var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a6, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a6, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a6, prop, b2[prop]);
    }
  return a6;
};
var __spreadProps = (a6, b2) => __defProps(a6, __getOwnPropDescs(b2));
var __objRest = (source2, exclude) => {
  var target = {};
  for (var prop in source2)
    if (__hasOwnProp.call(source2, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source2[prop];
  if (source2 != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source2)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source2, prop))
        target[prop] = source2[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React$1 from "react";
import React__default, { useContext, useState, useRef, useEffect, useMemo, createElement, useCallback, Children, cloneElement, createContext, useLayoutEffect, useReducer, forwardRef, useImperativeHandle, Fragment as Fragment$1, PureComponent, createRef, Component, isValidElement } from "react";
import ReactDOM from "react-dom";
function _mergeNamespaces(n2, m2) {
  m2.forEach(function(e2) {
    e2 && typeof e2 !== "string" && !Array.isArray(e2) && Object.keys(e2).forEach(function(k3) {
      if (k3 !== "default" && !(k3 in n2)) {
        var d2 = Object.getOwnPropertyDescriptor(e2, k3);
        Object.defineProperty(n2, k3, d2.get ? d2 : {
          enumerable: true,
          get: function() {
            return e2[k3];
          }
        });
      }
    });
  });
  return Object.freeze(Object.defineProperty(n2, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a6 = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k3) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k3);
    Object.defineProperty(a6, k3, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k3];
      }
    });
  });
  return a6;
}
function commonjsRequire(path2) {
  throw new Error('Could not dynamically require "' + path2 + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var sha1$1 = { exports: {} };
/*
 * [js-sha1]{@link https://github.com/emn178/js-sha1}
 *
 * @version 0.6.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function(module) {
  (function() {
    var root = typeof window === "object" ? window : {};
    var NODE_JS = !root.JS_SHA1_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) {
      root = commonjsGlobal;
    }
    var COMMON_JS = !root.JS_SHA1_NO_COMMON_JS && true && module.exports;
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [-2147483648, 8388608, 32768, 128];
    var SHIFT = [24, 16, 8, 0];
    var OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"];
    var blocks = [];
    var createOutputMethod = function(outputType) {
      return function(message2) {
        return new Sha1(true).update(message2)[outputType]();
      };
    };
    var createMethod = function() {
      var method2 = createOutputMethod("hex");
      if (NODE_JS) {
        method2 = nodeWrap(method2);
      }
      method2.create = function() {
        return new Sha1();
      };
      method2.update = function(message2) {
        return method2.create().update(message2);
      };
      for (var i2 = 0; i2 < OUTPUT_TYPES.length; ++i2) {
        var type = OUTPUT_TYPES[i2];
        method2[type] = createOutputMethod(type);
      }
      return method2;
    };
    var nodeWrap = function(method) {
      var crypto = eval("require('crypto')");
      var Buffer = eval("require('buffer').Buffer");
      var nodeMethod = function(message2) {
        if (typeof message2 === "string") {
          return crypto.createHash("sha1").update(message2, "utf8").digest("hex");
        } else if (message2.constructor === ArrayBuffer) {
          message2 = new Uint8Array(message2);
        } else if (message2.length === void 0) {
          return method(message2);
        }
        return crypto.createHash("sha1").update(new Buffer(message2)).digest("hex");
      };
      return nodeMethod;
    };
    function Sha1(sharedMemory) {
      if (sharedMemory) {
        blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        this.blocks = blocks;
      } else {
        this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      this.h0 = 1732584193;
      this.h1 = 4023233417;
      this.h2 = 2562383102;
      this.h3 = 271733878;
      this.h4 = 3285377520;
      this.block = this.start = this.bytes = this.hBytes = 0;
      this.finalized = this.hashed = false;
      this.first = true;
    }
    Sha1.prototype.update = function(message2) {
      if (this.finalized) {
        return;
      }
      var notString = typeof message2 !== "string";
      if (notString && message2.constructor === root.ArrayBuffer) {
        message2 = new Uint8Array(message2);
      }
      var code, index2 = 0, i2, length = message2.length || 0, blocks2 = this.blocks;
      while (index2 < length) {
        if (this.hashed) {
          this.hashed = false;
          blocks2[0] = this.block;
          blocks2[16] = blocks2[1] = blocks2[2] = blocks2[3] = blocks2[4] = blocks2[5] = blocks2[6] = blocks2[7] = blocks2[8] = blocks2[9] = blocks2[10] = blocks2[11] = blocks2[12] = blocks2[13] = blocks2[14] = blocks2[15] = 0;
        }
        if (notString) {
          for (i2 = this.start; index2 < length && i2 < 64; ++index2) {
            blocks2[i2 >> 2] |= message2[index2] << SHIFT[i2++ & 3];
          }
        } else {
          for (i2 = this.start; index2 < length && i2 < 64; ++index2) {
            code = message2.charCodeAt(index2);
            if (code < 128) {
              blocks2[i2 >> 2] |= code << SHIFT[i2++ & 3];
            } else if (code < 2048) {
              blocks2[i2 >> 2] |= (192 | code >> 6) << SHIFT[i2++ & 3];
              blocks2[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            } else if (code < 55296 || code >= 57344) {
              blocks2[i2 >> 2] |= (224 | code >> 12) << SHIFT[i2++ & 3];
              blocks2[i2 >> 2] |= (128 | code >> 6 & 63) << SHIFT[i2++ & 3];
              blocks2[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            } else {
              code = 65536 + ((code & 1023) << 10 | message2.charCodeAt(++index2) & 1023);
              blocks2[i2 >> 2] |= (240 | code >> 18) << SHIFT[i2++ & 3];
              blocks2[i2 >> 2] |= (128 | code >> 12 & 63) << SHIFT[i2++ & 3];
              blocks2[i2 >> 2] |= (128 | code >> 6 & 63) << SHIFT[i2++ & 3];
              blocks2[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            }
          }
        }
        this.lastByteIndex = i2;
        this.bytes += i2 - this.start;
        if (i2 >= 64) {
          this.block = blocks2[16];
          this.start = i2 - 64;
          this.hash();
          this.hashed = true;
        } else {
          this.start = i2;
        }
      }
      if (this.bytes > 4294967295) {
        this.hBytes += this.bytes / 4294967296 << 0;
        this.bytes = this.bytes % 4294967296;
      }
      return this;
    };
    Sha1.prototype.finalize = function() {
      if (this.finalized) {
        return;
      }
      this.finalized = true;
      var blocks2 = this.blocks, i2 = this.lastByteIndex;
      blocks2[16] = this.block;
      blocks2[i2 >> 2] |= EXTRA[i2 & 3];
      this.block = blocks2[16];
      if (i2 >= 56) {
        if (!this.hashed) {
          this.hash();
        }
        blocks2[0] = this.block;
        blocks2[16] = blocks2[1] = blocks2[2] = blocks2[3] = blocks2[4] = blocks2[5] = blocks2[6] = blocks2[7] = blocks2[8] = blocks2[9] = blocks2[10] = blocks2[11] = blocks2[12] = blocks2[13] = blocks2[14] = blocks2[15] = 0;
      }
      blocks2[14] = this.hBytes << 3 | this.bytes >>> 29;
      blocks2[15] = this.bytes << 3;
      this.hash();
    };
    Sha1.prototype.hash = function() {
      var a6 = this.h0, b2 = this.h1, c2 = this.h2, d2 = this.h3, e2 = this.h4;
      var f2, j2, t2, blocks2 = this.blocks;
      for (j2 = 16; j2 < 80; ++j2) {
        t2 = blocks2[j2 - 3] ^ blocks2[j2 - 8] ^ blocks2[j2 - 14] ^ blocks2[j2 - 16];
        blocks2[j2] = t2 << 1 | t2 >>> 31;
      }
      for (j2 = 0; j2 < 20; j2 += 5) {
        f2 = b2 & c2 | ~b2 & d2;
        t2 = a6 << 5 | a6 >>> 27;
        e2 = t2 + f2 + e2 + 1518500249 + blocks2[j2] << 0;
        b2 = b2 << 30 | b2 >>> 2;
        f2 = a6 & b2 | ~a6 & c2;
        t2 = e2 << 5 | e2 >>> 27;
        d2 = t2 + f2 + d2 + 1518500249 + blocks2[j2 + 1] << 0;
        a6 = a6 << 30 | a6 >>> 2;
        f2 = e2 & a6 | ~e2 & b2;
        t2 = d2 << 5 | d2 >>> 27;
        c2 = t2 + f2 + c2 + 1518500249 + blocks2[j2 + 2] << 0;
        e2 = e2 << 30 | e2 >>> 2;
        f2 = d2 & e2 | ~d2 & a6;
        t2 = c2 << 5 | c2 >>> 27;
        b2 = t2 + f2 + b2 + 1518500249 + blocks2[j2 + 3] << 0;
        d2 = d2 << 30 | d2 >>> 2;
        f2 = c2 & d2 | ~c2 & e2;
        t2 = b2 << 5 | b2 >>> 27;
        a6 = t2 + f2 + a6 + 1518500249 + blocks2[j2 + 4] << 0;
        c2 = c2 << 30 | c2 >>> 2;
      }
      for (; j2 < 40; j2 += 5) {
        f2 = b2 ^ c2 ^ d2;
        t2 = a6 << 5 | a6 >>> 27;
        e2 = t2 + f2 + e2 + 1859775393 + blocks2[j2] << 0;
        b2 = b2 << 30 | b2 >>> 2;
        f2 = a6 ^ b2 ^ c2;
        t2 = e2 << 5 | e2 >>> 27;
        d2 = t2 + f2 + d2 + 1859775393 + blocks2[j2 + 1] << 0;
        a6 = a6 << 30 | a6 >>> 2;
        f2 = e2 ^ a6 ^ b2;
        t2 = d2 << 5 | d2 >>> 27;
        c2 = t2 + f2 + c2 + 1859775393 + blocks2[j2 + 2] << 0;
        e2 = e2 << 30 | e2 >>> 2;
        f2 = d2 ^ e2 ^ a6;
        t2 = c2 << 5 | c2 >>> 27;
        b2 = t2 + f2 + b2 + 1859775393 + blocks2[j2 + 3] << 0;
        d2 = d2 << 30 | d2 >>> 2;
        f2 = c2 ^ d2 ^ e2;
        t2 = b2 << 5 | b2 >>> 27;
        a6 = t2 + f2 + a6 + 1859775393 + blocks2[j2 + 4] << 0;
        c2 = c2 << 30 | c2 >>> 2;
      }
      for (; j2 < 60; j2 += 5) {
        f2 = b2 & c2 | b2 & d2 | c2 & d2;
        t2 = a6 << 5 | a6 >>> 27;
        e2 = t2 + f2 + e2 - 1894007588 + blocks2[j2] << 0;
        b2 = b2 << 30 | b2 >>> 2;
        f2 = a6 & b2 | a6 & c2 | b2 & c2;
        t2 = e2 << 5 | e2 >>> 27;
        d2 = t2 + f2 + d2 - 1894007588 + blocks2[j2 + 1] << 0;
        a6 = a6 << 30 | a6 >>> 2;
        f2 = e2 & a6 | e2 & b2 | a6 & b2;
        t2 = d2 << 5 | d2 >>> 27;
        c2 = t2 + f2 + c2 - 1894007588 + blocks2[j2 + 2] << 0;
        e2 = e2 << 30 | e2 >>> 2;
        f2 = d2 & e2 | d2 & a6 | e2 & a6;
        t2 = c2 << 5 | c2 >>> 27;
        b2 = t2 + f2 + b2 - 1894007588 + blocks2[j2 + 3] << 0;
        d2 = d2 << 30 | d2 >>> 2;
        f2 = c2 & d2 | c2 & e2 | d2 & e2;
        t2 = b2 << 5 | b2 >>> 27;
        a6 = t2 + f2 + a6 - 1894007588 + blocks2[j2 + 4] << 0;
        c2 = c2 << 30 | c2 >>> 2;
      }
      for (; j2 < 80; j2 += 5) {
        f2 = b2 ^ c2 ^ d2;
        t2 = a6 << 5 | a6 >>> 27;
        e2 = t2 + f2 + e2 - 899497514 + blocks2[j2] << 0;
        b2 = b2 << 30 | b2 >>> 2;
        f2 = a6 ^ b2 ^ c2;
        t2 = e2 << 5 | e2 >>> 27;
        d2 = t2 + f2 + d2 - 899497514 + blocks2[j2 + 1] << 0;
        a6 = a6 << 30 | a6 >>> 2;
        f2 = e2 ^ a6 ^ b2;
        t2 = d2 << 5 | d2 >>> 27;
        c2 = t2 + f2 + c2 - 899497514 + blocks2[j2 + 2] << 0;
        e2 = e2 << 30 | e2 >>> 2;
        f2 = d2 ^ e2 ^ a6;
        t2 = c2 << 5 | c2 >>> 27;
        b2 = t2 + f2 + b2 - 899497514 + blocks2[j2 + 3] << 0;
        d2 = d2 << 30 | d2 >>> 2;
        f2 = c2 ^ d2 ^ e2;
        t2 = b2 << 5 | b2 >>> 27;
        a6 = t2 + f2 + a6 - 899497514 + blocks2[j2 + 4] << 0;
        c2 = c2 << 30 | c2 >>> 2;
      }
      this.h0 = this.h0 + a6 << 0;
      this.h1 = this.h1 + b2 << 0;
      this.h2 = this.h2 + c2 << 0;
      this.h3 = this.h3 + d2 << 0;
      this.h4 = this.h4 + e2 << 0;
    };
    Sha1.prototype.hex = function() {
      this.finalize();
      var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;
      return HEX_CHARS[h0 >> 28 & 15] + HEX_CHARS[h0 >> 24 & 15] + HEX_CHARS[h0 >> 20 & 15] + HEX_CHARS[h0 >> 16 & 15] + HEX_CHARS[h0 >> 12 & 15] + HEX_CHARS[h0 >> 8 & 15] + HEX_CHARS[h0 >> 4 & 15] + HEX_CHARS[h0 & 15] + HEX_CHARS[h1 >> 28 & 15] + HEX_CHARS[h1 >> 24 & 15] + HEX_CHARS[h1 >> 20 & 15] + HEX_CHARS[h1 >> 16 & 15] + HEX_CHARS[h1 >> 12 & 15] + HEX_CHARS[h1 >> 8 & 15] + HEX_CHARS[h1 >> 4 & 15] + HEX_CHARS[h1 & 15] + HEX_CHARS[h2 >> 28 & 15] + HEX_CHARS[h2 >> 24 & 15] + HEX_CHARS[h2 >> 20 & 15] + HEX_CHARS[h2 >> 16 & 15] + HEX_CHARS[h2 >> 12 & 15] + HEX_CHARS[h2 >> 8 & 15] + HEX_CHARS[h2 >> 4 & 15] + HEX_CHARS[h2 & 15] + HEX_CHARS[h3 >> 28 & 15] + HEX_CHARS[h3 >> 24 & 15] + HEX_CHARS[h3 >> 20 & 15] + HEX_CHARS[h3 >> 16 & 15] + HEX_CHARS[h3 >> 12 & 15] + HEX_CHARS[h3 >> 8 & 15] + HEX_CHARS[h3 >> 4 & 15] + HEX_CHARS[h3 & 15] + HEX_CHARS[h4 >> 28 & 15] + HEX_CHARS[h4 >> 24 & 15] + HEX_CHARS[h4 >> 20 & 15] + HEX_CHARS[h4 >> 16 & 15] + HEX_CHARS[h4 >> 12 & 15] + HEX_CHARS[h4 >> 8 & 15] + HEX_CHARS[h4 >> 4 & 15] + HEX_CHARS[h4 & 15];
    };
    Sha1.prototype.toString = Sha1.prototype.hex;
    Sha1.prototype.digest = function() {
      this.finalize();
      var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;
      return [
        h0 >> 24 & 255,
        h0 >> 16 & 255,
        h0 >> 8 & 255,
        h0 & 255,
        h1 >> 24 & 255,
        h1 >> 16 & 255,
        h1 >> 8 & 255,
        h1 & 255,
        h2 >> 24 & 255,
        h2 >> 16 & 255,
        h2 >> 8 & 255,
        h2 & 255,
        h3 >> 24 & 255,
        h3 >> 16 & 255,
        h3 >> 8 & 255,
        h3 & 255,
        h4 >> 24 & 255,
        h4 >> 16 & 255,
        h4 >> 8 & 255,
        h4 & 255
      ];
    };
    Sha1.prototype.array = Sha1.prototype.digest;
    Sha1.prototype.arrayBuffer = function() {
      this.finalize();
      var buffer2 = new ArrayBuffer(20);
      var dataView = new DataView(buffer2);
      dataView.setUint32(0, this.h0);
      dataView.setUint32(4, this.h1);
      dataView.setUint32(8, this.h2);
      dataView.setUint32(12, this.h3);
      dataView.setUint32(16, this.h4);
      return buffer2;
    };
    var exports = createMethod();
    if (COMMON_JS) {
      module.exports = exports;
    } else {
      root.sha1 = exports;
    }
  })();
})(sha1$1);
var sha1 = sha1$1.exports;
function _typeof$9(obj) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$9(obj);
}
function _classCallCheck$i(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$a(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$g(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$a(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$a(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf$1(o, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$1(o, p2);
}
function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$7(self2, call) {
  if (call && (_typeof$9(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _arrayWithHoles$5(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayLikeToArray$1(arr2, len) {
  if (len == null || len > arr2.length)
    len = arr2.length;
  for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
    arr22[i2] = arr2[i2];
  }
  return arr22;
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o, minLen);
}
function _nonIterableRest$5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toArray(arr2) {
  return _arrayWithHoles$5(arr2) || _iterableToArray$1(arr2) || _unsupportedIterableToArray$1(arr2) || _nonIterableRest$5();
}
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$b(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$6(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$6(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
var consoleLogger = {
  type: "logger",
  log: function log2(args) {
    this.output("log", args);
  },
  warn: function warn2(args) {
    this.output("warn", args);
  },
  error: function error2(args) {
    this.output("error", args);
  },
  output: function output(type, args) {
    if (console && console[type])
      console[type].apply(console, args);
  }
};
var Logger$1 = function() {
  function Logger2(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$i(this, Logger2);
    this.init(concreteLogger, options);
  }
  _createClass$g(Logger2, [{
    key: "init",
    value: function init3(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = options.prefix || "i18next:";
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log3() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, "log", "", true);
    }
  }, {
    key: "warn",
    value: function warn3() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, "warn", "", true);
    }
  }, {
    key: "error",
    value: function error3() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, "error", "");
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix2, debugOnly) {
      if (debugOnly && !this.debug)
        return null;
      if (typeof args[0] === "string")
        args[0] = "".concat(prefix2).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create3(moduleName) {
      return new Logger2(this.logger, _objectSpread$b(_objectSpread$b({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone2(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger2(this.logger, options);
    }
  }]);
  return Logger2;
}();
var baseLogger = new Logger$1();
var EventEmitter = function() {
  function EventEmitter2() {
    _classCallCheck$i(this, EventEmitter2);
    this.observers = {};
  }
  _createClass$g(EventEmitter2, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(" ").forEach(function(event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event])
        return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function(l2) {
        return l2 !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function(observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers["*"]) {
        var _cloned = [].concat(this.observers["*"]);
        _cloned.forEach(function(observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter2;
}();
function defer$1() {
  var res;
  var rej;
  var promise = new Promise(function(resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null)
    return "";
  return "" + object;
}
function copy(a6, s2, t2) {
  a6.forEach(function(m2) {
    if (s2[m2])
      t2[m2] = s2[m2];
  });
}
function getLastOfPath(object, path2, Empty) {
  function cleanKey(key2) {
    return key2 && key2.indexOf("###") > -1 ? key2.replace(/###/g, ".") : key2;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === "string";
  }
  var stack2 = typeof path2 !== "string" ? [].concat(path2) : path2.split(".");
  while (stack2.length > 1) {
    if (canNotTraverseDeeper())
      return {};
    var key = cleanKey(stack2.shift());
    if (!object[key] && Empty)
      object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper())
    return {};
  return {
    obj: object,
    k: cleanKey(stack2.shift())
  };
}
function setPath(object, path2, newValue) {
  var _getLastOfPath = getLastOfPath(object, path2, Object), obj = _getLastOfPath.obj, k3 = _getLastOfPath.k;
  obj[k3] = newValue;
}
function pushPath(object, path2, newValue, concat2) {
  var _getLastOfPath2 = getLastOfPath(object, path2, Object), obj = _getLastOfPath2.obj, k3 = _getLastOfPath2.k;
  obj[k3] = obj[k3] || [];
  if (concat2)
    obj[k3] = obj[k3].concat(newValue);
  if (!concat2)
    obj[k3].push(newValue);
}
function getPath$1(object, path2) {
  var _getLastOfPath3 = getLastOfPath(object, path2), obj = _getLastOfPath3.obj, k3 = _getLastOfPath3.k;
  if (!obj)
    return void 0;
  return obj[k3];
}
function getPathWithDefaults(data2, defaultData, key) {
  var value = getPath$1(data2, key);
  if (value !== void 0) {
    return value;
  }
  return getPath$1(defaultData, key);
}
function deepExtend(target, source2, overwrite) {
  for (var prop in source2) {
    if (prop !== "__proto__" && prop !== "constructor") {
      if (prop in target) {
        if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source2[prop] === "string" || source2[prop] instanceof String) {
          if (overwrite)
            target[prop] = source2[prop];
        } else {
          deepExtend(target[prop], source2[prop], overwrite);
        }
      } else {
        target[prop] = source2[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function escape$1(data2) {
  if (typeof data2 === "string") {
    return data2.replace(/[&<>"'\/]/g, function(s2) {
      return _entityMap[s2];
    });
  }
  return data2;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [" ", ",", "?", "!", ";"];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || "";
  keySeparator = keySeparator || "";
  var possibleChars = chars.filter(function(c2) {
    return nsSeparator.indexOf(c2) < 0 && keySeparator.indexOf(c2) < 0;
  });
  if (possibleChars.length === 0)
    return true;
  var r2 = new RegExp("(".concat(possibleChars.map(function(c2) {
    return c2 === "?" ? "\\?" : c2;
  }).join("|"), ")"));
  var matched2 = !r2.test(key);
  if (!matched2) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r2.test(key.substring(0, ki))) {
      matched2 = true;
    }
  }
  return matched2;
}
function ownKeys$1$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$1$1(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$1$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$7(this, result2);
  };
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function deepFind(obj, path2) {
  var keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!obj)
    return void 0;
  if (obj[path2])
    return obj[path2];
  var paths = path2.split(keySeparator);
  var current = obj;
  for (var i2 = 0; i2 < paths.length; ++i2) {
    if (!current)
      return void 0;
    if (typeof current[paths[i2]] === "string" && i2 + 1 < paths.length) {
      return void 0;
    }
    if (current[paths[i2]] === void 0) {
      var j2 = 2;
      var p2 = paths.slice(i2, i2 + j2).join(keySeparator);
      var mix2 = current[p2];
      while (mix2 === void 0 && paths.length > i2 + j2) {
        j2++;
        p2 = paths.slice(i2, i2 + j2).join(keySeparator);
        mix2 = current[p2];
      }
      if (mix2 === void 0)
        return void 0;
      if (mix2 === null)
        return null;
      if (path2.endsWith(p2)) {
        if (typeof mix2 === "string")
          return mix2;
        if (p2 && typeof mix2[p2] === "string")
          return mix2[p2];
      }
      var joinedPath = paths.slice(i2 + j2).join(keySeparator);
      if (joinedPath)
        return deepFind(mix2, joinedPath, keySeparator);
      return void 0;
    }
    current = current[paths[i2]];
  }
  return current;
}
var ResourceStore = function(_EventEmitter) {
  _inherits$7(ResourceStore2, _EventEmitter);
  var _super = _createSuper$7(ResourceStore2);
  function ResourceStore2(data2) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    _classCallCheck$i(this, ResourceStore2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    _this.data = data2 || {};
    _this.options = options;
    if (_this.options.keySeparator === void 0) {
      _this.options.keySeparator = ".";
    }
    if (_this.options.ignoreJSONStructure === void 0) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass$g(ResourceStore2, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index2 = this.options.ns.indexOf(ns);
      if (index2 > -1) {
        this.options.ns.splice(index2, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      var keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== void 0 ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path2 = [lng, ns];
      if (key && typeof key !== "string")
        path2 = path2.concat(key);
      if (key && typeof key === "string")
        path2 = path2.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path2 = lng.split(".");
      }
      var result2 = getPath$1(this.data, path2);
      if (result2 || !ignoreJSONStructure || typeof key !== "string")
        return result2;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === void 0)
        keySeparator = ".";
      var path2 = [lng, ns];
      if (key)
        path2 = path2.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path2 = lng.split(".");
        value = ns;
        ns = path2[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path2, value);
      if (!options.silent)
        this.emit("added", lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: false
      };
      for (var m2 in resources) {
        if (typeof resources[m2] === "string" || Object.prototype.toString.apply(resources[m2]) === "[object Array]")
          this.addResource(lng, ns, m2, resources[m2], {
            silent: true
          });
      }
      if (!options.silent)
        this.emit("added", lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: false
      };
      var path2 = [lng, ns];
      if (lng.indexOf(".") > -1) {
        path2 = lng.split(".");
        deep = resources;
        resources = ns;
        ns = path2[1];
      }
      this.addNamespaces(ns);
      var pack2 = getPath$1(this.data, path2) || {};
      if (deep) {
        deepExtend(pack2, resources, overwrite);
      } else {
        pack2 = _objectSpread$1$1(_objectSpread$1$1({}, pack2), resources);
      }
      setPath(this.data, path2, pack2);
      if (!options.silent)
        this.emit("added", lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit("removed", lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns)
        ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === "v1")
        return _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data2 = this.getDataByLanguage(lng);
      var n2 = data2 && Object.keys(data2) || [];
      return !!n2.find(function(v2) {
        return data2[v2] && Object.keys(data2[v2]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore2;
}(EventEmitter);
var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module2) {
    this.processors[module2.name] = module2;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function(processor) {
      if (_this.processors[processor])
        value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};
function ownKeys$2$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$2$1(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$2$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _createSuper$1$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$7(this, result2);
  };
}
function _isNativeReflectConstruct$1$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
  _inherits$7(Translator2, _EventEmitter);
  var _super = _createSuper$1$1(Translator2);
  function Translator2(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$i(this, Translator2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], services, _assertThisInitialized$1(_this));
    _this.options = options;
    if (_this.options.keySeparator === void 0) {
      _this.options.keySeparator = ".";
    }
    _this.logger = baseLogger.create("translator");
    return _this;
  }
  _createClass$g(Translator2, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng)
        this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (key === void 0 || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== void 0 ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === void 0)
        nsSeparator = ":";
      var keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m2 = key.match(this.interpolator.nestingRegexp);
        if (m2 && m2.length > 0) {
          return {
            key,
            namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1)
          namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === "string")
        namespaces = [namespaces];
      return {
        key,
        namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (_typeof$9(options) !== "object" && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (!options)
        options = {};
      if (keys === void 0 || keys === null)
        return "";
      if (!Array.isArray(keys))
        keys = [String(keys)];
      var returnDetails = options.returnDetails !== void 0 ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === "cimode") {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ["[object Number]", "[object Function]", "[object RegExp]"];
      var joinArrays = options.joinArrays !== void 0 ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          }
          var r2 = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2$1(_objectSpread$2$1({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r2;
            return resolved;
          }
          return r2;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === "[object Array]";
          var copy2 = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m2 in res) {
            if (Object.prototype.hasOwnProperty.call(res, m2)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m2);
              copy2[m2] = this.translate(deepKey, _objectSpread$2$1(_objectSpread$2$1({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy2[m2] === deepKey)
                copy2[m2] = res[m2];
            }
          }
          res = copy2;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
        res = res.join(joinArrays);
        if (res)
          res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== void 0 && typeof options.count !== "string";
        var hasDefaultValue = Translator2.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? void 0 : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2$1(_objectSpread$2$1({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res)
              this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) {
            for (var i2 = 0; i2 < fallbackLngs.length; i2++) {
              lngs.push(fallbackLngs[i2]);
            }
          } else if (this.options.saveMissingTo === "all") {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send2(l2, k3, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l2, namespace, k3, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l2, namespace, k3, defaultForMissing, updateMissing, options);
            }
            _this2.emit("missingKey", l2, namespace, k3, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function(language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey)
          res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== "v1") {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : void 0);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation)
          this.interpolator.init(_objectSpread$2$1(_objectSpread$2$1({}, options), {
            interpolation: _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation), options.interpolation)
          }));
        var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data2 = options.replace && typeof options.replace !== "string" ? options.replace : options;
        if (this.options.interpolation.defaultVariables)
          data2 = _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), data2);
        res = this.interpolator.interpolate(res, data2, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft)
            options.nest = false;
        }
        if (options.nest !== false)
          res = this.interpolator.nest(res, function() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (lastKey && lastKey[0] === args[0] && !options.context) {
              _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
              return null;
            }
            return _this3.translate.apply(_this3, args.concat([key]));
          }, options);
        if (options.interpolation)
          this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === "string" ? [postProcess] : postProcess;
      if (res !== void 0 && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2$1({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === "string")
        keys = [keys];
      keys.forEach(function(k3) {
        if (_this4.isValidLookup(found))
          return;
        var extracted = _this4.extractFromKey(k3, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS)
          namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== void 0 && typeof options.count !== "string";
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== void 0 && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function(ns) {
          if (_this4.isValidLookup(found))
            return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), `" won't get resolved as namespace "`).concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
          }
          codes.forEach(function(code) {
            if (_this4.isValidLookup(found))
              return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling)
                pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey,
        exactUsedKey,
        usedLng,
        usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== void 0 && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource)
        return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix2 = "defaultValue";
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix2 === option.substring(0, prefix2.length) && options[option] !== void 0) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator2;
}(EventEmitter);
function capitalize(string2) {
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}
var LanguageUtil = function() {
  function LanguageUtil2(options) {
    _classCallCheck$i(this, LanguageUtil2);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create("languageUtils");
  }
  _createClass$g(LanguageUtil2, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf("-") < 0)
        return null;
      var p2 = code.split("-");
      if (p2.length === 2)
        return null;
      p2.pop();
      if (p2[p2.length - 1].toLowerCase() === "x")
        return null;
      return this.formatLanguageCode(p2.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf("-") < 0)
        return code;
      var p2 = code.split("-");
      return this.formatLanguageCode(p2[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === "string" && code.indexOf("-") > -1) {
        var specialCases = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
        var p2 = code.split("-");
        if (this.options.lowerCaseLng) {
          p2 = p2.map(function(part) {
            return part.toLowerCase();
          });
        } else if (p2.length === 2) {
          p2[0] = p2[0].toLowerCase();
          p2[1] = p2[1].toUpperCase();
          if (specialCases.indexOf(p2[1].toLowerCase()) > -1)
            p2[1] = capitalize(p2[1].toLowerCase());
        } else if (p2.length === 3) {
          p2[0] = p2[0].toLowerCase();
          if (p2[1].length === 2)
            p2[1] = p2[1].toUpperCase();
          if (p2[0] !== "sgn" && p2[2].length === 2)
            p2[2] = p2[2].toUpperCase();
          if (specialCases.indexOf(p2[1].toLowerCase()) > -1)
            p2[1] = capitalize(p2[1].toLowerCase());
          if (specialCases.indexOf(p2[2].toLowerCase()) > -1)
            p2[2] = capitalize(p2[2].toLowerCase());
        }
        return p2.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes)
        return null;
      var found;
      codes.forEach(function(code) {
        if (found)
          return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng))
          found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function(code) {
          if (found)
            return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly))
            return found = lngOnly;
          found = _this.options.supportedLngs.find(function(supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0)
              return supportedLng;
          });
        });
      }
      if (!found)
        found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks)
        return [];
      if (typeof fallbacks === "function")
        fallbacks = fallbacks(code);
      if (typeof fallbacks === "string")
        fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === "[object Array]")
        return fallbacks;
      if (!code)
        return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found)
        found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found)
        found = fallbacks[this.formatLanguageCode(code)];
      if (!found)
        found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found)
        found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode2(c2) {
        if (!c2)
          return;
        if (_this2.isSupportedCode(c2)) {
          codes.push(c2);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c2));
        }
      };
      if (typeof code === "string" && code.indexOf("-") > -1) {
        if (this.options.load !== "languageOnly")
          addCode(this.formatLanguageCode(code));
        if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly")
          addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== "currentOnly")
          addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === "string") {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function(fc) {
        if (codes.indexOf(fc) < 0)
          addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil2;
}();
var sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _2(n2) {
    return Number(n2 > 1);
  },
  2: function _3(n2) {
    return Number(n2 != 1);
  },
  3: function _4(n2) {
    return 0;
  },
  4: function _5(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  5: function _6(n2) {
    return Number(n2 == 0 ? 0 : n2 == 1 ? 1 : n2 == 2 ? 2 : n2 % 100 >= 3 && n2 % 100 <= 10 ? 3 : n2 % 100 >= 11 ? 4 : 5);
  },
  6: function _7(n2) {
    return Number(n2 == 1 ? 0 : n2 >= 2 && n2 <= 4 ? 1 : 2);
  },
  7: function _8(n2) {
    return Number(n2 == 1 ? 0 : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  8: function _9(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 != 8 && n2 != 11 ? 2 : 3);
  },
  9: function _10(n2) {
    return Number(n2 >= 2);
  },
  10: function _11(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 < 7 ? 2 : n2 < 11 ? 3 : 4);
  },
  11: function _12(n2) {
    return Number(n2 == 1 || n2 == 11 ? 0 : n2 == 2 || n2 == 12 ? 1 : n2 > 2 && n2 < 20 ? 2 : 3);
  },
  12: function _13(n2) {
    return Number(n2 % 10 != 1 || n2 % 100 == 11);
  },
  13: function _14(n2) {
    return Number(n2 !== 0);
  },
  14: function _15(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 == 3 ? 2 : 3);
  },
  15: function _16(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 % 10 >= 2 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  16: function _17(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 !== 0 ? 1 : 2);
  },
  17: function _18(n2) {
    return Number(n2 == 1 || n2 % 10 == 1 && n2 % 100 != 11 ? 0 : 1);
  },
  18: function _19(n2) {
    return Number(n2 == 0 ? 0 : n2 == 1 ? 1 : 2);
  },
  19: function _20(n2) {
    return Number(n2 == 1 ? 0 : n2 == 0 || n2 % 100 > 1 && n2 % 100 < 11 ? 1 : n2 % 100 > 10 && n2 % 100 < 20 ? 2 : 3);
  },
  20: function _21(n2) {
    return Number(n2 == 1 ? 0 : n2 == 0 || n2 % 100 > 0 && n2 % 100 < 20 ? 1 : 2);
  },
  21: function _22(n2) {
    return Number(n2 % 100 == 1 ? 1 : n2 % 100 == 2 ? 2 : n2 % 100 == 3 || n2 % 100 == 4 ? 3 : 0);
  },
  22: function _23(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : (n2 < 0 || n2 > 10) && n2 % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ["v1", "v2", "v3"];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function(set2) {
    set2.lngs.forEach(function(l2) {
      rules[l2] = {
        numbers: set2.nr,
        plurals: _rulesPluralsTypes[set2.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function() {
  function PluralResolver2(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$i(this, PluralResolver2);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create("pluralResolver");
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
      this.options.compatibilityJSON = "v3";
      this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
    }
    this.rules = createRules();
  }
  _createClass$g(PluralResolver2, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? "ordinal" : "cardinal"
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function(suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function(pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function(number2) {
        return _this.getSuffix(code, number2, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count2) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count2));
        }
        return this.getSuffixRetroCompatible(rule, count2);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return "";
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count2) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count2) : rule.plurals(Math.abs(count2));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = "plural";
        } else if (suffix === 1) {
          suffix = "";
        }
      }
      var returnSuffix = function returnSuffix2() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === "v1") {
        if (suffix === 1)
          return "";
        if (typeof suffix === "number")
          return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === "v2") {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver2;
}();
function ownKeys$3$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$3$1(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$3$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
var Interpolator = function() {
  function Interpolator2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$i(this, Interpolator2);
    this.logger = baseLogger.create("interpolator");
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function(value) {
      return value;
    };
    this.init(options);
  }
  _createClass$g(Interpolator2, [{
    key: "init",
    value: function init3() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!options.interpolation)
        options.interpolation = {
          escapeValue: true
        };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== void 0 ? iOpts.escape : escape$1;
      this.escapeValue = iOpts.escapeValue !== void 0 ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== void 0 ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
      this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
      this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1e3;
      this.alwaysFormat = iOpts.alwaysFormat !== void 0 ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options)
        this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, "g");
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
  }, {
    key: "interpolate",
    value: function interpolate2(str, data2, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, "$$$$");
      }
      var handleFormat = function handleFormat2(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path2 = getPathWithDefaults(data2, defaultData, key);
          return _this.alwaysFormat ? _this.format(path2, void 0, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data2), {}, {
            interpolationkey: key
          })) : path2;
        }
        var p2 = key.split(_this.formatSeparator);
        var k3 = p2.shift().trim();
        var f2 = p2.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data2, defaultData, k3), f2, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data2), {}, {
          interpolationkey: k3
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function(todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === void 0) {
            if (typeof missingInterpolationHandler === "function") {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === "string" ? temp : "";
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = "";
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = "";
            }
          } else if (typeof value !== "string" && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions = _objectSpread$3$1({}, options);
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0)
          return key;
        var c2 = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c2[1]);
        key = c2[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions)
            clonedOptions = _objectSpread$3$1(_objectSpread$3$1({}, inheritedOptions), clonedOptions);
        } catch (e2) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e2);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r2 = match[1].split(this.formatSeparator).map(function(elem) {
            return elem.trim();
          });
          match[1] = r2.shift();
          formatters = r2;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== "string")
          return value;
        if (typeof value !== "string")
          value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = "";
        }
        if (doReduce) {
          value = formatters.reduce(function(v2, f2) {
            return _this2.format(v2, f2, options.lng, _objectSpread$3$1(_objectSpread$3$1({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator2;
}();
function ownKeys$4$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$4$1(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$4$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf("(") > -1) {
    var p2 = formatStr.split("(");
    formatName = p2[0].toLowerCase().trim();
    var optStr = p2[1].substring(0, p2[1].length - 1);
    if (formatName === "currency" && optStr.indexOf(":") < 0) {
      if (!formatOptions.currency)
        formatOptions.currency = optStr.trim();
    } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
      if (!formatOptions.range)
        formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(";");
      opts.forEach(function(opt) {
        if (!opt)
          return;
        var _opt$split = opt.split(":"), _opt$split2 = _toArray(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
        var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
        if (!formatOptions[key.trim()])
          formatOptions[key.trim()] = val;
        if (val === "false")
          formatOptions[key.trim()] = false;
        if (val === "true")
          formatOptions[key.trim()] = true;
        if (!isNaN(val))
          formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];
    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
var Formatter = function() {
  function Formatter2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$i(this, Formatter2);
    this.logger = baseLogger.create("formatter");
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function(lng, options2) {
        var formatter = new Intl.NumberFormat(lng, options2);
        return function(val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function(lng, options2) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4$1(_objectSpread$4$1({}, options2), {}, {
          style: "currency"
        }));
        return function(val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function(lng, options2) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4$1({}, options2));
        return function(val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function(lng, options2) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4$1({}, options2));
        return function(val) {
          return formatter.format(val, options2.range || "day");
        };
      }),
      list: createCachedFormatter(function(lng, options2) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4$1({}, options2));
        return function(val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }
  _createClass$g(Formatter2, [{
    key: "init",
    value: function init3(services) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function add4(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;
      var formats = _format.split(this.formatSeparator);
      var result2 = formats.reduce(function(mem, f2) {
        var _parseFormatStr = parseFormatStr(f2), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l2 = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l2, _objectSpread$4$1(_objectSpread$4$1(_objectSpread$4$1({}, formatOptions), options), valOptions));
          } catch (error3) {
            _this.logger.warn(error3);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result2;
    }
  }]);
  return Formatter2;
}();
function ownKeys$5$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$5$1(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$5$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _createSuper$2$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$7(this, result2);
  };
}
function _isNativeReflectConstruct$2$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function removePending(q2, name) {
  if (q2.pending[name] !== void 0) {
    delete q2.pending[name];
    q2.pendingCount--;
  }
}
var Connector = function(_EventEmitter) {
  _inherits$7(Connector2, _EventEmitter);
  var _super = _createSuper$2$1(Connector2);
  function Connector2(backend2, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    _classCallCheck$i(this, Connector2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    _this.backend = backend2;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create("backendConnector");
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass$g(Connector2, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function(lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function(ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0)
            ;
          else if (_this2.state[name] === 1) {
            if (pending[name] === void 0)
              pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === void 0)
              pending[name] = true;
            if (toLoad[name] === void 0)
              toLoad[name] = true;
            if (toLoadNamespaces[ns] === void 0)
              toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces)
          toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data2) {
      var s2 = name.split("|");
      var lng = s2[0];
      var ns = s2[1];
      if (err)
        this.emit("failedLoading", lng, ns, err);
      if (data2) {
        this.store.addResourceBundle(lng, ns, data2);
      }
      this.state[name] = err ? -1 : 2;
      var loaded2 = {};
      this.queue.forEach(function(q2) {
        pushPath(q2.loaded, [lng], ns);
        removePending(q2, name);
        if (err)
          q2.errors.push(err);
        if (q2.pendingCount === 0 && !q2.done) {
          Object.keys(q2.loaded).forEach(function(l2) {
            if (!loaded2[l2])
              loaded2[l2] = {};
            var loadedKeys = q2.loaded[l2];
            if (loadedKeys.length) {
              loadedKeys.forEach(function(ns2) {
                if (loaded2[l2][ns2] === void 0)
                  loaded2[l2][ns2] = true;
              });
            }
          });
          q2.done = true;
          if (q2.errors.length) {
            q2.callback(q2.errors);
          } else {
            q2.callback();
          }
        }
      });
      this.emit("loaded", loaded2);
      this.queue = this.queue.filter(function(q2) {
        return !q2.done;
      });
    }
  }, {
    key: "read",
    value: function read2(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : void 0;
      if (!lng.length)
        return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng,
          ns,
          fcName,
          tried,
          wait,
          callback
        });
        return;
      }
      this.readingCalls++;
      return this.backend[fcName](lng, ns, function(err, data2) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data2 && tried < _this3.maxRetries) {
          setTimeout(function() {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data2);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend) {
        this.logger.warn("No backend was added via i18next.use. Will not load resources.");
        return callback && callback();
      }
      if (typeof languages === "string")
        languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === "string")
        namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length)
          callback();
        return null;
      }
      toLoad.toLoad.forEach(function(name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload2(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      var s2 = name.split("|");
      var lng = s2[0];
      var ns = s2[1];
      this.read(lng, ns, "read", void 0, void 0, function(err, data2) {
        if (err)
          _this5.logger.warn("".concat(prefix2, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data2)
          _this5.logger.log("".concat(prefix2, "loaded namespace ").concat(ns, " for language ").concat(lng), data2);
        _this5.loaded(name, err, data2);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (key === void 0 || key === null || key === "")
        return;
      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5$1(_objectSpread$5$1({}, options), {}, {
          isUpdate
        }));
      }
      if (!languages || !languages[0])
        return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector2;
}(EventEmitter);
function get$3() {
  return {
    debug: false,
    initImmediate: true,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: "all",
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: "fallback",
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle2(args) {
      var ret = {};
      if (_typeof$9(args[1]) === "object")
        ret = args[1];
      if (typeof args[1] === "string")
        ret.defaultValue = args[1];
      if (typeof args[2] === "string")
        ret.tDescription = args[2];
      if (_typeof$9(args[2]) === "object" || _typeof$9(args[3]) === "object") {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function(key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === "string")
    options.ns = [options.ns];
  if (typeof options.fallbackLng === "string")
    options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === "string")
    options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) {
    options.supportedLngs = options.supportedLngs.concat(["cimode"]);
  }
  return options;
}
function ownKeys$6$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$6$1(Object(source2), true).forEach(function(key) {
        _defineProperty$9(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$6$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _createSuper$3$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$7(this, result2);
  };
}
function _isNativeReflectConstruct$3$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function noop$1() {
}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function(mem) {
    if (typeof inst[mem] === "function") {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function(_EventEmitter) {
  _inherits$7(I18n2, _EventEmitter);
  var _super = _createSuper$3$1(I18n2);
  function I18n2() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : void 0;
    _classCallCheck$i(this, I18n2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized$1(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn$7(_this, _assertThisInitialized$1(_this));
      }
      setTimeout(function() {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass$g(I18n2, [{
    key: "init",
    value: function init3() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : void 0;
      if (typeof options === "function") {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === "string") {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf("translation") < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get$3();
      this.options = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== "v1") {
        this.options.interpolation = _objectSpread$6$1(_objectSpread$6$1({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== void 0) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== void 0) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject)
          return null;
        if (typeof ClassOrObject === "function")
          return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== "undefined") {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s2 = this.services;
        s2.logger = baseLogger;
        s2.resourceStore = this.store;
        s2.languageUtils = lu;
        s2.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s2.formatter = createClassOnDemand(formatter);
          s2.formatter.init(s2, this.options);
          this.options.interpolation.format = s2.formatter.format.bind(s2.formatter);
        }
        s2.interpolator = new Interpolator(this.options);
        s2.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s2.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s2.resourceStore, s2, this.options);
        s2.backendConnector.on("*", function(event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s2.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s2.languageDetector.init(s2, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s2.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s2.i18nFormat.init)
            s2.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on("*", function(event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function(m2) {
          if (m2.init)
            m2.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback)
        callback = noop$1;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== "dev")
          this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn("init: no languageDetector is used and no lng is defined");
      }
      var storeApi = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      storeApi.forEach(function(fcName) {
        _this2[fcName] = function() {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      storeApiChained.forEach(function(fcName) {
        _this2[fcName] = function() {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer$1();
      var load = function load2() {
        var finish = function finish2(err, t2) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce)
            _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
          _this2.isInitialized = true;
          if (!_this2.options.isClone)
            _this2.logger.log("initialized", _this2.options);
          _this2.emit("initialized", _this2.options);
          deferred.resolve(t2);
          callback(err, t2);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized)
          return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === "string" ? language : this.language;
      if (typeof language === "function")
        usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === "cimode")
          return usedCallback();
        var toLoad = [];
        var append = function append2(lng) {
          if (!lng)
            return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function(l2) {
            if (toLoad.indexOf(l2) < 0)
              toLoad.push(l2);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function(l2) {
            return append(l2);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function(l2) {
            return append(l2);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function(e2) {
          if (!e2 && !_this3.resolvedLanguage && _this3.language)
            _this3.setResolvedLanguage(_this3.language);
          usedCallback(e2);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer$1();
      if (!lngs)
        lngs = this.languages;
      if (!ns)
        ns = this.options.ns;
      if (!callback)
        callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function(err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use2(module2) {
      if (!module2)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!module2.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      if (module2.type === "backend") {
        this.modules.backend = module2;
      }
      if (module2.type === "logger" || module2.log && module2.warn && module2.error) {
        this.modules.logger = module2;
      }
      if (module2.type === "languageDetector") {
        this.modules.languageDetector = module2;
      }
      if (module2.type === "i18nFormat") {
        this.modules.i18nFormat = module2;
      }
      if (module2.type === "postProcessor") {
        postProcessor.addPostProcessor(module2);
      }
      if (module2.type === "formatter") {
        this.modules.formatter = module2;
      }
      if (module2.type === "3rdParty") {
        this.modules.external.push(module2);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l2) {
      if (!l2 || !this.languages)
        return;
      if (["cimode", "dev"].indexOf(l2) > -1)
        return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (["cimode", "dev"].indexOf(lngInLngs) > -1)
          continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer$1();
      this.emit("languageChanging", lng);
      var setLngProps = function setLngProps2(l2) {
        _this4.language = l2;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l2);
        _this4.resolvedLanguage = void 0;
        _this4.setResolvedLanguage(l2);
      };
      var done = function done2(err, l2) {
        if (l2) {
          setLngProps(l2);
          _this4.translator.changeLanguage(l2);
          _this4.isLanguageChangingTo = void 0;
          _this4.emit("languageChanged", l2);
          _this4.logger.log("languageChanged", l2);
        } else {
          _this4.isLanguageChangingTo = void 0;
        }
        deferred.resolve(function() {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback)
          callback(err, function() {
            return _this4.t.apply(_this4, arguments);
          });
      };
      var setLng = function setLng2(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector)
          lngs = [];
        var l2 = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l2) {
          if (!_this4.language) {
            setLngProps(l2);
          }
          if (!_this4.translator.language)
            _this4.translator.changeLanguage(l2);
          if (_this4.services.languageDetector)
            _this4.services.languageDetector.cacheUserLanguage(l2);
        }
        _this4.loadResources(l2, function(err) {
          done(err, l2);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT2(key, opts) {
        var options;
        if (_typeof$9(opts) !== "object") {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6$1({}, opts);
        }
        options.lng = options.lng || fixedT2.lng;
        options.lngs = options.lngs || fixedT2.lngs;
        options.ns = options.ns || fixedT2.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT2.keyPrefix;
        var keySeparator = _this5.options.keySeparator || ".";
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };
      if (typeof lng === "string") {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t2() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace2(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
        return false;
      }
      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === "cimode")
        return true;
      var loadNotPending = function loadNotPending2(l2, n2) {
        var loadState = _this6.services.backendConnector.state["".concat(l2, "|").concat(n2)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== void 0)
          return preResult;
      }
      if (this.hasResourceBundle(lng, ns))
        return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages)
        return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
        return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces2(ns, callback) {
      var _this7 = this;
      var deferred = defer$1();
      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }
      if (typeof ns === "string")
        ns = [ns];
      ns.forEach(function(n2) {
        if (_this7.options.ns.indexOf(n2) < 0)
          _this7.options.ns.push(n2);
      });
      this.loadResources(function(err) {
        deferred.resolve();
        if (callback)
          callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer$1();
      if (typeof lngs === "string")
        lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function(lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback)
          callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function(err) {
        deferred.resolve();
        if (callback)
          callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng)
        lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng)
        return "rtl";
      var rtlLngs = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$1;
      var mergedOptions = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, this.options), options), {
        isClone: true
      });
      var clone2 = new I18n2(mergedOptions);
      if (options.debug !== void 0 || options.prefix !== void 0) {
        clone2.logger = clone2.logger.clone(options);
      }
      var membersToCopy = ["store", "services", "language"];
      membersToCopy.forEach(function(m2) {
        clone2[m2] = _this8[m2];
      });
      clone2.services = _objectSpread$6$1({}, this.services);
      clone2.services.utils = {
        hasLoadedNamespace: clone2.hasLoadedNamespace.bind(clone2)
      };
      clone2.translator = new Translator(clone2.services, clone2.options);
      clone2.translator.on("*", function(event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone2.emit.apply(clone2, [event].concat(args));
      });
      clone2.init(mergedOptions, callback);
      clone2.translator.options = clone2.options;
      clone2.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone2.hasLoadedNamespace.bind(clone2)
      };
      return clone2;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n2;
}(EventEmitter);
_defineProperty$9(I18n, "createInstance", function() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : void 0;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
function _typeof$8(obj) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$8(obj);
}
var arr$1 = [];
var each$1 = arr$1.forEach;
var slice$5 = arr$1.slice;
function defaults$5(obj) {
  each$1.call(slice$5.call(arguments, 1), function(source2) {
    if (source2) {
      for (var prop in source2) {
        if (obj[prop] === void 0)
          obj[prop] = source2[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof$8(XMLHttpRequest)) === "object";
}
function isPromise$1(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === "function";
}
function makePromise(maybePromise) {
  if (isPromise$1(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}
var getFetch$1 = { exports: {} };
var browserPonyfill = { exports: {} };
(function(module2, exports2) {
  var global2 = typeof self !== "undefined" ? self : commonjsGlobal;
  var __self__ = function() {
    function F2() {
      this.fetch = false;
      this.DOMException = global2.DOMException;
    }
    F2.prototype = global2;
    return new F2();
  }();
  (function(self2) {
    (function(exports3) {
      var support = {
        searchParams: "URLSearchParams" in self2,
        iterable: "Symbol" in self2 && "iterator" in Symbol,
        blob: "FileReader" in self2 && "Blob" in self2 && function() {
          try {
            new Blob();
            return true;
          } catch (e2) {
            return false;
          }
        }(),
        formData: "FormData" in self2,
        arrayBuffer: "ArrayBuffer" in self2
      };
      function isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
      }
      if (support.arrayBuffer) {
        var viewClasses = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ];
        var isArrayBufferView2 = ArrayBuffer.isView || function(obj) {
          return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
      }
      function normalizeName(name) {
        if (typeof name !== "string") {
          name = String(name);
        }
        if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
          throw new TypeError("Invalid character in header field name");
        }
        return name.toLowerCase();
      }
      function normalizeValue(value) {
        if (typeof value !== "string") {
          value = String(value);
        }
        return value;
      }
      function iteratorFor(items) {
        var iterator = {
          next: function() {
            var value = items.shift();
            return { done: value === void 0, value };
          }
        };
        if (support.iterable) {
          iterator[Symbol.iterator] = function() {
            return iterator;
          };
        }
        return iterator;
      }
      function Headers2(headers) {
        this.map = {};
        if (headers instanceof Headers2) {
          headers.forEach(function(value, name) {
            this.append(name, value);
          }, this);
        } else if (Array.isArray(headers)) {
          headers.forEach(function(header) {
            this.append(header[0], header[1]);
          }, this);
        } else if (headers) {
          Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
          }, this);
        }
      }
      Headers2.prototype.append = function(name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ", " + value : value;
      };
      Headers2.prototype["delete"] = function(name) {
        delete this.map[normalizeName(name)];
      };
      Headers2.prototype.get = function(name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
      };
      Headers2.prototype.has = function(name) {
        return this.map.hasOwnProperty(normalizeName(name));
      };
      Headers2.prototype.set = function(name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
      };
      Headers2.prototype.forEach = function(callback, thisArg) {
        for (var name in this.map) {
          if (this.map.hasOwnProperty(name)) {
            callback.call(thisArg, this.map[name], name, this);
          }
        }
      };
      Headers2.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push(name);
        });
        return iteratorFor(items);
      };
      Headers2.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
          items.push(value);
        });
        return iteratorFor(items);
      };
      Headers2.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push([name, value]);
        });
        return iteratorFor(items);
      };
      if (support.iterable) {
        Headers2.prototype[Symbol.iterator] = Headers2.prototype.entries;
      }
      function consumed(body) {
        if (body.bodyUsed) {
          return Promise.reject(new TypeError("Already read"));
        }
        body.bodyUsed = true;
      }
      function fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
          reader.onload = function() {
            resolve(reader.result);
          };
          reader.onerror = function() {
            reject(reader.error);
          };
        });
      }
      function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
      }
      function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise;
      }
      function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars2 = new Array(view.length);
        for (var i2 = 0; i2 < view.length; i2++) {
          chars2[i2] = String.fromCharCode(view[i2]);
        }
        return chars2.join("");
      }
      function bufferClone(buf) {
        if (buf.slice) {
          return buf.slice(0);
        } else {
          var view = new Uint8Array(buf.byteLength);
          view.set(new Uint8Array(buf));
          return view.buffer;
        }
      }
      function Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
          this._bodyInit = body;
          if (!body) {
            this._bodyText = "";
          } else if (typeof body === "string") {
            this._bodyText = body;
          } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
            this._bodyBlob = body;
          } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
            this._bodyFormData = body;
          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this._bodyText = body.toString();
          } else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            this._bodyInit = new Blob([this._bodyArrayBuffer]);
          } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView2(body))) {
            this._bodyArrayBuffer = bufferClone(body);
          } else {
            this._bodyText = body = Object.prototype.toString.call(body);
          }
          if (!this.headers.get("content-type")) {
            if (typeof body === "string") {
              this.headers.set("content-type", "text/plain;charset=UTF-8");
            } else if (this._bodyBlob && this._bodyBlob.type) {
              this.headers.set("content-type", this._bodyBlob.type);
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
            }
          }
        };
        if (support.blob) {
          this.blob = function() {
            var rejected = consumed(this);
            if (rejected) {
              return rejected;
            }
            if (this._bodyBlob) {
              return Promise.resolve(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            } else if (this._bodyFormData) {
              throw new Error("could not read FormData body as blob");
            } else {
              return Promise.resolve(new Blob([this._bodyText]));
            }
          };
          this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
            } else {
              return this.blob().then(readBlobAsArrayBuffer);
            }
          };
        }
        this.text = function() {
          var rejected = consumed(this);
          if (rejected) {
            return rejected;
          }
          if (this._bodyBlob) {
            return readBlobAsText(this._bodyBlob);
          } else if (this._bodyArrayBuffer) {
            return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
          } else if (this._bodyFormData) {
            throw new Error("could not read FormData body as text");
          } else {
            return Promise.resolve(this._bodyText);
          }
        };
        if (support.formData) {
          this.formData = function() {
            return this.text().then(decode);
          };
        }
        this.json = function() {
          return this.text().then(JSON.parse);
        };
        return this;
      }
      var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function normalizeMethod(method2) {
        var upcased = method2.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method2;
      }
      function Request(input, options) {
        options = options || {};
        var body = options.body;
        if (input instanceof Request) {
          if (input.bodyUsed) {
            throw new TypeError("Already read");
          }
          this.url = input.url;
          this.credentials = input.credentials;
          if (!options.headers) {
            this.headers = new Headers2(input.headers);
          }
          this.method = input.method;
          this.mode = input.mode;
          this.signal = input.signal;
          if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
          }
        } else {
          this.url = String(input);
        }
        this.credentials = options.credentials || this.credentials || "same-origin";
        if (options.headers || !this.headers) {
          this.headers = new Headers2(options.headers);
        }
        this.method = normalizeMethod(options.method || this.method || "GET");
        this.mode = options.mode || this.mode || null;
        this.signal = options.signal || this.signal;
        this.referrer = null;
        if ((this.method === "GET" || this.method === "HEAD") && body) {
          throw new TypeError("Body not allowed for GET or HEAD requests");
        }
        this._initBody(body);
      }
      Request.prototype.clone = function() {
        return new Request(this, { body: this._bodyInit });
      };
      function decode(body) {
        var form = new FormData();
        body.trim().split("&").forEach(function(bytes) {
          if (bytes) {
            var split2 = bytes.split("=");
            var name = split2.shift().replace(/\+/g, " ");
            var value = split2.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
          }
        });
        return form;
      }
      function parseHeaders3(rawHeaders) {
        var headers = new Headers2();
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
        preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
          var parts = line.split(":");
          var key = parts.shift().trim();
          if (key) {
            var value = parts.join(":").trim();
            headers.append(key, value);
          }
        });
        return headers;
      }
      Body.call(Request.prototype);
      function Response(bodyInit, options) {
        if (!options) {
          options = {};
        }
        this.type = "default";
        this.status = options.status === void 0 ? 200 : options.status;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = "statusText" in options ? options.statusText : "OK";
        this.headers = new Headers2(options.headers);
        this.url = options.url || "";
        this._initBody(bodyInit);
      }
      Body.call(Response.prototype);
      Response.prototype.clone = function() {
        return new Response(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Headers2(this.headers),
          url: this.url
        });
      };
      Response.error = function() {
        var response = new Response(null, { status: 0, statusText: "" });
        response.type = "error";
        return response;
      };
      var redirectStatuses = [301, 302, 303, 307, 308];
      Response.redirect = function(url, status) {
        if (redirectStatuses.indexOf(status) === -1) {
          throw new RangeError("Invalid status code");
        }
        return new Response(null, { status, headers: { location: url } });
      };
      exports3.DOMException = self2.DOMException;
      try {
        new exports3.DOMException();
      } catch (err) {
        exports3.DOMException = function(message2, name) {
          this.message = message2;
          this.name = name;
          var error3 = Error(message2);
          this.stack = error3.stack;
        };
        exports3.DOMException.prototype = Object.create(Error.prototype);
        exports3.DOMException.prototype.constructor = exports3.DOMException;
      }
      function fetch2(input, init3) {
        return new Promise(function(resolve, reject) {
          var request4 = new Request(input, init3);
          if (request4.signal && request4.signal.aborted) {
            return reject(new exports3.DOMException("Aborted", "AbortError"));
          }
          var xhr2 = new XMLHttpRequest();
          function abortXhr() {
            xhr2.abort();
          }
          xhr2.onload = function() {
            var options = {
              status: xhr2.status,
              statusText: xhr2.statusText,
              headers: parseHeaders3(xhr2.getAllResponseHeaders() || "")
            };
            options.url = "responseURL" in xhr2 ? xhr2.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr2 ? xhr2.response : xhr2.responseText;
            resolve(new Response(body, options));
          };
          xhr2.onerror = function() {
            reject(new TypeError("Network request failed"));
          };
          xhr2.ontimeout = function() {
            reject(new TypeError("Network request failed"));
          };
          xhr2.onabort = function() {
            reject(new exports3.DOMException("Aborted", "AbortError"));
          };
          xhr2.open(request4.method, request4.url, true);
          if (request4.credentials === "include") {
            xhr2.withCredentials = true;
          } else if (request4.credentials === "omit") {
            xhr2.withCredentials = false;
          }
          if ("responseType" in xhr2 && support.blob) {
            xhr2.responseType = "blob";
          }
          request4.headers.forEach(function(value, name) {
            xhr2.setRequestHeader(name, value);
          });
          if (request4.signal) {
            request4.signal.addEventListener("abort", abortXhr);
            xhr2.onreadystatechange = function() {
              if (xhr2.readyState === 4) {
                request4.signal.removeEventListener("abort", abortXhr);
              }
            };
          }
          xhr2.send(typeof request4._bodyInit === "undefined" ? null : request4._bodyInit);
        });
      }
      fetch2.polyfill = true;
      if (!self2.fetch) {
        self2.fetch = fetch2;
        self2.Headers = Headers2;
        self2.Request = Request;
        self2.Response = Response;
      }
      exports3.Headers = Headers2;
      exports3.Request = Request;
      exports3.Response = Response;
      exports3.fetch = fetch2;
      Object.defineProperty(exports3, "__esModule", { value: true });
      return exports3;
    })({});
  })(__self__);
  __self__.fetch.ponyfill = true;
  delete __self__.fetch.polyfill;
  var ctx = __self__;
  exports2 = ctx.fetch;
  exports2.default = ctx.fetch;
  exports2.fetch = ctx.fetch;
  exports2.Headers = ctx.Headers;
  exports2.Request = ctx.Request;
  exports2.Response = ctx.Response;
  module2.exports = exports2;
})(browserPonyfill, browserPonyfill.exports);
(function(module2, exports2) {
  var fetchApi2;
  if (typeof fetch === "function") {
    if (typeof commonjsGlobal !== "undefined" && commonjsGlobal.fetch) {
      fetchApi2 = commonjsGlobal.fetch;
    } else if (typeof window !== "undefined" && window.fetch) {
      fetchApi2 = window.fetch;
    } else {
      fetchApi2 = fetch;
    }
  }
  if (typeof commonjsRequire !== "undefined" && (typeof window === "undefined" || typeof window.document === "undefined")) {
    var f2 = fetchApi2 || browserPonyfill.exports;
    if (f2.default)
      f2 = f2.default;
    exports2.default = f2;
    module2.exports = exports2.default;
  }
})(getFetch$1, getFetch$1.exports);
var getFetch = getFetch$1.exports;
var fetchNode = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  "default": getFetch
}, [getFetch$1.exports]);
function _typeof$7(obj) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$7(obj);
}
var fetchApi;
if (typeof fetch === "function") {
  if (typeof global !== "undefined" && global.fetch) {
    fetchApi = global.fetch;
  } else if (typeof window !== "undefined" && window.fetch) {
    fetchApi = window.fetch;
  } else {
    fetchApi = fetch;
  }
}
var XmlHttpRequestApi;
if (hasXMLHttpRequest()) {
  if (typeof global !== "undefined" && global.XMLHttpRequest) {
    XmlHttpRequestApi = global.XMLHttpRequest;
  } else if (typeof window !== "undefined" && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
  if (typeof global !== "undefined" && global.ActiveXObject) {
    ActiveXObjectApi = global.ActiveXObject;
  } else if (typeof window !== "undefined" && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi)
  fetchApi = getFetch || fetchNode;
if (typeof fetchApi !== "function")
  fetchApi = void 0;
var addQueryString = function addQueryString2(url, params) {
  if (params && _typeof$7(params) === "object") {
    var queryString = "";
    for (var paramName in params) {
      queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
    }
    if (!queryString)
      return url;
    url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt2(url, fetchOptions, callback) {
  fetchApi(url, fetchOptions).then(function(response) {
    if (!response.ok)
      return callback(response.statusText || "Error", {
        status: response.status
      });
    response.text().then(function(data2) {
      callback(null, {
        status: response.status,
        data: data2
      });
    }).catch(callback);
  }).catch(callback);
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch2(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = defaults$5({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
  if (payload)
    headers["Content-Type"] = "application/json";
  var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = defaults$5({
    method: payload ? "POST" : "GET",
    body: payload ? options.stringify(payload) : void 0,
    headers
  }, omitFetchOptions ? {} : reqOptions);
  try {
    fetchIt(url, fetchOptions, callback);
  } catch (e2) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e2.message || e2.message.indexOf("not implemented") < 0) {
      return callback(e2);
    }
    try {
      Object.keys(reqOptions).forEach(function(opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest2(options, url, payload, callback) {
  if (payload && _typeof$7(payload) === "object") {
    payload = addQueryString("", payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x2;
    if (XmlHttpRequestApi) {
      x2 = new XmlHttpRequestApi();
    } else {
      x2 = new ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
    }
    x2.open(payload ? "POST" : "GET", url, 1);
    if (!options.crossDomain) {
      x2.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    x2.withCredentials = !!options.withCredentials;
    if (payload) {
      x2.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    }
    if (x2.overrideMimeType) {
      x2.overrideMimeType("application/json");
    }
    var h2 = options.customHeaders;
    h2 = typeof h2 === "function" ? h2() : h2;
    if (h2) {
      for (var i2 in h2) {
        x2.setRequestHeader(i2, h2[i2]);
      }
    }
    x2.onreadystatechange = function() {
      x2.readyState > 3 && callback(x2.status >= 400 ? x2.statusText : null, {
        status: x2.status,
        data: x2.responseText
      });
    };
    x2.send(payload);
  } catch (e2) {
    console && console.log(e2);
  }
};
var request = function request2(options, url, payload, callback) {
  if (typeof payload === "function") {
    callback = payload;
    payload = void 0;
  }
  callback = callback || function() {
  };
  if (fetchApi) {
    return requestWithFetch(options, url, payload, callback);
  }
  if (hasXMLHttpRequest() || typeof ActiveXObject === "function") {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error("No fetch and no xhr implementation found!"));
};
function _classCallCheck$h(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$9(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$f(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$9(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$9(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var getDefaults$2 = function getDefaults2() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    allowMultiLoading: false,
    parse: function parse2(data2) {
      return JSON.parse(data2);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty$8({}, key, fallbackValue || "");
    },
    request,
    reloadInterval: typeof window !== "undefined" ? false : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
};
var Backend = function() {
  function Backend2(services) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    _classCallCheck$h(this, Backend2);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = "backend";
    this.init(services, options, allOptions);
  }
  _createClass$f(Backend2, [{
    key: "init",
    value: function init3(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = services;
      this.options = defaults$5(options, this.options || {}, getDefaults$2());
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        setInterval(function() {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read2(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath2 = this.options.loadPath;
      if (typeof this.options.loadPath === "function") {
        loadPath2 = this.options.loadPath(languages, namespaces);
      }
      loadPath2 = makePromise(loadPath2);
      loadPath2.then(function(resolvedLoadPath) {
        if (!resolvedLoadPath)
          return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join("+"),
          ns: namespaces.join("+")
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      this.options.request(this.options, url, void 0, function(err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status))
          return callback("failed loading " + url + "; status code: " + res.status, true);
        if (res && res.status >= 400 && res.status < 500)
          return callback("failed loading " + url + "; status code: " + res.status, false);
        if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1)
          return callback("failed loading " + url + ": " + err.message, true);
        if (err)
          return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === "string") {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e2) {
          parseErr = "failed parsing " + url + " to json";
        }
        if (parseErr)
          return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create3(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath)
        return;
      if (typeof languages === "string")
        languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function(lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === "function") {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function(data2, res) {
          finished += 1;
          dataArray.push(data2);
          resArray.push(res);
          if (finished === languages.length) {
            if (callback)
              callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload2() {
      var _this5 = this;
      var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === "cimode")
        return;
      var toLoad = [];
      var append = function append2(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function(l2) {
          if (toLoad.indexOf(l2) < 0)
            toLoad.push(l2);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload)
        this.allOptions.preload.forEach(function(l2) {
          return append(l2);
        });
      toLoad.forEach(function(lng) {
        _this5.allOptions.ns.forEach(function(ns) {
          backendConnector.read(lng, ns, "read", null, null, function(err, data2) {
            if (err)
              logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data2)
              logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data2);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data2);
          });
        });
      });
    }
  }]);
  return Backend2;
}();
Backend.type = "backend";
function _classCallCheck$g(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$8(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$e(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$8(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$8(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
var arr = [];
var each = arr.forEach;
var slice$4 = arr.slice;
function defaults$4(obj) {
  each.call(slice$4.call(arguments, 1), function(source2) {
    if (source2) {
      for (var prop in source2) {
        if (obj[prop] === void 0)
          obj[prop] = source2[prop];
      }
    }
  });
  return obj;
}
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function serializeCookie2(name, val, options) {
  var opt = options || {};
  opt.path = opt.path || "/";
  var value = encodeURIComponent(val);
  var str = "".concat(name, "=").concat(value);
  if (opt.maxAge > 0) {
    var maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge))
      throw new Error("maxAge should be a Number");
    str += "; Max-Age=".concat(Math.floor(maxAge));
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError("option domain is invalid");
    }
    str += "; Domain=".concat(opt.domain);
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError("option path is invalid");
    }
    str += "; Path=".concat(opt.path);
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== "function") {
      throw new TypeError("option expires is invalid");
    }
    str += "; Expires=".concat(opt.expires.toUTCString());
  }
  if (opt.httpOnly)
    str += "; HttpOnly";
  if (opt.secure)
    str += "; Secure";
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += "; SameSite=Strict";
        break;
      case "lax":
        str += "; SameSite=Lax";
        break;
      case "strict":
        str += "; SameSite=Strict";
        break;
      case "none":
        str += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return str;
};
var cookie = {
  create: function create2(name, value, minutes, domain) {
    var cookieOptions = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1e3);
    }
    if (domain)
      cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
  },
  read: function read(name) {
    var nameEQ = "".concat(name, "=");
    var ca2 = document.cookie.split(";");
    for (var i2 = 0; i2 < ca2.length; i2++) {
      var c2 = ca2[i2];
      while (c2.charAt(0) === " ") {
        c2 = c2.substring(1, c2.length);
      }
      if (c2.indexOf(nameEQ) === 0)
        return c2.substring(nameEQ.length, c2.length);
    }
    return null;
  },
  remove: function remove(name) {
    this.create(name, "", -1);
  }
};
var cookie$1 = {
  name: "cookie",
  lookup: function lookup(options) {
    var found;
    if (options.lookupCookie && typeof document !== "undefined") {
      var c2 = cookie.read(options.lookupCookie);
      if (c2)
        found = c2;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== "undefined") {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
  }
};
var querystring = {
  name: "querystring",
  lookup: function lookup2(options) {
    var found;
    if (typeof window !== "undefined") {
      var search = window.location.search;
      if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf("?"));
      }
      var query = search.substring(1);
      var params = query.split("&");
      for (var i2 = 0; i2 < params.length; i2++) {
        var pos = params[i2].indexOf("=");
        if (pos > 0) {
          var key = params[i2].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i2].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};
var hasLocalStorageSupport = null;
var localStorageAvailable = function localStorageAvailable2() {
  if (hasLocalStorageSupport !== null)
    return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
    var testKey = "i18next.translate.boo";
    window.localStorage.setItem(testKey, "foo");
    window.localStorage.removeItem(testKey);
  } catch (e2) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var localStorage$1 = {
  name: "localStorage",
  lookup: function lookup3(options) {
    var found;
    if (options.lookupLocalStorage && localStorageAvailable()) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng)
        found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage2(lng, options) {
    if (options.lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};
var hasSessionStorageSupport = null;
var sessionStorageAvailable = function sessionStorageAvailable2() {
  if (hasSessionStorageSupport !== null)
    return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
    var testKey = "i18next.translate.boo";
    window.sessionStorage.setItem(testKey, "foo");
    window.sessionStorage.removeItem(testKey);
  } catch (e2) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage$1 = {
  name: "sessionStorage",
  lookup: function lookup4(options) {
    var found;
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
      if (lng)
        found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage3(lng, options) {
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
  }
};
var navigator$1 = {
  name: "navigator",
  lookup: function lookup5(options) {
    var found = [];
    if (typeof navigator !== "undefined") {
      if (navigator.languages) {
        for (var i2 = 0; i2 < navigator.languages.length; i2++) {
          found.push(navigator.languages[i2]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }
    return found.length > 0 ? found : void 0;
  }
};
var htmlTag = {
  name: "htmlTag",
  lookup: function lookup6(options) {
    var found;
    var htmlTag2 = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
    if (htmlTag2 && typeof htmlTag2.getAttribute === "function") {
      found = htmlTag2.getAttribute("lang");
    }
    return found;
  }
};
var path = {
  name: "path",
  lookup: function lookup7(options) {
    var found;
    if (typeof window !== "undefined") {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === "number") {
          if (typeof language[options.lookupFromPathIndex] !== "string") {
            return void 0;
          }
          found = language[options.lookupFromPathIndex].replace("/", "");
        } else {
          found = language[0].replace("/", "");
        }
      }
    }
    return found;
  }
};
var subdomain = {
  name: "subdomain",
  lookup: function lookup8(options) {
    var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
    var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (!language)
      return void 0;
    return language[lookupFromSubdomainIndex];
  }
};
function getDefaults$1() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"]
  };
}
var Browser = /* @__PURE__ */ function() {
  function Browser2(services) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$g(this, Browser2);
    this.type = "languageDetector";
    this.detectors = {};
    this.init(services, options);
  }
  _createClass$e(Browser2, [{
    key: "init",
    value: function init3(services) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = services;
      this.options = defaults$4(options, this.options || {}, getDefaults$1());
      if (this.options.lookupFromUrlIndex)
        this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(localStorage$1);
      this.addDetector(sessionStorage$1);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect2(detectionOrder) {
      var _this = this;
      if (!detectionOrder)
        detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function(detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup9 = _this.detectors[detectorName].lookup(_this.options);
          if (lookup9 && typeof lookup9 === "string")
            lookup9 = [lookup9];
          if (lookup9)
            detected = detected.concat(lookup9);
        }
      });
      if (this.services.languageUtils.getBestMatchFromCodes)
        return detected;
      return detected.length > 0 ? detected[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage4(lng, caches) {
      var _this2 = this;
      if (!caches)
        caches = this.options.caches;
      if (!caches)
        return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1)
        return;
      caches.forEach(function(cacheName) {
        if (_this2.detectors[cacheName])
          _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);
  return Browser2;
}();
Browser.type = "languageDetector";
function _objectWithoutPropertiesLoose(source2, excluded) {
  if (source2 == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source2[key];
  }
  return target;
}
function _objectWithoutProperties$3(source2, excluded) {
  if (source2 == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source2, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source2, key))
        continue;
      target[key] = source2[key];
    }
  }
  return target;
}
function _typeof$6(obj) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$6(obj);
}
function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var voidElements = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};
var t$1 = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n$2(n2) {
  var r2 = { type: "tag", name: "", voidElement: false, attrs: {}, children: [] }, i2 = n2.match(/<\/?([^\s]+?)[/\s>]/);
  if (i2 && (r2.name = i2[1], (voidElements[i2[1]] || n2.charAt(n2.length - 2) === "/") && (r2.voidElement = true), r2.name.startsWith("!--"))) {
    var s2 = n2.indexOf("-->");
    return { type: "comment", comment: s2 !== -1 ? n2.slice(4, s2) : "" };
  }
  for (var a6 = new RegExp(t$1), c2 = null; (c2 = a6.exec(n2)) !== null; )
    if (c2[0].trim())
      if (c2[1]) {
        var o = c2[1].trim(), l2 = [o, ""];
        o.indexOf("=") > -1 && (l2 = o.split("=")), r2.attrs[l2[0]] = l2[1], a6.lastIndex--;
      } else
        c2[2] && (r2.attrs[c2[2]] = c2[3].trim().substring(1, c2[3].length - 1));
  return r2;
}
var r$2 = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i$2 = /^\s*$/, s$1 = /* @__PURE__ */ Object.create(null);
function a$2(e2, t2) {
  switch (t2.type) {
    case "text":
      return e2 + t2.content;
    case "tag":
      return e2 += "<" + t2.name + (t2.attrs ? function(e3) {
        var t3 = [];
        for (var n2 in e3)
          t3.push(n2 + '="' + e3[n2] + '"');
        return t3.length ? " " + t3.join(" ") : "";
      }(t2.attrs) : "") + (t2.voidElement ? "/>" : ">"), t2.voidElement ? e2 : e2 + t2.children.reduce(a$2, "") + "</" + t2.name + ">";
    case "comment":
      return e2 + "<!--" + t2.comment + "-->";
  }
}
var c$2 = { parse: function(e2, t2) {
  t2 || (t2 = {}), t2.components || (t2.components = s$1);
  var a6, c2 = [], o = [], l2 = -1, m2 = false;
  if (e2.indexOf("<") !== 0) {
    var u2 = e2.indexOf("<");
    c2.push({ type: "text", content: u2 === -1 ? e2 : e2.substring(0, u2) });
  }
  return e2.replace(r$2, function(r2, s2) {
    if (m2) {
      if (r2 !== "</" + a6.name + ">")
        return;
      m2 = false;
    }
    var u3, f2 = r2.charAt(1) !== "/", h2 = r2.startsWith("<!--"), p2 = s2 + r2.length, d2 = e2.charAt(p2);
    if (h2) {
      var v2 = n$2(r2);
      return l2 < 0 ? (c2.push(v2), c2) : ((u3 = o[l2]).children.push(v2), c2);
    }
    if (f2 && (l2++, (a6 = n$2(r2)).type === "tag" && t2.components[a6.name] && (a6.type = "component", m2 = true), a6.voidElement || m2 || !d2 || d2 === "<" || a6.children.push({ type: "text", content: e2.slice(p2, e2.indexOf("<", p2)) }), l2 === 0 && c2.push(a6), (u3 = o[l2 - 1]) && u3.children.push(a6), o[l2] = a6), (!f2 || a6.voidElement) && (l2 > -1 && (a6.voidElement || a6.name === r2.slice(2, -1)) && (l2--, a6 = l2 === -1 ? c2 : o[l2]), !m2 && d2 !== "<" && d2)) {
      u3 = l2 === -1 ? c2 : o[l2].children;
      var x2 = e2.indexOf("<", p2), g2 = e2.slice(p2, x2 === -1 ? void 0 : x2);
      i$2.test(g2) && (g2 = " "), (x2 > -1 && l2 + u3.length >= 0 || g2 !== " ") && u3.push({ type: "text", content: g2 });
    }
  }), c2;
}, stringify: function(e2) {
  return e2.reduce(function(e3, t2) {
    return e3 + a$2("", t2);
  }, "");
} };
var replace = "".replace;
var es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
var unes = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"'
};
function unescape$1(un) {
  return replace.call(un, es, cape);
}
function cape(m2) {
  return unes[m2];
}
function _classCallCheck$f(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$7(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$d(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$7(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$a(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$5(Object(source2), true).forEach(function(key) {
        _defineProperty$7(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$5(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
var defaultOptions = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: true
};
var i18nInstance;
var I18nContext = React__default.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  defaultOptions = _objectSpread$a(_objectSpread$a({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function() {
  function ReportNamespaces2() {
    _classCallCheck$f(this, ReportNamespaces2);
    this.usedNamespaces = {};
  }
  _createClass$d(ReportNamespaces2, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function(ns) {
        if (!_this.usedNamespaces[ns])
          _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces2;
}();
function setI18n(instance2) {
  i18nInstance = instance2;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: "3rdParty",
  init: function init2(instance2) {
    setDefaults(instance2.options.react);
    setI18n(instance2);
  }
};
function warn$1() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === "string")
      args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === "string" && alreadyWarned[args[0]])
    return;
  if (typeof args[0] === "string")
    alreadyWarned[args[0]] = new Date();
  warn$1.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb2) {
  i18n.loadNamespaces(ns, function() {
    if (i18n.isInitialized) {
      cb2();
    } else {
      var initialized = function initialized2() {
        setTimeout(function() {
          i18n.off("initialized", initialized2);
        }, 0);
        cb2();
      };
      i18n.on("initialized", initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce("i18n.languages were undefined or empty", i18n.languages);
    return true;
  }
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === "cimode")
    return true;
  var loadNotPending = function loadNotPending2(l2, n2) {
    var loadState = i18n.services.backendConnector.state["".concat(l2, "|").concat(n2)];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns))
    return false;
  if (i18n.hasResourceBundle(lng, ns))
    return true;
  if (!i18n.services.backendConnector.backend)
    return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
    return true;
  return false;
}
var _excluded$1 = ["format"], _excluded2 = ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$9(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$4(Object(source2), true).forEach(function(key) {
        _defineProperty$7(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$4(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function hasChildren(node, checkLength) {
  if (!node)
    return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength)
    return base.length > 0;
  return !!base;
}
function getChildren(node) {
  if (!node)
    return [];
  return node && node.children ? node.children : node.props && node.props.children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== "[object Array]")
    return false;
  return children.every(function(child) {
    return React__default.isValidElement(child);
  });
}
function getAsArray(data2) {
  return Array.isArray(data2) ? data2 : [data2];
}
function mergeProps(source2, target) {
  var newTarget = _objectSpread$9({}, target);
  newTarget.props = Object.assign(source2.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children)
    return "";
  var stringNode = "";
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  childrenArray.forEach(function(child, childIndex) {
    if (typeof child === "string") {
      stringNode += "".concat(child);
    } else if (React__default.isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn$1("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof$6(child) === "object") {
      var format = child.format, clone2 = _objectWithoutProperties$3(child, _excluded$1);
      var keys = Object.keys(clone2);
      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn$1("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn$1("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === "")
    return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling)
    return [targetString];
  var data2 = {};
  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function(child) {
      if (typeof child === "string")
        return;
      if (hasChildren(child))
        getData(getChildren(child));
      else if (_typeof$6(child) === "object" && !React__default.isValidElement(child))
        Object.assign(data2, child);
    });
  }
  getData(children);
  var ast = c$2.parse("<0>".concat(targetString, "</0>"));
  var opts = _objectSpread$9(_objectSpread$9({}, data2), combinedTOpts);
  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i2, isVoid) {
    if (child.dummy)
      child.children = inner;
    mem.push(React__default.cloneElement(child, _objectSpread$9(_objectSpread$9({}, child.props), {}, {
      key: i2
    }), isVoid ? void 0 : inner));
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function(mem, node, i2) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === "tag") {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name])
          tmp = rootReactNode[0][node.name];
        if (!tmp)
          tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = React__default.isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof$6(child) === "object" && child.dummy && !isElement;
        var isKnownComponent = _typeof$6(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === "string") {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          var inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i2);
        } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);
          mem.push(React__default.cloneElement(child, _objectSpread$9(_objectSpread$9({}, child.props), {}, {
            key: i2
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, _inner2, mem, i2, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(React__default.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i2)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
              mem.push(React__default.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i2)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof$6(child) === "object" && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content)
            mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(React__default.cloneElement(child, _objectSpread$9(_objectSpread$9({}, child.props), {}, {
            key: i2
          }), translationContent));
        } else {
          mem.push(React__default.cloneElement(child, _objectSpread$9(_objectSpread$9({}, child.props), {}, {
            key: i2
          })));
        }
      } else if (node.type === "text") {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;
        var _content = shouldUnescape ? unescape$1(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push(React__default.createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i2)
          }, _content));
        } else {
          mem.push(_content);
        }
      }
      return mem;
    }, []);
  }
  var result2 = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result2[0]);
}
function Trans(_ref) {
  var children = _ref.children, count2 = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults2 = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = _objectWithoutProperties$3(_ref, _excluded2);
  var _ref2 = useContext(I18nContext) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (!i18n) {
    warnOnce("You will need to pass in an i18next instance by using i18nextReactModule");
    return children;
  }
  var t2 = tFromProps || i18n.t.bind(i18n) || function(k3) {
    return k3;
  };
  var reactI18nextOptions = _objectSpread$9(_objectSpread$9({}, getDefaults()), i18n.options && i18n.options.react);
  var namespaces = ns || t2.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  var defaultValue = defaults2 || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread$9(_objectSpread$9({}, tOptions.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  };
  var combinedTOpts = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, tOptions), {}, {
    count: count2
  }, values), interpolationOverride), {}, {
    defaultValue,
    ns: namespaces
  });
  var translation = key ? t2(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? React__default.createElement(useAsParent, additionalProps, content) : content;
}
function _arrayWithHoles$4(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function _iterableToArrayLimit$4(arr2, i2) {
  var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayLikeToArray(arr2, len) {
  if (len == null || len > arr2.length)
    len = arr2.length;
  for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
    arr22[i2] = arr2[i2];
  }
  return arr22;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest$4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$4(arr2, i2) {
  return _arrayWithHoles$4(arr2) || _iterableToArrayLimit$4(arr2, i2) || _unsupportedIterableToArray(arr2, i2) || _nonIterableRest$4();
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$8(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$3(Object(source2), true).forEach(function(key) {
        _defineProperty$7(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$3(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref = useContext(I18nContext) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces)
    i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce("You will need to pass in an i18next instance by using initReactI18next");
    var notReadyT = function notReadyT2(k3) {
      return Array.isArray(k3) ? k3[k3.length - 1] : k3;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== void 0)
    warnOnce("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var i18nOptions = _objectSpread$8(_objectSpread$8(_objectSpread$8({}, getDefaults()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  if (i18n.reportNamespaces.addUsedNamespaces)
    i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n2) {
    return hasLoadedNamespace(n2, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState(getT), _useState2 = _slicedToArray$4(_useState, 2), t2 = _useState2[0], setT = _useState2[1];
  var isMounted = useRef(true);
  useEffect(function() {
    var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function() {
        if (isMounted.current)
          setT(getT);
      });
    }
    function boundReset() {
      if (isMounted.current)
        setT(getT);
    }
    if (bindI18n && i18n)
      i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n)
      i18n.store.on(bindI18nStore, boundReset);
    return function() {
      isMounted.current = false;
      if (bindI18n && i18n)
        bindI18n.split(" ").forEach(function(e2) {
          return i18n.off(e2, boundReset);
        });
      if (bindI18nStore && i18n)
        bindI18nStore.split(" ").forEach(function(e2) {
          return i18n.store.off(e2, boundReset);
        });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = useRef(true);
  useEffect(function() {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n]);
  var ret = [t2, i18n, ready];
  ret.t = t2;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready)
    return ret;
  if (!ready && !useSuspense)
    return ret;
  throw new Promise(function(resolve) {
    loadNamespaces(i18n, namespaces, function() {
      resolve();
    });
  });
}
function I18nextProvider(_ref) {
  var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
  var value = useMemo(function() {
    return {
      i18n,
      defaultNS
    };
  }, [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children);
}
var dayjs_min = { exports: {} };
(function(module2, exports2) {
  !function(t2, e2) {
    module2.exports = e2();
  }(commonjsGlobal, function() {
    var t2 = 1e3, e2 = 6e4, n2 = 36e5, r2 = "millisecond", i2 = "second", s2 = "minute", u2 = "hour", a6 = "day", o = "week", f2 = "month", h2 = "quarter", c2 = "year", d2 = "date", $2 = "Invalid Date", l2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M2 = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m2 = function(t3, e3, n3) {
      var r3 = String(t3);
      return !r3 || r3.length >= e3 ? t3 : "" + Array(e3 + 1 - r3.length).join(n3) + t3;
    }, g2 = { s: m2, z: function(t3) {
      var e3 = -t3.utcOffset(), n3 = Math.abs(e3), r3 = Math.floor(n3 / 60), i3 = n3 % 60;
      return (e3 <= 0 ? "+" : "-") + m2(r3, 2, "0") + ":" + m2(i3, 2, "0");
    }, m: function t3(e3, n3) {
      if (e3.date() < n3.date())
        return -t3(n3, e3);
      var r3 = 12 * (n3.year() - e3.year()) + (n3.month() - e3.month()), i3 = e3.clone().add(r3, f2), s3 = n3 - i3 < 0, u3 = e3.clone().add(r3 + (s3 ? -1 : 1), f2);
      return +(-(r3 + (n3 - i3) / (s3 ? i3 - u3 : u3 - i3)) || 0);
    }, a: function(t3) {
      return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
    }, p: function(t3) {
      return { M: f2, y: c2, w: o, d: a6, D: d2, h: u2, m: s2, s: i2, ms: r2, Q: h2 }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t3) {
      return t3 === void 0;
    } }, v2 = "en", D2 = {};
    D2[v2] = M2;
    var p2 = function(t3) {
      return t3 instanceof _24;
    }, S2 = function t3(e3, n3, r3) {
      var i3;
      if (!e3)
        return v2;
      if (typeof e3 == "string") {
        var s3 = e3.toLowerCase();
        D2[s3] && (i3 = s3), n3 && (D2[s3] = n3, i3 = s3);
        var u3 = e3.split("-");
        if (!i3 && u3.length > 1)
          return t3(u3[0]);
      } else {
        var a7 = e3.name;
        D2[a7] = e3, i3 = a7;
      }
      return !r3 && i3 && (v2 = i3), i3 || !r3 && v2;
    }, w2 = function(t3, e3) {
      if (p2(t3))
        return t3.clone();
      var n3 = typeof e3 == "object" ? e3 : {};
      return n3.date = t3, n3.args = arguments, new _24(n3);
    }, O = g2;
    O.l = S2, O.i = p2, O.w = function(t3, e3) {
      return w2(t3, { locale: e3.$L, utc: e3.$u, x: e3.$x, $offset: e3.$offset });
    };
    var _24 = function() {
      function M3(t3) {
        this.$L = S2(t3.locale, null, true), this.parse(t3);
      }
      var m3 = M3.prototype;
      return m3.parse = function(t3) {
        this.$d = function(t4) {
          var e3 = t4.date, n3 = t4.utc;
          if (e3 === null)
            return new Date(NaN);
          if (O.u(e3))
            return new Date();
          if (e3 instanceof Date)
            return new Date(e3);
          if (typeof e3 == "string" && !/Z$/i.test(e3)) {
            var r3 = e3.match(l2);
            if (r3) {
              var i3 = r3[2] - 1 || 0, s3 = (r3[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r3[1], i3, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s3)) : new Date(r3[1], i3, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s3);
            }
          }
          return new Date(e3);
        }(t3), this.$x = t3.x || {}, this.init();
      }, m3.init = function() {
        var t3 = this.$d;
        this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
      }, m3.$utils = function() {
        return O;
      }, m3.isValid = function() {
        return !(this.$d.toString() === $2);
      }, m3.isSame = function(t3, e3) {
        var n3 = w2(t3);
        return this.startOf(e3) <= n3 && n3 <= this.endOf(e3);
      }, m3.isAfter = function(t3, e3) {
        return w2(t3) < this.startOf(e3);
      }, m3.isBefore = function(t3, e3) {
        return this.endOf(e3) < w2(t3);
      }, m3.$g = function(t3, e3, n3) {
        return O.u(t3) ? this[e3] : this.set(n3, t3);
      }, m3.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m3.valueOf = function() {
        return this.$d.getTime();
      }, m3.startOf = function(t3, e3) {
        var n3 = this, r3 = !!O.u(e3) || e3, h3 = O.p(t3), $3 = function(t4, e4) {
          var i3 = O.w(n3.$u ? Date.UTC(n3.$y, e4, t4) : new Date(n3.$y, e4, t4), n3);
          return r3 ? i3 : i3.endOf(a6);
        }, l3 = function(t4, e4) {
          return O.w(n3.toDate()[t4].apply(n3.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e4)), n3);
        }, y3 = this.$W, M4 = this.$M, m4 = this.$D, g3 = "set" + (this.$u ? "UTC" : "");
        switch (h3) {
          case c2:
            return r3 ? $3(1, 0) : $3(31, 11);
          case f2:
            return r3 ? $3(1, M4) : $3(0, M4 + 1);
          case o:
            var v3 = this.$locale().weekStart || 0, D3 = (y3 < v3 ? y3 + 7 : y3) - v3;
            return $3(r3 ? m4 - D3 : m4 + (6 - D3), M4);
          case a6:
          case d2:
            return l3(g3 + "Hours", 0);
          case u2:
            return l3(g3 + "Minutes", 1);
          case s2:
            return l3(g3 + "Seconds", 2);
          case i2:
            return l3(g3 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m3.endOf = function(t3) {
        return this.startOf(t3, false);
      }, m3.$set = function(t3, e3) {
        var n3, o2 = O.p(t3), h3 = "set" + (this.$u ? "UTC" : ""), $3 = (n3 = {}, n3[a6] = h3 + "Date", n3[d2] = h3 + "Date", n3[f2] = h3 + "Month", n3[c2] = h3 + "FullYear", n3[u2] = h3 + "Hours", n3[s2] = h3 + "Minutes", n3[i2] = h3 + "Seconds", n3[r2] = h3 + "Milliseconds", n3)[o2], l3 = o2 === a6 ? this.$D + (e3 - this.$W) : e3;
        if (o2 === f2 || o2 === c2) {
          var y3 = this.clone().set(d2, 1);
          y3.$d[$3](l3), y3.init(), this.$d = y3.set(d2, Math.min(this.$D, y3.daysInMonth())).$d;
        } else
          $3 && this.$d[$3](l3);
        return this.init(), this;
      }, m3.set = function(t3, e3) {
        return this.clone().$set(t3, e3);
      }, m3.get = function(t3) {
        return this[O.p(t3)]();
      }, m3.add = function(r3, h3) {
        var d3, $3 = this;
        r3 = Number(r3);
        var l3 = O.p(h3), y3 = function(t3) {
          var e3 = w2($3);
          return O.w(e3.date(e3.date() + Math.round(t3 * r3)), $3);
        };
        if (l3 === f2)
          return this.set(f2, this.$M + r3);
        if (l3 === c2)
          return this.set(c2, this.$y + r3);
        if (l3 === a6)
          return y3(1);
        if (l3 === o)
          return y3(7);
        var M4 = (d3 = {}, d3[s2] = e2, d3[u2] = n2, d3[i2] = t2, d3)[l3] || 1, m4 = this.$d.getTime() + r3 * M4;
        return O.w(m4, this);
      }, m3.subtract = function(t3, e3) {
        return this.add(-1 * t3, e3);
      }, m3.format = function(t3) {
        var e3 = this, n3 = this.$locale();
        if (!this.isValid())
          return n3.invalidDate || $2;
        var r3 = t3 || "YYYY-MM-DDTHH:mm:ssZ", i3 = O.z(this), s3 = this.$H, u3 = this.$m, a7 = this.$M, o2 = n3.weekdays, f3 = n3.months, h3 = function(t4, n4, i4, s4) {
          return t4 && (t4[n4] || t4(e3, r3)) || i4[n4].slice(0, s4);
        }, c3 = function(t4) {
          return O.s(s3 % 12 || 12, t4, "0");
        }, d3 = n3.meridiem || function(t4, e4, n4) {
          var r4 = t4 < 12 ? "AM" : "PM";
          return n4 ? r4.toLowerCase() : r4;
        }, l3 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a7 + 1, MM: O.s(a7 + 1, 2, "0"), MMM: h3(n3.monthsShort, a7, f3, 3), MMMM: h3(f3, a7), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h3(n3.weekdaysMin, this.$W, o2, 2), ddd: h3(n3.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s3), HH: O.s(s3, 2, "0"), h: c3(1), hh: c3(2), a: d3(s3, u3, true), A: d3(s3, u3, false), m: String(u3), mm: O.s(u3, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i3 };
        return r3.replace(y2, function(t4, e4) {
          return e4 || l3[t4] || i3.replace(":", "");
        });
      }, m3.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m3.diff = function(r3, d3, $3) {
        var l3, y3 = O.p(d3), M4 = w2(r3), m4 = (M4.utcOffset() - this.utcOffset()) * e2, g3 = this - M4, v3 = O.m(this, M4);
        return v3 = (l3 = {}, l3[c2] = v3 / 12, l3[f2] = v3, l3[h2] = v3 / 3, l3[o] = (g3 - m4) / 6048e5, l3[a6] = (g3 - m4) / 864e5, l3[u2] = g3 / n2, l3[s2] = g3 / e2, l3[i2] = g3 / t2, l3)[y3] || g3, $3 ? v3 : O.a(v3);
      }, m3.daysInMonth = function() {
        return this.endOf(f2).$D;
      }, m3.$locale = function() {
        return D2[this.$L];
      }, m3.locale = function(t3, e3) {
        if (!t3)
          return this.$L;
        var n3 = this.clone(), r3 = S2(t3, e3, true);
        return r3 && (n3.$L = r3), n3;
      }, m3.clone = function() {
        return O.w(this.$d, this);
      }, m3.toDate = function() {
        return new Date(this.valueOf());
      }, m3.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m3.toISOString = function() {
        return this.$d.toISOString();
      }, m3.toString = function() {
        return this.$d.toUTCString();
      }, M3;
    }(), T2 = _24.prototype;
    return w2.prototype = T2, [["$ms", r2], ["$s", i2], ["$m", s2], ["$H", u2], ["$W", a6], ["$M", f2], ["$y", c2], ["$D", d2]].forEach(function(t3) {
      T2[t3[1]] = function(e3) {
        return this.$g(e3, t3[0], t3[1]);
      };
    }), w2.extend = function(t3, e3) {
      return t3.$i || (t3(e3, _24, w2), t3.$i = true), w2;
    }, w2.locale = S2, w2.isDayjs = p2, w2.unix = function(t3) {
      return w2(1e3 * t3);
    }, w2.en = D2[v2], w2.Ls = D2, w2.p = {}, w2;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var utc$1 = { exports: {} };
(function(module2, exports2) {
  !function(t2, i2) {
    module2.exports = i2();
  }(commonjsGlobal, function() {
    var t2 = "minute", i2 = /[+-]\d\d(?::?\d\d)?/g, e2 = /([+-]|\d\d)/g;
    return function(s2, f2, n2) {
      var u2 = f2.prototype;
      n2.utc = function(t3) {
        var i3 = { date: t3, utc: true, args: arguments };
        return new f2(i3);
      }, u2.utc = function(i3) {
        var e3 = n2(this.toDate(), { locale: this.$L, utc: true });
        return i3 ? e3.add(this.utcOffset(), t2) : e3;
      }, u2.local = function() {
        return n2(this.toDate(), { locale: this.$L, utc: false });
      };
      var o = u2.parse;
      u2.parse = function(t3) {
        t3.utc && (this.$u = true), this.$utils().u(t3.$offset) || (this.$offset = t3.$offset), o.call(this, t3);
      };
      var r2 = u2.init;
      u2.init = function() {
        if (this.$u) {
          var t3 = this.$d;
          this.$y = t3.getUTCFullYear(), this.$M = t3.getUTCMonth(), this.$D = t3.getUTCDate(), this.$W = t3.getUTCDay(), this.$H = t3.getUTCHours(), this.$m = t3.getUTCMinutes(), this.$s = t3.getUTCSeconds(), this.$ms = t3.getUTCMilliseconds();
        } else
          r2.call(this);
      };
      var a6 = u2.utcOffset;
      u2.utcOffset = function(s3, f3) {
        var n3 = this.$utils().u;
        if (n3(s3))
          return this.$u ? 0 : n3(this.$offset) ? a6.call(this) : this.$offset;
        if (typeof s3 == "string" && (s3 = function(t3) {
          t3 === void 0 && (t3 = "");
          var s4 = t3.match(i2);
          if (!s4)
            return null;
          var f4 = ("" + s4[0]).match(e2) || ["-", 0, 0], n4 = f4[0], u4 = 60 * +f4[1] + +f4[2];
          return u4 === 0 ? 0 : n4 === "+" ? u4 : -u4;
        }(s3), s3 === null))
          return this;
        var u3 = Math.abs(s3) <= 16 ? 60 * s3 : s3, o2 = this;
        if (f3)
          return o2.$offset = u3, o2.$u = s3 === 0, o2;
        if (s3 !== 0) {
          var r3 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (o2 = this.local().add(u3 + r3, t2)).$offset = u3, o2.$x.$localOffset = r3;
        } else
          o2 = this.utc();
        return o2;
      };
      var h2 = u2.format;
      u2.format = function(t3) {
        var i3 = t3 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h2.call(this, i3);
      }, u2.valueOf = function() {
        var t3 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || new Date().getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * t3;
      }, u2.isUTC = function() {
        return !!this.$u;
      }, u2.toISOString = function() {
        return this.toDate().toISOString();
      }, u2.toString = function() {
        return this.toDate().toUTCString();
      };
      var l2 = u2.toDate;
      u2.toDate = function(t3) {
        return t3 === "s" && this.$offset ? n2(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l2.call(this);
      };
      var c2 = u2.diff;
      u2.diff = function(t3, i3, e3) {
        if (t3 && this.$u === t3.$u)
          return c2.call(this, t3, i3, e3);
        var s3 = this.local(), f3 = n2(t3).local();
        return c2.call(s3, f3, i3, e3);
      };
    };
  });
})(utc$1);
var utc = utc$1.exports;
dayjs.extend(utc);
const mobile = {
  Android: () => {
    return !!window.navigator.userAgent.match(/Android/i);
  },
  S10: () => {
    return !!window.navigator.userAgent.match(/SM-G973U1/i);
  },
  J7: () => {
    return !!window.navigator.userAgent.match(/SM-J710F/i);
  },
  BlackBerry: () => {
    return !!window.navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: () => {
    return !!window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: () => {
    return !!window.navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: () => {
    return !!window.navigator.userAgent.match(/IEMobile/i);
  },
  Xiaomi: () => {
    return !!window.navigator.userAgent.match(/Xiaomi/i);
  },
  J7Prime: () => {
    return !!window.navigator.userAgent.match(/SM-G610M/i);
  },
  J7Star: () => {
    return !!window.navigator.userAgent.match(/SM-J737T1/i);
  },
  Alcatel1x: () => {
    return !!window.navigator.userAgent.match(/5059S/i);
  },
  LenovoVibeB: () => {
    return !!window.navigator.userAgent.match(/A2016b30/i);
  },
  MiA3: () => {
    return !!window.navigator.userAgent.match(/MI 3W/i);
  },
  Redmi7: () => {
    return !!window.navigator.userAgent.match(/Redmi Note 7/i);
  },
  G7: () => {
    return !!window.navigator.userAgent.match(/moto g(7)/i);
  },
  HuaweiY9: () => {
    return !!window.navigator.userAgent.match(/STK-LX3/i);
  },
  HuaweiP30: () => {
    return !!window.navigator.userAgent.match(/MAR-LX3/i);
  },
  J4: () => {
    return !!window.navigator.userAgent.match(/SM-J4/i);
  },
  S5: () => {
    return !!window.navigator.userAgent.match(/SM-G900/i);
  },
  E5: () => {
    return !!window.navigator.userAgent.match(/moto e5/i);
  },
  E5Play: () => {
    return !!window.navigator.userAgent.match(/play/i);
  },
  isIpad: () => {
    return !!(/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
  },
  isFBInAppBrowser: () => {
    return window.navigator.userAgent.match(/\[FB/i);
  },
  isInstagramAppBrowser: () => {
    return window.navigator.userAgent.match(/Instagram/i);
  },
  any: () => {
    return isMobile$1;
  },
  isIOS12: () => {
    return !!window.navigator.userAgent.match(/12_2/i) || !!window.navigator.userAgent.match(/12_3/i);
  },
  isDesktop: () => {
    return !mobile.any();
  }
};
function isSafari() {
  return window.navigator.vendor && window.navigator.vendor.indexOf("Apple") > -1 && window.navigator.userAgent && window.navigator.userAgent.indexOf("CriOS") === -1 && window.navigator.userAgent.indexOf("FxiOS") === -1;
}
const isWebRtcSupported = () => {
  if (mobile.Xiaomi()) {
    return false;
  }
  return !!(window.navigator.mediaDevices && window.navigator.mediaDevices.getUserMedia);
};
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const throttle$1 = (func, limit) => {
  let inThrottle;
  return (...args) => {
    const context2 = globalThis;
    if (!inThrottle) {
      func.apply(context2, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};
const getLogObject = (key, payload) => {
  return {
    type: key,
    payload
  };
};
const resizeImg = function(image2, targetWidth) {
  const canvas = document.createElement("canvas");
  canvas.width = image2.width <= targetWidth ? image2.width : targetWidth;
  canvas.height = image2.width <= targetWidth ? image2.height : image2.height / (image2.width / targetWidth);
  const ctx = canvas.getContext("2d");
  ctx == null ? void 0 : ctx.drawImage(image2, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL();
};
const rotateImg = (image2) => {
  const canvas = document.createElement("canvas");
  canvas.width = image2.width;
  canvas.height = image2.height;
  const ctx = canvas.getContext("2d");
  ctx == null ? void 0 : ctx.drawImage(image2, 0, 0);
  const tmp = canvas.width;
  canvas.width = canvas.height;
  canvas.height = tmp;
  ctx == null ? void 0 : ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx == null ? void 0 : ctx.save();
  ctx == null ? void 0 : ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx == null ? void 0 : ctx.rotate(-90 * Math.PI / 180);
  ctx == null ? void 0 : ctx.drawImage(image2, -image2.width / 2, -image2.height / 2);
  ctx == null ? void 0 : ctx.restore();
  return canvas;
};
const getBase64 = (file) => new Promise((resolve, reject) => {
  const fileReader = new FileReader();
  fileReader.onload = function(fileLoadedEvent) {
    var _a;
    const base64 = (_a = fileLoadedEvent == null ? void 0 : fileLoadedEvent.target) == null ? void 0 : _a.result;
    resolve(base64);
  };
  fileReader.readAsDataURL(file);
  fileReader.onerror = (error3) => reject(error3);
});
const getScaledBase64 = (file, targetWidth = 1280, shouldBeVertical = false) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = function() {
    const finalImage = shouldBeVertical && img.width > img.height ? rotateImg(img) : img;
    const dataUrl = resizeImg(finalImage, targetWidth);
    URL.revokeObjectURL(img.src);
    resolve(dataUrl);
  };
  img.onerror = (error3) => reject(error3);
  img.src = URL.createObjectURL(file);
});
const getScaledImageFromFile = async (file, targetWidth = 1280, shouldBeVertical = false) => {
  const imageBase64 = file.type === "application/pdf" ? await getBase64(file) : await getScaledBase64(file, targetWidth, shouldBeVertical);
  return { imageBase64, fullImage: file };
};
const toBlob = (base64) => {
  const binary = atob(base64);
  const array = [];
  for (let i2 = 0; i2 < binary.length; i2++) {
    array.push(binary.charCodeAt(i2));
  }
  return new Blob([new Uint8Array(array)]);
};
function emptyFunc(...props) {
}
const camelToStartCase = (text) => {
  const result2 = text.replace(/([A-Z])/g, " $1");
  return result2.charAt(0).toUpperCase() + result2.slice(1);
};
const formatInputDate = (date) => {
  let d2 = new Date(date), month = "" + (d2.getMonth() + 1), day = "" + d2.getDate(), year = d2.getFullYear();
  if (month.length < 2)
    month = "0" + month;
  if (day.length < 2)
    day = "0" + day;
  return [year, month, day].join("-");
};
const getMaskPosition = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const ratio = 8.6 / 5.4;
  const maxWidth = 0.86;
  const maxHeightRatio = 0.9;
  const maxHeight = windowHeight * maxHeightRatio;
  const width2 = windowWidth * maxWidth;
  const idealHeight = width2 * ratio;
  const height2 = idealHeight > maxHeight ? maxHeight : idealHeight;
  return {
    width: width2,
    height: height2,
    left: (windowWidth - width2) / 2,
    top: (windowHeight - height2) / 2
  };
};
const isVirtualCamera = (mediaStreamTrack) => {
  return mediaStreamTrack.label.includes("Virtual") || mediaStreamTrack.label.includes("virtual") || mediaStreamTrack.label.includes("/") || mediaStreamTrack.label.includes("\\");
};
const isTouchDevice = () => navigator.maxTouchPoints > 0 || "ontouchstart" in document.documentElement;
const isBrowserSimulation = () => {
  return isTouchDevice() && navigator.maxTouchPoints === 1 && (getHasLiedBrowser() || window.navigator.userAgent.indexOf("Mobile") !== -1) || mobile.iOS() && typeof window.ontouchstart === "undefined";
};
const getHasLiedBrowser = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  let productSub = navigator.productSub;
  let browser;
  if (userAgent.indexOf("edge/") >= 0 || userAgent.indexOf("iemobile/") >= 0) {
    return false;
  } else if (userAgent.indexOf("opera mini") >= 0) {
    return false;
  } else if (userAgent.indexOf("firefox/") >= 0) {
    browser = "Firefox";
  } else if (userAgent.indexOf("opera/") >= 0 || userAgent.indexOf(" opr/") >= 0) {
    browser = "Opera";
  } else if (userAgent.indexOf("chrome/") >= 0) {
    browser = "Chrome";
  } else if (userAgent.indexOf("safari/") >= 0) {
    if (userAgent.indexOf("android 1.") >= 0 || userAgent.indexOf("android 2.") >= 0 || userAgent.indexOf("android 3.") >= 0 || userAgent.indexOf("android 4.") >= 0) {
      browser = "AOSP";
    } else {
      browser = "Safari";
    }
  } else if (userAgent.indexOf("trident/") >= 0) {
    browser = "Internet Explorer";
  } else {
    browser = "Other";
  }
  if ((browser === "Chrome" || browser === "Safari" || browser === "Opera") && productSub !== "20030107") {
    return true;
  }
  let tempRes = eval.toString().length;
  if (tempRes === 37 && browser !== "Safari" && browser !== "Firefox" && browser !== "Other") {
    return true;
  } else if (tempRes === 39 && browser !== "Internet Explorer" && browser !== "Other") {
    return true;
  } else if (tempRes === 33 && browser !== "Chrome" && browser !== "AOSP" && browser !== "Opera" && browser !== "Other") {
    return true;
  }
  let errFirefox;
  try {
    throw "a";
  } catch (err) {
    try {
      err.toSource();
      errFirefox = true;
    } catch (errOfErr) {
      errFirefox = false;
    }
  }
  return errFirefox && browser !== "Firefox" && browser !== "Other";
};
const isMobile$1 = (mobile.Android() || mobile.S10() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.isIpad() || mobile.Windows()) && !isBrowserSimulation();
function _toConsumableArray$1(arr2) {
  if (Array.isArray(arr2)) {
    for (var i2 = 0, arr22 = Array(arr2.length); i2 < arr2.length; i2++) {
      arr22[i2] = arr2[i2];
    }
    return arr22;
  } else {
    return Array.from(arr2);
  }
}
var hasPassiveEvents = false;
if (typeof window !== "undefined") {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return void 0;
    }
  };
  window.addEventListener("testPassive", null, passiveTestOptions);
  window.removeEventListener("testPassive", null, passiveTestOptions);
}
var isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPosition = void 0;
var previousBodyPaddingRight = void 0;
var allowTouchMove = function allowTouchMove2(el) {
  return locks.some(function(lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }
    return false;
  });
};
var preventDefault = function preventDefault2(rawEvent) {
  var e2 = rawEvent || window.event;
  if (allowTouchMove(e2.target)) {
    return true;
  }
  if (e2.touches.length > 1)
    return true;
  if (e2.preventDefault)
    e2.preventDefault();
  return false;
};
var setOverflowHidden = function setOverflowHidden2(options) {
  if (previousBodyPaddingRight === void 0) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (_reserveScrollBarGap && scrollBarGap > 0) {
      var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
    }
  }
  if (previousBodyOverflowSetting === void 0) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
};
var restoreOverflowSetting = function restoreOverflowSetting2() {
  if (previousBodyPaddingRight !== void 0) {
    document.body.style.paddingRight = previousBodyPaddingRight;
    previousBodyPaddingRight = void 0;
  }
  if (previousBodyOverflowSetting !== void 0) {
    document.body.style.overflow = previousBodyOverflowSetting;
    previousBodyOverflowSetting = void 0;
  }
};
var setPositionFixed = function setPositionFixed2() {
  return window.requestAnimationFrame(function() {
    if (previousBodyPosition === void 0) {
      previousBodyPosition = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };
      var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
      document.body.style.position = "fixed";
      document.body.style.top = -scrollY;
      document.body.style.left = -scrollX;
      setTimeout(function() {
        return window.requestAnimationFrame(function() {
          var bottomBarHeight = innerHeight - window.innerHeight;
          if (bottomBarHeight && scrollY >= innerHeight) {
            document.body.style.top = -(scrollY + bottomBarHeight);
          }
        });
      }, 300);
    }
  });
};
var restorePositionSetting = function restorePositionSetting2() {
  if (previousBodyPosition !== void 0) {
    var y2 = -parseInt(document.body.style.top, 10);
    var x2 = -parseInt(document.body.style.left, 10);
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;
    window.scrollTo(x2, y2);
    previousBodyPosition = void 0;
  }
};
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled2(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var handleScroll = function handleScroll2(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;
  if (allowTouchMove(event.target)) {
    return false;
  }
  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    return preventDefault(event);
  }
  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    return preventDefault(event);
  }
  event.stopPropagation();
  return true;
};
var disableBodyScroll = function disableBodyScroll2(targetElement, options) {
  if (!targetElement) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (locks.some(function(lock2) {
    return lock2.targetElement === targetElement;
  })) {
    return;
  }
  var lock = {
    targetElement,
    options: options || {}
  };
  locks = [].concat(_toConsumableArray$1(locks), [lock]);
  if (isIosDevice) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }
  if (isIosDevice) {
    targetElement.ontouchstart = function(event) {
      if (event.targetTouches.length === 1) {
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function(event) {
      if (event.targetTouches.length === 1) {
        handleScroll(event, targetElement);
      }
    };
    if (!documentListenerAdded) {
      document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = true;
    }
  }
};
var clearAllBodyScrollLocks = function clearAllBodyScrollLocks2() {
  if (isIosDevice) {
    locks.forEach(function(lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });
    if (documentListenerAdded) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = false;
    }
    initialClientY = -1;
  }
  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
  locks = [];
};
var enableBodyScroll = function enableBodyScroll2(targetElement) {
  if (!targetElement) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  locks = locks.filter(function(lock) {
    return lock.targetElement !== targetElement;
  });
  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;
    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = false;
    }
  }
  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
};
const useEventListener = (eventName, handler, element = window) => {
  const savedHandler = useRef(() => {
  });
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(() => {
    const isSupported = element && element.addEventListener;
    if (!isSupported)
      return;
    const eventListener = (event) => {
      var _a;
      return (_a = savedHandler == null ? void 0 : savedHandler.current) == null ? void 0 : _a.call(savedHandler, event);
    };
    element.addEventListener(eventName, eventListener);
    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
};
function usePermissions() {
  const [permission, setPermission] = useState(false);
  const [prompt2, setPrompt] = useState(false);
  useEffect(() => {
    var _a;
    if (!navigator.permissions) {
      setPrompt(true);
      return;
    }
    (_a = navigator.permissions) == null ? void 0 : _a.query({ name: "camera" }).then(function(result2) {
      if (result2.state === "granted") {
        setPermission(true);
        setPrompt(false);
      }
      if (result2.state === "prompt") {
        setPrompt(true);
      }
    }).catch(() => {
      setPermission(false);
      setPrompt(false);
    });
  }, []);
  return [permission, setPermission, prompt2];
}
function useInterval(callback, delay) {
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id2 = setInterval(tick, delay);
      return () => clearInterval(id2);
    }
  }, [delay]);
}
function resize() {
  const vw2 = window.innerWidth * 0.01;
  const vh2 = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vw", `${vw2}px`);
  document.documentElement.style.setProperty("--vh", `${vh2}px`);
}
const init$1 = () => {
  const body = document.body;
  const html = document.getElementsByTagName("html")[0];
  body.scrollTop = 0;
  resize();
  window.addEventListener("resize", resize);
  if (mobile.any()) {
    document.body.style.position = "fixed";
    disableBodyScroll(html);
  }
};
const unmount = () => {
  const body = document.getElementsByTagName("body")[0];
  const html = document.getElementsByTagName("html")[0];
  clearAllBodyScrollLocks();
  enableBodyScroll(html);
  body.style.removeProperty("position");
  window.removeEventListener("resize", resize);
};
function useOrientation() {
  const screenOrientation = window.innerWidth > window.innerHeight;
  const [isRotated, setIsRotated] = useState(screenOrientation);
  useEffect(() => {
    function handleOrientationChange(ev) {
      setIsRotated(ev.target.orientation !== 0);
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      window.focus();
    }
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);
  useEventListener("resize", () => {
    const MIN_KEYBOARD_HEIGHT = 300;
    const isKeyboardOpen = window.screen.height - MIN_KEYBOARD_HEIGHT > window.visualViewport.height;
    if (isKeyboardOpen) {
      return;
    }
    setIsRotated(window.innerWidth > window.innerHeight);
  }, window);
  return {
    isRotated
  };
}
const handleUnmount = (cb2, element) => (...props) => {
  ReactDOM.unmountComponentAtNode(element);
  unmount();
  cb2(...props);
};
function useSteps(initialState = 0) {
  const [currentStep, setStep] = useState(initialState);
  const nextStep = useCallback(() => {
    setStep((currentStep2) => currentStep2 + 1);
  }, []);
  return {
    currentStep,
    setStep,
    nextStep
  };
}
function useOffline(cb2 = emptyFunc) {
  useEventListener("offline", () => {
    if (navigator.onLine)
      return;
    cb2();
  });
}
const regex = {
  CURP_PATTERN: /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
  EMAIL_PATTERN: /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
  E164_PHONE_NUMBER: /^\+?[1-9]\d{7,14}$/
};
class ScriptLoader {
  constructor(options) {
    const { src: src2, global: global2, protocol = document.location.protocol } = options;
    this.src = src2;
    this.global = global2;
    this.protocol = protocol;
    this.isLoaded = false;
  }
  loadScript() {
    return new Promise((_24, reject) => {
      var _a;
      const script2 = document.createElement("script");
      script2.type = "text/javascript";
      script2.async = true;
      script2.src = this.src;
      const el = document.getElementsByTagName("script")[0];
      (_a = el == null ? void 0 : el.parentNode) == null ? void 0 : _a.insertBefore(script2, el);
      script2.addEventListener("load", () => {
        this.isLoaded = true;
      });
      script2.addEventListener("error", () => {
        reject(new Error(`${this.src} failed to load.`));
      });
    });
  }
  load() {
    return new Promise(async (resolve, reject) => {
      if (!this.isLoaded) {
        try {
          await this.loadScript();
          resolve(window[this.global]);
        } catch (e2) {
          reject(e2);
        }
      } else {
        resolve(window[this.global]);
      }
    });
  }
}
const apiKey = "cg41dUINoxdp8BaHDQLJhA";
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;
instance.use(Backend).use(Browser).use(initReactI18next).init({
  fallbackLng: (code) => {
    return ["dev", code, code && code.split("-")[0]];
  },
  supportedLngs: ["en", "es", "fr", "pt", "bn", "zh", "hi", "id", "ms", "tr", "vi"],
  ns: ["default"],
  detection: {
    lookupQuerystring: "lang"
  },
  defaultNS: "default",
  parseMissingKeyHandler: (key) => {
    const splitKey = key.split(".");
    const missingKey = splitKey[splitKey.length - 1];
    return camelToStartCase(missingKey);
  },
  partialBundledLanguages: true,
  keySeparator: ".",
  interpolation: {
    escapeValue: false
  },
  backend: {
    loadPath
  },
  react: {
    useSuspense: false
  },
  load: "languageOnly"
});
var uaParser = { exports: {} };
(function(module2, exports2) {
  (function(window2, undefined$1) {
    var LIBVERSION = "1.0.2", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION2 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 255;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook";
    var extend2 = function(regexes2, extensions) {
      var mergedRegexes = {};
      for (var i2 in regexes2) {
        if (extensions[i2] && extensions[i2].length % 2 === 0) {
          mergedRegexes[i2] = extensions[i2].concat(regexes2[i2]);
        } else {
          mergedRegexes[i2] = regexes2[i2];
        }
      }
      return mergedRegexes;
    }, enumerize = function(arr2) {
      var enums = {};
      for (var i2 = 0; i2 < arr2.length; i2++) {
        enums[arr2[i2].toUpperCase()] = arr2[i2];
      }
      return enums;
    }, has = function(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
      return str.toLowerCase();
    }, majorize = function(version2) {
      return typeof version2 === STR_TYPE ? version2.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
    }, trim2 = function(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };
    var rgxMapper = function(ua, arrays) {
      var i2 = 0, j2, k3, p2, q2, matches, match;
      while (i2 < arrays.length && !matches) {
        var regex2 = arrays[i2], props = arrays[i2 + 1];
        j2 = k3 = 0;
        while (j2 < regex2.length && !matches) {
          matches = regex2[j2++].exec(ua);
          if (!!matches) {
            for (p2 = 0; p2 < props.length; p2++) {
              match = matches[++k3];
              q2 = props[p2];
              if (typeof q2 === OBJ_TYPE && q2.length > 0) {
                if (q2.length === 2) {
                  if (typeof q2[1] == FUNC_TYPE) {
                    this[q2[0]] = q2[1].call(this, match);
                  } else {
                    this[q2[0]] = q2[1];
                  }
                } else if (q2.length === 3) {
                  if (typeof q2[1] === FUNC_TYPE && !(q2[1].exec && q2[1].test)) {
                    this[q2[0]] = match ? q2[1].call(this, match, q2[2]) : undefined$1;
                  } else {
                    this[q2[0]] = match ? match.replace(q2[1], q2[2]) : undefined$1;
                  }
                } else if (q2.length === 4) {
                  this[q2[0]] = match ? q2[3].call(this, match.replace(q2[1], q2[2])) : undefined$1;
                }
              } else {
                this[q2] = match ? match : undefined$1;
              }
            }
          }
        }
        i2 += 2;
      }
    }, strMapper = function(str, map) {
      for (var i2 in map) {
        if (typeof map[i2] === OBJ_TYPE && map[i2].length > 0) {
          for (var j2 = 0; j2 < map[i2].length; j2++) {
            if (has(map[i2][j2], str)) {
              return i2 === UNKNOWN ? undefined$1 : i2;
            }
          }
        } else if (has(map[i2], str)) {
          return i2 === UNKNOWN ? undefined$1 : i2;
        }
      }
      return str;
    };
    var oldSafariMap = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, windowsVersionMap = {
      "ME": "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      "2000": "NT 5.0",
      "XP": ["NT 5.1", "NT 5.2"],
      "Vista": "NT 6.0",
      "7": "NT 6.1",
      "8": "NT 6.2",
      "8.1": "NT 6.3",
      "10": ["NT 6.4", "NT 10.0"],
      "RT": "ARM"
    };
    var regexes = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /opios[\/ ]+([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        ],
        [VERSION2, [NAME, "UC" + BROWSER]],
        [
          /\bqbcore\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        ],
        [VERSION2, [NAME, "IE"]],
        [
          /yabrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION2],
        [
          /\bfocus\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "MIUI " + BROWSER]],
        [
          /fxios\/([-\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
        ],
        [[NAME, "360 " + BROWSER]],
        [
          /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 " + BROWSER], VERSION2],
        [
          /(comodo_dragon)\/([\w\.]+)/i
        ],
        [[NAME, /_/g, " "], VERSION2],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          /(lbbrowser)/i
        ],
        [NAME],
        [
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        ],
        [[NAME, FACEBOOK], VERSION2],
        [
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
        ],
        [VERSION2, [NAME, "GSA"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
        ],
        [VERSION2, [NAME, CHROME + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
        ],
        [[NAME, CHROME + " WebView"], VERSION2],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        ],
        [VERSION2, [NAME, "Android " + BROWSER]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
        ],
        [VERSION2, [NAME, "Mobile Safari"]],
        [
          /version\/([\w\.]+) .*(mobile ?safari|safari)/i
        ],
        [VERSION2, NAME],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        ],
        [NAME, [VERSION2, strMapper, oldSafariMap]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(navigator|netscape\d?)\/([-\w\.]+)/i
        ],
        [[NAME, "Netscape"], VERSION2],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
        ],
        [VERSION2, [NAME, FIREFOX + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /(links) \(([\w\.]+)/i
        ],
        [NAME, VERSION2]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i
        ],
        [[ARCHITECTURE, lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
        ],
        [[ARCHITECTURE, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
        ],
        [[ARCHITECTURE, "armhf"]],
        [
          /windows (ce|mobile); ppc;/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
        ],
        [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
        [
          /(sun4\w)[;\)]/i
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [[ARCHITECTURE, lowerize]]
      ],
      device: [
        [
          /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
        [
          /\((ip(?:hone|od)[\w ]*);/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
        [
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
        [
          /\b(poco[\w ]+)(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
        [
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
        [
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
        [
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, TABLET]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
        [
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]],
        [
          /(pixel c)\b/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
        [
          /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
        [
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
        [
          /(alexa)webm/i,
          /(kf[a-z]{2}wi)( bui|\))/i,
          /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        ],
        [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
        [
          /(playbook);[-\w\),; ]+(rim)/i
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
        ],
        [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
        [
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
        [
          /(nexus 9)/i
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [MODEL, [VENDOR, "Sharp"], [TYPE, MOBILE]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          /(hp) ([\w ]+\w)/i,
          /(asus)-?(\w+)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w]+)/i,
          /(jolla)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(archos) (gamepad2?)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(surface duo)/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
        [
          /(u304aa)/i
        ],
        [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
        [
          /\bsie-(\w*)/i
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /\b(rct\w+) b/i
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /\b(venue[\d ]{2,7}) b/i
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /\b(q(?:mv|ta)\w+) b/i
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        ],
        [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /\b(k88) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /\b(nx\d{3}j) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
        [
          /\b(gen\d{3}) b.+49h/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /\b(zur\d{3}) b/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /\b((zeki)?tb.*\b) b/i
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /\b(ns-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /\b(ph-1) /i
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /\b(trio[-\w\. ]+) b/i
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /\btu_(1491) b/i
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          /(shield[\w ]+) b/i
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
        [
          /(sprint) (\w+)/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kin\.[onetw]{3})/i
        ],
        [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
        [
          /(ouya)/i,
          /(nintendo) ([wids3utch]+)/i
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /droid.+; (shield) bui/i
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
        [
          /(playstation [345portablevi]+)/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
        [
          /smart-tv.+(samsung)/i
        ],
        [VENDOR, [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        ],
        [[VENDOR, LG], [TYPE, SMARTTV]],
        [
          /(apple) ?tv/i
        ],
        [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
        [
          /crkey/i
        ],
        [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
        [
          /droid.+aft(\w)( bui|\))/i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i
        ],
        [MODEL, [VENDOR, "Sharp"], [TYPE, SMARTTV]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
        ],
        [[VENDOR, trim2], [MODEL, trim2], [TYPE, SMARTTV]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[TYPE, SMARTTV]],
        [
          /((pebble))app/i
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /droid.+; (glass) \d/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
        [
          /(quest( 2)?)/i
        ],
        [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
        [
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        ],
        [VENDOR, [TYPE, EMBEDDED]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        ],
        [[TYPE, TABLET]],
        [
          /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
        ],
        [[TYPE, MOBILE]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, EDGE + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
        ],
        [VERSION2, NAME]
      ],
      os: [
        [
          /microsoft (windows) (vista|xp)/i
        ],
        [NAME, VERSION2],
        [
          /(windows) nt 6\.2; (arm)/i,
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [NAME, [VERSION2, strMapper, windowsVersionMap]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[NAME, "Windows"], [VERSION2, strMapper, windowsVersionMap]],
        [
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[VERSION2, /_/g, "."], [NAME, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        ],
        [[NAME, "Mac OS"], [VERSION2, /_/g, "."]],
        [
          /droid ([\w\.]+)\b.+(android[- ]x86)/i
        ],
        [VERSION2, NAME],
        [
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          /\((series40);/i
        ],
        [NAME, VERSION2],
        [
          /\(bb(10);/i
        ],
        [VERSION2, [NAME, BLACKBERRY]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
        ],
        [VERSION2, [NAME, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "webOS"]],
        [
          /crkey\/([\d\.]+)/i
        ],
        [VERSION2, [NAME, CHROME + "cast"]],
        [
          /(cros) [\w]+ ([\w\.]+\w)/i
        ],
        [[NAME, "Chromium OS"], VERSION2],
        [
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux) ?([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [NAME, VERSION2],
        [
          /(sunos) ?([\w\.\d]*)/i
        ],
        [[NAME, "Solaris"], VERSION2],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [NAME, VERSION2]
      ]
    };
    var UAParser2 = function(ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser2)) {
        return new UAParser2(ua, extensions).getResult();
      }
      var _ua = ua || (typeof window2 !== UNDEF_TYPE && window2.navigator && window2.navigator.userAgent ? window2.navigator.userAgent : EMPTY);
      var _rgxmap = extensions ? extend2(regexes, extensions) : regexes;
      this.getBrowser = function() {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION2] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser.major = majorize(_browser.version);
        return _browser;
      };
      this.getCPU = function() {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function() {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        return _device;
      };
      this.getEngine = function() {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION2] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function() {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION2] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        return _os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return _ua;
      };
      this.setUA = function(ua2) {
        _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim2(ua2, UA_MAX_LENGTH) : ua2;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser2.VERSION = LIBVERSION;
    UAParser2.BROWSER = enumerize([NAME, VERSION2, MAJOR]);
    UAParser2.CPU = enumerize([ARCHITECTURE]);
    UAParser2.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser2.ENGINE = UAParser2.OS = enumerize([NAME, VERSION2]);
    {
      if (module2.exports) {
        exports2 = module2.exports = UAParser2;
      }
      exports2.UAParser = UAParser2;
    }
    var $2 = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
    if ($2 && !$2.ua) {
      var parser = new UAParser2();
      $2.ua = parser.getResult();
      $2.ua.get = function() {
        return parser.getUA();
      };
      $2.ua.set = function(ua) {
        parser.setUA(ua);
        var result2 = parser.getResult();
        for (var prop in result2) {
          $2.ua[prop] = result2[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var UAParser = uaParser.exports;
let api;
function setApi(apiInstance) {
  api = apiInstance;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$3(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function r$1(e2) {
  for (var t2 = "", r2 = 0; r2 < e2.length; ++r2)
    if (r2 > 0) {
      var n2 = e2[r2].toLowerCase();
      n2 !== e2[r2] ? t2 += " " + n2 : t2 += e2[r2];
    } else
      t2 += e2[r2].toUpperCase();
  return t2;
}
var a$1 = r$1("WrongRegion"), d$1 = r$1("SubscriptionNotActive"), s = r$1("UnsupportedVersion"), u = r$1("InstallationMethodRestricted");
function y$1(e2, t2, r2) {
  return r2 === void 0 && (r2 = 0), t2(r2).catch(function(n2) {
    if (r2 >= e2.maxRetries)
      throw n2;
    var o, i2, R, a6, d2 = (o = e2.baseDelay, i2 = e2.maxDelay, R = e2.baseDelay * Math.pow(2, r2), Math.max(o, Math.min(i2, R)));
    return (a6 = d2, new Promise(function(e3) {
      return setTimeout(e3, a6);
    })).then(function() {
      return y$1(e2, t2, r2 + 1);
    });
  });
}
var P$1 = "Failed to load the JS script of the agent", h$2 = "https://fpnpmcdn.net/v<version>/<apiKey>/loader_v<loaderVersion>.js";
function m$2(r2) {
  var n2 = r2.scriptUrlPattern, o = r2.token, i2 = r2.apiKey, R = i2 === void 0 ? o : i2, a6 = __rest$3(r2, ["scriptUrlPattern", "token", "apiKey"]), d2 = [];
  return Promise.resolve().then(function() {
    if (!R || typeof R != "string")
      throw new Error("API key required");
    return y$1({ maxRetries: 5, baseDelay: 100, maxDelay: 3e3 }, function() {
      var e2, t2 = new Date(), r3 = function() {
        return d2.push({ startedAt: t2, finishedAt: new Date() });
      }, o2 = (e2 = function(e3, t3) {
        t3 === void 0 && (t3 = h$2);
        var r4 = encodeURIComponent;
        return t3.replace(/<[^<>]+>/g, function(t4) {
          return t4 === "<version>" ? "3" : t4 === "<apiKey>" ? r4(e3) : t4 === "<loaderVersion>" ? r4("3.6.1") : t4;
        });
      }(R, n2), new Promise(function(t3, r4) {
        var n3 = document.createElement("script"), o3 = function() {
          var e3;
          return (e3 = n3.parentNode) === null || e3 === void 0 ? void 0 : e3.removeChild(n3);
        }, i3 = document.head || document.getElementsByTagName("head")[0];
        n3.onload = function() {
          o3(), t3();
        }, n3.onerror = function() {
          o3(), r4(new Error(P$1));
        }, n3.async = true, n3.src = e2, i3.appendChild(n3);
      }));
      return o2.then(r3, r3), o2;
    });
  }).then(function() {
    var e2 = window, r3 = "__fpjs_p_l_b", n3 = e2[r3];
    if (function(e3, t2) {
      var r4, n4 = (r4 = Object.getOwnPropertyDescriptor) === null || r4 === void 0 ? void 0 : r4.call(Object, e3, t2);
      (n4 == null ? void 0 : n4.configurable) ? delete e3[t2] : n4 && !n4.writable || (e3[t2] = void 0);
    }(e2, r3), typeof (n3 == null ? void 0 : n3.load) != "function")
      throw new Error(P$1);
    return n3.load(__assign$1(__assign$1({}, a6), { ldi: { attempts: d2 } }));
  });
}
var D = { load: m$2, ERROR_SCRIPT_LOAD_FAIL: P$1, ERROR_API_KEY_EXPIRED: "API key expired", ERROR_API_KEY_INVALID: "API key not found", ERROR_API_KEY_MISSING: "API key required", ERROR_BAD_REQUEST_FORMAT: "Request cannot be parsed", ERROR_BAD_RESPONSE_FORMAT: "Response cannot be parsed", ERROR_CLIENT_TIMEOUT: "Client timeout", ERROR_FORBIDDEN_HEADER: "Not available with restricted header", ERROR_FORBIDDEN_ORIGIN: "Not available for this origin", ERROR_GENERAL_SERVER_FAILURE: "Request failed", ERROR_INSTALLATION_METHOD_RESTRICTED: u, ERROR_NETWORK_ABORT: "Network request aborted", ERROR_NETWORK_CONNECTION: "Network connection error", ERROR_RATE_LIMIT: "Too many requests, rate limit exceeded", ERROR_SERVER_TIMEOUT: "Request failed to process", ERROR_SUBSCRIPTION_NOT_ACTIVE: d$1, ERROR_TOKEN_EXPIRED: "API key expired", ERROR_TOKEN_INVALID: "API key not found", ERROR_TOKEN_MISSING: "API key required", ERROR_UNSUPPORTED_VERSION: s, ERROR_WRONG_REGION: a$1 };
var FingerprintJS = D;
const fingerPrintUrl = "/omni/add/device-fingerprint";
function postFingerprint({
  hash,
  ip,
  deviceType,
  token,
  data: data2,
  osVersion,
  deviceModel,
  browser,
  sdkVersion
}) {
  return api.post(fingerPrintUrl, {
    hash,
    ip,
    deviceType,
    data: data2,
    osVersion,
    deviceModel,
    browser,
    sdkVersion
  }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
const createSardineContext = (interviewId) => {
  const clientId = {}.VITE_SARDINE_CLIENT_ID;
  if (!clientId) {
    return;
  }
  return window._Sardine.createContext({
    clientId,
    sessionKey: interviewId,
    userIdHash: interviewId,
    flow: location.pathname,
    environment: "sandbox",
    parentElement: document.body,
    onDeviceResponse(data2) {
      console.log(data2);
      console.log(`sardine's deviceID is ${data2.deviceId}`);
    }
  });
};
function formatDeviceModel({ vendor, model: model2 }) {
  return `${vendor || ""} ${model2 || ""}`.trim();
}
const fingerPrintToken = "5uYRiI0XM6p8k4124ELX";
async function sendFingerprint({
  token,
  sdkVersion = null,
  interviewId
}, sendIP = true, sendDeviceFingerprint = true) {
  createSardineContext(interviewId);
  const ip = sendIP ? await fetch("https://api.ipify.org").then((response) => response.text()) : "";
  const deviceType = "WEBAPP";
  const parser = new UAParser();
  const { os, device, browser } = parser.getResult();
  const fingerPrint = sendDeviceFingerprint ? await FingerprintJS.load({
    token: fingerPrintToken,
    endpoint: "https://fingerprint.incodesmile.com"
  }).then((fp2) => fp2.get()) : { visitorId: void 0 };
  return postFingerprint({
    hash: fingerPrint.visitorId || "",
    ip,
    deviceType,
    token,
    data: JSON.stringify(fingerPrint),
    osVersion: `${os.name} ${os.version}`,
    deviceModel: formatDeviceModel(device),
    browser: `${browser.name} ${browser.version}`,
    sdkVersion: sdkVersion || "1.50.0"
  });
}
const eventsQueue = [];
function addEvent(event) {
  const { token, eventName, eventData, eventType } = event;
  if (!token) {
    eventsQueue.push(event);
    return;
  }
  return api.post("/omni/add/event", {
    eventName,
    eventData,
    eventType
  }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch(() => {
  });
}
function emptyQueue(token) {
  eventsQueue.forEach((event) => {
    addEvent(__spreadProps(__spreadValues({}, event), { token }));
  });
}
const state = {
  detecting: true,
  intervalCounter: 0,
  matchCounter: 0,
  intervalId: null,
  cascadeLoaded: false,
  selfieAttempt: 0,
  selfieGetFrames: 0,
  grabSelfieFrames: false,
  frames: [],
  facefinderClassifyRegion: () => {
    return -1;
  }
};
function mapI18nLang(lang) {
  if (lang.startsWith("en")) {
    return "en-US";
  }
  if (lang.startsWith("es")) {
    return "es-ES";
  }
  return "en-US";
}
const createSessionUrl = "/omni/start";
function createSession$4(countryCode, externalId, {
  configurationId,
  uuid: uuid2,
  interviewId,
  customFields,
  language: _language,
  sdkVersion
} = {}) {
  const language = _language ? _language : mapI18nLang(instance.language);
  return api.post(createSessionUrl, {
    countryCode,
    externalId,
    configurationId,
    uuid: uuid2,
    interviewId,
    customFields,
    language
  }).then((response) => {
    state.token = response.data;
    return response.data;
  }).then((session) => {
    emptyQueue(session.token);
    sendFingerprint({
      token: session.token,
      interviewId: session.interviewId,
      sdkVersion
    }).catch(emptyFunc);
    const parser = new UAParser();
    const result2 = parser.getResult();
    addEvent({
      eventName: "browser",
      eventType: "text",
      eventData: __spreadValues({
        userAgent: window.navigator.userAgent,
        isWebRtcSupported: isWebRtcSupported()
      }, result2),
      token: session.token
    });
    return session;
  }).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
const updateSessionUrl = "/omni/update";
function updateSession({ token, key, value, onProgress = emptyFunc }) {
  return api.put(updateSessionUrl, { [key]: value }, {
    headers: {
      "X-Incode-Hardware-Id": token
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
  });
}
/*! For license information please see bundle.js.LICENSE.txt */
(() => {
  var e2 = { 5766: (e3, t3) => {
    t3.byteLength = function(e4) {
      var t4 = u2(e4), r4 = t4[0], n4 = t4[1];
      return 3 * (r4 + n4) / 4 - n4;
    }, t3.toByteArray = function(e4) {
      var t4, r4, a7 = u2(e4), s3 = a7[0], o2 = a7[1], c3 = new i2(function(e5, t5, r5) {
        return 3 * (t5 + r5) / 4 - r5;
      }(0, s3, o2)), l2 = 0, h2 = o2 > 0 ? s3 - 4 : s3;
      for (r4 = 0; r4 < h2; r4 += 4)
        t4 = n3[e4.charCodeAt(r4)] << 18 | n3[e4.charCodeAt(r4 + 1)] << 12 | n3[e4.charCodeAt(r4 + 2)] << 6 | n3[e4.charCodeAt(r4 + 3)], c3[l2++] = t4 >> 16 & 255, c3[l2++] = t4 >> 8 & 255, c3[l2++] = 255 & t4;
      return o2 === 2 && (t4 = n3[e4.charCodeAt(r4)] << 2 | n3[e4.charCodeAt(r4 + 1)] >> 4, c3[l2++] = 255 & t4), o2 === 1 && (t4 = n3[e4.charCodeAt(r4)] << 10 | n3[e4.charCodeAt(r4 + 1)] << 4 | n3[e4.charCodeAt(r4 + 2)] >> 2, c3[l2++] = t4 >> 8 & 255, c3[l2++] = 255 & t4), c3;
    }, t3.fromByteArray = function(e4) {
      for (var t4, n4 = e4.length, i3 = n4 % 3, a7 = [], s3 = 16383, o2 = 0, u3 = n4 - i3; o2 < u3; o2 += s3)
        a7.push(c2(e4, o2, o2 + s3 > u3 ? u3 : o2 + s3));
      return i3 === 1 ? (t4 = e4[n4 - 1], a7.push(r3[t4 >> 2] + r3[t4 << 4 & 63] + "==")) : i3 === 2 && (t4 = (e4[n4 - 2] << 8) + e4[n4 - 1], a7.push(r3[t4 >> 10] + r3[t4 >> 4 & 63] + r3[t4 << 2 & 63] + "=")), a7.join("");
    };
    for (var r3 = [], n3 = [], i2 = typeof Uint8Array != "undefined" ? Uint8Array : Array, a6 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s2 = 0, o = a6.length; s2 < o; ++s2)
      r3[s2] = a6[s2], n3[a6.charCodeAt(s2)] = s2;
    function u2(e4) {
      var t4 = e4.length;
      if (t4 % 4 > 0)
        throw new Error("Invalid string. Length must be a multiple of 4");
      var r4 = e4.indexOf("=");
      return r4 === -1 && (r4 = t4), [r4, r4 === t4 ? 0 : 4 - r4 % 4];
    }
    function c2(e4, t4, n4) {
      for (var i3, a7, s3 = [], o2 = t4; o2 < n4; o2 += 3)
        i3 = (e4[o2] << 16 & 16711680) + (e4[o2 + 1] << 8 & 65280) + (255 & e4[o2 + 2]), s3.push(r3[(a7 = i3) >> 18 & 63] + r3[a7 >> 12 & 63] + r3[a7 >> 6 & 63] + r3[63 & a7]);
      return s3.join("");
    }
    n3["-".charCodeAt(0)] = 62, n3["_".charCodeAt(0)] = 63;
  }, 8834: (e3, t3, r3) => {
    var n3 = r3(5766), i2 = r3(2333), a6 = r3(7906);
    function s2() {
      return u2.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function o(e4, t4) {
      if (s2() < t4)
        throw new RangeError("Invalid typed array length");
      return u2.TYPED_ARRAY_SUPPORT ? (e4 = new Uint8Array(t4)).__proto__ = u2.prototype : (e4 === null && (e4 = new u2(t4)), e4.length = t4), e4;
    }
    function u2(e4, t4, r4) {
      if (!(u2.TYPED_ARRAY_SUPPORT || this instanceof u2))
        return new u2(e4, t4, r4);
      if (typeof e4 == "number") {
        if (typeof t4 == "string")
          throw new Error("If encoding is specified then the first argument must be a string");
        return h2(this, e4);
      }
      return c2(this, e4, t4, r4);
    }
    function c2(e4, t4, r4, n4) {
      if (typeof t4 == "number")
        throw new TypeError('"value" argument must not be a number');
      return typeof ArrayBuffer != "undefined" && t4 instanceof ArrayBuffer ? function(e5, t5, r5, n5) {
        if (t5.byteLength, r5 < 0 || t5.byteLength < r5)
          throw new RangeError("'offset' is out of bounds");
        if (t5.byteLength < r5 + (n5 || 0))
          throw new RangeError("'length' is out of bounds");
        return t5 = r5 === void 0 && n5 === void 0 ? new Uint8Array(t5) : n5 === void 0 ? new Uint8Array(t5, r5) : new Uint8Array(t5, r5, n5), u2.TYPED_ARRAY_SUPPORT ? (e5 = t5).__proto__ = u2.prototype : e5 = f2(e5, t5), e5;
      }(e4, t4, r4, n4) : typeof t4 == "string" ? function(e5, t5, r5) {
        if (typeof r5 == "string" && r5 !== "" || (r5 = "utf8"), !u2.isEncoding(r5))
          throw new TypeError('"encoding" must be a valid string encoding');
        var n5 = 0 | d2(t5, r5), i3 = (e5 = o(e5, n5)).write(t5, r5);
        return i3 !== n5 && (e5 = e5.slice(0, i3)), e5;
      }(e4, t4, r4) : function(e5, t5) {
        if (u2.isBuffer(t5)) {
          var r5 = 0 | p2(t5.length);
          return (e5 = o(e5, r5)).length === 0 || t5.copy(e5, 0, 0, r5), e5;
        }
        if (t5) {
          if (typeof ArrayBuffer != "undefined" && t5.buffer instanceof ArrayBuffer || "length" in t5)
            return typeof t5.length != "number" || (n5 = t5.length) != n5 ? o(e5, 0) : f2(e5, t5);
          if (t5.type === "Buffer" && a6(t5.data))
            return f2(e5, t5.data);
        }
        var n5;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(e4, t4);
    }
    function l2(e4) {
      if (typeof e4 != "number")
        throw new TypeError('"size" argument must be a number');
      if (e4 < 0)
        throw new RangeError('"size" argument must not be negative');
    }
    function h2(e4, t4) {
      if (l2(t4), e4 = o(e4, t4 < 0 ? 0 : 0 | p2(t4)), !u2.TYPED_ARRAY_SUPPORT)
        for (var r4 = 0; r4 < t4; ++r4)
          e4[r4] = 0;
      return e4;
    }
    function f2(e4, t4) {
      var r4 = t4.length < 0 ? 0 : 0 | p2(t4.length);
      e4 = o(e4, r4);
      for (var n4 = 0; n4 < r4; n4 += 1)
        e4[n4] = 255 & t4[n4];
      return e4;
    }
    function p2(e4) {
      if (e4 >= s2())
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s2().toString(16) + " bytes");
      return 0 | e4;
    }
    function d2(e4, t4) {
      if (u2.isBuffer(e4))
        return e4.length;
      if (typeof ArrayBuffer != "undefined" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e4) || e4 instanceof ArrayBuffer))
        return e4.byteLength;
      typeof e4 != "string" && (e4 = "" + e4);
      var r4 = e4.length;
      if (r4 === 0)
        return 0;
      for (var n4 = false; ; )
        switch (t4) {
          case "ascii":
          case "latin1":
          case "binary":
            return r4;
          case "utf8":
          case "utf-8":
          case void 0:
            return K2(e4).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * r4;
          case "hex":
            return r4 >>> 1;
          case "base64":
            return j2(e4).length;
          default:
            if (n4)
              return K2(e4).length;
            t4 = ("" + t4).toLowerCase(), n4 = true;
        }
    }
    function g2(e4, t4, r4) {
      var n4 = false;
      if ((t4 === void 0 || t4 < 0) && (t4 = 0), t4 > this.length)
        return "";
      if ((r4 === void 0 || r4 > this.length) && (r4 = this.length), r4 <= 0)
        return "";
      if ((r4 >>>= 0) <= (t4 >>>= 0))
        return "";
      for (e4 || (e4 = "utf8"); ; )
        switch (e4) {
          case "hex":
            return N2(this, t4, r4);
          case "utf8":
          case "utf-8":
            return A2(this, t4, r4);
          case "ascii":
            return w2(this, t4, r4);
          case "latin1":
          case "binary":
            return R(this, t4, r4);
          case "base64":
            return I2(this, t4, r4);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return L2(this, t4, r4);
          default:
            if (n4)
              throw new TypeError("Unknown encoding: " + e4);
            e4 = (e4 + "").toLowerCase(), n4 = true;
        }
    }
    function y2(e4, t4, r4) {
      var n4 = e4[t4];
      e4[t4] = e4[r4], e4[r4] = n4;
    }
    function v2(e4, t4, r4, n4, i3) {
      if (e4.length === 0)
        return -1;
      if (typeof r4 == "string" ? (n4 = r4, r4 = 0) : r4 > 2147483647 ? r4 = 2147483647 : r4 < -2147483648 && (r4 = -2147483648), r4 = +r4, isNaN(r4) && (r4 = i3 ? 0 : e4.length - 1), r4 < 0 && (r4 = e4.length + r4), r4 >= e4.length) {
        if (i3)
          return -1;
        r4 = e4.length - 1;
      } else if (r4 < 0) {
        if (!i3)
          return -1;
        r4 = 0;
      }
      if (typeof t4 == "string" && (t4 = u2.from(t4, n4)), u2.isBuffer(t4))
        return t4.length === 0 ? -1 : m2(e4, t4, r4, n4, i3);
      if (typeof t4 == "number")
        return t4 &= 255, u2.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i3 ? Uint8Array.prototype.indexOf.call(e4, t4, r4) : Uint8Array.prototype.lastIndexOf.call(e4, t4, r4) : m2(e4, [t4], r4, n4, i3);
      throw new TypeError("val must be string, number or Buffer");
    }
    function m2(e4, t4, r4, n4, i3) {
      var a7, s3 = 1, o2 = e4.length, u3 = t4.length;
      if (n4 !== void 0 && ((n4 = String(n4).toLowerCase()) === "ucs2" || n4 === "ucs-2" || n4 === "utf16le" || n4 === "utf-16le")) {
        if (e4.length < 2 || t4.length < 2)
          return -1;
        s3 = 2, o2 /= 2, u3 /= 2, r4 /= 2;
      }
      function c3(e5, t5) {
        return s3 === 1 ? e5[t5] : e5.readUInt16BE(t5 * s3);
      }
      if (i3) {
        var l3 = -1;
        for (a7 = r4; a7 < o2; a7++)
          if (c3(e4, a7) === c3(t4, l3 === -1 ? 0 : a7 - l3)) {
            if (l3 === -1 && (l3 = a7), a7 - l3 + 1 === u3)
              return l3 * s3;
          } else
            l3 !== -1 && (a7 -= a7 - l3), l3 = -1;
      } else
        for (r4 + u3 > o2 && (r4 = o2 - u3), a7 = r4; a7 >= 0; a7--) {
          for (var h3 = true, f3 = 0; f3 < u3; f3++)
            if (c3(e4, a7 + f3) !== c3(t4, f3)) {
              h3 = false;
              break;
            }
          if (h3)
            return a7;
        }
      return -1;
    }
    function E2(e4, t4, r4, n4) {
      r4 = Number(r4) || 0;
      var i3 = e4.length - r4;
      n4 ? (n4 = Number(n4)) > i3 && (n4 = i3) : n4 = i3;
      var a7 = t4.length;
      if (a7 % 2 != 0)
        throw new TypeError("Invalid hex string");
      n4 > a7 / 2 && (n4 = a7 / 2);
      for (var s3 = 0; s3 < n4; ++s3) {
        var o2 = parseInt(t4.substr(2 * s3, 2), 16);
        if (isNaN(o2))
          return s3;
        e4[r4 + s3] = o2;
      }
      return s3;
    }
    function C(e4, t4, r4, n4) {
      return F2(K2(t4, e4.length - r4), e4, r4, n4);
    }
    function S2(e4, t4, r4, n4) {
      return F2(function(e5) {
        for (var t5 = [], r5 = 0; r5 < e5.length; ++r5)
          t5.push(255 & e5.charCodeAt(r5));
        return t5;
      }(t4), e4, r4, n4);
    }
    function b2(e4, t4, r4, n4) {
      return S2(e4, t4, r4, n4);
    }
    function T2(e4, t4, r4, n4) {
      return F2(j2(t4), e4, r4, n4);
    }
    function _24(e4, t4, r4, n4) {
      return F2(function(e5, t5) {
        for (var r5, n5, i3, a7 = [], s3 = 0; s3 < e5.length && !((t5 -= 2) < 0); ++s3)
          n5 = (r5 = e5.charCodeAt(s3)) >> 8, i3 = r5 % 256, a7.push(i3), a7.push(n5);
        return a7;
      }(t4, e4.length - r4), e4, r4, n4);
    }
    function I2(e4, t4, r4) {
      return t4 === 0 && r4 === e4.length ? n3.fromByteArray(e4) : n3.fromByteArray(e4.slice(t4, r4));
    }
    function A2(e4, t4, r4) {
      r4 = Math.min(e4.length, r4);
      for (var n4 = [], i3 = t4; i3 < r4; ) {
        var a7, s3, o2, u3, c3 = e4[i3], l3 = null, h3 = c3 > 239 ? 4 : c3 > 223 ? 3 : c3 > 191 ? 2 : 1;
        if (i3 + h3 <= r4)
          switch (h3) {
            case 1:
              c3 < 128 && (l3 = c3);
              break;
            case 2:
              (192 & (a7 = e4[i3 + 1])) == 128 && (u3 = (31 & c3) << 6 | 63 & a7) > 127 && (l3 = u3);
              break;
            case 3:
              a7 = e4[i3 + 1], s3 = e4[i3 + 2], (192 & a7) == 128 && (192 & s3) == 128 && (u3 = (15 & c3) << 12 | (63 & a7) << 6 | 63 & s3) > 2047 && (u3 < 55296 || u3 > 57343) && (l3 = u3);
              break;
            case 4:
              a7 = e4[i3 + 1], s3 = e4[i3 + 2], o2 = e4[i3 + 3], (192 & a7) == 128 && (192 & s3) == 128 && (192 & o2) == 128 && (u3 = (15 & c3) << 18 | (63 & a7) << 12 | (63 & s3) << 6 | 63 & o2) > 65535 && u3 < 1114112 && (l3 = u3);
          }
        l3 === null ? (l3 = 65533, h3 = 1) : l3 > 65535 && (l3 -= 65536, n4.push(l3 >>> 10 & 1023 | 55296), l3 = 56320 | 1023 & l3), n4.push(l3), i3 += h3;
      }
      return function(e5) {
        var t5 = e5.length;
        if (t5 <= B2)
          return String.fromCharCode.apply(String, e5);
        for (var r5 = "", n5 = 0; n5 < t5; )
          r5 += String.fromCharCode.apply(String, e5.slice(n5, n5 += B2));
        return r5;
      }(n4);
    }
    t3.Buffer = u2, t3.SlowBuffer = function(e4) {
      return +e4 != e4 && (e4 = 0), u2.alloc(+e4);
    }, t3.INSPECT_MAX_BYTES = 50, u2.TYPED_ARRAY_SUPPORT = r3.g.TYPED_ARRAY_SUPPORT !== void 0 ? r3.g.TYPED_ARRAY_SUPPORT : function() {
      try {
        var e4 = new Uint8Array(1);
        return e4.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
          return 42;
        } }, e4.foo() === 42 && typeof e4.subarray == "function" && e4.subarray(1, 1).byteLength === 0;
      } catch (e5) {
        return false;
      }
    }(), t3.kMaxLength = s2(), u2.poolSize = 8192, u2._augment = function(e4) {
      return e4.__proto__ = u2.prototype, e4;
    }, u2.from = function(e4, t4, r4) {
      return c2(null, e4, t4, r4);
    }, u2.TYPED_ARRAY_SUPPORT && (u2.prototype.__proto__ = Uint8Array.prototype, u2.__proto__ = Uint8Array, typeof Symbol != "undefined" && Symbol.species && u2[Symbol.species] === u2 && Object.defineProperty(u2, Symbol.species, { value: null, configurable: true })), u2.alloc = function(e4, t4, r4) {
      return function(e5, t5, r5, n4) {
        return l2(t5), t5 <= 0 ? o(e5, t5) : r5 !== void 0 ? typeof n4 == "string" ? o(e5, t5).fill(r5, n4) : o(e5, t5).fill(r5) : o(e5, t5);
      }(null, e4, t4, r4);
    }, u2.allocUnsafe = function(e4) {
      return h2(null, e4);
    }, u2.allocUnsafeSlow = function(e4) {
      return h2(null, e4);
    }, u2.isBuffer = function(e4) {
      return !(e4 == null || !e4._isBuffer);
    }, u2.compare = function(e4, t4) {
      if (!u2.isBuffer(e4) || !u2.isBuffer(t4))
        throw new TypeError("Arguments must be Buffers");
      if (e4 === t4)
        return 0;
      for (var r4 = e4.length, n4 = t4.length, i3 = 0, a7 = Math.min(r4, n4); i3 < a7; ++i3)
        if (e4[i3] !== t4[i3]) {
          r4 = e4[i3], n4 = t4[i3];
          break;
        }
      return r4 < n4 ? -1 : n4 < r4 ? 1 : 0;
    }, u2.isEncoding = function(e4) {
      switch (String(e4).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    }, u2.concat = function(e4, t4) {
      if (!a6(e4))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (e4.length === 0)
        return u2.alloc(0);
      var r4;
      if (t4 === void 0)
        for (t4 = 0, r4 = 0; r4 < e4.length; ++r4)
          t4 += e4[r4].length;
      var n4 = u2.allocUnsafe(t4), i3 = 0;
      for (r4 = 0; r4 < e4.length; ++r4) {
        var s3 = e4[r4];
        if (!u2.isBuffer(s3))
          throw new TypeError('"list" argument must be an Array of Buffers');
        s3.copy(n4, i3), i3 += s3.length;
      }
      return n4;
    }, u2.byteLength = d2, u2.prototype._isBuffer = true, u2.prototype.swap16 = function() {
      var e4 = this.length;
      if (e4 % 2 != 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var t4 = 0; t4 < e4; t4 += 2)
        y2(this, t4, t4 + 1);
      return this;
    }, u2.prototype.swap32 = function() {
      var e4 = this.length;
      if (e4 % 4 != 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var t4 = 0; t4 < e4; t4 += 4)
        y2(this, t4, t4 + 3), y2(this, t4 + 1, t4 + 2);
      return this;
    }, u2.prototype.swap64 = function() {
      var e4 = this.length;
      if (e4 % 8 != 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var t4 = 0; t4 < e4; t4 += 8)
        y2(this, t4, t4 + 7), y2(this, t4 + 1, t4 + 6), y2(this, t4 + 2, t4 + 5), y2(this, t4 + 3, t4 + 4);
      return this;
    }, u2.prototype.toString = function() {
      var e4 = 0 | this.length;
      return e4 === 0 ? "" : arguments.length === 0 ? A2(this, 0, e4) : g2.apply(this, arguments);
    }, u2.prototype.equals = function(e4) {
      if (!u2.isBuffer(e4))
        throw new TypeError("Argument must be a Buffer");
      return this === e4 || u2.compare(this, e4) === 0;
    }, u2.prototype.inspect = function() {
      var e4 = "", r4 = t3.INSPECT_MAX_BYTES;
      return this.length > 0 && (e4 = this.toString("hex", 0, r4).match(/.{2}/g).join(" "), this.length > r4 && (e4 += " ... ")), "<Buffer " + e4 + ">";
    }, u2.prototype.compare = function(e4, t4, r4, n4, i3) {
      if (!u2.isBuffer(e4))
        throw new TypeError("Argument must be a Buffer");
      if (t4 === void 0 && (t4 = 0), r4 === void 0 && (r4 = e4 ? e4.length : 0), n4 === void 0 && (n4 = 0), i3 === void 0 && (i3 = this.length), t4 < 0 || r4 > e4.length || n4 < 0 || i3 > this.length)
        throw new RangeError("out of range index");
      if (n4 >= i3 && t4 >= r4)
        return 0;
      if (n4 >= i3)
        return -1;
      if (t4 >= r4)
        return 1;
      if (this === e4)
        return 0;
      for (var a7 = (i3 >>>= 0) - (n4 >>>= 0), s3 = (r4 >>>= 0) - (t4 >>>= 0), o2 = Math.min(a7, s3), c3 = this.slice(n4, i3), l3 = e4.slice(t4, r4), h3 = 0; h3 < o2; ++h3)
        if (c3[h3] !== l3[h3]) {
          a7 = c3[h3], s3 = l3[h3];
          break;
        }
      return a7 < s3 ? -1 : s3 < a7 ? 1 : 0;
    }, u2.prototype.includes = function(e4, t4, r4) {
      return this.indexOf(e4, t4, r4) !== -1;
    }, u2.prototype.indexOf = function(e4, t4, r4) {
      return v2(this, e4, t4, r4, true);
    }, u2.prototype.lastIndexOf = function(e4, t4, r4) {
      return v2(this, e4, t4, r4, false);
    }, u2.prototype.write = function(e4, t4, r4, n4) {
      if (t4 === void 0)
        n4 = "utf8", r4 = this.length, t4 = 0;
      else if (r4 === void 0 && typeof t4 == "string")
        n4 = t4, r4 = this.length, t4 = 0;
      else {
        if (!isFinite(t4))
          throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        t4 |= 0, isFinite(r4) ? (r4 |= 0, n4 === void 0 && (n4 = "utf8")) : (n4 = r4, r4 = void 0);
      }
      var i3 = this.length - t4;
      if ((r4 === void 0 || r4 > i3) && (r4 = i3), e4.length > 0 && (r4 < 0 || t4 < 0) || t4 > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      n4 || (n4 = "utf8");
      for (var a7 = false; ; )
        switch (n4) {
          case "hex":
            return E2(this, e4, t4, r4);
          case "utf8":
          case "utf-8":
            return C(this, e4, t4, r4);
          case "ascii":
            return S2(this, e4, t4, r4);
          case "latin1":
          case "binary":
            return b2(this, e4, t4, r4);
          case "base64":
            return T2(this, e4, t4, r4);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return _24(this, e4, t4, r4);
          default:
            if (a7)
              throw new TypeError("Unknown encoding: " + n4);
            n4 = ("" + n4).toLowerCase(), a7 = true;
        }
    }, u2.prototype.toJSON = function() {
      return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
    };
    var B2 = 4096;
    function w2(e4, t4, r4) {
      var n4 = "";
      r4 = Math.min(e4.length, r4);
      for (var i3 = t4; i3 < r4; ++i3)
        n4 += String.fromCharCode(127 & e4[i3]);
      return n4;
    }
    function R(e4, t4, r4) {
      var n4 = "";
      r4 = Math.min(e4.length, r4);
      for (var i3 = t4; i3 < r4; ++i3)
        n4 += String.fromCharCode(e4[i3]);
      return n4;
    }
    function N2(e4, t4, r4) {
      var n4, i3 = e4.length;
      (!t4 || t4 < 0) && (t4 = 0), (!r4 || r4 < 0 || r4 > i3) && (r4 = i3);
      for (var a7 = "", s3 = t4; s3 < r4; ++s3)
        a7 += (n4 = e4[s3]) < 16 ? "0" + n4.toString(16) : n4.toString(16);
      return a7;
    }
    function L2(e4, t4, r4) {
      for (var n4 = e4.slice(t4, r4), i3 = "", a7 = 0; a7 < n4.length; a7 += 2)
        i3 += String.fromCharCode(n4[a7] + 256 * n4[a7 + 1]);
      return i3;
    }
    function k3(e4, t4, r4) {
      if (e4 % 1 != 0 || e4 < 0)
        throw new RangeError("offset is not uint");
      if (e4 + t4 > r4)
        throw new RangeError("Trying to access beyond buffer length");
    }
    function U2(e4, t4, r4, n4, i3, a7) {
      if (!u2.isBuffer(e4))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (t4 > i3 || t4 < a7)
        throw new RangeError('"value" argument is out of bounds');
      if (r4 + n4 > e4.length)
        throw new RangeError("Index out of range");
    }
    function D2(e4, t4, r4, n4) {
      t4 < 0 && (t4 = 65535 + t4 + 1);
      for (var i3 = 0, a7 = Math.min(e4.length - r4, 2); i3 < a7; ++i3)
        e4[r4 + i3] = (t4 & 255 << 8 * (n4 ? i3 : 1 - i3)) >>> 8 * (n4 ? i3 : 1 - i3);
    }
    function P2(e4, t4, r4, n4) {
      t4 < 0 && (t4 = 4294967295 + t4 + 1);
      for (var i3 = 0, a7 = Math.min(e4.length - r4, 4); i3 < a7; ++i3)
        e4[r4 + i3] = t4 >>> 8 * (n4 ? i3 : 3 - i3) & 255;
    }
    function O(e4, t4, r4, n4, i3, a7) {
      if (r4 + n4 > e4.length)
        throw new RangeError("Index out of range");
      if (r4 < 0)
        throw new RangeError("Index out of range");
    }
    function V2(e4, t4, r4, n4, a7) {
      return a7 || O(e4, 0, r4, 4), i2.write(e4, t4, r4, n4, 23, 4), r4 + 4;
    }
    function x2(e4, t4, r4, n4, a7) {
      return a7 || O(e4, 0, r4, 8), i2.write(e4, t4, r4, n4, 52, 8), r4 + 8;
    }
    u2.prototype.slice = function(e4, t4) {
      var r4, n4 = this.length;
      if ((e4 = ~~e4) < 0 ? (e4 += n4) < 0 && (e4 = 0) : e4 > n4 && (e4 = n4), (t4 = t4 === void 0 ? n4 : ~~t4) < 0 ? (t4 += n4) < 0 && (t4 = 0) : t4 > n4 && (t4 = n4), t4 < e4 && (t4 = e4), u2.TYPED_ARRAY_SUPPORT)
        (r4 = this.subarray(e4, t4)).__proto__ = u2.prototype;
      else {
        var i3 = t4 - e4;
        r4 = new u2(i3, void 0);
        for (var a7 = 0; a7 < i3; ++a7)
          r4[a7] = this[a7 + e4];
      }
      return r4;
    }, u2.prototype.readUIntLE = function(e4, t4, r4) {
      e4 |= 0, t4 |= 0, r4 || k3(e4, t4, this.length);
      for (var n4 = this[e4], i3 = 1, a7 = 0; ++a7 < t4 && (i3 *= 256); )
        n4 += this[e4 + a7] * i3;
      return n4;
    }, u2.prototype.readUIntBE = function(e4, t4, r4) {
      e4 |= 0, t4 |= 0, r4 || k3(e4, t4, this.length);
      for (var n4 = this[e4 + --t4], i3 = 1; t4 > 0 && (i3 *= 256); )
        n4 += this[e4 + --t4] * i3;
      return n4;
    }, u2.prototype.readUInt8 = function(e4, t4) {
      return t4 || k3(e4, 1, this.length), this[e4];
    }, u2.prototype.readUInt16LE = function(e4, t4) {
      return t4 || k3(e4, 2, this.length), this[e4] | this[e4 + 1] << 8;
    }, u2.prototype.readUInt16BE = function(e4, t4) {
      return t4 || k3(e4, 2, this.length), this[e4] << 8 | this[e4 + 1];
    }, u2.prototype.readUInt32LE = function(e4, t4) {
      return t4 || k3(e4, 4, this.length), (this[e4] | this[e4 + 1] << 8 | this[e4 + 2] << 16) + 16777216 * this[e4 + 3];
    }, u2.prototype.readUInt32BE = function(e4, t4) {
      return t4 || k3(e4, 4, this.length), 16777216 * this[e4] + (this[e4 + 1] << 16 | this[e4 + 2] << 8 | this[e4 + 3]);
    }, u2.prototype.readIntLE = function(e4, t4, r4) {
      e4 |= 0, t4 |= 0, r4 || k3(e4, t4, this.length);
      for (var n4 = this[e4], i3 = 1, a7 = 0; ++a7 < t4 && (i3 *= 256); )
        n4 += this[e4 + a7] * i3;
      return n4 >= (i3 *= 128) && (n4 -= Math.pow(2, 8 * t4)), n4;
    }, u2.prototype.readIntBE = function(e4, t4, r4) {
      e4 |= 0, t4 |= 0, r4 || k3(e4, t4, this.length);
      for (var n4 = t4, i3 = 1, a7 = this[e4 + --n4]; n4 > 0 && (i3 *= 256); )
        a7 += this[e4 + --n4] * i3;
      return a7 >= (i3 *= 128) && (a7 -= Math.pow(2, 8 * t4)), a7;
    }, u2.prototype.readInt8 = function(e4, t4) {
      return t4 || k3(e4, 1, this.length), 128 & this[e4] ? -1 * (255 - this[e4] + 1) : this[e4];
    }, u2.prototype.readInt16LE = function(e4, t4) {
      t4 || k3(e4, 2, this.length);
      var r4 = this[e4] | this[e4 + 1] << 8;
      return 32768 & r4 ? 4294901760 | r4 : r4;
    }, u2.prototype.readInt16BE = function(e4, t4) {
      t4 || k3(e4, 2, this.length);
      var r4 = this[e4 + 1] | this[e4] << 8;
      return 32768 & r4 ? 4294901760 | r4 : r4;
    }, u2.prototype.readInt32LE = function(e4, t4) {
      return t4 || k3(e4, 4, this.length), this[e4] | this[e4 + 1] << 8 | this[e4 + 2] << 16 | this[e4 + 3] << 24;
    }, u2.prototype.readInt32BE = function(e4, t4) {
      return t4 || k3(e4, 4, this.length), this[e4] << 24 | this[e4 + 1] << 16 | this[e4 + 2] << 8 | this[e4 + 3];
    }, u2.prototype.readFloatLE = function(e4, t4) {
      return t4 || k3(e4, 4, this.length), i2.read(this, e4, true, 23, 4);
    }, u2.prototype.readFloatBE = function(e4, t4) {
      return t4 || k3(e4, 4, this.length), i2.read(this, e4, false, 23, 4);
    }, u2.prototype.readDoubleLE = function(e4, t4) {
      return t4 || k3(e4, 8, this.length), i2.read(this, e4, true, 52, 8);
    }, u2.prototype.readDoubleBE = function(e4, t4) {
      return t4 || k3(e4, 8, this.length), i2.read(this, e4, false, 52, 8);
    }, u2.prototype.writeUIntLE = function(e4, t4, r4, n4) {
      e4 = +e4, t4 |= 0, r4 |= 0, n4 || U2(this, e4, t4, r4, Math.pow(2, 8 * r4) - 1, 0);
      var i3 = 1, a7 = 0;
      for (this[t4] = 255 & e4; ++a7 < r4 && (i3 *= 256); )
        this[t4 + a7] = e4 / i3 & 255;
      return t4 + r4;
    }, u2.prototype.writeUIntBE = function(e4, t4, r4, n4) {
      e4 = +e4, t4 |= 0, r4 |= 0, n4 || U2(this, e4, t4, r4, Math.pow(2, 8 * r4) - 1, 0);
      var i3 = r4 - 1, a7 = 1;
      for (this[t4 + i3] = 255 & e4; --i3 >= 0 && (a7 *= 256); )
        this[t4 + i3] = e4 / a7 & 255;
      return t4 + r4;
    }, u2.prototype.writeUInt8 = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 1, 255, 0), u2.TYPED_ARRAY_SUPPORT || (e4 = Math.floor(e4)), this[t4] = 255 & e4, t4 + 1;
    }, u2.prototype.writeUInt16LE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 2, 65535, 0), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = 255 & e4, this[t4 + 1] = e4 >>> 8) : D2(this, e4, t4, true), t4 + 2;
    }, u2.prototype.writeUInt16BE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 2, 65535, 0), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = e4 >>> 8, this[t4 + 1] = 255 & e4) : D2(this, e4, t4, false), t4 + 2;
    }, u2.prototype.writeUInt32LE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 4, 4294967295, 0), u2.TYPED_ARRAY_SUPPORT ? (this[t4 + 3] = e4 >>> 24, this[t4 + 2] = e4 >>> 16, this[t4 + 1] = e4 >>> 8, this[t4] = 255 & e4) : P2(this, e4, t4, true), t4 + 4;
    }, u2.prototype.writeUInt32BE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 4, 4294967295, 0), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = e4 >>> 24, this[t4 + 1] = e4 >>> 16, this[t4 + 2] = e4 >>> 8, this[t4 + 3] = 255 & e4) : P2(this, e4, t4, false), t4 + 4;
    }, u2.prototype.writeIntLE = function(e4, t4, r4, n4) {
      if (e4 = +e4, t4 |= 0, !n4) {
        var i3 = Math.pow(2, 8 * r4 - 1);
        U2(this, e4, t4, r4, i3 - 1, -i3);
      }
      var a7 = 0, s3 = 1, o2 = 0;
      for (this[t4] = 255 & e4; ++a7 < r4 && (s3 *= 256); )
        e4 < 0 && o2 === 0 && this[t4 + a7 - 1] !== 0 && (o2 = 1), this[t4 + a7] = (e4 / s3 >> 0) - o2 & 255;
      return t4 + r4;
    }, u2.prototype.writeIntBE = function(e4, t4, r4, n4) {
      if (e4 = +e4, t4 |= 0, !n4) {
        var i3 = Math.pow(2, 8 * r4 - 1);
        U2(this, e4, t4, r4, i3 - 1, -i3);
      }
      var a7 = r4 - 1, s3 = 1, o2 = 0;
      for (this[t4 + a7] = 255 & e4; --a7 >= 0 && (s3 *= 256); )
        e4 < 0 && o2 === 0 && this[t4 + a7 + 1] !== 0 && (o2 = 1), this[t4 + a7] = (e4 / s3 >> 0) - o2 & 255;
      return t4 + r4;
    }, u2.prototype.writeInt8 = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 1, 127, -128), u2.TYPED_ARRAY_SUPPORT || (e4 = Math.floor(e4)), e4 < 0 && (e4 = 255 + e4 + 1), this[t4] = 255 & e4, t4 + 1;
    }, u2.prototype.writeInt16LE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 2, 32767, -32768), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = 255 & e4, this[t4 + 1] = e4 >>> 8) : D2(this, e4, t4, true), t4 + 2;
    }, u2.prototype.writeInt16BE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 2, 32767, -32768), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = e4 >>> 8, this[t4 + 1] = 255 & e4) : D2(this, e4, t4, false), t4 + 2;
    }, u2.prototype.writeInt32LE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 4, 2147483647, -2147483648), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = 255 & e4, this[t4 + 1] = e4 >>> 8, this[t4 + 2] = e4 >>> 16, this[t4 + 3] = e4 >>> 24) : P2(this, e4, t4, true), t4 + 4;
    }, u2.prototype.writeInt32BE = function(e4, t4, r4) {
      return e4 = +e4, t4 |= 0, r4 || U2(this, e4, t4, 4, 2147483647, -2147483648), e4 < 0 && (e4 = 4294967295 + e4 + 1), u2.TYPED_ARRAY_SUPPORT ? (this[t4] = e4 >>> 24, this[t4 + 1] = e4 >>> 16, this[t4 + 2] = e4 >>> 8, this[t4 + 3] = 255 & e4) : P2(this, e4, t4, false), t4 + 4;
    }, u2.prototype.writeFloatLE = function(e4, t4, r4) {
      return V2(this, e4, t4, true, r4);
    }, u2.prototype.writeFloatBE = function(e4, t4, r4) {
      return V2(this, e4, t4, false, r4);
    }, u2.prototype.writeDoubleLE = function(e4, t4, r4) {
      return x2(this, e4, t4, true, r4);
    }, u2.prototype.writeDoubleBE = function(e4, t4, r4) {
      return x2(this, e4, t4, false, r4);
    }, u2.prototype.copy = function(e4, t4, r4, n4) {
      if (r4 || (r4 = 0), n4 || n4 === 0 || (n4 = this.length), t4 >= e4.length && (t4 = e4.length), t4 || (t4 = 0), n4 > 0 && n4 < r4 && (n4 = r4), n4 === r4)
        return 0;
      if (e4.length === 0 || this.length === 0)
        return 0;
      if (t4 < 0)
        throw new RangeError("targetStart out of bounds");
      if (r4 < 0 || r4 >= this.length)
        throw new RangeError("sourceStart out of bounds");
      if (n4 < 0)
        throw new RangeError("sourceEnd out of bounds");
      n4 > this.length && (n4 = this.length), e4.length - t4 < n4 - r4 && (n4 = e4.length - t4 + r4);
      var i3, a7 = n4 - r4;
      if (this === e4 && r4 < t4 && t4 < n4)
        for (i3 = a7 - 1; i3 >= 0; --i3)
          e4[i3 + t4] = this[i3 + r4];
      else if (a7 < 1e3 || !u2.TYPED_ARRAY_SUPPORT)
        for (i3 = 0; i3 < a7; ++i3)
          e4[i3 + t4] = this[i3 + r4];
      else
        Uint8Array.prototype.set.call(e4, this.subarray(r4, r4 + a7), t4);
      return a7;
    }, u2.prototype.fill = function(e4, t4, r4, n4) {
      if (typeof e4 == "string") {
        if (typeof t4 == "string" ? (n4 = t4, t4 = 0, r4 = this.length) : typeof r4 == "string" && (n4 = r4, r4 = this.length), e4.length === 1) {
          var i3 = e4.charCodeAt(0);
          i3 < 256 && (e4 = i3);
        }
        if (n4 !== void 0 && typeof n4 != "string")
          throw new TypeError("encoding must be a string");
        if (typeof n4 == "string" && !u2.isEncoding(n4))
          throw new TypeError("Unknown encoding: " + n4);
      } else
        typeof e4 == "number" && (e4 &= 255);
      if (t4 < 0 || this.length < t4 || this.length < r4)
        throw new RangeError("Out of range index");
      if (r4 <= t4)
        return this;
      var a7;
      if (t4 >>>= 0, r4 = r4 === void 0 ? this.length : r4 >>> 0, e4 || (e4 = 0), typeof e4 == "number")
        for (a7 = t4; a7 < r4; ++a7)
          this[a7] = e4;
      else {
        var s3 = u2.isBuffer(e4) ? e4 : K2(new u2(e4, n4).toString()), o2 = s3.length;
        for (a7 = 0; a7 < r4 - t4; ++a7)
          this[a7 + t4] = s3[a7 % o2];
      }
      return this;
    };
    var M2 = /[^+\/0-9A-Za-z-_]/g;
    function K2(e4, t4) {
      var r4;
      t4 = t4 || 1 / 0;
      for (var n4 = e4.length, i3 = null, a7 = [], s3 = 0; s3 < n4; ++s3) {
        if ((r4 = e4.charCodeAt(s3)) > 55295 && r4 < 57344) {
          if (!i3) {
            if (r4 > 56319) {
              (t4 -= 3) > -1 && a7.push(239, 191, 189);
              continue;
            }
            if (s3 + 1 === n4) {
              (t4 -= 3) > -1 && a7.push(239, 191, 189);
              continue;
            }
            i3 = r4;
            continue;
          }
          if (r4 < 56320) {
            (t4 -= 3) > -1 && a7.push(239, 191, 189), i3 = r4;
            continue;
          }
          r4 = 65536 + (i3 - 55296 << 10 | r4 - 56320);
        } else
          i3 && (t4 -= 3) > -1 && a7.push(239, 191, 189);
        if (i3 = null, r4 < 128) {
          if ((t4 -= 1) < 0)
            break;
          a7.push(r4);
        } else if (r4 < 2048) {
          if ((t4 -= 2) < 0)
            break;
          a7.push(r4 >> 6 | 192, 63 & r4 | 128);
        } else if (r4 < 65536) {
          if ((t4 -= 3) < 0)
            break;
          a7.push(r4 >> 12 | 224, r4 >> 6 & 63 | 128, 63 & r4 | 128);
        } else {
          if (!(r4 < 1114112))
            throw new Error("Invalid code point");
          if ((t4 -= 4) < 0)
            break;
          a7.push(r4 >> 18 | 240, r4 >> 12 & 63 | 128, r4 >> 6 & 63 | 128, 63 & r4 | 128);
        }
      }
      return a7;
    }
    function j2(e4) {
      return n3.toByteArray(function(e5) {
        if ((e5 = function(e6) {
          return e6.trim ? e6.trim() : e6.replace(/^\s+|\s+$/g, "");
        }(e5).replace(M2, "")).length < 2)
          return "";
        for (; e5.length % 4 != 0; )
          e5 += "=";
        return e5;
      }(e4));
    }
    function F2(e4, t4, r4, n4) {
      for (var i3 = 0; i3 < n4 && !(i3 + r4 >= t4.length || i3 >= e4.length); ++i3)
        t4[i3 + r4] = e4[i3];
      return i3;
    }
  }, 3973: (e3, t3, r3) => {
    var n3 = r3(7834).Buffer, i2 = r3(4851).Transform, a6 = r3(214).s;
    function s2(e4) {
      i2.call(this), this.hashMode = typeof e4 == "string", this.hashMode ? this[e4] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
    }
    r3(1285)(s2, i2), s2.prototype.update = function(e4, t4, r4) {
      typeof e4 == "string" && (e4 = n3.from(e4, t4));
      var i3 = this._update(e4);
      return this.hashMode ? this : (r4 && (i3 = this._toString(i3, r4)), i3);
    }, s2.prototype.setAutoPadding = function() {
    }, s2.prototype.getAuthTag = function() {
      throw new Error("trying to get auth tag in unsupported state");
    }, s2.prototype.setAuthTag = function() {
      throw new Error("trying to set auth tag in unsupported state");
    }, s2.prototype.setAAD = function() {
      throw new Error("trying to set aad in unsupported state");
    }, s2.prototype._transform = function(e4, t4, r4) {
      var n4;
      try {
        this.hashMode ? this._update(e4) : this.push(this._update(e4));
      } catch (e5) {
        n4 = e5;
      } finally {
        r4(n4);
      }
    }, s2.prototype._flush = function(e4) {
      var t4;
      try {
        this.push(this.__final());
      } catch (e5) {
        t4 = e5;
      }
      e4(t4);
    }, s2.prototype._finalOrDigest = function(e4) {
      var t4 = this.__final() || n3.alloc(0);
      return e4 && (t4 = this._toString(t4, e4, true)), t4;
    }, s2.prototype._toString = function(e4, t4, r4) {
      if (this._decoder || (this._decoder = new a6(t4), this._encoding = t4), this._encoding !== t4)
        throw new Error("can't switch encodings");
      var n4 = this._decoder.write(e4);
      return r4 && (n4 += this._decoder.end()), n4;
    }, e3.exports = s2;
  }, 2511: (e3, t3, r3) => {
    var n3 = r3(7993);
    e3.exports = function(e4) {
      return new n3().update(e4).digest();
    };
  }, 11: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(6456), a6 = r3(3973), s2 = r3(7834).Buffer, o = r3(2511), u2 = r3(1445), c2 = r3(9065), l2 = s2.alloc(128);
    function h2(e4, t4) {
      a6.call(this, "digest"), typeof t4 == "string" && (t4 = s2.from(t4));
      var r4 = e4 === "sha512" || e4 === "sha384" ? 128 : 64;
      this._alg = e4, this._key = t4, t4.length > r4 ? t4 = (e4 === "rmd160" ? new u2() : c2(e4)).update(t4).digest() : t4.length < r4 && (t4 = s2.concat([t4, l2], r4));
      for (var n4 = this._ipad = s2.allocUnsafe(r4), i3 = this._opad = s2.allocUnsafe(r4), o2 = 0; o2 < r4; o2++)
        n4[o2] = 54 ^ t4[o2], i3[o2] = 92 ^ t4[o2];
      this._hash = e4 === "rmd160" ? new u2() : c2(e4), this._hash.update(n4);
    }
    n3(h2, a6), h2.prototype._update = function(e4) {
      this._hash.update(e4);
    }, h2.prototype._final = function() {
      var e4 = this._hash.digest();
      return (this._alg === "rmd160" ? new u2() : c2(this._alg)).update(this._opad).update(e4).digest();
    }, e3.exports = function(e4, t4) {
      return (e4 = e4.toLowerCase()) === "rmd160" || e4 === "ripemd160" ? new h2("rmd160", t4) : e4 === "md5" ? new i2(o, t4) : new h2(e4, t4);
    };
  }, 6456: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(7834).Buffer, a6 = r3(3973), s2 = i2.alloc(128), o = 64;
    function u2(e4, t4) {
      a6.call(this, "digest"), typeof t4 == "string" && (t4 = i2.from(t4)), this._alg = e4, this._key = t4, t4.length > o ? t4 = e4(t4) : t4.length < o && (t4 = i2.concat([t4, s2], o));
      for (var r4 = this._ipad = i2.allocUnsafe(o), n4 = this._opad = i2.allocUnsafe(o), u3 = 0; u3 < o; u3++)
        r4[u3] = 54 ^ t4[u3], n4[u3] = 92 ^ t4[u3];
      this._hash = [r4];
    }
    n3(u2, a6), u2.prototype._update = function(e4) {
      this._hash.push(e4);
    }, u2.prototype._final = function() {
      var e4 = this._alg(i2.concat(this._hash));
      return this._alg(i2.concat([this._opad, e4]));
    }, e3.exports = u2;
  }, 2699: (e3) => {
    var t3, r3 = typeof Reflect == "object" ? Reflect : null, n3 = r3 && typeof r3.apply == "function" ? r3.apply : function(e4, t4, r4) {
      return Function.prototype.apply.call(e4, t4, r4);
    };
    t3 = r3 && typeof r3.ownKeys == "function" ? r3.ownKeys : Object.getOwnPropertySymbols ? function(e4) {
      return Object.getOwnPropertyNames(e4).concat(Object.getOwnPropertySymbols(e4));
    } : function(e4) {
      return Object.getOwnPropertyNames(e4);
    };
    var i2 = Number.isNaN || function(e4) {
      return e4 != e4;
    };
    function a6() {
      a6.init.call(this);
    }
    e3.exports = a6, e3.exports.once = function(e4, t4) {
      return new Promise(function(r4, n4) {
        function i3(r5) {
          e4.removeListener(t4, a7), n4(r5);
        }
        function a7() {
          typeof e4.removeListener == "function" && e4.removeListener("error", i3), r4([].slice.call(arguments));
        }
        g2(e4, t4, a7, { once: true }), t4 !== "error" && function(e5, t5, r5) {
          typeof e5.on == "function" && g2(e5, "error", t5, { once: true });
        }(e4, i3);
      });
    }, a6.EventEmitter = a6, a6.prototype._events = void 0, a6.prototype._eventsCount = 0, a6.prototype._maxListeners = void 0;
    var s2 = 10;
    function o(e4) {
      if (typeof e4 != "function")
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e4);
    }
    function u2(e4) {
      return e4._maxListeners === void 0 ? a6.defaultMaxListeners : e4._maxListeners;
    }
    function c2(e4, t4, r4, n4) {
      var i3, a7, s3, c3;
      if (o(r4), (a7 = e4._events) === void 0 ? (a7 = e4._events = /* @__PURE__ */ Object.create(null), e4._eventsCount = 0) : (a7.newListener !== void 0 && (e4.emit("newListener", t4, r4.listener ? r4.listener : r4), a7 = e4._events), s3 = a7[t4]), s3 === void 0)
        s3 = a7[t4] = r4, ++e4._eventsCount;
      else if (typeof s3 == "function" ? s3 = a7[t4] = n4 ? [r4, s3] : [s3, r4] : n4 ? s3.unshift(r4) : s3.push(r4), (i3 = u2(e4)) > 0 && s3.length > i3 && !s3.warned) {
        s3.warned = true;
        var l3 = new Error("Possible EventEmitter memory leak detected. " + s3.length + " " + String(t4) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        l3.name = "MaxListenersExceededWarning", l3.emitter = e4, l3.type = t4, l3.count = s3.length, c3 = l3, console && console.warn && console.warn(c3);
      }
      return e4;
    }
    function l2() {
      if (!this.fired)
        return this.target.removeListener(this.type, this.wrapFn), this.fired = true, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function h2(e4, t4, r4) {
      var n4 = { fired: false, wrapFn: void 0, target: e4, type: t4, listener: r4 }, i3 = l2.bind(n4);
      return i3.listener = r4, n4.wrapFn = i3, i3;
    }
    function f2(e4, t4, r4) {
      var n4 = e4._events;
      if (n4 === void 0)
        return [];
      var i3 = n4[t4];
      return i3 === void 0 ? [] : typeof i3 == "function" ? r4 ? [i3.listener || i3] : [i3] : r4 ? function(e5) {
        for (var t5 = new Array(e5.length), r5 = 0; r5 < t5.length; ++r5)
          t5[r5] = e5[r5].listener || e5[r5];
        return t5;
      }(i3) : d2(i3, i3.length);
    }
    function p2(e4) {
      var t4 = this._events;
      if (t4 !== void 0) {
        var r4 = t4[e4];
        if (typeof r4 == "function")
          return 1;
        if (r4 !== void 0)
          return r4.length;
      }
      return 0;
    }
    function d2(e4, t4) {
      for (var r4 = new Array(t4), n4 = 0; n4 < t4; ++n4)
        r4[n4] = e4[n4];
      return r4;
    }
    function g2(e4, t4, r4, n4) {
      if (typeof e4.on == "function")
        n4.once ? e4.once(t4, r4) : e4.on(t4, r4);
      else {
        if (typeof e4.addEventListener != "function")
          throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e4);
        e4.addEventListener(t4, function i3(a7) {
          n4.once && e4.removeEventListener(t4, i3), r4(a7);
        });
      }
    }
    Object.defineProperty(a6, "defaultMaxListeners", { enumerable: true, get: function() {
      return s2;
    }, set: function(e4) {
      if (typeof e4 != "number" || e4 < 0 || i2(e4))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e4 + ".");
      s2 = e4;
    } }), a6.init = function() {
      this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, a6.prototype.setMaxListeners = function(e4) {
      if (typeof e4 != "number" || e4 < 0 || i2(e4))
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e4 + ".");
      return this._maxListeners = e4, this;
    }, a6.prototype.getMaxListeners = function() {
      return u2(this);
    }, a6.prototype.emit = function(e4) {
      for (var t4 = [], r4 = 1; r4 < arguments.length; r4++)
        t4.push(arguments[r4]);
      var i3 = e4 === "error", a7 = this._events;
      if (a7 !== void 0)
        i3 = i3 && a7.error === void 0;
      else if (!i3)
        return false;
      if (i3) {
        var s3;
        if (t4.length > 0 && (s3 = t4[0]), s3 instanceof Error)
          throw s3;
        var o2 = new Error("Unhandled error." + (s3 ? " (" + s3.message + ")" : ""));
        throw o2.context = s3, o2;
      }
      var u3 = a7[e4];
      if (u3 === void 0)
        return false;
      if (typeof u3 == "function")
        n3(u3, this, t4);
      else {
        var c3 = u3.length, l3 = d2(u3, c3);
        for (r4 = 0; r4 < c3; ++r4)
          n3(l3[r4], this, t4);
      }
      return true;
    }, a6.prototype.addListener = function(e4, t4) {
      return c2(this, e4, t4, false);
    }, a6.prototype.on = a6.prototype.addListener, a6.prototype.prependListener = function(e4, t4) {
      return c2(this, e4, t4, true);
    }, a6.prototype.once = function(e4, t4) {
      return o(t4), this.on(e4, h2(this, e4, t4)), this;
    }, a6.prototype.prependOnceListener = function(e4, t4) {
      return o(t4), this.prependListener(e4, h2(this, e4, t4)), this;
    }, a6.prototype.removeListener = function(e4, t4) {
      var r4, n4, i3, a7, s3;
      if (o(t4), (n4 = this._events) === void 0)
        return this;
      if ((r4 = n4[e4]) === void 0)
        return this;
      if (r4 === t4 || r4.listener === t4)
        --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete n4[e4], n4.removeListener && this.emit("removeListener", e4, r4.listener || t4));
      else if (typeof r4 != "function") {
        for (i3 = -1, a7 = r4.length - 1; a7 >= 0; a7--)
          if (r4[a7] === t4 || r4[a7].listener === t4) {
            s3 = r4[a7].listener, i3 = a7;
            break;
          }
        if (i3 < 0)
          return this;
        i3 === 0 ? r4.shift() : function(e5, t5) {
          for (; t5 + 1 < e5.length; t5++)
            e5[t5] = e5[t5 + 1];
          e5.pop();
        }(r4, i3), r4.length === 1 && (n4[e4] = r4[0]), n4.removeListener !== void 0 && this.emit("removeListener", e4, s3 || t4);
      }
      return this;
    }, a6.prototype.off = a6.prototype.removeListener, a6.prototype.removeAllListeners = function(e4) {
      var t4, r4, n4;
      if ((r4 = this._events) === void 0)
        return this;
      if (r4.removeListener === void 0)
        return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r4[e4] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r4[e4]), this;
      if (arguments.length === 0) {
        var i3, a7 = Object.keys(r4);
        for (n4 = 0; n4 < a7.length; ++n4)
          (i3 = a7[n4]) !== "removeListener" && this.removeAllListeners(i3);
        return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
      }
      if (typeof (t4 = r4[e4]) == "function")
        this.removeListener(e4, t4);
      else if (t4 !== void 0)
        for (n4 = t4.length - 1; n4 >= 0; n4--)
          this.removeListener(e4, t4[n4]);
      return this;
    }, a6.prototype.listeners = function(e4) {
      return f2(this, e4, true);
    }, a6.prototype.rawListeners = function(e4) {
      return f2(this, e4, false);
    }, a6.listenerCount = function(e4, t4) {
      return typeof e4.listenerCount == "function" ? e4.listenerCount(t4) : p2.call(e4, t4);
    }, a6.prototype.listenerCount = p2, a6.prototype.eventNames = function() {
      return this._eventsCount > 0 ? t3(this._events) : [];
    };
  }, 4485: (e3, t3, r3) => {
    var n3 = r3(7834).Buffer, i2 = r3(7525).Transform;
    function a6(e4) {
      i2.call(this), this._block = n3.allocUnsafe(e4), this._blockSize = e4, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = false;
    }
    r3(1285)(a6, i2), a6.prototype._transform = function(e4, t4, r4) {
      var n4 = null;
      try {
        this.update(e4, t4);
      } catch (e5) {
        n4 = e5;
      }
      r4(n4);
    }, a6.prototype._flush = function(e4) {
      var t4 = null;
      try {
        this.push(this.digest());
      } catch (e5) {
        t4 = e5;
      }
      e4(t4);
    }, a6.prototype.update = function(e4, t4) {
      if (function(e5, t5) {
        if (!n3.isBuffer(e5) && typeof e5 != "string")
          throw new TypeError("Data must be a string or a buffer");
      }(e4), this._finalized)
        throw new Error("Digest already called");
      n3.isBuffer(e4) || (e4 = n3.from(e4, t4));
      for (var r4 = this._block, i3 = 0; this._blockOffset + e4.length - i3 >= this._blockSize; ) {
        for (var a7 = this._blockOffset; a7 < this._blockSize; )
          r4[a7++] = e4[i3++];
        this._update(), this._blockOffset = 0;
      }
      for (; i3 < e4.length; )
        r4[this._blockOffset++] = e4[i3++];
      for (var s2 = 0, o = 8 * e4.length; o > 0; ++s2)
        this._length[s2] += o, (o = this._length[s2] / 4294967296 | 0) > 0 && (this._length[s2] -= 4294967296 * o);
      return this;
    }, a6.prototype._update = function() {
      throw new Error("_update is not implemented");
    }, a6.prototype.digest = function(e4) {
      if (this._finalized)
        throw new Error("Digest already called");
      this._finalized = true;
      var t4 = this._digest();
      e4 !== void 0 && (t4 = t4.toString(e4)), this._block.fill(0), this._blockOffset = 0;
      for (var r4 = 0; r4 < 4; ++r4)
        this._length[r4] = 0;
      return t4;
    }, a6.prototype._digest = function() {
      throw new Error("_digest is not implemented");
    }, e3.exports = a6;
  }, 2333: (e3, t3) => {
    t3.read = function(e4, t4, r3, n3, i2) {
      var a6, s2, o = 8 * i2 - n3 - 1, u2 = (1 << o) - 1, c2 = u2 >> 1, l2 = -7, h2 = r3 ? i2 - 1 : 0, f2 = r3 ? -1 : 1, p2 = e4[t4 + h2];
      for (h2 += f2, a6 = p2 & (1 << -l2) - 1, p2 >>= -l2, l2 += o; l2 > 0; a6 = 256 * a6 + e4[t4 + h2], h2 += f2, l2 -= 8)
        ;
      for (s2 = a6 & (1 << -l2) - 1, a6 >>= -l2, l2 += n3; l2 > 0; s2 = 256 * s2 + e4[t4 + h2], h2 += f2, l2 -= 8)
        ;
      if (a6 === 0)
        a6 = 1 - c2;
      else {
        if (a6 === u2)
          return s2 ? NaN : 1 / 0 * (p2 ? -1 : 1);
        s2 += Math.pow(2, n3), a6 -= c2;
      }
      return (p2 ? -1 : 1) * s2 * Math.pow(2, a6 - n3);
    }, t3.write = function(e4, t4, r3, n3, i2, a6) {
      var s2, o, u2, c2 = 8 * a6 - i2 - 1, l2 = (1 << c2) - 1, h2 = l2 >> 1, f2 = i2 === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p2 = n3 ? 0 : a6 - 1, d2 = n3 ? 1 : -1, g2 = t4 < 0 || t4 === 0 && 1 / t4 < 0 ? 1 : 0;
      for (t4 = Math.abs(t4), isNaN(t4) || t4 === 1 / 0 ? (o = isNaN(t4) ? 1 : 0, s2 = l2) : (s2 = Math.floor(Math.log(t4) / Math.LN2), t4 * (u2 = Math.pow(2, -s2)) < 1 && (s2--, u2 *= 2), (t4 += s2 + h2 >= 1 ? f2 / u2 : f2 * Math.pow(2, 1 - h2)) * u2 >= 2 && (s2++, u2 /= 2), s2 + h2 >= l2 ? (o = 0, s2 = l2) : s2 + h2 >= 1 ? (o = (t4 * u2 - 1) * Math.pow(2, i2), s2 += h2) : (o = t4 * Math.pow(2, h2 - 1) * Math.pow(2, i2), s2 = 0)); i2 >= 8; e4[r3 + p2] = 255 & o, p2 += d2, o /= 256, i2 -= 8)
        ;
      for (s2 = s2 << i2 | o, c2 += i2; c2 > 0; e4[r3 + p2] = 255 & s2, p2 += d2, s2 /= 256, c2 -= 8)
        ;
      e4[r3 + p2 - d2] |= 128 * g2;
    };
  }, 1285: (e3) => {
    typeof Object.create == "function" ? e3.exports = function(e4, t3) {
      t3 && (e4.super_ = t3, e4.prototype = Object.create(t3.prototype, { constructor: { value: e4, enumerable: false, writable: true, configurable: true } }));
    } : e3.exports = function(e4, t3) {
      if (t3) {
        e4.super_ = t3;
        var r3 = function() {
        };
        r3.prototype = t3.prototype, e4.prototype = new r3(), e4.prototype.constructor = e4;
      }
    };
  }, 7906: (e3) => {
    var t3 = {}.toString;
    e3.exports = Array.isArray || function(e4) {
      return t3.call(e4) == "[object Array]";
    };
  }, 7993: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(4485), a6 = r3(7834).Buffer, s2 = new Array(16);
    function o() {
      i2.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
    }
    function u2(e4, t4) {
      return e4 << t4 | e4 >>> 32 - t4;
    }
    function c2(e4, t4, r4, n4, i3, a7, s3) {
      return u2(e4 + (t4 & r4 | ~t4 & n4) + i3 + a7 | 0, s3) + t4 | 0;
    }
    function l2(e4, t4, r4, n4, i3, a7, s3) {
      return u2(e4 + (t4 & n4 | r4 & ~n4) + i3 + a7 | 0, s3) + t4 | 0;
    }
    function h2(e4, t4, r4, n4, i3, a7, s3) {
      return u2(e4 + (t4 ^ r4 ^ n4) + i3 + a7 | 0, s3) + t4 | 0;
    }
    function f2(e4, t4, r4, n4, i3, a7, s3) {
      return u2(e4 + (r4 ^ (t4 | ~n4)) + i3 + a7 | 0, s3) + t4 | 0;
    }
    n3(o, i2), o.prototype._update = function() {
      for (var e4 = s2, t4 = 0; t4 < 16; ++t4)
        e4[t4] = this._block.readInt32LE(4 * t4);
      var r4 = this._a, n4 = this._b, i3 = this._c, a7 = this._d;
      r4 = c2(r4, n4, i3, a7, e4[0], 3614090360, 7), a7 = c2(a7, r4, n4, i3, e4[1], 3905402710, 12), i3 = c2(i3, a7, r4, n4, e4[2], 606105819, 17), n4 = c2(n4, i3, a7, r4, e4[3], 3250441966, 22), r4 = c2(r4, n4, i3, a7, e4[4], 4118548399, 7), a7 = c2(a7, r4, n4, i3, e4[5], 1200080426, 12), i3 = c2(i3, a7, r4, n4, e4[6], 2821735955, 17), n4 = c2(n4, i3, a7, r4, e4[7], 4249261313, 22), r4 = c2(r4, n4, i3, a7, e4[8], 1770035416, 7), a7 = c2(a7, r4, n4, i3, e4[9], 2336552879, 12), i3 = c2(i3, a7, r4, n4, e4[10], 4294925233, 17), n4 = c2(n4, i3, a7, r4, e4[11], 2304563134, 22), r4 = c2(r4, n4, i3, a7, e4[12], 1804603682, 7), a7 = c2(a7, r4, n4, i3, e4[13], 4254626195, 12), i3 = c2(i3, a7, r4, n4, e4[14], 2792965006, 17), r4 = l2(r4, n4 = c2(n4, i3, a7, r4, e4[15], 1236535329, 22), i3, a7, e4[1], 4129170786, 5), a7 = l2(a7, r4, n4, i3, e4[6], 3225465664, 9), i3 = l2(i3, a7, r4, n4, e4[11], 643717713, 14), n4 = l2(n4, i3, a7, r4, e4[0], 3921069994, 20), r4 = l2(r4, n4, i3, a7, e4[5], 3593408605, 5), a7 = l2(a7, r4, n4, i3, e4[10], 38016083, 9), i3 = l2(i3, a7, r4, n4, e4[15], 3634488961, 14), n4 = l2(n4, i3, a7, r4, e4[4], 3889429448, 20), r4 = l2(r4, n4, i3, a7, e4[9], 568446438, 5), a7 = l2(a7, r4, n4, i3, e4[14], 3275163606, 9), i3 = l2(i3, a7, r4, n4, e4[3], 4107603335, 14), n4 = l2(n4, i3, a7, r4, e4[8], 1163531501, 20), r4 = l2(r4, n4, i3, a7, e4[13], 2850285829, 5), a7 = l2(a7, r4, n4, i3, e4[2], 4243563512, 9), i3 = l2(i3, a7, r4, n4, e4[7], 1735328473, 14), r4 = h2(r4, n4 = l2(n4, i3, a7, r4, e4[12], 2368359562, 20), i3, a7, e4[5], 4294588738, 4), a7 = h2(a7, r4, n4, i3, e4[8], 2272392833, 11), i3 = h2(i3, a7, r4, n4, e4[11], 1839030562, 16), n4 = h2(n4, i3, a7, r4, e4[14], 4259657740, 23), r4 = h2(r4, n4, i3, a7, e4[1], 2763975236, 4), a7 = h2(a7, r4, n4, i3, e4[4], 1272893353, 11), i3 = h2(i3, a7, r4, n4, e4[7], 4139469664, 16), n4 = h2(n4, i3, a7, r4, e4[10], 3200236656, 23), r4 = h2(r4, n4, i3, a7, e4[13], 681279174, 4), a7 = h2(a7, r4, n4, i3, e4[0], 3936430074, 11), i3 = h2(i3, a7, r4, n4, e4[3], 3572445317, 16), n4 = h2(n4, i3, a7, r4, e4[6], 76029189, 23), r4 = h2(r4, n4, i3, a7, e4[9], 3654602809, 4), a7 = h2(a7, r4, n4, i3, e4[12], 3873151461, 11), i3 = h2(i3, a7, r4, n4, e4[15], 530742520, 16), r4 = f2(r4, n4 = h2(n4, i3, a7, r4, e4[2], 3299628645, 23), i3, a7, e4[0], 4096336452, 6), a7 = f2(a7, r4, n4, i3, e4[7], 1126891415, 10), i3 = f2(i3, a7, r4, n4, e4[14], 2878612391, 15), n4 = f2(n4, i3, a7, r4, e4[5], 4237533241, 21), r4 = f2(r4, n4, i3, a7, e4[12], 1700485571, 6), a7 = f2(a7, r4, n4, i3, e4[3], 2399980690, 10), i3 = f2(i3, a7, r4, n4, e4[10], 4293915773, 15), n4 = f2(n4, i3, a7, r4, e4[1], 2240044497, 21), r4 = f2(r4, n4, i3, a7, e4[8], 1873313359, 6), a7 = f2(a7, r4, n4, i3, e4[15], 4264355552, 10), i3 = f2(i3, a7, r4, n4, e4[6], 2734768916, 15), n4 = f2(n4, i3, a7, r4, e4[13], 1309151649, 21), r4 = f2(r4, n4, i3, a7, e4[4], 4149444226, 6), a7 = f2(a7, r4, n4, i3, e4[11], 3174756917, 10), i3 = f2(i3, a7, r4, n4, e4[2], 718787259, 15), n4 = f2(n4, i3, a7, r4, e4[9], 3951481745, 21), this._a = this._a + r4 | 0, this._b = this._b + n4 | 0, this._c = this._c + i3 | 0, this._d = this._d + a7 | 0;
    }, o.prototype._digest = function() {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var e4 = a6.allocUnsafe(16);
      return e4.writeInt32LE(this._a, 0), e4.writeInt32LE(this._b, 4), e4.writeInt32LE(this._c, 8), e4.writeInt32LE(this._d, 12), e4;
    }, e3.exports = o;
  }, 1482: (e3, t3, r3) => {
    var n3 = r3(7768);
    function i2(e4, t4) {
      n3.cipher.registerAlgorithm(e4, function() {
        return new n3.aes.Algorithm(e4, t4);
      });
    }
    r3(4609), r3(9554), r3(3103), e3.exports = n3.aes = n3.aes || {}, n3.aes.startEncrypting = function(e4, t4, r4, n4) {
      var i3 = d2({ key: e4, output: r4, decrypt: false, mode: n4 });
      return i3.start(t4), i3;
    }, n3.aes.createEncryptionCipher = function(e4, t4) {
      return d2({ key: e4, output: null, decrypt: false, mode: t4 });
    }, n3.aes.startDecrypting = function(e4, t4, r4, n4) {
      var i3 = d2({ key: e4, output: r4, decrypt: true, mode: n4 });
      return i3.start(t4), i3;
    }, n3.aes.createDecryptionCipher = function(e4, t4) {
      return d2({ key: e4, output: null, decrypt: true, mode: t4 });
    }, n3.aes.Algorithm = function(e4, t4) {
      l2 || h2();
      var r4 = this;
      r4.name = e4, r4.mode = new t4({ blockSize: 16, cipher: { encrypt: function(e5, t5) {
        return p2(r4._w, e5, t5, false);
      }, decrypt: function(e5, t5) {
        return p2(r4._w, e5, t5, true);
      } } }), r4._init = false;
    }, n3.aes.Algorithm.prototype.initialize = function(e4) {
      if (!this._init) {
        var t4, r4 = e4.key;
        if (typeof r4 != "string" || r4.length !== 16 && r4.length !== 24 && r4.length !== 32) {
          if (n3.util.isArray(r4) && (r4.length === 16 || r4.length === 24 || r4.length === 32)) {
            t4 = r4, r4 = n3.util.createBuffer();
            for (var i3 = 0; i3 < t4.length; ++i3)
              r4.putByte(t4[i3]);
          }
        } else
          r4 = n3.util.createBuffer(r4);
        if (!n3.util.isArray(r4)) {
          t4 = r4, r4 = [];
          var a7 = t4.length();
          if (a7 === 16 || a7 === 24 || a7 === 32)
            for (a7 >>>= 2, i3 = 0; i3 < a7; ++i3)
              r4.push(t4.getInt32());
        }
        if (!n3.util.isArray(r4) || r4.length !== 4 && r4.length !== 6 && r4.length !== 8)
          throw new Error("Invalid key parameter.");
        var s3 = this.mode.name, o2 = ["CFB", "OFB", "CTR", "GCM"].indexOf(s3) !== -1;
        this._w = f2(r4, e4.decrypt && !o2), this._init = true;
      }
    }, n3.aes._expandKey = function(e4, t4) {
      return l2 || h2(), f2(e4, t4);
    }, n3.aes._updateBlock = p2, i2("AES-ECB", n3.cipher.modes.ecb), i2("AES-CBC", n3.cipher.modes.cbc), i2("AES-CFB", n3.cipher.modes.cfb), i2("AES-OFB", n3.cipher.modes.ofb), i2("AES-CTR", n3.cipher.modes.ctr), i2("AES-GCM", n3.cipher.modes.gcm);
    var a6, s2, o, u2, c2, l2 = false;
    function h2() {
      l2 = true, o = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
      for (var e4 = new Array(256), t4 = 0; t4 < 128; ++t4)
        e4[t4] = t4 << 1, e4[t4 + 128] = t4 + 128 << 1 ^ 283;
      for (a6 = new Array(256), s2 = new Array(256), u2 = new Array(4), c2 = new Array(4), t4 = 0; t4 < 4; ++t4)
        u2[t4] = new Array(256), c2[t4] = new Array(256);
      var r4, n4, i3, h3, f3, p3, d3, g2 = 0, y2 = 0;
      for (t4 = 0; t4 < 256; ++t4) {
        h3 = (h3 = y2 ^ y2 << 1 ^ y2 << 2 ^ y2 << 3 ^ y2 << 4) >> 8 ^ 255 & h3 ^ 99, a6[g2] = h3, s2[h3] = g2, p3 = (f3 = e4[h3]) << 24 ^ h3 << 16 ^ h3 << 8 ^ h3 ^ f3, d3 = ((r4 = e4[g2]) ^ (n4 = e4[r4]) ^ (i3 = e4[n4])) << 24 ^ (g2 ^ i3) << 16 ^ (g2 ^ n4 ^ i3) << 8 ^ g2 ^ r4 ^ i3;
        for (var v2 = 0; v2 < 4; ++v2)
          u2[v2][g2] = p3, c2[v2][h3] = d3, p3 = p3 << 24 | p3 >>> 8, d3 = d3 << 24 | d3 >>> 8;
        g2 === 0 ? g2 = y2 = 1 : (g2 = r4 ^ e4[e4[e4[r4 ^ i3]]], y2 ^= e4[e4[y2]]);
      }
    }
    function f2(e4, t4) {
      for (var r4, n4 = e4.slice(0), i3 = 1, s3 = n4.length, u3 = 4 * (s3 + 6 + 1), l3 = s3; l3 < u3; ++l3)
        r4 = n4[l3 - 1], l3 % s3 == 0 ? (r4 = a6[r4 >>> 16 & 255] << 24 ^ a6[r4 >>> 8 & 255] << 16 ^ a6[255 & r4] << 8 ^ a6[r4 >>> 24] ^ o[i3] << 24, i3++) : s3 > 6 && l3 % s3 == 4 && (r4 = a6[r4 >>> 24] << 24 ^ a6[r4 >>> 16 & 255] << 16 ^ a6[r4 >>> 8 & 255] << 8 ^ a6[255 & r4]), n4[l3] = n4[l3 - s3] ^ r4;
      if (t4) {
        for (var h3, f3 = c2[0], p3 = c2[1], d3 = c2[2], g2 = c2[3], y2 = n4.slice(0), v2 = (l3 = 0, (u3 = n4.length) - 4); l3 < u3; l3 += 4, v2 -= 4)
          if (l3 === 0 || l3 === u3 - 4)
            y2[l3] = n4[v2], y2[l3 + 1] = n4[v2 + 3], y2[l3 + 2] = n4[v2 + 2], y2[l3 + 3] = n4[v2 + 1];
          else
            for (var m2 = 0; m2 < 4; ++m2)
              h3 = n4[v2 + m2], y2[l3 + (3 & -m2)] = f3[a6[h3 >>> 24]] ^ p3[a6[h3 >>> 16 & 255]] ^ d3[a6[h3 >>> 8 & 255]] ^ g2[a6[255 & h3]];
        n4 = y2;
      }
      return n4;
    }
    function p2(e4, t4, r4, n4) {
      var i3, o2, l3, h3, f3, p3, d3, g2, y2, v2, m2, E2, C = e4.length / 4 - 1;
      n4 ? (i3 = c2[0], o2 = c2[1], l3 = c2[2], h3 = c2[3], f3 = s2) : (i3 = u2[0], o2 = u2[1], l3 = u2[2], h3 = u2[3], f3 = a6), p3 = t4[0] ^ e4[0], d3 = t4[n4 ? 3 : 1] ^ e4[1], g2 = t4[2] ^ e4[2], y2 = t4[n4 ? 1 : 3] ^ e4[3];
      for (var S2 = 3, b2 = 1; b2 < C; ++b2)
        v2 = i3[p3 >>> 24] ^ o2[d3 >>> 16 & 255] ^ l3[g2 >>> 8 & 255] ^ h3[255 & y2] ^ e4[++S2], m2 = i3[d3 >>> 24] ^ o2[g2 >>> 16 & 255] ^ l3[y2 >>> 8 & 255] ^ h3[255 & p3] ^ e4[++S2], E2 = i3[g2 >>> 24] ^ o2[y2 >>> 16 & 255] ^ l3[p3 >>> 8 & 255] ^ h3[255 & d3] ^ e4[++S2], y2 = i3[y2 >>> 24] ^ o2[p3 >>> 16 & 255] ^ l3[d3 >>> 8 & 255] ^ h3[255 & g2] ^ e4[++S2], p3 = v2, d3 = m2, g2 = E2;
      r4[0] = f3[p3 >>> 24] << 24 ^ f3[d3 >>> 16 & 255] << 16 ^ f3[g2 >>> 8 & 255] << 8 ^ f3[255 & y2] ^ e4[++S2], r4[n4 ? 3 : 1] = f3[d3 >>> 24] << 24 ^ f3[g2 >>> 16 & 255] << 16 ^ f3[y2 >>> 8 & 255] << 8 ^ f3[255 & p3] ^ e4[++S2], r4[2] = f3[g2 >>> 24] << 24 ^ f3[y2 >>> 16 & 255] << 16 ^ f3[p3 >>> 8 & 255] << 8 ^ f3[255 & d3] ^ e4[++S2], r4[n4 ? 1 : 3] = f3[y2 >>> 24] << 24 ^ f3[p3 >>> 16 & 255] << 16 ^ f3[d3 >>> 8 & 255] << 8 ^ f3[255 & g2] ^ e4[++S2];
    }
    function d2(e4) {
      var t4, r4 = "AES-" + ((e4 = e4 || {}).mode || "CBC").toUpperCase(), i3 = (t4 = e4.decrypt ? n3.cipher.createDecipher(r4, e4.key) : n3.cipher.createCipher(r4, e4.key)).start;
      return t4.start = function(e5, r5) {
        var a7 = null;
        r5 instanceof n3.util.ByteBuffer && (a7 = r5, r5 = {}), (r5 = r5 || {}).output = a7, r5.iv = e5, i3.call(t4, r5);
      }, t4;
    }
  }, 6898: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(1482), r3(8472);
    var i2 = e3.exports = n3.tls;
    function a6(e4, t4, r4) {
      var a7 = t4.entity === n3.tls.ConnectionEnd.client;
      e4.read.cipherState = { init: false, cipher: n3.cipher.createDecipher("AES-CBC", a7 ? r4.keys.server_write_key : r4.keys.client_write_key), iv: a7 ? r4.keys.server_write_IV : r4.keys.client_write_IV }, e4.write.cipherState = { init: false, cipher: n3.cipher.createCipher("AES-CBC", a7 ? r4.keys.client_write_key : r4.keys.server_write_key), iv: a7 ? r4.keys.client_write_IV : r4.keys.server_write_IV }, e4.read.cipherFunction = c2, e4.write.cipherFunction = s2, e4.read.macLength = e4.write.macLength = r4.mac_length, e4.read.macFunction = e4.write.macFunction = i2.hmac_sha1;
    }
    function s2(e4, t4) {
      var r4, a7 = false, s3 = t4.macFunction(t4.macKey, t4.sequenceNumber, e4);
      e4.fragment.putBytes(s3), t4.updateSequenceNumber(), r4 = e4.version.minor === i2.Versions.TLS_1_0.minor ? t4.cipherState.init ? null : t4.cipherState.iv : n3.random.getBytesSync(16), t4.cipherState.init = true;
      var u3 = t4.cipherState.cipher;
      return u3.start({ iv: r4 }), e4.version.minor >= i2.Versions.TLS_1_1.minor && u3.output.putBytes(r4), u3.update(e4.fragment), u3.finish(o) && (e4.fragment = u3.output, e4.length = e4.fragment.length(), a7 = true), a7;
    }
    function o(e4, t4, r4) {
      if (!r4) {
        var n4 = e4 - t4.length() % e4;
        t4.fillWithByte(n4 - 1, n4);
      }
      return true;
    }
    function u2(e4, t4, r4) {
      var n4 = true;
      if (r4) {
        for (var i3 = t4.length(), a7 = t4.last(), s3 = i3 - 1 - a7; s3 < i3 - 1; ++s3)
          n4 = n4 && t4.at(s3) == a7;
        n4 && t4.truncate(a7 + 1);
      }
      return n4;
    }
    function c2(e4, t4) {
      var r4, a7 = false;
      r4 = e4.version.minor === i2.Versions.TLS_1_0.minor ? t4.cipherState.init ? null : t4.cipherState.iv : e4.fragment.getBytes(16), t4.cipherState.init = true;
      var s3 = t4.cipherState.cipher;
      s3.start({ iv: r4 }), s3.update(e4.fragment), a7 = s3.finish(u2);
      var o2 = t4.macLength, c3 = n3.random.getBytesSync(o2), l2 = s3.output.length();
      l2 >= o2 ? (e4.fragment = s3.output.getBytes(l2 - o2), c3 = s3.output.getBytes(o2)) : e4.fragment = s3.output.getBytes(), e4.fragment = n3.util.createBuffer(e4.fragment), e4.length = e4.fragment.length();
      var h2 = t4.macFunction(t4.macKey, t4.sequenceNumber, e4);
      return t4.updateSequenceNumber(), a7 = function(e5, t5, r5) {
        var i3 = n3.hmac.create();
        return i3.start("SHA1", e5), i3.update(t5), t5 = i3.digest().getBytes(), i3.start(null, null), i3.update(r5), t5 === (r5 = i3.digest().getBytes());
      }(t4.macKey, c3, h2) && a7, a7;
    }
    i2.CipherSuites.TLS_RSA_WITH_AES_128_CBC_SHA = { id: [0, 47], name: "TLS_RSA_WITH_AES_128_CBC_SHA", initSecurityParameters: function(e4) {
      e4.bulk_cipher_algorithm = i2.BulkCipherAlgorithm.aes, e4.cipher_type = i2.CipherType.block, e4.enc_key_length = 16, e4.block_length = 16, e4.fixed_iv_length = 16, e4.record_iv_length = 16, e4.mac_algorithm = i2.MACAlgorithm.hmac_sha1, e4.mac_length = 20, e4.mac_key_length = 20;
    }, initConnectionState: a6 }, i2.CipherSuites.TLS_RSA_WITH_AES_256_CBC_SHA = { id: [0, 53], name: "TLS_RSA_WITH_AES_256_CBC_SHA", initSecurityParameters: function(e4) {
      e4.bulk_cipher_algorithm = i2.BulkCipherAlgorithm.aes, e4.cipher_type = i2.CipherType.block, e4.enc_key_length = 32, e4.block_length = 16, e4.fixed_iv_length = 16, e4.record_iv_length = 16, e4.mac_algorithm = i2.MACAlgorithm.hmac_sha1, e4.mac_length = 20, e4.mac_key_length = 20;
    }, initConnectionState: a6 };
  }, 5235: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(2624);
    var i2 = n3.asn1;
    t3.privateKeyValidator = { name: "PrivateKeyInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "PrivateKeyInfo.version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "privateKeyVersion" }, { name: "PrivateKeyInfo.privateKeyAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "privateKeyOid" }] }, { name: "PrivateKeyInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OCTETSTRING, constructed: false, capture: "privateKey" }] }, t3.publicKeyValidator = { name: "SubjectPublicKeyInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "subjectPublicKeyInfo", value: [{ name: "SubjectPublicKeyInfo.AlgorithmIdentifier", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "publicKeyOid" }] }, { tagClass: i2.Class.UNIVERSAL, type: i2.Type.BITSTRING, constructed: false, composed: true, captureBitStringValue: "ed25519PublicKey" }] };
  }, 2624: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), r3(2884);
    var i2 = e3.exports = n3.asn1 = n3.asn1 || {};
    function a6(e4, t4, r4) {
      if (r4 > t4) {
        var n4 = new Error("Too few bytes to parse DER.");
        throw n4.available = e4.length(), n4.remaining = t4, n4.requested = r4, n4;
      }
    }
    function s2(e4, t4, r4, n4) {
      var o2;
      a6(e4, t4, 2);
      var u2 = e4.getByte();
      t4--;
      var c2 = 192 & u2, l2 = 31 & u2;
      o2 = e4.length();
      var h2, f2, p2 = function(e5, t5) {
        var r5 = e5.getByte();
        if (t5--, r5 !== 128) {
          var n5;
          if (128 & r5) {
            var i3 = 127 & r5;
            a6(e5, t5, i3), n5 = e5.getInt(i3 << 3);
          } else
            n5 = r5;
          if (n5 < 0)
            throw new Error("Negative length: " + n5);
          return n5;
        }
      }(e4, t4);
      if (t4 -= o2 - e4.length(), p2 !== void 0 && p2 > t4) {
        if (n4.strict) {
          var d2 = new Error("Too few bytes to read ASN.1 value.");
          throw d2.available = e4.length(), d2.remaining = t4, d2.requested = p2, d2;
        }
        p2 = t4;
      }
      var g2 = (32 & u2) == 32;
      if (g2)
        if (h2 = [], p2 === void 0)
          for (; ; ) {
            if (a6(e4, t4, 2), e4.bytes(2) === String.fromCharCode(0, 0)) {
              e4.getBytes(2), t4 -= 2;
              break;
            }
            o2 = e4.length(), h2.push(s2(e4, t4, r4 + 1, n4)), t4 -= o2 - e4.length();
          }
        else
          for (; p2 > 0; )
            o2 = e4.length(), h2.push(s2(e4, p2, r4 + 1, n4)), t4 -= o2 - e4.length(), p2 -= o2 - e4.length();
      if (h2 === void 0 && c2 === i2.Class.UNIVERSAL && l2 === i2.Type.BITSTRING && (f2 = e4.bytes(p2)), h2 === void 0 && n4.decodeBitStrings && c2 === i2.Class.UNIVERSAL && l2 === i2.Type.BITSTRING && p2 > 1) {
        var y2 = e4.read, v2 = t4, m2 = 0;
        if (l2 === i2.Type.BITSTRING && (a6(e4, t4, 1), m2 = e4.getByte(), t4--), m2 === 0)
          try {
            o2 = e4.length();
            var E2 = s2(e4, t4, r4 + 1, { strict: true, decodeBitStrings: true }), C = o2 - e4.length();
            t4 -= C, l2 == i2.Type.BITSTRING && C++;
            var S2 = E2.tagClass;
            C !== p2 || S2 !== i2.Class.UNIVERSAL && S2 !== i2.Class.CONTEXT_SPECIFIC || (h2 = [E2]);
          } catch (e5) {
          }
        h2 === void 0 && (e4.read = y2, t4 = v2);
      }
      if (h2 === void 0) {
        if (p2 === void 0) {
          if (n4.strict)
            throw new Error("Non-constructed ASN.1 object of indefinite length.");
          p2 = t4;
        }
        if (l2 === i2.Type.BMPSTRING)
          for (h2 = ""; p2 > 0; p2 -= 2)
            a6(e4, t4, 2), h2 += String.fromCharCode(e4.getInt16()), t4 -= 2;
        else
          h2 = e4.getBytes(p2), t4 -= p2;
      }
      var b2 = f2 === void 0 ? null : { bitStringContents: f2 };
      return i2.create(c2, l2, g2, h2, b2);
    }
    i2.Class = { UNIVERSAL: 0, APPLICATION: 64, CONTEXT_SPECIFIC: 128, PRIVATE: 192 }, i2.Type = { NONE: 0, BOOLEAN: 1, INTEGER: 2, BITSTRING: 3, OCTETSTRING: 4, NULL: 5, OID: 6, ODESC: 7, EXTERNAL: 8, REAL: 9, ENUMERATED: 10, EMBEDDED: 11, UTF8: 12, ROID: 13, SEQUENCE: 16, SET: 17, PRINTABLESTRING: 19, IA5STRING: 22, UTCTIME: 23, GENERALIZEDTIME: 24, BMPSTRING: 30 }, i2.create = function(e4, t4, r4, a7, s3) {
      if (n3.util.isArray(a7)) {
        for (var o2 = [], u2 = 0; u2 < a7.length; ++u2)
          a7[u2] !== void 0 && o2.push(a7[u2]);
        a7 = o2;
      }
      var c2 = { tagClass: e4, type: t4, constructed: r4, composed: r4 || n3.util.isArray(a7), value: a7 };
      return s3 && "bitStringContents" in s3 && (c2.bitStringContents = s3.bitStringContents, c2.original = i2.copy(c2)), c2;
    }, i2.copy = function(e4, t4) {
      var r4;
      if (n3.util.isArray(e4)) {
        r4 = [];
        for (var a7 = 0; a7 < e4.length; ++a7)
          r4.push(i2.copy(e4[a7], t4));
        return r4;
      }
      return typeof e4 == "string" ? e4 : (r4 = { tagClass: e4.tagClass, type: e4.type, constructed: e4.constructed, composed: e4.composed, value: i2.copy(e4.value, t4) }, t4 && !t4.excludeBitStringContents && (r4.bitStringContents = e4.bitStringContents), r4);
    }, i2.equals = function(e4, t4, r4) {
      if (n3.util.isArray(e4)) {
        if (!n3.util.isArray(t4))
          return false;
        if (e4.length !== t4.length)
          return false;
        for (var a7 = 0; a7 < e4.length; ++a7)
          if (!i2.equals(e4[a7], t4[a7]))
            return false;
        return true;
      }
      if (typeof e4 != typeof t4)
        return false;
      if (typeof e4 == "string")
        return e4 === t4;
      var s3 = e4.tagClass === t4.tagClass && e4.type === t4.type && e4.constructed === t4.constructed && e4.composed === t4.composed && i2.equals(e4.value, t4.value);
      return r4 && r4.includeBitStringContents && (s3 = s3 && e4.bitStringContents === t4.bitStringContents), s3;
    }, i2.getBerValueLength = function(e4) {
      var t4 = e4.getByte();
      if (t4 !== 128)
        return 128 & t4 ? e4.getInt((127 & t4) << 3) : t4;
    }, i2.fromDer = function(e4, t4) {
      t4 === void 0 && (t4 = { strict: true, parseAllBytes: true, decodeBitStrings: true }), typeof t4 == "boolean" && (t4 = { strict: t4, parseAllBytes: true, decodeBitStrings: true }), "strict" in t4 || (t4.strict = true), "parseAllBytes" in t4 || (t4.parseAllBytes = true), "decodeBitStrings" in t4 || (t4.decodeBitStrings = true), typeof e4 == "string" && (e4 = n3.util.createBuffer(e4));
      var r4 = e4.length(), i3 = s2(e4, e4.length(), 0, t4);
      if (t4.parseAllBytes && e4.length() !== 0) {
        var a7 = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
        throw a7.byteCount = r4, a7.remaining = e4.length(), a7;
      }
      return i3;
    }, i2.toDer = function(e4) {
      var t4 = n3.util.createBuffer(), r4 = e4.tagClass | e4.type, a7 = n3.util.createBuffer(), s3 = false;
      if ("bitStringContents" in e4 && (s3 = true, e4.original && (s3 = i2.equals(e4, e4.original))), s3)
        a7.putBytes(e4.bitStringContents);
      else if (e4.composed) {
        e4.constructed ? r4 |= 32 : a7.putByte(0);
        for (var o2 = 0; o2 < e4.value.length; ++o2)
          e4.value[o2] !== void 0 && a7.putBuffer(i2.toDer(e4.value[o2]));
      } else if (e4.type === i2.Type.BMPSTRING)
        for (o2 = 0; o2 < e4.value.length; ++o2)
          a7.putInt16(e4.value.charCodeAt(o2));
      else
        e4.type === i2.Type.INTEGER && e4.value.length > 1 && (e4.value.charCodeAt(0) === 0 && (128 & e4.value.charCodeAt(1)) == 0 || e4.value.charCodeAt(0) === 255 && (128 & e4.value.charCodeAt(1)) == 128) ? a7.putBytes(e4.value.substr(1)) : a7.putBytes(e4.value);
      if (t4.putByte(r4), a7.length() <= 127)
        t4.putByte(127 & a7.length());
      else {
        var u2 = a7.length(), c2 = "";
        do {
          c2 += String.fromCharCode(255 & u2), u2 >>>= 8;
        } while (u2 > 0);
        for (t4.putByte(128 | c2.length), o2 = c2.length - 1; o2 >= 0; --o2)
          t4.putByte(c2.charCodeAt(o2));
      }
      return t4.putBuffer(a7), t4;
    }, i2.oidToDer = function(e4) {
      var t4, r4, i3, a7, s3 = e4.split("."), o2 = n3.util.createBuffer();
      o2.putByte(40 * parseInt(s3[0], 10) + parseInt(s3[1], 10));
      for (var u2 = 2; u2 < s3.length; ++u2) {
        t4 = true, r4 = [], i3 = parseInt(s3[u2], 10);
        do {
          a7 = 127 & i3, i3 >>>= 7, t4 || (a7 |= 128), r4.push(a7), t4 = false;
        } while (i3 > 0);
        for (var c2 = r4.length - 1; c2 >= 0; --c2)
          o2.putByte(r4[c2]);
      }
      return o2;
    }, i2.derToOid = function(e4) {
      var t4;
      typeof e4 == "string" && (e4 = n3.util.createBuffer(e4));
      var r4 = e4.getByte();
      t4 = Math.floor(r4 / 40) + "." + r4 % 40;
      for (var i3 = 0; e4.length() > 0; )
        i3 <<= 7, 128 & (r4 = e4.getByte()) ? i3 += 127 & r4 : (t4 += "." + (i3 + r4), i3 = 0);
      return t4;
    }, i2.utcTimeToDate = function(e4) {
      var t4 = new Date(), r4 = parseInt(e4.substr(0, 2), 10);
      r4 = r4 >= 50 ? 1900 + r4 : 2e3 + r4;
      var n4 = parseInt(e4.substr(2, 2), 10) - 1, i3 = parseInt(e4.substr(4, 2), 10), a7 = parseInt(e4.substr(6, 2), 10), s3 = parseInt(e4.substr(8, 2), 10), o2 = 0;
      if (e4.length > 11) {
        var u2 = e4.charAt(10), c2 = 10;
        u2 !== "+" && u2 !== "-" && (o2 = parseInt(e4.substr(10, 2), 10), c2 += 2);
      }
      if (t4.setUTCFullYear(r4, n4, i3), t4.setUTCHours(a7, s3, o2, 0), c2 && ((u2 = e4.charAt(c2)) === "+" || u2 === "-")) {
        var l2 = 60 * parseInt(e4.substr(c2 + 1, 2), 10) + parseInt(e4.substr(c2 + 4, 2), 10);
        l2 *= 6e4, u2 === "+" ? t4.setTime(+t4 - l2) : t4.setTime(+t4 + l2);
      }
      return t4;
    }, i2.generalizedTimeToDate = function(e4) {
      var t4 = new Date(), r4 = parseInt(e4.substr(0, 4), 10), n4 = parseInt(e4.substr(4, 2), 10) - 1, i3 = parseInt(e4.substr(6, 2), 10), a7 = parseInt(e4.substr(8, 2), 10), s3 = parseInt(e4.substr(10, 2), 10), o2 = parseInt(e4.substr(12, 2), 10), u2 = 0, c2 = 0, l2 = false;
      e4.charAt(e4.length - 1) === "Z" && (l2 = true);
      var h2 = e4.length - 5, f2 = e4.charAt(h2);
      return f2 !== "+" && f2 !== "-" || (c2 = 60 * parseInt(e4.substr(h2 + 1, 2), 10) + parseInt(e4.substr(h2 + 4, 2), 10), c2 *= 6e4, f2 === "+" && (c2 *= -1), l2 = true), e4.charAt(14) === "." && (u2 = 1e3 * parseFloat(e4.substr(14), 10)), l2 ? (t4.setUTCFullYear(r4, n4, i3), t4.setUTCHours(a7, s3, o2, u2), t4.setTime(+t4 + c2)) : (t4.setFullYear(r4, n4, i3), t4.setHours(a7, s3, o2, u2)), t4;
    }, i2.dateToUtcTime = function(e4) {
      if (typeof e4 == "string")
        return e4;
      var t4 = "", r4 = [];
      r4.push(("" + e4.getUTCFullYear()).substr(2)), r4.push("" + (e4.getUTCMonth() + 1)), r4.push("" + e4.getUTCDate()), r4.push("" + e4.getUTCHours()), r4.push("" + e4.getUTCMinutes()), r4.push("" + e4.getUTCSeconds());
      for (var n4 = 0; n4 < r4.length; ++n4)
        r4[n4].length < 2 && (t4 += "0"), t4 += r4[n4];
      return t4 + "Z";
    }, i2.dateToGeneralizedTime = function(e4) {
      if (typeof e4 == "string")
        return e4;
      var t4 = "", r4 = [];
      r4.push("" + e4.getUTCFullYear()), r4.push("" + (e4.getUTCMonth() + 1)), r4.push("" + e4.getUTCDate()), r4.push("" + e4.getUTCHours()), r4.push("" + e4.getUTCMinutes()), r4.push("" + e4.getUTCSeconds());
      for (var n4 = 0; n4 < r4.length; ++n4)
        r4[n4].length < 2 && (t4 += "0"), t4 += r4[n4];
      return t4 + "Z";
    }, i2.integerToDer = function(e4) {
      var t4 = n3.util.createBuffer();
      if (e4 >= -128 && e4 < 128)
        return t4.putSignedInt(e4, 8);
      if (e4 >= -32768 && e4 < 32768)
        return t4.putSignedInt(e4, 16);
      if (e4 >= -8388608 && e4 < 8388608)
        return t4.putSignedInt(e4, 24);
      if (e4 >= -2147483648 && e4 < 2147483648)
        return t4.putSignedInt(e4, 32);
      var r4 = new Error("Integer too large; max is 32-bits.");
      throw r4.integer = e4, r4;
    }, i2.derToInteger = function(e4) {
      typeof e4 == "string" && (e4 = n3.util.createBuffer(e4));
      var t4 = 8 * e4.length();
      if (t4 > 32)
        throw new Error("Integer too large; max is 32-bits.");
      return e4.getSignedInt(t4);
    }, i2.validate = function(e4, t4, r4, a7) {
      var s3 = false;
      if (e4.tagClass !== t4.tagClass && t4.tagClass !== void 0 || e4.type !== t4.type && t4.type !== void 0)
        a7 && (e4.tagClass !== t4.tagClass && a7.push("[" + t4.name + '] Expected tag class "' + t4.tagClass + '", got "' + e4.tagClass + '"'), e4.type !== t4.type && a7.push("[" + t4.name + '] Expected type "' + t4.type + '", got "' + e4.type + '"'));
      else if (e4.constructed === t4.constructed || t4.constructed === void 0) {
        if (s3 = true, t4.value && n3.util.isArray(t4.value))
          for (var o2 = 0, u2 = 0; s3 && u2 < t4.value.length; ++u2)
            s3 = t4.value[u2].optional || false, e4.value[o2] && ((s3 = i2.validate(e4.value[o2], t4.value[u2], r4, a7)) ? ++o2 : t4.value[u2].optional && (s3 = true)), !s3 && a7 && a7.push("[" + t4.name + '] Tag class "' + t4.tagClass + '", type "' + t4.type + '" expected value length "' + t4.value.length + '", got "' + e4.value.length + '"');
        if (s3 && r4 && (t4.capture && (r4[t4.capture] = e4.value), t4.captureAsn1 && (r4[t4.captureAsn1] = e4), t4.captureBitStringContents && "bitStringContents" in e4 && (r4[t4.captureBitStringContents] = e4.bitStringContents), t4.captureBitStringValue && "bitStringContents" in e4))
          if (e4.bitStringContents.length < 2)
            r4[t4.captureBitStringValue] = "";
          else {
            if (e4.bitStringContents.charCodeAt(0) !== 0)
              throw new Error("captureBitStringValue only supported for zero unused bits");
            r4[t4.captureBitStringValue] = e4.bitStringContents.slice(1);
          }
      } else
        a7 && a7.push("[" + t4.name + '] Expected constructed "' + t4.constructed + '", got "' + e4.constructed + '"');
      return s3;
    };
    var o = /[^\\u0000-\\u00ff]/;
    i2.prettyPrint = function(e4, t4, r4) {
      var a7 = "";
      r4 = r4 || 2, (t4 = t4 || 0) > 0 && (a7 += "\n");
      for (var s3 = "", u2 = 0; u2 < t4 * r4; ++u2)
        s3 += " ";
      switch (a7 += s3 + "Tag: ", e4.tagClass) {
        case i2.Class.UNIVERSAL:
          a7 += "Universal:";
          break;
        case i2.Class.APPLICATION:
          a7 += "Application:";
          break;
        case i2.Class.CONTEXT_SPECIFIC:
          a7 += "Context-Specific:";
          break;
        case i2.Class.PRIVATE:
          a7 += "Private:";
      }
      if (e4.tagClass === i2.Class.UNIVERSAL)
        switch (a7 += e4.type, e4.type) {
          case i2.Type.NONE:
            a7 += " (None)";
            break;
          case i2.Type.BOOLEAN:
            a7 += " (Boolean)";
            break;
          case i2.Type.INTEGER:
            a7 += " (Integer)";
            break;
          case i2.Type.BITSTRING:
            a7 += " (Bit string)";
            break;
          case i2.Type.OCTETSTRING:
            a7 += " (Octet string)";
            break;
          case i2.Type.NULL:
            a7 += " (Null)";
            break;
          case i2.Type.OID:
            a7 += " (Object Identifier)";
            break;
          case i2.Type.ODESC:
            a7 += " (Object Descriptor)";
            break;
          case i2.Type.EXTERNAL:
            a7 += " (External or Instance of)";
            break;
          case i2.Type.REAL:
            a7 += " (Real)";
            break;
          case i2.Type.ENUMERATED:
            a7 += " (Enumerated)";
            break;
          case i2.Type.EMBEDDED:
            a7 += " (Embedded PDV)";
            break;
          case i2.Type.UTF8:
            a7 += " (UTF8)";
            break;
          case i2.Type.ROID:
            a7 += " (Relative Object Identifier)";
            break;
          case i2.Type.SEQUENCE:
            a7 += " (Sequence)";
            break;
          case i2.Type.SET:
            a7 += " (Set)";
            break;
          case i2.Type.PRINTABLESTRING:
            a7 += " (Printable String)";
            break;
          case i2.Type.IA5String:
            a7 += " (IA5String (ASCII))";
            break;
          case i2.Type.UTCTIME:
            a7 += " (UTC time)";
            break;
          case i2.Type.GENERALIZEDTIME:
            a7 += " (Generalized time)";
            break;
          case i2.Type.BMPSTRING:
            a7 += " (BMP String)";
        }
      else
        a7 += e4.type;
      if (a7 += "\n", a7 += s3 + "Constructed: " + e4.constructed + "\n", e4.composed) {
        var c2 = 0, l2 = "";
        for (u2 = 0; u2 < e4.value.length; ++u2)
          e4.value[u2] !== void 0 && (c2 += 1, l2 += i2.prettyPrint(e4.value[u2], t4 + 1, r4), u2 + 1 < e4.value.length && (l2 += ","));
        a7 += s3 + "Sub values: " + c2 + l2;
      } else {
        if (a7 += s3 + "Value: ", e4.type === i2.Type.OID) {
          var h2 = i2.derToOid(e4.value);
          a7 += h2, n3.pki && n3.pki.oids && h2 in n3.pki.oids && (a7 += " (" + n3.pki.oids[h2] + ") ");
        }
        if (e4.type === i2.Type.INTEGER)
          try {
            a7 += i2.derToInteger(e4.value);
          } catch (t5) {
            a7 += "0x" + n3.util.bytesToHex(e4.value);
          }
        else if (e4.type === i2.Type.BITSTRING) {
          if (e4.value.length > 1 ? a7 += "0x" + n3.util.bytesToHex(e4.value.slice(1)) : a7 += "(none)", e4.value.length > 0) {
            var f2 = e4.value.charCodeAt(0);
            f2 == 1 ? a7 += " (1 unused bit shown)" : f2 > 1 && (a7 += " (" + f2 + " unused bits shown)");
          }
        } else if (e4.type === i2.Type.OCTETSTRING)
          o.test(e4.value) || (a7 += "(" + e4.value + ") "), a7 += "0x" + n3.util.bytesToHex(e4.value);
        else if (e4.type === i2.Type.UTF8)
          try {
            a7 += n3.util.decodeUtf8(e4.value);
          } catch (t5) {
            if (t5.message !== "URI malformed")
              throw t5;
            a7 += "0x" + n3.util.bytesToHex(e4.value) + " (malformed UTF8)";
          }
        else
          e4.type === i2.Type.PRINTABLESTRING || e4.type === i2.Type.IA5String ? a7 += e4.value : o.test(e4.value) ? a7 += "0x" + n3.util.bytesToHex(e4.value) : e4.value.length === 0 ? a7 += "[null]" : a7 += e4.value;
      }
      return a7;
    };
  }, 7858: (e3, t3, r3) => {
    var n3 = r3(7573).Buffer, i2 = {};
    e3.exports = i2;
    var a6 = {};
    i2.encode = function(e4, t4, r4) {
      if (typeof t4 != "string")
        throw new TypeError('"alphabet" must be a string.');
      if (r4 !== void 0 && typeof r4 != "number")
        throw new TypeError('"maxline" must be a number.');
      var n4 = "";
      if (e4 instanceof Uint8Array) {
        var i3 = 0, a7 = t4.length, s2 = t4.charAt(0), o = [0];
        for (i3 = 0; i3 < e4.length; ++i3) {
          for (var u2 = 0, c2 = e4[i3]; u2 < o.length; ++u2)
            c2 += o[u2] << 8, o[u2] = c2 % a7, c2 = c2 / a7 | 0;
          for (; c2 > 0; )
            o.push(c2 % a7), c2 = c2 / a7 | 0;
        }
        for (i3 = 0; e4[i3] === 0 && i3 < e4.length - 1; ++i3)
          n4 += s2;
        for (i3 = o.length - 1; i3 >= 0; --i3)
          n4 += t4[o[i3]];
      } else
        n4 = function(e5, t5) {
          var r5 = 0, n5 = t5.length, i4 = t5.charAt(0), a8 = [0];
          for (r5 = 0; r5 < e5.length(); ++r5) {
            for (var s3 = 0, o2 = e5.at(r5); s3 < a8.length; ++s3)
              o2 += a8[s3] << 8, a8[s3] = o2 % n5, o2 = o2 / n5 | 0;
            for (; o2 > 0; )
              a8.push(o2 % n5), o2 = o2 / n5 | 0;
          }
          var u3 = "";
          for (r5 = 0; e5.at(r5) === 0 && r5 < e5.length() - 1; ++r5)
            u3 += i4;
          for (r5 = a8.length - 1; r5 >= 0; --r5)
            u3 += t5[a8[r5]];
          return u3;
        }(e4, t4);
      if (r4) {
        var l2 = new RegExp(".{1," + r4 + "}", "g");
        n4 = n4.match(l2).join("\r\n");
      }
      return n4;
    }, i2.decode = function(e4, t4) {
      if (typeof e4 != "string")
        throw new TypeError('"input" must be a string.');
      if (typeof t4 != "string")
        throw new TypeError('"alphabet" must be a string.');
      var r4 = a6[t4];
      if (!r4) {
        r4 = a6[t4] = [];
        for (var i3 = 0; i3 < t4.length; ++i3)
          r4[t4.charCodeAt(i3)] = i3;
      }
      e4 = e4.replace(/\s/g, "");
      var s2 = t4.length, o = t4.charAt(0), u2 = [0];
      for (i3 = 0; i3 < e4.length; i3++) {
        var c2 = r4[e4.charCodeAt(i3)];
        if (c2 === void 0)
          return;
        for (var l2 = 0, h2 = c2; l2 < u2.length; ++l2)
          h2 += u2[l2] * s2, u2[l2] = 255 & h2, h2 >>= 8;
        for (; h2 > 0; )
          u2.push(255 & h2), h2 >>= 8;
      }
      for (var f2 = 0; e4[f2] === o && f2 < e4.length - 1; ++f2)
        u2.push(0);
      return n3 !== void 0 ? n3.from(u2.reverse()) : new Uint8Array(u2.reverse());
    };
  }, 4609: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), e3.exports = n3.cipher = n3.cipher || {}, n3.cipher.algorithms = n3.cipher.algorithms || {}, n3.cipher.createCipher = function(e4, t4) {
      var r4 = e4;
      if (typeof r4 == "string" && (r4 = n3.cipher.getAlgorithm(r4)) && (r4 = r4()), !r4)
        throw new Error("Unsupported algorithm: " + e4);
      return new n3.cipher.BlockCipher({ algorithm: r4, key: t4, decrypt: false });
    }, n3.cipher.createDecipher = function(e4, t4) {
      var r4 = e4;
      if (typeof r4 == "string" && (r4 = n3.cipher.getAlgorithm(r4)) && (r4 = r4()), !r4)
        throw new Error("Unsupported algorithm: " + e4);
      return new n3.cipher.BlockCipher({ algorithm: r4, key: t4, decrypt: true });
    }, n3.cipher.registerAlgorithm = function(e4, t4) {
      e4 = e4.toUpperCase(), n3.cipher.algorithms[e4] = t4;
    }, n3.cipher.getAlgorithm = function(e4) {
      return (e4 = e4.toUpperCase()) in n3.cipher.algorithms ? n3.cipher.algorithms[e4] : null;
    };
    var i2 = n3.cipher.BlockCipher = function(e4) {
      this.algorithm = e4.algorithm, this.mode = this.algorithm.mode, this.blockSize = this.mode.blockSize, this._finish = false, this._input = null, this.output = null, this._op = e4.decrypt ? this.mode.decrypt : this.mode.encrypt, this._decrypt = e4.decrypt, this.algorithm.initialize(e4);
    };
    i2.prototype.start = function(e4) {
      e4 = e4 || {};
      var t4 = {};
      for (var r4 in e4)
        t4[r4] = e4[r4];
      t4.decrypt = this._decrypt, this._finish = false, this._input = n3.util.createBuffer(), this.output = e4.output || n3.util.createBuffer(), this.mode.start(t4);
    }, i2.prototype.update = function(e4) {
      for (e4 && this._input.putBuffer(e4); !this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish; )
        ;
      this._input.compact();
    }, i2.prototype.finish = function(e4) {
      !e4 || this.mode.name !== "ECB" && this.mode.name !== "CBC" || (this.mode.pad = function(t5) {
        return e4(this.blockSize, t5, false);
      }, this.mode.unpad = function(t5) {
        return e4(this.blockSize, t5, true);
      });
      var t4 = {};
      return t4.decrypt = this._decrypt, t4.overflow = this._input.length() % this.blockSize, !(!this._decrypt && this.mode.pad && !this.mode.pad(this._input, t4) || (this._finish = true, this.update(), this._decrypt && this.mode.unpad && !this.mode.unpad(this.output, t4) || this.mode.afterFinish && !this.mode.afterFinish(this.output, t4)));
    };
  }, 9554: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), n3.cipher = n3.cipher || {};
    var i2 = e3.exports = n3.cipher.modes = n3.cipher.modes || {};
    function a6(e4, t4) {
      if (typeof e4 == "string" && (e4 = n3.util.createBuffer(e4)), n3.util.isArray(e4) && e4.length > 4) {
        var r4 = e4;
        e4 = n3.util.createBuffer();
        for (var i3 = 0; i3 < r4.length; ++i3)
          e4.putByte(r4[i3]);
      }
      if (e4.length() < t4)
        throw new Error("Invalid IV length; got " + e4.length() + " bytes and expected " + t4 + " bytes.");
      if (!n3.util.isArray(e4)) {
        var a7 = [], s3 = t4 / 4;
        for (i3 = 0; i3 < s3; ++i3)
          a7.push(e4.getInt32());
        e4 = a7;
      }
      return e4;
    }
    function s2(e4) {
      e4[e4.length - 1] = e4[e4.length - 1] + 1 & 4294967295;
    }
    function o(e4) {
      return [e4 / 4294967296 | 0, 4294967295 & e4];
    }
    i2.ecb = function(e4) {
      e4 = e4 || {}, this.name = "ECB", this.cipher = e4.cipher, this.blockSize = e4.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
    }, i2.ecb.prototype.start = function(e4) {
    }, i2.ecb.prototype.encrypt = function(e4, t4, r4) {
      if (e4.length() < this.blockSize && !(r4 && e4.length() > 0))
        return true;
      for (var n4 = 0; n4 < this._ints; ++n4)
        this._inBlock[n4] = e4.getInt32();
      for (this.cipher.encrypt(this._inBlock, this._outBlock), n4 = 0; n4 < this._ints; ++n4)
        t4.putInt32(this._outBlock[n4]);
    }, i2.ecb.prototype.decrypt = function(e4, t4, r4) {
      if (e4.length() < this.blockSize && !(r4 && e4.length() > 0))
        return true;
      for (var n4 = 0; n4 < this._ints; ++n4)
        this._inBlock[n4] = e4.getInt32();
      for (this.cipher.decrypt(this._inBlock, this._outBlock), n4 = 0; n4 < this._ints; ++n4)
        t4.putInt32(this._outBlock[n4]);
    }, i2.ecb.prototype.pad = function(e4, t4) {
      var r4 = e4.length() === this.blockSize ? this.blockSize : this.blockSize - e4.length();
      return e4.fillWithByte(r4, r4), true;
    }, i2.ecb.prototype.unpad = function(e4, t4) {
      if (t4.overflow > 0)
        return false;
      var r4 = e4.length(), n4 = e4.at(r4 - 1);
      return !(n4 > this.blockSize << 2 || (e4.truncate(n4), 0));
    }, i2.cbc = function(e4) {
      e4 = e4 || {}, this.name = "CBC", this.cipher = e4.cipher, this.blockSize = e4.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
    }, i2.cbc.prototype.start = function(e4) {
      if (e4.iv === null) {
        if (!this._prev)
          throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
      } else {
        if (!("iv" in e4))
          throw new Error("Invalid IV parameter.");
        this._iv = a6(e4.iv, this.blockSize), this._prev = this._iv.slice(0);
      }
    }, i2.cbc.prototype.encrypt = function(e4, t4, r4) {
      if (e4.length() < this.blockSize && !(r4 && e4.length() > 0))
        return true;
      for (var n4 = 0; n4 < this._ints; ++n4)
        this._inBlock[n4] = this._prev[n4] ^ e4.getInt32();
      for (this.cipher.encrypt(this._inBlock, this._outBlock), n4 = 0; n4 < this._ints; ++n4)
        t4.putInt32(this._outBlock[n4]);
      this._prev = this._outBlock;
    }, i2.cbc.prototype.decrypt = function(e4, t4, r4) {
      if (e4.length() < this.blockSize && !(r4 && e4.length() > 0))
        return true;
      for (var n4 = 0; n4 < this._ints; ++n4)
        this._inBlock[n4] = e4.getInt32();
      for (this.cipher.decrypt(this._inBlock, this._outBlock), n4 = 0; n4 < this._ints; ++n4)
        t4.putInt32(this._prev[n4] ^ this._outBlock[n4]);
      this._prev = this._inBlock.slice(0);
    }, i2.cbc.prototype.pad = function(e4, t4) {
      var r4 = e4.length() === this.blockSize ? this.blockSize : this.blockSize - e4.length();
      return e4.fillWithByte(r4, r4), true;
    }, i2.cbc.prototype.unpad = function(e4, t4) {
      if (t4.overflow > 0)
        return false;
      var r4 = e4.length(), n4 = e4.at(r4 - 1);
      return !(n4 > this.blockSize << 2 || (e4.truncate(n4), 0));
    }, i2.cfb = function(e4) {
      e4 = e4 || {}, this.name = "CFB", this.cipher = e4.cipher, this.blockSize = e4.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialBlock = new Array(this._ints), this._partialOutput = n3.util.createBuffer(), this._partialBytes = 0;
    }, i2.cfb.prototype.start = function(e4) {
      if (!("iv" in e4))
        throw new Error("Invalid IV parameter.");
      this._iv = a6(e4.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, i2.cfb.prototype.encrypt = function(e4, t4, r4) {
      var n4 = e4.length();
      if (n4 === 0)
        return true;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && n4 >= this.blockSize)
        for (var i3 = 0; i3 < this._ints; ++i3)
          this._inBlock[i3] = e4.getInt32() ^ this._outBlock[i3], t4.putInt32(this._inBlock[i3]);
      else {
        var a7 = (this.blockSize - n4) % this.blockSize;
        for (a7 > 0 && (a7 = this.blockSize - a7), this._partialOutput.clear(), i3 = 0; i3 < this._ints; ++i3)
          this._partialBlock[i3] = e4.getInt32() ^ this._outBlock[i3], this._partialOutput.putInt32(this._partialBlock[i3]);
        if (a7 > 0)
          e4.read -= this.blockSize;
        else
          for (i3 = 0; i3 < this._ints; ++i3)
            this._inBlock[i3] = this._partialBlock[i3];
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a7 > 0 && !r4)
          return t4.putBytes(this._partialOutput.getBytes(a7 - this._partialBytes)), this._partialBytes = a7, true;
        t4.putBytes(this._partialOutput.getBytes(n4 - this._partialBytes)), this._partialBytes = 0;
      }
    }, i2.cfb.prototype.decrypt = function(e4, t4, r4) {
      var n4 = e4.length();
      if (n4 === 0)
        return true;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && n4 >= this.blockSize)
        for (var i3 = 0; i3 < this._ints; ++i3)
          this._inBlock[i3] = e4.getInt32(), t4.putInt32(this._inBlock[i3] ^ this._outBlock[i3]);
      else {
        var a7 = (this.blockSize - n4) % this.blockSize;
        for (a7 > 0 && (a7 = this.blockSize - a7), this._partialOutput.clear(), i3 = 0; i3 < this._ints; ++i3)
          this._partialBlock[i3] = e4.getInt32(), this._partialOutput.putInt32(this._partialBlock[i3] ^ this._outBlock[i3]);
        if (a7 > 0)
          e4.read -= this.blockSize;
        else
          for (i3 = 0; i3 < this._ints; ++i3)
            this._inBlock[i3] = this._partialBlock[i3];
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a7 > 0 && !r4)
          return t4.putBytes(this._partialOutput.getBytes(a7 - this._partialBytes)), this._partialBytes = a7, true;
        t4.putBytes(this._partialOutput.getBytes(n4 - this._partialBytes)), this._partialBytes = 0;
      }
    }, i2.ofb = function(e4) {
      e4 = e4 || {}, this.name = "OFB", this.cipher = e4.cipher, this.blockSize = e4.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = n3.util.createBuffer(), this._partialBytes = 0;
    }, i2.ofb.prototype.start = function(e4) {
      if (!("iv" in e4))
        throw new Error("Invalid IV parameter.");
      this._iv = a6(e4.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, i2.ofb.prototype.encrypt = function(e4, t4, r4) {
      var n4 = e4.length();
      if (e4.length() === 0)
        return true;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && n4 >= this.blockSize)
        for (var i3 = 0; i3 < this._ints; ++i3)
          t4.putInt32(e4.getInt32() ^ this._outBlock[i3]), this._inBlock[i3] = this._outBlock[i3];
      else {
        var a7 = (this.blockSize - n4) % this.blockSize;
        for (a7 > 0 && (a7 = this.blockSize - a7), this._partialOutput.clear(), i3 = 0; i3 < this._ints; ++i3)
          this._partialOutput.putInt32(e4.getInt32() ^ this._outBlock[i3]);
        if (a7 > 0)
          e4.read -= this.blockSize;
        else
          for (i3 = 0; i3 < this._ints; ++i3)
            this._inBlock[i3] = this._outBlock[i3];
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a7 > 0 && !r4)
          return t4.putBytes(this._partialOutput.getBytes(a7 - this._partialBytes)), this._partialBytes = a7, true;
        t4.putBytes(this._partialOutput.getBytes(n4 - this._partialBytes)), this._partialBytes = 0;
      }
    }, i2.ofb.prototype.decrypt = i2.ofb.prototype.encrypt, i2.ctr = function(e4) {
      e4 = e4 || {}, this.name = "CTR", this.cipher = e4.cipher, this.blockSize = e4.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = n3.util.createBuffer(), this._partialBytes = 0;
    }, i2.ctr.prototype.start = function(e4) {
      if (!("iv" in e4))
        throw new Error("Invalid IV parameter.");
      this._iv = a6(e4.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, i2.ctr.prototype.encrypt = function(e4, t4, r4) {
      var n4 = e4.length();
      if (n4 === 0)
        return true;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && n4 >= this.blockSize)
        for (var i3 = 0; i3 < this._ints; ++i3)
          t4.putInt32(e4.getInt32() ^ this._outBlock[i3]);
      else {
        var a7 = (this.blockSize - n4) % this.blockSize;
        for (a7 > 0 && (a7 = this.blockSize - a7), this._partialOutput.clear(), i3 = 0; i3 < this._ints; ++i3)
          this._partialOutput.putInt32(e4.getInt32() ^ this._outBlock[i3]);
        if (a7 > 0 && (e4.read -= this.blockSize), this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a7 > 0 && !r4)
          return t4.putBytes(this._partialOutput.getBytes(a7 - this._partialBytes)), this._partialBytes = a7, true;
        t4.putBytes(this._partialOutput.getBytes(n4 - this._partialBytes)), this._partialBytes = 0;
      }
      s2(this._inBlock);
    }, i2.ctr.prototype.decrypt = i2.ctr.prototype.encrypt, i2.gcm = function(e4) {
      e4 = e4 || {}, this.name = "GCM", this.cipher = e4.cipher, this.blockSize = e4.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints), this._partialOutput = n3.util.createBuffer(), this._partialBytes = 0, this._R = 3774873600;
    }, i2.gcm.prototype.start = function(e4) {
      if (!("iv" in e4))
        throw new Error("Invalid IV parameter.");
      var t4, r4 = n3.util.createBuffer(e4.iv);
      if (this._cipherLength = 0, t4 = "additionalData" in e4 ? n3.util.createBuffer(e4.additionalData) : n3.util.createBuffer(), this._tagLength = "tagLength" in e4 ? e4.tagLength : 128, this._tag = null, e4.decrypt && (this._tag = n3.util.createBuffer(e4.tag).getBytes(), this._tag.length !== this._tagLength / 8))
        throw new Error("Authentication tag does not match tag length.");
      this._hashBlock = new Array(this._ints), this.tag = null, this._hashSubkey = new Array(this._ints), this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey), this.componentBits = 4, this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
      var i3 = r4.length();
      if (i3 === 12)
        this._j0 = [r4.getInt32(), r4.getInt32(), r4.getInt32(), 1];
      else {
        for (this._j0 = [0, 0, 0, 0]; r4.length() > 0; )
          this._j0 = this.ghash(this._hashSubkey, this._j0, [r4.getInt32(), r4.getInt32(), r4.getInt32(), r4.getInt32()]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [0, 0].concat(o(8 * i3)));
      }
      this._inBlock = this._j0.slice(0), s2(this._inBlock), this._partialBytes = 0, t4 = n3.util.createBuffer(t4), this._aDataLength = o(8 * t4.length());
      var a7 = t4.length() % this.blockSize;
      for (a7 && t4.fillWithByte(0, this.blockSize - a7), this._s = [0, 0, 0, 0]; t4.length() > 0; )
        this._s = this.ghash(this._hashSubkey, this._s, [t4.getInt32(), t4.getInt32(), t4.getInt32(), t4.getInt32()]);
    }, i2.gcm.prototype.encrypt = function(e4, t4, r4) {
      var n4 = e4.length();
      if (n4 === 0)
        return true;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && n4 >= this.blockSize) {
        for (var i3 = 0; i3 < this._ints; ++i3)
          t4.putInt32(this._outBlock[i3] ^= e4.getInt32());
        this._cipherLength += this.blockSize;
      } else {
        var a7 = (this.blockSize - n4) % this.blockSize;
        for (a7 > 0 && (a7 = this.blockSize - a7), this._partialOutput.clear(), i3 = 0; i3 < this._ints; ++i3)
          this._partialOutput.putInt32(e4.getInt32() ^ this._outBlock[i3]);
        if (a7 <= 0 || r4) {
          if (r4) {
            var o2 = n4 % this.blockSize;
            this._cipherLength += o2, this._partialOutput.truncate(this.blockSize - o2);
          } else
            this._cipherLength += this.blockSize;
          for (i3 = 0; i3 < this._ints; ++i3)
            this._outBlock[i3] = this._partialOutput.getInt32();
          this._partialOutput.read -= this.blockSize;
        }
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a7 > 0 && !r4)
          return e4.read -= this.blockSize, t4.putBytes(this._partialOutput.getBytes(a7 - this._partialBytes)), this._partialBytes = a7, true;
        t4.putBytes(this._partialOutput.getBytes(n4 - this._partialBytes)), this._partialBytes = 0;
      }
      this._s = this.ghash(this._hashSubkey, this._s, this._outBlock), s2(this._inBlock);
    }, i2.gcm.prototype.decrypt = function(e4, t4, r4) {
      var n4 = e4.length();
      if (n4 < this.blockSize && !(r4 && n4 > 0))
        return true;
      this.cipher.encrypt(this._inBlock, this._outBlock), s2(this._inBlock), this._hashBlock[0] = e4.getInt32(), this._hashBlock[1] = e4.getInt32(), this._hashBlock[2] = e4.getInt32(), this._hashBlock[3] = e4.getInt32(), this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
      for (var i3 = 0; i3 < this._ints; ++i3)
        t4.putInt32(this._outBlock[i3] ^ this._hashBlock[i3]);
      n4 < this.blockSize ? this._cipherLength += n4 % this.blockSize : this._cipherLength += this.blockSize;
    }, i2.gcm.prototype.afterFinish = function(e4, t4) {
      var r4 = true;
      t4.decrypt && t4.overflow && e4.truncate(this.blockSize - t4.overflow), this.tag = n3.util.createBuffer();
      var i3 = this._aDataLength.concat(o(8 * this._cipherLength));
      this._s = this.ghash(this._hashSubkey, this._s, i3);
      var a7 = [];
      this.cipher.encrypt(this._j0, a7);
      for (var s3 = 0; s3 < this._ints; ++s3)
        this.tag.putInt32(this._s[s3] ^ a7[s3]);
      return this.tag.truncate(this.tag.length() % (this._tagLength / 8)), t4.decrypt && this.tag.bytes() !== this._tag && (r4 = false), r4;
    }, i2.gcm.prototype.multiply = function(e4, t4) {
      for (var r4 = [0, 0, 0, 0], n4 = t4.slice(0), i3 = 0; i3 < 128; ++i3)
        e4[i3 / 32 | 0] & 1 << 31 - i3 % 32 && (r4[0] ^= n4[0], r4[1] ^= n4[1], r4[2] ^= n4[2], r4[3] ^= n4[3]), this.pow(n4, n4);
      return r4;
    }, i2.gcm.prototype.pow = function(e4, t4) {
      for (var r4 = 1 & e4[3], n4 = 3; n4 > 0; --n4)
        t4[n4] = e4[n4] >>> 1 | (1 & e4[n4 - 1]) << 31;
      t4[0] = e4[0] >>> 1, r4 && (t4[0] ^= this._R);
    }, i2.gcm.prototype.tableMultiply = function(e4) {
      for (var t4 = [0, 0, 0, 0], r4 = 0; r4 < 32; ++r4) {
        var n4 = e4[r4 / 8 | 0] >>> 4 * (7 - r4 % 8) & 15, i3 = this._m[r4][n4];
        t4[0] ^= i3[0], t4[1] ^= i3[1], t4[2] ^= i3[2], t4[3] ^= i3[3];
      }
      return t4;
    }, i2.gcm.prototype.ghash = function(e4, t4, r4) {
      return t4[0] ^= r4[0], t4[1] ^= r4[1], t4[2] ^= r4[2], t4[3] ^= r4[3], this.tableMultiply(t4);
    }, i2.gcm.prototype.generateHashTable = function(e4, t4) {
      for (var r4 = 8 / t4, n4 = 4 * r4, i3 = 16 * r4, a7 = new Array(i3), s3 = 0; s3 < i3; ++s3) {
        var o2 = [0, 0, 0, 0], u2 = (n4 - 1 - s3 % n4) * t4;
        o2[s3 / n4 | 0] = 1 << t4 - 1 << u2, a7[s3] = this.generateSubHashTable(this.multiply(o2, e4), t4);
      }
      return a7;
    }, i2.gcm.prototype.generateSubHashTable = function(e4, t4) {
      var r4 = 1 << t4, n4 = r4 >>> 1, i3 = new Array(r4);
      i3[n4] = e4.slice(0);
      for (var a7 = n4 >>> 1; a7 > 0; )
        this.pow(i3[2 * a7], i3[a7] = []), a7 >>= 1;
      for (a7 = 2; a7 < n4; ) {
        for (var s3 = 1; s3 < a7; ++s3) {
          var o2 = i3[a7], u2 = i3[s3];
          i3[a7 + s3] = [o2[0] ^ u2[0], o2[1] ^ u2[1], o2[2] ^ u2[2], o2[3] ^ u2[3]];
        }
        a7 *= 2;
      }
      for (i3[0] = [0, 0, 0, 0], a7 = n4 + 1; a7 < r4; ++a7) {
        var c2 = i3[a7 ^ n4];
        i3[a7] = [e4[0] ^ c2[0], e4[1] ^ c2[1], e4[2] ^ c2[2], e4[3] ^ c2[3]];
      }
      return i3;
    };
  }, 2023: (e3, t3, r3) => {
    var n3 = r3(7768);
    function i2(e4, t4) {
      n3.cipher.registerAlgorithm(e4, function() {
        return new n3.des.Algorithm(e4, t4);
      });
    }
    r3(4609), r3(9554), r3(3103), e3.exports = n3.des = n3.des || {}, n3.des.startEncrypting = function(e4, t4, r4, n4) {
      var i3 = d2({ key: e4, output: r4, decrypt: false, mode: n4 || (t4 === null ? "ECB" : "CBC") });
      return i3.start(t4), i3;
    }, n3.des.createEncryptionCipher = function(e4, t4) {
      return d2({ key: e4, output: null, decrypt: false, mode: t4 });
    }, n3.des.startDecrypting = function(e4, t4, r4, n4) {
      var i3 = d2({ key: e4, output: r4, decrypt: true, mode: n4 || (t4 === null ? "ECB" : "CBC") });
      return i3.start(t4), i3;
    }, n3.des.createDecryptionCipher = function(e4, t4) {
      return d2({ key: e4, output: null, decrypt: true, mode: t4 });
    }, n3.des.Algorithm = function(e4, t4) {
      var r4 = this;
      r4.name = e4, r4.mode = new t4({ blockSize: 8, cipher: { encrypt: function(e5, t5) {
        return p2(r4._keys, e5, t5, false);
      }, decrypt: function(e5, t5) {
        return p2(r4._keys, e5, t5, true);
      } } }), r4._init = false;
    }, n3.des.Algorithm.prototype.initialize = function(e4) {
      if (!this._init) {
        var t4 = n3.util.createBuffer(e4.key);
        if (this.name.indexOf("3DES") === 0 && t4.length() !== 24)
          throw new Error("Invalid Triple-DES key size: " + 8 * t4.length());
        this._keys = function(e5) {
          for (var t5, r4 = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], n4 = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], i3 = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], a7 = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], s3 = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], o2 = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], u3 = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], c3 = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], l3 = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], h3 = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], f3 = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], p3 = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], d3 = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], g2 = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261], y2 = e5.length() > 8 ? 3 : 1, v2 = [], m2 = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0], E2 = 0, C = 0; C < y2; C++) {
            var S2 = e5.getInt32(), b2 = e5.getInt32();
            S2 ^= (t5 = 252645135 & (S2 >>> 4 ^ b2)) << 4, S2 ^= t5 = 65535 & ((b2 ^= t5) >>> -16 ^ S2), S2 ^= (t5 = 858993459 & (S2 >>> 2 ^ (b2 ^= t5 << -16))) << 2, S2 ^= t5 = 65535 & ((b2 ^= t5) >>> -16 ^ S2), S2 ^= (t5 = 1431655765 & (S2 >>> 1 ^ (b2 ^= t5 << -16))) << 1, S2 ^= t5 = 16711935 & ((b2 ^= t5) >>> 8 ^ S2), t5 = (S2 ^= (t5 = 1431655765 & (S2 >>> 1 ^ (b2 ^= t5 << 8))) << 1) << 8 | (b2 ^= t5) >>> 20 & 240, S2 = b2 << 24 | b2 << 8 & 16711680 | b2 >>> 8 & 65280 | b2 >>> 24 & 240, b2 = t5;
            for (var T2 = 0; T2 < m2.length; ++T2) {
              m2[T2] ? (S2 = S2 << 2 | S2 >>> 26, b2 = b2 << 2 | b2 >>> 26) : (S2 = S2 << 1 | S2 >>> 27, b2 = b2 << 1 | b2 >>> 27);
              var _24 = r4[(S2 &= -15) >>> 28] | n4[S2 >>> 24 & 15] | i3[S2 >>> 20 & 15] | a7[S2 >>> 16 & 15] | s3[S2 >>> 12 & 15] | o2[S2 >>> 8 & 15] | u3[S2 >>> 4 & 15], I2 = c3[(b2 &= -15) >>> 28] | l3[b2 >>> 24 & 15] | h3[b2 >>> 20 & 15] | f3[b2 >>> 16 & 15] | p3[b2 >>> 12 & 15] | d3[b2 >>> 8 & 15] | g2[b2 >>> 4 & 15];
              t5 = 65535 & (I2 >>> 16 ^ _24), v2[E2++] = _24 ^ t5, v2[E2++] = I2 ^ t5 << 16;
            }
          }
          return v2;
        }(t4), this._init = true;
      }
    }, i2("DES-ECB", n3.cipher.modes.ecb), i2("DES-CBC", n3.cipher.modes.cbc), i2("DES-CFB", n3.cipher.modes.cfb), i2("DES-OFB", n3.cipher.modes.ofb), i2("DES-CTR", n3.cipher.modes.ctr), i2("3DES-ECB", n3.cipher.modes.ecb), i2("3DES-CBC", n3.cipher.modes.cbc), i2("3DES-CFB", n3.cipher.modes.cfb), i2("3DES-OFB", n3.cipher.modes.ofb), i2("3DES-CTR", n3.cipher.modes.ctr);
    var a6 = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756], s2 = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344], o = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584], u2 = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928], c2 = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080], l2 = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312], h2 = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154], f2 = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];
    function p2(e4, t4, r4, n4) {
      var i3, p3, d3 = e4.length === 32 ? 3 : 9;
      i3 = d3 === 3 ? n4 ? [30, -2, -2] : [0, 32, 2] : n4 ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
      var g2 = t4[0], y2 = t4[1];
      g2 ^= (p3 = 252645135 & (g2 >>> 4 ^ y2)) << 4, g2 ^= (p3 = 65535 & (g2 >>> 16 ^ (y2 ^= p3))) << 16, g2 ^= p3 = 858993459 & ((y2 ^= p3) >>> 2 ^ g2), g2 ^= p3 = 16711935 & ((y2 ^= p3 << 2) >>> 8 ^ g2), g2 = (g2 ^= (p3 = 1431655765 & (g2 >>> 1 ^ (y2 ^= p3 << 8))) << 1) << 1 | g2 >>> 31, y2 = (y2 ^= p3) << 1 | y2 >>> 31;
      for (var v2 = 0; v2 < d3; v2 += 3) {
        for (var m2 = i3[v2 + 1], E2 = i3[v2 + 2], C = i3[v2]; C != m2; C += E2) {
          var S2 = y2 ^ e4[C], b2 = (y2 >>> 4 | y2 << 28) ^ e4[C + 1];
          p3 = g2, g2 = y2, y2 = p3 ^ (s2[S2 >>> 24 & 63] | u2[S2 >>> 16 & 63] | l2[S2 >>> 8 & 63] | f2[63 & S2] | a6[b2 >>> 24 & 63] | o[b2 >>> 16 & 63] | c2[b2 >>> 8 & 63] | h2[63 & b2]);
        }
        p3 = g2, g2 = y2, y2 = p3;
      }
      y2 = y2 >>> 1 | y2 << 31, y2 ^= p3 = 1431655765 & ((g2 = g2 >>> 1 | g2 << 31) >>> 1 ^ y2), y2 ^= (p3 = 16711935 & (y2 >>> 8 ^ (g2 ^= p3 << 1))) << 8, y2 ^= (p3 = 858993459 & (y2 >>> 2 ^ (g2 ^= p3))) << 2, y2 ^= p3 = 65535 & ((g2 ^= p3) >>> 16 ^ y2), y2 ^= p3 = 252645135 & ((g2 ^= p3 << 16) >>> 4 ^ y2), g2 ^= p3 << 4, r4[0] = g2, r4[1] = y2;
    }
    function d2(e4) {
      var t4, r4 = "DES-" + ((e4 = e4 || {}).mode || "CBC").toUpperCase(), i3 = (t4 = e4.decrypt ? n3.cipher.createDecipher(r4, e4.key) : n3.cipher.createCipher(r4, e4.key)).start;
      return t4.start = function(e5, r5) {
        var a7 = null;
        r5 instanceof n3.util.ByteBuffer && (a7 = r5, r5 = {}), (r5 = r5 || {}).output = a7, r5.iv = e5, i3.call(t4, r5);
      }, t4;
    }
  }, 2554: (e3, t3, r3) => {
    var n3 = r3(7573).Buffer, i2 = r3(7768);
    r3(1633), r3(4097), r3(8672), r3(3103);
    var a6 = r3(5235), s2 = a6.publicKeyValidator, o = a6.privateKeyValidator;
    if (u2 === void 0)
      var u2 = i2.jsbn.BigInteger;
    var c2 = i2.util.ByteBuffer, l2 = n3 === void 0 ? Uint8Array : n3;
    i2.pki = i2.pki || {}, e3.exports = i2.pki.ed25519 = i2.ed25519 = i2.ed25519 || {};
    var h2 = i2.ed25519;
    function f2(e4) {
      var t4 = e4.message;
      if (t4 instanceof Uint8Array || t4 instanceof l2)
        return t4;
      var r4 = e4.encoding;
      if (t4 === void 0) {
        if (!e4.md)
          throw new TypeError('"options.message" or "options.md" not specified.');
        t4 = e4.md.digest().getBytes(), r4 = "binary";
      }
      if (typeof t4 == "string" && !r4)
        throw new TypeError('"options.encoding" must be "binary" or "utf8".');
      if (typeof t4 == "string") {
        if (n3 !== void 0)
          return n3.from(t4, r4);
        t4 = new c2(t4, r4);
      } else if (!(t4 instanceof c2))
        throw new TypeError('"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.');
      for (var i3 = new l2(t4.length()), a7 = 0; a7 < i3.length; ++a7)
        i3[a7] = t4.at(a7);
      return i3;
    }
    h2.constants = {}, h2.constants.PUBLIC_KEY_BYTE_LENGTH = 32, h2.constants.PRIVATE_KEY_BYTE_LENGTH = 64, h2.constants.SEED_BYTE_LENGTH = 32, h2.constants.SIGN_BYTE_LENGTH = 64, h2.constants.HASH_BYTE_LENGTH = 64, h2.generateKeyPair = function(e4) {
      var t4 = (e4 = e4 || {}).seed;
      if (t4 === void 0)
        t4 = i2.random.getBytesSync(h2.constants.SEED_BYTE_LENGTH);
      else if (typeof t4 == "string") {
        if (t4.length !== h2.constants.SEED_BYTE_LENGTH)
          throw new TypeError('"seed" must be ' + h2.constants.SEED_BYTE_LENGTH + " bytes in length.");
      } else if (!(t4 instanceof Uint8Array))
        throw new TypeError('"seed" must be a node.js Buffer, Uint8Array, or a binary string.');
      t4 = f2({ message: t4, encoding: "binary" });
      for (var r4 = new l2(h2.constants.PUBLIC_KEY_BYTE_LENGTH), n4 = new l2(h2.constants.PRIVATE_KEY_BYTE_LENGTH), a7 = 0; a7 < 32; ++a7)
        n4[a7] = t4[a7];
      return function(e5, t5) {
        var r5, n5 = [O(), O(), O(), O()], i3 = S2(t5, 32);
        for (i3[0] &= 248, i3[31] &= 127, i3[31] |= 64, k3(n5, i3), A2(e5, n5), r5 = 0; r5 < 32; ++r5)
          t5[r5 + 32] = e5[r5];
      }(r4, n4), { publicKey: r4, privateKey: n4 };
    }, h2.privateKeyFromAsn1 = function(e4) {
      var t4 = {}, r4 = [];
      if (!i2.asn1.validate(e4, o, t4, r4)) {
        var n4 = new Error("Invalid Key.");
        throw n4.errors = r4, n4;
      }
      var a7 = i2.asn1.derToOid(t4.privateKeyOid), s3 = i2.oids.EdDSA25519;
      if (a7 !== s3)
        throw new Error('Invalid OID "' + a7 + '"; OID must be "' + s3 + '".');
      var u3 = t4.privateKey;
      return { privateKeyBytes: f2({ message: i2.asn1.fromDer(u3).value, encoding: "binary" }) };
    }, h2.publicKeyFromAsn1 = function(e4) {
      var t4 = {}, r4 = [];
      if (!i2.asn1.validate(e4, s2, t4, r4)) {
        var n4 = new Error("Invalid Key.");
        throw n4.errors = r4, n4;
      }
      var a7 = i2.asn1.derToOid(t4.publicKeyOid), o2 = i2.oids.EdDSA25519;
      if (a7 !== o2)
        throw new Error('Invalid OID "' + a7 + '"; OID must be "' + o2 + '".');
      var u3 = t4.ed25519PublicKey;
      if (u3.length !== h2.constants.PUBLIC_KEY_BYTE_LENGTH)
        throw new Error("Key length is invalid.");
      return f2({ message: u3, encoding: "binary" });
    }, h2.publicKeyFromPrivateKey = function(e4) {
      var t4 = f2({ message: (e4 = e4 || {}).privateKey, encoding: "binary" });
      if (t4.length !== h2.constants.PRIVATE_KEY_BYTE_LENGTH)
        throw new TypeError('"options.privateKey" must have a byte length of ' + h2.constants.PRIVATE_KEY_BYTE_LENGTH);
      for (var r4 = new l2(h2.constants.PUBLIC_KEY_BYTE_LENGTH), n4 = 0; n4 < r4.length; ++n4)
        r4[n4] = t4[32 + n4];
      return r4;
    }, h2.sign = function(e4) {
      var t4 = f2(e4 = e4 || {}), r4 = f2({ message: e4.privateKey, encoding: "binary" });
      if (r4.length === h2.constants.SEED_BYTE_LENGTH)
        r4 = h2.generateKeyPair({ seed: r4 }).privateKey;
      else if (r4.length !== h2.constants.PRIVATE_KEY_BYTE_LENGTH)
        throw new TypeError('"options.privateKey" must have a byte length of ' + h2.constants.SEED_BYTE_LENGTH + " or " + h2.constants.PRIVATE_KEY_BYTE_LENGTH);
      var n4 = new l2(h2.constants.SIGN_BYTE_LENGTH + t4.length);
      !function(e5, t5, r5, n5) {
        var i4, a8, s3 = new Float64Array(64), o2 = [O(), O(), O(), O()], u3 = S2(n5, 32);
        u3[0] &= 248, u3[31] &= 127, u3[31] |= 64;
        for (i4 = 0; i4 < r5; ++i4)
          e5[64 + i4] = t5[i4];
        for (i4 = 0; i4 < 32; ++i4)
          e5[32 + i4] = u3[32 + i4];
        var c3 = S2(e5.subarray(32), r5 + 32);
        for (T2(c3), k3(o2, c3), A2(e5, o2), i4 = 32; i4 < 64; ++i4)
          e5[i4] = n5[i4];
        var l3 = S2(e5, r5 + 64);
        for (T2(l3), i4 = 32; i4 < 64; ++i4)
          s3[i4] = 0;
        for (i4 = 0; i4 < 32; ++i4)
          s3[i4] = c3[i4];
        for (i4 = 0; i4 < 32; ++i4)
          for (a8 = 0; a8 < 32; a8++)
            s3[i4 + a8] += l3[i4] * u3[a8];
        b2(e5.subarray(32), s3);
      }(n4, t4, t4.length, r4);
      for (var i3 = new l2(h2.constants.SIGN_BYTE_LENGTH), a7 = 0; a7 < i3.length; ++a7)
        i3[a7] = n4[a7];
      return i3;
    }, h2.verify = function(e4) {
      var t4 = f2(e4 = e4 || {});
      if (e4.signature === void 0)
        throw new TypeError('"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.');
      var r4 = f2({ message: e4.signature, encoding: "binary" });
      if (r4.length !== h2.constants.SIGN_BYTE_LENGTH)
        throw new TypeError('"options.signature" must have a byte length of ' + h2.constants.SIGN_BYTE_LENGTH);
      var n4 = f2({ message: e4.publicKey, encoding: "binary" });
      if (n4.length !== h2.constants.PUBLIC_KEY_BYTE_LENGTH)
        throw new TypeError('"options.publicKey" must have a byte length of ' + h2.constants.PUBLIC_KEY_BYTE_LENGTH);
      var i3, a7 = new l2(h2.constants.SIGN_BYTE_LENGTH + t4.length), s3 = new l2(h2.constants.SIGN_BYTE_LENGTH + t4.length);
      for (i3 = 0; i3 < h2.constants.SIGN_BYTE_LENGTH; ++i3)
        a7[i3] = r4[i3];
      for (i3 = 0; i3 < t4.length; ++i3)
        a7[i3 + h2.constants.SIGN_BYTE_LENGTH] = t4[i3];
      return function(e5, t5, r5, n5) {
        var i4, a8 = new l2(32), s4 = [O(), O(), O(), O()], o2 = [O(), O(), O(), O()];
        if (r5 < 64)
          return -1;
        if (function(e6, t6) {
          var r6 = O(), n6 = O(), i5 = O(), a9 = O(), s5 = O(), o3 = O(), u4 = O();
          return U2(e6[2], d2), function(e7, t7) {
            var r7;
            for (r7 = 0; r7 < 16; ++r7)
              e7[r7] = t7[2 * r7] + (t7[2 * r7 + 1] << 8);
            e7[15] &= 32767;
          }(e6[1], t6), M2(i5, e6[1]), K2(a9, i5, g2), x2(i5, i5, e6[2]), V2(a9, e6[2], a9), M2(s5, a9), M2(o3, s5), K2(u4, o3, s5), K2(r6, u4, i5), K2(r6, r6, a9), function(e7, t7) {
            var r7, n7 = O();
            for (r7 = 0; r7 < 16; ++r7)
              n7[r7] = t7[r7];
            for (r7 = 250; r7 >= 0; --r7)
              M2(n7, n7), r7 !== 1 && K2(n7, n7, t7);
            for (r7 = 0; r7 < 16; ++r7)
              e7[r7] = n7[r7];
          }(r6, r6), K2(r6, r6, i5), K2(r6, r6, a9), K2(r6, r6, a9), K2(e6[0], r6, a9), M2(n6, e6[0]), K2(n6, n6, a9), w2(n6, i5) && K2(e6[0], e6[0], C), M2(n6, e6[0]), K2(n6, n6, a9), w2(n6, i5) ? -1 : (N2(e6[0]) === t6[31] >> 7 && x2(e6[0], p2, e6[0]), K2(e6[3], e6[0], e6[1]), 0);
        }(o2, n5))
          return -1;
        for (i4 = 0; i4 < r5; ++i4)
          e5[i4] = t5[i4];
        for (i4 = 0; i4 < 32; ++i4)
          e5[i4 + 32] = n5[i4];
        var u3 = S2(e5, r5);
        if (T2(u3), L2(s4, o2, u3), k3(o2, t5.subarray(32)), _24(s4, o2), A2(a8, s4), r5 -= 64, R(t5, 0, a8, 0)) {
          for (i4 = 0; i4 < r5; ++i4)
            e5[i4] = 0;
          return -1;
        }
        for (i4 = 0; i4 < r5; ++i4)
          e5[i4] = t5[i4 + 64];
        return r5;
      }(s3, a7, a7.length, n4) >= 0;
    };
    var p2 = O(), d2 = O([1]), g2 = O([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), y2 = O([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), v2 = O([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), m2 = O([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), E2 = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]), C = O([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function S2(e4, t4) {
      var r4 = i2.md.sha512.create(), a7 = new c2(e4);
      r4.update(a7.getBytes(t4), "binary");
      var s3 = r4.digest().getBytes();
      if (n3 !== void 0)
        return n3.from(s3, "binary");
      for (var o2 = new l2(h2.constants.HASH_BYTE_LENGTH), u3 = 0; u3 < 64; ++u3)
        o2[u3] = s3.charCodeAt(u3);
      return o2;
    }
    function b2(e4, t4) {
      var r4, n4, i3, a7;
      for (n4 = 63; n4 >= 32; --n4) {
        for (r4 = 0, i3 = n4 - 32, a7 = n4 - 12; i3 < a7; ++i3)
          t4[i3] += r4 - 16 * t4[n4] * E2[i3 - (n4 - 32)], r4 = t4[i3] + 128 >> 8, t4[i3] -= 256 * r4;
        t4[i3] += r4, t4[n4] = 0;
      }
      for (r4 = 0, i3 = 0; i3 < 32; ++i3)
        t4[i3] += r4 - (t4[31] >> 4) * E2[i3], r4 = t4[i3] >> 8, t4[i3] &= 255;
      for (i3 = 0; i3 < 32; ++i3)
        t4[i3] -= r4 * E2[i3];
      for (n4 = 0; n4 < 32; ++n4)
        t4[n4 + 1] += t4[n4] >> 8, e4[n4] = 255 & t4[n4];
    }
    function T2(e4) {
      for (var t4 = new Float64Array(64), r4 = 0; r4 < 64; ++r4)
        t4[r4] = e4[r4], e4[r4] = 0;
      b2(e4, t4);
    }
    function _24(e4, t4) {
      var r4 = O(), n4 = O(), i3 = O(), a7 = O(), s3 = O(), o2 = O(), u3 = O(), c3 = O(), l3 = O();
      x2(r4, e4[1], e4[0]), x2(l3, t4[1], t4[0]), K2(r4, r4, l3), V2(n4, e4[0], e4[1]), V2(l3, t4[0], t4[1]), K2(n4, n4, l3), K2(i3, e4[3], t4[3]), K2(i3, i3, y2), K2(a7, e4[2], t4[2]), V2(a7, a7, a7), x2(s3, n4, r4), x2(o2, a7, i3), V2(u3, a7, i3), V2(c3, n4, r4), K2(e4[0], s3, o2), K2(e4[1], c3, u3), K2(e4[2], u3, o2), K2(e4[3], s3, c3);
    }
    function I2(e4, t4, r4) {
      for (var n4 = 0; n4 < 4; ++n4)
        P2(e4[n4], t4[n4], r4);
    }
    function A2(e4, t4) {
      var r4 = O(), n4 = O(), i3 = O();
      !function(e5, t5) {
        var r5, n5 = O();
        for (r5 = 0; r5 < 16; ++r5)
          n5[r5] = t5[r5];
        for (r5 = 253; r5 >= 0; --r5)
          M2(n5, n5), r5 !== 2 && r5 !== 4 && K2(n5, n5, t5);
        for (r5 = 0; r5 < 16; ++r5)
          e5[r5] = n5[r5];
      }(i3, t4[2]), K2(r4, t4[0], i3), K2(n4, t4[1], i3), B2(e4, n4), e4[31] ^= N2(r4) << 7;
    }
    function B2(e4, t4) {
      var r4, n4, i3, a7 = O(), s3 = O();
      for (r4 = 0; r4 < 16; ++r4)
        s3[r4] = t4[r4];
      for (D2(s3), D2(s3), D2(s3), n4 = 0; n4 < 2; ++n4) {
        for (a7[0] = s3[0] - 65517, r4 = 1; r4 < 15; ++r4)
          a7[r4] = s3[r4] - 65535 - (a7[r4 - 1] >> 16 & 1), a7[r4 - 1] &= 65535;
        a7[15] = s3[15] - 32767 - (a7[14] >> 16 & 1), i3 = a7[15] >> 16 & 1, a7[14] &= 65535, P2(s3, a7, 1 - i3);
      }
      for (r4 = 0; r4 < 16; r4++)
        e4[2 * r4] = 255 & s3[r4], e4[2 * r4 + 1] = s3[r4] >> 8;
    }
    function w2(e4, t4) {
      var r4 = new l2(32), n4 = new l2(32);
      return B2(r4, e4), B2(n4, t4), R(r4, 0, n4, 0);
    }
    function R(e4, t4, r4, n4) {
      return function(e5, t5, r5, n5, i3) {
        var a7, s3 = 0;
        for (a7 = 0; a7 < 32; ++a7)
          s3 |= e5[t5 + a7] ^ r5[n5 + a7];
        return (1 & s3 - 1 >>> 8) - 1;
      }(e4, t4, r4, n4);
    }
    function N2(e4) {
      var t4 = new l2(32);
      return B2(t4, e4), 1 & t4[0];
    }
    function L2(e4, t4, r4) {
      var n4, i3;
      for (U2(e4[0], p2), U2(e4[1], d2), U2(e4[2], d2), U2(e4[3], p2), i3 = 255; i3 >= 0; --i3)
        I2(e4, t4, n4 = r4[i3 / 8 | 0] >> (7 & i3) & 1), _24(t4, e4), _24(e4, e4), I2(e4, t4, n4);
    }
    function k3(e4, t4) {
      var r4 = [O(), O(), O(), O()];
      U2(r4[0], v2), U2(r4[1], m2), U2(r4[2], d2), K2(r4[3], v2, m2), L2(e4, r4, t4);
    }
    function U2(e4, t4) {
      var r4;
      for (r4 = 0; r4 < 16; r4++)
        e4[r4] = 0 | t4[r4];
    }
    function D2(e4) {
      var t4, r4, n4 = 1;
      for (t4 = 0; t4 < 16; ++t4)
        r4 = e4[t4] + n4 + 65535, n4 = Math.floor(r4 / 65536), e4[t4] = r4 - 65536 * n4;
      e4[0] += n4 - 1 + 37 * (n4 - 1);
    }
    function P2(e4, t4, r4) {
      for (var n4, i3 = ~(r4 - 1), a7 = 0; a7 < 16; ++a7)
        n4 = i3 & (e4[a7] ^ t4[a7]), e4[a7] ^= n4, t4[a7] ^= n4;
    }
    function O(e4) {
      var t4, r4 = new Float64Array(16);
      if (e4)
        for (t4 = 0; t4 < e4.length; ++t4)
          r4[t4] = e4[t4];
      return r4;
    }
    function V2(e4, t4, r4) {
      for (var n4 = 0; n4 < 16; ++n4)
        e4[n4] = t4[n4] + r4[n4];
    }
    function x2(e4, t4, r4) {
      for (var n4 = 0; n4 < 16; ++n4)
        e4[n4] = t4[n4] - r4[n4];
    }
    function M2(e4, t4) {
      K2(e4, t4, t4);
    }
    function K2(e4, t4, r4) {
      var n4, i3, a7 = 0, s3 = 0, o2 = 0, u3 = 0, c3 = 0, l3 = 0, h3 = 0, f3 = 0, p3 = 0, d3 = 0, g3 = 0, y3 = 0, v3 = 0, m3 = 0, E3 = 0, C2 = 0, S3 = 0, b3 = 0, T3 = 0, _25 = 0, I3 = 0, A3 = 0, B3 = 0, w3 = 0, R2 = 0, N3 = 0, L3 = 0, k4 = 0, U3 = 0, D3 = 0, P3 = 0, O2 = r4[0], V5 = r4[1], x3 = r4[2], M3 = r4[3], K3 = r4[4], j2 = r4[5], F2 = r4[6], q2 = r4[7], H2 = r4[8], G2 = r4[9], z2 = r4[10], Q2 = r4[11], Y2 = r4[12], W2 = r4[13], X2 = r4[14], Z2 = r4[15];
      a7 += (n4 = t4[0]) * O2, s3 += n4 * V5, o2 += n4 * x3, u3 += n4 * M3, c3 += n4 * K3, l3 += n4 * j2, h3 += n4 * F2, f3 += n4 * q2, p3 += n4 * H2, d3 += n4 * G2, g3 += n4 * z2, y3 += n4 * Q2, v3 += n4 * Y2, m3 += n4 * W2, E3 += n4 * X2, C2 += n4 * Z2, s3 += (n4 = t4[1]) * O2, o2 += n4 * V5, u3 += n4 * x3, c3 += n4 * M3, l3 += n4 * K3, h3 += n4 * j2, f3 += n4 * F2, p3 += n4 * q2, d3 += n4 * H2, g3 += n4 * G2, y3 += n4 * z2, v3 += n4 * Q2, m3 += n4 * Y2, E3 += n4 * W2, C2 += n4 * X2, S3 += n4 * Z2, o2 += (n4 = t4[2]) * O2, u3 += n4 * V5, c3 += n4 * x3, l3 += n4 * M3, h3 += n4 * K3, f3 += n4 * j2, p3 += n4 * F2, d3 += n4 * q2, g3 += n4 * H2, y3 += n4 * G2, v3 += n4 * z2, m3 += n4 * Q2, E3 += n4 * Y2, C2 += n4 * W2, S3 += n4 * X2, b3 += n4 * Z2, u3 += (n4 = t4[3]) * O2, c3 += n4 * V5, l3 += n4 * x3, h3 += n4 * M3, f3 += n4 * K3, p3 += n4 * j2, d3 += n4 * F2, g3 += n4 * q2, y3 += n4 * H2, v3 += n4 * G2, m3 += n4 * z2, E3 += n4 * Q2, C2 += n4 * Y2, S3 += n4 * W2, b3 += n4 * X2, T3 += n4 * Z2, c3 += (n4 = t4[4]) * O2, l3 += n4 * V5, h3 += n4 * x3, f3 += n4 * M3, p3 += n4 * K3, d3 += n4 * j2, g3 += n4 * F2, y3 += n4 * q2, v3 += n4 * H2, m3 += n4 * G2, E3 += n4 * z2, C2 += n4 * Q2, S3 += n4 * Y2, b3 += n4 * W2, T3 += n4 * X2, _25 += n4 * Z2, l3 += (n4 = t4[5]) * O2, h3 += n4 * V5, f3 += n4 * x3, p3 += n4 * M3, d3 += n4 * K3, g3 += n4 * j2, y3 += n4 * F2, v3 += n4 * q2, m3 += n4 * H2, E3 += n4 * G2, C2 += n4 * z2, S3 += n4 * Q2, b3 += n4 * Y2, T3 += n4 * W2, _25 += n4 * X2, I3 += n4 * Z2, h3 += (n4 = t4[6]) * O2, f3 += n4 * V5, p3 += n4 * x3, d3 += n4 * M3, g3 += n4 * K3, y3 += n4 * j2, v3 += n4 * F2, m3 += n4 * q2, E3 += n4 * H2, C2 += n4 * G2, S3 += n4 * z2, b3 += n4 * Q2, T3 += n4 * Y2, _25 += n4 * W2, I3 += n4 * X2, A3 += n4 * Z2, f3 += (n4 = t4[7]) * O2, p3 += n4 * V5, d3 += n4 * x3, g3 += n4 * M3, y3 += n4 * K3, v3 += n4 * j2, m3 += n4 * F2, E3 += n4 * q2, C2 += n4 * H2, S3 += n4 * G2, b3 += n4 * z2, T3 += n4 * Q2, _25 += n4 * Y2, I3 += n4 * W2, A3 += n4 * X2, B3 += n4 * Z2, p3 += (n4 = t4[8]) * O2, d3 += n4 * V5, g3 += n4 * x3, y3 += n4 * M3, v3 += n4 * K3, m3 += n4 * j2, E3 += n4 * F2, C2 += n4 * q2, S3 += n4 * H2, b3 += n4 * G2, T3 += n4 * z2, _25 += n4 * Q2, I3 += n4 * Y2, A3 += n4 * W2, B3 += n4 * X2, w3 += n4 * Z2, d3 += (n4 = t4[9]) * O2, g3 += n4 * V5, y3 += n4 * x3, v3 += n4 * M3, m3 += n4 * K3, E3 += n4 * j2, C2 += n4 * F2, S3 += n4 * q2, b3 += n4 * H2, T3 += n4 * G2, _25 += n4 * z2, I3 += n4 * Q2, A3 += n4 * Y2, B3 += n4 * W2, w3 += n4 * X2, R2 += n4 * Z2, g3 += (n4 = t4[10]) * O2, y3 += n4 * V5, v3 += n4 * x3, m3 += n4 * M3, E3 += n4 * K3, C2 += n4 * j2, S3 += n4 * F2, b3 += n4 * q2, T3 += n4 * H2, _25 += n4 * G2, I3 += n4 * z2, A3 += n4 * Q2, B3 += n4 * Y2, w3 += n4 * W2, R2 += n4 * X2, N3 += n4 * Z2, y3 += (n4 = t4[11]) * O2, v3 += n4 * V5, m3 += n4 * x3, E3 += n4 * M3, C2 += n4 * K3, S3 += n4 * j2, b3 += n4 * F2, T3 += n4 * q2, _25 += n4 * H2, I3 += n4 * G2, A3 += n4 * z2, B3 += n4 * Q2, w3 += n4 * Y2, R2 += n4 * W2, N3 += n4 * X2, L3 += n4 * Z2, v3 += (n4 = t4[12]) * O2, m3 += n4 * V5, E3 += n4 * x3, C2 += n4 * M3, S3 += n4 * K3, b3 += n4 * j2, T3 += n4 * F2, _25 += n4 * q2, I3 += n4 * H2, A3 += n4 * G2, B3 += n4 * z2, w3 += n4 * Q2, R2 += n4 * Y2, N3 += n4 * W2, L3 += n4 * X2, k4 += n4 * Z2, m3 += (n4 = t4[13]) * O2, E3 += n4 * V5, C2 += n4 * x3, S3 += n4 * M3, b3 += n4 * K3, T3 += n4 * j2, _25 += n4 * F2, I3 += n4 * q2, A3 += n4 * H2, B3 += n4 * G2, w3 += n4 * z2, R2 += n4 * Q2, N3 += n4 * Y2, L3 += n4 * W2, k4 += n4 * X2, U3 += n4 * Z2, E3 += (n4 = t4[14]) * O2, C2 += n4 * V5, S3 += n4 * x3, b3 += n4 * M3, T3 += n4 * K3, _25 += n4 * j2, I3 += n4 * F2, A3 += n4 * q2, B3 += n4 * H2, w3 += n4 * G2, R2 += n4 * z2, N3 += n4 * Q2, L3 += n4 * Y2, k4 += n4 * W2, U3 += n4 * X2, D3 += n4 * Z2, C2 += (n4 = t4[15]) * O2, s3 += 38 * (b3 += n4 * x3), o2 += 38 * (T3 += n4 * M3), u3 += 38 * (_25 += n4 * K3), c3 += 38 * (I3 += n4 * j2), l3 += 38 * (A3 += n4 * F2), h3 += 38 * (B3 += n4 * q2), f3 += 38 * (w3 += n4 * H2), p3 += 38 * (R2 += n4 * G2), d3 += 38 * (N3 += n4 * z2), g3 += 38 * (L3 += n4 * Q2), y3 += 38 * (k4 += n4 * Y2), v3 += 38 * (U3 += n4 * W2), m3 += 38 * (D3 += n4 * X2), E3 += 38 * (P3 += n4 * Z2), a7 = (n4 = (a7 += 38 * (S3 += n4 * V5)) + (i3 = 1) + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), s3 = (n4 = s3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), o2 = (n4 = o2 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), u3 = (n4 = u3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), c3 = (n4 = c3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), l3 = (n4 = l3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), h3 = (n4 = h3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), f3 = (n4 = f3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), p3 = (n4 = p3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), d3 = (n4 = d3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), g3 = (n4 = g3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), y3 = (n4 = y3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), v3 = (n4 = v3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), m3 = (n4 = m3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), E3 = (n4 = E3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), C2 = (n4 = C2 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), a7 = (n4 = (a7 += i3 - 1 + 37 * (i3 - 1)) + (i3 = 1) + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), s3 = (n4 = s3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), o2 = (n4 = o2 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), u3 = (n4 = u3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), c3 = (n4 = c3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), l3 = (n4 = l3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), h3 = (n4 = h3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), f3 = (n4 = f3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), p3 = (n4 = p3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), d3 = (n4 = d3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), g3 = (n4 = g3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), y3 = (n4 = y3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), v3 = (n4 = v3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), m3 = (n4 = m3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), E3 = (n4 = E3 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), C2 = (n4 = C2 + i3 + 65535) - 65536 * (i3 = Math.floor(n4 / 65536)), a7 += i3 - 1 + 37 * (i3 - 1), e4[0] = a7, e4[1] = s3, e4[2] = o2, e4[3] = u3, e4[4] = c3, e4[5] = l3, e4[6] = h3, e4[7] = f3, e4[8] = p3, e4[9] = d3, e4[10] = g3, e4[11] = y3, e4[12] = v3, e4[13] = m3, e4[14] = E3, e4[15] = C2;
    }
  }, 7768: (e3) => {
    e3.exports = { options: { usePureJavaScript: false } };
  }, 7461: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(6067), r3(3103), (e3.exports = n3.hmac = n3.hmac || {}).create = function() {
      var e4 = null, t4 = null, r4 = null, i2 = null, a6 = { start: function(a7, s2) {
        if (a7 !== null)
          if (typeof a7 == "string") {
            if (!((a7 = a7.toLowerCase()) in n3.md.algorithms))
              throw new Error('Unknown hash algorithm "' + a7 + '"');
            t4 = n3.md.algorithms[a7].create();
          } else
            t4 = a7;
        if (s2 === null)
          s2 = e4;
        else {
          if (typeof s2 == "string")
            s2 = n3.util.createBuffer(s2);
          else if (n3.util.isArray(s2)) {
            var o = s2;
            s2 = n3.util.createBuffer();
            for (var u2 = 0; u2 < o.length; ++u2)
              s2.putByte(o[u2]);
          }
          var c2 = s2.length();
          for (c2 > t4.blockLength && (t4.start(), t4.update(s2.bytes()), s2 = t4.digest()), r4 = n3.util.createBuffer(), i2 = n3.util.createBuffer(), c2 = s2.length(), u2 = 0; u2 < c2; ++u2)
            o = s2.at(u2), r4.putByte(54 ^ o), i2.putByte(92 ^ o);
          if (c2 < t4.blockLength)
            for (o = t4.blockLength - c2, u2 = 0; u2 < o; ++u2)
              r4.putByte(54), i2.putByte(92);
          e4 = s2, r4 = r4.bytes(), i2 = i2.bytes();
        }
        t4.start(), t4.update(r4);
      }, update: function(e5) {
        t4.update(e5);
      }, getMac: function() {
        var e5 = t4.digest().bytes();
        return t4.start(), t4.update(i2), t4.update(e5), t4.digest();
      } };
      return a6.digest = a6.getMac, a6;
    };
  }, 6432: (e3, t3, r3) => {
    e3.exports = r3(7768), r3(1482), r3(6898), r3(2624), r3(4609), r3(2023), r3(2554), r3(7461), r3(1169), r3(7316), r3(7847), r3(5024), r3(9580), r3(5477), r3(4034), r3(779), r3(1559), r3(4885), r3(8547), r3(3930), r3(665), r3(4097), r3(3323), r3(2676), r3(8472), r3(3103);
  }, 1633: (e3, t3, r3) => {
    var n3, i2 = r3(7768);
    function a6(e4, t4, r4) {
      this.data = [], e4 != null && (typeof e4 == "number" ? this.fromNumber(e4, t4, r4) : t4 == null && typeof e4 != "string" ? this.fromString(e4, 256) : this.fromString(e4, t4));
    }
    function s2() {
      return new a6(null);
    }
    function o(e4, t4, r4, n4, i3, a7) {
      for (var s3 = 16383 & t4, o2 = t4 >> 14; --a7 >= 0; ) {
        var u3 = 16383 & this.data[e4], c3 = this.data[e4++] >> 14, l3 = o2 * u3 + c3 * s3;
        i3 = ((u3 = s3 * u3 + ((16383 & l3) << 14) + r4.data[n4] + i3) >> 28) + (l3 >> 14) + o2 * c3, r4.data[n4++] = 268435455 & u3;
      }
      return i3;
    }
    e3.exports = i2.jsbn = i2.jsbn || {}, i2.jsbn.BigInteger = a6, typeof navigator == "undefined" ? (a6.prototype.am = o, n3 = 28) : navigator.appName == "Microsoft Internet Explorer" ? (a6.prototype.am = function(e4, t4, r4, n4, i3, a7) {
      for (var s3 = 32767 & t4, o2 = t4 >> 15; --a7 >= 0; ) {
        var u3 = 32767 & this.data[e4], c3 = this.data[e4++] >> 15, l3 = o2 * u3 + c3 * s3;
        i3 = ((u3 = s3 * u3 + ((32767 & l3) << 15) + r4.data[n4] + (1073741823 & i3)) >>> 30) + (l3 >>> 15) + o2 * c3 + (i3 >>> 30), r4.data[n4++] = 1073741823 & u3;
      }
      return i3;
    }, n3 = 30) : navigator.appName != "Netscape" ? (a6.prototype.am = function(e4, t4, r4, n4, i3, a7) {
      for (; --a7 >= 0; ) {
        var s3 = t4 * this.data[e4++] + r4.data[n4] + i3;
        i3 = Math.floor(s3 / 67108864), r4.data[n4++] = 67108863 & s3;
      }
      return i3;
    }, n3 = 26) : (a6.prototype.am = o, n3 = 28), a6.prototype.DB = n3, a6.prototype.DM = (1 << n3) - 1, a6.prototype.DV = 1 << n3, a6.prototype.FV = Math.pow(2, 52), a6.prototype.F1 = 52 - n3, a6.prototype.F2 = 2 * n3 - 52;
    var u2, c2, l2 = new Array();
    for (u2 = "0".charCodeAt(0), c2 = 0; c2 <= 9; ++c2)
      l2[u2++] = c2;
    for (u2 = "a".charCodeAt(0), c2 = 10; c2 < 36; ++c2)
      l2[u2++] = c2;
    for (u2 = "A".charCodeAt(0), c2 = 10; c2 < 36; ++c2)
      l2[u2++] = c2;
    function h2(e4) {
      return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(e4);
    }
    function f2(e4, t4) {
      var r4 = l2[e4.charCodeAt(t4)];
      return r4 == null ? -1 : r4;
    }
    function p2(e4) {
      var t4 = s2();
      return t4.fromInt(e4), t4;
    }
    function d2(e4) {
      var t4, r4 = 1;
      return (t4 = e4 >>> 16) != 0 && (e4 = t4, r4 += 16), (t4 = e4 >> 8) != 0 && (e4 = t4, r4 += 8), (t4 = e4 >> 4) != 0 && (e4 = t4, r4 += 4), (t4 = e4 >> 2) != 0 && (e4 = t4, r4 += 2), (t4 = e4 >> 1) != 0 && (e4 = t4, r4 += 1), r4;
    }
    function g2(e4) {
      this.m = e4;
    }
    function y2(e4) {
      this.m = e4, this.mp = e4.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << e4.DB - 15) - 1, this.mt2 = 2 * e4.t;
    }
    function v2(e4, t4) {
      return e4 & t4;
    }
    function m2(e4, t4) {
      return e4 | t4;
    }
    function E2(e4, t4) {
      return e4 ^ t4;
    }
    function C(e4, t4) {
      return e4 & ~t4;
    }
    function S2(e4) {
      if (e4 == 0)
        return -1;
      var t4 = 0;
      return (65535 & e4) == 0 && (e4 >>= 16, t4 += 16), (255 & e4) == 0 && (e4 >>= 8, t4 += 8), (15 & e4) == 0 && (e4 >>= 4, t4 += 4), (3 & e4) == 0 && (e4 >>= 2, t4 += 2), (1 & e4) == 0 && ++t4, t4;
    }
    function b2(e4) {
      for (var t4 = 0; e4 != 0; )
        e4 &= e4 - 1, ++t4;
      return t4;
    }
    function T2() {
    }
    function _24(e4) {
      return e4;
    }
    function I2(e4) {
      this.r2 = s2(), this.q3 = s2(), a6.ONE.dlShiftTo(2 * e4.t, this.r2), this.mu = this.r2.divide(e4), this.m = e4;
    }
    g2.prototype.convert = function(e4) {
      return e4.s < 0 || e4.compareTo(this.m) >= 0 ? e4.mod(this.m) : e4;
    }, g2.prototype.revert = function(e4) {
      return e4;
    }, g2.prototype.reduce = function(e4) {
      e4.divRemTo(this.m, null, e4);
    }, g2.prototype.mulTo = function(e4, t4, r4) {
      e4.multiplyTo(t4, r4), this.reduce(r4);
    }, g2.prototype.sqrTo = function(e4, t4) {
      e4.squareTo(t4), this.reduce(t4);
    }, y2.prototype.convert = function(e4) {
      var t4 = s2();
      return e4.abs().dlShiftTo(this.m.t, t4), t4.divRemTo(this.m, null, t4), e4.s < 0 && t4.compareTo(a6.ZERO) > 0 && this.m.subTo(t4, t4), t4;
    }, y2.prototype.revert = function(e4) {
      var t4 = s2();
      return e4.copyTo(t4), this.reduce(t4), t4;
    }, y2.prototype.reduce = function(e4) {
      for (; e4.t <= this.mt2; )
        e4.data[e4.t++] = 0;
      for (var t4 = 0; t4 < this.m.t; ++t4) {
        var r4 = 32767 & e4.data[t4], n4 = r4 * this.mpl + ((r4 * this.mph + (e4.data[t4] >> 15) * this.mpl & this.um) << 15) & e4.DM;
        for (r4 = t4 + this.m.t, e4.data[r4] += this.m.am(0, n4, e4, t4, 0, this.m.t); e4.data[r4] >= e4.DV; )
          e4.data[r4] -= e4.DV, e4.data[++r4]++;
      }
      e4.clamp(), e4.drShiftTo(this.m.t, e4), e4.compareTo(this.m) >= 0 && e4.subTo(this.m, e4);
    }, y2.prototype.mulTo = function(e4, t4, r4) {
      e4.multiplyTo(t4, r4), this.reduce(r4);
    }, y2.prototype.sqrTo = function(e4, t4) {
      e4.squareTo(t4), this.reduce(t4);
    }, a6.prototype.copyTo = function(e4) {
      for (var t4 = this.t - 1; t4 >= 0; --t4)
        e4.data[t4] = this.data[t4];
      e4.t = this.t, e4.s = this.s;
    }, a6.prototype.fromInt = function(e4) {
      this.t = 1, this.s = e4 < 0 ? -1 : 0, e4 > 0 ? this.data[0] = e4 : e4 < -1 ? this.data[0] = e4 + this.DV : this.t = 0;
    }, a6.prototype.fromString = function(e4, t4) {
      var r4;
      if (t4 == 16)
        r4 = 4;
      else if (t4 == 8)
        r4 = 3;
      else if (t4 == 256)
        r4 = 8;
      else if (t4 == 2)
        r4 = 1;
      else if (t4 == 32)
        r4 = 5;
      else {
        if (t4 != 4)
          return void this.fromRadix(e4, t4);
        r4 = 2;
      }
      this.t = 0, this.s = 0;
      for (var n4 = e4.length, i3 = false, s3 = 0; --n4 >= 0; ) {
        var o2 = r4 == 8 ? 255 & e4[n4] : f2(e4, n4);
        o2 < 0 ? e4.charAt(n4) == "-" && (i3 = true) : (i3 = false, s3 == 0 ? this.data[this.t++] = o2 : s3 + r4 > this.DB ? (this.data[this.t - 1] |= (o2 & (1 << this.DB - s3) - 1) << s3, this.data[this.t++] = o2 >> this.DB - s3) : this.data[this.t - 1] |= o2 << s3, (s3 += r4) >= this.DB && (s3 -= this.DB));
      }
      r4 == 8 && (128 & e4[0]) != 0 && (this.s = -1, s3 > 0 && (this.data[this.t - 1] |= (1 << this.DB - s3) - 1 << s3)), this.clamp(), i3 && a6.ZERO.subTo(this, this);
    }, a6.prototype.clamp = function() {
      for (var e4 = this.s & this.DM; this.t > 0 && this.data[this.t - 1] == e4; )
        --this.t;
    }, a6.prototype.dlShiftTo = function(e4, t4) {
      var r4;
      for (r4 = this.t - 1; r4 >= 0; --r4)
        t4.data[r4 + e4] = this.data[r4];
      for (r4 = e4 - 1; r4 >= 0; --r4)
        t4.data[r4] = 0;
      t4.t = this.t + e4, t4.s = this.s;
    }, a6.prototype.drShiftTo = function(e4, t4) {
      for (var r4 = e4; r4 < this.t; ++r4)
        t4.data[r4 - e4] = this.data[r4];
      t4.t = Math.max(this.t - e4, 0), t4.s = this.s;
    }, a6.prototype.lShiftTo = function(e4, t4) {
      var r4, n4 = e4 % this.DB, i3 = this.DB - n4, a7 = (1 << i3) - 1, s3 = Math.floor(e4 / this.DB), o2 = this.s << n4 & this.DM;
      for (r4 = this.t - 1; r4 >= 0; --r4)
        t4.data[r4 + s3 + 1] = this.data[r4] >> i3 | o2, o2 = (this.data[r4] & a7) << n4;
      for (r4 = s3 - 1; r4 >= 0; --r4)
        t4.data[r4] = 0;
      t4.data[s3] = o2, t4.t = this.t + s3 + 1, t4.s = this.s, t4.clamp();
    }, a6.prototype.rShiftTo = function(e4, t4) {
      t4.s = this.s;
      var r4 = Math.floor(e4 / this.DB);
      if (r4 >= this.t)
        t4.t = 0;
      else {
        var n4 = e4 % this.DB, i3 = this.DB - n4, a7 = (1 << n4) - 1;
        t4.data[0] = this.data[r4] >> n4;
        for (var s3 = r4 + 1; s3 < this.t; ++s3)
          t4.data[s3 - r4 - 1] |= (this.data[s3] & a7) << i3, t4.data[s3 - r4] = this.data[s3] >> n4;
        n4 > 0 && (t4.data[this.t - r4 - 1] |= (this.s & a7) << i3), t4.t = this.t - r4, t4.clamp();
      }
    }, a6.prototype.subTo = function(e4, t4) {
      for (var r4 = 0, n4 = 0, i3 = Math.min(e4.t, this.t); r4 < i3; )
        n4 += this.data[r4] - e4.data[r4], t4.data[r4++] = n4 & this.DM, n4 >>= this.DB;
      if (e4.t < this.t) {
        for (n4 -= e4.s; r4 < this.t; )
          n4 += this.data[r4], t4.data[r4++] = n4 & this.DM, n4 >>= this.DB;
        n4 += this.s;
      } else {
        for (n4 += this.s; r4 < e4.t; )
          n4 -= e4.data[r4], t4.data[r4++] = n4 & this.DM, n4 >>= this.DB;
        n4 -= e4.s;
      }
      t4.s = n4 < 0 ? -1 : 0, n4 < -1 ? t4.data[r4++] = this.DV + n4 : n4 > 0 && (t4.data[r4++] = n4), t4.t = r4, t4.clamp();
    }, a6.prototype.multiplyTo = function(e4, t4) {
      var r4 = this.abs(), n4 = e4.abs(), i3 = r4.t;
      for (t4.t = i3 + n4.t; --i3 >= 0; )
        t4.data[i3] = 0;
      for (i3 = 0; i3 < n4.t; ++i3)
        t4.data[i3 + r4.t] = r4.am(0, n4.data[i3], t4, i3, 0, r4.t);
      t4.s = 0, t4.clamp(), this.s != e4.s && a6.ZERO.subTo(t4, t4);
    }, a6.prototype.squareTo = function(e4) {
      for (var t4 = this.abs(), r4 = e4.t = 2 * t4.t; --r4 >= 0; )
        e4.data[r4] = 0;
      for (r4 = 0; r4 < t4.t - 1; ++r4) {
        var n4 = t4.am(r4, t4.data[r4], e4, 2 * r4, 0, 1);
        (e4.data[r4 + t4.t] += t4.am(r4 + 1, 2 * t4.data[r4], e4, 2 * r4 + 1, n4, t4.t - r4 - 1)) >= t4.DV && (e4.data[r4 + t4.t] -= t4.DV, e4.data[r4 + t4.t + 1] = 1);
      }
      e4.t > 0 && (e4.data[e4.t - 1] += t4.am(r4, t4.data[r4], e4, 2 * r4, 0, 1)), e4.s = 0, e4.clamp();
    }, a6.prototype.divRemTo = function(e4, t4, r4) {
      var n4 = e4.abs();
      if (!(n4.t <= 0)) {
        var i3 = this.abs();
        if (i3.t < n4.t)
          return t4 != null && t4.fromInt(0), void (r4 != null && this.copyTo(r4));
        r4 == null && (r4 = s2());
        var o2 = s2(), u3 = this.s, c3 = e4.s, l3 = this.DB - d2(n4.data[n4.t - 1]);
        l3 > 0 ? (n4.lShiftTo(l3, o2), i3.lShiftTo(l3, r4)) : (n4.copyTo(o2), i3.copyTo(r4));
        var h3 = o2.t, f3 = o2.data[h3 - 1];
        if (f3 != 0) {
          var p3 = f3 * (1 << this.F1) + (h3 > 1 ? o2.data[h3 - 2] >> this.F2 : 0), g3 = this.FV / p3, y3 = (1 << this.F1) / p3, v3 = 1 << this.F2, m3 = r4.t, E3 = m3 - h3, C2 = t4 == null ? s2() : t4;
          for (o2.dlShiftTo(E3, C2), r4.compareTo(C2) >= 0 && (r4.data[r4.t++] = 1, r4.subTo(C2, r4)), a6.ONE.dlShiftTo(h3, C2), C2.subTo(o2, o2); o2.t < h3; )
            o2.data[o2.t++] = 0;
          for (; --E3 >= 0; ) {
            var S3 = r4.data[--m3] == f3 ? this.DM : Math.floor(r4.data[m3] * g3 + (r4.data[m3 - 1] + v3) * y3);
            if ((r4.data[m3] += o2.am(0, S3, r4, E3, 0, h3)) < S3)
              for (o2.dlShiftTo(E3, C2), r4.subTo(C2, r4); r4.data[m3] < --S3; )
                r4.subTo(C2, r4);
          }
          t4 != null && (r4.drShiftTo(h3, t4), u3 != c3 && a6.ZERO.subTo(t4, t4)), r4.t = h3, r4.clamp(), l3 > 0 && r4.rShiftTo(l3, r4), u3 < 0 && a6.ZERO.subTo(r4, r4);
        }
      }
    }, a6.prototype.invDigit = function() {
      if (this.t < 1)
        return 0;
      var e4 = this.data[0];
      if ((1 & e4) == 0)
        return 0;
      var t4 = 3 & e4;
      return (t4 = (t4 = (t4 = (t4 = t4 * (2 - (15 & e4) * t4) & 15) * (2 - (255 & e4) * t4) & 255) * (2 - ((65535 & e4) * t4 & 65535)) & 65535) * (2 - e4 * t4 % this.DV) % this.DV) > 0 ? this.DV - t4 : -t4;
    }, a6.prototype.isEven = function() {
      return (this.t > 0 ? 1 & this.data[0] : this.s) == 0;
    }, a6.prototype.exp = function(e4, t4) {
      if (e4 > 4294967295 || e4 < 1)
        return a6.ONE;
      var r4 = s2(), n4 = s2(), i3 = t4.convert(this), o2 = d2(e4) - 1;
      for (i3.copyTo(r4); --o2 >= 0; )
        if (t4.sqrTo(r4, n4), (e4 & 1 << o2) > 0)
          t4.mulTo(n4, i3, r4);
        else {
          var u3 = r4;
          r4 = n4, n4 = u3;
        }
      return t4.revert(r4);
    }, a6.prototype.toString = function(e4) {
      if (this.s < 0)
        return "-" + this.negate().toString(e4);
      var t4;
      if (e4 == 16)
        t4 = 4;
      else if (e4 == 8)
        t4 = 3;
      else if (e4 == 2)
        t4 = 1;
      else if (e4 == 32)
        t4 = 5;
      else {
        if (e4 != 4)
          return this.toRadix(e4);
        t4 = 2;
      }
      var r4, n4 = (1 << t4) - 1, i3 = false, a7 = "", s3 = this.t, o2 = this.DB - s3 * this.DB % t4;
      if (s3-- > 0)
        for (o2 < this.DB && (r4 = this.data[s3] >> o2) > 0 && (i3 = true, a7 = h2(r4)); s3 >= 0; )
          o2 < t4 ? (r4 = (this.data[s3] & (1 << o2) - 1) << t4 - o2, r4 |= this.data[--s3] >> (o2 += this.DB - t4)) : (r4 = this.data[s3] >> (o2 -= t4) & n4, o2 <= 0 && (o2 += this.DB, --s3)), r4 > 0 && (i3 = true), i3 && (a7 += h2(r4));
      return i3 ? a7 : "0";
    }, a6.prototype.negate = function() {
      var e4 = s2();
      return a6.ZERO.subTo(this, e4), e4;
    }, a6.prototype.abs = function() {
      return this.s < 0 ? this.negate() : this;
    }, a6.prototype.compareTo = function(e4) {
      var t4 = this.s - e4.s;
      if (t4 != 0)
        return t4;
      var r4 = this.t;
      if ((t4 = r4 - e4.t) != 0)
        return this.s < 0 ? -t4 : t4;
      for (; --r4 >= 0; )
        if ((t4 = this.data[r4] - e4.data[r4]) != 0)
          return t4;
      return 0;
    }, a6.prototype.bitLength = function() {
      return this.t <= 0 ? 0 : this.DB * (this.t - 1) + d2(this.data[this.t - 1] ^ this.s & this.DM);
    }, a6.prototype.mod = function(e4) {
      var t4 = s2();
      return this.abs().divRemTo(e4, null, t4), this.s < 0 && t4.compareTo(a6.ZERO) > 0 && e4.subTo(t4, t4), t4;
    }, a6.prototype.modPowInt = function(e4, t4) {
      var r4;
      return r4 = e4 < 256 || t4.isEven() ? new g2(t4) : new y2(t4), this.exp(e4, r4);
    }, a6.ZERO = p2(0), a6.ONE = p2(1), T2.prototype.convert = _24, T2.prototype.revert = _24, T2.prototype.mulTo = function(e4, t4, r4) {
      e4.multiplyTo(t4, r4);
    }, T2.prototype.sqrTo = function(e4, t4) {
      e4.squareTo(t4);
    }, I2.prototype.convert = function(e4) {
      if (e4.s < 0 || e4.t > 2 * this.m.t)
        return e4.mod(this.m);
      if (e4.compareTo(this.m) < 0)
        return e4;
      var t4 = s2();
      return e4.copyTo(t4), this.reduce(t4), t4;
    }, I2.prototype.revert = function(e4) {
      return e4;
    }, I2.prototype.reduce = function(e4) {
      for (e4.drShiftTo(this.m.t - 1, this.r2), e4.t > this.m.t + 1 && (e4.t = this.m.t + 1, e4.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); e4.compareTo(this.r2) < 0; )
        e4.dAddOffset(1, this.m.t + 1);
      for (e4.subTo(this.r2, e4); e4.compareTo(this.m) >= 0; )
        e4.subTo(this.m, e4);
    }, I2.prototype.mulTo = function(e4, t4, r4) {
      e4.multiplyTo(t4, r4), this.reduce(r4);
    }, I2.prototype.sqrTo = function(e4, t4) {
      e4.squareTo(t4), this.reduce(t4);
    };
    var A2 = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509], B2 = (1 << 26) / A2[A2.length - 1];
    a6.prototype.chunkSize = function(e4) {
      return Math.floor(Math.LN2 * this.DB / Math.log(e4));
    }, a6.prototype.toRadix = function(e4) {
      if (e4 == null && (e4 = 10), this.signum() == 0 || e4 < 2 || e4 > 36)
        return "0";
      var t4 = this.chunkSize(e4), r4 = Math.pow(e4, t4), n4 = p2(r4), i3 = s2(), a7 = s2(), o2 = "";
      for (this.divRemTo(n4, i3, a7); i3.signum() > 0; )
        o2 = (r4 + a7.intValue()).toString(e4).substr(1) + o2, i3.divRemTo(n4, i3, a7);
      return a7.intValue().toString(e4) + o2;
    }, a6.prototype.fromRadix = function(e4, t4) {
      this.fromInt(0), t4 == null && (t4 = 10);
      for (var r4 = this.chunkSize(t4), n4 = Math.pow(t4, r4), i3 = false, s3 = 0, o2 = 0, u3 = 0; u3 < e4.length; ++u3) {
        var c3 = f2(e4, u3);
        c3 < 0 ? e4.charAt(u3) == "-" && this.signum() == 0 && (i3 = true) : (o2 = t4 * o2 + c3, ++s3 >= r4 && (this.dMultiply(n4), this.dAddOffset(o2, 0), s3 = 0, o2 = 0));
      }
      s3 > 0 && (this.dMultiply(Math.pow(t4, s3)), this.dAddOffset(o2, 0)), i3 && a6.ZERO.subTo(this, this);
    }, a6.prototype.fromNumber = function(e4, t4, r4) {
      if (typeof t4 == "number")
        if (e4 < 2)
          this.fromInt(1);
        else
          for (this.fromNumber(e4, r4), this.testBit(e4 - 1) || this.bitwiseTo(a6.ONE.shiftLeft(e4 - 1), m2, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(t4); )
            this.dAddOffset(2, 0), this.bitLength() > e4 && this.subTo(a6.ONE.shiftLeft(e4 - 1), this);
      else {
        var n4 = new Array(), i3 = 7 & e4;
        n4.length = 1 + (e4 >> 3), t4.nextBytes(n4), i3 > 0 ? n4[0] &= (1 << i3) - 1 : n4[0] = 0, this.fromString(n4, 256);
      }
    }, a6.prototype.bitwiseTo = function(e4, t4, r4) {
      var n4, i3, a7 = Math.min(e4.t, this.t);
      for (n4 = 0; n4 < a7; ++n4)
        r4.data[n4] = t4(this.data[n4], e4.data[n4]);
      if (e4.t < this.t) {
        for (i3 = e4.s & this.DM, n4 = a7; n4 < this.t; ++n4)
          r4.data[n4] = t4(this.data[n4], i3);
        r4.t = this.t;
      } else {
        for (i3 = this.s & this.DM, n4 = a7; n4 < e4.t; ++n4)
          r4.data[n4] = t4(i3, e4.data[n4]);
        r4.t = e4.t;
      }
      r4.s = t4(this.s, e4.s), r4.clamp();
    }, a6.prototype.changeBit = function(e4, t4) {
      var r4 = a6.ONE.shiftLeft(e4);
      return this.bitwiseTo(r4, t4, r4), r4;
    }, a6.prototype.addTo = function(e4, t4) {
      for (var r4 = 0, n4 = 0, i3 = Math.min(e4.t, this.t); r4 < i3; )
        n4 += this.data[r4] + e4.data[r4], t4.data[r4++] = n4 & this.DM, n4 >>= this.DB;
      if (e4.t < this.t) {
        for (n4 += e4.s; r4 < this.t; )
          n4 += this.data[r4], t4.data[r4++] = n4 & this.DM, n4 >>= this.DB;
        n4 += this.s;
      } else {
        for (n4 += this.s; r4 < e4.t; )
          n4 += e4.data[r4], t4.data[r4++] = n4 & this.DM, n4 >>= this.DB;
        n4 += e4.s;
      }
      t4.s = n4 < 0 ? -1 : 0, n4 > 0 ? t4.data[r4++] = n4 : n4 < -1 && (t4.data[r4++] = this.DV + n4), t4.t = r4, t4.clamp();
    }, a6.prototype.dMultiply = function(e4) {
      this.data[this.t] = this.am(0, e4 - 1, this, 0, 0, this.t), ++this.t, this.clamp();
    }, a6.prototype.dAddOffset = function(e4, t4) {
      if (e4 != 0) {
        for (; this.t <= t4; )
          this.data[this.t++] = 0;
        for (this.data[t4] += e4; this.data[t4] >= this.DV; )
          this.data[t4] -= this.DV, ++t4 >= this.t && (this.data[this.t++] = 0), ++this.data[t4];
      }
    }, a6.prototype.multiplyLowerTo = function(e4, t4, r4) {
      var n4, i3 = Math.min(this.t + e4.t, t4);
      for (r4.s = 0, r4.t = i3; i3 > 0; )
        r4.data[--i3] = 0;
      for (n4 = r4.t - this.t; i3 < n4; ++i3)
        r4.data[i3 + this.t] = this.am(0, e4.data[i3], r4, i3, 0, this.t);
      for (n4 = Math.min(e4.t, t4); i3 < n4; ++i3)
        this.am(0, e4.data[i3], r4, i3, 0, t4 - i3);
      r4.clamp();
    }, a6.prototype.multiplyUpperTo = function(e4, t4, r4) {
      --t4;
      var n4 = r4.t = this.t + e4.t - t4;
      for (r4.s = 0; --n4 >= 0; )
        r4.data[n4] = 0;
      for (n4 = Math.max(t4 - this.t, 0); n4 < e4.t; ++n4)
        r4.data[this.t + n4 - t4] = this.am(t4 - n4, e4.data[n4], r4, 0, 0, this.t + n4 - t4);
      r4.clamp(), r4.drShiftTo(1, r4);
    }, a6.prototype.modInt = function(e4) {
      if (e4 <= 0)
        return 0;
      var t4 = this.DV % e4, r4 = this.s < 0 ? e4 - 1 : 0;
      if (this.t > 0)
        if (t4 == 0)
          r4 = this.data[0] % e4;
        else
          for (var n4 = this.t - 1; n4 >= 0; --n4)
            r4 = (t4 * r4 + this.data[n4]) % e4;
      return r4;
    }, a6.prototype.millerRabin = function(e4) {
      var t4 = this.subtract(a6.ONE), r4 = t4.getLowestSetBit();
      if (r4 <= 0)
        return false;
      for (var n4, i3 = t4.shiftRight(r4), s3 = { nextBytes: function(e5) {
        for (var t5 = 0; t5 < e5.length; ++t5)
          e5[t5] = Math.floor(256 * Math.random());
      } }, o2 = 0; o2 < e4; ++o2) {
        do {
          n4 = new a6(this.bitLength(), s3);
        } while (n4.compareTo(a6.ONE) <= 0 || n4.compareTo(t4) >= 0);
        var u3 = n4.modPow(i3, this);
        if (u3.compareTo(a6.ONE) != 0 && u3.compareTo(t4) != 0) {
          for (var c3 = 1; c3++ < r4 && u3.compareTo(t4) != 0; )
            if ((u3 = u3.modPowInt(2, this)).compareTo(a6.ONE) == 0)
              return false;
          if (u3.compareTo(t4) != 0)
            return false;
        }
      }
      return true;
    }, a6.prototype.clone = function() {
      var e4 = s2();
      return this.copyTo(e4), e4;
    }, a6.prototype.intValue = function() {
      if (this.s < 0) {
        if (this.t == 1)
          return this.data[0] - this.DV;
        if (this.t == 0)
          return -1;
      } else {
        if (this.t == 1)
          return this.data[0];
        if (this.t == 0)
          return 0;
      }
      return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
    }, a6.prototype.byteValue = function() {
      return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
    }, a6.prototype.shortValue = function() {
      return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
    }, a6.prototype.signum = function() {
      return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this.data[0] <= 0 ? 0 : 1;
    }, a6.prototype.toByteArray = function() {
      var e4 = this.t, t4 = new Array();
      t4[0] = this.s;
      var r4, n4 = this.DB - e4 * this.DB % 8, i3 = 0;
      if (e4-- > 0)
        for (n4 < this.DB && (r4 = this.data[e4] >> n4) != (this.s & this.DM) >> n4 && (t4[i3++] = r4 | this.s << this.DB - n4); e4 >= 0; )
          n4 < 8 ? (r4 = (this.data[e4] & (1 << n4) - 1) << 8 - n4, r4 |= this.data[--e4] >> (n4 += this.DB - 8)) : (r4 = this.data[e4] >> (n4 -= 8) & 255, n4 <= 0 && (n4 += this.DB, --e4)), (128 & r4) != 0 && (r4 |= -256), i3 == 0 && (128 & this.s) != (128 & r4) && ++i3, (i3 > 0 || r4 != this.s) && (t4[i3++] = r4);
      return t4;
    }, a6.prototype.equals = function(e4) {
      return this.compareTo(e4) == 0;
    }, a6.prototype.min = function(e4) {
      return this.compareTo(e4) < 0 ? this : e4;
    }, a6.prototype.max = function(e4) {
      return this.compareTo(e4) > 0 ? this : e4;
    }, a6.prototype.and = function(e4) {
      var t4 = s2();
      return this.bitwiseTo(e4, v2, t4), t4;
    }, a6.prototype.or = function(e4) {
      var t4 = s2();
      return this.bitwiseTo(e4, m2, t4), t4;
    }, a6.prototype.xor = function(e4) {
      var t4 = s2();
      return this.bitwiseTo(e4, E2, t4), t4;
    }, a6.prototype.andNot = function(e4) {
      var t4 = s2();
      return this.bitwiseTo(e4, C, t4), t4;
    }, a6.prototype.not = function() {
      for (var e4 = s2(), t4 = 0; t4 < this.t; ++t4)
        e4.data[t4] = this.DM & ~this.data[t4];
      return e4.t = this.t, e4.s = ~this.s, e4;
    }, a6.prototype.shiftLeft = function(e4) {
      var t4 = s2();
      return e4 < 0 ? this.rShiftTo(-e4, t4) : this.lShiftTo(e4, t4), t4;
    }, a6.prototype.shiftRight = function(e4) {
      var t4 = s2();
      return e4 < 0 ? this.lShiftTo(-e4, t4) : this.rShiftTo(e4, t4), t4;
    }, a6.prototype.getLowestSetBit = function() {
      for (var e4 = 0; e4 < this.t; ++e4)
        if (this.data[e4] != 0)
          return e4 * this.DB + S2(this.data[e4]);
      return this.s < 0 ? this.t * this.DB : -1;
    }, a6.prototype.bitCount = function() {
      for (var e4 = 0, t4 = this.s & this.DM, r4 = 0; r4 < this.t; ++r4)
        e4 += b2(this.data[r4] ^ t4);
      return e4;
    }, a6.prototype.testBit = function(e4) {
      var t4 = Math.floor(e4 / this.DB);
      return t4 >= this.t ? this.s != 0 : (this.data[t4] & 1 << e4 % this.DB) != 0;
    }, a6.prototype.setBit = function(e4) {
      return this.changeBit(e4, m2);
    }, a6.prototype.clearBit = function(e4) {
      return this.changeBit(e4, C);
    }, a6.prototype.flipBit = function(e4) {
      return this.changeBit(e4, E2);
    }, a6.prototype.add = function(e4) {
      var t4 = s2();
      return this.addTo(e4, t4), t4;
    }, a6.prototype.subtract = function(e4) {
      var t4 = s2();
      return this.subTo(e4, t4), t4;
    }, a6.prototype.multiply = function(e4) {
      var t4 = s2();
      return this.multiplyTo(e4, t4), t4;
    }, a6.prototype.divide = function(e4) {
      var t4 = s2();
      return this.divRemTo(e4, t4, null), t4;
    }, a6.prototype.remainder = function(e4) {
      var t4 = s2();
      return this.divRemTo(e4, null, t4), t4;
    }, a6.prototype.divideAndRemainder = function(e4) {
      var t4 = s2(), r4 = s2();
      return this.divRemTo(e4, t4, r4), new Array(t4, r4);
    }, a6.prototype.modPow = function(e4, t4) {
      var r4, n4, i3 = e4.bitLength(), a7 = p2(1);
      if (i3 <= 0)
        return a7;
      r4 = i3 < 18 ? 1 : i3 < 48 ? 3 : i3 < 144 ? 4 : i3 < 768 ? 5 : 6, n4 = i3 < 8 ? new g2(t4) : t4.isEven() ? new I2(t4) : new y2(t4);
      var o2 = new Array(), u3 = 3, c3 = r4 - 1, l3 = (1 << r4) - 1;
      if (o2[1] = n4.convert(this), r4 > 1) {
        var h3 = s2();
        for (n4.sqrTo(o2[1], h3); u3 <= l3; )
          o2[u3] = s2(), n4.mulTo(h3, o2[u3 - 2], o2[u3]), u3 += 2;
      }
      var f3, v3, m3 = e4.t - 1, E3 = true, C2 = s2();
      for (i3 = d2(e4.data[m3]) - 1; m3 >= 0; ) {
        for (i3 >= c3 ? f3 = e4.data[m3] >> i3 - c3 & l3 : (f3 = (e4.data[m3] & (1 << i3 + 1) - 1) << c3 - i3, m3 > 0 && (f3 |= e4.data[m3 - 1] >> this.DB + i3 - c3)), u3 = r4; (1 & f3) == 0; )
          f3 >>= 1, --u3;
        if ((i3 -= u3) < 0 && (i3 += this.DB, --m3), E3)
          o2[f3].copyTo(a7), E3 = false;
        else {
          for (; u3 > 1; )
            n4.sqrTo(a7, C2), n4.sqrTo(C2, a7), u3 -= 2;
          u3 > 0 ? n4.sqrTo(a7, C2) : (v3 = a7, a7 = C2, C2 = v3), n4.mulTo(C2, o2[f3], a7);
        }
        for (; m3 >= 0 && (e4.data[m3] & 1 << i3) == 0; )
          n4.sqrTo(a7, C2), v3 = a7, a7 = C2, C2 = v3, --i3 < 0 && (i3 = this.DB - 1, --m3);
      }
      return n4.revert(a7);
    }, a6.prototype.modInverse = function(e4) {
      var t4 = e4.isEven();
      if (this.isEven() && t4 || e4.signum() == 0)
        return a6.ZERO;
      for (var r4 = e4.clone(), n4 = this.clone(), i3 = p2(1), s3 = p2(0), o2 = p2(0), u3 = p2(1); r4.signum() != 0; ) {
        for (; r4.isEven(); )
          r4.rShiftTo(1, r4), t4 ? (i3.isEven() && s3.isEven() || (i3.addTo(this, i3), s3.subTo(e4, s3)), i3.rShiftTo(1, i3)) : s3.isEven() || s3.subTo(e4, s3), s3.rShiftTo(1, s3);
        for (; n4.isEven(); )
          n4.rShiftTo(1, n4), t4 ? (o2.isEven() && u3.isEven() || (o2.addTo(this, o2), u3.subTo(e4, u3)), o2.rShiftTo(1, o2)) : u3.isEven() || u3.subTo(e4, u3), u3.rShiftTo(1, u3);
        r4.compareTo(n4) >= 0 ? (r4.subTo(n4, r4), t4 && i3.subTo(o2, i3), s3.subTo(u3, s3)) : (n4.subTo(r4, n4), t4 && o2.subTo(i3, o2), u3.subTo(s3, u3));
      }
      return n4.compareTo(a6.ONE) != 0 ? a6.ZERO : u3.compareTo(e4) >= 0 ? u3.subtract(e4) : u3.signum() < 0 ? (u3.addTo(e4, u3), u3.signum() < 0 ? u3.add(e4) : u3) : u3;
    }, a6.prototype.pow = function(e4) {
      return this.exp(e4, new T2());
    }, a6.prototype.gcd = function(e4) {
      var t4 = this.s < 0 ? this.negate() : this.clone(), r4 = e4.s < 0 ? e4.negate() : e4.clone();
      if (t4.compareTo(r4) < 0) {
        var n4 = t4;
        t4 = r4, r4 = n4;
      }
      var i3 = t4.getLowestSetBit(), a7 = r4.getLowestSetBit();
      if (a7 < 0)
        return t4;
      for (i3 < a7 && (a7 = i3), a7 > 0 && (t4.rShiftTo(a7, t4), r4.rShiftTo(a7, r4)); t4.signum() > 0; )
        (i3 = t4.getLowestSetBit()) > 0 && t4.rShiftTo(i3, t4), (i3 = r4.getLowestSetBit()) > 0 && r4.rShiftTo(i3, r4), t4.compareTo(r4) >= 0 ? (t4.subTo(r4, t4), t4.rShiftTo(1, t4)) : (r4.subTo(t4, r4), r4.rShiftTo(1, r4));
      return a7 > 0 && r4.lShiftTo(a7, r4), r4;
    }, a6.prototype.isProbablePrime = function(e4) {
      var t4, r4 = this.abs();
      if (r4.t == 1 && r4.data[0] <= A2[A2.length - 1]) {
        for (t4 = 0; t4 < A2.length; ++t4)
          if (r4.data[0] == A2[t4])
            return true;
        return false;
      }
      if (r4.isEven())
        return false;
      for (t4 = 1; t4 < A2.length; ) {
        for (var n4 = A2[t4], i3 = t4 + 1; i3 < A2.length && n4 < B2; )
          n4 *= A2[i3++];
        for (n4 = r4.modInt(n4); t4 < i3; )
          if (n4 % A2[t4++] == 0)
            return false;
      }
      return r4.millerRabin(e4);
    };
  }, 1169: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), r3(4097), r3(1633), e3.exports = n3.kem = n3.kem || {};
    var i2 = n3.jsbn.BigInteger;
    function a6(e4, t4, r4, i3) {
      e4.generate = function(e5, a7) {
        for (var s2 = new n3.util.ByteBuffer(), o = Math.ceil(a7 / i3) + r4, u2 = new n3.util.ByteBuffer(), c2 = r4; c2 < o; ++c2) {
          u2.putInt32(c2), t4.start(), t4.update(e5 + u2.getBytes());
          var l2 = t4.digest();
          s2.putBytes(l2.getBytes(i3));
        }
        return s2.truncate(s2.length() - a7), s2.getBytes();
      };
    }
    n3.kem.rsa = {}, n3.kem.rsa.create = function(e4, t4) {
      var r4 = (t4 = t4 || {}).prng || n3.random;
      return { encrypt: function(t5, a7) {
        var s2, o = Math.ceil(t5.n.bitLength() / 8);
        do {
          s2 = new i2(n3.util.bytesToHex(r4.getBytesSync(o)), 16).mod(t5.n);
        } while (s2.compareTo(i2.ONE) <= 0);
        var u2 = o - (s2 = n3.util.hexToBytes(s2.toString(16))).length;
        return u2 > 0 && (s2 = n3.util.fillString(String.fromCharCode(0), u2) + s2), { encapsulation: t5.encrypt(s2, "NONE"), key: e4.generate(s2, a7) };
      }, decrypt: function(t5, r5, n4) {
        var i3 = t5.decrypt(r5, "NONE");
        return e4.generate(i3, n4);
      } };
    }, n3.kem.kdf1 = function(e4, t4) {
      a6(this, e4, 0, t4 || e4.digestLength);
    }, n3.kem.kdf2 = function(e4, t4) {
      a6(this, e4, 1, t4 || e4.digestLength);
    };
  }, 7316: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), e3.exports = n3.log = n3.log || {}, n3.log.levels = ["none", "error", "warning", "info", "debug", "verbose", "max"];
    var i2 = {}, a6 = [], s2 = null;
    n3.log.LEVEL_LOCKED = 2, n3.log.NO_LEVEL_CHECK = 4, n3.log.INTERPOLATE = 8;
    for (var o = 0; o < n3.log.levels.length; ++o) {
      var u2 = n3.log.levels[o];
      i2[u2] = { index: o, name: u2.toUpperCase() };
    }
    n3.log.logMessage = function(e4) {
      for (var t4 = i2[e4.level].index, r4 = 0; r4 < a6.length; ++r4) {
        var s3 = a6[r4];
        s3.flags & n3.log.NO_LEVEL_CHECK ? s3.f(e4) : t4 <= i2[s3.level].index && s3.f(s3, e4);
      }
    }, n3.log.prepareStandard = function(e4) {
      "standard" in e4 || (e4.standard = i2[e4.level].name + " [" + e4.category + "] " + e4.message);
    }, n3.log.prepareFull = function(e4) {
      if (!("full" in e4)) {
        var t4 = [e4.message];
        t4 = t4.concat([]), e4.full = n3.util.format.apply(this, t4);
      }
    }, n3.log.prepareStandardFull = function(e4) {
      "standardFull" in e4 || (n3.log.prepareStandard(e4), e4.standardFull = e4.standard);
    };
    var c2 = ["error", "warning", "info", "debug", "verbose"];
    for (o = 0; o < c2.length; ++o)
      !function(e4) {
        n3.log[e4] = function(t4, r4) {
          var i3 = Array.prototype.slice.call(arguments).slice(2), a7 = { timestamp: new Date(), level: e4, category: t4, message: r4, arguments: i3 };
          n3.log.logMessage(a7);
        };
      }(c2[o]);
    if (n3.log.makeLogger = function(e4) {
      var t4 = { flags: 0, f: e4 };
      return n3.log.setLevel(t4, "none"), t4;
    }, n3.log.setLevel = function(e4, t4) {
      var r4 = false;
      if (e4 && !(e4.flags & n3.log.LEVEL_LOCKED)) {
        for (var i3 = 0; i3 < n3.log.levels.length; ++i3)
          if (t4 == n3.log.levels[i3]) {
            e4.level = t4, r4 = true;
            break;
          }
      }
      return r4;
    }, n3.log.lock = function(e4, t4) {
      t4 === void 0 || t4 ? e4.flags |= n3.log.LEVEL_LOCKED : e4.flags &= ~n3.log.LEVEL_LOCKED;
    }, n3.log.addLogger = function(e4) {
      a6.push(e4);
    }, typeof console != "undefined" && "log" in console) {
      var l2;
      if (console.error && console.warn && console.info && console.debug) {
        var h2 = { error: console.error, warning: console.warn, info: console.info, debug: console.debug, verbose: console.debug }, f2 = function(e4, t4) {
          n3.log.prepareStandard(t4);
          var r4 = h2[t4.level], i3 = [t4.standard];
          i3 = i3.concat(t4.arguments.slice()), r4.apply(console, i3);
        };
        l2 = n3.log.makeLogger(f2);
      } else
        f2 = function(e4, t4) {
          n3.log.prepareStandardFull(t4), console.log(t4.standardFull);
        }, l2 = n3.log.makeLogger(f2);
      n3.log.setLevel(l2, "debug"), n3.log.addLogger(l2), s2 = l2;
    } else
      console = { log: function() {
      } };
    if (s2 !== null && typeof window != "undefined" && window.location) {
      var p2 = new URL(window.location.href).searchParams;
      p2.has("console.level") && n3.log.setLevel(s2, p2.get("console.level").slice(-1)[0]), p2.has("console.lock") && p2.get("console.lock").slice(-1)[0] == "true" && n3.log.lock(s2);
    }
    n3.log.consoleLogger = s2;
  }, 7847: (e3, t3, r3) => {
    e3.exports = r3(6067), r3(4581), r3(2936), r3(9141), r3(8672);
  }, 6067: (e3, t3, r3) => {
    var n3 = r3(7768);
    e3.exports = n3.md = n3.md || {}, n3.md.algorithms = n3.md.algorithms || {};
  }, 4581: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(6067), r3(3103);
    var i2 = e3.exports = n3.md5 = n3.md5 || {};
    n3.md.md5 = n3.md.algorithms.md5 = i2, i2.create = function() {
      c2 || function() {
        a6 = String.fromCharCode(128), a6 += n3.util.fillString(String.fromCharCode(0), 64), s2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 1, 6, 11, 0, 5, 10, 15, 4, 9, 14, 3, 8, 13, 2, 7, 12, 5, 8, 11, 14, 1, 4, 7, 10, 13, 0, 3, 6, 9, 12, 15, 2, 0, 7, 14, 5, 12, 3, 10, 1, 8, 15, 6, 13, 4, 11, 2, 9], o = [7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21], u2 = new Array(64);
        for (var e5 = 0; e5 < 64; ++e5)
          u2[e5] = Math.floor(4294967296 * Math.abs(Math.sin(e5 + 1)));
        c2 = true;
      }();
      var e4 = null, t4 = n3.util.createBuffer(), r4 = new Array(16), i3 = { algorithm: "md5", blockLength: 64, digestLength: 16, messageLength: 0, fullMessageLength: null, messageLengthSize: 8, start: function() {
        i3.messageLength = 0, i3.fullMessageLength = i3.messageLength64 = [];
        for (var r5 = i3.messageLengthSize / 4, a7 = 0; a7 < r5; ++a7)
          i3.fullMessageLength.push(0);
        return t4 = n3.util.createBuffer(), e4 = { h0: 1732584193, h1: 4023233417, h2: 2562383102, h3: 271733878 }, i3;
      } };
      return i3.start(), i3.update = function(a7, s3) {
        s3 === "utf8" && (a7 = n3.util.encodeUtf8(a7));
        var o2 = a7.length;
        i3.messageLength += o2, o2 = [o2 / 4294967296 >>> 0, o2 >>> 0];
        for (var u3 = i3.fullMessageLength.length - 1; u3 >= 0; --u3)
          i3.fullMessageLength[u3] += o2[1], o2[1] = o2[0] + (i3.fullMessageLength[u3] / 4294967296 >>> 0), i3.fullMessageLength[u3] = i3.fullMessageLength[u3] >>> 0, o2[0] = o2[1] / 4294967296 >>> 0;
        return t4.putBytes(a7), l2(e4, r4, t4), (t4.read > 2048 || t4.length() === 0) && t4.compact(), i3;
      }, i3.digest = function() {
        var s3 = n3.util.createBuffer();
        s3.putBytes(t4.bytes());
        var o2 = i3.fullMessageLength[i3.fullMessageLength.length - 1] + i3.messageLengthSize & i3.blockLength - 1;
        s3.putBytes(a6.substr(0, i3.blockLength - o2));
        for (var u3, c3 = 0, h2 = i3.fullMessageLength.length - 1; h2 >= 0; --h2)
          c3 = (u3 = 8 * i3.fullMessageLength[h2] + c3) / 4294967296 >>> 0, s3.putInt32Le(u3 >>> 0);
        var f2 = { h0: e4.h0, h1: e4.h1, h2: e4.h2, h3: e4.h3 };
        l2(f2, r4, s3);
        var p2 = n3.util.createBuffer();
        return p2.putInt32Le(f2.h0), p2.putInt32Le(f2.h1), p2.putInt32Le(f2.h2), p2.putInt32Le(f2.h3), p2;
      }, i3;
    };
    var a6 = null, s2 = null, o = null, u2 = null, c2 = false;
    function l2(e4, t4, r4) {
      for (var n4, i3, a7, c3, l3, h2, f2, p2 = r4.length(); p2 >= 64; ) {
        for (i3 = e4.h0, a7 = e4.h1, c3 = e4.h2, l3 = e4.h3, f2 = 0; f2 < 16; ++f2)
          t4[f2] = r4.getInt32Le(), n4 = i3 + (l3 ^ a7 & (c3 ^ l3)) + u2[f2] + t4[f2], i3 = l3, l3 = c3, c3 = a7, a7 += n4 << (h2 = o[f2]) | n4 >>> 32 - h2;
        for (; f2 < 32; ++f2)
          n4 = i3 + (c3 ^ l3 & (a7 ^ c3)) + u2[f2] + t4[s2[f2]], i3 = l3, l3 = c3, c3 = a7, a7 += n4 << (h2 = o[f2]) | n4 >>> 32 - h2;
        for (; f2 < 48; ++f2)
          n4 = i3 + (a7 ^ c3 ^ l3) + u2[f2] + t4[s2[f2]], i3 = l3, l3 = c3, c3 = a7, a7 += n4 << (h2 = o[f2]) | n4 >>> 32 - h2;
        for (; f2 < 64; ++f2)
          n4 = i3 + (c3 ^ (a7 | ~l3)) + u2[f2] + t4[s2[f2]], i3 = l3, l3 = c3, c3 = a7, a7 += n4 << (h2 = o[f2]) | n4 >>> 32 - h2;
        e4.h0 = e4.h0 + i3 | 0, e4.h1 = e4.h1 + a7 | 0, e4.h2 = e4.h2 + c3 | 0, e4.h3 = e4.h3 + l3 | 0, p2 -= 64;
      }
    }
  }, 826: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(5024), e3.exports = n3.mgf = n3.mgf || {}, n3.mgf.mgf1 = n3.mgf1;
  }, 5024: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), n3.mgf = n3.mgf || {}, (e3.exports = n3.mgf.mgf1 = n3.mgf1 = n3.mgf1 || {}).create = function(e4) {
      return { generate: function(t4, r4) {
        for (var i2 = new n3.util.ByteBuffer(), a6 = Math.ceil(r4 / e4.digestLength), s2 = 0; s2 < a6; s2++) {
          var o = new n3.util.ByteBuffer();
          o.putInt32(s2), e4.start(), e4.update(t4 + o.getBytes()), i2.putBuffer(e4.digest());
        }
        return i2.truncate(i2.length() - r4), i2.getBytes();
      } };
    };
  }, 2884: (e3, t3, r3) => {
    var n3 = r3(7768);
    n3.pki = n3.pki || {};
    var i2 = e3.exports = n3.pki.oids = n3.oids = n3.oids || {};
    function a6(e4, t4) {
      i2[e4] = t4, i2[t4] = e4;
    }
    function s2(e4, t4) {
      i2[e4] = t4;
    }
    a6("1.2.840.113549.1.1.1", "rsaEncryption"), a6("1.2.840.113549.1.1.4", "md5WithRSAEncryption"), a6("1.2.840.113549.1.1.5", "sha1WithRSAEncryption"), a6("1.2.840.113549.1.1.7", "RSAES-OAEP"), a6("1.2.840.113549.1.1.8", "mgf1"), a6("1.2.840.113549.1.1.9", "pSpecified"), a6("1.2.840.113549.1.1.10", "RSASSA-PSS"), a6("1.2.840.113549.1.1.11", "sha256WithRSAEncryption"), a6("1.2.840.113549.1.1.12", "sha384WithRSAEncryption"), a6("1.2.840.113549.1.1.13", "sha512WithRSAEncryption"), a6("1.3.101.112", "EdDSA25519"), a6("1.2.840.10040.4.3", "dsa-with-sha1"), a6("1.3.14.3.2.7", "desCBC"), a6("1.3.14.3.2.26", "sha1"), a6("1.3.14.3.2.29", "sha1WithRSASignature"), a6("2.16.840.1.101.3.4.2.1", "sha256"), a6("2.16.840.1.101.3.4.2.2", "sha384"), a6("2.16.840.1.101.3.4.2.3", "sha512"), a6("2.16.840.1.101.3.4.2.4", "sha224"), a6("2.16.840.1.101.3.4.2.5", "sha512-224"), a6("2.16.840.1.101.3.4.2.6", "sha512-256"), a6("1.2.840.113549.2.2", "md2"), a6("1.2.840.113549.2.5", "md5"), a6("1.2.840.113549.1.7.1", "data"), a6("1.2.840.113549.1.7.2", "signedData"), a6("1.2.840.113549.1.7.3", "envelopedData"), a6("1.2.840.113549.1.7.4", "signedAndEnvelopedData"), a6("1.2.840.113549.1.7.5", "digestedData"), a6("1.2.840.113549.1.7.6", "encryptedData"), a6("1.2.840.113549.1.9.1", "emailAddress"), a6("1.2.840.113549.1.9.2", "unstructuredName"), a6("1.2.840.113549.1.9.3", "contentType"), a6("1.2.840.113549.1.9.4", "messageDigest"), a6("1.2.840.113549.1.9.5", "signingTime"), a6("1.2.840.113549.1.9.6", "counterSignature"), a6("1.2.840.113549.1.9.7", "challengePassword"), a6("1.2.840.113549.1.9.8", "unstructuredAddress"), a6("1.2.840.113549.1.9.14", "extensionRequest"), a6("1.2.840.113549.1.9.20", "friendlyName"), a6("1.2.840.113549.1.9.21", "localKeyId"), a6("1.2.840.113549.1.9.22.1", "x509Certificate"), a6("1.2.840.113549.1.12.10.1.1", "keyBag"), a6("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag"), a6("1.2.840.113549.1.12.10.1.3", "certBag"), a6("1.2.840.113549.1.12.10.1.4", "crlBag"), a6("1.2.840.113549.1.12.10.1.5", "secretBag"), a6("1.2.840.113549.1.12.10.1.6", "safeContentsBag"), a6("1.2.840.113549.1.5.13", "pkcs5PBES2"), a6("1.2.840.113549.1.5.12", "pkcs5PBKDF2"), a6("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4"), a6("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4"), a6("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC"), a6("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC"), a6("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC"), a6("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC"), a6("1.2.840.113549.2.7", "hmacWithSHA1"), a6("1.2.840.113549.2.8", "hmacWithSHA224"), a6("1.2.840.113549.2.9", "hmacWithSHA256"), a6("1.2.840.113549.2.10", "hmacWithSHA384"), a6("1.2.840.113549.2.11", "hmacWithSHA512"), a6("1.2.840.113549.3.7", "des-EDE3-CBC"), a6("2.16.840.1.101.3.4.1.2", "aes128-CBC"), a6("2.16.840.1.101.3.4.1.22", "aes192-CBC"), a6("2.16.840.1.101.3.4.1.42", "aes256-CBC"), a6("2.5.4.3", "commonName"), a6("2.5.4.4", "surname"), a6("2.5.4.5", "serialNumber"), a6("2.5.4.6", "countryName"), a6("2.5.4.7", "localityName"), a6("2.5.4.8", "stateOrProvinceName"), a6("2.5.4.9", "streetAddress"), a6("2.5.4.10", "organizationName"), a6("2.5.4.11", "organizationalUnitName"), a6("2.5.4.12", "title"), a6("2.5.4.13", "description"), a6("2.5.4.15", "businessCategory"), a6("2.5.4.17", "postalCode"), a6("2.5.4.42", "givenName"), a6("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName"), a6("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName"), a6("2.16.840.1.113730.1.1", "nsCertType"), a6("2.16.840.1.113730.1.13", "nsComment"), s2("2.5.29.1", "authorityKeyIdentifier"), s2("2.5.29.2", "keyAttributes"), s2("2.5.29.3", "certificatePolicies"), s2("2.5.29.4", "keyUsageRestriction"), s2("2.5.29.5", "policyMapping"), s2("2.5.29.6", "subtreesConstraint"), s2("2.5.29.7", "subjectAltName"), s2("2.5.29.8", "issuerAltName"), s2("2.5.29.9", "subjectDirectoryAttributes"), s2("2.5.29.10", "basicConstraints"), s2("2.5.29.11", "nameConstraints"), s2("2.5.29.12", "policyConstraints"), s2("2.5.29.13", "basicConstraints"), a6("2.5.29.14", "subjectKeyIdentifier"), a6("2.5.29.15", "keyUsage"), s2("2.5.29.16", "privateKeyUsagePeriod"), a6("2.5.29.17", "subjectAltName"), a6("2.5.29.18", "issuerAltName"), a6("2.5.29.19", "basicConstraints"), s2("2.5.29.20", "cRLNumber"), s2("2.5.29.21", "cRLReason"), s2("2.5.29.22", "expirationDate"), s2("2.5.29.23", "instructionCode"), s2("2.5.29.24", "invalidityDate"), s2("2.5.29.25", "cRLDistributionPoints"), s2("2.5.29.26", "issuingDistributionPoint"), s2("2.5.29.27", "deltaCRLIndicator"), s2("2.5.29.28", "issuingDistributionPoint"), s2("2.5.29.29", "certificateIssuer"), s2("2.5.29.30", "nameConstraints"), a6("2.5.29.31", "cRLDistributionPoints"), a6("2.5.29.32", "certificatePolicies"), s2("2.5.29.33", "policyMappings"), s2("2.5.29.34", "policyConstraints"), a6("2.5.29.35", "authorityKeyIdentifier"), s2("2.5.29.36", "policyConstraints"), a6("2.5.29.37", "extKeyUsage"), s2("2.5.29.46", "freshestCRL"), s2("2.5.29.54", "inhibitAnyPolicy"), a6("1.3.6.1.4.1.11129.2.4.2", "timestampList"), a6("1.3.6.1.5.5.7.1.1", "authorityInfoAccess"), a6("1.3.6.1.5.5.7.3.1", "serverAuth"), a6("1.3.6.1.5.5.7.3.2", "clientAuth"), a6("1.3.6.1.5.5.7.3.3", "codeSigning"), a6("1.3.6.1.5.5.7.3.4", "emailProtection"), a6("1.3.6.1.5.5.7.3.8", "timeStamping");
  }, 6635: (e3, t3, r3) => {
    var n3 = r3(7768);
    if (r3(1482), r3(2624), r3(2023), r3(6067), r3(2884), r3(9580), r3(5477), r3(4097), r3(3323), r3(144), r3(3103), i2 === void 0)
      var i2 = n3.jsbn.BigInteger;
    var a6 = n3.asn1, s2 = n3.pki = n3.pki || {};
    e3.exports = s2.pbe = n3.pbe = n3.pbe || {};
    var o = s2.oids, u2 = { name: "EncryptedPrivateKeyInfo", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "EncryptedPrivateKeyInfo.encryptionAlgorithm", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OID, constructed: false, capture: "encryptionOid" }, { name: "AlgorithmIdentifier.parameters", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, captureAsn1: "encryptionParams" }] }, { name: "EncryptedPrivateKeyInfo.encryptedData", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OCTETSTRING, constructed: false, capture: "encryptedData" }] }, c2 = { name: "PBES2Algorithms", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "PBES2Algorithms.keyDerivationFunc", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "PBES2Algorithms.keyDerivationFunc.oid", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OID, constructed: false, capture: "kdfOid" }, { name: "PBES2Algorithms.params", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "PBES2Algorithms.params.salt", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OCTETSTRING, constructed: false, capture: "kdfSalt" }, { name: "PBES2Algorithms.params.iterationCount", tagClass: a6.Class.UNIVERSAL, type: a6.Type.INTEGER, constructed: false, capture: "kdfIterationCount" }, { name: "PBES2Algorithms.params.keyLength", tagClass: a6.Class.UNIVERSAL, type: a6.Type.INTEGER, constructed: false, optional: true, capture: "keyLength" }, { name: "PBES2Algorithms.params.prf", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, optional: true, value: [{ name: "PBES2Algorithms.params.prf.algorithm", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OID, constructed: false, capture: "prfOid" }] }] }] }, { name: "PBES2Algorithms.encryptionScheme", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "PBES2Algorithms.encryptionScheme.oid", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OID, constructed: false, capture: "encOid" }, { name: "PBES2Algorithms.encryptionScheme.iv", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OCTETSTRING, constructed: false, capture: "encIv" }] }] }, l2 = { name: "pkcs-12PbeParams", tagClass: a6.Class.UNIVERSAL, type: a6.Type.SEQUENCE, constructed: true, value: [{ name: "pkcs-12PbeParams.salt", tagClass: a6.Class.UNIVERSAL, type: a6.Type.OCTETSTRING, constructed: false, capture: "salt" }, { name: "pkcs-12PbeParams.iterations", tagClass: a6.Class.UNIVERSAL, type: a6.Type.INTEGER, constructed: false, capture: "iterations" }] };
    function h2(e4, t4) {
      return e4.start().update(t4).digest().getBytes();
    }
    function f2(e4) {
      var t4;
      if (e4) {
        if (!(t4 = s2.oids[a6.derToOid(e4)])) {
          var r4 = new Error("Unsupported PRF OID.");
          throw r4.oid = e4, r4.supported = ["hmacWithSHA1", "hmacWithSHA224", "hmacWithSHA256", "hmacWithSHA384", "hmacWithSHA512"], r4;
        }
      } else
        t4 = "hmacWithSHA1";
      return p2(t4);
    }
    function p2(e4) {
      var t4 = n3.md;
      switch (e4) {
        case "hmacWithSHA224":
          t4 = n3.md.sha512;
        case "hmacWithSHA1":
        case "hmacWithSHA256":
        case "hmacWithSHA384":
        case "hmacWithSHA512":
          e4 = e4.substr(8).toLowerCase();
          break;
        default:
          var r4 = new Error("Unsupported PRF algorithm.");
          throw r4.algorithm = e4, r4.supported = ["hmacWithSHA1", "hmacWithSHA224", "hmacWithSHA256", "hmacWithSHA384", "hmacWithSHA512"], r4;
      }
      if (!t4 || !(e4 in t4))
        throw new Error("Unknown hash algorithm: " + e4);
      return t4[e4].create();
    }
    s2.encryptPrivateKeyInfo = function(e4, t4, r4) {
      (r4 = r4 || {}).saltSize = r4.saltSize || 8, r4.count = r4.count || 2048, r4.algorithm = r4.algorithm || "aes128", r4.prfAlgorithm = r4.prfAlgorithm || "sha1";
      var i3, u3, c3, l3 = n3.random.getBytesSync(r4.saltSize), h3 = r4.count, f3 = a6.integerToDer(h3);
      if (r4.algorithm.indexOf("aes") === 0 || r4.algorithm === "des") {
        var d2, g2, y2;
        switch (r4.algorithm) {
          case "aes128":
            i3 = 16, d2 = 16, g2 = o["aes128-CBC"], y2 = n3.aes.createEncryptionCipher;
            break;
          case "aes192":
            i3 = 24, d2 = 16, g2 = o["aes192-CBC"], y2 = n3.aes.createEncryptionCipher;
            break;
          case "aes256":
            i3 = 32, d2 = 16, g2 = o["aes256-CBC"], y2 = n3.aes.createEncryptionCipher;
            break;
          case "des":
            i3 = 8, d2 = 8, g2 = o.desCBC, y2 = n3.des.createEncryptionCipher;
            break;
          default:
            throw (b2 = new Error("Cannot encrypt private key. Unknown encryption algorithm.")).algorithm = r4.algorithm, b2;
        }
        var v2 = "hmacWith" + r4.prfAlgorithm.toUpperCase(), m2 = p2(v2), E2 = n3.pkcs5.pbkdf2(t4, l3, h3, i3, m2), C = n3.random.getBytesSync(d2);
        (T2 = y2(E2)).start(C), T2.update(a6.toDer(e4)), T2.finish(), c3 = T2.output.getBytes();
        var S2 = function(e5, t5, r5, i4) {
          var o2 = a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OCTETSTRING, false, e5), a6.create(a6.Class.UNIVERSAL, a6.Type.INTEGER, false, t5.getBytes())]);
          return i4 !== "hmacWithSHA1" && o2.value.push(a6.create(a6.Class.UNIVERSAL, a6.Type.INTEGER, false, n3.util.hexToBytes(r5.toString(16))), a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OID, false, a6.oidToDer(s2.oids[i4]).getBytes()), a6.create(a6.Class.UNIVERSAL, a6.Type.NULL, false, "")])), o2;
        }(l3, f3, i3, v2);
        u3 = a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OID, false, a6.oidToDer(o.pkcs5PBES2).getBytes()), a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OID, false, a6.oidToDer(o.pkcs5PBKDF2).getBytes()), S2]), a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OID, false, a6.oidToDer(g2).getBytes()), a6.create(a6.Class.UNIVERSAL, a6.Type.OCTETSTRING, false, C)])])]);
      } else {
        var b2;
        if (r4.algorithm !== "3des")
          throw (b2 = new Error("Cannot encrypt private key. Unknown encryption algorithm.")).algorithm = r4.algorithm, b2;
        i3 = 24;
        var T2, _24 = new n3.util.ByteBuffer(l3);
        E2 = s2.pbe.generatePkcs12Key(t4, _24, 1, h3, i3), C = s2.pbe.generatePkcs12Key(t4, _24, 2, h3, i3), (T2 = n3.des.createEncryptionCipher(E2)).start(C), T2.update(a6.toDer(e4)), T2.finish(), c3 = T2.output.getBytes(), u3 = a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OID, false, a6.oidToDer(o["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()), a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [a6.create(a6.Class.UNIVERSAL, a6.Type.OCTETSTRING, false, l3), a6.create(a6.Class.UNIVERSAL, a6.Type.INTEGER, false, f3.getBytes())])]);
      }
      return a6.create(a6.Class.UNIVERSAL, a6.Type.SEQUENCE, true, [u3, a6.create(a6.Class.UNIVERSAL, a6.Type.OCTETSTRING, false, c3)]);
    }, s2.decryptPrivateKeyInfo = function(e4, t4) {
      var r4 = null, i3 = {}, o2 = [];
      if (!a6.validate(e4, u2, i3, o2)) {
        var c3 = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        throw c3.errors = o2, c3;
      }
      var l3 = a6.derToOid(i3.encryptionOid), h3 = s2.pbe.getCipher(l3, i3.encryptionParams, t4), f3 = n3.util.createBuffer(i3.encryptedData);
      return h3.update(f3), h3.finish() && (r4 = a6.fromDer(h3.output)), r4;
    }, s2.encryptedPrivateKeyToPem = function(e4, t4) {
      var r4 = { type: "ENCRYPTED PRIVATE KEY", body: a6.toDer(e4).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, s2.encryptedPrivateKeyFromPem = function(e4) {
      var t4 = n3.pem.decode(e4)[0];
      if (t4.type !== "ENCRYPTED PRIVATE KEY") {
        var r4 = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        throw r4.headerType = t4.type, r4;
      }
      if (t4.procType && t4.procType.type === "ENCRYPTED")
        throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
      return a6.fromDer(t4.body);
    }, s2.encryptRsaPrivateKey = function(e4, t4, r4) {
      if (!(r4 = r4 || {}).legacy) {
        var i3 = s2.wrapRsaPrivateKey(s2.privateKeyToAsn1(e4));
        return i3 = s2.encryptPrivateKeyInfo(i3, t4, r4), s2.encryptedPrivateKeyToPem(i3);
      }
      var o2, u3, c3, l3;
      switch (r4.algorithm) {
        case "aes128":
          o2 = "AES-128-CBC", c3 = 16, u3 = n3.random.getBytesSync(16), l3 = n3.aes.createEncryptionCipher;
          break;
        case "aes192":
          o2 = "AES-192-CBC", c3 = 24, u3 = n3.random.getBytesSync(16), l3 = n3.aes.createEncryptionCipher;
          break;
        case "aes256":
          o2 = "AES-256-CBC", c3 = 32, u3 = n3.random.getBytesSync(16), l3 = n3.aes.createEncryptionCipher;
          break;
        case "3des":
          o2 = "DES-EDE3-CBC", c3 = 24, u3 = n3.random.getBytesSync(8), l3 = n3.des.createEncryptionCipher;
          break;
        case "des":
          o2 = "DES-CBC", c3 = 8, u3 = n3.random.getBytesSync(8), l3 = n3.des.createEncryptionCipher;
          break;
        default:
          var h3 = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + r4.algorithm + '".');
          throw h3.algorithm = r4.algorithm, h3;
      }
      var f3 = l3(n3.pbe.opensslDeriveBytes(t4, u3.substr(0, 8), c3));
      f3.start(u3), f3.update(a6.toDer(s2.privateKeyToAsn1(e4))), f3.finish();
      var p3 = { type: "RSA PRIVATE KEY", procType: { version: "4", type: "ENCRYPTED" }, dekInfo: { algorithm: o2, parameters: n3.util.bytesToHex(u3).toUpperCase() }, body: f3.output.getBytes() };
      return n3.pem.encode(p3);
    }, s2.decryptRsaPrivateKey = function(e4, t4) {
      var r4 = null, i3 = n3.pem.decode(e4)[0];
      if (i3.type !== "ENCRYPTED PRIVATE KEY" && i3.type !== "PRIVATE KEY" && i3.type !== "RSA PRIVATE KEY")
        throw (c3 = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".')).headerType = c3, c3;
      if (i3.procType && i3.procType.type === "ENCRYPTED") {
        var o2, u3;
        switch (i3.dekInfo.algorithm) {
          case "DES-CBC":
            o2 = 8, u3 = n3.des.createDecryptionCipher;
            break;
          case "DES-EDE3-CBC":
            o2 = 24, u3 = n3.des.createDecryptionCipher;
            break;
          case "AES-128-CBC":
            o2 = 16, u3 = n3.aes.createDecryptionCipher;
            break;
          case "AES-192-CBC":
            o2 = 24, u3 = n3.aes.createDecryptionCipher;
            break;
          case "AES-256-CBC":
            o2 = 32, u3 = n3.aes.createDecryptionCipher;
            break;
          case "RC2-40-CBC":
            o2 = 5, u3 = function(e5) {
              return n3.rc2.createDecryptionCipher(e5, 40);
            };
            break;
          case "RC2-64-CBC":
            o2 = 8, u3 = function(e5) {
              return n3.rc2.createDecryptionCipher(e5, 64);
            };
            break;
          case "RC2-128-CBC":
            o2 = 16, u3 = function(e5) {
              return n3.rc2.createDecryptionCipher(e5, 128);
            };
            break;
          default:
            var c3;
            throw (c3 = new Error('Could not decrypt private key; unsupported encryption algorithm "' + i3.dekInfo.algorithm + '".')).algorithm = i3.dekInfo.algorithm, c3;
        }
        var l3 = n3.util.hexToBytes(i3.dekInfo.parameters), h3 = u3(n3.pbe.opensslDeriveBytes(t4, l3.substr(0, 8), o2));
        if (h3.start(l3), h3.update(n3.util.createBuffer(i3.body)), !h3.finish())
          return r4;
        r4 = h3.output.getBytes();
      } else
        r4 = i3.body;
      return (r4 = i3.type === "ENCRYPTED PRIVATE KEY" ? s2.decryptPrivateKeyInfo(a6.fromDer(r4), t4) : a6.fromDer(r4)) !== null && (r4 = s2.privateKeyFromAsn1(r4)), r4;
    }, s2.pbe.generatePkcs12Key = function(e4, t4, r4, i3, a7, s3) {
      var o2, u3;
      if (s3 == null) {
        if (!("sha1" in n3.md))
          throw new Error('"sha1" hash algorithm unavailable.');
        s3 = n3.md.sha1.create();
      }
      var c3 = s3.digestLength, l3 = s3.blockLength, h3 = new n3.util.ByteBuffer(), f3 = new n3.util.ByteBuffer();
      if (e4 != null) {
        for (u3 = 0; u3 < e4.length; u3++)
          f3.putInt16(e4.charCodeAt(u3));
        f3.putInt16(0);
      }
      var p3 = f3.length(), d2 = t4.length(), g2 = new n3.util.ByteBuffer();
      g2.fillWithByte(r4, l3);
      var y2 = l3 * Math.ceil(d2 / l3), v2 = new n3.util.ByteBuffer();
      for (u3 = 0; u3 < y2; u3++)
        v2.putByte(t4.at(u3 % d2));
      var m2 = l3 * Math.ceil(p3 / l3), E2 = new n3.util.ByteBuffer();
      for (u3 = 0; u3 < m2; u3++)
        E2.putByte(f3.at(u3 % p3));
      var C = v2;
      C.putBuffer(E2);
      for (var S2 = Math.ceil(a7 / c3), b2 = 1; b2 <= S2; b2++) {
        var T2 = new n3.util.ByteBuffer();
        T2.putBytes(g2.bytes()), T2.putBytes(C.bytes());
        for (var _24 = 0; _24 < i3; _24++)
          s3.start(), s3.update(T2.getBytes()), T2 = s3.digest();
        var I2 = new n3.util.ByteBuffer();
        for (u3 = 0; u3 < l3; u3++)
          I2.putByte(T2.at(u3 % c3));
        var A2 = Math.ceil(d2 / l3) + Math.ceil(p3 / l3), B2 = new n3.util.ByteBuffer();
        for (o2 = 0; o2 < A2; o2++) {
          var w2 = new n3.util.ByteBuffer(C.getBytes(l3)), R = 511;
          for (u3 = I2.length() - 1; u3 >= 0; u3--)
            R >>= 8, R += I2.at(u3) + w2.at(u3), w2.setAt(u3, 255 & R);
          B2.putBuffer(w2);
        }
        C = B2, h3.putBuffer(T2);
      }
      return h3.truncate(h3.length() - a7), h3;
    }, s2.pbe.getCipher = function(e4, t4, r4) {
      switch (e4) {
        case s2.oids.pkcs5PBES2:
          return s2.pbe.getCipherForPBES2(e4, t4, r4);
        case s2.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        case s2.oids["pbewithSHAAnd40BitRC2-CBC"]:
          return s2.pbe.getCipherForPKCS12PBE(e4, t4, r4);
        default:
          var n4 = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
          throw n4.oid = e4, n4.supportedOids = ["pkcs5PBES2", "pbeWithSHAAnd3-KeyTripleDES-CBC", "pbewithSHAAnd40BitRC2-CBC"], n4;
      }
    }, s2.pbe.getCipherForPBES2 = function(e4, t4, r4) {
      var i3, o2 = {}, u3 = [];
      if (!a6.validate(t4, c2, o2, u3))
        throw (i3 = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.")).errors = u3, i3;
      if ((e4 = a6.derToOid(o2.kdfOid)) !== s2.oids.pkcs5PBKDF2)
        throw (i3 = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.")).oid = e4, i3.supportedOids = ["pkcs5PBKDF2"], i3;
      if ((e4 = a6.derToOid(o2.encOid)) !== s2.oids["aes128-CBC"] && e4 !== s2.oids["aes192-CBC"] && e4 !== s2.oids["aes256-CBC"] && e4 !== s2.oids["des-EDE3-CBC"] && e4 !== s2.oids.desCBC)
        throw (i3 = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.")).oid = e4, i3.supportedOids = ["aes128-CBC", "aes192-CBC", "aes256-CBC", "des-EDE3-CBC", "desCBC"], i3;
      var l3, h3, p3 = o2.kdfSalt, d2 = n3.util.createBuffer(o2.kdfIterationCount);
      switch (d2 = d2.getInt(d2.length() << 3), s2.oids[e4]) {
        case "aes128-CBC":
          l3 = 16, h3 = n3.aes.createDecryptionCipher;
          break;
        case "aes192-CBC":
          l3 = 24, h3 = n3.aes.createDecryptionCipher;
          break;
        case "aes256-CBC":
          l3 = 32, h3 = n3.aes.createDecryptionCipher;
          break;
        case "des-EDE3-CBC":
          l3 = 24, h3 = n3.des.createDecryptionCipher;
          break;
        case "desCBC":
          l3 = 8, h3 = n3.des.createDecryptionCipher;
      }
      var g2 = f2(o2.prfOid), y2 = n3.pkcs5.pbkdf2(r4, p3, d2, l3, g2), v2 = o2.encIv, m2 = h3(y2);
      return m2.start(v2), m2;
    }, s2.pbe.getCipherForPKCS12PBE = function(e4, t4, r4) {
      var i3 = {}, o2 = [];
      if (!a6.validate(t4, l2, i3, o2))
        throw (g2 = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.")).errors = o2, g2;
      var u3, c3, h3, p3 = n3.util.createBuffer(i3.salt), d2 = n3.util.createBuffer(i3.iterations);
      switch (d2 = d2.getInt(d2.length() << 3), e4) {
        case s2.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
          u3 = 24, c3 = 8, h3 = n3.des.startDecrypting;
          break;
        case s2.oids["pbewithSHAAnd40BitRC2-CBC"]:
          u3 = 5, c3 = 8, h3 = function(e5, t5) {
            var r5 = n3.rc2.createDecryptionCipher(e5, 40);
            return r5.start(t5, null), r5;
          };
          break;
        default:
          var g2;
          throw (g2 = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.")).oid = e4, g2;
      }
      var y2 = f2(i3.prfOid), v2 = s2.pbe.generatePkcs12Key(r4, p3, 1, d2, u3, y2);
      return y2.start(), h3(v2, s2.pbe.generatePkcs12Key(r4, p3, 2, d2, c3, y2));
    }, s2.pbe.opensslDeriveBytes = function(e4, t4, r4, i3) {
      if (i3 == null) {
        if (!("md5" in n3.md))
          throw new Error('"md5" hash algorithm unavailable.');
        i3 = n3.md.md5.create();
      }
      t4 === null && (t4 = "");
      for (var a7 = [h2(i3, e4 + t4)], s3 = 16, o2 = 1; s3 < r4; ++o2, s3 += 16)
        a7.push(h2(i3, a7[o2 - 1] + e4 + t4));
      return a7.join("").substr(0, r4);
    };
  }, 9580: (e3, t3, r3) => {
    var n3 = r3(7573).Buffer, i2 = r3(7768);
    r3(7461), r3(6067), r3(3103);
    var a6, s2 = i2.pkcs5 = i2.pkcs5 || {};
    i2.util.isNodejs && !i2.options.usePureJavaScript && (a6 = r3(5942)), e3.exports = i2.pbkdf2 = s2.pbkdf2 = function(e4, t4, r4, s3, o, u2) {
      if (typeof o == "function" && (u2 = o, o = null), i2.util.isNodejs && !i2.options.usePureJavaScript && a6.pbkdf2 && (o === null || typeof o != "object") && (a6.pbkdf2Sync.length > 4 || !o || o === "sha1"))
        return typeof o != "string" && (o = "sha1"), e4 = n3.from(e4, "binary"), t4 = n3.from(t4, "binary"), u2 ? a6.pbkdf2Sync.length === 4 ? a6.pbkdf2(e4, t4, r4, s3, function(e5, t5) {
          if (e5)
            return u2(e5);
          u2(null, t5.toString("binary"));
        }) : a6.pbkdf2(e4, t4, r4, s3, o, function(e5, t5) {
          if (e5)
            return u2(e5);
          u2(null, t5.toString("binary"));
        }) : a6.pbkdf2Sync.length === 4 ? a6.pbkdf2Sync(e4, t4, r4, s3).toString("binary") : a6.pbkdf2Sync(e4, t4, r4, s3, o).toString("binary");
      if (o == null && (o = "sha1"), typeof o == "string") {
        if (!(o in i2.md.algorithms))
          throw new Error("Unknown hash algorithm: " + o);
        o = i2.md[o].create();
      }
      var c2 = o.digestLength;
      if (s3 > 4294967295 * c2) {
        var l2 = new Error("Derived key is too long.");
        if (u2)
          return u2(l2);
        throw l2;
      }
      var h2 = Math.ceil(s3 / c2), f2 = s3 - (h2 - 1) * c2, p2 = i2.hmac.create();
      p2.start(o, e4);
      var d2, g2, y2, v2 = "";
      if (!u2) {
        for (var m2 = 1; m2 <= h2; ++m2) {
          p2.start(null, null), p2.update(t4), p2.update(i2.util.int32ToBytes(m2)), d2 = y2 = p2.digest().getBytes();
          for (var E2 = 2; E2 <= r4; ++E2)
            p2.start(null, null), p2.update(y2), g2 = p2.digest().getBytes(), d2 = i2.util.xorBytes(d2, g2, c2), y2 = g2;
          v2 += m2 < h2 ? d2 : d2.substr(0, f2);
        }
        return v2;
      }
      function C() {
        if (m2 > h2)
          return u2(null, v2);
        p2.start(null, null), p2.update(t4), p2.update(i2.util.int32ToBytes(m2)), d2 = y2 = p2.digest().getBytes(), E2 = 2, S2();
      }
      function S2() {
        if (E2 <= r4)
          return p2.start(null, null), p2.update(y2), g2 = p2.digest().getBytes(), d2 = i2.util.xorBytes(d2, g2, c2), y2 = g2, ++E2, i2.util.setImmediate(S2);
        v2 += m2 < h2 ? d2 : d2.substr(0, f2), ++m2, C();
      }
      m2 = 1, C();
    };
  }, 5477: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103);
    var i2 = e3.exports = n3.pem = n3.pem || {};
    function a6(e4) {
      for (var t4 = e4.name + ": ", r4 = [], n4 = function(e5, t5) {
        return " " + t5;
      }, i3 = 0; i3 < e4.values.length; ++i3)
        r4.push(e4.values[i3].replace(/^(\S+\r\n)/, n4));
      t4 += r4.join(",") + "\r\n";
      var a7 = 0, s3 = -1;
      for (i3 = 0; i3 < t4.length; ++i3, ++a7)
        if (a7 > 65 && s3 !== -1) {
          var o = t4[s3];
          o === "," ? (++s3, t4 = t4.substr(0, s3) + "\r\n " + t4.substr(s3)) : t4 = t4.substr(0, s3) + "\r\n" + o + t4.substr(s3 + 1), a7 = i3 - s3 - 1, s3 = -1, ++i3;
        } else
          t4[i3] !== " " && t4[i3] !== "	" && t4[i3] !== "," || (s3 = i3);
      return t4;
    }
    function s2(e4) {
      return e4.replace(/^\s+/, "");
    }
    i2.encode = function(e4, t4) {
      t4 = t4 || {};
      var r4, i3 = "-----BEGIN " + e4.type + "-----\r\n";
      if (e4.procType && (i3 += a6(r4 = { name: "Proc-Type", values: [String(e4.procType.version), e4.procType.type] })), e4.contentDomain && (i3 += a6(r4 = { name: "Content-Domain", values: [e4.contentDomain] })), e4.dekInfo && (r4 = { name: "DEK-Info", values: [e4.dekInfo.algorithm] }, e4.dekInfo.parameters && r4.values.push(e4.dekInfo.parameters), i3 += a6(r4)), e4.headers)
        for (var s3 = 0; s3 < e4.headers.length; ++s3)
          i3 += a6(e4.headers[s3]);
      return e4.procType && (i3 += "\r\n"), (i3 += n3.util.encode64(e4.body, t4.maxline || 64) + "\r\n") + "-----END " + e4.type + "-----\r\n";
    }, i2.decode = function(e4) {
      for (var t4, r4 = [], i3 = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g, a7 = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/, o = /\r?\n/; t4 = i3.exec(e4); ) {
        var u2 = t4[1];
        u2 === "NEW CERTIFICATE REQUEST" && (u2 = "CERTIFICATE REQUEST");
        var c2 = { type: u2, procType: null, contentDomain: null, dekInfo: null, headers: [], body: n3.util.decode64(t4[3]) };
        if (r4.push(c2), t4[2]) {
          for (var l2 = t4[2].split(o), h2 = 0; t4 && h2 < l2.length; ) {
            for (var f2 = l2[h2].replace(/\s+$/, ""), p2 = h2 + 1; p2 < l2.length; ++p2) {
              var d2 = l2[p2];
              if (!/\s/.test(d2[0]))
                break;
              f2 += d2, h2 = p2;
            }
            if (t4 = f2.match(a7)) {
              for (var g2 = { name: t4[1], values: [] }, y2 = t4[2].split(","), v2 = 0; v2 < y2.length; ++v2)
                g2.values.push(s2(y2[v2]));
              if (c2.procType)
                if (c2.contentDomain || g2.name !== "Content-Domain")
                  if (c2.dekInfo || g2.name !== "DEK-Info")
                    c2.headers.push(g2);
                  else {
                    if (g2.values.length === 0)
                      throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    c2.dekInfo = { algorithm: y2[0], parameters: y2[1] || null };
                  }
                else
                  c2.contentDomain = y2[0] || "";
              else {
                if (g2.name !== "Proc-Type")
                  throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                if (g2.values.length !== 2)
                  throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                c2.procType = { version: y2[0], type: y2[1] };
              }
            }
            ++h2;
          }
          if (c2.procType === "ENCRYPTED" && !c2.dekInfo)
            throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
        }
      }
      if (r4.length === 0)
        throw new Error("Invalid PEM formatted message.");
      return r4;
    };
  }, 4034: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), r3(4097), r3(2936);
    var i2 = e3.exports = n3.pkcs1 = n3.pkcs1 || {};
    function a6(e4, t4, r4) {
      r4 || (r4 = n3.md.sha1.create());
      for (var i3 = "", a7 = Math.ceil(t4 / r4.digestLength), s2 = 0; s2 < a7; ++s2) {
        var o = String.fromCharCode(s2 >> 24 & 255, s2 >> 16 & 255, s2 >> 8 & 255, 255 & s2);
        r4.start(), r4.update(e4 + o), i3 += r4.digest().getBytes();
      }
      return i3.substring(0, t4);
    }
    i2.encode_rsa_oaep = function(e4, t4, r4) {
      var i3, s2, o, u2;
      typeof r4 == "string" ? (i3 = r4, s2 = arguments[3] || void 0, o = arguments[4] || void 0) : r4 && (i3 = r4.label || void 0, s2 = r4.seed || void 0, o = r4.md || void 0, r4.mgf1 && r4.mgf1.md && (u2 = r4.mgf1.md)), o ? o.start() : o = n3.md.sha1.create(), u2 || (u2 = o);
      var c2 = Math.ceil(e4.n.bitLength() / 8), l2 = c2 - 2 * o.digestLength - 2;
      if (t4.length > l2)
        throw (y2 = new Error("RSAES-OAEP input message length is too long.")).length = t4.length, y2.maxLength = l2, y2;
      i3 || (i3 = ""), o.update(i3, "raw");
      for (var h2 = o.digest(), f2 = "", p2 = l2 - t4.length, d2 = 0; d2 < p2; d2++)
        f2 += "\0";
      var g2 = h2.getBytes() + f2 + "" + t4;
      if (s2) {
        if (s2.length !== o.digestLength) {
          var y2;
          throw (y2 = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.")).seedLength = s2.length, y2.digestLength = o.digestLength, y2;
        }
      } else
        s2 = n3.random.getBytes(o.digestLength);
      var v2 = a6(s2, c2 - o.digestLength - 1, u2), m2 = n3.util.xorBytes(g2, v2, g2.length), E2 = a6(m2, o.digestLength, u2), C = n3.util.xorBytes(s2, E2, s2.length);
      return "\0" + C + m2;
    }, i2.decode_rsa_oaep = function(e4, t4, r4) {
      var i3, s2, o;
      typeof r4 == "string" ? (i3 = r4, s2 = arguments[3] || void 0) : r4 && (i3 = r4.label || void 0, s2 = r4.md || void 0, r4.mgf1 && r4.mgf1.md && (o = r4.mgf1.md));
      var u2 = Math.ceil(e4.n.bitLength() / 8);
      if (t4.length !== u2)
        throw (m2 = new Error("RSAES-OAEP encoded message length is invalid.")).length = t4.length, m2.expectedLength = u2, m2;
      if (s2 === void 0 ? s2 = n3.md.sha1.create() : s2.start(), o || (o = s2), u2 < 2 * s2.digestLength + 2)
        throw new Error("RSAES-OAEP key is too short for the hash function.");
      i3 || (i3 = ""), s2.update(i3, "raw");
      for (var c2 = s2.digest().getBytes(), l2 = t4.charAt(0), h2 = t4.substring(1, s2.digestLength + 1), f2 = t4.substring(1 + s2.digestLength), p2 = a6(f2, s2.digestLength, o), d2 = n3.util.xorBytes(h2, p2, h2.length), g2 = a6(d2, u2 - s2.digestLength - 1, o), y2 = n3.util.xorBytes(f2, g2, f2.length), v2 = y2.substring(0, s2.digestLength), m2 = l2 !== "\0", E2 = 0; E2 < s2.digestLength; ++E2)
        m2 |= c2.charAt(E2) !== v2.charAt(E2);
      for (var C = 1, S2 = s2.digestLength, b2 = s2.digestLength; b2 < y2.length; b2++) {
        var T2 = y2.charCodeAt(b2), _24 = 1 & T2 ^ 1, I2 = C ? 65534 : 0;
        m2 |= T2 & I2, S2 += C &= _24;
      }
      if (m2 || y2.charCodeAt(S2) !== 1)
        throw new Error("Invalid RSAES-OAEP padding.");
      return y2.substring(S2 + 1);
    };
  }, 779: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(2624), r3(7461), r3(2884), r3(8989), r3(6635), r3(4097), r3(144), r3(2936), r3(3103), r3(6446);
    var i2 = n3.asn1, a6 = n3.pki, s2 = e3.exports = n3.pkcs12 = n3.pkcs12 || {}, o = { name: "ContentInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "ContentInfo.contentType", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "contentType" }, { name: "ContentInfo.content", tagClass: i2.Class.CONTEXT_SPECIFIC, constructed: true, captureAsn1: "content" }] }, u2 = { name: "PFX", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "PFX.version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "version" }, o, { name: "PFX.macData", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, optional: true, captureAsn1: "mac", value: [{ name: "PFX.macData.mac", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "PFX.macData.mac.digestAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "PFX.macData.mac.digestAlgorithm.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "macAlgorithm" }, { name: "PFX.macData.mac.digestAlgorithm.parameters", tagClass: i2.Class.UNIVERSAL, captureAsn1: "macAlgorithmParameters" }] }, { name: "PFX.macData.mac.digest", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OCTETSTRING, constructed: false, capture: "macDigest" }] }, { name: "PFX.macData.macSalt", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OCTETSTRING, constructed: false, capture: "macSalt" }, { name: "PFX.macData.iterations", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, optional: true, capture: "macIterations" }] }] }, c2 = { name: "SafeBag", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "SafeBag.bagId", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "bagId" }, { name: "SafeBag.bagValue", tagClass: i2.Class.CONTEXT_SPECIFIC, constructed: true, captureAsn1: "bagValue" }, { name: "SafeBag.bagAttributes", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SET, constructed: true, optional: true, capture: "bagAttributes" }] }, l2 = { name: "Attribute", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "Attribute.attrId", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "oid" }, { name: "Attribute.attrValues", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SET, constructed: true, capture: "values" }] }, h2 = { name: "CertBag", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "CertBag.certId", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "certId" }, { name: "CertBag.certValue", tagClass: i2.Class.CONTEXT_SPECIFIC, constructed: true, value: [{ name: "CertBag.certValue[0]", tagClass: i2.Class.UNIVERSAL, type: i2.Class.OCTETSTRING, constructed: false, capture: "cert" }] }] };
    function f2(e4, t4, r4, n4) {
      for (var i3 = [], a7 = 0; a7 < e4.length; a7++)
        for (var s3 = 0; s3 < e4[a7].safeBags.length; s3++) {
          var o2 = e4[a7].safeBags[s3];
          n4 !== void 0 && o2.type !== n4 || (t4 !== null ? o2.attributes[t4] !== void 0 && o2.attributes[t4].indexOf(r4) >= 0 && i3.push(o2) : i3.push(o2));
        }
      return i3;
    }
    function p2(e4) {
      if (e4.composed || e4.constructed) {
        for (var t4 = n3.util.createBuffer(), r4 = 0; r4 < e4.value.length; ++r4)
          t4.putBytes(e4.value[r4].value);
        e4.composed = e4.constructed = false, e4.value = t4.getBytes();
      }
      return e4;
    }
    function d2(e4, t4) {
      var r4 = {}, s3 = [];
      if (!i2.validate(e4, n3.pkcs7.asn1.encryptedDataValidator, r4, s3))
        throw (o2 = new Error("Cannot read EncryptedContentInfo.")).errors = s3, o2;
      var o2, u3 = i2.derToOid(r4.contentType);
      if (u3 !== a6.oids.data)
        throw (o2 = new Error("PKCS#12 EncryptedContentInfo ContentType is not Data.")).oid = u3, o2;
      u3 = i2.derToOid(r4.encAlgorithm);
      var c3 = a6.pbe.getCipher(u3, r4.encParameter, t4), l3 = p2(r4.encryptedContentAsn1), h3 = n3.util.createBuffer(l3.value);
      if (c3.update(h3), !c3.finish())
        throw new Error("Failed to decrypt PKCS#12 SafeContents.");
      return c3.output.getBytes();
    }
    function g2(e4, t4, r4) {
      if (!t4 && e4.length === 0)
        return [];
      if ((e4 = i2.fromDer(e4, t4)).tagClass !== i2.Class.UNIVERSAL || e4.type !== i2.Type.SEQUENCE || e4.constructed !== true)
        throw new Error("PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.");
      for (var n4 = [], s3 = 0; s3 < e4.value.length; s3++) {
        var o2 = e4.value[s3], u3 = {}, l3 = [];
        if (!i2.validate(o2, c2, u3, l3))
          throw (v2 = new Error("Cannot read SafeBag.")).errors = l3, v2;
        var f3, p3, d3 = { type: i2.derToOid(u3.bagId), attributes: y2(u3.bagAttributes) };
        n4.push(d3);
        var g3 = u3.bagValue.value[0];
        switch (d3.type) {
          case a6.oids.pkcs8ShroudedKeyBag:
            if ((g3 = a6.decryptPrivateKeyInfo(g3, r4)) === null)
              throw new Error("Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?");
          case a6.oids.keyBag:
            try {
              d3.key = a6.privateKeyFromAsn1(g3);
            } catch (e5) {
              d3.key = null, d3.asn1 = g3;
            }
            continue;
          case a6.oids.certBag:
            f3 = h2, p3 = function() {
              if (i2.derToOid(u3.certId) !== a6.oids.x509Certificate) {
                var e5 = new Error("Unsupported certificate type, only X.509 supported.");
                throw e5.oid = i2.derToOid(u3.certId), e5;
              }
              var r5 = i2.fromDer(u3.cert, t4);
              try {
                d3.cert = a6.certificateFromAsn1(r5, true);
              } catch (e6) {
                d3.cert = null, d3.asn1 = r5;
              }
            };
            break;
          default:
            var v2;
            throw (v2 = new Error("Unsupported PKCS#12 SafeBag type.")).oid = d3.type, v2;
        }
        if (f3 !== void 0 && !i2.validate(g3, f3, u3, l3))
          throw (v2 = new Error("Cannot read PKCS#12 " + f3.name)).errors = l3, v2;
        p3();
      }
      return n4;
    }
    function y2(e4) {
      var t4 = {};
      if (e4 !== void 0)
        for (var r4 = 0; r4 < e4.length; ++r4) {
          var n4 = {}, s3 = [];
          if (!i2.validate(e4[r4], l2, n4, s3)) {
            var o2 = new Error("Cannot read PKCS#12 BagAttribute.");
            throw o2.errors = s3, o2;
          }
          var u3 = i2.derToOid(n4.oid);
          if (a6.oids[u3] !== void 0) {
            t4[a6.oids[u3]] = [];
            for (var c3 = 0; c3 < n4.values.length; ++c3)
              t4[a6.oids[u3]].push(n4.values[c3].value);
          }
        }
      return t4;
    }
    s2.pkcs12FromAsn1 = function(e4, t4, r4) {
      typeof t4 == "string" ? (r4 = t4, t4 = true) : t4 === void 0 && (t4 = true);
      var c3 = {};
      if (!i2.validate(e4, u2, c3, []))
        throw (l3 = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.")).errors = l3, l3;
      var l3, h3 = { version: c3.version.charCodeAt(0), safeContents: [], getBags: function(e5) {
        var t5, r5 = {};
        return "localKeyId" in e5 ? t5 = e5.localKeyId : "localKeyIdHex" in e5 && (t5 = n3.util.hexToBytes(e5.localKeyIdHex)), t5 === void 0 && !("friendlyName" in e5) && "bagType" in e5 && (r5[e5.bagType] = f2(h3.safeContents, null, null, e5.bagType)), t5 !== void 0 && (r5.localKeyId = f2(h3.safeContents, "localKeyId", t5, e5.bagType)), "friendlyName" in e5 && (r5.friendlyName = f2(h3.safeContents, "friendlyName", e5.friendlyName, e5.bagType)), r5;
      }, getBagsByFriendlyName: function(e5, t5) {
        return f2(h3.safeContents, "friendlyName", e5, t5);
      }, getBagsByLocalKeyId: function(e5, t5) {
        return f2(h3.safeContents, "localKeyId", e5, t5);
      } };
      if (c3.version.charCodeAt(0) !== 3)
        throw (l3 = new Error("PKCS#12 PFX of version other than 3 not supported.")).version = c3.version.charCodeAt(0), l3;
      if (i2.derToOid(c3.contentType) !== a6.oids.data)
        throw (l3 = new Error("Only PKCS#12 PFX in password integrity mode supported.")).oid = i2.derToOid(c3.contentType), l3;
      var y3 = c3.content.value[0];
      if (y3.tagClass !== i2.Class.UNIVERSAL || y3.type !== i2.Type.OCTETSTRING)
        throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
      if (y3 = p2(y3), c3.mac) {
        var v2 = null, m2 = 0, E2 = i2.derToOid(c3.macAlgorithm);
        switch (E2) {
          case a6.oids.sha1:
            v2 = n3.md.sha1.create(), m2 = 20;
            break;
          case a6.oids.sha256:
            v2 = n3.md.sha256.create(), m2 = 32;
            break;
          case a6.oids.sha384:
            v2 = n3.md.sha384.create(), m2 = 48;
            break;
          case a6.oids.sha512:
            v2 = n3.md.sha512.create(), m2 = 64;
            break;
          case a6.oids.md5:
            v2 = n3.md.md5.create(), m2 = 16;
        }
        if (v2 === null)
          throw new Error("PKCS#12 uses unsupported MAC algorithm: " + E2);
        var C = new n3.util.ByteBuffer(c3.macSalt), S2 = "macIterations" in c3 ? parseInt(n3.util.bytesToHex(c3.macIterations), 16) : 1, b2 = s2.generateKey(r4, C, 3, S2, m2, v2), T2 = n3.hmac.create();
        if (T2.start(v2, b2), T2.update(y3.value), T2.getMac().getBytes() !== c3.macDigest)
          throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
      }
      return function(e5, t5, r5, n4) {
        if ((t5 = i2.fromDer(t5, r5)).tagClass !== i2.Class.UNIVERSAL || t5.type !== i2.Type.SEQUENCE || t5.constructed !== true)
          throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
        for (var s3 = 0; s3 < t5.value.length; s3++) {
          var u3 = t5.value[s3], c4 = {}, l4 = [];
          if (!i2.validate(u3, o, c4, l4))
            throw (v3 = new Error("Cannot read ContentInfo.")).errors = l4, v3;
          var h4 = { encrypted: false }, f3 = null, y4 = c4.content.value[0];
          switch (i2.derToOid(c4.contentType)) {
            case a6.oids.data:
              if (y4.tagClass !== i2.Class.UNIVERSAL || y4.type !== i2.Type.OCTETSTRING)
                throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
              f3 = p2(y4).value;
              break;
            case a6.oids.encryptedData:
              f3 = d2(y4, n4), h4.encrypted = true;
              break;
            default:
              var v3;
              throw (v3 = new Error("Unsupported PKCS#12 contentType.")).contentType = i2.derToOid(c4.contentType), v3;
          }
          h4.safeBags = g2(f3, r5, n4), e5.safeContents.push(h4);
        }
      }(h3, y3.value, t4, r4), h3;
    }, s2.toPkcs12Asn1 = function(e4, t4, r4, o2) {
      (o2 = o2 || {}).saltSize = o2.saltSize || 8, o2.count = o2.count || 2048, o2.algorithm = o2.algorithm || o2.encAlgorithm || "aes128", "useMac" in o2 || (o2.useMac = true), "localKeyId" in o2 || (o2.localKeyId = null), "generateLocalKeyId" in o2 || (o2.generateLocalKeyId = true);
      var u3, c3 = o2.localKeyId;
      if (c3 !== null)
        c3 = n3.util.hexToBytes(c3);
      else if (o2.generateLocalKeyId)
        if (t4) {
          var l3 = n3.util.isArray(t4) ? t4[0] : t4;
          typeof l3 == "string" && (l3 = a6.certificateFromPem(l3)), (B2 = n3.md.sha1.create()).update(i2.toDer(a6.certificateToAsn1(l3)).getBytes()), c3 = B2.digest().getBytes();
        } else
          c3 = n3.random.getBytes(20);
      var h3 = [];
      c3 !== null && h3.push(i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.localKeyId).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, c3)])])), "friendlyName" in o2 && h3.push(i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.friendlyName).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.BMPSTRING, false, o2.friendlyName)])])), h3.length > 0 && (u3 = i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, h3));
      var f3 = [], p3 = [];
      t4 !== null && (p3 = n3.util.isArray(t4) ? t4 : [t4]);
      for (var d3 = [], g3 = 0; g3 < p3.length; ++g3) {
        typeof (t4 = p3[g3]) == "string" && (t4 = a6.certificateFromPem(t4));
        var y3 = g3 === 0 ? u3 : void 0, v2 = a6.certificateToAsn1(t4), m2 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.certBag).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.x509Certificate).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, i2.toDer(v2).getBytes())])])]), y3]);
        d3.push(m2);
      }
      if (d3.length > 0) {
        var E2 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, d3), C = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.data).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, i2.toDer(E2).getBytes())])]);
        f3.push(C);
      }
      var S2 = null;
      if (e4 !== null) {
        var b2 = a6.wrapRsaPrivateKey(a6.privateKeyToAsn1(e4));
        S2 = r4 === null ? i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.keyBag).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [b2]), u3]) : i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.pkcs8ShroudedKeyBag).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [a6.encryptPrivateKeyInfo(b2, r4, o2)]), u3]);
        var T2 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [S2]), _24 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.data).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, i2.toDer(T2).getBytes())])]);
        f3.push(_24);
      }
      var I2, A2 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, f3);
      if (o2.useMac) {
        var B2 = n3.md.sha1.create(), w2 = new n3.util.ByteBuffer(n3.random.getBytes(o2.saltSize)), R = o2.count, N2 = (e4 = s2.generateKey(r4, w2, 3, R, 20), n3.hmac.create());
        N2.start(B2, e4), N2.update(i2.toDer(A2).getBytes());
        var L2 = N2.getMac();
        I2 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.sha1).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")]), i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, L2.getBytes())]), i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, w2.getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(R).getBytes())]);
      }
      return i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(3).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(a6.oids.data).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, i2.toDer(A2).getBytes())])]), I2]);
    }, s2.generateKey = n3.pbe.generatePkcs12Key;
  }, 1559: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(1482), r3(2624), r3(2023), r3(2884), r3(5477), r3(8989), r3(4097), r3(3103), r3(6446);
    var i2 = n3.asn1, a6 = e3.exports = n3.pkcs7 = n3.pkcs7 || {};
    function s2(e4) {
      var t4 = {}, r4 = [];
      if (!i2.validate(e4, a6.asn1.recipientInfoValidator, t4, r4)) {
        var s3 = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        throw s3.errors = r4, s3;
      }
      return { version: t4.version.charCodeAt(0), issuer: n3.pki.RDNAttributesAsArray(t4.issuer), serialNumber: n3.util.createBuffer(t4.serial).toHex(), encryptedContent: { algorithm: i2.derToOid(t4.encAlgorithm), parameter: t4.encParameter ? t4.encParameter.value : void 0, content: t4.encKey } };
    }
    function o(e4) {
      for (var t4, r4 = [], a7 = 0; a7 < e4.length; ++a7)
        r4.push((t4 = e4[a7], i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(t4.version).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [n3.pki.distinguishedNameToAsn1({ attributes: t4.issuer }), i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, n3.util.hexToBytes(t4.serialNumber))]), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(t4.encryptedContent.algorithm).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")]), i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, t4.encryptedContent.content)])));
      return r4;
    }
    function u2(e4) {
      var t4 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(e4.version).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [n3.pki.distinguishedNameToAsn1({ attributes: e4.issuer }), i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, n3.util.hexToBytes(e4.serialNumber))]), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.digestAlgorithm).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")])]);
      if (e4.authenticatedAttributesAsn1 && t4.value.push(e4.authenticatedAttributesAsn1), t4.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.signatureAlgorithm).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")])), t4.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, e4.signature)), e4.unauthenticatedAttributes.length > 0) {
        for (var r4 = i2.create(i2.Class.CONTEXT_SPECIFIC, 1, true, []), a7 = 0; a7 < e4.unauthenticatedAttributes.length; ++a7) {
          var s3 = e4.unauthenticatedAttributes[a7];
          r4.values.push(c2(s3));
        }
        t4.value.push(r4);
      }
      return t4;
    }
    function c2(e4) {
      var t4;
      if (e4.type === n3.pki.oids.contentType)
        t4 = i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.value).getBytes());
      else if (e4.type === n3.pki.oids.messageDigest)
        t4 = i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, e4.value.bytes());
      else if (e4.type === n3.pki.oids.signingTime) {
        var r4 = new Date("1950-01-01T00:00:00Z"), a7 = new Date("2050-01-01T00:00:00Z"), s3 = e4.value;
        if (typeof s3 == "string") {
          var o2 = Date.parse(s3);
          s3 = isNaN(o2) ? s3.length === 13 ? i2.utcTimeToDate(s3) : i2.generalizedTimeToDate(s3) : new Date(o2);
        }
        t4 = s3 >= r4 && s3 < a7 ? i2.create(i2.Class.UNIVERSAL, i2.Type.UTCTIME, false, i2.dateToUtcTime(s3)) : i2.create(i2.Class.UNIVERSAL, i2.Type.GENERALIZEDTIME, false, i2.dateToGeneralizedTime(s3));
      }
      return i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.type).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, [t4])]);
    }
    function l2(e4, t4, r4) {
      var a7 = {};
      if (!i2.validate(t4, r4, a7, [])) {
        var s3 = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        throw s3.errors = s3, s3;
      }
      if (i2.derToOid(a7.contentType) !== n3.pki.oids.data)
        throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
      if (a7.encryptedContent) {
        var o2 = "";
        if (n3.util.isArray(a7.encryptedContent))
          for (var u3 = 0; u3 < a7.encryptedContent.length; ++u3) {
            if (a7.encryptedContent[u3].type !== i2.Type.OCTETSTRING)
              throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
            o2 += a7.encryptedContent[u3].value;
          }
        else
          o2 = a7.encryptedContent;
        e4.encryptedContent = { algorithm: i2.derToOid(a7.encAlgorithm), parameter: n3.util.createBuffer(a7.encParameter.value), content: n3.util.createBuffer(o2) };
      }
      if (a7.content) {
        if (o2 = "", n3.util.isArray(a7.content))
          for (u3 = 0; u3 < a7.content.length; ++u3) {
            if (a7.content[u3].type !== i2.Type.OCTETSTRING)
              throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
            o2 += a7.content[u3].value;
          }
        else
          o2 = a7.content;
        e4.content = n3.util.createBuffer(o2);
      }
      return e4.version = a7.version.charCodeAt(0), e4.rawCapture = a7, a7;
    }
    function h2(e4) {
      if (e4.encryptedContent.key === void 0)
        throw new Error("Symmetric key not available.");
      if (e4.content === void 0) {
        var t4;
        switch (e4.encryptedContent.algorithm) {
          case n3.pki.oids["aes128-CBC"]:
          case n3.pki.oids["aes192-CBC"]:
          case n3.pki.oids["aes256-CBC"]:
            t4 = n3.aes.createDecryptionCipher(e4.encryptedContent.key);
            break;
          case n3.pki.oids.desCBC:
          case n3.pki.oids["des-EDE3-CBC"]:
            t4 = n3.des.createDecryptionCipher(e4.encryptedContent.key);
            break;
          default:
            throw new Error("Unsupported symmetric cipher, OID " + e4.encryptedContent.algorithm);
        }
        if (t4.start(e4.encryptedContent.parameter), t4.update(e4.encryptedContent.content), !t4.finish())
          throw new Error("Symmetric decryption failed.");
        e4.content = t4.output;
      }
    }
    a6.messageFromPem = function(e4) {
      var t4 = n3.pem.decode(e4)[0];
      if (t4.type !== "PKCS7") {
        var r4 = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        throw r4.headerType = t4.type, r4;
      }
      if (t4.procType && t4.procType.type === "ENCRYPTED")
        throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
      var s3 = i2.fromDer(t4.body);
      return a6.messageFromAsn1(s3);
    }, a6.messageToPem = function(e4, t4) {
      var r4 = { type: "PKCS7", body: i2.toDer(e4.toAsn1()).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, a6.messageFromAsn1 = function(e4) {
      var t4 = {}, r4 = [];
      if (!i2.validate(e4, a6.asn1.contentInfoValidator, t4, r4)) {
        var s3 = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        throw s3.errors = r4, s3;
      }
      var o2, u3 = i2.derToOid(t4.contentType);
      switch (u3) {
        case n3.pki.oids.envelopedData:
          o2 = a6.createEnvelopedData();
          break;
        case n3.pki.oids.encryptedData:
          o2 = a6.createEncryptedData();
          break;
        case n3.pki.oids.signedData:
          o2 = a6.createSignedData();
          break;
        default:
          throw new Error("Cannot read PKCS#7 message. ContentType with OID " + u3 + " is not (yet) supported.");
      }
      return o2.fromAsn1(t4.content.value[0]), o2;
    }, a6.createSignedData = function() {
      var e4 = null;
      return e4 = { type: n3.pki.oids.signedData, version: 1, certificates: [], crls: [], signers: [], digestAlgorithmIdentifiers: [], contentInfo: null, signerInfos: [], fromAsn1: function(t4) {
        if (l2(e4, t4, a6.asn1.signedDataValidator), e4.certificates = [], e4.crls = [], e4.digestAlgorithmIdentifiers = [], e4.contentInfo = null, e4.signerInfos = [], e4.rawCapture.certificates)
          for (var r4 = e4.rawCapture.certificates.value, i3 = 0; i3 < r4.length; ++i3)
            e4.certificates.push(n3.pki.certificateFromAsn1(r4[i3]));
      }, toAsn1: function() {
        e4.contentInfo || e4.sign();
        for (var t4 = [], r4 = 0; r4 < e4.certificates.length; ++r4)
          t4.push(n3.pki.certificateToAsn1(e4.certificates[r4]));
        var a7 = [], s3 = i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(e4.version).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, e4.digestAlgorithmIdentifiers), e4.contentInfo])]);
        return t4.length > 0 && s3.value[0].value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, t4)), a7.length > 0 && s3.value[0].value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 1, true, a7)), s3.value[0].value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, e4.signerInfos)), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.type).getBytes()), s3]);
      }, addSigner: function(t4) {
        var r4 = t4.issuer, i3 = t4.serialNumber;
        if (t4.certificate) {
          var a7 = t4.certificate;
          typeof a7 == "string" && (a7 = n3.pki.certificateFromPem(a7)), r4 = a7.issuer.attributes, i3 = a7.serialNumber;
        }
        var s3 = t4.key;
        if (!s3)
          throw new Error("Could not add PKCS#7 signer; no private key specified.");
        typeof s3 == "string" && (s3 = n3.pki.privateKeyFromPem(s3));
        var o2 = t4.digestAlgorithm || n3.pki.oids.sha1;
        switch (o2) {
          case n3.pki.oids.sha1:
          case n3.pki.oids.sha256:
          case n3.pki.oids.sha384:
          case n3.pki.oids.sha512:
          case n3.pki.oids.md5:
            break;
          default:
            throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + o2);
        }
        var u3 = t4.authenticatedAttributes || [];
        if (u3.length > 0) {
          for (var c3 = false, l3 = false, h3 = 0; h3 < u3.length; ++h3) {
            var f2 = u3[h3];
            if (c3 || f2.type !== n3.pki.oids.contentType) {
              if (l3 || f2.type !== n3.pki.oids.messageDigest)
                ;
              else if (l3 = true, c3)
                break;
            } else if (c3 = true, l3)
              break;
          }
          if (!c3 || !l3)
            throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
        }
        e4.signers.push({ key: s3, version: 1, issuer: r4, serialNumber: i3, digestAlgorithm: o2, signatureAlgorithm: n3.pki.oids.rsaEncryption, signature: null, authenticatedAttributes: u3, unauthenticatedAttributes: [] });
      }, sign: function(t4) {
        var r4;
        t4 = t4 || {}, (typeof e4.content != "object" || e4.contentInfo === null) && (e4.contentInfo = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(n3.pki.oids.data).getBytes())]), "content" in e4 && (e4.content instanceof n3.util.ByteBuffer ? r4 = e4.content.bytes() : typeof e4.content == "string" && (r4 = n3.util.encodeUtf8(e4.content)), t4.detached ? e4.detachedContent = i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, r4) : e4.contentInfo.value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, r4)])))), e4.signers.length !== 0 && function(t5) {
          var r5;
          if (!(r5 = e4.detachedContent ? e4.detachedContent : (r5 = e4.contentInfo.value[1]).value[0]))
            throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
          var a7 = i2.derToOid(e4.contentInfo.value[0].value), s3 = i2.toDer(r5);
          for (var o2 in s3.getByte(), i2.getBerValueLength(s3), s3 = s3.getBytes(), t5)
            t5[o2].start().update(s3);
          for (var l3 = new Date(), h3 = 0; h3 < e4.signers.length; ++h3) {
            var f2 = e4.signers[h3];
            if (f2.authenticatedAttributes.length === 0) {
              if (a7 !== n3.pki.oids.data)
                throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
            } else {
              f2.authenticatedAttributesAsn1 = i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, []);
              for (var p2 = i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, []), d2 = 0; d2 < f2.authenticatedAttributes.length; ++d2) {
                var g2 = f2.authenticatedAttributes[d2];
                g2.type === n3.pki.oids.messageDigest ? g2.value = t5[f2.digestAlgorithm].digest() : g2.type === n3.pki.oids.signingTime && (g2.value || (g2.value = l3)), p2.value.push(c2(g2)), f2.authenticatedAttributesAsn1.value.push(c2(g2));
              }
              s3 = i2.toDer(p2).getBytes(), f2.md.start().update(s3);
            }
            f2.signature = f2.key.sign(f2.md, "RSASSA-PKCS1-V1_5");
          }
          e4.signerInfos = function(e5) {
            for (var t6 = [], r6 = 0; r6 < e5.length; ++r6)
              t6.push(u2(e5[r6]));
            return t6;
          }(e4.signers);
        }(function() {
          for (var t5 = {}, r5 = 0; r5 < e4.signers.length; ++r5) {
            var a7 = e4.signers[r5];
            (s3 = a7.digestAlgorithm) in t5 || (t5[s3] = n3.md[n3.pki.oids[s3]].create()), a7.authenticatedAttributes.length === 0 ? a7.md = t5[s3] : a7.md = n3.md[n3.pki.oids[s3]].create();
          }
          for (var s3 in e4.digestAlgorithmIdentifiers = [], t5)
            e4.digestAlgorithmIdentifiers.push(i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(s3).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")]));
          return t5;
        }());
      }, verify: function() {
        throw new Error("PKCS#7 signature verification not yet implemented.");
      }, addCertificate: function(t4) {
        typeof t4 == "string" && (t4 = n3.pki.certificateFromPem(t4)), e4.certificates.push(t4);
      }, addCertificateRevokationList: function(e5) {
        throw new Error("PKCS#7 CRL support not yet implemented.");
      } };
    }, a6.createEncryptedData = function() {
      var e4 = null;
      return e4 = { type: n3.pki.oids.encryptedData, version: 0, encryptedContent: { algorithm: n3.pki.oids["aes256-CBC"] }, fromAsn1: function(t4) {
        l2(e4, t4, a6.asn1.encryptedDataValidator);
      }, decrypt: function(t4) {
        t4 !== void 0 && (e4.encryptedContent.key = t4), h2(e4);
      } };
    }, a6.createEnvelopedData = function() {
      var e4 = null;
      return e4 = { type: n3.pki.oids.envelopedData, version: 0, recipients: [], encryptedContent: { algorithm: n3.pki.oids["aes256-CBC"] }, fromAsn1: function(t4) {
        var r4 = l2(e4, t4, a6.asn1.envelopedDataValidator);
        e4.recipients = function(e5) {
          for (var t5 = [], r5 = 0; r5 < e5.length; ++r5)
            t5.push(s2(e5[r5]));
          return t5;
        }(r4.recipientInfos.value);
      }, toAsn1: function() {
        return i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.type).getBytes()), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(e4.version).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, o(e4.recipients)), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, (t4 = e4.encryptedContent, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(n3.pki.oids.data).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(t4.algorithm).getBytes()), t4.parameter ? i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, t4.parameter.getBytes()) : void 0]), i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, t4.content.getBytes())])]))])])]);
        var t4;
      }, findRecipient: function(t4) {
        for (var r4 = t4.issuer.attributes, n4 = 0; n4 < e4.recipients.length; ++n4) {
          var i3 = e4.recipients[n4], a7 = i3.issuer;
          if (i3.serialNumber === t4.serialNumber && a7.length === r4.length) {
            for (var s3 = true, o2 = 0; o2 < r4.length; ++o2)
              if (a7[o2].type !== r4[o2].type || a7[o2].value !== r4[o2].value) {
                s3 = false;
                break;
              }
            if (s3)
              return i3;
          }
        }
        return null;
      }, decrypt: function(t4, r4) {
        if (e4.encryptedContent.key === void 0 && t4 !== void 0 && r4 !== void 0)
          switch (t4.encryptedContent.algorithm) {
            case n3.pki.oids.rsaEncryption:
            case n3.pki.oids.desCBC:
              var i3 = r4.decrypt(t4.encryptedContent.content);
              e4.encryptedContent.key = n3.util.createBuffer(i3);
              break;
            default:
              throw new Error("Unsupported asymmetric cipher, OID " + t4.encryptedContent.algorithm);
          }
        h2(e4);
      }, addRecipient: function(t4) {
        e4.recipients.push({ version: 0, issuer: t4.issuer.attributes, serialNumber: t4.serialNumber, encryptedContent: { algorithm: n3.pki.oids.rsaEncryption, key: t4.publicKey } });
      }, encrypt: function(t4, r4) {
        if (e4.encryptedContent.content === void 0) {
          var i3, a7, s3;
          switch (r4 = r4 || e4.encryptedContent.algorithm, t4 = t4 || e4.encryptedContent.key, r4) {
            case n3.pki.oids["aes128-CBC"]:
              i3 = 16, a7 = 16, s3 = n3.aes.createEncryptionCipher;
              break;
            case n3.pki.oids["aes192-CBC"]:
              i3 = 24, a7 = 16, s3 = n3.aes.createEncryptionCipher;
              break;
            case n3.pki.oids["aes256-CBC"]:
              i3 = 32, a7 = 16, s3 = n3.aes.createEncryptionCipher;
              break;
            case n3.pki.oids["des-EDE3-CBC"]:
              i3 = 24, a7 = 8, s3 = n3.des.createEncryptionCipher;
              break;
            default:
              throw new Error("Unsupported symmetric cipher, OID " + r4);
          }
          if (t4 === void 0)
            t4 = n3.util.createBuffer(n3.random.getBytes(i3));
          else if (t4.length() != i3)
            throw new Error("Symmetric key has wrong length; got " + t4.length() + " bytes, expected " + i3 + ".");
          e4.encryptedContent.algorithm = r4, e4.encryptedContent.key = t4, e4.encryptedContent.parameter = n3.util.createBuffer(n3.random.getBytes(a7));
          var o2 = s3(t4);
          if (o2.start(e4.encryptedContent.parameter.copy()), o2.update(e4.content), !o2.finish())
            throw new Error("Symmetric encryption failed.");
          e4.encryptedContent.content = o2.output;
        }
        for (var u3 = 0; u3 < e4.recipients.length; ++u3) {
          var c3 = e4.recipients[u3];
          if (c3.encryptedContent.content === void 0) {
            if (c3.encryptedContent.algorithm !== n3.pki.oids.rsaEncryption)
              throw new Error("Unsupported asymmetric cipher, OID " + c3.encryptedContent.algorithm);
            c3.encryptedContent.content = c3.encryptedContent.key.encrypt(e4.encryptedContent.key.data);
          }
        }
      } };
    };
  }, 8989: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(2624), r3(3103);
    var i2 = n3.asn1, a6 = e3.exports = n3.pkcs7asn1 = n3.pkcs7asn1 || {};
    n3.pkcs7 = n3.pkcs7 || {}, n3.pkcs7.asn1 = a6;
    var s2 = { name: "ContentInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "ContentInfo.ContentType", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "contentType" }, { name: "ContentInfo.content", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, constructed: true, optional: true, captureAsn1: "content" }] };
    a6.contentInfoValidator = s2;
    var o = { name: "EncryptedContentInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "EncryptedContentInfo.contentType", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "contentType" }, { name: "EncryptedContentInfo.contentEncryptionAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "encAlgorithm" }, { name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter", tagClass: i2.Class.UNIVERSAL, captureAsn1: "encParameter" }] }, { name: "EncryptedContentInfo.encryptedContent", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, capture: "encryptedContent", captureAsn1: "encryptedContentAsn1" }] };
    a6.envelopedDataValidator = { name: "EnvelopedData", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "EnvelopedData.Version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "version" }, { name: "EnvelopedData.RecipientInfos", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SET, constructed: true, captureAsn1: "recipientInfos" }].concat(o) }, a6.encryptedDataValidator = { name: "EncryptedData", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "EncryptedData.Version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "version" }].concat(o) };
    var u2 = { name: "SignerInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "SignerInfo.version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false }, { name: "SignerInfo.issuerAndSerialNumber", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "SignerInfo.issuerAndSerialNumber.issuer", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "issuer" }, { name: "SignerInfo.issuerAndSerialNumber.serialNumber", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "serial" }] }, { name: "SignerInfo.digestAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "SignerInfo.digestAlgorithm.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "digestAlgorithm" }, { name: "SignerInfo.digestAlgorithm.parameter", tagClass: i2.Class.UNIVERSAL, constructed: false, captureAsn1: "digestParameter", optional: true }] }, { name: "SignerInfo.authenticatedAttributes", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, constructed: true, optional: true, capture: "authenticatedAttributes" }, { name: "SignerInfo.digestEncryptionAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, capture: "signatureAlgorithm" }, { name: "SignerInfo.encryptedDigest", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OCTETSTRING, constructed: false, capture: "signature" }, { name: "SignerInfo.unauthenticatedAttributes", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 1, constructed: true, optional: true, capture: "unauthenticatedAttributes" }] };
    a6.signedDataValidator = { name: "SignedData", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "SignedData.Version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "version" }, { name: "SignedData.DigestAlgorithms", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SET, constructed: true, captureAsn1: "digestAlgorithms" }, s2, { name: "SignedData.Certificates", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, optional: true, captureAsn1: "certificates" }, { name: "SignedData.CertificateRevocationLists", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 1, optional: true, captureAsn1: "crls" }, { name: "SignedData.SignerInfos", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SET, capture: "signerInfos", optional: true, value: [u2] }] }, a6.recipientInfoValidator = { name: "RecipientInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "RecipientInfo.version", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "version" }, { name: "RecipientInfo.issuerAndSerial", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "RecipientInfo.issuerAndSerial.issuer", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "issuer" }, { name: "RecipientInfo.issuerAndSerial.serialNumber", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "serial" }] }, { name: "RecipientInfo.keyEncryptionAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "RecipientInfo.keyEncryptionAlgorithm.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "encAlgorithm" }, { name: "RecipientInfo.keyEncryptionAlgorithm.parameter", tagClass: i2.Class.UNIVERSAL, constructed: false, captureAsn1: "encParameter", optional: true }] }, { name: "RecipientInfo.encryptedKey", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OCTETSTRING, constructed: false, capture: "encKey" }] };
  }, 4885: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(2624), r3(2884), r3(6635), r3(5477), r3(9580), r3(779), r3(665), r3(144), r3(3103), r3(6446);
    var i2 = n3.asn1, a6 = e3.exports = n3.pki = n3.pki || {};
    a6.pemToDer = function(e4) {
      var t4 = n3.pem.decode(e4)[0];
      if (t4.procType && t4.procType.type === "ENCRYPTED")
        throw new Error("Could not convert PEM to DER; PEM is encrypted.");
      return n3.util.createBuffer(t4.body);
    }, a6.privateKeyFromPem = function(e4) {
      var t4 = n3.pem.decode(e4)[0];
      if (t4.type !== "PRIVATE KEY" && t4.type !== "RSA PRIVATE KEY") {
        var r4 = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
        throw r4.headerType = t4.type, r4;
      }
      if (t4.procType && t4.procType.type === "ENCRYPTED")
        throw new Error("Could not convert private key from PEM; PEM is encrypted.");
      var s2 = i2.fromDer(t4.body);
      return a6.privateKeyFromAsn1(s2);
    }, a6.privateKeyToPem = function(e4, t4) {
      var r4 = { type: "RSA PRIVATE KEY", body: i2.toDer(a6.privateKeyToAsn1(e4)).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, a6.privateKeyInfoToPem = function(e4, t4) {
      var r4 = { type: "PRIVATE KEY", body: i2.toDer(e4).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    };
  }, 8547: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103), r3(1633), r3(4097), function() {
      if (n3.prime)
        e3.exports = n3.prime;
      else {
        var t4 = e3.exports = n3.prime = n3.prime || {}, r4 = n3.jsbn.BigInteger, i2 = [6, 4, 2, 4, 2, 4, 6, 2], a6 = new r4(null);
        a6.fromInt(30);
        var s2 = function(e4, t5) {
          return e4 | t5;
        };
        t4.generateProbablePrime = function(e4, t5, i3) {
          typeof t5 == "function" && (i3 = t5, t5 = {});
          var a7 = (t5 = t5 || {}).algorithm || "PRIMEINC";
          typeof a7 == "string" && (a7 = { name: a7 }), a7.options = a7.options || {};
          var s3 = t5.prng || n3.random, u3 = { nextBytes: function(e5) {
            for (var t6 = s3.getBytesSync(e5.length), r5 = 0; r5 < e5.length; ++r5)
              e5[r5] = t6.charCodeAt(r5);
          } };
          if (a7.name === "PRIMEINC")
            return function(e5, t6, i4, a8) {
              return "workers" in i4 ? function(e6, t7, i5, a9) {
                if (typeof Worker == "undefined")
                  return o(e6, t7, i5, a9);
                var s4 = c2(e6, t7), u4 = i5.workers, l2 = i5.workLoad || 100, h2 = 30 * l2 / 8, f2 = i5.workerScript || "forge/prime.worker.js";
                if (u4 === -1)
                  return n3.util.estimateCores(function(e7, t8) {
                    e7 && (t8 = 2), u4 = t8 - 1, p2();
                  });
                function p2() {
                  u4 = Math.max(1, u4);
                  for (var n4 = [], i6 = 0; i6 < u4; ++i6)
                    n4[i6] = new Worker(f2);
                  for (i6 = 0; i6 < u4; ++i6)
                    n4[i6].addEventListener("message", p3);
                  var o2 = false;
                  function p3(i7) {
                    if (!o2) {
                      var u5 = i7.data;
                      if (u5.found) {
                        for (var f3 = 0; f3 < n4.length; ++f3)
                          n4[f3].terminate();
                        return o2 = true, a9(null, new r4(u5.prime, 16));
                      }
                      s4.bitLength() > e6 && (s4 = c2(e6, t7));
                      var p4 = s4.toString(16);
                      i7.target.postMessage({ hex: p4, workLoad: l2 }), s4.dAddOffset(h2, 0);
                    }
                  }
                }
                p2();
              }(e5, t6, i4, a8) : o(e5, t6, i4, a8);
            }(e4, u3, a7.options, i3);
          throw new Error("Invalid prime generation algorithm: " + a7.name);
        };
      }
      function o(e4, t5, r5, n4) {
        var i3 = c2(e4, t5), a7 = function(e5) {
          return e5 <= 100 ? 27 : e5 <= 150 ? 18 : e5 <= 200 ? 15 : e5 <= 250 ? 12 : e5 <= 300 ? 9 : e5 <= 350 ? 8 : e5 <= 400 ? 7 : e5 <= 500 ? 6 : e5 <= 600 ? 5 : e5 <= 800 ? 4 : e5 <= 1250 ? 3 : 2;
        }(i3.bitLength());
        "millerRabinTests" in r5 && (a7 = r5.millerRabinTests);
        var s3 = 10;
        "maxBlockTime" in r5 && (s3 = r5.maxBlockTime), u2(i3, e4, t5, 0, a7, s3, n4);
      }
      function u2(e4, t5, r5, a7, s3, o2, l2) {
        var h2 = +new Date();
        do {
          if (e4.bitLength() > t5 && (e4 = c2(t5, r5)), e4.isProbablePrime(s3))
            return l2(null, e4);
          e4.dAddOffset(i2[a7++ % 8], 0);
        } while (o2 < 0 || +new Date() - h2 < o2);
        n3.util.setImmediate(function() {
          u2(e4, t5, r5, a7, s3, o2, l2);
        });
      }
      function c2(e4, t5) {
        var n4 = new r4(e4, t5), i3 = e4 - 1;
        return n4.testBit(i3) || n4.bitwiseTo(r4.ONE.shiftLeft(i3), s2, n4), n4.dAddOffset(31 - n4.mod(a6).byteValue(), 0), n4;
      }
    }();
  }, 3930: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103);
    var i2 = null;
    !n3.util.isNodejs || n3.options.usePureJavaScript || process.versions["node-webkit"] || (i2 = r3(5942)), (e3.exports = n3.prng = n3.prng || {}).create = function(e4) {
      for (var t4 = { plugin: e4, key: null, seed: null, time: null, reseeds: 0, generated: 0, keyBytes: "" }, r4 = e4.md, a6 = new Array(32), s2 = 0; s2 < 32; ++s2)
        a6[s2] = r4.create();
      function o() {
        if (t4.pools[0].messageLength >= 32)
          return u2();
        var e5 = 32 - t4.pools[0].messageLength << 5;
        t4.collect(t4.seedFileSync(e5)), u2();
      }
      function u2() {
        t4.reseeds = t4.reseeds === 4294967295 ? 0 : t4.reseeds + 1;
        var e5 = t4.plugin.md.create();
        e5.update(t4.keyBytes);
        for (var r5 = 1, n4 = 0; n4 < 32; ++n4)
          t4.reseeds % r5 == 0 && (e5.update(t4.pools[n4].digest().getBytes()), t4.pools[n4].start()), r5 <<= 1;
        t4.keyBytes = e5.digest().getBytes(), e5.start(), e5.update(t4.keyBytes);
        var i3 = e5.digest().getBytes();
        t4.key = t4.plugin.formatKey(t4.keyBytes), t4.seed = t4.plugin.formatSeed(i3), t4.generated = 0;
      }
      function c2(e5) {
        var t5 = null, r5 = n3.util.globalScope, i3 = r5.crypto || r5.msCrypto;
        i3 && i3.getRandomValues && (t5 = function(e6) {
          return i3.getRandomValues(e6);
        });
        var a7 = n3.util.createBuffer();
        if (t5)
          for (; a7.length() < e5; ) {
            var s3 = Math.max(1, Math.min(e5 - a7.length(), 65536) / 4), o2 = new Uint32Array(Math.floor(s3));
            try {
              t5(o2);
              for (var u3 = 0; u3 < o2.length; ++u3)
                a7.putInt32(o2[u3]);
            } catch (e6) {
              if (!(typeof QuotaExceededError != "undefined" && e6 instanceof QuotaExceededError))
                throw e6;
            }
          }
        if (a7.length() < e5)
          for (var c3, l2, h2, f2 = Math.floor(65536 * Math.random()); a7.length() < e5; )
            for (l2 = 16807 * (65535 & f2), l2 += (32767 & (c3 = 16807 * (f2 >> 16))) << 16, f2 = 4294967295 & (l2 = (2147483647 & (l2 += c3 >> 15)) + (l2 >> 31)), u3 = 0; u3 < 3; ++u3)
              h2 = f2 >>> (u3 << 3), h2 ^= Math.floor(256 * Math.random()), a7.putByte(255 & h2);
        return a7.getBytes(e5);
      }
      return t4.pools = a6, t4.pool = 0, t4.generate = function(e5, r5) {
        if (!r5)
          return t4.generateSync(e5);
        var i3 = t4.plugin.cipher, a7 = t4.plugin.increment, s3 = t4.plugin.formatKey, o2 = t4.plugin.formatSeed, c3 = n3.util.createBuffer();
        t4.key = null, function l2(h2) {
          if (h2)
            return r5(h2);
          if (c3.length() >= e5)
            return r5(null, c3.getBytes(e5));
          if (t4.generated > 1048575 && (t4.key = null), t4.key === null)
            return n3.util.nextTick(function() {
              !function(e6) {
                if (t4.pools[0].messageLength >= 32)
                  return u2(), e6();
                var r6 = 32 - t4.pools[0].messageLength << 5;
                t4.seedFile(r6, function(r7, n4) {
                  if (r7)
                    return e6(r7);
                  t4.collect(n4), u2(), e6();
                });
              }(l2);
            });
          var f2 = i3(t4.key, t4.seed);
          t4.generated += f2.length, c3.putBytes(f2), t4.key = s3(i3(t4.key, a7(t4.seed))), t4.seed = o2(i3(t4.key, t4.seed)), n3.util.setImmediate(l2);
        }();
      }, t4.generateSync = function(e5) {
        var r5 = t4.plugin.cipher, i3 = t4.plugin.increment, a7 = t4.plugin.formatKey, s3 = t4.plugin.formatSeed;
        t4.key = null;
        for (var u3 = n3.util.createBuffer(); u3.length() < e5; ) {
          t4.generated > 1048575 && (t4.key = null), t4.key === null && o();
          var c3 = r5(t4.key, t4.seed);
          t4.generated += c3.length, u3.putBytes(c3), t4.key = a7(r5(t4.key, i3(t4.seed))), t4.seed = s3(r5(t4.key, t4.seed));
        }
        return u3.getBytes(e5);
      }, i2 ? (t4.seedFile = function(e5, t5) {
        i2.randomBytes(e5, function(e6, r5) {
          if (e6)
            return t5(e6);
          t5(null, r5.toString());
        });
      }, t4.seedFileSync = function(e5) {
        return i2.randomBytes(e5).toString();
      }) : (t4.seedFile = function(e5, t5) {
        try {
          t5(null, c2(e5));
        } catch (e6) {
          t5(e6);
        }
      }, t4.seedFileSync = c2), t4.collect = function(e5) {
        for (var r5 = e5.length, n4 = 0; n4 < r5; ++n4)
          t4.pools[t4.pool].update(e5.substr(n4, 1)), t4.pool = t4.pool === 31 ? 0 : t4.pool + 1;
      }, t4.collectInt = function(e5, r5) {
        for (var n4 = "", i3 = 0; i3 < r5; i3 += 8)
          n4 += String.fromCharCode(e5 >> i3 & 255);
        t4.collect(n4);
      }, t4.registerWorker = function(e5) {
        e5 === self ? t4.seedFile = function(e6, t5) {
          self.addEventListener("message", function e7(r5) {
            var n4 = r5.data;
            n4.forge && n4.forge.prng && (self.removeEventListener("message", e7), t5(n4.forge.prng.err, n4.forge.prng.bytes));
          }), self.postMessage({ forge: { prng: { needed: e6 } } });
        } : e5.addEventListener("message", function(r5) {
          var n4 = r5.data;
          n4.forge && n4.forge.prng && t4.seedFile(n4.forge.prng.needed, function(t5, r6) {
            e5.postMessage({ forge: { prng: { err: t5, bytes: r6 } } });
          });
        });
      }, t4;
    };
  }, 665: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(4097), r3(3103), (e3.exports = n3.pss = n3.pss || {}).create = function(e4) {
      arguments.length === 3 && (e4 = { md: arguments[0], mgf: arguments[1], saltLength: arguments[2] });
      var t4, r4 = e4.md, i2 = e4.mgf, a6 = r4.digestLength, s2 = e4.salt || null;
      if (typeof s2 == "string" && (s2 = n3.util.createBuffer(s2)), "saltLength" in e4)
        t4 = e4.saltLength;
      else {
        if (s2 === null)
          throw new Error("Salt length not specified or specific salt not given.");
        t4 = s2.length();
      }
      if (s2 !== null && s2.length() !== t4)
        throw new Error("Given salt length does not match length of given salt.");
      var o = e4.prng || n3.random, u2 = { encode: function(e5, u3) {
        var c2, l2, h2 = u3 - 1, f2 = Math.ceil(h2 / 8), p2 = e5.digest().getBytes();
        if (f2 < a6 + t4 + 2)
          throw new Error("Message is too long to encrypt.");
        l2 = s2 === null ? o.getBytesSync(t4) : s2.bytes();
        var d2 = new n3.util.ByteBuffer();
        d2.fillWithByte(0, 8), d2.putBytes(p2), d2.putBytes(l2), r4.start(), r4.update(d2.getBytes());
        var g2 = r4.digest().getBytes(), y2 = new n3.util.ByteBuffer();
        y2.fillWithByte(0, f2 - t4 - a6 - 2), y2.putByte(1), y2.putBytes(l2);
        var v2 = y2.getBytes(), m2 = f2 - a6 - 1, E2 = i2.generate(g2, m2), C = "";
        for (c2 = 0; c2 < m2; c2++)
          C += String.fromCharCode(v2.charCodeAt(c2) ^ E2.charCodeAt(c2));
        var S2 = 65280 >> 8 * f2 - h2 & 255;
        return (C = String.fromCharCode(C.charCodeAt(0) & ~S2) + C.substr(1)) + g2 + String.fromCharCode(188);
      }, verify: function(e5, s3, o2) {
        var u3, c2 = o2 - 1, l2 = Math.ceil(c2 / 8);
        if (s3 = s3.substr(-l2), l2 < a6 + t4 + 2)
          throw new Error("Inconsistent parameters to PSS signature verification.");
        if (s3.charCodeAt(l2 - 1) !== 188)
          throw new Error("Encoded message does not end in 0xBC.");
        var h2 = l2 - a6 - 1, f2 = s3.substr(0, h2), p2 = s3.substr(h2, a6), d2 = 65280 >> 8 * l2 - c2 & 255;
        if ((f2.charCodeAt(0) & d2) != 0)
          throw new Error("Bits beyond keysize not zero as expected.");
        var g2 = i2.generate(p2, h2), y2 = "";
        for (u3 = 0; u3 < h2; u3++)
          y2 += String.fromCharCode(f2.charCodeAt(u3) ^ g2.charCodeAt(u3));
        y2 = String.fromCharCode(y2.charCodeAt(0) & ~d2) + y2.substr(1);
        var v2 = l2 - a6 - t4 - 2;
        for (u3 = 0; u3 < v2; u3++)
          if (y2.charCodeAt(u3) !== 0)
            throw new Error("Leftmost octets not zero as expected");
        if (y2.charCodeAt(v2) !== 1)
          throw new Error("Inconsistent PSS signature, 0x01 marker not found");
        var m2 = y2.substr(-t4), E2 = new n3.util.ByteBuffer();
        return E2.fillWithByte(0, 8), E2.putBytes(e5), E2.putBytes(m2), r4.start(), r4.update(E2.getBytes()), p2 === r4.digest().getBytes();
      } };
      return u2;
    };
  }, 4097: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(1482), r3(9141), r3(3930), r3(3103), n3.random && n3.random.getBytes ? e3.exports = n3.random : function(t4) {
      var r4 = {}, i2 = new Array(4), a6 = n3.util.createBuffer();
      function s2() {
        var e4 = n3.prng.create(r4);
        return e4.getBytes = function(t5, r5) {
          return e4.generate(t5, r5);
        }, e4.getBytesSync = function(t5) {
          return e4.generate(t5);
        }, e4;
      }
      r4.formatKey = function(e4) {
        var t5 = n3.util.createBuffer(e4);
        return (e4 = new Array(4))[0] = t5.getInt32(), e4[1] = t5.getInt32(), e4[2] = t5.getInt32(), e4[3] = t5.getInt32(), n3.aes._expandKey(e4, false);
      }, r4.formatSeed = function(e4) {
        var t5 = n3.util.createBuffer(e4);
        return (e4 = new Array(4))[0] = t5.getInt32(), e4[1] = t5.getInt32(), e4[2] = t5.getInt32(), e4[3] = t5.getInt32(), e4;
      }, r4.cipher = function(e4, t5) {
        return n3.aes._updateBlock(e4, t5, i2, false), a6.putInt32(i2[0]), a6.putInt32(i2[1]), a6.putInt32(i2[2]), a6.putInt32(i2[3]), a6.getBytes();
      }, r4.increment = function(e4) {
        return ++e4[3], e4;
      }, r4.md = n3.md.sha256;
      var o = s2(), u2 = null, c2 = n3.util.globalScope, l2 = c2.crypto || c2.msCrypto;
      if (l2 && l2.getRandomValues && (u2 = function(e4) {
        return l2.getRandomValues(e4);
      }), n3.options.usePureJavaScript || !n3.util.isNodejs && !u2) {
        if (o.collectInt(+new Date(), 32), typeof navigator != "undefined") {
          var h2 = "";
          for (var f2 in navigator)
            try {
              typeof navigator[f2] == "string" && (h2 += navigator[f2]);
            } catch (e4) {
            }
          o.collect(h2), h2 = null;
        }
        t4 && (t4().mousemove(function(e4) {
          o.collectInt(e4.clientX, 16), o.collectInt(e4.clientY, 16);
        }), t4().keypress(function(e4) {
          o.collectInt(e4.charCode, 8);
        }));
      }
      if (n3.random)
        for (var f2 in o)
          n3.random[f2] = o[f2];
      else
        n3.random = o;
      n3.random.createInstance = s2, e3.exports = n3.random;
    }(typeof jQuery != "undefined" ? jQuery : null);
  }, 3323: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(3103);
    var i2 = [217, 120, 249, 196, 25, 221, 181, 237, 40, 233, 253, 121, 74, 160, 216, 157, 198, 126, 55, 131, 43, 118, 83, 142, 98, 76, 100, 136, 68, 139, 251, 162, 23, 154, 89, 245, 135, 179, 79, 19, 97, 69, 109, 141, 9, 129, 125, 50, 189, 143, 64, 235, 134, 183, 123, 11, 240, 149, 33, 34, 92, 107, 78, 130, 84, 214, 101, 147, 206, 96, 178, 28, 115, 86, 192, 20, 167, 140, 241, 220, 18, 117, 202, 31, 59, 190, 228, 209, 66, 61, 212, 48, 163, 60, 182, 38, 111, 191, 14, 218, 70, 105, 7, 87, 39, 242, 29, 155, 188, 148, 67, 3, 248, 17, 199, 246, 144, 239, 62, 231, 6, 195, 213, 47, 200, 102, 30, 215, 8, 232, 234, 222, 128, 82, 238, 247, 132, 170, 114, 172, 53, 77, 106, 42, 150, 26, 210, 113, 90, 21, 73, 116, 75, 159, 208, 94, 4, 24, 164, 236, 194, 224, 65, 110, 15, 81, 203, 204, 36, 145, 175, 80, 161, 244, 112, 57, 153, 124, 58, 133, 35, 184, 180, 122, 252, 2, 54, 91, 37, 85, 151, 49, 45, 93, 250, 152, 227, 138, 146, 174, 5, 223, 41, 16, 103, 108, 186, 201, 211, 0, 230, 207, 225, 158, 168, 44, 99, 22, 1, 63, 88, 226, 137, 169, 13, 56, 52, 27, 171, 51, 255, 176, 187, 72, 12, 95, 185, 177, 205, 46, 197, 243, 219, 71, 229, 165, 156, 119, 10, 166, 32, 104, 254, 127, 193, 173], a6 = [1, 2, 3, 5], s2 = function(e4, t4) {
      return e4 << t4 & 65535 | (65535 & e4) >> 16 - t4;
    }, o = function(e4, t4) {
      return (65535 & e4) >> t4 | e4 << 16 - t4 & 65535;
    };
    e3.exports = n3.rc2 = n3.rc2 || {}, n3.rc2.expandKey = function(e4, t4) {
      typeof e4 == "string" && (e4 = n3.util.createBuffer(e4)), t4 = t4 || 128;
      var r4, a7 = e4, s3 = e4.length(), o2 = t4, u3 = Math.ceil(o2 / 8), c2 = 255 >> (7 & o2);
      for (r4 = s3; r4 < 128; r4++)
        a7.putByte(i2[a7.at(r4 - 1) + a7.at(r4 - s3) & 255]);
      for (a7.setAt(128 - u3, i2[a7.at(128 - u3) & c2]), r4 = 127 - u3; r4 >= 0; r4--)
        a7.setAt(r4, i2[a7.at(r4 + 1) ^ a7.at(r4 + u3)]);
      return a7;
    };
    var u2 = function(e4, t4, r4) {
      var i3, u3, c2, l2, h2 = false, f2 = null, p2 = null, d2 = null, g2 = [];
      for (e4 = n3.rc2.expandKey(e4, t4), c2 = 0; c2 < 64; c2++)
        g2.push(e4.getInt16Le());
      r4 ? (i3 = function(e5) {
        for (c2 = 0; c2 < 4; c2++)
          e5[c2] += g2[l2] + (e5[(c2 + 3) % 4] & e5[(c2 + 2) % 4]) + (~e5[(c2 + 3) % 4] & e5[(c2 + 1) % 4]), e5[c2] = s2(e5[c2], a6[c2]), l2++;
      }, u3 = function(e5) {
        for (c2 = 0; c2 < 4; c2++)
          e5[c2] += g2[63 & e5[(c2 + 3) % 4]];
      }) : (i3 = function(e5) {
        for (c2 = 3; c2 >= 0; c2--)
          e5[c2] = o(e5[c2], a6[c2]), e5[c2] -= g2[l2] + (e5[(c2 + 3) % 4] & e5[(c2 + 2) % 4]) + (~e5[(c2 + 3) % 4] & e5[(c2 + 1) % 4]), l2--;
      }, u3 = function(e5) {
        for (c2 = 3; c2 >= 0; c2--)
          e5[c2] -= g2[63 & e5[(c2 + 3) % 4]];
      });
      var y2 = function(e5) {
        var t5 = [];
        for (c2 = 0; c2 < 4; c2++) {
          var n4 = f2.getInt16Le();
          d2 !== null && (r4 ? n4 ^= d2.getInt16Le() : d2.putInt16Le(n4)), t5.push(65535 & n4);
        }
        l2 = r4 ? 0 : 63;
        for (var i4 = 0; i4 < e5.length; i4++)
          for (var a7 = 0; a7 < e5[i4][0]; a7++)
            e5[i4][1](t5);
        for (c2 = 0; c2 < 4; c2++)
          d2 !== null && (r4 ? d2.putInt16Le(t5[c2]) : t5[c2] ^= d2.getInt16Le()), p2.putInt16Le(t5[c2]);
      }, v2 = null;
      return v2 = { start: function(e5, t5) {
        e5 && typeof e5 == "string" && (e5 = n3.util.createBuffer(e5)), h2 = false, f2 = n3.util.createBuffer(), p2 = t5 || new n3.util.createBuffer(), d2 = e5, v2.output = p2;
      }, update: function(e5) {
        for (h2 || f2.putBuffer(e5); f2.length() >= 8; )
          y2([[5, i3], [1, u3], [6, i3], [1, u3], [5, i3]]);
      }, finish: function(e5) {
        var t5 = true;
        if (r4)
          if (e5)
            t5 = e5(8, f2, !r4);
          else {
            var n4 = f2.length() === 8 ? 8 : 8 - f2.length();
            f2.fillWithByte(n4, n4);
          }
        if (t5 && (h2 = true, v2.update()), !r4 && (t5 = f2.length() === 0))
          if (e5)
            t5 = e5(8, p2, !r4);
          else {
            var i4 = p2.length(), a7 = p2.at(i4 - 1);
            a7 > i4 ? t5 = false : p2.truncate(a7);
          }
        return t5;
      } };
    };
    n3.rc2.startEncrypting = function(e4, t4, r4) {
      var i3 = n3.rc2.createEncryptionCipher(e4, 128);
      return i3.start(t4, r4), i3;
    }, n3.rc2.createEncryptionCipher = function(e4, t4) {
      return u2(e4, t4, true);
    }, n3.rc2.startDecrypting = function(e4, t4, r4) {
      var i3 = n3.rc2.createDecryptionCipher(e4, 128);
      return i3.start(t4, r4), i3;
    }, n3.rc2.createDecryptionCipher = function(e4, t4) {
      return u2(e4, t4, false);
    };
  }, 144: (e3, t3, r3) => {
    var n3 = r3(7768);
    if (r3(2624), r3(1633), r3(2884), r3(4034), r3(8547), r3(4097), r3(3103), i2 === void 0)
      var i2 = n3.jsbn.BigInteger;
    var a6 = n3.util.isNodejs ? r3(5942) : null, s2 = n3.asn1, o = n3.util;
    n3.pki = n3.pki || {}, e3.exports = n3.pki.rsa = n3.rsa = n3.rsa || {};
    var u2 = n3.pki, c2 = [6, 4, 2, 4, 2, 4, 6, 2], l2 = { name: "PrivateKeyInfo", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "PrivateKeyInfo.version", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyVersion" }, { name: "PrivateKeyInfo.privateKeyAlgorithm", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: s2.Class.UNIVERSAL, type: s2.Type.OID, constructed: false, capture: "privateKeyOid" }] }, { name: "PrivateKeyInfo", tagClass: s2.Class.UNIVERSAL, type: s2.Type.OCTETSTRING, constructed: false, capture: "privateKey" }] }, h2 = { name: "RSAPrivateKey", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "RSAPrivateKey.version", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyVersion" }, { name: "RSAPrivateKey.modulus", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyModulus" }, { name: "RSAPrivateKey.publicExponent", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyPublicExponent" }, { name: "RSAPrivateKey.privateExponent", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyPrivateExponent" }, { name: "RSAPrivateKey.prime1", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyPrime1" }, { name: "RSAPrivateKey.prime2", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyPrime2" }, { name: "RSAPrivateKey.exponent1", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyExponent1" }, { name: "RSAPrivateKey.exponent2", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyExponent2" }, { name: "RSAPrivateKey.coefficient", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "privateKeyCoefficient" }] }, f2 = { name: "RSAPublicKey", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "RSAPublicKey.modulus", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "publicKeyModulus" }, { name: "RSAPublicKey.exponent", tagClass: s2.Class.UNIVERSAL, type: s2.Type.INTEGER, constructed: false, capture: "publicKeyExponent" }] }, p2 = n3.pki.rsa.publicKeyValidator = { name: "SubjectPublicKeyInfo", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, captureAsn1: "subjectPublicKeyInfo", value: [{ name: "SubjectPublicKeyInfo.AlgorithmIdentifier", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: s2.Class.UNIVERSAL, type: s2.Type.OID, constructed: false, capture: "publicKeyOid" }] }, { name: "SubjectPublicKeyInfo.subjectPublicKey", tagClass: s2.Class.UNIVERSAL, type: s2.Type.BITSTRING, constructed: false, value: [{ name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, optional: true, captureAsn1: "rsaPublicKey" }] }] }, d2 = { name: "DigestInfo", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "DigestInfo.DigestAlgorithm", tagClass: s2.Class.UNIVERSAL, type: s2.Type.SEQUENCE, constructed: true, value: [{ name: "DigestInfo.DigestAlgorithm.algorithmIdentifier", tagClass: s2.Class.UNIVERSAL, type: s2.Type.OID, constructed: false, capture: "algorithmIdentifier" }, { name: "DigestInfo.DigestAlgorithm.parameters", tagClass: s2.Class.UNIVERSAL, type: s2.Type.NULL, capture: "parameters", optional: true, constructed: false }] }, { name: "DigestInfo.digest", tagClass: s2.Class.UNIVERSAL, type: s2.Type.OCTETSTRING, constructed: false, capture: "digest" }] }, g2 = function(e4) {
      var t4;
      if (!(e4.algorithm in u2.oids)) {
        var r4 = new Error("Unknown message digest algorithm.");
        throw r4.algorithm = e4.algorithm, r4;
      }
      t4 = u2.oids[e4.algorithm];
      var n4 = s2.oidToDer(t4).getBytes(), i3 = s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, []), a7 = s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, []);
      a7.value.push(s2.create(s2.Class.UNIVERSAL, s2.Type.OID, false, n4)), a7.value.push(s2.create(s2.Class.UNIVERSAL, s2.Type.NULL, false, ""));
      var o2 = s2.create(s2.Class.UNIVERSAL, s2.Type.OCTETSTRING, false, e4.digest().getBytes());
      return i3.value.push(a7), i3.value.push(o2), s2.toDer(i3).getBytes();
    }, y2 = function(e4, t4, r4) {
      if (r4)
        return e4.modPow(t4.e, t4.n);
      if (!t4.p || !t4.q)
        return e4.modPow(t4.d, t4.n);
      var a7;
      t4.dP || (t4.dP = t4.d.mod(t4.p.subtract(i2.ONE))), t4.dQ || (t4.dQ = t4.d.mod(t4.q.subtract(i2.ONE))), t4.qInv || (t4.qInv = t4.q.modInverse(t4.p));
      do {
        a7 = new i2(n3.util.bytesToHex(n3.random.getBytes(t4.n.bitLength() / 8)), 16);
      } while (a7.compareTo(t4.n) >= 0 || !a7.gcd(t4.n).equals(i2.ONE));
      for (var s3 = (e4 = e4.multiply(a7.modPow(t4.e, t4.n)).mod(t4.n)).mod(t4.p).modPow(t4.dP, t4.p), o2 = e4.mod(t4.q).modPow(t4.dQ, t4.q); s3.compareTo(o2) < 0; )
        s3 = s3.add(t4.p);
      var u3 = s3.subtract(o2).multiply(t4.qInv).mod(t4.p).multiply(t4.q).add(o2);
      return u3.multiply(a7.modInverse(t4.n)).mod(t4.n);
    };
    function v2(e4, t4, r4) {
      var i3 = n3.util.createBuffer(), a7 = Math.ceil(t4.n.bitLength() / 8);
      if (e4.length > a7 - 11) {
        var s3 = new Error("Message is too long for PKCS#1 v1.5 padding.");
        throw s3.length = e4.length, s3.max = a7 - 11, s3;
      }
      i3.putByte(0), i3.putByte(r4);
      var o2, u3 = a7 - 3 - e4.length;
      if (r4 === 0 || r4 === 1) {
        o2 = r4 === 0 ? 0 : 255;
        for (var c3 = 0; c3 < u3; ++c3)
          i3.putByte(o2);
      } else
        for (; u3 > 0; ) {
          var l3 = 0, h3 = n3.random.getBytes(u3);
          for (c3 = 0; c3 < u3; ++c3)
            (o2 = h3.charCodeAt(c3)) === 0 ? ++l3 : i3.putByte(o2);
          u3 = l3;
        }
      return i3.putByte(0), i3.putBytes(e4), i3;
    }
    function m2(e4, t4, r4, i3) {
      var a7 = Math.ceil(t4.n.bitLength() / 8), s3 = n3.util.createBuffer(e4), o2 = s3.getByte(), u3 = s3.getByte();
      if (o2 !== 0 || r4 && u3 !== 0 && u3 !== 1 || !r4 && u3 != 2 || r4 && u3 === 0 && i3 === void 0)
        throw new Error("Encryption block is invalid.");
      var c3 = 0;
      if (u3 === 0) {
        c3 = a7 - 3 - i3;
        for (var l3 = 0; l3 < c3; ++l3)
          if (s3.getByte() !== 0)
            throw new Error("Encryption block is invalid.");
      } else if (u3 === 1)
        for (c3 = 0; s3.length() > 1; ) {
          if (s3.getByte() !== 255) {
            --s3.read;
            break;
          }
          ++c3;
        }
      else if (u3 === 2)
        for (c3 = 0; s3.length() > 1; ) {
          if (s3.getByte() === 0) {
            --s3.read;
            break;
          }
          ++c3;
        }
      if (s3.getByte() !== 0 || c3 !== a7 - 3 - s3.length())
        throw new Error("Encryption block is invalid.");
      return s3.getBytes();
    }
    function E2(e4, t4, r4) {
      typeof t4 == "function" && (r4 = t4, t4 = {});
      var a7 = { algorithm: { name: (t4 = t4 || {}).algorithm || "PRIMEINC", options: { workers: t4.workers || 2, workLoad: t4.workLoad || 100, workerScript: t4.workerScript } } };
      function s3() {
        o2(e4.pBits, function(t5, n4) {
          return t5 ? r4(t5) : (e4.p = n4, e4.q !== null ? c3(t5, e4.q) : void o2(e4.qBits, c3));
        });
      }
      function o2(e5, t5) {
        n3.prime.generateProbablePrime(e5, a7, t5);
      }
      function c3(t5, n4) {
        if (t5)
          return r4(t5);
        if (e4.q = n4, e4.p.compareTo(e4.q) < 0) {
          var a8 = e4.p;
          e4.p = e4.q, e4.q = a8;
        }
        if (e4.p.subtract(i2.ONE).gcd(e4.e).compareTo(i2.ONE) !== 0)
          return e4.p = null, void s3();
        if (e4.q.subtract(i2.ONE).gcd(e4.e).compareTo(i2.ONE) !== 0)
          return e4.q = null, void o2(e4.qBits, c3);
        if (e4.p1 = e4.p.subtract(i2.ONE), e4.q1 = e4.q.subtract(i2.ONE), e4.phi = e4.p1.multiply(e4.q1), e4.phi.gcd(e4.e).compareTo(i2.ONE) !== 0)
          return e4.p = e4.q = null, void s3();
        if (e4.n = e4.p.multiply(e4.q), e4.n.bitLength() !== e4.bits)
          return e4.q = null, void o2(e4.qBits, c3);
        var l3 = e4.e.modInverse(e4.phi);
        e4.keys = { privateKey: u2.rsa.setPrivateKey(e4.n, e4.e, l3, e4.p, e4.q, l3.mod(e4.p1), l3.mod(e4.q1), e4.q.modInverse(e4.p)), publicKey: u2.rsa.setPublicKey(e4.n, e4.e) }, r4(null, e4.keys);
      }
      "prng" in t4 && (a7.prng = t4.prng), s3();
    }
    function C(e4) {
      var t4 = e4.toString(16);
      t4[0] >= "8" && (t4 = "00" + t4);
      var r4 = n3.util.hexToBytes(t4);
      return r4.length > 1 && (r4.charCodeAt(0) === 0 && (128 & r4.charCodeAt(1)) == 0 || r4.charCodeAt(0) === 255 && (128 & r4.charCodeAt(1)) == 128) ? r4.substr(1) : r4;
    }
    function S2(e4) {
      return e4 <= 100 ? 27 : e4 <= 150 ? 18 : e4 <= 200 ? 15 : e4 <= 250 ? 12 : e4 <= 300 ? 9 : e4 <= 350 ? 8 : e4 <= 400 ? 7 : e4 <= 500 ? 6 : e4 <= 600 ? 5 : e4 <= 800 ? 4 : e4 <= 1250 ? 3 : 2;
    }
    function b2(e4) {
      return n3.util.isNodejs && typeof a6[e4] == "function";
    }
    function T2(e4) {
      return o.globalScope !== void 0 && typeof o.globalScope.crypto == "object" && typeof o.globalScope.crypto.subtle == "object" && typeof o.globalScope.crypto.subtle[e4] == "function";
    }
    function _24(e4) {
      return o.globalScope !== void 0 && typeof o.globalScope.msCrypto == "object" && typeof o.globalScope.msCrypto.subtle == "object" && typeof o.globalScope.msCrypto.subtle[e4] == "function";
    }
    function I2(e4) {
      for (var t4 = n3.util.hexToBytes(e4.toString(16)), r4 = new Uint8Array(t4.length), i3 = 0; i3 < t4.length; ++i3)
        r4[i3] = t4.charCodeAt(i3);
      return r4;
    }
    u2.rsa.encrypt = function(e4, t4, r4) {
      var a7, s3 = r4, o2 = Math.ceil(t4.n.bitLength() / 8);
      r4 !== false && r4 !== true ? (s3 = r4 === 2, a7 = v2(e4, t4, r4)) : (a7 = n3.util.createBuffer()).putBytes(e4);
      for (var u3 = new i2(a7.toHex(), 16), c3 = y2(u3, t4, s3).toString(16), l3 = n3.util.createBuffer(), h3 = o2 - Math.ceil(c3.length / 2); h3 > 0; )
        l3.putByte(0), --h3;
      return l3.putBytes(n3.util.hexToBytes(c3)), l3.getBytes();
    }, u2.rsa.decrypt = function(e4, t4, r4, a7) {
      var s3 = Math.ceil(t4.n.bitLength() / 8);
      if (e4.length !== s3) {
        var o2 = new Error("Encrypted message length is invalid.");
        throw o2.length = e4.length, o2.expected = s3, o2;
      }
      var u3 = new i2(n3.util.createBuffer(e4).toHex(), 16);
      if (u3.compareTo(t4.n) >= 0)
        throw new Error("Encrypted message is invalid.");
      for (var c3 = y2(u3, t4, r4).toString(16), l3 = n3.util.createBuffer(), h3 = s3 - Math.ceil(c3.length / 2); h3 > 0; )
        l3.putByte(0), --h3;
      return l3.putBytes(n3.util.hexToBytes(c3)), a7 !== false ? m2(l3.getBytes(), t4, r4) : l3.getBytes();
    }, u2.rsa.createKeyPairGenerationState = function(e4, t4, r4) {
      typeof e4 == "string" && (e4 = parseInt(e4, 10)), e4 = e4 || 2048;
      var a7, s3 = (r4 = r4 || {}).prng || n3.random, o2 = { nextBytes: function(e5) {
        for (var t5 = s3.getBytesSync(e5.length), r5 = 0; r5 < e5.length; ++r5)
          e5[r5] = t5.charCodeAt(r5);
      } }, u3 = r4.algorithm || "PRIMEINC";
      if (u3 !== "PRIMEINC")
        throw new Error("Invalid key generation algorithm: " + u3);
      return (a7 = { algorithm: u3, state: 0, bits: e4, rng: o2, eInt: t4 || 65537, e: new i2(null), p: null, q: null, qBits: e4 >> 1, pBits: e4 - (e4 >> 1), pqState: 0, num: null, keys: null }).e.fromInt(a7.eInt), a7;
    }, u2.rsa.stepKeyPairGenerationState = function(e4, t4) {
      "algorithm" in e4 || (e4.algorithm = "PRIMEINC");
      var r4 = new i2(null);
      r4.fromInt(30);
      for (var n4, a7 = 0, s3 = function(e5, t5) {
        return e5 | t5;
      }, o2 = +new Date(), l3 = 0; e4.keys === null && (t4 <= 0 || l3 < t4); ) {
        if (e4.state === 0) {
          var h3 = e4.p === null ? e4.pBits : e4.qBits, f3 = h3 - 1;
          e4.pqState === 0 ? (e4.num = new i2(h3, e4.rng), e4.num.testBit(f3) || e4.num.bitwiseTo(i2.ONE.shiftLeft(f3), s3, e4.num), e4.num.dAddOffset(31 - e4.num.mod(r4).byteValue(), 0), a7 = 0, ++e4.pqState) : e4.pqState === 1 ? e4.num.bitLength() > h3 ? e4.pqState = 0 : e4.num.isProbablePrime(S2(e4.num.bitLength())) ? ++e4.pqState : e4.num.dAddOffset(c2[a7++ % 8], 0) : e4.pqState === 2 ? e4.pqState = e4.num.subtract(i2.ONE).gcd(e4.e).compareTo(i2.ONE) === 0 ? 3 : 0 : e4.pqState === 3 && (e4.pqState = 0, e4.p === null ? e4.p = e4.num : e4.q = e4.num, e4.p !== null && e4.q !== null && ++e4.state, e4.num = null);
        } else if (e4.state === 1)
          e4.p.compareTo(e4.q) < 0 && (e4.num = e4.p, e4.p = e4.q, e4.q = e4.num), ++e4.state;
        else if (e4.state === 2)
          e4.p1 = e4.p.subtract(i2.ONE), e4.q1 = e4.q.subtract(i2.ONE), e4.phi = e4.p1.multiply(e4.q1), ++e4.state;
        else if (e4.state === 3)
          e4.phi.gcd(e4.e).compareTo(i2.ONE) === 0 ? ++e4.state : (e4.p = null, e4.q = null, e4.state = 0);
        else if (e4.state === 4)
          e4.n = e4.p.multiply(e4.q), e4.n.bitLength() === e4.bits ? ++e4.state : (e4.q = null, e4.state = 0);
        else if (e4.state === 5) {
          var p3 = e4.e.modInverse(e4.phi);
          e4.keys = { privateKey: u2.rsa.setPrivateKey(e4.n, e4.e, p3, e4.p, e4.q, p3.mod(e4.p1), p3.mod(e4.q1), e4.q.modInverse(e4.p)), publicKey: u2.rsa.setPublicKey(e4.n, e4.e) };
        }
        l3 += (n4 = +new Date()) - o2, o2 = n4;
      }
      return e4.keys !== null;
    }, u2.rsa.generateKeyPair = function(e4, t4, r4, i3) {
      if (arguments.length === 1 ? typeof e4 == "object" ? (r4 = e4, e4 = void 0) : typeof e4 == "function" && (i3 = e4, e4 = void 0) : arguments.length === 2 ? typeof e4 == "number" ? typeof t4 == "function" ? (i3 = t4, t4 = void 0) : typeof t4 != "number" && (r4 = t4, t4 = void 0) : (r4 = e4, i3 = t4, e4 = void 0, t4 = void 0) : arguments.length === 3 && (typeof t4 == "number" ? typeof r4 == "function" && (i3 = r4, r4 = void 0) : (i3 = r4, r4 = t4, t4 = void 0)), r4 = r4 || {}, e4 === void 0 && (e4 = r4.bits || 2048), t4 === void 0 && (t4 = r4.e || 65537), !n3.options.usePureJavaScript && !r4.prng && e4 >= 256 && e4 <= 16384 && (t4 === 65537 || t4 === 3)) {
        if (i3) {
          if (b2("generateKeyPair"))
            return a6.generateKeyPair("rsa", { modulusLength: e4, publicExponent: t4, publicKeyEncoding: { type: "spki", format: "pem" }, privateKeyEncoding: { type: "pkcs8", format: "pem" } }, function(e5, t5, r5) {
              if (e5)
                return i3(e5);
              i3(null, { privateKey: u2.privateKeyFromPem(r5), publicKey: u2.publicKeyFromPem(t5) });
            });
          if (T2("generateKey") && T2("exportKey"))
            return o.globalScope.crypto.subtle.generateKey({ name: "RSASSA-PKCS1-v1_5", modulusLength: e4, publicExponent: I2(t4), hash: { name: "SHA-256" } }, true, ["sign", "verify"]).then(function(e5) {
              return o.globalScope.crypto.subtle.exportKey("pkcs8", e5.privateKey);
            }).then(void 0, function(e5) {
              i3(e5);
            }).then(function(e5) {
              if (e5) {
                var t5 = u2.privateKeyFromAsn1(s2.fromDer(n3.util.createBuffer(e5)));
                i3(null, { privateKey: t5, publicKey: u2.setRsaPublicKey(t5.n, t5.e) });
              }
            });
          if (_24("generateKey") && _24("exportKey")) {
            var c3 = o.globalScope.msCrypto.subtle.generateKey({ name: "RSASSA-PKCS1-v1_5", modulusLength: e4, publicExponent: I2(t4), hash: { name: "SHA-256" } }, true, ["sign", "verify"]);
            return c3.oncomplete = function(e5) {
              var t5 = e5.target.result, r5 = o.globalScope.msCrypto.subtle.exportKey("pkcs8", t5.privateKey);
              r5.oncomplete = function(e6) {
                var t6 = e6.target.result, r6 = u2.privateKeyFromAsn1(s2.fromDer(n3.util.createBuffer(t6)));
                i3(null, { privateKey: r6, publicKey: u2.setRsaPublicKey(r6.n, r6.e) });
              }, r5.onerror = function(e6) {
                i3(e6);
              };
            }, void (c3.onerror = function(e5) {
              i3(e5);
            });
          }
        } else if (b2("generateKeyPairSync")) {
          var l3 = a6.generateKeyPairSync("rsa", { modulusLength: e4, publicExponent: t4, publicKeyEncoding: { type: "spki", format: "pem" }, privateKeyEncoding: { type: "pkcs8", format: "pem" } });
          return { privateKey: u2.privateKeyFromPem(l3.privateKey), publicKey: u2.publicKeyFromPem(l3.publicKey) };
        }
      }
      var h3 = u2.rsa.createKeyPairGenerationState(e4, t4, r4);
      if (!i3)
        return u2.rsa.stepKeyPairGenerationState(h3, 0), h3.keys;
      E2(h3, r4, i3);
    }, u2.setRsaPublicKey = u2.rsa.setPublicKey = function(e4, t4) {
      var r4 = { n: e4, e: t4, encrypt: function(e5, t5, i3) {
        if (typeof t5 == "string" ? t5 = t5.toUpperCase() : t5 === void 0 && (t5 = "RSAES-PKCS1-V1_5"), t5 === "RSAES-PKCS1-V1_5")
          t5 = { encode: function(e6, t6, r5) {
            return v2(e6, t6, 2).getBytes();
          } };
        else if (t5 === "RSA-OAEP" || t5 === "RSAES-OAEP")
          t5 = { encode: function(e6, t6) {
            return n3.pkcs1.encode_rsa_oaep(t6, e6, i3);
          } };
        else if (["RAW", "NONE", "NULL", null].indexOf(t5) !== -1)
          t5 = { encode: function(e6) {
            return e6;
          } };
        else if (typeof t5 == "string")
          throw new Error('Unsupported encryption scheme: "' + t5 + '".');
        var a7 = t5.encode(e5, r4, true);
        return u2.rsa.encrypt(a7, r4, true);
      }, verify: function(e5, t5, i3, a7) {
        typeof i3 == "string" ? i3 = i3.toUpperCase() : i3 === void 0 && (i3 = "RSASSA-PKCS1-V1_5"), a7 === void 0 && (a7 = { _parseAllDigestBytes: true }), "_parseAllDigestBytes" in a7 || (a7._parseAllDigestBytes = true), i3 === "RSASSA-PKCS1-V1_5" ? i3 = { verify: function(e6, t6) {
          t6 = m2(t6, r4, true);
          var i4 = s2.fromDer(t6, { parseAllBytes: a7._parseAllDigestBytes }), o3 = {}, u3 = [];
          if (!s2.validate(i4, d2, o3, u3))
            throw (c3 = new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value.")).errors = u3, c3;
          var c3, l3 = s2.derToOid(o3.algorithmIdentifier);
          if (l3 !== n3.oids.md2 && l3 !== n3.oids.md5 && l3 !== n3.oids.sha1 && l3 !== n3.oids.sha224 && l3 !== n3.oids.sha256 && l3 !== n3.oids.sha384 && l3 !== n3.oids.sha512 && l3 !== n3.oids["sha512-224"] && l3 !== n3.oids["sha512-256"])
            throw (c3 = new Error("Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier.")).oid = l3, c3;
          if ((l3 === n3.oids.md2 || l3 === n3.oids.md5) && !("parameters" in o3))
            throw new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters.");
          return e6 === o3.digest;
        } } : i3 !== "NONE" && i3 !== "NULL" && i3 !== null || (i3 = { verify: function(e6, t6) {
          return e6 === m2(t6, r4, true);
        } });
        var o2 = u2.rsa.decrypt(t5, r4, true, false);
        return i3.verify(e5, o2, r4.n.bitLength());
      } };
      return r4;
    }, u2.setRsaPrivateKey = u2.rsa.setPrivateKey = function(e4, t4, r4, i3, a7, s3, o2, c3) {
      var l3 = { n: e4, e: t4, d: r4, p: i3, q: a7, dP: s3, dQ: o2, qInv: c3, decrypt: function(e5, t5, r5) {
        typeof t5 == "string" ? t5 = t5.toUpperCase() : t5 === void 0 && (t5 = "RSAES-PKCS1-V1_5");
        var i4 = u2.rsa.decrypt(e5, l3, false, false);
        if (t5 === "RSAES-PKCS1-V1_5")
          t5 = { decode: m2 };
        else if (t5 === "RSA-OAEP" || t5 === "RSAES-OAEP")
          t5 = { decode: function(e6, t6) {
            return n3.pkcs1.decode_rsa_oaep(t6, e6, r5);
          } };
        else {
          if (["RAW", "NONE", "NULL", null].indexOf(t5) === -1)
            throw new Error('Unsupported encryption scheme: "' + t5 + '".');
          t5 = { decode: function(e6) {
            return e6;
          } };
        }
        return t5.decode(i4, l3, false);
      }, sign: function(e5, t5) {
        var r5 = false;
        typeof t5 == "string" && (t5 = t5.toUpperCase()), t5 === void 0 || t5 === "RSASSA-PKCS1-V1_5" ? (t5 = { encode: g2 }, r5 = 1) : t5 !== "NONE" && t5 !== "NULL" && t5 !== null || (t5 = { encode: function() {
          return e5;
        } }, r5 = 1);
        var n4 = t5.encode(e5, l3.n.bitLength());
        return u2.rsa.encrypt(n4, l3, r5);
      } };
      return l3;
    }, u2.wrapRsaPrivateKey = function(e4) {
      return s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, [s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, s2.integerToDer(0).getBytes()), s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, [s2.create(s2.Class.UNIVERSAL, s2.Type.OID, false, s2.oidToDer(u2.oids.rsaEncryption).getBytes()), s2.create(s2.Class.UNIVERSAL, s2.Type.NULL, false, "")]), s2.create(s2.Class.UNIVERSAL, s2.Type.OCTETSTRING, false, s2.toDer(e4).getBytes())]);
    }, u2.privateKeyFromAsn1 = function(e4) {
      var t4, r4, a7, o2, c3, f3, p3, d3, g3 = {}, y3 = [];
      if (s2.validate(e4, l2, g3, y3) && (e4 = s2.fromDer(n3.util.createBuffer(g3.privateKey))), g3 = {}, y3 = [], !s2.validate(e4, h2, g3, y3)) {
        var v3 = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        throw v3.errors = y3, v3;
      }
      return t4 = n3.util.createBuffer(g3.privateKeyModulus).toHex(), r4 = n3.util.createBuffer(g3.privateKeyPublicExponent).toHex(), a7 = n3.util.createBuffer(g3.privateKeyPrivateExponent).toHex(), o2 = n3.util.createBuffer(g3.privateKeyPrime1).toHex(), c3 = n3.util.createBuffer(g3.privateKeyPrime2).toHex(), f3 = n3.util.createBuffer(g3.privateKeyExponent1).toHex(), p3 = n3.util.createBuffer(g3.privateKeyExponent2).toHex(), d3 = n3.util.createBuffer(g3.privateKeyCoefficient).toHex(), u2.setRsaPrivateKey(new i2(t4, 16), new i2(r4, 16), new i2(a7, 16), new i2(o2, 16), new i2(c3, 16), new i2(f3, 16), new i2(p3, 16), new i2(d3, 16));
    }, u2.privateKeyToAsn1 = u2.privateKeyToRSAPrivateKey = function(e4) {
      return s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, [s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, s2.integerToDer(0).getBytes()), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.n)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.e)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.d)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.p)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.q)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.dP)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.dQ)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.qInv))]);
    }, u2.publicKeyFromAsn1 = function(e4) {
      var t4 = {}, r4 = [];
      if (s2.validate(e4, p2, t4, r4)) {
        var a7, o2 = s2.derToOid(t4.publicKeyOid);
        if (o2 !== u2.oids.rsaEncryption)
          throw (a7 = new Error("Cannot read public key. Unknown OID.")).oid = o2, a7;
        e4 = t4.rsaPublicKey;
      }
      if (r4 = [], !s2.validate(e4, f2, t4, r4))
        throw (a7 = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.")).errors = r4, a7;
      var c3 = n3.util.createBuffer(t4.publicKeyModulus).toHex(), l3 = n3.util.createBuffer(t4.publicKeyExponent).toHex();
      return u2.setRsaPublicKey(new i2(c3, 16), new i2(l3, 16));
    }, u2.publicKeyToAsn1 = u2.publicKeyToSubjectPublicKeyInfo = function(e4) {
      return s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, [s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, [s2.create(s2.Class.UNIVERSAL, s2.Type.OID, false, s2.oidToDer(u2.oids.rsaEncryption).getBytes()), s2.create(s2.Class.UNIVERSAL, s2.Type.NULL, false, "")]), s2.create(s2.Class.UNIVERSAL, s2.Type.BITSTRING, false, [u2.publicKeyToRSAPublicKey(e4)])]);
    }, u2.publicKeyToRSAPublicKey = function(e4) {
      return s2.create(s2.Class.UNIVERSAL, s2.Type.SEQUENCE, true, [s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.n)), s2.create(s2.Class.UNIVERSAL, s2.Type.INTEGER, false, C(e4.e))]);
    };
  }, 2936: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(6067), r3(3103);
    var i2 = e3.exports = n3.sha1 = n3.sha1 || {};
    n3.md.sha1 = n3.md.algorithms.sha1 = i2, i2.create = function() {
      s2 || (a6 = String.fromCharCode(128), a6 += n3.util.fillString(String.fromCharCode(0), 64), s2 = true);
      var e4 = null, t4 = n3.util.createBuffer(), r4 = new Array(80), i3 = { algorithm: "sha1", blockLength: 64, digestLength: 20, messageLength: 0, fullMessageLength: null, messageLengthSize: 8, start: function() {
        i3.messageLength = 0, i3.fullMessageLength = i3.messageLength64 = [];
        for (var r5 = i3.messageLengthSize / 4, a7 = 0; a7 < r5; ++a7)
          i3.fullMessageLength.push(0);
        return t4 = n3.util.createBuffer(), e4 = { h0: 1732584193, h1: 4023233417, h2: 2562383102, h3: 271733878, h4: 3285377520 }, i3;
      } };
      return i3.start(), i3.update = function(a7, s3) {
        s3 === "utf8" && (a7 = n3.util.encodeUtf8(a7));
        var u2 = a7.length;
        i3.messageLength += u2, u2 = [u2 / 4294967296 >>> 0, u2 >>> 0];
        for (var c2 = i3.fullMessageLength.length - 1; c2 >= 0; --c2)
          i3.fullMessageLength[c2] += u2[1], u2[1] = u2[0] + (i3.fullMessageLength[c2] / 4294967296 >>> 0), i3.fullMessageLength[c2] = i3.fullMessageLength[c2] >>> 0, u2[0] = u2[1] / 4294967296 >>> 0;
        return t4.putBytes(a7), o(e4, r4, t4), (t4.read > 2048 || t4.length() === 0) && t4.compact(), i3;
      }, i3.digest = function() {
        var s3 = n3.util.createBuffer();
        s3.putBytes(t4.bytes());
        var u2, c2 = i3.fullMessageLength[i3.fullMessageLength.length - 1] + i3.messageLengthSize & i3.blockLength - 1;
        s3.putBytes(a6.substr(0, i3.blockLength - c2));
        for (var l2 = 8 * i3.fullMessageLength[0], h2 = 0; h2 < i3.fullMessageLength.length - 1; ++h2)
          l2 += (u2 = 8 * i3.fullMessageLength[h2 + 1]) / 4294967296 >>> 0, s3.putInt32(l2 >>> 0), l2 = u2 >>> 0;
        s3.putInt32(l2);
        var f2 = { h0: e4.h0, h1: e4.h1, h2: e4.h2, h3: e4.h3, h4: e4.h4 };
        o(f2, r4, s3);
        var p2 = n3.util.createBuffer();
        return p2.putInt32(f2.h0), p2.putInt32(f2.h1), p2.putInt32(f2.h2), p2.putInt32(f2.h3), p2.putInt32(f2.h4), p2;
      }, i3;
    };
    var a6 = null, s2 = false;
    function o(e4, t4, r4) {
      for (var n4, i3, a7, s3, o2, u2, c2, l2 = r4.length(); l2 >= 64; ) {
        for (i3 = e4.h0, a7 = e4.h1, s3 = e4.h2, o2 = e4.h3, u2 = e4.h4, c2 = 0; c2 < 16; ++c2)
          n4 = r4.getInt32(), t4[c2] = n4, n4 = (i3 << 5 | i3 >>> 27) + (o2 ^ a7 & (s3 ^ o2)) + u2 + 1518500249 + n4, u2 = o2, o2 = s3, s3 = (a7 << 30 | a7 >>> 2) >>> 0, a7 = i3, i3 = n4;
        for (; c2 < 20; ++c2)
          n4 = (n4 = t4[c2 - 3] ^ t4[c2 - 8] ^ t4[c2 - 14] ^ t4[c2 - 16]) << 1 | n4 >>> 31, t4[c2] = n4, n4 = (i3 << 5 | i3 >>> 27) + (o2 ^ a7 & (s3 ^ o2)) + u2 + 1518500249 + n4, u2 = o2, o2 = s3, s3 = (a7 << 30 | a7 >>> 2) >>> 0, a7 = i3, i3 = n4;
        for (; c2 < 32; ++c2)
          n4 = (n4 = t4[c2 - 3] ^ t4[c2 - 8] ^ t4[c2 - 14] ^ t4[c2 - 16]) << 1 | n4 >>> 31, t4[c2] = n4, n4 = (i3 << 5 | i3 >>> 27) + (a7 ^ s3 ^ o2) + u2 + 1859775393 + n4, u2 = o2, o2 = s3, s3 = (a7 << 30 | a7 >>> 2) >>> 0, a7 = i3, i3 = n4;
        for (; c2 < 40; ++c2)
          n4 = (n4 = t4[c2 - 6] ^ t4[c2 - 16] ^ t4[c2 - 28] ^ t4[c2 - 32]) << 2 | n4 >>> 30, t4[c2] = n4, n4 = (i3 << 5 | i3 >>> 27) + (a7 ^ s3 ^ o2) + u2 + 1859775393 + n4, u2 = o2, o2 = s3, s3 = (a7 << 30 | a7 >>> 2) >>> 0, a7 = i3, i3 = n4;
        for (; c2 < 60; ++c2)
          n4 = (n4 = t4[c2 - 6] ^ t4[c2 - 16] ^ t4[c2 - 28] ^ t4[c2 - 32]) << 2 | n4 >>> 30, t4[c2] = n4, n4 = (i3 << 5 | i3 >>> 27) + (a7 & s3 | o2 & (a7 ^ s3)) + u2 + 2400959708 + n4, u2 = o2, o2 = s3, s3 = (a7 << 30 | a7 >>> 2) >>> 0, a7 = i3, i3 = n4;
        for (; c2 < 80; ++c2)
          n4 = (n4 = t4[c2 - 6] ^ t4[c2 - 16] ^ t4[c2 - 28] ^ t4[c2 - 32]) << 2 | n4 >>> 30, t4[c2] = n4, n4 = (i3 << 5 | i3 >>> 27) + (a7 ^ s3 ^ o2) + u2 + 3395469782 + n4, u2 = o2, o2 = s3, s3 = (a7 << 30 | a7 >>> 2) >>> 0, a7 = i3, i3 = n4;
        e4.h0 = e4.h0 + i3 | 0, e4.h1 = e4.h1 + a7 | 0, e4.h2 = e4.h2 + s3 | 0, e4.h3 = e4.h3 + o2 | 0, e4.h4 = e4.h4 + u2 | 0, l2 -= 64;
      }
    }
  }, 9141: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(6067), r3(3103);
    var i2 = e3.exports = n3.sha256 = n3.sha256 || {};
    n3.md.sha256 = n3.md.algorithms.sha256 = i2, i2.create = function() {
      s2 || (a6 = String.fromCharCode(128), a6 += n3.util.fillString(String.fromCharCode(0), 64), o = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], s2 = true);
      var e4 = null, t4 = n3.util.createBuffer(), r4 = new Array(64), i3 = { algorithm: "sha256", blockLength: 64, digestLength: 32, messageLength: 0, fullMessageLength: null, messageLengthSize: 8, start: function() {
        i3.messageLength = 0, i3.fullMessageLength = i3.messageLength64 = [];
        for (var r5 = i3.messageLengthSize / 4, a7 = 0; a7 < r5; ++a7)
          i3.fullMessageLength.push(0);
        return t4 = n3.util.createBuffer(), e4 = { h0: 1779033703, h1: 3144134277, h2: 1013904242, h3: 2773480762, h4: 1359893119, h5: 2600822924, h6: 528734635, h7: 1541459225 }, i3;
      } };
      return i3.start(), i3.update = function(a7, s3) {
        s3 === "utf8" && (a7 = n3.util.encodeUtf8(a7));
        var o2 = a7.length;
        i3.messageLength += o2, o2 = [o2 / 4294967296 >>> 0, o2 >>> 0];
        for (var c2 = i3.fullMessageLength.length - 1; c2 >= 0; --c2)
          i3.fullMessageLength[c2] += o2[1], o2[1] = o2[0] + (i3.fullMessageLength[c2] / 4294967296 >>> 0), i3.fullMessageLength[c2] = i3.fullMessageLength[c2] >>> 0, o2[0] = o2[1] / 4294967296 >>> 0;
        return t4.putBytes(a7), u2(e4, r4, t4), (t4.read > 2048 || t4.length() === 0) && t4.compact(), i3;
      }, i3.digest = function() {
        var s3 = n3.util.createBuffer();
        s3.putBytes(t4.bytes());
        var o2, c2 = i3.fullMessageLength[i3.fullMessageLength.length - 1] + i3.messageLengthSize & i3.blockLength - 1;
        s3.putBytes(a6.substr(0, i3.blockLength - c2));
        for (var l2 = 8 * i3.fullMessageLength[0], h2 = 0; h2 < i3.fullMessageLength.length - 1; ++h2)
          l2 += (o2 = 8 * i3.fullMessageLength[h2 + 1]) / 4294967296 >>> 0, s3.putInt32(l2 >>> 0), l2 = o2 >>> 0;
        s3.putInt32(l2);
        var f2 = { h0: e4.h0, h1: e4.h1, h2: e4.h2, h3: e4.h3, h4: e4.h4, h5: e4.h5, h6: e4.h6, h7: e4.h7 };
        u2(f2, r4, s3);
        var p2 = n3.util.createBuffer();
        return p2.putInt32(f2.h0), p2.putInt32(f2.h1), p2.putInt32(f2.h2), p2.putInt32(f2.h3), p2.putInt32(f2.h4), p2.putInt32(f2.h5), p2.putInt32(f2.h6), p2.putInt32(f2.h7), p2;
      }, i3;
    };
    var a6 = null, s2 = false, o = null;
    function u2(e4, t4, r4) {
      for (var n4, i3, a7, s3, u3, c2, l2, h2, f2, p2, d2, g2, y2, v2 = r4.length(); v2 >= 64; ) {
        for (u3 = 0; u3 < 16; ++u3)
          t4[u3] = r4.getInt32();
        for (; u3 < 64; ++u3)
          n4 = ((n4 = t4[u3 - 2]) >>> 17 | n4 << 15) ^ (n4 >>> 19 | n4 << 13) ^ n4 >>> 10, i3 = ((i3 = t4[u3 - 15]) >>> 7 | i3 << 25) ^ (i3 >>> 18 | i3 << 14) ^ i3 >>> 3, t4[u3] = n4 + t4[u3 - 7] + i3 + t4[u3 - 16] | 0;
        for (c2 = e4.h0, l2 = e4.h1, h2 = e4.h2, f2 = e4.h3, p2 = e4.h4, d2 = e4.h5, g2 = e4.h6, y2 = e4.h7, u3 = 0; u3 < 64; ++u3)
          a7 = (c2 >>> 2 | c2 << 30) ^ (c2 >>> 13 | c2 << 19) ^ (c2 >>> 22 | c2 << 10), s3 = c2 & l2 | h2 & (c2 ^ l2), n4 = y2 + ((p2 >>> 6 | p2 << 26) ^ (p2 >>> 11 | p2 << 21) ^ (p2 >>> 25 | p2 << 7)) + (g2 ^ p2 & (d2 ^ g2)) + o[u3] + t4[u3], y2 = g2, g2 = d2, d2 = p2, p2 = f2 + n4 >>> 0, f2 = h2, h2 = l2, l2 = c2, c2 = n4 + (i3 = a7 + s3) >>> 0;
        e4.h0 = e4.h0 + c2 | 0, e4.h1 = e4.h1 + l2 | 0, e4.h2 = e4.h2 + h2 | 0, e4.h3 = e4.h3 + f2 | 0, e4.h4 = e4.h4 + p2 | 0, e4.h5 = e4.h5 + d2 | 0, e4.h6 = e4.h6 + g2 | 0, e4.h7 = e4.h7 + y2 | 0, v2 -= 64;
      }
    }
  }, 8672: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(6067), r3(3103);
    var i2 = e3.exports = n3.sha512 = n3.sha512 || {};
    n3.md.sha512 = n3.md.algorithms.sha512 = i2;
    var a6 = n3.sha384 = n3.sha512.sha384 = n3.sha512.sha384 || {};
    a6.create = function() {
      return i2.create("SHA-384");
    }, n3.md.sha384 = n3.md.algorithms.sha384 = a6, n3.sha512.sha256 = n3.sha512.sha256 || { create: function() {
      return i2.create("SHA-512/256");
    } }, n3.md["sha512/256"] = n3.md.algorithms["sha512/256"] = n3.sha512.sha256, n3.sha512.sha224 = n3.sha512.sha224 || { create: function() {
      return i2.create("SHA-512/224");
    } }, n3.md["sha512/224"] = n3.md.algorithms["sha512/224"] = n3.sha512.sha224, i2.create = function(e4) {
      if (o || (s2 = String.fromCharCode(128), s2 += n3.util.fillString(String.fromCharCode(0), 128), u2 = [[1116352408, 3609767458], [1899447441, 602891725], [3049323471, 3964484399], [3921009573, 2173295548], [961987163, 4081628472], [1508970993, 3053834265], [2453635748, 2937671579], [2870763221, 3664609560], [3624381080, 2734883394], [310598401, 1164996542], [607225278, 1323610764], [1426881987, 3590304994], [1925078388, 4068182383], [2162078206, 991336113], [2614888103, 633803317], [3248222580, 3479774868], [3835390401, 2666613458], [4022224774, 944711139], [264347078, 2341262773], [604807628, 2007800933], [770255983, 1495990901], [1249150122, 1856431235], [1555081692, 3175218132], [1996064986, 2198950837], [2554220882, 3999719339], [2821834349, 766784016], [2952996808, 2566594879], [3210313671, 3203337956], [3336571891, 1034457026], [3584528711, 2466948901], [113926993, 3758326383], [338241895, 168717936], [666307205, 1188179964], [773529912, 1546045734], [1294757372, 1522805485], [1396182291, 2643833823], [1695183700, 2343527390], [1986661051, 1014477480], [2177026350, 1206759142], [2456956037, 344077627], [2730485921, 1290863460], [2820302411, 3158454273], [3259730800, 3505952657], [3345764771, 106217008], [3516065817, 3606008344], [3600352804, 1432725776], [4094571909, 1467031594], [275423344, 851169720], [430227734, 3100823752], [506948616, 1363258195], [659060556, 3750685593], [883997877, 3785050280], [958139571, 3318307427], [1322822218, 3812723403], [1537002063, 2003034995], [1747873779, 3602036899], [1955562222, 1575990012], [2024104815, 1125592928], [2227730452, 2716904306], [2361852424, 442776044], [2428436474, 593698344], [2756734187, 3733110249], [3204031479, 2999351573], [3329325298, 3815920427], [3391569614, 3928383900], [3515267271, 566280711], [3940187606, 3454069534], [4118630271, 4000239992], [116418474, 1914138554], [174292421, 2731055270], [289380356, 3203993006], [460393269, 320620315], [685471733, 587496836], [852142971, 1086792851], [1017036298, 365543100], [1126000580, 2618297676], [1288033470, 3409855158], [1501505948, 4234509866], [1607167915, 987167468], [1816402316, 1246189591]], (c2 = {})["SHA-512"] = [[1779033703, 4089235720], [3144134277, 2227873595], [1013904242, 4271175723], [2773480762, 1595750129], [1359893119, 2917565137], [2600822924, 725511199], [528734635, 4215389547], [1541459225, 327033209]], c2["SHA-384"] = [[3418070365, 3238371032], [1654270250, 914150663], [2438529370, 812702999], [355462360, 4144912697], [1731405415, 4290775857], [2394180231, 1750603025], [3675008525, 1694076839], [1203062813, 3204075428]], c2["SHA-512/256"] = [[573645204, 4230739756], [2673172387, 3360449730], [596883563, 1867755857], [2520282905, 1497426621], [2519219938, 2827943907], [3193839141, 1401305490], [721525244, 746961066], [246885852, 2177182882]], c2["SHA-512/224"] = [[2352822216, 424955298], [1944164710, 2312950998], [502970286, 855612546], [1738396948, 1479516111], [258812777, 2077511080], [2011393907, 79989058], [1067287976, 1780299464], [286451373, 2446758561]], o = true), e4 === void 0 && (e4 = "SHA-512"), !(e4 in c2))
        throw new Error("Invalid SHA-512 algorithm: " + e4);
      for (var t4 = c2[e4], r4 = null, i3 = n3.util.createBuffer(), a7 = new Array(80), h2 = 0; h2 < 80; ++h2)
        a7[h2] = new Array(2);
      var f2 = 64;
      switch (e4) {
        case "SHA-384":
          f2 = 48;
          break;
        case "SHA-512/256":
          f2 = 32;
          break;
        case "SHA-512/224":
          f2 = 28;
      }
      var p2 = { algorithm: e4.replace("-", "").toLowerCase(), blockLength: 128, digestLength: f2, messageLength: 0, fullMessageLength: null, messageLengthSize: 16, start: function() {
        p2.messageLength = 0, p2.fullMessageLength = p2.messageLength128 = [];
        for (var e5 = p2.messageLengthSize / 4, a8 = 0; a8 < e5; ++a8)
          p2.fullMessageLength.push(0);
        for (i3 = n3.util.createBuffer(), r4 = new Array(t4.length), a8 = 0; a8 < t4.length; ++a8)
          r4[a8] = t4[a8].slice(0);
        return p2;
      } };
      return p2.start(), p2.update = function(e5, t5) {
        t5 === "utf8" && (e5 = n3.util.encodeUtf8(e5));
        var s3 = e5.length;
        p2.messageLength += s3, s3 = [s3 / 4294967296 >>> 0, s3 >>> 0];
        for (var o2 = p2.fullMessageLength.length - 1; o2 >= 0; --o2)
          p2.fullMessageLength[o2] += s3[1], s3[1] = s3[0] + (p2.fullMessageLength[o2] / 4294967296 >>> 0), p2.fullMessageLength[o2] = p2.fullMessageLength[o2] >>> 0, s3[0] = s3[1] / 4294967296 >>> 0;
        return i3.putBytes(e5), l2(r4, a7, i3), (i3.read > 2048 || i3.length() === 0) && i3.compact(), p2;
      }, p2.digest = function() {
        var t5 = n3.util.createBuffer();
        t5.putBytes(i3.bytes());
        var o2, u3 = p2.fullMessageLength[p2.fullMessageLength.length - 1] + p2.messageLengthSize & p2.blockLength - 1;
        t5.putBytes(s2.substr(0, p2.blockLength - u3));
        for (var c3 = 8 * p2.fullMessageLength[0], h3 = 0; h3 < p2.fullMessageLength.length - 1; ++h3)
          c3 += (o2 = 8 * p2.fullMessageLength[h3 + 1]) / 4294967296 >>> 0, t5.putInt32(c3 >>> 0), c3 = o2 >>> 0;
        t5.putInt32(c3);
        var f3 = new Array(r4.length);
        for (h3 = 0; h3 < r4.length; ++h3)
          f3[h3] = r4[h3].slice(0);
        l2(f3, a7, t5);
        var d2, g2 = n3.util.createBuffer();
        for (d2 = e4 === "SHA-512" ? f3.length : e4 === "SHA-384" ? f3.length - 2 : f3.length - 4, h3 = 0; h3 < d2; ++h3)
          g2.putInt32(f3[h3][0]), h3 === d2 - 1 && e4 === "SHA-512/224" || g2.putInt32(f3[h3][1]);
        return g2;
      }, p2;
    };
    var s2 = null, o = false, u2 = null, c2 = null;
    function l2(e4, t4, r4) {
      for (var n4, i3, a7, s3, o2, c3, l3, h2, f2, p2, d2, g2, y2, v2, m2, E2, C, S2, b2, T2, _24, I2, A2, B2, w2, R, N2, L2, k3, U2, D2, P2, O, V2 = r4.length(); V2 >= 128; ) {
        for (N2 = 0; N2 < 16; ++N2)
          t4[N2][0] = r4.getInt32() >>> 0, t4[N2][1] = r4.getInt32() >>> 0;
        for (; N2 < 80; ++N2)
          n4 = (((L2 = (U2 = t4[N2 - 2])[0]) >>> 19 | (k3 = U2[1]) << 13) ^ (k3 >>> 29 | L2 << 3) ^ L2 >>> 6) >>> 0, i3 = ((L2 << 13 | k3 >>> 19) ^ (k3 << 3 | L2 >>> 29) ^ (L2 << 26 | k3 >>> 6)) >>> 0, a7 = (((L2 = (P2 = t4[N2 - 15])[0]) >>> 1 | (k3 = P2[1]) << 31) ^ (L2 >>> 8 | k3 << 24) ^ L2 >>> 7) >>> 0, s3 = ((L2 << 31 | k3 >>> 1) ^ (L2 << 24 | k3 >>> 8) ^ (L2 << 25 | k3 >>> 7)) >>> 0, D2 = t4[N2 - 7], O = t4[N2 - 16], k3 = i3 + D2[1] + s3 + O[1], t4[N2][0] = n4 + D2[0] + a7 + O[0] + (k3 / 4294967296 >>> 0) >>> 0, t4[N2][1] = k3 >>> 0;
        for (d2 = e4[0][0], g2 = e4[0][1], y2 = e4[1][0], v2 = e4[1][1], m2 = e4[2][0], E2 = e4[2][1], C = e4[3][0], S2 = e4[3][1], b2 = e4[4][0], T2 = e4[4][1], _24 = e4[5][0], I2 = e4[5][1], A2 = e4[6][0], B2 = e4[6][1], w2 = e4[7][0], R = e4[7][1], N2 = 0; N2 < 80; ++N2)
          l3 = ((b2 >>> 14 | T2 << 18) ^ (b2 >>> 18 | T2 << 14) ^ (T2 >>> 9 | b2 << 23)) >>> 0, h2 = (A2 ^ b2 & (_24 ^ A2)) >>> 0, o2 = ((d2 >>> 28 | g2 << 4) ^ (g2 >>> 2 | d2 << 30) ^ (g2 >>> 7 | d2 << 25)) >>> 0, c3 = ((d2 << 4 | g2 >>> 28) ^ (g2 << 30 | d2 >>> 2) ^ (g2 << 25 | d2 >>> 7)) >>> 0, f2 = (d2 & y2 | m2 & (d2 ^ y2)) >>> 0, p2 = (g2 & v2 | E2 & (g2 ^ v2)) >>> 0, k3 = R + (((b2 << 18 | T2 >>> 14) ^ (b2 << 14 | T2 >>> 18) ^ (T2 << 23 | b2 >>> 9)) >>> 0) + ((B2 ^ T2 & (I2 ^ B2)) >>> 0) + u2[N2][1] + t4[N2][1], n4 = w2 + l3 + h2 + u2[N2][0] + t4[N2][0] + (k3 / 4294967296 >>> 0) >>> 0, i3 = k3 >>> 0, a7 = o2 + f2 + ((k3 = c3 + p2) / 4294967296 >>> 0) >>> 0, s3 = k3 >>> 0, w2 = A2, R = B2, A2 = _24, B2 = I2, _24 = b2, I2 = T2, b2 = C + n4 + ((k3 = S2 + i3) / 4294967296 >>> 0) >>> 0, T2 = k3 >>> 0, C = m2, S2 = E2, m2 = y2, E2 = v2, y2 = d2, v2 = g2, d2 = n4 + a7 + ((k3 = i3 + s3) / 4294967296 >>> 0) >>> 0, g2 = k3 >>> 0;
        k3 = e4[0][1] + g2, e4[0][0] = e4[0][0] + d2 + (k3 / 4294967296 >>> 0) >>> 0, e4[0][1] = k3 >>> 0, k3 = e4[1][1] + v2, e4[1][0] = e4[1][0] + y2 + (k3 / 4294967296 >>> 0) >>> 0, e4[1][1] = k3 >>> 0, k3 = e4[2][1] + E2, e4[2][0] = e4[2][0] + m2 + (k3 / 4294967296 >>> 0) >>> 0, e4[2][1] = k3 >>> 0, k3 = e4[3][1] + S2, e4[3][0] = e4[3][0] + C + (k3 / 4294967296 >>> 0) >>> 0, e4[3][1] = k3 >>> 0, k3 = e4[4][1] + T2, e4[4][0] = e4[4][0] + b2 + (k3 / 4294967296 >>> 0) >>> 0, e4[4][1] = k3 >>> 0, k3 = e4[5][1] + I2, e4[5][0] = e4[5][0] + _24 + (k3 / 4294967296 >>> 0) >>> 0, e4[5][1] = k3 >>> 0, k3 = e4[6][1] + B2, e4[6][0] = e4[6][0] + A2 + (k3 / 4294967296 >>> 0) >>> 0, e4[6][1] = k3 >>> 0, k3 = e4[7][1] + R, e4[7][0] = e4[7][0] + w2 + (k3 / 4294967296 >>> 0) >>> 0, e4[7][1] = k3 >>> 0, V2 -= 128;
      }
    }
  }, 2676: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(1482), r3(7461), r3(4581), r3(2936), r3(3103);
    var i2 = e3.exports = n3.ssh = n3.ssh || {};
    function a6(e4, t4) {
      var r4 = t4.toString(16);
      r4[0] >= "8" && (r4 = "00" + r4);
      var i3 = n3.util.hexToBytes(r4);
      e4.putInt32(i3.length), e4.putBytes(i3);
    }
    function s2(e4, t4) {
      e4.putInt32(t4.length), e4.putString(t4);
    }
    function o() {
      for (var e4 = n3.md.sha1.create(), t4 = arguments.length, r4 = 0; r4 < t4; ++r4)
        e4.update(arguments[r4]);
      return e4.digest();
    }
    i2.privateKeyToPutty = function(e4, t4, r4) {
      var i3 = "ssh-rsa", u2 = (t4 = t4 || "") === "" ? "none" : "aes256-cbc", c2 = "PuTTY-User-Key-File-2: ssh-rsa\r\n";
      c2 += "Encryption: " + u2 + "\r\n", c2 += "Comment: " + (r4 = r4 || "") + "\r\n";
      var l2 = n3.util.createBuffer();
      s2(l2, i3), a6(l2, e4.e), a6(l2, e4.n);
      var h2 = n3.util.encode64(l2.bytes(), 64), f2 = Math.floor(h2.length / 66) + 1;
      c2 += "Public-Lines: " + f2 + "\r\n", c2 += h2;
      var p2, d2 = n3.util.createBuffer();
      if (a6(d2, e4.d), a6(d2, e4.p), a6(d2, e4.q), a6(d2, e4.qInv), t4) {
        var g2 = d2.length() + 16 - 1;
        g2 -= g2 % 16;
        var y2 = o(d2.bytes());
        y2.truncate(y2.length() - g2 + d2.length()), d2.putBuffer(y2);
        var v2 = n3.util.createBuffer();
        v2.putBuffer(o("\0\0\0\0", t4)), v2.putBuffer(o("\0\0\0", t4));
        var m2 = n3.aes.createEncryptionCipher(v2.truncate(8), "CBC");
        m2.start(n3.util.createBuffer().fillWithByte(0, 16)), m2.update(d2.copy()), m2.finish();
        var E2 = m2.output;
        E2.truncate(16), p2 = n3.util.encode64(E2.bytes(), 64);
      } else
        p2 = n3.util.encode64(d2.bytes(), 64);
      c2 += "\r\nPrivate-Lines: " + (f2 = Math.floor(p2.length / 66) + 1) + "\r\n", c2 += p2;
      var C = o("putty-private-key-file-mac-key", t4), S2 = n3.util.createBuffer();
      s2(S2, i3), s2(S2, u2), s2(S2, r4), S2.putInt32(l2.length()), S2.putBuffer(l2), S2.putInt32(d2.length()), S2.putBuffer(d2);
      var b2 = n3.hmac.create();
      return b2.start("sha1", C), b2.update(S2.bytes()), c2 + "\r\nPrivate-MAC: " + b2.digest().toHex() + "\r\n";
    }, i2.publicKeyToOpenSSH = function(e4, t4) {
      var r4 = "ssh-rsa";
      t4 = t4 || "";
      var i3 = n3.util.createBuffer();
      return s2(i3, r4), a6(i3, e4.e), a6(i3, e4.n), r4 + " " + n3.util.encode64(i3.bytes()) + " " + t4;
    }, i2.privateKeyToOpenSSH = function(e4, t4) {
      return t4 ? n3.pki.encryptRsaPrivateKey(e4, t4, { legacy: true, algorithm: "aes128" }) : n3.pki.privateKeyToPem(e4);
    }, i2.getPublicKeyFingerprint = function(e4, t4) {
      var r4 = (t4 = t4 || {}).md || n3.md.md5.create(), i3 = n3.util.createBuffer();
      s2(i3, "ssh-rsa"), a6(i3, e4.e), a6(i3, e4.n), r4.start(), r4.update(i3.getBytes());
      var o2 = r4.digest();
      if (t4.encoding === "hex") {
        var u2 = o2.toHex();
        return t4.delimiter ? u2.match(/.{2}/g).join(t4.delimiter) : u2;
      }
      if (t4.encoding === "binary")
        return o2.getBytes();
      if (t4.encoding)
        throw new Error('Unknown encoding "' + t4.encoding + '".');
      return o2;
    };
  }, 8472: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(2624), r3(7461), r3(4581), r3(5477), r3(4885), r3(4097), r3(2936), r3(3103);
    var i2 = function(e4, t4, r4, i3) {
      var a7 = n3.util.createBuffer(), s3 = e4.length >> 1, o2 = s3 + (1 & e4.length), u3 = e4.substr(0, o2), c3 = e4.substr(s3, o2), l3 = n3.util.createBuffer(), h3 = n3.hmac.create();
      r4 = t4 + r4;
      var f3 = Math.ceil(i3 / 16), p3 = Math.ceil(i3 / 20);
      h3.start("MD5", u3);
      var d3 = n3.util.createBuffer();
      l3.putBytes(r4);
      for (var g3 = 0; g3 < f3; ++g3)
        h3.start(null, null), h3.update(l3.getBytes()), l3.putBuffer(h3.digest()), h3.start(null, null), h3.update(l3.bytes() + r4), d3.putBuffer(h3.digest());
      h3.start("SHA1", c3);
      var y3 = n3.util.createBuffer();
      for (l3.clear(), l3.putBytes(r4), g3 = 0; g3 < p3; ++g3)
        h3.start(null, null), h3.update(l3.getBytes()), l3.putBuffer(h3.digest()), h3.start(null, null), h3.update(l3.bytes() + r4), y3.putBuffer(h3.digest());
      return a7.putBytes(n3.util.xorBytes(d3.getBytes(), y3.getBytes(), i3)), a7;
    }, a6 = function(e4, t4, r4) {
      var i3 = false;
      try {
        var a7 = e4.deflate(t4.fragment.getBytes());
        t4.fragment = n3.util.createBuffer(a7), t4.length = a7.length, i3 = true;
      } catch (e5) {
      }
      return i3;
    }, s2 = function(e4, t4, r4) {
      var i3 = false;
      try {
        var a7 = e4.inflate(t4.fragment.getBytes());
        t4.fragment = n3.util.createBuffer(a7), t4.length = a7.length, i3 = true;
      } catch (e5) {
      }
      return i3;
    }, o = function(e4, t4) {
      var r4 = 0;
      switch (t4) {
        case 1:
          r4 = e4.getByte();
          break;
        case 2:
          r4 = e4.getInt16();
          break;
        case 3:
          r4 = e4.getInt24();
          break;
        case 4:
          r4 = e4.getInt32();
      }
      return n3.util.createBuffer(e4.getBytes(r4));
    }, u2 = function(e4, t4, r4) {
      e4.putInt(r4.length(), t4 << 3), e4.putBuffer(r4);
    }, c2 = { Versions: { TLS_1_0: { major: 3, minor: 1 }, TLS_1_1: { major: 3, minor: 2 }, TLS_1_2: { major: 3, minor: 3 } } };
    c2.SupportedVersions = [c2.Versions.TLS_1_1, c2.Versions.TLS_1_0], c2.Version = c2.SupportedVersions[0], c2.MaxFragment = 15360, c2.ConnectionEnd = { server: 0, client: 1 }, c2.PRFAlgorithm = { tls_prf_sha256: 0 }, c2.BulkCipherAlgorithm = { none: null, rc4: 0, des3: 1, aes: 2 }, c2.CipherType = { stream: 0, block: 1, aead: 2 }, c2.MACAlgorithm = { none: null, hmac_md5: 0, hmac_sha1: 1, hmac_sha256: 2, hmac_sha384: 3, hmac_sha512: 4 }, c2.CompressionMethod = { none: 0, deflate: 1 }, c2.ContentType = { change_cipher_spec: 20, alert: 21, handshake: 22, application_data: 23, heartbeat: 24 }, c2.HandshakeType = { hello_request: 0, client_hello: 1, server_hello: 2, certificate: 11, server_key_exchange: 12, certificate_request: 13, server_hello_done: 14, certificate_verify: 15, client_key_exchange: 16, finished: 20 }, c2.Alert = {}, c2.Alert.Level = { warning: 1, fatal: 2 }, c2.Alert.Description = { close_notify: 0, unexpected_message: 10, bad_record_mac: 20, decryption_failed: 21, record_overflow: 22, decompression_failure: 30, handshake_failure: 40, bad_certificate: 42, unsupported_certificate: 43, certificate_revoked: 44, certificate_expired: 45, certificate_unknown: 46, illegal_parameter: 47, unknown_ca: 48, access_denied: 49, decode_error: 50, decrypt_error: 51, export_restriction: 60, protocol_version: 70, insufficient_security: 71, internal_error: 80, user_canceled: 90, no_renegotiation: 100 }, c2.HeartbeatMessageType = { heartbeat_request: 1, heartbeat_response: 2 }, c2.CipherSuites = {}, c2.getCipherSuite = function(e4) {
      var t4 = null;
      for (var r4 in c2.CipherSuites) {
        var n4 = c2.CipherSuites[r4];
        if (n4.id[0] === e4.charCodeAt(0) && n4.id[1] === e4.charCodeAt(1)) {
          t4 = n4;
          break;
        }
      }
      return t4;
    }, c2.handleUnexpected = function(e4, t4) {
      !e4.open && e4.entity === c2.ConnectionEnd.client || e4.error(e4, { message: "Unexpected message. Received TLS record out of order.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.unexpected_message } });
    }, c2.handleHelloRequest = function(e4, t4, r4) {
      !e4.handshaking && e4.handshakes > 0 && (c2.queue(e4, c2.createAlert(e4, { level: c2.Alert.Level.warning, description: c2.Alert.Description.no_renegotiation })), c2.flush(e4)), e4.process();
    }, c2.parseHelloMessage = function(e4, t4, r4) {
      var i3 = null, a7 = e4.entity === c2.ConnectionEnd.client;
      if (r4 < 38)
        e4.error(e4, { message: a7 ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.illegal_parameter } });
      else {
        var s3 = t4.fragment, u3 = s3.length();
        if (i3 = { version: { major: s3.getByte(), minor: s3.getByte() }, random: n3.util.createBuffer(s3.getBytes(32)), session_id: o(s3, 1), extensions: [] }, a7 ? (i3.cipher_suite = s3.getBytes(2), i3.compression_method = s3.getByte()) : (i3.cipher_suites = o(s3, 2), i3.compression_methods = o(s3, 1)), (u3 = r4 - (u3 - s3.length())) > 0) {
          for (var l3 = o(s3, 2); l3.length() > 0; )
            i3.extensions.push({ type: [l3.getByte(), l3.getByte()], data: o(l3, 2) });
          if (!a7)
            for (var h3 = 0; h3 < i3.extensions.length; ++h3) {
              var f3 = i3.extensions[h3];
              if (f3.type[0] === 0 && f3.type[1] === 0)
                for (var p3 = o(f3.data, 2); p3.length() > 0 && p3.getByte() === 0; )
                  e4.session.extensions.server_name.serverNameList.push(o(p3, 2).getBytes());
            }
        }
        if (e4.session.version && (i3.version.major !== e4.session.version.major || i3.version.minor !== e4.session.version.minor))
          return e4.error(e4, { message: "TLS version change is disallowed during renegotiation.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.protocol_version } });
        if (a7)
          e4.session.cipherSuite = c2.getCipherSuite(i3.cipher_suite);
        else
          for (var d3 = n3.util.createBuffer(i3.cipher_suites.bytes()); d3.length() > 0 && (e4.session.cipherSuite = c2.getCipherSuite(d3.getBytes(2)), e4.session.cipherSuite === null); )
            ;
        if (e4.session.cipherSuite === null)
          return e4.error(e4, { message: "No cipher suites in common.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.handshake_failure }, cipherSuite: n3.util.bytesToHex(i3.cipher_suite) });
        e4.session.compressionMethod = a7 ? i3.compression_method : c2.CompressionMethod.none;
      }
      return i3;
    }, c2.createSecurityParameters = function(e4, t4) {
      var r4 = e4.entity === c2.ConnectionEnd.client, n4 = t4.random.bytes(), i3 = r4 ? e4.session.sp.client_random : n4, a7 = r4 ? n4 : c2.createRandom().getBytes();
      e4.session.sp = { entity: e4.entity, prf_algorithm: c2.PRFAlgorithm.tls_prf_sha256, bulk_cipher_algorithm: null, cipher_type: null, enc_key_length: null, block_length: null, fixed_iv_length: null, record_iv_length: null, mac_algorithm: null, mac_length: null, mac_key_length: null, compression_algorithm: e4.session.compressionMethod, pre_master_secret: null, master_secret: null, client_random: i3, server_random: a7 };
    }, c2.handleServerHello = function(e4, t4, r4) {
      var n4 = c2.parseHelloMessage(e4, t4, r4);
      if (!e4.fail) {
        if (!(n4.version.minor <= e4.version.minor))
          return e4.error(e4, { message: "Incompatible TLS version.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.protocol_version } });
        e4.version.minor = n4.version.minor, e4.session.version = e4.version;
        var i3 = n4.session_id.bytes();
        i3.length > 0 && i3 === e4.session.id ? (e4.expect = d2, e4.session.resuming = true, e4.session.sp.server_random = n4.random.bytes()) : (e4.expect = l2, e4.session.resuming = false, c2.createSecurityParameters(e4, n4)), e4.session.id = i3, e4.process();
      }
    }, c2.handleClientHello = function(e4, t4, r4) {
      var i3 = c2.parseHelloMessage(e4, t4, r4);
      if (!e4.fail) {
        var a7 = i3.session_id.bytes(), s3 = null;
        if (e4.sessionCache && ((s3 = e4.sessionCache.getSession(a7)) === null ? a7 = "" : (s3.version.major !== i3.version.major || s3.version.minor > i3.version.minor) && (s3 = null, a7 = "")), a7.length === 0 && (a7 = n3.random.getBytes(32)), e4.session.id = a7, e4.session.clientHelloVersion = i3.version, e4.session.sp = {}, s3)
          e4.version = e4.session.version = s3.version, e4.session.sp = s3.sp;
        else {
          for (var o2, u3 = 1; u3 < c2.SupportedVersions.length && !((o2 = c2.SupportedVersions[u3]).minor <= i3.version.minor); ++u3)
            ;
          e4.version = { major: o2.major, minor: o2.minor }, e4.session.version = e4.version;
        }
        s3 !== null ? (e4.expect = S2, e4.session.resuming = true, e4.session.sp.client_random = i3.random.bytes()) : (e4.expect = e4.verifyClient !== false ? m2 : E2, e4.session.resuming = false, c2.createSecurityParameters(e4, i3)), e4.open = true, c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createServerHello(e4) })), e4.session.resuming ? (c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.change_cipher_spec, data: c2.createChangeCipherSpec() })), e4.state.pending = c2.createConnectionState(e4), e4.state.current.write = e4.state.pending.write, c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createFinished(e4) }))) : (c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createCertificate(e4) })), e4.fail || (c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createServerKeyExchange(e4) })), e4.verifyClient !== false && c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createCertificateRequest(e4) })), c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createServerHelloDone(e4) })))), c2.flush(e4), e4.process();
      }
    }, c2.handleCertificate = function(e4, t4, r4) {
      if (r4 < 3)
        return e4.error(e4, { message: "Invalid Certificate message. Message too short.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.illegal_parameter } });
      var i3, a7, s3 = t4.fragment, u3 = { certificate_list: o(s3, 3) }, l3 = [];
      try {
        for (; u3.certificate_list.length() > 0; )
          i3 = o(u3.certificate_list, 3), a7 = n3.asn1.fromDer(i3), i3 = n3.pki.certificateFromAsn1(a7, true), l3.push(i3);
      } catch (t5) {
        return e4.error(e4, { message: "Could not parse certificate list.", cause: t5, send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.bad_certificate } });
      }
      var f3 = e4.entity === c2.ConnectionEnd.client;
      !f3 && e4.verifyClient !== true || l3.length !== 0 ? l3.length === 0 ? e4.expect = f3 ? h2 : E2 : (f3 ? e4.session.serverCertificate = l3[0] : e4.session.clientCertificate = l3[0], c2.verifyCertificateChain(e4, l3) && (e4.expect = f3 ? h2 : E2)) : e4.error(e4, { message: f3 ? "No server certificate provided." : "No client certificate provided.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.illegal_parameter } }), e4.process();
    }, c2.handleServerKeyExchange = function(e4, t4, r4) {
      if (r4 > 0)
        return e4.error(e4, { message: "Invalid key parameters. Only RSA is supported.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.unsupported_certificate } });
      e4.expect = f2, e4.process();
    }, c2.handleClientKeyExchange = function(e4, t4, r4) {
      if (r4 < 48)
        return e4.error(e4, { message: "Invalid key parameters. Only RSA is supported.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.unsupported_certificate } });
      var i3 = t4.fragment, a7 = { enc_pre_master_secret: o(i3, 2).getBytes() }, s3 = null;
      if (e4.getPrivateKey)
        try {
          s3 = e4.getPrivateKey(e4, e4.session.serverCertificate), s3 = n3.pki.privateKeyFromPem(s3);
        } catch (t5) {
          e4.error(e4, { message: "Could not get private key.", cause: t5, send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.internal_error } });
        }
      if (s3 === null)
        return e4.error(e4, { message: "No private key set.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.internal_error } });
      try {
        var u3 = e4.session.sp;
        u3.pre_master_secret = s3.decrypt(a7.enc_pre_master_secret);
        var l3 = e4.session.clientHelloVersion;
        if (l3.major !== u3.pre_master_secret.charCodeAt(0) || l3.minor !== u3.pre_master_secret.charCodeAt(1))
          throw new Error("TLS version rollback attack detected.");
      } catch (e5) {
        u3.pre_master_secret = n3.random.getBytes(48);
      }
      e4.expect = S2, e4.session.clientCertificate !== null && (e4.expect = C), e4.process();
    }, c2.handleCertificateRequest = function(e4, t4, r4) {
      if (r4 < 3)
        return e4.error(e4, { message: "Invalid CertificateRequest. Message too short.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.illegal_parameter } });
      var n4 = t4.fragment, i3 = { certificate_types: o(n4, 1), certificate_authorities: o(n4, 2) };
      e4.session.certificateRequest = i3, e4.expect = p2, e4.process();
    }, c2.handleCertificateVerify = function(e4, t4, r4) {
      if (r4 < 2)
        return e4.error(e4, { message: "Invalid CertificateVerify. Message too short.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.illegal_parameter } });
      var i3 = t4.fragment;
      i3.read -= 4;
      var a7 = i3.bytes();
      i3.read += 4;
      var s3 = { signature: o(i3, 2).getBytes() }, u3 = n3.util.createBuffer();
      u3.putBuffer(e4.session.md5.digest()), u3.putBuffer(e4.session.sha1.digest()), u3 = u3.getBytes();
      try {
        if (!e4.session.clientCertificate.publicKey.verify(u3, s3.signature, "NONE"))
          throw new Error("CertificateVerify signature does not match.");
        e4.session.md5.update(a7), e4.session.sha1.update(a7);
      } catch (t5) {
        return e4.error(e4, { message: "Bad signature in CertificateVerify.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.handshake_failure } });
      }
      e4.expect = S2, e4.process();
    }, c2.handleServerHelloDone = function(e4, t4, r4) {
      if (r4 > 0)
        return e4.error(e4, { message: "Invalid ServerHelloDone message. Invalid length.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.record_overflow } });
      if (e4.serverCertificate === null) {
        var i3 = { message: "No server certificate provided. Not enough security.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.insufficient_security } }, a7 = e4.verify(e4, i3.alert.description, 0, []);
        if (a7 !== true)
          return (a7 || a7 === 0) && (typeof a7 != "object" || n3.util.isArray(a7) ? typeof a7 == "number" && (i3.alert.description = a7) : (a7.message && (i3.message = a7.message), a7.alert && (i3.alert.description = a7.alert))), e4.error(e4, i3);
      }
      e4.session.certificateRequest !== null && (t4 = c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createCertificate(e4) }), c2.queue(e4, t4)), t4 = c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createClientKeyExchange(e4) }), c2.queue(e4, t4), e4.expect = v2;
      var s3 = function(e5, t5) {
        e5.session.certificateRequest !== null && e5.session.clientCertificate !== null && c2.queue(e5, c2.createRecord(e5, { type: c2.ContentType.handshake, data: c2.createCertificateVerify(e5, t5) })), c2.queue(e5, c2.createRecord(e5, { type: c2.ContentType.change_cipher_spec, data: c2.createChangeCipherSpec() })), e5.state.pending = c2.createConnectionState(e5), e5.state.current.write = e5.state.pending.write, c2.queue(e5, c2.createRecord(e5, { type: c2.ContentType.handshake, data: c2.createFinished(e5) })), e5.expect = d2, c2.flush(e5), e5.process();
      };
      if (e4.session.certificateRequest === null || e4.session.clientCertificate === null)
        return s3(e4, null);
      c2.getClientSignature(e4, s3);
    }, c2.handleChangeCipherSpec = function(e4, t4) {
      if (t4.fragment.getByte() !== 1)
        return e4.error(e4, { message: "Invalid ChangeCipherSpec message received.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.illegal_parameter } });
      var r4 = e4.entity === c2.ConnectionEnd.client;
      (e4.session.resuming && r4 || !e4.session.resuming && !r4) && (e4.state.pending = c2.createConnectionState(e4)), e4.state.current.read = e4.state.pending.read, (!e4.session.resuming && r4 || e4.session.resuming && !r4) && (e4.state.pending = null), e4.expect = r4 ? g2 : b2, e4.process();
    }, c2.handleFinished = function(e4, t4, r4) {
      var a7 = t4.fragment;
      a7.read -= 4;
      var s3 = a7.bytes();
      a7.read += 4;
      var o2 = t4.fragment.getBytes();
      (a7 = n3.util.createBuffer()).putBuffer(e4.session.md5.digest()), a7.putBuffer(e4.session.sha1.digest());
      var u3 = e4.entity === c2.ConnectionEnd.client, l3 = u3 ? "server finished" : "client finished", h3 = e4.session.sp;
      if ((a7 = i2(h3.master_secret, l3, a7.getBytes(), 12)).getBytes() !== o2)
        return e4.error(e4, { message: "Invalid verify_data in Finished message.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.decrypt_error } });
      e4.session.md5.update(s3), e4.session.sha1.update(s3), (e4.session.resuming && u3 || !e4.session.resuming && !u3) && (c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.change_cipher_spec, data: c2.createChangeCipherSpec() })), e4.state.current.write = e4.state.pending.write, e4.state.pending = null, c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.handshake, data: c2.createFinished(e4) }))), e4.expect = u3 ? y2 : T2, e4.handshaking = false, ++e4.handshakes, e4.peerCertificate = u3 ? e4.session.serverCertificate : e4.session.clientCertificate, c2.flush(e4), e4.isConnected = true, e4.connected(e4), e4.process();
    }, c2.handleAlert = function(e4, t4) {
      var r4, n4 = t4.fragment, i3 = { level: n4.getByte(), description: n4.getByte() };
      switch (i3.description) {
        case c2.Alert.Description.close_notify:
          r4 = "Connection closed.";
          break;
        case c2.Alert.Description.unexpected_message:
          r4 = "Unexpected message.";
          break;
        case c2.Alert.Description.bad_record_mac:
          r4 = "Bad record MAC.";
          break;
        case c2.Alert.Description.decryption_failed:
          r4 = "Decryption failed.";
          break;
        case c2.Alert.Description.record_overflow:
          r4 = "Record overflow.";
          break;
        case c2.Alert.Description.decompression_failure:
          r4 = "Decompression failed.";
          break;
        case c2.Alert.Description.handshake_failure:
          r4 = "Handshake failure.";
          break;
        case c2.Alert.Description.bad_certificate:
          r4 = "Bad certificate.";
          break;
        case c2.Alert.Description.unsupported_certificate:
          r4 = "Unsupported certificate.";
          break;
        case c2.Alert.Description.certificate_revoked:
          r4 = "Certificate revoked.";
          break;
        case c2.Alert.Description.certificate_expired:
          r4 = "Certificate expired.";
          break;
        case c2.Alert.Description.certificate_unknown:
          r4 = "Certificate unknown.";
          break;
        case c2.Alert.Description.illegal_parameter:
          r4 = "Illegal parameter.";
          break;
        case c2.Alert.Description.unknown_ca:
          r4 = "Unknown certificate authority.";
          break;
        case c2.Alert.Description.access_denied:
          r4 = "Access denied.";
          break;
        case c2.Alert.Description.decode_error:
          r4 = "Decode error.";
          break;
        case c2.Alert.Description.decrypt_error:
          r4 = "Decrypt error.";
          break;
        case c2.Alert.Description.export_restriction:
          r4 = "Export restriction.";
          break;
        case c2.Alert.Description.protocol_version:
          r4 = "Unsupported protocol version.";
          break;
        case c2.Alert.Description.insufficient_security:
          r4 = "Insufficient security.";
          break;
        case c2.Alert.Description.internal_error:
          r4 = "Internal error.";
          break;
        case c2.Alert.Description.user_canceled:
          r4 = "User canceled.";
          break;
        case c2.Alert.Description.no_renegotiation:
          r4 = "Renegotiation not supported.";
          break;
        default:
          r4 = "Unknown error.";
      }
      if (i3.description === c2.Alert.Description.close_notify)
        return e4.close();
      e4.error(e4, { message: r4, send: false, origin: e4.entity === c2.ConnectionEnd.client ? "server" : "client", alert: i3 }), e4.process();
    }, c2.handleHandshake = function(e4, t4) {
      var r4 = t4.fragment, i3 = r4.getByte(), a7 = r4.getInt24();
      if (a7 > r4.length())
        return e4.fragmented = t4, t4.fragment = n3.util.createBuffer(), r4.read -= 4, e4.process();
      e4.fragmented = null, r4.read -= 4;
      var s3 = r4.bytes(a7 + 4);
      r4.read += 4, i3 in x2[e4.entity][e4.expect] ? (e4.entity !== c2.ConnectionEnd.server || e4.open || e4.fail || (e4.handshaking = true, e4.session = { version: null, extensions: { server_name: { serverNameList: [] } }, cipherSuite: null, compressionMethod: null, serverCertificate: null, clientCertificate: null, md5: n3.md.md5.create(), sha1: n3.md.sha1.create() }), i3 !== c2.HandshakeType.hello_request && i3 !== c2.HandshakeType.certificate_verify && i3 !== c2.HandshakeType.finished && (e4.session.md5.update(s3), e4.session.sha1.update(s3)), x2[e4.entity][e4.expect][i3](e4, t4, a7)) : c2.handleUnexpected(e4, t4);
    }, c2.handleApplicationData = function(e4, t4) {
      e4.data.putBuffer(t4.fragment), e4.dataReady(e4), e4.process();
    }, c2.handleHeartbeat = function(e4, t4) {
      var r4 = t4.fragment, i3 = r4.getByte(), a7 = r4.getInt16(), s3 = r4.getBytes(a7);
      if (i3 === c2.HeartbeatMessageType.heartbeat_request) {
        if (e4.handshaking || a7 > s3.length)
          return e4.process();
        c2.queue(e4, c2.createRecord(e4, { type: c2.ContentType.heartbeat, data: c2.createHeartbeat(c2.HeartbeatMessageType.heartbeat_response, s3) })), c2.flush(e4);
      } else if (i3 === c2.HeartbeatMessageType.heartbeat_response) {
        if (s3 !== e4.expectedHeartbeatPayload)
          return e4.process();
        e4.heartbeatReceived && e4.heartbeatReceived(e4, n3.util.createBuffer(s3));
      }
      e4.process();
    };
    var l2 = 1, h2 = 2, f2 = 3, p2 = 4, d2 = 5, g2 = 6, y2 = 7, v2 = 8, m2 = 1, E2 = 2, C = 3, S2 = 4, b2 = 5, T2 = 6, _24 = c2.handleUnexpected, I2 = c2.handleChangeCipherSpec, A2 = c2.handleAlert, B2 = c2.handleHandshake, w2 = c2.handleApplicationData, R = c2.handleHeartbeat, N2 = [];
    N2[c2.ConnectionEnd.client] = [[_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [I2, A2, _24, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, w2, R], [_24, A2, B2, _24, R]], N2[c2.ConnectionEnd.server] = [[_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, _24, R], [I2, A2, _24, _24, R], [_24, A2, B2, _24, R], [_24, A2, B2, w2, R], [_24, A2, B2, _24, R]];
    var L2 = c2.handleHelloRequest, k3 = c2.handleServerHello, U2 = c2.handleCertificate, D2 = c2.handleServerKeyExchange, P2 = c2.handleCertificateRequest, O = c2.handleServerHelloDone, V2 = c2.handleFinished, x2 = [];
    x2[c2.ConnectionEnd.client] = [[_24, _24, k3, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, U2, D2, P2, O, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, D2, P2, O, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, P2, O, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, O, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, V2], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24], [L2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24]];
    var M2 = c2.handleClientHello, K2 = c2.handleClientKeyExchange, j2 = c2.handleCertificateVerify;
    x2[c2.ConnectionEnd.server] = [[_24, M2, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, U2, _24, _24, _24, _24, _24, _24, _24, _24, _24], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, K2, _24, _24, _24, _24], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, j2, _24, _24, _24, _24, _24], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, V2], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24], [_24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24, _24]], c2.generateKeys = function(e4, t4) {
      var r4 = i2, n4 = t4.client_random + t4.server_random;
      e4.session.resuming || (t4.master_secret = r4(t4.pre_master_secret, "master secret", n4, 48).bytes(), t4.pre_master_secret = null), n4 = t4.server_random + t4.client_random;
      var a7 = 2 * t4.mac_key_length + 2 * t4.enc_key_length, s3 = e4.version.major === c2.Versions.TLS_1_0.major && e4.version.minor === c2.Versions.TLS_1_0.minor;
      s3 && (a7 += 2 * t4.fixed_iv_length);
      var o2 = r4(t4.master_secret, "key expansion", n4, a7), u3 = { client_write_MAC_key: o2.getBytes(t4.mac_key_length), server_write_MAC_key: o2.getBytes(t4.mac_key_length), client_write_key: o2.getBytes(t4.enc_key_length), server_write_key: o2.getBytes(t4.enc_key_length) };
      return s3 && (u3.client_write_IV = o2.getBytes(t4.fixed_iv_length), u3.server_write_IV = o2.getBytes(t4.fixed_iv_length)), u3;
    }, c2.createConnectionState = function(e4) {
      var t4 = e4.entity === c2.ConnectionEnd.client, r4 = function() {
        var e5 = { sequenceNumber: [0, 0], macKey: null, macLength: 0, macFunction: null, cipherState: null, cipherFunction: function(e6) {
          return true;
        }, compressionState: null, compressFunction: function(e6) {
          return true;
        }, updateSequenceNumber: function() {
          e5.sequenceNumber[1] === 4294967295 ? (e5.sequenceNumber[1] = 0, ++e5.sequenceNumber[0]) : ++e5.sequenceNumber[1];
        } };
        return e5;
      }, n4 = { read: r4(), write: r4() };
      if (n4.read.update = function(e5, t5) {
        return n4.read.cipherFunction(t5, n4.read) ? n4.read.compressFunction(e5, t5, n4.read) || e5.error(e5, { message: "Could not decompress record.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.decompression_failure } }) : e5.error(e5, { message: "Could not decrypt record or bad MAC.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.bad_record_mac } }), !e5.fail;
      }, n4.write.update = function(e5, t5) {
        return n4.write.compressFunction(e5, t5, n4.write) ? n4.write.cipherFunction(t5, n4.write) || e5.error(e5, { message: "Could not encrypt record.", send: false, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.internal_error } }) : e5.error(e5, { message: "Could not compress record.", send: false, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.internal_error } }), !e5.fail;
      }, e4.session) {
        var i3 = e4.session.sp;
        switch (e4.session.cipherSuite.initSecurityParameters(i3), i3.keys = c2.generateKeys(e4, i3), n4.read.macKey = t4 ? i3.keys.server_write_MAC_key : i3.keys.client_write_MAC_key, n4.write.macKey = t4 ? i3.keys.client_write_MAC_key : i3.keys.server_write_MAC_key, e4.session.cipherSuite.initConnectionState(n4, e4, i3), i3.compression_algorithm) {
          case c2.CompressionMethod.none:
            break;
          case c2.CompressionMethod.deflate:
            n4.read.compressFunction = s2, n4.write.compressFunction = a6;
            break;
          default:
            throw new Error("Unsupported compression algorithm.");
        }
      }
      return n4;
    }, c2.createRandom = function() {
      var e4 = new Date(), t4 = +e4 + 6e4 * e4.getTimezoneOffset(), r4 = n3.util.createBuffer();
      return r4.putInt32(t4), r4.putBytes(n3.random.getBytes(28)), r4;
    }, c2.createRecord = function(e4, t4) {
      return t4.data ? { type: t4.type, version: { major: e4.version.major, minor: e4.version.minor }, length: t4.data.length(), fragment: t4.data } : null;
    }, c2.createAlert = function(e4, t4) {
      var r4 = n3.util.createBuffer();
      return r4.putByte(t4.level), r4.putByte(t4.description), c2.createRecord(e4, { type: c2.ContentType.alert, data: r4 });
    }, c2.createClientHello = function(e4) {
      e4.session.clientHelloVersion = { major: e4.version.major, minor: e4.version.minor };
      for (var t4 = n3.util.createBuffer(), r4 = 0; r4 < e4.cipherSuites.length; ++r4) {
        var i3 = e4.cipherSuites[r4];
        t4.putByte(i3.id[0]), t4.putByte(i3.id[1]);
      }
      var a7 = t4.length(), s3 = n3.util.createBuffer();
      s3.putByte(c2.CompressionMethod.none);
      var o2 = s3.length(), l3 = n3.util.createBuffer();
      if (e4.virtualHost) {
        var h3 = n3.util.createBuffer();
        h3.putByte(0), h3.putByte(0);
        var f3 = n3.util.createBuffer();
        f3.putByte(0), u2(f3, 2, n3.util.createBuffer(e4.virtualHost));
        var p3 = n3.util.createBuffer();
        u2(p3, 2, f3), u2(h3, 2, p3), l3.putBuffer(h3);
      }
      var d3 = l3.length();
      d3 > 0 && (d3 += 2);
      var g3 = e4.session.id, y3 = g3.length + 1 + 2 + 4 + 28 + 2 + a7 + 1 + o2 + d3, v3 = n3.util.createBuffer();
      return v3.putByte(c2.HandshakeType.client_hello), v3.putInt24(y3), v3.putByte(e4.version.major), v3.putByte(e4.version.minor), v3.putBytes(e4.session.sp.client_random), u2(v3, 1, n3.util.createBuffer(g3)), u2(v3, 2, t4), u2(v3, 1, s3), d3 > 0 && u2(v3, 2, l3), v3;
    }, c2.createServerHello = function(e4) {
      var t4 = e4.session.id, r4 = t4.length + 1 + 2 + 4 + 28 + 2 + 1, i3 = n3.util.createBuffer();
      return i3.putByte(c2.HandshakeType.server_hello), i3.putInt24(r4), i3.putByte(e4.version.major), i3.putByte(e4.version.minor), i3.putBytes(e4.session.sp.server_random), u2(i3, 1, n3.util.createBuffer(t4)), i3.putByte(e4.session.cipherSuite.id[0]), i3.putByte(e4.session.cipherSuite.id[1]), i3.putByte(e4.session.compressionMethod), i3;
    }, c2.createCertificate = function(e4) {
      var t4, r4 = e4.entity === c2.ConnectionEnd.client, i3 = null;
      e4.getCertificate && (t4 = r4 ? e4.session.certificateRequest : e4.session.extensions.server_name.serverNameList, i3 = e4.getCertificate(e4, t4));
      var a7 = n3.util.createBuffer();
      if (i3 !== null)
        try {
          n3.util.isArray(i3) || (i3 = [i3]);
          for (var s3 = null, o2 = 0; o2 < i3.length; ++o2) {
            var l3 = n3.pem.decode(i3[o2])[0];
            if (l3.type !== "CERTIFICATE" && l3.type !== "X509 CERTIFICATE" && l3.type !== "TRUSTED CERTIFICATE") {
              var h3 = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
              throw h3.headerType = l3.type, h3;
            }
            if (l3.procType && l3.procType.type === "ENCRYPTED")
              throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
            var f3 = n3.util.createBuffer(l3.body);
            s3 === null && (s3 = n3.asn1.fromDer(f3.bytes(), false));
            var p3 = n3.util.createBuffer();
            u2(p3, 3, f3), a7.putBuffer(p3);
          }
          i3 = n3.pki.certificateFromAsn1(s3), r4 ? e4.session.clientCertificate = i3 : e4.session.serverCertificate = i3;
        } catch (t5) {
          return e4.error(e4, { message: "Could not send certificate list.", cause: t5, send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.bad_certificate } });
        }
      var d3 = 3 + a7.length(), g3 = n3.util.createBuffer();
      return g3.putByte(c2.HandshakeType.certificate), g3.putInt24(d3), u2(g3, 3, a7), g3;
    }, c2.createClientKeyExchange = function(e4) {
      var t4 = n3.util.createBuffer();
      t4.putByte(e4.session.clientHelloVersion.major), t4.putByte(e4.session.clientHelloVersion.minor), t4.putBytes(n3.random.getBytes(46));
      var r4 = e4.session.sp;
      r4.pre_master_secret = t4.getBytes();
      var i3 = (t4 = e4.session.serverCertificate.publicKey.encrypt(r4.pre_master_secret)).length + 2, a7 = n3.util.createBuffer();
      return a7.putByte(c2.HandshakeType.client_key_exchange), a7.putInt24(i3), a7.putInt16(t4.length), a7.putBytes(t4), a7;
    }, c2.createServerKeyExchange = function(e4) {
      return n3.util.createBuffer();
    }, c2.getClientSignature = function(e4, t4) {
      var r4 = n3.util.createBuffer();
      r4.putBuffer(e4.session.md5.digest()), r4.putBuffer(e4.session.sha1.digest()), r4 = r4.getBytes(), e4.getSignature = e4.getSignature || function(e5, t5, r5) {
        var i3 = null;
        if (e5.getPrivateKey)
          try {
            i3 = e5.getPrivateKey(e5, e5.session.clientCertificate), i3 = n3.pki.privateKeyFromPem(i3);
          } catch (t6) {
            e5.error(e5, { message: "Could not get private key.", cause: t6, send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.internal_error } });
          }
        i3 === null ? e5.error(e5, { message: "No private key set.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.internal_error } }) : t5 = i3.sign(t5, null), r5(e5, t5);
      }, e4.getSignature(e4, r4, t4);
    }, c2.createCertificateVerify = function(e4, t4) {
      var r4 = t4.length + 2, i3 = n3.util.createBuffer();
      return i3.putByte(c2.HandshakeType.certificate_verify), i3.putInt24(r4), i3.putInt16(t4.length), i3.putBytes(t4), i3;
    }, c2.createCertificateRequest = function(e4) {
      var t4 = n3.util.createBuffer();
      t4.putByte(1);
      var r4 = n3.util.createBuffer();
      for (var i3 in e4.caStore.certs) {
        var a7 = e4.caStore.certs[i3], s3 = n3.pki.distinguishedNameToAsn1(a7.subject), o2 = n3.asn1.toDer(s3);
        r4.putInt16(o2.length()), r4.putBuffer(o2);
      }
      var l3 = 1 + t4.length() + 2 + r4.length(), h3 = n3.util.createBuffer();
      return h3.putByte(c2.HandshakeType.certificate_request), h3.putInt24(l3), u2(h3, 1, t4), u2(h3, 2, r4), h3;
    }, c2.createServerHelloDone = function(e4) {
      var t4 = n3.util.createBuffer();
      return t4.putByte(c2.HandshakeType.server_hello_done), t4.putInt24(0), t4;
    }, c2.createChangeCipherSpec = function() {
      var e4 = n3.util.createBuffer();
      return e4.putByte(1), e4;
    }, c2.createFinished = function(e4) {
      var t4 = n3.util.createBuffer();
      t4.putBuffer(e4.session.md5.digest()), t4.putBuffer(e4.session.sha1.digest());
      var r4 = e4.entity === c2.ConnectionEnd.client, a7 = e4.session.sp, s3 = r4 ? "client finished" : "server finished";
      t4 = i2(a7.master_secret, s3, t4.getBytes(), 12);
      var o2 = n3.util.createBuffer();
      return o2.putByte(c2.HandshakeType.finished), o2.putInt24(t4.length()), o2.putBuffer(t4), o2;
    }, c2.createHeartbeat = function(e4, t4, r4) {
      r4 === void 0 && (r4 = t4.length);
      var i3 = n3.util.createBuffer();
      i3.putByte(e4), i3.putInt16(r4), i3.putBytes(t4);
      var a7 = i3.length(), s3 = Math.max(16, a7 - r4 - 3);
      return i3.putBytes(n3.random.getBytes(s3)), i3;
    }, c2.queue = function(e4, t4) {
      if (t4 && (t4.fragment.length() !== 0 || t4.type !== c2.ContentType.handshake && t4.type !== c2.ContentType.alert && t4.type !== c2.ContentType.change_cipher_spec)) {
        if (t4.type === c2.ContentType.handshake) {
          var r4 = t4.fragment.bytes();
          e4.session.md5.update(r4), e4.session.sha1.update(r4), r4 = null;
        }
        var i3;
        if (t4.fragment.length() <= c2.MaxFragment)
          i3 = [t4];
        else {
          i3 = [];
          for (var a7 = t4.fragment.bytes(); a7.length > c2.MaxFragment; )
            i3.push(c2.createRecord(e4, { type: t4.type, data: n3.util.createBuffer(a7.slice(0, c2.MaxFragment)) })), a7 = a7.slice(c2.MaxFragment);
          a7.length > 0 && i3.push(c2.createRecord(e4, { type: t4.type, data: n3.util.createBuffer(a7) }));
        }
        for (var s3 = 0; s3 < i3.length && !e4.fail; ++s3) {
          var o2 = i3[s3];
          e4.state.current.write.update(e4, o2) && e4.records.push(o2);
        }
      }
    }, c2.flush = function(e4) {
      for (var t4 = 0; t4 < e4.records.length; ++t4) {
        var r4 = e4.records[t4];
        e4.tlsData.putByte(r4.type), e4.tlsData.putByte(r4.version.major), e4.tlsData.putByte(r4.version.minor), e4.tlsData.putInt16(r4.fragment.length()), e4.tlsData.putBuffer(e4.records[t4].fragment);
      }
      return e4.records = [], e4.tlsDataReady(e4);
    };
    var F2 = function(e4) {
      switch (e4) {
        case true:
          return true;
        case n3.pki.certificateError.bad_certificate:
          return c2.Alert.Description.bad_certificate;
        case n3.pki.certificateError.unsupported_certificate:
          return c2.Alert.Description.unsupported_certificate;
        case n3.pki.certificateError.certificate_revoked:
          return c2.Alert.Description.certificate_revoked;
        case n3.pki.certificateError.certificate_expired:
          return c2.Alert.Description.certificate_expired;
        case n3.pki.certificateError.certificate_unknown:
          return c2.Alert.Description.certificate_unknown;
        case n3.pki.certificateError.unknown_ca:
          return c2.Alert.Description.unknown_ca;
        default:
          return c2.Alert.Description.bad_certificate;
      }
    };
    for (var q2 in c2.verifyCertificateChain = function(e4, t4) {
      try {
        var r4 = {};
        for (var i3 in e4.verifyOptions)
          r4[i3] = e4.verifyOptions[i3];
        r4.verify = function(t5, r5, i4) {
          F2(t5);
          var a8 = e4.verify(e4, t5, r5, i4);
          if (a8 !== true) {
            if (typeof a8 == "object" && !n3.util.isArray(a8)) {
              var s3 = new Error("The application rejected the certificate.");
              throw s3.send = true, s3.alert = { level: c2.Alert.Level.fatal, description: c2.Alert.Description.bad_certificate }, a8.message && (s3.message = a8.message), a8.alert && (s3.alert.description = a8.alert), s3;
            }
            a8 !== t5 && (a8 = function(e5) {
              switch (e5) {
                case true:
                  return true;
                case c2.Alert.Description.bad_certificate:
                  return n3.pki.certificateError.bad_certificate;
                case c2.Alert.Description.unsupported_certificate:
                  return n3.pki.certificateError.unsupported_certificate;
                case c2.Alert.Description.certificate_revoked:
                  return n3.pki.certificateError.certificate_revoked;
                case c2.Alert.Description.certificate_expired:
                  return n3.pki.certificateError.certificate_expired;
                case c2.Alert.Description.certificate_unknown:
                  return n3.pki.certificateError.certificate_unknown;
                case c2.Alert.Description.unknown_ca:
                  return n3.pki.certificateError.unknown_ca;
                default:
                  return n3.pki.certificateError.bad_certificate;
              }
            }(a8));
          }
          return a8;
        }, n3.pki.verifyCertificateChain(e4.caStore, t4, r4);
      } catch (t5) {
        var a7 = t5;
        (typeof a7 != "object" || n3.util.isArray(a7)) && (a7 = { send: true, alert: { level: c2.Alert.Level.fatal, description: F2(t5) } }), "send" in a7 || (a7.send = true), "alert" in a7 || (a7.alert = { level: c2.Alert.Level.fatal, description: F2(a7.error) }), e4.error(e4, a7);
      }
      return !e4.fail;
    }, c2.createSessionCache = function(e4, t4) {
      var r4 = null;
      if (e4 && e4.getSession && e4.setSession && e4.order)
        r4 = e4;
      else {
        for (var i3 in (r4 = {}).cache = e4 || {}, r4.capacity = Math.max(t4 || 100, 1), r4.order = [], e4)
          r4.order.length <= t4 ? r4.order.push(i3) : delete e4[i3];
        r4.getSession = function(e5) {
          var t5 = null, i4 = null;
          if (e5 ? i4 = n3.util.bytesToHex(e5) : r4.order.length > 0 && (i4 = r4.order[0]), i4 !== null && i4 in r4.cache) {
            for (var a7 in t5 = r4.cache[i4], delete r4.cache[i4], r4.order)
              if (r4.order[a7] === i4) {
                r4.order.splice(a7, 1);
                break;
              }
          }
          return t5;
        }, r4.setSession = function(e5, t5) {
          if (r4.order.length === r4.capacity) {
            var i4 = r4.order.shift();
            delete r4.cache[i4];
          }
          i4 = n3.util.bytesToHex(e5), r4.order.push(i4), r4.cache[i4] = t5;
        };
      }
      return r4;
    }, c2.createConnection = function(e4) {
      var t4;
      t4 = e4.caStore ? n3.util.isArray(e4.caStore) ? n3.pki.createCaStore(e4.caStore) : e4.caStore : n3.pki.createCaStore();
      var r4 = e4.cipherSuites || null;
      if (r4 === null)
        for (var i3 in r4 = [], c2.CipherSuites)
          r4.push(c2.CipherSuites[i3]);
      var a7 = e4.server ? c2.ConnectionEnd.server : c2.ConnectionEnd.client, s3 = e4.sessionCache ? c2.createSessionCache(e4.sessionCache) : null, o2 = { version: { major: c2.Version.major, minor: c2.Version.minor }, entity: a7, sessionId: e4.sessionId, caStore: t4, sessionCache: s3, cipherSuites: r4, connected: e4.connected, virtualHost: e4.virtualHost || null, verifyClient: e4.verifyClient || false, verify: e4.verify || function(e5, t5, r5, n4) {
        return t5;
      }, verifyOptions: e4.verifyOptions || {}, getCertificate: e4.getCertificate || null, getPrivateKey: e4.getPrivateKey || null, getSignature: e4.getSignature || null, input: n3.util.createBuffer(), tlsData: n3.util.createBuffer(), data: n3.util.createBuffer(), tlsDataReady: e4.tlsDataReady, dataReady: e4.dataReady, heartbeatReceived: e4.heartbeatReceived, closed: e4.closed, error: function(t5, r5) {
        r5.origin = r5.origin || (t5.entity === c2.ConnectionEnd.client ? "client" : "server"), r5.send && (c2.queue(t5, c2.createAlert(t5, r5.alert)), c2.flush(t5));
        var n4 = r5.fatal !== false;
        n4 && (t5.fail = true), e4.error(t5, r5), n4 && t5.close(false);
      }, deflate: e4.deflate || null, inflate: e4.inflate || null, reset: function(e5) {
        o2.version = { major: c2.Version.major, minor: c2.Version.minor }, o2.record = null, o2.session = null, o2.peerCertificate = null, o2.state = { pending: null, current: null }, o2.expect = (o2.entity, c2.ConnectionEnd.client, 0), o2.fragmented = null, o2.records = [], o2.open = false, o2.handshakes = 0, o2.handshaking = false, o2.isConnected = false, o2.fail = !(e5 || e5 === void 0), o2.input.clear(), o2.tlsData.clear(), o2.data.clear(), o2.state.current = c2.createConnectionState(o2);
      } };
      return o2.reset(), o2.handshake = function(e5) {
        if (o2.entity !== c2.ConnectionEnd.client)
          o2.error(o2, { message: "Cannot initiate handshake as a server.", fatal: false });
        else if (o2.handshaking)
          o2.error(o2, { message: "Handshake already in progress.", fatal: false });
        else {
          o2.fail && !o2.open && o2.handshakes === 0 && (o2.fail = false), o2.handshaking = true;
          var t5 = null;
          (e5 = e5 || "").length > 0 && (o2.sessionCache && (t5 = o2.sessionCache.getSession(e5)), t5 === null && (e5 = "")), e5.length === 0 && o2.sessionCache && (t5 = o2.sessionCache.getSession()) !== null && (e5 = t5.id), o2.session = { id: e5, version: null, cipherSuite: null, compressionMethod: null, serverCertificate: null, certificateRequest: null, clientCertificate: null, sp: {}, md5: n3.md.md5.create(), sha1: n3.md.sha1.create() }, t5 && (o2.version = t5.version, o2.session.sp = t5.sp), o2.session.sp.client_random = c2.createRandom().getBytes(), o2.open = true, c2.queue(o2, c2.createRecord(o2, { type: c2.ContentType.handshake, data: c2.createClientHello(o2) })), c2.flush(o2);
        }
      }, o2.process = function(e5) {
        var t5 = 0;
        return e5 && o2.input.putBytes(e5), o2.fail || (o2.record !== null && o2.record.ready && o2.record.fragment.isEmpty() && (o2.record = null), o2.record === null && (t5 = function(e6) {
          var t6 = 0, r5 = e6.input, i4 = r5.length();
          if (i4 < 5)
            t6 = 5 - i4;
          else {
            e6.record = { type: r5.getByte(), version: { major: r5.getByte(), minor: r5.getByte() }, length: r5.getInt16(), fragment: n3.util.createBuffer(), ready: false };
            var a8 = e6.record.version.major === e6.version.major;
            a8 && e6.session && e6.session.version && (a8 = e6.record.version.minor === e6.version.minor), a8 || e6.error(e6, { message: "Incompatible TLS version.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.protocol_version } });
          }
          return t6;
        }(o2)), o2.fail || o2.record === null || o2.record.ready || (t5 = function(e6) {
          var t6 = 0, r5 = e6.input, n4 = r5.length();
          return n4 < e6.record.length ? t6 = e6.record.length - n4 : (e6.record.fragment.putBytes(r5.getBytes(e6.record.length)), r5.compact(), e6.state.current.read.update(e6, e6.record) && (e6.fragmented !== null && (e6.fragmented.type === e6.record.type ? (e6.fragmented.fragment.putBuffer(e6.record.fragment), e6.record = e6.fragmented) : e6.error(e6, { message: "Invalid fragmented record.", send: true, alert: { level: c2.Alert.Level.fatal, description: c2.Alert.Description.unexpected_message } })), e6.record.ready = true)), t6;
        }(o2)), !o2.fail && o2.record !== null && o2.record.ready && function(e6, t6) {
          var r5 = t6.type - c2.ContentType.change_cipher_spec, n4 = N2[e6.entity][e6.expect];
          r5 in n4 ? n4[r5](e6, t6) : c2.handleUnexpected(e6, t6);
        }(o2, o2.record)), t5;
      }, o2.prepare = function(e5) {
        return c2.queue(o2, c2.createRecord(o2, { type: c2.ContentType.application_data, data: n3.util.createBuffer(e5) })), c2.flush(o2);
      }, o2.prepareHeartbeatRequest = function(e5, t5) {
        return e5 instanceof n3.util.ByteBuffer && (e5 = e5.bytes()), t5 === void 0 && (t5 = e5.length), o2.expectedHeartbeatPayload = e5, c2.queue(o2, c2.createRecord(o2, { type: c2.ContentType.heartbeat, data: c2.createHeartbeat(c2.HeartbeatMessageType.heartbeat_request, e5, t5) })), c2.flush(o2);
      }, o2.close = function(e5) {
        if (!o2.fail && o2.sessionCache && o2.session) {
          var t5 = { id: o2.session.id, version: o2.session.version, sp: o2.session.sp };
          t5.sp.keys = null, o2.sessionCache.setSession(t5.id, t5);
        }
        o2.open && (o2.open = false, o2.input.clear(), (o2.isConnected || o2.handshaking) && (o2.isConnected = o2.handshaking = false, c2.queue(o2, c2.createAlert(o2, { level: c2.Alert.Level.warning, description: c2.Alert.Description.close_notify })), c2.flush(o2)), o2.closed(o2)), o2.reset(e5);
      }, o2;
    }, e3.exports = n3.tls = n3.tls || {}, c2)
      typeof c2[q2] != "function" && (n3.tls[q2] = c2[q2]);
    n3.tls.prf_tls1 = i2, n3.tls.hmac_sha1 = function(e4, t4, r4) {
      var i3 = n3.hmac.create();
      i3.start("SHA1", e4);
      var a7 = n3.util.createBuffer();
      return a7.putInt32(t4[0]), a7.putInt32(t4[1]), a7.putByte(r4.type), a7.putByte(r4.version.major), a7.putByte(r4.version.minor), a7.putInt16(r4.length), a7.putBytes(r4.fragment.bytes()), i3.update(a7.getBytes()), i3.digest().getBytes();
    }, n3.tls.createSessionCache = c2.createSessionCache, n3.tls.createConnection = c2.createConnection;
  }, 3103: (e3, t3, r3) => {
    var n3 = r3(7573).Buffer, i2 = r3(7768), a6 = r3(7858), s2 = e3.exports = i2.util = i2.util || {};
    function o(e4) {
      if (e4 !== 8 && e4 !== 16 && e4 !== 24 && e4 !== 32)
        throw new Error("Only 8, 16, 24, or 32 bits supported: " + e4);
    }
    function u2(e4) {
      if (this.data = "", this.read = 0, typeof e4 == "string")
        this.data = e4;
      else if (s2.isArrayBuffer(e4) || s2.isArrayBufferView(e4))
        if (n3 !== void 0 && e4 instanceof n3)
          this.data = e4.toString("binary");
        else {
          var t4 = new Uint8Array(e4);
          try {
            this.data = String.fromCharCode.apply(null, t4);
          } catch (e5) {
            for (var r4 = 0; r4 < t4.length; ++r4)
              this.putByte(t4[r4]);
          }
        }
      else
        (e4 instanceof u2 || typeof e4 == "object" && typeof e4.data == "string" && typeof e4.read == "number") && (this.data = e4.data, this.read = e4.read);
      this._constructedStringLength = 0;
    }
    !function() {
      if (typeof process != "undefined" && process.nextTick && !process.browser)
        return s2.nextTick = process.nextTick, void (typeof setImmediate == "function" ? s2.setImmediate = setImmediate : s2.setImmediate = s2.nextTick);
      if (typeof setImmediate == "function")
        return s2.setImmediate = function() {
          return setImmediate.apply(void 0, arguments);
        }, void (s2.nextTick = function(e5) {
          return setImmediate(e5);
        });
      if (s2.setImmediate = function(e5) {
        setTimeout(e5, 0);
      }, typeof window != "undefined" && typeof window.postMessage == "function") {
        var e4 = "forge.setImmediate", t4 = [];
        s2.setImmediate = function(r5) {
          t4.push(r5), t4.length === 1 && window.postMessage(e4, "*");
        }, window.addEventListener("message", function(r5) {
          if (r5.source === window && r5.data === e4) {
            r5.stopPropagation();
            var n5 = t4.slice();
            t4.length = 0, n5.forEach(function(e5) {
              e5();
            });
          }
        }, true);
      }
      if (typeof MutationObserver != "undefined") {
        var r4 = Date.now(), n4 = true, i3 = document.createElement("div");
        t4 = [], new MutationObserver(function() {
          var e5 = t4.slice();
          t4.length = 0, e5.forEach(function(e6) {
            e6();
          });
        }).observe(i3, { attributes: true });
        var a7 = s2.setImmediate;
        s2.setImmediate = function(e5) {
          Date.now() - r4 > 15 ? (r4 = Date.now(), a7(e5)) : (t4.push(e5), t4.length === 1 && i3.setAttribute("a", n4 = !n4));
        };
      }
      s2.nextTick = s2.setImmediate;
    }(), s2.isNodejs = typeof process != "undefined" && process.versions && process.versions.node, s2.globalScope = s2.isNodejs ? r3.g : typeof self == "undefined" ? window : self, s2.isArray = Array.isArray || function(e4) {
      return Object.prototype.toString.call(e4) === "[object Array]";
    }, s2.isArrayBuffer = function(e4) {
      return typeof ArrayBuffer != "undefined" && e4 instanceof ArrayBuffer;
    }, s2.isArrayBufferView = function(e4) {
      return e4 && s2.isArrayBuffer(e4.buffer) && e4.byteLength !== void 0;
    }, s2.ByteBuffer = u2, s2.ByteStringBuffer = u2, s2.ByteStringBuffer.prototype._optimizeConstructedString = function(e4) {
      this._constructedStringLength += e4, this._constructedStringLength > 4096 && (this.data.substr(0, 1), this._constructedStringLength = 0);
    }, s2.ByteStringBuffer.prototype.length = function() {
      return this.data.length - this.read;
    }, s2.ByteStringBuffer.prototype.isEmpty = function() {
      return this.length() <= 0;
    }, s2.ByteStringBuffer.prototype.putByte = function(e4) {
      return this.putBytes(String.fromCharCode(e4));
    }, s2.ByteStringBuffer.prototype.fillWithByte = function(e4, t4) {
      e4 = String.fromCharCode(e4);
      for (var r4 = this.data; t4 > 0; )
        1 & t4 && (r4 += e4), (t4 >>>= 1) > 0 && (e4 += e4);
      return this.data = r4, this._optimizeConstructedString(t4), this;
    }, s2.ByteStringBuffer.prototype.putBytes = function(e4) {
      return this.data += e4, this._optimizeConstructedString(e4.length), this;
    }, s2.ByteStringBuffer.prototype.putString = function(e4) {
      return this.putBytes(s2.encodeUtf8(e4));
    }, s2.ByteStringBuffer.prototype.putInt16 = function(e4) {
      return this.putBytes(String.fromCharCode(e4 >> 8 & 255) + String.fromCharCode(255 & e4));
    }, s2.ByteStringBuffer.prototype.putInt24 = function(e4) {
      return this.putBytes(String.fromCharCode(e4 >> 16 & 255) + String.fromCharCode(e4 >> 8 & 255) + String.fromCharCode(255 & e4));
    }, s2.ByteStringBuffer.prototype.putInt32 = function(e4) {
      return this.putBytes(String.fromCharCode(e4 >> 24 & 255) + String.fromCharCode(e4 >> 16 & 255) + String.fromCharCode(e4 >> 8 & 255) + String.fromCharCode(255 & e4));
    }, s2.ByteStringBuffer.prototype.putInt16Le = function(e4) {
      return this.putBytes(String.fromCharCode(255 & e4) + String.fromCharCode(e4 >> 8 & 255));
    }, s2.ByteStringBuffer.prototype.putInt24Le = function(e4) {
      return this.putBytes(String.fromCharCode(255 & e4) + String.fromCharCode(e4 >> 8 & 255) + String.fromCharCode(e4 >> 16 & 255));
    }, s2.ByteStringBuffer.prototype.putInt32Le = function(e4) {
      return this.putBytes(String.fromCharCode(255 & e4) + String.fromCharCode(e4 >> 8 & 255) + String.fromCharCode(e4 >> 16 & 255) + String.fromCharCode(e4 >> 24 & 255));
    }, s2.ByteStringBuffer.prototype.putInt = function(e4, t4) {
      o(t4);
      var r4 = "";
      do {
        t4 -= 8, r4 += String.fromCharCode(e4 >> t4 & 255);
      } while (t4 > 0);
      return this.putBytes(r4);
    }, s2.ByteStringBuffer.prototype.putSignedInt = function(e4, t4) {
      return e4 < 0 && (e4 += 2 << t4 - 1), this.putInt(e4, t4);
    }, s2.ByteStringBuffer.prototype.putBuffer = function(e4) {
      return this.putBytes(e4.getBytes());
    }, s2.ByteStringBuffer.prototype.getByte = function() {
      return this.data.charCodeAt(this.read++);
    }, s2.ByteStringBuffer.prototype.getInt16 = function() {
      var e4 = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
      return this.read += 2, e4;
    }, s2.ByteStringBuffer.prototype.getInt24 = function() {
      var e4 = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
      return this.read += 3, e4;
    }, s2.ByteStringBuffer.prototype.getInt32 = function() {
      var e4 = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
      return this.read += 4, e4;
    }, s2.ByteStringBuffer.prototype.getInt16Le = function() {
      var e4 = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
      return this.read += 2, e4;
    }, s2.ByteStringBuffer.prototype.getInt24Le = function() {
      var e4 = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
      return this.read += 3, e4;
    }, s2.ByteStringBuffer.prototype.getInt32Le = function() {
      var e4 = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
      return this.read += 4, e4;
    }, s2.ByteStringBuffer.prototype.getInt = function(e4) {
      o(e4);
      var t4 = 0;
      do {
        t4 = (t4 << 8) + this.data.charCodeAt(this.read++), e4 -= 8;
      } while (e4 > 0);
      return t4;
    }, s2.ByteStringBuffer.prototype.getSignedInt = function(e4) {
      var t4 = this.getInt(e4), r4 = 2 << e4 - 2;
      return t4 >= r4 && (t4 -= r4 << 1), t4;
    }, s2.ByteStringBuffer.prototype.getBytes = function(e4) {
      var t4;
      return e4 ? (e4 = Math.min(this.length(), e4), t4 = this.data.slice(this.read, this.read + e4), this.read += e4) : e4 === 0 ? t4 = "" : (t4 = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), t4;
    }, s2.ByteStringBuffer.prototype.bytes = function(e4) {
      return e4 === void 0 ? this.data.slice(this.read) : this.data.slice(this.read, this.read + e4);
    }, s2.ByteStringBuffer.prototype.at = function(e4) {
      return this.data.charCodeAt(this.read + e4);
    }, s2.ByteStringBuffer.prototype.setAt = function(e4, t4) {
      return this.data = this.data.substr(0, this.read + e4) + String.fromCharCode(t4) + this.data.substr(this.read + e4 + 1), this;
    }, s2.ByteStringBuffer.prototype.last = function() {
      return this.data.charCodeAt(this.data.length - 1);
    }, s2.ByteStringBuffer.prototype.copy = function() {
      var e4 = s2.createBuffer(this.data);
      return e4.read = this.read, e4;
    }, s2.ByteStringBuffer.prototype.compact = function() {
      return this.read > 0 && (this.data = this.data.slice(this.read), this.read = 0), this;
    }, s2.ByteStringBuffer.prototype.clear = function() {
      return this.data = "", this.read = 0, this;
    }, s2.ByteStringBuffer.prototype.truncate = function(e4) {
      var t4 = Math.max(0, this.length() - e4);
      return this.data = this.data.substr(this.read, t4), this.read = 0, this;
    }, s2.ByteStringBuffer.prototype.toHex = function() {
      for (var e4 = "", t4 = this.read; t4 < this.data.length; ++t4) {
        var r4 = this.data.charCodeAt(t4);
        r4 < 16 && (e4 += "0"), e4 += r4.toString(16);
      }
      return e4;
    }, s2.ByteStringBuffer.prototype.toString = function() {
      return s2.decodeUtf8(this.bytes());
    }, s2.DataBuffer = function(e4, t4) {
      t4 = t4 || {}, this.read = t4.readOffset || 0, this.growSize = t4.growSize || 1024;
      var r4 = s2.isArrayBuffer(e4), n4 = s2.isArrayBufferView(e4);
      if (r4 || n4)
        return this.data = r4 ? new DataView(e4) : new DataView(e4.buffer, e4.byteOffset, e4.byteLength), void (this.write = "writeOffset" in t4 ? t4.writeOffset : this.data.byteLength);
      this.data = new DataView(new ArrayBuffer(0)), this.write = 0, e4 != null && this.putBytes(e4), "writeOffset" in t4 && (this.write = t4.writeOffset);
    }, s2.DataBuffer.prototype.length = function() {
      return this.write - this.read;
    }, s2.DataBuffer.prototype.isEmpty = function() {
      return this.length() <= 0;
    }, s2.DataBuffer.prototype.accommodate = function(e4, t4) {
      if (this.length() >= e4)
        return this;
      t4 = Math.max(t4 || this.growSize, e4);
      var r4 = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength), n4 = new Uint8Array(this.length() + t4);
      return n4.set(r4), this.data = new DataView(n4.buffer), this;
    }, s2.DataBuffer.prototype.putByte = function(e4) {
      return this.accommodate(1), this.data.setUint8(this.write++, e4), this;
    }, s2.DataBuffer.prototype.fillWithByte = function(e4, t4) {
      this.accommodate(t4);
      for (var r4 = 0; r4 < t4; ++r4)
        this.data.setUint8(e4);
      return this;
    }, s2.DataBuffer.prototype.putBytes = function(e4, t4) {
      if (s2.isArrayBufferView(e4)) {
        var r4 = (n4 = new Uint8Array(e4.buffer, e4.byteOffset, e4.byteLength)).byteLength - n4.byteOffset;
        return this.accommodate(r4), new Uint8Array(this.data.buffer, this.write).set(n4), this.write += r4, this;
      }
      if (s2.isArrayBuffer(e4)) {
        var n4 = new Uint8Array(e4);
        return this.accommodate(n4.byteLength), new Uint8Array(this.data.buffer).set(n4, this.write), this.write += n4.byteLength, this;
      }
      if (e4 instanceof s2.DataBuffer || typeof e4 == "object" && typeof e4.read == "number" && typeof e4.write == "number" && s2.isArrayBufferView(e4.data))
        return n4 = new Uint8Array(e4.data.byteLength, e4.read, e4.length()), this.accommodate(n4.byteLength), new Uint8Array(e4.data.byteLength, this.write).set(n4), this.write += n4.byteLength, this;
      if (e4 instanceof s2.ByteStringBuffer && (e4 = e4.data, t4 = "binary"), t4 = t4 || "binary", typeof e4 == "string") {
        var i3;
        if (t4 === "hex")
          return this.accommodate(Math.ceil(e4.length / 2)), i3 = new Uint8Array(this.data.buffer, this.write), this.write += s2.binary.hex.decode(e4, i3, this.write), this;
        if (t4 === "base64")
          return this.accommodate(3 * Math.ceil(e4.length / 4)), i3 = new Uint8Array(this.data.buffer, this.write), this.write += s2.binary.base64.decode(e4, i3, this.write), this;
        if (t4 === "utf8" && (e4 = s2.encodeUtf8(e4), t4 = "binary"), t4 === "binary" || t4 === "raw")
          return this.accommodate(e4.length), i3 = new Uint8Array(this.data.buffer, this.write), this.write += s2.binary.raw.decode(i3), this;
        if (t4 === "utf16")
          return this.accommodate(2 * e4.length), i3 = new Uint16Array(this.data.buffer, this.write), this.write += s2.text.utf16.encode(i3), this;
        throw new Error("Invalid encoding: " + t4);
      }
      throw Error("Invalid parameter: " + e4);
    }, s2.DataBuffer.prototype.putBuffer = function(e4) {
      return this.putBytes(e4), e4.clear(), this;
    }, s2.DataBuffer.prototype.putString = function(e4) {
      return this.putBytes(e4, "utf16");
    }, s2.DataBuffer.prototype.putInt16 = function(e4) {
      return this.accommodate(2), this.data.setInt16(this.write, e4), this.write += 2, this;
    }, s2.DataBuffer.prototype.putInt24 = function(e4) {
      return this.accommodate(3), this.data.setInt16(this.write, e4 >> 8 & 65535), this.data.setInt8(this.write, e4 >> 16 & 255), this.write += 3, this;
    }, s2.DataBuffer.prototype.putInt32 = function(e4) {
      return this.accommodate(4), this.data.setInt32(this.write, e4), this.write += 4, this;
    }, s2.DataBuffer.prototype.putInt16Le = function(e4) {
      return this.accommodate(2), this.data.setInt16(this.write, e4, true), this.write += 2, this;
    }, s2.DataBuffer.prototype.putInt24Le = function(e4) {
      return this.accommodate(3), this.data.setInt8(this.write, e4 >> 16 & 255), this.data.setInt16(this.write, e4 >> 8 & 65535, true), this.write += 3, this;
    }, s2.DataBuffer.prototype.putInt32Le = function(e4) {
      return this.accommodate(4), this.data.setInt32(this.write, e4, true), this.write += 4, this;
    }, s2.DataBuffer.prototype.putInt = function(e4, t4) {
      o(t4), this.accommodate(t4 / 8);
      do {
        t4 -= 8, this.data.setInt8(this.write++, e4 >> t4 & 255);
      } while (t4 > 0);
      return this;
    }, s2.DataBuffer.prototype.putSignedInt = function(e4, t4) {
      return o(t4), this.accommodate(t4 / 8), e4 < 0 && (e4 += 2 << t4 - 1), this.putInt(e4, t4);
    }, s2.DataBuffer.prototype.getByte = function() {
      return this.data.getInt8(this.read++);
    }, s2.DataBuffer.prototype.getInt16 = function() {
      var e4 = this.data.getInt16(this.read);
      return this.read += 2, e4;
    }, s2.DataBuffer.prototype.getInt24 = function() {
      var e4 = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
      return this.read += 3, e4;
    }, s2.DataBuffer.prototype.getInt32 = function() {
      var e4 = this.data.getInt32(this.read);
      return this.read += 4, e4;
    }, s2.DataBuffer.prototype.getInt16Le = function() {
      var e4 = this.data.getInt16(this.read, true);
      return this.read += 2, e4;
    }, s2.DataBuffer.prototype.getInt24Le = function() {
      var e4 = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
      return this.read += 3, e4;
    }, s2.DataBuffer.prototype.getInt32Le = function() {
      var e4 = this.data.getInt32(this.read, true);
      return this.read += 4, e4;
    }, s2.DataBuffer.prototype.getInt = function(e4) {
      o(e4);
      var t4 = 0;
      do {
        t4 = (t4 << 8) + this.data.getInt8(this.read++), e4 -= 8;
      } while (e4 > 0);
      return t4;
    }, s2.DataBuffer.prototype.getSignedInt = function(e4) {
      var t4 = this.getInt(e4), r4 = 2 << e4 - 2;
      return t4 >= r4 && (t4 -= r4 << 1), t4;
    }, s2.DataBuffer.prototype.getBytes = function(e4) {
      var t4;
      return e4 ? (e4 = Math.min(this.length(), e4), t4 = this.data.slice(this.read, this.read + e4), this.read += e4) : e4 === 0 ? t4 = "" : (t4 = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), t4;
    }, s2.DataBuffer.prototype.bytes = function(e4) {
      return e4 === void 0 ? this.data.slice(this.read) : this.data.slice(this.read, this.read + e4);
    }, s2.DataBuffer.prototype.at = function(e4) {
      return this.data.getUint8(this.read + e4);
    }, s2.DataBuffer.prototype.setAt = function(e4, t4) {
      return this.data.setUint8(e4, t4), this;
    }, s2.DataBuffer.prototype.last = function() {
      return this.data.getUint8(this.write - 1);
    }, s2.DataBuffer.prototype.copy = function() {
      return new s2.DataBuffer(this);
    }, s2.DataBuffer.prototype.compact = function() {
      if (this.read > 0) {
        var e4 = new Uint8Array(this.data.buffer, this.read), t4 = new Uint8Array(e4.byteLength);
        t4.set(e4), this.data = new DataView(t4), this.write -= this.read, this.read = 0;
      }
      return this;
    }, s2.DataBuffer.prototype.clear = function() {
      return this.data = new DataView(new ArrayBuffer(0)), this.read = this.write = 0, this;
    }, s2.DataBuffer.prototype.truncate = function(e4) {
      return this.write = Math.max(0, this.length() - e4), this.read = Math.min(this.read, this.write), this;
    }, s2.DataBuffer.prototype.toHex = function() {
      for (var e4 = "", t4 = this.read; t4 < this.data.byteLength; ++t4) {
        var r4 = this.data.getUint8(t4);
        r4 < 16 && (e4 += "0"), e4 += r4.toString(16);
      }
      return e4;
    }, s2.DataBuffer.prototype.toString = function(e4) {
      var t4 = new Uint8Array(this.data, this.read, this.length());
      if ((e4 = e4 || "utf8") === "binary" || e4 === "raw")
        return s2.binary.raw.encode(t4);
      if (e4 === "hex")
        return s2.binary.hex.encode(t4);
      if (e4 === "base64")
        return s2.binary.base64.encode(t4);
      if (e4 === "utf8")
        return s2.text.utf8.decode(t4);
      if (e4 === "utf16")
        return s2.text.utf16.decode(t4);
      throw new Error("Invalid encoding: " + e4);
    }, s2.createBuffer = function(e4, t4) {
      return t4 = t4 || "raw", e4 !== void 0 && t4 === "utf8" && (e4 = s2.encodeUtf8(e4)), new s2.ByteBuffer(e4);
    }, s2.fillString = function(e4, t4) {
      for (var r4 = ""; t4 > 0; )
        1 & t4 && (r4 += e4), (t4 >>>= 1) > 0 && (e4 += e4);
      return r4;
    }, s2.xorBytes = function(e4, t4, r4) {
      for (var n4 = "", i3 = "", a7 = "", s3 = 0, o2 = 0; r4 > 0; --r4, ++s3)
        i3 = e4.charCodeAt(s3) ^ t4.charCodeAt(s3), o2 >= 10 && (n4 += a7, a7 = "", o2 = 0), a7 += String.fromCharCode(i3), ++o2;
      return n4 + a7;
    }, s2.hexToBytes = function(e4) {
      var t4 = "", r4 = 0;
      for (true & e4.length && (r4 = 1, t4 += String.fromCharCode(parseInt(e4[0], 16))); r4 < e4.length; r4 += 2)
        t4 += String.fromCharCode(parseInt(e4.substr(r4, 2), 16));
      return t4;
    }, s2.bytesToHex = function(e4) {
      return s2.createBuffer(e4).toHex();
    }, s2.int32ToBytes = function(e4) {
      return String.fromCharCode(e4 >> 24 & 255) + String.fromCharCode(e4 >> 16 & 255) + String.fromCharCode(e4 >> 8 & 255) + String.fromCharCode(255 & e4);
    };
    var c2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", l2 = [62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 64, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], h2 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    s2.encode64 = function(e4, t4) {
      for (var r4, n4, i3, a7 = "", s3 = "", o2 = 0; o2 < e4.length; )
        r4 = e4.charCodeAt(o2++), n4 = e4.charCodeAt(o2++), i3 = e4.charCodeAt(o2++), a7 += c2.charAt(r4 >> 2), a7 += c2.charAt((3 & r4) << 4 | n4 >> 4), isNaN(n4) ? a7 += "==" : (a7 += c2.charAt((15 & n4) << 2 | i3 >> 6), a7 += isNaN(i3) ? "=" : c2.charAt(63 & i3)), t4 && a7.length > t4 && (s3 += a7.substr(0, t4) + "\r\n", a7 = a7.substr(t4));
      return s3 + a7;
    }, s2.decode64 = function(e4) {
      e4 = e4.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      for (var t4, r4, n4, i3, a7 = "", s3 = 0; s3 < e4.length; )
        t4 = l2[e4.charCodeAt(s3++) - 43], r4 = l2[e4.charCodeAt(s3++) - 43], n4 = l2[e4.charCodeAt(s3++) - 43], i3 = l2[e4.charCodeAt(s3++) - 43], a7 += String.fromCharCode(t4 << 2 | r4 >> 4), n4 !== 64 && (a7 += String.fromCharCode((15 & r4) << 4 | n4 >> 2), i3 !== 64 && (a7 += String.fromCharCode((3 & n4) << 6 | i3)));
      return a7;
    }, s2.encodeUtf8 = function(e4) {
      return unescape(encodeURIComponent(e4));
    }, s2.decodeUtf8 = function(e4) {
      return decodeURIComponent(escape(e4));
    }, s2.binary = { raw: {}, hex: {}, base64: {}, base58: {}, baseN: { encode: a6.encode, decode: a6.decode } }, s2.binary.raw.encode = function(e4) {
      return String.fromCharCode.apply(null, e4);
    }, s2.binary.raw.decode = function(e4, t4, r4) {
      var n4 = t4;
      n4 || (n4 = new Uint8Array(e4.length));
      for (var i3 = r4 = r4 || 0, a7 = 0; a7 < e4.length; ++a7)
        n4[i3++] = e4.charCodeAt(a7);
      return t4 ? i3 - r4 : n4;
    }, s2.binary.hex.encode = s2.bytesToHex, s2.binary.hex.decode = function(e4, t4, r4) {
      var n4 = t4;
      n4 || (n4 = new Uint8Array(Math.ceil(e4.length / 2)));
      var i3 = 0, a7 = r4 = r4 || 0;
      for (1 & e4.length && (i3 = 1, n4[a7++] = parseInt(e4[0], 16)); i3 < e4.length; i3 += 2)
        n4[a7++] = parseInt(e4.substr(i3, 2), 16);
      return t4 ? a7 - r4 : n4;
    }, s2.binary.base64.encode = function(e4, t4) {
      for (var r4, n4, i3, a7 = "", s3 = "", o2 = 0; o2 < e4.byteLength; )
        r4 = e4[o2++], n4 = e4[o2++], i3 = e4[o2++], a7 += c2.charAt(r4 >> 2), a7 += c2.charAt((3 & r4) << 4 | n4 >> 4), isNaN(n4) ? a7 += "==" : (a7 += c2.charAt((15 & n4) << 2 | i3 >> 6), a7 += isNaN(i3) ? "=" : c2.charAt(63 & i3)), t4 && a7.length > t4 && (s3 += a7.substr(0, t4) + "\r\n", a7 = a7.substr(t4));
      return s3 + a7;
    }, s2.binary.base64.decode = function(e4, t4, r4) {
      var n4, i3, a7, s3, o2 = t4;
      o2 || (o2 = new Uint8Array(3 * Math.ceil(e4.length / 4))), e4 = e4.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      for (var u3 = 0, c3 = r4 = r4 || 0; u3 < e4.length; )
        n4 = l2[e4.charCodeAt(u3++) - 43], i3 = l2[e4.charCodeAt(u3++) - 43], a7 = l2[e4.charCodeAt(u3++) - 43], s3 = l2[e4.charCodeAt(u3++) - 43], o2[c3++] = n4 << 2 | i3 >> 4, a7 !== 64 && (o2[c3++] = (15 & i3) << 4 | a7 >> 2, s3 !== 64 && (o2[c3++] = (3 & a7) << 6 | s3));
      return t4 ? c3 - r4 : o2.subarray(0, c3);
    }, s2.binary.base58.encode = function(e4, t4) {
      return s2.binary.baseN.encode(e4, h2, t4);
    }, s2.binary.base58.decode = function(e4, t4) {
      return s2.binary.baseN.decode(e4, h2, t4);
    }, s2.text = { utf8: {}, utf16: {} }, s2.text.utf8.encode = function(e4, t4, r4) {
      e4 = s2.encodeUtf8(e4);
      var n4 = t4;
      n4 || (n4 = new Uint8Array(e4.length));
      for (var i3 = r4 = r4 || 0, a7 = 0; a7 < e4.length; ++a7)
        n4[i3++] = e4.charCodeAt(a7);
      return t4 ? i3 - r4 : n4;
    }, s2.text.utf8.decode = function(e4) {
      return s2.decodeUtf8(String.fromCharCode.apply(null, e4));
    }, s2.text.utf16.encode = function(e4, t4, r4) {
      var n4 = t4;
      n4 || (n4 = new Uint8Array(2 * e4.length));
      for (var i3 = new Uint16Array(n4.buffer), a7 = r4 = r4 || 0, s3 = r4, o2 = 0; o2 < e4.length; ++o2)
        i3[s3++] = e4.charCodeAt(o2), a7 += 2;
      return t4 ? a7 - r4 : n4;
    }, s2.text.utf16.decode = function(e4) {
      return String.fromCharCode.apply(null, new Uint16Array(e4.buffer));
    }, s2.deflate = function(e4, t4, r4) {
      if (t4 = s2.decode64(e4.deflate(s2.encode64(t4)).rval), r4) {
        var n4 = 2;
        32 & t4.charCodeAt(1) && (n4 = 6), t4 = t4.substring(n4, t4.length - 4);
      }
      return t4;
    }, s2.inflate = function(e4, t4, r4) {
      var n4 = e4.inflate(s2.encode64(t4)).rval;
      return n4 === null ? null : s2.decode64(n4);
    };
    var f2 = function(e4, t4, r4) {
      if (!e4)
        throw new Error("WebStorage not available.");
      var n4;
      if (r4 === null ? n4 = e4.removeItem(t4) : (r4 = s2.encode64(JSON.stringify(r4)), n4 = e4.setItem(t4, r4)), n4 !== void 0 && n4.rval !== true) {
        var i3 = new Error(n4.error.message);
        throw i3.id = n4.error.id, i3.name = n4.error.name, i3;
      }
    }, p2 = function(e4, t4) {
      if (!e4)
        throw new Error("WebStorage not available.");
      var r4 = e4.getItem(t4);
      if (e4.init)
        if (r4.rval === null) {
          if (r4.error) {
            var n4 = new Error(r4.error.message);
            throw n4.id = r4.error.id, n4.name = r4.error.name, n4;
          }
          r4 = null;
        } else
          r4 = r4.rval;
      return r4 !== null && (r4 = JSON.parse(s2.decode64(r4))), r4;
    }, d2 = function(e4, t4, r4, n4) {
      var i3 = p2(e4, t4);
      i3 === null && (i3 = {}), i3[r4] = n4, f2(e4, t4, i3);
    }, g2 = function(e4, t4, r4) {
      var n4 = p2(e4, t4);
      return n4 !== null && (n4 = r4 in n4 ? n4[r4] : null), n4;
    }, y2 = function(e4, t4, r4) {
      var n4 = p2(e4, t4);
      if (n4 !== null && r4 in n4) {
        delete n4[r4];
        var i3 = true;
        for (var a7 in n4) {
          i3 = false;
          break;
        }
        i3 && (n4 = null), f2(e4, t4, n4);
      }
    }, v2 = function(e4, t4) {
      f2(e4, t4, null);
    }, m2 = function(e4, t4, r4) {
      var n4, i3 = null;
      r4 === void 0 && (r4 = ["web", "flash"]);
      var a7 = false, s3 = null;
      for (var o2 in r4) {
        n4 = r4[o2];
        try {
          if (n4 === "flash" || n4 === "both") {
            if (t4[0] === null)
              throw new Error("Flash local storage not available.");
            i3 = e4.apply(this, t4), a7 = n4 === "flash";
          }
          n4 !== "web" && n4 !== "both" || (t4[0] = localStorage, i3 = e4.apply(this, t4), a7 = true);
        } catch (e5) {
          s3 = e5;
        }
        if (a7)
          break;
      }
      if (!a7)
        throw s3;
      return i3;
    };
    s2.setItem = function(e4, t4, r4, n4, i3) {
      m2(d2, arguments, i3);
    }, s2.getItem = function(e4, t4, r4, n4) {
      return m2(g2, arguments, n4);
    }, s2.removeItem = function(e4, t4, r4, n4) {
      m2(y2, arguments, n4);
    }, s2.clearItems = function(e4, t4, r4) {
      m2(v2, arguments, r4);
    }, s2.isEmpty = function(e4) {
      for (var t4 in e4)
        if (e4.hasOwnProperty(t4))
          return false;
      return true;
    }, s2.format = function(e4) {
      for (var t4, r4, n4 = /%./g, i3 = 0, a7 = [], s3 = 0; t4 = n4.exec(e4); ) {
        (r4 = e4.substring(s3, n4.lastIndex - 2)).length > 0 && a7.push(r4), s3 = n4.lastIndex;
        var o2 = t4[0][1];
        switch (o2) {
          case "s":
          case "o":
            i3 < arguments.length ? a7.push(arguments[1 + i3++]) : a7.push("<?>");
            break;
          case "%":
            a7.push("%");
            break;
          default:
            a7.push("<%" + o2 + "?>");
        }
      }
      return a7.push(e4.substring(s3)), a7.join("");
    }, s2.formatNumber = function(e4, t4, r4, n4) {
      var i3 = e4, a7 = isNaN(t4 = Math.abs(t4)) ? 2 : t4, s3 = r4 === void 0 ? "," : r4, o2 = n4 === void 0 ? "." : n4, u3 = i3 < 0 ? "-" : "", c3 = parseInt(i3 = Math.abs(+i3 || 0).toFixed(a7), 10) + "", l3 = c3.length > 3 ? c3.length % 3 : 0;
      return u3 + (l3 ? c3.substr(0, l3) + o2 : "") + c3.substr(l3).replace(/(\d{3})(?=\d)/g, "$1" + o2) + (a7 ? s3 + Math.abs(i3 - c3).toFixed(a7).slice(2) : "");
    }, s2.formatSize = function(e4) {
      return e4 >= 1073741824 ? s2.formatNumber(e4 / 1073741824, 2, ".", "") + " GiB" : e4 >= 1048576 ? s2.formatNumber(e4 / 1048576, 2, ".", "") + " MiB" : e4 >= 1024 ? s2.formatNumber(e4 / 1024, 0) + " KiB" : s2.formatNumber(e4, 0) + " bytes";
    }, s2.bytesFromIP = function(e4) {
      return e4.indexOf(".") !== -1 ? s2.bytesFromIPv4(e4) : e4.indexOf(":") !== -1 ? s2.bytesFromIPv6(e4) : null;
    }, s2.bytesFromIPv4 = function(e4) {
      if ((e4 = e4.split(".")).length !== 4)
        return null;
      for (var t4 = s2.createBuffer(), r4 = 0; r4 < e4.length; ++r4) {
        var n4 = parseInt(e4[r4], 10);
        if (isNaN(n4))
          return null;
        t4.putByte(n4);
      }
      return t4.getBytes();
    }, s2.bytesFromIPv6 = function(e4) {
      for (var t4 = 0, r4 = 2 * (8 - (e4 = e4.split(":").filter(function(e5) {
        return e5.length === 0 && ++t4, true;
      })).length + t4), n4 = s2.createBuffer(), i3 = 0; i3 < 8; ++i3)
        if (e4[i3] && e4[i3].length !== 0) {
          var a7 = s2.hexToBytes(e4[i3]);
          a7.length < 2 && n4.putByte(0), n4.putBytes(a7);
        } else
          n4.fillWithByte(0, r4), r4 = 0;
      return n4.getBytes();
    }, s2.bytesToIP = function(e4) {
      return e4.length === 4 ? s2.bytesToIPv4(e4) : e4.length === 16 ? s2.bytesToIPv6(e4) : null;
    }, s2.bytesToIPv4 = function(e4) {
      if (e4.length !== 4)
        return null;
      for (var t4 = [], r4 = 0; r4 < e4.length; ++r4)
        t4.push(e4.charCodeAt(r4));
      return t4.join(".");
    }, s2.bytesToIPv6 = function(e4) {
      if (e4.length !== 16)
        return null;
      for (var t4 = [], r4 = [], n4 = 0, i3 = 0; i3 < e4.length; i3 += 2) {
        for (var a7 = s2.bytesToHex(e4[i3] + e4[i3 + 1]); a7[0] === "0" && a7 !== "0"; )
          a7 = a7.substr(1);
        if (a7 === "0") {
          var o2 = r4[r4.length - 1], u3 = t4.length;
          o2 && u3 === o2.end + 1 ? (o2.end = u3, o2.end - o2.start > r4[n4].end - r4[n4].start && (n4 = r4.length - 1)) : r4.push({ start: u3, end: u3 });
        }
        t4.push(a7);
      }
      if (r4.length > 0) {
        var c3 = r4[n4];
        c3.end - c3.start > 0 && (t4.splice(c3.start, c3.end - c3.start + 1, ""), c3.start === 0 && t4.unshift(""), c3.end === 7 && t4.push(""));
      }
      return t4.join(":");
    }, s2.estimateCores = function(e4, t4) {
      if (typeof e4 == "function" && (t4 = e4, e4 = {}), e4 = e4 || {}, "cores" in s2 && !e4.update)
        return t4(null, s2.cores);
      if (typeof navigator != "undefined" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0)
        return s2.cores = navigator.hardwareConcurrency, t4(null, s2.cores);
      if (typeof Worker == "undefined")
        return s2.cores = 1, t4(null, s2.cores);
      if (typeof Blob == "undefined")
        return s2.cores = 2, t4(null, s2.cores);
      var r4 = URL.createObjectURL(new Blob(["(", function() {
        self.addEventListener("message", function(e5) {
          for (var t5 = Date.now(), r5 = t5 + 4; Date.now() < r5; )
            ;
          self.postMessage({ st: t5, et: r5 });
        });
      }.toString(), ")()"], { type: "application/javascript" }));
      !function e5(n4, i3, a7) {
        if (i3 === 0) {
          var o2 = Math.floor(n4.reduce(function(e6, t5) {
            return e6 + t5;
          }, 0) / n4.length);
          return s2.cores = Math.max(1, o2), URL.revokeObjectURL(r4), t4(null, s2.cores);
        }
        !function(e6, t5) {
          for (var n5 = [], i4 = [], a8 = 0; a8 < e6; ++a8) {
            var s3 = new Worker(r4);
            s3.addEventListener("message", function(r5) {
              if (i4.push(r5.data), i4.length === e6) {
                for (var a9 = 0; a9 < e6; ++a9)
                  n5[a9].terminate();
                t5(0, i4);
              }
            }), n5.push(s3);
          }
          for (a8 = 0; a8 < e6; ++a8)
            n5[a8].postMessage(a8);
        }(a7, function(t5, r5) {
          n4.push(function(e6, t6) {
            for (var r6 = [], n5 = 0; n5 < e6; ++n5)
              for (var i4 = t6[n5], a8 = r6[n5] = [], s3 = 0; s3 < e6; ++s3)
                if (n5 !== s3) {
                  var o3 = t6[s3];
                  (i4.st > o3.st && i4.st < o3.et || o3.st > i4.st && o3.st < i4.et) && a8.push(s3);
                }
            return r6.reduce(function(e7, t7) {
              return Math.max(e7, t7.length);
            }, 0);
          }(a7, r5)), e5(n4, i3 - 1, a7);
        });
      }([], 5, 16);
    };
  }, 6446: (e3, t3, r3) => {
    var n3 = r3(7768);
    r3(1482), r3(2624), r3(2023), r3(6067), r3(826), r3(2884), r3(5477), r3(665), r3(144), r3(3103);
    var i2 = n3.asn1, a6 = e3.exports = n3.pki = n3.pki || {}, s2 = a6.oids, o = {};
    o.CN = s2.commonName, o.commonName = "CN", o.C = s2.countryName, o.countryName = "C", o.L = s2.localityName, o.localityName = "L", o.ST = s2.stateOrProvinceName, o.stateOrProvinceName = "ST", o.O = s2.organizationName, o.organizationName = "O", o.OU = s2.organizationalUnitName, o.organizationalUnitName = "OU", o.E = s2.emailAddress, o.emailAddress = "E";
    var u2 = n3.pki.rsa.publicKeyValidator, c2 = { name: "Certificate", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "Certificate.TBSCertificate", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "tbsCertificate", value: [{ name: "Certificate.TBSCertificate.version", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, constructed: true, optional: true, value: [{ name: "Certificate.TBSCertificate.version.integer", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "certVersion" }] }, { name: "Certificate.TBSCertificate.serialNumber", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "certSerialNumber" }, { name: "Certificate.TBSCertificate.signature", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "Certificate.TBSCertificate.signature.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "certinfoSignatureOid" }, { name: "Certificate.TBSCertificate.signature.parameters", tagClass: i2.Class.UNIVERSAL, optional: true, captureAsn1: "certinfoSignatureParams" }] }, { name: "Certificate.TBSCertificate.issuer", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "certIssuer" }, { name: "Certificate.TBSCertificate.validity", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "Certificate.TBSCertificate.validity.notBefore (utc)", tagClass: i2.Class.UNIVERSAL, type: i2.Type.UTCTIME, constructed: false, optional: true, capture: "certValidity1UTCTime" }, { name: "Certificate.TBSCertificate.validity.notBefore (generalized)", tagClass: i2.Class.UNIVERSAL, type: i2.Type.GENERALIZEDTIME, constructed: false, optional: true, capture: "certValidity2GeneralizedTime" }, { name: "Certificate.TBSCertificate.validity.notAfter (utc)", tagClass: i2.Class.UNIVERSAL, type: i2.Type.UTCTIME, constructed: false, optional: true, capture: "certValidity3UTCTime" }, { name: "Certificate.TBSCertificate.validity.notAfter (generalized)", tagClass: i2.Class.UNIVERSAL, type: i2.Type.GENERALIZEDTIME, constructed: false, optional: true, capture: "certValidity4GeneralizedTime" }] }, { name: "Certificate.TBSCertificate.subject", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "certSubject" }, u2, { name: "Certificate.TBSCertificate.issuerUniqueID", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 1, constructed: true, optional: true, value: [{ name: "Certificate.TBSCertificate.issuerUniqueID.id", tagClass: i2.Class.UNIVERSAL, type: i2.Type.BITSTRING, constructed: false, captureBitStringValue: "certIssuerUniqueId" }] }, { name: "Certificate.TBSCertificate.subjectUniqueID", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 2, constructed: true, optional: true, value: [{ name: "Certificate.TBSCertificate.subjectUniqueID.id", tagClass: i2.Class.UNIVERSAL, type: i2.Type.BITSTRING, constructed: false, captureBitStringValue: "certSubjectUniqueId" }] }, { name: "Certificate.TBSCertificate.extensions", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 3, constructed: true, captureAsn1: "certExtensions", optional: true }] }, { name: "Certificate.signatureAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "Certificate.signatureAlgorithm.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "certSignatureOid" }, { name: "Certificate.TBSCertificate.signature.parameters", tagClass: i2.Class.UNIVERSAL, optional: true, captureAsn1: "certSignatureParams" }] }, { name: "Certificate.signatureValue", tagClass: i2.Class.UNIVERSAL, type: i2.Type.BITSTRING, constructed: false, captureBitStringValue: "certSignature" }] }, l2 = { name: "rsapss", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "rsapss.hashAlgorithm", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, constructed: true, value: [{ name: "rsapss.hashAlgorithm.AlgorithmIdentifier", tagClass: i2.Class.UNIVERSAL, type: i2.Class.SEQUENCE, constructed: true, optional: true, value: [{ name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "hashOid" }] }] }, { name: "rsapss.maskGenAlgorithm", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 1, constructed: true, value: [{ name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier", tagClass: i2.Class.UNIVERSAL, type: i2.Class.SEQUENCE, constructed: true, optional: true, value: [{ name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "maskGenOid" }, { name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "maskGenHashOid" }] }] }] }, { name: "rsapss.saltLength", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 2, optional: true, value: [{ name: "rsapss.saltLength.saltLength", tagClass: i2.Class.UNIVERSAL, type: i2.Class.INTEGER, constructed: false, capture: "saltLength" }] }, { name: "rsapss.trailerField", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 3, optional: true, value: [{ name: "rsapss.trailer.trailer", tagClass: i2.Class.UNIVERSAL, type: i2.Class.INTEGER, constructed: false, capture: "trailer" }] }] }, h2 = { name: "CertificationRequestInfo", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "certificationRequestInfo", value: [{ name: "CertificationRequestInfo.integer", tagClass: i2.Class.UNIVERSAL, type: i2.Type.INTEGER, constructed: false, capture: "certificationRequestInfoVersion" }, { name: "CertificationRequestInfo.subject", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "certificationRequestInfoSubject" }, u2, { name: "CertificationRequestInfo.attributes", tagClass: i2.Class.CONTEXT_SPECIFIC, type: 0, constructed: true, optional: true, capture: "certificationRequestInfoAttributes", value: [{ name: "CertificationRequestInfo.attributes", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "CertificationRequestInfo.attributes.type", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false }, { name: "CertificationRequestInfo.attributes.value", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SET, constructed: true }] }] }] }, f2 = { name: "CertificationRequest", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, captureAsn1: "csr", value: [h2, { name: "CertificationRequest.signatureAlgorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.SEQUENCE, constructed: true, value: [{ name: "CertificationRequest.signatureAlgorithm.algorithm", tagClass: i2.Class.UNIVERSAL, type: i2.Type.OID, constructed: false, capture: "csrSignatureOid" }, { name: "CertificationRequest.signatureAlgorithm.parameters", tagClass: i2.Class.UNIVERSAL, optional: true, captureAsn1: "csrSignatureParams" }] }, { name: "CertificationRequest.signature", tagClass: i2.Class.UNIVERSAL, type: i2.Type.BITSTRING, constructed: false, captureBitStringValue: "csrSignature" }] };
    function p2(e4, t4) {
      typeof t4 == "string" && (t4 = { shortName: t4 });
      for (var r4, n4 = null, i3 = 0; n4 === null && i3 < e4.attributes.length; ++i3)
        r4 = e4.attributes[i3], (t4.type && t4.type === r4.type || t4.name && t4.name === r4.name || t4.shortName && t4.shortName === r4.shortName) && (n4 = r4);
      return n4;
    }
    a6.RDNAttributesAsArray = function(e4, t4) {
      for (var r4, n4, a7, u3 = [], c3 = 0; c3 < e4.value.length; ++c3) {
        r4 = e4.value[c3];
        for (var l3 = 0; l3 < r4.value.length; ++l3)
          a7 = {}, n4 = r4.value[l3], a7.type = i2.derToOid(n4.value[0].value), a7.value = n4.value[1].value, a7.valueTagClass = n4.value[1].type, a7.type in s2 && (a7.name = s2[a7.type], a7.name in o && (a7.shortName = o[a7.name])), t4 && (t4.update(a7.type), t4.update(a7.value)), u3.push(a7);
      }
      return u3;
    }, a6.CRIAttributesAsArray = function(e4) {
      for (var t4 = [], r4 = 0; r4 < e4.length; ++r4)
        for (var n4 = e4[r4], u3 = i2.derToOid(n4.value[0].value), c3 = n4.value[1].value, l3 = 0; l3 < c3.length; ++l3) {
          var h3 = {};
          if (h3.type = u3, h3.value = c3[l3].value, h3.valueTagClass = c3[l3].type, h3.type in s2 && (h3.name = s2[h3.type], h3.name in o && (h3.shortName = o[h3.name])), h3.type === s2.extensionRequest) {
            h3.extensions = [];
            for (var f3 = 0; f3 < h3.value.length; ++f3)
              h3.extensions.push(a6.certificateExtensionFromAsn1(h3.value[f3]));
          }
          t4.push(h3);
        }
      return t4;
    };
    var d2 = function(e4, t4, r4) {
      var n4 = {};
      if (e4 !== s2["RSASSA-PSS"])
        return n4;
      r4 && (n4 = { hash: { algorithmOid: s2.sha1 }, mgf: { algorithmOid: s2.mgf1, hash: { algorithmOid: s2.sha1 } }, saltLength: 20 });
      var a7 = {}, o2 = [];
      if (!i2.validate(t4, l2, a7, o2)) {
        var u3 = new Error("Cannot read RSASSA-PSS parameter block.");
        throw u3.errors = o2, u3;
      }
      return a7.hashOid !== void 0 && (n4.hash = n4.hash || {}, n4.hash.algorithmOid = i2.derToOid(a7.hashOid)), a7.maskGenOid !== void 0 && (n4.mgf = n4.mgf || {}, n4.mgf.algorithmOid = i2.derToOid(a7.maskGenOid), n4.mgf.hash = n4.mgf.hash || {}, n4.mgf.hash.algorithmOid = i2.derToOid(a7.maskGenHashOid)), a7.saltLength !== void 0 && (n4.saltLength = a7.saltLength.charCodeAt(0)), n4;
    }, g2 = function(e4) {
      switch (s2[e4.signatureOid]) {
        case "sha1WithRSAEncryption":
        case "sha1WithRSASignature":
          return n3.md.sha1.create();
        case "md5WithRSAEncryption":
          return n3.md.md5.create();
        case "sha256WithRSAEncryption":
        case "RSASSA-PSS":
          return n3.md.sha256.create();
        case "sha384WithRSAEncryption":
          return n3.md.sha384.create();
        case "sha512WithRSAEncryption":
          return n3.md.sha512.create();
        default:
          var t4 = new Error("Could not compute " + e4.type + " digest. Unknown signature OID.");
          throw t4.signatureOid = e4.signatureOid, t4;
      }
    }, y2 = function(e4) {
      var t4, r4 = e4.certificate;
      switch (r4.signatureOid) {
        case s2.sha1WithRSAEncryption:
        case s2.sha1WithRSASignature:
          break;
        case s2["RSASSA-PSS"]:
          var i3, a7, o2;
          if ((i3 = s2[r4.signatureParameters.mgf.hash.algorithmOid]) === void 0 || n3.md[i3] === void 0)
            throw (o2 = new Error("Unsupported MGF hash function.")).oid = r4.signatureParameters.mgf.hash.algorithmOid, o2.name = i3, o2;
          if ((a7 = s2[r4.signatureParameters.mgf.algorithmOid]) === void 0 || n3.mgf[a7] === void 0)
            throw (o2 = new Error("Unsupported MGF function.")).oid = r4.signatureParameters.mgf.algorithmOid, o2.name = a7, o2;
          if (a7 = n3.mgf[a7].create(n3.md[i3].create()), (i3 = s2[r4.signatureParameters.hash.algorithmOid]) === void 0 || n3.md[i3] === void 0)
            throw (o2 = new Error("Unsupported RSASSA-PSS hash function.")).oid = r4.signatureParameters.hash.algorithmOid, o2.name = i3, o2;
          t4 = n3.pss.create(n3.md[i3].create(), a7, r4.signatureParameters.saltLength);
      }
      return r4.publicKey.verify(e4.md.digest().getBytes(), e4.signature, t4);
    };
    function v2(e4) {
      for (var t4, r4, a7 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []), s3 = e4.attributes, o2 = 0; o2 < s3.length; ++o2) {
        var u3 = (t4 = s3[o2]).value, c3 = i2.Type.PRINTABLESTRING;
        "valueTagClass" in t4 && (c3 = t4.valueTagClass) === i2.Type.UTF8 && (u3 = n3.util.encodeUtf8(u3)), r4 = i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(t4.type).getBytes()), i2.create(i2.Class.UNIVERSAL, c3, false, u3)])]), a7.value.push(r4);
      }
      return a7;
    }
    function m2(e4) {
      for (var t4, r4 = 0; r4 < e4.length; ++r4) {
        if ((t4 = e4[r4]).name === void 0 && (t4.type && t4.type in a6.oids ? t4.name = a6.oids[t4.type] : t4.shortName && t4.shortName in o && (t4.name = a6.oids[o[t4.shortName]])), t4.type === void 0) {
          if (!t4.name || !(t4.name in a6.oids))
            throw (u3 = new Error("Attribute type not specified.")).attribute = t4, u3;
          t4.type = a6.oids[t4.name];
        }
        if (t4.shortName === void 0 && t4.name && t4.name in o && (t4.shortName = o[t4.name]), t4.type === s2.extensionRequest && (t4.valueConstructed = true, t4.valueTagClass = i2.Type.SEQUENCE, !t4.value && t4.extensions)) {
          t4.value = [];
          for (var n4 = 0; n4 < t4.extensions.length; ++n4)
            t4.value.push(a6.certificateExtensionToAsn1(E2(t4.extensions[n4])));
        }
        var u3;
        if (t4.value === void 0)
          throw (u3 = new Error("Attribute value not specified.")).attribute = t4, u3;
      }
    }
    function E2(e4, t4) {
      if (t4 = t4 || {}, e4.name === void 0 && e4.id && e4.id in a6.oids && (e4.name = a6.oids[e4.id]), e4.id === void 0) {
        if (!e4.name || !(e4.name in a6.oids))
          throw (S3 = new Error("Extension ID not specified.")).extension = e4, S3;
        e4.id = a6.oids[e4.name];
      }
      if (e4.value !== void 0)
        return e4;
      if (e4.name === "keyUsage") {
        var r4 = 0, o2 = 0, u3 = 0;
        e4.digitalSignature && (o2 |= 128, r4 = 7), e4.nonRepudiation && (o2 |= 64, r4 = 6), e4.keyEncipherment && (o2 |= 32, r4 = 5), e4.dataEncipherment && (o2 |= 16, r4 = 4), e4.keyAgreement && (o2 |= 8, r4 = 3), e4.keyCertSign && (o2 |= 4, r4 = 2), e4.cRLSign && (o2 |= 2, r4 = 1), e4.encipherOnly && (o2 |= 1, r4 = 0), e4.decipherOnly && (u3 |= 128, r4 = 7);
        var c3 = String.fromCharCode(r4);
        u3 !== 0 ? c3 += String.fromCharCode(o2) + String.fromCharCode(u3) : o2 !== 0 && (c3 += String.fromCharCode(o2)), e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.BITSTRING, false, c3);
      } else if (e4.name === "basicConstraints")
        e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []), e4.cA && e4.value.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.BOOLEAN, false, String.fromCharCode(255))), "pathLenConstraint" in e4 && e4.value.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(e4.pathLenConstraint).getBytes()));
      else if (e4.name === "extKeyUsage") {
        e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []);
        var l3 = e4.value.value;
        for (var h3 in e4)
          e4[h3] === true && (h3 in s2 ? l3.push(i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(s2[h3]).getBytes())) : h3.indexOf(".") !== -1 && l3.push(i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(h3).getBytes())));
      } else if (e4.name === "nsCertType")
        r4 = 0, o2 = 0, e4.client && (o2 |= 128, r4 = 7), e4.server && (o2 |= 64, r4 = 6), e4.email && (o2 |= 32, r4 = 5), e4.objsign && (o2 |= 16, r4 = 4), e4.reserved && (o2 |= 8, r4 = 3), e4.sslCA && (o2 |= 4, r4 = 2), e4.emailCA && (o2 |= 2, r4 = 1), e4.objCA && (o2 |= 1, r4 = 0), c3 = String.fromCharCode(r4), o2 !== 0 && (c3 += String.fromCharCode(o2)), e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.BITSTRING, false, c3);
      else if (e4.name === "subjectAltName" || e4.name === "issuerAltName") {
        e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []);
        for (var f3 = 0; f3 < e4.altNames.length; ++f3) {
          if (c3 = (m3 = e4.altNames[f3]).value, m3.type === 7 && m3.ip) {
            if ((c3 = n3.util.bytesFromIP(m3.ip)) === null)
              throw (S3 = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.')).extension = e4, S3;
          } else
            m3.type === 8 && (c3 = m3.oid ? i2.oidToDer(i2.oidToDer(m3.oid)) : i2.oidToDer(c3));
          e4.value.value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, m3.type, false, c3));
        }
      } else if (e4.name === "nsComment" && t4.cert) {
        if (!/^[\x00-\x7F]*$/.test(e4.comment) || e4.comment.length < 1 || e4.comment.length > 128)
          throw new Error('Invalid "nsComment" content.');
        e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.IA5STRING, false, e4.comment);
      } else if (e4.name === "subjectKeyIdentifier" && t4.cert) {
        var p3 = t4.cert.generateSubjectKeyIdentifier();
        e4.subjectKeyIdentifier = p3.toHex(), e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, p3.getBytes());
      } else if (e4.name === "authorityKeyIdentifier" && t4.cert) {
        if (e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []), l3 = e4.value.value, e4.keyIdentifier) {
          var d3 = e4.keyIdentifier === true ? t4.cert.generateSubjectKeyIdentifier().getBytes() : e4.keyIdentifier;
          l3.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 0, false, d3));
        }
        if (e4.authorityCertIssuer) {
          var g3 = [i2.create(i2.Class.CONTEXT_SPECIFIC, 4, true, [v2(e4.authorityCertIssuer === true ? t4.cert.issuer : e4.authorityCertIssuer)])];
          l3.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 1, true, g3));
        }
        if (e4.serialNumber) {
          var y3 = n3.util.hexToBytes(e4.serialNumber === true ? t4.cert.serialNumber : e4.serialNumber);
          l3.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 2, false, y3));
        }
      } else if (e4.name === "cRLDistributionPoints") {
        e4.value = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []), l3 = e4.value.value;
        var m3, E3 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []), C2 = i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, []);
        for (f3 = 0; f3 < e4.altNames.length; ++f3) {
          if (c3 = (m3 = e4.altNames[f3]).value, m3.type === 7 && m3.ip) {
            if ((c3 = n3.util.bytesFromIP(m3.ip)) === null)
              throw (S3 = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.')).extension = e4, S3;
          } else
            m3.type === 8 && (c3 = m3.oid ? i2.oidToDer(i2.oidToDer(m3.oid)) : i2.oidToDer(c3));
          C2.value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, m3.type, false, c3));
        }
        E3.value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [C2])), l3.push(E3);
      }
      var S3;
      if (e4.value === void 0)
        throw (S3 = new Error("Extension value not specified.")).extension = e4, S3;
      return e4;
    }
    function C(e4, t4) {
      if (e4 === s2["RSASSA-PSS"]) {
        var r4 = [];
        return t4.hash.algorithmOid !== void 0 && r4.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(t4.hash.algorithmOid).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")])])), t4.mgf.algorithmOid !== void 0 && r4.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 1, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(t4.mgf.algorithmOid).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(t4.mgf.hash.algorithmOid).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "")])])])), t4.saltLength !== void 0 && r4.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 2, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(t4.saltLength).getBytes())])), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, r4);
      }
      return i2.create(i2.Class.UNIVERSAL, i2.Type.NULL, false, "");
    }
    function S2(e4) {
      var t4 = i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, []);
      if (e4.attributes.length === 0)
        return t4;
      for (var r4 = e4.attributes, a7 = 0; a7 < r4.length; ++a7) {
        var s3 = r4[a7], o2 = s3.value, u3 = i2.Type.UTF8;
        "valueTagClass" in s3 && (u3 = s3.valueTagClass), u3 === i2.Type.UTF8 && (o2 = n3.util.encodeUtf8(o2));
        var c3 = false;
        "valueConstructed" in s3 && (c3 = s3.valueConstructed);
        var l3 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(s3.type).getBytes()), i2.create(i2.Class.UNIVERSAL, i2.Type.SET, true, [i2.create(i2.Class.UNIVERSAL, u3, c3, o2)])]);
        t4.value.push(l3);
      }
      return t4;
    }
    a6.certificateFromPem = function(e4, t4, r4) {
      var s3 = n3.pem.decode(e4)[0];
      if (s3.type !== "CERTIFICATE" && s3.type !== "X509 CERTIFICATE" && s3.type !== "TRUSTED CERTIFICATE") {
        var o2 = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        throw o2.headerType = s3.type, o2;
      }
      if (s3.procType && s3.procType.type === "ENCRYPTED")
        throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
      var u3 = i2.fromDer(s3.body, r4);
      return a6.certificateFromAsn1(u3, t4);
    }, a6.certificateToPem = function(e4, t4) {
      var r4 = { type: "CERTIFICATE", body: i2.toDer(a6.certificateToAsn1(e4)).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, a6.publicKeyFromPem = function(e4) {
      var t4 = n3.pem.decode(e4)[0];
      if (t4.type !== "PUBLIC KEY" && t4.type !== "RSA PUBLIC KEY") {
        var r4 = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        throw r4.headerType = t4.type, r4;
      }
      if (t4.procType && t4.procType.type === "ENCRYPTED")
        throw new Error("Could not convert public key from PEM; PEM is encrypted.");
      var s3 = i2.fromDer(t4.body);
      return a6.publicKeyFromAsn1(s3);
    }, a6.publicKeyToPem = function(e4, t4) {
      var r4 = { type: "PUBLIC KEY", body: i2.toDer(a6.publicKeyToAsn1(e4)).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, a6.publicKeyToRSAPublicKeyPem = function(e4, t4) {
      var r4 = { type: "RSA PUBLIC KEY", body: i2.toDer(a6.publicKeyToRSAPublicKey(e4)).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, a6.getPublicKeyFingerprint = function(e4, t4) {
      var r4, s3 = (t4 = t4 || {}).md || n3.md.sha1.create();
      switch (t4.type || "RSAPublicKey") {
        case "RSAPublicKey":
          r4 = i2.toDer(a6.publicKeyToRSAPublicKey(e4)).getBytes();
          break;
        case "SubjectPublicKeyInfo":
          r4 = i2.toDer(a6.publicKeyToAsn1(e4)).getBytes();
          break;
        default:
          throw new Error('Unknown fingerprint type "' + t4.type + '".');
      }
      s3.start(), s3.update(r4);
      var o2 = s3.digest();
      if (t4.encoding === "hex") {
        var u3 = o2.toHex();
        return t4.delimiter ? u3.match(/.{2}/g).join(t4.delimiter) : u3;
      }
      if (t4.encoding === "binary")
        return o2.getBytes();
      if (t4.encoding)
        throw new Error('Unknown encoding "' + t4.encoding + '".');
      return o2;
    }, a6.certificationRequestFromPem = function(e4, t4, r4) {
      var s3 = n3.pem.decode(e4)[0];
      if (s3.type !== "CERTIFICATE REQUEST") {
        var o2 = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        throw o2.headerType = s3.type, o2;
      }
      if (s3.procType && s3.procType.type === "ENCRYPTED")
        throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
      var u3 = i2.fromDer(s3.body, r4);
      return a6.certificationRequestFromAsn1(u3, t4);
    }, a6.certificationRequestToPem = function(e4, t4) {
      var r4 = { type: "CERTIFICATE REQUEST", body: i2.toDer(a6.certificationRequestToAsn1(e4)).getBytes() };
      return n3.pem.encode(r4, { maxline: t4 });
    }, a6.createCertificate = function() {
      var e4 = { version: 2, serialNumber: "00", signatureOid: null, signature: null, siginfo: {} };
      return e4.siginfo.algorithmOid = null, e4.validity = {}, e4.validity.notBefore = new Date(), e4.validity.notAfter = new Date(), e4.issuer = {}, e4.issuer.getField = function(t4) {
        return p2(e4.issuer, t4);
      }, e4.issuer.addField = function(t4) {
        m2([t4]), e4.issuer.attributes.push(t4);
      }, e4.issuer.attributes = [], e4.issuer.hash = null, e4.subject = {}, e4.subject.getField = function(t4) {
        return p2(e4.subject, t4);
      }, e4.subject.addField = function(t4) {
        m2([t4]), e4.subject.attributes.push(t4);
      }, e4.subject.attributes = [], e4.subject.hash = null, e4.extensions = [], e4.publicKey = null, e4.md = null, e4.setSubject = function(t4, r4) {
        m2(t4), e4.subject.attributes = t4, delete e4.subject.uniqueId, r4 && (e4.subject.uniqueId = r4), e4.subject.hash = null;
      }, e4.setIssuer = function(t4, r4) {
        m2(t4), e4.issuer.attributes = t4, delete e4.issuer.uniqueId, r4 && (e4.issuer.uniqueId = r4), e4.issuer.hash = null;
      }, e4.setExtensions = function(t4) {
        for (var r4 = 0; r4 < t4.length; ++r4)
          E2(t4[r4], { cert: e4 });
        e4.extensions = t4;
      }, e4.getExtension = function(t4) {
        typeof t4 == "string" && (t4 = { name: t4 });
        for (var r4, n4 = null, i3 = 0; n4 === null && i3 < e4.extensions.length; ++i3)
          r4 = e4.extensions[i3], (t4.id && r4.id === t4.id || t4.name && r4.name === t4.name) && (n4 = r4);
        return n4;
      }, e4.sign = function(t4, r4) {
        e4.md = r4 || n3.md.sha1.create();
        var o2 = s2[e4.md.algorithm + "WithRSAEncryption"];
        if (!o2) {
          var u3 = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
          throw u3.algorithm = e4.md.algorithm, u3;
        }
        e4.signatureOid = e4.siginfo.algorithmOid = o2, e4.tbsCertificate = a6.getTBSCertificate(e4);
        var c3 = i2.toDer(e4.tbsCertificate);
        e4.md.update(c3.getBytes()), e4.signature = t4.sign(e4.md);
      }, e4.verify = function(t4) {
        var r4 = false;
        if (!e4.issued(t4)) {
          var n4 = t4.issuer, s3 = e4.subject, o2 = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
          throw o2.expectedIssuer = s3.attributes, o2.actualIssuer = n4.attributes, o2;
        }
        var u3 = t4.md;
        if (u3 === null) {
          u3 = g2({ signatureOid: t4.signatureOid, type: "certificate" });
          var c3 = t4.tbsCertificate || a6.getTBSCertificate(t4), l3 = i2.toDer(c3);
          u3.update(l3.getBytes());
        }
        return u3 !== null && (r4 = y2({ certificate: e4, md: u3, signature: t4.signature })), r4;
      }, e4.isIssuer = function(t4) {
        var r4 = false, n4 = e4.issuer, i3 = t4.subject;
        if (n4.hash && i3.hash)
          r4 = n4.hash === i3.hash;
        else if (n4.attributes.length === i3.attributes.length) {
          var a7, s3;
          r4 = true;
          for (var o2 = 0; r4 && o2 < n4.attributes.length; ++o2)
            a7 = n4.attributes[o2], s3 = i3.attributes[o2], a7.type === s3.type && a7.value === s3.value || (r4 = false);
        }
        return r4;
      }, e4.issued = function(t4) {
        return t4.isIssuer(e4);
      }, e4.generateSubjectKeyIdentifier = function() {
        return a6.getPublicKeyFingerprint(e4.publicKey, { type: "RSAPublicKey" });
      }, e4.verifySubjectKeyIdentifier = function() {
        for (var t4 = s2.subjectKeyIdentifier, r4 = 0; r4 < e4.extensions.length; ++r4) {
          var i3 = e4.extensions[r4];
          if (i3.id === t4) {
            var a7 = e4.generateSubjectKeyIdentifier().getBytes();
            return n3.util.hexToBytes(i3.subjectKeyIdentifier) === a7;
          }
        }
        return false;
      }, e4;
    }, a6.certificateFromAsn1 = function(e4, t4) {
      var r4 = {}, s3 = [];
      if (!i2.validate(e4, c2, r4, s3)) {
        var o2 = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
        throw o2.errors = s3, o2;
      }
      if (i2.derToOid(r4.publicKeyOid) !== a6.oids.rsaEncryption)
        throw new Error("Cannot read public key. OID is not RSA.");
      var u3 = a6.createCertificate();
      u3.version = r4.certVersion ? r4.certVersion.charCodeAt(0) : 0;
      var l3 = n3.util.createBuffer(r4.certSerialNumber);
      u3.serialNumber = l3.toHex(), u3.signatureOid = n3.asn1.derToOid(r4.certSignatureOid), u3.signatureParameters = d2(u3.signatureOid, r4.certSignatureParams, true), u3.siginfo.algorithmOid = n3.asn1.derToOid(r4.certinfoSignatureOid), u3.siginfo.parameters = d2(u3.siginfo.algorithmOid, r4.certinfoSignatureParams, false), u3.signature = r4.certSignature;
      var h3 = [];
      if (r4.certValidity1UTCTime !== void 0 && h3.push(i2.utcTimeToDate(r4.certValidity1UTCTime)), r4.certValidity2GeneralizedTime !== void 0 && h3.push(i2.generalizedTimeToDate(r4.certValidity2GeneralizedTime)), r4.certValidity3UTCTime !== void 0 && h3.push(i2.utcTimeToDate(r4.certValidity3UTCTime)), r4.certValidity4GeneralizedTime !== void 0 && h3.push(i2.generalizedTimeToDate(r4.certValidity4GeneralizedTime)), h3.length > 2)
        throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
      if (h3.length < 2)
        throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
      if (u3.validity.notBefore = h3[0], u3.validity.notAfter = h3[1], u3.tbsCertificate = r4.tbsCertificate, t4) {
        u3.md = g2({ signatureOid: u3.signatureOid, type: "certificate" });
        var f3 = i2.toDer(u3.tbsCertificate);
        u3.md.update(f3.getBytes());
      }
      var y3 = n3.md.sha1.create(), v3 = i2.toDer(r4.certIssuer);
      y3.update(v3.getBytes()), u3.issuer.getField = function(e5) {
        return p2(u3.issuer, e5);
      }, u3.issuer.addField = function(e5) {
        m2([e5]), u3.issuer.attributes.push(e5);
      }, u3.issuer.attributes = a6.RDNAttributesAsArray(r4.certIssuer), r4.certIssuerUniqueId && (u3.issuer.uniqueId = r4.certIssuerUniqueId), u3.issuer.hash = y3.digest().toHex();
      var E3 = n3.md.sha1.create(), C2 = i2.toDer(r4.certSubject);
      return E3.update(C2.getBytes()), u3.subject.getField = function(e5) {
        return p2(u3.subject, e5);
      }, u3.subject.addField = function(e5) {
        m2([e5]), u3.subject.attributes.push(e5);
      }, u3.subject.attributes = a6.RDNAttributesAsArray(r4.certSubject), r4.certSubjectUniqueId && (u3.subject.uniqueId = r4.certSubjectUniqueId), u3.subject.hash = E3.digest().toHex(), r4.certExtensions ? u3.extensions = a6.certificateExtensionsFromAsn1(r4.certExtensions) : u3.extensions = [], u3.publicKey = a6.publicKeyFromAsn1(r4.subjectPublicKeyInfo), u3;
    }, a6.certificateExtensionsFromAsn1 = function(e4) {
      for (var t4 = [], r4 = 0; r4 < e4.value.length; ++r4)
        for (var n4 = e4.value[r4], i3 = 0; i3 < n4.value.length; ++i3)
          t4.push(a6.certificateExtensionFromAsn1(n4.value[i3]));
      return t4;
    }, a6.certificateExtensionFromAsn1 = function(e4) {
      var t4 = {};
      if (t4.id = i2.derToOid(e4.value[0].value), t4.critical = false, e4.value[1].type === i2.Type.BOOLEAN ? (t4.critical = e4.value[1].value.charCodeAt(0) !== 0, t4.value = e4.value[2].value) : t4.value = e4.value[1].value, t4.id in s2)
        if (t4.name = s2[t4.id], t4.name === "keyUsage") {
          var r4 = 0, a7 = 0;
          (u3 = i2.fromDer(t4.value)).value.length > 1 && (r4 = u3.value.charCodeAt(1), a7 = u3.value.length > 2 ? u3.value.charCodeAt(2) : 0), t4.digitalSignature = (128 & r4) == 128, t4.nonRepudiation = (64 & r4) == 64, t4.keyEncipherment = (32 & r4) == 32, t4.dataEncipherment = (16 & r4) == 16, t4.keyAgreement = (8 & r4) == 8, t4.keyCertSign = (4 & r4) == 4, t4.cRLSign = (2 & r4) == 2, t4.encipherOnly = (1 & r4) == 1, t4.decipherOnly = (128 & a7) == 128;
        } else if (t4.name === "basicConstraints") {
          (u3 = i2.fromDer(t4.value)).value.length > 0 && u3.value[0].type === i2.Type.BOOLEAN ? t4.cA = u3.value[0].value.charCodeAt(0) !== 0 : t4.cA = false;
          var o2 = null;
          u3.value.length > 0 && u3.value[0].type === i2.Type.INTEGER ? o2 = u3.value[0].value : u3.value.length > 1 && (o2 = u3.value[1].value), o2 !== null && (t4.pathLenConstraint = i2.derToInteger(o2));
        } else if (t4.name === "extKeyUsage")
          for (var u3 = i2.fromDer(t4.value), c3 = 0; c3 < u3.value.length; ++c3) {
            var l3 = i2.derToOid(u3.value[c3].value);
            l3 in s2 ? t4[s2[l3]] = true : t4[l3] = true;
          }
        else if (t4.name === "nsCertType")
          r4 = 0, (u3 = i2.fromDer(t4.value)).value.length > 1 && (r4 = u3.value.charCodeAt(1)), t4.client = (128 & r4) == 128, t4.server = (64 & r4) == 64, t4.email = (32 & r4) == 32, t4.objsign = (16 & r4) == 16, t4.reserved = (8 & r4) == 8, t4.sslCA = (4 & r4) == 4, t4.emailCA = (2 & r4) == 2, t4.objCA = (1 & r4) == 1;
        else if (t4.name === "subjectAltName" || t4.name === "issuerAltName") {
          var h3;
          t4.altNames = [], u3 = i2.fromDer(t4.value);
          for (var f3 = 0; f3 < u3.value.length; ++f3) {
            var p3 = { type: (h3 = u3.value[f3]).type, value: h3.value };
            switch (t4.altNames.push(p3), h3.type) {
              case 1:
              case 2:
              case 6:
                break;
              case 7:
                p3.ip = n3.util.bytesToIP(h3.value);
                break;
              case 8:
                p3.oid = i2.derToOid(h3.value);
            }
          }
        } else
          t4.name === "subjectKeyIdentifier" && (u3 = i2.fromDer(t4.value), t4.subjectKeyIdentifier = n3.util.bytesToHex(u3.value));
      return t4;
    }, a6.certificationRequestFromAsn1 = function(e4, t4) {
      var r4 = {}, s3 = [];
      if (!i2.validate(e4, f2, r4, s3)) {
        var o2 = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
        throw o2.errors = s3, o2;
      }
      if (i2.derToOid(r4.publicKeyOid) !== a6.oids.rsaEncryption)
        throw new Error("Cannot read public key. OID is not RSA.");
      var u3 = a6.createCertificationRequest();
      if (u3.version = r4.csrVersion ? r4.csrVersion.charCodeAt(0) : 0, u3.signatureOid = n3.asn1.derToOid(r4.csrSignatureOid), u3.signatureParameters = d2(u3.signatureOid, r4.csrSignatureParams, true), u3.siginfo.algorithmOid = n3.asn1.derToOid(r4.csrSignatureOid), u3.siginfo.parameters = d2(u3.siginfo.algorithmOid, r4.csrSignatureParams, false), u3.signature = r4.csrSignature, u3.certificationRequestInfo = r4.certificationRequestInfo, t4) {
        u3.md = g2({ signatureOid: u3.signatureOid, type: "certification request" });
        var c3 = i2.toDer(u3.certificationRequestInfo);
        u3.md.update(c3.getBytes());
      }
      var l3 = n3.md.sha1.create();
      return u3.subject.getField = function(e5) {
        return p2(u3.subject, e5);
      }, u3.subject.addField = function(e5) {
        m2([e5]), u3.subject.attributes.push(e5);
      }, u3.subject.attributes = a6.RDNAttributesAsArray(r4.certificationRequestInfoSubject, l3), u3.subject.hash = l3.digest().toHex(), u3.publicKey = a6.publicKeyFromAsn1(r4.subjectPublicKeyInfo), u3.getAttribute = function(e5) {
        return p2(u3, e5);
      }, u3.addAttribute = function(e5) {
        m2([e5]), u3.attributes.push(e5);
      }, u3.attributes = a6.CRIAttributesAsArray(r4.certificationRequestInfoAttributes || []), u3;
    }, a6.createCertificationRequest = function() {
      var e4 = { version: 0, signatureOid: null, signature: null, siginfo: {} };
      return e4.siginfo.algorithmOid = null, e4.subject = {}, e4.subject.getField = function(t4) {
        return p2(e4.subject, t4);
      }, e4.subject.addField = function(t4) {
        m2([t4]), e4.subject.attributes.push(t4);
      }, e4.subject.attributes = [], e4.subject.hash = null, e4.publicKey = null, e4.attributes = [], e4.getAttribute = function(t4) {
        return p2(e4, t4);
      }, e4.addAttribute = function(t4) {
        m2([t4]), e4.attributes.push(t4);
      }, e4.md = null, e4.setSubject = function(t4) {
        m2(t4), e4.subject.attributes = t4, e4.subject.hash = null;
      }, e4.setAttributes = function(t4) {
        m2(t4), e4.attributes = t4;
      }, e4.sign = function(t4, r4) {
        e4.md = r4 || n3.md.sha1.create();
        var o2 = s2[e4.md.algorithm + "WithRSAEncryption"];
        if (!o2) {
          var u3 = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
          throw u3.algorithm = e4.md.algorithm, u3;
        }
        e4.signatureOid = e4.siginfo.algorithmOid = o2, e4.certificationRequestInfo = a6.getCertificationRequestInfo(e4);
        var c3 = i2.toDer(e4.certificationRequestInfo);
        e4.md.update(c3.getBytes()), e4.signature = t4.sign(e4.md);
      }, e4.verify = function() {
        var t4 = false, r4 = e4.md;
        if (r4 === null) {
          r4 = g2({ signatureOid: e4.signatureOid, type: "certification request" });
          var n4 = e4.certificationRequestInfo || a6.getCertificationRequestInfo(e4), s3 = i2.toDer(n4);
          r4.update(s3.getBytes());
        }
        return r4 !== null && (t4 = y2({ certificate: e4, md: r4, signature: e4.signature })), t4;
      }, e4;
    };
    var b2 = new Date("1950-01-01T00:00:00Z"), T2 = new Date("2050-01-01T00:00:00Z");
    function _24(e4) {
      return e4 >= b2 && e4 < T2 ? i2.create(i2.Class.UNIVERSAL, i2.Type.UTCTIME, false, i2.dateToUtcTime(e4)) : i2.create(i2.Class.UNIVERSAL, i2.Type.GENERALIZEDTIME, false, i2.dateToGeneralizedTime(e4));
    }
    a6.getTBSCertificate = function(e4) {
      var t4 = _24(e4.validity.notBefore), r4 = _24(e4.validity.notAfter), s3 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.CONTEXT_SPECIFIC, 0, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(e4.version).getBytes())]), i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, n3.util.hexToBytes(e4.serialNumber)), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.siginfo.algorithmOid).getBytes()), C(e4.siginfo.algorithmOid, e4.siginfo.parameters)]), v2(e4.issuer), i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [t4, r4]), v2(e4.subject), a6.publicKeyToAsn1(e4.publicKey)]);
      return e4.issuer.uniqueId && s3.value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 1, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.BITSTRING, false, String.fromCharCode(0) + e4.issuer.uniqueId)])), e4.subject.uniqueId && s3.value.push(i2.create(i2.Class.CONTEXT_SPECIFIC, 2, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.BITSTRING, false, String.fromCharCode(0) + e4.subject.uniqueId)])), e4.extensions.length > 0 && s3.value.push(a6.certificateExtensionsToAsn1(e4.extensions)), s3;
    }, a6.getCertificationRequestInfo = function(e4) {
      return i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.INTEGER, false, i2.integerToDer(e4.version).getBytes()), v2(e4.subject), a6.publicKeyToAsn1(e4.publicKey), S2(e4)]);
    }, a6.distinguishedNameToAsn1 = function(e4) {
      return v2(e4);
    }, a6.certificateToAsn1 = function(e4) {
      var t4 = e4.tbsCertificate || a6.getTBSCertificate(e4);
      return i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [t4, i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.signatureOid).getBytes()), C(e4.signatureOid, e4.signatureParameters)]), i2.create(i2.Class.UNIVERSAL, i2.Type.BITSTRING, false, String.fromCharCode(0) + e4.signature)]);
    }, a6.certificateExtensionsToAsn1 = function(e4) {
      var t4 = i2.create(i2.Class.CONTEXT_SPECIFIC, 3, true, []), r4 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []);
      t4.value.push(r4);
      for (var n4 = 0; n4 < e4.length; ++n4)
        r4.value.push(a6.certificateExtensionToAsn1(e4[n4]));
      return t4;
    }, a6.certificateExtensionToAsn1 = function(e4) {
      var t4 = i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, []);
      t4.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.id).getBytes())), e4.critical && t4.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.BOOLEAN, false, String.fromCharCode(255)));
      var r4 = e4.value;
      return typeof e4.value != "string" && (r4 = i2.toDer(r4).getBytes()), t4.value.push(i2.create(i2.Class.UNIVERSAL, i2.Type.OCTETSTRING, false, r4)), t4;
    }, a6.certificationRequestToAsn1 = function(e4) {
      var t4 = e4.certificationRequestInfo || a6.getCertificationRequestInfo(e4);
      return i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [t4, i2.create(i2.Class.UNIVERSAL, i2.Type.SEQUENCE, true, [i2.create(i2.Class.UNIVERSAL, i2.Type.OID, false, i2.oidToDer(e4.signatureOid).getBytes()), C(e4.signatureOid, e4.signatureParameters)]), i2.create(i2.Class.UNIVERSAL, i2.Type.BITSTRING, false, String.fromCharCode(0) + e4.signature)]);
    }, a6.createCaStore = function(e4) {
      var t4 = { certs: {} };
      function r4(e5) {
        return s3(e5), t4.certs[e5.hash] || null;
      }
      function s3(e5) {
        if (!e5.hash) {
          var t5 = n3.md.sha1.create();
          e5.attributes = a6.RDNAttributesAsArray(v2(e5), t5), e5.hash = t5.digest().toHex();
        }
      }
      if (t4.getIssuer = function(e5) {
        return r4(e5.issuer);
      }, t4.addCertificate = function(e5) {
        if (typeof e5 == "string" && (e5 = n3.pki.certificateFromPem(e5)), s3(e5.subject), !t4.hasCertificate(e5))
          if (e5.subject.hash in t4.certs) {
            var r5 = t4.certs[e5.subject.hash];
            n3.util.isArray(r5) || (r5 = [r5]), r5.push(e5), t4.certs[e5.subject.hash] = r5;
          } else
            t4.certs[e5.subject.hash] = e5;
      }, t4.hasCertificate = function(e5) {
        typeof e5 == "string" && (e5 = n3.pki.certificateFromPem(e5));
        var t5 = r4(e5.subject);
        if (!t5)
          return false;
        n3.util.isArray(t5) || (t5 = [t5]);
        for (var s4 = i2.toDer(a6.certificateToAsn1(e5)).getBytes(), o3 = 0; o3 < t5.length; ++o3)
          if (s4 === i2.toDer(a6.certificateToAsn1(t5[o3])).getBytes())
            return true;
        return false;
      }, t4.listAllCertificates = function() {
        var e5 = [];
        for (var r5 in t4.certs)
          if (t4.certs.hasOwnProperty(r5)) {
            var i3 = t4.certs[r5];
            if (n3.util.isArray(i3))
              for (var a7 = 0; a7 < i3.length; ++a7)
                e5.push(i3[a7]);
            else
              e5.push(i3);
          }
        return e5;
      }, t4.removeCertificate = function(e5) {
        var o3;
        if (typeof e5 == "string" && (e5 = n3.pki.certificateFromPem(e5)), s3(e5.subject), !t4.hasCertificate(e5))
          return null;
        var u4 = r4(e5.subject);
        if (!n3.util.isArray(u4))
          return o3 = t4.certs[e5.subject.hash], delete t4.certs[e5.subject.hash], o3;
        for (var c3 = i2.toDer(a6.certificateToAsn1(e5)).getBytes(), l3 = 0; l3 < u4.length; ++l3)
          c3 === i2.toDer(a6.certificateToAsn1(u4[l3])).getBytes() && (o3 = u4[l3], u4.splice(l3, 1));
        return u4.length === 0 && delete t4.certs[e5.subject.hash], o3;
      }, e4)
        for (var o2 = 0; o2 < e4.length; ++o2) {
          var u3 = e4[o2];
          t4.addCertificate(u3);
        }
      return t4;
    }, a6.certificateError = { bad_certificate: "forge.pki.BadCertificate", unsupported_certificate: "forge.pki.UnsupportedCertificate", certificate_revoked: "forge.pki.CertificateRevoked", certificate_expired: "forge.pki.CertificateExpired", certificate_unknown: "forge.pki.CertificateUnknown", unknown_ca: "forge.pki.UnknownCertificateAuthority" }, a6.verifyCertificateChain = function(e4, t4, r4) {
      typeof r4 == "function" && (r4 = { verify: r4 }), r4 = r4 || {};
      var i3 = (t4 = t4.slice(0)).slice(0), s3 = r4.validityCheckDate;
      s3 === void 0 && (s3 = new Date());
      var o2 = true, u3 = null, c3 = 0;
      do {
        var l3 = t4.shift(), h3 = null, f3 = false;
        if (s3 && (s3 < l3.validity.notBefore || s3 > l3.validity.notAfter) && (u3 = { message: "Certificate is not valid yet or has expired.", error: a6.certificateError.certificate_expired, notBefore: l3.validity.notBefore, notAfter: l3.validity.notAfter, now: s3 }), u3 === null) {
          if ((h3 = t4[0] || e4.getIssuer(l3)) === null && l3.isIssuer(l3) && (f3 = true, h3 = l3), h3) {
            var p3 = h3;
            n3.util.isArray(p3) || (p3 = [p3]);
            for (var d3 = false; !d3 && p3.length > 0; ) {
              h3 = p3.shift();
              try {
                d3 = h3.verify(l3);
              } catch (e5) {
              }
            }
            d3 || (u3 = { message: "Certificate signature is invalid.", error: a6.certificateError.bad_certificate });
          }
          u3 !== null || h3 && !f3 || e4.hasCertificate(l3) || (u3 = { message: "Certificate is not trusted.", error: a6.certificateError.unknown_ca });
        }
        if (u3 === null && h3 && !l3.isIssuer(h3) && (u3 = { message: "Certificate issuer is invalid.", error: a6.certificateError.bad_certificate }), u3 === null)
          for (var g3 = { keyUsage: true, basicConstraints: true }, y3 = 0; u3 === null && y3 < l3.extensions.length; ++y3) {
            var v3 = l3.extensions[y3];
            v3.critical && !(v3.name in g3) && (u3 = { message: "Certificate has an unsupported critical extension.", error: a6.certificateError.unsupported_certificate });
          }
        if (u3 === null && (!o2 || t4.length === 0 && (!h3 || f3))) {
          var m3 = l3.getExtension("basicConstraints"), E3 = l3.getExtension("keyUsage");
          E3 !== null && (E3.keyCertSign && m3 !== null || (u3 = { message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.", error: a6.certificateError.bad_certificate })), u3 !== null || m3 === null || m3.cA || (u3 = { message: "Certificate basicConstraints indicates the certificate is not a CA.", error: a6.certificateError.bad_certificate }), u3 === null && E3 !== null && "pathLenConstraint" in m3 && c3 - 1 > m3.pathLenConstraint && (u3 = { message: "Certificate basicConstraints pathLenConstraint violated.", error: a6.certificateError.bad_certificate });
        }
        var C2 = u3 === null || u3.error, S3 = r4.verify ? r4.verify(C2, c3, i3) : C2;
        if (S3 !== true)
          throw C2 === true && (u3 = { message: "The application rejected the certificate.", error: a6.certificateError.bad_certificate }), (S3 || S3 === 0) && (typeof S3 != "object" || n3.util.isArray(S3) ? typeof S3 == "string" && (u3.error = S3) : (S3.message && (u3.message = S3.message), S3.error && (u3.error = S3.error))), u3;
        u3 = null, o2 = false, ++c3;
      } while (t4.length > 0);
      return true;
    };
  }, 4406: (e3) => {
    var t3, r3, n3 = e3.exports = {};
    function i2() {
      throw new Error("setTimeout has not been defined");
    }
    function a6() {
      throw new Error("clearTimeout has not been defined");
    }
    function s2(e4) {
      if (t3 === setTimeout)
        return setTimeout(e4, 0);
      if ((t3 === i2 || !t3) && setTimeout)
        return t3 = setTimeout, setTimeout(e4, 0);
      try {
        return t3(e4, 0);
      } catch (r4) {
        try {
          return t3.call(null, e4, 0);
        } catch (r5) {
          return t3.call(this, e4, 0);
        }
      }
    }
    !function() {
      try {
        t3 = typeof setTimeout == "function" ? setTimeout : i2;
      } catch (e4) {
        t3 = i2;
      }
      try {
        r3 = typeof clearTimeout == "function" ? clearTimeout : a6;
      } catch (e4) {
        r3 = a6;
      }
    }();
    var o, u2 = [], c2 = false, l2 = -1;
    function h2() {
      c2 && o && (c2 = false, o.length ? u2 = o.concat(u2) : l2 = -1, u2.length && f2());
    }
    function f2() {
      if (!c2) {
        var e4 = s2(h2);
        c2 = true;
        for (var t4 = u2.length; t4; ) {
          for (o = u2, u2 = []; ++l2 < t4; )
            o && o[l2].run();
          l2 = -1, t4 = u2.length;
        }
        o = null, c2 = false, function(e5) {
          if (r3 === clearTimeout)
            return clearTimeout(e5);
          if ((r3 === a6 || !r3) && clearTimeout)
            return r3 = clearTimeout, clearTimeout(e5);
          try {
            r3(e5);
          } catch (t5) {
            try {
              return r3.call(null, e5);
            } catch (t6) {
              return r3.call(this, e5);
            }
          }
        }(e4);
      }
    }
    function p2(e4, t4) {
      this.fun = e4, this.array = t4;
    }
    function d2() {
    }
    n3.nextTick = function(e4) {
      var t4 = new Array(arguments.length - 1);
      if (arguments.length > 1)
        for (var r4 = 1; r4 < arguments.length; r4++)
          t4[r4 - 1] = arguments[r4];
      u2.push(new p2(e4, t4)), u2.length !== 1 || c2 || s2(f2);
    }, p2.prototype.run = function() {
      this.fun.apply(null, this.array);
    }, n3.title = "browser", n3.browser = true, n3.env = {}, n3.argv = [], n3.version = "", n3.versions = {}, n3.on = d2, n3.addListener = d2, n3.once = d2, n3.off = d2, n3.removeListener = d2, n3.removeAllListeners = d2, n3.emit = d2, n3.prependListener = d2, n3.prependOnceListener = d2, n3.listeners = function(e4) {
      return [];
    }, n3.binding = function(e4) {
      throw new Error("process.binding is not supported");
    }, n3.cwd = function() {
      return "/";
    }, n3.chdir = function(e4) {
      throw new Error("process.chdir is not supported");
    }, n3.umask = function() {
      return 0;
    };
  }, 4452: (e3) => {
    var t3 = {};
    function r3(e4, r4, n4) {
      n4 || (n4 = Error);
      var i2 = function(e5) {
        var t4, n5;
        function i3(t5, n6, i4) {
          return e5.call(this, function(e6, t6, n7) {
            return typeof r4 == "string" ? r4 : r4(e6, t6, n7);
          }(t5, n6, i4)) || this;
        }
        return n5 = e5, (t4 = i3).prototype = Object.create(n5.prototype), t4.prototype.constructor = t4, t4.__proto__ = n5, i3;
      }(n4);
      i2.prototype.name = n4.name, i2.prototype.code = e4, t3[e4] = i2;
    }
    function n3(e4, t4) {
      if (Array.isArray(e4)) {
        var r4 = e4.length;
        return e4 = e4.map(function(e5) {
          return String(e5);
        }), r4 > 2 ? "one of ".concat(t4, " ").concat(e4.slice(0, r4 - 1).join(", "), ", or ") + e4[r4 - 1] : r4 === 2 ? "one of ".concat(t4, " ").concat(e4[0], " or ").concat(e4[1]) : "of ".concat(t4, " ").concat(e4[0]);
      }
      return "of ".concat(t4, " ").concat(String(e4));
    }
    r3("ERR_INVALID_OPT_VALUE", function(e4, t4) {
      return 'The value "' + t4 + '" is invalid for option "' + e4 + '"';
    }, TypeError), r3("ERR_INVALID_ARG_TYPE", function(e4, t4, r4) {
      var i2, a6, s2, o, u2;
      if (typeof t4 == "string" && (a6 = "not ", t4.substr(0, a6.length) === a6) ? (i2 = "must not be", t4 = t4.replace(/^not /, "")) : i2 = "must be", function(e5, t5, r5) {
        return (r5 === void 0 || r5 > e5.length) && (r5 = e5.length), e5.substring(r5 - t5.length, r5) === t5;
      }(e4, " argument"))
        s2 = "The ".concat(e4, " ").concat(i2, " ").concat(n3(t4, "type"));
      else {
        var c2 = (typeof u2 != "number" && (u2 = 0), u2 + ".".length > (o = e4).length || o.indexOf(".", u2) === -1 ? "argument" : "property");
        s2 = 'The "'.concat(e4, '" ').concat(c2, " ").concat(i2, " ").concat(n3(t4, "type"));
      }
      return s2 + ". Received type ".concat(typeof r4);
    }, TypeError), r3("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r3("ERR_METHOD_NOT_IMPLEMENTED", function(e4) {
      return "The " + e4 + " method is not implemented";
    }), r3("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r3("ERR_STREAM_DESTROYED", function(e4) {
      return "Cannot call " + e4 + " after a stream was destroyed";
    }), r3("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r3("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r3("ERR_STREAM_WRITE_AFTER_END", "write after end"), r3("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r3("ERR_UNKNOWN_ENCODING", function(e4) {
      return "Unknown encoding: " + e4;
    }, TypeError), r3("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e3.exports.q = t3;
  }, 7073: (e3, t3, r3) => {
    var n3 = Object.keys || function(e4) {
      var t4 = [];
      for (var r4 in e4)
        t4.push(r4);
      return t4;
    };
    e3.exports = c2;
    var i2 = r3(8051), a6 = r3(2557);
    r3(1285)(c2, i2);
    for (var s2 = n3(a6.prototype), o = 0; o < s2.length; o++) {
      var u2 = s2[o];
      c2.prototype[u2] || (c2.prototype[u2] = a6.prototype[u2]);
    }
    function c2(e4) {
      if (!(this instanceof c2))
        return new c2(e4);
      i2.call(this, e4), a6.call(this, e4), this.allowHalfOpen = true, e4 && (e4.readable === false && (this.readable = false), e4.writable === false && (this.writable = false), e4.allowHalfOpen === false && (this.allowHalfOpen = false, this.once("end", l2)));
    }
    function l2() {
      this._writableState.ended || process.nextTick(h2, this);
    }
    function h2(e4) {
      e4.end();
    }
    Object.defineProperty(c2.prototype, "writableHighWaterMark", { enumerable: false, get: function() {
      return this._writableState.highWaterMark;
    } }), Object.defineProperty(c2.prototype, "writableBuffer", { enumerable: false, get: function() {
      return this._writableState && this._writableState.getBuffer();
    } }), Object.defineProperty(c2.prototype, "writableLength", { enumerable: false, get: function() {
      return this._writableState.length;
    } }), Object.defineProperty(c2.prototype, "destroyed", { enumerable: false, get: function() {
      return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
    }, set: function(e4) {
      this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = e4, this._writableState.destroyed = e4);
    } });
  }, 5163: (e3, t3, r3) => {
    e3.exports = i2;
    var n3 = r3(7640);
    function i2(e4) {
      if (!(this instanceof i2))
        return new i2(e4);
      n3.call(this, e4);
    }
    r3(1285)(i2, n3), i2.prototype._transform = function(e4, t4, r4) {
      r4(null, e4);
    };
  }, 8051: (e3, t3, r3) => {
    var n3;
    e3.exports = _24, _24.ReadableState = T2, r3(2699).EventEmitter;
    var i2, a6 = function(e4, t4) {
      return e4.listeners(t4).length;
    }, s2 = r3(5010), o = r3(8834).Buffer, u2 = r3.g.Uint8Array || function() {
    }, c2 = r3(6602);
    i2 = c2 && c2.debuglog ? c2.debuglog("stream") : function() {
    };
    var l2, h2, f2, p2 = r3(6637), d2 = r3(2262), g2 = r3(7605).getHighWaterMark, y2 = r3(4452).q, v2 = y2.ERR_INVALID_ARG_TYPE, m2 = y2.ERR_STREAM_PUSH_AFTER_EOF, E2 = y2.ERR_METHOD_NOT_IMPLEMENTED, C = y2.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    r3(1285)(_24, s2);
    var S2 = d2.errorOrDestroy, b2 = ["error", "close", "destroy", "pause", "resume"];
    function T2(e4, t4, i3) {
      n3 = n3 || r3(7073), e4 = e4 || {}, typeof i3 != "boolean" && (i3 = t4 instanceof n3), this.objectMode = !!e4.objectMode, i3 && (this.objectMode = this.objectMode || !!e4.readableObjectMode), this.highWaterMark = g2(this, e4, "readableHighWaterMark", i3), this.buffer = new p2(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this.paused = true, this.emitClose = e4.emitClose !== false, this.autoDestroy = !!e4.autoDestroy, this.destroyed = false, this.defaultEncoding = e4.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = false, this.decoder = null, this.encoding = null, e4.encoding && (l2 || (l2 = r3(214).s), this.decoder = new l2(e4.encoding), this.encoding = e4.encoding);
    }
    function _24(e4) {
      if (n3 = n3 || r3(7073), !(this instanceof _24))
        return new _24(e4);
      var t4 = this instanceof n3;
      this._readableState = new T2(e4, this, t4), this.readable = true, e4 && (typeof e4.read == "function" && (this._read = e4.read), typeof e4.destroy == "function" && (this._destroy = e4.destroy)), s2.call(this);
    }
    function I2(e4, t4, r4, n4, a7) {
      i2("readableAddChunk", t4);
      var s3, c3 = e4._readableState;
      if (t4 === null)
        c3.reading = false, function(e5, t5) {
          if (i2("onEofChunk"), !t5.ended) {
            if (t5.decoder) {
              var r5 = t5.decoder.end();
              r5 && r5.length && (t5.buffer.push(r5), t5.length += t5.objectMode ? 1 : r5.length);
            }
            t5.ended = true, t5.sync ? R(e5) : (t5.needReadable = false, t5.emittedReadable || (t5.emittedReadable = true, N2(e5)));
          }
        }(e4, c3);
      else if (a7 || (s3 = function(e5, t5) {
        var r5, n5;
        return n5 = t5, o.isBuffer(n5) || n5 instanceof u2 || typeof t5 == "string" || t5 === void 0 || e5.objectMode || (r5 = new v2("chunk", ["string", "Buffer", "Uint8Array"], t5)), r5;
      }(c3, t4)), s3)
        S2(e4, s3);
      else if (c3.objectMode || t4 && t4.length > 0)
        if (typeof t4 == "string" || c3.objectMode || Object.getPrototypeOf(t4) === o.prototype || (t4 = function(e5) {
          return o.from(e5);
        }(t4)), n4)
          c3.endEmitted ? S2(e4, new C()) : A2(e4, c3, t4, true);
        else if (c3.ended)
          S2(e4, new m2());
        else {
          if (c3.destroyed)
            return false;
          c3.reading = false, c3.decoder && !r4 ? (t4 = c3.decoder.write(t4), c3.objectMode || t4.length !== 0 ? A2(e4, c3, t4, false) : L2(e4, c3)) : A2(e4, c3, t4, false);
        }
      else
        n4 || (c3.reading = false, L2(e4, c3));
      return !c3.ended && (c3.length < c3.highWaterMark || c3.length === 0);
    }
    function A2(e4, t4, r4, n4) {
      t4.flowing && t4.length === 0 && !t4.sync ? (t4.awaitDrain = 0, e4.emit("data", r4)) : (t4.length += t4.objectMode ? 1 : r4.length, n4 ? t4.buffer.unshift(r4) : t4.buffer.push(r4), t4.needReadable && R(e4)), L2(e4, t4);
    }
    Object.defineProperty(_24.prototype, "destroyed", { enumerable: false, get: function() {
      return this._readableState !== void 0 && this._readableState.destroyed;
    }, set: function(e4) {
      this._readableState && (this._readableState.destroyed = e4);
    } }), _24.prototype.destroy = d2.destroy, _24.prototype._undestroy = d2.undestroy, _24.prototype._destroy = function(e4, t4) {
      t4(e4);
    }, _24.prototype.push = function(e4, t4) {
      var r4, n4 = this._readableState;
      return n4.objectMode ? r4 = true : typeof e4 == "string" && ((t4 = t4 || n4.defaultEncoding) !== n4.encoding && (e4 = o.from(e4, t4), t4 = ""), r4 = true), I2(this, e4, t4, false, r4);
    }, _24.prototype.unshift = function(e4) {
      return I2(this, e4, null, true, false);
    }, _24.prototype.isPaused = function() {
      return this._readableState.flowing === false;
    }, _24.prototype.setEncoding = function(e4) {
      l2 || (l2 = r3(214).s);
      var t4 = new l2(e4);
      this._readableState.decoder = t4, this._readableState.encoding = this._readableState.decoder.encoding;
      for (var n4 = this._readableState.buffer.head, i3 = ""; n4 !== null; )
        i3 += t4.write(n4.data), n4 = n4.next;
      return this._readableState.buffer.clear(), i3 !== "" && this._readableState.buffer.push(i3), this._readableState.length = i3.length, this;
    };
    var B2 = 1073741824;
    function w2(e4, t4) {
      return e4 <= 0 || t4.length === 0 && t4.ended ? 0 : t4.objectMode ? 1 : e4 != e4 ? t4.flowing && t4.length ? t4.buffer.head.data.length : t4.length : (e4 > t4.highWaterMark && (t4.highWaterMark = function(e5) {
        return e5 >= B2 ? e5 = B2 : (e5--, e5 |= e5 >>> 1, e5 |= e5 >>> 2, e5 |= e5 >>> 4, e5 |= e5 >>> 8, e5 |= e5 >>> 16, e5++), e5;
      }(e4)), e4 <= t4.length ? e4 : t4.ended ? t4.length : (t4.needReadable = true, 0));
    }
    function R(e4) {
      var t4 = e4._readableState;
      i2("emitReadable", t4.needReadable, t4.emittedReadable), t4.needReadable = false, t4.emittedReadable || (i2("emitReadable", t4.flowing), t4.emittedReadable = true, process.nextTick(N2, e4));
    }
    function N2(e4) {
      var t4 = e4._readableState;
      i2("emitReadable_", t4.destroyed, t4.length, t4.ended), t4.destroyed || !t4.length && !t4.ended || (e4.emit("readable"), t4.emittedReadable = false), t4.needReadable = !t4.flowing && !t4.ended && t4.length <= t4.highWaterMark, O(e4);
    }
    function L2(e4, t4) {
      t4.readingMore || (t4.readingMore = true, process.nextTick(k3, e4, t4));
    }
    function k3(e4, t4) {
      for (; !t4.reading && !t4.ended && (t4.length < t4.highWaterMark || t4.flowing && t4.length === 0); ) {
        var r4 = t4.length;
        if (i2("maybeReadMore read 0"), e4.read(0), r4 === t4.length)
          break;
      }
      t4.readingMore = false;
    }
    function U2(e4) {
      var t4 = e4._readableState;
      t4.readableListening = e4.listenerCount("readable") > 0, t4.resumeScheduled && !t4.paused ? t4.flowing = true : e4.listenerCount("data") > 0 && e4.resume();
    }
    function D2(e4) {
      i2("readable nexttick read 0"), e4.read(0);
    }
    function P2(e4, t4) {
      i2("resume", t4.reading), t4.reading || e4.read(0), t4.resumeScheduled = false, e4.emit("resume"), O(e4), t4.flowing && !t4.reading && e4.read(0);
    }
    function O(e4) {
      var t4 = e4._readableState;
      for (i2("flow", t4.flowing); t4.flowing && e4.read() !== null; )
        ;
    }
    function V2(e4, t4) {
      return t4.length === 0 ? null : (t4.objectMode ? r4 = t4.buffer.shift() : !e4 || e4 >= t4.length ? (r4 = t4.decoder ? t4.buffer.join("") : t4.buffer.length === 1 ? t4.buffer.first() : t4.buffer.concat(t4.length), t4.buffer.clear()) : r4 = t4.buffer.consume(e4, t4.decoder), r4);
      var r4;
    }
    function x2(e4) {
      var t4 = e4._readableState;
      i2("endReadable", t4.endEmitted), t4.endEmitted || (t4.ended = true, process.nextTick(M2, t4, e4));
    }
    function M2(e4, t4) {
      if (i2("endReadableNT", e4.endEmitted, e4.length), !e4.endEmitted && e4.length === 0 && (e4.endEmitted = true, t4.readable = false, t4.emit("end"), e4.autoDestroy)) {
        var r4 = t4._writableState;
        (!r4 || r4.autoDestroy && r4.finished) && t4.destroy();
      }
    }
    function K2(e4, t4) {
      for (var r4 = 0, n4 = e4.length; r4 < n4; r4++)
        if (e4[r4] === t4)
          return r4;
      return -1;
    }
    _24.prototype.read = function(e4) {
      i2("read", e4), e4 = parseInt(e4, 10);
      var t4 = this._readableState, r4 = e4;
      if (e4 !== 0 && (t4.emittedReadable = false), e4 === 0 && t4.needReadable && ((t4.highWaterMark !== 0 ? t4.length >= t4.highWaterMark : t4.length > 0) || t4.ended))
        return i2("read: emitReadable", t4.length, t4.ended), t4.length === 0 && t4.ended ? x2(this) : R(this), null;
      if ((e4 = w2(e4, t4)) === 0 && t4.ended)
        return t4.length === 0 && x2(this), null;
      var n4, a7 = t4.needReadable;
      return i2("need readable", a7), (t4.length === 0 || t4.length - e4 < t4.highWaterMark) && i2("length less than watermark", a7 = true), t4.ended || t4.reading ? i2("reading or ended", a7 = false) : a7 && (i2("do read"), t4.reading = true, t4.sync = true, t4.length === 0 && (t4.needReadable = true), this._read(t4.highWaterMark), t4.sync = false, t4.reading || (e4 = w2(r4, t4))), (n4 = e4 > 0 ? V2(e4, t4) : null) === null ? (t4.needReadable = t4.length <= t4.highWaterMark, e4 = 0) : (t4.length -= e4, t4.awaitDrain = 0), t4.length === 0 && (t4.ended || (t4.needReadable = true), r4 !== e4 && t4.ended && x2(this)), n4 !== null && this.emit("data", n4), n4;
    }, _24.prototype._read = function(e4) {
      S2(this, new E2("_read()"));
    }, _24.prototype.pipe = function(e4, t4) {
      var r4 = this, n4 = this._readableState;
      switch (n4.pipesCount) {
        case 0:
          n4.pipes = e4;
          break;
        case 1:
          n4.pipes = [n4.pipes, e4];
          break;
        default:
          n4.pipes.push(e4);
      }
      n4.pipesCount += 1, i2("pipe count=%d opts=%j", n4.pipesCount, t4);
      var s3 = t4 && t4.end === false || e4 === process.stdout || e4 === process.stderr ? d3 : o2;
      function o2() {
        i2("onend"), e4.end();
      }
      n4.endEmitted ? process.nextTick(s3) : r4.once("end", s3), e4.on("unpipe", function t5(a7, s4) {
        i2("onunpipe"), a7 === r4 && s4 && s4.hasUnpiped === false && (s4.hasUnpiped = true, i2("cleanup"), e4.removeListener("close", f3), e4.removeListener("finish", p3), e4.removeListener("drain", u3), e4.removeListener("error", h3), e4.removeListener("unpipe", t5), r4.removeListener("end", o2), r4.removeListener("end", d3), r4.removeListener("data", l3), c3 = true, !n4.awaitDrain || e4._writableState && !e4._writableState.needDrain || u3());
      });
      var u3 = function(e5) {
        return function() {
          var t5 = e5._readableState;
          i2("pipeOnDrain", t5.awaitDrain), t5.awaitDrain && t5.awaitDrain--, t5.awaitDrain === 0 && a6(e5, "data") && (t5.flowing = true, O(e5));
        };
      }(r4);
      e4.on("drain", u3);
      var c3 = false;
      function l3(t5) {
        i2("ondata");
        var a7 = e4.write(t5);
        i2("dest.write", a7), a7 === false && ((n4.pipesCount === 1 && n4.pipes === e4 || n4.pipesCount > 1 && K2(n4.pipes, e4) !== -1) && !c3 && (i2("false write response, pause", n4.awaitDrain), n4.awaitDrain++), r4.pause());
      }
      function h3(t5) {
        i2("onerror", t5), d3(), e4.removeListener("error", h3), a6(e4, "error") === 0 && S2(e4, t5);
      }
      function f3() {
        e4.removeListener("finish", p3), d3();
      }
      function p3() {
        i2("onfinish"), e4.removeListener("close", f3), d3();
      }
      function d3() {
        i2("unpipe"), r4.unpipe(e4);
      }
      return r4.on("data", l3), function(e5, t5, r5) {
        if (typeof e5.prependListener == "function")
          return e5.prependListener(t5, r5);
        e5._events && e5._events.error ? Array.isArray(e5._events.error) ? e5._events.error.unshift(r5) : e5._events.error = [r5, e5._events.error] : e5.on(t5, r5);
      }(e4, "error", h3), e4.once("close", f3), e4.once("finish", p3), e4.emit("pipe", r4), n4.flowing || (i2("pipe resume"), r4.resume()), e4;
    }, _24.prototype.unpipe = function(e4) {
      var t4 = this._readableState, r4 = { hasUnpiped: false };
      if (t4.pipesCount === 0)
        return this;
      if (t4.pipesCount === 1)
        return e4 && e4 !== t4.pipes || (e4 || (e4 = t4.pipes), t4.pipes = null, t4.pipesCount = 0, t4.flowing = false, e4 && e4.emit("unpipe", this, r4)), this;
      if (!e4) {
        var n4 = t4.pipes, i3 = t4.pipesCount;
        t4.pipes = null, t4.pipesCount = 0, t4.flowing = false;
        for (var a7 = 0; a7 < i3; a7++)
          n4[a7].emit("unpipe", this, { hasUnpiped: false });
        return this;
      }
      var s3 = K2(t4.pipes, e4);
      return s3 === -1 || (t4.pipes.splice(s3, 1), t4.pipesCount -= 1, t4.pipesCount === 1 && (t4.pipes = t4.pipes[0]), e4.emit("unpipe", this, r4)), this;
    }, _24.prototype.on = function(e4, t4) {
      var r4 = s2.prototype.on.call(this, e4, t4), n4 = this._readableState;
      return e4 === "data" ? (n4.readableListening = this.listenerCount("readable") > 0, n4.flowing !== false && this.resume()) : e4 === "readable" && (n4.endEmitted || n4.readableListening || (n4.readableListening = n4.needReadable = true, n4.flowing = false, n4.emittedReadable = false, i2("on readable", n4.length, n4.reading), n4.length ? R(this) : n4.reading || process.nextTick(D2, this))), r4;
    }, _24.prototype.addListener = _24.prototype.on, _24.prototype.removeListener = function(e4, t4) {
      var r4 = s2.prototype.removeListener.call(this, e4, t4);
      return e4 === "readable" && process.nextTick(U2, this), r4;
    }, _24.prototype.removeAllListeners = function(e4) {
      var t4 = s2.prototype.removeAllListeners.apply(this, arguments);
      return e4 !== "readable" && e4 !== void 0 || process.nextTick(U2, this), t4;
    }, _24.prototype.resume = function() {
      var e4 = this._readableState;
      return e4.flowing || (i2("resume"), e4.flowing = !e4.readableListening, function(e5, t4) {
        t4.resumeScheduled || (t4.resumeScheduled = true, process.nextTick(P2, e5, t4));
      }(this, e4)), e4.paused = false, this;
    }, _24.prototype.pause = function() {
      return i2("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== false && (i2("pause"), this._readableState.flowing = false, this.emit("pause")), this._readableState.paused = true, this;
    }, _24.prototype.wrap = function(e4) {
      var t4 = this, r4 = this._readableState, n4 = false;
      for (var a7 in e4.on("end", function() {
        if (i2("wrapped end"), r4.decoder && !r4.ended) {
          var e5 = r4.decoder.end();
          e5 && e5.length && t4.push(e5);
        }
        t4.push(null);
      }), e4.on("data", function(a8) {
        i2("wrapped data"), r4.decoder && (a8 = r4.decoder.write(a8)), r4.objectMode && a8 == null || (r4.objectMode || a8 && a8.length) && (t4.push(a8) || (n4 = true, e4.pause()));
      }), e4)
        this[a7] === void 0 && typeof e4[a7] == "function" && (this[a7] = function(t5) {
          return function() {
            return e4[t5].apply(e4, arguments);
          };
        }(a7));
      for (var s3 = 0; s3 < b2.length; s3++)
        e4.on(b2[s3], this.emit.bind(this, b2[s3]));
      return this._read = function(t5) {
        i2("wrapped _read", t5), n4 && (n4 = false, e4.resume());
      }, this;
    }, typeof Symbol == "function" && (_24.prototype[Symbol.asyncIterator] = function() {
      return h2 === void 0 && (h2 = r3(1029)), h2(this);
    }), Object.defineProperty(_24.prototype, "readableHighWaterMark", { enumerable: false, get: function() {
      return this._readableState.highWaterMark;
    } }), Object.defineProperty(_24.prototype, "readableBuffer", { enumerable: false, get: function() {
      return this._readableState && this._readableState.buffer;
    } }), Object.defineProperty(_24.prototype, "readableFlowing", { enumerable: false, get: function() {
      return this._readableState.flowing;
    }, set: function(e4) {
      this._readableState && (this._readableState.flowing = e4);
    } }), _24._fromList = V2, Object.defineProperty(_24.prototype, "readableLength", { enumerable: false, get: function() {
      return this._readableState.length;
    } }), typeof Symbol == "function" && (_24.from = function(e4, t4) {
      return f2 === void 0 && (f2 = r3(352)), f2(_24, e4, t4);
    });
  }, 7640: (e3, t3, r3) => {
    e3.exports = l2;
    var n3 = r3(4452).q, i2 = n3.ERR_METHOD_NOT_IMPLEMENTED, a6 = n3.ERR_MULTIPLE_CALLBACK, s2 = n3.ERR_TRANSFORM_ALREADY_TRANSFORMING, o = n3.ERR_TRANSFORM_WITH_LENGTH_0, u2 = r3(7073);
    function c2(e4, t4) {
      var r4 = this._transformState;
      r4.transforming = false;
      var n4 = r4.writecb;
      if (n4 === null)
        return this.emit("error", new a6());
      r4.writechunk = null, r4.writecb = null, t4 != null && this.push(t4), n4(e4);
      var i3 = this._readableState;
      i3.reading = false, (i3.needReadable || i3.length < i3.highWaterMark) && this._read(i3.highWaterMark);
    }
    function l2(e4) {
      if (!(this instanceof l2))
        return new l2(e4);
      u2.call(this, e4), this._transformState = { afterTransform: c2.bind(this), needTransform: false, transforming: false, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = true, this._readableState.sync = false, e4 && (typeof e4.transform == "function" && (this._transform = e4.transform), typeof e4.flush == "function" && (this._flush = e4.flush)), this.on("prefinish", h2);
    }
    function h2() {
      var e4 = this;
      typeof this._flush != "function" || this._readableState.destroyed ? f2(this, null, null) : this._flush(function(t4, r4) {
        f2(e4, t4, r4);
      });
    }
    function f2(e4, t4, r4) {
      if (t4)
        return e4.emit("error", t4);
      if (r4 != null && e4.push(r4), e4._writableState.length)
        throw new o();
      if (e4._transformState.transforming)
        throw new s2();
      return e4.push(null);
    }
    r3(1285)(l2, u2), l2.prototype.push = function(e4, t4) {
      return this._transformState.needTransform = false, u2.prototype.push.call(this, e4, t4);
    }, l2.prototype._transform = function(e4, t4, r4) {
      r4(new i2("_transform()"));
    }, l2.prototype._write = function(e4, t4, r4) {
      var n4 = this._transformState;
      if (n4.writecb = r4, n4.writechunk = e4, n4.writeencoding = t4, !n4.transforming) {
        var i3 = this._readableState;
        (n4.needTransform || i3.needReadable || i3.length < i3.highWaterMark) && this._read(i3.highWaterMark);
      }
    }, l2.prototype._read = function(e4) {
      var t4 = this._transformState;
      t4.writechunk === null || t4.transforming ? t4.needTransform = true : (t4.transforming = true, this._transform(t4.writechunk, t4.writeencoding, t4.afterTransform));
    }, l2.prototype._destroy = function(e4, t4) {
      u2.prototype._destroy.call(this, e4, function(e5) {
        t4(e5);
      });
    };
  }, 2557: (e3, t3, r3) => {
    function n3(e4) {
      var t4 = this;
      this.next = null, this.entry = null, this.finish = function() {
        !function(e5, t5, r4) {
          var n4 = e5.entry;
          for (e5.entry = null; n4; ) {
            var i3 = n4.callback;
            t5.pendingcb--, i3(void 0), n4 = n4.next;
          }
          t5.corkedRequestsFree.next = e5;
        }(t4, e4);
      };
    }
    var i2;
    e3.exports = _24, _24.WritableState = T2;
    var a6, s2 = { deprecate: r3(5803) }, o = r3(5010), u2 = r3(8834).Buffer, c2 = r3.g.Uint8Array || function() {
    }, l2 = r3(2262), h2 = r3(7605).getHighWaterMark, f2 = r3(4452).q, p2 = f2.ERR_INVALID_ARG_TYPE, d2 = f2.ERR_METHOD_NOT_IMPLEMENTED, g2 = f2.ERR_MULTIPLE_CALLBACK, y2 = f2.ERR_STREAM_CANNOT_PIPE, v2 = f2.ERR_STREAM_DESTROYED, m2 = f2.ERR_STREAM_NULL_VALUES, E2 = f2.ERR_STREAM_WRITE_AFTER_END, C = f2.ERR_UNKNOWN_ENCODING, S2 = l2.errorOrDestroy;
    function b2() {
    }
    function T2(e4, t4, a7) {
      i2 = i2 || r3(7073), e4 = e4 || {}, typeof a7 != "boolean" && (a7 = t4 instanceof i2), this.objectMode = !!e4.objectMode, a7 && (this.objectMode = this.objectMode || !!e4.writableObjectMode), this.highWaterMark = h2(this, e4, "writableHighWaterMark", a7), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
      var s3 = e4.decodeStrings === false;
      this.decodeStrings = !s3, this.defaultEncoding = e4.defaultEncoding || "utf8", this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = function(e5) {
        !function(e6, t5) {
          var r4 = e6._writableState, n4 = r4.sync, i3 = r4.writecb;
          if (typeof i3 != "function")
            throw new g2();
          if (function(e7) {
            e7.writing = false, e7.writecb = null, e7.length -= e7.writelen, e7.writelen = 0;
          }(r4), t5)
            !function(e7, t6, r5, n5, i4) {
              --t6.pendingcb, r5 ? (process.nextTick(i4, n5), process.nextTick(N2, e7, t6), e7._writableState.errorEmitted = true, S2(e7, n5)) : (i4(n5), e7._writableState.errorEmitted = true, S2(e7, n5), N2(e7, t6));
            }(e6, r4, n4, t5, i3);
          else {
            var a8 = w2(r4) || e6.destroyed;
            a8 || r4.corked || r4.bufferProcessing || !r4.bufferedRequest || B2(e6, r4), n4 ? process.nextTick(A2, e6, r4, a8, i3) : A2(e6, r4, a8, i3);
          }
        }(t4, e5);
      }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = false, this.errorEmitted = false, this.emitClose = e4.emitClose !== false, this.autoDestroy = !!e4.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new n3(this);
    }
    function _24(e4) {
      var t4 = this instanceof (i2 = i2 || r3(7073));
      if (!t4 && !a6.call(_24, this))
        return new _24(e4);
      this._writableState = new T2(e4, this, t4), this.writable = true, e4 && (typeof e4.write == "function" && (this._write = e4.write), typeof e4.writev == "function" && (this._writev = e4.writev), typeof e4.destroy == "function" && (this._destroy = e4.destroy), typeof e4.final == "function" && (this._final = e4.final)), o.call(this);
    }
    function I2(e4, t4, r4, n4, i3, a7, s3) {
      t4.writelen = n4, t4.writecb = s3, t4.writing = true, t4.sync = true, t4.destroyed ? t4.onwrite(new v2("write")) : r4 ? e4._writev(i3, t4.onwrite) : e4._write(i3, a7, t4.onwrite), t4.sync = false;
    }
    function A2(e4, t4, r4, n4) {
      r4 || function(e5, t5) {
        t5.length === 0 && t5.needDrain && (t5.needDrain = false, e5.emit("drain"));
      }(e4, t4), t4.pendingcb--, n4(), N2(e4, t4);
    }
    function B2(e4, t4) {
      t4.bufferProcessing = true;
      var r4 = t4.bufferedRequest;
      if (e4._writev && r4 && r4.next) {
        var i3 = t4.bufferedRequestCount, a7 = new Array(i3), s3 = t4.corkedRequestsFree;
        s3.entry = r4;
        for (var o2 = 0, u3 = true; r4; )
          a7[o2] = r4, r4.isBuf || (u3 = false), r4 = r4.next, o2 += 1;
        a7.allBuffers = u3, I2(e4, t4, true, t4.length, a7, "", s3.finish), t4.pendingcb++, t4.lastBufferedRequest = null, s3.next ? (t4.corkedRequestsFree = s3.next, s3.next = null) : t4.corkedRequestsFree = new n3(t4), t4.bufferedRequestCount = 0;
      } else {
        for (; r4; ) {
          var c3 = r4.chunk, l3 = r4.encoding, h3 = r4.callback;
          if (I2(e4, t4, false, t4.objectMode ? 1 : c3.length, c3, l3, h3), r4 = r4.next, t4.bufferedRequestCount--, t4.writing)
            break;
        }
        r4 === null && (t4.lastBufferedRequest = null);
      }
      t4.bufferedRequest = r4, t4.bufferProcessing = false;
    }
    function w2(e4) {
      return e4.ending && e4.length === 0 && e4.bufferedRequest === null && !e4.finished && !e4.writing;
    }
    function R(e4, t4) {
      e4._final(function(r4) {
        t4.pendingcb--, r4 && S2(e4, r4), t4.prefinished = true, e4.emit("prefinish"), N2(e4, t4);
      });
    }
    function N2(e4, t4) {
      var r4 = w2(t4);
      if (r4 && (function(e5, t5) {
        t5.prefinished || t5.finalCalled || (typeof e5._final != "function" || t5.destroyed ? (t5.prefinished = true, e5.emit("prefinish")) : (t5.pendingcb++, t5.finalCalled = true, process.nextTick(R, e5, t5)));
      }(e4, t4), t4.pendingcb === 0 && (t4.finished = true, e4.emit("finish"), t4.autoDestroy))) {
        var n4 = e4._readableState;
        (!n4 || n4.autoDestroy && n4.endEmitted) && e4.destroy();
      }
      return r4;
    }
    r3(1285)(_24, o), T2.prototype.getBuffer = function() {
      for (var e4 = this.bufferedRequest, t4 = []; e4; )
        t4.push(e4), e4 = e4.next;
      return t4;
    }, function() {
      try {
        Object.defineProperty(T2.prototype, "buffer", { get: s2.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
      } catch (e4) {
      }
    }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (a6 = Function.prototype[Symbol.hasInstance], Object.defineProperty(_24, Symbol.hasInstance, { value: function(e4) {
      return !!a6.call(this, e4) || this === _24 && e4 && e4._writableState instanceof T2;
    } })) : a6 = function(e4) {
      return e4 instanceof this;
    }, _24.prototype.pipe = function() {
      S2(this, new y2());
    }, _24.prototype.write = function(e4, t4, r4) {
      var n4, i3 = this._writableState, a7 = false, s3 = !i3.objectMode && (n4 = e4, u2.isBuffer(n4) || n4 instanceof c2);
      return s3 && !u2.isBuffer(e4) && (e4 = function(e5) {
        return u2.from(e5);
      }(e4)), typeof t4 == "function" && (r4 = t4, t4 = null), s3 ? t4 = "buffer" : t4 || (t4 = i3.defaultEncoding), typeof r4 != "function" && (r4 = b2), i3.ending ? function(e5, t5) {
        var r5 = new E2();
        S2(e5, r5), process.nextTick(t5, r5);
      }(this, r4) : (s3 || function(e5, t5, r5, n5) {
        var i4;
        return r5 === null ? i4 = new m2() : typeof r5 == "string" || t5.objectMode || (i4 = new p2("chunk", ["string", "Buffer"], r5)), !i4 || (S2(e5, i4), process.nextTick(n5, i4), false);
      }(this, i3, e4, r4)) && (i3.pendingcb++, a7 = function(e5, t5, r5, n5, i4, a8) {
        if (!r5) {
          var s4 = function(e6, t6, r6) {
            return e6.objectMode || e6.decodeStrings === false || typeof t6 != "string" || (t6 = u2.from(t6, r6)), t6;
          }(t5, n5, i4);
          n5 !== s4 && (r5 = true, i4 = "buffer", n5 = s4);
        }
        var o2 = t5.objectMode ? 1 : n5.length;
        t5.length += o2;
        var c3 = t5.length < t5.highWaterMark;
        if (c3 || (t5.needDrain = true), t5.writing || t5.corked) {
          var l3 = t5.lastBufferedRequest;
          t5.lastBufferedRequest = { chunk: n5, encoding: i4, isBuf: r5, callback: a8, next: null }, l3 ? l3.next = t5.lastBufferedRequest : t5.bufferedRequest = t5.lastBufferedRequest, t5.bufferedRequestCount += 1;
        } else
          I2(e5, t5, false, o2, n5, i4, a8);
        return c3;
      }(this, i3, s3, e4, t4, r4)), a7;
    }, _24.prototype.cork = function() {
      this._writableState.corked++;
    }, _24.prototype.uncork = function() {
      var e4 = this._writableState;
      e4.corked && (e4.corked--, e4.writing || e4.corked || e4.bufferProcessing || !e4.bufferedRequest || B2(this, e4));
    }, _24.prototype.setDefaultEncoding = function(e4) {
      if (typeof e4 == "string" && (e4 = e4.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e4 + "").toLowerCase()) > -1))
        throw new C(e4);
      return this._writableState.defaultEncoding = e4, this;
    }, Object.defineProperty(_24.prototype, "writableBuffer", { enumerable: false, get: function() {
      return this._writableState && this._writableState.getBuffer();
    } }), Object.defineProperty(_24.prototype, "writableHighWaterMark", { enumerable: false, get: function() {
      return this._writableState.highWaterMark;
    } }), _24.prototype._write = function(e4, t4, r4) {
      r4(new d2("_write()"));
    }, _24.prototype._writev = null, _24.prototype.end = function(e4, t4, r4) {
      var n4 = this._writableState;
      return typeof e4 == "function" ? (r4 = e4, e4 = null, t4 = null) : typeof t4 == "function" && (r4 = t4, t4 = null), e4 != null && this.write(e4, t4), n4.corked && (n4.corked = 1, this.uncork()), n4.ending || function(e5, t5, r5) {
        t5.ending = true, N2(e5, t5), r5 && (t5.finished ? process.nextTick(r5) : e5.once("finish", r5)), t5.ended = true, e5.writable = false;
      }(this, n4, r4), this;
    }, Object.defineProperty(_24.prototype, "writableLength", { enumerable: false, get: function() {
      return this._writableState.length;
    } }), Object.defineProperty(_24.prototype, "destroyed", { enumerable: false, get: function() {
      return this._writableState !== void 0 && this._writableState.destroyed;
    }, set: function(e4) {
      this._writableState && (this._writableState.destroyed = e4);
    } }), _24.prototype.destroy = l2.destroy, _24.prototype._undestroy = l2.undestroy, _24.prototype._destroy = function(e4, t4) {
      t4(e4);
    };
  }, 1029: (e3, t3, r3) => {
    var n3;
    function i2(e4, t4, r4) {
      return t4 in e4 ? Object.defineProperty(e4, t4, { value: r4, enumerable: true, configurable: true, writable: true }) : e4[t4] = r4, e4;
    }
    var a6 = r3(9885), s2 = Symbol("lastResolve"), o = Symbol("lastReject"), u2 = Symbol("error"), c2 = Symbol("ended"), l2 = Symbol("lastPromise"), h2 = Symbol("handlePromise"), f2 = Symbol("stream");
    function p2(e4, t4) {
      return { value: e4, done: t4 };
    }
    function d2(e4) {
      var t4 = e4[s2];
      if (t4 !== null) {
        var r4 = e4[f2].read();
        r4 !== null && (e4[l2] = null, e4[s2] = null, e4[o] = null, t4(p2(r4, false)));
      }
    }
    function g2(e4) {
      process.nextTick(d2, e4);
    }
    var y2 = Object.getPrototypeOf(function() {
    }), v2 = Object.setPrototypeOf((i2(n3 = { get stream() {
      return this[f2];
    }, next: function() {
      var e4 = this, t4 = this[u2];
      if (t4 !== null)
        return Promise.reject(t4);
      if (this[c2])
        return Promise.resolve(p2(void 0, true));
      if (this[f2].destroyed)
        return new Promise(function(t5, r5) {
          process.nextTick(function() {
            e4[u2] ? r5(e4[u2]) : t5(p2(void 0, true));
          });
        });
      var r4, n4 = this[l2];
      if (n4)
        r4 = new Promise(function(e5, t5) {
          return function(r5, n5) {
            e5.then(function() {
              t5[c2] ? r5(p2(void 0, true)) : t5[h2](r5, n5);
            }, n5);
          };
        }(n4, this));
      else {
        var i3 = this[f2].read();
        if (i3 !== null)
          return Promise.resolve(p2(i3, false));
        r4 = new Promise(this[h2]);
      }
      return this[l2] = r4, r4;
    } }, Symbol.asyncIterator, function() {
      return this;
    }), i2(n3, "return", function() {
      var e4 = this;
      return new Promise(function(t4, r4) {
        e4[f2].destroy(null, function(e5) {
          e5 ? r4(e5) : t4(p2(void 0, true));
        });
      });
    }), n3), y2);
    e3.exports = function(e4) {
      var t4, r4 = Object.create(v2, (i2(t4 = {}, f2, { value: e4, writable: true }), i2(t4, s2, { value: null, writable: true }), i2(t4, o, { value: null, writable: true }), i2(t4, u2, { value: null, writable: true }), i2(t4, c2, { value: e4._readableState.endEmitted, writable: true }), i2(t4, h2, { value: function(e5, t5) {
        var n4 = r4[f2].read();
        n4 ? (r4[l2] = null, r4[s2] = null, r4[o] = null, e5(p2(n4, false))) : (r4[s2] = e5, r4[o] = t5);
      }, writable: true }), t4));
      return r4[l2] = null, a6(e4, function(e5) {
        if (e5 && e5.code !== "ERR_STREAM_PREMATURE_CLOSE") {
          var t5 = r4[o];
          return t5 !== null && (r4[l2] = null, r4[s2] = null, r4[o] = null, t5(e5)), void (r4[u2] = e5);
        }
        var n4 = r4[s2];
        n4 !== null && (r4[l2] = null, r4[s2] = null, r4[o] = null, n4(p2(void 0, true))), r4[c2] = true;
      }), e4.on("readable", g2.bind(null, r4)), r4;
    };
  }, 6637: (e3, t3, r3) => {
    function n3(e4, t4) {
      var r4 = Object.keys(e4);
      if (Object.getOwnPropertySymbols) {
        var n4 = Object.getOwnPropertySymbols(e4);
        t4 && (n4 = n4.filter(function(t5) {
          return Object.getOwnPropertyDescriptor(e4, t5).enumerable;
        })), r4.push.apply(r4, n4);
      }
      return r4;
    }
    function i2(e4, t4, r4) {
      return t4 in e4 ? Object.defineProperty(e4, t4, { value: r4, enumerable: true, configurable: true, writable: true }) : e4[t4] = r4, e4;
    }
    function a6(e4, t4) {
      for (var r4 = 0; r4 < t4.length; r4++) {
        var n4 = t4[r4];
        n4.enumerable = n4.enumerable || false, n4.configurable = true, "value" in n4 && (n4.writable = true), Object.defineProperty(e4, n4.key, n4);
      }
    }
    var s2 = r3(8834).Buffer, o = r3(4854).inspect, u2 = o && o.custom || "inspect";
    e3.exports = function() {
      function e4() {
        !function(e5, t5) {
          if (!(e5 instanceof t5))
            throw new TypeError("Cannot call a class as a function");
        }(this, e4), this.head = null, this.tail = null, this.length = 0;
      }
      var t4, r4;
      return t4 = e4, r4 = [{ key: "push", value: function(e5) {
        var t5 = { data: e5, next: null };
        this.length > 0 ? this.tail.next = t5 : this.head = t5, this.tail = t5, ++this.length;
      } }, { key: "unshift", value: function(e5) {
        var t5 = { data: e5, next: this.head };
        this.length === 0 && (this.tail = t5), this.head = t5, ++this.length;
      } }, { key: "shift", value: function() {
        if (this.length !== 0) {
          var e5 = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e5;
        }
      } }, { key: "clear", value: function() {
        this.head = this.tail = null, this.length = 0;
      } }, { key: "join", value: function(e5) {
        if (this.length === 0)
          return "";
        for (var t5 = this.head, r5 = "" + t5.data; t5 = t5.next; )
          r5 += e5 + t5.data;
        return r5;
      } }, { key: "concat", value: function(e5) {
        if (this.length === 0)
          return s2.alloc(0);
        for (var t5, r5, n4, i3 = s2.allocUnsafe(e5 >>> 0), a7 = this.head, o2 = 0; a7; )
          t5 = a7.data, r5 = i3, n4 = o2, s2.prototype.copy.call(t5, r5, n4), o2 += a7.data.length, a7 = a7.next;
        return i3;
      } }, { key: "consume", value: function(e5, t5) {
        var r5;
        return e5 < this.head.data.length ? (r5 = this.head.data.slice(0, e5), this.head.data = this.head.data.slice(e5)) : r5 = e5 === this.head.data.length ? this.shift() : t5 ? this._getString(e5) : this._getBuffer(e5), r5;
      } }, { key: "first", value: function() {
        return this.head.data;
      } }, { key: "_getString", value: function(e5) {
        var t5 = this.head, r5 = 1, n4 = t5.data;
        for (e5 -= n4.length; t5 = t5.next; ) {
          var i3 = t5.data, a7 = e5 > i3.length ? i3.length : e5;
          if (a7 === i3.length ? n4 += i3 : n4 += i3.slice(0, e5), (e5 -= a7) == 0) {
            a7 === i3.length ? (++r5, t5.next ? this.head = t5.next : this.head = this.tail = null) : (this.head = t5, t5.data = i3.slice(a7));
            break;
          }
          ++r5;
        }
        return this.length -= r5, n4;
      } }, { key: "_getBuffer", value: function(e5) {
        var t5 = s2.allocUnsafe(e5), r5 = this.head, n4 = 1;
        for (r5.data.copy(t5), e5 -= r5.data.length; r5 = r5.next; ) {
          var i3 = r5.data, a7 = e5 > i3.length ? i3.length : e5;
          if (i3.copy(t5, t5.length - e5, 0, a7), (e5 -= a7) == 0) {
            a7 === i3.length ? (++n4, r5.next ? this.head = r5.next : this.head = this.tail = null) : (this.head = r5, r5.data = i3.slice(a7));
            break;
          }
          ++n4;
        }
        return this.length -= n4, t5;
      } }, { key: u2, value: function(e5, t5) {
        return o(this, function(e6) {
          for (var t6 = 1; t6 < arguments.length; t6++) {
            var r5 = arguments[t6] != null ? arguments[t6] : {};
            t6 % 2 ? n3(Object(r5), true).forEach(function(t7) {
              i2(e6, t7, r5[t7]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e6, Object.getOwnPropertyDescriptors(r5)) : n3(Object(r5)).forEach(function(t7) {
              Object.defineProperty(e6, t7, Object.getOwnPropertyDescriptor(r5, t7));
            });
          }
          return e6;
        }({}, t5, { depth: 0, customInspect: false }));
      } }], r4 && a6(t4.prototype, r4), e4;
    }();
  }, 2262: (e3) => {
    function t3(e4, t4) {
      n3(e4, t4), r3(e4);
    }
    function r3(e4) {
      e4._writableState && !e4._writableState.emitClose || e4._readableState && !e4._readableState.emitClose || e4.emit("close");
    }
    function n3(e4, t4) {
      e4.emit("error", t4);
    }
    e3.exports = { destroy: function(e4, i2) {
      var a6 = this, s2 = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
      return s2 || o ? (i2 ? i2(e4) : e4 && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = true, process.nextTick(n3, this, e4)) : process.nextTick(n3, this, e4)), this) : (this._readableState && (this._readableState.destroyed = true), this._writableState && (this._writableState.destroyed = true), this._destroy(e4 || null, function(e5) {
        !i2 && e5 ? a6._writableState ? a6._writableState.errorEmitted ? process.nextTick(r3, a6) : (a6._writableState.errorEmitted = true, process.nextTick(t3, a6, e5)) : process.nextTick(t3, a6, e5) : i2 ? (process.nextTick(r3, a6), i2(e5)) : process.nextTick(r3, a6);
      }), this);
    }, undestroy: function() {
      this._readableState && (this._readableState.destroyed = false, this._readableState.reading = false, this._readableState.ended = false, this._readableState.endEmitted = false), this._writableState && (this._writableState.destroyed = false, this._writableState.ended = false, this._writableState.ending = false, this._writableState.finalCalled = false, this._writableState.prefinished = false, this._writableState.finished = false, this._writableState.errorEmitted = false);
    }, errorOrDestroy: function(e4, t4) {
      var r4 = e4._readableState, n4 = e4._writableState;
      r4 && r4.autoDestroy || n4 && n4.autoDestroy ? e4.destroy(t4) : e4.emit("error", t4);
    } };
  }, 9885: (e3, t3, r3) => {
    var n3 = r3(4452).q.ERR_STREAM_PREMATURE_CLOSE;
    function i2() {
    }
    e3.exports = function e4(t4, r4, a6) {
      if (typeof r4 == "function")
        return e4(t4, null, r4);
      r4 || (r4 = {}), a6 = function(e5) {
        var t5 = false;
        return function() {
          if (!t5) {
            t5 = true;
            for (var r5 = arguments.length, n4 = new Array(r5), i3 = 0; i3 < r5; i3++)
              n4[i3] = arguments[i3];
            e5.apply(this, n4);
          }
        };
      }(a6 || i2);
      var s2 = r4.readable || r4.readable !== false && t4.readable, o = r4.writable || r4.writable !== false && t4.writable, u2 = function() {
        t4.writable || l2();
      }, c2 = t4._writableState && t4._writableState.finished, l2 = function() {
        o = false, c2 = true, s2 || a6.call(t4);
      }, h2 = t4._readableState && t4._readableState.endEmitted, f2 = function() {
        s2 = false, h2 = true, o || a6.call(t4);
      }, p2 = function(e5) {
        a6.call(t4, e5);
      }, d2 = function() {
        var e5;
        return s2 && !h2 ? (t4._readableState && t4._readableState.ended || (e5 = new n3()), a6.call(t4, e5)) : o && !c2 ? (t4._writableState && t4._writableState.ended || (e5 = new n3()), a6.call(t4, e5)) : void 0;
      }, g2 = function() {
        t4.req.on("finish", l2);
      };
      return function(e5) {
        return e5.setHeader && typeof e5.abort == "function";
      }(t4) ? (t4.on("complete", l2), t4.on("abort", d2), t4.req ? g2() : t4.on("request", g2)) : o && !t4._writableState && (t4.on("end", u2), t4.on("close", u2)), t4.on("end", f2), t4.on("finish", l2), r4.error !== false && t4.on("error", p2), t4.on("close", d2), function() {
        t4.removeListener("complete", l2), t4.removeListener("abort", d2), t4.removeListener("request", g2), t4.req && t4.req.removeListener("finish", l2), t4.removeListener("end", u2), t4.removeListener("close", u2), t4.removeListener("finish", l2), t4.removeListener("end", f2), t4.removeListener("error", p2), t4.removeListener("close", d2);
      };
    };
  }, 352: (e3) => {
    e3.exports = function() {
      throw new Error("Readable.from is not available in the browser");
    };
  }, 3495: (e3, t3, r3) => {
    var n3, i2 = r3(4452).q, a6 = i2.ERR_MISSING_ARGS, s2 = i2.ERR_STREAM_DESTROYED;
    function o(e4) {
      if (e4)
        throw e4;
    }
    function u2(e4, t4, i3, a7) {
      a7 = function(e5) {
        var t5 = false;
        return function() {
          t5 || (t5 = true, e5.apply(void 0, arguments));
        };
      }(a7);
      var o2 = false;
      e4.on("close", function() {
        o2 = true;
      }), n3 === void 0 && (n3 = r3(9885)), n3(e4, { readable: t4, writable: i3 }, function(e5) {
        if (e5)
          return a7(e5);
        o2 = true, a7();
      });
      var u3 = false;
      return function(t5) {
        if (!o2 && !u3)
          return u3 = true, function(e5) {
            return e5.setHeader && typeof e5.abort == "function";
          }(e4) ? e4.abort() : typeof e4.destroy == "function" ? e4.destroy() : void a7(t5 || new s2("pipe"));
      };
    }
    function c2(e4) {
      e4();
    }
    function l2(e4, t4) {
      return e4.pipe(t4);
    }
    function h2(e4) {
      return e4.length ? typeof e4[e4.length - 1] != "function" ? o : e4.pop() : o;
    }
    e3.exports = function() {
      for (var e4 = arguments.length, t4 = new Array(e4), r4 = 0; r4 < e4; r4++)
        t4[r4] = arguments[r4];
      var n4, i3 = h2(t4);
      if (Array.isArray(t4[0]) && (t4 = t4[0]), t4.length < 2)
        throw new a6("streams");
      var s3 = t4.map(function(e5, r5) {
        var a7 = r5 < t4.length - 1;
        return u2(e5, a7, r5 > 0, function(e6) {
          n4 || (n4 = e6), e6 && s3.forEach(c2), a7 || (s3.forEach(c2), i3(n4));
        });
      });
      return t4.reduce(l2);
    };
  }, 7605: (e3, t3, r3) => {
    var n3 = r3(4452).q.ERR_INVALID_OPT_VALUE;
    e3.exports = { getHighWaterMark: function(e4, t4, r4, i2) {
      var a6 = function(e5, t5, r5) {
        return e5.highWaterMark != null ? e5.highWaterMark : t5 ? e5[r5] : null;
      }(t4, i2, r4);
      if (a6 != null) {
        if (!isFinite(a6) || Math.floor(a6) !== a6 || a6 < 0)
          throw new n3(i2 ? r4 : "highWaterMark", a6);
        return Math.floor(a6);
      }
      return e4.objectMode ? 16 : 16384;
    } };
  }, 5010: (e3, t3, r3) => {
    e3.exports = r3(2699).EventEmitter;
  }, 7525: (e3, t3, r3) => {
    (t3 = e3.exports = r3(8051)).Stream = t3, t3.Readable = t3, t3.Writable = r3(2557), t3.Duplex = r3(7073), t3.Transform = r3(7640), t3.PassThrough = r3(5163), t3.finished = r3(9885), t3.pipeline = r3(3495);
  }, 1445: (e3, t3, r3) => {
    var n3 = r3(8834).Buffer, i2 = r3(1285), a6 = r3(4485), s2 = new Array(16), o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13], u2 = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11], c2 = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6], l2 = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11], h2 = [0, 1518500249, 1859775393, 2400959708, 2840853838], f2 = [1352829926, 1548603684, 1836072691, 2053994217, 0];
    function p2() {
      a6.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
    }
    function d2(e4, t4) {
      return e4 << t4 | e4 >>> 32 - t4;
    }
    function g2(e4, t4, r4, n4, i3, a7, s3, o2) {
      return d2(e4 + (t4 ^ r4 ^ n4) + a7 + s3 | 0, o2) + i3 | 0;
    }
    function y2(e4, t4, r4, n4, i3, a7, s3, o2) {
      return d2(e4 + (t4 & r4 | ~t4 & n4) + a7 + s3 | 0, o2) + i3 | 0;
    }
    function v2(e4, t4, r4, n4, i3, a7, s3, o2) {
      return d2(e4 + ((t4 | ~r4) ^ n4) + a7 + s3 | 0, o2) + i3 | 0;
    }
    function m2(e4, t4, r4, n4, i3, a7, s3, o2) {
      return d2(e4 + (t4 & n4 | r4 & ~n4) + a7 + s3 | 0, o2) + i3 | 0;
    }
    function E2(e4, t4, r4, n4, i3, a7, s3, o2) {
      return d2(e4 + (t4 ^ (r4 | ~n4)) + a7 + s3 | 0, o2) + i3 | 0;
    }
    i2(p2, a6), p2.prototype._update = function() {
      for (var e4 = s2, t4 = 0; t4 < 16; ++t4)
        e4[t4] = this._block.readInt32LE(4 * t4);
      for (var r4 = 0 | this._a, n4 = 0 | this._b, i3 = 0 | this._c, a7 = 0 | this._d, p3 = 0 | this._e, C = 0 | this._a, S2 = 0 | this._b, b2 = 0 | this._c, T2 = 0 | this._d, _24 = 0 | this._e, I2 = 0; I2 < 80; I2 += 1) {
        var A2, B2;
        I2 < 16 ? (A2 = g2(r4, n4, i3, a7, p3, e4[o[I2]], h2[0], c2[I2]), B2 = E2(C, S2, b2, T2, _24, e4[u2[I2]], f2[0], l2[I2])) : I2 < 32 ? (A2 = y2(r4, n4, i3, a7, p3, e4[o[I2]], h2[1], c2[I2]), B2 = m2(C, S2, b2, T2, _24, e4[u2[I2]], f2[1], l2[I2])) : I2 < 48 ? (A2 = v2(r4, n4, i3, a7, p3, e4[o[I2]], h2[2], c2[I2]), B2 = v2(C, S2, b2, T2, _24, e4[u2[I2]], f2[2], l2[I2])) : I2 < 64 ? (A2 = m2(r4, n4, i3, a7, p3, e4[o[I2]], h2[3], c2[I2]), B2 = y2(C, S2, b2, T2, _24, e4[u2[I2]], f2[3], l2[I2])) : (A2 = E2(r4, n4, i3, a7, p3, e4[o[I2]], h2[4], c2[I2]), B2 = g2(C, S2, b2, T2, _24, e4[u2[I2]], f2[4], l2[I2])), r4 = p3, p3 = a7, a7 = d2(i3, 10), i3 = n4, n4 = A2, C = _24, _24 = T2, T2 = d2(b2, 10), b2 = S2, S2 = B2;
      }
      var w2 = this._b + i3 + T2 | 0;
      this._b = this._c + a7 + _24 | 0, this._c = this._d + p3 + C | 0, this._d = this._e + r4 + S2 | 0, this._e = this._a + n4 + b2 | 0, this._a = w2;
    }, p2.prototype._digest = function() {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var e4 = n3.alloc ? n3.alloc(20) : new n3(20);
      return e4.writeInt32LE(this._a, 0), e4.writeInt32LE(this._b, 4), e4.writeInt32LE(this._c, 8), e4.writeInt32LE(this._d, 12), e4.writeInt32LE(this._e, 16), e4;
    }, e3.exports = p2;
  }, 7834: (e3, t3, r3) => {
    var n3 = r3(8834), i2 = n3.Buffer;
    function a6(e4, t4) {
      for (var r4 in e4)
        t4[r4] = e4[r4];
    }
    function s2(e4, t4, r4) {
      return i2(e4, t4, r4);
    }
    i2.from && i2.alloc && i2.allocUnsafe && i2.allocUnsafeSlow ? e3.exports = n3 : (a6(n3, t3), t3.Buffer = s2), s2.prototype = Object.create(i2.prototype), a6(i2, s2), s2.from = function(e4, t4, r4) {
      if (typeof e4 == "number")
        throw new TypeError("Argument must not be a number");
      return i2(e4, t4, r4);
    }, s2.alloc = function(e4, t4, r4) {
      if (typeof e4 != "number")
        throw new TypeError("Argument must be a number");
      var n4 = i2(e4);
      return t4 !== void 0 ? typeof r4 == "string" ? n4.fill(t4, r4) : n4.fill(t4) : n4.fill(0), n4;
    }, s2.allocUnsafe = function(e4) {
      if (typeof e4 != "number")
        throw new TypeError("Argument must be a number");
      return i2(e4);
    }, s2.allocUnsafeSlow = function(e4) {
      if (typeof e4 != "number")
        throw new TypeError("Argument must be a number");
      return n3.SlowBuffer(e4);
    };
  }, 3327: (e3, t3, r3) => {
    var n3 = r3(7834).Buffer;
    function i2(e4, t4) {
      this._block = n3.alloc(e4), this._finalSize = t4, this._blockSize = e4, this._len = 0;
    }
    i2.prototype.update = function(e4, t4) {
      typeof e4 == "string" && (t4 = t4 || "utf8", e4 = n3.from(e4, t4));
      for (var r4 = this._block, i3 = this._blockSize, a6 = e4.length, s2 = this._len, o = 0; o < a6; ) {
        for (var u2 = s2 % i3, c2 = Math.min(a6 - o, i3 - u2), l2 = 0; l2 < c2; l2++)
          r4[u2 + l2] = e4[o + l2];
        o += c2, (s2 += c2) % i3 == 0 && this._update(r4);
      }
      return this._len += a6, this;
    }, i2.prototype.digest = function(e4) {
      var t4 = this._len % this._blockSize;
      this._block[t4] = 128, this._block.fill(0, t4 + 1), t4 >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var r4 = 8 * this._len;
      if (r4 <= 4294967295)
        this._block.writeUInt32BE(r4, this._blockSize - 4);
      else {
        var n4 = (4294967295 & r4) >>> 0, i3 = (r4 - n4) / 4294967296;
        this._block.writeUInt32BE(i3, this._blockSize - 8), this._block.writeUInt32BE(n4, this._blockSize - 4);
      }
      this._update(this._block);
      var a6 = this._hash();
      return e4 ? a6.toString(e4) : a6;
    }, i2.prototype._update = function() {
      throw new Error("_update must be implemented by subclass");
    }, e3.exports = i2;
  }, 9065: (e3, t3, r3) => {
    var n3 = e3.exports = function(e4) {
      e4 = e4.toLowerCase();
      var t4 = n3[e4];
      if (!t4)
        throw new Error(e4 + " is not supported (we accept pull requests)");
      return new t4();
    };
    n3.sha = r3(8820), n3.sha1 = r3(7885), n3.sha224 = r3(8321), n3.sha256 = r3(4424), n3.sha384 = r3(213), n3.sha512 = r3(5596);
  }, 8820: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(3327), a6 = r3(7834).Buffer, s2 = [1518500249, 1859775393, -1894007588, -899497514], o = new Array(80);
    function u2() {
      this.init(), this._w = o, i2.call(this, 64, 56);
    }
    function c2(e4) {
      return e4 << 30 | e4 >>> 2;
    }
    function l2(e4, t4, r4, n4) {
      return e4 === 0 ? t4 & r4 | ~t4 & n4 : e4 === 2 ? t4 & r4 | t4 & n4 | r4 & n4 : t4 ^ r4 ^ n4;
    }
    n3(u2, i2), u2.prototype.init = function() {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, u2.prototype._update = function(e4) {
      for (var t4, r4 = this._w, n4 = 0 | this._a, i3 = 0 | this._b, a7 = 0 | this._c, o2 = 0 | this._d, u3 = 0 | this._e, h2 = 0; h2 < 16; ++h2)
        r4[h2] = e4.readInt32BE(4 * h2);
      for (; h2 < 80; ++h2)
        r4[h2] = r4[h2 - 3] ^ r4[h2 - 8] ^ r4[h2 - 14] ^ r4[h2 - 16];
      for (var f2 = 0; f2 < 80; ++f2) {
        var p2 = ~~(f2 / 20), d2 = 0 | ((t4 = n4) << 5 | t4 >>> 27) + l2(p2, i3, a7, o2) + u3 + r4[f2] + s2[p2];
        u3 = o2, o2 = a7, a7 = c2(i3), i3 = n4, n4 = d2;
      }
      this._a = n4 + this._a | 0, this._b = i3 + this._b | 0, this._c = a7 + this._c | 0, this._d = o2 + this._d | 0, this._e = u3 + this._e | 0;
    }, u2.prototype._hash = function() {
      var e4 = a6.allocUnsafe(20);
      return e4.writeInt32BE(0 | this._a, 0), e4.writeInt32BE(0 | this._b, 4), e4.writeInt32BE(0 | this._c, 8), e4.writeInt32BE(0 | this._d, 12), e4.writeInt32BE(0 | this._e, 16), e4;
    }, e3.exports = u2;
  }, 7885: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(3327), a6 = r3(7834).Buffer, s2 = [1518500249, 1859775393, -1894007588, -899497514], o = new Array(80);
    function u2() {
      this.init(), this._w = o, i2.call(this, 64, 56);
    }
    function c2(e4) {
      return e4 << 5 | e4 >>> 27;
    }
    function l2(e4) {
      return e4 << 30 | e4 >>> 2;
    }
    function h2(e4, t4, r4, n4) {
      return e4 === 0 ? t4 & r4 | ~t4 & n4 : e4 === 2 ? t4 & r4 | t4 & n4 | r4 & n4 : t4 ^ r4 ^ n4;
    }
    n3(u2, i2), u2.prototype.init = function() {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, u2.prototype._update = function(e4) {
      for (var t4, r4 = this._w, n4 = 0 | this._a, i3 = 0 | this._b, a7 = 0 | this._c, o2 = 0 | this._d, u3 = 0 | this._e, f2 = 0; f2 < 16; ++f2)
        r4[f2] = e4.readInt32BE(4 * f2);
      for (; f2 < 80; ++f2)
        r4[f2] = (t4 = r4[f2 - 3] ^ r4[f2 - 8] ^ r4[f2 - 14] ^ r4[f2 - 16]) << 1 | t4 >>> 31;
      for (var p2 = 0; p2 < 80; ++p2) {
        var d2 = ~~(p2 / 20), g2 = c2(n4) + h2(d2, i3, a7, o2) + u3 + r4[p2] + s2[d2] | 0;
        u3 = o2, o2 = a7, a7 = l2(i3), i3 = n4, n4 = g2;
      }
      this._a = n4 + this._a | 0, this._b = i3 + this._b | 0, this._c = a7 + this._c | 0, this._d = o2 + this._d | 0, this._e = u3 + this._e | 0;
    }, u2.prototype._hash = function() {
      var e4 = a6.allocUnsafe(20);
      return e4.writeInt32BE(0 | this._a, 0), e4.writeInt32BE(0 | this._b, 4), e4.writeInt32BE(0 | this._c, 8), e4.writeInt32BE(0 | this._d, 12), e4.writeInt32BE(0 | this._e, 16), e4;
    }, e3.exports = u2;
  }, 8321: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(4424), a6 = r3(3327), s2 = r3(7834).Buffer, o = new Array(64);
    function u2() {
      this.init(), this._w = o, a6.call(this, 64, 56);
    }
    n3(u2, i2), u2.prototype.init = function() {
      return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
    }, u2.prototype._hash = function() {
      var e4 = s2.allocUnsafe(28);
      return e4.writeInt32BE(this._a, 0), e4.writeInt32BE(this._b, 4), e4.writeInt32BE(this._c, 8), e4.writeInt32BE(this._d, 12), e4.writeInt32BE(this._e, 16), e4.writeInt32BE(this._f, 20), e4.writeInt32BE(this._g, 24), e4;
    }, e3.exports = u2;
  }, 4424: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(3327), a6 = r3(7834).Buffer, s2 = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], o = new Array(64);
    function u2() {
      this.init(), this._w = o, i2.call(this, 64, 56);
    }
    function c2(e4, t4, r4) {
      return r4 ^ e4 & (t4 ^ r4);
    }
    function l2(e4, t4, r4) {
      return e4 & t4 | r4 & (e4 | t4);
    }
    function h2(e4) {
      return (e4 >>> 2 | e4 << 30) ^ (e4 >>> 13 | e4 << 19) ^ (e4 >>> 22 | e4 << 10);
    }
    function f2(e4) {
      return (e4 >>> 6 | e4 << 26) ^ (e4 >>> 11 | e4 << 21) ^ (e4 >>> 25 | e4 << 7);
    }
    function p2(e4) {
      return (e4 >>> 7 | e4 << 25) ^ (e4 >>> 18 | e4 << 14) ^ e4 >>> 3;
    }
    n3(u2, i2), u2.prototype.init = function() {
      return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
    }, u2.prototype._update = function(e4) {
      for (var t4, r4 = this._w, n4 = 0 | this._a, i3 = 0 | this._b, a7 = 0 | this._c, o2 = 0 | this._d, u3 = 0 | this._e, d2 = 0 | this._f, g2 = 0 | this._g, y2 = 0 | this._h, v2 = 0; v2 < 16; ++v2)
        r4[v2] = e4.readInt32BE(4 * v2);
      for (; v2 < 64; ++v2)
        r4[v2] = 0 | (((t4 = r4[v2 - 2]) >>> 17 | t4 << 15) ^ (t4 >>> 19 | t4 << 13) ^ t4 >>> 10) + r4[v2 - 7] + p2(r4[v2 - 15]) + r4[v2 - 16];
      for (var m2 = 0; m2 < 64; ++m2) {
        var E2 = y2 + f2(u3) + c2(u3, d2, g2) + s2[m2] + r4[m2] | 0, C = h2(n4) + l2(n4, i3, a7) | 0;
        y2 = g2, g2 = d2, d2 = u3, u3 = o2 + E2 | 0, o2 = a7, a7 = i3, i3 = n4, n4 = E2 + C | 0;
      }
      this._a = n4 + this._a | 0, this._b = i3 + this._b | 0, this._c = a7 + this._c | 0, this._d = o2 + this._d | 0, this._e = u3 + this._e | 0, this._f = d2 + this._f | 0, this._g = g2 + this._g | 0, this._h = y2 + this._h | 0;
    }, u2.prototype._hash = function() {
      var e4 = a6.allocUnsafe(32);
      return e4.writeInt32BE(this._a, 0), e4.writeInt32BE(this._b, 4), e4.writeInt32BE(this._c, 8), e4.writeInt32BE(this._d, 12), e4.writeInt32BE(this._e, 16), e4.writeInt32BE(this._f, 20), e4.writeInt32BE(this._g, 24), e4.writeInt32BE(this._h, 28), e4;
    }, e3.exports = u2;
  }, 213: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(5596), a6 = r3(3327), s2 = r3(7834).Buffer, o = new Array(160);
    function u2() {
      this.init(), this._w = o, a6.call(this, 128, 112);
    }
    n3(u2, i2), u2.prototype.init = function() {
      return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
    }, u2.prototype._hash = function() {
      var e4 = s2.allocUnsafe(48);
      function t4(t5, r4, n4) {
        e4.writeInt32BE(t5, n4), e4.writeInt32BE(r4, n4 + 4);
      }
      return t4(this._ah, this._al, 0), t4(this._bh, this._bl, 8), t4(this._ch, this._cl, 16), t4(this._dh, this._dl, 24), t4(this._eh, this._el, 32), t4(this._fh, this._fl, 40), e4;
    }, e3.exports = u2;
  }, 5596: (e3, t3, r3) => {
    var n3 = r3(1285), i2 = r3(3327), a6 = r3(7834).Buffer, s2 = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591], o = new Array(160);
    function u2() {
      this.init(), this._w = o, i2.call(this, 128, 112);
    }
    function c2(e4, t4, r4) {
      return r4 ^ e4 & (t4 ^ r4);
    }
    function l2(e4, t4, r4) {
      return e4 & t4 | r4 & (e4 | t4);
    }
    function h2(e4, t4) {
      return (e4 >>> 28 | t4 << 4) ^ (t4 >>> 2 | e4 << 30) ^ (t4 >>> 7 | e4 << 25);
    }
    function f2(e4, t4) {
      return (e4 >>> 14 | t4 << 18) ^ (e4 >>> 18 | t4 << 14) ^ (t4 >>> 9 | e4 << 23);
    }
    function p2(e4, t4) {
      return (e4 >>> 1 | t4 << 31) ^ (e4 >>> 8 | t4 << 24) ^ e4 >>> 7;
    }
    function d2(e4, t4) {
      return (e4 >>> 1 | t4 << 31) ^ (e4 >>> 8 | t4 << 24) ^ (e4 >>> 7 | t4 << 25);
    }
    function g2(e4, t4) {
      return (e4 >>> 19 | t4 << 13) ^ (t4 >>> 29 | e4 << 3) ^ e4 >>> 6;
    }
    function y2(e4, t4) {
      return (e4 >>> 19 | t4 << 13) ^ (t4 >>> 29 | e4 << 3) ^ (e4 >>> 6 | t4 << 26);
    }
    function v2(e4, t4) {
      return e4 >>> 0 < t4 >>> 0 ? 1 : 0;
    }
    n3(u2, i2), u2.prototype.init = function() {
      return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
    }, u2.prototype._update = function(e4) {
      for (var t4 = this._w, r4 = 0 | this._ah, n4 = 0 | this._bh, i3 = 0 | this._ch, a7 = 0 | this._dh, o2 = 0 | this._eh, u3 = 0 | this._fh, m2 = 0 | this._gh, E2 = 0 | this._hh, C = 0 | this._al, S2 = 0 | this._bl, b2 = 0 | this._cl, T2 = 0 | this._dl, _24 = 0 | this._el, I2 = 0 | this._fl, A2 = 0 | this._gl, B2 = 0 | this._hl, w2 = 0; w2 < 32; w2 += 2)
        t4[w2] = e4.readInt32BE(4 * w2), t4[w2 + 1] = e4.readInt32BE(4 * w2 + 4);
      for (; w2 < 160; w2 += 2) {
        var R = t4[w2 - 30], N2 = t4[w2 - 30 + 1], L2 = p2(R, N2), k3 = d2(N2, R), U2 = g2(R = t4[w2 - 4], N2 = t4[w2 - 4 + 1]), D2 = y2(N2, R), P2 = t4[w2 - 14], O = t4[w2 - 14 + 1], V2 = t4[w2 - 32], x2 = t4[w2 - 32 + 1], M2 = k3 + O | 0, K2 = L2 + P2 + v2(M2, k3) | 0;
        K2 = (K2 = K2 + U2 + v2(M2 = M2 + D2 | 0, D2) | 0) + V2 + v2(M2 = M2 + x2 | 0, x2) | 0, t4[w2] = K2, t4[w2 + 1] = M2;
      }
      for (var j2 = 0; j2 < 160; j2 += 2) {
        K2 = t4[j2], M2 = t4[j2 + 1];
        var F2 = l2(r4, n4, i3), q2 = l2(C, S2, b2), H2 = h2(r4, C), G2 = h2(C, r4), z2 = f2(o2, _24), Q2 = f2(_24, o2), Y2 = s2[j2], W2 = s2[j2 + 1], X2 = c2(o2, u3, m2), Z2 = c2(_24, I2, A2), J2 = B2 + Q2 | 0, $2 = E2 + z2 + v2(J2, B2) | 0;
        $2 = ($2 = ($2 = $2 + X2 + v2(J2 = J2 + Z2 | 0, Z2) | 0) + Y2 + v2(J2 = J2 + W2 | 0, W2) | 0) + K2 + v2(J2 = J2 + M2 | 0, M2) | 0;
        var ee2 = G2 + q2 | 0, te2 = H2 + F2 + v2(ee2, G2) | 0;
        E2 = m2, B2 = A2, m2 = u3, A2 = I2, u3 = o2, I2 = _24, o2 = a7 + $2 + v2(_24 = T2 + J2 | 0, T2) | 0, a7 = i3, T2 = b2, i3 = n4, b2 = S2, n4 = r4, S2 = C, r4 = $2 + te2 + v2(C = J2 + ee2 | 0, J2) | 0;
      }
      this._al = this._al + C | 0, this._bl = this._bl + S2 | 0, this._cl = this._cl + b2 | 0, this._dl = this._dl + T2 | 0, this._el = this._el + _24 | 0, this._fl = this._fl + I2 | 0, this._gl = this._gl + A2 | 0, this._hl = this._hl + B2 | 0, this._ah = this._ah + r4 + v2(this._al, C) | 0, this._bh = this._bh + n4 + v2(this._bl, S2) | 0, this._ch = this._ch + i3 + v2(this._cl, b2) | 0, this._dh = this._dh + a7 + v2(this._dl, T2) | 0, this._eh = this._eh + o2 + v2(this._el, _24) | 0, this._fh = this._fh + u3 + v2(this._fl, I2) | 0, this._gh = this._gh + m2 + v2(this._gl, A2) | 0, this._hh = this._hh + E2 + v2(this._hl, B2) | 0;
    }, u2.prototype._hash = function() {
      var e4 = a6.allocUnsafe(64);
      function t4(t5, r4, n4) {
        e4.writeInt32BE(t5, n4), e4.writeInt32BE(r4, n4 + 4);
      }
      return t4(this._ah, this._al, 0), t4(this._bh, this._bl, 8), t4(this._ch, this._cl, 16), t4(this._dh, this._dl, 24), t4(this._eh, this._el, 32), t4(this._fh, this._fl, 40), t4(this._gh, this._gl, 48), t4(this._hh, this._hl, 56), e4;
    }, e3.exports = u2;
  }, 4851: (e3, t3, r3) => {
    e3.exports = i2;
    var n3 = r3(2699).EventEmitter;
    function i2() {
      n3.call(this);
    }
    r3(1285)(i2, n3), i2.Readable = r3(8051), i2.Writable = r3(2557), i2.Duplex = r3(7073), i2.Transform = r3(7640), i2.PassThrough = r3(5163), i2.finished = r3(9885), i2.pipeline = r3(3495), i2.Stream = i2, i2.prototype.pipe = function(e4, t4) {
      var r4 = this;
      function i3(t5) {
        e4.writable && e4.write(t5) === false && r4.pause && r4.pause();
      }
      function a6() {
        r4.readable && r4.resume && r4.resume();
      }
      r4.on("data", i3), e4.on("drain", a6), e4._isStdio || t4 && t4.end === false || (r4.on("end", o), r4.on("close", u2));
      var s2 = false;
      function o() {
        s2 || (s2 = true, e4.end());
      }
      function u2() {
        s2 || (s2 = true, typeof e4.destroy == "function" && e4.destroy());
      }
      function c2(e5) {
        if (l2(), n3.listenerCount(this, "error") === 0)
          throw e5;
      }
      function l2() {
        r4.removeListener("data", i3), e4.removeListener("drain", a6), r4.removeListener("end", o), r4.removeListener("close", u2), r4.removeListener("error", c2), e4.removeListener("error", c2), r4.removeListener("end", l2), r4.removeListener("close", l2), e4.removeListener("close", l2);
      }
      return r4.on("error", c2), e4.on("error", c2), r4.on("end", l2), r4.on("close", l2), e4.on("close", l2), e4.emit("pipe", r4), e4;
    };
  }, 214: (e3, t3, r3) => {
    var n3 = r3(7834).Buffer, i2 = n3.isEncoding || function(e4) {
      switch ((e4 = "" + e4) && e4.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return true;
        default:
          return false;
      }
    };
    function a6(e4) {
      var t4;
      switch (this.encoding = function(e5) {
        var t5 = function(e6) {
          if (!e6)
            return "utf8";
          for (var t6; ; )
            switch (e6) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return e6;
              default:
                if (t6)
                  return;
                e6 = ("" + e6).toLowerCase(), t6 = true;
            }
        }(e5);
        if (typeof t5 != "string" && (n3.isEncoding === i2 || !i2(e5)))
          throw new Error("Unknown encoding: " + e5);
        return t5 || e5;
      }(e4), this.encoding) {
        case "utf16le":
          this.text = u2, this.end = c2, t4 = 4;
          break;
        case "utf8":
          this.fillLast = o, t4 = 4;
          break;
        case "base64":
          this.text = l2, this.end = h2, t4 = 3;
          break;
        default:
          return this.write = f2, void (this.end = p2);
      }
      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n3.allocUnsafe(t4);
    }
    function s2(e4) {
      return e4 <= 127 ? 0 : e4 >> 5 == 6 ? 2 : e4 >> 4 == 14 ? 3 : e4 >> 3 == 30 ? 4 : e4 >> 6 == 2 ? -1 : -2;
    }
    function o(e4) {
      var t4 = this.lastTotal - this.lastNeed, r4 = function(e5, t5, r5) {
        if ((192 & t5[0]) != 128)
          return e5.lastNeed = 0, "\uFFFD";
        if (e5.lastNeed > 1 && t5.length > 1) {
          if ((192 & t5[1]) != 128)
            return e5.lastNeed = 1, "\uFFFD";
          if (e5.lastNeed > 2 && t5.length > 2 && (192 & t5[2]) != 128)
            return e5.lastNeed = 2, "\uFFFD";
        }
      }(this, e4);
      return r4 !== void 0 ? r4 : this.lastNeed <= e4.length ? (e4.copy(this.lastChar, t4, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e4.copy(this.lastChar, t4, 0, e4.length), void (this.lastNeed -= e4.length));
    }
    function u2(e4, t4) {
      if ((e4.length - t4) % 2 == 0) {
        var r4 = e4.toString("utf16le", t4);
        if (r4) {
          var n4 = r4.charCodeAt(r4.length - 1);
          if (n4 >= 55296 && n4 <= 56319)
            return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e4[e4.length - 2], this.lastChar[1] = e4[e4.length - 1], r4.slice(0, -1);
        }
        return r4;
      }
      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e4[e4.length - 1], e4.toString("utf16le", t4, e4.length - 1);
    }
    function c2(e4) {
      var t4 = e4 && e4.length ? this.write(e4) : "";
      if (this.lastNeed) {
        var r4 = this.lastTotal - this.lastNeed;
        return t4 + this.lastChar.toString("utf16le", 0, r4);
      }
      return t4;
    }
    function l2(e4, t4) {
      var r4 = (e4.length - t4) % 3;
      return r4 === 0 ? e4.toString("base64", t4) : (this.lastNeed = 3 - r4, this.lastTotal = 3, r4 === 1 ? this.lastChar[0] = e4[e4.length - 1] : (this.lastChar[0] = e4[e4.length - 2], this.lastChar[1] = e4[e4.length - 1]), e4.toString("base64", t4, e4.length - r4));
    }
    function h2(e4) {
      var t4 = e4 && e4.length ? this.write(e4) : "";
      return this.lastNeed ? t4 + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t4;
    }
    function f2(e4) {
      return e4.toString(this.encoding);
    }
    function p2(e4) {
      return e4 && e4.length ? this.write(e4) : "";
    }
    t3.s = a6, a6.prototype.write = function(e4) {
      if (e4.length === 0)
        return "";
      var t4, r4;
      if (this.lastNeed) {
        if ((t4 = this.fillLast(e4)) === void 0)
          return "";
        r4 = this.lastNeed, this.lastNeed = 0;
      } else
        r4 = 0;
      return r4 < e4.length ? t4 ? t4 + this.text(e4, r4) : this.text(e4, r4) : t4 || "";
    }, a6.prototype.end = function(e4) {
      var t4 = e4 && e4.length ? this.write(e4) : "";
      return this.lastNeed ? t4 + "\uFFFD" : t4;
    }, a6.prototype.text = function(e4, t4) {
      var r4 = function(e5, t5, r5) {
        var n5 = t5.length - 1;
        if (n5 < r5)
          return 0;
        var i3 = s2(t5[n5]);
        return i3 >= 0 ? (i3 > 0 && (e5.lastNeed = i3 - 1), i3) : --n5 < r5 || i3 === -2 ? 0 : (i3 = s2(t5[n5])) >= 0 ? (i3 > 0 && (e5.lastNeed = i3 - 2), i3) : --n5 < r5 || i3 === -2 ? 0 : (i3 = s2(t5[n5])) >= 0 ? (i3 > 0 && (i3 === 2 ? i3 = 0 : e5.lastNeed = i3 - 3), i3) : 0;
      }(this, e4, t4);
      if (!this.lastNeed)
        return e4.toString("utf8", t4);
      this.lastTotal = r4;
      var n4 = e4.length - (r4 - this.lastNeed);
      return e4.copy(this.lastChar, 0, n4), e4.toString("utf8", t4, n4);
    }, a6.prototype.fillLast = function(e4) {
      if (this.lastNeed <= e4.length)
        return e4.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      e4.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e4.length), this.lastNeed -= e4.length;
    };
  }, 5803: (e3, t3, r3) => {
    function n3(e4) {
      try {
        if (!r3.g.localStorage)
          return false;
      } catch (e5) {
        return false;
      }
      var t4 = r3.g.localStorage[e4];
      return t4 != null && String(t4).toLowerCase() === "true";
    }
    e3.exports = function(e4, t4) {
      if (n3("noDeprecation"))
        return e4;
      var r4 = false;
      return function() {
        if (!r4) {
          if (n3("throwDeprecation"))
            throw new Error(t4);
          n3("traceDeprecation") ? console.trace(t4) : console.warn(t4), r4 = true;
        }
        return e4.apply(this, arguments);
      };
    };
  }, 7573: () => {
  }, 5942: () => {
  }, 4854: () => {
  }, 6602: () => {
  } }, t2 = {};
  function r2(n3) {
    var i2 = t2[n3];
    if (i2 !== void 0)
      return i2.exports;
    var a6 = t2[n3] = { exports: {} };
    return e2[n3](a6, a6.exports, r2), a6.exports;
  }
  r2.n = (e3) => {
    var t3 = e3 && e3.__esModule ? () => e3.default : () => e3;
    return r2.d(t3, { a: t3 }), t3;
  }, r2.d = (e3, t3) => {
    for (var n3 in t3)
      r2.o(t3, n3) && !r2.o(e3, n3) && Object.defineProperty(e3, n3, { enumerable: true, get: t3[n3] });
  }, r2.g = function() {
    if (typeof globalThis == "object")
      return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e3) {
      if (typeof window == "object")
        return window;
    }
  }(), r2.o = (e3, t3) => Object.prototype.hasOwnProperty.call(e3, t3), r2.r = (e3) => {
    typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e3, "__esModule", { value: true });
  };
  var n2 = {};
  (() => {
    r2.r(n2), r2.d(n2, { encryptImage: () => o, forge: () => l2() });
    var e3 = r2(11), t3 = r2.n(e3), i2 = r2(4406), a6 = r2.n(i2);
    function s2(e4) {
      return new Promise(function(r3) {
        var n3 = t3()("sha256", "2c4c31a9cb31a23971792b8105187d21e0df9f28df26f35d97af140a770daa10");
        n3.on("readable", function() {
          var e5 = n3.read();
          e5 && r3(e5.toString("hex"));
        }), n3.write(e4), n3.end();
      });
    }
    function o(e4) {
      return t4 = this, r3 = void 0, i3 = function() {
        var t5;
        return function(e5, t6) {
          var r4, n4, i4, a7, s3 = { label: 0, sent: function() {
            if (1 & i4[0])
              throw i4[1];
            return i4[1];
          }, trys: [], ops: [] };
          return a7 = { next: o2(0), throw: o2(1), return: o2(2) }, typeof Symbol == "function" && (a7[Symbol.iterator] = function() {
            return this;
          }), a7;
          function o2(a8) {
            return function(o3) {
              return function(a9) {
                if (r4)
                  throw new TypeError("Generator is already executing.");
                for (; s3; )
                  try {
                    if (r4 = 1, n4 && (i4 = 2 & a9[0] ? n4.return : a9[0] ? n4.throw || ((i4 = n4.return) && i4.call(n4), 0) : n4.next) && !(i4 = i4.call(n4, a9[1])).done)
                      return i4;
                    switch (n4 = 0, i4 && (a9 = [2 & a9[0], i4.value]), a9[0]) {
                      case 0:
                      case 1:
                        i4 = a9;
                        break;
                      case 4:
                        return s3.label++, { value: a9[1], done: false };
                      case 5:
                        s3.label++, n4 = a9[1], a9 = [0];
                        continue;
                      case 7:
                        a9 = s3.ops.pop(), s3.trys.pop();
                        continue;
                      default:
                        if (!((i4 = (i4 = s3.trys).length > 0 && i4[i4.length - 1]) || a9[0] !== 6 && a9[0] !== 2)) {
                          s3 = 0;
                          continue;
                        }
                        if (a9[0] === 3 && (!i4 || a9[1] > i4[0] && a9[1] < i4[3])) {
                          s3.label = a9[1];
                          break;
                        }
                        if (a9[0] === 6 && s3.label < i4[1]) {
                          s3.label = i4[1], i4 = a9;
                          break;
                        }
                        if (i4 && s3.label < i4[2]) {
                          s3.label = i4[2], s3.ops.push(a9);
                          break;
                        }
                        i4[2] && s3.ops.pop(), s3.trys.pop();
                        continue;
                    }
                    a9 = t6.call(e5, s3);
                  } catch (e6) {
                    a9 = [6, e6], n4 = 0;
                  } finally {
                    r4 = i4 = 0;
                  }
                if (5 & a9[0])
                  throw a9[1];
                return { value: a9[0] ? a9[1] : void 0, done: true };
              }([a8, o3]);
            };
          }
        }(this, function(r4) {
          switch (r4.label) {
            case 0:
              return [4, s2(e4)];
            case 1:
              return t5 = r4.sent(), [2, u2(e4, t5)];
          }
        });
      }, new ((n3 = void 0) || (n3 = Promise))(function(e5, a7) {
        function s3(e6) {
          try {
            u3(i3.next(e6));
          } catch (e7) {
            a7(e7);
          }
        }
        function o2(e6) {
          try {
            u3(i3.throw(e6));
          } catch (e7) {
            a7(e7);
          }
        }
        function u3(t5) {
          var r4;
          t5.done ? e5(t5.value) : (r4 = t5.value, r4 instanceof n3 ? r4 : new n3(function(e6) {
            e6(r4);
          })).then(s3, o2);
        }
        u3((i3 = i3.apply(t4, r3 || [])).next());
      });
      var t4, r3, n3, i3;
    }
    function u2(e4, t4) {
      for (var r3, n3, i3, a7 = e4, s3 = 0; s3 < t4.length; s3++)
        r3 = a7, n3 = s3 + 64 * (s3 + 1), i3 = t4.charAt(s3), a7 = "".concat(r3.substring(0, n3)).concat(i3).concat(r3.substring(n3));
      return a7;
    }
    r2.g.process = a6();
    var c2 = r2(6432), l2 = r2.n(c2);
  })(), window.__MODULE_DEFAULT_EXPORT__ = n2;
})();
const __MODULE_DEFAULT_EXPORT__ = window.__MODULE_DEFAULT_EXPORT__;
delete window.__MODULE_DEFAULT_EXPORT__;
const { encryptImage, forge } = __MODULE_DEFAULT_EXPORT__;
const getPublicKeyUrl = () => `/e2ee/key/v2`;
const postPublicKeyUrl = () => `/e2ee/key`;
function getPublicKey() {
  return api.get(getPublicKeyUrl()).then((response) => response.data).catch(emptyFunc);
}
function encryptRsaOaepSha1Mgf1(publicKey, data2) {
  const encrypted = publicKey.encrypt(data2, "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create()
    }
  });
  return forge.util.bytesToHex(encrypted);
}
function encryptAesGcm(secretKey, data2) {
  try {
    const iv = forge.random.getBytesSync(12);
    const cipher = forge.cipher.createCipher("AES-GCM", secretKey);
    cipher.start({ iv });
    cipher.update(forge.util.createBuffer(JSON.stringify(data2), "utf8"));
    cipher.finish();
    const encrypted = cipher.output.toHex();
    const tag = cipher.mode.tag.toHex();
    const ivHex = forge.util.bytesToHex(iv);
    return { encryptedData: encrypted + tag, iv: ivHex };
  } catch (err) {
    throw new Error(err);
  }
}
function decryptAesGcm(secretKey, data2) {
  try {
    const iv = forge.util.hexToBytes(data2.iv);
    const tag = forge.util.hexToBytes(data2.encryptedData.slice(-32));
    const decipher = forge.cipher.createDecipher("AES-GCM", secretKey);
    decipher.start({ iv, tag });
    decipher.update(forge.util.createBuffer(forge.util.hexToBytes(data2.encryptedData.slice(0, -32))));
    decipher.finish();
    const decrypted = decipher.output;
    return decrypted.data;
  } catch (err) {
    throw new Error(err);
  }
}
function postPublicKey(encryptedKey, encryptedIv, sessionId, token) {
  return api.post(postPublicKeyUrl(), {
    encryptedKey,
    encryptedIv
  }, {
    headers: {
      sessionId,
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
async function publishKeys(token) {
  if (!this.encrypt) {
    throw new Error("Encryption is not active");
  }
  const secretKey = forge.random.getBytesSync(32);
  const iv = forge.random.getBytesSync(16);
  const publicKeyData = await getPublicKey();
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----
${publicKeyData.publicKey}
-----END PUBLIC KEY-----`;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encryptedKey = encryptRsaOaepSha1Mgf1(publicKey, secretKey);
  const encryptedIv = encryptRsaOaepSha1Mgf1(publicKey, iv);
  const sessionId = publicKeyData.sessionId;
  const postStatus = await postPublicKey(encryptedKey, encryptedIv, sessionId, token);
  api.instance.interceptors.request.use(function(config2) {
    config2.headers.sessionid = sessionId;
    const encrypted = encryptAesGcm(secretKey, config2.data);
    config2.data = encrypted;
    return config2;
  }, function(error3) {
    return Promise.reject(error3);
  });
  api.instance.interceptors.response.use(function(response) {
    const decrypted = decryptAesGcm(secretKey, response.data);
    response.data = JSON.parse(decrypted);
    return response;
  }, function(error3) {
    return Promise.reject(error3);
  });
  return postStatus;
}
function ocrData({ token }) {
  return api.get("/omni/get/ocr-data", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function ocrDataSecondId({ token }) {
  return api.get("/omni/get/ocr-data-second-id", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
const getScoreUrl = () => `/omni/get/score`;
function getScore({ token }) {
  return api.get(getScoreUrl(), null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function addToQueue$1({ token, queueName = "", interviewCode }) {
  return api.put(`/omni/queue/conference/add?queueName=${queueName}`, { interviewCode }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function getQueueIndex({ token, queueName }) {
  return api.get(`/omni/queue/conference/index?queueName=${queueName}`, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function addDocument({ token, type, image: image2, onProgress = emptyFunc }) {
  try {
    const res = api.post(`/omni/add/document/v2?type=${type}`, { base64Image: image2 }, {
      headers: {
        "X-Incode-Hardware-Id": token
      },
      onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
    });
    return res == null ? void 0 : res.data;
  } catch (error3) {
    return error3.response;
  }
}
const handleDetectRectangleCascade = (src2, rectCascade, width2, height2, neighbours2) => {
  const cv = window.cv;
  const dst = new cv.Mat();
  const rects = new cv.RectVector();
  let maxArea = 0;
  let maxRect = null;
  cv.cvtColor(src2, dst, cv.COLOR_RGBA2GRAY, 0);
  const minsize = new cv.Size(width2, height2);
  rectCascade.detectMultiScale(dst, rects, 1.1, neighbours2, 0, minsize);
  for (let i2 = 0; i2 < rects.size(); ++i2) {
    if (rects.get(i2).width * rects.get(i2).height > maxArea) {
      maxArea = rects.get(i2).width * rects.get(i2).height;
      maxRect = rects.get(i2);
    }
  }
  dst.delete();
  rects.delete();
  return maxRect;
};
const globalTimeout = 9e3;
const intervalTimeout = 150;
let showIDTimeout;
const callIDClassification = ({
  canvas,
  context: context2,
  rectCascade,
  widthThreshold: widthThreshold2,
  heightThreshold: heightThreshold2,
  minWidth: minWidth2,
  minHeight: minHeight2,
  neighbours: neighbours2,
  webcam,
  onFarAway,
  onCapturing,
  onCapture,
  onIDNotDetected,
  onNothingHappen,
  onPercentage
}) => {
  const cv = window.cv;
  if (state.cascadeLoaded && webcam.video) {
    if (!showIDTimeout) {
      showIDTimeout = setTimeout(onNothingHappen, 5e3);
    }
    if (state.intervalCounter === globalTimeout / intervalTimeout && state.matchCounter < 2) {
      state.intervalCounter = 0;
      state.matchCounter = 0;
      clearTimeout(showIDTimeout);
      onIDNotDetected();
    } else {
      state.intervalCounter += 1;
      const src2 = new cv.Mat(canvas.height, canvas.width, cv.CV_8UC4);
      context2.drawImage(webcam.video, 0, 0, canvas.width, canvas.height);
      src2.data.set(context2.getImageData(0, 0, canvas.width, canvas.height).data);
      const rect = handleDetectRectangleCascade(src2, rectCascade, minWidth2, minHeight2, neighbours2);
      src2.delete();
      if (rect) {
        clearTimeout(showIDTimeout);
        state.matchCounter += 1;
        const { width: width2, height: height2 } = rect;
        const widthHundredPercent = canvas.width * widthThreshold2;
        const heightHundredPercent = canvas.height * heightThreshold2;
        const widthPercentage = width2 * 100 / widthHundredPercent;
        const heightPercentage = height2 * 100 / heightHundredPercent;
        onPercentage({
          widthPercentage: widthPercentage >= 100 ? 100 : widthPercentage,
          heightPercentage: heightPercentage >= 100 ? 100 : heightPercentage
        });
        if (width2 > widthHundredPercent && height2 > heightHundredPercent) {
          state.intervalCounter = 0;
          state.matchCounter = 0;
          onCapturing();
          window.clearInterval(state.intervalId);
          setTimeout(() => {
            const newCanvas = document.createElement("canvas");
            newCanvas.width = webcam.video.videoWidth;
            newCanvas.height = webcam.video.videoHeight;
            const ctx = newCanvas.getContext("2d");
            ctx.clearRect(0, 0, newCanvas.width, newCanvas.height);
            ctx.drawImage(webcam.video, 0, 0);
            const base64Image = newCanvas.toDataURL("image/jpeg", 1).split(",")[1];
            onCapture(base64Image);
          }, 1e3);
        } else {
          onFarAway();
        }
      } else {
        onPercentage({});
      }
    }
  }
};
const pico = {};
pico.unpack_cascade = function(bytes) {
  var dview = new DataView(new ArrayBuffer(4));
  var p2 = 8;
  dview.setUint8(0, bytes[p2 + 0]);
  dview.setUint8(1, bytes[p2 + 1]);
  dview.setUint8(2, bytes[p2 + 2]);
  dview.setUint8(3, bytes[p2 + 3]);
  var tdepth = dview.getInt32(0, true);
  p2 = p2 + 4;
  dview.setUint8(0, bytes[p2 + 0]);
  dview.setUint8(1, bytes[p2 + 1]);
  dview.setUint8(2, bytes[p2 + 2]);
  dview.setUint8(3, bytes[p2 + 3]);
  var ntrees = dview.getInt32(0, true);
  p2 = p2 + 4;
  var tcodes = [];
  var tpreds = [];
  var thresh = [];
  for (var t2 = 0; t2 < ntrees; ++t2) {
    var i2;
    Array.prototype.push.apply(tcodes, [0, 0, 0, 0]);
    Array.prototype.push.apply(tcodes, bytes.slice(p2, p2 + 4 * Math.pow(2, tdepth) - 4));
    p2 = p2 + 4 * Math.pow(2, tdepth) - 4;
    for (i2 = 0; i2 < Math.pow(2, tdepth); ++i2) {
      dview.setUint8(0, bytes[p2 + 0]);
      dview.setUint8(1, bytes[p2 + 1]);
      dview.setUint8(2, bytes[p2 + 2]);
      dview.setUint8(3, bytes[p2 + 3]);
      tpreds.push(dview.getFloat32(0, true));
      p2 = p2 + 4;
    }
    dview.setUint8(0, bytes[p2 + 0]);
    dview.setUint8(1, bytes[p2 + 1]);
    dview.setUint8(2, bytes[p2 + 2]);
    dview.setUint8(3, bytes[p2 + 3]);
    thresh.push(dview.getFloat32(0, true));
    p2 = p2 + 4;
  }
  tcodes = new Int8Array(tcodes);
  tpreds = new Float32Array(tpreds);
  thresh = new Float32Array(thresh);
  function classify_region(r2, c2, s2, pixels, ldim) {
    r2 = 256 * r2;
    c2 = 256 * c2;
    var root2 = 0;
    var o = 0;
    var pow2tdepth = Math.pow(2, tdepth) >> 0;
    for (var i3 = 0; i3 < ntrees; ++i3) {
      let idx = 1;
      for (var j2 = 0; j2 < tdepth; ++j2)
        idx = 2 * idx + (pixels[(r2 + tcodes[root2 + 4 * idx + 0] * s2 >> 8) * ldim + (c2 + tcodes[root2 + 4 * idx + 1] * s2 >> 8)] <= pixels[(r2 + tcodes[root2 + 4 * idx + 2] * s2 >> 8) * ldim + (c2 + tcodes[root2 + 4 * idx + 3] * s2 >> 8)]);
      o = o + tpreds[pow2tdepth * i3 + idx - pow2tdepth];
      if (o <= thresh[i3])
        return -1;
      root2 += 4 * pow2tdepth;
    }
    return o - thresh[ntrees - 1];
  }
  return classify_region;
};
pico.run_cascade = function(image2, classify_region, params) {
  var pixels = image2.pixels;
  var nrows = image2.nrows;
  var ncols = image2.ncols;
  var ldim = image2.ldim;
  var shiftfactor = params.shiftfactor;
  var minsize = params.minsize;
  var maxsize = params.maxsize;
  var scalefactor = params.scalefactor;
  var scale2 = minsize;
  var detections = [];
  while (scale2 <= maxsize) {
    var step2 = Math.max(shiftfactor * scale2, 1) >> 0;
    var offset = scale2 / 2 + 1 >> 0;
    for (var r2 = offset; r2 <= nrows - offset; r2 += step2)
      for (var c2 = offset; c2 <= ncols - offset; c2 += step2) {
        var q2 = classify_region(r2, c2, scale2, pixels, ldim);
        if (q2 > 0)
          detections.push([r2, c2, scale2, q2]);
      }
    scale2 = scale2 * scalefactor;
  }
  return detections;
};
pico.cluster_detections = function(dets, iouthreshold) {
  dets = dets.sort(function(a6, b2) {
    return b2[3] - a6[3];
  });
  function calculate_iou(det1, det2) {
    var r1 = det1[0], c1 = det1[1], s1 = det1[2];
    var r22 = det2[0], c22 = det2[1], s22 = det2[2];
    var overr = Math.max(0, Math.min(r1 + s1 / 2, r22 + s22 / 2) - Math.max(r1 - s1 / 2, r22 - s22 / 2));
    var overc = Math.max(0, Math.min(c1 + s1 / 2, c22 + s22 / 2) - Math.max(c1 - s1 / 2, c22 - s22 / 2));
    return overr * overc / (s1 * s1 + s22 * s22 - overr * overc);
  }
  var assignments = new Array(dets.length).fill(0);
  var clusters = [];
  for (var i2 = 0; i2 < dets.length; ++i2) {
    if (assignments[i2] == 0) {
      var r2 = 0, c2 = 0, s2 = 0, q2 = 0, n2 = 0;
      for (var j2 = i2; j2 < dets.length; ++j2)
        if (calculate_iou(dets[i2], dets[j2]) > iouthreshold) {
          assignments[j2] = 1;
          r2 = r2 + dets[j2][0];
          c2 = c2 + dets[j2][1];
          s2 = s2 + dets[j2][2];
          q2 = q2 + dets[j2][3];
          n2 = n2 + 1;
        }
      clusters.push([r2 / n2, c2 / n2, s2 / n2, q2]);
    }
  }
  return clusters;
};
pico.instantiate_detection_memory = function(size) {
  var n2 = 0, memory2 = [];
  for (var i2 = 0; i2 < size; ++i2)
    memory2.push([]);
  function update_memory(dets) {
    memory2[n2] = dets;
    n2 = (n2 + 1) % memory2.length;
    dets = [];
    for (i2 = 0; i2 < memory2.length; ++i2)
      dets = dets.concat(memory2[i2]);
    return dets;
  }
  return update_memory;
};
const rgbaToGrayscale = (rgba2, nrows, ncols) => {
  const gray = new Uint8Array(nrows * ncols);
  for (let r2 = 0; r2 < nrows; ++r2) {
    for (let c2 = 0; c2 < ncols; ++c2) {
      gray[r2 * ncols + c2] = (2 * rgba2[r2 * 4 * ncols + 4 * c2 + 0] + 7 * rgba2[r2 * 4 * ncols + 4 * c2 + 1] + 1 * rgba2[r2 * 4 * ncols + 4 * c2 + 2]) / 10;
    }
  }
  return gray;
};
function getBlurriness(src2) {
  const cv = window.cv;
  const dst = new cv.Mat();
  const mean2 = new cv.Mat();
  const stddev = new cv.Mat();
  const rect = new cv.Rect(src2.cols / 4, src2.rows / 4, src2.cols / 2, src2.rows / 2);
  src2 = src2.roi(rect);
  cv.cvtColor(src2, src2, cv.COLOR_BGR2GRAY, 0);
  cv.Laplacian(src2, dst, cv.CV_64F);
  cv.meanStdDev(dst, mean2, stddev);
  const result2 = stddev.doubleAt(0, 0) * stddev.doubleAt(0, 0);
  dst.delete();
  mean2.delete();
  stddev.delete();
  return result2;
}
function getBigger(key, array) {
  const values = array.map((i2) => i2[key]);
  return array[values.indexOf(Math.max(...values))];
}
const timer = 2e3;
const callFaceDetection = ({
  canvas,
  context: context2,
  webcam,
  onFarAway,
  onCapture,
  onCapturing,
  onTooClose,
  onError,
  onNoFace,
  looseMode
}) => {
  const cv = window.cv;
  if (!cv)
    return;
  state.intervalCounter += 1;
  context2.drawImage(webcam.video, 0, 0, canvas.width, canvas.height);
  const src2 = new cv.Mat(canvas.height, canvas.width, cv.CV_8UC4);
  src2.data.set(context2.getImageData(0, 0, canvas.width, canvas.height).data);
  const blurriness = getBlurriness(src2);
  src2.delete();
  const rgba2 = context2.getImageData(0, 0, 400, 300).data;
  const image2 = {
    pixels: rgbaToGrayscale(rgba2, 400, 300),
    nrows: 300,
    ncols: 400,
    ldim: 400
  };
  const params = {
    shiftfactor: 0.1,
    minsize: 100,
    maxsize: 500,
    scalefactor: 1.4
  };
  let dets = pico.run_cascade(image2, state.facefinderClassifyRegion, params);
  dets = pico.cluster_detections(dets, 0.2);
  const { width: width2 } = canvas;
  const qthresh = 5;
  const isDesktop2 = !mobile.any();
  const min2 = isDesktop2 ? 46 : 53;
  const max2 = 60;
  let faceDetected = false;
  for (let i2 = 0; i2 < dets.length; ++i2) {
    if (dets[i2][3] > qthresh) {
      faceDetected = true;
      const percentage = dets[i2][2] / width2 * 100;
      if (looseMode) {
        onCapturing();
      }
      if (percentage < min2) {
        onFarAway();
      } else if (percentage < max2) {
        if (state.grabSelfieFrames) {
          state.frames.push({
            blurriness,
            frame: webcam.getBase64ScreenShot(webcam.video.videoWidth, webcam.video.videoHeight, 1, false),
            fullImage: webcam.getFullImage(webcam.video.videoWidth, webcam.video.videoHeight, 1)
          });
        } else {
          onCapturing();
          setTimeout(() => {
            window.clearInterval(state.intervalId);
            const { frame: frame2, fullImage } = getBigger("blurriness", state.frames);
            if (!frame2)
              return;
            onCapture(frame2, fullImage);
            state.intervalCounter = 0;
            state.grabSelfieFrames = false;
            state.frames = [];
          }, timer);
          state.grabSelfieFrames = true;
          state.frames.push({
            blurriness,
            frame: webcam.getBase64ScreenShot(webcam.video.videoWidth, webcam.video.videoHeight, 1, false),
            fullImage: webcam.getFullImage(webcam.video.videoWidth, webcam.video.videoHeight, 1)
          });
        }
      } else {
        onTooClose();
      }
    }
  }
  if (!faceDetected) {
    onNoFace();
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const EPSILON_FLOAT32$1 = 1e-7;
const EPSILON_FLOAT16$1 = 1e-4;
class DataStorage {
  constructor(backend2, dataMover) {
    this.backend = backend2;
    this.dataMover = dataMover;
    this.data = /* @__PURE__ */ new WeakMap();
    this.dataIdsCount = 0;
  }
  get(dataId) {
    if (!this.data.has(dataId)) {
      this.dataMover.moveData(this.backend, dataId);
    }
    return this.data.get(dataId);
  }
  set(dataId, value) {
    this.dataIdsCount++;
    this.data.set(dataId, value);
  }
  has(dataId) {
    return this.data.has(dataId);
  }
  delete(dataId) {
    this.dataIdsCount--;
    return this.data.delete(dataId);
  }
  numDataIds() {
    return this.dataIdsCount;
  }
}
class KernelBackend {
  refCount(dataId) {
    return notYetImplemented("refCount");
  }
  incRef(dataId) {
    return notYetImplemented("incRef");
  }
  timerAvailable() {
    return true;
  }
  time(f2) {
    return notYetImplemented("time");
  }
  read(dataId) {
    return notYetImplemented("read");
  }
  readSync(dataId) {
    return notYetImplemented("readSync");
  }
  readToGPU(dataId, options) {
    return notYetImplemented("readToGPU");
  }
  numDataIds() {
    return notYetImplemented("numDataIds");
  }
  disposeData(dataId, force) {
    return notYetImplemented("disposeData");
  }
  write(values, shape, dtype) {
    return notYetImplemented("write");
  }
  move(dataId, values, shape, dtype, refCount) {
    return notYetImplemented("move");
  }
  memory() {
    return notYetImplemented("memory");
  }
  floatPrecision() {
    return notYetImplemented("floatPrecision");
  }
  epsilon() {
    return this.floatPrecision() === 32 ? EPSILON_FLOAT32$1 : EPSILON_FLOAT16$1;
  }
  dispose() {
    return notYetImplemented("dispose");
  }
}
function notYetImplemented(kernelName) {
  throw new Error(`'${kernelName}' not yet implemented or not found in the registry. This kernel may not be supported by the tfjs backend you have chosen`);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function shuffle(array) {
  let counter2 = array.length;
  let index2 = 0;
  while (counter2 > 0) {
    index2 = Math.random() * counter2 | 0;
    counter2--;
    swap(array, counter2, index2);
  }
}
function clamp$2(min2, x2, max2) {
  return Math.max(min2, Math.min(x2, max2));
}
function nearestLargerEven(val) {
  return val % 2 === 0 ? val : val + 1;
}
function swap(object, left2, right) {
  const temp = object[left2];
  object[left2] = object[right];
  object[right] = temp;
}
function sum$4(arr2) {
  let sum2 = 0;
  for (let i2 = 0; i2 < arr2.length; i2++) {
    sum2 += arr2[i2];
  }
  return sum2;
}
function assert$1(expr, msg) {
  if (!expr) {
    throw new Error(typeof msg === "string" ? msg : msg());
  }
}
function assertShapesMatch(shapeA, shapeB, errorMessagePrefix = "") {
  assert$1(arraysEqual(shapeA, shapeB), () => errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
}
function assertNonNull(a6) {
  assert$1(a6 != null, () => `The input to the tensor constructor must be a non-null value.`);
}
function flatten$1(arr2, result2 = [], skipTypedArray = false) {
  if (result2 == null) {
    result2 = [];
  }
  if (Array.isArray(arr2) || isTypedArray(arr2) && !skipTypedArray) {
    for (let i2 = 0; i2 < arr2.length; ++i2) {
      flatten$1(arr2[i2], result2, skipTypedArray);
    }
  } else {
    result2.push(arr2);
  }
  return result2;
}
function sizeFromShape(shape) {
  if (shape.length === 0) {
    return 1;
  }
  let size = shape[0];
  for (let i2 = 1; i2 < shape.length; i2++) {
    size *= shape[i2];
  }
  return size;
}
function arraysEqual(n1, n2) {
  if (n1 === n2) {
    return true;
  }
  if (n1 == null || n2 == null) {
    return false;
  }
  if (n1.length !== n2.length) {
    return false;
  }
  for (let i2 = 0; i2 < n1.length; i2++) {
    if (n1[i2] !== n2[i2]) {
      return false;
    }
  }
  return true;
}
function isInt(a6) {
  return a6 % 1 === 0;
}
function sizeToSquarishShape(size) {
  const width2 = Math.ceil(Math.sqrt(size));
  return [width2, Math.ceil(size / width2)];
}
function rightPad(a6, size) {
  if (size <= a6.length) {
    return a6;
  }
  return a6 + " ".repeat(size - a6.length);
}
function repeatedTry(checkFn, delayFn = (counter2) => 0, maxCounter) {
  return new Promise((resolve, reject) => {
    let tryCount = 0;
    const tryFn = () => {
      if (checkFn()) {
        resolve();
        return;
      }
      tryCount++;
      const nextBackoff = delayFn(tryCount);
      if (maxCounter != null && tryCount >= maxCounter) {
        reject();
        return;
      }
      setTimeout(tryFn, nextBackoff);
    };
    tryFn();
  });
}
function inferFromImplicitShape(shape, size) {
  let shapeProd = 1;
  let implicitIdx = -1;
  for (let i2 = 0; i2 < shape.length; ++i2) {
    if (shape[i2] >= 0) {
      shapeProd *= shape[i2];
    } else if (shape[i2] === -1) {
      if (implicitIdx !== -1) {
        throw Error(`Shapes can only have 1 implicit size. Found -1 at dim ${implicitIdx} and dim ${i2}`);
      }
      implicitIdx = i2;
    } else if (shape[i2] < 0) {
      throw Error(`Shapes can not be < 0. Found ${shape[i2]} at dim ${i2}`);
    }
  }
  if (implicitIdx === -1) {
    if (size > 0 && size !== shapeProd) {
      throw Error(`Size(${size}) must match the product of shape ${shape}`);
    }
    return shape;
  }
  if (shapeProd === 0) {
    throw Error(`Cannot infer the missing size in [${shape}] when there are 0 elements`);
  }
  if (size % shapeProd !== 0) {
    throw Error(`The implicit shape can't be a fractional number. Got ${size} / ${shapeProd}`);
  }
  const newShape = shape.slice();
  newShape[implicitIdx] = size / shapeProd;
  return newShape;
}
function parseAxisParam(axis, shape) {
  const rank = shape.length;
  axis = axis == null ? shape.map((s2, i2) => i2) : [].concat(axis);
  assert$1(axis.every((ax) => ax >= -rank && ax < rank), () => `All values in axis param must be in range [-${rank}, ${rank}) but got axis ${axis}`);
  assert$1(axis.every((ax) => isInt(ax)), () => `All values in axis param must be integers but got axis ${axis}`);
  return axis.map((a6) => a6 < 0 ? rank + a6 : a6);
}
function squeezeShape(shape, axis) {
  const newShape = [];
  const keptDims = [];
  const isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
  const axes = axis == null || isEmptyArray ? null : parseAxisParam(axis, shape).sort();
  let j2 = 0;
  for (let i2 = 0; i2 < shape.length; ++i2) {
    if (axes != null) {
      if (axes[j2] === i2 && shape[i2] !== 1) {
        throw new Error(`Can't squeeze axis ${i2} since its dim '${shape[i2]}' is not 1`);
      }
      if ((axes[j2] == null || axes[j2] > i2) && shape[i2] === 1) {
        newShape.push(shape[i2]);
        keptDims.push(i2);
      }
      if (axes[j2] <= i2) {
        j2++;
      }
    }
    if (shape[i2] !== 1) {
      newShape.push(shape[i2]);
      keptDims.push(i2);
    }
  }
  return { newShape, keptDims };
}
function getTypedArrayFromDType(dtype, size) {
  let values = null;
  if (dtype == null || dtype === "float32") {
    values = new Float32Array(size);
  } else if (dtype === "int32") {
    values = new Int32Array(size);
  } else if (dtype === "bool") {
    values = new Uint8Array(size);
  } else {
    throw new Error(`Unknown data type ${dtype}`);
  }
  return values;
}
function getArrayFromDType(dtype, size) {
  let values = null;
  if (dtype == null || dtype === "float32") {
    values = new Float32Array(size);
  } else if (dtype === "int32") {
    values = new Int32Array(size);
  } else if (dtype === "bool") {
    values = new Uint8Array(size);
  } else if (dtype === "string") {
    values = new Array(size);
  } else {
    throw new Error(`Unknown data type ${dtype}`);
  }
  return values;
}
function checkConversionForErrors(vals, dtype) {
  for (let i2 = 0; i2 < vals.length; i2++) {
    const num = vals[i2];
    if (isNaN(num) || !isFinite(num)) {
      throw Error(`A tensor of type ${dtype} being uploaded contains ${num}.`);
    }
  }
}
function isValidDtype(dtype) {
  return dtype === "bool" || dtype === "complex64" || dtype === "float32" || dtype === "int32" || dtype === "string";
}
function hasEncodingLoss(oldType, newType) {
  if (newType === "complex64") {
    return false;
  }
  if (newType === "float32" && oldType !== "complex64") {
    return false;
  }
  if (newType === "int32" && oldType !== "float32" && oldType !== "complex64") {
    return false;
  }
  if (newType === "bool" && oldType === "bool") {
    return false;
  }
  return true;
}
function isTypedArray(a6) {
  return a6 instanceof Float32Array || a6 instanceof Int32Array || a6 instanceof Uint8Array || a6 instanceof Uint8ClampedArray;
}
function bytesPerElement(dtype) {
  if (dtype === "float32" || dtype === "int32") {
    return 4;
  } else if (dtype === "complex64") {
    return 8;
  } else if (dtype === "bool") {
    return 1;
  } else {
    throw new Error(`Unknown dtype ${dtype}`);
  }
}
function bytesFromStringArray(arr2) {
  if (arr2 == null) {
    return 0;
  }
  let bytes = 0;
  arr2.forEach((x2) => bytes += x2.length);
  return bytes;
}
function isString$4(value) {
  return typeof value === "string" || value instanceof String;
}
function isBoolean$1(value) {
  return typeof value === "boolean";
}
function isNumber$1(value) {
  return typeof value === "number";
}
function inferDtype(values) {
  if (Array.isArray(values)) {
    return inferDtype(values[0]);
  }
  if (values instanceof Float32Array) {
    return "float32";
  } else if (values instanceof Int32Array || values instanceof Uint8Array || values instanceof Uint8ClampedArray) {
    return "int32";
  } else if (isNumber$1(values)) {
    return "float32";
  } else if (isString$4(values)) {
    return "string";
  } else if (isBoolean$1(values)) {
    return "bool";
  }
  return "float32";
}
function isFunction$2(f2) {
  return !!(f2 && f2.constructor && f2.call && f2.apply);
}
function nearestDivisor(size, start) {
  for (let i2 = start; i2 < size; ++i2) {
    if (size % i2 === 0) {
      return i2;
    }
  }
  return size;
}
function computeStrides(shape) {
  const rank = shape.length;
  if (rank < 2) {
    return [];
  }
  const strides = new Array(rank - 1);
  strides[rank - 2] = shape[rank - 1];
  for (let i2 = rank - 3; i2 >= 0; --i2) {
    strides[i2] = strides[i2 + 1] * shape[i2 + 1];
  }
  return strides;
}
function createNestedArray(offset, shape, a6, isComplex = false) {
  const ret = new Array();
  if (shape.length === 1) {
    const d2 = shape[0] * (isComplex ? 2 : 1);
    for (let i2 = 0; i2 < d2; i2++) {
      ret[i2] = a6[offset + i2];
    }
  } else {
    const d2 = shape[0];
    const rest = shape.slice(1);
    const len = rest.reduce((acc, c2) => acc * c2) * (isComplex ? 2 : 1);
    for (let i2 = 0; i2 < d2; i2++) {
      ret[i2] = createNestedArray(offset + i2 * len, rest, a6, isComplex);
    }
  }
  return ret;
}
function toNestedArray(shape, a6, isComplex = false) {
  if (shape.length === 0) {
    return a6[0];
  }
  const size = shape.reduce((acc, c2) => acc * c2) * (isComplex ? 2 : 1);
  if (size === 0) {
    return [];
  }
  if (size !== a6.length) {
    throw new Error(`[${shape}] does not match the input size ${a6.length}${isComplex ? " for a complex tensor" : ""}.`);
  }
  return createNestedArray(0, shape, a6, isComplex);
}
function makeOnesTypedArray(size, dtype) {
  const array = makeZerosTypedArray(size, dtype);
  for (let i2 = 0; i2 < array.length; i2++) {
    array[i2] = 1;
  }
  return array;
}
function makeZerosTypedArray(size, dtype) {
  if (dtype == null || dtype === "float32" || dtype === "complex64") {
    return new Float32Array(size);
  } else if (dtype === "int32") {
    return new Int32Array(size);
  } else if (dtype === "bool") {
    return new Uint8Array(size);
  } else {
    throw new Error(`Unknown data type ${dtype}`);
  }
}
function makeZerosNestedTypedArray(shape, dtype) {
  const size = shape.reduce((prev, curr) => prev * curr, 1);
  if (dtype == null || dtype === "float32") {
    return toNestedArray(shape, new Float32Array(size));
  } else if (dtype === "int32") {
    return toNestedArray(shape, new Int32Array(size));
  } else if (dtype === "bool") {
    return toNestedArray(shape, new Uint8Array(size));
  } else {
    throw new Error(`Unknown data type ${dtype}`);
  }
}
function assertNonNegativeIntegerDimensions(shape) {
  shape.forEach((dimSize) => {
    assert$1(Number.isInteger(dimSize) && dimSize >= 0, () => `Tensor must have a shape comprised of positive integers but got shape [${shape}].`);
  });
}
function locToIndex(locs, rank, strides) {
  if (rank === 0) {
    return 0;
  } else if (rank === 1) {
    return locs[0];
  }
  let index2 = locs[locs.length - 1];
  for (let i2 = 0; i2 < locs.length - 1; ++i2) {
    index2 += strides[i2] * locs[i2];
  }
  return index2;
}
function indexToLoc(index2, rank, strides) {
  if (rank === 0) {
    return [];
  } else if (rank === 1) {
    return [index2];
  }
  const locs = new Array(rank);
  for (let i2 = 0; i2 < locs.length - 1; ++i2) {
    locs[i2] = Math.floor(index2 / strides[i2]);
    index2 -= locs[i2] * strides[i2];
  }
  locs[locs.length - 1] = index2;
  return locs;
}
function isPromise(object) {
  return object && object.then && typeof object.then === "function";
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const TENSORFLOWJS_FLAGS_PREFIX = "tfjsflags";
class Environment {
  constructor(global2) {
    this.global = global2;
    this.flags = {};
    this.flagRegistry = {};
    this.urlFlags = {};
    this.getQueryParams = getQueryParams;
    this.populateURLFlags();
  }
  setPlatform(platformName, platform) {
    if (this.platform != null) {
      if (!(env().getBool("IS_TEST") || env().getBool("PROD"))) {
        console.warn(`Platform ${this.platformName} has already been set. Overwriting the platform with ${platformName}.`);
      }
    }
    this.platformName = platformName;
    this.platform = platform;
  }
  registerFlag(flagName, evaluationFn, setHook) {
    this.flagRegistry[flagName] = { evaluationFn, setHook };
    if (this.urlFlags[flagName] != null) {
      const flagValue = this.urlFlags[flagName];
      if (!(env().getBool("IS_TEST") || env().getBool("PROD"))) {
        console.warn(`Setting feature override from URL ${flagName}: ${flagValue}.`);
      }
      this.set(flagName, flagValue);
    }
  }
  async getAsync(flagName) {
    if (flagName in this.flags) {
      return this.flags[flagName];
    }
    this.flags[flagName] = await this.evaluateFlag(flagName);
    return this.flags[flagName];
  }
  get(flagName) {
    if (flagName in this.flags) {
      return this.flags[flagName];
    }
    const flagValue = this.evaluateFlag(flagName);
    if (isPromise(flagValue)) {
      throw new Error(`Flag ${flagName} cannot be synchronously evaluated. Please use getAsync() instead.`);
    }
    this.flags[flagName] = flagValue;
    return this.flags[flagName];
  }
  getNumber(flagName) {
    return this.get(flagName);
  }
  getBool(flagName) {
    return this.get(flagName);
  }
  getFlags() {
    return this.flags;
  }
  get features() {
    return this.flags;
  }
  set(flagName, value) {
    if (this.flagRegistry[flagName] == null) {
      throw new Error(`Cannot set flag ${flagName} as it has not been registered.`);
    }
    this.flags[flagName] = value;
    if (this.flagRegistry[flagName].setHook != null) {
      this.flagRegistry[flagName].setHook(value);
    }
  }
  evaluateFlag(flagName) {
    if (this.flagRegistry[flagName] == null) {
      throw new Error(`Cannot evaluate flag '${flagName}': no evaluation function found.`);
    }
    return this.flagRegistry[flagName].evaluationFn();
  }
  setFlags(flags) {
    this.flags = Object.assign({}, flags);
  }
  reset() {
    this.flags = {};
    this.urlFlags = {};
    this.populateURLFlags();
  }
  populateURLFlags() {
    if (typeof this.global === "undefined" || typeof this.global.location === "undefined" || typeof this.global.location.search === "undefined") {
      return;
    }
    const urlParams = this.getQueryParams(this.global.location.search);
    if (TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
      const keyValues = urlParams[TENSORFLOWJS_FLAGS_PREFIX].split(",");
      keyValues.forEach((keyValue) => {
        const [key, value] = keyValue.split(":");
        this.urlFlags[key] = parseValue(key, value);
      });
    }
  }
}
function getQueryParams(queryString) {
  const params = {};
  queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (s2, ...t2) => {
    decodeParam(params, t2[0], t2[1]);
    return t2.join("=");
  });
  return params;
}
function decodeParam(params, name, value) {
  params[decodeURIComponent(name)] = decodeURIComponent(value || "");
}
function parseValue(flagName, value) {
  value = value.toLowerCase();
  if (value === "true" || value === "false") {
    return value === "true";
  } else if (`${+value}` === value) {
    return +value;
  }
  throw new Error(`Could not parse value flag value ${value} for flag ${flagName}.`);
}
function env() {
  return ENV$5;
}
let ENV$5 = null;
function setEnvironmentGlobal(environment) {
  ENV$5 = environment;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let globalNameSpace;
function getGlobalNamespace() {
  if (globalNameSpace == null) {
    let ns;
    if (typeof window !== "undefined") {
      ns = window;
    } else if (typeof global !== "undefined") {
      ns = global;
    } else if (typeof process !== "undefined") {
      ns = process;
    } else if (typeof self !== "undefined") {
      ns = self;
    } else {
      throw new Error("Could not find a global object");
    }
    globalNameSpace = ns;
  }
  return globalNameSpace;
}
function getGlobalMap() {
  const ns = getGlobalNamespace();
  if (ns._tfGlobals == null) {
    ns._tfGlobals = /* @__PURE__ */ new Map();
  }
  return ns._tfGlobals;
}
function getGlobal(key, init3) {
  const globalMap = getGlobalMap();
  if (globalMap.has(key)) {
    return globalMap.get(key);
  } else {
    const singleton = init3();
    globalMap.set(key, singleton);
    return globalMap.get(key);
  }
}
const Abs = "Abs";
const Acos = "Acos";
const Acosh = "Acosh";
const Add$1 = "Add";
const AddN = "AddN";
const All = "All";
const Any = "Any";
const ArgMax = "ArgMax";
const ArgMin = "ArgMin";
const Asin = "Asin";
const Asinh = "Asinh";
const Atan = "Atan";
const Atanh = "Atanh";
const Atan2 = "Atan2";
const AvgPool = "AvgPool";
const AvgPoolGrad = "AvgPoolGrad";
const AvgPool3D = "AvgPool3D";
const AvgPool3DGrad = "AvgPool3DGrad";
const BatchMatMul = "BatchMatMul";
const BatchToSpaceND = "BatchToSpaceND";
const Bincount = "Bincount";
const BroadcastTo = "BroadcastTo";
const BroadcastArgs = "BroadcastArgs";
const Cast = "Cast";
const Ceil = "Ceil";
const ClipByValue = "ClipByValue";
const Complex = "Complex";
const ComplexAbs = "ComplexAbs";
const Concat = "Concat";
const Conv2D$1 = "Conv2D";
const Conv2DBackpropFilter = "Conv2DBackpropFilter";
const Conv2DBackpropInput = "Conv2DBackpropInput";
const Conv3D$1 = "Conv3D";
const Conv3DBackpropFilterV2 = "Conv3DBackpropFilterV2";
const Conv3DBackpropInputV2 = "Conv3DBackpropInputV2";
const Cos = "Cos";
const Cosh = "Cosh";
const Cumprod = "Cumprod";
const Cumsum = "Cumsum";
const CropAndResize = "CropAndResize";
const DenseBincount = "DenseBincount";
const DepthToSpace = "DepthToSpace";
const DepthwiseConv2dNative = "DepthwiseConv2dNative";
const DepthwiseConv2dNativeBackpropFilter = "DepthwiseConv2dNativeBackpropFilter";
const DepthwiseConv2dNativeBackpropInput = "DepthwiseConv2dNativeBackpropInput";
const Diag = "Diag";
const Dilation2D = "Dilation2D";
const Dilation2DBackpropInput = "Dilation2DBackpropInput";
const Dilation2DBackpropFilter = "Dilation2DBackpropFilter";
const RealDiv = "RealDiv";
const Einsum = "Einsum";
const Elu$1 = "Elu";
const EluGrad = "EluGrad";
const Erf = "Erf";
const Equal = "Equal";
const Exp = "Exp";
const ExpandDims = "ExpandDims";
const Expm1 = "Expm1";
const FFT = "FFT";
const Fill = "Fill";
const FlipLeftRight = "FlipLeftRight";
const Floor = "Floor";
const FloorDiv = "FloorDiv";
const FusedBatchNorm = "FusedBatchNorm";
const GatherV2 = "GatherV2";
const GatherNd = "GatherNd";
const Greater = "Greater";
const GreaterEqual = "GreaterEqual";
const Identity$1 = "Identity";
const IFFT = "IFFT";
const Imag = "Imag";
const IsFinite = "IsFinite";
const IsInf = "IsInf";
const IsNan = "IsNan";
const LeakyRelu = "LeakyRelu";
const Less = "Less";
const LessEqual = "LessEqual";
const LinSpace = "LinSpace";
const Log = "Log";
const Log1p = "Log1p";
const LogicalAnd = "LogicalAnd";
const LogicalNot = "LogicalNot";
const LogicalOr = "LogicalOr";
const LogSoftmax$1 = "LogSoftmax";
const LRN = "LRN";
const LRNGrad = "LRNGrad";
const Max = "Max";
const Maximum$1 = "Maximum";
const MaxPool = "MaxPool";
const MaxPoolGrad = "MaxPoolGrad";
const MaxPool3D = "MaxPool3D";
const MaxPool3DGrad = "MaxPool3DGrad";
const MaxPoolWithArgmax = "MaxPoolWithArgmax";
const Mean = "Mean";
const Min = "Min";
const Minimum$1 = "Minimum";
const MirrorPad = "MirrorPad";
const Mod = "Mod";
const Multinomial = "Multinomial";
const Multiply$1 = "Multiply";
const Neg = "Neg";
const NotEqual = "NotEqual";
const NonMaxSuppressionV3 = "NonMaxSuppressionV3";
const NonMaxSuppressionV4 = "NonMaxSuppressionV4";
const NonMaxSuppressionV5 = "NonMaxSuppressionV5";
const OnesLike = "OnesLike";
const OneHot = "OneHot";
const Pack = "Pack";
const PadV2 = "PadV2";
const Pow = "Pow";
const Prelu = "Prelu";
const Prod = "Prod";
const Range = "Range";
const Real = "Real";
const Reciprocal = "Reciprocal";
const Relu$1 = "Relu";
const Reshape$1 = "Reshape";
const ResizeNearestNeighbor = "ResizeNearestNeighbor";
const ResizeNearestNeighborGrad = "ResizeNearestNeighborGrad";
const ResizeBilinear = "ResizeBilinear";
const ResizeBilinearGrad = "ResizeBilinearGrad";
const Relu6$1 = "Relu6";
const Reverse = "Reverse";
const Round = "Round";
const Rsqrt = "Rsqrt";
const ScatterNd = "ScatterNd";
const Select$1 = "Select";
const Selu$1 = "Selu";
const Slice = "Slice";
const Sin = "Sin";
const Sinh = "Sinh";
const Sign = "Sign";
const Sigmoid$1 = "Sigmoid";
const Softplus$1 = "Softplus";
const Sqrt = "Sqrt";
const Sum = "Sum";
const SpaceToBatchND = "SpaceToBatchND";
const SplitV = "SplitV";
const Softmax$2 = "Softmax";
const SparseFillEmptyRows = "SparseFillEmptyRows";
const SparseReshape = "SparseReshape";
const SparseSegmentMean = "SparseSegmentMean";
const SparseSegmentSum = "SparseSegmentSum";
const SparseToDense = "SparseToDense";
const SquaredDifference = "SquaredDifference";
const Square = "Square";
const StridedSlice = "StridedSlice";
const StringNGrams = "StringNGrams";
const StringSplit = "StringSplit";
const StringToHashBucketFast = "StringToHashBucketFast";
const Sub = "Sub";
const Tan = "Tan";
const Tanh$1 = "Tanh";
const Tile = "Tile";
const TopK = "TopK";
const Transform = "Transform";
const Transpose = "Transpose";
const Unique = "Unique";
const Unpack = "Unpack";
const UnsortedSegmentSum = "UnsortedSegmentSum";
const ZerosLike = "ZerosLike";
const Step = "Step";
const FromPixels = "FromPixels";
const RotateWithOffset = "RotateWithOffset";
const _FusedMatMul = "_FusedMatMul";
const FusedConv2D = "FusedConv2D";
const FusedDepthwiseConv2D = "FusedDepthwiseConv2D";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function warn(...msg) {
  if (!(env().getBool("IS_TEST") || env().getBool("PROD"))) {
    console.warn(...msg);
  }
}
function log$8(...msg) {
  if (!(env().getBool("IS_TEST") || env().getBool("PROD"))) {
    console.log(...msg);
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const kernelRegistry = getGlobal("kernelRegistry", () => /* @__PURE__ */ new Map());
const gradRegistry = getGlobal("gradRegistry", () => /* @__PURE__ */ new Map());
function getKernel(kernelName, backendName) {
  const key = makeKey(kernelName, backendName);
  return kernelRegistry.get(key);
}
function getGradient(kernelName) {
  return gradRegistry.get(kernelName);
}
function getKernelsForBackend(backendName) {
  const it = kernelRegistry.entries();
  const result2 = [];
  while (true) {
    const { done, value } = it.next();
    if (done) {
      break;
    }
    const [key, config2] = value;
    const [backend2] = key.split("_");
    if (backend2 === backendName) {
      result2.push(config2);
    }
  }
  return result2;
}
function registerKernel(config2) {
  const { kernelName, backendName } = config2;
  const key = makeKey(kernelName, backendName);
  if (kernelRegistry.has(key)) {
    warn(`The kernel '${kernelName}' for backend '${backendName}' is already registered`);
  }
  kernelRegistry.set(key, config2);
}
function registerGradient(config2) {
  const { kernelName } = config2;
  if (gradRegistry.has(kernelName)) {
    if (env().getBool("DEBUG")) {
      warn(`Overriding the gradient for '${kernelName}'`);
    }
  }
  gradRegistry.set(kernelName, config2);
}
function makeKey(kernelName, backendName) {
  return `${backendName}_${kernelName}`;
}
var long = Long$1;
var wasm = null;
try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (e2) {
}
function Long$1(low, high, unsigned) {
  this.low = low | 0;
  this.high = high | 0;
  this.unsigned = !!unsigned;
}
Long$1.prototype.__isLong__;
Object.defineProperty(Long$1.prototype, "__isLong__", { value: true });
function isLong(obj) {
  return (obj && obj["__isLong__"]) === true;
}
Long$1.isLong = isLong;
var INT_CACHE = {};
var UINT_CACHE = {};
function fromInt(value, unsigned) {
  var obj, cachedObj, cache;
  if (unsigned) {
    value >>>= 0;
    if (cache = 0 <= value && value < 256) {
      cachedObj = UINT_CACHE[value];
      if (cachedObj)
        return cachedObj;
    }
    obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
    if (cache)
      UINT_CACHE[value] = obj;
    return obj;
  } else {
    value |= 0;
    if (cache = -128 <= value && value < 128) {
      cachedObj = INT_CACHE[value];
      if (cachedObj)
        return cachedObj;
    }
    obj = fromBits(value, value < 0 ? -1 : 0, false);
    if (cache)
      INT_CACHE[value] = obj;
    return obj;
  }
}
Long$1.fromInt = fromInt;
function fromNumber(value, unsigned) {
  if (isNaN(value))
    return unsigned ? UZERO : ZERO;
  if (unsigned) {
    if (value < 0)
      return UZERO;
    if (value >= TWO_PWR_64_DBL)
      return MAX_UNSIGNED_VALUE;
  } else {
    if (value <= -TWO_PWR_63_DBL)
      return MIN_VALUE;
    if (value + 1 >= TWO_PWR_63_DBL)
      return MAX_VALUE;
  }
  if (value < 0)
    return fromNumber(-value, unsigned).neg();
  return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
}
Long$1.fromNumber = fromNumber;
function fromBits(lowBits, highBits, unsigned) {
  return new Long$1(lowBits, highBits, unsigned);
}
Long$1.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(str, unsigned, radix) {
  if (str.length === 0)
    throw Error("empty string");
  if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
    return ZERO;
  if (typeof unsigned === "number") {
    radix = unsigned, unsigned = false;
  } else {
    unsigned = !!unsigned;
  }
  radix = radix || 10;
  if (radix < 2 || 36 < radix)
    throw RangeError("radix");
  var p2;
  if ((p2 = str.indexOf("-")) > 0)
    throw Error("interior hyphen");
  else if (p2 === 0) {
    return fromString(str.substring(1), unsigned, radix).neg();
  }
  var radixToPower = fromNumber(pow_dbl(radix, 8));
  var result2 = ZERO;
  for (var i2 = 0; i2 < str.length; i2 += 8) {
    var size = Math.min(8, str.length - i2), value = parseInt(str.substring(i2, i2 + size), radix);
    if (size < 8) {
      var power = fromNumber(pow_dbl(radix, size));
      result2 = result2.mul(power).add(fromNumber(value));
    } else {
      result2 = result2.mul(radixToPower);
      result2 = result2.add(fromNumber(value));
    }
  }
  result2.unsigned = unsigned;
  return result2;
}
Long$1.fromString = fromString;
function fromValue(val, unsigned) {
  if (typeof val === "number")
    return fromNumber(val, unsigned);
  if (typeof val === "string")
    return fromString(val, unsigned);
  return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
Long$1.fromValue = fromValue;
var TWO_PWR_16_DBL = 1 << 16;
var TWO_PWR_24_DBL = 1 << 24;
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
var ZERO = fromInt(0);
Long$1.ZERO = ZERO;
var UZERO = fromInt(0, true);
Long$1.UZERO = UZERO;
var ONE = fromInt(1);
Long$1.ONE = ONE;
var UONE = fromInt(1, true);
Long$1.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long$1.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(4294967295 | 0, 2147483647 | 0, false);
Long$1.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(4294967295 | 0, 4294967295 | 0, true);
Long$1.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, 2147483648 | 0, false);
Long$1.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long$1.prototype;
LongPrototype.toInt = function toInt() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function toNumber2() {
  if (this.unsigned)
    return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
  return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function toString2(radix) {
  radix = radix || 10;
  if (radix < 2 || 36 < radix)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative()) {
    if (this.eq(MIN_VALUE)) {
      var radixLong = fromNumber(radix), div2 = this.div(radixLong), rem1 = div2.mul(radixLong).sub(this);
      return div2.toString(radix) + rem1.toInt().toString(radix);
    } else
      return "-" + this.neg().toString(radix);
  }
  var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
  var result2 = "";
  while (true) {
    var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
    rem = remDiv;
    if (rem.isZero())
      return digits + result2;
    else {
      while (digits.length < 6)
        digits = "0" + digits;
      result2 = "" + digits + result2;
    }
  }
};
LongPrototype.getHighBits = function getHighBits() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function getLowBits() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  var val = this.high != 0 ? this.high : this.low;
  for (var bit = 31; bit > 0; bit--)
    if ((val & 1 << bit) != 0)
      break;
  return this.high != 0 ? bit + 33 : bit + 1;
};
LongPrototype.isZero = function isZero2() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function isNegative() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function isPositive() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function isOdd() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function isEven2() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function equals(other) {
  if (!isLong(other))
    other = fromValue(other);
  if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1)
    return false;
  return this.high === other.high && this.low === other.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function notEquals(other) {
  return !this.eq(other);
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function lessThan(other) {
  return this.comp(other) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
  return this.comp(other) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function greaterThan(other) {
  return this.comp(other) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
  return this.comp(other) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function compare2(other) {
  if (!isLong(other))
    other = fromValue(other);
  if (this.eq(other))
    return 0;
  var thisNeg = this.isNegative(), otherNeg = other.isNegative();
  if (thisNeg && !otherNeg)
    return -1;
  if (!thisNeg && otherNeg)
    return 1;
  if (!this.unsigned)
    return this.sub(other).isNegative() ? -1 : 1;
  return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function negate() {
  if (!this.unsigned && this.eq(MIN_VALUE))
    return MIN_VALUE;
  return this.not().add(ONE);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function add2(addend) {
  if (!isLong(addend))
    addend = fromValue(addend);
  var a48 = this.high >>> 16;
  var a32 = this.high & 65535;
  var a16 = this.low >>> 16;
  var a00 = this.low & 65535;
  var b48 = addend.high >>> 16;
  var b32 = addend.high & 65535;
  var b16 = addend.low >>> 16;
  var b00 = addend.low & 65535;
  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 + b00;
  c16 += c00 >>> 16;
  c00 &= 65535;
  c16 += a16 + b16;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c32 += a32 + b32;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c48 += a48 + b48;
  c48 &= 65535;
  return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
LongPrototype.subtract = function subtract(subtrahend) {
  if (!isLong(subtrahend))
    subtrahend = fromValue(subtrahend);
  return this.add(subtrahend.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function multiply2(multiplier) {
  if (this.isZero())
    return ZERO;
  if (!isLong(multiplier))
    multiplier = fromValue(multiplier);
  if (wasm) {
    var low = wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
    return fromBits(low, wasm.get_high(), this.unsigned);
  }
  if (multiplier.isZero())
    return ZERO;
  if (this.eq(MIN_VALUE))
    return multiplier.isOdd() ? MIN_VALUE : ZERO;
  if (multiplier.eq(MIN_VALUE))
    return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative()) {
    if (multiplier.isNegative())
      return this.neg().mul(multiplier.neg());
    else
      return this.neg().mul(multiplier).neg();
  } else if (multiplier.isNegative())
    return this.mul(multiplier.neg()).neg();
  if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
  var a48 = this.high >>> 16;
  var a32 = this.high & 65535;
  var a16 = this.low >>> 16;
  var a00 = this.low & 65535;
  var b48 = multiplier.high >>> 16;
  var b32 = multiplier.high & 65535;
  var b16 = multiplier.low >>> 16;
  var b00 = multiplier.low & 65535;
  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 * b00;
  c16 += c00 >>> 16;
  c00 &= 65535;
  c16 += a16 * b00;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c16 += a00 * b16;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c32 += a32 * b00;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c32 += a16 * b16;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c32 += a00 * b32;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
  c48 &= 65535;
  return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function divide(divisor) {
  if (!isLong(divisor))
    divisor = fromValue(divisor);
  if (divisor.isZero())
    throw Error("division by zero");
  if (wasm) {
    if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) {
      return this;
    }
    var low = (this.unsigned ? wasm.div_u : wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
    return fromBits(low, wasm.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO : ZERO;
  var approx, rem, res;
  if (!this.unsigned) {
    if (this.eq(MIN_VALUE)) {
      if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
        return MIN_VALUE;
      else if (divisor.eq(MIN_VALUE))
        return ONE;
      else {
        var halfThis = this.shr(1);
        approx = halfThis.div(divisor).shl(1);
        if (approx.eq(ZERO)) {
          return divisor.isNegative() ? ONE : NEG_ONE;
        } else {
          rem = this.sub(divisor.mul(approx));
          res = approx.add(rem.div(divisor));
          return res;
        }
      }
    } else if (divisor.eq(MIN_VALUE))
      return this.unsigned ? UZERO : ZERO;
    if (this.isNegative()) {
      if (divisor.isNegative())
        return this.neg().div(divisor.neg());
      return this.neg().div(divisor).neg();
    } else if (divisor.isNegative())
      return this.div(divisor.neg()).neg();
    res = ZERO;
  } else {
    if (!divisor.unsigned)
      divisor = divisor.toUnsigned();
    if (divisor.gt(this))
      return UZERO;
    if (divisor.gt(this.shru(1)))
      return UONE;
    res = UZERO;
  }
  rem = this;
  while (rem.gte(divisor)) {
    approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
    var log22 = Math.ceil(Math.log(approx) / Math.LN2), delta = log22 <= 48 ? 1 : pow_dbl(2, log22 - 48), approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
    while (approxRem.isNegative() || approxRem.gt(rem)) {
      approx -= delta;
      approxRes = fromNumber(approx, this.unsigned);
      approxRem = approxRes.mul(divisor);
    }
    if (approxRes.isZero())
      approxRes = ONE;
    res = res.add(approxRes);
    rem = rem.sub(approxRem);
  }
  return res;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function modulo(divisor) {
  if (!isLong(divisor))
    divisor = fromValue(divisor);
  if (wasm) {
    var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
    return fromBits(low, wasm.get_high(), this.unsigned);
  }
  return this.sub(this.div(divisor).mul(divisor));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function not() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.and = function and(other) {
  if (!isLong(other))
    other = fromValue(other);
  return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
LongPrototype.or = function or(other) {
  if (!isLong(other))
    other = fromValue(other);
  return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
LongPrototype.xor = function xor(other) {
  if (!isLong(other))
    other = fromValue(other);
  return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
LongPrototype.shiftLeft = function shiftLeft(numBits) {
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  else if (numBits < 32)
    return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
  else
    return fromBits(0, this.low << numBits - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function shiftRight(numBits) {
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  else if (numBits < 32)
    return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
  else
    return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
  if (isLong(numBits))
    numBits = numBits.toInt();
  numBits &= 63;
  if (numBits === 0)
    return this;
  else {
    var high = this.high;
    if (numBits < 32) {
      var low = this.low;
      return fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
    } else if (numBits === 32)
      return fromBits(high, 0, this.unsigned);
    else
      return fromBits(high >>> numBits - 32, 0, this.unsigned);
  }
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.toSigned = function toSigned() {
  if (!this.unsigned)
    return this;
  return fromBits(this.low, this.high, false);
};
LongPrototype.toUnsigned = function toUnsigned() {
  if (this.unsigned)
    return this;
  return fromBits(this.low, this.high, true);
};
LongPrototype.toBytes = function toBytes(le) {
  return le ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function toBytesLE() {
  var hi = this.high, lo = this.low;
  return [
    lo & 255,
    lo >>> 8 & 255,
    lo >>> 16 & 255,
    lo >>> 24,
    hi & 255,
    hi >>> 8 & 255,
    hi >>> 16 & 255,
    hi >>> 24
  ];
};
LongPrototype.toBytesBE = function toBytesBE() {
  var hi = this.high, lo = this.low;
  return [
    hi >>> 24,
    hi >>> 16 & 255,
    hi >>> 8 & 255,
    hi & 255,
    lo >>> 24,
    lo >>> 16 & 255,
    lo >>> 8 & 255,
    lo & 255
  ];
};
Long$1.fromBytes = function fromBytes(bytes, unsigned, le) {
  return le ? Long$1.fromBytesLE(bytes, unsigned) : Long$1.fromBytesBE(bytes, unsigned);
};
Long$1.fromBytesLE = function fromBytesLE(bytes, unsigned) {
  return new Long$1(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
Long$1.fromBytesBE = function fromBytesBE(bytes, unsigned) {
  return new Long$1(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};
var LongExports = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  "default": long
}, [long]);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const Long = long || LongExports;
function hexToLong(hex2) {
  return Long.fromString(hex2, true, 16);
}
const k0 = hexToLong("c3a5c85c97cb3127");
const k1 = hexToLong("b492b66fbe98f273");
const k2 = hexToLong("9ae16a3b2f90404f");
function shiftMix(val) {
  return val.xor(val.shru(47));
}
function fetch$2(s2, offset, numBytes) {
  const bytes = s2.slice(offset, offset + numBytes);
  return Long.fromBytes(Array.from(bytes), true, true);
}
function fetch64(s2, offset) {
  return fetch$2(s2, offset, 8);
}
function fetch32(s2, offset) {
  return fetch$2(s2, offset, 4);
}
function rotate64(val, shift) {
  return shift === 0 ? val : val.shru(shift).or(val.shl(64 - shift));
}
function hashLen16(u2, v2, mul2 = hexToLong("9ddfea08eb382d69")) {
  let a6 = u2.xor(v2).mul(mul2);
  a6 = a6.xor(a6.shru(47));
  let b2 = v2.xor(a6).mul(mul2);
  b2 = b2.xor(b2.shru(47));
  b2 = b2.mul(mul2);
  return b2;
}
function weakHashLen32WithSeeds(w2, x2, y2, z2, a6, b2) {
  a6 = a6.add(w2);
  b2 = rotate64(b2.add(a6).add(z2), 21);
  const c2 = a6;
  a6 = a6.add(x2);
  a6 = a6.add(y2);
  b2 = b2.add(rotate64(a6, 44));
  return [a6.add(z2), b2.add(c2)];
}
function weakHashLen32WithSeedsStr(s2, offset, a6, b2) {
  return weakHashLen32WithSeeds(fetch64(s2, offset), fetch64(s2, offset + 8), fetch64(s2, offset + 16), fetch64(s2, offset + 24), a6, b2);
}
function hashLen0to16(s2, len = s2.length) {
  if (len >= 8) {
    const mul2 = k2.add(len * 2);
    const a6 = fetch64(s2, 0).add(k2);
    const b2 = fetch64(s2, len - 8);
    const c2 = rotate64(b2, 37).mul(mul2).add(a6);
    const d2 = rotate64(a6, 25).add(b2).mul(mul2);
    return hashLen16(c2, d2, mul2);
  }
  if (len >= 4) {
    const mul2 = k2.add(len * 2);
    const a6 = fetch32(s2, 0);
    return hashLen16(a6.shl(3).add(len), fetch32(s2, len - 4), mul2);
  }
  if (len > 0) {
    const a6 = s2[0];
    const b2 = s2[len >> 1];
    const c2 = s2[len - 1];
    const y2 = a6 + (b2 << 8);
    const z2 = len + (c2 << 2);
    return shiftMix(k2.mul(y2).xor(k0.mul(z2))).mul(k2);
  }
  return k2;
}
function hashLen17to32(s2, len = s2.length) {
  const mul2 = k2.add(len * 2);
  const a6 = fetch64(s2, 0).mul(k1);
  const b2 = fetch64(s2, 8);
  const c2 = fetch64(s2, len - 8).mul(mul2);
  const d2 = fetch64(s2, len - 16).mul(k2);
  return hashLen16(rotate64(a6.add(b2), 43).add(rotate64(c2, 30)).add(d2), a6.add(rotate64(b2.add(k2), 18)).add(c2), mul2);
}
function hashLen33to64(s2, len = s2.length) {
  const mul2 = k2.add(len * 2);
  const a6 = fetch64(s2, 0).mul(k2);
  const b2 = fetch64(s2, 8);
  const c2 = fetch64(s2, len - 8).mul(mul2);
  const d2 = fetch64(s2, len - 16).mul(k2);
  const y2 = rotate64(a6.add(b2), 43).add(rotate64(c2, 30)).add(d2);
  const z2 = hashLen16(y2, a6.add(rotate64(b2.add(k2), 18)).add(c2), mul2);
  const e2 = fetch64(s2, 16).mul(mul2);
  const f2 = fetch64(s2, 24);
  const g2 = y2.add(fetch64(s2, len - 32)).mul(mul2);
  const h2 = z2.add(fetch64(s2, len - 24)).mul(mul2);
  return hashLen16(rotate64(e2.add(f2), 43).add(rotate64(g2, 30)).add(h2), e2.add(rotate64(f2.add(a6), 18)).add(g2), mul2);
}
function fingerPrint64(s2, len = s2.length) {
  const seed = Long.fromNumber(81, true);
  if (len <= 32) {
    if (len <= 16) {
      return hashLen0to16(s2, len);
    } else {
      return hashLen17to32(s2, len);
    }
  } else if (len <= 64) {
    return hashLen33to64(s2, len);
  }
  let x2 = seed;
  let y2 = seed.mul(k1).add(113);
  let z2 = shiftMix(y2.mul(k2).add(113)).mul(k2);
  let v2 = [Long.UZERO, Long.UZERO];
  let w2 = [Long.UZERO, Long.UZERO];
  x2 = x2.mul(k2).add(fetch64(s2, 0));
  let offset = 0;
  const end = (len - 1 >> 6) * 64;
  const last64 = end + (len - 1 & 63) - 63;
  do {
    x2 = rotate64(x2.add(y2).add(v2[0]).add(fetch64(s2, offset + 8)), 37).mul(k1);
    y2 = rotate64(y2.add(v2[1]).add(fetch64(s2, offset + 48)), 42).mul(k1);
    x2 = x2.xor(w2[1]);
    y2 = y2.add(v2[0]).add(fetch64(s2, offset + 40));
    z2 = rotate64(z2.add(w2[0]), 33).mul(k1);
    v2 = weakHashLen32WithSeedsStr(s2, offset, v2[1].mul(k1), x2.add(w2[0]));
    w2 = weakHashLen32WithSeedsStr(s2, offset + 32, z2.add(w2[1]), y2.add(fetch64(s2, offset + 16)));
    [z2, x2] = [x2, z2];
    offset += 64;
  } while (offset !== end);
  const mul2 = k1.add(z2.and(255).shl(1));
  offset = last64;
  w2[0] = w2[0].add(len - 1 & 63);
  v2[0] = v2[0].add(w2[0]);
  w2[0] = w2[0].add(v2[0]);
  x2 = rotate64(x2.add(y2).add(v2[0]).add(fetch64(s2, offset + 8)), 37).mul(mul2);
  y2 = rotate64(y2.add(v2[1]).add(fetch64(s2, offset + 48)), 42).mul(mul2);
  x2 = x2.xor(w2[1].mul(9));
  y2 = y2.add(v2[0].mul(9).add(fetch64(s2, offset + 40)));
  z2 = rotate64(z2.add(w2[0]), 33).mul(mul2);
  v2 = weakHashLen32WithSeedsStr(s2, offset, v2[1].mul(mul2), x2.add(w2[0]));
  w2 = weakHashLen32WithSeedsStr(s2, offset + 32, z2.add(w2[1]), y2.add(fetch64(s2, offset + 16)));
  [z2, x2] = [x2, z2];
  return hashLen16(hashLen16(v2[0], w2[0], mul2).add(shiftMix(y2).mul(k0)).add(z2), hashLen16(v2[1], w2[1], mul2).add(x2), mul2);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function createScalarValue(value, dtype) {
  if (dtype === "string") {
    return encodeString(value);
  }
  return toTypedArray([value], dtype);
}
function noConversionNeeded(a6, dtype) {
  return a6 instanceof Float32Array && dtype === "float32" || a6 instanceof Int32Array && dtype === "int32" || a6 instanceof Uint8Array && dtype === "bool";
}
function toTypedArray(a6, dtype) {
  if (dtype === "string") {
    throw new Error("Cannot convert a string[] to a TypedArray");
  }
  if (Array.isArray(a6)) {
    a6 = flatten$1(a6);
  }
  if (env().getBool("DEBUG")) {
    checkConversionForErrors(a6, dtype);
  }
  if (noConversionNeeded(a6, dtype)) {
    return a6;
  }
  if (dtype == null || dtype === "float32" || dtype === "complex64") {
    return new Float32Array(a6);
  } else if (dtype === "int32") {
    return new Int32Array(a6);
  } else if (dtype === "bool") {
    const bool = new Uint8Array(a6.length);
    for (let i2 = 0; i2 < bool.length; ++i2) {
      if (Math.round(a6[i2]) !== 0) {
        bool[i2] = 1;
      }
    }
    return bool;
  } else {
    throw new Error(`Unknown data type ${dtype}`);
  }
}
function now() {
  return env().platform.now();
}
function fetch$1(path2, requestInits) {
  return env().platform.fetch(path2, requestInits);
}
function encodeString(s2, encoding = "utf-8") {
  encoding = encoding || "utf-8";
  return env().platform.encode(s2, encoding);
}
function decodeString(bytes, encoding = "utf-8") {
  encoding = encoding || "utf-8";
  return env().platform.decode(bytes, encoding);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Profiler {
  constructor(backendTimer, logger) {
    this.backendTimer = backendTimer;
    this.logger = logger;
    if (logger == null) {
      this.logger = new Logger();
    }
  }
  profileKernel(kernelName, inputs, f2) {
    let outputs;
    const holdResultWrapperFn = () => {
      outputs = f2();
    };
    let timer2;
    const start = now();
    if (this.backendTimer.timerAvailable()) {
      timer2 = this.backendTimer.time(holdResultWrapperFn);
    } else {
      holdResultWrapperFn();
      for (const output2 of outputs) {
        output2.dataSync();
      }
      timer2 = Promise.resolve({ kernelMs: now() - start });
    }
    if (env().getBool("CHECK_COMPUTATION_FOR_ERRORS")) {
      for (let i2 = 0; i2 < outputs.length; i2++) {
        const output2 = outputs[i2];
        output2.data().then((tensorVals) => {
          checkComputationForErrors(tensorVals, output2.dtype, kernelName);
        });
      }
    }
    const kernelProfile = {
      kernelName,
      outputs,
      inputs,
      timeMs: timer2.then((timing) => timing.kernelMs),
      extraInfo: timer2.then((timing) => timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : "")
    };
    return kernelProfile;
  }
  logKernelProfile(kernelProfile) {
    const { kernelName, outputs, timeMs, inputs, extraInfo } = kernelProfile;
    outputs.forEach((result2) => {
      Promise.all([result2.data(), timeMs, extraInfo]).then((valueContainer) => {
        this.logger.logKernelProfile(kernelName, result2, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
      });
    });
  }
}
function checkComputationForErrors(vals, dtype, kernelName) {
  if (dtype !== "float32") {
    return false;
  }
  for (let i2 = 0; i2 < vals.length; i2++) {
    const num = vals[i2];
    if (isNaN(num) || !isFinite(num)) {
      console.warn(`Found ${num} in the result of '${kernelName}'`);
      return true;
    }
  }
  return false;
}
class Logger {
  logKernelProfile(name, result2, vals, timeMs, inputs, extraInfo) {
    const time = typeof timeMs === "number" ? rightPad(`${timeMs}ms`, 9) : timeMs["error"];
    const paddedName = rightPad(name, 25);
    const rank = result2.rank;
    const size = result2.size;
    const shape = rightPad(result2.shape.toString(), 14);
    let inputShapesDescription = "";
    for (const name2 in inputs) {
      const input = inputs[name2];
      if (input != null) {
        const inputShape = input.shape || result2.shape;
        const inputRank = inputShape.length;
        inputShapesDescription += `${name2}: ${inputRank}D ${inputRank > 0 ? inputShape : ""} `;
      }
    }
    console.log(`%c${paddedName}	%c${time}	%c${rank}D ${shape}	%c${size}	%c${inputShapesDescription}	%c${extraInfo}`, "font-weight:bold", "color:red", "color:blue", "color: orange", "color: green", "color: steelblue");
  }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getFilteredNodesXToY(tape, xs, y2) {
  const tensorsFromX = {};
  const nodesFromX = {};
  for (let i2 = 0; i2 < xs.length; i2++) {
    tensorsFromX[xs[i2].id] = true;
  }
  for (let i2 = 0; i2 < tape.length; i2++) {
    const node = tape[i2];
    const nodeInputs = node.inputs;
    for (const inputName in nodeInputs) {
      const input = nodeInputs[inputName];
      let anyInputFromX = false;
      for (let j2 = 0; j2 < xs.length; j2++) {
        if (tensorsFromX[input.id]) {
          node.outputs.forEach((output2) => tensorsFromX[output2.id] = true);
          anyInputFromX = true;
          nodesFromX[node.id] = true;
          break;
        }
      }
      if (anyInputFromX) {
        break;
      }
    }
  }
  const tensorsLeadToY = {};
  tensorsLeadToY[y2.id] = true;
  const nodesToY = {};
  for (let i2 = tape.length - 1; i2 >= 0; i2--) {
    const node = tape[i2];
    const nodeInputs = node.inputs;
    for (let j2 = 0; j2 < node.outputs.length; j2++) {
      if (tensorsLeadToY[node.outputs[j2].id]) {
        for (const inputName in nodeInputs) {
          tensorsLeadToY[nodeInputs[inputName].id] = true;
          nodesToY[node.id] = true;
        }
        break;
      }
    }
  }
  const filteredTape = [];
  for (let i2 = 0; i2 < tape.length; i2++) {
    const node = tape[i2];
    if (nodesFromX[node.id] && nodesToY[node.id]) {
      const prunedInputs = {};
      for (const inputName in node.inputs) {
        const nodeInput = node.inputs[inputName];
        if (tensorsFromX[nodeInput.id]) {
          prunedInputs[inputName] = nodeInput;
        }
      }
      const prunedNode = Object.assign({}, node);
      prunedNode.inputs = prunedInputs;
      prunedNode.outputs = node.outputs;
      filteredTape.push(prunedNode);
    }
  }
  return filteredTape;
}
function backpropagateGradients(tensorAccumulatedGradientMap, filteredTape, tidy2, add4) {
  for (let i2 = filteredTape.length - 1; i2 >= 0; i2--) {
    const node = filteredTape[i2];
    const dys = [];
    node.outputs.forEach((o) => {
      const gradTensor = tensorAccumulatedGradientMap[o.id];
      if (gradTensor != null) {
        dys.push(gradTensor);
      } else {
        dys.push(null);
      }
    });
    if (node.gradient == null) {
      throw new Error(`Cannot compute gradient: gradient function not found for ${node.kernelName}.`);
    }
    const inputGradients = node.gradient(dys);
    for (const inputName in node.inputs) {
      if (!(inputName in inputGradients)) {
        throw new Error(`Cannot backprop through input ${inputName}. Available gradients found: ${Object.keys(inputGradients)}.`);
      }
      const dx = tidy2(() => inputGradients[inputName]());
      if (dx.dtype !== "float32") {
        throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ${inputName} must have 'float32' dtype, but has '${dx.dtype}'`);
      }
      const x2 = node.inputs[inputName];
      if (!arraysEqual(dx.shape, x2.shape)) {
        throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input '${inputName}' has shape '${dx.shape}', which does not match the shape of the input '${x2.shape}'`);
      }
      if (tensorAccumulatedGradientMap[x2.id] == null) {
        tensorAccumulatedGradientMap[x2.id] = dx;
      } else {
        const curGradient = tensorAccumulatedGradientMap[x2.id];
        tensorAccumulatedGradientMap[x2.id] = add4(curGradient, dx);
        curGradient.dispose();
      }
    }
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const FORMAT_LIMIT_NUM_VALS = 20;
const FORMAT_NUM_FIRST_LAST_VALS = 3;
const FORMAT_NUM_SIG_DIGITS = 7;
function tensorToString(vals, shape, dtype, verbose) {
  const strides = computeStrides(shape);
  const padPerCol = computeMaxSizePerColumn(vals, shape, dtype, strides);
  const rank = shape.length;
  const valsLines = subTensorToString(vals, shape, dtype, strides, padPerCol);
  const lines = ["Tensor"];
  if (verbose) {
    lines.push(`  dtype: ${dtype}`);
    lines.push(`  rank: ${rank}`);
    lines.push(`  shape: [${shape}]`);
    lines.push(`  values:`);
  }
  lines.push(valsLines.map((l2) => "    " + l2).join("\n"));
  return lines.join("\n");
}
function computeMaxSizePerColumn(vals, shape, dtype, strides) {
  const n2 = sizeFromShape(shape);
  const numCols = strides[strides.length - 1];
  const padPerCol = new Array(numCols).fill(0);
  const rank = shape.length;
  const valuesOrTuples = dtype === "complex64" ? createComplexTuples(vals) : vals;
  if (rank > 1) {
    for (let row = 0; row < n2 / numCols; row++) {
      const offset = row * numCols;
      for (let j2 = 0; j2 < numCols; j2++) {
        padPerCol[j2] = Math.max(padPerCol[j2], valToString(valuesOrTuples[offset + j2], 0, dtype).length);
      }
    }
  }
  return padPerCol;
}
function valToString(val, pad2, dtype) {
  let valStr;
  if (Array.isArray(val)) {
    valStr = `${parseFloat(val[0].toFixed(FORMAT_NUM_SIG_DIGITS))} + ${parseFloat(val[1].toFixed(FORMAT_NUM_SIG_DIGITS))}j`;
  } else if (isString$4(val)) {
    valStr = `'${val}'`;
  } else if (dtype === "bool") {
    valStr = boolNumToString(val);
  } else {
    valStr = parseFloat(val.toFixed(FORMAT_NUM_SIG_DIGITS)).toString();
  }
  return rightPad(valStr, pad2);
}
function boolNumToString(v2) {
  return v2 === 0 ? "false" : "true";
}
function subTensorToString(vals, shape, dtype, strides, padPerCol, isLast = true) {
  const storagePerElement = dtype === "complex64" ? 2 : 1;
  const size = shape[0];
  const rank = shape.length;
  if (rank === 0) {
    if (dtype === "complex64") {
      const complexTuple = createComplexTuples(vals);
      return [valToString(complexTuple[0], 0, dtype)];
    }
    if (dtype === "bool") {
      return [boolNumToString(vals[0])];
    }
    return [vals[0].toString()];
  }
  if (rank === 1) {
    if (size > FORMAT_LIMIT_NUM_VALS) {
      const firstValsSize = FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
      let firstVals = Array.from(vals.slice(0, firstValsSize));
      let lastVals = Array.from(vals.slice((size - FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
      if (dtype === "complex64") {
        firstVals = createComplexTuples(firstVals);
        lastVals = createComplexTuples(lastVals);
      }
      return [
        "[" + firstVals.map((x2, i2) => valToString(x2, padPerCol[i2], dtype)).join(", ") + ", ..., " + lastVals.map((x2, i2) => valToString(x2, padPerCol[size - FORMAT_NUM_FIRST_LAST_VALS + i2], dtype)).join(", ") + "]"
      ];
    }
    const displayVals = dtype === "complex64" ? createComplexTuples(vals) : Array.from(vals);
    return [
      "[" + displayVals.map((x2, i2) => valToString(x2, padPerCol[i2], dtype)).join(", ") + "]"
    ];
  }
  const subshape = shape.slice(1);
  const substrides = strides.slice(1);
  const stride = strides[0] * storagePerElement;
  const lines = [];
  if (size > FORMAT_LIMIT_NUM_VALS) {
    for (let i2 = 0; i2 < FORMAT_NUM_FIRST_LAST_VALS; i2++) {
      const start = i2 * stride;
      const end = start + stride;
      lines.push(...subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false));
    }
    lines.push("...");
    for (let i2 = size - FORMAT_NUM_FIRST_LAST_VALS; i2 < size; i2++) {
      const start = i2 * stride;
      const end = start + stride;
      lines.push(...subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i2 === size - 1));
    }
  } else {
    for (let i2 = 0; i2 < size; i2++) {
      const start = i2 * stride;
      const end = start + stride;
      lines.push(...subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i2 === size - 1));
    }
  }
  const sep = rank === 2 ? "," : "";
  lines[0] = "[" + lines[0] + sep;
  for (let i2 = 1; i2 < lines.length - 1; i2++) {
    lines[i2] = " " + lines[i2] + sep;
  }
  let newLineSep = ",\n";
  for (let i2 = 2; i2 < rank; i2++) {
    newLineSep += "\n";
  }
  lines[lines.length - 1] = " " + lines[lines.length - 1] + "]" + (isLast ? "" : newLineSep);
  return lines;
}
function createComplexTuples(vals) {
  const complexTuples = [];
  for (let i2 = 0; i2 < vals.length; i2 += 2) {
    complexTuples.push([vals[i2], vals[i2 + 1]]);
  }
  return complexTuples;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TensorBuffer {
  constructor(shape, dtype, values) {
    this.dtype = dtype;
    this.shape = shape.slice();
    this.size = sizeFromShape(shape);
    if (values != null) {
      const n2 = values.length;
      assert$1(n2 === this.size, () => `Length of values '${n2}' does not match the size inferred by the shape '${this.size}'.`);
    }
    if (dtype === "complex64") {
      throw new Error(`complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).`);
    }
    this.values = values || getArrayFromDType(dtype, this.size);
    this.strides = computeStrides(shape);
  }
  set(value, ...locs) {
    if (locs.length === 0) {
      locs = [0];
    }
    assert$1(locs.length === this.rank, () => `The number of provided coordinates (${locs.length}) must match the rank (${this.rank})`);
    const index2 = this.locToIndex(locs);
    this.values[index2] = value;
  }
  get(...locs) {
    if (locs.length === 0) {
      locs = [0];
    }
    let i2 = 0;
    for (const loc of locs) {
      if (loc < 0 || loc >= this.shape[i2]) {
        const msg = `Requested out of range element at ${locs}.   Buffer shape=${this.shape}`;
        throw new Error(msg);
      }
      i2++;
    }
    let index2 = locs[locs.length - 1];
    for (let i3 = 0; i3 < locs.length - 1; ++i3) {
      index2 += this.strides[i3] * locs[i3];
    }
    return this.values[index2];
  }
  locToIndex(locs) {
    if (this.rank === 0) {
      return 0;
    } else if (this.rank === 1) {
      return locs[0];
    }
    let index2 = locs[locs.length - 1];
    for (let i2 = 0; i2 < locs.length - 1; ++i2) {
      index2 += this.strides[i2] * locs[i2];
    }
    return index2;
  }
  indexToLoc(index2) {
    if (this.rank === 0) {
      return [];
    } else if (this.rank === 1) {
      return [index2];
    }
    const locs = new Array(this.shape.length);
    for (let i2 = 0; i2 < locs.length - 1; ++i2) {
      locs[i2] = Math.floor(index2 / this.strides[i2]);
      index2 -= locs[i2] * this.strides[i2];
    }
    locs[locs.length - 1] = index2;
    return locs;
  }
  get rank() {
    return this.shape.length;
  }
  toTensor() {
    return trackerFn().makeTensor(this.values, this.shape, this.dtype);
  }
}
let trackerFn = null;
let opHandler$1 = null;
function setTensorTracker(fn) {
  trackerFn = fn;
}
function setOpHandler(handler) {
  opHandler$1 = handler;
}
class Tensor {
  constructor(shape, dtype, dataId, id2) {
    this.kept = false;
    this.isDisposedInternal = false;
    this.shape = shape.slice();
    this.dtype = dtype || "float32";
    this.size = sizeFromShape(shape);
    this.strides = computeStrides(shape);
    this.dataId = dataId;
    this.id = id2;
    this.rankType = this.rank < 5 ? this.rank.toString() : "higher";
  }
  get rank() {
    return this.shape.length;
  }
  async buffer() {
    const vals = await this.data();
    return opHandler$1.buffer(this.shape, this.dtype, vals);
  }
  bufferSync() {
    return opHandler$1.buffer(this.shape, this.dtype, this.dataSync());
  }
  async array() {
    const vals = await this.data();
    return toNestedArray(this.shape, vals, this.dtype === "complex64");
  }
  arraySync() {
    return toNestedArray(this.shape, this.dataSync(), this.dtype === "complex64");
  }
  async data() {
    this.throwIfDisposed();
    const data2 = trackerFn().read(this.dataId);
    if (this.dtype === "string") {
      const bytes = await data2;
      try {
        return bytes.map((b2) => decodeString(b2));
      } catch (_a) {
        throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
      }
    }
    return data2;
  }
  dataToGPU(options) {
    this.throwIfDisposed();
    return trackerFn().readToGPU(this.dataId, options);
  }
  dataSync() {
    this.throwIfDisposed();
    const data2 = trackerFn().readSync(this.dataId);
    if (this.dtype === "string") {
      try {
        return data2.map((b2) => decodeString(b2));
      } catch (_a) {
        throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
      }
    }
    return data2;
  }
  async bytes() {
    this.throwIfDisposed();
    const data2 = await trackerFn().read(this.dataId);
    if (this.dtype === "string") {
      return data2;
    } else {
      return new Uint8Array(data2.buffer);
    }
  }
  dispose() {
    if (this.isDisposed) {
      return;
    }
    trackerFn().disposeTensor(this);
    this.isDisposedInternal = true;
  }
  get isDisposed() {
    return this.isDisposedInternal;
  }
  throwIfDisposed() {
    if (this.isDisposed) {
      throw new Error(`Tensor is disposed.`);
    }
  }
  print(verbose = false) {
    return opHandler$1.print(this, verbose);
  }
  clone() {
    this.throwIfDisposed();
    return opHandler$1.clone(this);
  }
  toString(verbose = false) {
    const vals = this.dataSync();
    return tensorToString(vals, this.shape, this.dtype, verbose);
  }
  cast(dtype) {
    this.throwIfDisposed();
    return opHandler$1.cast(this, dtype);
  }
  variable(trainable = true, name, dtype) {
    this.throwIfDisposed();
    return trackerFn().makeVariable(this, trainable, name, dtype);
  }
}
Object.defineProperty(Tensor, Symbol.hasInstance, {
  value: (instance2) => {
    return !!instance2 && instance2.data != null && instance2.dataSync != null && instance2.throwIfDisposed != null;
  }
});
function getGlobalTensorClass() {
  return getGlobal("Tensor", () => {
    return Tensor;
  });
}
getGlobalTensorClass();
class Variable extends Tensor {
  constructor(initialValue, trainable, name, tensorId) {
    super(initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId);
    this.trainable = trainable;
    this.name = name;
  }
  assign(newValue) {
    if (newValue.dtype !== this.dtype) {
      throw new Error(`dtype of the new value (${newValue.dtype}) and previous value (${this.dtype}) must match`);
    }
    if (!arraysEqual(newValue.shape, this.shape)) {
      throw new Error(`shape of the new value (${newValue.shape}) and previous value (${this.shape}) must match`);
    }
    trackerFn().disposeTensor(this);
    this.dataId = newValue.dataId;
    trackerFn().incRef(this, null);
  }
  dispose() {
    trackerFn().disposeVariable(this);
    this.isDisposedInternal = true;
  }
}
Object.defineProperty(Variable, Symbol.hasInstance, {
  value: (instance2) => {
    return instance2 instanceof Tensor && instance2.assign != null && instance2.assign instanceof Function;
  }
});
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var Rank;
(function(Rank2) {
  Rank2["R0"] = "R0";
  Rank2["R1"] = "R1";
  Rank2["R2"] = "R2";
  Rank2["R3"] = "R3";
  Rank2["R4"] = "R4";
  Rank2["R5"] = "R5";
  Rank2["R6"] = "R6";
})(Rank || (Rank = {}));
var UpcastInt32AndMap;
(function(UpcastInt32AndMap2) {
  UpcastInt32AndMap2["float32"] = "float32";
  UpcastInt32AndMap2["int32"] = "int32";
  UpcastInt32AndMap2["bool"] = "int32";
  UpcastInt32AndMap2["complex64"] = "complex64";
})(UpcastInt32AndMap || (UpcastInt32AndMap = {}));
var UpcastBoolAndMap;
(function(UpcastBoolAndMap2) {
  UpcastBoolAndMap2["float32"] = "float32";
  UpcastBoolAndMap2["int32"] = "int32";
  UpcastBoolAndMap2["bool"] = "bool";
  UpcastBoolAndMap2["complex64"] = "complex64";
})(UpcastBoolAndMap || (UpcastBoolAndMap = {}));
var UpcastFloat32AndMap;
(function(UpcastFloat32AndMap2) {
  UpcastFloat32AndMap2["float32"] = "float32";
  UpcastFloat32AndMap2["int32"] = "float32";
  UpcastFloat32AndMap2["bool"] = "float32";
  UpcastFloat32AndMap2["complex64"] = "complex64";
})(UpcastFloat32AndMap || (UpcastFloat32AndMap = {}));
var UpcastComplex64AndMap;
(function(UpcastComplex64AndMap2) {
  UpcastComplex64AndMap2["float32"] = "complex64";
  UpcastComplex64AndMap2["int32"] = "complex64";
  UpcastComplex64AndMap2["bool"] = "complex64";
  UpcastComplex64AndMap2["complex64"] = "complex64";
})(UpcastComplex64AndMap || (UpcastComplex64AndMap = {}));
const upcastTypeMap = {
  "float32": UpcastFloat32AndMap,
  "int32": UpcastInt32AndMap,
  "bool": UpcastBoolAndMap,
  "complex64": UpcastComplex64AndMap
};
function upcastType(typeA, typeB) {
  if (typeA === "string" || typeB === "string") {
    if (typeA === "string" && typeB === "string") {
      return "string";
    }
    throw new Error(`Can not upcast ${typeA} with ${typeB}`);
  }
  return upcastTypeMap[typeA][typeB];
}
function sumOutType(type) {
  return upcastType(type, "int32");
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function makeTypesMatch(a6, b2) {
  if (a6.dtype === b2.dtype) {
    return [a6, b2];
  }
  const dtype = upcastType(a6.dtype, b2.dtype);
  return [a6.cast(dtype), b2.cast(dtype)];
}
function getTensorsInContainer(result2) {
  const list = [];
  const seen = /* @__PURE__ */ new Set();
  walkTensorContainer(result2, list, seen);
  return list;
}
function walkTensorContainer(container, list, seen) {
  if (container == null) {
    return;
  }
  if (container instanceof Tensor) {
    list.push(container);
    return;
  }
  if (!isIterable(container)) {
    return;
  }
  const iterable = container;
  for (const k3 in iterable) {
    const val = iterable[k3];
    if (!seen.has(val)) {
      seen.add(val);
      walkTensorContainer(val, list, seen);
    }
  }
}
function isIterable(obj) {
  return Array.isArray(obj) || typeof obj === "object";
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function isRegisteredKernelInvocation(kernelInvocation) {
  return kernelInvocation.kernelName != null;
}
class EngineState {
  constructor() {
    this.registeredVariables = {};
    this.nextTapeNodeId = 0;
    this.numBytes = 0;
    this.numTensors = 0;
    this.numStringTensors = 0;
    this.numDataBuffers = 0;
    this.gradientDepth = 0;
    this.kernelDepth = 0;
    this.scopeStack = [];
    this.numDataMovesStack = [];
    this.nextScopeId = 0;
    this.tensorInfo = /* @__PURE__ */ new WeakMap();
    this.profiling = false;
    this.activeProfile = {
      newBytes: 0,
      newTensors: 0,
      peakBytes: 0,
      kernels: [],
      result: null,
      get kernelNames() {
        return Array.from(new Set(this.kernels.map((k3) => k3.name)));
      }
    };
  }
  dispose() {
    for (const variableName in this.registeredVariables) {
      this.registeredVariables[variableName].dispose();
    }
  }
}
class Engine {
  constructor(ENV2) {
    this.ENV = ENV2;
    this.registry = {};
    this.registryFactory = {};
    this.pendingBackendInitId = 0;
    this.state = new EngineState();
  }
  async ready() {
    if (this.pendingBackendInit != null) {
      return this.pendingBackendInit.then(() => {
      });
    }
    if (this.backendInstance != null) {
      return;
    }
    const sortedBackends = this.getSortedBackends();
    for (let i2 = 0; i2 < sortedBackends.length; i2++) {
      const backendName = sortedBackends[i2];
      const success = await this.initializeBackend(backendName).success;
      if (success) {
        await this.setBackend(backendName);
        return;
      }
    }
    throw new Error(`Could not initialize any backends, all backend initializations failed.`);
  }
  get backend() {
    if (this.pendingBackendInit != null) {
      throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods`);
    }
    if (this.backendInstance == null) {
      const { name, asyncInit } = this.initializeBackendsAndReturnBest();
      if (asyncInit) {
        throw new Error(`The highest priority backend '${name}' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods`);
      }
      this.setBackend(name);
    }
    return this.backendInstance;
  }
  backendNames() {
    return Object.keys(this.registryFactory);
  }
  findBackend(backendName) {
    if (!(backendName in this.registry)) {
      if (backendName in this.registryFactory) {
        const { asyncInit } = this.initializeBackend(backendName);
        if (asyncInit) {
          return null;
        }
      } else {
        return null;
      }
    }
    return this.registry[backendName];
  }
  findBackendFactory(backendName) {
    if (!(backendName in this.registryFactory)) {
      return null;
    }
    return this.registryFactory[backendName].factory;
  }
  registerBackend(backendName, factory, priority = 1) {
    if (backendName in this.registryFactory) {
      warn(`${backendName} backend was already registered. Reusing existing backend factory.`);
      return false;
    }
    this.registryFactory[backendName] = { factory, priority };
    return true;
  }
  async setBackend(backendName) {
    if (this.registryFactory[backendName] == null) {
      throw new Error(`Backend name '${backendName}' not found in registry`);
    }
    this.backendName = backendName;
    if (this.registry[backendName] == null) {
      this.backendInstance = null;
      const { success, asyncInit } = this.initializeBackend(backendName);
      const result2 = asyncInit ? await success : success;
      if (!result2) {
        return false;
      }
    }
    this.backendInstance = this.registry[backendName];
    this.setupRegisteredKernels();
    this.profiler = new Profiler(this.backendInstance);
    return true;
  }
  setupRegisteredKernels() {
    const kernels = getKernelsForBackend(this.backendName);
    kernels.forEach((kernel) => {
      if (kernel.setupFunc != null) {
        kernel.setupFunc(this.backendInstance);
      }
    });
  }
  disposeRegisteredKernels(backendName) {
    const kernels = getKernelsForBackend(backendName);
    kernels.forEach((kernel) => {
      if (kernel.disposeFunc != null) {
        kernel.disposeFunc(this.registry[backendName]);
      }
    });
  }
  initializeBackend(backendName) {
    const registryFactoryEntry = this.registryFactory[backendName];
    if (registryFactoryEntry == null) {
      throw new Error(`Cannot initialize backend ${backendName}, no registration found.`);
    }
    try {
      const backend2 = registryFactoryEntry.factory();
      if (backend2 && !(backend2 instanceof KernelBackend) && typeof backend2.then === "function") {
        const promiseId = ++this.pendingBackendInitId;
        const success = backend2.then((backendInstance) => {
          if (promiseId < this.pendingBackendInitId) {
            return false;
          }
          this.registry[backendName] = backendInstance;
          this.pendingBackendInit = null;
          return true;
        }).catch((err) => {
          if (promiseId < this.pendingBackendInitId) {
            return false;
          }
          this.pendingBackendInit = null;
          warn(`Initialization of backend ${backendName} failed`);
          warn(err.stack || err.message);
          return false;
        });
        this.pendingBackendInit = success;
        return { success, asyncInit: true };
      } else {
        this.registry[backendName] = backend2;
        return { success: true, asyncInit: false };
      }
    } catch (err) {
      warn(`Initialization of backend ${backendName} failed`);
      warn(err.stack || err.message);
      return { success: false, asyncInit: false };
    }
  }
  removeBackend(backendName) {
    if (!(backendName in this.registryFactory)) {
      throw new Error(`${backendName} backend not found in registry`);
    }
    if (this.backendName === backendName && this.pendingBackendInit != null) {
      this.pendingBackendInitId++;
    }
    if (backendName in this.registry) {
      this.disposeRegisteredKernels(backendName);
      this.registry[backendName].dispose();
      delete this.registry[backendName];
    }
    delete this.registryFactory[backendName];
    if (this.backendName === backendName) {
      this.pendingBackendInit = null;
      this.backendName = null;
      this.backendInstance = null;
    }
  }
  getSortedBackends() {
    if (Object.keys(this.registryFactory).length === 0) {
      throw new Error("No backend found in registry.");
    }
    return Object.keys(this.registryFactory).sort((a6, b2) => {
      return this.registryFactory[b2].priority - this.registryFactory[a6].priority;
    });
  }
  initializeBackendsAndReturnBest() {
    const sortedBackends = this.getSortedBackends();
    for (let i2 = 0; i2 < sortedBackends.length; i2++) {
      const backendName = sortedBackends[i2];
      const { success, asyncInit } = this.initializeBackend(backendName);
      if (asyncInit || success) {
        return { name: backendName, asyncInit };
      }
    }
    throw new Error(`Could not initialize any backends, all backend initializations failed.`);
  }
  moveData(backend2, dataId) {
    const info = this.state.tensorInfo.get(dataId);
    const srcBackend = info.backend;
    const values = this.readSync(dataId);
    const refCount = srcBackend.refCount(dataId);
    srcBackend.disposeData(dataId, true);
    info.backend = backend2;
    backend2.move(dataId, values, info.shape, info.dtype, refCount);
    if (this.shouldCheckForMemLeaks()) {
      this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
  }
  tidy(nameOrFn, fn) {
    let name = null;
    if (fn == null) {
      if (typeof nameOrFn !== "function") {
        throw new Error("Please provide a function to tidy()");
      }
      fn = nameOrFn;
    } else {
      if (typeof nameOrFn !== "string" && !(nameOrFn instanceof String)) {
        throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
      }
      if (typeof fn !== "function") {
        throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
      }
      name = nameOrFn;
    }
    let result2;
    return this.scopedRun(() => this.startScope(name), () => this.endScope(result2), () => {
      result2 = fn();
      if (result2 instanceof Promise) {
        console.error("Cannot return a Promise inside of tidy.");
      }
      return result2;
    });
  }
  scopedRun(start, end, f2) {
    start();
    try {
      const res = f2();
      end();
      return res;
    } catch (ex) {
      end();
      throw ex;
    }
  }
  nextTensorId() {
    return Engine.nextTensorId++;
  }
  nextVariableId() {
    return Engine.nextVariableId++;
  }
  clone(x2) {
    const y2 = ENGINE.runKernel(Identity$1, { x: x2 });
    const inputs = { x: x2 };
    const grad = (dy) => ({
      x: () => {
        const dtype = "float32";
        const gradInputs = { x: dy };
        const attrs = { dtype };
        return ENGINE.runKernel(Cast, gradInputs, attrs);
      }
    });
    const saved = [];
    this.addTapeNode(this.state.activeScope.name, inputs, [y2], grad, saved, {});
    return y2;
  }
  runKernel(kernelName, inputs, attrs) {
    if (this.backendName == null) {
      this.backend;
    }
    const hasKernel = getKernel(kernelName, this.backendName) != null;
    if (!hasKernel) {
      throw new Error(`Kernel '${kernelName}' not registered for backend '${this.backendName}'`);
    }
    return this.runKernelFunc({ kernelName, inputs, attrs });
  }
  shouldCheckForMemLeaks() {
    return this.ENV.getBool("IS_TEST");
  }
  checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos) {
    const numDataIdsAfter = this.backend.numDataIds();
    let numOutputDataIds = 0;
    outInfos.forEach((info) => {
      numOutputDataIds += info.dtype === "complex64" ? 3 : 1;
    });
    const numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
    const dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
    if (dataIdsLeaked > 0) {
      throw new Error(`Backend '${this.backendName}' has an internal memory leak (${dataIdsLeaked} data ids) after running '${kernelName}'`);
    }
  }
  runKernelFunc(kernelParams) {
    let outputs;
    let saved = [];
    const isTapeOn = this.isTapeOn();
    const startingBytecount = this.state.numBytes;
    const startingNumTensors = this.state.numTensors;
    if (this.shouldCheckForMemLeaks()) {
      this.state.numDataMovesStack.push(0);
    }
    let kernelFunc2;
    if (this.backendName == null) {
      this.backend;
    }
    let out;
    const kernelOrScopeName = isRegisteredKernelInvocation(kernelParams) ? kernelParams.kernelName : this.state.activeScope != null ? this.state.activeScope.name : "";
    if (isRegisteredKernelInvocation(kernelParams)) {
      const { kernelName, inputs: inputs2, attrs: attrs2 } = kernelParams;
      if (this.backendName == null) {
        this.backend;
      }
      const kernel = getKernel(kernelName, this.backendName);
      assert$1(kernel != null, () => `Cannot find registered kernel '${kernelName}' for backend '${this.backendName}'`);
      kernelFunc2 = () => {
        const numDataIdsBefore = this.backend.numDataIds();
        out = kernel.kernelFunc({ inputs: inputs2, attrs: attrs2, backend: this.backend });
        const outInfos = Array.isArray(out) ? out : [out];
        if (this.shouldCheckForMemLeaks()) {
          this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
        }
        const outTensors = outInfos.map((outInfo) => {
          if (outInfo.rank != null) {
            return outInfo;
          }
          const { dataId, shape, dtype } = outInfo;
          return this.makeTensorFromDataId(dataId, shape, dtype);
        });
        if (isTapeOn) {
          const tensorsToSave = this.getTensorsForGradient(kernelName, inputs2, outTensors);
          saved = this.saveTensorsForBackwardMode(tensorsToSave);
        }
        return outTensors;
      };
    } else {
      const { forwardFunc } = kernelParams;
      const saveFunc = (tensors) => {
        if (!isTapeOn) {
          return;
        }
        saved = tensors.map((tensor2) => this.keep(this.clone(tensor2)));
      };
      kernelFunc2 = () => {
        const numDataIdsBefore = this.backend.numDataIds();
        out = this.tidy(() => forwardFunc(this.backend, saveFunc));
        const outs = Array.isArray(out) ? out : [out];
        if (this.shouldCheckForMemLeaks()) {
          this.checkKernelForMemLeak(kernelOrScopeName, numDataIdsBefore, outs);
        }
        return outs;
      };
    }
    const { inputs, attrs } = kernelParams;
    const backwardsFunc = isRegisteredKernelInvocation(kernelParams) ? null : kernelParams.backwardsFunc;
    let kernelProfile;
    this.scopedRun(() => this.state.kernelDepth++, () => this.state.kernelDepth--, () => {
      if (!this.ENV.getBool("DEBUG") && !this.state.profiling) {
        outputs = kernelFunc2();
      } else {
        kernelProfile = this.profiler.profileKernel(kernelOrScopeName, inputs, () => kernelFunc2());
        if (this.ENV.getBool("DEBUG")) {
          this.profiler.logKernelProfile(kernelProfile);
        }
        outputs = kernelProfile.outputs;
      }
    });
    if (isTapeOn) {
      this.addTapeNode(kernelOrScopeName, inputs, outputs, backwardsFunc, saved, attrs);
    }
    if (this.state.profiling) {
      this.state.activeProfile.kernels.push({
        name: kernelOrScopeName,
        bytesAdded: this.state.numBytes - startingBytecount,
        totalBytesSnapshot: this.state.numBytes,
        tensorsAdded: this.state.numTensors - startingNumTensors,
        totalTensorsSnapshot: this.state.numTensors,
        inputShapes: Object.keys(inputs).map((key) => inputs[key] != null ? inputs[key].shape : null),
        outputShapes: outputs.map((item) => item.shape),
        kernelTimeMs: kernelProfile.timeMs,
        extraInfo: kernelProfile.extraInfo
      });
    }
    return Array.isArray(out) ? outputs : outputs[0];
  }
  saveTensorsForBackwardMode(tensors) {
    const saved = tensors.map((tensor2) => this.keep(this.clone(tensor2)));
    return saved;
  }
  getTensorsForGradient(kernelName, inputs, outputs) {
    const gradConfig = getGradient(kernelName);
    if (gradConfig != null) {
      const inputsToSave = gradConfig.inputsToSave || [];
      const outputsToSave = gradConfig.outputsToSave || [];
      let inputTensorsToSave;
      if (gradConfig.saveAllInputs) {
        assert$1(Array.isArray(inputs), () => "saveAllInputs is true, expected inputs to be an array.");
        inputTensorsToSave = Object.keys(inputs).map((key) => inputs[key]);
      } else {
        inputTensorsToSave = inputsToSave.map((inputName) => inputs[inputName]);
      }
      const outputTensorsToSave = outputs.filter((_24, i2) => outputsToSave[i2]);
      return inputTensorsToSave.concat(outputTensorsToSave);
    }
    return [];
  }
  makeTensor(values, shape, dtype, backend2) {
    if (values == null) {
      throw new Error("Values passed to engine.makeTensor() are null");
    }
    dtype = dtype || "float32";
    backend2 = backend2 || this.backend;
    let backendVals = values;
    if (dtype === "string" && isString$4(values[0])) {
      backendVals = values.map((d2) => encodeString(d2));
    }
    const dataId = backend2.write(backendVals, shape, dtype);
    const t2 = new Tensor(shape, dtype, dataId, this.nextTensorId());
    this.trackTensor(t2, backend2);
    if (dtype === "string") {
      const info = this.state.tensorInfo.get(dataId);
      const newBytes = bytesFromStringArray(backendVals);
      this.state.numBytes += newBytes - info.bytes;
      info.bytes = newBytes;
    }
    return t2;
  }
  makeTensorFromDataId(dataId, shape, dtype, backend2) {
    dtype = dtype || "float32";
    const t2 = new Tensor(shape, dtype, dataId, this.nextTensorId());
    this.trackTensor(t2, backend2);
    return t2;
  }
  makeVariable(initialValue, trainable = true, name, dtype) {
    name = name || this.nextVariableId().toString();
    if (dtype != null && dtype !== initialValue.dtype) {
      initialValue = initialValue.cast(dtype);
    }
    const v2 = new Variable(initialValue, trainable, name, this.nextTensorId());
    if (this.state.registeredVariables[v2.name] != null) {
      throw new Error(`Variable with name ${v2.name} was already registered`);
    }
    this.state.registeredVariables[v2.name] = v2;
    this.incRef(v2, this.backend);
    return v2;
  }
  trackTensor(a6, backend2) {
    this.state.numTensors++;
    if (a6.dtype === "string") {
      this.state.numStringTensors++;
    }
    let bytes = 0;
    if (a6.dtype !== "complex64" && a6.dtype !== "string") {
      bytes = a6.size * bytesPerElement(a6.dtype);
    }
    this.state.numBytes += bytes;
    if (!this.state.tensorInfo.has(a6.dataId)) {
      this.state.numDataBuffers++;
      this.state.tensorInfo.set(a6.dataId, {
        backend: backend2 || this.backend,
        dtype: a6.dtype,
        shape: a6.shape,
        bytes
      });
    }
    if (!(a6 instanceof Variable)) {
      this.track(a6);
    }
  }
  incRef(a6, backend2) {
    this.trackTensor(a6, backend2);
    this.backend.incRef(a6.dataId);
  }
  removeDataId(dataId, backend2) {
    if (this.state.tensorInfo.has(dataId) && this.state.tensorInfo.get(dataId).backend === backend2) {
      this.state.tensorInfo.delete(dataId);
      this.state.numDataBuffers--;
    }
  }
  disposeTensor(a6) {
    if (!this.state.tensorInfo.has(a6.dataId)) {
      return;
    }
    const info = this.state.tensorInfo.get(a6.dataId);
    this.state.numTensors--;
    if (a6.dtype === "string") {
      this.state.numStringTensors--;
      this.state.numBytes -= info.bytes;
    }
    if (a6.dtype !== "complex64" && a6.dtype !== "string") {
      const bytes = a6.size * bytesPerElement(a6.dtype);
      this.state.numBytes -= bytes;
    }
    if (info.backend.disposeData(a6.dataId)) {
      this.removeDataId(a6.dataId, info.backend);
    }
  }
  disposeVariables() {
    for (const varName in this.state.registeredVariables) {
      const v2 = this.state.registeredVariables[varName];
      this.disposeVariable(v2);
    }
  }
  disposeVariable(v2) {
    this.disposeTensor(v2);
    if (this.state.registeredVariables[v2.name] != null) {
      delete this.state.registeredVariables[v2.name];
    }
  }
  memory() {
    const info = this.backend.memory();
    info.numTensors = this.state.numTensors;
    info.numDataBuffers = this.state.numDataBuffers;
    info.numBytes = this.state.numBytes;
    if (this.state.numStringTensors > 0) {
      info.unreliable = true;
      if (info.reasons == null) {
        info.reasons = [];
      }
      info.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)");
    }
    return info;
  }
  async profile(query) {
    this.state.profiling = true;
    const startBytes = this.state.numBytes;
    const startNumTensors = this.state.numTensors;
    this.state.activeProfile.kernels = [];
    this.state.activeProfile.result = await query();
    this.state.profiling = false;
    this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((d2) => d2.totalBytesSnapshot));
    this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
    this.state.activeProfile.newTensors = this.state.numTensors - startNumTensors;
    for (const kernel of this.state.activeProfile.kernels) {
      kernel.kernelTimeMs = await kernel.kernelTimeMs;
      kernel.extraInfo = await kernel.extraInfo;
    }
    return this.state.activeProfile;
  }
  isTapeOn() {
    return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
  }
  addTapeNode(kernelName, inputs, outputs, gradientsFunc, saved, attrs) {
    const tapeNode = { id: this.state.nextTapeNodeId++, kernelName, inputs, outputs, saved };
    const gradConfig = getGradient(kernelName);
    if (gradConfig != null) {
      gradientsFunc = gradConfig.gradFunc;
    }
    if (gradientsFunc != null) {
      tapeNode.gradient = (dys) => {
        dys = dys.map((dy, i2) => {
          if (dy == null) {
            const output2 = outputs[i2];
            const vals = makeZerosTypedArray(output2.size, output2.dtype);
            return this.makeTensor(vals, output2.shape, output2.dtype);
          }
          return dy;
        });
        return gradientsFunc(dys.length > 1 ? dys : dys[0], saved, attrs);
      };
    }
    this.state.activeTape.push(tapeNode);
  }
  keep(result2) {
    result2.kept = true;
    return result2;
  }
  startTape() {
    if (this.state.gradientDepth === 0) {
      this.state.activeTape = [];
    }
    this.state.gradientDepth++;
  }
  endTape() {
    this.state.gradientDepth--;
  }
  startScope(name) {
    const scopeInfo = {
      track: [],
      name: "unnamed scope",
      id: this.state.nextScopeId++
    };
    if (name) {
      scopeInfo.name = name;
    }
    this.state.scopeStack.push(scopeInfo);
    this.state.activeScope = scopeInfo;
  }
  endScope(result2) {
    const tensorsToTrackInParent = getTensorsInContainer(result2);
    const tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map((t2) => t2.id));
    for (let i2 = 0; i2 < this.state.activeScope.track.length; i2++) {
      const tensor2 = this.state.activeScope.track[i2];
      if (!tensor2.kept && !tensorsToTrackInParentSet.has(tensor2.id)) {
        tensor2.dispose();
      }
    }
    const oldScope = this.state.scopeStack.pop();
    this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1];
    tensorsToTrackInParent.forEach((tensor2) => {
      if (!tensor2.kept && tensor2.scopeId === oldScope.id) {
        this.track(tensor2);
      }
    });
  }
  gradients(f2, xs, dy, allowNoGradients = false) {
    assert$1(xs.length > 0, () => "gradients() received an empty list of xs.");
    if (dy != null && dy.dtype !== "float32") {
      throw new Error(`dy must have 'float32' dtype, but has '${dy.dtype}'`);
    }
    const y2 = this.scopedRun(() => this.startTape(), () => this.endTape(), () => this.tidy("forward", f2));
    assert$1(y2 instanceof Tensor, () => "The result y returned by f() must be a tensor.");
    const filteredTape = getFilteredNodesXToY(this.state.activeTape, xs, y2);
    if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) {
      throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
    }
    return this.tidy("backward", () => {
      const accumulatedGradientMap = {};
      accumulatedGradientMap[y2.id] = dy == null ? ones$1(y2.shape) : dy;
      backpropagateGradients(accumulatedGradientMap, filteredTape, (f3) => this.tidy(f3), add$2);
      const grads = xs.map((x2) => accumulatedGradientMap[x2.id]);
      if (this.state.gradientDepth === 0) {
        this.state.activeTape.forEach((node) => {
          for (const tensor2 of node.saved) {
            tensor2.dispose();
          }
        });
        this.state.activeTape = null;
      }
      return { value: y2, grads };
    });
  }
  customGrad(f2) {
    assert$1(isFunction$2(f2), () => "The f passed in customGrad(f) must be a function.");
    return (...inputs) => {
      assert$1(inputs.every((t2) => t2 instanceof Tensor), () => "The args passed in customGrad(f)(x1, x2,...) must all be tensors");
      let res;
      const inputMap = {};
      inputs.forEach((input, i2) => {
        inputMap[i2] = input;
      });
      const forwardFunc = (_24, save) => {
        res = f2(...[...inputs, save]);
        assert$1(res.value instanceof Tensor, () => "The function f passed in customGrad(f) must return an object where `obj.value` is a tensor");
        assert$1(isFunction$2(res.gradFunc), () => "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.");
        return res.value;
      };
      const backwardsFunc = (dy, saved) => {
        const gradRes = res.gradFunc(dy, saved);
        const grads = Array.isArray(gradRes) ? gradRes : [gradRes];
        assert$1(grads.length === inputs.length, () => "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).");
        assert$1(grads.every((t2) => t2 instanceof Tensor), () => "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
        const gradMap = {};
        grads.forEach((grad, i2) => {
          gradMap[i2] = () => grad;
        });
        return gradMap;
      };
      return this.runKernelFunc({
        forwardFunc,
        backwardsFunc,
        inputs: inputMap
      });
    };
  }
  readSync(dataId) {
    const info = this.state.tensorInfo.get(dataId);
    return info.backend.readSync(dataId);
  }
  read(dataId) {
    const info = this.state.tensorInfo.get(dataId);
    return info.backend.read(dataId);
  }
  readToGPU(dataId, options) {
    const info = this.state.tensorInfo.get(dataId);
    return info.backend.readToGPU(dataId, options);
  }
  async time(query) {
    const start = now();
    const timingInfo = await this.backend.time(query);
    timingInfo.wallMs = now() - start;
    return timingInfo;
  }
  track(result2) {
    if (this.state.activeScope != null) {
      result2.scopeId = this.state.activeScope.id;
      this.state.activeScope.track.push(result2);
    }
    return result2;
  }
  get registeredVariables() {
    return this.state.registeredVariables;
  }
  reset() {
    this.pendingBackendInitId++;
    this.state.dispose();
    this.ENV.reset();
    this.state = new EngineState();
    for (const backendName in this.registry) {
      this.disposeRegisteredKernels(backendName);
      this.registry[backendName].dispose();
      delete this.registry[backendName];
    }
    this.backendName = null;
    this.backendInstance = null;
    this.pendingBackendInit = null;
  }
}
Engine.nextTensorId = 0;
Engine.nextVariableId = 0;
function ones$1(shape) {
  const values = makeOnesTypedArray(sizeFromShape(shape), "float32");
  return ENGINE.makeTensor(values, shape, "float32");
}
function getOrMakeEngine() {
  const ns = getGlobalNamespace();
  if (ns._tfengine == null) {
    const environment = new Environment(ns);
    ns._tfengine = new Engine(environment);
  }
  setEnvironmentGlobal(ns._tfengine.ENV);
  setTensorTracker(() => ns._tfengine);
  return ns._tfengine;
}
const ENGINE = getOrMakeEngine();
function add$2(a6, b2) {
  const inputs = { a: a6, b: b2 };
  return ENGINE.runKernel(Add$1, inputs);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function _isNavigatorDefined() {
  return typeof navigator !== "undefined" && navigator != null;
}
function isMobile(nav) {
  if (nav || _isNavigatorDefined()) {
    if (!nav) {
      nav = navigator;
    }
    if (nav.product === "ReactNative") {
      return true;
    }
    const a6 = nav.userAgent || nav.vendor || (typeof window !== "undefined" ? window.opera : "");
    if (!a6) {
      const navAny = nav;
      return navAny.userAgentData && navAny.userAgentData.mobile;
    }
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a6) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a6.substr(0, 4));
  }
  return false;
}
function isBrowser$2() {
  return typeof window !== "undefined" && window.document != null || typeof WorkerGlobalScope !== "undefined";
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ENV$4 = env();
ENV$4.registerFlag("DEBUG", () => false, (debugValue) => {
  if (debugValue) {
    console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
  }
});
ENV$4.registerFlag("IS_BROWSER", () => isBrowser$2());
ENV$4.registerFlag("IS_NODE", () => typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined");
ENV$4.registerFlag("IS_CHROME", () => typeof navigator !== "undefined" && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
ENV$4.registerFlag("PROD", () => false);
ENV$4.registerFlag("TENSORLIKE_CHECK_SHAPE_CONSISTENCY", () => ENV$4.getBool("DEBUG"));
ENV$4.registerFlag("DEPRECATION_WARNINGS_ENABLED", () => true);
ENV$4.registerFlag("IS_TEST", () => false);
ENV$4.registerFlag("CHECK_COMPUTATION_FOR_ERRORS", () => true);
ENV$4.registerFlag("WRAP_TO_IMAGEBITMAP", () => false);
ENV$4.registerFlag("ENGINE_COMPILE_ONLY", () => false);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function inferShape(val, dtype) {
  let firstElem = val;
  if (isTypedArray(val)) {
    return dtype === "string" ? [] : [val.length];
  }
  if (!Array.isArray(val)) {
    return [];
  }
  const shape = [];
  while (Array.isArray(firstElem) || isTypedArray(firstElem) && dtype !== "string") {
    shape.push(firstElem.length);
    firstElem = firstElem[0];
  }
  if (Array.isArray(val) && env().getBool("TENSORLIKE_CHECK_SHAPE_CONSISTENCY")) {
    deepAssertShapeConsistency(val, shape, []);
  }
  return shape;
}
function deepAssertShapeConsistency(val, shape, indices) {
  indices = indices || [];
  if (!Array.isArray(val) && !isTypedArray(val)) {
    assert$1(shape.length === 0, () => `Element arr[${indices.join("][")}] is a primitive, but should be an array/TypedArray of ${shape[0]} elements`);
    return;
  }
  assert$1(shape.length > 0, () => `Element arr[${indices.join("][")}] should be a primitive, but is an array of ${val.length} elements`);
  assert$1(val.length === shape[0], () => `Element arr[${indices.join("][")}] should have ${shape[0]} elements, but has ${val.length} elements`);
  const subShape = shape.slice(1);
  for (let i2 = 0; i2 < val.length; ++i2) {
    deepAssertShapeConsistency(val[i2], subShape, indices.concat(i2));
  }
}
function assertDtype(expectedDtype, actualDType, argName, functionName) {
  if (expectedDtype === "string_or_numeric") {
    return;
  }
  if (expectedDtype == null) {
    throw new Error(`Expected dtype cannot be null.`);
  }
  if (expectedDtype !== "numeric" && expectedDtype !== actualDType || expectedDtype === "numeric" && actualDType === "string") {
    throw new Error(`Argument '${argName}' passed to '${functionName}' must be ${expectedDtype} tensor, but got ${actualDType} tensor`);
  }
}
function convertToTensor(x2, argName, functionName, parseAsDtype = "numeric") {
  if (x2 instanceof Tensor) {
    assertDtype(parseAsDtype, x2.dtype, argName, functionName);
    return x2;
  }
  let inferredDtype = inferDtype(x2);
  if (inferredDtype !== "string" && ["bool", "int32", "float32"].indexOf(parseAsDtype) >= 0) {
    inferredDtype = parseAsDtype;
  }
  assertDtype(parseAsDtype, inferredDtype, argName, functionName);
  if (x2 == null || !isTypedArray(x2) && !Array.isArray(x2) && typeof x2 !== "number" && typeof x2 !== "boolean" && typeof x2 !== "string") {
    const type = x2 == null ? "null" : x2.constructor.name;
    throw new Error(`Argument '${argName}' passed to '${functionName}' must be a Tensor or TensorLike, but got '${type}'`);
  }
  const inferredShape = inferShape(x2, inferredDtype);
  if (!isTypedArray(x2) && !Array.isArray(x2)) {
    x2 = [x2];
  }
  const skipTypedArray = true;
  const values = inferredDtype !== "string" ? toTypedArray(x2, inferredDtype) : flatten$1(x2, [], skipTypedArray);
  return ENGINE.makeTensor(values, inferredShape, inferredDtype);
}
function convertToTensorArray(arg, argName, functionName, parseAsDtype = "numeric") {
  if (!Array.isArray(arg)) {
    throw new Error(`Argument ${argName} passed to ${functionName} must be a \`Tensor[]\` or \`TensorLike[]\``);
  }
  const tensors = arg;
  return tensors.map((t2, i2) => convertToTensor(t2, `${argName}[${i2}]`, functionName, parseAsDtype));
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const OP_SCOPE_SUFFIX = "__op";
function op(f2) {
  const keys = Object.keys(f2);
  if (keys.length !== 1) {
    throw new Error(`Please provide an object with a single key (operation name) mapping to a function. Got an object with ${keys.length} keys.`);
  }
  let opName = keys[0];
  const fn = f2[opName];
  if (opName.endsWith("_")) {
    opName = opName.substring(0, opName.length - 1);
  }
  opName = opName + OP_SCOPE_SUFFIX;
  const f22 = (...args) => {
    ENGINE.startScope(opName);
    try {
      const result2 = fn(...args);
      if (isPromise(result2)) {
        console.error("Cannot return a Promise inside of tidy.");
      }
      ENGINE.endScope(result2);
      return result2;
    } catch (ex) {
      ENGINE.endScope(null);
      throw ex;
    }
  };
  Object.defineProperty(f22, "name", { value: opName, configurable: true });
  return f22;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function complex_(real2, imag2) {
  const $real = convertToTensor(real2, "real", "complex");
  const $imag = convertToTensor(imag2, "imag", "complex");
  assertShapesMatch($real.shape, $imag.shape, `real and imag shapes, ${$real.shape} and ${$imag.shape}, must match in call to tf.complex().`);
  const inputs = { real: $real, imag: $imag };
  return ENGINE.runKernel(Complex, inputs);
}
const complex$3 = op({ complex_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function makeTensor(values, shape, inferredShape, dtype) {
  if (dtype == null) {
    dtype = inferDtype(values);
  }
  if (dtype === "complex64") {
    throw new Error(`Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).`);
  }
  if (!isTypedArray(values) && !Array.isArray(values) && typeof values !== "number" && typeof values !== "boolean" && typeof values !== "string") {
    throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
  }
  if (shape != null) {
    assertNonNegativeIntegerDimensions(shape);
    const providedSize = sizeFromShape(shape);
    const inferredSize = sizeFromShape(inferredShape);
    assert$1(providedSize === inferredSize, () => `Based on the provided shape, [${shape}], the tensor should have ${providedSize} values but has ${inferredSize}`);
    for (let i2 = 0; i2 < inferredShape.length; ++i2) {
      const inferred = inferredShape[i2];
      const flatDimsDontMatch = i2 === inferredShape.length - 1 ? inferred !== sizeFromShape(shape.slice(i2)) : true;
      assert$1(inferredShape[i2] === shape[i2] || !flatDimsDontMatch, () => `Error creating a new Tensor. Inferred shape (${inferredShape}) does not match the provided shape (${shape}). `);
    }
  }
  if (!isTypedArray(values) && !Array.isArray(values)) {
    values = [values];
  }
  shape = shape || inferredShape;
  values = dtype !== "string" ? toTypedArray(values, dtype) : flatten$1(values, [], true);
  return ENGINE.makeTensor(values, shape, dtype);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tensor(values, shape, dtype) {
  const inferredShape = inferShape(values, dtype);
  return makeTensor(values, shape, inferredShape, dtype);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const DTYPE_VALUE_SIZE_MAP = {
  "float32": 4,
  "float16": 2,
  "int32": 4,
  "uint16": 2,
  "uint8": 1,
  "bool": 1,
  "complex64": 8
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const NUM_BYTES_STRING_LENGTH = 4;
async function encodeWeights(tensors, group) {
  const specs = [];
  const dataPromises = [];
  const names2 = Array.isArray(tensors) ? tensors.map((tensor2) => tensor2.name) : Object.keys(tensors);
  for (let i2 = 0; i2 < names2.length; ++i2) {
    const name = names2[i2];
    const t2 = Array.isArray(tensors) ? tensors[i2].tensor : tensors[name];
    if (t2.dtype !== "float32" && t2.dtype !== "int32" && t2.dtype !== "bool" && t2.dtype !== "string" && t2.dtype !== "complex64") {
      throw new Error(`Unsupported dtype in weight '${name}': ${t2.dtype}`);
    }
    const spec = { name, shape: t2.shape, dtype: t2.dtype };
    if (t2.dtype === "string") {
      const utf8bytes = new Promise(async (resolve) => {
        const vals = await t2.bytes();
        const totalNumBytes = vals.reduce((p2, c2) => p2 + c2.length, 0) + NUM_BYTES_STRING_LENGTH * vals.length;
        const bytes = new Uint8Array(totalNumBytes);
        let offset = 0;
        for (let i3 = 0; i3 < vals.length; i3++) {
          const val = vals[i3];
          const bytesOfLength = new Uint8Array(new Uint32Array([val.length]).buffer);
          bytes.set(bytesOfLength, offset);
          offset += NUM_BYTES_STRING_LENGTH;
          bytes.set(val, offset);
          offset += val.length;
        }
        resolve(bytes);
      });
      dataPromises.push(utf8bytes);
    } else {
      dataPromises.push(t2.data());
    }
    if (group != null) {
      spec.group = group;
    }
    specs.push(spec);
  }
  const tensorValues = await Promise.all(dataPromises);
  return { data: concatenateTypedArrays(tensorValues), specs };
}
function decodeWeights(buffer2, specs) {
  const out = {};
  let float16Decode;
  let offset = 0;
  for (const spec of specs) {
    const name = spec.name;
    const dtype = spec.dtype;
    const shape = spec.shape;
    const size = sizeFromShape(shape);
    let values;
    if ("quantization" in spec) {
      const quantization = spec.quantization;
      if (quantization.dtype === "uint8" || quantization.dtype === "uint16") {
        if (!("min" in quantization && "scale" in quantization)) {
          throw new Error(`Weight ${spec.name} with quantization ${quantization.dtype} doesn't have corresponding metadata min and scale.`);
        }
      } else if (quantization.dtype === "float16") {
        if (dtype !== "float32") {
          throw new Error(`Weight ${spec.name} is quantized with ${quantization.dtype} which only supports weights of type float32 not ${dtype}.`);
        }
      } else {
        throw new Error(`Weight ${spec.name} has unknown quantization dtype ${quantization.dtype}. Supported quantization dtypes are: 'uint8', 'uint16', and 'float16'.`);
      }
      const quantizationSizeFactor = DTYPE_VALUE_SIZE_MAP[quantization.dtype];
      const byteBuffer = buffer2.slice(offset, offset + size * quantizationSizeFactor);
      const quantizedArray = quantization.dtype === "uint8" ? new Uint8Array(byteBuffer) : new Uint16Array(byteBuffer);
      if (dtype === "float32") {
        if (quantization.dtype === "uint8" || quantization.dtype === "uint16") {
          values = new Float32Array(quantizedArray.length);
          for (let i2 = 0; i2 < quantizedArray.length; i2++) {
            const v2 = quantizedArray[i2];
            values[i2] = v2 * quantization.scale + quantization.min;
          }
        } else if (quantization.dtype === "float16") {
          if (float16Decode === void 0) {
            float16Decode = getFloat16Decoder();
          }
          values = float16Decode(quantizedArray);
        } else {
          throw new Error(`Unsupported quantization type ${quantization.dtype} for weight type float32.`);
        }
      } else if (dtype === "int32") {
        if (quantization.dtype !== "uint8" && quantization.dtype !== "uint16") {
          throw new Error(`Unsupported quantization type ${quantization.dtype} for weight type int32.`);
        }
        values = new Int32Array(quantizedArray.length);
        for (let i2 = 0; i2 < quantizedArray.length; i2++) {
          const v2 = quantizedArray[i2];
          values[i2] = Math.round(v2 * quantization.scale + quantization.min);
        }
      } else {
        throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
      }
      offset += size * quantizationSizeFactor;
    } else if (dtype === "string") {
      const size2 = sizeFromShape(spec.shape);
      values = [];
      for (let i2 = 0; i2 < size2; i2++) {
        const byteLength = new Uint32Array(buffer2.slice(offset, offset + NUM_BYTES_STRING_LENGTH))[0];
        offset += NUM_BYTES_STRING_LENGTH;
        const bytes = new Uint8Array(buffer2.slice(offset, offset + byteLength));
        values.push(bytes);
        offset += byteLength;
      }
    } else {
      const dtypeFactor = DTYPE_VALUE_SIZE_MAP[dtype];
      const byteBuffer = buffer2.slice(offset, offset + size * dtypeFactor);
      if (dtype === "float32") {
        values = new Float32Array(byteBuffer);
      } else if (dtype === "int32") {
        values = new Int32Array(byteBuffer);
      } else if (dtype === "bool") {
        values = new Uint8Array(byteBuffer);
      } else if (dtype === "complex64") {
        values = new Float32Array(byteBuffer);
        const real2 = new Float32Array(values.length / 2);
        const image2 = new Float32Array(values.length / 2);
        for (let i2 = 0; i2 < real2.length; i2++) {
          real2[i2] = values[i2 * 2];
          image2[i2] = values[i2 * 2 + 1];
        }
        const realTensor = tensor(real2, shape, "float32");
        const imageTensor = tensor(image2, shape, "float32");
        out[name] = complex$3(realTensor, imageTensor);
        realTensor.dispose();
        imageTensor.dispose();
      } else {
        throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
      }
      offset += size * dtypeFactor;
    }
    if (dtype !== "complex64") {
      out[name] = tensor(values, shape, dtype);
    }
  }
  return out;
}
function concatenateTypedArrays(xs) {
  if (xs === null) {
    throw new Error(`Invalid input value: ${JSON.stringify(xs)}`);
  }
  let totalByteLength = 0;
  const normalizedXs = [];
  xs.forEach((x2) => {
    totalByteLength += x2.byteLength;
    normalizedXs.push(x2.byteLength === x2.buffer.byteLength ? x2 : new x2.constructor(x2));
    if (!(x2 instanceof Float32Array || x2 instanceof Int32Array || x2 instanceof Uint8Array)) {
      throw new Error(`Unsupported TypedArray subtype: ${x2.constructor.name}`);
    }
  });
  const y2 = new Uint8Array(totalByteLength);
  let offset = 0;
  normalizedXs.forEach((x2) => {
    y2.set(new Uint8Array(x2.buffer), offset);
    offset += x2.byteLength;
  });
  return y2.buffer;
}
const useNodeBuffer = typeof Buffer !== "undefined" && (typeof Blob === "undefined" || typeof atob === "undefined" || typeof btoa === "undefined");
function stringByteLength(str) {
  if (useNodeBuffer) {
    return Buffer.byteLength(str);
  }
  return new Blob([str]).size;
}
function arrayBufferToBase64String(buffer2) {
  if (useNodeBuffer) {
    return Buffer.from(buffer2).toString("base64");
  }
  const buf = new Uint8Array(buffer2);
  let s2 = "";
  for (let i2 = 0, l2 = buf.length; i2 < l2; i2++) {
    s2 += String.fromCharCode(buf[i2]);
  }
  return btoa(s2);
}
function base64StringToArrayBuffer(str) {
  if (useNodeBuffer) {
    const buf = Buffer.from(str, "base64");
    return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
  }
  const s2 = atob(str);
  const buffer2 = new Uint8Array(s2.length);
  for (let i2 = 0; i2 < s2.length; ++i2) {
    buffer2.set([s2.charCodeAt(i2)], i2);
  }
  return buffer2.buffer;
}
function concatenateArrayBuffers(buffers) {
  if (buffers.length === 1) {
    return buffers[0];
  }
  let totalByteLength = 0;
  buffers.forEach((buffer2) => {
    totalByteLength += buffer2.byteLength;
  });
  const temp = new Uint8Array(totalByteLength);
  let offset = 0;
  buffers.forEach((buffer2) => {
    temp.set(new Uint8Array(buffer2), offset);
    offset += buffer2.byteLength;
  });
  return temp.buffer;
}
function getModelJSONForModelArtifacts(artifacts, manifest) {
  const result2 = {
    modelTopology: artifacts.modelTopology,
    format: artifacts.format,
    generatedBy: artifacts.generatedBy,
    convertedBy: artifacts.convertedBy,
    weightsManifest: manifest
  };
  if (artifacts.signature != null) {
    result2.signature = artifacts.signature;
  }
  if (artifacts.userDefinedMetadata != null) {
    result2.userDefinedMetadata = artifacts.userDefinedMetadata;
  }
  if (artifacts.modelInitializer != null) {
    result2.modelInitializer = artifacts.modelInitializer;
  }
  if (artifacts.trainingConfig != null) {
    result2.trainingConfig = artifacts.trainingConfig;
  }
  return result2;
}
async function getModelArtifactsForJSON(modelJSON, loadWeights) {
  const modelArtifacts = {
    modelTopology: modelJSON.modelTopology,
    format: modelJSON.format,
    generatedBy: modelJSON.generatedBy,
    convertedBy: modelJSON.convertedBy
  };
  if (modelJSON.trainingConfig != null) {
    modelArtifacts.trainingConfig = modelJSON.trainingConfig;
  }
  if (modelJSON.weightsManifest != null) {
    const [weightSpecs, weightData] = await loadWeights(modelJSON.weightsManifest);
    modelArtifacts.weightSpecs = weightSpecs;
    modelArtifacts.weightData = weightData;
  }
  if (modelJSON.signature != null) {
    modelArtifacts.signature = modelJSON.signature;
  }
  if (modelJSON.userDefinedMetadata != null) {
    modelArtifacts.userDefinedMetadata = modelJSON.userDefinedMetadata;
  }
  if (modelJSON.modelInitializer != null) {
    modelArtifacts.modelInitializer = modelJSON.modelInitializer;
  }
  return modelArtifacts;
}
function getModelArtifactsInfoForJSON(modelArtifacts) {
  if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
    throw new Error("Expected JSON model topology, received ArrayBuffer.");
  }
  return {
    dateSaved: new Date(),
    modelTopologyType: "JSON",
    modelTopologyBytes: modelArtifacts.modelTopology == null ? 0 : stringByteLength(JSON.stringify(modelArtifacts.modelTopology)),
    weightSpecsBytes: modelArtifacts.weightSpecs == null ? 0 : stringByteLength(JSON.stringify(modelArtifacts.weightSpecs)),
    weightDataBytes: modelArtifacts.weightData == null ? 0 : modelArtifacts.weightData.byteLength
  };
}
function computeFloat16MantisaTable() {
  const convertMantissa = (i2) => {
    let m2 = i2 << 13;
    let e2 = 0;
    while ((m2 & 8388608) === 0) {
      e2 -= 8388608;
      m2 <<= 1;
    }
    m2 &= ~8388608;
    e2 += 947912704;
    return m2 | e2;
  };
  const mantisaTable = new Uint32Array(2048);
  mantisaTable[0] = 0;
  for (let i2 = 1; i2 < 1024; i2++) {
    mantisaTable[i2] = convertMantissa(i2);
  }
  for (let i2 = 1024; i2 < 2048; i2++) {
    mantisaTable[i2] = 939524096 + (i2 - 1024 << 13);
  }
  return mantisaTable;
}
function computeFloat16ExponentTable() {
  const exponentTable = new Uint32Array(64);
  exponentTable[0] = 0;
  exponentTable[31] = 1199570944;
  exponentTable[32] = 2147483648;
  exponentTable[63] = 3347054592;
  for (let i2 = 1; i2 < 31; i2++) {
    exponentTable[i2] = i2 << 23;
  }
  for (let i2 = 33; i2 < 63; i2++) {
    exponentTable[i2] = 2147483648 + (i2 - 32 << 23);
  }
  return exponentTable;
}
function computeFloat16OffsetTable() {
  const offsetTable = new Uint32Array(64);
  for (let i2 = 0; i2 < 64; i2++) {
    offsetTable[i2] = 1024;
  }
  offsetTable[0] = offsetTable[32] = 0;
  return offsetTable;
}
function getFloat16Decoder() {
  const mantisaTable = computeFloat16MantisaTable();
  const exponentTable = computeFloat16ExponentTable();
  const offsetTable = computeFloat16OffsetTable();
  return (quantizedArray) => {
    const buffer2 = new ArrayBuffer(4 * quantizedArray.length);
    const bufferUint32View = new Uint32Array(buffer2);
    for (let index2 = 0; index2 < quantizedArray.length; index2++) {
      const float16Bits = quantizedArray[index2];
      const float32Bits = mantisaTable[offsetTable[float16Bits >> 10] + (float16Bits & 1023)] + exponentTable[float16Bits >> 10];
      bufferUint32View[index2] = float32Bits;
    }
    return new Float32Array(buffer2);
  };
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class IORouterRegistry {
  constructor() {
    this.saveRouters = [];
    this.loadRouters = [];
  }
  static getInstance() {
    if (IORouterRegistry.instance == null) {
      IORouterRegistry.instance = new IORouterRegistry();
    }
    return IORouterRegistry.instance;
  }
  static registerSaveRouter(saveRouter) {
    IORouterRegistry.getInstance().saveRouters.push(saveRouter);
  }
  static registerLoadRouter(loadRouter) {
    IORouterRegistry.getInstance().loadRouters.push(loadRouter);
  }
  static getSaveHandlers(url) {
    return IORouterRegistry.getHandlers(url, "save");
  }
  static getLoadHandlers(url, loadOptions) {
    return IORouterRegistry.getHandlers(url, "load", loadOptions);
  }
  static getHandlers(url, handlerType, loadOptions) {
    const validHandlers = [];
    const routers = handlerType === "load" ? IORouterRegistry.getInstance().loadRouters : IORouterRegistry.getInstance().saveRouters;
    routers.forEach((router) => {
      const handler = router(url, loadOptions);
      if (handler !== null) {
        validHandlers.push(handler);
      }
    });
    return validHandlers;
  }
}
const getSaveHandlers = (url) => IORouterRegistry.getSaveHandlers(url);
const getLoadHandlers = (url, loadOptions) => IORouterRegistry.getLoadHandlers(url, loadOptions);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const DATABASE_NAME = "tensorflowjs";
const DATABASE_VERSION = 1;
const MODEL_STORE_NAME = "models_store";
const INFO_STORE_NAME = "model_info_store";
function getIndexedDBFactory() {
  if (!env().getBool("IS_BROWSER")) {
    throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
  }
  const theWindow = typeof window === "undefined" ? self : window;
  const factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;
  if (factory == null) {
    throw new Error("The current browser does not appear to support IndexedDB.");
  }
  return factory;
}
function setUpDatabase(openRequest) {
  const db = openRequest.result;
  db.createObjectStore(MODEL_STORE_NAME, { keyPath: "modelPath" });
  db.createObjectStore(INFO_STORE_NAME, { keyPath: "modelPath" });
}
class BrowserIndexedDB {
  constructor(modelPath) {
    this.indexedDB = getIndexedDBFactory();
    if (modelPath == null || !modelPath) {
      throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");
    }
    this.modelPath = modelPath;
  }
  async save(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
      throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
    }
    return this.databaseAction(this.modelPath, modelArtifacts);
  }
  async load() {
    return this.databaseAction(this.modelPath);
  }
  databaseAction(modelPath, modelArtifacts) {
    return new Promise((resolve, reject) => {
      const openRequest = this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
      openRequest.onupgradeneeded = () => setUpDatabase(openRequest);
      openRequest.onsuccess = () => {
        const db = openRequest.result;
        if (modelArtifacts == null) {
          const modelTx = db.transaction(MODEL_STORE_NAME, "readonly");
          const modelStore = modelTx.objectStore(MODEL_STORE_NAME);
          const getRequest = modelStore.get(this.modelPath);
          getRequest.onsuccess = () => {
            if (getRequest.result == null) {
              db.close();
              return reject(new Error(`Cannot find model with path '${this.modelPath}' in IndexedDB.`));
            } else {
              resolve(getRequest.result.modelArtifacts);
            }
          };
          getRequest.onerror = (error3) => {
            db.close();
            return reject(getRequest.error);
          };
          modelTx.oncomplete = () => db.close();
        } else {
          const modelArtifactsInfo = getModelArtifactsInfoForJSON(modelArtifacts);
          const infoTx = db.transaction(INFO_STORE_NAME, "readwrite");
          let infoStore = infoTx.objectStore(INFO_STORE_NAME);
          const putInfoRequest = infoStore.put({ modelPath: this.modelPath, modelArtifactsInfo });
          let modelTx;
          putInfoRequest.onsuccess = () => {
            modelTx = db.transaction(MODEL_STORE_NAME, "readwrite");
            const modelStore = modelTx.objectStore(MODEL_STORE_NAME);
            const putModelRequest = modelStore.put({
              modelPath: this.modelPath,
              modelArtifacts,
              modelArtifactsInfo
            });
            putModelRequest.onsuccess = () => resolve({ modelArtifactsInfo });
            putModelRequest.onerror = (error3) => {
              infoStore = infoTx.objectStore(INFO_STORE_NAME);
              const deleteInfoRequest = infoStore.delete(this.modelPath);
              deleteInfoRequest.onsuccess = () => {
                db.close();
                return reject(putModelRequest.error);
              };
              deleteInfoRequest.onerror = (error4) => {
                db.close();
                return reject(putModelRequest.error);
              };
            };
          };
          putInfoRequest.onerror = (error3) => {
            db.close();
            return reject(putInfoRequest.error);
          };
          infoTx.oncomplete = () => {
            if (modelTx == null) {
              db.close();
            } else {
              modelTx.oncomplete = () => db.close();
            }
          };
        }
      };
      openRequest.onerror = (error3) => reject(openRequest.error);
    });
  }
}
BrowserIndexedDB.URL_SCHEME = "indexeddb://";
const indexedDBRouter = (url) => {
  if (!env().getBool("IS_BROWSER")) {
    return null;
  } else {
    if (!Array.isArray(url) && url.startsWith(BrowserIndexedDB.URL_SCHEME)) {
      return browserIndexedDB(url.slice(BrowserIndexedDB.URL_SCHEME.length));
    } else {
      return null;
    }
  }
};
IORouterRegistry.registerSaveRouter(indexedDBRouter);
IORouterRegistry.registerLoadRouter(indexedDBRouter);
function browserIndexedDB(modelPath) {
  return new BrowserIndexedDB(modelPath);
}
function maybeStripScheme$1(key) {
  return key.startsWith(BrowserIndexedDB.URL_SCHEME) ? key.slice(BrowserIndexedDB.URL_SCHEME.length) : key;
}
class BrowserIndexedDBManager {
  constructor() {
    this.indexedDB = getIndexedDBFactory();
  }
  async listModels() {
    return new Promise((resolve, reject) => {
      const openRequest = this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
      openRequest.onupgradeneeded = () => setUpDatabase(openRequest);
      openRequest.onsuccess = () => {
        const db = openRequest.result;
        const tx = db.transaction(INFO_STORE_NAME, "readonly");
        const store = tx.objectStore(INFO_STORE_NAME);
        const getAllInfoRequest = store.getAll();
        getAllInfoRequest.onsuccess = () => {
          const out = {};
          for (const item of getAllInfoRequest.result) {
            out[item.modelPath] = item.modelArtifactsInfo;
          }
          resolve(out);
        };
        getAllInfoRequest.onerror = (error3) => {
          db.close();
          return reject(getAllInfoRequest.error);
        };
        tx.oncomplete = () => db.close();
      };
      openRequest.onerror = (error3) => reject(openRequest.error);
    });
  }
  async removeModel(path2) {
    path2 = maybeStripScheme$1(path2);
    return new Promise((resolve, reject) => {
      const openRequest = this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
      openRequest.onupgradeneeded = () => setUpDatabase(openRequest);
      openRequest.onsuccess = () => {
        const db = openRequest.result;
        const infoTx = db.transaction(INFO_STORE_NAME, "readwrite");
        const infoStore = infoTx.objectStore(INFO_STORE_NAME);
        const getInfoRequest = infoStore.get(path2);
        let modelTx;
        getInfoRequest.onsuccess = () => {
          if (getInfoRequest.result == null) {
            db.close();
            return reject(new Error(`Cannot find model with path '${path2}' in IndexedDB.`));
          } else {
            const deleteInfoRequest = infoStore.delete(path2);
            const deleteModelData = () => {
              modelTx = db.transaction(MODEL_STORE_NAME, "readwrite");
              const modelStore = modelTx.objectStore(MODEL_STORE_NAME);
              const deleteModelRequest = modelStore.delete(path2);
              deleteModelRequest.onsuccess = () => resolve(getInfoRequest.result.modelArtifactsInfo);
              deleteModelRequest.onerror = (error3) => reject(getInfoRequest.error);
            };
            deleteInfoRequest.onsuccess = deleteModelData;
            deleteInfoRequest.onerror = (error3) => {
              deleteModelData();
              db.close();
              return reject(getInfoRequest.error);
            };
          }
        };
        getInfoRequest.onerror = (error3) => {
          db.close();
          return reject(getInfoRequest.error);
        };
        infoTx.oncomplete = () => {
          if (modelTx == null) {
            db.close();
          } else {
            modelTx.oncomplete = () => db.close();
          }
        };
      };
      openRequest.onerror = (error3) => reject(openRequest.error);
    });
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const PATH_SEPARATOR = "/";
const PATH_PREFIX = "tensorflowjs_models";
const INFO_SUFFIX = "info";
const MODEL_TOPOLOGY_SUFFIX = "model_topology";
const WEIGHT_SPECS_SUFFIX = "weight_specs";
const WEIGHT_DATA_SUFFIX = "weight_data";
const MODEL_METADATA_SUFFIX = "model_metadata";
function getModelKeys(path2) {
  return {
    info: [PATH_PREFIX, path2, INFO_SUFFIX].join(PATH_SEPARATOR),
    topology: [PATH_PREFIX, path2, MODEL_TOPOLOGY_SUFFIX].join(PATH_SEPARATOR),
    weightSpecs: [PATH_PREFIX, path2, WEIGHT_SPECS_SUFFIX].join(PATH_SEPARATOR),
    weightData: [PATH_PREFIX, path2, WEIGHT_DATA_SUFFIX].join(PATH_SEPARATOR),
    modelMetadata: [PATH_PREFIX, path2, MODEL_METADATA_SUFFIX].join(PATH_SEPARATOR)
  };
}
function removeItems(keys) {
  for (const key of Object.values(keys)) {
    window.localStorage.removeItem(key);
  }
}
function getModelPathFromKey(key) {
  const items = key.split(PATH_SEPARATOR);
  if (items.length < 3) {
    throw new Error(`Invalid key format: ${key}`);
  }
  return items.slice(1, items.length - 1).join(PATH_SEPARATOR);
}
function maybeStripScheme(key) {
  return key.startsWith(BrowserLocalStorage.URL_SCHEME) ? key.slice(BrowserLocalStorage.URL_SCHEME.length) : key;
}
class BrowserLocalStorage {
  constructor(modelPath) {
    if (!env().getBool("IS_BROWSER") || typeof window === "undefined" || typeof window.localStorage === "undefined") {
      throw new Error("The current environment does not support local storage.");
    }
    this.LS = window.localStorage;
    if (modelPath == null || !modelPath) {
      throw new Error("For local storage, modelPath must not be null, undefined or empty.");
    }
    this.modelPath = modelPath;
    this.keys = getModelKeys(this.modelPath);
  }
  async save(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
      throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
    } else {
      const topology = JSON.stringify(modelArtifacts.modelTopology);
      const weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
      const modelArtifactsInfo = getModelArtifactsInfoForJSON(modelArtifacts);
      try {
        this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
        this.LS.setItem(this.keys.topology, topology);
        this.LS.setItem(this.keys.weightSpecs, weightSpecs);
        this.LS.setItem(this.keys.weightData, arrayBufferToBase64String(modelArtifacts.weightData));
        const metadata2 = {
          format: modelArtifacts.format,
          generatedBy: modelArtifacts.generatedBy,
          convertedBy: modelArtifacts.convertedBy,
          signature: modelArtifacts.signature != null ? modelArtifacts.signature : void 0,
          userDefinedMetadata: modelArtifacts.userDefinedMetadata != null ? modelArtifacts.userDefinedMetadata : void 0,
          modelInitializer: modelArtifacts.modelInitializer != null ? modelArtifacts.modelInitializer : void 0,
          trainingConfig: modelArtifacts.trainingConfig != null ? modelArtifacts.trainingConfig : void 0
        };
        this.LS.setItem(this.keys.modelMetadata, JSON.stringify(metadata2));
        return { modelArtifactsInfo };
      } catch (err) {
        removeItems(this.keys);
        throw new Error(`Failed to save model '${this.modelPath}' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes=${modelArtifactsInfo.modelTopologyBytes}, weightSpecsBytes=${modelArtifactsInfo.weightSpecsBytes}, weightDataBytes=${modelArtifactsInfo.weightDataBytes}.`);
      }
    }
  }
  async load() {
    const info = JSON.parse(this.LS.getItem(this.keys.info));
    if (info == null) {
      throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
    }
    if (info.modelTopologyType !== "JSON") {
      throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
    }
    const out = {};
    const topology = JSON.parse(this.LS.getItem(this.keys.topology));
    if (topology == null) {
      throw new Error(`In local storage, the topology of model '${this.modelPath}' is missing.`);
    }
    out.modelTopology = topology;
    const weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
    if (weightSpecs == null) {
      throw new Error(`In local storage, the weight specs of model '${this.modelPath}' are missing.`);
    }
    out.weightSpecs = weightSpecs;
    const metadataString = this.LS.getItem(this.keys.modelMetadata);
    if (metadataString != null) {
      const metadata2 = JSON.parse(metadataString);
      out.format = metadata2.format;
      out.generatedBy = metadata2.generatedBy;
      out.convertedBy = metadata2.convertedBy;
      if (metadata2.signature != null) {
        out.signature = metadata2.signature;
      }
      if (metadata2.userDefinedMetadata != null) {
        out.userDefinedMetadata = metadata2.userDefinedMetadata;
      }
      if (metadata2.modelInitializer != null) {
        out.modelInitializer = metadata2.modelInitializer;
      }
      if (metadata2.trainingConfig != null) {
        out.trainingConfig = metadata2.trainingConfig;
      }
    }
    const weightDataBase64 = this.LS.getItem(this.keys.weightData);
    if (weightDataBase64 == null) {
      throw new Error(`In local storage, the binary weight values of model '${this.modelPath}' are missing.`);
    }
    out.weightData = base64StringToArrayBuffer(weightDataBase64);
    return out;
  }
}
BrowserLocalStorage.URL_SCHEME = "localstorage://";
const localStorageRouter = (url) => {
  if (!env().getBool("IS_BROWSER")) {
    return null;
  } else {
    if (!Array.isArray(url) && url.startsWith(BrowserLocalStorage.URL_SCHEME)) {
      return browserLocalStorage(url.slice(BrowserLocalStorage.URL_SCHEME.length));
    } else {
      return null;
    }
  }
};
IORouterRegistry.registerSaveRouter(localStorageRouter);
IORouterRegistry.registerLoadRouter(localStorageRouter);
function browserLocalStorage(modelPath) {
  return new BrowserLocalStorage(modelPath);
}
class BrowserLocalStorageManager {
  constructor() {
    assert$1(env().getBool("IS_BROWSER"), () => "Current environment is not a web browser");
    assert$1(typeof window === "undefined" || typeof window.localStorage !== "undefined", () => "Current browser does not appear to support localStorage");
    this.LS = window.localStorage;
  }
  async listModels() {
    const out = {};
    const prefix2 = PATH_PREFIX + PATH_SEPARATOR;
    const suffix = PATH_SEPARATOR + INFO_SUFFIX;
    for (let i2 = 0; i2 < this.LS.length; ++i2) {
      const key = this.LS.key(i2);
      if (key.startsWith(prefix2) && key.endsWith(suffix)) {
        const modelPath = getModelPathFromKey(key);
        out[modelPath] = JSON.parse(this.LS.getItem(key));
      }
    }
    return out;
  }
  async removeModel(path2) {
    path2 = maybeStripScheme(path2);
    const keys = getModelKeys(path2);
    if (this.LS.getItem(keys.info) == null) {
      throw new Error(`Cannot find model at path '${path2}'`);
    }
    const info = JSON.parse(this.LS.getItem(keys.info));
    removeItems(keys);
    return info;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const URL_SCHEME_SUFFIX = "://";
class ModelStoreManagerRegistry {
  constructor() {
    this.managers = {};
  }
  static getInstance() {
    if (ModelStoreManagerRegistry.instance == null) {
      ModelStoreManagerRegistry.instance = new ModelStoreManagerRegistry();
    }
    return ModelStoreManagerRegistry.instance;
  }
  static registerManager(scheme, manager) {
    assert$1(scheme != null, () => "scheme must not be undefined or null.");
    if (scheme.endsWith(URL_SCHEME_SUFFIX)) {
      scheme = scheme.slice(0, scheme.indexOf(URL_SCHEME_SUFFIX));
    }
    assert$1(scheme.length > 0, () => "scheme must not be an empty string.");
    const registry = ModelStoreManagerRegistry.getInstance();
    assert$1(registry.managers[scheme] == null, () => `A model store manager is already registered for scheme '${scheme}'.`);
    registry.managers[scheme] = manager;
  }
  static getManager(scheme) {
    const manager = this.getInstance().managers[scheme];
    if (manager == null) {
      throw new Error(`Cannot find model manager for scheme '${scheme}'`);
    }
    return manager;
  }
  static getSchemes() {
    return Object.keys(this.getInstance().managers);
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class PlatformBrowser {
  fetch(path2, init3) {
    return fetch(path2, init3);
  }
  now() {
    return performance.now();
  }
  encode(text, encoding) {
    if (encoding !== "utf-8" && encoding !== "utf8") {
      throw new Error(`Browser's encoder only supports utf-8, but got ${encoding}`);
    }
    if (this.textEncoder == null) {
      this.textEncoder = new TextEncoder();
    }
    return this.textEncoder.encode(text);
  }
  decode(bytes, encoding) {
    return new TextDecoder(encoding).decode(bytes);
  }
}
if (env().get("IS_BROWSER")) {
  env().setPlatform("browser", new PlatformBrowser());
  try {
    ModelStoreManagerRegistry.registerManager(BrowserLocalStorage.URL_SCHEME, new BrowserLocalStorageManager());
  } catch (err) {
  }
  try {
    ModelStoreManagerRegistry.registerManager(BrowserIndexedDB.URL_SCHEME, new BrowserIndexedDBManager());
  } catch (err) {
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const getNodeFetch = {
  importFetch: () => require("node-fetch")
};
let systemFetch;
class PlatformNode {
  constructor() {
    this.util = require("util");
    this.textEncoder = new this.util.TextEncoder();
  }
  fetch(path2, requestInits) {
    if (env().global.fetch != null) {
      return env().global.fetch(path2, requestInits);
    }
    if (systemFetch == null) {
      systemFetch = getNodeFetch.importFetch();
    }
    return systemFetch(path2, requestInits);
  }
  now() {
    const time = process.hrtime();
    return time[0] * 1e3 + time[1] / 1e6;
  }
  encode(text, encoding) {
    if (encoding !== "utf-8" && encoding !== "utf8") {
      throw new Error(`Node built-in encoder only supports utf-8, but got ${encoding}`);
    }
    return this.textEncoder.encode(text);
  }
  decode(bytes, encoding) {
    if (bytes.length === 0) {
      return "";
    }
    return new this.util.TextDecoder(encoding).decode(bytes);
  }
}
if (env().get("IS_NODE") && !env().get("IS_BROWSER")) {
  env().setPlatform("node", new PlatformNode());
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function buffer(shape, dtype = "float32", values) {
  dtype = dtype || "float32";
  assertNonNegativeIntegerDimensions(shape);
  return new TensorBuffer(shape, dtype, values);
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cast_(x2, dtype) {
  const $x = convertToTensor(x2, "x", "cast");
  if (!isValidDtype(dtype)) {
    throw new Error(`Failed to cast to unknown dtype ${dtype}`);
  }
  if (dtype === "string" && $x.dtype !== "string" || dtype !== "string" && $x.dtype === "string") {
    throw new Error("Only strings can be casted to strings");
  }
  const inputs = { x: $x };
  const attrs = { dtype };
  return ENGINE.runKernel(Cast, inputs, attrs);
}
const cast$4 = op({ cast_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function clone_(x2) {
  const $x = convertToTensor(x2, "x", "clone", "string_or_numeric");
  const inputs = { x: $x };
  return ENGINE.runKernel(Identity$1, inputs);
}
const clone = op({ clone_ });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function print(x2, verbose = false) {
  console.log(x2.toString(verbose));
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getOrMakeEngine();
const opHandler = {
  buffer,
  cast: cast$4,
  clone,
  print
};
setOpHandler(opHandler);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const DEFAULT_FILE_NAME_PREFIX = "model";
const DEFAULT_JSON_EXTENSION_NAME = ".json";
const DEFAULT_WEIGHT_DATA_EXTENSION_NAME = ".weights.bin";
function defer(f2) {
  return new Promise((resolve) => setTimeout(resolve)).then(f2);
}
class BrowserDownloads {
  constructor(fileNamePrefix) {
    if (!env().getBool("IS_BROWSER")) {
      throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
    }
    if (fileNamePrefix.startsWith(BrowserDownloads.URL_SCHEME)) {
      fileNamePrefix = fileNamePrefix.slice(BrowserDownloads.URL_SCHEME.length);
    }
    if (fileNamePrefix == null || fileNamePrefix.length === 0) {
      fileNamePrefix = DEFAULT_FILE_NAME_PREFIX;
    }
    this.modelJsonFileName = fileNamePrefix + DEFAULT_JSON_EXTENSION_NAME;
    this.weightDataFileName = fileNamePrefix + DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
  }
  async save(modelArtifacts) {
    if (typeof document === "undefined") {
      throw new Error("Browser downloads are not supported in this environment since `document` is not present");
    }
    const weightsURL = window.URL.createObjectURL(new Blob([modelArtifacts.weightData], { type: "application/octet-stream" }));
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
      throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
    } else {
      const weightsManifest = [{
        paths: ["./" + this.weightDataFileName],
        weights: modelArtifacts.weightSpecs
      }];
      const modelJSON = getModelJSONForModelArtifacts(modelArtifacts, weightsManifest);
      const modelJsonURL = window.URL.createObjectURL(new Blob([JSON.stringify(modelJSON)], { type: "application/json" }));
      const jsonAnchor = this.modelJsonAnchor == null ? document.createElement("a") : this.modelJsonAnchor;
      jsonAnchor.download = this.modelJsonFileName;
      jsonAnchor.href = modelJsonURL;
      await defer(() => jsonAnchor.dispatchEvent(new MouseEvent("click")));
      if (modelArtifacts.weightData != null) {
        const weightDataAnchor = this.weightDataAnchor == null ? document.createElement("a") : this.weightDataAnchor;
        weightDataAnchor.download = this.weightDataFileName;
        weightDataAnchor.href = weightsURL;
        await defer(() => weightDataAnchor.dispatchEvent(new MouseEvent("click")));
      }
      return { modelArtifactsInfo: getModelArtifactsInfoForJSON(modelArtifacts) };
    }
  }
}
BrowserDownloads.URL_SCHEME = "downloads://";
const browserDownloadsRouter = (url) => {
  if (!env().getBool("IS_BROWSER")) {
    return null;
  } else {
    if (!Array.isArray(url) && url.startsWith(BrowserDownloads.URL_SCHEME)) {
      return browserDownloads(url.slice(BrowserDownloads.URL_SCHEME.length));
    } else {
      return null;
    }
  }
};
IORouterRegistry.registerSaveRouter(browserDownloadsRouter);
function browserDownloads(fileNamePrefix = "model") {
  return new BrowserDownloads(fileNamePrefix);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function monitorPromisesProgress(promises, onProgress, startFraction, endFraction) {
  checkPromises(promises);
  startFraction = startFraction == null ? 0 : startFraction;
  endFraction = endFraction == null ? 1 : endFraction;
  checkFraction(startFraction, endFraction);
  let resolvedPromise = 0;
  const registerMonitor = (promise) => {
    promise.then((value) => {
      const fraction = startFraction + ++resolvedPromise / promises.length * (endFraction - startFraction);
      onProgress(fraction);
      return value;
    });
    return promise;
  };
  function checkPromises(promises2) {
    assert$1(promises2 != null && Array.isArray(promises2) && promises2.length > 0, () => "promises must be a none empty array");
  }
  function checkFraction(startFraction2, endFraction2) {
    assert$1(startFraction2 >= 0 && startFraction2 <= 1, () => `Progress fraction must be in range [0, 1], but got startFraction ${startFraction2}`);
    assert$1(endFraction2 >= 0 && endFraction2 <= 1, () => `Progress fraction must be in range [0, 1], but got endFraction ${endFraction2}`);
    assert$1(endFraction2 >= startFraction2, () => `startFraction must be no more than endFraction, but got startFraction ${startFraction2} and endFraction ${endFraction2}`);
  }
  return Promise.all(promises.map(registerMonitor));
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
async function loadWeightsAsArrayBuffer(fetchURLs, loadOptions) {
  if (loadOptions == null) {
    loadOptions = {};
  }
  const fetchFunc = loadOptions.fetchFunc == null ? env().platform.fetch : loadOptions.fetchFunc;
  const requests = fetchURLs.map((fetchURL) => fetchFunc(fetchURL, loadOptions.requestInit, { isBinary: true }));
  const fetchStartFraction = 0;
  const fetchEndFraction = 0.5;
  const responses = loadOptions.onProgress == null ? await Promise.all(requests) : await monitorPromisesProgress(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction);
  const bufferPromises = responses.map((response) => response.arrayBuffer());
  const bufferStartFraction = 0.5;
  const bufferEndFraction = 1;
  const buffers = loadOptions.onProgress == null ? await Promise.all(bufferPromises) : await monitorPromisesProgress(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction);
  return buffers;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const OCTET_STREAM_MIME_TYPE = "application/octet-stream";
const JSON_TYPE = "application/json";
class HTTPRequest {
  constructor(path2, loadOptions) {
    this.DEFAULT_METHOD = "POST";
    if (loadOptions == null) {
      loadOptions = {};
    }
    this.weightPathPrefix = loadOptions.weightPathPrefix;
    this.onProgress = loadOptions.onProgress;
    this.weightUrlConverter = loadOptions.weightUrlConverter;
    if (loadOptions.fetchFunc != null) {
      assert$1(typeof loadOptions.fetchFunc === "function", () => "Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)");
      this.fetch = loadOptions.fetchFunc;
    } else {
      this.fetch = env().platform.fetch;
    }
    assert$1(path2 != null && path2.length > 0, () => "URL path for http must not be null, undefined or empty.");
    if (Array.isArray(path2)) {
      assert$1(path2.length === 2, () => `URL paths for http must have a length of 2, (actual length is ${path2.length}).`);
    }
    this.path = path2;
    if (loadOptions.requestInit != null && loadOptions.requestInit.body != null) {
      throw new Error("requestInit is expected to have no pre-existing body, but has one.");
    }
    this.requestInit = loadOptions.requestInit || {};
  }
  async save(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
      throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
    }
    const init3 = Object.assign({ method: this.DEFAULT_METHOD }, this.requestInit);
    init3.body = new FormData();
    const weightsManifest = [{
      paths: ["./model.weights.bin"],
      weights: modelArtifacts.weightSpecs
    }];
    const modelTopologyAndWeightManifest = getModelJSONForModelArtifacts(modelArtifacts, weightsManifest);
    init3.body.append("model.json", new Blob([JSON.stringify(modelTopologyAndWeightManifest)], { type: JSON_TYPE }), "model.json");
    if (modelArtifacts.weightData != null) {
      init3.body.append("model.weights.bin", new Blob([modelArtifacts.weightData], { type: OCTET_STREAM_MIME_TYPE }), "model.weights.bin");
    }
    const response = await this.fetch(this.path, init3);
    if (response.ok) {
      return {
        modelArtifactsInfo: getModelArtifactsInfoForJSON(modelArtifacts),
        responses: [response]
      };
    } else {
      throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ${response.status}.`);
    }
  }
  async load() {
    const modelConfigRequest = await this.fetch(this.path, this.requestInit);
    if (!modelConfigRequest.ok) {
      throw new Error(`Request to ${this.path} failed with status code ${modelConfigRequest.status}. Please verify this URL points to the model JSON of the model to load.`);
    }
    let modelJSON;
    try {
      modelJSON = await modelConfigRequest.json();
    } catch (e2) {
      let message2 = `Failed to parse model JSON of response from ${this.path}.`;
      if (this.path.endsWith(".pb")) {
        message2 += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.";
      } else {
        message2 += " Please make sure the server is serving valid JSON for this request.";
      }
      throw new Error(message2);
    }
    const modelTopology = modelJSON.modelTopology;
    const weightsManifest = modelJSON.weightsManifest;
    if (modelTopology == null && weightsManifest == null) {
      throw new Error(`The JSON from HTTP path ${this.path} contains neither model topology or manifest for weights.`);
    }
    return getModelArtifactsForJSON(modelJSON, (weightsManifest2) => this.loadWeights(weightsManifest2));
  }
  async loadWeights(weightsManifest) {
    const weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
    const [prefix2, suffix] = parseUrl(weightPath);
    const pathPrefix = this.weightPathPrefix || prefix2;
    const weightSpecs = [];
    for (const entry of weightsManifest) {
      weightSpecs.push(...entry.weights);
    }
    const fetchURLs = [];
    const urlPromises = [];
    for (const weightsGroup of weightsManifest) {
      for (const path2 of weightsGroup.paths) {
        if (this.weightUrlConverter != null) {
          urlPromises.push(this.weightUrlConverter(path2));
        } else {
          fetchURLs.push(pathPrefix + path2 + suffix);
        }
      }
    }
    if (this.weightUrlConverter) {
      fetchURLs.push(...await Promise.all(urlPromises));
    }
    const buffers = await loadWeightsAsArrayBuffer(fetchURLs, {
      requestInit: this.requestInit,
      fetchFunc: this.fetch,
      onProgress: this.onProgress
    });
    return [weightSpecs, concatenateArrayBuffers(buffers)];
  }
}
HTTPRequest.URL_SCHEME_REGEX = /^https?:\/\//;
function parseUrl(url) {
  const lastSlash = url.lastIndexOf("/");
  const lastSearchParam = url.lastIndexOf("?");
  const prefix2 = url.substring(0, lastSlash);
  const suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : "";
  return [prefix2 + "/", suffix];
}
function isHTTPScheme(url) {
  return url.match(HTTPRequest.URL_SCHEME_REGEX) != null;
}
const httpRouter = (url, loadOptions) => {
  if (typeof fetch === "undefined" && (loadOptions == null || loadOptions.fetchFunc == null)) {
    return null;
  } else {
    let isHTTP = true;
    if (Array.isArray(url)) {
      isHTTP = url.every((urlItem) => isHTTPScheme(urlItem));
    } else {
      isHTTP = isHTTPScheme(url);
    }
    if (isHTTP) {
      return http(url, loadOptions);
    }
  }
  return null;
};
IORouterRegistry.registerSaveRouter(httpRouter);
IORouterRegistry.registerLoadRouter(httpRouter);
function http(path2, loadOptions) {
  return new HTTPRequest(path2, loadOptions);
}
function browserHTTPRequest(path2, loadOptions) {
  return http(path2, loadOptions);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function matMul_(a6, b2, transposeA = false, transposeB = false) {
  let $a = convertToTensor(a6, "a", "matMul");
  let $b = convertToTensor(b2, "b", "matMul");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  const attrs = { transposeA, transposeB };
  return ENGINE.runKernel(BatchMatMul, inputs, attrs);
}
const matMul$1 = op({ matMul_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function oneHot_(indices, depth, onValue = 1, offValue = 0) {
  if (depth < 2) {
    throw new Error(`Error in oneHot: depth must be >=2, but it is ${depth}`);
  }
  const $indices = convertToTensor(indices, "indices", "oneHot", "int32");
  const inputs = { indices: $indices };
  const attrs = { depth, onValue, offValue };
  return ENGINE.runKernel(OneHot, inputs, attrs);
}
const oneHot$3 = op({ oneHot_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transpose_(x2, perm) {
  const $x = convertToTensor(x2, "x", "transpose");
  if (perm == null) {
    perm = $x.shape.map((s2, i2) => i2).reverse();
  }
  assert$1($x.rank === perm.length, () => `Error in transpose: rank of input ${$x.rank} must match length of perm ${perm}.`);
  perm.forEach((axis) => {
    assert$1(axis >= 0 && axis < $x.rank, () => `All entries in 'perm' must be between 0 and ${$x.rank - 1} but got ${perm}`);
  });
  if ($x.rank <= 1) {
    return $x.clone();
  }
  const inputs = { x: $x };
  const attrs = { perm };
  return ENGINE.runKernel(Transpose, inputs, attrs);
}
const transpose$3 = op({ transpose_ });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getBroadcastDims$1(inShape, outShape) {
  const inRank = inShape.length;
  const dims = [];
  for (let i2 = 0; i2 < inRank; i2++) {
    const dim = inRank - 1 - i2;
    const a6 = inShape[dim] || 1;
    const b2 = outShape[outShape.length - 1 - i2] || 1;
    if (b2 > 1 && a6 === 1) {
      dims.unshift(dim);
    }
  }
  return dims;
}
function getReductionAxes(inShape, outShape) {
  const result2 = [];
  for (let i2 = 0; i2 < outShape.length; i2++) {
    const inDim = inShape[inShape.length - i2 - 1];
    const outAxis = outShape.length - i2 - 1;
    const outDim = outShape[outAxis];
    if (inDim == null || inDim === 1 && outDim > 1) {
      result2.unshift(outAxis);
    }
  }
  return result2;
}
function assertAndGetBroadcastShape(shapeA, shapeB) {
  const result2 = [];
  const l2 = Math.max(shapeA.length, shapeB.length);
  for (let i2 = 0; i2 < l2; i2++) {
    let a6 = shapeA[shapeA.length - i2 - 1];
    if (a6 == null) {
      a6 = 1;
    }
    let b2 = shapeB[shapeB.length - i2 - 1];
    if (b2 == null) {
      b2 = 1;
    }
    if (a6 === 1) {
      result2.unshift(b2);
    } else if (b2 === 1) {
      result2.unshift(a6);
    } else if (a6 !== b2) {
      const errMsg = `Operands could not be broadcast together with shapes ${shapeA} and ${shapeB}.`;
      throw Error(errMsg);
    } else {
      result2.unshift(a6);
    }
  }
  return result2;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tensor3d(values, shape, dtype) {
  assertNonNull(values);
  if (shape != null && shape.length !== 3) {
    throw new Error("tensor3d() requires shape to have three numbers");
  }
  const inferredShape = inferShape(values, dtype);
  if (inferredShape.length !== 3 && inferredShape.length !== 1) {
    throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");
  }
  if (inferredShape.length === 1 && shape == null) {
    throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
  }
  return makeTensor(values, shape, inferredShape, dtype);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let fromPixels2DContext$1;
function fromPixels_(pixels, numChannels = 3) {
  if (numChannels > 4) {
    throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");
  }
  if (pixels == null) {
    throw new Error("pixels passed to tf.browser.fromPixels() can not be null");
  }
  let isPixelData2 = false;
  let isImageData = false;
  let isVideo = false;
  let isImage = false;
  let isCanvasLike = false;
  let isImageBitmap = false;
  if (pixels.data instanceof Uint8Array) {
    isPixelData2 = true;
  } else if (typeof ImageData !== "undefined" && pixels instanceof ImageData) {
    isImageData = true;
  } else if (typeof HTMLVideoElement !== "undefined" && pixels instanceof HTMLVideoElement) {
    isVideo = true;
  } else if (typeof HTMLImageElement !== "undefined" && pixels instanceof HTMLImageElement) {
    isImage = true;
  } else if (pixels.getContext != null) {
    isCanvasLike = true;
  } else if (typeof ImageBitmap !== "undefined" && pixels instanceof ImageBitmap) {
    isImageBitmap = true;
  } else {
    throw new Error(`pixels passed to tf.browser.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData in browser, or OffscreenCanvas, ImageData in webworker or {data: Uint32Array, width: number, height: number}, but was ${pixels.constructor.name}`);
  }
  if (isVideo) {
    const HAVE_CURRENT_DATA_READY_STATE = 2;
    if (isVideo && pixels.readyState < HAVE_CURRENT_DATA_READY_STATE) {
      throw new Error("The video element has not loaded data yet. Please wait for `loadeddata` event on the <video> element.");
    }
  }
  const kernel = getKernel(FromPixels, ENGINE.backendName);
  if (kernel != null) {
    const inputs = { pixels };
    const attrs = { numChannels };
    return ENGINE.runKernel(FromPixels, inputs, attrs);
  }
  const [width2, height2] = isVideo ? [
    pixels.videoWidth,
    pixels.videoHeight
  ] : [pixels.width, pixels.height];
  let vals;
  if (isCanvasLike) {
    vals = pixels.getContext("2d").getImageData(0, 0, width2, height2).data;
  } else if (isImageData || isPixelData2) {
    vals = pixels.data;
  } else if (isImage || isVideo || isImageBitmap) {
    if (fromPixels2DContext$1 == null) {
      if (typeof document === "undefined") {
        if (typeof OffscreenCanvas !== "undefined" && typeof OffscreenCanvasRenderingContext2D !== "undefined") {
          fromPixels2DContext$1 = new OffscreenCanvas(1, 1).getContext("2d");
        } else {
          throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
        }
      } else {
        fromPixels2DContext$1 = document.createElement("canvas").getContext("2d");
      }
    }
    fromPixels2DContext$1.canvas.width = width2;
    fromPixels2DContext$1.canvas.height = height2;
    fromPixels2DContext$1.drawImage(pixels, 0, 0, width2, height2);
    vals = fromPixels2DContext$1.getImageData(0, 0, width2, height2).data;
  }
  let values;
  if (numChannels === 4) {
    values = new Int32Array(vals);
  } else {
    const numPixels = width2 * height2;
    values = new Int32Array(numPixels * numChannels);
    for (let i2 = 0; i2 < numPixels; i2++) {
      for (let channel = 0; channel < numChannels; ++channel) {
        values[i2 * numChannels + channel] = vals[i2 * 4 + channel];
      }
    }
  }
  const outShape = [height2, width2, numChannels];
  return tensor3d(values, outShape, "int32");
}
function isPixelData(pixels) {
  return pixels != null && pixels.data instanceof Uint8Array;
}
function isImageBitmapFullySupported() {
  return typeof window !== "undefined" && typeof ImageBitmap !== "undefined" && window.hasOwnProperty("createImageBitmap");
}
function isNonEmptyPixels(pixels) {
  return pixels != null && pixels.width !== 0 && pixels.height !== 0;
}
function canWrapPixelsToImageBitmap(pixels) {
  return isImageBitmapFullySupported() && !(pixels instanceof ImageBitmap) && isNonEmptyPixels(pixels) && !isPixelData(pixels);
}
async function fromPixelsAsync(pixels, numChannels = 3) {
  let inputs = null;
  if (env().getBool("WRAP_TO_IMAGEBITMAP") && canWrapPixelsToImageBitmap(pixels)) {
    let imageBitmap;
    try {
      imageBitmap = await createImageBitmap(pixels, { premultiplyAlpha: "none" });
    } catch (e2) {
      imageBitmap = null;
    }
    if (imageBitmap != null && imageBitmap.width === pixels.width && imageBitmap.height === pixels.height) {
      inputs = imageBitmap;
    } else {
      inputs = pixels;
    }
  } else {
    inputs = pixels;
  }
  return fromPixels_(inputs, numChannels);
}
const fromPixels$1 = op({ fromPixels_ });
function prepareAndValidate(tensor2, indices) {
  const tensorRank = tensor2.shape.length;
  const indicesRank = indices.shape.length;
  if (tensorRank < 1) {
    throw new Error(`tf.gatherND() expects the input to be rank 1 or higher, but the rank was ${tensorRank}.`);
  }
  if (indicesRank < 1) {
    throw new Error(`tf.gatherND() expects the indices to be rank 1 or higher, but the rank was ${indicesRank}.`);
  }
  if (indices.dtype !== "int32") {
    throw new Error(`tf.gatherND() expects the indices to be int32 type, but the dtype was ${indices.dtype}.`);
  }
  if (indices.shape[indicesRank - 1] > tensorRank) {
    throw new Error(`index innermost dimension length must be <= tensor rank; saw: ${indices.shape[indicesRank - 1]} vs. ${tensorRank}`);
  }
  if (sizeFromShape(tensor2.shape) === 0) {
    throw new Error(`Requested more than 0 entries, but input is empty. Input shape: ${tensor2.shape}.`);
  }
  const indicesShape = indices.shape;
  const sliceRank = indicesShape[indicesShape.length - 1];
  let nResult = 1;
  for (let i2 = 0; i2 < indicesShape.length - 1; ++i2) {
    nResult *= indicesShape[i2];
  }
  const inputShape = tensor2.shape;
  const resultShape = indicesShape.slice();
  resultShape.pop();
  let sliceSize = 1;
  for (let i2 = sliceRank; i2 < tensorRank; ++i2) {
    sliceSize *= inputShape[i2];
    resultShape.push(inputShape[i2]);
  }
  const strides = [
    ...computeStrides(tensor2.shape).map((stride) => stride / sliceSize),
    1
  ].slice(0, sliceRank);
  return [resultShape, nResult, sliceSize, strides];
}
function validateUpdateShape(shape, indices, updates) {
  const sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
  const batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
  const shapeError = `Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: ${updates.shape}, indices.shape: ${indices.shape}, shape: ${shape}, sliceDim: ${sliceDim}, and batchDim: ${batchDim}.`;
  if (updates.rank < batchDim) {
    throw new Error(shapeError + ` update.rank < ${batchDim}. `);
  }
  if (shape.length < sliceDim + (updates.rank - batchDim)) {
    throw new Error(shapeError + ` Output shape length < ${sliceDim + (updates.rank - batchDim)}`);
  }
  if (updates.rank !== batchDim + shape.length - sliceDim) {
    throw new Error(shapeError + ` update.rank != ${batchDim + shape.length - sliceDim}`);
  }
  for (let d2 = 0; d2 < batchDim; ++d2) {
    if (updates.shape[d2] !== indices.shape[d2]) {
      throw new Error(shapeError + ` updates.shape[${d2}] (${updates.shape[d2]}) != indices.shape[${d2}] (${indices.shape[d2]}).`);
    }
  }
  for (let d2 = 0; d2 < updates.rank - batchDim; ++d2) {
    if (updates.shape[d2 + batchDim] !== shape[d2 + sliceDim]) {
      throw new Error(shapeError + ` updates.shape[${d2 + batchDim}] (${updates.shape[d2 + batchDim]}) != shape[${d2 + batchDim}] (${shape[d2 + batchDim]})`);
    }
  }
}
function validateInput$1(updates, indices, shape) {
  if (indices.rank < 1) {
    throw new Error(`tf.scatterND() expects the indices to be rank 1 or higher, but the rank was ${indices.rank}.`);
  }
  if (updates.rank < 1) {
    throw new Error(`tf.scatterND() expects the updates to be rank 1 or higher, but the rank was ${updates.rank}.`);
  }
  if (indices.dtype !== "int32") {
    throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${indices.dtype}`);
  }
  if (shape.length < 1) {
    throw new Error(`Output rank must be greater or equal to 1, but got shape: ${shape}`);
  }
  if (shape.length === 0) {
    if (indices.size === 0) {
      throw new Error(`Indices specified for empty output. indices shape: ${indices.shape}`);
    }
    if (updates.size === 0) {
      throw new Error(`Updates specified for empty output. updates shape: ${updates.shape}`);
    }
  }
  validateUpdateShape(shape, indices, updates);
}
function calculateShapes(updates, indices, shape) {
  const indicesRank = indices.shape.length;
  const sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1;
  const totalNd = shape.length;
  let sliceSize = 1;
  for (let i2 = sliceRank; i2 < totalNd; ++i2) {
    sliceSize *= shape[i2];
  }
  const safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
  const numUpdates = sizeFromShape(indices.shape) / safeSliceDim;
  const strides = [...computeStrides(shape.slice(0, sliceRank)), 1];
  const outputSize = sizeFromShape(shape);
  return { sliceRank, numUpdates, sliceSize, strides, outputSize };
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const NEW_AXIS = -2;
const SHRINK_AXIS = -1;
function assertParamsValid(input, begin, size) {
  const inputRank = input.shape.length;
  assert$1(inputRank === begin.length, () => `Error in slice${inputRank}D: Length of begin ${begin} must match the rank of the array (${inputRank}).`);
  assert$1(inputRank === size.length, () => `Error in slice${inputRank}D: Length of size ${size} must match the rank of the array (${inputRank}).`);
  for (let i2 = 0; i2 < inputRank; ++i2) {
    assert$1(begin[i2] + size[i2] <= input.shape[i2], () => `Error in slice${inputRank}D: begin[${i2}] + size[${i2}] (${begin[i2] + size[i2]}) would overflow input.shape[${i2}] (${input.shape[i2]})`);
  }
}
function maskToAxes(mask) {
  const axes = [];
  let axis = 0;
  while (mask > 0) {
    if (mask & 1) {
      axes.push(axis);
    }
    mask /= 2;
    axis++;
  }
  return axes;
}
function computeOutShape$3(begin, end, strides) {
  const size = [];
  for (let axis = 0; axis < begin.length; axis++) {
    size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
  }
  return size;
}
function stridesWithElidedDims(strides, ellipsisInsertionIndex, numElidedAxes, inputShape) {
  const newStrides = [...strides];
  for (let i2 = newStrides.length; i2 < inputShape.length; i2++) {
    newStrides.push(1);
  }
  for (let i2 = 0; i2 < numElidedAxes; i2++) {
    if (i2 === 0) {
      newStrides[ellipsisInsertionIndex] = 1;
    } else {
      newStrides.splice(ellipsisInsertionIndex, 0, 1);
      newStrides.pop();
    }
  }
  return newStrides;
}
function unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, normalizedAxis) {
  if (normalizedAxis <= ellipsisInsertionIndex) {
    return normalizedAxis;
  }
  return normalizedAxis - (numElidedAxes - 1);
}
function getElidedAxes(numElidedAxes, ellipsisInsertionIndex) {
  const elidedAxes = [];
  for (let i2 = 0; i2 < numElidedAxes; i2++) {
    elidedAxes.push(ellipsisInsertionIndex + i2);
  }
  return elidedAxes;
}
function getNormalizedAxes(inputShape, ellipsisAxes, numInterpolatedAxes, begin, end, strides, beginMask, endMask, ellipsisMask) {
  const inputRank = inputShape.length;
  let normalizedBegin = new Array(inputRank), normalizedEnd = new Array(inputRank), normalizedStrides = new Array(inputRank);
  if (ellipsisAxes.length && numInterpolatedAxes > 0) {
    const fullIndex = ellipsisAxes[0];
    const numElidedAxes = numInterpolatedAxes + 1;
    normalizedBegin = startIndicesWithElidedDims(beginMask, fullIndex, numElidedAxes, begin, inputShape);
    normalizedEnd = stopIndicesWithElidedDims(endMask, fullIndex, numElidedAxes, end, inputShape);
    normalizedStrides = stridesWithElidedDims(strides, fullIndex, numElidedAxes, inputShape);
  } else {
    for (let axis = 0; axis < inputRank; axis++) {
      normalizedBegin[axis] = startForAxis(beginMask, begin, strides, inputShape, axis, ellipsisMask);
      normalizedEnd[axis] = stopForAxis(endMask, end, strides, inputShape, axis, ellipsisMask);
      normalizedStrides[axis] = stridesForAxis(strides, axis, ellipsisMask);
    }
  }
  return {
    begin: normalizedBegin,
    end: normalizedEnd,
    strides: normalizedStrides
  };
}
function startIndicesWithElidedDims(beginMask, ellipsisInsertionIndex, numElidedAxes, originalBegin, inputShape) {
  const newIndices = [...inputShape];
  const elidedAxes = getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
  for (let axis = 0; axis < newIndices.length; axis++) {
    if (elidedAxes.indexOf(axis) > -1) {
      newIndices[axis] = 0;
    } else {
      const originalAxis = unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
      let originalValue = originalBegin[originalAxis];
      if (beginMask & 1 << originalAxis) {
        originalValue = 0;
      }
      newIndices[axis] = originalValue;
    }
  }
  return newIndices;
}
function stopIndicesWithElidedDims(endMask, ellipsisInsertionIndex, numElidedAxes, originalEnd, inputShape) {
  const newIndices = [...inputShape];
  const elidedAxes = getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
  for (let axis = 0; axis < newIndices.length; axis++) {
    if (elidedAxes.indexOf(axis) > -1) {
      newIndices[axis] = Number.MAX_SAFE_INTEGER;
    } else {
      const originalAxis = unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
      let originalValue = originalEnd[originalAxis];
      if (endMask & 1 << originalAxis) {
        originalValue = Number.MAX_SAFE_INTEGER;
      }
      newIndices[axis] = originalValue;
    }
  }
  for (let i2 = 0; i2 < newIndices.length; i2++) {
    const axisSize = inputShape[i2];
    if (newIndices[i2] < 0) {
      newIndices[i2] += axisSize;
    }
    newIndices[i2] = clamp$2(0, newIndices[i2], inputShape[i2]);
  }
  return newIndices;
}
function stridesForAxis(strides, axis, ellipsisMask) {
  let stride = strides[axis];
  if (ellipsisMask & 1 << axis || stride == null) {
    stride = 1;
  }
  return stride;
}
function startForAxis(beginMask, startIndices, strides, inputShape, axis, ellipsisMask) {
  let start = startIndices[axis];
  const stride = strides[axis] || 1;
  if (beginMask & 1 << axis || ellipsisMask & 1 << axis || start == null) {
    if (stride > 0) {
      start = Number.MIN_SAFE_INTEGER;
    } else {
      start = Number.MAX_SAFE_INTEGER;
    }
  }
  const axisSize = inputShape[axis];
  if (start < 0) {
    start += axisSize;
  }
  start = clamp$2(0, start, axisSize - 1);
  return start;
}
function stopForAxis(endMask, stopIndices, strides, inputShape, axis, ellipsisMask) {
  let stop = stopIndices[axis];
  const stride = strides[axis] || 1;
  if (endMask & 1 << axis || ellipsisMask & 1 << axis || stop == null) {
    if (stride > 0) {
      stop = Number.MAX_SAFE_INTEGER;
    } else {
      stop = Number.MIN_SAFE_INTEGER;
    }
  }
  const axisSize = inputShape[axis];
  if (stop < 0) {
    stop += axisSize;
  }
  if (stride > 0) {
    stop = clamp$2(0, stop, axisSize);
  } else {
    stop = clamp$2(-1, stop, axisSize - 1);
  }
  return stop;
}
function isSliceContinous(shape, begin, size) {
  let firstNonOneAxis = size.length;
  for (let i2 = 0; i2 < size.length; i2++) {
    if (size[i2] > 1) {
      firstNonOneAxis = i2;
      break;
    }
  }
  for (let i2 = firstNonOneAxis + 1; i2 < size.length; i2++) {
    if (begin[i2] > 0 || size[i2] !== shape[i2]) {
      return false;
    }
  }
  return true;
}
function computeFlatOffset(begin, strides) {
  let flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
  for (let i2 = 0; i2 < begin.length - 1; i2++) {
    flatOffset += begin[i2] * strides[i2];
  }
  return flatOffset;
}
function parseSliceParams(x2, begin, size) {
  let begin_;
  const xRank = x2.shape.length;
  if (typeof begin === "number") {
    begin_ = [begin, ...new Array(xRank - 1).fill(0)];
  } else if (begin.length < xRank) {
    begin_ = begin.concat(new Array(xRank - begin.length).fill(0));
  } else {
    begin_ = begin.slice();
  }
  begin_.forEach((d2) => {
    assert$1(d2 !== -1, () => "slice() does not support negative begin indexing.");
  });
  let size_;
  if (size == null) {
    size_ = new Array(xRank).fill(-1);
  } else if (typeof size === "number") {
    size_ = [size, ...new Array(xRank - 1).fill(-1)];
  } else if (size.length < xRank) {
    size_ = size.concat(new Array(xRank - size.length).fill(-1));
  } else {
    size_ = size;
  }
  size_ = size_.map((d2, i2) => {
    if (d2 >= 0) {
      return d2;
    } else {
      assert$1(d2 === -1, () => `Negative size values should be exactly -1 but got ${d2} for the slice() size at index ${i2}.`);
      return x2.shape[i2] - begin_[i2];
    }
  });
  return [begin_, size_];
}
function sliceInfo(xShape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
  let stridesNonNull;
  if (strides == null) {
    stridesNonNull = new Array(begin.length);
    stridesNonNull.fill(1);
  } else {
    stridesNonNull = strides;
  }
  if (ellipsisMask != null && (ellipsisMask & ellipsisMask - 1) !== 0) {
    throw new Error("Multiple ellipses in slice is not allowed.");
  }
  let ellipsisSeen = false;
  const sparseSpec = {
    dims: stridesNonNull.length,
    numAddAxisAfterEllipsis: 0,
    begin: begin.slice(),
    end: end.slice(),
    strides: stridesNonNull.slice(),
    beginMask,
    endMask,
    ellipsisMask,
    newAxisMask,
    shrinkAxisMask
  };
  for (let i2 = 0; i2 < sparseSpec.dims; i2++) {
    if (ellipsisSeen && (1 << i2 & newAxisMask) !== 0) {
      sparseSpec.numAddAxisAfterEllipsis++;
    }
    if (1 << i2 & ellipsisMask) {
      ellipsisSeen = true;
    }
  }
  if (!ellipsisSeen) {
    sparseSpec.ellipsisMask |= 1 << sparseSpec.dims;
    sparseSpec.dims++;
  }
  const denseSpec = {
    dims: xShape.length,
    beginMask: 0,
    endMask: 0,
    beginValid: false,
    endValid: false
  };
  buildDenseSpec(sparseSpec, denseSpec);
  let isIdentity = true;
  let sliceDim0 = true;
  let isSimpleSlice = true;
  const processingShape = [];
  const finalShape = [];
  for (let i2 = 0; i2 < xShape.length; ++i2) {
    if (denseSpec.strides[i2] === 0) {
      throw Error(`strides[${i2}] must be non-zero`);
    }
    const shrinkI = !!(denseSpec.shrinkAxisMask & 1 << i2);
    const dimI = xShape[i2];
    if (dimI === -1) {
      processingShape.push(shrinkI ? 1 : -1);
      continue;
    }
    const masks = [denseSpec.beginMask & 1 << i2, denseSpec.endMask & 1 << i2];
    const validRange = [
      denseSpec.strides[i2] > 0 ? 0 : -1,
      denseSpec.strides[i2] > 0 ? dimI : dimI - 1
    ];
    if (shrinkI && denseSpec.strides[i2] <= 0) {
      throw Error("only stride 1 allowed on non-range indexing.");
    }
    isSimpleSlice = isSimpleSlice && denseSpec.strides[i2] === 1;
    const beginAndEndMasked = !!(denseSpec.beginMask & 1 << i2 && denseSpec.endMask & 1 << i2);
    if (denseSpec.beginValid && denseSpec.endValid) {
      if (shrinkI) {
        const xFwd = denseSpec.begin[i2] < 0 ? dimI + denseSpec.begin[i2] : denseSpec.begin[i2];
        denseSpec.begin[i2] = xFwd;
        denseSpec.end[i2] = denseSpec.begin[i2] + 1;
        if (xFwd < 0 || xFwd >= dimI) {
          throw Error(`slice index ${denseSpec.begin[i2]} of dimension ${i2} out of bounds.`);
        }
      } else {
        denseSpec.begin[i2] = canonical(denseSpec.begin[i2], 0, denseSpec.strides[i2], dimI, masks, validRange);
        denseSpec.end[i2] = canonical(denseSpec.end[i2], 1, denseSpec.strides[i2], dimI, masks, validRange);
      }
      const takeAllInDimension = denseSpec.strides[i2] === 1 && denseSpec.begin[i2] === 0 && denseSpec.end[i2] === dimI;
      isIdentity = isIdentity && takeAllInDimension;
      sliceDim0 = sliceDim0 && (i2 === 0 && denseSpec.strides[i2] === 1 || takeAllInDimension);
    } else {
      isIdentity = isIdentity && (denseSpec.strides[i2] === 1 && beginAndEndMasked);
      sliceDim0 = sliceDim0 && (i2 === 0 && denseSpec.strides[i2] === 1 || beginAndEndMasked);
    }
    let intervalLength;
    let knownInterval = false;
    if (denseSpec.beginValid && denseSpec.endValid) {
      intervalLength = denseSpec.end[i2] - denseSpec.begin[i2];
      knownInterval = true;
    } else if (shrinkI) {
      intervalLength = 1;
      knownInterval = true;
    } else if (beginAndEndMasked) {
      if (dimI >= 0) {
        if (denseSpec.strides[i2] < 0) {
          intervalLength = -dimI;
        } else {
          intervalLength = dimI;
        }
        knownInterval = true;
      }
    }
    if (knownInterval) {
      let sizeI;
      if (intervalLength === 0 || intervalLength < 0 !== denseSpec.strides[i2] < 0) {
        sizeI = 0;
      } else {
        sizeI = Math.trunc(intervalLength / denseSpec.strides[i2]) + (intervalLength % denseSpec.strides[i2] !== 0 ? 1 : 0);
      }
      processingShape.push(sizeI);
    } else {
      processingShape.push(-1);
    }
  }
  for (let denseDim = 0; denseDim < denseSpec.finalShapeGatherIndices.length; ++denseDim) {
    const gatherIndex = denseSpec.finalShapeGatherIndices[denseDim];
    if (gatherIndex >= 0) {
      finalShape.push(processingShape[gatherIndex]);
    } else if (gatherIndex === NEW_AXIS) {
      finalShape.push(1);
    }
  }
  const finalShapeSparse = finalShape.filter((dim, i2) => denseSpec.finalShapeGatherIndices[i2] !== NEW_AXIS);
  return {
    finalShapeSparse,
    finalShape,
    isIdentity,
    sliceDim0,
    isSimpleSlice,
    begin: denseSpec.begin,
    end: denseSpec.end,
    strides: denseSpec.strides
  };
}
function buildDenseSpec(sparse2, dense) {
  dense.beginMask = 0;
  dense.endMask = 0;
  dense.shrinkAxisMask = 0;
  let fullIndex = 0;
  dense.beginValid = sparse2.begin != null;
  dense.endValid = sparse2.end != null;
  dense.begin = new Array(dense.dims);
  dense.end = new Array(dense.dims);
  dense.strides = new Array(dense.dims);
  dense.finalShapeGatherIndices = [];
  dense.finalShapeGatherIndicesSparse = [];
  dense.inputShapeGatherIndicesSparse = new Array(dense.dims);
  for (let i2 = 0; i2 < sparse2.dims; i2++) {
    if (1 << i2 & sparse2.ellipsisMask) {
      const nextIndex = Math.min(dense.dims - (sparse2.dims - i2) + 1 + sparse2.numAddAxisAfterEllipsis, dense.dims);
      for (; fullIndex < nextIndex; fullIndex++) {
        dense.begin[fullIndex] = 0;
        dense.end[fullIndex] = 0;
        dense.strides[fullIndex] = 1;
        dense.beginMask |= 1 << fullIndex;
        dense.endMask |= 1 << fullIndex;
        dense.finalShapeGatherIndices.push(fullIndex);
        dense.finalShapeGatherIndicesSparse.push(-1);
        dense.inputShapeGatherIndicesSparse[fullIndex] = i2;
      }
    } else if (1 << i2 & sparse2.newAxisMask) {
      dense.finalShapeGatherIndices.push(NEW_AXIS);
      dense.finalShapeGatherIndicesSparse.push(-1);
    } else {
      if (fullIndex === dense.begin.length) {
        throw Error(`Index out of range using input dim ${fullIndex}; input has only ${dense.dims} dims, ${dense.begin.length}.`);
      }
      if (sparse2.begin != null) {
        dense.begin[fullIndex] = sparse2.begin[i2];
      }
      if (sparse2.end != null) {
        dense.end[fullIndex] = sparse2.end[i2];
      }
      dense.strides[fullIndex] = sparse2.strides[i2];
      if (sparse2.beginMask & 1 << i2) {
        dense.beginMask |= 1 << fullIndex;
      }
      if (sparse2.endMask & 1 << i2) {
        dense.endMask |= 1 << fullIndex;
      }
      if (sparse2.shrinkAxisMask & 1 << i2) {
        dense.finalShapeGatherIndices.push(SHRINK_AXIS);
        dense.finalShapeGatherIndicesSparse.push(-1);
        dense.shrinkAxisMask |= 1 << fullIndex;
      } else {
        dense.finalShapeGatherIndices.push(fullIndex);
        dense.finalShapeGatherIndicesSparse.push(i2);
      }
      dense.inputShapeGatherIndicesSparse[fullIndex] = i2;
      fullIndex++;
    }
  }
}
function canonical(x2, c2, strideI, dimI, masks, validRange) {
  if (masks[c2]) {
    return strideI > 0 ? validRange[c2] : validRange[c2 + 1 & 1];
  } else {
    const xFwd = x2 < 0 ? dimI + x2 : x2;
    return xFwd < validRange[0] ? validRange[0] : xFwd > validRange[1] ? validRange[1] : xFwd;
  }
}
var slice_util = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  assertParamsValid,
  maskToAxes,
  computeOutShape: computeOutShape$3,
  stridesWithElidedDims,
  getNormalizedAxes,
  startIndicesWithElidedDims,
  stopIndicesWithElidedDims,
  stridesForAxis,
  startForAxis,
  stopForAxis,
  isSliceContinous,
  computeFlatOffset,
  parseSliceParams,
  sliceInfo
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Serializable {
  getClassName() {
    return this.constructor.className;
  }
  static fromConfig(cls, config2) {
    return new cls(config2);
  }
}
class SerializationMap {
  constructor() {
    this.classNameMap = {};
  }
  static getMap() {
    if (SerializationMap.instance == null) {
      SerializationMap.instance = new SerializationMap();
    }
    return SerializationMap.instance;
  }
  static register(cls) {
    SerializationMap.getMap().classNameMap[cls.className] = [cls, cls.fromConfig];
  }
}
function registerClass(cls) {
  assert$1(cls.className != null, () => `Class being registered does not have the static className property defined.`);
  assert$1(typeof cls.className === "string", () => `className is required to be a string, but got type ` + typeof cls.className);
  assert$1(cls.className.length > 0, () => `Class being registered has an empty-string as its className, which is disallowed.`);
  SerializationMap.register(cls);
}
/** @license See the LICENSE file. */
const version$6 = "3.16.0";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function enableProdMode() {
  env().set("PROD", true);
}
function engine() {
  return ENGINE;
}
function memory() {
  return ENGINE.memory();
}
function tidy(nameOrFn, fn) {
  return ENGINE.tidy(nameOrFn, fn);
}
function dispose(container) {
  const tensors = getTensorsInContainer(container);
  tensors.forEach((tensor2) => tensor2.dispose());
}
function keep(result2) {
  return ENGINE.keep(result2);
}
function setBackend(backendName) {
  return ENGINE.setBackend(backendName);
}
function getBackend() {
  return ENGINE.backendName;
}
function registerBackend(name, factory, priority = 1) {
  return ENGINE.registerBackend(name, factory, priority);
}
function backend() {
  return ENGINE.backend;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function add_(a6, b2) {
  let $a = convertToTensor(a6, "a", "add");
  let $b = convertToTensor(b2, "b", "add");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Add$1, inputs);
}
const add$1 = op({ add_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function floorDiv_(a6, b2) {
  let $a = convertToTensor(a6, "a", "floorDiv");
  let $b = convertToTensor(b2, "b", "floorDiv");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(FloorDiv, inputs);
}
const floorDiv$2 = op({ floorDiv_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function div_(a6, b2) {
  let $a = convertToTensor(a6, "a", "div");
  let $b = convertToTensor(b2, "b", "div");
  [$a, $b] = makeTypesMatch($a, $b);
  if ($a.dtype === "int32" && $b.dtype === "int32") {
    return floorDiv$2($a, $b);
  }
  const inputs = { a: $a, b: $b };
  const attrs = {};
  return ENGINE.runKernel(RealDiv, inputs, attrs);
}
const div$1 = op({ div_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mul_(a6, b2) {
  let $a = convertToTensor(a6, "a", "mul");
  let $b = convertToTensor(b2, "b", "mul");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Multiply$1, inputs);
}
const mul = op({ mul_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function abs_(x2) {
  const $x = convertToTensor(x2, "x", "abs");
  if ($x.dtype === "complex64") {
    const inputs = { x: $x };
    return ENGINE.runKernel(ComplexAbs, inputs);
  } else {
    const inputs = { x: $x };
    return ENGINE.runKernel(Abs, inputs);
  }
}
const abs$2 = op({ abs_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function acos_(x2) {
  const $x = convertToTensor(x2, "x", "acos");
  const inputs = { x: $x };
  return ENGINE.runKernel(Acos, inputs);
}
const acos$2 = op({ acos_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function acosh_(x2) {
  const $x = convertToTensor(x2, "x", "acosh");
  const inputs = { x: $x };
  return ENGINE.runKernel(Acosh, inputs);
}
const acosh$2 = op({ acosh_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function addN_(tensors) {
  assert$1(Array.isArray(tensors), () => "The argument passed to tf.addN() must be a list of tensors");
  assert$1(tensors.length >= 1, () => `Must pass at least one tensor to tf.addN(), but got ${tensors.length}`);
  const $tensors = tensors.map((t2, i2) => convertToTensor(t2, `tensors${i2}`, "addN"));
  const firstTensor = $tensors[0];
  $tensors.forEach((t2) => {
    if (t2.dtype !== firstTensor.dtype) {
      throw new Error("All tensors passed to tf.addN() must have the same dtype");
    }
  });
  $tensors.forEach((t2) => {
    if (!arraysEqual(t2.shape, firstTensor.shape)) {
      throw new Error("All tensors passed to tf.addN() must have the same shape");
    }
  });
  const inputs = $tensors;
  return ENGINE.runKernel(AddN, inputs);
}
const addN$2 = op({ addN_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function all_(x2, axis = null, keepDims = false) {
  const $x = convertToTensor(x2, "x", "all", "bool");
  const inputs = { x: $x };
  const attrs = { axis, keepDims };
  return ENGINE.runKernel(All, inputs, attrs);
}
const all$3 = op({ all_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function any_(x2, axis = null, keepDims = false) {
  const $x = convertToTensor(x2, "x", "any", "bool");
  const inputs = { x: $x };
  const attrs = { axis, keepDims };
  return ENGINE.runKernel(Any, inputs, attrs);
}
const any$3 = op({ any_ });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argMax_(x2, axis = 0) {
  const $x = convertToTensor(x2, "x", "argMax");
  const inputs = { x: $x };
  const attrs = { axis };
  return ENGINE.runKernel(ArgMax, inputs, attrs);
}
const argMax$2 = op({ argMax_ });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argMin_(x2, axis = 0) {
  const $x = convertToTensor(x2, "x", "argMin");
  const inputs = { x: $x };
  const attrs = { axis };
  return ENGINE.runKernel(ArgMin, inputs, attrs);
}
const argMin$2 = op({ argMin_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function asin_(x2) {
  const $x = convertToTensor(x2, "x", "asin");
  const inputs = { x: $x };
  return ENGINE.runKernel(Asin, inputs);
}
const asin$2 = op({ asin_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function asinh_(x2) {
  const $x = convertToTensor(x2, "x", "asinh");
  const inputs = { x: $x };
  return ENGINE.runKernel(Asinh, inputs);
}
const asinh$2 = op({ asinh_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function atan_(x2) {
  const $x = convertToTensor(x2, "x", "atan");
  const inputs = { x: $x };
  return ENGINE.runKernel(Atan, inputs);
}
const atan$2 = op({ atan_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function atan2_(a6, b2) {
  let $a = convertToTensor(a6, "a", "atan2");
  let $b = convertToTensor(b2, "b", "atan2");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Atan2, inputs);
}
const atan2$2 = op({ atan2_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function atanh_(x2) {
  const $x = convertToTensor(x2, "x", "atanh");
  const inputs = { x: $x };
  return ENGINE.runKernel(Atanh, inputs);
}
const atanh$2 = op({ atanh_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function computeDilation2DInfo(inputShape, filterShape, strides, pad2, dataFormat = "NHWC", dilations) {
  const inputChannels = inputShape[3];
  const $filterShape = [...filterShape, inputChannels];
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  return computeConv2DInfo(inputShape, $filterShape, strides, dilations, pad2, null, null, $dataFormat);
}
function computePool2DInfo(inShape, filterSize, strides, dilations, pad2, roundingMode, dataFormat = "channelsLast") {
  const [filterHeight, filterWidth] = parseTupleParam(filterSize);
  let filterShape;
  if (dataFormat === "channelsLast") {
    filterShape = [filterHeight, filterWidth, inShape[3], inShape[3]];
  } else if (dataFormat === "channelsFirst") {
    filterShape = [filterHeight, filterWidth, inShape[1], inShape[1]];
  } else {
    throw new Error(`Unknown dataFormat ${dataFormat}`);
  }
  return computeConv2DInfo(inShape, filterShape, strides, dilations, pad2, roundingMode, false, dataFormat);
}
function computePool3DInfo(inShape, filterSize, strides, dilations, pad2, roundingMode, dataFormat = "NDHWC") {
  const [filterDepth, filterHeight, filterWidth] = parse3TupleParam(filterSize);
  let filterShape;
  let $dataFormat;
  if (dataFormat === "NDHWC") {
    $dataFormat = "channelsLast";
    filterShape = [filterDepth, filterHeight, filterWidth, inShape[4], inShape[4]];
  } else if (dataFormat === "NCDHW") {
    $dataFormat = "channelsFirst";
    filterShape = [filterDepth, filterHeight, filterWidth, inShape[1], inShape[1]];
  } else {
    throw new Error(`Unknown dataFormat ${dataFormat}`);
  }
  return computeConv3DInfo(inShape, filterShape, strides, dilations, pad2, false, $dataFormat, roundingMode);
}
function computeConv2DInfo(inShape, filterShape, strides, dilations, pad2, roundingMode, depthwise = false, dataFormat = "channelsLast") {
  let [batchSize, inHeight, inWidth, inChannels] = [-1, -1, -1, -1];
  if (dataFormat === "channelsLast") {
    [batchSize, inHeight, inWidth, inChannels] = inShape;
  } else if (dataFormat === "channelsFirst") {
    [batchSize, inChannels, inHeight, inWidth] = inShape;
  } else {
    throw new Error(`Unknown dataFormat ${dataFormat}`);
  }
  const [filterHeight, filterWidth, , filterChannels] = filterShape;
  const [strideHeight, strideWidth] = parseTupleParam(strides);
  const [dilationHeight, dilationWidth] = parseTupleParam(dilations);
  const effectiveFilterHeight = getEffectiveFilterSize(filterHeight, dilationHeight);
  const effectiveFilterWidth = getEffectiveFilterSize(filterWidth, dilationWidth);
  const { padInfo, outHeight, outWidth } = getPadAndOutInfo(pad2, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode, dataFormat);
  const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
  let outShape;
  if (dataFormat === "channelsFirst") {
    outShape = [batchSize, outChannels, outHeight, outWidth];
  } else if (dataFormat === "channelsLast") {
    outShape = [batchSize, outHeight, outWidth, outChannels];
  }
  return {
    batchSize,
    dataFormat,
    inHeight,
    inWidth,
    inChannels,
    outHeight,
    outWidth,
    outChannels,
    padInfo,
    strideHeight,
    strideWidth,
    filterHeight,
    filterWidth,
    effectiveFilterHeight,
    effectiveFilterWidth,
    dilationHeight,
    dilationWidth,
    inShape,
    outShape,
    filterShape
  };
}
function computeConv3DInfo(inShape, filterShape, strides, dilations, pad2, depthwise = false, dataFormat = "channelsLast", roundingMode) {
  let [batchSize, inDepth, inHeight, inWidth, inChannels] = [-1, -1, -1, -1, -1];
  if (dataFormat === "channelsLast") {
    [batchSize, inDepth, inHeight, inWidth, inChannels] = inShape;
  } else if (dataFormat === "channelsFirst") {
    [batchSize, inChannels, inDepth, inHeight, inWidth] = inShape;
  } else {
    throw new Error(`Unknown dataFormat ${dataFormat}`);
  }
  const [filterDepth, filterHeight, filterWidth, , filterChannels] = filterShape;
  const [strideDepth, strideHeight, strideWidth] = parse3TupleParam(strides);
  const [dilationDepth, dilationHeight, dilationWidth] = parse3TupleParam(dilations);
  const effectiveFilterDepth = getEffectiveFilterSize(filterDepth, dilationDepth);
  const effectiveFilterHeight = getEffectiveFilterSize(filterHeight, dilationHeight);
  const effectiveFilterWidth = getEffectiveFilterSize(filterWidth, dilationWidth);
  const { padInfo, outDepth, outHeight, outWidth } = get3DPadAndOutInfo(pad2, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode);
  const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
  let outShape;
  if (dataFormat === "channelsFirst") {
    outShape = [batchSize, outChannels, outDepth, outHeight, outWidth];
  } else if (dataFormat === "channelsLast") {
    outShape = [batchSize, outDepth, outHeight, outWidth, outChannels];
  }
  return {
    batchSize,
    dataFormat,
    inDepth,
    inHeight,
    inWidth,
    inChannels,
    outDepth,
    outHeight,
    outWidth,
    outChannels,
    padInfo,
    strideDepth,
    strideHeight,
    strideWidth,
    filterDepth,
    filterHeight,
    filterWidth,
    effectiveFilterDepth,
    effectiveFilterHeight,
    effectiveFilterWidth,
    dilationDepth,
    dilationHeight,
    dilationWidth,
    inShape,
    outShape,
    filterShape
  };
}
function computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
  if (zeroPad == null) {
    zeroPad = computeDefaultPad(inShape, fieldSize, stride);
  }
  const inputRows = inShape[0];
  const inputCols = inShape[1];
  const outputRows = round$3((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
  const outputCols = round$3((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
  return [outputRows, outputCols];
}
function computeOutputShape4D(inShape, fieldSize, outChannels, stride, zeroPad, roundingMode) {
  if (zeroPad == null) {
    zeroPad = computeDefaultPad(inShape, fieldSize, stride);
  }
  const inputDepth = inShape[0];
  const inputRows = inShape[1];
  const inputCols = inShape[2];
  const outputDepths = round$3((inputDepth - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
  const outputRows = round$3((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
  const outputCols = round$3((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
  return [outputDepths, outputRows, outputCols, outChannels];
}
function computeDefaultPad(inputShape, fieldSize, stride, dilation = 1) {
  const effectiveFieldSize = getEffectiveFilterSize(fieldSize, dilation);
  return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
}
function parseTupleParam(param) {
  if (typeof param === "number") {
    return [param, param, param];
  }
  if (param.length === 2) {
    return [param[0], param[1], 1];
  }
  return param;
}
function parse3TupleParam(param) {
  return typeof param === "number" ? [param, param, param] : param;
}
function getEffectiveFilterSize(filterSize, dilation) {
  if (dilation <= 1) {
    return filterSize;
  }
  return filterSize + (filterSize - 1) * (dilation - 1);
}
function getPadAndOutInfo(pad2, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode, dataFormat) {
  let padInfo;
  let outHeight;
  let outWidth;
  if (typeof pad2 === "number") {
    const padType = pad2 === 0 ? "VALID" : "NUMBER";
    padInfo = { top: pad2, bottom: pad2, left: pad2, right: pad2, type: padType };
    const outShape = computeOutputShape2D([inHeight, inWidth], filterHeight, strideHeight, pad2, roundingMode);
    outHeight = outShape[0];
    outWidth = outShape[1];
  } else if (pad2 === "same") {
    outHeight = Math.ceil(inHeight / strideHeight);
    outWidth = Math.ceil(inWidth / strideWidth);
    const padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
    const padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
    const top2 = Math.floor(padAlongHeight / 2);
    const bottom = padAlongHeight - top2;
    const left2 = Math.floor(padAlongWidth / 2);
    const right = padAlongWidth - left2;
    padInfo = { top: top2, bottom, left: left2, right, type: "SAME" };
  } else if (pad2 === "valid") {
    padInfo = { top: 0, bottom: 0, left: 0, right: 0, type: "VALID" };
    outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
    outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
  } else if (typeof pad2 === "object") {
    const top2 = dataFormat === "channelsLast" ? pad2[1][0] : pad2[2][0];
    const bottom = dataFormat === "channelsLast" ? pad2[1][1] : pad2[2][1];
    const left2 = dataFormat === "channelsLast" ? pad2[2][0] : pad2[3][0];
    const right = dataFormat === "channelsLast" ? pad2[2][1] : pad2[3][1];
    const padType = top2 === 0 && bottom === 0 && left2 === 0 && right === 0 ? "VALID" : "EXPLICIT";
    padInfo = { top: top2, bottom, left: left2, right, type: padType };
    outHeight = round$3((inHeight - filterHeight + top2 + bottom) / strideHeight + 1, roundingMode);
    outWidth = round$3((inWidth - filterWidth + left2 + right) / strideWidth + 1, roundingMode);
  } else {
    throw Error(`Unknown padding parameter: ${pad2}`);
  }
  return { padInfo, outHeight, outWidth };
}
function get3DPadAndOutInfo(pad2, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
  let padInfo;
  let outDepth;
  let outHeight;
  let outWidth;
  if (typeof pad2 === "number") {
    const padType = pad2 === 0 ? "VALID" : "NUMBER";
    padInfo = {
      top: pad2,
      bottom: pad2,
      left: pad2,
      right: pad2,
      front: pad2,
      back: pad2,
      type: padType
    };
    const outShape = computeOutputShape4D([inDepth, inHeight, inWidth, 1], filterDepth, 1, strideDepth, pad2, roundingMode);
    outDepth = outShape[0];
    outHeight = outShape[1];
    outWidth = outShape[2];
  } else if (pad2 === "same") {
    outDepth = Math.ceil(inDepth / strideDepth);
    outHeight = Math.ceil(inHeight / strideHeight);
    outWidth = Math.ceil(inWidth / strideWidth);
    const padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
    const padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
    const padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
    const front = Math.floor(padAlongDepth / 2);
    const back = padAlongDepth - front;
    const top2 = Math.floor(padAlongHeight / 2);
    const bottom = padAlongHeight - top2;
    const left2 = Math.floor(padAlongWidth / 2);
    const right = padAlongWidth - left2;
    padInfo = { top: top2, bottom, left: left2, right, front, back, type: "SAME" };
  } else if (pad2 === "valid") {
    padInfo = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      front: 0,
      back: 0,
      type: "VALID"
    };
    outDepth = Math.ceil((inDepth - filterDepth + 1) / strideDepth);
    outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
    outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
  } else {
    throw Error(`Unknown padding parameter: ${pad2}`);
  }
  return { padInfo, outDepth, outHeight, outWidth };
}
function round$3(value, roundingMode) {
  if (!roundingMode) {
    return Math.trunc(value);
  }
  switch (roundingMode) {
    case "round":
      return Math.round(value);
    case "ceil":
      return Math.ceil(value);
    case "floor":
      return Math.floor(value);
    default:
      throw new Error(`Unknown roundingMode ${roundingMode}`);
  }
}
function tupleValuesAreOne(param) {
  const [dimA, dimB, dimC] = parseTupleParam(param);
  return dimA === 1 && dimB === 1 && dimC === 1;
}
function eitherStridesOrDilationsAreOne(strides, dilations) {
  return tupleValuesAreOne(strides) || tupleValuesAreOne(dilations);
}
function convertConv2DDataFormat(dataFormat) {
  if (dataFormat === "NHWC") {
    return "channelsLast";
  } else if (dataFormat === "NCHW") {
    return "channelsFirst";
  } else {
    throw new Error(`Unknown dataFormat ${dataFormat}`);
  }
}
function checkPadOnDimRoundingMode(opDesc, pad2, dimRoundingMode) {
  if (dimRoundingMode != null) {
    if (typeof pad2 === "string") {
      throw Error(`Error in ${opDesc}: pad must be an integer when using dimRoundingMode ${dimRoundingMode} but got pad ${pad2}.`);
    } else if (typeof pad2 === "number") {
      assert$1(isInt(pad2), () => `Error in ${opDesc}: pad must be an integer when using dimRoundingMode ${dimRoundingMode} but got pad ${pad2}.`);
    } else if (typeof pad2 === "object") {
      pad2.forEach((p2) => {
        p2.forEach((v2) => {
          assert$1(isInt(v2), () => `Error in ${opDesc}: pad must be an integer when using dimRoundingMode ${dimRoundingMode} but got pad ${v2}.`);
        });
      });
    } else {
      throw Error(`Error in ${opDesc}: Unknown padding parameter: ${pad2}`);
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reshape_(x2, shape) {
  const $x = convertToTensor(x2, "x", "reshape", "string_or_numeric");
  const inputs = { x: $x };
  const attrs = { shape };
  return ENGINE.runKernel(Reshape$1, inputs, attrs);
}
const reshape$3 = op({ reshape_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool_(x2, filterSize, strides, pad2, dimRoundingMode) {
  const $x = convertToTensor(x2, "x", "avgPool", "float32");
  const dilations = 1;
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in avgPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in avgPool: x must be rank 4 but got rank ${x4D.rank}.`);
  checkPadOnDimRoundingMode("avgPool", pad2, dimRoundingMode);
  const inputs = { x: x4D };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode };
  let res = ENGINE.runKernel(AvgPool, inputs, attrs);
  res = cast$4(res, $x.dtype);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const avgPool$3 = op({ avgPool_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool3d_(x2, filterSize, strides, pad2, dimRoundingMode, dataFormat = "NDHWC") {
  const $x = convertToTensor(x2, "x", "avgPool3d", "float32");
  let x5D = $x;
  let reshapedTo5D = false;
  if ($x.rank === 4) {
    reshapedTo5D = true;
    x5D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]]);
  }
  assert$1(x5D.rank === 5, () => `Error in avgPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
  assert$1(dataFormat === "NDHWC", () => `Error in avgPool3d: Only NDHWC is currently supported, but got dataFormat of ${dataFormat}`);
  checkPadOnDimRoundingMode("avgPool3d", pad2, dimRoundingMode);
  const inputs = { x: x5D };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode, dataFormat };
  let res = ENGINE.runKernel(AvgPool3D, inputs, attrs);
  res = cast$4(res, x5D.dtype);
  if (reshapedTo5D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3], res.shape[4]]);
  }
  return res;
}
const avgPool3d = op({ avgPool3d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function concat_(tensors, axis = 0) {
  assert$1(tensors.length >= 1, () => "Pass at least one tensor to concat");
  const $tensors = convertToTensorArray(tensors, "tensors", "concat", "string_or_numeric");
  if ($tensors[0].dtype === "complex64") {
    $tensors.forEach((tensor2) => {
      if (tensor2.dtype !== "complex64") {
        throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${tensor2.dtype}. `);
      }
    });
  }
  if ($tensors.length === 1) {
    return clone($tensors[0]);
  }
  const inputs = $tensors;
  const attr = { axis };
  return ENGINE.runKernel(Concat, inputs, attr);
}
const concat$3 = op({ concat_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sigmoid_(x2) {
  const $x = convertToTensor(x2, "x", "sigmoid", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Sigmoid$1, inputs);
}
const sigmoid$3 = op({ sigmoid_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function slice_(x2, begin, size) {
  const $x = convertToTensor(x2, "x", "slice", "string_or_numeric");
  if ($x.rank === 0) {
    throw new Error("Slicing scalar is not possible");
  }
  const inputs = { x: $x };
  const attrs = { begin, size };
  return ENGINE.runKernel(Slice, inputs, attrs);
}
const slice$3 = op({ slice_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tanh_(x2) {
  const $x = convertToTensor(x2, "x", "tanh", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Tanh$1, inputs);
}
const tanh$2 = op({ tanh_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchToSpaceND_(x2, blockShape, crops) {
  const $x = convertToTensor(x2, "x", "batchToSpaceND");
  const prod2 = blockShape.reduce((a6, b2) => a6 * b2);
  assert$1($x.rank >= 1 + blockShape.length, () => `input rank is ${$x.rank} but should be > than blockShape.length ${blockShape.length}`);
  assert$1(crops.length === blockShape.length, () => `crops.length is ${crops.length} but should be equal to blockShape.length  ${blockShape.length}`);
  assert$1($x.shape[0] % prod2 === 0, () => `input tensor batch is ${$x.shape[0]} but is not divisible by the product of the elements of blockShape ${blockShape.join(" * ")} === ${prod2}`);
  const inputs = { x: $x };
  const attrs = { blockShape, crops };
  return ENGINE.runKernel(BatchToSpaceND, inputs, attrs);
}
const batchToSpaceND$3 = op({ batchToSpaceND_ });
function xAs4D(x2) {
  let x4D;
  if (x2.rank === 0 || x2.rank === 1) {
    x4D = reshape$3(x2, [1, 1, 1, x2.size]);
  } else if (x2.rank === 2) {
    x4D = reshape$3(x2, [1, 1, x2.shape[0], x2.shape[1]]);
  } else if (x2.rank === 3) {
    x4D = reshape$3(x2, [1, x2.shape[0], x2.shape[1], x2.shape[2]]);
  } else {
    x4D = x2;
  }
  return x4D;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchNorm_(x2, mean2, variance, offset, scale2, varianceEpsilon) {
  if (varianceEpsilon == null) {
    varianceEpsilon = 1e-3;
  }
  const $x = convertToTensor(x2, "x", "batchNorm");
  const $mean = convertToTensor(mean2, "mean", "batchNorm");
  const $variance = convertToTensor(variance, "variance", "batchNorm");
  let $scale;
  if (scale2 != null) {
    $scale = convertToTensor(scale2, "scale", "batchNorm");
  }
  let $offset;
  if (offset != null) {
    $offset = convertToTensor(offset, "offset", "batchNorm");
  }
  assert$1($mean.rank === $variance.rank, () => "Batch normalization gradient requires mean and variance to have equal ranks.");
  assert$1($offset == null || $mean.rank === $offset.rank, () => "Batch normalization gradient requires mean and offset to have equal ranks.");
  assert$1($scale == null || $mean.rank === $scale.rank, () => "Batch normalization gradient requires mean and scale to have equal ranks.");
  const x4D = xAs4D($x);
  const inputs = {
    x: x4D,
    scale: $scale,
    offset: $offset,
    mean: $mean,
    variance: $variance
  };
  const attrs = { varianceEpsilon };
  const res = ENGINE.runKernel(FusedBatchNorm, inputs, attrs);
  return reshape$3(res, $x.shape);
}
const batchNorm$2 = op({ batchNorm_ });
function batchNorm2d_(x2, mean2, variance, offset, scale2, varianceEpsilon) {
  const $x = convertToTensor(x2, "x", "batchNorm");
  const $mean = convertToTensor(mean2, "mean", "batchNorm");
  const $variance = convertToTensor(variance, "variance", "batchNorm");
  let $scale;
  if (scale2 != null) {
    $scale = convertToTensor(scale2, "scale", "batchNorm");
  }
  let $offset;
  if (offset != null) {
    $offset = convertToTensor(offset, "offset", "batchNorm");
  }
  assert$1($x.rank === 2, () => `Error in batchNorm2D: x must be rank 2 but got rank ${$x.rank}.`);
  assert$1($mean.rank === 2 || $mean.rank === 1, () => `Error in batchNorm2D: mean must be rank 2 or rank 1 but got rank ${$mean.rank}.`);
  assert$1($variance.rank === 2 || $variance.rank === 1, () => `Error in batchNorm2D: variance must be rank 2 or rank 1 but got rank ${$variance.rank}.`);
  if ($scale != null) {
    assert$1($scale.rank === 2 || $scale.rank === 1, () => `Error in batchNorm2D: scale must be rank 2 or rank 1 but got rank ${$scale.rank}.`);
  }
  if ($offset != null) {
    assert$1($offset.rank === 2 || $offset.rank === 1, () => `Error in batchNorm2D: offset must be rank 2 or rank 1 but got rank ${$offset.rank}.`);
  }
  return batchNorm$2($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const batchNorm2d = op({ batchNorm2d_ });
function batchNorm3d_(x2, mean2, variance, offset, scale2, varianceEpsilon) {
  const $x = convertToTensor(x2, "x", "batchNorm");
  const $mean = convertToTensor(mean2, "mean", "batchNorm");
  const $variance = convertToTensor(variance, "variance", "batchNorm");
  let $scale;
  if (scale2 != null) {
    $scale = convertToTensor(scale2, "scale", "batchNorm");
  }
  let $offset;
  if (offset != null) {
    $offset = convertToTensor(offset, "offset", "batchNorm");
  }
  assert$1($x.rank === 3, () => `Error in batchNorm3D: x must be rank 3 but got rank ${$x.rank}.`);
  assert$1($mean.rank === 3 || $mean.rank === 1, () => `Error in batchNorm3D: mean must be rank 3 or rank 1 but got rank ${$mean.rank}.`);
  assert$1($variance.rank === 3 || $variance.rank === 1, () => `Error in batchNorm3D: variance must be rank 3 or rank 1 but got rank ${$variance.rank}.`);
  if ($scale != null) {
    assert$1($scale.rank === 3 || $scale.rank === 1, () => `Error in batchNorm3D: scale must be rank 3 or rank 1 but got rank ${$scale.rank}.`);
  }
  if ($offset != null) {
    assert$1($offset.rank === 3 || $offset.rank === 1, () => `Error in batchNorm3D: offset must be rank 3 or rank 1 but got rank ${$offset.rank}.`);
  }
  return batchNorm$2($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const batchNorm3d = op({ batchNorm3d_ });
function batchNorm4d_(x2, mean2, variance, offset, scale2, varianceEpsilon) {
  const $x = convertToTensor(x2, "x", "batchNorm");
  const $mean = convertToTensor(mean2, "mean", "batchNorm");
  const $variance = convertToTensor(variance, "variance", "batchNorm");
  let $scale;
  if (scale2 != null) {
    $scale = convertToTensor(scale2, "scale", "batchNorm");
  }
  let $offset;
  if (offset != null) {
    $offset = convertToTensor(offset, "offset", "batchNorm");
  }
  assert$1($x.rank === 4, () => `Error in batchNorm4D: x must be rank 4 but got rank ${$x.rank}.`);
  assert$1($mean.rank === 4 || $mean.rank === 1, () => `Error in batchNorm4D: mean must be rank 4 or rank 1 but got rank ${$mean.rank}.`);
  assert$1($variance.rank === 4 || $variance.rank === 1, () => `Error in batchNorm4D: variance must be rank 4 or rank 1 but got rank ${$variance.rank}.`);
  if ($scale != null) {
    assert$1($scale.rank === 4 || $scale.rank === 1, () => `Error in batchNorm4D: scale must be rank 4 or rank 1 but got rank ${$scale.rank}.`);
  }
  if ($offset != null) {
    assert$1($offset.rank === 4 || $offset.rank === 1, () => `Error in batchNorm4D: offset must be rank 4 or rank 1 but got rank ${$offset.rank}.`);
  }
  return batchNorm$2($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const batchNorm4d = op({ batchNorm4d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function bincount_(x2, weights, size) {
  const $x = convertToTensor(x2, "x", "bincount");
  const $weights = convertToTensor(weights, "weights", "bincount");
  assert$1($x.dtype === "int32", () => `Error in bincount: input dtype must be int32, but got ${$x.dtype}`);
  assert$1(size >= 0, () => `size must be non-negative, but got ${size}.`);
  assert$1($weights.size === $x.size || $weights.size === 0, () => `Error in bincount: weights must have the same size as input or0-length, but got input shape: ${$x.shape}, weights shape: ${$weights.shape}.`);
  const inputs = { x: $x, weights: $weights };
  const attrs = { size };
  return ENGINE.runKernel(Bincount, inputs, attrs);
}
const bincount$2 = op({ bincount_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function broadcastArgs_(s0, s1) {
  const shape1Input = convertToTensor(s0, "s0", "broadcastArgs", "int32");
  const shape2Input = convertToTensor(s1, "s1", "broadcastArgs", "int32");
  if (shape1Input.rank !== 1) {
    throw new Error(`broadcastArgs(): first input must be a vector (rank=1). Has rank ${shape1Input.rank}`);
  }
  if (shape2Input.rank !== 1) {
    throw new Error(`broadcastArgs(): second input must be a vector (rank=1). Has rank ${shape2Input.rank}`);
  }
  const inputs = { s0: shape1Input, s1: shape2Input };
  return ENGINE.runKernel(BroadcastArgs, inputs);
}
const broadcastArgs$2 = op({ broadcastArgs_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function broadcastTo_(x2, shape) {
  let input = convertToTensor(x2, "broadcastTo", "x");
  const xShape = input.shape;
  if (shape.some((d2) => !(d2 > 0) || d2 % 1 !== 0)) {
    throw new Error(`broadcastTo(): Invalid broadcast shape [${shape}].`);
  }
  if (shape.length < input.rank) {
    throw new Error(`broadcastTo(): shape.length=${shape.length} < input.rank=${input.rank}.`);
  }
  if (shape.length > input.rank) {
    const newShape = input.shape.slice();
    while (newShape.length < shape.length) {
      newShape.unshift(1);
    }
    input = reshape$3(input, newShape);
  }
  const inputShape = input.shape;
  const reps = Array.from(shape);
  for (let i2 = shape.length - 1; i2 >= 0; i2--) {
    if (inputShape[i2] === shape[i2]) {
      reps[i2] = 1;
    } else if (input.shape[i2] !== 1) {
      throw new Error(`broadcastTo(): [${xShape}] cannot be broadcast to [${shape}].`);
    }
  }
  const axes = reps.map((n2, i2) => n2 > 1 ? i2 : -1).filter((i2) => i2 >= 0);
  if (axes.length === 0) {
    return clone(input);
  }
  const inputs = { x: input };
  const attrs = { reps };
  return ENGINE.runKernel(Tile, inputs, attrs);
}
const broadcastTo = op({ broadcastTo_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function ceil_(x2) {
  const $x = convertToTensor(x2, "x", "ceil", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Ceil, inputs);
}
const ceil$2 = op({ ceil_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function clipByValue_(x2, clipValueMin, clipValueMax) {
  const $x = convertToTensor(x2, "x", "clipByValue");
  assert$1(clipValueMin <= clipValueMax, () => `Error in clip: min (${clipValueMin}) must be less than or equal to max (${clipValueMax}).`);
  const inputs = { x: $x };
  const attrs = { clipValueMin, clipValueMax };
  return ENGINE.runKernel(ClipByValue, inputs, attrs);
}
const clipByValue$2 = op({ clipByValue_ });
function concat1d_(tensors) {
  return concat$3(tensors, 0);
}
const concat1d = op({ concat1d_ });
function concat2d_(tensors, axis) {
  return concat$3(tensors, axis);
}
const concat2d = op({ concat2d_ });
function concat3d_(tensors, axis) {
  return concat$3(tensors, axis);
}
const concat3d = op({ concat3d_ });
function concat4d_(tensors, axis) {
  return concat$3(tensors, axis);
}
const concat4d = op({ concat4d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2d_(x2, filter2, strides, pad2, dataFormat = "NHWC", dilations = [1, 1], dimRoundingMode) {
  const $x = convertToTensor(x2, "x", "conv2d", "float32");
  const $filter = convertToTensor(filter2, "filter", "conv2d", "float32");
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
  assert$1($filter.rank === 4, () => `Error in conv2d: filter must be rank 4, but got rank ${$filter.rank}.`);
  checkPadOnDimRoundingMode("conv2d", pad2, dimRoundingMode);
  const inDepth = dataFormat === "NHWC" ? x4D.shape[3] : x4D.shape[1];
  assert$1(inDepth === $filter.shape[2], () => `Error in conv2d: depth of input (${inDepth}) must match input depth for filter ${$filter.shape[2]}.`);
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in conv2D: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  const inputs = { x: x4D, filter: $filter };
  const attrs = { strides, pad: pad2, dataFormat, dilations, dimRoundingMode };
  const res = ENGINE.runKernel(Conv2D$1, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const conv2d$3 = op({ conv2d_ });
function conv1d_(x2, filter2, stride, pad2, dataFormat = "NWC", dilation = 1, dimRoundingMode) {
  const $x = convertToTensor(x2, "x", "conv1d");
  const $filter = convertToTensor(filter2, "filter", "conv1d");
  let x3D = $x;
  let reshapedTo3D = false;
  if ($x.rank === 2) {
    reshapedTo3D = true;
    x3D = reshape$3($x, [1, $x.shape[0], $x.shape[1]]);
  }
  assert$1(x3D.rank === 3, () => `Error in conv1d: input must be rank 3, but got rank ${x3D.rank}.`);
  assert$1($filter.rank === 3, () => `Error in conv1d: filter must be rank 3, but got rank ${$filter.rank}.`);
  checkPadOnDimRoundingMode("conv1d", pad2, dimRoundingMode);
  assert$1(x3D.shape[2] === $filter.shape[1], () => `Error in conv1d: depth of input (${x3D.shape[2]}) must match input depth for filter ${$filter.shape[1]}.`);
  assert$1(eitherStridesOrDilationsAreOne(stride, dilation), () => `Error in conv1D: Either stride or dilation must be 1. Got stride ${stride} and dilation '${dilation}'`);
  assert$1(dataFormat === "NWC", () => `Error in conv1d: got dataFormat of ${dataFormat} but only NWC is currently supported.`);
  const filter4D = reshape$3($filter, [1, $filter.shape[0], $filter.shape[1], $filter.shape[2]]);
  const input4D = reshape$3(x3D, [x3D.shape[0], 1, x3D.shape[1], x3D.shape[2]]);
  const strides = [1, stride];
  const dilations = [1, dilation];
  const conv2dDataFormat = "NHWC";
  const res = conv2d$3(input4D, filter4D, strides, pad2, conv2dDataFormat, dilations, dimRoundingMode);
  if (reshapedTo3D) {
    return reshape$3(res, [res.shape[2], res.shape[3]]);
  }
  return reshape$3(res, [res.shape[0], res.shape[2], res.shape[3]]);
}
const conv1d = op({ conv1d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2DBackpropInput_(xShape, dy, filter2, strides, pad2, dataFormat = "NHWC", dimRoundingMode) {
  assert$1(xShape.length === dy.rank, () => `Length of inShape (${xShape.length}) and rank of dy (${dy.rank}) must match`);
  let xShape4D = xShape;
  let dy4D = dy;
  let reshapedTo4D = false;
  if (dy.rank === 3) {
    reshapedTo4D = true;
    dy4D = reshape$3(dy, [1, dy.shape[0], dy.shape[1], dy.shape[2]]);
    xShape4D = [1, xShape[0], xShape[1], xShape[2]];
  }
  assert$1(xShape4D.length === 4, () => `Error in conv2dDerInput: inShape must be length 4, but got length ${xShape4D.length}.`);
  assert$1(dy4D.rank === 4, () => `Error in conv2dDerInput: dy must be rank 4, but got rank ${dy4D.rank}`);
  assert$1(filter2.rank === 4, () => `Error in conv2dDerInput: filter must be rank 4, but got rank ${filter2.rank}`);
  const inDepth = dataFormat === "NHWC" ? xShape4D[3] : xShape4D[1];
  const outDepth = dataFormat === "NHWC" ? dy4D.shape[3] : dy4D.shape[1];
  assert$1(inDepth === filter2.shape[2], () => `Error in conv2dDerInput: depth of input (${inDepth}) must match input depth for filter ${filter2.shape[2]}.`);
  assert$1(outDepth === filter2.shape[3], () => `Error in conv2dDerInput: depth of output (${outDepth}) must match output depth for filter ${filter2.shape[3]}.`);
  checkPadOnDimRoundingMode("conv2dDerInput", pad2, dimRoundingMode);
  const inputs = { dy: dy4D, filter: filter2 };
  const attrs = { strides, pad: pad2, dataFormat, dimRoundingMode, inputShape: xShape4D };
  const res = ENGINE.runKernel(Conv2DBackpropInput, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const conv2DBackpropInput$3 = op({ conv2DBackpropInput_ });
function conv2dTranspose_(x2, filter2, outputShape, strides, pad2, dimRoundingMode) {
  const $x = convertToTensor(x2, "x", "conv2dTranspose");
  const $filter = convertToTensor(filter2, "filter", "conv2dTranspose");
  return conv2DBackpropInput$3(outputShape, $x, $filter, strides, pad2, "NHWC", dimRoundingMode);
}
const conv2dTranspose = op({ conv2dTranspose_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3d_(x2, filter2, strides, pad2, dataFormat = "NDHWC", dilations = [1, 1, 1]) {
  const $x = convertToTensor(x2, "x", "conv3d");
  const $filter = convertToTensor(filter2, "filter", "conv3d");
  let x5D = $x;
  let reshapedTo5D = false;
  if ($x.rank === 4) {
    reshapedTo5D = true;
    x5D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]]);
  }
  assert$1(x5D.rank === 5, () => `Error in conv3d: input must be rank 5, but got rank ${x5D.rank}.`);
  assert$1($filter.rank === 5, () => `Error in conv3d: filter must be rank 5, but got rank ${$filter.rank}.`);
  assert$1(x5D.shape[4] === $filter.shape[3], () => `Error in conv3d: depth of input (${x5D.shape[4]}) must match input depth for filter ${$filter.shape[3]}.`);
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in conv3D: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  assert$1(dataFormat === "NDHWC", () => `Error in conv3d: got dataFormat of ${dataFormat} but only NDHWC is currently supported.`);
  const inputs = { x: x5D, filter: $filter };
  const attrs = { strides, pad: pad2, dataFormat, dilations };
  const res = ENGINE.runKernel(Conv3D$1, inputs, attrs);
  if (reshapedTo5D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3], res.shape[4]]);
  }
  return res;
}
const conv3d = op({ conv3d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3DBackpropInput_(xShape, dy, filter2, strides, pad2) {
  assert$1(xShape.length === dy.rank, () => `Length of inShape (${xShape.length}) and rank of dy (${dy.rank}) must match`);
  let xShape5D = xShape;
  let dy5D = dy;
  let reshapedTo5D = false;
  if (dy.rank === 4) {
    reshapedTo5D = true;
    dy5D = reshape$3(dy, [1, dy.shape[0], dy.shape[1], dy.shape[2], dy.shape[3]]);
    xShape5D = [1, xShape[0], xShape[1], xShape[2], xShape[3]];
  }
  const inDepth = xShape5D[4];
  const outDepth = dy5D.shape[4];
  assert$1(xShape5D.length === 5, () => `Error in conv3dDerInput: inShape must be length 5, but got length ${xShape5D.length}.`);
  assert$1(dy5D.rank === 5, () => `Error in conv3dDerInput: dy must be rank 5, but got rank ${dy5D.rank}`);
  assert$1(filter2.rank === 5, () => `Error in conv3dDerInput: filter must be rank 5, but got rank ${filter2.rank}`);
  assert$1(inDepth === filter2.shape[3], () => `Error in conv3dDerInput: depth of input (${inDepth}) must match input depth for filter ${filter2.shape[3]}.`);
  assert$1(outDepth === filter2.shape[4], () => `Error in conv3dDerInput: depth of output (${outDepth}) must match output depth for filter ${filter2.shape[4]}.`);
  const inputs = { dy: dy5D, filter: filter2 };
  const attrs = { pad: pad2, strides, inputShape: xShape5D };
  const res = ENGINE.runKernel(Conv3DBackpropInputV2, inputs, attrs);
  if (reshapedTo5D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3], res.shape[4]]);
  }
  return res;
}
const conv3DBackpropInput$1 = op({ conv3DBackpropInput_ });
function conv3dTranspose_(x2, filter2, outputShape, strides, pad2) {
  const $x = convertToTensor(x2, "x", "conv3dTranspose");
  const $filter = convertToTensor(filter2, "filter", "conv3dTranspose");
  return conv3DBackpropInput$1(outputShape, $x, $filter, strides, pad2);
}
const conv3dTranspose = op({ conv3dTranspose_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cos_(x2) {
  const $x = convertToTensor(x2, "x", "cos", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Cos, inputs);
}
const cos$2 = op({ cos_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cosh_(x2) {
  const $x = convertToTensor(x2, "x", "cosh", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Cosh, inputs);
}
const cosh$2 = op({ cosh_ });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cumprod_(x2, axis = 0, exclusive = false, reverse2 = false) {
  const $x = convertToTensor(x2, "x", "cumprod");
  const inputs = { x: $x };
  const attrs = { axis, exclusive, reverse: reverse2 };
  return ENGINE.runKernel(Cumprod, inputs, attrs);
}
const cumprod$3 = op({ cumprod_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cumsum_(x2, axis = 0, exclusive = false, reverse2 = false) {
  const $x = convertToTensor(x2, "x", "cumsum");
  const inputs = { x: $x };
  const attrs = { axis, exclusive, reverse: reverse2 };
  return ENGINE.runKernel(Cumsum, inputs, attrs);
}
const cumsum$3 = op({ cumsum_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function denseBincount_(x2, weights, size, binaryOutput = false) {
  const $x = convertToTensor(x2, "x", "denseBincount");
  const $weights = convertToTensor(weights, "weights", "denseBincount");
  assert$1($x.dtype === "int32", () => `Error in denseBincount: input dtype must be int32, but got ${$x.dtype}`);
  assert$1($x.rank <= 2, () => `Error in denseBincount: input must be at most rank 2, but got rank ${$x.rank}.`);
  assert$1(size >= 0, () => `size must be non-negative, but got ${size}.`);
  assert$1($weights.size === $x.size || $weights.size === 0, () => `Error in denseBincount: weights must have the same shape as x or 0-length, but got x shape: ${$x.shape}, weights shape: ${$weights.shape}.`);
  const inputs = { x: $x, weights: $weights };
  const attrs = { size, binaryOutput };
  return ENGINE.runKernel(DenseBincount, inputs, attrs);
}
const denseBincount$2 = op({ denseBincount_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthToSpace_(x2, blockSize, dataFormat = "NHWC") {
  const $x = convertToTensor(x2, "x", "depthToSpace", "float32");
  const inputHeight = dataFormat === "NHWC" ? $x.shape[1] : $x.shape[2];
  const inputWidth = dataFormat === "NHWC" ? $x.shape[2] : $x.shape[3];
  const inputDepth = dataFormat === "NHWC" ? $x.shape[3] : $x.shape[1];
  assert$1(blockSize > 1, () => `blockSize should be > 1 for depthToSpace, but was: ${blockSize}`);
  assert$1(inputHeight * blockSize >= 0, () => `Negative dimension size caused by overflow when multiplying
    ${inputHeight} and ${blockSize}  for depthToSpace with input shape
    ${$x.shape}`);
  assert$1(inputWidth * blockSize >= 0, () => `Negative dimension size caused by overflow when multiplying
    ${inputWidth} and ${blockSize} for depthToSpace with input shape
        ${$x.shape}`);
  assert$1(inputDepth % (blockSize * blockSize) === 0, () => `Dimension size must be evenly divisible by ${blockSize * blockSize} but is ${inputDepth} for depthToSpace with input shape ${$x.shape}`);
  const inputs = { x: $x };
  const attrs = { blockSize, dataFormat };
  return ENGINE.runKernel(DepthToSpace, inputs, attrs);
}
const depthToSpace$3 = op({ depthToSpace_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2d_(x2, filter2, strides, pad2, dataFormat = "NHWC", dilations = [1, 1], dimRoundingMode) {
  const $x = convertToTensor(x2, "x", "depthwiseConv2d", "float32");
  const $filter = convertToTensor(filter2, "filter", "depthwiseConv2d", "float32");
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in depthwiseConv2d: input must be rank 4, but got rank ${x4D.rank}.`);
  assert$1($filter.rank === 4, () => `Error in depthwiseConv2d: filter must be rank 4, but got rank ${$filter.rank}.`);
  assert$1(x4D.shape[3] === $filter.shape[2], () => `Error in depthwiseConv2d: number of input channels (${x4D.shape[3]}) must match the inChannels dimension in filter ${$filter.shape[2]}.`);
  checkPadOnDimRoundingMode("depthwiseConv2d", pad2, dimRoundingMode);
  const inputs = { x: x4D, filter: $filter };
  const attrs = { strides, pad: pad2, dataFormat, dilations, dimRoundingMode };
  const res = ENGINE.runKernel(DepthwiseConv2dNative, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const depthwiseConv2d$3 = op({ depthwiseConv2d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function dilation2d_(x2, filter2, strides, pad2, dilations = [1, 1], dataFormat = "NHWC") {
  const $x = convertToTensor(x2, "x", "dilation2d");
  const $filter = convertToTensor(filter2, "filter", "dilation2d");
  assert$1($x.rank === 3 || $x.rank === 4, () => `Error in dilation2d: input must be rank 3 or 4, but got rank ${$x.rank}.`);
  assert$1($filter.rank === 3, () => `Error in dilation2d: filter must be rank 3, but got rank ${$filter.rank}.`);
  assert$1(dataFormat === "NHWC", () => `Error in dilation2d: Only NHWC is currently supported, but got dataFormat of ${dataFormat}`);
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
    reshapedTo4D = true;
  }
  const inputs = { x: x4D, filter: $filter };
  const attrs = { strides, pad: pad2, dilations };
  const res = ENGINE.runKernel(Dilation2D, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const dilation2d = op({ dilation2d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function equal_(a6, b2) {
  let $a = convertToTensor(a6, "a", "equal", "string_or_numeric");
  let $b = convertToTensor(b2, "b", "equal", "string_or_numeric");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Equal, inputs);
}
const equal$2 = op({ equal_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function where_(condition, a6, b2) {
  const $a = convertToTensor(a6, "a", "where");
  const $b = convertToTensor(b2, "b", "where");
  const $condition = convertToTensor(condition, "condition", "where", "bool");
  const broadcastShape = assertAndGetBroadcastShape(assertAndGetBroadcastShape($condition.shape, $a.shape), $b.shape);
  const $broadcastedCondition = broadcastTo($condition, broadcastShape);
  const $broadcastedA = broadcastTo($a, broadcastShape);
  const $broadcastedB = broadcastTo($b, broadcastShape);
  const inputs = {
    condition: $broadcastedCondition,
    t: $broadcastedA,
    e: $broadcastedB
  };
  return ENGINE.runKernel(Select$1, inputs);
}
const where = op({ where_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function zerosLike_(x2) {
  const $x = convertToTensor(x2, "x", "zerosLike");
  const inputs = { x: $x };
  return ENGINE.runKernel(ZerosLike, inputs);
}
const zerosLike$3 = op({ zerosLike_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function divNoNan_(a6, b2) {
  let $a = convertToTensor(a6, "a", "div");
  let $b = convertToTensor(b2, "b", "div");
  [$a, $b] = makeTypesMatch($a, $b);
  const divResult = div$1($a, $b);
  const zeros2 = zerosLike$3(divResult);
  const bEqualsZero = equal$2($b, zeros2);
  return where(bEqualsZero, zeros2, divResult);
}
const divNoNan = op({ divNoNan_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function dot_(t1, t2) {
  const $t1 = convertToTensor(t1, "t1", "dot");
  const $t2 = convertToTensor(t2, "t2", "dot");
  assert$1(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), () => `Error in dot: inputs must all be rank 1 or 2, but got ranks ${$t1.rank} and ${$t2.rank}.`);
  const t1Inner = $t1.rank === 1 ? $t1.size : $t1.shape[1];
  const t2Inner = $t2.rank === 1 ? $t2.size : $t2.shape[0];
  assert$1(t1Inner === t2Inner, () => `Error in dot: inner dimensions of inputs must match, but got ${t1Inner} and ${t2Inner}.`);
  if ($t1.rank === 1 && $t2.rank === 1) {
    const t12D = reshape$3($t1, [1, -1]);
    const t22D = reshape$3($t2, [-1, 1]);
    const t1t2 = matMul$1(t12D, t22D);
    return reshape$3(t1t2, []);
  } else if ($t1.rank === 1 && $t2.rank === 2) {
    const t12D = reshape$3($t1, [1, -1]);
    const t22D = reshape$3($t2, [$t2.shape[0], $t2.shape[1]]);
    const t1t2 = matMul$1(t12D, t22D);
    return reshape$3(t1t2, [t1t2.size]);
  } else if ($t1.rank === 2 && $t2.rank === 1) {
    const t22D = reshape$3($t2, [-1, 1]);
    const t1t2 = matMul$1($t1, t22D);
    return reshape$3(t1t2, [t1t2.size]);
  } else {
    const t22D = reshape$3($t2, [$t2.shape[0], $t2.shape[1]]);
    const t1t2 = matMul$1($t1, t22D);
    return t1t2;
  }
}
const dot$1 = op({ dot_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function einsum_(equation, ...tensors) {
  const $tensors = tensors.map((t2, i2) => convertToTensor(t2, `tensors${i2}`, "einsum"));
  const attrs = { equation };
  return ENGINE.runKernel(Einsum, $tensors, attrs);
}
const einsum$2 = op({ einsum_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function elu_(x2) {
  const $x = convertToTensor(x2, "x", "elu", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Elu$1, inputs);
}
const elu$3 = op({ elu_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function erf_(x2) {
  let $x = convertToTensor(x2, "x", "erf");
  assert$1($x.dtype === "int32" || $x.dtype === "float32", () => "Input dtype must be `int32` or `float32`.");
  if ($x.dtype === "int32") {
    $x = cast$4($x, "float32");
  }
  const inputs = { x: $x };
  return ENGINE.runKernel(Erf, inputs);
}
const erf$2 = op({ erf_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function exp_(x2) {
  const $x = convertToTensor(x2, "x", "exp");
  const inputs = { x: $x };
  return ENGINE.runKernel(Exp, inputs);
}
const exp$2 = op({ exp_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function expandDims_(x2, axis = 0) {
  const $x = convertToTensor(x2, "x", "expandDims", "string_or_numeric");
  assert$1(axis <= $x.rank, () => "Axis must be <= rank of the tensor");
  const inputs = { input: $x };
  const attrs = { dim: axis };
  return ENGINE.runKernel(ExpandDims, inputs, attrs);
}
const expandDims$4 = op({ expandDims_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function expm1_(x2) {
  const $x = convertToTensor(x2, "x", "expm1");
  const inputs = { x: $x };
  return ENGINE.runKernel(Expm1, inputs);
}
const expm1$2 = op({ expm1_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tile_(x2, reps) {
  const $x = convertToTensor(x2, "x", "tile", "string_or_numeric");
  assert$1($x.rank === reps.length, () => `Error in transpose: rank of input ${$x.rank} must match length of reps ${reps}.`);
  const inputs = { x: $x };
  const attrs = { reps };
  return ENGINE.runKernel(Tile, inputs, attrs);
}
const tile$4 = op({ tile_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function eye_(numRows, numColumns, batchShape, dtype = "float32") {
  if (numColumns == null) {
    numColumns = numRows;
  }
  const buff = buffer([numRows, numColumns], dtype);
  const n2 = numRows <= numColumns ? numRows : numColumns;
  for (let i2 = 0; i2 < n2; ++i2) {
    buff.set(1, i2, i2);
  }
  const out = reshape$3(buff.toTensor(), [numRows, numColumns]);
  if (batchShape == null) {
    return out;
  } else {
    if (batchShape.length === 1) {
      return tile$4(expandDims$4(out, 0), [batchShape[0], 1, 1]);
    } else if (batchShape.length === 2) {
      return tile$4(expandDims$4(expandDims$4(out, 0), 0), [batchShape[0], batchShape[1], 1, 1]);
    } else if (batchShape.length === 3) {
      return tile$4(expandDims$4(expandDims$4(expandDims$4(out, 0), 0), 0), [
        batchShape[0],
        batchShape[1],
        batchShape[2],
        1,
        1
      ]);
    } else {
      throw new Error(`eye() currently supports only 1D and 2D batchShapes, but received ${batchShape.length}D.`);
    }
  }
}
const eye = op({ eye_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fill$3(shape, value, dtype) {
  const attrs = { shape, value, dtype };
  return ENGINE.runKernel(Fill, {}, attrs);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function floor_(x2) {
  const $x = convertToTensor(x2, "x", "floor", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Floor, inputs);
}
const floor$2 = op({ floor_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gather_(x2, indices, axis = 0, batchDims = 0) {
  const $x = convertToTensor(x2, "x", "gather");
  const $indices = convertToTensor(indices, "indices", "gather", "int32");
  const inputs = { x: $x, indices: $indices };
  const attrs = { axis, batchDims };
  return ENGINE.runKernel(GatherV2, inputs, attrs);
}
const gather$1 = op({ gather_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function greater_(a6, b2) {
  let $a = convertToTensor(a6, "a", "greater", "string_or_numeric");
  let $b = convertToTensor(b2, "b", "greater", "string_or_numeric");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Greater, inputs);
}
const greater$2 = op({ greater_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function greaterEqual_(a6, b2) {
  let $a = convertToTensor(a6, "a", "greaterEqual", "string_or_numeric");
  let $b = convertToTensor(b2, "b", "greaterEqual", "string_or_numeric");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(GreaterEqual, inputs);
}
const greaterEqual$2 = op({ greaterEqual_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function imag_(input) {
  const $input = convertToTensor(input, "input", "imag");
  const inputs = { input: $input };
  return ENGINE.runKernel(Imag, inputs);
}
const imag$2 = op({ imag_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function isFinite_(x2) {
  const $x = convertToTensor(x2, "x", "isFinite");
  const inputs = { x: $x };
  return ENGINE.runKernel(IsFinite, inputs);
}
const isFinite$3 = op({ isFinite_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function isInf_(x2) {
  const $x = convertToTensor(x2, "x", "isInf");
  const inputs = { x: $x };
  return ENGINE.runKernel(IsInf, inputs);
}
const isInf$2 = op({ isInf_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function isNaN_(x2) {
  const $x = convertToTensor(x2, "x", "isNaN");
  const inputs = { x: $x };
  return ENGINE.runKernel(IsNan, inputs);
}
const isNaN$3 = op({ isNaN_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function leakyRelu_(x2, alpha2 = 0.2) {
  const $x = convertToTensor(x2, "x", "leakyRelu");
  const inputs = { x: $x };
  const attrs = { alpha: alpha2 };
  return ENGINE.runKernel(LeakyRelu, inputs, attrs);
}
const leakyRelu$3 = op({ leakyRelu_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function less_(a6, b2) {
  let $a = convertToTensor(a6, "a", "less", "string_or_numeric");
  let $b = convertToTensor(b2, "b", "less", "string_or_numeric");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Less, inputs);
}
const less$2 = op({ less_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function lessEqual_(a6, b2) {
  let $a = convertToTensor(a6, "a", "lessEqual", "string_or_numeric");
  let $b = convertToTensor(b2, "b", "lessEqual", "string_or_numeric");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(LessEqual, inputs);
}
const lessEqual$2 = op({ lessEqual_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function linspace(start, stop, num) {
  if (num <= 0) {
    throw new Error("The number of values should be positive.");
  }
  const attrs = { start, stop, num };
  return ENGINE.runKernel(LinSpace, {}, attrs);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function localResponseNormalization_(x2, depthRadius = 5, bias = 1, alpha2 = 1, beta = 0.5) {
  const $x = convertToTensor(x2, "x", "localResponseNormalization");
  assert$1($x.rank === 4 || $x.rank === 3, () => `Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${$x.rank}.`);
  assert$1(isInt(depthRadius), () => `Error in localResponseNormalization: depthRadius must be an integer but got depthRadius ${depthRadius}.`);
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  const inputs = { x: x4D };
  const attrs = { depthRadius, bias, alpha: alpha2, beta };
  const res = ENGINE.runKernel(LRN, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  } else {
    return res;
  }
}
const localResponseNormalization = op({ localResponseNormalization_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function log_(x2) {
  const $x = convertToTensor(x2, "x", "log", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Log, inputs);
}
const log$7 = op({ log_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function log1p_(x2) {
  const $x = convertToTensor(x2, "x", "log1p");
  const inputs = { x: $x };
  return ENGINE.runKernel(Log1p, inputs);
}
const log1p$2 = op({ log1p_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function variableGrads(f2, varList) {
  assert$1(isFunction$2(f2), () => "The f passed in variableGrads(f) must be a function");
  assert$1(varList == null || Array.isArray(varList) && varList.every((v2) => v2 instanceof Variable), () => "The varList passed in variableGrads(f, varList) must be an array of variables");
  const specifiedVarList = varList != null;
  if (!specifiedVarList) {
    varList = [];
    for (const varName in ENGINE.registeredVariables) {
      varList.push(ENGINE.registeredVariables[varName]);
    }
  }
  const specifiedNonTrainable = specifiedVarList ? varList.filter((variable2) => !variable2.trainable) : null;
  const originalVarCount = varList.length;
  varList = varList.filter((variable2) => variable2.trainable);
  assert$1(varList.length > 0, () => `variableGrads() expects at least one of the input variables to be trainable, but none of the ${originalVarCount} variables is trainable.`);
  const allowNoGradients = true;
  const { value, grads } = ENGINE.gradients(f2, varList, null, allowNoGradients);
  assert$1(grads.some((g2) => g2 != null), () => "Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().");
  assert$1(value.rank === 0, () => `The f passed in variableGrads(f) must return a scalar, but it returned a rank-${value.rank} tensor`);
  const namedGrads = {};
  varList.forEach((v2, i2) => {
    if (grads[i2] != null) {
      namedGrads[v2.name] = grads[i2];
    }
  });
  if (specifiedNonTrainable != null) {
    specifiedNonTrainable.forEach((v2) => namedGrads[v2.name] = null);
  }
  return { value, grads: namedGrads };
}
function customGrad(f2) {
  return ENGINE.customGrad(f2);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function neg_(x2) {
  const $x = convertToTensor(x2, "x", "neg");
  const inputs = { x: $x };
  return ENGINE.runKernel(Neg, inputs);
}
const neg$2 = op({ neg_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function softplus_(x2) {
  const $x = convertToTensor(x2, "x", "softplus");
  const inputs = { x: $x };
  return ENGINE.runKernel(Softplus$1, inputs);
}
const softplus$2 = op({ softplus_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logSigmoid_(x2) {
  const $x = convertToTensor(x2, "x", "logSigmoid");
  const customOp = customGrad((x3) => {
    const value = neg$2(softplus$2(neg$2(x3)));
    const gradFunc = (dy) => {
      const derX = mul(dy, sigmoid$3(neg$2(x3)));
      return derX;
    };
    return { value, gradFunc };
  });
  return customOp($x);
}
const logSigmoid = op({ logSigmoid_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function max_(x2, axis = null, keepDims = false) {
  const $x = convertToTensor(x2, "x", "max");
  const inputs = { x: $x };
  const attrs = { reductionIndices: axis, keepDims };
  return ENGINE.runKernel(Max, inputs, attrs);
}
const max$4 = op({ max_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sub_(a6, b2) {
  let $a = convertToTensor(a6, "a", "sub");
  let $b = convertToTensor(b2, "b", "sub");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Sub, inputs);
}
const sub$2 = op({ sub_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sum_(x2, axis = null, keepDims = false) {
  let $x = convertToTensor(x2, "x", "sum");
  if ($x.dtype === "bool") {
    $x = cast$4($x, "int32");
  }
  const inputs = { x: $x };
  const attrs = { axis, keepDims };
  return ENGINE.runKernel(Sum, inputs, attrs);
}
const sum$3 = op({ sum_ });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logSoftmax_(logits, axis = -1) {
  const $logits = convertToTensor(logits, "logits", "logSoftmax");
  if (axis === -1) {
    axis = $logits.rank - 1;
  }
  if (axis !== $logits.rank - 1) {
    throw Error(`Log Softmax along a non-last dimension is not yet supported. Logits was rank ${$logits.rank} and axis was ${axis}`);
  }
  const customOp = customGrad((logits2, save) => {
    const keepDims = true;
    const xMax = max$4(logits2, axis, true);
    const shifted = sub$2(logits2, xMax);
    const value = sub$2(cast$4(shifted, "float32"), log$7(sum$3(exp$2(shifted), axis, keepDims)));
    save([value]);
    const gradFunc = (dy, saved) => {
      const [value2] = saved;
      const keepDims2 = true;
      const softmax2 = exp$2(value2);
      return sub$2(dy, mul(sum$3(dy, axis, keepDims2), softmax2));
    };
    return { value, gradFunc };
  });
  return customOp($logits);
}
const logSoftmax = op({ logSoftmax_ });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function axesAreInnerMostDims(axes, rank) {
  for (let i2 = 0; i2 < axes.length; ++i2) {
    if (axes[axes.length - i2 - 1] !== rank - 1 - i2) {
      return false;
    }
  }
  return true;
}
function combineLocations(outputLoc, reduceLoc, axes) {
  const rank = outputLoc.length + reduceLoc.length;
  const loc = [];
  let outIdx = 0;
  let reduceIdx = 0;
  for (let dim = 0; dim < rank; dim++) {
    if (axes.indexOf(dim) === -1) {
      loc.push(outputLoc[outIdx++]);
    } else {
      loc.push(reduceLoc[reduceIdx++]);
    }
  }
  return loc;
}
function computeOutAndReduceShapes(aShape, axes) {
  const outShape = [];
  const rank = aShape.length;
  for (let dim = 0; dim < rank; dim++) {
    if (axes.indexOf(dim) === -1) {
      outShape.push(aShape[dim]);
    }
  }
  const reduceShape = axes.map((dim) => aShape[dim]);
  return [outShape, reduceShape];
}
function expandShapeToKeepDim(shape, axes) {
  const reduceSubShape = axes.map((x2) => 1);
  return combineLocations(shape, reduceSubShape, axes);
}
function assertAxesAreInnerMostDims(msg, axes, rank) {
  assert$1(axesAreInnerMostDims(axes, rank), () => `${msg} supports only inner-most axes for now. Got axes ${axes} and rank-${rank} input.`);
}
function getAxesPermutation(axes, rank) {
  if (axesAreInnerMostDims(axes, rank)) {
    return null;
  }
  const result2 = [];
  for (let i2 = 0; i2 < rank; ++i2) {
    if (axes.indexOf(i2) === -1) {
      result2.push(i2);
    }
  }
  axes.forEach((axis) => result2.push(axis));
  return result2;
}
function getUndoAxesPermutation(axes) {
  return axes.map((axis, i2) => [i2, axis]).sort((a6, b2) => a6[1] - b2[1]).map((x2) => x2[0]);
}
function getInnerMostAxes(numAxes, rank) {
  const res = [];
  for (let i2 = rank - numAxes; i2 < rank; ++i2) {
    res.push(i2);
  }
  return res;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logSumExp_(x2, axis = null, keepDims = false) {
  const $x = convertToTensor(x2, "x", "logSumExp");
  const axes = parseAxisParam(axis, $x.shape);
  const xMax = max$4($x, axes, true);
  const a6 = sub$2($x, xMax);
  const b2 = exp$2(a6);
  const c2 = sum$3(b2, axes);
  const d2 = log$7(c2);
  const res = add$1(reshape$3(xMax, d2.shape), d2);
  if (keepDims) {
    const newShape = expandShapeToKeepDim(res.shape, axes);
    return reshape$3(res, newShape);
  }
  return res;
}
const logSumExp = op({ logSumExp_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logicalAnd_(a6, b2) {
  const $a = convertToTensor(a6, "a", "logicalAnd", "bool");
  const $b = convertToTensor(b2, "b", "logicalAnd", "bool");
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(LogicalAnd, inputs);
}
const logicalAnd$2 = op({ logicalAnd_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logicalNot_(x2) {
  const $x = convertToTensor(x2, "x", "logicalNot", "bool");
  const inputs = { x: $x };
  return ENGINE.runKernel(LogicalNot, inputs);
}
const logicalNot$2 = op({ logicalNot_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logicalOr_(a6, b2) {
  const $a = convertToTensor(a6, "a", "logicalOr", "bool");
  const $b = convertToTensor(b2, "b", "logicalOr", "bool");
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(LogicalOr, inputs);
}
const logicalOr$2 = op({ logicalOr_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logicalXor_(a6, b2) {
  const $a = convertToTensor(a6, "a", "logicalXor", "bool");
  const $b = convertToTensor(b2, "b", "logicalXor", "bool");
  assertAndGetBroadcastShape($a.shape, $b.shape);
  return logicalAnd$2(logicalOr$2(a6, b2), logicalNot$2(logicalAnd$2(a6, b2)));
}
const logicalXor = op({ logicalXor_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool_(x2, filterSize, strides, pad2, dimRoundingMode) {
  const $x = convertToTensor(x2, "x", "maxPool");
  const dilations = 1;
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in maxPool: input must be rank 4 but got rank ${x4D.rank}.`);
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in maxPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  checkPadOnDimRoundingMode("maxPool", pad2, dimRoundingMode);
  const inputs = { x: x4D };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode };
  const res = ENGINE.runKernel(MaxPool, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const maxPool$3 = op({ maxPool_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool3d_(x2, filterSize = [1, 1, 1], strides, pad2, dimRoundingMode, dataFormat = "NDHWC") {
  const $x = convertToTensor(x2, "x", "maxPool3d");
  let x5D = $x;
  let reshapedTo5D = false;
  if ($x.rank === 4) {
    reshapedTo5D = true;
    x5D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]]);
  }
  assert$1(x5D.rank === 5, () => `Error in maxPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
  assert$1(dataFormat === "NDHWC", () => `Error in maxPool3d: Only NDHWC is currently supported, but got dataFormat of ${dataFormat}`);
  checkPadOnDimRoundingMode("maxPool3d", pad2, dimRoundingMode);
  const inputs = { x: x5D };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode, dataFormat };
  const res = ENGINE.runKernel(MaxPool3D, inputs, attrs);
  if (reshapedTo5D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3], res.shape[4]]);
  }
  return res;
}
const maxPool3d$1 = op({ maxPool3d_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPoolWithArgmax_(x2, filterSize, strides, pad2, includeBatchInIndex = false) {
  const $x = convertToTensor(x2, "x", "maxPoolWithArgmax");
  const inputs = { x: $x };
  const attrs = { filterSize, strides, pad: pad2, includeBatchInIndex };
  const result2 = ENGINE.runKernel(MaxPoolWithArgmax, inputs, attrs);
  return { result: result2[0], indexes: result2[1] };
}
const maxPoolWithArgmax = op({ maxPoolWithArgmax_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maximum_(a6, b2) {
  let $a = convertToTensor(a6, "a", "maximum");
  let $b = convertToTensor(b2, "b", "maximum");
  [$a, $b] = makeTypesMatch($a, $b);
  if ($a.dtype === "bool") {
    $a = cast$4($a, "int32");
    $b = cast$4($b, "int32");
  }
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Maximum$1, inputs);
}
const maximum$2 = op({ maximum_ });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mean_(x2, axis = null, keepDims = false) {
  const $x = convertToTensor(x2, "x", "mean");
  const inputs = { x: $x };
  const attrs = { axis, keepDims };
  return ENGINE.runKernel(Mean, inputs, attrs);
}
const mean$2 = op({ mean_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function zeros$1(shape, dtype = "float32") {
  if (dtype === "complex64") {
    const real2 = zeros$1(shape, "float32");
    const imag2 = zeros$1(shape, "float32");
    return complex$3(real2, imag2);
  }
  const values = makeZerosTypedArray(sizeFromShape(shape), dtype);
  return ENGINE.makeTensor(values, shape, dtype);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function ones(shape, dtype = "float32") {
  if (dtype === "complex64") {
    const real2 = ones(shape, "float32");
    const imag2 = zeros$1(shape, "float32");
    return complex$3(real2, imag2);
  }
  const values = makeOnesTypedArray(sizeFromShape(shape), dtype);
  return ENGINE.makeTensor(values, shape, dtype);
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function min_(x2, axis = null, keepDims = false) {
  const $x = convertToTensor(x2, "x", "min");
  const inputs = { x: $x };
  const attrs = { axis, keepDims };
  return ENGINE.runKernel(Min, inputs, attrs);
}
const min$4 = op({ min_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function minimum_(a6, b2) {
  let $a = convertToTensor(a6, "a", "minimum");
  let $b = convertToTensor(b2, "b", "minimum");
  [$a, $b] = makeTypesMatch($a, $b);
  if ($a.dtype === "bool") {
    $a = cast$4($a, "int32");
    $b = cast$4($b, "int32");
  }
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Minimum$1, inputs);
}
const minimum$2 = op({ minimum_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mirrorPad_(x2, paddings, mode2) {
  assert$1(mode2 === "reflect" || mode2 === "symmetric", () => `Invalid mode. Mode must be either reflect or symmetric. Got ${mode2}.`);
  const $x = convertToTensor(x2, "x", "mirrorPad");
  if ($x.rank === 0) {
    throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
  }
  assert$1(paddings.length === $x.rank, () => `Padding doesn't match input. Must be ${$x.rank}. Got ${paddings.length}.`);
  const shapeOffset = mode2 === "reflect" ? 1 : 0;
  for (let i2 = 0; i2 < $x.rank; i2++) {
    assert$1(paddings[i2].length === 2, () => `Invalid number of paddings. Must be length of 2 each.`);
    assert$1(paddings[i2][0] >= 0 && paddings[i2][0] <= $x.shape[i2] - shapeOffset && paddings[i2][1] >= 0 && paddings[i2][1] <= $x.shape[i2] - shapeOffset, () => `Padding in dimension ${i2} cannot be greater than or equal to ${$x.shape[i2] - shapeOffset} or less than 0 for input of shape ${$x.shape}`);
  }
  const attrs = { paddings, mode: mode2 };
  const inputs = { x: $x };
  return ENGINE.runKernel(MirrorPad, inputs, attrs);
}
const mirrorPad$2 = op({ mirrorPad_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mod_(a6, b2) {
  let $a = convertToTensor(a6, "a", "mod");
  let $b = convertToTensor(b2, "b", "mod");
  [$a, $b] = makeTypesMatch($a, $b);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(Mod, inputs);
}
const mod$2 = op({ mod_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function square_(x2) {
  const $x = convertToTensor(x2, "x", "square");
  const attrs = {};
  return ENGINE.runKernel("Square", { x: $x }, attrs);
}
const square$2 = op({ square_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function moments_(x2, axis = null, keepDims = false) {
  x2 = convertToTensor(x2, "x", "moments");
  const axes = parseAxisParam(axis, x2.shape);
  const xMean = mean$2(x2, axes, keepDims);
  let keepDimsShape = xMean.shape;
  if (!keepDims) {
    keepDimsShape = expandShapeToKeepDim(xMean.shape, axes);
  }
  const devSquared = square$2(sub$2(cast$4(x2, "float32"), reshape$3(xMean, keepDimsShape)));
  const variance = mean$2(devSquared, axes, keepDims);
  return { mean: xMean, variance };
}
const moments = op({ moments_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function multinomial_(logits, numSamples, seed, normalized = false) {
  const $logits = convertToTensor(logits, "logits", "multinomial");
  const numOutcomes = $logits.size;
  const origRank = $logits.rank;
  if (numOutcomes < 2) {
    throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ${numOutcomes}.`);
  }
  if (origRank > 2) {
    throw new Error(`Rank of probabilities must be 1 or 2, but is ${origRank}`);
  }
  seed = seed || Math.random();
  const logits2D = origRank === 1 ? reshape$3($logits, [1, -1]) : $logits;
  const inputs = { logits: logits2D };
  const attrs = { numSamples, seed, normalized };
  const res = ENGINE.runKernel(Multinomial, inputs, attrs);
  return origRank === 1 ? reshape$3(res, [res.size]) : res;
}
const multinomial$2 = op({ multinomial_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function notEqual_(a6, b2) {
  let $a = convertToTensor(a6, "a", "notEqual", "string_or_numeric");
  let $b = convertToTensor(b2, "b", "notEqual", "string_or_numeric");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  return ENGINE.runKernel(NotEqual, inputs);
}
const notEqual$2 = op({ notEqual_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function onesLike_(x2) {
  const $x = convertToTensor(x2, "x", "onesLike");
  const inputs = { x: $x };
  return ENGINE.runKernel(OnesLike, inputs);
}
const onesLike$3 = op({ onesLike_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pad_(x2, paddings, constantValue = 0) {
  const $x = convertToTensor(x2, "x", "pad");
  if ($x.rank === 0) {
    throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");
  }
  const attrs = { paddings, constantValue };
  const inputs = { x: $x };
  return ENGINE.runKernel(PadV2, inputs, attrs);
}
const pad$1 = op({ pad_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function spaceToBatchND_(x2, blockShape, paddings) {
  const $x = convertToTensor(x2, "x", "spaceToBatchND");
  assert$1($x.rank >= 1 + blockShape.length, () => `input rank ${$x.rank} should be > than [blockShape] ${blockShape.length}`);
  assert$1(paddings.length === blockShape.length, () => `paddings.shape[0] ${paddings.length} must be equal to [blockShape] ${blockShape.length}`);
  assert$1($x.shape.reduce((a6, b2, i2) => {
    if (i2 > 0 && i2 <= blockShape.length) {
      return a6 && (b2 + paddings[i2 - 1][0] + paddings[i2 - 1][1]) % blockShape[i2 - 1] === 0;
    }
    return a6;
  }, true), () => `input spatial dimensions ${$x.shape.slice(1)} with paddings ${paddings.toString()} must be divisible by blockShapes ${blockShape.toString()}`);
  const inputs = { x: $x };
  const attrs = { blockShape, paddings };
  return ENGINE.runKernel(SpaceToBatchND, inputs, attrs);
}
const spaceToBatchND$3 = op({ spaceToBatchND_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pool_(input, windowShape, poolingType, pad2, dilations, strides, dimRoundingMode) {
  if (dilations == null) {
    dilations = [1, 1];
  }
  if (strides == null) {
    strides = 1;
  }
  if (pad2 === 0) {
    pad2 = "valid";
  }
  const $x = convertToTensor(input, "x", "maxPool");
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in pool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  const convInfo = computePool2DInfo(x4D.shape, windowShape, strides, dilations, pad2);
  const dilation = [convInfo.dilationHeight, convInfo.dilationWidth];
  let basePadding;
  if (pad2 === "same") {
    basePadding = withSpaceToBatchBasePaddings([convInfo.filterHeight, convInfo.filterWidth], dilation);
  } else {
    basePadding = [[0, 0], [0, 0]];
  }
  const isDilationOne = dilation[0] === 1 && dilation[1] === 1;
  const [adjustedPadding, adjustedCrops] = requiredSpaceToBatchPaddings([convInfo.inHeight, convInfo.inWidth], dilation, basePadding);
  const convertedPad = isDilationOne ? pad2 : "valid";
  const convertedX = isDilationOne ? x4D : spaceToBatchND$3(x4D, dilation, adjustedPadding);
  const forwardOp = poolingType === "avg" ? () => avgPool$3(convertedX, windowShape, strides, convertedPad, dimRoundingMode) : () => maxPool$3(convertedX, windowShape, strides, convertedPad, dimRoundingMode);
  const y2 = forwardOp();
  const res = isDilationOne ? y2 : batchToSpaceND$3(y2, dilation, adjustedCrops);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
function requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
  const padStart = basePadding.map((b2) => b2[0]);
  const origPadEnd = basePadding.map((b2) => b2[1]);
  const fullInputShape = inputShape.concat(padStart, origPadEnd);
  const padEndExtra = blockShape.map((b2, i2) => (b2 - fullInputShape[i2] % b2) % b2);
  const padEnd = origPadEnd.map((s2, i2) => s2 + padEndExtra[i2]);
  const paddings = blockShape.map((_24, i2) => [padStart[i2], padEnd[i2]]);
  const crops = blockShape.map((_24, i2) => [0, padEndExtra[i2]]);
  return [paddings, crops];
}
function withSpaceToBatchBasePaddings(filterShape, dilation) {
  const dilatedFilterShape = filterShape.map((s2, i2) => {
    return s2 + (s2 - 1) * (dilation[i2] - 1);
  });
  const padExtraShape = dilatedFilterShape.map((s2) => s2 - 1);
  const padExtraStart = padExtraShape.map((s2) => Math.floor(s2 / 2));
  const padExtraEnd = padExtraShape.map((s2, i2) => s2 - padExtraStart[i2]);
  return padExtraShape.map((_24, i2) => {
    return [padExtraStart[i2], padExtraEnd[i2]];
  });
}
const pool$1 = op({ pool_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pow_(base, exp2) {
  let $base = convertToTensor(base, "base", "pow");
  let $exp = convertToTensor(exp2, "exp", "pow");
  [$base, $exp] = makeTypesMatch($base, $exp);
  const inputs = { a: $base, b: $exp };
  return ENGINE.runKernel(Pow, inputs);
}
const pow$2 = op({ pow_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function prelu_(x2, alpha2) {
  const $x = convertToTensor(x2, "x", "prelu");
  const $alpha = convertToTensor(alpha2, "alpha", "prelu");
  const inputs = { x: $x, alpha: $alpha };
  return ENGINE.runKernel(Prelu, inputs);
}
const prelu$3 = op({ prelu_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function prod_(x2, axis = null, keepDims = false) {
  let $x = convertToTensor(x2, "x", "prod");
  if ($x.dtype === "bool") {
    $x = cast$4($x, "int32");
  }
  const inputs = { x: $x };
  const attrs = { axis, keepDims };
  return ENGINE.runKernel(Prod, inputs, attrs);
}
const prod$3 = op({ prod_ });
var alea$1 = { exports: {} };
(function(module2) {
  (function(global2, module3, define) {
    function Alea(seed) {
      var me2 = this, mash = Mash();
      me2.next = function() {
        var t2 = 2091639 * me2.s0 + me2.c * 23283064365386963e-26;
        me2.s0 = me2.s1;
        me2.s1 = me2.s2;
        return me2.s2 = t2 - (me2.c = t2 | 0);
      };
      me2.c = 1;
      me2.s0 = mash(" ");
      me2.s1 = mash(" ");
      me2.s2 = mash(" ");
      me2.s0 -= mash(seed);
      if (me2.s0 < 0) {
        me2.s0 += 1;
      }
      me2.s1 -= mash(seed);
      if (me2.s1 < 0) {
        me2.s1 += 1;
      }
      me2.s2 -= mash(seed);
      if (me2.s2 < 0) {
        me2.s2 += 1;
      }
      mash = null;
    }
    function copy2(f2, t2) {
      t2.c = f2.c;
      t2.s0 = f2.s0;
      t2.s1 = f2.s1;
      t2.s2 = f2.s2;
      return t2;
    }
    function impl(seed, opts) {
      var xg = new Alea(seed), state2 = opts && opts.state, prng = xg.next;
      prng.int32 = function() {
        return xg.next() * 4294967296 | 0;
      };
      prng.double = function() {
        return prng() + (prng() * 2097152 | 0) * 11102230246251565e-32;
      };
      prng.quick = prng;
      if (state2) {
        if (typeof state2 == "object")
          copy2(state2, xg);
        prng.state = function() {
          return copy2(xg, {});
        };
      }
      return prng;
    }
    function Mash() {
      var n2 = 4022871197;
      var mash = function(data2) {
        data2 = data2.toString();
        for (var i2 = 0; i2 < data2.length; i2++) {
          n2 += data2.charCodeAt(i2);
          var h2 = 0.02519603282416938 * n2;
          n2 = h2 >>> 0;
          h2 -= n2;
          h2 *= n2;
          n2 = h2 >>> 0;
          h2 -= n2;
          n2 += h2 * 4294967296;
        }
        return (n2 >>> 0) * 23283064365386963e-26;
      };
      return mash;
    }
    if (module3 && module3.exports) {
      module3.exports = impl;
    } else if (define && define.amd) {
      define(function() {
        return impl;
      });
    } else {
      this.alea = impl;
    }
  })(commonjsGlobal, module2, false);
})(alea$1);
var xor128$1 = { exports: {} };
(function(module2) {
  (function(global2, module3, define) {
    function XorGen(seed) {
      var me2 = this, strseed = "";
      me2.x = 0;
      me2.y = 0;
      me2.z = 0;
      me2.w = 0;
      me2.next = function() {
        var t2 = me2.x ^ me2.x << 11;
        me2.x = me2.y;
        me2.y = me2.z;
        me2.z = me2.w;
        return me2.w ^= me2.w >>> 19 ^ t2 ^ t2 >>> 8;
      };
      if (seed === (seed | 0)) {
        me2.x = seed;
      } else {
        strseed += seed;
      }
      for (var k3 = 0; k3 < strseed.length + 64; k3++) {
        me2.x ^= strseed.charCodeAt(k3) | 0;
        me2.next();
      }
    }
    function copy2(f2, t2) {
      t2.x = f2.x;
      t2.y = f2.y;
      t2.z = f2.z;
      t2.w = f2.w;
      return t2;
    }
    function impl(seed, opts) {
      var xg = new XorGen(seed), state2 = opts && opts.state, prng = function() {
        return (xg.next() >>> 0) / 4294967296;
      };
      prng.double = function() {
        do {
          var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
        } while (result2 === 0);
        return result2;
      };
      prng.int32 = xg.next;
      prng.quick = prng;
      if (state2) {
        if (typeof state2 == "object")
          copy2(state2, xg);
        prng.state = function() {
          return copy2(xg, {});
        };
      }
      return prng;
    }
    if (module3 && module3.exports) {
      module3.exports = impl;
    } else if (define && define.amd) {
      define(function() {
        return impl;
      });
    } else {
      this.xor128 = impl;
    }
  })(commonjsGlobal, module2, false);
})(xor128$1);
var xorwow$1 = { exports: {} };
(function(module2) {
  (function(global2, module3, define) {
    function XorGen(seed) {
      var me2 = this, strseed = "";
      me2.next = function() {
        var t2 = me2.x ^ me2.x >>> 2;
        me2.x = me2.y;
        me2.y = me2.z;
        me2.z = me2.w;
        me2.w = me2.v;
        return (me2.d = me2.d + 362437 | 0) + (me2.v = me2.v ^ me2.v << 4 ^ (t2 ^ t2 << 1)) | 0;
      };
      me2.x = 0;
      me2.y = 0;
      me2.z = 0;
      me2.w = 0;
      me2.v = 0;
      if (seed === (seed | 0)) {
        me2.x = seed;
      } else {
        strseed += seed;
      }
      for (var k3 = 0; k3 < strseed.length + 64; k3++) {
        me2.x ^= strseed.charCodeAt(k3) | 0;
        if (k3 == strseed.length) {
          me2.d = me2.x << 10 ^ me2.x >>> 4;
        }
        me2.next();
      }
    }
    function copy2(f2, t2) {
      t2.x = f2.x;
      t2.y = f2.y;
      t2.z = f2.z;
      t2.w = f2.w;
      t2.v = f2.v;
      t2.d = f2.d;
      return t2;
    }
    function impl(seed, opts) {
      var xg = new XorGen(seed), state2 = opts && opts.state, prng = function() {
        return (xg.next() >>> 0) / 4294967296;
      };
      prng.double = function() {
        do {
          var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
        } while (result2 === 0);
        return result2;
      };
      prng.int32 = xg.next;
      prng.quick = prng;
      if (state2) {
        if (typeof state2 == "object")
          copy2(state2, xg);
        prng.state = function() {
          return copy2(xg, {});
        };
      }
      return prng;
    }
    if (module3 && module3.exports) {
      module3.exports = impl;
    } else if (define && define.amd) {
      define(function() {
        return impl;
      });
    } else {
      this.xorwow = impl;
    }
  })(commonjsGlobal, module2, false);
})(xorwow$1);
var xorshift7$1 = { exports: {} };
(function(module2) {
  (function(global2, module3, define) {
    function XorGen(seed) {
      var me2 = this;
      me2.next = function() {
        var X2 = me2.x, i2 = me2.i, t2, v2;
        t2 = X2[i2];
        t2 ^= t2 >>> 7;
        v2 = t2 ^ t2 << 24;
        t2 = X2[i2 + 1 & 7];
        v2 ^= t2 ^ t2 >>> 10;
        t2 = X2[i2 + 3 & 7];
        v2 ^= t2 ^ t2 >>> 3;
        t2 = X2[i2 + 4 & 7];
        v2 ^= t2 ^ t2 << 7;
        t2 = X2[i2 + 7 & 7];
        t2 = t2 ^ t2 << 13;
        v2 ^= t2 ^ t2 << 9;
        X2[i2] = v2;
        me2.i = i2 + 1 & 7;
        return v2;
      };
      function init3(me3, seed2) {
        var j2, X2 = [];
        if (seed2 === (seed2 | 0)) {
          X2[0] = seed2;
        } else {
          seed2 = "" + seed2;
          for (j2 = 0; j2 < seed2.length; ++j2) {
            X2[j2 & 7] = X2[j2 & 7] << 15 ^ seed2.charCodeAt(j2) + X2[j2 + 1 & 7] << 13;
          }
        }
        while (X2.length < 8)
          X2.push(0);
        for (j2 = 0; j2 < 8 && X2[j2] === 0; ++j2)
          ;
        if (j2 == 8)
          X2[7] = -1;
        me3.x = X2;
        me3.i = 0;
        for (j2 = 256; j2 > 0; --j2) {
          me3.next();
        }
      }
      init3(me2, seed);
    }
    function copy2(f2, t2) {
      t2.x = f2.x.slice();
      t2.i = f2.i;
      return t2;
    }
    function impl(seed, opts) {
      if (seed == null)
        seed = +new Date();
      var xg = new XorGen(seed), state2 = opts && opts.state, prng = function() {
        return (xg.next() >>> 0) / 4294967296;
      };
      prng.double = function() {
        do {
          var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
        } while (result2 === 0);
        return result2;
      };
      prng.int32 = xg.next;
      prng.quick = prng;
      if (state2) {
        if (state2.x)
          copy2(state2, xg);
        prng.state = function() {
          return copy2(xg, {});
        };
      }
      return prng;
    }
    if (module3 && module3.exports) {
      module3.exports = impl;
    } else if (define && define.amd) {
      define(function() {
        return impl;
      });
    } else {
      this.xorshift7 = impl;
    }
  })(commonjsGlobal, module2, false);
})(xorshift7$1);
var xor4096$1 = { exports: {} };
(function(module2) {
  (function(global2, module3, define) {
    function XorGen(seed) {
      var me2 = this;
      me2.next = function() {
        var w2 = me2.w, X2 = me2.X, i2 = me2.i, t2, v2;
        me2.w = w2 = w2 + 1640531527 | 0;
        v2 = X2[i2 + 34 & 127];
        t2 = X2[i2 = i2 + 1 & 127];
        v2 ^= v2 << 13;
        t2 ^= t2 << 17;
        v2 ^= v2 >>> 15;
        t2 ^= t2 >>> 12;
        v2 = X2[i2] = v2 ^ t2;
        me2.i = i2;
        return v2 + (w2 ^ w2 >>> 16) | 0;
      };
      function init3(me3, seed2) {
        var t2, v2, i2, j2, w2, X2 = [], limit = 128;
        if (seed2 === (seed2 | 0)) {
          v2 = seed2;
          seed2 = null;
        } else {
          seed2 = seed2 + "\0";
          v2 = 0;
          limit = Math.max(limit, seed2.length);
        }
        for (i2 = 0, j2 = -32; j2 < limit; ++j2) {
          if (seed2)
            v2 ^= seed2.charCodeAt((j2 + 32) % seed2.length);
          if (j2 === 0)
            w2 = v2;
          v2 ^= v2 << 10;
          v2 ^= v2 >>> 15;
          v2 ^= v2 << 4;
          v2 ^= v2 >>> 13;
          if (j2 >= 0) {
            w2 = w2 + 1640531527 | 0;
            t2 = X2[j2 & 127] ^= v2 + w2;
            i2 = t2 == 0 ? i2 + 1 : 0;
          }
        }
        if (i2 >= 128) {
          X2[(seed2 && seed2.length || 0) & 127] = -1;
        }
        i2 = 127;
        for (j2 = 4 * 128; j2 > 0; --j2) {
          v2 = X2[i2 + 34 & 127];
          t2 = X2[i2 = i2 + 1 & 127];
          v2 ^= v2 << 13;
          t2 ^= t2 << 17;
          v2 ^= v2 >>> 15;
          t2 ^= t2 >>> 12;
          X2[i2] = v2 ^ t2;
        }
        me3.w = w2;
        me3.X = X2;
        me3.i = i2;
      }
      init3(me2, seed);
    }
    function copy2(f2, t2) {
      t2.i = f2.i;
      t2.w = f2.w;
      t2.X = f2.X.slice();
      return t2;
    }
    function impl(seed, opts) {
      if (seed == null)
        seed = +new Date();
      var xg = new XorGen(seed), state2 = opts && opts.state, prng = function() {
        return (xg.next() >>> 0) / 4294967296;
      };
      prng.double = function() {
        do {
          var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
        } while (result2 === 0);
        return result2;
      };
      prng.int32 = xg.next;
      prng.quick = prng;
      if (state2) {
        if (state2.X)
          copy2(state2, xg);
        prng.state = function() {
          return copy2(xg, {});
        };
      }
      return prng;
    }
    if (module3 && module3.exports) {
      module3.exports = impl;
    } else if (define && define.amd) {
      define(function() {
        return impl;
      });
    } else {
      this.xor4096 = impl;
    }
  })(commonjsGlobal, module2, false);
})(xor4096$1);
var tychei$1 = { exports: {} };
(function(module2) {
  (function(global2, module3, define) {
    function XorGen(seed) {
      var me2 = this, strseed = "";
      me2.next = function() {
        var b2 = me2.b, c2 = me2.c, d2 = me2.d, a6 = me2.a;
        b2 = b2 << 25 ^ b2 >>> 7 ^ c2;
        c2 = c2 - d2 | 0;
        d2 = d2 << 24 ^ d2 >>> 8 ^ a6;
        a6 = a6 - b2 | 0;
        me2.b = b2 = b2 << 20 ^ b2 >>> 12 ^ c2;
        me2.c = c2 = c2 - d2 | 0;
        me2.d = d2 << 16 ^ c2 >>> 16 ^ a6;
        return me2.a = a6 - b2 | 0;
      };
      me2.a = 0;
      me2.b = 0;
      me2.c = 2654435769 | 0;
      me2.d = 1367130551;
      if (seed === Math.floor(seed)) {
        me2.a = seed / 4294967296 | 0;
        me2.b = seed | 0;
      } else {
        strseed += seed;
      }
      for (var k3 = 0; k3 < strseed.length + 20; k3++) {
        me2.b ^= strseed.charCodeAt(k3) | 0;
        me2.next();
      }
    }
    function copy2(f2, t2) {
      t2.a = f2.a;
      t2.b = f2.b;
      t2.c = f2.c;
      t2.d = f2.d;
      return t2;
    }
    function impl(seed, opts) {
      var xg = new XorGen(seed), state2 = opts && opts.state, prng = function() {
        return (xg.next() >>> 0) / 4294967296;
      };
      prng.double = function() {
        do {
          var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
        } while (result2 === 0);
        return result2;
      };
      prng.int32 = xg.next;
      prng.quick = prng;
      if (state2) {
        if (typeof state2 == "object")
          copy2(state2, xg);
        prng.state = function() {
          return copy2(xg, {});
        };
      }
      return prng;
    }
    if (module3 && module3.exports) {
      module3.exports = impl;
    } else if (define && define.amd) {
      define(function() {
        return impl;
      });
    } else {
      this.tychei = impl;
    }
  })(commonjsGlobal, module2, false);
})(tychei$1);
var seedrandom$1 = { exports: {} };
(function(module2) {
  (function(pool2, math2) {
    var global2 = this, width2 = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math2.pow(width2, chunks), significance = math2.pow(2, digits), overflow = significance * 2, mask = width2 - 1, nodecrypto;
    function seedrandom2(seed, options, callback) {
      var key = [];
      options = options == true ? { entropy: true } : options || {};
      var shortseed = mixkey(flatten2(options.entropy ? [seed, tostring(pool2)] : seed == null ? autoseed() : seed, 3), key);
      var arc4 = new ARC4(key);
      var prng = function() {
        var n2 = arc4.g(chunks), d2 = startdenom, x2 = 0;
        while (n2 < significance) {
          n2 = (n2 + x2) * width2;
          d2 *= width2;
          x2 = arc4.g(1);
        }
        while (n2 >= overflow) {
          n2 /= 2;
          d2 /= 2;
          x2 >>>= 1;
        }
        return (n2 + x2) / d2;
      };
      prng.int32 = function() {
        return arc4.g(4) | 0;
      };
      prng.quick = function() {
        return arc4.g(4) / 4294967296;
      };
      prng.double = prng;
      mixkey(tostring(arc4.S), pool2);
      return (options.pass || callback || function(prng2, seed2, is_math_call, state2) {
        if (state2) {
          if (state2.S) {
            copy2(state2, arc4);
          }
          prng2.state = function() {
            return copy2(arc4, {});
          };
        }
        if (is_math_call) {
          math2[rngname] = prng2;
          return seed2;
        } else
          return prng2;
      })(prng, shortseed, "global" in options ? options.global : this == math2, options.state);
    }
    math2["seed" + rngname] = seedrandom2;
    function ARC4(key) {
      var t2, keylen = key.length, me2 = this, i2 = 0, j2 = me2.i = me2.j = 0, s2 = me2.S = [];
      if (!keylen) {
        key = [keylen++];
      }
      while (i2 < width2) {
        s2[i2] = i2++;
      }
      for (i2 = 0; i2 < width2; i2++) {
        s2[i2] = s2[j2 = mask & j2 + key[i2 % keylen] + (t2 = s2[i2])];
        s2[j2] = t2;
      }
      (me2.g = function(count2) {
        var t3, r2 = 0, i3 = me2.i, j3 = me2.j, s3 = me2.S;
        while (count2--) {
          t3 = s3[i3 = mask & i3 + 1];
          r2 = r2 * width2 + s3[mask & (s3[i3] = s3[j3 = mask & j3 + t3]) + (s3[j3] = t3)];
        }
        me2.i = i3;
        me2.j = j3;
        return r2;
      })(width2);
    }
    function copy2(f2, t2) {
      t2.i = f2.i;
      t2.j = f2.j;
      t2.S = f2.S.slice();
      return t2;
    }
    function flatten2(obj, depth) {
      var result2 = [], typ = typeof obj, prop;
      if (depth && typ == "object") {
        for (prop in obj) {
          try {
            result2.push(flatten2(obj[prop], depth - 1));
          } catch (e2) {
          }
        }
      }
      return result2.length ? result2 : typ == "string" ? obj : obj + "\0";
    }
    function mixkey(seed, key) {
      var stringseed = seed + "", smear, j2 = 0;
      while (j2 < stringseed.length) {
        key[mask & j2] = mask & (smear ^= key[mask & j2] * 19) + stringseed.charCodeAt(j2++);
      }
      return tostring(key);
    }
    function autoseed() {
      try {
        var out;
        if (nodecrypto && (out = nodecrypto.randomBytes)) {
          out = out(width2);
        } else {
          out = new Uint8Array(width2);
          (global2.crypto || global2.msCrypto).getRandomValues(out);
        }
        return tostring(out);
      } catch (e2) {
        var browser = global2.navigator, plugins = browser && browser.plugins;
        return [+new Date(), global2, plugins, global2.screen, tostring(pool2)];
      }
    }
    function tostring(a6) {
      return String.fromCharCode.apply(0, a6);
    }
    mixkey(math2.random(), pool2);
    if (module2.exports) {
      module2.exports = seedrandom2;
      try {
        nodecrypto = require("crypto");
      } catch (ex) {
      }
    }
  })([], Math);
})(seedrandom$1);
var alea = alea$1.exports;
var xor128 = xor128$1.exports;
var xorwow = xorwow$1.exports;
var xorshift7 = xorshift7$1.exports;
var xor4096 = xor4096$1.exports;
var tychei = tychei$1.exports;
var sr = seedrandom$1.exports;
sr.alea = alea;
sr.xor128 = xor128;
sr.xorwow = xorwow;
sr.xorshift7 = xorshift7;
sr.xor4096 = xor4096;
sr.tychei = tychei;
var seedrandom = sr;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MPRandGauss {
  constructor(mean2, stdDeviation, dtype, truncated, seed) {
    this.mean = mean2;
    this.stdDev = stdDeviation;
    this.dtype = dtype;
    this.nextVal = NaN;
    this.truncated = truncated;
    if (this.truncated) {
      this.upper = this.mean + this.stdDev * 2;
      this.lower = this.mean - this.stdDev * 2;
    }
    const seedValue = seed ? seed : Math.random();
    this.random = seedrandom.alea(seedValue.toString());
  }
  nextValue() {
    if (!isNaN(this.nextVal)) {
      const value = this.nextVal;
      this.nextVal = NaN;
      return value;
    }
    let resultX, resultY;
    let isValid = false;
    while (!isValid) {
      let v12, v2, s2;
      do {
        v12 = 2 * this.random() - 1;
        v2 = 2 * this.random() - 1;
        s2 = v12 * v12 + v2 * v2;
      } while (s2 >= 1 || s2 === 0);
      const mul2 = Math.sqrt(-2 * Math.log(s2) / s2);
      resultX = this.mean + this.stdDev * v12 * mul2;
      resultY = this.mean + this.stdDev * v2 * mul2;
      if (!this.truncated || this.isValidTruncated(resultX)) {
        isValid = true;
      }
    }
    if (!this.truncated || this.isValidTruncated(resultY)) {
      this.nextVal = this.convertValue(resultY);
    }
    return this.convertValue(resultX);
  }
  convertValue(value) {
    if (this.dtype == null || this.dtype === "float32") {
      return value;
    }
    return Math.round(value);
  }
  isValidTruncated(value) {
    return value <= this.upper && value >= this.lower;
  }
}
class UniformRandom {
  constructor(min2 = 0, max2 = 1, dtype, seed) {
    this.canReturnFloat = () => this.dtype == null || this.dtype === "float32";
    this.min = min2;
    this.range = max2 - min2;
    this.dtype = dtype;
    if (seed == null) {
      seed = Math.random();
    }
    if (typeof seed === "number") {
      seed = seed.toString();
    }
    if (!this.canReturnFloat() && this.range <= 1) {
      throw new Error(`The difference between ${min2} - ${max2} <= 1 and dtype is not float`);
    }
    this.random = seedrandom.alea(seed);
  }
  convertValue(value) {
    if (this.canReturnFloat()) {
      return value;
    }
    return Math.round(value);
  }
  nextValue() {
    return this.convertValue(this.min + this.range * this.random());
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function randomNormal_(shape, mean2 = 0, stdDev = 1, dtype, seed) {
  if (dtype != null && dtype === "bool") {
    throw new Error(`Unsupported data type ${dtype}`);
  }
  const randGauss = new MPRandGauss(mean2, stdDev, dtype, false, seed);
  const res = buffer(shape, dtype);
  for (let i2 = 0; i2 < res.values.length; i2++) {
    res.values[i2] = randGauss.nextValue();
  }
  return res.toTensor();
}
const randomNormal$1 = op({ randomNormal_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function randomUniform_(shape, minval = 0, maxval = 1, dtype = "float32", seed) {
  const res = buffer(shape, dtype);
  const random = new UniformRandom(minval, maxval, null, seed);
  for (let i2 = 0; i2 < res.values.length; i2++) {
    res.values[i2] = random.nextValue();
  }
  return res.toTensor();
}
const randomUniform = op({ randomUniform_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function range$4(start, stop, step2 = 1, dtype = "float32") {
  if (step2 === 0) {
    throw new Error("Cannot have a step of zero");
  }
  const attrs = { start, stop, step: step2, dtype };
  return ENGINE.runKernel(Range, {}, attrs);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function real_(input) {
  const $input = convertToTensor(input, "input", "real");
  const inputs = { input: $input };
  return ENGINE.runKernel(Real, inputs);
}
const real$2 = op({ real_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reciprocal_(x2) {
  const $x = convertToTensor(x2, "x", "reciprocal");
  const inputs = { x: $x };
  return ENGINE.runKernel(Reciprocal, inputs);
}
const reciprocal$2 = op({ reciprocal_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function relu_(x2) {
  const $x = convertToTensor(x2, "x", "relu");
  const inputs = { x: $x };
  return ENGINE.runKernel(Relu$1, inputs);
}
const relu$2 = op({ relu_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function relu6_(x2) {
  const $x = convertToTensor(x2, "x", "relu6");
  const inputs = { x: $x };
  return ENGINE.runKernel(Relu6$1, inputs);
}
const relu6$2 = op({ relu6_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reverse_(x2, axis) {
  const $x = convertToTensor(x2, "x", "reverse");
  const inputs = { x: $x };
  const attrs = { dims: axis };
  return ENGINE.runKernel(Reverse, inputs, attrs);
}
const reverse$3 = op({ reverse_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function round_(x2) {
  const $x = convertToTensor(x2, "x", "round");
  const inputs = { x: $x };
  return ENGINE.runKernel(Round, inputs);
}
const round$2 = op({ round_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function rsqrt_(x2) {
  const $x = convertToTensor(x2, "x", "rsqrt", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Rsqrt, inputs);
}
const rsqrt$2 = op({ rsqrt_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function scalar(value, dtype) {
  if ((isTypedArray(value) && dtype !== "string" || Array.isArray(value)) && dtype !== "complex64") {
    throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
  }
  if (dtype === "string" && isTypedArray(value) && !(value instanceof Uint8Array)) {
    throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
  }
  const shape = [];
  const inferredShape = [];
  return makeTensor(value, shape, inferredShape, dtype);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function selu_(x2) {
  const $x = convertToTensor(x2, "x", "selu");
  const inputs = { x: $x };
  return ENGINE.runKernel(Selu$1, inputs);
}
const selu$2 = op({ selu_ });
function separableConv2d_(x2, depthwiseFilter, pointwiseFilter, strides, pad2, dilation = [1, 1], dataFormat = "NHWC") {
  const $x = convertToTensor(x2, "x", "separableConv2d");
  const $depthwiseFilter = convertToTensor(depthwiseFilter, "depthwiseFilter", "separableConv2d");
  const $pointwiseFilter = convertToTensor(pointwiseFilter, "pointwiseFilter", "separableConv2d");
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  if (dataFormat === "NCHW") {
    throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
  }
  assert$1(x4D.rank === 4, () => `Error in separableConv2d: input must be rank 4, but got rank ${x4D.rank}.`);
  assert$1($depthwiseFilter.rank === 4, () => `Error in separableConv2d: depthwise filter must be rank 4, but got rank ${$depthwiseFilter.rank}.`);
  assert$1($pointwiseFilter.rank === 4, () => `Error in separableConv2d: pointwise filter must be rank 4, but got rank ${$depthwiseFilter.rank}.`);
  assert$1($pointwiseFilter.shape[0] === 1, () => `Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got ${$pointwiseFilter.shape[0]}.`);
  assert$1($pointwiseFilter.shape[1] === 1, () => `Error in separableConv2d: the second dimension of pointwise filter must be 1, but got ${$pointwiseFilter.shape[1]}.`);
  const inChannels = $depthwiseFilter.shape[2];
  const channelMultiplier = $depthwiseFilter.shape[3];
  assert$1($pointwiseFilter.shape[2] === inChannels * channelMultiplier, () => `Error in separableConv2d: the third dimension of pointwise filter must be ${inChannels * channelMultiplier}, but got ${$pointwiseFilter.shape[2]}.`);
  const depthwise = depthwiseConv2d$3(x4D, $depthwiseFilter, strides, pad2, dataFormat, dilation);
  const pointwiseStride = 1;
  const res = conv2d$3(depthwise, $pointwiseFilter, pointwiseStride, "valid", dataFormat);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const separableConv2d = op({ separableConv2d_ });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
async function setdiff1dAsync_(x2, y2) {
  const $x = convertToTensor(x2, "x", "setdiff1d");
  const $y = convertToTensor(y2, "y", "setdiff1d");
  assert$1($x.dtype === $y.dtype, () => `x and y should have the same dtype, but got x (${$x.dtype}) and y (${$y.dtype}).`);
  assert$1($x.rank === 1, () => `x should be 1D tensor, but got x (${$x.shape}).`);
  assert$1($y.rank === 1, () => `y should be 1D tensor, but got y (${$y.shape}).`);
  const xVals = await $x.data();
  const yVals = await $y.data();
  const ySet = new Set(yVals);
  let outputSize = 0;
  for (let i2 = 0; i2 < xVals.length; i2++) {
    if (!ySet.has(xVals[i2])) {
      outputSize++;
    }
  }
  const buffer2 = new TensorBuffer([outputSize], $x.dtype);
  const indices = new TensorBuffer([outputSize], "int32");
  for (let i2 = 0, p2 = 0; i2 < xVals.length; i2++) {
    if (!ySet.has(xVals[i2])) {
      buffer2.values[p2] = xVals[i2];
      indices.values[p2] = i2;
      p2++;
    }
  }
  return [buffer2.toTensor(), indices.toTensor()];
}
const setdiff1dAsync = setdiff1dAsync_;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sign_(x2) {
  const $x = convertToTensor(x2, "x", "sign");
  const inputs = { x: $x };
  return ENGINE.runKernel(Sign, inputs);
}
const sign$2 = op({ sign_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sin_(x2) {
  const $x = convertToTensor(x2, "x", "sin", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Sin, inputs);
}
const sin$2 = op({ sin_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sinh_(x2) {
  const $x = convertToTensor(x2, "x", "sinh");
  const inputs = { x: $x };
  return ENGINE.runKernel(Sinh, inputs);
}
const sinh$2 = op({ sinh_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function slice1d_(x2, begin, size) {
  const $x = convertToTensor(x2, "x", "slice1d");
  assert$1($x.rank === 1, () => `slice1d expects a rank-1 tensor, but got a rank-${$x.rank} tensor`);
  return slice$3($x, [begin], [size]);
}
const slice1d = op({ slice1d_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function slice2d_(x2, begin, size) {
  const $x = convertToTensor(x2, "x", "slice2d");
  assert$1($x.rank === 2, () => `slice2d expects a rank-2 tensor, but got a rank-${$x.rank} tensor`);
  return slice$3($x, begin, size);
}
const slice2d$1 = op({ slice2d_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function slice3d_(x2, begin, size) {
  const $x = convertToTensor(x2, "x", "slice3d");
  assert$1($x.rank === 3, () => `slice3d expects a rank-3 tensor, but got a rank-${$x.rank} tensor`);
  return slice$3($x, begin, size);
}
const slice3d$1 = op({ slice3d_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function slice4d_(x2, begin, size) {
  const $x = convertToTensor(x2, "x", "slice4d");
  assert$1($x.rank === 4, () => `slice4d expects a rank-4 tensor, but got a rank-${$x.rank} tensor`);
  return slice$3($x, begin, size);
}
const slice4d$1 = op({ slice4d_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function softmax_(logits, dim = -1) {
  const $logits = convertToTensor(logits, "logits", "softmax", "float32");
  if (dim === -1) {
    dim = $logits.rank - 1;
  }
  if (dim !== $logits.rank - 1) {
    throw Error(`Softmax along a non-last dimension is not yet supported. Logits was rank ${$logits.rank} and dim was ${dim}`);
  }
  const inputs = { logits: $logits };
  const attrs = { dim };
  return ENGINE.runKernel(Softmax$2, inputs, attrs);
}
const softmax$3 = op({ softmax_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fft_(input) {
  assert$1(input.dtype === "complex64", () => `The dtype for tf.spectral.fft() must be complex64 but got ${input.dtype}.`);
  const inputs = { input };
  return ENGINE.runKernel(FFT, inputs);
}
const fft$2 = op({ fft_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function ifft_(input) {
  assert$1(input.dtype === "complex64", () => `The dtype for tf.spectral.ifft() must be complex64 but got ${input.dtype}.`);
  const inputs = { input };
  return ENGINE.runKernel(IFFT, inputs);
}
const ifft$2 = op({ ifft_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function irfft_(input) {
  const innerDimensionSize = input.shape[input.shape.length - 1];
  const batch = input.size / innerDimensionSize;
  let ret;
  if (innerDimensionSize <= 2) {
    const complexInput = reshape$3(input, [batch, innerDimensionSize]);
    ret = ifft$2(complexInput);
  } else {
    const outputShape = [batch, 2 * (innerDimensionSize - 1)];
    const realInput = reshape$3(real$2(input), [batch, innerDimensionSize]);
    const imagInput = reshape$3(imag$2(input), [batch, innerDimensionSize]);
    const realConjugate = reverse$3(slice$3(realInput, [0, 1], [batch, innerDimensionSize - 2]), 1);
    const imagConjugate = mul(reverse$3(slice$3(imagInput, [0, 1], [batch, innerDimensionSize - 2]), 1), scalar(-1));
    const r2 = concat$3([realInput, realConjugate], 1);
    const i2 = concat$3([imagInput, imagConjugate], 1);
    const complexInput = reshape$3(complex$3(r2, i2), [outputShape[0], outputShape[1]]);
    ret = ifft$2(complexInput);
  }
  ret = real$2(ret);
  if (input.rank === 3 && input.shape[0] !== 0) {
    const temp = ret;
    const batch2 = input.shape[0];
    ret = reshape$3(ret, [batch2, ret.shape[0] / batch2, ret.shape[1]]);
    temp.dispose();
  }
  return ret;
}
const irfft = op({ irfft_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function split_(x2, numOrSizeSplits, axis = 0) {
  const $x = convertToTensor(x2, "x", "split");
  const inputs = { x: $x };
  const attr = { numOrSizeSplits, axis };
  return ENGINE.runKernel(SplitV, inputs, attr);
}
const split$2 = op({ split_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function rfft_(input, fftLength) {
  assert$1(input.dtype === "float32", () => `The dtype for rfft() must be real value but got ${input.dtype}`);
  let innerDimensionSize = input.shape[input.shape.length - 1];
  const batch = input.size / innerDimensionSize;
  let adjustedInput;
  if (fftLength != null && fftLength < innerDimensionSize) {
    const begin = input.shape.map((v2) => 0);
    const size = input.shape.map((v2) => v2);
    size[input.shape.length - 1] = fftLength;
    adjustedInput = slice$3(input, begin, size);
    innerDimensionSize = fftLength;
  } else if (fftLength != null && fftLength > innerDimensionSize) {
    const zerosShape = input.shape.map((v2) => v2);
    zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
    adjustedInput = concat$3([input, zeros$1(zerosShape)], input.shape.length - 1);
    innerDimensionSize = fftLength;
  } else {
    adjustedInput = input;
  }
  const zerosInput = zerosLike$3(adjustedInput);
  const complexInput = reshape$3(complex$3(adjustedInput, zerosInput), [batch, innerDimensionSize]);
  const ret = fft$2(complexInput);
  const half = Math.floor(innerDimensionSize / 2) + 1;
  const realValues = real$2(ret);
  const imagValues = imag$2(ret);
  const realComplexConjugate = split$2(realValues, [half, innerDimensionSize - half], realValues.shape.length - 1);
  const imagComplexConjugate = split$2(imagValues, [half, innerDimensionSize - half], imagValues.shape.length - 1);
  const outputShape = adjustedInput.shape.slice();
  outputShape[adjustedInput.shape.length - 1] = half;
  return reshape$3(complex$3(realComplexConjugate[0], imagComplexConjugate[0]), outputShape);
}
const rfft = op({ rfft_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sqrt_(x2) {
  const $x = convertToTensor(x2, "x", "sqrt", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Sqrt, inputs);
}
const sqrt$2 = op({ sqrt_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function squaredDifference_(a6, b2) {
  let $a = convertToTensor(a6, "a", "squaredDifference");
  let $b = convertToTensor(b2, "b", "squaredDifference");
  [$a, $b] = makeTypesMatch($a, $b);
  assertAndGetBroadcastShape($a.shape, $b.shape);
  const inputs = { a: $a, b: $b };
  const attrs = {};
  return ENGINE.runKernel(SquaredDifference, inputs, attrs);
}
const squaredDifference$2 = op({ squaredDifference_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function squeeze_(x2, axis) {
  const $x = convertToTensor(x2, "x", "squeeze");
  return reshape$3($x, squeezeShape($x.shape, axis).newShape);
}
const squeeze = op({ squeeze_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stack_(tensors, axis = 0) {
  const $tensors = convertToTensorArray(tensors, "tensors", "stack", "string_or_numeric");
  assert$1($tensors.length >= 1, () => "Pass at least one tensor to tf.stack");
  if ($tensors.length > 0) {
    assert$1(axis <= $tensors[0].rank, () => "Axis must be <= rank of the tensor");
  }
  const inputs = $tensors;
  const attrs = { axis };
  return ENGINE.runKernel(Pack, inputs, attrs);
}
const stack = op({ stack_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function step_(x2, alpha2 = 0) {
  const $x = convertToTensor(x2, "x", "step");
  const inputs = { x: $x };
  const attrs = { alpha: alpha2 };
  return ENGINE.runKernel(Step, inputs, attrs);
}
const step$3 = op({ step_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stridedSlice_(x2, begin, end, strides, beginMask = 0, endMask = 0, ellipsisMask = 0, newAxisMask = 0, shrinkAxisMask = 0) {
  const $x = convertToTensor(x2, "x", "stridedSlice", "string_or_numeric");
  const inputs = { x: $x };
  const attrs = {
    begin,
    end,
    strides,
    beginMask,
    endMask,
    ellipsisMask,
    newAxisMask,
    shrinkAxisMask
  };
  return ENGINE.runKernel(StridedSlice, inputs, attrs);
}
const stridedSlice$3 = op({ stridedSlice_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tan_(x2) {
  const $x = convertToTensor(x2, "x", "tan", "float32");
  const inputs = { x: $x };
  return ENGINE.runKernel(Tan, inputs);
}
const tan$2 = op({ tan_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tensor1d(values, dtype) {
  assertNonNull(values);
  const inferredShape = inferShape(values, dtype);
  if (inferredShape.length !== 1) {
    throw new Error("tensor1d() requires values to be a flat/TypedArray");
  }
  const shape = null;
  return makeTensor(values, shape, inferredShape, dtype);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tensor2d(values, shape, dtype) {
  assertNonNull(values);
  if (shape != null && shape.length !== 2) {
    throw new Error("tensor2d() requires shape to have two numbers");
  }
  const inferredShape = inferShape(values, dtype);
  if (inferredShape.length !== 2 && inferredShape.length !== 1) {
    throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");
  }
  if (inferredShape.length === 1 && shape == null) {
    throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
  }
  return makeTensor(values, shape, inferredShape, dtype);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function topk_(x2, k3 = 1, sorted = true) {
  const $x = convertToTensor(x2, "x", "topk");
  if ($x.rank === 0) {
    throw new Error("topk() expects the input to be of rank 1 or higher");
  }
  const lastDim = $x.shape[$x.shape.length - 1];
  if (k3 < 0) {
    throw new Error(`'k' passed to topk() must be >= 0 but got ${k3}`);
  }
  if (k3 > lastDim) {
    throw new Error(`'k' passed to topk() must be <= the last dimension (${lastDim}) but got ${k3}`);
  }
  const inputs = { x: $x };
  const attrs = { k: k3, sorted };
  const [values, indices] = ENGINE.runKernel(TopK, inputs, attrs);
  return { values, indices };
}
const topk$1 = op({ topk_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function truncatedNormal_(shape, mean2 = 0, stdDev = 1, dtype, seed) {
  if (dtype != null && dtype === "bool") {
    throw new Error(`Unsupported data type $ { dtype }`);
  }
  const randGauss = new MPRandGauss(mean2, stdDev, dtype, true, seed);
  const res = buffer(shape, dtype);
  for (let i2 = 0; i2 < res.values.length; i2++) {
    res.values[i2] = randGauss.nextValue();
  }
  return res.toTensor();
}
const truncatedNormal = op({ truncatedNormal_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unique_(x2, axis = 0) {
  const $x = convertToTensor(x2, "x", "unique", "string_or_numeric");
  assert$1($x.rank > 0, () => "The input tensor must be at least 1D");
  const inputs = { x: $x };
  const attrs = { axis };
  const [values, indices] = ENGINE.runKernel(Unique, inputs, attrs);
  return { values, indices };
}
const unique$3 = op({ unique_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unsortedSegmentSum_(x2, segmentIds, numSegments) {
  const $x = convertToTensor(x2, "x", "unsortedSegmentSum");
  const $segmentIds = convertToTensor(segmentIds, "segmentIds", "unsortedSegmentSum", "int32");
  assert$1(isInt(numSegments), () => "numSegments must be of dtype int");
  const inputs = { x: $x, segmentIds: $segmentIds };
  const attrs = { numSegments };
  return ENGINE.runKernel(UnsortedSegmentSum, inputs, attrs);
}
const unsortedSegmentSum$2 = op({ unsortedSegmentSum_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unstack_(x2, axis = 0) {
  const $x = convertToTensor(x2, "x", "unstack", "string_or_numeric");
  assert$1(axis >= -$x.shape.length && axis < $x.shape.length, () => `Axis = ${axis} is not in [-${$x.shape.length}, ${$x.shape.length})`);
  const inputs = { value: $x };
  const attrs = { axis };
  return ENGINE.runKernel(Unpack, inputs, attrs);
}
const unstack = op({ unstack_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function variable(initialValue, trainable = true, name, dtype) {
  return ENGINE.makeVariable(initialValue, trainable, name, dtype);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function whereImpl$2(condShape, condVals) {
  const indices = [];
  for (let i2 = 0; i2 < condVals.length; i2++) {
    if (condVals[i2]) {
      indices.push(i2);
    }
  }
  const inBuffer = buffer(condShape, "int32");
  const out = buffer([indices.length, condShape.length], "int32");
  for (let i2 = 0; i2 < indices.length; i2++) {
    const loc = inBuffer.indexToLoc(indices[i2]);
    const offset = i2 * condShape.length;
    out.values.set(loc, offset);
  }
  return out.toTensor();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
async function whereAsync_(condition) {
  const $condition = convertToTensor(condition, "condition", "whereAsync", "bool");
  const vals = await $condition.data();
  const res = whereImpl$2($condition.shape, vals);
  if (condition !== $condition) {
    $condition.dispose();
  }
  return res;
}
const whereAsync = whereAsync_;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function norm_(x2, ord = "euclidean", axis = null, keepDims = false) {
  x2 = convertToTensor(x2, "x", "norm");
  const norm2 = normImpl(x2, ord, axis);
  let keepDimsShape = norm2.shape;
  if (keepDims) {
    const axes = parseAxisParam(axis, x2.shape);
    keepDimsShape = expandShapeToKeepDim(norm2.shape, axes);
  }
  return reshape$3(norm2, keepDimsShape);
}
function normImpl(x2, p2, axis = null) {
  if (x2.rank === 0) {
    return abs$2(x2);
  }
  if (x2.rank !== 1 && axis === null) {
    return normImpl(reshape$3(x2, [-1]), p2, axis);
  }
  if (x2.rank === 1 || typeof axis === "number" || Array.isArray(axis) && axis.length === 1) {
    if (p2 === 1) {
      return sum$3(abs$2(x2), axis);
    }
    if (p2 === Infinity) {
      return max$4(abs$2(x2), axis);
    }
    if (p2 === -Infinity) {
      return min$4(abs$2(x2), axis);
    }
    if (p2 === "euclidean" || p2 === 2) {
      return sqrt$2(sum$3(pow$2(abs$2(x2), scalar(2, "int32")), axis));
    }
    throw new Error(`Error in norm: invalid ord value: ${p2}`);
  }
  if (Array.isArray(axis) && axis.length === 2) {
    if (p2 === 1) {
      return max$4(sum$3(abs$2(x2), axis[0]), axis[1] - 1);
    }
    if (p2 === Infinity) {
      return max$4(sum$3(abs$2(x2), axis[1]), axis[0]);
    }
    if (p2 === -Infinity) {
      return min$4(sum$3(abs$2(x2), axis[1]), axis[0]);
    }
    if (p2 === "fro" || p2 === "euclidean") {
      return sqrt$2(sum$3(square$2(x2), axis));
    }
    throw new Error(`Error in norm: invalid ord value: ${p2}`);
  }
  throw new Error(`Error in norm: invalid axis: ${axis}`);
}
const norm = op({ norm_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function scatterND_(indices, updates, shape) {
  const $indices = convertToTensor(indices, "indices", "scatterND", "int32");
  const $updates = convertToTensor(updates, "updates", "scatterND");
  validateInput$1($updates, $indices, shape);
  const inputs = { indices: $indices, updates: $updates };
  const attrs = { shape };
  return ENGINE.runKernel(ScatterNd, inputs, attrs);
}
const scatterND = op({ scatterND_ });
function validateInput(sparseIndices, sparseValues, outputShape, defaultValues) {
  if (sparseIndices.dtype !== "int32") {
    throw new Error(`tf.sparseToDense() expects the indices to be int32 type, but the dtype was ${sparseIndices.dtype}.`);
  }
  if (sparseIndices.rank > 2) {
    throw new Error(`sparseIndices should be a scalar, vector, or matrix, but got shape ${sparseIndices.shape}.`);
  }
  const numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
  const numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
  if (outputShape.length !== numDims) {
    throw new Error(`outputShape has incorrect number of elements:, ${outputShape.length}, should be: ${numDims}.`);
  }
  const numValues = sparseValues.size;
  if (!(sparseValues.rank === 0 || sparseValues.rank === 1 && numValues === numElems)) {
    throw new Error(`sparseValues has incorrect shape ${sparseValues.shape}, should be [] or [${numElems}]`);
  }
  if (sparseValues.dtype !== defaultValues.dtype) {
    throw new Error("sparseValues.dtype must match defaultValues.dtype");
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue = 0) {
  const $sparseIndices = convertToTensor(sparseIndices, "sparseIndices", "sparseToDense", "int32");
  const $sparseValues = convertToTensor(sparseValues, "sparseValues", "sparseToDense");
  const $defaultValue = convertToTensor(defaultValue, "defaultValue", "sparseToDense", $sparseValues.dtype);
  validateInput($sparseIndices, $sparseValues, outputShape, $defaultValue);
  const inputs = {
    sparseIndices: $sparseIndices,
    sparseValues: $sparseValues,
    defaultValue: $defaultValue
  };
  const attrs = { outputShape };
  return ENGINE.runKernel(SparseToDense, inputs, attrs);
}
const sparseToDense$2 = op({ sparseToDense_ });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherND_(x2, indices) {
  const $indices = convertToTensor(indices, "indices", "gatherND", "int32");
  const $x = convertToTensor(x2, "x", "gatherND", "string_or_numeric");
  const inputs = { params: $x, indices: $indices };
  return ENGINE.runKernel(GatherNd, inputs);
}
const gatherND = op({ gatherND_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getNoiseShape(x2, noiseShape) {
  if (noiseShape == null) {
    return x2.shape.slice();
  }
  if (arraysEqual(x2.shape, noiseShape)) {
    return noiseShape;
  }
  if (x2.shape.length === noiseShape.length) {
    const newDimension = [];
    for (let i2 = 0; i2 < x2.shape.length; i2++) {
      if (noiseShape[i2] == null && x2.shape[i2] != null) {
        newDimension.push(x2.shape[i2]);
      } else {
        newDimension.push(noiseShape[i2]);
      }
    }
    return newDimension;
  }
  return noiseShape;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function dropout_(x2, rate, noiseShape, seed) {
  const $x = convertToTensor(x2, "x", "dropout");
  assert$1($x.dtype === "float32", () => `x has to be a floating point tensor since it's going to be scaled, but got a ${$x.dtype} tensor instead.`);
  assert$1(rate >= 0 && rate < 1, () => `rate must be a float in the range [0, 1), but got ${rate}.`);
  if (rate === 0) {
    return x2 instanceof Tensor ? $x.clone() : $x;
  }
  const $noiseShape = getNoiseShape($x, noiseShape);
  const keepProb = 1 - rate;
  const multiplier = div$1(floor$2(add$1(randomUniform($noiseShape, 0, 1, "float32", seed), keepProb)), keepProb);
  return mul($x, multiplier);
}
const dropout$1 = op({ dropout_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function enclosingPowerOfTwo(value) {
  return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2))));
}
function cosineWindow(windowLength, a6, b2) {
  const even = 1 - windowLength % 2;
  const newValues = new Float32Array(windowLength);
  for (let i2 = 0; i2 < windowLength; ++i2) {
    const cosArg = 2 * Math.PI * i2 / (windowLength + even - 1);
    newValues[i2] = a6 - b2 * Math.cos(cosArg);
  }
  return tensor1d(newValues, "float32");
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2DBackpropFilter_(x2, dy, filterShape, strides, pad2, dataFormat = "NHWC", dimRoundingMode) {
  let x4D = x2;
  if (x2.rank === 3) {
    x4D = reshape$3(x2, [1, x2.shape[0], x2.shape[1], x2.shape[2]]);
  }
  let dy4D = dy;
  if (dy4D.rank === 3) {
    dy4D = reshape$3(dy, [1, dy.shape[0], dy.shape[1], dy.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in conv2dDerFilter: input must be rank 4, but got shape ${x4D.shape}.`);
  assert$1(dy4D.rank === 4, () => `Error in conv2dDerFilter: dy must be rank 4, but got shape ${dy4D.shape}.`);
  assert$1(filterShape.length === 4, () => `Error in conv2dDerFilter: filterShape must be length 4, but got ${filterShape}.`);
  const inDepth = dataFormat === "NHWC" ? x4D.shape[3] : x4D.shape[1];
  const outDepth = dataFormat === "NHWC" ? dy4D.shape[3] : dy4D.shape[1];
  assert$1(inDepth === filterShape[2], () => `Error in conv2dDerFilter: depth of input ${inDepth}) must match input depth in filter (${filterShape[2]}.`);
  assert$1(outDepth === filterShape[3], () => `Error in conv2dDerFilter: depth of dy (${outDepth}) must match output depth for filter (${filterShape[3]}).`);
  checkPadOnDimRoundingMode("conv2dDerFilter", pad2, dimRoundingMode);
  const inputs = { x: x4D, dy: dy4D };
  const attrs = { strides, pad: pad2, dataFormat, dimRoundingMode, filterShape };
  return ENGINE.runKernel(Conv2DBackpropFilter, inputs, attrs);
}
const conv2DBackpropFilter$2 = op({ conv2DBackpropFilter_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getFusedDyActivation(dy, y2, activation) {
  if (activation == null || activation === "linear") {
    return dy;
  }
  if (activation === "relu") {
    return mul(dy, step$3(y2));
  }
  throw new Error(`Cannot compute gradient for fused activation ${activation}.`);
}
function getFusedBiasGradient(bias, dyActivation) {
  let res = dyActivation;
  const reduceAxes = getReductionAxes(bias.shape, dyActivation.shape);
  if (reduceAxes.length > 0) {
    res = sum$3(res, reduceAxes);
  }
  return reshape$3(res, bias.shape);
}
function applyActivation$1(x2, activation, preluActivationWeights, leakyreluAlpha) {
  if (activation === "linear") {
    return x2;
  } else if (activation === "relu") {
    return relu$2(x2);
  } else if (activation === "elu") {
    return elu$3(x2);
  } else if (activation === "relu6") {
    return relu6$2(x2);
  } else if (activation === "prelu") {
    return prelu$3(x2, preluActivationWeights);
  } else if (activation === "leakyrelu") {
    return leakyRelu$3(x2, leakyreluAlpha);
  } else if (activation === "sigmoid") {
    return sigmoid$3(x2);
  }
  throw new Error(`Unknown fused activation ${activation}.`);
}
const shouldFuse = (gradientDepth, activation) => {
  const gradientMode = gradientDepth > 0;
  return !gradientMode || activation === "linear";
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedConv2d_({ x: x2, filter: filter2, strides, pad: pad2, dataFormat = "NHWC", dilations = [1, 1], dimRoundingMode, bias, activation = "linear", preluActivationWeights, leakyreluAlpha }) {
  activation = activation || "linear";
  if (shouldFuse(ENGINE.state.gradientDepth, activation) === false) {
    let result2 = conv2d$3(x2, filter2, strides, pad2, dataFormat, dilations, dimRoundingMode);
    if (bias != null) {
      result2 = add$1(result2, bias);
    }
    return applyActivation$1(result2, activation, preluActivationWeights, leakyreluAlpha);
  }
  const $x = convertToTensor(x2, "x", "conv2d", "float32");
  const $filter = convertToTensor(filter2, "filter", "conv2d", "float32");
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in fused conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
  assert$1($filter.rank === 4, () => `Error in fused conv2d: filter must be rank 4, but got rank ${$filter.rank}.`);
  checkPadOnDimRoundingMode("fused conv2d", pad2, dimRoundingMode);
  assert$1(x4D.shape[3] === $filter.shape[2], () => `Error in conv2d: depth of input (${x4D.shape[3]}) must match input depth for filter ${$filter.shape[2]}.`);
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in conv2D: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  assert$1(dataFormat === "NHWC", () => `Error in conv2d: got dataFormat of ${dataFormat} but only NHWC is currently supported.`);
  const convInfo = computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad2, dimRoundingMode);
  let $bias;
  if (bias != null) {
    $bias = convertToTensor(bias, "bias", "fused conv2d");
    [$bias] = makeTypesMatch($bias, $x);
    assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
  }
  let $preluActivationWeights;
  if (preluActivationWeights != null) {
    $preluActivationWeights = convertToTensor(preluActivationWeights, "prelu weights", "fused conv2d");
  }
  const grad = (dy, saved) => {
    const [$filter2, x4D2, y2, $bias2] = saved;
    const dyActivation = getFusedDyActivation(dy, y2, activation);
    assert$1(tupleValuesAreOne(dilations), () => `Error in gradient of fused conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${dilations}'`);
    const xDer = conv2DBackpropInput$3(x4D2.shape, dyActivation, $filter2, strides, pad2);
    const filterDer = conv2DBackpropFilter$2(x4D2, dyActivation, $filter2.shape, strides, pad2);
    const der = [xDer, filterDer];
    if ($bias2 != null) {
      const biasDer = getFusedBiasGradient($bias2, dyActivation);
      der.push(biasDer);
    }
    return der;
  };
  const inputs = {
    x: x4D,
    filter: $filter,
    bias: $bias,
    preluActivationWeights: $preluActivationWeights
  };
  const attrs = {
    strides,
    pad: pad2,
    dataFormat,
    dilations,
    dimRoundingMode,
    activation,
    leakyreluAlpha
  };
  if (bias == null) {
    const customOp = customGrad((x4D2, filter3, save) => {
      let res = ENGINE.runKernel(FusedConv2D, inputs, attrs);
      save([filter3, x4D2, res]);
      if (reshapedTo4D) {
        res = reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
      }
      return { value: res, gradFunc: grad };
    });
    return customOp(x4D, $filter);
  } else {
    const customOpWithBias = customGrad((x4D2, filter3, bias2, save) => {
      let res = ENGINE.runKernel(FusedConv2D, inputs, attrs);
      save([filter3, x4D2, res, bias2]);
      if (reshapedTo4D) {
        res = reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
      }
      return { value: res, gradFunc: grad };
    });
    return customOpWithBias(x4D, $filter, $bias);
  }
}
const conv2d$2 = op({ fusedConv2d_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNativeBackpropFilter_(x2, dy, filterShape, strides, pad2, dilations = [1, 1], dimRoundingMode) {
  let x4D = x2;
  if (x2.rank === 3) {
    x4D = reshape$3(x2, [1, x2.shape[0], x2.shape[1], x2.shape[2]]);
  }
  let dy4D = dy;
  if (dy4D.rank === 3) {
    dy4D = reshape$3(dy, [1, dy.shape[0], dy.shape[1], dy.shape[2]]);
  }
  const inputs = { x: x4D, dy: dy4D };
  const attrs = { strides, pad: pad2, dimRoundingMode, dilations, filterShape };
  return ENGINE.runKernel(DepthwiseConv2dNativeBackpropFilter, inputs, attrs);
}
const depthwiseConv2dNativeBackpropFilter$2 = op({ depthwiseConv2dNativeBackpropFilter_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNativeBackpropInput_(xShape, dy, filter2, strides, pad2, dilations = [1, 1], dimRoundingMode) {
  let dy4D = dy;
  let reshapedTo4D = false;
  if (dy.rank === 3) {
    reshapedTo4D = true;
    dy4D = reshape$3(dy, [1, dy.shape[0], dy.shape[1], dy.shape[2]]);
  }
  const inputs = { dy: dy4D, filter: filter2 };
  const attrs = { strides, pad: pad2, dimRoundingMode, dilations, inputShape: xShape };
  const res = ENGINE.runKernel(DepthwiseConv2dNativeBackpropInput, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const depthwiseConv2dNativeBackpropInput$2 = op({ depthwiseConv2dNativeBackpropInput_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedDepthwiseConv2d_({ x: x2, filter: filter2, strides, pad: pad2, dataFormat = "NHWC", dilations = [1, 1], dimRoundingMode, bias, activation = "linear", preluActivationWeights, leakyreluAlpha }) {
  if (shouldFuse(ENGINE.state.gradientDepth, activation) === false) {
    let result2 = depthwiseConv2d$3(x2, filter2, strides, pad2, dataFormat, dilations, dimRoundingMode);
    if (bias != null) {
      result2 = add$1(result2, bias);
    }
    return applyActivation$1(result2, activation, preluActivationWeights, leakyreluAlpha);
  }
  const $x = convertToTensor(x2, "x", "depthwiseConv2d", "float32");
  const $filter = convertToTensor(filter2, "filter", "depthwiseConv2d", "float32");
  let x4D = $x;
  let reshapedTo4D = false;
  if ($x.rank === 3) {
    reshapedTo4D = true;
    x4D = reshape$3($x, [1, $x.shape[0], $x.shape[1], $x.shape[2]]);
  }
  assert$1(x4D.rank === 4, () => `Error in fused depthwiseConv2d: input must be rank 4, but got rank ${x4D.rank}.`);
  assert$1($filter.rank === 4, () => `Error in fused depthwiseConv2d: filter must be rank 4, but got rank ${$filter.rank}.`);
  assert$1(x4D.shape[3] === $filter.shape[2], () => `Error in fused depthwiseConv2d: number of input channels (${x4D.shape[3]}) must match the inChannels dimension in filter ${$filter.shape[2]}.`);
  if (dilations == null) {
    dilations = [1, 1];
  }
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in fused depthwiseConv2d: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  checkPadOnDimRoundingMode("fused depthwiseConv2d", pad2, dimRoundingMode);
  const convInfo = computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad2, dimRoundingMode, true);
  let $bias;
  if (bias != null) {
    $bias = convertToTensor(bias, "bias", "fused conv2d");
    [$bias] = makeTypesMatch($bias, $x);
    assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
  }
  let $preluActivationWeights;
  if (preluActivationWeights != null) {
    $preluActivationWeights = convertToTensor(preluActivationWeights, "prelu weights", "fused depthwiseConv2d");
  }
  const grad = (dy, saved) => {
    assert$1(tupleValuesAreOne(dilations), () => `Error in gradient of fused depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '${dilations}'`);
    const [$filter2, x4D2, y2, bias2] = saved;
    const dyActivation = getFusedDyActivation(dy, y2, activation);
    const xDer = depthwiseConv2dNativeBackpropInput$2(x4D2.shape, dyActivation, $filter2, strides, pad2, dilations, dimRoundingMode);
    const filterDer = depthwiseConv2dNativeBackpropFilter$2(x4D2, dyActivation, $filter2.shape, strides, pad2, dilations, dimRoundingMode);
    if (bias2 != null) {
      const biasDer = getFusedBiasGradient($bias, dyActivation);
      return [xDer, filterDer, biasDer];
    }
    return [xDer, filterDer];
  };
  const inputs = {
    x: x4D,
    filter: $filter,
    bias: $bias,
    preluActivationWeights: $preluActivationWeights
  };
  const attrs = {
    strides,
    pad: pad2,
    dataFormat,
    dilations,
    dimRoundingMode,
    activation,
    leakyreluAlpha
  };
  if (bias == null) {
    const customOp = customGrad((x4D2, filter3, save) => {
      let res = ENGINE.runKernel(FusedDepthwiseConv2D, inputs, attrs);
      save([filter3, x4D2, res]);
      if (reshapedTo4D) {
        res = reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
      }
      return { value: res, gradFunc: grad };
    });
    return customOp(x4D, $filter);
  } else {
    const customOpWithBias = customGrad((x4D2, filter3, bias2, save) => {
      let res = ENGINE.runKernel(FusedDepthwiseConv2D, inputs, attrs);
      save([filter3, x4D2, res, bias2]);
      if (reshapedTo4D) {
        res = reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
      }
      return { value: res, gradFunc: grad };
    });
    return customOpWithBias(x4D, $filter, $bias);
  }
}
const depthwiseConv2d$2 = op({ fusedDepthwiseConv2d_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedMatMul_({ a: a6, b: b2, transposeA = false, transposeB = false, bias, activation = "linear", preluActivationWeights, leakyreluAlpha }) {
  if (shouldFuse(ENGINE.state.gradientDepth, activation) === false) {
    let result2 = matMul$1(a6, b2, transposeA, transposeB);
    if (bias != null) {
      result2 = add$1(result2, bias);
    }
    return applyActivation$1(result2, activation, preluActivationWeights, leakyreluAlpha);
  }
  let $a = convertToTensor(a6, "a", "fused matMul");
  let $b = convertToTensor(b2, "b", "fused matMul");
  [$a, $b] = makeTypesMatch($a, $b);
  const innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
  const innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
  const outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
  const outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
  const outerDimsA = $a.shape.slice(0, -2);
  const outerDimsB = $b.shape.slice(0, -2);
  const batchDimA = sizeFromShape(outerDimsA);
  const batchDimB = sizeFromShape(outerDimsB);
  assert$1(innerShapeA === innerShapeB, () => `Error in fused matMul: inner shapes (${innerShapeA}) and (${innerShapeB}) of Tensors with shapes ${$a.shape} and ${$b.shape} and transposeA=${transposeA} and transposeB=${transposeB} must match.`);
  const outShapeOuterDims = assertAndGetBroadcastShape($a.shape.slice(0, -2), $b.shape.slice(0, -2));
  const outShape = outShapeOuterDims.concat([outerShapeA, outerShapeB]);
  const a3D = transposeA ? reshape$3($a, [batchDimA, innerShapeA, outerShapeA]) : reshape$3($a, [batchDimA, outerShapeA, innerShapeA]);
  const b3D = transposeB ? reshape$3($b, [batchDimB, outerShapeB, innerShapeB]) : reshape$3($b, [batchDimB, innerShapeB, outerShapeB]);
  let $bias;
  if (bias != null) {
    $bias = convertToTensor(bias, "bias", "fused matMul");
    [$bias] = makeTypesMatch($bias, $a);
    assertAndGetBroadcastShape(outShape, $bias.shape);
  }
  let $preluActivationWeights;
  if (preluActivationWeights != null) {
    $preluActivationWeights = convertToTensor(preluActivationWeights, "prelu weights", "fused matMul");
  }
  const grad = (dy, saved) => {
    const [a3D2, b3D2, y2, $bias2] = saved;
    const dyActivation = getFusedDyActivation(reshape$3(dy, y2.shape), y2, activation);
    let aDer;
    let bDer;
    if (!transposeA && !transposeB) {
      aDer = matMul$1(dyActivation, b3D2, false, true);
      bDer = matMul$1(a3D2, dyActivation, true, false);
    } else if (!transposeA && transposeB) {
      aDer = matMul$1(dyActivation, b3D2, false, false);
      bDer = matMul$1(dyActivation, a3D2, true, false);
    } else if (transposeA && !transposeB) {
      aDer = matMul$1(b3D2, dyActivation, false, true);
      bDer = matMul$1(a3D2, dyActivation, false, false);
    } else {
      aDer = matMul$1(b3D2, dyActivation, true, true);
      bDer = matMul$1(dyActivation, a3D2, true, true);
    }
    if (bias != null) {
      const biasDer = getFusedBiasGradient($bias2, dyActivation);
      return [aDer, bDer, biasDer];
    } else {
      return [aDer, bDer];
    }
  };
  const inputs = {
    a: a3D,
    b: b3D,
    bias: $bias,
    preluActivationWeights: $preluActivationWeights
  };
  const attrs = { transposeA, transposeB, activation, leakyreluAlpha };
  if (bias == null) {
    const customOp = customGrad((a3D2, b3D2, save) => {
      const res = ENGINE.runKernel(_FusedMatMul, inputs, attrs);
      save([a3D2, b3D2, res]);
      return { value: reshape$3(res, outShape), gradFunc: grad };
    });
    return customOp(a3D, b3D);
  } else {
    const customOpWithBias = customGrad((a3D2, b3D2, $bias2, save) => {
      const res = ENGINE.runKernel(_FusedMatMul, inputs, attrs);
      save([a3D2, b3D2, res, $bias2]);
      return { value: reshape$3(res, outShape), gradFunc: grad };
    });
    return customOpWithBias(a3D, b3D, $bias);
  }
}
const matMul = op({ fusedMatMul_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function hammingWindow_(windowLength) {
  return cosineWindow(windowLength, 0.54, 0.46);
}
const hammingWindow = op({ hammingWindow_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function hannWindow_(windowLength) {
  return cosineWindow(windowLength, 0.5, 0.5);
}
const hannWindow = op({ hannWindow_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function frame_(signal, frameLength, frameStep, padEnd = false, padValue = 0) {
  let start = 0;
  const output2 = [];
  while (start + frameLength <= signal.size) {
    output2.push(slice$3(signal, start, frameLength));
    start += frameStep;
  }
  if (padEnd) {
    while (start < signal.size) {
      const padLen = start + frameLength - signal.size;
      const pad2 = concat$3([
        slice$3(signal, start, frameLength - padLen),
        fill$3([padLen], padValue)
      ]);
      output2.push(pad2);
      start += frameStep;
    }
  }
  if (output2.length === 0) {
    return tensor2d([], [0, frameLength]);
  }
  return reshape$3(concat$3(output2), [output2.length, frameLength]);
}
const frame$1 = op({ frame_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stft_(signal, frameLength, frameStep, fftLength, windowFn = hannWindow) {
  if (fftLength == null) {
    fftLength = enclosingPowerOfTwo(frameLength);
  }
  const framedSignal = frame$1(signal, frameLength, frameStep);
  const windowedSignal = mul(framedSignal, windowFn(frameLength));
  return rfft(windowedSignal, fftLength);
}
const stft = op({ stft_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cropAndResize_(image2, boxes, boxInd, cropSize, method2 = "bilinear", extrapolationValue = 0) {
  const $image = convertToTensor(image2, "image", "cropAndResize");
  const $boxes = convertToTensor(boxes, "boxes", "cropAndResize", "float32");
  const $boxInd = convertToTensor(boxInd, "boxInd", "cropAndResize", "int32");
  const numBoxes = $boxes.shape[0];
  assert$1($image.rank === 4, () => `Error in cropAndResize: image must be rank 4,but got rank ${$image.rank}.`);
  assert$1($boxes.rank === 2 && $boxes.shape[1] === 4, () => `Error in cropAndResize: boxes must be have size [${numBoxes},4] but had shape ${$boxes.shape}.`);
  assert$1($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, () => `Error in cropAndResize: boxInd must be have size [${numBoxes}] but had shape ${$boxes.shape}.`);
  assert$1(cropSize.length === 2, () => `Error in cropAndResize: cropSize must be of length 2, but got length ${cropSize.length}.`);
  assert$1(cropSize[0] >= 1 && cropSize[1] >= 1, () => `cropSize must be atleast [1,1], but was ${cropSize}`);
  assert$1(method2 === "bilinear" || method2 === "nearest", () => `method must be bilinear or nearest, but was ${method2}`);
  const inputs = { image: $image, boxes: $boxes, boxInd: $boxInd };
  const attrs = { method: method2, extrapolationValue, cropSize };
  const res = ENGINE.runKernel(CropAndResize, inputs, attrs);
  return res;
}
const cropAndResize$3 = op({ cropAndResize_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function flipLeftRight_(image2) {
  const $image = convertToTensor(image2, "image", "flipLeftRight", "float32");
  assert$1($image.rank === 4, () => `Error in flipLeftRight: image must be rank 4,but got rank ${$image.rank}.`);
  const inputs = { image: $image };
  const res = ENGINE.runKernel(FlipLeftRight, inputs, {});
  return res;
}
const flipLeftRight$1 = op({ flipLeftRight_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function grayscaleToRGB_(image2) {
  const $image = convertToTensor(image2, "image", "grayscaleToRGB");
  const lastDimsIdx = $image.rank - 1;
  const lastDims = $image.shape[lastDimsIdx];
  assert$1($image.rank >= 2, () => `Error in grayscaleToRGB: images must be at least rank 2, but got rank ${$image.rank}.`);
  assert$1(lastDims === 1, () => `Error in grayscaleToRGB: last dimension of a grayscale image should be size 1, but got size ${lastDims}.`);
  const reps = new Array($image.rank);
  reps.fill(1, 0, lastDimsIdx);
  reps[lastDimsIdx] = 3;
  return tile$4($image, reps);
}
const grayscaleToRGB = op({ grayscaleToRGB_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function rotateWithOffset_(image2, radians, fillValue = 0, center = 0.5) {
  const $image = convertToTensor(image2, "image", "rotateWithOffset", "float32");
  assert$1($image.rank === 4, () => `Error in rotateWithOffset: image must be rank 4,but got rank ${$image.rank}.`);
  const inputs = { image: $image };
  const attrs = { radians, fillValue, center };
  const res = ENGINE.runKernel(RotateWithOffset, inputs, attrs);
  return res;
}
const rotateWithOffset$1 = op({ rotateWithOffset_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function nonMaxSuppSanityCheck(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
  if (iouThreshold == null) {
    iouThreshold = 0.5;
  }
  if (scoreThreshold == null) {
    scoreThreshold = Number.NEGATIVE_INFINITY;
  }
  if (softNmsSigma == null) {
    softNmsSigma = 0;
  }
  const numBoxes = boxes.shape[0];
  maxOutputSize = Math.min(maxOutputSize, numBoxes);
  assert$1(0 <= iouThreshold && iouThreshold <= 1, () => `iouThreshold must be in [0, 1], but was '${iouThreshold}'`);
  assert$1(boxes.rank === 2, () => `boxes must be a 2D tensor, but was of rank '${boxes.rank}'`);
  assert$1(boxes.shape[1] === 4, () => `boxes must have 4 columns, but 2nd dimension was ${boxes.shape[1]}`);
  assert$1(scores.rank === 1, () => "scores must be a 1D tensor");
  assert$1(scores.shape[0] === numBoxes, () => `scores has incompatible shape with boxes. Expected ${numBoxes}, but was ${scores.shape[0]}`);
  assert$1(0 <= softNmsSigma && softNmsSigma <= 1, () => `softNmsSigma must be in [0, 1], but was '${softNmsSigma}'`);
  return { maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
  const $boxes = convertToTensor(boxes, "boxes", "nonMaxSuppression", "float32");
  const $scores = convertToTensor(scores, "scores", "nonMaxSuppression", "float32");
  const inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
  maxOutputSize = inputs.maxOutputSize;
  iouThreshold = inputs.iouThreshold;
  scoreThreshold = inputs.scoreThreshold;
  const attrs = { maxOutputSize, iouThreshold, scoreThreshold };
  return ENGINE.runKernel(NonMaxSuppressionV3, { boxes: $boxes, scores: $scores }, attrs);
}
const nonMaxSuppression = op({ nonMaxSuppression_ });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function binaryInsert(arr2, element, comparator) {
  const index2 = binarySearch(arr2, element, comparator);
  const insertionPoint = index2 < 0 ? -(index2 + 1) : index2;
  arr2.splice(insertionPoint, 0, element);
}
function binarySearch(arr2, target, comparator) {
  return binarySearch_(arr2, target, comparator || defaultComparator);
}
function defaultComparator(a6, b2) {
  return a6 > b2 ? 1 : a6 < b2 ? -1 : 0;
}
function binarySearch_(arr2, target, comparator) {
  let left2 = 0;
  let right = arr2.length;
  let middle = 0;
  let found = false;
  while (left2 < right) {
    middle = left2 + (right - left2 >>> 1);
    const compareResult = comparator(target, arr2[middle]);
    if (compareResult > 0) {
      left2 = middle + 1;
    } else {
      right = middle;
      found = !compareResult;
    }
  }
  return found ? left2 : -left2 - 1;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function nonMaxSuppressionV3Impl$2(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
  return nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0);
}
function nonMaxSuppressionV4Impl$2(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize) {
  return nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0, false, padToMaxOutputSize, true);
}
function nonMaxSuppressionV5Impl$2(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
  return nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, true);
}
function nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor = false, padToMaxOutputSize = false, returnValidOutputs = false) {
  const candidates = [];
  for (let i2 = 0; i2 < scores.length; i2++) {
    if (scores[i2] > scoreThreshold) {
      candidates.push({ score: scores[i2], boxIndex: i2, suppressBeginIndex: 0 });
    }
  }
  candidates.sort(ascendingComparator);
  const scale2 = softNmsSigma > 0 ? -0.5 / softNmsSigma : 0;
  const selectedIndices = [];
  const selectedScores = [];
  while (selectedIndices.length < maxOutputSize && candidates.length > 0) {
    const candidate = candidates.pop();
    const { score: originalScore, boxIndex, suppressBeginIndex } = candidate;
    if (originalScore < scoreThreshold) {
      break;
    }
    let ignoreCandidate = false;
    for (let j2 = selectedIndices.length - 1; j2 >= suppressBeginIndex; --j2) {
      const iou = intersectionOverUnion(boxes, boxIndex, selectedIndices[j2]);
      if (iou >= iouThreshold) {
        ignoreCandidate = true;
        break;
      }
      candidate.score = candidate.score * suppressWeight(iouThreshold, scale2, iou);
      if (candidate.score <= scoreThreshold) {
        break;
      }
    }
    candidate.suppressBeginIndex = selectedIndices.length;
    if (!ignoreCandidate) {
      if (candidate.score === originalScore) {
        selectedIndices.push(boxIndex);
        selectedScores.push(candidate.score);
      } else if (candidate.score > scoreThreshold) {
        binaryInsert(candidates, candidate, ascendingComparator);
      }
    }
  }
  const validOutputs = selectedIndices.length;
  const elemsToPad = maxOutputSize - validOutputs;
  if (padToMaxOutputSize && elemsToPad > 0) {
    selectedIndices.push(...new Array(elemsToPad).fill(0));
    selectedScores.push(...new Array(elemsToPad).fill(0));
  }
  const result2 = { selectedIndices };
  if (returnScoresTensor) {
    result2["selectedScores"] = selectedScores;
  }
  if (returnValidOutputs) {
    result2["validOutputs"] = validOutputs;
  }
  return result2;
}
function intersectionOverUnion(boxes, i2, j2) {
  const iCoord = boxes.subarray(i2 * 4, i2 * 4 + 4);
  const jCoord = boxes.subarray(j2 * 4, j2 * 4 + 4);
  const yminI = Math.min(iCoord[0], iCoord[2]);
  const xminI = Math.min(iCoord[1], iCoord[3]);
  const ymaxI = Math.max(iCoord[0], iCoord[2]);
  const xmaxI = Math.max(iCoord[1], iCoord[3]);
  const yminJ = Math.min(jCoord[0], jCoord[2]);
  const xminJ = Math.min(jCoord[1], jCoord[3]);
  const ymaxJ = Math.max(jCoord[0], jCoord[2]);
  const xmaxJ = Math.max(jCoord[1], jCoord[3]);
  const areaI = (ymaxI - yminI) * (xmaxI - xminI);
  const areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
  if (areaI <= 0 || areaJ <= 0) {
    return 0;
  }
  const intersectionYmin = Math.max(yminI, yminJ);
  const intersectionXmin = Math.max(xminI, xminJ);
  const intersectionYmax = Math.min(ymaxI, ymaxJ);
  const intersectionXmax = Math.min(xmaxI, xmaxJ);
  const intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0) * Math.max(intersectionXmax - intersectionXmin, 0);
  return intersectionArea / (areaI + areaJ - intersectionArea);
}
function suppressWeight(iouThreshold, scale2, iou) {
  const weight = Math.exp(scale2 * iou * iou);
  return iou <= iouThreshold ? weight : 0;
}
function ascendingComparator(c1, c2) {
  return c1.score - c2.score || c1.score === c2.score && c2.boxIndex - c1.boxIndex;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
async function nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
  const $boxes = convertToTensor(boxes, "boxes", "nonMaxSuppressionAsync");
  const $scores = convertToTensor(scores, "scores", "nonMaxSuppressionAsync");
  const inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
  maxOutputSize = inputs.maxOutputSize;
  iouThreshold = inputs.iouThreshold;
  scoreThreshold = inputs.scoreThreshold;
  const boxesAndScores = await Promise.all([$boxes.data(), $scores.data()]);
  const boxesVals = boxesAndScores[0];
  const scoresVals = boxesAndScores[1];
  const { selectedIndices } = nonMaxSuppressionV3Impl$2(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
  if ($boxes !== boxes) {
    $boxes.dispose();
  }
  if ($scores !== scores) {
    $scores.dispose();
  }
  return tensor1d(selectedIndices, "int32");
}
const nonMaxSuppressionAsync = nonMaxSuppressionAsync_;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0) {
  const $boxes = convertToTensor(boxes, "boxes", "nonMaxSuppression");
  const $scores = convertToTensor(scores, "scores", "nonMaxSuppression");
  const params = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
  maxOutputSize = params.maxOutputSize;
  iouThreshold = params.iouThreshold;
  scoreThreshold = params.scoreThreshold;
  softNmsSigma = params.softNmsSigma;
  const inputs = { boxes: $boxes, scores: $scores };
  const attrs = { maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma };
  const result2 = ENGINE.runKernel(NonMaxSuppressionV5, inputs, attrs);
  return { selectedIndices: result2[0], selectedScores: result2[1] };
}
const nonMaxSuppressionWithScore = op({ nonMaxSuppressionWithScore_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
async function nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0) {
  const $boxes = convertToTensor(boxes, "boxes", "nonMaxSuppressionAsync");
  const $scores = convertToTensor(scores, "scores", "nonMaxSuppressionAsync");
  const params = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
  maxOutputSize = params.maxOutputSize;
  iouThreshold = params.iouThreshold;
  scoreThreshold = params.scoreThreshold;
  softNmsSigma = params.softNmsSigma;
  const boxesAndScores = await Promise.all([$boxes.data(), $scores.data()]);
  const boxesVals = boxesAndScores[0];
  const scoresVals = boxesAndScores[1];
  const { selectedIndices, selectedScores } = nonMaxSuppressionV5Impl$2(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
  if ($boxes !== boxes) {
    $boxes.dispose();
  }
  if ($scores !== scores) {
    $scores.dispose();
  }
  return {
    selectedIndices: tensor1d(selectedIndices, "int32"),
    selectedScores: tensor1d(selectedScores)
  };
}
const nonMaxSuppressionWithScoreAsync = nonMaxSuppressionWithScoreAsync_;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function nonMaxSuppressionPadded_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
  const $boxes = convertToTensor(boxes, "boxes", "nonMaxSuppression");
  const $scores = convertToTensor(scores, "scores", "nonMaxSuppression");
  const params = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
  const $maxOutputSize = params.maxOutputSize;
  const $iouThreshold = params.iouThreshold;
  const $scoreThreshold = params.scoreThreshold;
  const inputs = { boxes: $boxes, scores: $scores };
  const attrs = {
    maxOutputSize: $maxOutputSize,
    iouThreshold: $iouThreshold,
    scoreThreshold: $scoreThreshold,
    padToMaxOutputSize
  };
  const result2 = ENGINE.runKernel(NonMaxSuppressionV4, inputs, attrs);
  return { selectedIndices: result2[0], validOutputs: result2[1] };
}
const nonMaxSuppressionPadded = op({ nonMaxSuppressionPadded_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
async function nonMaxSuppressionPaddedAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
  const $boxes = convertToTensor(boxes, "boxes", "nonMaxSuppressionAsync");
  const $scores = convertToTensor(scores, "scores", "nonMaxSuppressionAsync");
  const params = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
  const $maxOutputSize = params.maxOutputSize;
  const $iouThreshold = params.iouThreshold;
  const $scoreThreshold = params.scoreThreshold;
  const [boxesVals, scoresVals] = await Promise.all([$boxes.data(), $scores.data()]);
  const { selectedIndices, validOutputs } = nonMaxSuppressionV4Impl$2(boxesVals, scoresVals, $maxOutputSize, $iouThreshold, $scoreThreshold, padToMaxOutputSize);
  if ($boxes !== boxes) {
    $boxes.dispose();
  }
  if ($scores !== scores) {
    $scores.dispose();
  }
  return {
    selectedIndices: tensor1d(selectedIndices, "int32"),
    validOutputs: scalar(validOutputs, "int32")
  };
}
const nonMaxSuppressionPaddedAsync = nonMaxSuppressionPaddedAsync_;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeBilinear_(images, size, alignCorners = false, halfPixelCenters = false) {
  const $images = convertToTensor(images, "images", "resizeBilinear");
  assert$1($images.rank === 3 || $images.rank === 4, () => `Error in resizeBilinear: x must be rank 3 or 4, but got rank ${$images.rank}.`);
  assert$1(size.length === 2, () => `Error in resizeBilinear: new shape must 2D, but got shape ${size}.`);
  assert$1(halfPixelCenters === false || alignCorners === false, () => `Error in resizeBilinear: If halfPixelCenters is true, alignCorners must be false.`);
  let batchImages = $images;
  let reshapedTo4D = false;
  if ($images.rank === 3) {
    reshapedTo4D = true;
    batchImages = reshape$3($images, [1, $images.shape[0], $images.shape[1], $images.shape[2]]);
  }
  const inputs = { images: batchImages };
  const attrs = { alignCorners, halfPixelCenters, size };
  const res = ENGINE.runKernel(ResizeBilinear, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const resizeBilinear$3 = op({ resizeBilinear_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeNearestNeighbor_(images, size, alignCorners = false, halfPixelCenters = false) {
  const $images = convertToTensor(images, "images", "resizeNearestNeighbor");
  assert$1($images.rank === 3 || $images.rank === 4, () => `Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank ${$images.rank}.`);
  assert$1(size.length === 2, () => `Error in resizeNearestNeighbor: new shape must 2D, but got shape ${size}.`);
  assert$1($images.dtype === "float32" || $images.dtype === "int32", () => "`images` must have `int32` or `float32` as dtype");
  assert$1(halfPixelCenters === false || alignCorners === false, () => `Error in resizeNearestNeighbor: If halfPixelCenters is true, alignCorners must be false.`);
  let batchImages = $images;
  let reshapedTo4D = false;
  if ($images.rank === 3) {
    reshapedTo4D = true;
    batchImages = reshape$3($images, [1, $images.shape[0], $images.shape[1], $images.shape[2]]);
  }
  const inputs = { images: batchImages };
  const attrs = { alignCorners, halfPixelCenters, size };
  const res = ENGINE.runKernel(ResizeNearestNeighbor, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const resizeNearestNeighbor$2 = op({ resizeNearestNeighbor_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function threshold_(image2, method2 = "binary", inverted = false, threshValue = 0.5) {
  const $image = convertToTensor(image2, "image", "threshold");
  const RED_INTENCITY_COEF = 0.2989;
  const GREEN_INTENCITY_COEF = 0.587;
  const BLUE_INTENCITY_COEF = 0.114;
  const totalPixelsInImage = $image.shape[0] * $image.shape[1];
  let $threshold = mul(tensor1d([threshValue]), 255);
  let r2, g2, b2, grayscale;
  assert$1($image.rank === 3, () => `Error in threshold: image must be rank 3,but got rank ${$image.rank}.`);
  assert$1($image.shape[2] === 3 || $image.shape[2] === 1, () => `Error in threshold: image color channel must be equal to 3 or 1but got ${$image.shape[2]}.`);
  assert$1($image.dtype === "int32" || $image.dtype === "float32", () => `Error in dtype: image dtype must be int32 or float32,but got dtype ${$image.dtype}.`);
  assert$1(method2 === "otsu" || method2 === "binary", () => `Method must be binary or otsu, but was ${method2}`);
  if ($image.shape[2] === 3) {
    [r2, g2, b2] = split$2($image, [1, 1, 1], -1);
    const $r = mul(r2, RED_INTENCITY_COEF);
    const $g = mul(g2, GREEN_INTENCITY_COEF);
    const $b = mul(b2, BLUE_INTENCITY_COEF);
    grayscale = add$1(add$1($r, $g), $b);
  } else {
    grayscale = image2;
  }
  if (method2 === "otsu") {
    const $histogram = bincount$2(cast$4(round$2(grayscale), "int32"), tensor([]), 256);
    $threshold = otsu($histogram, totalPixelsInImage);
  }
  const invCondition = inverted ? lessEqual$2(grayscale, $threshold) : greater$2(grayscale, $threshold);
  const result2 = cast$4(mul(invCondition, 255), "int32");
  return result2;
}
function otsu(histogram, total) {
  let bestThresh = tensor1d([-1]);
  let bestInBetVar = tensor1d([0]);
  let cInBetVar = tensor1d([0]);
  let classFirst, classSecond, meanFirst, meanSec, weightForeground, weightBack;
  for (let index2 = 0; index2 < histogram.size - 1; index2++) {
    classFirst = slice$3(histogram, 0, index2 + 1);
    classSecond = slice$3(histogram, index2 + 1);
    weightForeground = div$1(sum$3(classFirst), total);
    weightBack = div$1(sum$3(classSecond), total);
    const meanFirstDivA = sum$3(mul(classFirst, range$4(0, classFirst.size)));
    meanFirst = div$1(meanFirstDivA, sum$3(classFirst));
    const meanSecFill = fill$3(classSecond.shape, classFirst.size);
    const meanSecAdd = add$1(range$4(0, classSecond.size), meanSecFill);
    const meanSecMul = mul(classSecond, meanSecAdd);
    meanSec = div$1(sum$3(meanSecMul), sum$3(classSecond));
    const cInBetVarSubA = sub$2(meanFirst, meanSec);
    const cInBetVarSubB = sub$2(meanFirst, meanSec);
    const cInBetVarMul = mul(weightForeground, weightBack);
    cInBetVar = mul(mul(cInBetVarMul, cInBetVarSubA), cInBetVarSubB);
    const condition = greater$2(cInBetVar, bestInBetVar);
    bestInBetVar = where(condition, cInBetVar, bestInBetVar);
    bestThresh = where(condition, tensor1d([index2]), bestThresh);
  }
  return bestThresh;
}
const threshold$1 = op({ threshold_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transform_(image2, transforms, interpolation = "nearest", fillMode = "constant", fillValue = 0, outputShape) {
  const $image = convertToTensor(image2, "image", "transform", "float32");
  const $transforms = convertToTensor(transforms, "transforms", "transform", "float32");
  assert$1($image.rank === 4, () => `Error in transform: image must be rank 4,but got rank ${$image.rank}.`);
  assert$1($transforms.rank === 2 && ($transforms.shape[0] === $image.shape[0] || $transforms.shape[0] === 1) && $transforms.shape[1] === 8, () => `Error in transform: Input transform should be batch x 8 or 1 x 8`);
  assert$1(outputShape == null || outputShape.length === 2, () => `Error in transform: outputShape must be [height, width] or null, but got ${outputShape}.`);
  const inputs = { image: $image, transforms: $transforms };
  const attrs = { interpolation, fillMode, fillValue, outputShape };
  return ENGINE.runKernel(Transform, inputs, attrs);
}
const transform$3 = op({ transform_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function bandPart_(a6, numLower, numUpper) {
  assert$1(numLower % 1 === 0, () => `bandPart(): numLower must be an integer, got ${numLower}.`);
  assert$1(numUpper % 1 === 0, () => `bandPart(): numUpper must be an integer, got ${numUpper}.`);
  const $a = convertToTensor(a6, "a", "bandPart");
  assert$1($a.rank >= 2, () => `bandPart(): Rank must be at least 2, got ${$a.rank}.`);
  const shape = $a.shape;
  const [M2, N2] = $a.shape.slice(-2);
  if (!(numLower <= M2)) {
    throw new Error(`bandPart(): numLower (${numLower}) must not be greater than the number of rows (${M2}).`);
  }
  if (!(numUpper <= N2)) {
    throw new Error(`bandPart(): numUpper (${numUpper}) must not be greater than the number of columns (${N2}).`);
  }
  if (numLower < 0) {
    numLower = M2;
  }
  if (numUpper < 0) {
    numUpper = N2;
  }
  const i2 = reshape$3(range$4(0, M2, 1, "int32"), [-1, 1]);
  const j2 = range$4(0, N2, 1, "int32");
  const ij = sub$2(i2, j2);
  const inBand = logicalAnd$2(lessEqual$2(ij, scalar(+numLower, "int32")), greaterEqual$2(ij, scalar(-numUpper, "int32")));
  const zero2 = zeros$1([M2, N2], $a.dtype);
  return reshape$3(stack(unstack(reshape$3($a, [-1, M2, N2])).map((mat) => where(inBand, mat, zero2))), shape);
}
const bandPart = op({ bandPart_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gramSchmidt_(xs) {
  let inputIsTensor2D;
  if (Array.isArray(xs)) {
    inputIsTensor2D = false;
    assert$1(xs != null && xs.length > 0, () => "Gram-Schmidt process: input must not be null, undefined, or empty");
    const dim = xs[0].shape[0];
    for (let i2 = 1; i2 < xs.length; ++i2) {
      assert$1(xs[i2].shape[0] === dim, () => `Gram-Schmidt: Non-unique lengths found in the input vectors: (${xs[i2].shape[0]} vs. ${dim})`);
    }
  } else {
    inputIsTensor2D = true;
    xs = split$2(xs, xs.shape[0], 0).map((x2) => squeeze(x2, [0]));
  }
  assert$1(xs.length <= xs[0].shape[0], () => `Gram-Schmidt: Number of vectors (${xs.length}) exceeds number of dimensions (${xs[0].shape[0]}).`);
  const ys = [];
  const xs1d = xs;
  for (let i2 = 0; i2 < xs.length; ++i2) {
    ys.push(ENGINE.tidy(() => {
      let x2 = xs1d[i2];
      if (i2 > 0) {
        for (let j2 = 0; j2 < i2; ++j2) {
          const proj = mul(sum$3(mul(ys[j2], x2)), ys[j2]);
          x2 = sub$2(x2, proj);
        }
      }
      return div$1(x2, norm(x2, "euclidean"));
    }));
  }
  if (inputIsTensor2D) {
    return stack(ys, 0);
  } else {
    return ys;
  }
}
const gramSchmidt = op({ gramSchmidt_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function qr_(x2, fullMatrices = false) {
  assert$1(x2.rank >= 2, () => `qr() requires input tensor to have a rank >= 2, but got rank ${x2.rank}`);
  if (x2.rank === 2) {
    return qr2d(x2, fullMatrices);
  } else {
    const outerDimsProd = x2.shape.slice(0, x2.shape.length - 2).reduce((value, prev) => value * prev);
    const x2ds = unstack(reshape$3(x2, [
      outerDimsProd,
      x2.shape[x2.shape.length - 2],
      x2.shape[x2.shape.length - 1]
    ]), 0);
    const q2ds = [];
    const r2ds = [];
    x2ds.forEach((x2d) => {
      const [q2d, r2d] = qr2d(x2d, fullMatrices);
      q2ds.push(q2d);
      r2ds.push(r2d);
    });
    const q2 = reshape$3(stack(q2ds, 0), x2.shape);
    const r2 = reshape$3(stack(r2ds, 0), x2.shape);
    return [q2, r2];
  }
}
function qr2d(x2, fullMatrices = false) {
  return ENGINE.tidy(() => {
    assert$1(x2.shape.length === 2, () => `qr2d() requires a 2D Tensor, but got a ${x2.shape.length}D Tensor.`);
    const m2 = x2.shape[0];
    const n2 = x2.shape[1];
    let q2 = eye(m2);
    let r2 = clone(x2);
    const one2D = tensor2d([[1]], [1, 1]);
    let w2 = clone(one2D);
    const iters = m2 >= n2 ? n2 : m2;
    for (let j2 = 0; j2 < iters; ++j2) {
      const rTemp = r2;
      const wTemp = w2;
      const qTemp = q2;
      [w2, r2, q2] = ENGINE.tidy(() => {
        const rjEnd1 = slice$3(r2, [j2, j2], [m2 - j2, 1]);
        const normX = norm(rjEnd1);
        const rjj = slice$3(r2, [j2, j2], [1, 1]);
        const s2 = where(greater$2(rjj, 0), tensor2d([[-1]]), tensor2d([[1]]));
        const u1 = sub$2(rjj, mul(s2, normX));
        const wPre = div$1(rjEnd1, u1);
        if (wPre.shape[0] === 1) {
          w2 = clone(one2D);
        } else {
          w2 = concat$3([
            one2D,
            slice$3(wPre, [1, 0], [wPre.shape[0] - 1, wPre.shape[1]])
          ], 0);
        }
        const tau = neg$2(div$1(matMul$1(s2, u1), normX));
        const rjEndAll = slice$3(r2, [j2, 0], [m2 - j2, n2]);
        const tauTimesW = mul(tau, w2);
        const wT = transpose$3(w2);
        if (j2 === 0) {
          r2 = sub$2(rjEndAll, matMul$1(tauTimesW, matMul$1(wT, rjEndAll)));
        } else {
          const rTimesTau = sub$2(rjEndAll, matMul$1(tauTimesW, matMul$1(wT, rjEndAll)));
          r2 = concat$3([slice$3(r2, [0, 0], [j2, n2]), rTimesTau], 0);
        }
        const tawTimesWT = transpose$3(tauTimesW);
        const qAllJEnd = slice$3(q2, [0, j2], [m2, q2.shape[1] - j2]);
        if (j2 === 0) {
          q2 = sub$2(qAllJEnd, matMul$1(matMul$1(qAllJEnd, w2), tawTimesWT));
        } else {
          const qTimesTau = sub$2(qAllJEnd, matMul$1(matMul$1(qAllJEnd, w2), tawTimesWT));
          q2 = concat$3([slice$3(q2, [0, 0], [m2, j2]), qTimesTau], 1);
        }
        return [w2, r2, q2];
      });
      dispose([rTemp, wTemp, qTemp]);
    }
    if (!fullMatrices && m2 > n2) {
      q2 = slice$3(q2, [0, 0], [m2, n2]);
      r2 = slice$3(r2, [0, 0], [n2, n2]);
    }
    return [q2, r2];
  });
}
const qr = op({ qr_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var Reduction;
(function(Reduction2) {
  Reduction2[Reduction2["NONE"] = 0] = "NONE";
  Reduction2[Reduction2["MEAN"] = 1] = "MEAN";
  Reduction2[Reduction2["SUM"] = 2] = "SUM";
  Reduction2[Reduction2["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
})(Reduction || (Reduction = {}));
function computeWeightedLoss_(losses, weights, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  const $losses = convertToTensor(losses, "losses", "computeWeightedLoss");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "computeWeightedLoss");
  }
  const weightedLoss = $weights == null ? $losses : mul($losses, $weights);
  if (reduction2 === Reduction.NONE) {
    return weightedLoss;
  }
  if (reduction2 === Reduction.SUM) {
    return sum$3(weightedLoss);
  }
  if (reduction2 === Reduction.MEAN) {
    if ($weights == null) {
      return mean$2(weightedLoss);
    } else {
      const broadcastFactor = $losses.size / $weights.size;
      const result2 = div$1(sum$3(weightedLoss), sum$3($weights));
      return broadcastFactor > 1 ? div$1(result2, scalar(broadcastFactor)) : result2;
    }
  }
  if (reduction2 === Reduction.SUM_BY_NONZERO_WEIGHTS) {
    if ($weights == null) {
      return div$1(sum$3(weightedLoss), scalar($losses.size));
    } else {
      const broadcastedWeights = mul($weights, ones($losses.shape));
      const numNonZeros = cast$4(sum$3(notEqual$2(broadcastedWeights, scalar(0))), "float32");
      return div$1(sum$3(weightedLoss), numNonZeros);
    }
  }
  throw Error(`Unknown reduction: ${reduction2}`);
}
const computeWeightedLoss$1 = op({ computeWeightedLoss_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function absoluteDifference_(labels, predictions, weights, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  const $labels = convertToTensor(labels, "labels", "absoluteDifference");
  const $predictions = convertToTensor(predictions, "predictions", "absoluteDifference");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "absoluteDifference");
  }
  assertShapesMatch($labels.shape, $predictions.shape, "Error in absoluteDifference: ");
  const losses = abs$2(sub$2($labels, $predictions));
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const absoluteDifference = op({ absoluteDifference_ });
function cosineDistance_(labels, predictions, axis, weights, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  const $labels = convertToTensor(labels, "labels", "cosineDistance");
  const $predictions = convertToTensor(predictions, "predictions", "cosineDistance");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "cosineDistance");
  }
  assertShapesMatch($labels.shape, $predictions.shape, "Error in cosineDistance: ");
  const one = scalar(1);
  const losses = sub$2(one, sum$3(mul($labels, $predictions), axis, true));
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const cosineDistance = op({ cosineDistance_ });
function hingeLoss_(labels, predictions, weights, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  let $labels = convertToTensor(labels, "labels", "hingeLoss");
  const $predictions = convertToTensor(predictions, "predictions", "hingeLoss");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "hingeLoss");
  }
  assertShapesMatch($labels.shape, $predictions.shape, "Error in hingeLoss: ");
  const one = scalar(1);
  $labels = sub$2(mul(scalar(2), $labels), one);
  const losses = relu$2(sub$2(one, mul($labels, $predictions)));
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const hingeLoss = op({ hingeLoss_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function huberLoss_(labels, predictions, weights, delta = 1, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  const $labels = convertToTensor(labels, "labels", "huberLoss");
  const $predictions = convertToTensor(predictions, "predictions", "huberLoss");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "huberLoss");
  }
  assertShapesMatch($labels.shape, $predictions.shape, "Error in huberLoss: ");
  const deltaScalar = scalar(delta);
  const error3 = abs$2(sub$2($predictions, $labels));
  const quadratic = minimum$2(error3, deltaScalar);
  const linear2 = sub$2(error3, quadratic);
  const losses = add$1(mul(scalar(0.5), square$2(quadratic)), mul(deltaScalar, linear2));
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const huberLoss = op({ huberLoss_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function logLoss_(labels, predictions, weights, epsilon2 = 1e-7, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  const $labels = convertToTensor(labels, "labels", "logLoss");
  const $predictions = convertToTensor(predictions, "predictions", "logLoss");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "logLoss");
  }
  assertShapesMatch($labels.shape, $predictions.shape, "Error in logLoss: ");
  const one = scalar(1);
  const epsilonScalar = scalar(epsilon2);
  const l1 = neg$2(mul($labels, log$7(add$1($predictions, epsilonScalar))));
  const l2 = mul(sub$2(one, $labels), log$7(add$1(sub$2(one, $predictions), epsilonScalar)));
  const losses = sub$2(l1, l2);
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const logLoss = op({ logLoss_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function meanSquaredError_(labels, predictions, weights, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  const $labels = convertToTensor(labels, "labels", "meanSquaredError");
  const $predictions = convertToTensor(predictions, "predictions", "meanSquaredError");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "meanSquaredError");
  }
  assertShapesMatch($labels.shape, $predictions.shape, "Error in meanSquaredError: ");
  const losses = squaredDifference$2($labels, $predictions);
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const meanSquaredError$1 = op({ meanSquaredError_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sigmoidCrossEntropyWithLogits_(labels, logits) {
  const $labels = convertToTensor(labels, "labels", "sigmoidCrossEntropyWithLogits");
  const $logits = convertToTensor(logits, "logits", "sigmoidCrossEntropyWithLogits");
  assertShapesMatch($labels.shape, $logits.shape, "Error in sigmoidCrossEntropyWithLogits: ");
  const maxOutput = relu$2($logits);
  const outputXTarget = mul($logits, $labels);
  const sigmoidOutput = log1p$2(exp$2(neg$2(abs$2($logits))));
  return add$1(sub$2(maxOutput, outputXTarget), sigmoidOutput);
}
function sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing = 0, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  let $multiClassLabels = convertToTensor(multiClassLabels, "multiClassLabels", "sigmoidCrossEntropy");
  const $logits = convertToTensor(logits, "logits", "sigmoidCrossEntropy");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "sigmoidCrossEntropy");
  }
  assertShapesMatch($multiClassLabels.shape, $logits.shape, "Error in sigmoidCrossEntropy: ");
  if (labelSmoothing > 0) {
    const labelSmoothingScalar = scalar(labelSmoothing);
    const one = scalar(1);
    const half = scalar(0.5);
    $multiClassLabels = add$1(mul($multiClassLabels, sub$2(one, labelSmoothingScalar)), mul(half, labelSmoothingScalar));
  }
  const losses = sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const sigmoidCrossEntropy = op({ sigmoidCrossEntropy_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function softmaxCrossEntropyWithLogits_(labels, logits, dim = -1) {
  if (dim === -1) {
    dim = logits.rank - 1;
  }
  if (dim !== logits.rank - 1) {
    throw Error(`Softmax cross entropy along a non-last dimension is not yet supported. Labels / logits was rank ${logits.rank} and dim was ${dim}`);
  }
  const customOp = customGrad((labels2, logits2, save) => {
    const keepDims = true;
    const lse = logSumExp(logits2, [dim], keepDims);
    const logResult = sub$2(cast$4(logits2, "float32"), lse);
    save([labels2, logResult]);
    const costVector = neg$2(mul(logResult, labels2));
    const value = sum$3(costVector, [dim]);
    const gradFunc = (dy, saved) => {
      const [labels3, logResult2] = saved;
      const dyShape = expandShapeToKeepDim(dy.shape, [dim]);
      return [
        mul(reshape$3(dy, dyShape), sub$2(cast$4(labels3, "float32"), exp$2(logResult2))),
        mul(reshape$3(dy, dyShape), sub$2(exp$2(logResult2), cast$4(labels3, "float32")))
      ];
    };
    return { value, gradFunc };
  });
  return customOp(labels, logits);
}
function softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing = 0, reduction2 = Reduction.SUM_BY_NONZERO_WEIGHTS) {
  let $onehotLabels = convertToTensor(onehotLabels, "onehotLabels", "softmaxCrossEntropy");
  const $logits = convertToTensor(logits, "logits", "softmaxCrossEntropy");
  let $weights = null;
  if (weights != null) {
    $weights = convertToTensor(weights, "weights", "softmaxCrossEntropy");
  }
  assertShapesMatch($onehotLabels.shape, $logits.shape, "Error in softmaxCrossEntropy: ");
  if (labelSmoothing > 0) {
    const labelSmoothingScalar = scalar(labelSmoothing);
    const one = scalar(1);
    const numClasses = scalar($onehotLabels.shape[1]);
    $onehotLabels = add$1(mul($onehotLabels, sub$2(one, labelSmoothingScalar)), div$1(labelSmoothingScalar, numClasses));
  }
  const losses = softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
  return computeWeightedLoss$1(losses, $weights, reduction2);
}
const softmaxCrossEntropy = op({ softmaxCrossEntropy_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseFillEmptyRows_(indices, values, denseShape, defaultValue) {
  const $indices = convertToTensor(indices, "indices", "sparseFillEmptyRows", "int32");
  const $values = convertToTensor(values, "values", "sparseFillEmptyRows");
  const $denseShape = convertToTensor(denseShape, "denseShape", "sparseFillEmptyRows", "int32");
  const $defaultValue = convertToTensor(defaultValue, "defaultValue", "sparseFillEmptyRows", $values.dtype);
  if ($indices.rank !== 2) {
    throw new Error(`Indices should be Tensor2D but received shape
        ${$indices.shape}`);
  }
  if ($values.rank !== 1) {
    throw new Error(`Values should be Tensor1D but received shape ${$values.shape}`);
  }
  if ($denseShape.rank !== 1) {
    throw new Error(`Dense shape should be Tensor1D but received shape ${$denseShape.shape}`);
  }
  if ($defaultValue.rank !== 0) {
    throw new Error(`Default value should be a scalar but received shape ${$defaultValue.shape}`);
  }
  const inputs = {
    indices: $indices,
    values: $values,
    denseShape: $denseShape,
    defaultValue: $defaultValue
  };
  const result2 = ENGINE.runKernel(SparseFillEmptyRows, inputs);
  return {
    outputIndices: result2[0],
    outputValues: result2[1],
    emptyRowIndicator: result2[2],
    reverseIndexMap: result2[3]
  };
}
const sparseFillEmptyRows$3 = op({ sparseFillEmptyRows_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseReshape_(inputIndices, inputShape, newShape) {
  const $inputIndices = convertToTensor(inputIndices, "inputIndices", "sparseReshape", "int32");
  const $inputShape = convertToTensor(inputShape, "inputShape", "sparseReshape", "int32");
  const $newShape = convertToTensor(newShape, "newShape", "sparseReshape", "int32");
  if ($inputIndices.rank !== 2) {
    throw new Error(`Input indices should be Tensor2D but received shape
        ${$inputIndices.shape}`);
  }
  if ($inputShape.rank !== 1) {
    throw new Error(`Input shape should be Tensor1D but received shape ${$inputShape.shape}`);
  }
  if ($newShape.rank !== 1) {
    throw new Error(`New shape should be Tensor1D but received shape ${$newShape.shape}`);
  }
  const inputs = {
    inputIndices: $inputIndices,
    inputShape: $inputShape,
    newShape: $newShape
  };
  const result2 = ENGINE.runKernel(SparseReshape, inputs);
  return { outputIndices: result2[0], outputShape: result2[1] };
}
const sparseReshape$3 = op({ sparseReshape_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentMean_(data2, indices, segmentIds) {
  const $data = convertToTensor(data2, "data", "sparseSegmentMean");
  const $indices = convertToTensor(indices, "indices", "sparseSegmentMean", "int32");
  const $segmentIds = convertToTensor(segmentIds, "segmentIds", "sparseSegmentMean", "int32");
  if ($data.rank < 1) {
    throw new Error(`Data should be at least 1 dimensional but received scalar`);
  }
  if ($indices.rank !== 1) {
    throw new Error(`Indices should be Tensor1D but received shape
          ${$indices.shape}`);
  }
  if ($segmentIds.rank !== 1) {
    throw new Error(`Segment ids should be Tensor1D but received shape
          ${$segmentIds.shape}`);
  }
  const inputs = {
    data: $data,
    indices: $indices,
    segmentIds: $segmentIds
  };
  return ENGINE.runKernel(SparseSegmentMean, inputs);
}
const sparseSegmentMean$3 = op({ sparseSegmentMean_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentSum_(data2, indices, segmentIds) {
  const $data = convertToTensor(data2, "data", "sparseSegmentSum");
  const $indices = convertToTensor(indices, "indices", "sparseSegmentSum", "int32");
  const $segmentIds = convertToTensor(segmentIds, "segmentIds", "sparseSegmentSum", "int32");
  if ($data.rank < 1) {
    throw new Error(`Data should be at least 1 dimensional but received scalar`);
  }
  if ($indices.rank !== 1) {
    throw new Error(`Indices should be Tensor1D but received shape
         ${$indices.shape}`);
  }
  if ($segmentIds.rank !== 1) {
    throw new Error(`Segment ids should be Tensor1D but received shape
         ${$segmentIds.shape}`);
  }
  const inputs = {
    data: $data,
    indices: $indices,
    segmentIds: $segmentIds
  };
  return ENGINE.runKernel(SparseSegmentSum, inputs);
}
const sparseSegmentSum$3 = op({ sparseSegmentSum_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringNGrams_(data2, dataSplits, separator, nGramWidths, leftPad, rightPad2, padWidth, preserveShortSequences) {
  const $data = convertToTensor(data2, "data", "stringNGrams", "string");
  if ($data.dtype !== "string") {
    throw new Error("Data must be of datatype string");
  }
  if ($data.shape.length !== 1) {
    throw new Error(`Data must be a vector, saw: ${$data.shape}`);
  }
  const $dataSplits = convertToTensor(dataSplits, "dataSplits", "stringNGrams");
  if ($dataSplits.dtype !== "int32") {
    throw new Error("Data splits must be of datatype int32");
  }
  const attrs = {
    separator,
    nGramWidths,
    leftPad,
    rightPad: rightPad2,
    padWidth,
    preserveShortSequences
  };
  const inputs = { data: $data, dataSplits: $dataSplits };
  const result2 = ENGINE.runKernel(StringNGrams, inputs, attrs);
  return { nGrams: result2[0], nGramsSplits: result2[1] };
}
const stringNGrams$2 = op({ stringNGrams_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringSplit_(input, delimiter, skipEmpty = true) {
  const $input = convertToTensor(input, "input", "stringSplit", "string");
  const $delimiter = convertToTensor(delimiter, "delimiter", "stringSplit", "string");
  if ($input.rank !== 1) {
    throw new Error(`Input should be Tensor1D but received shape ${$input.shape}`);
  }
  if ($delimiter.rank !== 0) {
    throw new Error(`Delimiter should be a scalar but received shape ${$delimiter.shape}`);
  }
  const attrs = { skipEmpty };
  const inputs = { input: $input, delimiter: $delimiter };
  const result2 = ENGINE.runKernel(StringSplit, inputs, attrs);
  return { indices: result2[0], values: result2[1], shape: result2[2] };
}
const stringSplit$2 = op({ stringSplit_ });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringToHashBucketFast_(input, numBuckets) {
  const $input = convertToTensor(input, "input", "stringToHashBucketFast", "string");
  const attrs = { numBuckets };
  if (numBuckets <= 0) {
    throw new Error(`Number of buckets must be at least 1`);
  }
  const inputs = { input: $input };
  return ENGINE.runKernel(StringToHashBucketFast, inputs, attrs);
}
const stringToHashBucketFast$2 = op({ stringToHashBucketFast_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
({
  hammingWindow,
  hannWindow,
  frame: frame$1,
  stft
});
const image$1 = {
  flipLeftRight: flipLeftRight$1,
  grayscaleToRGB,
  resizeNearestNeighbor: resizeNearestNeighbor$2,
  resizeBilinear: resizeBilinear$3,
  rotateWithOffset: rotateWithOffset$1,
  cropAndResize: cropAndResize$3,
  nonMaxSuppression,
  nonMaxSuppressionAsync,
  nonMaxSuppressionWithScore,
  nonMaxSuppressionWithScoreAsync,
  nonMaxSuppressionPadded,
  nonMaxSuppressionPaddedAsync,
  threshold: threshold$1,
  transform: transform$3
};
const linalg = {
  bandPart,
  gramSchmidt,
  qr
};
({
  absoluteDifference,
  computeWeightedLoss: computeWeightedLoss$1,
  cosineDistance,
  hingeLoss,
  huberLoss,
  logLoss,
  meanSquaredError: meanSquaredError$1,
  sigmoidCrossEntropy,
  softmaxCrossEntropy
});
const sparse$1 = {
  sparseFillEmptyRows: sparseFillEmptyRows$3,
  sparseReshape: sparseReshape$3,
  sparseSegmentMean: sparseSegmentMean$3,
  sparseSegmentSum: sparseSegmentSum$3
};
const string$1 = {
  stringNGrams: stringNGrams$2,
  stringSplit: stringSplit$2,
  stringToHashBucketFast: stringToHashBucketFast$2
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Optimizer extends Serializable {
  minimize(f2, returnCost = false, varList) {
    const { value, grads } = this.computeGradients(f2, varList);
    if (varList != null) {
      const gradArray = varList.map((v2) => ({ name: v2.name, tensor: grads[v2.name] }));
      this.applyGradients(gradArray);
    } else {
      this.applyGradients(grads);
    }
    dispose(grads);
    if (returnCost) {
      return value;
    } else {
      value.dispose();
      return null;
    }
  }
  get iterations() {
    if (this.iterations_ == null) {
      this.iterations_ = 0;
    }
    return this.iterations_;
  }
  incrementIterations() {
    this.iterations_ = this.iterations + 1;
  }
  computeGradients(f2, varList) {
    return variableGrads(f2, varList);
  }
  dispose() {
    if (this.iterations_ != null) {
      dispose(this.iterations_);
    }
  }
  async saveIterations() {
    if (this.iterations_ == null) {
      this.iterations_ = 0;
    }
    return {
      name: "iter",
      tensor: scalar(this.iterations_, "int32")
    };
  }
  async getWeights() {
    throw new Error("getWeights() is not implemented for this optimizer yet.");
  }
  async setWeights(weightValues) {
    throw new Error(`setWeights() is not implemented for this optimizer class ${this.getClassName()}`);
  }
  async extractIterations(weightValues) {
    this.iterations_ = (await weightValues[0].tensor.data())[0];
    return weightValues.slice(1);
  }
}
Object.defineProperty(Optimizer, Symbol.hasInstance, {
  value: (instance2) => {
    return instance2.minimize != null && instance2.computeGradients != null && instance2.applyGradients != null;
  }
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class AdadeltaOptimizer extends Optimizer {
  constructor(learningRate, rho, epsilon2 = null) {
    super();
    this.learningRate = learningRate;
    this.rho = rho;
    this.epsilon = epsilon2;
    this.accumulatedGrads = [];
    this.accumulatedUpdates = [];
    if (epsilon2 == null) {
      this.epsilon = ENGINE.backend.epsilon();
    }
  }
  applyGradients(variableGradients) {
    const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item) => item.name) : Object.keys(variableGradients);
    variableNames.forEach((name, i2) => {
      const value = ENGINE.registeredVariables[name];
      const trainable = false;
      if (this.accumulatedGrads[i2] == null) {
        this.accumulatedGrads[i2] = {
          originalName: `${name}/accum_grad`,
          variable: tidy(() => zerosLike$3(value).variable(trainable))
        };
      }
      if (this.accumulatedUpdates[i2] == null) {
        this.accumulatedUpdates[i2] = {
          originalName: `${name}/accum_var`,
          variable: tidy(() => zerosLike$3(value).variable(trainable))
        };
      }
      const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
      if (gradient == null) {
        return;
      }
      const accumulatedGrad = this.accumulatedGrads[i2].variable;
      const accumulatedUpdate = this.accumulatedUpdates[i2].variable;
      tidy(() => {
        const newAccumulatedGrad = add$1(mul(accumulatedGrad, this.rho), mul(square$2(gradient), 1 - this.rho));
        const updates = mul(div$1(sqrt$2(add$1(accumulatedUpdate, this.epsilon)), sqrt$2(add$1(accumulatedGrad, this.epsilon))), gradient);
        const newAccumulatedUpdate = add$1(mul(accumulatedUpdate, this.rho), mul(square$2(updates), 1 - this.rho));
        accumulatedGrad.assign(newAccumulatedGrad);
        accumulatedUpdate.assign(newAccumulatedUpdate);
        const newValue = add$1(mul(updates, -this.learningRate), value);
        value.assign(newValue);
      });
    });
    this.incrementIterations();
  }
  dispose() {
    if (this.accumulatedUpdates != null) {
      dispose(this.accumulatedGrads.map((v2) => v2.variable));
      dispose(this.accumulatedUpdates.map((v2) => v2.variable));
    }
  }
  async getWeights() {
    const variables = [...this.accumulatedGrads, ...this.accumulatedUpdates];
    return [await this.saveIterations()].concat(variables.map((v2) => ({ name: v2.originalName, tensor: v2.variable })));
  }
  async setWeights(weightValues) {
    weightValues = await this.extractIterations(weightValues);
    const variableCount = weightValues.length / 2;
    const trainable = false;
    this.accumulatedGrads = weightValues.slice(0, variableCount).map((v2) => ({
      originalName: v2.name,
      variable: v2.tensor.variable(trainable)
    }));
    this.accumulatedUpdates = weightValues.slice(variableCount, variableCount * 2).map((v2) => ({
      originalName: v2.name,
      variable: v2.tensor.variable(trainable)
    }));
  }
  getConfig() {
    return {
      "learningRate": this.learningRate,
      "rho": this.rho,
      "epsilon": this.epsilon
    };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"], config2["rho"], config2["epsilon"]);
  }
}
AdadeltaOptimizer.className = "Adadelta";
registerClass(AdadeltaOptimizer);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class AdagradOptimizer extends Optimizer {
  constructor(learningRate, initialAccumulatorValue = 0.1) {
    super();
    this.learningRate = learningRate;
    this.initialAccumulatorValue = initialAccumulatorValue;
    this.accumulatedGrads = [];
  }
  applyGradients(variableGradients) {
    const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item) => item.name) : Object.keys(variableGradients);
    variableNames.forEach((name, i2) => {
      const value = ENGINE.registeredVariables[name];
      if (this.accumulatedGrads[i2] == null) {
        const trainable = false;
        this.accumulatedGrads[i2] = {
          originalName: `${name}/accumulator`,
          variable: tidy(() => fill$3(value.shape, this.initialAccumulatorValue).variable(trainable))
        };
      }
      const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
      if (gradient == null) {
        return;
      }
      const accumulatedGrad = this.accumulatedGrads[i2].variable;
      tidy(() => {
        const newAccumulatedGrad = add$1(accumulatedGrad, square$2(gradient));
        accumulatedGrad.assign(newAccumulatedGrad);
        const newValue = add$1(mul(div$1(gradient, sqrt$2(add$1(newAccumulatedGrad, ENGINE.backend.epsilon()))), -this.learningRate), value);
        value.assign(newValue);
      });
    });
    this.incrementIterations();
  }
  dispose() {
    if (this.accumulatedGrads != null) {
      dispose(this.accumulatedGrads.map((v2) => v2.variable));
    }
  }
  async getWeights() {
    return [await this.saveIterations()].concat(this.accumulatedGrads.map((v2) => ({ name: v2.originalName, tensor: v2.variable })));
  }
  async setWeights(weightValues) {
    weightValues = await this.extractIterations(weightValues);
    const trainable = false;
    this.accumulatedGrads = weightValues.map((v2) => ({ originalName: v2.name, variable: v2.tensor.variable(trainable) }));
  }
  getConfig() {
    return {
      "learningRate": this.learningRate,
      "initialAccumulatorValue": this.initialAccumulatorValue
    };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"], config2["initialAccumulatorValue"]);
  }
}
AdagradOptimizer.className = "Adagrad";
registerClass(AdagradOptimizer);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class AdamOptimizer extends Optimizer {
  constructor(learningRate, beta1, beta2, epsilon2 = null) {
    super();
    this.learningRate = learningRate;
    this.beta1 = beta1;
    this.beta2 = beta2;
    this.epsilon = epsilon2;
    this.accumulatedFirstMoment = [];
    this.accumulatedSecondMoment = [];
    tidy(() => {
      this.accBeta1 = scalar(beta1).variable();
      this.accBeta2 = scalar(beta2).variable();
    });
    if (epsilon2 == null) {
      this.epsilon = ENGINE.backend.epsilon();
    }
  }
  applyGradients(variableGradients) {
    const varNames = Array.isArray(variableGradients) ? variableGradients.map((v2) => v2.name) : Object.keys(variableGradients);
    tidy(() => {
      const oneMinusAccBeta1 = sub$2(1, this.accBeta1);
      const oneMinusAccBeta2 = sub$2(1, this.accBeta2);
      varNames.forEach((name, i2) => {
        const value = ENGINE.registeredVariables[name];
        const trainable = false;
        if (this.accumulatedFirstMoment[i2] == null) {
          this.accumulatedFirstMoment[i2] = {
            originalName: `${name}/m`,
            variable: tidy(() => zerosLike$3(value).variable(trainable))
          };
        }
        if (this.accumulatedSecondMoment[i2] == null) {
          this.accumulatedSecondMoment[i2] = {
            originalName: `${name}/v`,
            variable: tidy(() => zerosLike$3(value).variable(trainable))
          };
        }
        const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
        if (gradient == null) {
          return;
        }
        const firstMoment = this.accumulatedFirstMoment[i2].variable;
        const secondMoment = this.accumulatedSecondMoment[i2].variable;
        const newFirstMoment = add$1(mul(firstMoment, this.beta1), mul(gradient, 1 - this.beta1));
        const newSecondMoment = add$1(mul(secondMoment, this.beta2), mul(square$2(gradient), 1 - this.beta2));
        const biasCorrectedFirstMoment = div$1(newFirstMoment, oneMinusAccBeta1);
        const biasCorrectedSecondMoment = div$1(newSecondMoment, oneMinusAccBeta2);
        firstMoment.assign(newFirstMoment);
        secondMoment.assign(newSecondMoment);
        const newValue = add$1(mul(div$1(biasCorrectedFirstMoment, add$1(sqrt$2(biasCorrectedSecondMoment), this.epsilon)), -this.learningRate), value);
        value.assign(newValue);
      });
      this.accBeta1.assign(mul(this.accBeta1, this.beta1));
      this.accBeta2.assign(mul(this.accBeta2, this.beta2));
    });
    this.incrementIterations();
  }
  dispose() {
    this.accBeta1.dispose();
    this.accBeta2.dispose();
    if (this.accumulatedFirstMoment != null) {
      dispose(this.accumulatedFirstMoment.map((v2) => v2.variable));
    }
    if (this.accumulatedSecondMoment != null) {
      dispose(this.accumulatedSecondMoment.map((v2) => v2.variable));
    }
  }
  async getWeights() {
    const variables = [...this.accumulatedFirstMoment, ...this.accumulatedSecondMoment];
    return [await this.saveIterations()].concat(variables.map((v2) => ({ name: v2.originalName, tensor: v2.variable })));
  }
  async setWeights(weightValues) {
    weightValues = await this.extractIterations(weightValues);
    tidy(() => {
      this.accBeta1.assign(pow$2(this.beta1, this.iterations_ + 1));
      this.accBeta2.assign(pow$2(this.beta2, this.iterations_ + 1));
    });
    const variableCount = weightValues.length / 2;
    const trainable = false;
    this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map((v2) => ({
      originalName: v2.name,
      variable: v2.tensor.variable(trainable)
    }));
    this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map((v2) => ({
      originalName: v2.name,
      variable: v2.tensor.variable(trainable)
    }));
  }
  getConfig() {
    return {
      "learningRate": this.learningRate,
      "beta1": this.beta1,
      "beta2": this.beta2,
      "epsilon": this.epsilon
    };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"], config2["beta1"], config2["beta2"], config2["epsilon"]);
  }
}
AdamOptimizer.className = "Adam";
registerClass(AdamOptimizer);
/**
* @license
* Copyright 2018 Google LLC. All Rights Reserved.
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
* http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* =============================================================================
*/
class AdamaxOptimizer extends Optimizer {
  constructor(learningRate, beta1, beta2, epsilon2 = null, decay2 = 0) {
    super();
    this.learningRate = learningRate;
    this.beta1 = beta1;
    this.beta2 = beta2;
    this.epsilon = epsilon2;
    this.decay = decay2;
    this.accumulatedFirstMoment = [];
    this.accumulatedWeightedInfNorm = [];
    tidy(() => {
      this.iteration = scalar(0).variable();
      this.accBeta1 = scalar(beta1).variable();
    });
    if (epsilon2 == null) {
      this.epsilon = ENGINE.backend.epsilon();
    }
  }
  applyGradients(variableGradients) {
    const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item) => item.name) : Object.keys(variableGradients);
    tidy(() => {
      const oneMinusAccBeta1 = sub$2(1, this.accBeta1);
      const lr = div$1(-this.learningRate, add$1(mul(this.iteration, this.decay), 1));
      variableNames.forEach((name, i2) => {
        const value = ENGINE.registeredVariables[name];
        const trainable = false;
        if (this.accumulatedFirstMoment[i2] == null) {
          this.accumulatedFirstMoment[i2] = {
            originalName: `${name}/m`,
            variable: zerosLike$3(value).variable(trainable)
          };
        }
        if (this.accumulatedWeightedInfNorm[i2] == null) {
          this.accumulatedWeightedInfNorm[i2] = {
            originalName: `${name}/v`,
            variable: zerosLike$3(value).variable(trainable)
          };
        }
        const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
        if (gradient == null) {
          return;
        }
        const firstMoment = this.accumulatedFirstMoment[i2].variable;
        const weightedInfNorm = this.accumulatedWeightedInfNorm[i2].variable;
        const newFirstMoment = add$1(mul(firstMoment, this.beta1), mul(gradient, 1 - this.beta1));
        const ut0 = mul(weightedInfNorm, this.beta2);
        const ut1 = abs$2(gradient);
        const newWeightedInfNorm = maximum$2(ut0, ut1);
        firstMoment.assign(newFirstMoment);
        weightedInfNorm.assign(newWeightedInfNorm);
        const newValue = add$1(mul(div$1(lr, oneMinusAccBeta1), div$1(newFirstMoment, add$1(newWeightedInfNorm, this.epsilon))), value);
        value.assign(newValue);
      });
      this.iteration.assign(add$1(this.iteration, 1));
      this.accBeta1.assign(mul(this.accBeta1, this.beta1));
    });
    this.incrementIterations();
  }
  dispose() {
    this.accBeta1.dispose();
    this.iteration.dispose();
    if (this.accumulatedFirstMoment != null) {
      dispose(this.accumulatedFirstMoment.map((v2) => v2.variable));
    }
    if (this.accumulatedWeightedInfNorm != null) {
      dispose(this.accumulatedWeightedInfNorm.map((v2) => v2.variable));
    }
  }
  async getWeights() {
    throw new Error("getWeights() is not implemented for Adamax yet.");
  }
  async setWeights(weightValues) {
    throw new Error("setWeights() is not implemented for Adamax yet.");
  }
  getConfig() {
    return {
      "learningRate": this.learningRate,
      "beta1": this.beta1,
      "beta2": this.beta2,
      "epsilon": this.epsilon,
      "decay": this.decay
    };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"], config2["beta1"], config2["beta2"], config2["epsilon"], config2["decay"]);
  }
}
AdamaxOptimizer.className = "Adamax";
registerClass(AdamaxOptimizer);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class SGDOptimizer extends Optimizer {
  constructor(learningRate) {
    super();
    this.learningRate = learningRate;
    this.setLearningRate(learningRate);
  }
  applyGradients(variableGradients) {
    const varNames = Array.isArray(variableGradients) ? variableGradients.map((v2) => v2.name) : Object.keys(variableGradients);
    varNames.forEach((name, i2) => {
      const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
      if (gradient == null) {
        return;
      }
      const value = ENGINE.registeredVariables[name];
      tidy(() => {
        const newValue = add$1(mul(this.c, gradient), value);
        value.assign(newValue);
      });
    });
    this.incrementIterations();
  }
  setLearningRate(learningRate) {
    this.learningRate = learningRate;
    if (this.c != null) {
      this.c.dispose();
    }
    this.c = keep(scalar(-learningRate));
  }
  dispose() {
    this.c.dispose();
  }
  async getWeights() {
    return [await this.saveIterations()];
  }
  async setWeights(weightValues) {
    weightValues = await this.extractIterations(weightValues);
    if (weightValues.length !== 0) {
      throw new Error("SGD optimizer does not have settable weights.");
    }
  }
  getConfig() {
    return { "learningRate": this.learningRate };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"]);
  }
}
SGDOptimizer.className = "SGD";
registerClass(SGDOptimizer);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MomentumOptimizer extends SGDOptimizer {
  constructor(learningRate, momentum, useNesterov = false) {
    super(learningRate);
    this.learningRate = learningRate;
    this.momentum = momentum;
    this.useNesterov = useNesterov;
    this.accumulations = [];
    this.m = scalar(this.momentum);
  }
  applyGradients(variableGradients) {
    const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item) => item.name) : Object.keys(variableGradients);
    variableNames.forEach((name, i2) => {
      const value = ENGINE.registeredVariables[name];
      if (this.accumulations[i2] == null) {
        const trainable = false;
        this.accumulations[i2] = {
          originalName: `${name}/momentum`,
          variable: tidy(() => zerosLike$3(value).variable(trainable))
        };
      }
      const accumulation = this.accumulations[i2].variable;
      const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
      if (gradient == null) {
        return;
      }
      tidy(() => {
        let newValue;
        const newAccumulation = add$1(mul(this.m, accumulation), gradient);
        if (this.useNesterov) {
          newValue = add$1(mul(this.c, add$1(gradient, mul(newAccumulation, this.m))), value);
        } else {
          newValue = add$1(mul(this.c, newAccumulation), value);
        }
        accumulation.assign(newAccumulation);
        value.assign(newValue);
      });
    });
    this.incrementIterations();
  }
  dispose() {
    this.m.dispose();
    if (this.accumulations != null) {
      dispose(this.accumulations.map((v2) => v2.variable));
    }
  }
  setMomentum(momentum) {
    this.momentum = momentum;
  }
  async getWeights() {
    return [await this.saveIterations()].concat(this.accumulations.map((v2) => ({ name: v2.originalName, tensor: v2.variable })));
  }
  async setWeights(weightValues) {
    weightValues = await this.extractIterations(weightValues);
    const trainable = false;
    this.accumulations = weightValues.map((v2) => ({ originalName: v2.name, variable: v2.tensor.variable(trainable) }));
  }
  getConfig() {
    return {
      "learningRate": this.learningRate,
      "momentum": this.momentum,
      "useNesterov": this.useNesterov
    };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"], config2["momentum"], config2["useNesterov"]);
  }
}
MomentumOptimizer.className = "Momentum";
registerClass(MomentumOptimizer);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class RMSPropOptimizer extends Optimizer {
  constructor(learningRate, decay2 = 0.9, momentum = 0, epsilon2 = null, centered = false) {
    super();
    this.learningRate = learningRate;
    this.decay = decay2;
    this.momentum = momentum;
    this.epsilon = epsilon2;
    this.accumulatedMeanSquares = [];
    this.accumulatedMoments = [];
    this.accumulatedMeanGrads = [];
    this.centered = centered;
    if (epsilon2 == null) {
      this.epsilon = ENGINE.backend.epsilon();
    }
    if (learningRate == null) {
      throw new Error(`learningRate for RMSPropOptimizer must be defined.`);
    }
  }
  applyGradients(variableGradients) {
    const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item) => item.name) : Object.keys(variableGradients);
    variableNames.forEach((name, i2) => {
      const value = ENGINE.registeredVariables[name];
      const trainable = false;
      if (this.accumulatedMeanSquares[i2] == null) {
        this.accumulatedMeanSquares[i2] = {
          originalName: `${name}/rms`,
          variable: tidy(() => zerosLike$3(value).variable(trainable))
        };
      }
      if (this.accumulatedMoments[i2] == null) {
        this.accumulatedMoments[i2] = {
          originalName: `${name}/momentum`,
          variable: tidy(() => zerosLike$3(value).variable(trainable))
        };
      }
      if (this.accumulatedMeanGrads[i2] == null && this.centered) {
        this.accumulatedMeanGrads[i2] = {
          originalName: `${name}/mg`,
          variable: tidy(() => zerosLike$3(value).variable(trainable))
        };
      }
      const gradient = Array.isArray(variableGradients) ? variableGradients[i2].tensor : variableGradients[name];
      if (gradient == null) {
        return;
      }
      const accumulatedMeanSquare = this.accumulatedMeanSquares[i2].variable;
      const accumulatedMoments = this.accumulatedMoments[i2].variable;
      tidy(() => {
        const newAccumulatedMeanSquare = add$1(mul(accumulatedMeanSquare, this.decay), mul(square$2(gradient), 1 - this.decay));
        if (this.centered) {
          const accumulatedMeanGrad = this.accumulatedMeanGrads[i2].variable;
          const newAccumulatedMeanGrad = add$1(mul(accumulatedMeanGrad, this.decay), mul(gradient, 1 - this.decay));
          const gradContribution = div$1(mul(gradient, this.learningRate), sqrt$2(sub$2(newAccumulatedMeanSquare, add$1(square$2(newAccumulatedMeanGrad), this.epsilon))));
          const newAccumulatedMoments = add$1(mul(accumulatedMoments, this.momentum), gradContribution);
          accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
          accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
          accumulatedMoments.assign(newAccumulatedMoments);
          const newValue = sub$2(value, newAccumulatedMoments);
          value.assign(newValue);
        } else {
          const newAccumulatedMeanSquare2 = add$1(mul(accumulatedMeanSquare, this.decay), mul(square$2(gradient), 1 - this.decay));
          const newAccumulatedMoments = add$1(mul(accumulatedMoments, this.momentum), div$1(mul(gradient, this.learningRate), sqrt$2(add$1(newAccumulatedMeanSquare2, this.epsilon))));
          accumulatedMeanSquare.assign(newAccumulatedMeanSquare2);
          accumulatedMoments.assign(newAccumulatedMoments);
          const newValue = sub$2(value, newAccumulatedMoments);
          value.assign(newValue);
        }
      });
    });
    this.incrementIterations();
  }
  dispose() {
    if (this.accumulatedMeanSquares != null) {
      dispose(this.accumulatedMeanSquares.map((v2) => v2.variable));
    }
    if (this.accumulatedMeanGrads != null && this.centered) {
      dispose(this.accumulatedMeanGrads.map((v2) => v2.variable));
    }
    if (this.accumulatedMoments != null) {
      dispose(this.accumulatedMoments.map((v2) => v2.variable));
    }
  }
  async getWeights() {
    const variables = [...this.accumulatedMeanSquares, ...this.accumulatedMoments];
    if (this.centered) {
      variables.push(...this.accumulatedMeanGrads);
    }
    return [await this.saveIterations()].concat(variables.map((v2) => ({ name: v2.originalName, tensor: v2.variable })));
  }
  async setWeights(weightValues) {
    weightValues = await this.extractIterations(weightValues);
    const variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
    const trainable = false;
    this.accumulatedMeanSquares = weightValues.slice(0, variableCount).map((v2) => ({
      originalName: v2.name,
      variable: v2.tensor.variable(trainable)
    }));
    this.accumulatedMoments = weightValues.slice(variableCount, variableCount * 2).map((v2) => ({
      originalName: v2.name,
      variable: v2.tensor.variable(trainable)
    }));
    if (this.centered) {
      this.accumulatedMeanGrads = weightValues.slice(variableCount * 2, variableCount * 3).map((v2) => ({
        originalName: v2.name,
        variable: v2.tensor.variable(trainable)
      }));
    }
  }
  getConfig() {
    return {
      "learningRate": this.learningRate,
      "decay": this.decay,
      "momentum": this.momentum,
      "epsilon": this.epsilon,
      "centered": this.centered
    };
  }
  static fromConfig(cls, config2) {
    return new cls(config2["learningRate"], config2["decay"], config2["momentum"], config2["epsilon"], config2["centered"]);
  }
}
RMSPropOptimizer.className = "RMSProp";
registerClass(RMSPropOptimizer);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class OptimizerConstructors {
  static sgd(learningRate) {
    return new SGDOptimizer(learningRate);
  }
  static momentum(learningRate, momentum, useNesterov = false) {
    return new MomentumOptimizer(learningRate, momentum, useNesterov);
  }
  static rmsprop(learningRate, decay2 = 0.9, momentum = 0, epsilon2 = null, centered = false) {
    return new RMSPropOptimizer(learningRate, decay2, momentum, epsilon2, centered);
  }
  static adam(learningRate = 1e-3, beta1 = 0.9, beta2 = 0.999, epsilon2 = null) {
    return new AdamOptimizer(learningRate, beta1, beta2, epsilon2);
  }
  static adadelta(learningRate = 1e-3, rho = 0.95, epsilon2 = null) {
    return new AdadeltaOptimizer(learningRate, rho, epsilon2);
  }
  static adamax(learningRate = 2e-3, beta1 = 0.9, beta2 = 0.999, epsilon2 = null, decay2 = 0) {
    return new AdamaxOptimizer(learningRate, beta1, beta2, epsilon2, decay2);
  }
  static adagrad(learningRate, initialAccumulatorValue = 0.1) {
    return new AdagradOptimizer(learningRate, initialAccumulatorValue);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
[
  MomentumOptimizer,
  SGDOptimizer,
  AdadeltaOptimizer,
  AdagradOptimizer,
  RMSPropOptimizer,
  AdamaxOptimizer,
  AdamOptimizer
];
const train = {
  sgd: OptimizerConstructors.sgd,
  momentum: OptimizerConstructors.momentum,
  adadelta: OptimizerConstructors.adadelta,
  adagrad: OptimizerConstructors.adagrad,
  rmsprop: OptimizerConstructors.rmsprop,
  adamax: OptimizerConstructors.adamax,
  adam: OptimizerConstructors.adam
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const delayCallback = (() => {
  if (typeof requestAnimationFrame !== "undefined") {
    return requestAnimationFrame;
  } else if (typeof setImmediate !== "undefined") {
    return setImmediate;
  }
  return (f2) => f2();
})();
function nextFrame() {
  return new Promise((resolve) => delayCallback(() => resolve()));
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function assertParamsConsistent(shapes, axis) {
  const rank = shapes[0].length;
  shapes.forEach((shape, i2) => {
    assert$1(shape.length === rank, () => `Error in concat${rank}D: rank of tensors[${i2}] must be the same as the rank of the rest (${rank})`);
  });
  assert$1(axis >= 0 && axis < rank, () => `Error in concat${rank}D: axis must be between 0 and ${rank - 1}.`);
  const firstShape = shapes[0];
  shapes.forEach((shape, i2) => {
    for (let r2 = 0; r2 < rank; r2++) {
      assert$1(r2 === axis || shape[r2] === firstShape[r2], () => `Error in concat${rank}D: Shape of tensors[${i2}] (${shape}) does not match the shape of the rest (${firstShape}) along the non-concatenated axis ${i2}.`);
    }
  });
}
function computeOutShape$2(shapes, axis) {
  const outputShape = shapes[0].slice();
  for (let i2 = 1; i2 < shapes.length; i2++) {
    outputShape[axis] += shapes[i2][axis];
  }
  return outputShape;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const PARALLELIZE_THRESHOLD = 30;
function computeOptimalWindowSize(inSize) {
  if (inSize <= PARALLELIZE_THRESHOLD) {
    return inSize;
  }
  return nearestDivisor(inSize, Math.floor(Math.sqrt(inSize)));
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getImageCenter(center, imageHeight, imageWidth) {
  const centerX = imageWidth * (typeof center === "number" ? center : center[0]);
  const centerY = imageHeight * (typeof center === "number" ? center : center[1]);
  return [centerX, centerY];
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getReshaped(inputShape, blockShape, prod2, batchToSpace = true) {
  let reshaped = [];
  if (batchToSpace) {
    reshaped = reshaped.concat(blockShape.slice(0));
    reshaped.push(inputShape[0] / prod2);
    reshaped = reshaped.concat(inputShape.slice(1));
  } else {
    reshaped = reshaped.concat(inputShape[0]);
    const spatialLength = blockShape.length;
    for (let i2 = 0; i2 < spatialLength; ++i2) {
      reshaped = reshaped.concat([inputShape[i2 + 1] / blockShape[i2], blockShape[i2]]);
    }
    reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
  }
  return reshaped;
}
function getPermuted(reshapedRank, blockShapeRank, batchToSpace = true) {
  const permuted = [];
  if (batchToSpace) {
    permuted.push(blockShapeRank);
    for (let i2 = blockShapeRank + 1; i2 < reshapedRank; ++i2) {
      if (i2 <= 2 * blockShapeRank) {
        permuted.push(i2);
        permuted.push(i2 - (blockShapeRank + 1));
      } else {
        permuted.push(i2);
      }
    }
  } else {
    const permutedBeforeBatch = [];
    const permutedAfterBatch = [];
    for (let i2 = 1; i2 < reshapedRank; ++i2) {
      if (i2 >= blockShapeRank * 2 + 1 || i2 % 2 === 1) {
        permutedAfterBatch.push(i2);
      } else {
        permutedBeforeBatch.push(i2);
      }
    }
    permuted.push(...permutedBeforeBatch);
    permuted.push(0);
    permuted.push(...permutedAfterBatch);
  }
  return permuted;
}
function getReshapedPermuted(inputShape, blockShape, prod2, batchToSpace = true) {
  const reshapedPermuted = [];
  if (batchToSpace) {
    reshapedPermuted.push(inputShape[0] / prod2);
  } else {
    reshapedPermuted.push(inputShape[0] * prod2);
  }
  for (let i2 = 1; i2 < inputShape.length; ++i2) {
    if (i2 <= blockShape.length) {
      if (batchToSpace) {
        reshapedPermuted.push(blockShape[i2 - 1] * inputShape[i2]);
      } else {
        reshapedPermuted.push(inputShape[i2] / blockShape[i2 - 1]);
      }
    } else {
      reshapedPermuted.push(inputShape[i2]);
    }
  }
  return reshapedPermuted;
}
function getSliceBeginCoords(crops, blockShape) {
  const sliceBeginCoords = [0];
  for (let i2 = 0; i2 < blockShape; ++i2) {
    sliceBeginCoords.push(crops[i2][0]);
  }
  return sliceBeginCoords;
}
function getSliceSize(uncroppedShape, crops, blockShape) {
  const sliceSize = uncroppedShape.slice(0, 1);
  for (let i2 = 0; i2 < blockShape; ++i2) {
    sliceSize.push(uncroppedShape[i2 + 1] - crops[i2][0] - crops[i2][1]);
  }
  return sliceSize;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SELU_SCALEALPHA = 1.7580993408473768;
const SELU_SCALE = 1.0507009873554805;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ERF_P = 0.3275911;
const ERF_A1 = 0.254829592;
const ERF_A2 = -0.284496736;
const ERF_A3 = 1.421413741;
const ERF_A4 = -1.453152027;
const ERF_A5 = 1.061405429;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mergeRealAndImagArrays(real2, imag2) {
  if (real2.length !== imag2.length) {
    throw new Error(`Cannot merge real and imag arrays of different lengths. real:${real2.length}, imag: ${imag2.length}.`);
  }
  const result2 = new Float32Array(real2.length * 2);
  for (let i2 = 0; i2 < result2.length; i2 += 2) {
    result2[i2] = real2[i2 / 2];
    result2[i2 + 1] = imag2[i2 / 2];
  }
  return result2;
}
function splitRealAndImagArrays(complex2) {
  const real2 = new Float32Array(complex2.length / 2);
  const imag2 = new Float32Array(complex2.length / 2);
  for (let i2 = 0; i2 < complex2.length; i2 += 2) {
    real2[i2 / 2] = complex2[i2];
    imag2[i2 / 2] = complex2[i2 + 1];
  }
  return { real: real2, imag: imag2 };
}
function complexWithEvenIndex(complex2) {
  const len = Math.ceil(complex2.length / 4);
  const real2 = new Float32Array(len);
  const imag2 = new Float32Array(len);
  for (let i2 = 0; i2 < complex2.length; i2 += 4) {
    real2[Math.floor(i2 / 4)] = complex2[i2];
    imag2[Math.floor(i2 / 4)] = complex2[i2 + 1];
  }
  return { real: real2, imag: imag2 };
}
function complexWithOddIndex(complex2) {
  const len = Math.floor(complex2.length / 4);
  const real2 = new Float32Array(len);
  const imag2 = new Float32Array(len);
  for (let i2 = 2; i2 < complex2.length; i2 += 4) {
    real2[Math.floor(i2 / 4)] = complex2[i2];
    imag2[Math.floor(i2 / 4)] = complex2[i2 + 1];
  }
  return { real: real2, imag: imag2 };
}
function getComplexWithIndex(complex2, index2) {
  const real2 = complex2[index2 * 2];
  const imag2 = complex2[index2 * 2 + 1];
  return { real: real2, imag: imag2 };
}
function assignToTypedArray(data2, real2, imag2, index2) {
  data2[index2 * 2] = real2;
  data2[index2 * 2 + 1] = imag2;
}
function exponents(n2, inverse) {
  const real2 = new Float32Array(n2 / 2);
  const imag2 = new Float32Array(n2 / 2);
  for (let i2 = 0; i2 < Math.ceil(n2 / 2); i2++) {
    const x2 = (inverse ? 2 : -2) * Math.PI * (i2 / n2);
    real2[i2] = Math.cos(x2);
    imag2[i2] = Math.sin(x2);
  }
  return { real: real2, imag: imag2 };
}
function exponent(k3, n2, inverse) {
  const x2 = (inverse ? 2 : -2) * Math.PI * (k3 / n2);
  const real2 = Math.cos(x2);
  const imag2 = Math.sin(x2);
  return { real: real2, imag: imag2 };
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ARROW = "->";
const ARROW_REGEX = /->/g;
const COMMA = ",";
const ELLIPSIS = "...";
function decodeEinsumEquation(equation, numTensors) {
  equation = equation.replace(/\s/g, "");
  const numArrows = (equation.length - equation.replace(ARROW_REGEX, "").length) / ARROW.length;
  if (numArrows < 1) {
    throw new Error("Equations without an arrow are not supported.");
  } else if (numArrows > 1) {
    throw new Error(`Equation must contain exactly one arrow ("${ARROW}").`);
  }
  const [inputString, outputString] = equation.split(ARROW);
  assert$1(inputString.indexOf(ELLIPSIS) === -1, () => `The ellipsis notation ("${ELLIPSIS}") is not supported yet.`);
  const inputTerms = inputString.split(COMMA);
  const numInputs = inputTerms.length;
  if (numTensors !== numInputs) {
    throw new Error(`Expected ${numInputs} input tensors, received ${numTensors}`);
  }
  if (numInputs > 2) {
    throw new Error("Support for more than 2 input tensors is not implemented yet.");
  }
  const allDims = [];
  for (let i2 = 0; i2 < outputString.length; ++i2) {
    const dimName = outputString[i2];
    if (!inputTerms.some((inputTerm) => inputTerm.indexOf(dimName) !== -1)) {
      throw new Error(`Output subscripts contain the label ${dimName} not present in the input subscripts.`);
    }
    if (allDims.indexOf(dimName) === -1) {
      allDims.push(dimName);
    }
  }
  for (let i2 = 0; i2 < inputString.length; ++i2) {
    const dimName = inputString[i2];
    if (allDims.indexOf(dimName) === -1 && dimName !== COMMA) {
      allDims.push(dimName);
    }
  }
  const idDims = new Array(inputTerms.length);
  for (let i2 = 0; i2 < numInputs; ++i2) {
    if (new Set(inputTerms[i2].split("")).size !== inputTerms[i2].length) {
      throw new Error(`Found duplicate axes in input component ${inputTerms[i2]}. Support for duplicate axes in input is not implemented yet.`);
    }
    idDims[i2] = [];
    for (let j2 = 0; j2 < inputTerms[i2].length; ++j2) {
      idDims[i2].push(allDims.indexOf(inputTerms[i2][j2]));
    }
  }
  const numDims = allDims.length;
  const numOutDims = outputString.length;
  const summedDims = [];
  for (let i2 = numOutDims; i2 < numDims; ++i2) {
    summedDims.push(i2);
  }
  return { allDims, summedDims, idDims };
}
function getEinsumPermutation(nDims, idDims) {
  let permutationIndices = new Array(nDims);
  permutationIndices.fill(-1);
  for (let i2 = 0; i2 < idDims.length; ++i2) {
    permutationIndices[idDims[i2]] = i2;
  }
  const expandDims2 = [];
  for (let i2 = 0; i2 < nDims; ++i2) {
    if (permutationIndices[i2] === -1) {
      expandDims2.push(i2);
    }
  }
  permutationIndices = permutationIndices.filter((d2) => d2 !== -1);
  return { permutationIndices, expandDims: expandDims2 };
}
function checkEinsumDimSizes(nDims, idDims, tensors) {
  const dimSizes = new Array(nDims);
  for (let i2 = 0; i2 < tensors.length; ++i2) {
    const shape = tensors[i2].shape;
    for (let j2 = 0; j2 < idDims[i2].length; ++j2) {
      if (dimSizes[idDims[i2][j2]] === void 0) {
        dimSizes[idDims[i2][j2]] = shape[j2];
      } else {
        assert$1(dimSizes[idDims[i2][j2]] === shape[j2], () => `Expected dimension ${dimSizes[idDims[i2][j2]]} at axis ${j2} of input shaped ${JSON.stringify(shape)}, but got dimension ${shape[j2]}`);
      }
    }
  }
}
function getEinsumComputePath(summedDims, idDims) {
  const path2 = summedDims;
  const steps2 = [];
  let nSteps = 0;
  if (summedDims.length === 0) {
    path2.push(-1);
  }
  nSteps = summedDims.length + 1;
  for (let i2 = 0; i2 < nSteps; ++i2) {
    steps2.push([]);
  }
  const computedTermIndices = [];
  for (let i2 = 0; i2 < path2.length; ++i2) {
    const summedDim = path2[i2];
    const termIndices = findTermsWithDim(idDims, summedDim);
    for (const termIndex of termIndices) {
      if (computedTermIndices.indexOf(termIndex) === -1) {
        steps2[i2].push(termIndex);
        computedTermIndices.push(termIndex);
      }
    }
  }
  return { path: path2, steps: steps2 };
}
function isIdentityPermutation(perm) {
  return perm.every((dim, index2) => dim === index2);
}
function findTermsWithDim(idDims, dim) {
  const termIndices = [];
  for (let i2 = 0; i2 < idDims.length; ++i2) {
    if (idDims[i2].length === 0 || idDims[i2].indexOf(dim) !== -1 || dim === -1) {
      termIndices.push(i2);
    }
  }
  return termIndices;
}
function prepareSplitSize(x2, numOrSizeSplits, axis = 0) {
  let splitSizes = [];
  if (typeof numOrSizeSplits === "number") {
    assert$1(x2.shape[axis] % numOrSizeSplits === 0, () => "Number of splits must evenly divide the axis.");
    splitSizes = new Array(numOrSizeSplits).fill(x2.shape[axis] / numOrSizeSplits);
  } else {
    const numOfNegs = numOrSizeSplits.reduce((count2, value) => {
      if (value === -1) {
        count2 += 1;
      }
      return count2;
    }, 0);
    assert$1(numOfNegs <= 1, () => "There should be only one negative value in split array.");
    const negIndex = numOrSizeSplits.indexOf(-1);
    if (negIndex !== -1) {
      const total = numOrSizeSplits.reduce((a6, b2) => b2 > 0 ? a6 + b2 : a6);
      numOrSizeSplits[negIndex] = x2.shape[axis] - total;
    }
    assert$1(x2.shape[axis] === numOrSizeSplits.reduce((a6, b2) => a6 + b2), () => "The sum of sizes must match the size of the axis dimension.");
    splitSizes = numOrSizeSplits;
  }
  return splitSizes;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getSparseFillEmptyRowsIndicesDenseShapeMismatch(indicesLength) {
  return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${indicesLength}`;
}
function getSparseFillEmptyRowsNegativeIndexErrorMessage(index2, value) {
  return `indices(${index2}, 0) is invalid: ${value} < 0`;
}
function getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(index2, value, limit) {
  return `indices(${index2}, 0) is invalid: ${value} >= ${limit}`;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(dim1, dim2) {
  return `only one output dimension may be -1, not both ${dim1} and ${dim2}`;
}
function getSparseReshapeNegativeOutputDimErrorMessage(dim, value) {
  return `size ${dim} must be non-negative, not ${value}`;
}
function getSparseReshapeEmptyTensorZeroOutputDimErrorMessage() {
  return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function getSparseReshapeInputOutputMultipleErrorMessage(inputShape, outputShape) {
  const inputSize = sizeFromShape(inputShape);
  const outputSize = sizeFromShape(outputShape);
  return `Input to reshape is a SparseTensor with ${inputSize}
  dense values, but the requested shape requires a multiple of ${outputSize}. inputShape=${inputShape} outputShape= ${outputShape}`;
}
function getSparseReshapeInputOutputMismatchErrorMessage(inputShape, outputShape) {
  const inputSize = sizeFromShape(inputShape);
  const outputSize = sizeFromShape(outputShape);
  return `Input to reshape is a tensor with ${inputSize} dense values, but the requested shape has ${outputSize}. inputShape=${inputShape} outputShape=${outputShape}`;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getSparseSegmentReductionNegativeSegmentIdsErrorMessage() {
  return `segment ids must be >= 0`;
}
function getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage() {
  return `segment ids are not increasing`;
}
function getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(segmentId, outputRows) {
  return `Segment id ${segmentId} out of range [0, ${outputRows}), possibly because segmentIds input is not sorted.`;
}
function getSparseSegmentReductionIndicesOutOfRangeErrorMessage(index2, indexValue, inputRows) {
  return `Bad: indices[${index2}] == ${indexValue} out of range [0, ${inputRows})`;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function segOpComputeOptimalWindowSize(inSize, numSegments) {
  let done = false;
  let res;
  if (inSize <= PARALLELIZE_THRESHOLD) {
    res = inSize;
    done = true;
  } else {
    res = nearestDivisor(inSize, Math.floor(Math.sqrt(inSize)));
  }
  while (!done) {
    if (res > numSegments || res === inSize) {
      done = true;
    } else {
      res = nearestDivisor(inSize, res + 1);
    }
  }
  return res;
}
function computeOutShape$1(aShape, axis, numSegments) {
  const outShape = [];
  const rank = aShape.length;
  for (let dim = 0; dim < rank; dim++) {
    if (dim !== axis) {
      outShape.push(aShape[dim]);
    } else {
      outShape.push(numSegments);
    }
  }
  return outShape;
}
function collectGatherOpShapeInfo(x2, indices, axis, batchDims) {
  const indicesRank = indices.shape.length;
  const xRank = x2.shape.length;
  if (batchDims !== 0) {
    if (batchDims < -indicesRank || batchDims > indicesRank) {
      throw new Error(`Expect batchDims in the range of [-${indicesRank}, ${indicesRank}], but got ${batchDims}`);
    }
  }
  if (batchDims < 0) {
    batchDims += indicesRank;
  }
  if (batchDims > xRank) {
    throw new Error(`batchDims (${batchDims}) must be less than rank(x) (
    ${xRank}).`);
  }
  if (axis < batchDims) {
    throw new Error(`batchDims (${batchDims}) must be less than or equal to axis (${axis}).`);
  }
  for (let i2 = 0; i2 < batchDims; ++i2) {
    if (x2.shape[i2] !== indices.shape[i2]) {
      throw new Error(`x.shape[${i2}]: ${x2.shape[i2]} should be equal to indices.shape[${i2}]: ${indices.shape[i2]}.`);
    }
  }
  const dimSize = x2.shape[axis];
  const outputShape = [];
  let batchSize = 1;
  let outerSize = 1;
  let sliceSize = 1;
  for (let i2 = 0; i2 < batchDims; ++i2) {
    outputShape.push(x2.shape[i2]);
    batchSize *= x2.shape[i2];
  }
  for (let i2 = batchDims; i2 < axis; i2++) {
    outputShape.push(x2.shape[i2]);
    outerSize *= x2.shape[i2];
  }
  for (let i2 = batchDims; i2 < indicesRank; i2++) {
    outputShape.push(indices.shape[i2]);
  }
  for (let i2 = axis + 1; i2 < xRank; i2++) {
    outputShape.push(x2.shape[i2]);
    sliceSize *= x2.shape[i2];
  }
  return { batchSize, sliceSize, outerSize, dimSize, outputShape };
}
var segment_util = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  segOpComputeOptimalWindowSize,
  computeOutShape: computeOutShape$1,
  collectGatherOpShapeInfo
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fromUint8ToStringArray(vals) {
  try {
    return vals.map((val) => decodeString(val));
  } catch (err) {
    throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${err}`);
  }
}
function fromStringArrayToUint8(strings) {
  return strings.map((s2) => encodeString(s2));
}
var backend_util = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  slice_util,
  segment_util,
  fromUint8ToStringArray,
  fromStringArrayToUint8,
  upcastType,
  axesAreInnerMostDims,
  combineLocations,
  computeOutAndReduceShapes,
  expandShapeToKeepDim,
  assertAxesAreInnerMostDims,
  getAxesPermutation,
  getUndoAxesPermutation,
  getInnerMostAxes,
  getBroadcastDims: getBroadcastDims$1,
  getReductionAxes,
  assertAndGetBroadcastShape,
  assertParamsConsistent,
  computeOutShape: computeOutShape$2,
  computeDilation2DInfo,
  computePool2DInfo,
  computePool3DInfo,
  computeConv2DInfo,
  computeConv3DInfo,
  computeDefaultPad,
  tupleValuesAreOne,
  eitherStridesOrDilationsAreOne,
  convertConv2DDataFormat,
  checkPadOnDimRoundingMode,
  getFusedDyActivation,
  getFusedBiasGradient,
  applyActivation: applyActivation$1,
  shouldFuse,
  PARALLELIZE_THRESHOLD,
  computeOptimalWindowSize,
  getImageCenter,
  getReshaped,
  getPermuted,
  getReshapedPermuted,
  getSliceBeginCoords,
  getSliceSize,
  prepareAndValidate,
  validateUpdateShape,
  validateInput: validateInput$1,
  calculateShapes,
  SELU_SCALEALPHA,
  SELU_SCALE,
  ERF_P,
  ERF_A1,
  ERF_A2,
  ERF_A3,
  ERF_A4,
  ERF_A5,
  warn,
  log: log$8,
  mergeRealAndImagArrays,
  splitRealAndImagArrays,
  complexWithEvenIndex,
  complexWithOddIndex,
  getComplexWithIndex,
  assignToTypedArray,
  exponents,
  exponent,
  decodeEinsumEquation,
  getEinsumPermutation,
  checkEinsumDimSizes,
  getEinsumComputePath,
  isIdentityPermutation,
  prepareSplitSize,
  getSparseFillEmptyRowsIndicesDenseShapeMismatch,
  getSparseFillEmptyRowsNegativeIndexErrorMessage,
  getSparseFillEmptyRowsOutOfRangeIndexErrorMessage,
  getSparseReshapeMultipleNegativeOneOutputDimErrorMessage,
  getSparseReshapeNegativeOutputDimErrorMessage,
  getSparseReshapeEmptyTensorZeroOutputDimErrorMessage,
  getSparseReshapeInputOutputMultipleErrorMessage,
  getSparseReshapeInputOutputMismatchErrorMessage,
  getSparseSegmentReductionNegativeSegmentIdsErrorMessage,
  getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage,
  getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage,
  getSparseSegmentReductionIndicesOutOfRangeErrorMessage
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const absGradConfig = {
  kernelName: Abs,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(dy, step$3(cast$4(x2, "float32"), -1)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const acosGradConfig = {
  kernelName: Acos,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return {
      x: () => {
        const a6 = square$2(cast$4(x2, "float32"));
        const b2 = sqrt$2(sub$2(scalar(1), a6));
        return neg$2(div$1(dy, b2));
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const acoshGradConfig = {
  kernelName: Acosh,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return {
      x: () => {
        const a6 = sqrt$2(sub$2(square$2(cast$4(x2, "float32")), 1));
        return div$1(dy, a6);
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const addGradConfig = {
  kernelName: Add$1,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      let res = dy;
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, a6.shape);
    };
    const derB = () => {
      let res = dy;
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, b2.shape);
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const addNGradConfig = {
  kernelName: AddN,
  saveAllInputs: true,
  gradFunc: (dy, saved) => {
    const ders = {};
    saved.forEach((_24, i2) => {
      ders[i2] = () => dy.clone();
    });
    return ders;
  }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const argMaxGradConfig = {
  kernelName: ArgMax,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => zerosLike$3(x2) };
  }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const argMinGradConfig = {
  kernelName: ArgMin,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => zerosLike$3(x2) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const asinGradConfig = {
  kernelName: Asin,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, sqrt$2(sub$2(scalar(1), square$2(cast$4(x2, "float32"))))) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const asinhGradConfig = {
  kernelName: Asinh,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return {
      x: () => {
        const a6 = sqrt$2(add$1(scalar(1), square$2(cast$4(x2, "float32"))));
        return div$1(dy, a6);
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const atan2GradConfig = {
  kernelName: Atan2,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      const d2 = add$1(square$2(a6), square$2(b2));
      let res = mul(dy, div$1(b2, d2));
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, a6.shape);
    };
    const derB = () => {
      const d2 = add$1(square$2(a6), square$2(b2));
      let res = neg$2(mul(dy, div$1(a6, d2)));
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, b2.shape);
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const atanGradConfig = {
  kernelName: Atan,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, add$1(square$2(cast$4(x2, "float32")), 1)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const atanhGradConfig = {
  kernelName: Atanh,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, sub$2(scalar(1), square$2(cast$4(x2, "float32")))) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool3dGrad_(dy, input, filterSize, strides, pad2, dimRoundingMode) {
  const $dy = convertToTensor(dy, "dy", "avgPool3dGrad");
  const $input = convertToTensor(input, "input", "avgPool3dGrad");
  let dy5D = $dy;
  let input5D = $input;
  let reshapedTo5D = false;
  if ($input.rank === 4) {
    reshapedTo5D = true;
    dy5D = reshape$3($dy, [1, $dy.shape[0], $dy.shape[1], $dy.shape[2], $dy.shape[3]]);
    input5D = reshape$3($input, [
      1,
      $input.shape[0],
      $input.shape[1],
      $input.shape[2],
      $input.shape[3]
    ]);
  }
  assert$1(dy5D.rank === 5, () => `Error in avgPool3dGrad: dy must be rank 5 but got rank ${dy5D.rank}.`);
  assert$1(input5D.rank === 5, () => `Error in avgPool3dGrad: input must be rank 5 but got rank ${input5D.rank}.`);
  checkPadOnDimRoundingMode("avgPool3dGrad", pad2, dimRoundingMode);
  const inputs = { dy: dy5D, input: input5D };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode };
  const res = ENGINE.runKernel(AvgPool3DGrad, inputs, attrs);
  if (reshapedTo5D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3], res.shape[4]]);
  }
  return res;
}
const avgPool3dGrad = op({ avgPool3dGrad_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const avgPool3DGradConfig$2 = {
  kernelName: AvgPool3D,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
    return {
      x: () => avgPool3dGrad(dy, x2, filterSize, strides, pad2, dimRoundingMode)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPoolGrad_(dy, input, filterSize, strides, pad2) {
  const $dy = convertToTensor(dy, "dy", "avgPoolGrad");
  const $input = convertToTensor(input, "input", "avgPoolGrad");
  assert$1($input.rank === $dy.rank, () => `Rank of input (${$input.rank}) does not match rank of dy (${$dy.rank})`);
  let input4D = $input;
  let dy4D = $dy;
  let reshapedTo4D = false;
  if ($input.rank === 3) {
    reshapedTo4D = true;
    input4D = reshape$3($input, [1, $input.shape[0], $input.shape[1], $input.shape[2]]);
    dy4D = reshape$3($dy, [1, $dy.shape[0], $dy.shape[1], $dy.shape[2]]);
  }
  assert$1(dy4D.rank === 4, () => `Error in avgPoolGrad: dy must be rank 4 but got rank ${dy4D.rank}.`);
  assert$1(input4D.rank === 4, () => `Error in avgPoolGrad: input must be rank 4 but got rank ${input4D.rank}.`);
  const inputs = { dy: dy4D, input: input4D };
  const attrs = { filterSize, strides, pad: pad2 };
  const res = ENGINE.runKernel(AvgPoolGrad, inputs, attrs);
  if (reshapedTo4D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3]]);
  }
  return res;
}
const avgPoolGrad$2 = op({ avgPoolGrad_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const avgPoolGradConfig$2 = {
  kernelName: AvgPool,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { filterSize, strides, pad: pad2 } = attrs;
    return { x: () => avgPoolGrad$2(dy, x2, filterSize, strides, pad2) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const batchMatMulGradConfig = {
  kernelName: BatchMatMul,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved, attrs) => {
    const [a6, b2] = saved;
    const { transposeA, transposeB } = attrs;
    if (!transposeA && !transposeB) {
      return {
        a: () => matMul$1(dy, b2, false, true),
        b: () => matMul$1(a6, dy, true, false)
      };
    } else if (!transposeA && transposeB) {
      return {
        a: () => matMul$1(dy, b2, false, false),
        b: () => matMul$1(dy, a6, true, false)
      };
    } else if (transposeA && !transposeB) {
      return {
        a: () => matMul$1(b2, dy, false, true),
        b: () => matMul$1(a6, dy, false, false)
      };
    } else {
      return {
        a: () => matMul$1(b2, dy, true, true),
        b: () => matMul$1(dy, a6, true, true)
      };
    }
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const batchToSpaceNDGradConfig = {
  kernelName: BatchToSpaceND,
  gradFunc: (dy, saved, attrs) => {
    const { blockShape, crops } = attrs;
    return { x: () => spaceToBatchND$3(dy, blockShape, crops) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const broadcastToGradConfig = {
  kernelName: BroadcastTo,
  gradFunc: (dy, saved, attrs) => {
    const broadCastToAttrs = attrs;
    const inputShape = broadCastToAttrs.inputShape;
    const outputShape = broadCastToAttrs.shape;
    const reps = Array.from(outputShape);
    for (let i2 = inputShape.length - 1; i2 >= 0; i2--) {
      if (inputShape[i2] === outputShape[i2]) {
        reps[i2] = 1;
      } else if (inputShape[i2] !== 1) {
        throw new Error(`broadcastTo(): [${inputShape}] cannot be broadcast to [${outputShape}].`);
      }
    }
    const axes = [];
    for (let i2 = 0; i2 < reps.length; i2++) {
      if (reps[i2] > 1) {
        axes.push(i2);
      }
    }
    return { x: () => sum$3(dy, axes, true) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const castGradConfig = {
  kernelName: Cast,
  gradFunc: (dy) => {
    return { x: () => dy.clone() };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ceilGradConfig = {
  kernelName: Ceil,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const clipByValueGradConfig = {
  kernelName: ClipByValue,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { clipValueMin, clipValueMax } = attrs;
    return {
      x: () => where(logicalAnd$2(greaterEqual$2(x2, clipValueMin), lessEqual$2(x2, clipValueMax)), dy, zerosLike$3(dy))
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const complexAbsGradConfig = {
  kernelName: ComplexAbs,
  inputsToSave: ["x"],
  gradFunc: absGradConfig.gradFunc
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const concatGradConfig = {
  kernelName: Concat,
  saveAllInputs: true,
  gradFunc: (dy, saved, attrs) => {
    const shapes = saved.map((t2) => t2.shape);
    const { axis } = attrs;
    const $axis = parseAxisParam(axis, saved[0].shape)[0];
    const sizeSplits = shapes.map((s2) => s2[$axis]);
    const derTensors = split$2(dy, sizeSplits, $axis);
    return derTensors.map((t2) => () => t2);
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const conv2DGradConfig = {
  kernelName: Conv2D$1,
  inputsToSave: ["x", "filter"],
  gradFunc: (dy, saved, attrs) => {
    const [x4D, $filter] = saved;
    const { dilations, strides, pad: pad2, dataFormat } = attrs;
    assert$1(tupleValuesAreOne(dilations), () => `Error in gradient of conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${dilations}'`);
    return {
      x: () => conv2DBackpropInput$3(x4D.shape, dy, $filter, strides, pad2, dataFormat),
      filter: () => conv2DBackpropFilter$2(x4D, dy, $filter.shape, strides, pad2, dataFormat)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const conv2DBackpropInputGradConfig = {
  kernelName: Conv2DBackpropInput,
  inputsToSave: ["dy", "filter"],
  gradFunc: (ddx, saved, attrs) => {
    const [dy, filter2] = saved;
    const { strides, pad: pad2, dataFormat, dimRoundingMode } = attrs;
    return {
      dy: () => conv2d$3(ddx, filter2, strides, pad2, dataFormat, 1, dimRoundingMode),
      filter: () => conv2DBackpropFilter$2(ddx, dy, filter2.shape, strides, pad2, dataFormat, dimRoundingMode)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3DBackpropFilter_(x2, dy, filterShape, strides, pad2) {
  let x5D = x2;
  if (x2.rank === 4) {
    x5D = reshape$3(x2, [1, x2.shape[0], x2.shape[1], x2.shape[2], x2.shape[3]]);
  }
  let dy5D = dy;
  if (dy5D.rank === 4) {
    dy5D = reshape$3(dy, [1, dy.shape[0], dy.shape[1], dy.shape[2], dy.shape[3]]);
  }
  assert$1(x5D.rank === 5, () => `Error in conv3dDerFilter: input must be rank 5, but got shape ${x5D.shape}.`);
  assert$1(dy5D.rank === 5, () => `Error in conv3dDerFilter: dy must be rank 5, but got shape ${dy5D.shape}.`);
  assert$1(filterShape.length === 5, () => `Error in conv3dDerFilter: filterShape must be length 5, but got ${filterShape}.`);
  assert$1(x5D.shape[4] === filterShape[3], () => `Error in conv3dDerFilter: depth of input ${x5D.shape[4]}) must match input depth in filter (${filterShape[3]}.`);
  assert$1(dy5D.shape[4] === filterShape[4], () => `Error in conv3dDerFilter: depth of dy (${dy5D.shape[4]}) must match output depth for filter (${filterShape[4]}).`);
  const inputs = { x: x5D, dy: dy5D };
  const attrs = { strides, pad: pad2, filterShape };
  return ENGINE.runKernel(Conv3DBackpropFilterV2, inputs, attrs);
}
const conv3DBackpropFilter = op({ conv3DBackpropFilter_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const conv3DGradConfig = {
  kernelName: Conv3D$1,
  inputsToSave: ["x", "filter"],
  gradFunc: (dy, saved, attrs) => {
    const { dilations, strides, pad: pad2 } = attrs;
    assert$1(tupleValuesAreOne(dilations), () => `Error in gradient of conv3D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${dilations}'`);
    const [x5D, $filter] = saved;
    return {
      x: () => conv3DBackpropInput$1(x5D.shape, dy, $filter, strides, pad2),
      filter: () => conv3DBackpropFilter(x5D, dy, $filter.shape, strides, pad2)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const cosGradConfig = {
  kernelName: Cos,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(neg$2(sin$2(cast$4(x2, "float32"))), dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const coshGradConfig = {
  kernelName: Cosh,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(sinh$2(cast$4(x2, "float32")), dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const cumsumGradConfig = {
  kernelName: Cumsum,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { axis, exclusive, reverse: reverse2 } = attrs;
    return {
      x: () => {
        const permutation = getAxesPermutation([axis], x2.rank);
        let out = cumsum$3(dy, axis, exclusive, !reverse2);
        if (permutation != null) {
          out = transpose$3(out, permutation);
        }
        return out;
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const depthwiseConv2dNativeGradConfig = {
  kernelName: DepthwiseConv2dNative,
  inputsToSave: ["x", "filter"],
  gradFunc: (dy, saved, attrs) => {
    const { dilations, strides, pad: pad2, dimRoundingMode } = attrs;
    const $dilations = dilations == null ? [1, 1] : dilations;
    assert$1(tupleValuesAreOne($dilations), () => `Error in gradient of depthwiseConv2dNative: dilation rates greater than 1 are not yet supported. Got dilations '${$dilations}'`);
    const [x2, filter2] = saved;
    assert$1(x2.rank === 4, () => `Error in gradient of depthwiseConv2dNative: input must be rank 4, but got rank ${x2.rank}.`);
    assert$1(filter2.rank === 4, () => `Error in gradient of depthwiseConv2dNative: filter must be rank 4, but got rank ${filter2.rank}.`);
    assert$1(x2.shape[3] === filter2.shape[2], () => `Error in gradient of depthwiseConv2d: number of input channels (${x2.shape[3]}) must match the inChannels dimension in filter ${filter2.shape[2]}.`);
    assert$1(eitherStridesOrDilationsAreOne(strides, $dilations), () => `Error in gradient of depthwiseConv2d: Either strides or dilations must be  1. Got strides ${strides} and dilations '${$dilations}'.`);
    checkPadOnDimRoundingMode("depthwiseConv2d", pad2, dimRoundingMode);
    return {
      x: () => depthwiseConv2dNativeBackpropInput$2(x2.shape, dy, filter2, strides, pad2, $dilations, dimRoundingMode),
      filter: () => depthwiseConv2dNativeBackpropFilter$2(x2, dy, filter2.shape, strides, pad2, $dilations, dimRoundingMode)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const dilation2dGradConfig = {
  kernelName: Dilation2D,
  inputsToSave: ["x", "filter"],
  gradFunc: (dy, saved, attrs) => {
    const [x2, filter2] = saved;
    const inputInputs = { x: x2, filter: filter2, dy };
    const filterInputs = { x: x2, filter: filter2, dy };
    return {
      x: () => ENGINE.runKernel(Dilation2DBackpropInput, inputInputs, attrs),
      filter: () => ENGINE.runKernel(Dilation2DBackpropFilter, filterInputs, attrs)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const eluGradConfig$2 = {
  kernelName: Elu$1,
  outputsToSave: [true],
  gradFunc: (dy, saved) => {
    const [y2] = saved;
    const inputs = { dy, y: y2 };
    return { x: () => ENGINE.runKernel(EluGrad, inputs) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const erfGradConfig = {
  kernelName: Erf,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    const a6 = mul(exp$2(neg$2(square$2(x2))), 2 / Math.sqrt(Math.PI));
    return { x: () => mul(dy, a6) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const expGradConfig = {
  kernelName: Exp,
  outputsToSave: [true],
  gradFunc: (dy, saved) => {
    const [y2] = saved;
    return { x: () => mul(dy, y2) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const expandDimsGradConfig = {
  kernelName: ExpandDims,
  inputsToSave: ["input"],
  gradFunc: (dy, saved) => {
    const [input] = saved;
    return { input: () => reshape$3(dy, input.shape) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const expm1GradConfig = {
  kernelName: Expm1,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(dy, exp$2(x2)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const floorGradConfig = {
  kernelName: Floor,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const floorDivGradConfig = {
  kernelName: FloorDiv,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      const res = div$1(dy, cast$4(b2, "float32"));
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        return reshape$3(sum$3(res, reduceAxes), a6.shape);
      }
      return res;
    };
    const derB = () => {
      let res = mul(dy, cast$4(a6, "float32"));
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        res = reshape$3(sum$3(res, reduceAxes), b2.shape);
      }
      const tmp = square$2(b2);
      return neg$2(div$1(res, cast$4(tmp, "float32")));
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const fusedBatchNormGradConfig = {
  kernelName: FusedBatchNorm,
  inputsToSave: ["x", "mean", "variance", "scale"],
  gradFunc: (dy, saved, attrs) => {
    const { varianceEpsilon } = attrs;
    const [x2, mean2, variance, scale2] = saved;
    const scaleValue = scale2 == null ? scalar(1) : scale2;
    const reductionAxes = getReductionAxes(mean2.shape, x2.shape);
    const tileShape = [];
    if (mean2.rank === 1) {
      for (let i2 = 0; i2 < x2.shape.length - 1; ++i2) {
        tileShape.push(x2.shape[i2]);
      }
      tileShape.push(1);
    }
    const xMinusMean = sub$2(x2, mean2);
    const dyTimesScaleValue = mul(dy, scaleValue);
    const oneOverSqrtVariance = rsqrt$2(add$1(variance, scalar(varianceEpsilon)));
    const minusHalfRCube = mul(mul(mul(oneOverSqrtVariance, oneOverSqrtVariance), oneOverSqrtVariance), scalar(-0.5));
    const derX = () => {
      if (mean2.rank === 1) {
        return reshape$3(mul(mul(dy, tile$4(reshape$3(oneOverSqrtVariance, [1, 1, 1, mean2.shape[0]]), tileShape)), scaleValue), x2.shape);
      } else {
        return reshape$3(mul(mul(dy, oneOverSqrtVariance), scaleValue), x2.shape);
      }
    };
    const derMean = () => {
      let meanDer = mul(mul(oneOverSqrtVariance, scalar(-1)), dyTimesScaleValue);
      if (mean2.rank === 1) {
        meanDer = sum$3(meanDer, reductionAxes);
      }
      return reshape$3(meanDer, mean2.shape);
    };
    const derVariance = () => {
      let varianceDer = mul(mul(minusHalfRCube, xMinusMean), dyTimesScaleValue);
      if (mean2.rank === 1) {
        varianceDer = sum$3(varianceDer, reductionAxes);
      }
      return reshape$3(varianceDer, mean2.shape);
    };
    const derScale = () => {
      const xMinusMean2TimesRsqrt = mul(xMinusMean, oneOverSqrtVariance);
      let scaleDer = mul(dy, xMinusMean2TimesRsqrt);
      if (mean2.rank === 1) {
        scaleDer = sum$3(scaleDer, reductionAxes);
      }
      return reshape$3(scaleDer, mean2.shape);
    };
    const derOffset = () => {
      let offsetDer = dy;
      if (mean2.rank === 1) {
        offsetDer = sum$3(offsetDer, reductionAxes);
      }
      return reshape$3(offsetDer, mean2.shape);
    };
    return {
      x: derX,
      mean: derMean,
      variance: derVariance,
      scale: derScale,
      offset: derOffset
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const gatherGradConfig = {
  kernelName: GatherV2,
  inputsToSave: ["x", "indices"],
  gradFunc: (dy, saved, attrs) => {
    const [x2, indices] = saved;
    const { axis } = attrs;
    const parsedAxis = parseAxisParam(axis, x2.shape)[0];
    const derX = () => {
      const paramsShape = x2.shape;
      const indicesSize = indices.size;
      const outerShape = paramsShape.slice(0, parsedAxis);
      const outerDims = outerShape.length;
      const innerShape = paramsShape.slice(axis, paramsShape.length).slice(1);
      const innerDims = innerShape.length;
      const outerAxesIndices = arrayRange(0, outerDims);
      const innerAxesIndices = arrayRange(outerDims + 1, outerDims + 1 + innerDims);
      const valuesShape = arrayConcat([outerShape, [indicesSize], innerShape]);
      const values = reshape$3(dy, valuesShape);
      const reshapedIndices = reshape$3(indices, [indicesSize]);
      const transposeDims = arrayConcat([[outerDims], outerAxesIndices, innerAxesIndices]);
      const valuesTranspose = transpose$3(values, transposeDims);
      let paramsGrad = unsortedSegmentSum$2(valuesTranspose, reshapedIndices, x2.shape[parsedAxis]);
      const invertTransposeDims = getUndoAxesPermutation(transposeDims);
      paramsGrad = transpose$3(paramsGrad, invertTransposeDims);
      return paramsGrad;
    };
    return { x: derX, indices: () => indices };
  }
};
function arrayRange(start, stop) {
  const result2 = [];
  for (let i2 = start; i2 < stop; ++i2) {
    result2.push(i2);
  }
  return result2;
}
function arrayConcat(arrays) {
  const result2 = [];
  for (let i2 = 0; i2 < arrays.length; ++i2) {
    for (let j2 = 0; j2 < arrays[i2].length; ++j2) {
      result2.push(arrays[i2][j2]);
    }
  }
  return result2;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const greaterEqualGradConfig = {
  kernelName: GreaterEqual,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    return { a: () => zerosLike$3(a6), b: () => zerosLike$3(b2) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const identityGradConfig = {
  kernelName: Identity$1,
  gradFunc: (dy) => {
    return { x: () => cast$4(dy, "float32") };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const isFiniteGradConfig = {
  kernelName: IsFinite,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const isInfGradConfig = {
  kernelName: IsInf,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const isNanGradConfig = {
  kernelName: IsNan,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const leakyReluGradConfig = {
  kernelName: LeakyRelu,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { alpha: alpha2 } = attrs;
    const mask = greater$2(x2, 0);
    return { x: () => where(mask, dy, mul(dy, alpha2)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const log1pGradConfig = {
  kernelName: Log1p,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, add$1(x2, 1)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logGradConfig = {
  kernelName: Log,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, cast$4(x2, "float32")) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logSoftmaxGradConfig = {
  kernelName: LogSoftmax$1,
  inputsToSave: [],
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const [value] = saved;
    const { axis } = attrs;
    return {
      logits: () => {
        const keepDims = true;
        const softmax2 = exp$2(value);
        return sub$2(dy, mul(sum$3(dy, axis, keepDims), softmax2));
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function localResponseNormalizationBackprop_(x2, y2, dy, depthRadius = 5, bias = 1, alpha2 = 1, beta = 0.5) {
  const inputs = { x: x2, y: y2, dy };
  const attrs = { depthRadius, bias, alpha: alpha2, beta };
  return ENGINE.runKernel(LRNGrad, inputs, attrs);
}
const localResponseNormalizationBackprop = op({ localResponseNormalizationBackprop_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const lrnGradConfig = {
  kernelName: LRN,
  inputsToSave: ["x"],
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const [x2, y2] = saved;
    const { depthRadius, bias, alpha: alpha2, beta } = attrs;
    return {
      x: () => localResponseNormalizationBackprop(x2, y2, dy, depthRadius, bias, alpha2, beta)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gradForMinAndMax(dy, y2, xOrig, origAxes) {
  if (y2.rank < xOrig.rank) {
    y2 = reshape$3(y2, expandShapeToKeepDim(y2.shape, origAxes));
  }
  if (dy.rank < xOrig.rank) {
    dy = reshape$3(dy, expandShapeToKeepDim(dy.shape, origAxes));
  }
  return {
    x: () => {
      const dx = mul(dy, cast$4(equal$2(xOrig, y2), dy.dtype));
      return dx;
    }
  };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maxGradConfig = {
  kernelName: Max,
  inputsToSave: ["x"],
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const maxAttrs = attrs;
    const { reductionIndices } = maxAttrs;
    const x2 = saved[0];
    const y2 = saved[1];
    const origAxes = parseAxisParam(reductionIndices, x2.shape);
    const maxGrad = gradForMinAndMax(dy, y2, x2, origAxes);
    return {
      x: () => {
        return maxGrad["x"]();
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maximumGradConfig = {
  kernelName: Maximum$1,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const derA = () => mul(dy, cast$4(greaterEqual$2(a6, b2), "float32"));
    const derB = () => mul(dy, cast$4(less$2(a6, b2), "float32"));
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool3dGrad_(dy, input, output2, filterSize, strides, pad2, dimRoundingMode) {
  const $dy = convertToTensor(dy, "dy", "maxPool3dGrad");
  const $input = convertToTensor(input, "input", "maxPool3dGrad");
  const $output = convertToTensor(output2, "output", "maxPool3dGrad");
  let dy5D = $dy;
  let input5D = $input;
  let output5D = $output;
  let reshapedTo5D = false;
  if ($input.rank === 4) {
    reshapedTo5D = true;
    dy5D = reshape$3($dy, [1, $dy.shape[0], $dy.shape[1], $dy.shape[2], $dy.shape[3]]);
    input5D = reshape$3($input, [
      1,
      $input.shape[0],
      $input.shape[1],
      $input.shape[2],
      $input.shape[3]
    ]);
    output5D = reshape$3($output, [
      1,
      $output.shape[0],
      $output.shape[1],
      $output.shape[2],
      $output.shape[3]
    ]);
  }
  assert$1(dy5D.rank === 5, () => `Error in maxPool3dGrad: dy must be rank 5 but got rank ${dy5D.rank}.`);
  assert$1(input5D.rank === 5, () => `Error in maxPool3dGrad: input must be rank 5 but got rank ${input5D.rank}.`);
  assert$1(output5D.rank === 5, () => `Error in maxPool3dGrad: output must be rank 5 but got rank ${output5D.rank}.`);
  checkPadOnDimRoundingMode("maxPool3dGrad", pad2, dimRoundingMode);
  const inputs = { dy: dy5D, input: input5D, output: output5D };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode };
  const res = ENGINE.runKernel(MaxPool3DGrad, inputs, attrs);
  if (reshapedTo5D) {
    return reshape$3(res, [res.shape[1], res.shape[2], res.shape[3], res.shape[4]]);
  }
  return res;
}
const maxPool3dGrad = op({ maxPool3dGrad_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maxPool3DGradConfig$2 = {
  kernelName: MaxPool3D,
  inputsToSave: ["x"],
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const [x2, y2] = saved;
    const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
    return {
      x: () => maxPool3dGrad(dy, x2, y2, filterSize, strides, pad2, dimRoundingMode)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPoolGrad_(dy, input, output2, filterSize, strides, pad2, dimRoundingMode) {
  const $dy = convertToTensor(dy, "dy", "maxPoolGrad");
  const $input = convertToTensor(input, "input", "maxPoolGrad");
  const $output = convertToTensor(output2, "output", "maxPoolGrad");
  assert$1($input.rank === $dy.rank, () => `Rank of input (${$input.rank}) does not match rank of dy (${$dy.rank})`);
  assert$1($dy.rank === 4, () => `Error in maxPoolGrad: dy must be rank 4 but got rank ${$dy.rank}.`);
  assert$1($input.rank === 4, () => `Error in maxPoolGrad: input must be rank 4 but got rank ${$input.rank}.`);
  checkPadOnDimRoundingMode("maxPoolGrad", pad2, dimRoundingMode);
  const inputs = { dy: $dy, input: $input, output: $output };
  const attrs = { filterSize, strides, pad: pad2, dimRoundingMode };
  return ENGINE.runKernel(MaxPoolGrad, inputs, attrs);
}
const maxPoolGrad$2 = op({ maxPoolGrad_ });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maxPoolGradConfig$2 = {
  kernelName: MaxPool,
  inputsToSave: ["x"],
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const [x2, y2] = saved;
    const { filterSize, strides, pad: pad2 } = attrs;
    return {
      x: () => maxPoolGrad$2(dy, x2, y2, filterSize, strides, pad2)
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const meanGradConfig = {
  kernelName: Mean,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { axis } = attrs;
    const axes = parseAxisParam(axis, x2.shape);
    const shapes = computeOutAndReduceShapes(x2.shape, axes);
    const reduceShape = shapes[1];
    const reduceSize = sizeFromShape(reduceShape);
    const derX = () => {
      const expandedDyShape = x2.shape.slice();
      axes.forEach((axis2) => {
        expandedDyShape[axis2] = 1;
      });
      const expandedDy = reshape$3(dy, expandedDyShape);
      const res = div$1(mul(expandedDy, ones(x2.shape, "float32")), reduceSize);
      return res;
    };
    return { x: derX };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const minGradConfig = {
  kernelName: Min,
  inputsToSave: ["x"],
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const minAttrs = attrs;
    const { axis } = minAttrs;
    const [x2, y2] = saved;
    const origAxes = parseAxisParam(axis, x2.shape);
    const minGrad = gradForMinAndMax(dy, y2, x2, origAxes);
    return {
      x: () => {
        return minGrad["x"]();
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const minimumGradConfig = {
  kernelName: Minimum$1,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const derA = () => mul(dy, cast$4(lessEqual$2(a6, b2), "float32"));
    const derB = () => mul(dy, cast$4(greater$2(a6, b2), "float32"));
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const mirrorPadGradConfig = {
  kernelName: MirrorPad,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const x2 = saved[0];
    const { paddings } = attrs;
    const begin = paddings.map((p2) => p2[0]);
    return { x: () => slice$3(dy, begin, x2.shape) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const modGradConfig = {
  kernelName: Mod,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        return reshape$3(sum$3(dy, reduceAxes), a6.shape);
      }
      return dy;
    };
    const derB = () => {
      const res = mul(dy, neg$2(floor$2(div$1(a6, b2))));
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        return reshape$3(sum$3(res, reduceAxes), b2.shape);
      }
      return res;
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const multiplyGradConfig = {
  kernelName: Multiply$1,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      const res = mul(dy, cast$4(b2, "float32"));
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        return reshape$3(sum$3(res, reduceAxes), a6.shape);
      }
      return res;
    };
    const derB = () => {
      const res = mul(dy, cast$4(a6, "float32"));
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        return reshape$3(sum$3(res, reduceAxes), b2.shape);
      }
      return res;
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const negGradConfig = {
  kernelName: Neg,
  gradFunc: (dy) => {
    return { x: () => neg$2(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const oneHotGradConfig = {
  kernelName: OneHot,
  inputsToSave: ["indices"],
  gradFunc: (dy, saved) => {
    const indices = saved[0];
    return { indices: () => zeros$1(indices.shape, "float32") };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const onesLikeGradConfig = {
  kernelName: OnesLike,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const packGradConfig = {
  kernelName: Pack,
  saveAllInputs: true,
  gradFunc: (dy, saved, attrs) => {
    const { axis } = attrs;
    const derTensors = unstack(dy, axis);
    return derTensors.map((t2) => () => t2);
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const padV2GradConfig = {
  kernelName: PadV2,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const x2 = saved[0];
    const { paddings } = attrs;
    const begin = paddings.map((p2) => p2[0]);
    return { x: () => slice$3(dy, begin, x2.shape) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const powGradConfig = {
  kernelName: Pow,
  inputsToSave: ["a", "b"],
  outputsToSave: [true],
  gradFunc: (dy, saved) => {
    const [a6, b2, y2] = saved;
    const base = a6;
    const exp2 = b2;
    const outShape = assertAndGetBroadcastShape(base.shape, exp2.shape);
    const derBase = () => {
      const expFloat = cast$4(exp2, "float32");
      let res = mul(dy, mul(expFloat, pow$2(base, sub$2(expFloat, scalar(1)))));
      const reduceAxes = getReductionAxes(base.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, base.shape);
    };
    const derExp = () => {
      const condition = greater$2(base, 0);
      const logBase = where(condition, log$7(base), zerosLike$3(base));
      let res = mul(dy, mul(y2, logBase));
      const reduceAxes = getReductionAxes(exp2.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, exp2.shape);
    };
    return { a: derBase, b: derExp };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const preluGradConfig = {
  kernelName: Prelu,
  inputsToSave: ["x", "alpha"],
  gradFunc: (dy, saved) => {
    const [x2, alpha2] = saved;
    const mask = greater$2(x2, 0);
    return {
      x: () => where(mask, dy, mul(dy, alpha2)),
      alpha: () => {
        let res = where(mask, zerosLike$3(dy), mul(dy, x2));
        const reduceAxes = getReductionAxes(alpha2.shape, dy.shape);
        if (reduceAxes.length > 0) {
          res = sum$3(res, reduceAxes);
        }
        return reshape$3(res, alpha2.shape);
      }
    };
  }
};
/**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function prodGradFn_(x2, dy, axis) {
  const expandedYShape = x2.shape.slice();
  expandedYShape[axis] = 1;
  const expandedDy = reshape$3(dy, expandedYShape);
  const xCumProd = cumprod$3(x2, axis, true, false);
  const xCumRevProd = cumprod$3(x2, axis, true, true);
  const dx = mul(xCumProd, xCumRevProd);
  return mul(expandedDy, dx);
}
function prodsGradFn_(x2, dy, axis) {
  const xRank = x2.shape.length;
  const finalProdAxis = xRank - axis.length;
  const xPermutation = getAxesPermutation(axis, xRank);
  let permutedX = x2;
  if (xPermutation != null) {
    permutedX = transpose$3(x2, xPermutation);
  }
  const newShape = permutedX.shape.slice();
  const removedShape = newShape.splice(xRank - axis.length, axis.length);
  const endPartShape = removedShape.reduce((p2, c2) => p2 * c2, 1);
  newShape.push(endPartShape);
  const reshapedPermutedX = permutedX.reshape(newShape);
  let prodGrad = prodGradFn_(reshapedPermutedX, dy, finalProdAxis);
  prodGrad = prodGrad.reshape(permutedX.shape);
  if (xPermutation != null) {
    const undoPermutation = getUndoAxesPermutation(xPermutation);
    prodGrad = transpose$3(prodGrad, undoPermutation);
  }
  return prodGrad;
}
const prodGradConfig = {
  kernelName: Prod,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { axis } = attrs;
    let axisArr = [];
    if (axis === void 0 || axis === null) {
      axisArr = x2.shape.map((_24, i2) => i2);
    } else if (typeof axis === "number") {
      axisArr = [axis];
    } else {
      axisArr = axis;
    }
    return { x: () => prodsGradFn_(x2, dy, axisArr) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const divGradConfig = {
  kernelName: RealDiv,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      const res = div$1(dy, cast$4(b2, "float32"));
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        return reshape$3(sum$3(res, reduceAxes), a6.shape);
      }
      return res;
    };
    const derB = () => {
      let res = mul(dy, cast$4(a6, "float32"));
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        res = reshape$3(sum$3(res, reduceAxes), b2.shape);
      }
      const tmp = square$2(b2);
      return neg$2(div$1(res, cast$4(tmp, "float32")));
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const reciprocalGradConfig = {
  kernelName: Reciprocal,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, neg$2(square$2(x2))) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const relu6GradConfig = {
  kernelName: Relu6$1,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    const mask = mul(lessEqual$2(x2, 6), step$3(x2));
    return { x: () => mul(dy, cast$4(mask, "float32")) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const reluGradConfig = {
  kernelName: Relu$1,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(dy, cast$4(step$3(x2), "float32")) };
  }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const reshapeGradConfig = {
  kernelName: Reshape$1,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => reshape$3(dy, x2.shape) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const resizeBilinearGradConfig$2 = {
  kernelName: ResizeBilinear,
  inputsToSave: ["images"],
  gradFunc: (dy, saved, attrs) => {
    const [images] = saved;
    const inputs = { dy, images };
    const imagesDer = () => ENGINE.runKernel(ResizeBilinearGrad, inputs, attrs);
    return { images: imagesDer };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const resizeNearestNeighborGradConfig$2 = {
  kernelName: ResizeNearestNeighbor,
  inputsToSave: ["images"],
  gradFunc: (dy, saved, attrs) => {
    const [images] = saved;
    const inputs = { dy, images };
    const imagesDer = () => ENGINE.runKernel(ResizeNearestNeighborGrad, inputs, attrs);
    return { images: imagesDer };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const reverseGradConfig = {
  kernelName: Reverse,
  gradFunc: (dy, saved, attrs) => {
    const { dims } = attrs;
    const axes = parseAxisParam(dims, dy.shape);
    return { x: () => reverse$3(dy, axes) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const roundGradConfig = {
  kernelName: Round,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const rsqrtGradConfig = {
  kernelName: Rsqrt,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => neg$2(div$1(dy, mul(pow$2(x2, 1.5), 2))) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const selectGradConfig = {
  kernelName: Select$1,
  inputsToSave: ["condition"],
  gradFunc: (dy, saved) => {
    const [condition] = saved;
    return {
      condition: () => cast$4(zerosLike$3(condition), "float32"),
      t: () => mul(dy, cast$4(condition, dy.dtype)),
      e: () => mul(dy, cast$4(logicalNot$2(condition), dy.dtype))
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const seluGradConfig = {
  kernelName: Selu$1,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return {
      x: () => {
        const mask = greater$2(x2, scalar(0));
        const scaleAlpha2 = scalar(SELU_SCALEALPHA);
        const scale2 = scalar(SELU_SCALE);
        const greaterThanZeroDer = mul(dy, scale2);
        const lessEqualZeroDer = mul(mul(dy, scaleAlpha2), exp$2(cast$4(x2, "float32")));
        return where(mask, greaterThanZeroDer, lessEqualZeroDer);
      }
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sigmoidGradConfig = {
  kernelName: Sigmoid$1,
  outputsToSave: [true],
  gradFunc: (dy, saved) => {
    const [y2] = saved;
    return { x: () => mul(dy, mul(y2, sub$2(scalar(1), y2))) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const signGradConfig = {
  kernelName: Sign,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sinGradConfig = {
  kernelName: Sin,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(cos$2(cast$4(x2, "float32")), dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sinhGradConfig = {
  kernelName: Sinh,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(cosh$2(cast$4(x2, "float32")), dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sliceGradConfig = {
  kernelName: Slice,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { begin, size } = attrs;
    const inputShape = x2.shape;
    const [begin_, size_] = parseSliceParams(x2, begin, size);
    const paddings = [];
    for (let i2 = 0; i2 < dy.rank; i2++) {
      paddings.push([begin_[i2], inputShape[i2] - begin_[i2] - size_[i2]]);
    }
    return { x: () => pad$1(dy, paddings) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const softmaxGradConfig = {
  kernelName: Softmax$2,
  outputsToSave: [true],
  gradFunc: (dy, saved, attrs) => {
    const [y2] = saved;
    const { dim } = attrs;
    const keepDims = true;
    const dyTimesY = mul(dy, y2);
    return {
      logits: () => sub$2(dyTimesY, mul(sum$3(dyTimesY, [dim], keepDims), y2))
    };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const softplusGradConfig = {
  kernelName: Softplus$1,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(dy, sigmoid$3(x2)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const spaceToBatchNDGradConfig = {
  kernelName: SpaceToBatchND,
  gradFunc: (dy, saved, attrs) => {
    const { blockShape, paddings } = attrs;
    return { x: () => batchToSpaceND$3(dy, blockShape, paddings) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const splitVGradConfig = {
  kernelName: SplitV,
  gradFunc: (dy, saved, attrs) => {
    const { axis } = attrs;
    return { x: () => concat$3(dy, axis) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sqrtGradConfig = {
  kernelName: Sqrt,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, mul(sqrt$2(cast$4(x2, "float32")), 2)) };
  }
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const squareGradConfig = {
  kernelName: Square,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => mul(dy, mul(cast$4(x2, "float32"), 2)) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const squaredDifferenceGradConfig = {
  kernelName: SquaredDifference,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const two = scalar(2);
    const derA = () => mul(dy, mul(two, sub$2(a6, b2)));
    const derB = () => mul(dy, mul(two, sub$2(b2, a6)));
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const stepGradConfig = {
  kernelName: Step,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const subGradConfig = {
  kernelName: Sub,
  inputsToSave: ["a", "b"],
  gradFunc: (dy, saved) => {
    const [a6, b2] = saved;
    const outShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const derA = () => {
      let res = dy;
      const reduceAxes = getReductionAxes(a6.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(res, a6.shape);
    };
    const derB = () => {
      let res = dy;
      const reduceAxes = getReductionAxes(b2.shape, outShape);
      if (reduceAxes.length > 0) {
        res = sum$3(res, reduceAxes);
      }
      return reshape$3(neg$2(res), b2.shape);
    };
    return { a: derA, b: derB };
  }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sumGradConfig = {
  kernelName: Sum,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const expandedDyShape = x2.shape.slice();
    const { axis } = attrs;
    const axes = parseAxisParam(axis, x2.shape);
    axes.forEach((axis2) => {
      expandedDyShape[axis2] = 1;
    });
    const expandedDy = reshape$3(dy, expandedDyShape);
    const derX = mul(expandedDy, ones(x2.shape, "float32"));
    return { x: () => derX };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tanGradConfig = {
  kernelName: Tan,
  inputsToSave: ["x"],
  gradFunc: (dy, saved) => {
    const [x2] = saved;
    return { x: () => div$1(dy, square$2(cos$2(x2))) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tanhGradConfig = {
  kernelName: Tanh$1,
  outputsToSave: [true],
  gradFunc: (dy, saved) => {
    const [y2] = saved;
    return { x: () => mul(sub$2(scalar(1), square$2(y2)), dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tileGradConfig = {
  kernelName: Tile,
  inputsToSave: ["x"],
  gradFunc: (dy, saved, attrs) => {
    const [x2] = saved;
    const { reps } = attrs;
    const derX = () => {
      let xGrad = zerosLike$3(x2);
      if (x2.rank === 1) {
        for (let i2 = 0; i2 < reps[0]; ++i2) {
          xGrad = add$1(xGrad, slice$3(dy, [i2 * x2.shape[0]], [x2.shape[0]]));
        }
      } else if (x2.rank === 2) {
        for (let i2 = 0; i2 < reps[0]; ++i2) {
          for (let j2 = 0; j2 < reps[1]; ++j2) {
            xGrad = add$1(xGrad, slice$3(dy, [i2 * x2.shape[0], j2 * x2.shape[1]], [
              x2.shape[0],
              x2.shape[1]
            ]));
          }
        }
      } else if (x2.rank === 3) {
        for (let i2 = 0; i2 < reps[0]; ++i2) {
          for (let j2 = 0; j2 < reps[1]; ++j2) {
            for (let k3 = 0; k3 < reps[2]; ++k3) {
              xGrad = add$1(xGrad, slice$3(dy, [i2 * x2.shape[0], j2 * x2.shape[1], k3 * x2.shape[2]], [x2.shape[0], x2.shape[1], x2.shape[2]]));
            }
          }
        }
      } else if (x2.rank === 4) {
        for (let i2 = 0; i2 < reps[0]; ++i2) {
          for (let j2 = 0; j2 < reps[1]; ++j2) {
            for (let k3 = 0; k3 < reps[2]; ++k3) {
              for (let l2 = 0; l2 < reps[3]; ++l2) {
                xGrad = add$1(xGrad, slice$3(dy, [
                  i2 * x2.shape[0],
                  j2 * x2.shape[1],
                  k3 * x2.shape[2],
                  l2 * x2.shape[3]
                ], [x2.shape[0], x2.shape[1], x2.shape[2], x2.shape[3]]));
              }
            }
          }
        }
      } else {
        throw new Error(`Gradient for tile operation is not implemented for rank-${x2.rank} tensors yet.`);
      }
      return xGrad;
    };
    return { x: derX };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const transposeGradConfig = {
  kernelName: Transpose,
  gradFunc: (dy, saved, attrs) => {
    const transposeAttrs = attrs;
    const { perm } = transposeAttrs;
    const undoPerm = getUndoAxesPermutation(perm);
    return { x: () => transpose$3(dy, undoPerm) };
  }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const unpackGradConfig = {
  kernelName: Unpack,
  gradFunc: (dy, saved, attrs) => {
    const unpackAttrs = attrs;
    const { axis } = unpackAttrs;
    return { value: () => stack(dy, axis) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const unsortedSegmentSumGradConfig = {
  kernelName: UnsortedSegmentSum,
  inputsToSave: ["segmentIds"],
  gradFunc: (dy, saved) => {
    const [segmentIds] = saved;
    const derX = () => {
      return gatherDropNegatives(dy, segmentIds);
    };
    return { x: derX };
  }
};
function gatherDropNegatives(x2, indices) {
  const zeroClippedIndices = maximum$2(indices, zerosLike$3(indices));
  const gathered = gather$1(x2, zeroClippedIndices);
  let isPositive2 = greaterEqual$2(indices, scalar(0, "int32"));
  const numIters = gathered.rank - isPositive2.rank;
  for (let i2 = 0; i2 < numIters; ++i2) {
    isPositive2 = expandDims$4(isPositive2, i2 + 1);
  }
  isPositive2 = logicalAnd$2(isPositive2, ones(gathered.shape, "bool"));
  const zeroSlice = zerosLike$3(gathered);
  return where(isPositive2, gathered, zeroSlice);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const zerosLikeGradConfig = {
  kernelName: ZerosLike,
  gradFunc: (dy) => {
    return { x: () => zerosLike$3(dy) };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const gradConfigs = [
  absGradConfig,
  acosGradConfig,
  acoshGradConfig,
  addGradConfig,
  addNGradConfig,
  argMaxGradConfig,
  argMinGradConfig,
  asinGradConfig,
  asinhGradConfig,
  atan2GradConfig,
  atanGradConfig,
  atanhGradConfig,
  avgPool3DGradConfig$2,
  avgPoolGradConfig$2,
  batchMatMulGradConfig,
  batchToSpaceNDGradConfig,
  broadcastToGradConfig,
  castGradConfig,
  ceilGradConfig,
  clipByValueGradConfig,
  complexAbsGradConfig,
  concatGradConfig,
  conv2DBackpropInputGradConfig,
  conv2DGradConfig,
  conv3DGradConfig,
  cosGradConfig,
  coshGradConfig,
  cumsumGradConfig,
  depthwiseConv2dNativeGradConfig,
  dilation2dGradConfig,
  divGradConfig,
  eluGradConfig$2,
  erfGradConfig,
  expGradConfig,
  expandDimsGradConfig,
  expm1GradConfig,
  floorDivGradConfig,
  floorGradConfig,
  fusedBatchNormGradConfig,
  gatherGradConfig,
  greaterEqualGradConfig,
  identityGradConfig,
  isFiniteGradConfig,
  isInfGradConfig,
  isNanGradConfig,
  leakyReluGradConfig,
  log1pGradConfig,
  logGradConfig,
  logSoftmaxGradConfig,
  lrnGradConfig,
  maxGradConfig,
  maxGradConfig,
  maximumGradConfig,
  maxPool3DGradConfig$2,
  maxPoolGradConfig$2,
  meanGradConfig,
  minGradConfig,
  minimumGradConfig,
  mirrorPadGradConfig,
  modGradConfig,
  multiplyGradConfig,
  negGradConfig,
  oneHotGradConfig,
  onesLikeGradConfig,
  packGradConfig,
  padV2GradConfig,
  padV2GradConfig,
  powGradConfig,
  preluGradConfig,
  prodGradConfig,
  reciprocalGradConfig,
  relu6GradConfig,
  reluGradConfig,
  reshapeGradConfig,
  resizeBilinearGradConfig$2,
  resizeNearestNeighborGradConfig$2,
  reverseGradConfig,
  roundGradConfig,
  rsqrtGradConfig,
  selectGradConfig,
  seluGradConfig,
  sigmoidGradConfig,
  signGradConfig,
  sinGradConfig,
  sinhGradConfig,
  sliceGradConfig,
  softmaxGradConfig,
  softplusGradConfig,
  spaceToBatchNDGradConfig,
  spaceToBatchNDGradConfig,
  splitVGradConfig,
  splitVGradConfig,
  sqrtGradConfig,
  squaredDifferenceGradConfig,
  squareGradConfig,
  stepGradConfig,
  subGradConfig,
  sumGradConfig,
  tanGradConfig,
  tanhGradConfig,
  tileGradConfig,
  transposeGradConfig,
  unpackGradConfig,
  unsortedSegmentSumGradConfig,
  zerosLikeGradConfig
];
for (const gradientConfig of gradConfigs) {
  registerGradient(gradientConfig);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.abs = function() {
  this.throwIfDisposed();
  return abs$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.acos = function() {
  this.throwIfDisposed();
  return acos$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.acosh = function() {
  this.throwIfDisposed();
  return acosh$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.add = function(b2) {
  this.throwIfDisposed();
  return add$1(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.all = function(axis, keepDims) {
  this.throwIfDisposed();
  return all$3(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.any = function(axis, keepDims) {
  this.throwIfDisposed();
  return any$3(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.argMax = function(axis) {
  this.throwIfDisposed();
  return argMax$2(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.argMin = function(axis) {
  this.throwIfDisposed();
  return argMin$2(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.asScalar = function() {
  this.throwIfDisposed();
  assert$1(this.size === 1, () => "The array must have only 1 element.");
  return reshape$3(this, []);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.asType = function(dtype) {
  this.throwIfDisposed();
  return cast$4(this, dtype);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.as1D = function() {
  this.throwIfDisposed();
  return reshape$3(this, [this.size]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.as2D = function(rows, columns) {
  this.throwIfDisposed();
  return reshape$3(this, [rows, columns]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.as3D = function(rows, columns, depth) {
  this.throwIfDisposed();
  return reshape$3(this, [rows, columns, depth]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.as4D = function(rows, columns, depth, depth2) {
  this.throwIfDisposed();
  return reshape$3(this, [rows, columns, depth, depth2]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.as5D = function(rows, columns, depth, depth2, depth3) {
  this.throwIfDisposed();
  return reshape$3(this, [rows, columns, depth, depth2, depth3]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.asin = function() {
  this.throwIfDisposed();
  return asin$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.asinh = function() {
  this.throwIfDisposed();
  return asinh$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.atan = function() {
  this.throwIfDisposed();
  return atan$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.atan2 = function(b2) {
  this.throwIfDisposed();
  return atan2$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.atanh = function() {
  this.throwIfDisposed();
  return atanh$2(this);
};
getGlobalTensorClass().prototype.avgPool = function(filterSize, strides, pad2, dimRoundingMode) {
  this.throwIfDisposed();
  return avgPool$3(this, filterSize, strides, pad2, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.batchToSpaceND = function(blockShape, crops) {
  this.throwIfDisposed();
  return batchToSpaceND$3(this, blockShape, crops);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.batchNorm = function(mean2, variance, offset, scale2, varianceEpsilon) {
  this.throwIfDisposed();
  return batchNorm$2(this, mean2, variance, offset, scale2, varianceEpsilon);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.broadcastTo = function(shape) {
  this.throwIfDisposed();
  return broadcastTo(this, shape);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.cast = function(dtype) {
  this.throwIfDisposed();
  return cast$4(this, dtype);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.ceil = function() {
  this.throwIfDisposed();
  return ceil$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.clipByValue = function(min2, max2) {
  this.throwIfDisposed();
  return clipByValue$2(this, min2, max2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.concat = function(x2, axis) {
  this.throwIfDisposed();
  if (x2 instanceof Tensor) {
    x2 = [x2];
  }
  return concat$3([this, ...x2], axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.conv1d = function(filter2, stride, pad2, dataFormat, dilation, dimRoundingMode) {
  this.throwIfDisposed();
  return conv1d(this, filter2, stride, pad2, dataFormat, dilation, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.conv2dTranspose = function(filter2, outputShape, strides, pad2, dimRoundingMode) {
  this.throwIfDisposed();
  return conv2dTranspose(this, filter2, outputShape, strides, pad2, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.conv2d = function(filter2, strides, pad2, dataFormat, dilations, dimRoundingMode) {
  this.throwIfDisposed();
  return conv2d$3(this, filter2, strides, pad2, dataFormat, dilations, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.cos = function() {
  this.throwIfDisposed();
  return cos$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.cosh = function() {
  this.throwIfDisposed();
  return cosh$2(this);
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.cumprod = function(axis, exclusive, reverse2) {
  this.throwIfDisposed();
  return cumprod$3(this, axis, exclusive, reverse2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.cumsum = function(axis, exclusive, reverse2) {
  this.throwIfDisposed();
  return cumsum$3(this, axis, exclusive, reverse2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.depthToSpace = function(blockSize, dataFormat) {
  this.throwIfDisposed();
  return depthToSpace$3(this, blockSize, dataFormat);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.depthwiseConv2d = function(filter2, strides, pad2, dataFormat, dilations, dimRoundingMode) {
  this.throwIfDisposed();
  return depthwiseConv2d$3(this, filter2, strides, pad2, dataFormat, dilations, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.dilation2d = function(filter2, strides, pad2, dilations, dataFormat) {
  this.throwIfDisposed();
  return dilation2d(this, filter2, strides, pad2, dilations, dataFormat);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.divNoNan = function(b2) {
  this.throwIfDisposed();
  return divNoNan(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.div = function(b2) {
  this.throwIfDisposed();
  return div$1(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.dot = function(b2) {
  this.throwIfDisposed();
  return dot$1(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.elu = function() {
  this.throwIfDisposed();
  return elu$3(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.equal = function(b2) {
  this.throwIfDisposed();
  return equal$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.erf = function() {
  this.throwIfDisposed();
  return erf$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.exp = function() {
  this.throwIfDisposed();
  return exp$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.expandDims = function(axis) {
  this.throwIfDisposed();
  return expandDims$4(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.expm1 = function() {
  this.throwIfDisposed();
  return expm1$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.fft = function() {
  this.throwIfDisposed();
  return fft$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.flatten = function() {
  this.throwIfDisposed();
  return reshape$3(this, [this.size]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.floor = function() {
  this.throwIfDisposed();
  return floor$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.floorDiv = function(b2) {
  this.throwIfDisposed();
  return floorDiv$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.gather = function(indices, axis) {
  this.throwIfDisposed();
  return gather$1(this, indices, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.greaterEqual = function(b2) {
  this.throwIfDisposed();
  return greaterEqual$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.greater = function(b2) {
  this.throwIfDisposed();
  return greater$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.ifft = function() {
  this.throwIfDisposed();
  return ifft$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.irfft = function() {
  this.throwIfDisposed();
  return irfft(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.isFinite = function() {
  this.throwIfDisposed();
  return isFinite$3(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.isInf = function() {
  this.throwIfDisposed();
  return isInf$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.isNaN = function() {
  this.throwIfDisposed();
  return isNaN$3(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.leakyRelu = function(alpha2) {
  this.throwIfDisposed();
  return leakyRelu$3(this, alpha2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.lessEqual = function(b2) {
  this.throwIfDisposed();
  return lessEqual$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.less = function(b2) {
  this.throwIfDisposed();
  return less$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.localResponseNormalization = function(depthRadius, bias, alpha2, beta) {
  this.throwIfDisposed();
  return localResponseNormalization(this, depthRadius, bias, alpha2, beta);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logSigmoid = function() {
  this.throwIfDisposed();
  return logSigmoid(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logSoftmax = function(axis) {
  this.throwIfDisposed();
  return logSoftmax(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logSumExp = function(axis, keepDims) {
  this.throwIfDisposed();
  return logSumExp(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.log = function() {
  this.throwIfDisposed();
  return log$7(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.log1p = function() {
  this.throwIfDisposed();
  return log1p$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logicalAnd = function(b2) {
  this.throwIfDisposed();
  return logicalAnd$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logicalNot = function() {
  this.throwIfDisposed();
  return logicalNot$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logicalOr = function(b2) {
  this.throwIfDisposed();
  return logicalOr$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.logicalXor = function(b2) {
  this.throwIfDisposed();
  return logicalXor(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.matMul = function(b2, transposeA, transposeB) {
  this.throwIfDisposed();
  return matMul$1(this, b2, transposeA, transposeB);
};
getGlobalTensorClass().prototype.maxPool = function(filterSize, strides, pad2, dimRoundingMode) {
  this.throwIfDisposed();
  return maxPool$3(this, filterSize, strides, pad2, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.max = function(axis, keepDims) {
  this.throwIfDisposed();
  return max$4(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.maximum = function(b2) {
  this.throwIfDisposed();
  return maximum$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.mean = function(axis, keepDims) {
  this.throwIfDisposed();
  return mean$2(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.min = function(axis, keepDims) {
  this.throwIfDisposed();
  return min$4(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.minimum = function(b2) {
  this.throwIfDisposed();
  return minimum$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.mirrorPad = function(paddings, mode2) {
  this.throwIfDisposed();
  return mirrorPad$2(this, paddings, mode2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.mod = function(b2) {
  this.throwIfDisposed();
  return mod$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.mul = function(b2) {
  this.throwIfDisposed();
  return mul(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.neg = function() {
  this.throwIfDisposed();
  return neg$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.norm = function(ord, axis, keepDims) {
  this.throwIfDisposed();
  return norm(this, ord, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.notEqual = function(b2) {
  this.throwIfDisposed();
  return notEqual$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.oneHot = function(depth, onValue = 1, offValue = 0) {
  this.throwIfDisposed();
  return oneHot$3(this, depth, onValue, offValue);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.onesLike = function() {
  this.throwIfDisposed();
  return onesLike$3(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.pad = function(paddings, constantValue) {
  this.throwIfDisposed();
  return pad$1(this, paddings, constantValue);
};
getGlobalTensorClass().prototype.pool = function(windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode) {
  this.throwIfDisposed();
  return pool$1(this, windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.pow = function(exp2) {
  this.throwIfDisposed();
  return pow$2(this, exp2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.prelu = function(alpha2) {
  this.throwIfDisposed();
  return prelu$3(this, alpha2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.prod = function(axis, keepDims) {
  this.throwIfDisposed();
  return prod$3(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.reciprocal = function() {
  this.throwIfDisposed();
  return reciprocal$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.relu = function() {
  this.throwIfDisposed();
  return relu$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.relu6 = function() {
  this.throwIfDisposed();
  return relu6$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.reshapeAs = function(x2) {
  this.throwIfDisposed();
  return reshape$3(this, x2.shape);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.reshape = function(shape) {
  this.throwIfDisposed();
  return reshape$3(this, shape);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.resizeBilinear = function(newShape2D, alignCorners, halfPixelCenters) {
  this.throwIfDisposed();
  return resizeBilinear$3(this, newShape2D, alignCorners, halfPixelCenters);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.resizeNearestNeighbor = function(newShape2D, alignCorners, halfFloatCenters) {
  this.throwIfDisposed();
  return resizeNearestNeighbor$2(this, newShape2D, alignCorners, halfFloatCenters);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.reverse = function(axis) {
  this.throwIfDisposed();
  return reverse$3(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.rfft = function() {
  this.throwIfDisposed();
  return rfft(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.round = function() {
  this.throwIfDisposed();
  return round$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.rsqrt = function() {
  this.throwIfDisposed();
  return rsqrt$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.selu = function() {
  this.throwIfDisposed();
  return selu$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.separableConv2d = function(depthwiseFilter, pointwiseFilter, strides, pad2, dilation, dataFormat) {
  this.throwIfDisposed();
  return separableConv2d(this, depthwiseFilter, pointwiseFilter, strides, pad2, dilation, dataFormat);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sigmoid = function() {
  this.throwIfDisposed();
  return sigmoid$3(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sign = function() {
  this.throwIfDisposed();
  return sign$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sin = function() {
  this.throwIfDisposed();
  return sin$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sinh = function() {
  this.throwIfDisposed();
  return sinh$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.slice = function(begin, size) {
  this.throwIfDisposed();
  return slice$3(this, begin, size);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.softmax = function(dim) {
  this.throwIfDisposed();
  return softmax$3(this, dim);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.softplus = function() {
  this.throwIfDisposed();
  return softplus$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.spaceToBatchND = function(blockShape, paddings) {
  this.throwIfDisposed();
  return spaceToBatchND$3(this, blockShape, paddings);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.split = function(numOrSizeSplits, axis) {
  this.throwIfDisposed();
  return split$2(this, numOrSizeSplits, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sqrt = function() {
  this.throwIfDisposed();
  return sqrt$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.square = function() {
  this.throwIfDisposed();
  return square$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.squaredDifference = function(b2) {
  this.throwIfDisposed();
  return squaredDifference$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.squeeze = function(axis) {
  this.throwIfDisposed();
  return squeeze(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.stack = function(x2, axis) {
  this.throwIfDisposed();
  const tensorsToBeStacked = x2 instanceof Tensor ? [this, x2] : [this, ...x2];
  return stack(tensorsToBeStacked, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.step = function(alpha2) {
  this.throwIfDisposed();
  return step$3(this, alpha2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.stridedSlice = function(begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
  this.throwIfDisposed();
  return stridedSlice$3(this, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sub = function(b2) {
  this.throwIfDisposed();
  return sub$2(this, b2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.sum = function(axis, keepDims) {
  this.throwIfDisposed();
  return sum$3(this, axis, keepDims);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.tan = function() {
  this.throwIfDisposed();
  return tan$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.tanh = function() {
  this.throwIfDisposed();
  return tanh$2(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.tile = function(reps) {
  this.throwIfDisposed();
  return tile$4(this, reps);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.toBool = function() {
  this.throwIfDisposed();
  return cast$4(this, "bool");
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.toFloat = function() {
  this.throwIfDisposed();
  return cast$4(this, "float32");
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.toInt = function() {
  this.throwIfDisposed();
  return cast$4(this, "int32");
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.topk = function(k3, sorted) {
  this.throwIfDisposed();
  return topk$1(this, k3, sorted);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.transpose = function(perm) {
  this.throwIfDisposed();
  return transpose$3(this, perm);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.unique = function(axis) {
  this.throwIfDisposed();
  return unique$3(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.unsortedSegmentSum = function(segmentIds, numSegments) {
  this.throwIfDisposed();
  return unsortedSegmentSum$2(this, segmentIds, numSegments);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.unstack = function(axis) {
  this.throwIfDisposed();
  return unstack(this, axis);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.where = function(condition, x2) {
  this.throwIfDisposed();
  return where(condition, this, x2);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
getGlobalTensorClass().prototype.zerosLike = function() {
  this.throwIfDisposed();
  return zerosLike$3(this);
};
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class AttributeError extends Error {
  constructor(message2) {
    super(message2);
    Object.setPrototypeOf(this, AttributeError.prototype);
  }
}
class RuntimeError extends Error {
  constructor(message2) {
    super(message2);
    Object.setPrototypeOf(this, RuntimeError.prototype);
  }
}
class ValueError extends Error {
  constructor(message2) {
    super(message2);
    Object.setPrototypeOf(this, ValueError.prototype);
  }
}
class NotImplementedError extends Error {
  constructor(message2) {
    super(message2);
    Object.setPrototypeOf(this, NotImplementedError.prototype);
  }
}
class AssertionError extends Error {
  constructor(message2) {
    super(message2);
    Object.setPrototypeOf(this, AssertionError.prototype);
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class LruCache {
  constructor(maxEntries) {
    this.maxEntries = maxEntries || 100;
    this.cache = /* @__PURE__ */ new Map();
  }
  get(key) {
    let entry;
    if (this.cache.has(key)) {
      entry = this.cache.get(key);
      this.cache.delete(key);
      this.cache.set(key, entry);
    }
    return entry;
  }
  put(key, value) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } else if (this.cache.size >= this.maxEntries) {
      const keyToDelete = this.cache.keys().next().value;
      this.cache.delete(keyToDelete);
    }
    this.cache.set(key, value);
  }
  getMaxEntries() {
    return this.maxEntries;
  }
  setMaxEntries(maxEntries) {
    if (maxEntries < 0) {
      throw new Error(`The maxEntries of LRU caches must be at least 0, but got ${maxEntries}.`);
    }
    if (this.maxEntries > maxEntries) {
      for (let i2 = 0; i2 < this.maxEntries - maxEntries; i2++) {
        const keyToDelete = this.cache.keys().next().value;
        this.cache.delete(keyToDelete);
      }
    }
    this.maxEntries = maxEntries;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function pyListRepeat(value, numValues) {
  if (Array.isArray(value)) {
    let newArray = [];
    for (let i2 = 0; i2 < numValues; i2++) {
      newArray = newArray.concat(value);
    }
    return newArray;
  } else {
    const newArray = new Array(numValues);
    newArray.fill(value);
    return newArray;
  }
}
function assert(val, message2) {
  if (!val) {
    throw new AssertionError(message2);
  }
}
function count(array, refernce) {
  let counter2 = 0;
  for (const item of array) {
    if (item === refernce) {
      counter2++;
    }
  }
  return counter2;
}
function singletonOrArray(xs) {
  if (xs.length === 1) {
    return xs[0];
  }
  return xs;
}
function toList(x2) {
  if (Array.isArray(x2)) {
    return x2;
  }
  return [x2];
}
function toSnakeCase(name) {
  const intermediate = name.replace(/(.)([A-Z][a-z0-9]+)/g, "$1_$2");
  const insecure = intermediate.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
  if (insecure[0] !== "_") {
    return insecure;
  }
  return "private" + insecure;
}
function toCamelCase(identifier) {
  if (identifier.length <= 1) {
    return identifier;
  }
  if (identifier.indexOf("_") === -1) {
    return identifier;
  }
  return identifier.replace(/[_]+(\w|$)/g, (m2, p1) => p1.toUpperCase());
}
let _GLOBAL_CUSTOM_OBJECTS = {};
function serializeKerasObject(instance2) {
  if (instance2 === null || instance2 === void 0) {
    return null;
  }
  const dict = {};
  dict["className"] = instance2.getClassName();
  dict["config"] = instance2.getConfig();
  return dict;
}
function convertNDArrayScalarsInConfig(config2) {
  if (config2 == null || typeof config2 !== "object") {
    return;
  } else if (Array.isArray(config2)) {
    config2.forEach((configItem) => convertNDArrayScalarsInConfig(configItem));
  } else {
    const fields = Object.keys(config2);
    for (const field of fields) {
      const value = config2[field];
      if (value != null && typeof value === "object") {
        if (!Array.isArray(value) && value["type"] === "ndarray" && typeof value["value"] === "number") {
          config2[field] = value["value"];
        } else {
          convertNDArrayScalarsInConfig(value);
        }
      }
    }
  }
}
function deserializeKerasObject(identifier, moduleObjects = {}, customObjects = {}, printableModuleName = "object", fastWeightInit = false) {
  if (typeof identifier === "string") {
    const functionName = identifier;
    let fn;
    if (functionName in customObjects) {
      fn = customObjects[functionName];
    } else if (functionName in _GLOBAL_CUSTOM_OBJECTS) {
      fn = _GLOBAL_CUSTOM_OBJECTS[functionName];
    } else {
      fn = moduleObjects[functionName];
      if (fn == null) {
        throw new ValueError(`Unknown ${printableModuleName}: ${identifier}. This may be due to one of the following reasons:
1. The ${printableModuleName} is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.
2. The custom ${printableModuleName} is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().`);
      }
    }
    return fn;
  } else {
    const config2 = identifier;
    if (config2["className"] == null || config2["config"] == null) {
      throw new ValueError(`${printableModuleName}: Improper config format: ${JSON.stringify(config2)}.
'className' and 'config' must set.`);
    }
    const className = config2["className"];
    let cls, fromConfig;
    if (className in customObjects) {
      [cls, fromConfig] = customObjects[className];
    } else if (className in _GLOBAL_CUSTOM_OBJECTS) {
      [cls, fromConfig] = _GLOBAL_CUSTOM_OBJECTS["className"];
    } else if (className in moduleObjects) {
      [cls, fromConfig] = moduleObjects[className];
    }
    if (cls == null) {
      throw new ValueError(`Unknown ${printableModuleName}: ${className}. This may be due to one of the following reasons:
1. The ${printableModuleName} is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.
2. The custom ${printableModuleName} is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().`);
    }
    if (fromConfig != null) {
      const customObjectsCombined = {};
      for (const key of Object.keys(_GLOBAL_CUSTOM_OBJECTS)) {
        customObjectsCombined[key] = _GLOBAL_CUSTOM_OBJECTS[key];
      }
      for (const key of Object.keys(customObjects)) {
        customObjectsCombined[key] = customObjects[key];
      }
      const nestedConfig = config2["config"];
      nestedConfig["customObjects"] = customObjectsCombined;
      const backupCustomObjects = Object.assign({}, _GLOBAL_CUSTOM_OBJECTS);
      for (const key of Object.keys(customObjects)) {
        _GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
      }
      convertNDArrayScalarsInConfig(config2["config"]);
      const returnObj = fromConfig(cls, config2["config"], customObjects, fastWeightInit);
      _GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
      return returnObj;
    } else {
      const backupCustomObjects = Object.assign({}, _GLOBAL_CUSTOM_OBJECTS);
      for (const key of Object.keys(customObjects)) {
        _GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
      }
      const returnObj = new cls(config2["config"]);
      _GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
      return returnObj;
    }
  }
}
function numberCompare(a6, b2) {
  return a6 < b2 ? -1 : a6 > b2 ? 1 : 0;
}
function reverseNumberCompare(a6, b2) {
  return -1 * numberCompare(a6, b2);
}
function unique$2(xs) {
  if (xs == null) {
    return xs;
  }
  const out = [];
  for (const x2 of xs) {
    if (out.indexOf(x2) === -1) {
      out.push(x2);
    }
  }
  return out;
}
function isObjectEmpty(obj) {
  if (obj == null) {
    throw new ValueError(`Invalid value in obj: ${JSON.stringify(obj)}`);
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}
function checkStringTypeUnionValue(values, label, value) {
  if (value == null) {
    return;
  }
  if (values.indexOf(value) < 0) {
    throw new ValueError(`${value} is not a valid ${label}.  Valid values are ${values} or null/undefined.`);
  }
}
function checkArrayTypeAndLength(x2, expectedType, minLength = 0, maxLength = Infinity) {
  assert(minLength >= 0);
  assert(maxLength >= minLength);
  return Array.isArray(x2) && x2.length >= minLength && x2.length <= maxLength && x2.every((e2) => typeof e2 === expectedType);
}
function assertPositiveInteger(value, name) {
  if (Array.isArray(value)) {
    assert$1(value.length > 0, () => `${name} is unexpectedly an empty array.`);
    value.forEach((v2, i2) => assertPositiveInteger(v2, `element ${i2 + 1} of ${name}`));
  } else {
    assert$1(Number.isInteger(value) && value > 0, () => `Expected ${name} to be a positive integer, but got ${formatAsFriendlyString(value)}.`);
  }
}
function formatAsFriendlyString(value) {
  if (value === null) {
    return "null";
  } else if (Array.isArray(value)) {
    return "[" + value.map((v2) => formatAsFriendlyString(v2)).join(",") + "]";
  } else if (typeof value === "string") {
    return `"${value}"`;
  } else {
    return `${value}`;
  }
}
function debounce$1(f2, waitMs, nowFunc) {
  let lastTime = nowFunc != null ? nowFunc() : now();
  let lastResult;
  const f22 = (...args) => {
    const now$1 = nowFunc != null ? nowFunc() : now();
    if (now$1 - lastTime < waitMs) {
      return lastResult;
    }
    lastTime = now$1;
    lastResult = f2(...args);
    return lastResult;
  };
  return f22;
}
function mapActivationToFusedKernel(activationName) {
  if (activationName === "relu") {
    return "relu";
  }
  if (activationName === "linear") {
    return "linear";
  }
  if (activationName === "elu") {
    return "elu";
  }
  return null;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
let _nextUniqueTensorId = 0;
function getNextUniqueTensorId() {
  return _nextUniqueTensorId++;
}
const _uidPrefixes = {};
function getUid(prefix2 = "") {
  if (!(prefix2 in _uidPrefixes)) {
    _uidPrefixes[prefix2] = 0;
  }
  _uidPrefixes[prefix2] += 1;
  return prefix2 + _uidPrefixes[prefix2].toString();
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
const VALID_DATA_FORMAT_VALUES = ["channelsFirst", "channelsLast"];
const VALID_INTERPOLATION_FORMAT_VALUES = ["nearest", "bilinear"];
const VALID_PADDING_MODE_VALUES = ["valid", "same", "causal"];
const VALID_POOL_MODE_VALUES = ["max", "avg"];
const VALID_BIDIRECTIONAL_MERGE_MODES = ["sum", "mul", "concat", "ave"];
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
const nameMap = /* @__PURE__ */ new Map();
function checkDataFormat(value) {
  checkStringTypeUnionValue(VALID_DATA_FORMAT_VALUES, "DataFormat", value);
}
function checkInterpolationFormat(value) {
  checkStringTypeUnionValue(VALID_INTERPOLATION_FORMAT_VALUES, "InterpolationFormat", value);
}
function checkPaddingMode(value) {
  checkStringTypeUnionValue(VALID_PADDING_MODE_VALUES, "PaddingMode", value);
}
function checkPoolMode(value) {
  checkStringTypeUnionValue(VALID_POOL_MODE_VALUES, "PoolMode", value);
}
const _nameScopeStack = [];
const _nameScopeDivider = "/";
function nameScope(name, fn) {
  _nameScopeStack.push(name);
  try {
    const val = fn();
    _nameScopeStack.pop();
    return val;
  } catch (e2) {
    _nameScopeStack.pop();
    throw e2;
  }
}
function currentNameScopePrefix() {
  if (_nameScopeStack.length === 0) {
    return "";
  } else {
    return _nameScopeStack.join(_nameScopeDivider) + _nameScopeDivider;
  }
}
function getScopedTensorName(tensorName) {
  if (!isValidTensorName(tensorName)) {
    throw new Error("Not a valid tensor name: '" + tensorName + "'");
  }
  return currentNameScopePrefix() + tensorName;
}
function getUniqueTensorName(scopedName) {
  if (!isValidTensorName(scopedName)) {
    throw new Error("Not a valid tensor name: '" + scopedName + "'");
  }
  if (!nameMap.has(scopedName)) {
    nameMap.set(scopedName, 0);
  }
  const index2 = nameMap.get(scopedName);
  nameMap.set(scopedName, nameMap.get(scopedName) + 1);
  if (index2 > 0) {
    const result2 = `${scopedName}_${index2}`;
    nameMap.set(result2, 1);
    return result2;
  } else {
    return scopedName;
  }
}
const tensorNameRegex = new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);
function isValidTensorName(name) {
  return !!name.match(tensorNameRegex);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function isInteger(x2) {
  return x2 === parseInt(x2.toString(), 10);
}
function arrayProd(array, begin, end) {
  if (begin == null) {
    begin = 0;
  }
  if (end == null) {
    end = array.length;
  }
  let prod2 = 1;
  for (let i2 = begin; i2 < end; ++i2) {
    prod2 *= array[i2];
  }
  return prod2;
}
function min$3(array) {
  if (array.length === 0) {
    return Number.NaN;
  }
  let min2 = Number.POSITIVE_INFINITY;
  for (let i2 = 0; i2 < array.length; i2++) {
    const value = array[i2];
    if (value < min2) {
      min2 = value;
    }
  }
  return min2;
}
function max$3(array) {
  if (array.length === 0) {
    return Number.NaN;
  }
  let max2 = Number.NEGATIVE_INFINITY;
  for (let i2 = 0; i2 < array.length; i2++) {
    const value = array[i2];
    if (value > max2) {
      max2 = value;
    }
  }
  return max2;
}
function range$3(begin, end) {
  if (end < begin) {
    throw new ValueError(`end (${end}) < begin (${begin}) is forbidden.`);
  }
  const out = [];
  for (let i2 = begin; i2 < end; ++i2) {
    out.push(i2);
  }
  return out;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
let _epsilon;
function epsilon$1() {
  if (_epsilon == null) {
    _epsilon = backend().epsilon();
  }
  return _epsilon;
}
function imageDataFormat() {
  return "channelsLast";
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function cast$3(x2, dtype) {
  return cast$4(x2, dtype);
}
function expandDims$3(x2, axis = -1) {
  const outShape = x2.shape.slice();
  if (axis < 0) {
    axis = outShape.length + axis + 1;
  }
  outShape.splice(axis, 0, 1);
  return reshape$3(x2, outShape);
}
function repeat$1(x2, n2) {
  return tidy(() => {
    if (x2.shape.length !== 2) {
      throw new ValueError(`repeat() expects a rank-2 tensor, but received a rank-${x2.shape.length} tensor.`);
    }
    const y2 = expandDims$3(x2, 1);
    return tile$3(y2, [1, n2, 1]);
  });
}
function flatten(x2) {
  const newShape = [arrayProd(x2.shape)];
  return reshape$3(x2, newShape);
}
function batchFlatten(x2) {
  if (x2.rank <= 1) {
    throw new ValueError(`batchFlatten requires a minimum rank of 2. Got rank: ${x2.rank}.`);
  }
  const newShape = [x2.shape[0], arrayProd(x2.shape, 1)];
  return reshape$3(x2, newShape);
}
function sliceAlongFirstAxis(array, start, size) {
  return tidy(() => {
    switch (array.rank) {
      case 1:
        return slice1d(array, start, size);
      case 2:
        return slice2d$1(array, [start, 0], [size, array.shape[1]]);
      case 3:
        return slice3d$1(array, [start, 0, 0], [size, array.shape[1], array.shape[2]]);
      case 4:
        return slice4d$1(array, [start, 0, 0, 0], [size, array.shape[1], array.shape[2], array.shape[3]]);
      case 5:
        return slice$3(array, [start, 0, 0, 0, 0], [
          size,
          array.shape[1],
          array.shape[2],
          array.shape[3],
          array.shape[4]
        ]);
      case 6:
        return slice$3(array, [start, 0, 0, 0, 0, 0], [
          size,
          array.shape[1],
          array.shape[2],
          array.shape[3],
          array.shape[4],
          array.shape[5]
        ]);
      default:
        throw new ValueError(`sliceAlongFirstAxis() received an unsupported tensor rank: ${array.rank}`);
    }
  });
}
function sliceAlongLastAxis(array, start, size) {
  return tidy(() => {
    switch (array.rank) {
      case 1:
        return slice1d(array, start, size);
      case 2:
        return slice2d$1(array, [0, start], [array.shape[0], size]);
      case 3:
        return slice3d$1(array, [0, 0, start], [array.shape[0], array.shape[1], size]);
      case 4:
        return slice4d$1(array, [0, 0, 0, start], [array.shape[0], array.shape[1], array.shape[2], size]);
      default:
        throw new ValueError(`sliceAlongLastAxis() received an unsupported tensor rank: ${array.rank}`);
    }
  });
}
function sliceAlongAxis(array, start, size, axis) {
  return tidy(() => {
    switch (array.rank) {
      case 1:
        return slice1d(array, start, size);
      case 2:
        switch (axis) {
          case 1:
            return sliceAlongFirstAxis(array, start, size);
          case 2:
            return sliceAlongLastAxis(array, start, size);
          default:
            throw new ValueError(`The axis is not within the rank of the tensor ${axis}`);
        }
      case 3:
        switch (axis) {
          case 1:
            return sliceAlongFirstAxis(array, start, size);
          case 2:
            return slice3d$1(array, [0, start, 0], [array.shape[0], size, array.shape[2]]);
          case 3:
            return sliceAlongLastAxis(array, start, size);
          default:
            throw new ValueError(`The axis is not within the rank of the tensor ${axis}`);
        }
      case 4:
        switch (axis) {
          case 1:
            return sliceAlongFirstAxis(array, start, size);
          case 2:
            return slice4d$1(array, [0, start, 0, 0], [array.shape[0], size, array.shape[2], array.shape[3]]);
          case 3:
            return slice4d$1(array, [0, 0, start, 0], [array.shape[0], array.shape[1], size, array.shape[3]]);
          case 4:
            return sliceAlongLastAxis(array, start, size);
          default:
            throw new ValueError(`The axis is not within the rank of the tensor ${axis}`);
        }
      default:
        throw new ValueError(`sliceAlongLastAxis() received an unsupported tensor rank: ${array.rank}`);
    }
  });
}
function concatenate(tensors, axis = -1) {
  let rank;
  if (axis < 0) {
    rank = tensors[0].rank;
    if (rank !== 0) {
      axis = rank;
    } else {
      axis = 0;
    }
  }
  if (axis === tensors[0].rank) {
    axis = -1;
  }
  return concat$3(tensors, axis);
}
function concatAlongFirstAxis(a6, b2) {
  switch (a6.rank) {
    case 1:
      return concat1d([a6, b2]);
    case 2:
      return concat2d([a6, b2], 0);
    case 3:
      return concat3d([a6, b2], 0);
    case 4:
      return concat4d([a6, b2], 0);
    default:
      throw new ValueError(`concatAlongFirstAxis() received an unsupported tensor rank: ${a6.rank}`);
  }
}
function tile$3(x2, n2) {
  if (!Array.isArray(n2)) {
    n2 = [n2];
  }
  if (x2.rank !== n2.length) {
    throw new ValueError(`The length of input n (${n2.length}) does not match the number of dimensions in input x (${x2.rank})`);
  }
  return tile$4(x2, n2);
}
function randomNormal(shape, mean2 = 0, stddev = 1, dtype, seed) {
  return randomNormal$1(shape, mean2, stddev, dtype, seed);
}
function dot(a6, b2, activation, bias) {
  if (a6.rank < 2 || b2.rank < 2) {
    throw new NotImplementedError(`dot requires both inputs to be rank >= 2 but got x shape = ${a6.shape} and y shape = ${b2.shape}`);
  }
  if (b2.rank >= 3) {
    const xLastDim = a6.shape.slice(-1)[0];
    const ySecondLastDim = b2.shape.slice(-2)[0];
    if (xLastDim !== ySecondLastDim) {
      throw new NotImplementedError(`If rank y >= 3, then the second last dim of y must equal the last dim of x but got x shape = ${a6.shape} and  y shape = ${b2.shape}`);
    }
  }
  if (a6.rank === 2 && b2.rank === 2) {
    const transposeA = false;
    const transposeB = false;
    return matMul({
      a: a6,
      b: b2,
      transposeA,
      transposeB,
      bias: bias ? reshapeBias(a6.rank, bias, imageDataFormat()) : null,
      activation
    });
  } else {
    const aFirstDims = a6.shape.slice();
    const aLastDim = aFirstDims.pop();
    a6 = reshape$3(a6, [-1, aLastDim]);
    const bShape = b2.shape.slice();
    const bLastDim = bShape.pop();
    const ySecondLastDim = bShape.pop();
    const yOtherDims = [...bShape, bLastDim];
    const perm = Array.from({ length: b2.rank }, (_24, i2) => {
      if (i2 === 0) {
        return b2.rank - 2;
      } else if (i2 <= b2.rank - 2) {
        return i2 - 1;
      }
      return i2;
    });
    b2 = reshape$3(transpose$3(b2, perm), [ySecondLastDim, -1]);
    const outputShape = [...aFirstDims, ...yOtherDims];
    const transposeA = false;
    const transposeB = false;
    return reshape$3(matMul({
      a: a6,
      b: b2,
      transposeA,
      transposeB,
      bias: bias ? reshapeBias(a6.rank, bias, imageDataFormat()) : null,
      activation
    }), outputShape);
  }
}
function gather(reference, indices, axis) {
  return tidy(() => {
    if (Array.isArray(indices)) {
      indices = tensor1d(indices, "int32");
    } else {
      indices = cast$4(indices, "int32");
    }
    return gather$1(reference, indices, axis);
  });
}
function square$1(x2) {
  return mul(x2, x2);
}
function reshapeBias(xRank, bias, dataFormat) {
  const biasShape = bias.shape;
  if (bias.rank !== 1 && bias.rank !== xRank) {
    throw new ValueError(`Unexpected bias dimensions: ${bias.rank}; expected it to be 1 or ${xRank}`);
  }
  if (xRank === 5) {
    if (dataFormat === "channelsFirst") {
      if (biasShape.length === 1) {
        return reshape$3(bias, [1, biasShape[0], 1, 1, 1]);
      } else {
        return reshape$3(bias, [1, biasShape[3], biasShape[0], biasShape[1], biasShape[2]]);
      }
    } else if (dataFormat === "channelsLast") {
      if (biasShape.length === 1) {
        return reshape$3(bias, [1, 1, 1, 1, biasShape[0]]);
      } else {
        return reshape$3(bias, [1].concat(biasShape));
      }
    }
  } else if (xRank === 4) {
    if (dataFormat === "channelsFirst") {
      if (biasShape.length === 1) {
        return reshape$3(bias, [1, biasShape[0], 1, 1]);
      } else {
        return reshape$3(bias, [1, biasShape[2], biasShape[0], biasShape[1]]);
      }
    } else if (dataFormat === "channelsLast") {
      if (biasShape.length === 1) {
        return reshape$3(bias, [1, 1, 1, biasShape[0]]);
      } else {
        return reshape$3(bias, [1].concat(biasShape));
      }
    }
  } else if (xRank === 3) {
    if (dataFormat === "channelsFirst") {
      if (biasShape.length === 1) {
        return reshape$3(bias, [1, biasShape[0], 1]);
      } else {
        return reshape$3(bias, [1, biasShape[1], biasShape[0]]);
      }
    } else if (dataFormat === "channelsLast") {
      if (biasShape.length === 1) {
        return reshape$3(bias, [1, 1, biasShape[0]]);
      } else {
        return reshape$3(bias, [1].concat(biasShape));
      }
    }
  } else if (xRank < 3) {
    return bias;
  }
  throw new ValueError(`Unsupported input rank by biasAdd: ${bias.rank}`);
}
function biasAdd(x2, bias, dataFormat) {
  return tidy(() => {
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    checkDataFormat(dataFormat);
    return add$1(x2, reshapeBias(x2.rank, bias, dataFormat));
  });
}
function elu$2(x2, alpha2 = 1) {
  if (alpha2 !== 1) {
    throw new NotImplementedError(`Support for alpha values other than 1 (${alpha2}) is not implemented yet.`);
  }
  return elu$3(x2);
}
function softsign(x2) {
  return tidy(() => div$1(x2, add$1(abs$2(x2), 1)));
}
function dropout(x2, level, noiseShape, seed) {
  return tidy(() => dropout$1(x2, level, noiseShape, seed));
}
function hardSigmoid(x2) {
  return tidy(() => {
    const y2 = add$1(0.5, mul(0.2, x2));
    return clipByValue$2(y2, 0, 1);
  });
}
function inTrainPhase(x2, alt, training = false) {
  return training ? x2() : alt();
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
const VALID_FAN_MODE_VALUES = ["fanIn", "fanOut", "fanAvg"];
const VALID_DISTRIBUTION_VALUES = ["normal", "uniform", "truncatedNormal"];
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function checkFanMode(value) {
  checkStringTypeUnionValue(VALID_FAN_MODE_VALUES, "FanMode", value);
}
function checkDistribution(value) {
  checkStringTypeUnionValue(VALID_DISTRIBUTION_VALUES, "Distribution", value);
}
class Initializer extends Serializable {
  fromConfigUsesCustomObjects() {
    return false;
  }
  getConfig() {
    return {};
  }
}
class Zeros extends Initializer {
  apply(shape, dtype) {
    return zeros$1(shape, dtype);
  }
}
Zeros.className = "Zeros";
registerClass(Zeros);
class Ones extends Initializer {
  apply(shape, dtype) {
    return ones(shape, dtype);
  }
}
Ones.className = "Ones";
registerClass(Ones);
class Constant extends Initializer {
  constructor(args) {
    super();
    if (typeof args !== "object") {
      throw new ValueError(`Expected argument of type ConstantConfig but got ${args}`);
    }
    if (args.value === void 0) {
      throw new ValueError(`config must have value set but got ${args}`);
    }
    this.value = args.value;
  }
  apply(shape, dtype) {
    return tidy(() => mul(scalar(this.value), ones(shape, dtype)));
  }
  getConfig() {
    return {
      value: this.value
    };
  }
}
Constant.className = "Constant";
registerClass(Constant);
class RandomUniform extends Initializer {
  constructor(args) {
    super();
    this.DEFAULT_MINVAL = -0.05;
    this.DEFAULT_MAXVAL = 0.05;
    this.minval = args.minval || this.DEFAULT_MINVAL;
    this.maxval = args.maxval || this.DEFAULT_MAXVAL;
    this.seed = args.seed;
  }
  apply(shape, dtype) {
    return randomUniform(shape, this.minval, this.maxval, dtype);
  }
  getConfig() {
    return { minval: this.minval, maxval: this.maxval, seed: this.seed };
  }
}
RandomUniform.className = "RandomUniform";
registerClass(RandomUniform);
class RandomNormal extends Initializer {
  constructor(args) {
    super();
    this.DEFAULT_MEAN = 0;
    this.DEFAULT_STDDEV = 0.05;
    this.mean = args.mean || this.DEFAULT_MEAN;
    this.stddev = args.stddev || this.DEFAULT_STDDEV;
    this.seed = args.seed;
  }
  apply(shape, dtype) {
    dtype = dtype || "float32";
    if (dtype !== "float32" && dtype !== "int32") {
      throw new NotImplementedError(`randomNormal does not support dType ${dtype}.`);
    }
    return randomNormal(shape, this.mean, this.stddev, dtype, this.seed);
  }
  getConfig() {
    return { mean: this.mean, stddev: this.stddev, seed: this.seed };
  }
}
RandomNormal.className = "RandomNormal";
registerClass(RandomNormal);
class TruncatedNormal extends Initializer {
  constructor(args) {
    super();
    this.DEFAULT_MEAN = 0;
    this.DEFAULT_STDDEV = 0.05;
    this.mean = args.mean || this.DEFAULT_MEAN;
    this.stddev = args.stddev || this.DEFAULT_STDDEV;
    this.seed = args.seed;
  }
  apply(shape, dtype) {
    dtype = dtype || "float32";
    if (dtype !== "float32" && dtype !== "int32") {
      throw new NotImplementedError(`truncatedNormal does not support dType ${dtype}.`);
    }
    return truncatedNormal(shape, this.mean, this.stddev, dtype, this.seed);
  }
  getConfig() {
    return { mean: this.mean, stddev: this.stddev, seed: this.seed };
  }
}
TruncatedNormal.className = "TruncatedNormal";
registerClass(TruncatedNormal);
class Identity extends Initializer {
  constructor(args) {
    super();
    this.gain = args.gain != null ? args.gain : 1;
  }
  apply(shape, dtype) {
    return tidy(() => {
      if (shape.length !== 2 || shape[0] !== shape[1]) {
        throw new ValueError("Identity matrix initializer can only be used for 2D square matrices.");
      } else {
        return mul(this.gain, eye(shape[0]));
      }
    });
  }
  getConfig() {
    return { gain: this.gain };
  }
}
Identity.className = "Identity";
registerClass(Identity);
function computeFans(shape, dataFormat = "channelsLast") {
  let fanIn;
  let fanOut;
  checkDataFormat(dataFormat);
  if (shape.length === 2) {
    fanIn = shape[0];
    fanOut = shape[1];
  } else if ([3, 4, 5].indexOf(shape.length) !== -1) {
    if (dataFormat === "channelsFirst") {
      const receptiveFieldSize = arrayProd(shape, 2);
      fanIn = shape[1] * receptiveFieldSize;
      fanOut = shape[0] * receptiveFieldSize;
    } else if (dataFormat === "channelsLast") {
      const receptiveFieldSize = arrayProd(shape, 0, shape.length - 2);
      fanIn = shape[shape.length - 2] * receptiveFieldSize;
      fanOut = shape[shape.length - 1] * receptiveFieldSize;
    }
  } else {
    const shapeProd = arrayProd(shape);
    fanIn = Math.sqrt(shapeProd);
    fanOut = Math.sqrt(shapeProd);
  }
  return [fanIn, fanOut];
}
class VarianceScaling extends Initializer {
  constructor(args) {
    super();
    if (args.scale < 0) {
      throw new ValueError(`scale must be a positive float. Got: ${args.scale}`);
    }
    this.scale = args.scale == null ? 1 : args.scale;
    this.mode = args.mode == null ? "fanIn" : args.mode;
    checkFanMode(this.mode);
    this.distribution = args.distribution == null ? "normal" : args.distribution;
    checkDistribution(this.distribution);
    this.seed = args.seed;
  }
  apply(shape, dtype) {
    const fans = computeFans(shape);
    const fanIn = fans[0];
    const fanOut = fans[1];
    let scale2 = this.scale;
    if (this.mode === "fanIn") {
      scale2 /= Math.max(1, fanIn);
    } else if (this.mode === "fanOut") {
      scale2 /= Math.max(1, fanOut);
    } else {
      scale2 /= Math.max(1, (fanIn + fanOut) / 2);
    }
    if (this.distribution === "normal") {
      const stddev = Math.sqrt(scale2);
      dtype = dtype || "float32";
      if (dtype !== "float32" && dtype !== "int32") {
        throw new NotImplementedError(`${this.getClassName()} does not support dType ${dtype}.`);
      }
      return truncatedNormal(shape, 0, stddev, dtype, this.seed);
    } else {
      const limit = Math.sqrt(3 * scale2);
      return randomUniform(shape, -limit, limit, dtype);
    }
  }
  getConfig() {
    return {
      scale: this.scale,
      mode: this.mode,
      distribution: this.distribution,
      seed: this.seed
    };
  }
}
VarianceScaling.className = "VarianceScaling";
registerClass(VarianceScaling);
class GlorotUniform extends VarianceScaling {
  constructor(args) {
    super({
      scale: 1,
      mode: "fanAvg",
      distribution: "uniform",
      seed: args == null ? null : args.seed
    });
  }
  getClassName() {
    return VarianceScaling.className;
  }
}
GlorotUniform.className = "GlorotUniform";
registerClass(GlorotUniform);
class GlorotNormal extends VarianceScaling {
  constructor(args) {
    super({
      scale: 1,
      mode: "fanAvg",
      distribution: "normal",
      seed: args == null ? null : args.seed
    });
  }
  getClassName() {
    return VarianceScaling.className;
  }
}
GlorotNormal.className = "GlorotNormal";
registerClass(GlorotNormal);
class HeNormal extends VarianceScaling {
  constructor(args) {
    super({
      scale: 2,
      mode: "fanIn",
      distribution: "normal",
      seed: args == null ? null : args.seed
    });
  }
  getClassName() {
    return VarianceScaling.className;
  }
}
HeNormal.className = "HeNormal";
registerClass(HeNormal);
class HeUniform extends VarianceScaling {
  constructor(args) {
    super({
      scale: 2,
      mode: "fanIn",
      distribution: "uniform",
      seed: args == null ? null : args.seed
    });
  }
  getClassName() {
    return VarianceScaling.className;
  }
}
HeUniform.className = "HeUniform";
registerClass(HeUniform);
class LeCunNormal extends VarianceScaling {
  constructor(args) {
    super({
      scale: 1,
      mode: "fanIn",
      distribution: "normal",
      seed: args == null ? null : args.seed
    });
  }
  getClassName() {
    return VarianceScaling.className;
  }
}
LeCunNormal.className = "LeCunNormal";
registerClass(LeCunNormal);
class LeCunUniform extends VarianceScaling {
  constructor(args) {
    super({
      scale: 1,
      mode: "fanIn",
      distribution: "uniform",
      seed: args == null ? null : args.seed
    });
  }
  getClassName() {
    return VarianceScaling.className;
  }
}
LeCunUniform.className = "LeCunNormal";
registerClass(LeCunUniform);
class Orthogonal extends Initializer {
  constructor(args) {
    super();
    this.DEFAULT_GAIN = 1;
    this.gain = args.gain == null ? this.DEFAULT_GAIN : args.gain;
    this.seed = args.seed;
    if (this.seed != null) {
      throw new NotImplementedError("Random seed is not implemented for Orthogonal Initializer yet.");
    }
  }
  apply(shape, dtype) {
    return tidy(() => {
      if (shape.length < 2) {
        throw new NotImplementedError("Shape must be at least 2D.");
      }
      if (shape[0] * shape[1] > 2e3) {
        console.warn(`Orthogonal initializer is being called on a matrix with more than 2000 (${shape[0] * shape[1]}) elements: Slowness may result.`);
      }
      const normalizedShape = shape[0] > shape[1] ? [shape[1], shape[0]] : shape;
      const a6 = randomNormal(normalizedShape, 0, 1, "float32");
      let q2 = linalg.gramSchmidt(a6);
      if (shape[0] > shape[1]) {
        q2 = transpose$3(q2);
      }
      return mul(this.gain, q2);
    });
  }
  getConfig() {
    return {
      gain: this.gain,
      seed: this.seed
    };
  }
}
Orthogonal.className = "Orthogonal";
registerClass(Orthogonal);
const INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP = {
  "constant": "Constant",
  "glorotNormal": "GlorotNormal",
  "glorotUniform": "GlorotUniform",
  "heNormal": "HeNormal",
  "heUniform": "HeUniform",
  "identity": "Identity",
  "leCunNormal": "LeCunNormal",
  "leCunUniform": "LeCunUniform",
  "ones": "Ones",
  "orthogonal": "Orthogonal",
  "randomNormal": "RandomNormal",
  "randomUniform": "RandomUniform",
  "truncatedNormal": "TruncatedNormal",
  "varianceScaling": "VarianceScaling",
  "zeros": "Zeros"
};
function deserializeInitializer(config2, customObjects = {}) {
  return deserializeKerasObject(config2, SerializationMap.getMap().classNameMap, customObjects, "initializer");
}
function serializeInitializer(initializer) {
  return serializeKerasObject(initializer);
}
function getInitializer(identifier) {
  if (typeof identifier === "string") {
    const className = identifier in INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP ? INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[identifier] : identifier;
    if (className === "GlorotNormal") {
      return new GlorotNormal();
    } else if (className === "GlorotUniform") {
      return new GlorotUniform();
    } else if (className === "HeNormal") {
      return new HeNormal();
    } else if (className === "HeUniform") {
      return new HeUniform();
    } else if (className === "LeCunNormal") {
      return new LeCunNormal();
    } else if (className === "LeCunUniform") {
      return new LeCunUniform();
    } else {
      const config2 = {};
      config2["className"] = className;
      config2["config"] = {};
      return deserializeInitializer(config2);
    }
  } else if (identifier instanceof Initializer) {
    return identifier;
  } else {
    return deserializeInitializer(identifier);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function isArrayOfShapes(x2) {
  return Array.isArray(x2) && Array.isArray(x2[0]);
}
function normalizeShapeList(x2) {
  if (x2.length === 0) {
    return [];
  }
  if (!Array.isArray(x2[0])) {
    return [x2];
  }
  return x2;
}
function getExactlyOneTensor(xs) {
  let x2;
  if (Array.isArray(xs)) {
    if (xs.length !== 1) {
      throw new ValueError(`Expected Tensor length to be 1; got ${xs.length}`);
    }
    x2 = xs[0];
  } else {
    x2 = xs;
  }
  return x2;
}
function getExactlyOneShape(shapes) {
  if (Array.isArray(shapes) && Array.isArray(shapes[0])) {
    if (shapes.length === 1) {
      shapes = shapes;
      return shapes[0];
    } else {
      throw new ValueError(`Expected exactly 1 Shape; got ${shapes.length}`);
    }
  } else {
    return shapes;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function countParamsInWeights(weights) {
  let count2 = 0;
  for (const weight of weights) {
    if (weight.shape.length === 0) {
      count2 += 1;
    } else {
      count2 += weight.shape.reduce((a6, b2) => a6 * b2);
    }
  }
  return count2;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
const DEFAULT_VARIABLE_NAME_PREFIX = "Variable";
class LayerVariable {
  constructor(val, dtype = "float32", name = DEFAULT_VARIABLE_NAME_PREFIX, trainable = true, constraint = null) {
    this.dtype = dtype == null ? "float32" : dtype;
    this.shape = val.shape;
    this.id = getNextUniqueTensorId();
    name = name == null ? DEFAULT_VARIABLE_NAME_PREFIX : name;
    this.originalName = getScopedTensorName(name);
    this.name = getUniqueTensorName(this.originalName);
    this.trainable_ = trainable;
    this.constraint = constraint;
    this.val = variable(val, this.trainable_, this.name, this.dtype);
  }
  read() {
    this.assertNotDisposed();
    return this.val;
  }
  write(newVal) {
    this.assertNotDisposed();
    checkShapesMatch(this.val, newVal);
    if (this.val.id !== newVal.id) {
      this.val.assign(newVal);
      if (this.constraint != null) {
        this.val.assign(this.constraint.apply(this.val));
      }
    }
    return this;
  }
  dispose() {
    this.assertNotDisposed();
    this.val.dispose();
  }
  assertNotDisposed() {
    if (this.val.isDisposed) {
      throw new Error(`LayersVariable ${this.name} is already disposed.`);
    }
  }
  get trainable() {
    return this.trainable_;
  }
  set trainable(trainable) {
    this.trainable_ = trainable;
    this.val.trainable = trainable;
  }
}
function checkShapesMatch(x2, y2) {
  if (x2.shape.toString() !== y2.shape.toString()) {
    throw new Error("Shape mismatch: " + JSON.stringify(x2.shape) + " vs. " + JSON.stringify(y2.shape));
  }
}
function batchGetValue(xs) {
  return xs.map((x2) => x2.read());
}
function batchSetValue(variablesAndValues) {
  variablesAndValues.forEach((variableAndValue) => {
    const variable2 = variableAndValue[0];
    variable2.write(variableAndValue[1]);
  });
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class InputSpec {
  constructor(args) {
    this.dtype = args.dtype;
    this.shape = args.shape;
    if (args.shape != null) {
      this.ndim = args.shape.length;
    } else {
      this.ndim = args.ndim;
    }
    this.maxNDim = args.maxNDim;
    this.minNDim = args.minNDim;
    this.axes = args.axes || {};
  }
}
class SymbolicTensor {
  constructor(dtype, shape, sourceLayer, inputs, callArgs, name, outputTensorIndex) {
    this.dtype = dtype;
    this.shape = shape;
    this.sourceLayer = sourceLayer;
    this.inputs = inputs;
    this.callArgs = callArgs;
    this.outputTensorIndex = outputTensorIndex;
    this.id = getNextUniqueTensorId();
    if (name != null) {
      this.originalName = getScopedTensorName(name);
      this.name = getUniqueTensorName(this.originalName);
    }
    this.rank = shape.length;
  }
}
let _nextNodeID = 0;
class Node$1 {
  constructor(args, callArgs) {
    this.callArgs = callArgs;
    this.id = _nextNodeID++;
    this.outboundLayer = args.outboundLayer;
    this.inboundLayers = args.inboundLayers;
    this.nodeIndices = args.nodeIndices;
    this.tensorIndices = args.tensorIndices;
    this.inputTensors = args.inputTensors;
    this.outputTensors = args.outputTensors;
    this.inputMasks = args.inputMasks;
    this.outputMasks = args.outputMasks;
    this.inputShapes = args.inputShapes;
    this.outputShapes = args.outputShapes;
    for (const layer of args.inboundLayers) {
      if (layer != null) {
        layer.outboundNodes.push(this);
      }
    }
    args.outboundLayer.inboundNodes.push(this);
  }
  getConfig() {
    const inboundNames = [];
    for (const layer of this.inboundLayers) {
      if (layer != null) {
        inboundNames.push(layer.name);
      } else {
        inboundNames.push(null);
      }
    }
    return {
      outboundLayer: this.outboundLayer ? this.outboundLayer.name : null,
      inboundLayers: inboundNames,
      nodeIndices: this.nodeIndices,
      tensorIndices: this.tensorIndices
    };
  }
}
let _nextLayerID = 0;
class Layer extends Serializable {
  constructor(args = {}) {
    super();
    this._callHook = null;
    this._addedWeightNames = [];
    this._stateful = false;
    this.id = _nextLayerID++;
    this.activityRegularizer = null;
    this.inputSpec = null;
    this.supportsMasking = false;
    this._trainableWeights = [];
    this._nonTrainableWeights = [];
    this._losses = [];
    this._updates = [];
    this._built = false;
    this.inboundNodes = [];
    this.outboundNodes = [];
    let name = args.name;
    if (!name) {
      const prefix2 = this.getClassName();
      name = toSnakeCase(prefix2) + "_" + getUid(prefix2);
    }
    this.name = name;
    this.trainable_ = args.trainable == null ? true : args.trainable;
    if (args.inputShape != null || args.batchInputShape != null) {
      let batchInputShape;
      if (args.batchInputShape != null) {
        batchInputShape = args.batchInputShape;
      } else if (args.inputShape != null) {
        let batchSize = null;
        if (args.batchSize != null) {
          batchSize = args.batchSize;
        }
        batchInputShape = [batchSize].concat(args.inputShape);
      }
      this.batchInputShape = batchInputShape;
      let dtype = args.dtype;
      if (dtype == null) {
        dtype = args.inputDType;
      }
      if (dtype == null) {
        dtype = "float32";
      }
      this.dtype = dtype;
    }
    if (args.weights != null) {
      this.initialWeights = args.weights;
    } else {
      this.initialWeights = null;
    }
    this._refCount = null;
    this.fastWeightInitDuringBuild = false;
  }
  static nodeKey(layer, nodeIndex) {
    return layer.name + "_ib-" + nodeIndex.toString();
  }
  getNodeAtIndex(nodeIndex, attrName) {
    if (this.inboundNodes.length === 0) {
      throw new RuntimeError(`The layer has never been called and thus has no defined ${attrName}.`);
    }
    if (this.inboundNodes.length <= nodeIndex) {
      throw new ValueError(`Asked to get ${attrName} at node ${nodeIndex}, but the layer has only ${this.inboundNodes.length} inbound nodes.`);
    }
    return this.inboundNodes[nodeIndex];
  }
  getInputAt(nodeIndex) {
    return singletonOrArray(this.getNodeAtIndex(nodeIndex, "input").inputTensors);
  }
  getOutputAt(nodeIndex) {
    return singletonOrArray(this.getNodeAtIndex(nodeIndex, "output").outputTensors);
  }
  get input() {
    if (this.inboundNodes.length > 1) {
      throw new AttributeError(`Layer ${this.name} has multiple inbound nodes, hence the notion of "layer input" is ill-defined. Use \`getInputAt(nodeIndex)\` instead.`);
    } else if (this.inboundNodes.length === 0) {
      throw new AttributeError(`Layer ${this.name} is not connected, no input to return.`);
    }
    return singletonOrArray(this.getNodeAtIndex(0, "input").inputTensors);
  }
  get output() {
    if (this.inboundNodes.length === 0) {
      throw new AttributeError(`Layer ${this.name} has no inbound nodes.`);
    }
    if (this.inboundNodes.length > 1) {
      throw new AttributeError(`Layer ${this.name} has multiple inbound nodes, hence the notion of "layer output" is ill-defined. Use \`getOutputAt(nodeIndex)\` instead.`);
    }
    return singletonOrArray(this.getNodeAtIndex(0, "output").outputTensors);
  }
  get losses() {
    return this._losses;
  }
  calculateLosses() {
    return this.losses.map((lossFn) => lossFn());
  }
  get updates() {
    return this._updates;
  }
  get built() {
    return this._built;
  }
  set built(built) {
    this._built = built;
  }
  get trainable() {
    return this.trainable_;
  }
  set trainable(trainable) {
    this._trainableWeights.forEach((w2) => w2.trainable = trainable);
    this.trainable_ = trainable;
  }
  get trainableWeights() {
    if (this.trainable_) {
      return this._trainableWeights.filter((w2) => w2.trainable);
    } else {
      return [];
    }
  }
  set trainableWeights(weights) {
    this._trainableWeights = weights;
  }
  get nonTrainableWeights() {
    if (this.trainable) {
      return this._trainableWeights.filter((w2) => !w2.trainable).concat(this._nonTrainableWeights);
    } else {
      return this._trainableWeights.concat(this._nonTrainableWeights);
    }
  }
  set nonTrainableWeights(weights) {
    this._nonTrainableWeights = weights;
  }
  get weights() {
    return this.trainableWeights.concat(this.nonTrainableWeights);
  }
  get stateful() {
    return this._stateful;
  }
  resetStates() {
    if (!this.stateful) {
      throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
    }
  }
  assertInputCompatibility(inputs) {
    inputs = toList(inputs);
    if (this.inputSpec == null || this.inputSpec.length === 0) {
      return;
    }
    const inputSpec = toList(this.inputSpec);
    if (inputs.length !== inputSpec.length) {
      throw new ValueError(`Layer ${this.name} expects ${inputSpec.length} inputs, but it received ${inputs.length} input tensors. Input received: ${inputs}`);
    }
    for (let inputIndex = 0; inputIndex < inputs.length; inputIndex++) {
      const x2 = inputs[inputIndex];
      const spec = inputSpec[inputIndex];
      if (spec == null) {
        continue;
      }
      const ndim = x2.rank;
      if (spec.ndim != null) {
        if (ndim !== spec.ndim) {
          throw new ValueError(`Input ${inputIndex} is incompatible with layer ${this.name}: expected ndim=${spec.ndim}, found ndim=${ndim}`);
        }
      }
      if (spec.maxNDim != null) {
        if (ndim > spec.maxNDim) {
          throw new ValueError(`Input ${inputIndex} is incompatible with layer ${this.name}: expected max_ndim=${spec.maxNDim}, found ndim=${ndim}`);
        }
      }
      if (spec.minNDim != null) {
        if (ndim < spec.minNDim) {
          throw new ValueError(`Input ${inputIndex} is incompatible with layer ${this.name}: expected min_ndim=${spec.minNDim}, found ndim=${ndim}.`);
        }
      }
      if (spec.dtype != null) {
        if (x2.dtype !== spec.dtype) {
          throw new ValueError(`Input ${inputIndex} is incompatible with layer ${this.name} : expected dtype=${spec.dtype}, found dtype=${x2.dtype}.`);
        }
      }
      if (spec.axes) {
        const xShape = x2.shape;
        for (const key in spec.axes) {
          const axis = Number(key);
          const value = spec.axes[key];
          const xShapeAtAxis = axis >= 0 ? xShape[axis] : xShape[xShape.length + axis];
          if (value != null && [value, null].indexOf(xShapeAtAxis) === -1) {
            throw new ValueError(`Input ${inputIndex} is incompatible with layer ${this.name}: expected axis ${axis} of input shape to have value ${value} but got shape ${xShape}.`);
          }
        }
      }
      if (spec.shape != null) {
        for (let i2 = 0; i2 < spec.shape.length; ++i2) {
          const specDim = spec.shape[i2];
          const dim = x2.shape[i2];
          if (specDim != null && dim != null) {
            if (specDim !== dim) {
              throw new ValueError(`Input ${inputIndex} is incompatible with layer ${this.name}: expected shape=${spec.shape}, found shape=${x2.shape}.`);
            }
          }
        }
      }
    }
  }
  call(inputs, kwargs) {
    return inputs;
  }
  invokeCallHook(inputs, kwargs) {
    if (this._callHook != null) {
      this._callHook(inputs, kwargs);
    }
  }
  setCallHook(callHook3) {
    this._callHook = callHook3;
  }
  clearCallHook() {
    this._callHook = null;
  }
  apply(inputs, kwargs) {
    kwargs = kwargs || {};
    this.assertNotDisposed();
    const inputsList = toList(inputs);
    let allAreSymbolic = true;
    for (const input of inputsList) {
      if (!(input instanceof SymbolicTensor)) {
        allAreSymbolic = false;
        break;
      }
    }
    let noneAreSymbolic = true;
    for (const input of inputsList) {
      if (input instanceof SymbolicTensor) {
        noneAreSymbolic = false;
        break;
      }
    }
    if (allAreSymbolic === noneAreSymbolic) {
      throw new ValueError("Arguments to apply() must be all SymbolicTensors or all Tensors");
    }
    return nameScope(this.name, () => {
      if (!this.built) {
        this.assertInputCompatibility(inputs);
        const inputShapes = [];
        for (const xElem of toList(inputs)) {
          inputShapes.push(xElem.shape);
        }
        this.build(singletonOrArray(inputShapes));
        this.built = true;
        if (this.initialWeights) {
          this.setWeights(this.initialWeights);
        }
        if (this._refCount === null && noneAreSymbolic) {
          this._refCount = 1;
        }
      }
      this.assertInputCompatibility(inputs);
      if (noneAreSymbolic) {
        let output2 = this.call(inputs, kwargs);
        const outputList = toList(output2);
        const outputListCopy = [];
        for (let x2 of outputList) {
          if (inputsList.indexOf(x2) !== -1) {
            x2 = x2.clone();
          }
          outputListCopy.push(x2);
        }
        output2 = singletonOrArray(outputListCopy);
        if (this.activityRegularizer != null) {
          throw new NotImplementedError("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
        }
        return output2;
      } else {
        const inputShape = collectInputShape(inputs);
        const outputShape = this.computeOutputShape(inputShape);
        let output2;
        const outputDType = guessOutputDType(inputs);
        this.warnOnIncompatibleInputShape(Array.isArray(inputs) ? inputShape[0] : inputShape);
        if (outputShape != null && outputShape.length > 0 && Array.isArray(outputShape[0])) {
          output2 = outputShape.map((shape, index2) => new SymbolicTensor(outputDType, shape, this, toList(inputs), kwargs, this.name, index2));
        } else {
          output2 = new SymbolicTensor(outputDType, outputShape, this, toList(inputs), kwargs, this.name);
        }
        this.addInboundNode(inputs, output2, null, null, inputShape, outputShape, kwargs);
        this._refCount++;
        if (this.activityRegularizer != null) {
          throw new NotImplementedError("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
        }
        return output2;
      }
    });
  }
  warnOnIncompatibleInputShape(inputShape) {
    if (this.batchInputShape == null) {
      return;
    } else if (inputShape.length !== this.batchInputShape.length) {
      console.warn(`The rank of the input tensor provided (shape: ${JSON.stringify(inputShape)}) does not match that of the batchInputShape (${JSON.stringify(this.batchInputShape)}) of the layer ${this.name}`);
    } else {
      let dimMismatch = false;
      this.batchInputShape.forEach((dimension, i2) => {
        if (dimension != null && inputShape[i2] != null && inputShape[i2] !== dimension) {
          dimMismatch = true;
        }
      });
      if (dimMismatch) {
        console.warn(`The shape of the input tensor (${JSON.stringify(inputShape)}) does not match the expectation of layer ${this.name}: ${JSON.stringify(this.batchInputShape)}`);
      }
    }
  }
  get outputShape() {
    if (this.inboundNodes == null || this.inboundNodes.length === 0) {
      throw new AttributeError(`The layer ${this.name} has never been called and thus has no defined output shape.`);
    }
    const allOutputShapes = [];
    for (const node of this.inboundNodes) {
      const shapeString = JSON.stringify(node.outputShapes);
      if (allOutputShapes.indexOf(shapeString) === -1) {
        allOutputShapes.push(shapeString);
      }
    }
    if (allOutputShapes.length === 1) {
      const outputShapes = this.inboundNodes[0].outputShapes;
      if (Array.isArray(outputShapes) && Array.isArray(outputShapes[0]) && outputShapes.length === 1) {
        return outputShapes[0];
      } else {
        return outputShapes;
      }
    } else {
      throw new AttributeError(`The layer ${this.name} has multiple inbound nodes with different output shapes. Hence the notion of "output shape" is ill-defined for the layer.`);
    }
  }
  countParams() {
    if (!this.built) {
      throw new RuntimeError(`You tried to call countParams() on ${this.name}, but the layer is not built yet. Build it first by calling build(batchInputShape).`);
    }
    return countParamsInWeights(this.weights);
  }
  build(inputShape) {
    this.built = true;
  }
  getWeights(trainableOnly = false) {
    return batchGetValue(trainableOnly ? this.trainableWeights : this.weights);
  }
  setWeights(weights) {
    tidy(() => {
      const params = this.weights;
      if (params.length !== weights.length) {
        throw new ValueError(`You called setWeights(weights) on layer "${this.name}" with a weight list of length ${weights.length}, but the layer was expecting ${params.length} weights. Provided weights: ${weights}...`);
      }
      if (params.length === 0) {
        return;
      }
      const weightValueTuples = [];
      const paramValues = batchGetValue(params);
      for (let i2 = 0; i2 < paramValues.length; ++i2) {
        const pv = paramValues[i2];
        const p2 = params[i2];
        const w2 = weights[i2];
        if (!arraysEqual(pv.shape, w2.shape)) {
          throw new ValueError(`Layer weight shape ${pv.shape} not compatible with provided weight shape ${w2.shape}`);
        }
        weightValueTuples.push([p2, w2]);
      }
      batchSetValue(weightValueTuples);
    });
  }
  addWeight(name, shape, dtype, initializer, regularizer, trainable, constraint, getInitializerFunc) {
    if (this._addedWeightNames.indexOf(name) !== -1) {
      throw new ValueError(`Duplicate weight name ${name} for layer ${this.name}`);
    }
    this._addedWeightNames.push(name);
    if (dtype == null) {
      dtype = "float32";
    }
    if (this.fastWeightInitDuringBuild) {
      initializer = getInitializerFunc != null ? getInitializerFunc() : getInitializer("zeros");
    }
    const initValue = initializer.apply(shape, dtype);
    const weight = new LayerVariable(initValue, dtype, name, trainable, constraint);
    initValue.dispose();
    if (regularizer != null) {
      this.addLoss(() => regularizer.apply(weight.read()));
    }
    if (trainable == null) {
      trainable = true;
    }
    if (trainable) {
      this._trainableWeights.push(weight);
    } else {
      this._nonTrainableWeights.push(weight);
    }
    return weight;
  }
  setFastWeightInitDuringBuild(value) {
    this.fastWeightInitDuringBuild = value;
  }
  addLoss(losses) {
    if (losses == null || Array.isArray(losses) && losses.length === 0) {
      return;
    }
    losses = toList(losses);
    if (this._losses !== void 0 && this._losses !== null) {
      this.losses.push(...losses);
    }
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  computeMask(inputs, mask) {
    if (!this.supportsMasking) {
      if (mask != null) {
        if (Array.isArray(mask)) {
          mask.forEach((maskElement) => {
            if (maskElement != null) {
              throw new TypeError(`Layer ${this.name} does not support masking, but was passed an inputMask.`);
            }
          });
        } else {
          throw new TypeError(`Layer ${this.name} does not support masking, but was passed an inputMask.`);
        }
      }
      return null;
    }
    return mask;
  }
  addInboundNode(inputTensors, outputTensors, inputMasks, outputMasks, inputShapes, outputShapes, kwargs = null) {
    const inputTensorList = toList(inputTensors);
    outputTensors = toList(outputTensors);
    inputMasks = toList(inputMasks);
    outputMasks = toList(outputMasks);
    inputShapes = normalizeShapeList(inputShapes);
    outputShapes = normalizeShapeList(outputShapes);
    const inboundLayers = [];
    const nodeIndices = [];
    const tensorIndices = [];
    for (const x2 of inputTensorList) {
      inboundLayers.push(x2.sourceLayer);
      nodeIndices.push(x2.nodeIndex);
      tensorIndices.push(x2.tensorIndex);
    }
    new Node$1({
      outboundLayer: this,
      inboundLayers,
      nodeIndices,
      tensorIndices,
      inputTensors: inputTensorList,
      outputTensors,
      inputMasks,
      outputMasks,
      inputShapes,
      outputShapes
    }, kwargs);
    for (let i2 = 0; i2 < outputTensors.length; i2++) {
      outputTensors[i2].sourceLayer = this;
      outputTensors[i2].nodeIndex = this.inboundNodes.length - 1;
      outputTensors[i2].tensorIndex = i2;
    }
  }
  getConfig() {
    const config2 = { name: this.name, trainable: this.trainable };
    if (this.batchInputShape != null) {
      config2["batchInputShape"] = this.batchInputShape;
    }
    if (this.dtype != null) {
      config2["dtype"] = this.dtype;
    }
    return config2;
  }
  disposeWeights() {
    this.weights.forEach((weight) => weight.dispose());
    return this.weights.length;
  }
  assertNotDisposed() {
    if (this._refCount === 0) {
      throw new Error(`Layer '${this.name}' is already disposed.`);
    }
  }
  dispose() {
    if (!this.built) {
      throw new Error(`Cannot dispose Layer ${this.name} because it has not been built yet.`);
    }
    if (this._refCount === null) {
      throw new Error(`Cannot dispose Layer ${this.name} because it has not been used yet.`);
    }
    this.assertNotDisposed();
    let numDisposedVariables = 0;
    if (--this._refCount === 0) {
      numDisposedVariables = this.disposeWeights();
    }
    return { refCountAfterDispose: this._refCount, numDisposedVariables };
  }
}
function collectInputShape(inputTensors) {
  inputTensors = toList(inputTensors);
  const shapes = [];
  for (const x2 of inputTensors) {
    shapes.push(x2.shape);
  }
  return singletonOrArray(shapes);
}
function guessOutputDType(inputTensors) {
  return "float32";
}
function getSourceInputs(tensor2, layer, nodeIndex) {
  if (layer == null || nodeIndex != null && nodeIndex > 0) {
    layer = tensor2.sourceLayer;
    nodeIndex = tensor2.nodeIndex;
  }
  if (layer.inboundNodes.length === 0) {
    return [tensor2];
  } else {
    const node = layer.inboundNodes[nodeIndex];
    if (node.inboundLayers.length === 0) {
      return node.inputTensors;
    } else {
      const sourceTensors = [];
      for (let i2 = 0; i2 < node.inboundLayers.length; i2++) {
        const x2 = node.inputTensors[i2];
        const layer2 = node.inboundLayers[i2];
        const nodeIndex2 = node.nodeIndices[i2];
        const previousSources = getSourceInputs(x2, layer2, nodeIndex2);
        for (const x3 of previousSources) {
          if (sourceTensors.indexOf(x3) === -1) {
            sourceTensors.push(x3);
          }
        }
      }
      return sourceTensors;
    }
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class InputLayer extends Layer {
  constructor(args) {
    super({
      dtype: args.dtype,
      name: args.name != null ? args.name : getUid("input").toString()
    });
    if (args.batchSize == null) {
      args.batchSize = null;
    }
    if (args.sparse == null) {
      args.sparse = false;
    }
    this.trainable = false;
    this.built = true;
    this.sparse = args.sparse;
    if (args.inputShape != null && args.batchInputShape != null) {
      throw new ValueError("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
    }
    let batchInputShape = args.batchInputShape;
    if (batchInputShape == null) {
      if (args.inputShape == null) {
        throw new ValueError("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
      } else {
        batchInputShape = [args.batchSize].concat(args.inputShape);
      }
    } else {
      if (args.batchSize != null) {
        throw new ValueError("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
      }
    }
    const dtype = args.dtype || "float32";
    this.batchInputShape = batchInputShape;
    this.dtype = dtype;
    this.inputSpec = [{ shape: batchInputShape }];
    const inputTensor = new SymbolicTensor(this.dtype, this.batchInputShape, this, [], {}, this.name);
    inputTensor.nodeIndex = 0;
    inputTensor.tensorIndex = 0;
    new Node$1({
      outboundLayer: this,
      inboundLayers: [],
      nodeIndices: [],
      tensorIndices: [],
      inputTensors: [inputTensor],
      outputTensors: [inputTensor],
      inputMasks: [null],
      outputMasks: [null],
      inputShapes: [batchInputShape],
      outputShapes: [batchInputShape]
    });
  }
  apply(inputs, kwargs) {
    throw new ValueError(`Cannot pass any input to an InputLayer's apply() method. InputLayer name: ${this.name}`);
  }
  dispose() {
    return { refCountAfterDispose: this._refCount, numDisposedVariables: 0 };
  }
  getConfig() {
    return {
      batchInputShape: this.batchInputShape,
      dtype: this.dtype,
      sparse: this.sparse,
      name: this.name
    };
  }
}
InputLayer.className = "InputLayer";
registerClass(InputLayer);
function Input$4(config2) {
  if (config2.batchShape == null && config2.shape == null) {
    throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
  }
  if (config2.batchShape != null && config2.shape != null) {
    throw new ValueError("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
  }
  let batchShape = config2.batchShape;
  if (config2.shape != null && batchShape == null) {
    batchShape = [null].concat(config2.shape);
  }
  let dtype = config2.dtype;
  if (dtype == null) {
    dtype = "float32";
  }
  const inputLayer = new InputLayer({
    batchInputShape: batchShape,
    name: config2.name,
    dtype,
    sparse: config2.sparse
  });
  const outputs = inputLayer.inboundNodes[0].outputTensors;
  return outputs[0];
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function assertFeedCompatibility(key, val) {
  if (key.dtype == null || key.dtype === val.dtype) {
    return val;
  }
  try {
    return cast$4(val, key.dtype);
  } catch (err) {
    throw new ValueError(`The dtype of the feed (${val.dtype}) can not be cast to the dtype of the key '${key.name}' (${key.dtype}).`);
  }
}
class FeedDict {
  constructor(feeds) {
    this.id2Value = {};
    this.id2Mask = {};
    this.name2Id = {};
    if (feeds instanceof FeedDict) {
      for (const id2 in feeds.id2Value) {
        this.id2Value[id2] = feeds.id2Value[id2];
        if (id2 in feeds.id2Mask) {
          this.id2Mask[id2] = feeds.id2Mask[id2];
        }
      }
    } else {
      if (feeds == null) {
        return;
      }
      for (const feed of feeds) {
        this.add(feed.key, feed.value);
      }
    }
  }
  add(key, value, mask) {
    if (this.id2Value[key.id] == null) {
      this.id2Value[key.id] = assertFeedCompatibility(key, value);
      this.name2Id[key.name] = key.id;
      if (mask != null) {
        this.id2Mask[key.id] = mask;
      }
    } else {
      throw new ValueError(`Duplicate key: name=${key.name}, id=${key.id}`);
    }
    return this;
  }
  addFeed(feed) {
    this.add(feed.key, feed.value);
  }
  hasKey(key) {
    return this.id2Value[key.id] != null;
  }
  names() {
    return Object.keys(this.name2Id);
  }
  getValue(key) {
    if (key instanceof SymbolicTensor) {
      if (this.id2Value[key.id] == null) {
        throw new ValueError(`Nonexistent key: ${key.name}`);
      } else {
        return this.id2Value[key.id];
      }
    } else {
      const id2 = this.name2Id[key];
      if (id2 == null) {
        throw new ValueError(`Feed dict has no SymbolicTensor name: ${key}`);
      }
      return this.id2Value[id2];
    }
  }
  getMask(key) {
    if (key instanceof SymbolicTensor) {
      if (this.id2Value[key.id] == null) {
        throw new ValueError(`Nonexistent key: ${key.name}`);
      } else {
        return this.id2Mask[key.id];
      }
    } else {
      const id2 = this.name2Id[key];
      if (id2 == null) {
        throw new ValueError(`Feed dict has no SymbolicTensor name: ${key}`);
      }
      return this.id2Mask[id2];
    }
  }
  disposeMasks() {
    if (this.id2Mask != null) {
      dispose(this.id2Mask);
    }
  }
}
const cachedSorted = new LruCache();
const cachedRecipientCounts = new LruCache();
function updateCacheMaxEntries(maxEntries) {
  if (cachedSorted != null) {
    cachedSorted.setMaxEntries(maxEntries);
  }
  if (cachedRecipientCounts != null) {
    cachedRecipientCounts.setMaxEntries(maxEntries);
  }
}
function execute(fetches, feedDict, kwargs, probe) {
  const training = kwargs == null ? false : kwargs["training"];
  const arrayFetches = Array.isArray(fetches);
  const fetchArray = arrayFetches ? fetches : [fetches];
  const outputNames = fetchArray.map((t2) => t2.name);
  const finalOutputs = [];
  const feedNames = feedDict.names();
  for (const outputName of outputNames) {
    if (feedNames.indexOf(outputName) !== -1) {
      finalOutputs.push(feedDict.getValue(outputName));
    } else {
      finalOutputs.push(null);
    }
  }
  if (probe != null) {
    probe.maxNumTensors = -Infinity;
    probe.minNumTensors = Infinity;
  }
  const fetchAndFeedKey = outputNames.join(",") + "|" + feedDict.names().join(",");
  let sorted = cachedSorted.get(fetchAndFeedKey);
  let recipientCounts;
  if (sorted == null) {
    const out = getTopologicalSortAndRecipientCounts(fetchArray, feedDict);
    sorted = out.sorted;
    recipientCounts = out.recipientCounts;
    cachedSorted.put(fetchAndFeedKey, sorted);
    cachedRecipientCounts.put(fetchAndFeedKey, recipientCounts);
  }
  recipientCounts = {};
  if (!training) {
    Object.assign(recipientCounts, cachedRecipientCounts.get(fetchAndFeedKey));
  }
  const internalFeedDict = new FeedDict(feedDict);
  for (let i2 = 0; i2 < sorted.length; ++i2) {
    if (probe != null) {
      const numTensors = memory().numTensors;
      if (numTensors > probe.maxNumTensors) {
        probe.maxNumTensors = numTensors;
      }
      if (numTensors < probe.minNumTensors) {
        probe.minNumTensors = numTensors;
      }
    }
    const symbolic = sorted[i2];
    const srcLayer = symbolic.sourceLayer;
    if (srcLayer instanceof InputLayer) {
      continue;
    }
    const inputValues = [];
    const inputMasks = [];
    const tensorsToDispose = [];
    let maskExists = false;
    for (const input of symbolic.inputs) {
      const value = internalFeedDict.getValue(input);
      const mask = internalFeedDict.getMask(input);
      inputValues.push(value);
      inputMasks.push(mask);
      if (mask != null) {
        maskExists = true;
      }
      if (!training) {
        recipientCounts[input.name]--;
        if (recipientCounts[input.name] === 0 && !feedDict.hasKey(input) && outputNames.indexOf(input.name) === -1 && !value.isDisposed && input.sourceLayer.stateful !== true) {
          tensorsToDispose.push(value);
        }
      }
    }
    if (maskExists) {
      kwargs = kwargs || {};
      kwargs["mask"] = inputMasks[0];
    }
    const outputTensors = toList(srcLayer.apply(inputValues, kwargs));
    let outputMask = null;
    if (srcLayer.supportsMasking) {
      outputMask = srcLayer.computeMask(inputValues, inputMasks);
    }
    const layerOutputs = getNodeOutputs(symbolic);
    const outputSymbolicTensors = Array.isArray(layerOutputs) ? layerOutputs : [layerOutputs];
    for (let i3 = 0; i3 < outputSymbolicTensors.length; ++i3) {
      if (!internalFeedDict.hasKey(outputSymbolicTensors[i3])) {
        internalFeedDict.add(outputSymbolicTensors[i3], outputTensors[i3], Array.isArray(outputMask) ? outputMask[0] : outputMask);
      }
      const index2 = outputNames.indexOf(outputSymbolicTensors[i3].name);
      if (index2 !== -1) {
        finalOutputs[index2] = outputTensors[i3];
      }
    }
    if (!training) {
      dispose(tensorsToDispose);
    }
  }
  internalFeedDict.disposeMasks();
  return arrayFetches ? finalOutputs : finalOutputs[0];
}
function getTopologicalSortAndRecipientCounts(fetches, feedDict) {
  assert$1(fetches != null && fetches.length > 0, () => `Expected at least one fetch, got none`);
  let finalSorted = [];
  let finalRecipientMap = {};
  if (fetches.length === 1) {
    const out = getTopologicalSortAndRecipientCountsForOneFetch(fetches[0], feedDict);
    finalSorted = out.sorted;
    finalRecipientMap = out.recipientMap;
  } else {
    const visited = /* @__PURE__ */ new Set();
    for (const fetch2 of fetches) {
      const { sorted, recipientMap } = getTopologicalSortAndRecipientCountsForOneFetch(fetch2, feedDict);
      for (const symbolicTensor of sorted) {
        if (!visited.has(symbolicTensor.name)) {
          finalSorted.push(symbolicTensor);
          visited.add(symbolicTensor.name);
        }
      }
      for (const name in recipientMap) {
        if (finalRecipientMap[name] == null) {
          finalRecipientMap[name] = /* @__PURE__ */ new Set();
        }
        recipientMap[name].forEach((recipient) => finalRecipientMap[name].add(recipient));
      }
    }
  }
  return {
    sorted: finalSorted,
    recipientCounts: recipientMap2Counts(finalRecipientMap)
  };
}
function recipientMap2Counts(recipientMap) {
  const recipientCounts = {};
  for (const name in recipientMap) {
    recipientCounts[name] = recipientMap[name].size;
  }
  return recipientCounts;
}
function getTopologicalSortAndRecipientCountsForOneFetch(fetch2, feedDict) {
  const visited = /* @__PURE__ */ new Set();
  const sorted = [];
  const recipientMap = {};
  for (const key of feedDict.names()) {
    visited.add(key);
  }
  const stack2 = [];
  const marks = [];
  stack2.push(fetch2);
  while (stack2.length > 0) {
    const top2 = stack2[stack2.length - 1];
    if (visited.has(top2.name)) {
      stack2.pop();
      continue;
    }
    const topIsMarked = marks[marks.length - 1] === stack2.length - 1;
    if (top2.inputs.length === 0 || topIsMarked) {
      stack2.pop();
      sorted.push(top2);
      visited.add(top2.name);
      if (topIsMarked) {
        marks.pop();
      }
    } else {
      marks.push(stack2.length - 1);
      for (const input of top2.inputs) {
        if (recipientMap[input.name] == null) {
          recipientMap[input.name] = /* @__PURE__ */ new Set();
        }
        recipientMap[input.name].add(top2.name);
        if (visited.has(input.name)) {
          continue;
        }
        stack2.push(input);
      }
    }
  }
  return { sorted, recipientMap };
}
function getNodeOutputs(fetch2) {
  let layerOutputs;
  if (fetch2.sourceLayer.inboundNodes.length === 1) {
    layerOutputs = fetch2.sourceLayer.output;
  } else {
    let nodeIndex = null;
    for (let i2 = 0; i2 < fetch2.sourceLayer.inboundNodes.length; ++i2) {
      for (const outputTensor of fetch2.sourceLayer.inboundNodes[i2].outputTensors) {
        if (outputTensor.id === fetch2.id) {
          nodeIndex = i2;
          break;
        }
      }
    }
    layerOutputs = fetch2.sourceLayer.getOutputAt(nodeIndex);
  }
  return layerOutputs;
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ENV$3 = env();
ENV$3.registerFlag("TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES", () => 100, updateCacheMaxEntries);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function calcL2Norms(w2, axis) {
  return tidy(() => sqrt$2(sum$3(mul(w2, w2), axis, true)));
}
class Constraint extends Serializable {
  getConfig() {
    return {};
  }
}
class MaxNorm extends Constraint {
  constructor(args) {
    super();
    this.defaultMaxValue = 2;
    this.defaultAxis = 0;
    this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
    this.axis = args.axis != null ? args.axis : this.defaultAxis;
  }
  apply(w2) {
    return tidy(() => {
      const norms = calcL2Norms(w2, this.axis);
      const desired = clipByValue$2(norms, 0, this.maxValue);
      return mul(w2, div$1(desired, add$1(epsilon$1(), norms)));
    });
  }
  getConfig() {
    return { maxValue: this.maxValue, axis: this.axis };
  }
}
MaxNorm.className = "MaxNorm";
registerClass(MaxNorm);
class UnitNorm extends Constraint {
  constructor(args) {
    super();
    this.defaultAxis = 0;
    this.axis = args.axis != null ? args.axis : this.defaultAxis;
  }
  apply(w2) {
    return tidy(() => div$1(w2, add$1(epsilon$1(), calcL2Norms(w2, this.axis))));
  }
  getConfig() {
    return { axis: this.axis };
  }
}
UnitNorm.className = "UnitNorm";
registerClass(UnitNorm);
class NonNeg extends Constraint {
  apply(w2) {
    return relu$2(w2);
  }
}
NonNeg.className = "NonNeg";
registerClass(NonNeg);
class MinMaxNorm extends Constraint {
  constructor(args) {
    super();
    this.defaultMinValue = 0;
    this.defaultMaxValue = 1;
    this.defaultRate = 1;
    this.defaultAxis = 0;
    this.minValue = args.minValue != null ? args.minValue : this.defaultMinValue;
    this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
    this.rate = args.rate != null ? args.rate : this.defaultRate;
    this.axis = args.axis != null ? args.axis : this.defaultAxis;
  }
  apply(w2) {
    return tidy(() => {
      const norms = calcL2Norms(w2, this.axis);
      const desired = add$1(mul(this.rate, clipByValue$2(norms, this.minValue, this.maxValue)), mul(1 - this.rate, norms));
      return mul(w2, div$1(desired, add$1(epsilon$1(), norms)));
    });
  }
  getConfig() {
    return {
      minValue: this.minValue,
      maxValue: this.maxValue,
      rate: this.rate,
      axis: this.axis
    };
  }
}
MinMaxNorm.className = "MinMaxNorm";
registerClass(MinMaxNorm);
const CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP = {
  "maxNorm": "MaxNorm",
  "minMaxNorm": "MinMaxNorm",
  "nonNeg": "NonNeg",
  "unitNorm": "UnitNorm"
};
function serializeConstraint(constraint) {
  return serializeKerasObject(constraint);
}
function deserializeConstraint(config2, customObjects = {}) {
  return deserializeKerasObject(config2, SerializationMap.getMap().classNameMap, customObjects, "constraint");
}
function getConstraint(identifier) {
  if (identifier == null) {
    return null;
  }
  if (typeof identifier === "string") {
    const className = identifier in CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP ? CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP[identifier] : identifier;
    const config2 = { className, config: {} };
    return deserializeConstraint(config2);
  } else if (identifier instanceof Constraint) {
    return identifier;
  } else {
    return deserializeConstraint(identifier);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
async function resolveScalarsInLogs(logs) {
  if (logs == null) {
    return;
  }
  const promises = [];
  const keys = [];
  const scalarsToDispose = [];
  for (const key in logs) {
    const value = logs[key];
    if (typeof value !== "number") {
      const valueScalar = value;
      promises.push(valueScalar.data());
      keys.push(key);
      scalarsToDispose.push(valueScalar);
    }
  }
  if (promises.length > 0) {
    const values = await Promise.all(promises);
    for (let i2 = 0; i2 < values.length; ++i2) {
      logs[keys[i2]] = values[i2][0];
    }
    dispose(scalarsToDispose);
  }
}
function disposeTensorsInLogs(logs) {
  if (logs == null) {
    return;
  }
  for (const key in logs) {
    const value = logs[key];
    if (typeof value !== "number") {
      value.dispose();
    }
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
var ModelLoggingVerbosity;
(function(ModelLoggingVerbosity2) {
  ModelLoggingVerbosity2[ModelLoggingVerbosity2["SILENT"] = 0] = "SILENT";
  ModelLoggingVerbosity2[ModelLoggingVerbosity2["VERBOSE"] = 1] = "VERBOSE";
})(ModelLoggingVerbosity || (ModelLoggingVerbosity = {}));
const DEFAULT_YIELD_EVERY_MS = 125;
class BaseCallback {
  constructor() {
    this.validationData = null;
  }
  setParams(params) {
    this.params = params;
  }
  async onEpochBegin(epoch, logs) {
  }
  async onEpochEnd(epoch, logs) {
  }
  async onBatchBegin(batch, logs) {
  }
  async onBatchEnd(batch, logs) {
  }
  async onTrainBegin(logs) {
  }
  async onTrainEnd(logs) {
  }
  setModel(model2) {
  }
}
class CallbackList {
  constructor(callbacks, queueLength = 10) {
    if (callbacks == null) {
      callbacks = [];
    }
    this.callbacks = callbacks;
    this.queueLength = queueLength;
  }
  append(callback) {
    this.callbacks.push(callback);
  }
  setParams(params) {
    for (const callback of this.callbacks) {
      callback.setParams(params);
    }
  }
  setModel(model2) {
    for (const callback of this.callbacks) {
      callback.setModel(model2);
    }
  }
  async onEpochBegin(epoch, logs) {
    if (logs == null) {
      logs = {};
    }
    for (const callback of this.callbacks) {
      await callback.onEpochBegin(epoch, logs);
    }
  }
  async onEpochEnd(epoch, logs) {
    if (logs == null) {
      logs = {};
    }
    for (const callback of this.callbacks) {
      await callback.onEpochEnd(epoch, logs);
    }
  }
  async onBatchBegin(batch, logs) {
    if (logs == null) {
      logs = {};
    }
    for (const callback of this.callbacks) {
      await callback.onBatchBegin(batch, logs);
    }
  }
  async onBatchEnd(batch, logs) {
    if (logs == null) {
      logs = {};
    }
    for (const callback of this.callbacks) {
      await callback.onBatchEnd(batch, logs);
    }
  }
  async onTrainBegin(logs) {
    if (logs == null) {
      logs = {};
    }
    for (const callback of this.callbacks) {
      await callback.onTrainBegin(logs);
    }
  }
  async onTrainEnd(logs) {
    if (logs == null) {
      logs = {};
    }
    for (const callback of this.callbacks) {
      await callback.onTrainEnd(logs);
    }
  }
}
class BaseLogger extends BaseCallback {
  constructor() {
    super();
  }
  async onEpochBegin(epoch) {
    this.seen = 0;
    this.totals = {};
  }
  async onBatchEnd(batch, logs) {
    if (logs == null) {
      logs = {};
    }
    const batchSize = logs["size"] == null ? 0 : logs["size"];
    this.seen += batchSize;
    for (const key in logs) {
      const value = logs[key];
      if (typeof value === "number") {
        if (!this.totals.hasOwnProperty(key)) {
          this.totals[key] = 0;
        }
        this.totals[key] = this.totals[key] + value * batchSize;
      } else {
        let oldTotalsToDispose;
        if (key in this.totals) {
          oldTotalsToDispose = this.totals[key];
        } else {
          this.totals[key] = 0;
        }
        const total = tidy(() => add$1(this.totals[key], mul(value, batchSize)));
        this.totals[key] = total;
        if (oldTotalsToDispose != null) {
          oldTotalsToDispose.dispose();
        }
      }
    }
  }
  async onEpochEnd(epoch, logs) {
    if (logs != null) {
      for (const key of this.params["metrics"]) {
        if (this.totals[key] == null) {
          continue;
        }
        if (typeof this.totals[key] === "number") {
          logs[key] = this.totals[key] / this.seen;
        } else {
          tidy(() => {
            const log3 = mul(div$1(1, this.seen), this.totals[key]);
            logs[key] = log3;
            this.totals[key].dispose();
            keep(logs[key]);
          });
        }
      }
    }
  }
}
class History extends BaseCallback {
  async onTrainBegin(logs) {
    this.epoch = [];
    this.history = {};
  }
  async onEpochEnd(epoch, logs) {
    if (logs == null) {
      logs = {};
    }
    this.epoch.push(epoch);
    for (const key in logs) {
      if (this.history[key] == null) {
        this.history[key] = [];
      }
      this.history[key].push(logs[key]);
    }
  }
  async syncData() {
    const promises = [];
    const keys = [];
    const indices = [];
    for (const key in this.history) {
      const valueArray = this.history[key];
      for (let i2 = 0; i2 < valueArray.length; ++i2) {
        if (typeof valueArray[i2] !== "number") {
          const valueScalar = valueArray[i2];
          promises.push(valueScalar.data());
          keys.push(key);
          indices.push(i2);
        }
      }
    }
    const values = await Promise.all(promises);
    for (let n2 = 0; n2 < values.length; ++n2) {
      const tensorToDispose = this.history[keys[n2]][indices[n2]];
      tensorToDispose.dispose();
      this.history[keys[n2]][indices[n2]] = values[n2][0];
    }
  }
}
class CustomCallback extends BaseCallback {
  constructor(args, yieldEvery) {
    super();
    this.currentEpoch = 0;
    this.nowFunc = args.nowFunc;
    this.nextFrameFunc = args.nextFrameFunc || nextFrame;
    this.yieldEvery = yieldEvery || "auto";
    if (this.yieldEvery === "auto") {
      this.yieldEvery = DEFAULT_YIELD_EVERY_MS;
    }
    if (this.yieldEvery === "never" && args.onYield != null) {
      throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
    }
    if (isNumber$1(this.yieldEvery)) {
      this.maybeWait = debounce$1(this.maybeWait.bind(this), this.yieldEvery, this.nowFunc);
    }
    this.trainBegin = args.onTrainBegin;
    this.trainEnd = args.onTrainEnd;
    this.epochBegin = args.onEpochBegin;
    this.epochEnd = args.onEpochEnd;
    this.batchBegin = args.onBatchBegin;
    this.batchEnd = args.onBatchEnd;
    this.yield = args.onYield;
  }
  async maybeWait(epoch, batch, logs) {
    const ps = [];
    if (this.yield != null) {
      await resolveScalarsInLogs(logs);
      ps.push(this.yield(epoch, batch, logs));
    }
    ps.push(this.nextFrameFunc());
    await Promise.all(ps);
  }
  async onEpochBegin(epoch, logs) {
    this.currentEpoch = epoch;
    if (this.epochBegin != null) {
      await resolveScalarsInLogs(logs);
      await this.epochBegin(epoch, logs);
    }
  }
  async onEpochEnd(epoch, logs) {
    const ps = [];
    if (this.epochEnd != null) {
      await resolveScalarsInLogs(logs);
      ps.push(this.epochEnd(epoch, logs));
    }
    if (this.yieldEvery === "epoch") {
      ps.push(this.nextFrameFunc());
    }
    await Promise.all(ps);
  }
  async onBatchBegin(batch, logs) {
    if (this.batchBegin != null) {
      await resolveScalarsInLogs(logs);
      await this.batchBegin(batch, logs);
    }
  }
  async onBatchEnd(batch, logs) {
    const ps = [];
    if (this.batchEnd != null) {
      await resolveScalarsInLogs(logs);
      ps.push(this.batchEnd(batch, logs));
    }
    if (this.yieldEvery === "batch") {
      ps.push(this.nextFrameFunc());
    } else if (isNumber$1(this.yieldEvery)) {
      ps.push(this.maybeWait(this.currentEpoch, batch, logs));
    }
    await Promise.all(ps);
  }
  async onTrainBegin(logs) {
    if (this.trainBegin != null) {
      await resolveScalarsInLogs(logs);
      await this.trainBegin(logs);
    }
  }
  async onTrainEnd(logs) {
    if (this.trainEnd != null) {
      await resolveScalarsInLogs(logs);
      await this.trainEnd(logs);
    }
  }
}
function standardizeCallbacks(callbacks, yieldEvery) {
  if (callbacks == null) {
    callbacks = {};
  }
  if (callbacks instanceof BaseCallback) {
    return [callbacks];
  }
  if (Array.isArray(callbacks) && callbacks[0] instanceof BaseCallback) {
    return callbacks;
  }
  const callbackConfigs = toList(callbacks);
  return callbackConfigs.map((callbackConfig) => new CustomCallback(callbackConfig, yieldEvery));
}
class CallbackConstructorRegistry {
  constructor() {
  }
  static registerCallbackConstructor(verbosityLevel, callbackConstructor) {
    assert$1(verbosityLevel >= 0 && Number.isInteger(verbosityLevel), () => `Verbosity level is expected to be an integer >= 0, but got ${verbosityLevel}`);
    CallbackConstructorRegistry.checkForDuplicate(callbackConstructor);
    if (CallbackConstructorRegistry.constructors[verbosityLevel] == null) {
      CallbackConstructorRegistry.constructors[verbosityLevel] = [];
    }
    CallbackConstructorRegistry.constructors[verbosityLevel].push(callbackConstructor);
  }
  static checkForDuplicate(callbackConstructor) {
    for (const levelName in CallbackConstructorRegistry.constructors) {
      const constructors = CallbackConstructorRegistry.constructors[+levelName];
      constructors.forEach((ctor) => {
        if (ctor === callbackConstructor) {
          throw new ValueError("Duplicate callback constructor.");
        }
      });
    }
  }
  static clear() {
    CallbackConstructorRegistry.constructors = {};
  }
  static createCallbacks(verbosityLevel) {
    const constructors = [];
    for (const levelName in CallbackConstructorRegistry.constructors) {
      const level = +levelName;
      if (verbosityLevel >= level) {
        constructors.push(...CallbackConstructorRegistry.constructors[level]);
      }
    }
    return constructors.map((ctor) => new ctor());
  }
}
CallbackConstructorRegistry.constructors = {};
function configureCallbacks(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics) {
  const history = new History();
  const actualCallbacks = [
    new BaseLogger(),
    ...CallbackConstructorRegistry.createCallbacks(verbose)
  ];
  if (callbacks != null) {
    actualCallbacks.push(...callbacks);
  }
  actualCallbacks.push(history);
  const callbackList = new CallbackList(actualCallbacks);
  callbackList.setParams({
    epochs,
    initialEpoch,
    samples: numTrainSamples,
    steps: stepsPerEpoch,
    batchSize,
    verbose,
    doValidation,
    metrics: callbackMetrics
  });
  return { callbackList, history };
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function deserialize(config2, customObjects = {}, fastWeightInit = false) {
  return deserializeKerasObject(config2, SerializationMap.getMap().classNameMap, customObjects, "layer", fastWeightInit);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function l2Normalize(x2, axis) {
  return tidy(() => {
    if (x2.dtype !== "float32") {
      x2 = cast$4(x2, "float32");
    }
    const squareSum = sum$3(square$1(x2), axis, true);
    const epsilonTensor = fill$3(squareSum.shape, epsilon$1());
    const norm2 = sqrt$2(maximum$2(squareSum, epsilonTensor));
    return div$1(x2, norm2);
  });
}
function meanSquaredError(yTrue, yPred) {
  return tidy(() => mean$2(square$1(sub$2(yPred, yTrue)), -1));
}
function meanAbsoluteError(yTrue, yPred) {
  return tidy(() => mean$2(abs$2(sub$2(yPred, yTrue)), -1));
}
function meanAbsolutePercentageError(yTrue, yPred) {
  return tidy(() => {
    const diff = sub$2(yTrue, yPred);
    const clippedTrue = clipByValue$2(abs$2(yTrue), epsilon$1(), Number.MAX_VALUE);
    const absResult = abs$2(div$1(diff, clippedTrue));
    return mul(100, mean$2(absResult, -1));
  });
}
function meanSquaredLogarithmicError(yTrue, yPred) {
  return tidy(() => {
    const clippedPred = clipByValue$2(yPred, epsilon$1(), Number.MAX_VALUE);
    const firstLog = log$7(add$1(1, clippedPred));
    const clippedTrue = clipByValue$2(yTrue, epsilon$1(), Number.MAX_VALUE);
    const secondLog = log$7(add$1(1, clippedTrue));
    return mean$2(square$1(sub$2(firstLog, secondLog)), -1);
  });
}
function squaredHinge(yTrue, yPred) {
  return tidy(() => {
    const maxResult = maximum$2(0, sub$2(1, mul(yTrue, yPred)));
    return mean$2(square$1(maxResult), -1);
  });
}
function hinge(yTrue, yPred) {
  return tidy(() => {
    const maxResult = maximum$2(0, sub$2(1, mul(yTrue, yPred)));
    return mean$2(maxResult, -1);
  });
}
function categoricalHinge(yTrue, yPred) {
  return tidy(() => {
    const pos = sum$3(mul(yTrue, yPred), -1);
    const neg2 = max$4(mul(sub$2(1, yTrue), yPred), -1);
    return maximum$2(0, add$1(1, sub$2(neg2, pos)));
  });
}
function logcosh(yTrue, yPred) {
  return tidy(() => {
    const log22 = Math.log(2);
    const predictionDiff = sub$2(yPred, yTrue);
    const logcoshResult = sub$2(add$1(predictionDiff, softplus$2(mul(-2, predictionDiff))), log22);
    return mean$2(logcoshResult, -1);
  });
}
function categoricalCrossentropy$1(target, output2, fromLogits = false) {
  return tidy(() => {
    if (fromLogits) {
      output2 = softmax$3(output2);
    } else {
      const outputSum = sum$3(output2, output2.shape.length - 1, true);
      output2 = div$1(output2, outputSum);
    }
    output2 = clipByValue$2(output2, epsilon$1(), 1 - epsilon$1());
    return neg$2(sum$3(mul(cast$4(target, "float32"), log$7(output2)), output2.shape.length - 1));
  });
}
function sparseCategoricalCrossentropy$1(target, output2, fromLogits = false) {
  return tidy(() => {
    const flatTarget = cast$4(floor$2(flatten(target)), "int32");
    output2 = clipByValue$2(output2, epsilon$1(), 1 - epsilon$1());
    const outputShape = output2.shape;
    const oneHotTarget = reshape$3(oneHot$3(flatTarget, outputShape[outputShape.length - 1]), outputShape);
    return categoricalCrossentropy$1(oneHotTarget, output2, fromLogits);
  });
}
function sigmoidCrossEntropyWithLogits(labels, logits) {
  if (!arraysEqual(labels.shape, logits.shape)) {
    throw new ValueError(`logits and labels must have the same shape, but got shapes ${JSON.stringify(labels.shape)} and ${JSON.stringify(logits.shape)}`);
  }
  return tidy(() => {
    const reluLogits = relu$2(logits);
    const negAbsLogits = neg$2(abs$2(logits));
    return add$1(sub$2(reluLogits, mul(logits, labels)), log1p$2(exp$2(negAbsLogits)));
  });
}
function binaryCrossentropy$1(yTrue, yPred) {
  return tidy(() => {
    let y2;
    y2 = clipByValue$2(yPred, epsilon$1(), 1 - epsilon$1());
    y2 = log$7(div$1(y2, sub$2(1, y2)));
    return mean$2(sigmoidCrossEntropyWithLogits(yTrue, y2), -1);
  });
}
function kullbackLeiblerDivergence(yTrue, yPred) {
  return tidy(() => {
    const clippedTrue = clipByValue$2(yTrue, epsilon$1(), 1);
    const clippedPred = clipByValue$2(yPred, epsilon$1(), 1);
    return sum$3(mul(yTrue, log$7(div$1(clippedTrue, clippedPred))), -1);
  });
}
function poisson(yTrue, yPred) {
  return tidy(() => {
    const logPred = log$7(add$1(epsilon$1(), yPred));
    return mean$2(sub$2(yPred, mul(yTrue, logPred)), -1);
  });
}
function cosineProximity(yTrue, yPred) {
  return tidy(() => {
    const trueNormalized = l2Normalize(yTrue, -1);
    const predNormalized = l2Normalize(yPred, -1);
    const trueXPred = mul(trueNormalized, predNormalized);
    return neg$2(sum$3(trueXPred, -1));
  });
}
const lossesMap = {
  meanSquaredError,
  meanAbsoluteError,
  meanAbsolutePercentageError,
  meanSquaredLogarithmicError,
  squaredHinge,
  hinge,
  categoricalHinge,
  logcosh,
  categoricalCrossentropy: categoricalCrossentropy$1,
  sparseCategoricalCrossentropy: sparseCategoricalCrossentropy$1,
  binaryCrossentropy: binaryCrossentropy$1,
  kullbackLeiblerDivergence,
  poisson,
  cosineProximity
};
function get$2(identifierOrFn) {
  if (typeof identifierOrFn === "string") {
    if (identifierOrFn in lossesMap) {
      return lossesMap[identifierOrFn];
    }
    let errMsg = `Unknown loss ${identifierOrFn}`;
    if (identifierOrFn.toLowerCase().includes("softmaxcrossentropy")) {
      errMsg = `Unknown loss ${identifierOrFn}. Use "categoricalCrossentropy" as the string name for tf.losses.softmaxCrossEntropy`;
    }
    throw new ValueError(errMsg);
  } else {
    return identifierOrFn;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function binaryAccuracy(yTrue, yPred) {
  return tidy(() => {
    const threshold2 = mul(0.5, onesLike$3(yPred));
    const yPredThresholded = cast$3(greater$2(yPred, threshold2), yTrue.dtype);
    return mean$2(equal$2(yTrue, yPredThresholded), -1);
  });
}
function categoricalAccuracy(yTrue, yPred) {
  return tidy(() => cast$3(equal$2(argMax$2(yTrue, -1), argMax$2(yPred, -1)), "float32"));
}
function truePositives(yTrue, yPred) {
  return tidy(() => {
    return cast$4(sum$3(logicalAnd$2(equal$2(yTrue, 1), equal$2(yPred, 1))), "float32");
  });
}
function falsePositives(yTrue, yPred) {
  return tidy(() => {
    return cast$4(sum$3(logicalAnd$2(equal$2(yTrue, 0), equal$2(yPred, 1))), "float32");
  });
}
function precision(yTrue, yPred) {
  return tidy(() => {
    const tp = truePositives(yTrue, yPred);
    const fp2 = falsePositives(yTrue, yPred);
    const denominator = add$1(tp, fp2);
    return cast$4(where(greater$2(denominator, 0), div$1(tp, denominator), 0), "float32");
  });
}
function binaryCrossentropy(yTrue, yPred) {
  return binaryCrossentropy$1(yTrue, yPred);
}
function sparseCategoricalAccuracy(yTrue, yPred) {
  if (yTrue.rank === yPred.rank) {
    yTrue = squeeze(yTrue, [yTrue.rank - 1]);
  }
  yPred = argMax$2(yPred, -1);
  if (yPred.dtype !== yTrue.dtype) {
    yPred = cast$4(yPred, yTrue.dtype);
  }
  return cast$4(equal$2(yTrue, yPred), "float32");
}
const mse = meanSquaredError;
const MSE = meanSquaredError;
const mae = meanAbsoluteError;
const MAE = meanAbsoluteError;
const mape = meanAbsolutePercentageError;
const MAPE = meanAbsolutePercentageError;
const categoricalCrossentropy = categoricalCrossentropy$1;
const cosine = cosineProximity;
const sparseCategoricalCrossentropy = sparseCategoricalCrossentropy$1;
const metricsMap = {
  binaryAccuracy,
  categoricalAccuracy,
  precision,
  categoricalCrossentropy,
  sparseCategoricalCrossentropy,
  mse,
  MSE,
  mae,
  MAE,
  mape,
  MAPE,
  cosine
};
function get$1(identifier) {
  if (typeof identifier === "string" && identifier in metricsMap) {
    return metricsMap[identifier];
  } else if (typeof identifier !== "string" && identifier != null) {
    return identifier;
  } else {
    throw new ValueError(`Unknown metric ${identifier}`);
  }
}
function getLossOrMetricName(fn) {
  assert(fn !== null, `Unknown LossOrMetricFn ${fn}`);
  if (typeof fn === "string") {
    return fn;
  } else {
    let fnName;
    for (const key of Object.keys(lossesMap)) {
      if (lossesMap[key] === fn) {
        fnName = key;
        break;
      }
    }
    if (fnName !== void 0) {
      return fnName;
    }
    for (const key of Object.keys(metricsMap)) {
      if (metricsMap[key] === fn) {
        fnName = key;
        break;
      }
    }
    if (fnName !== void 0) {
      return fnName;
    }
    return fn.name;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function getOptimizer(identifier) {
  const optimizerMap = {
    "Adagrad": () => train.adagrad(0.01),
    "Adadelta": () => train.adadelta(1, 0.95, epsilon$1()),
    "Adam": () => train.adam(1e-3, 0.9, 0.999, epsilon$1()),
    "Adamax": () => train.adamax(2e-3, 0.9, 0.999, epsilon$1(), 0),
    "RMSProp": () => train.rmsprop(1e-3, 0.9, 0, epsilon$1()),
    "SGD": () => train.sgd(0.01)
  };
  optimizerMap["adagrad"] = optimizerMap["Adagrad"];
  optimizerMap["adadelta"] = optimizerMap["Adadelta"];
  optimizerMap["adam"] = optimizerMap["Adam"];
  optimizerMap["adamax"] = optimizerMap["Adamax"];
  optimizerMap["rmsprop"] = optimizerMap["RMSProp"];
  optimizerMap["sgd"] = optimizerMap["SGD"];
  if (identifier in optimizerMap) {
    return optimizerMap[identifier]();
  }
  throw new ValueError(`Unknown Optimizer ${identifier}`);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
const MAX_USER_DEFINED_METADATA_SERIALIZED_LENGTH = 1 * 1024 * 1024;
function checkUserDefinedMetadata(userDefinedMetadata, modelName, checkSize = false) {
  if (userDefinedMetadata == null || typeof userDefinedMetadata !== "object" || Object.getPrototypeOf(userDefinedMetadata) !== Object.prototype || !plainObjectCheck(userDefinedMetadata)) {
    throw new Error("User-defined metadata is expected to be a JSON object, but is not.");
  }
  if (checkSize) {
    const out = JSON.stringify(userDefinedMetadata);
    if (out.length > MAX_USER_DEFINED_METADATA_SERIALIZED_LENGTH) {
      console.warn(`User-defined metadata of model "${modelName}" is too large in size (length=${out.length} when serialized). It is not recommended to store such large objects in user-defined metadata. Please make sure its serialized length is <= ${MAX_USER_DEFINED_METADATA_SERIALIZED_LENGTH}.`);
    }
  }
}
function plainObjectCheck(x2) {
  if (x2 === null) {
    return true;
  } else if (typeof x2 === "object") {
    if (Object.getPrototypeOf(x2) === Object.prototype) {
      const keys = Object.keys(x2);
      for (const key of keys) {
        if (typeof key !== "string") {
          return false;
        }
        if (!plainObjectCheck(x2[key])) {
          return false;
        }
      }
      return true;
    } else {
      if (Array.isArray(x2)) {
        for (const item of x2) {
          if (!plainObjectCheck(item)) {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    }
  } else {
    const xType = typeof x2;
    return xType === "string" || xType === "number" || xType === "boolean";
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function printSummary(model2, lineLength, positions, printFn = console.log) {
  const sequentialLike = isModelSequentialLike(model2);
  const toDisplay = ["Layer (type)", "Input Shape", "Output shape", "Param #"];
  if (sequentialLike) {
    lineLength = lineLength || 90;
    positions = positions || [0.32, 0.61, 0.89, 1];
  } else {
    lineLength = lineLength || 115;
    positions = positions || [0.24, 0.48, 0.7, 0.8, 1];
  }
  if (positions[positions.length - 1] <= 1) {
    positions = positions.map((p2) => Math.floor(lineLength * p2));
  }
  let relevantNodes;
  if (!sequentialLike) {
    toDisplay.push("Receives inputs");
    relevantNodes = [];
    for (const depth in model2.nodesByDepth) {
      relevantNodes.push(...model2.nodesByDepth[depth]);
    }
  }
  printFn("_".repeat(lineLength));
  printRow(toDisplay, positions, printFn);
  printFn("=".repeat(lineLength));
  const layers = model2.layers;
  for (let i2 = 0; i2 < layers.length; ++i2) {
    if (sequentialLike) {
      printLayerSummary(layers[i2], positions, printFn);
    } else {
      printLayerSummaryWithConnections(layers[i2], positions, relevantNodes, printFn);
    }
    printFn((i2 === layers.length - 1 ? "=" : "_").repeat(lineLength));
  }
  model2.checkTrainableWeightsConsistency();
  const trainableCount = countTrainableParams(model2);
  const nonTrainableCount = countParamsInWeights(model2.nonTrainableWeights);
  printFn(`Total params: ${trainableCount + nonTrainableCount}`);
  printFn(`Trainable params: ${trainableCount}`);
  printFn(`Non-trainable params: ${nonTrainableCount}`);
  printFn("_".repeat(lineLength));
}
function countTrainableParams(model2) {
  let trainableCount;
  if (model2.collectedTrainableWeights != null) {
    trainableCount = countParamsInWeights(model2.collectedTrainableWeights);
  } else {
    trainableCount = countParamsInWeights(model2.trainableWeights);
  }
  return trainableCount;
}
function isModelSequentialLike(model2) {
  let sequentialLike = true;
  const nodesByDepth = [];
  const nodes = [];
  for (const depth in model2.nodesByDepth) {
    nodesByDepth.push(model2.nodesByDepth[depth]);
  }
  for (const depthNodes of nodesByDepth) {
    if (depthNodes.length > 1 || depthNodes.length === 1 && depthNodes[0].inboundLayers.length > 1) {
      sequentialLike = false;
      break;
    }
    nodes.push(...depthNodes);
  }
  if (sequentialLike) {
    for (const layer of model2.layers) {
      let flag = false;
      for (const node of layer.inboundNodes) {
        if (nodes.indexOf(node) !== -1) {
          if (flag) {
            sequentialLike = false;
            break;
          } else {
            flag = true;
          }
        }
      }
      if (!sequentialLike) {
        break;
      }
    }
  }
  return sequentialLike;
}
function printRow(fields, positions, printFn = console.log) {
  let line = "";
  for (let i2 = 0; i2 < fields.length; ++i2) {
    if (i2 > 0) {
      line = line.slice(0, line.length - 1) + " ";
    }
    line += fields[i2];
    line = line.slice(0, positions[i2]);
    line += " ".repeat(positions[i2] - line.length);
  }
  printFn(line);
}
function printLayerSummary(layer, positions, printFn) {
  let outputShape;
  let inputShape;
  try {
    inputShape = layer.inboundNodes.map((x2) => JSON.stringify(x2.inputShapes)).join(",");
  } catch (err) {
    inputShape = "multiple";
  }
  try {
    outputShape = JSON.stringify(layer.outputShape);
  } catch (err) {
    outputShape = "multiple";
  }
  const name = layer.name;
  const className = layer.getClassName();
  const fields = [
    `${name} (${className})`,
    inputShape,
    outputShape,
    layer.countParams().toString()
  ];
  printRow(fields, positions, printFn);
}
function printLayerSummaryWithConnections(layer, positions, relevantNodes, printFn) {
  let outputShape;
  let inputShape;
  try {
    inputShape = layer.inboundNodes.map((x2) => JSON.stringify(x2.inputShapes)).join(",");
  } catch (err) {
    inputShape = "multiple";
  }
  try {
    outputShape = JSON.stringify(layer.outputShape);
  } catch (err) {
    outputShape = "multiple";
  }
  const connections = [];
  for (const node of layer.inboundNodes) {
    if (relevantNodes != null && relevantNodes.length > 0 && relevantNodes.indexOf(node) === -1) {
      continue;
    }
    for (let i2 = 0; i2 < node.inboundLayers.length; ++i2) {
      const inboundLayer = node.inboundLayers[i2].name;
      const inboundLayerIndex = node.nodeIndices[i2];
      const inboundTensorIndex = node.tensorIndices[i2];
      connections.push(`${inboundLayer}[${inboundLayerIndex}][${inboundTensorIndex}]`);
    }
  }
  const name = layer.name;
  const className = layer.getClassName();
  const firstConnection = connections.length === 0 ? "" : connections[0];
  const fields = [
    `${name} (${className})`,
    inputShape,
    outputShape,
    layer.countParams().toString(),
    firstConnection
  ];
  printRow(fields, positions, printFn);
  for (let i2 = 1; i2 < connections.length; ++i2) {
    printRow(["", "", "", "", connections[i2]], positions, printFn);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function isArrayItemInputOrOutputName(key, index2, value) {
  return (key === "inboundNodes" || key === "outputLayers" || key === "inputLayers") && index2 === 0 && typeof value === "string";
}
function convertPythonicToTs(pythonicConfig, key) {
  if (pythonicConfig === null) {
    return null;
  } else if (typeof pythonicConfig === "string") {
    return toCamelCase(pythonicConfig);
  } else if (typeof pythonicConfig === "number" || typeof pythonicConfig === "boolean") {
    return pythonicConfig;
  } else if (pythonicConfig instanceof Array) {
    const tsArray = [];
    const arrayLength = pythonicConfig.length;
    for (let i2 = 0; i2 < arrayLength; ++i2) {
      const item = pythonicConfig[i2];
      if (isArrayItemInputOrOutputName(key, i2, item)) {
        tsArray.push(item);
      } else {
        tsArray.push(convertPythonicToTs(item, key));
      }
    }
    return tsArray;
  } else {
    const tsDict = {};
    for (const pythonicKey of Object.keys(pythonicConfig)) {
      const pythonicValue = pythonicConfig[pythonicKey];
      if (pythonicKey === "name" && typeof pythonicValue === "string") {
        tsDict[pythonicKey] = pythonicValue;
      } else {
        const tsKey = toCamelCase(pythonicKey);
        tsDict[tsKey] = convertPythonicToTs(pythonicValue, tsKey);
      }
    }
    return tsDict;
  }
}
function convertTsToPythonic(tsConfig, key) {
  if (tsConfig === null || tsConfig === void 0) {
    return null;
  } else if (typeof tsConfig === "string") {
    return toSnakeCase(tsConfig);
  } else if (typeof tsConfig === "number" || typeof tsConfig === "boolean") {
    return tsConfig;
  } else if (tsConfig instanceof Array) {
    const pyArray = [];
    const arrayLength = tsConfig.length;
    for (let i2 = 0; i2 < arrayLength; ++i2) {
      const item = tsConfig[i2];
      if (isArrayItemInputOrOutputName(key, i2, item)) {
        pyArray.push(item);
      } else {
        pyArray.push(convertTsToPythonic(item, key));
      }
    }
    return pyArray;
  } else {
    const pyDict = {};
    for (const tsKey of Object.keys(tsConfig)) {
      const tsValue = tsConfig[tsKey];
      const pyKey = toSnakeCase(tsKey);
      if ((tsKey === "name" || tsKey === "className") && typeof tsValue === "string") {
        pyDict[pyKey] = tsValue;
      } else {
        pyDict[pyKey] = convertTsToPythonic(tsValue, tsKey);
      }
    }
    return pyDict;
  }
}
/** @license See the LICENSE file. */
const version$5 = "3.16.0";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Container$9 extends Layer {
  constructor(args) {
    super({});
    this.containerNodes = /* @__PURE__ */ new Set();
    this.name = args.name;
    if (this.name == null) {
      const prefix2 = this.getClassName().toLowerCase();
      this.name = getUid(prefix2);
    }
    this.supportsMasking = false;
    this.trainable_ = true;
    if (Array.isArray(args.inputs)) {
      this.inputs = args.inputs.slice();
    } else {
      this.inputs = [args.inputs];
    }
    if (Array.isArray(args.outputs)) {
      this.outputs = args.outputs.slice();
    } else {
      this.outputs = [args.outputs];
    }
    if (unique$2(this.inputs).length !== this.inputs.length) {
      throw new ValueError(`The list of inputs passed to the model is redundant. All inputs should only appear once. Found: ${this.inputs.map((x2) => x2.name)}`);
    }
    if (unique$2(this.outputs).length !== this.outputs.length) {
      console.warn(`The list of outputs passed to the model is redundant. All outputs should only appear once. Found: ${this.outputs.map((x2) => x2.name)}`);
    }
    this.inputLayers = [];
    this.inputLayersNodeIndices = [];
    this.inputLayersTensorIndices = [];
    this.outputLayers = [];
    this.outputLayersNodeIndices = [];
    this.outputLayersTensorIndices = [];
    this.layers = [];
    this.internalContainerRefs = [];
    for (const x2 of this.outputs) {
      const layer = x2.sourceLayer;
      const nodeIndex = x2.nodeIndex;
      const tensorIndex = x2.tensorIndex;
      this.outputLayers.push(layer);
      this.outputLayersNodeIndices.push(nodeIndex);
      this.outputLayersTensorIndices.push(tensorIndex);
    }
    for (const x2 of this.inputs) {
      const layer = x2.sourceLayer;
      const nodeIndex = x2.nodeIndex;
      const tensorIndex = x2.tensorIndex;
      assert(nodeIndex === 0, "input layer has >1 nodes");
      assert(tensorIndex === 0, "input layer has >1 tensors");
      this.inputLayers.push(layer);
      this.inputLayersNodeIndices.push(nodeIndex);
      this.inputLayersTensorIndices.push(tensorIndex);
    }
    this.inputNames = [];
    this.outputNames = [];
    this.feedInputShapes = [];
    this.feedInputNames = [];
    this.feedOutputNames = [];
    for (let i2 = 0; i2 < this.inputLayers.length; i2++) {
      const layer = this.inputLayers[i2];
      if (!(layer instanceof InputLayer)) {
        throw new TypeError(`Input layers to a LayersModel must be InputLayer objects. Received inputs: ${args.inputs}. Input ${i2} (0-based) originates from layer type ${layer.getClassName()}.`);
      }
      this.inputNames.push(layer.name);
      this.feedInputShapes.push(layer.batchInputShape);
      this.feedInputNames.push(layer.name);
    }
    for (const layer of this.outputLayers) {
      this.outputNames.push(layer.name);
    }
    this.internalInputShapes = this.inputs.map((x2) => x2.shape);
    this.internalOutputShapes = this.outputs.map((x2) => x2.shape);
    const nodesDepths = {};
    const nodeIDToNode = {};
    const layersDepths = {};
    const layerIDToLayer = {};
    const layerIndices = {};
    const nodesInDecreasingDepth = [];
    const buildMapOfGraph = (tensor2, finishedNodes2, nodesInProgress2, layer, nodeIndex, tensorIndex) => {
      if (layer == null || nodeIndex == null || tensorIndex == null) {
        layer = tensor2.sourceLayer;
        nodeIndex = tensor2.nodeIndex;
        tensorIndex = tensor2.tensorIndex;
      }
      const node = layer.inboundNodes[nodeIndex];
      if (nodesInProgress2.indexOf(node) !== -1) {
        throw new RuntimeError(`The tensor ${tensor2.name} at layer "${layer.name}" is part of a cycle.`);
      }
      if (finishedNodes2.indexOf(node) !== -1) {
        return;
      }
      this.containerNodes.add(Container$9.nodeKey(layer, nodeIndex));
      if (!(layer.id in layerIndices)) {
        layerIndices[layer.id] = Object.keys(layerIndices).length;
      }
      if (nodesInProgress2.indexOf(node) === -1) {
        nodesInProgress2.push(node);
      }
      const numInboundLayers = node.inboundLayers.length;
      for (let i2 = 0; i2 < numInboundLayers; i2++) {
        const x2 = node.inputTensors[i2];
        const layer2 = node.inboundLayers[i2];
        const nodeIndex2 = node.nodeIndices[i2];
        const tensorIndex2 = node.tensorIndices[i2];
        buildMapOfGraph(x2, finishedNodes2, nodesInProgress2, layer2, nodeIndex2, tensorIndex2);
      }
      finishedNodes2.push(node);
      while (nodesInProgress2.indexOf(node) >= 0) {
        nodesInProgress2.splice(nodesInProgress2.indexOf(node), 1);
      }
      nodesInDecreasingDepth.push(node);
    };
    const finishedNodes = [];
    const nodesInProgress = [];
    for (const x2 of this.outputs) {
      buildMapOfGraph(x2, finishedNodes, nodesInProgress);
    }
    const reversedNodesInDecreasingDepth = nodesInDecreasingDepth.slice().reverse();
    for (const node of reversedNodesInDecreasingDepth) {
      nodeIDToNode[node.id] = node;
      if (!(node.id in nodesDepths)) {
        nodesDepths[node.id] = 0;
      }
      let depth = nodesDepths[node.id];
      const previousDepth = layersDepths[node.outboundLayer.id] == null ? 0 : layersDepths[node.outboundLayer.id];
      depth = Math.max(depth, previousDepth);
      layersDepths[node.outboundLayer.id] = depth;
      layerIDToLayer[node.outboundLayer.id] = node.outboundLayer;
      nodesDepths[node.id] = depth;
      for (let i2 = 0; i2 < node.inboundLayers.length; i2++) {
        const inboundLayer = node.inboundLayers[i2];
        const nodeIndex = node.nodeIndices[i2];
        const inboundNode = inboundLayer.inboundNodes[nodeIndex];
        const previousDepth2 = nodesDepths[inboundNode.id] == null ? 0 : nodesDepths[inboundNode.id];
        nodesDepths[inboundNode.id] = Math.max(depth + 1, previousDepth2);
        nodeIDToNode[inboundNode.id] = inboundNode;
      }
    }
    const nodesByDepth = {};
    for (const nodeID in nodesDepths) {
      const depth = nodesDepths[nodeID];
      if (!(depth in nodesByDepth)) {
        nodesByDepth[depth] = [];
      }
      nodesByDepth[depth].push(nodeIDToNode[nodeID]);
    }
    const layersByDepth = {};
    for (const layerID in layersDepths) {
      const depth = layersDepths[layerID];
      if (!(depth in layersByDepth)) {
        layersByDepth[depth] = [];
      }
      layersByDepth[depth].push(layerIDToLayer[layerID]);
    }
    let depthKeys = Object.keys(layersByDepth).map((x2) => parseInt(x2, 10)).sort(reverseNumberCompare);
    this.layers = [];
    for (const depth of depthKeys) {
      const layersForDepth = layersByDepth[depth];
      layersForDepth.sort((a6, b2) => {
        const aIndex = layerIndices[a6.id];
        const bIndex = layerIndices[b2.id];
        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      });
      for (const layer of layersForDepth) {
        if (layer instanceof Container$9) {
          this.internalContainerRefs.push(layer);
        }
        this.layers.push(layer);
      }
    }
    this.layersByDepth = layersByDepth;
    depthKeys = Object.keys(nodesByDepth).map((x2) => parseInt(x2, 10)).sort(reverseNumberCompare);
    const computableTensors = this.inputs.slice();
    const layersWithCompleteInput = [];
    for (const depth of depthKeys) {
      for (const node of nodesByDepth[depth]) {
        const layer = node.outboundLayer;
        if (layer != null) {
          for (const x2 of node.inputTensors) {
            if (computableTensors.indexOf(x2) === -1) {
              throw new RuntimeError(`Graph disconnected: cannot obtain value for tensor ${x2} at layer "${layer.name}". The following previous layers were accessed without issue: ${layersWithCompleteInput}`);
            }
          }
          for (const x2 of node.outputTensors) {
            computableTensors.push(x2);
          }
          layersWithCompleteInput.push(layer.name);
        }
      }
    }
    this.nodesByDepth = nodesByDepth;
    const allNames = this.layers.map((x2) => x2.name);
    for (const name of allNames) {
      const numOccurrences = allNames.filter((x2) => x2 === name).length;
      if (numOccurrences !== 1) {
        throw new RuntimeError(`The name "${name}" is used ${numOccurrences} times in the model. All layer names should be unique. Layer names: ` + JSON.stringify(allNames));
      }
    }
    this.outboundNodes = [];
    this.inboundNodes = [];
    new Node$1({
      outboundLayer: this,
      inboundLayers: [],
      nodeIndices: [],
      tensorIndices: [],
      inputTensors: this.inputs,
      outputTensors: this.outputs,
      inputMasks: this.inputs.map((x2) => null),
      outputMasks: this.outputs.map((x2) => null),
      inputShapes: this.inputs.map((x2) => x2.shape),
      outputShapes: this.outputs.map((x2) => x2.shape)
    });
    this.built = true;
    this._refCount = 1;
  }
  assertNotDisposed() {
    if (this._refCount === 0) {
      throw new Error(`Container '${this.name}' is already disposed.`);
    }
  }
  dispose() {
    this.assertNotDisposed();
    const result2 = { refCountAfterDispose: null, numDisposedVariables: 0 };
    if (--this._refCount === 0) {
      for (const layer of this.layers) {
        result2.numDisposedVariables += layer.dispose().numDisposedVariables;
      }
      for (const container of this.internalContainerRefs) {
        result2.numDisposedVariables += container.dispose().numDisposedVariables;
      }
    }
    result2.refCountAfterDispose = this._refCount;
    return result2;
  }
  get trainable() {
    return this.trainable_;
  }
  set trainable(trainable) {
    this.layers.forEach((layer) => {
      layer._trainableWeights.forEach((w2) => w2.trainable = trainable);
    });
    this.trainable_ = trainable;
  }
  get trainableWeights() {
    if (this._trainableWeights.length > 0) {
      throw new ValueError("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
    }
    if (!this.trainable) {
      return [];
    }
    let weights = [];
    for (const layer of this.layers) {
      weights = weights.concat(layer.trainableWeights);
    }
    return weights;
  }
  get nonTrainableWeights() {
    const weights = [];
    for (const layer of this.layers) {
      weights.push(...layer.nonTrainableWeights);
    }
    if (!this.trainable) {
      const trainableWeights = [];
      for (const layer of this.layers) {
        trainableWeights.push(...layer.trainableWeights);
      }
      return trainableWeights.concat(weights);
    }
    return weights;
  }
  get weights() {
    return this.trainableWeights.concat(this.nonTrainableWeights);
  }
  loadWeights(weights, strict = true) {
    const nameToWeight = {};
    let totalWeightsCount = 0;
    for (const layer of this.layers) {
      for (const weight of layer.weights) {
        if (nameToWeight[weight.originalName] != null) {
          throw new ValueError(`Duplicate weight name: ${weight.originalName}`);
        }
        nameToWeight[weight.originalName] = weight;
        totalWeightsCount++;
      }
    }
    const weightValueTuples = [];
    for (const name in weights) {
      let validatedName = name;
      if (nameToWeight[name] == null) {
        const tokens = name.split("/");
        const shortenNameArray = tokens.slice(0, -2).concat([tokens[tokens.length - 1]]);
        validatedName = shortenNameArray.join("/");
      }
      if (nameToWeight[validatedName] != null) {
        weightValueTuples.push([nameToWeight[validatedName], weights[name]]);
      } else if (strict) {
        throw new ValueError(`Provided weight data has no target variable: ${name}`);
      }
      delete nameToWeight[validatedName];
    }
    if (strict) {
      const unsetNames = [];
      for (const name in nameToWeight) {
        unsetNames.push(name);
      }
      if (unsetNames.length > 0) {
        throw new ValueError(`${unsetNames.length} of ${totalWeightsCount} weights are not set: ${unsetNames}`);
      }
    }
    batchSetValue(weightValueTuples);
  }
  updatedConfig() {
    const theConfig = this.getConfig();
    const modelConfig = {};
    modelConfig["className"] = this.getClassName();
    modelConfig["config"] = theConfig;
    modelConfig["kerasVersion"] = `tfjs-layers ${version$5}`;
    modelConfig["backend"] = "TensorFlow.js";
    return modelConfig;
  }
  toJSON(unused, returnString = true) {
    const modelConfig = convertTsToPythonic(this.updatedConfig());
    return returnString ? JSON.stringify(modelConfig) : modelConfig;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = toList(inputs);
      const feedDict = new FeedDict();
      for (let i2 = 0; i2 < this.inputs.length; ++i2) {
        feedDict.add(this.inputs[i2], inputs[i2]);
      }
      return execute(this.outputs, feedDict, kwargs);
    });
  }
  computeMask(inputs, mask) {
    return tidy(() => {
      inputs = toList(inputs);
      let masks;
      if (mask == null) {
        masks = pyListRepeat(null, inputs.length);
      } else {
        masks = toList(mask);
      }
      return this.runInternalGraph(inputs, masks)[1];
    });
  }
  computeOutputShape(inputShape) {
    const inputShapes = normalizeShapeList(inputShape);
    if (inputShapes.length !== this.inputLayers.length) {
      throw new ValueError(`Invalid inputShape argument ${inputShape}: model has ${this.inputLayers.length} tensor inputs.`);
    }
    const layersToOutputShapes = {};
    for (let i2 = 0; i2 < inputShapes.length; i2++) {
      const layer = this.inputLayers[i2];
      const inputShape2 = inputShapes[i2];
      const shapeKey = layer.name + "_0_0";
      layersToOutputShapes[shapeKey] = inputShape2;
    }
    const depthKeys = Object.keys(this.nodesByDepth).map((x2) => parseInt(x2, 10)).sort(reverseNumberCompare);
    if (depthKeys.length > 1) {
      for (const depth of depthKeys) {
        const nodes = this.nodesByDepth[depth];
        for (const node of nodes) {
          const layer = node.outboundLayer;
          if (this.inputLayers.map((x2) => x2.id).indexOf(layer.id) !== -1) {
            continue;
          }
          const inputShapes2 = [];
          for (let j2 = 0; j2 < node.inboundLayers.length; j2++) {
            const inboundLayer = node.inboundLayers[j2];
            const nodeIndex2 = node.nodeIndices[j2];
            const tensorIndex = node.tensorIndices[j2];
            const shapeKey = `${inboundLayer.name}_${nodeIndex2}_${tensorIndex}`;
            const inputShape2 = layersToOutputShapes[shapeKey];
            inputShapes2.push(inputShape2);
          }
          const outputShape = layer.computeOutputShape(singletonOrArray(inputShapes2));
          const outputShapes2 = normalizeShapeList(outputShape);
          const nodeIndex = layer.inboundNodes.indexOf(node);
          for (let j2 = 0; j2 < outputShapes2.length; j2++) {
            const shapeKey = `${layer.name}_${nodeIndex}_${j2}`;
            layersToOutputShapes[shapeKey] = outputShapes2[j2];
          }
        }
      }
    }
    const outputShapes = [];
    const outputShapeKeys = [];
    for (let i2 = 0; i2 < this.outputLayers.length; i2++) {
      const layer = this.outputLayers[i2];
      const nodeIndex = this.outputLayersNodeIndices[i2];
      const tensorIndex = this.outputLayersTensorIndices[i2];
      const shapeKey = `${layer.name}_${nodeIndex}_${tensorIndex}`;
      outputShapeKeys.push(shapeKey);
    }
    for (let i2 = 0; i2 < outputShapeKeys.length; i2++) {
      const key = outputShapeKeys[i2];
      assert(key in layersToOutputShapes);
      outputShapes.push(layersToOutputShapes[key]);
    }
    return singletonOrArray(outputShapes);
  }
  runInternalGraph(inputs, masks) {
    if (masks == null) {
      masks = pyListRepeat(null, inputs.length);
    }
    const tensorMap = {};
    for (let i2 = 0; i2 < this.inputs.length; ++i2) {
      const x2 = this.inputs[i2];
      const y2 = inputs[i2];
      const mask = masks[i2];
      tensorMap[x2.id] = [y2, mask];
    }
    const depthKeys = Object.keys(this.nodesByDepth).map((x2) => parseInt(x2, 10)).sort(reverseNumberCompare);
    for (const depth of depthKeys) {
      const nodes = this.nodesByDepth[depth];
      for (const node of nodes) {
        const layer = node.outboundLayer;
        const referenceInputTensors = node.inputTensors;
        const referenceOutputTensors = node.outputTensors;
        const computedData = new Array();
        for (const x2 of referenceInputTensors) {
          if (x2.id in tensorMap) {
            computedData.push(tensorMap[x2.id]);
          }
        }
        if (computedData.length === referenceInputTensors.length) {
          let kwargs = {};
          let computedTensors;
          let computedMasks;
          let outputTensors2;
          let outputMasks2;
          if (node.callArgs != null) {
            kwargs = node.callArgs;
          }
          if (computedData.length === 1) {
            const [computedTensor, computedMask] = computedData[0];
            if (kwargs["mask"] == null) {
              kwargs["mask"] = computedMask;
            }
            outputTensors2 = toList(layer.call(computedTensor, kwargs));
            outputMasks2 = toList(layer.computeMask(computedTensor, computedMask));
            computedTensors = [computedTensor];
            computedMasks = [computedMask];
          } else {
            computedTensors = computedData.map((x2) => x2[0]);
            computedMasks = computedData.map((x2) => x2[1]);
            if (kwargs["mask"] == null) {
              kwargs["mask"] = computedMasks;
            }
            outputTensors2 = toList(layer.call(computedTensors, kwargs));
            outputMasks2 = toList(layer.computeMask(computedTensors, computedMasks));
          }
          if (layer.activityRegularizer) {
            throw new NotImplementedError("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
          }
          for (let i2 = 0; i2 < referenceOutputTensors.length; ++i2) {
            const x2 = referenceOutputTensors[i2];
            const y2 = outputTensors2[i2];
            const mask = outputMasks2[i2];
            tensorMap[x2.id] = [y2, mask];
          }
        }
      }
    }
    const outputTensors = [];
    const outputMasks = [];
    const outputShapes = [];
    for (const x2 of this.outputs) {
      assert(x2.id in tensorMap, `Could not compute output ${x2.name} : ${x2.id}`);
      const [tensor2, mask] = tensorMap[x2.id];
      outputShapes.push(tensor2.shape);
      outputTensors.push(tensor2);
      outputMasks.push(mask);
    }
    return [outputTensors, outputMasks, outputShapes];
  }
  buildNodeConversionMap(layers) {
    const nodeConversionMap = {};
    let keptNodes;
    for (const layer of this.layers) {
      keptNodes = layer instanceof Container$9 ? 1 : 0;
      for (let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++) {
        const nodeKey = Container$9.nodeKey(layer, originalNodeIndex);
        if (this.containerNodes.has(nodeKey)) {
          nodeConversionMap[nodeKey] = keptNodes;
          keptNodes += 1;
        }
      }
    }
    return nodeConversionMap;
  }
  getLayer(name, index2) {
    if (index2 != null) {
      if (this.layers.length <= index2) {
        throw new ValueError(`Was asked to retrieve layer at index ${index2}, but model only has ${this.layers.length} layer(s).`);
      } else {
        return this.layers[index2];
      }
    } else {
      if (name == null) {
        throw new ValueError("Provide either a layer name or layer index");
      }
    }
    for (const layer of this.layers) {
      if (layer.name === name) {
        return layer;
      }
    }
    throw new ValueError(`No such layer: ${name}`);
  }
  calculateLosses() {
    return tidy(() => {
      const losses = [];
      for (const layer of this.layers) {
        for (let nodeIndex = 0; nodeIndex < layer.inboundNodes.length; ++nodeIndex) {
          const nodeKey = Container$9.nodeKey(layer, nodeIndex);
          if (this.containerNodes.has(nodeKey)) {
            losses.push(...layer.calculateLosses());
          }
        }
      }
      return losses;
    });
  }
  getConfig() {
    const config2 = { name: this.name };
    const nodeConversionMap = this.buildNodeConversionMap(this.layers);
    const layerConfigs = [];
    for (const layer of this.layers) {
      const layerClassName = layer.getClassName();
      const layerConfig = layer.getConfig();
      const filteredInboundNodes = [];
      for (let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++) {
        const node = layer.inboundNodes[originalNodeIndex];
        const nodeKey = Container$9.nodeKey(layer, originalNodeIndex);
        let kwargs = {};
        if (this.containerNodes.has(nodeKey)) {
          if (node.callArgs) {
            try {
              JSON.stringify(node.callArgs);
              kwargs = node.callArgs;
            } catch (err) {
              console.warn(`Layer ${layer.name} was passed non-serializable keyword arguments: ${node.callArgs}. They will not be included in the serialized model (and thus will be missing at deserialization time).`);
              kwargs = {};
            }
          }
          if (node.inboundLayers.length > 0) {
            const nodeData = [];
            for (let i2 = 0; i2 < node.inboundLayers.length; i2++) {
              const inboundLayer = node.inboundLayers[i2];
              const nodeIndex = node.nodeIndices[i2];
              const tensorIndex = node.tensorIndices[i2];
              const nodeKey2 = Container$9.nodeKey(inboundLayer, nodeIndex);
              let newNodeIndex = nodeConversionMap[nodeKey2];
              if (newNodeIndex == null) {
                newNodeIndex = 0;
              }
              nodeData.push([inboundLayer.name, newNodeIndex, tensorIndex, kwargs]);
            }
            filteredInboundNodes.push(nodeData);
          }
        }
      }
      const dict = {};
      dict["name"] = layer.name;
      dict["className"] = layerClassName;
      dict["config"] = layerConfig;
      dict["inboundNodes"] = filteredInboundNodes;
      layerConfigs.push(dict);
    }
    config2["layers"] = layerConfigs;
    const modelInputs = [];
    for (let i2 = 0; i2 < this.inputLayers.length; i2++) {
      const layer = this.inputLayers[i2];
      const nodeIndex = this.inputLayersNodeIndices[i2];
      const nodeKey = Container$9.nodeKey(layer, nodeIndex);
      if (!this.containerNodes.has(nodeKey)) {
        continue;
      }
      let newNodeIndex = nodeConversionMap[nodeKey];
      if (newNodeIndex === null || newNodeIndex === void 0) {
        newNodeIndex = 0;
      }
      const tensorIndex = this.inputLayersTensorIndices[i2];
      modelInputs.push([layer.name, newNodeIndex, tensorIndex]);
    }
    config2["inputLayers"] = modelInputs;
    const modelOutputs = [];
    for (let i2 = 0; i2 < this.outputLayers.length; i2++) {
      const layer = this.outputLayers[i2];
      const nodeIndex = this.outputLayersNodeIndices[i2];
      const nodeKey = Container$9.nodeKey(layer, nodeIndex);
      if (!this.containerNodes.has(nodeKey)) {
        continue;
      }
      let newNodeIndex = nodeConversionMap[nodeKey];
      if (newNodeIndex === null || newNodeIndex === void 0) {
        newNodeIndex = 0;
      }
      const tensorIndex = this.outputLayersTensorIndices[i2];
      modelOutputs.push([layer.name, newNodeIndex, tensorIndex]);
    }
    config2["outputLayers"] = modelOutputs;
    return config2;
  }
  static fromConfig(cls, config2, customObjects = {}, fastWeightInit = false) {
    const createdLayers = {};
    const unprocessedNodes = {};
    function addUnprocessedNode(layer, nodeData) {
      if (!(layer.name in unprocessedNodes)) {
        unprocessedNodes[layer.name] = [nodeData];
      } else {
        unprocessedNodes[layer.name].push(nodeData);
      }
    }
    function processNode(layer, nodeData) {
      const inputTensors2 = [];
      let kwargs;
      for (const inputData of nodeData) {
        const inboundLayerName = inputData[0];
        const inboundNodeIndex = inputData[1];
        const inboundTensorIndex = inputData[2];
        kwargs = inputData[3] == null ? {} : inputData[3];
        if (!(inboundLayerName in createdLayers)) {
          addUnprocessedNode(layer, nodeData);
          return;
        }
        const inboundLayer = createdLayers[inboundLayerName];
        if (inboundLayer.inboundNodes.length <= inboundNodeIndex) {
          addUnprocessedNode(layer, nodeData);
          return;
        }
        const inboundNode = inboundLayer.inboundNodes[inboundNodeIndex];
        inputTensors2.push(inboundNode.outputTensors[inboundTensorIndex]);
      }
      if (inputTensors2.length > 0) {
        layer.apply(singletonOrArray(inputTensors2), kwargs);
      }
    }
    function processLayer(layerData) {
      const layerName = layerData["name"];
      const layer = deserialize(layerData, config2["customObjects"] != null ? config2["customObjects"] : {});
      layer.setFastWeightInitDuringBuild(fastWeightInit);
      createdLayers[layerName] = layer;
      const inboundNodesData = layerData["inboundNodes"];
      inboundNodesData.forEach((nodeData) => {
        if (!(nodeData instanceof Array)) {
          throw new ValueError(`Corrupted configuration, expected array for nodeData: ${nodeData}`);
        }
        addUnprocessedNode(layer, nodeData);
      });
    }
    const name = config2["name"];
    const layersFromConfig = config2["layers"];
    for (const layerData of layersFromConfig) {
      processLayer(layerData);
    }
    while (!isObjectEmpty(unprocessedNodes)) {
      for (const layerData of layersFromConfig) {
        const layer = createdLayers[layerData["name"]];
        if (layer.name in unprocessedNodes) {
          const currentUnprocessedNodesForLayer = unprocessedNodes[layer.name];
          delete unprocessedNodes[layer.name];
          for (const nodeData of currentUnprocessedNodesForLayer) {
            processNode(layer, nodeData);
          }
        }
      }
    }
    const inputTensors = [];
    const outputTensors = [];
    const inputLayersFromConfig = config2["inputLayers"];
    for (const layerData of inputLayersFromConfig) {
      const layerName = layerData[0];
      const nodeIndex = layerData[1];
      const tensorIndex = layerData[2];
      assert(layerName in createdLayers);
      const layer = createdLayers[layerName];
      const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
      inputTensors.push(layerOutputTensors[tensorIndex]);
    }
    const outputLayersFromConfig = config2["outputLayers"];
    for (const layerData of outputLayersFromConfig) {
      const layerName = layerData[0];
      const nodeIndex = layerData[1];
      const tensorIndex = layerData[2];
      assert(layerName in createdLayers);
      const layer = createdLayers[layerName];
      const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
      outputTensors.push(layerOutputTensors[tensorIndex]);
    }
    return new cls({ inputs: inputTensors, outputs: outputTensors, name });
  }
  get stateful() {
    if (this._stateful) {
      throw new ValueError("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
    }
    for (const layer of this.layers) {
      if (layer.stateful) {
        return true;
      }
    }
    return false;
  }
  resetStates() {
    tidy(() => {
      this.layers.forEach((layer) => {
        if (layer.stateful) {
          layer.resetStates();
        }
      });
    });
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function standardizeSampleOrClassWeights(xWeight, outputNames, weightType) {
  const numOutputs = outputNames.length;
  if (xWeight == null || Array.isArray(xWeight) && xWeight.length === 0) {
    return outputNames.map((name) => null);
  }
  if (numOutputs === 1) {
    if (Array.isArray(xWeight) && xWeight.length === 1) {
      return xWeight;
    } else if (typeof xWeight === "object" && outputNames[0] in xWeight) {
      return [xWeight[outputNames[0]]];
    } else {
      return [xWeight];
    }
  }
  if (Array.isArray(xWeight)) {
    if (xWeight.length !== numOutputs) {
      throw new Error(`Provided ${weightType} is an array of ${xWeight.length} element(s), but the model has ${numOutputs} outputs. Make sure a set of weights is provided for each model output.`);
    }
    return xWeight;
  } else if (typeof xWeight === "object" && Object.keys(xWeight).length > 0 && typeof xWeight[Object.keys(xWeight)[0]] === "object") {
    const output2 = [];
    outputNames.forEach((outputName) => {
      if (outputName in xWeight) {
        output2.push(xWeight[outputName]);
      } else {
        output2.push(null);
      }
    });
    return output2;
  } else {
    throw new Error(`The model has multiple (${numOutputs}) outputs, so ${weightType} must be either an array with ${numOutputs} elements or an object with ${outputNames} keys. Provided ${weightType} not understood: ${JSON.stringify(xWeight)}`);
  }
}
function standardizeClassWeights(classWeight, outputNames) {
  return standardizeSampleOrClassWeights(classWeight, outputNames, "classWeight");
}
async function standardizeWeights(y2, sampleWeight, classWeight, sampleWeightMode) {
  if (sampleWeight != null || sampleWeightMode != null) {
    throw new Error("Support sampleWeight is not implemented yet");
  }
  if (classWeight != null) {
    const yClasses = tidy(() => {
      if (y2.shape.length === 1) {
        return clone(y2);
      } else if (y2.shape.length === 2) {
        if (y2.shape[1] > 1) {
          const axis = 1;
          return argMax$2(y2, axis);
        } else if (y2.shape[1] === 1) {
          return reshape$3(y2, [y2.shape[0]]);
        } else {
          throw new Error(`Encountered unexpected last-dimension size (${y2.shape[1]}) during handling of class weights. The size is expected to be >= 1.`);
        }
      } else {
        throw new Error(`Unexpected rank of target (y) tensor (${y2.rank}) during handling of class weights. The rank is expected to be 1 or 2.`);
      }
    });
    const yClassIndices = Array.from(await yClasses.data());
    dispose(yClasses);
    const classSampleWeight = [];
    yClassIndices.forEach((classIndex) => {
      if (classWeight[classIndex] == null) {
        throw new Error(`classWeight must contain all classes in the training data. The class ${classIndex} exists in the data but not in classWeight`);
      } else {
        classSampleWeight.push(classWeight[classIndex]);
      }
    });
    return tensor1d(classSampleWeight, "float32");
  } else {
    return null;
  }
}
function computeWeightedLoss(losses, sampleWeights) {
  return mul(losses, sampleWeights);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
const DEFAULT_VALIDATION_BATCH_SIZE = 32;
function standardizeDataIteratorOutput(model2, iteratorOut) {
  let xs;
  let ys;
  const iteratorOutObj = iteratorOut;
  xs = iteratorOutObj["xs"];
  ys = iteratorOutObj["ys"];
  assert$1(xs != null && ys != null, () => `A Dataset iterator for fitDataset() is expected to generate objects of the form \`{xs: xVal, ys: yVal}\`, where the two values may be \`tf.Tensor\`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates ${iteratorOut}`);
  const flattenedXs = flattenTensorOrArrayOrMap("input", model2.inputNames, xs);
  const flattenedYs = flattenTensorOrArrayOrMap("output", model2.outputNames, ys);
  const batchSize = flattenedXs[0].shape[0];
  assert$1(flattenedXs.length === model2.inputs.length, () => `LayersModel has ${model2.inputs.length} inputs, but the dataset provides ${flattenedXs.length} inputs.  (Expected input keys: ${JSON.stringify(model2.inputNames)})`);
  assert$1(flattenedYs.length === model2.outputs.length, () => `LayersModel has ${model2.outputs.length} outputs, but the dataset provides ${flattenedYs.length} outputs.  (Expected output keys: ${JSON.stringify(model2.outputNames)})`);
  for (let xIndex = 0; xIndex < flattenedXs.length; xIndex++) {
    assert$1(flattenedXs[xIndex].shape[0] === batchSize, () => `Batch size mismatch: input ${model2.inputNames[xIndex]} has ${flattenedXs[xIndex].shape[0]}; expected  ${batchSize} based on input ${model2.inputNames[0]}.`);
  }
  for (let yIndex = 0; yIndex < flattenedYs.length; yIndex++) {
    assert$1(flattenedYs[yIndex].shape[0] === batchSize, () => `Batch size mismatch: output ${model2.outputNames[yIndex]} has ${flattenedYs[yIndex].shape[0]}; expected  ${batchSize} based on input ${model2.inputNames[0]}.`);
  }
  return { xs: flattenedXs, ys: flattenedYs };
}
function flattenTensorOrArrayOrMap(inputOrOutput, names2, values) {
  if (values instanceof Tensor) {
    return [values];
  } else if (Array.isArray(values)) {
    assert$1(values.length === names2.length, () => `Received an array of ${values.length} Tensors, but expected ${names2.length} to match the ${inputOrOutput} keys ${names2}.`);
    return values;
  } else {
    const result2 = [];
    for (const name of names2) {
      if (values[name] == null) {
        throw new ValueError(`The feature data generated by the dataset lacks the required ${inputOrOutput} key '${name}'.`);
      }
      result2.push(values[name]);
    }
    return result2;
  }
}
function standardizeTensorValidationData(data2) {
  if (data2.length === 3) {
    throw new NotImplementedError("Validation with sample weights is not implemented yet.");
  }
  return { xs: data2[0], ys: data2[1] };
}
async function fitDataset(model2, dataset, args) {
  const hasBatchesPerEpoch = args.batchesPerEpoch != null;
  assert$1(model2.optimizer != null, () => "You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig).");
  assert$1(args != null, () => `For fitDataset(), the 2nd argument (config) is required, but it is not provided in this call.`);
  assert$1(args.epochs != null && args.epochs > 0 && Number.isInteger(args.epochs), () => `For fitDataset(), config.epochs is expected to be a positive integer, but got ${args.epochs}`);
  assert$1(!hasBatchesPerEpoch || args.batchesPerEpoch > 0 && Number.isInteger(args.batchesPerEpoch), () => `For fitDataset(), config.batchesPerEpoch is expected to be a positive integer if specified, but got ${args.batchesPerEpoch}`);
  assert$1(args["validationSplit"] == null, () => "`validationSplit` is not supported by `fitDataset()`. Use validationData instead.");
  if (model2.isTraining) {
    throw new Error("Cannot start training because another fit() call is ongoing.");
  }
  model2.isTraining = true;
  try {
    const doValidation = args.validationData != null;
    let valXs;
    let valYs;
    if (doValidation) {
      if (isDatasetObject(args.validationData)) {
        assert$1(args.validationBatches == null || args.validationBatches > 0 && Number.isInteger(args.validationBatches), () => `For fitDataset() with dataset-based validation, config.validationBatches is expected not to be provided, or to be a positive integer, but got ${args.validationBatches}`);
      } else {
        const validationData = standardizeTensorValidationData(args.validationData);
        valXs = validationData.xs;
        valYs = validationData.ys;
      }
    }
    const trainFunction = model2.makeTrainFunction();
    const outLabels = model2.getDedupedMetricsNames();
    let callbackMetrics;
    if (doValidation) {
      callbackMetrics = outLabels.slice().concat(outLabels.map((n2) => "val_" + n2));
    } else {
      callbackMetrics = outLabels.slice();
    }
    const callbacks = standardizeCallbacks(args.callbacks, args.yieldEvery);
    const verbose = args.verbose == null ? 1 : args.verbose;
    const { callbackList, history } = configureCallbacks(callbacks, verbose, args.epochs, null, null, getStepsPerEpoch(dataset, args), null, doValidation, callbackMetrics);
    callbackList.setModel(model2);
    model2.history = history;
    await callbackList.onTrainBegin();
    model2.stopTraining_ = false;
    let epoch = args.initialEpoch == null ? 0 : args.initialEpoch;
    let dataIterator = await dataset.iterator();
    while (epoch < args.epochs) {
      const epochLogs = {};
      await callbackList.onEpochBegin(epoch);
      let stepsDone = 0;
      let batchIndex = 0;
      if (!hasBatchesPerEpoch) {
        dataIterator = await dataset.iterator();
      }
      while (hasBatchesPerEpoch ? stepsDone < args.batchesPerEpoch : true) {
        const iteratorOut = await dataIterator.next();
        if (hasBatchesPerEpoch && iteratorOut.done) {
          console.warn(`You provided \`batchesPerEpoch\` as ${args.batchesPerEpoch}, but your dataset iterator ran out of data after ${stepsDone} batches; interrupting training. Make sure that your dataset can generate at least \`batchesPerEpoch * epochs\` batches (in this case, ${args.batchesPerEpoch * args.epochs} batches). You may need to use the repeat() function when building your dataset.`);
          break;
        }
        if (iteratorOut.value != null) {
          const { xs, ys } = standardizeDataIteratorOutput(model2, iteratorOut.value);
          const batchLogs = {};
          batchLogs["batch"] = batchIndex;
          batchLogs["size"] = xs[0].shape[0];
          await callbackList.onBatchBegin(batchIndex, batchLogs);
          const sampleWeights = [];
          if (args.classWeight != null) {
            const standardClassWeights = standardizeClassWeights(args.classWeight, model2.outputNames);
            for (let i2 = 0; i2 < standardClassWeights.length; ++i2) {
              sampleWeights.push(await standardizeWeights(ys[i2], null, standardClassWeights[i2]));
            }
          }
          const ins = xs.concat(ys).concat(sampleWeights);
          const outs = trainFunction(ins);
          dispose(ins);
          for (let i2 = 0; i2 < outLabels.length; ++i2) {
            const label = outLabels[i2];
            const out = outs[i2];
            batchLogs[label] = out;
            keep(out);
          }
          await callbackList.onBatchEnd(batchIndex, batchLogs);
          disposeTensorsInLogs(batchLogs);
          batchIndex++;
          stepsDone++;
        }
        if (hasBatchesPerEpoch ? stepsDone >= args.batchesPerEpoch : iteratorOut.done) {
          if (doValidation) {
            let valOuts;
            if (isDatasetObject(args.validationData)) {
              valOuts = toList(await model2.evaluateDataset(args.validationData, { batches: args.validationBatches }));
            } else {
              valOuts = toList(model2.evaluate(valXs, valYs, {
                batchSize: args.validationBatchSize == null ? DEFAULT_VALIDATION_BATCH_SIZE : args.validationBatchSize,
                verbose: 0
              }));
            }
            for (let i2 = 0; i2 < model2.metricsNames.length; ++i2) {
              epochLogs[`val_${model2.metricsNames[i2]}`] = valOuts[i2];
            }
          }
          break;
        }
        if (model2.stopTraining_) {
          break;
        }
      }
      await callbackList.onEpochEnd(epoch, epochLogs);
      epoch++;
      if (model2.stopTraining_) {
        break;
      }
    }
    await callbackList.onTrainEnd();
    await model2.history.syncData();
    return model2.history;
  } finally {
    model2.isTraining = false;
  }
}
function getStepsPerEpoch(dataset, args) {
  let stepsPerEpoch = null;
  if (args.batchesPerEpoch != null) {
    stepsPerEpoch = args.batchesPerEpoch;
  } else if (Number.isFinite(dataset.size)) {
    stepsPerEpoch = dataset.size;
  }
  return stepsPerEpoch;
}
function isDatasetObject(dataset) {
  return typeof dataset.iterator === "function";
}
function isLazyIteratorObject(iterator) {
  return typeof iterator.next === "function";
}
async function evaluateDataset(model2, dataset, args) {
  args = args || {};
  const hasBatches = args.batches != null;
  const f2 = model2.testFunction;
  let outs = [];
  if (args.verbose > 0) {
    throw new NotImplementedError("Verbose mode is not implemented yet.");
  }
  assert$1(!hasBatches || args.batches > 0 && Number.isInteger(args.batches), () => `Test loop expects \`batches\` to be a positive integer, but received ${JSON.stringify(args.batches)}`);
  const dataIterator = isLazyIteratorObject(dataset) ? dataset : await dataset.iterator();
  let numExamples = 0;
  let batch = 0;
  while (hasBatches ? batch < args.batches : true) {
    const iteratorOut = await dataIterator.next();
    outs = tidy(() => {
      if (iteratorOut.value) {
        const { xs, ys } = standardizeDataIteratorOutput(model2, iteratorOut.value);
        const xsAndYs = xs.concat(ys);
        const batchOuts = tidy(() => f2(xsAndYs));
        dispose(xsAndYs);
        if (batch === 0) {
          for (let i2 = 0; i2 < batchOuts.length; ++i2) {
            outs.push(scalar(0));
          }
        }
        const batchSize = xsAndYs[0].shape[0];
        for (let i2 = 0; i2 < batchOuts.length; ++i2) {
          const batchOut = batchOuts[i2];
          const oldScalar = outs[i2];
          outs[i2] = tidy(() => add$1(outs[i2], mul(batchSize, batchOut)));
          if (batch > 0) {
            dispose(oldScalar);
          }
        }
        dispose(batchOuts);
        numExamples += batchSize;
        ++batch;
      }
      return outs;
    });
    if (iteratorOut.done) {
      if (hasBatches) {
        console.warn(`Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least \`batches\` batches (in this case, ${args.batches} batches). You may need to use the repeat() function when building your dataset.`);
      }
      break;
    }
  }
  for (let i2 = 0; i2 < outs.length; ++i2) {
    const oldScalar = outs[i2];
    outs[i2] = div$1(outs[i2], numExamples);
    dispose(oldScalar);
  }
  return singletonOrArray(outs);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function checkBatchSize(batchSize) {
  assert$1(batchSize > 0 && Number.isInteger(batchSize), () => `batchSize is required to be a positive integer, but got ${batchSize}`);
}
function sliceArrays(arrays, start, stop) {
  if (arrays == null) {
    return [null];
  } else if (Array.isArray(arrays)) {
    return arrays.map((array) => sliceAlongFirstAxis(array, start, stop - start));
  } else {
    return sliceAlongFirstAxis(arrays, start, stop - start);
  }
}
function sliceArraysByIndices(arrays, indices) {
  return tidy(() => {
    if (arrays == null) {
      return null;
    } else if (Array.isArray(arrays)) {
      return arrays.map((array) => sliceArraysByIndices(array, indices));
    } else {
      return gather(arrays, indices.dtype === "int32" ? indices : cast$4(indices, "int32"));
    }
  });
}
function makeBatches(size, batchSize) {
  const output2 = [];
  let batchStart = 0;
  let batchEnd = null;
  while (batchStart < size) {
    batchEnd = batchStart + batchSize;
    if (batchEnd >= size) {
      batchEnd = size;
    }
    output2.push([batchStart, batchEnd]);
    batchStart = batchEnd;
  }
  return output2;
}
async function fitLoop(model2, f2, ins, outLabels, batchSize, epochs, verbose, callbacks, valF, valIns, shuffle$1, callbackMetrics, initialEpoch, stepsPerEpoch, validationSteps) {
  if (batchSize == null) {
    batchSize = 32;
  }
  if (epochs == null) {
    epochs = 1;
  }
  if (shuffle$1 == null) {
    shuffle$1 = true;
  }
  if (initialEpoch == null) {
    initialEpoch = 0;
  }
  let doValidation = false;
  if (valF != null && valIns != null) {
    doValidation = true;
  }
  if (validationSteps != null) {
    doValidation = true;
    if (stepsPerEpoch == null) {
      throw new ValueError("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
    }
  }
  const numTrainSamples = model2.checkNumSamples(ins, batchSize, stepsPerEpoch, "steps_per_epoch");
  let indexArray;
  if (numTrainSamples != null) {
    indexArray = range$3(0, numTrainSamples);
  }
  if (verbose == null) {
    verbose = 1;
  }
  const { callbackList, history } = configureCallbacks(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics);
  callbackList.setModel(model2);
  model2.history = history;
  await callbackList.onTrainBegin();
  model2.stopTraining_ = false;
  for (let epoch = initialEpoch; epoch < epochs; ++epoch) {
    await callbackList.onEpochBegin(epoch);
    const epochLogs = {};
    if (stepsPerEpoch != null) {
      throw new NotImplementedError("stepsPerEpoch mode is not implemented yet.");
    } else {
      if (shuffle$1 === "batch") {
        throw new NotImplementedError("batch shuffling is not implemneted yet");
      } else if (shuffle$1) {
        shuffle(indexArray);
      }
      const epochIndexArray1D = tensor1d(indexArray);
      const batches = makeBatches(numTrainSamples, batchSize);
      for (let batchIndex = 0; batchIndex < batches.length; ++batchIndex) {
        const batchLogs = {};
        await callbackList.onBatchBegin(batchIndex, batchLogs);
        tidy(() => {
          const batchStart = batches[batchIndex][0];
          const batchEnd = batches[batchIndex][1];
          const batchIds = sliceAlongFirstAxis(epochIndexArray1D, batchStart, batchEnd - batchStart);
          batchLogs["batch"] = batchIndex;
          batchLogs["size"] = batchEnd - batchStart;
          const insBatch = sliceArraysByIndices(ins, batchIds);
          const outs = f2(insBatch);
          for (let i2 = 0; i2 < outLabels.length; ++i2) {
            const label = outLabels[i2];
            const out = outs[i2];
            batchLogs[label] = out;
            keep(out);
          }
          if (batchIndex === batches.length - 1) {
            if (doValidation) {
              const valOuts = model2.testLoop(valF, valIns, batchSize);
              for (let i2 = 0; i2 < outLabels.length; ++i2) {
                const label = outLabels[i2];
                const out = valOuts[i2];
                keep(out);
                epochLogs["val_" + label] = out;
              }
            }
          }
        });
        await callbackList.onBatchEnd(batchIndex, batchLogs);
        disposeTensorsInLogs(batchLogs);
        if (model2.stopTraining_) {
          break;
        }
      }
      epochIndexArray1D.dispose();
    }
    await callbackList.onEpochEnd(epoch, epochLogs);
    if (model2.stopTraining_) {
      break;
    }
  }
  await callbackList.onTrainEnd();
  await model2.history.syncData();
  return model2.history;
}
async function fitTensors(model2, x2, y2, args = {}) {
  if (model2.isTraining) {
    throw new Error("Cannot start training because another fit() call is ongoing.");
  }
  model2.isTraining = true;
  let inputs;
  let targets;
  let originalInputs;
  let originalTargets;
  let inputValX;
  let inputValY;
  let valX;
  let valY;
  let sampleWeights;
  try {
    const batchSize = args.batchSize == null ? 32 : args.batchSize;
    checkBatchSize(batchSize);
    const checkBatchAxis = false;
    const standardizedOuts = await model2.standardizeUserData(x2, y2, args.sampleWeight, args.classWeight, checkBatchAxis, batchSize);
    inputs = standardizedOuts[0];
    targets = standardizedOuts[1];
    sampleWeights = standardizedOuts[2];
    let doValidation = false;
    let valIns;
    if (args.validationData != null && args.validationData.length > 0) {
      doValidation = true;
      if (args.validationData.length === 2) {
        inputValX = args.validationData[0];
        inputValY = args.validationData[1];
      } else if (args.validationData.length === 3) {
        throw new NotImplementedError("validationData including sample weights is not supported yet.");
      } else {
        throw new ValueError(`When passing validation data, it must contain 2 (valX, valY) or 3 (valX, valY, valSampleWeight) items; ${args.validationData} is invalid.`);
      }
      const checkBatchAxis2 = true;
      const valStandardized = await model2.standardizeUserData(inputValX, inputValY, null, null, checkBatchAxis2, batchSize);
      valX = valStandardized[0];
      valY = valStandardized[1];
      valIns = valX.concat(valY);
    } else if (args.validationSplit != null && args.validationSplit > 0 && args.validationSplit < 1) {
      doValidation = true;
      const splitAt = Math.floor(inputs[0].shape[0] * (1 - args.validationSplit));
      const originalBatchSize = inputs[0].shape[0];
      valX = sliceArrays(inputs, splitAt, originalBatchSize);
      originalInputs = inputs;
      inputs = sliceArrays(inputs, 0, splitAt);
      valY = sliceArrays(targets, splitAt, originalBatchSize);
      originalTargets = targets;
      targets = sliceArrays(targets, 0, splitAt);
      valIns = valX.concat(valY);
    } else if (args.validationSteps != null) {
      doValidation = true;
    }
    const ins = inputs.concat(targets).concat(sampleWeights);
    model2.checkTrainableWeightsConsistency();
    const trainFunction = model2.makeTrainFunction();
    const outLabels = model2.getDedupedMetricsNames();
    let valFunction;
    let callbackMetrics;
    if (doValidation) {
      model2.makeTestFunction();
      valFunction = model2.testFunction;
      callbackMetrics = outLabels.slice().concat(outLabels.map((n2) => "val_" + n2));
    } else {
      valFunction = null;
      valIns = [];
      callbackMetrics = outLabels.slice();
    }
    const callbacks = standardizeCallbacks(args.callbacks, args.yieldEvery);
    const out = await fitLoop(model2, trainFunction, ins, outLabels, batchSize, args.epochs, args.verbose, callbacks, valFunction, valIns, args.shuffle, callbackMetrics, args.initialEpoch, null, null);
    return out;
  } finally {
    model2.isTraining = false;
    disposeNewTensors(inputs, x2);
    disposeNewTensors(targets, y2);
    disposeNewTensors(originalInputs, x2);
    disposeNewTensors(originalTargets, y2);
    disposeNewTensors(valX, inputValX);
    disposeNewTensors(valY, inputValY);
    if (sampleWeights != null) {
      dispose(sampleWeights);
    }
  }
}
function ensureTensorsRank2OrHigher(tensors) {
  const outs = [];
  if (tensors instanceof Tensor) {
    tensors = [tensors];
  }
  for (let i2 = 0; i2 < tensors.length; ++i2) {
    const tensor2 = tensors[i2];
    if (tensor2.rank === 1) {
      outs.push(expandDims$3(tensor2, 1));
    } else if (tensor2.rank === 0) {
      throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
    } else {
      outs.push(tensor2);
    }
  }
  return outs;
}
function disposeNewTensors(tensors, refTensors) {
  if (tensors == null) {
    return;
  }
  const oldTensorIds = [];
  if (refTensors instanceof Tensor) {
    oldTensorIds.push(refTensors.id);
  } else if (Array.isArray(refTensors)) {
    refTensors.forEach((t2) => oldTensorIds.push(t2.id));
  } else if (refTensors != null) {
    for (const name in refTensors) {
      const oldTensor = refTensors[name];
      oldTensorIds.push(oldTensor.id);
    }
  }
  const tensorsToDispose = [];
  if (tensors instanceof Tensor) {
    if (oldTensorIds.indexOf(tensors.id) === -1) {
      tensorsToDispose.push(tensors);
    }
  } else if (Array.isArray(tensors)) {
    tensors.forEach((t2) => {
      if (oldTensorIds.indexOf(t2.id) === -1) {
        tensorsToDispose.push(t2);
      }
    });
  } else if (tensors != null) {
    for (const name in tensors) {
      const tensor2 = tensors[name];
      if (oldTensorIds.indexOf(tensor2.id) === -1) {
        tensorsToDispose.push(tensor2);
      }
    }
  }
  tensorsToDispose.forEach((t2) => {
    if (!t2.isDisposed) {
      t2.dispose();
    }
  });
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function isDataTensor(x2) {
  return x2 instanceof Tensor;
}
function isDataArray(x2) {
  return Array.isArray(x2);
}
function isDataDict(x2) {
  return !isDataTensor(x2) && !isDataArray(x2);
}
function standardizeInputData(data2, names2, shapes, checkBatchAxis = true, exceptionPrefix = "") {
  if (names2 == null || names2.length === 0) {
    if (data2 != null) {
      let gotUnexpectedData = false;
      if (isDataArray(data2) && data2.length > 0) {
        gotUnexpectedData = true;
      } else if (isDataDict(data2)) {
        for (const key in data2) {
          if (data2.hasOwnProperty(key)) {
            gotUnexpectedData = true;
            break;
          }
        }
      } else {
        gotUnexpectedData = true;
      }
      if (gotUnexpectedData) {
        throw new ValueError(`Error when checking model ${exceptionPrefix} expected no data, but got ${data2}`);
      }
    }
    return [];
  }
  if (data2 == null) {
    return names2.map((name) => null);
  }
  let arrays;
  if (isDataDict(data2)) {
    data2 = data2;
    arrays = [];
    for (const name of names2) {
      if (data2[name] == null) {
        throw new ValueError(`No data provided for "${name}". Need data for each key in: ${names2}`);
      }
      arrays.push(data2[name]);
    }
  } else if (isDataArray(data2)) {
    data2 = data2;
    if (data2.length !== names2.length) {
      throw new ValueError(`Error when checking model ${exceptionPrefix}: the Array of Tensors that you are passing to your model is not the size the model expected. Expected to see ${names2.length} Tensor(s), but instead got the following list of Tensor(s): ${data2}`);
    }
    arrays = data2;
  } else {
    data2 = data2;
    if (names2.length > 1) {
      throw new ValueError(`The model ${exceptionPrefix} expects ${names2.length} Tensor(s), but only received one Tensor. Found: Tensor with shape ${data2.shape}`);
    }
    arrays = [data2];
  }
  arrays = ensureTensorsRank2OrHigher(arrays);
  if (shapes != null) {
    for (let i2 = 0; i2 < names2.length; ++i2) {
      if (shapes[i2] == null) {
        continue;
      }
      const array = arrays[i2];
      if (array.shape.length !== shapes[i2].length) {
        throw new ValueError(`Error when checking ${exceptionPrefix}: expected ${names2[i2]} to have ${shapes[i2].length} dimension(s). but got array with shape ${array.shape}`);
      }
      for (let j2 = 0; j2 < shapes[i2].length; ++j2) {
        if (j2 === 0 && !checkBatchAxis) {
          continue;
        }
        const dim = array.shape[j2];
        const refDim = shapes[i2][j2];
        if (refDim != null && refDim >= 0 && dim !== refDim) {
          throw new ValueError(`${exceptionPrefix} expected a batch of elements where each example has shape [${shapes[i2].slice(1, shapes[i2].length)}] (i.e.,tensor shape [*,${shapes[i2].slice(1, shapes[i2].length)}]) but the ${exceptionPrefix} received an input with ${array.shape[0]} examples, each with shape [${array.shape.slice(1, array.shape.length)}] (tensor shape [${array.shape}])`);
        }
      }
    }
  }
  return arrays;
}
function checkArrayLengths(inputs, targets, weights) {
  const setX = unique$2(inputs.map((input) => input.shape[0]));
  setX.sort();
  const setY = unique$2(targets.map((target) => target.shape[0]));
  setY.sort();
  if (setX.length > 1) {
    throw new ValueError(`All input Tensors (x) should have the same number of samples. Got array shapes: ${JSON.stringify(inputs.map((input) => input.shape))}`);
  }
  if (setY.length > 1) {
    throw new ValueError(`All target Tensors (y) should have the same number of samples. Got array shapes: ${JSON.stringify(targets.map((target) => target.shape))}`);
  }
  if (setX.length > 0 && setY.length > 0 && !arraysEqual(setX, setY)) {
    throw new ValueError(`Input Tensors should have the same number of samples as target Tensors. Found ${setX[0]} input sample(s) and ${setY[0]} target sample(s).`);
  }
}
function checkLossAndTargetCompatibility(targets, lossFns, outputShapes) {
  const keyLosses = [
    meanSquaredError,
    binaryCrossentropy$1,
    categoricalCrossentropy$1
  ];
  for (let i2 = 0; i2 < targets.length; ++i2) {
    const y2 = targets[i2];
    const loss = lossFns[i2];
    const shape = outputShapes[i2];
    if (loss == null) {
      continue;
    }
    if (loss === categoricalCrossentropy$1) {
      if (y2.shape[y2.shape.length - 1] === 1) {
        throw new ValueError(`You are passing a target array of shape ${y2.shape} while using a loss 'categorical_crossentropy'. 'categorical_crossentropy'expects targets to be binary matrices (1s and 0s) of shape [samples, classes].`);
      }
    }
    if (keyLosses.indexOf(loss) !== -1) {
      const slicedYShape = y2.shape.slice(1);
      const slicedShape = shape.slice(1);
      for (let j2 = 0; j2 < slicedYShape.length; ++j2) {
        const targetDim = slicedYShape[j2];
        const outDim = slicedShape[j2];
        if (outDim != null && targetDim !== outDim) {
          throw new ValueError(`A target Tensor with shape ${y2.shape} was passed for an output of shape ${shape}, while using a loss function that expects targets to have the same shape as the output.`);
        }
      }
    }
  }
}
function checkInputData(data2, names2, shapes, checkBatchAxis = true, exceptionPrefix = "") {
  let arrays;
  if (Array.isArray(data2)) {
    if (data2.length !== names2.length) {
      throw new ValueError(`Error when checking model ${exceptionPrefix}: the Array of Tensors that you are passing to your model is not the size the the model expected. Expected to see ${names2.length} Tensor(s), but instead got ${data2.length} Tensors(s).`);
    }
    arrays = data2;
  } else {
    if (names2.length > 1) {
      throw new ValueError(`The model expects ${names2.length} ${exceptionPrefix} Tensors, but only received one Tensor. Found: array with shape ${JSON.stringify(data2.shape)}.`);
    }
    arrays = [data2];
  }
  if (shapes != null) {
    for (let i2 = 0; i2 < names2.length; ++i2) {
      if (shapes[i2] == null) {
        continue;
      }
      const array = arrays[i2];
      if (array.shape.length !== shapes[i2].length) {
        throw new ValueError(`Error when checking ${exceptionPrefix}: expected ${names2[i2]} to have ${shapes[i2].length} dimension(s), but got array with shape ${JSON.stringify(array.shape)}`);
      }
      for (let j2 = 0; j2 < shapes[i2].length; ++j2) {
        if (j2 === 0 && !checkBatchAxis) {
          continue;
        }
        const dim = array.shape[j2];
        const refDim = shapes[i2][j2];
        if (refDim != null) {
          if (refDim !== dim) {
            throw new ValueError(`Error when checking ${exceptionPrefix}: expected ${names2[i2]} to have shape ${JSON.stringify(shapes[i2])} but got array with shape ${JSON.stringify(array.shape)}.`);
          }
        }
      }
    }
  }
}
function collectMetrics(metrics, outputNames) {
  if (metrics == null || Array.isArray(metrics) && metrics.length === 0) {
    return outputNames.map((name) => []);
  }
  let wrappedMetrics;
  if (typeof metrics === "string" || typeof metrics === "function") {
    wrappedMetrics = [metrics];
  } else if (Array.isArray(metrics) || typeof metrics === "object") {
    wrappedMetrics = metrics;
  } else {
    throw new TypeError(`Type of metrics argument not understood. Expected an string,function, Array, or Object, found: ${metrics}`);
  }
  if (Array.isArray(wrappedMetrics)) {
    return outputNames.map((name) => wrappedMetrics);
  } else {
    const nestedMetrics = [];
    for (const name of outputNames) {
      let outputMetrics = wrappedMetrics.hasOwnProperty(name) ? wrappedMetrics[name] : [];
      if (!Array.isArray(outputMetrics)) {
        outputMetrics = [outputMetrics];
      }
      nestedMetrics.push(outputMetrics);
    }
    return nestedMetrics;
  }
}
const LAYERS_MODEL_FORMAT_NAME = "layers-model";
class LayersModel extends Container$9 {
  constructor(args) {
    super(args);
    this.isTraining = false;
  }
  summary(lineLength, positions, printFn = console.log) {
    if (!this.built) {
      throw new ValueError(`This model has never been called, thus its weights have not been created yet. So no summary can be displayed. Build the model first (e.g., by calling it on some test data).`);
    }
    printSummary(this, lineLength, positions, printFn);
  }
  compile(args) {
    if (args.loss == null) {
      args.loss = [];
    }
    this.loss = args.loss;
    if (typeof args.optimizer === "string") {
      this.optimizer_ = getOptimizer(args.optimizer);
      this.isOptimizerOwned = true;
    } else {
      if (!(args.optimizer instanceof Optimizer)) {
        throw new ValueError(`User-defined optimizer must be an instance of tf.Optimizer.`);
      }
      this.optimizer_ = args.optimizer;
      this.isOptimizerOwned = false;
    }
    let lossFunctions = [];
    if (!Array.isArray(args.loss) && typeof args.loss !== "string" && typeof args.loss !== "function") {
      args.loss = args.loss;
      for (const name in args.loss) {
        if (this.outputNames.indexOf(name) === -1) {
          throw new ValueError(`Unknown entry in loss dictionary: "${name}". Only expected the following keys: ${this.outputNames}`);
        }
      }
      for (const name of this.outputNames) {
        if (args.loss[name] == null) {
          console.warn(`Output "${name}" is missing from loss dictionary. We assume this was done on purpose, and we will not be expecting data to be passed to ${name} during training`);
        }
        lossFunctions.push(get$2(args.loss[name]));
      }
    } else if (Array.isArray(args.loss)) {
      if (args.loss.length !== this.outputs.length) {
        throw new ValueError(`When passing an Array as loss, it should have one entry per model output. The model has ${this.outputs.length} output(s), but you passed loss=${args.loss}.`);
      }
      const theLosses = args.loss;
      lossFunctions = theLosses.map((l2) => get$2(l2));
    } else {
      const lossFunction = get$2(args.loss);
      this.outputs.forEach((_24) => {
        lossFunctions.push(lossFunction);
      });
    }
    this.lossFunctions = lossFunctions;
    this.feedOutputNames = [];
    this.feedOutputShapes = [];
    this.feedLossFns = [];
    for (let i2 = 0; i2 < this.outputs.length; ++i2) {
      const shape = this.internalOutputShapes[i2];
      const name = this.outputNames[i2];
      this.feedOutputNames.push(name);
      this.feedOutputShapes.push(shape);
      this.feedLossFns.push(this.lossFunctions[i2]);
    }
    const skipTargetIndices = [];
    this.metrics = args.metrics;
    this.metricsNames = ["loss"];
    this.metricsTensors = [];
    nameScope("loss", () => {
      for (let i2 = 0; i2 < this.outputs.length; ++i2) {
        if (skipTargetIndices.indexOf(i2) !== -1) {
          continue;
        }
        const weightedLoss = this.lossFunctions[i2];
        if (this.outputs.length > 1) {
          this.metricsTensors.push([weightedLoss, i2]);
          this.metricsNames.push(this.outputNames[i2] + "_loss");
        }
      }
    });
    const nestedMetrics = collectMetrics(args.metrics, this.outputNames);
    const appendMetric = (outputIndex, metricName, metricTensor) => {
      if (this.outputNames.length > 1) {
        metricName = this.outputNames[outputIndex] + "_" + metricName;
      }
      this.metricsNames.push(metricName);
      this.metricsTensors.push([metricTensor, outputIndex]);
    };
    nameScope("metric", () => {
      for (let i2 = 0; i2 < this.outputs.length; ++i2) {
        if (skipTargetIndices.indexOf(i2) !== -1) {
          continue;
        }
        const outputMetrics = nestedMetrics[i2];
        const handleMetrics = (metrics) => {
          const metricNamePrefix = "";
          let metricName;
          let accFn;
          let weightedMetricFn;
          for (const metric of metrics) {
            if (typeof metric === "string" && ["accuracy", "acc", "crossentropy", "ce"].indexOf(metric) !== -1) {
              const outputShape = this.internalOutputShapes[i2];
              if (outputShape[outputShape.length - 1] === 1 || this.lossFunctions[i2] === binaryCrossentropy$1) {
                if (["accuracy", "acc"].indexOf(metric) !== -1) {
                  accFn = binaryAccuracy;
                } else if (["crossentropy", "ce"].indexOf(metric) !== -1) {
                  accFn = binaryCrossentropy;
                }
              } else if (this.lossFunctions[i2] === sparseCategoricalCrossentropy$1) {
                if (["accuracy", "acc"].indexOf(metric) !== -1) {
                  accFn = sparseCategoricalAccuracy;
                } else if (["crossentropy", "ce"].indexOf(metric) !== -1) {
                  accFn = sparseCategoricalCrossentropy;
                }
              } else {
                if (["accuracy", "acc"].indexOf(metric) !== -1) {
                  accFn = categoricalAccuracy;
                } else if (["crossentropy", "ce"].indexOf(metric) !== -1) {
                  accFn = categoricalCrossentropy;
                }
              }
              let suffix;
              if (["accuracy", "acc"].indexOf(metric) !== -1) {
                suffix = "acc";
              } else if (["crossentropy", "ce"].indexOf(metric) !== -1) {
                suffix = "ce";
              }
              weightedMetricFn = accFn;
              metricName = metricNamePrefix + suffix;
            } else {
              const metricFn = get$1(metric);
              weightedMetricFn = metricFn;
              metricName = metricNamePrefix + getLossOrMetricName(metric);
            }
            let metricResult;
            nameScope(metricName, () => {
              metricResult = weightedMetricFn;
            });
            appendMetric(i2, metricName, metricResult);
          }
        };
        handleMetrics(outputMetrics);
      }
    });
    this.collectedTrainableWeights = this.trainableWeights;
  }
  checkTrainableWeightsConsistency() {
    if (this.collectedTrainableWeights == null) {
      return;
    }
    if (this.trainableWeights.length !== this.collectedTrainableWeights.length) {
      console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
    }
  }
  evaluate(x2, y2, args = {}) {
    const batchSize = args.batchSize == null ? 32 : args.batchSize;
    checkBatchSize(batchSize);
    const checkBatchAxis = true;
    const standardizedOuts = this.standardizeUserDataXY(x2, y2, checkBatchAxis, batchSize);
    try {
      const ins = standardizedOuts[0].concat(standardizedOuts[1]);
      this.makeTestFunction();
      const f2 = this.testFunction;
      const testOuts = this.testLoop(f2, ins, batchSize, args.verbose, args.steps);
      return singletonOrArray(testOuts);
    } finally {
      disposeNewTensors(standardizedOuts[0], x2);
      disposeNewTensors(standardizedOuts[1], y2);
    }
  }
  async evaluateDataset(dataset, args) {
    this.makeTestFunction();
    return evaluateDataset(this, dataset, args);
  }
  checkNumSamples(ins, batchSize, steps2, stepsName = "steps") {
    let numSamples;
    if (steps2 != null) {
      numSamples = null;
      if (batchSize != null) {
        throw new ValueError(`If ${stepsName} is set, batchSize must be null or undefined.Got batchSize = ${batchSize}`);
      }
    } else if (ins != null) {
      if (Array.isArray(ins)) {
        numSamples = ins[0].shape[0];
      } else {
        numSamples = ins.shape[0];
      }
    } else {
      throw new ValueError(`Either the input data should have a defined shape, or ${stepsName} shoud be specified.`);
    }
    return numSamples;
  }
  execute(inputs, outputs) {
    if (Array.isArray(outputs) && outputs.length === 0) {
      throw new ValueError("`outputs` is an empty Array, which is not allowed.");
    }
    const outputsIsArray = Array.isArray(outputs);
    const outputNames = outputsIsArray ? outputs : [outputs];
    const outputSymbolicTensors = this.retrieveSymbolicTensors(outputNames);
    const feedDict = new FeedDict();
    if (inputs instanceof Tensor) {
      inputs = [inputs];
    }
    if (Array.isArray(inputs)) {
      if (inputs.length !== this.inputs.length) {
        throw new ValueError(`The number of inputs provided (${inputs.length}) does not match the number of inputs of this model (${this.inputs.length}).`);
      }
      for (let i2 = 0; i2 < this.inputs.length; ++i2) {
        feedDict.add(this.inputs[i2], inputs[i2]);
      }
    } else {
      for (const input of this.inputs) {
        const tensorValue = inputs[input.name];
        if (tensorValue == null) {
          throw new ValueError(`No value is provided for the model's input ${input.name}`);
        }
        feedDict.add(input, tensorValue);
      }
    }
    const executeOutputs = execute(outputSymbolicTensors, feedDict);
    return outputsIsArray ? executeOutputs : executeOutputs[0];
  }
  retrieveSymbolicTensors(symbolicTensorNames) {
    const outputSymbolicTensors = pyListRepeat(null, symbolicTensorNames.length);
    let outputsRemaining = symbolicTensorNames.length;
    for (const layer of this.layers) {
      const layerOutputs = Array.isArray(layer.output) ? layer.output : [layer.output];
      const layerOutputNames = layerOutputs.map((output2) => output2.name);
      for (let i2 = 0; i2 < symbolicTensorNames.length; ++i2) {
        const index2 = layerOutputNames.indexOf(symbolicTensorNames[i2]);
        if (index2 !== -1) {
          outputSymbolicTensors[i2] = layerOutputs[index2];
          outputsRemaining--;
        }
        if (outputsRemaining === 0) {
          break;
        }
      }
      if (outputsRemaining === 0) {
        break;
      }
    }
    if (outputsRemaining > 0) {
      const remainingNames = [];
      outputSymbolicTensors.forEach((tensor2, i2) => {
        if (tensor2 == null) {
          remainingNames.push(symbolicTensorNames[i2]);
        }
      });
      throw new ValueError(`Cannot find SymbolicTensors for output name(s): ${JSON.stringify(remainingNames)}`);
    }
    return outputSymbolicTensors;
  }
  predictLoop(ins, batchSize = 32, verbose = false) {
    return tidy(() => {
      const numSamples = this.checkNumSamples(ins);
      if (verbose) {
        throw new NotImplementedError("Verbose predictLoop() is not implemented yet.");
      }
      const batches = makeBatches(numSamples, batchSize);
      const outsBatches = this.outputs.map((output2) => []);
      for (let batchIndex = 0; batchIndex < batches.length; ++batchIndex) {
        const batchOuts = tidy(() => {
          const batchStart = batches[batchIndex][0];
          const batchEnd = batches[batchIndex][1];
          const insBatch = sliceArrays(ins, batchStart, batchEnd);
          const feeds = [];
          if (Array.isArray(insBatch)) {
            for (let i2 = 0; i2 < insBatch.length; ++i2) {
              feeds.push({ key: this.inputs[i2], value: insBatch[i2] });
            }
          } else {
            feeds.push({ key: this.inputs[0], value: insBatch });
          }
          const feedDict = new FeedDict(feeds);
          return execute(this.outputs, feedDict);
        });
        batchOuts.forEach((batchOut, i2) => outsBatches[i2].push(batchOut));
      }
      return singletonOrArray(outsBatches.map((batches2) => concat$3(batches2, 0)));
    });
  }
  predict(x2, args = {}) {
    const xsRank2OrHigher = ensureTensorsRank2OrHigher(x2);
    checkInputData(xsRank2OrHigher, this.inputNames, this.feedInputShapes, false);
    try {
      const batchSize = args.batchSize == null ? 32 : args.batchSize;
      checkBatchSize(batchSize);
      return this.predictLoop(xsRank2OrHigher, batchSize);
    } finally {
      disposeNewTensors(xsRank2OrHigher, x2);
    }
  }
  predictOnBatch(x2) {
    checkInputData(x2, this.inputNames, this.feedInputShapes, true);
    const batchSize = (Array.isArray(x2) ? x2[0] : x2).shape[0];
    return this.predictLoop(x2, batchSize);
  }
  standardizeUserDataXY(x2, y2, checkBatchAxis = true, batchSize) {
    if (this.optimizer_ == null) {
      throw new RuntimeError("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
    }
    const outputShapes = [];
    for (let i2 = 0; i2 < this.feedOutputShapes.length; ++i2) {
      const outputShape = this.feedOutputShapes[i2];
      const lossFn = this.feedLossFns[i2];
      if (lossFn === sparseCategoricalCrossentropy$1) {
        outputShapes.push(outputShape.slice(0, outputShape.length - 1).concat([1]));
      } else {
        outputShapes.push(outputShape);
      }
    }
    x2 = standardizeInputData(x2, this.feedInputNames, this.feedInputShapes, false, "input");
    y2 = standardizeInputData(y2, this.feedOutputNames, outputShapes, false, "target");
    checkArrayLengths(x2, y2);
    checkLossAndTargetCompatibility(y2, this.feedLossFns, this.feedOutputShapes);
    if (this.stateful && batchSize != null && batchSize > 0) {
      if (x2[0].shape[0] % batchSize !== 0) {
        throw new ValueError(`In a stateful network, you should only pass inputs with a number of samples that is divisible by the batch size ${batchSize}. Found: ${x2[0].shape[0]} sample(s).`);
      }
    }
    return [x2, y2];
  }
  async standardizeUserData(x2, y2, sampleWeight, classWeight, checkBatchAxis = true, batchSize) {
    const [standardXs, standardYs] = this.standardizeUserDataXY(x2, y2, checkBatchAxis, batchSize);
    if (sampleWeight != null) {
      throw new Error("sample weight is not supported yet.");
    }
    let standardSampleWeights = null;
    if (classWeight != null) {
      const classWeights = standardizeClassWeights(classWeight, this.outputNames);
      standardSampleWeights = [];
      for (let i2 = 0; i2 < classWeights.length; ++i2) {
        standardSampleWeights.push(await standardizeWeights(standardYs[i2], null, classWeights[i2]));
      }
    }
    return [standardXs, standardYs, standardSampleWeights];
  }
  testLoop(f2, ins, batchSize, verbose = 0, steps2) {
    return tidy(() => {
      const numSamples = this.checkNumSamples(ins, batchSize, steps2, "steps");
      const outs = [];
      if (verbose > 0) {
        throw new NotImplementedError("Verbose mode is not implemented yet.");
      }
      if (steps2 != null) {
        throw new NotImplementedError("steps mode in testLoop() is not implemented yet");
      } else {
        const batches = makeBatches(numSamples, batchSize);
        const indexArray = tensor1d(range$3(0, numSamples));
        for (let batchIndex = 0; batchIndex < batches.length; ++batchIndex) {
          const batchStart = batches[batchIndex][0];
          const batchEnd = batches[batchIndex][1];
          const batchIds = sliceAlongFirstAxis(indexArray, batchStart, batchEnd - batchStart);
          const insBatch = sliceArraysByIndices(ins, batchIds);
          const batchOuts = f2(insBatch);
          if (batchIndex === 0) {
            for (let i2 = 0; i2 < batchOuts.length; ++i2) {
              outs.push(scalar(0));
            }
          }
          for (let i2 = 0; i2 < batchOuts.length; ++i2) {
            const batchOut = batchOuts[i2];
            outs[i2] = add$1(outs[i2], mul(batchEnd - batchStart, batchOut));
          }
        }
        for (let i2 = 0; i2 < outs.length; ++i2) {
          outs[i2] = div$1(outs[i2], numSamples);
        }
      }
      return outs;
    });
  }
  getDedupedMetricsNames() {
    const outLabels = this.metricsNames;
    const dedupedOutLabels = [];
    for (let i2 = 0; i2 < outLabels.length; ++i2) {
      const label = outLabels[i2];
      let newLabel = label;
      if (count(outLabels, label) > 1) {
        const dupIndex = count(outLabels.slice(0, i2), label);
        newLabel += `_${dupIndex}`;
      }
      dedupedOutLabels.push(newLabel);
    }
    return dedupedOutLabels;
  }
  makeTrainFunction() {
    return (data2) => {
      const lossValues = [];
      const inputs = data2.slice(0, this.inputs.length);
      const targets = data2.slice(this.inputs.length, this.inputs.length + this.outputs.length);
      const sampleWeights = data2.slice(this.inputs.length + this.outputs.length, this.inputs.length + this.outputs.length * 2);
      const metricsValues = [];
      const totalLossFunction = () => {
        const feeds = [];
        for (let i2 = 0; i2 < this.inputs.length; ++i2) {
          feeds.push({ key: this.inputs[i2], value: inputs[i2] });
        }
        const feedDict = new FeedDict(feeds);
        const outputs = execute(this.outputs, feedDict, { "training": true });
        let totalLoss;
        for (let i2 = 0; i2 < this.lossFunctions.length; ++i2) {
          const lossFunction = this.lossFunctions[i2];
          let loss = lossFunction(targets[i2], outputs[i2]);
          if (sampleWeights[i2] != null) {
            loss = computeWeightedLoss(loss, sampleWeights[i2]);
          }
          const meanLoss = mean$2(loss);
          lossValues.push(meanLoss);
          if (i2 === 0) {
            totalLoss = loss;
          } else {
            totalLoss = add$1(totalLoss, loss);
          }
        }
        for (let i2 = 0; i2 < this.metricsTensors.length; ++i2) {
          let weightedMetric;
          if (this.outputs.length > 1 && i2 < this.outputs.length) {
            weightedMetric = lossValues[i2];
          } else {
            const metric = this.metricsTensors[i2][0];
            const outputIndex = this.metricsTensors[i2][1];
            weightedMetric = mean$2(metric(targets[outputIndex], outputs[outputIndex]));
          }
          keep(weightedMetric);
          metricsValues.push(weightedMetric);
        }
        totalLoss = mean$2(totalLoss);
        this.calculateLosses().forEach((regularizerLoss) => {
          totalLoss = add$1(totalLoss, regularizerLoss);
        });
        return totalLoss;
      };
      const variables = this.collectedTrainableWeights.map((param) => param.read());
      const returnCost = true;
      const totalLossValue = this.optimizer_.minimize(totalLossFunction, returnCost, variables);
      return [totalLossValue].concat(metricsValues);
    };
  }
  makeTestFunction() {
    this.testFunction = (data2) => {
      return tidy(() => {
        const valOutputs = [];
        let totalLoss;
        const inputs = data2.slice(0, this.inputs.length);
        const targets = data2.slice(this.inputs.length, this.inputs.length + this.outputs.length);
        const feeds = [];
        for (let i2 = 0; i2 < this.inputs.length; ++i2) {
          feeds.push({ key: this.inputs[i2], value: inputs[i2] });
        }
        const feedDict = new FeedDict(feeds);
        const outputs = execute(this.outputs, feedDict);
        for (let i2 = 0; i2 < this.lossFunctions.length; ++i2) {
          const lossFunction = this.lossFunctions[i2];
          const loss = mean$2(lossFunction(targets[i2], outputs[i2]));
          if (i2 === 0) {
            totalLoss = loss;
          } else {
            totalLoss = add$1(totalLoss, loss);
          }
          valOutputs.push(totalLoss);
        }
        for (let i2 = 0; i2 < this.metricsTensors.length; ++i2) {
          const metric = this.metricsTensors[i2][0];
          const outputIndex = this.metricsTensors[i2][1];
          const meanMetric = mean$2(metric(targets[outputIndex], outputs[outputIndex]));
          valOutputs.push(meanMetric);
        }
        return valOutputs;
      });
    };
  }
  async fit(x2, y2, args = {}) {
    return fitTensors(this, x2, y2, args);
  }
  async fitDataset(dataset, args) {
    return fitDataset(this, dataset, args);
  }
  async trainOnBatch(x2, y2) {
    const standardizeOut = await this.standardizeUserData(x2, y2);
    const inputs = standardizeOut[0];
    const targets = standardizeOut[1];
    const trainFunction = this.makeTrainFunction();
    const losses = trainFunction(inputs.concat(targets));
    const lossValues = [];
    for (const loss of losses) {
      const v2 = await loss.data();
      lossValues.push(v2[0]);
    }
    dispose(losses);
    disposeNewTensors(standardizeOut[0], x2);
    disposeNewTensors(standardizeOut[1], y2);
    return singletonOrArray(lossValues);
  }
  getNamedWeights(config2) {
    const namedWeights = [];
    const trainableOnly = config2 != null && config2.trainableOnly;
    const weights = trainableOnly ? this.trainableWeights : this.weights;
    const weightValues = this.getWeights(trainableOnly);
    for (let i2 = 0; i2 < weights.length; ++i2) {
      if (trainableOnly && !weights[i2].trainable) {
        continue;
      }
      namedWeights.push({ name: weights[i2].originalName, tensor: weightValues[i2] });
    }
    return namedWeights;
  }
  set stopTraining(stop) {
    this.stopTraining_ = stop;
  }
  get stopTraining() {
    return this.stopTraining_;
  }
  get optimizer() {
    return this.optimizer_;
  }
  set optimizer(optimizer) {
    if (this.optimizer_ !== optimizer) {
      this.optimizer_ = optimizer;
      this.isOptimizerOwned = false;
    }
  }
  dispose() {
    const result2 = super.dispose();
    if (result2.refCountAfterDispose === 0 && this.optimizer != null && this.isOptimizerOwned) {
      const numTensorsBeforeOptmizerDisposal = memory().numTensors;
      this.optimizer_.dispose();
      result2.numDisposedVariables += numTensorsBeforeOptmizerDisposal - memory().numTensors;
    }
    return result2;
  }
  getLossIdentifiers() {
    let lossNames;
    if (typeof this.loss === "string") {
      lossNames = toSnakeCase(this.loss);
    } else if (Array.isArray(this.loss)) {
      for (const loss of this.loss) {
        if (typeof loss !== "string") {
          throw new Error("Serialization of non-string loss is not supported.");
        }
      }
      lossNames = this.loss.map((name) => toSnakeCase(name));
    } else {
      const outputNames = Object.keys(this.loss);
      lossNames = {};
      const losses = this.loss;
      for (const outputName of outputNames) {
        if (typeof losses[outputName] === "string") {
          lossNames[outputName] = toSnakeCase(losses[outputName]);
        } else {
          throw new Error("Serialization of non-string loss is not supported.");
        }
      }
    }
    return lossNames;
  }
  getMetricIdentifiers() {
    if (typeof this.metrics === "string" || typeof this.metrics === "function") {
      return [toSnakeCase(getLossOrMetricName(this.metrics))];
    } else if (Array.isArray(this.metrics)) {
      return this.metrics.map((metric) => toSnakeCase(getLossOrMetricName(metric)));
    } else {
      const metricsIdentifiers = {};
      for (const key in this.metrics) {
        metricsIdentifiers[key] = toSnakeCase(getLossOrMetricName(this.metrics[key]));
      }
      return metricsIdentifiers;
    }
  }
  getTrainingConfig() {
    return {
      loss: this.getLossIdentifiers(),
      metrics: this.getMetricIdentifiers(),
      optimizer_config: {
        class_name: this.optimizer.getClassName(),
        config: this.optimizer.getConfig()
      }
    };
  }
  loadTrainingConfig(trainingConfig) {
    if (trainingConfig.weighted_metrics != null) {
      throw new Error("Loading weight_metrics is not supported yet.");
    }
    if (trainingConfig.loss_weights != null) {
      throw new Error("Loading loss_weights is not supported yet.");
    }
    if (trainingConfig.sample_weight_mode != null) {
      throw new Error("Loading sample_weight_mode is not supported yet.");
    }
    const tsConfig = convertPythonicToTs(trainingConfig.optimizer_config);
    const optimizer = deserialize(tsConfig);
    let loss;
    if (typeof trainingConfig.loss === "string") {
      loss = toCamelCase(trainingConfig.loss);
    } else if (Array.isArray(trainingConfig.loss)) {
      loss = trainingConfig.loss.map((lossEntry) => toCamelCase(lossEntry));
    } else if (trainingConfig.loss != null) {
      loss = {};
      for (const key in trainingConfig.loss) {
        loss[key] = toCamelCase(trainingConfig.loss[key]);
      }
    }
    let metrics;
    if (Array.isArray(trainingConfig.metrics)) {
      metrics = trainingConfig.metrics.map((metric) => toCamelCase(metric));
    } else if (trainingConfig.metrics != null) {
      metrics = {};
      for (const key in trainingConfig.metrics) {
        metrics[key] = toCamelCase(trainingConfig.metrics[key]);
      }
    }
    this.compile({ loss, metrics, optimizer });
  }
  async save(handlerOrURL, config2) {
    if (typeof handlerOrURL === "string") {
      const handlers = getSaveHandlers(handlerOrURL);
      if (handlers.length === 0) {
        throw new ValueError(`Cannot find any save handlers for URL '${handlerOrURL}'`);
      } else if (handlers.length > 1) {
        throw new ValueError(`Found more than one (${handlers.length}) save handlers for URL '${handlerOrURL}'`);
      }
      handlerOrURL = handlers[0];
    }
    if (handlerOrURL.save == null) {
      throw new ValueError("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
    }
    const weightDataAndSpecs = await encodeWeights(this.getNamedWeights(config2));
    const returnString = false;
    const unusedArg = null;
    const modelConfig = this.toJSON(unusedArg, returnString);
    const modelArtifacts = {
      modelTopology: modelConfig,
      format: LAYERS_MODEL_FORMAT_NAME,
      generatedBy: `TensorFlow.js tfjs-layers v${version$5}`,
      convertedBy: null
    };
    const includeOptimizer = config2 == null ? false : config2.includeOptimizer;
    if (includeOptimizer && this.optimizer != null) {
      modelArtifacts.trainingConfig = this.getTrainingConfig();
      const weightType = "optimizer";
      const { data: optimizerWeightData, specs: optimizerWeightSpecs } = await encodeWeights(await this.optimizer.getWeights(), weightType);
      weightDataAndSpecs.specs.push(...optimizerWeightSpecs);
      weightDataAndSpecs.data = concatenateArrayBuffers([weightDataAndSpecs.data, optimizerWeightData]);
    }
    if (this.userDefinedMetadata != null) {
      const checkSize = true;
      checkUserDefinedMetadata(this.userDefinedMetadata, this.name, checkSize);
      modelArtifacts.userDefinedMetadata = this.userDefinedMetadata;
    }
    modelArtifacts.weightData = weightDataAndSpecs.data;
    modelArtifacts.weightSpecs = weightDataAndSpecs.specs;
    return handlerOrURL.save(modelArtifacts);
  }
  setUserDefinedMetadata(userDefinedMetadata) {
    checkUserDefinedMetadata(userDefinedMetadata, this.name);
    this.userDefinedMetadata = userDefinedMetadata;
  }
  getUserDefinedMetadata() {
    return this.userDefinedMetadata;
  }
}
LayersModel.className = "Model";
registerClass(LayersModel);
class Functional extends LayersModel {
}
Functional.className = "Functional";
registerClass(Functional);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Sequential extends LayersModel {
  constructor(args) {
    super({ inputs: [], outputs: [] });
    args = args || {};
    this.trainable = true;
    this.built = false;
    this.name = args.name != null ? args.name : getUid("sequential_");
    if (args.layers != null) {
      for (const layer of args.layers) {
        this.add(layer);
      }
    }
  }
  checkShape(layer) {
    const shape = layer.inboundNodes[0].outputTensors[0].shape;
    if (shape.some((x2) => x2 < 0)) {
      throw new ValueError(`Negative dimension size caused by adding layer ${layer.name} with input shape [${layer.inboundNodes[0].inputTensors[0].shape}]`);
    }
  }
  add(layer) {
    const isLayerModelInstance = layer instanceof Sequential || layer instanceof LayersModel;
    let modelLayer;
    if (isLayerModelInstance) {
      modelLayer = layer;
      if (modelLayer.outputs.length !== 1) {
        throw new ValueError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
      }
      if (modelLayer.inputs.length !== 1) {
        throw new ValueError("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
      }
    }
    if (this.outputs.length === 0) {
      if (layer.inboundNodes.length === 0) {
        if (layer.batchInputShape == null) {
          throw new ValueError("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
        }
        const x2 = Input$4({
          batchShape: layer.batchInputShape,
          dtype: layer.dtype,
          name: layer.name + "_input"
        });
        layer.apply(x2);
      }
      if (isLayerModelInstance) {
        this.outputs = modelLayer.outputs;
        this.inputs = modelLayer.inputs;
      } else {
        if (layer.inboundNodes.length !== 1) {
          throw new ValueError(`A layer added to a Sequential model must not already be connected somewhere else. LayersModel received layer ${layer.name} which has ${layer.inboundNodes.length} pre-existing inbound connections.`);
        }
        if (layer.inboundNodes[0].outputTensors.length !== 1) {
          throw new ValueError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
        }
        this.checkShape(layer);
        this.outputs = [layer.inboundNodes[0].outputTensors[0]];
        this.inputs = getSourceInputs(this.outputs[0]);
      }
      this.inboundNodes = [];
      new Node$1({
        outboundLayer: this,
        inboundLayers: [],
        nodeIndices: [],
        tensorIndices: [],
        inputTensors: this.inputs,
        outputTensors: this.outputs,
        inputMasks: pyListRepeat(null, this.inputs.length),
        outputMasks: [null],
        inputShapes: this.inputs.map((x2) => x2.shape),
        outputShapes: this.outputs[0].shape
      });
    } else {
      const outputTensor = layer.apply(this.outputs[0]);
      if (Array.isArray(outputTensor)) {
        throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
      }
      this.checkShape(layer);
      this.outputs = [outputTensor];
      this.inboundNodes[0].outputTensors = this.outputs;
      this.inboundNodes[0].outputShapes = [this.outputs[0].shape];
    }
    this.layers.push(layer);
    this.built = false;
  }
  pop() {
    if (this.layers.length === 0) {
      throw new TypeError("There are no layers in the model.");
    }
    this.layers.pop();
    if (this.layers.length === 0) {
      this.outputs = [];
      this.inboundNodes = [];
      this.outboundNodes = [];
    } else {
      const lastLayerIndex = this.layers.length - 1;
      this.layers[lastLayerIndex].outboundNodes = [];
      this.outputs = [this.layers[lastLayerIndex].output];
      this.inboundNodes[0].outputTensors = this.outputs;
      this.inboundNodes[0].outputShapes = [this.outputs[0].shape];
    }
  }
  call(inputs, kwargs) {
    if (this.model == null) {
      this.build();
    }
    return this.model.call(inputs, kwargs);
  }
  build(inputShape) {
    getExactlyOneShape(inputShape);
    if (this.inputs.length === 0 || this.outputs.length === 0) {
      throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
    }
    this.model = new LayersModel({
      inputs: this.inputs,
      outputs: this.outputs[0],
      name: this.name + "_model"
    });
    this.model.trainable = this.trainable;
    this.supportsMasking = this.model.supportsMasking;
    this.inputLayers = this.model.inputLayers;
    this.inputLayersNodeIndices = this.model.inputLayersNodeIndices;
    this.inputLayersTensorIndices = this.model.inputLayersTensorIndices;
    this.outputLayers = this.model.outputLayers;
    this.outputLayersNodeIndices = this.model.outputLayersNodeIndices;
    this.outputLayersTensorIndices = this.model.outputLayersTensorIndices;
    this.nodesByDepth = this.model.nodesByDepth;
    this.containerNodes = this.model.containerNodes;
    this.outputNames = this.model.outputNames;
    this.inputNames = this.model.inputNames;
    this.built = true;
  }
  countParams() {
    if (!this.built) {
      this.build();
    }
    return super.countParams();
  }
  summary(lineLength, positions, printFn = console.log) {
    if (!this.built) {
      this.build();
    }
    super.summary(lineLength, positions, printFn);
  }
  setWeights(weights) {
    if (this.model == null) {
      this.build();
    }
    this.model.setWeights(weights);
  }
  evaluate(x2, y2, args = {}) {
    if (!this.built) {
      throw new RuntimeError("The model needs to be compiled before being used.");
    }
    return this.model.evaluate(x2, y2, args);
  }
  async evaluateDataset(dataset, args) {
    if (!this.built) {
      throw new RuntimeError("The model needs to be compiled before being used.");
    }
    return this.model.evaluateDataset(dataset, args);
  }
  predict(x2, args = {}) {
    if (this.model == null) {
      this.build();
    }
    return this.model.predict(x2, args);
  }
  predictOnBatch(x2) {
    if (this.model == null) {
      this.build();
    }
    return this.model.predictOnBatch(x2);
  }
  compile(args) {
    this.build();
    this.model.compile(args);
    this.optimizer_ = this.model.optimizer;
    this.isOptimizerOwned = this.model.isOptimizerOwned;
    this.loss = this.model.loss;
    this.metrics = this.model.metrics;
    this.metricsTensors = this.model.metricsTensors;
    this.metricsNames = this.model.metricsNames;
  }
  get optimizer() {
    return this.model == null ? void 0 : this.model.optimizer;
  }
  set optimizer(optimizer) {
    this.model.optimizer = optimizer;
  }
  async fit(x2, y2, args = {}) {
    if (!this.built) {
      throw new RuntimeError("The model needs to be compiled before being used.");
    }
    return this.model.fit(x2, y2, args);
  }
  async fitDataset(dataset, args) {
    if (!this.built) {
      throw new RuntimeError("The model needs to be compiled before being used.");
    }
    return this.model.fitDataset(dataset, args);
  }
  async trainOnBatch(x2, y2) {
    return this.model.trainOnBatch(x2, y2);
  }
  static fromConfig(cls, config2, customObjects = {}, fastWeightInit = false) {
    let configArray;
    let extraModelConfig = {};
    if (config2 instanceof Array) {
      if (!(config2[0].className != null) || config2[0]["className"] === "Merge") {
        throw new ValueError("Legacy serialization format not supported yet.");
      }
      configArray = config2;
    } else {
      assert$1(config2["layers"] != null, () => `When the config data for a Sequential model is not an Array, it must be an Object that contains the 'layers' field.`);
      configArray = config2["layers"];
      delete config2["layers"];
      extraModelConfig = config2;
    }
    const model2 = new cls(extraModelConfig);
    if (!(model2 instanceof Sequential)) {
      throw new NotImplementedError(`Sequential.fromConfig called on non-Sequential input: ${model2}`);
    }
    for (const conf of configArray) {
      const customObjects2 = void 0;
      const layer = deserialize(conf, customObjects2, fastWeightInit);
      if (fastWeightInit) {
        layer.setFastWeightInitDuringBuild(true);
      }
      model2.add(layer);
    }
    return model2;
  }
  set stopTraining(stop) {
    if (this.model == null) {
      throw new ValueError("Cannot set the stopTraining property of a sequential model before it is compiled.");
    }
    this.model.stopTraining = stop;
  }
  get stopTraining() {
    if (this.model == null) {
      throw new ValueError("Cannot get the stopTraining property of a sequential model before it is compiled.");
    }
    return this.model.stopTraining;
  }
  getConfig() {
    const layers = [];
    for (const layer of this.layers) {
      const dict = {};
      dict["className"] = layer.getClassName();
      dict["config"] = layer.getConfig();
      layers.push(dict);
    }
    return { name: this.name, layers };
  }
}
Sequential.className = "Sequential";
registerClass(Sequential);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Activation$1 extends Serializable {
  getConfig() {
    return {};
  }
}
class Elu extends Activation$1 {
  apply(x2, alpha2 = 1) {
    return elu$2(x2, alpha2);
  }
}
Elu.className = "elu";
registerClass(Elu);
class Selu extends Activation$1 {
  apply(x2) {
    return selu$2(x2);
  }
}
Selu.className = "selu";
registerClass(Selu);
class Relu extends Activation$1 {
  apply(x2) {
    return relu$2(x2);
  }
}
Relu.className = "relu";
registerClass(Relu);
class Relu6 extends Activation$1 {
  apply(x2) {
    return tidy(() => minimum$2(6, relu$2(x2)));
  }
}
Relu6.className = "relu6";
registerClass(Relu6);
class Linear extends Activation$1 {
  apply(x2) {
    return x2;
  }
}
Linear.className = "linear";
registerClass(Linear);
class Sigmoid extends Activation$1 {
  apply(x2) {
    return sigmoid$3(x2);
  }
}
Sigmoid.className = "sigmoid";
registerClass(Sigmoid);
class HardSigmoid extends Activation$1 {
  apply(x2) {
    return hardSigmoid(x2);
  }
}
HardSigmoid.className = "hardSigmoid";
registerClass(HardSigmoid);
class Softplus extends Activation$1 {
  apply(x2) {
    return softplus$2(x2);
  }
}
Softplus.className = "softplus";
registerClass(Softplus);
class Softsign extends Activation$1 {
  apply(x2) {
    return softsign(x2);
  }
}
Softsign.className = "softsign";
registerClass(Softsign);
class Tanh extends Activation$1 {
  apply(x2) {
    return tanh$2(x2);
  }
}
Tanh.className = "tanh";
registerClass(Tanh);
class Softmax$1 extends Activation$1 {
  apply(x2, axis = -1) {
    return softmax$3(x2, axis);
  }
}
Softmax$1.className = "softmax";
registerClass(Softmax$1);
class LogSoftmax extends Activation$1 {
  apply(x2, axis = -1) {
    return logSoftmax(x2, axis);
  }
}
LogSoftmax.className = "logSoftmax";
registerClass(LogSoftmax);
class Swish extends Activation$1 {
  apply(x2, alpha2 = 1) {
    return tidy(() => mul(sigmoid$3(mul(x2, alpha2)), x2));
  }
}
Swish.className = "swish";
registerClass(Swish);
class Mish extends Activation$1 {
  apply(x2) {
    return tidy(() => mul(x2, tanh$2(softplus$2(x2))));
  }
}
Mish.className = "mish";
registerClass(Mish);
function serializeActivation(activation) {
  return activation.getClassName();
}
function deserializeActivation(config2, customObjects = {}) {
  return deserializeKerasObject(config2, SerializationMap.getMap().classNameMap, customObjects, "activation");
}
function getActivation(identifier) {
  if (identifier == null) {
    const config2 = {};
    config2["className"] = "linear";
    config2["config"] = {};
    return deserializeActivation(config2);
  }
  if (typeof identifier === "string") {
    const config2 = {};
    config2["className"] = identifier;
    config2["config"] = {};
    return deserializeActivation(config2);
  } else if (identifier instanceof Activation$1) {
    return identifier;
  } else {
    return deserializeActivation(identifier);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function assertObjectArgs(args) {
  if (args != null && typeof args !== "object") {
    throw new Error(`Argument to L1L2 regularizer's constructor is expected to be an object, but received: ${args}`);
  }
}
class Regularizer extends Serializable {
}
class L1L2 extends Regularizer {
  constructor(args) {
    super();
    assertObjectArgs(args);
    this.l1 = args == null || args.l1 == null ? 0.01 : args.l1;
    this.l2 = args == null || args.l2 == null ? 0.01 : args.l2;
    this.hasL1 = this.l1 !== 0;
    this.hasL2 = this.l2 !== 0;
  }
  apply(x2) {
    return tidy(() => {
      let regularization = zeros$1([1]);
      if (this.hasL1) {
        regularization = add$1(regularization, sum$3(mul(this.l1, abs$2(x2))));
      }
      if (this.hasL2) {
        regularization = add$1(regularization, sum$3(mul(this.l2, square$1(x2))));
      }
      return reshape$3(regularization, []);
    });
  }
  getConfig() {
    return { "l1": this.l1, "l2": this.l2 };
  }
  static fromConfig(cls, config2) {
    return new cls({ l1: config2["l1"], l2: config2["l2"] });
  }
}
L1L2.className = "L1L2";
registerClass(L1L2);
const REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP = {
  "l1l2": "L1L2"
};
function serializeRegularizer(constraint) {
  return serializeKerasObject(constraint);
}
function deserializeRegularizer(config2, customObjects = {}) {
  return deserializeKerasObject(config2, SerializationMap.getMap().classNameMap, customObjects, "regularizer");
}
function getRegularizer(identifier) {
  if (identifier == null) {
    return null;
  }
  if (typeof identifier === "string") {
    const className = identifier in REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP ? REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[identifier] : identifier;
    const config2 = { className, config: {} };
    return deserializeRegularizer(config2);
  } else if (identifier instanceof Regularizer) {
    return identifier;
  } else {
    return deserializeRegularizer(identifier);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class ReLU extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.supportsMasking = true;
    if (args != null) {
      this.maxValue = args.maxValue;
    }
  }
  call(inputs, kwargs) {
    inputs = getExactlyOneTensor(inputs);
    let output2 = relu$2(inputs);
    if (this.maxValue != null) {
      output2 = clipByValue$2(output2, 0, this.maxValue);
    }
    return output2;
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const config2 = { maxValue: this.maxValue };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
ReLU.className = "ReLU";
registerClass(ReLU);
class LeakyReLU extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.DEFAULT_ALPHA = 0.3;
    if (args == null) {
      args = {};
    }
    this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
  }
  call(inputs, kwargs) {
    const x2 = getExactlyOneTensor(inputs);
    return leakyRelu$3(x2, this.alpha);
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const config2 = { alpha: this.alpha };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
LeakyReLU.className = "LeakyReLU";
registerClass(LeakyReLU);
class PReLU extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.DEFAULT_ALPHA_INITIALIZER = "zeros";
    if (args == null) {
      args = {};
    }
    this.supportsMasking = true;
    this.alphaInitializer = getInitializer(args.alphaInitializer || this.DEFAULT_ALPHA_INITIALIZER);
    this.alphaRegularizer = getRegularizer(args.alphaRegularizer);
    this.alphaConstraint = getConstraint(args.alphaConstraint);
    if (args.sharedAxes == null) {
      this.sharedAxes = null;
    } else if (Array.isArray(args.sharedAxes)) {
      this.sharedAxes = args.sharedAxes;
    } else if (typeof args.sharedAxes === "number") {
      this.sharedAxes = [args.sharedAxes];
    } else {
      throw new ValueError(`Expected sharedAxes to be a number or an array of numbers, but got ${args.sharedAxes}`);
    }
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const paramShape = inputShape.slice(1);
    if (this.sharedAxes != null) {
      for (const i2 of this.sharedAxes) {
        paramShape[i2 - 1] = 1;
      }
    }
    this.alpha = this.addWeight("alpha", paramShape, "float32", this.alphaInitializer, this.alphaRegularizer, true, this.alphaConstraint);
    const axes = {};
    if (this.sharedAxes != null) {
      for (let i2 = 1; i2 < inputShape.length; ++i2) {
        axes[i2] = inputShape[i2];
      }
    }
    this.inputSpec = [new InputSpec({
      ndim: inputShape.length,
      axes
    })];
    this.built = true;
  }
  call(inputs, kwargs) {
    inputs = getExactlyOneTensor(inputs);
    return prelu$3(inputs, this.alpha.read());
  }
  getConfig() {
    const config2 = {
      alphaInitializer: serializeInitializer(this.alphaInitializer),
      alphaRegularizer: serializeRegularizer(this.alphaRegularizer),
      alphaConstraint: serializeConstraint(this.alphaConstraint),
      sharedAxes: this.sharedAxes
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
PReLU.className = "PReLU";
registerClass(PReLU);
class ELU$3 extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.DEFAULT_ALPHA = 1;
    if (args == null) {
      args = {};
    }
    if (args.alpha != null && args.alpha !== this.DEFAULT_ALPHA) {
      throw new NotImplementedError(`Non-default alpha value (${args.alpha}) is not supported by the ELU layer yet.`);
    }
    this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
  }
  call(inputs, kwargs) {
    const x2 = getExactlyOneTensor(inputs);
    return elu$3(x2);
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const config2 = { alpha: this.alpha };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
ELU$3.className = "ELU";
registerClass(ELU$3);
class ThresholdedReLU extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.DEFAULT_THETA = 1;
    if (args == null) {
      args = {};
    }
    this.theta = args.theta == null ? this.DEFAULT_THETA : args.theta;
  }
  call(inputs, kwargs) {
    const x2 = getExactlyOneTensor(inputs);
    return mul(x2, cast$4(greater$2(x2, this.theta), "float32"));
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const config2 = { theta: this.theta };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
ThresholdedReLU.className = "ThresholdedReLU";
registerClass(ThresholdedReLU);
class Softmax extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.DEFAULT_AXIS = 1;
    if (args == null) {
      args = {};
    }
    this.softmax = new Softmax$1().apply;
    this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
  }
  call(inputs, kwargs) {
    const x2 = getExactlyOneTensor(inputs);
    return this.softmax(x2, this.axis);
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const config2 = { axis: this.axis };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Softmax.className = "Softmax";
registerClass(Softmax);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function normalizeArray(value, n2, name) {
  if (typeof value === "number") {
    return pyListRepeat(value, n2);
  } else {
    if (value.length !== n2) {
      throw new ValueError(`The ${name} argument must be an integer or tuple of ${n2} integers. Received: ${value.length} elements.`);
    }
    for (let i2 = 0; i2 < n2; ++i2) {
      const singleValue = value[i2];
      if (!isInteger(singleValue)) {
        throw new ValueError(`The ${name} argument must be an integer or tuple of ${n2} integers. Received: ${JSON.stringify(value)} including a non-integer number ${singleValue}`);
      }
    }
    return value;
  }
}
function convOutputLength(inputLength, filterSize, padding, stride, dilation = 1) {
  if (inputLength == null) {
    return inputLength;
  }
  const dilatedFilterSize = filterSize + (filterSize - 1) * (dilation - 1);
  let outputLength;
  if (padding === "same") {
    outputLength = inputLength;
  } else {
    outputLength = inputLength - dilatedFilterSize + 1;
  }
  return Math.floor((outputLength + stride - 1) / stride);
}
function deconvLength(dimSize, strideSize, kernelSize, padding) {
  if (dimSize == null) {
    return null;
  }
  if (padding === "valid") {
    dimSize = dimSize * strideSize + max$3([kernelSize - strideSize, 0]);
  } else if (padding === "same") {
    dimSize = dimSize * strideSize;
  } else {
    throw new ValueError(`Unsupport padding mode: ${padding}.`);
  }
  return dimSize;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function preprocessConv2DInput(x2, dataFormat) {
  return tidy(() => {
    checkDataFormat(dataFormat);
    if (dataFormat === "channelsFirst") {
      return transpose$3(x2, [0, 2, 3, 1]);
    } else {
      return x2;
    }
  });
}
function preprocessConv3DInput(x2, dataFormat) {
  return tidy(() => {
    checkDataFormat(dataFormat);
    if (dataFormat === "channelsFirst") {
      return transpose$3(x2, [0, 2, 3, 4, 1]);
    } else {
      return x2;
    }
  });
}
function conv1dWithBias(x2, kernel, bias, strides = 1, padding = "valid", dataFormat, dilationRate = 1) {
  return tidy(() => {
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    checkDataFormat(dataFormat);
    if (x2.shape.length !== 3) {
      throw new ValueError(`The input of a conv1dWithBias operation should be 3, but is ${x2.shape.length} instead.`);
    }
    if (kernel.shape.length !== 3) {
      throw new ValueError(`The kernel for a conv1dWithBias operation should be 3, but is ${kernel.shape.length} instead`);
    }
    if (bias != null && bias.shape.length !== 1) {
      throw new ValueError(`The bias for a conv1dWithBias operation should be 1, but is ${kernel.shape.length} instead`);
    }
    if (dataFormat === "channelsFirst") {
      x2 = transpose$3(x2, [0, 2, 1]);
    }
    if (padding === "causal") {
      throw new NotImplementedError("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
    }
    let y2 = conv1d(x2, kernel, strides, padding === "same" ? "same" : "valid", "NWC", dilationRate);
    if (bias != null) {
      y2 = biasAdd(y2, bias);
    }
    return y2;
  });
}
function conv2dWithBiasActivation(x2, kernel, bias, strides = [1, 1], padding = "valid", dataFormat, dilationRate, activation = null) {
  return tidy(() => {
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    checkDataFormat(dataFormat);
    if (x2.rank !== 3 && x2.rank !== 4) {
      throw new ValueError(`conv2dWithBiasActivation expects input to be of rank 3 or 4, but received ${x2.rank}.`);
    }
    if (kernel.rank !== 3 && kernel.rank !== 4) {
      throw new ValueError(`conv2dWithBiasActivation expects kernel to be of rank 3 or 4, but received ${x2.rank}.`);
    }
    let y2 = preprocessConv2DInput(x2, dataFormat);
    if (padding === "causal") {
      throw new NotImplementedError("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
    }
    y2 = conv2d$2({
      x: y2,
      filter: kernel,
      strides,
      pad: padding === "same" ? "same" : "valid",
      dilations: dilationRate,
      dataFormat: "NHWC",
      bias,
      activation
    });
    if (dataFormat === "channelsFirst") {
      y2 = transpose$3(y2, [0, 3, 1, 2]);
    }
    return y2;
  });
}
function conv3dWithBias(x2, kernel, bias, strides = [1, 1, 1], padding = "valid", dataFormat, dilationRate) {
  return tidy(() => {
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    checkDataFormat(dataFormat);
    if (x2.rank !== 4 && x2.rank !== 5) {
      throw new ValueError(`conv3dWithBias expects input to be of rank 4 or 5, but received ${x2.rank}.`);
    }
    if (kernel.rank !== 4 && kernel.rank !== 5) {
      throw new ValueError(`conv3dWithBias expects kernel to be of rank 4 or 5, but received ${x2.rank}.`);
    }
    let y2 = preprocessConv3DInput(x2, dataFormat);
    if (padding === "causal") {
      throw new NotImplementedError("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
    }
    y2 = conv3d(y2, kernel, strides, padding === "same" ? "same" : "valid", "NDHWC", dilationRate);
    if (bias != null) {
      y2 = biasAdd(y2, bias);
    }
    if (dataFormat === "channelsFirst") {
      y2 = transpose$3(y2, [0, 4, 1, 2, 3]);
    }
    return y2;
  });
}
class BaseConv extends Layer {
  constructor(rank, args) {
    super(args);
    this.bias = null;
    this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal";
    this.DEFAULT_BIAS_INITIALIZER = "zeros";
    BaseConv.verifyArgs(args);
    this.rank = rank;
    assertPositiveInteger(this.rank, "rank");
    if (this.rank !== 1 && this.rank !== 2 && this.rank !== 3) {
      throw new NotImplementedError(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is not implemented yet.`);
    }
    this.kernelSize = normalizeArray(args.kernelSize, rank, "kernelSize");
    this.strides = normalizeArray(args.strides == null ? 1 : args.strides, rank, "strides");
    this.padding = args.padding == null ? "valid" : args.padding;
    checkPaddingMode(this.padding);
    this.dataFormat = args.dataFormat == null ? "channelsLast" : args.dataFormat;
    checkDataFormat(this.dataFormat);
    this.activation = getActivation(args.activation);
    this.useBias = args.useBias == null ? true : args.useBias;
    this.biasInitializer = getInitializer(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
    this.biasConstraint = getConstraint(args.biasConstraint);
    this.biasRegularizer = getRegularizer(args.biasRegularizer);
    this.activityRegularizer = getRegularizer(args.activityRegularizer);
    this.dilationRate = normalizeArray(args.dilationRate == null ? 1 : args.dilationRate, rank, "dilationRate");
    if (this.rank === 1 && (Array.isArray(this.dilationRate) && this.dilationRate.length !== 1)) {
      throw new ValueError(`dilationRate must be a number or an array of a single number for 1D convolution, but received ${JSON.stringify(this.dilationRate)}`);
    } else if (this.rank === 2) {
      if (typeof this.dilationRate === "number") {
        this.dilationRate = [this.dilationRate, this.dilationRate];
      } else if (this.dilationRate.length !== 2) {
        throw new ValueError(`dilationRate must be a number or array of two numbers for 2D convolution, but received ${JSON.stringify(this.dilationRate)}`);
      }
    } else if (this.rank === 3) {
      if (typeof this.dilationRate === "number") {
        this.dilationRate = [this.dilationRate, this.dilationRate, this.dilationRate];
      } else if (this.dilationRate.length !== 3) {
        throw new ValueError(`dilationRate must be a number or array of three numbers for 3D convolution, but received ${JSON.stringify(this.dilationRate)}`);
      }
    }
  }
  static verifyArgs(args) {
    assert("kernelSize" in args, `required key 'kernelSize' not in config`);
    if (typeof args.kernelSize !== "number" && !checkArrayTypeAndLength(args.kernelSize, "number", 1, 3)) {
      throw new ValueError(`BaseConv expects config.kernelSize to be number or number[] with length 1, 2, or 3, but received ${JSON.stringify(args.kernelSize)}.`);
    }
  }
  getConfig() {
    const config2 = {
      kernelSize: this.kernelSize,
      strides: this.strides,
      padding: this.padding,
      dataFormat: this.dataFormat,
      dilationRate: this.dilationRate,
      activation: serializeActivation(this.activation),
      useBias: this.useBias,
      biasInitializer: serializeInitializer(this.biasInitializer),
      biasRegularizer: serializeRegularizer(this.biasRegularizer),
      activityRegularizer: serializeRegularizer(this.activityRegularizer),
      biasConstraint: serializeConstraint(this.biasConstraint)
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
class Conv extends BaseConv {
  constructor(rank, args) {
    super(rank, args);
    this.kernel = null;
    Conv.verifyArgs(args);
    this.filters = args.filters;
    assertPositiveInteger(this.filters, "filters");
    this.kernelInitializer = getInitializer(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
    this.kernelConstraint = getConstraint(args.kernelConstraint);
    this.kernelRegularizer = getRegularizer(args.kernelRegularizer);
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const channelAxis = this.dataFormat === "channelsFirst" ? 1 : inputShape.length - 1;
    if (inputShape[channelAxis] == null) {
      throw new ValueError(`The channel dimension of the input should be defined. Found ${inputShape[channelAxis]}`);
    }
    const inputDim = inputShape[channelAxis];
    const kernelShape = this.kernelSize.concat([inputDim, this.filters]);
    this.kernel = this.addWeight("kernel", kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [this.filters], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    }
    this.inputSpec = [{ ndim: this.rank + 2, axes: { [channelAxis]: inputDim } }];
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = getExactlyOneTensor(inputs);
      let outputs;
      const biasValue = this.bias == null ? null : this.bias.read();
      const fusedActivationName = mapActivationToFusedKernel(this.activation.getClassName());
      if (fusedActivationName != null && this.rank === 2) {
        outputs = conv2dWithBiasActivation(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate, fusedActivationName);
      } else {
        if (this.rank === 1) {
          outputs = conv1dWithBias(inputs, this.kernel.read(), biasValue, this.strides[0], this.padding, this.dataFormat, this.dilationRate[0]);
        } else if (this.rank === 2) {
          outputs = conv2dWithBiasActivation(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
        } else if (this.rank === 3) {
          outputs = conv3dWithBias(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
        } else {
          throw new NotImplementedError("convolutions greater than 3D are not implemented yet.");
        }
        if (this.activation != null) {
          outputs = this.activation.apply(outputs);
        }
      }
      return outputs;
    });
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const newSpace = [];
    const space = this.dataFormat === "channelsLast" ? inputShape.slice(1, inputShape.length - 1) : inputShape.slice(2);
    for (let i2 = 0; i2 < space.length; ++i2) {
      const newDim = convOutputLength(space[i2], this.kernelSize[i2], this.padding, this.strides[i2], typeof this.dilationRate === "number" ? this.dilationRate : this.dilationRate[i2]);
      newSpace.push(newDim);
    }
    let outputShape = [inputShape[0]];
    if (this.dataFormat === "channelsLast") {
      outputShape = outputShape.concat(newSpace);
      outputShape.push(this.filters);
    } else {
      outputShape.push(this.filters);
      outputShape = outputShape.concat(newSpace);
    }
    return outputShape;
  }
  getConfig() {
    const config2 = {
      filters: this.filters,
      kernelInitializer: serializeInitializer(this.kernelInitializer),
      kernelRegularizer: serializeRegularizer(this.kernelRegularizer),
      kernelConstraint: serializeConstraint(this.kernelConstraint)
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
  static verifyArgs(args) {
    if (!("filters" in args) || typeof args.filters !== "number" || args.filters < 1) {
      throw new ValueError(`Convolution layer expected config.filters to be a 'number' > 0 but got ${JSON.stringify(args.filters)}`);
    }
  }
}
class Conv2D extends Conv {
  constructor(args) {
    super(2, args);
    Conv2D.verifyArgs(args);
  }
  getConfig() {
    const config2 = super.getConfig();
    delete config2["rank"];
    return config2;
  }
  static verifyArgs(args) {
    if (typeof args.kernelSize !== "number" && !checkArrayTypeAndLength(args.kernelSize, "number", 1, 2)) {
      throw new ValueError(`Conv2D expects config.kernelSize to be number or number[] with length 1 or 2, but received ${JSON.stringify(args.kernelSize)}.`);
    }
  }
}
Conv2D.className = "Conv2D";
registerClass(Conv2D);
class Conv3D extends Conv {
  constructor(args) {
    super(3, args);
    Conv3D.verifyArgs(args);
  }
  getConfig() {
    const config2 = super.getConfig();
    delete config2["rank"];
    return config2;
  }
  static verifyArgs(args) {
    if (typeof args.kernelSize !== "number") {
      if (!(Array.isArray(args.kernelSize) && (args.kernelSize.length === 1 || args.kernelSize.length === 3))) {
        throw new ValueError(`Conv3D expects config.kernelSize to be number or [number, number, number], but received ${JSON.stringify(args.kernelSize)}.`);
      }
    }
  }
}
Conv3D.className = "Conv3D";
registerClass(Conv3D);
class Conv2DTranspose extends Conv2D {
  constructor(args) {
    super(args);
    this.inputSpec = [new InputSpec({ ndim: 4 })];
    if (this.padding !== "same" && this.padding !== "valid") {
      throw new ValueError(`Conv2DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode ${this.padding}`);
    }
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    if (inputShape.length !== 4) {
      throw new ValueError("Input should have rank 4; Received input shape: " + JSON.stringify(inputShape));
    }
    const channelAxis = this.dataFormat === "channelsFirst" ? 1 : inputShape.length - 1;
    if (inputShape[channelAxis] == null) {
      throw new ValueError("The channel dimension of the inputs should be defined. Found `None`.");
    }
    const inputDim = inputShape[channelAxis];
    const kernelShape = this.kernelSize.concat([this.filters, inputDim]);
    this.kernel = this.addWeight("kernel", kernelShape, "float32", this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    }
    this.inputSpec = [new InputSpec({ ndim: 4, axes: { [channelAxis]: inputDim } })];
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      let input = getExactlyOneTensor(inputs);
      if (input.shape.length !== 4) {
        throw new ValueError(`Conv2DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-${input.shape.length}`);
      }
      const inputShape = input.shape;
      const batchSize = inputShape[0];
      let hAxis;
      let wAxis;
      if (this.dataFormat === "channelsFirst") {
        hAxis = 2;
        wAxis = 3;
      } else {
        hAxis = 1;
        wAxis = 2;
      }
      const height2 = inputShape[hAxis];
      const width2 = inputShape[wAxis];
      const kernelH = this.kernelSize[0];
      const kernelW = this.kernelSize[1];
      const strideH = this.strides[0];
      const strideW = this.strides[1];
      const outHeight = deconvLength(height2, strideH, kernelH, this.padding);
      const outWidth = deconvLength(width2, strideW, kernelW, this.padding);
      const outputShape = [batchSize, outHeight, outWidth, this.filters];
      if (this.dataFormat !== "channelsLast") {
        input = transpose$3(input, [0, 2, 3, 1]);
      }
      let outputs = conv2dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
      if (this.dataFormat !== "channelsLast") {
        outputs = transpose$3(outputs, [0, 3, 1, 2]);
      }
      if (this.bias != null) {
        outputs = biasAdd(outputs, this.bias.read(), this.dataFormat);
      }
      if (this.activation != null) {
        outputs = this.activation.apply(outputs);
      }
      return outputs;
    });
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const outputShape = inputShape.slice();
    let channelAxis;
    let heightAxis;
    let widthAxis;
    if (this.dataFormat === "channelsFirst") {
      channelAxis = 1;
      heightAxis = 2;
      widthAxis = 3;
    } else {
      channelAxis = 3;
      heightAxis = 1;
      widthAxis = 2;
    }
    const kernelH = this.kernelSize[0];
    const kernelW = this.kernelSize[1];
    const strideH = this.strides[0];
    const strideW = this.strides[1];
    outputShape[channelAxis] = this.filters;
    outputShape[heightAxis] = deconvLength(outputShape[heightAxis], strideH, kernelH, this.padding);
    outputShape[widthAxis] = deconvLength(outputShape[widthAxis], strideW, kernelW, this.padding);
    return outputShape;
  }
  getConfig() {
    const config2 = super.getConfig();
    delete config2["dilationRate"];
    return config2;
  }
}
Conv2DTranspose.className = "Conv2DTranspose";
registerClass(Conv2DTranspose);
class Conv3DTranspose extends Conv3D {
  constructor(args) {
    super(args);
    this.inputSpec = [new InputSpec({ ndim: 5 })];
    if (this.padding !== "same" && this.padding !== "valid") {
      throw new ValueError(`Conv3DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode ${this.padding}`);
    }
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    if (inputShape.length !== 5) {
      throw new ValueError("Input should have rank 5; Received input shape: " + JSON.stringify(inputShape));
    }
    const channelAxis = this.dataFormat === "channelsFirst" ? 1 : inputShape.length - 1;
    if (inputShape[channelAxis] == null) {
      throw new ValueError("The channel dimension of the inputs should be defined. Found `None`.");
    }
    const inputDim = inputShape[channelAxis];
    const kernelShape = this.kernelSize.concat([this.filters, inputDim]);
    this.kernel = this.addWeight("kernel", kernelShape, "float32", this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    }
    this.inputSpec = [new InputSpec({ ndim: 5, axes: { [channelAxis]: inputDim } })];
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      let input = getExactlyOneTensor(inputs);
      if (input.shape.length !== 5) {
        throw new ValueError(`Conv3DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-${input.shape.length}`);
      }
      const inputShape = input.shape;
      const batchSize = inputShape[0];
      let hAxis;
      let wAxis;
      let dAxis;
      if (this.dataFormat === "channelsFirst") {
        dAxis = 2;
        hAxis = 3;
        wAxis = 4;
      } else {
        dAxis = 1;
        hAxis = 2;
        wAxis = 3;
      }
      const depth = inputShape[dAxis];
      const height2 = inputShape[hAxis];
      const width2 = inputShape[wAxis];
      const kernelD = this.kernelSize[0];
      const kernelH = this.kernelSize[1];
      const kernelW = this.kernelSize[2];
      const strideD = this.strides[0];
      const strideH = this.strides[1];
      const strideW = this.strides[2];
      const outDepth = deconvLength(depth, strideD, kernelD, this.padding);
      const outHeight = deconvLength(height2, strideH, kernelH, this.padding);
      const outWidth = deconvLength(width2, strideW, kernelW, this.padding);
      const outputShape = [batchSize, outDepth, outHeight, outWidth, this.filters];
      if (this.dataFormat !== "channelsLast") {
        input = transpose$3(input, [0, 2, 3, 4, 1]);
      }
      let outputs = conv3dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
      if (this.dataFormat !== "channelsLast") {
        outputs = transpose$3(outputs, [0, 4, 1, 2, 3]);
      }
      if (this.bias !== null) {
        outputs = biasAdd(outputs, this.bias.read(), this.dataFormat);
      }
      if (this.activation !== null) {
        outputs = this.activation.apply(outputs);
      }
      return outputs;
    });
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const outputShape = inputShape.slice();
    let channelAxis;
    let depthAxis;
    let heightAxis;
    let widthAxis;
    if (this.dataFormat === "channelsFirst") {
      channelAxis = 1;
      depthAxis = 2;
      heightAxis = 3;
      widthAxis = 4;
    } else {
      channelAxis = 4;
      depthAxis = 1;
      heightAxis = 2;
      widthAxis = 3;
    }
    const kernelD = this.kernelSize[0];
    const kernelH = this.kernelSize[1];
    const kernelW = this.kernelSize[2];
    const strideD = this.strides[0];
    const strideH = this.strides[1];
    const strideW = this.strides[2];
    outputShape[channelAxis] = this.filters;
    outputShape[depthAxis] = deconvLength(outputShape[depthAxis], strideD, kernelD, this.padding);
    outputShape[heightAxis] = deconvLength(outputShape[heightAxis], strideH, kernelH, this.padding);
    outputShape[widthAxis] = deconvLength(outputShape[widthAxis], strideW, kernelW, this.padding);
    return outputShape;
  }
  getConfig() {
    const config2 = super.getConfig();
    delete config2["dilationRate"];
    return config2;
  }
}
Conv3DTranspose.className = "Conv3DTranspose";
registerClass(Conv3DTranspose);
class SeparableConv extends Conv {
  constructor(rank, config2) {
    super(rank, config2);
    this.DEFAULT_DEPTHWISE_INITIALIZER = "glorotUniform";
    this.DEFAULT_POINTWISE_INITIALIZER = "glorotUniform";
    this.depthwiseKernel = null;
    this.pointwiseKernel = null;
    if (config2.filters == null) {
      throw new ValueError("The `filters` configuration field is required by SeparableConv, but is unspecified.");
    }
    if (config2.kernelInitializer != null || config2.kernelRegularizer != null || config2.kernelConstraint != null) {
      throw new ValueError("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
    }
    if (config2.padding != null && config2.padding !== "same" && config2.padding !== "valid") {
      throw new ValueError(`SeparableConv${this.rank}D supports only padding modes: 'same' and 'valid', but received ${JSON.stringify(config2.padding)}`);
    }
    this.depthMultiplier = config2.depthMultiplier == null ? 1 : config2.depthMultiplier;
    this.depthwiseInitializer = getInitializer(config2.depthwiseInitializer || this.DEFAULT_DEPTHWISE_INITIALIZER);
    this.depthwiseRegularizer = getRegularizer(config2.depthwiseRegularizer);
    this.depthwiseConstraint = getConstraint(config2.depthwiseConstraint);
    this.pointwiseInitializer = getInitializer(config2.depthwiseInitializer || this.DEFAULT_POINTWISE_INITIALIZER);
    this.pointwiseRegularizer = getRegularizer(config2.pointwiseRegularizer);
    this.pointwiseConstraint = getConstraint(config2.pointwiseConstraint);
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    if (inputShape.length < this.rank + 2) {
      throw new ValueError(`Inputs to SeparableConv${this.rank}D should have rank ${this.rank + 2}, but received input shape: ${JSON.stringify(inputShape)}`);
    }
    const channelAxis = this.dataFormat === "channelsFirst" ? 1 : inputShape.length - 1;
    if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) {
      throw new ValueError(`The channel dimension of the inputs should be defined, but found ${JSON.stringify(inputShape[channelAxis])}`);
    }
    const inputDim = inputShape[channelAxis];
    const depthwiseKernelShape = this.kernelSize.concat([inputDim, this.depthMultiplier]);
    const pointwiseKernelShape = [];
    for (let i2 = 0; i2 < this.rank; ++i2) {
      pointwiseKernelShape.push(1);
    }
    pointwiseKernelShape.push(inputDim * this.depthMultiplier, this.filters);
    const trainable = true;
    this.depthwiseKernel = this.addWeight("depthwise_kernel", depthwiseKernelShape, "float32", this.depthwiseInitializer, this.depthwiseRegularizer, trainable, this.depthwiseConstraint);
    this.pointwiseKernel = this.addWeight("pointwise_kernel", pointwiseKernelShape, "float32", this.pointwiseInitializer, this.pointwiseRegularizer, trainable, this.pointwiseConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, trainable, this.biasConstraint);
    } else {
      this.bias = null;
    }
    this.inputSpec = [new InputSpec({ ndim: this.rank + 2, axes: { [channelAxis]: inputDim } })];
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = getExactlyOneTensor(inputs);
      let output2;
      if (this.rank === 1) {
        throw new NotImplementedError("1D separable convolution is not implemented yet.");
      } else if (this.rank === 2) {
        if (this.dataFormat === "channelsFirst") {
          inputs = transpose$3(inputs, [0, 2, 3, 1]);
        }
        output2 = separableConv2d(inputs, this.depthwiseKernel.read(), this.pointwiseKernel.read(), this.strides, this.padding, this.dilationRate, "NHWC");
      }
      if (this.useBias) {
        output2 = biasAdd(output2, this.bias.read(), this.dataFormat);
      }
      if (this.activation != null) {
        output2 = this.activation.apply(output2);
      }
      if (this.dataFormat === "channelsFirst") {
        output2 = transpose$3(output2, [0, 3, 1, 2]);
      }
      return output2;
    });
  }
  getConfig() {
    const config2 = super.getConfig();
    delete config2["rank"];
    delete config2["kernelInitializer"];
    delete config2["kernelRegularizer"];
    delete config2["kernelConstraint"];
    config2["depthwiseInitializer"] = serializeInitializer(this.depthwiseInitializer);
    config2["pointwiseInitializer"] = serializeInitializer(this.pointwiseInitializer);
    config2["depthwiseRegularizer"] = serializeRegularizer(this.depthwiseRegularizer);
    config2["pointwiseRegularizer"] = serializeRegularizer(this.pointwiseRegularizer);
    config2["depthwiseConstraint"] = serializeConstraint(this.depthwiseConstraint);
    config2["pointwiseConstraint"] = serializeConstraint(this.pointwiseConstraint);
    return config2;
  }
}
SeparableConv.className = "SeparableConv";
class SeparableConv2D extends SeparableConv {
  constructor(args) {
    super(2, args);
  }
}
SeparableConv2D.className = "SeparableConv2D";
registerClass(SeparableConv2D);
class Conv1D extends Conv {
  constructor(args) {
    super(1, args);
    Conv1D.verifyArgs(args);
    this.inputSpec = [{ ndim: 3 }];
  }
  getConfig() {
    const config2 = super.getConfig();
    delete config2["rank"];
    delete config2["dataFormat"];
    return config2;
  }
  static verifyArgs(args) {
    if (typeof args.kernelSize !== "number" && !checkArrayTypeAndLength(args.kernelSize, "number", 1, 1)) {
      throw new ValueError(`Conv1D expects config.kernelSize to be number or number[] with length 1, but received ${JSON.stringify(args.kernelSize)}.`);
    }
  }
}
Conv1D.className = "Conv1D";
registerClass(Conv1D);
class Cropping2D extends Layer {
  constructor(args) {
    super(args);
    if (typeof args.cropping === "number") {
      this.cropping = [[args.cropping, args.cropping], [args.cropping, args.cropping]];
    } else if (typeof args.cropping[0] === "number") {
      this.cropping = [
        [args.cropping[0], args.cropping[0]],
        [args.cropping[1], args.cropping[1]]
      ];
    } else {
      this.cropping = args.cropping;
    }
    this.dataFormat = args.dataFormat === void 0 ? "channelsLast" : args.dataFormat;
    this.inputSpec = [{ ndim: 4 }];
  }
  computeOutputShape(inputShape) {
    if (this.dataFormat === "channelsFirst") {
      return [
        inputShape[0],
        inputShape[1],
        inputShape[2] - this.cropping[0][0] - this.cropping[0][1],
        inputShape[3] - this.cropping[1][0] - this.cropping[1][1]
      ];
    } else {
      return [
        inputShape[0],
        inputShape[1] - this.cropping[0][0] - this.cropping[0][1],
        inputShape[2] - this.cropping[1][0] - this.cropping[1][1],
        inputShape[3]
      ];
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = getExactlyOneTensor(inputs);
      if (this.dataFormat === "channelsLast") {
        const hSliced = sliceAlongAxis(inputs, this.cropping[0][0], inputs.shape[1] - this.cropping[0][0] - this.cropping[0][1], 2);
        return sliceAlongAxis(hSliced, this.cropping[1][0], inputs.shape[2] - this.cropping[1][1] - this.cropping[1][0], 3);
      } else {
        const hSliced = sliceAlongAxis(inputs, this.cropping[0][0], inputs.shape[2] - this.cropping[0][0] - this.cropping[0][1], 3);
        return sliceAlongAxis(hSliced, this.cropping[1][0], inputs.shape[3] - this.cropping[1][1] - this.cropping[1][0], 4);
      }
    });
  }
  getConfig() {
    const config2 = { cropping: this.cropping, dataFormat: this.dataFormat };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Cropping2D.className = "Cropping2D";
registerClass(Cropping2D);
class UpSampling2D extends Layer {
  constructor(args) {
    super(args);
    this.DEFAULT_SIZE = [2, 2];
    this.inputSpec = [{ ndim: 4 }];
    this.size = args.size == null ? this.DEFAULT_SIZE : args.size;
    this.dataFormat = args.dataFormat == null ? "channelsLast" : args.dataFormat;
    checkDataFormat(this.dataFormat);
    this.interpolation = args.interpolation == null ? "nearest" : args.interpolation;
    checkInterpolationFormat(this.interpolation);
  }
  computeOutputShape(inputShape) {
    if (this.dataFormat === "channelsFirst") {
      const height2 = inputShape[2] == null ? null : this.size[0] * inputShape[2];
      const width2 = inputShape[3] == null ? null : this.size[1] * inputShape[3];
      return [inputShape[0], inputShape[1], height2, width2];
    } else {
      const height2 = inputShape[1] == null ? null : this.size[0] * inputShape[1];
      const width2 = inputShape[2] == null ? null : this.size[1] * inputShape[2];
      return [inputShape[0], height2, width2, inputShape[3]];
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      let input = getExactlyOneTensor(inputs);
      const inputShape = input.shape;
      if (this.dataFormat === "channelsFirst") {
        input = transpose$3(input, [0, 2, 3, 1]);
        const height2 = this.size[0] * inputShape[2];
        const width2 = this.size[1] * inputShape[3];
        const resized = this.interpolation === "nearest" ? image$1.resizeNearestNeighbor(input, [height2, width2]) : image$1.resizeBilinear(input, [height2, width2]);
        return transpose$3(resized, [0, 3, 1, 2]);
      } else {
        const height2 = this.size[0] * inputShape[1];
        const width2 = this.size[1] * inputShape[2];
        return this.interpolation === "nearest" ? image$1.resizeNearestNeighbor(input, [height2, width2]) : image$1.resizeBilinear(input, [height2, width2]);
      }
    });
  }
  getConfig() {
    const config2 = { size: this.size, dataFormat: this.dataFormat };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
UpSampling2D.className = "UpSampling2D";
registerClass(UpSampling2D);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function depthwiseConv2d$1(x2, depthwiseKernel, strides = [1, 1], padding = "valid", dataFormat, dilationRate) {
  return tidy(() => {
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    checkDataFormat(dataFormat);
    let y2 = preprocessConv2DInput(x2, dataFormat);
    if (x2.rank !== 4) {
      throw new ValueError(`Input for depthwiseConv2d is required to be 4-D, but is instead ${x2.rank}-D`);
    }
    if (depthwiseKernel.rank !== 4) {
      throw new ValueError(`depthwiseKernel is required to be 4-D, but is instead ${depthwiseKernel.rank}-D`);
    }
    y2 = depthwiseConv2d$3(y2, depthwiseKernel, strides, padding === "same" ? "same" : "valid", "NHWC", dilationRate);
    if (dataFormat === "channelsFirst") {
      y2 = transpose$3(y2, [0, 3, 1, 2]);
    }
    return y2;
  });
}
class DepthwiseConv2D extends BaseConv {
  constructor(args) {
    super(2, args);
    this.depthwiseKernel = null;
    this.depthMultiplier = args.depthMultiplier == null ? 1 : args.depthMultiplier;
    this.depthwiseInitializer = getInitializer(args.depthwiseInitializer || this.DEFAULT_KERNEL_INITIALIZER);
    this.depthwiseConstraint = getConstraint(args.depthwiseConstraint);
    this.depthwiseRegularizer = getRegularizer(args.depthwiseRegularizer);
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    if (inputShape.length < 4) {
      throw new ValueError(`Inputs to DepthwiseConv2D should have rank 4. Received input shape: ${JSON.stringify(inputShape)}.`);
    }
    const channelAxis = this.dataFormat === "channelsFirst" ? 1 : 3;
    if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) {
      throw new ValueError(`The channel dimension of the inputs to DepthwiseConv2D should be defined, but is not (${inputShape[channelAxis]}).`);
    }
    const inputDim = inputShape[channelAxis];
    const depthwiseKernelShape = [
      this.kernelSize[0],
      this.kernelSize[1],
      inputDim,
      this.depthMultiplier
    ];
    this.depthwiseKernel = this.addWeight("depthwise_kernel", depthwiseKernelShape, null, this.depthwiseInitializer, this.depthwiseRegularizer, true, this.depthwiseConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [inputDim * this.depthMultiplier], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    } else {
      this.bias = null;
    }
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = getExactlyOneTensor(inputs);
      let outputs = depthwiseConv2d$1(inputs, this.depthwiseKernel.read(), this.strides, this.padding, this.dataFormat, null);
      if (this.useBias) {
        outputs = biasAdd(outputs, this.bias.read(), this.dataFormat);
      }
      if (this.activation != null) {
        outputs = this.activation.apply(outputs);
      }
      return outputs;
    });
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const rows = this.dataFormat === "channelsFirst" ? inputShape[2] : inputShape[1];
    const cols = this.dataFormat === "channelsFirst" ? inputShape[3] : inputShape[2];
    const outFilters = this.dataFormat === "channelsFirst" ? inputShape[1] * this.depthMultiplier : inputShape[3] * this.depthMultiplier;
    const outRows = convOutputLength(rows, this.kernelSize[0], this.padding, this.strides[0]);
    const outCols = convOutputLength(cols, this.kernelSize[1], this.padding, this.strides[1]);
    if (this.dataFormat === "channelsFirst") {
      return [inputShape[0], outFilters, outRows, outCols];
    } else {
      return [inputShape[0], outRows, outCols, outFilters];
    }
  }
  getConfig() {
    const config2 = super.getConfig();
    config2["depthMultiplier"] = this.depthMultiplier;
    config2["depthwiseInitializer"] = serializeInitializer(this.depthwiseInitializer);
    config2["depthwiseRegularizer"] = serializeRegularizer(this.depthwiseRegularizer);
    config2["depthwiseConstraint"] = serializeConstraint(this.depthwiseRegularizer);
    return config2;
  }
}
DepthwiseConv2D.className = "DepthwiseConv2D";
registerClass(DepthwiseConv2D);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function standardizeArgs(inputs, initialState, constants, numConstants) {
  if (Array.isArray(inputs)) {
    if (initialState != null || constants != null) {
      throw new ValueError("When inputs is an array, neither initialState or constants should be provided");
    }
    if (numConstants != null) {
      constants = inputs.slice(inputs.length - numConstants, inputs.length);
      inputs = inputs.slice(0, inputs.length - numConstants);
    }
    if (inputs.length > 1) {
      initialState = inputs.slice(1, inputs.length);
    }
    inputs = inputs[0];
  }
  function toListOrNull(x2) {
    if (x2 == null || Array.isArray(x2)) {
      return x2;
    } else {
      return [x2];
    }
  }
  initialState = toListOrNull(initialState);
  constants = toListOrNull(constants);
  return { inputs, initialState, constants };
}
function rnn(stepFunction, inputs, initialStates, goBackwards = false, mask, constants, unroll = false, needPerStepOutputs = false) {
  return tidy(() => {
    const ndim = inputs.shape.length;
    if (ndim < 3) {
      throw new ValueError(`Input should be at least 3D, but is ${ndim}D.`);
    }
    const axes = [1, 0].concat(range$3(2, ndim));
    inputs = transpose$3(inputs, axes);
    if (constants != null) {
      throw new NotImplementedError("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
    }
    if (unroll) {
      console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend.");
    }
    if (mask != null) {
      mask = cast$4(cast$4(mask, "bool"), "float32");
      if (mask.rank === ndim - 1) {
        mask = expandDims$4(mask, -1);
      }
      mask = transpose$3(mask, axes);
    }
    if (goBackwards) {
      inputs = reverse$3(inputs, 0);
      if (mask != null) {
        mask = reverse$3(mask, 0);
      }
    }
    const perStepOutputs = [];
    let lastOutput;
    let states2 = initialStates;
    const timeSteps = inputs.shape[0];
    const perStepInputs = unstack(inputs);
    let perStepMasks;
    if (mask != null) {
      perStepMasks = unstack(mask);
    }
    for (let t2 = 0; t2 < timeSteps; ++t2) {
      const currentInput = perStepInputs[t2];
      const stepOutputs = tidy(() => stepFunction(currentInput, states2));
      if (mask == null) {
        lastOutput = stepOutputs[0];
        states2 = stepOutputs[1];
      } else {
        const maskedOutputs = tidy(() => {
          const stepMask = perStepMasks[t2];
          const negStepMask = sub$2(onesLike$3(stepMask), stepMask);
          const output2 = add$1(mul(stepOutputs[0], stepMask), mul(states2[0], negStepMask));
          const newStates = states2.map((state2, i2) => {
            return add$1(mul(stepOutputs[1][i2], stepMask), mul(state2, negStepMask));
          });
          return { output: output2, newStates };
        });
        lastOutput = maskedOutputs.output;
        states2 = maskedOutputs.newStates;
      }
      if (needPerStepOutputs) {
        perStepOutputs.push(lastOutput);
      }
    }
    let outputs;
    if (needPerStepOutputs) {
      const axis = 1;
      outputs = stack(perStepOutputs, axis);
    }
    return [lastOutput, outputs, states2];
  });
}
class RNN extends Layer {
  constructor(args) {
    super(args);
    let cell;
    if (args.cell == null) {
      throw new ValueError("cell property is missing for the constructor of RNN.");
    } else if (Array.isArray(args.cell)) {
      cell = new StackedRNNCells({ cells: args.cell });
    } else {
      cell = args.cell;
    }
    if (cell.stateSize == null) {
      throw new ValueError("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
    }
    this.cell = cell;
    this.returnSequences = args.returnSequences == null ? false : args.returnSequences;
    this.returnState = args.returnState == null ? false : args.returnState;
    this.goBackwards = args.goBackwards == null ? false : args.goBackwards;
    this._stateful = args.stateful == null ? false : args.stateful;
    this.unroll = args.unroll == null ? false : args.unroll;
    this.supportsMasking = true;
    this.inputSpec = [new InputSpec({ ndim: 3 })];
    this.stateSpec = null;
    this.states_ = null;
    this.numConstants = null;
    this.keptStates = [];
  }
  getStates() {
    if (this.states_ == null) {
      const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
      return range$3(0, numStates).map((x2) => null);
    } else {
      return this.states_;
    }
  }
  setStates(states2) {
    this.states_ = states2;
  }
  computeOutputShape(inputShape) {
    if (isArrayOfShapes(inputShape)) {
      inputShape = inputShape[0];
    }
    inputShape = inputShape;
    let stateSize = this.cell.stateSize;
    if (!Array.isArray(stateSize)) {
      stateSize = [stateSize];
    }
    const outputDim = stateSize[0];
    let outputShape;
    if (this.returnSequences) {
      outputShape = [inputShape[0], inputShape[1], outputDim];
    } else {
      outputShape = [inputShape[0], outputDim];
    }
    if (this.returnState) {
      const stateShape = [];
      for (const dim of stateSize) {
        stateShape.push([inputShape[0], dim]);
      }
      return [outputShape].concat(stateShape);
    } else {
      return outputShape;
    }
  }
  computeMask(inputs, mask) {
    return tidy(() => {
      if (Array.isArray(mask)) {
        mask = mask[0];
      }
      const outputMask = this.returnSequences ? mask : null;
      if (this.returnState) {
        const stateMask = this.states.map((s2) => null);
        return [outputMask].concat(stateMask);
      } else {
        return outputMask;
      }
    });
  }
  get states() {
    if (this.states_ == null) {
      const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
      const output2 = [];
      for (let i2 = 0; i2 < numStates; ++i2) {
        output2.push(null);
      }
      return output2;
    } else {
      return this.states_;
    }
  }
  set states(s2) {
    this.states_ = s2;
  }
  build(inputShape) {
    if (this.numConstants != null) {
      throw new NotImplementedError("Constants support is not implemented in RNN yet.");
    }
    if (isArrayOfShapes(inputShape)) {
      inputShape = inputShape[0];
    }
    inputShape = inputShape;
    const batchSize = this.stateful ? inputShape[0] : null;
    const inputDim = inputShape.slice(2);
    this.inputSpec[0] = new InputSpec({ shape: [batchSize, null, ...inputDim] });
    const stepInputShape = [inputShape[0]].concat(inputShape.slice(2));
    {
      this.cell.build(stepInputShape);
    }
    let stateSize;
    if (Array.isArray(this.cell.stateSize)) {
      stateSize = this.cell.stateSize;
    } else {
      stateSize = [this.cell.stateSize];
    }
    if (this.stateSpec != null) {
      if (!arraysEqual(this.stateSpec.map((spec) => spec.shape[spec.shape.length - 1]), stateSize)) {
        throw new ValueError(`An initialState was passed that is not compatible with cell.stateSize. Received stateSpec=${this.stateSpec}; However cell.stateSize is ${this.cell.stateSize}`);
      }
    } else {
      this.stateSpec = stateSize.map((dim) => new InputSpec({ shape: [null, dim] }));
    }
    if (this.stateful) {
      this.resetStates();
    }
  }
  resetStates(states2, training = false) {
    tidy(() => {
      if (!this.stateful) {
        throw new AttributeError("Cannot call resetStates() on an RNN Layer that is not stateful.");
      }
      const batchSize = this.inputSpec[0].shape[0];
      if (batchSize == null) {
        throw new ValueError("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
      }
      if (this.states_ == null) {
        if (Array.isArray(this.cell.stateSize)) {
          this.states_ = this.cell.stateSize.map((dim) => zeros$1([batchSize, dim]));
        } else {
          this.states_ = [zeros$1([batchSize, this.cell.stateSize])];
        }
      } else if (states2 == null) {
        dispose(this.states_);
        if (this.keptStates != null) {
          dispose(this.keptStates);
          this.keptStates = [];
        }
        if (Array.isArray(this.cell.stateSize)) {
          this.states_ = this.cell.stateSize.map((dim) => zeros$1([batchSize, dim]));
        } else {
          this.states_[0] = zeros$1([batchSize, this.cell.stateSize]);
        }
      } else {
        if (!Array.isArray(states2)) {
          states2 = [states2];
        }
        if (states2.length !== this.states_.length) {
          throw new ValueError(`Layer ${this.name} expects ${this.states_.length} state(s), but it received ${states2.length} state value(s). Input received: ${states2}`);
        }
        if (training === true) {
          this.keptStates.push(this.states_.slice());
        } else {
          dispose(this.states_);
        }
        for (let index2 = 0; index2 < this.states_.length; ++index2) {
          const value = states2[index2];
          const dim = Array.isArray(this.cell.stateSize) ? this.cell.stateSize[index2] : this.cell.stateSize;
          const expectedShape = [batchSize, dim];
          if (!arraysEqual(value.shape, expectedShape)) {
            throw new ValueError(`State ${index2} is incompatible with layer ${this.name}: expected shape=${expectedShape}, received shape=${value.shape}`);
          }
          this.states_[index2] = value;
        }
      }
      this.states_ = this.states_.map((state2) => keep(state2.clone()));
    });
  }
  apply(inputs, kwargs) {
    let initialState = kwargs == null ? null : kwargs["initialState"];
    let constants = kwargs == null ? null : kwargs["constants"];
    if (kwargs == null) {
      kwargs = {};
    }
    const standardized = standardizeArgs(inputs, initialState, constants, this.numConstants);
    inputs = standardized.inputs;
    initialState = standardized.initialState;
    constants = standardized.constants;
    let additionalInputs = [];
    let additionalSpecs = [];
    if (initialState != null) {
      kwargs["initialState"] = initialState;
      additionalInputs = additionalInputs.concat(initialState);
      this.stateSpec = [];
      for (const state2 of initialState) {
        this.stateSpec.push(new InputSpec({ shape: state2.shape }));
      }
      additionalSpecs = additionalSpecs.concat(this.stateSpec);
    }
    if (constants != null) {
      kwargs["constants"] = constants;
      additionalInputs = additionalInputs.concat(constants);
      this.numConstants = constants.length;
    }
    const isTensor = additionalInputs[0] instanceof SymbolicTensor;
    if (isTensor) {
      const fullInput = [inputs].concat(additionalInputs);
      const fullInputSpec = this.inputSpec.concat(additionalSpecs);
      const originalInputSpec = this.inputSpec;
      this.inputSpec = fullInputSpec;
      const output2 = super.apply(fullInput, kwargs);
      this.inputSpec = originalInputSpec;
      return output2;
    } else {
      return super.apply(inputs, kwargs);
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      const mask = kwargs == null ? null : kwargs["mask"];
      const training = kwargs == null ? null : kwargs["training"];
      let initialState = kwargs == null ? null : kwargs["initialState"];
      inputs = getExactlyOneTensor(inputs);
      if (initialState == null) {
        if (this.stateful) {
          initialState = this.states_;
        } else {
          initialState = this.getInitialState(inputs);
        }
      }
      const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
      if (initialState.length !== numStates) {
        throw new ValueError(`RNN Layer has ${numStates} state(s) but was passed ${initialState.length} initial state(s).`);
      }
      if (this.unroll) {
        console.warn("Ignoring unroll = true for RNN layer, due to imperative backend.");
      }
      const cellCallKwargs = { training };
      const step2 = (inputs2, states3) => {
        const outputs2 = this.cell.call([inputs2].concat(states3), cellCallKwargs);
        return [outputs2[0], outputs2.slice(1)];
      };
      const rnnOutputs = rnn(step2, inputs, initialState, this.goBackwards, mask, null, this.unroll, this.returnSequences);
      const lastOutput = rnnOutputs[0];
      const outputs = rnnOutputs[1];
      const states2 = rnnOutputs[2];
      if (this.stateful) {
        this.resetStates(states2, training);
      }
      const output2 = this.returnSequences ? outputs : lastOutput;
      if (this.returnState) {
        return [output2].concat(states2);
      } else {
        return output2;
      }
    });
  }
  getInitialState(inputs) {
    return tidy(() => {
      let initialState = zeros$1(inputs.shape);
      initialState = sum$3(initialState, [1, 2]);
      initialState = expandDims$3(initialState);
      if (Array.isArray(this.cell.stateSize)) {
        return this.cell.stateSize.map((dim) => dim > 1 ? tile$3(initialState, [1, dim]) : initialState);
      } else {
        return this.cell.stateSize > 1 ? [tile$3(initialState, [1, this.cell.stateSize])] : [initialState];
      }
    });
  }
  get trainableWeights() {
    if (!this.trainable) {
      return [];
    }
    return this.cell.trainableWeights;
  }
  get nonTrainableWeights() {
    if (!this.trainable) {
      return this.cell.weights;
    }
    return this.cell.nonTrainableWeights;
  }
  setFastWeightInitDuringBuild(value) {
    super.setFastWeightInitDuringBuild(value);
    if (this.cell != null) {
      this.cell.setFastWeightInitDuringBuild(value);
    }
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = {
      returnSequences: this.returnSequences,
      returnState: this.returnState,
      goBackwards: this.goBackwards,
      stateful: this.stateful,
      unroll: this.unroll
    };
    if (this.numConstants != null) {
      config2["numConstants"] = this.numConstants;
    }
    const cellConfig = this.cell.getConfig();
    if (this.getClassName() === RNN.className) {
      config2["cell"] = {
        "className": this.cell.getClassName(),
        "config": cellConfig
      };
    }
    return Object.assign({}, cellConfig, baseConfig, config2);
  }
  static fromConfig(cls, config2, customObjects = {}) {
    const cellConfig = config2["cell"];
    const cell = deserialize(cellConfig, customObjects);
    return new cls(Object.assign(config2, { cell }));
  }
}
RNN.className = "RNN";
registerClass(RNN);
class RNNCell extends Layer {
}
class SimpleRNNCell extends RNNCell {
  constructor(args) {
    super(args);
    this.DEFAULT_ACTIVATION = "tanh";
    this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal";
    this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal";
    this.DEFAULT_BIAS_INITIALIZER = "zeros";
    this.units = args.units;
    assertPositiveInteger(this.units, `units`);
    this.activation = getActivation(args.activation == null ? this.DEFAULT_ACTIVATION : args.activation);
    this.useBias = args.useBias == null ? true : args.useBias;
    this.kernelInitializer = getInitializer(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
    this.recurrentInitializer = getInitializer(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
    this.biasInitializer = getInitializer(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
    this.kernelRegularizer = getRegularizer(args.kernelRegularizer);
    this.recurrentRegularizer = getRegularizer(args.recurrentRegularizer);
    this.biasRegularizer = getRegularizer(args.biasRegularizer);
    this.kernelConstraint = getConstraint(args.kernelConstraint);
    this.recurrentConstraint = getConstraint(args.recurrentConstraint);
    this.biasConstraint = getConstraint(args.biasConstraint);
    this.dropout = min$3([1, max$3([0, args.dropout == null ? 0 : args.dropout])]);
    this.recurrentDropout = min$3([
      1,
      max$3([0, args.recurrentDropout == null ? 0 : args.recurrentDropout])
    ]);
    this.dropoutFunc = args.dropoutFunc;
    this.stateSize = this.units;
    this.dropoutMask = null;
    this.recurrentDropoutMask = null;
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    this.kernel = this.addWeight("kernel", [inputShape[inputShape.length - 1], this.units], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, this.units], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [this.units], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    } else {
      this.bias = null;
    }
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = inputs;
      if (inputs.length !== 2) {
        throw new ValueError(`SimpleRNNCell expects 2 input Tensors, got ${inputs.length}.`);
      }
      let prevOutput = inputs[1];
      inputs = inputs[0];
      const training = kwargs["training"] == null ? false : kwargs["training"];
      if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) {
        this.dropoutMask = generateDropoutMask({
          ones: () => onesLike$3(inputs),
          rate: this.dropout,
          training,
          dropoutFunc: this.dropoutFunc
        });
      }
      if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) {
        this.recurrentDropoutMask = generateDropoutMask({
          ones: () => onesLike$3(prevOutput),
          rate: this.recurrentDropout,
          training,
          dropoutFunc: this.dropoutFunc
        });
      }
      let h2;
      const dpMask = this.dropoutMask;
      const recDpMask = this.recurrentDropoutMask;
      if (dpMask != null) {
        h2 = dot(mul(inputs, dpMask), this.kernel.read());
      } else {
        h2 = dot(inputs, this.kernel.read());
      }
      if (this.bias != null) {
        h2 = biasAdd(h2, this.bias.read());
      }
      if (recDpMask != null) {
        prevOutput = mul(prevOutput, recDpMask);
      }
      let output2 = add$1(h2, dot(prevOutput, this.recurrentKernel.read()));
      if (this.activation != null) {
        output2 = this.activation.apply(output2);
      }
      return [output2, output2];
    });
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = {
      units: this.units,
      activation: serializeActivation(this.activation),
      useBias: this.useBias,
      kernelInitializer: serializeInitializer(this.kernelInitializer),
      recurrentInitializer: serializeInitializer(this.recurrentInitializer),
      biasInitializer: serializeInitializer(this.biasInitializer),
      kernelRegularizer: serializeRegularizer(this.kernelRegularizer),
      recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer),
      biasRegularizer: serializeRegularizer(this.biasRegularizer),
      activityRegularizer: serializeRegularizer(this.activityRegularizer),
      kernelConstraint: serializeConstraint(this.kernelConstraint),
      recurrentConstraint: serializeConstraint(this.recurrentConstraint),
      biasConstraint: serializeConstraint(this.biasConstraint),
      dropout: this.dropout,
      recurrentDropout: this.recurrentDropout
    };
    return Object.assign({}, baseConfig, config2);
  }
}
SimpleRNNCell.className = "SimpleRNNCell";
registerClass(SimpleRNNCell);
class SimpleRNN extends RNN {
  constructor(args) {
    args.cell = new SimpleRNNCell(args);
    super(args);
  }
  call(inputs, kwargs) {
    return tidy(() => {
      if (this.cell.dropoutMask != null) {
        dispose(this.cell.dropoutMask);
        this.cell.dropoutMask = null;
      }
      if (this.cell.recurrentDropoutMask != null) {
        dispose(this.cell.recurrentDropoutMask);
        this.cell.recurrentDropoutMask = null;
      }
      const mask = kwargs == null ? null : kwargs["mask"];
      const training = kwargs == null ? null : kwargs["training"];
      const initialState = kwargs == null ? null : kwargs["initialState"];
      return super.call(inputs, { mask, training, initialState });
    });
  }
  static fromConfig(cls, config2) {
    return new cls(config2);
  }
}
SimpleRNN.className = "SimpleRNN";
registerClass(SimpleRNN);
class GRUCell extends RNNCell {
  constructor(args) {
    super(args);
    this.DEFAULT_ACTIVATION = "tanh";
    this.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid";
    this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal";
    this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal";
    this.DEFAULT_BIAS_INITIALIZER = "zeros";
    if (args.resetAfter) {
      throw new ValueError(`GRUCell does not support reset_after parameter set to true.`);
    }
    this.units = args.units;
    assertPositiveInteger(this.units, "units");
    this.activation = getActivation(args.activation === void 0 ? this.DEFAULT_ACTIVATION : args.activation);
    this.recurrentActivation = getActivation(args.recurrentActivation === void 0 ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
    this.useBias = args.useBias == null ? true : args.useBias;
    this.kernelInitializer = getInitializer(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
    this.recurrentInitializer = getInitializer(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
    this.biasInitializer = getInitializer(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
    this.kernelRegularizer = getRegularizer(args.kernelRegularizer);
    this.recurrentRegularizer = getRegularizer(args.recurrentRegularizer);
    this.biasRegularizer = getRegularizer(args.biasRegularizer);
    this.kernelConstraint = getConstraint(args.kernelConstraint);
    this.recurrentConstraint = getConstraint(args.recurrentConstraint);
    this.biasConstraint = getConstraint(args.biasConstraint);
    this.dropout = min$3([1, max$3([0, args.dropout == null ? 0 : args.dropout])]);
    this.recurrentDropout = min$3([
      1,
      max$3([0, args.recurrentDropout == null ? 0 : args.recurrentDropout])
    ]);
    this.dropoutFunc = args.dropoutFunc;
    this.implementation = args.implementation;
    this.stateSize = this.units;
    this.dropoutMask = null;
    this.recurrentDropoutMask = null;
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const inputDim = inputShape[inputShape.length - 1];
    this.kernel = this.addWeight("kernel", [inputDim, this.units * 3], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, this.units * 3], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
    if (this.useBias) {
      this.bias = this.addWeight("bias", [this.units * 3], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    } else {
      this.bias = null;
    }
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = inputs;
      if (inputs.length !== 2) {
        throw new ValueError(`GRUCell expects 2 input Tensors (inputs, h, c), got ${inputs.length}.`);
      }
      const training = kwargs["training"] == null ? false : kwargs["training"];
      let hTMinus1 = inputs[1];
      inputs = inputs[0];
      if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) {
        this.dropoutMask = generateDropoutMask({
          ones: () => onesLike$3(inputs),
          rate: this.dropout,
          training,
          count: 3,
          dropoutFunc: this.dropoutFunc
        });
      }
      if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) {
        this.recurrentDropoutMask = generateDropoutMask({
          ones: () => onesLike$3(hTMinus1),
          rate: this.recurrentDropout,
          training,
          count: 3,
          dropoutFunc: this.dropoutFunc
        });
      }
      const dpMask = this.dropoutMask;
      const recDpMask = this.recurrentDropoutMask;
      let z2;
      let r2;
      let hh;
      if (0 < this.dropout && this.dropout < 1) {
        inputs = mul(inputs, dpMask[0]);
      }
      let matrixX = dot(inputs, this.kernel.read());
      if (this.useBias) {
        matrixX = biasAdd(matrixX, this.bias.read());
      }
      if (0 < this.recurrentDropout && this.recurrentDropout < 1) {
        hTMinus1 = mul(hTMinus1, recDpMask[0]);
      }
      const recurrentKernelValue = this.recurrentKernel.read();
      const [rk1, rk2] = split$2(recurrentKernelValue, [2 * this.units, this.units], recurrentKernelValue.rank - 1);
      const matrixInner = dot(hTMinus1, rk1);
      const [xZ, xR, xH] = split$2(matrixX, 3, matrixX.rank - 1);
      const [recurrentZ, recurrentR] = split$2(matrixInner, 2, matrixInner.rank - 1);
      z2 = this.recurrentActivation.apply(add$1(xZ, recurrentZ));
      r2 = this.recurrentActivation.apply(add$1(xR, recurrentR));
      const recurrentH = dot(mul(r2, hTMinus1), rk2);
      hh = this.activation.apply(add$1(xH, recurrentH));
      const h2 = add$1(mul(z2, hTMinus1), mul(add$1(1, neg$2(z2)), hh));
      return [h2, h2];
    });
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = {
      units: this.units,
      activation: serializeActivation(this.activation),
      recurrentActivation: serializeActivation(this.recurrentActivation),
      useBias: this.useBias,
      kernelInitializer: serializeInitializer(this.kernelInitializer),
      recurrentInitializer: serializeInitializer(this.recurrentInitializer),
      biasInitializer: serializeInitializer(this.biasInitializer),
      kernelRegularizer: serializeRegularizer(this.kernelRegularizer),
      recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer),
      biasRegularizer: serializeRegularizer(this.biasRegularizer),
      activityRegularizer: serializeRegularizer(this.activityRegularizer),
      kernelConstraint: serializeConstraint(this.kernelConstraint),
      recurrentConstraint: serializeConstraint(this.recurrentConstraint),
      biasConstraint: serializeConstraint(this.biasConstraint),
      dropout: this.dropout,
      recurrentDropout: this.recurrentDropout,
      implementation: this.implementation,
      resetAfter: false
    };
    return Object.assign({}, baseConfig, config2);
  }
}
GRUCell.className = "GRUCell";
registerClass(GRUCell);
class GRU extends RNN {
  constructor(args) {
    if (args.implementation === 0) {
      console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
    }
    args.cell = new GRUCell(args);
    super(args);
  }
  call(inputs, kwargs) {
    return tidy(() => {
      if (this.cell.dropoutMask != null) {
        dispose(this.cell.dropoutMask);
        this.cell.dropoutMask = null;
      }
      if (this.cell.recurrentDropoutMask != null) {
        dispose(this.cell.recurrentDropoutMask);
        this.cell.recurrentDropoutMask = null;
      }
      const mask = kwargs == null ? null : kwargs["mask"];
      const training = kwargs == null ? null : kwargs["training"];
      const initialState = kwargs == null ? null : kwargs["initialState"];
      return super.call(inputs, { mask, training, initialState });
    });
  }
  static fromConfig(cls, config2) {
    if (config2["implmentation"] === 0) {
      config2["implementation"] = 1;
    }
    return new cls(config2);
  }
}
GRU.className = "GRU";
registerClass(GRU);
class LSTMCell extends RNNCell {
  constructor(args) {
    super(args);
    this.DEFAULT_ACTIVATION = "tanh";
    this.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid";
    this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal";
    this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal";
    this.DEFAULT_BIAS_INITIALIZER = "zeros";
    this.units = args.units;
    assertPositiveInteger(this.units, "units");
    this.activation = getActivation(args.activation === void 0 ? this.DEFAULT_ACTIVATION : args.activation);
    this.recurrentActivation = getActivation(args.recurrentActivation === void 0 ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
    this.useBias = args.useBias == null ? true : args.useBias;
    this.kernelInitializer = getInitializer(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
    this.recurrentInitializer = getInitializer(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
    this.biasInitializer = getInitializer(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
    this.unitForgetBias = args.unitForgetBias;
    this.kernelRegularizer = getRegularizer(args.kernelRegularizer);
    this.recurrentRegularizer = getRegularizer(args.recurrentRegularizer);
    this.biasRegularizer = getRegularizer(args.biasRegularizer);
    this.kernelConstraint = getConstraint(args.kernelConstraint);
    this.recurrentConstraint = getConstraint(args.recurrentConstraint);
    this.biasConstraint = getConstraint(args.biasConstraint);
    this.dropout = min$3([1, max$3([0, args.dropout == null ? 0 : args.dropout])]);
    this.recurrentDropout = min$3([
      1,
      max$3([0, args.recurrentDropout == null ? 0 : args.recurrentDropout])
    ]);
    this.dropoutFunc = args.dropoutFunc;
    this.implementation = args.implementation;
    this.stateSize = [this.units, this.units];
    this.dropoutMask = null;
    this.recurrentDropoutMask = null;
  }
  build(inputShape) {
    var _a;
    inputShape = getExactlyOneShape(inputShape);
    const inputDim = inputShape[inputShape.length - 1];
    this.kernel = this.addWeight("kernel", [inputDim, this.units * 4], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, this.units * 4], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
    let biasInitializer;
    if (this.useBias) {
      if (this.unitForgetBias) {
        const capturedBiasInit = this.biasInitializer;
        const capturedUnits = this.units;
        biasInitializer = new (_a = class CustomInit extends Initializer {
          apply(shape, dtype) {
            const bI = capturedBiasInit.apply([capturedUnits]);
            const bF = new Ones().apply([capturedUnits]);
            const bCAndH = capturedBiasInit.apply([capturedUnits * 2]);
            return concatAlongFirstAxis(concatAlongFirstAxis(bI, bF), bCAndH);
          }
        }, _a.className = "CustomInit", _a)();
      } else {
        biasInitializer = this.biasInitializer;
      }
      this.bias = this.addWeight("bias", [this.units * 4], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    } else {
      this.bias = null;
    }
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      const training = kwargs["training"] == null ? false : kwargs["training"];
      inputs = inputs;
      if (inputs.length !== 3) {
        throw new ValueError(`LSTMCell expects 3 input Tensors (inputs, h, c), got ${inputs.length}.`);
      }
      let hTMinus1 = inputs[1];
      const cTMinus1 = inputs[2];
      inputs = inputs[0];
      if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) {
        this.dropoutMask = generateDropoutMask({
          ones: () => onesLike$3(inputs),
          rate: this.dropout,
          training,
          count: 4,
          dropoutFunc: this.dropoutFunc
        });
      }
      if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) {
        this.recurrentDropoutMask = generateDropoutMask({
          ones: () => onesLike$3(hTMinus1),
          rate: this.recurrentDropout,
          training,
          count: 4,
          dropoutFunc: this.dropoutFunc
        });
      }
      const dpMask = this.dropoutMask;
      const recDpMask = this.recurrentDropoutMask;
      let i2;
      let f2;
      let c2;
      let o;
      if (0 < this.dropout && this.dropout < 1) {
        inputs = mul(inputs, dpMask[0]);
      }
      let z2 = dot(inputs, this.kernel.read());
      if (0 < this.recurrentDropout && this.recurrentDropout < 1) {
        hTMinus1 = mul(hTMinus1, recDpMask[0]);
      }
      z2 = add$1(z2, dot(hTMinus1, this.recurrentKernel.read()));
      if (this.useBias) {
        z2 = biasAdd(z2, this.bias.read());
      }
      const [z0, z1, z22, z3] = split$2(z2, 4, z2.rank - 1);
      i2 = this.recurrentActivation.apply(z0);
      f2 = this.recurrentActivation.apply(z1);
      c2 = add$1(mul(f2, cTMinus1), mul(i2, this.activation.apply(z22)));
      o = this.recurrentActivation.apply(z3);
      const h2 = mul(o, this.activation.apply(c2));
      return [h2, h2, c2];
    });
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = {
      units: this.units,
      activation: serializeActivation(this.activation),
      recurrentActivation: serializeActivation(this.recurrentActivation),
      useBias: this.useBias,
      kernelInitializer: serializeInitializer(this.kernelInitializer),
      recurrentInitializer: serializeInitializer(this.recurrentInitializer),
      biasInitializer: serializeInitializer(this.biasInitializer),
      unitForgetBias: this.unitForgetBias,
      kernelRegularizer: serializeRegularizer(this.kernelRegularizer),
      recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer),
      biasRegularizer: serializeRegularizer(this.biasRegularizer),
      activityRegularizer: serializeRegularizer(this.activityRegularizer),
      kernelConstraint: serializeConstraint(this.kernelConstraint),
      recurrentConstraint: serializeConstraint(this.recurrentConstraint),
      biasConstraint: serializeConstraint(this.biasConstraint),
      dropout: this.dropout,
      recurrentDropout: this.recurrentDropout,
      implementation: this.implementation
    };
    return Object.assign({}, baseConfig, config2);
  }
}
LSTMCell.className = "LSTMCell";
registerClass(LSTMCell);
class LSTM extends RNN {
  constructor(args) {
    if (args.implementation === 0) {
      console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
    }
    args.cell = new LSTMCell(args);
    super(args);
  }
  call(inputs, kwargs) {
    return tidy(() => {
      if (this.cell.dropoutMask != null) {
        dispose(this.cell.dropoutMask);
        this.cell.dropoutMask = null;
      }
      if (this.cell.recurrentDropoutMask != null) {
        dispose(this.cell.recurrentDropoutMask);
        this.cell.recurrentDropoutMask = null;
      }
      const mask = kwargs == null ? null : kwargs["mask"];
      const training = kwargs == null ? null : kwargs["training"];
      const initialState = kwargs == null ? null : kwargs["initialState"];
      return super.call(inputs, { mask, training, initialState });
    });
  }
  static fromConfig(cls, config2) {
    if (config2["implmentation"] === 0) {
      config2["implementation"] = 1;
    }
    return new cls(config2);
  }
}
LSTM.className = "LSTM";
registerClass(LSTM);
class StackedRNNCells extends RNNCell {
  constructor(args) {
    super(args);
    this.cells = args.cells;
  }
  get stateSize() {
    const stateSize = [];
    for (const cell of this.cells.slice().reverse()) {
      if (Array.isArray(cell.stateSize)) {
        stateSize.push(...cell.stateSize);
      } else {
        stateSize.push(cell.stateSize);
      }
    }
    return stateSize;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = inputs;
      let states2 = inputs.slice(1);
      const nestedStates = [];
      for (const cell of this.cells.slice().reverse()) {
        if (Array.isArray(cell.stateSize)) {
          nestedStates.push(states2.splice(0, cell.stateSize.length));
        } else {
          nestedStates.push(states2.splice(0, 1));
        }
      }
      nestedStates.reverse();
      const newNestedStates = [];
      let callInputs;
      for (let i2 = 0; i2 < this.cells.length; ++i2) {
        const cell = this.cells[i2];
        states2 = nestedStates[i2];
        if (i2 === 0) {
          callInputs = [inputs[0]].concat(states2);
        } else {
          callInputs = [callInputs[0]].concat(states2);
        }
        callInputs = cell.call(callInputs, kwargs);
        newNestedStates.push(callInputs.slice(1));
      }
      states2 = [];
      for (const cellStates of newNestedStates.slice().reverse()) {
        states2.push(...cellStates);
      }
      return [callInputs[0]].concat(states2);
    });
  }
  build(inputShape) {
    if (isArrayOfShapes(inputShape)) {
      inputShape = inputShape[0];
    }
    inputShape = inputShape;
    let outputDim;
    this.cells.forEach((cell, i2) => {
      nameScope(`RNNCell_${i2}`, () => {
        cell.build(inputShape);
        if (Array.isArray(cell.stateSize)) {
          outputDim = cell.stateSize[0];
        } else {
          outputDim = cell.stateSize;
        }
        inputShape = [inputShape[0], outputDim];
      });
    });
    this.built = true;
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const getCellConfig = (cell) => {
      return {
        "className": cell.getClassName(),
        "config": cell.getConfig()
      };
    };
    const cellConfigs = this.cells.map(getCellConfig);
    const config2 = { "cells": cellConfigs };
    return Object.assign({}, baseConfig, config2);
  }
  static fromConfig(cls, config2, customObjects = {}) {
    const cells = [];
    for (const cellConfig of config2["cells"]) {
      cells.push(deserialize(cellConfig, customObjects));
    }
    return new cls({ cells });
  }
  get trainableWeights() {
    if (!this.trainable) {
      return [];
    }
    const weights = [];
    for (const cell of this.cells) {
      weights.push(...cell.trainableWeights);
    }
    return weights;
  }
  get nonTrainableWeights() {
    const weights = [];
    for (const cell of this.cells) {
      weights.push(...cell.nonTrainableWeights);
    }
    if (!this.trainable) {
      const trainableWeights = [];
      for (const cell of this.cells) {
        trainableWeights.push(...cell.trainableWeights);
      }
      return trainableWeights.concat(weights);
    }
    return weights;
  }
  getWeights() {
    const weights = [];
    for (const cell of this.cells) {
      weights.push(...cell.weights);
    }
    return batchGetValue(weights);
  }
  setWeights(weights) {
    const tuples = [];
    for (const cell of this.cells) {
      const numParams = cell.weights.length;
      const inputWeights = weights.splice(numParams);
      for (let i2 = 0; i2 < cell.weights.length; ++i2) {
        tuples.push([cell.weights[i2], inputWeights[i2]]);
      }
    }
    batchSetValue(tuples);
  }
}
StackedRNNCells.className = "StackedRNNCells";
registerClass(StackedRNNCells);
function generateDropoutMask(args) {
  const { ones: ones2, rate, training = false, count: count2 = 1, dropoutFunc } = args;
  const droppedInputs = () => dropoutFunc != null ? dropoutFunc(ones2(), rate) : dropout(ones2(), rate);
  const createMask = () => inTrainPhase(droppedInputs, ones2, training);
  if (!count2 || count2 <= 1) {
    return keep(createMask().clone());
  }
  const masks = Array(count2).fill(void 0).map(createMask);
  return masks.map((m2) => keep(m2.clone()));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
var __rest$2 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
class ConvRNN2D extends RNN {
  constructor(args) {
    if (args.unroll) {
      throw new NotImplementedError("Unrolling is not possible with convolutional RNNs.");
    }
    if (Array.isArray(args.cell)) {
      throw new NotImplementedError("It is not possible at the moment to stack convolutional cells.");
    }
    super(args);
    this.inputSpec = [new InputSpec({ ndim: 5 })];
  }
  call(inputs, kwargs) {
    return tidy(() => {
      if (this.cell.dropoutMask != null) {
        dispose(this.cell.dropoutMask);
        this.cell.dropoutMask = null;
      }
      if (this.cell.recurrentDropoutMask != null) {
        dispose(this.cell.recurrentDropoutMask);
        this.cell.recurrentDropoutMask = null;
      }
      if (kwargs && kwargs["constants"]) {
        throw new ValueError("ConvRNN2D cell does not support constants");
      }
      const mask = kwargs == null ? null : kwargs["mask"];
      const training = kwargs == null ? null : kwargs["training"];
      const initialState = kwargs == null ? null : kwargs["initialState"];
      return super.call(inputs, { mask, training, initialState });
    });
  }
  computeOutputShape(inputShape) {
    let outShape = this.computeSingleOutputShape(inputShape);
    if (!this.returnSequences) {
      outShape = [outShape[0], ...outShape.slice(2)];
    }
    if (this.returnState) {
      outShape = [outShape, ...Array(2).fill([inputShape[0], ...outShape.slice(-3)])];
    }
    return outShape;
  }
  getInitialState(inputs) {
    return tidy(() => {
      const { stateSize } = this.cell;
      const inputShape = inputs.shape;
      const outputShape = this.computeSingleOutputShape(inputShape);
      const stateShape = [outputShape[0], ...outputShape.slice(2)];
      const initialState = zeros$1(stateShape);
      if (Array.isArray(stateSize)) {
        return Array(stateSize.length).fill(initialState);
      }
      return [initialState];
    });
  }
  resetStates(states2, training = false) {
    tidy(() => {
      if (!this.stateful) {
        throw new AttributeError("Cannot call resetStates() on an RNN Layer that is not stateful.");
      }
      const inputShape = this.inputSpec[0].shape;
      const outputShape = this.computeSingleOutputShape(inputShape);
      const stateShape = [outputShape[0], ...outputShape.slice(2)];
      const batchSize = inputShape[0];
      if (batchSize == null) {
        throw new ValueError("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
      }
      if (this.getStates() == null) {
        if (Array.isArray(this.cell.stateSize)) {
          this.states_ = this.cell.stateSize.map(() => zeros$1(stateShape));
        } else {
          this.states_ = [zeros$1(stateShape)];
        }
      } else if (states2 == null) {
        dispose(this.states_);
        if (this.keptStates != null) {
          dispose(this.keptStates);
          this.keptStates = [];
        }
        if (Array.isArray(this.cell.stateSize)) {
          this.states_ = this.cell.stateSize.map(() => zeros$1(stateShape));
        } else {
          this.states_[0] = zeros$1(stateShape);
        }
      } else {
        if (!Array.isArray(states2)) {
          states2 = [states2];
        }
        if (states2.length !== this.states_.length) {
          throw new ValueError(`Layer ${this.name} expects ${this.states_.length} state(s), but it received ${states2.length} state value(s). Input received: ${states2}`);
        }
        if (training) {
          this.keptStates.push(this.states_.slice());
        } else {
          dispose(this.states_);
        }
        for (let index2 = 0; index2 < this.states_.length; ++index2) {
          const value = states2[index2];
          const expectedShape = stateShape;
          if (!arraysEqual(value.shape, expectedShape)) {
            throw new ValueError(`State ${index2} is incompatible with layer ${this.name}: expected shape=${expectedShape}, received shape=${value.shape}`);
          }
          this.states_[index2] = value;
        }
      }
      this.states_ = this.states_.map((state2) => keep(state2.clone()));
    });
  }
  computeSingleOutputShape(inputShape) {
    const { dataFormat, filters, kernelSize, padding, strides, dilationRate } = this.cell;
    const isChannelsFirst = dataFormat === "channelsFirst";
    const h2 = inputShape[isChannelsFirst ? 3 : 2];
    const w2 = inputShape[isChannelsFirst ? 4 : 3];
    const hOut = convOutputLength(h2, kernelSize[0], padding, strides[0], dilationRate[0]);
    const wOut = convOutputLength(w2, kernelSize[1], padding, strides[1], dilationRate[1]);
    const outShape = [
      ...inputShape.slice(0, 2),
      ...isChannelsFirst ? [filters, hOut, wOut] : [hOut, wOut, filters]
    ];
    return outShape;
  }
}
ConvRNN2D.className = "ConvRNN2D";
class ConvLSTM2DCell extends LSTMCell {
  constructor(args) {
    const { filters, kernelSize, strides, padding, dataFormat, dilationRate } = args;
    super(Object.assign({}, args, { units: filters }));
    this.filters = filters;
    assertPositiveInteger(this.filters, "filters");
    this.kernelSize = normalizeArray(kernelSize, 2, "kernelSize");
    this.kernelSize.forEach((size) => assertPositiveInteger(size, "kernelSize"));
    this.strides = normalizeArray(strides || 1, 2, "strides");
    this.strides.forEach((stride) => assertPositiveInteger(stride, "strides"));
    this.padding = padding || "valid";
    checkPaddingMode(this.padding);
    this.dataFormat = dataFormat || "channelsLast";
    checkDataFormat(this.dataFormat);
    this.dilationRate = normalizeArray(dilationRate || 1, 2, "dilationRate");
    this.dilationRate.forEach((rate) => assertPositiveInteger(rate, "dilationRate"));
  }
  build(inputShape) {
    var _a;
    inputShape = getExactlyOneShape(inputShape);
    const channelAxis = this.dataFormat === "channelsFirst" ? 1 : inputShape.length - 1;
    if (inputShape[channelAxis] == null) {
      throw new ValueError(`The channel dimension of the input should be defined. Found ${inputShape[channelAxis]}`);
    }
    const inputDim = inputShape[channelAxis];
    const numOfKernels = 4;
    const kernelShape = this.kernelSize.concat([inputDim, this.filters * numOfKernels]);
    this.kernel = this.addWeight("kernel", kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
    const recurrentKernelShape = this.kernelSize.concat([this.filters, this.filters * numOfKernels]);
    this.recurrentKernel = this.addWeight("recurrent_kernel", recurrentKernelShape, null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
    if (this.useBias) {
      let biasInitializer;
      if (this.unitForgetBias) {
        const init3 = this.biasInitializer;
        const filters = this.filters;
        biasInitializer = new (_a = class CustomInit extends Initializer {
          apply(shape, dtype) {
            const biasI = init3.apply([filters]);
            const biasF = ones([filters]);
            const biasCAndO = init3.apply([filters * 2]);
            return concatenate([biasI, biasF, biasCAndO]);
          }
        }, _a.className = "CustomInit", _a)();
      } else {
        biasInitializer = this.biasInitializer;
      }
      this.bias = this.addWeight("bias", [this.filters * numOfKernels], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
    }
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      if (inputs.length !== 3) {
        throw new ValueError(`ConvLSTM2DCell expects 3 input Tensors (inputs, h, c), got ${inputs.length}.`);
      }
      const training = kwargs["training"] || false;
      const x2 = inputs[0];
      const hTMinus1 = inputs[1];
      const cTMinus1 = inputs[2];
      const numOfKernels = 4;
      if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) {
        this.dropoutMask = generateDropoutMask({
          ones: () => onesLike$3(x2),
          rate: this.dropout,
          training,
          count: numOfKernels,
          dropoutFunc: this.dropoutFunc
        });
      }
      const dropoutMask = this.dropoutMask;
      const applyDropout = (x3, mask, index2) => {
        if (!mask || !mask[index2]) {
          return x3;
        }
        return mul(mask[index2], x3);
      };
      let xI = applyDropout(x2, dropoutMask, 0);
      let xF = applyDropout(x2, dropoutMask, 1);
      let xC = applyDropout(x2, dropoutMask, 2);
      let xO = applyDropout(x2, dropoutMask, 3);
      if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) {
        this.recurrentDropoutMask = generateDropoutMask({
          ones: () => onesLike$3(hTMinus1),
          rate: this.recurrentDropout,
          training,
          count: numOfKernels,
          dropoutFunc: this.dropoutFunc
        });
      }
      const recDropoutMask = this.recurrentDropoutMask;
      let hI = applyDropout(hTMinus1, recDropoutMask, 0);
      let hF = applyDropout(hTMinus1, recDropoutMask, 1);
      let hC = applyDropout(hTMinus1, recDropoutMask, 2);
      let hO = applyDropout(hTMinus1, recDropoutMask, 3);
      const kernelChannelAxis = 3;
      const [kernelI, kernelF, kernelC, kernelO] = split$2(this.kernel.read(), numOfKernels, kernelChannelAxis);
      const [biasI, biasF, biasC, biasO] = this.useBias ? split$2(this.bias.read(), numOfKernels) : [null, null, null, null];
      xI = this.inputConv(xI, kernelI, biasI, this.padding);
      xF = this.inputConv(xF, kernelF, biasF, this.padding);
      xC = this.inputConv(xC, kernelC, biasC, this.padding);
      xO = this.inputConv(xO, kernelO, biasO, this.padding);
      const [recKernelI, recKernelF, recKernelC, recKernelO] = split$2(this.recurrentKernel.read(), numOfKernels, kernelChannelAxis);
      hI = this.recurrentConv(hI, recKernelI);
      hF = this.recurrentConv(hF, recKernelF);
      hC = this.recurrentConv(hC, recKernelC);
      hO = this.recurrentConv(hO, recKernelO);
      const i2 = this.recurrentActivation.apply(add$1(xI, hI));
      const f2 = this.recurrentActivation.apply(add$1(xF, hF));
      const c2 = add$1(mul(f2, cTMinus1), mul(i2, this.activation.apply(add$1(xC, hC))));
      const h2 = mul(this.recurrentActivation.apply(add$1(xO, hO)), this.activation.apply(c2));
      return [h2, h2, c2];
    });
  }
  getConfig() {
    const _a = super.getConfig(), baseConfig = __rest$2(_a, ["units"]);
    const config2 = {
      filters: this.filters,
      kernelSize: this.kernelSize,
      padding: this.padding,
      dataFormat: this.dataFormat,
      dilationRate: this.dilationRate,
      strides: this.strides
    };
    return Object.assign({}, baseConfig, config2);
  }
  inputConv(x2, w2, b2, padding) {
    const out = conv2d$3(x2, w2, this.strides, padding || "valid", this.dataFormat === "channelsFirst" ? "NCHW" : "NHWC", this.dilationRate);
    if (b2) {
      return biasAdd(out, b2, this.dataFormat);
    }
    return out;
  }
  recurrentConv(x2, w2) {
    const strides = 1;
    return conv2d$3(x2, w2, strides, "same", this.dataFormat === "channelsFirst" ? "NCHW" : "NHWC");
  }
}
ConvLSTM2DCell.className = "ConvLSTM2DCell";
registerClass(ConvLSTM2DCell);
class ConvLSTM2D extends ConvRNN2D {
  constructor(args) {
    const cell = new ConvLSTM2DCell(args);
    super(Object.assign({}, args, { cell }));
  }
  static fromConfig(cls, config2) {
    return new cls(config2);
  }
}
ConvLSTM2D.className = "ConvLSTM2D";
registerClass(ConvLSTM2D);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Dropout extends Layer {
  constructor(args) {
    super(args);
    this.rate = Math.max(Math.min(args.rate, 1), 0);
    this.noiseShape = args.noiseShape;
    this.seed = args.seed;
    this.supportsMasking = true;
  }
  getNoiseShape(input) {
    if (this.noiseShape == null) {
      return this.noiseShape;
    }
    const inputShape = input.shape;
    const noiseShape = [];
    for (let i2 = 0; i2 < this.noiseShape.length; ++i2) {
      noiseShape.push(this.noiseShape[i2] == null ? inputShape[i2] : this.noiseShape[i2]);
    }
    return noiseShape;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      if (0 < this.rate && this.rate < 1) {
        const training = kwargs["training"] == null ? false : kwargs["training"];
        const noiseShape = this.getNoiseShape(input);
        const output2 = inTrainPhase(() => dropout(input, this.rate, noiseShape, this.seed), () => input, training);
        return output2;
      }
      return inputs;
    });
  }
  getConfig() {
    const config2 = {
      rate: this.rate,
      noiseShape: this.noiseShape,
      seed: this.seed
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
  dispose() {
    return super.dispose();
  }
}
Dropout.className = "Dropout";
registerClass(Dropout);
class SpatialDropout1D extends Dropout {
  constructor(args) {
    super(args);
    this.inputSpec = [{ ndim: 3 }];
  }
  getNoiseShape(input) {
    const inputShape = input.shape;
    return [inputShape[0], 1, inputShape[2]];
  }
}
SpatialDropout1D.className = "SpatialDropout1D";
registerClass(SpatialDropout1D);
class Dense extends Layer {
  constructor(args) {
    super(args);
    this.activation = null;
    this.useBias = true;
    this.kernel = null;
    this.bias = null;
    this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal";
    this.DEFAULT_BIAS_INITIALIZER = "zeros";
    if (args.batchInputShape == null && args.inputShape == null && args.inputDim != null) {
      let batchSize = null;
      if (args.batchSize != null) {
        batchSize = args.batchSize;
      }
      this.batchInputShape = [batchSize, args.inputDim];
    }
    this.units = args.units;
    assertPositiveInteger(this.units, "units");
    this.activation = getActivation(args.activation);
    if (args.useBias != null) {
      this.useBias = args.useBias;
    }
    this.kernelInitializer = getInitializer(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
    this.biasInitializer = getInitializer(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
    this.kernelConstraint = getConstraint(args.kernelConstraint);
    this.biasConstraint = getConstraint(args.biasConstraint);
    this.kernelRegularizer = getRegularizer(args.kernelRegularizer);
    this.biasRegularizer = getRegularizer(args.biasRegularizer);
    this.activityRegularizer = getRegularizer(args.activityRegularizer);
    this.supportsMasking = true;
    this.inputSpec = [{ minNDim: 2 }];
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const inputLastDim = inputShape[inputShape.length - 1];
    if (this.kernel == null) {
      this.kernel = this.addWeight("kernel", [inputLastDim, this.units], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
      if (this.useBias) {
        this.bias = this.addWeight("bias", [this.units], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
      }
    }
    this.inputSpec = [{ minNDim: 2, axes: { [-1]: inputLastDim } }];
    this.built = true;
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const outputShape = inputShape.slice();
    outputShape[outputShape.length - 1] = this.units;
    return outputShape;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      const fusedActivationName = mapActivationToFusedKernel(this.activation.getClassName());
      let output2;
      if (fusedActivationName != null) {
        output2 = dot(input, this.kernel.read(), fusedActivationName, this.bias ? this.bias.read() : null);
      } else {
        output2 = dot(input, this.kernel.read());
        if (this.bias != null) {
          output2 = biasAdd(output2, this.bias.read());
        }
        if (this.activation != null) {
          output2 = this.activation.apply(output2);
        }
      }
      return output2;
    });
  }
  getConfig() {
    const config2 = {
      units: this.units,
      activation: serializeActivation(this.activation),
      useBias: this.useBias,
      kernelInitializer: serializeInitializer(this.kernelInitializer),
      biasInitializer: serializeInitializer(this.biasInitializer),
      kernelRegularizer: serializeRegularizer(this.kernelRegularizer),
      biasRegularizer: serializeRegularizer(this.biasRegularizer),
      activityRegularizer: serializeRegularizer(this.activityRegularizer),
      kernelConstraint: serializeConstraint(this.kernelConstraint),
      biasConstraint: serializeConstraint(this.biasConstraint)
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Dense.className = "Dense";
registerClass(Dense);
class Flatten extends Layer {
  constructor(args) {
    args = args || {};
    super(args);
    this.inputSpec = [{ minNDim: 3 }];
    this.dataFormat = args.dataFormat;
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    for (const dim of inputShape.slice(1)) {
      if (dim == null) {
        throw new ValueError(`The shape of the input to "Flatten" is not fully defined (got ${inputShape.slice(1)}). Make sure to pass a complete "input_shape" or "batch_input_shape" argument to the first layer in your model.`);
      }
    }
    return [inputShape[0], arrayProd(inputShape, 1)];
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      let input = getExactlyOneTensor(inputs);
      if (this.dataFormat === "channelsFirst" && input.rank > 1) {
        const permutation = [0];
        for (let i2 = 2; i2 < input.rank; ++i2) {
          permutation.push(i2);
        }
        permutation.push(1);
        input = transpose$3(input, permutation);
      }
      return batchFlatten(input);
    });
  }
  getConfig() {
    const config2 = {};
    if (this.dataFormat != null) {
      config2["dataFormat"] = this.dataFormat;
    }
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Flatten.className = "Flatten";
registerClass(Flatten);
class Activation extends Layer {
  constructor(args) {
    super(args);
    this.supportsMasking = true;
    this.activation = getActivation(args.activation);
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      return this.activation.apply(input);
    });
  }
  getConfig() {
    const config2 = { activation: serializeActivation(this.activation) };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Activation.className = "Activation";
registerClass(Activation);
class RepeatVector extends Layer {
  constructor(args) {
    super(args);
    this.n = args.n;
    this.inputSpec = [{ ndim: 2 }];
  }
  computeOutputShape(inputShape) {
    return [inputShape[0], this.n, inputShape[1]];
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = getExactlyOneTensor(inputs);
      return repeat$1(inputs, this.n);
    });
  }
  getConfig() {
    const config2 = {
      n: this.n
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
RepeatVector.className = "RepeatVector";
registerClass(RepeatVector);
class Reshape extends Layer {
  constructor(args) {
    super(args);
    this.targetShape = args.targetShape;
    for (let i2 = 0; i2 < this.targetShape.length; ++i2) {
      if (this.isUnknown(this.targetShape[i2])) {
        this.targetShape[i2] = null;
      }
    }
  }
  isUnknown(dim) {
    return dim < 0 || dim == null;
  }
  fixUnknownDimension(inputShape, outputShape) {
    const errorMsg = "Total size of new array must be unchanged.";
    const finalShape = outputShape.slice();
    let known = 1;
    let unknown = null;
    for (let i2 = 0; i2 < finalShape.length; ++i2) {
      const dim = finalShape[i2];
      if (this.isUnknown(dim)) {
        if (unknown === null) {
          unknown = i2;
        } else {
          throw new ValueError("Can only specifiy one unknown dimension.");
        }
      } else {
        known *= dim;
      }
    }
    const originalSize = arrayProd(inputShape);
    if (unknown !== null) {
      if (known === 0 || originalSize % known !== 0) {
        throw new ValueError(errorMsg);
      }
      finalShape[unknown] = originalSize / known;
    } else if (originalSize !== known) {
      throw new ValueError(errorMsg);
    }
    return finalShape;
  }
  computeOutputShape(inputShape) {
    let anyUnknownDims = false;
    for (let i2 = 0; i2 < inputShape.length; ++i2) {
      if (this.isUnknown(inputShape[i2])) {
        anyUnknownDims = true;
        break;
      }
    }
    if (anyUnknownDims) {
      return inputShape.slice(0, 1).concat(this.targetShape);
    } else {
      return inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      const inputShape = input.shape;
      const outputShape = inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
      return reshape$3(input, outputShape);
    });
  }
  getConfig() {
    const config2 = {
      targetShape: this.targetShape
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Reshape.className = "Reshape";
registerClass(Reshape);
class Permute extends Layer {
  constructor(args) {
    super(args);
    if (args.dims == null) {
      throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
    }
    if (!Array.isArray(args.dims)) {
      throw new Error(`Permute constructor requires \`dims\` to be an Array, but received ${args.dims} instead.`);
    }
    const expectedSortedIndices = range$3(1, args.dims.length + 1);
    if (!arraysEqual(args.dims.slice().sort(), expectedSortedIndices)) {
      throw new Error("Invalid permutation `dims`: " + JSON.stringify(args.dims) + " `dims` must contain consecutive integers starting from 1.");
    }
    this.dims = args.dims;
    this.dimsIncludingBatch = [0].concat(this.dims);
    this.inputSpec = [new InputSpec({ ndim: this.dims.length + 1 })];
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const outputShape = inputShape.slice();
    this.dims.forEach((dim, i2) => {
      outputShape[i2 + 1] = inputShape[dim];
    });
    return outputShape;
  }
  call(inputs, kwargs) {
    return transpose$3(getExactlyOneTensor(inputs), this.dimsIncludingBatch);
  }
  getConfig() {
    const config2 = {
      dims: this.dims
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Permute.className = "Permute";
registerClass(Permute);
class Masking extends Layer {
  constructor(args) {
    super(args == null ? {} : args);
    this.supportsMasking = true;
    if (args != null) {
      this.maskValue = args.maskValue == null ? 0 : args.maskValue;
    } else {
      this.maskValue = 0;
    }
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = { maskValue: this.maskValue };
    Object.assign(config2, baseConfig);
    return config2;
  }
  computeMask(inputs, mask) {
    const input = getExactlyOneTensor(inputs);
    const axis = -1;
    return any$3(notEqual$2(input, this.maskValue), axis);
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      const axis = -1;
      const keepDims = true;
      const booleanMask = any$3(notEqual$2(input, this.maskValue), axis, keepDims);
      const output2 = mul(input, cast$4(booleanMask, input.dtype));
      return output2;
    });
  }
}
Masking.className = "Masking";
registerClass(Masking);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Embedding extends Layer {
  constructor(args) {
    super(args);
    this.embeddings = null;
    this.DEFAULT_EMBEDDINGS_INITIALIZER = "randomUniform";
    if (args.batchInputShape == null && args.inputShape == null) {
      let batchSize = null;
      if (args.batchSize != null) {
        batchSize = args.batchSize;
      }
      if (args.inputLength == null) {
        this.batchInputShape = [batchSize, null];
      } else {
        this.batchInputShape = [batchSize].concat(toList(args.inputLength));
      }
    }
    this.inputDim = args.inputDim;
    assertPositiveInteger(this.inputDim, "inputDim");
    this.outputDim = args.outputDim;
    assertPositiveInteger(this.outputDim, "outputDim");
    this.embeddingsInitializer = getInitializer(args.embeddingsInitializer || this.DEFAULT_EMBEDDINGS_INITIALIZER);
    this.embeddingsRegularizer = getRegularizer(args.embeddingsRegularizer);
    this.activityRegularizer = getRegularizer(args.activityRegularizer);
    this.embeddingsConstraint = getConstraint(args.embeddingsConstraint);
    this.maskZero = args.maskZero;
    this.supportsMasking = args.maskZero;
    this.inputLength = args.inputLength;
  }
  build(inputShape) {
    this.embeddings = this.addWeight("embeddings", [this.inputDim, this.outputDim], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, true, this.embeddingsConstraint);
    this.built = true;
  }
  warnOnIncompatibleInputShape(inputShape) {
  }
  computeMask(inputs, mask) {
    return tidy(() => {
      if (!this.maskZero) {
        return null;
      } else {
        inputs = getExactlyOneTensor(inputs);
        return notEqual$2(inputs, zerosLike$3(inputs));
      }
    });
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    if (this.inputLength == null) {
      return [...inputShape, this.outputDim];
    }
    const inLens = toList(this.inputLength);
    if (inLens.length !== inputShape.length - 1) {
      throw new ValueError(`"inputLength" is ${this.inputLength}, but received input shape has shape ${inputShape}`);
    } else {
      let i2 = 0;
      for (let k3 = 0; k3 < inLens.length; ++k3) {
        const s1 = inLens[k3];
        const s2 = inputShape[k3 + 1];
        if (s1 != null && s2 != null && s1 !== s2) {
          throw new ValueError(`"inputLength" is ${this.inputLength}, but received input shape has shape ${inputShape}`);
        } else if (s1 == null) {
          inLens[i2] = s2;
        }
        i2++;
      }
    }
    return [inputShape[0], ...inLens, this.outputDim];
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      let input = getExactlyOneTensor(inputs);
      if (input.dtype !== "int32") {
        input = cast$3(input, "int32");
      }
      const output2 = gather(this.embeddings.read(), reshape$3(input, [input.size]));
      return reshape$3(output2, getExactlyOneShape(this.computeOutputShape(input.shape)));
    });
  }
  getConfig() {
    const config2 = {
      inputDim: this.inputDim,
      outputDim: this.outputDim,
      embeddingsInitializer: serializeInitializer(this.embeddingsInitializer),
      embeddingsRegularizer: serializeRegularizer(this.embeddingsRegularizer),
      activityRegularizer: serializeRegularizer(this.activityRegularizer),
      embeddingsConstraint: serializeConstraint(this.embeddingsConstraint),
      maskZero: this.maskZero,
      inputLength: this.inputLength
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Embedding.className = "Embedding";
registerClass(Embedding);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Merge extends Layer {
  constructor(args) {
    super(args || {});
    this.supportsMasking = true;
  }
  mergeFunction(inputs) {
    throw new NotImplementedError();
  }
  computeElementwiseOpOutputShape(shape1, shape2) {
    if (shape1 == null || shape2 == null) {
      return null;
    } else if (shape1.length < shape2.length) {
      return this.computeElementwiseOpOutputShape(shape2, shape1);
    } else if (shape2.length === 0) {
      return shape1;
    }
    const outputShape = shape1.slice(0, shape1.length - shape2.length);
    for (let k3 = 0; k3 < shape2.length; ++k3) {
      const i2 = shape1[shape1.length - shape2.length + k3];
      const j2 = shape2[k3];
      if (i2 == null || j2 == null || i2 < 0 || j2 < 0) {
        outputShape.push(null);
      } else if (i2 === 1) {
        outputShape.push(j2);
      } else if (j2 === 1) {
        outputShape.push(i2);
      } else {
        if (i2 !== j2) {
          throw new ValueError("Operands could not be broadcast together with shapes " + JSON.stringify(shape1) + " " + JSON.stringify(shape2));
        }
        outputShape.push(i2);
      }
    }
    return outputShape;
  }
  build(inputShape) {
    if (Array.isArray(inputShape) && !Array.isArray(inputShape[0])) {
      inputShape = [getExactlyOneShape(inputShape)];
    }
    inputShape = inputShape;
    if (inputShape.length < 2) {
      throw new ValueError(`A merge layer should be called on an Array of at least 2 inputs. Got ${inputShape.length} input(s).`);
    }
    let batchSizes = [];
    for (const shape of inputShape) {
      if (shape != null && shape[0] !== null) {
        batchSizes.push(shape[0]);
      }
    }
    batchSizes = unique$2(batchSizes);
    if (batchSizes.length > 1) {
      throw new ValueError(`Can not merge tensors with different batch sizes. Got tensors with shapes: ${JSON.stringify(inputShape)}.`);
    }
    let outputShape = inputShape[0] == null ? null : inputShape[0].slice(1);
    for (let i2 = 1; i2 < inputShape.length; ++i2) {
      const shape = inputShape[i2] == null ? null : inputShape[i2].slice(1);
      outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
    }
    const allRanks = inputShape.map((shape) => shape.length);
    if (inputShape.indexOf(null) === -1 && unique$2(allRanks).length === 1) {
      this.reshapeRequired = false;
    } else {
      this.reshapeRequired = true;
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = inputs;
      if (this.reshapeRequired) {
        const reshapedInputs = [];
        const inputDims = inputs.map((input) => input.rank);
        if (inputDims.indexOf(null) === -1) {
          const maxNDim = max$3(inputDims);
          for (let x2 of inputs) {
            const xNDim = x2.rank;
            for (let k3 = 0; k3 < maxNDim - xNDim; ++k3) {
              x2 = expandDims$3(x2, 1);
            }
            reshapedInputs.push(x2);
          }
          return this.mergeFunction(reshapedInputs);
        } else {
          let transposed = false;
          for (const x2 of inputs) {
            const xNDim = x2.rank;
            if (xNDim == null) {
              const xShape = x2.shape;
              const batchSize = xShape[0];
              const newShape = xShape.slice(1).concat([batchSize]);
              let xTransposed = reshape$3(x2, [batchSize].concat(arrayProd(xShape.slice(1))));
              xTransposed = transpose$3(xTransposed, [1, 0]);
              xTransposed = reshape$3(xTransposed, newShape);
              reshapedInputs.push(xTransposed);
              transposed = true;
            } else if (xNDim > 1) {
              const dims = range$3(1, xNDim).concat([0]);
              reshapedInputs.push(transpose$3(x2, dims));
              transposed = true;
            } else {
              reshapedInputs.push(x2);
            }
          }
          let y2 = this.mergeFunction(reshapedInputs);
          const yNDim = y2.rank;
          if (transposed) {
            if (yNDim == null) {
              const yShape = y2.shape;
              const yNDim2 = yShape.length;
              const batchSize = yShape[yNDim2 - 1];
              const newShape = [batchSize].concat(yShape.slice(0, yShape.length - 1));
              y2 = reshape$3(transpose$3(reshape$3(y2, [-1, batchSize]), [1, 0]), newShape);
            } else if (yNDim > 1) {
              const dims = [yNDim - 1].concat(range$3(0, yNDim - 1));
              y2 = transpose$3(y2, dims);
            }
          }
          return y2;
        }
      } else {
        return this.mergeFunction(inputs);
      }
    });
  }
  computeOutputShape(inputShape) {
    inputShape = inputShape;
    let outputShape;
    if (inputShape[0] == null) {
      outputShape = null;
    } else {
      outputShape = inputShape[0].slice(1);
    }
    for (let i2 = 1; i2 < inputShape.length; ++i2) {
      const shape = inputShape[i2] == null ? null : inputShape[i2].slice(1);
      outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
    }
    let batchSizes = [];
    for (const shape of inputShape) {
      if (shape != null && shape[0] !== null) {
        batchSizes.push(shape[0]);
      }
    }
    batchSizes = unique$2(batchSizes);
    if (batchSizes.length === 1) {
      outputShape = batchSizes.concat(outputShape);
    } else {
      outputShape = [null].concat(outputShape);
    }
    return outputShape;
  }
  computeMask(inputs, mask) {
    return tidy(() => {
      if (mask == null) {
        return null;
      }
      if (!Array.isArray(mask)) {
        throw new ValueError("`mask` should be an Array");
      }
      if (!Array.isArray(inputs)) {
        throw new ValueError("`inputs` should be an Array");
      }
      if (mask.length !== inputs.length) {
        throw new ValueError(`The Array 'inputs' and 'mask' are expected to have the same length, but have different lengths (${inputs.length} vs ${mask.length})`);
      }
      if (mask.every((m2) => m2 == null)) {
        return null;
      }
      mask = mask.map((m2) => m2 == null ? m2 : expandDims$4(m2, 0));
      let output2 = mask[0];
      for (let i2 = 1; i2 < mask.length - 1; ++i2) {
        output2 = logicalAnd$2(output2, mask[i2]);
      }
      return output2;
    });
  }
}
class Add extends Merge {
  constructor(args) {
    super(args);
  }
  mergeFunction(inputs) {
    return tidy(() => {
      let output2 = inputs[0].clone();
      for (let i2 = 1; i2 < inputs.length; ++i2) {
        output2 = add$1(output2, inputs[i2]);
      }
      return output2;
    });
  }
}
Add.className = "Add";
registerClass(Add);
class Multiply extends Merge {
  constructor(args) {
    super(args);
  }
  mergeFunction(inputs) {
    return tidy(() => {
      let output2 = inputs[0].clone();
      for (let i2 = 1; i2 < inputs.length; ++i2) {
        output2 = mul(output2, inputs[i2]);
      }
      return output2;
    });
  }
}
Multiply.className = "Multiply";
registerClass(Multiply);
class Average extends Merge {
  constructor(args) {
    super(args);
  }
  mergeFunction(inputs) {
    return tidy(() => {
      let output2 = inputs[0].clone();
      for (let i2 = 1; i2 < inputs.length; ++i2) {
        output2 = add$1(output2, inputs[i2]);
      }
      return mul(1 / inputs.length, output2);
    });
  }
}
Average.className = "Average";
registerClass(Average);
class Maximum extends Merge {
  constructor(args) {
    super(args);
  }
  mergeFunction(inputs) {
    return tidy(() => {
      let output2 = inputs[0];
      for (let i2 = 1; i2 < inputs.length; ++i2) {
        output2 = maximum$2(output2, inputs[i2]);
      }
      return output2;
    });
  }
}
Maximum.className = "Maximum";
registerClass(Maximum);
class Minimum extends Merge {
  constructor(args) {
    super(args);
  }
  mergeFunction(inputs) {
    return tidy(() => {
      let output2 = inputs[0];
      for (let i2 = 1; i2 < inputs.length; ++i2) {
        output2 = minimum$2(output2, inputs[i2]);
      }
      return output2;
    });
  }
}
Minimum.className = "Minimum";
registerClass(Minimum);
class Concatenate extends Merge {
  constructor(args) {
    super(args);
    this.DEFAULT_AXIS = -1;
    if (args == null) {
      args = {};
    }
    this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
    this.supportsMasking = true;
    this.reshapeRequired = false;
  }
  build(inputShape) {
    if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0])) || inputShape.length === 1) {
      throw new ValueError("A `Concatenate` layer should be called on a list of at least 2 inputs");
    }
    inputShape = inputShape;
    let allNoneShape = true;
    for (const shape of inputShape) {
      if (shape != null) {
        allNoneShape = false;
        break;
      }
    }
    if (allNoneShape) {
      return;
    }
    const shapeSet = [];
    for (let i2 = 0; i2 < inputShape.length; ++i2) {
      const shapeWithoutConcatAxis = inputShape[i2].slice();
      shapeWithoutConcatAxis.splice(this.axis, 1);
      let exists = false;
      for (const shape of shapeSet) {
        if (arraysEqual(shape, shapeWithoutConcatAxis)) {
          exists = true;
          break;
        }
      }
      if (!exists) {
        shapeSet.push(shapeWithoutConcatAxis);
      }
    }
    if (shapeSet.length > 1) {
      throw new ValueError("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(inputShape));
    }
  }
  mergeFunction(inputs) {
    return tidy(() => {
      return concatenate(inputs, this.axis);
    });
  }
  computeOutputShape(inputShape) {
    if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0]))) {
      throw new ValueError("A `Concatenate` layer should be called on a list of inputs.");
    }
    const inputShapes = inputShape;
    const outputShape = inputShapes[0].slice();
    const axis = this.axis < 0 ? outputShape.length + this.axis : this.axis;
    for (const shape of inputShapes.slice(1)) {
      if (outputShape[axis] == null || shape[axis] == null) {
        outputShape[axis] = null;
        break;
      }
      outputShape[axis] += shape[axis];
    }
    return outputShape;
  }
  computeMask(inputs, mask) {
    if (mask == null) {
      return null;
    }
    if (!Array.isArray(mask)) {
      throw new ValueError("`mask` should be an array for Concatenate");
    }
    if (!Array.isArray(inputs)) {
      throw new ValueError("`inputs` should be an array for Concatenate");
    }
    if (mask.length !== inputs.length) {
      throw new ValueError(`Mismatch in the length of mask (${mask.length}) and the legnth of inputs (${inputs.length})`);
    }
    return tidy(() => {
      let allNullMasks = true;
      mask.forEach((m2) => {
        if (m2 != null) {
          allNullMasks = false;
          return;
        }
      });
      if (allNullMasks) {
        return null;
      }
      const outputMasks = [];
      for (let i2 = 0; i2 < inputs.length; ++i2) {
        if (mask[i2] == null) {
          outputMasks.push(cast$4(onesLike$3(inputs[i2]), "bool"));
        } else if (mask[i2].rank < inputs[i2].rank) {
          outputMasks.push(expandDims$4(mask[i2], -1));
        } else {
          outputMasks.push(mask[i2]);
        }
      }
      const concatenatedMasks = concat$3(outputMasks, this.axis);
      return all$3(concatenatedMasks, -1, false);
    });
  }
  getConfig() {
    const config2 = {
      "axis": this.axis
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Concatenate.className = "Concatenate";
registerClass(Concatenate);
function interpretAxis(axis, dim) {
  while (axis < 0) {
    axis += dim;
  }
  return axis;
}
function batchDot(x2, y2, axes) {
  if (x2.shape.length > 3 || y2.shape.length > 3) {
    throw new NotImplementedError("batchDot is not implemented for tensors of 4D or higher rank yet");
  }
  assert$1(x2.shape.length >= 2, () => `batchDot requires the rank of x to be >= 2, but got ${x2.shape.length}`);
  assert$1(x2.shape.length >= 2, () => `batchDot requires the rank of y to be >= 2, but got ${y2.shape.length}`);
  if (typeof axes === "number") {
    axes = [axes, axes];
  }
  if (x2.dtype === "complex64" || y2.dtype === "complex64") {
    throw new NotImplementedError("batchDot is not implemented for complex64-type Tensors yet.");
  }
  const xNDim = x2.shape.length;
  const yNDim = y2.shape.length;
  if (axes == null) {
    axes = [xNDim - 1, yNDim - 2];
  }
  const axesArray = axes;
  return tidy(() => {
    let diff;
    if (xNDim > yNDim) {
      diff = xNDim - yNDim;
      const diffShape = [];
      for (let i2 = 0; i2 < diff; ++i2) {
        diffShape.push(1);
      }
      y2 = reshape$3(y2, y2.shape.concat(diffShape));
    } else if (yNDim > xNDim) {
      diff = yNDim - xNDim;
      const diffShape = [];
      for (let i2 = 0; i2 < diff; ++i2) {
        diffShape.push(1);
      }
      x2 = reshape$3(x2, x2.shape.concat(diffShape));
    } else {
      diff = 0;
    }
    let out;
    if (x2.shape.length === 2 && y2.shape.length === 2) {
      if (axesArray[0] === axesArray[1]) {
        out = sum$3(mul(x2, y2), axesArray[0]);
      } else {
        out = sum$3(mul(transpose$3(x2, [1, 0]), y2), axesArray[1]);
      }
    } else {
      const adjX = axesArray[0] !== x2.shape.length - 1;
      const adjY = axesArray[1] === y2.shape.length - 1;
      out = matMul$1(x2, y2, adjX, adjY);
    }
    if (diff > 0) {
      let idx;
      if (xNDim > yNDim) {
        idx = xNDim + yNDim - 3;
      } else {
        idx = xNDim - 1;
      }
      const squeezeAxes = [];
      for (let i2 = idx; i2 < idx + diff; ++i2) {
        squeezeAxes.push(i2);
      }
      out = squeeze(out, squeezeAxes);
    }
    if (out.shape.length === 1) {
      out = expandDims$4(out, 1);
    }
    return out;
  });
}
class Dot extends Merge {
  constructor(args) {
    super(args);
    this.axes = args.axes;
    this.normalize = args.normalize == null ? false : args.normalize;
    this.supportsMasking = true;
    this.reshapeRequired = false;
  }
  build(inputShape) {
    assert$1(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), () => "A `Dot` layer should be called on a list of exactly 2 inputs.");
    const shape1 = inputShape[0];
    const shape2 = inputShape[1];
    if (shape1.length > 3 || shape2.length > 3) {
      throw new NotImplementedError("Dot layer does not support tensors of 4D or higher rank yet.");
    }
    const axes = this.interpretAxes(shape1, shape2);
    if (shape1[axes[0]] !== shape2[axes[1]]) {
      throw new ValueError(`Dimension incompatibility: ${shape1[axes[0]]} !== ${shape2[axes[1]]}`);
    }
  }
  mergeFunction(inputs) {
    if (inputs.length !== 2) {
      throw new ValueError(`A \`Dot\` layer must be called on exactly 2 inputs, but received ${inputs.length} input(s).`);
    }
    let x1 = inputs[0];
    let x2 = inputs[1];
    let axes;
    if (!Array.isArray(this.axes)) {
      axes = [
        interpretAxis(this.axes, x1.shape.length),
        interpretAxis(this.axes, x2.shape.length)
      ];
    } else {
      axes = this.axes.map((axis, i2) => interpretAxis(axis, inputs[i2].shape.length));
    }
    if (this.normalize) {
      x1 = l2Normalize(x1, axes[0]);
      x2 = l2Normalize(x2, axes[1]);
    }
    return batchDot(x1, x2, axes);
  }
  interpretAxes(shape1, shape2) {
    let axes;
    if (!Array.isArray(this.axes)) {
      axes = [
        interpretAxis(this.axes, shape1.length),
        interpretAxis(this.axes, shape2.length)
      ];
    } else {
      axes = this.axes;
    }
    return axes;
  }
  computeOutputShape(inputShape) {
    assert$1(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), () => "A `Dot` layer should be called on a list of exactly 2 inputs.");
    const shape1 = inputShape[0].slice();
    const shape2 = inputShape[1].slice();
    if (shape1.length > 3 || shape2.length > 3) {
      throw new NotImplementedError("Dot layer does not support tensors of 4D or higher rank yet.");
    }
    const axes = this.interpretAxes(shape1, shape2);
    shape1.splice(axes[0], 1);
    shape2.splice(axes[1], 1);
    shape2.splice(0, 1);
    const outputShape = shape1.concat(shape2);
    if (outputShape.length === 1) {
      outputShape.push(1);
    }
    return outputShape;
  }
  computeMask(inputs, mask) {
    return null;
  }
  getConfig() {
    const config2 = {
      "axes": this.axes,
      "normalize": this.normalize
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
Dot.className = "Dot";
registerClass(Dot);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class GaussianNoise extends Layer {
  constructor(args) {
    super(args);
    this.supportsMasking = true;
    this.stddev = args.stddev;
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = { stddev: this.stddev };
    Object.assign(config2, baseConfig);
    return config2;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      const noised = () => add$1(randomNormal(input.shape, 0, this.stddev), input);
      const output2 = inTrainPhase(noised, () => input, kwargs["training"] || false);
      return output2;
    });
  }
}
GaussianNoise.className = "GaussianNoise";
registerClass(GaussianNoise);
class GaussianDropout extends Layer {
  constructor(args) {
    super(args);
    this.supportsMasking = true;
    this.rate = args.rate;
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = { rate: this.rate };
    Object.assign(config2, baseConfig);
    return config2;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      const input = getExactlyOneTensor(inputs);
      if (this.rate > 0 && this.rate < 1) {
        const noised = () => {
          const stddev = Math.sqrt(this.rate / (1 - this.rate));
          return mul(input, randomNormal(input.shape, 1, stddev));
        };
        return inTrainPhase(noised, () => input, kwargs["training"] || false);
      }
      return input;
    });
  }
}
GaussianDropout.className = "GaussianDropout";
registerClass(GaussianDropout);
class AlphaDropout extends Layer {
  constructor(args) {
    super(args);
    this.supportsMasking = true;
    this.rate = args.rate;
    this.noiseShape = args.noiseShape;
  }
  _getNoiseShape(inputs) {
    return this.noiseShape || getExactlyOneTensor(inputs).shape;
  }
  computeOutputShape(inputShape) {
    return inputShape;
  }
  getConfig() {
    const baseConfig = super.getConfig();
    const config2 = { rate: this.rate };
    Object.assign(config2, baseConfig);
    return config2;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      if (this.rate < 1 && this.rate > 0) {
        const noiseShape = this._getNoiseShape(inputs);
        const droppedInputs = () => {
          const input = getExactlyOneTensor(inputs);
          const alpha2 = 1.6732632423543772;
          const scale2 = 1.0507009873554805;
          const alphaP = -alpha2 * scale2;
          let keptIdx = greaterEqual$2(randomUniform(noiseShape), this.rate);
          keptIdx = cast$3(keptIdx, "float32");
          const a6 = ((1 - this.rate) * (1 + this.rate * alphaP ** 2)) ** -0.5;
          const b2 = -a6 * alphaP * this.rate;
          const x2 = add$1(mul(input, keptIdx), mul(add$1(keptIdx, -1), alphaP));
          return add$1(mul(x2, a6), b2);
        };
        return inTrainPhase(droppedInputs, () => getExactlyOneTensor(inputs), kwargs["training"] || false);
      }
      return inputs;
    });
  }
}
AlphaDropout.className = "AlphaDropout";
registerClass(AlphaDropout);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function batchNormalization(x2, mean2, variance, beta, gamma, epsilon2 = 1e-3) {
  let out;
  if (x2.rank === 2) {
    out = batchNorm2d(x2, mean2, variance, beta, gamma, epsilon2);
  } else if (x2.rank === 3) {
    out = batchNorm3d(x2, mean2, variance, beta, gamma, epsilon2);
  } else if (x2.rank === 4) {
    out = batchNorm4d(x2, mean2, variance, beta, gamma, epsilon2);
  } else {
    throw new NotImplementedError(`batchNormalization is not implemented for array of rank ${x2.rank} yet`);
  }
  return out;
}
function regularNormalizeBatchInTraining(x2, gamma, beta, reductionAxes, epsilon2 = 1e-3) {
  return tidy(() => {
    const meanAndVariance = moments(x2, reductionAxes);
    const mean2 = meanAndVariance.mean;
    const variance = meanAndVariance.variance;
    const normed = batchNormalization(x2, mean2, variance, beta, gamma, epsilon2);
    return [normed, mean2, variance];
  });
}
function broadcastNormalizeBatchInTraining(x2, gamma, beta, reductionAxes, epsilon2 = 1e-3) {
  return tidy(() => {
    const meanAndVariance = moments(x2, reductionAxes);
    const mean2 = meanAndVariance.mean;
    const variance = meanAndVariance.variance;
    const targetShape = [];
    for (const axis of range$3(0, x2.rank)) {
      if (reductionAxes.indexOf(axis) !== -1) {
        targetShape.push(1);
      } else {
        targetShape.push(x2.shape[axis]);
      }
    }
    const broadcastMean = reshape$3(mean2, targetShape);
    const broadcastVariance = reshape$3(variance, targetShape);
    const broadcastGamma = gamma == null ? null : reshape$3(gamma, targetShape);
    const broadcastBeta = beta == null ? null : reshape$3(beta, targetShape);
    const normed = batchNormalization(x2, broadcastMean, broadcastVariance, broadcastBeta, broadcastGamma, epsilon2);
    return [normed, mean2, variance];
  });
}
function normalizeBatchInTraining(x2, gamma, beta, reductionAxes, epsilon2 = 1e-3) {
  if (arraysEqual(reductionAxes.slice().sort(), range$3(0, x2.rank - 1))) {
    return regularNormalizeBatchInTraining(x2, gamma, beta, reductionAxes, epsilon2);
  } else {
    return broadcastNormalizeBatchInTraining(x2, gamma, beta, reductionAxes, epsilon2);
  }
}
class BatchNormalization extends Layer {
  constructor(args) {
    if (args == null) {
      args = {};
    }
    super(args);
    this.supportsMasking = true;
    this.axis = args.axis == null ? -1 : args.axis;
    this.momentum = args.momentum == null ? 0.99 : args.momentum;
    this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
    this.center = args.center == null ? true : args.center;
    this.scale = args.scale == null ? true : args.scale;
    this.betaInitializer = getInitializer(args.betaInitializer || "zeros");
    this.gammaInitializer = getInitializer(args.gammaInitializer || "ones");
    this.movingMeanInitializer = getInitializer(args.movingMeanInitializer || "zeros");
    this.movingVarianceInitializer = getInitializer(args.movingVarianceInitializer || "ones");
    this.betaConstraint = getConstraint(args.betaConstraint);
    this.gammaConstraint = getConstraint(args.gammaConstraint);
    this.betaRegularizer = getRegularizer(args.betaRegularizer);
    this.gammaRegularizer = getRegularizer(args.gammaRegularizer);
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const axis = this.axis >= 0 ? this.axis : this.axis + inputShape.length;
    const dim = inputShape[axis];
    if (dim == null) {
      throw new ValueError(`Axis ${axis} of input tensor should have a defined dimension but the layer received an input with shape ${JSON.stringify(inputShape)}.`);
    }
    this.inputSpec = [new InputSpec({ ndim: inputShape.length, axes: { [axis]: dim } })];
    const shape = [dim];
    if (this.scale) {
      this.gamma = this.addWeight("gamma", shape, null, this.gammaInitializer, this.gammaRegularizer, true, this.gammaConstraint);
    }
    if (this.center) {
      this.beta = this.addWeight("beta", shape, null, this.betaInitializer, this.betaRegularizer, true, this.betaConstraint);
    }
    this.movingMean = this.addWeight("moving_mean", shape, null, this.movingMeanInitializer, null, false);
    this.movingVariance = this.addWeight("moving_variance", shape, null, this.movingVarianceInitializer, null, false);
    this.built = true;
  }
  call(inputs, kwargs) {
    return tidy(() => {
      const training = kwargs["training"] == null ? false : kwargs["training"];
      const input = getExactlyOneTensor(inputs);
      const inputShape = input.shape;
      const ndim = inputShape.length;
      const reductionAxes = range$3(0, ndim);
      const axis = this.axis >= 0 ? this.axis : this.axis + ndim;
      reductionAxes.splice(axis, 1);
      const broadcastShape = pyListRepeat(1, ndim);
      broadcastShape[axis] = inputShape[axis];
      const sortedReductionAxes = reductionAxes.slice();
      sortedReductionAxes.sort();
      const needsBroadcasting = !arraysEqual(sortedReductionAxes, range$3(0, ndim).slice(0, ndim - 1));
      const normalizeInference = () => {
        if (needsBroadcasting) {
          const broadcastMovingMean = reshape$3(this.movingMean.read(), broadcastShape);
          const broadcastMovingVariance = reshape$3(this.movingVariance.read(), broadcastShape);
          const broadcastBeta = this.center ? reshape$3(this.beta.read(), broadcastShape) : null;
          const broadcastGamma = this.scale ? reshape$3(this.gamma.read(), broadcastShape) : null;
          return batchNormalization(input, broadcastMovingMean, broadcastMovingVariance, broadcastBeta, broadcastGamma, this.epsilon);
        } else {
          return batchNormalization(input, this.movingMean.read(), this.movingVariance.read(), this.beta == null ? null : this.beta.read(), this.gamma == null ? null : this.gamma.read(), this.epsilon);
        }
      };
      if (!training) {
        return normalizeInference();
      }
      const [normedTraining, mean2, variance] = normalizeBatchInTraining(input, this.gamma.read(), this.beta.read(), reductionAxes, this.epsilon);
      const doMovingAverage = (variable2, value, momentum) => {
        tidy(() => {
          const decay2 = 1 - momentum;
          const origValue = variable2.read();
          const updateDelta = mul(sub$2(origValue, value), decay2);
          variable2.write(sub$2(origValue, updateDelta));
        });
      };
      const updateMovingMeanAndVariance = () => {
        doMovingAverage(this.movingMean, mean2, this.momentum);
        doMovingAverage(this.movingVariance, variance, this.momentum);
      };
      updateMovingMeanAndVariance();
      return normedTraining;
    });
  }
  getConfig() {
    const config2 = {
      axis: this.axis,
      momentum: this.momentum,
      epsilon: this.epsilon,
      center: this.center,
      scale: this.scale,
      betaInitializer: serializeInitializer(this.betaInitializer),
      gammaInitializer: serializeInitializer(this.gammaInitializer),
      movingMeanInitializer: serializeInitializer(this.movingMeanInitializer),
      movingVarianceInitializer: serializeInitializer(this.movingVarianceInitializer),
      betaRegularizer: serializeRegularizer(this.betaRegularizer),
      gammaRegularizer: serializeRegularizer(this.gammaRegularizer),
      betaConstraint: serializeConstraint(this.betaConstraint),
      gammaConstraint: serializeConstraint(this.gammaConstraint)
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
BatchNormalization.className = "BatchNormalization";
registerClass(BatchNormalization);
class LayerNormalization extends Layer {
  constructor(args) {
    if (args == null) {
      args = {};
    }
    super(args);
    this.axis = args.axis == null ? -1 : args.axis;
    if (typeof this.axis === "number") {
      if (!Number.isInteger(this.axis)) {
        throw new Error(`Expected axis to be an integer, but received ${this.axis}`);
      }
    } else if (Array.isArray(this.axis)) {
      for (const axis of this.axis) {
        if (!Number.isInteger(axis)) {
          throw new Error(`Expected axis to be an array of integers, but received ${JSON.stringify(this.axis)}`);
        }
      }
    } else {
      throw new Error(`Expected axis to be an integer or an array of integers, but received ${JSON.stringify(this.axis)}`);
    }
    this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
    this.center = args.center == null ? true : args.center;
    this.scale = args.scale == null ? true : args.scale;
    this.betaInitializer = getInitializer(args.betaInitializer || "zeros");
    this.gammaInitializer = getInitializer(args.gammaInitializer || "ones");
    this.betaRegularizer = getRegularizer(args.betaRegularizer);
    this.gammaRegularizer = getRegularizer(args.gammaRegularizer);
    this.supportsMasking = true;
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const nDims = inputShape.length;
    if (typeof this.axis === "number") {
      this.axis = [this.axis];
    }
    for (let i2 = 0; i2 < this.axis.length; ++i2) {
      if (this.axis[i2] < 0) {
        this.axis[i2] += nDims;
      }
    }
    for (const axis of this.axis) {
      if (axis < 0 || axis >= nDims) {
        throw new Error(`Invalid axis: ${axis}`);
      }
    }
    if (this.axis.length !== unique$2(this.axis).length) {
      throw new Error(`Found duplicate axes in: ${this.axis}`);
    }
    const paramShape = this.axis.map((axis) => inputShape[axis]);
    const trainable = true;
    if (this.scale) {
      this.gamma = this.addWeight("gamma", paramShape, "float32", this.gammaInitializer, this.gammaRegularizer, trainable);
    } else {
      this.gamma = null;
    }
    if (this.center) {
      this.beta = this.addWeight("beta", paramShape, "float32", this.betaInitializer, this.betaRegularizer, trainable);
    } else {
      this.beta = null;
    }
    this.built = true;
  }
  call(inputs, kwargs) {
    const input = getExactlyOneTensor(inputs);
    const inputShape = input.shape;
    const nDims = inputShape.length;
    return tidy(() => {
      const keepDims = true;
      let { mean: mean2, variance } = moments(input, this.axis, keepDims);
      const broadcastShape = pyListRepeat(1, nDims);
      for (const dim of this.axis) {
        broadcastShape[dim] = inputShape[dim];
      }
      const broadcast = (v2) => {
        if (v2 != null && v2.shape.length !== nDims) {
          return reshape$3(v2, broadcastShape);
        } else {
          return v2;
        }
      };
      let scale2 = broadcast(this.gamma.read());
      let offset = broadcast(this.beta.read());
      const momentsTiling = [];
      const scaleOffsetTiling = [];
      for (let i2 = 0; i2 < nDims; ++i2) {
        if (this.axis.indexOf(i2) !== -1) {
          momentsTiling.push(inputShape[i2]);
          scaleOffsetTiling.push(1);
        } else {
          momentsTiling.push(1);
          scaleOffsetTiling.push(inputShape[i2]);
        }
      }
      mean2 = tile$4(mean2, momentsTiling);
      variance = tile$4(variance, momentsTiling);
      scale2 = tile$4(scale2, scaleOffsetTiling);
      offset = tile$4(offset, scaleOffsetTiling);
      return batchNormalization(input, mean2, variance, offset, scale2, this.epsilon);
    });
  }
  getConfig() {
    const config2 = {
      axis: this.axis,
      epsilon: this.epsilon,
      center: this.center,
      scale: this.scale,
      betaInitializer: serializeInitializer(this.betaInitializer),
      gammaInitializer: serializeInitializer(this.gammaInitializer),
      betaRegularizer: serializeRegularizer(this.betaRegularizer),
      gammaRegularizer: serializeRegularizer(this.gammaRegularizer)
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
LayerNormalization.className = "LayerNormalization";
registerClass(LayerNormalization);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function spatial2dPadding(x2, padding, dataFormat) {
  return tidy(() => {
    if (x2.rank !== 4) {
      throw new ValueError(`temporalPadding expects input tensor to be 4-D, but received a ${x2.rank}-D tensor.`);
    }
    if (padding == null) {
      padding = [[1, 1], [1, 1]];
    }
    if (padding.length !== 2 || padding[0].length !== 2 || padding[1].length !== 2) {
      throw new ValueError("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
    }
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    if (dataFormat !== "channelsLast" && dataFormat !== "channelsFirst") {
      throw new ValueError(`Unknown data format: ${dataFormat}. Supported data formats are 'channelsLast' and 'channelsFirst.`);
    }
    let pattern;
    if (dataFormat === "channelsFirst") {
      pattern = [[0, 0], [0, 0], padding[0], padding[1]];
    } else {
      pattern = [[0, 0], padding[0], padding[1], [0, 0]];
    }
    return pad$1(x2, pattern);
  });
}
class ZeroPadding2D extends Layer {
  constructor(args) {
    if (args == null) {
      args = {};
    }
    super(args);
    this.dataFormat = args.dataFormat == null ? imageDataFormat() : args.dataFormat;
    if (args.padding == null) {
      this.padding = [[1, 1], [1, 1]];
    } else if (typeof args.padding === "number") {
      this.padding = [[args.padding, args.padding], [args.padding, args.padding]];
    } else {
      args.padding = args.padding;
      if (args.padding.length !== 2) {
        throw new ValueError(`ZeroPadding2D expects padding to be a length-2 array, but received a length-${args.padding.length} array.`);
      }
      let heightPadding;
      let widthPadding;
      if (typeof args.padding[0] === "number") {
        heightPadding = [args.padding[0], args.padding[0]];
        widthPadding = [args.padding[1], args.padding[1]];
      } else {
        args.padding = args.padding;
        if (args.padding[0].length !== 2) {
          throw new ValueError(`ZeroPadding2D expects height padding to be a length-2 array, but received a length-${args.padding[0].length} array.`);
        }
        heightPadding = args.padding[0];
        if (args.padding[1].length !== 2) {
          throw new ValueError(`ZeroPadding2D expects width padding to be a length-2 array, but received a length-${args.padding[1].length} array.`);
        }
        widthPadding = args.padding[1];
      }
      this.padding = [heightPadding, widthPadding];
    }
    this.inputSpec = [new InputSpec({ ndim: 4 })];
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    let rows;
    let cols;
    if (this.dataFormat === "channelsFirst") {
      if (inputShape[2] != null && inputShape[2] >= 0) {
        rows = inputShape[2] + this.padding[0][0] + this.padding[0][1];
      } else {
        rows = null;
      }
      if (inputShape[3] != null && inputShape[3] >= 0) {
        cols = inputShape[3] + this.padding[1][0] + this.padding[1][1];
      } else {
        cols = null;
      }
      return [inputShape[0], inputShape[1], rows, cols];
    } else {
      if (inputShape[1] != null && inputShape[1] >= 0) {
        rows = inputShape[1] + this.padding[0][0] + this.padding[0][1];
      } else {
        rows = null;
      }
      if (inputShape[2] != null && inputShape[2] >= 0) {
        cols = inputShape[2] + this.padding[1][0] + this.padding[1][1];
      } else {
        cols = null;
      }
      return [inputShape[0], rows, cols, inputShape[3]];
    }
  }
  call(inputs, kwargs) {
    return tidy(() => spatial2dPadding(getExactlyOneTensor(inputs), this.padding, this.dataFormat));
  }
  getConfig() {
    const config2 = {
      padding: this.padding,
      dataFormat: this.dataFormat
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
ZeroPadding2D.className = "ZeroPadding2D";
registerClass(ZeroPadding2D);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
function pool2d(x2, poolSize, strides, padding, dataFormat, poolMode) {
  return tidy(() => {
    checkDataFormat(dataFormat);
    checkPoolMode(poolMode);
    checkPaddingMode(padding);
    if (strides == null) {
      strides = [1, 1];
    }
    if (padding == null) {
      padding = "valid";
    }
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    if (poolMode == null) {
      poolMode = "max";
    }
    x2 = preprocessConv2DInput(x2, dataFormat);
    let y2;
    const paddingString = padding === "same" ? "same" : "valid";
    if (poolMode === "max") {
      y2 = maxPool$3(x2, poolSize, strides, paddingString);
    } else {
      y2 = avgPool$3(x2, poolSize, strides, paddingString);
    }
    if (dataFormat === "channelsFirst") {
      y2 = transpose$3(y2, [0, 3, 1, 2]);
    }
    return y2;
  });
}
function pool3d$1(x2, poolSize, strides, padding, dataFormat, poolMode) {
  return tidy(() => {
    checkDataFormat(dataFormat);
    checkPoolMode(poolMode);
    checkPaddingMode(padding);
    if (strides == null) {
      strides = [1, 1, 1];
    }
    if (padding == null) {
      padding = "valid";
    }
    if (dataFormat == null) {
      dataFormat = imageDataFormat();
    }
    if (poolMode == null) {
      poolMode = "max";
    }
    x2 = preprocessConv3DInput(x2, dataFormat);
    let y2;
    const paddingString = padding === "same" ? "same" : "valid";
    if (poolMode === "max") {
      y2 = maxPool3d$1(x2, poolSize, strides, paddingString);
    } else {
      y2 = avgPool3d(x2, poolSize, strides, paddingString);
    }
    if (dataFormat === "channelsFirst") {
      y2 = transpose$3(y2, [0, 4, 1, 2, 3]);
    }
    return y2;
  });
}
class Pooling1D extends Layer {
  constructor(args) {
    if (args.poolSize == null) {
      args.poolSize = 2;
    }
    super(args);
    if (typeof args.poolSize === "number") {
      this.poolSize = [args.poolSize];
    } else if (Array.isArray(args.poolSize) && args.poolSize.length === 1 && typeof args.poolSize[0] === "number") {
      this.poolSize = args.poolSize;
    } else {
      throw new ValueError(`poolSize for 1D convolutional layer must be a number or an Array of a single number, but received ${JSON.stringify(args.poolSize)}`);
    }
    assertPositiveInteger(this.poolSize, "poolSize");
    if (args.strides == null) {
      this.strides = this.poolSize;
    } else {
      if (typeof args.strides === "number") {
        this.strides = [args.strides];
      } else if (Array.isArray(args.strides) && args.strides.length === 1 && typeof args.strides[0] === "number") {
        this.strides = args.strides;
      } else {
        throw new ValueError(`strides for 1D convolutional layer must be a number or an Array of a single number, but received ${JSON.stringify(args.strides)}`);
      }
    }
    assertPositiveInteger(this.strides, "strides");
    this.padding = args.padding == null ? "valid" : args.padding;
    checkPaddingMode(this.padding);
    this.inputSpec = [new InputSpec({ ndim: 3 })];
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const length = convOutputLength(inputShape[1], this.poolSize[0], this.padding, this.strides[0]);
    return [inputShape[0], length, inputShape[2]];
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      inputs = expandDims$3(getExactlyOneTensor(inputs), 2);
      const output2 = this.poolingFunction(getExactlyOneTensor(inputs), [this.poolSize[0], 1], [this.strides[0], 1], this.padding, "channelsLast");
      return squeeze(output2, [2]);
    });
  }
  getConfig() {
    const config2 = {
      poolSize: this.poolSize,
      padding: this.padding,
      strides: this.strides
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
class MaxPooling1D extends Pooling1D {
  constructor(args) {
    super(args);
  }
  poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
    checkDataFormat(dataFormat);
    checkPaddingMode(padding);
    return pool2d(inputs, poolSize, strides, padding, dataFormat, "max");
  }
}
MaxPooling1D.className = "MaxPooling1D";
registerClass(MaxPooling1D);
class AveragePooling1D extends Pooling1D {
  constructor(args) {
    super(args);
  }
  poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
    checkDataFormat(dataFormat);
    checkPaddingMode(padding);
    return pool2d(inputs, poolSize, strides, padding, dataFormat, "avg");
  }
}
AveragePooling1D.className = "AveragePooling1D";
registerClass(AveragePooling1D);
class Pooling2D extends Layer {
  constructor(args) {
    if (args.poolSize == null) {
      args.poolSize = [2, 2];
    }
    super(args);
    this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [args.poolSize, args.poolSize];
    if (args.strides == null) {
      this.strides = this.poolSize;
    } else if (Array.isArray(args.strides)) {
      if (args.strides.length !== 2) {
        throw new ValueError(`If the strides property of a 2D pooling layer is an Array, it is expected to have a length of 2, but received length ${args.strides.length}.`);
      }
      this.strides = args.strides;
    } else {
      this.strides = [args.strides, args.strides];
    }
    assertPositiveInteger(this.poolSize, "poolSize");
    assertPositiveInteger(this.strides, "strides");
    this.padding = args.padding == null ? "valid" : args.padding;
    this.dataFormat = args.dataFormat == null ? "channelsLast" : args.dataFormat;
    checkDataFormat(this.dataFormat);
    checkPaddingMode(this.padding);
    this.inputSpec = [new InputSpec({ ndim: 4 })];
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    let rows = this.dataFormat === "channelsFirst" ? inputShape[2] : inputShape[1];
    let cols = this.dataFormat === "channelsFirst" ? inputShape[3] : inputShape[2];
    rows = convOutputLength(rows, this.poolSize[0], this.padding, this.strides[0]);
    cols = convOutputLength(cols, this.poolSize[1], this.padding, this.strides[1]);
    if (this.dataFormat === "channelsFirst") {
      return [inputShape[0], inputShape[1], rows, cols];
    } else {
      return [inputShape[0], rows, cols, inputShape[3]];
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      return this.poolingFunction(getExactlyOneTensor(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
    });
  }
  getConfig() {
    const config2 = {
      poolSize: this.poolSize,
      padding: this.padding,
      strides: this.strides,
      dataFormat: this.dataFormat
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
class MaxPooling2D extends Pooling2D {
  constructor(args) {
    super(args);
  }
  poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
    checkDataFormat(dataFormat);
    checkPaddingMode(padding);
    return pool2d(inputs, poolSize, strides, padding, dataFormat, "max");
  }
}
MaxPooling2D.className = "MaxPooling2D";
registerClass(MaxPooling2D);
class AveragePooling2D extends Pooling2D {
  constructor(args) {
    super(args);
  }
  poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
    checkDataFormat(dataFormat);
    checkPaddingMode(padding);
    return pool2d(inputs, poolSize, strides, padding, dataFormat, "avg");
  }
}
AveragePooling2D.className = "AveragePooling2D";
registerClass(AveragePooling2D);
class Pooling3D extends Layer {
  constructor(args) {
    if (args.poolSize == null) {
      args.poolSize = [2, 2, 2];
    }
    super(args);
    this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [args.poolSize, args.poolSize, args.poolSize];
    if (args.strides == null) {
      this.strides = this.poolSize;
    } else if (Array.isArray(args.strides)) {
      if (args.strides.length !== 3) {
        throw new ValueError(`If the strides property of a 3D pooling layer is an Array, it is expected to have a length of 3, but received length ${args.strides.length}.`);
      }
      this.strides = args.strides;
    } else {
      this.strides = [args.strides, args.strides, args.strides];
    }
    assertPositiveInteger(this.poolSize, "poolSize");
    assertPositiveInteger(this.strides, "strides");
    this.padding = args.padding == null ? "valid" : args.padding;
    this.dataFormat = args.dataFormat == null ? "channelsLast" : args.dataFormat;
    checkDataFormat(this.dataFormat);
    checkPaddingMode(this.padding);
    this.inputSpec = [new InputSpec({ ndim: 5 })];
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    let depths = this.dataFormat === "channelsFirst" ? inputShape[2] : inputShape[1];
    let rows = this.dataFormat === "channelsFirst" ? inputShape[3] : inputShape[2];
    let cols = this.dataFormat === "channelsFirst" ? inputShape[4] : inputShape[3];
    depths = convOutputLength(depths, this.poolSize[0], this.padding, this.strides[0]);
    rows = convOutputLength(rows, this.poolSize[1], this.padding, this.strides[1]);
    cols = convOutputLength(cols, this.poolSize[2], this.padding, this.strides[2]);
    if (this.dataFormat === "channelsFirst") {
      return [inputShape[0], inputShape[1], depths, rows, cols];
    } else {
      return [inputShape[0], depths, rows, cols, inputShape[4]];
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      this.invokeCallHook(inputs, kwargs);
      return this.poolingFunction(getExactlyOneTensor(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
    });
  }
  getConfig() {
    const config2 = {
      poolSize: this.poolSize,
      padding: this.padding,
      strides: this.strides,
      dataFormat: this.dataFormat
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
class MaxPooling3D extends Pooling3D {
  constructor(args) {
    super(args);
  }
  poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
    checkDataFormat(dataFormat);
    checkPaddingMode(padding);
    return pool3d$1(inputs, poolSize, strides, padding, dataFormat, "max");
  }
}
MaxPooling3D.className = "MaxPooling3D";
registerClass(MaxPooling3D);
class AveragePooling3D extends Pooling3D {
  constructor(args) {
    super(args);
  }
  poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
    checkDataFormat(dataFormat);
    checkPaddingMode(padding);
    return pool3d$1(inputs, poolSize, strides, padding, dataFormat, "avg");
  }
}
AveragePooling3D.className = "AveragePooling3D";
registerClass(AveragePooling3D);
class GlobalPooling1D extends Layer {
  constructor(args) {
    super(args);
    this.inputSpec = [new InputSpec({ ndim: 3 })];
  }
  computeOutputShape(inputShape) {
    return [inputShape[0], inputShape[2]];
  }
  call(inputs, kwargs) {
    throw new NotImplementedError();
  }
}
class GlobalAveragePooling1D extends GlobalPooling1D {
  constructor(args) {
    super(args || {});
  }
  call(inputs, kwargs) {
    return tidy(() => {
      const input = getExactlyOneTensor(inputs);
      return mean$2(input, 1);
    });
  }
}
GlobalAveragePooling1D.className = "GlobalAveragePooling1D";
registerClass(GlobalAveragePooling1D);
class GlobalMaxPooling1D extends GlobalPooling1D {
  constructor(args) {
    super(args || {});
  }
  call(inputs, kwargs) {
    return tidy(() => {
      const input = getExactlyOneTensor(inputs);
      return max$4(input, 1);
    });
  }
}
GlobalMaxPooling1D.className = "GlobalMaxPooling1D";
registerClass(GlobalMaxPooling1D);
class GlobalPooling2D extends Layer {
  constructor(args) {
    super(args);
    this.dataFormat = args.dataFormat == null ? "channelsLast" : args.dataFormat;
    checkDataFormat(this.dataFormat);
    this.inputSpec = [new InputSpec({ ndim: 4 })];
  }
  computeOutputShape(inputShape) {
    inputShape = inputShape;
    if (this.dataFormat === "channelsLast") {
      return [inputShape[0], inputShape[3]];
    } else {
      return [inputShape[0], inputShape[1]];
    }
  }
  call(inputs, kwargs) {
    throw new NotImplementedError();
  }
  getConfig() {
    const config2 = { dataFormat: this.dataFormat };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
}
class GlobalAveragePooling2D extends GlobalPooling2D {
  call(inputs, kwargs) {
    return tidy(() => {
      const input = getExactlyOneTensor(inputs);
      if (this.dataFormat === "channelsLast") {
        return mean$2(input, [1, 2]);
      } else {
        return mean$2(input, [2, 3]);
      }
    });
  }
}
GlobalAveragePooling2D.className = "GlobalAveragePooling2D";
registerClass(GlobalAveragePooling2D);
class GlobalMaxPooling2D extends GlobalPooling2D {
  call(inputs, kwargs) {
    return tidy(() => {
      const input = getExactlyOneTensor(inputs);
      if (this.dataFormat === "channelsLast") {
        return max$4(input, [1, 2]);
      } else {
        return max$4(input, [2, 3]);
      }
    });
  }
}
GlobalMaxPooling2D.className = "GlobalMaxPooling2D";
registerClass(GlobalMaxPooling2D);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
class Wrapper$2 extends Layer {
  constructor(args) {
    super(args);
    this.layer = args.layer;
  }
  build(inputShape) {
    this.built = true;
  }
  get trainable() {
    if (this.layer != null) {
      return this.layer.trainable;
    } else {
      return false;
    }
  }
  set trainable(value) {
    if (this.layer != null) {
      this.layer.trainable = value;
    }
  }
  get trainableWeights() {
    return this.layer.trainableWeights;
  }
  get nonTrainableWeights() {
    return this.layer.nonTrainableWeights;
  }
  get updates() {
    return this.layer._updates;
  }
  get losses() {
    return this.layer.losses;
  }
  getWeights() {
    return this.layer.getWeights();
  }
  setWeights(weights) {
    this.layer.setWeights(weights);
  }
  getConfig() {
    const config2 = {
      "layer": {
        "className": this.layer.getClassName(),
        "config": this.layer.getConfig()
      }
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
  setFastWeightInitDuringBuild(value) {
    super.setFastWeightInitDuringBuild(value);
    if (this.layer != null) {
      this.layer.setFastWeightInitDuringBuild(value);
    }
  }
  static fromConfig(cls, config2, customObjects = {}) {
    const layerConfig = config2["layer"];
    const layer = deserialize(layerConfig, customObjects);
    delete config2["layer"];
    const newConfig = { layer };
    Object.assign(newConfig, config2);
    return new cls(newConfig);
  }
}
class TimeDistributed extends Wrapper$2 {
  constructor(args) {
    super(args);
    this.supportsMasking = true;
  }
  build(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    if (inputShape.length < 3) {
      throw new ValueError(`TimeDistributed layer expects an input shape >= 3D, but received input shape ${JSON.stringify(inputShape)}`);
    }
    this.inputSpec = [{ shape: inputShape }];
    const childInputShape = [inputShape[0]].concat(inputShape.slice(2));
    if (!this.layer.built) {
      this.layer.build(childInputShape);
      this.layer.built = true;
    }
    super.build(inputShape);
  }
  computeOutputShape(inputShape) {
    inputShape = getExactlyOneShape(inputShape);
    const childInputShape = [inputShape[0]].concat(inputShape.slice(2));
    const childOutputShape = this.layer.computeOutputShape(childInputShape);
    const timesteps = inputShape[1];
    return [childOutputShape[0], timesteps].concat(childOutputShape.slice(1));
  }
  call(inputs, kwargs) {
    return tidy(() => {
      inputs = getExactlyOneTensor(inputs);
      const step2 = (inputs2, states2) => {
        const output2 = getExactlyOneTensor(this.layer.call(inputs2, kwargs));
        return [output2, []];
      };
      const rnnOutputs = rnn(step2, inputs, [], false, null, null, false, true);
      const y2 = rnnOutputs[1];
      return y2;
    });
  }
}
TimeDistributed.className = "TimeDistributed";
registerClass(TimeDistributed);
function checkBidirectionalMergeMode(value) {
  checkStringTypeUnionValue(VALID_BIDIRECTIONAL_MERGE_MODES, "BidirectionalMergeMode", value);
}
const DEFAULT_BIDIRECTIONAL_MERGE_MODE = "concat";
class Bidirectional extends Wrapper$2 {
  constructor(args) {
    super(args);
    const layerConfig = args.layer.getConfig();
    const forwDict = {};
    forwDict["className"] = args.layer.getClassName();
    forwDict["config"] = layerConfig;
    this.forwardLayer = deserialize(forwDict);
    layerConfig["goBackwards"] = layerConfig["goBackwards"] === true ? false : true;
    const backDict = {};
    backDict["className"] = args.layer.getClassName();
    backDict["config"] = layerConfig;
    this.backwardLayer = deserialize(backDict);
    this.forwardLayer.name = "forward_" + this.forwardLayer.name;
    this.backwardLayer.name = "backward_" + this.backwardLayer.name;
    this.mergeMode = args.mergeMode === void 0 ? DEFAULT_BIDIRECTIONAL_MERGE_MODE : args.mergeMode;
    checkBidirectionalMergeMode(this.mergeMode);
    if (args.weights) {
      throw new NotImplementedError("weights support is not implemented for Bidirectional layer yet.");
    }
    this._stateful = args.layer.stateful;
    this.returnSequences = args.layer.returnSequences;
    this.returnState = args.layer.returnState;
    this.supportsMasking = true;
    this._trainable = true;
    this.inputSpec = args.layer.inputSpec;
    this.numConstants = null;
  }
  get trainable() {
    return this._trainable;
  }
  set trainable(value) {
    this._trainable = value;
    if (this.forwardLayer != null) {
      this.forwardLayer.trainable = value;
    }
    if (this.backwardLayer != null) {
      this.backwardLayer.trainable = value;
    }
  }
  getWeights() {
    return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
  }
  setWeights(weights) {
    const numWeights = weights.length;
    const numeightsOver2 = Math.floor(numWeights / 2);
    this.forwardLayer.setWeights(weights.slice(0, numeightsOver2));
    this.backwardLayer.setWeights(weights.slice(numeightsOver2));
  }
  computeOutputShape(inputShape) {
    let layerShapes = this.forwardLayer.computeOutputShape(inputShape);
    if (!(Array.isArray(layerShapes) && Array.isArray(layerShapes[0]))) {
      layerShapes = [layerShapes];
    }
    layerShapes = layerShapes;
    let outputShape;
    let outputShapes;
    let stateShape;
    if (this.returnState) {
      stateShape = layerShapes.slice(1);
      outputShape = layerShapes[0];
    } else {
      outputShape = layerShapes[0];
    }
    outputShape = outputShape;
    if (this.mergeMode === "concat") {
      outputShape[outputShape.length - 1] *= 2;
      outputShapes = [outputShape];
    } else if (this.mergeMode == null) {
      outputShapes = [outputShape, outputShape.slice()];
    } else {
      outputShapes = [outputShape];
    }
    if (this.returnState) {
      if (this.mergeMode == null) {
        return outputShapes.concat(stateShape).concat(stateShape.slice());
      }
      return [outputShape].concat(stateShape).concat(stateShape.slice());
    }
    return singletonOrArray(outputShapes);
  }
  apply(inputs, kwargs) {
    let initialState = kwargs == null ? null : kwargs["initialState"];
    let constants = kwargs == null ? null : kwargs["constants"];
    if (kwargs == null) {
      kwargs = {};
    }
    const standardized = standardizeArgs(inputs, initialState, constants, this.numConstants);
    inputs = standardized.inputs;
    initialState = standardized.initialState;
    constants = standardized.constants;
    if (Array.isArray(inputs)) {
      initialState = inputs.slice(1);
      inputs = inputs[0];
    }
    if ((initialState == null || initialState.length === 0) && constants == null) {
      return super.apply(inputs, kwargs);
    }
    const additionalInputs = [];
    const additionalSpecs = [];
    if (initialState != null) {
      const numStates = initialState.length;
      if (numStates % 2 > 0) {
        throw new ValueError("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
      }
      kwargs["initialState"] = initialState;
      additionalInputs.push(...initialState);
      const stateSpecs = initialState.map((state2) => new InputSpec({ shape: state2.shape }));
      this.forwardLayer.stateSpec = stateSpecs.slice(0, numStates / 2);
      this.backwardLayer.stateSpec = stateSpecs.slice(numStates / 2);
      additionalSpecs.push(...stateSpecs);
    }
    if (constants != null) {
      throw new NotImplementedError("Support for constants in Bidirectional layers is not implemented yet.");
    }
    const isSymbolicTensor = additionalInputs[0] instanceof SymbolicTensor;
    for (const tensor2 of additionalInputs) {
      if (tensor2 instanceof SymbolicTensor !== isSymbolicTensor) {
        throw new ValueError("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
      }
    }
    if (isSymbolicTensor) {
      const fullInput = [inputs].concat(additionalInputs);
      const fullInputSpec = this.inputSpec.concat(additionalSpecs);
      const originalInputSpec = this.inputSpec;
      this.inputSpec = fullInputSpec;
      const output2 = super.apply(fullInput, kwargs);
      this.inputSpec = originalInputSpec;
      return output2;
    } else {
      return super.apply(inputs, kwargs);
    }
  }
  call(inputs, kwargs) {
    return tidy(() => {
      const initialState = kwargs["initialState"];
      let y2;
      let yRev;
      if (initialState == null) {
        y2 = this.forwardLayer.call(inputs, kwargs);
        yRev = this.backwardLayer.call(inputs, kwargs);
      } else {
        const forwardState = initialState.slice(0, initialState.length / 2);
        const backwardState = initialState.slice(initialState.length / 2);
        y2 = this.forwardLayer.call(inputs, Object.assign(kwargs, { initialState: forwardState }));
        yRev = this.backwardLayer.call(inputs, Object.assign(kwargs, { initialState: backwardState }));
      }
      let states2;
      if (this.returnState) {
        if (Array.isArray(y2)) {
          states2 = y2.slice(1).concat(yRev.slice(1));
        }
        y2 = y2[0];
        yRev = yRev[0];
      }
      if (this.returnSequences) {
        yRev = reverse$3(yRev, 1);
      }
      let output2;
      if (this.mergeMode === "concat") {
        output2 = concatenate([y2, yRev]);
      } else if (this.mergeMode === "sum") {
        output2 = add$1(y2, yRev);
      } else if (this.mergeMode === "ave") {
        output2 = mul(0.5, add$1(y2, yRev));
      } else if (this.mergeMode === "mul") {
        output2 = mul(y2, yRev);
      } else if (this.mergeMode == null) {
        output2 = [y2, yRev];
      }
      if (this.returnState) {
        if (this.mergeMode == null) {
          return output2.concat(states2);
        }
        return [output2].concat(states2);
      }
      return output2;
    });
  }
  resetStates(states2) {
    this.forwardLayer.resetStates();
    this.backwardLayer.resetStates();
  }
  build(inputShape) {
    nameScope(this.forwardLayer.name, () => {
      this.forwardLayer.build(inputShape);
    });
    nameScope(this.backwardLayer.name, () => {
      this.backwardLayer.build(inputShape);
    });
    this.built = true;
  }
  computeMask(inputs, mask) {
    if (Array.isArray(mask)) {
      mask = mask[0];
    }
    let outputMask;
    if (this.returnSequences) {
      if (this.mergeMode == null) {
        outputMask = [mask, mask];
      } else {
        outputMask = mask;
      }
    } else {
      if (this.mergeMode == null) {
        outputMask = [null, null];
      } else {
        outputMask = null;
      }
    }
    if (this.returnState) {
      const states2 = this.forwardLayer.states;
      const stateMask = states2.map((state2) => null);
      if (Array.isArray(outputMask)) {
        return outputMask.concat(stateMask).concat(stateMask);
      } else {
        return [outputMask].concat(stateMask).concat(stateMask);
      }
    } else {
      return outputMask;
    }
  }
  get trainableWeights() {
    return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
  }
  get nonTrainableWeights() {
    return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
  }
  setFastWeightInitDuringBuild(value) {
    super.setFastWeightInitDuringBuild(value);
    if (this.forwardLayer != null) {
      this.forwardLayer.setFastWeightInitDuringBuild(value);
    }
    if (this.backwardLayer != null) {
      this.backwardLayer.setFastWeightInitDuringBuild(value);
    }
  }
  getConfig() {
    const config2 = {
      "mergeMode": this.mergeMode
    };
    const baseConfig = super.getConfig();
    Object.assign(config2, baseConfig);
    return config2;
  }
  static fromConfig(cls, config2) {
    const rnnLayer = deserialize(config2["layer"]);
    delete config2["layer"];
    if (config2["numConstants"] != null) {
      throw new NotImplementedError(`Deserialization of a Bidirectional layer with numConstants present is not supported yet.`);
    }
    const newConfig = config2;
    newConfig["layer"] = rnnLayer;
    return new cls(newConfig);
  }
}
Bidirectional.className = "Bidirectional";
registerClass(Bidirectional);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ENV$2 = env();
ENV$2.registerFlag("KEEP_INTERMEDIATE_TENSORS", () => false, (debugValue) => {
  if (debugValue) {
    console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
  }
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
var DataType;
(function(DataType2) {
  DataType2[DataType2["DT_INVALID"] = 0] = "DT_INVALID";
  DataType2[DataType2["DT_FLOAT"] = 1] = "DT_FLOAT";
  DataType2[DataType2["DT_DOUBLE"] = 2] = "DT_DOUBLE";
  DataType2[DataType2["DT_INT32"] = 3] = "DT_INT32";
  DataType2[DataType2["DT_UINT8"] = 4] = "DT_UINT8";
  DataType2[DataType2["DT_INT16"] = 5] = "DT_INT16";
  DataType2[DataType2["DT_INT8"] = 6] = "DT_INT8";
  DataType2[DataType2["DT_STRING"] = 7] = "DT_STRING";
  DataType2[DataType2["DT_COMPLEX64"] = 8] = "DT_COMPLEX64";
  DataType2[DataType2["DT_INT64"] = 9] = "DT_INT64";
  DataType2[DataType2["DT_BOOL"] = 10] = "DT_BOOL";
  DataType2[DataType2["DT_QINT8"] = 11] = "DT_QINT8";
  DataType2[DataType2["DT_QUINT8"] = 12] = "DT_QUINT8";
  DataType2[DataType2["DT_QINT32"] = 13] = "DT_QINT32";
  DataType2[DataType2["DT_BFLOAT16"] = 14] = "DT_BFLOAT16";
  DataType2[DataType2["DT_QINT16"] = 15] = "DT_QINT16";
  DataType2[DataType2["DT_QUINT16"] = 16] = "DT_QUINT16";
  DataType2[DataType2["DT_UINT16"] = 17] = "DT_UINT16";
  DataType2[DataType2["DT_COMPLEX128"] = 18] = "DT_COMPLEX128";
  DataType2[DataType2["DT_HALF"] = 19] = "DT_HALF";
  DataType2[DataType2["DT_RESOURCE"] = 20] = "DT_RESOURCE";
  DataType2[DataType2["DT_VARIANT"] = 21] = "DT_VARIANT";
  DataType2[DataType2["DT_UINT32"] = 22] = "DT_UINT32";
  DataType2[DataType2["DT_UINT64"] = 23] = "DT_UINT64";
  DataType2[DataType2["DT_FLOAT_REF"] = 101] = "DT_FLOAT_REF";
  DataType2[DataType2["DT_DOUBLE_REF"] = 102] = "DT_DOUBLE_REF";
  DataType2[DataType2["DT_INT32_REF"] = 103] = "DT_INT32_REF";
  DataType2[DataType2["DT_UINT8_REF"] = 104] = "DT_UINT8_REF";
  DataType2[DataType2["DT_INT16_REF"] = 105] = "DT_INT16_REF";
  DataType2[DataType2["DT_INT8_REF"] = 106] = "DT_INT8_REF";
  DataType2[DataType2["DT_STRING_REF"] = 107] = "DT_STRING_REF";
  DataType2[DataType2["DT_COMPLEX64_REF"] = 108] = "DT_COMPLEX64_REF";
  DataType2[DataType2["DT_INT64_REF"] = 109] = "DT_INT64_REF";
  DataType2[DataType2["DT_BOOL_REF"] = 110] = "DT_BOOL_REF";
  DataType2[DataType2["DT_QINT8_REF"] = 111] = "DT_QINT8_REF";
  DataType2[DataType2["DT_QUINT8_REF"] = 112] = "DT_QUINT8_REF";
  DataType2[DataType2["DT_QINT32_REF"] = 113] = "DT_QINT32_REF";
  DataType2[DataType2["DT_BFLOAT16_REF"] = 114] = "DT_BFLOAT16_REF";
  DataType2[DataType2["DT_QINT16_REF"] = 115] = "DT_QINT16_REF";
  DataType2[DataType2["DT_QUINT16_REF"] = 116] = "DT_QUINT16_REF";
  DataType2[DataType2["DT_UINT16_REF"] = 117] = "DT_UINT16_REF";
  DataType2[DataType2["DT_COMPLEX128_REF"] = 118] = "DT_COMPLEX128_REF";
  DataType2[DataType2["DT_HALF_REF"] = 119] = "DT_HALF_REF";
  DataType2[DataType2["DT_RESOURCE_REF"] = 120] = "DT_RESOURCE_REF";
  DataType2[DataType2["DT_VARIANT_REF"] = 121] = "DT_VARIANT_REF";
  DataType2[DataType2["DT_UINT32_REF"] = 122] = "DT_UINT32_REF";
  DataType2[DataType2["DT_UINT64_REF"] = 123] = "DT_UINT64_REF";
})(DataType || (DataType = {}));
var SaverDef;
(function(SaverDef2) {
  (function(CheckpointFormatVersion) {
    CheckpointFormatVersion[CheckpointFormatVersion["LEGACY"] = 0] = "LEGACY";
    CheckpointFormatVersion[CheckpointFormatVersion["V1"] = 1] = "V1";
    CheckpointFormatVersion[CheckpointFormatVersion["V2"] = 2] = "V2";
  })(SaverDef2.CheckpointFormatVersion || (SaverDef2.CheckpointFormatVersion = {}));
})(SaverDef || (SaverDef = {}));
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const CUSTOM_OPS = {};
function getRegisteredOp(name) {
  return CUSTOM_OPS[name];
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getParamValue(paramName, node, tensorMap, context2, resourceManager) {
  const inputParam = node.inputParams[paramName];
  if (inputParam && inputParam.inputIndexStart !== void 0) {
    const start = inputParam.inputIndexStart;
    const end = inputParam.inputIndexEnd === 0 ? void 0 : inputParam.inputIndexEnd === void 0 ? start + 1 : inputParam.inputIndexEnd;
    if (inputParam.type === "tensor") {
      return getTensor(node.inputNames[inputParam.inputIndexStart], tensorMap, context2, resourceManager);
    }
    if (inputParam.type === "tensors") {
      const inputs = node.inputNames.slice(start, end);
      return inputs.map((name) => getTensor(name, tensorMap, context2, resourceManager));
    }
    const tensor2 = getTensor(node.inputNames.slice(start)[0], tensorMap, context2, resourceManager);
    const data2 = tensor2.dataSync();
    return inputParam.type === "number" ? data2[0] : toNestedArray(tensor2.shape, data2);
  }
  const attrParam = node.attrParams[paramName];
  return attrParam && attrParam.value;
}
function getTensor(name, tensorsMap, context2, resourceManager) {
  const [nodeName, index2] = parseNodeName(name);
  if (resourceManager != null) {
    const tensor2 = resourceManager.getHashTableHandleByName(nodeName);
    if (tensor2 != null) {
      return tensor2;
    }
  }
  const contextId = context2.currentContextIds.find((contextId2) => {
    return !!tensorsMap[getNodeNameWithContextId(nodeName, contextId2)];
  });
  return contextId !== void 0 ? tensorsMap[getNodeNameWithContextId(nodeName, contextId)][index2] : void 0;
}
function getTensorsForCurrentContenxt(name, tensorsMap, context2) {
  return tensorsMap[getNodeNameWithContextId(name, context2.currentContextId)];
}
function getNodeNameAndIndex(inputName, context2) {
  const [nodeName, index2, outputName] = parseNodeName(inputName);
  return [
    getNodeNameWithContextId(nodeName, context2 && context2.currentContextId),
    index2,
    outputName
  ];
}
function getNodeNameWithContextId(name, contextId) {
  return !!contextId ? `${name}-${contextId}` : name;
}
function parseNodeName(name) {
  const parts = name.split(":");
  if (parts.length === 1) {
    return [name, 0, void 0];
  }
  const nodeName = parts[0];
  const outputName = parts.length === 3 ? parts[1] : void 0;
  const index2 = Number(parts[parts.length - 1]);
  return [nodeName, index2, outputName];
}
function getPadding(node, tensorMap, context2) {
  let pad2 = getParamValue("pad", node, tensorMap, context2);
  if (pad2 === "explicit") {
    pad2 = getParamValue("explicitPaddings", node, tensorMap, context2);
    const explicitPadding = [[0, 0], [0, 0], [0, 0], [0, 0]];
    for (let i2 = 0; i2 < 4; i2++) {
      explicitPadding[i2][0] = pad2[i2 * 2];
      explicitPadding[i2][1] = pad2[i2 * 2 + 1];
    }
    return explicitPadding;
  }
  return pad2;
}
function cloneTensor(tensor2) {
  return tensor2.kept ? tensor2 : clone(tensor2);
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$i = [
  {
    "tfOpName": "Add",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "AddV2",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "AddN",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "tensors",
        "type": "tensors"
      }
    ]
  },
  {
    "tfOpName": "BiasAdd",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Sub",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "RealDiv",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Div",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "DivNoNan",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "FloorDiv",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Mul",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Maximum",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Minimum",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Pow",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "SquaredDifference",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Mod",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "FloorMod",
    "category": "arithmetic",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  }
];
var arithmetic = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$i
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$h = [
  {
    "tfOpName": "Abs",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Acos",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Asin",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Atan",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Atan2",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "y",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Ceil",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "ClipByValue",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "clipValueMin",
        "type": "number"
      },
      {
        "start": 2,
        "name": "clipValueMax",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Complex",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "real",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "imag",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "ComplexAbs",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Cos",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Cosh",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Elu",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Exp",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Floor",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Log",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Imag",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "Tout",
        "name": "outputType",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Neg",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Real",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "Tout",
        "name": "outputType",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Prelu",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "alpha",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Relu",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Relu6",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Selu",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Sigmoid",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Sin",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Sinh",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Sqrt",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Rsqrt",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Square",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Tan",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Tanh",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Sign",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Round",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Expm1",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Log1p",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Reciprocal",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Softplus",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Asinh",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Acosh",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Atanh",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Erf",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Prod",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axes",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool",
        "notSupported": true
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LeakyRelu",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "alpha",
        "name": "alpha",
        "type": "number",
        "defaultValue": 0.2
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "IsNan",
    "category": "basic_math",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  }
];
var basicMath = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$h
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$g = [
  {
    "tfOpName": "EmptyTensorList",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "elementShape",
        "type": "shape"
      },
      {
        "start": 1,
        "name": "maxNumElements",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "LoopCond",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "pred",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "Switch",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "data",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "pred",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "Merge",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "tensors",
        "type": "tensors"
      }
    ]
  },
  {
    "tfOpName": "Enter",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "frame_name",
        "name": "frameName",
        "type": "string"
      },
      {
        "tfName": "is_constant",
        "name": "isConstant",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Exit",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "NextIteration",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "TensorArrayV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "size",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      },
      {
        "tfName": "element_shape",
        "name": "elementShape",
        "type": "shape"
      },
      {
        "tfName": "dynamic_size",
        "name": "dynamicSize",
        "type": "bool"
      },
      {
        "tfName": "clear_after_read",
        "name": "clearAfterRead",
        "type": "bool"
      },
      {
        "tfName": "identical_element_shapes",
        "name": "identicalElementShapes",
        "type": "bool"
      },
      {
        "tfName": "tensor_array_name",
        "name": "name",
        "type": "string"
      }
    ]
  },
  {
    "tfOpName": "TensorArrayWriteV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "index",
        "type": "number"
      },
      {
        "start": 2,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "flowIn",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "TensorArrayReadV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "index",
        "type": "number"
      },
      {
        "start": 2,
        "name": "flowIn",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "TensorArrayGatherV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "flowIn",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      },
      {
        "tfName": "element_shape",
        "name": "elementShape",
        "type": "shape"
      }
    ]
  },
  {
    "tfOpName": "TensorArrayScatterV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "flowIn",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorArrayConcatV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "flowIn",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      },
      {
        "tfName": "element_shape_except0",
        "name": "elementShapeExcept0",
        "type": "shape",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "TensorArraySplitV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "lengths",
        "type": "number[]"
      },
      {
        "start": 3,
        "name": "flowIn",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorArraySizeV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "flowIn",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "TensorArrayCloseV3",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorArrayId",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "StatelessIf",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "cond",
        "type": "tensor"
      },
      {
        "start": 1,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "then_branch",
        "name": "thenBranch",
        "type": "func"
      },
      {
        "tfName": "else_branch",
        "name": "elseBranch",
        "type": "func"
      }
    ]
  },
  {
    "tfOpName": "If",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "cond",
        "type": "tensor"
      },
      {
        "start": 1,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "then_branch",
        "name": "thenBranch",
        "type": "func"
      },
      {
        "tfName": "else_branch",
        "name": "elseBranch",
        "type": "func"
      }
    ]
  },
  {
    "tfOpName": "StatelessWhile",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "cond",
        "name": "cond",
        "type": "func"
      },
      {
        "tfName": "body",
        "name": "body",
        "type": "func"
      }
    ]
  },
  {
    "tfOpName": "While",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "cond",
        "name": "cond",
        "type": "func"
      },
      {
        "tfName": "body",
        "name": "body",
        "type": "func"
      }
    ]
  },
  {
    "tfOpName": "TensorListScatter",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "elementShape",
        "type": "shape"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListScatterV2",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "elementShape",
        "type": "shape"
      },
      {
        "start": 3,
        "name": "numElements",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListGather",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "elementShape",
        "type": "shape"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListGetItem",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "index",
        "type": "number"
      },
      {
        "start": 2,
        "name": "elementShape",
        "type": "shape"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListSetItem",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "index",
        "type": "number"
      },
      {
        "start": 2,
        "name": "tensor",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListReserve",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "elementShape",
        "type": "shape"
      },
      {
        "start": 1,
        "name": "numElements",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListFromTensor",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "elementShape",
        "type": "shape"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListStack",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "elementShape",
        "type": "shape"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      },
      {
        "tfName": "num_elements",
        "name": "numElements",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListSplit",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "elementShape",
        "type": "shape"
      },
      {
        "start": 2,
        "name": "lengths",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListConcat",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "element_shape",
        "name": "elementShape",
        "type": "shape"
      },
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListPopBack",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "elementShape",
        "type": "shape"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListPushBack",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "tensor",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "element_dtype",
        "name": "elementDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TensorListLength",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "TensorListResize",
    "category": "control",
    "inputs": [
      {
        "start": 0,
        "name": "tensorListId",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "size",
        "type": "number"
      }
    ]
  }
];
var control = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$g
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$f = [
  {
    "tfOpName": "AvgPool",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      },
      {
        "tfName": "ksize",
        "name": "kernelSize",
        "type": "number[]"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "MaxPool",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      },
      {
        "tfName": "ksize",
        "name": "kernelSize",
        "type": "number[]"
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": [],
        "notSupported": true
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "MaxPoolWithArgmax",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "ksize",
        "name": "kernelSize",
        "type": "number[]"
      },
      {
        "tfName": "include_batch_in_index",
        "name": "includeBatchInIndex",
        "type": "bool"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "AvgPool3D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      },
      {
        "tfName": "ksize",
        "name": "kernelSize",
        "type": "number[]"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "MaxPool3D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      },
      {
        "tfName": "ksize",
        "name": "kernelSize",
        "type": "number[]"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Conv1D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "stride",
        "name": "stride",
        "type": "number"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NWC"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "dilation",
        "name": "dilation",
        "type": "number",
        "defaultValue": 1
      }
    ]
  },
  {
    "tfOpName": "Conv2D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "useCudnnOnGpu",
        "name": "useCudnnOnGpu",
        "type": "bool"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NHWC"
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": []
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "_FusedConv2D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      },
      {
        "start": 2,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "num_args",
        "name": "numArgs",
        "type": "number"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": []
      },
      {
        "tfName": "use_cudnn_on_gpu",
        "name": "useCudnnOnGpu",
        "type": "bool",
        "defaultValue": true
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NHWC"
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]",
        "defaultValue": [
          1,
          1,
          1,
          1
        ]
      },
      {
        "tfName": "fused_ops",
        "name": "fusedOps",
        "type": "string[]",
        "defaultValue": []
      },
      {
        "tfName": "epsilon",
        "name": "epsilon",
        "type": "number",
        "defaultValue": 1e-4
      },
      {
        "tfName": "leakyrelu_alpha",
        "name": "leakyreluAlpha",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "Conv2DBackpropInput",
    "category": "convolution",
    "inputs": [
      {
        "start": 2,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      },
      {
        "start": 0,
        "name": "outputShape",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": []
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "DepthwiseConv2d",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "input",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NHWC"
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": []
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "DepthwiseConv2dNative",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "input",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NHWC"
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": []
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "FusedDepthwiseConv2dNative",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      },
      {
        "start": 2,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "num_args",
        "name": "numArgs",
        "type": "number"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NHWC"
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]",
        "defaultValue": [
          1,
          1,
          1,
          1
        ]
      },
      {
        "tfName": "fused_ops",
        "name": "fusedOps",
        "type": "string[]",
        "defaultValue": []
      },
      {
        "tfName": "explicit_paddings",
        "name": "explicitPaddings",
        "type": "number[]",
        "defaultValue": []
      }
    ]
  },
  {
    "tfOpName": "Conv3D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "defaultValue": "NHWC"
      },
      {
        "tfName": "dilations",
        "name": "dilations",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "Dilation2D",
    "category": "convolution",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "filter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "strides",
        "name": "strides",
        "type": "number[]"
      },
      {
        "tfName": "rates",
        "name": "dilations",
        "type": "number[]"
      },
      {
        "tfName": "padding",
        "name": "pad",
        "type": "string"
      }
    ]
  }
];
var convolution = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$f
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$e = [
  {
    "tfOpName": "Fill",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "shape",
        "type": "number[]"
      },
      {
        "start": 1,
        "name": "value",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "LinSpace",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "start",
        "type": "number"
      },
      {
        "start": 1,
        "name": "stop",
        "type": "number"
      },
      {
        "start": 2,
        "name": "num",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "OneHot",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "indices",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "depth",
        "type": "number"
      },
      {
        "start": 2,
        "name": "onValue",
        "type": "number",
        "defaultValue": 1
      },
      {
        "start": 3,
        "name": "offValue",
        "type": "number",
        "defaultValue": 0
      }
    ],
    "attrs": [
      {
        "tfName": "axis",
        "name": "axis",
        "type": "number",
        "notSupported": true
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Ones",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "shape",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "OnesLike",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "RandomUniform",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "shape",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "minval",
        "name": "minval",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "maxval",
        "name": "maxval",
        "type": "number",
        "defaultValue": 1
      },
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      },
      {
        "tfName": "seed",
        "name": "seed",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "seed2",
        "name": "seed2",
        "type": "number",
        "defaultValue": 0,
        "notSupported": true
      },
      {
        "tfName": "T",
        "name": "T",
        "type": "number",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Range",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "start",
        "type": "number"
      },
      {
        "start": 1,
        "name": "stop",
        "type": "number"
      },
      {
        "start": 2,
        "name": "step",
        "type": "number",
        "defaultValue": 0
      }
    ],
    "attrs": [
      {
        "tfName": "Tidx",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "TruncatedNormal",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "shape",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "means",
        "name": "mean",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "stddev",
        "name": "stdDev",
        "type": "number",
        "defaultValue": 1
      },
      {
        "tfName": "seed",
        "name": "seed",
        "type": "number"
      },
      {
        "tfName": "seed2",
        "name": "seed2",
        "type": "number",
        "defaultValue": 0,
        "notSupported": true
      },
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      },
      {
        "tfName": "T",
        "name": "T",
        "type": "number",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Zeros",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "shape",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "ZerosLike",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "Multinomial",
    "category": "creation",
    "inputs": [
      {
        "start": 0,
        "name": "logits",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "numSamples",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "seed",
        "name": "seed",
        "type": "number"
      },
      {
        "tfName": "seed2",
        "name": "seed2",
        "type": "number"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      },
      {
        "tfName": "output_dtype",
        "name": "output_dtype",
        "type": "dtype"
      }
    ]
  }
];
var creation = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$e
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$d = [
  {
    "tfOpName": "NonMaxSuppressionV2",
    "category": "dynamic",
    "inputs": [
      {
        "start": 0,
        "name": "boxes",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scores",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "maxOutputSize",
        "type": "number"
      },
      {
        "start": 3,
        "name": "iouThreshold",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "NonMaxSuppressionV3",
    "category": "dynamic",
    "inputs": [
      {
        "start": 0,
        "name": "boxes",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scores",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "maxOutputSize",
        "type": "number"
      },
      {
        "start": 3,
        "name": "iouThreshold",
        "type": "number"
      },
      {
        "start": 4,
        "name": "scoreThreshold",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "NonMaxSuppressionV4",
    "category": "dynamic",
    "inputs": [
      {
        "start": 0,
        "name": "boxes",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scores",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "maxOutputSize",
        "type": "number"
      },
      {
        "start": 3,
        "name": "iouThreshold",
        "type": "number"
      },
      {
        "start": 4,
        "name": "scoreThreshold",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "T_threshold",
        "name": "threshold",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "pad_to_max_output_size",
        "name": "padToMaxOutputSize",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "NonMaxSuppressionV5",
    "category": "dynamic",
    "inputs": [
      {
        "start": 0,
        "name": "boxes",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scores",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "maxOutputSize",
        "type": "number"
      },
      {
        "start": 3,
        "name": "iouThreshold",
        "type": "number"
      },
      {
        "start": 4,
        "name": "scoreThreshold",
        "type": "number"
      },
      {
        "start": 5,
        "name": "softNmsSigma",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "Where",
    "category": "dynamic",
    "inputs": [
      {
        "start": 0,
        "name": "condition",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "ListDiff",
    "category": "dynamic",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "y",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  }
];
var dynamic = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$d
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$c = [
  {
    "tfOpName": "TopKV2",
    "category": "evaluation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "k",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "sorted",
        "name": "sorted",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Unique",
    "category": "evaluation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "UniqueV2",
    "category": "evaluation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number"
      }
    ]
  }
];
var evaluation = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$c
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$b = [
  {
    "tfOpName": "PlaceholderWithDefault",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "default",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "shape",
        "name": "shape",
        "type": "shape"
      },
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "Placeholder",
    "category": "graph",
    "attrs": [
      {
        "tfName": "shape",
        "name": "shape",
        "type": "shape"
      },
      {
        "tfName": "dtype",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "Const",
    "category": "graph"
  },
  {
    "tfOpName": "Identity",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "IdentityN",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "x",
        "type": "tensors"
      }
    ]
  },
  {
    "tfOpName": "Snapshot",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "Rank",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "Size",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "Shape",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "ShapeN",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "x",
        "type": "tensors"
      }
    ]
  },
  {
    "tfOpName": "Print",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "data",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "message",
        "name": "message",
        "type": "string"
      },
      {
        "tfName": "first_n",
        "name": "firstN",
        "type": "number",
        "notSupported": true
      },
      {
        "tfName": "summarize",
        "name": "summarize",
        "type": "number",
        "defaultValue": 3
      }
    ]
  },
  {
    "tfOpName": "NoOp",
    "category": "graph",
    "inputs": []
  },
  {
    "tfOpName": "StopGradient",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "FakeQuantWithMinMaxVars",
    "category": "graph",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "min",
        "name": "min",
        "type": "number"
      },
      {
        "tfName": "max",
        "name": "max",
        "type": "number"
      }
    ]
  }
];
var graph = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$b
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$a = [
  {
    "tfOpName": "HashTable",
    "category": "hash_table",
    "inputs": [],
    "attrs": [
      {
        "tfName": "shared_name",
        "name": "sharedName",
        "type": "string"
      },
      {
        "tfName": "use_node_name_sharing",
        "name": "useNodeNameSharing",
        "type": "bool"
      },
      {
        "tfName": "key_dtype",
        "name": "keyDType",
        "type": "dtype"
      },
      {
        "tfName": "value_dtype",
        "name": "valueDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "HashTableV2",
    "category": "hash_table",
    "inputs": [],
    "attrs": [
      {
        "tfName": "shared_name",
        "name": "sharedName",
        "type": "string"
      },
      {
        "tfName": "use_node_name_sharing",
        "name": "useNodeNameSharing",
        "type": "bool"
      },
      {
        "tfName": "key_dtype",
        "name": "keyDType",
        "type": "dtype"
      },
      {
        "tfName": "value_dtype",
        "name": "valueDType",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "LookupTableImport",
    "category": "hash_table",
    "inputs": [
      {
        "start": 0,
        "name": "tableHandle",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "keys",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "values",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "Tin",
        "name": "tIn",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "Tout",
        "name": "tOut",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LookupTableImportV2",
    "category": "hash_table",
    "inputs": [
      {
        "start": 0,
        "name": "tableHandle",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "keys",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "values",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "Tin",
        "name": "tIn",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "Tout",
        "name": "tOut",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LookupTableFind",
    "category": "hash_table",
    "inputs": [
      {
        "start": 0,
        "name": "tableHandle",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "keys",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "defaultValue",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "Tin",
        "name": "tIn",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "Tout",
        "name": "tOut",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LookupTableFindV2",
    "category": "hash_table",
    "inputs": [
      {
        "start": 0,
        "name": "tableHandle",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "keys",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "defaultValue",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "Tin",
        "name": "tIn",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "Tout",
        "name": "tOut",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LookupTableSize",
    "category": "hash_table",
    "inputs": [
      {
        "start": 0,
        "name": "tableHandle",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "LookupTableSizeV2",
    "category": "hash_table",
    "inputs": [
      {
        "start": 0,
        "name": "tableHandle",
        "type": "tensor"
      }
    ]
  }
];
var hashTable = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$a
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$9 = [
  {
    "tfOpName": "ResizeBilinear",
    "category": "image",
    "inputs": [
      {
        "start": 0,
        "name": "images",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "size",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "align_corners",
        "name": "alignCorners",
        "type": "bool"
      },
      {
        "tfName": "half_pixel_centers",
        "name": "halfPixelCenters",
        "type": "bool"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "ResizeNearestNeighbor",
    "category": "image",
    "inputs": [
      {
        "start": 0,
        "name": "images",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "size",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "align_corners",
        "name": "alignCorners",
        "type": "bool"
      },
      {
        "tfName": "half_pixel_centers",
        "name": "halfPixelCenters",
        "type": "bool"
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "CropAndResize",
    "category": "image",
    "inputs": [
      {
        "start": 0,
        "name": "image",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "boxes",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "boxInd",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "cropSize",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "method",
        "name": "method",
        "type": "string"
      },
      {
        "tfName": "extrapolation_value",
        "name": "extrapolationValue",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "ImageProjectiveTransformV3",
    "category": "image",
    "inputs": [
      {
        "start": 0,
        "name": "images",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "transforms",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "outputShape",
        "type": "number[]"
      },
      {
        "start": 3,
        "name": "fillValue",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "interpolation",
        "name": "interpolation",
        "type": "string"
      },
      {
        "tfName": "fill_mode",
        "name": "fillMode",
        "type": "string"
      }
    ]
  }
];
var image = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$9
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$8 = [
  {
    "tfOpName": "Equal",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "NotEqual",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Greater",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "GreaterEqual",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Less",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LessEqual",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LogicalAnd",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LogicalNot",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LogicalOr",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Select",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "condition",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "SelectV2",
    "category": "logical",
    "inputs": [
      {
        "start": 0,
        "name": "condition",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  }
];
var logical = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$8
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$7 = [
  {
    "tfOpName": "_FusedMatMul",
    "category": "matrices",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      },
      {
        "start": 2,
        "end": 0,
        "name": "args",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "num_args",
        "name": "numArgs",
        "type": "number"
      },
      {
        "tfName": "fused_ops",
        "name": "fusedOps",
        "type": "string[]",
        "defaultValue": []
      },
      {
        "tfName": "epsilon",
        "name": "epsilon",
        "type": "number",
        "defaultValue": 1e-4
      },
      {
        "tfName": "transpose_a",
        "name": "transposeA",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "transpose_b",
        "name": "transposeB",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "MatMul",
    "category": "matrices",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "transpose_a",
        "name": "transposeA",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "transpose_b",
        "name": "transposeB",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "BatchMatMul",
    "category": "matrices",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "adj_x",
        "name": "transposeA",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "adj_y",
        "name": "transposeB",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "BatchMatMulV2",
    "category": "matrices",
    "inputs": [
      {
        "start": 0,
        "name": "a",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "b",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "adj_x",
        "name": "transposeA",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "adj_y",
        "name": "transposeB",
        "type": "bool",
        "defaultValue": false
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Transpose",
    "category": "matrices",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "perm",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Einsum",
    "category": "matrices",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "tensors",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "equation",
        "name": "equation",
        "type": "string"
      },
      {
        "tfName": "N",
        "name": "n",
        "type": "number",
        "defaultValue": 2
      },
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  }
];
var matrices = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$7
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$6 = [
  {
    "tfOpName": "FusedBatchNorm",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scale",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "offset",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "mean",
        "type": "tensor"
      },
      {
        "start": 4,
        "name": "variance",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "epsilon",
        "name": "epsilon",
        "type": "number",
        "defaultValue": 1e-3
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "FusedBatchNormV2",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scale",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "offset",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "mean",
        "type": "tensor"
      },
      {
        "start": 4,
        "name": "variance",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "epsilon",
        "name": "epsilon",
        "type": "number",
        "defaultValue": 1e-3
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "FusedBatchNormV3",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "scale",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "offset",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "mean",
        "type": "tensor"
      },
      {
        "start": 4,
        "name": "variance",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "epsilon",
        "name": "epsilon",
        "type": "number",
        "defaultValue": 1e-3
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "LRN",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "depth_radius",
        "name": "radius",
        "type": "number",
        "defaultValue": 5
      },
      {
        "tfName": "bias",
        "name": "bias",
        "type": "number",
        "defaultValue": 1
      },
      {
        "tfName": "alpha",
        "name": "alpha",
        "type": "number",
        "defaultValue": 1
      },
      {
        "tfName": "beta",
        "name": "beta",
        "type": "number",
        "defaultValue": 0.5
      }
    ]
  },
  {
    "tfOpName": "Softmax",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "LogSoftmax",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "SparseToDense",
    "category": "normalization",
    "inputs": [
      {
        "start": 0,
        "name": "sparseIndices",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "outputShape",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "sparseValues",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "defaultValue",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "validate_indices",
        "name": "validateIndices",
        "type": "bool",
        "defaultValue": true,
        "notSupported": true
      }
    ]
  }
];
var normalization = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$6
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$5 = [
  {
    "tfOpName": "Bincount",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "size",
        "type": "number"
      },
      {
        "start": 2,
        "name": "weights",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "DenseBincount",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "size",
        "type": "number"
      },
      {
        "start": 2,
        "name": "weights",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "binary_output",
        "name": "binaryOutput",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Max",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Mean",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Min",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Sum",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "All",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Any",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "ArgMax",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "ArgMin",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "Prod",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "keep_dims",
        "name": "keepDims",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Cumprod",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "exclusive",
        "name": "exclusive",
        "type": "bool"
      },
      {
        "tfName": "reverse",
        "name": "reverse",
        "type": "bool"
      }
    ]
  },
  {
    "tfOpName": "Cumsum",
    "category": "reduction",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "exclusive",
        "name": "exclusive",
        "type": "bool"
      },
      {
        "tfName": "reverse",
        "name": "reverse",
        "type": "bool"
      }
    ]
  }
];
var reduction = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$5
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$4 = [
  {
    "tfOpName": "ConcatV2",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "end": -1,
        "name": "tensors",
        "type": "tensors"
      },
      {
        "start": -1,
        "name": "axis",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "N",
        "name": "n",
        "type": "number",
        "defaultValue": 2
      }
    ]
  },
  {
    "tfOpName": "Concat",
    "category": "slice_join",
    "inputs": [
      {
        "start": 1,
        "end": 0,
        "name": "tensors",
        "type": "tensors"
      },
      {
        "start": 0,
        "name": "axis",
        "type": "number"
      }
    ],
    "attrs": [
      {
        "tfName": "N",
        "name": "n",
        "type": "number",
        "defaultValue": 2
      }
    ]
  },
  {
    "tfOpName": "GatherV2",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "axis",
        "type": "number",
        "defaultValue": 0
      }
    ],
    "attrs": [
      {
        "tfName": "batch_dims",
        "name": "batchDims",
        "type": "number",
        "defaultValue": 0
      }
    ]
  },
  {
    "tfOpName": "Gather",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "validate_indices",
        "name": "validateIndices",
        "type": "bool",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Reverse",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "dims",
        "type": "bool[]"
      }
    ]
  },
  {
    "tfOpName": "ReverseV2",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "Slice",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "begin",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "size",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "StridedSlice",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "begin",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "end",
        "type": "number[]"
      },
      {
        "start": 3,
        "name": "strides",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "begin_mask",
        "name": "beginMask",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "end_mask",
        "name": "endMask",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "new_axis_mask",
        "name": "newAxisMask",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "ellipsis_mask",
        "name": "ellipsisMask",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "shrink_axis_mask",
        "name": "shrinkAxisMask",
        "type": "number",
        "defaultValue": 0
      }
    ]
  },
  {
    "tfOpName": "Pack",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "end": 0,
        "name": "tensors",
        "type": "tensors"
      }
    ],
    "attrs": [
      {
        "tfName": "axis",
        "name": "axis",
        "type": "number",
        "defaultValue": 0
      }
    ]
  },
  {
    "tfOpName": "Unpack",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "tensor",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "axis",
        "name": "axis",
        "type": "number",
        "defaultValue": 0
      },
      {
        "tfName": "num",
        "name": "num",
        "type": "number",
        "defaultValue": 0,
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "Tile",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "reps",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "Split",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "axis",
        "type": "number",
        "defaultValue": 0
      },
      {
        "start": 1,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "num_split",
        "name": "numOrSizeSplits",
        "type": "number",
        "defaultValue": 1
      }
    ]
  },
  {
    "tfOpName": "SplitV",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "numOrSizeSplits",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "axis",
        "type": "number",
        "defaultValue": 0
      }
    ]
  },
  {
    "tfOpName": "ScatterNd",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "indices",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "values",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "shape",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "GatherNd",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "SparseToDense",
    "category": "slice_join",
    "inputs": [
      {
        "start": 0,
        "name": "sparseIndices",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "outputShape",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "sparseValues",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "defaultValue",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "validate_indices",
        "name": "validateIndices",
        "type": "bool",
        "defaultValue": false,
        "notSupported": true
      }
    ]
  }
];
var sliceJoin = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$4
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$3 = [
  {
    "tfOpName": "SparseFillEmptyRows",
    "category": "sparse",
    "inputs": [
      {
        "start": 0,
        "name": "indices",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "values",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "denseShape",
        "type": "tensor"
      },
      {
        "start": 3,
        "name": "defaultValue",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "SparseReshape",
    "category": "sparse",
    "inputs": [
      {
        "start": 0,
        "name": "inputIndices",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "inputShape",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "newShape",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "T",
        "name": "dtype",
        "type": "dtype",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "SparseSegmentMean",
    "category": "sparse",
    "inputs": [
      {
        "start": 0,
        "name": "data",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "segmentIds",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "SparseSegmentSum",
    "category": "sparse",
    "inputs": [
      {
        "start": 0,
        "name": "data",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "indices",
        "type": "tensor"
      },
      {
        "start": 2,
        "name": "segmentIds",
        "type": "tensor"
      }
    ]
  }
];
var sparse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$3
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$2 = [
  {
    "tfOpName": "FFT",
    "category": "spectral",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "IFFT",
    "category": "spectral",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ]
  },
  {
    "tfOpName": "RFFT",
    "category": "spectral",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "fft_length",
        "type": "number",
        "notSupported": true
      }
    ]
  },
  {
    "tfOpName": "IRFFT",
    "category": "spectral",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "fft_length",
        "type": "number",
        "notSupported": true
      }
    ]
  }
];
var spectral = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$2
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json$1 = [
  {
    "tfOpName": "StringNGrams",
    "category": "string",
    "inputs": [
      {
        "start": 0,
        "name": "data",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "dataSplits",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "separator",
        "name": "separator",
        "type": "string"
      },
      {
        "tfName": "ngram_widths",
        "name": "nGramWidths",
        "type": "number[]"
      },
      {
        "tfName": "left_pad",
        "name": "leftPad",
        "type": "string"
      },
      {
        "tfName": "right_pad",
        "name": "rightPad",
        "type": "string"
      },
      {
        "tfName": "pad_width",
        "name": "padWidth",
        "type": "number"
      },
      {
        "tfName": "preserve_short_sequences",
        "name": "preserveShortSequences",
        "type": "bool"
      }
    ],
    "outputs": [
      "ngrams",
      "ngrams_splits"
    ]
  },
  {
    "tfOpName": "StringSplit",
    "category": "string",
    "inputs": [
      {
        "start": 0,
        "name": "input",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "delimiter",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "skip_empty",
        "name": "skipEmpty",
        "type": "bool"
      }
    ],
    "outputs": [
      "indices",
      "values",
      "shape"
    ]
  },
  {
    "tfOpName": "StringToHashBucketFast",
    "category": "string",
    "inputs": [
      {
        "start": 0,
        "name": "input",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "num_buckets",
        "name": "numBuckets",
        "type": "number"
      }
    ]
  }
];
var string = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json: json$1
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const json = [
  {
    "tfOpName": "Cast",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "SrcT",
        "name": "sdtype",
        "type": "dtype",
        "notSupported": true
      },
      {
        "tfName": "DstT",
        "name": "dtype",
        "type": "dtype"
      }
    ]
  },
  {
    "tfOpName": "ExpandDims",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "axis",
        "type": "number"
      }
    ]
  },
  {
    "tfOpName": "MirrorPad",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "padding",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "mode",
        "name": "mode",
        "type": "string"
      }
    ]
  },
  {
    "tfOpName": "Pad",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "padding",
        "type": "number[]"
      }
    ],
    "attrs": [
      {
        "tfName": "constant_value",
        "name": "constantValue",
        "type": "number",
        "defaultValue": 0
      }
    ]
  },
  {
    "tfOpName": "PadV2",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "padding",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "constantValue",
        "type": "number",
        "defaultValue": 0
      }
    ]
  },
  {
    "tfOpName": "Reshape",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "shape",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "Squeeze",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "axis",
        "tfDeprecatedName": "squeeze_dims",
        "name": "axis",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "SpaceToBatchND",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "blockShape",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "paddings",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "BatchToSpaceND",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "blockShape",
        "type": "number[]"
      },
      {
        "start": 2,
        "name": "crops",
        "type": "number[]"
      }
    ]
  },
  {
    "tfOpName": "DepthToSpace",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      }
    ],
    "attrs": [
      {
        "tfName": "block_size",
        "name": "blockSize",
        "type": "number"
      },
      {
        "tfName": "data_format",
        "name": "dataFormat",
        "type": "string"
      }
    ]
  },
  {
    "tfOpName": "BroadcastTo",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "x",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "shape",
        "type": "number[]"
      }
    ],
    "attrs": []
  },
  {
    "tfOpName": "BroadcastArgs",
    "category": "transformation",
    "inputs": [
      {
        "start": 0,
        "name": "s0",
        "type": "tensor"
      },
      {
        "start": 1,
        "name": "s1",
        "type": "tensor"
      }
    ],
    "attrs": []
  }
];
var transformation = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class OperationMapper {
  static get Instance() {
    return this._instance || (this._instance = new this());
  }
  constructor() {
    const ops = [
      arithmetic,
      basicMath,
      control,
      convolution,
      creation,
      dynamic,
      evaluation,
      graph,
      hashTable,
      image,
      logical,
      matrices,
      normalization,
      reduction,
      sliceJoin,
      sparse,
      spectral,
      string,
      transformation
    ];
    const mappersJson = [].concat(...ops.map((op2) => op2.json));
    this.opMappers = mappersJson.reduce((map, mapper) => {
      map[mapper.tfOpName] = mapper;
      return map;
    }, {});
  }
  transformGraph(graph2, signature = {}) {
    const tfNodes = graph2.node;
    const placeholders = [];
    const weights = [];
    const initNodes = [];
    const nodes = tfNodes.reduce((map, node) => {
      map[node.name] = this.mapNode(node);
      if (node.op.startsWith("Placeholder")) {
        placeholders.push(map[node.name]);
      } else if (node.op === "Const") {
        weights.push(map[node.name]);
      } else if (node.input == null || node.input.length === 0) {
        initNodes.push(map[node.name]);
      }
      return map;
    }, {});
    let inputs = [];
    const outputs = [];
    let inputNodeNameToKey = {};
    let outputNodeNameToKey = {};
    if (signature != null) {
      inputNodeNameToKey = this.mapSignatureEntries(signature.inputs);
      outputNodeNameToKey = this.mapSignatureEntries(signature.outputs);
    }
    const allNodes = Object.keys(nodes);
    allNodes.forEach((key) => {
      const node = nodes[key];
      node.inputNames.forEach((name, index2) => {
        const [nodeName, , outputName] = getNodeNameAndIndex(name);
        const inputNode = nodes[nodeName];
        if (inputNode.outputs != null) {
          const outputIndex = inputNode.outputs.indexOf(outputName);
          if (outputIndex !== -1) {
            const inputName = `${nodeName}:${outputIndex}`;
            node.inputNames[index2] = inputName;
          }
        }
        node.inputs.push(inputNode);
        inputNode.children.push(node);
      });
    });
    if (Object.keys(outputNodeNameToKey).length === 0) {
      allNodes.forEach((key) => {
        const node = nodes[key];
        if (node.children.length === 0) {
          outputs.push(node);
        }
      });
    } else {
      Object.keys(outputNodeNameToKey).forEach((name) => {
        const [nodeName] = getNodeNameAndIndex(name);
        const node = nodes[nodeName];
        if (node != null) {
          node.signatureKey = outputNodeNameToKey[name];
          outputs.push(node);
        }
      });
    }
    if (Object.keys(inputNodeNameToKey).length > 0) {
      Object.keys(inputNodeNameToKey).forEach((name) => {
        const [nodeName] = getNodeNameAndIndex(name);
        const node = nodes[nodeName];
        if (node) {
          node.signatureKey = inputNodeNameToKey[name];
          inputs.push(node);
        }
      });
    } else {
      inputs = placeholders;
    }
    let functions = {};
    if (graph2.library != null && graph2.library.function != null) {
      functions = graph2.library.function.reduce((functions2, func) => {
        functions2[func.signature.name] = this.mapFunction(func);
        return functions2;
      }, {});
    }
    const result2 = { nodes, inputs, outputs, weights, placeholders, signature, functions };
    if (initNodes.length > 0) {
      result2.initNodes = initNodes;
    }
    return result2;
  }
  mapSignatureEntries(entries) {
    return Object.keys(entries || {}).reduce((prev, curr) => {
      prev[entries[curr].name] = curr;
      return prev;
    }, {});
  }
  mapNode(node) {
    const mapper = getRegisteredOp(node.op) || this.opMappers[node.op] || {};
    if (node.attr == null) {
      node.attr = {};
    }
    const newNode = {
      name: node.name,
      op: node.op,
      category: mapper.category,
      inputNames: (node.input || []).map((input) => input.startsWith("^") ? input.slice(1) : input),
      inputs: [],
      children: [],
      inputParams: {},
      attrParams: {},
      rawAttrs: node.attr,
      outputs: mapper.outputs
    };
    if (mapper.inputs != null) {
      newNode.inputParams = mapper.inputs.reduce((map, param) => {
        map[param.name] = {
          type: param.type,
          inputIndexStart: param.start,
          inputIndexEnd: param.end
        };
        return map;
      }, {});
    }
    if (mapper.attrs != null) {
      newNode.attrParams = mapper.attrs.reduce((map, param) => {
        const type = param.type;
        let value = void 0;
        switch (param.type) {
          case "string":
            value = getStringParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getStringParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "string[]":
            value = getStringArrayParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getStringArrayParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "number":
            value = getNumberParam(node.attr, param.tfName, param.defaultValue || 0);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getNumberParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "number[]":
            value = getNumericArrayParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getNumericArrayParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "bool":
            value = getBoolParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getBoolParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "bool[]":
            value = getBoolArrayParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getBoolArrayParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "shape":
            value = getTensorShapeParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getTensorShapeParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "shape[]":
            value = getTensorShapeArrayParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getTensorShapeArrayParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "dtype":
            value = getDtypeParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getDtypeParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "dtype[]":
            value = getDtypeArrayParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getDtypeArrayParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "func":
            value = getFuncParam(node.attr, param.tfName, param.defaultValue);
            if (value === void 0 && !!param.tfDeprecatedName) {
              value = getFuncParam(node.attr, param.tfDeprecatedName, param.defaultValue);
            }
            break;
          case "tensor":
          case "tensors":
            break;
          default:
            throw new Error(`Unsupported param type: ${param.type} for op: ${node.op}`);
        }
        map[param.name] = { value, type };
        return map;
      }, {});
    }
    return newNode;
  }
  mapFunction(functionDef) {
    const tfNodes = functionDef.nodeDef;
    const placeholders = [];
    const weights = [];
    let nodes = {};
    if (tfNodes != null) {
      nodes = tfNodes.reduce((map, node) => {
        map[node.name] = this.mapNode(node);
        if (node.op === "Const") {
          weights.push(map[node.name]);
        }
        return map;
      }, {});
    }
    const inputs = [];
    const outputs = [];
    functionDef.signature.inputArg.forEach((arg) => {
      const [nodeName] = getNodeNameAndIndex(arg.name);
      const node = {
        name: nodeName,
        op: "Placeholder",
        inputs: [],
        inputNames: [],
        category: "graph",
        inputParams: {},
        attrParams: { dtype: { value: parseDtypeParam(arg.type), type: "dtype" } },
        children: []
      };
      node.signatureKey = arg.name;
      inputs.push(node);
      nodes[nodeName] = node;
    });
    const allNodes = Object.keys(nodes);
    allNodes.forEach((key) => {
      const node = nodes[key];
      node.inputNames.forEach((name, index2) => {
        const [nodeName, , outputName] = getNodeNameAndIndex(name);
        const inputNode = nodes[nodeName];
        if (inputNode.outputs != null) {
          const outputIndex = inputNode.outputs.indexOf(outputName);
          if (outputIndex !== -1) {
            const inputName = `${nodeName}:${outputIndex}`;
            node.inputNames[index2] = inputName;
          }
        }
        node.inputs.push(inputNode);
        inputNode.children.push(node);
      });
    });
    const returnNodeMap = functionDef.ret;
    functionDef.signature.outputArg.forEach((output2) => {
      const [nodeName, index2] = getNodeNameAndIndex(returnNodeMap[output2.name]);
      const node = nodes[nodeName];
      if (node != null) {
        node.defaultOutput = index2;
        outputs.push(node);
      }
    });
    const signature = this.mapArgsToSignature(functionDef);
    return { nodes, inputs, outputs, weights, placeholders, signature };
  }
  mapArgsToSignature(functionDef) {
    return {
      methodName: functionDef.signature.name,
      inputs: functionDef.signature.inputArg.reduce((map, arg) => {
        map[arg.name] = this.mapArgToTensorInfo(arg);
        return map;
      }, {}),
      outputs: functionDef.signature.outputArg.reduce((map, arg) => {
        map[arg.name] = this.mapArgToTensorInfo(arg, functionDef.ret);
        return map;
      }, {})
    };
  }
  mapArgToTensorInfo(arg, nameMap2) {
    let name = arg.name;
    if (nameMap2 != null) {
      name = nameMap2[name];
    }
    return { name, dtype: arg.type };
  }
}
function decodeBase64(text) {
  const global2 = env().global;
  if (typeof global2.atob !== "undefined") {
    return global2.atob(text);
  } else if (typeof Buffer !== "undefined") {
    return new Buffer(text, "base64").toString();
  } else {
    throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
  }
}
function parseStringParam(s2, keepCase) {
  const value = Array.isArray(s2) ? String.fromCharCode.apply(null, s2) : decodeBase64(s2);
  return keepCase ? value : value.toLowerCase();
}
function getStringParam(attrs, name, def, keepCase = false) {
  const param = attrs[name];
  if (param != null) {
    return parseStringParam(param.s, keepCase);
  }
  return def;
}
function getBoolParam(attrs, name, def) {
  const param = attrs[name];
  return param ? param.b : def;
}
function getNumberParam(attrs, name, def) {
  const param = attrs[name] || {};
  const value = param["i"] != null ? param["i"] : param["f"] != null ? param["f"] : def;
  return typeof value === "number" ? value : parseInt(value, 10);
}
function parseDtypeParam(value) {
  if (typeof value === "string") {
    value = DataType[value];
  }
  switch (value) {
    case DataType.DT_FLOAT:
    case DataType.DT_HALF:
      return "float32";
    case DataType.DT_INT32:
    case DataType.DT_INT64:
    case DataType.DT_INT8:
    case DataType.DT_UINT8:
      return "int32";
    case DataType.DT_BOOL:
      return "bool";
    case DataType.DT_DOUBLE:
      return "float32";
    case DataType.DT_STRING:
      return "string";
    default:
      return null;
  }
}
function getFuncParam(attrs, name, def) {
  const param = attrs[name];
  if (param && param.func) {
    return param.func.name;
  }
  return def;
}
function getDtypeParam(attrs, name, def) {
  const param = attrs[name];
  if (param && param.type) {
    return parseDtypeParam(param.type);
  }
  return def;
}
function getDtypeArrayParam(attrs, name, def) {
  const param = attrs[name];
  if (param && param.list && param.list.type) {
    return param.list.type.map((v2) => parseDtypeParam(v2));
  }
  return def;
}
function parseTensorShapeParam(shape) {
  if (shape.unknownRank) {
    return void 0;
  }
  if (shape.dim != null) {
    return shape.dim.map((dim) => typeof dim.size === "number" ? dim.size : parseInt(dim.size, 10));
  }
  return [];
}
function getTensorShapeParam(attrs, name, def) {
  const param = attrs[name];
  if (param && param.shape) {
    return parseTensorShapeParam(param.shape);
  }
  return def;
}
function getNumericArrayParam(attrs, name, def) {
  const param = attrs[name];
  if (param) {
    return ((param.list.f && param.list.f.length ? param.list.f : param.list.i) || []).map((v2) => typeof v2 === "number" ? v2 : parseInt(v2, 10));
  }
  return def;
}
function getStringArrayParam(attrs, name, def, keepCase = false) {
  const param = attrs[name];
  if (param && param.list && param.list.s) {
    return param.list.s.map((v2) => {
      return parseStringParam(v2, keepCase);
    });
  }
  return def;
}
function getTensorShapeArrayParam(attrs, name, def) {
  const param = attrs[name];
  if (param && param.list && param.list.shape) {
    return param.list.shape.map((v2) => {
      return parseTensorShapeParam(v2);
    });
  }
  return def;
}
function getBoolArrayParam(attrs, name, def) {
  const param = attrs[name];
  if (param && param.list && param.list.b) {
    return param.list.b;
  }
  return def;
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class NodeValueImpl {
  constructor(node, tensorMap, context2) {
    this.node = node;
    this.tensorMap = tensorMap;
    this.context = context2;
    this.inputs = [];
    this.attrs = {};
    this.inputs = node.inputNames.map((name) => this.getInput(name));
    if (node.rawAttrs != null) {
      this.attrs = Object.keys(node.rawAttrs).reduce((attrs, key) => {
        attrs[key] = this.getAttr(key);
        return attrs;
      }, {});
    }
  }
  getInput(name) {
    return getTensor(name, this.tensorMap, this.context);
  }
  getAttr(name, defaultValue) {
    const value = this.node.rawAttrs[name];
    if (value.tensor != null) {
      return getTensor(name, this.tensorMap, this.context);
    }
    if (value.i != null || value.f != null) {
      return getNumberParam(this.node.rawAttrs, name, defaultValue);
    }
    if (value.s != null) {
      return getStringParam(this.node.rawAttrs, name, defaultValue);
    }
    if (value.b != null) {
      return getBoolParam(this.node.rawAttrs, name, defaultValue);
    }
    if (value.shape != null) {
      return getTensorShapeParam(this.node.rawAttrs, name, defaultValue);
    }
    if (value.type != null) {
      return getDtypeParam(this.node.rawAttrs, name, defaultValue);
    }
    if (value.list != null) {
      if (value.list.i != null || value.list.f != null) {
        return getNumericArrayParam(this.node.rawAttrs, name, defaultValue);
      }
      if (value.list.s != null) {
        return getStringArrayParam(this.node.rawAttrs, name, defaultValue);
      }
      if (value.list.shape != null) {
        return getTensorShapeArrayParam(this.node.rawAttrs, name, defaultValue);
      }
      if (value.list.b != null) {
        return getBoolArrayParam(this.node.rawAttrs, name, defaultValue);
      }
      if (value.list.type != null) {
        return getDtypeArrayParam(this.node.rawAttrs, name, defaultValue);
      }
    }
    return defaultValue;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$j = (node, tensorMap, context2) => {
  switch (node.op) {
    case "BiasAdd":
    case "AddV2":
    case "Add": {
      return [add$1(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "AddN": {
      return [addN$2(getParamValue("tensors", node, tensorMap, context2))];
    }
    case "FloorMod":
    case "Mod":
      return [mod$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    case "Mul":
      return [mul(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    case "RealDiv":
    case "Div": {
      return [div$1(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "DivNoNan": {
      return [divNoNan(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "FloorDiv": {
      return [floorDiv$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Sub": {
      return [sub$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Minimum": {
      return [minimum$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Maximum": {
      return [maximum$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Pow": {
      return [pow$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "SquaredDifference": {
      return [squaredDifference$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$i = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Abs":
    case "ComplexAbs":
      return [abs$2(getParamValue("x", node, tensorMap, context2))];
    case "Acos":
      return [acos$2(getParamValue("x", node, tensorMap, context2))];
    case "Acosh":
      return [acosh$2(getParamValue("x", node, tensorMap, context2))];
    case "Asin":
      return [asin$2(getParamValue("x", node, tensorMap, context2))];
    case "Asinh":
      return [asinh$2(getParamValue("x", node, tensorMap, context2))];
    case "Atan":
      return [atan$2(getParamValue("x", node, tensorMap, context2))];
    case "Atan2":
      return [atan2$2(getParamValue("x", node, tensorMap, context2), getParamValue("y", node, tensorMap, context2))];
    case "Atanh":
      return [atanh$2(getParamValue("x", node, tensorMap, context2))];
    case "Ceil":
      return [ceil$2(getParamValue("x", node, tensorMap, context2))];
    case "Complex":
      return [complex$3(getParamValue("real", node, tensorMap, context2), getParamValue("imag", node, tensorMap, context2))];
    case "Cos":
      return [cos$2(getParamValue("x", node, tensorMap, context2))];
    case "Cosh":
      return [cosh$2(getParamValue("x", node, tensorMap, context2))];
    case "Elu":
      return [elu$3(getParamValue("x", node, tensorMap, context2))];
    case "Erf":
      return [erf$2(getParamValue("x", node, tensorMap, context2))];
    case "Exp":
      return [exp$2(getParamValue("x", node, tensorMap, context2))];
    case "Expm1": {
      return [expm1$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Floor":
      return [floor$2(getParamValue("x", node, tensorMap, context2))];
    case "Log":
      return [log$7(getParamValue("x", node, tensorMap, context2))];
    case "Log1p": {
      return [log1p$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Imag":
      return [imag$2(getParamValue("x", node, tensorMap, context2))];
    case "Neg":
      return [neg$2(getParamValue("x", node, tensorMap, context2))];
    case "Reciprocal": {
      return [reciprocal$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Real":
      return [real$2(getParamValue("x", node, tensorMap, context2))];
    case "Relu":
      return [relu$2(getParamValue("x", node, tensorMap, context2))];
    case "Round": {
      return [round$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Selu":
      return [selu$2(getParamValue("x", node, tensorMap, context2))];
    case "Sigmoid":
      return [sigmoid$3(getParamValue("x", node, tensorMap, context2))];
    case "Sin":
      return [sin$2(getParamValue("x", node, tensorMap, context2))];
    case "Sign": {
      return [sign$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Sinh": {
      return [sinh$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Softplus": {
      return [softplus$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Sqrt": {
      return [sqrt$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Square": {
      return [square$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Tanh": {
      return [tanh$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "Tan":
      return [tan$2(getParamValue("x", node, tensorMap, context2))];
    case "ClipByValue":
      return [clipByValue$2(getParamValue("x", node, tensorMap, context2), getParamValue("clipValueMin", node, tensorMap, context2), getParamValue("clipValueMax", node, tensorMap, context2))];
    case "Relu6":
      return [relu6$2(getParamValue("x", node, tensorMap, context2))];
    case "Rsqrt":
      return [rsqrt$2(getTensor(node.inputNames[0], tensorMap, context2))];
    case "Prod":
      return [prod$3(getParamValue("x", node, tensorMap, context2), getParamValue("axes", node, tensorMap, context2))];
    case "LeakyRelu":
      return [leakyRelu$3(getParamValue("x", node, tensorMap, context2), getParamValue("alpha", node, tensorMap, context2))];
    case "Prelu":
      return [prelu$3(getParamValue("x", node, tensorMap, context2), getParamValue("alpha", node, tensorMap, context2))];
    case "IsNan":
      return [isNaN$3(getTensor(node.inputNames[0], tensorMap, context2))];
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function assertShapesMatchAllowUndefinedSize(shapeA, shapeB, errorMessagePrefix = "") {
  if (typeof shapeA === "number" || typeof shapeB === "number") {
    return;
  }
  assert$1(shapeA.length === shapeB.length, () => errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
  for (let i2 = 0; i2 < shapeA.length; i2++) {
    const dim0 = shapeA[i2];
    const dim1 = shapeB[i2];
    assert$1(dim0 < 0 || dim1 < 0 || dim0 === dim1, () => errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
  }
}
function fullDefinedShape(elementShape) {
  if (typeof elementShape === "number" || elementShape.some((dim) => dim < 0)) {
    return false;
  }
  return true;
}
function inferElementShape(listElementShape, tensors, elementShape) {
  let partialShape = mergeElementShape(listElementShape, elementShape);
  const notfullDefinedShape = !fullDefinedShape(partialShape);
  if (notfullDefinedShape && tensors.length === 0) {
    throw new Error(`Tried to calculate elements of an empty list with non-fully-defined elementShape: ${partialShape}`);
  }
  if (notfullDefinedShape) {
    tensors.forEach((tensor2) => {
      partialShape = mergeElementShape(tensor2.shape, partialShape);
    });
  }
  if (!fullDefinedShape(partialShape)) {
    throw new Error(`Non-fully-defined elementShape: ${partialShape}`);
  }
  return partialShape;
}
function mergeElementShape(elementShapeA, elementShapeB) {
  if (typeof elementShapeA === "number") {
    return elementShapeB;
  }
  if (typeof elementShapeB === "number") {
    return elementShapeA;
  }
  if (elementShapeA.length !== elementShapeB.length) {
    throw new Error(`Incompatible ranks during merge: ${elementShapeA} vs. ${elementShapeB}`);
  }
  const result2 = [];
  for (let i2 = 0; i2 < elementShapeA.length; ++i2) {
    const dim0 = elementShapeA[i2];
    const dim1 = elementShapeB[i2];
    if (dim0 >= 0 && dim1 >= 0 && dim0 !== dim1) {
      throw new Error(`Incompatible shape during merge: ${elementShapeA} vs. ${elementShapeB}`);
    }
    result2[i2] = dim0 >= 0 ? dim0 : dim1;
  }
  return result2;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TensorArray {
  constructor(name, dtype, maxSize, elementShape, identicalElementShapes, dynamicSize, clearAfterRead) {
    this.name = name;
    this.dtype = dtype;
    this.maxSize = maxSize;
    this.elementShape = elementShape;
    this.identicalElementShapes = identicalElementShapes;
    this.dynamicSize = dynamicSize;
    this.clearAfterRead = clearAfterRead;
    this.tensors = [];
    this.closed_ = false;
    this.idTensor = scalar(0);
    keep(this.idTensor);
  }
  get id() {
    return this.idTensor.id;
  }
  get closed() {
    return this.closed_;
  }
  clearAndClose(keepIds) {
    this.tensors.forEach((tensor2) => {
      if (keepIds == null || !keepIds.has(tensor2.tensor.id)) {
        tensor2.tensor.dispose();
      }
    });
    this.tensors = [];
    this.closed_ = true;
    this.idTensor.dispose();
  }
  size() {
    return this.tensors.length;
  }
  read(index2) {
    if (this.closed_) {
      throw new Error(`TensorArray ${this.name} has already been closed.`);
    }
    if (index2 < 0 || index2 >= this.size()) {
      throw new Error(`Tried to read from index ${index2}, but array size is: ${this.size()}`);
    }
    const tensorWithState = this.tensors[index2];
    if (tensorWithState.cleared) {
      throw new Error(`TensorArray ${this.name}: Could not read index ${index2} twice because it was cleared after a previous read (perhaps try setting clear_after_read = false?).`);
    }
    if (this.clearAfterRead) {
      tensorWithState.cleared = true;
    }
    tensorWithState.read = true;
    return tensorWithState.tensor;
  }
  readMany(indices) {
    return indices.map((index2) => this.read(index2));
  }
  write(index2, tensor2) {
    if (this.closed_) {
      throw new Error(`TensorArray ${this.name} has already been closed.`);
    }
    if (index2 < 0 || !this.dynamicSize && index2 >= this.maxSize) {
      throw new Error(`Tried to write to index ${index2}, but array is not resizeable and size is: ${this.maxSize}`);
    }
    const t2 = this.tensors[index2] || {};
    if (tensor2.dtype !== this.dtype) {
      throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index2},
          because the value dtype is ${tensor2.dtype}, but TensorArray dtype is ${this.dtype}.`);
    }
    if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0)) {
      this.elementShape = tensor2.shape;
    }
    assertShapesMatchAllowUndefinedSize(this.elementShape, tensor2.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${index2}.`);
    if (t2.read) {
      throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index2}, because it has already been read.`);
    }
    if (t2.written) {
      throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index2}, because it has already been written.`);
    }
    t2.tensor = tensor2;
    keep(tensor2);
    t2.written = true;
    this.tensors[index2] = t2;
  }
  writeMany(indices, tensors) {
    if (indices.length !== tensors.length) {
      throw new Error(`TensorArray ${this.name}: could not write multiple tensors,because the index size: ${indices.length} is not the same as tensors size: ${tensors.length}.`);
    }
    indices.forEach((i2, index2) => this.write(i2, tensors[index2]));
  }
  gather(indices, dtype) {
    if (!!dtype && dtype !== this.dtype) {
      throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${dtype}`);
    }
    if (!indices) {
      indices = [];
      for (let i2 = 0; i2 < this.size(); i2++) {
        indices.push(i2);
      }
    } else {
      indices = indices.slice(0, this.size());
    }
    if (indices.length === 0) {
      return tensor([], [0].concat(this.elementShape));
    }
    const tensors = this.readMany(indices);
    assertShapesMatchAllowUndefinedSize(this.elementShape, tensors[0].shape, "TensorArray shape mismatch: ");
    return stack(tensors, 0);
  }
  concat(dtype) {
    if (!!dtype && dtype !== this.dtype) {
      throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${dtype}`);
    }
    if (this.size() === 0) {
      return tensor([], [0].concat(this.elementShape));
    }
    const indices = [];
    for (let i2 = 0; i2 < this.size(); i2++) {
      indices.push(i2);
    }
    const tensors = this.readMany(indices);
    assertShapesMatchAllowUndefinedSize(this.elementShape, tensors[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${tensors[0].shape})`);
    return concat$3(tensors, 0);
  }
  scatter(indices, tensor2) {
    if (tensor2.dtype !== this.dtype) {
      throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor2.dtype}`);
    }
    if (indices.length !== tensor2.shape[0]) {
      throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor2.shape[0]}`);
    }
    const maxIndex = Math.max(...indices);
    if (!this.dynamicSize && maxIndex >= this.maxSize) {
      throw new Error(`Max index must be < array size (${maxIndex}  vs. ${this.maxSize})`);
    }
    this.writeMany(indices, unstack(tensor2, 0));
  }
  split(length, tensor2) {
    if (tensor2.dtype !== this.dtype) {
      throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor2.dtype}`);
    }
    let totalLength = 0;
    const cumulativeLengths = length.map((len) => {
      totalLength += len;
      return totalLength;
    });
    if (totalLength !== tensor2.shape[0]) {
      throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor2.shape}`);
    }
    if (!this.dynamicSize && length.length !== this.maxSize) {
      throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${length.length}), and the TensorArray is not marked as dynamically resizeable`);
    }
    const elementPerRow = totalLength === 0 ? 0 : tensor2.size / totalLength;
    const tensors = [];
    tidy(() => {
      tensor2 = reshape$3(tensor2, [1, totalLength, elementPerRow]);
      for (let i2 = 0; i2 < length.length; ++i2) {
        const previousLength = i2 === 0 ? 0 : cumulativeLengths[i2 - 1];
        const indices2 = [0, previousLength, 0];
        const sizes2 = [1, length[i2], elementPerRow];
        tensors[i2] = reshape$3(slice$3(tensor2, indices2, sizes2), this.elementShape);
      }
      return tensors;
    });
    const indices = [];
    for (let i2 = 0; i2 < length.length; i2++) {
      indices[i2] = i2;
    }
    this.writeMany(indices, tensors);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TensorList {
  constructor(tensors, elementShape, elementDtype, maxNumElements = -1) {
    this.tensors = tensors;
    this.elementShape = elementShape;
    this.elementDtype = elementDtype;
    if (tensors != null) {
      tensors.forEach((tensor2) => {
        if (elementDtype !== tensor2.dtype) {
          throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${tensor2.dtype}`);
        }
        assertShapesMatchAllowUndefinedSize(elementShape, tensor2.shape, "TensorList shape mismatch: ");
        keep(tensor2);
      });
    }
    this.idTensor = scalar(0);
    this.maxNumElements = maxNumElements;
    keep(this.idTensor);
  }
  get id() {
    return this.idTensor.id;
  }
  copy() {
    return new TensorList([...this.tensors], this.elementShape, this.elementDtype);
  }
  clearAndClose(keepIds) {
    this.tensors.forEach((tensor2) => {
      if (keepIds == null || !keepIds.has(tensor2.id)) {
        tensor2.dispose();
      }
    });
    this.tensors.length = 0;
    this.idTensor.dispose();
  }
  size() {
    return this.tensors.length;
  }
  stack(elementShape, elementDtype, numElements = -1) {
    if (elementDtype !== this.elementDtype) {
      throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
    }
    if (numElements !== -1 && this.tensors.length !== numElements) {
      throw new Error(`Operation expected a list with ${numElements} elements but got a list with ${this.tensors.length} elements.`);
    }
    assertShapesMatchAllowUndefinedSize(elementShape, this.elementShape, "TensorList shape mismatch: ");
    const outputElementShape = inferElementShape(this.elementShape, this.tensors, elementShape);
    return tidy(() => {
      const reshapedTensors = this.tensors.map((tensor2) => reshape$3(tensor2, outputElementShape));
      return stack(reshapedTensors, 0);
    });
  }
  popBack(elementShape, elementDtype) {
    if (elementDtype !== this.elementDtype) {
      throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
    }
    if (this.size() === 0) {
      throw new Error("Trying to pop from an empty list.");
    }
    const outputElementShape = inferElementShape(this.elementShape, this.tensors, elementShape);
    const tensor2 = this.tensors.pop();
    assertShapesMatchAllowUndefinedSize(tensor2.shape, elementShape, "TensorList shape mismatch: ");
    return reshape$3(tensor2, outputElementShape);
  }
  pushBack(tensor2) {
    if (tensor2.dtype !== this.elementDtype) {
      throw new Error(`Invalid data types; op elements ${tensor2.dtype}, but list elements ${this.elementDtype}`);
    }
    assertShapesMatchAllowUndefinedSize(tensor2.shape, this.elementShape, "TensorList shape mismatch: ");
    if (this.maxNumElements === this.size()) {
      throw new Error(`Trying to push element into a full list.`);
    }
    keep(tensor2);
    this.tensors.push(tensor2);
  }
  resize(size) {
    if (size < 0) {
      throw new Error(`TensorListResize expects size to be non-negative. Got: ${size}`);
    }
    if (this.maxNumElements !== -1 && size > this.maxNumElements) {
      throw new Error(`TensorListResize input size ${size} is greater maxNumElement ${this.maxNumElements}.`);
    }
    const destTensorList = new TensorList([], this.elementShape, this.elementDtype, this.maxNumElements);
    destTensorList.tensors.length = size;
    for (let i2 = 0; i2 < Math.min(this.tensors.length, size); ++i2) {
      destTensorList.tensors[i2] = this.tensors[i2];
    }
    return destTensorList;
  }
  getItem(elementIndex, elementShape, elementDtype) {
    if (elementDtype !== this.elementDtype) {
      throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
    }
    if (elementIndex < 0 || elementIndex > this.tensors.length) {
      throw new Error(`Trying to access element ${elementIndex} in a list with ${this.tensors.length} elements.`);
    }
    if (this.tensors[elementIndex] == null) {
      throw new Error(`element at index ${elementIndex} is null.`);
    }
    assertShapesMatchAllowUndefinedSize(this.tensors[elementIndex].shape, elementShape, "TensorList shape mismatch: ");
    const outputElementShape = inferElementShape(this.elementShape, this.tensors, elementShape);
    return reshape$3(this.tensors[elementIndex], outputElementShape);
  }
  setItem(elementIndex, tensor2) {
    if (tensor2.dtype !== this.elementDtype) {
      throw new Error(`Invalid data types; op elements ${tensor2.dtype}, but list elements ${this.elementDtype}`);
    }
    if (elementIndex < 0 || this.maxNumElements !== -1 && elementIndex >= this.maxNumElements) {
      throw new Error(`Trying to set element ${elementIndex} in a list with max ${this.maxNumElements} elements.`);
    }
    assertShapesMatchAllowUndefinedSize(this.elementShape, tensor2.shape, "TensorList shape mismatch: ");
    keep(tensor2);
    this.tensors[elementIndex] = tensor2;
  }
  gather(indices, elementDtype, elementShape) {
    if (elementDtype !== this.elementDtype) {
      throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
    }
    assertShapesMatchAllowUndefinedSize(this.elementShape, elementShape, "TensorList shape mismatch: ");
    indices = indices.slice(0, this.size());
    const outputElementShape = inferElementShape(this.elementShape, this.tensors, elementShape);
    if (indices.length === 0) {
      return tensor([], [0].concat(outputElementShape));
    }
    return tidy(() => {
      const tensors = indices.map((i2) => reshape$3(this.tensors[i2], outputElementShape));
      return stack(tensors, 0);
    });
  }
  concat(elementDtype, elementShape) {
    if (!!elementDtype && elementDtype !== this.elementDtype) {
      throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${elementDtype}`);
    }
    assertShapesMatchAllowUndefinedSize(this.elementShape, elementShape, "TensorList shape mismatch: ");
    const outputElementShape = inferElementShape(this.elementShape, this.tensors, elementShape);
    if (this.size() === 0) {
      return tensor([], [0].concat(outputElementShape));
    }
    return tidy(() => {
      const tensors = this.tensors.map((t2) => reshape$3(t2, outputElementShape));
      return concat$3(tensors, 0);
    });
  }
}
function fromTensor(tensor2, elementShape, elementDtype) {
  const dtype = tensor2.dtype;
  if (tensor2.shape.length < 1) {
    throw new Error(`Tensor must be at least a vector, but saw shape: ${tensor2.shape}`);
  }
  if (tensor2.dtype !== elementDtype) {
    throw new Error(`Invalid data types; op elements ${tensor2.dtype}, but list elements ${elementDtype}`);
  }
  const tensorElementShape = tensor2.shape.slice(1);
  assertShapesMatchAllowUndefinedSize(tensorElementShape, elementShape, "TensorList shape mismatch: ");
  const tensorList = unstack(tensor2);
  return new TensorList(tensorList, elementShape, dtype);
}
function reserve(elementShape, elementDtype, numElements) {
  return new TensorList([], elementShape, elementDtype, numElements);
}
function scatter(tensor2, indices, elementShape, numElements) {
  if (indices.length !== tensor2.shape[0]) {
    throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor2.shape[0]}`);
  }
  const maxIndex = Math.max(...indices);
  if (numElements != null && numElements !== -1 && maxIndex >= numElements) {
    throw new Error(`Max index must be < array size (${maxIndex}  vs. ${numElements})`);
  }
  const list = new TensorList([], elementShape, tensor2.dtype, numElements);
  const tensors = unstack(tensor2, 0);
  indices.forEach((value, index2) => {
    list.setItem(value, tensors[index2]);
  });
  return list;
}
function split$1(tensor2, length, elementShape) {
  let totalLength = 0;
  const cumulativeLengths = length.map((len) => {
    totalLength += len;
    return totalLength;
  });
  if (totalLength !== tensor2.shape[0]) {
    throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor2.shape}`);
  }
  const shapeWithoutFirstDim = tensor2.shape.slice(1);
  const outputElementShape = mergeElementShape(shapeWithoutFirstDim, elementShape);
  const elementPerRow = totalLength === 0 ? 0 : tensor2.size / totalLength;
  const tensors = tidy(() => {
    const tensors2 = [];
    tensor2 = reshape$3(tensor2, [1, totalLength, elementPerRow]);
    for (let i2 = 0; i2 < length.length; ++i2) {
      const previousLength = i2 === 0 ? 0 : cumulativeLengths[i2 - 1];
      const indices = [0, previousLength, 0];
      const sizes2 = [1, length[i2], elementPerRow];
      tensors2[i2] = reshape$3(slice$3(tensor2, indices, sizes2), outputElementShape);
    }
    tensor2.dispose();
    return tensors2;
  });
  const list = new TensorList([], elementShape, tensor2.dtype, length.length);
  for (let i2 = 0; i2 < tensors.length; i2++) {
    list.setItem(i2, tensors[i2]);
  }
  return list;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$h = async (node, tensorMap, context2) => {
  switch (node.op) {
    case "If":
    case "StatelessIf": {
      const thenFunc = getParamValue("thenBranch", node, tensorMap, context2);
      const elseFunc = getParamValue("elseBranch", node, tensorMap, context2);
      const cond = getParamValue("cond", node, tensorMap, context2);
      const args = getParamValue("args", node, tensorMap, context2);
      const condValue = await cond.data();
      if (condValue[0]) {
        return context2.functionMap[thenFunc].executeFunctionAsync(args, context2.tensorArrayMap, context2.tensorListMap);
      } else {
        return context2.functionMap[elseFunc].executeFunctionAsync(args, context2.tensorArrayMap, context2.tensorListMap);
      }
    }
    case "While":
    case "StatelessWhile": {
      const bodyFunc = getParamValue("body", node, tensorMap, context2);
      const condFunc = getParamValue("cond", node, tensorMap, context2);
      const args = getParamValue("args", node, tensorMap, context2);
      const condResult = await context2.functionMap[condFunc].executeFunctionAsync(args, context2.tensorArrayMap, context2.tensorListMap);
      const argIds = args.map((tensor2) => tensor2.id);
      let condValue = await condResult[0].data();
      condResult.forEach((tensor2) => {
        if (!tensor2.kept && argIds.indexOf(tensor2.id) === -1) {
          tensor2.dispose();
        }
      });
      let result2 = args;
      while (condValue[0]) {
        const origResult = result2;
        result2 = await context2.functionMap[bodyFunc].executeFunctionAsync(result2, context2.tensorArrayMap, context2.tensorListMap);
        const resultIds = result2.map((tensor2) => tensor2.id);
        origResult.forEach((tensor2) => {
          if (!tensor2.kept && argIds.indexOf(tensor2.id) === -1 && resultIds.indexOf(tensor2.id) === -1) {
            tensor2.dispose();
          }
        });
        const condResult2 = await context2.functionMap[condFunc].executeFunctionAsync(result2, context2.tensorArrayMap, context2.tensorListMap);
        condValue = await condResult2[0].data();
        condResult2.forEach((tensor2) => {
          if (!tensor2.kept && argIds.indexOf(tensor2.id) === -1 && resultIds.indexOf(tensor2.id) === -1) {
            tensor2.dispose();
          }
        });
      }
      return result2;
    }
    case "LoopCond": {
      const pred = getParamValue("pred", node, tensorMap, context2);
      return [cloneTensor(pred)];
    }
    case "Switch": {
      const pred = getParamValue("pred", node, tensorMap, context2);
      let data2 = getParamValue("data", node, tensorMap, context2);
      if (!data2.kept) {
        data2 = cloneTensor(data2);
      }
      return (await pred.data())[0] ? [void 0, data2] : [data2, void 0];
    }
    case "Merge": {
      const inputName = node.inputNames.find((name) => getTensor(name, tensorMap, context2) !== void 0);
      if (inputName) {
        const data2 = getTensor(inputName, tensorMap, context2);
        return [cloneTensor(data2)];
      }
      return void 0;
    }
    case "Enter": {
      const frameId = getParamValue("frameName", node, tensorMap, context2);
      const data2 = getParamValue("tensor", node, tensorMap, context2);
      context2.enterFrame(frameId);
      return [cloneTensor(data2)];
    }
    case "Exit": {
      const data2 = getParamValue("tensor", node, tensorMap, context2);
      context2.exitFrame();
      return [cloneTensor(data2)];
    }
    case "NextIteration": {
      const data2 = getParamValue("tensor", node, tensorMap, context2);
      context2.nextIteration();
      return [cloneTensor(data2)];
    }
    case "TensorArrayV3": {
      const size = getParamValue("size", node, tensorMap, context2);
      const dtype = getParamValue("dtype", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const dynamicSize = getParamValue("dynamicSize", node, tensorMap, context2);
      const clearAfterRead = getParamValue("clearAfterRead", node, tensorMap, context2);
      const identicalElementShapes = getParamValue("identicalElementShapes", node, tensorMap, context2);
      const name = getParamValue("name", node, tensorMap, context2);
      const tensorArray = new TensorArray(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
      context2.addTensorArray(tensorArray);
      return [tensorArray.idTensor, scalar(1)];
    }
    case "TensorArrayWriteV3": {
      const id2 = getParamValue("tensorArrayId", node, tensorMap, context2);
      const index2 = getParamValue("index", node, tensorMap, context2);
      const writeTensor = getParamValue("tensor", node, tensorMap, context2);
      const writeTensorArray = context2.getTensorArray(id2.id);
      writeTensorArray.write(index2, writeTensor);
      return [writeTensorArray.idTensor];
    }
    case "TensorArrayReadV3": {
      const readId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const readIndex = getParamValue("index", node, tensorMap, context2);
      const readTensorArray = context2.getTensorArray(readId.id);
      return [readTensorArray.read(readIndex)];
    }
    case "TensorArrayGatherV3": {
      const gatherId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const gatherIndices = getParamValue("indices", node, tensorMap, context2);
      const gatherDtype = getParamValue("dtype", node, tensorMap, context2);
      const gatherTensorArray = context2.getTensorArray(gatherId.id);
      return [gatherTensorArray.gather(gatherIndices, gatherDtype)];
    }
    case "TensorArrayScatterV3": {
      const scatterId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const scatterIndices = getParamValue("indices", node, tensorMap, context2);
      const scatterTensor = getParamValue("tensor", node, tensorMap, context2);
      const scatterTensorArray = context2.getTensorArray(scatterId.id);
      scatterTensorArray.scatter(scatterIndices, scatterTensor);
      return [scatterTensorArray.idTensor];
    }
    case "TensorArrayConcatV3": {
      const concatId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const concatTensorArray = context2.getTensorArray(concatId.id);
      const concatDtype = getParamValue("dtype", node, tensorMap, context2);
      return [concatTensorArray.concat(concatDtype)];
    }
    case "TensorArraySplitV3": {
      const splitId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const splitTensor = getParamValue("tensor", node, tensorMap, context2);
      const lengths = getParamValue("lengths", node, tensorMap, context2);
      const splitTensorArray = context2.getTensorArray(splitId.id);
      splitTensorArray.split(lengths, splitTensor);
      return [splitTensorArray.idTensor];
    }
    case "TensorArraySizeV3": {
      const sizeId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const sizeTensorArray = context2.getTensorArray(sizeId.id);
      return [scalar(sizeTensorArray.size(), "int32")];
    }
    case "TensorArrayCloseV3": {
      const closeId = getParamValue("tensorArrayId", node, tensorMap, context2);
      const closeTensorArray = context2.getTensorArray(closeId.id);
      closeTensorArray.clearAndClose();
      return [closeTensorArray.idTensor];
    }
    case "TensorListSetItem": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const index2 = getParamValue("index", node, tensorMap, context2);
      const writeTensor = getParamValue("tensor", node, tensorMap, context2);
      const tensorList = context2.getTensorList(idTensor.id);
      tensorList.setItem(index2, writeTensor);
      return [tensorList.idTensor];
    }
    case "TensorListGetItem": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const readIndex = getParamValue("index", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const elementDType = getParamValue("elementDType", node, tensorMap, context2);
      const tensorList = context2.getTensorList(idTensor.id);
      return [tensorList.getItem(readIndex, elementShape, elementDType)];
    }
    case "TensorListScatterV2":
    case "TensorListScatter": {
      const scatterIndices = getParamValue("indices", node, tensorMap, context2);
      const scatterTensor = getParamValue("tensor", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const numElements = getParamValue("numElements", node, tensorMap, context2);
      const tensorList = scatter(scatterTensor, scatterIndices, elementShape, numElements);
      context2.addTensorList(tensorList);
      return [tensorList.idTensor];
    }
    case "TensorListReserve":
    case "EmptyTensorList": {
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const elementDtype = getParamValue("elementDType", node, tensorMap, context2);
      let numElementsParam;
      if (node.op === "TensorListReserve") {
        numElementsParam = "numElements";
      } else {
        numElementsParam = "maxNumElements";
      }
      const numElements = getParamValue(numElementsParam, node, tensorMap, context2);
      const tensorList = reserve(elementShape, elementDtype, numElements);
      context2.addTensorList(tensorList);
      return [tensorList.idTensor];
    }
    case "TensorListGather": {
      const gatherId = getParamValue("tensorListId", node, tensorMap, context2);
      const gatherIndices = getParamValue("indices", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const elementDtype = getParamValue("elementDType", node, tensorMap, context2);
      const tensorList = context2.getTensorList(gatherId.id);
      return [tensorList.gather(gatherIndices, elementDtype, elementShape)];
    }
    case "TensorListStack": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const elementDtype = getParamValue("elementDType", node, tensorMap, context2);
      const numElements = getParamValue("numElements", node, tensorMap, context2);
      const tensorList = context2.getTensorList(idTensor.id);
      return [tensorList.stack(elementShape, elementDtype, numElements)];
    }
    case "TensorListFromTensor": {
      const tensor2 = getParamValue("tensor", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const elementDtype = getParamValue("elementDType", node, tensorMap, context2);
      const tensorList = fromTensor(tensor2, elementShape, elementDtype);
      context2.addTensorList(tensorList);
      return [tensorList.idTensor];
    }
    case "TensorListConcat": {
      const concatId = getParamValue("tensorListId", node, tensorMap, context2);
      const tensorList = context2.getTensorList(concatId.id);
      const concatDtype = getParamValue("dtype", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      return [tensorList.concat(concatDtype, elementShape)];
    }
    case "TensorListPushBack": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const writeTensor = getParamValue("tensor", node, tensorMap, context2);
      const tensorList = context2.getTensorList(idTensor.id);
      tensorList.pushBack(writeTensor);
      return [tensorList.idTensor];
    }
    case "TensorListPopBack": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const elementDType = getParamValue("elementDType", node, tensorMap, context2);
      const tensorList = context2.getTensorList(idTensor.id);
      return [tensorList.popBack(elementShape, elementDType)];
    }
    case "TensorListSplit": {
      const splitTensor = getParamValue("tensor", node, tensorMap, context2);
      const elementShape = getParamValue("elementShape", node, tensorMap, context2);
      const lengths = getParamValue("lengths", node, tensorMap, context2);
      const tensorList = split$1(splitTensor, lengths, elementShape);
      context2.addTensorList(tensorList);
      return [tensorList.idTensor];
    }
    case "TensorListLength": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const tensorList = context2.getTensorList(idTensor.id);
      return [scalar(tensorList.size(), "int32")];
    }
    case "TensorListResize": {
      const idTensor = getParamValue("tensorListId", node, tensorMap, context2);
      const size = getParamValue("size", node, tensorMap, context2);
      const srcTensorList = context2.getTensorList(idTensor.id);
      const destTensorList = srcTensorList.resize(size);
      context2.addTensorList(destTensorList);
      return [destTensorList.idTensor];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedConvAndDepthWiseParams(node, tensorMap, context2) {
  const [extraOp, activationFunc] = getParamValue("fusedOps", node, tensorMap, context2);
  const isBiasAdd = extraOp === "biasadd";
  const noBiasAdd = !isBiasAdd;
  const isPrelu = activationFunc === "prelu";
  const isBatchNorm = extraOp === "fusedbatchnorm";
  const numArgs = getParamValue("numArgs", node, tensorMap, context2);
  if (isBiasAdd) {
    if (isPrelu && numArgs !== 2) {
      throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
    }
    if (!isPrelu && isBiasAdd && numArgs !== 1) {
      throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
  }
  if (isBatchNorm) {
    throw new Error("FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported");
  }
  const stride = getParamValue("strides", node, tensorMap, context2);
  const pad2 = getPadding(node, tensorMap, context2);
  const dataFormat = getParamValue("dataFormat", node, tensorMap, context2).toUpperCase();
  const dilations = getParamValue("dilations", node, tensorMap, context2);
  let [biasArg, preluArg] = getParamValue("args", node, tensorMap, context2);
  if (noBiasAdd) {
    preluArg = biasArg;
    biasArg = void 0;
  }
  const leakyreluAlpha = getParamValue("leakyreluAlpha", node, tensorMap, context2);
  return {
    stride,
    pad: pad2,
    dataFormat,
    dilations,
    biasArg,
    preluArg,
    activationFunc,
    leakyreluAlpha
  };
}
const executeOp$g = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Conv1D": {
      const stride = getParamValue("stride", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const dataFormat = getParamValue("dataFormat", node, tensorMap, context2).toUpperCase();
      const dilation = getParamValue("dilation", node, tensorMap, context2);
      return [conv1d(getParamValue("x", node, tensorMap, context2), getParamValue("filter", node, tensorMap, context2), stride, pad2, dataFormat, dilation)];
    }
    case "Conv2D": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getPadding(node, tensorMap, context2);
      const dataFormat = getParamValue("dataFormat", node, tensorMap, context2).toUpperCase();
      const dilations = getParamValue("dilations", node, tensorMap, context2);
      return [conv2d$3(getParamValue("x", node, tensorMap, context2), getParamValue("filter", node, tensorMap, context2), [stride[1], stride[2]], pad2, dataFormat, [dilations[1], dilations[2]])];
    }
    case "_FusedConv2D": {
      const { stride, pad: pad2, dataFormat, dilations, biasArg, preluArg, activationFunc, leakyreluAlpha } = fusedConvAndDepthWiseParams(node, tensorMap, context2);
      return [conv2d$2({
        x: getParamValue("x", node, tensorMap, context2),
        filter: getParamValue("filter", node, tensorMap, context2),
        strides: [stride[1], stride[2]],
        pad: pad2,
        dataFormat,
        dilations: [dilations[1], dilations[2]],
        bias: biasArg,
        activation: activationFunc,
        preluActivationWeights: preluArg,
        leakyreluAlpha
      })];
    }
    case "FusedDepthwiseConv2dNative": {
      const { stride, pad: pad2, dataFormat, dilations, biasArg, preluArg, activationFunc, leakyreluAlpha } = fusedConvAndDepthWiseParams(node, tensorMap, context2);
      return [depthwiseConv2d$2({
        x: getParamValue("x", node, tensorMap, context2),
        filter: getParamValue("filter", node, tensorMap, context2),
        strides: [stride[1], stride[2]],
        pad: pad2,
        dataFormat,
        dilations: [dilations[1], dilations[2]],
        bias: biasArg,
        activation: activationFunc,
        preluActivationWeights: preluArg,
        leakyreluAlpha
      })];
    }
    case "Conv2DBackpropInput":
    case "Conv2dTranspose": {
      const shape = getParamValue("outputShape", node, tensorMap, context2);
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getPadding(node, tensorMap, context2);
      return [conv2dTranspose(getParamValue("x", node, tensorMap, context2), getParamValue("filter", node, tensorMap, context2), shape, [stride[1], stride[2]], pad2)];
    }
    case "DepthwiseConv2dNative":
    case "DepthwiseConv2d": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getPadding(node, tensorMap, context2);
      const dilations = getParamValue("dilations", node, tensorMap, context2);
      const dataFormat = getParamValue("dataFormat", node, tensorMap, context2).toUpperCase();
      return [depthwiseConv2d$3(getParamValue("input", node, tensorMap, context2), getParamValue("filter", node, tensorMap, context2), [stride[1], stride[2]], pad2, dataFormat, [dilations[1], dilations[2]])];
    }
    case "Conv3D": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const dataFormat = getParamValue("dataFormat", node, tensorMap, context2).toUpperCase();
      const dilations = getParamValue("dilations", node, tensorMap, context2);
      return [conv3d(getParamValue("x", node, tensorMap, context2), getParamValue("filter", node, tensorMap, context2), [stride[1], stride[2], stride[3]], pad2, dataFormat, [dilations[1], dilations[2], dilations[3]])];
    }
    case "AvgPool": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const kernelSize = getParamValue("kernelSize", node, tensorMap, context2);
      return [avgPool$3(getParamValue("x", node, tensorMap, context2), [kernelSize[1], kernelSize[2]], [stride[1], stride[2]], pad2)];
    }
    case "MaxPool": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const kernelSize = getParamValue("kernelSize", node, tensorMap, context2);
      return [maxPool$3(getParamValue("x", node, tensorMap, context2), [kernelSize[1], kernelSize[2]], [stride[1], stride[2]], pad2)];
    }
    case "MaxPoolWithArgmax": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const kernelSize = getParamValue("kernelSize", node, tensorMap, context2);
      const includeBatchInIndex = getParamValue("includeBatchInIndex", node, tensorMap, context2);
      const { result: result2, indexes } = maxPoolWithArgmax(getParamValue("x", node, tensorMap, context2), [kernelSize[1], kernelSize[2]], [stride[1], stride[2]], pad2, includeBatchInIndex);
      return [result2, indexes];
    }
    case "AvgPool3D": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const kernelSize = getParamValue("kernelSize", node, tensorMap, context2);
      return [avgPool3d(getParamValue("x", node, tensorMap, context2), [kernelSize[1], kernelSize[2], kernelSize[3]], [stride[1], stride[2], stride[3]], pad2)];
    }
    case "MaxPool3D": {
      const stride = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const kernelSize = getParamValue("kernelSize", node, tensorMap, context2);
      return [maxPool3d$1(getParamValue("x", node, tensorMap, context2), [kernelSize[1], kernelSize[2], kernelSize[3]], [stride[1], stride[2], stride[3]], pad2)];
    }
    case "Dilation2D": {
      const strides = getParamValue("strides", node, tensorMap, context2);
      const pad2 = getParamValue("pad", node, tensorMap, context2);
      const dilations = getParamValue("dilations", node, tensorMap, context2);
      const strideHeight = strides[1];
      const strideWidth = strides[2];
      const dilationHeight = dilations[1];
      const dilationWidth = dilations[2];
      return [dilation2d(getParamValue("x", node, tensorMap, context2), getParamValue("filter", node, tensorMap, context2), [strideHeight, strideWidth], pad2, [dilationHeight, dilationWidth], "NHWC")];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$f = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Fill": {
      const shape = getParamValue("shape", node, tensorMap, context2);
      const dtype = getParamValue("dtype", node, tensorMap, context2);
      const value = getParamValue("value", node, tensorMap, context2);
      return [fill$3(shape, value, dtype)];
    }
    case "LinSpace": {
      const start = getParamValue("start", node, tensorMap, context2);
      const stop = getParamValue("stop", node, tensorMap, context2);
      const num = getParamValue("num", node, tensorMap, context2);
      return [linspace(start, stop, num)];
    }
    case "Multinomial": {
      const logits = getParamValue("logits", node, tensorMap, context2);
      const numSamples = getParamValue("numSamples", node, tensorMap, context2);
      const seed = getParamValue("seed", node, tensorMap, context2);
      return [multinomial$2(logits, numSamples, seed)];
    }
    case "OneHot": {
      const indices = getParamValue("indices", node, tensorMap, context2);
      const depth = getParamValue("depth", node, tensorMap, context2);
      const onValue = getParamValue("onValue", node, tensorMap, context2);
      const offValue = getParamValue("offValue", node, tensorMap, context2);
      return [oneHot$3(indices, depth, onValue, offValue)];
    }
    case "Ones": {
      return [ones(getParamValue("shape", node, tensorMap, context2), getParamValue("dtype", node, tensorMap, context2))];
    }
    case "OnesLike": {
      return [onesLike$3(getParamValue("x", node, tensorMap, context2))];
    }
    case "RandomUniform": {
      return [randomUniform(getParamValue("shape", node, tensorMap, context2), getParamValue("minval", node, tensorMap, context2), getParamValue("maxval", node, tensorMap, context2), getParamValue("dtype", node, tensorMap, context2))];
    }
    case "Range": {
      const start = getParamValue("start", node, tensorMap, context2);
      const stop = getParamValue("stop", node, tensorMap, context2);
      const step2 = getParamValue("step", node, tensorMap, context2);
      return [range$4(start, stop, step2, getParamValue("dtype", node, tensorMap, context2))];
    }
    case "TruncatedNormal": {
      const shape = getParamValue("shape", node, tensorMap, context2);
      const mean2 = getParamValue("mean", node, tensorMap, context2);
      const stdDev = getParamValue("stdDev", node, tensorMap, context2);
      const seed = getParamValue("seed", node, tensorMap, context2);
      return [truncatedNormal(shape, mean2, stdDev, getParamValue("dtype", node, tensorMap, context2), seed)];
    }
    case "Zeros": {
      return [zeros$1(getParamValue("shape", node, tensorMap, context2), getParamValue("dtype", node, tensorMap, context2))];
    }
    case "ZerosLike": {
      return [zerosLike$3(getParamValue("x", node, tensorMap, context2))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function nmsParams(node, tensorMap, context2) {
  const boxes = getParamValue("boxes", node, tensorMap, context2);
  const scores = getParamValue("scores", node, tensorMap, context2);
  const maxOutputSize = getParamValue("maxOutputSize", node, tensorMap, context2);
  const iouThreshold = getParamValue("iouThreshold", node, tensorMap, context2);
  const scoreThreshold = getParamValue("scoreThreshold", node, tensorMap, context2);
  const softNmsSigma = getParamValue("softNmsSigma", node, tensorMap, context2);
  return {
    boxes,
    scores,
    maxOutputSize,
    iouThreshold,
    scoreThreshold,
    softNmsSigma
  };
}
const executeOp$e = async (node, tensorMap, context2) => {
  switch (node.op) {
    case "NonMaxSuppressionV5": {
      const { boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma } = nmsParams(node, tensorMap, context2);
      const result2 = await image$1.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
      return [result2.selectedIndices, result2.selectedScores];
    }
    case "NonMaxSuppressionV4": {
      const { boxes, scores, maxOutputSize, iouThreshold, scoreThreshold } = nmsParams(node, tensorMap, context2);
      const padToMaxOutputSize = getParamValue("padToMaxOutputSize", node, tensorMap, context2);
      const result2 = await image$1.nonMaxSuppressionPaddedAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
      return [result2.selectedIndices, result2.validOutputs];
    }
    case "NonMaxSuppressionV3":
    case "NonMaxSuppressionV2": {
      const { boxes, scores, maxOutputSize, iouThreshold, scoreThreshold } = nmsParams(node, tensorMap, context2);
      return [await image$1.nonMaxSuppressionAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold)];
    }
    case "Where": {
      const condition = cast$4(getParamValue("condition", node, tensorMap, context2), "bool");
      const result2 = [await whereAsync(condition)];
      condition.dispose();
      return result2;
    }
    case "ListDiff": {
      return setdiff1dAsync(getParamValue("x", node, tensorMap, context2), getParamValue("y", node, tensorMap, context2));
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$d = (node, tensorMap, context2) => {
  switch (node.op) {
    case "TopKV2": {
      const x2 = getParamValue("x", node, tensorMap, context2);
      const k3 = getParamValue("k", node, tensorMap, context2);
      const sorted = getParamValue("sorted", node, tensorMap, context2);
      const result2 = topk$1(x2, k3, sorted);
      return [result2.values, result2.indices];
    }
    case "Unique": {
      const x2 = getParamValue("x", node, tensorMap, context2);
      const result2 = unique$3(x2);
      return [result2.values, result2.indices];
    }
    case "UniqueV2": {
      const x2 = getParamValue("x", node, tensorMap, context2);
      const axis = getParamValue("axis", node, tensorMap, context2);
      const result2 = unique$3(x2, axis);
      return [result2.values, result2.indices];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$c = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Const": {
      return tensorMap[node.name];
    }
    case "PlaceholderWithDefault":
      const def = getParamValue("default", node, tensorMap, context2);
      return [getTensor(node.name, tensorMap, context2) || def];
    case "Placeholder":
      return [getTensor(node.name, tensorMap, context2)];
    case "Identity":
    case "StopGradient":
    case "FakeQuantWithMinMaxVars": {
      const data3 = getParamValue("x", node, tensorMap, context2);
      return [cloneTensor(data3)];
    }
    case "IdentityN":
      return getParamValue("x", node, tensorMap, context2).map((t2) => cloneTensor(t2));
    case "Snapshot":
      const snapshot = getParamValue("x", node, tensorMap, context2);
      return [cloneTensor(snapshot)];
    case "Shape":
      return [tensor1d(getParamValue("x", node, tensorMap, context2).shape, "int32")];
    case "ShapeN":
      return getParamValue("x", node, tensorMap, context2).map((t2) => tensor1d(t2.shape));
    case "Size":
      return [scalar(getParamValue("x", node, tensorMap, context2).size, "int32")];
    case "Rank":
      return [scalar(getParamValue("x", node, tensorMap, context2).rank, "int32")];
    case "NoOp":
      return [scalar(1)];
    case "Print":
      const input = getParamValue("x", node, tensorMap, context2);
      const data2 = getParamValue("data", node, tensorMap, context2);
      const message2 = getParamValue("message", node, tensorMap, context2);
      const summarize = getParamValue("summarize", node, tensorMap, context2);
      console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance.");
      console.log(message2);
      for (let i2 = 0; i2 < data2.length; i2++) {
        console.log(Array.prototype.slice.call(data2[i2].dataSync()).slice(0, summarize));
      }
      return [input];
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class HashTable {
  constructor(keyDType, valueDType) {
    this.keyDType = keyDType;
    this.valueDType = valueDType;
    this.handle = scalar(0);
    this.tensorMap = /* @__PURE__ */ new Map();
    keep(this.handle);
  }
  get id() {
    return this.handle.id;
  }
  clearAndClose() {
    this.tensorMap.forEach((value) => value.dispose());
    this.tensorMap.clear();
    this.handle.dispose();
  }
  size() {
    return this.tensorMap.size;
  }
  tensorSize() {
    return scalar(this.size(), "int32");
  }
  async import(keys, values) {
    this.checkKeyAndValueTensor(keys, values);
    const $keys = await keys.data();
    this.tensorMap.forEach((value) => value.dispose());
    this.tensorMap.clear();
    return tidy(() => {
      const $values = unstack(values);
      const keysLength = $keys.length;
      const valuesLength = $values.length;
      assert$1(keysLength === valuesLength, () => `The number of elements doesn't match, keys has ${keysLength} elements, the values has ${valuesLength} elements.`);
      for (let i2 = 0; i2 < keysLength; i2++) {
        const key = $keys[i2];
        const value = $values[i2];
        keep(value);
        this.tensorMap.set(key, value);
      }
      return this.handle;
    });
  }
  async find(keys, defaultValue) {
    this.checkKeyAndValueTensor(keys, defaultValue);
    const $keys = await keys.data();
    return tidy(() => {
      const result2 = [];
      for (let i2 = 0; i2 < $keys.length; i2++) {
        const key = $keys[i2];
        const value = this.findWithDefault(key, defaultValue);
        result2.push(value);
      }
      return stack(result2);
    });
  }
  findWithDefault(key, defaultValue) {
    const result2 = this.tensorMap.get(key);
    return result2 != null ? result2 : defaultValue;
  }
  checkKeyAndValueTensor(key, value) {
    if (key.dtype !== this.keyDType) {
      throw new Error(`Expect key dtype ${this.keyDType}, but got ${key.dtype}`);
    }
    if (value.dtype !== this.valueDType) {
      throw new Error(`Expect value dtype ${this.valueDType}, but got ${value.dtype}`);
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$b = async (node, tensorMap, context2, resourceManager) => {
  switch (node.op) {
    case "HashTable":
    case "HashTableV2": {
      const keyDType = getParamValue("keyDType", node, tensorMap, context2);
      const valueDType = getParamValue("valueDType", node, tensorMap, context2);
      const hashTable2 = new HashTable(keyDType, valueDType);
      resourceManager.addHashTable(node.name, hashTable2);
      return [hashTable2.handle];
    }
    case "LookupTableImport":
    case "LookupTableImportV2": {
      const handle2 = getParamValue("tableHandle", node, tensorMap, context2, resourceManager);
      const keys = getParamValue("keys", node, tensorMap, context2);
      const values = getParamValue("values", node, tensorMap, context2);
      const hashTable2 = resourceManager.getHashTableById(handle2.id);
      return [await hashTable2.import(keys, values)];
    }
    case "LookupTableFind":
    case "LookupTableFindV2": {
      const handle2 = getParamValue("tableHandle", node, tensorMap, context2, resourceManager);
      const keys = getParamValue("keys", node, tensorMap, context2);
      const defaultValue = getParamValue("defaultValue", node, tensorMap, context2);
      const hashTable2 = resourceManager.getHashTableById(handle2.id);
      return [await hashTable2.find(keys, defaultValue)];
    }
    case "LookupTableSize":
    case "LookupTableSizeV2": {
      const handle2 = getParamValue("tableHandle", node, tensorMap, context2, resourceManager);
      const hashTable2 = resourceManager.getHashTableById(handle2.id);
      return [hashTable2.tensorSize()];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$a = (node, tensorMap, context2) => {
  switch (node.op) {
    case "ResizeBilinear": {
      const images = getParamValue("images", node, tensorMap, context2);
      const size = getParamValue("size", node, tensorMap, context2);
      const alignCorners = getParamValue("alignCorners", node, tensorMap, context2);
      const halfPixelCenters = getParamValue("halfPixelCenters", node, tensorMap, context2);
      return [image$1.resizeBilinear(images, [size[0], size[1]], alignCorners, halfPixelCenters)];
    }
    case "ResizeNearestNeighbor": {
      const images = getParamValue("images", node, tensorMap, context2);
      const size = getParamValue("size", node, tensorMap, context2);
      const alignCorners = getParamValue("alignCorners", node, tensorMap, context2);
      const halfPixelCenters = getParamValue("halfPixelCenters", node, tensorMap, context2);
      return [image$1.resizeNearestNeighbor(images, [size[0], size[1]], alignCorners, halfPixelCenters)];
    }
    case "CropAndResize": {
      const image2 = getParamValue("image", node, tensorMap, context2);
      const boxes = getParamValue("boxes", node, tensorMap, context2);
      const boxInd = getParamValue("boxInd", node, tensorMap, context2);
      const cropSize = getParamValue("cropSize", node, tensorMap, context2);
      const method2 = getParamValue("method", node, tensorMap, context2);
      const extrapolationValue = getParamValue("extrapolationValue", node, tensorMap, context2);
      return [image$1.cropAndResize(image2, boxes, boxInd, cropSize, method2, extrapolationValue)];
    }
    case "ImageProjectiveTransformV3": {
      const images = getParamValue("images", node, tensorMap, context2);
      const transforms = getParamValue("transforms", node, tensorMap, context2);
      const outputShape = getParamValue("outputShape", node, tensorMap, context2);
      const fillValue = getParamValue("fillValue", node, tensorMap, context2);
      const interpolation = getParamValue("interpolation", node, tensorMap, context2);
      const fillMode = getParamValue("fillMode", node, tensorMap, context2);
      return [image$1.transform(images, transforms, interpolation.toLowerCase(), fillMode.toLowerCase(), fillValue, outputShape)];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$9 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Equal": {
      return [equal$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "NotEqual": {
      return [notEqual$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Greater": {
      return [greater$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "GreaterEqual": {
      return [greaterEqual$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Less": {
      return [less$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "LessEqual": {
      return [lessEqual$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "LogicalAnd": {
      return [logicalAnd$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "LogicalNot": {
      return [logicalNot$2(getParamValue("a", node, tensorMap, context2))];
    }
    case "LogicalOr": {
      return [logicalOr$2(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    case "Select":
    case "SelectV2": {
      return [where(getParamValue("condition", node, tensorMap, context2), getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$8 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "BatchMatMul":
    case "BatchMatMulV2":
    case "MatMul":
      return [matMul$1(getParamValue("a", node, tensorMap, context2), getParamValue("b", node, tensorMap, context2), getParamValue("transposeA", node, tensorMap, context2), getParamValue("transposeB", node, tensorMap, context2))];
    case "Einsum":
      return [einsum$2(getParamValue("equation", node, tensorMap, context2), ...getParamValue("tensors", node, tensorMap, context2))];
    case "Transpose":
      return [transpose$3(getParamValue("x", node, tensorMap, context2), getParamValue("perm", node, tensorMap, context2))];
    case "_FusedMatMul":
      const [extraOp, activationFunc] = getParamValue("fusedOps", node, tensorMap, context2);
      const isBiasAdd = extraOp === "biasadd";
      const isPrelu = activationFunc === "prelu";
      const numArgs = getParamValue("numArgs", node, tensorMap, context2);
      const leakyreluAlpha = getParamValue("leakyreluAlpha", node, tensorMap, context2);
      if (isBiasAdd) {
        if (isPrelu && numArgs !== 2) {
          throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        }
        if (!isPrelu && numArgs !== 1) {
          throw new Error("Fused MatMul with BiasAdd must have one extra argument: bias.");
        }
      }
      const [biasArg, preluArg] = getParamValue("args", node, tensorMap, context2);
      return [matMul({
        a: getParamValue("a", node, tensorMap, context2),
        b: getParamValue("b", node, tensorMap, context2),
        transposeA: getParamValue("transposeA", node, tensorMap, context2),
        transposeB: getParamValue("transposeB", node, tensorMap, context2),
        bias: biasArg,
        activation: activationFunc,
        preluActivationWeights: preluArg,
        leakyreluAlpha
      })];
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$7 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "FusedBatchNorm":
    case "FusedBatchNormV2": {
      return [batchNorm$2(getParamValue("x", node, tensorMap, context2), getParamValue("mean", node, tensorMap, context2), getParamValue("variance", node, tensorMap, context2), getParamValue("offset", node, tensorMap, context2), getParamValue("scale", node, tensorMap, context2), getParamValue("epsilon", node, tensorMap, context2))];
    }
    case "FusedBatchNormV3": {
      return [batchNorm$2(getParamValue("x", node, tensorMap, context2), getParamValue("mean", node, tensorMap, context2), getParamValue("variance", node, tensorMap, context2), getParamValue("offset", node, tensorMap, context2), getParamValue("scale", node, tensorMap, context2), getParamValue("epsilon", node, tensorMap, context2))];
    }
    case "LRN": {
      return [localResponseNormalization(getParamValue("x", node, tensorMap, context2), getParamValue("radius", node, tensorMap, context2), getParamValue("bias", node, tensorMap, context2), getParamValue("alpha", node, tensorMap, context2), getParamValue("beta", node, tensorMap, context2))];
    }
    case "Softmax": {
      return [softmax$3(getParamValue("x", node, tensorMap, context2))];
    }
    case "LogSoftmax": {
      return [logSoftmax(getParamValue("x", node, tensorMap, context2))];
    }
    case "SparseToDense": {
      return [sparseToDense$2(getParamValue("sparseIndices", node, tensorMap, context2), getParamValue("outputShape", node, tensorMap, context2), getParamValue("sparseValues", node, tensorMap, context2), getParamValue("defaultValue", node, tensorMap, context2))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$6 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Max": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [max$4(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "Mean": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [mean$2(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "Min": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [min$4(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "Sum": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [sum$3(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "All": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [all$3(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "Any": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [any$3(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "ArgMax": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      return [argMax$2(getParamValue("x", node, tensorMap, context2), axis)];
    }
    case "ArgMin": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      return [argMin$2(getParamValue("x", node, tensorMap, context2), axis)];
    }
    case "Prod": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const keepDims = getParamValue("keepDims", node, tensorMap, context2);
      return [prod$3(getParamValue("x", node, tensorMap, context2), axis, keepDims)];
    }
    case "Cumprod": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const exclusive = getParamValue("exclusive", node, tensorMap, context2);
      const reverse2 = getParamValue("reverse", node, tensorMap, context2);
      return [cumprod$3(getParamValue("x", node, tensorMap, context2), axis, exclusive, reverse2)];
    }
    case "Cumsum": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const exclusive = getParamValue("exclusive", node, tensorMap, context2);
      const reverse2 = getParamValue("reverse", node, tensorMap, context2);
      return [cumsum$3(getParamValue("x", node, tensorMap, context2), axis, exclusive, reverse2)];
    }
    case "Bincount":
      const x2 = getParamValue("x", node, tensorMap, context2);
      const weights = getParamValue("weights", node, tensorMap, context2);
      const size = getParamValue("size", node, tensorMap, context2);
      return [bincount$2(x2, weights, size)];
    case "DenseBincount": {
      const x3 = getParamValue("x", node, tensorMap, context2);
      const weights2 = getParamValue("weights", node, tensorMap, context2);
      const size2 = getParamValue("size", node, tensorMap, context2);
      const binaryOutput = getParamValue("binaryOutput", node, tensorMap, context2);
      return [denseBincount$2(x3, weights2, size2, binaryOutput)];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$5 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "ConcatV2":
    case "Concat": {
      const n2 = getParamValue("n", node, tensorMap, context2);
      const axis = getParamValue("axis", node, tensorMap, context2);
      let inputs = getParamValue("tensors", node, tensorMap, context2);
      inputs = inputs.slice(0, n2);
      return [concat$3(inputs, axis)];
    }
    case "Gather": {
      const input = getParamValue("x", node, tensorMap, context2);
      const indices = getParamValue("indices", node, tensorMap, context2);
      return [gather$1(input, cast$4(indices, "int32"), 0)];
    }
    case "GatherV2": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const batchDims = getParamValue("batchDims", node, tensorMap, context2);
      const input = getParamValue("x", node, tensorMap, context2);
      const indices = getParamValue("indices", node, tensorMap, context2);
      return [gather$1(input, cast$4(indices, "int32"), axis, batchDims)];
    }
    case "Reverse": {
      const dims = getParamValue("dims", node, tensorMap, context2);
      const axis = [];
      for (let i2 = 0; i2 < dims.length; i2++) {
        if (dims[i2]) {
          axis.push(i2);
        }
      }
      const input = getParamValue("x", node, tensorMap, context2);
      return [reverse$3(input, axis)];
    }
    case "ReverseV2": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const input = getParamValue("x", node, tensorMap, context2);
      return [reverse$3(input, axis)];
    }
    case "Slice": {
      const begin = getParamValue("begin", node, tensorMap, context2);
      const size = getParamValue("size", node, tensorMap, context2);
      return [slice$3(getParamValue("x", node, tensorMap, context2), begin, size)];
    }
    case "StridedSlice": {
      const begin = getParamValue("begin", node, tensorMap, context2);
      const end = getParamValue("end", node, tensorMap, context2);
      const strides = getParamValue("strides", node, tensorMap, context2);
      const beginMask = getParamValue("beginMask", node, tensorMap, context2);
      const endMask = getParamValue("endMask", node, tensorMap, context2);
      const ellipsisMask = getParamValue("ellipsisMask", node, tensorMap, context2);
      const newAxisMask = getParamValue("newAxisMask", node, tensorMap, context2);
      const shrinkAxisMask = getParamValue("shrinkAxisMask", node, tensorMap, context2);
      const tensor2 = getParamValue("x", node, tensorMap, context2);
      return [stridedSlice$3(tensor2, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask)];
    }
    case "Pack": {
      return tidy(() => {
        const axis = getParamValue("axis", node, tensorMap, context2);
        const tensors = getParamValue("tensors", node, tensorMap, context2);
        const shape = tensors[0].shape;
        const squeezedShape = squeeze(tensors[0]).shape;
        const mapped = tensors.map((tensor2) => {
          const sameShape = arraysEqual(tensor2.shape, shape);
          if (!sameShape && !arraysEqual(squeeze(tensor2).shape, squeezedShape)) {
            throw new Error("the input tensors shape does not match");
          }
          return sameShape ? tensor2 : reshape$3(tensor2, shape);
        });
        return [stack(mapped, axis)];
      });
    }
    case "Unpack": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const tensor2 = getParamValue("tensor", node, tensorMap, context2);
      return unstack(tensor2, axis);
    }
    case "Tile": {
      const reps = getParamValue("reps", node, tensorMap, context2);
      return [tile$4(getParamValue("x", node, tensorMap, context2), reps)];
    }
    case "Split":
    case "SplitV": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      const numOrSizeSplits = getParamValue("numOrSizeSplits", node, tensorMap, context2);
      const tensor2 = getParamValue("x", node, tensorMap, context2);
      return split$2(tensor2, numOrSizeSplits, axis);
    }
    case "ScatterNd": {
      const indices = getParamValue("indices", node, tensorMap, context2);
      const values = getParamValue("values", node, tensorMap, context2);
      const shape = getParamValue("shape", node, tensorMap, context2);
      return [scatterND(indices, values, shape)];
    }
    case "GatherNd": {
      const x2 = getParamValue("x", node, tensorMap, context2);
      const indices = getParamValue("indices", node, tensorMap, context2);
      return [gatherND(x2, indices)];
    }
    case "SparseToDense": {
      const indices = getParamValue("sparseIndices", node, tensorMap, context2);
      const shape = getParamValue("outputShape", node, tensorMap, context2);
      const sparseValues = getParamValue("sparseValues", node, tensorMap, context2);
      const defaultValue = getParamValue("defaultValue", node, tensorMap, context2);
      return [sparseToDense$2(indices, sparseValues, shape, sparseValues.dtype === defaultValue.dtype ? defaultValue : cast$4(defaultValue, sparseValues.dtype))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$4 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "SparseFillEmptyRows": {
      const { outputIndices, outputValues, emptyRowIndicator, reverseIndexMap } = sparse$1.sparseFillEmptyRows(getParamValue("indices", node, tensorMap, context2), getParamValue("values", node, tensorMap, context2), getParamValue("denseShape", node, tensorMap, context2), getParamValue("defaultValue", node, tensorMap, context2));
      return [
        outputIndices,
        outputValues,
        emptyRowIndicator,
        reverseIndexMap
      ];
    }
    case "SparseReshape": {
      const { outputIndices, outputShape } = sparse$1.sparseReshape(getParamValue("inputIndices", node, tensorMap, context2), getParamValue("inputShape", node, tensorMap, context2), getParamValue("newShape", node, tensorMap, context2));
      return [outputIndices, outputShape];
    }
    case "SparseSegmentMean": {
      const outputData = sparse$1.sparseSegmentMean(getParamValue("data", node, tensorMap, context2), getParamValue("indices", node, tensorMap, context2), getParamValue("segmentIds", node, tensorMap, context2));
      return [outputData];
    }
    case "SparseSegmentSum": {
      const outputData = sparse$1.sparseSegmentSum(getParamValue("data", node, tensorMap, context2), getParamValue("indices", node, tensorMap, context2), getParamValue("segmentIds", node, tensorMap, context2));
      return [outputData];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$3 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "FFT": {
      return [fft$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "IFFT": {
      return [ifft$2(getParamValue("x", node, tensorMap, context2))];
    }
    case "RFFT": {
      return [rfft(getParamValue("x", node, tensorMap, context2))];
    }
    case "IRFFT": {
      return [irfft(getParamValue("x", node, tensorMap, context2))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$2 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "StringNGrams": {
      const { nGrams, nGramsSplits } = string$1.stringNGrams(getParamValue("data", node, tensorMap, context2), getParamValue("dataSplits", node, tensorMap, context2), getParamValue("separator", node, tensorMap, context2), getParamValue("nGramWidths", node, tensorMap, context2), getParamValue("leftPad", node, tensorMap, context2), getParamValue("rightPad", node, tensorMap, context2), getParamValue("padWidth", node, tensorMap, context2), getParamValue("preserveShortSequences", node, tensorMap, context2));
      return [nGrams, nGramsSplits];
    }
    case "StringSplit": {
      const { indices, values, shape } = string$1.stringSplit(getParamValue("input", node, tensorMap, context2), getParamValue("delimiter", node, tensorMap, context2), getParamValue("skipEmpty", node, tensorMap, context2));
      return [indices, values, shape];
    }
    case "StringToHashBucketFast": {
      const output2 = string$1.stringToHashBucketFast(getParamValue("input", node, tensorMap, context2), getParamValue("numBuckets", node, tensorMap, context2));
      return [output2];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const executeOp$1 = (node, tensorMap, context2) => {
  switch (node.op) {
    case "Cast": {
      return [cast$4(getParamValue("x", node, tensorMap, context2), getParamValue("dtype", node, tensorMap, context2))];
    }
    case "ExpandDims": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      return [expandDims$4(getParamValue("x", node, tensorMap, context2), axis)];
    }
    case "Squeeze": {
      const axis = getParamValue("axis", node, tensorMap, context2);
      return [squeeze(getParamValue("x", node, tensorMap, context2), axis)];
    }
    case "Reshape": {
      return [reshape$3(getParamValue("x", node, tensorMap, context2), getParamValue("shape", node, tensorMap, context2))];
    }
    case "MirrorPad": {
      return [mirrorPad$2(getParamValue("x", node, tensorMap, context2), getParamValue("padding", node, tensorMap, context2), getParamValue("mode", node, tensorMap, context2))];
    }
    case "PadV2":
    case "Pad": {
      return [pad$1(getParamValue("x", node, tensorMap, context2), getParamValue("padding", node, tensorMap, context2), getParamValue("constantValue", node, tensorMap, context2))];
    }
    case "SpaceToBatchND": {
      const blockShape = getParamValue("blockShape", node, tensorMap, context2);
      const paddings = getParamValue("paddings", node, tensorMap, context2);
      return [spaceToBatchND$3(getParamValue("x", node, tensorMap, context2), blockShape, paddings)];
    }
    case "BatchToSpaceND": {
      const blockShape = getParamValue("blockShape", node, tensorMap, context2);
      const crops = getParamValue("crops", node, tensorMap, context2);
      return [batchToSpaceND$3(getParamValue("x", node, tensorMap, context2), blockShape, crops)];
    }
    case "DepthToSpace": {
      const blockSize = getParamValue("blockSize", node, tensorMap, context2);
      const dataFormat = getParamValue("dataFormat", node, tensorMap, context2).toUpperCase();
      return [depthToSpace$3(getParamValue("x", node, tensorMap, context2), blockSize, dataFormat)];
    }
    case "BroadcastTo": {
      return [broadcastTo(getParamValue("x", node, tensorMap, context2), getParamValue("shape", node, tensorMap, context2))];
    }
    case "BroadcastArgs": {
      return [broadcastArgs$2(getParamValue("s0", node, tensorMap, context2), getParamValue("s1", node, tensorMap, context2))];
    }
    default:
      throw TypeError(`Node type ${node.op} is not implemented`);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function executeOp(node, tensorMap, context2, resourceManager) {
  const value = ((node2, tensorMap2, context3) => {
    switch (node2.category) {
      case "arithmetic":
        return tidy(() => executeOp$j(node2, tensorMap2, context3));
      case "basic_math":
        return tidy(() => executeOp$i(node2, tensorMap2, context3));
      case "control":
        return executeOp$h(node2, tensorMap2, context3);
      case "convolution":
        return tidy(() => executeOp$g(node2, tensorMap2, context3));
      case "creation":
        return tidy(() => executeOp$f(node2, tensorMap2, context3));
      case "dynamic":
        return executeOp$e(node2, tensorMap2, context3);
      case "evaluation":
        return tidy(() => executeOp$d(node2, tensorMap2, context3));
      case "image":
        return tidy(() => executeOp$a(node2, tensorMap2, context3));
      case "graph":
        return tidy(() => executeOp$c(node2, tensorMap2, context3));
      case "logical":
        return tidy(() => executeOp$9(node2, tensorMap2, context3));
      case "matrices":
        return tidy(() => executeOp$8(node2, tensorMap2, context3));
      case "normalization":
        return tidy(() => executeOp$7(node2, tensorMap2, context3));
      case "reduction":
        return tidy(() => executeOp$6(node2, tensorMap2, context3));
      case "slice_join":
        return tidy(() => executeOp$5(node2, tensorMap2, context3));
      case "sparse":
        return tidy(() => executeOp$4(node2, tensorMap2, context3));
      case "spectral":
        return tidy(() => executeOp$3(node2, tensorMap2, context3));
      case "string":
        return tidy(() => executeOp$2(node2, tensorMap2, context3));
      case "transformation":
        return tidy(() => executeOp$1(node2, tensorMap2, context3));
      case "hash_table":
        return executeOp$b(node2, tensorMap2, context3, resourceManager);
      case "custom":
        const opMapper = getRegisteredOp(node2.op);
        if (opMapper && opMapper.customExecutor) {
          return opMapper.customExecutor(new NodeValueImpl(node2, tensorMap2, context3));
        } else {
          throw TypeError(`Custom op ${node2.op} is not registered.`);
        }
      default:
        throw TypeError(`Unknown op '${node2.op}'. File an issue at https://github.com/tensorflow/tfjs/issues so we can add it, or register a custom execution with tf.registerOp()`);
    }
  })(node, tensorMap, context2);
  if (isPromise(value)) {
    return value.then((data2) => [].concat(data2));
  }
  return [].concat(value);
}
class ExecutionContext {
  constructor(weightMap = {}, tensorArrayMap = {}, tensorListMap = {}, functionMap = {}) {
    this.weightMap = weightMap;
    this.tensorArrayMap = tensorArrayMap;
    this.tensorListMap = tensorListMap;
    this.functionMap = functionMap;
    this.rootContext = { id: 0, frameName: "", iterationId: 0 };
    this.contexts = [this.rootContext];
    this.lastId = 0;
    this.generateCurrentContextIds();
  }
  newFrame(id2, frameName) {
    return { id: id2, frameName, iterationId: 0 };
  }
  set currentContext(contexts2) {
    if (this.contexts !== contexts2) {
      this.contexts = contexts2;
      this.generateCurrentContextIds();
    }
  }
  get currentContext() {
    return this.contexts;
  }
  get currentContextId() {
    return this._currentContextIds[0];
  }
  get currentContextIds() {
    return this._currentContextIds;
  }
  generateCurrentContextIds() {
    const names2 = [];
    for (let i2 = 0; i2 < this.contexts.length - 1; i2++) {
      const contexts2 = this.contexts.slice(0, this.contexts.length - i2);
      names2.push(this.contextIdforContexts(contexts2));
    }
    names2.push("");
    this._currentContextIds = names2;
  }
  contextIdforContexts(contexts2) {
    return contexts2 ? contexts2.map((context2) => context2.id === 0 && context2.iterationId === 0 ? "" : `${context2.frameName}-${context2.iterationId}`).join("/") : "";
  }
  enterFrame(frameId) {
    if (this.contexts) {
      this.lastId++;
      this.contexts = this.contexts.slice();
      this.contexts.push(this.newFrame(this.lastId, frameId));
      this._currentContextIds.unshift(this.contextIdforContexts(this.contexts));
    }
  }
  exitFrame() {
    if (this.contexts && this.contexts.length > 1) {
      this.contexts = this.contexts.slice();
      this.contexts.splice(-1);
      this.currentContextIds.shift();
    } else {
      throw new Error("Cannot exit frame, the context is empty");
    }
  }
  nextIteration() {
    if (this.contexts && this.contexts.length > 0) {
      this.contexts = this.contexts.slice();
      this.lastId++;
      const context2 = Object.assign({}, this.contexts[this.contexts.length - 1]);
      context2.iterationId += 1;
      context2.id = this.lastId;
      this.contexts.splice(-1, 1, context2);
      this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
    } else {
      throw new Error("Cannot increase frame iteration, the context is empty");
    }
  }
  getWeight(name) {
    return this.weightMap[name];
  }
  addTensorArray(tensorArray) {
    this.tensorArrayMap[tensorArray.id] = tensorArray;
  }
  getTensorArray(id2) {
    return this.tensorArrayMap[id2];
  }
  addTensorList(tensorList) {
    this.tensorListMap[tensorList.id] = tensorList;
  }
  getTensorList(id2) {
    return this.tensorListMap[id2];
  }
  dispose(keepIds) {
    for (const key in this.tensorArrayMap) {
      this.tensorArrayMap[key].clearAndClose(keepIds);
    }
    for (const key in this.tensorListMap) {
      this.tensorListMap[key].clearAndClose(keepIds);
    }
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getExecutionSubgraph(inputs, outputs, weightMap, initNodes) {
  const usedNodes = /* @__PURE__ */ new Set();
  const missingInputs = [];
  let dynamicNode = null;
  let syncInputs = null;
  const seen = /* @__PURE__ */ new Set();
  const inputNodeNames = Object.keys(inputs).map((name) => parseNodeName(name)[0]);
  let initNodeNames = [];
  if (initNodes != null) {
    initNodeNames = initNodes.map((node) => parseNodeName(node.name)[0]);
  }
  const frontier = [...outputs];
  while (frontier.length > 0) {
    const node = frontier.pop();
    if (isControlFlow(node) || isDynamicShape(node) || isHashTable(node)) {
      if (dynamicNode == null) {
        dynamicNode = node;
        syncInputs = dynamicNode.children.map((child) => child.name).filter((name) => usedNodes.has(name));
      }
    }
    usedNodes.add(node.name);
    if (weightMap[node.name] != null) {
      continue;
    }
    if (inputNodeNames.indexOf(node.name) !== -1) {
      continue;
    }
    if (initNodeNames.indexOf(node.name) !== -1) {
      continue;
    }
    if (node.inputs.length === 0) {
      missingInputs.push(node.name);
      continue;
    }
    node.inputs.forEach((input) => {
      if (seen.has(input.name)) {
        return;
      }
      seen.add(input.name);
      frontier.push(input);
    });
  }
  return { inputs, outputs, usedNodes, missingInputs, dynamicNode, syncInputs };
}
function getNodesInTopologicalOrder(graph2, weightMap, executionInfo) {
  const { usedNodes, inputs } = executionInfo;
  const frontier = [];
  const inputNodes = Object.keys(inputs).map((name) => parseNodeName(name)[0]).map((name) => graph2.nodes[name]);
  const initNodes = graph2.initNodes;
  inputNodes.forEach((input) => {
    if (usedNodes.has(input.name)) {
      frontier.push(input);
    }
  });
  graph2.weights.forEach((weight) => {
    if (usedNodes.has(weight.name)) {
      frontier.push(weight);
    }
  });
  if (initNodes != null) {
    initNodes.forEach((node) => {
      if (usedNodes.has(node.name)) {
        frontier.push(node);
      }
    });
  }
  const seen = /* @__PURE__ */ new Set();
  const orderedNodes = [];
  while (frontier.length > 0) {
    const node = frontier.pop();
    seen.add(node.name);
    if (!weightMap[node.name]) {
      orderedNodes.push(node);
    }
    node.children.forEach((child) => {
      if (!seen.has(child.name) && usedNodes.has(child.name) && child.inputs.every((input) => seen.has(input.name))) {
        frontier.push(child);
      }
    });
  }
  return orderedNodes;
}
const CONTROL_FLOW_OPS = [
  "Switch",
  "Merge",
  "Enter",
  "Exit",
  "NextIteration",
  "StatelessIf",
  "StatelessWhile",
  "if",
  "While"
];
const DYNAMIC_SHAPE_OPS = [
  "NonMaxSuppressionV2",
  "NonMaxSuppressionV3",
  "NonMaxSuppressionV5",
  "Where"
];
const HASH_TABLE_OPS = [
  "HashTable",
  "HashTableV2",
  "LookupTableImport",
  "LookupTableImportV2",
  "LookupTableFind",
  "LookupTableFindV2",
  "LookupTableSize",
  "LookupTableSizeV2"
];
function isControlFlow(node) {
  return CONTROL_FLOW_OPS.indexOf(node.op) >= 0;
}
function isDynamicShape(node) {
  return DYNAMIC_SHAPE_OPS.indexOf(node.op) >= 0;
}
function isHashTable(node) {
  return HASH_TABLE_OPS.indexOf(node.op) >= 0;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class GraphExecutor {
  constructor(graph2, parent) {
    this.graph = graph2;
    this.parent = parent;
    this.compiledMap = /* @__PURE__ */ new Map();
    this._weightMap = {};
    this.SEPERATOR = ",";
    this._functions = {};
    this._functionExecutorMap = {};
    this.intermediateTensors = {};
    this.keepTensorForDebug = false;
    this._outputs = graph2.outputs;
    this._inputs = graph2.inputs;
    this._initNodes = graph2.initNodes;
    this._signature = graph2.signature;
    this._functions = graph2.functions;
    if (graph2.functions != null) {
      Object.keys(graph2.functions).forEach((name) => {
        this._functionExecutorMap[name] = new GraphExecutor(graph2.functions[name], this);
      });
    }
  }
  get weightIds() {
    return this.parent ? this.parent.weightIds : this._weightIds;
  }
  get functionExecutorMap() {
    return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
  }
  get weightMap() {
    return this.parent ? this.parent.weightMap : this._weightMap;
  }
  set weightMap(weightMap) {
    const weightIds = Object.keys(weightMap).map((key) => weightMap[key].map((tensor2) => tensor2.id));
    this._weightIds = [].concat(...weightIds);
    this._weightMap = weightMap;
  }
  set resourceManager(resourceManager) {
    this._resourceManager = resourceManager;
  }
  get inputs() {
    return this._inputs.map((node) => {
      return {
        name: node.name,
        shape: node.attrParams["shape"] ? node.attrParams["shape"].value : void 0,
        dtype: node.attrParams["dtype"] ? node.attrParams["dtype"].value : void 0
      };
    });
  }
  get outputs() {
    return this._outputs.map((node) => {
      return {
        name: node.name,
        shape: node.attrParams["shape"] ? node.attrParams["shape"].value : void 0,
        dtype: node.attrParams["dtype"] ? node.attrParams["dtype"].value : void 0
      };
    });
  }
  get inputNodes() {
    return this._inputs.map((node) => node.signatureKey || node.name);
  }
  get outputNodes() {
    return this._outputs.map((node) => {
      const name = node.signatureKey || node.name;
      return node.defaultOutput ? `${name}:${node.defaultOutput}` : name;
    });
  }
  get functions() {
    return Object.keys(this._functions).reduce((map, key) => {
      map[key] = this._functions[key].signature;
      return map;
    }, {});
  }
  getCompilationKey(inputs, outputs) {
    const sortedInputs = inputs.map((node) => node.name).sort();
    const sortedOutputs = outputs.map((node) => node.name).sort();
    return sortedInputs.join(this.SEPERATOR) + "--" + sortedOutputs.join(this.SEPERATOR);
  }
  compile(inputs, outputs) {
    const executionInfo = getExecutionSubgraph(inputs, outputs, this.weightMap, this._initNodes);
    const { missingInputs, dynamicNode, syncInputs } = executionInfo;
    if (dynamicNode != null) {
      throw new Error(`This execution contains the node '${dynamicNode.name}', which has the dynamic op '${dynamicNode.op}'. Please use model.executeAsync() instead. Alternatively, to avoid the dynamic ops, specify the inputs [${syncInputs}]`);
    }
    if (missingInputs.length > 0) {
      const outNames = outputs.map((n2) => n2.name);
      const inNames = Object.keys(inputs);
      throw new Error(`Cannot compute the outputs [${outNames}] from the provided inputs [${inNames}]. Missing the following inputs: [${missingInputs}]`);
    }
    return getNodesInTopologicalOrder(this.graph, this.weightMap, executionInfo);
  }
  execute(inputs, outputs) {
    inputs = this.mapInputs(inputs);
    const names2 = Object.keys(inputs).sort();
    this.checkInputs(inputs);
    this.checkInputShapeAndType(inputs);
    outputs = this.mapOutputs(outputs);
    this.checkOutputs(outputs);
    const inputNodes = names2.map((name) => this.graph.nodes[parseNodeName(name)[0]]);
    const outputNodeNames = outputs.map((name) => parseNodeName(name)[0]);
    let outputNodes = outputNodeNames.map((name) => this.graph.nodes[name]);
    this.resetIntermediateTensors();
    if (outputNodes.length === 0) {
      outputNodes = this._outputs;
    }
    const compilationKey = this.getCompilationKey(inputNodes, outputNodes);
    let orderedNodes = this.compiledMap.get(compilationKey);
    if (orderedNodes == null) {
      orderedNodes = this.compile(inputs, outputNodes);
      this.compiledMap.set(compilationKey, orderedNodes);
    }
    const tensorArrayMap = {};
    const tensorListMap = {};
    return tidy(() => {
      const context2 = new ExecutionContext(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap);
      const tensorsMap = Object.assign({}, this.weightMap);
      Object.keys(inputs).forEach((name) => {
        const [nodeName, index2] = parseNodeName(name);
        const tensors = [];
        tensors[index2] = inputs[name];
        tensorsMap[nodeName] = tensors;
      });
      const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
      const intermediateTensorConsumerCount = {};
      for (let i2 = 0; i2 < orderedNodes.length; i2++) {
        const node = orderedNodes[i2];
        if (!tensorsMap[node.name]) {
          const tensors = executeOp(node, tensorsMap, context2, this._resourceManager);
          if (isPromise(tensors)) {
            throw new Error(`The execution of the op '${node.op}' returned a promise. Please use model.executeAsync() instead.`);
          }
          tensorsMap[node.name] = tensors;
          this.checkTensorForDisposal(node.name, node, tensorsMap, context2, tensorsToKeep, outputNodeNames, intermediateTensorConsumerCount);
        }
      }
      if (this.parent == null) {
        context2.dispose(tensorsToKeep);
      }
      return outputs.map((name) => getTensor(name, tensorsMap, context2));
    });
  }
  getFrozenTensorIds(tensorMap) {
    const ids = [].concat.apply([], Object.keys(tensorMap).map((key) => tensorMap[key]).map((tensors) => tensors.map((tensor2) => tensor2.id)));
    return new Set(ids);
  }
  checkTensorForDisposal(nodeName, node, tensorMap, context2, tensorsToKeep, outputNames, intermediateTensorConsumerCount) {
    if (node.category === "control" || outputNames.indexOf(nodeName) !== -1) {
      return;
    }
    tensorMap[nodeName].forEach((tensor2) => {
      if (tensor2 != null) {
        intermediateTensorConsumerCount[tensor2.id] = (intermediateTensorConsumerCount[tensor2.id] || 0) + node.children.length;
      }
    });
    node.inputs.forEach((input) => {
      if (input.category !== "control") {
        const tensors = getTensorsForCurrentContenxt(input.name, tensorMap, context2);
        if (tensors != null) {
          tensors.forEach((tensor2) => {
            if (tensor2 && !tensor2.kept && !tensorsToKeep.has(tensor2.id)) {
              const count2 = intermediateTensorConsumerCount[tensor2.id];
              if (count2 === 1) {
                if (!this.keepTensorForDebug) {
                  tensor2.dispose();
                } else {
                  const [nodeName2, index2] = getNodeNameAndIndex(node.name, context2);
                  if (this.intermediateTensors[nodeName2]) {
                    this.intermediateTensors[nodeName2][index2] = tensor2;
                  } else {
                    this.intermediateTensors[nodeName2] = [];
                    this.intermediateTensors[nodeName2][index2] = tensor2;
                  }
                }
                delete intermediateTensorConsumerCount[tensor2.id];
              } else if (count2 != null) {
                intermediateTensorConsumerCount[tensor2.id]--;
              }
            }
          });
        }
      }
    });
  }
  async executeAsync(inputs, outputs) {
    return this._executeAsync(inputs, outputs);
  }
  disposeIntermediateTensors() {
    if (!this.intermediateTensors) {
      return;
    }
    Object.keys(this.intermediateTensors).forEach((key) => this.intermediateTensors[key].forEach((tensor2) => tensor2.dispose()));
    this.disposeTensorsMap();
  }
  disposeTensorsMap() {
    if (!this.tensorsMap) {
      return;
    }
    Object.keys(this.tensorsMap).forEach((key) => {
      const tensorArray = this.tensorsMap[key];
      tensorArray.forEach((tensor2) => {
        if (tensor2 && !tensor2.kept && !tensor2.isDisposed && !this.keepIds.has(tensor2.id)) {
          tensor2.dispose();
        }
      });
    });
  }
  getIntermediateTensors() {
    return this.tensorsMap;
  }
  resetIntermediateTensors() {
    for (const key in this.intermediateTensors) {
      this.intermediateTensors[key].forEach((tensor2) => tensor2.dispose());
      delete this.intermediateTensors[key];
    }
  }
  async _executeAsync(inputs, outputs, isFunctionExecution = false, tensorArrayMap = {}, tensorListMap = {}) {
    if (!isFunctionExecution) {
      inputs = this.mapInputs(inputs);
      this.checkInputs(inputs);
      this.checkInputShapeAndType(inputs);
      outputs = this.mapOutputs(outputs);
      this.checkOutputs(outputs);
    }
    try {
      this.keepTensorForDebug = env().getBool("KEEP_INTERMEDIATE_TENSORS");
    } catch (e2) {
      console.warn(e2.message);
    }
    this.resetIntermediateTensors();
    const context2 = new ExecutionContext(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap);
    this.tensorsMap = await this.executeWithControlFlow(inputs, context2, outputs, isFunctionExecution);
    const results = outputs.map((name) => getTensor(name, this.tensorsMap, context2));
    const outputIds = results.map((t2) => t2.id);
    const inputIds = Object.keys(inputs).map((name) => inputs[name].id);
    this.keepIds = /* @__PURE__ */ new Set([...outputIds, ...inputIds, ...this.weightIds]);
    if (!this.keepTensorForDebug) {
      this.disposeTensorsMap();
    }
    if (this.parent == null) {
      context2.dispose(this.keepIds);
    }
    return results;
  }
  async executeFunctionAsync(inputs, tensorArrayMap, tensorListMap) {
    const mappedInputs = inputs.reduce((map, tensor2, index2) => {
      map[this.inputs[index2].name] = tensor2;
      return map;
    }, {});
    return this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap);
  }
  async executeWithControlFlow(inputs, context2, outputNames, isFunctionExecution) {
    const names2 = Object.keys(inputs);
    const inputNodes = names2.map((name) => this.graph.nodes[parseNodeName(name)[0]]);
    const outputNodeNames = outputNames.map((name) => parseNodeName(name)[0]);
    let outputNodes = outputNodeNames.map((name) => this.graph.nodes[name]);
    if (outputNodes.length === 0) {
      outputNodes = this._outputs;
    }
    const { usedNodes, missingInputs, dynamicNode, syncInputs } = getExecutionSubgraph(inputs, outputNodes, this.weightMap, this._initNodes);
    const stack2 = [
      ...inputNodes,
      ...this.graph.weights,
      ...this._initNodes || []
    ].map((node) => {
      return { node, contexts: context2.currentContext };
    });
    const tensorsMap = Object.assign({}, this.weightMap);
    Object.keys(inputs).forEach((name) => {
      const [nodeName, index2] = parseNodeName(name);
      const tensors = [];
      tensors[index2] = inputs[name];
      tensorsMap[nodeName] = tensors;
    });
    const intermediateTensorConsumerCount = {};
    const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
    const added = {};
    while (stack2.length > 0) {
      const promises = this.processStack(inputNodes, stack2, context2, tensorsMap, added, tensorsToKeep, outputNodeNames, intermediateTensorConsumerCount, usedNodes);
      await Promise.all(promises);
    }
    if (dynamicNode == null && !isFunctionExecution) {
      console.warn(`This model execution did not contain any nodes with control flow or dynamic output shapes. You can use model.execute() instead.`);
    }
    const missingOutputs = outputNodes.filter((node) => !isControlFlow(node) && !getTensor(node.name, tensorsMap, context2)).map((node) => node.name);
    if (missingOutputs.length > 0) {
      let alternativeMsg = "";
      if (dynamicNode != null) {
        alternativeMsg = `Alternatively, to avoid the dynamic ops, use model.execute() and specify the inputs [${syncInputs}]`;
      }
      throw new Error(`Cannot compute the outputs [${missingOutputs}] from the provided inputs [${names2}]. Consider providing the following inputs: [${missingInputs}]. ${alternativeMsg}`);
    }
    return tensorsMap;
  }
  processStack(inputNodes, stack2, context2, tensorMap, added, tensorsToKeep, outputNames, intermediateTensorConsumerCount, usedNodes) {
    const promises = [];
    while (stack2.length > 0) {
      const item = stack2.pop();
      context2.currentContext = item.contexts;
      let nodeName = "";
      if (item.node.op === "Enter" && getParamValue("isConstant", item.node, tensorMap, context2)) {
        [nodeName] = getNodeNameAndIndex(item.node.name, context2);
      }
      if (tensorMap[item.node.name] == null) {
        const tensors = executeOp(item.node, tensorMap, context2, this._resourceManager);
        if (!nodeName) {
          [nodeName] = getNodeNameAndIndex(item.node.name, context2);
        }
        const currentContext = context2.currentContext;
        if (isPromise(tensors)) {
          promises.push(tensors.then((t2) => {
            tensorMap[nodeName] = t2;
            context2.currentContext = currentContext;
            this.checkTensorForDisposal(nodeName, item.node, tensorMap, context2, tensorsToKeep, outputNames, intermediateTensorConsumerCount);
            this.processChildNodes(item.node, stack2, context2, tensorMap, added, usedNodes);
            return t2;
          }));
        } else {
          tensorMap[nodeName] = tensors;
          this.checkTensorForDisposal(nodeName, item.node, tensorMap, context2, tensorsToKeep, outputNames, intermediateTensorConsumerCount);
          this.processChildNodes(item.node, stack2, context2, tensorMap, added, usedNodes);
        }
      } else {
        this.processChildNodes(item.node, stack2, context2, tensorMap, added, usedNodes);
      }
    }
    return promises;
  }
  processChildNodes(node, stack2, context2, tensorMap, added, usedNodes) {
    node.children.forEach((childNode) => {
      const [nodeName] = getNodeNameAndIndex(childNode.name, context2);
      if (added[nodeName] || !usedNodes.has(childNode.name)) {
        return;
      }
      if (childNode.op === "Merge") {
        if (childNode.inputNames.some((name) => {
          return !!getTensor(name, tensorMap, context2);
        })) {
          added[nodeName] = true;
          stack2.push({ contexts: context2.currentContext, node: childNode });
        }
      } else if (childNode.inputNames.every((name) => {
        return !!getTensor(name, tensorMap, context2);
      })) {
        added[nodeName] = true;
        stack2.push({ contexts: context2.currentContext, node: childNode });
      }
    });
  }
  dispose() {
    Object.keys(this.weightMap).forEach((key) => this.weightMap[key].forEach((tensor2) => tensor2.dispose()));
  }
  checkInputShapeAndType(inputs) {
    Object.keys(inputs).forEach((name) => {
      const input = inputs[name];
      const [nodeName] = parseNodeName(name);
      const node = this.graph.nodes[nodeName];
      if (node.attrParams["shape"] && node.attrParams["shape"].value) {
        const shape = node.attrParams["shape"].value;
        const match = shape.length === input.shape.length && input.shape.every((dim, index2) => shape[index2] === -1 || shape[index2] === dim);
        assert$1(match, () => `The shape of dict['${node.name}'] provided in model.execute(dict) must be [${shape}], but was [${input.shape}]`);
      }
      if (node.attrParams["dtype"] && node.attrParams["dtype"].value) {
        assert$1(input.dtype === node.attrParams["dtype"].value, () => `The dtype of dict['${node.name}'] provided in model.execute(dict) must be ${node.attrParams["dtype"].value}, but was ${input.dtype}`);
      }
    });
  }
  mapInputs(inputs) {
    const result2 = {};
    for (const inputName in inputs) {
      if (this._signature != null && this._signature.inputs != null && this._signature.inputs[inputName] != null) {
        const tensor2 = this._signature.inputs[inputName];
        result2[tensor2.name] = inputs[inputName];
      } else {
        result2[inputName] = inputs[inputName];
      }
    }
    return result2;
  }
  checkInputs(inputs) {
    const notInGraph = Object.keys(inputs).filter((name) => {
      const [nodeName] = parseNodeName(name);
      return this.graph.nodes[nodeName] == null;
    });
    if (notInGraph.length > 0) {
      throw new Error(`The dict provided in model.execute(dict) has keys: [${notInGraph}] that are not part of graph`);
    }
  }
  mapOutputs(outputs) {
    return outputs.map((name) => {
      if (this._signature != null && this._signature.outputs != null && this._signature.outputs[name] != null) {
        const tensor2 = this._signature.outputs[name];
        return tensor2.name;
      }
      return name;
    }, {});
  }
  checkOutputs(outputs) {
    outputs.forEach((name) => {
      const [normalizedName] = parseNodeName(name);
      if (!this.graph.nodes[normalizedName]) {
        throw new Error(`The output '${name}' is not found in the graph`);
      }
    });
  }
}
class ResourceManager {
  constructor(hashTableNameToHandle = {}, hashTableMap = {}) {
    this.hashTableNameToHandle = hashTableNameToHandle;
    this.hashTableMap = hashTableMap;
  }
  addHashTable(name, hashTable2) {
    this.hashTableNameToHandle[name] = hashTable2.handle;
    this.hashTableMap[hashTable2.id] = hashTable2;
  }
  getHashTableHandleByName(name) {
    return this.hashTableNameToHandle[name];
  }
  getHashTableById(id2) {
    return this.hashTableMap[id2];
  }
  dispose() {
    for (const key in this.hashTableMap) {
      this.hashTableMap[key].clearAndClose();
      delete this.hashTableMap[key];
    }
    for (const name in this.hashTableNameToHandle) {
      this.hashTableNameToHandle[name].dispose();
      delete this.hashTableNameToHandle[name];
    }
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const TFHUB_SEARCH_PARAM = "?tfjs-format=file";
const DEFAULT_MODEL_NAME = "model.json";
class GraphModel {
  constructor(modelUrl, loadOptions = {}) {
    this.modelUrl = modelUrl;
    this.loadOptions = loadOptions;
    this.version = "n/a";
    if (loadOptions == null) {
      this.loadOptions = {};
    }
    this.resourceManager = new ResourceManager();
  }
  get modelVersion() {
    return this.version;
  }
  get inputNodes() {
    return this.executor.inputNodes;
  }
  get outputNodes() {
    return this.executor.outputNodes;
  }
  get inputs() {
    return this.executor.inputs;
  }
  get outputs() {
    return this.executor.outputs;
  }
  get weights() {
    return this.executor.weightMap;
  }
  get metadata() {
    return this.artifacts.userDefinedMetadata;
  }
  get modelSignature() {
    return this.signature;
  }
  findIOHandler() {
    const path2 = this.modelUrl;
    if (path2.load != null) {
      this.handler = path2;
    } else if (this.loadOptions.requestInit != null) {
      this.handler = browserHTTPRequest(path2, this.loadOptions);
    } else {
      const handlers = getLoadHandlers(path2, this.loadOptions);
      if (handlers.length === 0) {
        handlers.push(browserHTTPRequest(path2, this.loadOptions));
      } else if (handlers.length > 1) {
        throw new Error(`Found more than one (${handlers.length}) load handlers for URL '${[path2]}'`);
      }
      this.handler = handlers[0];
    }
  }
  async load() {
    this.findIOHandler();
    if (this.handler.load == null) {
      throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
    }
    const artifacts = await this.handler.load();
    return this.loadSync(artifacts);
  }
  loadSync(artifacts) {
    this.artifacts = artifacts;
    const graph2 = this.artifacts.modelTopology;
    let signature;
    if (this.artifacts.userDefinedMetadata != null && this.artifacts.userDefinedMetadata.signature != null) {
      signature = this.artifacts.userDefinedMetadata.signature;
    } else {
      signature = this.artifacts.signature;
    }
    this.signature = signature;
    this.version = `${graph2.versions.producer}.${graph2.versions.minConsumer}`;
    const weightMap = decodeWeights(this.artifacts.weightData, this.artifacts.weightSpecs);
    this.executor = new GraphExecutor(OperationMapper.Instance.transformGraph(graph2, this.signature));
    this.executor.weightMap = this.convertTensorMapToTensorsMap(weightMap);
    this.executor.resourceManager = this.resourceManager;
    if (artifacts.modelInitializer != null && artifacts.modelInitializer.node != null) {
      const initializer = OperationMapper.Instance.transformGraph(artifacts.modelInitializer);
      this.initializer = new GraphExecutor(initializer);
      this.initializer.weightMap = this.executor.weightMap;
      this.initializer.resourceManager = this.resourceManager;
      this.initializer.executeAsync({}, []);
    }
    return true;
  }
  async save(handlerOrURL, config2) {
    if (typeof handlerOrURL === "string") {
      const handlers = getSaveHandlers(handlerOrURL);
      if (handlers.length === 0) {
        throw new Error(`Cannot find any save handlers for URL '${handlerOrURL}'`);
      } else if (handlers.length > 1) {
        throw new Error(`Found more than one (${handlers.length}) save handlers for URL '${handlerOrURL}'`);
      }
      handlerOrURL = handlers[0];
    }
    if (handlerOrURL.save == null) {
      throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
    }
    return handlerOrURL.save(this.artifacts);
  }
  predict(inputs, config2) {
    return this.execute(inputs, this.outputNodes);
  }
  normalizeInputs(inputs) {
    if (!(inputs instanceof Tensor) && !Array.isArray(inputs)) {
      return inputs;
    }
    inputs = Array.isArray(inputs) ? inputs : [inputs];
    if (inputs.length !== this.inputNodes.length) {
      throw new Error(`Input tensor count mismatch,the graph model has ${this.inputNodes.length} placeholders, while there are ${inputs.length} input tensors.`);
    }
    return this.inputNodes.reduce((map, inputName, i2) => {
      map[inputName] = inputs[i2];
      return map;
    }, {});
  }
  normalizeOutputs(outputs) {
    outputs = outputs || this.outputNodes;
    return !Array.isArray(outputs) ? [outputs] : outputs;
  }
  execute(inputs, outputs) {
    inputs = this.normalizeInputs(inputs);
    outputs = this.normalizeOutputs(outputs);
    const result2 = this.executor.execute(inputs, outputs);
    return result2.length > 1 ? result2 : result2[0];
  }
  async executeAsync(inputs, outputs) {
    inputs = this.normalizeInputs(inputs);
    outputs = this.normalizeOutputs(outputs);
    const result2 = await this.executor.executeAsync(inputs, outputs);
    return result2.length > 1 ? result2 : result2[0];
  }
  getIntermediateTensors() {
    return this.executor.getIntermediateTensors();
  }
  disposeIntermediateTensors() {
    this.executor.disposeIntermediateTensors();
  }
  convertTensorMapToTensorsMap(map) {
    return Object.keys(map).reduce((newMap, key) => {
      newMap[key] = [map[key]];
      return newMap;
    }, {});
  }
  dispose() {
    this.executor.dispose();
    if (this.initializer) {
      this.initializer.dispose();
    }
    this.resourceManager.dispose();
  }
}
async function loadGraphModel(modelUrl, options = {}) {
  if (modelUrl == null) {
    throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
  }
  if (options == null) {
    options = {};
  }
  if (options.fromTFHub) {
    if (modelUrl.load == null) {
      if (!modelUrl.endsWith("/")) {
        modelUrl = modelUrl + "/";
      }
      modelUrl = `${modelUrl}${DEFAULT_MODEL_NAME}${TFHUB_SEARCH_PARAM}`;
    }
  }
  const model2 = new GraphModel(modelUrl, options);
  await model2.load();
  return model2;
}
/** @license See the LICENSE file. */
const version$4 = "3.16.0";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
var ZipMismatchMode;
(function(ZipMismatchMode2) {
  ZipMismatchMode2[ZipMismatchMode2["FAIL"] = 0] = "FAIL";
  ZipMismatchMode2[ZipMismatchMode2["SHORTEST"] = 1] = "SHORTEST";
  ZipMismatchMode2[ZipMismatchMode2["LONGEST"] = 2] = "LONGEST";
})(ZipMismatchMode || (ZipMismatchMode = {}));
/** @license See the LICENSE file. */
const version$3 = "3.16.0";
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function assertNotComplex$1(tensor2, opName) {
  if (!Array.isArray(tensor2)) {
    tensor2 = [tensor2];
  }
  tensor2.forEach((t2) => {
    if (t2 != null) {
      assert$1(t2.dtype !== "complex64", () => `${opName} does not support complex64 tensors in the CPU backend.`);
    }
  });
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const whereImpl$1 = whereImpl$2;
class MathBackendCPU extends KernelBackend {
  constructor() {
    super();
    this.blockSize = 48;
    this.firstUse = true;
    this.data = new DataStorage(this, engine());
  }
  nextDataId() {
    return MathBackendCPU.nextDataId++;
  }
  write(values, shape, dtype) {
    if (this.firstUse) {
      this.firstUse = false;
      if (env().get("IS_NODE")) {
        warn("\n============================\nHi there \u{1F44B}. Looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, which binds to TensorFlow C++, by running npm i @tensorflow/tfjs-node, or npm i @tensorflow/tfjs-node-gpu if you have CUDA. Then call require('@tensorflow/tfjs-node'); (-gpu suffix for CUDA) at the start of your program. Visit https://github.com/tensorflow/tfjs-node for more details.\n============================");
      }
    }
    const dataId = { id: this.nextDataId() };
    this.data.set(dataId, { values, dtype, refCount: 1 });
    return dataId;
  }
  makeTensorInfo(shape, dtype, values) {
    let outId;
    if (dtype === "string" && values != null && values.length > 0 && isString$4(values[0])) {
      const encodedValues = values.map((d2) => encodeString(d2));
      outId = this.write(encodedValues, shape, dtype);
    } else {
      outId = this.write(values, shape, dtype);
    }
    return { dataId: outId, shape, dtype };
  }
  refCount(dataId) {
    if (this.data.has(dataId)) {
      const tensorData = this.data.get(dataId);
      return tensorData.refCount;
    }
    return 0;
  }
  incRef(dataId) {
    const tensorData = this.data.get(dataId);
    tensorData.refCount++;
  }
  decRef(dataId) {
    if (this.data.has(dataId)) {
      const tensorData = this.data.get(dataId);
      tensorData.refCount--;
    }
  }
  move(dataId, values, shape, dtype, refCount) {
    this.data.set(dataId, { values, dtype, refCount });
  }
  numDataIds() {
    return this.data.numDataIds();
  }
  async read(dataId) {
    return this.readSync(dataId);
  }
  readSync(dataId) {
    const { dtype, complexTensorInfos } = this.data.get(dataId);
    if (dtype === "complex64") {
      const realValues = this.readSync(complexTensorInfos.real.dataId);
      const imagValues = this.readSync(complexTensorInfos.imag.dataId);
      return mergeRealAndImagArrays(realValues, imagValues);
    }
    return this.data.get(dataId).values;
  }
  bufferSync(t2) {
    const data2 = this.readSync(t2.dataId);
    let decodedData = data2;
    if (t2.dtype === "string") {
      try {
        decodedData = data2.map((d2) => decodeString(d2));
      } catch (_a) {
        throw new Error("Failed to decode encoded string bytes into utf-8");
      }
    }
    return buffer(t2.shape, t2.dtype, decodedData);
  }
  makeOutput(values, shape, dtype) {
    const dataId = this.write(values, shape, dtype);
    return engine().makeTensorFromDataId(dataId, shape, dtype, this);
  }
  disposeData(dataId, force = false) {
    if (this.data.has(dataId)) {
      this.data.get(dataId).refCount--;
      if (!force && this.data.get(dataId).refCount > 0) {
        return false;
      }
      const { complexTensorInfos } = this.data.get(dataId);
      if (complexTensorInfos != null) {
        this.disposeData(complexTensorInfos.real.dataId, true);
        this.disposeData(complexTensorInfos.imag.dataId, true);
      }
      this.data.delete(dataId);
    }
    return true;
  }
  disposeIntermediateTensorInfo(tensorInfo) {
    this.disposeData(tensorInfo.dataId);
  }
  async time(f2) {
    const start = now();
    f2();
    const kernelMs = now() - start;
    return { kernelMs };
  }
  memory() {
    return {
      unreliable: true,
      reasons: ["The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."]
    };
  }
  where(condition) {
    assertNotComplex$1([condition], "where");
    const condVals = this.readSync(condition.dataId);
    return whereImpl$1(condition.shape, condVals);
  }
  dispose() {
  }
  floatPrecision() {
    return 32;
  }
  epsilon() {
    return super.epsilon();
  }
}
MathBackendCPU.nextDataId = 0;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function simpleAbsImpl(vals) {
  const resultValues = new Float32Array(vals.length);
  for (let i2 = 0; i2 < vals.length; ++i2) {
    resultValues[i2] = Math.abs(vals[i2]);
  }
  return resultValues;
}
const abs$1 = (args) => {
  const { x: x2 } = args.inputs;
  const cpuBackend = args.backend;
  assertNotComplex$1(x2, "abs");
  let resultValues = new Float32Array(sizeFromShape(x2.shape));
  const values = cpuBackend.data.get(x2.dataId).values;
  resultValues = simpleAbsImpl(values);
  return cpuBackend.makeOutput(resultValues, x2.shape, x2.dtype);
};
const absConfig$2 = {
  kernelName: Abs,
  backendName: "cpu",
  kernelFunc: abs$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function createSimpleBinaryKernelImpl(op2) {
  return (aShape, bShape, aVals, bVals, dtype) => {
    const newShape = assertAndGetBroadcastShape(aShape, bShape);
    const resultRank = newShape.length;
    const resultStrides = computeStrides(newShape);
    const resultSize = sizeFromShape(newShape);
    const result2 = getTypedArrayFromDType(dtype, resultSize);
    const aRank = aShape.length;
    const bRank = bShape.length;
    const aStrides = computeStrides(aShape);
    const bStrides = computeStrides(bShape);
    const aBroadcastDims = getBroadcastDims$1(aShape, newShape);
    const bBroadcastDims = getBroadcastDims$1(bShape, newShape);
    if (aBroadcastDims.length + bBroadcastDims.length === 0) {
      for (let i2 = 0; i2 < result2.length; ++i2) {
        result2[i2] = op2(aVals[i2 % aVals.length], bVals[i2 % bVals.length]);
      }
    } else {
      for (let i2 = 0; i2 < result2.length; ++i2) {
        const loc = indexToLoc(i2, resultRank, resultStrides);
        const aLoc = loc.slice(-aRank);
        aBroadcastDims.forEach((d2) => aLoc[d2] = 0);
        const aIndex = locToIndex(aLoc, aRank, aStrides);
        const bLoc = loc.slice(-bRank);
        bBroadcastDims.forEach((d2) => bLoc[d2] = 0);
        const bIndex = locToIndex(bLoc, bRank, bStrides);
        result2[i2] = op2(aVals[aIndex], bVals[bIndex]);
      }
    }
    return [result2, newShape];
  };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function complex$2(args) {
  const { inputs, backend: backend2 } = args;
  const { real: real2, imag: imag2 } = inputs;
  const realVals = backend2.data.get(real2.dataId).values;
  const imagVals = backend2.data.get(imag2.dataId).values;
  const complexInfo = backend2.makeTensorInfo(real2.shape, "complex64");
  const complex2 = backend2.data.get(complexInfo.dataId);
  complex2.complexTensorInfos = {
    real: backend2.makeTensorInfo(real2.shape, "float32", realVals),
    imag: backend2.makeTensorInfo(imag2.shape, "float32", imagVals)
  };
  return complexInfo;
}
const complexConfig$1 = {
  kernelName: Complex,
  backendName: "cpu",
  kernelFunc: complex$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function zeros(backend2, shape, dtype = "float32") {
  if (dtype === "complex64") {
    const real2 = zeros(backend2, shape, "float32");
    const imag2 = zeros(backend2, shape, "float32");
    return complex$2({ inputs: { real: real2, imag: imag2 }, backend: backend2 });
  }
  const values = makeZerosTypedArray(sizeFromShape(shape), dtype);
  return backend2.makeTensorInfo(shape, dtype, values);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function identity$2(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  backend2.incRef(x2.dataId);
  return { dataId: x2.dataId, shape: x2.shape, dtype: x2.dtype };
}
const identityConfig$2 = {
  kernelName: Identity$1,
  backendName: "cpu",
  kernelFunc: identity$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function real$1(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  const real2 = backend2.data.get(input.dataId).complexTensorInfos.real;
  const realVal = backend2.data.get(real2.dataId).values;
  return backend2.makeTensorInfo(real2.shape, real2.dtype, realVal);
}
const realConfig$1 = {
  kernelName: Real,
  backendName: "cpu",
  kernelFunc: real$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cast$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { dtype } = attrs;
  if (dtype === "complex64") {
    if (x2.dtype === "complex64") {
      return identity$2({ inputs: { x: x2 }, backend: backend2 });
    }
    const zerosTensorInfo = zeros(backend2, x2.shape, x2.dtype);
    const floatX = cast$2({ inputs: { x: x2 }, backend: backend2, attrs: { dtype: "float32" } });
    const result2 = complex$2({ inputs: { real: floatX, imag: zerosTensorInfo }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(zerosTensorInfo);
    backend2.disposeIntermediateTensorInfo(floatX);
    return result2;
  }
  if (x2.dtype === "complex64") {
    const realPart = real$1({ inputs: { input: x2 }, backend: backend2 });
    const result2 = cast$2({ inputs: { x: realPart }, backend: backend2, attrs: { dtype } });
    backend2.disposeIntermediateTensorInfo(realPart);
    return result2;
  }
  if (!hasEncodingLoss(x2.dtype, dtype)) {
    const result2 = identity$2({ inputs: { x: x2 }, backend: backend2 });
    return { dataId: result2.dataId, shape: result2.shape, dtype };
  }
  if (dtype === "int32") {
    const values = backend2.data.get(x2.dataId).values;
    const resultValues = Int32Array.from(values);
    return backend2.makeTensorInfo(x2.shape, "int32", resultValues);
  }
  if (dtype === "bool") {
    const xVals = backend2.data.get(x2.dataId).values;
    const zero2 = toTypedArray([0], x2.dtype);
    const [resultData, resultShape] = createSimpleBinaryKernelImpl((a6, b2) => a6 !== b2 ? 1 : 0)(x2.shape, [], xVals, zero2, "bool");
    return backend2.makeTensorInfo(resultShape, "bool", resultData);
  }
  throw new Error(`Error in Cast: failed to cast ${x2.dtype} to ${dtype}`);
}
const castConfig$2 = {
  kernelName: Cast,
  backendName: "cpu",
  kernelFunc: cast$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function binaryKernelFunc$1(name, simpleImpl, complexImpl, dtype) {
  if (complexImpl == null) {
    return ({ inputs, backend: backend2 }) => {
      const { a: a6, b: b2 } = inputs;
      const cpuBackend = backend2;
      assertNotComplex$1([a6, b2], name);
      const aVals = cpuBackend.data.get(a6.dataId).values;
      const bVals = cpuBackend.data.get(b2.dataId).values;
      const decodedAVals = a6.dtype === "string" ? fromUint8ToStringArray(aVals) : aVals;
      const decodedBVals = a6.dtype === "string" ? fromUint8ToStringArray(bVals) : bVals;
      const $dtype = dtype || a6.dtype;
      const [resultData, resultShape] = simpleImpl(a6.shape, b2.shape, decodedAVals, decodedBVals, $dtype);
      return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
    };
  }
  return ({ inputs, backend: backend2 }) => {
    const { a: a6, b: b2 } = inputs;
    const cpuBackend = backend2;
    if (a6.dtype === "complex64" || b2.dtype === "complex64") {
      const $aComplex = cast$2({ inputs: { x: a6 }, backend: cpuBackend, attrs: { dtype: "complex64" } });
      const $aComplexVals = cpuBackend.data.get($aComplex.dataId);
      const aReal = $aComplexVals.complexTensorInfos.real;
      const aImag = $aComplexVals.complexTensorInfos.imag;
      const aRealVals = cpuBackend.data.get(aReal.dataId).values;
      const aImagVals = cpuBackend.data.get(aImag.dataId).values;
      const $bComplex = cast$2({ inputs: { x: b2 }, backend: cpuBackend, attrs: { dtype: "complex64" } });
      const $bComplexVals = cpuBackend.data.get($bComplex.dataId);
      const bReal = $bComplexVals.complexTensorInfos.real;
      const bImag = $bComplexVals.complexTensorInfos.imag;
      const bRealVals = cpuBackend.data.get(bReal.dataId).values;
      const bImagVals = cpuBackend.data.get(bImag.dataId).values;
      const [resultRealData, resultImagData, resultShape] = complexImpl(a6.shape, b2.shape, aRealVals, aImagVals, bRealVals, bImagVals);
      const resultReal = cpuBackend.makeTensorInfo(resultShape, "float32", resultRealData);
      const resultImag = cpuBackend.makeTensorInfo(resultShape, "float32", resultImagData);
      const result2 = complex$2({ inputs: { real: resultReal, imag: resultImag }, backend: cpuBackend });
      cpuBackend.disposeIntermediateTensorInfo($aComplex);
      cpuBackend.disposeIntermediateTensorInfo($bComplex);
      cpuBackend.disposeIntermediateTensorInfo(resultReal);
      cpuBackend.disposeIntermediateTensorInfo(resultImag);
      return result2;
    } else {
      const aVals = cpuBackend.data.get(a6.dataId).values;
      const bVals = cpuBackend.data.get(b2.dataId).values;
      const $dtype = dtype || a6.dtype;
      const [resultData, resultShape] = simpleImpl(a6.shape, b2.shape, aVals, bVals, $dtype);
      return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
    }
  };
}
function createComplexBinaryKernelImpl(op2) {
  return (aShape, bShape, aRealVals, aImagVals, bRealVals, bImagVals) => {
    const resultShape = assertAndGetBroadcastShape(aShape, bShape);
    const resultSize = sizeFromShape(resultShape);
    const resultRank = resultShape.length;
    const resultStrides = computeStrides(resultShape);
    const resultRealVals = getTypedArrayFromDType("float32", resultSize);
    const resultImagVals = getTypedArrayFromDType("float32", resultSize);
    const aBroadcastDims = getBroadcastDims$1(aShape, resultShape);
    const bBroadcastDims = getBroadcastDims$1(bShape, resultShape);
    const aVals = mergeRealAndImagArrays(aRealVals, aImagVals);
    const bVals = mergeRealAndImagArrays(bRealVals, bImagVals);
    const aRank = aShape.length;
    const aStrides = computeStrides(aShape);
    const bRank = bShape.length;
    const bStrides = computeStrides(bShape);
    if (aBroadcastDims.length + bBroadcastDims.length === 0) {
      for (let i2 = 0; i2 < resultRealVals.length; i2++) {
        const aIdx = i2 % aVals.length;
        const bIdx = i2 % bVals.length;
        const result2 = op2(aVals[aIdx * 2], aVals[aIdx * 2 + 1], bVals[bIdx * 2], bVals[bIdx * 2 + 1]);
        resultRealVals[i2] = result2.real;
        resultImagVals[i2] = result2.imag;
      }
    } else {
      for (let i2 = 0; i2 < resultRealVals.length; i2++) {
        const loc = indexToLoc(i2, resultRank, resultStrides);
        const aLoc = loc.slice(-aRank);
        aBroadcastDims.forEach((d2) => aLoc[d2] = 0);
        const aIndex = locToIndex(aLoc, aRank, aStrides);
        const bLoc = loc.slice(-bRank);
        bBroadcastDims.forEach((d2) => bLoc[d2] = 0);
        const bIndex = locToIndex(bLoc, bRank, bStrides);
        const opResult = op2(aVals[aIndex * 2], aVals[aIndex * 2 + 1], bVals[bIndex * 2], bVals[bIndex * 2 + 1]);
        resultRealVals[i2] = opResult.real;
        resultImagVals[i2] = opResult.imag;
      }
    }
    return [resultRealVals, resultImagVals, resultShape];
  };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const addImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 + b2);
const addComplexImpl = createComplexBinaryKernelImpl((aReal, aImag, bReal, bImag) => {
  return { real: aReal + bReal, imag: aImag + bImag };
});
const add = binaryKernelFunc$1(Add$1, addImpl, addComplexImpl);
const addConfig$2 = {
  kernelName: Add$1,
  backendName: "cpu",
  kernelFunc: add
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function bincountImpl(xVals, weightsVals, weightsDtype, weightsShape, size) {
  const weightsSize = sizeFromShape(weightsShape);
  const outVals = makeZerosTypedArray(size, weightsDtype);
  for (let i2 = 0; i2 < xVals.length; i2++) {
    const value = xVals[i2];
    if (value < 0) {
      throw new Error("Input x must be non-negative!");
    }
    if (value >= size) {
      continue;
    }
    if (weightsSize > 0) {
      outVals[value] += weightsVals[i2];
    } else {
      outVals[value] += 1;
    }
  }
  return outVals;
}
function bincountReduceImpl(xBuf, weightsBuf, size, binaryOutput = false) {
  const numRows = xBuf.shape[0];
  const numCols = xBuf.shape[1];
  const outBuf = buffer([numRows, size], weightsBuf.dtype);
  for (let i2 = 0; i2 < numRows; i2++) {
    for (let j2 = 0; j2 < numCols; j2++) {
      const value = xBuf.get(i2, j2);
      if (value < 0) {
        throw new Error("Input x must be non-negative!");
      }
      if (value >= size) {
        continue;
      }
      if (binaryOutput) {
        outBuf.set(1, i2, value);
      } else {
        if (weightsBuf.size > 0) {
          outBuf.set(outBuf.get(i2, value) + weightsBuf.get(i2, j2), i2, value);
        } else {
          outBuf.set(outBuf.get(i2, value) + 1, i2, value);
        }
      }
    }
  }
  return outBuf;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function createSimpleUnaryImpl(op2) {
  return (values, dtype, attrs) => {
    const newValues = getTypedArrayFromDType(dtype, values.length);
    for (let i2 = 0; i2 < values.length; ++i2) {
      newValues[i2] = op2(values[i2], attrs);
    }
    return newValues;
  };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unaryKernelFunc$1(name, op2, dtype) {
  return ({ inputs, attrs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    assertNotComplex$1(x2, name);
    if (x2.dtype === "string" || dtype === "string") {
      throw new Error("unaryKernelFunc does not support string input/output");
    }
    const cpuBackend = backend2;
    const values = cpuBackend.data.get(x2.dataId).values;
    const xSize = sizeFromShape(x2.shape);
    const $dtype = dtype || x2.dtype;
    const newValues = getArrayFromDType($dtype, xSize);
    for (let i2 = 0; i2 < xSize; ++i2) {
      newValues[i2] = op2(values[i2], attrs);
    }
    return cpuBackend.makeTensorInfo(x2.shape, $dtype, newValues);
  };
}
function unaryKernelFuncFromImpl(name, unaryImpl, dtype) {
  return ({ inputs, attrs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    assertNotComplex$1(x2, name);
    if (x2.dtype === "string" || dtype === "string") {
      throw new Error("unaryKernelFunc does not support string input/output");
    }
    const cpuBackend = backend2;
    const values = cpuBackend.data.get(x2.dataId).values;
    const $dtype = dtype || x2.dtype;
    const newValues = unaryImpl(values, $dtype, attrs);
    return cpuBackend.makeTensorInfo(x2.shape, $dtype, newValues);
  };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ceilImpl = createSimpleUnaryImpl((xi) => Math.ceil(xi));
const ceil$1 = unaryKernelFuncFromImpl(Ceil, ceilImpl);
const ceilConfig$2 = {
  kernelName: Ceil,
  backendName: "cpu",
  kernelFunc: ceil$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function concatImpl$1(inputs, outShape, dtype, simplyConcat) {
  const outVals = getArrayFromDType(dtype, sizeFromShape(outShape));
  if (simplyConcat && dtype !== "string") {
    let offset = 0;
    inputs.forEach((input) => {
      const size = sizeFromShape(input.shape);
      outVals.set(input.vals, offset);
      offset += size;
    });
  } else {
    let colOffset = 0;
    inputs.forEach((input) => {
      const decodedData = dtype === "string" ? fromUint8ToStringArray(input.vals) : input.vals;
      let tIdx = 0;
      for (let row = 0; row < input.shape[0]; ++row) {
        const resIdx = row * outShape[1] + colOffset;
        for (let col = 0; col < input.shape[1]; ++col) {
          outVals[resIdx + col] = decodedData[tIdx++];
        }
      }
      colOffset += input.shape[1];
    });
  }
  return outVals;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const equalImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 === b2 ? 1 : 0);
const equal$1 = binaryKernelFunc$1(Equal, equalImpl, null, "bool");
const equalConfig$2 = {
  kernelName: Equal,
  backendName: "cpu",
  kernelFunc: equal$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const expImpl = createSimpleUnaryImpl((xi) => Math.exp(xi));
const exp$1 = unaryKernelFuncFromImpl(Exp, expImpl, "float32");
const expConfig$2 = {
  kernelName: Exp,
  backendName: "cpu",
  kernelFunc: exp$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const expm1Impl = createSimpleUnaryImpl((xi) => Math.expm1(xi));
const expm1$1 = unaryKernelFuncFromImpl(Expm1, expm1Impl);
const expm1Config$1 = {
  kernelName: Expm1,
  backendName: "cpu",
  kernelFunc: expm1$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const floorImpl = createSimpleUnaryImpl((xi) => Math.floor(xi));
const floor$1 = unaryKernelFuncFromImpl(Floor, floorImpl);
const floorConfig$2 = {
  kernelName: Floor,
  backendName: "cpu",
  kernelFunc: floor$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherNdImpl(indicesData, paramsBuf, dtype, numSlices, sliceRank, sliceSize, strides, paramsShape, paramsSize) {
  const outBuf = buffer([numSlices, sliceSize], dtype);
  for (let i2 = 0; i2 < numSlices; i2++) {
    const index2 = [];
    let flattenIndex = 0;
    for (let j2 = 0; j2 < sliceRank; j2++) {
      const dim = indicesData[i2 * sliceRank + j2];
      flattenIndex += dim * strides[j2];
      index2.push(dim);
    }
    if (flattenIndex < 0 || flattenIndex >= paramsSize / sliceSize) {
      throw new Error(`Invalid indices: ${index2} does not index into ${paramsShape}`);
    }
    for (let k3 = 0; k3 < sliceSize; k3++) {
      outBuf.values[i2 * sliceSize + k3] = paramsBuf.get(...paramsBuf.indexToLoc(flattenIndex * sliceSize + k3));
    }
  }
  return outBuf;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherV2Impl(xBuf, indicesBuf, flattenOutputShape) {
  const outBuf = buffer(flattenOutputShape, xBuf.dtype);
  for (let i2 = 0; i2 < outBuf.size; ++i2) {
    const newLoc = outBuf.indexToLoc(i2);
    const originalLoc = newLoc.slice();
    const batchIdx = originalLoc[0];
    const indicesIdx = originalLoc[2];
    const indicesIndex = indicesBuf.locToIndex([batchIdx, indicesIdx]);
    originalLoc[2] = indicesBuf.values[indicesIndex];
    const originalIndex = xBuf.locToIndex(originalLoc);
    if (0 <= originalIndex && originalIndex < xBuf.values.length) {
      outBuf.values[i2] = xBuf.values[originalIndex];
    }
  }
  return outBuf;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const greaterImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 > b2 ? 1 : 0);
const greater$1 = binaryKernelFunc$1(Greater, greaterImpl, null, "bool");
const greaterConfig$2 = {
  kernelName: Greater,
  backendName: "cpu",
  kernelFunc: greater$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const greaterEqualImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 >= b2 ? 1 : 0);
const greaterEqual$1 = binaryKernelFunc$1(GreaterEqual, greaterEqualImpl, null, "bool");
const greaterEqualConfig$2 = {
  kernelName: GreaterEqual,
  backendName: "cpu",
  kernelFunc: greaterEqual$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const lessImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 < b2 ? 1 : 0);
const less$1 = binaryKernelFunc$1(Less, lessImpl, null, "bool");
const lessConfig$2 = {
  kernelName: Less,
  backendName: "cpu",
  kernelFunc: less$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const lessEqualImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 <= b2 ? 1 : 0);
const lessEqual$1 = binaryKernelFunc$1(LessEqual, lessEqualImpl, null, "bool");
const lessEqualConfig$2 = {
  kernelName: LessEqual,
  backendName: "cpu",
  kernelFunc: lessEqual$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function linSpaceImpl(start, stop, num) {
  const step2 = (stop - start) / (num - 1);
  const values = makeZerosTypedArray(num, "float32");
  values[0] = start;
  for (let i2 = 1; i2 < values.length; i2++) {
    values[i2] = values[i2 - 1] + step2;
  }
  return values;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logImpl = createSimpleUnaryImpl((xi) => Math.log(xi));
const log$6 = unaryKernelFuncFromImpl(Log, logImpl);
const logConfig$2 = {
  kernelName: Log,
  backendName: "cpu",
  kernelFunc: log$6
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxImpl$1(aVals, reduceSize, outShape, dtype) {
  const vals = getTypedArrayFromDType(dtype, sizeFromShape(outShape));
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let max2 = aVals[offset];
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      const value = aVals[offset + j2];
      if (Number.isNaN(value) || value > max2) {
        max2 = value;
      }
    }
    vals[i2] = max2;
  }
  return vals;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maximumImpl = createSimpleBinaryKernelImpl((aValue, bValue) => Math.max(aValue, bValue));
const maximum$1 = binaryKernelFunc$1(Maximum$1, maximumImpl);
const maximumConfig$2 = {
  kernelName: Maximum$1,
  backendName: "cpu",
  kernelFunc: maximum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const minimumImpl = createSimpleBinaryKernelImpl((aValue, bValue) => Math.min(aValue, bValue));
const minimum$1 = binaryKernelFunc$1(Minimum$1, minimumImpl);
const minimumConfig$2 = {
  kernelName: Minimum$1,
  backendName: "cpu",
  kernelFunc: minimum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const multiplyImpl = createSimpleBinaryKernelImpl((aValue, bValue) => aValue * bValue);
const multiplyComplexImpl = createComplexBinaryKernelImpl((aReal, aImag, bReal, bImag) => {
  return {
    real: aReal * bReal - aImag * bImag,
    imag: aReal * bImag + aImag * bReal
  };
});
const multiply$1 = binaryKernelFunc$1(Multiply$1, multiplyImpl, multiplyComplexImpl);
const multiplyConfig$2 = {
  kernelName: Multiply$1,
  backendName: "cpu",
  kernelFunc: multiply$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function negImpl(xVals, xShape, xDtype) {
  const minusOne = createScalarValue(-1, xDtype);
  return multiplyImpl([], xShape, minusOne, xVals, xDtype);
}
function neg$1(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  assertNotComplex$1(x2, "neg");
  const xVals = backend2.data.get(x2.dataId).values;
  const [res, newShape] = negImpl(xVals, x2.shape, x2.dtype);
  return backend2.makeTensorInfo(newShape, x2.dtype, res);
}
const negConfig$2 = {
  kernelName: Neg,
  backendName: "cpu",
  kernelFunc: neg$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const notEqualImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 !== b2 ? 1 : 0);
const notEqual$1 = binaryKernelFunc$1(NotEqual, notEqualImpl, null, "bool");
const notEqualConfig$2 = {
  kernelName: NotEqual,
  backendName: "cpu",
  kernelFunc: notEqual$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transposeImpl$1(xVals, xShape, dtype, perm, newShape) {
  const xRank = xShape.length;
  const xSize = sizeFromShape(xShape);
  const xStrides = computeStrides(xShape);
  const newStrides = computeStrides(newShape);
  const result2 = getTypedArrayFromDType(dtype, sizeFromShape(newShape));
  for (let i2 = 0; i2 < xSize; ++i2) {
    const loc = indexToLoc(i2, xRank, xStrides);
    const newLoc = new Array(loc.length);
    for (let i3 = 0; i3 < newLoc.length; i3++) {
      newLoc[i3] = loc[perm[i3]];
    }
    const newIndex = locToIndex(newLoc, xRank, newStrides);
    result2[newIndex] = xVals[i2];
  }
  return result2;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transpose$2(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  const { perm } = attrs;
  assertNotComplex$1(x2, "transpose");
  const xRank = x2.shape.length;
  const newShape = new Array(xRank);
  for (let i2 = 0; i2 < newShape.length; i2++) {
    newShape[i2] = x2.shape[perm[i2]];
  }
  const values = backend2.data.get(x2.dataId).values;
  const result2 = transposeImpl$1(values, x2.shape, x2.dtype, perm, newShape);
  const dataId = backend2.write(result2, newShape, x2.dtype);
  return { dataId, shape: newShape, dtype: x2.dtype };
}
const transposeConfig$2 = {
  kernelName: Transpose,
  backendName: "cpu",
  kernelFunc: transpose$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function prodImpl(xShape, xDtype, xVals, reductionAxes) {
  const [outShape, reduceShape] = computeOutAndReduceShapes(xShape, reductionAxes);
  const outDtype = upcastType(xDtype, "int32");
  const outVals = makeZerosTypedArray(sizeFromShape(outShape), outDtype);
  const reduceSize = sizeFromShape(reduceShape);
  for (let i2 = 0; i2 < outVals.length; ++i2) {
    const offset = i2 * reduceSize;
    let prod2 = 1;
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      prod2 *= xVals[offset + j2];
    }
    outVals[i2] = prod2;
  }
  return { outVals, outShape, outDtype };
}
function prod$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  assertNotComplex$1(x2, "prod");
  const xRank = x2.shape.length;
  const axes = parseAxisParam(axis, x2.shape);
  const permutation = getAxesPermutation(axes, xRank);
  let reductionAxes = axes;
  let permutedX = x2;
  const intermediateTensorInfos = [];
  if (permutation != null) {
    permutedX = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutation } });
    intermediateTensorInfos.push(permutedX);
    reductionAxes = getInnerMostAxes(reductionAxes.length, xRank);
  }
  const xVals = backend2.data.get(permutedX.dataId).values;
  const { outVals, outShape, outDtype } = prodImpl(permutedX.shape, permutedX.dtype, xVals, reductionAxes);
  let resultShape = outShape;
  if (keepDims) {
    resultShape = expandShapeToKeepDim(outShape, axes);
  }
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return backend2.makeTensorInfo(resultShape, outDtype, outVals);
}
const prodConfig$2 = {
  kernelName: Prod,
  backendName: "cpu",
  kernelFunc: prod$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function rangeImpl(start, stop, step2, dtype) {
  const sameStartStop = start === stop;
  const increasingRangeNegativeStep = start < stop && step2 < 0;
  const decreasingRangePositiveStep = stop < start && step2 > 1;
  if (sameStartStop || increasingRangeNegativeStep || decreasingRangePositiveStep) {
    return makeZerosTypedArray(0, dtype);
  }
  const numElements = Math.abs(Math.ceil((stop - start) / step2));
  const values = makeZerosTypedArray(numElements, dtype);
  if (stop < start && step2 === 1) {
    step2 = -1;
  }
  values[0] = start;
  for (let i2 = 1; i2 < values.length; i2++) {
    values[i2] = values[i2 - 1] + step2;
  }
  return values;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const rsqrtImpl = createSimpleUnaryImpl((xi) => 1 / Math.sqrt(xi));
const rsqrt$1 = unaryKernelFuncFromImpl(Rsqrt, rsqrtImpl);
const rsqrtConfig$2 = {
  kernelName: Rsqrt,
  backendName: "cpu",
  kernelFunc: rsqrt$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sigmoidImpl = createSimpleUnaryImpl((xi) => 1 / (1 + Math.exp(-xi)));
const sigmoid$2 = unaryKernelFunc$1(Sigmoid$1, (xi) => 1 / (1 + Math.exp(-xi)));
const sigmoidConfig$2 = {
  kernelName: Sigmoid$1,
  backendName: "cpu",
  kernelFunc: sigmoid$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sliceImpl(vals, begin, size, shape, dtype) {
  const isContinous = isSliceContinous(shape, begin, size);
  const length = sizeFromShape(size);
  const xStrides = computeStrides(shape);
  if (isContinous) {
    const flatOffset = computeFlatOffset(begin, xStrides);
    if (dtype === "string") {
      return vals.slice(flatOffset, flatOffset + length);
    }
    return vals.subarray(flatOffset, flatOffset + length);
  }
  const decodedData = dtype === "string" ? fromUint8ToStringArray(vals) : vals;
  const inBuf = buffer(shape, dtype, decodedData);
  const outBuf = buffer(size, dtype);
  for (let i2 = 0; i2 < outBuf.size; ++i2) {
    const outLoc = outBuf.indexToLoc(i2);
    const inLoc = outLoc.map((idx, j2) => idx + begin[j2]);
    outBuf.set(inBuf.get(...inLoc), ...outLoc);
  }
  if (dtype === "string") {
    return fromStringArrayToUint8(outBuf.values);
  }
  return outBuf.values;
}
function slice$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { begin, size } = attrs;
  assertNotComplex$1(x2, "slice");
  const [$begin, $size] = parseSliceParams(x2, begin, size);
  assertParamsValid(x2, $begin, $size);
  const vals = backend2.data.get(x2.dataId).values;
  const outVals = sliceImpl(vals, $begin, $size, x2.shape, x2.dtype);
  return backend2.makeTensorInfo($size, x2.dtype, outVals);
}
const sliceConfig$2 = {
  kernelName: Slice,
  backendName: "cpu",
  kernelFunc: slice$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseFillEmptyRowsImpl(indices, indicesShape, indicesDType, values, valuesDType, denseShape, defaultValue) {
  const indicesCount = indicesShape[0];
  const denseRows = denseShape[0];
  const emptyRowIndicator = new Array(denseRows);
  const reverseIndexMap = new Array(indicesCount);
  const rank = indicesShape[1];
  if (denseRows === 0) {
    if (indicesCount !== 0) {
      throw new Error(getSparseFillEmptyRowsIndicesDenseShapeMismatch(indicesCount));
    }
    const outputIndices = getArrayFromDType(indicesDType, 0);
    const outputValues = getArrayFromDType(valuesDType, 0);
    return [
      outputIndices,
      [0, rank],
      outputValues,
      emptyRowIndicator,
      reverseIndexMap
    ];
  }
  let rowsAreOrdered = true;
  let lastIndicesRow = 0;
  const csrOffset = new Array(denseRows).fill(0);
  for (let i2 = 0; i2 < indicesCount; ++i2) {
    const row = indices[i2 * rank];
    if (row < 0) {
      throw new Error(getSparseFillEmptyRowsNegativeIndexErrorMessage(i2, row));
    }
    if (row >= denseRows) {
      throw new Error(getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(i2, row, denseRows));
    }
    ++csrOffset[row];
    rowsAreOrdered = rowsAreOrdered && row >= lastIndicesRow;
    lastIndicesRow = row;
  }
  let allRowsFull = true;
  for (let row = 0; row < denseRows; ++row) {
    const rowEmpty = csrOffset[row] === 0;
    emptyRowIndicator[row] = rowEmpty;
    allRowsFull = allRowsFull && !rowEmpty;
    csrOffset[row] = Math.max(csrOffset[row], 1);
    if (row > 0) {
      csrOffset[row] += csrOffset[row - 1];
    }
  }
  if (allRowsFull && rowsAreOrdered) {
    const outputIndices = indices;
    const outputValues = values;
    for (let i2 = 0; i2 < indicesCount; ++i2) {
      reverseIndexMap[i2] = i2;
    }
    return [
      outputIndices,
      [indicesCount, rank],
      outputValues,
      emptyRowIndicator,
      reverseIndexMap
    ];
  } else {
    const fullIndicesCount = csrOffset[denseRows - 1];
    const outputIndices = getArrayFromDType(indicesDType, fullIndicesCount * rank);
    const outputValues = getArrayFromDType(valuesDType, fullIndicesCount);
    const filledCount = new Array(denseRows).fill(0);
    for (let i2 = 0; i2 < indicesCount; ++i2) {
      const row = indices[i2 * rank];
      const offset = filledCount[row];
      const outputI = (row === 0 ? 0 : csrOffset[row - 1]) + offset;
      filledCount[row]++;
      for (let j2 = 0; j2 < rank; ++j2) {
        outputIndices[outputI * rank + j2] = indices[i2 * rank + j2];
      }
      outputValues[outputI] = values[i2];
      reverseIndexMap[i2] = outputI;
    }
    for (let row = 0; row < denseRows; ++row) {
      const rowCount = filledCount[row];
      if (rowCount === 0) {
        const startingIndex = row === 0 ? 0 : csrOffset[row - 1];
        outputIndices[startingIndex * rank + 0] = row;
        for (let col = 1; col < rank; ++col) {
          outputIndices[startingIndex * rank + col] = 0;
        }
        outputValues[startingIndex] = defaultValue;
      }
    }
    return [
      outputIndices,
      [fullIndicesCount, rank],
      outputValues,
      emptyRowIndicator,
      reverseIndexMap
    ];
  }
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseReshapeImpl(inputIndices, inputIndicesShape, inputDType, inputShape, targetShape) {
  const denseSize = sizeFromShape(inputShape);
  const nnz = inputIndicesShape[0];
  const outputRank = targetShape.length;
  const outputShape = [];
  let product = 1;
  let unknownIndex = -1;
  for (let d2 = 0; d2 < outputRank; ++d2) {
    const size = targetShape[d2];
    if (size === -1) {
      if (unknownIndex !== -1) {
        throw new Error(getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(unknownIndex, d2));
      }
      unknownIndex = d2;
      outputShape.push(1);
    } else {
      if (size < 0) {
        throw new Error(getSparseReshapeNegativeOutputDimErrorMessage(d2, size));
      }
      product *= size;
      outputShape.push(size);
    }
  }
  if (unknownIndex !== -1) {
    if (product <= 0) {
      throw new Error(getSparseReshapeEmptyTensorZeroOutputDimErrorMessage());
    }
    const missing = Math.trunc(denseSize / product);
    if (product * missing !== denseSize) {
      throw new Error(getSparseReshapeInputOutputMultipleErrorMessage(inputShape, outputShape));
    }
    outputShape[unknownIndex] = missing;
  }
  const outputSize = sizeFromShape(outputShape);
  if (outputSize !== denseSize) {
    throw new Error(getSparseReshapeInputOutputMismatchErrorMessage(inputShape, outputShape));
  }
  const inputRank = inputShape.length;
  const inputStrides = [];
  if (inputRank > 0) {
    inputStrides[inputRank - 1] = 1;
    for (let d2 = inputRank - 2; d2 >= 0; --d2) {
      inputStrides[d2] = inputStrides[d2 + 1] * inputShape[d2 + 1];
    }
  }
  const outputStrides = [];
  if (outputRank > 0) {
    outputStrides[outputRank - 1] = 1;
    for (let d2 = outputRank - 2; d2 >= 0; --d2) {
      outputStrides[d2] = outputStrides[d2 + 1] * outputShape[d2 + 1];
    }
  }
  const newIndices = getArrayFromDType(inputDType, nnz * outputRank);
  for (let i2 = 0; i2 < nnz; ++i2) {
    let id2 = 0;
    for (let j2 = 0; j2 < inputRank; ++j2) {
      id2 += inputIndices[i2 * inputRank + j2] * inputStrides[j2];
    }
    for (let j2 = 0; j2 < outputRank; ++j2) {
      newIndices[i2 * outputRank + j2] = Math.trunc(id2 / outputStrides[j2]);
      id2 %= outputStrides[j2];
    }
  }
  return [newIndices, [nnz, outputRank], outputShape];
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentReductionImpl(input, inputShape, inputDType, indices, segmentIds, isMean = false, defaultValue = 0) {
  const numIndices = indices.length;
  const inputFlat = [inputShape[0], input.length / inputShape[0]];
  const numCol = inputFlat[1];
  const lastSegmentIdPlusOne = numIndices > 0 ? segmentIds[numIndices - 1] + 1 : 0;
  const outputRows = lastSegmentIdPlusOne;
  if (outputRows < 0) {
    throw new Error(getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
  }
  const outputShape = inputShape.slice();
  outputShape[0] = outputRows;
  const outputLength = outputShape.reduce((product, value) => product * value, 1);
  const output2 = getArrayFromDType(inputDType, outputLength);
  if (numIndices === 0) {
    if (outputRows > 0) {
      output2.fill(defaultValue);
    }
    return [output2, outputShape];
  }
  if (outputRows <= 0) {
    throw new Error(getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
  }
  let start = 0, end = 1;
  let uninitializedIndex = 0;
  let outIndex = segmentIds[start];
  while (true) {
    let nextIndex = 0;
    if (end < numIndices) {
      nextIndex = segmentIds[end];
      if (outIndex === nextIndex) {
        ++end;
        continue;
      }
      if (outIndex >= nextIndex) {
        throw new Error(getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage());
      }
    }
    if (outIndex < 0 || outIndex >= outputRows) {
      throw new Error(getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(outIndex, outputRows));
    }
    if (outIndex > uninitializedIndex) {
      output2.fill(defaultValue, uninitializedIndex * numCol, outIndex * numCol);
    }
    for (let i2 = start; i2 < end; ++i2) {
      const index2 = indices[i2];
      if (index2 < 0 || index2 >= inputFlat[0]) {
        throw new Error(getSparseSegmentReductionIndicesOutOfRangeErrorMessage(i2, indices[i2], inputFlat[0]));
      }
      for (let j2 = 0; j2 < numCol; j2++) {
        output2[outIndex * numCol + j2] += input[index2 * numCol + j2];
      }
    }
    if (isMean) {
      for (let j2 = 0; j2 < numCol; j2++) {
        output2[outIndex * numCol + j2] /= end - start;
      }
    }
    start = end;
    ++end;
    uninitializedIndex = outIndex + 1;
    outIndex = nextIndex;
    if (end > numIndices) {
      break;
    }
  }
  if (uninitializedIndex < outputRows) {
    output2.fill(defaultValue, uninitializedIndex * numCol, outputRows * numCol);
  }
  return [output2, outputShape];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sqrtImpl = createSimpleUnaryImpl((xi) => Math.sqrt(xi));
const sqrt$1 = unaryKernelFunc$1(Sqrt, (xi) => Math.sqrt(xi));
const sqrtConfig$2 = {
  kernelName: Sqrt,
  backendName: "cpu",
  kernelFunc: sqrt$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const squaredDifferenceImpl = createSimpleBinaryKernelImpl((a6, b2) => {
  const diff = a6 - b2;
  return diff * diff;
});
const squaredDifference$1 = binaryKernelFunc$1(SquaredDifference, squaredDifferenceImpl);
const squaredDifferenceConfig$2 = {
  kernelName: SquaredDifference,
  backendName: "cpu",
  kernelFunc: squaredDifference$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stridedSliceImpl(outShape, xBuf, strides, begin) {
  const outBuf = buffer(outShape, xBuf.dtype);
  for (let i2 = 0; i2 < outBuf.size; i2++) {
    const loc = outBuf.indexToLoc(i2);
    const newLoc = new Array(loc.length);
    for (let j2 = 0; j2 < newLoc.length; j2++) {
      newLoc[j2] = loc[j2] * strides[j2] + begin[j2];
    }
    outBuf.set(xBuf.get(...newLoc), ...loc);
  }
  return outBuf;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class StringNGramsOp {
  constructor(separator, nGramWidths, leftPad, rightPad2, padWidth, preserveShortSequences) {
    this.separator = encodeString(separator);
    this.nGramWidths = nGramWidths;
    this.leftPad = encodeString(leftPad);
    this.rightPad = encodeString(rightPad2);
    this.padWidth = padWidth;
    this.preserveShort = preserveShortSequences;
  }
  getPadWidth(nGramWidth) {
    return Math.min(this.padWidth < 0 ? nGramWidth - 1 : this.padWidth, nGramWidth - 1);
  }
  getNumNGrams(length, nGramWidth) {
    const padWidth = this.getPadWidth(nGramWidth);
    return Math.max(0, length + 2 * padWidth - nGramWidth + 1);
  }
  createNGrams(data2, splitIndex, output2, outputStartIndex, numNGrams, nGramWidth) {
    for (let nGramIndex = 0; nGramIndex < numNGrams; ++nGramIndex) {
      const padWidth = this.getPadWidth(nGramWidth);
      const leftPadding = Math.max(0, padWidth - nGramIndex);
      const rightPadding = Math.max(0, padWidth - (numNGrams - (nGramIndex + 1)));
      const numTokens = nGramWidth - (leftPadding + rightPadding);
      const dataStartIndex = splitIndex + (leftPadding > 0 ? 0 : nGramIndex - padWidth);
      let nGramSize = 0;
      nGramSize += leftPadding * this.leftPad.length;
      for (let n2 = 0; n2 < numTokens; ++n2) {
        nGramSize += data2[dataStartIndex + n2].length;
      }
      nGramSize += rightPadding * this.rightPad.length;
      const numSeparators = leftPadding + rightPadding + numTokens - 1;
      nGramSize += numSeparators * this.separator.length;
      output2[outputStartIndex + nGramIndex] = new Uint8Array(nGramSize);
      const nGram = output2[outputStartIndex + nGramIndex];
      let nextNGramIndex = 0;
      const appendToNGram = (str) => str.forEach((value) => nGram[nextNGramIndex++] = value);
      for (let n2 = 0; n2 < leftPadding; ++n2) {
        appendToNGram(this.leftPad);
        appendToNGram(this.separator);
      }
      for (let n2 = 0; n2 < numTokens - 1; ++n2) {
        appendToNGram(data2[dataStartIndex + n2]);
        appendToNGram(this.separator);
      }
      if (numTokens > 0) {
        appendToNGram(data2[dataStartIndex + numTokens - 1]);
        for (let n2 = 0; n2 < rightPadding; ++n2) {
          appendToNGram(this.separator);
          appendToNGram(this.rightPad);
        }
      } else {
        for (let n2 = 0; n2 < rightPadding - 1; ++n2) {
          appendToNGram(this.rightPad);
          appendToNGram(this.separator);
        }
        appendToNGram(this.rightPad);
      }
    }
  }
  compute(data2, splits) {
    const inputDataSize = data2.length;
    const splitsSize = splits.length;
    if (splitsSize > 0) {
      let prevSplit = splits[0];
      if (prevSplit !== 0) {
        throw new Error(`First split value must be 0, got ${prevSplit}`);
      }
      for (let i2 = 1; i2 < splitsSize; ++i2) {
        let validSplits = splits[i2] >= prevSplit;
        validSplits = validSplits && splits[i2] <= inputDataSize;
        if (!validSplits) {
          throw new Error(`Invalid split value ${splits[i2]}, must be in [${prevSplit}, ${inputDataSize}]`);
        }
        prevSplit = splits[i2];
      }
      if (prevSplit !== inputDataSize) {
        throw new Error(`Last split value must be data size. Expected ${inputDataSize}, got ${prevSplit}`);
      }
    }
    const numBatchItems = splitsSize - 1;
    const nGramsSplits = getArrayFromDType("int32", splitsSize);
    if (inputDataSize === 0 || splitsSize === 0) {
      const empty = new Array(inputDataSize);
      for (let i2 = 0; i2 <= numBatchItems; ++i2) {
        nGramsSplits[i2] = 0;
      }
      return [empty, nGramsSplits];
    }
    nGramsSplits[0] = 0;
    for (let i2 = 1; i2 <= numBatchItems; ++i2) {
      const length = splits[i2] - splits[i2 - 1];
      let numNGrams = 0;
      this.nGramWidths.forEach((nGramWidth) => {
        numNGrams += this.getNumNGrams(length, nGramWidth);
      });
      if (this.preserveShort && length > 0 && numNGrams === 0) {
        numNGrams = 1;
      }
      nGramsSplits[i2] = nGramsSplits[i2 - 1] + numNGrams;
    }
    const nGrams = new Array(nGramsSplits[numBatchItems]);
    for (let i2 = 0; i2 < numBatchItems; ++i2) {
      const splitIndex = splits[i2];
      let outputStartIdx = nGramsSplits[i2];
      this.nGramWidths.forEach((nGramWidth) => {
        const length = splits[i2 + 1] - splits[i2];
        const numNGrams = this.getNumNGrams(length, nGramWidth);
        this.createNGrams(data2, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
        outputStartIdx += numNGrams;
      });
      if (this.preserveShort && outputStartIdx === nGramsSplits[i2]) {
        const dataLength = splits[i2 + 1] - splits[i2];
        if (dataLength === 0) {
          continue;
        }
        const nGramWidth = dataLength + 2 * this.padWidth;
        const numNGrams = 1;
        this.createNGrams(data2, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
      }
    }
    return [nGrams, nGramsSplits];
  }
}
function stringNGramsImpl(data2, dataSplits, separator, nGramWidths, leftPad, rightPad2, padWidth, preserveShortSequences) {
  return new StringNGramsOp(separator, nGramWidths, leftPad, rightPad2, padWidth, preserveShortSequences).compute(data2, dataSplits);
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function split(str, delimiters, skipEmpty, result2) {
  if (!str.length) {
    return;
  }
  if (delimiters.length === 0) {
    for (let i2 = 0; i2 < str.length; ++i2) {
      result2.push(str.subarray(i2, i2 + 1));
    }
    return;
  }
  if (delimiters.length === 1) {
    const delimiter = delimiters[0];
    let f2 = str.indexOf(delimiter);
    while (f2 !== -1) {
      const token = str.subarray(0, f2);
      if (!skipEmpty || token.length !== 0) {
        result2.push(token);
      }
      str = str.subarray(f2 + 1);
      f2 = str.indexOf(delimiter);
    }
    if (!skipEmpty || str.length !== 0) {
      result2.push(str);
    }
    return;
  }
  let tokenStart = 0;
  for (let i2 = 0; i2 < str.length + 1; i2++) {
    if (i2 === str.length || delimiters.indexOf(str[i2]) !== -1) {
      const token = str.subarray(tokenStart, i2);
      if (!skipEmpty || token.length !== 0) {
        result2.push(token);
      }
      tokenStart = i2 + 1;
    }
  }
}
function stringSplitImpl(input, delimiter, skipEmpty) {
  const batchSize = input.length;
  const tokens = [];
  let outputSize = 0;
  let maxNumEntries = 0;
  const numIndices = new Array(batchSize);
  for (let i2 = 0; i2 < batchSize; ++i2) {
    const prevTokensLength = tokens.length;
    split(input[i2], delimiter, skipEmpty, tokens);
    const nEntries = tokens.length - prevTokensLength;
    numIndices[i2] = nEntries;
    outputSize += nEntries;
    maxNumEntries = Math.max(maxNumEntries, nEntries);
  }
  const indices = getArrayFromDType("int32", outputSize * 2);
  const values = new Array(outputSize);
  const shape = [batchSize, maxNumEntries];
  let c2 = 0;
  for (let i2 = 0; i2 < batchSize; ++i2) {
    for (let j2 = 0; j2 < numIndices[i2]; ++j2) {
      indices[c2 * 2] = i2;
      indices[c2 * 2 + 1] = j2;
      values[c2] = tokens[c2];
      ++c2;
    }
  }
  return [indices, values, shape];
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringToHashBucketFastImpl(input, numBuckets) {
  const output2 = getArrayFromDType("int32", input.length);
  for (let i2 = 0; i2 < input.length; ++i2) {
    output2[i2] = fingerPrint64(input[i2]).modulo(numBuckets).getLowBitsUnsigned();
  }
  return output2;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const subImpl = createSimpleBinaryKernelImpl((aValue, bValue) => aValue - bValue);
const subComplexImpl = createComplexBinaryKernelImpl((aReal, aImag, bReal, bImag) => {
  return { real: aReal - bReal, imag: aImag - bImag };
});
const sub$1 = binaryKernelFunc$1(Sub, subImpl, subComplexImpl);
const subConfig$2 = {
  kernelName: Sub,
  backendName: "cpu",
  kernelFunc: sub$1
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tileImpl(xBuf, reps) {
  const newShape = new Array(xBuf.rank);
  for (let i2 = 0; i2 < newShape.length; i2++) {
    newShape[i2] = xBuf.shape[i2] * reps[i2];
  }
  const result2 = buffer(newShape, xBuf.dtype);
  for (let i2 = 0; i2 < result2.values.length; ++i2) {
    const newLoc = result2.indexToLoc(i2);
    const originalLoc = new Array(xBuf.rank);
    for (let j2 = 0; j2 < originalLoc.length; j2++) {
      originalLoc[j2] = newLoc[j2] % xBuf.shape[j2];
    }
    const originalIndex = xBuf.locToIndex(originalLoc);
    result2.values[i2] = xBuf.values[originalIndex];
  }
  return result2;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const comparePair = (a6, b2) => {
  const valueDiff = b2.value - a6.value;
  return valueDiff === 0 ? a6.index - b2.index : valueDiff;
};
function select$3(array, k3, left2 = 0, right = array.length - 1) {
  while (right > left2) {
    if (right - left2 > 600) {
      const n2 = right - left2 + 1;
      const i3 = k3 - left2 + 1;
      const z2 = Math.log(n2);
      const s2 = 0.5 * Math.exp(2 * z2 / 3);
      const sd = 0.5 * Math.sqrt(z2 * s2 * (n2 - s2) / n2) * Math.sign(i3 - n2 / 2);
      const newLeft = Math.max(left2, Math.floor(k3 - i3 * s2 / n2 + sd));
      const newRight = Math.min(right, Math.floor(k3 + (n2 - i3) * s2 / n2 + sd));
      select$3(array, k3, newLeft, newRight);
    }
    const t2 = array[k3];
    let i2 = left2;
    let j2 = right;
    swap(array, left2, k3);
    if (comparePair(array[right], t2) > 0) {
      swap(array, left2, right);
    }
    while (i2 < j2) {
      swap(array, i2, j2);
      i2++;
      j2--;
      while (comparePair(array[i2], t2) < 0) {
        i2 = i2 + 1;
      }
      while (comparePair(array[j2], t2) > 0) {
        j2 = j2 - 1;
      }
    }
    if (comparePair(array[left2], t2) === 0) {
      swap(array, left2, j2);
    } else {
      j2 = j2 + 1;
      swap(array, j2, right);
    }
    if (j2 <= k3) {
      left2 = j2 + 1;
    }
    if (k3 <= j2) {
      right = j2 - 1;
    }
  }
}
function topKImpl(x2, xShape, xDtype, k3, sorted) {
  const lastDim = xShape[xShape.length - 1];
  const [batch, size] = [x2.length / lastDim, lastDim];
  const allTopKVals = getTypedArrayFromDType(xDtype, batch * k3);
  const allTopKIndices = getTypedArrayFromDType("int32", batch * k3);
  for (let b2 = 0; b2 < batch; b2++) {
    const offset = b2 * size;
    const vals = x2.subarray(offset, offset + size);
    let valAndInd = new Array(vals.length);
    vals.forEach((value, index2) => valAndInd[index2] = { value, index: index2 });
    if (k3 < valAndInd.length) {
      select$3(valAndInd, k3);
      valAndInd = valAndInd.slice(0, k3);
    }
    if (sorted) {
      valAndInd.sort(comparePair);
    }
    const outOffset = b2 * k3;
    const topKVals = allTopKVals.subarray(outOffset, outOffset + k3);
    const topKIndices = allTopKIndices.subarray(outOffset, outOffset + k3);
    for (let i2 = 0; i2 < k3; i2++) {
      topKVals[i2] = valAndInd[i2].value;
      topKIndices[i2] = valAndInd[i2].index;
    }
  }
  const outputShape = xShape.slice();
  outputShape[outputShape.length - 1] = k3;
  return [
    buffer(outputShape, xDtype, allTopKVals),
    buffer(outputShape, "int32", allTopKIndices)
  ];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function uniqueImpl(values, axis, shape, dtype) {
  const $axis = parseAxisParam(axis, shape)[0];
  const newShape = [1, shape[0], 1];
  for (let i2 = 0; i2 < $axis; i2++) {
    newShape[0] *= shape[i2];
  }
  newShape[1] = shape[$axis];
  for (let i2 = $axis + 1; i2 < shape.length; i2++) {
    newShape[2] *= shape[i2];
  }
  const uniqueElements = {};
  const indices = new Int32Array(shape[$axis]);
  const inputBuffer = new TensorBuffer(newShape, dtype, values);
  const uniqueIndices = [];
  const is1DTensor = newShape[0] === 1 && newShape[2] === 1;
  for (let i2 = 0; i2 < shape[$axis]; i2++) {
    let element;
    if (is1DTensor) {
      element = values[i2].toString();
    } else {
      const axisValues = [];
      for (let m2 = 0; m2 < newShape[0]; m2++) {
        for (let n2 = 0; n2 < newShape[2]; n2++) {
          axisValues.push(inputBuffer.get(m2, i2, n2));
        }
      }
      element = axisValues.join(",");
    }
    if (uniqueElements[element] !== void 0) {
      indices[i2] = uniqueElements[element];
    } else {
      const uniqueIndex = Object.keys(uniqueElements).length;
      uniqueElements[element] = uniqueIndex;
      indices[i2] = uniqueIndex;
      uniqueIndices.push(i2);
    }
  }
  const outputTmpShape = newShape.slice();
  outputTmpShape[1] = Object.keys(uniqueElements).length;
  const outputBuffer = new TensorBuffer(outputTmpShape, dtype);
  uniqueIndices.forEach((uniqueElementIndex, i2) => {
    for (let m2 = 0; m2 < newShape[0]; m2++) {
      for (let n2 = 0; n2 < newShape[2]; n2++) {
        outputBuffer.set(inputBuffer.get(m2, uniqueElementIndex, n2), m2, i2, n2);
      }
    }
  });
  const outputShape = shape.slice();
  outputShape[$axis] = outputTmpShape[1];
  return {
    outputValues: outputBuffer.values,
    outputShape,
    indices
  };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var shared = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  simpleAbsImpl,
  addImpl,
  bincountImpl,
  bincountReduceImpl,
  ceilImpl,
  concatImpl: concatImpl$1,
  equalImpl,
  expImpl,
  expm1Impl,
  floorImpl,
  gatherNdImpl,
  gatherV2Impl,
  greaterImpl,
  greaterEqualImpl,
  lessImpl,
  lessEqualImpl,
  linSpaceImpl,
  logImpl,
  maxImpl: maxImpl$1,
  maximumImpl,
  minimumImpl,
  multiplyImpl,
  negImpl,
  notEqualImpl,
  prodImpl,
  rangeImpl,
  rsqrtImpl,
  sigmoidImpl,
  sliceImpl,
  sparseFillEmptyRowsImpl,
  sparseReshapeImpl,
  sparseSegmentReductionImpl,
  sqrtImpl,
  squaredDifferenceImpl,
  stridedSliceImpl,
  stringNGramsImpl,
  stringSplitImpl,
  stringToHashBucketFastImpl,
  subImpl,
  tileImpl,
  topKImpl,
  transposeImpl: transposeImpl$1,
  uniqueImpl
}, Symbol.toStringTag, { value: "Module" }));
/** @license See the LICENSE file. */
const version$2 = "3.16.0";
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
registerBackend("cpu", () => new MathBackendCPU(), 1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const elu$1 = unaryKernelFunc$1(Elu$1, (xi) => xi >= 0 ? xi : Math.exp(xi) - 1);
const eluConfig$2 = {
  kernelName: Elu$1,
  backendName: "cpu",
  kernelFunc: elu$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function leakyRelu$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { alpha: alpha2 } = attrs;
  assertNotComplex$1([x2], "leakyRelu");
  const xSize = sizeFromShape(x2.shape);
  const xVals = backend2.data.get(x2.dataId).values;
  const outVals = getTypedArrayFromDType("float32", xSize);
  for (let i2 = 0; i2 < xVals.length; i2++) {
    outVals[i2] = xVals[i2] < 0 ? alpha2 * xVals[i2] : xVals[i2];
  }
  return backend2.makeTensorInfo(x2.shape, "float32", outVals);
}
const leakyReluConfig$2 = {
  kernelName: LeakyRelu,
  backendName: "cpu",
  kernelFunc: leakyRelu$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const preluImpl = createSimpleBinaryKernelImpl((xValue, aValue) => xValue < 0 ? aValue * xValue : xValue);
function prelu$2(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2, alpha: alpha2 } = inputs;
  assertNotComplex$1([x2, alpha2], "prelu");
  const aVals = backend2.data.get(x2.dataId).values;
  const bVals = backend2.data.get(alpha2.dataId).values;
  const [resultData, resultShape] = preluImpl(x2.shape, alpha2.shape, aVals, bVals, "float32");
  return backend2.makeTensorInfo(resultShape, "float32", resultData);
}
const preluConfig$2 = {
  kernelName: Prelu,
  backendName: "cpu",
  kernelFunc: prelu$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const relu$1 = unaryKernelFunc$1(Relu$1, (xi) => Math.max(0, xi));
const reluConfig$2 = {
  kernelName: Relu$1,
  backendName: "cpu",
  kernelFunc: relu$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const relu6$1 = unaryKernelFunc$1(Relu6$1, (xi) => Math.min(Math.max(0, xi), 6));
const relu6Config$2 = {
  kernelName: Relu6$1,
  backendName: "cpu",
  kernelFunc: relu6$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function applyActivation(backend2, x2, activation, preluActivationWeights, leakyreluAlpha) {
  if (activation === "linear") {
    return identity$2({ inputs: { x: x2 }, backend: backend2 });
  } else if (activation === "relu") {
    return relu$1({ inputs: { x: x2 }, backend: backend2 });
  } else if (activation === "elu") {
    return elu$1({ inputs: { x: x2 }, backend: backend2 });
  } else if (activation === "relu6") {
    return relu6$1({ inputs: { x: x2 }, backend: backend2 });
  } else if (activation === "prelu") {
    return prelu$2({ inputs: { x: x2, alpha: preluActivationWeights }, backend: backend2 });
  } else if (activation === "leakyrelu") {
    return leakyRelu$2({ inputs: { x: x2 }, backend: backend2, attrs: { alpha: leakyreluAlpha } });
  } else if (activation === "sigmoid") {
    return sigmoid$2({ inputs: { x: x2 }, backend: backend2 });
  }
  throw new Error(`Activation ${activation} has not been implemented for the CPU backend.`);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reshape$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { shape } = attrs;
  const xSize = sizeFromShape(x2.shape);
  const $shape = inferFromImplicitShape(shape, xSize);
  const $xSize = sizeFromShape($shape);
  assert$1(xSize === $xSize, () => `The new shape (${$shape}) has ${$xSize} elements and the old shape (${x2.shape}) has ${xSize} elements. The new shape and old shape must have the same number of elements.`);
  backend2.incRef(x2.dataId);
  const xData = backend2.data.get(x2.dataId);
  if (xData.complexTensorInfos != null) {
    const real2 = xData.complexTensorInfos.real;
    const imag2 = xData.complexTensorInfos.imag;
    real2.shape = $shape;
    imag2.shape = $shape;
  }
  return { dataId: x2.dataId, shape: $shape, dtype: x2.dtype };
}
const reshapeConfig$2 = {
  kernelName: Reshape$1,
  backendName: "cpu",
  kernelFunc: reshape$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchMatMul$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { a: a6, b: b2 } = inputs;
  const { transposeA, transposeB } = attrs;
  assertNotComplex$1([a6, b2], "matMul");
  const aRank = a6.shape.length;
  const bRank = b2.shape.length;
  const innerShapeA = transposeA ? a6.shape[aRank - 2] : a6.shape[aRank - 1];
  const innerShapeB = transposeB ? b2.shape[bRank - 1] : b2.shape[bRank - 2];
  const outerShapeA = transposeA ? a6.shape[aRank - 1] : a6.shape[aRank - 2];
  const outerShapeB = transposeB ? b2.shape[bRank - 2] : b2.shape[bRank - 1];
  const outerDimsA = a6.shape.slice(0, -2);
  const outerDimsB = b2.shape.slice(0, -2);
  const batchDimA = sizeFromShape(outerDimsA);
  const batchDimB = sizeFromShape(outerDimsB);
  const outShapeOuterDims = assertAndGetBroadcastShape(a6.shape.slice(0, -2), b2.shape.slice(0, -2));
  const outShape = outShapeOuterDims.concat([outerShapeA, outerShapeB]);
  assert$1(innerShapeA === innerShapeB, () => `Error in matMul: inner shapes (${innerShapeA}) and (${innerShapeB}) of Tensors with shapes ${a6.shape} and ${b2.shape} and transposeA=${transposeA} and transposeB=${transposeB} must match.`);
  const a3dShape = transposeA ? [batchDimA, innerShapeA, outerShapeA] : [batchDimA, outerShapeA, innerShapeA];
  const b3dShape = transposeB ? [batchDimB, outerShapeB, innerShapeB] : [batchDimB, innerShapeB, outerShapeB];
  const a3d = reshape$2({ inputs: { x: a6 }, backend: backend2, attrs: { shape: a3dShape } });
  const b3d = reshape$2({ inputs: { x: b2 }, backend: backend2, attrs: { shape: b3dShape } });
  const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
  const leftDim = transposeA ? a3d.shape[2] : a3d.shape[1];
  const rightDim = transposeB ? b3d.shape[1] : b3d.shape[2];
  const batchDim = Math.max(batchDimA, batchDimB);
  const a3dValues = backend2.data.get(a3d.dataId).values;
  const b3dValues = backend2.data.get(b3d.dataId).values;
  const a3dStrides = computeStrides(a3d.shape);
  const b3dStrides = computeStrides(b3d.shape);
  const [aBatch, aOuterStep, aInnerStep] = transposeA ? [a3dStrides[0], 1, a3dStrides[1]] : [a3dStrides[0], a3dStrides[1], 1];
  const [bInnerStep, bOuterStep, bBatch] = transposeB ? [1, b3dStrides[1], b3dStrides[0]] : [b3dStrides[1], 1, b3dStrides[0]];
  const size = leftDim * rightDim;
  const result2 = buffer([batchDim, leftDim, rightDim], a3d.dtype);
  const resVals = result2.values;
  const blockSize = backend2.blockSize;
  for (let bi = 0; bi < batchDim; bi++) {
    for (let i0 = 0; i0 < leftDim; i0 += blockSize) {
      for (let j0 = 0; j0 < rightDim; j0 += blockSize) {
        for (let k02 = 0; k02 < sharedDim; k02 += blockSize) {
          const iBlock = Math.min(i0 + blockSize, leftDim);
          const jBlock = Math.min(j0 + blockSize, rightDim);
          const kBlock = Math.min(k02 + blockSize, sharedDim);
          for (let i2 = i0; i2 < iBlock; i2++) {
            for (let j2 = j0; j2 < jBlock; j2++) {
              let sum2 = 0;
              for (let k3 = k02; k3 < kBlock; k3++) {
                const batchOffsetA = Math.min(bi, batchDimA - 1) * aBatch;
                const batchOffsetB = Math.min(bi, batchDimB - 1) * bBatch;
                const aVal = a3dValues[batchOffsetA + i2 * aOuterStep + k3 * aInnerStep];
                const bVal = b3dValues[k3 * bInnerStep + j2 * bOuterStep + batchOffsetB];
                sum2 += aVal * bVal;
              }
              resVals[bi * size + (i2 * rightDim + j2)] += sum2;
            }
          }
        }
      }
    }
  }
  backend2.disposeIntermediateTensorInfo(a3d);
  backend2.disposeIntermediateTensorInfo(b3d);
  return backend2.makeTensorInfo(outShape, result2.dtype, result2.values);
}
const batchMatMulConfig$2 = {
  kernelName: BatchMatMul,
  backendName: "cpu",
  kernelFunc: batchMatMul$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function _fusedMatMul$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { a: a6, b: b2, bias, preluActivationWeights } = inputs;
  const { transposeA, transposeB, activation, leakyreluAlpha } = attrs;
  let current;
  let addRes;
  let activationRes;
  const intermediates = [];
  const matMulRes = batchMatMul$2({ inputs: { a: a6, b: b2 }, attrs: { transposeA, transposeB }, backend: backend2 });
  current = matMulRes;
  if (bias) {
    addRes = add({ inputs: { a: current, b: bias }, backend: backend2 });
    intermediates.push(current);
    current = addRes;
  }
  if (activation) {
    activationRes = applyActivation(backend2, current, activation, preluActivationWeights, leakyreluAlpha);
    intermediates.push(current);
    current = activationRes;
  }
  for (const i2 of intermediates) {
    backend2.disposeIntermediateTensorInfo(i2);
  }
  return current;
}
const _fusedMatMulConfig$2 = {
  kernelName: _FusedMatMul,
  backendName: "cpu",
  kernelFunc: _fusedMatMul$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const acos$1 = unaryKernelFunc$1(Acos, (xi) => Math.acos(xi));
const acosConfig$1 = {
  kernelName: Acos,
  backendName: "cpu",
  kernelFunc: acos$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const acosh$1 = unaryKernelFunc$1(Acosh, (xi) => Math.acosh(xi));
const acoshConfig$1 = {
  kernelName: Acosh,
  backendName: "cpu",
  kernelFunc: acosh$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function addN$1(args) {
  const { inputs, backend: backend2 } = args;
  const tensors = inputs;
  assertNotComplex$1(inputs, "addN");
  const vals = tensors.map((t2) => backend2.data.get(t2.dataId).values);
  const outBuf = buffer(tensors[0].shape, tensors[0].dtype);
  const outVals = outBuf.values;
  for (let i2 = 0; i2 < tensors.length; i2++) {
    const currVals = vals[i2];
    for (let j2 = 0; j2 < outVals.length; j2++) {
      outVals[j2] += currVals[j2];
    }
  }
  return backend2.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const addNConfig$2 = {
  kernelName: AddN,
  backendName: "cpu",
  kernelFunc: addN$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function all$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  assertNotComplex$1(x2, "all");
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  if (permutedAxes != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, x2.shape.length);
  }
  assertAxesAreInnerMostDims("all", axes, $x.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes($x.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const vals = makeZerosTypedArray(sizeFromShape(outShape), $x.dtype);
  const aVals = backend2.data.get($x.dataId).values;
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let all3 = aVals[offset];
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      const value = aVals[offset + j2];
      all3 = all3 && value;
    }
    vals[i2] = all3;
  }
  if (permutedAxes != null) {
    backend2.disposeIntermediateTensorInfo($x);
  }
  const result2 = backend2.makeTensorInfo(outShape, $x.dtype, vals);
  if (keepDims) {
    const expandedShape = expandShapeToKeepDim(outShape, origAxes);
    const reshapedResult = reshape$2({ inputs: { x: result2 }, backend: backend2, attrs: { shape: expandedShape } });
    backend2.disposeIntermediateTensorInfo(result2);
    return reshapedResult;
  }
  return result2;
}
const allConfig$2 = {
  kernelName: All,
  backendName: "cpu",
  kernelFunc: all$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function any$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  assertNotComplex$1(x2, "any");
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  if (permutedAxes != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, x2.shape.length);
  }
  assertAxesAreInnerMostDims("any", axes, $x.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes($x.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const vals = makeZerosTypedArray(sizeFromShape(outShape), $x.dtype);
  const aVals = backend2.data.get($x.dataId).values;
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let anyVal = aVals[offset];
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      const value = aVals[offset + j2];
      anyVal = anyVal || value;
    }
    vals[i2] = anyVal;
  }
  if (permutedAxes != null) {
    backend2.disposeIntermediateTensorInfo($x);
  }
  const result2 = backend2.makeTensorInfo(outShape, $x.dtype, vals);
  if (keepDims) {
    const expandedShape = expandShapeToKeepDim(outShape, origAxes);
    const reshapedResult = reshape$2({ inputs: { x: result2 }, backend: backend2, attrs: { shape: expandedShape } });
    backend2.disposeIntermediateTensorInfo(result2);
    return reshapedResult;
  }
  return result2;
}
const anyConfig$2 = {
  kernelName: Any,
  backendName: "cpu",
  kernelFunc: any$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argMax$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis } = attrs;
  assertNotComplex$1(x2, "argMax");
  let axes = parseAxisParam(axis, x2.shape);
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  const intermediateTensorInfos = [];
  if (permutedAxes != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    intermediateTensorInfos.push($x);
    axes = getInnerMostAxes(axes.length, $x.shape.length);
  }
  axes = [axes[0]];
  assertAxesAreInnerMostDims("argMax", axes, $x.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes($x.shape, axes);
  const outSize = sizeFromShape(outShape);
  const vals = makeZerosTypedArray(outSize, "int32");
  const reduceSize = sizeFromShape(reduceShape);
  const aVals = backend2.data.get($x.dataId).values;
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let max2 = aVals[offset];
    let maxIndex = 0;
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      const value = aVals[offset + j2];
      if (value > max2) {
        max2 = value;
        maxIndex = j2;
      }
    }
    vals[i2] = maxIndex;
  }
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return backend2.makeTensorInfo(outShape, "int32", vals);
}
const argMaxConfig$2 = {
  kernelName: ArgMax,
  backendName: "cpu",
  kernelFunc: argMax$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argMin$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis } = attrs;
  assertNotComplex$1(x2, "argMin");
  let axes = parseAxisParam(axis, x2.shape);
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  const intermediateTensorInfos = [];
  if (permutedAxes != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    intermediateTensorInfos.push($x);
    axes = getInnerMostAxes(axes.length, $x.shape.length);
  }
  axes = [axes[0]];
  assertAxesAreInnerMostDims("argMin", axes, $x.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes($x.shape, axes);
  const outSize = sizeFromShape(outShape);
  const vals = makeZerosTypedArray(outSize, "int32");
  const reduceSize = sizeFromShape(reduceShape);
  const aVals = backend2.data.get($x.dataId).values;
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let min2 = aVals[offset];
    let minIndex = 0;
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      const value = aVals[offset + j2];
      if (value < min2) {
        min2 = value;
        minIndex = j2;
      }
    }
    vals[i2] = minIndex;
  }
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return backend2.makeTensorInfo(outShape, "int32", vals);
}
const argMinConfig$1 = {
  kernelName: ArgMin,
  backendName: "cpu",
  kernelFunc: argMin$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const asin$1 = unaryKernelFunc$1(Asin, (xi) => Math.asin(xi));
const asinConfig$1 = {
  kernelName: Asin,
  backendName: "cpu",
  kernelFunc: asin$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const asinh$1 = unaryKernelFunc$1(Asinh, (xi) => Math.asinh(xi));
const asinhConfig$1 = {
  kernelName: Asinh,
  backendName: "cpu",
  kernelFunc: asinh$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const atan$1 = unaryKernelFunc$1(Atan, (xi) => Math.atan(xi));
const atanConfig$1 = {
  kernelName: Atan,
  backendName: "cpu",
  kernelFunc: atan$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const atan2Impl = createSimpleBinaryKernelImpl((aValue, bValue) => Math.atan2(aValue, bValue));
const atan2$1 = binaryKernelFunc$1(Atan2, atan2Impl);
const atan2Config$1 = {
  kernelName: Atan2,
  backendName: "cpu",
  kernelFunc: atan2$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const atanh$1 = unaryKernelFunc$1(Atanh, (xi) => Math.atanh(xi));
const atanhConfig$1 = {
  kernelName: Atanh,
  backendName: "cpu",
  kernelFunc: atanh$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pool(xValues, xShape, dtype, strides, convInfo, poolType) {
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padTop = convInfo.padInfo.top;
  const padLeft = convInfo.padInfo.left;
  const initialValue = poolType === "max" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  const output2 = buffer(convInfo.outShape, dtype);
  const outputVals = output2.values;
  const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3];
  const outputRowStrides = convInfo.outShape[2] * convInfo.outShape[3];
  const outputColStrides = convInfo.outShape[3];
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    const outputBatchOffset = b2 * outputBatchStrides;
    const inputBatchOffset = b2 * strides[0];
    for (let d2 = 0; d2 < convInfo.inChannels; ++d2) {
      for (let yR = 0; yR < convInfo.outHeight; ++yR) {
        const xRCorner = yR * strideHeight - padTop;
        const xRMin = Math.max(0, xRCorner);
        const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
        const outputRowOffset = outputBatchOffset + yR * outputRowStrides;
        for (let yC = 0; yC < convInfo.outWidth; ++yC) {
          const xCCorner = yC * strideWidth - padLeft;
          const xCMin = Math.max(0, xCCorner);
          const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
          let minMaxValue = initialValue;
          let avgValue = 0;
          let count2 = 0;
          for (let xR = xRMin; xR < xRMax; xR += dilationHeight) {
            const xROffset = inputBatchOffset + xR * strides[1];
            for (let xC = xCMin; xC < xCMax; xC += dilationWidth) {
              const xCOffset = xROffset + xC * strides[2];
              const pixel = xValues[xCOffset + d2];
              if (poolType === "max" && pixel > minMaxValue) {
                minMaxValue = pixel;
              } else if (poolType === "avg") {
                avgValue += pixel;
                count2++;
              }
            }
            if (isNaN(minMaxValue)) {
              break;
            }
          }
          const outputOffset = outputRowOffset + yC * outputColStrides + d2;
          outputVals[outputOffset] = poolType === "avg" ? avgValue / count2 : minMaxValue;
        }
      }
    }
  }
  return output2;
}
function maxPoolPositions(xValues, xShape, dtype, convInfo, flattenPositions = false, includeBatchInIndex = false) {
  const maxPositions = buffer(convInfo.outShape, "int32");
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padTop = convInfo.padInfo.top;
  const padLeft = convInfo.padInfo.left;
  const xBuf = buffer(xShape, dtype, xValues);
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    for (let d2 = 0; d2 < convInfo.inChannels; ++d2) {
      for (let yR = 0; yR < convInfo.outHeight; ++yR) {
        const xRCorner = yR * strideHeight - padTop;
        let xRMin = xRCorner;
        while (xRMin < 0) {
          xRMin += dilationHeight;
        }
        const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
        for (let yC = 0; yC < convInfo.outWidth; ++yC) {
          const xCCorner = yC * strideWidth - padLeft;
          let xCMin = xCCorner;
          while (xCMin < 0) {
            xCMin += dilationWidth;
          }
          const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
          let maxValue = Number.NEGATIVE_INFINITY;
          let maxPosition = -1;
          for (let xR = xRMin; xR < xRMax; xR += dilationHeight) {
            const wR = xR - xRCorner;
            for (let xC = xCMin; xC < xCMax; xC += dilationWidth) {
              const wC = xC - xCCorner;
              const pixel = xBuf.get(b2, xR, xC, d2);
              if (pixel > maxValue) {
                maxValue = pixel;
                if (flattenPositions) {
                  maxPosition = includeBatchInIndex ? ((b2 * convInfo.inHeight + xR) * convInfo.inWidth + xC) * convInfo.inChannels + d2 : (xR * convInfo.inWidth + xC) * convInfo.inChannels + d2;
                } else {
                  maxPosition = wR * effectiveFilterWidth + wC;
                }
              }
            }
          }
          maxPositions.set(maxPosition, b2, yR, yC, d2);
        }
      }
    }
  }
  return maxPositions;
}
function pool3d(xValues, xShape, dtype, strides, convInfo, poolType) {
  const strideDepth = convInfo.strideDepth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const dilationDepth = convInfo.dilationDepth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterDepth = convInfo.effectiveFilterDepth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padFront = convInfo.padInfo.front;
  const padTop = convInfo.padInfo.top;
  const padLeft = convInfo.padInfo.left;
  const initialValue = poolType === "max" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  const output2 = buffer(convInfo.outShape, dtype);
  const outputVals = output2.values;
  const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
  const outputDepthStrides = convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
  const outputRowStrides = convInfo.outShape[3] * convInfo.outShape[4];
  const outputColStrides = convInfo.outShape[4];
  for (let batch = 0; batch < convInfo.batchSize; ++batch) {
    const outputBatchOffset = batch * outputBatchStrides;
    const inputBatchOffset = batch * strides[0];
    for (let channel = 0; channel < convInfo.inChannels; ++channel) {
      for (let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth) {
        const xDepthCorner = yDepth * strideDepth - padFront;
        let xDepthMin = xDepthCorner;
        while (xDepthMin < 0) {
          xDepthMin += dilationDepth;
        }
        const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
        const outputDepthOffset = outputBatchOffset + yDepth * outputDepthStrides;
        for (let yRow = 0; yRow < convInfo.outHeight; ++yRow) {
          const xRowCorner = yRow * strideHeight - padTop;
          let xRowMin = xRowCorner;
          while (xRowMin < 0) {
            xRowMin += dilationHeight;
          }
          const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
          const outputRowOffset = outputDepthOffset + yRow * outputRowStrides;
          for (let yCol = 0; yCol < convInfo.outWidth; ++yCol) {
            const xColCorner = yCol * strideWidth - padLeft;
            let xColMin = xColCorner;
            while (xColMin < 0) {
              xColMin += dilationWidth;
            }
            const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
            const outputColOffset = outputRowOffset + yCol * outputColStrides;
            let minMaxValue = initialValue;
            let avgValue = 0;
            let count2 = 0;
            for (let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth) {
              const xDepthOffset = inputBatchOffset + xDepth * strides[1];
              for (let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight) {
                const xRowOffset = xDepthOffset + xRow * strides[2];
                for (let xCol = xColMin; xCol < xColMax; xCol += dilationWidth) {
                  const xColOffset = xRowOffset + xCol * strides[3];
                  const pixel = xValues[xColOffset + channel];
                  if (poolType === "max" && pixel > minMaxValue) {
                    minMaxValue = pixel;
                  } else if (poolType === "avg") {
                    avgValue += pixel;
                    count2++;
                  }
                  if (isNaN(minMaxValue)) {
                    break;
                  }
                }
                if (isNaN(minMaxValue)) {
                  break;
                }
              }
              if (isNaN(minMaxValue)) {
                break;
              }
            }
            const outputOffset = outputColOffset + channel;
            outputVals[outputOffset] = poolType === "avg" ? avgValue / count2 : minMaxValue;
          }
        }
      }
    }
  }
  return output2;
}
function maxPool3dPositions(xBuf, convInfo) {
  const maxPositions = buffer(convInfo.outShape, "int32");
  const strideDepth = convInfo.strideDepth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const dilationDepth = convInfo.dilationDepth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterDepth = convInfo.effectiveFilterDepth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padFront = convInfo.padInfo.front;
  const padTop = convInfo.padInfo.top;
  const padLeft = convInfo.padInfo.left;
  for (let batch = 0; batch < convInfo.batchSize; ++batch) {
    for (let channel = 0; channel < convInfo.inChannels; ++channel) {
      for (let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth) {
        const xDepthCorner = yDepth * strideDepth - padFront;
        let xDepthMin = xDepthCorner;
        while (xDepthMin < 0) {
          xDepthMin += dilationDepth;
        }
        const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
        for (let yRow = 0; yRow < convInfo.outHeight; ++yRow) {
          const xRowCorner = yRow * strideHeight - padTop;
          let xRowMin = xRowCorner;
          while (xRowMin < 0) {
            xRowMin += dilationHeight;
          }
          const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
          for (let yCol = 0; yCol < convInfo.outWidth; ++yCol) {
            const xColCorner = yCol * strideWidth - padLeft;
            let xColMin = xColCorner;
            while (xColMin < 0) {
              xColMin += dilationWidth;
            }
            const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
            let maxValue = Number.NEGATIVE_INFINITY;
            let maxPosition = -1;
            for (let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth) {
              const wDepth = xDepth - xDepthCorner;
              for (let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight) {
                const wRow = xRow - xRowCorner;
                for (let xCol = xColMin; xCol < xColMax; xCol += dilationWidth) {
                  const wCol = xCol - xColCorner;
                  const pixel = xBuf.get(batch, xDepth, xRow, xCol, channel);
                  if (pixel >= maxValue) {
                    maxValue = pixel;
                    maxPosition = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterHeight + wCol;
                  }
                }
              }
            }
            maxPositions.set(maxPosition, batch, yDepth, yRow, yCol, channel);
          }
        }
      }
    }
  }
  return maxPositions;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  assertNotComplex$1(x2, "avgPool");
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const dilations = 1;
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in avgPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode);
  let res;
  if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && arraysEqual(convInfo.inShape, convInfo.outShape)) {
    res = identity$2({ inputs: { x: x2 }, backend: backend2 });
  } else {
    const xValues = backend2.data.get(x2.dataId).values;
    const strides2 = computeStrides(x2.shape);
    const buffer2 = pool(xValues, x2.shape, x2.dtype, strides2, convInfo, "avg");
    res = backend2.makeTensorInfo(convInfo.outShape, x2.dtype, buffer2.values);
  }
  return res;
}
const avgPoolConfig$2 = {
  kernelName: AvgPool,
  backendName: "cpu",
  kernelFunc: avgPool$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool3D$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { filterSize, strides, pad: pad2, dimRoundingMode, dataFormat } = attrs;
  assertNotComplex$1(x2, "avgPool3d");
  const convInfo = computePool3DInfo(x2.shape, filterSize, strides, 1, pad2, dimRoundingMode, dataFormat);
  const xValues = backend2.data.get(x2.dataId).values;
  const outBuf = pool3d(xValues, x2.shape, x2.dtype, computeStrides(x2.shape), convInfo, "avg");
  return backend2.makeTensorInfo(outBuf.shape, "float32", outBuf.values);
}
const avgPool3DConfig$1 = {
  kernelName: AvgPool3D,
  backendName: "cpu",
  kernelFunc: avgPool3D$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool3DGrad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input } = inputs;
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  assertNotComplex$1([dy, input], "avgPool3DGrad");
  const convInfo = computePool3DInfo(input.shape, filterSize, strides, 1, pad2, dimRoundingMode);
  const strideDepth = convInfo.strideDepth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const filterDepth = convInfo.filterDepth;
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const dilationDepth = convInfo.dilationDepth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterDepth = convInfo.effectiveFilterDepth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
  const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
  const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
  const dx = buffer(input.shape, "float32");
  const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
  const dyBuf = backend2.bufferSync(dy);
  for (let batch = 0; batch < convInfo.batchSize; ++batch) {
    for (let channel = 0; channel < convInfo.inChannels; ++channel) {
      for (let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth) {
        for (let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow) {
          for (let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol) {
            const dyDepthCorner = dxDepth - padFront;
            const dyRowCorner = dxRow - padTop;
            const dyColCorner = dxCol - padLeft;
            let dotProd = 0;
            for (let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth) {
              const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
              if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) {
                continue;
              }
              for (let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight) {
                const dyRow = (dyRowCorner + wRow) / strideHeight;
                if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) {
                  continue;
                }
                for (let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth) {
                  const dyCol = (dyColCorner + wCol) / strideWidth;
                  if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) {
                    continue;
                  }
                  const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                  dotProd += pixel;
                }
              }
            }
            dx.set(dotProd * avgMultiplier, batch, dxDepth, dxRow, dxCol, channel);
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const avgPool3DGradConfig$1 = {
  kernelName: AvgPool3DGrad,
  backendName: "cpu",
  kernelFunc: avgPool3DGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPoolGrad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input } = inputs;
  const x2 = input;
  assertNotComplex$1([dy, input], "avgPoolGrad");
  const { filterSize, strides, pad: pad2 } = attrs;
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, 1, pad2);
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
  const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
  const dx = buffer(x2.shape, "float32");
  const avgMultiplier = 1 / (filterHeight * filterWidth);
  const dyData = backend2.data.get(dy.dataId).values;
  const dyBuf = buffer(dy.shape, "float32", dyData);
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    for (let d2 = 0; d2 < convInfo.inChannels; ++d2) {
      for (let dxR = 0; dxR < convInfo.inHeight; ++dxR) {
        for (let dxC = 0; dxC < convInfo.inWidth; ++dxC) {
          const dyRCorner = dxR - padTop;
          const dyCCorner = dxC - padLeft;
          let dotProd = 0;
          for (let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight) {
            const dyR = (dyRCorner + wR) / strideHeight;
            if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) {
              continue;
            }
            for (let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth) {
              const dyC = (dyCCorner + wC) / strideWidth;
              if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) {
                continue;
              }
              const pixel = dyBuf.get(b2, dyR, dyC, d2);
              dotProd += pixel;
            }
          }
          dx.set(dotProd * avgMultiplier, b2, dxR, dxC, d2);
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const avgPoolGradConfig$1 = {
  kernelName: AvgPoolGrad,
  backendName: "cpu",
  kernelFunc: avgPoolGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchNorm$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, scale: scale2, offset, mean: mean2, variance } = inputs;
  assert$1(mean2.shape.length === variance.shape.length, () => "Batch normalization gradient requires mean and variance to have equal ranks.");
  assert$1(offset == null || mean2.shape.length === offset.shape.length, () => "Batch normalization gradient requires mean and offset to have equal ranks.");
  assert$1(scale2 == null || mean2.shape.length === scale2.shape.length, () => "Batch normalization gradient requires mean and scale to have equal ranks.");
  assertNotComplex$1([x2, mean2, variance, scale2, offset], "batchNorm");
  let { varianceEpsilon } = attrs;
  if (varianceEpsilon == null) {
    varianceEpsilon = 1e-3;
  }
  const xVals = backend2.data.get(x2.dataId).values;
  const mVals = backend2.data.get(mean2.dataId).values;
  const varVals = backend2.data.get(variance.dataId).values;
  const sVals = scale2 ? backend2.data.get(scale2.dataId).values : new Float32Array([1]);
  const offVals = offset ? backend2.data.get(offset.dataId).values : new Float32Array([0]);
  const outVals = new Float32Array(xVals.length);
  const offValsLength = offVals.length;
  const sValsLength = sVals.length;
  const varValsLength = varVals.length;
  const mValsLength = mVals.length;
  let offi = 0;
  let mi = 0;
  let si = 0;
  let vi = 0;
  for (let i2 = 0; i2 < xVals.length; ++i2) {
    outVals[i2] = offVals[offi++] + (xVals[i2] - mVals[mi++]) * sVals[si++] / Math.sqrt(varVals[vi++] + varianceEpsilon);
    if (offi >= offValsLength) {
      offi = 0;
    }
    if (mi >= mValsLength) {
      mi = 0;
    }
    if (si >= sValsLength) {
      si = 0;
    }
    if (vi >= varValsLength) {
      vi = 0;
    }
  }
  return backend2.makeTensorInfo(x2.shape, x2.dtype, outVals);
}
const batchNormConfig$1 = {
  kernelName: FusedBatchNorm,
  backendName: "cpu",
  kernelFunc: batchNorm$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchToSpaceND$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockShape, crops } = attrs;
  assertNotComplex$1([x2], "batchToSpaceND");
  const prod2 = blockShape.reduce((a6, b2) => a6 * b2);
  const reshaped = getReshaped(x2.shape, blockShape, prod2);
  const permuted = getPermuted(reshaped.length, blockShape.length);
  const reshapedPermuted = getReshapedPermuted(x2.shape, blockShape, prod2);
  const sliceBeginCoords = getSliceBeginCoords(crops, blockShape.length);
  const sliceSize = getSliceSize(reshapedPermuted, crops, blockShape.length);
  const xReshaped = reshape$2({ inputs: { x: x2 }, backend: backend2, attrs: { shape: reshaped } });
  const xTransposed = transpose$2({ inputs: { x: xReshaped }, backend: backend2, attrs: { perm: permuted } });
  const xTransposedReshaped = reshape$2({ inputs: { x: xTransposed }, backend: backend2, attrs: { shape: reshapedPermuted } });
  const result2 = slice$2({
    inputs: { x: xTransposedReshaped },
    backend: backend2,
    attrs: { begin: sliceBeginCoords, size: sliceSize }
  });
  backend2.disposeIntermediateTensorInfo(xReshaped);
  backend2.disposeIntermediateTensorInfo(xTransposed);
  backend2.disposeIntermediateTensorInfo(xTransposedReshaped);
  return result2;
}
const batchToSpaceNDConfig$2 = {
  kernelName: BatchToSpaceND,
  backendName: "cpu",
  kernelFunc: batchToSpaceND$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function bincount$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, weights } = inputs;
  const { size } = attrs;
  const xVals = backend2.data.get(x2.dataId).values;
  const weightsVals = backend2.data.get(weights.dataId).values;
  const outVals = bincountImpl(xVals, weightsVals, weights.dtype, weights.shape, size);
  return backend2.makeTensorInfo([size], weights.dtype, outVals);
}
const bincountConfig$1 = {
  kernelName: Bincount,
  backendName: "cpu",
  kernelFunc: bincount$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function broadcastArgs$1(args) {
  const { inputs, backend: backend2 } = args;
  const { s0, s1 } = inputs;
  const s0Vals = backend2.data.get(s0.dataId).values;
  const s1Vals = backend2.data.get(s1.dataId).values;
  const broadcastShape = assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
  return backend2.makeTensorInfo([broadcastShape.length], "int32", Int32Array.from(broadcastShape));
}
const broadcastArgsConfig$1 = {
  kernelName: BroadcastArgs,
  backendName: "cpu",
  kernelFunc: broadcastArgs$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const clipByValue$1 = unaryKernelFunc$1(ClipByValue, (xi, attrs) => {
  const clipAttrs = attrs;
  if (xi > clipAttrs.clipValueMax) {
    return clipAttrs.clipValueMax;
  }
  return xi < clipAttrs.clipValueMin ? clipAttrs.clipValueMin : xi;
});
const clipByValueConfig$2 = {
  kernelName: ClipByValue,
  backendName: "cpu",
  kernelFunc: clipByValue$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const complexAbs$1 = (args) => {
  const { x: x2 } = args.inputs;
  const cpuBackend = args.backend;
  const resultValues = new Float32Array(sizeFromShape(x2.shape));
  const complexVals = cpuBackend.data.get(x2.dataId);
  const real2 = complexVals.complexTensorInfos.real;
  const imag2 = complexVals.complexTensorInfos.imag;
  const realVals = cpuBackend.data.get(real2.dataId).values;
  const imagVals = cpuBackend.data.get(imag2.dataId).values;
  for (let i2 = 0; i2 < realVals.length; i2++) {
    const real3 = realVals[i2];
    const imag3 = imagVals[i2];
    resultValues[i2] = Math.hypot(real3, imag3);
  }
  return cpuBackend.makeOutput(resultValues, x2.shape, "float32");
};
const complexAbsConfig$1 = {
  kernelName: ComplexAbs,
  backendName: "cpu",
  kernelFunc: complexAbs$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function imag$1(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  const imag2 = backend2.data.get(input.dataId).complexTensorInfos.imag;
  const imagVal = backend2.data.get(imag2.dataId).values;
  return backend2.makeTensorInfo(imag2.shape, imag2.dtype, imagVal);
}
const imagConfig$1 = {
  kernelName: Imag,
  backendName: "cpu",
  kernelFunc: imag$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function concat$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { axis } = attrs;
  const $axis = parseAxisParam(axis, inputs[0].shape)[0];
  let outShape = computeOutShape$2(inputs.map((t2) => t2.shape), $axis);
  if (sizeFromShape(outShape) === 0) {
    return backend2.makeTensorInfo(outShape, inputs[0].dtype, []);
  }
  const $inputs = inputs.filter((t2) => sizeFromShape(t2.shape) > 0);
  if ($inputs.length === 1) {
    return identity$2({ inputs: { x: $inputs[0] }, backend: backend2 });
  }
  const shapes = $inputs.map((t2) => t2.shape);
  assertParamsConsistent(shapes, $axis);
  if ($inputs[0].dtype === "complex64") {
    const reals = $inputs.map((t2) => real$1({ inputs: { input: t2 }, backend: backend2 }));
    const imags = $inputs.map((t2) => imag$1({ inputs: { input: t2 }, backend: backend2 }));
    const realConcated = concat$2({ inputs: reals, backend: backend2, attrs: { axis: $axis } });
    const imagConcated = concat$2({ inputs: imags, backend: backend2, attrs: { axis: $axis } });
    const result2 = complex$2({ inputs: { real: realConcated, imag: imagConcated }, backend: backend2 });
    reals.forEach((r2) => backend2.disposeIntermediateTensorInfo(r2));
    imags.forEach((i2) => backend2.disposeIntermediateTensorInfo(i2));
    backend2.disposeIntermediateTensorInfo(realConcated);
    backend2.disposeIntermediateTensorInfo(imagConcated);
    return result2;
  }
  const inputs2D = $inputs.map((t2) => {
    const innerSize = sizeFromShape(t2.shape.slice($axis));
    const shape = [-1, innerSize];
    return reshape$2({ inputs: { x: t2 }, backend: backend2, attrs: { shape } });
  });
  const inputsValShapes = inputs2D.map((t2) => {
    return { vals: backend2.data.get(t2.dataId).values, shape: t2.shape };
  });
  outShape = computeOutShape$2(inputs2D.map((t2) => t2.shape), 1);
  const simplyConcat = inputs2D[0].shape[0] === 1;
  const outVals = concatImpl$1(inputsValShapes, outShape, inputs[0].dtype, simplyConcat);
  const finalOutShape = computeOutShape$2($inputs.map((t2) => t2.shape), $axis);
  const outInfo = backend2.makeTensorInfo(finalOutShape, inputs[0].dtype, outVals);
  inputs2D.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return outInfo;
}
const concatConfig$2 = {
  kernelName: Concat,
  backendName: "cpu",
  kernelFunc: concat$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dataFormat, dilations, dimRoundingMode } = attrs;
  assertNotComplex$1([x2, filter2], "conv2d");
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, dilations, pad2, dimRoundingMode, false, $dataFormat);
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const padLeft = convInfo.padInfo.left;
  const padTop = convInfo.padInfo.top;
  const isChannelsLast = convInfo.dataFormat === "channelsLast";
  const y2 = new TensorBuffer(convInfo.outShape, x2.dtype);
  const xStrides = computeStrides(x2.shape);
  const filterStrides = computeStrides(filter2.shape);
  const xBatchStride = xStrides[0];
  const xRowStride = isChannelsLast ? xStrides[1] : xStrides[2];
  const xColStride = isChannelsLast ? xStrides[2] : 1;
  const xChannelStride = isChannelsLast ? 1 : xStrides[1];
  const yBatchStride = y2.strides[0];
  const yRowStride = isChannelsLast ? y2.strides[1] : y2.strides[2];
  const yColStride = isChannelsLast ? y2.strides[2] : 1;
  const yChannelStride = isChannelsLast ? 1 : y2.strides[1];
  const xVals = backend2.data.get(x2.dataId).values;
  const wVals = backend2.data.get(filter2.dataId).values;
  const yVals = y2.values;
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    const xOffset1 = b2 * xBatchStride;
    const yOffset1 = b2 * yBatchStride;
    for (let yR = 0; yR < convInfo.outHeight; ++yR) {
      const yOffset2 = yOffset1 + yR * yRowStride;
      const xRCorner = yR * convInfo.strideHeight - padTop;
      for (let wR = 0; wR < filterHeight; ++wR) {
        const xR = xRCorner + wR * dilationHeight;
        if (xR < 0 || xR >= convInfo.inHeight) {
          continue;
        }
        const wOffset1 = wR * filterStrides[0];
        const xOffset2 = xOffset1 + xR * xRowStride;
        for (let yC = 0; yC < convInfo.outWidth; ++yC) {
          const yOffset3 = yOffset2 + yC * yColStride;
          const xCCorner = yC * convInfo.strideWidth - padLeft;
          for (let wC = 0; wC < filterWidth; ++wC) {
            const xC = xCCorner + wC * dilationWidth;
            if (xC < 0 || xC >= convInfo.inWidth) {
              continue;
            }
            const wOffset2 = wOffset1 + wC * filterStrides[1];
            const xOffset3 = xOffset2 + xC * xColStride;
            let wOffset3 = wOffset2;
            for (let d1 = 0; d1 < convInfo.inChannels; ++d1) {
              const xVal = xVals[xOffset3 + d1 * xChannelStride];
              for (let d2 = 0; d2 < convInfo.outChannels; ++d2) {
                yVals[yOffset3 + d2 * yChannelStride] += xVal * wVals[wOffset3 + d2];
              }
              wOffset3 += convInfo.outChannels;
            }
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(y2.shape, y2.dtype, yVals);
}
const conv2DConfig$2 = {
  kernelName: Conv2D$1,
  backendName: "cpu",
  kernelFunc: conv2D
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2DBackpropFilter$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, dy } = inputs;
  const { strides, pad: pad2, dataFormat, dimRoundingMode, filterShape } = attrs;
  assertNotComplex$1([x2, dy], "conv2dBackpropFilter");
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(x2.shape, filterShape, strides, 1, pad2, dimRoundingMode, false, $dataFormat);
  const { strideHeight, strideWidth, filterHeight, filterWidth } = convInfo;
  const isChannelsLast = convInfo.dataFormat === "channelsLast";
  const dW = new TensorBuffer(convInfo.filterShape, "float32");
  const leftPad = convInfo.padInfo.left;
  const topPad = convInfo.padInfo.top;
  const xVals = backend2.data.get(x2.dataId).values;
  const dyVals = backend2.data.get(dy.dataId).values;
  const xBuf = new TensorBuffer(x2.shape, x2.dtype, xVals);
  const dyBuf = new TensorBuffer(dy.shape, dy.dtype, dyVals);
  for (let wR = 0; wR < filterHeight; ++wR) {
    const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
    const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
    for (let wC = 0; wC < filterWidth; ++wC) {
      const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
      const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
      for (let d1 = 0; d1 < convInfo.inChannels; ++d1) {
        for (let d2 = 0; d2 < convInfo.outChannels; ++d2) {
          let dotProd = 0;
          for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
            for (let yR = yRMin; yR < yRMax; ++yR) {
              const xR = wR + yR * strideHeight - topPad;
              for (let yC = yCMin; yC < yCMax; ++yC) {
                const xC = wC + yC * strideWidth - leftPad;
                if (isChannelsLast) {
                  dotProd += xBuf.get(b2, xR, xC, d1) * dyBuf.get(b2, yR, yC, d2);
                } else {
                  dotProd += xBuf.get(b2, d1, xR, xC) * dyBuf.get(b2, d2, yR, yC);
                }
              }
            }
          }
          dW.set(dotProd, wR, wC, d1, d2);
        }
      }
    }
  }
  return backend2.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const conv2DBackpropFilterConfig$1 = {
  kernelName: Conv2DBackpropFilter,
  backendName: "cpu",
  kernelFunc: conv2DBackpropFilter$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2DBackpropInput$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { inputShape, strides, pad: pad2, dataFormat, dimRoundingMode } = attrs;
  assertNotComplex$1([dy, filter2], "conv2dBackpropInput");
  const filterStrides = computeStrides(filter2.shape);
  const dyStrides = computeStrides(dy.shape);
  let $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(inputShape, filter2.shape, strides, 1, pad2, dimRoundingMode, false, $dataFormat);
  const dx = new TensorBuffer(convInfo.inShape, "float32");
  const dxValues = dx.values;
  const dyValues = backend2.data.get(dy.dataId).values;
  const fltValues = backend2.data.get(filter2.dataId).values;
  const [fltS0, fltS1, fltS2] = filterStrides;
  const { batchSize, filterHeight, filterWidth, inChannels, inHeight, inWidth, outChannels, outHeight, outWidth, strideHeight, strideWidth } = convInfo;
  $dataFormat = convInfo.dataFormat;
  const topPad = filterHeight - 1 - convInfo.padInfo.top;
  const leftPad = filterWidth - 1 - convInfo.padInfo.left;
  const isChannelsLast = $dataFormat === "channelsLast";
  const xBatchStride = dx.strides[0];
  const xRowStride = isChannelsLast ? dx.strides[1] : dx.strides[2];
  const xColStride = isChannelsLast ? dx.strides[2] : 1;
  const xChannelStride = isChannelsLast ? 1 : dx.strides[1];
  const yBatchStride = dyStrides[0];
  const yRowStride = isChannelsLast ? dyStrides[1] : dyStrides[2];
  const yColStride = isChannelsLast ? dyStrides[2] : 1;
  const yChannelStride = isChannelsLast ? 1 : dyStrides[1];
  for (let b2 = 0; b2 < batchSize; ++b2) {
    for (let d1 = 0; d1 < inChannels; ++d1) {
      for (let xR = 0; xR < inHeight; ++xR) {
        const xRCorner = xR - topPad;
        const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
        const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
        for (let xC = 0; xC < inWidth; ++xC) {
          const xCCorner = xC - leftPad;
          const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
          const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
          let dotProd = 0;
          for (let yR = xRMin; yR < yRMax; ++yR) {
            const wR = yR * strideHeight - xRCorner;
            for (let yC = xCMin; yC < yCMax; ++yC) {
              const wC = yC * strideWidth - xCCorner;
              const dyOffset = yBatchStride * b2 + yRowStride * yR + yColStride * yC;
              const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
              for (let d2 = 0; d2 < outChannels; ++d2) {
                const pixel = dyValues[dyOffset + yChannelStride * d2];
                const weight = fltValues[fltOffset + d2];
                dotProd += pixel * weight;
              }
            }
          }
          const dxOffset = xBatchStride * b2 + xRowStride * xR + xColStride * xC + xChannelStride * d1;
          dxValues[dxOffset] = dotProd;
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const conv2DBackpropInputConfig$2 = {
  kernelName: Conv2DBackpropInput,
  backendName: "cpu",
  kernelFunc: conv2DBackpropInput$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3D$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dilations } = attrs;
  assertNotComplex$1([x2, filter2], "conv3d");
  const convInfo = computeConv3DInfo(x2.shape, filter2.shape, strides, dilations, pad2);
  const { filterDepth, filterHeight, filterWidth, dilationDepth, dilationHeight, dilationWidth, padInfo } = convInfo;
  const padFront = padInfo.front;
  const padLeft = padInfo.left;
  const padTop = padInfo.top;
  const y2 = new TensorBuffer(convInfo.outShape, x2.dtype);
  const xVals = backend2.data.get(x2.dataId).values;
  const wVals = backend2.data.get(filter2.dataId).values;
  const yVals = y2.values;
  const xStrides = computeStrides(x2.shape);
  const filterStrides = computeStrides(filter2.shape);
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    const xOffset1 = b2 * xStrides[0];
    const yOffset1 = b2 * y2.strides[0];
    for (let yF = 0; yF < convInfo.outDepth; ++yF) {
      const yOffset2 = yOffset1 + yF * y2.strides[1];
      const xFCorner = yF * convInfo.strideDepth - padFront;
      for (let wF = 0; wF < filterDepth; ++wF) {
        const xF = xFCorner + wF * dilationDepth;
        if (xF < 0 || xF >= convInfo.inDepth) {
          continue;
        }
        const wOffset1 = wF * filterStrides[0];
        const xOffset2 = xOffset1 + xF * xStrides[1];
        for (let yR = 0; yR < convInfo.outHeight; ++yR) {
          const yOffset3 = yOffset2 + yR * y2.strides[2];
          const xRCorner = yR * convInfo.strideHeight - padTop;
          for (let wR = 0; wR < filterHeight; ++wR) {
            const xR = xRCorner + wR * dilationHeight;
            if (xR < 0 || xR >= convInfo.inHeight) {
              continue;
            }
            const wOffset2 = wOffset1 + wR * filterStrides[1];
            const xOffset3 = xOffset2 + xR * xStrides[2];
            for (let yC = 0; yC < convInfo.outWidth; ++yC) {
              const yOffset4 = yOffset3 + yC * convInfo.outChannels;
              const xCCorner = yC * convInfo.strideWidth - padLeft;
              for (let wC = 0; wC < filterWidth; ++wC) {
                const xC = xCCorner + wC * dilationWidth;
                if (xC < 0 || xC >= convInfo.inWidth) {
                  continue;
                }
                const wOffset3 = wOffset2 + wC * filterStrides[2];
                const xOffset4 = xOffset3 + xC * convInfo.inChannels;
                let wOffset4 = wOffset3;
                for (let d1 = 0; d1 < convInfo.inChannels; ++d1) {
                  const xVal = xVals[xOffset4 + d1];
                  for (let d2 = 0; d2 < convInfo.outChannels; ++d2) {
                    yVals[yOffset4 + d2] += xVal * wVals[wOffset4 + d2];
                  }
                  wOffset4 += convInfo.outChannels;
                }
              }
            }
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(y2.shape, y2.dtype, y2.values);
}
const conv3DConfig$1 = {
  kernelName: Conv3D$1,
  backendName: "cpu",
  kernelFunc: conv3D$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3DBackpropFilterV2$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, dy } = inputs;
  const { strides, pad: pad2, filterShape } = attrs;
  assertNotComplex$1([x2, dy], "conv3dBackpropFilterV2");
  const xStrides = computeStrides(x2.shape);
  const dyStrides = computeStrides(dy.shape);
  const convInfo = computeConv3DInfo(x2.shape, filterShape, strides, 1, pad2);
  const strideDepth = convInfo.strideDepth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const filterDepth = convInfo.filterDepth;
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const dw = new TensorBuffer(convInfo.filterShape, "float32");
  const dwValues = dw.values;
  const [dwS0, dwS1, dwS2, dwS3] = dw.strides;
  const dyValues = backend2.data.get(dy.dataId).values;
  const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
  const xValues = backend2.data.get(x2.dataId).values;
  const [xS0, xS1, xS2, xS3] = xStrides;
  const frontPad = convInfo.padInfo.front;
  const leftPad = convInfo.padInfo.left;
  const topPad = convInfo.padInfo.top;
  for (let wF = 0; wF < filterDepth; ++wF) {
    const yFMin = Math.max(0, Math.ceil((frontPad - wF) / strideDepth));
    const yFMax = Math.min(convInfo.outDepth, (convInfo.inDepth + frontPad - wF) / strideDepth);
    const wOffset1 = wF * dwS0;
    for (let wR = 0; wR < filterHeight; ++wR) {
      const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
      const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
      const wOffset2 = wR * dwS1 + wOffset1;
      for (let wC = 0; wC < filterWidth; ++wC) {
        const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
        const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
        const wOffset3 = wC * dwS2 + wOffset2;
        for (let d1 = 0; d1 < convInfo.inChannels; ++d1) {
          const wOffset4 = d1 * dwS3 + wOffset3;
          for (let d2 = 0; d2 < convInfo.outChannels; ++d2) {
            let dotProd = 0;
            for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
              const xOffset1 = b2 * xS0;
              const yOffset1 = b2 * dyS0;
              for (let yF = yFMin; yF < yFMax; ++yF) {
                const xF = wF + yF * strideDepth - frontPad;
                const xOffset2 = xF * xS1 + xOffset1;
                const yOffset2 = yF * dyS1 + yOffset1;
                for (let yR = yRMin; yR < yRMax; ++yR) {
                  const xR = wR + yR * strideHeight - topPad;
                  const xOffset3 = xR * xS2 + xOffset2;
                  const yOffset3 = yR * dyS2 + yOffset2;
                  for (let yC = yCMin; yC < yCMax; ++yC) {
                    const xC = wC + yC * strideWidth - leftPad;
                    const xOffset4 = xC * xS3 + xOffset3;
                    const yOffset4 = yC * dyS3 + yOffset3;
                    dotProd += xValues[xOffset4 + d1] * dyValues[yOffset4 + d2];
                  }
                }
              }
            }
            dwValues[wOffset4 + d2] = dotProd;
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(dw.shape, dw.dtype, dw.values);
}
const conv3DBackpropFilterV2Config$1 = {
  kernelName: Conv3DBackpropFilterV2,
  backendName: "cpu",
  kernelFunc: conv3DBackpropFilterV2$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3DBackpropInputV2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { pad: pad2, strides, inputShape } = attrs;
  assertNotComplex$1([dy], "conv3dBackpropInputV2");
  const dyStrides = computeStrides(dy.shape);
  const filterStrides = computeStrides(filter2.shape);
  const convInfo = computeConv3DInfo(inputShape, filter2.shape, strides, 1, pad2);
  const dx = new TensorBuffer(convInfo.inShape, "float32");
  const dxValues = dx.values;
  const [dxS0, dxS1, dxS2, dxS3] = dx.strides;
  const dyValues = backend2.data.get(dy.dataId).values;
  const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
  const fltValues = backend2.data.get(filter2.dataId).values;
  const [fltS0, fltS1, fltS2, fltS3] = filterStrides;
  const { batchSize, filterDepth, filterHeight, filterWidth, inChannels, inDepth, inHeight, inWidth, outChannels, outDepth, outHeight, outWidth, strideDepth, strideHeight, strideWidth } = convInfo;
  const frontPad = filterDepth - 1 - convInfo.padInfo.front;
  const topPad = filterHeight - 1 - convInfo.padInfo.top;
  const leftPad = filterWidth - 1 - convInfo.padInfo.left;
  for (let b2 = 0; b2 < batchSize; ++b2) {
    for (let d1 = 0; d1 < inChannels; ++d1) {
      for (let xF = 0; xF < inDepth; ++xF) {
        const xFCorner = xF - frontPad;
        const xFMin = Math.max(0, Math.ceil(xFCorner / strideDepth));
        const yFMax = Math.min(outDepth, (filterDepth + xFCorner) / strideDepth);
        for (let xR = 0; xR < inHeight; ++xR) {
          const xRCorner = xR - topPad;
          const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
          const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
          for (let xC = 0; xC < inWidth; ++xC) {
            const xCCorner = xC - leftPad;
            const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
            const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
            let dotProd = 0;
            for (let yF = xFMin; yF < yFMax; ++yF) {
              const wF = yF * strideDepth - xFCorner;
              for (let yR = xRMin; yR < yRMax; ++yR) {
                const wR = yR * strideHeight - xRCorner;
                for (let yC = xCMin; yC < yCMax; ++yC) {
                  const wC = yC * strideWidth - xCCorner;
                  const dyOffset = dyS0 * b2 + dyS1 * yF + dyS2 * yR + dyS3 * yC;
                  const fltOffset = fltS0 * (filterDepth - 1 - wF) + fltS1 * (filterHeight - 1 - wR) + fltS2 * (filterWidth - 1 - wC) + fltS3 * d1;
                  for (let d2 = 0; d2 < outChannels; ++d2) {
                    const pixel = dyValues[dyOffset + d2];
                    const weight = fltValues[fltOffset + d2];
                    dotProd += pixel * weight;
                  }
                }
              }
            }
            dxValues[dxS0 * b2 + dxS1 * xF + dxS2 * xR + dxS3 * xC + d1] = dotProd;
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const conv3DBackpropInputV2Config = {
  kernelName: Conv3DBackpropInputV2,
  backendName: "cpu",
  kernelFunc: conv3DBackpropInputV2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const cos$1 = unaryKernelFunc$1(Cos, (xi) => Math.cos(xi));
const cosConfig$2 = {
  kernelName: Cos,
  backendName: "cpu",
  kernelFunc: cos$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const cosh$1 = unaryKernelFunc$1(Cosh, (xi) => Math.cosh(xi));
const coshConfig$2 = {
  kernelName: Cosh,
  backendName: "cpu",
  kernelFunc: cosh$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cropAndResize$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { image: image2, boxes, boxInd } = inputs;
  const { cropSize, method: method2, extrapolationValue } = attrs;
  const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
  const numBoxes = boxes.shape[0];
  const [cropHeight, cropWidth] = cropSize;
  const output2 = buffer([numBoxes, cropHeight, cropWidth, numChannels], "float32");
  const boxVals = backend2.data.get(boxes.dataId).values;
  const boxIndVals = backend2.data.get(boxInd.dataId).values;
  const imageVals = backend2.data.get(image2.dataId).values;
  const inStride = computeStrides(image2.shape);
  const outStride = computeStrides(output2.shape);
  for (let b2 = 0; b2 < numBoxes; b2++) {
    const startInd = b2 * 4;
    const y1 = boxVals[startInd];
    const x1 = boxVals[startInd + 1];
    const y2 = boxVals[startInd + 2];
    const x2 = boxVals[startInd + 3];
    const bInd = boxIndVals[b2];
    if (bInd >= batch) {
      continue;
    }
    const heightScale = cropHeight > 1 ? (y2 - y1) * (imageHeight - 1) / (cropHeight - 1) : 0;
    const widthScale = cropWidth > 1 ? (x2 - x1) * (imageWidth - 1) / (cropWidth - 1) : 0;
    for (let y3 = 0; y3 < cropHeight; y3++) {
      const yInd = cropHeight > 1 ? y1 * (imageHeight - 1) + y3 * heightScale : 0.5 * (y1 + y2) * (imageHeight - 1);
      if (yInd < 0 || yInd > imageHeight - 1) {
        for (let x3 = 0; x3 < cropWidth; x3++) {
          for (let c2 = 0; c2 < numChannels; c2++) {
            const ind = c2 + x3 * outStride[2] + y3 * outStride[1] + b2 * outStride[0];
            output2.values[ind] = extrapolationValue;
          }
        }
        continue;
      }
      if (method2 === "bilinear") {
        const topInd = Math.floor(yInd);
        const bottomInd = Math.ceil(yInd);
        const yLerp = yInd - topInd;
        for (let x3 = 0; x3 < cropWidth; x3++) {
          const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x3 * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
          if (xInd < 0 || xInd > imageWidth - 1) {
            for (let c2 = 0; c2 < numChannels; c2++) {
              const ind = c2 + x3 * outStride[2] + y3 * outStride[1] + b2 * outStride[0];
              output2.values[ind] = extrapolationValue;
            }
            continue;
          }
          const leftInd = Math.floor(xInd);
          const rightInd = Math.ceil(xInd);
          const xLerp = xInd - leftInd;
          for (let c2 = 0; c2 < numChannels; c2++) {
            let ind = c2 + leftInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
            const topLeft = imageVals[ind];
            ind = c2 + rightInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
            const topRight = imageVals[ind];
            ind = c2 + leftInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
            const bottomLeft = imageVals[ind];
            ind = c2 + rightInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
            const bottomRight = imageVals[ind];
            const top2 = topLeft + (topRight - topLeft) * xLerp;
            const bottom = bottomLeft + (bottomRight - bottomLeft) * xLerp;
            ind = c2 + x3 * outStride[2] + y3 * outStride[1] + b2 * outStride[0];
            output2.values[ind] = top2 + (bottom - top2) * yLerp;
          }
        }
      } else {
        for (let x3 = 0; x3 < cropWidth; ++x3) {
          const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x3 * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
          if (xInd < 0 || xInd > imageWidth - 1) {
            for (let c2 = 0; c2 < numChannels; c2++) {
              const ind = c2 + x3 * outStride[2] + y3 * outStride[1] + b2 * outStride[0];
              output2.values[ind] = extrapolationValue;
            }
            continue;
          }
          const closestX = Math.round(xInd);
          const closestY = Math.round(yInd);
          for (let c2 = 0; c2 < numChannels; c2++) {
            const inInd = c2 + closestX * inStride[2] + closestY * inStride[1] + bInd * inStride[0];
            const outInd = c2 + x3 * outStride[2] + y3 * outStride[1] + b2 * outStride[0];
            output2.values[outInd] = imageVals[inInd];
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(output2.shape, output2.dtype, output2.values);
}
const cropAndResizeConfig$2 = {
  kernelName: CropAndResize,
  backendName: "cpu",
  kernelFunc: cropAndResize$2
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cumprod$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, exclusive, reverse: reverse2 } = attrs;
  assertNotComplex$1(x2, "cumprod");
  const permutation = getAxesPermutation([axis], x2.shape.length);
  let $x = x2;
  if (permutation != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutation } });
  }
  const permutedAxis = getInnerMostAxes(1, x2.shape.length)[0];
  if (permutedAxis !== $x.shape.length - 1) {
    throw new Error(`backend.cumprod in CPU expects an inner-most axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
  }
  const resultDtype = upcastType($x.dtype, "int32");
  const vals = makeOnesTypedArray(sizeFromShape($x.shape), resultDtype);
  const aVals = backend2.data.get($x.dataId).values;
  const finalDim = $x.shape[$x.shape.length - 1];
  const indexAdjuster = reverse2 ? (i2, j2) => i2 + finalDim - j2 - 1 : (i2, j2) => i2 + j2;
  for (let i2 = 0; i2 < aVals.length; i2 += finalDim) {
    for (let j2 = 0; j2 < finalDim; j2++) {
      const idx = indexAdjuster(i2, j2);
      if (j2 === 0) {
        vals[idx] = exclusive ? 1 : aVals[idx];
      } else {
        const prevIdx = indexAdjuster(i2, j2 - 1);
        vals[idx] = exclusive ? aVals[prevIdx] * vals[prevIdx] : aVals[idx] * vals[prevIdx];
      }
    }
  }
  const result2 = backend2.makeTensorInfo($x.shape, resultDtype, vals);
  if (permutation != null) {
    const reversePermutation = getUndoAxesPermutation(permutation);
    const reverseTransposedResult = transpose$2({ inputs: { x: result2 }, backend: backend2, attrs: { perm: reversePermutation } });
    backend2.disposeIntermediateTensorInfo(result2);
    backend2.disposeIntermediateTensorInfo($x);
    return reverseTransposedResult;
  }
  return result2;
}
const cumprodConfig$2 = {
  kernelName: Cumprod,
  backendName: "cpu",
  kernelFunc: cumprod$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cumsum$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, exclusive, reverse: reverse2 } = attrs;
  assertNotComplex$1(x2, "cumsum");
  const permutation = getAxesPermutation([axis], x2.shape.length);
  let $x = x2;
  if (permutation != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutation } });
  }
  const permutedAxis = getInnerMostAxes(1, x2.shape.length)[0];
  if (permutedAxis !== $x.shape.length - 1) {
    throw new Error(`backend.cumsum in CPU expects an inner-most axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
  }
  const resultDtype = upcastType($x.dtype, "int32");
  const vals = makeZerosTypedArray(sizeFromShape($x.shape), resultDtype);
  const aVals = backend2.data.get($x.dataId).values;
  const finalDim = $x.shape[$x.shape.length - 1];
  const indexAdjuster = reverse2 ? (i2, j2) => i2 + finalDim - j2 - 1 : (i2, j2) => i2 + j2;
  for (let i2 = 0; i2 < aVals.length; i2 += finalDim) {
    for (let j2 = 0; j2 < finalDim; j2++) {
      const idx = indexAdjuster(i2, j2);
      if (j2 === 0) {
        vals[idx] = exclusive ? 0 : aVals[idx];
      } else {
        const prevIdx = indexAdjuster(i2, j2 - 1);
        vals[idx] = exclusive ? aVals[prevIdx] + vals[prevIdx] : aVals[idx] + vals[prevIdx];
      }
    }
  }
  const result2 = backend2.makeTensorInfo($x.shape, resultDtype, vals);
  if (permutation != null) {
    const reversePermutation = getUndoAxesPermutation(permutation);
    const reverseTransposedResult = transpose$2({ inputs: { x: result2 }, backend: backend2, attrs: { perm: reversePermutation } });
    backend2.disposeIntermediateTensorInfo(result2);
    backend2.disposeIntermediateTensorInfo($x);
    return reverseTransposedResult;
  }
  return result2;
}
const cumsumConfig$2 = {
  kernelName: Cumsum,
  backendName: "cpu",
  kernelFunc: cumsum$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function denseBincount$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, weights } = inputs;
  const { size, binaryOutput } = attrs;
  if (x2.shape.length === 1) {
    const xVals = backend2.data.get(x2.dataId).values;
    const weightsVals = backend2.data.get(weights.dataId).values;
    const outVals = bincountImpl(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend2.makeTensorInfo([size], weights.dtype, outVals);
  } else if (x2.shape.length === 2) {
    const xBuf = backend2.bufferSync(x2);
    const weightsBuf = backend2.bufferSync(weights);
    const outBuf = bincountReduceImpl(xBuf, weightsBuf, size, binaryOutput);
    return backend2.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
  }
  throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank${x2.shape.length}.`);
}
const denseBincountConfig$1 = {
  kernelName: DenseBincount,
  backendName: "cpu",
  kernelFunc: denseBincount$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthToSpace$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockSize, dataFormat } = attrs;
  assert$1(dataFormat === "NHWC", () => `Only NHWC dataFormat supported on CPU for depthToSpace. Got ${dataFormat}`);
  const batchSize = x2.shape[0];
  const inputHeight = x2.shape[1];
  const inputWidth = x2.shape[2];
  const inputDepth = x2.shape[3];
  const outputHeight = inputHeight * blockSize;
  const outputWidth = inputWidth * blockSize;
  const outputDepth = inputDepth / (blockSize * blockSize);
  const xValues = backend2.data.get(x2.dataId).values;
  const result2 = new Float32Array(batchSize * outputHeight * outputWidth * outputDepth);
  let outputIdx = 0;
  for (let b2 = 0; b2 < batchSize; ++b2) {
    for (let h2 = 0; h2 < outputHeight; ++h2) {
      const inH = Math.floor(h2 / blockSize);
      const offsetH = h2 % blockSize;
      for (let w2 = 0; w2 < outputWidth; ++w2) {
        const inW = Math.floor(w2 / blockSize);
        const offsetW = w2 % blockSize;
        const offsetD = (offsetH * blockSize + offsetW) * outputDepth;
        for (let d2 = 0; d2 < outputDepth; ++d2) {
          const inD = d2 + offsetD;
          const inputIdx = inD + inputDepth * (inW + inputWidth * (inH + inputHeight * b2));
          result2[outputIdx++] = xValues[inputIdx];
        }
      }
    }
  }
  return backend2.makeTensorInfo([batchSize, outputHeight, outputWidth, outputDepth], x2.dtype, result2);
}
const depthToSpaceConfig$2 = {
  kernelName: DepthToSpace,
  backendName: "cpu",
  kernelFunc: depthToSpace$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNative$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dilations, dimRoundingMode } = attrs;
  assertNotComplex$1([x2, filter2], "depthwiseConv2DNative");
  const xStrides = computeStrides(x2.shape);
  const filterStrides = computeStrides(filter2.shape);
  let $dilations = dilations;
  if ($dilations == null) {
    $dilations = [1, 1];
  }
  assert$1(eitherStridesOrDilationsAreOne(strides, $dilations), () => `Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${strides} and dilations '${$dilations}'`);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, $dilations, pad2, dimRoundingMode, true);
  const { filterHeight, filterWidth, dilationHeight, dilationWidth, padInfo } = convInfo;
  const padLeft = padInfo.left;
  const padTop = padInfo.top;
  const chMul = convInfo.outChannels / convInfo.inChannels;
  const y2 = new TensorBuffer(convInfo.outShape, x2.dtype);
  const xVals = backend2.data.get(x2.dataId).values;
  const wVals = backend2.data.get(filter2.dataId).values;
  const yVals = y2.values;
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    const xOffset1 = b2 * xStrides[0];
    const yOffset1 = b2 * y2.strides[0];
    for (let yR = 0; yR < convInfo.outHeight; ++yR) {
      const yOffset2 = yOffset1 + yR * y2.strides[1];
      const xRCorner = yR * convInfo.strideHeight - padTop;
      for (let wR = 0; wR < filterHeight; ++wR) {
        const xR = xRCorner + wR * dilationHeight;
        if (xR < 0 || xR >= convInfo.inHeight) {
          continue;
        }
        const wOffset1 = wR * filterStrides[0];
        const xOffset2 = xOffset1 + xR * xStrides[1];
        for (let yC = 0; yC < convInfo.outWidth; ++yC) {
          const yOffset3 = yOffset2 + yC * y2.strides[2];
          const xCCorner = yC * convInfo.strideWidth - padLeft;
          for (let wC = 0; wC < filterWidth; ++wC) {
            const xC = xCCorner + wC * dilationWidth;
            if (xC < 0 || xC >= convInfo.inWidth) {
              continue;
            }
            const wOffset2 = wOffset1 + wC * filterStrides[1];
            const xOffset3 = xOffset2 + xC * convInfo.inChannels;
            let yOffset4 = yOffset3;
            let wOffset3 = wOffset2;
            for (let d1 = 0; d1 < convInfo.inChannels; ++d1) {
              const xVal = xVals[xOffset3 + d1];
              for (let q2 = 0; q2 < chMul; ++q2) {
                yVals[yOffset4 + q2] += xVal * wVals[wOffset3 + q2];
              }
              yOffset4 += chMul;
              wOffset3 += chMul;
            }
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(y2.shape, y2.dtype, y2.values);
}
const depthwiseConv2dNativeConfig$2 = {
  kernelName: DepthwiseConv2dNative,
  backendName: "cpu",
  kernelFunc: depthwiseConv2dNative$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNativeBackpropFilter$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, dy } = inputs;
  const { strides, dilations, pad: pad2, dimRoundingMode, filterShape } = attrs;
  assertNotComplex$1([x2, dy], "depthwiseConv2dNativeBackpropFilter");
  const convInfo = computeConv2DInfo(x2.shape, filterShape, strides, dilations, pad2, dimRoundingMode, true);
  const { strideHeight, strideWidth, filterHeight, filterWidth } = convInfo;
  const dW = new TensorBuffer(convInfo.filterShape, "float32");
  const leftPad = convInfo.padInfo.left;
  const topPad = convInfo.padInfo.top;
  const chMul = convInfo.outChannels / convInfo.inChannels;
  const xVals = backend2.data.get(x2.dataId).values;
  const xBuf = new TensorBuffer(x2.shape, x2.dtype, xVals);
  const dyVals = backend2.data.get(dy.dataId).values;
  const dyBuf = new TensorBuffer(dy.shape, dy.dtype, dyVals);
  for (let wR = 0; wR < filterHeight; ++wR) {
    const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
    const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
    for (let wC = 0; wC < filterWidth; ++wC) {
      const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
      const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
      for (let d2 = 0; d2 < convInfo.outChannels; ++d2) {
        const d1 = Math.trunc(d2 / chMul);
        const dm = d2 % chMul;
        let dotProd = 0;
        for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
          for (let yR = yRMin; yR < yRMax; ++yR) {
            const xR = wR + yR * strideHeight - topPad;
            for (let yC = yCMin; yC < yCMax; ++yC) {
              const xC = wC + yC * strideWidth - leftPad;
              dotProd += xBuf.get(b2, xR, xC, d1) * dyBuf.get(b2, yR, yC, d2);
            }
          }
        }
        dW.set(dotProd, wR, wC, d1, dm);
      }
    }
  }
  return backend2.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const depthwiseConv2dNativeBackpropFilterConfig$1 = {
  kernelName: DepthwiseConv2dNativeBackpropFilter,
  backendName: "cpu",
  kernelFunc: depthwiseConv2dNativeBackpropFilter$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNativeBackpropInput$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { strides, dilations, pad: pad2, dimRoundingMode, inputShape } = attrs;
  assertNotComplex$1([dy, filter2], "depthwiseConv2DNativeBackpropInput");
  const dyStrides = computeStrides(dy.shape);
  const filterStrides = computeStrides(filter2.shape);
  const convInfo = computeConv2DInfo(inputShape, filter2.shape, strides, dilations, pad2, dimRoundingMode, true);
  const dx = new TensorBuffer(convInfo.inShape, "float32");
  const dxValues = dx.values;
  const [dxS0, dxS1, dxS2] = dx.strides;
  const dyValues = backend2.data.get(dy.dataId).values;
  const [dyS0, dyS1, dyS2] = dyStrides;
  const fltValues = backend2.data.get(filter2.dataId).values;
  const [fltS0, fltS1, fltS2] = filterStrides;
  const { batchSize, filterHeight, filterWidth, inChannels, inHeight, inWidth, outChannels, outHeight, outWidth, strideHeight, strideWidth } = convInfo;
  const topPad = filterHeight - 1 - convInfo.padInfo.top;
  const leftPad = filterWidth - 1 - convInfo.padInfo.left;
  const chMul = outChannels / inChannels;
  for (let b2 = 0; b2 < batchSize; ++b2) {
    for (let d1 = 0; d1 < inChannels; ++d1) {
      for (let xR = 0; xR < inHeight; ++xR) {
        const xRCorner = xR - topPad;
        const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
        const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
        for (let xC = 0; xC < inWidth; ++xC) {
          const xCCorner = xC - leftPad;
          const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
          const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
          let dotProd = 0;
          for (let yR = xRMin; yR < yRMax; ++yR) {
            const wR = yR * strideHeight - xRCorner;
            for (let yC = xCMin; yC < yCMax; ++yC) {
              const wC = yC * strideWidth - xCCorner;
              const dyOffset = dyS0 * b2 + dyS1 * yR + dyS2 * yC;
              const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
              for (let dm = 0; dm < chMul; ++dm) {
                const d2 = d1 * chMul + dm;
                const pixel = dyValues[dyOffset + d2];
                const weight = fltValues[fltOffset + dm];
                dotProd += pixel * weight;
              }
            }
          }
          dxValues[dxS0 * b2 + dxS1 * xR + dxS2 * xC + d1] = dotProd;
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const depthwiseConv2dNativeBackpropInputConfig$1 = {
  kernelName: DepthwiseConv2dNativeBackpropInput,
  backendName: "cpu",
  kernelFunc: depthwiseConv2dNativeBackpropInput$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function diag$1(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  const xSize = sizeFromShape(x2.shape);
  const xVals = backend2.data.get(x2.dataId).values;
  const outBuf = buffer([xSize, xSize], x2.dtype);
  const vals = outBuf.values;
  for (let i2 = 0; i2 < xVals.length; i2++) {
    vals[i2 * xSize + i2] = xVals[i2];
  }
  const outShape = [...x2.shape, ...x2.shape];
  return backend2.makeTensorInfo(outShape, outBuf.dtype, outBuf.values);
}
const diagConfig$1 = {
  kernelName: Diag,
  backendName: "cpu",
  kernelFunc: diag$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const dilation2DConfig$1 = {
  kernelName: Dilation2D,
  backendName: "cpu",
  kernelFunc: ({ inputs, backend: backend2, attrs }) => {
    const { x: x2, filter: filter2 } = inputs;
    const { strides, pad: pad2, dilations } = attrs;
    const cpuBackend = backend2;
    const xVals = cpuBackend.data.get(x2.dataId).values;
    const xRank = x2.shape.length;
    const filterVals = cpuBackend.data.get(filter2.dataId).values;
    const filterRank = filter2.shape.length;
    const { batchSize, inHeight, inWidth, inChannels, outHeight, outWidth, padInfo, strideHeight, strideWidth, filterHeight, filterWidth, dilationHeight, dilationWidth, outShape } = computeDilation2DInfo(x2.shape, filter2.shape, strides, pad2, "NHWC", dilations);
    const outSize = sizeFromShape(outShape);
    const outRank = outShape.length;
    const outputVals = getArrayFromDType(x2.dtype, outSize);
    for (let b2 = 0; b2 < batchSize; ++b2) {
      for (let hOut = 0; hOut < outHeight; ++hOut) {
        const hBeg = hOut * strideHeight - padInfo.top;
        for (let wOut = 0; wOut < outWidth; ++wOut) {
          const wBeg = wOut * strideWidth - padInfo.left;
          for (let d2 = 0; d2 < inChannels; ++d2) {
            let curVal = Number.MIN_SAFE_INTEGER;
            for (let h2 = 0; h2 < filterHeight; ++h2) {
              const hIn = hBeg + h2 * dilationHeight;
              if (hIn >= 0 && hIn < inHeight) {
                for (let w2 = 0; w2 < filterWidth; ++w2) {
                  const wIn = wBeg + w2 * dilationWidth;
                  if (wIn >= 0 && wIn < inWidth) {
                    const xIndex = locToIndex([b2, hIn, wIn, d2], xRank, computeStrides(x2.shape));
                    const filterIndex = locToIndex([h2, w2, d2], filterRank, computeStrides(filter2.shape));
                    const val = xVals[xIndex] + filterVals[filterIndex];
                    if (val > curVal) {
                      curVal = val;
                    }
                  }
                }
              }
            }
            const outputIndex = locToIndex([b2, hOut, wOut, d2], outRank, computeStrides(outShape));
            outputVals[outputIndex] = curVal;
          }
        }
      }
    }
    const dataId = cpuBackend.write(toTypedArray(outputVals, x2.dtype), outShape, x2.dtype);
    return { dataId, shape: outShape, dtype: x2.dtype };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const dilation2DBackpropFilterConfig = {
  kernelName: Dilation2DBackpropFilter,
  backendName: "cpu",
  kernelFunc: ({ inputs, backend: backend2, attrs }) => {
    const { x: x2, filter: filter2, dy } = inputs;
    const { strides, pad: pad2, dilations } = attrs;
    const cpuBackend = backend2;
    const $x = toNestedArray(x2.shape, cpuBackend.data.get(x2.dataId).values);
    const $filter = toNestedArray(filter2.shape, cpuBackend.data.get(filter2.dataId).values);
    const { batchSize, inHeight, inWidth, inChannels, outHeight, outWidth, padInfo, strideHeight, strideWidth, filterHeight, filterWidth, dilationHeight, dilationWidth, outShape } = computeDilation2DInfo(x2.shape, filter2.shape, strides, pad2, "NHWC", dilations);
    assert$1(dy.rank === outShape.length, () => `Error in ${Dilation2DBackpropFilter}, dy must have the same rank as output ${outShape.length}, but got ${dy.rank}`);
    const $dy = toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
    const gradients = makeZerosNestedTypedArray(filter2.shape, filter2.dtype);
    for (let b2 = 0; b2 < batchSize; ++b2) {
      for (let hOut = 0; hOut < outHeight; ++hOut) {
        const hBeg = hOut * strideHeight - padInfo.top;
        for (let wOut = 0; wOut < outWidth; ++wOut) {
          const wBeg = wOut * strideWidth - padInfo.left;
          for (let d2 = 0; d2 < inChannels; ++d2) {
            let curVal = Number.MIN_SAFE_INTEGER;
            let hMax = 0;
            let wMax = 0;
            for (let h2 = 0; h2 < filterHeight; ++h2) {
              const hIn = hBeg + h2 * dilationHeight;
              if (hIn >= 0 && hIn < inHeight) {
                for (let w2 = 0; w2 < filterWidth; ++w2) {
                  const wIn = wBeg + w2 * dilationWidth;
                  if (wIn >= 0 && wIn < inWidth) {
                    const val = $x[b2][hIn][wIn][d2] + $filter[h2][w2][d2];
                    if (val > curVal) {
                      curVal = val;
                      hMax = h2;
                      wMax = w2;
                    }
                  }
                }
              }
            }
            gradients[hMax][wMax][d2] += $dy[b2][hOut][wOut][d2];
          }
        }
      }
    }
    const dataId = cpuBackend.write(toTypedArray(gradients, x2.dtype), filter2.shape, filter2.dtype);
    return { dataId, shape: filter2.shape, dtype: filter2.dtype };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const dilation2DBackpropInputConfig = {
  kernelName: Dilation2DBackpropInput,
  backendName: "cpu",
  kernelFunc: ({ inputs, backend: backend2, attrs }) => {
    const { x: x2, filter: filter2, dy } = inputs;
    const { strides, pad: pad2, dilations } = attrs;
    const cpuBackend = backend2;
    const $x = toNestedArray(x2.shape, cpuBackend.data.get(x2.dataId).values);
    const $filter = toNestedArray(filter2.shape, cpuBackend.data.get(filter2.dataId).values);
    const { batchSize, inHeight, inWidth, inChannels, outHeight, outWidth, padInfo, strideHeight, strideWidth, filterHeight, filterWidth, dilationHeight, dilationWidth, outShape } = computeDilation2DInfo(x2.shape, filter2.shape, strides, pad2, "NHWC", dilations);
    assert$1(dy.rank === outShape.length, () => `Error in ${Dilation2DBackpropInput}, dy must have the same rank as output ${outShape.length}, but got ${dy.rank}`);
    const $dy = toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
    const gradients = makeZerosNestedTypedArray(x2.shape, x2.dtype);
    for (let b2 = 0; b2 < batchSize; ++b2) {
      for (let hOut = 0; hOut < outHeight; ++hOut) {
        const hBeg = hOut * strideHeight - padInfo.top;
        for (let wOut = 0; wOut < outWidth; ++wOut) {
          const wBeg = wOut * strideWidth - padInfo.left;
          for (let d2 = 0; d2 < inChannels; ++d2) {
            let curVal = Number.MIN_SAFE_INTEGER;
            let hInMax = hBeg < 0 ? 0 : hBeg;
            let wInMax = wBeg < 0 ? 0 : wBeg;
            for (let h2 = 0; h2 < filterHeight; ++h2) {
              const hIn = hBeg + h2 * dilationHeight;
              if (hIn >= 0 && hIn < inHeight) {
                for (let w2 = 0; w2 < filterWidth; ++w2) {
                  const wIn = wBeg + w2 * dilationWidth;
                  if (wIn >= 0 && wIn < inWidth) {
                    const val = $x[b2][hIn][wIn][d2] + $filter[h2][w2][d2];
                    if (val > curVal) {
                      curVal = val;
                      hInMax = hIn;
                      wInMax = wIn;
                    }
                  }
                }
              }
            }
            gradients[b2][hInMax][wInMax][d2] += $dy[b2][hOut][wOut][d2];
          }
        }
      }
    }
    const dataId = cpuBackend.write(toTypedArray(gradients, x2.dtype), x2.shape, x2.dtype);
    return { dataId, shape: x2.shape, dtype: x2.dtype };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sum$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  assertNotComplex$1(x2, "sum");
  let $x;
  if (x2.dtype === "bool") {
    $x = cast$2({ inputs: { x: x2 }, backend: backend2, attrs: { dtype: "int32" } });
  } else {
    $x = identity$2({ inputs: { x: x2 }, backend: backend2 });
  }
  const xRank = $x.shape.length;
  const axes = parseAxisParam(axis, $x.shape);
  const permutation = getAxesPermutation(axes, xRank);
  let reductionAxes = axes;
  let permutedX = $x;
  if (permutation != null) {
    permutedX = transpose$2({ inputs: { x: $x }, backend: backend2, attrs: { perm: permutation } });
    reductionAxes = getInnerMostAxes(reductionAxes.length, xRank);
  }
  assertAxesAreInnerMostDims("sum", reductionAxes, permutedX.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes(permutedX.shape, reductionAxes);
  const resultDtype = upcastType(permutedX.dtype, "int32");
  let result2 = zeros(backend2, outShape, resultDtype);
  const reduceSize = sizeFromShape(reduceShape);
  const vals = backend2.data.get(result2.dataId).values;
  const aVals = backend2.data.get(permutedX.dataId).values;
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let sum2 = 0;
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      sum2 += aVals[offset + j2];
    }
    vals[i2] = sum2;
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(result2.shape, axes);
    const oldResult = result2;
    result2 = reshape$2({ inputs: { x: result2 }, backend: backend2, attrs: { shape: newShape } });
    backend2.disposeIntermediateTensorInfo(oldResult);
  }
  backend2.disposeIntermediateTensorInfo($x);
  if (permutation != null) {
    backend2.disposeIntermediateTensorInfo(permutedX);
  }
  return result2;
}
const sumConfig$2 = {
  kernelName: Sum,
  backendName: "cpu",
  kernelFunc: sum$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function einsum$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { equation } = attrs;
  const tensors = inputs;
  const { allDims, summedDims, idDims } = decodeEinsumEquation(equation, tensors.length);
  checkEinsumDimSizes(allDims.length, idDims, tensors);
  const { path: path2, steps: steps2 } = getEinsumComputePath(summedDims, idDims);
  const nSteps = steps2.length;
  let out = null;
  let numDimsRemaining = allDims.length;
  const tensorsToDispose = [];
  for (let i2 = 0; i2 < nSteps; ++i2) {
    for (const idTerm of steps2[i2]) {
      const { permutationIndices: perm, expandDims: dimsToExpand } = getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
      let x2;
      if (isIdentityPermutation(perm)) {
        x2 = tensors[idTerm];
      } else {
        x2 = transpose$2({ inputs: { x: tensors[idTerm] }, backend: backend2, attrs: { perm } });
        tensorsToDispose.push(x2);
      }
      const targetShape = x2.shape.slice();
      for (let k3 = 0; k3 < dimsToExpand.length; ++k3) {
        targetShape.splice(dimsToExpand[k3], 0, 1);
      }
      if (!arraysEqual(x2.shape, targetShape)) {
        x2 = reshape$2({ inputs: { x: x2 }, backend: backend2, attrs: { shape: targetShape } });
        tensorsToDispose.push(x2);
      }
      if (out === null) {
        out = x2;
      } else {
        out = multiply$1({ inputs: { a: x2, b: out }, backend: backend2 });
        tensorsToDispose.push(out);
      }
    }
    if (i2 < nSteps - 1) {
      if (path2[i2] >= 0) {
        out = sum$2({
          inputs: { x: out },
          backend: backend2,
          attrs: {
            axis: path2[i2] - (allDims.length - numDimsRemaining),
            keepDims: false
          }
        });
        tensorsToDispose.push(out);
      }
      numDimsRemaining--;
    }
  }
  for (const tensorInfo of tensorsToDispose) {
    if (tensorInfo === out) {
      continue;
    }
    backend2.disposeIntermediateTensorInfo(tensorInfo);
  }
  return out;
}
const einsumConfig$1 = {
  kernelName: Einsum,
  backendName: "cpu",
  kernelFunc: einsum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function eluGrad$1(args) {
  const { inputs, backend: backend2 } = args;
  const { dy, y: y2 } = inputs;
  assertNotComplex$1([dy, y2], "eluGrad");
  const resultValues = new Float32Array(sizeFromShape(y2.shape));
  const values = backend2.data.get(y2.dataId).values;
  const dyValues = backend2.data.get(dy.dataId).values;
  for (let i2 = 0; i2 < values.length; ++i2) {
    const v2 = values[i2];
    if (v2 >= 1) {
      resultValues[i2] = dyValues[i2];
    } else {
      resultValues[i2] = dyValues[i2] * (v2 + 1);
    }
  }
  return backend2.makeTensorInfo(y2.shape, "float32", resultValues);
}
const eluGradConfig$1 = {
  kernelName: EluGrad,
  backendName: "cpu",
  kernelFunc: eluGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const p$2 = ERF_P;
const a1 = ERF_A1;
const a2 = ERF_A2;
const a3 = ERF_A3;
const a4 = ERF_A4;
const a5 = ERF_A5;
const erf$1 = unaryKernelFunc$1(Erf, (xi) => {
  const sign2 = Math.sign(xi);
  const v2 = Math.abs(xi);
  const t2 = 1 / (1 + p$2 * v2);
  return sign2 * (1 - ((((a5 * t2 + a4) * t2 + a3) * t2 + a2) * t2 + a1) * t2 * Math.exp(-v2 * v2));
});
const erfConfig$1 = {
  kernelName: Erf,
  backendName: "cpu",
  kernelFunc: erf$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function expandDims$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { input } = inputs;
  const { dim } = attrs;
  const inputRank = input.shape.length;
  const newShape = input.shape.slice();
  let $dim = dim;
  if (dim < 0) {
    assert$1(-(inputRank + 1) <= dim, () => `Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
    $dim = inputRank + dim + 1;
  }
  newShape.splice($dim, 0, 1);
  return reshape$2({ inputs: { x: input }, backend: backend2, attrs: { shape: newShape } });
}
const expandDimsConfig$2 = {
  kernelName: ExpandDims,
  backendName: "cpu",
  kernelFunc: expandDims$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const realDivImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 / b2);
const div = binaryKernelFunc$1(RealDiv, realDivImpl);
const realDivConfig$2 = {
  kernelName: RealDiv,
  backendName: "cpu",
  kernelFunc: div
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fftBatch(input, inverse, cpuBackend) {
  const inputShape = input.shape;
  const batch = inputShape[0];
  const innerDim = inputShape[1];
  const inputVals = cpuBackend.data.get(input.dataId);
  const real2D = inputVals.complexTensorInfos.real;
  const imag2D = inputVals.complexTensorInfos.imag;
  const resultShape = [batch, innerDim];
  const resultSize = sizeFromShape(resultShape);
  const resultReal = getTypedArrayFromDType("float32", resultSize);
  const resultImag = getTypedArrayFromDType("float32", resultSize);
  for (let b2 = 0; b2 < batch; b2++) {
    const r2 = slice$2({
      inputs: { x: real2D },
      backend: cpuBackend,
      attrs: { begin: [b2, 0], size: [1, innerDim] }
    });
    const i2 = slice$2({
      inputs: { x: imag2D },
      backend: cpuBackend,
      attrs: { begin: [b2, 0], size: [1, innerDim] }
    });
    const input2 = complex$2({ inputs: { real: r2, imag: i2 }, backend: cpuBackend });
    const { real: real2, imag: imag2 } = fftImpl$1(input2, inverse, cpuBackend);
    const res = mergeRealAndImagArrays(real2, imag2);
    for (let d2 = 0; d2 < innerDim; d2++) {
      const c2 = getComplexWithIndex(res, d2);
      resultReal[b2 * innerDim + d2] = c2.real;
      resultImag[b2 * innerDim + d2] = c2.imag;
    }
    cpuBackend.disposeIntermediateTensorInfo(r2);
    cpuBackend.disposeIntermediateTensorInfo(i2);
    cpuBackend.disposeIntermediateTensorInfo(input2);
  }
  const $realInfo = cpuBackend.makeTensorInfo(resultShape, "float32", resultReal);
  const $imagInfo = cpuBackend.makeTensorInfo(resultShape, "float32", resultImag);
  const result2 = complex$2({ inputs: { real: $realInfo, imag: $imagInfo }, backend: cpuBackend });
  cpuBackend.disposeIntermediateTensorInfo($realInfo);
  cpuBackend.disposeIntermediateTensorInfo($imagInfo);
  return result2;
}
function fftImpl$1(input, inverse, cpuBackend) {
  const inputSize = sizeFromShape(input.shape);
  const inputVals = cpuBackend.data.get(input.dataId);
  const realVals = cpuBackend.data.get(inputVals.complexTensorInfos.real.dataId).values;
  const imagVals = cpuBackend.data.get(inputVals.complexTensorInfos.imag.dataId).values;
  if (isExponentOf2(inputSize)) {
    const result2 = fftRadix2(realVals, imagVals, inputSize, inverse, cpuBackend);
    const resultShape = [input.shape[0], input.shape[1]];
    if (inverse) {
      const realInfo = cpuBackend.makeTensorInfo(resultShape, "float32", result2.real);
      const imagInfo = cpuBackend.makeTensorInfo(resultShape, "float32", result2.imag);
      const sizeInfo = cpuBackend.makeTensorInfo([], "float32", createScalarValue(inputSize, "float32"));
      const sizeInfoCopy = identity$2({ inputs: { x: sizeInfo }, backend: cpuBackend });
      const divRealInfo = realDivConfig$2.kernelFunc({ inputs: { a: realInfo, b: sizeInfo }, backend: cpuBackend });
      const divImagInfo = realDivConfig$2.kernelFunc({ inputs: { a: imagInfo, b: sizeInfoCopy }, backend: cpuBackend });
      const divRealVals = cpuBackend.data.get(divRealInfo.dataId).values;
      const divImagVals = cpuBackend.data.get(divImagInfo.dataId).values;
      cpuBackend.disposeIntermediateTensorInfo(realInfo);
      cpuBackend.disposeIntermediateTensorInfo(imagInfo);
      cpuBackend.disposeIntermediateTensorInfo(sizeInfo);
      cpuBackend.disposeIntermediateTensorInfo(sizeInfoCopy);
      cpuBackend.disposeIntermediateTensorInfo(divRealInfo);
      cpuBackend.disposeIntermediateTensorInfo(divImagInfo);
      return { real: divRealVals, imag: divImagVals };
    }
    return result2;
  } else {
    const data2 = mergeRealAndImagArrays(realVals, imagVals);
    const rawOutput = fourierTransformByMatmul(data2, inputSize, inverse);
    return splitRealAndImagArrays(rawOutput);
  }
}
function isExponentOf2(size) {
  return (size & size - 1) === 0;
}
function fftRadix2(realVals, imagVals, size, inverse, cpuBackend) {
  if (size === 1) {
    return { real: realVals, imag: imagVals };
  }
  const data2 = mergeRealAndImagArrays(realVals, imagVals);
  const half = size / 2;
  const evenComplex = complexWithEvenIndex(data2);
  const evenRealVals = evenComplex.real;
  const evenImagVals = evenComplex.imag;
  const evenShape = [evenRealVals.length];
  const evenRealInfo = cpuBackend.makeTensorInfo(evenShape, "float32", evenRealVals);
  const evenImagInfo = cpuBackend.makeTensorInfo(evenShape, "float32", evenImagVals);
  const evenTensorInfo = complex$2({ inputs: { real: evenRealInfo, imag: evenImagInfo }, backend: cpuBackend });
  const oddComplex = complexWithOddIndex(data2);
  const oddRealVals = oddComplex.real;
  const oddImagVals = oddComplex.imag;
  const oddShape = [oddRealVals.length];
  const oddRealInfo = cpuBackend.makeTensorInfo(oddShape, "float32", oddRealVals);
  const oddImagInfo = cpuBackend.makeTensorInfo(oddShape, "float32", oddImagVals);
  const oddTensorInfo = complex$2({ inputs: { real: oddRealInfo, imag: oddImagInfo }, backend: cpuBackend });
  const $evenComplex = fftRadix2(evenRealVals, evenImagVals, half, inverse, cpuBackend);
  const $evenRealVals = $evenComplex.real;
  const $evenImagVals = $evenComplex.imag;
  const $evenShape = [$evenRealVals.length];
  const $evenRealInfo = cpuBackend.makeTensorInfo($evenShape, "float32", $evenRealVals);
  const $evenImagInfo = cpuBackend.makeTensorInfo($evenShape, "float32", $evenImagVals);
  const $evenTensorInfo = complex$2({
    inputs: { real: $evenRealInfo, imag: $evenImagInfo },
    backend: cpuBackend
  });
  const $oddComplex = fftRadix2(oddRealVals, oddImagVals, half, inverse, cpuBackend);
  const $oddRealVals = $oddComplex.real;
  const $oddImagVals = $oddComplex.imag;
  const $oddShape = [$oddRealVals.length];
  const $oddRealInfo = cpuBackend.makeTensorInfo($oddShape, "float32", $oddRealVals);
  const $oddImagInfo = cpuBackend.makeTensorInfo($oddShape, "float32", $oddImagVals);
  const $oddTensorInfo = complex$2({ inputs: { real: $oddRealInfo, imag: $oddImagInfo }, backend: cpuBackend });
  const e2 = exponents(size, inverse);
  const eShape = [e2.real.length];
  const eRealInfo = cpuBackend.makeTensorInfo(eShape, "float32", e2.real);
  const eImagInfo = cpuBackend.makeTensorInfo(eShape, "float32", e2.imag);
  const complexInfo = complex$2({ inputs: { real: eRealInfo, imag: eImagInfo }, backend: cpuBackend });
  const exponentInfo = multiply$1({ inputs: { a: complexInfo, b: $oddTensorInfo }, backend: cpuBackend });
  const addPart = add({
    inputs: { a: $evenTensorInfo, b: exponentInfo },
    backend: cpuBackend
  });
  const subPart = sub$1({
    inputs: { a: $evenTensorInfo, b: exponentInfo },
    backend: cpuBackend
  });
  const addPartReal = real$1({ inputs: { input: addPart }, backend: cpuBackend });
  const subPartReal = real$1({ inputs: { input: subPart }, backend: cpuBackend });
  const addPartImag = imag$1({ inputs: { input: addPart }, backend: cpuBackend });
  const subPartImag = imag$1({ inputs: { input: subPart }, backend: cpuBackend });
  const $real = concat$2({
    inputs: [addPartReal, subPartReal],
    backend: cpuBackend,
    attrs: { axis: 0 }
  });
  const $imag = concat$2({
    inputs: [addPartImag, subPartImag],
    backend: cpuBackend,
    attrs: { axis: 0 }
  });
  const $realVals = cpuBackend.data.get($real.dataId).values;
  const $imagVals = cpuBackend.data.get($imag.dataId).values;
  cpuBackend.disposeIntermediateTensorInfo(evenRealInfo);
  cpuBackend.disposeIntermediateTensorInfo(evenImagInfo);
  cpuBackend.disposeIntermediateTensorInfo(evenTensorInfo);
  cpuBackend.disposeIntermediateTensorInfo(oddRealInfo);
  cpuBackend.disposeIntermediateTensorInfo(oddImagInfo);
  cpuBackend.disposeIntermediateTensorInfo(oddTensorInfo);
  cpuBackend.disposeIntermediateTensorInfo($evenRealInfo);
  cpuBackend.disposeIntermediateTensorInfo($evenImagInfo);
  cpuBackend.disposeIntermediateTensorInfo($evenTensorInfo);
  cpuBackend.disposeIntermediateTensorInfo($oddRealInfo);
  cpuBackend.disposeIntermediateTensorInfo($oddImagInfo);
  cpuBackend.disposeIntermediateTensorInfo($oddTensorInfo);
  cpuBackend.disposeIntermediateTensorInfo(eRealInfo);
  cpuBackend.disposeIntermediateTensorInfo(eImagInfo);
  cpuBackend.disposeIntermediateTensorInfo(complexInfo);
  cpuBackend.disposeIntermediateTensorInfo(exponentInfo);
  cpuBackend.disposeIntermediateTensorInfo(addPart);
  cpuBackend.disposeIntermediateTensorInfo(subPart);
  cpuBackend.disposeIntermediateTensorInfo(addPartReal);
  cpuBackend.disposeIntermediateTensorInfo(addPartImag);
  cpuBackend.disposeIntermediateTensorInfo(subPartReal);
  cpuBackend.disposeIntermediateTensorInfo(subPartImag);
  cpuBackend.disposeIntermediateTensorInfo($real);
  cpuBackend.disposeIntermediateTensorInfo($imag);
  return { real: $realVals, imag: $imagVals };
}
function fourierTransformByMatmul(data2, size, inverse) {
  const ret = new Float32Array(size * 2);
  for (let r2 = 0; r2 < size; r2++) {
    let real2 = 0;
    let imag2 = 0;
    for (let c2 = 0; c2 < size; c2++) {
      const e2 = exponent(r2 * c2, size, inverse);
      const term = getComplexWithIndex(data2, c2);
      real2 += term.real * e2.real - term.imag * e2.imag;
      imag2 += term.real * e2.imag + term.imag * e2.real;
    }
    if (inverse) {
      real2 /= size;
      imag2 /= size;
    }
    assignToTypedArray(ret, real2, imag2, r2);
  }
  return ret;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fft$1(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  const inputSize = sizeFromShape(input.shape);
  const innerDimensionSize = input.shape[input.shape.length - 1];
  const batch = inputSize / innerDimensionSize;
  const input2D = reshape$2({
    inputs: { x: input },
    backend: backend2,
    attrs: { shape: [batch, innerDimensionSize] }
  });
  const result2 = fftBatch(input2D, false, backend2);
  const resultReshaped = reshape$2({ inputs: { x: result2 }, backend: backend2, attrs: { shape: input.shape } });
  backend2.disposeIntermediateTensorInfo(input2D);
  backend2.disposeIntermediateTensorInfo(result2);
  return resultReshaped;
}
const fftConfig$1 = {
  kernelName: FFT,
  backendName: "cpu",
  kernelFunc: fft$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fill$2(args) {
  const { backend: backend2, attrs } = args;
  const { shape, value, dtype } = attrs;
  const $dtype = dtype || inferDtype(value);
  const values = getArrayFromDType($dtype, sizeFromShape(shape));
  fillValues(values, value, $dtype);
  return backend2.makeTensorInfo(shape, $dtype, values);
}
const fillConfig$2 = {
  kernelName: Fill,
  backendName: "cpu",
  kernelFunc: fill$2
};
function fillValues(values, value, dtype) {
  if (dtype === "string") {
    values.fill(value);
  } else {
    values.fill(value);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const flipLeftRightConfig$2 = {
  kernelName: FlipLeftRight,
  backendName: "cpu",
  kernelFunc: ({ inputs, attrs, backend: backend2 }) => {
    const { image: image2 } = inputs;
    const cpuBackend = backend2;
    const output2 = getTypedArrayFromDType(image2.dtype, sizeFromShape(image2.shape));
    const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
    const imageVals = cpuBackend.data.get(image2.dataId).values;
    for (let batchIdx = 0; batchIdx < batch; batchIdx++) {
      const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
      for (let row = 0; row < imageHeight; row++) {
        const rowOffset = row * (imageWidth * numChannels);
        for (let col = 0; col < imageWidth; col++) {
          const colOffset = col * numChannels;
          for (let channel = 0; channel < numChannels; channel++) {
            const coordX = Math.round(imageWidth - col - 1);
            const outIdx = batchOffset + rowOffset + colOffset + channel;
            let outputValue = imageVals[outIdx];
            if (coordX >= 0 && coordX < imageWidth) {
              const rotatedColOffset = coordX * numChannels;
              const imageIdx = batchOffset + rowOffset + rotatedColOffset + channel;
              outputValue = imageVals[imageIdx];
            }
            output2[outIdx] = outputValue;
          }
        }
      }
    }
    const dataId = cpuBackend.write(output2, image2.shape, image2.dtype);
    return { dataId, shape: image2.shape, dtype: image2.dtype };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const floorDivImpl = createSimpleBinaryKernelImpl((a6, b2) => Math.floor(a6 / b2));
const floorDiv$1 = binaryKernelFunc$1(FloorDiv, floorDivImpl, null, "int32");
const floorDivConfig$2 = {
  kernelName: FloorDiv,
  backendName: "cpu",
  kernelFunc: floorDiv$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedConv2D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2, bias, preluActivationWeights } = inputs;
  const { strides, pad: pad2, dataFormat, dilations, dimRoundingMode, activation, leakyreluAlpha } = attrs;
  let result2 = conv2D({
    inputs: { x: x2, filter: filter2 },
    backend: backend2,
    attrs: { strides, pad: pad2, dataFormat, dilations, dimRoundingMode }
  });
  if (bias) {
    const resultOld = result2;
    result2 = add({ inputs: { a: result2, b: bias }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(resultOld);
  }
  if (activation) {
    const resultOld = result2;
    result2 = applyActivation(backend2, result2, activation, preluActivationWeights, leakyreluAlpha);
    backend2.disposeIntermediateTensorInfo(resultOld);
  }
  return result2;
}
const fusedConv2DConfig$2 = {
  kernelName: FusedConv2D,
  backendName: "cpu",
  kernelFunc: fusedConv2D
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedDepthwiseConv2D$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2, bias, preluActivationWeights } = inputs;
  const { strides, pad: pad2, dataFormat, dilations, dimRoundingMode, activation, leakyreluAlpha } = attrs;
  let result2 = depthwiseConv2dNative$1({
    inputs: { x: x2, filter: filter2 },
    backend: backend2,
    attrs: { strides, pad: pad2, dataFormat, dilations, dimRoundingMode }
  });
  if (bias) {
    const oldResult = result2;
    result2 = add({ inputs: { a: result2, b: bias }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(oldResult);
  }
  if (activation) {
    const oldResult = result2;
    result2 = applyActivation(backend2, result2, activation, preluActivationWeights, leakyreluAlpha);
    backend2.disposeIntermediateTensorInfo(oldResult);
  }
  return result2;
}
const fusedDepthwiseConv2DConfig$2 = {
  kernelName: FusedDepthwiseConv2D,
  backendName: "cpu",
  kernelFunc: fusedDepthwiseConv2D$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherNd$2(args) {
  const { inputs, backend: backend2 } = args;
  const { params, indices } = inputs;
  const paramsSize = sizeFromShape(params.shape);
  const indicesShape = indices.shape;
  const sliceRank = indicesShape[indicesShape.length - 1];
  const [resultShape, numSlices, sliceSize, strides] = prepareAndValidate(params, indices);
  if (numSlices === 0) {
    return backend2.makeTensorInfo(resultShape, params.dtype, []);
  }
  const indicesData = backend2.data.get(indices.dataId).values;
  const paramsBuf = backend2.bufferSync(params);
  const outBuf = gatherNdImpl(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
  return backend2.makeTensorInfo(resultShape, params.dtype, outBuf.values);
}
const gatherNdConfig$2 = {
  kernelName: GatherNd,
  backendName: "cpu",
  kernelFunc: gatherNd$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherV2$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, indices } = inputs;
  const { axis, batchDims } = attrs;
  assertNotComplex$1([x2, indices], "gatherV2");
  const parsedAxis = parseAxisParam(axis, x2.shape)[0];
  const indicesVals = backend2.data.get(indices.dataId).values;
  const axisDim = x2.shape[parsedAxis];
  for (let i2 = 0; i2 < indicesVals.length; ++i2) {
    const index2 = indicesVals[i2];
    assert$1(index2 <= axisDim - 1 && index2 >= 0, () => `GatherV2: the index value ${index2} is not in [0, ${axisDim - 1}]`);
  }
  let $batchDims = batchDims;
  if (batchDims == null) {
    $batchDims = 0;
  }
  const indicesSize = sizeFromShape(indices.shape);
  const shapeInfo = collectGatherOpShapeInfo(x2, indices, parsedAxis, $batchDims);
  const flattenX = reshape$2({
    inputs: { x: x2 },
    backend: backend2,
    attrs: {
      shape: [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        shapeInfo.dimSize,
        shapeInfo.sliceSize
      ]
    }
  });
  const flattenIndex = reshape$2({
    inputs: { x: indices },
    backend: backend2,
    attrs: { shape: [shapeInfo.batchSize, indicesSize / shapeInfo.batchSize] }
  });
  const flattenOutputShape = [
    shapeInfo.batchSize,
    shapeInfo.outerSize,
    indicesSize / shapeInfo.batchSize,
    shapeInfo.sliceSize
  ];
  const indicesBuf = backend2.bufferSync(flattenIndex);
  const xBuf = backend2.bufferSync(flattenX);
  const outBuf = gatherV2Impl(xBuf, indicesBuf, flattenOutputShape);
  backend2.disposeIntermediateTensorInfo(flattenX);
  backend2.disposeIntermediateTensorInfo(flattenIndex);
  return backend2.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
}
const gatherV2Config$2 = {
  kernelName: GatherV2,
  backendName: "cpu",
  kernelFunc: gatherV2$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function ifft$1(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  const inputSize = sizeFromShape(input.shape);
  const innerDimensionSize = input.shape[input.shape.length - 1];
  const batch = inputSize / innerDimensionSize;
  const input2D = reshape$2({
    inputs: { x: input },
    backend: backend2,
    attrs: { shape: [batch, innerDimensionSize] }
  });
  const result2 = fftBatch(input2D, true, backend2);
  const resultReshaped = reshape$2({ inputs: { x: result2 }, backend: backend2, attrs: { shape: input.shape } });
  backend2.disposeIntermediateTensorInfo(input2D);
  backend2.disposeIntermediateTensorInfo(result2);
  return resultReshaped;
}
const ifftConfig$1 = {
  kernelName: IFFT,
  backendName: "cpu",
  kernelFunc: ifft$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const isFinite$2 = unaryKernelFunc$1(IsFinite, (xi) => Number.isFinite(xi) ? 1 : 0, "bool");
const isFiniteConfig$1 = {
  kernelName: IsFinite,
  backendName: "cpu",
  kernelFunc: isFinite$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const isInf$1 = unaryKernelFunc$1(IsInf, (xi) => Math.abs(xi) === Infinity ? 1 : 0, "bool");
const isInfConfig$1 = {
  kernelName: IsInf,
  backendName: "cpu",
  kernelFunc: isInf$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const isNaN$2 = unaryKernelFunc$1(IsNan, (xi) => Number.isNaN(xi) ? 1 : 0, "bool");
const isNaNConfig$1 = {
  kernelName: IsNan,
  backendName: "cpu",
  kernelFunc: isNaN$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function linSpace$1(args) {
  const { backend: backend2, attrs } = args;
  const { start, stop, num } = attrs;
  const outVals = linSpaceImpl(start, stop, num);
  return backend2.makeTensorInfo([outVals.length], "float32", outVals);
}
const linSpaceConfig$1 = {
  kernelName: LinSpace,
  backendName: "cpu",
  kernelFunc: linSpace$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const log1p$1 = unaryKernelFunc$1(Log1p, (xi) => Math.log1p(xi));
const log1pConfig$1 = {
  kernelName: Log1p,
  backendName: "cpu",
  kernelFunc: log1p$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logicalAndImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 && b2);
const logicalAnd$1 = binaryKernelFunc$1(LogicalAnd, logicalAndImpl, null, "bool");
const logicalAndConfig$2 = {
  kernelName: LogicalAnd,
  backendName: "cpu",
  kernelFunc: logicalAnd$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logicalNot$1 = unaryKernelFunc$1(LogicalNot, (xi) => xi ? 0 : 1, "bool");
const logicalNotConfig$1 = {
  kernelName: LogicalNot,
  backendName: "cpu",
  kernelFunc: logicalNot$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logicalOrImpl = createSimpleBinaryKernelImpl((a6, b2) => a6 || b2);
const logicalOr$1 = binaryKernelFunc$1(LogicalOr, logicalOrImpl, null, "bool");
const logicalOrConfig$1 = {
  kernelName: LogicalOr,
  backendName: "cpu",
  kernelFunc: logicalOr$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function lRN(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { depthRadius, bias, alpha: alpha2, beta } = attrs;
  assertNotComplex$1(x2, "LRN");
  const channels = x2.shape[3];
  const maxD = channels - 1;
  const xValues = backend2.data.get(x2.dataId).values;
  const size = sizeFromShape(x2.shape);
  const result2 = new Float32Array(size);
  function sumAcrossChannels(offset) {
    const currentChannel = offset % channels;
    let beginSumOffset = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
    const endSumOffset = offset - currentChannel + Math.min(currentChannel + depthRadius, maxD);
    let sum2 = 0;
    for (; beginSumOffset <= endSumOffset; beginSumOffset++) {
      const z2 = xValues[beginSumOffset];
      sum2 += z2 * z2;
    }
    return sum2;
  }
  for (let offset = 0; offset < size; offset++) {
    const sum2 = sumAcrossChannels(offset);
    const val = xValues[offset] * Math.pow(bias + alpha2 * sum2, -beta);
    result2[offset] = val;
  }
  return backend2.makeTensorInfo(x2.shape, x2.dtype, result2);
}
const LRNConfig$1 = {
  kernelName: LRN,
  backendName: "cpu",
  kernelFunc: lRN
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function lRNGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, y: y2, dy } = inputs;
  const { depthRadius, bias, alpha: alpha2, beta } = attrs;
  assertNotComplex$1(dy, "LRNGrad");
  const dySize = sizeFromShape(dy.shape);
  const channels = dy.shape[3];
  const dyValues = backend2.data.get(dy.dataId).values;
  const xValues = backend2.data.get(x2.dataId).values;
  const yValues = backend2.data.get(y2.dataId).values;
  const result2 = new Float32Array(dySize);
  const size = dySize;
  for (let offset = 0; offset < size; offset++) {
    const currentChannel = offset % channels;
    const depthBegin = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
    const depthEnd = offset - currentChannel + Math.min(channels, currentChannel + depthRadius + 1);
    let norm2 = 0;
    for (let k3 = depthBegin; k3 < depthEnd; k3++) {
      norm2 += Math.pow(xValues[k3], 2);
    }
    norm2 = alpha2 * norm2 + bias;
    for (let k3 = depthBegin; k3 < depthEnd; k3++) {
      let dyi = -2 * alpha2 * beta * xValues[k3] * yValues[offset] / norm2;
      if (offset === k3) {
        dyi += Math.pow(norm2, -beta);
      }
      dyi *= dyValues[offset];
      result2[k3] += dyi;
    }
  }
  return backend2.makeTensorInfo(dy.shape, x2.dtype, result2);
}
const LRNGradConfig$1 = {
  kernelName: LRNGrad,
  backendName: "cpu",
  kernelFunc: lRNGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function max$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { reductionIndices, keepDims } = attrs;
  const cpuBackend = backend2;
  let xShape = x2.shape;
  const xRank = xShape.length;
  const origAxes = parseAxisParam(reductionIndices, xShape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  let xVals = cpuBackend.data.get(x2.dataId).values;
  if (permutedAxes != null) {
    const newShape = new Array(xRank);
    for (let i2 = 0; i2 < newShape.length; i2++) {
      newShape[i2] = xShape[permutedAxes[i2]];
    }
    xVals = transposeImpl$1(xVals, xShape, x2.dtype, permutedAxes, newShape);
    axes = getInnerMostAxes(axes.length, xRank);
    xShape = newShape;
  }
  assertNotComplex$1(x2, "max");
  assertAxesAreInnerMostDims("max", axes, xRank);
  const [maxOutShape, reduceShape] = computeOutAndReduceShapes(xShape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const result2 = maxImpl$1(xVals, reduceSize, maxOutShape, x2.dtype);
  const dataId = cpuBackend.write(result2, maxOutShape, x2.dtype);
  let outShape = maxOutShape;
  if (keepDims) {
    const newShape = expandShapeToKeepDim(maxOutShape, origAxes);
    outShape = newShape;
  }
  return { dataId, shape: outShape, dtype: x2.dtype };
}
const maxConfig$2 = {
  kernelName: Max,
  backendName: "cpu",
  kernelFunc: max$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  assertNotComplex$1(x2, "maxPool");
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const dilations = 1;
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in maxPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode);
  let res;
  if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && arraysEqual(convInfo.inShape, convInfo.outShape)) {
    res = identity$2({ inputs: { x: x2 }, backend: backend2 });
  } else {
    const xValues = backend2.data.get(x2.dataId).values;
    const strides2 = computeStrides(x2.shape);
    const buffer2 = pool(xValues, x2.shape, x2.dtype, strides2, convInfo, "max");
    res = backend2.makeTensorInfo(convInfo.outShape, x2.dtype, buffer2.values);
  }
  return res;
}
const maxPoolConfig$2 = {
  kernelName: MaxPool,
  backendName: "cpu",
  kernelFunc: maxPool$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool3D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { filterSize, strides, pad: pad2, dimRoundingMode, dataFormat } = attrs;
  assertNotComplex$1(x2, "maxPool3d");
  const convInfo = computePool3DInfo(x2.shape, filterSize, strides, 1, pad2, dimRoundingMode, dataFormat);
  const xValues = backend2.data.get(x2.dataId).values;
  const outBuf = pool3d(xValues, x2.shape, x2.dtype, computeStrides(x2.shape), convInfo, "max");
  return backend2.makeTensorInfo(outBuf.shape, "float32", outBuf.values);
}
const maxPool3DConfig$1 = {
  kernelName: MaxPool3D,
  backendName: "cpu",
  kernelFunc: maxPool3D
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool3DGrad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input } = inputs;
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  assertNotComplex$1([dy, input], "maxPool3DGrad");
  const convInfo = computePool3DInfo(input.shape, filterSize, strides, 1, pad2, dimRoundingMode);
  const inputBuf = backend2.bufferSync(input);
  const maxPosBuf = maxPool3dPositions(inputBuf, convInfo);
  const strideDepth = convInfo.strideDepth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const dilationDepth = convInfo.dilationDepth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterDepth = convInfo.effectiveFilterDepth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
  const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
  const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
  const dx = buffer(input.shape, "float32");
  const dyBuf = backend2.bufferSync(dy);
  for (let batch = 0; batch < convInfo.batchSize; ++batch) {
    for (let channel = 0; channel < convInfo.inChannels; ++channel) {
      for (let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth) {
        for (let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow) {
          for (let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol) {
            const dyDepthCorner = dxDepth - padFront;
            const dyRowCorner = dxRow - padTop;
            const dyColCorner = dxCol - padLeft;
            let dotProd = 0;
            for (let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth) {
              const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
              if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) {
                continue;
              }
              for (let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight) {
                const dyRow = (dyRowCorner + wRow) / strideHeight;
                if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) {
                  continue;
                }
                for (let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth) {
                  const dyCol = (dyColCorner + wCol) / strideWidth;
                  if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) {
                    continue;
                  }
                  const maxPos = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                  const curPos = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterWidth + wCol;
                  const mask = maxPos === curPos ? 1 : 0;
                  if (mask === 0) {
                    continue;
                  }
                  const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                  dotProd += pixel * mask;
                }
              }
            }
            dx.set(dotProd, batch, dxDepth, dxRow, dxCol, channel);
          }
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const maxPool3DGradConfig$1 = {
  kernelName: MaxPool3DGrad,
  backendName: "cpu",
  kernelFunc: maxPool3DGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPoolGrad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input, output: output2 } = inputs;
  const x2 = input;
  assertNotComplex$1([input, output2], "maxPoolGrad");
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, 1, pad2, dimRoundingMode);
  const xValues = backend2.data.get(x2.dataId).values;
  const maxPosBuf = buffer(convInfo.outShape, x2.dtype, maxPoolPositions(xValues, x2.shape, x2.dtype, convInfo).values);
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const effectiveFilterHeight = convInfo.effectiveFilterHeight;
  const effectiveFilterWidth = convInfo.effectiveFilterWidth;
  const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
  const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
  const dx = buffer(x2.shape, "float32");
  const dyData = backend2.data.get(dy.dataId).values;
  const dyBuf = buffer(dy.shape, "float32", dyData);
  for (let b2 = 0; b2 < convInfo.batchSize; ++b2) {
    for (let d2 = 0; d2 < convInfo.inChannels; ++d2) {
      for (let dxR = 0; dxR < convInfo.inHeight; ++dxR) {
        for (let dxC = 0; dxC < convInfo.inWidth; ++dxC) {
          const dyRCorner = dxR - padTop;
          const dyCCorner = dxC - padLeft;
          let dotProd = 0;
          for (let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight) {
            const dyR = (dyRCorner + wR) / strideHeight;
            if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) {
              continue;
            }
            for (let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth) {
              const dyC = (dyCCorner + wC) / strideWidth;
              if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) {
                continue;
              }
              const maxPos = effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(b2, dyR, dyC, d2);
              const curPos = wR * effectiveFilterWidth + wC;
              const mask = maxPos === curPos ? 1 : 0;
              if (mask === 0) {
                continue;
              }
              const pixel = dyBuf.get(b2, dyR, dyC, d2);
              dotProd += pixel * mask;
            }
          }
          dx.set(dotProd, b2, dxR, dxC, d2);
        }
      }
    }
  }
  return backend2.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const maxPoolGradConfig$1 = {
  kernelName: MaxPoolGrad,
  backendName: "cpu",
  kernelFunc: maxPoolGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPoolWithArgmaxImpl$1(xValues, xShape, dtype, includeBatchInIndex, convInfo) {
  const strides = computeStrides(xShape);
  const maxPools = pool(xValues, xShape, dtype, strides, convInfo, "max");
  const maxPositions = maxPoolPositions(xValues, xShape, dtype, convInfo, true, includeBatchInIndex);
  return [maxPools.values, maxPositions.values];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maxPoolWithArgmaxConfig$1 = {
  kernelName: MaxPoolWithArgmax,
  backendName: "cpu",
  kernelFunc: ({ inputs, attrs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    const { filterSize, strides, pad: pad2, includeBatchInIndex } = attrs;
    const cpuBackend = backend2;
    assertNotComplex$1(x2, "MaxPoolWithArgmax");
    const values = cpuBackend.data.get(x2.dataId).values;
    const convInfo = computePool2DInfo(x2.shape, filterSize, strides, [1, 1], pad2);
    const [pooled, indexes] = maxPoolWithArgmaxImpl$1(values, x2.shape, x2.dtype, includeBatchInIndex, convInfo);
    const pooledDataId = cpuBackend.write(pooled, convInfo.outShape, x2.dtype);
    const indexesDataId = cpuBackend.write(indexes, convInfo.outShape, x2.dtype);
    return [
      { dataId: pooledDataId, shape: convInfo.outShape, dtype: x2.dtype },
      { dataId: indexesDataId, shape: convInfo.outShape, dtype: "int32" }
    ];
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mean$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  const axes = parseAxisParam(axis, x2.shape);
  const shapes = computeOutAndReduceShapes(x2.shape, axes);
  const reduceShape = shapes[1];
  const reduceSize = sizeFromShape(reduceShape);
  const toDispose = [];
  const reduceSizeScalar = backend2.makeTensorInfo([], "float32", new Float32Array([reduceSize]));
  toDispose.push(reduceSizeScalar);
  const $x = cast$2({ inputs: { x: x2 }, backend: backend2, attrs: { dtype: "float32" } });
  toDispose.push($x);
  const res = div({ inputs: { a: $x, b: reduceSizeScalar }, backend: backend2 });
  toDispose.push(res);
  const result2 = sum$2({ inputs: { x: res }, backend: backend2, attrs: { axis, keepDims } });
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
}
const meanConfig$2 = {
  kernelName: Mean,
  backendName: "cpu",
  kernelFunc: mean$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function min$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  assertNotComplex$1(x2, "min");
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  if (permutedAxes != null) {
    $x = transpose$2({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, x2.shape.length);
  }
  assertAxesAreInnerMostDims("min", axes, $x.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes($x.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const vals = makeZerosTypedArray(sizeFromShape(outShape), $x.dtype);
  const aVals = backend2.data.get($x.dataId).values;
  for (let i2 = 0; i2 < vals.length; ++i2) {
    const offset = i2 * reduceSize;
    let min2 = aVals[offset];
    for (let j2 = 0; j2 < reduceSize; ++j2) {
      const value = aVals[offset + j2];
      if (Number.isNaN(value) || value < min2) {
        min2 = value;
      }
    }
    vals[i2] = min2;
  }
  if (permutedAxes != null) {
    backend2.disposeIntermediateTensorInfo($x);
  }
  const result2 = backend2.makeTensorInfo(outShape, $x.dtype, vals);
  if (keepDims) {
    const expandedShape = expandShapeToKeepDim(outShape, origAxes);
    const reshapedResult = reshape$2({ inputs: { x: result2 }, backend: backend2, attrs: { shape: expandedShape } });
    backend2.disposeIntermediateTensorInfo(result2);
    return reshapedResult;
  }
  return result2;
}
const minConfig$2 = {
  kernelName: Min,
  backendName: "cpu",
  kernelFunc: min$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function mirrorPad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { paddings, mode: mode2 } = attrs;
  assertNotComplex$1(x2, "mirrorPad");
  const outShape = paddings.map((p2, i2) => p2[0] + x2.shape[i2] + p2[1]);
  const start = paddings.map((p2) => p2[0]);
  const end = paddings.map((p2, i2) => p2[0] + x2.shape[i2]);
  const offset = mode2 === "reflect" ? 0 : 1;
  const xVals = backend2.data.get(x2.dataId).values;
  const xRank = x2.shape.length;
  const xStrides = computeStrides(x2.shape);
  const resultSize = sizeFromShape(outShape);
  const resultRank = outShape.length;
  const resultStrides = computeStrides(outShape);
  const resVals = getTypedArrayFromDType(x2.dtype, resultSize);
  for (let i2 = 0; i2 < resultSize; i2++) {
    let coords2 = indexToLoc(i2, resultRank, resultStrides);
    for (let i3 = 0; i3 < resultRank; i3++) {
      if (coords2[i3] < start[i3]) {
        coords2[i3] = start[i3] * 2 - coords2[i3] - offset;
      } else if (coords2[i3] >= end[i3]) {
        coords2[i3] = (end[i3] - 1) * 2 - coords2[i3] + offset;
      }
    }
    coords2 = coords2.map((c2, i3) => c2 - start[i3]);
    const inIndex = locToIndex(coords2, xRank, xStrides);
    resVals[i2] = xVals[inIndex];
  }
  const outId = backend2.write(resVals, outShape, x2.dtype);
  return { dataId: outId, shape: outShape, dtype: x2.dtype };
}
const mirrorPadConfig$2 = {
  kernelName: MirrorPad,
  backendName: "cpu",
  kernelFunc: mirrorPad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const modImpl = createSimpleBinaryKernelImpl((aValue, bValue) => {
  const rem = aValue % bValue;
  if (aValue < 0 && bValue < 0 || aValue >= 0 && bValue >= 0) {
    return rem;
  } else {
    return (rem + bValue) % bValue;
  }
});
const mod$1 = binaryKernelFunc$1(Mod, modImpl);
const modConfig$1 = {
  kernelName: Mod,
  backendName: "cpu",
  kernelFunc: mod$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function softmax$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { logits } = inputs;
  const { dim } = attrs;
  const logitsRank = logits.shape.length;
  let $dim = dim;
  if ($dim === -1) {
    $dim = logitsRank - 1;
  }
  if ($dim !== logitsRank - 1) {
    throw Error(`Softmax along a non-last dimension is not yet supported. Logits was rank ${logitsRank} and dim was ${$dim}`);
  }
  const axes = parseAxisParam([$dim], logits.shape);
  const maxLogit = max$2({
    inputs: { x: logits },
    backend: backend2,
    attrs: { reductionIndices: axes, keepDims: false }
  });
  const expandedShape = expandShapeToKeepDim(maxLogit.shape, axes);
  const maxLogitReshaped = reshape$2({ inputs: { x: maxLogit }, backend: backend2, attrs: { shape: expandedShape } });
  const a6 = sub$1({ inputs: { a: logits, b: maxLogitReshaped }, backend: backend2 });
  const b2 = exp$1({ inputs: { x: a6 }, backend: backend2 });
  const sumExp = sum$2({ inputs: { x: b2 }, backend: backend2, attrs: { axis: axes, keepDims: false } });
  const sumReshaped = reshape$2({ inputs: { x: sumExp }, backend: backend2, attrs: { shape: expandedShape } });
  const result2 = div({ inputs: { a: b2, b: sumReshaped }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(maxLogit);
  backend2.disposeIntermediateTensorInfo(maxLogitReshaped);
  backend2.disposeIntermediateTensorInfo(a6);
  backend2.disposeIntermediateTensorInfo(b2);
  backend2.disposeIntermediateTensorInfo(sumExp);
  backend2.disposeIntermediateTensorInfo(sumReshaped);
  return result2;
}
const softmaxConfig$2 = {
  kernelName: Softmax$2,
  backendName: "cpu",
  kernelFunc: softmax$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function multinomial$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { logits } = inputs;
  const { numSamples, seed, normalized } = attrs;
  assertNotComplex$1(logits, "multinomial");
  const probabilities = normalized ? logits : softmax$2({ inputs: { logits }, backend: backend2, attrs: { dim: -1 } });
  const batchSize = probabilities.shape[0];
  const numEvents = probabilities.shape[1];
  const probVals = backend2.data.get(probabilities.dataId).values;
  const resShape = [batchSize, numSamples];
  const resVals = makeZerosTypedArray(sizeFromShape(resShape), "int32");
  for (let b2 = 0; b2 < batchSize; ++b2) {
    const offset = b2 * numEvents;
    const cdf = new Float32Array(numEvents - 1);
    cdf[0] = probVals[offset];
    for (let event = 1; event < cdf.length; ++event) {
      cdf[event] = cdf[event - 1] + probVals[offset + event];
    }
    const random = seedrandom.alea(seed.toString());
    const outOffset = b2 * numSamples;
    for (let sampleId = 0; sampleId < numSamples; ++sampleId) {
      const r2 = random();
      resVals[outOffset + sampleId] = cdf.length;
      for (let event = 0; event < cdf.length; event++) {
        if (r2 < cdf[event]) {
          resVals[outOffset + sampleId] = event;
          break;
        }
      }
    }
  }
  if (!normalized) {
    backend2.disposeIntermediateTensorInfo(probabilities);
  }
  return backend2.makeTensorInfo(resShape, "int32", resVals);
}
const multinomialConfig$1 = {
  kernelName: Multinomial,
  backendName: "cpu",
  kernelFunc: multinomial$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const nonMaxSuppressionV3Impl$1 = nonMaxSuppressionV3Impl$2;
function nonMaxSuppressionV3$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { boxes, scores } = inputs;
  const { maxOutputSize, iouThreshold, scoreThreshold } = attrs;
  assertNotComplex$1(boxes, "NonMaxSuppression");
  const boxesVals = backend2.data.get(boxes.dataId).values;
  const scoresVals = backend2.data.get(scores.dataId).values;
  const { selectedIndices } = nonMaxSuppressionV3Impl$1(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
  return backend2.makeTensorInfo([selectedIndices.length], "int32", new Int32Array(selectedIndices));
}
const nonMaxSuppressionV3Config$2 = {
  kernelName: NonMaxSuppressionV3,
  backendName: "cpu",
  kernelFunc: nonMaxSuppressionV3$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const nonMaxSuppressionV4Impl$1 = nonMaxSuppressionV4Impl$2;
function nonMaxSuppressionV4$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { boxes, scores } = inputs;
  const { maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize } = attrs;
  assertNotComplex$1(boxes, "NonMaxSuppressionPadded");
  const boxesVals = backend2.data.get(boxes.dataId).values;
  const scoresVals = backend2.data.get(scores.dataId).values;
  const { selectedIndices, validOutputs } = nonMaxSuppressionV4Impl$1(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
  return [
    backend2.makeTensorInfo([selectedIndices.length], "int32", new Int32Array(selectedIndices)),
    backend2.makeTensorInfo([], "int32", new Int32Array([validOutputs]))
  ];
}
const nonMaxSuppressionV4Config$2 = {
  kernelName: NonMaxSuppressionV4,
  backendName: "cpu",
  kernelFunc: nonMaxSuppressionV4$2
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const nonMaxSuppressionV5Impl$1 = nonMaxSuppressionV5Impl$2;
function nonMaxSuppressionV5$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { boxes, scores } = inputs;
  const { maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma } = attrs;
  assertNotComplex$1(boxes, "NonMaxSuppressionWithScore");
  const boxesVals = backend2.data.get(boxes.dataId).values;
  const scoresVals = backend2.data.get(scores.dataId).values;
  const maxOutputSizeVal = maxOutputSize;
  const iouThresholdVal = iouThreshold;
  const scoreThresholdVal = scoreThreshold;
  const softNmsSigmaVal = softNmsSigma;
  const { selectedIndices, selectedScores } = nonMaxSuppressionV5Impl$1(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
  return [
    backend2.makeTensorInfo([selectedIndices.length], "int32", new Int32Array(selectedIndices)),
    backend2.makeTensorInfo([selectedScores.length], "float32", new Float32Array(selectedScores))
  ];
}
const nonMaxSuppressionV5Config$2 = {
  kernelName: NonMaxSuppressionV5,
  backendName: "cpu",
  kernelFunc: nonMaxSuppressionV5$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function oneHot$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { indices } = inputs;
  const { depth, onValue, offValue } = attrs;
  assertNotComplex$1(indices, "oneHot");
  const indicesSize = sizeFromShape(indices.shape);
  const res = new Float32Array(indicesSize * depth);
  res.fill(offValue);
  const indicesVal = backend2.data.get(indices.dataId).values;
  for (let event = 0; event < indicesSize; ++event) {
    if (indicesVal[event] >= 0 && indicesVal[event] < depth) {
      res[event * depth + indicesVal[event]] = onValue;
    }
  }
  return backend2.makeTensorInfo([...indices.shape, depth], "int32", res);
}
const oneHotConfig$2 = {
  kernelName: OneHot,
  backendName: "cpu",
  kernelFunc: oneHot$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function zerosLike$2(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  if (x2.dtype === "string") {
    throw new Error("zerosLike is not supported for string tensors");
  } else if (x2.dtype === "complex64") {
    const realPart = real$1({ inputs: { input: x2 }, backend: backend2 });
    const r2 = zerosLike$2({ inputs: { x: realPart }, backend: backend2 });
    const imagPart = imag$1({ inputs: { input: x2 }, backend: backend2 });
    const i2 = zerosLike$2({ inputs: { x: imagPart }, backend: backend2 });
    const result2 = complex$2({ inputs: { real: r2, imag: i2 }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(realPart);
    backend2.disposeIntermediateTensorInfo(r2);
    backend2.disposeIntermediateTensorInfo(imagPart);
    backend2.disposeIntermediateTensorInfo(i2);
    return result2;
  } else {
    return fill$2({ backend: backend2, attrs: { shape: x2.shape, value: 0, dtype: x2.dtype } });
  }
}
const zerosLikeConfig$2 = {
  kernelName: ZerosLike,
  backendName: "cpu",
  kernelFunc: zerosLike$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function onesLike$2(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  if (x2.dtype === "string") {
    throw new Error("onesLike is not supported for string tensors");
  } else if (x2.dtype === "complex64") {
    const realPart = real$1({ inputs: { input: x2 }, backend: backend2 });
    const r2 = onesLike$2({ inputs: { x: realPart }, backend: backend2 });
    const imagPart = imag$1({ inputs: { input: x2 }, backend: backend2 });
    const i2 = zerosLike$2({ inputs: { x: imagPart }, backend: backend2 });
    const result2 = complex$2({ inputs: { real: r2, imag: i2 }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(realPart);
    backend2.disposeIntermediateTensorInfo(r2);
    backend2.disposeIntermediateTensorInfo(imagPart);
    backend2.disposeIntermediateTensorInfo(i2);
    return result2;
  } else {
    return fill$2({ backend: backend2, attrs: { shape: x2.shape, value: 1, dtype: x2.dtype } });
  }
}
const onesLikeConfig$2 = {
  kernelName: OnesLike,
  backendName: "cpu",
  kernelFunc: onesLike$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pack$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { axis } = attrs;
  if (inputs.length === 1) {
    return expandDims$2({ inputs: { input: inputs[0] }, backend: backend2, attrs: { dim: axis } });
  }
  const shape = inputs[0].shape;
  const dtype = inputs[0].dtype;
  inputs.forEach((t2) => {
    assertShapesMatch(shape, t2.shape, "All tensors passed to stack must have matching shapes");
    assert$1(dtype === t2.dtype, () => "All tensors passed to stack must have matching dtypes");
  });
  const intermediateTensorInfos = [];
  const expandedTensors = inputs.map((t2) => {
    const expandedT = expandDims$2({ inputs: { input: t2 }, backend: backend2, attrs: { dim: axis } });
    intermediateTensorInfos.push(expandedT);
    return expandedT;
  });
  const result2 = concat$2({ inputs: expandedTensors, backend: backend2, attrs: { axis } });
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
}
const packConfig$2 = {
  kernelName: Pack,
  backendName: "cpu",
  kernelFunc: pack$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function padV2$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { paddings, constantValue } = attrs;
  assertNotComplex$1(x2, "pad");
  const outShape = paddings.map((p2, i2) => p2[0] + x2.shape[i2] + p2[1]);
  const start = paddings.map((p2) => p2[0]);
  const xVals = backend2.data.get(x2.dataId).values;
  const xSize = sizeFromShape(x2.shape);
  const xRank = x2.shape.length;
  const xStrides = computeStrides(x2.shape);
  const resultSize = sizeFromShape(outShape);
  const resultRank = outShape.length;
  const resultStrides = computeStrides(outShape);
  const resVals = getTypedArrayFromDType(x2.dtype, resultSize);
  if (constantValue !== 0) {
    resVals.fill(constantValue);
  }
  for (let i2 = 0; i2 < xSize; i2++) {
    const coords2 = indexToLoc(i2, xRank, xStrides);
    const outCoords = coords2.map((c2, i3) => c2 + start[i3]);
    const outIndex = locToIndex(outCoords, resultRank, resultStrides);
    resVals[outIndex] = xVals[i2];
  }
  const outId = backend2.write(resVals, outShape, x2.dtype);
  return { dataId: outId, shape: outShape, dtype: x2.dtype };
}
const padV2Config$2 = {
  kernelName: PadV2,
  backendName: "cpu",
  kernelFunc: padV2$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const powImpl = createSimpleBinaryKernelImpl((a6, b2) => Math.pow(a6, b2));
const pow$1 = binaryKernelFunc$1(Pow, powImpl);
const powConfig$2 = {
  kernelName: Pow,
  backendName: "cpu",
  kernelFunc: pow$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function range$2(args) {
  const { backend: backend2, attrs } = args;
  const { start, stop, dtype, step: step2 } = attrs;
  const values = rangeImpl(start, stop, step2, dtype);
  return backend2.makeTensorInfo([values.length], dtype, values);
}
const rangeConfig$2 = {
  kernelName: Range,
  backendName: "cpu",
  kernelFunc: range$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const reciprocal$1 = unaryKernelFunc$1(Reciprocal, (xi) => 1 / xi);
const reciprocalConfig$1 = {
  kernelName: Reciprocal,
  backendName: "cpu",
  kernelFunc: reciprocal$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeBilinear$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images } = inputs;
  const { alignCorners, halfPixelCenters, size } = attrs;
  assertNotComplex$1(images, "resizeBilinear");
  const imagesStrides = computeStrides(images.shape);
  const [newHeight, newWidth] = size;
  const [batch, oldHeight, oldWidth, numChannels] = images.shape;
  const xValues = backend2.data.get(images.dataId).values;
  const result2 = new Float32Array(sizeFromShape([batch, newHeight, newWidth, numChannels]));
  const effectiveInputSize = [
    alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
    alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
  ];
  const effectiveOutputSize = [
    alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
    alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
  ];
  let outputIdx = 0;
  const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
  const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
  for (let b2 = 0; b2 < batch; b2++) {
    for (let r2 = 0; r2 < newHeight; r2++) {
      let sourceFracRow;
      if (halfPixelCenters) {
        sourceFracRow = effectiveRowSizeRatio * (r2 + 0.5) - 0.5;
      } else {
        sourceFracRow = effectiveRowSizeRatio * r2;
      }
      const sourceRowFloor = Math.max(0, Math.floor(sourceFracRow));
      const rowFrac = sourceFracRow - sourceRowFloor;
      const sourceRowCeil = Math.min(oldHeight - 1, Math.ceil(sourceFracRow));
      const topRowOffset = b2 * imagesStrides[0] + sourceRowFloor * imagesStrides[1];
      const botRowOffset = b2 * imagesStrides[0] + sourceRowCeil * imagesStrides[1];
      for (let c2 = 0; c2 < newWidth; c2++) {
        let sourceFracCol;
        if (halfPixelCenters) {
          sourceFracCol = effectiveColSizeRatio * (c2 + 0.5) - 0.5;
        } else {
          sourceFracCol = effectiveColSizeRatio * c2;
        }
        const sourceColFloor = Math.max(0, Math.floor(sourceFracCol));
        const colFrac = sourceFracCol - sourceColFloor;
        const sourceColCeil = Math.min(oldWidth - 1, Math.ceil(sourceFracCol));
        const topLeftOffest = topRowOffset + sourceColFloor * imagesStrides[2];
        const botLeftOffset = botRowOffset + sourceColFloor * imagesStrides[2];
        const topRightOffset = topRowOffset + sourceColCeil * imagesStrides[2];
        const botRightOffest = botRowOffset + sourceColCeil * imagesStrides[2];
        for (let d2 = 0; d2 < numChannels; d2++) {
          const topLeft = xValues[topLeftOffest + d2];
          const bottomLeft = xValues[botLeftOffset + d2];
          const topRight = xValues[topRightOffset + d2];
          const bottomRight = xValues[botRightOffest + d2];
          const top2 = topLeft + (topRight - topLeft) * colFrac;
          const bottom = bottomLeft + (bottomRight - bottomLeft) * colFrac;
          const newValue = top2 + (bottom - top2) * rowFrac;
          result2[outputIdx++] = newValue;
        }
      }
    }
  }
  return backend2.makeTensorInfo([batch, newHeight, newWidth, numChannels], "float32", result2);
}
const resizeBilinearConfig$2 = {
  kernelName: ResizeBilinear,
  backendName: "cpu",
  kernelFunc: resizeBilinear$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeBilinearGrad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images, dy } = inputs;
  const { alignCorners } = attrs;
  assertNotComplex$1([dy, images], "resizeBilinearGrad");
  const imagesStrides = computeStrides(images.shape);
  const [batch, xHeight, xWidth, depth] = images.shape;
  const [, yHeight, yWidth] = dy.shape;
  const output2 = new Float32Array(batch * xHeight * xWidth * depth);
  const effectiveXSize = [
    alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
    alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
  ];
  const effectiveYSize = [
    alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
    alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
  ];
  const heightScale = effectiveXSize[0] / effectiveYSize[0];
  const widthScale = effectiveXSize[1] / effectiveYSize[1];
  const dyValues = backend2.data.get(dy.dataId).values;
  let offset = 0;
  for (let b2 = 0; b2 < batch; b2++) {
    const bOffset = b2 * imagesStrides[0];
    for (let r2 = 0; r2 < yHeight; r2++) {
      const dxR = r2 * heightScale;
      const topDxRIndex = Math.floor(dxR);
      const bottomDxRIndex = Math.min(Math.ceil(dxR), xHeight - 1);
      const topDxROffset = bOffset + topDxRIndex * imagesStrides[1];
      const bottomDxROffset = bOffset + bottomDxRIndex * imagesStrides[1];
      const dxRLerp = dxR - topDxRIndex;
      const inverseDxRLerp = 1 - dxRLerp;
      for (let c2 = 0; c2 < yWidth; c2++) {
        const dxC = c2 * widthScale;
        const leftDxCIndex = Math.floor(dxC);
        const rightDxCIndex = Math.min(Math.ceil(dxC), xWidth - 1);
        const dxCLerp = dxC - leftDxCIndex;
        const inverseDxCLerp = 1 - dxCLerp;
        const topLeftRCOffset = topDxROffset + leftDxCIndex * imagesStrides[2];
        const topRightRCOffset = topDxROffset + rightDxCIndex * imagesStrides[2];
        const bottomLeftRCOffset = bottomDxROffset + leftDxCIndex * imagesStrides[2];
        const bottomRightRCOffset = bottomDxROffset + rightDxCIndex * imagesStrides[2];
        const inverseDxRLerpTimesInverseDxCLerp = inverseDxRLerp * inverseDxCLerp;
        const inverseDxRLerpTimesDxCLerp = inverseDxRLerp * dxCLerp;
        const dxRLerpTimesInverseDxCLerp = dxRLerp * inverseDxCLerp;
        const dxRLerpTimesDxCLerp = dxRLerp * dxCLerp;
        for (let d2 = 0; d2 < depth; d2++) {
          const dyVal = dyValues[offset++];
          output2[topLeftRCOffset + d2] += dyVal * inverseDxRLerpTimesInverseDxCLerp;
          output2[topRightRCOffset + d2] += dyVal * inverseDxRLerpTimesDxCLerp;
          output2[bottomLeftRCOffset + d2] += dyVal * dxRLerpTimesInverseDxCLerp;
          output2[bottomRightRCOffset + d2] += dyVal * dxRLerpTimesDxCLerp;
        }
      }
    }
  }
  return backend2.makeTensorInfo([batch, xWidth, xHeight, depth], "float32", output2);
}
const resizeBilinearGradConfig$1 = {
  kernelName: ResizeBilinearGrad,
  backendName: "cpu",
  kernelFunc: resizeBilinearGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeNearestNeighbor$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images } = inputs;
  const { alignCorners, halfPixelCenters, size } = attrs;
  assertNotComplex$1(images, "resizeNearestNeighbor");
  const imagesStrides = computeStrides(images.shape);
  const [newHeight, newWidth] = size;
  const [batch, oldHeight, oldWidth, numChannels] = images.shape;
  const xValues = backend2.data.get(images.dataId).values;
  const output2 = new Float32Array(batch * newHeight * newWidth * numChannels);
  const effectiveInputSize = [
    alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
    alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
  ];
  const effectiveOutputSize = [
    alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
    alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
  ];
  const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
  const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
  let outputOffset = 0;
  for (let b2 = 0; b2 < batch; b2++) {
    const batchOffset = b2 * imagesStrides[0];
    for (let r2 = 0; r2 < newHeight; r2++) {
      const sourceFracRow = halfPixelCenters ? effectiveRowSizeRatio * (r2 + 0.5) : effectiveRowSizeRatio * r2;
      let sourceNearestRow = Math.min(oldHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
      if (halfPixelCenters) {
        sourceNearestRow = Math.max(0, sourceNearestRow);
      }
      const rowOffset = batchOffset + sourceNearestRow * imagesStrides[1];
      for (let c2 = 0; c2 < newWidth; c2++) {
        const sourceFracCol = halfPixelCenters ? effectiveColSizeRatio * (c2 + 0.5) : effectiveColSizeRatio * c2;
        let sourceNearestCol = Math.min(oldWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
        if (halfPixelCenters) {
          sourceNearestCol = Math.max(0, sourceNearestCol);
        }
        const colOffset = rowOffset + sourceNearestCol * imagesStrides[2];
        for (let d2 = 0; d2 < numChannels; d2++) {
          const newVal = xValues[colOffset + d2];
          output2[outputOffset++] = newVal;
        }
      }
    }
  }
  return backend2.makeTensorInfo([batch, newHeight, newWidth, numChannels], images.dtype, output2);
}
const resizeNearestNeighborConfig$1 = {
  kernelName: ResizeNearestNeighbor,
  backendName: "cpu",
  kernelFunc: resizeNearestNeighbor$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeNearestNeighborGrad$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images, dy } = inputs;
  const { alignCorners } = attrs;
  assertNotComplex$1([dy, images], "resizeNearestNeighborGrad");
  const imagesStrides = computeStrides(images.shape);
  const dyStrides = computeStrides(dy.shape);
  const [batch, xHeight, xWidth, depth] = images.shape;
  const [, yHeight, yWidth] = dy.shape;
  const output2 = new Float32Array(batch * xHeight * xWidth * depth);
  const dyValues = backend2.data.get(dy.dataId).values;
  const effectiveXSize = [
    alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
    alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
  ];
  const effectiveYSize = [
    alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
    alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
  ];
  const heightScale = effectiveXSize[0] / effectiveYSize[0];
  const widthScale = effectiveXSize[1] / effectiveYSize[1];
  const invHeightScale = 1 / heightScale;
  const invWidthScale = 1 / widthScale;
  const winHeight = Math.ceil(invHeightScale) * 2 + 2;
  const winWidth = Math.ceil(invWidthScale) * 2 + 2;
  for (let b2 = 0; b2 < batch; b2++) {
    const batchOffset = b2 * imagesStrides[0];
    for (let r2 = 0; r2 < xHeight; r2++) {
      const rowOffset = batchOffset + r2 * imagesStrides[1];
      const startRLerp = Math.floor(r2 * invHeightScale);
      const startDyR = Math.floor(startRLerp - winHeight / 2);
      for (let c2 = 0; c2 < xWidth; c2++) {
        const colOffset = rowOffset + c2 * imagesStrides[2];
        const startCLerp = Math.floor(c2 * invWidthScale);
        const startDyC = Math.floor(startCLerp - winWidth / 2);
        for (let d2 = 0; d2 < depth; d2++) {
          let accum = 0;
          for (let dyRIndex = 0; dyRIndex < winHeight; dyRIndex++) {
            const dyR = dyRIndex + startDyR;
            if (dyR < 0 || dyR >= yHeight) {
              continue;
            }
            const dyROffset = batchOffset + dyR * dyStrides[1];
            const sourceFracRow = dyR * heightScale;
            const sourceNearestRow = Math.min(xHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
            if (r2 !== sourceNearestRow) {
              continue;
            }
            for (let dyCIndex = 0; dyCIndex < winWidth; dyCIndex++) {
              const dyC = dyCIndex + startDyC;
              if (dyC < 0 || dyC >= yWidth) {
                continue;
              }
              const dyCOffset = dyROffset + dyC * dyStrides[2];
              const sourceFracCol = dyC * widthScale;
              const sourceNearestCol = Math.min(xWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
              if (c2 === sourceNearestCol) {
                accum += dyValues[dyCOffset + d2];
              }
            }
          }
          output2[colOffset + d2] = accum;
        }
      }
    }
  }
  return backend2.makeTensorInfo(images.shape, images.dtype, output2);
}
const resizeNearestNeighborGradConfig$1 = {
  kernelName: ResizeNearestNeighborGrad,
  backendName: "cpu",
  kernelFunc: resizeNearestNeighborGrad$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reverse$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { dims } = attrs;
  assertNotComplex$1(x2, "reverse");
  const xRank = x2.shape.length;
  const $dims = parseAxisParam(dims, x2.shape);
  if (xRank === 0) {
    return identity$2({ inputs: { x: x2 }, backend: backend2 });
  }
  const outBuf = new TensorBuffer(x2.shape, x2.dtype);
  const xBuf = backend2.bufferSync(x2);
  for (let i2 = 0; i2 < outBuf.size; i2++) {
    const outLoc = outBuf.indexToLoc(i2);
    const inLoc = outLoc.slice();
    $dims.forEach((d2) => inLoc[d2] = x2.shape[d2] - 1 - inLoc[d2]);
    outBuf.set(xBuf.get(...inLoc), ...outLoc);
  }
  return backend2.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const reverseConfig$2 = {
  kernelName: Reverse,
  backendName: "cpu",
  kernelFunc: reverse$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const rotateWithOffsetConfig$2 = {
  kernelName: RotateWithOffset,
  backendName: "cpu",
  kernelFunc: ({ inputs, attrs, backend: backend2 }) => {
    const { image: image2 } = inputs;
    const { radians, fillValue, center } = attrs;
    const cpuBackend = backend2;
    const output2 = getTypedArrayFromDType(image2.dtype, sizeFromShape(image2.shape));
    const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
    const [centerX, centerY] = getImageCenter(center, imageHeight, imageWidth);
    const fullOpacityValue = 255;
    const sinFactor = Math.sin(radians);
    const cosFactor = Math.cos(radians);
    const imageVals = cpuBackend.data.get(image2.dataId).values;
    for (let batchIdx = 0; batchIdx < batch; batchIdx++) {
      const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
      for (let row = 0; row < imageHeight; row++) {
        const rowOffset = row * (imageWidth * numChannels);
        for (let col = 0; col < imageWidth; col++) {
          const colOffset = col * numChannels;
          for (let channel = 0; channel < numChannels; channel++) {
            const coords2 = [batch, row, col, channel];
            const x2 = coords2[2];
            const y2 = coords2[1];
            let coordX = (x2 - centerX) * cosFactor - (y2 - centerY) * sinFactor;
            let coordY = (x2 - centerX) * sinFactor + (y2 - centerY) * cosFactor;
            coordX = Math.round(coordX + centerX);
            coordY = Math.round(coordY + centerY);
            let outputValue = fillValue;
            if (typeof fillValue !== "number") {
              if (channel === 3) {
                outputValue = fullOpacityValue;
              } else {
                outputValue = fillValue[channel];
              }
            }
            if (coordX >= 0 && coordX < imageWidth && coordY >= 0 && coordY < imageHeight) {
              const rotatedRowOffset = coordY * (imageWidth * numChannels);
              const rotatedColOffset = coordX * numChannels;
              const imageIdx = batchOffset + rotatedRowOffset + rotatedColOffset + channel;
              outputValue = imageVals[imageIdx];
            }
            const outIdx = batchOffset + rowOffset + colOffset + channel;
            output2[outIdx] = outputValue;
          }
        }
      }
    }
    const dataId = cpuBackend.write(output2, image2.shape, image2.dtype);
    return { dataId, shape: image2.shape, dtype: image2.dtype };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const round$1 = unaryKernelFunc$1(Round, (xi) => {
  const base = Math.floor(xi);
  if (xi - base < 0.5) {
    return Math.floor(xi);
  } else if (xi - base > 0.5) {
    return Math.ceil(xi);
  } else {
    if (base % 2 === 0) {
      return base;
    } else {
      return base + 1;
    }
  }
});
const roundConfig$2 = {
  kernelName: Round,
  backendName: "cpu",
  kernelFunc: round$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function scatterImpl(indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices) {
  const flattenShape = [outputSize / sliceSize, sliceSize];
  const indicesData = indices.values;
  const updatesData = updates.values;
  if (outputSize === 0) {
    return buffer(shape, updates.dtype);
  }
  const outBuf = buffer(flattenShape, updates.dtype);
  outBuf.values.fill(defaultValue);
  for (let i2 = 0; i2 < numUpdates; i2++) {
    const index2 = [];
    let flattenIndex = 0;
    for (let j2 = 0; j2 < sliceRank; j2++) {
      const dim = indicesData[i2 * sliceRank + j2];
      index2.push(dim);
      flattenIndex += dim * strides[j2];
    }
    if (flattenIndex < 0 || flattenIndex >= outputSize / sliceSize) {
      throw new Error(`Invalid indices: ${index2} does not index into ${shape}`);
    }
    for (let k3 = 0; k3 < sliceSize; k3++) {
      if (sumDupeIndices) {
        outBuf.values[flattenIndex * sliceSize + k3] += updatesData[i2 * sliceSize + k3];
      } else {
        outBuf.values[flattenIndex * sliceSize + k3] = updates.rank === 0 ? updatesData[0] : updatesData[i2 * sliceSize + k3];
      }
    }
  }
  return outBuf;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function scatterNd$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { indices, updates } = inputs;
  const { shape } = attrs;
  const { sliceRank, numUpdates, sliceSize, strides, outputSize } = calculateShapes(updates, indices, shape);
  const sumDupeIndices = true;
  const indicesBuf = backend2.bufferSync(indices);
  const updatesBuf = backend2.bufferSync(updates);
  const outBuf = scatterImpl(indicesBuf, updatesBuf, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, 0, sumDupeIndices);
  return backend2.makeTensorInfo(shape, outBuf.dtype, outBuf.values);
}
const scatterNdConfig$2 = {
  kernelName: ScatterNd,
  backendName: "cpu",
  kernelFunc: scatterNd$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function select$2(args) {
  const { inputs, backend: backend2 } = args;
  const { condition, t: t2, e: e2 } = inputs;
  assertNotComplex$1([condition, t2, e2], "select");
  const conditionRank = condition.shape.length;
  const values = backend2.data.get(condition.dataId).values;
  const tValues = backend2.data.get(t2.dataId).values;
  const eValues = backend2.data.get(e2.dataId).values;
  const resultDtype = upcastType(t2.dtype, e2.dtype);
  const newValues = makeZerosTypedArray(sizeFromShape(t2.shape), resultDtype);
  let index2 = 0;
  const offset = conditionRank === 0 || conditionRank > 1 || t2.shape.length === 1 ? 1 : sizeFromShape(t2.shape.slice(1));
  for (let i2 = 0; i2 < values.length; i2++) {
    for (let j2 = 0; j2 < offset; j2++) {
      if (values[i2] === 1) {
        newValues[index2++] = tValues[i2];
      } else {
        newValues[index2++] = eValues[i2];
      }
    }
  }
  return backend2.makeTensorInfo(t2.shape, resultDtype, newValues);
}
const selectConfig$2 = {
  kernelName: Select$1,
  backendName: "cpu",
  kernelFunc: select$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const scaleAlpha = SELU_SCALEALPHA;
const scale$1 = SELU_SCALE;
const selu$1 = unaryKernelFunc$1(Selu$1, (xi) => {
  if (xi >= 0) {
    return scale$1 * xi;
  } else {
    return scaleAlpha * (Math.exp(xi) - 1);
  }
});
const seluConfig$1 = {
  kernelName: Selu$1,
  backendName: "cpu",
  kernelFunc: selu$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sign$1 = unaryKernelFunc$1(Sign, (xi) => {
  if (xi < 0) {
    return -1;
  } else if (xi > 0) {
    return 1;
  } else {
    return 0;
  }
});
const signConfig$1 = {
  kernelName: Sign,
  backendName: "cpu",
  kernelFunc: sign$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sin$1 = unaryKernelFunc$1(Sin, (xi) => Math.sin(xi));
const sinConfig$2 = {
  kernelName: Sin,
  backendName: "cpu",
  kernelFunc: sin$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sinh$1 = unaryKernelFunc$1(Sinh, (xi) => Math.sinh(xi));
const sinhConfig$1 = {
  kernelName: Sinh,
  backendName: "cpu",
  kernelFunc: sinh$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const epsilon = 11920928955078125e-23;
const threshold = Math.log(epsilon) + 2;
const softplus$1 = unaryKernelFunc$1(Softplus$1, (xi) => {
  const tooLarge = xi > -threshold;
  const tooSmall = xi < threshold;
  const expX = Math.exp(xi);
  let result2;
  if (tooSmall) {
    result2 = expX;
  } else if (tooLarge) {
    result2 = xi;
  } else {
    result2 = Math.log(1 + expX);
  }
  return result2;
});
const softplusConfig$1 = {
  kernelName: Softplus$1,
  backendName: "cpu",
  kernelFunc: softplus$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function spaceToBatchND$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockShape, paddings } = attrs;
  assertNotComplex$1([x2], "spaceToBatchND");
  const prod2 = sizeFromShape(blockShape);
  const completePaddings = [[0, 0]];
  completePaddings.push(...paddings);
  for (let i2 = 1 + blockShape.length; i2 < x2.shape.length; ++i2) {
    completePaddings.push([0, 0]);
  }
  const paddedX = padV2Config$2.kernelFunc({
    inputs: { x: x2 },
    backend: backend2,
    attrs: { paddings: completePaddings, constantValue: 0 }
  });
  const reshapedPaddedShape = getReshaped(paddedX.shape, blockShape, prod2, false);
  const permutedReshapedPaddedPermutation = getPermuted(reshapedPaddedShape.length, blockShape.length, false);
  const flattenShape = getReshapedPermuted(paddedX.shape, blockShape, prod2, false);
  const reshapeInputs = { x: paddedX };
  const reshapeAttrs = { shape: reshapedPaddedShape };
  const paddedXReshaped = reshape$2({ inputs: reshapeInputs, backend: backend2, attrs: reshapeAttrs });
  const transposeInputs = { x: paddedXReshaped };
  const transposeAttrs = { perm: permutedReshapedPaddedPermutation };
  const paddedXT = transpose$2({ inputs: transposeInputs, backend: backend2, attrs: transposeAttrs });
  const resultReshapeInputs = { x: paddedXT };
  const resultReshapeAttrs = { shape: flattenShape };
  const result2 = reshape$2({ inputs: resultReshapeInputs, backend: backend2, attrs: resultReshapeAttrs });
  backend2.disposeIntermediateTensorInfo(paddedX);
  backend2.disposeIntermediateTensorInfo(paddedXReshaped);
  backend2.disposeIntermediateTensorInfo(paddedXT);
  return result2;
}
const spaceToBatchNDConfig$2 = {
  kernelName: SpaceToBatchND,
  backendName: "cpu",
  kernelFunc: spaceToBatchND$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseFillEmptyRows$2(args) {
  const { inputs, backend: backend2 } = args;
  const { indices, values, denseShape, defaultValue } = inputs;
  if (denseShape.shape.length !== 1) {
    throw new Error(`Dense shape must be a vector, saw:
        ${denseShape.shape}`);
  }
  if (indices.shape.length !== 2) {
    throw new Error(`Indices must be a matrix, saw:
        ${indices.shape}`);
  }
  if (values.shape.length !== 1) {
    throw new Error(`Values must be a vector, saw:
        ${values.shape}`);
  }
  if (defaultValue.shape.length !== 0) {
    throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
  }
  const $indices = backend2.data.get(indices.dataId).values;
  const $values = backend2.data.get(values.dataId).values;
  const $denseShape = backend2.data.get(denseShape.dataId).values;
  const $defaultValue = backend2.data.get(defaultValue.dataId).values[0];
  const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = sparseFillEmptyRowsImpl($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
  return [
    backend2.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
    backend2.makeTensorInfo([outputIndicesShape[0]], values.dtype, outputValues),
    backend2.makeTensorInfo([emptyRowIndicator.length], "bool", new Uint8Array(emptyRowIndicator.map((value) => Number(value)))),
    backend2.makeTensorInfo([reverseIndexMap.length], indices.dtype, new Int32Array(reverseIndexMap))
  ];
}
const sparseFillEmptyRowsConfig$2 = {
  kernelName: SparseFillEmptyRows,
  backendName: "cpu",
  kernelFunc: sparseFillEmptyRows$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseReshape$2(args) {
  const { inputs, backend: backend2 } = args;
  const { inputIndices, inputShape, newShape } = inputs;
  if (inputIndices.shape.length !== 2) {
    throw new Error(`Input indices should be a matrix but received shape
        ${inputIndices.shape}`);
  }
  if (inputShape.shape.length !== 1) {
    throw new Error(`Input shape should be a vector but received shape
        ${inputShape.shape}`);
  }
  if (newShape.shape.length !== 1) {
    throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
  }
  const $inputShape = Array.from(backend2.data.get(inputShape.dataId).values);
  const $inputIndices = backend2.data.get(inputIndices.dataId).values;
  const targetShape = Array.from(backend2.data.get(newShape.dataId).values);
  const [newIndices, indicesShape, outputShape] = sparseReshapeImpl($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
  return [
    backend2.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
    backend2.makeTensorInfo([outputShape.length], newShape.dtype, new Int32Array(outputShape))
  ];
}
const sparseReshapeConfig$2 = {
  kernelName: SparseReshape,
  backendName: "cpu",
  kernelFunc: sparseReshape$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentMean$2(args) {
  const { inputs, backend: backend2 } = args;
  const { data: data2, indices, segmentIds } = inputs;
  if (data2.shape.length < 1) {
    throw new Error(`Data should be at least 1 dimensional but received scalar`);
  }
  if (indices.shape.length !== 1) {
    throw new Error(`Indices should be a vector but received shape
          ${indices.shape}`);
  }
  if (segmentIds.shape.length !== 1) {
    throw new Error(`Segment ids should be a vector but received shape
          ${segmentIds.shape}`);
  }
  if (indices.shape[0] !== segmentIds.shape[0]) {
    throw new Error(`segmentIds and indices should have same size.`);
  }
  const $data = backend2.data.get(data2.dataId).values;
  const $indices = backend2.data.get(indices.dataId).values;
  const $segmentIds = backend2.data.get(segmentIds.dataId).values;
  const [outputData, outputDataShape] = sparseSegmentReductionImpl($data, data2.shape, data2.dtype, $indices, $segmentIds, true);
  return backend2.makeTensorInfo(outputDataShape, data2.dtype, outputData);
}
const sparseSegmentMeanConfig$2 = {
  kernelName: SparseSegmentMean,
  backendName: "cpu",
  kernelFunc: sparseSegmentMean$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentSum$2(args) {
  const { inputs, backend: backend2 } = args;
  const { data: data2, indices, segmentIds } = inputs;
  if (data2.shape.length < 1) {
    throw new Error(`Data should be at least 1 dimensional but received scalar`);
  }
  if (indices.shape.length !== 1) {
    throw new Error(`Indices should be a vector but received shape
         ${indices.shape}`);
  }
  if (segmentIds.shape.length !== 1) {
    throw new Error(`Segment ids should be a vector but received shape
         ${segmentIds.shape}`);
  }
  if (indices.shape[0] !== segmentIds.shape[0]) {
    throw new Error(`segmentIds and indices should have same size.`);
  }
  const $data = backend2.data.get(data2.dataId).values;
  const $indices = backend2.data.get(indices.dataId).values;
  const $segmentIds = backend2.data.get(segmentIds.dataId).values;
  const [outputData, outputDataShape] = sparseSegmentReductionImpl($data, data2.shape, data2.dtype, $indices, $segmentIds);
  return backend2.makeTensorInfo(outputDataShape, data2.dtype, outputData);
}
const sparseSegmentSumConfig$2 = {
  kernelName: SparseSegmentSum,
  backendName: "cpu",
  kernelFunc: sparseSegmentSum$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseToDense$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { sparseIndices, sparseValues, defaultValue } = inputs;
  const { outputShape } = attrs;
  const { sliceRank, numUpdates, sliceSize, strides, outputSize } = calculateShapes(sparseValues, sparseIndices, outputShape);
  const sumDupeIndices = false;
  const indicesBuf = backend2.bufferSync(sparseIndices);
  const updatesBuf = backend2.bufferSync(sparseValues);
  const $defaultValue = backend2.data.get(defaultValue.dataId).values[0];
  const outBuf = scatterImpl(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
  return backend2.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
}
const sparseToDenseConfig$1 = {
  kernelName: SparseToDense,
  backendName: "cpu",
  kernelFunc: sparseToDense$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function splitV$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { numOrSizeSplits, axis } = attrs;
  const $axis = parseAxisParam(axis, x2.shape)[0];
  const splitSizes = prepareSplitSize(x2, numOrSizeSplits, $axis);
  const begin = new Array(x2.shape.length).fill(0);
  const size = x2.shape.slice();
  return splitSizes.map((s2) => {
    const sliceSize = [...size];
    sliceSize[$axis] = s2;
    const sliceT = slice$2({ inputs: { x: x2 }, backend: backend2, attrs: { begin, size: sliceSize } });
    begin[$axis] += s2;
    return sliceT;
  });
}
const splitVConfig$2 = {
  kernelName: SplitV,
  backendName: "cpu",
  kernelFunc: splitV$2
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const squareConfig$2 = {
  kernelName: Square,
  backendName: "cpu",
  kernelFunc: ({ inputs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    const cpuBackend = backend2;
    assertNotComplex$1(x2, "square");
    const values = cpuBackend.data.get(x2.dataId).values;
    const newValues = new Float32Array(values.length);
    for (let i2 = 0; i2 < values.length; ++i2) {
      const value = values[i2];
      newValues[i2] = value * value;
    }
    const dataId = cpuBackend.write(newValues, x2.shape, x2.dtype);
    return { dataId, shape: x2.shape, dtype: x2.dtype };
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const step$2 = unaryKernelFunc$1(Step, (xi, attrs) => {
  const stepAttrs = attrs;
  if (isNaN(xi)) {
    return NaN;
  } else {
    return xi > 0 ? 1 : stepAttrs.alpha;
  }
});
const stepConfig$2 = {
  kernelName: Step,
  backendName: "cpu",
  kernelFunc: step$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stridedSlice$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask } = attrs;
  assertNotComplex$1(x2, "stridedSlice");
  const { finalShapeSparse, finalShape, isIdentity, sliceDim0, isSimpleSlice, begin: $begin, end: $end, strides: $strides } = sliceInfo(x2.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
  let result2;
  if (isIdentity) {
    result2 = reshape$2({ inputs: { x: x2 }, backend: backend2, attrs: { shape: finalShape } });
  } else if (sliceDim0 || isSimpleSlice) {
    assert$1(x2.shape.length >= 1, () => `Input must have rank at least 1, got: ${x2.shape.length}`);
    const size = computeOutShape$3($begin, $end, $strides);
    const sliced = slice$2({ inputs: { x: x2 }, backend: backend2, attrs: { begin: $begin, size } });
    result2 = reshape$2({ inputs: { x: sliced }, backend: backend2, attrs: { shape: finalShape } });
    backend2.disposeIntermediateTensorInfo(sliced);
  } else {
    const xBuf = backend2.bufferSync(x2);
    const outBuf = stridedSliceImpl(finalShapeSparse, xBuf, $strides, $begin);
    result2 = backend2.makeTensorInfo(finalShape, outBuf.dtype, outBuf.values);
  }
  return result2;
}
const stridedSliceConfig$2 = {
  kernelName: StridedSlice,
  backendName: "cpu",
  kernelFunc: stridedSlice$2
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringNGrams$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { separator, nGramWidths, leftPad, rightPad: rightPad2, padWidth, preserveShortSequences } = attrs;
  const { data: data2, dataSplits } = inputs;
  const $data = backend2.data.get(data2.dataId).values;
  const $dataSplits = backend2.data.get(dataSplits.dataId).values;
  const [nGrams, nGramsSplits] = stringNGramsImpl($data, $dataSplits, separator, nGramWidths, leftPad, rightPad2, padWidth, preserveShortSequences);
  return [
    backend2.makeTensorInfo([nGrams.length], "string", nGrams),
    backend2.makeTensorInfo(dataSplits.shape, "int32", nGramsSplits)
  ];
}
const stringNGramsConfig$1 = {
  kernelName: StringNGrams,
  backendName: "cpu",
  kernelFunc: stringNGrams$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringSplit$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { skipEmpty } = attrs;
  const { input, delimiter } = inputs;
  if (input.dtype !== "string") {
    throw new Error("Input must be of datatype string");
  }
  if (input.shape.length !== 1) {
    throw new Error(`Input must be a vector, got shape: ${input.shape}`);
  }
  if (delimiter.shape.length !== 0) {
    throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
  }
  const $input = backend2.data.get(input.dataId).values;
  const $delimiter = backend2.data.get(delimiter.dataId).values[0];
  const [indices, values, shape] = stringSplitImpl($input, $delimiter, skipEmpty);
  const outputSize = values.length;
  return [
    backend2.makeTensorInfo([outputSize, 2], "int32", indices),
    backend2.makeTensorInfo([outputSize], "string", values),
    backend2.makeTensorInfo([2], "int32", new Int32Array(shape))
  ];
}
const stringSplitConfig$1 = {
  kernelName: StringSplit,
  backendName: "cpu",
  kernelFunc: stringSplit$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringToHashBucketFast$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { numBuckets } = attrs;
  const { input } = inputs;
  if (input.dtype !== "string") {
    throw new Error("Input must be of datatype string");
  }
  if (numBuckets <= 0) {
    throw new Error(`Number of buckets must be at least 1`);
  }
  const $input = backend2.data.get(input.dataId).values;
  const output2 = stringToHashBucketFastImpl($input, numBuckets);
  return backend2.makeTensorInfo(input.shape, "int32", output2);
}
const stringToHashBucketFastConfig$1 = {
  kernelName: StringToHashBucketFast,
  backendName: "cpu",
  kernelFunc: stringToHashBucketFast$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tan$1 = unaryKernelFunc$1(Tan, (xi) => Math.tan(xi));
const tanConfig$2 = {
  kernelName: Tan,
  backendName: "cpu",
  kernelFunc: tan$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tanh$1 = unaryKernelFunc$1(Tanh$1, (xi) => Math.tanh(xi));
const tanhConfig$2 = {
  kernelName: Tanh$1,
  backendName: "cpu",
  kernelFunc: tanh$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tile$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { reps } = attrs;
  assertNotComplex$1(x2, "tile");
  const outBuf = tileImpl(backend2.bufferSync(x2), reps);
  return backend2.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const tileConfig$2 = {
  kernelName: Tile,
  backendName: "cpu",
  kernelFunc: tile$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function topK$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { k: k3, sorted } = attrs;
  assertNotComplex$1(x2, "topk");
  const xVals = backend2.data.get(x2.dataId).values;
  const [allTopKVals, allTopKIndices] = topKImpl(xVals, x2.shape, x2.dtype, k3, sorted);
  return [
    backend2.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
    backend2.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
  ];
}
const topKConfig$2 = {
  kernelName: TopK,
  backendName: "cpu",
  kernelFunc: topK$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transform$2(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { image: image2, transforms } = inputs;
  const { interpolation, fillMode, fillValue, outputShape } = attrs;
  const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
  const [outHeight, outWidth] = outputShape != null ? outputShape : [imageHeight, imageWidth];
  const outShape = [batch, outHeight, outWidth, numChannels];
  const strides = computeStrides(image2.shape);
  const batchStride = strides[0];
  const rowStride = strides[1];
  const colStride = strides[2];
  const outVals = getTypedArrayFromDType(image2.dtype, sizeFromShape(outShape));
  outVals.fill(fillValue);
  const imageVals = backend2.data.get(image2.dataId).values;
  const transformVals = backend2.data.get(transforms.dataId).values;
  for (let b2 = 0; b2 < batch; ++b2) {
    const transform2 = transforms.shape[0] === 1 ? transformVals : transformVals.subarray(b2 * 8, b2 * 8 + 8);
    for (let outY = 0; outY < outHeight; ++outY) {
      for (let outX = 0; outX < outWidth; ++outX) {
        for (let channel = 0; channel < numChannels; ++channel) {
          let val;
          const projection = transform2[6] * outX + transform2[7] * outY + 1;
          if (projection === 0) {
            continue;
          }
          const inX = (transform2[0] * outX + transform2[1] * outY + transform2[2]) / projection;
          const inY = (transform2[3] * outX + transform2[4] * outY + transform2[5]) / projection;
          const x2 = mapCoord(inX, imageWidth, fillMode);
          const y2 = mapCoord(inY, imageHeight, fillMode);
          switch (interpolation) {
            case "nearest":
              val = nearestInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, b2, y2, x2, channel, fillValue);
              break;
            case "bilinear":
              val = bilinearInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, b2, y2, x2, channel, fillValue);
              break;
            default:
              throw new Error(`Error in Transform: Expect 'nearest' or 'bilinear', but got ${interpolation}`);
          }
          const ind = b2 * batchStride + outY * rowStride + outX * colStride + channel;
          outVals[ind] = val;
        }
      }
    }
    return backend2.makeTensorInfo(outShape, image2.dtype, outVals);
  }
  const dataId = backend2.write(outVals, outShape, image2.dtype);
  return { dataId, shape: image2.shape, dtype: image2.dtype };
}
const transformConfig$2 = {
  kernelName: Transform,
  backendName: "cpu",
  kernelFunc: transform$2
};
function mapCoord(outCoord, len, mode2) {
  switch (mode2) {
    case "reflect":
      return mapCoordReflect(outCoord, len);
    case "wrap":
      return mapCoordWrap(outCoord, len);
    case "nearest":
      return mapCoordNearest(outCoord, len);
    case "constant":
    default:
      return mapCoordConstant(outCoord);
  }
}
function mapCoordReflect(outCoord, len) {
  let inCoord = outCoord;
  if (inCoord < 0) {
    if (len <= 1) {
      inCoord = 0;
    } else {
      const sz2 = 2 * len;
      if (inCoord < sz2) {
        inCoord = sz2 * Math.trunc(-inCoord / sz2) + inCoord;
      }
      inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1;
    }
  } else if (inCoord > len - 1) {
    if (len <= 1) {
      inCoord = 0;
    } else {
      const sz2 = 2 * len;
      inCoord -= sz2 * Math.trunc(inCoord / sz2);
      if (inCoord >= len) {
        inCoord = sz2 - inCoord - 1;
      }
    }
  }
  return clamp$2(0, inCoord, len - 1);
}
function mapCoordWrap(outCoord, len) {
  let inCoord = outCoord;
  if (inCoord < 0) {
    if (len <= 1) {
      inCoord = 0;
    } else {
      const sz = len - 1;
      inCoord += len * (Math.trunc(-inCoord / sz) + 1);
    }
  } else if (inCoord > len - 1) {
    if (len <= 1) {
      inCoord = 0;
    } else {
      const sz = len - 1;
      inCoord -= len * Math.trunc(inCoord / sz);
    }
  }
  return clamp$2(0, inCoord, len - 1);
}
function mapCoordConstant(outCoord, len) {
  return outCoord;
}
function mapCoordNearest(outCoord, len) {
  return clamp$2(0, outCoord, len - 1);
}
function readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y2, x2, channel, fillValue) {
  const ind = batch * batchStride + y2 * rowStride + x2 * colStride + channel;
  if (0 <= y2 && y2 < imageHeight && 0 <= x2 && x2 < imageWidth) {
    return imageVals[ind];
  } else {
    return fillValue;
  }
}
function nearestInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y2, x2, channel, fillValue) {
  const $y = Math.round(y2);
  const $x = Math.round(x2);
  return readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, $y, $x, channel, fillValue);
}
function bilinearInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y2, x2, channel, fillValue) {
  const yFloor = Math.floor(y2);
  const xFloor = Math.floor(x2);
  const yCeil = yFloor + 1;
  const xCeil = xFloor + 1;
  const valueYFloor = (xCeil - x2) * readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xFloor, channel, fillValue) + (x2 - xFloor) * readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xCeil, channel, fillValue);
  const valueYCeil = (xCeil - x2) * readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xFloor, channel, fillValue) + (x2 - xFloor) * readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xCeil, channel, fillValue);
  return (yCeil - y2) * valueYFloor + (y2 - yFloor) * valueYCeil;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unique$1(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { axis } = attrs;
  const { x: x2 } = inputs;
  assertNotComplex$1(x2, "unique");
  const values = backend2.data.get(x2.dataId).values;
  const { outputValues, outputShape, indices } = uniqueImpl(values, axis, x2.shape, x2.dtype);
  return [
    backend2.makeTensorInfo(outputShape, x2.dtype, outputValues),
    backend2.makeTensorInfo([indices.length], "int32", indices)
  ];
}
const uniqueConfig$1 = {
  kernelName: Unique,
  backendName: "cpu",
  kernelFunc: unique$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unpack$2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { value } = inputs;
  let { axis } = attrs;
  if (axis < 0) {
    axis += value.shape.length;
  }
  const valueRank = value.shape.length;
  const num = value.shape[axis];
  const outShape = new Array(valueRank - 1);
  let outIndex = 0;
  for (let i2 = 0; i2 < valueRank; i2++) {
    if (i2 !== axis) {
      outShape[outIndex++] = value.shape[i2];
    }
  }
  const begin = new Array(valueRank).fill(0);
  const size = value.shape.slice();
  size[axis] = 1;
  const res = new Array(num);
  for (let i2 = 0; i2 < res.length; i2++) {
    begin[axis] = i2;
    const tempRes = slice$2({ inputs: { x: value }, backend: backend2, attrs: { begin, size } });
    res[i2] = reshape$2({ inputs: { x: tempRes }, backend: backend2, attrs: { shape: outShape } });
    backend2.disposeIntermediateTensorInfo(tempRes);
  }
  return res;
}
const unpackConfig$2 = {
  kernelName: Unpack,
  backendName: "cpu",
  kernelFunc: unpack$2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unsortedSegmentSum$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, segmentIds } = inputs;
  const { numSegments } = attrs;
  assertNotComplex$1(x2, "unsortedSegmentSum");
  const xRank = x2.shape.length;
  const segmentIdsRank = segmentIds.shape.length;
  const res = [];
  const intermediates = [];
  const numIters = xRank - segmentIdsRank;
  let $segmentIds = segmentIds;
  for (let i2 = 0; i2 < numIters; ++i2) {
    const expanded = expandDims$2({ inputs: { input: $segmentIds }, backend: backend2, attrs: { dim: i2 + 1 } });
    $segmentIds = expanded;
    intermediates.push(expanded);
  }
  for (let i2 = 0; i2 < numSegments; ++i2) {
    const scalarValue = createScalarValue(i2, "int32");
    const segmentId = backend2.makeTensorInfo([], "int32", scalarValue);
    const mask = equal$1({ inputs: { a: segmentId, b: $segmentIds }, backend: backend2 });
    const maskCasted = cast$2({ inputs: { x: mask }, backend: backend2, attrs: { dtype: "float32" } });
    const mul2 = multiply$1({ inputs: { a: maskCasted, b: x2 }, backend: backend2 });
    const sumTensorInfo = sum$2({ inputs: { x: mul2 }, backend: backend2, attrs: { axis: 0, keepDims: false } });
    res.push(sumTensorInfo);
    intermediates.push(segmentId);
    intermediates.push(mask);
    intermediates.push(maskCasted);
    intermediates.push(mul2);
    intermediates.push(sumTensorInfo);
  }
  const result2 = pack$2({ inputs: res, backend: backend2, attrs: { axis: 0 } });
  intermediates.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
}
const unsortedSegmentSumConfig$1 = {
  kernelName: UnsortedSegmentSum,
  backendName: "cpu",
  kernelFunc: unsortedSegmentSum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const kernelConfigs$2 = [
  _fusedMatMulConfig$2,
  absConfig$2,
  acosConfig$1,
  acoshConfig$1,
  addConfig$2,
  addNConfig$2,
  allConfig$2,
  anyConfig$2,
  argMaxConfig$2,
  argMinConfig$1,
  asinConfig$1,
  asinhConfig$1,
  atanConfig$1,
  atan2Config$1,
  atanhConfig$1,
  avgPoolConfig$2,
  avgPool3DConfig$1,
  avgPool3DGradConfig$1,
  avgPoolGradConfig$1,
  batchMatMulConfig$2,
  batchNormConfig$1,
  batchToSpaceNDConfig$2,
  bincountConfig$1,
  broadcastArgsConfig$1,
  castConfig$2,
  ceilConfig$2,
  clipByValueConfig$2,
  complexConfig$1,
  complexAbsConfig$1,
  concatConfig$2,
  conv2DConfig$2,
  conv2DBackpropFilterConfig$1,
  conv2DBackpropInputConfig$2,
  conv3DConfig$1,
  conv3DBackpropFilterV2Config$1,
  conv3DBackpropInputV2Config,
  cosConfig$2,
  coshConfig$2,
  cropAndResizeConfig$2,
  cumprodConfig$2,
  cumsumConfig$2,
  denseBincountConfig$1,
  depthToSpaceConfig$2,
  depthwiseConv2dNativeConfig$2,
  depthwiseConv2dNativeBackpropFilterConfig$1,
  depthwiseConv2dNativeBackpropInputConfig$1,
  diagConfig$1,
  dilation2DConfig$1,
  dilation2DBackpropFilterConfig,
  dilation2DBackpropInputConfig,
  einsumConfig$1,
  eluConfig$2,
  eluGradConfig$1,
  equalConfig$2,
  erfConfig$1,
  expConfig$2,
  expandDimsConfig$2,
  expm1Config$1,
  fftConfig$1,
  fillConfig$2,
  flipLeftRightConfig$2,
  floorConfig$2,
  floorDivConfig$2,
  fusedConv2DConfig$2,
  fusedDepthwiseConv2DConfig$2,
  gatherNdConfig$2,
  gatherV2Config$2,
  greaterConfig$2,
  greaterEqualConfig$2,
  identityConfig$2,
  ifftConfig$1,
  imagConfig$1,
  isFiniteConfig$1,
  isInfConfig$1,
  isNaNConfig$1,
  leakyReluConfig$2,
  lessConfig$2,
  lessEqualConfig$2,
  linSpaceConfig$1,
  logConfig$2,
  log1pConfig$1,
  logicalAndConfig$2,
  logicalNotConfig$1,
  logicalOrConfig$1,
  LRNConfig$1,
  LRNGradConfig$1,
  maxConfig$2,
  maximumConfig$2,
  maxPoolConfig$2,
  maxPool3DConfig$1,
  maxPool3DGradConfig$1,
  maxPoolGradConfig$1,
  maxPoolWithArgmaxConfig$1,
  meanConfig$2,
  minConfig$2,
  minimumConfig$2,
  mirrorPadConfig$2,
  modConfig$1,
  multinomialConfig$1,
  multiplyConfig$2,
  negConfig$2,
  nonMaxSuppressionV3Config$2,
  nonMaxSuppressionV4Config$2,
  nonMaxSuppressionV5Config$2,
  notEqualConfig$2,
  oneHotConfig$2,
  onesLikeConfig$2,
  packConfig$2,
  padV2Config$2,
  powConfig$2,
  preluConfig$2,
  prodConfig$2,
  rangeConfig$2,
  realConfig$1,
  realDivConfig$2,
  reciprocalConfig$1,
  reluConfig$2,
  relu6Config$2,
  reshapeConfig$2,
  resizeBilinearConfig$2,
  resizeBilinearGradConfig$1,
  resizeNearestNeighborConfig$1,
  resizeNearestNeighborGradConfig$1,
  reverseConfig$2,
  rotateWithOffsetConfig$2,
  roundConfig$2,
  rsqrtConfig$2,
  scatterNdConfig$2,
  selectConfig$2,
  seluConfig$1,
  sigmoidConfig$2,
  signConfig$1,
  sinConfig$2,
  sinhConfig$1,
  sliceConfig$2,
  softmaxConfig$2,
  softplusConfig$1,
  spaceToBatchNDConfig$2,
  sparseFillEmptyRowsConfig$2,
  sparseReshapeConfig$2,
  sparseSegmentMeanConfig$2,
  sparseSegmentSumConfig$2,
  sparseToDenseConfig$1,
  splitVConfig$2,
  sqrtConfig$2,
  squareConfig$2,
  squaredDifferenceConfig$2,
  stepConfig$2,
  stridedSliceConfig$2,
  stringNGramsConfig$1,
  stringSplitConfig$1,
  stringToHashBucketFastConfig$1,
  subConfig$2,
  sumConfig$2,
  tanConfig$2,
  tanhConfig$2,
  tileConfig$2,
  topKConfig$2,
  transformConfig$2,
  transposeConfig$2,
  uniqueConfig$1,
  unpackConfig$2,
  unsortedSegmentSumConfig$1,
  zerosLikeConfig$2
];
for (const kernelConfig of kernelConfigs$2) {
  registerKernel(kernelConfig);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const contexts = {};
const WEBGL_ATTRIBUTES = {
  alpha: false,
  antialias: false,
  premultipliedAlpha: false,
  preserveDrawingBuffer: false,
  depth: false,
  stencil: false,
  failIfMajorPerformanceCaveat: true
};
function setWebGLContext(webGLVersion, gl) {
  contexts[webGLVersion] = gl;
}
function getWebGLContext(webGLVersion, customCanvas) {
  if (!(webGLVersion in contexts) || customCanvas != null) {
    const newCtx = getWebGLRenderingContext(webGLVersion, customCanvas);
    if (newCtx !== null) {
      contexts[webGLVersion] = newCtx;
    } else {
      console.log("Could not get context for WebGL version", webGLVersion);
      return null;
    }
  }
  const gl = contexts[webGLVersion];
  if (gl == null || gl.isContextLost()) {
    delete contexts[webGLVersion];
    return getWebGLContext(webGLVersion);
  }
  gl.disable(gl.DEPTH_TEST);
  gl.disable(gl.STENCIL_TEST);
  gl.disable(gl.BLEND);
  gl.disable(gl.DITHER);
  gl.disable(gl.POLYGON_OFFSET_FILL);
  gl.disable(gl.SAMPLE_COVERAGE);
  gl.enable(gl.SCISSOR_TEST);
  gl.enable(gl.CULL_FACE);
  gl.cullFace(gl.BACK);
  return contexts[webGLVersion];
}
function createCanvas(webGLVersion) {
  if (typeof OffscreenCanvas !== "undefined" && webGLVersion === 2) {
    return new OffscreenCanvas(300, 150);
  } else if (typeof document !== "undefined") {
    return document.createElement("canvas");
  } else {
    throw new Error("Cannot create a canvas in this context");
  }
}
function getWebGLRenderingContext(webGLVersion, customCanvas) {
  if (webGLVersion !== 1 && webGLVersion !== 2) {
    throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");
  }
  const canvas = customCanvas == null ? createCanvas(webGLVersion) : customCanvas;
  canvas.addEventListener("webglcontextlost", (ev) => {
    ev.preventDefault();
    delete contexts[webGLVersion];
  }, false);
  if (webGLVersion === 1) {
    return canvas.getContext("webgl", WEBGL_ATTRIBUTES) || canvas.getContext("experimental-webgl", WEBGL_ATTRIBUTES);
  }
  return canvas.getContext("webgl2", WEBGL_ATTRIBUTES);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var PackingScheme;
(function(PackingScheme2) {
  PackingScheme2[PackingScheme2["DENSE"] = 0] = "DENSE";
  PackingScheme2[PackingScheme2["SHARED_BATCH"] = 1] = "SHARED_BATCH";
})(PackingScheme || (PackingScheme = {}));
var TextureUsage;
(function(TextureUsage2) {
  TextureUsage2[TextureUsage2["RENDER"] = 0] = "RENDER";
  TextureUsage2[TextureUsage2["UPLOAD"] = 1] = "UPLOAD";
  TextureUsage2[TextureUsage2["PIXELS"] = 2] = "PIXELS";
  TextureUsage2[TextureUsage2["DOWNLOAD"] = 3] = "DOWNLOAD";
})(TextureUsage || (TextureUsage = {}));
var PhysicalTextureType;
(function(PhysicalTextureType2) {
  PhysicalTextureType2[PhysicalTextureType2["UNPACKED_FLOAT16"] = 0] = "UNPACKED_FLOAT16";
  PhysicalTextureType2[PhysicalTextureType2["UNPACKED_FLOAT32"] = 1] = "UNPACKED_FLOAT32";
  PhysicalTextureType2[PhysicalTextureType2["PACKED_4X1_UNSIGNED_BYTE"] = 2] = "PACKED_4X1_UNSIGNED_BYTE";
  PhysicalTextureType2[PhysicalTextureType2["PACKED_2X2_FLOAT32"] = 3] = "PACKED_2X2_FLOAT32";
  PhysicalTextureType2[PhysicalTextureType2["PACKED_2X2_FLOAT16"] = 4] = "PACKED_2X2_FLOAT16";
})(PhysicalTextureType || (PhysicalTextureType = {}));
function getUnpackedMatrixTextureShapeWidthHeight(rows, columns) {
  return [columns, rows];
}
function getUnpackedArraySizeFromMatrixSize(matrixSize, channelsPerTexture) {
  return matrixSize * channelsPerTexture;
}
function getDenseTexShape(shape) {
  const size = sizeFromShape(shape);
  const texelsNeeded = Math.ceil(size / 4);
  return sizeToSquarishShape(texelsNeeded);
}
function getPackedMatrixTextureShapeWidthHeight(rows, columns) {
  return [
    Math.max(1, Math.ceil(columns / 2)),
    Math.max(1, Math.ceil(rows / 2))
  ];
}
function getPackedRGBAArraySizeFromMatrixShape(rows, columns) {
  const [w2, h2] = getPackedMatrixTextureShapeWidthHeight(rows, columns);
  return w2 * h2 * 4;
}
function getTextureConfig(gl, textureHalfFloatExtension) {
  const glany = gl;
  let internalFormatFloat;
  let internalFormatHalfFloat;
  let internalFormatPackedHalfFloat;
  let internalFormatPackedFloat;
  let textureFormatFloat;
  let downloadTextureFormat;
  let downloadUnpackNumChannels;
  let defaultNumChannels;
  let textureTypeHalfFloat;
  let textureTypeFloat;
  if (env().getNumber("WEBGL_VERSION") === 2) {
    internalFormatFloat = glany.R32F;
    internalFormatHalfFloat = glany.R16F;
    internalFormatPackedHalfFloat = glany.RGBA16F;
    internalFormatPackedFloat = glany.RGBA32F;
    textureFormatFloat = glany.RED;
    downloadUnpackNumChannels = 4;
    defaultNumChannels = 1;
    textureTypeHalfFloat = glany.HALF_FLOAT;
    textureTypeFloat = glany.FLOAT;
    downloadTextureFormat = glany.RGBA8;
  } else {
    internalFormatFloat = gl.RGBA;
    internalFormatHalfFloat = gl.RGBA;
    internalFormatPackedHalfFloat = gl.RGBA;
    internalFormatPackedFloat = glany.RGBA;
    textureFormatFloat = gl.RGBA;
    downloadUnpackNumChannels = 4;
    defaultNumChannels = 4;
    textureTypeHalfFloat = textureHalfFloatExtension != null ? textureHalfFloatExtension.HALF_FLOAT_OES : null;
    textureTypeFloat = gl.FLOAT;
    downloadTextureFormat = gl.RGBA;
  }
  return {
    internalFormatFloat,
    internalFormatHalfFloat,
    internalFormatPackedHalfFloat,
    internalFormatPackedFloat,
    textureFormatFloat,
    downloadTextureFormat,
    downloadUnpackNumChannels,
    defaultNumChannels,
    textureTypeHalfFloat,
    textureTypeFloat
  };
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function callAndCheck(gl, func) {
  const returnValue = func();
  if (env().getBool("DEBUG")) {
    checkWebGLError(gl);
  }
  return returnValue;
}
function checkWebGLError(gl) {
  const error3 = gl.getError();
  if (error3 !== gl.NO_ERROR) {
    throw new Error("WebGL Error: " + getWebGLErrorMessage(gl, error3));
  }
}
const MIN_FLOAT16 = 596e-10;
const MAX_FLOAT16 = 65504;
function canBeRepresented(num) {
  if (env().getBool("WEBGL_RENDER_FLOAT32_ENABLED") || num === 0 || MIN_FLOAT16 < Math.abs(num) && Math.abs(num) < MAX_FLOAT16) {
    return true;
  }
  return false;
}
function getWebGLErrorMessage(gl, status) {
  switch (status) {
    case gl.NO_ERROR:
      return "NO_ERROR";
    case gl.INVALID_ENUM:
      return "INVALID_ENUM";
    case gl.INVALID_VALUE:
      return "INVALID_VALUE";
    case gl.INVALID_OPERATION:
      return "INVALID_OPERATION";
    case gl.INVALID_FRAMEBUFFER_OPERATION:
      return "INVALID_FRAMEBUFFER_OPERATION";
    case gl.OUT_OF_MEMORY:
      return "OUT_OF_MEMORY";
    case gl.CONTEXT_LOST_WEBGL:
      return "CONTEXT_LOST_WEBGL";
    default:
      return `Unknown error code ${status}`;
  }
}
function getExtensionOrThrow(gl, extensionName) {
  return throwIfNull(gl, () => gl.getExtension(extensionName), 'Extension "' + extensionName + '" not supported on this browser.');
}
function createVertexShader$1(gl, vertexShaderSource) {
  const vertexShader = throwIfNull(gl, () => gl.createShader(gl.VERTEX_SHADER), "Unable to create vertex WebGLShader.");
  callAndCheck(gl, () => gl.shaderSource(vertexShader, vertexShaderSource));
  callAndCheck(gl, () => gl.compileShader(vertexShader));
  if (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) === false) {
    console.log(gl.getShaderInfoLog(vertexShader));
    throw new Error("Failed to compile vertex shader.");
  }
  return vertexShader;
}
function createFragmentShader(gl, fragmentShaderSource) {
  const fragmentShader = throwIfNull(gl, () => gl.createShader(gl.FRAGMENT_SHADER), "Unable to create fragment WebGLShader.");
  callAndCheck(gl, () => gl.shaderSource(fragmentShader, fragmentShaderSource));
  callAndCheck(gl, () => gl.compileShader(fragmentShader));
  if (env().get("ENGINE_COMPILE_ONLY")) {
    return fragmentShader;
  }
  if (gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) === false) {
    logShaderSourceAndInfoLog(fragmentShaderSource, gl.getShaderInfoLog(fragmentShader));
    throw new Error("Failed to compile fragment shader.");
  }
  return fragmentShader;
}
const lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;
function logShaderSourceAndInfoLog(shaderSource, shaderInfoLog) {
  const lineNumberRegexResult = lineNumberRegex.exec(shaderInfoLog);
  if (lineNumberRegexResult == null) {
    console.log(`Couldn't parse line number in error: ${shaderInfoLog}`);
    console.log(shaderSource);
    return;
  }
  const lineNumber = +lineNumberRegexResult[1];
  const shaderLines = shaderSource.split("\n");
  const pad2 = shaderLines.length.toString().length + 2;
  const linesWithLineNumbers = shaderLines.map((line, lineNumber2) => rightPad((lineNumber2 + 1).toString(), pad2) + line);
  let maxLineLength = 0;
  for (let i2 = 0; i2 < linesWithLineNumbers.length; i2++) {
    maxLineLength = Math.max(linesWithLineNumbers[i2].length, maxLineLength);
  }
  const beforeErrorLines = linesWithLineNumbers.slice(0, lineNumber - 1);
  const errorLine = linesWithLineNumbers.slice(lineNumber - 1, lineNumber);
  const afterErrorLines = linesWithLineNumbers.slice(lineNumber);
  console.log(beforeErrorLines.join("\n"));
  console.log(shaderInfoLog.split("\n")[0]);
  console.log(`%c ${rightPad(errorLine[0], maxLineLength)}`, "border:1px solid red; background-color:#e3d2d2; color:#a61717");
  console.log(afterErrorLines.join("\n"));
}
function createProgram(gl) {
  return throwIfNull(gl, () => gl.createProgram(), "Unable to create WebGLProgram.");
}
function linkProgram(gl, program) {
  callAndCheck(gl, () => gl.linkProgram(program));
  if (env().get("ENGINE_COMPILE_ONLY")) {
    return;
  }
  if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
    console.log(gl.getProgramInfoLog(program));
    throw new Error("Failed to link vertex and fragment shaders.");
  }
}
function validateProgram(gl, program) {
  callAndCheck(gl, () => gl.validateProgram(program));
  if (gl.getProgramParameter(program, gl.VALIDATE_STATUS) === false) {
    console.log(gl.getProgramInfoLog(program));
    throw new Error("Shader program validation failed.");
  }
}
function createStaticVertexBuffer(gl, data2) {
  const buffer2 = throwIfNull(gl, () => gl.createBuffer(), "Unable to create WebGLBuffer");
  callAndCheck(gl, () => gl.bindBuffer(gl.ARRAY_BUFFER, buffer2));
  callAndCheck(gl, () => gl.bufferData(gl.ARRAY_BUFFER, data2, gl.STATIC_DRAW));
  return buffer2;
}
function createStaticIndexBuffer(gl, data2) {
  const buffer2 = throwIfNull(gl, () => gl.createBuffer(), "Unable to create WebGLBuffer");
  callAndCheck(gl, () => gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer2));
  callAndCheck(gl, () => gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, data2, gl.STATIC_DRAW));
  return buffer2;
}
function createTexture(gl) {
  return throwIfNull(gl, () => gl.createTexture(), "Unable to create WebGLTexture.");
}
function validateTextureSize(width2, height2) {
  const maxTextureSize = env().getNumber("WEBGL_MAX_TEXTURE_SIZE");
  if (width2 <= 0 || height2 <= 0) {
    const requested = `[${width2}x${height2}]`;
    throw new Error("Requested texture size " + requested + " is invalid.");
  }
  if (width2 > maxTextureSize || height2 > maxTextureSize) {
    const requested = `[${width2}x${height2}]`;
    const max2 = `[${maxTextureSize}x${maxTextureSize}]`;
    throw new Error("Requested texture size " + requested + " greater than WebGL maximum on this browser / GPU " + max2 + ".");
  }
}
function createFramebuffer(gl) {
  return throwIfNull(gl, () => gl.createFramebuffer(), "Unable to create WebGLFramebuffer.");
}
function bindVertexBufferToProgramAttribute(gl, program, attribute, buffer2, arrayEntriesPerItem, itemStrideInBytes, itemOffsetInBytes) {
  const loc = gl.getAttribLocation(program, attribute);
  if (loc === -1) {
    return false;
  }
  callAndCheck(gl, () => gl.bindBuffer(gl.ARRAY_BUFFER, buffer2));
  callAndCheck(gl, () => gl.vertexAttribPointer(loc, arrayEntriesPerItem, gl.FLOAT, false, itemStrideInBytes, itemOffsetInBytes));
  callAndCheck(gl, () => gl.enableVertexAttribArray(loc));
  return true;
}
function bindTextureUnit(gl, texture, textureUnit) {
  validateTextureUnit(gl, textureUnit);
  callAndCheck(gl, () => gl.activeTexture(gl.TEXTURE0 + textureUnit));
  callAndCheck(gl, () => gl.bindTexture(gl.TEXTURE_2D, texture));
}
function getProgramUniformLocationOrThrow(gl, program, uniformName) {
  return throwIfNull(gl, () => gl.getUniformLocation(program, uniformName), 'uniform "' + uniformName + '" not present in program.');
}
function getProgramUniformLocation(gl, program, uniformName) {
  return gl.getUniformLocation(program, uniformName);
}
function bindTextureToProgramUniformSampler(gl, texture, uniformSamplerLocation, textureUnit) {
  callAndCheck(gl, () => bindTextureUnit(gl, texture, textureUnit));
  callAndCheck(gl, () => gl.uniform1i(uniformSamplerLocation, textureUnit));
}
function bindColorTextureToFramebuffer(gl, texture, framebuffer) {
  callAndCheck(gl, () => gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
  callAndCheck(gl, () => gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0));
}
function unbindColorTextureFromFramebuffer(gl, framebuffer) {
  callAndCheck(gl, () => gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
  callAndCheck(gl, () => gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0));
}
function validateFramebuffer(gl) {
  const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
  if (status !== gl.FRAMEBUFFER_COMPLETE) {
    throw new Error("Error binding framebuffer: " + getFramebufferErrorMessage(gl, status));
  }
}
function getFramebufferErrorMessage(gl, status) {
  switch (status) {
    case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
      return "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
    case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
      return "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
    case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
      return "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
    case gl.FRAMEBUFFER_UNSUPPORTED:
      return "FRAMEBUFFER_UNSUPPORTED";
    default:
      return `unknown error ${status}`;
  }
}
function throwIfNull(gl, returnTOrNull, failureMessage) {
  const tOrNull = callAndCheck(gl, () => returnTOrNull());
  if (tOrNull == null) {
    throw new Error(failureMessage);
  }
  return tOrNull;
}
function validateTextureUnit(gl, textureUnit) {
  const maxTextureUnit = gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1;
  const glTextureUnit = textureUnit + gl.TEXTURE0;
  if (glTextureUnit < gl.TEXTURE0 || glTextureUnit > maxTextureUnit) {
    const textureUnitRange = `[gl.TEXTURE0, gl.TEXTURE${maxTextureUnit}]`;
    throw new Error(`textureUnit must be in ${textureUnitRange}.`);
  }
}
function getBatchDim(shape, dimsToSkip = 2) {
  return sizeFromShape(shape.slice(0, shape.length - dimsToSkip));
}
function getRowsCols(shape) {
  if (shape.length === 0) {
    throw Error("Cannot get rows and columns of an empty shape array.");
  }
  return [
    shape.length > 1 ? shape[shape.length - 2] : 1,
    shape[shape.length - 1]
  ];
}
function getShapeAs3D(shape) {
  let shapeAs3D = [1, 1, 1];
  const isScalar = shape.length === 0 || shape.length === 1 && shape[0] === 1;
  if (!isScalar) {
    shapeAs3D = [getBatchDim(shape), ...getRowsCols(shape)];
  }
  return shapeAs3D;
}
function getTextureShapeFromLogicalShape(logShape, isPacked = false) {
  let maxTexSize = env().getNumber("WEBGL_MAX_TEXTURE_SIZE");
  if (isPacked) {
    maxTexSize = maxTexSize * 2;
    logShape = logShape.map((d2, i2) => i2 >= logShape.length - 2 ? nearestLargerEven(logShape[i2]) : logShape[i2]);
    if (logShape.length === 1) {
      logShape = [2, logShape[0]];
    }
  }
  if (logShape.length !== 2) {
    const squeezeResult = squeezeShape(logShape);
    logShape = squeezeResult.newShape;
  }
  let size = sizeFromShape(logShape);
  if (logShape.length <= 1 && size <= maxTexSize) {
    return [1, size];
  } else if (logShape.length === 2 && logShape[0] <= maxTexSize && logShape[1] <= maxTexSize) {
    return logShape;
  } else if (logShape.length === 3 && logShape[0] * logShape[1] <= maxTexSize && logShape[2] <= maxTexSize) {
    return [logShape[0] * logShape[1], logShape[2]];
  } else if (logShape.length === 3 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] <= maxTexSize) {
    return [logShape[0], logShape[1] * logShape[2]];
  } else if (logShape.length === 4 && logShape[0] * logShape[1] * logShape[2] <= maxTexSize && logShape[3] <= maxTexSize) {
    return [logShape[0] * logShape[1] * logShape[2], logShape[3]];
  } else if (logShape.length === 4 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] * logShape[3] <= maxTexSize) {
    return [logShape[0], logShape[1] * logShape[2] * logShape[3]];
  } else {
    if (isPacked) {
      const batchDim = getBatchDim(logShape);
      let rows = 2, cols = 2;
      if (logShape.length) {
        [rows, cols] = getRowsCols(logShape);
      }
      size = batchDim * (rows / 2) * (cols / 2);
      return sizeToSquarishShape(size).map((d2) => d2 * 2);
    }
    return sizeToSquarishShape(size);
  }
}
function isEven(n2) {
  return n2 % 2 === 0;
}
function isReshapeFree(shape1, shape2) {
  shape1 = shape1.slice(-2);
  shape2 = shape2.slice(-2);
  if (arraysEqual(shape1, shape2)) {
    return true;
  }
  if (!shape1.length || !shape2.length) {
    return true;
  }
  if (shape1[0] === 0 || shape1[1] === 0 || shape2[0] === 0 || shape2[1] === 0) {
    return true;
  }
  if (shape1.length !== shape2.length) {
    const shape1Cols = shape1.slice(-1)[0];
    const shape2Cols = shape2.slice(-1)[0];
    if (shape1Cols === shape2Cols) {
      return true;
    }
    if (isEven(shape1Cols) && isEven(shape2Cols) && (shape1[0] === 1 || shape2[0] === 1)) {
      return true;
    }
  }
  return shape1[1] === shape2[1] && isEven(shape1[0]) && isEven(shape2[0]);
}
let MAX_TEXTURE_SIZE;
let MAX_TEXTURES_IN_SHADER;
function getWebGLMaxTextureSize(webGLVersion) {
  if (MAX_TEXTURE_SIZE == null) {
    const gl = getWebGLContext(webGLVersion);
    MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  }
  return MAX_TEXTURE_SIZE;
}
function getMaxTexturesInShader(webGLVersion) {
  if (MAX_TEXTURES_IN_SHADER == null) {
    const gl = getWebGLContext(webGLVersion);
    MAX_TEXTURES_IN_SHADER = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
  }
  return Math.min(16, MAX_TEXTURES_IN_SHADER);
}
function getWebGLDisjointQueryTimerVersion(webGLVersion) {
  if (webGLVersion === 0) {
    return 0;
  }
  let queryTimerVersion;
  const gl = getWebGLContext(webGLVersion);
  if (hasExtension(gl, "EXT_disjoint_timer_query_webgl2") && webGLVersion === 2) {
    queryTimerVersion = 2;
  } else if (hasExtension(gl, "EXT_disjoint_timer_query")) {
    queryTimerVersion = 1;
  } else {
    queryTimerVersion = 0;
  }
  return queryTimerVersion;
}
function hasExtension(gl, extensionName) {
  const ext = gl.getExtension(extensionName);
  return ext != null;
}
function isWebGLVersionEnabled(webGLVersion) {
  try {
    const gl = getWebGLContext(webGLVersion);
    if (gl != null) {
      return true;
    }
  } catch (e2) {
    console.log("Error when getting WebGL context: ", e2);
    return false;
  }
  return false;
}
function isCapableOfRenderingToFloatTexture(webGLVersion) {
  if (webGLVersion === 0) {
    return false;
  }
  const gl = getWebGLContext(webGLVersion);
  if (webGLVersion === 1) {
    if (!hasExtension(gl, "OES_texture_float")) {
      return false;
    }
  } else {
    if (!hasExtension(gl, "EXT_color_buffer_float")) {
      return false;
    }
  }
  const isFrameBufferComplete = createFloatTextureAndBindToFramebuffer(gl);
  return isFrameBufferComplete;
}
function isDownloadFloatTextureEnabled(webGLVersion) {
  if (webGLVersion === 0) {
    return false;
  }
  const gl = getWebGLContext(webGLVersion);
  if (webGLVersion === 1) {
    if (!hasExtension(gl, "OES_texture_float")) {
      return false;
    }
    if (!hasExtension(gl, "WEBGL_color_buffer_float")) {
      return false;
    }
  } else {
    if (hasExtension(gl, "EXT_color_buffer_float")) {
      return createFloatTextureAndBindToFramebuffer(gl);
    }
    const COLOR_BUFFER_HALF_FLOAT = "EXT_color_buffer_half_float";
    if (hasExtension(gl, COLOR_BUFFER_HALF_FLOAT)) {
      const textureHalfFloatExtension = gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
      return createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension);
    }
    return false;
  }
  const isFrameBufferComplete = createFloatTextureAndBindToFramebuffer(gl);
  return isFrameBufferComplete;
}
function createFloatTextureAndBindToFramebuffer(gl) {
  const texConfig = getTextureConfig(gl);
  const texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  const width2 = 1;
  const height2 = 1;
  gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatFloat, width2, height2, 0, texConfig.textureFormatFloat, texConfig.textureTypeFloat, null);
  const frameBuffer = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
  const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
  gl.bindTexture(gl.TEXTURE_2D, null);
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.deleteTexture(texture);
  gl.deleteFramebuffer(frameBuffer);
  return isFrameBufferComplete;
}
function createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension) {
  const texConfig = getTextureConfig(gl, textureHalfFloatExtension);
  const texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  const width2 = 1;
  const height2 = 1;
  gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatHalfFloat, width2, height2, 0, texConfig.textureFormatFloat, texConfig.textureTypeHalfFloat, null);
  const frameBuffer = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
  const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
  gl.bindTexture(gl.TEXTURE_2D, null);
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.deleteTexture(texture);
  gl.deleteFramebuffer(frameBuffer);
  return isFrameBufferComplete;
}
function isWebGLFenceEnabled(webGLVersion) {
  if (webGLVersion !== 2) {
    return false;
  }
  const gl = getWebGLContext(webGLVersion);
  const isEnabled = gl.fenceSync != null;
  return isEnabled;
}
function assertNotComplex(tensor2, opName) {
  if (!Array.isArray(tensor2)) {
    tensor2 = [tensor2];
  }
  tensor2.forEach((t2) => {
    if (t2 != null) {
      assert$1(t2.dtype !== "complex64", () => `${opName} does not support complex64 tensors in the WebGL backend.`);
    }
  });
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ENV$1 = env();
ENV$1.registerFlag("HAS_WEBGL", () => ENV$1.getNumber("WEBGL_VERSION") > 0);
ENV$1.registerFlag("WEBGL_VERSION", () => {
  if (isWebGLVersionEnabled(2)) {
    return 2;
  } else if (isWebGLVersionEnabled(1)) {
    return 1;
  }
  return 0;
});
ENV$1.registerFlag("WEBGL_CHECK_NUMERICAL_PROBLEMS", () => false);
ENV$1.registerFlag("WEBGL_BUFFER_SUPPORTED", () => ENV$1.get("WEBGL_VERSION") === 2);
ENV$1.registerFlag("WEBGL_CPU_FORWARD", () => true);
ENV$1.registerFlag("WEBGL_FORCE_F16_TEXTURES", () => false);
ENV$1.registerFlag("WEBGL_PACK", () => ENV$1.getBool("HAS_WEBGL"));
ENV$1.registerFlag("WEBGL_PACK_NORMALIZATION", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_CLIP", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_DEPTHWISECONV", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_BINARY_OPERATIONS", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_UNARY_OPERATIONS", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_ARRAY_OPERATIONS", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_IMAGE_OPERATIONS", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_PACK_REDUCE", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_LAZILY_UNPACK", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_CONV_IM2COL", () => ENV$1.getBool("WEBGL_PACK"));
ENV$1.registerFlag("WEBGL_MAX_TEXTURE_SIZE", () => getWebGLMaxTextureSize(ENV$1.getNumber("WEBGL_VERSION")));
ENV$1.registerFlag("WEBGL_MAX_TEXTURES_IN_SHADER", () => getMaxTexturesInShader(ENV$1.getNumber("WEBGL_VERSION")));
ENV$1.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION", () => {
  const webGLVersion = ENV$1.getNumber("WEBGL_VERSION");
  if (webGLVersion === 0) {
    return 0;
  }
  return getWebGLDisjointQueryTimerVersion(webGLVersion);
});
ENV$1.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE", () => ENV$1.getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 && !isMobile());
ENV$1.registerFlag("WEBGL_RENDER_FLOAT32_CAPABLE", () => isCapableOfRenderingToFloatTexture(ENV$1.getNumber("WEBGL_VERSION")));
ENV$1.registerFlag("WEBGL_RENDER_FLOAT32_ENABLED", () => {
  return ENV$1.getBool("WEBGL_FORCE_F16_TEXTURES") ? false : ENV$1.getBool("WEBGL_RENDER_FLOAT32_CAPABLE");
});
ENV$1.registerFlag("WEBGL_DOWNLOAD_FLOAT_ENABLED", () => isDownloadFloatTextureEnabled(ENV$1.getNumber("WEBGL_VERSION")));
ENV$1.registerFlag("WEBGL_FENCE_API_ENABLED", () => isWebGLFenceEnabled(ENV$1.getNumber("WEBGL_VERSION")));
ENV$1.registerFlag("WEBGL_SIZE_UPLOAD_UNIFORM", () => {
  const useUniforms = ENV$1.getBool("WEBGL_RENDER_FLOAT32_ENABLED");
  return useUniforms ? 4 : 0;
});
ENV$1.registerFlag("WEBGL_DELETE_TEXTURE_THRESHOLD", () => {
  return -1;
}, (threshold2) => {
  if (threshold2 < 0 && threshold2 !== -1) {
    throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never delete) or at least 0, but got ${threshold2}.`);
  }
});
ENV$1.registerFlag("WEBGL_FLUSH_THRESHOLD", () => {
  return isMobile() ? 1 : -1;
}, (threshold2) => {
  if (threshold2 < 0 && threshold2 !== -1) {
    throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never manual flush) or at least 0, but got ${threshold2}.`);
  }
});
ENV$1.registerFlag("CPU_HANDOFF_SIZE_THRESHOLD", () => 128);
ENV$1.registerFlag("WEBGL_USE_SHAPES_UNIFORMS", () => false);
ENV$1.registerFlag("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD", () => 1e5);
ENV$1.registerFlag("TOPK_K_CPU_HANDOFF_THRESHOLD", () => 128);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getGlslDifferences() {
  let version2;
  let attribute;
  let varyingVs;
  let varyingFs;
  let texture2D;
  let output2;
  let defineOutput;
  let defineSpecialNaN;
  let defineSpecialInf;
  let defineRound;
  if (env().getNumber("WEBGL_VERSION") === 2) {
    version2 = "#version 300 es";
    attribute = "in";
    varyingVs = "out";
    varyingFs = "in";
    texture2D = "texture";
    output2 = "outputColor";
    defineOutput = "out vec4 outputColor;";
    defineSpecialNaN = `
      bool isnan_custom(float val) {
        uint floatToUint = floatBitsToUint(val);
        return (floatToUint & 0x7fffffffu) > 0x7f800000u;
      }

      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan_custom(val.x),
          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));
      }

      #define isnan(value) isnan_custom(value)
    `;
    defineSpecialInf = ``;
    defineRound = `
      #define round(value) newRound(value)
      int newRound(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 newRound(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
  } else {
    version2 = "";
    attribute = "attribute";
    varyingVs = "varying";
    varyingFs = "varying";
    texture2D = "texture2D";
    output2 = "gl_FragColor";
    defineOutput = "";
    defineSpecialNaN = `
      #define isnan(value) isnan_custom(value)
      bool isnan_custom(float val) {
        return (val > 0. || val < 1. || val == 0.) ? false : true;
      }
      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));
      }
    `;
    defineSpecialInf = `
      uniform float INFINITY;

      bool isinf(float val) {
        return abs(val) == INFINITY;
      }
      bvec4 isinf(vec4 val) {
        return equal(abs(val), vec4(INFINITY));
      }
    `;
    defineRound = `
      int round(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 round(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
  }
  return {
    version: version2,
    attribute,
    varyingVs,
    varyingFs,
    texture2D,
    output: output2,
    defineOutput,
    defineSpecialNaN,
    defineSpecialInf,
    defineRound
  };
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getLogicalCoordinatesFromFlatIndex(coords2, shape, index2 = "index") {
  const strides = computeStrides(shape);
  return strides.map((stride, i2) => {
    const line1 = `int ${coords2[i2]} = ${index2} / ${stride}`;
    const line2 = i2 === strides.length - 1 ? `int ${coords2[i2 + 1]} = ${index2} - ${coords2[i2]} * ${stride}` : `index -= ${coords2[i2]} * ${stride}`;
    return `${line1}; ${line2};`;
  }).join("");
}
function getOutputLogicalCoordinatesFromFlatIndexByUniform(coords2, shape, index2 = "index") {
  const strides = computeStrides(shape);
  return strides.map((_24, i2) => {
    const line1 = `int ${coords2[i2]} = ${index2} / outShapeStrides[${i2}]`;
    const line2 = i2 === strides.length - 1 ? `int ${coords2[i2 + 1]} = ${index2} - ${coords2[i2]} * outShapeStrides[${i2}]` : `index -= ${coords2[i2]} * outShapeStrides[${i2}]`;
    return `${line1}; ${line2};`;
  }).join("");
}
function symbolicallyComputeStrides(indicesArr, variableName) {
  const numCoords = indicesArr.length;
  const shape = indicesArr.map((d2) => `${variableName}[${d2}]`);
  const strides = new Array(numCoords - 1);
  strides[numCoords - 2] = shape[numCoords - 1];
  for (let i2 = numCoords - 3; i2 >= 0; --i2) {
    strides[i2] = `(${strides[i2 + 1]} * ${shape[i2 + 1]})`;
  }
  return strides;
}
function getLogicalCoordinatesFromFlatIndexByUniform(coords2, variableName, index2 = "index") {
  const indicesArray = coords2.map((_24, i2) => i2);
  const strides = symbolicallyComputeStrides(indicesArray, variableName);
  return strides.map((_24, i2) => {
    const line1 = `int ${coords2[i2]} = ${index2} / ${strides[i2]}`;
    const line2 = i2 === strides.length - 1 ? `int ${coords2[i2 + 1]} = ${index2} - ${coords2[i2]} * ${strides[i2]}` : `index -= ${coords2[i2]} * ${strides[i2]}`;
    return `${line1}; ${line2};`;
  }).join("");
}
function getFlatIndexFrom3D(shape) {
  const strides = computeStrides(shape).map((d2) => d2.toString());
  return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * ${strides[0]} + coords.y * ${strides[1]} + coords.z;
  }
`;
}
function getFlatIndexFrom3DOutput() {
  return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;
  }
`;
}
const ENCODE_FLOAT_SNIPPET = `
  const float FLOAT_MAX = 1.70141184e38;
  const float FLOAT_MIN = 1.17549435e-38;

  lowp vec4 encode_float(highp float v) {
    if (isnan(v)) {
      return vec4(255, 255, 255, 255);
    }

    highp float av = abs(v);

    if(av < FLOAT_MIN) {
      return vec4(0.0, 0.0, 0.0, 0.0);
    } else if(v > FLOAT_MAX) {
      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;
    } else if(v < -FLOAT_MAX) {
      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;
    }

    highp vec4 c = vec4(0,0,0,0);

    highp float e = floor(log2(av));
    highp float m = exp2(fract(log2(av))) - 1.0;

    c[2] = floor(128.0 * m);
    m -= c[2] / 128.0;
    c[1] = floor(32768.0 * m);
    m -= c[1] / 32768.0;
    c[0] = floor(8388608.0 * m);

    highp float ebias = e + 127.0;
    c[3] = floor(ebias / 2.0);
    ebias -= c[3] * 2.0;
    c[2] += floor(ebias) * 128.0;

    c[3] += 128.0 * step(0.0, -v);

    return c / 255.0;
  }
`;
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const { getBroadcastDims } = backend_util;
function makeShader(inputsInfo, outputShape, program) {
  const prefixSnippets = [];
  inputsInfo.forEach((x2) => {
    const size = sizeFromShape(x2.shapeInfo.logicalShape);
    if (x2.shapeInfo.isUniform) {
      prefixSnippets.push(`uniform float ${x2.name}${size > 1 ? `[${size}]` : ""};`);
    } else {
      prefixSnippets.push(`uniform sampler2D ${x2.name};`);
      prefixSnippets.push(`uniform int offset${x2.name};`);
    }
    if (program.enableShapeUniforms) {
      const { uniformShape } = getUniformInfoFromShape(program.packedInputs, x2.shapeInfo.logicalShape, x2.shapeInfo.texShape);
      switch (uniformShape.length) {
        case 1:
          prefixSnippets.push(`uniform int ${x2.name}Shape;`);
          break;
        case 2:
          prefixSnippets.push(`uniform ivec2 ${x2.name}Shape;`);
          break;
        case 3:
          prefixSnippets.push(`uniform ivec3 ${x2.name}Shape;`);
          break;
        case 4:
          prefixSnippets.push(`uniform ivec4 ${x2.name}Shape;`);
          break;
      }
      prefixSnippets.push(`uniform ivec2 ${x2.name}TexShape;`);
    }
  });
  if (program.enableShapeUniforms) {
    switch (outputShape.logicalShape.length) {
      case 1:
        prefixSnippets.push(`uniform int outShape;`);
        break;
      case 2:
        prefixSnippets.push(`uniform ivec2 outShape;`);
        prefixSnippets.push(`uniform int outShapeStrides;`);
        break;
      case 3:
        prefixSnippets.push(`uniform ivec3 outShape;`);
        prefixSnippets.push(`uniform ivec2 outShapeStrides;`);
        break;
      case 4:
        prefixSnippets.push(`uniform ivec4 outShape;`);
        prefixSnippets.push(`uniform ivec3 outShapeStrides;`);
        break;
    }
    prefixSnippets.push(`uniform ivec2 outTexShape;`);
  }
  if (program.customUniforms) {
    program.customUniforms.forEach((d2) => {
      prefixSnippets.push(`uniform ${d2.type} ${d2.name}${d2.arrayIndex ? `[${d2.arrayIndex}]` : ""};`);
    });
  }
  const inputPrefixSnippet = prefixSnippets.join("\n");
  const inputSamplingSnippet = inputsInfo.map((x2) => getInputSamplingSnippet(x2, outputShape, program.packedInputs, program.enableShapeUniforms)).join("\n");
  const outTexShape = outputShape.texShape;
  const glsl = getGlslDifferences();
  const floatTextureSampleSnippet = getFloatTextureSampleSnippet(glsl);
  let outputSamplingSnippet;
  let floatTextureSetOutputSnippet;
  let shaderPrefix = getShaderPrefix(glsl);
  if (outputShape.isPacked) {
    outputSamplingSnippet = getPackedOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
    floatTextureSetOutputSnippet = getFloatTextureSetRGBASnippet(glsl);
  } else {
    outputSamplingSnippet = getOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
    floatTextureSetOutputSnippet = getFloatTextureSetRSnippet(glsl);
  }
  if (program.packedInputs) {
    shaderPrefix += SHADER_PACKED_PREFIX;
  }
  const source2 = [
    shaderPrefix,
    floatTextureSampleSnippet,
    floatTextureSetOutputSnippet,
    inputPrefixSnippet,
    outputSamplingSnippet,
    inputSamplingSnippet,
    program.userCode
  ].join("\n");
  return source2;
}
function getSamplerFromInInfo(inInfo, enableShapeUniforms = false) {
  const shape = inInfo.shapeInfo.logicalShape;
  switch (shape.length) {
    case 0:
      return getSamplerScalar(inInfo, enableShapeUniforms);
    case 1:
      return getSampler1D(inInfo, enableShapeUniforms);
    case 2:
      return getSampler2D(inInfo, enableShapeUniforms);
    case 3:
      return getSampler3D(inInfo, enableShapeUniforms);
    case 4:
      return getSampler4D(inInfo, enableShapeUniforms);
    case 5:
      return getSampler5D(inInfo);
    case 6:
      return getSampler6D(inInfo);
    default:
      throw new Error(`${shape.length}-D input sampling is not yet supported`);
  }
}
function getPackedSamplerFromInInfo(inInfo, enableShapeUniforms) {
  const shape = inInfo.shapeInfo.logicalShape;
  switch (shape.length) {
    case 0:
      return getPackedSamplerScalar(inInfo);
    case 1:
      return getPackedSampler1D(inInfo, enableShapeUniforms);
    case 2:
      return getPackedSampler2D(inInfo, enableShapeUniforms);
    case 3:
      return getPackedSampler3D(inInfo, enableShapeUniforms);
    default:
      return getPackedSamplerND(inInfo, enableShapeUniforms);
  }
}
function getInputSamplingSnippet(inInfo, outShapeInfo, usesPackedTextures = false, enableShapeUniforms) {
  let res = "";
  if (usesPackedTextures) {
    res += getPackedSamplerFromInInfo(inInfo, enableShapeUniforms);
  } else {
    res += getSamplerFromInInfo(inInfo, enableShapeUniforms);
  }
  const inShape = inInfo.shapeInfo.logicalShape;
  const outShape = outShapeInfo.logicalShape;
  if (inShape.length <= outShape.length) {
    if (usesPackedTextures) {
      res += getPackedSamplerAtOutputCoords(inInfo, outShapeInfo);
    } else {
      res += getSamplerAtOutputCoords(inInfo, outShapeInfo);
    }
  }
  return res;
}
function getPackedOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
  switch (outShape.length) {
    case 0:
      return getOutputScalarCoords();
    case 1:
      return getOutputPacked1DCoords(outShape, outTexShape, enableShapeUniforms);
    case 2:
      return getOutputPacked2DCoords(outShape, outTexShape, enableShapeUniforms);
    case 3:
      return getOutputPacked3DCoords(outShape, outTexShape, enableShapeUniforms);
    default:
      return getOutputPackedNDCoords(outShape, outTexShape, enableShapeUniforms);
  }
}
function getOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
  switch (outShape.length) {
    case 0:
      return getOutputScalarCoords();
    case 1:
      return getOutput1DCoords(outShape, outTexShape, enableShapeUniforms);
    case 2:
      return getOutput2DCoords(outShape, outTexShape, enableShapeUniforms);
    case 3:
      return getOutput3DCoords(outShape, outTexShape, enableShapeUniforms);
    case 4:
      return getOutput4DCoords(outShape, outTexShape, enableShapeUniforms);
    case 5:
      return getOutput5DCoords(outShape, outTexShape);
    case 6:
      return getOutput6DCoords(outShape, outTexShape);
    default:
      throw new Error(`${outShape.length}-D output sampling is not yet supported`);
  }
}
function getFloatTextureSampleSnippet(glsl) {
  return `
    float sampleTexture(sampler2D textureSampler, vec2 uv) {
      return ${glsl.texture2D}(textureSampler, uv).r;
    }
  `;
}
function getFloatTextureSetRSnippet(glsl) {
  return `
    void setOutput(float val) {
      ${glsl.output} = vec4(val, 0, 0, 0);
    }
  `;
}
function getFloatTextureSetRGBASnippet(glsl) {
  return `
    void setOutput(vec4 val) {
      ${glsl.output} = val;
    }
  `;
}
function getShaderPrefix(glsl) {
  const SHADER_PREFIX = `${glsl.version}
    precision highp float;
    precision highp int;
    precision highp sampler2D;
    ${glsl.varyingFs} vec2 resultUV;
    ${glsl.defineOutput}
    const vec2 halfCR = vec2(0.5, 0.5);

    struct ivec5
    {
      int x;
      int y;
      int z;
      int w;
      int u;
    };

    struct ivec6
    {
      int x;
      int y;
      int z;
      int w;
      int u;
      int v;
    };

    uniform float NAN;
    ${glsl.defineSpecialNaN}
    ${glsl.defineSpecialInf}
    ${glsl.defineRound}

    int imod(int x, int y) {
      return x - y * (x / y);
    }

    int idiv(int a, int b, float sign) {
      int res = a / b;
      int mod = imod(a, b);
      if (sign < 0. && mod != 0) {
        res -= 1;
      }
      return res;
    }

    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    #define HASHSCALE1 443.8975
    float random(float seed){
      vec2 p = resultUV * seed;
      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
      p3 += dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${SAMPLE_1D_SNIPPET}
    ${SAMPLE_2D_SNIPPET}
    ${SAMPLE_3D_SNIPPET}
  `;
  return SHADER_PREFIX;
}
const SAMPLE_1D_SNIPPET = `
vec2 uvFromFlat(int texNumR, int texNumC, int index) {
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
  int texelIndex = index / 2;
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const SAMPLE_2D_SNIPPET = `
vec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,
  int texNumC, int row, int col) {
  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const SAMPLE_3D_SNIPPET = `
vec2 packedUVfrom3D(int texNumR, int texNumC,
    int texelsInBatch, int texelsInLogicalRow, int b,
    int row, int col) {
  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const SHADER_PACKED_PREFIX = `
  float getChannel(vec4 frag, vec2 innerDims) {
    vec2 modCoord = mod(innerDims, 2.);
    return modCoord.x == 0. ?
      (modCoord.y == 0. ? frag.r : frag.g) :
      (modCoord.y == 0. ? frag.b : frag.a);
  }
  float getChannel(vec4 frag, int dim) {
    float modCoord = mod(float(dim), 2.);
    return modCoord == 0. ? frag.r : frag.g;
  }
`;
function getOutputScalarCoords() {
  return `
    int getOutputCoords() {
      return 0;
    }
  `;
}
function getOutputPacked1DCoords(shape, texShape, enableShapeUniforms) {
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  if (packedTexShape[0] === 1) {
    if (enableShapeUniforms) {
      return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));
      }
    `;
    }
    return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ${packedTexShape[1]}.0);
      }
    `;
  }
  if (packedTexShape[1] === 1) {
    if (enableShapeUniforms) {
      return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));
      }
    `;
    }
    return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ${packedTexShape[0]}.0);
      }
    `;
  }
  if (enableShapeUniforms) {
    return `
    int getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);
    }
  `;
  }
  return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      return 2 * (resTexRC.x * ${packedTexShape[1]} + resTexRC.y);
    }
  `;
}
function getOutput1DCoords(shape, texShape, enableShapeUniforms) {
  if (texShape[0] === 1) {
    if (enableShapeUniforms) {
      return `
      int getOutputCoords() {
        return int(resultUV.x * float(outTexShape[1]));
      }
    `;
    }
    return `
      int getOutputCoords() {
        return int(resultUV.x * ${texShape[1]}.0);
      }
    `;
  }
  if (texShape[1] === 1) {
    if (enableShapeUniforms) {
      return `
      int getOutputCoords() {
        return int(resultUV.y * float(outTexShape[0]));
      }
    `;
    }
    return `
      int getOutputCoords() {
        return int(resultUV.y * ${texShape[0]}.0);
      }
    `;
  }
  if (enableShapeUniforms) {
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      return resTexRC.x * outTexShape[1] + resTexRC.y;
    }
  `;
  }
  return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      return resTexRC.x * ${texShape[1]} + resTexRC.y;
    }
  `;
}
function getOutputPacked3DCoords(shape, texShape, enableShapeUniforms) {
  if (enableShapeUniforms) {
    return `
    ivec3 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec3(b, r, c);
    }
  `;
  }
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  const texelsInLogicalRow = Math.ceil(shape[2] / 2);
  const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[1] / 2);
  return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec3(b, r, c);
    }
  `;
}
function getOutput3DCoords(shape, texShape, enableShapeUniforms) {
  if (enableShapeUniforms) {
    const coordsFromIndexSnippet2 = getOutputLogicalCoordinatesFromFlatIndexByUniform(["r", "c", "d"], shape);
    return `
  ivec3 getOutputCoords() {
    ivec2 resTexRC = ivec2(resultUV.yx *
                           vec2(outTexShape[0], outTexShape[1]));
    int index = resTexRC.x * outTexShape[1] + resTexRC.y;
    ${coordsFromIndexSnippet2}
    return ivec3(r, c, d);
  }
`;
  }
  const coordsFromIndexSnippet = getLogicalCoordinatesFromFlatIndex(["r", "c", "d"], shape);
  return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}
function getOutputPackedNDCoords(shape, texShape, enableShapeUniforms) {
  if (enableShapeUniforms) {
    return `
    ivec4 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatchN = texelsInBatch * outShape[1];

      int b2 = index / texelsInBatchN;
      index -= b2 * texelsInBatchN;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec4(b2, b, r, c);
    }
  `;
  }
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  const texelsInLogicalRow = Math.ceil(shape[shape.length - 1] / 2);
  const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[shape.length - 2] / 2);
  let texelsInBatchN = texelsInBatch;
  let batches = ``;
  let coords2 = "b, r, c";
  for (let b2 = 2; b2 < shape.length - 1; b2++) {
    texelsInBatchN *= shape[shape.length - b2 - 1];
    batches = `
      int b${b2} = index / ${texelsInBatchN};
      index -= b${b2} * ${texelsInBatchN};
    ` + batches;
    coords2 = `b${b2}, ` + coords2;
  }
  return `
    ivec${shape.length} getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      ${batches}

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec${shape.length}(${coords2});
    }
  `;
}
function getOutput4DCoords(shape, texShape, enableShapeUniforms) {
  if (enableShapeUniforms) {
    const coordsFromIndexSnippet2 = getOutputLogicalCoordinatesFromFlatIndexByUniform(["r", "c", "d", "d2"], shape);
    return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      ${coordsFromIndexSnippet2}
      return ivec4(r, c, d, d2);
    }
  `;
  }
  const coordsFromIndexSnippet = getLogicalCoordinatesFromFlatIndex(["r", "c", "d", "d2"], shape);
  return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
}
function getOutput5DCoords(shape, texShape) {
  const coordsFromIndexSnippet = getLogicalCoordinatesFromFlatIndex(["r", "c", "d", "d2", "d3"], shape);
  return `
    ivec5 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${texShape[0]},
                             ${texShape[1]}));

      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec5 outShape = ivec5(r, c, d, d2, d3);
      return outShape;
    }
  `;
}
function getOutput6DCoords(shape, texShape) {
  const coordsFromIndexSnippet = getLogicalCoordinatesFromFlatIndex(["r", "c", "d", "d2", "d3", "d4"], shape);
  return `
    ivec6 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec6 result = ivec6(r, c, d, d2, d3, d4);
      return result;
    }
  `;
}
function getOutputPacked2DCoords(shape, texShape, enableShapeUniforms) {
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  if (arraysEqual(shape, texShape)) {
    if (enableShapeUniforms) {
      return `
      ivec2 getOutputCoords() {
        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));
      }
    `;
    }
    return `
      ivec2 getOutputCoords() {
        return 2 * ivec2(resultUV.yx * vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      }
    `;
  }
  const texelsInLogicalRow = Math.ceil(shape[1] / 2);
  if (enableShapeUniforms) {
    return `
    ivec2 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));

      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;
      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec2(r, c);
    }
  `;
  }
  return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));

      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;
      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec2(r, c);
    }
  `;
}
function getOutput2DCoords(shape, texShape, enableShapeUniforms) {
  if (arraysEqual(shape, texShape)) {
    if (enableShapeUniforms) {
      return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));
      }
    `;
    }
    return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(${texShape[0]}, ${texShape[1]}));
      }
    `;
  }
  if (shape[1] === 1) {
    if (enableShapeUniforms) {
      return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
    }
    return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
  }
  if (shape[0] === 1) {
    if (enableShapeUniforms) {
      return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(0, index);
      }
    `;
    }
    return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(0, index);
      }
    `;
  }
  if (enableShapeUniforms) {
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      int r = index / outShape[1];
      int c = index - r * outShape[1];
      return ivec2(r, c);
    }
  `;
  }
  return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      int r = index / ${shape[1]};
      int c = index - r * ${shape[1]};
      return ivec2(r, c);
    }
  `;
}
function getFlatOffsetUniformName(texName) {
  return `offset${texName}`;
}
function getPackedSamplerScalar(inputInfo) {
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const glsl = getGlslDifferences();
  return `
    vec4 ${funcName}() {
      return ${glsl.texture2D}(${texName}, halfCR);
    }
  `;
}
function getSamplerScalar(inputInfo, enableShapeUniforms) {
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  if (inputInfo.shapeInfo.isUniform) {
    return `float ${funcName}() {return ${texName};}`;
  }
  const [texNumR, texNumC] = inputInfo.shapeInfo.texShape;
  if (texNumR === 1 && texNumC === 1) {
    return `
      float ${funcName}() {
        return sampleTexture(${texName}, halfCR);
      }
    `;
  }
  const offset = getFlatOffsetUniformName(texName);
  if (enableShapeUniforms) {
    return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  const [tNumR, tNumC] = inputInfo.shapeInfo.texShape;
  return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function getPackedSampler1D(inputInfo, enableShapeUniforms) {
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const texShape = inputInfo.shapeInfo.texShape;
  const glsl = getGlslDifferences();
  if (enableShapeUniforms) {
    return `
    vec4 ${funcName}(int index) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      vec2 uv = packedUVfrom1D(
        packedTexShape[0], packedTexShape[1], index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
  }
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  return `
    vec4 ${funcName}(int index) {
      vec2 uv = packedUVfrom1D(
        ${packedTexShape[0]}, ${packedTexShape[1]}, index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function getSampler1D(inputInfo, enableShapeUniforms) {
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  if (inputInfo.shapeInfo.isUniform) {
    return `
      float ${funcName}(int index) {
        ${getUniformSampler(inputInfo)}
      }
    `;
  }
  const texShape = inputInfo.shapeInfo.texShape;
  const tNumR = texShape[0];
  const tNumC = texShape[1];
  if (tNumC === 1 && tNumR === 1) {
    return `
      float ${funcName}(int index) {
        return sampleTexture(${texName}, halfCR);
      }
    `;
  }
  const offset = getFlatOffsetUniformName(texName);
  if (tNumC === 1) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / ${tNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  if (tNumR === 1) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / ${tNumC}.0, 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  if (enableShapeUniforms) {
    return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function getPackedSampler2D(inputInfo, enableShapeUniforms) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const texShape = inputInfo.shapeInfo.texShape;
  const texNumR = texShape[0];
  const texNumC = texShape[1];
  const glsl = getGlslDifferences();
  if (texShape != null && arraysEqual(shape, texShape)) {
    if (enableShapeUniforms) {
      return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
    }
    return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
  }
  if (enableShapeUniforms) {
    return `
    vec4 ${funcName}(int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
  }
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  const valuesPerRow = Math.ceil(shape[1] / 2);
  return `
    vec4 ${funcName}(int row, int col) {
      vec2 uv = packedUVfrom2D(${valuesPerRow}, ${packedTexShape[0]}, ${packedTexShape[1]}, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function getSampler2D(inputInfo, enableShapeUniforms) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const texShape = inputInfo.shapeInfo.texShape;
  if (texShape != null && arraysEqual(shape, texShape)) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    const texNumR2 = texShape[0];
    const texNumC2 = texShape[1];
    return `
    float ${funcName}(int row, int col) {
      vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC2}.0, ${texNumR2}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  const { newShape, keptDims } = squeezeShape(shape);
  const squeezedShape = newShape;
  if (squeezedShape.length < shape.length) {
    const newInputInfo = squeezeInputInfo(inputInfo, squeezedShape);
    const params = ["row", "col"];
    return `
      ${getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col) {
        return ${funcName}(${getSqueezedParams(params, keptDims)});
      }
    `;
  }
  if (inputInfo.shapeInfo.isUniform) {
    return `
      float ${funcName}(int row, int col) {
        int index = round(dot(vec2(row, col), vec2(${shape[1]}, 1)));
        ${getUniformSampler(inputInfo)}
      }
    `;
  }
  const texNumR = texShape[0];
  const texNumC = texShape[1];
  const offset = getFlatOffsetUniformName(texName);
  if (texNumC === 1) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2(0.5, (index + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2(0.5, (index + 0.5) / ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  if (texNumR === 1) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2((index + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2((index + 0.5) / ${texNumC}.0, 0.5);
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  if (enableShapeUniforms) {
    return `
      float ${funcName}(int row, int col) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${texName}Shape[1] + col + ${offset};
        vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  return `
  float ${funcName}(int row, int col) {
    // Explicitly use integer operations as dot() only works on floats.
    int index = row * ${shape[1]} + col + ${offset};
    vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
    return sampleTexture(${texName}, uv);
  }
`;
}
function getPackedSampler3D(inputInfo, enableShapeUniforms) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const texShape = inputInfo.shapeInfo.texShape;
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  if (shape[0] === 1) {
    const squeezedShape = shape.slice(1);
    const keptDims = [1, 2];
    const newInputInfo = squeezeInputInfo(inputInfo, squeezedShape);
    const params = ["b", "row", "col"];
    return `
        ${getPackedSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        vec4 ${funcName}(int b, int row, int col) {
          return ${funcName}(${getSqueezedParams(params, keptDims)});
        }
      `;
  }
  const glsl = getGlslDifferences();
  if (enableShapeUniforms) {
    return `
    vec4 ${funcName}(int b, int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[2]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom3D(
        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
  }
  const texNumR = packedTexShape[0];
  const texNumC = packedTexShape[1];
  const valuesPerRow = Math.ceil(shape[2] / 2);
  const texelsInBatch = valuesPerRow * Math.ceil(shape[1] / 2);
  return `
    vec4 ${funcName}(int b, int row, int col) {
      vec2 uv = packedUVfrom3D(
        ${texNumR}, ${texNumC}, ${texelsInBatch}, ${valuesPerRow}, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function getSampler3D(inputInfo, enableShapeUniforms) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const stride0 = shape[1] * shape[2];
  const stride1 = shape[2];
  const { newShape, keptDims } = squeezeShape(shape);
  const squeezedShape = newShape;
  if (squeezedShape.length < shape.length) {
    const newInputInfo = squeezeInputInfo(inputInfo, squeezedShape);
    const params = ["row", "col", "depth"];
    return `
        ${getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        float ${funcName}(int row, int col, int depth) {
          return ${funcName}(${getSqueezedParams(params, keptDims)});
        }
      `;
  }
  if (inputInfo.shapeInfo.isUniform) {
    return `
      float ${funcName}(int row, int col, int depth) {
        int index = round(dot(vec3(row, col, depth),
                          vec3(${stride0}, ${stride1}, 1)));
        ${getUniformSampler(inputInfo)}
      }
    `;
  }
  const texShape = inputInfo.shapeInfo.texShape;
  const texNumR = texShape[0];
  const texNumC = texShape[1];
  const flatOffset = inputInfo.shapeInfo.flatOffset;
  if (texNumC === stride0 && flatOffset == null) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col, int depth) {
        int stride1 = ${texName}Shape[2];
        float texR = float(row);
        float texC = dot(vec2(col, depth), vec2(stride1, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
        float ${funcName}(int row, int col, int depth) {
          float texR = float(row);
          float texC = dot(vec2(col, depth), vec2(${stride1}, 1));
          vec2 uv = (vec2(texC, texR) + halfCR) /
                     vec2(${texNumC}.0, ${texNumR}.0);
          return sampleTexture(${texName}, uv);
        }
      `;
  }
  if (texNumC === stride1 && flatOffset == null) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col, int depth) {
        float texR = dot(vec2(row, col), vec2(${texName}Shape[1], 1));
        float texC = float(depth);
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
    float ${funcName}(int row, int col, int depth) {
      float texR = dot(vec2(row, col), vec2(${shape[1]}, 1));
      float texC = float(depth);
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  const offset = getFlatOffsetUniformName(texName);
  if (enableShapeUniforms) {
    return `
    float ${funcName}(int row, int col, int depth) {
      // Explicitly use integer operations as dot() only works on floats.
      int stride0 = ${texName}Shape[1] * ${texName}Shape[2];
      int stride1 = ${texName}Shape[2];
      int index = row * ${stride0} + col * ${stride1} + depth + ${offset};
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
      return sampleTexture(${texName}, uv);
    }
    `;
  }
  return `
      float ${funcName}(int row, int col, int depth) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${stride0} + col * ${stride1} + depth + ${offset};
        vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
        return sampleTexture(${texName}, uv);
      }
  `;
}
function getPackedSamplerND(inputInfo, enableShapeUniforms) {
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const glsl = getGlslDifferences();
  if (enableShapeUniforms) {
    return `
    vec4 ${funcName}(int b2, int b, int row, int col) {
      int valuesPerRow = int(ceil(float(${texName}Shape[3]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[2]) / 2.0));
      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);
      texelsInBatch *= ${texName}Shape[1];
      index = b2 * texelsInBatch + index;
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int texR = index / packedTexShape[1];
      int texC = index - texR * packedTexShape[1];
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${glsl.texture2D}(${texName}, uv);
    }
  `;
  }
  const shape = inputInfo.shapeInfo.logicalShape;
  const rank = shape.length;
  const texShape = inputInfo.shapeInfo.texShape;
  const packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
  const texNumR = packedTexShape[0];
  const texNumC = packedTexShape[1];
  const valuesPerRow = Math.ceil(shape[rank - 1] / 2);
  let texelsInBatch = valuesPerRow * Math.ceil(shape[rank - 2] / 2);
  let params = `int b, int row, int col`;
  let index2 = `b * ${texelsInBatch} + (row / 2) * ${valuesPerRow} + (col / 2)`;
  for (let b2 = 2; b2 < rank - 1; b2++) {
    params = `int b${b2}, ` + params;
    texelsInBatch *= shape[rank - b2 - 1];
    index2 = `b${b2} * ${texelsInBatch} + ` + index2;
  }
  return `
    vec4 ${funcName}(${params}) {
      int index = ${index2};
      int texR = index / ${texNumC};
      int texC = index - texR * ${texNumC};
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}, ${texNumR});
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function getSampler4D(inputInfo, enableShapeUniforms) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const stride2 = shape[3];
  const stride1 = shape[2] * stride2;
  const stride0 = shape[1] * stride1;
  const { newShape, keptDims } = squeezeShape(shape);
  if (newShape.length < shape.length) {
    const newInputInfo = squeezeInputInfo(inputInfo, newShape);
    const params = ["row", "col", "depth", "depth2"];
    return `
      ${getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col, int depth, int depth2) {
        return ${funcName}(${getSqueezedParams(params, keptDims)});
      }
    `;
  }
  if (inputInfo.shapeInfo.isUniform) {
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        int index = round(dot(vec4(row, col, depth, depth2),
                          vec4(${stride0}, ${stride1}, ${stride2}, 1)));
        ${getUniformSampler(inputInfo)}
      }
    `;
  }
  const flatOffset = inputInfo.shapeInfo.flatOffset;
  const texShape = inputInfo.shapeInfo.texShape;
  const texNumR = texShape[0];
  const texNumC = texShape[1];
  const stride2Str = `int stride2 = ${texName}Shape[3];`;
  const stride1Str = `int stride1 = ${texName}Shape[2] * stride2;`;
  const stride0Str = `int stride0 = ${texName}Shape[1] * stride1;`;
  if (texNumC === stride0 && flatOffset == null) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        ${stride2Str}
        ${stride1Str}
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(stride1, stride2, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(${stride1}, ${stride2}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  if (texNumC === stride2 && flatOffset == null) {
    if (enableShapeUniforms) {
      return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${texName}Shape[1] * ${texName}Shape[2], ${texName}Shape[2], 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${shape[1] * shape[2]}, ${shape[2]}, 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  const offset = getFlatOffsetUniformName(texName);
  if (enableShapeUniforms) {
    return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      ${stride2Str}
      ${stride1Str}
      ${stride0Str}
      int index = row * stride0 + col * stride1 +
          depth * stride2 + depth2;
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
  }
  return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} +
          depth * ${stride2} + depth2;
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function getSampler5D(inputInfo) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const stride3 = shape[4];
  const stride2 = shape[3] * stride3;
  const stride1 = shape[2] * stride2;
  const stride0 = shape[1] * stride1;
  const { newShape, keptDims } = squeezeShape(shape);
  if (newShape.length < shape.length) {
    const newInputInfo = squeezeInputInfo(inputInfo, newShape);
    const params = ["row", "col", "depth", "depth2", "depth3"];
    return `
      ${getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        return ${funcName}(${getSqueezedParams(params, keptDims)});
      }
    `;
  }
  if (inputInfo.shapeInfo.isUniform) {
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float index = dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          depth3;
        ${getUniformSampler(inputInfo)}
      }
    `;
  }
  const flatOffset = inputInfo.shapeInfo.flatOffset;
  const texShape = inputInfo.shapeInfo.texShape;
  const texNumR = texShape[0];
  const texNumC = texShape[1];
  if (texNumC === stride0 && flatOffset == null) {
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
                         vec4(${stride1}, ${stride2}, ${stride3}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  if (texNumC === stride3 && flatOffset == null) {
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float texR = dot(
          vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3]},
               ${shape[2] * shape[3]}, ${shape[3]}, 1));
        int texC = depth3;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  const offset = getFlatOffsetUniformName(texName);
  return `
    float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function getSampler6D(inputInfo) {
  const shape = inputInfo.shapeInfo.logicalShape;
  const texName = inputInfo.name;
  const funcName = "get" + texName.charAt(0).toUpperCase() + texName.slice(1);
  const { newShape, keptDims } = squeezeShape(shape);
  if (newShape.length < shape.length) {
    const newInputInfo = squeezeInputInfo(inputInfo, newShape);
    const params = ["row", "col", "depth", "depth2", "depth3", "depth4"];
    return `
      ${getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        return ${funcName}(${getSqueezedParams(params, keptDims)});
      }
    `;
  }
  const stride4 = shape[5];
  const stride3 = shape[4] * stride4;
  const stride2 = shape[3] * stride3;
  const stride1 = shape[2] * stride2;
  const stride0 = shape[1] * stride1;
  if (inputInfo.shapeInfo.isUniform) {
    return `
      float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
        int index = round(dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          dot(
            vec2(depth3, depth4),
            vec2(${stride4}, 1)));
        ${getUniformSampler(inputInfo)}
      }
    `;
  }
  const flatOffset = inputInfo.shapeInfo.flatOffset;
  const texShape = inputInfo.shapeInfo.texShape;
  const texNumR = texShape[0];
  const texNumC = texShape[1];
  if (texNumC === stride0 && flatOffset == null) {
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
          vec4(${stride1}, ${stride2}, ${stride3}, ${stride4})) +
               float(depth4);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  if (texNumC === stride4 && flatOffset == null) {
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        float texR = dot(vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3] * shape[4]},
               ${shape[2] * shape[3] * shape[4]},
               ${shape[3] * shape[4]},
               ${shape[4]})) + float(depth3);
        int texC = depth4;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
  }
  const offset = getFlatOffsetUniformName(texName);
  return `
    float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 * ${stride4} + depth4 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function getUniformSampler(inputInfo) {
  const texName = inputInfo.name;
  const inSize = sizeFromShape(inputInfo.shapeInfo.logicalShape);
  if (inSize < 2) {
    return `return ${texName};`;
  }
  return `
    for (int i = 0; i < ${inSize}; i++) {
      if (i == index) {
        return ${texName}[i];
      }
    }
  `;
}
function getPackedSamplerAtOutputCoords(inputInfo, outShapeInfo) {
  const texName = inputInfo.name;
  const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
  const funcName = "get" + texFuncSnippet + "AtOutCoords";
  const inRank = inputInfo.shapeInfo.logicalShape.length;
  const outRank = outShapeInfo.logicalShape.length;
  const broadcastDims = getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
  const type = getCoordsDataType(outRank);
  const rankDiff = outRank - inRank;
  let coordsSnippet;
  const fields = ["x", "y", "z", "w", "u", "v"];
  if (inRank === 0) {
    coordsSnippet = "";
  } else if (outRank < 2 && broadcastDims.length >= 1) {
    coordsSnippet = "coords = 0;";
  } else {
    coordsSnippet = broadcastDims.map((d2) => `coords.${fields[d2 + rankDiff]} = 0;`).join("\n");
  }
  let unpackedCoordsSnippet = "";
  if (outRank < 2 && inRank > 0) {
    unpackedCoordsSnippet = "coords";
  } else {
    unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s2, i2) => `coords.${fields[i2 + rankDiff]}`).join(", ");
  }
  let output2 = `return outputValue;`;
  const inSize = sizeFromShape(inputInfo.shapeInfo.logicalShape);
  const isInputScalar = inSize === 1;
  const outSize = sizeFromShape(outShapeInfo.logicalShape);
  const isOutputScalar = outSize === 1;
  if (inRank === 1 && !isInputScalar && !isOutputScalar) {
    output2 = `
      return vec4(outputValue.xy, outputValue.xy);
    `;
  } else if (isInputScalar && !isOutputScalar) {
    if (outRank === 1) {
      output2 = `
        return vec4(outputValue.x, outputValue.x, 0., 0.);
      `;
    } else {
      output2 = `
        return vec4(outputValue.x);
      `;
    }
  } else if (broadcastDims.length) {
    const rows = inRank - 2;
    const cols = inRank - 1;
    if (broadcastDims.indexOf(rows) > -1 && broadcastDims.indexOf(cols) > -1) {
      output2 = `return vec4(outputValue.x);`;
    } else if (broadcastDims.indexOf(rows) > -1) {
      output2 = `return vec4(outputValue.x, outputValue.y, outputValue.x, outputValue.y);`;
    } else if (broadcastDims.indexOf(cols) > -1) {
      output2 = `return vec4(outputValue.xx, outputValue.zz);`;
    }
  }
  return `
    vec4 ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      vec4 outputValue = get${texFuncSnippet}(${unpackedCoordsSnippet});
      ${output2}
    }
  `;
}
function getSamplerAtOutputCoords(inputInfo, outShapeInfo) {
  const texName = inputInfo.name;
  const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
  const funcName = "get" + texFuncSnippet + "AtOutCoords";
  const outTexShape = outShapeInfo.texShape;
  const inTexShape = inputInfo.shapeInfo.texShape;
  const inRank = inputInfo.shapeInfo.logicalShape.length;
  const outRank = outShapeInfo.logicalShape.length;
  if (!inputInfo.shapeInfo.isUniform && inRank === outRank && inputInfo.shapeInfo.flatOffset == null && arraysEqual(inTexShape, outTexShape)) {
    return `
      float ${funcName}() {
        return sampleTexture(${texName}, resultUV);
      }
    `;
  }
  const type = getCoordsDataType(outRank);
  const broadcastDims = getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
  const rankDiff = outRank - inRank;
  let coordsSnippet;
  const fields = ["x", "y", "z", "w", "u", "v"];
  if (inRank === 0) {
    coordsSnippet = "";
  } else if (outRank < 2 && broadcastDims.length >= 1) {
    coordsSnippet = "coords = 0;";
  } else {
    coordsSnippet = broadcastDims.map((d2) => `coords.${fields[d2 + rankDiff]} = 0;`).join("\n");
  }
  let unpackedCoordsSnippet = "";
  if (outRank < 2 && inRank > 0) {
    unpackedCoordsSnippet = "coords";
  } else {
    unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s2, i2) => `coords.${fields[i2 + rankDiff]}`).join(", ");
  }
  return `
    float ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      return get${texFuncSnippet}(${unpackedCoordsSnippet});
    }
  `;
}
function getCoordsDataType(rank) {
  if (rank <= 1) {
    return "int";
  } else if (rank === 2) {
    return "ivec2";
  } else if (rank === 3) {
    return "ivec3";
  } else if (rank === 4) {
    return "ivec4";
  } else if (rank === 5) {
    return "ivec5";
  } else if (rank === 6) {
    return "ivec6";
  } else {
    throw Error(`GPU for rank ${rank} is not yet supported`);
  }
}
function getUniformInfoFromShape(isPacked, shape, texShape) {
  const { newShape, keptDims } = squeezeShape(shape);
  const rank = shape.length;
  const useSqueezePackedShape = isPacked && rank === 3 && shape[0] === 1;
  const squeezeShape$1 = useSqueezePackedShape ? shape.slice(1) : newShape;
  const useSqueezeShape = !isPacked && rank > 1 && !arraysEqual(shape, texShape) && newShape.length < rank || useSqueezePackedShape;
  const uniformShape = useSqueezeShape ? squeezeShape$1 : shape;
  return { useSqueezeShape, uniformShape, keptDims };
}
function squeezeInputInfo(inInfo, squeezedShape) {
  const newInputInfo = JSON.parse(JSON.stringify(inInfo));
  newInputInfo.shapeInfo.logicalShape = squeezedShape;
  return newInputInfo;
}
function getSqueezedParams(params, keptDims) {
  return keptDims.map((d2) => params[d2]).join(", ");
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function compileProgram(gpgpu, program, inputs, output2) {
  const inputInfos = inputs.map((input, i2) => {
    const shapeInfo = {
      logicalShape: input.shape,
      texShape: input.isUniform ? null : input.texData.texShape,
      isUniform: input.isUniform,
      isPacked: input.isUniform ? false : input.texData.isPacked,
      flatOffset: null
    };
    if (input.texData != null && input.texData.slice != null && input.texData.slice.flatOffset > 0) {
      shapeInfo.flatOffset = input.texData.slice.flatOffset;
    }
    return { name: program.variableNames[i2], shapeInfo };
  });
  const inShapeInfos = inputInfos.map((x2) => x2.shapeInfo);
  const outShapeInfo = {
    logicalShape: output2.shape,
    texShape: output2.texData.texShape,
    isUniform: false,
    isPacked: output2.texData.isPacked,
    flatOffset: null
  };
  const source2 = makeShader(inputInfos, outShapeInfo, program);
  const fragmentShader = createFragmentShader(gpgpu.gl, source2);
  const webGLProgram = gpgpu.createProgram(fragmentShader);
  if (!env().get("ENGINE_COMPILE_ONLY")) {
    return Object.assign({
      program,
      fragmentShader,
      source: source2,
      webGLProgram,
      inShapeInfos,
      outShapeInfo
    }, getUniformLocations(gpgpu, program, webGLProgram));
  } else {
    return {
      program,
      fragmentShader,
      source: source2,
      webGLProgram,
      inShapeInfos,
      outShapeInfo,
      uniformLocations: null,
      customUniformLocations: null,
      infLoc: null,
      nanLoc: null,
      inShapesLocations: null,
      inTexShapesLocations: null,
      outShapeLocation: null,
      outShapeStridesLocation: null,
      outTexShapeLocation: null
    };
  }
}
function getUniformLocations(gpgpu, program, webGLProgram) {
  const uniformLocations = {};
  const inShapesLocations = {};
  const inTexShapesLocations = {};
  const customUniformLocations = [];
  let outShapeLocation;
  let outTexShapeLocation;
  let outShapeStridesLocation;
  let infLoc = null;
  let nanLoc = null;
  nanLoc = gpgpu.getUniformLocation(webGLProgram, "NAN", false);
  if (env().getNumber("WEBGL_VERSION") === 1) {
    infLoc = gpgpu.getUniformLocation(webGLProgram, "INFINITY", false);
  }
  const shouldThrow = false;
  for (let i2 = 0; i2 < program.variableNames.length; i2++) {
    const varName = program.variableNames[i2];
    uniformLocations[varName] = gpgpu.getUniformLocation(webGLProgram, varName, shouldThrow);
    uniformLocations[`offset${varName}`] = gpgpu.getUniformLocation(webGLProgram, `offset${varName}`, shouldThrow);
    if (program.enableShapeUniforms) {
      inShapesLocations[`${varName}Shape`] = gpgpu.getUniformLocation(webGLProgram, `${varName}Shape`, shouldThrow);
      inTexShapesLocations[`${varName}TexShape`] = gpgpu.getUniformLocation(webGLProgram, `${varName}TexShape`, shouldThrow);
    }
  }
  if (program.enableShapeUniforms) {
    outShapeLocation = gpgpu.getUniformLocation(webGLProgram, "outShape", shouldThrow);
    outShapeStridesLocation = gpgpu.getUniformLocation(webGLProgram, "outShapeStrides", shouldThrow);
    outTexShapeLocation = gpgpu.getUniformLocation(webGLProgram, "outTexShape", shouldThrow);
  }
  if (program.customUniforms) {
    program.customUniforms.forEach((d2, i2) => {
      customUniformLocations[i2] = gpgpu.getUniformLocation(webGLProgram, d2.name, shouldThrow);
    });
  }
  return {
    uniformLocations,
    customUniformLocations,
    infLoc,
    nanLoc,
    inShapesLocations,
    inTexShapesLocations,
    outShapeLocation,
    outShapeStridesLocation,
    outTexShapeLocation
  };
}
function validateBinaryAndProgram(shapeInfos, inputs) {
  if (shapeInfos.length !== inputs.length) {
    throw Error(`Binary was compiled with ${shapeInfos.length} inputs, but was executed with ${inputs.length} inputs`);
  }
  shapeInfos.forEach((s2, i2) => {
    const shapeA = s2.logicalShape;
    const input = inputs[i2];
    const shapeB = input.shape;
    if (!arraysEqual(shapeA, shapeB)) {
      throw Error(`Binary was compiled with different shapes than the current args. Shapes ${shapeA} and ${shapeB} must match`);
    }
    if (s2.isUniform && input.isUniform) {
      return;
    }
    const texShapeA = s2.texShape;
    const texShapeB = input.isUniform ? null : input.texData.texShape;
    if (!arraysEqual(texShapeA, texShapeB)) {
      throw Error(`Binary was compiled with different texture shapes than the current args. Shape ${texShapeA} and ${texShapeB} must match`);
    }
  });
}
function runProgram(gpgpu, binary, inputs, output2, customUniformValues) {
  if (!binary.program.enableShapeUniforms) {
    validateBinaryAndProgram(binary.inShapeInfos, inputs);
    validateBinaryAndProgram([binary.outShapeInfo], [output2]);
  }
  const outTex = output2.texData.texture;
  const outTexShape = output2.texData.texShape;
  if (output2.texData.isPacked) {
    gpgpu.setOutputPackedMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
  } else {
    gpgpu.setOutputMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
  }
  gpgpu.setProgram(binary.webGLProgram);
  if (env().getNumber("WEBGL_VERSION") === 1) {
    if (binary.infLoc !== null) {
      gpgpu.gl.uniform1f(binary.infLoc, Infinity);
    }
  }
  if (binary.nanLoc !== null) {
    gpgpu.gl.uniform1f(binary.nanLoc, NaN);
  }
  inputs.forEach((input, i2) => {
    const varName = binary.program.variableNames[i2];
    const varLoc = binary.uniformLocations[varName];
    const varOffsetLoc = binary.uniformLocations[`offset${varName}`];
    const varShapeLoc = binary.inShapesLocations[`${varName}Shape`];
    const varTexShapeLoc = binary.inTexShapesLocations[`${varName}TexShape`];
    if (varShapeLoc) {
      const { uniformShape } = getUniformInfoFromShape(binary.program.packedInputs, input.shape, input.texData.texShape);
      switch (uniformShape.length) {
        case 1:
          gpgpu.gl.uniform1iv(varShapeLoc, new Int32Array(uniformShape));
          break;
        case 2:
          gpgpu.gl.uniform2iv(varShapeLoc, new Int32Array(uniformShape));
          break;
        case 3:
          gpgpu.gl.uniform3iv(varShapeLoc, new Int32Array(uniformShape));
          break;
        case 4:
          gpgpu.gl.uniform4iv(varShapeLoc, new Int32Array(uniformShape));
          break;
      }
    }
    if (varTexShapeLoc) {
      gpgpu.gl.uniform2i(varTexShapeLoc, input.texData.texShape[0], input.texData.texShape[1]);
    }
    if (varLoc == null) {
      return;
    }
    if (input.isUniform) {
      if (sizeFromShape(input.shape) < 2) {
        gpgpu.gl.uniform1f(varLoc, input.uniformValues[0]);
      } else {
        let vals = input.uniformValues;
        if (!(vals instanceof Float32Array)) {
          vals = new Float32Array(vals);
        }
        gpgpu.gl.uniform1fv(varLoc, vals);
      }
      return;
    }
    if (input.texData.slice != null && varOffsetLoc != null) {
      gpgpu.gl.uniform1i(varOffsetLoc, input.texData.slice.flatOffset);
    }
    gpgpu.setInputMatrixTexture(input.texData.texture.texture, varLoc, i2);
  });
  const outShapeLoc = binary.outShapeLocation;
  if (outShapeLoc) {
    switch (output2.shape.length) {
      case 1:
        gpgpu.gl.uniform1iv(outShapeLoc, new Int32Array(output2.shape));
        break;
      case 2:
        gpgpu.gl.uniform2iv(outShapeLoc, new Int32Array(output2.shape));
        break;
      case 3:
        gpgpu.gl.uniform3iv(outShapeLoc, new Int32Array(output2.shape));
        break;
      case 4:
        gpgpu.gl.uniform4iv(outShapeLoc, new Int32Array(output2.shape));
        break;
    }
  }
  if (binary.outShapeStridesLocation) {
    const strides = computeStrides(output2.shape);
    switch (output2.shape.length) {
      case 2:
        gpgpu.gl.uniform1iv(binary.outShapeStridesLocation, new Int32Array(strides));
        break;
      case 3:
        gpgpu.gl.uniform2iv(binary.outShapeStridesLocation, new Int32Array(strides));
        break;
      case 4:
        gpgpu.gl.uniform3iv(binary.outShapeStridesLocation, new Int32Array(strides));
        break;
    }
  }
  if (binary.outTexShapeLocation) {
    gpgpu.gl.uniform2i(binary.outTexShapeLocation, output2.texData.texShape[0], output2.texData.texShape[1]);
  }
  if (binary.program.customUniforms && customUniformValues) {
    binary.program.customUniforms.forEach((d2, i2) => {
      const customLoc = binary.customUniformLocations[i2];
      const customValue = customUniformValues[i2];
      if (d2.type === "float") {
        gpgpu.gl.uniform1fv(customLoc, customValue);
      } else if (d2.type === "vec2") {
        gpgpu.gl.uniform2fv(customLoc, customValue);
      } else if (d2.type === "vec3") {
        gpgpu.gl.uniform3fv(customLoc, customValue);
      } else if (d2.type === "vec4") {
        gpgpu.gl.uniform4fv(customLoc, customValue);
      } else if (d2.type === "int") {
        gpgpu.gl.uniform1iv(customLoc, customValue);
      } else if (d2.type === "ivec2") {
        gpgpu.gl.uniform2iv(customLoc, customValue);
      } else if (d2.type === "ivec3") {
        gpgpu.gl.uniform3iv(customLoc, customValue);
      } else if (d2.type === "ivec4") {
        gpgpu.gl.uniform4iv(customLoc, customValue);
      } else {
        throw Error(`uniform type ${d2.type} is not supported yet.`);
      }
    });
  }
  gpgpu.executeProgram();
}
function makeShaderKey(program, inputs, output2) {
  let keyInputs = "";
  inputs.concat(output2).forEach((x2) => {
    const hasOffset = x2.texData != null && x2.texData.slice != null && x2.texData.slice.flatOffset > 0;
    if (program.enableShapeUniforms && !x2.isUniform) {
      const xTexShape = x2.texData.texShape;
      const { useSqueezeShape, uniformShape, keptDims } = getUniformInfoFromShape(program.packedInputs, x2.shape, xTexShape);
      let rank1 = "", rank2 = "", rank34 = "";
      if (uniformShape.length === 1 && program.packedInputs) {
        const packedTexShape = [Math.ceil(xTexShape[0] / 2), Math.ceil(xTexShape[1] / 2)];
        rank1 = `${packedTexShape[0] > 1}_${packedTexShape[1] > 1}`;
      } else if (uniformShape.length === 2 && !program.packedInputs) {
        rank2 = `${uniformShape[0] > 1}_${uniformShape[1] > 1}`;
      } else if (uniformShape.length > 2 && !program.packedInputs) {
        const strides = computeStrides(uniformShape);
        rank34 = `${strides[0] === xTexShape[1]}_${strides[strides.length - 1] === xTexShape[1]}`;
      }
      const xRank = x2.shape.length;
      const isLogicalShapTexShapeEqual = uniformShape.length === 2 && arraysEqual(x2.shape, xTexShape);
      const isScalar = sizeFromShape(x2.shape) === 1;
      const broadcastDims = getBroadcastDims$1(x2.shape, output2.shape);
      const isInOutTexShapeEqual = !program.packedInputs && xRank === output2.shape.length && arraysEqual(xTexShape, output2.texData.texShape);
      const isTexShapeGreaterThanOne = program.packedInputs || uniformShape.length > 2 ? "" : `${xTexShape[0] > 1}_${xTexShape[1] > 1}`;
      keyInputs += `${xRank}_${isInOutTexShapeEqual}_${useSqueezeShape ? keptDims : ""}_${uniformShape.length}_${isScalar}_${broadcastDims}_${isLogicalShapTexShapeEqual}_${rank1}_${rank2}_${rank34}_${isTexShapeGreaterThanOne}_${hasOffset}`;
    } else {
      const texShape = x2.isUniform ? "uniform" : x2.texData.texShape;
      keyInputs += `${x2.shape}_${texShape}_${hasOffset}`;
    }
  });
  const keyUserCode = program.userCode;
  let key = program.constructor.name;
  key += "_" + keyInputs + "_" + keyUserCode + `${env().getNumber("WEBGL_VERSION")}`;
  return key;
}
function useShapeUniforms(rank) {
  return env().getBool("WEBGL_USE_SHAPES_UNIFORMS") && rank <= 4;
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DecodeMatrixProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.packedInputs = false;
    this.packedOutput = true;
    this.outPackingScheme = PackingScheme.DENSE;
    this.customUniforms = [{ name: "texShape", type: "ivec2" }];
    const glsl = getGlslDifferences();
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? getOutputLogicalCoordinatesFromFlatIndexByUniform(["r", "c", "d"], outputShape) : getLogicalCoordinatesFromFlatIndex(["r", "c", "d"], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getA(rc.x, rc.y, rc.z);
        }

        ${glsl.output} = result;
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DecodeMatrixPackedProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outPackingScheme = PackingScheme.DENSE;
    this.customUniforms = [{ name: "texShape", type: "ivec2" }];
    const glsl = getGlslDifferences();
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? getOutputLogicalCoordinatesFromFlatIndexByUniform(["r", "c", "d"], outputShape) : getLogicalCoordinatesFromFlatIndex(["r", "c", "d"], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));
        }

        ${glsl.output} = result;
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class EncodeFloatProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.outTexUsage = TextureUsage.DOWNLOAD;
    const glsl = getGlslDifferences();
    this.outputShape = outputShape;
    this.userCode = `
      ${ENCODE_FLOAT_SNIPPET}

      void main() {
        float x = getAAtOutCoords();
        ${glsl.output} = encode_float(x);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class EncodeFloatPackedProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = false;
    this.outTexUsage = TextureUsage.DOWNLOAD;
    const glsl = getGlslDifferences();
    this.outputShape = outputShape;
    this.userCode = `
      ${ENCODE_FLOAT_SNIPPET}

      void main() {
        ivec3 coords = getOutputCoords();
        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));
        ${glsl.output} = encode_float(x);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class EncodeMatrixProgram {
  constructor(outputShape, inputIsUnsignedByte = false) {
    this.variableNames = ["A"];
    this.customUniforms = [{ name: "texShape", type: "ivec2" }];
    const glsl = getGlslDifferences();
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    let output2 = `result`;
    if (inputIsUnsignedByte) {
      output2 = `floor(result * 255. + 0.5)`;
    }
    this.userCode = `
      ${this.enableShapeUniforms ? getFlatIndexFrom3DOutput() : getFlatIndexFrom3D(outputShape)}

      void main() {
        ivec3 coords = getOutputCoords();

        int flatIndex = getFlatIndex(coords);
        int offset = imod(flatIndex, 4);

        flatIndex = idiv(flatIndex, 4, 1.);

        int r = flatIndex / texShape[1];
        int c = imod(flatIndex, texShape[1]);
        vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
        vec4 values = ${glsl.texture2D}(A, uv);

        float result;

        if(offset == 0) {
          result = values[0];
        } else if(offset == 1) {
          result = values[1];
        } else if(offset == 2) {
          result = values[2];
        } else {
          result = values[3];
        }

        ${glsl.output} = vec4(${output2}, 0., 0., 0.);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class EncodeMatrixPackedProgram {
  constructor(outputShape, inputIsUnsignedByte = false) {
    this.variableNames = ["A"];
    this.packedInputs = false;
    this.packedOutput = true;
    this.customUniforms = [{ name: "texShape", type: "ivec2" }];
    const glsl = getGlslDifferences();
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    let mainLoop = "";
    let output2 = "result";
    if (inputIsUnsignedByte) {
      output2 = "floor(result * 255. + 0.5)";
    }
    for (let row = 0; row <= 1; row++) {
      for (let col = 0; col <= 1; col++) {
        const channel = row * 2 + col;
        mainLoop += `
          localCoords = coords;
          if(localCoords[2] + ${col} < ${this.enableShapeUniforms ? "outShape[2]" : `${outputShape[2]}`}) {
          localCoords[2] += ${col};
          if (localCoords[1] + ${row} < ${this.enableShapeUniforms ? "outShape[1]" : `${outputShape[1]}`}) {
            localCoords[1] += ${row};

            flatIndex = getFlatIndex(localCoords);
            offset = imod(flatIndex, 4);

            flatIndex = idiv(flatIndex, 4, 1.);

            int r = flatIndex / texShape[1];
            int c = imod(flatIndex, texShape[1]);
            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
            values = ${glsl.texture2D}(A, uv);

            if (offset == 0) {
              result[${channel}] = values[0];
            } else if (offset == 1) {
              result[${channel}] = values[1];
            } else if (offset == 2) {
              result[${channel}] = values[2];
            } else {
              result[${channel}] = values[3];
            }
          }
        }
        `;
      }
    }
    this.userCode = `
        ${this.enableShapeUniforms ? getFlatIndexFrom3DOutput() : getFlatIndexFrom3D(outputShape)}

        void main() {
          ivec3 coords = getOutputCoords();

          vec4 result = vec4(0.);
          int flatIndex, r, c, offset;
          ivec3 localCoords;
          vec2 uv;
          vec4 values;

          ${mainLoop}

          ${glsl.output} = ${output2};
        }
    `;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function createVertexShader(gl) {
  const glsl = getGlslDifferences();
  const vertexShaderSource = `${glsl.version}
    precision highp float;
    ${glsl.attribute} vec3 clipSpacePos;
    ${glsl.attribute} vec2 uv;
    ${glsl.varyingVs} vec2 resultUV;

    void main() {
      gl_Position = vec4(clipSpacePos, 1);
      resultUV = uv;
    }`;
  return createVertexShader$1(gl, vertexShaderSource);
}
function createVertexBuffer(gl) {
  const vertexArray = new Float32Array([-1, 1, 0, 0, 1, -1, -1, 0, 0, 0, 1, 1, 0, 1, 1, 1, -1, 0, 1, 0]);
  return createStaticVertexBuffer(gl, vertexArray);
}
function createIndexBuffer(gl) {
  const triangleVertexIndices = new Uint16Array([0, 1, 2, 2, 1, 3]);
  return createStaticIndexBuffer(gl, triangleVertexIndices);
}
function createAndConfigureTexture(gl, width2, height2, internalFormat, textureFormat, textureType) {
  validateTextureSize(width2, height2);
  const texture = createTexture(gl);
  const tex2d = gl.TEXTURE_2D;
  callAndCheck(gl, () => gl.bindTexture(tex2d, texture));
  callAndCheck(gl, () => gl.texParameteri(tex2d, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE));
  callAndCheck(gl, () => gl.texParameteri(tex2d, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE));
  callAndCheck(gl, () => gl.texParameteri(tex2d, gl.TEXTURE_MIN_FILTER, gl.NEAREST));
  callAndCheck(gl, () => gl.texParameteri(tex2d, gl.TEXTURE_MAG_FILTER, gl.NEAREST));
  if (env().getNumber("WEBGL_VERSION") === 1) {
    callAndCheck(gl, () => gl.texImage2D(tex2d, 0, internalFormat, width2, height2, 0, textureFormat, textureType, null));
  } else {
    callAndCheck(gl, () => gl.texStorage2D(tex2d, 1, internalFormat, width2, height2));
  }
  callAndCheck(gl, () => gl.bindTexture(gl.TEXTURE_2D, null));
  return { texture, texShape: [height2, width2] };
}
function getInternalFormatForFloat32MatrixTexture(textureConfig) {
  return textureConfig.internalFormatFloat;
}
function createFloat32MatrixTexture(gl, rows, columns, textureConfig) {
  const [width2, height2] = getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
  return createAndConfigureTexture(gl, width2, height2, getInternalFormatForFloat32MatrixTexture(textureConfig), textureConfig.textureFormatFloat, gl.FLOAT);
}
function getInternalFormatForFloat16MatrixTexture(textureConfig) {
  return textureConfig.internalFormatHalfFloat;
}
function createFloat16MatrixTexture(gl, rows, columns, textureConfig) {
  const [width2, height2] = getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
  return createAndConfigureTexture(gl, width2, height2, getInternalFormatForFloat16MatrixTexture(textureConfig), textureConfig.textureFormatFloat, textureConfig.textureTypeHalfFloat);
}
function getInternalFormatForUnsignedBytesMatrixTexture(textureConfig) {
  return textureConfig.downloadTextureFormat;
}
function createUnsignedBytesMatrixTexture(gl, rows, columns, textureConfig) {
  const [width2, height2] = getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
  return createAndConfigureTexture(gl, width2, height2, getInternalFormatForUnsignedBytesMatrixTexture(textureConfig), gl.RGBA, gl.UNSIGNED_BYTE);
}
function getInternalFormatForPackedMatrixTexture(textureConfig) {
  return textureConfig.internalFormatPackedFloat;
}
function createPackedMatrixTexture(gl, rows, columns, textureConfig) {
  const [width2, height2] = getPackedMatrixTextureShapeWidthHeight(rows, columns);
  return createAndConfigureTexture(gl, width2, height2, getInternalFormatForPackedMatrixTexture(textureConfig), gl.RGBA, gl.FLOAT);
}
function getInternalFormatForFloat16PackedMatrixTexture(textureConfig) {
  return textureConfig.internalFormatPackedHalfFloat;
}
function createFloat16PackedMatrixTexture(gl, rows, columns, textureConfig) {
  const [width2, height2] = getPackedMatrixTextureShapeWidthHeight(rows, columns);
  return createAndConfigureTexture(gl, width2, height2, getInternalFormatForFloat16PackedMatrixTexture(textureConfig), gl.RGBA, textureConfig.textureTypeHalfFloat);
}
function bindVertexProgramAttributeStreams(gl, program, vertexBuffer) {
  const posOffset = 0;
  const uvOffset = 3 * 4;
  const stride = 3 * 4 + 2 * 4;
  callAndCheck(gl, () => gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer));
  const success = bindVertexBufferToProgramAttribute(gl, program, "clipSpacePos", vertexBuffer, 3, stride, posOffset);
  return success && bindVertexBufferToProgramAttribute(gl, program, "uv", vertexBuffer, 2, stride, uvOffset);
}
function uploadDenseMatrixToTexture(gl, texture, width2, height2, data2, textureConfig) {
  callAndCheck(gl, () => gl.bindTexture(gl.TEXTURE_2D, texture));
  let dataForUpload, texelDataType, internalFormat;
  if (data2 instanceof Uint8Array) {
    dataForUpload = new Uint8Array(width2 * height2 * 4);
    texelDataType = gl.UNSIGNED_BYTE;
    internalFormat = gl.RGBA;
  } else {
    dataForUpload = new Float32Array(width2 * height2 * 4);
    texelDataType = gl.FLOAT;
    internalFormat = textureConfig.internalFormatPackedFloat;
  }
  dataForUpload.set(data2);
  if (env().getNumber("WEBGL_VERSION") === 2) {
    callAndCheck(gl, () => gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width2, height2, gl.RGBA, texelDataType, dataForUpload));
  } else {
    callAndCheck(gl, () => gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width2, height2, 0, gl.RGBA, texelDataType, dataForUpload));
  }
  callAndCheck(gl, () => gl.bindTexture(gl.TEXTURE_2D, null));
}
function uploadPixelDataToTexture(gl, texture, pixels) {
  callAndCheck(gl, () => gl.bindTexture(gl.TEXTURE_2D, texture));
  if (pixels.data instanceof Uint8Array) {
    if (env().getNumber("WEBGL_VERSION") === 2) {
      callAndCheck(gl, () => gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, pixels.width, pixels.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
    } else {
      callAndCheck(gl, () => gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pixels.width, pixels.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
    }
  } else {
    if (env().getNumber("WEBGL_VERSION") === 2) {
      callAndCheck(gl, () => gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    } else {
      callAndCheck(gl, () => gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    }
  }
  callAndCheck(gl, () => gl.bindTexture(gl.TEXTURE_2D, null));
}
function createBufferFromOutputTexture(gl2, rows, columns, textureConfig) {
  const buffer2 = gl2.createBuffer();
  callAndCheck(gl2, () => gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer2));
  const bytesPerFloat = 4;
  const valuesPerTexel = 4;
  const bufferSizeBytes = bytesPerFloat * valuesPerTexel * rows * columns;
  callAndCheck(gl2, () => gl2.bufferData(gl2.PIXEL_PACK_BUFFER, bufferSizeBytes, gl2.STREAM_READ));
  callAndCheck(gl2, () => gl2.readPixels(0, 0, columns, rows, gl2.RGBA, gl2.FLOAT, 0));
  callAndCheck(gl2, () => gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null));
  return buffer2;
}
function downloadFloat32MatrixFromBuffer(gl, buffer2, size) {
  const gl2 = gl;
  const downloadTarget = new Float32Array(size);
  gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer2);
  gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
  gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
  return downloadTarget;
}
function downloadByteEncodedFloatMatrixFromOutputTexture(gl, rows, columns, textureConfig) {
  const [w2, h2] = getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
  const numChannels = 4;
  const downloadTarget = new Uint8Array(getUnpackedArraySizeFromMatrixSize(rows * columns, numChannels));
  callAndCheck(gl, () => gl.readPixels(0, 0, w2, h2, textureConfig.downloadTextureFormat, gl.UNSIGNED_BYTE, downloadTarget));
  return new Float32Array(downloadTarget.buffer);
}
function downloadPackedMatrixFromBuffer(gl, buffer2, batch, rows, cols, physicalRows, physicalCols, textureConfig) {
  const gl2 = gl;
  const downloadTarget = new Float32Array(getPackedRGBAArraySizeFromMatrixShape(physicalRows, physicalCols));
  gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer2);
  gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
  gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
  return downloadTarget;
}
function downloadMatrixFromPackedOutputTexture(gl, physicalRows, physicalCols) {
  const packedRGBA = new Float32Array(physicalRows * physicalCols * 4);
  callAndCheck(gl, () => gl.readPixels(0, 0, physicalCols, physicalRows, gl.RGBA, gl.FLOAT, packedRGBA));
  return packedRGBA;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class GPGPUContext {
  constructor(gl) {
    this.outputTexture = null;
    this.program = null;
    this.disposed = false;
    this.vertexAttrsAreBound = false;
    this.itemsToPoll = [];
    const glVersion = env().getNumber("WEBGL_VERSION");
    if (gl != null) {
      this.gl = gl;
      setWebGLContext(glVersion, gl);
    } else {
      this.gl = getWebGLContext(glVersion);
    }
    let COLOR_BUFFER_FLOAT = "WEBGL_color_buffer_float";
    const COLOR_BUFFER_HALF_FLOAT = "EXT_color_buffer_half_float";
    this.parallelCompilationExtension = this.gl.getExtension("KHR_parallel_shader_compile");
    if (env().getNumber("WEBGL_VERSION") === 1) {
      const TEXTURE_FLOAT = "OES_texture_float";
      const TEXTURE_HALF_FLOAT = "OES_texture_half_float";
      this.textureFloatExtension = getExtensionOrThrow(this.gl, TEXTURE_FLOAT);
      if (hasExtension(this.gl, TEXTURE_HALF_FLOAT)) {
        this.textureHalfFloatExtension = getExtensionOrThrow(this.gl, TEXTURE_HALF_FLOAT);
      } else if (env().get("WEBGL_FORCE_F16_TEXTURES")) {
        throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
      }
      this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
      if (hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) {
        this.colorBufferHalfFloatExtension = getExtensionOrThrow(this.gl, COLOR_BUFFER_HALF_FLOAT);
      } else if (env().get("WEBGL_FORCE_F16_TEXTURES")) {
        throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
      }
    } else {
      COLOR_BUFFER_FLOAT = "EXT_color_buffer_float";
      if (hasExtension(this.gl, COLOR_BUFFER_FLOAT)) {
        this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
      } else if (hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) {
        this.colorBufferHalfFloatExtension = this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
      } else {
        throw new Error("GL context does not support color renderable floats");
      }
    }
    this.vertexBuffer = createVertexBuffer(this.gl);
    this.indexBuffer = createIndexBuffer(this.gl);
    this.framebuffer = createFramebuffer(this.gl);
    this.textureConfig = getTextureConfig(this.gl, this.textureHalfFloatExtension);
  }
  get debug() {
    return env().getBool("DEBUG");
  }
  dispose() {
    if (this.disposed) {
      return;
    }
    if (this.program != null) {
      console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing.");
    }
    if (this.outputTexture != null) {
      console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
    }
    const gl = this.gl;
    callAndCheck(gl, () => gl.finish());
    callAndCheck(gl, () => gl.bindFramebuffer(gl.FRAMEBUFFER, null));
    callAndCheck(gl, () => gl.deleteFramebuffer(this.framebuffer));
    callAndCheck(gl, () => gl.bindBuffer(gl.ARRAY_BUFFER, null));
    callAndCheck(gl, () => gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null));
    callAndCheck(gl, () => gl.deleteBuffer(this.indexBuffer));
    this.disposed = true;
  }
  createFloat32MatrixTexture(rows, columns) {
    this.throwIfDisposed();
    return createFloat32MatrixTexture(this.gl, rows, columns, this.textureConfig);
  }
  createFloat16MatrixTexture(rows, columns) {
    this.throwIfDisposed();
    return createFloat16MatrixTexture(this.gl, rows, columns, this.textureConfig);
  }
  createUnsignedBytesMatrixTexture(rows, columns) {
    this.throwIfDisposed();
    return createUnsignedBytesMatrixTexture(this.gl, rows, columns, this.textureConfig);
  }
  uploadPixelDataToTexture(texture, pixels) {
    this.throwIfDisposed();
    uploadPixelDataToTexture(this.gl, texture, pixels);
  }
  uploadDenseMatrixToTexture(texture, width2, height2, data2) {
    this.throwIfDisposed();
    uploadDenseMatrixToTexture(this.gl, texture, width2, height2, data2, this.textureConfig);
  }
  createFloat16PackedMatrixTexture(rows, columns) {
    this.throwIfDisposed();
    return createFloat16PackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
  }
  createPackedMatrixTexture(rows, columns) {
    this.throwIfDisposed();
    return createPackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
  }
  deleteMatrixTexture(texture) {
    this.throwIfDisposed();
    if (this.outputTexture === texture) {
      unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
      this.outputTexture = null;
    }
    callAndCheck(this.gl, () => this.gl.deleteTexture(texture));
  }
  downloadByteEncodedFloatMatrixFromOutputTexture(texture, rows, columns) {
    return this.downloadMatrixDriver(texture, () => downloadByteEncodedFloatMatrixFromOutputTexture(this.gl, rows, columns, this.textureConfig));
  }
  downloadPackedMatrixFromBuffer(buffer2, batch, rows, columns, physicalRows, physicalCols) {
    return downloadPackedMatrixFromBuffer(this.gl, buffer2, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
  }
  downloadFloat32MatrixFromBuffer(buffer2, size) {
    return downloadFloat32MatrixFromBuffer(this.gl, buffer2, size);
  }
  createBufferFromTexture(texture, rows, columns) {
    this.bindTextureToFrameBuffer(texture);
    const result2 = createBufferFromOutputTexture(this.gl, rows, columns, this.textureConfig);
    this.unbindTextureToFrameBuffer();
    return result2;
  }
  createAndWaitForFence() {
    const fenceContext = this.createFence(this.gl);
    return this.pollFence(fenceContext);
  }
  createFence(gl) {
    let query;
    let isFencePassed;
    if (env().getBool("WEBGL_FENCE_API_ENABLED")) {
      const gl2 = gl;
      const sync2 = gl2.fenceSync(gl2.SYNC_GPU_COMMANDS_COMPLETE, 0);
      gl.flush();
      isFencePassed = () => {
        const status = gl2.clientWaitSync(sync2, 0, 0);
        return status === gl2.ALREADY_SIGNALED || status === gl2.CONDITION_SATISFIED;
      };
      query = sync2;
    } else if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0) {
      query = this.beginQuery();
      this.endQuery();
      isFencePassed = () => this.isQueryAvailable(query, env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
    } else {
      isFencePassed = () => true;
    }
    return { query, isFencePassed };
  }
  downloadMatrixFromPackedTexture(texture, physicalRows, physicalCols) {
    return this.downloadMatrixDriver(texture, () => downloadMatrixFromPackedOutputTexture(this.gl, physicalRows, physicalCols));
  }
  createProgram(fragmentShader) {
    this.throwIfDisposed();
    const gl = this.gl;
    if (this.vertexShader == null) {
      this.vertexShader = createVertexShader(gl);
    }
    const program = createProgram(gl);
    callAndCheck(gl, () => gl.attachShader(program, this.vertexShader));
    callAndCheck(gl, () => gl.attachShader(program, fragmentShader));
    linkProgram(gl, program);
    if (this.debug) {
      validateProgram(gl, program);
    }
    if (!this.vertexAttrsAreBound) {
      this.setProgram(program);
      this.vertexAttrsAreBound = bindVertexProgramAttributeStreams(gl, this.program, this.vertexBuffer);
    }
    return program;
  }
  deleteProgram(program) {
    this.throwIfDisposed();
    if (program === this.program) {
      this.program = null;
    }
    if (program != null) {
      callAndCheck(this.gl, () => this.gl.deleteProgram(program));
    }
  }
  setProgram(program) {
    this.throwIfDisposed();
    this.program = program;
    if (this.program != null && this.debug) {
      validateProgram(this.gl, this.program);
    }
    callAndCheck(this.gl, () => this.gl.useProgram(program));
  }
  getUniformLocation(program, uniformName, shouldThrow = true) {
    this.throwIfDisposed();
    if (shouldThrow) {
      return getProgramUniformLocationOrThrow(this.gl, program, uniformName);
    } else {
      return getProgramUniformLocation(this.gl, program, uniformName);
    }
  }
  getAttributeLocation(program, attribute) {
    this.throwIfDisposed();
    return callAndCheck(this.gl, () => this.gl.getAttribLocation(program, attribute));
  }
  getUniformLocationNoThrow(program, uniformName) {
    this.throwIfDisposed();
    return this.gl.getUniformLocation(program, uniformName);
  }
  setInputMatrixTexture(inputMatrixTexture, uniformLocation, textureUnit) {
    this.throwIfDisposed();
    this.throwIfNoProgram();
    bindTextureToProgramUniformSampler(this.gl, inputMatrixTexture, uniformLocation, textureUnit);
  }
  setOutputMatrixTexture(outputMatrixTexture, rows, columns) {
    this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
  }
  setOutputPackedMatrixTexture(outputPackedMatrixTexture, rows, columns) {
    this.throwIfDisposed();
    const [width2, height2] = getPackedMatrixTextureShapeWidthHeight(rows, columns);
    this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width2, height2);
  }
  setOutputMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
    this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
  }
  setOutputPackedMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
    throw new Error("setOutputPackedMatrixWriteRegion not implemented.");
  }
  debugValidate() {
    if (this.program != null) {
      validateProgram(this.gl, this.program);
    }
    validateFramebuffer(this.gl);
  }
  executeProgram() {
    this.throwIfDisposed();
    this.throwIfNoProgram();
    const gl = this.gl;
    if (this.debug) {
      this.debugValidate();
    }
    callAndCheck(gl, () => gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0));
  }
  blockUntilAllProgramsCompleted() {
    this.throwIfDisposed();
    callAndCheck(this.gl, () => this.gl.finish());
  }
  getQueryTimerExtension() {
    if (this.disjointQueryTimerExtension == null) {
      this.disjointQueryTimerExtension = getExtensionOrThrow(this.gl, env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") === 2 ? "EXT_disjoint_timer_query_webgl2" : "EXT_disjoint_timer_query");
    }
    return this.disjointQueryTimerExtension;
  }
  getQueryTimerExtensionWebGL2() {
    return this.getQueryTimerExtension();
  }
  getQueryTimerExtensionWebGL1() {
    return this.getQueryTimerExtension();
  }
  beginQuery() {
    if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") === 2) {
      const gl2 = this.gl;
      const ext2 = this.getQueryTimerExtensionWebGL2();
      const query2 = gl2.createQuery();
      gl2.beginQuery(ext2.TIME_ELAPSED_EXT, query2);
      return query2;
    }
    const ext = this.getQueryTimerExtensionWebGL1();
    const query = ext.createQueryEXT();
    ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
    return query;
  }
  endQuery() {
    if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") === 2) {
      const gl2 = this.gl;
      const ext2 = this.getQueryTimerExtensionWebGL2();
      gl2.endQuery(ext2.TIME_ELAPSED_EXT);
      return;
    }
    const ext = this.getQueryTimerExtensionWebGL1();
    ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
  }
  async waitForQueryAndGetTime(query) {
    await repeatedTry(() => this.disposed || this.isQueryAvailable(query, env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")));
    return this.getQueryTime(query, env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
  }
  getQueryTime(query, queryTimerVersion) {
    if (queryTimerVersion === 0) {
      return null;
    }
    if (queryTimerVersion === 2) {
      const gl2 = this.gl;
      const timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
      return timeElapsedNanos / 1e6;
    } else {
      const ext = this.getQueryTimerExtensionWebGL1();
      const timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
      return timeElapsedNanos / 1e6;
    }
  }
  isQueryAvailable(query, queryTimerVersion) {
    if (queryTimerVersion === 0) {
      return true;
    }
    if (queryTimerVersion === 2) {
      const gl2 = this.gl;
      const ext = this.getQueryTimerExtensionWebGL2();
      const available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
      if (this.disjoint == null) {
        this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
      }
      return available && !this.disjoint;
    } else {
      const ext = this.getQueryTimerExtensionWebGL1();
      const available = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_AVAILABLE_EXT);
      if (this.disjoint == null) {
        this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
      }
      return available && !this.disjoint;
    }
  }
  pollFence(fenceContext) {
    return new Promise((resolve) => {
      this.addItemToPoll(() => fenceContext.isFencePassed(), () => resolve());
    });
  }
  pollItems() {
    const index2 = linearSearchLastTrue(this.itemsToPoll.map((x2) => x2.isDoneFn));
    for (let i2 = 0; i2 <= index2; ++i2) {
      const { resolveFn } = this.itemsToPoll[i2];
      resolveFn();
    }
    this.itemsToPoll = this.itemsToPoll.slice(index2 + 1);
  }
  addItemToPoll(isDoneFn, resolveFn) {
    this.itemsToPoll.push({ isDoneFn, resolveFn });
    if (this.itemsToPoll.length > 1) {
      return;
    }
    repeatedTry(() => {
      this.pollItems();
      return this.itemsToPoll.length === 0;
    });
  }
  bindTextureToFrameBuffer(texture) {
    this.throwIfDisposed();
    bindColorTextureToFramebuffer(this.gl, texture, this.framebuffer);
    if (this.debug) {
      validateFramebuffer(this.gl);
    }
  }
  unbindTextureToFrameBuffer() {
    if (this.outputTexture != null) {
      bindColorTextureToFramebuffer(this.gl, this.outputTexture, this.framebuffer);
      if (this.debug) {
        validateFramebuffer(this.gl);
      }
    } else {
      unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
    }
  }
  downloadMatrixDriver(texture, downloadAndDecode) {
    this.bindTextureToFrameBuffer(texture);
    const result2 = downloadAndDecode();
    this.unbindTextureToFrameBuffer();
    return result2;
  }
  setOutputMatrixTextureDriver(outputMatrixTextureMaybePacked, width2, height2) {
    this.throwIfDisposed();
    const gl = this.gl;
    bindColorTextureToFramebuffer(gl, outputMatrixTextureMaybePacked, this.framebuffer);
    if (this.debug) {
      validateFramebuffer(gl);
    }
    this.outputTexture = outputMatrixTextureMaybePacked;
    callAndCheck(gl, () => gl.viewport(0, 0, width2, height2));
    callAndCheck(gl, () => gl.scissor(0, 0, width2, height2));
  }
  setOutputMatrixWriteRegionDriver(x2, y2, width2, height2) {
    this.throwIfDisposed();
    callAndCheck(this.gl, () => this.gl.scissor(x2, y2, width2, height2));
  }
  throwIfDisposed() {
    if (this.disposed) {
      throw new Error("Attempted to use disposed GPGPUContext.");
    }
  }
  throwIfNoProgram() {
    if (this.program == null) {
      throw new Error("No GPU program is currently set.");
    }
  }
}
function linearSearchLastTrue(arr2) {
  let i2 = 0;
  for (; i2 < arr2.length; ++i2) {
    const isDone = arr2[i2]();
    if (!isDone) {
      break;
    }
  }
  return i2 - 1;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const { addImpl: addImplCPU, bincountImpl: bincountImplCPU, bincountReduceImpl: bincountReduceImplCPU, ceilImpl: ceilImplCPU, concatImpl: concatImplCPU, equalImpl: equalImplCPU, expImpl: expImplCPU, expm1Impl: expm1ImplCPU, floorImpl: floorImplCPU, gatherNdImpl: gatherNdImplCPU, gatherV2Impl: gatherV2ImplCPU, greaterImpl: greaterImplCPU, greaterEqualImpl: greaterEqualImplCPU, lessImpl: lessImplCPU, lessEqualImpl: lessEqualImplCPU, linSpaceImpl: linSpaceImplCPU, logImpl: logImplCPU, maxImpl: maxImplCPU, maximumImpl: maximumImplCPU, minimumImpl: minimumImplCPU, multiplyImpl: multiplyImplCPU, negImpl: negImplCPU, notEqualImpl: notEqualImplCPU, prodImpl: prodImplCPU, rangeImpl: rangeImplCPU, rsqrtImpl: rsqrtImplCPU, sigmoidImpl: sigmoidImplCPU, simpleAbsImpl: simpleAbsImplCPU, sliceImpl: sliceImplCPU, sparseFillEmptyRowsImpl: sparseFillEmptyRowsImplCPU, sparseReshapeImpl: sparseReshapeImplCPU, sparseSegmentReductionImpl: sparseSegmentReductionImplCPU, sqrtImpl: sqrtImplCPU, stridedSliceImpl: stridedSliceImplCPU, stringNGramsImpl: stringNGramsImplCPU, stringSplitImpl: stringSplitImplCPU, stringToHashBucketFastImpl: stringToHashBucketFastImplCPU, subImpl: subImplCPU, tileImpl: tileImplCPU, topKImpl: topKImplCPU, transposeImpl: transposeImplCPU, uniqueImpl: uniqueImplCPU } = shared;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getVecChannels(name, rank) {
  return ["x", "y", "z", "w", "u", "v"].slice(0, rank).map((d2) => `${name}.${d2}`);
}
function getChannels(name, rank) {
  if (rank === 1) {
    return [name];
  }
  return getVecChannels(name, rank);
}
function getSourceCoords$2(rank, dims) {
  if (rank === 1) {
    return "rc";
  }
  let coords2 = "";
  for (let i2 = 0; i2 < rank; i2++) {
    coords2 += dims[i2];
    if (i2 < rank - 1) {
      coords2 += ",";
    }
  }
  return coords2;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class PackProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.packedInputs = false;
    this.packedOutput = true;
    this.outputShape = outputShape;
    this.rank = outputShape.length;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    if (this.rank === 0) {
      this.userCode = `
        void main() {
          setOutput(vec4(getA(), 0., 0., 0.));
        }
      `;
    } else {
      const channels = getChannels("rc", this.rank);
      const dtype = getCoordsDataType(this.rank);
      const outOfBoundsCondition = this.getOutOfBoundsCondition(channels);
      const setup2 = this.getSetup(channels);
      const output2 = this.getOutput(channels);
      this.userCode = `
        void main() {
          ${dtype} rc = getOutputCoords();

          if(${outOfBoundsCondition}) {
            setOutput(vec4(0));
          } else {
            ${setup2}

            setOutput(vec4(${output2}));
          }
        }
      `;
    }
  }
  getSourceCoordsArr(dims) {
    const coords2 = [];
    for (let row = 0; row <= 1; row++) {
      for (let col = 0; col <= 1; col++) {
        let coord = `${row === 0 ? "r" : "rp1"}, ${col === 0 ? "c" : "cp1"}`;
        for (let d2 = 2; d2 < this.rank; d2++) {
          coord = `${dims[dims.length - 1 - d2]},` + coord;
        }
        coords2.push(coord);
      }
    }
    return coords2;
  }
  getOutOfBoundsCondition(dims) {
    if (this.rank === 1) {
      return `rc > ${this.enableShapeUniforms ? "outShape" : this.outputShape[0]}`;
    }
    let cond = "";
    for (let i2 = this.rank - 2; i2 < this.rank; i2++) {
      cond += `${dims[i2]} >= ${this.enableShapeUniforms ? `outShape[${i2}]` : this.outputShape[i2]}`;
      if (i2 < this.rank - 1) {
        cond += "||";
      }
    }
    return cond;
  }
  getSetup(dims) {
    if (this.rank === 1) {
      return "";
    }
    const innerDims = dims.slice(-2);
    const col = this.enableShapeUniforms ? `outShape[${this.rank} - 1]` : this.outputShape[this.rank - 1];
    const row = this.enableShapeUniforms ? `outShape[${this.rank} - 2]` : this.outputShape[this.rank - 2];
    return `
      int r = ${innerDims[0]};
      int c = ${innerDims[1]};
      int rp1 = r + 1;
      int cp1 = c + 1;

      bool cEdge = cp1 >= ${col};
      bool rEdge = rp1 >= ${row};
    `;
  }
  getOutput(dims) {
    const sourceCoords = this.getSourceCoordsArr(dims);
    if (this.rank === 1) {
      const outShape = this.enableShapeUniforms ? "outShape" : this.outputShape[0];
      return `getA(rc), (rc + 1 >= ${outShape} ? 0. : getA(rc + 1)), 0, 0`;
    }
    return `getA(${sourceCoords[0]}),
            cEdge ? 0. : getA(${sourceCoords[1]}),
            rEdge ? 0. : getA(${sourceCoords[2]}),
            rEdge || cEdge ? 0. : getA(${sourceCoords[3]})`;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ReshapePackedProgram {
  constructor(outputShape, inputShape) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.customUniforms = [{ name: "inputShape", type: "ivec3" }];
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    let mainLoop = ``;
    for (let i2 = 0; i2 < 4; i2++) {
      let thisRC = `thisRC = rc;`;
      if (i2 % 2 === 1) {
        thisRC += `thisRC.z += 1;`;
      }
      if (i2 > 1) {
        thisRC += `thisRC.y += 1;`;
      }
      mainLoop += `
        ${thisRC}
        ${i2 > 0 ? `if(thisRC.y < rows && thisRC.z < cols){` : ""}
          int flatIndex = getFlatIndex(thisRC);

          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);
          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));

          result[${i2}] =
            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);
        ${i2 > 0 ? "}" : ""}
      `;
    }
    this.userCode = `
      ${getReshapedInputCoords(inputShape, this.enableShapeUniforms)}
      ${this.enableShapeUniforms ? getFlatIndexFrom3DOutput() : getFlatIndexFrom3D(outputShape)}

      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0.);

        ivec3 thisRC;
        int rows = ${this.enableShapeUniforms ? "outShape[1]" : outputShape[1]};
        int cols = ${this.enableShapeUniforms ? "outShape[2]" : outputShape[2]};

        ${mainLoop}

        setOutput(result);
      }
    `;
  }
}
function getReshapedInputCoords(shape, enableShapeUniforms) {
  const coordsFromIndexSnippet = enableShapeUniforms ? getLogicalCoordinatesFromFlatIndexByUniform(["r", "c", "d"], "inputShape") : getLogicalCoordinatesFromFlatIndex(["r", "c", "d"], shape);
  return `
    ivec3 inputCoordsFromReshapedOutCoords(int index) {
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TextureManager {
  constructor(gpgpu) {
    this.gpgpu = gpgpu;
    this.numUsedTextures = 0;
    this.numFreeTextures = 0;
    this._numBytesAllocated = 0;
    this._numBytesFree = 0;
    this.freeTextures = {};
    this.logEnabled = false;
    this.usedTextures = {};
  }
  acquireTexture(shapeRC, usage, isPacked) {
    const physicalTexType = getPhysicalFromLogicalTextureType(usage, isPacked);
    const shapeKey = getKeyFromTextureShape(shapeRC, physicalTexType, isPacked);
    if (!(shapeKey in this.freeTextures)) {
      this.freeTextures[shapeKey] = [];
    }
    if (!(shapeKey in this.usedTextures)) {
      this.usedTextures[shapeKey] = [];
    }
    const texBytes = computeBytes(shapeRC, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
    if (this.freeTextures[shapeKey].length > 0) {
      this.numFreeTextures--;
      this.numUsedTextures++;
      this._numBytesFree -= texBytes;
      this.log();
      const newTexture2 = this.freeTextures[shapeKey].shift();
      this.usedTextures[shapeKey].push(newTexture2);
      return newTexture2;
    }
    let newTexture;
    if (physicalTexType === PhysicalTextureType.PACKED_2X2_FLOAT32) {
      newTexture = this.gpgpu.createPackedMatrixTexture(shapeRC[0], shapeRC[1]);
    } else if (physicalTexType === PhysicalTextureType.PACKED_2X2_FLOAT16) {
      newTexture = this.gpgpu.createFloat16PackedMatrixTexture(shapeRC[0], shapeRC[1]);
    } else if (physicalTexType === PhysicalTextureType.UNPACKED_FLOAT32) {
      newTexture = this.gpgpu.createFloat32MatrixTexture(shapeRC[0], shapeRC[1]);
    } else if (physicalTexType === PhysicalTextureType.UNPACKED_FLOAT16) {
      newTexture = this.gpgpu.createFloat16MatrixTexture(shapeRC[0], shapeRC[1]);
    } else if (physicalTexType === PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE) {
      newTexture = this.gpgpu.createUnsignedBytesMatrixTexture(shapeRC[0], shapeRC[1]);
    }
    this.usedTextures[shapeKey].push(newTexture);
    this.numUsedTextures++;
    this._numBytesAllocated += texBytes;
    this.log();
    return newTexture;
  }
  releaseTexture(texture, shape, logicalTexType, isPacked) {
    if (this.freeTextures == null) {
      return;
    }
    const physicalTexType = getPhysicalFromLogicalTextureType(logicalTexType, isPacked);
    const shapeKey = getKeyFromTextureShape(shape, physicalTexType, isPacked);
    if (!(shapeKey in this.freeTextures)) {
      this.freeTextures[shapeKey] = [];
    }
    const texBytes = computeBytes(shape, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
    const deleteTexThreshold = env().get("WEBGL_DELETE_TEXTURE_THRESHOLD");
    if (deleteTexThreshold !== -1 && this._numBytesAllocated > deleteTexThreshold) {
      this.gpgpu.deleteMatrixTexture(texture.texture);
      this._numBytesAllocated -= texBytes;
    } else {
      this.freeTextures[shapeKey].push(texture);
      this.numFreeTextures++;
      this._numBytesFree += texBytes;
    }
    this.numUsedTextures--;
    const texList = this.usedTextures[shapeKey];
    const texIndex = texList.indexOf(texture);
    if (texIndex < 0) {
      throw new Error("Cannot release a texture that was never provided by this texture manager");
    }
    texList.splice(texIndex, 1);
    this.log();
  }
  log() {
    if (!this.logEnabled) {
      return;
    }
    const total = this.numFreeTextures + this.numUsedTextures;
    console.log("Free/Used", `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${total})`);
    const freeRatio = this._numBytesFree / this._numBytesAllocated;
    console.log(`Bytes allocated: ${this._numBytesAllocated}`);
    console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100 * freeRatio)}%)`);
  }
  get numBytesAllocated() {
    return this._numBytesAllocated;
  }
  get numBytesFree() {
    return this._numBytesFree;
  }
  getNumUsedTextures() {
    return this.numUsedTextures;
  }
  getNumFreeTextures() {
    return this.numFreeTextures;
  }
  dispose() {
    if (this.freeTextures == null) {
      return;
    }
    for (const texShape in this.freeTextures) {
      this.freeTextures[texShape].forEach((tex) => {
        this.gpgpu.deleteMatrixTexture(tex.texture);
      });
    }
    for (const texShape in this.usedTextures) {
      this.usedTextures[texShape].forEach((tex) => {
        this.gpgpu.deleteMatrixTexture(tex.texture);
      });
    }
    this.freeTextures = null;
    this.usedTextures = null;
    this.numUsedTextures = 0;
    this.numFreeTextures = 0;
    this._numBytesAllocated = 0;
    this._numBytesFree = 0;
  }
}
function numBytesForInternalFormat(gl, internalFormat) {
  const glany = gl;
  if (internalFormat === glany.R32F) {
    return 4;
  } else if (internalFormat === glany.R16F) {
    return 2;
  } else if (internalFormat === glany.RGBA32F) {
    return 16;
  } else if (internalFormat === gl.RGBA) {
    return 16;
  } else if (internalFormat === glany.RGBA16F) {
    return 8;
  } else if (internalFormat === glany.RGBA8) {
    return 4;
  }
  throw new Error(`Unknown internal format ${internalFormat}`);
}
function computeBytes(shape, physicalTexType, gl, textureConfig, isPacked) {
  const internalFormat = internalFormatForPhysicalTexType(physicalTexType, textureConfig);
  let numElements;
  if (isPacked) {
    const [packedWidth, packedHeight] = getPackedMatrixTextureShapeWidthHeight(shape[0], shape[1]);
    numElements = packedWidth * packedHeight;
  } else {
    const [width2, height2] = getUnpackedMatrixTextureShapeWidthHeight(shape[0], shape[1]);
    numElements = width2 * height2;
  }
  const bytesPerElement2 = numBytesForInternalFormat(gl, internalFormat);
  return numElements * bytesPerElement2;
}
function internalFormatForPhysicalTexType(physicalTexType, textureConfig) {
  switch (physicalTexType) {
    case PhysicalTextureType.PACKED_2X2_FLOAT32:
      return getInternalFormatForPackedMatrixTexture(textureConfig);
    case PhysicalTextureType.PACKED_2X2_FLOAT16:
      return getInternalFormatForFloat16PackedMatrixTexture(textureConfig);
    case PhysicalTextureType.UNPACKED_FLOAT32:
      return getInternalFormatForFloat32MatrixTexture(textureConfig);
    case PhysicalTextureType.UNPACKED_FLOAT16:
      return getInternalFormatForFloat16MatrixTexture(textureConfig);
    case PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE:
      return getInternalFormatForUnsignedBytesMatrixTexture(textureConfig);
    default:
      throw new Error(`Unknown physical texture type ${physicalTexType}`);
  }
}
function getPhysicalTextureForRendering(isPacked) {
  if (env().getBool("WEBGL_RENDER_FLOAT32_ENABLED")) {
    if (isPacked) {
      return PhysicalTextureType.PACKED_2X2_FLOAT32;
    }
    return PhysicalTextureType.UNPACKED_FLOAT32;
  }
  if (isPacked) {
    return PhysicalTextureType.PACKED_2X2_FLOAT16;
  }
  return PhysicalTextureType.UNPACKED_FLOAT16;
}
function getPhysicalFromLogicalTextureType(logicalTexType, isPacked) {
  if (logicalTexType === TextureUsage.UPLOAD) {
    return PhysicalTextureType.PACKED_2X2_FLOAT32;
  } else if (logicalTexType === TextureUsage.RENDER || logicalTexType == null) {
    return getPhysicalTextureForRendering(isPacked);
  } else if (logicalTexType === TextureUsage.DOWNLOAD || logicalTexType === TextureUsage.PIXELS) {
    return PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE;
  }
  throw new Error(`Unknown logical texture type ${logicalTexType}`);
}
function getKeyFromTextureShape(shapeRowsCol, physicalTexType, isPacked) {
  return `${shapeRowsCol[0]}_${shapeRowsCol[1]}_${physicalTexType}_${isPacked}`;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class UnaryOpProgram {
  constructor(aShape, opSnippet) {
    this.variableNames = ["A"];
    this.outputShape = aShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    this.userCode = `
      float unaryOperation(float x) {
        ${opSnippet}
      }

      void main() {
        float x = getAAtOutCoords();
        float y = unaryOperation(x);

        setOutput(y);
      }
    `;
  }
}
const CHECK_NAN_SNIPPET$2 = `if (isnan(x)) return x;`;
const LINEAR$1 = `return x;`;
const ABS$1 = `return abs(x);`;
const ELU$2 = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const RELU$2 = CHECK_NAN_SNIPPET$2 + `
  return (x < 0.0) ? 0.0 : x;
`;
const RELU6$2 = CHECK_NAN_SNIPPET$2 + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const CLONE = "return x;";
const SIGMOID$2 = `return 1.0 / (1.0 + exp(-1.0 * x));`;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LINEAR = `return x;`;
const ELU$1 = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const RELU$1 = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const RELU6$1 = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const SIGMOID$1 = `return 1.0 / (1.0 + exp(-1.0 * x));`;
class UnaryOpPackedProgram {
  constructor(aShape, opSnippet) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = aShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    this.userCode = `
      vec4 unaryOperation(vec4 x) {
        ${opSnippet}
      }

      void main() {
        vec4 x = getAAtOutCoords();
        vec4 y = unaryOperation(x);

        setOutput(y);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class UnpackProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = false;
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    const rank = outputShape.length;
    const channels = getChannels("rc", rank);
    const dtype = getCoordsDataType(rank);
    const sourceCoords = getSourceCoords$2(rank, channels);
    const innerDims = channels.slice(-2);
    const coords2 = rank <= 1 ? "rc" : `vec2(${innerDims.join(",")})`;
    this.userCode = `
      void main() {
        ${dtype} rc = getOutputCoords();
        vec4 packedInput = getA(${sourceCoords});

        setOutput(getChannel(packedInput, ${coords2}));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const whereImpl = whereImpl$2;
const EPSILON_FLOAT32 = 1e-7;
const EPSILON_FLOAT16 = 1e-4;
const binaryCaches = {};
function getBinaryCache(webGLVersion) {
  if (webGLVersion in binaryCaches) {
    return binaryCaches[webGLVersion];
  }
  binaryCaches[webGLVersion] = {};
  return binaryCaches[webGLVersion];
}
const CPU_HANDOFF_SIZE_THRESHOLD = env().getNumber("CPU_HANDOFF_SIZE_THRESHOLD");
const BEFORE_PAGING_CONSTANT = 600;
function numMBBeforeWarning() {
  if (env().global.screen == null) {
    return 1024;
  }
  return env().global.screen.height * env().global.screen.width * window.devicePixelRatio * BEFORE_PAGING_CONSTANT / 1024 / 1024;
}
class MathBackendWebGL extends KernelBackend {
  constructor(gpuResource) {
    super();
    this.pendingRead = /* @__PURE__ */ new WeakMap();
    this.pendingDisposal = /* @__PURE__ */ new WeakSet();
    this.dataRefCount = /* @__PURE__ */ new WeakMap();
    this.numBytesInGPU = 0;
    this.uploadWaitMs = 0;
    this.downloadWaitMs = 0;
    this.lastGlFlushTime = 0;
    this.warnedAboutMemory = false;
    this.pendingDeletes = 0;
    this.disposed = false;
    if (!env().getBool("HAS_WEBGL")) {
      throw new Error("WebGL is not supported on this device");
    }
    let newGPGPU;
    if (gpuResource != null) {
      if (gpuResource instanceof GPGPUContext) {
        newGPGPU = gpuResource;
      } else {
        const gl = getWebGLContext(env().getNumber("WEBGL_VERSION"), gpuResource);
        newGPGPU = new GPGPUContext(gl);
      }
      this.binaryCache = {};
      this.gpgpuCreatedLocally = false;
    } else {
      const gl = getWebGLContext(env().getNumber("WEBGL_VERSION"));
      newGPGPU = new GPGPUContext(gl);
      this.binaryCache = getBinaryCache(env().getNumber("WEBGL_VERSION"));
      this.gpgpuCreatedLocally = true;
    }
    this.gpgpu = newGPGPU;
    this.canvas = this.gpgpu.gl.canvas;
    this.textureManager = new TextureManager(this.gpgpu);
    this.numMBBeforeWarning = numMBBeforeWarning();
    this.texData = new DataStorage(this, engine());
  }
  nextDataId() {
    return MathBackendWebGL.nextDataId++;
  }
  numDataIds() {
    return this.texData.numDataIds() - this.pendingDeletes;
  }
  write(values, shape, dtype) {
    if (env().getBool("WEBGL_CHECK_NUMERICAL_PROBLEMS") || env().getBool("DEBUG")) {
      this.checkNumericalProblems(values);
    }
    if (dtype === "complex64" && values != null) {
      throw new Error(`Cannot write to a complex64 dtype. Please use tf.complex(real, imag).`);
    }
    const dataId = { id: this.nextDataId() };
    this.texData.set(dataId, { shape, dtype, values, usage: TextureUsage.UPLOAD, refCount: 1 });
    return dataId;
  }
  refCount(dataId) {
    if (this.texData.has(dataId)) {
      const tensorData = this.texData.get(dataId);
      return tensorData.refCount;
    }
    return 0;
  }
  incRef(dataId) {
    const texData = this.texData.get(dataId);
    texData.refCount++;
  }
  decRef(dataId) {
    if (this.texData.has(dataId)) {
      const texData = this.texData.get(dataId);
      texData.refCount--;
    }
  }
  move(dataId, values, shape, dtype, refCount) {
    if (env().getBool("DEBUG")) {
      this.checkNumericalProblems(values);
    }
    if (dtype === "complex64") {
      throw new Error(`Cannot write to a complex64 dtype. Please use tf.complex(real, imag).`);
    }
    this.texData.set(dataId, { shape, dtype, values, usage: TextureUsage.UPLOAD, refCount });
  }
  disposeIntermediateTensorInfo(tensorInfo) {
    this.disposeData(tensorInfo.dataId);
  }
  readSync(dataId) {
    const texData = this.texData.get(dataId);
    const { values, dtype, complexTensorInfos, slice: slice2, shape, isPacked } = texData;
    if (slice2 != null) {
      let program;
      if (isPacked) {
        program = new UnaryOpPackedProgram(shape, CLONE);
      } else {
        program = new UnaryOpProgram(shape, CLONE);
      }
      const res = this.runWebGLProgram(program, [{ dataId, shape, dtype }], dtype);
      const data2 = this.readSync(res.dataId);
      this.disposeIntermediateTensorInfo(res);
      return data2;
    }
    if (values != null) {
      return this.convertAndCacheOnCPU(dataId);
    }
    if (dtype === "string") {
      return values;
    }
    const shouldTimeProgram = this.activeTimers != null;
    let start;
    if (shouldTimeProgram) {
      start = now();
    }
    let result2;
    if (dtype === "complex64") {
      const realValues = this.readSync(complexTensorInfos.real.dataId);
      const imagValues = this.readSync(complexTensorInfos.imag.dataId);
      result2 = mergeRealAndImagArrays(realValues, imagValues);
    } else {
      result2 = this.getValuesFromTexture(dataId);
    }
    if (shouldTimeProgram) {
      this.downloadWaitMs += now() - start;
    }
    return this.convertAndCacheOnCPU(dataId, result2);
  }
  async read(dataId) {
    if (this.pendingRead.has(dataId)) {
      const subscribers2 = this.pendingRead.get(dataId);
      return new Promise((resolve) => subscribers2.push(resolve));
    }
    const texData = this.texData.get(dataId);
    const { values, shape, slice: slice2, dtype, complexTensorInfos, isPacked } = texData;
    if (slice2 != null) {
      let program;
      if (isPacked) {
        program = new UnaryOpPackedProgram(shape, CLONE);
      } else {
        program = new UnaryOpProgram(shape, CLONE);
      }
      const res = this.runWebGLProgram(program, [{ dataId, shape, dtype }], dtype);
      const data2 = this.read(res.dataId);
      this.disposeIntermediateTensorInfo(res);
      return data2;
    }
    if (values != null) {
      return this.convertAndCacheOnCPU(dataId);
    }
    if (env().getBool("DEBUG")) {
      if (!env().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED") && env().getNumber("WEBGL_VERSION") === 2) {
        throw new Error(`tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.`);
      }
    }
    let buffer2 = null;
    let tmpDownloadTarget;
    if (dtype !== "complex64" && env().get("WEBGL_BUFFER_SUPPORTED")) {
      tmpDownloadTarget = this.decode(dataId);
      const tmpData = this.texData.get(tmpDownloadTarget.dataId);
      buffer2 = this.gpgpu.createBufferFromTexture(tmpData.texture.texture, ...getDenseTexShape(shape));
    }
    this.pendingRead.set(dataId, []);
    if (dtype !== "complex64") {
      await this.gpgpu.createAndWaitForFence();
    }
    let vals;
    if (dtype === "complex64") {
      const ps = await Promise.all([
        this.read(complexTensorInfos.real.dataId),
        this.read(complexTensorInfos.imag.dataId)
      ]);
      const realValues = ps[0];
      const imagValues = ps[1];
      vals = mergeRealAndImagArrays(realValues, imagValues);
    } else if (buffer2 == null) {
      vals = this.getValuesFromTexture(dataId);
    } else {
      const size = sizeFromShape(shape);
      vals = this.gpgpu.downloadFloat32MatrixFromBuffer(buffer2, size);
    }
    if (tmpDownloadTarget != null) {
      this.disposeIntermediateTensorInfo(tmpDownloadTarget);
    }
    if (buffer2 != null) {
      const gl = this.gpgpu.gl;
      callAndCheck(gl, () => gl.deleteBuffer(buffer2));
    }
    const dTypeVals = this.convertAndCacheOnCPU(dataId, vals);
    const subscribers = this.pendingRead.get(dataId);
    this.pendingRead.delete(dataId);
    subscribers.forEach((resolve) => resolve(dTypeVals));
    if (this.pendingDisposal.has(dataId)) {
      this.pendingDisposal.delete(dataId);
      if (this.disposeData(dataId)) {
        engine().removeDataId(dataId, this);
      }
      this.pendingDeletes--;
    }
    return dTypeVals;
  }
  readToGPU(dataId, options = {}) {
    const texData = this.texData.get(dataId);
    const { values, shape, slice: slice2, dtype, isPacked, texture } = texData;
    if (dtype === "complex64") {
      throw new Error("Does not support reading texture for complex64 dtype.");
    }
    if (slice2 != null) {
      let program;
      if (isPacked) {
        program = new UnaryOpPackedProgram(shape, CLONE);
      } else {
        program = new UnaryOpProgram(shape, CLONE);
      }
      const res = this.runWebGLProgram(program, [{ dataId, shape, dtype }], dtype);
      const gpuResouorce = this.readToGPU(res, options);
      this.disposeIntermediateTensorInfo(res);
      return gpuResouorce;
    }
    if (texture == null) {
      if (values != null) {
        throw new Error("Data is not on GPU but on CPU.");
      } else {
        throw new Error("There is no data on GPU or CPU.");
      }
    }
    const tmpTarget = this.decode(dataId, options.customTexShape);
    const tensorRef = engine().makeTensorFromDataId(tmpTarget.dataId, tmpTarget.shape, tmpTarget.dtype);
    const tmpData = this.texData.get(tmpTarget.dataId);
    return Object.assign({ tensorRef }, tmpData.texture);
  }
  bufferSync(t2) {
    const data2 = this.readSync(t2.dataId);
    let decodedData = data2;
    if (t2.dtype === "string") {
      try {
        decodedData = data2.map((d2) => decodeString(d2));
      } catch (_a) {
        throw new Error("Failed to decode encoded string bytes into utf-8");
      }
    }
    return buffer(t2.shape, t2.dtype, decodedData);
  }
  checkNumericalProblems(values) {
    if (values == null) {
      return;
    }
    for (let i2 = 0; i2 < values.length; i2++) {
      const num = values[i2];
      if (!canBeRepresented(num)) {
        if (env().getBool("WEBGL_RENDER_FLOAT32_CAPABLE")) {
          throw Error(`The value ${num} cannot be represented with your current settings. Consider enabling float32 rendering: 'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`);
        }
        throw Error(`The value ${num} cannot be represented on this device.`);
      }
    }
  }
  getValuesFromTexture(dataId) {
    const { shape, dtype, isPacked } = this.texData.get(dataId);
    const size = sizeFromShape(shape);
    if (env().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED")) {
      const tmpTarget = this.decode(dataId);
      const tmpData2 = this.texData.get(tmpTarget.dataId);
      const vals2 = this.gpgpu.downloadMatrixFromPackedTexture(tmpData2.texture.texture, ...getDenseTexShape(shape)).subarray(0, size);
      this.disposeIntermediateTensorInfo(tmpTarget);
      return vals2;
    }
    const shouldUsePackedProgram = env().getBool("WEBGL_PACK") && isPacked === true;
    const outputShape = shouldUsePackedProgram ? getShapeAs3D(shape) : shape;
    const program = shouldUsePackedProgram ? new EncodeFloatPackedProgram(outputShape) : new EncodeFloatProgram(outputShape);
    const output2 = this.runWebGLProgram(program, [{ shape: outputShape, dtype, dataId }], "float32");
    const tmpData = this.texData.get(output2.dataId);
    const vals = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(tmpData.texture.texture, tmpData.texShape[0], tmpData.texShape[1]).subarray(0, size);
    this.disposeIntermediateTensorInfo(output2);
    return vals;
  }
  timerAvailable() {
    return env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0;
  }
  time(f2) {
    const oldActiveTimers = this.activeTimers;
    const newActiveTimers = [];
    let outerMostTime = false;
    if (this.programTimersStack == null) {
      this.programTimersStack = newActiveTimers;
      outerMostTime = true;
    } else {
      this.activeTimers.push(newActiveTimers);
    }
    this.activeTimers = newActiveTimers;
    f2();
    const flattenedActiveTimerQueries = flatten$1(this.activeTimers.map((d2) => d2.query)).filter((d2) => d2 != null);
    const flattenedActiveTimerNames = flatten$1(this.activeTimers.map((d2) => d2.name)).filter((d2) => d2 != null);
    this.activeTimers = oldActiveTimers;
    if (outerMostTime) {
      this.programTimersStack = null;
    }
    const res = {
      uploadWaitMs: this.uploadWaitMs,
      downloadWaitMs: this.downloadWaitMs,
      kernelMs: null,
      wallMs: null
    };
    return (async () => {
      if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) {
        const kernelMs = await Promise.all(flattenedActiveTimerQueries);
        res["kernelMs"] = sum$4(kernelMs);
        res["getExtraProfileInfo"] = () => kernelMs.map((d2, i2) => ({ name: flattenedActiveTimerNames[i2], ms: d2 })).map((d2) => `${d2.name}: ${d2.ms}`).join(", ");
      } else {
        res["kernelMs"] = {
          error: "WebGL query timers are not supported in this environment."
        };
      }
      this.uploadWaitMs = 0;
      this.downloadWaitMs = 0;
      return res;
    })();
  }
  memory() {
    return {
      unreliable: false,
      numBytesInGPU: this.numBytesInGPU,
      numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
      numBytesInGPUFree: this.textureManager.numBytesFree
    };
  }
  startTimer() {
    if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) {
      return this.gpgpu.beginQuery();
    }
    return { startMs: now(), endMs: null };
  }
  endTimer(query) {
    if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) {
      this.gpgpu.endQuery();
      return query;
    }
    query.endMs = now();
    return query;
  }
  async getQueryTime(query) {
    if (env().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) {
      return this.gpgpu.waitForQueryAndGetTime(query);
    }
    const timerQuery = query;
    return timerQuery.endMs - timerQuery.startMs;
  }
  disposeData(dataId, force = false) {
    if (this.pendingDisposal.has(dataId)) {
      return false;
    }
    if (!this.texData.has(dataId)) {
      return true;
    }
    if (force) {
      this.texData.get(dataId).refCount = 0;
    } else {
      this.texData.get(dataId).refCount--;
    }
    if (!force && this.texData.get(dataId).refCount > 0) {
      return false;
    }
    if (this.pendingRead.has(dataId)) {
      this.pendingDisposal.add(dataId);
      this.pendingDeletes++;
      return false;
    }
    this.releaseGPUData(dataId);
    const { complexTensorInfos } = this.texData.get(dataId);
    if (complexTensorInfos != null) {
      this.disposeData(complexTensorInfos.real.dataId, force);
      this.disposeData(complexTensorInfos.imag.dataId, force);
    }
    this.texData.delete(dataId);
    return true;
  }
  releaseGPUData(dataId) {
    const { texture, dtype, texShape, usage, isPacked, slice: slice2 } = this.texData.get(dataId);
    const key = slice2 && slice2.origDataId || dataId;
    const refCount = this.dataRefCount.get(key);
    if (refCount > 1) {
      this.dataRefCount.set(key, refCount - 1);
    } else {
      this.dataRefCount.delete(key);
      if (texture != null) {
        this.numBytesInGPU -= this.computeBytes(texShape, dtype);
        this.textureManager.releaseTexture(texture, texShape, usage, isPacked);
      }
    }
    const texData = this.texData.get(dataId);
    texData.texture = null;
    texData.texShape = null;
    texData.isPacked = false;
    texData.slice = null;
  }
  getTexture(dataId) {
    this.uploadToGPU(dataId);
    return this.texData.get(dataId).texture.texture;
  }
  getDataInfo(dataId) {
    return this.texData.get(dataId);
  }
  shouldExecuteOnCPU(inputs, sizeThreshold2 = CPU_HANDOFF_SIZE_THRESHOLD) {
    return env().getBool("WEBGL_CPU_FORWARD") && inputs.every((input) => this.texData.get(input.dataId).texture == null && sizeFromShape(input.shape) < sizeThreshold2);
  }
  getGPGPUContext() {
    return this.gpgpu;
  }
  where(condition) {
    warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
    const condVals = condition.dataSync();
    return whereImpl(condition.shape, condVals);
  }
  packedUnaryOp(x2, op2, dtype) {
    const program = new UnaryOpPackedProgram(x2.shape, op2);
    const outInfo = this.compileAndRun(program, [x2], dtype);
    return engine().makeTensorFromDataId(outInfo.dataId, outInfo.shape, outInfo.dtype);
  }
  abs(x2) {
    if (this.shouldExecuteOnCPU([x2]) && x2.dtype !== "complex64") {
      const outValues = simpleAbsImplCPU(this.texData.get(x2.dataId).values);
      return this.makeOutput(x2.shape, x2.dtype, outValues);
    }
    if (env().getBool("WEBGL_PACK_UNARY_OPERATIONS")) {
      return this.packedUnaryOp(x2, ABS$1, x2.dtype);
    }
    const program = new UnaryOpProgram(x2.shape, ABS$1);
    const outInfo = this.compileAndRun(program, [x2]);
    return engine().makeTensorFromDataId(outInfo.dataId, outInfo.shape, outInfo.dtype);
  }
  makeTensorInfo(shape, dtype, values) {
    let dataId;
    if (dtype === "string" && values != null && values.length > 0 && isString$4(values[0])) {
      const encodedValues = values.map((d2) => encodeString(d2));
      dataId = this.write(encodedValues, shape, dtype);
    } else {
      dataId = this.write(values, shape, dtype);
    }
    this.texData.get(dataId).usage = null;
    return { dataId, shape, dtype };
  }
  makeOutput(shape, dtype, values) {
    const { dataId } = this.makeTensorInfo(shape, dtype, values);
    return engine().makeTensorFromDataId(dataId, shape, dtype, this);
  }
  unpackTensor(input) {
    const program = new UnpackProgram(input.shape);
    return this.runWebGLProgram(program, [input], input.dtype);
  }
  packTensor(input) {
    const program = new PackProgram(input.shape);
    const preventEagerUnpackingOutput = true;
    return this.runWebGLProgram(program, [input], input.dtype, null, preventEagerUnpackingOutput);
  }
  packedReshape(input, afterShape) {
    const input3DShape = [
      getBatchDim(input.shape),
      ...getRowsCols(input.shape)
    ];
    const input3D = {
      dtype: input.dtype,
      shape: input3DShape,
      dataId: input.dataId
    };
    const afterShapeAs3D = [
      getBatchDim(afterShape),
      ...getRowsCols(afterShape)
    ];
    const program = new ReshapePackedProgram(afterShapeAs3D, input3DShape);
    const preventEagerUnpackingOfOutput = true;
    const customValues = [input3DShape];
    const output2 = this.runWebGLProgram(program, [input3D], input.dtype, customValues, preventEagerUnpackingOfOutput);
    return { dataId: output2.dataId, shape: afterShape, dtype: output2.dtype };
  }
  decode(dataId, customTexShape) {
    const texData = this.texData.get(dataId);
    const { isPacked, shape, dtype } = texData;
    if (customTexShape != null) {
      const size = sizeFromShape(shape);
      const texSize = customTexShape[0] * customTexShape[1] * 4;
      assert$1(size <= texSize, () => "customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data.");
    }
    const shapeAs3D = getShapeAs3D(shape);
    let program;
    if (isPacked) {
      program = new DecodeMatrixPackedProgram(shapeAs3D);
    } else {
      program = new DecodeMatrixProgram(shapeAs3D);
    }
    const preventEagerUnpackingOfOutput = true;
    const customValues = [customTexShape != null ? customTexShape : getDenseTexShape(shapeAs3D)];
    const out = this.runWebGLProgram(program, [{ shape: shapeAs3D, dtype, dataId }], dtype, customValues, preventEagerUnpackingOfOutput, customTexShape);
    return { dtype, shape, dataId: out.dataId };
  }
  runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false, customTexShape) {
    const output2 = this.makeTensorInfo(program.outputShape, outputDtype);
    const outData = this.texData.get(output2.dataId);
    if (program.packedOutput) {
      outData.isPacked = true;
    }
    if (program.outPackingScheme === PackingScheme.DENSE) {
      const texelShape = customTexShape != null ? customTexShape : getDenseTexShape(program.outputShape);
      outData.texShape = texelShape.map((d2) => d2 * 2);
    }
    if (program.outTexUsage != null) {
      outData.usage = program.outTexUsage;
    }
    if (sizeFromShape(output2.shape) === 0) {
      outData.values = getTypedArrayFromDType(output2.dtype, 0);
      return output2;
    }
    const dataToDispose = [];
    const inputsData = inputs.map((input) => {
      if (input.dtype === "complex64") {
        throw new Error(`GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.`);
      }
      let texData = this.texData.get(input.dataId);
      if (texData.texture == null) {
        if (!program.packedInputs && sizeFromShape(input.shape) <= env().getNumber("WEBGL_SIZE_UPLOAD_UNIFORM")) {
          return {
            shape: input.shape,
            texData: null,
            isUniform: true,
            uniformValues: texData.values
          };
        }
        if (program.packedInputs) {
          texData.isPacked = true;
          texData.shape = input.shape;
        }
      }
      this.uploadToGPU(input.dataId);
      if (!!texData.isPacked !== !!program.packedInputs) {
        input = texData.isPacked ? this.unpackTensor(input) : this.packTensor(input);
        dataToDispose.push(input);
        texData = this.texData.get(input.dataId);
      } else if (texData.isPacked && !isReshapeFree(texData.shape, input.shape)) {
        const savedInput = input;
        const targetShape = input.shape;
        input.shape = texData.shape;
        input = this.packedReshape(input, targetShape);
        dataToDispose.push(input);
        texData = this.texData.get(input.dataId);
        savedInput.shape = targetShape;
      }
      return { shape: input.shape, texData, isUniform: false };
    });
    this.uploadToGPU(output2.dataId);
    const outputData = { shape: output2.shape, texData: outData, isUniform: false };
    const key = makeShaderKey(program, inputsData, outputData);
    const binary = this.getAndSaveBinary(key, () => {
      return compileProgram(this.gpgpu, program, inputsData, outputData);
    });
    const shouldTimeProgram = this.activeTimers != null;
    let query;
    if (shouldTimeProgram) {
      query = this.startTimer();
    }
    if (!env().get("ENGINE_COMPILE_ONLY")) {
      runProgram(this.gpgpu, binary, inputsData, outputData, customUniformValues);
    }
    dataToDispose.forEach((info) => this.disposeIntermediateTensorInfo(info));
    if (shouldTimeProgram) {
      query = this.endTimer(query);
      this.activeTimers.push({ name: program.constructor.name, query: this.getQueryTime(query) });
    }
    const glFlushThreshold = env().get("WEBGL_FLUSH_THRESHOLD");
    if (glFlushThreshold > 0) {
      const time = now();
      if (time - this.lastGlFlushTime > glFlushThreshold) {
        this.gpgpu.gl.flush();
        this.lastGlFlushTime = time;
      }
    }
    if (!env().getBool("WEBGL_LAZILY_UNPACK") && outData.isPacked && preventEagerUnpackingOfOutput === false) {
      const unpacked = this.unpackTensor(output2);
      this.disposeIntermediateTensorInfo(output2);
      return unpacked;
    }
    return output2;
  }
  compileAndRun(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false) {
    outputDtype = outputDtype || inputs[0].dtype;
    const outInfo = this.runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput);
    return outInfo;
  }
  getAndSaveBinary(key, getBinary) {
    if (!(key in this.binaryCache)) {
      this.binaryCache[key] = getBinary();
    }
    return this.binaryCache[key];
  }
  getTextureManager() {
    return this.textureManager;
  }
  dispose() {
    if (this.disposed) {
      return;
    }
    if (!env().getBool("IS_TEST")) {
      const allKeys = Object.keys(this.binaryCache);
      allKeys.forEach((key) => {
        this.gpgpu.deleteProgram(this.binaryCache[key].webGLProgram);
        delete this.binaryCache[key];
      });
    }
    this.textureManager.dispose();
    if (this.canvas != null && (typeof HTMLCanvasElement !== "undefined" && this.canvas instanceof HTMLCanvasElement)) {
      this.canvas.remove();
    } else {
      this.canvas = null;
    }
    if (this.gpgpuCreatedLocally) {
      this.gpgpu.program = null;
      this.gpgpu.dispose();
    }
    this.disposed = true;
  }
  floatPrecision() {
    if (this.floatPrecisionValue == null) {
      this.floatPrecisionValue = tidy(() => {
        if (!env().get("WEBGL_RENDER_FLOAT32_ENABLED")) {
          const debugFlag = env().getBool("DEBUG");
          env().set("DEBUG", false);
          const underflowCheckValue = this.abs(scalar(1e-8)).dataSync()[0];
          env().set("DEBUG", debugFlag);
          if (underflowCheckValue > 0) {
            return 32;
          }
        }
        return 16;
      });
    }
    return this.floatPrecisionValue;
  }
  epsilon() {
    return this.floatPrecision() === 32 ? EPSILON_FLOAT32 : EPSILON_FLOAT16;
  }
  uploadToGPU(dataId) {
    const texData = this.texData.get(dataId);
    const { shape, dtype, values, texture, usage, isPacked } = texData;
    if (texture != null) {
      return;
    }
    const shouldTimeProgram = this.activeTimers != null;
    let start;
    if (shouldTimeProgram) {
      start = now();
    }
    let texShape = texData.texShape;
    if (texShape == null) {
      texShape = getTextureShapeFromLogicalShape(shape, isPacked);
      texData.texShape = texShape;
    }
    if (values != null) {
      const shapeAs3D = getShapeAs3D(shape);
      let program;
      let width2 = texShape[1], height2 = texShape[0];
      const isByteArray = values instanceof Uint8Array || values instanceof Uint8ClampedArray;
      if (isPacked || !isByteArray) {
        [width2, height2] = getPackedMatrixTextureShapeWidthHeight(texShape[0], texShape[1]);
      }
      if (isPacked) {
        program = new EncodeMatrixPackedProgram(shapeAs3D, isByteArray);
      } else {
        program = new EncodeMatrixProgram(shapeAs3D, isByteArray);
      }
      const tempDenseInputTexShape = isByteArray ? [height2, width2] : texShape;
      const tempDenseInputHandle = this.makeTensorInfo(tempDenseInputTexShape, dtype);
      const tempDenseInputTexData = this.texData.get(tempDenseInputHandle.dataId);
      if (isByteArray) {
        tempDenseInputTexData.usage = TextureUsage.PIXELS;
      } else {
        tempDenseInputTexData.usage = TextureUsage.UPLOAD;
      }
      tempDenseInputTexData.texShape = tempDenseInputTexShape;
      this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(tempDenseInputHandle.dataId), width2, height2, values);
      const customValues = [[height2, width2]];
      const preventEagerUnpacking = true;
      const encodedOutputTarget = this.runWebGLProgram(program, [tempDenseInputHandle], dtype, customValues, preventEagerUnpacking);
      const outputTexData = this.texData.get(encodedOutputTarget.dataId);
      texData.texShape = outputTexData.texShape;
      texData.isPacked = outputTexData.isPacked;
      texData.usage = outputTexData.usage;
      if (!env().get("ENGINE_COMPILE_ONLY")) {
        texData.texture = outputTexData.texture;
        texData.values = null;
        this.texData.delete(encodedOutputTarget.dataId);
      } else {
        this.disposeData(encodedOutputTarget.dataId);
      }
      this.disposeIntermediateTensorInfo(tempDenseInputHandle);
      if (shouldTimeProgram) {
        this.uploadWaitMs += now() - start;
      }
    } else {
      const newTexture = this.acquireTexture(texShape, usage, dtype, isPacked);
      texData.texture = newTexture;
    }
  }
  convertAndCacheOnCPU(dataId, float32Values) {
    const texData = this.texData.get(dataId);
    const { dtype } = texData;
    this.releaseGPUData(dataId);
    if (float32Values != null) {
      texData.values = float32ToTypedArray(float32Values, dtype);
    }
    return texData.values;
  }
  acquireTexture(texShape, texType, dtype, isPacked) {
    this.numBytesInGPU += this.computeBytes(texShape, dtype);
    if (!this.warnedAboutMemory && this.numBytesInGPU > this.numMBBeforeWarning * 1024 * 1024) {
      const mb = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
      this.warnedAboutMemory = true;
      console.warn(`High memory usage in GPU: ${mb} MB, most likely due to a memory leak`);
    }
    return this.textureManager.acquireTexture(texShape, texType, isPacked);
  }
  computeBytes(shape, dtype) {
    return shape[0] * shape[1] * bytesPerElement(dtype);
  }
  checkCompileCompletion() {
    for (const [, binary] of Object.entries(this.binaryCache)) {
      this.checkCompletion_(binary);
    }
  }
  async checkCompileCompletionAsync() {
    const ps = [];
    if (this.gpgpu.parallelCompilationExtension) {
      for (const [, binary] of Object.entries(this.binaryCache)) {
        ps.push(this.checkCompletionAsync_(binary));
      }
      return Promise.all(ps);
    } else {
      for (const [, binary] of Object.entries(this.binaryCache)) {
        const p2 = new Promise((resolve) => {
          try {
            this.checkCompletion_(binary);
            resolve(true);
          } catch (error3) {
            throw error3;
          }
        });
        ps.push(p2);
      }
      return Promise.all(ps);
    }
  }
  async checkCompletionAsync_(binary) {
    if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR)) {
      return this.checkCompletion_(binary);
    } else {
      await nextFrame();
      return this.checkCompletionAsync_(binary);
    }
  }
  checkCompletion_(binary) {
    if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.gl.LINK_STATUS) === false) {
      console.log(this.gpgpu.gl.getProgramInfoLog(binary.webGLProgram));
      if (this.gpgpu.gl.getShaderParameter(binary.fragmentShader, this.gpgpu.gl.COMPILE_STATUS) === false) {
        logShaderSourceAndInfoLog(binary.source, this.gpgpu.gl.getShaderInfoLog(binary.fragmentShader));
        throw new Error("Failed to compile fragment shader.");
      }
      throw new Error("Failed to link vertex and fragment shaders.");
    }
    return true;
  }
  getUniformLocations() {
    for (const [, binary] of Object.entries(this.binaryCache)) {
      const { uniformLocations, customUniformLocations, infLoc, nanLoc, inShapesLocations, inTexShapesLocations, outShapeLocation, outShapeStridesLocation, outTexShapeLocation } = getUniformLocations(this.gpgpu, binary.program, binary.webGLProgram);
      binary.uniformLocations = uniformLocations;
      binary.customUniformLocations = customUniformLocations;
      binary.infLoc = infLoc;
      binary.nanLoc = nanLoc;
      binary.inShapesLocations = inShapesLocations;
      binary.inTexShapesLocations = inTexShapesLocations;
      binary.outShapeLocation = outShapeLocation;
      binary.outShapeStridesLocation = outShapeStridesLocation;
      binary.outTexShapeLocation = outTexShapeLocation;
    }
  }
}
MathBackendWebGL.nextDataId = 0;
function float32ToTypedArray(a6, dtype) {
  if (dtype === "float32" || dtype === "complex64") {
    return a6;
  } else if (dtype === "int32" || dtype === "bool") {
    const result2 = dtype === "int32" ? new Int32Array(a6.length) : new Uint8Array(a6.length);
    for (let i2 = 0; i2 < result2.length; ++i2) {
      result2[i2] = Math.round(a6[i2]);
    }
    return result2;
  } else {
    throw new Error(`Unknown dtype ${dtype}`);
  }
}
/** @license See the LICENSE file. */
const version$1 = "3.16.0";
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
if (isBrowser$2()) {
  registerBackend("webgl", () => new MathBackendWebGL(), 2);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const CHECK_NAN_SNIPPET$1 = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
class BinaryOpProgram {
  constructor(op2, aShape, bShape) {
    this.variableNames = ["A", "B"];
    this.outputShape = assertAndGetBroadcastShape(aShape, bShape);
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    this.userCode = `
      float binaryOperation(float a, float b) {
        ${op2}
      }

      void main() {
        float a = getAAtOutCoords();
        float b = getBAtOutCoords();
        setOutput(binaryOperation(a, b));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const CHECK_NAN_SNIPPET = `
  result.r = isNaN.r > 0. ? NAN : result.r;
  result.g = isNaN.g > 0. ? NAN : result.g;
  result.b = isNaN.b > 0. ? NAN : result.b;
  result.a = isNaN.a > 0. ? NAN : result.a;
`;
class BinaryOpPackedProgram {
  constructor(op2, aShape, bShape, checkOutOfBounds = false) {
    this.variableNames = ["A", "B"];
    this.supportsBroadcasting = true;
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = assertAndGetBroadcastShape(aShape, bShape);
    const rank = this.outputShape.length;
    this.enableShapeUniforms = useShapeUniforms(rank);
    let checkOutOfBoundsString = "";
    if (checkOutOfBounds) {
      if (rank === 0 || sizeFromShape(this.outputShape) === 1) {
        checkOutOfBoundsString = `
          result.y = 0.;
          result.z = 0.;
          result.w = 0.;
        `;
      } else {
        const dtype = getCoordsDataType(rank);
        checkOutOfBoundsString = `
          ${dtype} coords = getOutputCoords();
        `;
        if (rank === 1) {
          if (this.enableShapeUniforms) {
            checkOutOfBoundsString += `
            result.y = (coords + 1) >= outShape ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
          } else {
            checkOutOfBoundsString += `
            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
          }
        } else {
          const channels = getChannels("coords", rank);
          if (this.enableShapeUniforms) {
            checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= outShape[${rank} - 2];
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= outShape[${rank} - 1];
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
          } else {
            checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= ${this.outputShape[rank - 2]};
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= ${this.outputShape[rank - 1]};
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
          }
        }
      }
    }
    this.userCode = `
      vec4 binaryOperation(vec4 a, vec4 b) {
        ${op2}
      }

      void main() {
        vec4 a = getAAtOutCoords();
        vec4 b = getBAtOutCoords();

        vec4 result = binaryOperation(a, b);
        ${checkOutOfBoundsString}

        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function identity$1(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  backend2.incRef(x2.dataId);
  return { dataId: x2.dataId, shape: x2.shape, dtype: x2.dtype };
}
const identityConfig$1 = {
  kernelName: Identity$1,
  backendName: "webgl",
  kernelFunc: identity$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function complex$1(args) {
  const { inputs, backend: backend2 } = args;
  const { real: real2, imag: imag2 } = inputs;
  const complexInfo = backend2.makeTensorInfo(real2.shape, "complex64");
  const complex2 = backend2.texData.get(complexInfo.dataId);
  const realTensorInfo = identity$1({ inputs: { x: real2 }, backend: backend2 });
  const imagTensorInfo = identity$1({ inputs: { x: imag2 }, backend: backend2 });
  complex2.complexTensorInfos = { real: realTensorInfo, imag: imagTensorInfo };
  return complexInfo;
}
const complexConfig = {
  kernelName: Complex,
  backendName: "webgl",
  kernelFunc: complex$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LEAKYRELU = `return (a < 0.) ? b * a : a;`;
const LEAKYRELU_PACKED = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function leakyRelu$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { alpha: alpha2 } = attrs;
  const $alpha = backend2.makeTensorInfo([], "float32", createScalarValue(alpha2, "float32"));
  const program = env().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new BinaryOpPackedProgram(LEAKYRELU_PACKED, x2.shape, $alpha.shape) : new BinaryOpProgram(LEAKYRELU, x2.shape, $alpha.shape);
  const result2 = backend2.runWebGLProgram(program, [x2, $alpha], "float32");
  backend2.disposeIntermediateTensorInfo($alpha);
  return result2;
}
const leakyReluConfig$1 = {
  kernelName: LeakyRelu,
  backendName: "webgl",
  kernelFunc: leakyRelu$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const PRELU = `return (a < 0.) ? b * a : a;`;
const PRELU_PACKED = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function prelu$1(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2, alpha: alpha2 } = inputs;
  const program = env().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new BinaryOpPackedProgram(PRELU_PACKED, x2.shape, alpha2.shape) : new BinaryOpProgram(PRELU, x2.shape, alpha2.shape);
  return backend2.runWebGLProgram(program, [x2, alpha2], "float32");
}
const preluConfig$1 = {
  kernelName: Prelu,
  backendName: "webgl",
  kernelFunc: prelu$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const CHECK_NAN_SNIPPET_UNARY = `if (isnan(x)) return x;`;
const CHECK_NAN_SNIPPET_BINARY = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
const CHECK_NAN_SNIPPET_BINARY_PACKED = `
  result.r = isNaN.r > 0. ? NAN : result.r;
  result.g = isNaN.g > 0. ? NAN : result.g;
  result.b = isNaN.b > 0. ? NAN : result.b;
  result.a = isNaN.a > 0. ? NAN : result.a;
`;
function unaryKernelFunc({ opSnippet, packedOpSnippet, cpuKernelImpl, dtype }) {
  return ({ inputs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    const webglBackend = backend2;
    const $dtype = dtype || x2.dtype;
    if (webglBackend.shouldExecuteOnCPU([x2]) && cpuKernelImpl != null) {
      const xData = webglBackend.texData.get(x2.dataId);
      const outValues = cpuKernelImpl(xData.values, $dtype);
      return webglBackend.makeTensorInfo(x2.shape, $dtype, outValues);
    }
    const shouldUsePackedProgram = env().getBool("WEBGL_PACK_UNARY_OPERATIONS") && packedOpSnippet != null;
    let program;
    if (shouldUsePackedProgram) {
      program = new UnaryOpPackedProgram(x2.shape, packedOpSnippet);
    } else {
      program = new UnaryOpProgram(x2.shape, opSnippet);
    }
    return webglBackend.runWebGLProgram(program, [x2], $dtype);
  };
}
function binaryKernelFunc({ opSnippet, packedOpSnippet, checkOutOfBounds = false, supportsComplex = false, cpuKernelImpl, dtype }) {
  return ({ inputs, backend: backend2 }) => {
    const { a: a6, b: b2 } = inputs;
    const webglBackend = backend2;
    if (supportsComplex && a6.dtype === "complex64") {
      const aData = webglBackend.texData.get(a6.dataId);
      const bData = webglBackend.texData.get(b2.dataId);
      const [real2, imag2] = [
        [aData.complexTensorInfos.real, bData.complexTensorInfos.real],
        [aData.complexTensorInfos.imag, bData.complexTensorInfos.imag]
      ].map((complexParts) => {
        const [aPart, bPart] = complexParts;
        const aHandle = {
          dataId: aPart.dataId,
          dtype: aPart.dtype,
          shape: a6.shape
        };
        const bHandle = {
          dataId: bPart.dataId,
          dtype: bPart.dtype,
          shape: b2.shape
        };
        const program2 = new BinaryOpProgram(opSnippet, a6.shape, b2.shape);
        return webglBackend.runWebGLProgram(program2, [aHandle, bHandle], upcastType(aPart.dtype, bPart.dtype));
      });
      const complexOutput = complex$1({ inputs: { real: real2, imag: imag2 }, backend: webglBackend });
      webglBackend.disposeIntermediateTensorInfo(real2);
      webglBackend.disposeIntermediateTensorInfo(imag2);
      return complexOutput;
    }
    const $dtype = dtype || upcastType(a6.dtype, b2.dtype);
    if ((a6.dtype === "string" || b2.dtype === "string" || webglBackend.shouldExecuteOnCPU([a6, b2])) && cpuKernelImpl != null) {
      const aVals = webglBackend.texData.get(a6.dataId).values;
      const bVals = webglBackend.texData.get(b2.dataId).values;
      const decodedAVals = a6.dtype === "string" ? fromUint8ToStringArray(aVals) : aVals;
      const decodedBVals = a6.dtype === "string" ? fromUint8ToStringArray(bVals) : bVals;
      const [outValues, outShape] = cpuKernelImpl(a6.shape, b2.shape, decodedAVals, decodedBVals, $dtype);
      const out = webglBackend.makeTensorInfo(outShape, $dtype);
      const outData = webglBackend.texData.get(out.dataId);
      outData.values = outValues;
      return out;
    }
    const shouldUsePackedProgram = env().getBool("WEBGL_PACK_BINARY_OPERATIONS") && packedOpSnippet != null;
    let program;
    if (shouldUsePackedProgram) {
      program = new BinaryOpPackedProgram(packedOpSnippet, a6.shape, b2.shape, checkOutOfBounds);
    } else {
      program = new BinaryOpProgram(opSnippet, a6.shape, b2.shape);
    }
    return webglBackend.runWebGLProgram(program, [a6, b2], $dtype);
  };
}
function mapActivationToShaderProgram(activation, packed = false) {
  if (activation === "linear") {
    if (packed) {
      return LINEAR;
    }
    return LINEAR$1;
  } else if (activation === "relu") {
    if (packed) {
      return RELU$1;
    }
    return RELU$2;
  } else if (activation === "elu") {
    if (packed) {
      return ELU$1;
    }
    return ELU$2;
  } else if (activation === "relu6") {
    if (packed) {
      return RELU6$1;
    }
    return RELU6$2;
  } else if (activation === "prelu") {
    if (packed) {
      return PRELU_PACKED;
    }
    return PRELU;
  } else if (activation === "leakyrelu") {
    if (packed) {
      return LEAKYRELU_PACKED;
    }
    return LEAKYRELU;
  } else if (activation === "sigmoid") {
    if (packed) {
      return SIGMOID$1;
    }
    return SIGMOID$2;
  }
  throw new Error(`Activation ${activation} has not been implemented for the WebGL backend.`);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MatMulPackedProgram {
  constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, addBias = false, activation = null, hasPreluActivation = false, hasLeakyreluActivation = false) {
    this.variableNames = ["matrixA", "matrixB"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    const sharedDim = transposeA ? aShape[1] : aShape[2];
    const sharedDimensionPacked = Math.ceil(sharedDim / 2);
    const aSample = transposeA ? "i * 2, rc.y" : "rc.y, i * 2";
    const bSample = transposeB ? "rc.z, i * 2" : "i * 2, rc.z";
    const aSwizzle = transposeA ? ["a.xxyy", "a.zzww"] : ["a.xxzz", "a.yyww"];
    const bSwizzle = transposeB ? ["b.xzxz", "b.ywyw"] : ["b.xyxy", "b.zwzw"];
    let activationSnippet = "", applyActivationSnippet = "";
    if (activation) {
      if (hasPreluActivation) {
        activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
      } else if (hasLeakyreluActivation) {
        activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
      } else {
        activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
      }
      applyActivationSnippet = `result = activation(result);`;
    }
    const addBiasSnippet = addBias ? "result += getBiasAtOutCoords();" : "";
    if (addBias) {
      this.variableNames.push("bias");
    }
    if (hasPreluActivation) {
      this.variableNames.push("preluActivationWeights");
    }
    if (hasLeakyreluActivation) {
      this.variableNames.push("leakyreluAlpha");
    }
    let batchASnippet = "rc.x";
    let batchBSnippet = "rc.x";
    if (aShape[0] < bShape[0]) {
      batchASnippet = `int(min(float(rc.x), ${aShape[0] - 1}.))`;
    } else if (bShape[0] < aShape[0]) {
      batchBSnippet = `int(min(float(rc.x), ${bShape[0] - 1}.))`;
    }
    this.userCode = `
      ${activationSnippet}
      // Don't use uniform for sharedDimensionPacked for performance.
      const float sharedDimension = ${sharedDimensionPacked}.0;

      vec4 dot2x2ARowBCol(ivec3 rc) {
        vec4 result = vec4(0);
        for (int i = 0; i < ${sharedDimensionPacked}; i++) {
          int batchA = ${batchASnippet};
          int batchB = ${batchBSnippet};
          vec4 a = getMatrixA(batchA, ${aSample});
          vec4 b = getMatrixB(batchB, ${bSample});

          // These swizzled products need to be separately added.
          // See: https://github.com/tensorflow/tfjs/issues/1735
          result += (${aSwizzle[0]} * ${bSwizzle[0]});
          result += (${aSwizzle[1]} * ${bSwizzle[1]});
        }
        return result;
      }

      void main() {
        ivec3 rc = getOutputCoords();
        vec4 result = dot2x2ARowBCol(rc);

        ${addBiasSnippet}

        ${applyActivationSnippet}

        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const COMPLEX_MULTIPLY = {
  REAL: "return areal * breal - aimag * bimag;",
  IMAG: "return areal * bimag + aimag * breal;"
};
class BinaryOpComplexProgram {
  constructor(op2, aShape, bShape) {
    this.variableNames = ["AReal", "AImag", "BReal", "BImag"];
    this.outputShape = assertAndGetBroadcastShape(aShape, bShape);
    this.userCode = `
      float binaryOpComplex(
          float areal, float aimag, float breal, float bimag) {
        ${op2}
      }

      void main() {
        float areal = getARealAtOutCoords();
        float aimag = getAImagAtOutCoords();
        float breal = getBRealAtOutCoords();
        float bimag = getBImagAtOutCoords();
        setOutput(binaryOpComplex(areal, aimag, breal, bimag));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const MUL = "return a * b;";
function multiply(args) {
  const { inputs, backend: backend2 } = args;
  const { a: a6, b: b2 } = inputs;
  const dtype = upcastType(a6.dtype, b2.dtype);
  if (a6.dtype === "complex64") {
    const aData = backend2.texData.get(a6.dataId);
    const bData = backend2.texData.get(b2.dataId);
    const realProgram = new BinaryOpComplexProgram(COMPLEX_MULTIPLY.REAL, a6.shape, b2.shape);
    const imagProgram = new BinaryOpComplexProgram(COMPLEX_MULTIPLY.IMAG, a6.shape, b2.shape);
    const inputs2 = [
      {
        dataId: aData.complexTensorInfos.real.dataId,
        dtype: aData.complexTensorInfos.real.dtype,
        shape: a6.shape
      },
      {
        dataId: aData.complexTensorInfos.imag.dataId,
        dtype: aData.complexTensorInfos.imag.dtype,
        shape: a6.shape
      },
      {
        dataId: bData.complexTensorInfos.real.dataId,
        dtype: bData.complexTensorInfos.real.dtype,
        shape: b2.shape
      },
      {
        dataId: bData.complexTensorInfos.imag.dataId,
        dtype: bData.complexTensorInfos.imag.dtype,
        shape: b2.shape
      }
    ];
    const realPart = backend2.runWebGLProgram(realProgram, inputs2, "float32");
    const imagPart = backend2.runWebGLProgram(imagProgram, inputs2, "float32");
    const complexOutput = complex$1({ inputs: { real: realPart, imag: imagPart }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(realPart);
    backend2.disposeIntermediateTensorInfo(imagPart);
    return complexOutput;
  }
  if (backend2.shouldExecuteOnCPU([a6, b2])) {
    const aData = backend2.texData.get(a6.dataId);
    const bData = backend2.texData.get(b2.dataId);
    const [outValues, outShape] = multiplyImplCPU(a6.shape, b2.shape, aData.values, bData.values, dtype);
    const out = backend2.makeTensorInfo(outShape, dtype);
    const outData = backend2.texData.get(out.dataId);
    outData.values = outValues;
    return out;
  }
  let program;
  if (env().getBool("WEBGL_PACK_BINARY_OPERATIONS")) {
    program = new BinaryOpPackedProgram(MUL, a6.shape, b2.shape);
  } else {
    program = new BinaryOpProgram(MUL, a6.shape, b2.shape);
  }
  return backend2.runWebGLProgram(program, [a6, b2], dtype);
}
const multiplyConfig$1 = {
  kernelName: Multiply$1,
  backendName: "webgl",
  kernelFunc: multiply
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function packedReshape(input, afterShape, backend2) {
  const input3DShape = [
    getBatchDim(input.shape),
    ...getRowsCols(input.shape)
  ];
  const input3D = {
    dtype: input.dtype,
    shape: input3DShape,
    dataId: input.dataId
  };
  const afterShapeAs3D = [
    getBatchDim(afterShape),
    ...getRowsCols(afterShape)
  ];
  const program = new ReshapePackedProgram(afterShapeAs3D, input3DShape);
  const preventEagerUnpackingOfOutput = true;
  const customValues = [input3DShape];
  const output2 = backend2.runWebGLProgram(program, [input3D], input.dtype, customValues, preventEagerUnpackingOfOutput);
  return { dataId: output2.dataId, shape: afterShape, dtype: output2.dtype };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reshape$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { shape } = attrs;
  const webglBackend = backend2;
  const xSize = sizeFromShape(x2.shape);
  const $shape = inferFromImplicitShape(shape, xSize);
  const $xSize = sizeFromShape($shape);
  assert$1(xSize === $xSize, () => `The new shape (${$shape}) has ${$xSize} elements and the old shape (${x2.shape}) has ${xSize} elements. The new shape and old shape must have the same number of elements.`);
  const xTexData = webglBackend.texData.get(x2.dataId);
  if (xTexData.isPacked && !isReshapeFree(x2.shape, $shape) && !(xTexData.texture !== null && isReshapeFree(xTexData.shape, $shape))) {
    return packedReshape(x2, $shape, webglBackend);
  }
  webglBackend.incRef(x2.dataId);
  return { dataId: x2.dataId, shape: $shape, dtype: x2.dtype };
}
const reshapeConfig$1 = {
  kernelName: Reshape$1,
  backendName: "webgl",
  kernelFunc: reshape$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MeanProgram {
  constructor(reduceInfo, divisor) {
    this.variableNames = ["x"];
    const { windowSize, batchSize, inSize, outSize } = reduceInfo;
    this.outputShape = [batchSize, outSize];
    const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
    const windowSizeVec4Remainder = windowSize % 4;
    let updateSnippet = `sumValue += dot(values, ones);`;
    if (divisor != null) {
      const denominator = 1 / divisor;
      updateSnippet = `sumValue += dot(values * ${isInt(denominator) ? denominator.toPrecision(2) : denominator}, ones);`;
    }
    let checkOutOfBounds = "";
    if (inSize % windowSize > 0) {
      checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return 0.0;
        }
      `;
    }
    this.userCode = `
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1), 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2), 0.0);

          ${updateSnippet}
        }
        setOutput(sumValue);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ReduceProgram {
  constructor(reduceInfo, reduceType) {
    this.variableNames = ["x"];
    const { windowSize, batchSize, inSize, outSize } = reduceInfo;
    this.outputShape = [batchSize, outSize];
    let initializationValue = "0.0";
    let compareOp = ``;
    if (reduceType === "prod") {
      initializationValue = "1.0";
    } else if (reduceType === "min") {
      initializationValue = "1.0 / 1e-20";
      compareOp = `min`;
    } else if (reduceType === "max") {
      initializationValue = "-1.0 / 1e-20";
      compareOp = `max`;
    }
    let returnValue = `${reduceType}(${reduceType}(${reduceType}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;
    if (reduceType === "sum") {
      returnValue = `sumValue`;
    } else if (reduceType === "prod") {
      returnValue = `prodValue`;
    } else if (reduceType === "all") {
      returnValue = `allValue`;
    } else if (reduceType === "any") {
      returnValue = `anyValue`;
    }
    const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
    const windowSizeVec4Remainder = windowSize % 4;
    let updateSnippet = `
      if (${reduceType === "sum"}) {
        sumValue += dot(values, ones);
      } else if (${reduceType === "prod"}) {
        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);
        prodValue *= tmp[0] * tmp[1];
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
        if (${reduceType === "min"} || ${reduceType === "max"}) {
          minMaxValue = ${compareOp}(values, minMaxValue);
          bvec4 isNaN = isnan(values);
          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {
            minMaxValue = vec4(NAN);
          }
        }
      }
    `;
    let vecType = `vec4`;
    if (reduceType === "all") {
      initializationValue = "1.0";
      updateSnippet = `
        bool reducedAllValue = all(values);
        float floatedReducedAllValue = float(reducedAllValue);
        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);
      `;
      vecType = `bvec4`;
    } else if (reduceType === "any") {
      initializationValue = "0.0";
      updateSnippet = `
        bool reducedAnyValue = any(values);
        float floatedReducedAnyValue = float(reducedAnyValue);
        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);
      `;
      vecType = `bvec4`;
    }
    let checkOutOfBounds = "";
    if (inSize % windowSize > 0) {
      checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
    }
    this.userCode = `
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        vec4 minMaxValue = vec4(${initializationValue});
        float prodValue = 1.0;
        float sumValue = 0.0;
        float allValue = 1.0;
        float anyValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function getReductionStages(inShape) {
  const stages = [];
  while (stages.length === 0 || stages[stages.length - 1].outSize !== 1) {
    const outSize = stages.length ? stages[stages.length - 1].outSize : inShape[1];
    const windowSize = computeOptimalWindowSize(outSize);
    stages.push({
      inSize: outSize,
      windowSize,
      outSize: Math.ceil(outSize / windowSize)
    });
  }
  return stages;
}
function reduce(x2, dtype, reductionType, backend2) {
  const reductionStages = getReductionStages(x2.shape);
  let result2 = x2;
  for (let i2 = 0; i2 < reductionStages.length; i2++) {
    const { inSize, windowSize, outSize } = reductionStages[i2];
    let program;
    let previousResult;
    if (reductionType === "mean") {
      program = i2 === 0 ? new MeanProgram({ windowSize, inSize, batchSize: x2.shape[0], outSize }, inSize) : new MeanProgram({ windowSize, inSize, batchSize: x2.shape[0], outSize });
    } else {
      program = new ReduceProgram({ windowSize, inSize, batchSize: x2.shape[0], outSize }, reductionType);
    }
    previousResult = result2;
    result2 = backend2.runWebGLProgram(program, [result2], dtype);
    if (previousResult.dataId !== x2.dataId) {
      backend2.disposeIntermediateTensorInfo(previousResult);
    }
  }
  return result2;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TransposeProgram {
  constructor(aShape, newDim) {
    this.variableNames = ["A"];
    const outputShape = new Array(aShape.length);
    for (let i2 = 0; i2 < outputShape.length; i2++) {
      outputShape[i2] = aShape[newDim[i2]];
    }
    this.outputShape = outputShape;
    this.rank = outputShape.length;
    const dtype = getCoordsDataType(this.rank);
    const switched = getSwitchedCoords(newDim);
    this.userCode = `
    void main() {
      ${dtype} resRC = getOutputCoords();
      setOutput(getA(${switched}));
    }
    `;
  }
}
function getSwitchedCoords(newDim) {
  const rank = newDim.length;
  if (rank > 6) {
    throw Error(`Transpose for rank ${rank} is not yet supported`);
  }
  const originalOrder = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u", "resRC.v"];
  const switchedCoords = new Array(rank);
  for (let i2 = 0; i2 < newDim.length; i2++) {
    switchedCoords[newDim[i2]] = originalOrder[i2];
  }
  return switchedCoords.join();
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TransposePackedProgram {
  constructor(aShape, newDim) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    const outputShape = new Array(aShape.length);
    for (let i2 = 0; i2 < outputShape.length; i2++) {
      outputShape[i2] = aShape[newDim[i2]];
    }
    this.outputShape = outputShape;
    this.rank = outputShape.length;
    if (this.rank > 6) {
      throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
    }
    const dtype = getCoordsDataType(this.rank);
    const outputOrder = getVecChannels("rc", this.rank);
    const switchedOrder = new Array(this.rank);
    for (let i2 = 0; i2 < newDim.length; i2++) {
      switchedOrder[newDim[i2]] = outputOrder[i2];
    }
    const innerDims = `vec2(${switchedOrder.slice(-2).join()})`;
    const nextColumn = `++${outputOrder[this.rank - 1]} < ${outputShape[this.rank - 1]}`;
    const getc = `getChannel(getA(${switchedOrder.join()}), ${innerDims})`;
    this.userCode = `
    void main() {
      ${dtype} rc = getOutputCoords();
      vec4 result = vec4(0.);
      result[0] = ${getc};
      if(${nextColumn}) {
        result[1] = ${getc};
      }
      --${outputOrder[this.rank - 1]};
      if(++${outputOrder[this.rank - 2]} < ${outputShape[this.rank - 2]}) {
        result[2] = ${getc};
        if(${nextColumn}) {
          result[3] = ${getc};
        }
      }
      setOutput(result);
    }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transposeImpl(x2, perm, backend2) {
  const program = env().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new TransposePackedProgram(x2.shape, perm) : new TransposeProgram(x2.shape, perm);
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sumImpl(x2, axis, keepDims, backend2) {
  const reductionIndices = axis;
  const xRank = x2.shape.length;
  const origAxes = parseAxisParam(reductionIndices, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  const sumInputIsTransposed = permutedAxes != null;
  let sumInput = x2;
  if (sumInputIsTransposed) {
    sumInput = transposeImpl(x2, permutedAxes, backend2);
    axes = getInnerMostAxes(axes.length, xRank);
  }
  assertAxesAreInnerMostDims("sum", axes, xRank);
  const [sumOutShape, reduceShape] = computeOutAndReduceShapes(sumInput.shape, axes);
  let outShape = sumOutShape;
  if (keepDims) {
    outShape = expandShapeToKeepDim(sumOutShape, origAxes);
  }
  const inSize = sizeFromShape(reduceShape);
  const xSize = sizeFromShape(x2.shape);
  const batchSize = xSize / inSize;
  const reshapedInput = reshape$1({ inputs: { x: sumInput }, attrs: { shape: [batchSize, inSize] }, backend: backend2 });
  const outType = sumOutType(x2.dtype);
  const reduced = reduce(reshapedInput, outType, "sum", backend2);
  const out = reshape$1({ inputs: { x: reduced }, attrs: { shape: outShape }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(reshapedInput);
  backend2.disposeIntermediateTensorInfo(reduced);
  if (sumInputIsTransposed) {
    backend2.disposeIntermediateTensorInfo(sumInput);
  }
  return out;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sum$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  return sumImpl(x2, axis, keepDims, backend2);
}
const sumConfig$1 = {
  kernelName: Sum,
  backendName: "webgl",
  kernelFunc: sum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transpose$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { perm } = attrs;
  const webglBackend = backend2;
  const xRank = x2.shape.length;
  const newShape = new Array(xRank);
  for (let i2 = 0; i2 < newShape.length; i2++) {
    newShape[i2] = x2.shape[perm[i2]];
  }
  let out;
  if (webglBackend.shouldExecuteOnCPU([x2])) {
    const xTexData = webglBackend.texData.get(x2.dataId);
    const values = xTexData.values;
    const outValues = transposeImplCPU(values, x2.shape, x2.dtype, perm, newShape);
    out = webglBackend.makeTensorInfo(newShape, x2.dtype);
    const outData = webglBackend.texData.get(out.dataId);
    outData.values = outValues;
  } else {
    out = transposeImpl(x2, perm, webglBackend);
  }
  return out;
}
const transposeConfig$1 = {
  kernelName: Transpose,
  backendName: "webgl",
  kernelFunc: transpose$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const MATMUL_SHARED_DIM_THRESHOLD = 1e3;
function batchMatMulImpl({ a: a6, b: b2, transposeA, transposeB, backend: backend2, bias = null, preluActivationWeights = null, leakyreluAlpha = 0, activation = null }) {
  const aRank = a6.shape.length;
  const bRank = b2.shape.length;
  const innerShapeA = transposeA ? a6.shape[aRank - 2] : a6.shape[aRank - 1];
  const innerShapeB = transposeB ? b2.shape[bRank - 1] : b2.shape[bRank - 2];
  const outerShapeA = transposeA ? a6.shape[aRank - 1] : a6.shape[aRank - 2];
  const outerShapeB = transposeB ? b2.shape[bRank - 2] : b2.shape[bRank - 1];
  const outerDimsA = a6.shape.slice(0, -2);
  const outerDimsB = b2.shape.slice(0, -2);
  const batchDimA = sizeFromShape(outerDimsA);
  const batchDimB = sizeFromShape(outerDimsB);
  const outShapeOuterDims = assertAndGetBroadcastShape(a6.shape.slice(0, -2), b2.shape.slice(0, -2));
  const outShape = outShapeOuterDims.concat([outerShapeA, outerShapeB]);
  assert$1(innerShapeA === innerShapeB, () => `Error in matMul: inner shapes (${innerShapeA}) and (${innerShapeB}) of Tensors with shapes ${a6.shape} and ${b2.shape} and transposeA=${transposeA} and transposeB=${transposeB} must match.`);
  const a3dShape = transposeA ? [batchDimA, innerShapeA, outerShapeA] : [batchDimA, outerShapeA, innerShapeA];
  const b3dShape = transposeB ? [batchDimB, outerShapeB, innerShapeB] : [batchDimB, innerShapeB, outerShapeB];
  const a3d = reshape$1({ inputs: { x: a6 }, backend: backend2, attrs: { shape: a3dShape } });
  const b3d = reshape$1({ inputs: { x: b2 }, backend: backend2, attrs: { shape: b3dShape } });
  const intermediates = [a3d, b3d];
  const batchDim = Math.max(batchDimA, batchDimB);
  const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
  const hasBias = bias != null;
  const hasPreluActivationWeights = preluActivationWeights != null;
  const hasLeakyreluAlpha = activation === "leakyrelu";
  const fusedActivation = activation != null ? mapActivationToShaderProgram(activation, true) : null;
  const containsFusedOps = hasBias || hasPreluActivationWeights || hasLeakyreluAlpha || fusedActivation != null;
  let out;
  if ((outerShapeA === 1 || outerShapeB === 1) && sharedDim > MATMUL_SHARED_DIM_THRESHOLD && containsFusedOps === false) {
    let aVec = a3d;
    let bVec = b3d;
    if (transposeA) {
      aVec = transpose$1({ inputs: { x: a3d }, backend: backend2, attrs: { perm: [0, 2, 1] } });
      intermediates.push(aVec);
    }
    if (transposeB) {
      bVec = transpose$1({ inputs: { x: b3d }, backend: backend2, attrs: { perm: [0, 2, 1] } });
      intermediates.push(bVec);
    }
    const shouldReshapeA = outerShapeB !== 1;
    const shouldReshapeB = outerShapeB === 1;
    let aVec3d = aVec;
    if (shouldReshapeA) {
      aVec3d = reshape$1({
        inputs: { x: aVec },
        backend: backend2,
        attrs: { shape: [batchDim, sharedDim, 1] }
      });
      intermediates.push(aVec3d);
    }
    const axis = outerShapeB === 1 ? 2 : 1;
    let bVec3d = bVec;
    if (shouldReshapeB) {
      bVec3d = reshape$1({
        inputs: { x: bVec },
        backend: backend2,
        attrs: { shape: [batchDim, 1, sharedDim] }
      });
      intermediates.push(bVec3d);
    }
    const product = multiply({ inputs: { a: aVec3d, b: bVec3d }, backend: backend2 });
    out = sum$1({ inputs: { x: product }, backend: backend2, attrs: { axis, keepDims: true } });
    intermediates.push(product);
  } else {
    const dtype = upcastType(a6.dtype, b2.dtype);
    const program = new MatMulPackedProgram(a3dShape, b3dShape, [batchDim, outerShapeA, outerShapeB], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const inputs = [a3d, b3d];
    if (bias != null) {
      inputs.push(bias);
    }
    if (hasPreluActivationWeights) {
      inputs.push(preluActivationWeights);
    }
    if (hasLeakyreluAlpha) {
      const $leakyreluAlpha = backend2.makeTensorInfo([], "float32", createScalarValue(leakyreluAlpha, "float32"));
      inputs.push($leakyreluAlpha);
      intermediates.push($leakyreluAlpha);
    }
    out = backend2.runWebGLProgram(program, inputs, dtype);
  }
  const outReshaped = reshape$1({ inputs: { x: out }, backend: backend2, attrs: { shape: outShape } });
  intermediates.push(out);
  for (const i2 of intermediates) {
    backend2.disposeIntermediateTensorInfo(i2);
  }
  return outReshaped;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function _fusedMatMul(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { a: a6, b: b2, bias, preluActivationWeights } = inputs;
  const { transposeA, transposeB, activation, leakyreluAlpha } = attrs;
  return batchMatMulImpl({
    a: a6,
    b: b2,
    transposeA,
    transposeB,
    backend: backend2,
    bias,
    preluActivationWeights,
    leakyreluAlpha,
    activation
  });
}
const _fusedMatMulConfig$1 = {
  kernelName: _FusedMatMul,
  backendName: "webgl",
  kernelFunc: _fusedMatMul
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ABS = `return abs(x);`;
function abs(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  if (backend2.shouldExecuteOnCPU([x2]) && x2.dtype !== "complex64") {
    const xData = backend2.texData.get(x2.dataId);
    const outValues = simpleAbsImplCPU(xData.values);
    return backend2.makeTensorInfo(x2.shape, x2.dtype, outValues);
  }
  let program;
  if (env().getBool("WEBGL_PACK_UNARY_OPERATIONS")) {
    program = new UnaryOpPackedProgram(x2.shape, ABS);
  } else {
    program = new UnaryOpProgram(x2.shape, ABS);
  }
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
}
const absConfig$1 = {
  kernelName: Abs,
  backendName: "webgl",
  kernelFunc: abs
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ACOS = CHECK_NAN_SNIPPET$2 + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return acos(x);
`;
const acos = unaryKernelFunc({ opSnippet: ACOS });
const acosConfig = {
  kernelName: Acos,
  backendName: "webgl",
  kernelFunc: acos
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ACOSH = CHECK_NAN_SNIPPET$2 + `
  if (x < 1.0) return NAN;
return log(x + sqrt(x * x - 1.0));`;
const acosh = unaryKernelFunc({ opSnippet: ACOSH });
const acoshConfig = {
  kernelName: Acosh,
  backendName: "webgl",
  kernelFunc: acosh
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ADD = "return a + b;";
const addKernelFunc = binaryKernelFunc({
  opSnippet: ADD,
  packedOpSnippet: ADD,
  supportsComplex: true,
  cpuKernelImpl: addImplCPU
});
const addConfig$1 = {
  kernelName: Add$1,
  backendName: "webgl",
  kernelFunc: addKernelFunc
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class AddNProgram {
  constructor(outputShape, shapes) {
    this.outputShape = [];
    this.outputShape = outputShape;
    this.variableNames = shapes.map((_24, i2) => `T${i2}`);
    const snippets = [];
    this.variableNames.forEach((variable2) => {
      snippets.push(`float v${variable2} = get${variable2}AtOutCoords();`);
    });
    const operation = this.variableNames.map((variable2) => {
      return `v${variable2}`;
    }).join(" + ");
    this.userCode = `
      void main() {
        ${snippets.join("\n        ")}

        float result = ${operation};
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class AddNPackedProgram {
  constructor(outputShape, shapes) {
    this.outputShape = [];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = outputShape;
    this.variableNames = shapes.map((_24, i2) => `T${i2}`);
    const snippets = [];
    this.variableNames.forEach((variable2) => {
      snippets.push(`vec4 v${variable2} = get${variable2}AtOutCoords();`);
    });
    const operation = this.variableNames.map((variable2) => {
      return `v${variable2}`;
    }).join(" + ");
    this.userCode = `
      void main() {
        ${snippets.join("\n        ")}

        vec4 result = ${operation};
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function addN(args) {
  const { inputs, backend: backend2 } = args;
  const tensors = inputs;
  if (tensors.length === 1) {
    return identity$1({ inputs: { x: tensors[0] }, backend: backend2 });
  }
  if (tensors.length > env().get("WEBGL_MAX_TEXTURES_IN_SHADER")) {
    const midIndex = Math.floor(tensors.length / 2);
    const leftSide = addN({ inputs: tensors.slice(0, midIndex), backend: backend2 });
    const rightSide = addN({ inputs: tensors.slice(midIndex), backend: backend2 });
    return addN({ inputs: [leftSide, rightSide], backend: backend2 });
  }
  const dtype = tensors.map((t2) => t2.dtype).reduce((d1, d2) => upcastType(d1, d2));
  const shapes = tensors.map((t2) => t2.shape);
  const usePackedOp = env().getBool("WEBGL_PACK");
  const program = usePackedOp ? new AddNPackedProgram(tensors[0].shape, shapes) : new AddNProgram(tensors[0].shape, shapes);
  return backend2.runWebGLProgram(program, tensors, dtype);
}
const addNConfig$1 = {
  kernelName: AddN,
  backendName: "webgl",
  kernelFunc: addN
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function all$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  const xRank = x2.shape.length;
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  let permutedX = x2;
  if (permutedAxes != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, xRank);
  }
  assertAxesAreInnerMostDims("all", axes, xRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(permutedX.shape, axes);
  const inSize = sizeFromShape(reduceShape);
  const a2D = reshape$1({ inputs: { x: permutedX }, backend: backend2, attrs: { shape: [-1, inSize] } });
  const reduced = reduce(a2D, a2D.dtype, "all", backend2);
  let res;
  if (keepDims) {
    const newShape = expandShapeToKeepDim(outShape, origAxes);
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: newShape } });
  } else {
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: outShape } });
  }
  backend2.disposeIntermediateTensorInfo(a2D);
  backend2.disposeIntermediateTensorInfo(reduced);
  if (permutedAxes != null) {
    backend2.disposeIntermediateTensorInfo(permutedX);
  }
  return res;
}
const allConfig$1 = {
  kernelName: All,
  backendName: "webgl",
  kernelFunc: all$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function any$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  const xRank = x2.shape.length;
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  let permutedX = x2;
  if (permutedAxes != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, xRank);
  }
  assertAxesAreInnerMostDims("any", axes, xRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(permutedX.shape, axes);
  const inSize = sizeFromShape(reduceShape);
  const a2D = reshape$1({ inputs: { x: permutedX }, backend: backend2, attrs: { shape: [-1, inSize] } });
  const reduced = reduce(a2D, a2D.dtype, "any", backend2);
  let res;
  if (keepDims) {
    const newShape = expandShapeToKeepDim(outShape, origAxes);
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: newShape } });
  } else {
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: outShape } });
  }
  backend2.disposeIntermediateTensorInfo(a2D);
  backend2.disposeIntermediateTensorInfo(reduced);
  if (permutedAxes != null) {
    backend2.disposeIntermediateTensorInfo(permutedX);
  }
  return res;
}
const anyConfig$1 = {
  kernelName: Any,
  backendName: "webgl",
  kernelFunc: any$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ArgMinMaxProgram {
  constructor(reduceInfo, op2, firstPass) {
    this.variableNames = ["A"];
    const { windowSize, batchSize, outSize } = reduceInfo;
    if (!firstPass) {
      this.variableNames.push("bestIndicesA");
    }
    this.outputShape = [batchSize, outSize];
    const compOp = op2 === "max" ? ">" : "<";
    const indexSnippet = firstPass ? "inOffset + i;" : "round(getBestIndicesA(batch, inOffset + i));";
    this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        int bestIndex = inOffset;
        float bestValue = getA(batch, bestIndex);

        for (int i = 0; i < ${windowSize}; i++) {
          int inIdx = ${indexSnippet};
          float candidate = getA(batch, inIdx);
          if (candidate ${compOp} bestValue) {
            bestValue = candidate;
            bestIndex = inIdx;
          }
        }
        setOutput(float(bestIndex));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ArgMinMaxPackedProgram {
  constructor(shape, windowSize, op2, firstPass) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    assert$1(shape.length > 2, () => `Packed arg${op2.charAt(0).toUpperCase() + op2.slice(1)} supports only inputs with rank above 2.`);
    const inSize = shape[shape.length - 1];
    const outSize = Math.ceil(inSize / windowSize);
    this.outputShape = shape.slice(0, -1);
    if (outSize > 1) {
      this.outputShape.push(outSize);
    }
    if (!firstPass) {
      this.variableNames.push("bestIndicesA");
    }
    const outShape = this.outputShape;
    const rank = outShape.length;
    const dtype = getCoordsDataType(rank);
    const coords2 = getChannels("coords", rank);
    let sourceLocSetup;
    let sourceRank;
    if (outSize === 1) {
      sourceRank = rank + 1;
      const sourceLocDType = getCoordsDataType(sourceRank);
      sourceLocSetup = `
        ${sourceLocDType} sourceLocR = ${sourceLocDType}(${coords2.join()}, 0);
        ++${coords2[rank - 1]};
        ${sourceLocDType} sourceLocG = ${sourceLocDType}(${coords2.join()}, 0);
        ++${coords2[rank - 2]};
        ${sourceLocDType} sourceLocA = ${sourceLocDType}(${coords2.join()}, 0);
        --${coords2[rank - 1]};
        ${sourceLocDType} sourceLocB = ${sourceLocDType}(${coords2.join()}, 0);
        --${coords2[rank - 2]};`;
    } else {
      sourceRank = rank;
      sourceLocSetup = `
        ${dtype} sourceLocR = coords;
        ++${coords2[rank - 1]};
        ${dtype} sourceLocG = coords;
        ++${coords2[rank - 2]};
        ${dtype} sourceLocA = coords;
        --${coords2[rank - 1]};
        ${dtype} sourceLocB = coords;
        --${coords2[rank - 2]};`;
    }
    const channels = ["x", "y", "z", "w", "u", "v"].slice(0, sourceRank);
    const inChannel = "." + channels[sourceRank - 1];
    const intChannels = channels.map((x2) => "int " + x2);
    const srcRCoords = getChannels("sourceLocR", sourceRank - 1).concat("inIdx.r");
    const srcGCoords = getChannels("sourceLocG", sourceRank - 1).concat("inIdx.g");
    const srcBCoords = getChannels("sourceLocB", sourceRank - 1).concat("inIdx.b");
    const srcACoords = getChannels("sourceLocA", sourceRank - 1).concat("inIdx.a");
    const compOp = op2 === "max" ? "greaterThan" : "lessThan";
    const fetchCandidateIdx = firstPass ? "" : `
          inIdx = round(vec4(getBestIndicesAChannel(${srcRCoords.join()}),
                             getBestIndicesAChannel(${srcGCoords.join()}),
                             getBestIndicesAChannel(${srcBCoords.join()}),
                             getBestIndicesAChannel(${srcACoords.join()})));`;
    const fetchValue = `vec4(
            getAChannel(${srcRCoords.join()}),
            hasNextCol ? getAChannel(${srcGCoords.join()}) : 0.,
            hasNextRow ? getAChannel(${srcBCoords.join()}) : 0.,
            hasNextRow && hasNextCol ? getAChannel(${srcACoords.join()}) : 0.)`;
    const getBestIndicesAChannelSnippet = firstPass ? "" : `
      float getBestIndicesAChannel(${intChannels.join()}) {
        return getChannel(getBestIndicesA(${channels.join()}),
                                          vec2(${channels.slice(-2).join()}));
      }`;
    this.userCode = `
      float getAChannel(${intChannels.join()}) {
        return getChannel(getA(${channels.join()}),
                               vec2(${channels.slice(-2).join()}));
      }
      ${getBestIndicesAChannelSnippet}
      void main() {
        ${dtype} coords = getOutputCoords();
        bool hasNextCol = ${coords2[rank - 1]} < ${outShape[rank - 1] - 1};
        bool hasNextRow = ${coords2[rank - 2]} < ${outShape[rank - 2] - 1};
        ${sourceLocSetup}
        ivec4 srcIdx = ivec4(sourceLocR${inChannel}, sourceLocG${inChannel},
          sourceLocB${inChannel}, sourceLocA${inChannel}) * ${windowSize};
        ivec4 inIdx = srcIdx;
        vec4 bestIndex = vec4(inIdx);
        vec4 bestValue = ${fetchValue};

        for (int i = 0; i < ${windowSize}; i++) {
          inIdx = srcIdx;
          ${fetchCandidateIdx}
          vec4 candidate = ${fetchValue};
          bvec4 nan = isnan(candidate);
          bvec4 replace = bvec4(
            vec4(${compOp}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));

          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,
                           replace.y  ? candidate.y : bestValue.y,
                           replace.z  ? candidate.z : bestValue.z,
                           replace.w  ? candidate.w : bestValue.w);
          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));
          srcIdx++;
        }
        setOutput(bestIndex);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argReduce(backend2, x2, reduceType, bestIndicesA = null) {
  let batchSize = x2.shape[0];
  let inSize = x2.shape[1];
  if (bestIndicesA != null) {
    batchSize = bestIndicesA.shape[0];
    inSize = bestIndicesA.shape[1];
  }
  const windowSize = computeOptimalWindowSize(inSize);
  const reduceInfo = { windowSize, inSize, batchSize, outSize: Math.ceil(inSize / windowSize) };
  const program = new ArgMinMaxProgram(reduceInfo, reduceType, bestIndicesA == null);
  const inputs = [x2];
  if (bestIndicesA != null) {
    inputs.push(bestIndicesA);
  }
  const output2 = backend2.runWebGLProgram(program, inputs, "int32");
  if (output2.shape[1] === 1) {
    return output2;
  }
  const result2 = argReduce(backend2, x2, reduceType, output2);
  backend2.disposeIntermediateTensorInfo(output2);
  return result2;
}
function argReducePacked(backend2, x2, reduceType, bestIndicesA = null) {
  const inShape = bestIndicesA != null ? bestIndicesA.shape : x2.shape;
  const inSize = inShape[inShape.length - 1];
  const windowSize = computeOptimalWindowSize(inSize);
  const program = new ArgMinMaxPackedProgram(inShape, windowSize, reduceType, bestIndicesA == null);
  const inputs = bestIndicesA == null ? [x2] : [x2, bestIndicesA];
  const output2 = backend2.runWebGLProgram(program, inputs, "int32");
  if (output2.shape.length === x2.shape.length) {
    const result2 = argReducePacked(backend2, x2, reduceType, output2);
    backend2.disposeIntermediateTensorInfo(output2);
    return result2;
  }
  return output2;
}
function argMinMaxReduce(backend2, x2, axis, reduceType) {
  const axes = [axis];
  assertAxesAreInnerMostDims("arg" + reduceType.charAt(0).toUpperCase() + reduceType.slice(1), axes, x2.shape.length);
  if (!env().getBool("WEBGL_PACK_REDUCE") || x2.shape.length <= 2) {
    const intermediateTensorInfos = [];
    const xtexData = backend2.texData.get(x2.dataId);
    const xIsPacked = xtexData !== null && xtexData.isPacked;
    let xUnPacked = x2;
    if (xIsPacked) {
      xUnPacked = backend2.unpackTensor(x2);
      intermediateTensorInfos.push(xUnPacked);
    }
    const [outShape, reduceShape] = computeOutAndReduceShapes(xUnPacked.shape, axes);
    const inSize = sizeFromShape(reduceShape);
    const a2D = reshape$1({ inputs: { x: xUnPacked }, backend: backend2, attrs: { shape: [-1, inSize] } });
    intermediateTensorInfos.push(a2D);
    const reduced = argReduce(backend2, a2D, reduceType);
    intermediateTensorInfos.push(reduced);
    const reshaped = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: outShape } });
    intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
    return reshaped;
  }
  return argReducePacked(backend2, x2, reduceType);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argMax(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis } = attrs;
  let axes = parseAxisParam(axis, x2.shape);
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  const intermediateTensorInfos = [];
  if (permutedAxes != null) {
    $x = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    intermediateTensorInfos.push($x);
    axes = getInnerMostAxes(axes.length, $x.shape.length);
  }
  assertAxesAreInnerMostDims("argMax", [axes[0]], $x.shape.length);
  const out = argMinMaxReduce(backend2, $x, axes[0], "max");
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return out;
}
const argMaxConfig$1 = {
  kernelName: ArgMax,
  backendName: "webgl",
  kernelFunc: argMax
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function argMin(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis } = attrs;
  let axes = parseAxisParam(axis, x2.shape);
  const permutedAxes = getAxesPermutation(axes, x2.shape.length);
  let $x = x2;
  const intermediateTensorInfos = [];
  if (permutedAxes != null) {
    $x = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    intermediateTensorInfos.push($x);
    axes = getInnerMostAxes(axes.length, $x.shape.length);
  }
  assertAxesAreInnerMostDims("argMin", [axes[0]], $x.shape.length);
  const out = argMinMaxReduce(backend2, $x, axes[0], "min");
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return out;
}
const argMinConfig = {
  kernelName: ArgMin,
  backendName: "webgl",
  kernelFunc: argMin
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ASIN = CHECK_NAN_SNIPPET$2 + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return asin(x);
`;
const asin = unaryKernelFunc({ opSnippet: ASIN });
const asinConfig = {
  kernelName: Asin,
  backendName: "webgl",
  kernelFunc: asin
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ASINH = CHECK_NAN_SNIPPET$2 + `return log(x + sqrt(x * x + 1.0));`;
const asinh = unaryKernelFunc({ opSnippet: ASINH });
const asinhConfig = {
  kernelName: Asinh,
  backendName: "webgl",
  kernelFunc: asinh
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ATAN = CHECK_NAN_SNIPPET$2 + `
  return atan(x);
`;
const atan = unaryKernelFunc({ opSnippet: ATAN });
const atanConfig = {
  kernelName: Atan,
  backendName: "webgl",
  kernelFunc: atan
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ATAN2 = CHECK_NAN_SNIPPET_BINARY + `
  return atan(a, b);
`;
const ATAN2_PACKED = `
  vec4 result = atan(a, b);
  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));
  ` + CHECK_NAN_SNIPPET_BINARY_PACKED + `
  return result;
`;
const atan2 = binaryKernelFunc({ opSnippet: ATAN2, packedOpSnippet: ATAN2_PACKED });
const atan2Config = {
  kernelName: Atan2,
  backendName: "webgl",
  kernelFunc: atan2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ATANH = CHECK_NAN_SNIPPET$2 + `
  if ((x < -1.0) || (x > 1.0)) return NAN;
return (log(1.0 + x) - log(1.0 - x)) / 2.0;`;
const atanh = unaryKernelFunc({ opSnippet: ATANH });
const atanhConfig = {
  kernelName: Atanh,
  backendName: "webgl",
  kernelFunc: atanh
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Pool2DProgram {
  constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false) {
    this.variableNames = ["x"];
    if (poolType === "avg" && computePositions) {
      throw new Error("Cannot compute positions for average pool.");
    }
    const filterWidth = convInfo.filterWidth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    this.outputShape = convInfo.outShape;
    const isAvgPool = poolType === "avg";
    const batchFlattenPositionStr = `((batch  * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
    const flattenPositionStr = `(xR * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
    let initializationValue = "0.0";
    if (!isAvgPool) {
      initializationValue = "-1.0 / 1e-20";
    }
    if (computePositions) {
      const compareOp2 = ">=";
      this.userCode = `
        const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
        const ivec2 pads = ivec2(${padTop}, ${padLeft});

        void main() {
          ivec4 coords = getOutputCoords();
          int batch = coords[0];
          int d = coords[3];

          ivec2 xRCCorner = coords.yz * strides - pads;
          int xRCorner = xRCCorner.x;
          int xCCorner = xRCCorner.y;

          // max/min x(?, ?, d) to get y(yR, yC, d).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;
          float avgValue = 0.0;

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              int xC = xCCorner + wC;

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float value = getX(batch, xR, xC, d);

              // If a min / max value has already been found, use it. If not,
              // use the current value.
              float currMinMaxValue = mix(
                  value, minMaxValue, minMaxValueFound);
              if (value ${compareOp2} currMinMaxValue) {
                minMaxValue = value;
                minMaxValueFound = 1.0;
                minMaxPosition = ${flattenPositions ? includeBatchInIndex ? batchFlattenPositionStr : flattenPositionStr : `wR * ${effectiveFilterWidth} + wC`};
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
      return;
    }
    const compareOp = "max";
    let returnValue = `${poolType}(${poolType}(${poolType}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;
    if (poolType === "avg") {
      returnValue = `avgValue / count`;
    }
    const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
    const filterWidthVec4Remainder = filterWidth % 4;
    const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
    this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xR, int xC, int d) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xR, xC, d);
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d = coords[3];

        ivec2 xRCCorner = coords.yz * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // max/min x(?, ?, d) to get y(yR, yC, d).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          int xR = xRCorner + wR;

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
            int xC = xCCorner + wC * ${dilationWidth};

            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              getValue(batch, xR, xC + 3 * ${dilationWidth}, d)
            );

            ${updateSnippet}
          }

          int xC = xCCorner + ${filterWidthNearestVec4};
          if (${filterWidthVec4Remainder === 1}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              initializationValue,
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 2}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 3}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              initializationValue
            );

            ${updateSnippet}
          }
        }
        setOutput(${returnValue});
      }
    `;
  }
}
class Pool3DProgram {
  constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false) {
    this.variableNames = ["x"];
    if (poolType === "avg" && computePositions) {
      throw new Error("Cannot compute positions for average pool.");
    }
    const filterWidth = convInfo.filterWidth;
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    this.outputShape = convInfo.outShape;
    const isAvgPool = poolType === "avg";
    let initializationValue = "0.0";
    if (!isAvgPool) {
      initializationValue = "-1.0 / 1e-20";
    }
    if (computePositions) {
      const compareOp2 = ">=";
      this.userCode = `
        const ivec3 strides =
            ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
        const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

        void main() {
          ivec5 coords = getOutputCoords();
          int batch = coords.x;
          int ch = coords.u;

          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
          int xDCorner = xCorner.x;
          int xRCorner = xCorner.y;
          int xCCorner = xCorner.z;

          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;

          for (int wD = 0; wD < ${effectiveFilterDepth};
              wD += ${dilationDepth}) {
            int xD = xDCorner + wD;

            if (xD < 0 || xD >= ${convInfo.inDepth}) {
              continue;
            }

            for (int wR = 0; wR < ${effectiveFilterHeight};
                wR += ${dilationHeight}) {
              int xR = xRCorner + wR;

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int wC = 0; wC < ${effectiveFilterWidth};
                  wC += ${dilationWidth}) {
                int xC = xCCorner + wC;

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float value = getX(batch, xD, xR, xC, ch);

                // If a min / max value has already been found, use it. If not,
                // use the current value.
                float currMinMaxValue = mix(
                    value, minMaxValue, minMaxValueFound);
                if (value ${compareOp2} currMinMaxValue) {
                  minMaxValue = value;
                  minMaxValueFound = 1.0;
                  minMaxPosition = ${flattenPositions ? includeBatchInIndex ? `(((batch * ${convInfo.inDepth} + xD) * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `((xD * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                      wR * ${effectiveFilterWidth} + wC`};
                }
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
      return;
    }
    const compareOp = "max";
    let returnValue = `${poolType}(${poolType}(${poolType}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;
    if (poolType === "avg") {
      returnValue = `avgValue / count`;
    }
    const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
    const filterWidthVec4Remainder = filterWidth % 4;
    const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
    this.userCode = `
      const ivec3 strides =
        ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xD, int xR, int xC, int ch) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xD, xR, xC, ch);
      }

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xDCorner = xCorner.x;
        int xRCorner = xCorner.y;
        int xCCorner = xCorner.z;

        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          int xD = xDCorner + wD;

          if (xD < 0 || xD >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
              int xC = xCCorner + wC * ${dilationWidth};

              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 3 * ${dilationWidth}, ch)
              );

              ${updateSnippet}
            }

            int xC = xCCorner + ${filterWidthNearestVec4};
            if (${filterWidthVec4Remainder === 1}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                initializationValue,
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 2}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 3}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                initializationValue
              );

              ${updateSnippet}
            }
          }
          setOutput(${returnValue});
        }
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  assertNotComplex(x2, "avgPool");
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const dilations = 1;
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in avgPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode);
  if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && arraysEqual(convInfo.inShape, convInfo.outShape)) {
    return identity$1({ inputs: { x: x2 }, backend: backend2 });
  }
  const avgPoolProgram = new Pool2DProgram(convInfo, "avg", false);
  return backend2.runWebGLProgram(avgPoolProgram, [x2], "float32");
}
const avgPoolConfig$1 = {
  kernelName: AvgPool,
  backendName: "webgl",
  kernelFunc: avgPool$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool3D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { filterSize, strides, pad: pad2, dimRoundingMode, dataFormat } = attrs;
  const dilations = [1, 1, 1];
  const convInfo = computePool3DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode, dataFormat);
  const avgPoolProgram = new Pool3DProgram(convInfo, "avg", false);
  return backend2.runWebGLProgram(avgPoolProgram, [x2], "float32");
}
const avgPool3DConfig = {
  kernelName: AvgPool3D,
  backendName: "webgl",
  kernelFunc: avgPool3D
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class AvgPool2DBackpropProgram {
  constructor(convInfo) {
    this.variableNames = ["dy"];
    this.outputShape = convInfo.inShape;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const avgMultiplier = 1 / (filterHeight * filterWidth);
    this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth};
            wC+= ${dilationWidth}) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);

            dotProd += dyValue * avgMultiplier;
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
class AvgPool3DBackpropProgram {
  constructor(convInfo) {
    this.variableNames = ["dy"];
    this.outputShape = convInfo.inShape;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
    this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);

              dotProd += dyValue * avgMultiplier;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPool3DGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input } = inputs;
  const x2 = input;
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const dilations = [1, 1, 1];
  const convInfo = computePool3DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode);
  const avgPoolBackpropProgram = new AvgPool3DBackpropProgram(convInfo);
  return backend2.runWebGLProgram(avgPoolBackpropProgram, [dy], x2.dtype);
}
const avgPool3DGradConfig = {
  kernelName: AvgPool3DGrad,
  backendName: "webgl",
  kernelFunc: avgPool3DGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function avgPoolGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input } = inputs;
  const x2 = input;
  assertNotComplex([dy, input], "avgPoolGrad");
  const { filterSize, strides, pad: pad2 } = attrs;
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, 1, pad2);
  const avgPoolBackpropProgram = new AvgPool2DBackpropProgram(convInfo);
  return backend2.runWebGLProgram(avgPoolBackpropProgram, [dy], x2.dtype);
}
const avgPoolGradConfig = {
  kernelName: AvgPoolGrad,
  backendName: "webgl",
  kernelFunc: avgPoolGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchMatMul$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { a: a6, b: b2 } = inputs;
  const { transposeA, transposeB } = attrs;
  return batchMatMulImpl({ a: a6, b: b2, transposeA, transposeB, backend: backend2 });
}
const batchMatMulConfig$1 = {
  kernelName: BatchMatMul,
  backendName: "webgl",
  kernelFunc: batchMatMul$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class BatchNormProgram {
  constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon) {
    this.outputShape = [];
    this.variableNames = ["x", "mean", "variance"];
    assertAndGetBroadcastShape(xShape, meanShape);
    assertAndGetBroadcastShape(xShape, varianceShape);
    let offsetSnippet = "0.0";
    if (offsetShape != null) {
      assertAndGetBroadcastShape(xShape, offsetShape);
      this.variableNames.push("offset");
      offsetSnippet = "getOffsetAtOutCoords()";
    }
    let scaleSnippet = "1.0";
    if (scaleShape != null) {
      assertAndGetBroadcastShape(xShape, scaleShape);
      this.variableNames.push("scale");
      scaleSnippet = "getScaleAtOutCoords()";
    }
    this.outputShape = xShape;
    this.userCode = `
      void main() {
        float x = getXAtOutCoords();
        float mean = getMeanAtOutCoords();
        float variance = getVarianceAtOutCoords();
        float offset = ${offsetSnippet};
        float scale = ${scaleSnippet};
        float inv = scale * inversesqrt(variance + float(${varianceEpsilon}));
        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class BatchNormPackedProgram {
  constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon) {
    this.packedInputs = true;
    this.packedOutput = true;
    this.variableNames = ["x", "mean", "variance"];
    assertAndGetBroadcastShape(xShape, meanShape);
    assertAndGetBroadcastShape(xShape, varianceShape);
    let offsetSnippet = "vec4(0.0)";
    if (offsetShape != null) {
      assertAndGetBroadcastShape(xShape, offsetShape);
      this.variableNames.push("offset");
      offsetSnippet = "getOffsetAtOutCoords()";
    }
    let scaleSnippet = "vec4(1.0)";
    if (scaleShape != null) {
      assertAndGetBroadcastShape(xShape, scaleShape);
      this.variableNames.push("scale");
      scaleSnippet = "getScaleAtOutCoords()";
    }
    this.outputShape = xShape;
    this.userCode = `
      void main() {
        vec4 offset = ${offsetSnippet};
        vec4 scale = ${scaleSnippet};

        vec4 x = getXAtOutCoords();
        vec4 mean = getMeanAtOutCoords();
        vec4 variance = getVarianceAtOutCoords();

        vec4 inv = scale * inversesqrt(variance + vec4(${varianceEpsilon}));

        setOutput((x - mean) * inv + offset);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const batchNorm = ({ inputs, backend: backend2, attrs }) => {
  const { x: x2, mean: mean2, variance, offset, scale: scale2 } = inputs;
  assert$1(mean2.shape.length === variance.shape.length, () => "Batch normalization gradient requires mean and variance to have equal ranks.");
  assert$1(offset == null || mean2.shape.length === offset.shape.length, () => "Batch normalization gradient requires mean and offset to have equal ranks.");
  assert$1(scale2 == null || mean2.shape.length === scale2.shape.length, () => "Batch normalization gradient requires mean and scale to have equal ranks.");
  let { varianceEpsilon } = attrs;
  if (varianceEpsilon == null) {
    varianceEpsilon = 1e-3;
  }
  const finalInputs = [x2, mean2, variance];
  let offsetShape = null;
  if (offset != null) {
    offsetShape = offset.shape;
    finalInputs.push(offset);
  }
  let scaleShape = null;
  if (scale2 != null) {
    scaleShape = scale2.shape;
    finalInputs.push(scale2);
  }
  const program = env().getBool("WEBGL_PACK_NORMALIZATION") ? new BatchNormPackedProgram(x2.shape, mean2.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon) : new BatchNormProgram(x2.shape, mean2.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
  const output2 = backend2.runWebGLProgram(program, finalInputs, finalInputs[0].dtype);
  return output2;
};
const batchNormConfig = {
  kernelName: FusedBatchNorm,
  backendName: "webgl",
  kernelFunc: batchNorm
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class SliceProgram {
  constructor(destSize) {
    this.variableNames = ["source"];
    this.outputShape = destSize;
    this.rank = destSize.length;
    const dtype = getCoordsDataType(this.rank);
    this.customUniforms = [{ name: "start", arrayIndex: this.rank, type: "int" }];
    const sourceCoords = getCoords$2(this.rank);
    let body;
    const coordSum = destSize.map((_24, i2) => {
      return `sourceLoc.${coords[i2]} = start[${i2}] + coords.${coords[i2]};`;
    });
    body = `
        ${dtype} sourceLoc;
        ${dtype} coords = getOutputCoords();
        ${coordSum.join("\n")}
      `;
    this.userCode = `
      void main() {
        ${body}
        setOutput(getSource(${sourceCoords}));
      }
    `;
  }
}
const coords = ["x", "y", "z", "w", "u", "v"];
function getCoords$2(rank) {
  if (rank === 1) {
    return "sourceLoc";
  } else if (rank <= 6) {
    return coords.slice(0, rank).map((x2) => "sourceLoc." + x2).join(",");
  } else {
    throw Error(`Slicing for rank ${rank} is not yet supported`);
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class SlicePackedProgram {
  constructor(destSize) {
    this.variableNames = ["source"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = destSize;
    this.rank = destSize.length;
    this.customUniforms = [{ name: "start", arrayIndex: this.rank, type: "int" }];
    const dtype = getCoordsDataType(this.rank);
    const coords2 = getChannels("coords", this.rank);
    const sourceLoc = getChannels("sourceLoc", this.rank);
    const innerDims = this.rank === 1 ? "sourceLoc" : `vec2(${sourceLoc.slice(-2).join()})`;
    const getChannel = `getChannel(getSource(${sourceLoc.join()}), ${innerDims})`;
    const upperRow = `
      result.x = ${getChannel};
      if (++${coords2[this.rank - 1]} < ${destSize[this.rank - 1]}) {
        ++${sourceLoc[this.rank - 1]};
        result.y = ${getChannel};
        --${sourceLoc[this.rank - 1]};
      }
    `;
    const lowerRow = this.rank === 1 ? "" : `
      --${coords2[this.rank - 1]};
      if (++${coords2[this.rank - 2]} < ${destSize[this.rank - 2]}) {
        ++${sourceLoc[this.rank - 2]};
        result.z = ${getChannel};
        if (++${coords2[this.rank - 1]} < ${destSize[this.rank - 1]}) {
          ++${sourceLoc[this.rank - 1]};
          result.w = ${getChannel};
        }
      }
    `;
    const sourceLocSetup = this.rank <= 4 ? `sourceLoc = coords +
            ${dtype}(${destSize.map((_24, i2) => `start[${i2}]`).join()});` : destSize.map((_24, i2) => `${sourceLoc[i2]} = ${coords2[i2]} + start[${i2}];`).join("\n");
    this.userCode = `
      void main() {
        ${dtype} coords = getOutputCoords();
        ${dtype} sourceLoc;
        ${sourceLocSetup}
        vec4 result = vec4(0.);
        ${upperRow}
        ${lowerRow}
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function shallowSlice(x2, begin, size, backend2) {
  const xTexData = backend2.texData.get(x2.dataId);
  const t2 = backend2.makeTensorInfo(size, x2.dtype);
  const newTexData = backend2.texData.get(t2.dataId);
  Object.assign(newTexData, xTexData);
  newTexData.refCount = 1;
  newTexData.shape = size;
  newTexData.dtype = x2.dtype;
  let flatOffset = computeFlatOffset(begin, computeStrides(x2.shape));
  if (xTexData.slice) {
    flatOffset += xTexData.slice.flatOffset;
  }
  newTexData.slice = {
    flatOffset,
    origDataId: xTexData.slice && xTexData.slice.origDataId || x2.dataId
  };
  const refCount = backend2.dataRefCount.get(newTexData.slice.origDataId) || 1;
  backend2.dataRefCount.set(newTexData.slice.origDataId, refCount + 1);
  return t2;
}
function slice$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { begin, size } = attrs;
  const [$begin, $size] = parseSliceParams(x2, begin, size);
  assertParamsValid(x2, $begin, $size);
  if (sizeFromShape($size) === 0) {
    return backend2.makeTensorInfo($size, x2.dtype, []);
  }
  if (backend2.shouldExecuteOnCPU([x2]) || x2.dtype === "string") {
    const xTexData = backend2.texData.get(x2.dataId);
    const outValues = sliceImplCPU(xTexData.values, $begin, $size, x2.shape, x2.dtype);
    return backend2.makeTensorInfo($size, x2.dtype, outValues);
  }
  const { isPacked } = backend2.texData.get(x2.dataId);
  const isContinous = isSliceContinous(x2.shape, $begin, $size);
  if (isPacked || !isContinous) {
    const program = env().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new SlicePackedProgram($size) : new SliceProgram($size);
    const customValues = [$begin];
    return backend2.runWebGLProgram(program, [x2], x2.dtype, customValues);
  }
  backend2.uploadToGPU(x2.dataId);
  return shallowSlice(x2, $begin, $size, backend2);
}
const sliceConfig$1 = {
  kernelName: Slice,
  backendName: "webgl",
  kernelFunc: slice$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const batchToSpaceND$1 = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockShape, crops } = attrs;
  assert$1(x2.shape.length <= 4, () => "batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
  const prod2 = blockShape.reduce((a6, b2) => a6 * b2);
  const reshaped = getReshaped(x2.shape, blockShape, prod2);
  const permuted = getPermuted(reshaped.length, blockShape.length);
  const reshapedPermuted = getReshapedPermuted(x2.shape, blockShape, prod2);
  const sliceBeginCoords = getSliceBeginCoords(crops, blockShape.length);
  const sliceSize = getSliceSize(reshapedPermuted, crops, blockShape.length);
  const toDispose = [];
  const reshapedIntermediate = reshape$1({ inputs: { x: x2 }, backend: backend2, attrs: { shape: reshaped } });
  const transposedIntermediate = transpose$1({ inputs: { x: reshapedIntermediate }, backend: backend2, attrs: { perm: permuted } });
  const reshapedIntermediate2 = reshape$1({
    inputs: { x: transposedIntermediate },
    backend: backend2,
    attrs: { shape: reshapedPermuted }
  });
  const sliced = slice$1({
    inputs: { x: reshapedIntermediate2 },
    backend: backend2,
    attrs: { begin: sliceBeginCoords, size: sliceSize }
  });
  toDispose.push(reshapedIntermediate);
  toDispose.push(transposedIntermediate);
  toDispose.push(reshapedIntermediate2);
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return sliced;
};
const batchToSpaceNDConfig$1 = {
  kernelName: BatchToSpaceND,
  backendName: "webgl",
  kernelFunc: batchToSpaceND$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function bincount(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, weights } = inputs;
  const { size } = attrs;
  const xVals = backend2.readSync(x2.dataId);
  const weightsVals = backend2.readSync(weights.dataId);
  const outVals = bincountImplCPU(xVals, weightsVals, weights.dtype, weights.shape, size);
  return backend2.makeTensorInfo([size], weights.dtype, outVals);
}
const bincountConfig = {
  kernelName: Bincount,
  backendName: "webgl",
  kernelFunc: bincount
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function broadcastArgs(args) {
  const { inputs, backend: backend2 } = args;
  const { s0, s1 } = inputs;
  const s0Vals = backend2.readSync(s0.dataId);
  const s1Vals = backend2.readSync(s1.dataId);
  const broadcastShape = assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
  return backend2.makeTensorInfo([broadcastShape.length], "int32", Int32Array.from(broadcastShape));
}
const broadcastArgsConfig = {
  kernelName: BroadcastArgs,
  backendName: "webgl",
  kernelFunc: broadcastArgs
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const NOT_EQUAL = `return float(a != b);`;
const notEqual = binaryKernelFunc({ opSnippet: NOT_EQUAL, cpuKernelImpl: notEqualImplCPU, dtype: "bool" });
const notEqualConfig$1 = {
  kernelName: NotEqual,
  backendName: "webgl",
  kernelFunc: notEqual
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function real(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  const inputData = backend2.texData.get(input.dataId);
  return identity$1({ inputs: { x: inputData.complexTensorInfos.real }, backend: backend2 });
}
const realConfig = {
  kernelName: Real,
  backendName: "webgl",
  kernelFunc: real
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const TO_INT = `return float(int(x));`;
function int$1(input, backend2) {
  const program = new UnaryOpProgram(input.shape, TO_INT);
  const output2 = backend2.runWebGLProgram(program, [input], "int32");
  return { dataId: output2.dataId, shape: output2.shape, dtype: output2.dtype };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cast$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { dtype } = attrs;
  if (dtype === "complex64") {
    if (x2.dtype === "complex64") {
      return identity$1({ inputs: { x: x2 }, backend: backend2 });
    }
    const zerosTensor = zeros$1(x2.shape);
    const floatX = cast$1({ inputs: { x: x2 }, backend: backend2, attrs: { dtype: "float32" } });
    const result2 = complex$1({ inputs: { real: floatX, imag: zerosTensor }, backend: backend2 });
    zerosTensor.dispose();
    backend2.disposeIntermediateTensorInfo(floatX);
    return result2;
  }
  if (x2.dtype === "complex64") {
    const realPart = real({ inputs: { input: x2 }, backend: backend2 });
    const result2 = cast$1({ inputs: { x: realPart }, backend: backend2, attrs: { dtype } });
    backend2.disposeIntermediateTensorInfo(realPart);
    return result2;
  }
  if (!hasEncodingLoss(x2.dtype, dtype)) {
    const result2 = identity$1({ inputs: { x: x2 }, backend: backend2 });
    return { dataId: result2.dataId, shape: result2.shape, dtype };
  }
  if (dtype === "int32") {
    return int$1(x2, backend2);
  }
  if (dtype === "bool") {
    const zerosTensorInfo = backend2.makeTensorInfo([], "bool", getTypedArrayFromDType("bool", 1));
    const binaryInputs = { a: x2, b: zerosTensorInfo };
    const result2 = notEqual({ inputs: binaryInputs, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(zerosTensorInfo);
    return result2;
  }
  throw new Error(`Error in Cast: failed to cast ${x2.dtype} to ${dtype}`);
}
const castConfig$1 = {
  kernelName: Cast,
  backendName: "webgl",
  kernelFunc: cast$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const CEIL = `return ceil(x);`;
const ceil = unaryKernelFunc({ opSnippet: CEIL, packedOpSnippet: CEIL, cpuKernelImpl: ceilImplCPU });
const ceilConfig$1 = {
  kernelName: Ceil,
  backendName: "webgl",
  kernelFunc: ceil
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ClipProgram {
  constructor(aShape) {
    this.variableNames = ["A"];
    this.customUniforms = [
      { name: "minVal", type: "float" },
      { name: "maxVal", type: "float" }
    ];
    this.outputShape = aShape;
    this.userCode = `

      void main() {
        float value = getAAtOutCoords();
        if (isnan(value)) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, minVal, maxVal));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ClipPackedProgram {
  constructor(aShape) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.customUniforms = [
      { name: "minVal", type: "float" },
      { name: "maxVal", type: "float" }
    ];
    this.outputShape = aShape;
    this.userCode = `
      void main() {
        vec4 value = getAAtOutCoords();

        if (any(isnan(value))) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function clipByValue(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { clipValueMin, clipValueMax } = attrs;
  let program;
  if (env().getBool("WEBGL_PACK_CLIP")) {
    program = new ClipPackedProgram(x2.shape);
  } else {
    program = new ClipProgram(x2.shape);
  }
  const customValues = [[clipValueMin], [clipValueMax]];
  return backend2.runWebGLProgram(program, [x2], x2.dtype, customValues);
}
const clipByValueConfig$1 = {
  kernelName: ClipByValue,
  backendName: "webgl",
  kernelFunc: clipByValue
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ComplexAbsProgram {
  constructor(shape) {
    this.variableNames = ["real", "imag"];
    this.outputShape = shape;
    this.userCode = `
      void main() {
        float re = abs(getRealAtOutCoords());
        float im = abs(getImagAtOutCoords());
        float mx = max(re, im);

        // sadly the length function in glsl is not underflow-safe
        // (at least not on Intel GPUs). So the safe solution is
        // to ensure underflow-safety in all cases.
        setOutput(
          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))
        );
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function makeComplexComponentTensorInfo(complexTensor, complexPart) {
  return {
    dataId: complexPart.dataId,
    dtype: complexPart.dtype,
    shape: complexTensor.shape
  };
}
function complexAbs(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  const xData = backend2.texData.get(x2.dataId);
  const program = new ComplexAbsProgram(x2.shape);
  const programInputs = [
    makeComplexComponentTensorInfo(x2, xData.complexTensorInfos.real),
    makeComplexComponentTensorInfo(x2, xData.complexTensorInfos.imag)
  ];
  return backend2.runWebGLProgram(program, programInputs, programInputs[0].dtype);
}
const complexAbsConfig = {
  kernelName: ComplexAbs,
  backendName: "webgl",
  kernelFunc: complexAbs
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ConcatProgram {
  constructor(shapes) {
    this.outputShape = [];
    this.outputShape = computeOutShape$2(shapes, 1);
    this.variableNames = shapes.map((_24, i2) => `T${i2}`);
    const offsets = new Array(shapes.length - 1);
    offsets[0] = shapes[0][1];
    for (let i2 = 1; i2 < offsets.length; i2++) {
      offsets[i2] = offsets[i2 - 1] + shapes[i2][1];
    }
    const snippets = [`if (yC < ${offsets[0]}) setOutput(getT0(yR, yC));`];
    for (let i2 = 1; i2 < offsets.length; i2++) {
      const shift = offsets[i2 - 1];
      snippets.push(`else if (yC < ${offsets[i2]}) setOutput(getT${i2}(yR, yC-${shift}));`);
    }
    const lastIndex = offsets.length;
    const lastShift = offsets[offsets.length - 1];
    snippets.push(`else setOutput(getT${lastIndex}(yR, yC-${lastShift}));`);
    this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int yR = coords.x;
        int yC = coords.y;

        ${snippets.join("\n        ")}
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ConcatPackedProgram {
  constructor(shapes, axis) {
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = [];
    this.outputShape = computeOutShape$2(shapes, axis);
    const shape = this.outputShape;
    const rank = shape.length;
    const dtype = getCoordsDataType(rank);
    const coords2 = getChannels("coords", rank);
    const channels = ["x", "y", "z", "w", "u", "v"].slice(0, rank);
    this.variableNames = shapes.map((_24, i2) => `T${i2}`);
    const offsets = new Array(shapes.length - 1);
    offsets[0] = shapes[0][axis];
    for (let i2 = 1; i2 < offsets.length; i2++) {
      offsets[i2] = offsets[i2 - 1] + shapes[i2][axis];
    }
    const channel = channels[axis];
    const lastChannels = channels.slice(-2);
    const allChannels = channels.join();
    let getValueSnippet = `if (${channel} < ${offsets[0]}) {
        return getChannel(
            getT0(${allChannels}), vec2(${lastChannels.join()}));
        }`;
    for (let i2 = 1; i2 < offsets.length; i2++) {
      const shift2 = offsets[i2 - 1];
      getValueSnippet += `
        if (${channel} < ${offsets[i2]}  && ${channel} >= ${offsets[i2 - 1]}) {
          return getChannel(
            getT${i2}(${shiftedChannels(channels, channel, shift2)}),
            vec2(${shiftedChannels(lastChannels, channel, shift2)}));
        }`;
    }
    const lastIndex = offsets.length;
    const shift = offsets[offsets.length - 1];
    getValueSnippet += `
        return getChannel(
          getT${lastIndex}(${shiftedChannels(channels, channel, shift)}),
          vec2(${shiftedChannels(lastChannels, channel, shift)}));`;
    this.userCode = `
      float getValue(${channels.map((x2) => "int " + x2)}) {
        ${getValueSnippet}
      }

      void main() {
        ${dtype} coords = getOutputCoords();
        vec4 result = vec4(getValue(${coords2}), 0., 0., 0.);

        ${coords2[rank - 1]} = ${coords2[rank - 1]} + 1;
        if (${coords2[rank - 1]} < ${shape[rank - 1]}) {
          result.g = getValue(${coords2});
        }

        ${coords2[rank - 2]} = ${coords2[rank - 2]} + 1;
        if (${coords2[rank - 2]} < ${shape[rank - 2]}) {
          result.a = getValue(${coords2});
        }

        ${coords2[rank - 1]} = ${coords2[rank - 1]} - 1;
        if (${coords2[rank - 2]} < ${shape[rank - 2]} &&
            ${coords2[rank - 1]} < ${shape[rank - 1]}) {
          result.b = getValue(${coords2});
        }
        setOutput(result);
      }
    `;
  }
}
function shiftedChannels(channels, channel, shift) {
  const channelIdx = channels.indexOf(channel);
  const res = channels.map((c2, idx) => {
    if (idx === channelIdx) {
      return `${c2} - ${shift}`;
    } else {
      return c2;
    }
  });
  return res.join();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function imag(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  const inputData = backend2.texData.get(input.dataId);
  return identity$1({ inputs: { x: inputData.complexTensorInfos.imag }, backend: backend2 });
}
const imagConfig = {
  kernelName: Imag,
  backendName: "webgl",
  kernelFunc: imag
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function concatImpl(inputs, axis, backend2) {
  const dtype = inputs[0].dtype;
  if (dtype === "complex64") {
    const reals = inputs.map((t2) => real({ inputs: { input: t2 }, backend: backend2 }));
    const imags = inputs.map((t2) => imag({ inputs: { input: t2 }, backend: backend2 }));
    const realConcated = concatImpl(reals, axis, backend2);
    const imagConcated = concatImpl(imags, axis, backend2);
    const result3 = complex$1({ inputs: { real: realConcated, imag: imagConcated }, backend: backend2 });
    reals.forEach((r2) => backend2.disposeIntermediateTensorInfo(r2));
    imags.forEach((i2) => backend2.disposeIntermediateTensorInfo(i2));
    backend2.disposeIntermediateTensorInfo(realConcated);
    backend2.disposeIntermediateTensorInfo(imagConcated);
    return result3;
  }
  let runOnCpu = backend2.shouldExecuteOnCPU(inputs);
  if (dtype === "string") {
    runOnCpu = true;
  }
  if (runOnCpu) {
    const tensors2D2 = inputs.map((t2) => {
      const innerSize = sizeFromShape(t2.shape.slice(axis));
      const shape = [-1, innerSize];
      return reshape$1({ inputs: { x: t2 }, backend: backend2, attrs: { shape } });
    });
    const inputsValShapes = tensors2D2.map((t2) => {
      return { vals: backend2.readSync(t2.dataId), shape: t2.shape };
    });
    const outShape2 = computeOutShape$2(tensors2D2.map((t2) => t2.shape), 1);
    const simplyConcat = tensors2D2[0].shape[0] === 1;
    const outVals = concatImplCPU(inputsValShapes, outShape2, dtype, simplyConcat);
    const finalOutShape = computeOutShape$2(inputs.map((t2) => t2.shape), axis);
    const outInfo = backend2.makeTensorInfo(finalOutShape, dtype, outVals);
    tensors2D2.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
    return outInfo;
  }
  if (inputs.length > env().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER")) {
    const midIndex = Math.floor(inputs.length / 2);
    const leftSide = concatImpl(inputs.slice(0, midIndex), axis, backend2);
    const rightSide = concatImpl(inputs.slice(midIndex), axis, backend2);
    const result3 = concatImpl([leftSide, rightSide], axis, backend2);
    backend2.disposeIntermediateTensorInfo(leftSide);
    backend2.disposeIntermediateTensorInfo(rightSide);
    return result3;
  }
  if (env().getBool("WEBGL_PACK_ARRAY_OPERATIONS") && inputs[0].shape.length > 1) {
    const program2 = new ConcatPackedProgram(inputs.map((t2) => t2.shape), axis);
    return backend2.runWebGLProgram(program2, inputs, dtype);
  }
  const { tensors2D, outShape } = computeTensors2D(inputs, axis, backend2);
  const program = new ConcatProgram(tensors2D.map((t2) => t2.shape));
  const result2 = backend2.runWebGLProgram(program, tensors2D, dtype);
  tensors2D.forEach((r2) => backend2.disposeIntermediateTensorInfo(r2));
  const reshapedResult = reshape$1({ inputs: { x: result2 }, attrs: { shape: outShape }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(result2);
  return reshapedResult;
}
function computeTensors2D(inputs, axis, backend2) {
  const outShape = computeOutShape$2(inputs.map((t2) => t2.shape), axis);
  const tensors2D = inputs.map((x2) => reshape$1({
    inputs: { x: x2 },
    attrs: { shape: [-1, sizeFromShape(x2.shape.slice(axis))] },
    backend: backend2
  }));
  return { tensors2D, outShape };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function concat$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { axis } = attrs;
  const $axis = parseAxisParam(axis, inputs[0].shape)[0];
  const outShape = computeOutShape$2(inputs.map((t2) => t2.shape), $axis);
  if (sizeFromShape(outShape) === 0) {
    return backend2.makeTensorInfo(outShape, inputs[0].dtype, []);
  }
  const $inputs = inputs.filter((t2) => sizeFromShape(t2.shape) > 0);
  if ($inputs.length === 1) {
    return identity$1({ inputs: { x: $inputs[0] }, backend: backend2 });
  }
  const shapes = $inputs.map((t2) => t2.shape);
  assertParamsConsistent(shapes, $axis);
  return concatImpl($inputs, $axis, backend2);
}
const concatConfig$1 = {
  kernelName: Concat,
  backendName: "webgl",
  kernelFunc: concat$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Conv2DProgram {
  constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false, hasLeakyreluAlpha = false) {
    this.variableNames = ["x", "W"];
    this.outputShape = convInfo.outShape;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
    const inputDepthVec4Remainder = convInfo.inChannels % 4;
    const isChannelsLast = convInfo.dataFormat === "channelsLast";
    const rowDim = isChannelsLast ? 1 : 2;
    const colDim = isChannelsLast ? 2 : 3;
    const channelDim = isChannelsLast ? 3 : 1;
    let activationSnippet = "", applyActivationSnippet = "";
    if (activation) {
      if (hasPreluActivationWeights) {
        activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
      } else if (hasLeakyreluAlpha) {
        activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
      } else {
        activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
      }
      applyActivationSnippet = `result = activation(result);`;
    }
    const addBiasSnippet = addBias ? "result += getBiasAtOutCoords();" : "";
    if (addBias) {
      this.variableNames.push("bias");
    }
    if (hasPreluActivationWeights) {
      this.variableNames.push("preluActivationWeights");
    }
    if (hasLeakyreluAlpha) {
      this.variableNames.push("leakyreluAlpha");
    }
    this.userCode = `
      ${activationSnippet}

      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d2 = coords[${channelDim}];

        ivec2 xRCCorner =
            ivec2(coords[${rowDim}], coords[${colDim}]) * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * ${dilationHeight};

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * ${dilationWidth};

            if (xC < 0 || xC >= ${convInfo.inWidth}) {
              continue;
            }

            for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
              vec4 wValues = vec4(
                getW(wR, wC, d1, d2),
                getW(wR, wC, d1 + 1, d2),
                getW(wR, wC, d1 + 2, d2),
                getW(wR, wC, d1 + 3, d2)
              );

              if (${isChannelsLast}) {
                vec4 xValues = vec4(
                  getX(batch, xR, xC, d1),
                  getX(batch, xR, xC, d1 + 1),
                  getX(batch, xR, xC, d1 + 2),
                  getX(batch, xR, xC, d1 + 3)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec4 xValues = vec4(
                  getX(batch, d1, xR, xC),
                  getX(batch, d1 + 1, xR, xC),
                  getX(batch, d1 + 2, xR, xC),
                  getX(batch, d1 + 3, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }
            }

            if (${inputDepthVec4Remainder === 1}) {

              if (${isChannelsLast}) {
                dotProd +=
                    getX(batch, xR, xC, ${inputDepthNearestVec4}) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              } else {
                dotProd +=
                    getX(batch, ${inputDepthNearestVec4}, xR, xC) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              }

            } else if (${inputDepthVec4Remainder === 2}) {
              vec2 wValues = vec2(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2)
              );

              if (${isChannelsLast}) {
                vec2 xValues = vec2(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec2 xValues = vec2(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            } else if (${inputDepthVec4Remainder === 3}) {
              vec3 wValues = vec3(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 2, d2)
              );

              if (${isChannelsLast}) {
                vec3 xValues = vec3(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec3 xValues = vec3(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 2, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            }
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
  }
}
class Conv3DProgram {
  constructor(convInfo) {
    this.variableNames = ["x", "W"];
    this.outputShape = convInfo.outShape;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
    const inputDepthVec4Remainder = convInfo.inChannels % 4;
    this.userCode = `
      const ivec3 strides = ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d2 = coords.u;

        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xFCorner = xFRCCorner.x;
        int xRCorner = xFRCCorner.y;
        int xCCorner = xFRCCorner.z;

        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get
        // y(yF, yR, yC, d2). ? = to be determined. : = across all
        // values in that axis.
        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          int xF = xFCorner + wF * ${dilationDepth};

          if (xF < 0 || xF >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            int xR = xRCorner + wR * ${dilationHeight};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              int xC = xCCorner + wC * ${dilationWidth};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
                vec4 xValues = vec4(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                vec4 wValues = vec4(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (${inputDepthVec4Remainder === 1}) {
                dotProd +=
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}) *
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2);
              } else if (${inputDepthVec4Remainder === 2}) {
                vec2 xValues = vec2(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                vec2 wValues = vec2(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (${inputDepthVec4Remainder === 3}) {
                vec3 xValues = vec3(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                vec3 wValues = vec3(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Im2ColPackedProgram {
  constructor(outputShape, convInfo) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.customUniforms = [
      { name: "inputShape", type: "ivec3" },
      { name: "pad", type: "ivec2" },
      { name: "stride", type: "ivec2" },
      { name: "dilation", type: "ivec2" },
      { name: "inChannels", type: "int" },
      { name: "itemsPerBlockRow", type: "int" },
      { name: "outWidth", type: "int" }
    ];
    this.outputShape = outputShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    const { dataFormat } = convInfo;
    const glsl = getGlslDifferences();
    const isChannelsLast = dataFormat === "channelsLast";
    const rowDim = isChannelsLast ? 0 : 1;
    const colDim = isChannelsLast ? 1 : 2;
    const boundsCheckingSnippet = this.enableShapeUniforms ? "if(blockIndex < outShape[1] && pos < outShape[0]) {" : `if(blockIndex < ${outputShape[1]} && pos < ${outputShape[0]}) {`;
    let unrolled = ``;
    for (let row = 0; row <= 1; row++) {
      for (let col = 0; col <= 1; col++) {
        unrolled += `
          blockIndex = rc.y + ${col};
          pos = rc.x + ${row};

          ${boundsCheckingSnippet}
            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];
            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);

            if(d0 < inputShape[${rowDim}] && d0 >= 0) {
              // Use custom imod instead mod. On Intel GPU, mod may generate
              // unexpected value.
              // https://github.com/tensorflow/tfjs/issues/5447
              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];
              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /
                  inChannels);

              if(d1 < inputShape[${colDim}] && d1 >= 0) {

                ch = imod(pos, inChannels);

                if (${isChannelsLast}) {
                  innerDims = vec2(d1, ch);
                  result[${row * 2 + col}] = getChannel(
                    getA(d0, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                } else {
                  innerDims = vec2(d0, d1);
                  result[${row * 2 + col}] = getChannel(
                    getA(ch, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                }
              }
            }
          }
        `;
      }
    }
    this.userCode = `
      void main() {
        ivec2 rc = getOutputCoords();

        vec4 result = vec4(0);

        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;
        vec2 innerDims;

        ${unrolled}

        ${glsl.output} = result;
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2dByMatMul({ x: x2, filter: filter2, convInfo, backend: backend2, bias = null, preluActivationWeights = null, leakyreluAlpha = 0, activation = null }) {
  const xShape = x2.shape;
  const xTexData = backend2.texData.get(x2.dataId);
  const sharedMatMulDim = convInfo.inChannels;
  const outerShapeX = xShape[0] * xShape[1] * xShape[2];
  const outerShapeFilter = convInfo.outChannels;
  const isChannelsLast = convInfo.dataFormat === "channelsLast";
  const transposeA = false;
  const transposeB = false;
  let out;
  const intermediates = [];
  const batchMatMulWillBeUnpacked = (outerShapeX === 1 || outerShapeFilter === 1) && sharedMatMulDim > MATMUL_SHARED_DIM_THRESHOLD;
  const canOptimize = !batchMatMulWillBeUnpacked && xTexData.isPacked && isChannelsLast && xTexData.texture != null && xShape[2] % 2 !== 0 && arraysEqual(xTexData.shape.slice(-3), xShape.slice(-3));
  if (canOptimize) {
    const targetShape = xShape[0] * xShape[1] * (xShape[2] + 1);
    const xReshaped = {
      dataId: x2.dataId,
      shape: [1, targetShape, convInfo.inChannels],
      dtype: x2.dtype
    };
    const originalXTexDataShape = xTexData.shape;
    xTexData.shape = xTexData.shape.slice();
    xTexData.shape[xTexData.shape.length - 2]++;
    assert$1(isReshapeFree(xTexData.shape, xReshaped.shape), () => `packed reshape ${xTexData.shape} to ${xReshaped.shape} isn't free`);
    const filterReshaped = reshape$1({
      inputs: { x: filter2 },
      backend: backend2,
      attrs: { shape: [1, convInfo.inChannels, convInfo.outChannels] }
    });
    intermediates.push(filterReshaped);
    const pointwiseConv = batchMatMulImpl({
      a: xReshaped,
      b: filterReshaped,
      backend: backend2,
      transposeA,
      transposeB,
      bias,
      activation,
      preluActivationWeights,
      leakyreluAlpha
    });
    const pointwiseConvTexData = backend2.texData.get(pointwiseConv.dataId);
    assert$1(pointwiseConvTexData.isPacked, () => "batchMatMul result is expected to be packed");
    xTexData.shape = originalXTexDataShape;
    pointwiseConvTexData.shape = convInfo.outShape;
    out = identity$1({ inputs: { x: pointwiseConv }, backend: backend2 });
    out.shape = convInfo.outShape;
    intermediates.push(pointwiseConv);
  } else {
    const targetShape = isChannelsLast ? xShape[0] * xShape[1] * xShape[2] : xShape[0] * xShape[2] * xShape[3];
    const xReshaped = reshape$1({
      inputs: { x: x2 },
      backend: backend2,
      attrs: { shape: [1, targetShape, convInfo.inChannels] }
    });
    const filterReshaped = reshape$1({
      inputs: { x: filter2 },
      backend: backend2,
      attrs: { shape: [1, convInfo.inChannels, convInfo.outChannels] }
    });
    const result2 = batchMatMulImpl({
      a: xReshaped,
      b: filterReshaped,
      transposeA,
      transposeB,
      backend: backend2,
      bias,
      activation,
      preluActivationWeights,
      leakyreluAlpha
    });
    out = reshape$1({ inputs: { x: result2 }, backend: backend2, attrs: { shape: convInfo.outShape } });
    intermediates.push(xReshaped);
    intermediates.push(filterReshaped);
    intermediates.push(result2);
  }
  for (const i2 of intermediates) {
    backend2.disposeIntermediateTensorInfo(i2);
  }
  return out;
}
function conv2dWithIm2Row({ x: x2, filter: filter2, convInfo, backend: backend2, bias = null, preluActivationWeights = null, leakyreluAlpha = 0, activation = null }) {
  const { filterWidth, filterHeight, inChannels, outWidth, outHeight, dataFormat } = convInfo;
  const isChannelsLast = dataFormat === "channelsLast";
  const sharedDim = filterWidth * filterHeight * inChannels;
  const numCols = outHeight * outWidth;
  const x2ColShape = [sharedDim, numCols];
  const transposeA = true;
  const transposeB = false;
  const intermediates = [];
  const xSqueezed = reshape$1({ inputs: { x: x2 }, backend: backend2, attrs: { shape: x2.shape.slice(1) } });
  const w2Row = reshape$1({
    inputs: { x: filter2 },
    backend: backend2,
    attrs: { shape: [1, sharedDim, sizeFromShape(filter2.shape) / sharedDim] }
  });
  intermediates.push(xSqueezed);
  intermediates.push(w2Row);
  const im2ColProgram = new Im2ColPackedProgram(x2ColShape, convInfo);
  const customValues = [
    xSqueezed.shape,
    [convInfo.padInfo.top, convInfo.padInfo.left],
    [convInfo.strideHeight, convInfo.strideWidth],
    [convInfo.dilationHeight, convInfo.dilationWidth],
    [convInfo.inChannels],
    [convInfo.filterWidth * convInfo.inChannels],
    [convInfo.outWidth]
  ];
  const im2Col = backend2.runWebGLProgram(im2ColProgram, [xSqueezed], "float32", customValues);
  const im2ColReshaped = reshape$1({
    inputs: { x: im2Col },
    backend: backend2,
    attrs: { shape: [1, x2ColShape[0], x2ColShape[1]] }
  });
  intermediates.push(im2Col);
  intermediates.push(im2ColReshaped);
  const hasBias = bias != null;
  const hasPreluActivationWeights = preluActivationWeights != null;
  const hasLeakyreluAlpha = activation === "leakyrelu";
  const fusedActivation = activation ? mapActivationToShaderProgram(activation, true) : null;
  const matmulProgram = new MatMulPackedProgram(im2ColReshaped.shape, w2Row.shape, [1, numCols, convInfo.outChannels], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
  const inputs = [im2ColReshaped, w2Row];
  if (bias) {
    inputs.push(bias);
  }
  if (hasPreluActivationWeights) {
    inputs.push(preluActivationWeights);
  }
  if (hasLeakyreluAlpha) {
    const $leakyreluAlpha = backend2.makeTensorInfo([], "float32", createScalarValue(leakyreluAlpha, "float32"));
    inputs.push($leakyreluAlpha);
    intermediates.push($leakyreluAlpha);
  }
  const product = backend2.runWebGLProgram(matmulProgram, inputs, "float32");
  const outShape = isChannelsLast ? [1, outHeight, outWidth, convInfo.outChannels] : [1, convInfo.outChannels, outHeight, outWidth];
  const out = reshape$1({ inputs: { x: product }, backend: backend2, attrs: { shape: outShape } });
  intermediates.push(product);
  for (const i2 of intermediates) {
    backend2.disposeIntermediateTensorInfo(i2);
  }
  return out;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2d$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dataFormat, dilations, dimRoundingMode } = attrs;
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, dilations, pad2, dimRoundingMode, false, $dataFormat);
  let out;
  if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === "SAME" || convInfo.padInfo.type === "VALID")) {
    out = conv2dByMatMul({ x: x2, filter: filter2, convInfo, backend: backend2 });
  } else if (env().getBool("WEBGL_CONV_IM2COL") && x2.shape[0] === 1) {
    out = conv2dWithIm2Row({ x: x2, filter: filter2, convInfo, backend: backend2 });
  } else {
    const program = new Conv2DProgram(convInfo);
    out = backend2.runWebGLProgram(program, [x2, filter2], "float32");
  }
  const outReshaped = reshape$1({ inputs: { x: out }, backend: backend2, attrs: { shape: convInfo.outShape } });
  backend2.disposeIntermediateTensorInfo(out);
  return outReshaped;
}
const conv2DConfig$1 = {
  kernelName: Conv2D$1,
  backendName: "webgl",
  kernelFunc: conv2d$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Conv2DDerFilterProgram {
  constructor(convInfo) {
    this.variableNames = ["x", "dy"];
    this.outputShape = convInfo.filterShape;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const isChannelsLast = convInfo.dataFormat === "channelsLast";
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int d2 = coords.w;

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              if (${isChannelsLast}) {
                float dyValue = getDy(b, yR, yC, d2);
                float xValue = getX(b, xR, xC, d1);
                dotProd += (xValue * dyValue);
              } else {
                float dyValue = getDy(b, d2, yR, yC);
                float xValue = getX(b, d1, xR, xC);
                dotProd += (xValue * dyValue);
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
class Conv2DDerInputProgram {
  constructor(convInfo) {
    this.variableNames = ["dy", "W"];
    this.outputShape = convInfo.inShape;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const isChannelsLast = convInfo.dataFormat === "channelsLast";
    const padTop = filterHeight - 1 - convInfo.padInfo.top;
    const padLeft = filterWidth - 1 - convInfo.padInfo.left;
    const rowDim = isChannelsLast ? 1 : 2;
    const colDim = isChannelsLast ? 2 : 3;
    const channelDim = isChannelsLast ? 3 : 1;
    this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[${channelDim}];

        ivec2 dyCorner = ivec2(coords[${rowDim}], coords[${colDim}]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {

              if (${isChannelsLast}) {
                float xValue = getDy(batch, idyR, idyC, d2);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              } else {
                float xValue = getDy(batch, d2, idyR, idyC);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
class Conv3DDerFilterProgram {
  constructor(convInfo) {
    this.variableNames = ["x", "dy"];
    this.outputShape = convInfo.filterShape;
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    this.userCode = `
      void main() {
        ivec5 coords = getOutputCoords();
        int wF = coords.x;
        int wR = coords.y;
        int wC = coords.z;
        int d1 = coords.w;
        int d2 = coords.u;

        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yF = 0; yF < ${convInfo.outDepth}; yF++) {
            int xF = wF + yF * ${strideDepth} - ${padFront};

            if (xF < 0 || xF >= ${convInfo.inDepth}) {
              continue;
            }

            for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
              int xR = wR + yR * ${strideHeight} - ${padTop};

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
                int xC = wC + yC * ${strideWidth} - ${padLeft};

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float dyValue = getDy(b, yF, yR, yC, d2);
                float xValue = getX(b, xF, xR, xC, d1);
                dotProd += (xValue * dyValue);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
class Conv3DDerInputProgram {
  constructor(convInfo) {
    this.variableNames = ["dy", "W"];
    this.outputShape = convInfo.inShape;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const padFront = filterDepth - 1 - convInfo.padInfo.front;
    const padTop = filterHeight - 1 - convInfo.padInfo.top;
    const padLeft = filterWidth - 1 - convInfo.padInfo.left;
    this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.u;


        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyFCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          float dyF = float(dyFCorner + wF) / ${strideDepth}.0;

          if (dyF < 0.0 || dyF >= ${convInfo.outDepth}.0 || fract(dyF) > 0.0) {
            continue;
          }
          int idyF = int(dyF);

          int wFPerm = ${filterDepth} - 1 - wF;

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
              fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            int wRPerm = ${filterHeight} - 1 - wR;

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              int wCPerm = ${filterWidth} - 1 - wC;

              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {
                float xValue = getDy(batch, idyF, idyR, idyC, d2);
                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2DBackpropFilter(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, dy } = inputs;
  const { strides, pad: pad2, dataFormat, dimRoundingMode, filterShape } = attrs;
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(x2.shape, filterShape, strides, 1, pad2, dimRoundingMode, false, $dataFormat);
  const program = new Conv2DDerFilterProgram(convInfo);
  return backend2.runWebGLProgram(program, [x2, dy], "float32");
}
const conv2DBackpropFilterConfig = {
  kernelName: Conv2DBackpropFilter,
  backendName: "webgl",
  kernelFunc: conv2DBackpropFilter
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv2DBackpropInput$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { inputShape, strides, pad: pad2, dataFormat, dimRoundingMode } = attrs;
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(inputShape, filter2.shape, strides, 1, pad2, dimRoundingMode, false, $dataFormat);
  const program = new Conv2DDerInputProgram(convInfo);
  return backend2.runWebGLProgram(program, [dy, filter2], "float32");
}
const conv2DBackpropInputConfig$1 = {
  kernelName: Conv2DBackpropInput,
  backendName: "webgl",
  kernelFunc: conv2DBackpropInput$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dilations } = attrs;
  const convInfo = computeConv3DInfo(x2.shape, filter2.shape, strides, dilations, pad2);
  const program = new Conv3DProgram(convInfo);
  return backend2.runWebGLProgram(program, [x2, filter2], "float32");
}
const conv3DConfig = {
  kernelName: Conv3D$1,
  backendName: "webgl",
  kernelFunc: conv3D
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3DBackpropFilterV2(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, dy } = inputs;
  const { strides, pad: pad2, filterShape } = attrs;
  const convInfo = computeConv3DInfo(x2.shape, filterShape, strides, 1, pad2);
  const program = new Conv3DDerFilterProgram(convInfo);
  return backend2.runWebGLProgram(program, [x2, dy], "float32");
}
const conv3DBackpropFilterV2Config = {
  kernelName: Conv3DBackpropFilterV2,
  backendName: "webgl",
  kernelFunc: conv3DBackpropFilterV2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function conv3DBackpropInput(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { pad: pad2, strides, inputShape } = attrs;
  const convInfo = computeConv3DInfo(inputShape, filter2.shape, strides, 1, pad2);
  const program = new Conv3DDerInputProgram(convInfo);
  return backend2.runWebGLProgram(program, [dy, filter2], "float32");
}
const conv3DBackpropInputConfig = {
  kernelName: Conv3DBackpropInputV2,
  backendName: "webgl",
  kernelFunc: conv3DBackpropInput
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const COS = CHECK_NAN_SNIPPET_UNARY + `
  return cos(x);
`;
const cos = unaryKernelFunc({ opSnippet: COS });
const cosConfig$1 = {
  kernelName: Cos,
  backendName: "webgl",
  kernelFunc: cos
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const COSH = `
  float e2x = exp(-x);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const cosh = unaryKernelFunc({ opSnippet: COSH });
const coshConfig$1 = {
  kernelName: Cosh,
  backendName: "webgl",
  kernelFunc: cosh
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class CropAndResizeProgram {
  constructor(imageShape, boxShape, cropSize, method2, extrapolationValue) {
    this.variableNames = ["Image", "Boxes", "BoxInd"];
    this.outputShape = [];
    const [batch, imageHeight, imageWidth, depth] = imageShape;
    const [numBoxes] = boxShape;
    const [cropHeight, cropWidth] = cropSize;
    this.outputShape = [numBoxes, cropHeight, cropWidth, depth];
    const methodId = method2 === "bilinear" ? 1 : 0;
    const [inputHeightFloat, inputWidthFloat] = [`${imageHeight - 1}.0`, `${imageWidth - 1}.0`];
    const [heightRatio, heightScale, inY] = cropHeight > 1 ? [
      `${(imageHeight - 1) / (cropHeight - 1)}`,
      "(y2-y1) * height_ratio",
      `y1*${inputHeightFloat} + float(y)*(height_scale)`
    ] : [
      "0.0",
      "0.0",
      `0.5 * (y1+y2) * ${inputHeightFloat}`
    ];
    const [widthRatio, widthScale, inX] = cropWidth > 1 ? [
      `${(imageWidth - 1) / (cropWidth - 1)}`,
      "(x2-x1) * width_ratio",
      `x1*${inputWidthFloat} + float(x)*(width_scale)`
    ] : [
      "0.0",
      "0.0",
      `0.5 * (x1+x2) * ${inputWidthFloat}`
    ];
    this.userCode = `
      const float height_ratio = float(${heightRatio});
      const float width_ratio = float(${widthRatio});
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int y = coords[1];
        int x = coords[2];
        int d = coords[3];

        // get box vals
        float y1 = getBoxes(b,0);
        float x1 = getBoxes(b,1);
        float y2 = getBoxes(b,2);
        float x2 = getBoxes(b,3);

        // get image in batch index
        int bInd = round(getBoxInd(b));
        if(bInd < 0 || bInd >= ${batch}) {
          return;
        }

        float height_scale = ${heightScale};
        float width_scale = ${widthScale};

        float in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }
        float in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }

        vec2 sourceFracIndexCR = vec2(in_x,in_y);
        if(${methodId} == 1) {
          // Compute the four integer indices.
          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);
          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));

          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);
          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);
          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);
          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);

          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);

          float top = topLeft + (topRight - topLeft) * fracCR.x;
          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          float newValue = top + (bottom - top) * fracCR.y;
          setOutput(newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          ivec2 sourceNearestCR = ivec2(floor(
            sourceFracIndexCR + vec2(0.5,0.5)));
          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutput(newValue);
        }
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const cropAndResize$1 = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { image: image2, boxes, boxInd } = inputs;
  const { cropSize, method: method2, extrapolationValue } = attrs;
  const program = new CropAndResizeProgram(image2.shape, boxes.shape, cropSize, method2, extrapolationValue);
  return backend2.runWebGLProgram(program, [image2, boxes, boxInd], "float32");
};
const cropAndResizeConfig$1 = {
  kernelName: CropAndResize,
  backendName: "webgl",
  kernelFunc: cropAndResize$1
};
class CumProdProgram {
  constructor(shape, exclusive, reverse2) {
    this.variableNames = ["x"];
    this.customUniforms = [{ name: "index", type: "float" }];
    this.outputShape = shape;
    const rank = shape.length;
    const val = exclusive ? "1.0" : `getX(${getCoords$1(rank, "coords")})`;
    const length = shape[shape.length - 1];
    let condition = "";
    let idxString = "";
    if (exclusive) {
      condition = reverse2 ? `end != ${length - 1}` : "end != 0";
      idxString = reverse2 ? "end + 1" : "end - 1";
    } else {
      condition = reverse2 ? `end + pow2 < ${length}` : "end >= pow2";
      idxString = reverse2 ? "end + pow2" : "end - pow2";
    }
    this.userCode = `
      void main() {
        ${getCoordsDataType(rank)} coords = getOutputCoords();
        int end = ${getFinalCoord$1(rank, "coords")};
        float val = ${val};
        int pow2 = int(pow(2.0, index));
        if (${condition}) {
          int idx = ${idxString};
          ${getFinalCoord$1(rank, "coords")} = idx;
          val *= getX(${getCoords$1(rank, "coords")});
        }
        setOutput(val);
      }
    `;
  }
}
function getCoords$1(rank, name) {
  if (rank === 1) {
    return `${name}`;
  } else if (rank === 2) {
    return `${name}.x, ${name}.y`;
  } else if (rank === 3) {
    return `${name}.x, ${name}.y, ${name}.z`;
  } else if (rank === 4) {
    return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
  } else {
    throw Error(`Cumulative product for rank ${rank} is not yet supported`);
  }
}
function getFinalCoord$1(rank, name) {
  if (rank === 1) {
    return `${name}`;
  } else if (rank === 2) {
    return `${name}.y`;
  } else if (rank === 3) {
    return `${name}.z`;
  } else if (rank === 4) {
    return `${name}.w`;
  } else {
    throw Error(`Cumulative product for rank ${rank} is not yet supported`);
  }
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cumprod$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, exclusive, reverse: reverse2 } = attrs;
  const xRank = x2.shape.length;
  const permutation = getAxesPermutation([axis], xRank);
  let permutedX = x2;
  if (permutation != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutation } });
  }
  const permutedAxis = getInnerMostAxes(1, xRank)[0];
  if (permutedAxis !== xRank - 1) {
    throw new Error(`WebGL cumprod shader expects an inner-most axis=${x2.shape.length - 1} but got axis=${axis}`);
  }
  const size = permutedX.shape[permutedAxis];
  let result2 = identity$1({ inputs: { x: permutedX }, backend: backend2 });
  for (let i2 = 0; i2 <= Math.ceil(Math.log2(size)) - 1; i2++) {
    const program = new CumProdProgram(permutedX.shape, false, reverse2);
    const customValues = [[i2]];
    const prevResult = result2;
    result2 = backend2.runWebGLProgram(program, [result2], result2.dtype, customValues);
    backend2.disposeIntermediateTensorInfo(prevResult);
  }
  if (exclusive) {
    const program = new CumProdProgram(permutedX.shape, exclusive, reverse2);
    const prevResult = result2;
    result2 = backend2.runWebGLProgram(program, [result2], result2.dtype);
    backend2.disposeIntermediateTensorInfo(prevResult);
  }
  if (permutation != null) {
    const reversePermutation = getUndoAxesPermutation(permutation);
    const reverseTransposedResult = transpose$1({ inputs: { x: result2 }, backend: backend2, attrs: { perm: reversePermutation } });
    backend2.disposeIntermediateTensorInfo(result2);
    backend2.disposeIntermediateTensorInfo(permutedX);
    return reverseTransposedResult;
  }
  return result2;
}
const cumprodConfig$1 = {
  kernelName: Cumprod,
  backendName: "webgl",
  kernelFunc: cumprod$1
};
class CumSumProgram {
  constructor(shape, exclusive, reverse2) {
    this.variableNames = ["x"];
    this.customUniforms = [{ name: "index", type: "float" }];
    this.outputShape = shape;
    const rank = shape.length;
    const val = exclusive ? "0.0" : `getX(${getCoords(rank, "coords")})`;
    const length = shape[shape.length - 1];
    let condition = "";
    let idxString = "";
    if (exclusive) {
      condition = reverse2 ? `end != ${length - 1}` : "end != 0";
      idxString = reverse2 ? "end + 1" : "end - 1";
    } else {
      condition = reverse2 ? `end + pow2 < ${length}` : "end >= pow2";
      idxString = reverse2 ? "end + pow2" : "end - pow2";
    }
    this.userCode = `
      void main() {
        ${getCoordsDataType(rank)} coords = getOutputCoords();
        int end = ${getFinalCoord(rank, "coords")};
        float val = ${val};
        int pow2 = int(pow(2.0, index));
        if (${condition}) {
          int idx = ${idxString};
          ${getFinalCoord(rank, "coords")} = idx;
          val += getX(${getCoords(rank, "coords")});
        }
        setOutput(val);
      }
    `;
  }
}
function getCoords(rank, name) {
  if (rank === 1) {
    return `${name}`;
  } else if (rank === 2) {
    return `${name}.x, ${name}.y`;
  } else if (rank === 3) {
    return `${name}.x, ${name}.y, ${name}.z`;
  } else if (rank === 4) {
    return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
  } else {
    throw Error(`Cumulative sum for rank ${rank} is not yet supported`);
  }
}
function getFinalCoord(rank, name) {
  if (rank === 1) {
    return `${name}`;
  } else if (rank === 2) {
    return `${name}.y`;
  } else if (rank === 3) {
    return `${name}.z`;
  } else if (rank === 4) {
    return `${name}.w`;
  } else {
    throw Error(`Cumulative sum for rank ${rank} is not yet supported`);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cumsum$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, exclusive, reverse: reverse2 } = attrs;
  const xRank = x2.shape.length;
  const permutation = getAxesPermutation([axis], xRank);
  let permutedX = x2;
  if (permutation != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutation } });
  }
  const permutedAxis = getInnerMostAxes(1, xRank)[0];
  if (permutedAxis !== xRank - 1) {
    throw new Error(`WebGL cumsum shader expects an inner-most axis=${x2.shape.length - 1} but got axis=${axis}`);
  }
  const size = permutedX.shape[permutedAxis];
  let result2 = identity$1({ inputs: { x: permutedX }, backend: backend2 });
  for (let i2 = 0; i2 <= Math.ceil(Math.log2(size)) - 1; i2++) {
    const program = new CumSumProgram(permutedX.shape, false, reverse2);
    const customValues = [[i2]];
    const prevResult = result2;
    result2 = backend2.runWebGLProgram(program, [result2], result2.dtype, customValues);
    backend2.disposeIntermediateTensorInfo(prevResult);
  }
  if (exclusive) {
    const program = new CumSumProgram(permutedX.shape, exclusive, reverse2);
    const prevResult = result2;
    result2 = backend2.runWebGLProgram(program, [result2], result2.dtype);
    backend2.disposeIntermediateTensorInfo(prevResult);
  }
  if (permutation != null) {
    const reversePermutation = getUndoAxesPermutation(permutation);
    const reverseTransposedResult = transpose$1({ inputs: { x: result2 }, backend: backend2, attrs: { perm: reversePermutation } });
    backend2.disposeIntermediateTensorInfo(result2);
    backend2.disposeIntermediateTensorInfo(permutedX);
    return reverseTransposedResult;
  }
  return result2;
}
const cumsumConfig$1 = {
  kernelName: Cumsum,
  backendName: "webgl",
  kernelFunc: cumsum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function denseBincount(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, weights } = inputs;
  const { size, binaryOutput } = attrs;
  if (x2.shape.length === 1) {
    const xVals = backend2.readSync(x2.dataId);
    const weightsVals = backend2.readSync(weights.dataId);
    const outVals = bincountImplCPU(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend2.makeTensorInfo([size], weights.dtype, outVals);
  } else if (x2.shape.length === 2) {
    const xBuf = backend2.bufferSync(x2);
    const weightsBuf = backend2.bufferSync(weights);
    const outBuf = bincountReduceImplCPU(xBuf, weightsBuf, size, binaryOutput);
    return backend2.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
  }
  throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank${x2.shape.length}.`);
}
const denseBincountConfig = {
  kernelName: DenseBincount,
  backendName: "webgl",
  kernelFunc: denseBincount
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DepthToSpaceProgram {
  constructor(outputShape, blockSize, dataFormat) {
    this.variableNames = ["x"];
    this.outputShape = [];
    this.outputShape = outputShape;
    this.blockSize = blockSize;
    this.dataFormat = dataFormat;
    this.userCode = `
    void main() {
      ivec4 coords = getOutputCoords();
      int b = coords[0];
      int h = ${this.getHeightCoordString()};
      int w = ${this.getWidthCoordString()};
      int d = ${this.getDepthCoordString()};

      int in_h = h / ${blockSize};
      int offset_h = imod(h, ${blockSize});
      int in_w = w / ${blockSize};
      int offset_w = imod(w, ${blockSize});
      int offset_d = (offset_h * ${blockSize} + offset_w) *
        ${this.getOutputDepthSize()};
      int in_d = d + offset_d;

      float result = ${this.getInputSamplingString()};
      setOutput(result);
    }
  `;
  }
  getHeightCoordString() {
    if (this.dataFormat === "NHWC") {
      return `coords[1]`;
    } else {
      return `coords[2]`;
    }
  }
  getWidthCoordString() {
    if (this.dataFormat === "NHWC") {
      return `coords[2]`;
    } else {
      return `coords[3]`;
    }
  }
  getDepthCoordString() {
    if (this.dataFormat === "NHWC") {
      return `coords[3]`;
    } else {
      return `coords[1]`;
    }
  }
  getOutputDepthSize() {
    if (this.dataFormat === "NHWC") {
      return this.outputShape[3];
    } else {
      return this.outputShape[1];
    }
  }
  getInputSamplingString() {
    if (this.dataFormat === "NHWC") {
      return `getX(b, in_h, in_w, in_d)`;
    } else {
      return `getX(b, in_d, in_h, in_w)`;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthToSpace$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockSize, dataFormat } = attrs;
  const batchSize = x2.shape[0];
  const inputHeight = dataFormat === "NHWC" ? x2.shape[1] : x2.shape[2];
  const inputWidth = dataFormat === "NHWC" ? x2.shape[2] : x2.shape[3];
  const inputDepth = dataFormat === "NHWC" ? x2.shape[3] : x2.shape[1];
  const outputHeight = inputHeight * blockSize;
  const outputWidth = inputWidth * blockSize;
  const outputDepth = inputDepth / (blockSize * blockSize);
  const outputShape = dataFormat === "NHWC" ? [batchSize, outputHeight, outputWidth, outputDepth] : [batchSize, outputDepth, outputHeight, outputWidth];
  const program = new DepthToSpaceProgram(outputShape, blockSize, dataFormat);
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
}
const depthToSpaceConfig$1 = {
  kernelName: DepthToSpace,
  backendName: "webgl",
  kernelFunc: depthToSpace$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DepthwiseConv2DProgram {
  constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false) {
    this.variableNames = ["x", "W"];
    this.customUniforms = [
      { name: "pads", type: "ivec2" },
      { name: "strides", type: "ivec2" },
      { name: "dilations", type: "ivec2" },
      { name: "inDims", type: "ivec2" }
    ];
    this.outputShape = convInfo.outShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const channelMul = convInfo.outChannels / convInfo.inChannels;
    let activationSnippet = "", applyActivationSnippet = "";
    if (activation) {
      if (hasPreluActivation) {
        activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
      } else if (hasLeakyReluAlpha) {
        activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
      } else {
        activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
      }
      applyActivationSnippet = `result = activation(result);`;
    }
    const addBiasSnippet = addBias ? "result += getBiasAtOutCoords();" : "";
    if (addBias) {
      this.variableNames.push("bias");
    }
    if (hasPreluActivation) {
      this.variableNames.push("preluActivationWeights");
    }
    if (hasLeakyReluAlpha) {
      this.variableNames.push("leakyreluAlpha");
    }
    this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};

        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * dilations[0];

          if (xR < 0 || xR >= inDims[0]) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * dilations[1];

            if (xC < 0 || xC >= inDims[1]) {
              continue;
            }

            float xVal = getX(batch, xR, xC, d1);
            float wVal = getW(wR, wC, d1, q);
            dotProd += xVal * wVal;
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DepthwiseConvPacked2DProgram {
  constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false) {
    this.variableNames = ["x", "W"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.customUniforms = [
      { name: "pads", type: "ivec2" },
      { name: "strides", type: "ivec2" },
      { name: "dilations", type: "ivec2" },
      { name: "inDims", type: "ivec2" }
    ];
    this.outputShape = convInfo.outShape;
    this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
    const channelMul = convInfo.outChannels / convInfo.inChannels;
    const padLeft = convInfo.padInfo.left;
    const strideWidth = convInfo.strideWidth;
    const dilationWidth = convInfo.dilationWidth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const texelsAcross = filterWidth;
    let mainLoop = `
      int xR; int xC; int xCOffset;
      vec4 wTexel; vec4 previous; vec4 final;`;
    for (let c2 = 0; c2 < filterWidth; c2++) {
      mainLoop += `
          vec4 xTexelC${c2 * 2};
          int xTexelC${c2 * 2}Ready;
          vec4 xTexelC${c2 * 2 + 1};
          int xTexelC${c2 * 2 + 1}Ready;
          vec4 xC${c2};`;
    }
    mainLoop += `
    for (int r = 0; r < ${filterHeight}; r++) {
      `;
    for (let c2 = 0; c2 < filterWidth; c2++) {
      mainLoop += `
          xTexelC${c2 * 2} = vec4(0.0);
          xTexelC${c2 * 2}Ready = 0;
          xTexelC${c2 * 2 + 1} = vec4(0.0);
          xTexelC${c2 * 2 + 1}Ready = 0;
          xC${c2} = vec4(0.0);`;
    }
    mainLoop += `
        xR = xRCorner + r * dilations[0];
        if (xR >=0 && xR < inDims[0]) {
      `;
    for (let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++) {
      const colIndex = texelC * 2;
      mainLoop += `
          xC = xCCorner + ${colIndex * dilationWidth};
          `;
      if (strideWidth === 1) {
        if (colIndex < filterWidth) {
          if (padLeft % 2 === 1) {
            mainLoop += `
                xCOffset = xC + 1;
                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }
              `;
            if (dilationWidth === 1 && colIndex > 0) {
              mainLoop += `
                xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                `;
            } else {
              mainLoop += `
                  xCOffset = xC + 1 - 2;

                  if (xCOffset >= 0 && xCOffset < inDims[1]) {
                    previous = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      previous.zw = vec2(0.0);
                    }

                    xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                  } else {
                    xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                  }
                  `;
            }
          } else {
            mainLoop += `
                if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xC${colIndex} = xTexelC${colIndex};
                `;
          }
          if (colIndex + 1 < filterWidth) {
            const nextTexelOffset = padLeft % 2 === 0 ? nearestLargerEven(dilationWidth) : dilationWidth;
            if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
              mainLoop += `
                  xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                    xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      xTexelC${colIndex + 1}.zw = vec2(0.0);
                    }
                    xTexelC${colIndex + 1}Ready = 1;
                  }
                  `;
              if (dilationWidth > 1) {
                mainLoop += `
                    xCOffset -= 2;
                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                      xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                      xTexelC${colIndex}Ready = 1;
                    }
                    `;
              }
              mainLoop += `
                  xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                  `;
            } else {
              if (nextTexelOffset === 1) {
                mainLoop += `
                    xC${colIndex + 1} = xTexelC${colIndex};
                    `;
              } else {
                mainLoop += `
                    xCOffset = xC + ${nextTexelOffset};

                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                      xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                      if (xCOffset + 1 >= inDims[1]) {
                        xTexelC${colIndex + 1}.zw = vec2(0.0);
                      }
                      xTexelC${colIndex + 1}Ready = 1;
                    }

                    xC${colIndex + 1} = xTexelC${colIndex + 1};
                    `;
              }
            }
          }
        }
      } else {
        if (colIndex < filterWidth) {
          if (padLeft % 2 === 1) {
            mainLoop += `
                xCOffset = xC + 1 - strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xC + 2 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
              `;
            if (colIndex + 1 < filterWidth) {
              mainLoop += `
                  final = vec4(0.0);
                  xCOffset = xC + 1 + strides[1];
                  if(xCOffset >= 0 && xCOffset < inDims[1]) {
                    final = getX(batch, xR, xCOffset, d1);
                  }
                  xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                `;
            }
          } else {
            mainLoop += `
                if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xCOffset = xC + strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(
                  xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
              `;
            if (colIndex + 1 < filterWidth) {
              mainLoop += `
                  xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                `;
            }
          }
        }
      }
      if (colIndex < filterWidth) {
        mainLoop += `
            wTexel = getW(r, ${colIndex}, d1, q);
            dotProd += xC${colIndex} * vec4(wTexel.xz, wTexel.xz);
          `;
        if (colIndex + 1 < filterWidth) {
          mainLoop += `
              wTexel = getW(r, ${colIndex + 1}, d1, q);
              dotProd += xC${colIndex + 1} * vec4(wTexel.xz, wTexel.xz);
            `;
        }
      }
    }
    mainLoop += `
    }
  `;
    mainLoop += `
      }
    `;
    let activationSnippet = "", applyActivationSnippet = "";
    if (activation) {
      if (hasPreluActivation) {
        activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
      } else if (hasLeakyReluAlpha) {
        activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
      } else {
        activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
      }
      applyActivationSnippet = `result = activation(result);`;
    }
    const addBiasSnippet = addBias ? "result += getBiasAtOutCoords();" : "";
    if (addBias) {
      this.variableNames.push("bias");
    }
    if (hasPreluActivation) {
      this.variableNames.push("preluActivationWeights");
    }
    if (hasLeakyReluAlpha) {
      this.variableNames.push("leakyreluAlpha");
    }
    this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
        vec4 dotProd = vec4(0.000000000000001);

        ${mainLoop}

        vec4 result = dotProd - vec4(0.000000000000001);
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNative(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dilations, dimRoundingMode } = attrs;
  let $dilations = dilations;
  if ($dilations == null) {
    $dilations = [1, 1];
  }
  assert$1(eitherStridesOrDilationsAreOne(strides, $dilations), () => `Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${strides} and dilations '${$dilations}'`);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, $dilations, pad2, dimRoundingMode, true);
  let program;
  if (env().getBool("WEBGL_PACK_DEPTHWISECONV") && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1) {
    program = new DepthwiseConvPacked2DProgram(convInfo);
  } else {
    program = new DepthwiseConv2DProgram(convInfo);
  }
  const customValues = [
    [convInfo.padInfo.top, convInfo.padInfo.left],
    [convInfo.strideHeight, convInfo.strideWidth],
    [convInfo.dilationHeight, convInfo.dilationWidth],
    [convInfo.inHeight, convInfo.inWidth]
  ];
  return backend2.runWebGLProgram(program, [x2, filter2], "float32", customValues);
}
const depthwiseConv2dNativeConfig$1 = {
  kernelName: DepthwiseConv2dNative,
  backendName: "webgl",
  kernelFunc: depthwiseConv2dNative
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DepthwiseConv2DDerFilterProgram {
  constructor(convInfo) {
    this.variableNames = ["x", "dy"];
    this.outputShape = convInfo.filterShape;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const channelMul = convInfo.outChannels / convInfo.inChannels;
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int dm = coords.w;
        int d2 = d1 * ${channelMul} + dm;

        float dotProd = 0.0;

        // TO DO: Vec4 over the batch size
        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
class DepthwiseConv2DDerInputProgram {
  constructor(convInfo) {
    this.variableNames = ["dy", "W"];
    this.outputShape = convInfo.inShape;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const padTop = filterHeight - 1 - convInfo.padInfo.top;
    const padLeft = filterWidth - 1 - convInfo.padInfo.left;
    const channelMul = convInfo.outChannels / convInfo.inChannels;
    this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];
        ivec2 dyCorner = coords.yz - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        float dotProd = 0.0;

        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            // TO DO: Vec4 over the channelMul
            for (int dm = 0; dm < ${channelMul}; dm++) {
              int d2 = d1 * ${channelMul} + dm;
              float xValue = getDy(batch, idyR, idyC, d2);
              float wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNativeBackpropFilter(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, dy } = inputs;
  const { strides, dilations, pad: pad2, dimRoundingMode, filterShape } = attrs;
  const convInfo = computeConv2DInfo(x2.shape, filterShape, strides, dilations, pad2, dimRoundingMode, true);
  const program = new DepthwiseConv2DDerFilterProgram(convInfo);
  return backend2.runWebGLProgram(program, [x2, dy], "float32");
}
const depthwiseConv2dNativeBackpropFilterConfig = {
  kernelName: DepthwiseConv2dNativeBackpropFilter,
  backendName: "webgl",
  kernelFunc: depthwiseConv2dNativeBackpropFilter
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function depthwiseConv2dNativeBackpropInput(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { strides, dilations, pad: pad2, dimRoundingMode, inputShape } = attrs;
  const convInfo = computeConv2DInfo(inputShape, filter2.shape, strides, dilations, pad2, dimRoundingMode, true);
  const program = new DepthwiseConv2DDerInputProgram(convInfo);
  return backend2.runWebGLProgram(program, [dy, filter2], "float32");
}
const depthwiseConv2dNativeBackpropInputConfig = {
  kernelName: DepthwiseConv2dNativeBackpropInput,
  backendName: "webgl",
  kernelFunc: depthwiseConv2dNativeBackpropInput
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class DiagProgram {
  constructor(size) {
    this.variableNames = ["X"];
    this.outputShape = [size, size];
    this.userCode = `
      void main() {
          ivec2 coords = getOutputCoords();
          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;
          setOutput(val);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function diag(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  const outShape = [...x2.shape, ...x2.shape];
  const xSize = sizeFromShape(x2.shape);
  const flat = reshape$1({ inputs: { x: x2 }, backend: backend2, attrs: { shape: [xSize] } });
  const program = new DiagProgram(xSize);
  const res = backend2.runWebGLProgram(program, [flat], flat.dtype);
  const out = reshape$1({ inputs: { x: res }, backend: backend2, attrs: { shape: outShape } });
  backend2.disposeIntermediateTensorInfo(flat);
  backend2.disposeIntermediateTensorInfo(res);
  return out;
}
const diagConfig = {
  kernelName: Diag,
  backendName: "webgl",
  kernelFunc: diag
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class Dilation2DProgram {
  constructor(convInfo) {
    this.variableNames = ["x", "W"];
    this.outputShape = convInfo.outShape;
    const { inHeight, inWidth, padInfo, strideHeight, strideWidth, filterHeight, filterWidth, dilationHeight, dilationWidth } = convInfo;
    const { top: padTop, left: padLeft } = padInfo;
    this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float neg_infinity = -3.4e38;

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.w;
        ivec2 outTopLeftCorner =
            coords.yz * strides - pads;
        int hBeg = outTopLeftCorner.x;
        int wBeg = outTopLeftCorner.y;

        float curVal = neg_infinity;
        for (int h = 0; h < ${filterHeight}; h++) {
          int hIn = hBeg + h * ${dilationHeight};

          if (hIn >= 0 && hIn < ${inHeight}) {
            for (int w = 0; w < ${filterWidth}; w++) {
              int wIn = wBeg + w * ${dilationWidth};

              if (wIn >= 0 && wIn < ${inWidth}) {
                float xVal = getX(batch, hIn, wIn, d1);
                float wVal = getW(h, w, d1);

                float val = xVal + wVal;
                if (val > curVal) {
                  curVal = val;
                }
              }
            }
          }
        }

        float result = curVal;
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function dilation2D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2 } = inputs;
  const { strides, pad: pad2, dilations } = attrs;
  const convInfo = computeDilation2DInfo(x2.shape, filter2.shape, strides, pad2, "NHWC", dilations);
  let out;
  const program = new Dilation2DProgram(convInfo);
  out = backend2.runWebGLProgram(program, [x2, filter2], "float32");
  const outReshaped = reshape$1({ inputs: { x: out }, backend: backend2, attrs: { shape: convInfo.outShape } });
  backend2.disposeIntermediateTensorInfo(out);
  return outReshaped;
}
const dilation2DConfig = {
  kernelName: Dilation2D,
  backendName: "webgl",
  kernelFunc: dilation2D
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function einsum(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { equation } = attrs;
  const tensors = inputs;
  const { allDims, summedDims, idDims } = decodeEinsumEquation(equation, tensors.length);
  checkEinsumDimSizes(allDims.length, idDims, tensors);
  const { path: path2, steps: steps2 } = getEinsumComputePath(summedDims, idDims);
  const nSteps = steps2.length;
  let out = null;
  let numDimsRemaining = allDims.length;
  const tensorsToDispose = [];
  for (let i2 = 0; i2 < nSteps; ++i2) {
    for (const idTerm of steps2[i2]) {
      const { permutationIndices: perm, expandDims: dimsToExpand } = getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
      let x2;
      if (isIdentityPermutation(perm)) {
        x2 = tensors[idTerm];
      } else {
        x2 = transpose$1({ inputs: { x: tensors[idTerm] }, backend: backend2, attrs: { perm } });
        tensorsToDispose.push(x2);
      }
      const targetShape = x2.shape.slice();
      for (let k3 = 0; k3 < dimsToExpand.length; ++k3) {
        targetShape.splice(dimsToExpand[k3], 0, 1);
      }
      if (!arraysEqual(x2.shape, targetShape)) {
        x2 = reshape$1({ inputs: { x: x2 }, backend: backend2, attrs: { shape: targetShape } });
        tensorsToDispose.push(x2);
      }
      if (out === null) {
        out = x2;
      } else {
        out = multiply({ inputs: { a: x2, b: out }, backend: backend2 });
        tensorsToDispose.push(out);
      }
    }
    if (i2 < nSteps - 1) {
      if (path2[i2] >= 0) {
        out = sum$1({
          inputs: { x: out },
          backend: backend2,
          attrs: {
            axis: path2[i2] - (allDims.length - numDimsRemaining),
            keepDims: false
          }
        });
        tensorsToDispose.push(out);
      }
      numDimsRemaining--;
    }
  }
  for (const tensorInfo of tensorsToDispose) {
    if (tensorInfo === out) {
      continue;
    }
    backend2.disposeIntermediateTensorInfo(tensorInfo);
  }
  return out;
}
const einsumConfig = {
  kernelName: Einsum,
  backendName: "webgl",
  kernelFunc: einsum
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ELU = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const ELU_PACKED = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const elu = unaryKernelFunc({ opSnippet: ELU, packedOpSnippet: ELU_PACKED });
const eluConfig$1 = {
  kernelName: Elu$1,
  backendName: "webgl",
  kernelFunc: elu
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ELU_DER = `return (b >= 1.0) ? a : a * (b + 1.0);`;
const ELU_DER_PACKED = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const eluGrad = (args) => {
  const { inputs, backend: backend2 } = args;
  const { dy, y: y2 } = inputs;
  const program = env().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new BinaryOpPackedProgram(ELU_DER_PACKED, dy.shape, y2.shape) : new BinaryOpProgram(ELU_DER, dy.shape, y2.shape);
  return backend2.runWebGLProgram(program, [dy, y2], dy.dtype);
};
const eluGradConfig = {
  kernelName: EluGrad,
  backendName: "webgl",
  kernelFunc: eluGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const PACKED_EQUAL = `
  return vec4(equal(a, b));
`;
const EQUAL = `return float(a == b);`;
const equal = binaryKernelFunc({
  opSnippet: EQUAL,
  packedOpSnippet: PACKED_EQUAL,
  dtype: "bool",
  cpuKernelImpl: equalImplCPU
});
const equalConfig$1 = {
  kernelName: Equal,
  backendName: "webgl",
  kernelFunc: equal
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  float p = ${ERF_P};
  float a1 = ${ERF_A1};
  float a2 = ${ERF_A2};
  float a3 = ${ERF_A3};
  float a4 = ${ERF_A4};
  float a5 = ${ERF_A5};

  float sign = sign(x);
  x = abs(x);
  float t = 1.0 / (1.0 + p * x);
  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));
`;
const erf = unaryKernelFunc({ opSnippet: ERF });
const erfConfig = {
  kernelName: Erf,
  backendName: "webgl",
  kernelFunc: erf
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const EXP = CHECK_NAN_SNIPPET_UNARY + `
  return exp(x);
`;
const EXP_PACKED = `
  vec4 result = exp(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const exp = unaryKernelFunc({
  opSnippet: EXP,
  packedOpSnippet: EXP_PACKED,
  cpuKernelImpl: expImplCPU,
  dtype: "float32"
});
const expConfig$1 = {
  kernelName: Exp,
  backendName: "webgl",
  kernelFunc: exp
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function expandDims$1(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { dim } = attrs;
  const { input } = inputs;
  const inputRank = input.shape.length;
  const newShape = input.shape.slice();
  let $dim = dim;
  if (dim < 0) {
    assert$1(-(inputRank + 1) <= dim, () => `Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
    $dim = inputRank + dim + 1;
  }
  newShape.splice($dim, 0, 1);
  return reshape$1({ inputs: { x: input }, backend: backend2, attrs: { shape: newShape } });
}
const expandDimsConfig$1 = {
  kernelName: ExpandDims,
  backendName: "webgl",
  kernelFunc: expandDims$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const EXPM1 = `return exp(x) - 1.0;`;
const expm1 = unaryKernelFunc({ opSnippet: EXPM1, packedOpSnippet: EXPM1, cpuKernelImpl: expm1ImplCPU });
const expm1Config = {
  kernelName: Expm1,
  backendName: "webgl",
  kernelFunc: expm1
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class FFTProgram {
  constructor(component, inputShape, inverse) {
    this.variableNames = ["real", "imag"];
    const innerDim = inputShape[1];
    this.outputShape = inputShape;
    const exponentMultiplierSnippet = inverse ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`;
    const resultDenominator = inverse ? `${innerDim}.0` : "1.0";
    let opString;
    if (component === "real") {
      opString = "return real * expR - imag * expI;";
    } else if (component === "imag") {
      opString = "return real * expI + imag * expR;";
    } else {
      throw new Error(`FFT component must be either "real" or "imag", got ${component}.`);
    }
    this.userCode = `
      const float exponentMultiplier = ${exponentMultiplierSnippet};

      float unaryOpComplex(float real, float expR, float imag, float expI) {
        ${opString}
      }

      float mulMatDFT(int batch, int index) {
        float indexRatio = float(index) / float(${innerDim});
        float exponentMultiplierTimesIndexRatio =
            exponentMultiplier * indexRatio;

        float result = 0.0;

        for (int i = 0; i < ${innerDim}; i++) {
          // x = (-2|2 * PI / N) * index * i;
          float x = exponentMultiplierTimesIndexRatio * float(i);
          float expR = cos(x);
          float expI = sin(x);
          float real = getReal(batch, i);
          float imag = getImag(batch, i);

          result +=
              unaryOpComplex(real, expR, imag, expI) / ${resultDenominator};
        }

        return result;
      }

      void main() {
        ivec2 coords = getOutputCoords();
        setOutput(mulMatDFT(coords[0], coords[1]));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fftImpl(x2, inverse, backend2) {
  const xData = backend2.texData.get(x2.dataId);
  const inputSize = sizeFromShape(x2.shape);
  const innerDimensionSize = x2.shape[x2.shape.length - 1];
  const batch = inputSize / innerDimensionSize;
  const input2D = reshape$1({ inputs: { x: x2 }, backend: backend2, attrs: { shape: [batch, innerDimensionSize] } });
  const xShape = input2D.shape;
  const realProgram = new FFTProgram("real", xShape, inverse);
  const imagProgram = new FFTProgram("imag", xShape, inverse);
  const inputs = [
    {
      dataId: xData.complexTensorInfos.real.dataId,
      dtype: xData.complexTensorInfos.real.dtype,
      shape: xShape
    },
    {
      dataId: xData.complexTensorInfos.imag.dataId,
      dtype: xData.complexTensorInfos.imag.dtype,
      shape: xShape
    }
  ];
  const realPart = backend2.runWebGLProgram(realProgram, inputs, "float32");
  const imagPart = backend2.runWebGLProgram(imagProgram, inputs, "float32");
  const complexOutput = complex$1({ inputs: { real: realPart, imag: imagPart }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(realPart);
  backend2.disposeIntermediateTensorInfo(imagPart);
  const complexOutputReshaped = reshape$1({ inputs: { x: complexOutput }, backend: backend2, attrs: { shape: x2.shape } });
  backend2.disposeIntermediateTensorInfo(input2D);
  backend2.disposeIntermediateTensorInfo(complexOutput);
  return complexOutputReshaped;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fft(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  return fftImpl(input, false, backend2);
}
const fftConfig = {
  kernelName: FFT,
  backendName: "webgl",
  kernelFunc: fft
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class FillProgram {
  constructor(shape, value) {
    this.outputShape = [];
    this.customUniforms = [{ name: "value", type: "float" }];
    this.variableNames = ["x"];
    this.outputShape = shape;
    this.userCode = `
      void main() {
        // Input can be obtained from uniform value.
        setOutput(value);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fill$1(args) {
  const { backend: backend2, attrs } = args;
  const { shape, value } = attrs;
  let { dtype } = attrs;
  dtype = dtype || inferDtype(value);
  if (dtype === "string") {
    const values = getArrayFromDType(dtype, sizeFromShape(shape));
    values.fill(value);
    return backend2.makeTensorInfo(shape, dtype, values);
  } else {
    const program = new FillProgram(shape, value);
    const customValues = [[value]];
    return backend2.runWebGLProgram(program, [], dtype, customValues);
  }
}
const fillConfig$1 = {
  kernelName: Fill,
  backendName: "webgl",
  kernelFunc: fill$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class FlipLeftRightProgram {
  constructor(imageShape) {
    this.variableNames = ["Image"];
    this.outputShape = [];
    const imageWidth = imageShape[2];
    this.outputShape = imageShape;
    this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];

          int coordX = ${imageWidth} - x - 1;
          float outputValue;
          if(coordX >= 0 && coordX < ${imageWidth}) {
            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);
          } else {
            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);
          }
          setOutput(outputValue);
        }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const flipLeftRightConfig$1 = {
  kernelName: FlipLeftRight,
  backendName: "webgl",
  kernelFunc: ({ inputs, backend: backend2 }) => {
    const { image: image2 } = inputs;
    const webglBackend = backend2;
    const program = new FlipLeftRightProgram(image2.shape);
    const output2 = webglBackend.runWebGLProgram(program, [image2], image2.dtype);
    return output2;
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const FLOOR = `return floor(x);`;
const floor = unaryKernelFunc({ opSnippet: FLOOR, packedOpSnippet: FLOOR, cpuKernelImpl: floorImplCPU });
const floorConfig$1 = {
  kernelName: Floor,
  backendName: "webgl",
  kernelFunc: floor
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const INT_DIV = `
  float s = sign(a) * sign(b);
  int ia = round(a);
  int ib = round(b);
  if (ib != 0) {
    // Windows (D3D) wants guaranteed non-zero int division at compile-time.
    return float(idiv(ia, ib, s));
  } else {
    return NAN;
  }
`;
const INT_DIV_PACKED = `
  ivec4 ia = round(a);
  ivec4 ib = round(b);
  bvec4 cond = notEqual(ib, ivec4(0));
  ivec4 result = ivec4(0);
  vec4 s = sign(a) * sign(b);

  // Windows (D3D) wants guaranteed non-zero int division at compile-time.
  if (cond[0]) {
    result[0] = idiv(ia[0], ib[0], s[0]);
  }
  if (cond[1]) {
    result[1] = idiv(ia[1], ib[1], s[1]);
  }
  if (cond[2]) {
    result[2] = idiv(ia[2], ib[2], s[2]);
  }
  if (cond[3]) {
    result[3] = idiv(ia[3], ib[3], s[3]);
  }
  return vec4(result);
`;
const floorDiv = binaryKernelFunc({ opSnippet: INT_DIV, packedOpSnippet: INT_DIV_PACKED, dtype: "int32" });
const floorDivConfig$1 = {
  kernelName: FloorDiv,
  backendName: "webgl",
  kernelFunc: floorDiv
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class FromPixelsProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    const glsl = getGlslDifferences();
    const [height2, width2] = outputShape;
    this.outputShape = outputShape;
    this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${width2}.0, ${height2}.0);

        vec4 values = ${glsl.texture2D}(A, uv);
        float value;
        if (depth == 0) {
          value = values.r;
        } else if (depth == 1) {
          value = values.g;
        } else if (depth == 2) {
          value = values.b;
        } else if (depth == 3) {
          value = values.a;
        }

        setOutput(floor(value * 255.0 + 0.5));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class FromPixelsPackedProgram {
  constructor(outputShape) {
    this.variableNames = ["A"];
    this.packedInputs = false;
    this.packedOutput = true;
    const glsl = getGlslDifferences();
    const [height2, width2] = outputShape;
    this.outputShape = outputShape;
    this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];

        vec4 result = vec4(0.);

        for(int row=0; row<=1; row++) {
          for(int col=0; col<=1; col++) {
            texC = coords[1] + row;
            depth = coords[2] + col;

            vec2 uv = (vec2(texC, texR) + halfCR) /
                       vec2(${width2}.0, ${height2}.0);
            vec4 values = ${glsl.texture2D}(A, uv);
            float value;
            if (depth == 0) {
              value = values.r;
            } else if (depth == 1) {
              value = values.g;
            } else if (depth == 2) {
              value = values.b;
            } else if (depth == 3) {
              value = values.a;
            }

            result[row * 2 + col] = floor(value * 255.0 + 0.5);
          }
        }

        ${glsl.output} = result;
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const fromPixelsConfig = {
  kernelName: FromPixels,
  backendName: "webgl",
  kernelFunc: fromPixels
};
let fromPixels2DContext;
function fromPixels(args) {
  const { inputs, backend: backend2, attrs } = args;
  let { pixels } = inputs;
  const { numChannels } = attrs;
  const isVideo = typeof HTMLVideoElement !== "undefined" && pixels instanceof HTMLVideoElement;
  const isImage = typeof HTMLImageElement !== "undefined" && pixels instanceof HTMLImageElement;
  const [width2, height2] = isVideo ? [
    pixels.videoWidth,
    pixels.videoHeight
  ] : [pixels.width, pixels.height];
  const texShape = [height2, width2];
  const outShape = [height2, width2, numChannels];
  if (isImage || isVideo) {
    if (fromPixels2DContext == null) {
      fromPixels2DContext = document.createElement("canvas").getContext("2d");
    }
    fromPixels2DContext.canvas.width = width2;
    fromPixels2DContext.canvas.height = height2;
    fromPixels2DContext.drawImage(pixels, 0, 0, width2, height2);
    pixels = fromPixels2DContext.canvas;
  }
  const tempPixelHandle = backend2.makeTensorInfo(texShape, "int32");
  backend2.texData.get(tempPixelHandle.dataId).usage = TextureUsage.PIXELS;
  backend2.gpgpu.uploadPixelDataToTexture(backend2.getTexture(tempPixelHandle.dataId), pixels);
  const program = env().getBool("WEBGL_PACK") ? new FromPixelsPackedProgram(outShape) : new FromPixelsProgram(outShape);
  const res = backend2.runWebGLProgram(program, [tempPixelHandle], "int32");
  backend2.disposeData(tempPixelHandle.dataId);
  return res;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedConv2d$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2, bias, preluActivationWeights } = inputs;
  const { strides, pad: pad2, dataFormat, dilations, dimRoundingMode, activation, leakyreluAlpha } = attrs;
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, dilations, pad2, dimRoundingMode, false, $dataFormat);
  let out;
  const intermediates = [];
  if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === "SAME" || convInfo.padInfo.type === "VALID")) {
    out = conv2dByMatMul({
      x: x2,
      filter: filter2,
      convInfo,
      backend: backend2,
      bias,
      activation,
      preluActivationWeights,
      leakyreluAlpha
    });
  } else if (env().getBool("WEBGL_CONV_IM2COL") && x2.shape[0] === 1) {
    out = conv2dWithIm2Row({
      x: x2,
      filter: filter2,
      convInfo,
      backend: backend2,
      bias,
      activation,
      preluActivationWeights,
      leakyreluAlpha
    });
  } else {
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === "leakyrelu";
    const fusedActivation = activation ? mapActivationToShaderProgram(activation, false) : null;
    const program = new Conv2DProgram(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const inputs2 = [x2, filter2];
    if (bias) {
      inputs2.push(bias);
    }
    if (preluActivationWeights) {
      inputs2.push(preluActivationWeights);
    }
    if (hasLeakyreluAlpha) {
      const $leakyreluAlpha = backend2.makeTensorInfo([], "float32", createScalarValue(leakyreluAlpha, "float32"));
      inputs2.push($leakyreluAlpha);
      intermediates.push($leakyreluAlpha);
    }
    out = backend2.runWebGLProgram(program, inputs2, "float32");
  }
  const outReshaped = reshape$1({ inputs: { x: out }, backend: backend2, attrs: { shape: convInfo.outShape } });
  intermediates.push(out);
  intermediates.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return outReshaped;
}
const fusedConv2DConfig$1 = {
  kernelName: FusedConv2D,
  backendName: "webgl",
  kernelFunc: fusedConv2d$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fusedDepthwiseConv2D(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, filter: filter2, bias, preluActivationWeights } = inputs;
  const { strides, pad: pad2, dilations, dimRoundingMode, activation, leakyreluAlpha } = attrs;
  const intermediates = [];
  let $dilations = dilations;
  if ($dilations == null) {
    $dilations = [1, 1];
  }
  assert$1(eitherStridesOrDilationsAreOne(strides, $dilations), () => `Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${strides} and dilations '${$dilations}'`);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, $dilations, pad2, dimRoundingMode, true);
  const shouldPackDepthwiseConv = env().getBool("WEBGL_PACK_DEPTHWISECONV") && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1;
  const fusedActivation = activation ? mapActivationToShaderProgram(activation, shouldPackDepthwiseConv) : null;
  const programInputs = [x2, filter2];
  const hasBias = bias != null;
  const hasPreluActivationWeights = preluActivationWeights != null;
  const hasLeakyreluAlpha = activation === "leakyrelu";
  if (hasBias) {
    programInputs.push(bias);
  }
  if (hasPreluActivationWeights) {
    programInputs.push(preluActivationWeights);
  }
  if (hasLeakyreluAlpha) {
    const $leakyreluAlpha = backend2.makeTensorInfo([], "float32", createScalarValue(leakyreluAlpha, "float32"));
    programInputs.push($leakyreluAlpha);
    intermediates.push($leakyreluAlpha);
  }
  let program;
  if (shouldPackDepthwiseConv) {
    program = new DepthwiseConvPacked2DProgram(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
  } else {
    program = new DepthwiseConv2DProgram(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
  }
  const customValues = [
    [convInfo.padInfo.top, convInfo.padInfo.left],
    [convInfo.strideHeight, convInfo.strideWidth],
    [convInfo.dilationHeight, convInfo.dilationWidth],
    [convInfo.inHeight, convInfo.inWidth]
  ];
  const result2 = backend2.runWebGLProgram(program, programInputs, "float32", customValues);
  intermediates.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
}
const fusedDepthwiseConv2DConfig$1 = {
  kernelName: FusedDepthwiseConv2D,
  backendName: "webgl",
  kernelFunc: fusedDepthwiseConv2D
};
class GatherNDProgram {
  constructor(sliceDim, strides, shape) {
    this.sliceDim = sliceDim;
    this.strides = strides;
    this.variableNames = ["x", "indices"];
    this.outputShape = shape;
    const stridesType = getCoordsDataType(strides.length);
    const dtype = getCoordsDataType(shape.length);
    const strideString = this.sliceDim > 1 ? "strides[j]" : "strides";
    this.userCode = `
        ${stridesType} strides = ${stridesType}(${this.strides});
         void main() {
          ${dtype} coords = getOutputCoords();
          int flattenIndex = 0;
          for (int j = 0; j < ${this.sliceDim}; j++) {
            int index = round(getIndices(coords[0], j));
            flattenIndex += index * ${strideString};
          }
          setOutput(getX(flattenIndex, coords[1]));
        }
      `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherNd$1(args) {
  const { inputs, backend: backend2 } = args;
  const { params, indices } = inputs;
  const indicesShape = indices.shape;
  const sliceRank = indicesShape[indicesShape.length - 1];
  const paramsSize = sizeFromShape(params.shape);
  const [resultShape, numSlices, sliceSize, strides] = prepareAndValidate(params, indices);
  const flattenIndices = reshape$1({ inputs: { x: indices }, backend: backend2, attrs: { shape: [numSlices, sliceRank] } });
  const flattenX = reshape$1({
    inputs: { x: params },
    backend: backend2,
    attrs: { shape: [sizeFromShape(params.shape) / sliceSize, sliceSize] }
  });
  if (backend2.shouldExecuteOnCPU([params, indices]) || params.dtype === "string") {
    const indicesData = backend2.readSync(indices.dataId);
    const paramsBuf = backend2.bufferSync(params);
    const outValue = gatherNdImplCPU(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
    return backend2.makeTensorInfo(resultShape, params.dtype, outValue.values);
  }
  const program = new GatherNDProgram(sliceRank, strides, [numSlices, sliceSize]);
  const res = backend2.runWebGLProgram(program, [flattenX, flattenIndices], flattenX.dtype);
  const reshaped = reshape$1({ inputs: { x: res }, backend: backend2, attrs: { shape: resultShape } });
  backend2.disposeIntermediateTensorInfo(flattenIndices);
  backend2.disposeIntermediateTensorInfo(flattenX);
  backend2.disposeIntermediateTensorInfo(res);
  return reshaped;
}
const gatherNdConfig$1 = {
  kernelName: GatherNd,
  backendName: "webgl",
  kernelFunc: gatherNd$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class GatherProgram {
  constructor(aShape, outputShape) {
    this.variableNames = ["A", "indices"];
    this.outputShape = outputShape;
    this.rank = outputShape.length;
    const dtype = getCoordsDataType(this.rank);
    const sourceCoords = getSourceCoords$1(aShape);
    this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        int index = int(getIndices(resRC.x, resRC.z));
        float inBounds = (index >= 0) && (index < ${aShape[2]}) ? 1.0 : 0.0;
        setOutput(inBounds * getA(${sourceCoords}));
      }
    `;
  }
}
function getSourceCoords$1(aShape, axis) {
  const currentCoords = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"];
  const sourceCoords = [];
  for (let i2 = 0; i2 < aShape.length; i2++) {
    if (i2 === 2) {
      sourceCoords.push("index");
    } else {
      sourceCoords.push(`${currentCoords[i2]}`);
    }
  }
  return sourceCoords.join();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function gatherV2$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, indices } = inputs;
  const { axis, batchDims } = attrs;
  const parsedAxis = parseAxisParam(axis, x2.shape)[0];
  if (env().get("DEBUG")) {
    const indicesVals = backend2.readSync(indices.dataId);
    const axisDim = x2.shape[parsedAxis];
    for (let i2 = 0; i2 < indicesVals.length; ++i2) {
      const index2 = indicesVals[i2];
      assert$1(index2 <= axisDim - 1 && index2 >= 0, () => `GatherV2: the index value ${index2} is not in [0, ${axisDim - 1}]`);
    }
  }
  const shapeInfo = collectGatherOpShapeInfo(x2, indices, parsedAxis, batchDims);
  const indicesSize = sizeFromShape(indices.shape);
  const toDispose = [];
  const flattenX = reshape$1({
    inputs: { x: x2 },
    backend: backend2,
    attrs: {
      shape: [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        shapeInfo.dimSize,
        shapeInfo.sliceSize
      ]
    }
  });
  const flattenIndex = reshape$1({
    inputs: { x: indices },
    backend: backend2,
    attrs: { shape: [shapeInfo.batchSize, indicesSize / shapeInfo.batchSize] }
  });
  toDispose.push(flattenX);
  toDispose.push(flattenIndex);
  const flattenOutputShape = [
    shapeInfo.batchSize,
    shapeInfo.outerSize,
    indicesSize / shapeInfo.batchSize,
    shapeInfo.sliceSize
  ];
  if (backend2.shouldExecuteOnCPU([x2, indices]) || x2.dtype === "string") {
    const indicesBuf = backend2.bufferSync(flattenIndex);
    const xBuf = backend2.bufferSync(flattenX);
    const outBuf = gatherV2ImplCPU(xBuf, indicesBuf, flattenOutputShape);
    toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
    return backend2.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
  }
  const program = new GatherProgram(flattenX.shape, flattenOutputShape);
  const res = backend2.runWebGLProgram(program, [flattenX, flattenIndex], flattenX.dtype);
  toDispose.push(res);
  const reshaped = reshape$1({ inputs: { x: res }, backend: backend2, attrs: { shape: shapeInfo.outputShape } });
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return reshaped;
}
const gatherV2Config$1 = {
  kernelName: GatherV2,
  backendName: "webgl",
  kernelFunc: gatherV2$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const GREATER = `return float(a > b);`;
const GREATER_PACKED = `
  return vec4(greaterThan(a, b));
`;
const greater = binaryKernelFunc({
  opSnippet: GREATER,
  packedOpSnippet: GREATER_PACKED,
  cpuKernelImpl: greaterImplCPU,
  dtype: "bool"
});
const greaterConfig$1 = {
  kernelName: Greater,
  backendName: "webgl",
  kernelFunc: greater
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const GREATER_EQUAL = `return float(a >= b);`;
const GREATER_EQUAL_PACKED = `
  return vec4(greaterThanEqual(a, b));
`;
const greaterEqual = binaryKernelFunc({
  opSnippet: GREATER_EQUAL,
  packedOpSnippet: GREATER_EQUAL_PACKED,
  dtype: "bool",
  cpuKernelImpl: greaterEqualImplCPU
});
const greaterEqualConfig$1 = {
  kernelName: GreaterEqual,
  backendName: "webgl",
  kernelFunc: greaterEqual
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function ifft(args) {
  const { inputs, backend: backend2 } = args;
  const { input } = inputs;
  return fftImpl(input, true, backend2);
}
const ifftConfig = {
  kernelName: IFFT,
  backendName: "webgl",
  kernelFunc: ifft
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const IS_FINITE = `return float(!isnan(x) && !isinf(x));`;
const isFinite$1 = unaryKernelFunc({ opSnippet: IS_FINITE, dtype: "bool" });
const isFiniteConfig = {
  kernelName: IsFinite,
  backendName: "webgl",
  kernelFunc: isFinite$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const IS_INF = `return float(isinf(x));`;
const isInf = unaryKernelFunc({ opSnippet: IS_INF, dtype: "bool" });
const isInfConfig = {
  kernelName: IsInf,
  backendName: "webgl",
  kernelFunc: isInf
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const IS_NAN = `return float(isnan(x));`;
const isNaN$1 = unaryKernelFunc({ opSnippet: IS_NAN, dtype: "bool" });
const isNaNConfig = {
  kernelName: IsNan,
  backendName: "webgl",
  kernelFunc: isNaN$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LESS = `return float(a < b);`;
const LESS_PACKED = `
  return vec4(lessThan(a, b));
`;
const less = binaryKernelFunc({
  opSnippet: LESS,
  packedOpSnippet: LESS_PACKED,
  cpuKernelImpl: lessImplCPU,
  dtype: "bool"
});
const lessConfig$1 = {
  kernelName: Less,
  backendName: "webgl",
  kernelFunc: less
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LESS_EQUAL = `return float(a <= b);`;
const LESS_EQUAL_PACKED = `
  return vec4(lessThanEqual(a, b));
`;
const lessEqual = binaryKernelFunc({
  opSnippet: LESS_EQUAL,
  packedOpSnippet: LESS_EQUAL_PACKED,
  cpuKernelImpl: lessEqualImplCPU,
  dtype: "bool"
});
const lessEqualConfig$1 = {
  kernelName: LessEqual,
  backendName: "webgl",
  kernelFunc: lessEqual
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function linSpace(args) {
  const { backend: backend2, attrs } = args;
  const { start, stop, num } = attrs;
  const outVals = linSpaceImplCPU(start, stop, num);
  return backend2.makeTensorInfo([outVals.length], "float32", outVals);
}
const linSpaceConfig = {
  kernelName: LinSpace,
  backendName: "webgl",
  kernelFunc: linSpace
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LOG = CHECK_NAN_SNIPPET_UNARY + `
  return x < 0.0 ? 0./0. : log(x);
`;
const LOG_PACKED = `
  vec4 result = log(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);
  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);
  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);
  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);
  return result;
`;
const log$5 = unaryKernelFunc({ opSnippet: LOG, packedOpSnippet: LOG_PACKED, cpuKernelImpl: logImplCPU });
const logConfig$1 = {
  kernelName: Log,
  backendName: "webgl",
  kernelFunc: log$5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LOG1P = CHECK_NAN_SNIPPET_UNARY + `
  return log(1.0 + x);
`;
const log1p = unaryKernelFunc({ opSnippet: LOG1P });
const log1pConfig = {
  kernelName: Log1p,
  backendName: "webgl",
  kernelFunc: log1p
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LOGICAL_AND = `return float(a >= 1.0 && b >= 1.0);`;
const LOGICAL_AND_PACKED = `
  return vec4(
    vec4(greaterThanEqual(a, vec4(1.0))) *
    vec4(greaterThanEqual(b, vec4(1.0))));
`;
const logicalAnd = binaryKernelFunc({
  opSnippet: LOGICAL_AND,
  packedOpSnippet: LOGICAL_AND_PACKED,
  dtype: "bool"
});
const logicalAndConfig$1 = {
  kernelName: LogicalAnd,
  backendName: "webgl",
  kernelFunc: logicalAnd
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LOGICAL_NOT = `return float(!(x >= 1.0));`;
const logicalNot = unaryKernelFunc({ opSnippet: LOGICAL_NOT });
const logicalNotConfig = {
  kernelName: LogicalNot,
  backendName: "webgl",
  kernelFunc: logicalNot
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const LOGICAL_OR = `return float(a >= 1.0 || b >= 1.0);`;
const LOGICAL_OR_PACKED = `
  return min(
    vec4(greaterThanEqual(a, vec4(1.0))) +
    vec4(greaterThanEqual(b, vec4(1.0))),
    vec4(1.0));
`;
const logicalOr = binaryKernelFunc({ opSnippet: LOGICAL_OR, packedOpSnippet: LOGICAL_OR_PACKED, dtype: "bool" });
const logicalOrConfig = {
  kernelName: LogicalOr,
  backendName: "webgl",
  kernelFunc: logicalOr
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class LRNProgram {
  constructor(xShape, radius, bias, alpha2, beta) {
    this.variableNames = ["x"];
    this.outputShape = [];
    const rad = radius;
    const maxD = xShape[3] - 1;
    this.outputShape = xShape;
    let powOperator;
    const basis = `float(${bias}) + float(${alpha2}) * sum`;
    if (beta === 0.5) {
      powOperator = `inversesqrt(${basis})`;
    } else if (beta === 1) {
      powOperator = `1.0/(${basis})`;
    } else {
      powOperator = `exp(log(${basis}) * float(-${beta}));`;
    }
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];
        int d = coords[3];
        float x = getX(b, r, c, d);
        float sum = 0.0;
        for (int j = -${rad}; j <= ${rad}; j++) {
          int idx = d + j;
          if (idx >= 0 && idx <=  ${maxD}) {
            float z = getX(b, r, c, idx);
            sum += z * z;
          }
        }
        float val = x * ${powOperator};
        setOutput(val);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class LRNPackedProgram {
  constructor(xShape, radius, bias, alpha2, beta) {
    this.variableNames = ["x"];
    this.outputShape = [];
    this.packedInputs = true;
    this.packedOutput = true;
    const rad = radius;
    const maxD = xShape[3] - 1;
    this.outputShape = xShape;
    let powOperator;
    const basis = `float(${bias}) + float(${alpha2}) * sum`;
    if (beta === 0.5) {
      powOperator = `inversesqrt(${basis})`;
    } else if (beta === 1) {
      powOperator = `1.0/(${basis})`;
    } else {
      powOperator = `exp(log(${basis}) * float(-${beta}));`;
    }
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords.x;
        int r = coords.y;
        int c = coords.z;
        int d = coords.w;

        bool hasNextCol = d < ${this.outputShape[3]};
        bool hasNextRow = c < ${this.outputShape[2]};

        vec4 sum = vec4(0.);
        vec4 xFragAtOutputCoords = getX(b, r, c, d);

        vec4 xAtOutputCoords = vec4(
          getChannel(xFragAtOutputCoords, vec2(c, d)),
          hasNextCol ?
            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,
          hasNextRow ?
            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,
          (hasNextRow && hasNextCol) ?
            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0
        );

        int firstChannel = d - ${rad};
        vec2 cache = vec2(0.);
        if(firstChannel >= 0){
          vec4 firstChannelFrag = getX(b, r, c, firstChannel);
          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));
            if(hasNextRow){
              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));
            }
        }

        ivec2 depth = ivec2(d, d + 1);
        for (int j = - ${rad}; j <= ${rad}; j++) {
          ivec2 idx = depth + j;
          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));
          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${maxD}));

          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;
          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;

          if(depthInRange || depthPlusOneInRange){
            vec4 z = vec4(0.);
            vec4 xFragAtCurrentDepth;
            z.xz = cache.xy;
            if(depthPlusOneInRange && hasNextCol){
              xFragAtCurrentDepth = idx.y != d ?
                getX(b, r, c, idx.y) : xFragAtOutputCoords;
              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));
              if(hasNextRow){
                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));
              }
            }
            cache.xy = z.yw;
            sum += z * z;
          }
        }
        vec4 result = xAtOutputCoords * ${powOperator};
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const lrn = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { depthRadius, bias, alpha: alpha2, beta } = attrs;
  const program = env().getBool("WEBGL_PACK_NORMALIZATION") ? new LRNPackedProgram(x2.shape, depthRadius, bias, alpha2, beta) : new LRNProgram(x2.shape, depthRadius, bias, alpha2, beta);
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
};
const LRNConfig = {
  kernelName: LRN,
  backendName: "webgl",
  kernelFunc: lrn
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class LRNGradProgram {
  constructor(inputShape, depthRadius, bias, alpha2, beta) {
    this.variableNames = ["inputImage", "outputImage", "dy"];
    this.outputShape = [];
    this.outputShape = inputShape;
    this.depth = inputShape[3];
    this.depthRadius = depthRadius;
    this.bias = bias;
    this.alpha = alpha2;
    this.beta = beta;
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];

        float result = 0.0;
        for (int d = 0; d < ${this.depth}; ++d) {
          int depthBegin = int(max(0.0, float(d - ${depthRadius})));
          int depthEnd = int(min(float(${this.depth}),
              float(d + ${depthRadius} + 1)));

          const int MIN_DEPTH_BEGIN = 0;
          const int MAX_DEPTH_END = ${this.depth};

          float norm = 0.0;
          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            }
            else {
              break;
            }
          }

          norm = float(${alpha2}) * norm + float(${bias});

          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd){
              float dyi = -2.0 * float(${alpha2})
                * float(${beta})
                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)
                / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * ${beta});
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            }
            else {
              break;
            }
          }
      }
      setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const lrnGrad = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, y: y2, dy } = inputs;
  const { depthRadius, bias, alpha: alpha2, beta } = attrs;
  const program = new LRNGradProgram(x2.shape, depthRadius, bias, alpha2, beta);
  return backend2.runWebGLProgram(program, [x2, y2, dy], x2.dtype);
};
const LRNGradConfig = {
  kernelName: LRNGrad,
  backendName: "webgl",
  kernelFunc: lrnGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxImpl(x2, reduceShape, outShape, backend2) {
  const inSize = sizeFromShape(reduceShape);
  const xSize = sizeFromShape(x2.shape);
  const batchSize = xSize / inSize;
  const reshapedInput = reshape$1({ inputs: { x: x2 }, attrs: { shape: [batchSize, inSize] }, backend: backend2 });
  const reduced = reduce(reshapedInput, x2.dtype, "max", backend2);
  const reshapedOutput = reshape$1({ inputs: { x: reduced }, attrs: { shape: outShape }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(reshapedInput);
  backend2.disposeIntermediateTensorInfo(reduced);
  return reshapedOutput;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function max$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { reductionIndices, keepDims } = attrs;
  const xRank = x2.shape.length;
  const origAxes = parseAxisParam(reductionIndices, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  const maxInputIsTransposed = permutedAxes != null;
  const shouldExecuteOnCPU = backend2.shouldExecuteOnCPU([x2]);
  let maxInput = x2;
  if (maxInputIsTransposed) {
    if (shouldExecuteOnCPU) {
      const xTexData = backend2.texData.get(maxInput.dataId);
      const values = xTexData.values;
      const newShape = new Array(xRank);
      for (let i2 = 0; i2 < newShape.length; i2++) {
        newShape[i2] = x2.shape[permutedAxes[i2]];
      }
      const maxInputValues = transposeImplCPU(values, x2.shape, x2.dtype, permutedAxes, newShape);
      maxInput = backend2.makeTensorInfo(newShape, x2.dtype);
      const maxInputData = backend2.texData.get(maxInput.dataId);
      maxInputData.values = maxInputValues;
    } else {
      maxInput = transposeImpl(x2, permutedAxes, backend2);
    }
    axes = getInnerMostAxes(axes.length, xRank);
  }
  assertAxesAreInnerMostDims("max", axes, xRank);
  const [maxOutShape, reduceShape] = computeOutAndReduceShapes(maxInput.shape, axes);
  let outShape = maxOutShape;
  if (keepDims) {
    outShape = expandShapeToKeepDim(maxOutShape, origAxes);
  }
  let out;
  if (shouldExecuteOnCPU) {
    const xTexData = backend2.texData.get(maxInput.dataId);
    const values = xTexData.values;
    const outValues = maxImplCPU(values, sizeFromShape(reduceShape), outShape, x2.dtype);
    out = backend2.makeTensorInfo(outShape, x2.dtype);
    const outData = backend2.texData.get(out.dataId);
    outData.values = outValues;
  } else {
    out = maxImpl(maxInput, reduceShape, outShape, backend2);
  }
  if (maxInputIsTransposed) {
    backend2.disposeIntermediateTensorInfo(maxInput);
  }
  return out;
}
const maxConfig$1 = {
  kernelName: Max,
  backendName: "webgl",
  kernelFunc: max$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const MAXIMUM = CHECK_NAN_SNIPPET$1 + `
  return max(a, b);
`;
const MAXIMUM_PACKED = `
  vec4 result = vec4(max(a, b));
  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));
  ` + CHECK_NAN_SNIPPET + `
  return result;
`;
const maximum = binaryKernelFunc({
  opSnippet: MAXIMUM,
  packedOpSnippet: MAXIMUM_PACKED,
  cpuKernelImpl: maximumImplCPU
});
const maximumConfig$1 = {
  kernelName: Maximum$1,
  backendName: "webgl",
  kernelFunc: maximum
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  assertNotComplex(x2, "maxPool");
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const dilations = 1;
  assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in maxPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode);
  if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && arraysEqual(convInfo.inShape, convInfo.outShape)) {
    return identity$1({ inputs: { x: x2 }, backend: backend2 });
  }
  const maxPoolProgram = new Pool2DProgram(convInfo, "max", false);
  return backend2.runWebGLProgram(maxPoolProgram, [x2], x2.dtype);
}
const maxPoolConfig$1 = {
  kernelName: MaxPool,
  backendName: "webgl",
  kernelFunc: maxPool$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool3d(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { filterSize, strides, pad: pad2, dataFormat, dimRoundingMode } = attrs;
  const dilations = [1, 1, 1];
  const convInfo = computePool3DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode, dataFormat);
  const maxPoolProgram = new Pool3DProgram(convInfo, "max", false);
  return backend2.runWebGLProgram(maxPoolProgram, [x2], x2.dtype);
}
const maxPool3DConfig = {
  kernelName: MaxPool3D,
  backendName: "webgl",
  kernelFunc: maxPool3d
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MaxPool2DBackpropProgram {
  constructor(convInfo) {
    this.variableNames = ["dy", "maxPos"];
    this.outputShape = convInfo.inShape;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const lastIndex = effectiveFilterHeight * effectiveFilterWidth - 1;
    this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
          wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);
            int maxPosValue = ${lastIndex} - int(getMaxPos(b, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            int curPosValue = wR * ${effectiveFilterWidth} + wC;
            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

            dotProd += dyValue * mask;
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
class MaxPool3DBackpropProgram {
  constructor(convInfo) {
    this.variableNames = ["dy", "maxPos"];
    this.outputShape = convInfo.inShape;
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const lastIndex = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1;
    this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
           wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);
              int maxPosValue = ${lastIndex} -
                  int(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              int curPosValue =
                  wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                  wR * ${effectiveFilterWidth} + wC;
              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

              dotProd += dyValue * mask;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPool3DGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input } = inputs;
  const x2 = input;
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const dilations = [1, 1, 1];
  const convInfo = computePool3DInfo(x2.shape, filterSize, strides, dilations, pad2, dimRoundingMode);
  const maxPool3dPositionsProgram = new Pool3DProgram(convInfo, "max", true);
  const maxPool3dPositions2 = backend2.runWebGLProgram(maxPool3dPositionsProgram, [x2], x2.dtype);
  const maxPoolBackpropProgram = new MaxPool3DBackpropProgram(convInfo);
  const result2 = backend2.runWebGLProgram(maxPoolBackpropProgram, [dy, maxPool3dPositions2], x2.dtype);
  backend2.disposeIntermediateTensorInfo(maxPool3dPositions2);
  return result2;
}
const maxPool3DGradConfig = {
  kernelName: MaxPool3DGrad,
  backendName: "webgl",
  kernelFunc: maxPool3DGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPoolGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { dy, input, output: output2 } = inputs;
  const x2 = input;
  assertNotComplex([input, output2], "maxPoolGrad");
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, 1, pad2, dimRoundingMode);
  const getPositions = true;
  const maxPoolPositionsProgram = new Pool2DProgram(convInfo, "max", getPositions);
  const maxPoolPositions2 = backend2.runWebGLProgram(maxPoolPositionsProgram, [x2], x2.dtype);
  const maxPoolBackPropProgram = new MaxPool2DBackpropProgram(convInfo);
  const result2 = backend2.runWebGLProgram(maxPoolBackPropProgram, [dy, maxPoolPositions2], x2.dtype);
  backend2.disposeIntermediateTensorInfo(maxPoolPositions2);
  return result2;
}
const maxPoolGradConfig = {
  kernelName: MaxPoolGrad,
  backendName: "webgl",
  kernelFunc: maxPoolGrad
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function maxPoolWithArgmaxImpl(x2, includeBatchInIndex, convInfo, backend2) {
  let program = new Pool2DProgram(convInfo, "max", false);
  const poolOutput = backend2.runWebGLProgram(program, [x2], "float32");
  program = new Pool2DProgram(convInfo, "max", true, true, includeBatchInIndex);
  const indexOutput = backend2.runWebGLProgram(program, [x2], "float32");
  return [poolOutput, indexOutput];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maxPoolWithArgmaxConfig = {
  kernelName: MaxPoolWithArgmax,
  backendName: "webgl",
  kernelFunc: ({ inputs, attrs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    const { filterSize, strides, pad: pad2, includeBatchInIndex } = attrs;
    const webglBackend = backend2;
    assert$1(x2.shape.length === 4, () => `Error in maxPool: input must be rank 4 but got rank ${x2.shape.length}.`);
    const dilations = [1, 1];
    assert$1(eitherStridesOrDilationsAreOne(strides, dilations), () => `Error in maxPool: Either strides or dilations must be 1. Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = computePool2DInfo(x2.shape, filterSize, strides, dilations, pad2);
    const [result2, indexes] = maxPoolWithArgmaxImpl(x2, includeBatchInIndex, convInfo, webglBackend);
    return [result2, indexes];
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function meanImpl(x2, reduceShape, outShape, backend2) {
  const inSize = sizeFromShape(reduceShape);
  const xSize = sizeFromShape(x2.shape);
  const batchSize = xSize / inSize;
  const reshapedInput = reshape$1({ inputs: { x: x2 }, attrs: { shape: [batchSize, inSize] }, backend: backend2 });
  const reduced = reduce(reshapedInput, "float32", "mean", backend2);
  const reshapedOutput = reshape$1({ inputs: { x: reduced }, attrs: { shape: outShape }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(reshapedInput);
  backend2.disposeIntermediateTensorInfo(reduced);
  return reshapedOutput;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const meanConfig$1 = {
  kernelName: Mean,
  backendName: "webgl",
  kernelFunc: ({ inputs, attrs, backend: backend2 }) => {
    const { x: x2 } = inputs;
    const { keepDims, axis } = attrs;
    const webglBackend = backend2;
    const xRank = x2.shape.length;
    const origAxes = parseAxisParam(axis, x2.shape);
    let axes = origAxes;
    const permutedAxes = getAxesPermutation(axes, xRank);
    const meanInputIsTransposed = permutedAxes != null;
    const shouldExecuteOnCPU = webglBackend.shouldExecuteOnCPU([x2]);
    const intermediates = [];
    let meanInput = x2;
    if (meanInputIsTransposed) {
      if (shouldExecuteOnCPU) {
        const xTexData = webglBackend.texData.get(meanInput.dataId);
        const values = xTexData.values;
        const newShape = new Array(xRank);
        for (let i2 = 0; i2 < newShape.length; i2++) {
          newShape[i2] = x2.shape[permutedAxes[i2]];
        }
        const meanInputValues = transposeImplCPU(values, x2.shape, x2.dtype, permutedAxes, newShape);
        meanInput = webglBackend.makeTensorInfo(newShape, x2.dtype);
        const meanInputData = webglBackend.texData.get(meanInput.dataId);
        meanInputData.values = meanInputValues;
      } else {
        meanInput = transposeImpl(x2, permutedAxes, webglBackend);
      }
      intermediates.push(meanInput);
      axes = getInnerMostAxes(axes.length, xRank);
    }
    assertAxesAreInnerMostDims("sum", axes, xRank);
    const [meanOutShape, reduceShape] = computeOutAndReduceShapes(meanInput.shape, axes);
    let outShape = meanOutShape;
    if (keepDims) {
      outShape = expandShapeToKeepDim(meanOutShape, origAxes);
    }
    const out = meanImpl(meanInput, reduceShape, outShape, webglBackend);
    for (const i2 of intermediates) {
      webglBackend.disposeIntermediateTensorInfo(i2);
    }
    return out;
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function min$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  const xRank = x2.shape.length;
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  let permutedX = x2;
  if (permutedAxes != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, x2.shape.length);
  }
  assertAxesAreInnerMostDims("min", axes, xRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(permutedX.shape, axes);
  const inSize = sizeFromShape(reduceShape);
  const a2D = reshape$1({ inputs: { x: permutedX }, backend: backend2, attrs: { shape: [-1, inSize] } });
  const reduced = reduce(a2D, a2D.dtype, "min", backend2);
  let res;
  if (keepDims) {
    const newShape = expandShapeToKeepDim(outShape, origAxes);
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: newShape } });
  } else {
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: outShape } });
  }
  backend2.disposeIntermediateTensorInfo(a2D);
  backend2.disposeIntermediateTensorInfo(reduced);
  if (permutedAxes != null) {
    backend2.disposeIntermediateTensorInfo(permutedX);
  }
  return res;
}
const minConfig$1 = {
  kernelName: Min,
  backendName: "webgl",
  kernelFunc: min$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const MINIMUM = CHECK_NAN_SNIPPET$1 + `
  return min(a, b);
`;
const MINIMUM_PACKED = `
  vec4 result = vec4(min(a, b));
  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));
  ` + CHECK_NAN_SNIPPET + `
  return result;
`;
const minimum = binaryKernelFunc({
  opSnippet: MINIMUM,
  packedOpSnippet: MINIMUM_PACKED,
  cpuKernelImpl: minimumImplCPU
});
const minimumConfig$1 = {
  kernelName: Minimum$1,
  backendName: "webgl",
  kernelFunc: minimum
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MirrorPadProgram {
  constructor(xShape, paddings, mode2) {
    this.variableNames = ["x"];
    this.outputShape = paddings.map((p2, i2) => p2[0] + xShape[i2] + p2[1]);
    const rank = xShape.length;
    const dtype = getCoordsDataType(rank);
    const start = paddings.map((p2) => p2[0]).join(",");
    const end = paddings.map((p2, i2) => p2[0] + xShape[i2]).join(",");
    const unpackedCoords = ["coords[0]", "coords[1]", "coords[2]", "coords[3]"].slice(0, rank);
    const offset = mode2 === "reflect" ? 0 : 1;
    if (rank === 1) {
      this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start) {
            outC = start * 2 - outC - ${offset};
          } else if(outC >= end) {
            outC = (end - 1) * 2 - outC + ${offset};
          }
          setOutput(getX(outC - start));
        }
      `;
      return;
    }
    this.userCode = `
      ${dtype} start = ${dtype}(${start});
      ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outC = getOutputCoords();
        for (int i = 0; i < ${rank}; i++) {
          if (outC[i] < start[i]) {
            outC[i] = start[i] * 2 - outC[i] - ${offset};
          } else if(outC[i] >= end[i]) {
            outC[i] = (end[i] - 1) * 2 - outC[i] + ${offset};
          }
        }
        ${dtype} coords = outC - start;
        setOutput(getX(${unpackedCoords}));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MirrorPadPackedProgram {
  constructor(xShape, paddings, mode2) {
    this.variableNames = ["x"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = paddings.map((p2, i2) => p2[0] + xShape[i2] + p2[1]);
    const rank = xShape.length;
    const dtype = getCoordsDataType(rank);
    const start = paddings.map((p2) => p2[0]).join(",");
    const end = paddings.map((p2, i2) => p2[0] + xShape[i2]).join(",");
    const coords2 = getChannels("rc", rank);
    const source2 = getChannels("source", rank);
    const cLimit = `${coords2[rank - 1]} < ${this.outputShape[rank - 1]}`;
    const innerDims = rank === 1 ? "source" : `vec2(${source2.slice(-2).join()})`;
    const offset = mode2 === "reflect" ? 0 : 1;
    let mainLoop = "";
    if (rank === 1) {
      const padSetup = `
        ${dtype} source = rc;
        if (source < start) {
          source = start * 2 - source - ${offset};
        } else if (source >= end) {
          source = (end - 1) * 2 - source + ${offset};
        }
        source -= start;
      `;
      mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source2.join()}), ${innerDims});
        ${coords2[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source2.join()}), ${innerDims});
        }
      `;
    } else {
      const padSetup = `
        ${dtype} source = rc;
        ${dtype} lt = ${dtype}(lessThan(source, start));
        ${dtype} gte = ${dtype}(greaterThanEqual(source, end));
        ${dtype} orig = 1 - (lt + gte);
        source = orig * source +
                lt * (start * 2 - source - ${offset}) +
                gte * ((end - 1) * 2 - source + ${offset});
        source -= start;
      `;
      mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source2.join()}), ${innerDims});
        ${coords2[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source2.join()}), ${innerDims});
        }
        rc = outputLoc;
        ${coords2[rank - 2]} += 1;
        if(${coords2[rank - 2]} < ${this.outputShape[rank - 2]}) {
          ${padSetup}
          result[2] = getChannel(getX(${source2.join()}), ${innerDims});
          ${coords2[rank - 1]} += 1;
          if(${cLimit}) {
            ${padSetup}
            result[3] = getChannel(getX(${source2.join()}), ${innerDims});
          }
        }
      `;
    }
    this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const mirrorPadKernelFunc = ({ inputs, backend: backend2, attrs }) => {
  const { x: x2 } = inputs;
  const { paddings, mode: mode2 } = attrs;
  const program = env().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new MirrorPadPackedProgram(x2.shape, paddings, mode2) : new MirrorPadProgram(x2.shape, paddings, mode2);
  const output2 = backend2.runWebGLProgram(program, [x2], x2.dtype);
  return output2;
};
const mirrorPadConfig$1 = {
  kernelName: MirrorPad,
  backendName: "webgl",
  kernelFunc: mirrorPadKernelFunc
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const MOD = `if (b == 0.0) return NAN;
  return mod(a, b);`;
const MOD_PACKED = `
  vec4 result = mod(a, b);
  vec4 isNaN = vec4(equal(b, vec4(0.0)));
  ` + CHECK_NAN_SNIPPET + `
  return result;
`;
const mod = binaryKernelFunc({
  opSnippet: MOD,
  packedOpSnippet: MOD_PACKED
});
const modConfig = {
  kernelName: Mod,
  backendName: "webgl",
  kernelFunc: mod
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class MultinomialProgram {
  constructor(batchSize, numOutcomes, numSamples) {
    this.variableNames = ["probs"];
    this.customUniforms = [{ name: "seed", type: "float" }];
    this.outputShape = [batchSize, numSamples];
    this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];

        float r = random(seed);
        float cdf = 0.0;

        for (int i = 0; i < ${numOutcomes - 1}; i++) {
          cdf += getProbs(batch, i);

          if (r < cdf) {
            setOutput(float(i));
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutput(float(${numOutcomes - 1}));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const DIV = `
if (a == b) {
  return 1.0;
};
return a / b;`;
const DIV_PACKED = `
  // vec4 one = vec4(equal(a, b));
  // return one + (vec4(1.0) - one) * a / b;
  vec4 result = a / b;
  if(a.x == b.x) {
    result.x = 1.;
  }
  if(a.y == b.y) {
    result.y = 1.;
  }
  if(a.z == b.z) {
    result.z = 1.;
  }
  if(a.w == b.w) {
    result.w = 1.;
  }

  return result;
`;
const realDiv = binaryKernelFunc({ opSnippet: DIV, packedOpSnippet: DIV_PACKED, checkOutOfBounds: true });
const realDivConfig$1 = {
  kernelName: RealDiv,
  backendName: "webgl",
  kernelFunc: realDiv
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SUB = "return a - b;";
const sub = binaryKernelFunc({
  opSnippet: SUB,
  packedOpSnippet: SUB,
  supportsComplex: true,
  cpuKernelImpl: subImplCPU
});
const subConfig$1 = {
  kernelName: Sub,
  backendName: "webgl",
  kernelFunc: sub
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function softmax$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { logits } = inputs;
  const { dim } = attrs;
  const axes = parseAxisParam([dim], logits.shape);
  const maxLogit = max$1({
    inputs: { x: logits },
    backend: backend2,
    attrs: { reductionIndices: axes, keepDims: false }
  });
  const expandedShape = expandShapeToKeepDim(maxLogit.shape, axes);
  const maxLogitsReshaped = reshape$1({ inputs: { x: maxLogit }, backend: backend2, attrs: { shape: expandedShape } });
  const a6 = sub({ inputs: { a: logits, b: maxLogitsReshaped }, backend: backend2 });
  const b2 = exp({ inputs: { x: a6 }, backend: backend2 });
  const sumExp = sum$1({ inputs: { x: b2 }, backend: backend2, attrs: { axis: axes, keepDims: false } });
  const sumExpReshaped = reshape$1({ inputs: { x: sumExp }, backend: backend2, attrs: { shape: expandedShape } });
  const res = realDiv({ inputs: { a: b2, b: sumExpReshaped }, backend: backend2 });
  backend2.disposeIntermediateTensorInfo(maxLogit);
  backend2.disposeIntermediateTensorInfo(maxLogitsReshaped);
  backend2.disposeIntermediateTensorInfo(a6);
  backend2.disposeIntermediateTensorInfo(b2);
  backend2.disposeIntermediateTensorInfo(sumExp);
  backend2.disposeIntermediateTensorInfo(sumExpReshaped);
  return res;
}
const softmaxConfig$1 = {
  kernelName: Softmax$2,
  backendName: "webgl",
  kernelFunc: softmax$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function multinomial(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { logits } = inputs;
  const { numSamples, seed, normalized } = attrs;
  const probs = normalized ? logits : softmax$1({ inputs: { logits }, backend: backend2, attrs: { dim: logits.shape.length - 1 } });
  const batchSize = probs.shape[0];
  const numOutcomes = probs.shape[1];
  const program = new MultinomialProgram(batchSize, numOutcomes, numSamples);
  const customValues = [[seed]];
  const res = backend2.runWebGLProgram(program, [probs], "int32", customValues);
  if (!normalized) {
    backend2.disposeIntermediateTensorInfo(probs);
  }
  return res;
}
const multinomialConfig = {
  kernelName: Multinomial,
  backendName: "webgl",
  kernelFunc: multinomial
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const NEG = CHECK_NAN_SNIPPET$2 + `
  return -x;
`;
const NEG_PACKED = `
  vec4 result = -x;
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
function neg(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  if (backend2.shouldExecuteOnCPU([x2])) {
    const xData = backend2.texData.get(x2.dataId);
    const [outValues, newShape] = negImplCPU(xData.values, x2.shape, x2.dtype);
    return backend2.makeTensorInfo(newShape, x2.dtype, outValues);
  }
  let program;
  if (env().getBool("WEBGL_PACK_UNARY_OPERATIONS")) {
    program = new UnaryOpPackedProgram(x2.shape, NEG_PACKED);
  } else {
    program = new UnaryOpProgram(x2.shape, NEG);
  }
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
}
const negConfig$1 = {
  kernelName: Neg,
  backendName: "webgl",
  kernelFunc: neg
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const nonMaxSuppressionV3Impl = nonMaxSuppressionV3Impl$2;
function nonMaxSuppressionV3(args) {
  warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
  const { inputs, backend: backend2, attrs } = args;
  const { boxes, scores } = inputs;
  const { maxOutputSize, iouThreshold, scoreThreshold } = attrs;
  const boxesVals = backend2.readSync(boxes.dataId);
  const scoresVals = backend2.readSync(scores.dataId);
  const { selectedIndices } = nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
  return backend2.makeTensorInfo([selectedIndices.length], "int32", new Int32Array(selectedIndices));
}
const nonMaxSuppressionV3Config$1 = {
  kernelName: NonMaxSuppressionV3,
  backendName: "webgl",
  kernelFunc: nonMaxSuppressionV3
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const nonMaxSuppressionV4Impl = nonMaxSuppressionV4Impl$2;
function nonMaxSuppressionV4$1(args) {
  warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
  const { inputs, backend: backend2, attrs } = args;
  const { boxes, scores } = inputs;
  const { maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize } = attrs;
  const boxesVals = backend2.readSync(boxes.dataId);
  const scoresVals = backend2.readSync(scores.dataId);
  const { selectedIndices, validOutputs } = nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
  return [
    backend2.makeTensorInfo([selectedIndices.length], "int32", new Int32Array(selectedIndices)),
    backend2.makeTensorInfo([], "int32", new Int32Array([validOutputs]))
  ];
}
const nonMaxSuppressionV4Config$1 = {
  kernelName: NonMaxSuppressionV4,
  backendName: "webgl",
  kernelFunc: nonMaxSuppressionV4$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const nonMaxSuppressionV5Impl = nonMaxSuppressionV5Impl$2;
function nonMaxSuppressionV5(args) {
  warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
  const { inputs, backend: backend2, attrs } = args;
  const { boxes, scores } = inputs;
  const { maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma } = attrs;
  const boxesVals = backend2.readSync(boxes.dataId);
  const scoresVals = backend2.readSync(scores.dataId);
  const maxOutputSizeVal = maxOutputSize;
  const iouThresholdVal = iouThreshold;
  const scoreThresholdVal = scoreThreshold;
  const softNmsSigmaVal = softNmsSigma;
  const { selectedIndices, selectedScores } = nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
  return [
    backend2.makeTensorInfo([selectedIndices.length], "int32", new Int32Array(selectedIndices)),
    backend2.makeTensorInfo([selectedScores.length], "float32", new Float32Array(selectedScores))
  ];
}
const nonMaxSuppressionV5Config$1 = {
  kernelName: NonMaxSuppressionV5,
  backendName: "webgl",
  kernelFunc: nonMaxSuppressionV5
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class OneHotProgram {
  constructor(numIndices, depth, onValue, offValue) {
    this.variableNames = ["indices"];
    this.outputShape = [numIndices, depth];
    this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int index = round(getIndices(coords.x));
        setOutput(mix(float(${offValue}), float(${onValue}),
                      float(index == coords.y)));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const oneHot$1 = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { indices } = inputs;
  const { depth, onValue, offValue } = attrs;
  const indicesSize = sizeFromShape(indices.shape);
  const program = new OneHotProgram(indicesSize, depth, onValue, offValue);
  const reshaped = reshape$1({ inputs: { x: indices }, backend: backend2, attrs: { shape: [indicesSize] } });
  const result2 = backend2.runWebGLProgram(program, [reshaped], indices.dtype);
  backend2.disposeIntermediateTensorInfo(reshaped);
  const outShape = [...indices.shape, depth];
  const out = reshape$1({ inputs: { x: result2 }, backend: backend2, attrs: { shape: outShape } });
  backend2.disposeIntermediateTensorInfo(result2);
  return out;
};
const oneHotConfig$1 = {
  kernelName: OneHot,
  backendName: "webgl",
  kernelFunc: oneHot$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function zerosLike$1(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  if (x2.dtype === "complex64") {
    const realPart = real({ inputs: { input: x2 }, backend: backend2 });
    const r2 = zerosLike$1({ inputs: { x: realPart }, backend: backend2 });
    const imagPart = imag({ inputs: { input: x2 }, backend: backend2 });
    const i2 = zerosLike$1({ inputs: { x: imagPart }, backend: backend2 });
    const result2 = complex$1({ inputs: { real: r2, imag: i2 }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(realPart);
    backend2.disposeIntermediateTensorInfo(r2);
    backend2.disposeIntermediateTensorInfo(imagPart);
    backend2.disposeIntermediateTensorInfo(i2);
    return result2;
  } else {
    return fill$1({
      attrs: {
        shape: x2.shape,
        dtype: x2.dtype,
        value: x2.dtype === "string" ? "" : 0
      },
      backend: backend2
    });
  }
}
const zerosLikeConfig$1 = {
  kernelName: ZerosLike,
  backendName: "webgl",
  kernelFunc: zerosLike$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function onesLike$1(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  if (x2.dtype === "string") {
    throw new Error("onesLike is not supported under string dtype");
  } else if (x2.dtype === "complex64") {
    const realPart = real({ inputs: { input: x2 }, backend: backend2 });
    const r2 = onesLike$1({ inputs: { x: realPart }, backend: backend2 });
    const imagPart = imag({ inputs: { input: x2 }, backend: backend2 });
    const i2 = zerosLike$1({ inputs: { x: imagPart }, backend: backend2 });
    const result2 = complex$1({ inputs: { real: r2, imag: i2 }, backend: backend2 });
    backend2.disposeIntermediateTensorInfo(realPart);
    backend2.disposeIntermediateTensorInfo(r2);
    backend2.disposeIntermediateTensorInfo(imagPart);
    backend2.disposeIntermediateTensorInfo(i2);
    return result2;
  } else {
    return fill$1({ attrs: { shape: x2.shape, dtype: x2.dtype, value: 1 }, backend: backend2 });
  }
}
const onesLikeConfig$1 = {
  kernelName: OnesLike,
  backendName: "webgl",
  kernelFunc: onesLike$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pack$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { axis } = attrs;
  if (inputs.length === 1) {
    return expandDims$1({ inputs: { input: inputs[0] }, backend: backend2, attrs: { dim: axis } });
  }
  const shape = inputs[0].shape;
  const dtype = inputs[0].dtype;
  inputs.forEach((t2) => {
    assertShapesMatch(shape, t2.shape, "All tensors passed to stack must have matching shapes");
    assert$1(dtype === t2.dtype, () => "All tensors passed to stack must have matching dtypes");
  });
  const intermediateTensorInfos = [];
  const expandedTensors = inputs.map((t2) => {
    const expandedT = expandDims$1({ inputs: { input: t2 }, backend: backend2, attrs: { dim: axis } });
    intermediateTensorInfos.push(expandedT);
    return expandedT;
  });
  const result2 = concat$1({ inputs: expandedTensors, backend: backend2, attrs: { axis } });
  intermediateTensorInfos.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
}
const packConfig$1 = {
  kernelName: Pack,
  backendName: "webgl",
  kernelFunc: pack$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class PadProgram {
  constructor(xShape, paddings, constantValue) {
    this.variableNames = ["x"];
    this.customUniforms = [{ name: "value", type: "float" }];
    this.outputShape = paddings.map((p2, i2) => p2[0] + xShape[i2] + p2[1]);
    const rank = xShape.length;
    const type = getCoordsDataType(rank);
    const start = paddings.map((p2) => p2[0]).join(",");
    const end = paddings.map((p2, i2) => p2[0] + xShape[i2]).join(",");
    const unpackedCoords = ["coords[0]", "coords[1]", "coords[2]", "coords[3]"].slice(0, rank);
    if (rank === 1) {
      this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start || outC >= end) {
            setOutput(value);
          } else {
            setOutput(getX(outC - start));
          }
        }
      `;
      return;
    }
    this.userCode = `
      ${type} start = ${type}(${start});
      ${type} end = ${type}(${end});

      void main() {
        ${type} outC = getOutputCoords();
        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {
          setOutput(value);
        } else {
          ${type} coords = outC - start;
          setOutput(getX(${unpackedCoords}));
        }
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class PadPackedProgram {
  constructor(xShape, paddings, constantValue) {
    this.variableNames = ["x"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.customUniforms = [{ name: "value", type: "float" }];
    this.outputShape = paddings.map((p2, i2) => p2[0] + xShape[i2] + p2[1]);
    const rank = xShape.length;
    const dtype = getCoordsDataType(rank);
    const start = paddings.map((p2) => p2[0]).join(",");
    const end = paddings.map((p2, i2) => p2[0] + xShape[i2]).join(",");
    const coords2 = getChannels("rc", rank);
    const source2 = getChannels("source", rank);
    const cLimit = `${coords2[rank - 1]} < ${this.outputShape[rank - 1]}`;
    const innerDims = rank === 1 ? "source" : `vec2(${source2.slice(-2).join()})`;
    const componentSetup = [
      `${dtype} rc = outputLoc;`,
      `${coords2[rank - 1]} += 1;
       if(${cLimit}) {
      `,
      rank === 1 ? "" : `}
       rc = outputLoc;
       ${coords2[rank - 2]} += 1;
       if(${coords2[rank - 2]} < ${this.outputShape[rank - 2]}) {`,
      rank === 1 ? "" : `  ${coords2[rank - 1]} += 1;
         if(${cLimit}) {`
    ];
    const paddingArea = rank === 1 ? "rc < start || rc >= end" : "any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))";
    let mainLoop = "";
    for (let i2 = 0, j2 = rank === 1 ? 2 : 4; i2 < j2; i2++) {
      mainLoop += `
        ${componentSetup[i2]}
        if (${paddingArea}) {
          result[${i2}] = float(value);
        } else {
          ${dtype} source = rc - start;
          result[${i2}] = getChannel(getX(${source2.join()}), ${innerDims});
        }
      `;
    }
    mainLoop += rank === 1 ? `} ` : `}}`;
    this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const padV2 = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { paddings, constantValue } = attrs;
  if (sizeFromShape(x2.shape) === 0) {
    const outputShape = paddings.map((p2, i2) => p2[0] + x2.shape[i2] + p2[1]);
    return fill$1({
      backend: backend2,
      attrs: { shape: outputShape, value: constantValue, dtype: x2.dtype }
    });
  }
  const program = env().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new PadPackedProgram(x2.shape, paddings, constantValue) : new PadProgram(x2.shape, paddings, constantValue);
  const customValues = [[constantValue]];
  return backend2.runWebGLProgram(program, [x2], x2.dtype, customValues);
};
const padV2Config$1 = {
  kernelName: PadV2,
  backendName: "webgl",
  kernelFunc: padV2
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const POW = `
  if(a < 0.0 && floor(b) < b){
    return NAN;
  }
  if (b == 0.0) {
    return 1.0;
  }
  return (round(mod(b, 2.0)) != 1) ?
      pow(abs(a), b) : sign(a) * pow(abs(a), b);
`;
const POW_PACKED = `
  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.
  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));
  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);
  vec4 result = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  bvec4 isExpZero = equal(b, vec4(0.0));
  result.r = isExpZero.r ? 1.0 : result.r;
  result.g = isExpZero.g ? 1.0 : result.g;
  result.b = isExpZero.b ? 1.0 : result.b;
  result.a = isExpZero.a ? 1.0 : result.a;

  vec4 isNaN = vec4(lessThan(a, vec4(0.0))) * vec4(lessThan(floor(b), b));
  ` + CHECK_NAN_SNIPPET + `
  return result;
`;
const pow = binaryKernelFunc({ opSnippet: POW, packedOpSnippet: POW_PACKED });
const powConfig$1 = {
  kernelName: Pow,
  backendName: "webgl",
  kernelFunc: pow
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function prod$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, keepDims } = attrs;
  const xRank = x2.shape.length;
  const toDispose = [];
  const origAxes = parseAxisParam(axis, x2.shape);
  let axes = origAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  let permutedX = x2;
  if (permutedAxes != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutedAxes } });
    axes = getInnerMostAxes(axes.length, xRank);
    toDispose.push(permutedX);
  }
  assertAxesAreInnerMostDims("prod", axes, xRank);
  let res;
  if (backend2.shouldExecuteOnCPU([permutedX])) {
    const xVals = backend2.texData.get(permutedX.dataId).values;
    const { outVals, outShape, outDtype } = prodImplCPU(permutedX.shape, permutedX.dtype, xVals, axes);
    res = backend2.makeTensorInfo(outShape, outDtype, outVals);
  } else {
    const [outShape, reduceShape] = computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = sizeFromShape(reduceShape);
    const a2D = reshape$1({ inputs: { x: permutedX }, backend: backend2, attrs: { shape: [-1, inSize] } });
    const outputDType = sumOutType(x2.dtype);
    const reduced = reduce(a2D, outputDType, "prod", backend2);
    res = reshape$1({ inputs: { x: reduced }, backend: backend2, attrs: { shape: outShape } });
    toDispose.push(a2D);
    toDispose.push(reduced);
  }
  if (keepDims) {
    toDispose.push(res);
    const newShape = expandShapeToKeepDim(res.shape, origAxes);
    res = reshape$1({ inputs: { x: res }, backend: backend2, attrs: { shape: newShape } });
  }
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return res;
}
const prodConfig$1 = {
  kernelName: Prod,
  backendName: "webgl",
  kernelFunc: prod$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const range$1 = (args) => {
  const { backend: backend2, attrs } = args;
  const { start, stop, step: step2, dtype } = attrs;
  const values = rangeImplCPU(start, stop, step2, dtype);
  return backend2.makeTensorInfo([values.length], dtype, values);
};
const rangeConfig$1 = {
  kernelName: Range,
  backendName: "webgl",
  kernelFunc: range$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const RECIPROCAL = `return 1.0 / x;`;
const reciprocal = unaryKernelFunc({ opSnippet: RECIPROCAL });
const reciprocalConfig = {
  kernelName: Reciprocal,
  backendName: "webgl",
  kernelFunc: reciprocal
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const RELU = CHECK_NAN_SNIPPET$2 + `
  return (x < 0.0) ? 0.0 : x;
`;
const RELU_PACKED = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const relu = unaryKernelFunc({ opSnippet: RELU, packedOpSnippet: RELU_PACKED });
const reluConfig$1 = {
  kernelName: Relu$1,
  backendName: "webgl",
  kernelFunc: relu
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const RELU6 = CHECK_NAN_SNIPPET$2 + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const RELU6_PACKED = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const relu6 = unaryKernelFunc({ opSnippet: RELU6, packedOpSnippet: RELU6_PACKED });
const relu6Config$1 = {
  kernelName: Relu6$1,
  backendName: "webgl",
  kernelFunc: relu6
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ResizeBilinearProgram {
  constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters) {
    this.variableNames = ["A"];
    this.outputShape = [];
    const [batch, oldHeight, oldWidth, depth] = inputShape;
    this.outputShape = [batch, newHeight, newWidth, depth];
    const effectiveInSize = [
      alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
      alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutSize = [
      alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
      alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    let sourceFracIndexRC;
    if (halfPixelCenters) {
      sourceFracIndexRC = `(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC - vec2(0.5)`;
    } else {
      sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
    }
    this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));
        ivec2 sourceCeilRC = ivec2(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);
        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);
        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);
        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);

        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);

        float top = topLeft + (topRight - topLeft) * fracRC.y;
        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
        float newValue = top + (bottom - top) * fracRC.x;

        setOutput(newValue);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ResizeBilinearPackedProgram {
  constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = [];
    const [batch, oldHeight, oldWidth, depth] = inputShape;
    this.outputShape = [batch, newHeight, newWidth, depth];
    const effectiveInSize = [
      alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
      alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutSize = [
      alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
      alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    let sourceFracIndexRC;
    if (halfPixelCenters) {
      sourceFracIndexRC = `(vec3(yRC) + vec3(0.5)) * effectiveInputOverOutputRatioRC - vec3(0.5)`;
    } else {
      sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
    }
    this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));
        ivec3 sourceCeilRC = ivec3(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        // In parallel, construct four corners for all four components in
        // packed 2x2 cell.
        vec4 topLeft = vec4(
          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 bottomLeft = vec4(
          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 topRight = vec4(
          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec4 bottomRight = vec4(
          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);

        vec4 top = mix(topLeft, topRight, fracRC.yyzz);
        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);
        vec4 newValue = mix(top, bottom, fracRC.x);

        setOutput(newValue);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeBilinear$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images } = inputs;
  const { alignCorners, halfPixelCenters, size } = attrs;
  const [newHeight, newWidth] = size;
  const program = env().getBool("WEBGL_PACK_IMAGE_OPERATIONS") ? new ResizeBilinearPackedProgram(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new ResizeBilinearProgram(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
  return backend2.runWebGLProgram(program, [images], "float32");
}
const resizeBilinearConfig$1 = {
  kernelName: ResizeBilinear,
  backendName: "webgl",
  kernelFunc: resizeBilinear$1
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ResizeBilinearBackpropProgram {
  constructor(dyShape, inputShape, alignCorners) {
    this.variableNames = ["dy"];
    this.outputShape = [];
    this.outputShape = inputShape;
    const [, xHeight, xWidth] = inputShape;
    const [, yHeight, yWidth] = dyShape;
    const effectiveXSize = [
      alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
      alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
      alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
      alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(startRLerp - float(winHeight / 2));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(startCLerp - float(winWidth / 2));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float dxR = float(dyR) * heightScale;
            int topDxRIndex = int(floor(dxR));
            int bottomDxRIndex = int(min(ceil(dxR), ${xHeight - 1}.0));
            float dxRLerp = dxR - float(topDxRIndex);
            float inverseDxRLerp = 1.0 - dxRLerp;

            float dxC = float(dyC) * widthScale;
            int leftDxCIndex = int(floor(dxC));
            int rightDxCIndex = int(min(ceil(dxC), ${xWidth - 1}.0));
            float dxCLerp = dxC - float(leftDxCIndex);
            float inverseDxCLerp = 1.0 - dxCLerp;

            if (r == topDxRIndex && c == leftDxCIndex) {
              // topLeft
              accumulator +=
                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
            }

            if (r == topDxRIndex && c == rightDxCIndex) {
              // topRight
              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
            }

            if (r == bottomDxRIndex && c == leftDxCIndex) {
              // bottomLeft
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
            }

            if (r == bottomDxRIndex && c == rightDxCIndex) {
              // bottomRight
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeBilinearGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images, dy } = inputs;
  const { alignCorners } = attrs;
  const program = new ResizeBilinearBackpropProgram(dy.shape, images.shape, alignCorners);
  return backend2.runWebGLProgram(program, [dy], dy.dtype);
}
const resizeBilinearGradConfig = {
  kernelName: ResizeBilinearGrad,
  backendName: "webgl",
  kernelFunc: resizeBilinearGrad
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ResizeNearestNeighborProgram {
  constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters) {
    this.variableNames = ["A"];
    this.outputShape = [];
    const [batch, oldHeight, oldWidth, depth] = inputShape;
    this.outputShape = [batch, newHeight, newWidth, depth];
    const effectiveInSize = [
      alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
      alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutSize = [
      alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
      alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    const roundBase = alignCorners ? "0.5" : "0.0";
    let sourceFracIndexRC;
    if (halfPixelCenters) {
      sourceFracIndexRC = `max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC, vec2(0.0))`;
    } else {
      sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
    }
    this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec2 sourceNearestRC = ivec2(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));
        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);

        setOutput(newValue);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ResizeNearestNeighborPackedProgram {
  constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters) {
    this.variableNames = ["A"];
    this.packedInputs = true;
    this.packedOutput = true;
    this.outputShape = [];
    const [batch, oldHeight, oldWidth, depth] = inputShape;
    this.outputShape = [batch, newHeight, newWidth, depth];
    const effectiveInSize = [
      alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
      alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutSize = [
      alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
      alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    const roundBase = alignCorners ? "0.5" : "0.0";
    let sourceFracIndexRC;
    if (halfPixelCenters) {
      sourceFracIndexRC = `max((vec3(yRC) + vec3(0.5)) * effectiveInputOverOutputRatioRC, vec3(0.0))`;
    } else {
      sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
    }
    this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec3 sourceNearestRC = ivec3(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        vec4 newValue = vec4(
          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),
          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);

        setOutput(newValue);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeNearestNeighbor(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images } = inputs;
  const { alignCorners, halfPixelCenters, size } = attrs;
  const [newHeight, newWidth] = size;
  const program = env().getBool("WEBGL_PACK_IMAGE_OPERATIONS") ? new ResizeNearestNeighborPackedProgram(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new ResizeNearestNeighborProgram(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
  return backend2.runWebGLProgram(program, [images], images.dtype);
}
const resizeNearestNeighborConfig = {
  kernelName: ResizeNearestNeighbor,
  backendName: "webgl",
  kernelFunc: resizeNearestNeighbor
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ResizeNearestNeigborBackpropProgram {
  constructor(dyShape, inputShape, alignCorners) {
    this.variableNames = ["dy"];
    this.outputShape = [];
    this.outputShape = inputShape;
    const [, xHeight, xWidth] = inputShape;
    const [, yHeight, yWidth] = dyShape;
    const effectiveXSize = [
      alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
      alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
      alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
      alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(floor(startRLerp - float(winHeight / 2)));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(floor(startCLerp - float(winWidth / 2)));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float sourceFracRow =
              float(${effectiveXSize[0]}) *
                (float(dyR) / float(${effectiveYSize[0]}));

            float sourceFracCol =
                float(${effectiveXSize[1]}) *
                  (float(dyC) / float(${effectiveYSize[1]}));

            int sourceNearestRow = int(min(
                float(int(${xHeight}) - 1),
                ${alignCorners} ? float(round(sourceFracRow)) :
                                  float(floor(sourceFracRow))));

            int sourceNearestCol = int(min(
                float(int(${xWidth}) - 1),
                ${alignCorners} ? float(round(sourceFracCol)) :
                                  float(floor(sourceFracCol))));

            if (r == sourceNearestRow && c == sourceNearestCol) {
              accumulator += getDy(b, dyR, dyC, d);
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function resizeNearestNeighborGrad(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { images, dy } = inputs;
  const { alignCorners } = attrs;
  const program = new ResizeNearestNeigborBackpropProgram(dy.shape, images.shape, alignCorners);
  return backend2.runWebGLProgram(program, [dy], dy.dtype);
}
const resizeNearestNeighborGradConfig = {
  kernelName: ResizeNearestNeighborGrad,
  backendName: "webgl",
  kernelFunc: resizeNearestNeighborGrad
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ReverseProgram {
  constructor(xShape, axis) {
    this.variableNames = ["x"];
    const rank = xShape.length;
    if (rank > 4) {
      throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
    }
    this.outputShape = xShape;
    if (rank === 1) {
      this.userCode = `
        void main() {
          int coord = getOutputCoords();
          setOutput(getX(${xShape[0]} - coord - 1));
        }
      `;
      return;
    }
    const getInCoord = (i2) => {
      if (axis.indexOf(i2) !== -1 && xShape[i2] !== 1) {
        return `${xShape[i2]} - coords[${i2}] - 1`;
      }
      return `coords[${i2}]`;
    };
    const inCoords = xShape.map((_24, i2) => getInCoord(i2)).join(",");
    const type = getCoordsDataType(rank);
    this.userCode = `
      void main() {
        ${type} coords = getOutputCoords();
        setOutput(getX(${inCoords}));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ReversePackedProgram {
  constructor(xShape, axis) {
    this.variableNames = ["x"];
    this.packedInputs = true;
    this.packedOutput = true;
    const rank = xShape.length;
    if (rank > 4) {
      throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
    }
    this.outputShape = xShape;
    const channels = getChannels("rc", rank);
    const nextColumn = `${channels[rank - 1]} + 1 < ${this.outputShape[rank - 1]}`;
    const nextRow = `${channels[rank - 2]} + 1 < ${this.outputShape[rank - 2]}`;
    const type = getCoordsDataType(rank);
    if (rank === 1) {
      this.userCode = `
        void main(){
          int rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = getChannel(getX(${xShape[0]} - rc - 1),
            ${xShape[0]} - rc - 1);
          if(${nextColumn}){
              result.g = getChannel(getX(${xShape[0]} - (rc  + 1) - 1),
                ${xShape[0]} - (rc  + 1) - 1);
          }
          setOutput(result);
        }
      `;
    } else {
      this.userCode = `
        void main() {
          ${type} rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = ${getR(channels.slice())};
          if(${nextColumn}){
            result.g = ${getG(channels.slice())};
          }
          if(${nextRow}) {
            result.b = ${getB(channels.slice())};
            if(${nextColumn}) {
              result.a = ${getA(channels.slice())};
            }
          }
          setOutput(result);
        }
    `;
    }
    function getR(channels2) {
      return getChannel(channels2);
    }
    function getG(channels2) {
      channels2[rank - 1] = "(" + channels2[rank - 1] + ` + 1)`;
      return getChannel(channels2);
    }
    function getB(channels2) {
      channels2[rank - 2] = "(" + channels2[rank - 2] + ` + 1)`;
      return getChannel(channels2);
    }
    function getA(channels2) {
      channels2[rank - 1] = "(" + channels2[rank - 1] + ` + 1)`;
      channels2[rank - 2] = "(" + channels2[rank - 2] + ` + 1)`;
      return getChannel(channels2);
    }
    function getChannel(channels2) {
      const inCoordsArray = xShape.map((_24, i2) => getInCoord(i2, channels2));
      const inCoords = inCoordsArray.join(",");
      const innerDims = inCoordsArray.slice(-2).join(",");
      return `getChannel(getX(${inCoords}), vec2(${innerDims}))`;
    }
    function getInCoord(i2, channels1) {
      if (axis.indexOf(i2) !== -1 && xShape[i2] !== 1) {
        return `${xShape[i2]} - ${channels1[i2]} - 1`;
      } else {
        return `${channels1[i2]}`;
      }
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reverse$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { dims } = attrs;
  const xRank = x2.shape.length;
  const $dims = parseAxisParam(dims, x2.shape);
  if (xRank === 0) {
    return identity$1({ inputs: { x: x2 }, backend: backend2 });
  }
  const program = env().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new ReversePackedProgram(x2.shape, $dims) : new ReverseProgram(x2.shape, $dims);
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
}
const reverseConfig$1 = {
  kernelName: Reverse,
  backendName: "webgl",
  kernelFunc: reverse$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class RotateProgram {
  constructor(imageShape, fillValue) {
    this.variableNames = ["Image"];
    this.outputShape = [];
    this.customUniforms = [{ name: "params", type: "vec4" }];
    const imageHeight = imageShape[1];
    const imageWidth = imageShape[2];
    this.outputShape = imageShape;
    let fillSnippet = "";
    if (typeof fillValue === "number") {
      fillSnippet = `float outputValue = ${fillValue.toFixed(2)};`;
    } else {
      fillSnippet = `
        vec3 fill = vec3(${fillValue.join(",")});
        float outputValue = fill[coords[3]];`;
    }
    this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];
          int y = coords[1];
          float coordXFloat = (float(x) - params[0]) * params[3] -
            (float(y) - params[1]) * params[2];
          float coordYFloat = (float(x) - params[0]) * params[2] +
            (float(y) - params[1]) * params[3];
          int coordX = int(round(coordXFloat + params[0]));
          int coordY = int(round(coordYFloat + params[1]));
          ${fillSnippet}
          if(coordX >= 0 && coordX < ${imageWidth} && coordY >= 0 && coordY < ${imageHeight}) {
            outputValue = getImage(coords[0], coordY, coordX, coords[3]);
          }
          setOutput(outputValue);
        }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const rotateWithOffsetConfig$1 = {
  kernelName: RotateWithOffset,
  backendName: "webgl",
  kernelFunc: ({ inputs, attrs, backend: backend2 }) => {
    const { image: image2 } = inputs;
    const { radians, fillValue, center } = attrs;
    const webglBackend = backend2;
    const program = new RotateProgram(image2.shape, fillValue);
    const [centerX, centerY] = getImageCenter(center, image2.shape[1], image2.shape[2]);
    const customValues = [[centerX, centerY, Math.sin(radians), Math.cos(radians)]];
    const output2 = webglBackend.runWebGLProgram(program, [image2], image2.dtype, customValues);
    return output2;
  }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ROUND = `
  // OpenGL ES does not support round function.
  // The algorithm is based on banker's rounding.
  float base = floor(x);
  if ((x - base) < 0.5) {
    return floor(x);
  } else if ((x - base) > 0.5) {
    return ceil(x);
  } else {
    if (mod(base, 2.0) == 0.0) {
      return base;
    } else {
      return base + 1.0;
    }
  }
`;
const round = unaryKernelFunc({ opSnippet: ROUND });
const roundConfig$1 = {
  kernelName: Round,
  backendName: "webgl",
  kernelFunc: round
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const RSQRT = `return inversesqrt(x);`;
const rsqrt = unaryKernelFunc({ opSnippet: RSQRT, cpuKernelImpl: rsqrtImplCPU });
const rsqrtConfig$1 = {
  kernelName: Rsqrt,
  backendName: "webgl",
  kernelFunc: rsqrt
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class ScatterProgram {
  constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true) {
    this.variableNames = ["updates", "indices", "defaultValue"];
    this.outputShape = shape;
    const stridesType = getCoordsDataType(strides.length);
    const dtype = getCoordsDataType(shape.length);
    let indicesString = "";
    if (indicesRank === 1) {
      indicesString = "i";
    } else if (indicesRank === 2) {
      indicesString = "i, j";
    }
    const indicesSnippet = `getIndices(${indicesString})`;
    let updatesString = "";
    if (updatesRank === 1) {
      updatesString = "i";
    } else if (updatesRank === 2) {
      updatesString = "i, coords[1]";
    }
    const updatesSnippet = `getUpdates(${updatesString})`;
    const strideString = sliceDim > 1 ? "strides[j]" : "strides";
    this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          float sum = 0.0;
          bool found = false;
          for (int i = 0; i < ${updateSize}; i++) {
            int flattenedIndex = 0;
            for (int j = 0; j < ${sliceDim}; j++) {
              int index = round(${indicesSnippet});
              flattenedIndex += index * ${strideString};
            }
            if (flattenedIndex == coords[0]) {
              sum += ${updatesSnippet};
              found = true;
            }
          }
          setOutput(mix(getDefaultValue(), sum, float(found)));
        }
      `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function scatterNd$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { indices, updates } = inputs;
  const { shape } = attrs;
  const { sliceRank, numUpdates, sliceSize, strides, outputSize } = calculateShapes(updates, indices, shape);
  const flattenShape = [outputSize / sliceSize, sliceSize];
  if (outputSize === 0) {
    return backend2.makeTensorInfo(shape, indices.dtype);
  }
  const flattenIndices = reshape$1({ inputs: { x: indices }, backend: backend2, attrs: { shape: [numUpdates, sliceRank] } });
  const flattenX = reshape$1({ inputs: { x: updates }, backend: backend2, attrs: { shape: [numUpdates, sliceSize] } });
  const defaultValue = backend2.makeTensorInfo([], "float32", new Float32Array([0]));
  const program = new ScatterProgram(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
  const res = backend2.runWebGLProgram(program, [flattenX, flattenIndices, defaultValue], flattenX.dtype);
  const reshaped = reshape$1({ inputs: { x: res }, backend: backend2, attrs: { shape } });
  backend2.disposeIntermediateTensorInfo(flattenIndices);
  backend2.disposeIntermediateTensorInfo(flattenX);
  backend2.disposeIntermediateTensorInfo(res);
  backend2.disposeIntermediateTensorInfo(defaultValue);
  return reshaped;
}
const scatterNdConfig$1 = {
  kernelName: ScatterNd,
  backendName: "webgl",
  kernelFunc: scatterNd$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class SelectProgram {
  constructor(cRank, shape, rank) {
    this.variableNames = ["c", "a", "b"];
    this.outputShape = shape;
    let cCoords;
    let abCoords;
    if (rank > 4) {
      throw Error(`Where for rank ${rank} is not yet supported`);
    }
    if (rank === 1) {
      abCoords = `resRC`;
      cCoords = `resRC`;
    } else {
      const currentCoords = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"];
      const cCoordVars = [];
      const abCoordVars = [];
      for (let i2 = 0; i2 < shape.length; i2++) {
        abCoordVars.push(`${currentCoords[i2]}`);
        if (i2 < cRank) {
          cCoordVars.push(`${currentCoords[i2]}`);
        }
      }
      cCoords = cCoordVars.join();
      abCoords = abCoordVars.join();
    }
    const dtype = getCoordsDataType(rank);
    this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        float cVal = getC(${cCoords});
        if (cVal >= 1.0) {
          setOutput(getA(${abCoords}));
        } else {
          setOutput(getB(${abCoords}));
        }
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function select$1(args) {
  const { inputs, backend: backend2 } = args;
  const { condition, t: t2, e: e2 } = inputs;
  const program = new SelectProgram(condition.shape.length, t2.shape, t2.shape.length);
  return backend2.runWebGLProgram(program, [condition, t2, e2], upcastType(t2.dtype, e2.dtype));
}
const selectConfig$1 = {
  kernelName: Select$1,
  backendName: "webgl",
  kernelFunc: select$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SELU = `
  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
  // see: https://arxiv.org/abs/1706.02515
  float scaleAlpha = ${SELU_SCALEALPHA};
  float scale = ${SELU_SCALE};
  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);
`;
const selu = unaryKernelFunc({ opSnippet: SELU });
const seluConfig = {
  kernelName: Selu$1,
  backendName: "webgl",
  kernelFunc: selu
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SIGMOID = CHECK_NAN_SNIPPET_UNARY + `
  return 1.0 / (1.0 + exp(-1.0 * x));
`;
const SIGMOID_PACKED = `
  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const sigmoid$1 = unaryKernelFunc({
  opSnippet: SIGMOID,
  packedOpSnippet: SIGMOID_PACKED,
  cpuKernelImpl: sigmoidImplCPU
});
const sigmoidConfig$1 = {
  kernelName: Sigmoid$1,
  backendName: "webgl",
  kernelFunc: sigmoid$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SIGN = `
  if (isnan(x)) { return 0.0; }
  return sign(x);
`;
const sign = unaryKernelFunc({ opSnippet: SIGN });
const signConfig = {
  kernelName: Sign,
  backendName: "webgl",
  kernelFunc: sign
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SIN = CHECK_NAN_SNIPPET_UNARY + `
  return sin(x);
`;
const sin = unaryKernelFunc({ opSnippet: SIN });
const sinConfig$1 = {
  kernelName: Sin,
  backendName: "webgl",
  kernelFunc: sin
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SINH = `
  float e2x = exp(x);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const sinh = unaryKernelFunc({ opSnippet: SINH });
const sinhConfig = {
  kernelName: Sinh,
  backendName: "webgl",
  kernelFunc: sinh
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SOFTPLUS = `
  float epsilon = 1.1920928955078125e-7;
  float threshold = log(epsilon) + 2.0;

  bool too_large = x > -threshold;
  bool too_small = x < threshold;

  float result;
  float exp_x = exp(x);

  if (too_large){
    result = x;
  }
  else if (too_small){
    result = exp_x;
  }
  else{
    result = log(exp_x + 1.0);
  }
  return result;
`;
const softplus = unaryKernelFunc({ opSnippet: SOFTPLUS });
const softplusConfig = {
  kernelName: Softplus$1,
  backendName: "webgl",
  kernelFunc: softplus
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const spaceToBatchND$1 = (args) => {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockShape, paddings } = attrs;
  assert$1(x2.shape.length <= 4, () => "spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
  const prod2 = blockShape.reduce((a6, b2) => a6 * b2);
  const completePaddings = [[0, 0]];
  completePaddings.push(...paddings);
  for (let i2 = 1 + blockShape.length; i2 < x2.shape.length; ++i2) {
    completePaddings.push([0, 0]);
  }
  const toDispose = [];
  const paddedX = padV2({
    inputs: { x: x2 },
    backend: backend2,
    attrs: { paddings: completePaddings, constantValue: 0 }
  });
  const reshapedPaddedShape = getReshaped(paddedX.shape, blockShape, prod2, false);
  const permutedReshapedPaddedPermutation = getPermuted(reshapedPaddedShape.length, blockShape.length, false);
  const flattenShape = getReshapedPermuted(paddedX.shape, blockShape, prod2, false);
  const reshapedPaddedX = reshape$1({ inputs: { x: paddedX }, backend: backend2, attrs: { shape: reshapedPaddedShape } });
  const paddedXT = transpose$1({
    inputs: { x: reshapedPaddedX },
    backend: backend2,
    attrs: { perm: permutedReshapedPaddedPermutation }
  });
  const result2 = reshape$1({ inputs: { x: paddedXT }, backend: backend2, attrs: { shape: flattenShape } });
  toDispose.push(paddedX);
  toDispose.push(reshapedPaddedX);
  toDispose.push(paddedXT);
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
};
const spaceToBatchNDConfig$1 = {
  kernelName: SpaceToBatchND,
  backendName: "webgl",
  kernelFunc: spaceToBatchND$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseFillEmptyRows$1(args) {
  const { inputs, backend: backend2 } = args;
  const { indices, values, denseShape, defaultValue } = inputs;
  if (denseShape.shape.length !== 1) {
    throw new Error(`Dense shape must be a vector, saw:
         ${denseShape.shape}`);
  }
  if (indices.shape.length !== 2) {
    throw new Error(`Indices must be a matrix, saw:
         ${indices.shape}`);
  }
  if (values.shape.length !== 1) {
    throw new Error(`Values must be a vector, saw:
         ${values.shape}`);
  }
  if (defaultValue.shape.length !== 0) {
    throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
  }
  const $indices = backend2.readSync(indices.dataId);
  const $values = backend2.readSync(values.dataId);
  const $denseShape = backend2.readSync(denseShape.dataId);
  const $defaultValue = backend2.readSync(defaultValue.dataId)[0];
  const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = sparseFillEmptyRowsImplCPU($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
  return [
    backend2.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
    backend2.makeTensorInfo([outputIndicesShape[0]], values.dtype, outputValues),
    backend2.makeTensorInfo([emptyRowIndicator.length], "bool", new Uint8Array(emptyRowIndicator.map((value) => Number(value)))),
    backend2.makeTensorInfo([reverseIndexMap.length], indices.dtype, new Int32Array(reverseIndexMap))
  ];
}
const sparseFillEmptyRowsConfig$1 = {
  kernelName: SparseFillEmptyRows,
  backendName: "webgl",
  kernelFunc: sparseFillEmptyRows$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseReshape$1(args) {
  const { inputs, backend: backend2 } = args;
  const { inputIndices, inputShape, newShape } = inputs;
  if (inputIndices.shape.length !== 2) {
    throw new Error(`Input indices should be a matrix but received shape ${inputIndices.shape}`);
  }
  if (inputShape.shape.length !== 1) {
    throw new Error(`Input shape should be a vector but received shape ${inputShape.shape}`);
  }
  if (newShape.shape.length !== 1) {
    throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
  }
  const $inputShape = Array.from(backend2.readSync(inputShape.dataId));
  const $inputIndices = backend2.readSync(inputIndices.dataId);
  const targetShape = Array.from(backend2.readSync(newShape.dataId));
  const [newIndices, indicesShape, outputShape] = sparseReshapeImplCPU($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
  return [
    backend2.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
    backend2.makeTensorInfo([outputShape.length], newShape.dtype, new Int32Array(outputShape))
  ];
}
const sparseReshapeConfig$1 = {
  kernelName: SparseReshape,
  backendName: "webgl",
  kernelFunc: sparseReshape$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentMean$1(args) {
  const { inputs, backend: backend2 } = args;
  const { data: data2, indices, segmentIds } = inputs;
  if (data2.shape.length < 1) {
    throw new Error(`Data should be at least 1 dimensional but received scalar`);
  }
  if (indices.shape.length !== 1) {
    throw new Error(`Indices should be a vector but received shape
              ${indices.shape}`);
  }
  if (segmentIds.shape.length !== 1) {
    throw new Error(`Segment ids should be a vector but received shape
              ${segmentIds.shape}`);
  }
  const $data = backend2.readSync(data2.dataId);
  const $indices = backend2.readSync(indices.dataId);
  const $segmentIds = backend2.readSync(segmentIds.dataId);
  const [outputData, outputDataShape] = sparseSegmentReductionImplCPU($data, data2.shape, data2.dtype, $indices, $segmentIds, true);
  return backend2.makeTensorInfo(outputDataShape, data2.dtype, outputData);
}
const sparseSegmentMeanConfig$1 = {
  kernelName: SparseSegmentMean,
  backendName: "webgl",
  kernelFunc: sparseSegmentMean$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentSum$1(args) {
  const { inputs, backend: backend2 } = args;
  const { data: data2, indices, segmentIds } = inputs;
  if (data2.shape.length < 1) {
    throw new Error(`Data should be at least 1 dimensional but received scalar`);
  }
  if (indices.shape.length !== 1) {
    throw new Error(`Indices should be a vector but received shape
             ${indices.shape}`);
  }
  if (segmentIds.shape.length !== 1) {
    throw new Error(`Segment ids should be a vector but received shape
             ${segmentIds.shape}`);
  }
  const $data = backend2.readSync(data2.dataId);
  const $indices = backend2.readSync(indices.dataId);
  const $segmentIds = backend2.readSync(segmentIds.dataId);
  const [outputData, outputDataShape] = sparseSegmentReductionImplCPU($data, data2.shape, data2.dtype, $indices, $segmentIds);
  return backend2.makeTensorInfo(outputDataShape, data2.dtype, outputData);
}
const sparseSegmentSumConfig$1 = {
  kernelName: SparseSegmentSum,
  backendName: "webgl",
  kernelFunc: sparseSegmentSum$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseToDense(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { sparseIndices, sparseValues, defaultValue } = inputs;
  const { outputShape } = attrs;
  const { sliceRank, numUpdates, strides, outputSize } = calculateShapes(sparseValues, sparseIndices, outputShape);
  const sumDupeIndices = false;
  const program = new ScatterProgram(numUpdates, sliceRank, sparseIndices.shape.length, sparseValues.shape.length, strides, [outputSize, 1], sumDupeIndices);
  const res = backend2.runWebGLProgram(program, [sparseValues, sparseIndices, defaultValue], sparseValues.dtype);
  const reshaped = reshape$1({ inputs: { x: res }, backend: backend2, attrs: { shape: outputShape } });
  backend2.disposeIntermediateTensorInfo(res);
  return reshaped;
}
const sparseToDenseConfig = {
  kernelName: SparseToDense,
  backendName: "webgl",
  kernelFunc: sparseToDense
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function splitV$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { numOrSizeSplits, axis } = attrs;
  const $axis = parseAxisParam(axis, x2.shape)[0];
  const splitSizes = prepareSplitSize(x2, numOrSizeSplits, $axis);
  const xRank = x2.shape.length;
  const begin = new Array(xRank).fill(0);
  const size = x2.shape.slice();
  return splitSizes.map((s2) => {
    const sliceSize = [...size];
    sliceSize[$axis] = s2;
    const sliceT = slice$1({ inputs: { x: x2 }, backend: backend2, attrs: { begin, size: sliceSize } });
    begin[$axis] += s2;
    return sliceT;
  });
}
const splitVConfig$1 = {
  kernelName: SplitV,
  backendName: "webgl",
  kernelFunc: splitV$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SQRT = `return sqrt(x);`;
const sqrt = unaryKernelFunc({ opSnippet: SQRT, packedOpSnippet: SQRT, cpuKernelImpl: sqrtImplCPU });
const sqrtConfig$1 = {
  kernelName: Sqrt,
  backendName: "webgl",
  kernelFunc: sqrt
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SQUARE = `return x * x;`;
const square = unaryKernelFunc({ opSnippet: SQUARE });
const squareConfig$1 = {
  kernelName: Square,
  backendName: "webgl",
  kernelFunc: square
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const SQUARED_DIFFERENCE = "return (a - b) * (a - b);";
const squaredDifference = binaryKernelFunc({ opSnippet: SQUARED_DIFFERENCE, packedOpSnippet: SQUARED_DIFFERENCE });
const squaredDifferenceConfig$1 = {
  kernelName: SquaredDifference,
  backendName: "webgl",
  kernelFunc: squaredDifference
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function step$1({ inputs, attrs, backend: backend2 }) {
  const { x: x2 } = inputs;
  const opSnippet = CHECK_NAN_SNIPPET$2 + `
    return x > 0.0 ? 1.0 : float(${attrs.alpha});
  `;
  const program = new UnaryOpProgram(x2.shape, opSnippet);
  return backend2.runWebGLProgram(program, [x2], x2.dtype);
}
const stepConfig$1 = {
  kernelName: Step,
  backendName: "webgl",
  kernelFunc: step$1
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class StridedSliceProgram {
  constructor(begin, strides, size) {
    this.variableNames = ["x"];
    this.outputShape = size;
    const rank = size.length;
    const inputDtype = getCoordsDataType(size.length);
    const dtype = getCoordsDataType(size.length);
    let newCoords = "";
    if (rank === 1) {
      newCoords = "coords * strides + begin";
    } else {
      let outputAxis = 0;
      newCoords = size.map((_24, i2) => {
        outputAxis++;
        return size.length === 1 ? `coords * strides[${i2}] + begin[${i2}]` : `coords[${outputAxis - 1}] * strides[${i2}] + begin[${i2}]`;
      }).join(",");
    }
    this.userCode = `
      ${inputDtype} begin = ${inputDtype}(${begin});
      ${inputDtype} strides = ${inputDtype}(${strides});

      void main() {
        ${dtype} coords = getOutputCoords();
        setOutput(getX(${newCoords}));
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stridedSlice$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask } = attrs;
  const { finalShapeSparse, finalShape, isIdentity, sliceDim0, isSimpleSlice, begin: $begin, end: $end, strides: $strides } = sliceInfo(x2.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
  let result2;
  if (isIdentity) {
    result2 = reshape$1({ inputs: { x: x2 }, backend: backend2, attrs: { shape: finalShape } });
  } else if (sliceDim0 || isSimpleSlice) {
    assert$1(x2.shape.length >= 1, () => `Input must have rank at least 1, got: ${x2.shape.length}`);
    const size = computeOutShape$3($begin, $end, $strides);
    const sliced = slice$1({ inputs: { x: x2 }, backend: backend2, attrs: { begin: $begin, size } });
    result2 = reshape$1({ inputs: { x: sliced }, backend: backend2, attrs: { shape: finalShape } });
    backend2.disposeIntermediateTensorInfo(sliced);
  } else {
    const shouldExecuteOnCPU = backend2.shouldExecuteOnCPU([x2]);
    if (shouldExecuteOnCPU) {
      const values = backend2.readSync(x2.dataId);
      const xBuf = buffer(x2.shape, x2.dtype, values);
      const resultValues = stridedSliceImplCPU(finalShapeSparse, xBuf, $strides, $begin);
      result2 = backend2.makeTensorInfo(finalShape, x2.dtype, resultValues.values);
    } else {
      const program = new StridedSliceProgram($begin, $strides, finalShapeSparse);
      result2 = backend2.runWebGLProgram(program, [x2], x2.dtype);
    }
  }
  const resultReshaped = reshape$1({ inputs: { x: result2 }, backend: backend2, attrs: { shape: finalShape } });
  backend2.disposeIntermediateTensorInfo(result2);
  return resultReshaped;
}
const stridedSliceConfig$1 = {
  kernelName: StridedSlice,
  backendName: "webgl",
  kernelFunc: stridedSlice$1
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringNGrams(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { separator, nGramWidths, leftPad, rightPad: rightPad2, padWidth, preserveShortSequences } = attrs;
  const { data: data2, dataSplits } = inputs;
  const $data = backend2.readSync(data2.dataId);
  const $dataSplits = backend2.readSync(dataSplits.dataId);
  const [nGrams, nGramsSplits] = stringNGramsImplCPU($data, $dataSplits, separator, nGramWidths, leftPad, rightPad2, padWidth, preserveShortSequences);
  return [
    backend2.makeTensorInfo([nGrams.length], "string", nGrams),
    backend2.makeTensorInfo(dataSplits.shape, "int32", nGramsSplits)
  ];
}
const stringNGramsConfig = {
  kernelName: StringNGrams,
  backendName: "webgl",
  kernelFunc: stringNGrams
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringSplit(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { skipEmpty } = attrs;
  const { input, delimiter } = inputs;
  if (input.dtype !== "string") {
    throw new Error("Input must be of datatype string");
  }
  if (input.shape.length !== 1) {
    throw new Error(`Input must be a vector, got shape: ${input.shape}`);
  }
  if (delimiter.shape.length !== 0) {
    throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
  }
  const $input = backend2.readSync(input.dataId);
  const $delimiter = backend2.readSync(delimiter.dataId)[0];
  const [indices, values, shape] = stringSplitImplCPU($input, $delimiter, skipEmpty);
  const outputSize = values.length;
  return [
    backend2.makeTensorInfo([outputSize, 2], "int32", indices),
    backend2.makeTensorInfo([outputSize], "string", values),
    backend2.makeTensorInfo([2], "int32", new Int32Array(shape))
  ];
}
const stringSplitConfig = {
  kernelName: StringSplit,
  backendName: "webgl",
  kernelFunc: stringSplit
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function stringToHashBucketFast(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { numBuckets } = attrs;
  const { input } = inputs;
  if (input.dtype !== "string") {
    throw new Error("Input must be of datatype string");
  }
  if (numBuckets <= 0) {
    throw new Error(`Number of buckets must be at least 1`);
  }
  const $input = backend2.readSync(input.dataId);
  const output2 = stringToHashBucketFastImplCPU($input, numBuckets);
  return backend2.makeTensorInfo(input.shape, "int32", output2);
}
const stringToHashBucketFastConfig = {
  kernelName: StringToHashBucketFast,
  backendName: "webgl",
  kernelFunc: stringToHashBucketFast
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const TAN = `return tan(x);`;
const tan = unaryKernelFunc({ opSnippet: TAN });
const tanConfig$1 = {
  kernelName: Tan,
  backendName: "webgl",
  kernelFunc: tan
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const TANH = `
  float e2x = exp(-2.0 * abs(x));
  return sign(x) * (1.0 - e2x) / (1.0 + e2x);
`;
const tanh = unaryKernelFunc({ opSnippet: TANH });
const tanhConfig$1 = {
  kernelName: Tanh$1,
  backendName: "webgl",
  kernelFunc: tanh
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TileProgram {
  constructor(aShape, reps) {
    this.variableNames = ["A"];
    const outputShape = new Array(aShape.length);
    for (let i2 = 0; i2 < outputShape.length; i2++) {
      outputShape[i2] = aShape[i2] * reps[i2];
    }
    this.outputShape = outputShape;
    this.rank = outputShape.length;
    const dtype = getCoordsDataType(this.rank);
    const sourceCoords = getSourceCoords(aShape);
    this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        setOutput(getA(${sourceCoords}));
      }
    `;
  }
}
function getSourceCoords(aShape) {
  const rank = aShape.length;
  if (rank > 5) {
    throw Error(`Tile for rank ${rank} is not yet supported`);
  }
  if (rank === 1) {
    return `imod(resRC, ${aShape[0]})`;
  }
  const currentCoords = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u"];
  const sourceCoords = [];
  for (let i2 = 0; i2 < aShape.length; i2++) {
    sourceCoords.push(`imod(${currentCoords[i2]}, ${aShape[i2]})`);
  }
  return sourceCoords.join();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function tile$1(params) {
  const { inputs, backend: backend2, attrs } = params;
  const { x: x2 } = inputs;
  const { reps } = attrs;
  if (x2.dtype === "string" || x2.shape.length > 5) {
    const data2 = backend2.readSync(x2.dataId);
    const value = x2.dtype === "string" ? data2.map((d2) => decodeString(d2)) : data2;
    const buf = buffer(x2.shape, x2.dtype, value);
    const outBuf = tileImplCPU(buf, reps);
    return backend2.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
  }
  const program = new TileProgram(x2.shape, reps);
  const output2 = backend2.runWebGLProgram(program, [x2], x2.dtype);
  return output2;
}
const tileConfig$1 = {
  kernelName: Tile,
  backendName: "webgl",
  kernelFunc: tile$1
};
class SwapProgram {
  constructor(shape) {
    this.variableNames = ["x", "indices"];
    this.customUniforms = [
      { name: "n", type: "int" },
      { name: "firstPass", type: "int" },
      { name: "negativeInf", type: "float" },
      { name: "dir", type: "int" },
      { name: "inc", type: "int" }
    ];
    this.outputShape = shape;
    this.userCode = `
       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // We compare elements pair-wise within a group of size 2 * inc.
         // The comparing rule for each group alternates between ascending
         // and descending. Within each group, we compare each pair at
         // positions i and i+inc. To decide whether an element at position i
         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
         // inc, it is in the first half of the group, we denote it as x0,
         // otherwise we denote it as x1.
         // For example, as shown in the Bitonic top K paper referenced above,
         // Figure5(a) shows that element[1] is in the
         // second half of the group when group size is 2, but it is in the
         // first half of the group when group size is 4.

         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;
         int i = isFirstInPair ? elemIdx : elemIdx - inc;

         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));
         float x0 = i0 < n ? getX(batch, i0) : negativeInf;
         float x1 = i1 < n ? getX(batch, i1) : negativeInf;

         // Denotes which direction indices are in (ascending or descending).
         bool reverse = imod(elemIdx, 2 * dir) >= dir;
         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
         if (reverse == isGreater) { // Elements in opposite order of direction
           int iTemp = i0;
           i0 = i1;
           i1 = iTemp;
         }
         if (isFirstInPair) {
            setOutput(float(i0));
         } else {
            setOutput(float(i1));
         }
       }
     `;
  }
}
class MergeProgram {
  constructor(shape) {
    this.variableNames = ["x", "indices"];
    this.customUniforms = [
      { name: "n", type: "int" },
      { name: "firstPass", type: "int" },
      { name: "k", type: "int" }
    ];
    this.outputShape = shape;
    this.userCode = `
    void main() {
         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // The output size is half of the previous size.
         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),
         // we only need to output the indices at positions |, the indices at
         // positions _ can be thrown away, see Figure5(b) After Phase 2
         // (Merge phase) in the Bitonic Top K paper referenced above.
         // For example, the paper shows we only need to output the orange bars.
         // The output sequence should look like this | | | | | | | |.
         // Because the sequence is halved, to map the output index back
         // to the previous sequence to find the corresponding value,
         // we need to double the index. When we double the index,
         // we basically interpolate a position, so 2i looks like
         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position
         // of each 2k positions by - elemIdx % k. E.g. for output at
         // index 4,5,6,7, we want to get the corresponding element at
         // original index 8,9,10,11, for output at index 8,9,10,11,
         // we want to get the corresponding element at original index
         // 16,17,18,19, so on and so forth.

         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));
         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));

         float x0 = getX(batch, i0);
         float x1 = i1 < n ? getX(batch, i1) : x0;

         setOutput(x0 >= x1 ? float(i0) : float(i1));
       }
     `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function disposeIntermediateTensorInfoOrNull(backend2, tensorInfo) {
  if (tensorInfo !== null) {
    backend2.disposeIntermediateTensorInfo(tensorInfo);
  }
}
function roundUpToPow2(num) {
  let pow2 = 1;
  while (pow2 < num) {
    pow2 *= 2;
  }
  return pow2;
}
function topK(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { k: k3, sorted } = attrs;
  const TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD = env().getNumber("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD");
  const TOPK_K_CPU_HANDOFF_THRESHOLD = env().getNumber("TOPK_K_CPU_HANDOFF_THRESHOLD");
  const xShape = x2.shape;
  const lastDim = xShape[xShape.length - 1];
  if (backend2.shouldExecuteOnCPU([x2]) || lastDim < TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD || k3 > TOPK_K_CPU_HANDOFF_THRESHOLD) {
    const xVals = backend2.readSync(x2.dataId);
    const [allTopKVals, allTopKIndices] = topKImplCPU(xVals, xShape, x2.dtype, k3, sorted);
    return [
      backend2.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
      backend2.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
    ];
  }
  if (k3 === 0) {
    xShape[xShape.length - 1] = 0;
    return [
      backend2.makeTensorInfo(xShape, x2.dtype, []),
      backend2.makeTensorInfo(xShape, "int32", [])
    ];
  }
  if (lastDim === 1) {
    return [
      x2,
      fill$1({ attrs: { shape: xShape, dtype: "int32", value: 0 }, backend: backend2 })
    ];
  }
  const xtexData = backend2.texData.get(x2.dataId);
  const xIsPacked = xtexData !== null && xtexData.isPacked;
  const xUnPacked = xIsPacked ? backend2.unpackTensor(x2) : x2;
  const xSize = sizeFromShape(xShape);
  const batch = xSize / lastDim;
  const x2D = reshape$1({ inputs: { x: xUnPacked }, attrs: { shape: [batch, lastDim] }, backend: backend2 });
  if (xIsPacked) {
    disposeIntermediateTensorInfoOrNull(backend2, xUnPacked);
  }
  const kPow2 = roundUpToPow2(k3);
  const lastDimPow2 = roundUpToPow2(lastDim);
  let indices = null;
  const getInputs = () => indices === null ? [x2D, x2D] : [x2D, indices];
  const runSwap = (dir, inc, shape) => {
    const inputs2 = getInputs();
    const program = new SwapProgram(shape);
    const fistPass = indices === null ? 1 : 0;
    const customValues = [[lastDim], [fistPass], [Number.NEGATIVE_INFINITY], [dir], [inc]];
    const prevIndices2 = indices;
    indices = backend2.runWebGLProgram(program, inputs2, "int32", customValues);
    disposeIntermediateTensorInfoOrNull(backend2, prevIndices2);
  };
  for (let len = 1; len < kPow2; len *= 2) {
    const dir = len * 2;
    for (let inc = len; inc >= 1; inc /= 2) {
      runSwap(dir, inc, [batch, lastDimPow2]);
    }
  }
  for (let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2) {
    const inputs2 = getInputs();
    const mergeProgram = new MergeProgram([batch, indicesSize / 2]);
    const firstPass = indices === null ? 1 : 0;
    const customValues = [[lastDim], [firstPass], [kPow2]];
    const prevIndices2 = indices;
    indices = backend2.runWebGLProgram(mergeProgram, inputs2, "int32", customValues);
    disposeIntermediateTensorInfoOrNull(backend2, prevIndices2);
    const len = kPow2 / 2;
    const dir = len * 2;
    for (let inc = len; inc >= 1; inc /= 2) {
      runSwap(dir, inc, indices.shape);
    }
  }
  let prevIndices = indices;
  indices = slice$1({ inputs: { x: indices }, backend: backend2, attrs: { begin: 0, size: [batch, k3] } });
  disposeIntermediateTensorInfoOrNull(backend2, prevIndices);
  let values = gatherV2$1({ inputs: { x: x2D, indices }, backend: backend2, attrs: { axis: 1, batchDims: 1 } });
  disposeIntermediateTensorInfoOrNull(backend2, x2D);
  const newShape = xShape.slice(0, -1);
  newShape.push(k3);
  prevIndices = indices;
  indices = reshape$1({ inputs: { x: indices }, attrs: { shape: newShape }, backend: backend2 });
  disposeIntermediateTensorInfoOrNull(backend2, prevIndices);
  const prevValues = values;
  values = reshape$1({ inputs: { x: values }, attrs: { shape: newShape }, backend: backend2 });
  disposeIntermediateTensorInfoOrNull(backend2, prevValues);
  return [values, indices];
}
const topKConfig$1 = {
  kernelName: TopK,
  backendName: "webgl",
  kernelFunc: topK
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class TransformProgram {
  constructor(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape) {
    this.variableNames = ["Image", "Transforms"];
    this.outputShape = outShape;
    const interpolationModeId = interpolation === "nearest" ? 1 : 2;
    let fillModeId;
    switch (fillMode) {
      case "constant":
        fillModeId = 1;
        break;
      case "reflect":
        fillModeId = 2;
        break;
      case "wrap":
        fillModeId = 3;
        break;
      case "nearest":
        fillModeId = 4;
        break;
      default:
        fillModeId = 1;
        break;
    }
    this.userCode = `
            float mapCoord(float outCoord, float len) {
              float inCoord = outCoord;
              if(${fillModeId} == 2) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    if (inCoord < sz2) {
                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +
                      inCoord;
                    }
                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    inCoord -= sz2 * float(int(float(inCoord / sz2)));
                    if (inCoord >= len) {
                      inCoord = sz2 - inCoord - 1.0;
                    }
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 3) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord -= len * float(int(float(inCoord / sz)));
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 4) {
                return clamp(outCoord, 0.0, len - 1.0);
              } else {
                return outCoord;
              }
            }

            float readWithFillValue(int batch, int coordY, int coordX,
              int channel) {
              float outputValue;
              if (0 <= coordY && coordY < ${imageHeight} && 0 <= coordX && coordX < ${imageWidth}) {
                  outputValue = getImage(batch, coordY, coordX, channel);
              } else {
                outputValue = float(${fillValue});
              }
              return outputValue;
            }

            void main() {
              ivec4 coords = getOutputCoords();
              float outputValue;
              int batch = coords[0];
              int x = coords[2];
              int y = coords[1];
              int channel = coords[3];
              float xf = float(x);
              float yf = float(y);
              float a1 = getTransforms(batch, 0);
              float a2 = getTransforms(batch, 1);
              float a3 = getTransforms(batch, 2);
              float b1 = getTransforms(batch, 3);
              float b2 = getTransforms(batch, 4);
              float b3 = getTransforms(batch, 5);
              float c1 = getTransforms(batch, 6);
              float c2 = getTransforms(batch, 7);
              float projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = float(${fillValue});
              } else {
                float inX = (a1 * xf + a2 * yf + a3) / projection;
                float inY = (b1 * xf + b2 * yf + b3) / projection;
                float mapX = mapCoord(inX, float(${imageWidth}));
                float mapY = mapCoord(inY, float(${imageHeight}));

                if (${interpolationModeId} == 1) {
                  int coordY = int(round(mapY));
                  int coordX = int(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  float yFloor = floor(mapY);
                  float xFloor = floor(mapX);
                  float yCeil = yFloor + 1.0;
                  float xCeil = xFloor + 1.0;
                  float valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);
                  float valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutput(outputValue);
            }
        `;
  }
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function transform$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { image: image2, transforms } = inputs;
  const { interpolation, fillMode, fillValue, outputShape } = attrs;
  const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
  const [outHeight, outWidth] = outputShape != null ? outputShape : [imageHeight, imageWidth];
  const outShape = [
    batch,
    outHeight,
    outWidth,
    numChannels
  ];
  const program = new TransformProgram(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape);
  return backend2.runWebGLProgram(program, [image2, transforms], "float32");
}
const transformConfig$1 = {
  kernelName: Transform,
  backendName: "webgl",
  kernelFunc: transform$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unique(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { axis } = attrs;
  const { x: x2 } = inputs;
  assertNotComplex(x2, "unique");
  console.warn("WARNING: ", "UI might be locked temporarily as data is being downloaded");
  const values = backend2.readSync(x2.dataId);
  const { outputValues, outputShape, indices } = uniqueImplCPU(values, axis, x2.shape, x2.dtype);
  return [
    backend2.makeTensorInfo(outputShape, x2.dtype, outputValues),
    backend2.makeTensorInfo([indices.length], "int32", indices)
  ];
}
const uniqueConfig = {
  kernelName: Unique,
  backendName: "webgl",
  kernelFunc: unique
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unpack$1(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { value } = inputs;
  let { axis } = attrs;
  if (axis < 0) {
    axis += value.shape.length;
  }
  const x2 = value;
  const xRank = x2.shape.length;
  const num = value.shape[axis];
  const outShape = new Array(xRank - 1);
  let outIndex = 0;
  for (let i2 = 0; i2 < xRank; i2++) {
    if (i2 !== axis) {
      outShape[outIndex++] = x2.shape[i2];
    }
  }
  const toDispose = [];
  const begin = new Array(xRank).fill(0);
  const size = x2.shape.slice();
  size[axis] = 1;
  const res = new Array(num);
  for (let i2 = 0; i2 < res.length; i2++) {
    begin[axis] = i2;
    const sliced = slice$1({ inputs: { x: x2 }, backend: backend2, attrs: { begin, size } });
    const reshaped = reshape$1({ inputs: { x: sliced }, backend: backend2, attrs: { shape: outShape } });
    res[i2] = reshaped;
    toDispose.push(sliced);
  }
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return res;
}
const unpackConfig$1 = {
  kernelName: Unpack,
  backendName: "webgl",
  kernelFunc: unpack$1
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class SegmentOpProgram {
  constructor(segOpInfo, segOpType) {
    this.variableNames = ["x", "segmentIds"];
    const windowSize = segOpInfo.windowSize;
    const batchSize = segOpInfo.batchSize;
    const inSize = segOpInfo.inSize;
    const numSegments = segOpInfo.numSegments;
    const outSize = numSegments * Math.ceil(inSize / windowSize);
    this.outputShape = [batchSize, outSize];
    const initializationValue = "0.0";
    const returnValue = `sumValue`;
    const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
    const windowSizeVec4Remainder = windowSize % 4;
    const updateSnippet = `
        sumValue += dot(values, segFilter);
    `;
    let checkValueOutOfBounds = "";
    if (inSize % windowSize > 0) {
      checkValueOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
    }
    let checkSegmentIdOutOfBounds = "";
    if (inSize % windowSize > 0) {
      checkSegmentIdOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return -1.0;
        }
      `;
    }
    this.userCode = `
      const float initializationValue = ${initializationValue};

      float getValue(int batch, int inIdx) {
        ${checkValueOutOfBounds}
        return getX(batch, inIdx);
      }

      float getSegmentIdAtIndex(int inIdx) {
        ${checkSegmentIdOutOfBounds}
        return getSegmentIds(inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = int(floor(float(outIdx) / float(
          ${numSegments})) * float(${windowSize}));
        int currentSeg = int(mod(float(outIdx), float(${numSegments})));

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            0,
            0,
            0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
              0,
              0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            0
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unsortedSegmentSum(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2, segmentIds } = inputs;
  const { numSegments } = attrs;
  const xRank = x2.shape.length;
  const toDispose = [];
  let axis = 0;
  const permutation = getAxesPermutation([axis], xRank);
  let permutedX = x2;
  if (permutation != null) {
    permutedX = transpose$1({ inputs: { x: x2 }, backend: backend2, attrs: { perm: permutation } });
    toDispose.push(permutedX);
    axis = getInnerMostAxes(1, xRank)[0];
  }
  const outShape = computeOutShape$1(permutedX.shape, axis, numSegments);
  const inSize = sizeFromShape([permutedX.shape[axis]]);
  const a2D = reshape$1({ inputs: { x: permutedX }, backend: backend2, attrs: { shape: [-1, inSize] } });
  toDispose.push(a2D);
  const outputDType = sumOutType(x2.dtype);
  const segOpCompute = (x3, segOpType, segmentIds2, dtype, numSegments2) => {
    const batchSize = x3.shape[0];
    const inSize2 = x3.shape[1];
    const windowSize = segOpComputeOptimalWindowSize(inSize2, numSegments2);
    const segOpInfo = { windowSize, inSize: inSize2, batchSize, numSegments: numSegments2 };
    const program = new SegmentOpProgram(segOpInfo, segOpType);
    const output2 = backend2.compileAndRun(program, [x3, segmentIds2], dtype);
    toDispose.push(output2);
    if (output2.shape[1] === numSegments2) {
      return output2;
    }
    const rangeInfo = range$1({
      backend: backend2,
      attrs: { start: 0, stop: numSegments2, step: 1, dtype: "float32" }
    });
    const tileInfo = tile$1({
      inputs: { x: rangeInfo },
      backend: backend2,
      attrs: { reps: [inSize2 / windowSize] }
    });
    toDispose.push(rangeInfo);
    toDispose.push(tileInfo);
    const result3 = segOpCompute(output2, segOpType, tileInfo, dtype, numSegments2);
    return result3;
  };
  const segOpResult = segOpCompute(a2D, "unsortedSegmentSum", segmentIds, outputDType, numSegments);
  const reshaped = reshape$1({ inputs: { x: segOpResult }, backend: backend2, attrs: { shape: outShape } });
  let result2 = reshaped;
  if (permutation != null) {
    toDispose.push(reshaped);
    const perm = getUndoAxesPermutation(permutation);
    result2 = transpose$1({ inputs: { x: result2 }, backend: backend2, attrs: { perm } });
  }
  toDispose.forEach((t2) => backend2.disposeIntermediateTensorInfo(t2));
  return result2;
}
const unsortedSegmentSumConfig = {
  kernelName: UnsortedSegmentSum,
  backendName: "webgl",
  kernelFunc: unsortedSegmentSum
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const kernelConfigs$1 = [
  _fusedMatMulConfig$1,
  absConfig$1,
  acosConfig,
  acoshConfig,
  addConfig$1,
  addNConfig$1,
  allConfig$1,
  anyConfig$1,
  argMaxConfig$1,
  argMinConfig,
  asinConfig,
  asinhConfig,
  atanConfig,
  atan2Config,
  atanhConfig,
  avgPoolConfig$1,
  avgPool3DConfig,
  avgPool3DGradConfig,
  avgPoolGradConfig,
  batchMatMulConfig$1,
  batchNormConfig,
  batchToSpaceNDConfig$1,
  bincountConfig,
  broadcastArgsConfig,
  castConfig$1,
  ceilConfig$1,
  clipByValueConfig$1,
  complexConfig,
  complexAbsConfig,
  concatConfig$1,
  conv2DConfig$1,
  conv2DBackpropFilterConfig,
  conv2DBackpropInputConfig$1,
  conv3DConfig,
  conv3DBackpropFilterV2Config,
  conv3DBackpropInputConfig,
  cosConfig$1,
  coshConfig$1,
  cropAndResizeConfig$1,
  cumprodConfig$1,
  cumsumConfig$1,
  denseBincountConfig,
  depthToSpaceConfig$1,
  depthwiseConv2dNativeConfig$1,
  depthwiseConv2dNativeBackpropFilterConfig,
  depthwiseConv2dNativeBackpropInputConfig,
  diagConfig,
  dilation2DConfig,
  einsumConfig,
  eluConfig$1,
  eluGradConfig,
  equalConfig$1,
  erfConfig,
  expConfig$1,
  expandDimsConfig$1,
  expm1Config,
  fftConfig,
  fillConfig$1,
  flipLeftRightConfig$1,
  floorConfig$1,
  floorDivConfig$1,
  fromPixelsConfig,
  fusedConv2DConfig$1,
  fusedDepthwiseConv2DConfig$1,
  gatherNdConfig$1,
  gatherV2Config$1,
  greaterConfig$1,
  greaterEqualConfig$1,
  identityConfig$1,
  ifftConfig,
  imagConfig,
  isFiniteConfig,
  isInfConfig,
  isNaNConfig,
  leakyReluConfig$1,
  lessConfig$1,
  lessEqualConfig$1,
  linSpaceConfig,
  logConfig$1,
  log1pConfig,
  logicalAndConfig$1,
  logicalNotConfig,
  logicalOrConfig,
  LRNConfig,
  LRNGradConfig,
  maxConfig$1,
  maximumConfig$1,
  maxPoolConfig$1,
  maxPool3DConfig,
  maxPool3DGradConfig,
  maxPoolGradConfig,
  maxPoolWithArgmaxConfig,
  meanConfig$1,
  minConfig$1,
  minimumConfig$1,
  mirrorPadConfig$1,
  modConfig,
  multinomialConfig,
  multiplyConfig$1,
  negConfig$1,
  nonMaxSuppressionV3Config$1,
  nonMaxSuppressionV4Config$1,
  nonMaxSuppressionV5Config$1,
  notEqualConfig$1,
  oneHotConfig$1,
  onesLikeConfig$1,
  packConfig$1,
  padV2Config$1,
  powConfig$1,
  preluConfig$1,
  prodConfig$1,
  rangeConfig$1,
  realConfig,
  realDivConfig$1,
  reciprocalConfig,
  reluConfig$1,
  relu6Config$1,
  reshapeConfig$1,
  resizeBilinearConfig$1,
  resizeBilinearGradConfig,
  resizeNearestNeighborConfig,
  resizeNearestNeighborGradConfig,
  reverseConfig$1,
  rotateWithOffsetConfig$1,
  roundConfig$1,
  rsqrtConfig$1,
  scatterNdConfig$1,
  selectConfig$1,
  seluConfig,
  sigmoidConfig$1,
  signConfig,
  sinConfig$1,
  sinhConfig,
  sliceConfig$1,
  softmaxConfig$1,
  softplusConfig,
  spaceToBatchNDConfig$1,
  sparseFillEmptyRowsConfig$1,
  sparseReshapeConfig$1,
  sparseSegmentMeanConfig$1,
  sparseSegmentSumConfig$1,
  sparseToDenseConfig,
  splitVConfig$1,
  sqrtConfig$1,
  squareConfig$1,
  squaredDifferenceConfig$1,
  stepConfig$1,
  stridedSliceConfig$1,
  stringNGramsConfig,
  stringSplitConfig,
  stringToHashBucketFastConfig,
  subConfig$1,
  sumConfig$1,
  tanConfig$1,
  tanhConfig$1,
  tileConfig$1,
  topKConfig$1,
  transformConfig$1,
  transposeConfig$1,
  uniqueConfig,
  unpackConfig$1,
  unsortedSegmentSumConfig,
  zerosLikeConfig$1
];
for (const kernelConfig of kernelConfigs$1) {
  registerKernel(kernelConfig);
}
/** @license See the LICENSE file. */
const version = "3.16.0";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
({
  "tfjs-core": version$6,
  "tfjs-backend-cpu": version$2,
  "tfjs-backend-webgl": version$1,
  "tfjs-data": version$3,
  "tfjs-layers": version$5,
  "tfjs-converter": version$4,
  "tfjs": version
});
const IMAGE_SIZE = 160;
async function runFaceModel(model2, src2, clsThreshold = 0.8) {
  engine().startScope();
  const tsImg = await fromPixelsAsync(src2);
  const meanT = tensor3d([104, 117, 123], [1, 1, 3]);
  const max_side = Math.max(tsImg.shape[0], tsImg.shape[1]);
  const scale_factor = IMAGE_SIZE / max_side;
  let resized = tsImg.resizeBilinear([
    scale_factor * tsImg.shape[0],
    scale_factor * tsImg.shape[1]
  ]);
  resized = resized.pad([
    [0, IMAGE_SIZE - resized.shape[0]],
    [0, IMAGE_SIZE - resized.shape[1]],
    [0, 0]
  ]);
  resized = resized.toFloat();
  let normalized = resized.sub(meanT);
  let output2 = model2.execute(normalized.expandDims(0), [
    "StatefulPartitionedCall/functional_1/513/transpose",
    "StatefulPartitionedCall/functional_1/525/transpose",
    "StatefulPartitionedCall/functional_1/537/transpose",
    "StatefulPartitionedCall/functional_1/476/transpose",
    "StatefulPartitionedCall/functional_1/488/transpose",
    "StatefulPartitionedCall/functional_1/500/transpose",
    "StatefulPartitionedCall/functional_1/550/transpose",
    "StatefulPartitionedCall/functional_1/562/transpose",
    "StatefulPartitionedCall/functional_1/574/transpose"
  ]);
  let conf_523 = reshape$3(transpose$3(output2[0], [0, 3, 1, 2]), [1, -1, 2]);
  let conf_535 = reshape$3(transpose$3(output2[1], [0, 3, 1, 2]), [1, -1, 2]);
  let conf_547 = reshape$3(transpose$3(output2[2], [0, 3, 1, 2]), [1, -1, 2]);
  let loc_486 = reshape$3(transpose$3(output2[3], [0, 3, 1, 2]), [1, -1, 4]);
  let loc_498 = reshape$3(transpose$3(output2[4], [0, 3, 1, 2]), [1, -1, 4]);
  let loc_510 = reshape$3(transpose$3(output2[5], [0, 3, 1, 2]), [1, -1, 4]);
  let landm_560 = reshape$3(transpose$3(output2[6], [0, 3, 1, 2]), [1, -1, 10]);
  let landm_572 = reshape$3(transpose$3(output2[7], [0, 3, 1, 2]), [1, -1, 10]);
  let landm_584 = reshape$3(transpose$3(output2[8], [0, 3, 1, 2]), [1, -1, 10]);
  let conf_nosoftmax = concat$3([conf_523, conf_535, conf_547], 1);
  let loc = concat$3([loc_486, loc_498, loc_510], 1);
  let landm = concat$3([landm_560, landm_572, landm_584], 1);
  let raw_loc = loc.dataSync();
  let raw_landms = landm.dataSync();
  let conf = softmax$3(conf_nosoftmax).dataSync();
  let scores = [];
  for (let i0 = 0; i0 < conf.length / 2; ++i0) {
    scores.push(conf[i0 * 2 + 1]);
  }
  let steps2 = [8, 16, 32];
  let min_sizes = [
    [16, 32],
    [64, 128],
    [256, 512]
  ];
  let feature_maps = [];
  for (let x2 in steps2) {
    feature_maps.push([
      Math.ceil(IMAGE_SIZE / steps2[x2]),
      Math.ceil(IMAGE_SIZE / steps2[x2])
    ]);
  }
  let anchors = [];
  for (let k3 = 0; k3 < feature_maps.length; k3++) {
    for (let i0 = 0; i0 < feature_maps[k3][0]; i0++) {
      for (let j0 = 0; j0 < feature_maps[k3][1]; j0++) {
        for (let m2 = 0; m2 < min_sizes[k3].length; m2++) {
          let s_kx = min_sizes[k3][m2] / IMAGE_SIZE;
          let s_ky = min_sizes[k3][m2] / IMAGE_SIZE;
          let dense_cx = (j0 + 0.5) * steps2[k3] / IMAGE_SIZE;
          let dense_cy = (i0 + 0.5) * steps2[k3] / IMAGE_SIZE;
          anchors.push(dense_cx);
          anchors.push(dense_cy);
          anchors.push(s_kx);
          anchors.push(s_ky);
        }
      }
    }
  }
  let variances = [0.1, 0.2];
  let boxes = [];
  let boxesCount = anchors.length / 4;
  for (let i0 = 0; i0 < boxesCount; i0++) {
    boxes.push(anchors[i0 * 4 + 0] + anchors[i0 * 4 + 2] * raw_loc[i0 * 4 + 0] * variances[0]);
    boxes.push(anchors[i0 * 4 + 1] + anchors[i0 * 4 + 3] * raw_loc[i0 * 4 + 1] * variances[0]);
    boxes.push(anchors[i0 * 4 + 2] * Math.exp(raw_loc[i0 * 4 + 2] * variances[1]));
    boxes.push(anchors[i0 * 4 + 3] * Math.exp(raw_loc[i0 * 4 + 3] * variances[1]));
  }
  for (let i0 = 0; i0 < boxesCount; i0++) {
    boxes[i0 * 4 + 0] -= boxes[i0 * 4 + 2] / 2;
    boxes[i0 * 4 + 1] -= boxes[i0 * 4 + 3] / 2;
    boxes[i0 * 4 + 2] += boxes[i0 * 4 + 0];
    boxes[i0 * 4 + 3] += boxes[i0 * 4 + 1];
  }
  for (let i0 = 0; i0 < boxesCount; i0++) {
    boxes[i0 * 4 + 0] *= IMAGE_SIZE;
    boxes[i0 * 4 + 1] *= IMAGE_SIZE;
    boxes[i0 * 4 + 2] *= IMAGE_SIZE;
    boxes[i0 * 4 + 3] *= IMAGE_SIZE;
  }
  const landms = [];
  for (let i0 = 0; i0 < boxesCount; i0++) {
    landms.push(anchors[i0 * 4 + 0] + raw_landms[i0 * 10 + 0] * anchors[i0 * 4 + 2] * variances[0]);
    landms.push(anchors[i0 * 4 + 1] + raw_landms[i0 * 10 + 1] * anchors[i0 * 4 + 3] * variances[0]);
    landms.push(anchors[i0 * 4 + 0] + raw_landms[i0 * 10 + 2] * anchors[i0 * 4 + 2] * variances[0]);
    landms.push(anchors[i0 * 4 + 1] + raw_landms[i0 * 10 + 3] * anchors[i0 * 4 + 3] * variances[0]);
    landms.push(anchors[i0 * 4 + 0] + raw_landms[i0 * 10 + 4] * anchors[i0 * 4 + 2] * variances[0]);
    landms.push(anchors[i0 * 4 + 1] + raw_landms[i0 * 10 + 5] * anchors[i0 * 4 + 3] * variances[0]);
    landms.push(anchors[i0 * 4 + 0] + raw_landms[i0 * 10 + 6] * anchors[i0 * 4 + 2] * variances[0]);
    landms.push(anchors[i0 * 4 + 1] + raw_landms[i0 * 10 + 7] * anchors[i0 * 4 + 3] * variances[0]);
    landms.push(anchors[i0 * 4 + 0] + raw_landms[i0 * 10 + 8] * anchors[i0 * 4 + 2] * variances[0]);
    landms.push(anchors[i0 * 4 + 1] + raw_landms[i0 * 10 + 9] * anchors[i0 * 4 + 3] * variances[0]);
  }
  for (let i0 = 0; i0 < boxesCount; i0++) {
    landms[i0 * 10 + 0] *= IMAGE_SIZE;
    landms[i0 * 10 + 1] *= IMAGE_SIZE;
    landms[i0 * 10 + 2] *= IMAGE_SIZE;
    landms[i0 * 10 + 3] *= IMAGE_SIZE;
    landms[i0 * 10 + 4] *= IMAGE_SIZE;
    landms[i0 * 10 + 5] *= IMAGE_SIZE;
    landms[i0 * 10 + 6] *= IMAGE_SIZE;
    landms[i0 * 10 + 7] *= IMAGE_SIZE;
    landms[i0 * 10 + 8] *= IMAGE_SIZE;
    landms[i0 * 10 + 9] *= IMAGE_SIZE;
  }
  const filtered_boxes = [];
  const filtered_landms = [];
  const filtered_conf = [];
  for (let i0 = 0; i0 < boxesCount; i0++) {
    if (scores[i0] > clsThreshold) {
      filtered_boxes.push([
        boxes[i0 * 4 + 0] / scale_factor,
        boxes[i0 * 4 + 1] / scale_factor,
        boxes[i0 * 4 + 2] / scale_factor,
        boxes[i0 * 4 + 3] / scale_factor
      ]);
      filtered_landms.push([
        landms[i0 * 10 + 0] / scale_factor,
        landms[i0 * 10 + 1] / scale_factor,
        landms[i0 * 10 + 2] / scale_factor,
        landms[i0 * 10 + 3] / scale_factor,
        landms[i0 * 10 + 4] / scale_factor,
        landms[i0 * 10 + 5] / scale_factor,
        landms[i0 * 10 + 6] / scale_factor,
        landms[i0 * 10 + 7] / scale_factor,
        landms[i0 * 10 + 8] / scale_factor,
        landms[i0 * 10 + 9] / scale_factor
      ]);
      filtered_conf.push(scores[i0]);
    }
  }
  let indices;
  try {
    indices = await image$1.nonMaxSuppressionAsync(filtered_boxes, filtered_conf, 1e4, 0.4);
  } catch (e2) {
    engine().endScope();
    return [];
  }
  indices = indices.dataSync();
  let final_boxes = [];
  let final_landmarks = [];
  let final_conf = [];
  for (let i2 = 0; i2 < indices.length; i2++) {
    final_boxes.push(filtered_boxes[indices[i2]]);
    final_landmarks.push(filtered_landms[indices[i2]]);
    final_conf.push(filtered_conf[indices[i2]]);
  }
  engine().endScope();
  const response = [
    {
      topLeft: [filtered_boxes[0][0], filtered_boxes[0][1]],
      bottomRight: [filtered_boxes[0][2], filtered_boxes[0][3]],
      landmarks: final_landmarks[0],
      predictions: final_conf[0]
    }
  ];
  return response;
}
let isSetup = false;
let model;
async function setup$N() {
  if (isSetup)
    return;
  isSetup = true;
}
async function setupFaceModel(modelURL) {
  if (model)
    return;
  model = await loadGraphModel(modelURL);
}
function magicCropFailure(prediction, width2, height2) {
  const ENLARGE_RATIO = 1.2;
  const dEyesX = prediction.landmarks[0] - prediction.landmarks[2];
  const dEyesY = prediction.landmarks[1] - prediction.landmarks[3];
  const eyesDistance = Math.sqrt(dEyesX * dEyesX + dEyesY * dEyesY);
  const fw = eyesDistance / 0.3849;
  const fh = fw;
  const fx = prediction.landmarks[0] - fw * 0.3075;
  const fy = prediction.landmarks[1] - fh * 0.397;
  const nfw = fw * ENLARGE_RATIO;
  const nfh = fh * ENLARGE_RATIO;
  const shift_ratio = (ENLARGE_RATIO - 1) / 2;
  const nfx = fx - fw * shift_ratio;
  const nfy = fy - fh * shift_ratio;
  return nfx < 0 || nfy < 0 || nfx + nfw >= width2 || nfy + nfh >= height2;
}
function formatLandmarks(rawLandmarks, topLeft, size) {
  const [
    rightEyeX,
    rightEyeY,
    leftEyeX,
    leftEyeY,
    noseTipX,
    noseTipY,
    rightMouthX,
    rightMouthY,
    mouthX,
    mouthY
  ] = rawLandmarks;
  return {
    rightEyeX,
    rightEyeY,
    leftEyeX,
    leftEyeY,
    noseTipX,
    noseTipY,
    rightMouthX,
    rightMouthY,
    mouthX,
    mouthY,
    x: topLeft[0],
    y: topLeft[1],
    width: size[0],
    height: size[1]
  };
}
async function detectFace(props) {
  const {
    onNoFace,
    onCapturing,
    onCapture,
    onTooManyFaces,
    onTooClose,
    onCenterFace,
    onFarAway,
    webcam
  } = props;
  await setup$N();
  const canvas = webcam.getCanvas(webcam.video.videoWidth, webcam.video.videoHeight);
  const predictions = await runFaceModel(model, canvas);
  if (predictions.length === 0) {
    onNoFace();
  } else if (predictions.length > 1) {
    onTooManyFaces();
  } else {
    const width2 = webcam.video.videoWidth;
    const height2 = webcam.video.videoHeight;
    const start = predictions[0].topLeft;
    const end = predictions[0].bottomRight;
    const size = [end[0] - start[0], end[1] - start[1]];
    if (magicCropFailure(predictions[0], width2, height2)) {
      onCenterFace();
    } else if (size[0] / width2 > 0.37) {
      onTooClose();
    } else if (size[0] / width2 > 0.25) {
      onCapturing();
      const canvas2 = webcam.getCanvas(webcam.video.videoWidth, webcam.video.videoHeight);
      onCapture(canvas2.toDataURL("image/png").split(",")[1], canvas2.toDataURL("image/png").split(",")[1], formatLandmarks(predictions[0].landmarks, predictions[0].topLeft, size));
    } else {
      onFarAway();
    }
  }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var CppDType;
(function(CppDType2) {
  CppDType2[CppDType2["float32"] = 0] = "float32";
  CppDType2[CppDType2["int32"] = 1] = "int32";
  CppDType2[CppDType2["bool"] = 2] = "bool";
  CppDType2[CppDType2["string"] = 3] = "string";
  CppDType2[CppDType2["complex64"] = 4] = "complex64";
})(CppDType || (CppDType = {}));
var FusableActivation;
(function(FusableActivation2) {
  FusableActivation2[FusableActivation2["linear"] = 0] = "linear";
  FusableActivation2[FusableActivation2["relu"] = 1] = "relu";
  FusableActivation2[FusableActivation2["relu6"] = 2] = "relu6";
  FusableActivation2[FusableActivation2["prelu"] = 3] = "prelu";
  FusableActivation2[FusableActivation2["leakyrelu"] = 4] = "leakyrelu";
  FusableActivation2[FusableActivation2["sigmoid"] = 5] = "sigmoid";
  FusableActivation2[FusableActivation2["elu"] = 6] = "elu";
})(FusableActivation || (FusableActivation = {}));
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFusedMatMul;
function setup$M(backend2) {
  wasmFusedMatMul = backend2.wasm.cwrap(_FusedMatMul, null, [
    "number",
    "array",
    "number",
    "number",
    "array",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function fusedBatchMatMul(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { a: a6, b: b2, bias, preluActivationWeights } = inputs;
  if (a6.dtype !== "float32" || b2.dtype !== "float32") {
    throw new Error(`_FusedMatMul for non non-float32 tensors not yet supported.`);
  }
  const { transposeA, transposeB, activation, leakyreluAlpha } = attrs;
  const aId = backend2.dataIdMap.get(a6.dataId).id;
  const bId = backend2.dataIdMap.get(b2.dataId).id;
  let biasId = 0;
  if (bias != null) {
    const biasData = backend2.dataIdMap.get(bias.dataId);
    if (biasData.shape.length !== 1) {
      throw new Error(`_FusedMatMul only supports rank-1 bias but got rank ${biasData.shape.length}.`);
    }
    biasId = biasData.id;
  }
  const preluActivationWeightsId = preluActivationWeights == null ? 0 : backend2.dataIdMap.get(preluActivationWeights.dataId).id;
  const fusedActivation = FusableActivation[activation];
  if (fusedActivation == null) {
    throw new Error(`${activation} activation not yet supported for FusedConv2D in the wasm backend.`);
  }
  const leftDim = transposeA ? a6.shape[2] : a6.shape[1];
  const rightDim = transposeB ? b2.shape[1] : b2.shape[2];
  const batchDims = assertAndGetBroadcastShape(a6.shape.slice(0, -2), b2.shape.slice(0, -2));
  const out = backend2.makeOutput([...batchDims, leftDim, rightDim], a6.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const aShapeBytes = new Uint8Array(new Int32Array(a6.shape).buffer);
  const bShapeBytes = new Uint8Array(new Int32Array(b2.shape).buffer);
  wasmFusedMatMul(aId, aShapeBytes, a6.shape.length, bId, bShapeBytes, b2.shape.length, transposeA, transposeB, fusedActivation, biasId, preluActivationWeightsId, leakyreluAlpha || 0, outId);
  return out;
}
const _fusedMatMulConfig = {
  kernelName: _FusedMatMul,
  backendName: "wasm",
  setupFunc: setup$M,
  kernelFunc: fusedBatchMatMul
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function createUnaryKernelConfig(kernelName, outType) {
  let wasmFunc2;
  function setupFunc2(backend2) {
    wasmFunc2 = backend2.wasm.cwrap(kernelName, null, [
      "number",
      "number",
      "number"
    ]);
  }
  function kernelFunc2(args) {
    const { backend: backend2, inputs: { x: x2 } } = args;
    const xId = backend2.dataIdMap.get(x2.dataId).id;
    const out = backend2.makeOutput(x2.shape, outType || x2.dtype);
    const outId = backend2.dataIdMap.get(out.dataId).id;
    if (sizeFromShape(out.shape) === 0) {
      return out;
    }
    wasmFunc2(xId, CppDType[x2.dtype], outId);
    return out;
  }
  return { kernelName, backendName: "wasm", setupFunc: setupFunc2, kernelFunc: kernelFunc2 };
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const absConfig = createUnaryKernelConfig(Abs);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function createBinaryKernelConfig(kernelName, supportsFullBroadcast2, dtype) {
  let wasmFunc2;
  function setupFunc2(backend2) {
    wasmFunc2 = backend2.wasm.cwrap(kernelName, null, [
      "number",
      "array",
      "number",
      "number",
      "array",
      "number",
      "number",
      "number"
    ]);
  }
  function kernelFunc2(args) {
    const { backend: backend2, inputs } = args;
    const { a: a6, b: b2 } = inputs;
    const aId = backend2.dataIdMap.get(a6.dataId).id;
    const bId = backend2.dataIdMap.get(b2.dataId).id;
    const outputType = dtype != null ? dtype : a6.dtype;
    const newShape = assertAndGetBroadcastShape(a6.shape, b2.shape);
    const out = backend2.makeOutput(newShape, outputType);
    if (sizeFromShape(newShape) === 0) {
      return out;
    }
    const aShapeBytes = new Uint8Array(new Int32Array(a6.shape).buffer);
    const bShapeBytes = new Uint8Array(new Int32Array(b2.shape).buffer);
    const outId = backend2.dataIdMap.get(out.dataId).id;
    const kernelFunc3 = () => wasmFunc2(aId, aShapeBytes, a6.shape.length, bId, bShapeBytes, b2.shape.length, CppDType[a6.dtype], outId);
    kernelFunc3();
    return out;
  }
  return { kernelName, backendName: "wasm", setupFunc: setupFunc2, kernelFunc: kernelFunc2 };
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const addConfig = createBinaryKernelConfig(Add$1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$7;
function setupFunc$1(backend2) {
  wasmFunc$7 = backend2.wasm.cwrap(AddN, null, [
    "array",
    "number",
    "number",
    "number"
  ]);
}
function addn(args) {
  const { inputs, backend: backend2 } = args;
  const out = backend2.makeOutput(inputs[0].shape, inputs[0].dtype);
  if (sizeFromShape(out.shape) === 0) {
    return out;
  }
  const inputIds = inputs.map((x2) => backend2.dataIdMap.get(x2.dataId).id);
  const inputIdsBytes = new Uint8Array(new Int32Array(inputIds).buffer);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmFunc$7(inputIdsBytes, inputIds.length, CppDType[out.dtype], outId);
  return out;
}
const addNConfig = {
  kernelName: AddN,
  backendName: "wasm",
  setupFunc: setupFunc$1,
  kernelFunc: addn
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function identity(args) {
  const { inputs: { x: x2 }, backend: backend2 } = args;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const inVals = backend2.typedArrayFromHeap(x2);
  const outVals = backend2.typedArrayFromHeap(out);
  outVals.set(inVals);
  return out;
}
const identityConfig = {
  kernelName: Identity$1,
  backendName: "wasm",
  kernelFunc: identity
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmTranspose;
function setup$L(backend2) {
  wasmTranspose = backend2.wasm.cwrap(Transpose, null, [
    "number",
    "array",
    "number",
    "number",
    "number",
    "array",
    "number"
  ]);
}
function transpose(args) {
  const { inputs, backend: backend2, attrs } = args;
  const [reducedShape, perm] = removeOneSizeDims(inputs.x.shape, attrs.perm);
  let permIsNoOp = true;
  for (let i2 = 0; i2 < perm.length; i2++) {
    if (perm[i2] !== i2) {
      permIsNoOp = false;
    }
  }
  const outShape = computeOutShape(inputs.x.shape, attrs.perm);
  const x2 = {
    dataId: inputs.x.dataId,
    shape: reducedShape,
    dtype: inputs.x.dtype
  };
  if (permIsNoOp) {
    const cloned = identity({ inputs, backend: backend2 });
    cloned.shape = outShape;
    return cloned;
  }
  const out = backend2.makeOutput(outShape, x2.dtype);
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const permBytes = new Uint8Array(new Int32Array(perm).buffer);
  const xShapeBytes = new Uint8Array(new Int32Array(x2.shape).buffer);
  wasmTranspose(xId, xShapeBytes, x2.shape.length, CppDType[x2.dtype], outId, permBytes, perm.length);
  return out;
}
function computeOutShape(inShape, perm) {
  const outShape = new Array(inShape.length);
  for (let i2 = 0; i2 < outShape.length; i2++) {
    outShape[i2] = inShape[perm[i2]];
  }
  return outShape;
}
function removeOneSizeDims(shape, perm) {
  const newShape = [];
  const newPerm = [];
  for (let i2 = 0; i2 < shape.length; ++i2) {
    if (shape[i2] !== 1) {
      newShape.push(shape[i2]);
    }
    if (shape[perm[i2]] !== 1) {
      newPerm.push(perm[i2]);
    }
  }
  for (let i2 = 0; i2 < newPerm.length; ++i2) {
    let minValIdx = -1;
    for (let j2 = 0; j2 < newPerm.length; ++j2) {
      if (newPerm[j2] >= i2 && (minValIdx === -1 || newPerm[minValIdx] > newPerm[j2])) {
        minValIdx = j2;
      }
    }
    newPerm[minValIdx] = i2;
  }
  return [newShape, newPerm];
}
const transposeConfig = {
  kernelName: Transpose,
  backendName: "wasm",
  kernelFunc: transpose,
  setupFunc: setup$L
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function permuteAxesAndTranspose(x2, axis, backend2) {
  const xShape = x2.shape;
  const xRank = x2.shape.length;
  const originalAxes = parseAxisParam(axis, xShape);
  let axes = originalAxes;
  const permutedAxes = getAxesPermutation(axes, xRank);
  let xTransposed = null;
  let inputWasTransposed = false;
  if (permutedAxes != null) {
    const newShape = new Array(xRank);
    for (let i2 = 0; i2 < newShape.length; i2++) {
      newShape[i2] = xShape[permutedAxes[i2]];
    }
    axes = getInnerMostAxes(axes.length, xRank);
    xTransposed = transpose({ inputs: { x: x2 }, attrs: { perm: permutedAxes }, backend: backend2 });
    const xId = backend2.dataIdMap.get(x2.dataId).id;
    const transposedId = backend2.dataIdMap.get(xTransposed.dataId).id;
    if (transposedId !== xId) {
      inputWasTransposed = true;
    }
  }
  return { transposed: xTransposed, originalAxes, axes, inputWasTransposed };
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmAll;
function setup$K(backend2) {
  wasmAll = backend2.wasm.cwrap(All, null, ["number, number, number"]);
}
function all(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    input = transposed;
    inputId = transposedId;
  }
  const inputRank = input.shape.length;
  assertAxesAreInnerMostDims("all", axes, inputRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const out = backend2.makeOutput(outShape, x2.dtype);
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmAll(inputId, reduceSize, outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  return out;
}
const allConfig = {
  kernelName: All,
  backendName: "wasm",
  setupFunc: setup$K,
  kernelFunc: all
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmAny;
function setup$J(backend2) {
  wasmAny = backend2.wasm.cwrap(Any, null, ["number, number, number"]);
}
function any(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    input = transposed;
    inputId = transposedId;
  }
  const inputRank = input.shape.length;
  assertAxesAreInnerMostDims("any", axes, inputRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const out = backend2.makeOutput(outShape, x2.dtype);
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmAny(inputId, reduceSize, outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  return out;
}
const anyConfig = {
  kernelName: Any,
  backendName: "wasm",
  setupFunc: setup$J,
  kernelFunc: any
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$6;
function setup$I(backend2) {
  wasmFunc$6 = backend2.wasm.cwrap(ArgMax, null, [
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function argmax(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    if (transposedId !== xId) {
      input = transposed;
      inputId = transposedId;
    }
  }
  const outShape = input.shape.slice(0, -1);
  const out = backend2.makeOutput(outShape, "int32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const outerSize = sizeFromShape(out.shape);
  const innerSize = input.shape[axes[0]];
  wasmFunc$6(inputId, CppDType[input.dtype], outerSize, innerSize, outId);
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  return out;
}
const argMaxConfig = {
  kernelName: ArgMax,
  backendName: "wasm",
  kernelFunc: argmax,
  setupFunc: setup$I
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmAvgPool;
function setup$H(backend2) {
  wasmAvgPool = backend2.wasm.cwrap(AvgPool, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function avgPool(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const x2 = inputs.x;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, 1, pad2, dimRoundingMode);
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const padTop = convInfo.padInfo.top;
  const padRight = convInfo.padInfo.right;
  const padBottom = convInfo.padInfo.bottom;
  const padLeft = convInfo.padInfo.left;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const channels = convInfo.inChannels;
  if (convInfo.dataFormat !== "channelsLast") {
    throw new Error(`wasm backend does not support dataFormat:'${convInfo.dataFormat}'. Please use 'channelsLast'.`);
  }
  if (convInfo.dilationWidth !== 1 || convInfo.dilationHeight !== 1) {
    throw new Error(`was backend only supports average pooling with dilation = [1, 1], got [${convInfo.dilationHeight}, ${convInfo.dilationWidth}].`);
  }
  const out = backend2.makeOutput(convInfo.outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmAvgPool(xId, x2.shape[0], x2.shape[1], x2.shape[2], filterHeight, filterWidth, padTop, padRight, padBottom, padLeft, strideHeight, strideWidth, channels, outId);
  return out;
}
const avgPoolConfig = {
  kernelName: AvgPool,
  backendName: "wasm",
  setupFunc: setup$H,
  kernelFunc: avgPool
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function reshape(args) {
  const { inputs, attrs } = args;
  const { x: x2 } = inputs;
  const { shape } = attrs;
  const xSize = sizeFromShape(x2.shape);
  const $shape = inferFromImplicitShape(shape, xSize);
  assert$1(xSize === sizeFromShape($shape), () => `new shape: ${$shape}, old shape: ${x2.shape}. New shape and old shape must have the same number of elements.`);
  args.backend.incRef(x2.dataId);
  return { dataId: x2.dataId, shape: $shape, dtype: x2.dtype };
}
const reshapeConfig = {
  kernelName: Reshape$1,
  backendName: "wasm",
  kernelFunc: reshape
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmBatchMatMul;
function setup$G(backend2) {
  wasmBatchMatMul = backend2.wasm.cwrap(BatchMatMul, null, [
    "number",
    "array",
    "number",
    "number",
    "array",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function batchMatMul(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { a: a6, b: b2 } = inputs;
  const { transposeA, transposeB } = attrs;
  if (a6.dtype !== "float32" || b2.dtype !== "float32") {
    throw new Error(`BatchMatMul for non non-float32 tensors not yet supported.`);
  }
  const aRank = a6.shape.length;
  const bRank = b2.shape.length;
  const innerShapeA = transposeA ? a6.shape[aRank - 2] : a6.shape[aRank - 1];
  const innerShapeB = transposeB ? b2.shape[bRank - 1] : b2.shape[bRank - 2];
  const outerShapeA = transposeA ? a6.shape[aRank - 1] : a6.shape[aRank - 2];
  const outerShapeB = transposeB ? b2.shape[bRank - 2] : b2.shape[bRank - 1];
  const outerDimsA = a6.shape.slice(0, -2);
  const outerDimsB = b2.shape.slice(0, -2);
  const batchDimA = sizeFromShape(outerDimsA);
  const batchDimB = sizeFromShape(outerDimsB);
  const outShapeOuterDims = assertAndGetBroadcastShape(a6.shape.slice(0, -2), b2.shape.slice(0, -2));
  const outShape = outShapeOuterDims.concat([outerShapeA, outerShapeB]);
  assert$1(innerShapeA === innerShapeB, () => `Error in matMul: inner shapes (${innerShapeA}) and (${innerShapeB}) of Tensors with shapes ${a6.shape} and ${b2.shape} and transposeA=${transposeA} and transposeB=${transposeB} must match.`);
  const a3dShape = transposeA ? [batchDimA, innerShapeA, outerShapeA] : [batchDimA, outerShapeA, innerShapeA];
  const b3dShape = transposeB ? [batchDimB, outerShapeB, innerShapeB] : [batchDimB, innerShapeB, outerShapeB];
  const a3d = reshape({ inputs: { x: a6 }, backend: backend2, attrs: { shape: a3dShape } });
  const b3d = reshape({ inputs: { x: b2 }, backend: backend2, attrs: { shape: b3dShape } });
  const a3dId = backend2.dataIdMap.get(a3d.dataId).id;
  const b3dId = backend2.dataIdMap.get(b3d.dataId).id;
  const leftDim = transposeA ? a3d.shape[2] : a3d.shape[1];
  const rightDim = transposeB ? b3d.shape[1] : b3d.shape[2];
  const batchDim = Math.max(batchDimA, batchDimB);
  const out = backend2.makeOutput([batchDim, leftDim, rightDim], a3d.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const aShapeBytes = new Uint8Array(new Int32Array(a3d.shape).buffer);
  const bShapeBytes = new Uint8Array(new Int32Array(b3d.shape).buffer);
  wasmBatchMatMul(a3dId, aShapeBytes, a3d.shape.length, b3dId, bShapeBytes, b3d.shape.length, transposeA, transposeB, outId);
  backend2.disposeData(a3d.dataId);
  backend2.disposeData(b3d.dataId);
  out.shape = outShape;
  return out;
}
const batchMatMulConfig = {
  kernelName: BatchMatMul,
  backendName: "wasm",
  setupFunc: setup$G,
  kernelFunc: batchMatMul
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function slice(args) {
  const { inputs: { x: x2 }, attrs: { begin, size }, backend: backend2 } = args;
  const [begin_, size_] = parseSliceParams(x2, begin, size);
  const isContinous = isSliceContinous(x2.shape, begin_, size_);
  const xVals = backend2.readSync(x2.dataId);
  const out = backend2.makeOutput(size_, x2.dtype);
  const xStrides = computeStrides(x2.shape);
  const outData = backend2.dataIdMap.get(out.dataId);
  if (isContinous) {
    const flatOffset = computeFlatOffset(begin_, xStrides);
    if (x2.dtype === "string") {
      outData.stringBytes = xVals.slice(flatOffset, flatOffset + sizeFromShape(size_));
    } else {
      const outVals2 = backend2.typedArrayFromHeap(out);
      outVals2.set(xVals.subarray(flatOffset, flatOffset + sizeFromShape(size_)));
    }
    return out;
  }
  if (x2.dtype === "string") {
    const res = sliceImpl(xVals, begin_, size_, x2.shape, x2.dtype);
    outData.stringBytes = res;
    return out;
  }
  const outVals = backend2.typedArrayFromHeap(out);
  const rank = x2.shape.length;
  if (rank === 2) {
    slice2d(xVals, xStrides[0], outVals, begin_, size_);
  } else if (rank === 3) {
    slice3d(xVals, xStrides[0], xStrides[1], outVals, begin_, size_);
  } else if (rank === 4) {
    slice4d(xVals, xStrides[0], xStrides[1], xStrides[2], outVals, begin_, size_);
  } else {
    const res = sliceImpl(xVals, begin_, size_, x2.shape, x2.dtype);
    outVals.set(res);
  }
  return out;
}
function slice2d(xVals, xStride, outVals, begin, size) {
  let outOffset = 0;
  const beginI = begin[0];
  const beginJ = begin[1];
  const endI = beginI + size[0];
  for (let i2 = beginI; i2 < endI; i2++) {
    const xOffset = i2 * xStride + beginJ;
    outVals.set(xVals.subarray(xOffset, xOffset + size[1]), outOffset);
    outOffset += size[1];
  }
}
function slice3d(xVals, xStride1, xStride2, outVals, begin, size) {
  let outOffset = 0;
  const beginI = begin[0];
  const beginJ = begin[1];
  const beginK = begin[2];
  const endI = beginI + size[0];
  const endJ = beginJ + size[1];
  for (let i2 = beginI; i2 < endI; i2++) {
    for (let j2 = beginJ; j2 < endJ; j2++) {
      const xOffset = i2 * xStride1 + j2 * xStride2 + beginK;
      outVals.set(xVals.subarray(xOffset, xOffset + size[2]), outOffset);
      outOffset += size[2];
    }
  }
}
function slice4d(xVals, xStride1, xStride2, xStride3, outVals, begin, size) {
  let outOffset = 0;
  const beginI = begin[0];
  const beginJ = begin[1];
  const beginK = begin[2];
  const endI = beginI + size[0];
  const endJ = beginJ + size[1];
  const endK = beginK + size[2];
  const beginL = begin[3];
  for (let i2 = beginI; i2 < endI; i2++) {
    for (let j2 = beginJ; j2 < endJ; j2++) {
      for (let k3 = beginK; k3 < endK; k3++) {
        const xOffset = i2 * xStride1 + j2 * xStride2 + k3 * xStride3 + beginL;
        outVals.set(xVals.subarray(xOffset, xOffset + size[3]), outOffset);
        outOffset += size[3];
      }
    }
  }
}
const sliceConfig = {
  kernelName: Slice,
  backendName: "wasm",
  kernelFunc: slice
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function batchToSpaceND(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockShape, crops } = attrs;
  const prod2 = blockShape.reduce((a6, b2) => a6 * b2);
  const reshaped = getReshaped(x2.shape, blockShape, prod2);
  const permuted = getPermuted(reshaped.length, blockShape.length);
  const reshapedPermuted = getReshapedPermuted(x2.shape, blockShape, prod2);
  const sliceBeginCoords = getSliceBeginCoords(crops, blockShape.length);
  const sliceSize = getSliceSize(reshapedPermuted, crops, blockShape.length);
  const xReshaped = reshape({ inputs: { x: x2 }, backend: backend2, attrs: { shape: reshaped } });
  const xTransposed = transpose({ inputs: { x: xReshaped }, backend: backend2, attrs: { perm: permuted } });
  const xTransposedReshaped = reshape({ inputs: { x: xTransposed }, backend: backend2, attrs: { shape: reshapedPermuted } });
  const result2 = slice({
    inputs: { x: xTransposedReshaped },
    backend: backend2,
    attrs: { begin: sliceBeginCoords, size: sliceSize }
  });
  backend2.disposeData(xReshaped.dataId);
  backend2.disposeData(xTransposed.dataId);
  backend2.disposeData(xReshaped.dataId);
  return result2;
}
const batchToSpaceNDConfig = {
  kernelName: BatchToSpaceND,
  backendName: "wasm",
  kernelFunc: batchToSpaceND
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function cast(args) {
  const { inputs: { x: x2 }, attrs: { dtype }, backend: backend2 } = args;
  const out = backend2.makeOutput(x2.shape, dtype);
  const inVals = backend2.typedArrayFromHeap(x2);
  const outVals = backend2.typedArrayFromHeap(out);
  outVals.set(inVals);
  return out;
}
const castConfig = {
  kernelName: Cast,
  backendName: "wasm",
  kernelFunc: cast
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ceilConfig = createUnaryKernelConfig(Ceil);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmClip;
function setup$F(backend2) {
  wasmClip = backend2.wasm.cwrap(ClipByValue, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function clip(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { clipValueMin, clipValueMax } = attrs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmClip(xId, clipValueMin, clipValueMax, outId);
  return out;
}
const clipByValueConfig = {
  kernelName: ClipByValue,
  backendName: "wasm",
  setupFunc: setup$F,
  kernelFunc: clip
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function concat(args) {
  const { inputs, backend: backend2 } = args;
  const axis = parseAxisParam(args.attrs.axis, inputs[0].shape)[0];
  let outShape = computeOutShape$2(inputs.map((t2) => t2.shape), axis);
  const $inputs = inputs.filter((t2) => sizeFromShape(t2.shape) > 0);
  if ($inputs.length === 1) {
    return identity({ inputs: { x: $inputs[0] }, backend: backend2 });
  }
  const out = backend2.makeOutput(outShape, inputs[0].dtype);
  if (sizeFromShape(outShape) === 0) {
    return out;
  }
  const shapes = $inputs.map((t2) => t2.shape);
  assertParamsConsistent(shapes, axis);
  if ($inputs[0].dtype === "string") {
    const inputs2D = $inputs.map((t2) => {
      const innerSize = sizeFromShape(t2.shape.slice(axis));
      const shape = [-1, innerSize];
      return reshape({ inputs: { x: t2 }, backend: backend2, attrs: { shape } });
    });
    const inputsValShapes = inputs2D.map((t2) => {
      return { vals: backend2.readSync(t2.dataId), shape: t2.shape };
    });
    outShape = computeOutShape$2(inputs2D.map((t2) => t2.shape), 1);
    const simplyConcat = inputs2D[0].shape[0] === 1;
    const outVals2 = concatImpl$1(inputsValShapes, outShape, inputs[0].dtype, simplyConcat);
    const finalOutShape = computeOutShape$2($inputs.map((t2) => t2.shape), axis);
    out.shape = finalOutShape;
    const outData = backend2.dataIdMap.get(out.dataId);
    outData.stringBytes = fromStringArrayToUint8(outVals2);
    inputs2D.forEach((t2) => backend2.disposeData(t2.dataId));
    return out;
  }
  const batchDim = sizeFromShape($inputs[0].shape.slice(0, axis));
  let sumInnerDims = 0;
  const innerDims = $inputs.map((input) => {
    const innerDim = sizeFromShape(input.shape.slice(axis));
    sumInnerDims += innerDim;
    return innerDim;
  });
  const inVals = $inputs.map((input) => backend2.typedArrayFromHeap(input));
  const outVals = backend2.typedArrayFromHeap(out);
  for (let b2 = 0; b2 < batchDim; b2++) {
    let outOffset = b2 * sumInnerDims;
    for (let i2 = 0; i2 < inVals.length; i2++) {
      const innerDim = innerDims[i2];
      const inOffset = b2 * innerDim;
      const vals = inVals[i2].subarray(inOffset, inOffset + innerDim);
      outVals.set(vals, outOffset);
      outOffset += innerDim;
    }
  }
  return out;
}
const concatConfig = {
  kernelName: Concat,
  backendName: "wasm",
  kernelFunc: concat
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmConv2d;
function setup$E(backend2) {
  wasmConv2d = backend2.wasm.cwrap(Conv2D$1, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function conv2d(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { x: x2, filter: filter2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const filterId = backend2.dataIdMap.get(filter2.dataId).id;
  const { strides, dilations, pad: pad2, dimRoundingMode, dataFormat } = attrs;
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, dilations, pad2, dimRoundingMode, false, $dataFormat);
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const padTop = convInfo.padInfo.top;
  const padRight = convInfo.padInfo.right;
  const padBottom = convInfo.padInfo.bottom;
  const padLeft = convInfo.padInfo.left;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const inputChannels = convInfo.inChannels;
  const outputChannels = convInfo.outChannels;
  const isSamePad = convInfo.padInfo.type === "SAME" ? 1 : 0;
  if (convInfo.dataFormat !== "channelsLast") {
    throw new Error(`wasm backend Conv2D does not support dataFormat:'${convInfo.dataFormat}'. Please use 'channelsLast'.`);
  }
  const out = backend2.makeOutput(convInfo.outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmConv2d(xId, x2.shape[0], x2.shape[1], x2.shape[2], filterId, filterHeight, filterWidth, padTop, padRight, padBottom, padLeft, isSamePad, dilationHeight, dilationWidth, strideHeight, strideWidth, inputChannels, outputChannels, outId);
  return out;
}
const conv2DConfig = {
  kernelName: Conv2D$1,
  backendName: "wasm",
  setupFunc: setup$E,
  kernelFunc: conv2d
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmConv2DBackpropInput;
function setup$D(backend2) {
  wasmConv2DBackpropInput = backend2.wasm.cwrap(Conv2DBackpropInput, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function conv2DBackpropInput(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { dy, filter: filter2 } = inputs;
  const { strides, pad: pad2, dataFormat, dimRoundingMode, inputShape } = attrs;
  const dilations = 1;
  const $dataFormat = convertConv2DDataFormat(dataFormat);
  const convInfo = computeConv2DInfo(inputShape, filter2.shape, strides, dilations, pad2, dimRoundingMode, false, $dataFormat);
  const { batchSize, filterHeight, filterWidth, inChannels, inHeight, inWidth, outChannels, outHeight, outWidth, strideHeight, strideWidth } = convInfo;
  const topPad = filterHeight - 1 - convInfo.padInfo.top;
  const leftPad = filterWidth - 1 - convInfo.padInfo.left;
  const isChannelsLast = convInfo.dataFormat === "channelsLast";
  const dxStrides = computeStrides(convInfo.inShape);
  const dyStrides = computeStrides(dy.shape);
  const [fltS0, fltS1, fltS2] = computeStrides(filter2.shape);
  const xBatchStride = dxStrides[0];
  const xRowStride = isChannelsLast ? dxStrides[1] : dxStrides[2];
  const xColStride = isChannelsLast ? dxStrides[2] : 1;
  const xChannelStride = isChannelsLast ? 1 : dxStrides[1];
  const yBatchStride = dyStrides[0];
  const yRowStride = isChannelsLast ? dyStrides[1] : dyStrides[2];
  const yColStride = isChannelsLast ? dyStrides[2] : 1;
  const yChannelStride = isChannelsLast ? 1 : dyStrides[1];
  const out = backend2.makeOutput(convInfo.inShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const dyId = backend2.dataIdMap.get(dy.dataId).id;
  const filterId = backend2.dataIdMap.get(filter2.dataId).id;
  wasmConv2DBackpropInput(dyId, filterId, batchSize, filterHeight, filterWidth, inHeight, inWidth, inChannels, outHeight, outWidth, outChannels, strideHeight, strideWidth, topPad, leftPad, fltS0, fltS1, fltS2, xBatchStride, xRowStride, xColStride, xChannelStride, yBatchStride, yRowStride, yColStride, yChannelStride, outId);
  return out;
}
const conv2DBackpropInputConfig = {
  kernelName: Conv2DBackpropInput,
  backendName: "wasm",
  setupFunc: setup$D,
  kernelFunc: conv2DBackpropInput
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const cosConfig = createUnaryKernelConfig(Cos);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const coshConfig = createUnaryKernelConfig(Cosh);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var InterpolationMethod;
(function(InterpolationMethod2) {
  InterpolationMethod2[InterpolationMethod2["bilinear"] = 0] = "bilinear";
  InterpolationMethod2[InterpolationMethod2["nearest"] = 1] = "nearest";
})(InterpolationMethod || (InterpolationMethod = {}));
let wasmCropAndResize;
function setup$C(backend2) {
  wasmCropAndResize = backend2.wasm.cwrap(CropAndResize, null, [
    "number",
    "number",
    "number",
    "number",
    "array",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function cropAndResize(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { method: method2, extrapolationValue, cropSize } = attrs;
  const { image: image2, boxes, boxInd } = inputs;
  const numBoxes = boxes.shape[0];
  const [cropHeight, cropWidth] = cropSize;
  const outShape = [numBoxes, cropHeight, cropWidth, image2.shape[3]];
  let imagesData = backend2.dataIdMap.get(image2.dataId);
  let castedData;
  if (image2.dtype !== "float32") {
    castedData = cast({ backend: backend2, inputs: { x: image2 }, attrs: { dtype: "float32" } });
    imagesData = backend2.dataIdMap.get(castedData.dataId);
  }
  const imagesId = imagesData.id;
  const boxesId = backend2.dataIdMap.get(boxes.dataId).id;
  const boxIndId = backend2.dataIdMap.get(boxInd.dataId).id;
  const out = backend2.makeOutput(outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const imagesShapeBytes = new Uint8Array(new Int32Array(image2.shape).buffer);
  wasmCropAndResize(imagesId, boxesId, boxIndId, numBoxes, imagesShapeBytes, cropHeight, cropWidth, InterpolationMethod[method2], extrapolationValue, outId);
  if (castedData != null) {
    backend2.disposeData(castedData.dataId);
  }
  return out;
}
const cropAndResizeConfig = {
  kernelName: CropAndResize,
  backendName: "wasm",
  setupFunc: setup$C,
  kernelFunc: cropAndResize
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmCumprod;
function setup$B(backend2) {
  wasmCumprod = backend2.wasm.cwrap(Cumprod, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function cumprod(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, exclusive, reverse: reverse2 } = attrs;
  const xRank = x2.shape.length;
  assert$1(x2.dtype === "float32" || x2.dtype === "int32", () => `cumprod does not support ${x2.dtype} tensors in the WASM backend`);
  const permutation = getAxesPermutation([axis], xRank);
  let permutedX = x2;
  if (permutation !== null) {
    permutedX = transpose({ inputs: { x: x2 }, attrs: { perm: permutation }, backend: backend2 });
  }
  const permutedAxis = getInnerMostAxes(1, xRank)[0];
  assertAxesAreInnerMostDims("cumprod", [permutedAxis], xRank);
  const permutedOut = backend2.makeOutput(permutedX.shape, permutedX.dtype);
  const finalDim = permutedX.shape[permutedAxis];
  const permutedXId = backend2.dataIdMap.get(permutedX.dataId).id;
  const permutedOutId = backend2.dataIdMap.get(permutedOut.dataId).id;
  wasmCumprod(permutedXId, exclusive ? 1 : 0, reverse2 ? 1 : 0, finalDim, permutedOutId, CppDType[x2.dtype]);
  let out = permutedOut;
  if (permutation !== null) {
    const undoPermutation = getUndoAxesPermutation(permutation);
    out = transpose({ inputs: { x: permutedOut }, attrs: { perm: undoPermutation }, backend: backend2 });
    backend2.disposeData(permutedX.dataId);
    backend2.disposeData(permutedOut.dataId);
  }
  return out;
}
const cumprodConfig = {
  kernelName: Cumprod,
  backendName: "wasm",
  setupFunc: setup$B,
  kernelFunc: cumprod
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmCumsum;
function setup$A(backend2) {
  wasmCumsum = backend2.wasm.cwrap(Cumsum, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function cumsum(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { axis, exclusive, reverse: reverse2 } = attrs;
  const xRank = x2.shape.length;
  assert$1(x2.dtype === "float32" || x2.dtype === "int32", () => `cumsum does not support ${x2.dtype} tensors in the WASM backend`);
  const permutation = getAxesPermutation([axis], xRank);
  let permutedX = x2;
  if (permutation !== null) {
    permutedX = transpose({ inputs: { x: x2 }, attrs: { perm: permutation }, backend: backend2 });
  }
  const permutedAxis = getInnerMostAxes(1, xRank)[0];
  assertAxesAreInnerMostDims("cumsum", [permutedAxis], xRank);
  const permutedOut = backend2.makeOutput(permutedX.shape, permutedX.dtype);
  const finalDim = permutedX.shape[permutedAxis];
  const permutedXId = backend2.dataIdMap.get(permutedX.dataId).id;
  const permutedOutId = backend2.dataIdMap.get(permutedOut.dataId).id;
  wasmCumsum(permutedXId, exclusive ? 1 : 0, reverse2 ? 1 : 0, finalDim, permutedOutId, CppDType[x2.dtype]);
  let out = permutedOut;
  if (permutation !== null) {
    const undoPermutation = getUndoAxesPermutation(permutation);
    out = transpose({ inputs: { x: permutedOut }, attrs: { perm: undoPermutation }, backend: backend2 });
    backend2.disposeData(permutedX.dataId);
    backend2.disposeData(permutedOut.dataId);
  }
  return out;
}
const cumsumConfig = {
  kernelName: Cumsum,
  backendName: "wasm",
  setupFunc: setup$A,
  kernelFunc: cumsum
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmDepthToSpace;
function setup$z(backend2) {
  wasmDepthToSpace = backend2.wasm.cwrap(DepthToSpace, null, [
    "number",
    "number",
    "number",
    "array",
    "number",
    "array",
    "array",
    "number",
    "number"
  ]);
}
function depthToSpace(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { x: x2 } = inputs;
  const { blockSize, dataFormat } = attrs;
  const batchSize = x2.shape[0];
  const inputHeight = dataFormat === "NHWC" ? x2.shape[1] : x2.shape[2];
  const inputWidth = dataFormat === "NHWC" ? x2.shape[2] : x2.shape[3];
  const inputDepth = dataFormat === "NHWC" ? x2.shape[3] : x2.shape[1];
  const outputHeight = inputHeight * blockSize;
  const outputWidth = inputWidth * blockSize;
  const outputDepth = inputDepth / (blockSize * blockSize);
  const outputShape = dataFormat === "NHWC" ? [batchSize, outputHeight, outputWidth, outputDepth] : [batchSize, outputDepth, outputHeight, outputWidth];
  const out = backend2.makeOutput(outputShape, "float32");
  const xData = backend2.dataIdMap.get(x2.dataId);
  const xId = xData.id;
  const xStridesBytes = new Uint8Array(new Int32Array(computeStrides(x2.shape)).buffer);
  const outputShapeBytes = new Uint8Array(new Int32Array(outputShape).buffer);
  const outStridesBytes = new Uint8Array(new Int32Array(computeStrides(outputShape)).buffer);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const channelsLast = dataFormat === "NHWC" ? 1 : 0;
  wasmDepthToSpace(xId, blockSize, channelsLast, xStridesBytes, x2.shape.length - 1, outputShapeBytes, outStridesBytes, outputShape.length, outId);
  return out;
}
const depthToSpaceConfig = {
  kernelName: DepthToSpace,
  backendName: "wasm",
  setupFunc: setup$z,
  kernelFunc: depthToSpace
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmDepthwiseConv2d;
function setup$y(backend2) {
  wasmDepthwiseConv2d = backend2.wasm.cwrap(DepthwiseConv2dNative, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function depthwiseConv2d(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { x: x2, filter: filter2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const filterId = backend2.dataIdMap.get(filter2.dataId).id;
  const { strides, dilations, pad: pad2, dimRoundingMode } = attrs;
  const $dilations = dilations == null ? [1, 1] : dilations;
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, $dilations, pad2, dimRoundingMode, true);
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const padTop = convInfo.padInfo.top;
  const padRight = convInfo.padInfo.right;
  const padBottom = convInfo.padInfo.bottom;
  const padLeft = convInfo.padInfo.left;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const inputChannels = convInfo.inChannels;
  const outputChannels = convInfo.outChannels;
  const isSamePad = convInfo.padInfo.type === "SAME" ? 1 : 0;
  if (convInfo.dataFormat !== "channelsLast") {
    throw new Error(`wasm backend DepthwiseConv2dNative does not support dataFormat:'${convInfo.dataFormat}'. Please use 'channelsLast'.`);
  }
  const out = backend2.makeOutput(convInfo.outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmDepthwiseConv2d(xId, x2.shape[0], x2.shape[1], x2.shape[2], filterId, filterHeight, filterWidth, padTop, padRight, padBottom, padLeft, isSamePad, dilationHeight, dilationWidth, strideHeight, strideWidth, inputChannels, outputChannels, outId);
  return out;
}
const depthwiseConv2dNativeConfig = {
  kernelName: DepthwiseConv2dNative,
  backendName: "wasm",
  setupFunc: setup$y,
  kernelFunc: depthwiseConv2d
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const eluConfig = createUnaryKernelConfig(Elu$1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast$6 = false;
const equalConfig = createBinaryKernelConfig(Equal, supportsFullBroadcast$6, "bool");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const expConfig = createUnaryKernelConfig(Exp, "float32");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function expandDims(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { input } = inputs;
  const { dim } = attrs;
  const inputRank = input.shape.length;
  const newShape = input.shape.slice();
  let $dim = dim;
  if (dim < 0) {
    assert$1(-(inputRank + 1) <= dim, () => `Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
    $dim = inputRank + dim + 1;
  }
  newShape.splice($dim, 0, 1);
  return reshape({ inputs: { x: input }, backend: backend2, attrs: { shape: newShape } });
}
const expandDimsConfig = {
  kernelName: ExpandDims,
  backendName: "wasm",
  kernelFunc: expandDims
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function fill(args) {
  const { attrs: { shape, value, dtype }, backend: backend2 } = args;
  const out = backend2.makeOutput(shape, dtype);
  const outVals = backend2.typedArrayFromHeap(out);
  outVals.fill(value);
  return out;
}
const fillConfig = {
  kernelName: Fill,
  backendName: "wasm",
  kernelFunc: fill
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFlipLeftRight;
function setup$x(backend2) {
  wasmFlipLeftRight = backend2.wasm.cwrap(FlipLeftRight, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function flipLeftRight(args) {
  const { inputs, backend: backend2 } = args;
  const { image: image2 } = inputs;
  const out = backend2.makeOutput(image2.shape, image2.dtype);
  const imageId = backend2.dataIdMap.get(image2.dataId).id;
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
  wasmFlipLeftRight(imageId, batch, imageHeight, imageWidth, numChannels, outId);
  return out;
}
const flipLeftRightConfig = {
  kernelName: FlipLeftRight,
  backendName: "wasm",
  kernelFunc: flipLeftRight,
  setupFunc: setup$x
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const floorConfig = createUnaryKernelConfig(Floor);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const floorDivConfig = createBinaryKernelConfig(FloorDiv);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmBatchNorm;
function setup$w(backend2) {
  wasmBatchNorm = backend2.wasm.cwrap(FusedBatchNorm, null, ["number", "number", "number", "number", "number", "number", "number"]);
}
function fusedBatchNorm(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { varianceEpsilon } = attrs;
  const { x: x2, mean: mean2, variance, offset, scale: scale2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const meanId = backend2.dataIdMap.get(mean2.dataId).id;
  const varianceId = backend2.dataIdMap.get(variance.dataId).id;
  const offsetId = offset != null ? backend2.dataIdMap.get(offset.dataId).id : 0;
  const scaleId = scale2 != null ? backend2.dataIdMap.get(scale2.dataId).id : 0;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  if (sizeFromShape(x2.shape) === 0) {
    return out;
  }
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmBatchNorm(xId, meanId, varianceId, offsetId, scaleId, varianceEpsilon, outId);
  return out;
}
const fusedBatchNormConfig = {
  kernelName: FusedBatchNorm,
  backendName: "wasm",
  setupFunc: setup$w,
  kernelFunc: fusedBatchNorm
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFusedConv2d;
function setup$v(backend2) {
  wasmFusedConv2d = backend2.wasm.cwrap(FusedConv2D, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function fusedConv2d(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { x: x2, filter: filter2, bias, preluActivationWeights } = inputs;
  const { strides, pad: pad2, dilations, dataFormat, dimRoundingMode, activation, leakyreluAlpha } = attrs;
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, dilations, pad2, dimRoundingMode);
  const fusedActivation = FusableActivation[activation];
  if (fusedActivation == null) {
    throw new Error(`${activation} activation not yet supported for FusedConv2D in the wasm backend.`);
  }
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const filterId = backend2.dataIdMap.get(filter2.dataId).id;
  const outputChannels = convInfo.outChannels;
  let biasId = 0;
  if (bias != null) {
    const biasData = backend2.dataIdMap.get(bias.dataId);
    if (biasData.shape.length !== 1) {
      throw new Error(`FusedConv2D only supports rank-1 bias but got rank ${biasData.shape.length}.`);
    }
    if (biasData.shape[0] !== outputChannels) {
      throw new Error(`FusedConv2D bias shape (${biasData.shape}) does not match the number of output channels (${outputChannels})`);
    }
    biasId = biasData.id;
  }
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const padTop = convInfo.padInfo.top;
  const padRight = convInfo.padInfo.right;
  const padBottom = convInfo.padInfo.bottom;
  const padLeft = convInfo.padInfo.left;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const inputChannels = convInfo.inChannels;
  const isSamePad = convInfo.padInfo.type === "SAME" ? 1 : 0;
  const batchSize = convInfo.batchSize;
  const inHeight = convInfo.inHeight;
  const inWidth = convInfo.inWidth;
  if (dataFormat !== "NHWC") {
    throw new Error(`wasm backend FusedConv2D does not support dataFormat:'${dataFormat}'. Please use 'NHWC'.`);
  }
  const out = backend2.makeOutput(convInfo.outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const preluActivationWeightsId = preluActivationWeights == null ? 0 : backend2.dataIdMap.get(preluActivationWeights.dataId).id;
  wasmFusedConv2d(xId, batchSize, inHeight, inWidth, filterId, filterHeight, filterWidth, biasId, padTop, padRight, padBottom, padLeft, isSamePad, dilationHeight, dilationWidth, strideHeight, strideWidth, inputChannels, outputChannels, fusedActivation, preluActivationWeightsId, leakyreluAlpha || 0, outId);
  return out;
}
const fusedConv2DConfig = {
  kernelName: FusedConv2D,
  backendName: "wasm",
  setupFunc: setup$v,
  kernelFunc: fusedConv2d
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFusedDepthwiseConv2d;
function setup$u(backend2) {
  wasmFusedDepthwiseConv2d = backend2.wasm.cwrap(FusedDepthwiseConv2D, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function fusedDepthwiseConv2d(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { x: x2, filter: filter2, bias, preluActivationWeights } = inputs;
  const { strides, pad: pad2, dilations, dataFormat, dimRoundingMode, activation, leakyreluAlpha } = attrs;
  const convInfo = computeConv2DInfo(x2.shape, filter2.shape, strides, dilations, pad2, dimRoundingMode, true);
  const fusedActivation = FusableActivation[activation];
  if (fusedActivation == null) {
    throw new Error(`${activation} activation not yet supported for FusedDepthwiseConv2D in the wasm backend.`);
  }
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const filterId = backend2.dataIdMap.get(filter2.dataId).id;
  const outputChannels = convInfo.outChannels;
  let biasId = 0;
  if (bias != null) {
    const biasData = backend2.dataIdMap.get(bias.dataId);
    if (biasData.shape.length !== 1) {
      throw new Error(`FusedDepthwiseConv2D only supports rank-1 bias but got rank ${biasData.shape.length}.`);
    }
    if (biasData.shape[0] !== outputChannels) {
      throw new Error(`FusedDepthwiseConv2D bias shape (${biasData.shape}) does not match the number of output channels (${outputChannels})`);
    }
    biasId = biasData.id;
  }
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const padTop = convInfo.padInfo.top;
  const padRight = convInfo.padInfo.right;
  const padBottom = convInfo.padInfo.bottom;
  const padLeft = convInfo.padInfo.left;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const inputChannels = convInfo.inChannels;
  const isSamePad = convInfo.padInfo.type === "SAME" ? 1 : 0;
  const batchSize = convInfo.batchSize;
  const inHeight = convInfo.inHeight;
  const inWidth = convInfo.inWidth;
  if (dataFormat !== "NHWC") {
    throw new Error(`wasm backend FusedDepthwiseConv2D does not support dataFormat:'${dataFormat}'. Please use 'NHWC'.`);
  }
  const out = backend2.makeOutput(convInfo.outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const preluActivationWeightsId = preluActivationWeights == null ? 0 : backend2.dataIdMap.get(preluActivationWeights.dataId).id;
  wasmFusedDepthwiseConv2d(xId, batchSize, inHeight, inWidth, filterId, filterHeight, filterWidth, biasId, padTop, padRight, padBottom, padLeft, isSamePad, dilationHeight, dilationWidth, strideHeight, strideWidth, inputChannels, outputChannels, fusedActivation, preluActivationWeightsId, leakyreluAlpha || 0, outId);
  return out;
}
const fusedDepthwiseConv2DConfig = {
  kernelName: FusedDepthwiseConv2D,
  backendName: "wasm",
  setupFunc: setup$u,
  kernelFunc: fusedDepthwiseConv2d
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmGatherNd;
function setup$t(backend2) {
  wasmGatherNd = backend2.wasm.cwrap(GatherNd, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "array",
    "number"
  ]);
}
function gatherNd(args) {
  const { backend: backend2, inputs } = args;
  const { params, indices } = inputs;
  const [resultShape, numSlices, sliceSize, strides] = prepareAndValidate(params, indices);
  const out = backend2.makeOutput(resultShape, params.dtype);
  if (numSlices === 0) {
    return out;
  }
  const indicesShape = indices.shape;
  const sliceRank = indicesShape[indicesShape.length - 1];
  const xData = backend2.dataIdMap.get(params.dataId);
  const xId = xData.id;
  const indicesData = backend2.dataIdMap.get(indices.dataId);
  const indicesId = indicesData.id;
  const stridesBytes = new Uint8Array(new Int32Array(strides).buffer);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmGatherNd(xId, CppDType[params.dtype], indicesId, numSlices, sliceRank, sliceSize, stridesBytes, outId);
  return out;
}
const gatherNdConfig = {
  kernelName: GatherNd,
  backendName: "wasm",
  setupFunc: setup$t,
  kernelFunc: gatherNd
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmGather;
function setup$s(backend2) {
  wasmGather = backend2.wasm.cwrap("Gather", null, [
    "number",
    "number",
    "array",
    "number",
    "number",
    "number",
    "array",
    "number"
  ]);
}
function gatherV2(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { x: x2, indices } = inputs;
  const { axis, batchDims } = attrs;
  const parsedAxis = parseAxisParam(axis, x2.shape)[0];
  const indicesVals = backend2.readSync(indices.dataId);
  const axisDim = x2.shape[parsedAxis];
  for (let i2 = 0; i2 < indicesVals.length; ++i2) {
    const index2 = indicesVals[i2];
    assert$1(index2 <= axisDim - 1 && index2 >= 0, () => `GatherV2: the index value ${index2} is not in [0, ${axisDim - 1}]`);
  }
  const shapeInfo = collectGatherOpShapeInfo(x2, indices, parsedAxis, batchDims);
  const flattenX = reshape({
    inputs: { x: x2 },
    attrs: {
      shape: [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        shapeInfo.dimSize,
        shapeInfo.sliceSize
      ]
    },
    backend: backend2
  });
  const indicesSize = sizeFromShape(indices.shape);
  const flattenIndex = reshape({
    inputs: { x: indices },
    attrs: { shape: [shapeInfo.batchSize, indicesSize / shapeInfo.batchSize] },
    backend: backend2
  });
  const flattenOutputShape = [
    shapeInfo.batchSize,
    shapeInfo.outerSize,
    indicesSize / shapeInfo.batchSize,
    shapeInfo.sliceSize
  ];
  const out = backend2.makeOutput(flattenOutputShape, x2.dtype);
  if (sizeFromShape(x2.shape) === 0) {
    return out;
  }
  const stridesSize = flattenX.shape.length - 1;
  const xData = backend2.dataIdMap.get(flattenX.dataId);
  const xId = xData.id;
  const indicesData = backend2.dataIdMap.get(flattenIndex.dataId);
  const indicesId = indicesData.id;
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const xStridesBytes = new Uint8Array(new Int32Array(computeStrides(flattenX.shape)).buffer);
  const outStridesBytes = new Uint8Array(new Int32Array(computeStrides(flattenOutputShape)).buffer);
  wasmGather(xId, CppDType[x2.dtype], xStridesBytes, stridesSize, indicesId, shapeInfo.batchSize, outStridesBytes, outId);
  backend2.disposeData(flattenX.dataId);
  backend2.disposeData(flattenIndex.dataId);
  out.shape = shapeInfo.outputShape;
  return out;
}
const gatherV2Config = {
  kernelName: GatherV2,
  backendName: "wasm",
  setupFunc: setup$s,
  kernelFunc: gatherV2
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast$5 = false;
const greaterConfig = createBinaryKernelConfig(Greater, supportsFullBroadcast$5, "bool");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast$4 = false;
const greaterEqualConfig = createBinaryKernelConfig(GreaterEqual, supportsFullBroadcast$4, "bool");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$5;
function setupFunc(backend2) {
  wasmFunc$5 = backend2.wasm.cwrap(LeakyRelu, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function leakyRelu(args) {
  const { inputs: { x: x2 }, attrs: { alpha: alpha2 }, backend: backend2 } = args;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const out = backend2.makeOutput(x2.shape, "float32");
  if (sizeFromShape(x2.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmFunc$5(xId, CppDType[x2.dtype], alpha2, outId);
  }
  return out;
}
const leakyReluConfig = {
  kernelName: LeakyRelu,
  backendName: "wasm",
  setupFunc,
  kernelFunc: leakyRelu
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast$3 = false;
const lessConfig = createBinaryKernelConfig(Less, supportsFullBroadcast$3, "bool");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast$2 = false;
const lessEqualConfig = createBinaryKernelConfig(LessEqual, supportsFullBroadcast$2, "bool");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const logConfig = createUnaryKernelConfig(Log);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast$1 = false;
const logicalAndConfig = createBinaryKernelConfig(LogicalAnd, supportsFullBroadcast$1, "bool");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmMax;
function setup$r(backend2) {
  wasmMax = backend2.wasm.cwrap(Max, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function max(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { reductionIndices: axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    input = transposed;
    inputId = transposedId;
  }
  const inputRank = input.shape.length;
  assertAxesAreInnerMostDims("max", axes, inputRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const out = backend2.makeOutput(outShape, x2.dtype);
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmMax(inputId, CppDType[x2.dtype], reduceSize, outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  return out;
}
const maxConfig = {
  kernelName: Max,
  backendName: "wasm",
  setupFunc: setup$r,
  kernelFunc: max
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const maximumConfig = createBinaryKernelConfig(Maximum$1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmMaxPool;
function setup$q(backend2) {
  wasmMaxPool = backend2.wasm.cwrap(MaxPool, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function maxPool(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const x2 = inputs.x;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  assert$1(x2.dtype === "float32", () => `Error in MaxPool: only float32 input is supported. Got ${x2.dtype}.`);
  const { filterSize, strides, pad: pad2, dimRoundingMode } = attrs;
  const convInfo = computePool2DInfo(x2.shape, filterSize, strides, 1, pad2, dimRoundingMode);
  const filterHeight = convInfo.filterHeight;
  const filterWidth = convInfo.filterWidth;
  const padTop = convInfo.padInfo.top;
  const padRight = convInfo.padInfo.right;
  const padBottom = convInfo.padInfo.bottom;
  const padLeft = convInfo.padInfo.left;
  const dilationHeight = convInfo.dilationHeight;
  const dilationWidth = convInfo.dilationWidth;
  const strideHeight = convInfo.strideHeight;
  const strideWidth = convInfo.strideWidth;
  const inputChannels = convInfo.inChannels;
  const outputChannels = convInfo.outChannels;
  if (convInfo.dataFormat !== "channelsLast") {
    throw new Error(`wasm backend does not support dataFormat:'${convInfo.dataFormat}'. Please use 'channelsLast'.`);
  }
  const out = backend2.makeOutput(convInfo.outShape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmMaxPool(xId, x2.shape[0], x2.shape[1], x2.shape[2], filterHeight, filterWidth, padTop, padRight, padBottom, padLeft, dilationHeight, dilationWidth, strideHeight, strideWidth, inputChannels, outputChannels, outId);
  return out;
}
const maxPoolConfig = {
  kernelName: MaxPool,
  backendName: "wasm",
  setupFunc: setup$q,
  kernelFunc: maxPool
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmMean;
function setup$p(backend2) {
  wasmMean = backend2.wasm.cwrap(Mean, null, ["number, number, number"]);
}
function mean(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  let reductionAxes = axes;
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    if (transposedId !== xId) {
      input = transposed;
      inputId = transposedId;
      reductionAxes = getInnerMostAxes(reductionAxes.length, input.shape.length);
    }
  }
  assertAxesAreInnerMostDims("mean", reductionAxes, input.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, reductionAxes);
  const reduceSize = sizeFromShape(reduceShape);
  let castedInput = input;
  if (input.dtype !== "float32") {
    castedInput = cast({ backend: backend2, inputs: { x: input }, attrs: { dtype: "float32" } });
    inputId = backend2.dataIdMap.get(castedInput.dataId).id;
  }
  const out = backend2.makeOutput(outShape, "float32");
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmMean(inputId, reduceSize, outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  if (input.dtype !== "float32") {
    backend2.disposeData(castedInput.dataId);
  }
  return out;
}
const meanConfig = {
  kernelName: Mean,
  backendName: "wasm",
  setupFunc: setup$p,
  kernelFunc: mean
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmMin;
function setup$o(backend2) {
  wasmMin = backend2.wasm.cwrap(Min, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function min(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    if (transposedId !== xId) {
      input = transposed;
      inputId = transposedId;
    }
  }
  const inputRank = input.shape.length;
  assertAxesAreInnerMostDims("min", axes, inputRank);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, axes);
  const reduceSize = sizeFromShape(reduceShape);
  const out = backend2.makeOutput(outShape, input.dtype);
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmMin(inputId, CppDType[x2.dtype], reduceSize, outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  return out;
}
const minConfig = {
  kernelName: Min,
  backendName: "wasm",
  setupFunc: setup$o,
  kernelFunc: min
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const minimumConfig = createBinaryKernelConfig(Minimum$1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var MirrorPaddingMode;
(function(MirrorPaddingMode2) {
  MirrorPaddingMode2[MirrorPaddingMode2["reflect"] = 0] = "reflect";
  MirrorPaddingMode2[MirrorPaddingMode2["symmetric"] = 1] = "symmetric";
})(MirrorPaddingMode || (MirrorPaddingMode = {}));
let wasmMirrorPad;
function setup$n(backend2) {
  wasmMirrorPad = backend2.wasm.cwrap(MirrorPad, null, [
    "number",
    "array",
    "number",
    "number",
    "array",
    "array",
    "number",
    "number"
  ]);
}
function mirrorPad(args) {
  const { inputs: { x: x2 }, backend: backend2, attrs: { paddings, mode: mode2 } } = args;
  const outShape = paddings.map((p2, i2) => p2[0] + x2.shape[i2] + p2[1]);
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const out = backend2.makeOutput(outShape, x2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const xShapeBytes = new Uint8Array(new Int32Array(x2.shape).buffer);
  const prePaddingsFlat = paddings.map((padTuple) => padTuple[0]);
  const postPaddingsFlat = paddings.map((padTuple) => padTuple[1]);
  const prePaddingsBytes = new Uint8Array(new Int32Array(prePaddingsFlat).buffer);
  const postPaddingsBytes = new Uint8Array(new Int32Array(postPaddingsFlat).buffer);
  wasmMirrorPad(xId, xShapeBytes, x2.shape.length, CppDType[x2.dtype], prePaddingsBytes, postPaddingsBytes, MirrorPaddingMode[mode2], outId);
  return out;
}
const mirrorPadConfig = {
  kernelName: MirrorPad,
  backendName: "wasm",
  kernelFunc: mirrorPad,
  setupFunc: setup$n
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const multiplyConfig = createBinaryKernelConfig(Multiply$1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const negConfig = createUnaryKernelConfig(Neg);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function parseResultStruct(backend2, resOffset) {
  const result2 = new Int32Array(backend2.wasm.HEAPU8.buffer, resOffset, 4);
  const pSelectedIndices = result2[0];
  const selectedSize = result2[1];
  const pSelectedScores = result2[2];
  const pValidOutputs = result2[3];
  backend2.wasm._free(resOffset);
  return { pSelectedIndices, selectedSize, pSelectedScores, pValidOutputs };
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$4;
function setup$m(backend2) {
  wasmFunc$4 = backend2.wasm.cwrap(NonMaxSuppressionV3, "number", [
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function kernelFunc$1(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { iouThreshold, maxOutputSize, scoreThreshold } = attrs;
  const { boxes, scores } = inputs;
  const boxesId = backend2.dataIdMap.get(boxes.dataId).id;
  const scoresId = backend2.dataIdMap.get(scores.dataId).id;
  const resOffset = wasmFunc$4(boxesId, scoresId, maxOutputSize, iouThreshold, scoreThreshold);
  const { pSelectedIndices, selectedSize, pSelectedScores, pValidOutputs } = parseResultStruct(backend2, resOffset);
  backend2.wasm._free(pSelectedScores);
  backend2.wasm._free(pValidOutputs);
  const selectedIndicesTensor = backend2.makeOutput([selectedSize], "int32", pSelectedIndices);
  return selectedIndicesTensor;
}
const nonMaxSuppressionV3Config = {
  kernelName: NonMaxSuppressionV3,
  backendName: "wasm",
  setupFunc: setup$m,
  kernelFunc: kernelFunc$1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$3;
function setup$l(backend2) {
  wasmFunc$3 = backend2.wasm.cwrap(NonMaxSuppressionV4, "number", [
    "number",
    "number",
    "number",
    "number",
    "number",
    "bool"
  ]);
}
function nonMaxSuppressionV4(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { iouThreshold, maxOutputSize, scoreThreshold, padToMaxOutputSize } = attrs;
  const { boxes, scores } = inputs;
  const boxesId = backend2.dataIdMap.get(boxes.dataId).id;
  const scoresId = backend2.dataIdMap.get(scores.dataId).id;
  const resOffset = wasmFunc$3(boxesId, scoresId, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
  const { pSelectedIndices, selectedSize, pSelectedScores, pValidOutputs } = parseResultStruct(backend2, resOffset);
  backend2.wasm._free(pSelectedScores);
  const selectedIndicesTensor = backend2.makeOutput([selectedSize], "int32", pSelectedIndices);
  const validOutputsTensor = backend2.makeOutput([], "int32", pValidOutputs);
  return [selectedIndicesTensor, validOutputsTensor];
}
const nonMaxSuppressionV4Config = {
  kernelName: NonMaxSuppressionV4,
  backendName: "wasm",
  setupFunc: setup$l,
  kernelFunc: nonMaxSuppressionV4
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$2;
function setup$k(backend2) {
  wasmFunc$2 = backend2.wasm.cwrap(NonMaxSuppressionV5, "number", [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function kernelFunc(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { iouThreshold, maxOutputSize, scoreThreshold, softNmsSigma } = attrs;
  const { boxes, scores } = inputs;
  const boxesId = backend2.dataIdMap.get(boxes.dataId).id;
  const scoresId = backend2.dataIdMap.get(scores.dataId).id;
  const resOffset = wasmFunc$2(boxesId, scoresId, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
  const { pSelectedIndices, selectedSize, pSelectedScores, pValidOutputs } = parseResultStruct(backend2, resOffset);
  backend2.wasm._free(pValidOutputs);
  const selectedIndicesTensor = backend2.makeOutput([selectedSize], "int32", pSelectedIndices);
  const selectedScoresTensor = backend2.makeOutput([selectedSize], "float32", pSelectedScores);
  return [selectedIndicesTensor, selectedScoresTensor];
}
const nonMaxSuppressionV5Config = {
  kernelName: NonMaxSuppressionV5,
  backendName: "wasm",
  setupFunc: setup$k,
  kernelFunc
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const supportsFullBroadcast = false;
const notEqualConfig = createBinaryKernelConfig(NotEqual, supportsFullBroadcast, "bool");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmOneHot;
function setup$j(backend2) {
  wasmOneHot = backend2.wasm.cwrap(OneHot, null, [
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function oneHot(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { indices } = inputs;
  const { depth, onValue, offValue } = attrs;
  const out = backend2.makeOutput([...indices.shape, depth], "int32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const indicesData = backend2.dataIdMap.get(indices.dataId);
  const indicesId = indicesData.id;
  wasmOneHot(indicesId, depth, onValue, offValue, outId);
  return out;
}
const oneHotConfig = {
  kernelName: OneHot,
  backendName: "wasm",
  setupFunc: setup$j,
  kernelFunc: oneHot
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function onesLike(args) {
  const { inputs: { x: x2 }, backend: backend2 } = args;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const outVals = backend2.typedArrayFromHeap(out);
  outVals.fill(1);
  return out;
}
const onesLikeConfig = {
  kernelName: OnesLike,
  backendName: "wasm",
  kernelFunc: onesLike
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function pack(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { axis } = attrs;
  if (inputs.length === 1) {
    return expandDims({ inputs: { input: inputs[0] }, backend: backend2, attrs: { dim: axis } });
  }
  const shape = inputs[0].shape;
  const dtype = inputs[0].dtype;
  inputs.forEach((t2) => {
    assertShapesMatch(shape, t2.shape, "All tensors passed to stack must have matching shapes");
    assert$1(dtype === t2.dtype, () => "All tensors passed to stack must have matching dtypes");
  });
  const intermediateTensorInfos = [];
  const expandedTensors = inputs.map((t2) => {
    const expandedT = expandDims({ inputs: { input: t2 }, backend: backend2, attrs: { dim: axis } });
    intermediateTensorInfos.push(expandedT);
    return expandedT;
  });
  const result2 = concat({ inputs: expandedTensors, backend: backend2, attrs: { axis } });
  intermediateTensorInfos.forEach((t2) => backend2.disposeData(t2.dataId));
  return result2;
}
const packConfig = {
  kernelName: Pack,
  backendName: "wasm",
  kernelFunc: pack
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmPadV2;
function setup$i(backend2) {
  wasmPadV2 = backend2.wasm.cwrap(PadV2, null, [
    "number",
    "array",
    "number",
    "number",
    "array",
    "array",
    "number",
    "number"
  ]);
}
function pad(args) {
  const { inputs: { x: x2 }, backend: backend2, attrs: { paddings, constantValue } } = args;
  const outShape = paddings.map((p2, i2) => p2[0] + x2.shape[i2] + p2[1]);
  if (sizeFromShape(x2.shape) === 0) {
    return fill({
      backend: backend2,
      attrs: { shape: outShape, value: constantValue, dtype: x2.dtype }
    });
  }
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const out = backend2.makeOutput(outShape, x2.dtype);
  const outTensorData = backend2.dataIdMap.get(out.dataId);
  const outId = outTensorData.id;
  const xShapeBytes = new Uint8Array(new Int32Array(x2.shape).buffer);
  const prePaddingsFlat = paddings.map((padTuple) => padTuple[0]);
  const postPaddingsFlat = paddings.map((padTuple) => padTuple[1]);
  const prePaddingsBytes = new Uint8Array(new Int32Array(prePaddingsFlat).buffer);
  const postPaddingsBytes = new Uint8Array(new Int32Array(postPaddingsFlat).buffer);
  wasmPadV2(xId, xShapeBytes, x2.shape.length, CppDType[x2.dtype], prePaddingsBytes, postPaddingsBytes, constantValue, outId);
  return out;
}
const padV2Config = {
  kernelName: PadV2,
  backendName: "wasm",
  kernelFunc: pad,
  setupFunc: setup$i
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const powConfig = createBinaryKernelConfig(Pow);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmPrelu;
function setup$h(backend2) {
  wasmPrelu = backend2.wasm.cwrap(Prelu, null, [
    "number",
    "number",
    "number"
  ]);
}
function prelu(args) {
  const { inputs, backend: backend2 } = args;
  const { x: x2, alpha: alpha2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const weightsId = backend2.dataIdMap.get(alpha2.dataId).id;
  let inputId = xId;
  const input = x2;
  let castedInput = input;
  if (input.dtype !== "float32") {
    castedInput = cast({ backend: backend2, inputs: { x: x2 }, attrs: { dtype: "float32" } });
    inputId = backend2.dataIdMap.get(castedInput.dataId).id;
  }
  const out = backend2.makeOutput(x2.shape, "float32");
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmPrelu(inputId, weightsId, outId);
  if (input.dtype !== "float32") {
    backend2.disposeData(castedInput.dataId);
  }
  return out;
}
const preluConfig = {
  kernelName: Prelu,
  backendName: "wasm",
  setupFunc: setup$h,
  kernelFunc: prelu
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmProd;
function setup$g(backend2) {
  wasmProd = backend2.wasm.cwrap(Prod, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function prod(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  let reductionAxes = axes;
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    if (transposedId !== xId) {
      input = transposed;
      inputId = transposedId;
      reductionAxes = getInnerMostAxes(reductionAxes.length, input.shape.length);
    }
  }
  assertAxesAreInnerMostDims("prod", reductionAxes, input.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, reductionAxes);
  const reduceSize = sizeFromShape(reduceShape);
  const out = backend2.makeOutput(outShape, input.dtype);
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmProd(inputId, reduceSize, CppDType[out.dtype], outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  return out;
}
const prodConfig = {
  kernelName: Prod,
  backendName: "wasm",
  setupFunc: setup$g,
  kernelFunc: prod
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const range = (args) => {
  const { backend: backend2, attrs } = args;
  const { start, stop, step: step2, dtype } = attrs;
  const values = rangeImpl(start, stop, step2, dtype);
  const out = backend2.makeOutput([values.length], dtype);
  const outVals = backend2.typedArrayFromHeap(out);
  outVals.set(values);
  return out;
};
const rangeConfig = {
  kernelName: Range,
  backendName: "wasm",
  kernelFunc: range
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const realDivConfig = createBinaryKernelConfig(RealDiv);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const reluConfig = createUnaryKernelConfig(Relu$1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const relu6Config = createUnaryKernelConfig(Relu6$1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmResizeBilinear;
function setup$f(backend2) {
  wasmResizeBilinear = backend2.wasm.cwrap(ResizeBilinear, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function resizeBilinear(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { images } = inputs;
  const { alignCorners, halfPixelCenters, size } = attrs;
  const [newHeight, newWidth] = size;
  const [batch, oldHeight, oldWidth, numChannels] = images.shape;
  const outShape = [batch, newHeight, newWidth, numChannels];
  let xData = backend2.dataIdMap.get(images.dataId);
  let castedData;
  if (xData.dtype !== "float32") {
    castedData = cast({ backend: backend2, inputs: { x: images }, attrs: { dtype: "float32" } });
    xData = backend2.dataIdMap.get(castedData.dataId);
  }
  const xId = xData.id;
  const out = backend2.makeOutput(outShape, "float32");
  if (sizeFromShape(images.shape) === 0) {
    return out;
  }
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmResizeBilinear(xId, batch, oldHeight, oldWidth, numChannels, newHeight, newWidth, alignCorners ? 1 : 0, halfPixelCenters ? 1 : 0, outId);
  if (castedData != null) {
    backend2.disposeData(castedData.dataId);
  }
  return out;
}
const resizeBilinearConfig = {
  kernelName: ResizeBilinear,
  backendName: "wasm",
  setupFunc: setup$f,
  kernelFunc: resizeBilinear
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmReverse;
function setup$e(backend2) {
  wasmReverse = backend2.wasm.cwrap(Reverse, null, [
    "number",
    "array",
    "number",
    "array",
    "number",
    "number"
  ]);
}
function reverse(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { dims } = attrs;
  const axes = parseAxisParam(dims, x2.shape);
  if (x2.shape.length === 0) {
    return identity({ inputs: { x: x2 }, backend: backend2 });
  }
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const axesBytes = new Uint8Array(new Int32Array(axes).buffer);
  const outShapeBytes = new Uint8Array(new Int32Array(x2.shape).buffer);
  wasmReverse(xId, axesBytes, axes.length, outShapeBytes, x2.shape.length, outId);
  const reshaped = reshape({ inputs: { x: out }, attrs: { shape: x2.shape }, backend: backend2 });
  backend2.disposeData(out.dataId);
  return reshaped;
}
const reverseConfig = {
  kernelName: Reverse,
  backendName: "wasm",
  kernelFunc: reverse,
  setupFunc: setup$e
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmRotate;
function setup$d(backend2) {
  wasmRotate = backend2.wasm.cwrap(RotateWithOffset, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "array",
    "number",
    "number"
  ]);
}
function rotateWithOffset(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { image: image2 } = inputs;
  const { radians, fillValue, center } = attrs;
  const out = backend2.makeOutput(image2.shape, image2.dtype);
  const imageId = backend2.dataIdMap.get(image2.dataId).id;
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
  const [centerX, centerY] = getImageCenter(center, imageHeight, imageWidth);
  const fillIsBlack = fillValue === 0;
  const fullOpacityValue = 255;
  const fillValues2 = typeof fillValue === "number" ? [fillValue, fillValue, fillValue, fillIsBlack ? 0 : fullOpacityValue] : [...fillValue, fullOpacityValue];
  const fillBytes = new Uint8Array(new Int32Array(fillValues2).buffer);
  wasmRotate(imageId, batch, imageHeight, imageWidth, numChannels, radians, centerX, centerY, fillBytes, fillValues2.length, outId);
  return out;
}
const rotateWithOffsetConfig = {
  kernelName: RotateWithOffset,
  backendName: "wasm",
  kernelFunc: rotateWithOffset,
  setupFunc: setup$d
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const roundConfig = createUnaryKernelConfig(Round);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const rsqrtConfig = createUnaryKernelConfig(Rsqrt);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmScatterNd;
function setup$c(backend2) {
  wasmScatterNd = backend2.wasm.cwrap(ScatterNd, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "array",
    "number",
    "number"
  ]);
}
function scatterNd(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { indices, updates } = inputs;
  const { shape } = attrs;
  const out = backend2.makeOutput(shape, updates.dtype);
  if (sizeFromShape(shape) === 0) {
    return out;
  }
  const { sliceRank, numUpdates, sliceSize, strides, outputSize } = calculateShapes(updates, indices, shape);
  const indicesData = backend2.dataIdMap.get(indices.dataId);
  const indicesId = indicesData.id;
  const updatesData = backend2.dataIdMap.get(updates.dataId);
  const updatesId = updatesData.id;
  const stridesBytes = new Uint8Array(new Int32Array(strides).buffer);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmScatterNd(indicesId, updatesId, CppDType[updates.dtype], sliceRank, numUpdates, sliceSize, stridesBytes, outputSize, outId);
  return out;
}
const scatterNdConfig = {
  kernelName: ScatterNd,
  backendName: "wasm",
  setupFunc: setup$c,
  kernelFunc: scatterNd
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmSelect;
function setup$b(backend2) {
  wasmSelect = backend2.wasm.cwrap("SelectV2", null, [
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function select(args) {
  const { inputs, backend: backend2 } = args;
  const { condition, t: t2, e: e2 } = inputs;
  const conditionId = backend2.dataIdMap.get(condition.dataId).id;
  const tId = backend2.dataIdMap.get(t2.dataId).id;
  const eId = backend2.dataIdMap.get(e2.dataId).id;
  const out = backend2.makeOutput(t2.shape, t2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const cRank = condition.shape.length;
  const tRank = t2.shape.length;
  const offset = cRank === 0 || cRank > 1 || tRank === 1 ? 1 : sizeFromShape(t2.shape.slice(1));
  wasmSelect(conditionId, tId, eId, offset, outId);
  return out;
}
const selectConfig = {
  kernelName: Select$1,
  backendName: "wasm",
  kernelFunc: select,
  setupFunc: setup$b
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc$1;
function setup$a(backend2) {
  wasmFunc$1 = backend2.wasm.cwrap(Sigmoid$1, null, ["number", "number"]);
}
function sigmoid(args) {
  const { backend: backend2, inputs: { x: x2 } } = args;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  if (sizeFromShape(out.shape) === 0) {
    return out;
  }
  wasmFunc$1(xId, outId);
  return out;
}
const sigmoidConfig = {
  kernelName: "Sigmoid",
  backendName: "wasm",
  setupFunc: setup$a,
  kernelFunc: sigmoid
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sinConfig = createUnaryKernelConfig(Sin);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmFunc;
function setup$9(backend2) {
  wasmFunc = backend2.wasm.cwrap(Softmax$2, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function softmax(args) {
  const { backend: backend2, inputs: { logits }, attrs: { dim } } = args;
  const xId = backend2.dataIdMap.get(logits.dataId).id;
  const out = backend2.makeOutput(logits.shape, logits.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const channels = logits.shape[dim];
  const batch = sizeFromShape(logits.shape) / channels;
  if (sizeFromShape(out.shape) === 0) {
    return out;
  }
  wasmFunc(xId, outId, channels, batch);
  return out;
}
const softmaxConfig = {
  kernelName: Softmax$2,
  backendName: "wasm",
  setupFunc: setup$9,
  kernelFunc: softmax
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function spaceToBatchND(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const { blockShape, paddings } = attrs;
  const prod2 = sizeFromShape(blockShape);
  const completePaddings = [[0, 0]];
  completePaddings.push(...paddings);
  for (let i2 = 1 + blockShape.length; i2 < x2.shape.length; ++i2) {
    completePaddings.push([0, 0]);
  }
  const paddedX = padV2Config.kernelFunc({
    inputs: { x: x2 },
    backend: backend2,
    attrs: { paddings: completePaddings, constantValue: 0 }
  });
  const reshapedPaddedShape = getReshaped(paddedX.shape, blockShape, prod2, false);
  const permutedReshapedPaddedPermutation = getPermuted(reshapedPaddedShape.length, blockShape.length, false);
  const flattenShape = getReshapedPermuted(paddedX.shape, blockShape, prod2, false);
  const reshapeInputs = { x: paddedX };
  const reshapeAttrs = { shape: reshapedPaddedShape };
  const paddedXReshaped = reshape({ inputs: reshapeInputs, backend: backend2, attrs: reshapeAttrs });
  const transposeInputs = { x: paddedXReshaped };
  const transposeAttrs = { perm: permutedReshapedPaddedPermutation };
  const paddedXT = transpose({ inputs: transposeInputs, backend: backend2, attrs: transposeAttrs });
  const resultReshapeInputs = { x: paddedXT };
  const resultReshapeAttrs = { shape: flattenShape };
  const result2 = reshape({ inputs: resultReshapeInputs, backend: backend2, attrs: resultReshapeAttrs });
  backend2.disposeData(paddedX.dataId);
  backend2.disposeData(paddedXReshaped.dataId);
  backend2.disposeData(paddedXT.dataId);
  return result2;
}
const spaceToBatchNDConfig = {
  kernelName: SpaceToBatchND,
  backendName: "wasm",
  kernelFunc: spaceToBatchND
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmSparseFillEmptyRows;
function setup$8(backend2) {
  wasmSparseFillEmptyRows = backend2.wasm.cwrap("SparseFillEmptyRows", "number", [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function sparseFillEmptyRows(args) {
  const { backend: backend2, inputs } = args;
  const { indices, values, denseShape, defaultValue } = inputs;
  const indicesCount = indices.shape[0];
  const rank = indices.shape[1];
  const denseRows = backend2.readSync(denseShape.dataId)[0];
  const maxOutputIndicesShape = [indicesCount + denseRows, rank];
  const indicesId = backend2.dataIdMap.get(indices.dataId).id;
  const valuesId = backend2.dataIdMap.get(values.dataId).id;
  const defaultValueId = backend2.dataIdMap.get(defaultValue.dataId).id;
  const outputIndices = backend2.makeOutput(maxOutputIndicesShape, indices.dtype);
  const outputIndicesId = backend2.dataIdMap.get(outputIndices.dataId).id;
  const outputValues = backend2.makeOutput(maxOutputIndicesShape.slice(0, 1), values.dtype);
  const outputValuesId = backend2.dataIdMap.get(outputValues.dataId).id;
  const emptyRowIndicator = backend2.makeOutput([denseRows], "bool");
  const emptyRowIndicatorId = backend2.dataIdMap.get(emptyRowIndicator.dataId).id;
  const reverseIndexMap = backend2.makeOutput([indicesCount], indices.dtype);
  const reverseIndexMapId = backend2.dataIdMap.get(reverseIndexMap.dataId).id;
  const exceptionValues = backend2.makeOutput([4], "int32");
  const exceptionValuesId = backend2.dataIdMap.get(exceptionValues.dataId).id;
  const outputRows = wasmSparseFillEmptyRows(indicesId, valuesId, CppDType[values.dtype], indicesCount, denseRows, rank, defaultValueId, outputIndicesId, outputValuesId, emptyRowIndicatorId, reverseIndexMapId, exceptionValuesId);
  const exceptionValuesArray = backend2.readSync(exceptionValues.dataId);
  let exceptionMessage;
  switch (exceptionValuesArray[0]) {
    case 1: {
      exceptionMessage = getSparseFillEmptyRowsIndicesDenseShapeMismatch(exceptionValuesArray[1]);
      break;
    }
    case 2: {
      exceptionMessage = getSparseFillEmptyRowsNegativeIndexErrorMessage(exceptionValuesArray[1], exceptionValuesArray[2]);
      break;
    }
    case 3:
      exceptionMessage = getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(exceptionValuesArray[1], exceptionValuesArray[2], exceptionValuesArray[3]);
      break;
    default:
      exceptionMessage = "";
  }
  backend2.disposeData(exceptionValues.dataId);
  if (exceptionMessage) {
    backend2.disposeData(outputIndices.dataId);
    backend2.disposeData(outputValues.dataId);
    backend2.disposeData(emptyRowIndicator.dataId);
    backend2.disposeData(reverseIndexMap.dataId);
    throw new Error(exceptionMessage);
  }
  let resizedIndices = outputIndices;
  let resizedValues = outputValues;
  if (outputRows !== maxOutputIndicesShape[0]) {
    resizedIndices = slice({
      inputs: { x: outputIndices },
      attrs: { begin: 0, size: [outputRows, rank] },
      backend: backend2
    });
    resizedValues = slice({
      inputs: { x: outputValues },
      attrs: { begin: 0, size: outputRows },
      backend: backend2
    });
    backend2.disposeData(outputIndices.dataId);
    backend2.disposeData(outputValues.dataId);
  }
  return [resizedIndices, resizedValues, emptyRowIndicator, reverseIndexMap];
}
const sparseFillEmptyRowsConfig = {
  kernelName: SparseFillEmptyRows,
  backendName: "wasm",
  setupFunc: setup$8,
  kernelFunc: sparseFillEmptyRows
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmSparseReshape;
function setup$7(backend2) {
  wasmSparseReshape = backend2.wasm.cwrap(SparseReshape, null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function sparseReshape(args) {
  const { backend: backend2, inputs } = args;
  const { inputIndices, inputShape, newShape } = inputs;
  if (inputIndices.shape.length !== 2) {
    throw new Error(`Input indices should be a matrix but received shape
        ${inputIndices.shape}`);
  }
  if (inputShape.shape.length !== 1) {
    throw new Error(`Input shape should be a vector but received shape
        ${inputShape.shape}`);
  }
  if (newShape.shape.length !== 1) {
    throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
  }
  const inputIndicesId = backend2.dataIdMap.get(inputIndices.dataId).id;
  const inputShapeId = backend2.dataIdMap.get(inputShape.dataId).id;
  const newShapeId = backend2.dataIdMap.get(newShape.dataId).id;
  const nnz = inputIndices.shape[0];
  const outputRank = sizeFromShape(newShape.shape);
  const newIndices = backend2.makeOutput([nnz, outputRank], inputIndices.dtype);
  const newIndicesId = backend2.dataIdMap.get(newIndices.dataId).id;
  const outputShape = backend2.makeOutput([outputRank], newShape.dtype);
  const outputShapeId = backend2.dataIdMap.get(outputShape.dataId).id;
  const exceptionValues = backend2.makeOutput([3], "int32");
  const exceptionValuesId = backend2.dataIdMap.get(exceptionValues.dataId).id;
  wasmSparseReshape(inputIndicesId, inputShapeId, newShapeId, nnz, newIndicesId, outputShapeId, exceptionValuesId);
  const exceptionValuesArray = backend2.readSync(exceptionValues.dataId);
  let exceptionMessage;
  switch (exceptionValuesArray[0]) {
    case 0: {
      exceptionMessage = getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(exceptionValuesArray[1], exceptionValuesArray[2]);
      break;
    }
    case 1: {
      exceptionMessage = getSparseReshapeNegativeOutputDimErrorMessage(exceptionValuesArray[1], exceptionValuesArray[2]);
      break;
    }
    case 2:
      exceptionMessage = getSparseReshapeEmptyTensorZeroOutputDimErrorMessage();
      break;
    case 3: {
      const inputShapeValues = Array.from(backend2.readSync(inputShape.dataId)), outputShapeValues = Array.from(backend2.readSync(outputShape.dataId));
      exceptionMessage = getSparseReshapeInputOutputMultipleErrorMessage(inputShapeValues, outputShapeValues);
      break;
    }
    case 4: {
      const inputShapeValues = Array.from(backend2.readSync(inputShape.dataId)), outputShapeValues = Array.from(backend2.readSync(outputShape.dataId));
      exceptionMessage = getSparseReshapeInputOutputMismatchErrorMessage(inputShapeValues, outputShapeValues);
      break;
    }
    default:
      exceptionMessage = "";
  }
  backend2.disposeData(exceptionValues.dataId);
  if (exceptionMessage) {
    backend2.disposeData(newIndices.dataId);
    backend2.disposeData(outputShape.dataId);
    throw new Error(exceptionMessage);
  }
  return [newIndices, outputShape];
}
const sparseReshapeConfig = {
  kernelName: SparseReshape,
  backendName: "wasm",
  setupFunc: setup$7,
  kernelFunc: sparseReshape
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmSparseSegmentReduction;
function setup$6(backend2) {
  wasmSparseSegmentReduction = backend2.wasm.cwrap("SparseSegmentReduction", null, [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function sparseSegmentReduction(args, isMean) {
  const { backend: backend2, inputs } = args;
  const { data: data2, indices, segmentIds } = inputs;
  const numIndices = indices.shape[0];
  const segmentIdsBack = backend2.readSync(segmentIds.dataId, numIndices - 1, numIndices)[0];
  const lastSegmentIdPlusOne = numIndices > 0 ? segmentIdsBack + 1 : 0;
  const outputRows = lastSegmentIdPlusOne;
  if (outputRows < 0) {
    throw new Error(getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
  }
  const outputShape = data2.shape.slice();
  outputShape[0] = outputRows;
  const dataId = backend2.dataIdMap.get(data2.dataId).id;
  const indicesId = backend2.dataIdMap.get(indices.dataId).id;
  const segmentIdsId = backend2.dataIdMap.get(segmentIds.dataId).id;
  const output2 = backend2.makeOutput(outputShape, data2.dtype);
  const outputId = backend2.dataIdMap.get(output2.dataId).id;
  const exceptionValues = backend2.makeOutput([4], "int32");
  const exceptionValuesId = backend2.dataIdMap.get(exceptionValues.dataId).id;
  wasmSparseSegmentReduction(dataId, CppDType[data2.dtype], data2.shape[0], indicesId, segmentIdsId, outputId, exceptionValuesId, isMean, 0);
  const exceptionValuesArray = backend2.readSync(exceptionValues.dataId);
  let exceptionMessage;
  switch (exceptionValuesArray[0]) {
    case 0: {
      exceptionMessage = getSparseSegmentReductionNegativeSegmentIdsErrorMessage();
      break;
    }
    case 1: {
      exceptionMessage = getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage();
      break;
    }
    case 2:
      exceptionMessage = getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(exceptionValuesArray[1], exceptionValuesArray[2]);
      break;
    case 3:
      exceptionMessage = getSparseSegmentReductionIndicesOutOfRangeErrorMessage(exceptionValuesArray[1], exceptionValuesArray[2], exceptionValuesArray[3]);
      break;
    default:
      exceptionMessage = "";
  }
  backend2.disposeData(exceptionValues.dataId);
  if (exceptionMessage) {
    backend2.disposeData(output2.dataId);
    throw new Error(exceptionMessage);
  }
  return output2;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentMean(args) {
  return sparseSegmentReduction(args, true);
}
const sparseSegmentMeanConfig = {
  kernelName: SparseSegmentMean,
  backendName: "wasm",
  setupFunc: setup$6,
  kernelFunc: sparseSegmentMean
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function sparseSegmentSum(args) {
  return sparseSegmentReduction(args, false);
}
const sparseSegmentSumConfig = {
  kernelName: SparseSegmentSum,
  backendName: "wasm",
  setupFunc: setup$6,
  kernelFunc: sparseSegmentSum
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function splitV(args) {
  const { inputs, attrs, backend: backend2 } = args;
  const { x: x2 } = inputs;
  const { numOrSizeSplits, axis } = attrs;
  const $axis = parseAxisParam(axis, x2.shape)[0];
  const splitSizes = prepareSplitSize(x2, numOrSizeSplits, $axis);
  const begin = new Array(x2.shape.length).fill(0);
  const size = x2.shape.slice();
  return splitSizes.map((s2) => {
    const xSliceSize = [...size];
    xSliceSize[$axis] = s2;
    const xSlice = slice({ inputs: { x: x2 }, attrs: { begin, size: xSliceSize }, backend: backend2 });
    begin[$axis] += s2;
    return xSlice;
  });
}
const splitVConfig = {
  kernelName: SplitV,
  backendName: "wasm",
  kernelFunc: splitV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const sqrtConfig = createUnaryKernelConfig(Sqrt);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const squareConfig = createUnaryKernelConfig(Square);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const squaredDifferenceConfig = createBinaryKernelConfig(SquaredDifference);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmStep;
function setup$5(backend2) {
  wasmStep = backend2.wasm.cwrap(Step, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function step(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { alpha: alpha2 } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmStep(xId, alpha2, CppDType[x2.dtype], outId);
  return out;
}
const stepConfig = {
  kernelName: Step,
  backendName: "wasm",
  setupFunc: setup$5,
  kernelFunc: step
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmStridedSlice;
function setup$4(backend2) {
  wasmStridedSlice = backend2.wasm.cwrap(StridedSlice, null, [
    "number",
    "array",
    "number",
    "array",
    "array",
    "array",
    "array",
    "array",
    "number",
    "number"
  ]);
}
function stridedSlice(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { x: x2 } = inputs;
  const { begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask } = attrs;
  const { finalShapeSparse, finalShape, isIdentity, sliceDim0, isSimpleSlice, begin: $begin, end: $end, strides: $strides } = sliceInfo(x2.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
  let result2;
  if (isIdentity) {
    result2 = reshape({ inputs: { x: x2 }, backend: backend2, attrs: { shape: finalShape } });
  } else if (sliceDim0 || isSimpleSlice) {
    assert$1(x2.shape.length >= 1, () => `Input must have rank at least 1, got: ${x2.shape.length}`);
    const size = computeOutShape$3($begin, $end, $strides);
    const sliced = slice({ inputs: { x: x2 }, backend: backend2, attrs: { begin: $begin, size } });
    result2 = reshape({ inputs: { x: sliced }, backend: backend2, attrs: { shape: finalShape } });
    backend2.disposeData(sliced.dataId);
  } else {
    const out = backend2.makeOutput(finalShapeSparse, "float32");
    const xId = backend2.dataIdMap.get(x2.dataId).id;
    const xStridesBytes = new Uint8Array(new Int32Array(computeStrides(x2.shape)).buffer);
    const beginBytes = new Uint8Array(new Int32Array($begin).buffer);
    const endBytes = new Uint8Array(new Int32Array($end).buffer);
    const stridesBytes = new Uint8Array(new Int32Array($strides).buffer);
    const outputShapeBytes = new Uint8Array(new Int32Array(finalShapeSparse).buffer);
    const outStridesBytes = new Uint8Array(new Int32Array(computeStrides(finalShapeSparse)).buffer);
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmStridedSlice(xId, xStridesBytes, x2.shape.length, beginBytes, endBytes, stridesBytes, outputShapeBytes, outStridesBytes, finalShapeSparse.length, outId);
    result2 = reshape({ inputs: { x: out }, backend: backend2, attrs: { shape: finalShape } });
    backend2.disposeData(out.dataId);
  }
  return result2;
}
const stridedSliceConfig = {
  kernelName: StridedSlice,
  backendName: "wasm",
  setupFunc: setup$4,
  kernelFunc: stridedSlice
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const subConfig = createBinaryKernelConfig(Sub);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmSum;
function setup$3(backend2) {
  wasmSum = backend2.wasm.cwrap(Sum, null, [
    "number",
    "number",
    "number",
    "number"
  ]);
}
function sum(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { axis, keepDims } = attrs;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  let inputId = xId;
  let input = x2;
  const { transposed, axes, originalAxes, inputWasTransposed } = permuteAxesAndTranspose(x2, axis, backend2);
  let reductionAxes = axes;
  if (inputWasTransposed) {
    const transposedId = backend2.dataIdMap.get(transposed.dataId).id;
    if (transposedId !== xId) {
      input = transposed;
      inputId = transposedId;
      reductionAxes = getInnerMostAxes(reductionAxes.length, input.shape.length);
    }
  }
  assertAxesAreInnerMostDims("sum", reductionAxes, input.shape.length);
  const [outShape, reduceShape] = computeOutAndReduceShapes(input.shape, reductionAxes);
  const reduceSize = sizeFromShape(reduceShape);
  const out = backend2.makeOutput(outShape, input.dtype);
  if (sizeFromShape(input.shape) !== 0) {
    const outId = backend2.dataIdMap.get(out.dataId).id;
    wasmSum(inputId, reduceSize, CppDType[out.dtype], outId);
  }
  if (inputWasTransposed) {
    backend2.disposeData(transposed.dataId);
  }
  if (keepDims) {
    const newShape = expandShapeToKeepDim(out.shape, originalAxes);
    out.shape = newShape;
  }
  return out;
}
const sumConfig = {
  kernelName: Sum,
  backendName: "wasm",
  setupFunc: setup$3,
  kernelFunc: sum
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tanConfig = createUnaryKernelConfig(Tan);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const tanhConfig = createUnaryKernelConfig(Tanh$1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmTile;
function setup$2(backend2) {
  wasmTile = backend2.wasm.cwrap(Tile, null, [
    "number",
    "array",
    "number",
    "array",
    "number",
    "number"
  ]);
}
function tile(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { x: x2 } = inputs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const { reps } = attrs;
  const newShape = new Array(x2.shape.length);
  for (let i2 = 0; i2 < newShape.length; i2++) {
    newShape[i2] = x2.shape[i2] * reps[i2];
  }
  const xShapeBytes = new Uint8Array(new Int32Array(x2.shape).buffer);
  const newShapeBytes = new Uint8Array(new Int32Array(newShape).buffer);
  const out = backend2.makeOutput(newShape, x2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  wasmTile(xId, xShapeBytes, x2.shape.length, newShapeBytes, newShape.length, CppDType[out.dtype], outId);
  return out;
}
const tileConfig = {
  kernelName: Tile,
  backendName: "wasm",
  setupFunc: setup$2,
  kernelFunc: tile
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmTopK;
function setup$1(backend2) {
  wasmTopK = backend2.wasm.cwrap(TopK, null, [
    "number",
    "array",
    "number",
    "number",
    "number",
    "bool",
    "number",
    "number"
  ]);
}
const topk = ({ inputs, backend: backend2, attrs }) => {
  const { x: x2 } = inputs;
  const { k: k3, sorted } = attrs;
  const xId = backend2.dataIdMap.get(x2.dataId).id;
  const xShapeBytes = new Uint8Array(new Int32Array(x2.shape).buffer);
  const outputShape = x2.shape.slice();
  outputShape[outputShape.length - 1] = k3;
  const outValues = backend2.makeOutput(outputShape, x2.dtype);
  const outValuesId = backend2.dataIdMap.get(outValues.dataId).id;
  const outIndices = backend2.makeOutput(outputShape, "int32");
  const outIndicesId = backend2.dataIdMap.get(outIndices.dataId).id;
  wasmTopK(xId, xShapeBytes, x2.shape.length, CppDType[x2.dtype], k3, sorted, outValuesId, outIndicesId);
  return [outValues, outIndices];
};
const topKConfig = {
  kernelName: TopK,
  backendName: "wasm",
  setupFunc: setup$1,
  kernelFunc: topk
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
let wasmTransform;
function setup(backend2) {
  wasmTransform = backend2.wasm.cwrap(Transform, null, [
    "number",
    "number",
    "bool",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number",
    "array",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]);
}
function transform(args) {
  const { backend: backend2, inputs, attrs } = args;
  const { image: image2, transforms } = inputs;
  const { interpolation, fillMode, fillValue, outputShape } = attrs;
  const [batch, imageHeight, imageWidth, numChannels] = image2.shape;
  const [outHeight, outWidth] = outputShape != null ? outputShape : [imageHeight, imageWidth];
  const outShape = [
    batch,
    outHeight,
    outWidth,
    numChannels
  ];
  const strides = new Uint8Array(new Int32Array(computeStrides(image2.shape)).buffer);
  const out = backend2.makeOutput(outShape, image2.dtype);
  const outId = backend2.dataIdMap.get(out.dataId).id;
  const imageData = backend2.dataIdMap.get(image2.dataId);
  const imageId = imageData.id;
  const transformsData = backend2.dataIdMap.get(transforms.dataId);
  const transformsId = transformsData.id;
  const interpolationModeId = interpolation === "nearest" ? 1 : 2;
  let fillModeId;
  switch (fillMode) {
    case "constant":
      fillModeId = 1;
      break;
    case "reflect":
      fillModeId = 2;
      break;
    case "wrap":
      fillModeId = 3;
      break;
    case "nearest":
      fillModeId = 4;
      break;
    default:
      fillModeId = 1;
      break;
  }
  wasmTransform(imageId, transformsId, transforms.shape[0] > 1, batch, outHeight, outWidth, numChannels, imageWidth, imageHeight, strides, image2.shape.length - 1, interpolationModeId, fillModeId, fillValue, outId);
  return out;
}
const transformConfig = {
  kernelName: Transform,
  backendName: "wasm",
  setupFunc: setup,
  kernelFunc: transform
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function unpack(args) {
  const { inputs, backend: backend2, attrs } = args;
  const { value } = inputs;
  let { axis } = attrs;
  if (axis < 0) {
    axis += value.shape.length;
  }
  const numOutputs = value.shape[axis];
  const rank = value.shape.length;
  const outShape = new Array(rank - 1);
  let outIndex = 0;
  for (let i2 = 0; i2 < rank; i2++) {
    if (i2 !== axis) {
      outShape[outIndex++] = value.shape[i2];
    }
  }
  const outs = new Array(numOutputs);
  const begin = new Array(rank).fill(0);
  const size = value.shape.slice();
  size[axis] = 1;
  for (let i2 = 0; i2 < outs.length; i2++) {
    begin[axis] = i2;
    outs[i2] = slice({ inputs: { x: value }, attrs: { begin, size }, backend: backend2 });
  }
  return outs.map(({ dataId, dtype }) => ({ dataId, dtype, shape: outShape }));
}
const unpackConfig = {
  kernelName: Unpack,
  backendName: "wasm",
  kernelFunc: unpack
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
function zerosLike(args) {
  const { inputs: { x: x2 }, backend: backend2 } = args;
  const out = backend2.makeOutput(x2.shape, x2.dtype);
  const outVals = backend2.typedArrayFromHeap(out);
  outVals.fill(0);
  return out;
}
const zerosLikeConfig = {
  kernelName: ZerosLike,
  backendName: "wasm",
  kernelFunc: zerosLike
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const kernelConfigs = [
  _fusedMatMulConfig,
  absConfig,
  addConfig,
  addNConfig,
  allConfig,
  anyConfig,
  argMaxConfig,
  avgPoolConfig,
  batchMatMulConfig,
  batchToSpaceNDConfig,
  castConfig,
  ceilConfig,
  clipByValueConfig,
  concatConfig,
  conv2DConfig,
  conv2DBackpropInputConfig,
  cosConfig,
  coshConfig,
  cropAndResizeConfig,
  cumprodConfig,
  cumsumConfig,
  depthToSpaceConfig,
  depthwiseConv2dNativeConfig,
  eluConfig,
  equalConfig,
  expConfig,
  expandDimsConfig,
  fillConfig,
  flipLeftRightConfig,
  floorConfig,
  floorDivConfig,
  fusedBatchNormConfig,
  fusedConv2DConfig,
  fusedDepthwiseConv2DConfig,
  gatherNdConfig,
  gatherV2Config,
  greaterConfig,
  greaterEqualConfig,
  identityConfig,
  leakyReluConfig,
  lessConfig,
  lessEqualConfig,
  logConfig,
  logicalAndConfig,
  maxConfig,
  maximumConfig,
  maxPoolConfig,
  meanConfig,
  minConfig,
  minimumConfig,
  mirrorPadConfig,
  multiplyConfig,
  negConfig,
  nonMaxSuppressionV3Config,
  nonMaxSuppressionV4Config,
  nonMaxSuppressionV5Config,
  notEqualConfig,
  oneHotConfig,
  onesLikeConfig,
  packConfig,
  padV2Config,
  powConfig,
  preluConfig,
  prodConfig,
  rangeConfig,
  realDivConfig,
  reluConfig,
  relu6Config,
  reshapeConfig,
  resizeBilinearConfig,
  reverseConfig,
  rotateWithOffsetConfig,
  roundConfig,
  rsqrtConfig,
  scatterNdConfig,
  selectConfig,
  sigmoidConfig,
  sinConfig,
  sliceConfig,
  softmaxConfig,
  spaceToBatchNDConfig,
  sparseFillEmptyRowsConfig,
  sparseReshapeConfig,
  sparseSegmentMeanConfig,
  sparseSegmentSumConfig,
  splitVConfig,
  sqrtConfig,
  squareConfig,
  squaredDifferenceConfig,
  stepConfig,
  stridedSliceConfig,
  subConfig,
  sumConfig,
  tanConfig,
  tanhConfig,
  tileConfig,
  topKConfig,
  transformConfig,
  transposeConfig,
  unpackConfig,
  zerosLikeConfig
];
for (const kernelConfig of kernelConfigs) {
  registerKernel(kernelConfig);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const ENV = env();
ENV.registerFlag("WASM_HAS_SIMD_SUPPORT", async () => WebAssembly.validate(new Uint8Array([
  0,
  97,
  115,
  109,
  1,
  0,
  0,
  0,
  1,
  4,
  1,
  96,
  0,
  0,
  3,
  2,
  1,
  0,
  10,
  9,
  1,
  7,
  0,
  65,
  0,
  253,
  15,
  26,
  11
])));
ENV.registerFlag("WASM_HAS_MULTITHREAD_SUPPORT", async () => {
  if (ENV.get("IS_NODE")) {
    return false;
  }
  try {
    new MessageChannel().port1.postMessage(new SharedArrayBuffer(1));
    return WebAssembly.validate(new Uint8Array([
      0,
      97,
      115,
      109,
      1,
      0,
      0,
      0,
      1,
      4,
      1,
      96,
      0,
      0,
      3,
      2,
      1,
      0,
      5,
      4,
      1,
      3,
      1,
      1,
      10,
      11,
      1,
      9,
      0,
      65,
      0,
      254,
      16,
      2,
      0,
      26,
      11
    ]));
  } catch (e2) {
    return false;
  }
});
var tfjsBackendWasmThreadedSimd = { exports: {} };
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
var require$$4 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(module2, exports2) {
  var WasmBackendModuleThreadedSimd2 = (() => {
    var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
    if (typeof __filename !== "undefined")
      _scriptDir = _scriptDir || __filename;
    return function(WasmBackendModuleThreadedSimd3) {
      WasmBackendModuleThreadedSimd3 = WasmBackendModuleThreadedSimd3 || {};
      function GROWABLE_HEAP_I8() {
        if (wasmMemory.buffer != buffer2) {
          updateGlobalBufferAndViews(wasmMemory.buffer);
        }
        return HEAP8;
      }
      function GROWABLE_HEAP_U8() {
        if (wasmMemory.buffer != buffer2) {
          updateGlobalBufferAndViews(wasmMemory.buffer);
        }
        return HEAPU8;
      }
      function GROWABLE_HEAP_I32() {
        if (wasmMemory.buffer != buffer2) {
          updateGlobalBufferAndViews(wasmMemory.buffer);
        }
        return HEAP32;
      }
      function GROWABLE_HEAP_F64() {
        if (wasmMemory.buffer != buffer2) {
          updateGlobalBufferAndViews(wasmMemory.buffer);
        }
        return HEAPF64;
      }
      var Module = typeof WasmBackendModuleThreadedSimd3 !== "undefined" ? WasmBackendModuleThreadedSimd3 : {};
      var readyPromiseResolve, readyPromiseReject;
      Module["ready"] = new Promise(function(resolve, reject) {
        readyPromiseResolve = resolve;
        readyPromiseReject = reject;
      });
      var beforeListeners;
      if (typeof process !== "undefined" && process.listeners) {
        beforeListeners = { uncaughtException: process.listeners("uncaughtException"), unhandledRejection: process.listeners("unhandledRejection") };
      }
      var moduleOverrides = Object.assign({}, Module);
      var quit_ = (status, toThrow) => {
        throw toThrow;
      };
      var ENVIRONMENT_IS_WEB = typeof window === "object";
      var ENVIRONMENT_IS_WORKER = typeof importScripts === "function";
      var ENVIRONMENT_IS_NODE = typeof process === "object" && typeof process.versions === "object" && typeof process.versions.node === "string";
      var ENVIRONMENT_IS_PTHREAD = Module["ENVIRONMENT_IS_PTHREAD"] || false;
      var scriptDirectory = "";
      function locateFile(path2) {
        if (Module["locateFile"]) {
          return Module["locateFile"](path2, scriptDirectory);
        }
        return scriptDirectory + path2;
      }
      var read_, readAsync, readBinary;
      function logExceptionOnExit(e2) {
        if (e2 instanceof ExitStatus)
          return;
        let toLog = e2;
        err("exiting due to exception: " + toLog);
      }
      var fs;
      var nodePath;
      var requireNodeFS;
      if (ENVIRONMENT_IS_NODE) {
        if (ENVIRONMENT_IS_WORKER) {
          scriptDirectory = require$$4.dirname(scriptDirectory) + "/";
        } else {
          scriptDirectory = __dirname + "/";
        }
        requireNodeFS = () => {
          if (!nodePath) {
            fs = require$$4;
            nodePath = require$$4;
          }
        };
        read_ = function shell_read(filename, binary) {
          requireNodeFS();
          filename = nodePath["normalize"](filename);
          return fs.readFileSync(filename, binary ? void 0 : "utf8");
        };
        readBinary = (filename) => {
          var ret = read_(filename, true);
          if (!ret.buffer) {
            ret = new Uint8Array(ret);
          }
          return ret;
        };
        readAsync = (filename, onload, onerror) => {
          requireNodeFS();
          filename = nodePath["normalize"](filename);
          fs.readFile(filename, function(err2, data2) {
            if (err2)
              onerror(err2);
            else
              onload(data2.buffer);
          });
        };
        if (process["argv"].length > 1) {
          process["argv"][1].replace(/\\/g, "/");
        }
        process["argv"].slice(2);
        process["on"]("uncaughtException", function(ex) {
          if (!(ex instanceof ExitStatus)) {
            throw ex;
          }
        });
        process["on"]("unhandledRejection", function(reason) {
          throw reason;
        });
        quit_ = (status, toThrow) => {
          if (keepRuntimeAlive()) {
            process["exitCode"] = status;
            throw toThrow;
          }
          logExceptionOnExit(toThrow);
          process["exit"](status);
        };
        Module["inspect"] = function() {
          return "[Emscripten Module object]";
        };
        let nodeWorkerThreads;
        try {
          nodeWorkerThreads = require("worker_threads");
        } catch (e2) {
          console.error('The "worker_threads" module is not supported in this node.js build - perhaps a newer version is needed?');
          throw e2;
        }
        commonjsGlobal.Worker = nodeWorkerThreads.Worker;
      } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
        if (ENVIRONMENT_IS_WORKER) {
          scriptDirectory = self.location.href;
        } else if (typeof document !== "undefined" && document.currentScript) {
          scriptDirectory = document.currentScript.src;
        }
        if (typeof _scriptDir !== "undefined" && _scriptDir) {
          scriptDirectory = _scriptDir;
        }
        if (scriptDirectory.indexOf("blob:") !== 0) {
          scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
        } else {
          scriptDirectory = "";
        }
        if (!ENVIRONMENT_IS_NODE) {
          read_ = (url) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open("GET", url, false);
            xhr2.send(null);
            return xhr2.responseText;
          };
          if (ENVIRONMENT_IS_WORKER) {
            readBinary = (url) => {
              var xhr2 = new XMLHttpRequest();
              xhr2.open("GET", url, false);
              xhr2.responseType = "arraybuffer";
              xhr2.send(null);
              return new Uint8Array(xhr2.response);
            };
          }
          readAsync = (url, onload, onerror) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open("GET", url, true);
            xhr2.responseType = "arraybuffer";
            xhr2.onload = () => {
              if (xhr2.status == 200 || xhr2.status == 0 && xhr2.response) {
                onload(xhr2.response);
                return;
              }
              onerror();
            };
            xhr2.onerror = onerror;
            xhr2.send(null);
          };
        }
      } else
        ;
      if (ENVIRONMENT_IS_NODE) {
        if (typeof performance === "undefined") {
          commonjsGlobal.performance = require$$4.performance;
        }
      }
      var defaultPrint = console.log.bind(console);
      var defaultPrintErr = console.warn.bind(console);
      if (ENVIRONMENT_IS_NODE) {
        requireNodeFS();
        defaultPrint = (str) => fs.writeSync(1, str + "\n");
        defaultPrintErr = (str) => fs.writeSync(2, str + "\n");
      }
      var out = Module["print"] || defaultPrint;
      var err = Module["printErr"] || defaultPrintErr;
      Object.assign(Module, moduleOverrides);
      moduleOverrides = null;
      if (Module["arguments"])
        ;
      if (Module["thisProgram"])
        ;
      if (Module["quit"])
        quit_ = Module["quit"];
      function warnOnce2(text) {
        if (!warnOnce2.shown)
          warnOnce2.shown = {};
        if (!warnOnce2.shown[text]) {
          warnOnce2.shown[text] = 1;
          err(text);
        }
      }
      var wasmBinary;
      if (Module["wasmBinary"])
        wasmBinary = Module["wasmBinary"];
      var noExitRuntime = Module["noExitRuntime"] || true;
      if (typeof WebAssembly !== "object") {
        abort("no native wasm support detected");
      }
      var wasmMemory;
      var wasmModule;
      var ABORT = false;
      var EXITSTATUS;
      function getCFunc(ident) {
        var func = Module["_" + ident];
        return func;
      }
      function ccall(ident, returnType, argTypes, args, opts) {
        var toC = { "string": function(str) {
          var ret2 = 0;
          if (str !== null && str !== void 0 && str !== 0) {
            var len = (str.length << 2) + 1;
            ret2 = stackAlloc(len);
            stringToUTF8(str, ret2, len);
          }
          return ret2;
        }, "array": function(arr2) {
          var ret2 = stackAlloc(arr2.length);
          writeArrayToMemory(arr2, ret2);
          return ret2;
        } };
        function convertReturnValue(ret2) {
          if (returnType === "string")
            return UTF8ToString(ret2);
          if (returnType === "boolean")
            return Boolean(ret2);
          return ret2;
        }
        var func = getCFunc(ident);
        var cArgs = [];
        var stack2 = 0;
        if (args) {
          for (var i2 = 0; i2 < args.length; i2++) {
            var converter = toC[argTypes[i2]];
            if (converter) {
              if (stack2 === 0)
                stack2 = stackSave();
              cArgs[i2] = converter(args[i2]);
            } else {
              cArgs[i2] = args[i2];
            }
          }
        }
        var ret = func.apply(null, cArgs);
        function onDone(ret2) {
          if (stack2 !== 0)
            stackRestore(stack2);
          return convertReturnValue(ret2);
        }
        ret = onDone(ret);
        return ret;
      }
      function cwrap(ident, returnType, argTypes, opts) {
        argTypes = argTypes || [];
        var numericArgs = argTypes.every(function(type) {
          return type === "number";
        });
        var numericRet = returnType !== "string";
        if (numericRet && numericArgs && !opts) {
          return getCFunc(ident);
        }
        return function() {
          return ccall(ident, returnType, argTypes, arguments);
        };
      }
      function TextDecoderWrapper(encoding) {
        var textDecoder = new TextDecoder(encoding);
        this.decode = (data2) => {
          if (data2.buffer instanceof SharedArrayBuffer) {
            data2 = new Uint8Array(data2);
          }
          return textDecoder.decode.call(textDecoder, data2);
        };
      }
      var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoderWrapper("utf8") : void 0;
      function UTF8ArrayToString(heap, idx, maxBytesToRead) {
        var endIdx = idx + maxBytesToRead;
        var endPtr = idx;
        while (heap[endPtr] && !(endPtr >= endIdx))
          ++endPtr;
        if (endPtr - idx > 16 && heap.subarray && UTF8Decoder) {
          return UTF8Decoder.decode(heap.subarray(idx, endPtr));
        } else {
          var str = "";
          while (idx < endPtr) {
            var u0 = heap[idx++];
            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }
            var u1 = heap[idx++] & 63;
            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }
            var u2 = heap[idx++] & 63;
            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heap[idx++] & 63;
            }
            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }
        }
        return str;
      }
      function UTF8ToString(ptr, maxBytesToRead) {
        return ptr ? UTF8ArrayToString(GROWABLE_HEAP_U8(), ptr, maxBytesToRead) : "";
      }
      function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
        if (!(maxBytesToWrite > 0))
          return 0;
        var startIdx = outIdx;
        var endIdx = outIdx + maxBytesToWrite - 1;
        for (var i2 = 0; i2 < str.length; ++i2) {
          var u2 = str.charCodeAt(i2);
          if (u2 >= 55296 && u2 <= 57343) {
            var u1 = str.charCodeAt(++i2);
            u2 = 65536 + ((u2 & 1023) << 10) | u1 & 1023;
          }
          if (u2 <= 127) {
            if (outIdx >= endIdx)
              break;
            heap[outIdx++] = u2;
          } else if (u2 <= 2047) {
            if (outIdx + 1 >= endIdx)
              break;
            heap[outIdx++] = 192 | u2 >> 6;
            heap[outIdx++] = 128 | u2 & 63;
          } else if (u2 <= 65535) {
            if (outIdx + 2 >= endIdx)
              break;
            heap[outIdx++] = 224 | u2 >> 12;
            heap[outIdx++] = 128 | u2 >> 6 & 63;
            heap[outIdx++] = 128 | u2 & 63;
          } else {
            if (outIdx + 3 >= endIdx)
              break;
            heap[outIdx++] = 240 | u2 >> 18;
            heap[outIdx++] = 128 | u2 >> 12 & 63;
            heap[outIdx++] = 128 | u2 >> 6 & 63;
            heap[outIdx++] = 128 | u2 & 63;
          }
        }
        heap[outIdx] = 0;
        return outIdx - startIdx;
      }
      function stringToUTF8(str, outPtr, maxBytesToWrite) {
        return stringToUTF8Array(str, GROWABLE_HEAP_U8(), outPtr, maxBytesToWrite);
      }
      function lengthBytesUTF8(str) {
        var len = 0;
        for (var i2 = 0; i2 < str.length; ++i2) {
          var u2 = str.charCodeAt(i2);
          if (u2 >= 55296 && u2 <= 57343)
            u2 = 65536 + ((u2 & 1023) << 10) | str.charCodeAt(++i2) & 1023;
          if (u2 <= 127)
            ++len;
          else if (u2 <= 2047)
            len += 2;
          else if (u2 <= 65535)
            len += 3;
          else
            len += 4;
        }
        return len;
      }
      typeof TextDecoder !== "undefined" ? new TextDecoderWrapper("utf-16le") : void 0;
      function writeArrayToMemory(array, buffer3) {
        GROWABLE_HEAP_I8().set(array, buffer3);
      }
      function alignUp(x2, multiple) {
        if (x2 % multiple > 0) {
          x2 += multiple - x2 % multiple;
        }
        return x2;
      }
      var buffer2, HEAP8, HEAPU8, HEAP32, HEAPF64;
      if (ENVIRONMENT_IS_PTHREAD) {
        buffer2 = Module["buffer"];
      }
      function updateGlobalBufferAndViews(buf) {
        buffer2 = buf;
        Module["HEAP8"] = HEAP8 = new Int8Array(buf);
        Module["HEAP16"] = new Int16Array(buf);
        Module["HEAP32"] = HEAP32 = new Int32Array(buf);
        Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
        Module["HEAPU16"] = new Uint16Array(buf);
        Module["HEAPU32"] = new Uint32Array(buf);
        Module["HEAPF32"] = new Float32Array(buf);
        Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
      }
      var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
      if (ENVIRONMENT_IS_PTHREAD) {
        wasmMemory = Module["wasmMemory"];
        buffer2 = Module["buffer"];
      } else {
        if (Module["wasmMemory"]) {
          wasmMemory = Module["wasmMemory"];
        } else {
          wasmMemory = new WebAssembly.Memory({ "initial": INITIAL_MEMORY / 65536, "maximum": 2147483648 / 65536, "shared": true });
          if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
            err("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag");
            if (ENVIRONMENT_IS_NODE) {
              console.log("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and also use a recent version)");
            }
            throw Error("bad memory");
          }
        }
      }
      if (wasmMemory) {
        buffer2 = wasmMemory.buffer;
      }
      INITIAL_MEMORY = buffer2.byteLength;
      updateGlobalBufferAndViews(buffer2);
      var wasmTable;
      var __ATPRERUN__ = [];
      var __ATINIT__ = [];
      var __ATPOSTRUN__ = [];
      var runtimeKeepaliveCounter = 0;
      function keepRuntimeAlive() {
        return noExitRuntime || runtimeKeepaliveCounter > 0;
      }
      function preRun() {
        if (Module["preRun"]) {
          if (typeof Module["preRun"] == "function")
            Module["preRun"] = [Module["preRun"]];
          while (Module["preRun"].length) {
            addOnPreRun(Module["preRun"].shift());
          }
        }
        callRuntimeCallbacks(__ATPRERUN__);
      }
      function initRuntime() {
        if (ENVIRONMENT_IS_PTHREAD)
          return;
        callRuntimeCallbacks(__ATINIT__);
      }
      function exitRuntime() {
        if (ENVIRONMENT_IS_PTHREAD)
          return;
        PThread.terminateAllThreads();
      }
      function postRun() {
        if (ENVIRONMENT_IS_PTHREAD)
          return;
        if (Module["postRun"]) {
          if (typeof Module["postRun"] == "function")
            Module["postRun"] = [Module["postRun"]];
          while (Module["postRun"].length) {
            addOnPostRun(Module["postRun"].shift());
          }
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
      }
      function addOnPreRun(cb2) {
        __ATPRERUN__.unshift(cb2);
      }
      function addOnInit(cb2) {
        __ATINIT__.unshift(cb2);
      }
      function addOnPostRun(cb2) {
        __ATPOSTRUN__.unshift(cb2);
      }
      var runDependencies = 0;
      var dependenciesFulfilled = null;
      function addRunDependency(id2) {
        runDependencies++;
        if (Module["monitorRunDependencies"]) {
          Module["monitorRunDependencies"](runDependencies);
        }
      }
      function removeRunDependency(id2) {
        runDependencies--;
        if (Module["monitorRunDependencies"]) {
          Module["monitorRunDependencies"](runDependencies);
        }
        if (runDependencies == 0) {
          if (dependenciesFulfilled) {
            var callback = dependenciesFulfilled;
            dependenciesFulfilled = null;
            callback();
          }
        }
      }
      Module["preloadedImages"] = {};
      Module["preloadedAudios"] = {};
      function abort(what) {
        if (ENVIRONMENT_IS_PTHREAD) {
          postMessage({ "cmd": "onAbort", "arg": what });
        } else {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }
        }
        what = "Aborted(" + what + ")";
        err(what);
        ABORT = true;
        EXITSTATUS = 1;
        what += ". Build with -s ASSERTIONS=1 for more info.";
        var e2 = new WebAssembly.RuntimeError(what);
        readyPromiseReject(e2);
        throw e2;
      }
      var dataURIPrefix = "data:application/octet-stream;base64,";
      function isDataURI2(filename) {
        return filename.startsWith(dataURIPrefix);
      }
      function isFileURI(filename) {
        return filename.startsWith("file://");
      }
      var wasmBinaryFile;
      wasmBinaryFile = "tfjs-backend-wasm-threaded-simd.wasm";
      if (!isDataURI2(wasmBinaryFile)) {
        wasmBinaryFile = locateFile(wasmBinaryFile);
      }
      function getBinary(file) {
        try {
          if (file == wasmBinaryFile && wasmBinary) {
            return new Uint8Array(wasmBinary);
          }
          if (readBinary) {
            return readBinary(file);
          } else {
            throw "both async and sync fetching of the wasm failed";
          }
        } catch (err2) {
          abort(err2);
        }
      }
      function getBinaryPromise() {
        if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
          if (typeof fetch === "function" && !isFileURI(wasmBinaryFile)) {
            return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
              if (!response["ok"]) {
                throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
              }
              return response["arrayBuffer"]();
            }).catch(function() {
              return getBinary(wasmBinaryFile);
            });
          } else {
            if (readAsync) {
              return new Promise(function(resolve, reject) {
                readAsync(wasmBinaryFile, function(response) {
                  resolve(new Uint8Array(response));
                }, reject);
              });
            }
          }
        }
        return Promise.resolve().then(function() {
          return getBinary(wasmBinaryFile);
        });
      }
      function createWasm() {
        var info = { "env": asmLibraryArg, "wasi_snapshot_preview1": asmLibraryArg };
        function receiveInstance(instance2, module3) {
          var exports4 = instance2.exports;
          Module["asm"] = exports4;
          registerTlsInit(Module["asm"]["emscripten_tls_init"]);
          wasmTable = Module["asm"]["__indirect_function_table"];
          addOnInit(Module["asm"]["__wasm_call_ctors"]);
          wasmModule = module3;
          if (!ENVIRONMENT_IS_PTHREAD) {
            var numWorkersToLoad = PThread.unusedWorkers.length;
            PThread.unusedWorkers.forEach(function(w2) {
              PThread.loadWasmModuleToWorker(w2, function() {
                if (!--numWorkersToLoad)
                  removeRunDependency();
              });
            });
          }
        }
        if (!ENVIRONMENT_IS_PTHREAD) {
          addRunDependency();
        }
        function receiveInstantiationResult(result2) {
          receiveInstance(result2["instance"], result2["module"]);
        }
        function instantiateArrayBuffer(receiver) {
          return getBinaryPromise().then(function(binary) {
            return WebAssembly.instantiate(binary, info);
          }).then(function(instance2) {
            return instance2;
          }).then(receiver, function(reason) {
            err("failed to asynchronously prepare wasm: " + reason);
            abort(reason);
          });
        }
        function instantiateAsync() {
          if (!wasmBinary && typeof WebAssembly.instantiateStreaming === "function" && !isDataURI2(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && typeof fetch === "function") {
            return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
              var result2 = WebAssembly.instantiateStreaming(response, info);
              return result2.then(receiveInstantiationResult, function(reason) {
                err("wasm streaming compile failed: " + reason);
                err("falling back to ArrayBuffer instantiation");
                return instantiateArrayBuffer(receiveInstantiationResult);
              });
            });
          } else {
            return instantiateArrayBuffer(receiveInstantiationResult);
          }
        }
        if (Module["instantiateWasm"]) {
          try {
            var exports3 = Module["instantiateWasm"](info, receiveInstance);
            return exports3;
          } catch (e2) {
            err("Module.instantiateWasm callback failed with error: " + e2);
            return false;
          }
        }
        instantiateAsync().catch(readyPromiseReject);
        return {};
      }
      var ASM_CONSTS = {};
      function callRuntimeCallbacks(callbacks) {
        while (callbacks.length > 0) {
          var callback = callbacks.shift();
          if (typeof callback == "function") {
            callback(Module);
            continue;
          }
          var func = callback.func;
          if (typeof func === "number") {
            if (callback.arg === void 0) {
              getWasmTableEntry(func)();
            } else {
              getWasmTableEntry(func)(callback.arg);
            }
          } else {
            func(callback.arg === void 0 ? null : callback.arg);
          }
        }
      }
      function withStackSave(f2) {
        var stack2 = stackSave();
        var ret = f2();
        stackRestore(stack2);
        return ret;
      }
      function killThread(pthread_ptr) {
        GROWABLE_HEAP_I32()[pthread_ptr >> 2] = 0;
        var pthread = PThread.pthreads[pthread_ptr];
        delete PThread.pthreads[pthread_ptr];
        pthread.worker.terminate();
        __emscripten_thread_free_data(pthread_ptr);
        PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(pthread.worker), 1);
        pthread.worker.pthread = void 0;
      }
      function cancelThread(pthread_ptr) {
        var pthread = PThread.pthreads[pthread_ptr];
        pthread.worker.postMessage({ "cmd": "cancel" });
      }
      function cleanupThread(pthread_ptr) {
        var pthread = PThread.pthreads[pthread_ptr];
        if (pthread) {
          GROWABLE_HEAP_I32()[pthread_ptr >> 2] = 0;
          var worker2 = pthread.worker;
          PThread.returnWorkerToPool(worker2);
        }
      }
      function _exit(status) {
        exit(status);
      }
      function handleException(e2) {
        if (e2 instanceof ExitStatus || e2 == "unwind") {
          return EXITSTATUS;
        }
        quit_(1, e2);
      }
      var PThread = { unusedWorkers: [], runningWorkers: [], tlsInitFunctions: [], init: function() {
        if (ENVIRONMENT_IS_PTHREAD) {
          PThread.initWorker();
        } else {
          PThread.initMainThread();
        }
      }, initMainThread: function() {
        var pthreadPoolSize = 8;
        for (var i2 = 0; i2 < pthreadPoolSize; ++i2) {
          PThread.allocateUnusedWorker();
        }
      }, initWorker: function() {
        noExitRuntime = false;
      }, pthreads: {}, setExitStatus: function(status) {
        EXITSTATUS = status;
      }, terminateAllThreads: function() {
        for (var t2 in PThread.pthreads) {
          var pthread = PThread.pthreads[t2];
          if (pthread && pthread.worker) {
            PThread.returnWorkerToPool(pthread.worker);
          }
        }
        for (var i2 = 0; i2 < PThread.unusedWorkers.length; ++i2) {
          var worker2 = PThread.unusedWorkers[i2];
          worker2.terminate();
        }
        PThread.unusedWorkers = [];
      }, returnWorkerToPool: function(worker2) {
        PThread.runWithoutMainThreadQueuedCalls(function() {
          delete PThread.pthreads[worker2.pthread.threadInfoStruct];
          PThread.unusedWorkers.push(worker2);
          PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker2), 1);
          __emscripten_thread_free_data(worker2.pthread.threadInfoStruct);
          worker2.pthread = void 0;
        });
      }, runWithoutMainThreadQueuedCalls: function(func) {
        GROWABLE_HEAP_I32()[__emscripten_allow_main_runtime_queued_calls >> 2] = 0;
        try {
          func();
        } finally {
          GROWABLE_HEAP_I32()[__emscripten_allow_main_runtime_queued_calls >> 2] = 1;
        }
      }, receiveObjectTransfer: function(data2) {
      }, threadInit: function() {
        for (var i2 in PThread.tlsInitFunctions) {
          PThread.tlsInitFunctions[i2]();
        }
      }, loadWasmModuleToWorker: function(worker2, onFinishedLoading) {
        worker2.onmessage = (e2) => {
          var d2 = e2["data"];
          var cmd = d2["cmd"];
          if (worker2.pthread)
            PThread.currentProxiedOperationCallerThread = worker2.pthread.threadInfoStruct;
          if (d2["targetThread"] && d2["targetThread"] != _pthread_self()) {
            var thread = PThread.pthreads[d2.targetThread];
            if (thread) {
              thread.worker.postMessage(d2, d2["transferList"]);
            } else {
              err('Internal error! Worker sent a message "' + cmd + '" to target pthread ' + d2["targetThread"] + ", but that thread no longer exists!");
            }
            PThread.currentProxiedOperationCallerThread = void 0;
            return;
          }
          if (cmd === "processQueuedMainThreadWork") {
            _emscripten_main_thread_process_queued_calls();
          } else if (cmd === "spawnThread") {
            spawnThread(d2);
          } else if (cmd === "cleanupThread") {
            cleanupThread(d2["thread"]);
          } else if (cmd === "killThread") {
            killThread(d2["thread"]);
          } else if (cmd === "cancelThread") {
            cancelThread(d2["thread"]);
          } else if (cmd === "loaded") {
            worker2.loaded = true;
            if (onFinishedLoading)
              onFinishedLoading(worker2);
            if (worker2.runPthread) {
              worker2.runPthread();
              delete worker2.runPthread;
            }
          } else if (cmd === "print") {
            out("Thread " + d2["threadId"] + ": " + d2["text"]);
          } else if (cmd === "printErr") {
            err("Thread " + d2["threadId"] + ": " + d2["text"]);
          } else if (cmd === "alert") {
            alert("Thread " + d2["threadId"] + ": " + d2["text"]);
          } else if (d2.target === "setimmediate") {
            worker2.postMessage(d2);
          } else if (cmd === "onAbort") {
            if (Module["onAbort"]) {
              Module["onAbort"](d2["arg"]);
            }
          } else {
            err("worker sent an unknown command " + cmd);
          }
          PThread.currentProxiedOperationCallerThread = void 0;
        };
        worker2.onerror = (e2) => {
          var message2 = "worker sent an error!";
          err(message2 + " " + e2.filename + ":" + e2.lineno + ": " + e2.message);
          throw e2;
        };
        if (ENVIRONMENT_IS_NODE) {
          worker2.on("message", function(data2) {
            worker2.onmessage({ data: data2 });
          });
          worker2.on("error", function(e2) {
            worker2.onerror(e2);
          });
          worker2.on("detachedExit", function() {
          });
        }
        worker2.postMessage({ "cmd": "load", "urlOrBlob": Module["mainScriptUrlOrBlob"] || _scriptDir, "wasmMemory": wasmMemory, "wasmModule": wasmModule });
      }, allocateUnusedWorker: function() {
        var pthreadMainJs = locateFile("tfjs-backend-wasm-threaded-simd.worker.js");
        PThread.unusedWorkers.push(new Worker(pthreadMainJs));
      }, getNewWorker: function() {
        if (PThread.unusedWorkers.length == 0) {
          PThread.allocateUnusedWorker();
          PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);
        }
        return PThread.unusedWorkers.pop();
      } };
      function establishStackSpace() {
        var pthread_ptr = _pthread_self();
        var stackTop = GROWABLE_HEAP_I32()[pthread_ptr + 44 >> 2];
        var stackSize = GROWABLE_HEAP_I32()[pthread_ptr + 48 >> 2];
        var stackMax = stackTop - stackSize;
        _emscripten_stack_set_limits(stackTop, stackMax);
        stackRestore(stackTop);
      }
      Module["establishStackSpace"] = establishStackSpace;
      function exitOnMainThread(returnCode) {
        if (ENVIRONMENT_IS_PTHREAD)
          return _emscripten_proxy_to_main_thread_js(1, 0, returnCode);
        try {
          _exit(returnCode);
        } catch (e2) {
          handleException(e2);
        }
      }
      var wasmTableMirror = [];
      function getWasmTableEntry(funcPtr) {
        var func = wasmTableMirror[funcPtr];
        if (!func) {
          if (funcPtr >= wasmTableMirror.length)
            wasmTableMirror.length = funcPtr + 1;
          wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
        }
        return func;
      }
      function invokeEntryPoint(ptr, arg) {
        return getWasmTableEntry(ptr)(arg);
      }
      Module["invokeEntryPoint"] = invokeEntryPoint;
      function registerTlsInit(tlsInitFunc, moduleExports, metadata2) {
        PThread.tlsInitFunctions.push(tlsInitFunc);
      }
      var _emscripten_get_now;
      if (ENVIRONMENT_IS_NODE) {
        _emscripten_get_now = () => {
          var t2 = process["hrtime"]();
          return t2[0] * 1e3 + t2[1] / 1e6;
        };
      } else if (ENVIRONMENT_IS_PTHREAD) {
        _emscripten_get_now = () => performance.now() - Module["__performance_now_clock_drift"];
      } else
        _emscripten_get_now = () => performance.now();
      var _emscripten_get_now_is_monotonic = true;
      function setErrNo(value) {
        GROWABLE_HEAP_I32()[___errno_location() >> 2] = value;
        return value;
      }
      function _clock_gettime(clk_id, tp) {
        var now2;
        if (clk_id === 0) {
          now2 = Date.now();
        } else if ((clk_id === 1 || clk_id === 4) && _emscripten_get_now_is_monotonic) {
          now2 = _emscripten_get_now();
        } else {
          setErrNo(28);
          return -1;
        }
        GROWABLE_HEAP_I32()[tp >> 2] = now2 / 1e3 | 0;
        GROWABLE_HEAP_I32()[tp + 4 >> 2] = now2 % 1e3 * 1e3 * 1e3 | 0;
        return 0;
      }
      function ___clock_gettime(a0, a12) {
        return _clock_gettime(a0, a12);
      }
      function ___emscripten_init_main_thread_js(tb) {
        __emscripten_thread_init(tb, !ENVIRONMENT_IS_WORKER, 1, !ENVIRONMENT_IS_WEB);
        PThread.threadInit();
      }
      function ___emscripten_thread_cleanup(thread) {
        if (!ENVIRONMENT_IS_PTHREAD)
          cleanupThread(thread);
        else
          postMessage({ "cmd": "cleanupThread", "thread": thread });
      }
      function spawnThread(threadParams) {
        var worker2 = PThread.getNewWorker();
        if (!worker2) {
          return 6;
        }
        PThread.runningWorkers.push(worker2);
        var pthread = PThread.pthreads[threadParams.pthread_ptr] = { worker: worker2, threadInfoStruct: threadParams.pthread_ptr };
        worker2.pthread = pthread;
        var msg = { "cmd": "run", "start_routine": threadParams.startRoutine, "arg": threadParams.arg, "threadInfoStruct": threadParams.pthread_ptr };
        worker2.runPthread = () => {
          msg.time = performance.now();
          worker2.postMessage(msg, threadParams.transferList);
        };
        if (worker2.loaded) {
          worker2.runPthread();
          delete worker2.runPthread;
        }
        return 0;
      }
      function ___pthread_create_js(pthread_ptr, attr, start_routine, arg) {
        if (typeof SharedArrayBuffer === "undefined") {
          err("Current environment does not support SharedArrayBuffer, pthreads are not available!");
          return 6;
        }
        var transferList = [];
        var error3 = 0;
        if (ENVIRONMENT_IS_PTHREAD && (transferList.length === 0 || error3)) {
          return _emscripten_sync_run_in_main_thread_4(687865856, pthread_ptr, attr, start_routine, arg);
        }
        var threadParams = { startRoutine: start_routine, pthread_ptr, arg, transferList };
        if (ENVIRONMENT_IS_PTHREAD) {
          threadParams.cmd = "spawnThread";
          postMessage(threadParams, transferList);
          return 0;
        }
        return spawnThread(threadParams);
      }
      function __emscripten_default_pthread_stack_size() {
        return 2097152;
      }
      function __emscripten_notify_thread_queue(targetThreadId, mainThreadId) {
        if (targetThreadId == mainThreadId) {
          postMessage({ "cmd": "processQueuedMainThreadWork" });
        } else if (ENVIRONMENT_IS_PTHREAD) {
          postMessage({ "targetThread": targetThreadId, "cmd": "processThreadQueue" });
        } else {
          var pthread = PThread.pthreads[targetThreadId];
          var worker2 = pthread && pthread.worker;
          if (!worker2) {
            return;
          }
          worker2.postMessage({ "cmd": "processThreadQueue" });
        }
        return 1;
      }
      function _abort() {
        abort("");
      }
      function _emscripten_check_blocking_allowed() {
        if (ENVIRONMENT_IS_NODE)
          return;
        if (ENVIRONMENT_IS_WORKER)
          return;
        warnOnce2("Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread");
      }
      function _emscripten_get_heap_max() {
        return 2147483648;
      }
      function _emscripten_memcpy_big(dest, src2, num) {
        GROWABLE_HEAP_U8().copyWithin(dest, src2, src2 + num);
      }
      function _emscripten_num_logical_cores() {
        if (ENVIRONMENT_IS_NODE)
          return require$$4.cpus().length;
        return navigator["hardwareConcurrency"];
      }
      function _emscripten_proxy_to_main_thread_js(index2, sync2) {
        var numCallArgs = arguments.length - 2;
        var outerArgs = arguments;
        return withStackSave(function() {
          var serializedNumCallArgs = numCallArgs;
          var args = stackAlloc(serializedNumCallArgs * 8);
          var b2 = args >> 3;
          for (var i2 = 0; i2 < numCallArgs; i2++) {
            var arg = outerArgs[2 + i2];
            GROWABLE_HEAP_F64()[b2 + i2] = arg;
          }
          return _emscripten_run_in_main_runtime_thread_js(index2, serializedNumCallArgs, args, sync2);
        });
      }
      var _emscripten_receive_on_main_thread_js_callArgs = [];
      function _emscripten_receive_on_main_thread_js(index2, numCallArgs, args) {
        _emscripten_receive_on_main_thread_js_callArgs.length = numCallArgs;
        var b2 = args >> 3;
        for (var i2 = 0; i2 < numCallArgs; i2++) {
          _emscripten_receive_on_main_thread_js_callArgs[i2] = GROWABLE_HEAP_F64()[b2 + i2];
        }
        var isEmAsmConst = index2 < 0;
        var func = !isEmAsmConst ? proxiedFunctionTable[index2] : ASM_CONSTS[-index2 - 1];
        return func.apply(null, _emscripten_receive_on_main_thread_js_callArgs);
      }
      function emscripten_realloc_buffer(size) {
        try {
          wasmMemory.grow(size - buffer2.byteLength + 65535 >>> 16);
          updateGlobalBufferAndViews(wasmMemory.buffer);
          return 1;
        } catch (e2) {
        }
      }
      function _emscripten_resize_heap(requestedSize) {
        var oldSize = GROWABLE_HEAP_U8().length;
        requestedSize = requestedSize >>> 0;
        if (requestedSize <= oldSize) {
          return false;
        }
        var maxHeapSize = _emscripten_get_heap_max();
        if (requestedSize > maxHeapSize) {
          return false;
        }
        for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
          var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
          overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
          var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
          var replacement = emscripten_realloc_buffer(newSize);
          if (replacement) {
            return true;
          }
        }
        return false;
      }
      var JSEvents = { inEventHandler: 0, removeAllEventListeners: function() {
        for (var i2 = JSEvents.eventHandlers.length - 1; i2 >= 0; --i2) {
          JSEvents._removeHandler(i2);
        }
        JSEvents.eventHandlers = [];
        JSEvents.deferredCalls = [];
      }, registerRemoveEventListeners: function() {
        if (!JSEvents.removeEventListenersRegistered) {
          JSEvents.removeEventListenersRegistered = true;
        }
      }, deferredCalls: [], deferCall: function(targetFunction, precedence, argsList) {
        function arraysHaveEqualContent(arrA, arrB) {
          if (arrA.length != arrB.length)
            return false;
          for (var i3 in arrA) {
            if (arrA[i3] != arrB[i3])
              return false;
          }
          return true;
        }
        for (var i2 in JSEvents.deferredCalls) {
          var call = JSEvents.deferredCalls[i2];
          if (call.targetFunction == targetFunction && arraysHaveEqualContent(call.argsList, argsList)) {
            return;
          }
        }
        JSEvents.deferredCalls.push({ targetFunction, precedence, argsList });
        JSEvents.deferredCalls.sort(function(x2, y2) {
          return x2.precedence < y2.precedence;
        });
      }, removeDeferredCalls: function(targetFunction) {
        for (var i2 = 0; i2 < JSEvents.deferredCalls.length; ++i2) {
          if (JSEvents.deferredCalls[i2].targetFunction == targetFunction) {
            JSEvents.deferredCalls.splice(i2, 1);
            --i2;
          }
        }
      }, canPerformEventHandlerRequests: function() {
        return JSEvents.inEventHandler && JSEvents.currentEventHandler.allowsDeferredCalls;
      }, runDeferredCalls: function() {
        if (!JSEvents.canPerformEventHandlerRequests()) {
          return;
        }
        for (var i2 = 0; i2 < JSEvents.deferredCalls.length; ++i2) {
          var call = JSEvents.deferredCalls[i2];
          JSEvents.deferredCalls.splice(i2, 1);
          --i2;
          call.targetFunction.apply(null, call.argsList);
        }
      }, eventHandlers: [], removeAllHandlersOnTarget: function(target, eventTypeString) {
        for (var i2 = 0; i2 < JSEvents.eventHandlers.length; ++i2) {
          if (JSEvents.eventHandlers[i2].target == target && (!eventTypeString || eventTypeString == JSEvents.eventHandlers[i2].eventTypeString)) {
            JSEvents._removeHandler(i2--);
          }
        }
      }, _removeHandler: function(i2) {
        var h2 = JSEvents.eventHandlers[i2];
        h2.target.removeEventListener(h2.eventTypeString, h2.eventListenerFunc, h2.useCapture);
        JSEvents.eventHandlers.splice(i2, 1);
      }, registerOrRemoveHandler: function(eventHandler) {
        var jsEventHandler = function jsEventHandler2(event) {
          ++JSEvents.inEventHandler;
          JSEvents.currentEventHandler = eventHandler;
          JSEvents.runDeferredCalls();
          eventHandler.handlerFunc(event);
          JSEvents.runDeferredCalls();
          --JSEvents.inEventHandler;
        };
        if (eventHandler.callbackfunc) {
          eventHandler.eventListenerFunc = jsEventHandler;
          eventHandler.target.addEventListener(eventHandler.eventTypeString, jsEventHandler, eventHandler.useCapture);
          JSEvents.eventHandlers.push(eventHandler);
          JSEvents.registerRemoveEventListeners();
        } else {
          for (var i2 = 0; i2 < JSEvents.eventHandlers.length; ++i2) {
            if (JSEvents.eventHandlers[i2].target == eventHandler.target && JSEvents.eventHandlers[i2].eventTypeString == eventHandler.eventTypeString) {
              JSEvents._removeHandler(i2--);
            }
          }
        }
      }, queueEventHandlerOnThread_iiii: function(targetThread, eventHandlerFunc, eventTypeId, eventData, userData) {
        withStackSave(function() {
          var varargs = stackAlloc(12);
          GROWABLE_HEAP_I32()[varargs >> 2] = eventTypeId;
          GROWABLE_HEAP_I32()[varargs + 4 >> 2] = eventData;
          GROWABLE_HEAP_I32()[varargs + 8 >> 2] = userData;
          _emscripten_dispatch_to_thread_(targetThread, 637534208, eventHandlerFunc, eventData, varargs);
        });
      }, getTargetThreadForEventCallback: function(targetThread) {
        switch (targetThread) {
          case 1:
            return 0;
          case 2:
            return PThread.currentProxiedOperationCallerThread;
          default:
            return targetThread;
        }
      }, getNodeNameForTarget: function(target) {
        if (!target)
          return "";
        if (target == window)
          return "#window";
        if (target == screen)
          return "#screen";
        return target && target.nodeName ? target.nodeName : "";
      }, fullscreenEnabled: function() {
        return document.fullscreenEnabled || document.webkitFullscreenEnabled;
      } };
      function stringToNewUTF8(jsString) {
        var length = lengthBytesUTF8(jsString) + 1;
        var cString = _malloc(length);
        stringToUTF8(jsString, cString, length);
        return cString;
      }
      function _emscripten_set_offscreencanvas_size_on_target_thread_js(targetThread, targetCanvas, width2, height2) {
        withStackSave(function() {
          var varargs = stackAlloc(12);
          var targetCanvasPtr = 0;
          if (targetCanvas) {
            targetCanvasPtr = stringToNewUTF8(targetCanvas);
          }
          GROWABLE_HEAP_I32()[varargs >> 2] = targetCanvasPtr;
          GROWABLE_HEAP_I32()[varargs + 4 >> 2] = width2;
          GROWABLE_HEAP_I32()[varargs + 8 >> 2] = height2;
          _emscripten_dispatch_to_thread_(targetThread, 657457152, 0, targetCanvasPtr, varargs);
        });
      }
      function _emscripten_set_offscreencanvas_size_on_target_thread(targetThread, targetCanvas, width2, height2) {
        targetCanvas = targetCanvas ? UTF8ToString(targetCanvas) : "";
        _emscripten_set_offscreencanvas_size_on_target_thread_js(targetThread, targetCanvas, width2, height2);
      }
      function maybeCStringToJsString(cString) {
        return cString > 2 ? UTF8ToString(cString) : cString;
      }
      var specialHTMLTargets = [0, typeof document !== "undefined" ? document : 0, typeof window !== "undefined" ? window : 0];
      function findEventTarget(target) {
        target = maybeCStringToJsString(target);
        var domElement = specialHTMLTargets[target] || (typeof document !== "undefined" ? document.querySelector(target) : void 0);
        return domElement;
      }
      function findCanvasEventTarget(target) {
        return findEventTarget(target);
      }
      function _emscripten_set_canvas_element_size_calling_thread(target, width2, height2) {
        var canvas = findCanvasEventTarget(target);
        if (!canvas)
          return -4;
        if (canvas.canvasSharedPtr) {
          GROWABLE_HEAP_I32()[canvas.canvasSharedPtr >> 2] = width2;
          GROWABLE_HEAP_I32()[canvas.canvasSharedPtr + 4 >> 2] = height2;
        }
        if (canvas.offscreenCanvas || !canvas.controlTransferredOffscreen) {
          if (canvas.offscreenCanvas)
            canvas = canvas.offscreenCanvas;
          var autoResizeViewport = false;
          if (canvas.GLctxObject && canvas.GLctxObject.GLctx) {
            var prevViewport = canvas.GLctxObject.GLctx.getParameter(2978);
            autoResizeViewport = prevViewport[0] === 0 && prevViewport[1] === 0 && prevViewport[2] === canvas.width && prevViewport[3] === canvas.height;
          }
          canvas.width = width2;
          canvas.height = height2;
          if (autoResizeViewport) {
            canvas.GLctxObject.GLctx.viewport(0, 0, width2, height2);
          }
        } else if (canvas.canvasSharedPtr) {
          var targetThread = GROWABLE_HEAP_I32()[canvas.canvasSharedPtr + 8 >> 2];
          _emscripten_set_offscreencanvas_size_on_target_thread(targetThread, target, width2, height2);
          return 1;
        } else {
          return -4;
        }
        return 0;
      }
      function _emscripten_set_canvas_element_size_main_thread(target, width2, height2) {
        if (ENVIRONMENT_IS_PTHREAD)
          return _emscripten_proxy_to_main_thread_js(2, 1, target, width2, height2);
        return _emscripten_set_canvas_element_size_calling_thread(target, width2, height2);
      }
      function _emscripten_set_canvas_element_size(target, width2, height2) {
        var canvas = findCanvasEventTarget(target);
        if (canvas) {
          return _emscripten_set_canvas_element_size_calling_thread(target, width2, height2);
        } else {
          return _emscripten_set_canvas_element_size_main_thread(target, width2, height2);
        }
      }
      function _emscripten_unwind_to_js_event_loop() {
        throw "unwind";
      }
      function __webgl_enable_ANGLE_instanced_arrays(ctx) {
        var ext = ctx.getExtension("ANGLE_instanced_arrays");
        if (ext) {
          ctx["vertexAttribDivisor"] = function(index2, divisor) {
            ext["vertexAttribDivisorANGLE"](index2, divisor);
          };
          ctx["drawArraysInstanced"] = function(mode2, first, count2, primcount) {
            ext["drawArraysInstancedANGLE"](mode2, first, count2, primcount);
          };
          ctx["drawElementsInstanced"] = function(mode2, count2, type, indices, primcount) {
            ext["drawElementsInstancedANGLE"](mode2, count2, type, indices, primcount);
          };
          return 1;
        }
      }
      function __webgl_enable_OES_vertex_array_object(ctx) {
        var ext = ctx.getExtension("OES_vertex_array_object");
        if (ext) {
          ctx["createVertexArray"] = function() {
            return ext["createVertexArrayOES"]();
          };
          ctx["deleteVertexArray"] = function(vao) {
            ext["deleteVertexArrayOES"](vao);
          };
          ctx["bindVertexArray"] = function(vao) {
            ext["bindVertexArrayOES"](vao);
          };
          ctx["isVertexArray"] = function(vao) {
            return ext["isVertexArrayOES"](vao);
          };
          return 1;
        }
      }
      function __webgl_enable_WEBGL_draw_buffers(ctx) {
        var ext = ctx.getExtension("WEBGL_draw_buffers");
        if (ext) {
          ctx["drawBuffers"] = function(n2, bufs) {
            ext["drawBuffersWEBGL"](n2, bufs);
          };
          return 1;
        }
      }
      function __webgl_enable_WEBGL_multi_draw(ctx) {
        return !!(ctx.multiDrawWebgl = ctx.getExtension("WEBGL_multi_draw"));
      }
      var GL = { counter: 1, buffers: [], programs: [], framebuffers: [], renderbuffers: [], textures: [], shaders: [], vaos: [], contexts: {}, offscreenCanvases: {}, queries: [], stringCache: {}, unpackAlignment: 4, recordError: function recordError(errorCode) {
        if (!GL.lastError) {
          GL.lastError = errorCode;
        }
      }, getNewId: function(table) {
        var ret = GL.counter++;
        for (var i2 = table.length; i2 < ret; i2++) {
          table[i2] = null;
        }
        return ret;
      }, getSource: function(shader, count2, string2, length) {
        var source2 = "";
        for (var i2 = 0; i2 < count2; ++i2) {
          var len = length ? GROWABLE_HEAP_I32()[length + i2 * 4 >> 2] : -1;
          source2 += UTF8ToString(GROWABLE_HEAP_I32()[string2 + i2 * 4 >> 2], len < 0 ? void 0 : len);
        }
        return source2;
      }, createContext: function(canvas, webGLContextAttributes) {
        if (!canvas.getContextSafariWebGL2Fixed) {
          canvas.getContextSafariWebGL2Fixed = canvas.getContext;
          canvas.getContext = function(ver, attrs) {
            var gl = canvas.getContextSafariWebGL2Fixed(ver, attrs);
            return ver == "webgl" == gl instanceof WebGLRenderingContext ? gl : null;
          };
        }
        var ctx = canvas.getContext("webgl", webGLContextAttributes);
        if (!ctx)
          return 0;
        var handle2 = GL.registerContext(ctx, webGLContextAttributes);
        return handle2;
      }, registerContext: function(ctx, webGLContextAttributes) {
        var handle2 = _malloc(8);
        GROWABLE_HEAP_I32()[handle2 + 4 >> 2] = _pthread_self();
        var context2 = { handle: handle2, attributes: webGLContextAttributes, version: webGLContextAttributes.majorVersion, GLctx: ctx };
        if (ctx.canvas)
          ctx.canvas.GLctxObject = context2;
        GL.contexts[handle2] = context2;
        if (typeof webGLContextAttributes.enableExtensionsByDefault === "undefined" || webGLContextAttributes.enableExtensionsByDefault) {
          GL.initExtensions(context2);
        }
        return handle2;
      }, makeContextCurrent: function(contextHandle) {
        GL.currentContext = GL.contexts[contextHandle];
        Module.ctx = GLctx = GL.currentContext && GL.currentContext.GLctx;
        return !(contextHandle && !GLctx);
      }, getContext: function(contextHandle) {
        return GL.contexts[contextHandle];
      }, deleteContext: function(contextHandle) {
        if (GL.currentContext === GL.contexts[contextHandle])
          GL.currentContext = null;
        if (typeof JSEvents === "object")
          JSEvents.removeAllHandlersOnTarget(GL.contexts[contextHandle].GLctx.canvas);
        if (GL.contexts[contextHandle] && GL.contexts[contextHandle].GLctx.canvas)
          GL.contexts[contextHandle].GLctx.canvas.GLctxObject = void 0;
        _free(GL.contexts[contextHandle].handle);
        GL.contexts[contextHandle] = null;
      }, initExtensions: function(context2) {
        if (!context2)
          context2 = GL.currentContext;
        if (context2.initExtensionsDone)
          return;
        context2.initExtensionsDone = true;
        var GLctx2 = context2.GLctx;
        __webgl_enable_ANGLE_instanced_arrays(GLctx2);
        __webgl_enable_OES_vertex_array_object(GLctx2);
        __webgl_enable_WEBGL_draw_buffers(GLctx2);
        {
          GLctx2.disjointTimerQueryExt = GLctx2.getExtension("EXT_disjoint_timer_query");
        }
        __webgl_enable_WEBGL_multi_draw(GLctx2);
        var exts = GLctx2.getSupportedExtensions() || [];
        exts.forEach(function(ext) {
          if (!ext.includes("lose_context") && !ext.includes("debug")) {
            GLctx2.getExtension(ext);
          }
        });
      } };
      var __emscripten_webgl_power_preferences = ["default", "low-power", "high-performance"];
      function _emscripten_webgl_do_create_context(target, attributes) {
        var a6 = attributes >> 2;
        var powerPreference = GROWABLE_HEAP_I32()[a6 + (24 >> 2)];
        var contextAttributes = { "alpha": !!GROWABLE_HEAP_I32()[a6 + (0 >> 2)], "depth": !!GROWABLE_HEAP_I32()[a6 + (4 >> 2)], "stencil": !!GROWABLE_HEAP_I32()[a6 + (8 >> 2)], "antialias": !!GROWABLE_HEAP_I32()[a6 + (12 >> 2)], "premultipliedAlpha": !!GROWABLE_HEAP_I32()[a6 + (16 >> 2)], "preserveDrawingBuffer": !!GROWABLE_HEAP_I32()[a6 + (20 >> 2)], "powerPreference": __emscripten_webgl_power_preferences[powerPreference], "failIfMajorPerformanceCaveat": !!GROWABLE_HEAP_I32()[a6 + (28 >> 2)], majorVersion: GROWABLE_HEAP_I32()[a6 + (32 >> 2)], minorVersion: GROWABLE_HEAP_I32()[a6 + (36 >> 2)], enableExtensionsByDefault: GROWABLE_HEAP_I32()[a6 + (40 >> 2)], explicitSwapControl: GROWABLE_HEAP_I32()[a6 + (44 >> 2)], proxyContextToMainThread: GROWABLE_HEAP_I32()[a6 + (48 >> 2)], renderViaOffscreenBackBuffer: GROWABLE_HEAP_I32()[a6 + (52 >> 2)] };
        var canvas = findCanvasEventTarget(target);
        if (!canvas) {
          return 0;
        }
        if (contextAttributes.explicitSwapControl) {
          return 0;
        }
        var contextHandle = GL.createContext(canvas, contextAttributes);
        return contextHandle;
      }
      function _emscripten_webgl_create_context(a0, a12) {
        return _emscripten_webgl_do_create_context(a0, a12);
      }
      var SYSCALLS = { mappings: {}, buffers: [null, [], []], printChar: function(stream, curr) {
        var buffer3 = SYSCALLS.buffers[stream];
        if (curr === 0 || curr === 10) {
          (stream === 1 ? out : err)(UTF8ArrayToString(buffer3, 0));
          buffer3.length = 0;
        } else {
          buffer3.push(curr);
        }
      }, varargs: void 0, get: function() {
        SYSCALLS.varargs += 4;
        var ret = GROWABLE_HEAP_I32()[SYSCALLS.varargs - 4 >> 2];
        return ret;
      }, getStr: function(ptr) {
        var ret = UTF8ToString(ptr);
        return ret;
      }, get64: function(low, high) {
        return low;
      } };
      function _fd_close(fd) {
        if (ENVIRONMENT_IS_PTHREAD)
          return _emscripten_proxy_to_main_thread_js(3, 1, fd);
        return 0;
      }
      function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
        if (ENVIRONMENT_IS_PTHREAD)
          return _emscripten_proxy_to_main_thread_js(4, 1, fd, offset_low, offset_high, whence, newOffset);
      }
      function _fd_write(fd, iov, iovcnt, pnum) {
        if (ENVIRONMENT_IS_PTHREAD)
          return _emscripten_proxy_to_main_thread_js(5, 1, fd, iov, iovcnt, pnum);
        var num = 0;
        for (var i2 = 0; i2 < iovcnt; i2++) {
          var ptr = GROWABLE_HEAP_I32()[iov >> 2];
          var len = GROWABLE_HEAP_I32()[iov + 4 >> 2];
          iov += 8;
          for (var j2 = 0; j2 < len; j2++) {
            SYSCALLS.printChar(fd, GROWABLE_HEAP_U8()[ptr + j2]);
          }
          num += len;
        }
        GROWABLE_HEAP_I32()[pnum >> 2] = num;
        return 0;
      }
      function _setTempRet0(val) {
      }
      PThread.init();
      var GLctx;
      var proxiedFunctionTable = [null, exitOnMainThread, _emscripten_set_canvas_element_size_main_thread, _fd_close, _fd_seek, _fd_write];
      var asmLibraryArg = { "__clock_gettime": ___clock_gettime, "__emscripten_init_main_thread_js": ___emscripten_init_main_thread_js, "__emscripten_thread_cleanup": ___emscripten_thread_cleanup, "__pthread_create_js": ___pthread_create_js, "_emscripten_default_pthread_stack_size": __emscripten_default_pthread_stack_size, "_emscripten_notify_thread_queue": __emscripten_notify_thread_queue, "abort": _abort, "emscripten_check_blocking_allowed": _emscripten_check_blocking_allowed, "emscripten_get_heap_max": _emscripten_get_heap_max, "emscripten_get_now": _emscripten_get_now, "emscripten_memcpy_big": _emscripten_memcpy_big, "emscripten_num_logical_cores": _emscripten_num_logical_cores, "emscripten_receive_on_main_thread_js": _emscripten_receive_on_main_thread_js, "emscripten_resize_heap": _emscripten_resize_heap, "emscripten_set_canvas_element_size": _emscripten_set_canvas_element_size, "emscripten_unwind_to_js_event_loop": _emscripten_unwind_to_js_event_loop, "emscripten_webgl_create_context": _emscripten_webgl_create_context, "exit": _exit, "fd_close": _fd_close, "fd_seek": _fd_seek, "fd_write": _fd_write, "memory": wasmMemory || Module["wasmMemory"], "setTempRet0": _setTempRet0 };
      createWasm();
      Module["___wasm_call_ctors"] = function() {
        return (Module["___wasm_call_ctors"] = Module["asm"]["__wasm_call_ctors"]).apply(null, arguments);
      };
      Module["_init"] = function() {
        return (Module["_init"] = Module["asm"]["init"]).apply(null, arguments);
      };
      Module["_init_with_threads_count"] = function() {
        return (Module["_init_with_threads_count"] = Module["asm"]["init_with_threads_count"]).apply(null, arguments);
      };
      Module["_get_threads_count"] = function() {
        return (Module["_get_threads_count"] = Module["asm"]["get_threads_count"]).apply(null, arguments);
      };
      Module["_register_tensor"] = function() {
        return (Module["_register_tensor"] = Module["asm"]["register_tensor"]).apply(null, arguments);
      };
      Module["_dispose_data"] = function() {
        return (Module["_dispose_data"] = Module["asm"]["dispose_data"]).apply(null, arguments);
      };
      Module["_dispose"] = function() {
        return (Module["_dispose"] = Module["asm"]["dispose"]).apply(null, arguments);
      };
      Module["_Abs"] = function() {
        return (Module["_Abs"] = Module["asm"]["Abs"]).apply(null, arguments);
      };
      Module["_Add"] = function() {
        return (Module["_Add"] = Module["asm"]["Add"]).apply(null, arguments);
      };
      Module["_AddN"] = function() {
        return (Module["_AddN"] = Module["asm"]["AddN"]).apply(null, arguments);
      };
      Module["_All"] = function() {
        return (Module["_All"] = Module["asm"]["All"]).apply(null, arguments);
      };
      Module["_Any"] = function() {
        return (Module["_Any"] = Module["asm"]["Any"]).apply(null, arguments);
      };
      Module["_ArgMax"] = function() {
        return (Module["_ArgMax"] = Module["asm"]["ArgMax"]).apply(null, arguments);
      };
      Module["_AvgPool"] = function() {
        return (Module["_AvgPool"] = Module["asm"]["AvgPool"]).apply(null, arguments);
      };
      Module["_BatchMatMul"] = function() {
        return (Module["_BatchMatMul"] = Module["asm"]["BatchMatMul"]).apply(null, arguments);
      };
      Module["_Ceil"] = function() {
        return (Module["_Ceil"] = Module["asm"]["Ceil"]).apply(null, arguments);
      };
      Module["_ClipByValue"] = function() {
        return (Module["_ClipByValue"] = Module["asm"]["ClipByValue"]).apply(null, arguments);
      };
      Module["_Conv2D"] = function() {
        return (Module["_Conv2D"] = Module["asm"]["Conv2D"]).apply(null, arguments);
      };
      Module["_Conv2DBackpropInput"] = function() {
        return (Module["_Conv2DBackpropInput"] = Module["asm"]["Conv2DBackpropInput"]).apply(null, arguments);
      };
      Module["_Cos"] = function() {
        return (Module["_Cos"] = Module["asm"]["Cos"]).apply(null, arguments);
      };
      Module["_Cosh"] = function() {
        return (Module["_Cosh"] = Module["asm"]["Cosh"]).apply(null, arguments);
      };
      Module["_CropAndResize"] = function() {
        return (Module["_CropAndResize"] = Module["asm"]["CropAndResize"]).apply(null, arguments);
      };
      Module["_Cumprod"] = function() {
        return (Module["_Cumprod"] = Module["asm"]["Cumprod"]).apply(null, arguments);
      };
      Module["_Cumsum"] = function() {
        return (Module["_Cumsum"] = Module["asm"]["Cumsum"]).apply(null, arguments);
      };
      Module["_DepthToSpace"] = function() {
        return (Module["_DepthToSpace"] = Module["asm"]["DepthToSpace"]).apply(null, arguments);
      };
      Module["_DepthwiseConv2dNative"] = function() {
        return (Module["_DepthwiseConv2dNative"] = Module["asm"]["DepthwiseConv2dNative"]).apply(null, arguments);
      };
      Module["_Elu"] = function() {
        return (Module["_Elu"] = Module["asm"]["Elu"]).apply(null, arguments);
      };
      Module["_Equal"] = function() {
        return (Module["_Equal"] = Module["asm"]["Equal"]).apply(null, arguments);
      };
      Module["_Exp"] = function() {
        return (Module["_Exp"] = Module["asm"]["Exp"]).apply(null, arguments);
      };
      Module["_FlipLeftRight"] = function() {
        return (Module["_FlipLeftRight"] = Module["asm"]["FlipLeftRight"]).apply(null, arguments);
      };
      Module["_Floor"] = function() {
        return (Module["_Floor"] = Module["asm"]["Floor"]).apply(null, arguments);
      };
      Module["_FloorDiv"] = function() {
        return (Module["_FloorDiv"] = Module["asm"]["FloorDiv"]).apply(null, arguments);
      };
      Module["_FusedBatchNorm"] = function() {
        return (Module["_FusedBatchNorm"] = Module["asm"]["FusedBatchNorm"]).apply(null, arguments);
      };
      Module["_FusedConv2D"] = function() {
        return (Module["_FusedConv2D"] = Module["asm"]["FusedConv2D"]).apply(null, arguments);
      };
      Module["_FusedDepthwiseConv2D"] = function() {
        return (Module["_FusedDepthwiseConv2D"] = Module["asm"]["FusedDepthwiseConv2D"]).apply(null, arguments);
      };
      Module["_Gather"] = function() {
        return (Module["_Gather"] = Module["asm"]["Gather"]).apply(null, arguments);
      };
      Module["_GatherNd"] = function() {
        return (Module["_GatherNd"] = Module["asm"]["GatherNd"]).apply(null, arguments);
      };
      Module["_Greater"] = function() {
        return (Module["_Greater"] = Module["asm"]["Greater"]).apply(null, arguments);
      };
      Module["_GreaterEqual"] = function() {
        return (Module["_GreaterEqual"] = Module["asm"]["GreaterEqual"]).apply(null, arguments);
      };
      Module["_LeakyRelu"] = function() {
        return (Module["_LeakyRelu"] = Module["asm"]["LeakyRelu"]).apply(null, arguments);
      };
      Module["_Less"] = function() {
        return (Module["_Less"] = Module["asm"]["Less"]).apply(null, arguments);
      };
      Module["_LessEqual"] = function() {
        return (Module["_LessEqual"] = Module["asm"]["LessEqual"]).apply(null, arguments);
      };
      Module["_Log"] = function() {
        return (Module["_Log"] = Module["asm"]["Log"]).apply(null, arguments);
      };
      Module["_LogicalAnd"] = function() {
        return (Module["_LogicalAnd"] = Module["asm"]["LogicalAnd"]).apply(null, arguments);
      };
      Module["_Max"] = function() {
        return (Module["_Max"] = Module["asm"]["Max"]).apply(null, arguments);
      };
      Module["_MaxPool"] = function() {
        return (Module["_MaxPool"] = Module["asm"]["MaxPool"]).apply(null, arguments);
      };
      Module["_Maximum"] = function() {
        return (Module["_Maximum"] = Module["asm"]["Maximum"]).apply(null, arguments);
      };
      Module["_Mean"] = function() {
        return (Module["_Mean"] = Module["asm"]["Mean"]).apply(null, arguments);
      };
      Module["_Min"] = function() {
        return (Module["_Min"] = Module["asm"]["Min"]).apply(null, arguments);
      };
      Module["_Minimum"] = function() {
        return (Module["_Minimum"] = Module["asm"]["Minimum"]).apply(null, arguments);
      };
      Module["_MirrorPad"] = function() {
        return (Module["_MirrorPad"] = Module["asm"]["MirrorPad"]).apply(null, arguments);
      };
      Module["_Multiply"] = function() {
        return (Module["_Multiply"] = Module["asm"]["Multiply"]).apply(null, arguments);
      };
      Module["_Neg"] = function() {
        return (Module["_Neg"] = Module["asm"]["Neg"]).apply(null, arguments);
      };
      Module["_NonMaxSuppressionV3"] = function() {
        return (Module["_NonMaxSuppressionV3"] = Module["asm"]["NonMaxSuppressionV3"]).apply(null, arguments);
      };
      Module["_NonMaxSuppressionV4"] = function() {
        return (Module["_NonMaxSuppressionV4"] = Module["asm"]["NonMaxSuppressionV4"]).apply(null, arguments);
      };
      Module["_NonMaxSuppressionV5"] = function() {
        return (Module["_NonMaxSuppressionV5"] = Module["asm"]["NonMaxSuppressionV5"]).apply(null, arguments);
      };
      Module["_NotEqual"] = function() {
        return (Module["_NotEqual"] = Module["asm"]["NotEqual"]).apply(null, arguments);
      };
      Module["_OneHot"] = function() {
        return (Module["_OneHot"] = Module["asm"]["OneHot"]).apply(null, arguments);
      };
      Module["_PadV2"] = function() {
        return (Module["_PadV2"] = Module["asm"]["PadV2"]).apply(null, arguments);
      };
      Module["_Pow"] = function() {
        return (Module["_Pow"] = Module["asm"]["Pow"]).apply(null, arguments);
      };
      Module["_Prelu"] = function() {
        return (Module["_Prelu"] = Module["asm"]["Prelu"]).apply(null, arguments);
      };
      Module["_Prod"] = function() {
        return (Module["_Prod"] = Module["asm"]["Prod"]).apply(null, arguments);
      };
      Module["_RealDiv"] = function() {
        return (Module["_RealDiv"] = Module["asm"]["RealDiv"]).apply(null, arguments);
      };
      Module["_Relu"] = function() {
        return (Module["_Relu"] = Module["asm"]["Relu"]).apply(null, arguments);
      };
      Module["_Relu6"] = function() {
        return (Module["_Relu6"] = Module["asm"]["Relu6"]).apply(null, arguments);
      };
      Module["_ResizeBilinear"] = function() {
        return (Module["_ResizeBilinear"] = Module["asm"]["ResizeBilinear"]).apply(null, arguments);
      };
      Module["_Reverse"] = function() {
        return (Module["_Reverse"] = Module["asm"]["Reverse"]).apply(null, arguments);
      };
      Module["_RotateWithOffset"] = function() {
        return (Module["_RotateWithOffset"] = Module["asm"]["RotateWithOffset"]).apply(null, arguments);
      };
      Module["_Round"] = function() {
        return (Module["_Round"] = Module["asm"]["Round"]).apply(null, arguments);
      };
      Module["_Rsqrt"] = function() {
        return (Module["_Rsqrt"] = Module["asm"]["Rsqrt"]).apply(null, arguments);
      };
      Module["_ScatterNd"] = function() {
        return (Module["_ScatterNd"] = Module["asm"]["ScatterNd"]).apply(null, arguments);
      };
      Module["_SelectV2"] = function() {
        return (Module["_SelectV2"] = Module["asm"]["SelectV2"]).apply(null, arguments);
      };
      Module["_Sigmoid"] = function() {
        return (Module["_Sigmoid"] = Module["asm"]["Sigmoid"]).apply(null, arguments);
      };
      Module["_Sin"] = function() {
        return (Module["_Sin"] = Module["asm"]["Sin"]).apply(null, arguments);
      };
      Module["_Softmax"] = function() {
        return (Module["_Softmax"] = Module["asm"]["Softmax"]).apply(null, arguments);
      };
      Module["_SparseFillEmptyRows"] = function() {
        return (Module["_SparseFillEmptyRows"] = Module["asm"]["SparseFillEmptyRows"]).apply(null, arguments);
      };
      Module["_SparseReshape"] = function() {
        return (Module["_SparseReshape"] = Module["asm"]["SparseReshape"]).apply(null, arguments);
      };
      Module["_SparseSegmentReduction"] = function() {
        return (Module["_SparseSegmentReduction"] = Module["asm"]["SparseSegmentReduction"]).apply(null, arguments);
      };
      Module["_Sqrt"] = function() {
        return (Module["_Sqrt"] = Module["asm"]["Sqrt"]).apply(null, arguments);
      };
      Module["_Square"] = function() {
        return (Module["_Square"] = Module["asm"]["Square"]).apply(null, arguments);
      };
      Module["_SquaredDifference"] = function() {
        return (Module["_SquaredDifference"] = Module["asm"]["SquaredDifference"]).apply(null, arguments);
      };
      Module["_Step"] = function() {
        return (Module["_Step"] = Module["asm"]["Step"]).apply(null, arguments);
      };
      Module["_StridedSlice"] = function() {
        return (Module["_StridedSlice"] = Module["asm"]["StridedSlice"]).apply(null, arguments);
      };
      Module["_Sub"] = function() {
        return (Module["_Sub"] = Module["asm"]["Sub"]).apply(null, arguments);
      };
      Module["_Sum"] = function() {
        return (Module["_Sum"] = Module["asm"]["Sum"]).apply(null, arguments);
      };
      Module["_Tan"] = function() {
        return (Module["_Tan"] = Module["asm"]["Tan"]).apply(null, arguments);
      };
      Module["_Tanh"] = function() {
        return (Module["_Tanh"] = Module["asm"]["Tanh"]).apply(null, arguments);
      };
      Module["_Tile"] = function() {
        return (Module["_Tile"] = Module["asm"]["Tile"]).apply(null, arguments);
      };
      Module["_TopK"] = function() {
        return (Module["_TopK"] = Module["asm"]["TopK"]).apply(null, arguments);
      };
      Module["_Transform"] = function() {
        return (Module["_Transform"] = Module["asm"]["Transform"]).apply(null, arguments);
      };
      Module["_Transpose"] = function() {
        return (Module["_Transpose"] = Module["asm"]["Transpose"]).apply(null, arguments);
      };
      Module["__FusedMatMul"] = function() {
        return (Module["__FusedMatMul"] = Module["asm"]["_FusedMatMul"]).apply(null, arguments);
      };
      var _malloc = Module["_malloc"] = function() {
        return (_malloc = Module["_malloc"] = Module["asm"]["malloc"]).apply(null, arguments);
      };
      var _free = Module["_free"] = function() {
        return (_free = Module["_free"] = Module["asm"]["free"]).apply(null, arguments);
      };
      Module["_emscripten_tls_init"] = function() {
        return (Module["_emscripten_tls_init"] = Module["asm"]["emscripten_tls_init"]).apply(null, arguments);
      };
      var ___errno_location = Module["___errno_location"] = function() {
        return (___errno_location = Module["___errno_location"] = Module["asm"]["__errno_location"]).apply(null, arguments);
      };
      var _pthread_self = Module["_pthread_self"] = function() {
        return (_pthread_self = Module["_pthread_self"] = Module["asm"]["pthread_self"]).apply(null, arguments);
      };
      var _emscripten_main_thread_process_queued_calls = Module["_emscripten_main_thread_process_queued_calls"] = function() {
        return (_emscripten_main_thread_process_queued_calls = Module["_emscripten_main_thread_process_queued_calls"] = Module["asm"]["emscripten_main_thread_process_queued_calls"]).apply(null, arguments);
      };
      Module["__emscripten_thread_crashed"] = function() {
        return (Module["__emscripten_thread_crashed"] = Module["asm"]["_emscripten_thread_crashed"]).apply(null, arguments);
      };
      var __emscripten_thread_init = Module["__emscripten_thread_init"] = function() {
        return (__emscripten_thread_init = Module["__emscripten_thread_init"] = Module["asm"]["_emscripten_thread_init"]).apply(null, arguments);
      };
      Module["_emscripten_current_thread_process_queued_calls"] = function() {
        return (Module["_emscripten_current_thread_process_queued_calls"] = Module["asm"]["emscripten_current_thread_process_queued_calls"]).apply(null, arguments);
      };
      Module["_emscripten_main_browser_thread_id"] = function() {
        return (Module["_emscripten_main_browser_thread_id"] = Module["asm"]["emscripten_main_browser_thread_id"]).apply(null, arguments);
      };
      Module["_emscripten_sync_run_in_main_thread_2"] = function() {
        return (Module["_emscripten_sync_run_in_main_thread_2"] = Module["asm"]["emscripten_sync_run_in_main_thread_2"]).apply(null, arguments);
      };
      var _emscripten_sync_run_in_main_thread_4 = Module["_emscripten_sync_run_in_main_thread_4"] = function() {
        return (_emscripten_sync_run_in_main_thread_4 = Module["_emscripten_sync_run_in_main_thread_4"] = Module["asm"]["emscripten_sync_run_in_main_thread_4"]).apply(null, arguments);
      };
      var _emscripten_run_in_main_runtime_thread_js = Module["_emscripten_run_in_main_runtime_thread_js"] = function() {
        return (_emscripten_run_in_main_runtime_thread_js = Module["_emscripten_run_in_main_runtime_thread_js"] = Module["asm"]["emscripten_run_in_main_runtime_thread_js"]).apply(null, arguments);
      };
      var _emscripten_dispatch_to_thread_ = Module["_emscripten_dispatch_to_thread_"] = function() {
        return (_emscripten_dispatch_to_thread_ = Module["_emscripten_dispatch_to_thread_"] = Module["asm"]["emscripten_dispatch_to_thread_"]).apply(null, arguments);
      };
      var __emscripten_thread_free_data = Module["__emscripten_thread_free_data"] = function() {
        return (__emscripten_thread_free_data = Module["__emscripten_thread_free_data"] = Module["asm"]["_emscripten_thread_free_data"]).apply(null, arguments);
      };
      Module["__emscripten_thread_exit"] = function() {
        return (Module["__emscripten_thread_exit"] = Module["asm"]["_emscripten_thread_exit"]).apply(null, arguments);
      };
      Module["_memalign"] = function() {
        return (Module["_memalign"] = Module["asm"]["memalign"]).apply(null, arguments);
      };
      var _emscripten_stack_set_limits = Module["_emscripten_stack_set_limits"] = function() {
        return (_emscripten_stack_set_limits = Module["_emscripten_stack_set_limits"] = Module["asm"]["emscripten_stack_set_limits"]).apply(null, arguments);
      };
      var stackSave = Module["stackSave"] = function() {
        return (stackSave = Module["stackSave"] = Module["asm"]["stackSave"]).apply(null, arguments);
      };
      var stackRestore = Module["stackRestore"] = function() {
        return (stackRestore = Module["stackRestore"] = Module["asm"]["stackRestore"]).apply(null, arguments);
      };
      var stackAlloc = Module["stackAlloc"] = function() {
        return (stackAlloc = Module["stackAlloc"] = Module["asm"]["stackAlloc"]).apply(null, arguments);
      };
      Module["dynCall_iijjiiii"] = function() {
        return (Module["dynCall_iijjiiii"] = Module["asm"]["dynCall_iijjiiii"]).apply(null, arguments);
      };
      Module["dynCall_jiji"] = function() {
        return (Module["dynCall_jiji"] = Module["asm"]["dynCall_jiji"]).apply(null, arguments);
      };
      var __emscripten_allow_main_runtime_queued_calls = Module["__emscripten_allow_main_runtime_queued_calls"] = 21464;
      Module["cwrap"] = cwrap;
      Module["keepRuntimeAlive"] = keepRuntimeAlive;
      Module["PThread"] = PThread;
      Module["PThread"] = PThread;
      Module["wasmMemory"] = wasmMemory;
      Module["ExitStatus"] = ExitStatus;
      var calledRun;
      function ExitStatus(status) {
        this.name = "ExitStatus";
        this.message = "Program terminated with exit(" + status + ")";
        this.status = status;
      }
      dependenciesFulfilled = function runCaller() {
        if (!calledRun)
          run();
        if (!calledRun)
          dependenciesFulfilled = runCaller;
      };
      function run(args) {
        if (runDependencies > 0) {
          return;
        }
        if (ENVIRONMENT_IS_PTHREAD) {
          readyPromiseResolve(Module);
          initRuntime();
          postMessage({ "cmd": "loaded" });
          return;
        }
        preRun();
        if (runDependencies > 0) {
          return;
        }
        function doRun() {
          if (calledRun)
            return;
          calledRun = true;
          Module["calledRun"] = true;
          if (ABORT)
            return;
          initRuntime();
          readyPromiseResolve(Module);
          if (Module["onRuntimeInitialized"])
            Module["onRuntimeInitialized"]();
          postRun();
        }
        if (Module["setStatus"]) {
          Module["setStatus"]("Running...");
          setTimeout(function() {
            setTimeout(function() {
              Module["setStatus"]("");
            }, 1);
            doRun();
          }, 1);
        } else {
          doRun();
        }
      }
      Module["run"] = run;
      function exit(status, implicit) {
        EXITSTATUS = status;
        if (!implicit) {
          if (ENVIRONMENT_IS_PTHREAD) {
            exitOnMainThread(status);
            throw "unwind";
          }
        }
        if (keepRuntimeAlive())
          ;
        else {
          exitRuntime();
        }
        procExit(status);
      }
      function procExit(code) {
        EXITSTATUS = code;
        if (!keepRuntimeAlive()) {
          PThread.terminateAllThreads();
          if (Module["onExit"])
            Module["onExit"](code);
          ABORT = true;
        }
        quit_(code, new ExitStatus(code));
      }
      if (Module["preInit"]) {
        if (typeof Module["preInit"] == "function")
          Module["preInit"] = [Module["preInit"]];
        while (Module["preInit"].length > 0) {
          Module["preInit"].pop()();
        }
      }
      run();
      var listenersAdded;
      if (beforeListeners) {
        listenersAdded = { uncaughtException: process.listeners("uncaughtException").filter(function(listener) {
          return !beforeListeners.uncaughtException.indexOf(listener) > -1;
        }), unhandledRejection: process.listeners("unhandledRejection").filter(function(listener) {
          return !beforeListeners.unhandledRejection.indexOf(listener) > -1;
        }) };
      }
      var actualModule;
      if (typeof WasmBackendModule !== "undefined") {
        actualModule = WasmBackendModule;
      } else if (typeof WasmBackendModuleThreadedSimd3 !== "undefined") {
        actualModule = WasmBackendModuleThreadedSimd3;
      } else {
        throw new Error("Could not find wasm module in post.js");
      }
      if (listenersAdded) {
        var tmpDispose = actualModule["_dispose"];
        actualModule["_dispose"] = function() {
          tmpDispose();
          listenersAdded.uncaughtException.forEach(function(listener) {
            process.removeListener("uncaughtException", listener);
          });
          listenersAdded.unhandledRejection.forEach(function(listener) {
            process.removeListener("unhandledRejection", listener);
          });
        };
      }
      return WasmBackendModuleThreadedSimd3.ready;
    };
  })();
  module2.exports = WasmBackendModuleThreadedSimd2;
})(tfjsBackendWasmThreadedSimd);
var wasmFactoryThreadedSimd = tfjsBackendWasmThreadedSimd.exports;
const wasmWorkerContents = '"use strict";var Module={};var ENVIRONMENT_IS_NODE=typeof process==="object"&&typeof process.versions==="object"&&typeof process.versions.node==="string";if(ENVIRONMENT_IS_NODE){var nodeWorkerThreads=require("worker_threads");var parentPort=nodeWorkerThreads.parentPort;parentPort.on("message",function(data){onmessage({data:data})});var fs=require("fs");Object.assign(global,{self:global,require:require,Module:Module,location:{href:__filename},Worker:nodeWorkerThreads.Worker,importScripts:function(f){(0,eval)(fs.readFileSync(f,"utf8"))},postMessage:function(msg){parentPort.postMessage(msg)},performance:global.performance||{now:function(){return Date.now()}}})}function threadPrintErr(){var text=Array.prototype.slice.call(arguments).join(" ");if(ENVIRONMENT_IS_NODE){fs.writeSync(2,text+"\n");return}console.error(text)}function threadAlert(){var text=Array.prototype.slice.call(arguments).join(" ");postMessage({cmd:"alert",text:text,threadId:Module["_pthread_self"]()})}var err=threadPrintErr;self.alert=threadAlert;Module["instantiateWasm"]=((info,receiveInstance)=>{var instance=new WebAssembly.Instance(Module["wasmModule"],info);receiveInstance(instance);Module["wasmModule"]=null;return instance.exports});self.onmessage=(e=>{try{if(e.data.cmd==="load"){Module["wasmModule"]=e.data.wasmModule;Module["wasmMemory"]=e.data.wasmMemory;Module["buffer"]=Module["wasmMemory"].buffer;Module["ENVIRONMENT_IS_PTHREAD"]=true;if(typeof e.data.urlOrBlob==="string"){importScripts(e.data.urlOrBlob)}else{var objectUrl=URL.createObjectURL(e.data.urlOrBlob);importScripts(objectUrl);URL.revokeObjectURL(objectUrl)}WasmBackendModuleThreadedSimd(Module).then(function(instance){Module=instance})}else if(e.data.cmd==="run"){Module["__performance_now_clock_drift"]=performance.now()-e.data.time;Module["__emscripten_thread_init"](e.data.threadInfoStruct,0,0,1);Module["establishStackSpace"]();Module["PThread"].receiveObjectTransfer(e.data);Module["PThread"].threadInit();try{var result=Module["invokeEntryPoint"](e.data.start_routine,e.data.arg);if(Module["keepRuntimeAlive"]()){Module["PThread"].setExitStatus(result)}else{Module["__emscripten_thread_exit"](result)}}catch(ex){if(ex!="unwind"){if(ex instanceof Module["ExitStatus"]){if(Module["keepRuntimeAlive"]()){}else{Module["__emscripten_thread_exit"](ex.status)}}else{throw ex}}}}else if(e.data.cmd==="cancel"){if(Module["_pthread_self"]()){Module["__emscripten_thread_exit"](-1)}}else if(e.data.target==="setimmediate"){}else if(e.data.cmd==="processThreadQueue"){if(Module["_pthread_self"]()){Module["_emscripten_current_thread_process_queued_calls"]()}}else if(e.data.cmd==="processProxyingQueue"){if(Module["_pthread_self"]()){Module["_emscripten_proxy_execute_queue"](e.data.queue)}}else{err("worker.js received unknown command "+e.data.cmd);err(e.data)}}catch(ex){err("worker.js onmessage() captured an uncaught exception: "+ex);if(ex&&ex.stack)err(ex.stack);if(Module["__emscripten_thread_crashed"]){Module["__emscripten_thread_crashed"]()}throw ex}});';
var tfjsBackendWasm = { exports: {} };
(function(module2, exports2) {
  var WasmBackendModule2 = (() => {
    var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
    if (typeof __filename !== "undefined")
      _scriptDir = _scriptDir || __filename;
    return function(WasmBackendModule3) {
      WasmBackendModule3 = WasmBackendModule3 || {};
      var Module = typeof WasmBackendModule3 !== "undefined" ? WasmBackendModule3 : {};
      var readyPromiseResolve, readyPromiseReject;
      Module["ready"] = new Promise(function(resolve, reject) {
        readyPromiseResolve = resolve;
        readyPromiseReject = reject;
      });
      var beforeListeners;
      if (typeof process !== "undefined" && process.listeners) {
        beforeListeners = { uncaughtException: process.listeners("uncaughtException"), unhandledRejection: process.listeners("unhandledRejection") };
      }
      var moduleOverrides = Object.assign({}, Module);
      var ENVIRONMENT_IS_WEB = typeof window === "object";
      var ENVIRONMENT_IS_WORKER = typeof importScripts === "function";
      var ENVIRONMENT_IS_NODE = typeof process === "object" && typeof process.versions === "object" && typeof process.versions.node === "string";
      var scriptDirectory = "";
      function locateFile(path2) {
        if (Module["locateFile"]) {
          return Module["locateFile"](path2, scriptDirectory);
        }
        return scriptDirectory + path2;
      }
      var read_, readAsync, readBinary;
      var fs;
      var nodePath;
      var requireNodeFS;
      if (ENVIRONMENT_IS_NODE) {
        if (ENVIRONMENT_IS_WORKER) {
          scriptDirectory = require$$4.dirname(scriptDirectory) + "/";
        } else {
          scriptDirectory = __dirname + "/";
        }
        requireNodeFS = () => {
          if (!nodePath) {
            fs = require$$4;
            nodePath = require$$4;
          }
        };
        read_ = function shell_read(filename, binary) {
          requireNodeFS();
          filename = nodePath["normalize"](filename);
          return fs.readFileSync(filename, binary ? void 0 : "utf8");
        };
        readBinary = (filename) => {
          var ret = read_(filename, true);
          if (!ret.buffer) {
            ret = new Uint8Array(ret);
          }
          return ret;
        };
        readAsync = (filename, onload, onerror) => {
          requireNodeFS();
          filename = nodePath["normalize"](filename);
          fs.readFile(filename, function(err2, data2) {
            if (err2)
              onerror(err2);
            else
              onload(data2.buffer);
          });
        };
        if (process["argv"].length > 1) {
          process["argv"][1].replace(/\\/g, "/");
        }
        process["argv"].slice(2);
        process["on"]("uncaughtException", function(ex) {
          if (!(ex instanceof ExitStatus)) {
            throw ex;
          }
        });
        process["on"]("unhandledRejection", function(reason) {
          throw reason;
        });
        Module["inspect"] = function() {
          return "[Emscripten Module object]";
        };
      } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
        if (ENVIRONMENT_IS_WORKER) {
          scriptDirectory = self.location.href;
        } else if (typeof document !== "undefined" && document.currentScript) {
          scriptDirectory = document.currentScript.src;
        }
        if (_scriptDir) {
          scriptDirectory = _scriptDir;
        }
        if (scriptDirectory.indexOf("blob:") !== 0) {
          scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
        } else {
          scriptDirectory = "";
        }
        {
          read_ = (url) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open("GET", url, false);
            xhr2.send(null);
            return xhr2.responseText;
          };
          if (ENVIRONMENT_IS_WORKER) {
            readBinary = (url) => {
              var xhr2 = new XMLHttpRequest();
              xhr2.open("GET", url, false);
              xhr2.responseType = "arraybuffer";
              xhr2.send(null);
              return new Uint8Array(xhr2.response);
            };
          }
          readAsync = (url, onload, onerror) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open("GET", url, true);
            xhr2.responseType = "arraybuffer";
            xhr2.onload = () => {
              if (xhr2.status == 200 || xhr2.status == 0 && xhr2.response) {
                onload(xhr2.response);
                return;
              }
              onerror();
            };
            xhr2.onerror = onerror;
            xhr2.send(null);
          };
        }
      } else
        ;
      var out = Module["print"] || console.log.bind(console);
      var err = Module["printErr"] || console.warn.bind(console);
      Object.assign(Module, moduleOverrides);
      moduleOverrides = null;
      if (Module["arguments"])
        ;
      if (Module["thisProgram"])
        ;
      if (Module["quit"])
        ;
      var wasmBinary;
      if (Module["wasmBinary"])
        wasmBinary = Module["wasmBinary"];
      Module["noExitRuntime"] || true;
      if (typeof WebAssembly !== "object") {
        abort("no native wasm support detected");
      }
      var wasmMemory;
      var ABORT = false;
      function getCFunc(ident) {
        var func = Module["_" + ident];
        return func;
      }
      function ccall(ident, returnType, argTypes, args, opts) {
        var toC = { "string": function(str) {
          var ret2 = 0;
          if (str !== null && str !== void 0 && str !== 0) {
            var len = (str.length << 2) + 1;
            ret2 = stackAlloc(len);
            stringToUTF8(str, ret2, len);
          }
          return ret2;
        }, "array": function(arr2) {
          var ret2 = stackAlloc(arr2.length);
          writeArrayToMemory(arr2, ret2);
          return ret2;
        } };
        function convertReturnValue(ret2) {
          if (returnType === "string")
            return UTF8ToString(ret2);
          if (returnType === "boolean")
            return Boolean(ret2);
          return ret2;
        }
        var func = getCFunc(ident);
        var cArgs = [];
        var stack2 = 0;
        if (args) {
          for (var i2 = 0; i2 < args.length; i2++) {
            var converter = toC[argTypes[i2]];
            if (converter) {
              if (stack2 === 0)
                stack2 = stackSave();
              cArgs[i2] = converter(args[i2]);
            } else {
              cArgs[i2] = args[i2];
            }
          }
        }
        var ret = func.apply(null, cArgs);
        function onDone(ret2) {
          if (stack2 !== 0)
            stackRestore(stack2);
          return convertReturnValue(ret2);
        }
        ret = onDone(ret);
        return ret;
      }
      function cwrap(ident, returnType, argTypes, opts) {
        argTypes = argTypes || [];
        var numericArgs = argTypes.every(function(type) {
          return type === "number";
        });
        var numericRet = returnType !== "string";
        if (numericRet && numericArgs && !opts) {
          return getCFunc(ident);
        }
        return function() {
          return ccall(ident, returnType, argTypes, arguments);
        };
      }
      var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : void 0;
      function UTF8ArrayToString(heap, idx, maxBytesToRead) {
        var endIdx = idx + maxBytesToRead;
        var endPtr = idx;
        while (heap[endPtr] && !(endPtr >= endIdx))
          ++endPtr;
        if (endPtr - idx > 16 && heap.subarray && UTF8Decoder) {
          return UTF8Decoder.decode(heap.subarray(idx, endPtr));
        } else {
          var str = "";
          while (idx < endPtr) {
            var u0 = heap[idx++];
            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }
            var u1 = heap[idx++] & 63;
            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }
            var u2 = heap[idx++] & 63;
            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heap[idx++] & 63;
            }
            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }
        }
        return str;
      }
      function UTF8ToString(ptr, maxBytesToRead) {
        return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
      }
      function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
        if (!(maxBytesToWrite > 0))
          return 0;
        var startIdx = outIdx;
        var endIdx = outIdx + maxBytesToWrite - 1;
        for (var i2 = 0; i2 < str.length; ++i2) {
          var u2 = str.charCodeAt(i2);
          if (u2 >= 55296 && u2 <= 57343) {
            var u1 = str.charCodeAt(++i2);
            u2 = 65536 + ((u2 & 1023) << 10) | u1 & 1023;
          }
          if (u2 <= 127) {
            if (outIdx >= endIdx)
              break;
            heap[outIdx++] = u2;
          } else if (u2 <= 2047) {
            if (outIdx + 1 >= endIdx)
              break;
            heap[outIdx++] = 192 | u2 >> 6;
            heap[outIdx++] = 128 | u2 & 63;
          } else if (u2 <= 65535) {
            if (outIdx + 2 >= endIdx)
              break;
            heap[outIdx++] = 224 | u2 >> 12;
            heap[outIdx++] = 128 | u2 >> 6 & 63;
            heap[outIdx++] = 128 | u2 & 63;
          } else {
            if (outIdx + 3 >= endIdx)
              break;
            heap[outIdx++] = 240 | u2 >> 18;
            heap[outIdx++] = 128 | u2 >> 12 & 63;
            heap[outIdx++] = 128 | u2 >> 6 & 63;
            heap[outIdx++] = 128 | u2 & 63;
          }
        }
        heap[outIdx] = 0;
        return outIdx - startIdx;
      }
      function stringToUTF8(str, outPtr, maxBytesToWrite) {
        return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
      }
      typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : void 0;
      function writeArrayToMemory(array, buffer3) {
        HEAP8.set(array, buffer3);
      }
      function alignUp(x2, multiple) {
        if (x2 % multiple > 0) {
          x2 += multiple - x2 % multiple;
        }
        return x2;
      }
      var buffer2, HEAP8, HEAPU8, HEAP32;
      function updateGlobalBufferAndViews(buf) {
        buffer2 = buf;
        Module["HEAP8"] = HEAP8 = new Int8Array(buf);
        Module["HEAP16"] = new Int16Array(buf);
        Module["HEAP32"] = HEAP32 = new Int32Array(buf);
        Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
        Module["HEAPU16"] = new Uint16Array(buf);
        Module["HEAPU32"] = new Uint32Array(buf);
        Module["HEAPF32"] = new Float32Array(buf);
        Module["HEAPF64"] = new Float64Array(buf);
      }
      Module["INITIAL_MEMORY"] || 16777216;
      var wasmTable;
      var __ATPRERUN__ = [];
      var __ATINIT__ = [];
      var __ATPOSTRUN__ = [];
      function preRun() {
        if (Module["preRun"]) {
          if (typeof Module["preRun"] == "function")
            Module["preRun"] = [Module["preRun"]];
          while (Module["preRun"].length) {
            addOnPreRun(Module["preRun"].shift());
          }
        }
        callRuntimeCallbacks(__ATPRERUN__);
      }
      function initRuntime() {
        callRuntimeCallbacks(__ATINIT__);
      }
      function postRun() {
        if (Module["postRun"]) {
          if (typeof Module["postRun"] == "function")
            Module["postRun"] = [Module["postRun"]];
          while (Module["postRun"].length) {
            addOnPostRun(Module["postRun"].shift());
          }
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
      }
      function addOnPreRun(cb2) {
        __ATPRERUN__.unshift(cb2);
      }
      function addOnInit(cb2) {
        __ATINIT__.unshift(cb2);
      }
      function addOnPostRun(cb2) {
        __ATPOSTRUN__.unshift(cb2);
      }
      var runDependencies = 0;
      var dependenciesFulfilled = null;
      function addRunDependency(id2) {
        runDependencies++;
        if (Module["monitorRunDependencies"]) {
          Module["monitorRunDependencies"](runDependencies);
        }
      }
      function removeRunDependency(id2) {
        runDependencies--;
        if (Module["monitorRunDependencies"]) {
          Module["monitorRunDependencies"](runDependencies);
        }
        if (runDependencies == 0) {
          if (dependenciesFulfilled) {
            var callback = dependenciesFulfilled;
            dependenciesFulfilled = null;
            callback();
          }
        }
      }
      Module["preloadedImages"] = {};
      Module["preloadedAudios"] = {};
      function abort(what) {
        {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }
        }
        what = "Aborted(" + what + ")";
        err(what);
        ABORT = true;
        what += ". Build with -s ASSERTIONS=1 for more info.";
        var e2 = new WebAssembly.RuntimeError(what);
        readyPromiseReject(e2);
        throw e2;
      }
      var dataURIPrefix = "data:application/octet-stream;base64,";
      function isDataURI2(filename) {
        return filename.startsWith(dataURIPrefix);
      }
      function isFileURI(filename) {
        return filename.startsWith("file://");
      }
      var wasmBinaryFile;
      wasmBinaryFile = "tfjs-backend-wasm.wasm";
      if (!isDataURI2(wasmBinaryFile)) {
        wasmBinaryFile = locateFile(wasmBinaryFile);
      }
      function getBinary(file) {
        try {
          if (file == wasmBinaryFile && wasmBinary) {
            return new Uint8Array(wasmBinary);
          }
          if (readBinary) {
            return readBinary(file);
          } else {
            throw "both async and sync fetching of the wasm failed";
          }
        } catch (err2) {
          abort(err2);
        }
      }
      function getBinaryPromise() {
        if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
          if (typeof fetch === "function" && !isFileURI(wasmBinaryFile)) {
            return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
              if (!response["ok"]) {
                throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
              }
              return response["arrayBuffer"]();
            }).catch(function() {
              return getBinary(wasmBinaryFile);
            });
          } else {
            if (readAsync) {
              return new Promise(function(resolve, reject) {
                readAsync(wasmBinaryFile, function(response) {
                  resolve(new Uint8Array(response));
                }, reject);
              });
            }
          }
        }
        return Promise.resolve().then(function() {
          return getBinary(wasmBinaryFile);
        });
      }
      function createWasm() {
        var info = { "env": asmLibraryArg, "wasi_snapshot_preview1": asmLibraryArg };
        function receiveInstance(instance2, module3) {
          var exports4 = instance2.exports;
          Module["asm"] = exports4;
          wasmMemory = Module["asm"]["memory"];
          updateGlobalBufferAndViews(wasmMemory.buffer);
          wasmTable = Module["asm"]["__indirect_function_table"];
          addOnInit(Module["asm"]["__wasm_call_ctors"]);
          removeRunDependency();
        }
        addRunDependency();
        function receiveInstantiationResult(result2) {
          receiveInstance(result2["instance"]);
        }
        function instantiateArrayBuffer(receiver) {
          return getBinaryPromise().then(function(binary) {
            return WebAssembly.instantiate(binary, info);
          }).then(function(instance2) {
            return instance2;
          }).then(receiver, function(reason) {
            err("failed to asynchronously prepare wasm: " + reason);
            abort(reason);
          });
        }
        function instantiateAsync() {
          if (!wasmBinary && typeof WebAssembly.instantiateStreaming === "function" && !isDataURI2(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && typeof fetch === "function") {
            return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
              var result2 = WebAssembly.instantiateStreaming(response, info);
              return result2.then(receiveInstantiationResult, function(reason) {
                err("wasm streaming compile failed: " + reason);
                err("falling back to ArrayBuffer instantiation");
                return instantiateArrayBuffer(receiveInstantiationResult);
              });
            });
          } else {
            return instantiateArrayBuffer(receiveInstantiationResult);
          }
        }
        if (Module["instantiateWasm"]) {
          try {
            var exports3 = Module["instantiateWasm"](info, receiveInstance);
            return exports3;
          } catch (e2) {
            err("Module.instantiateWasm callback failed with error: " + e2);
            return false;
          }
        }
        instantiateAsync().catch(readyPromiseReject);
        return {};
      }
      function callRuntimeCallbacks(callbacks) {
        while (callbacks.length > 0) {
          var callback = callbacks.shift();
          if (typeof callback == "function") {
            callback(Module);
            continue;
          }
          var func = callback.func;
          if (typeof func === "number") {
            if (callback.arg === void 0) {
              getWasmTableEntry(func)();
            } else {
              getWasmTableEntry(func)(callback.arg);
            }
          } else {
            func(callback.arg === void 0 ? null : callback.arg);
          }
        }
      }
      var wasmTableMirror = [];
      function getWasmTableEntry(funcPtr) {
        var func = wasmTableMirror[funcPtr];
        if (!func) {
          if (funcPtr >= wasmTableMirror.length)
            wasmTableMirror.length = funcPtr + 1;
          wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
        }
        return func;
      }
      function _abort() {
        abort("");
      }
      function _emscripten_get_heap_max() {
        return 2147483648;
      }
      function _emscripten_memcpy_big(dest, src2, num) {
        HEAPU8.copyWithin(dest, src2, src2 + num);
      }
      function emscripten_realloc_buffer(size) {
        try {
          wasmMemory.grow(size - buffer2.byteLength + 65535 >>> 16);
          updateGlobalBufferAndViews(wasmMemory.buffer);
          return 1;
        } catch (e2) {
        }
      }
      function _emscripten_resize_heap(requestedSize) {
        var oldSize = HEAPU8.length;
        requestedSize = requestedSize >>> 0;
        var maxHeapSize = _emscripten_get_heap_max();
        if (requestedSize > maxHeapSize) {
          return false;
        }
        for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
          var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
          overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
          var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
          var replacement = emscripten_realloc_buffer(newSize);
          if (replacement) {
            return true;
          }
        }
        return false;
      }
      var SYSCALLS = { mappings: {}, buffers: [null, [], []], printChar: function(stream, curr) {
        var buffer3 = SYSCALLS.buffers[stream];
        if (curr === 0 || curr === 10) {
          (stream === 1 ? out : err)(UTF8ArrayToString(buffer3, 0));
          buffer3.length = 0;
        } else {
          buffer3.push(curr);
        }
      }, varargs: void 0, get: function() {
        SYSCALLS.varargs += 4;
        var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
        return ret;
      }, getStr: function(ptr) {
        var ret = UTF8ToString(ptr);
        return ret;
      }, get64: function(low, high) {
        return low;
      } };
      function _fd_close(fd) {
        return 0;
      }
      function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
      }
      function _fd_write(fd, iov, iovcnt, pnum) {
        var num = 0;
        for (var i2 = 0; i2 < iovcnt; i2++) {
          var ptr = HEAP32[iov >> 2];
          var len = HEAP32[iov + 4 >> 2];
          iov += 8;
          for (var j2 = 0; j2 < len; j2++) {
            SYSCALLS.printChar(fd, HEAPU8[ptr + j2]);
          }
          num += len;
        }
        HEAP32[pnum >> 2] = num;
        return 0;
      }
      function _setTempRet0(val) {
      }
      var asmLibraryArg = { "abort": _abort, "emscripten_get_heap_max": _emscripten_get_heap_max, "emscripten_memcpy_big": _emscripten_memcpy_big, "emscripten_resize_heap": _emscripten_resize_heap, "fd_close": _fd_close, "fd_seek": _fd_seek, "fd_write": _fd_write, "setTempRet0": _setTempRet0 };
      createWasm();
      Module["___wasm_call_ctors"] = function() {
        return (Module["___wasm_call_ctors"] = Module["asm"]["__wasm_call_ctors"]).apply(null, arguments);
      };
      Module["_init"] = function() {
        return (Module["_init"] = Module["asm"]["init"]).apply(null, arguments);
      };
      Module["_init_with_threads_count"] = function() {
        return (Module["_init_with_threads_count"] = Module["asm"]["init_with_threads_count"]).apply(null, arguments);
      };
      Module["_get_threads_count"] = function() {
        return (Module["_get_threads_count"] = Module["asm"]["get_threads_count"]).apply(null, arguments);
      };
      Module["_register_tensor"] = function() {
        return (Module["_register_tensor"] = Module["asm"]["register_tensor"]).apply(null, arguments);
      };
      Module["_dispose_data"] = function() {
        return (Module["_dispose_data"] = Module["asm"]["dispose_data"]).apply(null, arguments);
      };
      Module["_dispose"] = function() {
        return (Module["_dispose"] = Module["asm"]["dispose"]).apply(null, arguments);
      };
      Module["_Abs"] = function() {
        return (Module["_Abs"] = Module["asm"]["Abs"]).apply(null, arguments);
      };
      Module["_Add"] = function() {
        return (Module["_Add"] = Module["asm"]["Add"]).apply(null, arguments);
      };
      Module["_AddN"] = function() {
        return (Module["_AddN"] = Module["asm"]["AddN"]).apply(null, arguments);
      };
      Module["_All"] = function() {
        return (Module["_All"] = Module["asm"]["All"]).apply(null, arguments);
      };
      Module["_Any"] = function() {
        return (Module["_Any"] = Module["asm"]["Any"]).apply(null, arguments);
      };
      Module["_ArgMax"] = function() {
        return (Module["_ArgMax"] = Module["asm"]["ArgMax"]).apply(null, arguments);
      };
      Module["_AvgPool"] = function() {
        return (Module["_AvgPool"] = Module["asm"]["AvgPool"]).apply(null, arguments);
      };
      Module["_BatchMatMul"] = function() {
        return (Module["_BatchMatMul"] = Module["asm"]["BatchMatMul"]).apply(null, arguments);
      };
      Module["_Ceil"] = function() {
        return (Module["_Ceil"] = Module["asm"]["Ceil"]).apply(null, arguments);
      };
      Module["_ClipByValue"] = function() {
        return (Module["_ClipByValue"] = Module["asm"]["ClipByValue"]).apply(null, arguments);
      };
      Module["_Conv2D"] = function() {
        return (Module["_Conv2D"] = Module["asm"]["Conv2D"]).apply(null, arguments);
      };
      Module["_Conv2DBackpropInput"] = function() {
        return (Module["_Conv2DBackpropInput"] = Module["asm"]["Conv2DBackpropInput"]).apply(null, arguments);
      };
      Module["_Cos"] = function() {
        return (Module["_Cos"] = Module["asm"]["Cos"]).apply(null, arguments);
      };
      Module["_Cosh"] = function() {
        return (Module["_Cosh"] = Module["asm"]["Cosh"]).apply(null, arguments);
      };
      Module["_CropAndResize"] = function() {
        return (Module["_CropAndResize"] = Module["asm"]["CropAndResize"]).apply(null, arguments);
      };
      Module["_Cumprod"] = function() {
        return (Module["_Cumprod"] = Module["asm"]["Cumprod"]).apply(null, arguments);
      };
      Module["_Cumsum"] = function() {
        return (Module["_Cumsum"] = Module["asm"]["Cumsum"]).apply(null, arguments);
      };
      Module["_DepthToSpace"] = function() {
        return (Module["_DepthToSpace"] = Module["asm"]["DepthToSpace"]).apply(null, arguments);
      };
      Module["_DepthwiseConv2dNative"] = function() {
        return (Module["_DepthwiseConv2dNative"] = Module["asm"]["DepthwiseConv2dNative"]).apply(null, arguments);
      };
      Module["_Elu"] = function() {
        return (Module["_Elu"] = Module["asm"]["Elu"]).apply(null, arguments);
      };
      Module["_Equal"] = function() {
        return (Module["_Equal"] = Module["asm"]["Equal"]).apply(null, arguments);
      };
      Module["_Exp"] = function() {
        return (Module["_Exp"] = Module["asm"]["Exp"]).apply(null, arguments);
      };
      Module["_FlipLeftRight"] = function() {
        return (Module["_FlipLeftRight"] = Module["asm"]["FlipLeftRight"]).apply(null, arguments);
      };
      Module["_Floor"] = function() {
        return (Module["_Floor"] = Module["asm"]["Floor"]).apply(null, arguments);
      };
      Module["_FloorDiv"] = function() {
        return (Module["_FloorDiv"] = Module["asm"]["FloorDiv"]).apply(null, arguments);
      };
      Module["_FusedBatchNorm"] = function() {
        return (Module["_FusedBatchNorm"] = Module["asm"]["FusedBatchNorm"]).apply(null, arguments);
      };
      Module["_FusedConv2D"] = function() {
        return (Module["_FusedConv2D"] = Module["asm"]["FusedConv2D"]).apply(null, arguments);
      };
      Module["_FusedDepthwiseConv2D"] = function() {
        return (Module["_FusedDepthwiseConv2D"] = Module["asm"]["FusedDepthwiseConv2D"]).apply(null, arguments);
      };
      Module["_Gather"] = function() {
        return (Module["_Gather"] = Module["asm"]["Gather"]).apply(null, arguments);
      };
      Module["_GatherNd"] = function() {
        return (Module["_GatherNd"] = Module["asm"]["GatherNd"]).apply(null, arguments);
      };
      Module["_Greater"] = function() {
        return (Module["_Greater"] = Module["asm"]["Greater"]).apply(null, arguments);
      };
      Module["_GreaterEqual"] = function() {
        return (Module["_GreaterEqual"] = Module["asm"]["GreaterEqual"]).apply(null, arguments);
      };
      Module["_LeakyRelu"] = function() {
        return (Module["_LeakyRelu"] = Module["asm"]["LeakyRelu"]).apply(null, arguments);
      };
      Module["_Less"] = function() {
        return (Module["_Less"] = Module["asm"]["Less"]).apply(null, arguments);
      };
      Module["_LessEqual"] = function() {
        return (Module["_LessEqual"] = Module["asm"]["LessEqual"]).apply(null, arguments);
      };
      Module["_Log"] = function() {
        return (Module["_Log"] = Module["asm"]["Log"]).apply(null, arguments);
      };
      Module["_LogicalAnd"] = function() {
        return (Module["_LogicalAnd"] = Module["asm"]["LogicalAnd"]).apply(null, arguments);
      };
      Module["_Max"] = function() {
        return (Module["_Max"] = Module["asm"]["Max"]).apply(null, arguments);
      };
      Module["_MaxPool"] = function() {
        return (Module["_MaxPool"] = Module["asm"]["MaxPool"]).apply(null, arguments);
      };
      Module["_Maximum"] = function() {
        return (Module["_Maximum"] = Module["asm"]["Maximum"]).apply(null, arguments);
      };
      Module["_Mean"] = function() {
        return (Module["_Mean"] = Module["asm"]["Mean"]).apply(null, arguments);
      };
      Module["_Min"] = function() {
        return (Module["_Min"] = Module["asm"]["Min"]).apply(null, arguments);
      };
      Module["_Minimum"] = function() {
        return (Module["_Minimum"] = Module["asm"]["Minimum"]).apply(null, arguments);
      };
      Module["_MirrorPad"] = function() {
        return (Module["_MirrorPad"] = Module["asm"]["MirrorPad"]).apply(null, arguments);
      };
      Module["_Multiply"] = function() {
        return (Module["_Multiply"] = Module["asm"]["Multiply"]).apply(null, arguments);
      };
      Module["_Neg"] = function() {
        return (Module["_Neg"] = Module["asm"]["Neg"]).apply(null, arguments);
      };
      Module["_NonMaxSuppressionV3"] = function() {
        return (Module["_NonMaxSuppressionV3"] = Module["asm"]["NonMaxSuppressionV3"]).apply(null, arguments);
      };
      Module["_NonMaxSuppressionV4"] = function() {
        return (Module["_NonMaxSuppressionV4"] = Module["asm"]["NonMaxSuppressionV4"]).apply(null, arguments);
      };
      Module["_NonMaxSuppressionV5"] = function() {
        return (Module["_NonMaxSuppressionV5"] = Module["asm"]["NonMaxSuppressionV5"]).apply(null, arguments);
      };
      Module["_NotEqual"] = function() {
        return (Module["_NotEqual"] = Module["asm"]["NotEqual"]).apply(null, arguments);
      };
      Module["_OneHot"] = function() {
        return (Module["_OneHot"] = Module["asm"]["OneHot"]).apply(null, arguments);
      };
      Module["_PadV2"] = function() {
        return (Module["_PadV2"] = Module["asm"]["PadV2"]).apply(null, arguments);
      };
      Module["_Pow"] = function() {
        return (Module["_Pow"] = Module["asm"]["Pow"]).apply(null, arguments);
      };
      Module["_Prelu"] = function() {
        return (Module["_Prelu"] = Module["asm"]["Prelu"]).apply(null, arguments);
      };
      Module["_Prod"] = function() {
        return (Module["_Prod"] = Module["asm"]["Prod"]).apply(null, arguments);
      };
      Module["_RealDiv"] = function() {
        return (Module["_RealDiv"] = Module["asm"]["RealDiv"]).apply(null, arguments);
      };
      Module["_Relu"] = function() {
        return (Module["_Relu"] = Module["asm"]["Relu"]).apply(null, arguments);
      };
      Module["_Relu6"] = function() {
        return (Module["_Relu6"] = Module["asm"]["Relu6"]).apply(null, arguments);
      };
      Module["_ResizeBilinear"] = function() {
        return (Module["_ResizeBilinear"] = Module["asm"]["ResizeBilinear"]).apply(null, arguments);
      };
      Module["_Reverse"] = function() {
        return (Module["_Reverse"] = Module["asm"]["Reverse"]).apply(null, arguments);
      };
      Module["_RotateWithOffset"] = function() {
        return (Module["_RotateWithOffset"] = Module["asm"]["RotateWithOffset"]).apply(null, arguments);
      };
      Module["_Round"] = function() {
        return (Module["_Round"] = Module["asm"]["Round"]).apply(null, arguments);
      };
      Module["_Rsqrt"] = function() {
        return (Module["_Rsqrt"] = Module["asm"]["Rsqrt"]).apply(null, arguments);
      };
      Module["_ScatterNd"] = function() {
        return (Module["_ScatterNd"] = Module["asm"]["ScatterNd"]).apply(null, arguments);
      };
      Module["_SelectV2"] = function() {
        return (Module["_SelectV2"] = Module["asm"]["SelectV2"]).apply(null, arguments);
      };
      Module["_Sigmoid"] = function() {
        return (Module["_Sigmoid"] = Module["asm"]["Sigmoid"]).apply(null, arguments);
      };
      Module["_Sin"] = function() {
        return (Module["_Sin"] = Module["asm"]["Sin"]).apply(null, arguments);
      };
      Module["_Softmax"] = function() {
        return (Module["_Softmax"] = Module["asm"]["Softmax"]).apply(null, arguments);
      };
      Module["_SparseFillEmptyRows"] = function() {
        return (Module["_SparseFillEmptyRows"] = Module["asm"]["SparseFillEmptyRows"]).apply(null, arguments);
      };
      Module["_SparseReshape"] = function() {
        return (Module["_SparseReshape"] = Module["asm"]["SparseReshape"]).apply(null, arguments);
      };
      Module["_SparseSegmentReduction"] = function() {
        return (Module["_SparseSegmentReduction"] = Module["asm"]["SparseSegmentReduction"]).apply(null, arguments);
      };
      Module["_Sqrt"] = function() {
        return (Module["_Sqrt"] = Module["asm"]["Sqrt"]).apply(null, arguments);
      };
      Module["_Square"] = function() {
        return (Module["_Square"] = Module["asm"]["Square"]).apply(null, arguments);
      };
      Module["_SquaredDifference"] = function() {
        return (Module["_SquaredDifference"] = Module["asm"]["SquaredDifference"]).apply(null, arguments);
      };
      Module["_Step"] = function() {
        return (Module["_Step"] = Module["asm"]["Step"]).apply(null, arguments);
      };
      Module["_StridedSlice"] = function() {
        return (Module["_StridedSlice"] = Module["asm"]["StridedSlice"]).apply(null, arguments);
      };
      Module["_Sub"] = function() {
        return (Module["_Sub"] = Module["asm"]["Sub"]).apply(null, arguments);
      };
      Module["_Sum"] = function() {
        return (Module["_Sum"] = Module["asm"]["Sum"]).apply(null, arguments);
      };
      Module["_Tan"] = function() {
        return (Module["_Tan"] = Module["asm"]["Tan"]).apply(null, arguments);
      };
      Module["_Tanh"] = function() {
        return (Module["_Tanh"] = Module["asm"]["Tanh"]).apply(null, arguments);
      };
      Module["_Tile"] = function() {
        return (Module["_Tile"] = Module["asm"]["Tile"]).apply(null, arguments);
      };
      Module["_TopK"] = function() {
        return (Module["_TopK"] = Module["asm"]["TopK"]).apply(null, arguments);
      };
      Module["_Transform"] = function() {
        return (Module["_Transform"] = Module["asm"]["Transform"]).apply(null, arguments);
      };
      Module["_Transpose"] = function() {
        return (Module["_Transpose"] = Module["asm"]["Transpose"]).apply(null, arguments);
      };
      Module["__FusedMatMul"] = function() {
        return (Module["__FusedMatMul"] = Module["asm"]["_FusedMatMul"]).apply(null, arguments);
      };
      Module["_malloc"] = function() {
        return (Module["_malloc"] = Module["asm"]["malloc"]).apply(null, arguments);
      };
      Module["_free"] = function() {
        return (Module["_free"] = Module["asm"]["free"]).apply(null, arguments);
      };
      Module["___errno_location"] = function() {
        return (Module["___errno_location"] = Module["asm"]["__errno_location"]).apply(null, arguments);
      };
      Module["_emscripten_main_thread_process_queued_calls"] = function() {
        return (Module["_emscripten_main_thread_process_queued_calls"] = Module["asm"]["emscripten_main_thread_process_queued_calls"]).apply(null, arguments);
      };
      var stackSave = Module["stackSave"] = function() {
        return (stackSave = Module["stackSave"] = Module["asm"]["stackSave"]).apply(null, arguments);
      };
      var stackRestore = Module["stackRestore"] = function() {
        return (stackRestore = Module["stackRestore"] = Module["asm"]["stackRestore"]).apply(null, arguments);
      };
      var stackAlloc = Module["stackAlloc"] = function() {
        return (stackAlloc = Module["stackAlloc"] = Module["asm"]["stackAlloc"]).apply(null, arguments);
      };
      Module["dynCall_iijjiiii"] = function() {
        return (Module["dynCall_iijjiiii"] = Module["asm"]["dynCall_iijjiiii"]).apply(null, arguments);
      };
      Module["dynCall_jiji"] = function() {
        return (Module["dynCall_jiji"] = Module["asm"]["dynCall_jiji"]).apply(null, arguments);
      };
      Module["cwrap"] = cwrap;
      var calledRun;
      function ExitStatus(status) {
        this.name = "ExitStatus";
        this.message = "Program terminated with exit(" + status + ")";
        this.status = status;
      }
      dependenciesFulfilled = function runCaller() {
        if (!calledRun)
          run();
        if (!calledRun)
          dependenciesFulfilled = runCaller;
      };
      function run(args) {
        if (runDependencies > 0) {
          return;
        }
        preRun();
        if (runDependencies > 0) {
          return;
        }
        function doRun() {
          if (calledRun)
            return;
          calledRun = true;
          Module["calledRun"] = true;
          if (ABORT)
            return;
          initRuntime();
          readyPromiseResolve(Module);
          if (Module["onRuntimeInitialized"])
            Module["onRuntimeInitialized"]();
          postRun();
        }
        if (Module["setStatus"]) {
          Module["setStatus"]("Running...");
          setTimeout(function() {
            setTimeout(function() {
              Module["setStatus"]("");
            }, 1);
            doRun();
          }, 1);
        } else {
          doRun();
        }
      }
      Module["run"] = run;
      if (Module["preInit"]) {
        if (typeof Module["preInit"] == "function")
          Module["preInit"] = [Module["preInit"]];
        while (Module["preInit"].length > 0) {
          Module["preInit"].pop()();
        }
      }
      run();
      var listenersAdded;
      if (beforeListeners) {
        listenersAdded = { uncaughtException: process.listeners("uncaughtException").filter(function(listener) {
          return !beforeListeners.uncaughtException.indexOf(listener) > -1;
        }), unhandledRejection: process.listeners("unhandledRejection").filter(function(listener) {
          return !beforeListeners.unhandledRejection.indexOf(listener) > -1;
        }) };
      }
      var actualModule;
      if (typeof WasmBackendModule3 !== "undefined") {
        actualModule = WasmBackendModule3;
      } else if (typeof WasmBackendModuleThreadedSimd !== "undefined") {
        actualModule = WasmBackendModuleThreadedSimd;
      } else {
        throw new Error("Could not find wasm module in post.js");
      }
      if (listenersAdded) {
        var tmpDispose = actualModule["_dispose"];
        actualModule["_dispose"] = function() {
          tmpDispose();
          listenersAdded.uncaughtException.forEach(function(listener) {
            process.removeListener("uncaughtException", listener);
          });
          listenersAdded.unhandledRejection.forEach(function(listener) {
            process.removeListener("unhandledRejection", listener);
          });
        };
      }
      return WasmBackendModule3.ready;
    };
  })();
  module2.exports = WasmBackendModule2;
})(tfjsBackendWasm);
var wasmFactory = tfjsBackendWasm.exports;
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
class BackendWasm extends KernelBackend {
  constructor(wasm2) {
    super();
    this.wasm = wasm2;
    this.dataIdNextNumber = 1;
    this.wasm.tfjs.initWithThreadsCount(threadsCount);
    actualThreadsCount = this.wasm.tfjs.getThreadsCount();
    this.dataIdMap = new DataStorage(this, engine());
  }
  write(values, shape, dtype) {
    const dataId = { id: this.dataIdNextNumber++ };
    this.move(dataId, values, shape, dtype, 1);
    return dataId;
  }
  numDataIds() {
    return this.dataIdMap.numDataIds();
  }
  async time(f2) {
    const start = now();
    f2();
    const kernelMs = now() - start;
    return { kernelMs };
  }
  move(dataId, values, shape, dtype, refCount) {
    const id2 = this.dataIdNextNumber++;
    if (dtype === "string") {
      const stringBytes = values;
      this.dataIdMap.set(dataId, { id: id2, stringBytes, shape, dtype, memoryOffset: null, refCount });
      return;
    }
    const size = sizeFromShape(shape);
    const numBytes = size * bytesPerElement(dtype);
    const memoryOffset = this.wasm._malloc(numBytes);
    this.dataIdMap.set(dataId, { id: id2, memoryOffset, shape, dtype, refCount });
    this.wasm.tfjs.registerTensor(id2, size, memoryOffset);
    if (values != null) {
      this.wasm.HEAPU8.set(new Uint8Array(values.buffer, values.byteOffset, numBytes), memoryOffset);
    }
  }
  async read(dataId) {
    return this.readSync(dataId);
  }
  readSync(dataId, start, end) {
    const { memoryOffset, dtype, shape, stringBytes } = this.dataIdMap.get(dataId);
    if (dtype === "string") {
      if ((start == null || start === 0) && (end == null || end >= stringBytes.length)) {
        return stringBytes;
      }
      return stringBytes.slice(start, end);
    }
    start = start || 0;
    end = end || sizeFromShape(shape);
    const bytesPerElement$1 = bytesPerElement(dtype);
    const bytes = this.wasm.HEAPU8.slice(memoryOffset + start * bytesPerElement$1, memoryOffset + end * bytesPerElement$1);
    return typedArrayFromBuffer(bytes.buffer, dtype);
  }
  disposeData(dataId, force = false) {
    if (this.dataIdMap.has(dataId)) {
      const data2 = this.dataIdMap.get(dataId);
      data2.refCount--;
      if (!force && data2.refCount > 0) {
        return false;
      }
      this.wasm._free(data2.memoryOffset);
      this.wasm.tfjs.disposeData(data2.id);
      this.dataIdMap.delete(dataId);
    }
    return true;
  }
  refCount(dataId) {
    if (this.dataIdMap.has(dataId)) {
      const tensorData = this.dataIdMap.get(dataId);
      return tensorData.refCount;
    }
    return 0;
  }
  incRef(dataId) {
    const data2 = this.dataIdMap.get(dataId);
    if (data2 != null) {
      data2.refCount++;
    }
  }
  floatPrecision() {
    return 32;
  }
  getMemoryOffset(dataId) {
    return this.dataIdMap.get(dataId).memoryOffset;
  }
  dispose() {
    this.wasm.tfjs.dispose();
    if ("PThread" in this.wasm) {
      this.wasm.PThread.terminateAllThreads();
    }
    this.wasm = null;
  }
  memory() {
    return { unreliable: false };
  }
  makeOutput(shape, dtype, memoryOffset) {
    let dataId;
    if (memoryOffset == null) {
      dataId = this.write(null, shape, dtype);
    } else {
      const id2 = this.dataIdNextNumber++;
      dataId = { id: id2 };
      this.dataIdMap.set(dataId, { id: id2, memoryOffset, shape, dtype, refCount: 1 });
      const size = sizeFromShape(shape);
      this.wasm.tfjs.registerTensor(id2, size, memoryOffset);
    }
    return { dataId, shape, dtype };
  }
  typedArrayFromHeap({ shape, dtype, dataId }) {
    const buffer2 = this.wasm.HEAPU8.buffer;
    const { memoryOffset } = this.dataIdMap.get(dataId);
    const size = sizeFromShape(shape);
    switch (dtype) {
      case "float32":
        return new Float32Array(buffer2, memoryOffset, size);
      case "int32":
        return new Int32Array(buffer2, memoryOffset, size);
      case "bool":
        return new Uint8Array(buffer2, memoryOffset, size);
      default:
        throw new Error(`Unknown dtype ${dtype}`);
    }
  }
}
function createInstantiateWasmFunc(path2) {
  return (imports, callback) => {
    fetch$1(path2, { credentials: "same-origin" }).then((response) => {
      if (!response["ok"]) {
        imports.env.a(`failed to load wasm binary file at '${path2}'`);
      }
      response.arrayBuffer().then((binary) => {
        WebAssembly.instantiate(binary, imports).then((output2) => {
          callback(output2.instance, output2.module);
        });
      });
    });
    return {};
  };
}
function getPathToWasmBinary(simdSupported, threadsSupported, wasmModuleFolder) {
  let path2 = "tfjs-backend-wasm.wasm";
  if (simdSupported && threadsSupported) {
    path2 = "tfjs-backend-wasm-threaded-simd.wasm";
  } else if (simdSupported) {
    path2 = "tfjs-backend-wasm-simd.wasm";
  }
  if (wasmFileMap != null) {
    if (wasmFileMap[path2] != null) {
      return wasmFileMap[path2];
    }
  }
  return wasmModuleFolder + path2;
}
async function init() {
  const [simdSupported, threadsSupported] = await Promise.all([
    env().getAsync("WASM_HAS_SIMD_SUPPORT"),
    env().getAsync("WASM_HAS_MULTITHREAD_SUPPORT")
  ]);
  return new Promise((resolve, reject) => {
    const factoryConfig = {};
    factoryConfig.locateFile = (path2, prefix2) => {
      if (path2.endsWith(".worker.js")) {
        const response = wasmWorkerContents.replace(/\n/g, "\\n");
        const blob = new Blob([response], { type: "application/javascript" });
        return URL.createObjectURL(blob);
      }
      if (path2.endsWith(".wasm")) {
        return getPathToWasmBinary(simdSupported, threadsSupported, wasmPathPrefix != null ? wasmPathPrefix : prefix2);
      }
      return prefix2 + path2;
    };
    if (customFetch) {
      factoryConfig.instantiateWasm = createInstantiateWasmFunc(getPathToWasmBinary(simdSupported, threadsSupported, wasmPathPrefix != null ? wasmPathPrefix : ""));
    }
    let initialized = false;
    factoryConfig.onAbort = () => {
      if (initialized) {
        return;
      }
      if (initAborted) {
        return;
      }
      initAborted = true;
      const rejectMsg = "Make sure the server can serve the `.wasm` file relative to the bundled js file. For more details see https://github.com/tensorflow/tfjs/blob/master/tfjs-backend-wasm/README.md#using-bundlers";
      reject({ message: rejectMsg });
    };
    let wasm2;
    if (threadsSupported && simdSupported && wasmPath == null) {
      factoryConfig.mainScriptUrlOrBlob = new Blob([`var WasmBackendModuleThreadedSimd = ` + wasmFactoryThreadedSimd.toString()], { type: "text/javascript" });
      wasm2 = wasmFactoryThreadedSimd(factoryConfig);
    } else {
      wasm2 = wasmFactory(factoryConfig);
    }
    wasm2.then((module2) => {
      initialized = true;
      initAborted = false;
      const voidReturnType = null;
      module2.tfjs = {
        init: module2.cwrap("init", null, []),
        initWithThreadsCount: module2.cwrap("init_with_threads_count", null, ["number"]),
        getThreadsCount: module2.cwrap("get_threads_count", "number", []),
        registerTensor: module2.cwrap("register_tensor", null, [
          "number",
          "number",
          "number"
        ]),
        disposeData: module2.cwrap("dispose_data", voidReturnType, ["number"]),
        dispose: module2.cwrap("dispose", voidReturnType, [])
      };
      resolve({ wasm: module2 });
    });
  });
}
function typedArrayFromBuffer(buffer2, dtype) {
  switch (dtype) {
    case "float32":
      return new Float32Array(buffer2);
    case "int32":
      return new Int32Array(buffer2);
    case "bool":
      return new Uint8Array(buffer2);
    default:
      throw new Error(`Unknown dtype ${dtype}`);
  }
}
const wasmBinaryNames = [
  "tfjs-backend-wasm.wasm",
  "tfjs-backend-wasm-simd.wasm",
  "tfjs-backend-wasm-threaded-simd.wasm"
];
let wasmPath = null;
let wasmPathPrefix = null;
let wasmFileMap = {};
let initAborted = false;
let customFetch = false;
function setWasmPaths(prefixOrFileMap, usePlatformFetch = false) {
  if (initAborted) {
    throw new Error("The WASM backend was already initialized. Make sure you call `setWasmPaths()` before you call `tf.setBackend()` or `tf.ready()`");
  }
  if (typeof prefixOrFileMap === "string") {
    wasmPathPrefix = prefixOrFileMap;
  } else {
    wasmFileMap = prefixOrFileMap;
    const missingPaths = wasmBinaryNames.filter((name) => wasmFileMap[name] == null);
    if (missingPaths.length > 0) {
      throw new Error(`There were no entries found for the following binaries: ${missingPaths.join(",")}. Please either call setWasmPaths with a map providing a path for each binary, or with a string indicating the directory where all the binaries can be found.`);
    }
  }
  customFetch = usePlatformFetch;
}
let threadsCount = -1;
let actualThreadsCount = -1;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
const WASM_PRIORITY = 2;
registerBackend("wasm", async () => {
  const { wasm: wasm2 } = await init();
  return new BackendWasm(wasm2);
}, WASM_PRIORITY);
let net;
let isWarmup = false;
let cannotLoad = true;
const segmLayer = "StatefulPartitionedCall/model/mask/Sigmoid";
const classificationLayer = "StatefulPartitionedCall/model/cls/Sigmoid";
const qualityLayer = "StatefulPartitionedCall/model/attr/Sigmoid";
let classificationArr = [];
let glareArr = [];
let sharpnessArr = [];
let rectArr = [];
let widthArr = [];
const isWebRtcNotSupported$3 = !isWebRtcSupported();
let maskChanged = false;
let classificationShowed = false;
let segmentation = false;
let sizeThreshold = 0.28;
async function warmup() {
}
function loadModelFirstTime() {
  const dummy = zeros$1([384, 384, 3], "int32");
  const meanT = tensor3d([0.485, 0.456, 0.406], [1, 1, 3]);
  const stdT = tensor3d([0.229, 0.224, 0.225], [1, 1, 3]);
  isWarmup = true;
  const normalizedD = dummy.div(scalar(255)).sub(meanT).div(stdT);
  net.execute(normalizedD.expandDims(0), [
    segmLayer,
    classificationLayer,
    qualityLayer
  ]);
}
async function _warmup({
  androidModelURL = "https://template-console.s3.amazonaws.com/webcamera/model/ANDROID/model.json",
  iOSModelURL = "https://template-console.s3.amazonaws.com/webcamera/model/IOS/model.json",
  androidLowModelURL = "https://template-console.s3.amazonaws.com/webcamera/model/ANDROID_LOW/model.json",
  wasmPaths = "https://template-console.s3.amazonaws.com/webcamera/tfjs-backend-wasm3.7.0/",
  faceDetectorModelURL = "https://template-console.s3.amazonaws.com/webcamera/model/faceDetector/model.json"
} = {}) {
  var _a, _b;
  addEvent({
    token: (_a = state.token) == null ? void 0 : _a.token,
    eventName: "modelLoadStart",
    eventData: {},
    eventType: "text"
  });
  let modelType = "ANDROID";
  let loadSuccessful = true;
  if (isWarmup || isWebRtcNotSupported$3) {
    return;
  }
  enableProdMode();
  if (mobile.isDesktop()) {
    setWasmPaths(wasmPaths);
    setupFaceModel(faceDetectorModelURL);
  }
  if (mobile.Android()) {
    console.log("WASM");
    isWarmup = true;
    setWasmPaths(wasmPaths);
    try {
      await setBackend("wasm");
      loadGraphModel(androidModelURL).then((model2) => {
        net = model2;
        cannotLoad = false;
      });
    } catch (err) {
      loadSuccessful = false;
      console.log(err);
      cannotLoad = true;
    }
  } else {
    try {
      modelType = "IOS";
      await setBackend("webgl");
      console.log("Standard model");
      loadGraphModel(iOSModelURL).then((model2) => {
        net = model2;
        cannotLoad = false;
        loadModelFirstTime();
      }).catch(() => loadSuccessful = false);
    } catch {
      modelType = "ANDROID_LOW";
      loadSuccessful = true;
      console.log("WASM");
      await setBackend("wasm");
      setWasmPaths(wasmPaths);
      loadGraphModel(androidLowModelURL).then((model2) => {
        net = model2;
        cannotLoad = false;
      }).catch(() => loadSuccessful = false);
    }
  }
  addEvent({
    token: (_b = state.token) == null ? void 0 : _b.token,
    eventName: "modelLoadEnd",
    eventData: {
      modelType,
      loadSuccessful
    },
    eventType: "text"
  });
}
const getImages$2 = (width2, height2, scaleFactor, webcam) => {
  return webcam.getImageData(width2, height2);
};
function approximateQuadrangle(arr2) {
  const cv = window.cv;
  const src2 = cv.matFromArray(384, 384, cv.CV_8UC1, arr2);
  const contours = new cv.MatVector();
  const hierarchy = new cv.Mat();
  cv.findContours(src2, contours, hierarchy, cv.RETR_CCOMP, cv.CHAIN_APPROX_SIMPLE);
  src2.delete();
  hierarchy.delete();
  let max_area = 0;
  let max_idx = -1;
  for (let i2 = 0; i2 < contours.size(); ++i2) {
    const temp_area = cv.contourArea(contours.get(i2));
    if (temp_area > max_area) {
      max_area = temp_area;
      max_idx = i2;
    }
  }
  if (max_idx === -1) {
    return null;
  }
  const poly = new cv.Mat();
  const max_contour = contours.get(max_idx);
  const epsilon2 = 0.025 * cv.arcLength(max_contour, true);
  cv.approxPolyDP(max_contour, poly, epsilon2, true);
  max_contour.delete();
  contours.delete();
  return { poly, area: max_area };
}
async function singleFrameDetection(webcam) {
  ENV$5.set("WEBGL_PACK", false);
  enableProdMode();
  engine().startScope();
  const meanT = tensor3d([0.485, 0.456, 0.406], [1, 1, 3]);
  const stdT = tensor3d([0.229, 0.224, 0.225], [1, 1, 3]);
  const desired_size = 384;
  const images = getImages$2(webcam.video.videoWidth, webcam.video.videoHeight, 1, webcam);
  const img = fromPixels$1(images.imageElement);
  const max_side = Math.max(img.shape[0], img.shape[1]);
  const scale_factor = desired_size / max_side;
  let resized = img.resizeBilinear([
    Math.round(scale_factor * img.shape[0]),
    Math.round(scale_factor * img.shape[1])
  ]).toFloat();
  resized = resized.pad([
    [0, desired_size - resized.shape[0]],
    [0, desired_size - resized.shape[1]],
    [0, 0]
  ]);
  const normalized = resized.div(scalar(255)).sub(meanT).div(stdT);
  const expanded = normalized.expandDims(0);
  if (getBackend() != "wasm") {
    const result2 = await net.execute(expanded, [
      segmLayer,
      classificationLayer,
      qualityLayer
    ]);
    const segmData = await result2[0].data();
    const classificationElement = await result2[1].data();
    const qualityElement = await result2[2].data();
    const dataElement = segmData.map(function(x2) {
      if (x2 > 0.5)
        return true;
      else
        return false;
    });
    const res = approximateQuadrangle(dataElement);
    if (classificationElement[0] > 0.5 && res) {
      const tmp = res.poly;
      const area = res.area;
      const width2 = Math.abs(tmp.intAt(2, 0) - tmp.intAt(0, 0));
      if (qualityElement[0] < 0.5 && qualityElement[1] < 0.5 && tmp && tmp.size().height === 4 && area > 35e3 && area < 55e3 || width2 > 155 && width2 < 205) {
        return images.canvasElement.toDataURL().split(",")[1];
      }
    }
    return null;
  } else {
    const result2 = await net.execute(expanded, [
      classificationLayer,
      qualityLayer
    ]);
    const classificationElement = await result2[0].data();
    const qualityElement = await result2[1].data();
    if (classificationElement[0] > 0.5 && qualityElement[0] < 0.5 && qualityElement[1] < 0.5 && qualityElement[2] > sizeThreshold) {
      return images.canvasElement.toDataURL().split(",")[1];
    } else {
      return null;
    }
  }
}
async function idDetection({
  webcam,
  canvasId,
  ctx,
  onCapturing,
  onFarAway,
  onTooClose,
  onGlare,
  onBlur,
  onIDNotDetected,
  onNothingHappen,
  forceManualCapture,
  onMaskChange
}) {
  if (cannotLoad) {
    await sleep(1e3);
    forceManualCapture();
    return;
  }
  ENV$5.set("WEBGL_PACK", false);
  enableProdMode();
  engine().startScope();
  const meanT = tensor3d([0.485, 0.456, 0.406], [1, 1, 3]);
  const stdT = tensor3d([0.229, 0.224, 0.225], [1, 1, 3]);
  const desired_size = 384;
  const areaDown = mobile.isDesktop() ? 55e3 : 25e3;
  const areaUp = mobile.isDesktop() ? 75e3 : 55e3;
  const widthDown = mobile.isDesktop() ? 185 : 135;
  const widthUp = mobile.isDesktop() ? 255 : 205;
  const sharpnessThreshold = mobile.isDesktop() ? 0.8 : 0.6;
  const sharpnessChangeThreshold = mobile.isDesktop() ? 0.9 : 0.6;
  const glareThreshold = 0.6;
  const classificationThreshold = 0.4;
  const images = getImages$2(webcam.video.videoWidth, webcam.video.videoHeight, 1, webcam);
  const img = fromPixels$1(images.imageElement);
  const max_side = Math.max(img.shape[0], img.shape[1]);
  const scale_factor = desired_size / max_side;
  let resized = img.resizeBilinear([
    Math.round(scale_factor * img.shape[0]),
    Math.round(scale_factor * img.shape[1])
  ]).toFloat();
  resized = resized.pad([
    [0, desired_size - resized.shape[0]],
    [0, desired_size - resized.shape[1]],
    [0, 0]
  ]);
  const normalized = resized.div(scalar(255)).sub(meanT).div(stdT);
  const expanded = normalized.expandDims(0);
  let result2;
  let classificationElement;
  let qualityElement;
  let segmData;
  if (!segmentation) {
    result2 = await net.execute(expanded, [classificationLayer, qualityLayer]);
    classificationElement = await result2[0].data();
    qualityElement = await result2[1].data();
  } else {
    result2 = await net.execute(expanded, [
      segmLayer,
      classificationLayer,
      qualityLayer
    ]);
    segmData = await result2[0].data();
    classificationElement = await result2[1].data();
    qualityElement = await result2[2].data();
  }
  classificationArr.push(classificationElement[0]);
  sharpnessArr.push(qualityElement[0]);
  glareArr.push(qualityElement[1]);
  const classificationBad = classificationArr.slice(-classificationArr.length / 2).every(function(a6) {
    return a6 < classificationThreshold;
  });
  const sharpnessCheck = sharpnessArr.length && sharpnessArr.slice(-sharpnessArr.length / 3).every(function(a6) {
    return a6 > sharpnessThreshold;
  });
  const sharpnessChange = sharpnessArr.length && sharpnessArr.slice(-sharpnessArr.length / 2).every(function(a6) {
    return a6 > sharpnessChangeThreshold;
  });
  const glareCheck = glareArr.length && glareArr.slice(-glareArr.length / 3).every(function(a6) {
    return a6 > glareThreshold;
  });
  const glareChange = glareArr.length && glareArr.slice(-glareArr.length / 2).every(function(a6) {
    return a6 > glareThreshold;
  });
  if (getBackend() !== "wasm") {
    if (classificationElement[0] > classificationThreshold) {
      if (!segmentation) {
        const resultPom = await net.execute(expanded, [
          segmLayer,
          classificationLayer,
          qualityLayer
        ]);
        segmData = await resultPom[0].data();
      }
      segmentation = true;
      const dataElement = segmData.map(function(x2) {
        if (x2 > 0.5)
          return true;
        else
          return false;
      });
      const res = approximateQuadrangle(dataElement);
      if (res) {
        const tmp = res.poly;
        const area = res.area;
        const width2 = Math.abs(tmp.intAt(2, 0) - tmp.intAt(0, 0));
        const height2 = Math.abs(tmp.intAt(2, 1) - tmp.intAt(0, 1));
        const top2 = Math.round(tmp.intAt(0, 1) * window.innerHeight / desired_size);
        rectArr.push(area);
        widthArr.push(width2);
        if (tmp && tmp.size().height === 4) {
          onFarAway();
          if (!maskChanged && width2 >= height2) {
            maskChanged = true;
            onMaskChange(true, true, top2 - top2 / 10);
          } else if (width2 < height2) {
            maskChanged = false;
            onMaskChange(true, false);
          }
          if (area > areaDown && area < areaUp || width2 > widthDown && width2 < widthUp) {
            if (qualityElement[0] < sharpnessThreshold && qualityElement[1] < glareThreshold) {
              engine().endScope();
              rectArr = [];
              widthArr = [];
              classificationArr = [];
              sharpnessArr = [];
              glareArr = [];
              maskChanged = false;
              classificationShowed = false;
              segmentation = false;
              return onCapturing(images);
            } else if (sharpnessArr.length > 0 && sharpnessChange) {
              onBlur(true);
            } else if (sharpnessArr.length > 0 && sharpnessCheck) {
              onBlur(false);
            } else if (glareArr.length > 0 && glareChange) {
              onGlare(true);
              glareArr = [];
            } else if (glareArr.length > 0 && glareCheck) {
              onGlare(false);
            }
          }
        }
      }
    } else if (!classificationShowed && classificationArr.length > 0 && classificationBad) {
      classificationShowed = true;
      onIDNotDetected();
      classificationArr = [];
    }
  } else {
    if (classificationElement[0] > classificationThreshold && qualityElement[2] > sizeThreshold && (qualityElement[0] < sharpnessThreshold && qualityElement[1] < glareThreshold || mobile.isDesktop())) {
      engine().endScope();
      return onCapturing(images);
    } else if (classificationElement[0] < classificationThreshold || qualityElement[2] < sizeThreshold) {
      onIDNotDetected();
    } else if (classificationElement[0] > classificationThreshold && qualityElement[0] > sharpnessThreshold) {
      onBlur();
    } else if (classificationElement[0] > classificationThreshold && qualityElement[1] > glareThreshold) {
      onGlare(false);
    } else if (glareArr.length > 0 && glareChange) {
      onGlare(true);
      glareArr = [];
    }
  }
  engine().endScope();
  await nextFrame();
}
async function idVideoSelfieDetection({
  webcam,
  onCapturing,
  onFarAway,
  onNothingHappen
}) {
  if (cannotLoad) {
    await sleep(3e3);
    onCapturing();
    return;
  }
  ENV$5.set("WEBGL_PACK", false);
  enableProdMode();
  if (!webcam.video)
    return;
  engine().startScope();
  const meanT = tensor3d([0.485, 0.456, 0.406], [1, 1, 3]);
  const stdT = tensor3d([0.229, 0.224, 0.225], [1, 1, 3]);
  const desired_size = 384;
  const img = fromPixels$1(webcam.video);
  const max_side = Math.max(img.shape[0], img.shape[1]);
  const scale_factor = desired_size / max_side;
  let resized = img.resizeBilinear([scale_factor * img.shape[0], scale_factor * img.shape[1]]).toFloat();
  resized = resized.pad([
    [0, desired_size - resized.shape[0]],
    [0, desired_size - resized.shape[1]],
    [0, 0]
  ]);
  const normalized = resized.div(scalar(255)).sub(meanT).div(stdT);
  const expanded = normalized.expandDims(0);
  const result2 = net.execute(expanded, [classificationLayer, qualityLayer]);
  const classificationElement = await result2[0].data();
  const qualityElement = await result2[1].data();
  engine().endScope();
  if (classificationElement > 0.5 && qualityElement[2] > sizeThreshold) {
    onCapturing();
  } else {
    onFarAway();
  }
  await nextFrame();
}
const frontType = "front";
const backType = "back";
const selfieType = "selfie";
const frontIdUrl = "/omni/add/front-id";
const secondFrontIdUrl = "/omni/add/front-second-id";
const backIdUrl = "/omni/add/back-id";
const secondBackIdUrl = "/omni/add/back-second-id";
const frontIdBase64Url = "/omni/add/front-id/v2";
const backIdBase64Url = "/omni/add/back-id/v2";
const getSelfieUrl = (type) => `/omni/add/face?imageType=${type}`;
function uploadFrontId({
  token,
  image: image2,
  onProgress = emptyFunc,
  sendBase64,
  onlyFront,
  isRetry = false,
  isSecondId = false
}) {
  const baseUrl = sendBase64 ? frontIdBase64Url : isSecondId ? secondFrontIdUrl : frontIdUrl;
  const url = onlyFront ? baseUrl + "?onlyFront=" + onlyFront : baseUrl;
  const body = sendBase64 ? { base64Image: image2 } : image2;
  const contentType = sendBase64 ? "application/json" : "image/jpeg";
  return api.post(url, body, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": contentType
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100),
    params: __spreadValues({}, isRetry ? { retry: true } : void 0)
  }).then((response) => {
    return response.data;
  });
}
function uploadBackId({
  token,
  image: image2,
  onProgress = emptyFunc,
  sendBase64,
  isRetry = false,
  isSecondId = false
}) {
  const url = sendBase64 ? backIdBase64Url : isSecondId ? secondBackIdUrl : backIdUrl;
  const body = sendBase64 ? { base64Image: image2 } : image2;
  const contentType = sendBase64 ? "application/json" : "image/jpeg";
  return api.post(url, body, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": contentType
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100),
    params: __spreadValues({}, isRetry ? { retry: true } : void 0)
  }).then((response) => {
    return response.data;
  });
}
function uploadSelfie({
  token,
  image: image2,
  onProgress = emptyFunc,
  encrypted,
  imageType: imageType2 = "selfie",
  faceCoordinates
}) {
  return api.post(getSelfieUrl(imageType2), { base64Image: image2, encrypted, faceCoordinates }, {
    headers: {
      "X-Incode-Hardware-Id": token
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
  }).then((response) => response.data);
}
function capture(_a) {
  var _b = _a, { type } = _b, props = __objRest(_b, ["type"]);
  if (type === frontType) {
    return uploadFrontId(__spreadValues({}, props));
  }
  if (type === backType) {
    return uploadBackId(__spreadValues({}, props));
  }
  if (type === selfieType) {
    return uploadSelfie(__spreadValues({}, props));
  }
  throw new Error(`type not supported, please use one of this: [${frontType}, ${backType}, ${selfieType}]`);
}
const widthThreshold = 0.65;
const heightThreshold = 0.65;
const minWidth = 120;
const minHeight = 170;
const neighbours = 0;
function detect({
  type,
  canvas,
  canvasId = false,
  webcam,
  onFarAway = emptyFunc,
  onBlur = emptyFunc,
  onGlare = emptyFunc,
  onCapturing = emptyFunc,
  onCapture = emptyFunc,
  onTooManyFaces = emptyFunc,
  onCenterFace = emptyFunc,
  onIDNotDetected = emptyFunc,
  onTooClose = emptyFunc,
  onNothingHappen = emptyFunc,
  onPercentage = emptyFunc,
  onNoFace = emptyFunc,
  forceManualCapture = emptyFunc,
  onMaskChange = emptyFunc,
  looseMode = false
}) {
  if (!canvas)
    return;
  canvas.width = 300;
  canvas.height = 400;
  const context2 = canvas.getContext("2d");
  let ctx = null;
  if (canvasId) {
    canvasId.width = webcam.video.videoWidth;
    canvasId.height = webcam.video.videoHeight;
    ctx = canvasId.getContext("2d");
    ctx.fillStyle = "red";
  }
  window.clearInterval(state.intervalId);
  const detectionFunction = ((type2) => {
    if (type2 === frontType || type2 === backType) {
      return idDetection;
    }
    if (type2 === selfieType) {
      return mobile.isDesktop() ? detectFace : callFaceDetection;
    }
    throw new Error(`type not supported, please use one of this: [${frontType}, ${backType}, ${selfieType}]`);
  })(type);
  const classificationParams = {
    canvas,
    context: context2,
    canvasId,
    ctx,
    widthThreshold,
    heightThreshold,
    minWidth,
    minHeight,
    neighbours,
    webcam,
    onFarAway,
    onCenterFace,
    onTooManyFaces,
    onBlur,
    onGlare,
    onCapturing,
    onCapture,
    onIDNotDetected,
    onTooClose,
    onNothingHappen,
    onPercentage,
    onNoFace,
    looseMode,
    forceManualCapture,
    onMaskChange
  };
  if (detectionFunction === idDetection || detectionFunction === detectFace) {
    const loop = async () => {
      if (!state.detecting) {
        await sleep(1e3);
        return;
      }
      await detectionFunction(classificationParams);
      await sleep(100);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  } else {
    state.intervalId = window.setInterval(() => {
      if (!state.detecting) {
        return;
      }
      detectionFunction(classificationParams);
    }, 100);
  }
}
function stopDetect() {
  window.clearInterval(state.intervalId);
  state.detecting = false;
}
function resumeDetect() {
  state.detecting = true;
}
function detectFrame(webcam) {
  return singleFrameDetection(webcam);
}
var axios$2 = { exports: {} };
var bind$2 = function bind2(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined$1(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer$1(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return toString.call(val) === "[object FormData]";
}
function isArrayBufferView(val) {
  var result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer$1(val.buffer);
  }
  return result2;
}
function isString$3(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject$4(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile$2(val) {
  return toString.call(val) === "[object File]";
}
function isBlob$1(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction$1(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject$4(val) && isFunction$1(val.pipe);
}
function isURLSearchParams(val) {
  return toString.call(val) === "[object URLSearchParams]";
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
      fn.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result2 = {};
  function assignValue(val, key) {
    if (isPlainObject(result2[key]) && isPlainObject(val)) {
      result2[key] = merge(result2[key], val);
    } else if (isPlainObject(val)) {
      result2[key] = merge({}, val);
    } else if (isArray(val)) {
      result2[key] = val.slice();
    } else {
      result2[key] = val;
    }
  }
  for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
    forEach(arguments[i2], assignValue);
  }
  return result2;
}
function extend(a6, b2, thisArg) {
  forEach(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a6[key] = bind$1(val, thisArg);
    } else {
      a6[key] = val;
    }
  });
  return a6;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$e = {
  isArray,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString$3,
  isNumber,
  isObject: isObject$4,
  isPlainObject,
  isUndefined: isUndefined$1,
  isDate,
  isFile: isFile$2,
  isBlob: isBlob$1,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$d = utils$e;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL2(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$d.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$d.forEach(val, function parseValue2(v2) {
        if (utils$d.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$d.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts.push(encode(key) + "=" + encode(v2));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$c = utils$e;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id2) {
  if (this.handlers[id2]) {
    this.handlers[id2] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$b = utils$e;
var normalizeHeaderName$1 = function normalizeHeaderName2(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError2(error3, config2, code, request4, response) {
  error3.config = config2;
  if (code) {
    error3.code = code;
  }
  error3.request = request4;
  error3.response = response;
  error3.isAxiosError = true;
  error3.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error3;
};
var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError2(message2, config2, code, request4, response) {
  var error3 = new Error(message2);
  return enhanceError$1(error3, config2, code, request4, response);
};
var createError$1 = createError$2;
var settle$1 = function settle2(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$a = utils$e;
var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path2, domain, secure) {
      var cookie2 = [];
      cookie2.push(name + "=" + encodeURIComponent(value));
      if (utils$a.isNumber(expires)) {
        cookie2.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$a.isString(path2)) {
        cookie2.push("path=" + path2);
      }
      if (utils$a.isString(domain)) {
        cookie2.push("domain=" + domain);
      }
      if (secure === true) {
        cookie2.push("secure");
      }
      document.cookie = cookie2.join("; ");
    },
    read: function read2(name) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove3(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read2() {
      return null;
    },
    remove: function remove3() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL2(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs2(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;
var buildFullPath$1 = function buildFullPath2(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$9 = utils$e;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders2(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$9.forEach(headers.split("\n"), function parser(line) {
    i2 = line.indexOf(":");
    key = utils$9.trim(line.substr(0, i2)).toLowerCase();
    val = utils$9.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$8 = utils$e;
var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message2) {
  this.message = message2;
}
Cancel$3.prototype.toString = function toString3() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$7 = utils$e;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;
var transitionalDefaults$1 = transitional;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config2) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config2.data;
    var requestHeaders = config2.headers;
    var responseType = config2.responseType;
    var onCanceled;
    function done() {
      if (config2.cancelToken) {
        config2.cancelToken.unsubscribe(onCanceled);
      }
      if (config2.signal) {
        config2.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$7.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request4 = new XMLHttpRequest();
    if (config2.auth) {
      var username = config2.auth.username || "";
      var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath(config2.baseURL, config2.url);
    request4.open(config2.method.toUpperCase(), buildURL$1(fullPath, config2.params, config2.paramsSerializer), true);
    request4.timeout = config2.timeout;
    function onloadend() {
      if (!request4) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request4 ? parseHeaders(request4.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request4.responseText : request4.response;
      var response = {
        data: responseData,
        status: request4.status,
        statusText: request4.statusText,
        headers: responseHeaders,
        config: config2,
        request: request4
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request4 = null;
    }
    if ("onloadend" in request4) {
      request4.onloadend = onloadend;
    } else {
      request4.onreadystatechange = function handleLoad() {
        if (!request4 || request4.readyState !== 4) {
          return;
        }
        if (request4.status === 0 && !(request4.responseURL && request4.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request4.onabort = function handleAbort() {
      if (!request4) {
        return;
      }
      reject(createError("Request aborted", config2, "ECONNABORTED", request4));
      request4 = null;
    };
    request4.onerror = function handleError() {
      reject(createError("Network Error", config2, null, request4));
      request4 = null;
    };
    request4.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config2.timeout ? "timeout of " + config2.timeout + "ms exceeded" : "timeout exceeded";
      var transitional3 = config2.transitional || transitionalDefaults$1;
      if (config2.timeoutErrorMessage) {
        timeoutErrorMessage = config2.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config2, transitional3.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request4));
      request4 = null;
    };
    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config2.withCredentials || isURLSameOrigin(fullPath)) && config2.xsrfCookieName ? cookies.read(config2.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config2.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request4) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request4.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$7.isUndefined(config2.withCredentials)) {
      request4.withCredentials = !!config2.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request4.responseType = config2.responseType;
    }
    if (typeof config2.onDownloadProgress === "function") {
      request4.addEventListener("progress", config2.onDownloadProgress);
    }
    if (typeof config2.onUploadProgress === "function" && request4.upload) {
      request4.upload.addEventListener("progress", config2.onUploadProgress);
    }
    if (config2.cancelToken || config2.signal) {
      onCanceled = function(cancel) {
        if (!request4) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request4.abort();
        request4 = null;
      };
      config2.cancelToken && config2.cancelToken.subscribe(onCanceled);
      if (config2.signal) {
        config2.signal.aborted ? onCanceled() : config2.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request4.send(requestData);
  });
};
var utils$6 = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$2;
var transitionalDefaults = transitional;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName(headers, "Accept");
    normalizeHeaderName(headers, "Content-Type");
    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }
    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method2) {
  defaults$3.headers[method2] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method2) {
  defaults$3.headers[method2] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$5 = utils$e;
var defaults$2 = defaults_1;
var transformData$1 = function transformData2(data2, headers, fns) {
  var context2 = this || defaults$2;
  utils$5.forEach(fns, function transform2(fn) {
    data2 = fn.call(context2, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel2(value) {
  return !!(value && value.__CANCEL__);
};
var utils$4 = utils$e;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
  if (config2.signal && config2.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest2(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = config2.headers || {};
  config2.data = transformData.call(config2, config2.data, config2.headers, config2.transformRequest);
  config2.headers = utils$4.merge(config2.headers.common || {}, config2.headers[config2.method] || {}, config2.headers);
  utils$4.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method2) {
    delete config2.headers[method2];
  });
  var adapter = config2.adapter || defaults$1.adapter;
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData.call(config2, response.data, response.headers, config2.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData.call(config2, reason.response.data, reason.response.headers, config2.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$3 = utils$e;
var mergeConfig$2 = function mergeConfig2(config1, config2) {
  config2 = config2 || {};
  var config3 = {};
  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config3[prop] = configValue);
  });
  return config3;
};
var data = {
  "version": "0.26.1"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional2(validator2, version2, message2) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message2 ? ". " + message2 : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i2 = keys.length;
  while (i2-- > 0) {
    var opt = keys[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new TypeError("option " + opt + " must be " + result2);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$2 = utils$e;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request3(configOrUrl, config2) {
  if (typeof configOrUrl === "string") {
    config2 = config2 || {};
    config2.url = configOrUrl;
  } else {
    config2 = configOrUrl || {};
  }
  config2 = mergeConfig$1(this.defaults, config2);
  if (config2.method) {
    config2.method = config2.method.toLowerCase();
  } else if (this.defaults.method) {
    config2.method = this.defaults.method.toLowerCase();
  } else {
    config2.method = "get";
  }
  var transitional3 = config2.transitional;
  if (transitional3 !== void 0) {
    validator.assertOptions(transitional3, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config2);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config2;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error3) {
      onRejected(error3);
      break;
    }
  }
  try {
    promise = dispatchRequest(newConfig);
  } catch (error3) {
    return Promise.reject(error3);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config2) {
  config2 = mergeConfig$1(this.defaults, config2);
  return buildURL(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
};
utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method2) {
  Axios$1.prototype[method2] = function(url, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method: method2,
      url,
      data: (config2 || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method2) {
  Axios$1.prototype[method2] = function(url, data2, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method: method2,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i2;
    var l2 = token._listeners.length;
    for (i2 = 0; i2 < l2; i2++) {
      token._listeners[i2](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message2) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message2);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c2) {
    cancel = c2;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr2) {
    return callback.apply(null, arr2);
  };
};
var utils$1 = utils$e;
var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};
var utils = utils$e;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context2 = new Axios(defaultConfig);
  var instance2 = bind(Axios.prototype.request, context2);
  utils.extend(instance2, Axios.prototype, context2);
  utils.extend(instance2, context2);
  instance2.create = function create3(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance2;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all2(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const createApi = ({ apiKey: apiKey2, apiURL }) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "api-version": "1.0"
  };
  if (apiKey2) {
    headers["x-api-key"] = apiKey2;
  }
  const axiosInstance = axios.create({
    baseURL: apiURL,
    headers
  });
  const createRequest = (method2) => (url, data2, config2) => {
    return axiosInstance(__spreadValues({
      method: method2,
      url,
      data: data2
    }, config2)).then((response) => {
      return __spreadValues({
        success: response.status >= 200 && response.status < 300
      }, response);
    });
  };
  return {
    get: createRequest("GET"),
    post: createRequest("POST"),
    put: createRequest("PUT"),
    delete: createRequest("DELETE"),
    request: (url, method2 = "GET") => createRequest(method2)(url),
    instance: axiosInstance
  };
};
let theme$1 = {
  main: "#3db0f7",
  buttonBorderRadius: "31px",
  buttonColor: "#fff",
  modal: {},
  mainButton: {},
  secondaryButton: {}
};
const setTheme = (customTheme) => {
  theme$1 = __spreadProps(__spreadValues(__spreadValues({}, theme$1), customTheme), {
    mainButton: __spreadValues(__spreadValues({}, theme$1.mainButton), customTheme.mainButton),
    secondaryButton: __spreadValues(__spreadValues({}, theme$1.secondaryButton), customTheme.secondaryButton),
    modal: __spreadValues(__spreadValues({}, theme$1.modal), customTheme.modal)
  });
  return theme$1;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2 = typeof Symbol === "function" && Symbol.for, c$1 = b$2 ? Symbol.for("react.element") : 60103, d = b$2 ? Symbol.for("react.portal") : 60106, e = b$2 ? Symbol.for("react.fragment") : 60107, f$1 = b$2 ? Symbol.for("react.strict_mode") : 60108, g$2 = b$2 ? Symbol.for("react.profiler") : 60114, h$1 = b$2 ? Symbol.for("react.provider") : 60109, k$1 = b$2 ? Symbol.for("react.context") : 60110, l = b$2 ? Symbol.for("react.async_mode") : 60111, m$1 = b$2 ? Symbol.for("react.concurrent_mode") : 60111, n$1 = b$2 ? Symbol.for("react.forward_ref") : 60112, p$1 = b$2 ? Symbol.for("react.suspense") : 60113, q$2 = b$2 ? Symbol.for("react.suspense_list") : 60120, r = b$2 ? Symbol.for("react.memo") : 60115, t = b$2 ? Symbol.for("react.lazy") : 60116, v$1 = b$2 ? Symbol.for("react.block") : 60121, w$1 = b$2 ? Symbol.for("react.fundamental") : 60117, x$1 = b$2 ? Symbol.for("react.responder") : 60118, y = b$2 ? Symbol.for("react.scope") : 60119;
function z$1(a6) {
  if (typeof a6 === "object" && a6 !== null) {
    var u2 = a6.$$typeof;
    switch (u2) {
      case c$1:
        switch (a6 = a6.type, a6) {
          case l:
          case m$1:
          case e:
          case g$2:
          case f$1:
          case p$1:
            return a6;
          default:
            switch (a6 = a6 && a6.$$typeof, a6) {
              case k$1:
              case n$1:
              case t:
              case r:
              case h$1:
                return a6;
              default:
                return u2;
            }
        }
      case d:
        return u2;
    }
  }
}
function A$1(a6) {
  return z$1(a6) === m$1;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m$1;
reactIs_production_min.ContextConsumer = k$1;
reactIs_production_min.ContextProvider = h$1;
reactIs_production_min.Element = c$1;
reactIs_production_min.ForwardRef = n$1;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g$2;
reactIs_production_min.StrictMode = f$1;
reactIs_production_min.Suspense = p$1;
reactIs_production_min.isAsyncMode = function(a6) {
  return A$1(a6) || z$1(a6) === l;
};
reactIs_production_min.isConcurrentMode = A$1;
reactIs_production_min.isContextConsumer = function(a6) {
  return z$1(a6) === k$1;
};
reactIs_production_min.isContextProvider = function(a6) {
  return z$1(a6) === h$1;
};
reactIs_production_min.isElement = function(a6) {
  return typeof a6 === "object" && a6 !== null && a6.$$typeof === c$1;
};
reactIs_production_min.isForwardRef = function(a6) {
  return z$1(a6) === n$1;
};
reactIs_production_min.isFragment = function(a6) {
  return z$1(a6) === e;
};
reactIs_production_min.isLazy = function(a6) {
  return z$1(a6) === t;
};
reactIs_production_min.isMemo = function(a6) {
  return z$1(a6) === r;
};
reactIs_production_min.isPortal = function(a6) {
  return z$1(a6) === d;
};
reactIs_production_min.isProfiler = function(a6) {
  return z$1(a6) === g$2;
};
reactIs_production_min.isStrictMode = function(a6) {
  return z$1(a6) === f$1;
};
reactIs_production_min.isSuspense = function(a6) {
  return z$1(a6) === p$1;
};
reactIs_production_min.isValidElementType = function(a6) {
  return typeof a6 === "string" || typeof a6 === "function" || a6 === e || a6 === m$1 || a6 === g$2 || a6 === f$1 || a6 === p$1 || a6 === q$2 || typeof a6 === "object" && a6 !== null && (a6.$$typeof === t || a6.$$typeof === r || a6.$$typeof === h$1 || a6.$$typeof === k$1 || a6.$$typeof === n$1 || a6.$$typeof === w$1 || a6.$$typeof === x$1 || a6.$$typeof === y || a6.$$typeof === v$1);
};
reactIs_production_min.typeOf = z$1;
{
  reactIs$1.exports = reactIs_production_min;
}
function stylis_min(W2) {
  function M2(d2, c2, e2, h2, a6) {
    for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x2 = 0, K2 = 0, k3, u2 = k3 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e2.length, J2 = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C; l2 < B3; ) {
      g2 = e2.charCodeAt(l2);
      l2 === J2 && b2 + n2 + v2 + m2 !== 0 && (b2 !== 0 && (g2 = b2 === 47 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J2++);
      if (b2 + n2 + v2 + m2 === 0) {
        if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e2.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k3 = 1;
            for (t2 = ++l2; l2 < B3; ) {
              switch (g2 = e2.charCodeAt(l2)) {
                case 123:
                  k3++;
                  break;
                case 125:
                  k3--;
                  break;
                case 47:
                  switch (g2 = e2.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J2; ++u2) {
                          switch (e2.charCodeAt(u2)) {
                            case 47:
                              if (g2 === 42 && e2.charCodeAt(u2 - 1) === 42 && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (g2 === 47) {
                                l2 = u2 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u2;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J2 && e2.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (k3 === 0)
                break;
              l2++;
            }
            k3 = e2.substring(t2, l2);
            q2 === 0 && (q2 = (f2 = f2.replace(ca2, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r2 && (f2 = f2.replace(N2, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c2;
                    break;
                  default:
                    r2 = O;
                }
                k3 = M2(c2, r2, k3, g2, a6 + 1);
                t2 = k3.length;
                0 < A2 && (r2 = X2(O, f2, I2), C = H2(3, k3, r2, c2, D2, z2, t2, g2, a6, h2), f2 = r2.join(""), C !== void 0 && (t2 = (k3 = C.trim()).length) === 0 && (g2 = 0, k3 = ""));
                if (0 < t2)
                  switch (g2) {
                    case 115:
                      f2 = f2.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k3 = f2 + "{" + k3 + "}";
                      break;
                    case 107:
                      f2 = f2.replace(fa, "$1 $2");
                      k3 = f2 + "{" + k3 + "}";
                      k3 = w2 === 1 || w2 === 2 && L2("@" + k3, 3) ? "@-webkit-" + k3 + "@" + k3 : "@" + k3;
                      break;
                    default:
                      k3 = f2 + k3, h2 === 112 && (k3 = (p2 += k3, ""));
                  }
                else
                  k3 = "";
                break;
              default:
                k3 = M2(c2, X2(c2, f2, I2), k3, h2, a6 + 1);
            }
            F3 += k3;
            k3 = I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
            if (1 < (t2 = f2.length))
              switch (u2 === 0 && (q2 = f2.charCodeAt(0), q2 === 45 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && (C = H2(1, f2, c2, d2, D2, z2, p2.length, h2, a6, h2)) !== void 0 && (t2 = (f2 = C.trim()).length) === 0 && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
                case 0:
                  break;
                case 64:
                  if (g2 === 105 || g2 === 99) {
                    G3 += f2 + e2.charAt(l2);
                    break;
                  }
                default:
                  f2.charCodeAt(t2 - 1) !== 58 && (p2 += P2(f2, q2, g2, f2.charCodeAt(2)));
              }
            I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          b2 === 47 ? b2 = 0 : 1 + q2 === 0 && h2 !== 107 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y2 && H2(0, f2, c2, d2, D2, z2, p2.length, h2, a6, h2);
          z2 = 1;
          D2++;
          break;
        case 59:
        case 125:
          if (b2 + n2 + v2 + m2 === 0) {
            z2++;
            break;
          }
        default:
          z2++;
          y2 = e2.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (n2 + m2 + b2 === 0)
                switch (x2) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y2 = "";
                    break;
                  default:
                    g2 !== 32 && (y2 = " ");
                }
              break;
            case 0:
              y2 = "\\0";
              break;
            case 12:
              y2 = "\\f";
              break;
            case 11:
              y2 = "\\v";
              break;
            case 38:
              n2 + b2 + m2 === 0 && (r2 = I2 = 1, y2 = "\f" + y2);
              break;
            case 108:
              if (n2 + b2 + m2 + E2 === 0 && 0 < u2)
                switch (l2 - u2) {
                  case 2:
                    x2 === 112 && e2.charCodeAt(l2 - 3) === 58 && (E2 = x2);
                  case 8:
                    K2 === 111 && (E2 = K2);
                }
              break;
            case 58:
              n2 + b2 + m2 === 0 && (u2 = l2);
              break;
            case 44:
              b2 + v2 + n2 + m2 === 0 && (r2 = 1, y2 += "\r");
              break;
            case 34:
            case 39:
              b2 === 0 && (n2 = n2 === g2 ? 0 : n2 === 0 ? g2 : n2);
              break;
            case 91:
              n2 + b2 + v2 === 0 && m2++;
              break;
            case 93:
              n2 + b2 + v2 === 0 && m2--;
              break;
            case 41:
              n2 + b2 + m2 === 0 && v2--;
              break;
            case 40:
              if (n2 + b2 + m2 === 0) {
                if (q2 === 0)
                  switch (2 * x2 + 3 * K2) {
                    case 533:
                      break;
                    default:
                      q2 = 1;
                  }
                v2++;
              }
              break;
            case 64:
              b2 + v2 + n2 + m2 + u2 + k3 === 0 && (k3 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m2 + v2))
                switch (b2) {
                  case 0:
                    switch (2 * g2 + 3 * e2.charCodeAt(l2 + 1)) {
                      case 235:
                        b2 = 47;
                        break;
                      case 220:
                        t2 = l2, b2 = 42;
                    }
                    break;
                  case 42:
                    g2 === 47 && x2 === 42 && t2 + 2 !== l2 && (e2.charCodeAt(t2 + 2) === 33 && (p2 += e2.substring(t2, l2 + 1)), y2 = "", b2 = 0);
                }
          }
          b2 === 0 && (f2 += y2);
      }
      K2 = x2;
      x2 = g2;
      l2++;
    }
    t2 = p2.length;
    if (0 < t2) {
      r2 = c2;
      if (0 < A2 && (C = H2(2, p2, r2, d2, D2, z2, t2, h2, a6, h2), C !== void 0 && (p2 = C).length === 0))
        return G3 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";
      if (w2 * E2 !== 0) {
        w2 !== 2 || L2(p2, 2) || (E2 = 0);
        switch (E2) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q2, "::-webkit-input-$1") + p2.replace(Q2, "::-moz-$1") + p2.replace(Q2, ":-ms-input-$1") + p2;
        }
        E2 = 0;
      }
    }
    return G3 + p2 + F3;
  }
  function X2(d2, c2, e2) {
    var h2 = c2.trim().split(ia);
    c2 = h2;
    var a6 = h2.length, m2 = d2.length;
    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;
        for (d2 = m2 === 0 ? "" : d2[0] + " "; b2 < a6; ++b2) {
          c2[b2] = Z2(d2, c2[b2], e2).trim();
        }
        break;
      default:
        var v2 = b2 = 0;
        for (c2 = []; b2 < a6; ++b2) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c2[v2++] = Z2(d2[n2] + " ", h2[b2], e2).trim();
          }
        }
    }
    return c2;
  }
  function Z2(d2, c2, e2) {
    var h2 = c2.charCodeAt(0);
    33 > h2 && (h2 = (c2 = c2.trim()).charCodeAt(0));
    switch (h2) {
      case 38:
        return c2.replace(F2, "$1" + d2.trim());
      case 58:
        return d2.trim() + c2.replace(F2, "$1" + d2.trim());
      default:
        if (0 < 1 * e2 && 0 < c2.indexOf("\f"))
          return c2.replace(F2, (d2.charCodeAt(0) === 58 ? "" : "$1") + d2.trim());
    }
    return d2 + c2;
  }
  function P2(d2, c2, e2, h2) {
    var a6 = d2 + ";", m2 = 2 * c2 + 3 * e2 + 4 * h2;
    if (m2 === 944) {
      d2 = a6.indexOf(":", 9) + 1;
      var b2 = a6.substring(d2, a6.length - 1).trim();
      b2 = a6.substring(0, d2).trim() + b2 + ";";
      return w2 === 1 || w2 === 2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }
    if (w2 === 0 || w2 === 2 && !L2(a6, 1))
      return a6;
    switch (m2) {
      case 1015:
        return a6.charCodeAt(10) === 97 ? "-webkit-" + a6 + a6 : a6;
      case 951:
        return a6.charCodeAt(3) === 116 ? "-webkit-" + a6 + a6 : a6;
      case 963:
        return a6.charCodeAt(5) === 110 ? "-webkit-" + a6 + a6 : a6;
      case 1009:
        if (a6.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a6 + a6;
      case 978:
        return "-webkit-" + a6 + "-moz-" + a6 + a6;
      case 1019:
      case 983:
        return "-webkit-" + a6 + "-moz-" + a6 + "-ms-" + a6 + a6;
      case 883:
        if (a6.charCodeAt(8) === 45)
          return "-webkit-" + a6 + a6;
        if (0 < a6.indexOf("image-set(", 11))
          return a6.replace(ja, "$1-webkit-$2") + a6;
        break;
      case 932:
        if (a6.charCodeAt(4) === 45)
          switch (a6.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a6.replace("-grow", "") + "-webkit-" + a6 + "-ms-" + a6.replace("grow", "positive") + a6;
            case 115:
              return "-webkit-" + a6 + "-ms-" + a6.replace("shrink", "negative") + a6;
            case 98:
              return "-webkit-" + a6 + "-ms-" + a6.replace("basis", "preferred-size") + a6;
          }
        return "-webkit-" + a6 + "-ms-" + a6 + a6;
      case 964:
        return "-webkit-" + a6 + "-ms-flex-" + a6 + a6;
      case 1023:
        if (a6.charCodeAt(8) !== 99)
          break;
        b2 = a6.substring(a6.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a6 + "-ms-flex-pack" + b2 + a6;
      case 1005:
        return ka.test(a6) ? a6.replace(aa, ":-webkit-") + a6.replace(aa, ":-moz-") + a6 : a6;
      case 1e3:
        b2 = a6.substring(13).trim();
        c2 = b2.indexOf("-") + 1;
        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a6.replace(G2, "tb");
            break;
          case 232:
            b2 = a6.replace(G2, "tb-rl");
            break;
          case 220:
            b2 = a6.replace(G2, "lr");
            break;
          default:
            return a6;
        }
        return "-webkit-" + a6 + "-ms-" + b2 + a6;
      case 1017:
        if (a6.indexOf("sticky", 9) === -1)
          break;
      case 975:
        c2 = (a6 = d2).length - 10;
        b2 = (a6.charCodeAt(c2) === 33 ? a6.substring(0, c2) : a6).substring(d2.indexOf(":", 7) + 1).trim();
        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8))
              break;
          case 115:
            a6 = a6.replace(b2, "-webkit-" + b2) + ";" + a6;
            break;
          case 207:
          case 102:
            a6 = a6.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a6.replace(b2, "-webkit-" + b2) + ";" + a6.replace(b2, "-ms-" + b2 + "box") + ";" + a6;
        }
        return a6 + ";";
      case 938:
        if (a6.charCodeAt(5) === 45)
          switch (a6.charCodeAt(6)) {
            case 105:
              return b2 = a6.replace("-items", ""), "-webkit-" + a6 + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a6;
            case 115:
              return "-webkit-" + a6 + "-ms-flex-item-" + a6.replace(ba, "") + a6;
            default:
              return "-webkit-" + a6 + "-ms-flex-line-pack" + a6.replace("align-content", "").replace(ba, "") + a6;
          }
        break;
      case 973:
      case 989:
        if (a6.charCodeAt(3) !== 45 || a6.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (la.test(d2) === true)
          return (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) === 115 ? P2(d2.replace("stretch", "fill-available"), c2, e2, h2).replace(":fill-available", ":stretch") : a6.replace(b2, "-webkit-" + b2) + a6.replace(b2, "-moz-" + b2.replace("fill-", "")) + a6;
        break;
      case 962:
        if (a6 = "-webkit-" + a6 + (a6.charCodeAt(5) === 102 ? "-ms-" + a6 : "") + a6, e2 + h2 === 211 && a6.charCodeAt(13) === 105 && 0 < a6.indexOf("transform", 10))
          return a6.substring(0, a6.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a6;
    }
    return a6;
  }
  function L2(d2, c2) {
    var e2 = d2.indexOf(c2 === 1 ? ":" : "{"), h2 = d2.substring(0, c2 !== 3 ? e2 : 10);
    e2 = d2.substring(e2 + 1, d2.length - 1);
    return R(c2 !== 2 ? h2 : h2.replace(na, "$1"), e2, c2);
  }
  function ea(d2, c2) {
    var e2 = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e2 !== c2 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }
  function H2(d2, c2, e2, h2, a6, m2, b2, v2, n2, q2) {
    for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S2[g2].call(B2, d2, x2, e2, h2, a6, m2, b2, v2, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x2 = w3;
      }
    }
    if (x2 !== c2)
      return x2;
  }
  function T2(d2) {
    switch (d2) {
      case void 0:
      case null:
        A2 = S2.length = 0;
        break;
      default:
        if (typeof d2 === "function")
          S2[A2++] = d2;
        else if (typeof d2 === "object")
          for (var c2 = 0, e2 = d2.length; c2 < e2; ++c2) {
            T2(d2[c2]);
          }
        else
          Y2 = !!d2 | 0;
    }
    return T2;
  }
  function U2(d2) {
    d2 = d2.prefix;
    d2 !== void 0 && (R = null, d2 ? typeof d2 !== "function" ? w2 = 1 : (w2 = 2, R = d2) : w2 = 0);
    return U2;
  }
  function B2(d2, c2) {
    var e2 = d2;
    33 > e2.charCodeAt(0) && (e2 = e2.trim());
    V2 = e2;
    e2 = [V2];
    if (0 < A2) {
      var h2 = H2(-1, c2, e2, e2, D2, z2, 0, 0, 0, 0);
      h2 !== void 0 && typeof h2 === "string" && (c2 = h2);
    }
    var a6 = M2(O, e2, c2, 0, 0);
    0 < A2 && (h2 = H2(-2, a6, e2, e2, D2, z2, a6.length, 0, 0, 0), h2 !== void 0 && (a6 = h2));
    V2 = "";
    E2 = 0;
    z2 = D2 = 1;
    return a6;
  }
  var ca2 = /^\0+/g, N2 = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q2 = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O = [], S2 = [], A2 = 0, R = null, Y2 = 0, V2 = "";
  B2.use = T2;
  B2.set = U2;
  W2 !== void 0 && U2(W2);
  return B2;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(fn) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var index = memoize(function(prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var reactIs = reactIs$1.exports;
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i2 = 0; i2 < keys.length; ++i2) {
      var key = keys[i2];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e2) {
        }
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
function v() {
  return (v = Object.assign || function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];
      for (var r2 in n2)
        Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
    }
    return e2;
  }).apply(this, arguments);
}
var g$1 = function(e2, t2) {
  for (var n2 = [e2[0]], r2 = 0, o = t2.length; r2 < o; r2 += 1)
    n2.push(t2[r2], e2[r2 + 1]);
  return n2;
}, S = function(t2) {
  return t2 !== null && typeof t2 == "object" && (t2.toString ? t2.toString() : Object.prototype.toString.call(t2)) === "[object Object]" && !reactIs$1.exports.typeOf(t2);
}, w = Object.freeze([]), E = Object.freeze({});
function b$1(e2) {
  return typeof e2 == "function";
}
function _$1(e2) {
  return e2.displayName || e2.name || "Component";
}
function N(e2) {
  return e2 && typeof e2.styledComponentId == "string";
}
var A = typeof process != "undefined" && ({}.REACT_APP_SC_ATTR || {}.SC_ATTR) || "data-styled", I = typeof window != "undefined" && "HTMLElement" in window, P = Boolean(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && {}.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && {}.REACT_APP_SC_DISABLE_SPEEDY !== "" ? {}.REACT_APP_SC_DISABLE_SPEEDY !== "false" && {}.REACT_APP_SC_DISABLE_SPEEDY : typeof process != "undefined" && {}.SC_DISABLE_SPEEDY !== void 0 && {}.SC_DISABLE_SPEEDY !== "" ? {}.SC_DISABLE_SPEEDY !== "false" && {}.SC_DISABLE_SPEEDY : false);
function j(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e2 + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : ""));
}
var T = function() {
  function e2(e3) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
  }
  var t2 = e2.prototype;
  return t2.indexOfGroup = function(e3) {
    for (var t3 = 0, n2 = 0; n2 < e3; n2++)
      t3 += this.groupSizes[n2];
    return t3;
  }, t2.insertRules = function(e3, t3) {
    if (e3 >= this.groupSizes.length) {
      for (var n2 = this.groupSizes, r2 = n2.length, o = r2; e3 >= o; )
        (o <<= 1) < 0 && j(16, "" + e3);
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(n2), this.length = o;
      for (var s2 = r2; s2 < o; s2++)
        this.groupSizes[s2] = 0;
    }
    for (var i2 = this.indexOfGroup(e3 + 1), a6 = 0, c2 = t3.length; a6 < c2; a6++)
      this.tag.insertRule(i2, t3[a6]) && (this.groupSizes[e3]++, i2++);
  }, t2.clearGroup = function(e3) {
    if (e3 < this.length) {
      var t3 = this.groupSizes[e3], n2 = this.indexOfGroup(e3), r2 = n2 + t3;
      this.groupSizes[e3] = 0;
      for (var o = n2; o < r2; o++)
        this.tag.deleteRule(n2);
    }
  }, t2.getGroup = function(e3) {
    var t3 = "";
    if (e3 >= this.length || this.groupSizes[e3] === 0)
      return t3;
    for (var n2 = this.groupSizes[e3], r2 = this.indexOfGroup(e3), o = r2 + n2, s2 = r2; s2 < o; s2++)
      t3 += this.tag.getRule(s2) + "/*!sc*/\n";
    return t3;
  }, e2;
}(), x = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Map(), V = 1, B = function(e2) {
  if (x.has(e2))
    return x.get(e2);
  for (; k.has(V); )
    V++;
  var t2 = V++;
  return x.set(e2, t2), k.set(t2, e2), t2;
}, z = function(e2) {
  return k.get(e2);
}, M = function(e2, t2) {
  t2 >= V && (V = t2 + 1), x.set(e2, t2), k.set(t2, e2);
}, G = "style[" + A + '][data-styled-version="5.3.3"]', L = new RegExp("^" + A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), F = function(e2, t2, n2) {
  for (var r2, o = n2.split(","), s2 = 0, i2 = o.length; s2 < i2; s2++)
    (r2 = o[s2]) && e2.registerName(t2, r2);
}, Y = function(e2, t2) {
  for (var n2 = (t2.textContent || "").split("/*!sc*/\n"), r2 = [], o = 0, s2 = n2.length; o < s2; o++) {
    var i2 = n2[o].trim();
    if (i2) {
      var a6 = i2.match(L);
      if (a6) {
        var c2 = 0 | parseInt(a6[1], 10), u2 = a6[2];
        c2 !== 0 && (M(u2, c2), F(e2, u2, a6[3]), e2.getTag().insertRules(c2, r2)), r2.length = 0;
      } else
        r2.push(i2);
    }
  }
}, q$1 = function() {
  return typeof window != "undefined" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
}, H = function(e2) {
  var t2 = document.head, n2 = e2 || t2, r2 = document.createElement("style"), o = function(e3) {
    for (var t3 = e3.childNodes, n3 = t3.length; n3 >= 0; n3--) {
      var r3 = t3[n3];
      if (r3 && r3.nodeType === 1 && r3.hasAttribute(A))
        return r3;
    }
  }(n2), s2 = o !== void 0 ? o.nextSibling : null;
  r2.setAttribute(A, "active"), r2.setAttribute("data-styled-version", "5.3.3");
  var i2 = q$1();
  return i2 && r2.setAttribute("nonce", i2), n2.insertBefore(r2, s2), r2;
}, $ = function() {
  function e2(e3) {
    var t3 = this.element = H(e3);
    t3.appendChild(document.createTextNode("")), this.sheet = function(e4) {
      if (e4.sheet)
        return e4.sheet;
      for (var t4 = document.styleSheets, n2 = 0, r2 = t4.length; n2 < r2; n2++) {
        var o = t4[n2];
        if (o.ownerNode === e4)
          return o;
      }
      j(17);
    }(t3), this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    try {
      return this.sheet.insertRule(t3, e3), this.length++, true;
    } catch (e4) {
      return false;
    }
  }, t2.deleteRule = function(e3) {
    this.sheet.deleteRule(e3), this.length--;
  }, t2.getRule = function(e3) {
    var t3 = this.sheet.cssRules[e3];
    return t3 !== void 0 && typeof t3.cssText == "string" ? t3.cssText : "";
  }, e2;
}(), W = function() {
  function e2(e3) {
    var t3 = this.element = H(e3);
    this.nodes = t3.childNodes, this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    if (e3 <= this.length && e3 >= 0) {
      var n2 = document.createTextNode(t3), r2 = this.nodes[e3];
      return this.element.insertBefore(n2, r2 || null), this.length++, true;
    }
    return false;
  }, t2.deleteRule = function(e3) {
    this.element.removeChild(this.nodes[e3]), this.length--;
  }, t2.getRule = function(e3) {
    return e3 < this.length ? this.nodes[e3].textContent : "";
  }, e2;
}(), U = function() {
  function e2(e3) {
    this.rules = [], this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    return e3 <= this.length && (this.rules.splice(e3, 0, t3), this.length++, true);
  }, t2.deleteRule = function(e3) {
    this.rules.splice(e3, 1), this.length--;
  }, t2.getRule = function(e3) {
    return e3 < this.length ? this.rules[e3] : "";
  }, e2;
}(), J = I, X = { isServer: !I, useCSSOMInjection: !P }, Z = function() {
  function e2(e3, t3, n2) {
    e3 === void 0 && (e3 = E), t3 === void 0 && (t3 = {}), this.options = v({}, X, {}, e3), this.gs = t3, this.names = new Map(n2), this.server = !!e3.isServer, !this.server && I && J && (J = false, function(e4) {
      for (var t4 = document.querySelectorAll(G), n3 = 0, r2 = t4.length; n3 < r2; n3++) {
        var o = t4[n3];
        o && o.getAttribute(A) !== "active" && (Y(e4, o), o.parentNode && o.parentNode.removeChild(o));
      }
    }(this));
  }
  e2.registerId = function(e3) {
    return B(e3);
  };
  var t2 = e2.prototype;
  return t2.reconstructWithOptions = function(t3, n2) {
    return n2 === void 0 && (n2 = true), new e2(v({}, this.options, {}, t3), this.gs, n2 && this.names || void 0);
  }, t2.allocateGSInstance = function(e3) {
    return this.gs[e3] = (this.gs[e3] || 0) + 1;
  }, t2.getTag = function() {
    return this.tag || (this.tag = (n2 = (t3 = this.options).isServer, r2 = t3.useCSSOMInjection, o = t3.target, e3 = n2 ? new U(o) : r2 ? new $(o) : new W(o), new T(e3)));
    var e3, t3, n2, r2, o;
  }, t2.hasNameForId = function(e3, t3) {
    return this.names.has(e3) && this.names.get(e3).has(t3);
  }, t2.registerName = function(e3, t3) {
    if (B(e3), this.names.has(e3))
      this.names.get(e3).add(t3);
    else {
      var n2 = /* @__PURE__ */ new Set();
      n2.add(t3), this.names.set(e3, n2);
    }
  }, t2.insertRules = function(e3, t3, n2) {
    this.registerName(e3, t3), this.getTag().insertRules(B(e3), n2);
  }, t2.clearNames = function(e3) {
    this.names.has(e3) && this.names.get(e3).clear();
  }, t2.clearRules = function(e3) {
    this.getTag().clearGroup(B(e3)), this.clearNames(e3);
  }, t2.clearTag = function() {
    this.tag = void 0;
  }, t2.toString = function() {
    return function(e3) {
      for (var t3 = e3.getTag(), n2 = t3.length, r2 = "", o = 0; o < n2; o++) {
        var s2 = z(o);
        if (s2 !== void 0) {
          var i2 = e3.names.get(s2), a6 = t3.getGroup(o);
          if (i2 && a6 && i2.size) {
            var c2 = A + ".g" + o + '[id="' + s2 + '"]', u2 = "";
            i2 !== void 0 && i2.forEach(function(e4) {
              e4.length > 0 && (u2 += e4 + ",");
            }), r2 += "" + a6 + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
          }
        }
      }
      return r2;
    }(this);
  }, e2;
}(), K = /(a)(d)/gi, Q = function(e2) {
  return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
};
function ee(e2) {
  var t2, n2 = "";
  for (t2 = Math.abs(e2); t2 > 52; t2 = t2 / 52 | 0)
    n2 = Q(t2 % 52) + n2;
  return (Q(t2 % 52) + n2).replace(K, "$1-$2");
}
var te = function(e2, t2) {
  for (var n2 = t2.length; n2; )
    e2 = 33 * e2 ^ t2.charCodeAt(--n2);
  return e2;
}, ne = function(e2) {
  return te(5381, e2);
};
function re(e2) {
  for (var t2 = 0; t2 < e2.length; t2 += 1) {
    var n2 = e2[t2];
    if (b$1(n2) && !N(n2))
      return false;
  }
  return true;
}
var oe = ne("5.3.3"), se = function() {
  function e2(e3, t2, n2) {
    this.rules = e3, this.staticRulesId = "", this.isStatic = (n2 === void 0 || n2.isStatic) && re(e3), this.componentId = t2, this.baseHash = te(oe, t2), this.baseStyle = n2, Z.registerId(t2);
  }
  return e2.prototype.generateAndInjectStyles = function(e3, t2, n2) {
    var r2 = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e3, t2, n2)), this.isStatic && !n2.hash)
      if (this.staticRulesId && t2.hasNameForId(r2, this.staticRulesId))
        o.push(this.staticRulesId);
      else {
        var s2 = Ne(this.rules, e3, t2, n2).join(""), i2 = ee(te(this.baseHash, s2) >>> 0);
        if (!t2.hasNameForId(r2, i2)) {
          var a6 = n2(s2, "." + i2, void 0, r2);
          t2.insertRules(r2, i2, a6);
        }
        o.push(i2), this.staticRulesId = i2;
      }
    else {
      for (var c2 = this.rules.length, u2 = te(this.baseHash, n2.hash), l2 = "", d2 = 0; d2 < c2; d2++) {
        var h2 = this.rules[d2];
        if (typeof h2 == "string")
          l2 += h2;
        else if (h2) {
          var p2 = Ne(h2, e3, t2, n2), f2 = Array.isArray(p2) ? p2.join("") : p2;
          u2 = te(u2, f2 + d2), l2 += f2;
        }
      }
      if (l2) {
        var m2 = ee(u2 >>> 0);
        if (!t2.hasNameForId(r2, m2)) {
          var y2 = n2(l2, "." + m2, void 0, r2);
          t2.insertRules(r2, m2, y2);
        }
        o.push(m2);
      }
    }
    return o.join(" ");
  }, e2;
}(), ie = /^\s*\/\/.*$/gm, ae = [":", "[", ".", "#"];
function ce(e2) {
  var t2, n2, r2, o, s2 = e2 === void 0 ? E : e2, i2 = s2.options, a6 = i2 === void 0 ? E : i2, c2 = s2.plugins, u2 = c2 === void 0 ? w : c2, l2 = new stylis_min(a6), d2 = [], h2 = function(e3) {
    function t3(t4) {
      if (t4)
        try {
          e3(t4 + "}");
        } catch (e4) {
        }
    }
    return function(n3, r3, o2, s3, i3, a7, c3, u3, l3, d3) {
      switch (n3) {
        case 1:
          if (l3 === 0 && r3.charCodeAt(0) === 64)
            return e3(r3 + ";"), "";
          break;
        case 2:
          if (u3 === 0)
            return r3 + "/*|*/";
          break;
        case 3:
          switch (u3) {
            case 102:
            case 112:
              return e3(o2[0] + r3), "";
            default:
              return r3 + (d3 === 0 ? "/*|*/" : "");
          }
        case -2:
          r3.split("/*|*/}").forEach(t3);
      }
    };
  }(function(e3) {
    d2.push(e3);
  }), f2 = function(e3, r3, s3) {
    return r3 === 0 && ae.indexOf(s3[n2.length]) !== -1 || s3.match(o) ? e3 : "." + t2;
  };
  function m2(e3, s3, i3, a7) {
    a7 === void 0 && (a7 = "&");
    var c3 = e3.replace(ie, ""), u3 = s3 && i3 ? i3 + " " + s3 + " { " + c3 + " }" : c3;
    return t2 = a7, n2 = s3, r2 = new RegExp("\\" + n2 + "\\b", "g"), o = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i3 || !s3 ? "" : s3, u3);
  }
  return l2.use([].concat(u2, [function(e3, t3, o2) {
    e3 === 2 && o2.length && o2[0].lastIndexOf(n2) > 0 && (o2[0] = o2[0].replace(r2, f2));
  }, h2, function(e3) {
    if (e3 === -2) {
      var t3 = d2;
      return d2 = [], t3;
    }
  }])), m2.hash = u2.length ? u2.reduce(function(e3, t3) {
    return t3.name || j(15), te(e3, t3.name);
  }, 5381).toString() : "", m2;
}
var ue = React__default.createContext();
ue.Consumer;
var de = React__default.createContext(), he = (de.Consumer, new Z()), pe = ce();
function fe() {
  return useContext(ue) || he;
}
function me() {
  return useContext(de) || pe;
}
var ve = function() {
  function e2(e3, t2) {
    var n2 = this;
    this.inject = function(e4, t3) {
      t3 === void 0 && (t3 = pe);
      var r2 = n2.name + t3.hash;
      e4.hasNameForId(n2.id, r2) || e4.insertRules(n2.id, r2, t3(n2.rules, r2, "@keyframes"));
    }, this.toString = function() {
      return j(12, String(n2.name));
    }, this.name = e3, this.id = "sc-keyframes-" + e3, this.rules = t2;
  }
  return e2.prototype.getName = function(e3) {
    return e3 === void 0 && (e3 = pe), this.name + e3.hash;
  }, e2;
}(), ge = /([A-Z])/, Se = /([A-Z])/g, we = /^ms-/, Ee = function(e2) {
  return "-" + e2.toLowerCase();
};
function be(e2) {
  return ge.test(e2) ? e2.replace(Se, Ee).replace(we, "-ms-") : e2;
}
var _e = function(e2) {
  return e2 == null || e2 === false || e2 === "";
};
function Ne(e2, n2, r2, o) {
  if (Array.isArray(e2)) {
    for (var s2, i2 = [], a6 = 0, c2 = e2.length; a6 < c2; a6 += 1)
      (s2 = Ne(e2[a6], n2, r2, o)) !== "" && (Array.isArray(s2) ? i2.push.apply(i2, s2) : i2.push(s2));
    return i2;
  }
  if (_e(e2))
    return "";
  if (N(e2))
    return "." + e2.styledComponentId;
  if (b$1(e2)) {
    if (typeof (l2 = e2) != "function" || l2.prototype && l2.prototype.isReactComponent || !n2)
      return e2;
    var u2 = e2(n2);
    return Ne(u2, n2, r2, o);
  }
  var l2;
  return e2 instanceof ve ? r2 ? (e2.inject(r2, o), e2.getName(o)) : e2 : S(e2) ? function e3(t2, n3) {
    var r3, o2, s3 = [];
    for (var i3 in t2)
      t2.hasOwnProperty(i3) && !_e(t2[i3]) && (Array.isArray(t2[i3]) && t2[i3].isCss || b$1(t2[i3]) ? s3.push(be(i3) + ":", t2[i3], ";") : S(t2[i3]) ? s3.push.apply(s3, e3(t2[i3], i3)) : s3.push(be(i3) + ": " + (r3 = i3, (o2 = t2[i3]) == null || typeof o2 == "boolean" || o2 === "" ? "" : typeof o2 != "number" || o2 === 0 || r3 in unitlessKeys ? String(o2).trim() : o2 + "px") + ";"));
    return n3 ? [n3 + " {"].concat(s3, ["}"]) : s3;
  }(e2) : e2.toString();
}
var Ae = function(e2) {
  return Array.isArray(e2) && (e2.isCss = true), e2;
};
function Ce(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  return b$1(e2) || S(e2) ? Ae(Ne(g$1(w, [e2].concat(n2)))) : n2.length === 0 && e2.length === 1 && typeof e2[0] == "string" ? e2 : Ae(Ne(g$1(e2, n2)));
}
var Re = function(e2, t2, n2) {
  return n2 === void 0 && (n2 = E), e2.theme !== n2.theme && e2.theme || t2 || n2.theme;
}, De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, je = /(^-|-$)/g;
function Te(e2) {
  return e2.replace(De, "-").replace(je, "");
}
var xe = function(e2) {
  return ee(ne(e2) >>> 0);
};
function ke(e2) {
  return typeof e2 == "string" && true;
}
var Ve = function(e2) {
  return typeof e2 == "function" || typeof e2 == "object" && e2 !== null && !Array.isArray(e2);
}, Be = function(e2) {
  return e2 !== "__proto__" && e2 !== "constructor" && e2 !== "prototype";
};
function ze(e2, t2, n2) {
  var r2 = e2[n2];
  Ve(t2) && Ve(r2) ? Me(r2, t2) : e2[n2] = t2;
}
function Me(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  for (var o = 0, s2 = n2; o < s2.length; o++) {
    var i2 = s2[o];
    if (Ve(i2))
      for (var a6 in i2)
        Be(a6) && ze(e2, i2[a6], a6);
  }
  return e2;
}
var Ge = React__default.createContext();
Ge.Consumer;
function Fe(e2) {
  var t2 = useContext(Ge), n2 = useMemo(function() {
    return function(e3, t3) {
      if (!e3)
        return j(14);
      if (b$1(e3)) {
        var n3 = e3(t3);
        return n3;
      }
      return Array.isArray(e3) || typeof e3 != "object" ? j(8) : t3 ? v({}, t3, {}, e3) : e3;
    }(e2.theme, t2);
  }, [e2.theme, t2]);
  return e2.children ? React__default.createElement(Ge.Provider, { value: n2 }, e2.children) : null;
}
var Ye = {};
function qe(e2, t2, n2) {
  var o = N(e2), i2 = !ke(e2), a6 = t2.attrs, c2 = a6 === void 0 ? w : a6, d2 = t2.componentId, h2 = d2 === void 0 ? function(e3, t3) {
    var n3 = typeof e3 != "string" ? "sc" : Te(e3);
    Ye[n3] = (Ye[n3] || 0) + 1;
    var r2 = n3 + "-" + xe("5.3.3" + n3 + Ye[n3]);
    return t3 ? t3 + "-" + r2 : r2;
  }(t2.displayName, t2.parentComponentId) : d2, p2 = t2.displayName, f2 = p2 === void 0 ? function(e3) {
    return ke(e3) ? "styled." + e3 : "Styled(" + _$1(e3) + ")";
  }(e2) : p2, g2 = t2.displayName && t2.componentId ? Te(t2.displayName) + "-" + t2.componentId : t2.componentId || h2, S2 = o && e2.attrs ? Array.prototype.concat(e2.attrs, c2).filter(Boolean) : c2, A2 = t2.shouldForwardProp;
  o && e2.shouldForwardProp && (A2 = t2.shouldForwardProp ? function(n3, r2, o2) {
    return e2.shouldForwardProp(n3, r2, o2) && t2.shouldForwardProp(n3, r2, o2);
  } : e2.shouldForwardProp);
  var C, I2 = new se(n2, g2, o ? e2.componentStyle : void 0), P2 = I2.isStatic && c2.length === 0, O = function(e3, t3) {
    return function(e4, t4, n3, r2) {
      var o2 = e4.attrs, i3 = e4.componentStyle, a7 = e4.defaultProps, c3 = e4.foldedComponentIds, d3 = e4.shouldForwardProp, h3 = e4.styledComponentId, p3 = e4.target;
      var f3 = function(e5, t5, n4) {
        e5 === void 0 && (e5 = E);
        var r3 = v({}, t5, { theme: e5 }), o3 = {};
        return n4.forEach(function(e6) {
          var t6, n5, s2, i4 = e6;
          for (t6 in b$1(i4) && (i4 = i4(r3)), i4)
            r3[t6] = o3[t6] = t6 === "className" ? (n5 = o3[t6], s2 = i4[t6], n5 && s2 ? n5 + " " + s2 : n5 || s2) : i4[t6];
        }), [r3, o3];
      }(Re(t4, useContext(Ge), a7) || E, t4, o2), y2 = f3[0], g3 = f3[1], S3 = function(e5, t5, n4, r3) {
        var o3 = fe(), s2 = me(), i4 = t5 ? e5.generateAndInjectStyles(E, o3, s2) : e5.generateAndInjectStyles(n4, o3, s2);
        return i4;
      }(i3, r2, y2), w2 = n3, _24 = g3.$as || t4.$as || g3.as || t4.as || p3, N2 = ke(_24), A3 = g3 !== t4 ? v({}, t4, {}, g3) : t4, C2 = {};
      for (var I3 in A3)
        I3[0] !== "$" && I3 !== "as" && (I3 === "forwardedAs" ? C2.as = A3[I3] : (d3 ? d3(I3, index, _24) : !N2 || index(I3)) && (C2[I3] = A3[I3]));
      return t4.style && g3.style !== t4.style && (C2.style = v({}, t4.style, {}, g3.style)), C2.className = Array.prototype.concat(c3, h3, S3 !== h3 ? S3 : null, t4.className, g3.className).filter(Boolean).join(" "), C2.ref = w2, createElement(_24, C2);
    }(C, e3, t3, P2);
  };
  return O.displayName = f2, (C = React__default.forwardRef(O)).attrs = S2, C.componentStyle = I2, C.displayName = f2, C.shouldForwardProp = A2, C.foldedComponentIds = o ? Array.prototype.concat(e2.foldedComponentIds, e2.styledComponentId) : w, C.styledComponentId = g2, C.target = o ? e2.target : e2, C.withComponent = function(e3) {
    var r2 = t2.componentId, o2 = function(e4, t3) {
      if (e4 == null)
        return {};
      var n3, r3, o3 = {}, s3 = Object.keys(e4);
      for (r3 = 0; r3 < s3.length; r3++)
        n3 = s3[r3], t3.indexOf(n3) >= 0 || (o3[n3] = e4[n3]);
      return o3;
    }(t2, ["componentId"]), s2 = r2 && r2 + "-" + (ke(e3) ? e3 : Te(_$1(e3)));
    return qe(e3, v({}, o2, { attrs: S2, componentId: s2 }), n2);
  }, Object.defineProperty(C, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t3) {
    this._foldedDefaultProps = o ? Me({}, e2.defaultProps, t3) : t3;
  } }), C.toString = function() {
    return "." + C.styledComponentId;
  }, i2 && hoistNonReactStatics_cjs(C, e2, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), C;
}
var He = function(e2) {
  return function e3(t2, r2, o) {
    if (o === void 0 && (o = E), !reactIs$1.exports.isValidElementType(r2))
      return j(1, String(r2));
    var s2 = function() {
      return t2(r2, o, Ce.apply(void 0, arguments));
    };
    return s2.withConfig = function(n2) {
      return e3(t2, r2, v({}, o, {}, n2));
    }, s2.attrs = function(n2) {
      return e3(t2, r2, v({}, o, { attrs: Array.prototype.concat(o.attrs, n2).filter(Boolean) }));
    }, s2;
  }(qe, e2);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e2) {
  He[e2] = He(e2);
});
function Ue(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  var o = Ce.apply(void 0, [e2].concat(n2)).join(""), s2 = xe(o);
  return new ve(s2, o);
}
var styled = He;
let theme = {
  main: "#3db0f7",
  buttonBorderRadius: "31px",
  buttonColor: "#fff",
  modal: {},
  mainButton: {},
  secondaryButton: {}
};
const buttonStyles = Ce`
  text-transform: uppercase;
  padding: 18px 25px;
  background-color: ${(props) => props.theme.main};
  min-width: 215px;
  border-radius: ${(props) => props.theme.buttonBorderRadius};
  color: ${(props) => props.theme.buttonColor};
  font-size: 18px;
  font-weight: bold;
  border: none;
  box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14);
  ${(props) => props.theme.mainButton}

  &.hover {
    background-color: ${(props) => props.theme.main};
  }

  &.button-hidden {
    display: none;
  }

  &:disabled {
    opacity: 0.5;
    box-shadow: none;
    background-color: #757575;
  }
`;
const Button$3 = styled.button`
  ${buttonStyles}
`;
Button$3.defaultProps = {
  theme
};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i2 = 0; i2 < 10; i2++) {
      test2["_" + String.fromCharCode(i2)] = i2;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source2) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s2 = 1; s2 < arguments.length; s2++) {
    from = Object(arguments[s2]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i2 = 0; i2 < symbols.length; i2++) {
        if (propIsEnumerable.call(from, symbols[i2])) {
          to[symbols[i2]] = from[symbols[i2]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c2, a6, k3) {
  var b2, d2 = {}, e2 = null, l2 = null;
  k3 !== void 0 && (e2 = "" + k3);
  a6.key !== void 0 && (e2 = "" + a6.key);
  a6.ref !== void 0 && (l2 = a6.ref);
  for (b2 in a6)
    n.call(a6, b2) && !p.hasOwnProperty(b2) && (d2[b2] = a6[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a6 = c2.defaultProps, a6)
      d2[b2] === void 0 && (d2[b2] = a6[b2]);
  return { $$typeof: g, type: c2, key: e2, ref: l2, props: d2, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const Steps = ({
  children,
  currentStep
}) => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: Children.toArray(children).filter((child) => child !== null).map((child, index2) => currentStep === index2 && cloneElement(child))
  });
};
const secondaryButtonStyles = Ce`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.11;
  color: rgba(32, 38, 61, 0.54);
  background: transparent;
  border: none;
`;
const SecondaryButton = styled.button`
  ${secondaryButtonStyles}
`;
const CustomCheckbox = styled.input.attrs({
  type: "checkbox"
})`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;
const CustomCheckboxSpan = styled.span`
  display: block;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;
const CustomCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  user-select: none;

  ${CustomCheckbox}:checked ~ ${CustomCheckboxSpan} {
    background-color: #0cd5a2;
  }

  ${CustomCheckbox}:checked ~ ${CustomCheckboxSpan}:after {
    display: block;
  }

  ${CustomCheckboxSpan}:after {
    position: absolute;
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;
const Checkbox = ({
  id: id2,
  text,
  handleChange
}) => {
  return /* @__PURE__ */ jsxs(CustomCheckboxLabel, {
    htmlFor: id2,
    className: "accept-check IncodeCheckbox",
    onChange: handleChange,
    children: [/* @__PURE__ */ jsx(CustomCheckbox, {
      id: id2
    }), /* @__PURE__ */ jsx(CustomCheckboxSpan, {}), text]
  });
};
const Input$3 = styled.input`
  justify-content: space-between;
  width: 100%;
  max-width: 45px;
  height: 45px;
  margin: 5px;
  text-align: center;
  font-size: 34px;
  border-radius: 6px;
  background-color: rgba(33, 39, 59, 0.1);
  border: none;
  padding: 0;
  line-height: 1;

  &:not(:placeholder-shown) {
    border: solid 3px #21273b;
  }
`;
const InputBox = (props) => {
  return /* @__PURE__ */ jsx(Input$3, __spreadValues({
    maxLength: 1,
    ref: props.inputRef,
    placeholder: " ",
    autoComplete: "off",
    className: "IncodeOTPInput"
  }, props));
};
const Wrapper$1 = styled.div`
  margin: auto;
  margin-top: 50px;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IndividualCharacterInputBoxes = (_c) => {
  var _d = _c, {
    isNumeric = true
  } = _d, props = __objRest(_d, [
    "isNumeric"
  ]);
  const [characterArray, setCharacterArray] = useState(Array(props.amount).fill(""));
  const inputElements = useRef({});
  useEffect(() => {
    setCharacterArray((characterArray2) => {
      characterArray2.forEach((_24, i2) => characterArray2[i2] = props.value[i2] || "");
      return [...characterArray2];
    });
  }, [props.value]);
  useEffect(() => {
    if (props.autoFocus) {
      inputElements.current["input0"].select();
    }
  }, [props.autoFocus]);
  useEffect(() => {
    props.onChange(characterArray.join(""));
  }, [characterArray, props]);
  const renderItems = () => {
    return characterArray.map((_24, i2) => {
      if (props.password) {
        return /* @__PURE__ */ jsx(InputBox, {
          type: "password",
          onKeyDown: handleKeyDown,
          onFocus: handleFocus2,
          onChange: handleChange,
          name: "input" + i2,
          inputRef: (el) => {
            if (!el)
              return;
            inputElements.current[el.name] = el;
          },
          value: characterArray[i2]
        }, i2);
      }
      if (!isNumeric) {
        return /* @__PURE__ */ jsx(InputBox, {
          type: "text",
          onKeyDown: handleKeyDown,
          onFocus: handleFocus2,
          onChange: handleChange,
          name: "input" + i2,
          inputRef: (el) => {
            if (!el)
              return;
            inputElements.current[el.name] = el;
          },
          value: characterArray[i2]
        }, i2);
      }
      return /* @__PURE__ */ jsx(InputBox, {
        type: "number",
        max: 1,
        inputMode: "numeric",
        pattern: "[0-9]{1}",
        onKeyDown: handleKeyDown,
        onFocus: handleFocus2,
        onChange: handleChange,
        name: "input" + i2,
        inputRef: (el) => {
          if (!el)
            return;
          inputElements.current[el.name] = el;
        },
        value: characterArray[i2]
      }, i2);
    });
  };
  const handleChange = ({
    target
  }) => {
    focusNextChar(target);
    setModuleOutput();
  };
  const handleKeyDown = (event) => {
    const key = event.key;
    const target = event.target;
    if (key === "Backspace") {
      if (target.value === "" && target.previousElementSibling !== null) {
        target.previousElementSibling.value = "";
        focusPrevChar(target);
      } else {
        target.value = "";
      }
      setModuleOutput();
    } else if (key === "ArrowLeft") {
      focusPrevChar(target);
    } else if (key === "ArrowRight") {
      focusNextChar(target);
    }
  };
  const handleFocus2 = ({
    target
  }) => {
    const el = target;
    setTimeout(function() {
      el.select();
    }, 0);
  };
  const focusPrevChar = (target) => {
    if (target.previousElementSibling !== null) {
      target.previousElementSibling.focus();
    }
  };
  const focusNextChar = (target) => {
    if (target.nextElementSibling !== null) {
      target.nextElementSibling.focus();
    }
  };
  const setModuleOutput = () => {
    setCharacterArray((characterArray2) => {
      return characterArray2.map((_24, number2) => inputElements.current["input" + number2].value[0]);
    });
  };
  return /* @__PURE__ */ jsx(Wrapper$1, {
    children: /* @__PURE__ */ jsx("div", {
      style: {
        display: "flex"
      },
      children: renderItems()
    })
  });
};
const ProgressStateContext = createContext(null);
ProgressStateContext.displayName = "ProgressStateContext";
const ProgressDispatcherContext = createContext(null);
ProgressDispatcherContext.displayName = "ProgressDispatcherContext";
var rotateImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MCIgaGVpZ2h0PSI5MCIgdmlld0JveD0iMCAwIDkwIDkwIj4KICAgIDxnIGZpbGw9IiMyMDI2M0QiPgogICAgICAgIDxwYXRoIGQ9Ik04NC4xMiAyNy41NGwtMi41OC0yLjU4TDY1LjAzNiA4LjQ1NmwtMi41OC0yLjU4Yy0zLjEyNy0zLjEyNy04LjU4LTIuNzY0LTEyLjE1Ny44MUw2LjY5IDUwLjMwNmMtMy41NzQgMy41NzQtMy45MzggOS4wMjctLjgxIDEyLjE1OGwyMS42NiAyMS42NmMzLjEyOCAzLjEyNyA4LjU4IDIuNzY0IDEyLjE1Ny0uODFsNDMuNjE3LTQzLjYxNmMzLjU3NC0zLjU3OCAzLjkzNy05LjAzLjgwNi0xMi4xNTh6bS01LjUyNCA4LjYxN2wtNDIuNDM5IDQyLjQ0Yy0xLjMgMS4zLTMuMjggMS40MzItNC40Mi4yOTZsLTIwLjYzLTIwLjYzYy0xLjE0LTEuMTQtMS4wMDgtMy4xMi4yOTctNC40Mmw0Mi40MzgtNDIuNDRjMS4zMDItMS4zIDMuMjgyLTEuNDMyIDQuNDIyLS4yOTZsMS4wMzEgMS4wMzJjMS4xNCAxLjE0IDEuMDA5IDMuMTItLjI5NiA0LjQyMS0xLjMwMiAxLjMwMS0xLjQzMyAzLjI4MS0uMjk3IDQuNDIxTDY5LjAyIDMxLjI5N2MxLjE0IDEuMTQgMy4xMiAxLjAxIDQuNDIxLS4yOTYgMS4zMDEtMS4zMDEgMy4yODEtMS40MzIgNC40MjEtLjI5NmwxLjAzMSAxLjAzMWMxLjEzNyAxLjE0IDEuMDA1IDMuMTItLjI5NiA0LjQyMXpNNTEuODg1IDkwYTMuMTM1IDMuMTM1IDAgMDEtMi4yMi01LjM1MWw4LjkyNS04LjkyNWEzLjEzOCAzLjEzOCAwIDAxNC42NDYuMjMzbDMuMzA4IDQuMDQ2YzEwLjExNC01LjM3NCAxNy4wODEtMTUuOTk0IDE3LjE3OC0yOC4xNGEzLjEzNiAzLjEzNiAwIDAxMy4xMzYtMy4xMTNoLjAyNmEzLjE0IDMuMTQgMCAwMTMuMTEyIDMuMTYxQzg5LjgzNSA3Mi43NDYgNzIuNzQ2IDg5LjgzNSA1MS45MTEgOTBoLS4wMjZ6TTM4LjExNSAwYTMuMTM1IDMuMTM1IDAgMDEyLjIyIDUuMzUxbC04LjkyNSA4LjkyNWEzLjEyNSAzLjEyNSAwIDAxLTIuMzc4LjkxNSAzLjEzOCAzLjEzOCAwIDAxLTIuMjcyLTEuMTQ3bC0zLjMwOC00LjA0NkMxMy4zNCAxNS4zNyA2LjM3MyAyNS45OSA2LjI3NCAzOC4xMzhhMy4xNCAzLjE0IDAgMDEtMy4xMzkgMy4xMTJoLS4wMjZhMy4xMzkgMy4xMzkgMCAwMS0zLjExLTMuMTYxQy4xNjYgMTcuMjU0IDE3LjI1NS4xNjUgMzguMDkgMGguMDI2eiIvPgogICAgPC9nPgo8L3N2Zz4=";
const LandscapeNotSupportedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  text-align: center;
  z-index: 99999999999999999;
  box-sizing: border-box;
  padding: 50px;
  font-weight: bolder;
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);

  @media only screen and (max-height: 480px) {
    width: 100vw;
    height: 100vh;
  }
`;
const Paragraph$3 = styled.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-size: 22px;
`;
const RotateIcon = styled.img`
  height: 90px;
  margin-bottom: 25px;
`;
function LandscapeNotSupported() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(LandscapeNotSupportedContainer, {
    children: [/* @__PURE__ */ jsx(RotateIcon, {
      src: rotateImage
    }), /* @__PURE__ */ jsx(Paragraph$3, {
      children: t2("common.landscape")
    }), /* @__PURE__ */ jsx(Paragraph$3, {
      children: mobile.isIpad() ? t2("common.rotateIpad") : t2("common.rotate")
    })]
  });
}
const StyledInput = styled.input`
  background: #edf2f6;
  border-radius: 6px;
  padding: 25px 0;
  text-align: center;
  width: 320px;
`;
const Input$2 = (_e2) => {
  var props = __objRest(_e2, []);
  return /* @__PURE__ */ jsx(StyledInput, __spreadValues({}, props));
};
var spinner$3 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjg2IiBoZWlnaHQ9IjI4NiIgdmlld0JveD0iMCAwIDI4NiAyODYiPgogIDxkZWZzPgogICAgPGNpcmNsZSBpZD0iYSIgY3g9IjE1MCIgY3k9IjE1MCIgcj0iMTMxIiAvPgogICAgPG1hc2sgaWQ9ImIiIHdpZHRoPSIyODYiIGhlaWdodD0iMjg2IiB4PSItMTIiIHk9Ii0xMiI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik03IDdoMjg2djI4Nkg3eiIgLz4KICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIgLz4KICAgIDwvbWFzaz4KICA8L2RlZnM+CiAgPHVzZSBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzFDMUYyOCIgc3Ryb2tlLWRhc2hhcnJheT0iMyw1IiBzdHJva2Utd2lkdGg9IjI0IiBtYXNrPSJ1cmwoI2IpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtNykiIHhsaW5rOmhyZWY9IiNhIiAvPgo8L3N2Zz4=";
const spinH2 = {
  margin: "0 0 20px 0"
};
function HangOn() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("h2", {
      style: spinH2,
      children: t2("loadingCircle.hangOn")
    }), /* @__PURE__ */ jsx("p", {
      children: t2("loadingCircle.validating")
    })]
  });
}
const SpinnerContainer$1 = styled.div`
  height: 100%;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0px;
  right: 0px;
  z-index: 100;
  bottom: 0px;
  background-color: #fff;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  .spinner-inner {
    width: 250px;
    height: 250px;
    position: absolute;
    border-radius: 50%;
    background-color: rgba(#000, 0.1);
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;

    img {
      position: absolute;
      animation: spinner 0.6s linear infinite;
    }
  }

  h2 {
    font-size: 36px;
  }

  p {
    font-size: 20px;
    margin: 0 10px;
  }
`;
function Spinner$2({
  children = /* @__PURE__ */ jsx(HangOn, {})
}) {
  return /* @__PURE__ */ jsx("section", {
    className: "wrapper user-data-wrapper yourInfo",
    children: /* @__PURE__ */ jsx(SpinnerContainer$1, {
      children: /* @__PURE__ */ jsxs("div", {
        className: "spinner-inner",
        children: [/* @__PURE__ */ jsx("img", {
          alt: "loading-circle",
          src: spinner$3
        }), children]
      })
    })
  });
}
var classnames = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(module2) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames2.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }
      return classes.join(" ");
    }
    if (module2.exports) {
      classNames2.default = classNames2;
      module2.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames);
var classNames = classnames.exports;
var lib$1 = { exports: {} };
var Modal$2 = {};
var propTypes$3 = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location2, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$3.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes$3.exports;
var ModalPortal = { exports: {} };
var focusManager = {};
var tabbable = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = findTabbableDescendants;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var tabbableNode = /input|select|textarea|button|object|iframe/;
  function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    if (zeroSize && !element.innerHTML)
      return true;
    try {
      var style = window.getComputedStyle(element);
      return zeroSize ? style.getPropertyValue("overflow") !== "visible" || element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
      console.warn("Failed to inspect element style");
      return false;
    }
  }
  function visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while (parentElement) {
      if (parentElement === document.body)
        break;
      if (rootNode && parentElement === rootNode)
        parentElement = rootNode.host.parentNode;
      if (hidesContents(parentElement))
        return false;
      parentElement = parentElement.parentNode;
    }
    return true;
  }
  function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
  }
  function tabbable2(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null)
      tabIndex = void 0;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
  }
  function findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
      return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter(tabbable2);
  }
  module2.exports = exports2["default"];
})(tabbable, tabbable.exports);
Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$4;
focusManager.log = log$4;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;
var _tabbable = tabbable.exports;
var _tabbable2 = _interopRequireDefault$e(_tabbable);
function _interopRequireDefault$e(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
function resetState$4() {
  focusLaterElements = [];
}
function log$4() {
}
function handleBlur() {
  needToFocus = true;
}
function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    setTimeout(function() {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}
function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll });
    }
    return;
  } catch (e2) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(element) {
  modalElement = element;
  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}
function teardownScopedFocus() {
  modalElement = null;
  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
var scopeTab = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = scopeTab2;
  var _tabbable3 = tabbable.exports;
  var _tabbable22 = _interopRequireDefault2(_tabbable3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
  }
  function scopeTab2(node, event) {
    var tabbable2 = (0, _tabbable22.default)(node);
    if (!tabbable2.length) {
      event.preventDefault();
      return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable2[0];
    var tail = tabbable2[tabbable2.length - 1];
    var activeElement = getActiveElement();
    if (node === activeElement) {
      if (!shiftKey)
        return;
      target = tail;
    }
    if (tail === activeElement && !shiftKey) {
      target = head;
    }
    if (head === activeElement && shiftKey) {
      target = tail;
    }
    if (target) {
      event.preventDefault();
      target.focus();
      return;
    }
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (!isSafariDesktop)
      return;
    var x2 = tabbable2.indexOf(activeElement);
    if (x2 > -1) {
      x2 += shiftKey ? -1 : 1;
    }
    target = tabbable2[x2];
    if (typeof target === "undefined") {
      event.preventDefault();
      target = shiftKey ? tail : head;
      target.focus();
      return;
    }
    event.preventDefault();
    target.focus();
  }
  module2.exports = exports2["default"];
})(scopeTab, scopeTab.exports);
var ariaAppHider$1 = {};
var warning$3 = function() {
};
var warning_1 = warning$3;
var safeHTMLElement = {};
var exenv = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(module2) {
  (function() {
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
      canUseDOM,
      canUseWorkers: typeof Worker !== "undefined",
      canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
      canUseViewport: canUseDOM && !!window.screen
    };
    if (module2.exports) {
      module2.exports = ExecutionEnvironment;
    } else {
      window.ExecutionEnvironment = ExecutionEnvironment;
    }
  })();
})(exenv);
Object.defineProperty(safeHTMLElement, "__esModule", {
  value: true
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = void 0;
var _exenv = exenv.exports;
var _exenv2 = _interopRequireDefault$d(_exenv);
function _interopRequireDefault$d(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var EE = _exenv2.default;
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
safeHTMLElement.canUseDOM = EE.canUseDOM;
safeHTMLElement.default = SafeHTMLElement;
Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: true
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$3;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = warning_1;
var _warning2 = _interopRequireDefault$c(_warning);
var _safeHTMLElement$1 = safeHTMLElement;
function _interopRequireDefault$c(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var globalElement = null;
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function(element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function(element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}
function log$3() {
}
function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}
function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}
function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
    return [];
  }
}
function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = void 0;
  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;
      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = void 0;
  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;
      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}
function documentNotReadyOrSSRTesting() {
  globalElement = null;
}
var classList = {};
Object.defineProperty(classList, "__esModule", {
  value: true
});
classList.resetState = resetState$2;
classList.log = log$2;
var htmlClassList = {};
var docBodyClassList = {};
function removeClass$2(at, cls) {
  at.classList.remove(cls);
}
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass$2(htmlElement, htmlClassList[cls]);
  }
  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass$2(body, docBodyClassList[_cls]);
  }
  htmlClassList = {};
  docBodyClassList = {};
}
function log$2() {
}
var incrementReference = function incrementReference2(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};
var decrementReference = function decrementReference2(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};
var trackClass = function trackClass2(classListRef, poll, classes) {
  classes.forEach(function(className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};
var untrackClass = function untrackClass2(classListRef, poll, classes) {
  classes.forEach(function(className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};
classList.add = function add3(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
classList.remove = function remove2(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
var portalOpenInstances$1 = {};
Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: true
});
portalOpenInstances$1.log = log$1;
portalOpenInstances$1.resetState = resetState$1;
function _classCallCheck$e(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var PortalOpenInstances = function PortalOpenInstances2() {
  var _this = this;
  _classCallCheck$e(this, PortalOpenInstances2);
  this.register = function(openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };
  this.deregister = function(openInstance) {
    var index2 = _this.openInstances.indexOf(openInstance);
    if (index2 === -1) {
      return;
    }
    _this.openInstances.splice(index2, 1);
    _this.emit("deregister");
  };
  this.subscribe = function(callback) {
    _this.subscribers.push(callback);
  };
  this.emit = function(eventType) {
    _this.subscribers.forEach(function(subscriber) {
      return subscriber(eventType, _this.openInstances.slice());
    });
  };
  this.openInstances = [];
  this.subscribers = [];
};
var portalOpenInstances = new PortalOpenInstances();
function log$1() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function(p2) {
    return console.log(p2);
  });
  console.log("end portalOpenInstances ----------");
}
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
portalOpenInstances$1.default = portalOpenInstances;
var bodyTrap$1 = {};
Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;
var _portalOpenInstances = portalOpenInstances$1;
var _portalOpenInstances2 = _interopRequireDefault$b(_portalOpenInstances);
function _interopRequireDefault$b(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var before$2 = void 0, after = void 0, instances = [];
function resetState() {
  var _arr = [before$2, after];
  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item)
      continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before$2 = after = null;
  instances = [];
}
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before$2, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check2 = item || {};
    console.log(check2.nodeName, check2.className, check2.id);
  }
  console.log("edn bodyTrap ----------");
}
function focusContent() {
  if (instances.length === 0) {
    return;
  }
  instances[instances.length - 1].focusContent();
}
function bodyTrap(eventType, openInstances) {
  if (!before$2 && !after) {
    before$2 = document.createElement("div");
    before$2.setAttribute("data-react-modal-body-trap", "");
    before$2.style.position = "absolute";
    before$2.style.opacity = "0";
    before$2.setAttribute("tabindex", "0");
    before$2.addEventListener("focus", focusContent);
    after = before$2.cloneNode();
    after.addEventListener("focus", focusContent);
  }
  instances = openInstances;
  if (instances.length > 0) {
    if (document.body.firstChild !== before$2) {
      document.body.insertBefore(before$2, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    if (before$2.parentElement) {
      before$2.parentElement.removeChild(before$2);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}
_portalOpenInstances2.default.subscribe(bodyTrap);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass2 = function() {
    function defineProperties(target, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react3 = React__default;
  var _propTypes3 = propTypes$3.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var _focusManager = focusManager;
  var focusManager$1 = _interopRequireWildcard2(_focusManager);
  var _scopeTab = scopeTab.exports;
  var _scopeTab2 = _interopRequireDefault2(_scopeTab);
  var _ariaAppHider2 = ariaAppHider$1;
  var ariaAppHider2 = _interopRequireWildcard2(_ariaAppHider2);
  var _classList = classList;
  var classList$1 = _interopRequireWildcard2(_classList);
  var _safeHTMLElement3 = safeHTMLElement;
  var _safeHTMLElement22 = _interopRequireDefault2(_safeHTMLElement3);
  var _portalOpenInstances3 = portalOpenInstances$1;
  var _portalOpenInstances22 = _interopRequireDefault2(_portalOpenInstances3);
  function _interopRequireWildcard2(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key))
            newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  };
  var TAB_KEY = 9;
  var ESC_KEY = 27;
  var ariaHiddenInstances = 0;
  var ModalPortal2 = function(_Component) {
    _inherits2(ModalPortal3, _Component);
    function ModalPortal3(props) {
      _classCallCheck2(this, ModalPortal3);
      var _this = _possibleConstructorReturn2(this, (ModalPortal3.__proto__ || Object.getPrototypeOf(ModalPortal3)).call(this, props));
      _this.setOverlayRef = function(overlay) {
        _this.overlay = overlay;
        _this.props.overlayRef && _this.props.overlayRef(overlay);
      };
      _this.setContentRef = function(content) {
        _this.content = content;
        _this.props.contentRef && _this.props.contentRef(content);
      };
      _this.afterClose = function() {
        var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName2 = _this$props.bodyOpenClassName;
        bodyOpenClassName2 && classList$1.remove(document.body, bodyOpenClassName2);
        htmlOpenClassName && classList$1.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
        if (ariaHideApp && ariaHiddenInstances > 0) {
          ariaHiddenInstances -= 1;
          if (ariaHiddenInstances === 0) {
            ariaAppHider2.show(appElement);
          }
        }
        if (_this.props.shouldFocusAfterRender) {
          if (_this.props.shouldReturnFocusAfterClose) {
            focusManager$1.returnFocus(_this.props.preventScroll);
            focusManager$1.teardownScopedFocus();
          } else {
            focusManager$1.popWithoutFocus();
          }
        }
        if (_this.props.onAfterClose) {
          _this.props.onAfterClose();
        }
        _portalOpenInstances22.default.deregister(_this);
      };
      _this.open = function() {
        _this.beforeOpen();
        if (_this.state.afterOpen && _this.state.beforeClose) {
          clearTimeout(_this.closeTimer);
          _this.setState({ beforeClose: false });
        } else {
          if (_this.props.shouldFocusAfterRender) {
            focusManager$1.setupScopedFocus(_this.node);
            focusManager$1.markForFocusLater();
          }
          _this.setState({ isOpen: true }, function() {
            _this.openAnimationFrame = requestAnimationFrame(function() {
              _this.setState({ afterOpen: true });
              if (_this.props.isOpen && _this.props.onAfterOpen) {
                _this.props.onAfterOpen({
                  overlayEl: _this.overlay,
                  contentEl: _this.content
                });
              }
            });
          });
        }
      };
      _this.close = function() {
        if (_this.props.closeTimeoutMS > 0) {
          _this.closeWithTimeout();
        } else {
          _this.closeWithoutTimeout();
        }
      };
      _this.focusContent = function() {
        return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
      };
      _this.closeWithTimeout = function() {
        var closesAt = Date.now() + _this.props.closeTimeoutMS;
        _this.setState({ beforeClose: true, closesAt }, function() {
          _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
        });
      };
      _this.closeWithoutTimeout = function() {
        _this.setState({
          beforeClose: false,
          isOpen: false,
          afterOpen: false,
          closesAt: null
        }, _this.afterClose);
      };
      _this.handleKeyDown = function(event) {
        if (event.keyCode === TAB_KEY) {
          (0, _scopeTab2.default)(_this.content, event);
        }
        if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
          event.stopPropagation();
          _this.requestClose(event);
        }
      };
      _this.handleOverlayOnClick = function(event) {
        if (_this.shouldClose === null) {
          _this.shouldClose = true;
        }
        if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
          if (_this.ownerHandlesClose()) {
            _this.requestClose(event);
          } else {
            _this.focusContent();
          }
        }
        _this.shouldClose = null;
      };
      _this.handleContentOnMouseUp = function() {
        _this.shouldClose = false;
      };
      _this.handleOverlayOnMouseDown = function(event) {
        if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
          event.preventDefault();
        }
      };
      _this.handleContentOnClick = function() {
        _this.shouldClose = false;
      };
      _this.handleContentOnMouseDown = function() {
        _this.shouldClose = false;
      };
      _this.requestClose = function(event) {
        return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
      };
      _this.ownerHandlesClose = function() {
        return _this.props.onRequestClose;
      };
      _this.shouldBeClosed = function() {
        return !_this.state.isOpen && !_this.state.beforeClose;
      };
      _this.contentHasFocus = function() {
        return document.activeElement === _this.content || _this.content.contains(document.activeElement);
      };
      _this.buildClassName = function(which, additional) {
        var classNames2 = (typeof additional === "undefined" ? "undefined" : _typeof2(additional)) === "object" ? additional : {
          base: CLASS_NAMES[which],
          afterOpen: CLASS_NAMES[which] + "--after-open",
          beforeClose: CLASS_NAMES[which] + "--before-close"
        };
        var className = classNames2.base;
        if (_this.state.afterOpen) {
          className = className + " " + classNames2.afterOpen;
        }
        if (_this.state.beforeClose) {
          className = className + " " + classNames2.beforeClose;
        }
        return typeof additional === "string" && additional ? className + " " + additional : className;
      };
      _this.attributesFromObject = function(prefix2, items) {
        return Object.keys(items).reduce(function(acc, name) {
          acc[prefix2 + "-" + name] = items[name];
          return acc;
        }, {});
      };
      _this.state = {
        afterOpen: false,
        beforeClose: false
      };
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
      return _this;
    }
    _createClass2(ModalPortal3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpen) {
          this.open();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
          this.open();
        } else if (!this.props.isOpen && prevProps.isOpen) {
          this.close();
        }
        if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
          this.focusContent();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.state.isOpen) {
          this.afterClose();
        }
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function beforeOpen() {
        var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName2 = _props.bodyOpenClassName;
        bodyOpenClassName2 && classList$1.add(document.body, bodyOpenClassName2);
        htmlOpenClassName && classList$1.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
        if (ariaHideApp) {
          ariaHiddenInstances += 1;
          ariaAppHider2.hide(appElement);
        }
        _portalOpenInstances22.default.register(this);
      }
    }, {
      key: "render",
      value: function render() {
        var _props2 = this.props, id2 = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
        var contentStyles = className ? {} : defaultStyles.content;
        var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
        if (this.shouldBeClosed()) {
          return null;
        }
        var overlayProps = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends2({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        };
        var contentProps = _extends2({
          id: id2,
          ref: this.setContentRef,
          style: _extends2({}, contentStyles, this.props.style.content),
          className: this.buildClassName("content", className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", _extends2({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        });
        var contentElement2 = this.props.contentElement(contentProps, children);
        return this.props.overlayElement(overlayProps, contentElement2);
      }
    }]);
    return ModalPortal3;
  }(_react3.Component);
  ModalPortal2.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  };
  ModalPortal2.propTypes = {
    isOpen: _propTypes22.default.bool.isRequired,
    defaultStyles: _propTypes22.default.shape({
      content: _propTypes22.default.object,
      overlay: _propTypes22.default.object
    }),
    style: _propTypes22.default.shape({
      content: _propTypes22.default.object,
      overlay: _propTypes22.default.object
    }),
    className: _propTypes22.default.oneOfType([_propTypes22.default.string, _propTypes22.default.object]),
    overlayClassName: _propTypes22.default.oneOfType([_propTypes22.default.string, _propTypes22.default.object]),
    bodyOpenClassName: _propTypes22.default.string,
    htmlOpenClassName: _propTypes22.default.string,
    ariaHideApp: _propTypes22.default.bool,
    appElement: _propTypes22.default.oneOfType([_propTypes22.default.instanceOf(_safeHTMLElement22.default), _propTypes22.default.instanceOf(_safeHTMLElement3.SafeHTMLCollection), _propTypes22.default.instanceOf(_safeHTMLElement3.SafeNodeList), _propTypes22.default.arrayOf(_propTypes22.default.instanceOf(_safeHTMLElement22.default))]),
    onAfterOpen: _propTypes22.default.func,
    onAfterClose: _propTypes22.default.func,
    onRequestClose: _propTypes22.default.func,
    closeTimeoutMS: _propTypes22.default.number,
    shouldFocusAfterRender: _propTypes22.default.bool,
    shouldCloseOnOverlayClick: _propTypes22.default.bool,
    shouldReturnFocusAfterClose: _propTypes22.default.bool,
    preventScroll: _propTypes22.default.bool,
    role: _propTypes22.default.string,
    contentLabel: _propTypes22.default.string,
    aria: _propTypes22.default.object,
    data: _propTypes22.default.object,
    children: _propTypes22.default.node,
    shouldCloseOnEsc: _propTypes22.default.bool,
    overlayRef: _propTypes22.default.func,
    contentRef: _propTypes22.default.func,
    id: _propTypes22.default.string,
    overlayElement: _propTypes22.default.func,
    contentElement: _propTypes22.default.func,
    testId: _propTypes22.default.string
  };
  exports2.default = ModalPortal2;
  module2.exports = exports2["default"];
})(ModalPortal, ModalPortal.exports);
function componentWillMount() {
  var state2 = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state2 !== null && state2 !== void 0) {
    this.setState(state2);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state2 = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state2 !== null && state2 !== void 0 ? state2 : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component2) {
  var prototype = Component2.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component2;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component2.displayName || Component2.name;
    var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
  }
  if (typeof Component2.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component2;
}
var reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill
}, Symbol.toStringTag, { value: "Module" }));
var require$$6 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
Object.defineProperty(Modal$2, "__esModule", {
  value: true
});
Modal$2.bodyOpenClassName = Modal$2.portalClassName = void 0;
var _extends$3 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2];
    for (var key in source2) {
      if (Object.prototype.hasOwnProperty.call(source2, key)) {
        target[key] = source2[key];
      }
    }
  }
  return target;
};
var _createClass$c = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react$9 = React__default;
var _react2$9 = _interopRequireDefault$a(_react$9);
var _reactDom = ReactDOM;
var _reactDom2 = _interopRequireDefault$a(_reactDom);
var _propTypes$9 = propTypes$3.exports;
var _propTypes2$9 = _interopRequireDefault$a(_propTypes$9);
var _ModalPortal = ModalPortal.exports;
var _ModalPortal2 = _interopRequireDefault$a(_ModalPortal);
var _ariaAppHider = ariaAppHider$1;
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _safeHTMLElement = safeHTMLElement;
var _safeHTMLElement2 = _interopRequireDefault$a(_safeHTMLElement);
var _reactLifecyclesCompat = require$$6;
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key))
          newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault$a(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck$d(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$6(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var portalClassName = Modal$2.portalClassName = "ReactModalPortal";
var bodyOpenClassName = Modal$2.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== void 0;
var createHTMLElement = function createHTMLElement2(name) {
  return document.createElement(name);
};
var getCreatePortal = function getCreatePortal2() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(parentSelector2) {
  return parentSelector2();
}
var Modal$1 = function(_Component) {
  _inherits$6(Modal2, _Component);
  function Modal2() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck$d(this, Modal2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$6(this, (_ref = Modal2.__proto__ || Object.getPrototypeOf(Modal2)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function() {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }
    }, _this.portalRef = function(ref) {
      _this.portal = ref;
    }, _this.renderPortal = function(props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2$9.default.createElement(_ModalPortal2.default, _extends$3({ defaultStyles: Modal2.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn$6(_this, _ret);
  }
  _createClass$c(Modal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM)
        return;
      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;
      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent, nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _24, snapshot) {
      if (!_safeHTMLElement.canUseDOM)
        return;
      var _props = this.props, isOpen = _props.isOpen, portalClassName2 = _props.portalClassName;
      if (prevProps.portalClassName !== portalClassName2) {
        this.node.className = portalClassName2;
      }
      var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }
      if (!prevProps.isOpen && !isOpen)
        return;
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal)
        return;
      var state2 = this.portal.state;
      var now2 = Date.now();
      var closesAt = state2.isOpen && this.props.closeTimeoutMS && (state2.closesAt || now2 + this.props.closeTimeoutMS);
      if (closesAt) {
        if (!state2.beforeClose) {
          this.portal.closeWithTimeout();
        }
        setTimeout(this.removePortal, closesAt - now2);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }
      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }
      var createPortal = getCreatePortal();
      return createPortal(_react2$9.default.createElement(_ModalPortal2.default, _extends$3({
        ref: this.portalRef,
        defaultStyles: Modal2.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }
  }]);
  return Modal2;
}(_react$9.Component);
Modal$1.propTypes = {
  isOpen: _propTypes2$9.default.bool.isRequired,
  style: _propTypes2$9.default.shape({
    content: _propTypes2$9.default.object,
    overlay: _propTypes2$9.default.object
  }),
  portalClassName: _propTypes2$9.default.string,
  bodyOpenClassName: _propTypes2$9.default.string,
  htmlOpenClassName: _propTypes2$9.default.string,
  className: _propTypes2$9.default.oneOfType([_propTypes2$9.default.string, _propTypes2$9.default.shape({
    base: _propTypes2$9.default.string.isRequired,
    afterOpen: _propTypes2$9.default.string.isRequired,
    beforeClose: _propTypes2$9.default.string.isRequired
  })]),
  overlayClassName: _propTypes2$9.default.oneOfType([_propTypes2$9.default.string, _propTypes2$9.default.shape({
    base: _propTypes2$9.default.string.isRequired,
    afterOpen: _propTypes2$9.default.string.isRequired,
    beforeClose: _propTypes2$9.default.string.isRequired
  })]),
  appElement: _propTypes2$9.default.oneOfType([_propTypes2$9.default.instanceOf(_safeHTMLElement2.default), _propTypes2$9.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2$9.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2$9.default.arrayOf(_propTypes2$9.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2$9.default.func,
  onRequestClose: _propTypes2$9.default.func,
  closeTimeoutMS: _propTypes2$9.default.number,
  ariaHideApp: _propTypes2$9.default.bool,
  shouldFocusAfterRender: _propTypes2$9.default.bool,
  shouldCloseOnOverlayClick: _propTypes2$9.default.bool,
  shouldReturnFocusAfterClose: _propTypes2$9.default.bool,
  preventScroll: _propTypes2$9.default.bool,
  parentSelector: _propTypes2$9.default.func,
  aria: _propTypes2$9.default.object,
  data: _propTypes2$9.default.object,
  role: _propTypes2$9.default.string,
  contentLabel: _propTypes2$9.default.string,
  shouldCloseOnEsc: _propTypes2$9.default.bool,
  overlayRef: _propTypes2$9.default.func,
  contentRef: _propTypes2$9.default.func,
  id: _propTypes2$9.default.string,
  overlayElement: _propTypes2$9.default.func,
  contentElement: _propTypes2$9.default.func
};
Modal$1.defaultProps = {
  isOpen: false,
  portalClassName,
  bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2$9.default.createElement("div", props, contentEl);
  },
  contentElement: function contentElement(props, children) {
    return _react2$9.default.createElement("div", props, children);
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, _reactLifecyclesCompat.polyfill)(Modal$1);
Modal$2.default = Modal$1;
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  var _Modal = Modal$2;
  var _Modal2 = _interopRequireDefault2(_Modal);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  exports2.default = _Modal2.default;
  module2.exports = exports2["default"];
})(lib$1, lib$1.exports);
var Modal = /* @__PURE__ */ getDefaultExportFromCjs(lib$1.exports);
const Container$8 = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  ${({
  fullScreen
}) => fullScreen && {
  width: "100vw",
  height: "100vh",
  zIndex: 1,
  background: "#000000",
  position: "absolute",
  justifyContent: "center"
}}
`;
const Spinner$1 = styled.div`
  border: 2px solid #fff;
  border-radius: 50%;
  border-top: 2px solid transparent;
  width: 38px;
  height: 38px;
  margin-bottom: 15px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Message$5 = styled.div`
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  margin: 15px;
`;
const customStyles$4 = {
  overlay: {
    zIndex: 5
  },
  content: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    padding: 0,
    borderRadius: 0,
    border: "none",
    inset: 0,
    backgroundColor: "transparent",
    transform: "translateY(0)"
  }
};
function Loader(_f) {
  var _g = _f, {
    message: message2
  } = _g, props = __objRest(_g, [
    "message"
  ]);
  return /* @__PURE__ */ jsx(Modal, {
    isOpen: true,
    style: customStyles$4,
    children: /* @__PURE__ */ jsxs(Container$8, __spreadProps(__spreadValues({}, props), {
      children: [/* @__PURE__ */ jsx(Spinner$1, {}), /* @__PURE__ */ jsx(Message$5, {
        children: message2
      })]
    }))
  });
}
const NotificationContainer = styled.div`
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 20px 15px 20px;
  position: fixed;
  top: 120px;
  left: 0;
  right: 0;
  display: ${(props) => !props.isOpen && "none"};
  max-width: calc(100% - 50px); // 40px are for the padding
  width: fit-content;
  margin: auto;
  box-sizing: content-box;

  &.center {
    font-size: 18px;

    .icon {
      text-align: center;
    }

    .notification-text {
      line-height: 1.5;
      margin: 0;
    }
  }

  &.inline {
    display: flex;
  }

  &.desktop {
    top: unset;
    padding: 0;
    background-color: transparent;
    color: #20263d;
    display: block;
    position: relative;
  }
`;
const NotificationText = styled.div`
  text-align: center;

  &.desktop {
    div {
      font-size: 24px;
      line-height: 22px;

      div {
        margin-top: 10px;
      }
    }
  }
`;
const DEFAULT_DURATION = 3e4;
const NotificationContext = createContext({});
const reducer = (state2, action) => {
  switch (action.type) {
    case "showNotification":
      if (state2.isOpen) {
        return state2;
      }
      return __spreadProps(__spreadValues({}, state2), {
        children: action.children,
        icon: action.icon,
        isOpen: true
      });
    case "showPriorityNotification":
      window.clearTimeout(closeTimeout);
      return __spreadProps(__spreadValues({}, state2), {
        children: action.children,
        icon: action.icon,
        isOpen: true
      });
    case "closeNotification":
      return __spreadProps(__spreadValues({}, state2), {
        children: null,
        icon: "",
        isOpen: false
      });
    default:
      return state2;
  }
};
let closeTimeout;
const showNotification = (dispatch, type) => (children, icon) => {
  dispatch({
    type,
    children,
    icon
  });
  closeTimeout = setTimeout(() => {
    closeNotification(dispatch);
  }, DEFAULT_DURATION);
};
const closeNotification = (dispatch) => {
  dispatch({
    type: "closeNotification"
  });
};
const NotificationProvider = ({
  children,
  initialValue
}) => /* @__PURE__ */ jsx(NotificationContext.Provider, {
  value: useReducer(reducer, initialValue),
  children
});
const useNotifications = () => {
  const [s2, dispatch] = useContext(NotificationContext);
  return __spreadProps(__spreadValues({}, s2), {
    showNotification: useCallback(showNotification(dispatch, "showNotification"), []),
    showPriorityNotification: useCallback(showNotification(dispatch, "showPriorityNotification"), []),
    closeNotification: useCallback(() => closeNotification(dispatch), [])
  });
};
function Portal({
  children
}) {
  const portalNode = useRef(null);
  const [, forceUpdate] = useState();
  useLayoutEffect(() => {
    portalNode.current = document.createElement("portal");
    document.body.appendChild(portalNode.current);
    forceUpdate({});
    return () => {
      if (portalNode.current) {
        document.body.removeChild(portalNode.current);
      }
    };
  }, []);
  return portalNode.current ? ReactDOM.createPortal(children, portalNode.current) : null;
}
function Notification$1({
  center = false,
  inline = true,
  noPortal = false
}) {
  const [{
    isOpen,
    children,
    icon
  }] = useContext(NotificationContext);
  if (noPortal) {
    return /* @__PURE__ */ jsx(NotificationContainer, {
      className: classNames({
        center,
        inline,
        desktop: mobile.isDesktop()
      }),
      isOpen,
      children: /* @__PURE__ */ jsx(NotificationText, {
        className: classNames({
          desktop: mobile.isDesktop()
        }),
        children
      })
    });
  }
  return /* @__PURE__ */ jsx(Portal, {
    children: /* @__PURE__ */ jsx(NotificationContainer, {
      className: classNames({
        center,
        inline,
        desktop: mobile.isDesktop()
      }),
      isOpen,
      children: /* @__PURE__ */ jsx(NotificationText, {
        className: classNames({
          desktop: mobile.isDesktop()
        }),
        children
      })
    })
  });
}
const PermissionRequestContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  z-index: 99999;
  box-sizing: border-box;
  padding: 75px 25px;
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
`;
const Text$7 = styled.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-size: 22px;
  color: white;
`;
function PermissionRequest({
  text,
  color: color2
}) {
  return /* @__PURE__ */ jsx(Portal, {
    children: /* @__PURE__ */ jsx(PermissionRequestContainer, {
      style: {
        background: color2
      },
      children: /* @__PURE__ */ jsx(Text$7, {
        children: text
      })
    })
  });
}
var cancelImg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjA1MzYgNS41MTUwM0wxOC41Njk3IDEzLjk5OThMMjcuMDUzNiAyMi40ODQyQzI4LjMxNTUgMjMuNzQ2NiAyOC4zMTU1IDI1Ljc5MTYgMjcuMDUzNiAyNy4wNTRDMjYuNDIzIDI3LjY4NDUgMjUuNTk2NCAyOCAyNC43NzAxIDI4QzIzLjk0MjUgMjggMjMuMTE1OCAyNy42ODUgMjIuNDg1NyAyNy4wNTRMMTQgMTguNTY4Nkw1LjUxNSAyNy4wNTM5QzQuODg0NTYgMjcuNjg0NCA0LjA1NzgyIDI3Ljk5OTkgMy4yMzA4NCAyNy45OTk5QzIuNDA0MTEgMjcuOTk5OSAxLjU3NzkzIDI3LjY4NDkgMC45NDY5MjkgMjcuMDUzOUMtMC4zMTUgMjUuNzkyIC0wLjMxNSAyMy43NDcgMC45NDY5MjkgMjIuNDg0MUw5LjQzMDUyIDEzLjk5OTdMMC45NDY0NDYgNS41MTUwM0MtMC4zMTU0ODIgNC4yNTMxIC0wLjMxNTQ4MiAyLjIwNzY3IDAuOTQ2NDQ2IDAuOTQ1NzI5QzIuMjA4MTMgLTAuMzE1MjQzIDQuMjUyMzUgLTAuMzE1MjQzIDUuNTE0NTIgMC45NDU3MjlMMTQgOS40MzA1TDIyLjQ4NDggMC45NDU3MjlDMjMuNzQ3MiAtMC4zMTUyNDMgMjUuNzkxNiAtMC4zMTUyNDMgMjcuMDUzMSAwLjk0NTcyOUMyOC4zMTU1IDIuMjA3NjcgMjguMzE1NSA0LjI1MzEgMjcuMDUzNiA1LjUxNTAzWiIgZmlsbD0iI0ZGNUM2RiIvPgo8L3N2Zz4K";
const Container$7 = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  z-index: 1;
  background: #fff;
  position: absolute;
  justify-content: center;
  gap: 40px;
`;
Container$7.displayName = "ModalPermissionContainer";
const Message$4 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  margin: 15px;
  strong {
    color: #00b2fd;
    margin-bottom: 5px;
  }
  span {
    margin-bottom: 5px;
  }
  @media only screen and (max-height: 640px) {
    font-size: 18px;
  }
`;
Message$4.displayName = "MessagePermission";
const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
`;
ContainerButtons.displayName = "ContainerButtonsPermission";
const customStyles$3 = {
  overlay: {
    zIndex: 9999999999
  },
  content: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    padding: 0,
    borderRadius: 0,
    border: "none",
    inset: 0,
    backgroundColor: "transparent",
    transform: "translateY(0)"
  }
};
function AllowCameraUse({
  handleAllowCamera
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx(Modal, {
    isOpen: true,
    style: customStyles$3,
    children: /* @__PURE__ */ jsxs(Container$7, {
      children: [/* @__PURE__ */ jsx("img", {
        src: cancelImg,
        alt: "cancel"
      }), /* @__PURE__ */ jsxs(Message$4, {
        children: [/* @__PURE__ */ jsx("span", {
          children: t2("fakePermissionsNotification.noPermissions.lineOne")
        }), /* @__PURE__ */ jsx("span", {
          children: t2("fakePermissionsNotification.noPermissions.lineTwo")
        }), /* @__PURE__ */ jsx("span", {
          children: t2("fakePermissionsNotification.noPermissions.lineThree")
        })]
      }), /* @__PURE__ */ jsx(ContainerButtons, {
        children: /* @__PURE__ */ jsx(Button$3, {
          onClick: handleAllowCamera,
          children: t2("fakePermissionsNotification.noPermissions.restartProcess")
        })
      })]
    })
  });
}
var BrowserNotSupportedIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTQiIGhlaWdodD0iMTQxIiB2aWV3Qm94PSIwIDAgMTU0IDE0MSI+CiAgICA8ZyBmaWxsPSIjMjAyNjNEIj4KICAgICAgICA8cGF0aCBkPSJNMTM3LjYuMUgxNkM3LjE4LjEgMCA3LjI4IDAgMTYuMXYxMDguOGMwIDguODIgNy4xOCAxNiAxNiAxNmgxMjEuNmM4LjgxOSAwIDE2LTcuMTggMTYtMTZWMTYuMWMwLTguODItNy4xOC0xNi0xNi0xNnptOS42IDEyNC44YzAgNS4yOTMtNC4zMDcgOS42LTkuNiA5LjZIMTZjLTUuMjkzIDAtOS42LTQuMzA3LTkuNi05LjZWMzIuMWgxNDAuOHY5Mi44em0wLTk5LjJINi40di05LjZjMC01LjI5MyA0LjMwNy05LjYgOS42LTkuNmgxMjEuNmM1LjI5MyAwIDkuNiA0LjMwNyA5LjYgOS42djkuNnoiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2LjEiIHI9IjMuMiIvPgogICAgICAgIDxjaXJjbGUgY3g9IjI4LjgiIGN5PSIxNi4xIiByPSIzLjIiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI0MS42IiBjeT0iMTYuMSIgcj0iMy4yIi8+CiAgICAgICAgPHBhdGggZD0iTTk4LjU4IDY4LjI3M0w4NS44NTUgODEgOTguNTggOTMuNzI2YzEuODkzIDEuODk0IDEuODkzIDQuOTYxIDAgNi44NTUtLjk0NS45NDYtMi4xODUgMS40MTktMy40MjUgMS40MTktMS4yNDEgMC0yLjQ4MS0uNDczLTMuNDI2LTEuNDE5TDc5IDg3Ljg1MyA2Ni4yNzIgMTAwLjU4Yy0uOTQ1Ljk0Ni0yLjE4NSAxLjQxOS0zLjQyNiAxLjQxOS0xLjI0IDAtMi40OC0uNDczLTMuNDI2LTEuNDItMS44OTItMS44OTItMS44OTItNC45NiAwLTYuODU0TDcyLjE0NiA4MSA1OS40MiA2OC4yNzNjLTEuODkzLTEuODkzLTEuODkzLTQuOTYyIDAtNi44NTQgMS44OTItMS44OTIgNC45NTktMS44OTIgNi44NTIgMEw3OSA3NC4xNDZsMTIuNzI3LTEyLjcyN2MxLjg5NC0xLjg5MiA0Ljk2LTEuODkyIDYuODUzIDAgMS44OTMgMS44OTIgMS44OTMgNC45NiAwIDYuODU0eiIvPgogICAgPC9nPgo8L3N2Zz4K";
const BrowserNotSupportedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  text-align: center;
  z-index: 9999999;
  box-sizing: border-box;
  padding: 50px;
  font-weight: bolder;
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
`;
const Image$9 = styled.img`
  height: 90px;
  margin-bottom: 25px;
`;
const Text$6 = styled.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-size: 22px;
`;
function BrowserNotSupported() {
  const {
    t: t2
  } = useTranslation();
  const isAndroid2 = window.navigator.userAgent.includes("Android");
  return /* @__PURE__ */ jsxs(BrowserNotSupportedContainer, {
    children: [/* @__PURE__ */ jsx(Image$9, {
      src: BrowserNotSupportedIcon,
      alt: "browser not supported"
    }), /* @__PURE__ */ jsx(Text$6, {
      children: t2("common.browserNotSupported")
    }), /* @__PURE__ */ jsx(Text$6, {
      children: t2("common.browserNotSupportedDesc", {
        browser: isAndroid2 ? "Chrome" : "Safari"
      })
    })]
  });
}
const backCameraKeywords = [
  "rear",
  "back",
  "r\xFCck",
  "arri\xE8re",
  "trasera",
  "tr\xE1s",
  "traseira",
  "posteriore",
  "\u540E\u9762",
  "\u5F8C\u9762",
  "\u80CC\u9762",
  "\u540E\u7F6E",
  "\u5F8C\u7F6E",
  "\u80CC\u7F6E",
  "\u0437\u0430\u0434\u043D\u0435\u0439",
  "\u0627\u0644\u062E\u0644\u0641\u064A\u0629",
  "\uD6C4",
  "arka",
  "achterzijde",
  "\u0E2B\u0E25\u0E31\u0E07",
  "baksidan",
  "bagside",
  "sau",
  "bak",
  "tylny",
  "takakamera",
  "belakang",
  "\u05D0\u05D7\u05D5\u05E8\u05D9\u05EA",
  "\u03C0\u03AF\u03C3\u03C9",
  "spate",
  "h\xE1ts\xF3",
  "zadn\xED",
  "darrere",
  "zadn\xE1",
  "\u0437\u0430\u0434\u043D\u044F",
  "stra\u017Enja",
  "belakang",
  "\u092C\u0948\u0915"
];
const cameraObjects = /* @__PURE__ */ new Map();
const inaccessibleCameras = /* @__PURE__ */ new Set();
let getCamerasPromise;
function isBackCameraLabel(label) {
  const lowercaseLabel = label.toLowerCase();
  return backCameraKeywords.some((keyword) => {
    return lowercaseLabel.includes(keyword);
  });
}
function adjustCamerasFromCameraStream(mediaStreamTrack, cameras) {
  let mediaTrackSettings;
  if (typeof mediaStreamTrack.getSettings === "function") {
    mediaTrackSettings = mediaStreamTrack.getSettings();
  }
  const activeCamera = cameras.find((camera) => {
    return camera.deviceId === (mediaTrackSettings == null ? void 0 : mediaTrackSettings.deviceId) || camera.label !== "" && camera.label === mediaStreamTrack.label;
  });
  if (activeCamera !== void 0) {
    const activeCameraIsBackFacing = mediaTrackSettings != null && mediaTrackSettings.facingMode === "environment" || isBackCameraLabel(mediaStreamTrack.label);
    if (activeCameraIsBackFacing && cameras.length > 1) {
      cameras.forEach((camera) => {
        if (camera.deviceId === activeCamera.deviceId) {
          camera.cameraType = "back";
        } else if (!isBackCameraLabel(camera.label)) {
          camera.cameraType = "front";
        }
      });
      return cameras.filter((camera) => {
        return camera.cameraType === "back";
      }).sort((camera1, camera2) => {
        return camera1.label.localeCompare(camera2.label);
      })[0];
    } else if (cameras.length === 1) {
      return activeCamera;
    }
  }
}
function extractCamerasFromDevices(devices) {
  function createCamera(videoDevice, index2, videoDevices) {
    var _a, _b, _c, _d, _e2, _f, _g;
    if (cameraObjects.has(videoDevice.deviceId)) {
      return cameraObjects.get(videoDevice.deviceId);
    }
    const label = (_a = videoDevice.label) != null ? _a : "";
    const capabilities = (_b = videoDevice == null ? void 0 : videoDevice.getCapabilities) == null ? void 0 : _b.call(videoDevice);
    const width2 = (_d = (_c = capabilities == null ? void 0 : capabilities.width) == null ? void 0 : _c.max) != null ? _d : "";
    const height2 = (_f = (_e2 = capabilities == null ? void 0 : capabilities.height) == null ? void 0 : _e2.max) != null ? _f : "";
    const aspectRatio = (_g = capabilities == null ? void 0 : capabilities.aspectRatio) != null ? _g : "";
    let cameraType;
    if (videoDevices.every((device) => {
      return device.label === "";
    })) {
      cameraType = videoDevices.length === 1 || index2 + 1 <= videoDevices.length / 2 ? "front" : "back";
    } else {
      cameraType = isBackCameraLabel(label) ? "back" : "front";
    }
    const camera = {
      deviceId: videoDevice.deviceId,
      label,
      cameraType,
      width: width2,
      height: height2,
      aspectRatio
    };
    cameraObjects.set(videoDevice.deviceId, camera);
    return camera;
  }
  const cameras = devices.filter((device) => {
    return device.kind === "videoinput";
  }).filter((videoDevice) => {
    return !/\b(?:ir|infrared)\b/i.test(videoDevice.label);
  }).filter((videoDevice) => {
    return !inaccessibleCameras.has(videoDevice.deviceId);
  }).map(createCamera);
  if (cameras.length > 1 && !cameras.some((camera) => {
    return camera.cameraType === "back";
  })) {
    let backCameraIndex = cameras.length - 1;
    const cameraResolutions = cameras.map((camera) => {
      const match = camera.label.match(/\b([0-9]+)MP?\b/i);
      if (match != null) {
        return parseInt(match[1], 10);
      }
      return NaN;
    });
    if (!cameraResolutions.some((cameraResolution) => {
      return isNaN(cameraResolution);
    })) {
      backCameraIndex = cameraResolutions.lastIndexOf(Math.max(...cameraResolutions));
    }
    cameras[backCameraIndex].cameraType = "back";
  }
  return cameras;
}
function getCameras() {
  if (getCamerasPromise != null) {
    return getCamerasPromise;
  }
  const accessPermissionPromise = new Promise((resolve, reject) => {
    return enumerateDevices().then((devices) => {
      if (devices.filter((device) => {
        return device.kind === "videoinput";
      }).every((device) => {
        return device.label === "";
      })) {
        resolve(navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false
        }).catch(() => {
          return null;
        }));
      } else {
        resolve(null);
      }
    }).catch(reject);
  });
  getCamerasPromise = new Promise(async (resolve, reject) => {
    if (accessPermissionPromise !== void 0) {
      accessPermissionPromise.then(async (stream) => {
        const devices = await enumerateDevices();
        const cameras = extractCamerasFromDevices(devices);
        if (stream) {
          stream.getTracks().forEach((track) => track.stop());
        }
        return resolve(cameras);
      }).catch((error3) => {
        return reject(error3);
      });
    }
  });
  return getCamerasPromise;
}
function enumerateDevices() {
  if (typeof navigator.enumerateDevices === "function") {
    return navigator.enumerateDevices();
  } else if (typeof navigator.mediaDevices === "object" && typeof navigator.mediaDevices.enumerateDevices === "function") {
    return navigator.mediaDevices.enumerateDevices();
  } else {
    return new Promise((resolve, reject) => {
      var _a;
      try {
        if (((_a = window.MediaStreamTrack) == null ? void 0 : _a.getSources) == null) {
          throw new Error();
        }
        window.MediaStreamTrack.getSources((devices) => {
          resolve(devices.filter((device) => {
            return device.kind.toLowerCase() === "video" || device.kind.toLowerCase() === "videoinput";
          }).map((device) => {
            var _a2;
            return {
              deviceId: (_a2 = device.deviceId) != null ? _a2 : "",
              groupId: device.groupId,
              kind: "videoinput",
              label: device.label,
              toJSON: function() {
                return this;
              }
            };
          }));
        });
      } catch {
        return reject(new Error("not supported"));
      }
    });
  }
}
const IOSNotificationStyled = styled.div`
  background: white;
  width: 80%;
  border-radius: 0.5rem;
  .content {
    display: flex;
    flex-direction: column;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    h4 {
      text-align: center;
    }
    p {
      text-align: center;
      font-size: 0.75rem;
    }
  }
  .container-buttons {
    width: 100%;
    display: flex;
    button {
      font-size: 0.875rem;
      line-height: 1.25rem;
      height: 2.5rem;
      color: #3db0f7;
    }
  }
`;
const IOSNotification = ({
  buttons
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(IOSNotificationStyled, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "content",
      children: [/* @__PURE__ */ jsx("h4", {
        children: t2("fakePermissionsNotification.ios.title")
      }), /* @__PURE__ */ jsx("p", {
        children: t2("fakePermissionsNotification.ios.content")
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "container-buttons",
      children: buttons
    })]
  });
};
const AndroidNotificationStyled = styled.div`
  background: white;
  width: 80%;
  padding: 1rem;
  .content {
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
    h4 {
      font-size: 1.1rem;
    }
    p {
      text-align: center;
      font-size: 0.75rem;
    }
  }
  .container-buttons {
    width: 100%;
    display: flex;
    button {
      font-size: 0.875rem;
      line-height: 1.25rem;
      height: 2.5rem;
      color: #009688;
    }
  }
`;
const AndroidNotification = ({
  buttons
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(AndroidNotificationStyled, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "content",
      children: /* @__PURE__ */ jsx("h4", {
        children: t2("fakePermissionsNotification.android.title")
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "container-buttons",
      children: buttons
    })]
  });
};
const ContainerMessage = styled.div`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  * + * {
    margin-bottom: 0.2rem;
  }
  button {
    margin-bottom: 1.5rem;
  }
  button:last-child {
    font-size: 0.8rem;
    margin-top: 1rem;
    border: none;
    background: transparent;
  }
  .content {
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 1.25rem;
    line-height: 1.75rem;
    strong {
      color: #3db0f7;
    }
  }
  .container-img {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    img {
      width: 80%;
    }
  }
`;
var permissionsImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUIAAACKCAYAAADfYUPxAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABQqADAAQAAAABAAAAigAAAADempTsAABAAElEQVR4Ae19CZxlRXlv3b1v7+vsPQszICOLrGoAURQXkiCYGMQlccsTjdFE84t5+fkz76nvxay/aIxREjWPSIRgUARhUEEwIMqwDzDALMxM90zPTM/0vt21+/3/de53u+7pc+5+by9zqvvc+uqrr6q++qrqO7UfpTzjScCTgCcBTwKeBDwJeBLwJOBJwJOAJwFPAp4EPAl4EvAk4EnAk4AnAU8CngQ8CXgS8CTgScCTgCcBTwKeBDwJeBLwJOBJwJOAJwFPAp4EPAl4EvAk4EnAk4AnAU8CngQ8CXgS8CRwakrAd2pm28u1J4EVJ4FateW5FScphwzVSngOSXkoTwKeBKoggaXSZleUglwqQq1C/fCi8CSwIiVQbhstN1y5Cq7ccEui0MoV1pJg3mPCk8AKlUAp7bIQbSF/EWEhRVbIX+KhXQqtGW7R4GKFtGgMegl7EjhFJFBsW3Sic8JRbG54N5G6KTAnvBPOKd5i6ZzC1g1XqqDqxpiXkCeBU0QCxbRBO00hN0VnpylWnE6Ky44r5HZKyx7GiWbRcOUKa9EY9hL2JLBCJFCo7dn9TbcJUxym24TtfvlEZ1dUptuEGYfpNmG7n1N6dnonmrrj7EKrOwNegp4ETjEJFGpzpn8huJC/iNakE5xp25WT6XaCnXCMzw1vpiWwSSu4RbMLCWjRGPMS9iSwwiRQqK2Z/gKLTVEIXMg2ae0w3W7GVExOsODcbMZr9zNxxaTrRlNzvAi12IRKpS82Xo/u1JSANJyVnvt87cb0E7gYewHNze99b8dre3vPaItGTw8HAmeEAoHTQbTK7/M1Q8AttOEmTI01OTs3Nwlwgjbcg8l0em8ind4zNjOz91f9/Xve9x//MWKRMkSOkpNyK9Y2w+vIbD8Sjw1dP6cIM1+KxdDkC+/5eRIoVgKL3iCKZbRIunxtx/QT2Mk2cYSz7ns//OG15/X2vqE5FHo9lN7lUHQbi+SrKDIoyD4ox/+eTCZ//nR//4Nv+9a3jiKglBFteRifHRacadthuk0jcZu4usAiVKfE8vnZ6UuhtYf13KeGBEqp5KXQLlXp5WsT4pfPpp/pr92PfeITZ5y+evV7oqHQNX6lTq9n5meV2juTTP5w7/Hj3734q1/dg7RF+Ul5ObnJoulvugnbjdDa8TV1i6DNRJxwpj9hNxo3vD285z51JOBUsZ1wdokUQ2MPs1Tcbu3AxAtM2w4LTtu3fPCDnW857bTrmoLBdwf8/guXQibTs7NPTKVSt/zk5Zdve/e//dsweGJ5OT1kV/AC06ZxK2M3vBWqBr9SABK13S14sU1/E3byF5xnn9oSsFfqQm5TWnZa028pwk5tQvgUPyebuAXPjo99bMOlGzZ8qjEU+r25ubmoRLSUbJ/PNzOdTP77Lw4f/oervv71w+CNZeb2kHUpU7tNP7sRGju+6m4pFInY7nbCmzRusISjbdKYeA9eWRJwq7R2vLjFphRM2C6VfH522sV056vn4mfahOUh3xjpWu5H/vAPTzt33bo/aQgE3o3Mh+m51A0ykoil07fsGhj4+0v+6Z9eBr8sNz4YUWsjbrGJJEwjtuXK/c3nl0tZgUsKhlGYsBml4O22GUb8TJwZhwefmhIwK7HAbjYlJH6mtJxwpv9SgM36b/Jj4gmLW2DT9v/Nr/96yw2XXPK5pnD4BvQAA2ZEywVGDzE9lUjceOMjj3zxM/fcMwG+qQhZhvaHWRIcYRq3snbDW6Gq8CsFw6hMWKIWnJPthHOLR+Lz7FNHAmblFZi2CVMaJk7ctE0jYUzcUoGlHdj5EbxpE3Z8jvzFX1y3qqnpL+G/xh7RMnUfHZya+uz6L3zhNvAvZexmM4tSxmLbs+2Gt9OV5TYLyR6B3c8sQNI6uQXvFpcd77lXhgTcKqngadthO46SMGlMyQjexC0FWNqInRfBm7bZXgT233fDDZsu27LlawGf7w32SFaCOz039+DDBw58/MobbzyE/Lj1DqV87bZdBOJvx1fsNgvKjMyOl4LL2vfcfnP3JZe/9vrGSOS6QDBwNgIvyclcM1MevCgSSKP2Hk0mEjv6jgx88xPv/ujzP9m1K5XhhBXb/tDLqcI74TLRLIolbcSeuOClrdBfYLH1fGDf5z539drm5q/Dv90eyQpzjx6dnPzYxi9+8S7ki+XopBCZZakLAtO2m5rUA7PQzASlwIgTOGsfe/mZN/esW/V5v89//txsWs3VhDWTHQ9e7hLw+/1qdnZuYnpq+u92/Ojef7nugx8fRZ6k4tttZtdeq+zuxRaJtB2TD8FJW6GfwNnFkN8455zId6+//ouNweDHzcArHZ5Opb72nltv/dzdzz4bR16lzE2lSBEIXmDapqlJPeCErBSeJCZuKUDT9h879OyVqzas+Y4/GNwym5QXuwT1bE8CzhLA5L+CMoyEmxqv2Lp187rVrase2HH//QmDmhVc6h7RJmyQLQnQiTfB0TZhKkBRgv7bP/ShNZ+94oo7I4HAtUsiJ3VkIuT3v/qd55zzpgs2brz3tqeems4kbcqLKJGdHc6Q5/gLrmLbzoQkbuKlEH233/6v3Ve/9aq7Q43Rc2djVOqe8SRQmgT8Abx7g8HkQF//767fct6dCE0FaPYK8vUIatIbKC0Hjg1RGq/Zbghn2w7hX3zyk1suWr/+TiC3lJhmUeSp2VmFs8IK83JqJB5XR6em1MlYTA1OT6vRREKNA4dN0JpG+Xw6I1GUR0s4rFY1Nqo1eDa1takNsKPBoIKyLirdUolQ2AceP3Lk7Zf+4z8eQFiz7AVmlPnqgfjTrooxC44R0k0jeLFZoP7xE/s+1tLa/HezafLrGU8C5UkA/UKVmp6+79N/+bfv+eqXvsqD/9IApPKbtpkI8YtppH2YPAhO2gr9COcowaf++I/PO3vt2tuBX02CahgqvlEotwkouaNQdv0TE6p/clKdgPKLQeHRlCowMh6BEtzW2qouXLVKbWppUd3Rmkz/H3/u6NHfPv/LX34aSZrlL7CwL1kQm3gxTjjxK8k2C48B6aYRvBSmVoSJ8b4HgqHQxRzmOBnsIVI+v0ThRLFycXOolC5iWb6Z9gWyFaKcTMyxGc4tfGmynkBYiQOH+3976xmv+RnilsovNiuYVDKxyYIJ011P41SxBUfbhM1249v7Z3922ebOzu+BpqVShnG0TSu9gYzi2zc2po5A+QXRe2O75IPLEipNhtMY6DT61BoowdesXq3O6epSXQ0NFcdri2Di4PDw75z+13/9MPBkWspfbJITLxkSm3gxTjjxK9o2C5CBxG3aWgnCz5+ePjIIEtfXQwo9xeND3EN5ahmc/1Rrulu08KpSKktCfD6Vip9A1eQUiLTxUhibU75gswqEO1GN0wsCspHNzqb3BZs2nAdPVnyp/BSh/ZHwiyleuxDEbdqERQlqONMT3AF8RUqQvb6Hjh5Ve0dH1YmZGT3ExW0zehisX8IioSrbrNs03VCCb9u4UV3Q06MVZBWTmUDP8Ko8PUMpc7stLAhe3GXZLCwpSEYgbrGzShB+UIQD4yRyMnwTffqv71ZP7x445XqFfAFf+6bt6lO//wY1m1j+C0j+QFSNHvqWGuu7CUVN/WRWEafSd8JhcSSIYdWZn1cNbeehp+KsDP3RtVQQpiJ0UoiSQFUqvURWgu0kAMHRNh9RhP6f46jcJb29P4V/RcPhA+Pj6pY9e9RxKEAqpln0CqvR6ysh/zpd3HGoLluzRr110yYVzijIUuLIQ3v8kf7+N7/eOpon5S82y1weRuFUB5xweZJb6BU0UFKwgirkFjptUxn85Bd71cmhyVNOEcah/Lrao+pTN1hvzxzBLEeHL6Rio4/jeVb5A+XmCT1Cf1glJnarhvYLHHuFmSkWU4lUXKFrIG57O2ASgjN5J5xVgre+//1rcEnqD4GrSAkyMc7TvRW9sbsOHFAj6Blm5EavuhkOyWNo5PcdPqznH9+xdasKVk8ZrqasILM3X3/TTceQKSpBypK2aVg/KGd7PXHCmeEKwqYiNIkZMQ1teTQi308A84OhEOaVOAd0Chnsj1Mcpqwsg/leZMnnD5WZLSrCosLa6xfdZkW3u8vkp2rByA+N8G23/dgnGL5m+/Zb0ZK3WKSV/bJuceHi5bFx9cixo1o7mAKqLPbiQ4sCfhhDdK4qX7Z+nWoPR4qPIA8lZUWZQXZvwT5DbquiEhRZmyHdlKFJUzJMrWsaKVQTR9gNb6fz3J4ESpWAVHazjgmu1LiqTe/Gh4kXvtmWNPzdd73r/wR9vouqxUwcW2K+t3efemhg8ZSgPS8/7e9X337heXV330F1Mh6ze5flpsy40RyBF8jUiNCUvYF2VJqmf17YrghNYklQbNPPgz0JVFMCZh0TmLbA1UyrkrhMfoQ/0/Yf+Oxnr8b9gX9QSSJm2CSGpLfv269+eohX/aGrzDmoRTbkgM+x6Rn16Ilj6tZ9L6n942NV4YqnbShDRJZ9sQA2ZSzpmGUhuLLtfIqQkZqJmXDZCXoBPQnYJCD1irbANpJFcdp5EbfwucDGBQobN7S2/nO1uOWCyD0HDqn7+45gOwuE41t8JWjmLZ5KK+4UYY/wjkP7oQx5arJyQxlSlohpgYwNHBOSMiFMY3db2CJ+3eYI7UGLSiCZnFVpCOZUmyNMpWZVEo9nVrwEzHZAWB52KPyXbt5MJdheLSk8evSY2nGgj91AFcai1dJSg5jEA0NU1lzFnkgm1d39h9S7TwurnmhjpSJoz8iSPUMac75QxEDZC6yJKvkpVhEWTIPK76rLz1CPPHXolFKELAnuIX/ja7cq5Z24KVhPXAhYqZeSsfNjugkveHCf4Duxivr6amWCp0S+v/+gikPJhAJcuPJVr9VXi0lRQ5DGLDbOD6Nn+BAWc67ZfJrCtWIVpUJZUqa4z5Ab0UXejFMiNlLPEQ39xY/0RZlSFKEw4Bgx8/2/Pn6lGh6Ts9SOZCsS6Ycm7OlsVt4lFCuyeCVTrP/mQ7x2/9+3vrUlc6mq0FZkz+B43H/t3a+GZmLoDEIR+oOlt+yKOCg9MKcu5zB03z06pC6eXq16m/Tnk0uPyAhBmUK29372xz/m/mXKmgqOtmlKVnpmYIHdFKGZmAlLOEe7oy2qOjoq7hY7xr3kkRgncBuNZ0qWQNH1q+SYywtg58fuZqzEcThM2/fxyy77HOyq3Sy9H8fmdg+P6iEn5wYD6BEuRcPOj+YsU+1Z/2dxT8Nzw0O4wKFJhSrsFVKmlC0U4WcAMynKnMNke0Ojn4mzu+Gd37gpwvyhXHy1IsgoA26mXbCPzGTVJQ4LXTRhTu5zZZE3AcPTlpbNaRBmQHcCH4spr3EP6xysSPoFZAsQztHbsNbpj/LC2qIqx6nbVCZgyRW5nARLCEN+nB7/z264YWtzJPKRaq3m4s4+9TOsEKfRjlgS3Ju7VI1WhDZlx43Xu0eG1GtXrVEdkcr3GFK2kPGNb7zxxv2Qg8wV2oVScaWtqiKUAvPhsP7U4L1qZugXGVSmDonQtMaw8mItrGT8M3UtB2fPMl4KjD/zLoJlxm3BmFGx/HVYSzvlxpnxFzrampZzMaLNbDRIxyKhv4Z02tm0NA544SeTc7wNsvRW3JmwpNdx0m2GY4wZGuElG6dJxwQgCx2WMP3meV/IF0nmeSFspcJfCwqEu3AsrvIhDblZIcYSTG5mRGDavmjjxk9DCbJCVsX0T0yqp08M6TPEjLDSubaqMOUSCTd6U0+bWoiLJxPplBqYmqyKIqRsKWOw8Id4TNmbyZJD+tlxxBdlaqIIyY3PH9UPlbh1CwmRGT45oUDlDovzClwVo7HegYQtt+C1Z/aH9LgVm26G09mnK/PouEQmjBF4elk/83QaJeHm/a03uw4wT+sQfr4HAM8MH0zLl8kLY9RJ+ngrTSadDJ32yuDIaTa80GVxiDGTtkXHF6L2zPxKvBZO5zXjY4na8tdRkBkrMlCQErxqXCbsXEK1b/0T1bLm7TqGU/RHi9mWd+Icn7s+8pH12Pd2vSVfW6gynCyen/cf0SVjVR686qp3jK0MjtyDUCDhzCKOnYqryM+PDqvtHZ1VOXFFGUPWX7r6X/7lMNIyy8JM2l4MpLPjTPocuCaKkIoq2vlaFe14TU5iTnzlcprrsgU2nBk6R3JHpBFWwDx0+vop6V2BXvfIGI6ypRE7A5vOrLLRhJkfp7TsOLhzUJYjB5VLgLgzvjlEOY55GpOdBeEyYTApn40zh/6UdJilKgIgLvu8ftOmP4bkqvbd4UlsQXkGvUGuwIpxYkL8FtMOYjtPKGS0EYMZvvj7Jsb1ONaZwiAuAqSMKWuQ/imerPwB2ys7/ew4oAqb2ihCnS54yioQd0YqKuiKArvw5AuqyYHvq1TsCPjHiAd58KnMUJzDSeZJD80Znv4ZXKZ8MFgAjn6kI2A91hA2Uy00nnDGn1Z2mDsfxkpbaHLxDJsd/prp6OEv4wO9Dbbo6cW4yKcVp+ADYVyxFLLOB8/NpawOpMOtMYy9sGFvlnHMN+rCYZYchSF0KSzL/vr113fhvO37q8nxCyMjinOE+Yxu5fjhLdR6cYIvXiLBKYepnH7h2grrqS7efJGV6MekGGcQCTWEM9MyLnHwJuyhmWm1Gosm1TCUNWT+Vx+79daTiA9cZB8zekqiLFNDRVgWP0sgEGWJRpy5h89qyGzMxMNGw9Y41grFD1eJH9xE0ZAmZxqASE4R0I8lSIiKghUrA2s/wjDag/4cvoqbaIuWKItGx6JhxqnpGQB0/LMMbIJMR/9bQ2IrLlLQE9SzCdW26fdVU8+VCJ5U0a5LVXx8N7zKv4+Qc44Rlyu4mPISM1rUeXgSf9q+39q+/XdgV/Wm0t1Dw7o0TB5YOjQsrxQWUJL4JiBPc+iqYHnZfq0XD+cWg0G8wqG0CPPCZMmALUBBZxpp8q8hbF3US7vQJSPs1R6LzVRNEYLJBsr8Y0p9A7BkhbaIyCkfhfyzYTxFmBVFBkAPqGXdb8FhydCSMn41IDI3bfFjeKvCzNM60ZHGotWRagd/DNoMzqLM4LM136DVuPlwEvN8K8nQahILtqjxa48P7kCk28pDOoa5wmtVY+frQLfwHkHNfjE/uH0mGMEtVPplUUyAJUMjDU0YEnfWbotErhfPatjcbHFwbOGlxlyFZVFRAfIp1rDHmE5aNSKIzj/vMeSNapad6S2yGjhEyPSsEyOWb1dbg9q0rllt2dCq9h8aU30D+LqCSMIhPFFUxyfRI6ymaQuH34X4bszESQ7IoNgZ9AK34PPaVVeE7J4vJcNCtYqzeK6sbST5MiJ+GVucSEKDhns+1XlaR+95whKhymOTGMzerc8fUcHohkL1PS+vWu6VKNK8sdfck2KRh4kJ7HvghhvOQC8LlyxWzwyj9zQeNz/qZ8Udx9FN1uFCRpSXRQsFmAlDpvWrDIt2zELAn8YCjNVL5P5EtlfdY0Sv0SovpRqjQdXT0aB61zar3jVNuH29Ua3qblaNTWF1zvaYuuu+/epg/3jeoTeH0PxwVDUNlPiFlP0VN974os6MVSZkm9kUU4S0hHTerqoiJDdjSc5f5HI2n1z9oRbkkHMmpUun9BD5c5eJr9rR5k+0KF9nloCFEnP2KyralUTEqp19zl2//t3Vztxx3OTCm2bsRhSaHU83e20conLhYlVXg9qyrlWt74mqluawHsaSY56Dn4mn1fRMSk3OJNXkdEpNx5IqnoR6nIUihCYMh3yqMRJUzU0htWE1FF9Xk4o2BFRDJKCi0RCG1fgeCtKJJ2ZVW0tEvfl1m9R/3vmSGp9MuCpDDsTHEpxWqa7JyP5/I9ZseQCuuJpWVRE+NjKn9qB3v7A4qyuMYmNjJVqHWZxLulHQyGm+SlVsnB7dipQAG5UYEybOdOvGh02+chmAhKnYHsHncePYf1eMoQJkXe5sjajzX9GlLj67R63tadRKjYqRvbF5tkFo/eswerCccWfVB+h1xhCQilHPJzIeXvSAxReQZ1UNN3r3dDWqSy5ep3b87ADS0omRYoGZTqFXxMDuJAvCFEJkZP95W6xMQbOZCW+6Tdg1+qopQnLxHK4kG0dZcj3U5Mo19Tp4jGC0cXabUk1UhHVIz0tiRUiAjUceZigL3/a+961F/T692rnk1hk9BVjgbc2VYm5bueDMbnXFxWvVlvUtWDxB3TbCWeDC2k6dxZ6azk0mV1k3FR+UnlZsUIDMsJshzbbNHWrDmpOq/+iE6xFA3EOleG46GqqamqFuOZ1lcN3NN2Nbh2aTrDKzJssLM++WmQy+ehwiQvYE9dJ9gUTr6Y35Yk8B1lPgKy8tNrDsc8mWLa+vRRZnoAh1Ty9P5PRvxbD3urds0YqQPbdkKk+bxwKJpdysSEnJOUGdHVEbWjtqdWgRFfFLZdyOIfJ5Z/WovqPjUMJUogsDsveZwBaqqKqqmlGZMrjFyki2bPIIYiFvdgw7b57xJOBJwFkC9ubtw2rx5c6klWHZGzR7dfbY2MsL43tA73jjJnXRK3v0y53bWtyMH98UCaAnFkAYf9B6ArB9+BIdh7w+KkmtKEtTgpIelfCa1c2YMwxrBS540ybPSS6HV9lkymBB2VSSzBJShMiXvJ2kkGALrpJMemE9CRQpAXvjYjDi5IEyCtVEEVo9NXcuk9g7eMVFa9WFUIL6QoY8+sUHBUjll2/+zj2l4nyohDuxrYZfb9SXrdiCWexxLrP6KwbhYPB1meSkXNzKzcaVu7O6fVb3dBb48G1EJTeHD9PMYVKVdgr7jlI4o5gaG1GpyXEVbG5RwfZOFe5erQINmAzGqQf91rQmQRbEWQ5CS9BJjOVEVsMwbll2GpIUy4ZbnMWGX6F0bo3L9w/XXtuJWttbi3xnt7A4FAqVzipsZ3n12at0r5Arwa4G7aoe55PZDhuxotzVEVUHsJXGyciijpNfJTgsCG1kWXzqjjuGbPGYLTnPq8IWCs7FUYTYJpCcnFCJ4RMq1veymj6wR8UGDqskvnkwp7cQIA+sEJlWHmxsVs1nnKXaLrpUNW7eCoUYAR1miKtg+KZ12LVQhZirFwXFEMTkq/0NTxHxEwEObadg4lacnEMqSLrSCfJJgH7yqCu3bq36IokIt7e1FZcYBFQciwv2FkyFcho2M6/DynAq35wgIqMStNcTSaPaNpXhKuwx5DabBD7TYa9LjcEQPvtpHdmsdtqZsqAilPKhbRedJJvPT9PUXxFCWuztDf7kDjX25KNqNj6DFRZ24zPDYGGddqaFk374sYfU2LOPq67XvVn1vPkaKMMwepHFbTcwozRhvlmPDc9YhWh6LEG4oy2iOjAfI0qPJTuF/WAnR+OOQ5NCWeA2i57OBtXUsPRvPy6Ulzr5+zobG2umCF/V06Xe1Lte3XOwL1vvmS8OO1uwv++cbR36VEi6QAeAc3f1MuRtNRUh6lAcewZNBYwWrd6yYaNqCVftToqcbGXK4tEcZAWOuitCCotqO3ZsAENibMiEQitoEMaPN8tsIqFO3PcjNYueY9flb1GhtRillNmdIx88shTDZtMazOcWzFIpBLPgcyaWxr4xyC6jCcl/LD6rN7nqd2IpEYJ2DpmO4y3eWNXTsiUysbTJTY2i4YZQqGaKkEPjX9+yST12fFCdwOZq6drQbmkMYZtMK84a5xkSU5Ymx3WQLdtNO+YJuYhjGvZKz+/qVme0dZjoqsJGWZi5JiyiKyk9dMPqaCCgWcwHHrn7+2oGX7xS2LFeipGVruHHH1GD3/2amtm1U+96LyUOJ1pKb0k/YA7txNEQXxbvLvE5JnLqIkW0WgINweC2WoqiORxSV/RuyJ3jQ7NuxmkA9t6dFiVqyU+huPlSbsaxuzBuojFHKmFUytf2rC0UvCJ/W1nklFM5EddVEXKh/sSvHlZDOx8CrwXebm65gZB53Cdx8oQau/+HKnnyKLYD1GYewo0FD78iJWC+GkxYMotOuA83SNTWnI8hcggdBjEEO9DrWqpX9vO8cmMDjuFlJBbANNf2ji7VXoVr+kUGTnamLBzLyaB38je858F5ic/jagKxNxcbPKYG7t+hN11zjqoSw31SqaHjKrbnWfSFy1SqlTDghV2pEnCqmBqHxlKdy/XySK41ElZntrdle4U88taOOULpceUJuihe5KsJQ3d9NI9jEyC2t7XrhZ9aMmSUhWt5lZJ+3RQhV4NPPv4rNX30sApAiVViOJ/C64Q4KKQiTONjMXo7TiWRemE9CVizDCIHaWBiczGg5h90wQWkanNbq57u0MoPiiaEObiyJr4kJzW2I7ifUBtICn1DfKskWuMUOVWUUxZSRmIzfRMuyE9lGqlg9PMEs9gWcPLpnVj0sJLkRKvcsssC5wWl7CXyQSbxWGHpx7kI2tR9fPM04Kyl9kc3PHG0X6Unx1SwE3fpFZpMnmcHEM5s4qI2FqLT0n8O6SI7uHWGl2GarYHHl6LYtsA8cHtFqYZy1rcMQ85lBC81ueVKbzYmLMjmNL6a5ImXn198Xpc66/WtaiaRVDufO6m3TtUksSpEynnLTdjaw200G9e1qGRsTrWdwAIoriyspcmURU75IL3SG0KGyfooQjS6BHptsRODSBYwtq1wBQx7qPVtu1R8bNTYDG/lBcJl46SyC+A4UDM2bjZhwrh3TYveSrDrhZMIi5uWQTCLrTXpCdz2UKIIGD8VTC+uHVouxlR45J/3xm2OVtZJ8ZRg8aWP6thcYjUrPnJSIoGpVTHVuiqgGtNs42G1vrtJjU4ldH0vLbL6UFMR8gIGtlUaXzvm8LtwKewetF3nfdYWYYW/LIsKo8gJXhdFSIUVGzwOZYXNv0ieilD38gBv623B04ZVsSiW4f36/rQp3JvGrR3cEtUQDuqLIdfhXOMqVAoE1Xervbh/JNv3TU9wI3Z1NljnSMdzeBKoowTSoVmVaOcpKySa0bjcXtuFPaT8Mhzb0VI18kJluw5hFTm1Bh0VKEKM3ZYqyzl81UUR8nWRQK/NOjVipR+B0nvHlVtwn1q36sC9ahQgJvrwbw2NOQS2DHp98OJyCL/ZwB7iJRetV32Hx/WFk4x7dhr9cA6Ll3BFyWTGs5axBFANOeDrrFUWklFoQFb7jBKUdNjr8mPqaCkrQuGVNkd7nETQR/1qtI6ZKQsz2Yrg+ihCsMgNvDIZlcaxtje/brO67Lw1unDjibRe7OBNGdqwImQ7eLm1gmHXrmpWnTjjeOQYboGlArUuZCtLERY6wG4xtPi/3D5h1/PMOhtJroSK45Xtzc9je8WRe1SQAKYmJjE3VTNFGMCN0Zz+WC4Kz61SsFbNYepK923ciCrEsywqjCIneH0UId4QTes3qEC0USUmJ3FjRQOuEurSBc6GTOPHwkcprbIXE7NUhDyZEuzq0cf0RNHm5NDFQaXCRZIjg1OwWflcCJcImsOjbshN5gnJ7yTmjo4Nx5Ht0lUhG9va7gZs1l26WzOWiOizbEDOk7WsKIEZDiSdKiKxTvgsa0sK0KM6qKlacqzLooq5rsv2GTbUpk2nqa7zL8YcYFofF2rCAkhOV6ZEqXVCKfCIXsMrzlUNZ5xTxlsUZ57x1uKz1JUgXxacVzVrFhtGnF8pK0MJsv5YcVpv7SrWpxUdVbV7IXZh+dL40lwSt8fYKyTbRontwx53Pd36S3nsr5X+fi6azWqXRV0UIXPnx3G6nldfqleJO1t5LId7o8qVFA6iN6Mngw+sR7dfoAJtnTnzj0VL0yP0JFCCBND4TpRAXjKpDy+1wBQuUc3Oj89HsVyGy9ThXAsIVHXgOi8HgapdFvUZGoN7CueVnSn1hg+ci71vUILsyeCK73IMg67DPOH7f+ccNbAprPYmMTwsJyIvjCeB/BIwq9VcPJ3eG6nwMED+5PBFuRnsa/Wj95+dI19WnUG9QJKawcpxqry2nV8+874sC7hyymfet3SoborQjz0B26d2qY4NLShZa+O0mYtSWW/A+cZNG4KqTR1Qx1Kb1UigA0v1NVqiKpU5j365SoBVUlqwwNlqOpVI7Gut8RnaQCyAPYMLv2+8XAQaxKmH9BS0uL43UURZfe5ZFkasUkZi08uEDVJnsG5DY/1d1ADm9dAz1NNa9nkQZ/7yYxFXHJtOZ7kdvwJTksQqSKfcoORPy8whgnJ5LzecAwsrDeUkGo07MTFhNr6a5NvPjdQ4nUGFImbBnKF4LEE7iJNOfg6LsQJeSzM8NcUeIY1reVnexf3WrUeIJQk1HFml1kz3OXJeHLu5VFikV2OBdjXjb0DsTvLIpTddHJqHUWhNOJ2hj9iZnksNRp1qBp/mwgjhxmgAx7ACivcVlmo4DxXFxldW19JDl5rasqCnGKT1mrAwP/eTffv2nrtunbhrYvugQIIzaJZNWMjDi56GbUcYq0miVYqUfRsuwvljEGSNK9WOPXv4UnJKxcSZcN5c1lcRhldh+IqLUCvswUmOqPxGoQhjKoJvDhiTKkJQwOYVQqu7cEC8aHEViLCG3lRcZq+QLEcjQVzfjt5wmfzrOIvkmb0SJpPGuUiecqDhlUvc4C5boDRyZf0wy1np/vndd498+vLL+9FX661ZNqEIQ5gnVCFenJvSyfgTmEpqwh7DzFazmqVdYcSsDzOTCRXF8L6WBgslfSwLI42ccjLwRYN1U4ScFxwLdaqJUIcK+mahutIVzemxWcb8UTUaxC24fBVlq2vRedeEetixHF63LtmqB/9csRyfmFJDI6PYuzilYjNxzU1LcxM+6dij2ttbrSkPFx6XKZo1SmqG1K65WCLxUGM4/J5a5YkJhrByPDEeU2G86GYnMHJJoJnidvLErKUYa5V2JfGSb44vguMYGuPrG7U0sWTyYcSfLRMjLcEZqOLAuilCH84ZTwdb1YOrr1GnT7+gzph6Hlkx61pxDAsVQ/aHN6ijobUqoA9nio9nV1MCVIIJfHz8uRf2qBMnhnQvUPTDseMn1eEjx9RpW3rVpt51elO8OXyvJh9LIC7dyIZjsZoqQubTHw+o5kP4TGYY22mm/SrZjQ86iUpeAoKws6D7IRgkzB1Kq/AAGC1bHdljdnazDDI+VUupboqQjM/iLDHnCUdTg2puiu8PfMrTOa8FsZiJUCPBLpX0BVVwrvw3Jb8Cx2N2S9lwhigUslba680nFdvRgUE1gt5gEFtHcvez8bspcbV3/yHV0tKkerqxn3Npi9JJfOTYTc3QTx6GnXtgz57//t2LLiJcUxOIY3M1O94UKIbL1sREgSTJ6aIY8Ic25JuGIOuwcYNlgGxKbqV8xO0kgXx+mr6uipAphmYT6nh4nZoKNKn21DByY80n8Cwyb9ooxnCbzIyvUR0Ori+7N8i3GM84D5yYsU6XFJPwItK0t4ZUD85X13OeiEpvZiaGCy4GMDeI24AyK5nEU0HSHcK3ptOYMxwaHlUd7e2Om4EXUWzlJG02GlNB6gb3oe997+h7LrxwHy4H3lZO5CWHgax9STwOm6wd4zK5dySoPpJCYrKBGu8dJOe4w3QfyyCTpD23uowyfiQv2tRdEfLNNhlsUbtbzlcXjP1SReZ4VhaC5OWE1oWEeZnHZ2JUyhdSu6Pb1TDmB+kuz6A/irdXCj86/fIiqUsoKr9kge/Z1oqRJC7UHR0b10qvFd/ejUat24epCAlTER49dkxNTU1DSacxdObqdq24qXm85NxUfkyQOHm0eyIev6u9oeFTdNTDBLFYMo1LWuUFlD/NRRA+JOZD8/WjR1hrQ9kjDcmklIu4zeSdcKZ/Dlx3RcjU/Zgv3N/0Ct3LePWJn2JS2LqGaxbKUF++kMPivINKb8YXUY83Xaz2R7ZVoATn4/SgAhKgVkNFX7t2rX7MXiFDUiHOzMyodDKxnBWgmxDYmEzFqBvXE319t77pjDPqpgjZI1S42y/ciQ/AJ/JPA2WKyy0/NcP7p8FjftaqkjZln4nIrujs7pLSK3IwWlKcRRHz7XYSp0FGT07iolVrJz17hWxYbiYZi6mRmF8dxiLJXLHjaLfIPHwREphTEbyk1q9ZoxqbrJu8uXWGZUTb2kaDY2H4iHdPTyfsZd0bdJMHK2TO87ZvfWtvMp1+0i1AtfFUhOExfDIduoZPPjOHTsZ8hykfZfX8OGIJ4t7lWhvKnLJHOjnlkXFXlPyiKEIqQX6sfQ4XqvKkyejQlBofm1FJzNml4wlsEM7cYK0bHIbCuLFmamJaxSenuJENV/OPY8NmHWZlKxLt8g/Md1IQ0xVr161VjY2NGcWXmy82vLa2NtXR2bGSeoRmQ2OGxZ2FR2Kx23IlUVtXcBxnkMewKhvKP4jjXHs9m0Y0ElKBYcwXjxXQ0FUQT0bmC8oiE7XgaZdsFkURsifR/9BD6vl77lMDk1gdwzb0ibFpNTQ4roaHJtXIiVE8Y2qYbtgjg6MqHYurACrB/oMjatf37lDDe/dgjF05+2zsy+UpuXSrFIAbZblu6WY4XObLbRkbs/GYMLNkuglr978//fTtgHGGoj6Gm6qjAyE1G5vFVHqeeq87D/XpJETwQfrkcFpF+lD+ppRqI5JYRuaMPVsOmaTsqZtuE3blLP/rxTVYmR5oLAFMrh9/5hk1+OTjKoHe323DAXX1mUpt6cD9gNjKkkpZiydMgd8wiWBTaRTHy9jQ7n0+oR7cM6Ov6E8++IBq27BBhTBkY6+yVMPhHY/YtTeH9V1/S70dtzTlHrErNb/l0lPJNTVGsKgUQ4/QuU7xhEpYb62xXirlprWEwzHjOc+f33nn0EcuuuhmXMLw+/XiOziBW5v6cZCgN4WvQeY5acKFRyrLGlVqtkV+PTE1kVKhl5FMvPYvwfF4/GbK3F4OGXfFRVAbRWgWQKa7xc95xoeHVWJoSI09/zyUV1oPu7CBXv3oBaWu2u5Xr1xjCdTaloGeIgqTx+B4eeo9zybUw/tTKskyxnAthWHyyK5dqrl3o4pgWObDPJX+tjHSZiy6yTLtPIZxd3fwwzggqn1Z5uGksBev6i+QncKRlEnRGI2omVgSewbxYSEwYfb+yBO/u8vD9ovFX5nZKhTMrDxSpYjLPnfv3fuV95x99u8Bge9X1seERtEpSPnV9PqECjTiwKpDJ4BlxM6Bj7e+18BQGKmT6Akewt7Wmdo3HKSQoKyRbFb2Bswcmni6SzbVVYRUQmiws9hkO4veXmpqUsVODqkZbK+IQwHqeUEWHCdXQxHMCWK4ixfXONZK7twNfCCsLt4c1Dh2PtC2cKnAnLr9qYR6vB8aEDgZFUQbGtT4S3vUxN59yofeSKSjQzWs6lENmNgPNTerACb5/XhMnewkHTbqGtUXp+SWJY4ybG2O4oQJTjhktB3lRpifRG1uopxr3yDqKDw2LDND4qZNQ3vu977znSNXf/GLtzWHw+/T2Dr9BDGd5D+M6fLNaBPoGTqZNObVeVN0VcsFSfmRc/9RjKb6ETc7EHUwE4nEbZQ1ktJyzyRploXJheBNXEG4uooQDWPqUJ+a3P8yFOBJdJ0nNOe6MMyGAjiK75dQEdJwryi+4Kl+8ExCTcTn1JVnhhS/Zz6CCx7vRk9wJ47uoEyzSo23XYcbeFkC3nxcacYzc/Somh4YAO5pFWxqVJGubtXUu0FFt25DOHwWQHOik/N+SpAAy47P9PQE9gpOoecXwjN/wiSeTuHyBz8+u9rsuJhSQlKLTcoG5KxVLM7En3b2eXDfvi9ffdZZ78ZLoTbdLxeppDA0Gh2eQifAr1raonr0lEOKtjGLF1cA83hVMagDaexlTOO4ZdORaN2UIOpemjJGHrIyz8DMFnH5TCH/bNiqKsKTz+9Wh37+sIpgHlAPU/lGyiZlAta2jBA+vJTE/jMaKkMsGqsdzyfVJJThebh09UdQgvtOYnIYSlAMeyGNTc16g6/gtJ1psITTOA0x1denRvftVU2jY2q292JUcdRThPVMcRLQLy/IK46e/eTktHpp3wGUVUp1d3frLTVcQImj5z84OKgGj0fUGds2q6amqFaSTEF6jsWltmSp7BWG7pznHTfddGDo85//ZmtDww31zAWquzbTU3Fstk/j4otGfE84tzlzeDwLP38RBxXy8c5mk5jGro5YQkV0Y7SLJV/oyvzGZma+SRkjlhy5u7jLTsxQMWXHYQWEtAZ3Pa0mRodxfRCUm5SUW7Twj2JLhtlgqAyZ25+/NKO++dCk2nM8maMEqci44TocwZRMvvjhx7vcJsbH1EnMRybx5by89G48noJ4KkBuVzo8cEw9/+J+PPvU/gP9KoHeQAJbnoYxz8tV/xj2dFIJEjeDFf09+w6p53bvUy/tPahODJk3JC1bITq1dqfGOPsXP/7xl1CP67CTzlmWyXhKDWE/7tSkNcIyqTg3z4MK5Rg2MW5lmxjBXt/xKesAQx2Wh4VXypSyhZuDcCfZC6nYTmUmfnnt6ilCJBMfGdHcTo6Pqplp7PkrYNgjDIUjoMIQF0pOD7ug6GbQyE5iX+EsvlLHI1tsnPRnLrnBlzgqRTeTQE9lHAqZE8lpzlemMO72TFESYEfjxMlhtReKbXRsAqdGrB4Hh8NcxGIv8MiRI+oopiKoBIlj75A31Eyh1zCIG2r24RIGHrnjavIyM06Viri8z9ceeWS8b2zsc/XMq+6xGwlSYY2NTuv9uDwXrv0z4ucQuRRlyLB84lgc4zY2HmSIRDCiqnNxUqaUbSH5Z/wNaWjQqSztNFl3VRWhxEodNYlNz9PcMC1IBzuAxtWgz65i+wUUXFt7h2ppbcO2GWzSRHeeuI7OTo2j8iN9BHOD9kpgRh2LzaAyjKLXUt5b0IzrVIRx6aUeDlOxpdCboGHPgAqPypBni60TJVwtnp8vZJnwZZVEuCR6j4yn7i1Hc1vVH6fqS9yCZ9uXvnQ7Pij0UFVTd4hsEEfsBtED9KNnxnLJMZA59+Ny7pBD5llsRxOlNodevj7PjwCCW2DjxUUcy35idEoNHxtllxDz+ZxntBJjmuyeHcYuglFu4aiRoSwpU0S/QNYZnD1lp7Ky07i6cycVXMnK85gcH1dcvWpuadUCtsfChtMAxRaEkguiUbGxpSF4Kju+1dhj5NxeAxZW6M9d89rWjSw3NqLiM9NqYmJMN0gWqCXDXDrPVZwEKD0qNcqRCpCGio9lRkVIPN2mIT1vsOZplBVm7I1MGqesm+rK9sPnnvvkda961QPIe3st8v8gFNwODIH5ZYaL1vrUBY1plANqucEdyyWGI6txKCpua2KHIoj9uFxBpi6jvzV/T5bnDU+jsNfIYTZ3B6CxqZamMMLOlyU7+GPTaXXrkVH14khKteNquI9s6FRrsde3ymaUskScppzdhsdG7svnouo5MFmh0DlE5llUKjM2IrshjVy6QD/S8AEaBkftoBjnoAw5bKZxioP4FIa/k5PsRVuFrYEif/jNEt5CU6ohixEsbzsNARN4W3L/Y6mG+dZxWgLIBmdMvDbMbVNzlrBIgPsSw6jktmR0Q2lqjGITtdXzphIURcioKX+GZUAOian4WF+tKQw2JvTyGyLYcLs4G8CLzH4+Mopa174Mkd1NNHGsMBxRCaze+93v9p2/YcMnT+/q+nfgq2qOYZh698kJNYK7Cfkiuu/InBpC/XrDadY2M243E8M2RZPg6iN6kFr5mTnSvrkIHTzT9hoagjhS2YAynachODg5q+7Azo6XsK2ZPhPJABTzhLp+datqrOLLb+/Q0CcpSyRBGZsKUGCdA+PHyL3G2t0GqTNYU0UoSSawTSYcwQeW7K0uQ5Cj3GxZ4BBL1zatHK2uu8QrhUd3Ih5zVJK26CSotsnOdDytjp2YxuIKlG+Ob2EHWFId+Fh9Vzs/HjVvZlABjxwvPEc6HyIXYpzdiJPx0/A6/gnsLxoYnKb+qYph3Gu6o6q1Eb08I0aWRXd3h+roaMti7WkKX5YOELJ5xkhPJZlTrkK2fG1TTMwFM0yc+cy+8m/+5u6TX/jCN9oikY+SqBoGW2nVT3AefxhKMJ2ZruDrZ+dh/T5Sl2zE92vQTzCVIdO1ys0ql/kyE47ms0M/q8xwiggnmHh5hmm4UDwwPqtu2ZlQB4d4xC+j/aGQHx5NqTNw8uiyjkYzSNnwWDz+DcoQEYjSM+XLeE33fCbKTtEKSB1TNeNW8fkGc/OzJ85D/KRlwegcs88OB3GcszIfroiJcZsTRHPMUVJCL3Yab1VdgZAYK0SpTwr3BNrzxmF9qfGY9AvuHoQs+KU69gZNukph9lidahJfWBzeykOlZj6Cl96iZefSi3yXqW0Xi+kmnPe56tvf/nyiSrfTMKEnMO/38xHc92is/lK9sY38Ev2m+/ejd4YFYzlsUKzMWX9oQhg6NzWFsAUnskAJcmT8Mk6R3PoYlOCwpQStUNYvo/g+7gQYwFC8UkOZUXaIJ698M/6SXCYX4nSs0llPNyBX9btRFYFn49l+xib10C+f0XN9EoRKIogCFOUgeCebcWhFB3rC/Cg8N476/bNYABnWc1b2cE3NLXpzNuNPGRWFdEmEPbu3W3W0WJuv7WE9tyeBEiXARkcdRCMNkDZ7L1nz2MGD8W8/8cR7/8fFF+/ATdabsx5lAExsjIsSOEQwh83rdkPl9xTuax7BB5Ou3KrUenTksUbiakT5cdgbxrQOlaCeS4Rb/CQwe4KPHsSQ/NmUGp5GO3boNrF9j4C/uD2wRFKkjZunD1JmlB2CMAfmQxnLIzGK/MVdkV01RUgu3nvdG9X5527VZ1KpyCzDK90hcMwTFmPY9ed8n65viCOEuUE/SntmenpBz4uysbbghKEwrYl6SYMFxLPKZ57eq9paeYWUu9y0hN29JcoFdr6yz+e3IKIiEeXy6RR9LfhzSmcZ4yhuqcTMhrjtNUXctLPPJ26/fXB1c/M7r92+fQfaQg8jKMUMo7feB713CM9Lc9xi5j7VQgV1EAu89+BCprdvV2p1c64yZFNke6TyY5sI43vW1rYndDYw38u6YNYHZpphHtqbVPe+kFS8D8BJCUp+omjbL6WgqNFs1wWxAMrAJRgkP3jnCy+8kzJDsKwMC8BMgbSmsbtNv7ywznOGQmDa1P1ic9mI7kB6emAYtquZV35OJPM8Uuj6M5QoBO5/ssLN+y+sf07x5eJ46cIctm04GfvQVWiYwSTSPzEahyLN8xqVADabA0vO57U05ip5LrwMDsfQCzbzZAucx9mJOJuNuTvKhwslgyPWDTDku1LDM+E9GAo1YH+Y2QgqjbfU8IHGdZ0IwykvFoDYFBzdtOUBuKDiE1dL4yRq4gRP22wr4iZOPw989KPnXrZly51wt+BZYPgFBtbaGbyoDwM4kJxTByEFLMoqgPg4mZUUDwdM4+x+vjbG6ramxad+61UhtbXHugSDwpMwVlScZ1/ARhbBdTDG8+iBpPrhLmyiB09ccHYzbFtt7Z2qMdqgwggchnsdzj9vwZzlFqwqd0N7hBEnwKzQbHFNPHzgwNuv+MY3dgFv9gKl/O02gzNbfOzGCWencXRTJHxoBKZtFm7RilDHkueHbx/pmXHecHx8ApPy7bqg6C5kzPAmLd9uTz79rDr37O36TWf6FQM7rfoWE440rAhOiqTacerCYS2totGXeFYxvnKiWuKKkFmyC13cukgy/gKLAqRbYP8Tf/RHl5y7bt13gWvhwATrDmoK9hC04EEovH7Y/dB6cxz+GpXJAjlfzs3NMRwSwIEFwx/xLTD0bm2AMjw/pM5dh5V7cFIgSDYOVi/snsFVdwl134sprRCZkXwmiC1u3P/LNigK16THXhF1GjRhLxRjLxRkK6TSxMeKeGLXwMB7LvzKVx5BGCoAeajQTJhu84FzgSKkf9mG7EheBabNQhS7KoqQQhoaHsEwtUWFsFF6x4771PnnnY0J2ja1b9/Lqrd3vWptackWNAVrKRmrInCbxhj2JXZhg7WpNNmzPHLkqLrnJz9TH3r/ux0Lo5B0ZlD65Wx1YbzRBiwS2F+ZKJJpbFsop0dIoTdi+4JdkXL1PBbDXGuxtbpAprkFhr1B3TMvQFtLb0MRSm+QDYCVWmxpAGSjosrOCMowLBK7ERxt8zHbjcBsP75bfv+j527ZsPk/B2fVqkNQegNQOClM+7Bc9ZngvB0BDl95cgTX2OFkj5PCMRmkssWFQOrac0Pqgo049w8OC1UbzjVO4Yz//S8m1c/2cMO2GaMzzPbJAxA8+++moMkr9y368WkNttt2fOUJ1wiojUHfYP+Rg+/64Dd1T5DlyvKnbSpAex2Q8hfbZMwJZ/rnhaUQSSQwbSlE2nxYmAWHxqBZYCgIbrTd9SwuHYQ57bTNUIjDUH4H1BvfcKn+aHgEZ4fZM5S3CoX6k/t/rtatXa1ecfo2NYGzwo8/8YwOd81vvg0btHHTCRQjzx2zIt115w51ztmvVFu2bHQtkAWMAcEKMg3lcnwYHx8qYxjLytXWElLdbbnXUMWwJWcAW3LKLZk2XBbbg3sSGT+N3j4znVRHT3L7DIunCgaRr+qMYtOstT+zCjGWFYWLIiylAZSVbomBnIQuONrmY2870oZ81177/i1bzzznv1Cwm7nLwU15OPHGcuc8+WTmwIATjYmjMqRyu3xbUF11No6yAibOyXD+7xi6qXdiKPzsAK/vsjLkRCs48h7EjfFt7V16R4HgC9mZNn5w/8vPv/OO7910APTkSpSf2IKjbT6Mnm67ccLZafK63RZLGLEUdN4I8nmy8LiS++KefVCAm/Dd2zZcyJBUD/x8t7rktRehhxPXm3V7oPBYSjwCNIs336M7n1TPPbtbbUIv8STuMRyfmFQtzU0Ic6E+7J/EYkoH7h8cRg9zZGQMm7Ub1Lr1a3AlEfQ1jxKJBsnHXMaPH3enEpQhexFBsiRMJs3tM8CYwuKFD5V8NH7B5m5ETv7Ip73zmWWmRIC8c+/kEjBLgokCcrAXsZ3czIPAbNSm8d1xx00HrrzyHb++/ZwLb8Z2pAtMz0Iw63QEd3DGZqYcd0/Yw7NHh6lq9QB6d3x38mq7KCbq7EVOpXccSvDWxxNqP256KkYJMi227TDuCeDWqVLaGzpFT77w7BPvu+++H/CSCsqI8hIFKG7izAdOVyPydiUoxgNiKNqUnCADDBw5pnq6u1Qnb5GG0Pr7jqitWzapNatX4SzytL666UjfYXUUw1veqHvs6CAU3Ki64IJXqe1nbdfKkpewnvXKV+jD/Dffcrt67vkX1T07fqpu+s6tOFI3qYfLPMq3f+/L+lIAP45+8c3jGU8CNZSAtAexmRRhe2M2G/ksFcCd3//X30wk4zeWyhvrdAQntIo1VIb4Vz97KaW+j8uNx/G9Eyo6MXq1eSitvoON0i9nrrsjfTGGvPB4bCmGeWbeDSVoyoayk0dkKNGLjMUWfNVstx5hxQnwjcGe3BguZz1r4yuQxTl8rW5YHTs+iDdaQh042KdeeHGvevGlveryy35N3XHXDj0E3Lhpg/rta34Dw16whp5VA5TgvT/+mT7yw5tn2vHFtElc00+4u6tLtbY2qz1QgL/a+YTasH6tevKpXXoOcuOGtWpVT0/Bt1WxBZ9PIPY47O58YT0/LYGaVfAqypc82otWcMI//QmzIVPl0JYw4laHDh2K//NX/vdnP/DhP/lFe0fXV0Eyf4wHAdyM7hXihNZ0YDJnc7UbPfHsDZKBx/pweTFWgN+BFeVVWLFgz/CFY2l9+/vgJI9N5otloR+3w/HmqOJ6g3NjoyNDn/h/3/r7exCTyEeUHW2BxY82DW0T1kjjR/wMVHkgZSQFJbDYFI35cI6w6IvmKKDdL+xRW7du0UqMH2riym5f/xG1bs1qtfPxp9TGjRvU5o29as2aVXpxgAquE3OFnC/kSQZOrvLapzGsLvOAfxRDYIqFeMb/i1/uxHD5Yt1N51xhK+YOJ3GLMldDOe9ovxTASUQcbg6NxXC5JcuidNPeTtpTUgAACzZJREFUHMG53Nz3CT9CdXIU22fs45AiomfFbW+J6AUTIScunphVQ4wT+WQBVWo479iJuc0GbKqtWm0qkSm+LP3RtR0IJgsl5oQ52TIfxr5YrDJtMU7iFxxtE2b7EZzA0qaI91/19us3btt61ldwVvt1kkAhW+YKC9HZ/TlUXt/mU++8MKyOjM6pe3cnsEDCOWg7ZQE3yq2jo0tfgFKAEtM5qYf27X/+j3bceWsfaEXh0TZhKWfBMVrBCUzbNFWtC1JITEBgsaXguFCiCw+KENs2izOjY+NY5RpTW7adhquBxrQCDGOVbNdzz6u3XHmFXvjo3bAePcQT+ijXaihH9gCp4OxvGTYY09D92BNP4y3m10No+YodwwmtPQ4zvAcvDQmwWP3RdbyphQ1AlKE0BmkIYpPpqlZ+Rlimya2QViSCo23C0o6IE3iB/aEbPvNbrc3tX0AFRkPIb7iDAj2sonuFZmx8Oa/BOfbJWEo/+gINk6AImPcGcMtMXoNLVccnR//i2zf+zfdBJ2XqZrNcxY/RFirzqtcDe6GJW2ytAMEY7UBqeqAfHo4bQ8m9GJ4EeQq9v7X4kBIV0hAu+ly7brXu7XEbAIe9+7FlpqenWx09dlxt3rxR30FYrPJiRfje7Xept77likycVZeLZMWzayQBbg/CdU+/jLT0vg1JsBGYj1PDICdLqaDZRuxGcNJ+6C+wKD+6Bc6xzz331a2XvuGq/xkJRz+MrLID4mq4uZp3fsqL35Uw48G2Jae22DP04T5DbmkJ4Zsm+qLjQhEY/hjO5zkp5kvHEzPf+sWDO/5q166d4whmlqUoO7FNPylb2iZspKxB8bPjK3LnjunmGZACNSOfSyYSj2Fu7o2FFBaHpls2bdTzgU347vC2bVv01UzW/j9EjULhdxa4rYbfwYhgyMtbdIsxLHheDX/2WWdCCXYgKsrUM8tJAixDrIJPPPrYk3+a4Vsqv1RysZdTtsgr+WbbEf5NmBWVbj40pk16PxTHGJ7PXn31e7+5ccsZf4R5uOuAd9jflFmxRYeC93cWMmx33H8oF5PohJHiLM7yx7F9jFfc8Sq8Ygx7g7wT1MFg6j9xW9+BPV+5667/OAB/UXZiM48Ci02cPIzSDhNXF2NXhJIoGaK8hDHa+BbF8H9sWLf2jYTzGSpKbpRuwtfkuLxOYylBIxRoiOPFkQvW9A0yO8i4G3FX3jk4ReIpQbt0lofbh/nbmZGxH3/pb/8Op2OzSkOY13VNHA7+hteigtJG7EwI3p4Pk46KwFSEJjwHRfIy/P/4rW99x99ue8Wr/hDbVN6HyDBBLgZ7+KC8eIHx1NSEa6+QLxzeAxqL4eaaGXeFSQXJm+LZHuO4lj9fL5OLl1wxls4QGI/hmr2b9730zD/9+Mc/OAIOmW9T0bnBpDMfZo5uGrEt1/yvG36eokyI3W8pBEZBWB672xdqCPVfeslrzw03NW2dM67AIqHdUFBuW1go6D5so0kijvXY/8er+Usx+QqqlHg82vpLwM8z4cnkzJ49Bz7z6c98/hA4MBtDzSp6DXNqth8zGcGLbfoVgrUc9u9/ceKxRx+8P+iP3NTW0XkUN7l34ZTGGgbmWXG2A971aXUIcpNhB6SltV2f+uAN8LwgWc+lI4xp2E6pUDu7evQ+RbZZXmBiN0IXbWzS6eJAw9PTM1P/+MyTOz95+/f+9Ufg1T4MlnI1FaHg7DaT03k27AUs2BHVdFMqpmTEbdqcx8g+j9x/x9mv+bWLb/FHoxvnMESVN0MpTFHYz+x6To2NTarLL/+1siZ9S0nPo10aEuD+TsyaJEaGhr78+ouv/OvnD/OaAde5QaeGIbilkaF5Lsw2NI91blv0N9uXwDJfKG67rf2veecHT1+7pvc6DGV/M+Dzb+WxO35RUDoHlsJqUE3NrdnRGHXf0MkTWLRcuNbJ01lUgvychrRlDqOnJidwCxQ/tUs2LNPc2rrfF/D/6Hj/wf/8wQ/+fR+wLI9Cis7Nn5EyvFmmJkx/MW548a/YFmFLRJJrwUvhiCIk3n//vbed+ZpXX/QnjdHob6MAAguGvRJbHptzg+PYY9jd1ZktgDzkntcylgAbKc+bJpKJ3RgJ/NV7P/DJe3bu3FlICUrlF5sSMOGlJhFpO058iZ9pE5aHYaStCa6gfeWV16xZt+G01+HaOmy98V2GDsaGaGMzeoFWr00Yofx5YcMMTqXw3k7TWD3HNnxat8loh9a9oBPjI4cTM9MPT8dnHho8efihX/73fccQlmVQyiMJ2sOQDSlPsYmzm3x+dtqy3SJsiYBuGsGLLYWUVYgf+MDvNP7BRz583iu2nXZ9c3PT1T6fv1PeKFYU+X9140ABlaNE88fs+S4VCbCMUdeh/5LPHD859O1bb7/7/s985nNy5xwbiPQWxLY3FnsjsLuXSlaFD2k/4jZt8XOyiSv2YZx2Wo179asv69i27VXbGpubtoXCDdsCodBWlMEqbJFpGh0ZbU4mYrip0IeHZg7bqNUkXlGT0aamqcZo4yAWL/eDZt/05NS+fX0v7tv58P3cNywyp20+OhIbzvR3giWMk02c3TCOuhgRqJmYiSMsStCEBSe2hKFNI7Yd1p7ez4qVgFlxzYbADJvKTmC7bQ9jxsc47G7ilqIx67/Jn4kXmLYdFpzYjENg0zbxApu2HabbzZiyFdi07TDd8jBOge226ScwbRrSOhk3vBNtVXCFVo2ZiMkUKy6VH20WCI1TwQheE3g/p5wEpM7QdnpEATr5ibAkDje34JeiTd6lfZj8SZ7oJzSCEzrBS7siXmCxTZwTTBwN6UsxJi8C084HO/mb9Ezfze3Em9A6+dUMJ4ISWxJyErjgxKZCpBFb8MQRFmPCgvPslScBewWmW3ACO9miFCkR8ReYthiJS9zLwc5X900/gZ1sE0fYdFMGTjjB06aRMJZr4a8pWyfYqVwEJ/TiZuwmznTbYbpNI+FMXF1gtx4hEydTFKAbc9IrpE0jwrbblq/3e6pIwKwvhMUtsJNN2QheYNrL3UjepU2Y+TH9BDb9BaaftEOJh7YJk9buNnGEizEmHwI72U44xu+GN/2c+JBwTn51wTkJTxK2+9EtD2nywRKHaUt8Js6DV4YEnCqy4EzbDtvdIg3Bu7kFv5zsQvXf9BdYbOZT4EK2SWuH6XYzpsydYMG52YzX7mfiiknXjabmeBEqEzJhSVhwTrYTzh5O3J596knArVGYeBMWCQlO3LSdcKb/coKl3bjxbPoXggv5SxomneBM2y5f0+0EO+EYnxveTEtgk1Zwi2abAjJhkyETL7CbzXDiZ8bhwaeeBMyK7gQLTmxKyIRFYk448VvOdqF2Yvc33SZMGZhuE7b75ZOXXc6m24QZh+k2YbufU3p2eieauuOKFZpJVwxsz4gZxu7nuVeGBNwquIkvBrZLwwxj91sJ7mLahp2mkJtysdMUKysnedtxhdxOadnDONEsGs5JWE44YdDuV8gt4Tz71JSAU+U3cSbsJKFC/k5hlivO3pbc8uFE54RjeDe8W9xu8nbCO+Gc4i2Wzils3XBud54VEmAh/7plwEtoSUvArRG44c3MFENj0q8kuJT2lY+2FBkWoi3kb8q/FFoz3KLB+YSYz8/OcCm09rCee+VLoJSGUQrtypdc6b06kUm5bbJc+ZcbTvhdVLsYYRVDs6iZ8BJfERJY1g2pjiWwVNrjiiqvcoRaTpg61hMvqWUkgRXVmBZZ7rVql14ZLXLBesl7EvAk4EnAk4AnAU8CngQ8CXgS8CTgScCTgCcBTwKeBDwJeBLwJOBJwJOAJwFPAp4EPAl4EvAk4EnAk0CtJfD/AU0Goc7g2L5yAAAAAElFTkSuQmCC";
const Message$3 = ({
  buttons
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(ContainerMessage, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "content",
      children: [/* @__PURE__ */ jsx("span", {
        children: t2("cameraPermission.messageLineOne")
      }), /* @__PURE__ */ jsx("strong", {
        children: t2("cameraPermission.messageLineTwo")
      }), /* @__PURE__ */ jsx("span", {
        children: t2("cameraPermission.messageLineThree")
      }), /* @__PURE__ */ jsx("span", {
        children: t2("cameraPermission.messageLineFour")
      }), /* @__PURE__ */ jsx("span", {
        children: t2("cameraPermission.messageLineFive")
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "container-img",
      children: /* @__PURE__ */ jsx("img", {
        src: permissionsImg,
        alt: "Permissions"
      })
    }), buttons]
  });
};
const ButtonDontAllowIOS = styled.button`
  border-color: rgb(232 233 236 / 1);
  border-right-width: 1px;
  border-top-width: 1px;
  border-bottom-left-radius: 0.5rem;
  flex: 1 1;
`;
const ButtonOkIOS = styled.button`
  border-color: rgb(232 233 236 / 1);
  flex: 1 1;
  border-top-width: 1px;
  border-bottom-right-radius: 0.5rem;
`;
const ButtonDontAllowAndroid = styled.button``;
const ButtonOKAndroid = styled.button`
  flex: 1 1;
`;
const customStyles$2 = {
  overlay: {
    zIndex: 9999999999,
    background: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0
  },
  content: {
    top: 0,
    left: 0,
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0,0,0,0.6)",
    padding: 0,
    border: 0,
    borderRadius: 0
  }
};
const isAndroidDevice = Boolean(mobile.Android());
const isIOSDevice = Boolean(mobile.iOS());
const FakePermissionsRequest = ({
  handleCameraPermission,
  handleQuitOnboarding,
  handleDenyPermission
}) => {
  const [showMessage, setShowMessage] = useState(false);
  const {
    t: t2
  } = useTranslation();
  const handleShowMessage = () => {
    setShowMessage(true);
    handleDenyPermission();
  };
  useEffect(() => {
    if (mobile.isIpad()) {
      handleCameraPermission();
    }
  }, [handleCameraPermission]);
  return /* @__PURE__ */ jsxs(Modal, {
    isOpen: true,
    style: customStyles$2,
    children: [!showMessage && isIOSDevice && /* @__PURE__ */ jsx(IOSNotification, {
      buttons: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ButtonDontAllowIOS, {
          onClick: handleShowMessage,
          children: t2("fakePermissionsNotification.ios.dontAllow")
        }), /* @__PURE__ */ jsx(ButtonOkIOS, {
          onClick: handleCameraPermission,
          children: t2("fakePermissionsNotification.ios.ok")
        })]
      })
    }), !showMessage && isAndroidDevice && /* @__PURE__ */ jsx(AndroidNotification, {
      buttons: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ButtonDontAllowAndroid, {
          onClick: handleShowMessage,
          children: t2("fakePermissionsNotification.android.deny")
        }), /* @__PURE__ */ jsx(ButtonOKAndroid, {
          onClick: handleCameraPermission,
          children: t2("fakePermissionsNotification.android.allow")
        })]
      })
    }), showMessage && /* @__PURE__ */ jsx(Message$3, {
      buttons: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(Button$3, {
          onClick: handleCameraPermission,
          children: t2("fakePermissionsNotification.allowPermission")
        }), /* @__PURE__ */ jsx("button", {
          onClick: handleQuitOnboarding,
          children: t2("fakePermissionsNotification.quitOnboarding")
        })]
      })
    })]
  });
};
const ChooseCameraContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 99999;
  box-sizing: border-box;
  padding: 75px 25px;
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
`;
const CameraSelect = styled.select`
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 20px;
  margin-top: 20px;
`;
const PreviewVideo = styled.video`
  max-height: 60vh;
  transform: rotateY(180deg);
  border: 5px solid white;
  border-radius: 30px;
  width: 100%;
  height: auto;
`;
const ChooseCamera = ({
  onCameraChosen
}) => {
  const [desktopCameras, setDesktopCameras] = useState([]);
  const previewVideoRef = useRef(null);
  const streamRef = useRef();
  const [deviceId, setDeviceId] = useState("");
  useEffect(() => {
    return () => {
      var _a;
      (_a = streamRef.current) == null ? void 0 : _a.getTracks().forEach((track) => {
        track.stop();
      });
    };
  }, []);
  const handleCameraChangeClick = () => {
    onCameraChosen(deviceId);
  };
  const changeCamera = async (deviceId2) => {
    setDeviceId(deviceId2);
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: {
          exact: deviceId2
        }
      }
    });
    streamRef.current = stream;
    previewVideoRef.current.srcObject = stream;
  };
  useEffect(() => {
    const enumerateDevices2 = async () => {
      const options = [];
      await navigator.mediaDevices.getUserMedia({
        video: true
      });
      const devices = await navigator.mediaDevices.enumerateDevices();
      devices.forEach((device) => {
        if (device.kind === "videoinput") {
          options.push(device);
        }
      });
      if (options.length === 1) {
        return onCameraChosen(options[0].deviceId);
      }
      setDesktopCameras(options);
      changeCamera(options[0].deviceId);
    };
    enumerateDevices2();
  }, []);
  const handleCameraChange = async (e2) => {
    await changeCamera(e2.target.value);
  };
  if (desktopCameras.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ChooseCameraContainer, {
    children: [/* @__PURE__ */ jsx("h1", {
      children: "Please confirm the camera you want to use"
    }), /* @__PURE__ */ jsx(PreviewVideo, {
      autoPlay: true,
      ref: previewVideoRef
    }), /* @__PURE__ */ jsx(CameraSelect, {
      onChange: handleCameraChange,
      children: desktopCameras.map((el) => {
        return /* @__PURE__ */ jsx("option", {
          value: el.deviceId,
          children: el.label
        }, el.deviceId);
      })
    }), /* @__PURE__ */ jsx(Button$3, {
      onClick: handleCameraChangeClick,
      children: "Continue"
    })]
  });
};
const Video = styled.video`
  width: calc(100% + 20px);
  margin-left: -10px;
  max-width: unset;

  @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
    width: auto;
    height: 100%;
  }

  &.selfie {
    height: auto;
    width: 100%;
    transform: rotateY(180deg);

    &.desktop {
      height: 100%;
      width: auto;
    }

    &.assistedOnboarding {
      transform: none;
    }
  }

  &.desktop {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: rotateY(180deg);
    overflow: hidden;
    margin: auto;
  }
`;
const isAndroid = !!mobile.Android();
const isJ7Prime = !!mobile.J7Prime();
const isAlcatel1x = !!mobile.Alcatel1x();
const isLenovoVibeB = !!mobile.LenovoVibeB();
const isDesktop = mobile.isDesktop();
const imageType = "image/jpeg";
const reload = () => {
  window.location.reload();
};
const Webcam = forwardRef(({
  className,
  onPlay,
  videoSource,
  screenshotFormat,
  isSelfie = false,
  permissionMessage,
  permissionBackgroundColor = "#696969",
  onLog = emptyFunc,
  stream,
  onError = emptyFunc,
  token,
  onStreamReady = emptyFunc,
  showCustomCameraPermissionScreen,
  assistedOnboarding,
  deviceId,
  onRestartOnboarding = reload,
  showDoublePermissionsRequest = false
}, ref) => {
  const [showCustomCameraPermission, setShowCustomCameraPermission] = useState(false);
  const [mediaStreamTrack, setMediaStreamTrack] = useState(null);
  const [isBrowserSupported, setIsBrowserSupported] = useState(true);
  const [isLoadingCamera, setIsLoadingCamera] = useState(false);
  const [isAlreadyPlayed, setIsAlreadyPlayed] = useState(false);
  const video = useRef(null);
  const streamRef = useRef();
  const canvasRef = useRef();
  const fallbackOption = useRef(0);
  const {
    t: t2
  } = useTranslation();
  const [permission, setPermission] = usePermissions();
  const canvasEl = canvasRef.current;
  const permissionsRef = useRef();
  const isAlreadyRequested = useRef(false);
  permissionsRef.current = permission;
  const [showRealPermissionsPopup, setShowRealPermissionsPopup] = useState();
  permissionMessage = permissionMessage ? permissionMessage : t2("permissionMessage");
  useEffect(() => {
    if (permissionsRef.current && !isDesktop) {
      setShowRealPermissionsPopup(permissionsRef.current);
    }
  }, [permission]);
  useEffect(() => {
    const camPermissions2 = sessionStorage.getItem("cameraPermissionsGranted") === "true";
    if (!isDesktop && camPermissions2) {
      setShowRealPermissionsPopup(true);
    }
  }, [permission]);
  useEffect(() => {
    return () => {
      var _a;
      if (video.current) {
        video.current.pause();
        video.current.srcObject = null;
      }
      (_a = streamRef.current) == null ? void 0 : _a.getTracks().forEach((track) => track.stop());
    };
  }, []);
  const playVideoWhenActiveAgain = useCallback(() => {
    var _a, _b, _c;
    if (!document.hidden) {
      (_b = (_a = video.current) == null ? void 0 : _a.srcObject) == null ? void 0 : _b.clone();
      return (_c = video.current) == null ? void 0 : _c.play();
    }
  }, []);
  useEventListener("visibilitychange", playVideoWhenActiveAgain, document);
  const logCameraInfo = (stream2) => {
    const {
      width: width2,
      height: height2
    } = stream2.getVideoTracks()[0].getSettings();
    const {
      focusMode = false
    } = navigator.mediaDevices.getSupportedConstraints();
    addEvent({
      eventName: "cameraType",
      eventType: "text",
      eventData: {
        type: "webRTC",
        resolution: `${width2}x${height2}`,
        autofocus: focusMode
      },
      token
    });
    if (isSelfie) {
      addEvent({
        eventName: "cameraSelfie",
        eventType: "text",
        eventData: {},
        token
      });
    }
  };
  const handleUserMediaError = (error3) => {
    console.log(error3);
    setIsLoadingCamera(false);
    if (error3.constructor.name === "DOMException") {
      addEvent({
        eventName: "permissionDenied",
        eventType: "text",
        eventData: {
          message: "User denied to use camera."
        },
        token
      });
      onLog(getLogObject("permissionDenied", {
        message: `User denied to use camera.`
      }));
      error3.type = "permissionDenied";
      if (showCustomCameraPermissionScreen) {
        setShowCustomCameraPermission(true);
      } else {
        onError(error3);
      }
    } else if (error3.constructor.name === "OverconstrainedError") {
      onLog(getLogObject("OSVersionNotSupported", {
        message: `OS version is not supported.`
      }));
      setIsBrowserSupported(false);
    } else {
      onLog(getLogObject("browserNotSupported", {
        message: `Browser is not supported.`
      }));
      setIsBrowserSupported(false);
    }
  };
  const handleUserMedia = async (stream2) => {
    setPermission(true);
    setIsLoadingCamera(false);
    video.current.srcObject = stream2;
    onStreamReady(stream2);
    const mediaStreamTrack2 = stream2.getVideoTracks()[0];
    if (isVirtualCamera(mediaStreamTrack2)) {
      onError(new Error("Virtual camera is detected"));
    }
    setMediaStreamTrack(mediaStreamTrack2);
    streamRef.current = stream2;
  };
  useEffect(() => {
    function getUserMediaVideoParams(resolutionFallbackLevel) {
      const userMediaVideoParams = {
        resizeMode: "none",
        facingMode: "environment"
      };
      switch (resolutionFallbackLevel) {
        case 0:
          return __spreadProps(__spreadValues({}, userMediaVideoParams), {
            height: {
              ideal: 720
            },
            aspectRatio: {
              ideal: 19.5 / 9
            }
          });
        case 1:
          return __spreadProps(__spreadValues({}, userMediaVideoParams), {
            width: {
              min: 3200,
              ideal: 3840,
              max: 4096
            },
            height: {
              min: 1800,
              ideal: 2160,
              max: 2400
            }
          });
        case 2:
          return __spreadProps(__spreadValues({}, userMediaVideoParams), {
            width: {
              min: 1400,
              ideal: 1920,
              max: 2160
            },
            height: {
              min: 900,
              ideal: 1080,
              max: 1440
            }
          });
        case 3:
          return __spreadProps(__spreadValues({}, userMediaVideoParams), {
            width: {
              min: 640,
              ideal: 640,
              max: 800
            },
            height: {
              min: 480,
              ideal: 480,
              max: 600
            }
          });
        case 4:
          return __spreadProps(__spreadValues({}, userMediaVideoParams), {
            width: {
              min: 640,
              ideal: 800,
              max: 960
            },
            height: {
              min: 480,
              ideal: 480,
              max: 480
            }
          });
        default:
          return {};
      }
    }
    const requestUserMedia = async (fallbackOption2) => {
      const constraints = {
        video: videoSource === "environment" ? getUserMediaVideoParams(fallbackOption2.current) : {
          facingMode: videoSource,
          height: {
            ideal: 480
          },
          width: {
            ideal: 640
          }
        }
      };
      const desktopConstraints = {
        audio: isSafari() ? true : false,
        video: {
          facingMode: "user",
          deviceId: deviceId ? {
            exact: deviceId
          } : void 0
        }
      };
      if (isAndroid && videoSource === "environment") {
        navigator.mediaDevices.getUserMedia(constraints).then(async (mediaStream) => {
          const myMediaStreamTracks = mediaStream.getVideoTracks()[0];
          const cameras = await getCameras();
          const mainCameraContraints = await adjustCamerasFromCameraStream(myMediaStreamTracks, cameras);
          mediaStream.getTracks().forEach((track) => track.stop());
          let idealWidth = 1280;
          let idealHeight = 720;
          if (fallbackOption2.current > 1 || isJ7Prime || isAlcatel1x || isLenovoVibeB) {
            const {
              width: width2,
              height: height2
            } = getUserMediaVideoParams(isJ7Prime ? 2 : isAlcatel1x || isLenovoVibeB ? 4 : fallbackOption2.current);
            idealWidth = width2 == null ? void 0 : width2.ideal;
            idealHeight = height2 == null ? void 0 : height2.ideal;
          }
          const exactConstraints = {
            video: {
              deviceId: {
                exact: mainCameraContraints.deviceId
              },
              width: {
                ideal: idealWidth
              },
              height: {
                ideal: idealHeight
              }
            }
          };
          navigator.mediaDevices.getUserMedia(exactConstraints).then((stream2) => {
            logCameraInfo(stream2);
            handleUserMedia(stream2);
          });
        }).catch(function(err) {
          fallbackOption2.current = fallbackOption2.current + 1;
          if (fallbackOption2.current > 4) {
            handleUserMediaError(err);
          } else {
            requestUserMedia(fallbackOption2);
          }
        });
      } else {
        navigator.mediaDevices.getUserMedia(mobile.any() ? constraints : desktopConstraints).then((stream2) => {
          logCameraInfo(stream2);
          handleUserMedia(stream2);
        }).catch(function(err) {
          handleUserMediaError(err);
        });
      }
    };
    if (mobile.iOS() && isAlreadyRequested.current) {
      return;
    }
    if (showRealPermissionsPopup === true || isDesktop || showDoublePermissionsRequest === false) {
      isAlreadyRequested.current = true;
      if (stream) {
        handleUserMedia(stream);
      } else {
        requestUserMedia(fallbackOption);
        setIsLoadingCamera(true);
      }
    }
    canvasRef.current = document.createElement("canvas");
  }, [showRealPermissionsPopup]);
  useLayoutEffect(() => {
    if (ref) {
      if (typeof ref === "function") {
        ref(video.current);
      } else {
        ref.current = video.current;
      }
    }
  }, [ref, video]);
  useImperativeHandle(ref, () => ({
    getBase64ScreenShot,
    getImageData,
    getFullImage,
    dataURLtoBlob,
    video: video.current,
    mediaStreamTrack,
    getProperSizeCanvas,
    getCanvas
  }));
  const getProperSizeCanvas = (source2, isCanvas = true) => {
    const cameraOffsetX = Math.abs(video.current.clientWidth - window.innerWidth);
    const newCanvas = document.createElement("canvas");
    const ratio = (isCanvas ? source2.height : source2.videoHeight) / video.current.clientHeight;
    const newWidth = window.innerWidth;
    const newHeight = window.innerHeight;
    newCanvas.width = newWidth;
    newCanvas.height = newHeight;
    newCanvas.getContext("2d").drawImage(source2, ratio * cameraOffsetX / 2, 0, ratio * newWidth, ratio * newHeight, 0, 0, newWidth, newHeight);
    return newCanvas;
  };
  const getBase64ScreenShot = (w2, h2, scaleFactor, hasMask = true) => {
    const canvas = getCanvas(w2, h2);
    const getMaskCroppedImage = (canvas2) => {
      const mask = getMaskPosition();
      const offsetX = hasMask ? mask.left : 0;
      const offsetY = hasMask ? mask.top : 0;
      const newWidth = hasMask ? mask.width : canvas2.width;
      const newHeight = hasMask ? mask.height : canvas2.height;
      const newCanvas2 = document.createElement("canvas");
      newCanvas2.width = newWidth;
      newCanvas2.height = newHeight;
      newCanvas2.getContext("2d").drawImage(canvas2, offsetX, offsetY, newWidth, newHeight, 0, 0, newWidth, newHeight);
      return newCanvas2;
    };
    const newCanvas = isSelfie ? canvas : getMaskCroppedImage(getProperSizeCanvas(canvas));
    return newCanvas.toDataURL(imageType, scaleFactor).split(",")[1];
  };
  const getImageData = (width2, height2) => {
    const canvas = getCanvas(width2, height2);
    const context2 = canvas.getContext("2d");
    return {
      canvasElement: canvas,
      imageElement: canvas && context2.getImageData(0, 0, width2, height2)
    };
  };
  const getCanvas = (width2 = 1280, height2 = 720) => {
    if (!video.current.videoHeight) {
      return null;
    }
    if (mobile.any()) {
      canvasEl.width = width2;
      canvasEl.height = height2;
      const ctx = canvasEl.getContext("2d");
      ctx.clearRect(0, 0, width2, height2);
      ctx.drawImage(video.current, 0, 0);
    } else {
      if (isSelfie) {
        const newWidth = 3 * height2 / 4;
        const sy = 0;
        const sx = width2 / 2 - newWidth / 2;
        canvasEl.width = newWidth;
        canvasEl.height = height2;
        const ctx = canvasEl.getContext("2d");
        ctx.clearRect(0, 0, width2, height2);
        ctx.drawImage(video.current, sx, sy, newWidth, height2, 0, 0, newWidth, height2);
      } else {
        canvasEl.width = width2;
        canvasEl.height = height2;
        const ctx = canvasEl.getContext("2d");
        ctx.clearRect(0, 0, 720, 1280);
        ctx.drawImage(video.current, 0, 0);
      }
    }
    return canvasEl;
  };
  const getFullImage = (width2, height2, scaleFactor) => {
    const canvas = getCanvas(width2, height2);
    return canvas.toDataURL(imageType, scaleFactor).split(",")[1];
  };
  const dataURLtoBlob = (width2, height2, scaleFactor) => {
    const canvas = getCanvas(width2, height2);
    const base64 = canvas.toDataURL(imageType, scaleFactor);
    const binary = atob(base64.split(",")[1]);
    const array = [];
    for (let i2 = 0; i2 < binary.length; i2++) {
      array.push(binary.charCodeAt(i2));
    }
    return new Blob([new Uint8Array(array)], {
      type: screenshotFormat
    });
  };
  const isHorizontal = () => {
    if (!video.current)
      return false;
    return video.current.videoWidth > video.current.videoHeight;
  };
  const handleCameraPermission = () => {
    setShowRealPermissionsPopup(true);
    sessionStorage.setItem("cameraPermissionsGranted", String(true));
    addEvent({
      token,
      eventName: "permissionsAllowedFake",
      eventData: {},
      eventType: "text"
    });
  };
  const handleQuitOnboarding = () => {
    setShowCustomCameraPermission(true);
    addEvent({
      token,
      eventName: "permissionsQuitFlow",
      eventData: {},
      eventType: "text"
    });
  };
  const handleDenyPermission = () => {
    addEvent({
      token,
      eventName: "permissionsDeniedFake",
      eventData: {},
      eventType: "text"
    });
  };
  const camPermissions = sessionStorage.getItem("cameraPermissionsGranted") === "true";
  const shouldShowFakePermissions = showDoublePermissionsRequest && (typeof permission !== "undefined" && !permission && !showRealPermissionsPopup || typeof showRealPermissionsPopup !== "undefined" && !showRealPermissionsPopup) && !isDesktop && !camPermissions;
  const handleOnPlay = () => {
    if (!isAlreadyPlayed && onPlay && typeof onPlay === "function") {
      onPlay();
    }
    setIsAlreadyPlayed(true);
  };
  return /* @__PURE__ */ jsxs(Fragment$1, {
    children: [showCustomCameraPermission && /* @__PURE__ */ jsx(AllowCameraUse, {
      handleAllowCamera: onRestartOnboarding
    }), !permission && isDesktop && /* @__PURE__ */ jsx(PermissionRequest, {
      text: permissionMessage,
      color: permissionBackgroundColor
    }), shouldShowFakePermissions && /* @__PURE__ */ jsx(FakePermissionsRequest, {
      handleDenyPermission,
      handleCameraPermission,
      handleQuitOnboarding
    }), !isBrowserSupported && /* @__PURE__ */ jsx(BrowserNotSupported, {}), isLoadingCamera && /* @__PURE__ */ jsx(Loader, {
      message: t2("webcam.loading"),
      fullScreen: true
    }), /* @__PURE__ */ jsx(Video, {
      autoPlay: true,
      className: classNames(className, {
        selfie: isSelfie,
        horizontal: isHorizontal(),
        desktop: !mobile.any(),
        assistedOnboarding
      }),
      playsInline: true,
      onPlay: handleOnPlay,
      ref: video,
      muted: true
    })]
  });
});
const WebcamWithChooseCamera = forwardRef((props, ref) => {
  const [deviceId, setDeviceId] = useState(sessionStorage.getItem("deviceId"));
  function handleCameraChosen(deviceId2) {
    setDeviceId(deviceId2);
    sessionStorage.setItem("deviceId", deviceId2);
  }
  if (mobile.any()) {
    return /* @__PURE__ */ jsx(Webcam, __spreadProps(__spreadValues({}, props), {
      ref
    }));
  }
  return deviceId ? /* @__PURE__ */ jsx(Webcam, __spreadProps(__spreadValues({}, props), {
    deviceId,
    ref
  })) : /* @__PURE__ */ jsx(ChooseCamera, {
    onCameraChosen: handleCameraChosen
  });
});
var warning$2 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI5IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjVDNkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTI4Ljc0NSAyMS4zNzdMMTYuMDIyLjgzN0ExLjc4OCAxLjc4OCAwIDAgMCAxNC41IDBjLS42MjMgMC0xLjIuMzE3LTEuNTIyLjgzN0wuMjU1IDIxLjM3N2ExLjY5IDEuNjkgMCAwIDAtLjAyNSAxLjc0NGMuMzE1LjU0My45MDYuODc5IDEuNTQ3Ljg3OWgyNS40NDZjLjY0MSAwIDEuMjMyLS4zMzYgMS41NDctLjg4YTEuNjkgMS42OSAwIDAgMC0uMDI1LTEuNzQzek0xNC41MDkgNy4xMDVjLjczMSAwIDEuMzUuNDAyIDEuMzUgMS4xMTMgMCAyLjE3LS4yNjMgNS4yOS0uMjYzIDcuNDYgMCAuNTY1LS42MzcuODAyLTEuMDg3LjgwMi0uNTk5IDAtMS4xMDUtLjIzNy0xLjEwNS0uODAyIDAtMi4xNy0uMjYyLTUuMjktLjI2Mi03LjQ2IDAtLjcxMS42LTEuMTEzIDEuMzY3LTEuMTEzem0uMDIgMTMuNDQyYy0uODI1IDAtMS40NDMtLjY1Ni0xLjQ0My0xLjQwNCAwLS43NjYuNjE4LTEuNDA0IDEuNDQyLTEuNDA0Ljc2OCAwIDEuNDI0LjYzOCAxLjQyNCAxLjQwNCAwIC43NDgtLjY1NiAxLjQwNC0xLjQyNCAxLjQwNHoiLz4KPC9zdmc+Cg==";
var pdf = { exports: {} };
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    return (() => {
      var __webpack_modules__ = [
        ,
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.StatTimer = exports2.RenderingCancelledException = exports2.PixelsPerInch = exports2.PageViewport = exports2.PDFDateString = exports2.LinkTarget = exports2.DOMStandardFontDataFactory = exports2.DOMSVGFactory = exports2.DOMCanvasFactory = exports2.DOMCMapReaderFactory = void 0;
          exports2.addLinkAttributes = addLinkAttributes;
          exports2.deprecated = deprecated;
          exports2.getFilenameFromUrl = getFilenameFromUrl;
          exports2.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
          exports2.getXfaPageViewport = getXfaPageViewport;
          exports2.isDataScheme = isDataScheme;
          exports2.isPdfFile = isPdfFile;
          exports2.isValidFetchUrl = isValidFetchUrl;
          exports2.loadScript = loadScript;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          var _base_factory = __w_pdfjs_require__2(135);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          var DEFAULT_LINK_REL2 = "noopener noreferrer nofollow";
          var SVG_NS = "http://www.w3.org/2000/svg";
          var PixelsPerInch = {
            CSS: 96,
            PDF: 72,
            get PDF_TO_CSS_UNITS() {
              return (0, _util2.shadow)(this, "PDF_TO_CSS_UNITS", this.CSS / this.PDF);
            }
          };
          exports2.PixelsPerInch = PixelsPerInch;
          var DOMCanvasFactory = /* @__PURE__ */ function(_BaseCanvasFactory) {
            _inherits2(DOMCanvasFactory2, _BaseCanvasFactory);
            var _super = _createSuper2(DOMCanvasFactory2);
            function DOMCanvasFactory2() {
              var _this;
              var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$ownerDocument = _ref.ownerDocument, ownerDocument = _ref$ownerDocument === void 0 ? globalThis.document : _ref$ownerDocument;
              _classCallCheck2(this, DOMCanvasFactory2);
              _this = _super.call(this);
              _this._document = ownerDocument;
              return _this;
            }
            _createClass2(DOMCanvasFactory2, [{
              key: "_createCanvas",
              value: function _createCanvas(width2, height2) {
                var canvas = this._document.createElement("canvas");
                canvas.width = width2;
                canvas.height = height2;
                return canvas;
              }
            }]);
            return DOMCanvasFactory2;
          }(_base_factory.BaseCanvasFactory);
          exports2.DOMCanvasFactory = DOMCanvasFactory;
          function fetchData(_x) {
            return _fetchData.apply(this, arguments);
          }
          function _fetchData() {
            _fetchData = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee(url) {
              var asTypedArray, response, _args = arguments;
              return _regenerator2["default"].wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      asTypedArray = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                      if (!isValidFetchUrl(url, document.baseURI)) {
                        _context.next = 21;
                        break;
                      }
                      _context.next = 4;
                      return fetch(url);
                    case 4:
                      response = _context.sent;
                      if (response.ok) {
                        _context.next = 7;
                        break;
                      }
                      throw new Error(response.statusText);
                    case 7:
                      if (!asTypedArray) {
                        _context.next = 15;
                        break;
                      }
                      _context.t1 = Uint8Array;
                      _context.next = 11;
                      return response.arrayBuffer();
                    case 11:
                      _context.t2 = _context.sent;
                      _context.t0 = new _context.t1(_context.t2);
                      _context.next = 20;
                      break;
                    case 15:
                      _context.t3 = _util2.stringToBytes;
                      _context.next = 18;
                      return response.text();
                    case 18:
                      _context.t4 = _context.sent;
                      _context.t0 = (0, _context.t3)(_context.t4);
                    case 20:
                      return _context.abrupt("return", _context.t0);
                    case 21:
                      return _context.abrupt("return", new Promise(function(resolve, reject) {
                        var request4 = new XMLHttpRequest();
                        request4.open("GET", url, true);
                        if (asTypedArray) {
                          request4.responseType = "arraybuffer";
                        }
                        request4.onreadystatechange = function() {
                          if (request4.readyState !== XMLHttpRequest.DONE) {
                            return;
                          }
                          if (request4.status === 200 || request4.status === 0) {
                            var data2;
                            if (asTypedArray && request4.response) {
                              data2 = new Uint8Array(request4.response);
                            } else if (!asTypedArray && request4.responseText) {
                              data2 = (0, _util2.stringToBytes)(request4.responseText);
                            }
                            if (data2) {
                              resolve(data2);
                              return;
                            }
                          }
                          reject(new Error(request4.statusText));
                        };
                        request4.send(null);
                      }));
                    case 22:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
            return _fetchData.apply(this, arguments);
          }
          var DOMCMapReaderFactory = /* @__PURE__ */ function(_BaseCMapReaderFactor) {
            _inherits2(DOMCMapReaderFactory2, _BaseCMapReaderFactor);
            var _super2 = _createSuper2(DOMCMapReaderFactory2);
            function DOMCMapReaderFactory2() {
              _classCallCheck2(this, DOMCMapReaderFactory2);
              return _super2.apply(this, arguments);
            }
            _createClass2(DOMCMapReaderFactory2, [{
              key: "_fetchData",
              value: function _fetchData2(url, compressionType) {
                return fetchData(url, this.isCompressed).then(function(data2) {
                  return {
                    cMapData: data2,
                    compressionType
                  };
                });
              }
            }]);
            return DOMCMapReaderFactory2;
          }(_base_factory.BaseCMapReaderFactory);
          exports2.DOMCMapReaderFactory = DOMCMapReaderFactory;
          var DOMStandardFontDataFactory = /* @__PURE__ */ function(_BaseStandardFontData) {
            _inherits2(DOMStandardFontDataFactory2, _BaseStandardFontData);
            var _super3 = _createSuper2(DOMStandardFontDataFactory2);
            function DOMStandardFontDataFactory2() {
              _classCallCheck2(this, DOMStandardFontDataFactory2);
              return _super3.apply(this, arguments);
            }
            _createClass2(DOMStandardFontDataFactory2, [{
              key: "_fetchData",
              value: function _fetchData2(url) {
                return fetchData(url, true);
              }
            }]);
            return DOMStandardFontDataFactory2;
          }(_base_factory.BaseStandardFontDataFactory);
          exports2.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
          var DOMSVGFactory = /* @__PURE__ */ function(_BaseSVGFactory) {
            _inherits2(DOMSVGFactory2, _BaseSVGFactory);
            var _super4 = _createSuper2(DOMSVGFactory2);
            function DOMSVGFactory2() {
              _classCallCheck2(this, DOMSVGFactory2);
              return _super4.apply(this, arguments);
            }
            _createClass2(DOMSVGFactory2, [{
              key: "_createSVG",
              value: function _createSVG(type) {
                return document.createElementNS(SVG_NS, type);
              }
            }]);
            return DOMSVGFactory2;
          }(_base_factory.BaseSVGFactory);
          exports2.DOMSVGFactory = DOMSVGFactory;
          var PageViewport = /* @__PURE__ */ function() {
            function PageViewport2(_ref2) {
              var viewBox = _ref2.viewBox, scale2 = _ref2.scale, rotation = _ref2.rotation, _ref2$offsetX = _ref2.offsetX, offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX, _ref2$offsetY = _ref2.offsetY, offsetY = _ref2$offsetY === void 0 ? 0 : _ref2$offsetY, _ref2$dontFlip = _ref2.dontFlip, dontFlip = _ref2$dontFlip === void 0 ? false : _ref2$dontFlip;
              _classCallCheck2(this, PageViewport2);
              this.viewBox = viewBox;
              this.scale = scale2;
              this.rotation = rotation;
              this.offsetX = offsetX;
              this.offsetY = offsetY;
              var centerX = (viewBox[2] + viewBox[0]) / 2;
              var centerY = (viewBox[3] + viewBox[1]) / 2;
              var rotateA, rotateB, rotateC, rotateD;
              rotation %= 360;
              if (rotation < 0) {
                rotation += 360;
              }
              switch (rotation) {
                case 180:
                  rotateA = -1;
                  rotateB = 0;
                  rotateC = 0;
                  rotateD = 1;
                  break;
                case 90:
                  rotateA = 0;
                  rotateB = 1;
                  rotateC = 1;
                  rotateD = 0;
                  break;
                case 270:
                  rotateA = 0;
                  rotateB = -1;
                  rotateC = -1;
                  rotateD = 0;
                  break;
                case 0:
                  rotateA = 1;
                  rotateB = 0;
                  rotateC = 0;
                  rotateD = -1;
                  break;
                default:
                  throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
              }
              if (dontFlip) {
                rotateC = -rotateC;
                rotateD = -rotateD;
              }
              var offsetCanvasX, offsetCanvasY;
              var width2, height2;
              if (rotateA === 0) {
                offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale2 + offsetX;
                offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale2 + offsetY;
                width2 = Math.abs(viewBox[3] - viewBox[1]) * scale2;
                height2 = Math.abs(viewBox[2] - viewBox[0]) * scale2;
              } else {
                offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale2 + offsetX;
                offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale2 + offsetY;
                width2 = Math.abs(viewBox[2] - viewBox[0]) * scale2;
                height2 = Math.abs(viewBox[3] - viewBox[1]) * scale2;
              }
              this.transform = [rotateA * scale2, rotateB * scale2, rotateC * scale2, rotateD * scale2, offsetCanvasX - rotateA * scale2 * centerX - rotateC * scale2 * centerY, offsetCanvasY - rotateB * scale2 * centerX - rotateD * scale2 * centerY];
              this.width = width2;
              this.height = height2;
            }
            _createClass2(PageViewport2, [{
              key: "clone",
              value: function clone2() {
                var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$scale = _ref3.scale, scale2 = _ref3$scale === void 0 ? this.scale : _ref3$scale, _ref3$rotation = _ref3.rotation, rotation = _ref3$rotation === void 0 ? this.rotation : _ref3$rotation, _ref3$offsetX = _ref3.offsetX, offsetX = _ref3$offsetX === void 0 ? this.offsetX : _ref3$offsetX, _ref3$offsetY = _ref3.offsetY, offsetY = _ref3$offsetY === void 0 ? this.offsetY : _ref3$offsetY, _ref3$dontFlip = _ref3.dontFlip, dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
                return new PageViewport2({
                  viewBox: this.viewBox.slice(),
                  scale: scale2,
                  rotation,
                  offsetX,
                  offsetY,
                  dontFlip
                });
              }
            }, {
              key: "convertToViewportPoint",
              value: function convertToViewportPoint(x2, y2) {
                return _util2.Util.applyTransform([x2, y2], this.transform);
              }
            }, {
              key: "convertToViewportRectangle",
              value: function convertToViewportRectangle(rect) {
                var topLeft = _util2.Util.applyTransform([rect[0], rect[1]], this.transform);
                var bottomRight = _util2.Util.applyTransform([rect[2], rect[3]], this.transform);
                return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
              }
            }, {
              key: "convertToPdfPoint",
              value: function convertToPdfPoint(x2, y2) {
                return _util2.Util.applyInverseTransform([x2, y2], this.transform);
              }
            }]);
            return PageViewport2;
          }();
          exports2.PageViewport = PageViewport;
          var RenderingCancelledException = /* @__PURE__ */ function(_BaseException) {
            _inherits2(RenderingCancelledException2, _BaseException);
            var _super5 = _createSuper2(RenderingCancelledException2);
            function RenderingCancelledException2(msg, type) {
              var _this2;
              _classCallCheck2(this, RenderingCancelledException2);
              _this2 = _super5.call(this, msg, "RenderingCancelledException");
              _this2.type = type;
              return _this2;
            }
            return RenderingCancelledException2;
          }(_util2.BaseException);
          exports2.RenderingCancelledException = RenderingCancelledException;
          var LinkTarget = {
            NONE: 0,
            SELF: 1,
            BLANK: 2,
            PARENT: 3,
            TOP: 4
          };
          exports2.LinkTarget = LinkTarget;
          function addLinkAttributes(link) {
            var _ref4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, url = _ref4.url, target = _ref4.target, rel = _ref4.rel, _ref4$enabled = _ref4.enabled, enabled = _ref4$enabled === void 0 ? true : _ref4$enabled;
            (0, _util2.assert)(url && typeof url === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
            var urlNullRemoved = (0, _util2.removeNullCharacters)(url);
            if (enabled) {
              link.href = link.title = urlNullRemoved;
            } else {
              link.href = "";
              link.title = "Disabled: ".concat(urlNullRemoved);
              link.onclick = function() {
                return false;
              };
            }
            var targetStr = "";
            switch (target) {
              case LinkTarget.NONE:
                break;
              case LinkTarget.SELF:
                targetStr = "_self";
                break;
              case LinkTarget.BLANK:
                targetStr = "_blank";
                break;
              case LinkTarget.PARENT:
                targetStr = "_parent";
                break;
              case LinkTarget.TOP:
                targetStr = "_top";
                break;
            }
            link.target = targetStr;
            link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL2;
          }
          function isDataScheme(url) {
            var ii = url.length;
            var i2 = 0;
            while (i2 < ii && url[i2].trim() === "") {
              i2++;
            }
            return url.substring(i2, i2 + 5).toLowerCase() === "data:";
          }
          function isPdfFile(filename) {
            return typeof filename === "string" && /\.pdf$/i.test(filename);
          }
          function getFilenameFromUrl(url) {
            var anchor = url.indexOf("#");
            var query = url.indexOf("?");
            var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
            return url.substring(url.lastIndexOf("/", end) + 1, end);
          }
          function getPdfFilenameFromUrl(url) {
            var defaultFilename = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "document.pdf";
            if (typeof url !== "string") {
              return defaultFilename;
            }
            if (isDataScheme(url)) {
              (0, _util2.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
              return defaultFilename;
            }
            var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
            var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
            var splitURI = reURI.exec(url);
            var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
            if (suggestedFilename) {
              suggestedFilename = suggestedFilename[0];
              if (suggestedFilename.includes("%")) {
                try {
                  suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                } catch (ex) {
                }
              }
            }
            return suggestedFilename || defaultFilename;
          }
          var StatTimer = /* @__PURE__ */ function() {
            function StatTimer2() {
              _classCallCheck2(this, StatTimer2);
              this.started = /* @__PURE__ */ Object.create(null);
              this.times = [];
            }
            _createClass2(StatTimer2, [{
              key: "time",
              value: function time(name) {
                if (name in this.started) {
                  (0, _util2.warn)("Timer is already running for ".concat(name));
                }
                this.started[name] = Date.now();
              }
            }, {
              key: "timeEnd",
              value: function timeEnd(name) {
                if (!(name in this.started)) {
                  (0, _util2.warn)("Timer has not been started for ".concat(name));
                }
                this.times.push({
                  name,
                  start: this.started[name],
                  end: Date.now()
                });
                delete this.started[name];
              }
            }, {
              key: "toString",
              value: function toString4() {
                var outBuf = [];
                var longest = 0;
                var _iterator = _createForOfIteratorHelper2(this.times), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var time = _step.value;
                    var name = time.name;
                    if (name.length > longest) {
                      longest = name.length;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                var _iterator2 = _createForOfIteratorHelper2(this.times), _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var _time = _step2.value;
                    var duration = _time.end - _time.start;
                    outBuf.push("".concat(_time.name.padEnd(longest), " ").concat(duration, "ms\n"));
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                return outBuf.join("");
              }
            }]);
            return StatTimer2;
          }();
          exports2.StatTimer = StatTimer;
          function isValidFetchUrl(url, baseUrl) {
            try {
              var _ref5 = baseUrl ? new URL(url, baseUrl) : new URL(url), protocol = _ref5.protocol;
              return protocol === "http:" || protocol === "https:";
            } catch (ex) {
              return false;
            }
          }
          function loadScript(src2) {
            var removeScriptElement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return new Promise(function(resolve, reject) {
              var script2 = document.createElement("script");
              script2.src = src2;
              script2.onload = function(evt) {
                if (removeScriptElement) {
                  script2.remove();
                }
                resolve(evt);
              };
              script2.onerror = function() {
                reject(new Error("Cannot load script at: ".concat(script2.src)));
              };
              (document.head || document.documentElement).appendChild(script2);
            });
          }
          function deprecated(details) {
            console.log("Deprecated API usage: " + details);
          }
          var pdfDateStringRegex;
          var PDFDateString = /* @__PURE__ */ function() {
            function PDFDateString2() {
              _classCallCheck2(this, PDFDateString2);
            }
            _createClass2(PDFDateString2, null, [{
              key: "toDateObject",
              value: function toDateObject(input) {
                if (!input || !(0, _util2.isString)(input)) {
                  return null;
                }
                if (!pdfDateStringRegex) {
                  pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                }
                var matches = pdfDateStringRegex.exec(input);
                if (!matches) {
                  return null;
                }
                var year = parseInt(matches[1], 10);
                var month = parseInt(matches[2], 10);
                month = month >= 1 && month <= 12 ? month - 1 : 0;
                var day = parseInt(matches[3], 10);
                day = day >= 1 && day <= 31 ? day : 1;
                var hour = parseInt(matches[4], 10);
                hour = hour >= 0 && hour <= 23 ? hour : 0;
                var minute = parseInt(matches[5], 10);
                minute = minute >= 0 && minute <= 59 ? minute : 0;
                var second = parseInt(matches[6], 10);
                second = second >= 0 && second <= 59 ? second : 0;
                var universalTimeRelation = matches[7] || "Z";
                var offsetHour = parseInt(matches[8], 10);
                offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                var offsetMinute = parseInt(matches[9], 10) || 0;
                offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                if (universalTimeRelation === "-") {
                  hour += offsetHour;
                  minute += offsetMinute;
                } else if (universalTimeRelation === "+") {
                  hour -= offsetHour;
                  minute -= offsetMinute;
                }
                return new Date(Date.UTC(year, month, day, hour, minute, second));
              }
            }]);
            return PDFDateString2;
          }();
          exports2.PDFDateString = PDFDateString;
          function getXfaPageViewport(xfaPage, _ref6) {
            var _ref6$scale = _ref6.scale, scale2 = _ref6$scale === void 0 ? 1 : _ref6$scale, _ref6$rotation = _ref6.rotation, rotation = _ref6$rotation === void 0 ? 0 : _ref6$rotation;
            var _xfaPage$attributes$s = xfaPage.attributes.style, width2 = _xfaPage$attributes$s.width, height2 = _xfaPage$attributes$s.height;
            var viewBox = [0, 0, parseInt(width2), parseInt(height2)];
            return new PageViewport({
              viewBox,
              scale: scale2,
              rotation
            });
          }
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          module2.exports = __w_pdfjs_require__2(3);
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          module2 = __w_pdfjs_require__2.nmd(module2);
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          var runtime = function(exports2) {
            var Op = Object.prototype;
            var hasOwn = Op.hasOwnProperty;
            var undefined$1;
            var $Symbol = typeof Symbol === "function" ? Symbol : {};
            var iteratorSymbol = $Symbol.iterator || "@@iterator";
            var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
            var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
            function define(obj, key, value) {
              Object.defineProperty(obj, key, {
                value,
                enumerable: true,
                configurable: true,
                writable: true
              });
              return obj[key];
            }
            try {
              define({}, "");
            } catch (err) {
              define = function define2(obj, key, value) {
                return obj[key] = value;
              };
            }
            function wrap(innerFn, outerFn, self2, tryLocsList) {
              var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
              var generator = Object.create(protoGenerator.prototype);
              var context2 = new Context(tryLocsList || []);
              generator._invoke = makeInvokeMethod(innerFn, self2, context2);
              return generator;
            }
            exports2.wrap = wrap;
            function tryCatch(fn, obj, arg) {
              try {
                return {
                  type: "normal",
                  arg: fn.call(obj, arg)
                };
              } catch (err) {
                return {
                  type: "throw",
                  arg: err
                };
              }
            }
            var GenStateSuspendedStart = "suspendedStart";
            var GenStateSuspendedYield = "suspendedYield";
            var GenStateExecuting = "executing";
            var GenStateCompleted = "completed";
            var ContinueSentinel = {};
            function Generator() {
            }
            function GeneratorFunction() {
            }
            function GeneratorFunctionPrototype() {
            }
            var IteratorPrototype = {};
            define(IteratorPrototype, iteratorSymbol, function() {
              return this;
            });
            var getProto = Object.getPrototypeOf;
            var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
            if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
              IteratorPrototype = NativeIteratorPrototype;
            }
            var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
            GeneratorFunction.prototype = GeneratorFunctionPrototype;
            define(Gp, "constructor", GeneratorFunctionPrototype);
            define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
            GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
            function defineIteratorMethods(prototype) {
              ["next", "throw", "return"].forEach(function(method2) {
                define(prototype, method2, function(arg) {
                  return this._invoke(method2, arg);
                });
              });
            }
            exports2.isGeneratorFunction = function(genFun) {
              var ctor = typeof genFun === "function" && genFun.constructor;
              return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
            };
            exports2.mark = function(genFun) {
              if (Object.setPrototypeOf) {
                Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
              } else {
                genFun.__proto__ = GeneratorFunctionPrototype;
                define(genFun, toStringTagSymbol, "GeneratorFunction");
              }
              genFun.prototype = Object.create(Gp);
              return genFun;
            };
            exports2.awrap = function(arg) {
              return {
                __await: arg
              };
            };
            function AsyncIterator(generator, PromiseImpl) {
              function invoke(method2, arg, resolve, reject) {
                var record = tryCatch(generator[method2], generator, arg);
                if (record.type === "throw") {
                  reject(record.arg);
                } else {
                  var result2 = record.arg;
                  var value = result2.value;
                  if (value && _typeof2(value) === "object" && hasOwn.call(value, "__await")) {
                    return PromiseImpl.resolve(value.__await).then(function(value2) {
                      invoke("next", value2, resolve, reject);
                    }, function(err) {
                      invoke("throw", err, resolve, reject);
                    });
                  }
                  return PromiseImpl.resolve(value).then(function(unwrapped) {
                    result2.value = unwrapped;
                    resolve(result2);
                  }, function(error3) {
                    return invoke("throw", error3, resolve, reject);
                  });
                }
              }
              var previousPromise;
              function enqueue(method2, arg) {
                function callInvokeWithMethodAndArg() {
                  return new PromiseImpl(function(resolve, reject) {
                    invoke(method2, arg, resolve, reject);
                  });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
              }
              this._invoke = enqueue;
            }
            defineIteratorMethods(AsyncIterator.prototype);
            define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
              return this;
            });
            exports2.AsyncIterator = AsyncIterator;
            exports2.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
              if (PromiseImpl === void 0)
                PromiseImpl = Promise;
              var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
              return exports2.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result2) {
                return result2.done ? result2.value : iter.next();
              });
            };
            function makeInvokeMethod(innerFn, self2, context2) {
              var state2 = GenStateSuspendedStart;
              return function invoke(method2, arg) {
                if (state2 === GenStateExecuting) {
                  throw new Error("Generator is already running");
                }
                if (state2 === GenStateCompleted) {
                  if (method2 === "throw") {
                    throw arg;
                  }
                  return doneResult();
                }
                context2.method = method2;
                context2.arg = arg;
                while (true) {
                  var delegate = context2.delegate;
                  if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context2);
                    if (delegateResult) {
                      if (delegateResult === ContinueSentinel)
                        continue;
                      return delegateResult;
                    }
                  }
                  if (context2.method === "next") {
                    context2.sent = context2._sent = context2.arg;
                  } else if (context2.method === "throw") {
                    if (state2 === GenStateSuspendedStart) {
                      state2 = GenStateCompleted;
                      throw context2.arg;
                    }
                    context2.dispatchException(context2.arg);
                  } else if (context2.method === "return") {
                    context2.abrupt("return", context2.arg);
                  }
                  state2 = GenStateExecuting;
                  var record = tryCatch(innerFn, self2, context2);
                  if (record.type === "normal") {
                    state2 = context2.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) {
                      continue;
                    }
                    return {
                      value: record.arg,
                      done: context2.done
                    };
                  } else if (record.type === "throw") {
                    state2 = GenStateCompleted;
                    context2.method = "throw";
                    context2.arg = record.arg;
                  }
                }
              };
            }
            function maybeInvokeDelegate(delegate, context2) {
              var method2 = delegate.iterator[context2.method];
              if (method2 === undefined$1) {
                context2.delegate = null;
                if (context2.method === "throw") {
                  if (delegate.iterator["return"]) {
                    context2.method = "return";
                    context2.arg = undefined$1;
                    maybeInvokeDelegate(delegate, context2);
                    if (context2.method === "throw") {
                      return ContinueSentinel;
                    }
                  }
                  context2.method = "throw";
                  context2.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return ContinueSentinel;
              }
              var record = tryCatch(method2, delegate.iterator, context2.arg);
              if (record.type === "throw") {
                context2.method = "throw";
                context2.arg = record.arg;
                context2.delegate = null;
                return ContinueSentinel;
              }
              var info = record.arg;
              if (!info) {
                context2.method = "throw";
                context2.arg = new TypeError("iterator result is not an object");
                context2.delegate = null;
                return ContinueSentinel;
              }
              if (info.done) {
                context2[delegate.resultName] = info.value;
                context2.next = delegate.nextLoc;
                if (context2.method !== "return") {
                  context2.method = "next";
                  context2.arg = undefined$1;
                }
              } else {
                return info;
              }
              context2.delegate = null;
              return ContinueSentinel;
            }
            defineIteratorMethods(Gp);
            define(Gp, toStringTagSymbol, "Generator");
            define(Gp, iteratorSymbol, function() {
              return this;
            });
            define(Gp, "toString", function() {
              return "[object Generator]";
            });
            function pushTryEntry(locs) {
              var entry = {
                tryLoc: locs[0]
              };
              if (1 in locs) {
                entry.catchLoc = locs[1];
              }
              if (2 in locs) {
                entry.finallyLoc = locs[2];
                entry.afterLoc = locs[3];
              }
              this.tryEntries.push(entry);
            }
            function resetTryEntry(entry) {
              var record = entry.completion || {};
              record.type = "normal";
              delete record.arg;
              entry.completion = record;
            }
            function Context(tryLocsList) {
              this.tryEntries = [{
                tryLoc: "root"
              }];
              tryLocsList.forEach(pushTryEntry, this);
              this.reset(true);
            }
            exports2.keys = function(object) {
              var keys = [];
              for (var key in object) {
                keys.push(key);
              }
              keys.reverse();
              return function next() {
                while (keys.length) {
                  var key2 = keys.pop();
                  if (key2 in object) {
                    next.value = key2;
                    next.done = false;
                    return next;
                  }
                }
                next.done = true;
                return next;
              };
            };
            function values(iterable) {
              if (iterable) {
                var iteratorMethod = iterable[iteratorSymbol];
                if (iteratorMethod) {
                  return iteratorMethod.call(iterable);
                }
                if (typeof iterable.next === "function") {
                  return iterable;
                }
                if (!isNaN(iterable.length)) {
                  var i2 = -1, next = function next2() {
                    while (++i2 < iterable.length) {
                      if (hasOwn.call(iterable, i2)) {
                        next2.value = iterable[i2];
                        next2.done = false;
                        return next2;
                      }
                    }
                    next2.value = undefined$1;
                    next2.done = true;
                    return next2;
                  };
                  return next.next = next;
                }
              }
              return {
                next: doneResult
              };
            }
            exports2.values = values;
            function doneResult() {
              return {
                value: undefined$1,
                done: true
              };
            }
            Context.prototype = {
              constructor: Context,
              reset: function reset(skipTempReset) {
                this.prev = 0;
                this.next = 0;
                this.sent = this._sent = undefined$1;
                this.done = false;
                this.delegate = null;
                this.method = "next";
                this.arg = undefined$1;
                this.tryEntries.forEach(resetTryEntry);
                if (!skipTempReset) {
                  for (var name in this) {
                    if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                      this[name] = undefined$1;
                    }
                  }
                }
              },
              stop: function stop() {
                this.done = true;
                var rootEntry = this.tryEntries[0];
                var rootRecord = rootEntry.completion;
                if (rootRecord.type === "throw") {
                  throw rootRecord.arg;
                }
                return this.rval;
              },
              dispatchException: function dispatchException(exception) {
                if (this.done) {
                  throw exception;
                }
                var context2 = this;
                function handle2(loc, caught) {
                  record.type = "throw";
                  record.arg = exception;
                  context2.next = loc;
                  if (caught) {
                    context2.method = "next";
                    context2.arg = undefined$1;
                  }
                  return !!caught;
                }
                for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
                  var entry = this.tryEntries[i2];
                  var record = entry.completion;
                  if (entry.tryLoc === "root") {
                    return handle2("end");
                  }
                  if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                      if (this.prev < entry.catchLoc) {
                        return handle2(entry.catchLoc, true);
                      } else if (this.prev < entry.finallyLoc) {
                        return handle2(entry.finallyLoc);
                      }
                    } else if (hasCatch) {
                      if (this.prev < entry.catchLoc) {
                        return handle2(entry.catchLoc, true);
                      }
                    } else if (hasFinally) {
                      if (this.prev < entry.finallyLoc) {
                        return handle2(entry.finallyLoc);
                      }
                    } else {
                      throw new Error("try statement without catch or finally");
                    }
                  }
                }
              },
              abrupt: function abrupt(type, arg) {
                for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
                  var entry = this.tryEntries[i2];
                  if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                  }
                }
                if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                  finallyEntry = null;
                }
                var record = finallyEntry ? finallyEntry.completion : {};
                record.type = type;
                record.arg = arg;
                if (finallyEntry) {
                  this.method = "next";
                  this.next = finallyEntry.finallyLoc;
                  return ContinueSentinel;
                }
                return this.complete(record);
              },
              complete: function complete(record, afterLoc) {
                if (record.type === "throw") {
                  throw record.arg;
                }
                if (record.type === "break" || record.type === "continue") {
                  this.next = record.arg;
                } else if (record.type === "return") {
                  this.rval = this.arg = record.arg;
                  this.method = "return";
                  this.next = "end";
                } else if (record.type === "normal" && afterLoc) {
                  this.next = afterLoc;
                }
                return ContinueSentinel;
              },
              finish: function finish(finallyLoc) {
                for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
                  var entry = this.tryEntries[i2];
                  if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                  }
                }
              },
              "catch": function _catch(tryLoc) {
                for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
                  var entry = this.tryEntries[i2];
                  if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                      var thrown = record.arg;
                      resetTryEntry(entry);
                    }
                    return thrown;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                this.delegate = {
                  iterator: values(iterable),
                  resultName,
                  nextLoc
                };
                if (this.method === "next") {
                  this.arg = undefined$1;
                }
                return ContinueSentinel;
              }
            };
            return exports2;
          }(_typeof2(module2) === "object" ? module2.exports : {});
          try {
            regeneratorRuntime = runtime;
          } catch (accidentalStrictMode) {
            if ((typeof globalThis === "undefined" ? "undefined" : _typeof2(globalThis)) === "object") {
              globalThis.regeneratorRuntime = runtime;
            } else {
              Function("r", "regeneratorRuntime = r")(runtime);
            }
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.VerbosityLevel = exports2.Util = exports2.UnknownErrorException = exports2.UnexpectedResponseException = exports2.UNSUPPORTED_FEATURES = exports2.TextRenderingMode = exports2.StreamType = exports2.RenderingIntentFlag = exports2.PermissionFlag = exports2.PasswordResponses = exports2.PasswordException = exports2.PageActionEventType = exports2.OPS = exports2.MissingPDFException = exports2.IsLittleEndianCached = exports2.IsEvalSupportedCached = exports2.InvalidPDFException = exports2.ImageKind = exports2.IDENTITY_MATRIX = exports2.FormatError = exports2.FontType = exports2.FONT_IDENTITY_MATRIX = exports2.DocumentActionEventType = exports2.CMapCompressionType = exports2.BaseException = exports2.AnnotationType = exports2.AnnotationStateModelType = exports2.AnnotationReviewState = exports2.AnnotationReplyType = exports2.AnnotationMode = exports2.AnnotationMarkedState = exports2.AnnotationFlag = exports2.AnnotationFieldFlag = exports2.AnnotationBorderStyleType = exports2.AnnotationActionEventType = exports2.AbortException = void 0;
          exports2.arrayByteLength = arrayByteLength;
          exports2.arraysToBytes = arraysToBytes;
          exports2.assert = assert2;
          exports2.bytesToString = bytesToString;
          exports2.createObjectURL = createObjectURL;
          exports2.createPromiseCapability = createPromiseCapability;
          exports2.createValidAbsoluteUrl = createValidAbsoluteUrl;
          exports2.escapeString = escapeString;
          exports2.getModificationDate = getModificationDate;
          exports2.getVerbosityLevel = getVerbosityLevel;
          exports2.info = info;
          exports2.isArrayBuffer = isArrayBuffer2;
          exports2.isArrayEqual = isArrayEqual;
          exports2.isAscii = isAscii;
          exports2.isBool = isBool;
          exports2.isNum = isNum2;
          exports2.isSameOrigin = isSameOrigin;
          exports2.isString = isString2;
          exports2.objectFromMap = objectFromMap;
          exports2.objectSize = objectSize;
          exports2.removeNullCharacters = removeNullCharacters;
          exports2.setVerbosityLevel = setVerbosityLevel;
          exports2.shadow = shadow;
          exports2.string32 = string32;
          exports2.stringToBytes = stringToBytes;
          exports2.stringToPDFString = stringToPDFString;
          exports2.stringToUTF16BEString = stringToUTF16BEString;
          exports2.stringToUTF8String = stringToUTF8String;
          exports2.unreachable = unreachable;
          exports2.utf8StringToString = utf8StringToString;
          exports2.warn = warn3;
          __w_pdfjs_require__2(5);
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _toConsumableArray2(arr2) {
            return _arrayWithoutHoles2(arr2) || _iterableToArray2(arr2) || _unsupportedIterableToArray2(arr2) || _nonIterableSpread2();
          }
          function _nonIterableSpread2() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArray2(iter) {
            if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
              return Array.from(iter);
          }
          function _arrayWithoutHoles2(arr2) {
            if (Array.isArray(arr2))
              return _arrayLikeToArray2(arr2);
          }
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e3) {
              didErr = true;
              err = _e3;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
          exports2.IDENTITY_MATRIX = IDENTITY_MATRIX;
          var FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0];
          exports2.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
          var RenderingIntentFlag = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          exports2.RenderingIntentFlag = RenderingIntentFlag;
          var AnnotationMode = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          exports2.AnnotationMode = AnnotationMode;
          var PermissionFlag = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          exports2.PermissionFlag = PermissionFlag;
          var TextRenderingMode = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          exports2.TextRenderingMode = TextRenderingMode;
          var ImageKind = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          exports2.ImageKind = ImageKind;
          var AnnotationType = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          exports2.AnnotationType = AnnotationType;
          var AnnotationStateModelType = {
            MARKED: "Marked",
            REVIEW: "Review"
          };
          exports2.AnnotationStateModelType = AnnotationStateModelType;
          var AnnotationMarkedState = {
            MARKED: "Marked",
            UNMARKED: "Unmarked"
          };
          exports2.AnnotationMarkedState = AnnotationMarkedState;
          var AnnotationReviewState = {
            ACCEPTED: "Accepted",
            REJECTED: "Rejected",
            CANCELLED: "Cancelled",
            COMPLETED: "Completed",
            NONE: "None"
          };
          exports2.AnnotationReviewState = AnnotationReviewState;
          var AnnotationReplyType = {
            GROUP: "Group",
            REPLY: "R"
          };
          exports2.AnnotationReplyType = AnnotationReplyType;
          var AnnotationFlag = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          exports2.AnnotationFlag = AnnotationFlag;
          var AnnotationFieldFlag = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          exports2.AnnotationFieldFlag = AnnotationFieldFlag;
          var AnnotationBorderStyleType = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          exports2.AnnotationBorderStyleType = AnnotationBorderStyleType;
          var AnnotationActionEventType = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          exports2.AnnotationActionEventType = AnnotationActionEventType;
          var DocumentActionEventType = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          exports2.DocumentActionEventType = DocumentActionEventType;
          var PageActionEventType = {
            O: "PageOpen",
            C: "PageClose"
          };
          exports2.PageActionEventType = PageActionEventType;
          var StreamType = {
            UNKNOWN: "UNKNOWN",
            FLATE: "FLATE",
            LZW: "LZW",
            DCT: "DCT",
            JPX: "JPX",
            JBIG: "JBIG",
            A85: "A85",
            AHX: "AHX",
            CCF: "CCF",
            RLX: "RLX"
          };
          exports2.StreamType = StreamType;
          var FontType = {
            UNKNOWN: "UNKNOWN",
            TYPE1: "TYPE1",
            TYPE1STANDARD: "TYPE1STANDARD",
            TYPE1C: "TYPE1C",
            CIDFONTTYPE0: "CIDFONTTYPE0",
            CIDFONTTYPE0C: "CIDFONTTYPE0C",
            TRUETYPE: "TRUETYPE",
            CIDFONTTYPE2: "CIDFONTTYPE2",
            TYPE3: "TYPE3",
            OPENTYPE: "OPENTYPE",
            TYPE0: "TYPE0",
            MMTYPE1: "MMTYPE1"
          };
          exports2.FontType = FontType;
          var VerbosityLevel = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          exports2.VerbosityLevel = VerbosityLevel;
          var CMapCompressionType = {
            NONE: 0,
            BINARY: 1,
            STREAM: 2
          };
          exports2.CMapCompressionType = CMapCompressionType;
          var OPS = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotations: 78,
            endAnnotations: 79,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintJpegXObject: 82,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          exports2.OPS = OPS;
          var UNSUPPORTED_FEATURES = {
            unknown: "unknown",
            forms: "forms",
            javaScript: "javaScript",
            signatures: "signatures",
            smask: "smask",
            shadingPattern: "shadingPattern",
            font: "font",
            errorTilingPattern: "errorTilingPattern",
            errorExtGState: "errorExtGState",
            errorXObject: "errorXObject",
            errorFontLoadType3: "errorFontLoadType3",
            errorFontState: "errorFontState",
            errorFontMissing: "errorFontMissing",
            errorFontTranslate: "errorFontTranslate",
            errorColorSpace: "errorColorSpace",
            errorOperatorList: "errorOperatorList",
            errorFontToUnicode: "errorFontToUnicode",
            errorFontLoadNative: "errorFontLoadNative",
            errorFontBuildPath: "errorFontBuildPath",
            errorFontGetPath: "errorFontGetPath",
            errorMarkedContent: "errorMarkedContent",
            errorContentSubStream: "errorContentSubStream"
          };
          exports2.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
          var PasswordResponses2 = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          exports2.PasswordResponses = PasswordResponses2;
          var verbosity = VerbosityLevel.WARNINGS;
          function setVerbosityLevel(level) {
            if (Number.isInteger(level)) {
              verbosity = level;
            }
          }
          function getVerbosityLevel() {
            return verbosity;
          }
          function info(msg) {
            if (verbosity >= VerbosityLevel.INFOS) {
              console.log("Info: ".concat(msg));
            }
          }
          function warn3(msg) {
            if (verbosity >= VerbosityLevel.WARNINGS) {
              console.log("Warning: ".concat(msg));
            }
          }
          function unreachable(msg) {
            throw new Error(msg);
          }
          function assert2(cond, msg) {
            if (!cond) {
              unreachable(msg);
            }
          }
          function isSameOrigin(baseUrl, otherUrl) {
            var base;
            try {
              base = new URL(baseUrl);
              if (!base.origin || base.origin === "null") {
                return false;
              }
            } catch (e2) {
              return false;
            }
            var other = new URL(otherUrl, base);
            return base.origin === other.origin;
          }
          function _isValidProtocol(url) {
            if (!url) {
              return false;
            }
            switch (url.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return true;
              default:
                return false;
            }
          }
          function createValidAbsoluteUrl(url) {
            var baseUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (!url) {
              return null;
            }
            try {
              if (options && typeof url === "string") {
                if (options.addDefaultProtocol && url.startsWith("www.")) {
                  var dots = url.match(/\./g);
                  if (dots && dots.length >= 2) {
                    url = "http://".concat(url);
                  }
                }
                if (options.tryConvertEncoding) {
                  try {
                    url = stringToUTF8String(url);
                  } catch (ex) {
                  }
                }
              }
              var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
              if (_isValidProtocol(absoluteUrl)) {
                return absoluteUrl;
              }
            } catch (ex) {
            }
            return null;
          }
          function shadow(obj, prop, value) {
            Object.defineProperty(obj, prop, {
              value,
              enumerable: true,
              configurable: true,
              writable: false
            });
            return value;
          }
          var BaseException = function BaseExceptionClosure() {
            function BaseException2(message2, name) {
              if (this.constructor === BaseException2) {
                unreachable("Cannot initialize BaseException.");
              }
              this.message = message2;
              this.name = name;
            }
            BaseException2.prototype = new Error();
            BaseException2.constructor = BaseException2;
            return BaseException2;
          }();
          exports2.BaseException = BaseException;
          var PasswordException = /* @__PURE__ */ function(_BaseException) {
            _inherits2(PasswordException2, _BaseException);
            var _super = _createSuper2(PasswordException2);
            function PasswordException2(msg, code) {
              var _this;
              _classCallCheck2(this, PasswordException2);
              _this = _super.call(this, msg, "PasswordException");
              _this.code = code;
              return _this;
            }
            return PasswordException2;
          }(BaseException);
          exports2.PasswordException = PasswordException;
          var UnknownErrorException = /* @__PURE__ */ function(_BaseException2) {
            _inherits2(UnknownErrorException2, _BaseException2);
            var _super2 = _createSuper2(UnknownErrorException2);
            function UnknownErrorException2(msg, details) {
              var _this2;
              _classCallCheck2(this, UnknownErrorException2);
              _this2 = _super2.call(this, msg, "UnknownErrorException");
              _this2.details = details;
              return _this2;
            }
            return UnknownErrorException2;
          }(BaseException);
          exports2.UnknownErrorException = UnknownErrorException;
          var InvalidPDFException = /* @__PURE__ */ function(_BaseException3) {
            _inherits2(InvalidPDFException2, _BaseException3);
            var _super3 = _createSuper2(InvalidPDFException2);
            function InvalidPDFException2(msg) {
              _classCallCheck2(this, InvalidPDFException2);
              return _super3.call(this, msg, "InvalidPDFException");
            }
            return InvalidPDFException2;
          }(BaseException);
          exports2.InvalidPDFException = InvalidPDFException;
          var MissingPDFException = /* @__PURE__ */ function(_BaseException4) {
            _inherits2(MissingPDFException2, _BaseException4);
            var _super4 = _createSuper2(MissingPDFException2);
            function MissingPDFException2(msg) {
              _classCallCheck2(this, MissingPDFException2);
              return _super4.call(this, msg, "MissingPDFException");
            }
            return MissingPDFException2;
          }(BaseException);
          exports2.MissingPDFException = MissingPDFException;
          var UnexpectedResponseException = /* @__PURE__ */ function(_BaseException5) {
            _inherits2(UnexpectedResponseException2, _BaseException5);
            var _super5 = _createSuper2(UnexpectedResponseException2);
            function UnexpectedResponseException2(msg, status) {
              var _this3;
              _classCallCheck2(this, UnexpectedResponseException2);
              _this3 = _super5.call(this, msg, "UnexpectedResponseException");
              _this3.status = status;
              return _this3;
            }
            return UnexpectedResponseException2;
          }(BaseException);
          exports2.UnexpectedResponseException = UnexpectedResponseException;
          var FormatError = /* @__PURE__ */ function(_BaseException6) {
            _inherits2(FormatError2, _BaseException6);
            var _super6 = _createSuper2(FormatError2);
            function FormatError2(msg) {
              _classCallCheck2(this, FormatError2);
              return _super6.call(this, msg, "FormatError");
            }
            return FormatError2;
          }(BaseException);
          exports2.FormatError = FormatError;
          var AbortException = /* @__PURE__ */ function(_BaseException7) {
            _inherits2(AbortException2, _BaseException7);
            var _super7 = _createSuper2(AbortException2);
            function AbortException2(msg) {
              _classCallCheck2(this, AbortException2);
              return _super7.call(this, msg, "AbortException");
            }
            return AbortException2;
          }(BaseException);
          exports2.AbortException = AbortException;
          var NullCharactersRegExp = /\x00+/g;
          var InvisibleCharactersRegExp = /[\x01-\x1F]/g;
          function removeNullCharacters(str) {
            var replaceInvisible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (typeof str !== "string") {
              warn3("The argument for removeNullCharacters must be a string.");
              return str;
            }
            if (replaceInvisible) {
              str = str.replace(InvisibleCharactersRegExp, " ");
            }
            return str.replace(NullCharactersRegExp, "");
          }
          function bytesToString(bytes) {
            assert2(bytes !== null && _typeof2(bytes) === "object" && bytes.length !== void 0, "Invalid argument for bytesToString");
            var length = bytes.length;
            var MAX_ARGUMENT_COUNT = 8192;
            if (length < MAX_ARGUMENT_COUNT) {
              return String.fromCharCode.apply(null, bytes);
            }
            var strBuf = [];
            for (var i2 = 0; i2 < length; i2 += MAX_ARGUMENT_COUNT) {
              var chunkEnd = Math.min(i2 + MAX_ARGUMENT_COUNT, length);
              var chunk = bytes.subarray(i2, chunkEnd);
              strBuf.push(String.fromCharCode.apply(null, chunk));
            }
            return strBuf.join("");
          }
          function stringToBytes(str) {
            assert2(typeof str === "string", "Invalid argument for stringToBytes");
            var length = str.length;
            var bytes = new Uint8Array(length);
            for (var i2 = 0; i2 < length; ++i2) {
              bytes[i2] = str.charCodeAt(i2) & 255;
            }
            return bytes;
          }
          function arrayByteLength(arr2) {
            if (arr2.length !== void 0) {
              return arr2.length;
            }
            assert2(arr2.byteLength !== void 0, "arrayByteLength - invalid argument.");
            return arr2.byteLength;
          }
          function arraysToBytes(arr2) {
            var length = arr2.length;
            if (length === 1 && arr2[0] instanceof Uint8Array) {
              return arr2[0];
            }
            var resultLength = 0;
            for (var i2 = 0; i2 < length; i2++) {
              resultLength += arrayByteLength(arr2[i2]);
            }
            var pos = 0;
            var data2 = new Uint8Array(resultLength);
            for (var _i = 0; _i < length; _i++) {
              var item = arr2[_i];
              if (!(item instanceof Uint8Array)) {
                if (typeof item === "string") {
                  item = stringToBytes(item);
                } else {
                  item = new Uint8Array(item);
                }
              }
              var itemLength = item.byteLength;
              data2.set(item, pos);
              pos += itemLength;
            }
            return data2;
          }
          function string32(value) {
            return String.fromCharCode(value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255);
          }
          function objectSize(obj) {
            return Object.keys(obj).length;
          }
          function objectFromMap(map) {
            var obj = /* @__PURE__ */ Object.create(null);
            var _iterator = _createForOfIteratorHelper2(map), _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                var _step$value = _slicedToArray2(_step.value, 2), key = _step$value[0], value = _step$value[1];
                obj[key] = value;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return obj;
          }
          function isLittleEndian() {
            var buffer8 = new Uint8Array(4);
            buffer8[0] = 1;
            var view32 = new Uint32Array(buffer8.buffer, 0, 1);
            return view32[0] === 1;
          }
          var IsLittleEndianCached = {
            get value() {
              return shadow(this, "value", isLittleEndian());
            }
          };
          exports2.IsLittleEndianCached = IsLittleEndianCached;
          function isEvalSupported() {
            try {
              new Function("");
              return true;
            } catch (e2) {
              return false;
            }
          }
          var IsEvalSupportedCached = {
            get value() {
              return shadow(this, "value", isEvalSupported());
            }
          };
          exports2.IsEvalSupportedCached = IsEvalSupportedCached;
          var hexNumbers = _toConsumableArray2(Array(256).keys()).map(function(n2) {
            return n2.toString(16).padStart(2, "0");
          });
          var Util = /* @__PURE__ */ function() {
            function Util2() {
              _classCallCheck2(this, Util2);
            }
            _createClass2(Util2, null, [{
              key: "makeHexColor",
              value: function makeHexColor(r2, g2, b2) {
                return "#".concat(hexNumbers[r2]).concat(hexNumbers[g2]).concat(hexNumbers[b2]);
              }
            }, {
              key: "transform",
              value: function transform2(m1, m2) {
                return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
              }
            }, {
              key: "applyTransform",
              value: function applyTransform(p2, m2) {
                var xt = p2[0] * m2[0] + p2[1] * m2[2] + m2[4];
                var yt = p2[0] * m2[1] + p2[1] * m2[3] + m2[5];
                return [xt, yt];
              }
            }, {
              key: "applyInverseTransform",
              value: function applyInverseTransform(p2, m2) {
                var d2 = m2[0] * m2[3] - m2[1] * m2[2];
                var xt = (p2[0] * m2[3] - p2[1] * m2[2] + m2[2] * m2[5] - m2[4] * m2[3]) / d2;
                var yt = (-p2[0] * m2[1] + p2[1] * m2[0] + m2[4] * m2[1] - m2[5] * m2[0]) / d2;
                return [xt, yt];
              }
            }, {
              key: "getAxialAlignedBoundingBox",
              value: function getAxialAlignedBoundingBox(r2, m2) {
                var p1 = Util2.applyTransform(r2, m2);
                var p2 = Util2.applyTransform(r2.slice(2, 4), m2);
                var p3 = Util2.applyTransform([r2[0], r2[3]], m2);
                var p4 = Util2.applyTransform([r2[2], r2[1]], m2);
                return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
              }
            }, {
              key: "inverseTransform",
              value: function inverseTransform(m2) {
                var d2 = m2[0] * m2[3] - m2[1] * m2[2];
                return [m2[3] / d2, -m2[1] / d2, -m2[2] / d2, m2[0] / d2, (m2[2] * m2[5] - m2[4] * m2[3]) / d2, (m2[4] * m2[1] - m2[5] * m2[0]) / d2];
              }
            }, {
              key: "apply3dTransform",
              value: function apply3dTransform(m2, v2) {
                return [m2[0] * v2[0] + m2[1] * v2[1] + m2[2] * v2[2], m2[3] * v2[0] + m2[4] * v2[1] + m2[5] * v2[2], m2[6] * v2[0] + m2[7] * v2[1] + m2[8] * v2[2]];
              }
            }, {
              key: "singularValueDecompose2dScale",
              value: function singularValueDecompose2dScale(m2) {
                var transpose2 = [m2[0], m2[2], m2[1], m2[3]];
                var a6 = m2[0] * transpose2[0] + m2[1] * transpose2[2];
                var b2 = m2[0] * transpose2[1] + m2[1] * transpose2[3];
                var c2 = m2[2] * transpose2[0] + m2[3] * transpose2[2];
                var d2 = m2[2] * transpose2[1] + m2[3] * transpose2[3];
                var first = (a6 + d2) / 2;
                var second = Math.sqrt(Math.pow(a6 + d2, 2) - 4 * (a6 * d2 - c2 * b2)) / 2;
                var sx = first + second || 1;
                var sy = first - second || 1;
                return [Math.sqrt(sx), Math.sqrt(sy)];
              }
            }, {
              key: "normalizeRect",
              value: function normalizeRect(rect) {
                var r2 = rect.slice(0);
                if (rect[0] > rect[2]) {
                  r2[0] = rect[2];
                  r2[2] = rect[0];
                }
                if (rect[1] > rect[3]) {
                  r2[1] = rect[3];
                  r2[3] = rect[1];
                }
                return r2;
              }
            }, {
              key: "intersect",
              value: function intersect(rect1, rect2) {
                function compare3(a6, b2) {
                  return a6 - b2;
                }
                var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare3);
                var orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare3);
                var result2 = [];
                rect1 = Util2.normalizeRect(rect1);
                rect2 = Util2.normalizeRect(rect2);
                if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
                  result2[0] = orderedX[1];
                  result2[2] = orderedX[2];
                } else {
                  return null;
                }
                if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
                  result2[1] = orderedY[1];
                  result2[3] = orderedY[2];
                } else {
                  return null;
                }
                return result2;
              }
            }, {
              key: "bezierBoundingBox",
              value: function bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                var tvalues = [], bounds = [[], []];
                var a6, b2, c2, t2, t1, t22, b2ac, sqrtb2ac;
                for (var i2 = 0; i2 < 2; ++i2) {
                  if (i2 === 0) {
                    b2 = 6 * x0 - 12 * x1 + 6 * x2;
                    a6 = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                    c2 = 3 * x1 - 3 * x0;
                  } else {
                    b2 = 6 * y0 - 12 * y1 + 6 * y2;
                    a6 = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                    c2 = 3 * y1 - 3 * y0;
                  }
                  if (Math.abs(a6) < 1e-12) {
                    if (Math.abs(b2) < 1e-12) {
                      continue;
                    }
                    t2 = -c2 / b2;
                    if (0 < t2 && t2 < 1) {
                      tvalues.push(t2);
                    }
                    continue;
                  }
                  b2ac = b2 * b2 - 4 * c2 * a6;
                  sqrtb2ac = Math.sqrt(b2ac);
                  if (b2ac < 0) {
                    continue;
                  }
                  t1 = (-b2 + sqrtb2ac) / (2 * a6);
                  if (0 < t1 && t1 < 1) {
                    tvalues.push(t1);
                  }
                  t22 = (-b2 - sqrtb2ac) / (2 * a6);
                  if (0 < t22 && t22 < 1) {
                    tvalues.push(t22);
                  }
                }
                var j2 = tvalues.length, mt;
                var jlen = j2;
                while (j2--) {
                  t2 = tvalues[j2];
                  mt = 1 - t2;
                  bounds[0][j2] = mt * mt * mt * x0 + 3 * mt * mt * t2 * x1 + 3 * mt * t2 * t2 * x2 + t2 * t2 * t2 * x3;
                  bounds[1][j2] = mt * mt * mt * y0 + 3 * mt * mt * t2 * y1 + 3 * mt * t2 * t2 * y2 + t2 * t2 * t2 * y3;
                }
                bounds[0][jlen] = x0;
                bounds[1][jlen] = y0;
                bounds[0][jlen + 1] = x3;
                bounds[1][jlen + 1] = y3;
                bounds[0].length = bounds[1].length = jlen + 2;
                return [Math.min.apply(Math, _toConsumableArray2(bounds[0])), Math.min.apply(Math, _toConsumableArray2(bounds[1])), Math.max.apply(Math, _toConsumableArray2(bounds[0])), Math.max.apply(Math, _toConsumableArray2(bounds[1]))];
              }
            }]);
            return Util2;
          }();
          exports2.Util = Util;
          var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function stringToPDFString(str) {
            var length = str.length, strBuf = [];
            if (str[0] === "\xFE" && str[1] === "\xFF") {
              for (var i2 = 2; i2 < length; i2 += 2) {
                strBuf.push(String.fromCharCode(str.charCodeAt(i2) << 8 | str.charCodeAt(i2 + 1)));
              }
            } else if (str[0] === "\xFF" && str[1] === "\xFE") {
              for (var _i2 = 2; _i2 < length; _i2 += 2) {
                strBuf.push(String.fromCharCode(str.charCodeAt(_i2 + 1) << 8 | str.charCodeAt(_i2)));
              }
            } else {
              for (var _i3 = 0; _i3 < length; ++_i3) {
                var code = PDFStringTranslateTable[str.charCodeAt(_i3)];
                strBuf.push(code ? String.fromCharCode(code) : str.charAt(_i3));
              }
            }
            return strBuf.join("");
          }
          function escapeString(str) {
            return str.replace(/([()\\\n\r])/g, function(match) {
              if (match === "\n") {
                return "\\n";
              } else if (match === "\r") {
                return "\\r";
              }
              return "\\".concat(match);
            });
          }
          function isAscii(str) {
            return /^[\x00-\x7F]*$/.test(str);
          }
          function stringToUTF16BEString(str) {
            var buf = ["\xFE\xFF"];
            for (var i2 = 0, ii = str.length; i2 < ii; i2++) {
              var _char = str.charCodeAt(i2);
              buf.push(String.fromCharCode(_char >> 8 & 255), String.fromCharCode(_char & 255));
            }
            return buf.join("");
          }
          function stringToUTF8String(str) {
            return decodeURIComponent(escape(str));
          }
          function utf8StringToString(str) {
            return unescape(encodeURIComponent(str));
          }
          function isBool(v2) {
            return typeof v2 === "boolean";
          }
          function isNum2(v2) {
            return typeof v2 === "number";
          }
          function isString2(v2) {
            return typeof v2 === "string";
          }
          function isArrayBuffer2(v2) {
            return _typeof2(v2) === "object" && v2 !== null && v2.byteLength !== void 0;
          }
          function isArrayEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) {
              return false;
            }
            for (var i2 = 0, ii = arr1.length; i2 < ii; i2++) {
              if (arr1[i2] !== arr2[i2]) {
                return false;
              }
            }
            return true;
          }
          function getModificationDate() {
            var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
            var buffer2 = [date.getUTCFullYear().toString(), (date.getUTCMonth() + 1).toString().padStart(2, "0"), date.getUTCDate().toString().padStart(2, "0"), date.getUTCHours().toString().padStart(2, "0"), date.getUTCMinutes().toString().padStart(2, "0"), date.getUTCSeconds().toString().padStart(2, "0")];
            return buffer2.join("");
          }
          function createPromiseCapability() {
            var capability = /* @__PURE__ */ Object.create(null);
            var isSettled = false;
            Object.defineProperty(capability, "settled", {
              get: function get2() {
                return isSettled;
              }
            });
            capability.promise = new Promise(function(resolve, reject) {
              capability.resolve = function(data2) {
                isSettled = true;
                resolve(data2);
              };
              capability.reject = function(reason) {
                isSettled = true;
                reject(reason);
              };
            });
            return capability;
          }
          function createObjectURL(data2) {
            var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            var forceDataSchema = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) {
              return URL.createObjectURL(new Blob([data2], {
                type: contentType
              }));
            }
            var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var buffer2 = "data:".concat(contentType, ";base64,");
            for (var i2 = 0, ii = data2.length; i2 < ii; i2 += 3) {
              var b1 = data2[i2] & 255;
              var b2 = data2[i2 + 1] & 255;
              var b3 = data2[i2 + 2] & 255;
              var d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
              var d3 = i2 + 1 < ii ? (b2 & 15) << 2 | b3 >> 6 : 64;
              var d4 = i2 + 2 < ii ? b3 & 63 : 64;
              buffer2 += digits[d1] + digits[d2] + digits[d3] + digits[d4];
            }
            return buffer2;
          }
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var _is_node2 = __w_pdfjs_require__2(6);
          if (typeof globalThis === "undefined" || !globalThis._pdfjsCompatibilityChecked) {
            if (typeof globalThis === "undefined" || globalThis.Math !== Math) {
              globalThis = __w_pdfjs_require__2(7);
            }
            globalThis._pdfjsCompatibilityChecked = true;
            (function checkNodeBtoa() {
              if (globalThis.btoa || !_is_node2.isNodeJS) {
                return;
              }
              globalThis.btoa = function(chars2) {
                return Buffer.from(chars2, "binary").toString("base64");
              };
            })();
            (function checkNodeAtob() {
              if (globalThis.atob || !_is_node2.isNodeJS) {
                return;
              }
              globalThis.atob = function(input) {
                return Buffer.from(input, "base64").toString("binary");
              };
            })();
            (function checkDOMMatrix() {
              if (globalThis.DOMMatrix || !_is_node2.isNodeJS) {
                return;
              }
              globalThis.DOMMatrix = __w_pdfjs_require__2(69);
            })();
            (function checkObjectFromEntries() {
              if (Object.fromEntries) {
                return;
              }
              __w_pdfjs_require__2(70);
            })();
            (function checkPromise() {
              if (globalThis.Promise.allSettled) {
                return;
              }
              globalThis.Promise = __w_pdfjs_require__2(97);
            })();
            (function checkReadableStream() {
              if (globalThis.ReadableStream || !_is_node2.isNodeJS) {
                return;
              }
              globalThis.ReadableStream = __w_pdfjs_require__2(134).ReadableStream;
            })();
          }
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.isNodeJS = void 0;
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          var isNodeJS = (typeof process === "undefined" ? "undefined" : _typeof2(process)) === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          exports2.isNodeJS = isNodeJS;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          __w_pdfjs_require__2(8);
          module2.exports = __w_pdfjs_require__2(10);
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var global2 = __w_pdfjs_require__2(10);
          $2({ global: true }, { globalThis: global2 });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var getOwnPropertyDescriptor2 = __w_pdfjs_require__2(11).f;
          var createNonEnumerableProperty = __w_pdfjs_require__2(47);
          var redefine = __w_pdfjs_require__2(50);
          var setGlobal = __w_pdfjs_require__2(41);
          var copyConstructorProperties = __w_pdfjs_require__2(57);
          var isForced = __w_pdfjs_require__2(68);
          module2.exports = function(options, source2) {
            var TARGET = options.target;
            var GLOBAL = options.global;
            var STATIC = options.stat;
            var FORCED, target, key, targetProperty, sourceProperty, descriptor;
            if (GLOBAL) {
              target = global2;
            } else if (STATIC) {
              target = global2[TARGET] || setGlobal(TARGET, {});
            } else {
              target = (global2[TARGET] || {}).prototype;
            }
            if (target)
              for (key in source2) {
                sourceProperty = source2[key];
                if (options.noTargetGet) {
                  descriptor = getOwnPropertyDescriptor2(target, key);
                  targetProperty = descriptor && descriptor.value;
                } else
                  targetProperty = target[key];
                FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                if (!FORCED && targetProperty !== void 0) {
                  if (typeof sourceProperty == typeof targetProperty)
                    continue;
                  copyConstructorProperties(sourceProperty, targetProperty);
                }
                if (options.sham || targetProperty && targetProperty.sham) {
                  createNonEnumerableProperty(sourceProperty, "sham", true);
                }
                redefine(target, key, sourceProperty, options);
              }
          };
        },
        (module2) => {
          var check2 = function(it) {
            return it && it.Math == Math && it;
          };
          module2.exports = check2(typeof globalThis == "object" && globalThis) || check2(typeof window == "object" && window) || check2(typeof self == "object" && self) || check2(typeof commonjsGlobal == "object" && commonjsGlobal) || function() {
            return this;
          }() || Function("return this")();
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var call = __w_pdfjs_require__2(14);
          var propertyIsEnumerableModule = __w_pdfjs_require__2(15);
          var createPropertyDescriptor = __w_pdfjs_require__2(16);
          var toIndexedObject = __w_pdfjs_require__2(17);
          var toPropertyKey = __w_pdfjs_require__2(22);
          var hasOwn = __w_pdfjs_require__2(42);
          var IE8_DOM_DEFINE = __w_pdfjs_require__2(45);
          var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
          exports2.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor2(O, P2) {
            O = toIndexedObject(O);
            P2 = toPropertyKey(P2);
            if (IE8_DOM_DEFINE)
              try {
                return $getOwnPropertyDescriptor(O, P2);
              } catch (error3) {
              }
            if (hasOwn(O, P2))
              return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P2), O[P2]);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var fails = __w_pdfjs_require__2(13);
          module2.exports = !fails(function() {
            return Object.defineProperty({}, 1, {
              get: function() {
                return 7;
              }
            })[1] != 7;
          });
        },
        (module2) => {
          module2.exports = function(exec) {
            try {
              return !!exec();
            } catch (error3) {
              return true;
            }
          };
        },
        (module2) => {
          var call = Function.prototype.call;
          module2.exports = call.bind ? call.bind(call) : function() {
            return call.apply(call, arguments);
          };
        },
        (__unused_webpack_module2, exports2) => {
          var $propertyIsEnumerable = {}.propertyIsEnumerable;
          var getOwnPropertyDescriptor2 = Object.getOwnPropertyDescriptor;
          var NASHORN_BUG = getOwnPropertyDescriptor2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);
          exports2.f = NASHORN_BUG ? function propertyIsEnumerable(V2) {
            var descriptor = getOwnPropertyDescriptor2(this, V2);
            return !!descriptor && descriptor.enumerable;
          } : $propertyIsEnumerable;
        },
        (module2) => {
          module2.exports = function(bitmap, value) {
            return {
              enumerable: !(bitmap & 1),
              configurable: !(bitmap & 2),
              writable: !(bitmap & 4),
              value
            };
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var IndexedObject = __w_pdfjs_require__2(18);
          var requireObjectCoercible = __w_pdfjs_require__2(21);
          module2.exports = function(it) {
            return IndexedObject(requireObjectCoercible(it));
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var uncurryThis = __w_pdfjs_require__2(19);
          var fails = __w_pdfjs_require__2(13);
          var classof = __w_pdfjs_require__2(20);
          var Object2 = global2.Object;
          var split2 = uncurryThis("".split);
          module2.exports = fails(function() {
            return !Object2("z").propertyIsEnumerable(0);
          }) ? function(it) {
            return classof(it) == "String" ? split2(it, "") : Object2(it);
          } : Object2;
        },
        (module2) => {
          var FunctionPrototype = Function.prototype;
          var bind3 = FunctionPrototype.bind;
          var call = FunctionPrototype.call;
          var callBind = bind3 && bind3.bind(call);
          module2.exports = bind3 ? function(fn) {
            return fn && callBind(call, fn);
          } : function(fn) {
            return fn && function() {
              return call.apply(fn, arguments);
            };
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var toString4 = uncurryThis({}.toString);
          var stringSlice = uncurryThis("".slice);
          module2.exports = function(it) {
            return stringSlice(toString4(it), 8, -1);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var TypeError2 = global2.TypeError;
          module2.exports = function(it) {
            if (it == void 0)
              throw TypeError2("Can't call method on " + it);
            return it;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toPrimitive = __w_pdfjs_require__2(23);
          var isSymbol2 = __w_pdfjs_require__2(26);
          module2.exports = function(argument) {
            var key = toPrimitive(argument, "string");
            return isSymbol2(key) ? key : key + "";
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var call = __w_pdfjs_require__2(14);
          var isObject3 = __w_pdfjs_require__2(24);
          var isSymbol2 = __w_pdfjs_require__2(26);
          var getMethod = __w_pdfjs_require__2(33);
          var ordinaryToPrimitive = __w_pdfjs_require__2(36);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var TypeError2 = global2.TypeError;
          var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
          module2.exports = function(input, pref) {
            if (!isObject3(input) || isSymbol2(input))
              return input;
            var exoticToPrim = getMethod(input, TO_PRIMITIVE);
            var result2;
            if (exoticToPrim) {
              if (pref === void 0)
                pref = "default";
              result2 = call(exoticToPrim, input, pref);
              if (!isObject3(result2) || isSymbol2(result2))
                return result2;
              throw TypeError2("Can't convert object to primitive value");
            }
            if (pref === void 0)
              pref = "number";
            return ordinaryToPrimitive(input, pref);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var isCallable = __w_pdfjs_require__2(25);
          module2.exports = function(it) {
            return typeof it == "object" ? it !== null : isCallable(it);
          };
        },
        (module2) => {
          module2.exports = function(argument) {
            return typeof argument == "function";
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var getBuiltIn = __w_pdfjs_require__2(27);
          var isCallable = __w_pdfjs_require__2(25);
          var isPrototypeOf = __w_pdfjs_require__2(28);
          var USE_SYMBOL_AS_UID = __w_pdfjs_require__2(29);
          var Object2 = global2.Object;
          module2.exports = USE_SYMBOL_AS_UID ? function(it) {
            return typeof it == "symbol";
          } : function(it) {
            var $Symbol = getBuiltIn("Symbol");
            return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object2(it));
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isCallable = __w_pdfjs_require__2(25);
          var aFunction = function(argument) {
            return isCallable(argument) ? argument : void 0;
          };
          module2.exports = function(namespace, method2) {
            return arguments.length < 2 ? aFunction(global2[namespace]) : global2[namespace] && global2[namespace][method2];
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          module2.exports = uncurryThis({}.isPrototypeOf);
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var NATIVE_SYMBOL = __w_pdfjs_require__2(30);
          module2.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var V8_VERSION = __w_pdfjs_require__2(31);
          var fails = __w_pdfjs_require__2(13);
          module2.exports = !!Object.getOwnPropertySymbols && !fails(function() {
            var symbol = Symbol();
            return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var userAgent = __w_pdfjs_require__2(32);
          var process2 = global2.process;
          var Deno = global2.Deno;
          var versions = process2 && process2.versions || Deno && Deno.version;
          var v8 = versions && versions.v8;
          var match, version2;
          if (v8) {
            match = v8.split(".");
            version2 = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
          }
          if (!version2 && userAgent) {
            match = userAgent.match(/Edge\/(\d+)/);
            if (!match || match[1] >= 74) {
              match = userAgent.match(/Chrome\/(\d+)/);
              if (match)
                version2 = +match[1];
            }
          }
          module2.exports = version2;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var getBuiltIn = __w_pdfjs_require__2(27);
          module2.exports = getBuiltIn("navigator", "userAgent") || "";
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var aCallable = __w_pdfjs_require__2(34);
          module2.exports = function(V2, P2) {
            var func = V2[P2];
            return func == null ? void 0 : aCallable(func);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isCallable = __w_pdfjs_require__2(25);
          var tryToString = __w_pdfjs_require__2(35);
          var TypeError2 = global2.TypeError;
          module2.exports = function(argument) {
            if (isCallable(argument))
              return argument;
            throw TypeError2(tryToString(argument) + " is not a function");
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var String2 = global2.String;
          module2.exports = function(argument) {
            try {
              return String2(argument);
            } catch (error3) {
              return "Object";
            }
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var call = __w_pdfjs_require__2(14);
          var isCallable = __w_pdfjs_require__2(25);
          var isObject3 = __w_pdfjs_require__2(24);
          var TypeError2 = global2.TypeError;
          module2.exports = function(input, pref) {
            var fn, val;
            if (pref === "string" && isCallable(fn = input.toString) && !isObject3(val = call(fn, input)))
              return val;
            if (isCallable(fn = input.valueOf) && !isObject3(val = call(fn, input)))
              return val;
            if (pref !== "string" && isCallable(fn = input.toString) && !isObject3(val = call(fn, input)))
              return val;
            throw TypeError2("Can't convert object to primitive value");
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var shared2 = __w_pdfjs_require__2(38);
          var hasOwn = __w_pdfjs_require__2(42);
          var uid = __w_pdfjs_require__2(44);
          var NATIVE_SYMBOL = __w_pdfjs_require__2(30);
          var USE_SYMBOL_AS_UID = __w_pdfjs_require__2(29);
          var WellKnownSymbolsStore = shared2("wks");
          var Symbol2 = global2.Symbol;
          var symbolFor = Symbol2 && Symbol2["for"];
          var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol2 : Symbol2 && Symbol2.withoutSetter || uid;
          module2.exports = function(name) {
            if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
              var description = "Symbol." + name;
              if (NATIVE_SYMBOL && hasOwn(Symbol2, name)) {
                WellKnownSymbolsStore[name] = Symbol2[name];
              } else if (USE_SYMBOL_AS_UID && symbolFor) {
                WellKnownSymbolsStore[name] = symbolFor(description);
              } else {
                WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
              }
            }
            return WellKnownSymbolsStore[name];
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var IS_PURE = __w_pdfjs_require__2(39);
          var store = __w_pdfjs_require__2(40);
          (module2.exports = function(key, value) {
            return store[key] || (store[key] = value !== void 0 ? value : {});
          })("versions", []).push({
            version: "3.19.3",
            mode: IS_PURE ? "pure" : "global",
            copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)"
          });
        },
        (module2) => {
          module2.exports = false;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var setGlobal = __w_pdfjs_require__2(41);
          var SHARED = "__core-js_shared__";
          var store = global2[SHARED] || setGlobal(SHARED, {});
          module2.exports = store;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var defineProperty2 = Object.defineProperty;
          module2.exports = function(key, value) {
            try {
              defineProperty2(global2, key, {
                value,
                configurable: true,
                writable: true
              });
            } catch (error3) {
              global2[key] = value;
            }
            return value;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var toObject2 = __w_pdfjs_require__2(43);
          var hasOwnProperty2 = uncurryThis({}.hasOwnProperty);
          module2.exports = Object.hasOwn || function hasOwn(it, key) {
            return hasOwnProperty2(toObject2(it), key);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var requireObjectCoercible = __w_pdfjs_require__2(21);
          var Object2 = global2.Object;
          module2.exports = function(argument) {
            return Object2(requireObjectCoercible(argument));
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var id2 = 0;
          var postfix = Math.random();
          var toString4 = uncurryThis(1 .toString);
          module2.exports = function(key) {
            return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString4(++id2 + postfix, 36);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var fails = __w_pdfjs_require__2(13);
          var createElement2 = __w_pdfjs_require__2(46);
          module2.exports = !DESCRIPTORS && !fails(function() {
            return Object.defineProperty(createElement2("div"), "a", {
              get: function() {
                return 7;
              }
            }).a != 7;
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isObject3 = __w_pdfjs_require__2(24);
          var document2 = global2.document;
          var EXISTS = isObject3(document2) && isObject3(document2.createElement);
          module2.exports = function(it) {
            return EXISTS ? document2.createElement(it) : {};
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var definePropertyModule = __w_pdfjs_require__2(48);
          var createPropertyDescriptor = __w_pdfjs_require__2(16);
          module2.exports = DESCRIPTORS ? function(object, key, value) {
            return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
          } : function(object, key, value) {
            object[key] = value;
            return object;
          };
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var IE8_DOM_DEFINE = __w_pdfjs_require__2(45);
          var anObject = __w_pdfjs_require__2(49);
          var toPropertyKey = __w_pdfjs_require__2(22);
          var TypeError2 = global2.TypeError;
          var $defineProperty = Object.defineProperty;
          exports2.f = DESCRIPTORS ? $defineProperty : function defineProperty2(O, P2, Attributes) {
            anObject(O);
            P2 = toPropertyKey(P2);
            anObject(Attributes);
            if (IE8_DOM_DEFINE)
              try {
                return $defineProperty(O, P2, Attributes);
              } catch (error3) {
              }
            if ("get" in Attributes || "set" in Attributes)
              throw TypeError2("Accessors not supported");
            if ("value" in Attributes)
              O[P2] = Attributes.value;
            return O;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isObject3 = __w_pdfjs_require__2(24);
          var String2 = global2.String;
          var TypeError2 = global2.TypeError;
          module2.exports = function(argument) {
            if (isObject3(argument))
              return argument;
            throw TypeError2(String2(argument) + " is not an object");
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isCallable = __w_pdfjs_require__2(25);
          var hasOwn = __w_pdfjs_require__2(42);
          var createNonEnumerableProperty = __w_pdfjs_require__2(47);
          var setGlobal = __w_pdfjs_require__2(41);
          var inspectSource = __w_pdfjs_require__2(51);
          var InternalStateModule = __w_pdfjs_require__2(52);
          var CONFIGURABLE_FUNCTION_NAME = __w_pdfjs_require__2(56).CONFIGURABLE;
          var getInternalState = InternalStateModule.get;
          var enforceInternalState = InternalStateModule.enforce;
          var TEMPLATE = String(String).split("String");
          (module2.exports = function(O, key, value, options) {
            var unsafe = options ? !!options.unsafe : false;
            var simple = options ? !!options.enumerable : false;
            var noTargetGet = options ? !!options.noTargetGet : false;
            var name = options && options.name !== void 0 ? options.name : key;
            var state2;
            if (isCallable(value)) {
              if (String(name).slice(0, 7) === "Symbol(") {
                name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
              }
              if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                createNonEnumerableProperty(value, "name", name);
              }
              state2 = enforceInternalState(value);
              if (!state2.source) {
                state2.source = TEMPLATE.join(typeof name == "string" ? name : "");
              }
            }
            if (O === global2) {
              if (simple)
                O[key] = value;
              else
                setGlobal(key, value);
              return;
            } else if (!unsafe) {
              delete O[key];
            } else if (!noTargetGet && O[key]) {
              simple = true;
            }
            if (simple)
              O[key] = value;
            else
              createNonEnumerableProperty(O, key, value);
          })(Function.prototype, "toString", function toString4() {
            return isCallable(this) && getInternalState(this).source || inspectSource(this);
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var isCallable = __w_pdfjs_require__2(25);
          var store = __w_pdfjs_require__2(40);
          var functionToString = uncurryThis(Function.toString);
          if (!isCallable(store.inspectSource)) {
            store.inspectSource = function(it) {
              return functionToString(it);
            };
          }
          module2.exports = store.inspectSource;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var NATIVE_WEAK_MAP = __w_pdfjs_require__2(53);
          var global2 = __w_pdfjs_require__2(10);
          var uncurryThis = __w_pdfjs_require__2(19);
          var isObject3 = __w_pdfjs_require__2(24);
          var createNonEnumerableProperty = __w_pdfjs_require__2(47);
          var hasOwn = __w_pdfjs_require__2(42);
          var shared2 = __w_pdfjs_require__2(40);
          var sharedKey = __w_pdfjs_require__2(54);
          var hiddenKeys = __w_pdfjs_require__2(55);
          var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
          var TypeError2 = global2.TypeError;
          var WeakMap2 = global2.WeakMap;
          var set2, get2, has;
          var enforce = function(it) {
            return has(it) ? get2(it) : set2(it, {});
          };
          var getterFor = function(TYPE) {
            return function(it) {
              var state2;
              if (!isObject3(it) || (state2 = get2(it)).type !== TYPE) {
                throw TypeError2("Incompatible receiver, " + TYPE + " required");
              }
              return state2;
            };
          };
          if (NATIVE_WEAK_MAP || shared2.state) {
            var store = shared2.state || (shared2.state = new WeakMap2());
            var wmget = uncurryThis(store.get);
            var wmhas = uncurryThis(store.has);
            var wmset = uncurryThis(store.set);
            set2 = function(it, metadata2) {
              if (wmhas(store, it))
                throw new TypeError2(OBJECT_ALREADY_INITIALIZED);
              metadata2.facade = it;
              wmset(store, it, metadata2);
              return metadata2;
            };
            get2 = function(it) {
              return wmget(store, it) || {};
            };
            has = function(it) {
              return wmhas(store, it);
            };
          } else {
            var STATE = sharedKey("state");
            hiddenKeys[STATE] = true;
            set2 = function(it, metadata2) {
              if (hasOwn(it, STATE))
                throw new TypeError2(OBJECT_ALREADY_INITIALIZED);
              metadata2.facade = it;
              createNonEnumerableProperty(it, STATE, metadata2);
              return metadata2;
            };
            get2 = function(it) {
              return hasOwn(it, STATE) ? it[STATE] : {};
            };
            has = function(it) {
              return hasOwn(it, STATE);
            };
          }
          module2.exports = {
            set: set2,
            get: get2,
            has,
            enforce,
            getterFor
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isCallable = __w_pdfjs_require__2(25);
          var inspectSource = __w_pdfjs_require__2(51);
          var WeakMap2 = global2.WeakMap;
          module2.exports = isCallable(WeakMap2) && /native code/.test(inspectSource(WeakMap2));
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var shared2 = __w_pdfjs_require__2(38);
          var uid = __w_pdfjs_require__2(44);
          var keys = shared2("keys");
          module2.exports = function(key) {
            return keys[key] || (keys[key] = uid(key));
          };
        },
        (module2) => {
          module2.exports = {};
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var hasOwn = __w_pdfjs_require__2(42);
          var FunctionPrototype = Function.prototype;
          var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
          var EXISTS = hasOwn(FunctionPrototype, "name");
          var PROPER = EXISTS && function something() {
          }.name === "something";
          var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
          module2.exports = {
            EXISTS,
            PROPER,
            CONFIGURABLE
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var hasOwn = __w_pdfjs_require__2(42);
          var ownKeys2 = __w_pdfjs_require__2(58);
          var getOwnPropertyDescriptorModule = __w_pdfjs_require__2(11);
          var definePropertyModule = __w_pdfjs_require__2(48);
          module2.exports = function(target, source2) {
            var keys = ownKeys2(source2);
            var defineProperty2 = definePropertyModule.f;
            var getOwnPropertyDescriptor2 = getOwnPropertyDescriptorModule.f;
            for (var i2 = 0; i2 < keys.length; i2++) {
              var key = keys[i2];
              if (!hasOwn(target, key))
                defineProperty2(target, key, getOwnPropertyDescriptor2(source2, key));
            }
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var getBuiltIn = __w_pdfjs_require__2(27);
          var uncurryThis = __w_pdfjs_require__2(19);
          var getOwnPropertyNamesModule = __w_pdfjs_require__2(59);
          var getOwnPropertySymbolsModule = __w_pdfjs_require__2(67);
          var anObject = __w_pdfjs_require__2(49);
          var concat2 = uncurryThis([].concat);
          module2.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys2(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols2 = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols2 ? concat2(keys, getOwnPropertySymbols2(it)) : keys;
          };
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          var internalObjectKeys = __w_pdfjs_require__2(60);
          var enumBugKeys = __w_pdfjs_require__2(66);
          var hiddenKeys = enumBugKeys.concat("length", "prototype");
          exports2.f = Object.getOwnPropertyNames || function getOwnPropertyNames2(O) {
            return internalObjectKeys(O, hiddenKeys);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var hasOwn = __w_pdfjs_require__2(42);
          var toIndexedObject = __w_pdfjs_require__2(17);
          var indexOf = __w_pdfjs_require__2(61).indexOf;
          var hiddenKeys = __w_pdfjs_require__2(55);
          var push2 = uncurryThis([].push);
          module2.exports = function(object, names2) {
            var O = toIndexedObject(object);
            var i2 = 0;
            var result2 = [];
            var key;
            for (key in O)
              !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push2(result2, key);
            while (names2.length > i2)
              if (hasOwn(O, key = names2[i2++])) {
                ~indexOf(result2, key) || push2(result2, key);
              }
            return result2;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toIndexedObject = __w_pdfjs_require__2(17);
          var toAbsoluteIndex = __w_pdfjs_require__2(62);
          var lengthOfArrayLike = __w_pdfjs_require__2(64);
          var createMethod2 = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
              var O = toIndexedObject($this);
              var length = lengthOfArrayLike(O);
              var index2 = toAbsoluteIndex(fromIndex, length);
              var value;
              if (IS_INCLUDES && el != el)
                while (length > index2) {
                  value = O[index2++];
                  if (value != value)
                    return true;
                }
              else
                for (; length > index2; index2++) {
                  if ((IS_INCLUDES || index2 in O) && O[index2] === el)
                    return IS_INCLUDES || index2 || 0;
                }
              return !IS_INCLUDES && -1;
            };
          };
          module2.exports = {
            includes: createMethod2(true),
            indexOf: createMethod2(false)
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toIntegerOrInfinity = __w_pdfjs_require__2(63);
          var max2 = Math.max;
          var min2 = Math.min;
          module2.exports = function(index2, length) {
            var integer = toIntegerOrInfinity(index2);
            return integer < 0 ? max2(integer + length, 0) : min2(integer, length);
          };
        },
        (module2) => {
          var ceil2 = Math.ceil;
          var floor2 = Math.floor;
          module2.exports = function(argument) {
            var number2 = +argument;
            return number2 !== number2 || number2 === 0 ? 0 : (number2 > 0 ? floor2 : ceil2)(number2);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toLength = __w_pdfjs_require__2(65);
          module2.exports = function(obj) {
            return toLength(obj.length);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toIntegerOrInfinity = __w_pdfjs_require__2(63);
          var min2 = Math.min;
          module2.exports = function(argument) {
            return argument > 0 ? min2(toIntegerOrInfinity(argument), 9007199254740991) : 0;
          };
        },
        (module2) => {
          module2.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
          ];
        },
        (__unused_webpack_module2, exports2) => {
          exports2.f = Object.getOwnPropertySymbols;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var fails = __w_pdfjs_require__2(13);
          var isCallable = __w_pdfjs_require__2(25);
          var replacement = /#|\.prototype\./;
          var isForced = function(feature, detection) {
            var value = data2[normalize(feature)];
            return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
          };
          var normalize = isForced.normalize = function(string2) {
            return String(string2).replace(replacement, ".").toLowerCase();
          };
          var data2 = isForced.data = {};
          var NATIVE = isForced.NATIVE = "N";
          var POLYFILL = isForced.POLYFILL = "P";
          module2.exports = isForced;
        },
        (module2, exports2, __w_pdfjs_require__2) => {
          var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          (function(global2, factory) {
            _typeof2(exports2) === "object" && true ? module2.exports = factory() : !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports2, __w_pdfjs_require__2, exports2, module2) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== void 0 && (module2.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          })(void 0, function() {
            function fromArray(array) {
              var m2 = new CSSMatrix();
              var a6 = Array.from(array);
              if (!a6.every(function(n2) {
                return !Number.isNaN(n2);
              })) {
                throw TypeError('CSSMatrix: "' + array + '" must only have numbers.');
              }
              if (a6.length === 16) {
                var m11 = a6[0];
                var m12 = a6[1];
                var m13 = a6[2];
                var m14 = a6[3];
                var m21 = a6[4];
                var m22 = a6[5];
                var m23 = a6[6];
                var m24 = a6[7];
                var m31 = a6[8];
                var m32 = a6[9];
                var m33 = a6[10];
                var m34 = a6[11];
                var m41 = a6[12];
                var m42 = a6[13];
                var m43 = a6[14];
                var m44 = a6[15];
                m2.m11 = m11;
                m2.a = m11;
                m2.m21 = m21;
                m2.c = m21;
                m2.m31 = m31;
                m2.m41 = m41;
                m2.e = m41;
                m2.m12 = m12;
                m2.b = m12;
                m2.m22 = m22;
                m2.d = m22;
                m2.m32 = m32;
                m2.m42 = m42;
                m2.f = m42;
                m2.m13 = m13;
                m2.m23 = m23;
                m2.m33 = m33;
                m2.m43 = m43;
                m2.m14 = m14;
                m2.m24 = m24;
                m2.m34 = m34;
                m2.m44 = m44;
              } else if (a6.length === 6) {
                var M11 = a6[0];
                var M12 = a6[1];
                var M21 = a6[2];
                var M22 = a6[3];
                var M41 = a6[4];
                var M42 = a6[5];
                m2.m11 = M11;
                m2.a = M11;
                m2.m12 = M12;
                m2.b = M12;
                m2.m21 = M21;
                m2.c = M21;
                m2.m22 = M22;
                m2.d = M22;
                m2.m41 = M41;
                m2.e = M41;
                m2.m42 = M42;
                m2.f = M42;
              } else {
                throw new TypeError("CSSMatrix: expecting an Array of 6/16 values.");
              }
              return m2;
            }
            function fromMatrix(m2) {
              var keys = Object.keys(new CSSMatrix());
              if (_typeof2(m2) === "object" && keys.every(function(k3) {
                return k3 in m2;
              })) {
                return fromArray([m2.m11, m2.m12, m2.m13, m2.m14, m2.m21, m2.m22, m2.m23, m2.m24, m2.m31, m2.m32, m2.m33, m2.m34, m2.m41, m2.m42, m2.m43, m2.m44]);
              }
              throw TypeError('CSSMatrix: "' + m2 + '" is not a DOMMatrix / CSSMatrix / JSON compatible object.');
            }
            function fromString2(source2) {
              if (typeof source2 !== "string") {
                throw TypeError('CSSMatrix: "' + source2 + '" is not a string.');
              }
              var str = String(source2).replace(/\s/g, "");
              var m2 = new CSSMatrix();
              var invalidStringError = 'CSSMatrix: invalid transform string "' + source2 + '"';
              str.split(")").filter(function(f2) {
                return f2;
              }).forEach(function(tf) {
                var ref = tf.split("(");
                var prop = ref[0];
                var value = ref[1];
                if (!value) {
                  throw TypeError(invalidStringError);
                }
                var components = value.split(",").map(function(n2) {
                  return n2.includes("rad") ? parseFloat(n2) * (180 / Math.PI) : parseFloat(n2);
                });
                var x2 = components[0];
                var y2 = components[1];
                var z2 = components[2];
                var a6 = components[3];
                var xyz = [x2, y2, z2];
                var xyza = [x2, y2, z2, a6];
                if (prop === "perspective" && x2 && [y2, z2].every(function(n2) {
                  return n2 === void 0;
                })) {
                  m2.m34 = -1 / x2;
                } else if (prop.includes("matrix") && [6, 16].includes(components.length) && components.every(function(n2) {
                  return !Number.isNaN(+n2);
                })) {
                  var values = components.map(function(n2) {
                    return Math.abs(n2) < 1e-6 ? 0 : n2;
                  });
                  m2 = m2.multiply(fromArray(values));
                } else if (prop === "translate3d" && xyz.every(function(n2) {
                  return !Number.isNaN(+n2);
                })) {
                  m2 = m2.translate(x2, y2, z2);
                } else if (prop === "translate" && x2 && z2 === void 0) {
                  m2 = m2.translate(x2, y2 || 0, 0);
                } else if (prop === "rotate3d" && xyza.every(function(n2) {
                  return !Number.isNaN(+n2);
                }) && a6) {
                  m2 = m2.rotateAxisAngle(x2, y2, z2, a6);
                } else if (prop === "rotate" && x2 && [y2, z2].every(function(n2) {
                  return n2 === void 0;
                })) {
                  m2 = m2.rotate(0, 0, x2);
                } else if (prop === "scale3d" && xyz.every(function(n2) {
                  return !Number.isNaN(+n2);
                }) && xyz.some(function(n2) {
                  return n2 !== 1;
                })) {
                  m2 = m2.scale(x2, y2, z2);
                } else if (prop === "scale" && !Number.isNaN(x2) && x2 !== 1 && z2 === void 0) {
                  var nosy = Number.isNaN(+y2);
                  var sy = nosy ? x2 : y2;
                  m2 = m2.scale(x2, sy, 1);
                } else if (prop === "skew" && x2 && z2 === void 0) {
                  m2 = m2.skewX(x2);
                  m2 = y2 ? m2.skewY(y2) : m2;
                } else if (/[XYZ]/.test(prop) && x2 && [y2, z2].every(function(n2) {
                  return n2 === void 0;
                }) && ["translate", "rotate", "scale", "skew"].some(function(p2) {
                  return prop.includes(p2);
                })) {
                  if (["skewX", "skewY"].includes(prop)) {
                    m2 = m2[prop](x2);
                  } else {
                    var fn = prop.replace(/[XYZ]/, "");
                    var axis = prop.replace(fn, "");
                    var idx = ["X", "Y", "Z"].indexOf(axis);
                    var axeValues = [idx === 0 ? x2 : 0, idx === 1 ? x2 : 0, idx === 2 ? x2 : 0];
                    m2 = m2[fn].apply(m2, axeValues);
                  }
                } else {
                  throw TypeError(invalidStringError);
                }
              });
              return m2;
            }
            function Translate(x2, y2, z2) {
              var m2 = new CSSMatrix();
              m2.m41 = x2;
              m2.e = x2;
              m2.m42 = y2;
              m2.f = y2;
              m2.m43 = z2;
              return m2;
            }
            function Rotate(rx, ry, rz) {
              var m2 = new CSSMatrix();
              var degToRad = Math.PI / 180;
              var radX = rx * degToRad;
              var radY = ry * degToRad;
              var radZ = rz * degToRad;
              var cosx = Math.cos(radX);
              var sinx = -Math.sin(radX);
              var cosy = Math.cos(radY);
              var siny = -Math.sin(radY);
              var cosz = Math.cos(radZ);
              var sinz = -Math.sin(radZ);
              var m11 = cosy * cosz;
              var m12 = -cosy * sinz;
              m2.m11 = m11;
              m2.a = m11;
              m2.m12 = m12;
              m2.b = m12;
              m2.m13 = siny;
              var m21 = sinx * siny * cosz + cosx * sinz;
              m2.m21 = m21;
              m2.c = m21;
              var m22 = cosx * cosz - sinx * siny * sinz;
              m2.m22 = m22;
              m2.d = m22;
              m2.m23 = -sinx * cosy;
              m2.m31 = sinx * sinz - cosx * siny * cosz;
              m2.m32 = sinx * cosz + cosx * siny * sinz;
              m2.m33 = cosx * cosy;
              return m2;
            }
            function RotateAxisAngle(x2, y2, z2, alpha2) {
              var m2 = new CSSMatrix();
              var angle = alpha2 * (Math.PI / 360);
              var sinA = Math.sin(angle);
              var cosA = Math.cos(angle);
              var sinA2 = sinA * sinA;
              var length = Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
              var X2 = x2;
              var Y2 = y2;
              var Z2 = z2;
              if (length === 0) {
                X2 = 0;
                Y2 = 0;
                Z2 = 1;
              } else {
                X2 /= length;
                Y2 /= length;
                Z2 /= length;
              }
              var x22 = X2 * X2;
              var y22 = Y2 * Y2;
              var z22 = Z2 * Z2;
              var m11 = 1 - 2 * (y22 + z22) * sinA2;
              m2.m11 = m11;
              m2.a = m11;
              var m12 = 2 * (X2 * Y2 * sinA2 + Z2 * sinA * cosA);
              m2.m12 = m12;
              m2.b = m12;
              m2.m13 = 2 * (X2 * Z2 * sinA2 - Y2 * sinA * cosA);
              var m21 = 2 * (Y2 * X2 * sinA2 - Z2 * sinA * cosA);
              m2.m21 = m21;
              m2.c = m21;
              var m22 = 1 - 2 * (z22 + x22) * sinA2;
              m2.m22 = m22;
              m2.d = m22;
              m2.m23 = 2 * (Y2 * Z2 * sinA2 + X2 * sinA * cosA);
              m2.m31 = 2 * (Z2 * X2 * sinA2 + Y2 * sinA * cosA);
              m2.m32 = 2 * (Z2 * Y2 * sinA2 - X2 * sinA * cosA);
              m2.m33 = 1 - 2 * (x22 + y22) * sinA2;
              return m2;
            }
            function Scale(x2, y2, z2) {
              var m2 = new CSSMatrix();
              m2.m11 = x2;
              m2.a = x2;
              m2.m22 = y2;
              m2.d = y2;
              m2.m33 = z2;
              return m2;
            }
            function SkewX(angle) {
              var m2 = new CSSMatrix();
              var radA = angle * Math.PI / 180;
              var t2 = Math.tan(radA);
              m2.m21 = t2;
              m2.c = t2;
              return m2;
            }
            function SkewY(angle) {
              var m2 = new CSSMatrix();
              var radA = angle * Math.PI / 180;
              var t2 = Math.tan(radA);
              m2.m12 = t2;
              m2.b = t2;
              return m2;
            }
            function Multiply2(m1, m2) {
              var m11 = m2.m11 * m1.m11 + m2.m12 * m1.m21 + m2.m13 * m1.m31 + m2.m14 * m1.m41;
              var m12 = m2.m11 * m1.m12 + m2.m12 * m1.m22 + m2.m13 * m1.m32 + m2.m14 * m1.m42;
              var m13 = m2.m11 * m1.m13 + m2.m12 * m1.m23 + m2.m13 * m1.m33 + m2.m14 * m1.m43;
              var m14 = m2.m11 * m1.m14 + m2.m12 * m1.m24 + m2.m13 * m1.m34 + m2.m14 * m1.m44;
              var m21 = m2.m21 * m1.m11 + m2.m22 * m1.m21 + m2.m23 * m1.m31 + m2.m24 * m1.m41;
              var m22 = m2.m21 * m1.m12 + m2.m22 * m1.m22 + m2.m23 * m1.m32 + m2.m24 * m1.m42;
              var m23 = m2.m21 * m1.m13 + m2.m22 * m1.m23 + m2.m23 * m1.m33 + m2.m24 * m1.m43;
              var m24 = m2.m21 * m1.m14 + m2.m22 * m1.m24 + m2.m23 * m1.m34 + m2.m24 * m1.m44;
              var m31 = m2.m31 * m1.m11 + m2.m32 * m1.m21 + m2.m33 * m1.m31 + m2.m34 * m1.m41;
              var m32 = m2.m31 * m1.m12 + m2.m32 * m1.m22 + m2.m33 * m1.m32 + m2.m34 * m1.m42;
              var m33 = m2.m31 * m1.m13 + m2.m32 * m1.m23 + m2.m33 * m1.m33 + m2.m34 * m1.m43;
              var m34 = m2.m31 * m1.m14 + m2.m32 * m1.m24 + m2.m33 * m1.m34 + m2.m34 * m1.m44;
              var m41 = m2.m41 * m1.m11 + m2.m42 * m1.m21 + m2.m43 * m1.m31 + m2.m44 * m1.m41;
              var m42 = m2.m41 * m1.m12 + m2.m42 * m1.m22 + m2.m43 * m1.m32 + m2.m44 * m1.m42;
              var m43 = m2.m41 * m1.m13 + m2.m42 * m1.m23 + m2.m43 * m1.m33 + m2.m44 * m1.m43;
              var m44 = m2.m41 * m1.m14 + m2.m42 * m1.m24 + m2.m43 * m1.m34 + m2.m44 * m1.m44;
              return fromArray([m11, m12, m13, m14, m21, m22, m23, m24, m31, m32, m33, m34, m41, m42, m43, m44]);
            }
            var CSSMatrix = function CSSMatrix2() {
              var args = [], len = arguments.length;
              while (len--) {
                args[len] = arguments[len];
              }
              var m2 = this;
              m2.a = 1;
              m2.b = 0;
              m2.c = 0;
              m2.d = 1;
              m2.e = 0;
              m2.f = 0;
              m2.m11 = 1;
              m2.m12 = 0;
              m2.m13 = 0;
              m2.m14 = 0;
              m2.m21 = 0;
              m2.m22 = 1;
              m2.m23 = 0;
              m2.m24 = 0;
              m2.m31 = 0;
              m2.m32 = 0;
              m2.m33 = 1;
              m2.m34 = 0;
              m2.m41 = 0;
              m2.m42 = 0;
              m2.m43 = 0;
              m2.m44 = 1;
              if (args && args.length) {
                var ARGS = [16, 6].some(function(l2) {
                  return l2 === args.length;
                }) ? args : args[0];
                return m2.setMatrixValue(ARGS);
              }
              return m2;
            };
            var prototypeAccessors = {
              isIdentity: {
                configurable: true
              },
              is2D: {
                configurable: true
              }
            };
            prototypeAccessors.isIdentity.set = function(value) {
              this.isIdentity = value;
            };
            prototypeAccessors.isIdentity.get = function() {
              var m2 = this;
              return m2.m11 === 1 && m2.m12 === 0 && m2.m13 === 0 && m2.m14 === 0 && m2.m21 === 0 && m2.m22 === 1 && m2.m23 === 0 && m2.m24 === 0 && m2.m31 === 0 && m2.m32 === 0 && m2.m33 === 1 && m2.m34 === 0 && m2.m41 === 0 && m2.m42 === 0 && m2.m43 === 0 && m2.m44 === 1;
            };
            prototypeAccessors.is2D.get = function() {
              var m2 = this;
              return m2.m31 === 0 && m2.m32 === 0 && m2.m33 === 1 && m2.m34 === 0 && m2.m43 === 0 && m2.m44 === 1;
            };
            prototypeAccessors.is2D.set = function(value) {
              this.is2D = value;
            };
            CSSMatrix.prototype.setMatrixValue = function setMatrixValue(source2) {
              var m2 = this;
              if ([Array, Float64Array, Float32Array].some(function(a6) {
                return source2 instanceof a6;
              })) {
                return fromArray(source2);
              }
              if (typeof source2 === "string" && source2.length && source2 !== "none") {
                return fromString2(source2);
              }
              if (_typeof2(source2) === "object") {
                return fromMatrix(source2);
              }
              return m2;
            };
            CSSMatrix.prototype.toArray = function toArray() {
              var m2 = this;
              var pow2 = Math.pow(10, 6);
              var result2;
              if (m2.is2D) {
                result2 = [m2.a, m2.b, m2.c, m2.d, m2.e, m2.f];
              } else {
                result2 = [m2.m11, m2.m12, m2.m13, m2.m14, m2.m21, m2.m22, m2.m23, m2.m24, m2.m31, m2.m32, m2.m33, m2.m34, m2.m41, m2.m42, m2.m43, m2.m44];
              }
              return result2.map(function(n2) {
                return Math.abs(n2) < 1e-6 ? 0 : (n2 * pow2 >> 0) / pow2;
              });
            };
            CSSMatrix.prototype.toString = function toString4() {
              var m2 = this;
              var values = m2.toArray();
              var type = m2.is2D ? "matrix" : "matrix3d";
              return type + "(" + values + ")";
            };
            CSSMatrix.prototype.toJSON = function toJSON() {
              var m2 = this;
              var is2D = m2.is2D;
              var isIdentity = m2.isIdentity;
              return Object.assign({}, m2, {
                is2D,
                isIdentity
              });
            };
            CSSMatrix.prototype.multiply = function multiply3(m2) {
              return Multiply2(this, m2);
            };
            CSSMatrix.prototype.translate = function translate(x2, y2, z2) {
              var X2 = x2;
              var Y2 = y2;
              var Z2 = z2;
              if (Z2 === void 0) {
                Z2 = 0;
              }
              if (Y2 === void 0) {
                Y2 = 0;
              }
              return Multiply2(this, Translate(X2, Y2, Z2));
            };
            CSSMatrix.prototype.scale = function scale2(x2, y2, z2) {
              var X2 = x2;
              var Y2 = y2;
              var Z2 = z2;
              if (Y2 === void 0) {
                Y2 = x2;
              }
              if (Z2 === void 0) {
                Z2 = 1;
              }
              return Multiply2(this, Scale(X2, Y2, Z2));
            };
            CSSMatrix.prototype.rotate = function rotate(rx, ry, rz) {
              var RX = rx;
              var RY = ry;
              var RZ = rz;
              if (RY === void 0) {
                RY = 0;
              }
              if (RZ === void 0) {
                RZ = RX;
                RX = 0;
              }
              return Multiply2(this, Rotate(RX, RY, RZ));
            };
            CSSMatrix.prototype.rotateAxisAngle = function rotateAxisAngle(x2, y2, z2, angle) {
              if ([x2, y2, z2, angle].some(function(n2) {
                return Number.isNaN(n2);
              })) {
                throw new TypeError("CSSMatrix: expecting 4 values");
              }
              return Multiply2(this, RotateAxisAngle(x2, y2, z2, angle));
            };
            CSSMatrix.prototype.skewX = function skewX(angle) {
              return Multiply2(this, SkewX(angle));
            };
            CSSMatrix.prototype.skewY = function skewY(angle) {
              return Multiply2(this, SkewY(angle));
            };
            CSSMatrix.prototype.transformPoint = function transformPoint2(v2) {
              var M2 = this;
              var m2 = Translate(v2.x, v2.y, v2.z);
              m2.m44 = v2.w || 1;
              m2 = M2.multiply(m2);
              return {
                x: m2.m41,
                y: m2.m42,
                z: m2.m43,
                w: m2.m44
              };
            };
            CSSMatrix.prototype.transform = function transform2(t2) {
              var m2 = this;
              var x2 = m2.m11 * t2.x + m2.m12 * t2.y + m2.m13 * t2.z + m2.m14 * t2.w;
              var y2 = m2.m21 * t2.x + m2.m22 * t2.y + m2.m23 * t2.z + m2.m24 * t2.w;
              var z2 = m2.m31 * t2.x + m2.m32 * t2.y + m2.m33 * t2.z + m2.m34 * t2.w;
              var w2 = m2.m41 * t2.x + m2.m42 * t2.y + m2.m43 * t2.z + m2.m44 * t2.w;
              return {
                x: x2 / w2,
                y: y2 / w2,
                z: z2 / w2,
                w: w2
              };
            };
            Object.defineProperties(CSSMatrix.prototype, prototypeAccessors);
            Object.assign(CSSMatrix, {
              Translate,
              Rotate,
              RotateAxisAngle,
              Scale,
              SkewX,
              SkewY,
              Multiply: Multiply2,
              fromArray,
              fromMatrix,
              fromString: fromString2
            });
            var version2 = "0.0.24";
            var Version = version2;
            Object.assign(CSSMatrix, {
              Version
            });
            return CSSMatrix;
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          __w_pdfjs_require__2(71);
          __w_pdfjs_require__2(86);
          var path2 = __w_pdfjs_require__2(96);
          module2.exports = path2.Object.fromEntries;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toIndexedObject = __w_pdfjs_require__2(17);
          var addToUnscopables = __w_pdfjs_require__2(72);
          var Iterators = __w_pdfjs_require__2(77);
          var InternalStateModule = __w_pdfjs_require__2(52);
          var defineIterator = __w_pdfjs_require__2(78);
          var ARRAY_ITERATOR = "Array Iterator";
          var setInternalState = InternalStateModule.set;
          var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
          module2.exports = defineIterator(Array, "Array", function(iterated, kind) {
            setInternalState(this, {
              type: ARRAY_ITERATOR,
              target: toIndexedObject(iterated),
              index: 0,
              kind
            });
          }, function() {
            var state2 = getInternalState(this);
            var target = state2.target;
            var kind = state2.kind;
            var index2 = state2.index++;
            if (!target || index2 >= target.length) {
              state2.target = void 0;
              return {
                value: void 0,
                done: true
              };
            }
            if (kind == "keys")
              return {
                value: index2,
                done: false
              };
            if (kind == "values")
              return {
                value: target[index2],
                done: false
              };
            return {
              value: [
                index2,
                target[index2]
              ],
              done: false
            };
          }, "values");
          Iterators.Arguments = Iterators.Array;
          addToUnscopables("keys");
          addToUnscopables("values");
          addToUnscopables("entries");
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var create3 = __w_pdfjs_require__2(73);
          var definePropertyModule = __w_pdfjs_require__2(48);
          var UNSCOPABLES = wellKnownSymbol("unscopables");
          var ArrayPrototype = Array.prototype;
          if (ArrayPrototype[UNSCOPABLES] == void 0) {
            definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
              configurable: true,
              value: create3(null)
            });
          }
          module2.exports = function(key) {
            ArrayPrototype[UNSCOPABLES][key] = true;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var anObject = __w_pdfjs_require__2(49);
          var defineProperties = __w_pdfjs_require__2(74);
          var enumBugKeys = __w_pdfjs_require__2(66);
          var hiddenKeys = __w_pdfjs_require__2(55);
          var html = __w_pdfjs_require__2(76);
          var documentCreateElement = __w_pdfjs_require__2(46);
          var sharedKey = __w_pdfjs_require__2(54);
          var GT = ">";
          var LT = "<";
          var PROTOTYPE = "prototype";
          var SCRIPT = "script";
          var IE_PROTO = sharedKey("IE_PROTO");
          var EmptyConstructor = function() {
          };
          var scriptTag = function(content) {
            return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
          };
          var NullProtoObjectViaActiveX = function(activeXDocument2) {
            activeXDocument2.write(scriptTag(""));
            activeXDocument2.close();
            var temp = activeXDocument2.parentWindow.Object;
            activeXDocument2 = null;
            return temp;
          };
          var NullProtoObjectViaIFrame = function() {
            var iframe = documentCreateElement("iframe");
            var JS = "java" + SCRIPT + ":";
            var iframeDocument;
            iframe.style.display = "none";
            html.appendChild(iframe);
            iframe.src = String(JS);
            iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(scriptTag("document.F=Object"));
            iframeDocument.close();
            return iframeDocument.F;
          };
          var activeXDocument;
          var NullProtoObject = function() {
            try {
              activeXDocument = new ActiveXObject("htmlfile");
            } catch (error3) {
            }
            NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
            var length = enumBugKeys.length;
            while (length--)
              delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
            return NullProtoObject();
          };
          hiddenKeys[IE_PROTO] = true;
          module2.exports = Object.create || function create3(O, Properties) {
            var result2;
            if (O !== null) {
              EmptyConstructor[PROTOTYPE] = anObject(O);
              result2 = new EmptyConstructor();
              EmptyConstructor[PROTOTYPE] = null;
              result2[IE_PROTO] = O;
            } else
              result2 = NullProtoObject();
            return Properties === void 0 ? result2 : defineProperties(result2, Properties);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var definePropertyModule = __w_pdfjs_require__2(48);
          var anObject = __w_pdfjs_require__2(49);
          var toIndexedObject = __w_pdfjs_require__2(17);
          var objectKeys = __w_pdfjs_require__2(75);
          module2.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
            anObject(O);
            var props = toIndexedObject(Properties);
            var keys = objectKeys(Properties);
            var length = keys.length;
            var index2 = 0;
            var key;
            while (length > index2)
              definePropertyModule.f(O, key = keys[index2++], props[key]);
            return O;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var internalObjectKeys = __w_pdfjs_require__2(60);
          var enumBugKeys = __w_pdfjs_require__2(66);
          module2.exports = Object.keys || function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var getBuiltIn = __w_pdfjs_require__2(27);
          module2.exports = getBuiltIn("document", "documentElement");
        },
        (module2) => {
          module2.exports = {};
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var call = __w_pdfjs_require__2(14);
          var IS_PURE = __w_pdfjs_require__2(39);
          var FunctionName = __w_pdfjs_require__2(56);
          var isCallable = __w_pdfjs_require__2(25);
          var createIteratorConstructor = __w_pdfjs_require__2(79);
          var getPrototypeOf2 = __w_pdfjs_require__2(81);
          var setPrototypeOf = __w_pdfjs_require__2(84);
          var setToStringTag = __w_pdfjs_require__2(83);
          var createNonEnumerableProperty = __w_pdfjs_require__2(47);
          var redefine = __w_pdfjs_require__2(50);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var Iterators = __w_pdfjs_require__2(77);
          var IteratorsCore = __w_pdfjs_require__2(80);
          var PROPER_FUNCTION_NAME = FunctionName.PROPER;
          var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
          var IteratorPrototype = IteratorsCore.IteratorPrototype;
          var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
          var ITERATOR = wellKnownSymbol("iterator");
          var KEYS = "keys";
          var VALUES = "values";
          var ENTRIES = "entries";
          var returnThis = function() {
            return this;
          };
          module2.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
            createIteratorConstructor(IteratorConstructor, NAME, next);
            var getIterationMethod = function(KIND) {
              if (KIND === DEFAULT && defaultIterator)
                return defaultIterator;
              if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
                return IterablePrototype[KIND];
              switch (KIND) {
                case KEYS:
                  return function keys() {
                    return new IteratorConstructor(this, KIND);
                  };
                case VALUES:
                  return function values() {
                    return new IteratorConstructor(this, KIND);
                  };
                case ENTRIES:
                  return function entries() {
                    return new IteratorConstructor(this, KIND);
                  };
              }
              return function() {
                return new IteratorConstructor(this);
              };
            };
            var TO_STRING_TAG = NAME + " Iterator";
            var INCORRECT_VALUES_NAME = false;
            var IterablePrototype = Iterable.prototype;
            var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
            var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
            var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
            var CurrentIteratorPrototype, methods, KEY;
            if (anyNativeIterator) {
              CurrentIteratorPrototype = getPrototypeOf2(anyNativeIterator.call(new Iterable()));
              if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                if (!IS_PURE && getPrototypeOf2(CurrentIteratorPrototype) !== IteratorPrototype) {
                  if (setPrototypeOf) {
                    setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                  } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
                    redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
                  }
                }
                setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                if (IS_PURE)
                  Iterators[TO_STRING_TAG] = returnThis;
              }
            }
            if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
              if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
                createNonEnumerableProperty(IterablePrototype, "name", VALUES);
              } else {
                INCORRECT_VALUES_NAME = true;
                defaultIterator = function values() {
                  return call(nativeIterator, this);
                };
              }
            }
            if (DEFAULT) {
              methods = {
                values: getIterationMethod(VALUES),
                keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                entries: getIterationMethod(ENTRIES)
              };
              if (FORCED)
                for (KEY in methods) {
                  if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                    redefine(IterablePrototype, KEY, methods[KEY]);
                  }
                }
              else
                $2({
                  target: NAME,
                  proto: true,
                  forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                }, methods);
            }
            if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
              redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
            }
            Iterators[NAME] = defaultIterator;
            return methods;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var IteratorPrototype = __w_pdfjs_require__2(80).IteratorPrototype;
          var create3 = __w_pdfjs_require__2(73);
          var createPropertyDescriptor = __w_pdfjs_require__2(16);
          var setToStringTag = __w_pdfjs_require__2(83);
          var Iterators = __w_pdfjs_require__2(77);
          var returnThis = function() {
            return this;
          };
          module2.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
            var TO_STRING_TAG = NAME + " Iterator";
            IteratorConstructor.prototype = create3(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
            setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
            Iterators[TO_STRING_TAG] = returnThis;
            return IteratorConstructor;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var fails = __w_pdfjs_require__2(13);
          var isCallable = __w_pdfjs_require__2(25);
          var create3 = __w_pdfjs_require__2(73);
          var getPrototypeOf2 = __w_pdfjs_require__2(81);
          var redefine = __w_pdfjs_require__2(50);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var IS_PURE = __w_pdfjs_require__2(39);
          var ITERATOR = wellKnownSymbol("iterator");
          var BUGGY_SAFARI_ITERATORS = false;
          var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
          if ([].keys) {
            arrayIterator = [].keys();
            if (!("next" in arrayIterator))
              BUGGY_SAFARI_ITERATORS = true;
            else {
              PrototypeOfArrayIteratorPrototype = getPrototypeOf2(getPrototypeOf2(arrayIterator));
              if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
                IteratorPrototype = PrototypeOfArrayIteratorPrototype;
            }
          }
          var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == void 0 || fails(function() {
            var test2 = {};
            return IteratorPrototype[ITERATOR].call(test2) !== test2;
          });
          if (NEW_ITERATOR_PROTOTYPE)
            IteratorPrototype = {};
          else if (IS_PURE)
            IteratorPrototype = create3(IteratorPrototype);
          if (!isCallable(IteratorPrototype[ITERATOR])) {
            redefine(IteratorPrototype, ITERATOR, function() {
              return this;
            });
          }
          module2.exports = {
            IteratorPrototype,
            BUGGY_SAFARI_ITERATORS
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var hasOwn = __w_pdfjs_require__2(42);
          var isCallable = __w_pdfjs_require__2(25);
          var toObject2 = __w_pdfjs_require__2(43);
          var sharedKey = __w_pdfjs_require__2(54);
          var CORRECT_PROTOTYPE_GETTER = __w_pdfjs_require__2(82);
          var IE_PROTO = sharedKey("IE_PROTO");
          var Object2 = global2.Object;
          var ObjectPrototype = Object2.prototype;
          module2.exports = CORRECT_PROTOTYPE_GETTER ? Object2.getPrototypeOf : function(O) {
            var object = toObject2(O);
            if (hasOwn(object, IE_PROTO))
              return object[IE_PROTO];
            var constructor = object.constructor;
            if (isCallable(constructor) && object instanceof constructor) {
              return constructor.prototype;
            }
            return object instanceof Object2 ? ObjectPrototype : null;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var fails = __w_pdfjs_require__2(13);
          module2.exports = !fails(function() {
            function F2() {
            }
            F2.prototype.constructor = null;
            return Object.getPrototypeOf(new F2()) !== F2.prototype;
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var defineProperty2 = __w_pdfjs_require__2(48).f;
          var hasOwn = __w_pdfjs_require__2(42);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var TO_STRING_TAG = wellKnownSymbol("toStringTag");
          module2.exports = function(it, TAG, STATIC) {
            if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
              defineProperty2(it, TO_STRING_TAG, {
                configurable: true,
                value: TAG
              });
            }
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var anObject = __w_pdfjs_require__2(49);
          var aPossiblePrototype = __w_pdfjs_require__2(85);
          module2.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
            var CORRECT_SETTER = false;
            var test2 = {};
            var setter;
            try {
              setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
              setter(test2, []);
              CORRECT_SETTER = test2 instanceof Array;
            } catch (error3) {
            }
            return function setPrototypeOf(O, proto2) {
              anObject(O);
              aPossiblePrototype(proto2);
              if (CORRECT_SETTER)
                setter(O, proto2);
              else
                O.__proto__ = proto2;
              return O;
            };
          }() : void 0);
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isCallable = __w_pdfjs_require__2(25);
          var String2 = global2.String;
          var TypeError2 = global2.TypeError;
          module2.exports = function(argument) {
            if (typeof argument == "object" || isCallable(argument))
              return argument;
            throw TypeError2("Can't set " + String2(argument) + " as a prototype");
          };
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var iterate = __w_pdfjs_require__2(87);
          var createProperty = __w_pdfjs_require__2(95);
          $2({
            target: "Object",
            stat: true
          }, {
            fromEntries: function fromEntries(iterable) {
              var obj = {};
              iterate(iterable, function(k3, v2) {
                createProperty(obj, k3, v2);
              }, { AS_ENTRIES: true });
              return obj;
            }
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var bind3 = __w_pdfjs_require__2(88);
          var call = __w_pdfjs_require__2(14);
          var anObject = __w_pdfjs_require__2(49);
          var tryToString = __w_pdfjs_require__2(35);
          var isArrayIteratorMethod = __w_pdfjs_require__2(89);
          var lengthOfArrayLike = __w_pdfjs_require__2(64);
          var isPrototypeOf = __w_pdfjs_require__2(28);
          var getIterator = __w_pdfjs_require__2(90);
          var getIteratorMethod = __w_pdfjs_require__2(91);
          var iteratorClose = __w_pdfjs_require__2(94);
          var TypeError2 = global2.TypeError;
          var Result = function(stopped, result2) {
            this.stopped = stopped;
            this.result = result2;
          };
          var ResultPrototype = Result.prototype;
          module2.exports = function(iterable, unboundFunction, options) {
            var that = options && options.that;
            var AS_ENTRIES = !!(options && options.AS_ENTRIES);
            var IS_ITERATOR = !!(options && options.IS_ITERATOR);
            var INTERRUPTED = !!(options && options.INTERRUPTED);
            var fn = bind3(unboundFunction, that);
            var iterator, iterFn, index2, length, result2, next, step2;
            var stop = function(condition) {
              if (iterator)
                iteratorClose(iterator, "normal", condition);
              return new Result(true, condition);
            };
            var callFn = function(value) {
              if (AS_ENTRIES) {
                anObject(value);
                return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
              }
              return INTERRUPTED ? fn(value, stop) : fn(value);
            };
            if (IS_ITERATOR) {
              iterator = iterable;
            } else {
              iterFn = getIteratorMethod(iterable);
              if (!iterFn)
                throw TypeError2(tryToString(iterable) + " is not iterable");
              if (isArrayIteratorMethod(iterFn)) {
                for (index2 = 0, length = lengthOfArrayLike(iterable); length > index2; index2++) {
                  result2 = callFn(iterable[index2]);
                  if (result2 && isPrototypeOf(ResultPrototype, result2))
                    return result2;
                }
                return new Result(false);
              }
              iterator = getIterator(iterable, iterFn);
            }
            next = iterator.next;
            while (!(step2 = call(next, iterator)).done) {
              try {
                result2 = callFn(step2.value);
              } catch (error3) {
                iteratorClose(iterator, "throw", error3);
              }
              if (typeof result2 == "object" && result2 && isPrototypeOf(ResultPrototype, result2))
                return result2;
            }
            return new Result(false);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var aCallable = __w_pdfjs_require__2(34);
          var bind3 = uncurryThis(uncurryThis.bind);
          module2.exports = function(fn, that) {
            aCallable(fn);
            return that === void 0 ? fn : bind3 ? bind3(fn, that) : function() {
              return fn.apply(that, arguments);
            };
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var Iterators = __w_pdfjs_require__2(77);
          var ITERATOR = wellKnownSymbol("iterator");
          var ArrayPrototype = Array.prototype;
          module2.exports = function(it) {
            return it !== void 0 && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var call = __w_pdfjs_require__2(14);
          var aCallable = __w_pdfjs_require__2(34);
          var anObject = __w_pdfjs_require__2(49);
          var tryToString = __w_pdfjs_require__2(35);
          var getIteratorMethod = __w_pdfjs_require__2(91);
          var TypeError2 = global2.TypeError;
          module2.exports = function(argument, usingIterator) {
            var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
            if (aCallable(iteratorMethod))
              return anObject(call(iteratorMethod, argument));
            throw TypeError2(tryToString(argument) + " is not iterable");
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var classof = __w_pdfjs_require__2(92);
          var getMethod = __w_pdfjs_require__2(33);
          var Iterators = __w_pdfjs_require__2(77);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var ITERATOR = wellKnownSymbol("iterator");
          module2.exports = function(it) {
            if (it != void 0)
              return getMethod(it, ITERATOR) || getMethod(it, "@@iterator") || Iterators[classof(it)];
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__2(93);
          var isCallable = __w_pdfjs_require__2(25);
          var classofRaw = __w_pdfjs_require__2(20);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var TO_STRING_TAG = wellKnownSymbol("toStringTag");
          var Object2 = global2.Object;
          var CORRECT_ARGUMENTS = classofRaw(function() {
            return arguments;
          }()) == "Arguments";
          var tryGet = function(it, key) {
            try {
              return it[key];
            } catch (error3) {
            }
          };
          module2.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
            var O, tag, result2;
            return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object2(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result2 = classofRaw(O)) == "Object" && isCallable(O.callee) ? "Arguments" : result2;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var TO_STRING_TAG = wellKnownSymbol("toStringTag");
          var test2 = {};
          test2[TO_STRING_TAG] = "z";
          module2.exports = String(test2) === "[object z]";
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var call = __w_pdfjs_require__2(14);
          var anObject = __w_pdfjs_require__2(49);
          var getMethod = __w_pdfjs_require__2(33);
          module2.exports = function(iterator, kind, value) {
            var innerResult, innerError;
            anObject(iterator);
            try {
              innerResult = getMethod(iterator, "return");
              if (!innerResult) {
                if (kind === "throw")
                  throw value;
                return value;
              }
              innerResult = call(innerResult, iterator);
            } catch (error3) {
              innerError = true;
              innerResult = error3;
            }
            if (kind === "throw")
              throw value;
            if (innerError)
              throw innerResult;
            anObject(innerResult);
            return value;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toPropertyKey = __w_pdfjs_require__2(22);
          var definePropertyModule = __w_pdfjs_require__2(48);
          var createPropertyDescriptor = __w_pdfjs_require__2(16);
          module2.exports = function(object, key, value) {
            var propertyKey = toPropertyKey(key);
            if (propertyKey in object)
              definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
            else
              object[propertyKey] = value;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          module2.exports = global2;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          __w_pdfjs_require__2(98);
          __w_pdfjs_require__2(71);
          __w_pdfjs_require__2(105);
          __w_pdfjs_require__2(107);
          __w_pdfjs_require__2(129);
          __w_pdfjs_require__2(130);
          __w_pdfjs_require__2(131);
          __w_pdfjs_require__2(132);
          var path2 = __w_pdfjs_require__2(96);
          module2.exports = path2.Promise;
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var global2 = __w_pdfjs_require__2(10);
          var isPrototypeOf = __w_pdfjs_require__2(28);
          var getPrototypeOf2 = __w_pdfjs_require__2(81);
          var setPrototypeOf = __w_pdfjs_require__2(84);
          var copyConstructorProperties = __w_pdfjs_require__2(57);
          var create3 = __w_pdfjs_require__2(73);
          var createNonEnumerableProperty = __w_pdfjs_require__2(47);
          var createPropertyDescriptor = __w_pdfjs_require__2(16);
          var clearErrorStack = __w_pdfjs_require__2(99);
          var installErrorCause = __w_pdfjs_require__2(101);
          var iterate = __w_pdfjs_require__2(87);
          var normalizeStringArgument = __w_pdfjs_require__2(102);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var ERROR_STACK_INSTALLABLE = __w_pdfjs_require__2(104);
          var TO_STRING_TAG = wellKnownSymbol("toStringTag");
          var Error2 = global2.Error;
          var push2 = [].push;
          var $AggregateError = function AggregateError(errors, message2) {
            var options = arguments.length > 2 ? arguments[2] : void 0;
            var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
            var that;
            if (setPrototypeOf) {
              that = setPrototypeOf(new Error2(void 0), isInstance ? getPrototypeOf2(this) : AggregateErrorPrototype);
            } else {
              that = isInstance ? this : create3(AggregateErrorPrototype);
              createNonEnumerableProperty(that, TO_STRING_TAG, "Error");
            }
            createNonEnumerableProperty(that, "message", normalizeStringArgument(message2, ""));
            if (ERROR_STACK_INSTALLABLE)
              createNonEnumerableProperty(that, "stack", clearErrorStack(that.stack, 1));
            installErrorCause(that, options);
            var errorsArray = [];
            iterate(errors, push2, { that: errorsArray });
            createNonEnumerableProperty(that, "errors", errorsArray);
            return that;
          };
          if (setPrototypeOf)
            setPrototypeOf($AggregateError, Error2);
          else
            copyConstructorProperties($AggregateError, Error2);
          var AggregateErrorPrototype = $AggregateError.prototype = create3(Error2.prototype, {
            constructor: createPropertyDescriptor(1, $AggregateError),
            message: createPropertyDescriptor(1, ""),
            name: createPropertyDescriptor(1, "AggregateError")
          });
          $2({ global: true }, { AggregateError: $AggregateError });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var arraySlice = __w_pdfjs_require__2(100);
          var replace2 = uncurryThis("".replace);
          var split2 = uncurryThis("".split);
          var join = uncurryThis([].join);
          var TEST = function(arg) {
            return String(Error(arg).stack);
          }("zxcasd");
          var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
          var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
          var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);
          module2.exports = function(stack2, dropEntries) {
            if (typeof stack2 != "string")
              return stack2;
            if (IS_V8_OR_CHAKRA_STACK) {
              while (dropEntries--)
                stack2 = replace2(stack2, V8_OR_CHAKRA_STACK_ENTRY, "");
            } else if (IS_FIREFOX_OR_SAFARI_STACK) {
              return join(arraySlice(split2(stack2, "\n"), dropEntries), "\n");
            }
            return stack2;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var toAbsoluteIndex = __w_pdfjs_require__2(62);
          var lengthOfArrayLike = __w_pdfjs_require__2(64);
          var createProperty = __w_pdfjs_require__2(95);
          var Array2 = global2.Array;
          var max2 = Math.max;
          module2.exports = function(O, start, end) {
            var length = lengthOfArrayLike(O);
            var k3 = toAbsoluteIndex(start, length);
            var fin = toAbsoluteIndex(end === void 0 ? length : end, length);
            var result2 = Array2(max2(fin - k3, 0));
            for (var n2 = 0; k3 < fin; k3++, n2++)
              createProperty(result2, n2, O[k3]);
            result2.length = n2;
            return result2;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var isObject3 = __w_pdfjs_require__2(24);
          var createNonEnumerableProperty = __w_pdfjs_require__2(47);
          module2.exports = function(O, options) {
            if (isObject3(options) && "cause" in options) {
              createNonEnumerableProperty(O, "cause", options.cause);
            }
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var toString4 = __w_pdfjs_require__2(103);
          module2.exports = function(argument, $default) {
            return argument === void 0 ? arguments.length < 2 ? "" : $default : toString4(argument);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var classof = __w_pdfjs_require__2(92);
          var String2 = global2.String;
          module2.exports = function(argument) {
            if (classof(argument) === "Symbol")
              throw TypeError("Cannot convert a Symbol value to a string");
            return String2(argument);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var fails = __w_pdfjs_require__2(13);
          var createPropertyDescriptor = __w_pdfjs_require__2(16);
          module2.exports = !fails(function() {
            var error3 = Error("a");
            if (!("stack" in error3))
              return true;
            Object.defineProperty(error3, "stack", createPropertyDescriptor(1, 7));
            return error3.stack !== 7;
          });
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__2(93);
          var redefine = __w_pdfjs_require__2(50);
          var toString4 = __w_pdfjs_require__2(106);
          if (!TO_STRING_TAG_SUPPORT) {
            redefine(Object.prototype, "toString", toString4, { unsafe: true });
          }
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__2(93);
          var classof = __w_pdfjs_require__2(92);
          module2.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString4() {
            return "[object " + classof(this) + "]";
          };
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var IS_PURE = __w_pdfjs_require__2(39);
          var global2 = __w_pdfjs_require__2(10);
          var getBuiltIn = __w_pdfjs_require__2(27);
          var call = __w_pdfjs_require__2(14);
          var NativePromise = __w_pdfjs_require__2(108);
          var redefine = __w_pdfjs_require__2(50);
          var redefineAll = __w_pdfjs_require__2(109);
          var setPrototypeOf = __w_pdfjs_require__2(84);
          var setToStringTag = __w_pdfjs_require__2(83);
          var setSpecies = __w_pdfjs_require__2(110);
          var aCallable = __w_pdfjs_require__2(34);
          var isCallable = __w_pdfjs_require__2(25);
          var isObject3 = __w_pdfjs_require__2(24);
          var anInstance = __w_pdfjs_require__2(111);
          var inspectSource = __w_pdfjs_require__2(51);
          var iterate = __w_pdfjs_require__2(87);
          var checkCorrectnessOfIteration = __w_pdfjs_require__2(112);
          var speciesConstructor = __w_pdfjs_require__2(113);
          var task = __w_pdfjs_require__2(116).set;
          var microtask = __w_pdfjs_require__2(121);
          var promiseResolve = __w_pdfjs_require__2(124);
          var hostReportErrors = __w_pdfjs_require__2(126);
          var newPromiseCapabilityModule = __w_pdfjs_require__2(125);
          var perform = __w_pdfjs_require__2(127);
          var InternalStateModule = __w_pdfjs_require__2(52);
          var isForced = __w_pdfjs_require__2(68);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var IS_BROWSER = __w_pdfjs_require__2(128);
          var IS_NODE = __w_pdfjs_require__2(120);
          var V8_VERSION = __w_pdfjs_require__2(31);
          var SPECIES = wellKnownSymbol("species");
          var PROMISE = "Promise";
          var getInternalState = InternalStateModule.getterFor(PROMISE);
          var setInternalState = InternalStateModule.set;
          var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
          var NativePromisePrototype = NativePromise && NativePromise.prototype;
          var PromiseConstructor = NativePromise;
          var PromisePrototype = NativePromisePrototype;
          var TypeError2 = global2.TypeError;
          var document2 = global2.document;
          var process2 = global2.process;
          var newPromiseCapability = newPromiseCapabilityModule.f;
          var newGenericPromiseCapability = newPromiseCapability;
          var DISPATCH_EVENT = !!(document2 && document2.createEvent && global2.dispatchEvent);
          var NATIVE_REJECTION_EVENT = isCallable(global2.PromiseRejectionEvent);
          var UNHANDLED_REJECTION = "unhandledrejection";
          var REJECTION_HANDLED = "rejectionhandled";
          var PENDING = 0;
          var FULFILLED = 1;
          var REJECTED = 2;
          var HANDLED = 1;
          var UNHANDLED = 2;
          var SUBCLASSING = false;
          var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
          var FORCED = isForced(PROMISE, function() {
            var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
            var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
            if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66)
              return true;
            if (IS_PURE && !PromisePrototype["finally"])
              return true;
            if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE))
              return false;
            var promise = new PromiseConstructor(function(resolve) {
              resolve(1);
            });
            var FakePromise = function(exec) {
              exec(function() {
              }, function() {
              });
            };
            var constructor = promise.constructor = {};
            constructor[SPECIES] = FakePromise;
            SUBCLASSING = promise.then(function() {
            }) instanceof FakePromise;
            if (!SUBCLASSING)
              return true;
            return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
          });
          var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
            PromiseConstructor.all(iterable)["catch"](function() {
            });
          });
          var isThenable = function(it) {
            var then;
            return isObject3(it) && isCallable(then = it.then) ? then : false;
          };
          var notify = function(state2, isReject) {
            if (state2.notified)
              return;
            state2.notified = true;
            var chain = state2.reactions;
            microtask(function() {
              var value = state2.value;
              var ok = state2.state == FULFILLED;
              var index2 = 0;
              while (chain.length > index2) {
                var reaction = chain[index2++];
                var handler = ok ? reaction.ok : reaction.fail;
                var resolve = reaction.resolve;
                var reject = reaction.reject;
                var domain = reaction.domain;
                var result2, then, exited;
                try {
                  if (handler) {
                    if (!ok) {
                      if (state2.rejection === UNHANDLED)
                        onHandleUnhandled(state2);
                      state2.rejection = HANDLED;
                    }
                    if (handler === true)
                      result2 = value;
                    else {
                      if (domain)
                        domain.enter();
                      result2 = handler(value);
                      if (domain) {
                        domain.exit();
                        exited = true;
                      }
                    }
                    if (result2 === reaction.promise) {
                      reject(TypeError2("Promise-chain cycle"));
                    } else if (then = isThenable(result2)) {
                      call(then, result2, resolve, reject);
                    } else
                      resolve(result2);
                  } else
                    reject(value);
                } catch (error3) {
                  if (domain && !exited)
                    domain.exit();
                  reject(error3);
                }
              }
              state2.reactions = [];
              state2.notified = false;
              if (isReject && !state2.rejection)
                onUnhandled(state2);
            });
          };
          var dispatchEvent = function(name, promise, reason) {
            var event, handler;
            if (DISPATCH_EVENT) {
              event = document2.createEvent("Event");
              event.promise = promise;
              event.reason = reason;
              event.initEvent(name, false, true);
              global2.dispatchEvent(event);
            } else
              event = {
                promise,
                reason
              };
            if (!NATIVE_REJECTION_EVENT && (handler = global2["on" + name]))
              handler(event);
            else if (name === UNHANDLED_REJECTION)
              hostReportErrors("Unhandled promise rejection", reason);
          };
          var onUnhandled = function(state2) {
            call(task, global2, function() {
              var promise = state2.facade;
              var value = state2.value;
              var IS_UNHANDLED = isUnhandled(state2);
              var result2;
              if (IS_UNHANDLED) {
                result2 = perform(function() {
                  if (IS_NODE) {
                    process2.emit("unhandledRejection", value, promise);
                  } else
                    dispatchEvent(UNHANDLED_REJECTION, promise, value);
                });
                state2.rejection = IS_NODE || isUnhandled(state2) ? UNHANDLED : HANDLED;
                if (result2.error)
                  throw result2.value;
              }
            });
          };
          var isUnhandled = function(state2) {
            return state2.rejection !== HANDLED && !state2.parent;
          };
          var onHandleUnhandled = function(state2) {
            call(task, global2, function() {
              var promise = state2.facade;
              if (IS_NODE) {
                process2.emit("rejectionHandled", promise);
              } else
                dispatchEvent(REJECTION_HANDLED, promise, state2.value);
            });
          };
          var bind3 = function(fn, state2, unwrap) {
            return function(value) {
              fn(state2, value, unwrap);
            };
          };
          var internalReject = function(state2, value, unwrap) {
            if (state2.done)
              return;
            state2.done = true;
            if (unwrap)
              state2 = unwrap;
            state2.value = value;
            state2.state = REJECTED;
            notify(state2, true);
          };
          var internalResolve = function(state2, value, unwrap) {
            if (state2.done)
              return;
            state2.done = true;
            if (unwrap)
              state2 = unwrap;
            try {
              if (state2.facade === value)
                throw TypeError2("Promise can't be resolved itself");
              var then = isThenable(value);
              if (then) {
                microtask(function() {
                  var wrapper = { done: false };
                  try {
                    call(then, value, bind3(internalResolve, wrapper, state2), bind3(internalReject, wrapper, state2));
                  } catch (error3) {
                    internalReject(wrapper, error3, state2);
                  }
                });
              } else {
                state2.value = value;
                state2.state = FULFILLED;
                notify(state2, false);
              }
            } catch (error3) {
              internalReject({ done: false }, error3, state2);
            }
          };
          if (FORCED) {
            PromiseConstructor = function Promise2(executor) {
              anInstance(this, PromisePrototype);
              aCallable(executor);
              call(Internal, this);
              var state2 = getInternalState(this);
              try {
                executor(bind3(internalResolve, state2), bind3(internalReject, state2));
              } catch (error3) {
                internalReject(state2, error3);
              }
            };
            PromisePrototype = PromiseConstructor.prototype;
            Internal = function Promise2(executor) {
              setInternalState(this, {
                type: PROMISE,
                done: false,
                notified: false,
                parent: false,
                reactions: [],
                rejection: false,
                state: PENDING,
                value: void 0
              });
            };
            Internal.prototype = redefineAll(PromisePrototype, {
              then: function then(onFulfilled, onRejected) {
                var state2 = getInternalPromiseState(this);
                var reactions = state2.reactions;
                var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                reaction.fail = isCallable(onRejected) && onRejected;
                reaction.domain = IS_NODE ? process2.domain : void 0;
                state2.parent = true;
                reactions[reactions.length] = reaction;
                if (state2.state != PENDING)
                  notify(state2, false);
                return reaction.promise;
              },
              "catch": function(onRejected) {
                return this.then(void 0, onRejected);
              }
            });
            OwnPromiseCapability = function() {
              var promise = new Internal();
              var state2 = getInternalState(promise);
              this.promise = promise;
              this.resolve = bind3(internalResolve, state2);
              this.reject = bind3(internalReject, state2);
            };
            newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
              return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
            };
            if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
              nativeThen = NativePromisePrototype.then;
              if (!SUBCLASSING) {
                redefine(NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
                  var that = this;
                  return new PromiseConstructor(function(resolve, reject) {
                    call(nativeThen, that, resolve, reject);
                  }).then(onFulfilled, onRejected);
                }, { unsafe: true });
                redefine(NativePromisePrototype, "catch", PromisePrototype["catch"], { unsafe: true });
              }
              try {
                delete NativePromisePrototype.constructor;
              } catch (error3) {
              }
              if (setPrototypeOf) {
                setPrototypeOf(NativePromisePrototype, PromisePrototype);
              }
            }
          }
          $2({
            global: true,
            wrap: true,
            forced: FORCED
          }, { Promise: PromiseConstructor });
          setToStringTag(PromiseConstructor, PROMISE, false, true);
          setSpecies(PROMISE);
          PromiseWrapper = getBuiltIn(PROMISE);
          $2({
            target: PROMISE,
            stat: true,
            forced: FORCED
          }, {
            reject: function reject(r2) {
              var capability = newPromiseCapability(this);
              call(capability.reject, void 0, r2);
              return capability.promise;
            }
          });
          $2({
            target: PROMISE,
            stat: true,
            forced: IS_PURE || FORCED
          }, {
            resolve: function resolve(x2) {
              return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x2);
            }
          });
          $2({
            target: PROMISE,
            stat: true,
            forced: INCORRECT_ITERATION
          }, {
            all: function all3(iterable) {
              var C = this;
              var capability = newPromiseCapability(C);
              var resolve = capability.resolve;
              var reject = capability.reject;
              var result2 = perform(function() {
                var $promiseResolve = aCallable(C.resolve);
                var values = [];
                var counter2 = 0;
                var remaining = 1;
                iterate(iterable, function(promise) {
                  var index2 = counter2++;
                  var alreadyCalled = false;
                  remaining++;
                  call($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled)
                      return;
                    alreadyCalled = true;
                    values[index2] = value;
                    --remaining || resolve(values);
                  }, reject);
                });
                --remaining || resolve(values);
              });
              if (result2.error)
                reject(result2.value);
              return capability.promise;
            },
            race: function race(iterable) {
              var C = this;
              var capability = newPromiseCapability(C);
              var reject = capability.reject;
              var result2 = perform(function() {
                var $promiseResolve = aCallable(C.resolve);
                iterate(iterable, function(promise) {
                  call($promiseResolve, C, promise).then(capability.resolve, reject);
                });
              });
              if (result2.error)
                reject(result2.value);
              return capability.promise;
            }
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          module2.exports = global2.Promise;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var redefine = __w_pdfjs_require__2(50);
          module2.exports = function(target, src2, options) {
            for (var key in src2)
              redefine(target, key, src2[key], options);
            return target;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var getBuiltIn = __w_pdfjs_require__2(27);
          var definePropertyModule = __w_pdfjs_require__2(48);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var DESCRIPTORS = __w_pdfjs_require__2(12);
          var SPECIES = wellKnownSymbol("species");
          module2.exports = function(CONSTRUCTOR_NAME) {
            var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
            var defineProperty2 = definePropertyModule.f;
            if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
              defineProperty2(Constructor, SPECIES, {
                configurable: true,
                get: function() {
                  return this;
                }
              });
            }
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isPrototypeOf = __w_pdfjs_require__2(28);
          var TypeError2 = global2.TypeError;
          module2.exports = function(it, Prototype) {
            if (isPrototypeOf(Prototype, it))
              return it;
            throw TypeError2("Incorrect invocation");
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var ITERATOR = wellKnownSymbol("iterator");
          var SAFE_CLOSING = false;
          try {
            var called = 0;
            var iteratorWithReturn = {
              next: function() {
                return { done: !!called++ };
              },
              "return": function() {
                SAFE_CLOSING = true;
              }
            };
            iteratorWithReturn[ITERATOR] = function() {
              return this;
            };
            Array.from(iteratorWithReturn, function() {
              throw 2;
            });
          } catch (error3) {
          }
          module2.exports = function(exec, SKIP_CLOSING) {
            if (!SKIP_CLOSING && !SAFE_CLOSING)
              return false;
            var ITERATION_SUPPORT = false;
            try {
              var object = {};
              object[ITERATOR] = function() {
                return {
                  next: function() {
                    return { done: ITERATION_SUPPORT = true };
                  }
                };
              };
              exec(object);
            } catch (error3) {
            }
            return ITERATION_SUPPORT;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var anObject = __w_pdfjs_require__2(49);
          var aConstructor = __w_pdfjs_require__2(114);
          var wellKnownSymbol = __w_pdfjs_require__2(37);
          var SPECIES = wellKnownSymbol("species");
          module2.exports = function(O, defaultConstructor) {
            var C = anObject(O).constructor;
            var S2;
            return C === void 0 || (S2 = anObject(C)[SPECIES]) == void 0 ? defaultConstructor : aConstructor(S2);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var isConstructor = __w_pdfjs_require__2(115);
          var tryToString = __w_pdfjs_require__2(35);
          var TypeError2 = global2.TypeError;
          module2.exports = function(argument) {
            if (isConstructor(argument))
              return argument;
            throw TypeError2(tryToString(argument) + " is not a constructor");
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var fails = __w_pdfjs_require__2(13);
          var isCallable = __w_pdfjs_require__2(25);
          var classof = __w_pdfjs_require__2(92);
          var getBuiltIn = __w_pdfjs_require__2(27);
          var inspectSource = __w_pdfjs_require__2(51);
          var noop2 = function() {
          };
          var empty = [];
          var construct = getBuiltIn("Reflect", "construct");
          var constructorRegExp = /^\s*(?:class|function)\b/;
          var exec = uncurryThis(constructorRegExp.exec);
          var INCORRECT_TO_STRING = !constructorRegExp.exec(noop2);
          var isConstructorModern = function(argument) {
            if (!isCallable(argument))
              return false;
            try {
              construct(noop2, empty, argument);
              return true;
            } catch (error3) {
              return false;
            }
          };
          var isConstructorLegacy = function(argument) {
            if (!isCallable(argument))
              return false;
            switch (classof(argument)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
          };
          module2.exports = !construct || fails(function() {
            var called;
            return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
              called = true;
            }) || called;
          }) ? isConstructorLegacy : isConstructorModern;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var apply = __w_pdfjs_require__2(117);
          var bind3 = __w_pdfjs_require__2(88);
          var isCallable = __w_pdfjs_require__2(25);
          var hasOwn = __w_pdfjs_require__2(42);
          var fails = __w_pdfjs_require__2(13);
          var html = __w_pdfjs_require__2(76);
          var arraySlice = __w_pdfjs_require__2(118);
          var createElement2 = __w_pdfjs_require__2(46);
          var IS_IOS = __w_pdfjs_require__2(119);
          var IS_NODE = __w_pdfjs_require__2(120);
          var set2 = global2.setImmediate;
          var clear = global2.clearImmediate;
          var process2 = global2.process;
          var Dispatch = global2.Dispatch;
          var Function2 = global2.Function;
          var MessageChannel2 = global2.MessageChannel;
          var String2 = global2.String;
          var counter2 = 0;
          var queue = {};
          var ONREADYSTATECHANGE = "onreadystatechange";
          var location2, defer2, channel, port;
          try {
            location2 = global2.location;
          } catch (error3) {
          }
          var run = function(id2) {
            if (hasOwn(queue, id2)) {
              var fn = queue[id2];
              delete queue[id2];
              fn();
            }
          };
          var runner = function(id2) {
            return function() {
              run(id2);
            };
          };
          var listener = function(event) {
            run(event.data);
          };
          var post = function(id2) {
            global2.postMessage(String2(id2), location2.protocol + "//" + location2.host);
          };
          if (!set2 || !clear) {
            set2 = function setImmediate2(fn) {
              var args = arraySlice(arguments, 1);
              queue[++counter2] = function() {
                apply(isCallable(fn) ? fn : Function2(fn), void 0, args);
              };
              defer2(counter2);
              return counter2;
            };
            clear = function clearImmediate(id2) {
              delete queue[id2];
            };
            if (IS_NODE) {
              defer2 = function(id2) {
                process2.nextTick(runner(id2));
              };
            } else if (Dispatch && Dispatch.now) {
              defer2 = function(id2) {
                Dispatch.now(runner(id2));
              };
            } else if (MessageChannel2 && !IS_IOS) {
              channel = new MessageChannel2();
              port = channel.port2;
              channel.port1.onmessage = listener;
              defer2 = bind3(port.postMessage, port);
            } else if (global2.addEventListener && isCallable(global2.postMessage) && !global2.importScripts && location2 && location2.protocol !== "file:" && !fails(post)) {
              defer2 = post;
              global2.addEventListener("message", listener, false);
            } else if (ONREADYSTATECHANGE in createElement2("script")) {
              defer2 = function(id2) {
                html.appendChild(createElement2("script"))[ONREADYSTATECHANGE] = function() {
                  html.removeChild(this);
                  run(id2);
                };
              };
            } else {
              defer2 = function(id2) {
                setTimeout(runner(id2), 0);
              };
            }
          }
          module2.exports = {
            set: set2,
            clear
          };
        },
        (module2) => {
          var FunctionPrototype = Function.prototype;
          var apply = FunctionPrototype.apply;
          var bind3 = FunctionPrototype.bind;
          var call = FunctionPrototype.call;
          module2.exports = typeof Reflect == "object" && Reflect.apply || (bind3 ? call.bind(apply) : function() {
            return call.apply(apply, arguments);
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          module2.exports = uncurryThis([].slice);
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var userAgent = __w_pdfjs_require__2(32);
          module2.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var classof = __w_pdfjs_require__2(20);
          var global2 = __w_pdfjs_require__2(10);
          module2.exports = classof(global2.process) == "process";
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          var bind3 = __w_pdfjs_require__2(88);
          var getOwnPropertyDescriptor2 = __w_pdfjs_require__2(11).f;
          var macrotask = __w_pdfjs_require__2(116).set;
          var IS_IOS = __w_pdfjs_require__2(119);
          var IS_IOS_PEBBLE = __w_pdfjs_require__2(122);
          var IS_WEBOS_WEBKIT = __w_pdfjs_require__2(123);
          var IS_NODE = __w_pdfjs_require__2(120);
          var MutationObserver2 = global2.MutationObserver || global2.WebKitMutationObserver;
          var document2 = global2.document;
          var process2 = global2.process;
          var Promise2 = global2.Promise;
          var queueMicrotaskDescriptor = getOwnPropertyDescriptor2(global2, "queueMicrotask");
          var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
          var flush, head, last, notify, toggle, node, promise, then;
          if (!queueMicrotask) {
            flush = function() {
              var parent, fn;
              if (IS_NODE && (parent = process2.domain))
                parent.exit();
              while (head) {
                fn = head.fn;
                head = head.next;
                try {
                  fn();
                } catch (error3) {
                  if (head)
                    notify();
                  else
                    last = void 0;
                  throw error3;
                }
              }
              last = void 0;
              if (parent)
                parent.enter();
            };
            if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver2 && document2) {
              toggle = true;
              node = document2.createTextNode("");
              new MutationObserver2(flush).observe(node, { characterData: true });
              notify = function() {
                node.data = toggle = !toggle;
              };
            } else if (!IS_IOS_PEBBLE && Promise2 && Promise2.resolve) {
              promise = Promise2.resolve(void 0);
              promise.constructor = Promise2;
              then = bind3(promise.then, promise);
              notify = function() {
                then(flush);
              };
            } else if (IS_NODE) {
              notify = function() {
                process2.nextTick(flush);
              };
            } else {
              macrotask = bind3(macrotask, global2);
              notify = function() {
                macrotask(flush);
              };
            }
          }
          module2.exports = queueMicrotask || function(fn) {
            var task = {
              fn,
              next: void 0
            };
            if (last)
              last.next = task;
            if (!head) {
              head = task;
              notify();
            }
            last = task;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var userAgent = __w_pdfjs_require__2(32);
          var global2 = __w_pdfjs_require__2(10);
          module2.exports = /ipad|iphone|ipod/i.test(userAgent) && global2.Pebble !== void 0;
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var userAgent = __w_pdfjs_require__2(32);
          module2.exports = /web0s(?!.*chrome)/i.test(userAgent);
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var anObject = __w_pdfjs_require__2(49);
          var isObject3 = __w_pdfjs_require__2(24);
          var newPromiseCapability = __w_pdfjs_require__2(125);
          module2.exports = function(C, x2) {
            anObject(C);
            if (isObject3(x2) && x2.constructor === C)
              return x2;
            var promiseCapability = newPromiseCapability.f(C);
            var resolve = promiseCapability.resolve;
            resolve(x2);
            return promiseCapability.promise;
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var aCallable = __w_pdfjs_require__2(34);
          var PromiseCapability = function(C) {
            var resolve, reject;
            this.promise = new C(function($$resolve, $$reject) {
              if (resolve !== void 0 || reject !== void 0)
                throw TypeError("Bad Promise constructor");
              resolve = $$resolve;
              reject = $$reject;
            });
            this.resolve = aCallable(resolve);
            this.reject = aCallable(reject);
          };
          module2.exports.f = function(C) {
            return new PromiseCapability(C);
          };
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var global2 = __w_pdfjs_require__2(10);
          module2.exports = function(a6, b2) {
            var console2 = global2.console;
            if (console2 && console2.error) {
              arguments.length == 1 ? console2.error(a6) : console2.error(a6, b2);
            }
          };
        },
        (module2) => {
          module2.exports = function(exec) {
            try {
              return {
                error: false,
                value: exec()
              };
            } catch (error3) {
              return {
                error: true,
                value: error3
              };
            }
          };
        },
        (module2) => {
          module2.exports = typeof window == "object";
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var call = __w_pdfjs_require__2(14);
          var aCallable = __w_pdfjs_require__2(34);
          var newPromiseCapabilityModule = __w_pdfjs_require__2(125);
          var perform = __w_pdfjs_require__2(127);
          var iterate = __w_pdfjs_require__2(87);
          $2({
            target: "Promise",
            stat: true
          }, {
            allSettled: function allSettled(iterable) {
              var C = this;
              var capability = newPromiseCapabilityModule.f(C);
              var resolve = capability.resolve;
              var reject = capability.reject;
              var result2 = perform(function() {
                var promiseResolve = aCallable(C.resolve);
                var values = [];
                var counter2 = 0;
                var remaining = 1;
                iterate(iterable, function(promise) {
                  var index2 = counter2++;
                  var alreadyCalled = false;
                  remaining++;
                  call(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled)
                      return;
                    alreadyCalled = true;
                    values[index2] = {
                      status: "fulfilled",
                      value
                    };
                    --remaining || resolve(values);
                  }, function(error3) {
                    if (alreadyCalled)
                      return;
                    alreadyCalled = true;
                    values[index2] = {
                      status: "rejected",
                      reason: error3
                    };
                    --remaining || resolve(values);
                  });
                });
                --remaining || resolve(values);
              });
              if (result2.error)
                reject(result2.value);
              return capability.promise;
            }
          });
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var aCallable = __w_pdfjs_require__2(34);
          var getBuiltIn = __w_pdfjs_require__2(27);
          var call = __w_pdfjs_require__2(14);
          var newPromiseCapabilityModule = __w_pdfjs_require__2(125);
          var perform = __w_pdfjs_require__2(127);
          var iterate = __w_pdfjs_require__2(87);
          var PROMISE_ANY_ERROR = "No one promise resolved";
          $2({
            target: "Promise",
            stat: true
          }, {
            any: function any2(iterable) {
              var C = this;
              var AggregateError = getBuiltIn("AggregateError");
              var capability = newPromiseCapabilityModule.f(C);
              var resolve = capability.resolve;
              var reject = capability.reject;
              var result2 = perform(function() {
                var promiseResolve = aCallable(C.resolve);
                var errors = [];
                var counter2 = 0;
                var remaining = 1;
                var alreadyResolved = false;
                iterate(iterable, function(promise) {
                  var index2 = counter2++;
                  var alreadyRejected = false;
                  remaining++;
                  call(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved)
                      return;
                    alreadyResolved = true;
                    resolve(value);
                  }, function(error3) {
                    if (alreadyRejected || alreadyResolved)
                      return;
                    alreadyRejected = true;
                    errors[index2] = error3;
                    --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                  });
                });
                --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
              });
              if (result2.error)
                reject(result2.value);
              return capability.promise;
            }
          });
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var $2 = __w_pdfjs_require__2(9);
          var IS_PURE = __w_pdfjs_require__2(39);
          var NativePromise = __w_pdfjs_require__2(108);
          var fails = __w_pdfjs_require__2(13);
          var getBuiltIn = __w_pdfjs_require__2(27);
          var isCallable = __w_pdfjs_require__2(25);
          var speciesConstructor = __w_pdfjs_require__2(113);
          var promiseResolve = __w_pdfjs_require__2(124);
          var redefine = __w_pdfjs_require__2(50);
          var NON_GENERIC = !!NativePromise && fails(function() {
            NativePromise.prototype["finally"].call({
              then: function() {
              }
            }, function() {
            });
          });
          $2({
            target: "Promise",
            proto: true,
            real: true,
            forced: NON_GENERIC
          }, {
            "finally": function(onFinally) {
              var C = speciesConstructor(this, getBuiltIn("Promise"));
              var isFunction2 = isCallable(onFinally);
              return this.then(isFunction2 ? function(x2) {
                return promiseResolve(C, onFinally()).then(function() {
                  return x2;
                });
              } : onFinally, isFunction2 ? function(e2) {
                return promiseResolve(C, onFinally()).then(function() {
                  throw e2;
                });
              } : onFinally);
            }
          });
          if (!IS_PURE && isCallable(NativePromise)) {
            var method2 = getBuiltIn("Promise").prototype["finally"];
            if (NativePromise.prototype["finally"] !== method2) {
              redefine(NativePromise.prototype, "finally", method2, { unsafe: true });
            }
          }
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var charAt = __w_pdfjs_require__2(133).charAt;
          var toString4 = __w_pdfjs_require__2(103);
          var InternalStateModule = __w_pdfjs_require__2(52);
          var defineIterator = __w_pdfjs_require__2(78);
          var STRING_ITERATOR = "String Iterator";
          var setInternalState = InternalStateModule.set;
          var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
          defineIterator(String, "String", function(iterated) {
            setInternalState(this, {
              type: STRING_ITERATOR,
              string: toString4(iterated),
              index: 0
            });
          }, function next() {
            var state2 = getInternalState(this);
            var string2 = state2.string;
            var index2 = state2.index;
            var point;
            if (index2 >= string2.length)
              return {
                value: void 0,
                done: true
              };
            point = charAt(string2, index2);
            state2.index += point.length;
            return {
              value: point,
              done: false
            };
          });
        },
        (module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          var uncurryThis = __w_pdfjs_require__2(19);
          var toIntegerOrInfinity = __w_pdfjs_require__2(63);
          var toString4 = __w_pdfjs_require__2(103);
          var requireObjectCoercible = __w_pdfjs_require__2(21);
          var charAt = uncurryThis("".charAt);
          var charCodeAt = uncurryThis("".charCodeAt);
          var stringSlice = uncurryThis("".slice);
          var createMethod2 = function(CONVERT_TO_STRING) {
            return function($this, pos) {
              var S2 = toString4(requireObjectCoercible($this));
              var position = toIntegerOrInfinity(pos);
              var size = S2.length;
              var first, second;
              if (position < 0 || position >= size)
                return CONVERT_TO_STRING ? "" : void 0;
              first = charCodeAt(S2, position);
              return first < 55296 || first > 56319 || position + 1 === size || (second = charCodeAt(S2, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt(S2, position) : first : CONVERT_TO_STRING ? stringSlice(S2, position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
            };
          };
          module2.exports = {
            codeAt: createMethod2(false),
            charAt: createMethod2(true)
          };
        },
        function(__unused_webpack_module2, exports2) {
          (function(global2, factory) {
            factory(exports2);
          })(this, function(exports3) {
            var SymbolPolyfill = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol : function(description) {
              return "Symbol(" + description + ")";
            };
            function noop2() {
              return void 0;
            }
            function getGlobals() {
              if (typeof self !== "undefined") {
                return self;
              } else if (typeof window !== "undefined") {
                return window;
              } else if (typeof commonjsGlobal !== "undefined") {
                return commonjsGlobal;
              }
              return void 0;
            }
            var globals = getGlobals();
            function typeIsObject(x2) {
              return typeof x2 === "object" && x2 !== null || typeof x2 === "function";
            }
            var rethrowAssertionErrorRejection = noop2;
            var originalPromise = Promise;
            var originalPromiseThen = Promise.prototype.then;
            var originalPromiseResolve = Promise.resolve.bind(originalPromise);
            var originalPromiseReject = Promise.reject.bind(originalPromise);
            function newPromise(executor) {
              return new originalPromise(executor);
            }
            function promiseResolvedWith(value) {
              return originalPromiseResolve(value);
            }
            function promiseRejectedWith(reason) {
              return originalPromiseReject(reason);
            }
            function PerformPromiseThen(promise, onFulfilled, onRejected) {
              return originalPromiseThen.call(promise, onFulfilled, onRejected);
            }
            function uponPromise(promise, onFulfilled, onRejected) {
              PerformPromiseThen(PerformPromiseThen(promise, onFulfilled, onRejected), void 0, rethrowAssertionErrorRejection);
            }
            function uponFulfillment(promise, onFulfilled) {
              uponPromise(promise, onFulfilled);
            }
            function uponRejection(promise, onRejected) {
              uponPromise(promise, void 0, onRejected);
            }
            function transformPromiseWith(promise, fulfillmentHandler, rejectionHandler) {
              return PerformPromiseThen(promise, fulfillmentHandler, rejectionHandler);
            }
            function setPromiseIsHandledToTrue(promise) {
              PerformPromiseThen(promise, void 0, rethrowAssertionErrorRejection);
            }
            var queueMicrotask = function() {
              var globalQueueMicrotask = globals && globals.queueMicrotask;
              if (typeof globalQueueMicrotask === "function") {
                return globalQueueMicrotask;
              }
              var resolvedPromise = promiseResolvedWith(void 0);
              return function(fn) {
                return PerformPromiseThen(resolvedPromise, fn);
              };
            }();
            function reflectCall(F2, V2, args) {
              if (typeof F2 !== "function") {
                throw new TypeError("Argument is not a function");
              }
              return Function.prototype.apply.call(F2, V2, args);
            }
            function promiseCall(F2, V2, args) {
              try {
                return promiseResolvedWith(reflectCall(F2, V2, args));
              } catch (value) {
                return promiseRejectedWith(value);
              }
            }
            var QUEUE_MAX_ARRAY_SIZE = 16384;
            var SimpleQueue = function() {
              function SimpleQueue2() {
                this._cursor = 0;
                this._size = 0;
                this._front = {
                  _elements: [],
                  _next: void 0
                };
                this._back = this._front;
                this._cursor = 0;
                this._size = 0;
              }
              Object.defineProperty(SimpleQueue2.prototype, "length", {
                get: function() {
                  return this._size;
                },
                enumerable: false,
                configurable: true
              });
              SimpleQueue2.prototype.push = function(element) {
                var oldBack = this._back;
                var newBack = oldBack;
                if (oldBack._elements.length === QUEUE_MAX_ARRAY_SIZE - 1) {
                  newBack = {
                    _elements: [],
                    _next: void 0
                  };
                }
                oldBack._elements.push(element);
                if (newBack !== oldBack) {
                  this._back = newBack;
                  oldBack._next = newBack;
                }
                ++this._size;
              };
              SimpleQueue2.prototype.shift = function() {
                var oldFront = this._front;
                var newFront = oldFront;
                var oldCursor = this._cursor;
                var newCursor = oldCursor + 1;
                var elements = oldFront._elements;
                var element = elements[oldCursor];
                if (newCursor === QUEUE_MAX_ARRAY_SIZE) {
                  newFront = oldFront._next;
                  newCursor = 0;
                }
                --this._size;
                this._cursor = newCursor;
                if (oldFront !== newFront) {
                  this._front = newFront;
                }
                elements[oldCursor] = void 0;
                return element;
              };
              SimpleQueue2.prototype.forEach = function(callback) {
                var i2 = this._cursor;
                var node = this._front;
                var elements = node._elements;
                while (i2 !== elements.length || node._next !== void 0) {
                  if (i2 === elements.length) {
                    node = node._next;
                    elements = node._elements;
                    i2 = 0;
                    if (elements.length === 0) {
                      break;
                    }
                  }
                  callback(elements[i2]);
                  ++i2;
                }
              };
              SimpleQueue2.prototype.peek = function() {
                var front = this._front;
                var cursor = this._cursor;
                return front._elements[cursor];
              };
              return SimpleQueue2;
            }();
            function ReadableStreamReaderGenericInitialize(reader, stream) {
              reader._ownerReadableStream = stream;
              stream._reader = reader;
              if (stream._state === "readable") {
                defaultReaderClosedPromiseInitialize(reader);
              } else if (stream._state === "closed") {
                defaultReaderClosedPromiseInitializeAsResolved(reader);
              } else {
                defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
              }
            }
            function ReadableStreamReaderGenericCancel(reader, reason) {
              var stream = reader._ownerReadableStream;
              return ReadableStreamCancel(stream, reason);
            }
            function ReadableStreamReaderGenericRelease(reader) {
              if (reader._ownerReadableStream._state === "readable") {
                defaultReaderClosedPromiseReject(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
              } else {
                defaultReaderClosedPromiseResetToRejected(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
              }
              reader._ownerReadableStream._reader = void 0;
              reader._ownerReadableStream = void 0;
            }
            function readerLockException(name) {
              return new TypeError("Cannot " + name + " a stream using a released reader");
            }
            function defaultReaderClosedPromiseInitialize(reader) {
              reader._closedPromise = newPromise(function(resolve, reject) {
                reader._closedPromise_resolve = resolve;
                reader._closedPromise_reject = reject;
              });
            }
            function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
              defaultReaderClosedPromiseInitialize(reader);
              defaultReaderClosedPromiseReject(reader, reason);
            }
            function defaultReaderClosedPromiseInitializeAsResolved(reader) {
              defaultReaderClosedPromiseInitialize(reader);
              defaultReaderClosedPromiseResolve(reader);
            }
            function defaultReaderClosedPromiseReject(reader, reason) {
              if (reader._closedPromise_reject === void 0) {
                return;
              }
              setPromiseIsHandledToTrue(reader._closedPromise);
              reader._closedPromise_reject(reason);
              reader._closedPromise_resolve = void 0;
              reader._closedPromise_reject = void 0;
            }
            function defaultReaderClosedPromiseResetToRejected(reader, reason) {
              defaultReaderClosedPromiseInitializeAsRejected(reader, reason);
            }
            function defaultReaderClosedPromiseResolve(reader) {
              if (reader._closedPromise_resolve === void 0) {
                return;
              }
              reader._closedPromise_resolve(void 0);
              reader._closedPromise_resolve = void 0;
              reader._closedPromise_reject = void 0;
            }
            var AbortSteps = SymbolPolyfill("[[AbortSteps]]");
            var ErrorSteps = SymbolPolyfill("[[ErrorSteps]]");
            var CancelSteps = SymbolPolyfill("[[CancelSteps]]");
            var PullSteps = SymbolPolyfill("[[PullSteps]]");
            var NumberIsFinite = Number.isFinite || function(x2) {
              return typeof x2 === "number" && isFinite(x2);
            };
            var MathTrunc = Math.trunc || function(v2) {
              return v2 < 0 ? Math.ceil(v2) : Math.floor(v2);
            };
            function isDictionary(x2) {
              return typeof x2 === "object" || typeof x2 === "function";
            }
            function assertDictionary(obj, context2) {
              if (obj !== void 0 && !isDictionary(obj)) {
                throw new TypeError(context2 + " is not an object.");
              }
            }
            function assertFunction(x2, context2) {
              if (typeof x2 !== "function") {
                throw new TypeError(context2 + " is not a function.");
              }
            }
            function isObject3(x2) {
              return typeof x2 === "object" && x2 !== null || typeof x2 === "function";
            }
            function assertObject(x2, context2) {
              if (!isObject3(x2)) {
                throw new TypeError(context2 + " is not an object.");
              }
            }
            function assertRequiredArgument(x2, position, context2) {
              if (x2 === void 0) {
                throw new TypeError("Parameter " + position + " is required in '" + context2 + "'.");
              }
            }
            function assertRequiredField(x2, field, context2) {
              if (x2 === void 0) {
                throw new TypeError(field + " is required in '" + context2 + "'.");
              }
            }
            function convertUnrestrictedDouble(value) {
              return Number(value);
            }
            function censorNegativeZero(x2) {
              return x2 === 0 ? 0 : x2;
            }
            function integerPart(x2) {
              return censorNegativeZero(MathTrunc(x2));
            }
            function convertUnsignedLongLongWithEnforceRange(value, context2) {
              var lowerBound = 0;
              var upperBound = Number.MAX_SAFE_INTEGER;
              var x2 = Number(value);
              x2 = censorNegativeZero(x2);
              if (!NumberIsFinite(x2)) {
                throw new TypeError(context2 + " is not a finite number");
              }
              x2 = integerPart(x2);
              if (x2 < lowerBound || x2 > upperBound) {
                throw new TypeError(context2 + " is outside the accepted range of " + lowerBound + " to " + upperBound + ", inclusive");
              }
              if (!NumberIsFinite(x2) || x2 === 0) {
                return 0;
              }
              return x2;
            }
            function assertReadableStream(x2, context2) {
              if (!IsReadableStream(x2)) {
                throw new TypeError(context2 + " is not a ReadableStream.");
              }
            }
            function AcquireReadableStreamDefaultReader(stream) {
              return new ReadableStreamDefaultReader(stream);
            }
            function ReadableStreamAddReadRequest(stream, readRequest) {
              stream._reader._readRequests.push(readRequest);
            }
            function ReadableStreamFulfillReadRequest(stream, chunk, done) {
              var reader = stream._reader;
              var readRequest = reader._readRequests.shift();
              if (done) {
                readRequest._closeSteps();
              } else {
                readRequest._chunkSteps(chunk);
              }
            }
            function ReadableStreamGetNumReadRequests(stream) {
              return stream._reader._readRequests.length;
            }
            function ReadableStreamHasDefaultReader(stream) {
              var reader = stream._reader;
              if (reader === void 0) {
                return false;
              }
              if (!IsReadableStreamDefaultReader(reader)) {
                return false;
              }
              return true;
            }
            var ReadableStreamDefaultReader = function() {
              function ReadableStreamDefaultReader2(stream) {
                assertRequiredArgument(stream, 1, "ReadableStreamDefaultReader");
                assertReadableStream(stream, "First parameter");
                if (IsReadableStreamLocked(stream)) {
                  throw new TypeError("This stream has already been locked for exclusive reading by another reader");
                }
                ReadableStreamReaderGenericInitialize(this, stream);
                this._readRequests = new SimpleQueue();
              }
              Object.defineProperty(ReadableStreamDefaultReader2.prototype, "closed", {
                get: function() {
                  if (!IsReadableStreamDefaultReader(this)) {
                    return promiseRejectedWith(defaultReaderBrandCheckException("closed"));
                  }
                  return this._closedPromise;
                },
                enumerable: false,
                configurable: true
              });
              ReadableStreamDefaultReader2.prototype.cancel = function(reason) {
                if (reason === void 0) {
                  reason = void 0;
                }
                if (!IsReadableStreamDefaultReader(this)) {
                  return promiseRejectedWith(defaultReaderBrandCheckException("cancel"));
                }
                if (this._ownerReadableStream === void 0) {
                  return promiseRejectedWith(readerLockException("cancel"));
                }
                return ReadableStreamReaderGenericCancel(this, reason);
              };
              ReadableStreamDefaultReader2.prototype.read = function() {
                if (!IsReadableStreamDefaultReader(this)) {
                  return promiseRejectedWith(defaultReaderBrandCheckException("read"));
                }
                if (this._ownerReadableStream === void 0) {
                  return promiseRejectedWith(readerLockException("read from"));
                }
                var resolvePromise;
                var rejectPromise;
                var promise = newPromise(function(resolve, reject) {
                  resolvePromise = resolve;
                  rejectPromise = reject;
                });
                var readRequest = {
                  _chunkSteps: function(chunk) {
                    return resolvePromise({
                      value: chunk,
                      done: false
                    });
                  },
                  _closeSteps: function() {
                    return resolvePromise({
                      value: void 0,
                      done: true
                    });
                  },
                  _errorSteps: function(e2) {
                    return rejectPromise(e2);
                  }
                };
                ReadableStreamDefaultReaderRead(this, readRequest);
                return promise;
              };
              ReadableStreamDefaultReader2.prototype.releaseLock = function() {
                if (!IsReadableStreamDefaultReader(this)) {
                  throw defaultReaderBrandCheckException("releaseLock");
                }
                if (this._ownerReadableStream === void 0) {
                  return;
                }
                if (this._readRequests.length > 0) {
                  throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
                }
                ReadableStreamReaderGenericRelease(this);
              };
              return ReadableStreamDefaultReader2;
            }();
            Object.defineProperties(ReadableStreamDefaultReader.prototype, {
              cancel: { enumerable: true },
              read: { enumerable: true },
              releaseLock: { enumerable: true },
              closed: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ReadableStreamDefaultReader.prototype, SymbolPolyfill.toStringTag, {
                value: "ReadableStreamDefaultReader",
                configurable: true
              });
            }
            function IsReadableStreamDefaultReader(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_readRequests")) {
                return false;
              }
              return x2 instanceof ReadableStreamDefaultReader;
            }
            function ReadableStreamDefaultReaderRead(reader, readRequest) {
              var stream = reader._ownerReadableStream;
              stream._disturbed = true;
              if (stream._state === "closed") {
                readRequest._closeSteps();
              } else if (stream._state === "errored") {
                readRequest._errorSteps(stream._storedError);
              } else {
                stream._readableStreamController[PullSteps](readRequest);
              }
            }
            function defaultReaderBrandCheckException(name) {
              return new TypeError("ReadableStreamDefaultReader.prototype." + name + " can only be used on a ReadableStreamDefaultReader");
            }
            var _a;
            var AsyncIteratorPrototype;
            if (typeof SymbolPolyfill.asyncIterator === "symbol") {
              AsyncIteratorPrototype = (_a = {}, _a[SymbolPolyfill.asyncIterator] = function() {
                return this;
              }, _a);
              Object.defineProperty(AsyncIteratorPrototype, SymbolPolyfill.asyncIterator, { enumerable: false });
            }
            var ReadableStreamAsyncIteratorImpl = function() {
              function ReadableStreamAsyncIteratorImpl2(reader, preventCancel) {
                this._ongoingPromise = void 0;
                this._isFinished = false;
                this._reader = reader;
                this._preventCancel = preventCancel;
              }
              ReadableStreamAsyncIteratorImpl2.prototype.next = function() {
                var _this = this;
                var nextSteps = function() {
                  return _this._nextSteps();
                };
                this._ongoingPromise = this._ongoingPromise ? transformPromiseWith(this._ongoingPromise, nextSteps, nextSteps) : nextSteps();
                return this._ongoingPromise;
              };
              ReadableStreamAsyncIteratorImpl2.prototype.return = function(value) {
                var _this = this;
                var returnSteps = function() {
                  return _this._returnSteps(value);
                };
                return this._ongoingPromise ? transformPromiseWith(this._ongoingPromise, returnSteps, returnSteps) : returnSteps();
              };
              ReadableStreamAsyncIteratorImpl2.prototype._nextSteps = function() {
                var _this = this;
                if (this._isFinished) {
                  return Promise.resolve({
                    value: void 0,
                    done: true
                  });
                }
                var reader = this._reader;
                if (reader._ownerReadableStream === void 0) {
                  return promiseRejectedWith(readerLockException("iterate"));
                }
                var resolvePromise;
                var rejectPromise;
                var promise = newPromise(function(resolve, reject) {
                  resolvePromise = resolve;
                  rejectPromise = reject;
                });
                var readRequest = {
                  _chunkSteps: function(chunk) {
                    _this._ongoingPromise = void 0;
                    queueMicrotask(function() {
                      return resolvePromise({
                        value: chunk,
                        done: false
                      });
                    });
                  },
                  _closeSteps: function() {
                    _this._ongoingPromise = void 0;
                    _this._isFinished = true;
                    ReadableStreamReaderGenericRelease(reader);
                    resolvePromise({
                      value: void 0,
                      done: true
                    });
                  },
                  _errorSteps: function(reason) {
                    _this._ongoingPromise = void 0;
                    _this._isFinished = true;
                    ReadableStreamReaderGenericRelease(reader);
                    rejectPromise(reason);
                  }
                };
                ReadableStreamDefaultReaderRead(reader, readRequest);
                return promise;
              };
              ReadableStreamAsyncIteratorImpl2.prototype._returnSteps = function(value) {
                if (this._isFinished) {
                  return Promise.resolve({
                    value,
                    done: true
                  });
                }
                this._isFinished = true;
                var reader = this._reader;
                if (reader._ownerReadableStream === void 0) {
                  return promiseRejectedWith(readerLockException("finish iterating"));
                }
                if (!this._preventCancel) {
                  var result2 = ReadableStreamReaderGenericCancel(reader, value);
                  ReadableStreamReaderGenericRelease(reader);
                  return transformPromiseWith(result2, function() {
                    return {
                      value,
                      done: true
                    };
                  });
                }
                ReadableStreamReaderGenericRelease(reader);
                return promiseResolvedWith({
                  value,
                  done: true
                });
              };
              return ReadableStreamAsyncIteratorImpl2;
            }();
            var ReadableStreamAsyncIteratorPrototype = {
              next: function() {
                if (!IsReadableStreamAsyncIterator(this)) {
                  return promiseRejectedWith(streamAsyncIteratorBrandCheckException("next"));
                }
                return this._asyncIteratorImpl.next();
              },
              return: function(value) {
                if (!IsReadableStreamAsyncIterator(this)) {
                  return promiseRejectedWith(streamAsyncIteratorBrandCheckException("return"));
                }
                return this._asyncIteratorImpl.return(value);
              }
            };
            if (AsyncIteratorPrototype !== void 0) {
              Object.setPrototypeOf(ReadableStreamAsyncIteratorPrototype, AsyncIteratorPrototype);
            }
            function AcquireReadableStreamAsyncIterator(stream, preventCancel) {
              var reader = AcquireReadableStreamDefaultReader(stream);
              var impl = new ReadableStreamAsyncIteratorImpl(reader, preventCancel);
              var iterator = Object.create(ReadableStreamAsyncIteratorPrototype);
              iterator._asyncIteratorImpl = impl;
              return iterator;
            }
            function IsReadableStreamAsyncIterator(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_asyncIteratorImpl")) {
                return false;
              }
              try {
                return x2._asyncIteratorImpl instanceof ReadableStreamAsyncIteratorImpl;
              } catch (_a2) {
                return false;
              }
            }
            function streamAsyncIteratorBrandCheckException(name) {
              return new TypeError("ReadableStreamAsyncIterator." + name + " can only be used on a ReadableSteamAsyncIterator");
            }
            var NumberIsNaN = Number.isNaN || function(x2) {
              return x2 !== x2;
            };
            function CreateArrayFromList(elements) {
              return elements.slice();
            }
            function CopyDataBlockBytes(dest, destOffset, src2, srcOffset, n2) {
              new Uint8Array(dest).set(new Uint8Array(src2, srcOffset, n2), destOffset);
            }
            function TransferArrayBuffer(O) {
              return O;
            }
            function IsDetachedBuffer(O) {
              return false;
            }
            function ArrayBufferSlice(buffer2, begin, end) {
              if (buffer2.slice) {
                return buffer2.slice(begin, end);
              }
              var length = end - begin;
              var slice2 = new ArrayBuffer(length);
              CopyDataBlockBytes(slice2, 0, buffer2, begin, length);
              return slice2;
            }
            function IsNonNegativeNumber(v2) {
              if (typeof v2 !== "number") {
                return false;
              }
              if (NumberIsNaN(v2)) {
                return false;
              }
              if (v2 < 0) {
                return false;
              }
              return true;
            }
            function CloneAsUint8Array(O) {
              var buffer2 = ArrayBufferSlice(O.buffer, O.byteOffset, O.byteOffset + O.byteLength);
              return new Uint8Array(buffer2);
            }
            function DequeueValue(container) {
              var pair = container._queue.shift();
              container._queueTotalSize -= pair.size;
              if (container._queueTotalSize < 0) {
                container._queueTotalSize = 0;
              }
              return pair.value;
            }
            function EnqueueValueWithSize(container, value, size) {
              if (!IsNonNegativeNumber(size) || size === Infinity) {
                throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
              }
              container._queue.push({
                value,
                size
              });
              container._queueTotalSize += size;
            }
            function PeekQueueValue(container) {
              var pair = container._queue.peek();
              return pair.value;
            }
            function ResetQueue(container) {
              container._queue = new SimpleQueue();
              container._queueTotalSize = 0;
            }
            var ReadableStreamBYOBRequest = function() {
              function ReadableStreamBYOBRequest2() {
                throw new TypeError("Illegal constructor");
              }
              Object.defineProperty(ReadableStreamBYOBRequest2.prototype, "view", {
                get: function() {
                  if (!IsReadableStreamBYOBRequest(this)) {
                    throw byobRequestBrandCheckException("view");
                  }
                  return this._view;
                },
                enumerable: false,
                configurable: true
              });
              ReadableStreamBYOBRequest2.prototype.respond = function(bytesWritten) {
                if (!IsReadableStreamBYOBRequest(this)) {
                  throw byobRequestBrandCheckException("respond");
                }
                assertRequiredArgument(bytesWritten, 1, "respond");
                bytesWritten = convertUnsignedLongLongWithEnforceRange(bytesWritten, "First parameter");
                if (this._associatedReadableByteStreamController === void 0) {
                  throw new TypeError("This BYOB request has been invalidated");
                }
                if (IsDetachedBuffer(this._view.buffer))
                  ;
                ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
              };
              ReadableStreamBYOBRequest2.prototype.respondWithNewView = function(view) {
                if (!IsReadableStreamBYOBRequest(this)) {
                  throw byobRequestBrandCheckException("respondWithNewView");
                }
                assertRequiredArgument(view, 1, "respondWithNewView");
                if (!ArrayBuffer.isView(view)) {
                  throw new TypeError("You can only respond with array buffer views");
                }
                if (this._associatedReadableByteStreamController === void 0) {
                  throw new TypeError("This BYOB request has been invalidated");
                }
                if (IsDetachedBuffer(view.buffer))
                  ;
                ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
              };
              return ReadableStreamBYOBRequest2;
            }();
            Object.defineProperties(ReadableStreamBYOBRequest.prototype, {
              respond: { enumerable: true },
              respondWithNewView: { enumerable: true },
              view: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ReadableStreamBYOBRequest.prototype, SymbolPolyfill.toStringTag, {
                value: "ReadableStreamBYOBRequest",
                configurable: true
              });
            }
            var ReadableByteStreamController = function() {
              function ReadableByteStreamController2() {
                throw new TypeError("Illegal constructor");
              }
              Object.defineProperty(ReadableByteStreamController2.prototype, "byobRequest", {
                get: function() {
                  if (!IsReadableByteStreamController(this)) {
                    throw byteStreamControllerBrandCheckException("byobRequest");
                  }
                  return ReadableByteStreamControllerGetBYOBRequest(this);
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(ReadableByteStreamController2.prototype, "desiredSize", {
                get: function() {
                  if (!IsReadableByteStreamController(this)) {
                    throw byteStreamControllerBrandCheckException("desiredSize");
                  }
                  return ReadableByteStreamControllerGetDesiredSize(this);
                },
                enumerable: false,
                configurable: true
              });
              ReadableByteStreamController2.prototype.close = function() {
                if (!IsReadableByteStreamController(this)) {
                  throw byteStreamControllerBrandCheckException("close");
                }
                if (this._closeRequested) {
                  throw new TypeError("The stream has already been closed; do not close it again!");
                }
                var state2 = this._controlledReadableByteStream._state;
                if (state2 !== "readable") {
                  throw new TypeError("The stream (in " + state2 + " state) is not in the readable state and cannot be closed");
                }
                ReadableByteStreamControllerClose(this);
              };
              ReadableByteStreamController2.prototype.enqueue = function(chunk) {
                if (!IsReadableByteStreamController(this)) {
                  throw byteStreamControllerBrandCheckException("enqueue");
                }
                assertRequiredArgument(chunk, 1, "enqueue");
                if (!ArrayBuffer.isView(chunk)) {
                  throw new TypeError("chunk must be an array buffer view");
                }
                if (chunk.byteLength === 0) {
                  throw new TypeError("chunk must have non-zero byteLength");
                }
                if (chunk.buffer.byteLength === 0) {
                  throw new TypeError("chunk's buffer must have non-zero byteLength");
                }
                if (this._closeRequested) {
                  throw new TypeError("stream is closed or draining");
                }
                var state2 = this._controlledReadableByteStream._state;
                if (state2 !== "readable") {
                  throw new TypeError("The stream (in " + state2 + " state) is not in the readable state and cannot be enqueued to");
                }
                ReadableByteStreamControllerEnqueue(this, chunk);
              };
              ReadableByteStreamController2.prototype.error = function(e2) {
                if (e2 === void 0) {
                  e2 = void 0;
                }
                if (!IsReadableByteStreamController(this)) {
                  throw byteStreamControllerBrandCheckException("error");
                }
                ReadableByteStreamControllerError(this, e2);
              };
              ReadableByteStreamController2.prototype[CancelSteps] = function(reason) {
                ReadableByteStreamControllerClearPendingPullIntos(this);
                ResetQueue(this);
                var result2 = this._cancelAlgorithm(reason);
                ReadableByteStreamControllerClearAlgorithms(this);
                return result2;
              };
              ReadableByteStreamController2.prototype[PullSteps] = function(readRequest) {
                var stream = this._controlledReadableByteStream;
                if (this._queueTotalSize > 0) {
                  var entry = this._queue.shift();
                  this._queueTotalSize -= entry.byteLength;
                  ReadableByteStreamControllerHandleQueueDrain(this);
                  var view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
                  readRequest._chunkSteps(view);
                  return;
                }
                var autoAllocateChunkSize = this._autoAllocateChunkSize;
                if (autoAllocateChunkSize !== void 0) {
                  var buffer2 = void 0;
                  try {
                    buffer2 = new ArrayBuffer(autoAllocateChunkSize);
                  } catch (bufferE) {
                    readRequest._errorSteps(bufferE);
                    return;
                  }
                  var pullIntoDescriptor = {
                    buffer: buffer2,
                    bufferByteLength: autoAllocateChunkSize,
                    byteOffset: 0,
                    byteLength: autoAllocateChunkSize,
                    bytesFilled: 0,
                    elementSize: 1,
                    viewConstructor: Uint8Array,
                    readerType: "default"
                  };
                  this._pendingPullIntos.push(pullIntoDescriptor);
                }
                ReadableStreamAddReadRequest(stream, readRequest);
                ReadableByteStreamControllerCallPullIfNeeded(this);
              };
              return ReadableByteStreamController2;
            }();
            Object.defineProperties(ReadableByteStreamController.prototype, {
              close: { enumerable: true },
              enqueue: { enumerable: true },
              error: { enumerable: true },
              byobRequest: { enumerable: true },
              desiredSize: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ReadableByteStreamController.prototype, SymbolPolyfill.toStringTag, {
                value: "ReadableByteStreamController",
                configurable: true
              });
            }
            function IsReadableByteStreamController(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_controlledReadableByteStream")) {
                return false;
              }
              return x2 instanceof ReadableByteStreamController;
            }
            function IsReadableStreamBYOBRequest(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_associatedReadableByteStreamController")) {
                return false;
              }
              return x2 instanceof ReadableStreamBYOBRequest;
            }
            function ReadableByteStreamControllerCallPullIfNeeded(controller) {
              var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
              if (!shouldPull) {
                return;
              }
              if (controller._pulling) {
                controller._pullAgain = true;
                return;
              }
              controller._pulling = true;
              var pullPromise = controller._pullAlgorithm();
              uponPromise(pullPromise, function() {
                controller._pulling = false;
                if (controller._pullAgain) {
                  controller._pullAgain = false;
                  ReadableByteStreamControllerCallPullIfNeeded(controller);
                }
              }, function(e2) {
                ReadableByteStreamControllerError(controller, e2);
              });
            }
            function ReadableByteStreamControllerClearPendingPullIntos(controller) {
              ReadableByteStreamControllerInvalidateBYOBRequest(controller);
              controller._pendingPullIntos = new SimpleQueue();
            }
            function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
              var done = false;
              if (stream._state === "closed") {
                done = true;
              }
              var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
              if (pullIntoDescriptor.readerType === "default") {
                ReadableStreamFulfillReadRequest(stream, filledView, done);
              } else {
                ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
              }
            }
            function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
              var bytesFilled = pullIntoDescriptor.bytesFilled;
              var elementSize = pullIntoDescriptor.elementSize;
              return new pullIntoDescriptor.viewConstructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
            }
            function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer2, byteOffset, byteLength) {
              controller._queue.push({
                buffer: buffer2,
                byteOffset,
                byteLength
              });
              controller._queueTotalSize += byteLength;
            }
            function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
              var elementSize = pullIntoDescriptor.elementSize;
              var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
              var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
              var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
              var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
              var totalBytesToCopyRemaining = maxBytesToCopy;
              var ready = false;
              if (maxAlignedBytes > currentAlignedBytes) {
                totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
                ready = true;
              }
              var queue = controller._queue;
              while (totalBytesToCopyRemaining > 0) {
                var headOfQueue = queue.peek();
                var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
                var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
                CopyDataBlockBytes(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
                if (headOfQueue.byteLength === bytesToCopy) {
                  queue.shift();
                } else {
                  headOfQueue.byteOffset += bytesToCopy;
                  headOfQueue.byteLength -= bytesToCopy;
                }
                controller._queueTotalSize -= bytesToCopy;
                ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
                totalBytesToCopyRemaining -= bytesToCopy;
              }
              return ready;
            }
            function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
              pullIntoDescriptor.bytesFilled += size;
            }
            function ReadableByteStreamControllerHandleQueueDrain(controller) {
              if (controller._queueTotalSize === 0 && controller._closeRequested) {
                ReadableByteStreamControllerClearAlgorithms(controller);
                ReadableStreamClose(controller._controlledReadableByteStream);
              } else {
                ReadableByteStreamControllerCallPullIfNeeded(controller);
              }
            }
            function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
              if (controller._byobRequest === null) {
                return;
              }
              controller._byobRequest._associatedReadableByteStreamController = void 0;
              controller._byobRequest._view = null;
              controller._byobRequest = null;
            }
            function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
              while (controller._pendingPullIntos.length > 0) {
                if (controller._queueTotalSize === 0) {
                  return;
                }
                var pullIntoDescriptor = controller._pendingPullIntos.peek();
                if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor)) {
                  ReadableByteStreamControllerShiftPendingPullInto(controller);
                  ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
                }
              }
            }
            function ReadableByteStreamControllerPullInto(controller, view, readIntoRequest) {
              var stream = controller._controlledReadableByteStream;
              var elementSize = 1;
              if (view.constructor !== DataView) {
                elementSize = view.constructor.BYTES_PER_ELEMENT;
              }
              var ctor = view.constructor;
              var buffer2 = TransferArrayBuffer(view.buffer);
              var pullIntoDescriptor = {
                buffer: buffer2,
                bufferByteLength: buffer2.byteLength,
                byteOffset: view.byteOffset,
                byteLength: view.byteLength,
                bytesFilled: 0,
                elementSize,
                viewConstructor: ctor,
                readerType: "byob"
              };
              if (controller._pendingPullIntos.length > 0) {
                controller._pendingPullIntos.push(pullIntoDescriptor);
                ReadableStreamAddReadIntoRequest(stream, readIntoRequest);
                return;
              }
              if (stream._state === "closed") {
                var emptyView = new ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
                readIntoRequest._closeSteps(emptyView);
                return;
              }
              if (controller._queueTotalSize > 0) {
                if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor)) {
                  var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
                  ReadableByteStreamControllerHandleQueueDrain(controller);
                  readIntoRequest._chunkSteps(filledView);
                  return;
                }
                if (controller._closeRequested) {
                  var e2 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                  ReadableByteStreamControllerError(controller, e2);
                  readIntoRequest._errorSteps(e2);
                  return;
                }
              }
              controller._pendingPullIntos.push(pullIntoDescriptor);
              ReadableStreamAddReadIntoRequest(stream, readIntoRequest);
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }
            function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
              var stream = controller._controlledReadableByteStream;
              if (ReadableStreamHasBYOBReader(stream)) {
                while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
                  var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
                  ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
                }
              }
            }
            function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
              ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
              if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
                return;
              }
              ReadableByteStreamControllerShiftPendingPullInto(controller);
              var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
              if (remainderSize > 0) {
                var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
                var remainder = ArrayBufferSlice(pullIntoDescriptor.buffer, end - remainderSize, end);
                ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
              }
              pullIntoDescriptor.bytesFilled -= remainderSize;
              ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
              ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
            }
            function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
              var firstDescriptor = controller._pendingPullIntos.peek();
              ReadableByteStreamControllerInvalidateBYOBRequest(controller);
              var state2 = controller._controlledReadableByteStream._state;
              if (state2 === "closed") {
                ReadableByteStreamControllerRespondInClosedState(controller);
              } else {
                ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
              }
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }
            function ReadableByteStreamControllerShiftPendingPullInto(controller) {
              var descriptor = controller._pendingPullIntos.shift();
              return descriptor;
            }
            function ReadableByteStreamControllerShouldCallPull(controller) {
              var stream = controller._controlledReadableByteStream;
              if (stream._state !== "readable") {
                return false;
              }
              if (controller._closeRequested) {
                return false;
              }
              if (!controller._started) {
                return false;
              }
              if (ReadableStreamHasDefaultReader(stream) && ReadableStreamGetNumReadRequests(stream) > 0) {
                return true;
              }
              if (ReadableStreamHasBYOBReader(stream) && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
                return true;
              }
              var desiredSize = ReadableByteStreamControllerGetDesiredSize(controller);
              if (desiredSize > 0) {
                return true;
              }
              return false;
            }
            function ReadableByteStreamControllerClearAlgorithms(controller) {
              controller._pullAlgorithm = void 0;
              controller._cancelAlgorithm = void 0;
            }
            function ReadableByteStreamControllerClose(controller) {
              var stream = controller._controlledReadableByteStream;
              if (controller._closeRequested || stream._state !== "readable") {
                return;
              }
              if (controller._queueTotalSize > 0) {
                controller._closeRequested = true;
                return;
              }
              if (controller._pendingPullIntos.length > 0) {
                var firstPendingPullInto = controller._pendingPullIntos.peek();
                if (firstPendingPullInto.bytesFilled > 0) {
                  var e2 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                  ReadableByteStreamControllerError(controller, e2);
                  throw e2;
                }
              }
              ReadableByteStreamControllerClearAlgorithms(controller);
              ReadableStreamClose(stream);
            }
            function ReadableByteStreamControllerEnqueue(controller, chunk) {
              var stream = controller._controlledReadableByteStream;
              if (controller._closeRequested || stream._state !== "readable") {
                return;
              }
              var buffer2 = chunk.buffer;
              var byteOffset = chunk.byteOffset;
              var byteLength = chunk.byteLength;
              var transferredBuffer = TransferArrayBuffer(buffer2);
              if (controller._pendingPullIntos.length > 0) {
                var firstPendingPullInto = controller._pendingPullIntos.peek();
                if (IsDetachedBuffer(firstPendingPullInto.buffer))
                  ;
                firstPendingPullInto.buffer = TransferArrayBuffer(firstPendingPullInto.buffer);
              }
              ReadableByteStreamControllerInvalidateBYOBRequest(controller);
              if (ReadableStreamHasDefaultReader(stream)) {
                if (ReadableStreamGetNumReadRequests(stream) === 0) {
                  ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                } else {
                  if (controller._pendingPullIntos.length > 0) {
                    ReadableByteStreamControllerShiftPendingPullInto(controller);
                  }
                  var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
                  ReadableStreamFulfillReadRequest(stream, transferredView, false);
                }
              } else if (ReadableStreamHasBYOBReader(stream)) {
                ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
              } else {
                ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
              }
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }
            function ReadableByteStreamControllerError(controller, e2) {
              var stream = controller._controlledReadableByteStream;
              if (stream._state !== "readable") {
                return;
              }
              ReadableByteStreamControllerClearPendingPullIntos(controller);
              ResetQueue(controller);
              ReadableByteStreamControllerClearAlgorithms(controller);
              ReadableStreamError(stream, e2);
            }
            function ReadableByteStreamControllerGetBYOBRequest(controller) {
              if (controller._byobRequest === null && controller._pendingPullIntos.length > 0) {
                var firstDescriptor = controller._pendingPullIntos.peek();
                var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
                var byobRequest = Object.create(ReadableStreamBYOBRequest.prototype);
                SetUpReadableStreamBYOBRequest(byobRequest, controller, view);
                controller._byobRequest = byobRequest;
              }
              return controller._byobRequest;
            }
            function ReadableByteStreamControllerGetDesiredSize(controller) {
              var state2 = controller._controlledReadableByteStream._state;
              if (state2 === "errored") {
                return null;
              }
              if (state2 === "closed") {
                return 0;
              }
              return controller._strategyHWM - controller._queueTotalSize;
            }
            function ReadableByteStreamControllerRespond(controller, bytesWritten) {
              var firstDescriptor = controller._pendingPullIntos.peek();
              var state2 = controller._controlledReadableByteStream._state;
              if (state2 === "closed") {
                if (bytesWritten !== 0) {
                  throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
                }
              } else {
                if (bytesWritten === 0) {
                  throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
                }
                if (firstDescriptor.bytesFilled + bytesWritten > firstDescriptor.byteLength) {
                  throw new RangeError("bytesWritten out of range");
                }
              }
              firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
              ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
            }
            function ReadableByteStreamControllerRespondWithNewView(controller, view) {
              var firstDescriptor = controller._pendingPullIntos.peek();
              var state2 = controller._controlledReadableByteStream._state;
              if (state2 === "closed") {
                if (view.byteLength !== 0) {
                  throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
                }
              } else {
                if (view.byteLength === 0) {
                  throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
                }
              }
              if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
                throw new RangeError("The region specified by view does not match byobRequest");
              }
              if (firstDescriptor.bufferByteLength !== view.buffer.byteLength) {
                throw new RangeError("The buffer of view has different capacity than byobRequest");
              }
              if (firstDescriptor.bytesFilled + view.byteLength > firstDescriptor.byteLength) {
                throw new RangeError("The region specified by view is larger than byobRequest");
              }
              var viewByteLength = view.byteLength;
              firstDescriptor.buffer = TransferArrayBuffer(view.buffer);
              ReadableByteStreamControllerRespondInternal(controller, viewByteLength);
            }
            function SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize) {
              controller._controlledReadableByteStream = stream;
              controller._pullAgain = false;
              controller._pulling = false;
              controller._byobRequest = null;
              controller._queue = controller._queueTotalSize = void 0;
              ResetQueue(controller);
              controller._closeRequested = false;
              controller._started = false;
              controller._strategyHWM = highWaterMark;
              controller._pullAlgorithm = pullAlgorithm;
              controller._cancelAlgorithm = cancelAlgorithm;
              controller._autoAllocateChunkSize = autoAllocateChunkSize;
              controller._pendingPullIntos = new SimpleQueue();
              stream._readableStreamController = controller;
              var startResult = startAlgorithm();
              uponPromise(promiseResolvedWith(startResult), function() {
                controller._started = true;
                ReadableByteStreamControllerCallPullIfNeeded(controller);
              }, function(r2) {
                ReadableByteStreamControllerError(controller, r2);
              });
            }
            function SetUpReadableByteStreamControllerFromUnderlyingSource(stream, underlyingByteSource, highWaterMark) {
              var controller = Object.create(ReadableByteStreamController.prototype);
              var startAlgorithm = function() {
                return void 0;
              };
              var pullAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              var cancelAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              if (underlyingByteSource.start !== void 0) {
                startAlgorithm = function() {
                  return underlyingByteSource.start(controller);
                };
              }
              if (underlyingByteSource.pull !== void 0) {
                pullAlgorithm = function() {
                  return underlyingByteSource.pull(controller);
                };
              }
              if (underlyingByteSource.cancel !== void 0) {
                cancelAlgorithm = function(reason) {
                  return underlyingByteSource.cancel(reason);
                };
              }
              var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
              if (autoAllocateChunkSize === 0) {
                throw new TypeError("autoAllocateChunkSize must be greater than 0");
              }
              SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize);
            }
            function SetUpReadableStreamBYOBRequest(request4, controller, view) {
              request4._associatedReadableByteStreamController = controller;
              request4._view = view;
            }
            function byobRequestBrandCheckException(name) {
              return new TypeError("ReadableStreamBYOBRequest.prototype." + name + " can only be used on a ReadableStreamBYOBRequest");
            }
            function byteStreamControllerBrandCheckException(name) {
              return new TypeError("ReadableByteStreamController.prototype." + name + " can only be used on a ReadableByteStreamController");
            }
            function AcquireReadableStreamBYOBReader(stream) {
              return new ReadableStreamBYOBReader(stream);
            }
            function ReadableStreamAddReadIntoRequest(stream, readIntoRequest) {
              stream._reader._readIntoRequests.push(readIntoRequest);
            }
            function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
              var reader = stream._reader;
              var readIntoRequest = reader._readIntoRequests.shift();
              if (done) {
                readIntoRequest._closeSteps(chunk);
              } else {
                readIntoRequest._chunkSteps(chunk);
              }
            }
            function ReadableStreamGetNumReadIntoRequests(stream) {
              return stream._reader._readIntoRequests.length;
            }
            function ReadableStreamHasBYOBReader(stream) {
              var reader = stream._reader;
              if (reader === void 0) {
                return false;
              }
              if (!IsReadableStreamBYOBReader(reader)) {
                return false;
              }
              return true;
            }
            var ReadableStreamBYOBReader = function() {
              function ReadableStreamBYOBReader2(stream) {
                assertRequiredArgument(stream, 1, "ReadableStreamBYOBReader");
                assertReadableStream(stream, "First parameter");
                if (IsReadableStreamLocked(stream)) {
                  throw new TypeError("This stream has already been locked for exclusive reading by another reader");
                }
                if (!IsReadableByteStreamController(stream._readableStreamController)) {
                  throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
                }
                ReadableStreamReaderGenericInitialize(this, stream);
                this._readIntoRequests = new SimpleQueue();
              }
              Object.defineProperty(ReadableStreamBYOBReader2.prototype, "closed", {
                get: function() {
                  if (!IsReadableStreamBYOBReader(this)) {
                    return promiseRejectedWith(byobReaderBrandCheckException("closed"));
                  }
                  return this._closedPromise;
                },
                enumerable: false,
                configurable: true
              });
              ReadableStreamBYOBReader2.prototype.cancel = function(reason) {
                if (reason === void 0) {
                  reason = void 0;
                }
                if (!IsReadableStreamBYOBReader(this)) {
                  return promiseRejectedWith(byobReaderBrandCheckException("cancel"));
                }
                if (this._ownerReadableStream === void 0) {
                  return promiseRejectedWith(readerLockException("cancel"));
                }
                return ReadableStreamReaderGenericCancel(this, reason);
              };
              ReadableStreamBYOBReader2.prototype.read = function(view) {
                if (!IsReadableStreamBYOBReader(this)) {
                  return promiseRejectedWith(byobReaderBrandCheckException("read"));
                }
                if (!ArrayBuffer.isView(view)) {
                  return promiseRejectedWith(new TypeError("view must be an array buffer view"));
                }
                if (view.byteLength === 0) {
                  return promiseRejectedWith(new TypeError("view must have non-zero byteLength"));
                }
                if (view.buffer.byteLength === 0) {
                  return promiseRejectedWith(new TypeError("view's buffer must have non-zero byteLength"));
                }
                if (IsDetachedBuffer(view.buffer))
                  ;
                if (this._ownerReadableStream === void 0) {
                  return promiseRejectedWith(readerLockException("read from"));
                }
                var resolvePromise;
                var rejectPromise;
                var promise = newPromise(function(resolve, reject) {
                  resolvePromise = resolve;
                  rejectPromise = reject;
                });
                var readIntoRequest = {
                  _chunkSteps: function(chunk) {
                    return resolvePromise({
                      value: chunk,
                      done: false
                    });
                  },
                  _closeSteps: function(chunk) {
                    return resolvePromise({
                      value: chunk,
                      done: true
                    });
                  },
                  _errorSteps: function(e2) {
                    return rejectPromise(e2);
                  }
                };
                ReadableStreamBYOBReaderRead(this, view, readIntoRequest);
                return promise;
              };
              ReadableStreamBYOBReader2.prototype.releaseLock = function() {
                if (!IsReadableStreamBYOBReader(this)) {
                  throw byobReaderBrandCheckException("releaseLock");
                }
                if (this._ownerReadableStream === void 0) {
                  return;
                }
                if (this._readIntoRequests.length > 0) {
                  throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
                }
                ReadableStreamReaderGenericRelease(this);
              };
              return ReadableStreamBYOBReader2;
            }();
            Object.defineProperties(ReadableStreamBYOBReader.prototype, {
              cancel: { enumerable: true },
              read: { enumerable: true },
              releaseLock: { enumerable: true },
              closed: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ReadableStreamBYOBReader.prototype, SymbolPolyfill.toStringTag, {
                value: "ReadableStreamBYOBReader",
                configurable: true
              });
            }
            function IsReadableStreamBYOBReader(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_readIntoRequests")) {
                return false;
              }
              return x2 instanceof ReadableStreamBYOBReader;
            }
            function ReadableStreamBYOBReaderRead(reader, view, readIntoRequest) {
              var stream = reader._ownerReadableStream;
              stream._disturbed = true;
              if (stream._state === "errored") {
                readIntoRequest._errorSteps(stream._storedError);
              } else {
                ReadableByteStreamControllerPullInto(stream._readableStreamController, view, readIntoRequest);
              }
            }
            function byobReaderBrandCheckException(name) {
              return new TypeError("ReadableStreamBYOBReader.prototype." + name + " can only be used on a ReadableStreamBYOBReader");
            }
            function ExtractHighWaterMark(strategy, defaultHWM) {
              var highWaterMark = strategy.highWaterMark;
              if (highWaterMark === void 0) {
                return defaultHWM;
              }
              if (NumberIsNaN(highWaterMark) || highWaterMark < 0) {
                throw new RangeError("Invalid highWaterMark");
              }
              return highWaterMark;
            }
            function ExtractSizeAlgorithm(strategy) {
              var size = strategy.size;
              if (!size) {
                return function() {
                  return 1;
                };
              }
              return size;
            }
            function convertQueuingStrategy(init3, context2) {
              assertDictionary(init3, context2);
              var highWaterMark = init3 === null || init3 === void 0 ? void 0 : init3.highWaterMark;
              var size = init3 === null || init3 === void 0 ? void 0 : init3.size;
              return {
                highWaterMark: highWaterMark === void 0 ? void 0 : convertUnrestrictedDouble(highWaterMark),
                size: size === void 0 ? void 0 : convertQueuingStrategySize(size, context2 + " has member 'size' that")
              };
            }
            function convertQueuingStrategySize(fn, context2) {
              assertFunction(fn, context2);
              return function(chunk) {
                return convertUnrestrictedDouble(fn(chunk));
              };
            }
            function convertUnderlyingSink(original, context2) {
              assertDictionary(original, context2);
              var abort = original === null || original === void 0 ? void 0 : original.abort;
              var close = original === null || original === void 0 ? void 0 : original.close;
              var start = original === null || original === void 0 ? void 0 : original.start;
              var type = original === null || original === void 0 ? void 0 : original.type;
              var write = original === null || original === void 0 ? void 0 : original.write;
              return {
                abort: abort === void 0 ? void 0 : convertUnderlyingSinkAbortCallback(abort, original, context2 + " has member 'abort' that"),
                close: close === void 0 ? void 0 : convertUnderlyingSinkCloseCallback(close, original, context2 + " has member 'close' that"),
                start: start === void 0 ? void 0 : convertUnderlyingSinkStartCallback(start, original, context2 + " has member 'start' that"),
                write: write === void 0 ? void 0 : convertUnderlyingSinkWriteCallback(write, original, context2 + " has member 'write' that"),
                type
              };
            }
            function convertUnderlyingSinkAbortCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(reason) {
                return promiseCall(fn, original, [reason]);
              };
            }
            function convertUnderlyingSinkCloseCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function() {
                return promiseCall(fn, original, []);
              };
            }
            function convertUnderlyingSinkStartCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(controller) {
                return reflectCall(fn, original, [controller]);
              };
            }
            function convertUnderlyingSinkWriteCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(chunk, controller) {
                return promiseCall(fn, original, [
                  chunk,
                  controller
                ]);
              };
            }
            function assertWritableStream(x2, context2) {
              if (!IsWritableStream(x2)) {
                throw new TypeError(context2 + " is not a WritableStream.");
              }
            }
            function isAbortSignal(value) {
              if (typeof value !== "object" || value === null) {
                return false;
              }
              try {
                return typeof value.aborted === "boolean";
              } catch (_a2) {
                return false;
              }
            }
            var supportsAbortController = typeof AbortController === "function";
            function createAbortController() {
              if (supportsAbortController) {
                return new AbortController();
              }
              return void 0;
            }
            var WritableStream = function() {
              function WritableStream2(rawUnderlyingSink, rawStrategy) {
                if (rawUnderlyingSink === void 0) {
                  rawUnderlyingSink = {};
                }
                if (rawStrategy === void 0) {
                  rawStrategy = {};
                }
                if (rawUnderlyingSink === void 0) {
                  rawUnderlyingSink = null;
                } else {
                  assertObject(rawUnderlyingSink, "First parameter");
                }
                var strategy = convertQueuingStrategy(rawStrategy, "Second parameter");
                var underlyingSink = convertUnderlyingSink(rawUnderlyingSink, "First parameter");
                InitializeWritableStream(this);
                var type = underlyingSink.type;
                if (type !== void 0) {
                  throw new RangeError("Invalid type is specified");
                }
                var sizeAlgorithm = ExtractSizeAlgorithm(strategy);
                var highWaterMark = ExtractHighWaterMark(strategy, 1);
                SetUpWritableStreamDefaultControllerFromUnderlyingSink(this, underlyingSink, highWaterMark, sizeAlgorithm);
              }
              Object.defineProperty(WritableStream2.prototype, "locked", {
                get: function() {
                  if (!IsWritableStream(this)) {
                    throw streamBrandCheckException$2("locked");
                  }
                  return IsWritableStreamLocked(this);
                },
                enumerable: false,
                configurable: true
              });
              WritableStream2.prototype.abort = function(reason) {
                if (reason === void 0) {
                  reason = void 0;
                }
                if (!IsWritableStream(this)) {
                  return promiseRejectedWith(streamBrandCheckException$2("abort"));
                }
                if (IsWritableStreamLocked(this)) {
                  return promiseRejectedWith(new TypeError("Cannot abort a stream that already has a writer"));
                }
                return WritableStreamAbort(this, reason);
              };
              WritableStream2.prototype.close = function() {
                if (!IsWritableStream(this)) {
                  return promiseRejectedWith(streamBrandCheckException$2("close"));
                }
                if (IsWritableStreamLocked(this)) {
                  return promiseRejectedWith(new TypeError("Cannot close a stream that already has a writer"));
                }
                if (WritableStreamCloseQueuedOrInFlight(this)) {
                  return promiseRejectedWith(new TypeError("Cannot close an already-closing stream"));
                }
                return WritableStreamClose(this);
              };
              WritableStream2.prototype.getWriter = function() {
                if (!IsWritableStream(this)) {
                  throw streamBrandCheckException$2("getWriter");
                }
                return AcquireWritableStreamDefaultWriter(this);
              };
              return WritableStream2;
            }();
            Object.defineProperties(WritableStream.prototype, {
              abort: { enumerable: true },
              close: { enumerable: true },
              getWriter: { enumerable: true },
              locked: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(WritableStream.prototype, SymbolPolyfill.toStringTag, {
                value: "WritableStream",
                configurable: true
              });
            }
            function AcquireWritableStreamDefaultWriter(stream) {
              return new WritableStreamDefaultWriter(stream);
            }
            function CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
              if (highWaterMark === void 0) {
                highWaterMark = 1;
              }
              if (sizeAlgorithm === void 0) {
                sizeAlgorithm = function() {
                  return 1;
                };
              }
              var stream = Object.create(WritableStream.prototype);
              InitializeWritableStream(stream);
              var controller = Object.create(WritableStreamDefaultController.prototype);
              SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
              return stream;
            }
            function InitializeWritableStream(stream) {
              stream._state = "writable";
              stream._storedError = void 0;
              stream._writer = void 0;
              stream._writableStreamController = void 0;
              stream._writeRequests = new SimpleQueue();
              stream._inFlightWriteRequest = void 0;
              stream._closeRequest = void 0;
              stream._inFlightCloseRequest = void 0;
              stream._pendingAbortRequest = void 0;
              stream._backpressure = false;
            }
            function IsWritableStream(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_writableStreamController")) {
                return false;
              }
              return x2 instanceof WritableStream;
            }
            function IsWritableStreamLocked(stream) {
              if (stream._writer === void 0) {
                return false;
              }
              return true;
            }
            function WritableStreamAbort(stream, reason) {
              var _a2;
              if (stream._state === "closed" || stream._state === "errored") {
                return promiseResolvedWith(void 0);
              }
              stream._writableStreamController._abortReason = reason;
              (_a2 = stream._writableStreamController._abortController) === null || _a2 === void 0 ? void 0 : _a2.abort();
              var state2 = stream._state;
              if (state2 === "closed" || state2 === "errored") {
                return promiseResolvedWith(void 0);
              }
              if (stream._pendingAbortRequest !== void 0) {
                return stream._pendingAbortRequest._promise;
              }
              var wasAlreadyErroring = false;
              if (state2 === "erroring") {
                wasAlreadyErroring = true;
                reason = void 0;
              }
              var promise = newPromise(function(resolve, reject) {
                stream._pendingAbortRequest = {
                  _promise: void 0,
                  _resolve: resolve,
                  _reject: reject,
                  _reason: reason,
                  _wasAlreadyErroring: wasAlreadyErroring
                };
              });
              stream._pendingAbortRequest._promise = promise;
              if (!wasAlreadyErroring) {
                WritableStreamStartErroring(stream, reason);
              }
              return promise;
            }
            function WritableStreamClose(stream) {
              var state2 = stream._state;
              if (state2 === "closed" || state2 === "errored") {
                return promiseRejectedWith(new TypeError("The stream (in " + state2 + " state) is not in the writable state and cannot be closed"));
              }
              var promise = newPromise(function(resolve, reject) {
                var closeRequest = {
                  _resolve: resolve,
                  _reject: reject
                };
                stream._closeRequest = closeRequest;
              });
              var writer = stream._writer;
              if (writer !== void 0 && stream._backpressure && state2 === "writable") {
                defaultWriterReadyPromiseResolve(writer);
              }
              WritableStreamDefaultControllerClose(stream._writableStreamController);
              return promise;
            }
            function WritableStreamAddWriteRequest(stream) {
              var promise = newPromise(function(resolve, reject) {
                var writeRequest = {
                  _resolve: resolve,
                  _reject: reject
                };
                stream._writeRequests.push(writeRequest);
              });
              return promise;
            }
            function WritableStreamDealWithRejection(stream, error3) {
              var state2 = stream._state;
              if (state2 === "writable") {
                WritableStreamStartErroring(stream, error3);
                return;
              }
              WritableStreamFinishErroring(stream);
            }
            function WritableStreamStartErroring(stream, reason) {
              var controller = stream._writableStreamController;
              stream._state = "erroring";
              stream._storedError = reason;
              var writer = stream._writer;
              if (writer !== void 0) {
                WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
              }
              if (!WritableStreamHasOperationMarkedInFlight(stream) && controller._started) {
                WritableStreamFinishErroring(stream);
              }
            }
            function WritableStreamFinishErroring(stream) {
              stream._state = "errored";
              stream._writableStreamController[ErrorSteps]();
              var storedError = stream._storedError;
              stream._writeRequests.forEach(function(writeRequest) {
                writeRequest._reject(storedError);
              });
              stream._writeRequests = new SimpleQueue();
              if (stream._pendingAbortRequest === void 0) {
                WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                return;
              }
              var abortRequest = stream._pendingAbortRequest;
              stream._pendingAbortRequest = void 0;
              if (abortRequest._wasAlreadyErroring) {
                abortRequest._reject(storedError);
                WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                return;
              }
              var promise = stream._writableStreamController[AbortSteps](abortRequest._reason);
              uponPromise(promise, function() {
                abortRequest._resolve();
                WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
              }, function(reason) {
                abortRequest._reject(reason);
                WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
              });
            }
            function WritableStreamFinishInFlightWrite(stream) {
              stream._inFlightWriteRequest._resolve(void 0);
              stream._inFlightWriteRequest = void 0;
            }
            function WritableStreamFinishInFlightWriteWithError(stream, error3) {
              stream._inFlightWriteRequest._reject(error3);
              stream._inFlightWriteRequest = void 0;
              WritableStreamDealWithRejection(stream, error3);
            }
            function WritableStreamFinishInFlightClose(stream) {
              stream._inFlightCloseRequest._resolve(void 0);
              stream._inFlightCloseRequest = void 0;
              var state2 = stream._state;
              if (state2 === "erroring") {
                stream._storedError = void 0;
                if (stream._pendingAbortRequest !== void 0) {
                  stream._pendingAbortRequest._resolve();
                  stream._pendingAbortRequest = void 0;
                }
              }
              stream._state = "closed";
              var writer = stream._writer;
              if (writer !== void 0) {
                defaultWriterClosedPromiseResolve(writer);
              }
            }
            function WritableStreamFinishInFlightCloseWithError(stream, error3) {
              stream._inFlightCloseRequest._reject(error3);
              stream._inFlightCloseRequest = void 0;
              if (stream._pendingAbortRequest !== void 0) {
                stream._pendingAbortRequest._reject(error3);
                stream._pendingAbortRequest = void 0;
              }
              WritableStreamDealWithRejection(stream, error3);
            }
            function WritableStreamCloseQueuedOrInFlight(stream) {
              if (stream._closeRequest === void 0 && stream._inFlightCloseRequest === void 0) {
                return false;
              }
              return true;
            }
            function WritableStreamHasOperationMarkedInFlight(stream) {
              if (stream._inFlightWriteRequest === void 0 && stream._inFlightCloseRequest === void 0) {
                return false;
              }
              return true;
            }
            function WritableStreamMarkCloseRequestInFlight(stream) {
              stream._inFlightCloseRequest = stream._closeRequest;
              stream._closeRequest = void 0;
            }
            function WritableStreamMarkFirstWriteRequestInFlight(stream) {
              stream._inFlightWriteRequest = stream._writeRequests.shift();
            }
            function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
              if (stream._closeRequest !== void 0) {
                stream._closeRequest._reject(stream._storedError);
                stream._closeRequest = void 0;
              }
              var writer = stream._writer;
              if (writer !== void 0) {
                defaultWriterClosedPromiseReject(writer, stream._storedError);
              }
            }
            function WritableStreamUpdateBackpressure(stream, backpressure) {
              var writer = stream._writer;
              if (writer !== void 0 && backpressure !== stream._backpressure) {
                if (backpressure) {
                  defaultWriterReadyPromiseReset(writer);
                } else {
                  defaultWriterReadyPromiseResolve(writer);
                }
              }
              stream._backpressure = backpressure;
            }
            var WritableStreamDefaultWriter = function() {
              function WritableStreamDefaultWriter2(stream) {
                assertRequiredArgument(stream, 1, "WritableStreamDefaultWriter");
                assertWritableStream(stream, "First parameter");
                if (IsWritableStreamLocked(stream)) {
                  throw new TypeError("This stream has already been locked for exclusive writing by another writer");
                }
                this._ownerWritableStream = stream;
                stream._writer = this;
                var state2 = stream._state;
                if (state2 === "writable") {
                  if (!WritableStreamCloseQueuedOrInFlight(stream) && stream._backpressure) {
                    defaultWriterReadyPromiseInitialize(this);
                  } else {
                    defaultWriterReadyPromiseInitializeAsResolved(this);
                  }
                  defaultWriterClosedPromiseInitialize(this);
                } else if (state2 === "erroring") {
                  defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
                  defaultWriterClosedPromiseInitialize(this);
                } else if (state2 === "closed") {
                  defaultWriterReadyPromiseInitializeAsResolved(this);
                  defaultWriterClosedPromiseInitializeAsResolved(this);
                } else {
                  var storedError = stream._storedError;
                  defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
                  defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
                }
              }
              Object.defineProperty(WritableStreamDefaultWriter2.prototype, "closed", {
                get: function() {
                  if (!IsWritableStreamDefaultWriter(this)) {
                    return promiseRejectedWith(defaultWriterBrandCheckException("closed"));
                  }
                  return this._closedPromise;
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(WritableStreamDefaultWriter2.prototype, "desiredSize", {
                get: function() {
                  if (!IsWritableStreamDefaultWriter(this)) {
                    throw defaultWriterBrandCheckException("desiredSize");
                  }
                  if (this._ownerWritableStream === void 0) {
                    throw defaultWriterLockException("desiredSize");
                  }
                  return WritableStreamDefaultWriterGetDesiredSize(this);
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(WritableStreamDefaultWriter2.prototype, "ready", {
                get: function() {
                  if (!IsWritableStreamDefaultWriter(this)) {
                    return promiseRejectedWith(defaultWriterBrandCheckException("ready"));
                  }
                  return this._readyPromise;
                },
                enumerable: false,
                configurable: true
              });
              WritableStreamDefaultWriter2.prototype.abort = function(reason) {
                if (reason === void 0) {
                  reason = void 0;
                }
                if (!IsWritableStreamDefaultWriter(this)) {
                  return promiseRejectedWith(defaultWriterBrandCheckException("abort"));
                }
                if (this._ownerWritableStream === void 0) {
                  return promiseRejectedWith(defaultWriterLockException("abort"));
                }
                return WritableStreamDefaultWriterAbort(this, reason);
              };
              WritableStreamDefaultWriter2.prototype.close = function() {
                if (!IsWritableStreamDefaultWriter(this)) {
                  return promiseRejectedWith(defaultWriterBrandCheckException("close"));
                }
                var stream = this._ownerWritableStream;
                if (stream === void 0) {
                  return promiseRejectedWith(defaultWriterLockException("close"));
                }
                if (WritableStreamCloseQueuedOrInFlight(stream)) {
                  return promiseRejectedWith(new TypeError("Cannot close an already-closing stream"));
                }
                return WritableStreamDefaultWriterClose(this);
              };
              WritableStreamDefaultWriter2.prototype.releaseLock = function() {
                if (!IsWritableStreamDefaultWriter(this)) {
                  throw defaultWriterBrandCheckException("releaseLock");
                }
                var stream = this._ownerWritableStream;
                if (stream === void 0) {
                  return;
                }
                WritableStreamDefaultWriterRelease(this);
              };
              WritableStreamDefaultWriter2.prototype.write = function(chunk) {
                if (chunk === void 0) {
                  chunk = void 0;
                }
                if (!IsWritableStreamDefaultWriter(this)) {
                  return promiseRejectedWith(defaultWriterBrandCheckException("write"));
                }
                if (this._ownerWritableStream === void 0) {
                  return promiseRejectedWith(defaultWriterLockException("write to"));
                }
                return WritableStreamDefaultWriterWrite(this, chunk);
              };
              return WritableStreamDefaultWriter2;
            }();
            Object.defineProperties(WritableStreamDefaultWriter.prototype, {
              abort: { enumerable: true },
              close: { enumerable: true },
              releaseLock: { enumerable: true },
              write: { enumerable: true },
              closed: { enumerable: true },
              desiredSize: { enumerable: true },
              ready: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(WritableStreamDefaultWriter.prototype, SymbolPolyfill.toStringTag, {
                value: "WritableStreamDefaultWriter",
                configurable: true
              });
            }
            function IsWritableStreamDefaultWriter(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_ownerWritableStream")) {
                return false;
              }
              return x2 instanceof WritableStreamDefaultWriter;
            }
            function WritableStreamDefaultWriterAbort(writer, reason) {
              var stream = writer._ownerWritableStream;
              return WritableStreamAbort(stream, reason);
            }
            function WritableStreamDefaultWriterClose(writer) {
              var stream = writer._ownerWritableStream;
              return WritableStreamClose(stream);
            }
            function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
              var stream = writer._ownerWritableStream;
              var state2 = stream._state;
              if (WritableStreamCloseQueuedOrInFlight(stream) || state2 === "closed") {
                return promiseResolvedWith(void 0);
              }
              if (state2 === "errored") {
                return promiseRejectedWith(stream._storedError);
              }
              return WritableStreamDefaultWriterClose(writer);
            }
            function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error3) {
              if (writer._closedPromiseState === "pending") {
                defaultWriterClosedPromiseReject(writer, error3);
              } else {
                defaultWriterClosedPromiseResetToRejected(writer, error3);
              }
            }
            function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error3) {
              if (writer._readyPromiseState === "pending") {
                defaultWriterReadyPromiseReject(writer, error3);
              } else {
                defaultWriterReadyPromiseResetToRejected(writer, error3);
              }
            }
            function WritableStreamDefaultWriterGetDesiredSize(writer) {
              var stream = writer._ownerWritableStream;
              var state2 = stream._state;
              if (state2 === "errored" || state2 === "erroring") {
                return null;
              }
              if (state2 === "closed") {
                return 0;
              }
              return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
            }
            function WritableStreamDefaultWriterRelease(writer) {
              var stream = writer._ownerWritableStream;
              var releasedError = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
              WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
              WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
              stream._writer = void 0;
              writer._ownerWritableStream = void 0;
            }
            function WritableStreamDefaultWriterWrite(writer, chunk) {
              var stream = writer._ownerWritableStream;
              var controller = stream._writableStreamController;
              var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
              if (stream !== writer._ownerWritableStream) {
                return promiseRejectedWith(defaultWriterLockException("write to"));
              }
              var state2 = stream._state;
              if (state2 === "errored") {
                return promiseRejectedWith(stream._storedError);
              }
              if (WritableStreamCloseQueuedOrInFlight(stream) || state2 === "closed") {
                return promiseRejectedWith(new TypeError("The stream is closing or closed and cannot be written to"));
              }
              if (state2 === "erroring") {
                return promiseRejectedWith(stream._storedError);
              }
              var promise = WritableStreamAddWriteRequest(stream);
              WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
              return promise;
            }
            var closeSentinel = {};
            var WritableStreamDefaultController = function() {
              function WritableStreamDefaultController2() {
                throw new TypeError("Illegal constructor");
              }
              Object.defineProperty(WritableStreamDefaultController2.prototype, "abortReason", {
                get: function() {
                  if (!IsWritableStreamDefaultController(this)) {
                    throw defaultControllerBrandCheckException$2("abortReason");
                  }
                  return this._abortReason;
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(WritableStreamDefaultController2.prototype, "signal", {
                get: function() {
                  if (!IsWritableStreamDefaultController(this)) {
                    throw defaultControllerBrandCheckException$2("signal");
                  }
                  if (this._abortController === void 0) {
                    throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
                  }
                  return this._abortController.signal;
                },
                enumerable: false,
                configurable: true
              });
              WritableStreamDefaultController2.prototype.error = function(e2) {
                if (e2 === void 0) {
                  e2 = void 0;
                }
                if (!IsWritableStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException$2("error");
                }
                var state2 = this._controlledWritableStream._state;
                if (state2 !== "writable") {
                  return;
                }
                WritableStreamDefaultControllerError(this, e2);
              };
              WritableStreamDefaultController2.prototype[AbortSteps] = function(reason) {
                var result2 = this._abortAlgorithm(reason);
                WritableStreamDefaultControllerClearAlgorithms(this);
                return result2;
              };
              WritableStreamDefaultController2.prototype[ErrorSteps] = function() {
                ResetQueue(this);
              };
              return WritableStreamDefaultController2;
            }();
            Object.defineProperties(WritableStreamDefaultController.prototype, {
              abortReason: { enumerable: true },
              signal: { enumerable: true },
              error: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(WritableStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                value: "WritableStreamDefaultController",
                configurable: true
              });
            }
            function IsWritableStreamDefaultController(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_controlledWritableStream")) {
                return false;
              }
              return x2 instanceof WritableStreamDefaultController;
            }
            function SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
              controller._controlledWritableStream = stream;
              stream._writableStreamController = controller;
              controller._queue = void 0;
              controller._queueTotalSize = void 0;
              ResetQueue(controller);
              controller._abortReason = void 0;
              controller._abortController = createAbortController();
              controller._started = false;
              controller._strategySizeAlgorithm = sizeAlgorithm;
              controller._strategyHWM = highWaterMark;
              controller._writeAlgorithm = writeAlgorithm;
              controller._closeAlgorithm = closeAlgorithm;
              controller._abortAlgorithm = abortAlgorithm;
              var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
              WritableStreamUpdateBackpressure(stream, backpressure);
              var startResult = startAlgorithm();
              var startPromise = promiseResolvedWith(startResult);
              uponPromise(startPromise, function() {
                controller._started = true;
                WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
              }, function(r2) {
                controller._started = true;
                WritableStreamDealWithRejection(stream, r2);
              });
            }
            function SetUpWritableStreamDefaultControllerFromUnderlyingSink(stream, underlyingSink, highWaterMark, sizeAlgorithm) {
              var controller = Object.create(WritableStreamDefaultController.prototype);
              var startAlgorithm = function() {
                return void 0;
              };
              var writeAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              var closeAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              var abortAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              if (underlyingSink.start !== void 0) {
                startAlgorithm = function() {
                  return underlyingSink.start(controller);
                };
              }
              if (underlyingSink.write !== void 0) {
                writeAlgorithm = function(chunk) {
                  return underlyingSink.write(chunk, controller);
                };
              }
              if (underlyingSink.close !== void 0) {
                closeAlgorithm = function() {
                  return underlyingSink.close();
                };
              }
              if (underlyingSink.abort !== void 0) {
                abortAlgorithm = function(reason) {
                  return underlyingSink.abort(reason);
                };
              }
              SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
            }
            function WritableStreamDefaultControllerClearAlgorithms(controller) {
              controller._writeAlgorithm = void 0;
              controller._closeAlgorithm = void 0;
              controller._abortAlgorithm = void 0;
              controller._strategySizeAlgorithm = void 0;
            }
            function WritableStreamDefaultControllerClose(controller) {
              EnqueueValueWithSize(controller, closeSentinel, 0);
              WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
            }
            function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
              try {
                return controller._strategySizeAlgorithm(chunk);
              } catch (chunkSizeE) {
                WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
                return 1;
              }
            }
            function WritableStreamDefaultControllerGetDesiredSize(controller) {
              return controller._strategyHWM - controller._queueTotalSize;
            }
            function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
              try {
                EnqueueValueWithSize(controller, chunk, chunkSize);
              } catch (enqueueE) {
                WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
                return;
              }
              var stream = controller._controlledWritableStream;
              if (!WritableStreamCloseQueuedOrInFlight(stream) && stream._state === "writable") {
                var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                WritableStreamUpdateBackpressure(stream, backpressure);
              }
              WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
            }
            function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
              var stream = controller._controlledWritableStream;
              if (!controller._started) {
                return;
              }
              if (stream._inFlightWriteRequest !== void 0) {
                return;
              }
              var state2 = stream._state;
              if (state2 === "erroring") {
                WritableStreamFinishErroring(stream);
                return;
              }
              if (controller._queue.length === 0) {
                return;
              }
              var value = PeekQueueValue(controller);
              if (value === closeSentinel) {
                WritableStreamDefaultControllerProcessClose(controller);
              } else {
                WritableStreamDefaultControllerProcessWrite(controller, value);
              }
            }
            function WritableStreamDefaultControllerErrorIfNeeded(controller, error3) {
              if (controller._controlledWritableStream._state === "writable") {
                WritableStreamDefaultControllerError(controller, error3);
              }
            }
            function WritableStreamDefaultControllerProcessClose(controller) {
              var stream = controller._controlledWritableStream;
              WritableStreamMarkCloseRequestInFlight(stream);
              DequeueValue(controller);
              var sinkClosePromise = controller._closeAlgorithm();
              WritableStreamDefaultControllerClearAlgorithms(controller);
              uponPromise(sinkClosePromise, function() {
                WritableStreamFinishInFlightClose(stream);
              }, function(reason) {
                WritableStreamFinishInFlightCloseWithError(stream, reason);
              });
            }
            function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
              var stream = controller._controlledWritableStream;
              WritableStreamMarkFirstWriteRequestInFlight(stream);
              var sinkWritePromise = controller._writeAlgorithm(chunk);
              uponPromise(sinkWritePromise, function() {
                WritableStreamFinishInFlightWrite(stream);
                var state2 = stream._state;
                DequeueValue(controller);
                if (!WritableStreamCloseQueuedOrInFlight(stream) && state2 === "writable") {
                  var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                  WritableStreamUpdateBackpressure(stream, backpressure);
                }
                WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
              }, function(reason) {
                if (stream._state === "writable") {
                  WritableStreamDefaultControllerClearAlgorithms(controller);
                }
                WritableStreamFinishInFlightWriteWithError(stream, reason);
              });
            }
            function WritableStreamDefaultControllerGetBackpressure(controller) {
              var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
              return desiredSize <= 0;
            }
            function WritableStreamDefaultControllerError(controller, error3) {
              var stream = controller._controlledWritableStream;
              WritableStreamDefaultControllerClearAlgorithms(controller);
              WritableStreamStartErroring(stream, error3);
            }
            function streamBrandCheckException$2(name) {
              return new TypeError("WritableStream.prototype." + name + " can only be used on a WritableStream");
            }
            function defaultControllerBrandCheckException$2(name) {
              return new TypeError("WritableStreamDefaultController.prototype." + name + " can only be used on a WritableStreamDefaultController");
            }
            function defaultWriterBrandCheckException(name) {
              return new TypeError("WritableStreamDefaultWriter.prototype." + name + " can only be used on a WritableStreamDefaultWriter");
            }
            function defaultWriterLockException(name) {
              return new TypeError("Cannot " + name + " a stream using a released writer");
            }
            function defaultWriterClosedPromiseInitialize(writer) {
              writer._closedPromise = newPromise(function(resolve, reject) {
                writer._closedPromise_resolve = resolve;
                writer._closedPromise_reject = reject;
                writer._closedPromiseState = "pending";
              });
            }
            function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
              defaultWriterClosedPromiseInitialize(writer);
              defaultWriterClosedPromiseReject(writer, reason);
            }
            function defaultWriterClosedPromiseInitializeAsResolved(writer) {
              defaultWriterClosedPromiseInitialize(writer);
              defaultWriterClosedPromiseResolve(writer);
            }
            function defaultWriterClosedPromiseReject(writer, reason) {
              if (writer._closedPromise_reject === void 0) {
                return;
              }
              setPromiseIsHandledToTrue(writer._closedPromise);
              writer._closedPromise_reject(reason);
              writer._closedPromise_resolve = void 0;
              writer._closedPromise_reject = void 0;
              writer._closedPromiseState = "rejected";
            }
            function defaultWriterClosedPromiseResetToRejected(writer, reason) {
              defaultWriterClosedPromiseInitializeAsRejected(writer, reason);
            }
            function defaultWriterClosedPromiseResolve(writer) {
              if (writer._closedPromise_resolve === void 0) {
                return;
              }
              writer._closedPromise_resolve(void 0);
              writer._closedPromise_resolve = void 0;
              writer._closedPromise_reject = void 0;
              writer._closedPromiseState = "resolved";
            }
            function defaultWriterReadyPromiseInitialize(writer) {
              writer._readyPromise = newPromise(function(resolve, reject) {
                writer._readyPromise_resolve = resolve;
                writer._readyPromise_reject = reject;
              });
              writer._readyPromiseState = "pending";
            }
            function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
              defaultWriterReadyPromiseInitialize(writer);
              defaultWriterReadyPromiseReject(writer, reason);
            }
            function defaultWriterReadyPromiseInitializeAsResolved(writer) {
              defaultWriterReadyPromiseInitialize(writer);
              defaultWriterReadyPromiseResolve(writer);
            }
            function defaultWriterReadyPromiseReject(writer, reason) {
              if (writer._readyPromise_reject === void 0) {
                return;
              }
              setPromiseIsHandledToTrue(writer._readyPromise);
              writer._readyPromise_reject(reason);
              writer._readyPromise_resolve = void 0;
              writer._readyPromise_reject = void 0;
              writer._readyPromiseState = "rejected";
            }
            function defaultWriterReadyPromiseReset(writer) {
              defaultWriterReadyPromiseInitialize(writer);
            }
            function defaultWriterReadyPromiseResetToRejected(writer, reason) {
              defaultWriterReadyPromiseInitializeAsRejected(writer, reason);
            }
            function defaultWriterReadyPromiseResolve(writer) {
              if (writer._readyPromise_resolve === void 0) {
                return;
              }
              writer._readyPromise_resolve(void 0);
              writer._readyPromise_resolve = void 0;
              writer._readyPromise_reject = void 0;
              writer._readyPromiseState = "fulfilled";
            }
            var NativeDOMException = typeof DOMException !== "undefined" ? DOMException : void 0;
            function isDOMExceptionConstructor(ctor) {
              if (!(typeof ctor === "function" || typeof ctor === "object")) {
                return false;
              }
              try {
                new ctor();
                return true;
              } catch (_a2) {
                return false;
              }
            }
            function createDOMExceptionPolyfill() {
              var ctor = function DOMException2(message2, name) {
                this.message = message2 || "";
                this.name = name || "Error";
                if (Error.captureStackTrace) {
                  Error.captureStackTrace(this, this.constructor);
                }
              };
              ctor.prototype = Object.create(Error.prototype);
              Object.defineProperty(ctor.prototype, "constructor", {
                value: ctor,
                writable: true,
                configurable: true
              });
              return ctor;
            }
            var DOMException$1 = isDOMExceptionConstructor(NativeDOMException) ? NativeDOMException : createDOMExceptionPolyfill();
            function ReadableStreamPipeTo(source2, dest, preventClose, preventAbort, preventCancel, signal) {
              var reader = AcquireReadableStreamDefaultReader(source2);
              var writer = AcquireWritableStreamDefaultWriter(dest);
              source2._disturbed = true;
              var shuttingDown = false;
              var currentWrite = promiseResolvedWith(void 0);
              return newPromise(function(resolve, reject) {
                var abortAlgorithm;
                if (signal !== void 0) {
                  abortAlgorithm = function() {
                    var error3 = new DOMException$1("Aborted", "AbortError");
                    var actions = [];
                    if (!preventAbort) {
                      actions.push(function() {
                        if (dest._state === "writable") {
                          return WritableStreamAbort(dest, error3);
                        }
                        return promiseResolvedWith(void 0);
                      });
                    }
                    if (!preventCancel) {
                      actions.push(function() {
                        if (source2._state === "readable") {
                          return ReadableStreamCancel(source2, error3);
                        }
                        return promiseResolvedWith(void 0);
                      });
                    }
                    shutdownWithAction(function() {
                      return Promise.all(actions.map(function(action) {
                        return action();
                      }));
                    }, true, error3);
                  };
                  if (signal.aborted) {
                    abortAlgorithm();
                    return;
                  }
                  signal.addEventListener("abort", abortAlgorithm);
                }
                function pipeLoop() {
                  return newPromise(function(resolveLoop, rejectLoop) {
                    function next(done) {
                      if (done) {
                        resolveLoop();
                      } else {
                        PerformPromiseThen(pipeStep(), next, rejectLoop);
                      }
                    }
                    next(false);
                  });
                }
                function pipeStep() {
                  if (shuttingDown) {
                    return promiseResolvedWith(true);
                  }
                  return PerformPromiseThen(writer._readyPromise, function() {
                    return newPromise(function(resolveRead, rejectRead) {
                      ReadableStreamDefaultReaderRead(reader, {
                        _chunkSteps: function(chunk) {
                          currentWrite = PerformPromiseThen(WritableStreamDefaultWriterWrite(writer, chunk), void 0, noop2);
                          resolveRead(false);
                        },
                        _closeSteps: function() {
                          return resolveRead(true);
                        },
                        _errorSteps: rejectRead
                      });
                    });
                  });
                }
                isOrBecomesErrored(source2, reader._closedPromise, function(storedError) {
                  if (!preventAbort) {
                    shutdownWithAction(function() {
                      return WritableStreamAbort(dest, storedError);
                    }, true, storedError);
                  } else {
                    shutdown(true, storedError);
                  }
                });
                isOrBecomesErrored(dest, writer._closedPromise, function(storedError) {
                  if (!preventCancel) {
                    shutdownWithAction(function() {
                      return ReadableStreamCancel(source2, storedError);
                    }, true, storedError);
                  } else {
                    shutdown(true, storedError);
                  }
                });
                isOrBecomesClosed(source2, reader._closedPromise, function() {
                  if (!preventClose) {
                    shutdownWithAction(function() {
                      return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
                    });
                  } else {
                    shutdown();
                  }
                });
                if (WritableStreamCloseQueuedOrInFlight(dest) || dest._state === "closed") {
                  var destClosed_1 = new TypeError("the destination writable stream closed before all data could be piped to it");
                  if (!preventCancel) {
                    shutdownWithAction(function() {
                      return ReadableStreamCancel(source2, destClosed_1);
                    }, true, destClosed_1);
                  } else {
                    shutdown(true, destClosed_1);
                  }
                }
                setPromiseIsHandledToTrue(pipeLoop());
                function waitForWritesToFinish() {
                  var oldCurrentWrite = currentWrite;
                  return PerformPromiseThen(currentWrite, function() {
                    return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : void 0;
                  });
                }
                function isOrBecomesErrored(stream, promise, action) {
                  if (stream._state === "errored") {
                    action(stream._storedError);
                  } else {
                    uponRejection(promise, action);
                  }
                }
                function isOrBecomesClosed(stream, promise, action) {
                  if (stream._state === "closed") {
                    action();
                  } else {
                    uponFulfillment(promise, action);
                  }
                }
                function shutdownWithAction(action, originalIsError, originalError) {
                  if (shuttingDown) {
                    return;
                  }
                  shuttingDown = true;
                  if (dest._state === "writable" && !WritableStreamCloseQueuedOrInFlight(dest)) {
                    uponFulfillment(waitForWritesToFinish(), doTheRest);
                  } else {
                    doTheRest();
                  }
                  function doTheRest() {
                    uponPromise(action(), function() {
                      return finalize(originalIsError, originalError);
                    }, function(newError) {
                      return finalize(true, newError);
                    });
                  }
                }
                function shutdown(isError, error3) {
                  if (shuttingDown) {
                    return;
                  }
                  shuttingDown = true;
                  if (dest._state === "writable" && !WritableStreamCloseQueuedOrInFlight(dest)) {
                    uponFulfillment(waitForWritesToFinish(), function() {
                      return finalize(isError, error3);
                    });
                  } else {
                    finalize(isError, error3);
                  }
                }
                function finalize(isError, error3) {
                  WritableStreamDefaultWriterRelease(writer);
                  ReadableStreamReaderGenericRelease(reader);
                  if (signal !== void 0) {
                    signal.removeEventListener("abort", abortAlgorithm);
                  }
                  if (isError) {
                    reject(error3);
                  } else {
                    resolve(void 0);
                  }
                }
              });
            }
            var ReadableStreamDefaultController = function() {
              function ReadableStreamDefaultController2() {
                throw new TypeError("Illegal constructor");
              }
              Object.defineProperty(ReadableStreamDefaultController2.prototype, "desiredSize", {
                get: function() {
                  if (!IsReadableStreamDefaultController(this)) {
                    throw defaultControllerBrandCheckException$1("desiredSize");
                  }
                  return ReadableStreamDefaultControllerGetDesiredSize(this);
                },
                enumerable: false,
                configurable: true
              });
              ReadableStreamDefaultController2.prototype.close = function() {
                if (!IsReadableStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException$1("close");
                }
                if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(this)) {
                  throw new TypeError("The stream is not in a state that permits close");
                }
                ReadableStreamDefaultControllerClose(this);
              };
              ReadableStreamDefaultController2.prototype.enqueue = function(chunk) {
                if (chunk === void 0) {
                  chunk = void 0;
                }
                if (!IsReadableStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException$1("enqueue");
                }
                if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(this)) {
                  throw new TypeError("The stream is not in a state that permits enqueue");
                }
                return ReadableStreamDefaultControllerEnqueue(this, chunk);
              };
              ReadableStreamDefaultController2.prototype.error = function(e2) {
                if (e2 === void 0) {
                  e2 = void 0;
                }
                if (!IsReadableStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException$1("error");
                }
                ReadableStreamDefaultControllerError(this, e2);
              };
              ReadableStreamDefaultController2.prototype[CancelSteps] = function(reason) {
                ResetQueue(this);
                var result2 = this._cancelAlgorithm(reason);
                ReadableStreamDefaultControllerClearAlgorithms(this);
                return result2;
              };
              ReadableStreamDefaultController2.prototype[PullSteps] = function(readRequest) {
                var stream = this._controlledReadableStream;
                if (this._queue.length > 0) {
                  var chunk = DequeueValue(this);
                  if (this._closeRequested && this._queue.length === 0) {
                    ReadableStreamDefaultControllerClearAlgorithms(this);
                    ReadableStreamClose(stream);
                  } else {
                    ReadableStreamDefaultControllerCallPullIfNeeded(this);
                  }
                  readRequest._chunkSteps(chunk);
                } else {
                  ReadableStreamAddReadRequest(stream, readRequest);
                  ReadableStreamDefaultControllerCallPullIfNeeded(this);
                }
              };
              return ReadableStreamDefaultController2;
            }();
            Object.defineProperties(ReadableStreamDefaultController.prototype, {
              close: { enumerable: true },
              enqueue: { enumerable: true },
              error: { enumerable: true },
              desiredSize: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ReadableStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                value: "ReadableStreamDefaultController",
                configurable: true
              });
            }
            function IsReadableStreamDefaultController(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_controlledReadableStream")) {
                return false;
              }
              return x2 instanceof ReadableStreamDefaultController;
            }
            function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
              var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
              if (!shouldPull) {
                return;
              }
              if (controller._pulling) {
                controller._pullAgain = true;
                return;
              }
              controller._pulling = true;
              var pullPromise = controller._pullAlgorithm();
              uponPromise(pullPromise, function() {
                controller._pulling = false;
                if (controller._pullAgain) {
                  controller._pullAgain = false;
                  ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                }
              }, function(e2) {
                ReadableStreamDefaultControllerError(controller, e2);
              });
            }
            function ReadableStreamDefaultControllerShouldCallPull(controller) {
              var stream = controller._controlledReadableStream;
              if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) {
                return false;
              }
              if (!controller._started) {
                return false;
              }
              if (IsReadableStreamLocked(stream) && ReadableStreamGetNumReadRequests(stream) > 0) {
                return true;
              }
              var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
              if (desiredSize > 0) {
                return true;
              }
              return false;
            }
            function ReadableStreamDefaultControllerClearAlgorithms(controller) {
              controller._pullAlgorithm = void 0;
              controller._cancelAlgorithm = void 0;
              controller._strategySizeAlgorithm = void 0;
            }
            function ReadableStreamDefaultControllerClose(controller) {
              if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) {
                return;
              }
              var stream = controller._controlledReadableStream;
              controller._closeRequested = true;
              if (controller._queue.length === 0) {
                ReadableStreamDefaultControllerClearAlgorithms(controller);
                ReadableStreamClose(stream);
              }
            }
            function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
              if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) {
                return;
              }
              var stream = controller._controlledReadableStream;
              if (IsReadableStreamLocked(stream) && ReadableStreamGetNumReadRequests(stream) > 0) {
                ReadableStreamFulfillReadRequest(stream, chunk, false);
              } else {
                var chunkSize = void 0;
                try {
                  chunkSize = controller._strategySizeAlgorithm(chunk);
                } catch (chunkSizeE) {
                  ReadableStreamDefaultControllerError(controller, chunkSizeE);
                  throw chunkSizeE;
                }
                try {
                  EnqueueValueWithSize(controller, chunk, chunkSize);
                } catch (enqueueE) {
                  ReadableStreamDefaultControllerError(controller, enqueueE);
                  throw enqueueE;
                }
              }
              ReadableStreamDefaultControllerCallPullIfNeeded(controller);
            }
            function ReadableStreamDefaultControllerError(controller, e2) {
              var stream = controller._controlledReadableStream;
              if (stream._state !== "readable") {
                return;
              }
              ResetQueue(controller);
              ReadableStreamDefaultControllerClearAlgorithms(controller);
              ReadableStreamError(stream, e2);
            }
            function ReadableStreamDefaultControllerGetDesiredSize(controller) {
              var state2 = controller._controlledReadableStream._state;
              if (state2 === "errored") {
                return null;
              }
              if (state2 === "closed") {
                return 0;
              }
              return controller._strategyHWM - controller._queueTotalSize;
            }
            function ReadableStreamDefaultControllerHasBackpressure(controller) {
              if (ReadableStreamDefaultControllerShouldCallPull(controller)) {
                return false;
              }
              return true;
            }
            function ReadableStreamDefaultControllerCanCloseOrEnqueue(controller) {
              var state2 = controller._controlledReadableStream._state;
              if (!controller._closeRequested && state2 === "readable") {
                return true;
              }
              return false;
            }
            function SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
              controller._controlledReadableStream = stream;
              controller._queue = void 0;
              controller._queueTotalSize = void 0;
              ResetQueue(controller);
              controller._started = false;
              controller._closeRequested = false;
              controller._pullAgain = false;
              controller._pulling = false;
              controller._strategySizeAlgorithm = sizeAlgorithm;
              controller._strategyHWM = highWaterMark;
              controller._pullAlgorithm = pullAlgorithm;
              controller._cancelAlgorithm = cancelAlgorithm;
              stream._readableStreamController = controller;
              var startResult = startAlgorithm();
              uponPromise(promiseResolvedWith(startResult), function() {
                controller._started = true;
                ReadableStreamDefaultControllerCallPullIfNeeded(controller);
              }, function(r2) {
                ReadableStreamDefaultControllerError(controller, r2);
              });
            }
            function SetUpReadableStreamDefaultControllerFromUnderlyingSource(stream, underlyingSource, highWaterMark, sizeAlgorithm) {
              var controller = Object.create(ReadableStreamDefaultController.prototype);
              var startAlgorithm = function() {
                return void 0;
              };
              var pullAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              var cancelAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              if (underlyingSource.start !== void 0) {
                startAlgorithm = function() {
                  return underlyingSource.start(controller);
                };
              }
              if (underlyingSource.pull !== void 0) {
                pullAlgorithm = function() {
                  return underlyingSource.pull(controller);
                };
              }
              if (underlyingSource.cancel !== void 0) {
                cancelAlgorithm = function(reason) {
                  return underlyingSource.cancel(reason);
                };
              }
              SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
            }
            function defaultControllerBrandCheckException$1(name) {
              return new TypeError("ReadableStreamDefaultController.prototype." + name + " can only be used on a ReadableStreamDefaultController");
            }
            function ReadableStreamTee(stream, cloneForBranch2) {
              if (IsReadableByteStreamController(stream._readableStreamController)) {
                return ReadableByteStreamTee(stream);
              }
              return ReadableStreamDefaultTee(stream);
            }
            function ReadableStreamDefaultTee(stream, cloneForBranch2) {
              var reader = AcquireReadableStreamDefaultReader(stream);
              var reading = false;
              var readAgain = false;
              var canceled1 = false;
              var canceled2 = false;
              var reason1;
              var reason2;
              var branch1;
              var branch2;
              var resolveCancelPromise;
              var cancelPromise = newPromise(function(resolve) {
                resolveCancelPromise = resolve;
              });
              function pullAlgorithm() {
                if (reading) {
                  readAgain = true;
                  return promiseResolvedWith(void 0);
                }
                reading = true;
                var readRequest = {
                  _chunkSteps: function(chunk) {
                    queueMicrotask(function() {
                      readAgain = false;
                      var chunk1 = chunk;
                      var chunk2 = chunk;
                      if (!canceled1) {
                        ReadableStreamDefaultControllerEnqueue(branch1._readableStreamController, chunk1);
                      }
                      if (!canceled2) {
                        ReadableStreamDefaultControllerEnqueue(branch2._readableStreamController, chunk2);
                      }
                      reading = false;
                      if (readAgain) {
                        pullAlgorithm();
                      }
                    });
                  },
                  _closeSteps: function() {
                    reading = false;
                    if (!canceled1) {
                      ReadableStreamDefaultControllerClose(branch1._readableStreamController);
                    }
                    if (!canceled2) {
                      ReadableStreamDefaultControllerClose(branch2._readableStreamController);
                    }
                    if (!canceled1 || !canceled2) {
                      resolveCancelPromise(void 0);
                    }
                  },
                  _errorSteps: function() {
                    reading = false;
                  }
                };
                ReadableStreamDefaultReaderRead(reader, readRequest);
                return promiseResolvedWith(void 0);
              }
              function cancel1Algorithm(reason) {
                canceled1 = true;
                reason1 = reason;
                if (canceled2) {
                  var compositeReason = CreateArrayFromList([
                    reason1,
                    reason2
                  ]);
                  var cancelResult = ReadableStreamCancel(stream, compositeReason);
                  resolveCancelPromise(cancelResult);
                }
                return cancelPromise;
              }
              function cancel2Algorithm(reason) {
                canceled2 = true;
                reason2 = reason;
                if (canceled1) {
                  var compositeReason = CreateArrayFromList([
                    reason1,
                    reason2
                  ]);
                  var cancelResult = ReadableStreamCancel(stream, compositeReason);
                  resolveCancelPromise(cancelResult);
                }
                return cancelPromise;
              }
              function startAlgorithm() {
              }
              branch1 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel1Algorithm);
              branch2 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel2Algorithm);
              uponRejection(reader._closedPromise, function(r2) {
                ReadableStreamDefaultControllerError(branch1._readableStreamController, r2);
                ReadableStreamDefaultControllerError(branch2._readableStreamController, r2);
                if (!canceled1 || !canceled2) {
                  resolveCancelPromise(void 0);
                }
              });
              return [
                branch1,
                branch2
              ];
            }
            function ReadableByteStreamTee(stream) {
              var reader = AcquireReadableStreamDefaultReader(stream);
              var reading = false;
              var readAgainForBranch1 = false;
              var readAgainForBranch2 = false;
              var canceled1 = false;
              var canceled2 = false;
              var reason1;
              var reason2;
              var branch1;
              var branch2;
              var resolveCancelPromise;
              var cancelPromise = newPromise(function(resolve) {
                resolveCancelPromise = resolve;
              });
              function forwardReaderError(thisReader) {
                uponRejection(thisReader._closedPromise, function(r2) {
                  if (thisReader !== reader) {
                    return;
                  }
                  ReadableByteStreamControllerError(branch1._readableStreamController, r2);
                  ReadableByteStreamControllerError(branch2._readableStreamController, r2);
                  if (!canceled1 || !canceled2) {
                    resolveCancelPromise(void 0);
                  }
                });
              }
              function pullWithDefaultReader() {
                if (IsReadableStreamBYOBReader(reader)) {
                  ReadableStreamReaderGenericRelease(reader);
                  reader = AcquireReadableStreamDefaultReader(stream);
                  forwardReaderError(reader);
                }
                var readRequest = {
                  _chunkSteps: function(chunk) {
                    queueMicrotask(function() {
                      readAgainForBranch1 = false;
                      readAgainForBranch2 = false;
                      var chunk1 = chunk;
                      var chunk2 = chunk;
                      if (!canceled1 && !canceled2) {
                        try {
                          chunk2 = CloneAsUint8Array(chunk);
                        } catch (cloneE) {
                          ReadableByteStreamControllerError(branch1._readableStreamController, cloneE);
                          ReadableByteStreamControllerError(branch2._readableStreamController, cloneE);
                          resolveCancelPromise(ReadableStreamCancel(stream, cloneE));
                          return;
                        }
                      }
                      if (!canceled1) {
                        ReadableByteStreamControllerEnqueue(branch1._readableStreamController, chunk1);
                      }
                      if (!canceled2) {
                        ReadableByteStreamControllerEnqueue(branch2._readableStreamController, chunk2);
                      }
                      reading = false;
                      if (readAgainForBranch1) {
                        pull1Algorithm();
                      } else if (readAgainForBranch2) {
                        pull2Algorithm();
                      }
                    });
                  },
                  _closeSteps: function() {
                    reading = false;
                    if (!canceled1) {
                      ReadableByteStreamControllerClose(branch1._readableStreamController);
                    }
                    if (!canceled2) {
                      ReadableByteStreamControllerClose(branch2._readableStreamController);
                    }
                    if (branch1._readableStreamController._pendingPullIntos.length > 0) {
                      ReadableByteStreamControllerRespond(branch1._readableStreamController, 0);
                    }
                    if (branch2._readableStreamController._pendingPullIntos.length > 0) {
                      ReadableByteStreamControllerRespond(branch2._readableStreamController, 0);
                    }
                    if (!canceled1 || !canceled2) {
                      resolveCancelPromise(void 0);
                    }
                  },
                  _errorSteps: function() {
                    reading = false;
                  }
                };
                ReadableStreamDefaultReaderRead(reader, readRequest);
              }
              function pullWithBYOBReader(view, forBranch2) {
                if (IsReadableStreamDefaultReader(reader)) {
                  ReadableStreamReaderGenericRelease(reader);
                  reader = AcquireReadableStreamBYOBReader(stream);
                  forwardReaderError(reader);
                }
                var byobBranch = forBranch2 ? branch2 : branch1;
                var otherBranch = forBranch2 ? branch1 : branch2;
                var readIntoRequest = {
                  _chunkSteps: function(chunk) {
                    queueMicrotask(function() {
                      readAgainForBranch1 = false;
                      readAgainForBranch2 = false;
                      var byobCanceled = forBranch2 ? canceled2 : canceled1;
                      var otherCanceled = forBranch2 ? canceled1 : canceled2;
                      if (!otherCanceled) {
                        var clonedChunk = void 0;
                        try {
                          clonedChunk = CloneAsUint8Array(chunk);
                        } catch (cloneE) {
                          ReadableByteStreamControllerError(byobBranch._readableStreamController, cloneE);
                          ReadableByteStreamControllerError(otherBranch._readableStreamController, cloneE);
                          resolveCancelPromise(ReadableStreamCancel(stream, cloneE));
                          return;
                        }
                        if (!byobCanceled) {
                          ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                        }
                        ReadableByteStreamControllerEnqueue(otherBranch._readableStreamController, clonedChunk);
                      } else if (!byobCanceled) {
                        ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                      }
                      reading = false;
                      if (readAgainForBranch1) {
                        pull1Algorithm();
                      } else if (readAgainForBranch2) {
                        pull2Algorithm();
                      }
                    });
                  },
                  _closeSteps: function(chunk) {
                    reading = false;
                    var byobCanceled = forBranch2 ? canceled2 : canceled1;
                    var otherCanceled = forBranch2 ? canceled1 : canceled2;
                    if (!byobCanceled) {
                      ReadableByteStreamControllerClose(byobBranch._readableStreamController);
                    }
                    if (!otherCanceled) {
                      ReadableByteStreamControllerClose(otherBranch._readableStreamController);
                    }
                    if (chunk !== void 0) {
                      if (!byobCanceled) {
                        ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                      }
                      if (!otherCanceled && otherBranch._readableStreamController._pendingPullIntos.length > 0) {
                        ReadableByteStreamControllerRespond(otherBranch._readableStreamController, 0);
                      }
                    }
                    if (!byobCanceled || !otherCanceled) {
                      resolveCancelPromise(void 0);
                    }
                  },
                  _errorSteps: function() {
                    reading = false;
                  }
                };
                ReadableStreamBYOBReaderRead(reader, view, readIntoRequest);
              }
              function pull1Algorithm() {
                if (reading) {
                  readAgainForBranch1 = true;
                  return promiseResolvedWith(void 0);
                }
                reading = true;
                var byobRequest = ReadableByteStreamControllerGetBYOBRequest(branch1._readableStreamController);
                if (byobRequest === null) {
                  pullWithDefaultReader();
                } else {
                  pullWithBYOBReader(byobRequest._view, false);
                }
                return promiseResolvedWith(void 0);
              }
              function pull2Algorithm() {
                if (reading) {
                  readAgainForBranch2 = true;
                  return promiseResolvedWith(void 0);
                }
                reading = true;
                var byobRequest = ReadableByteStreamControllerGetBYOBRequest(branch2._readableStreamController);
                if (byobRequest === null) {
                  pullWithDefaultReader();
                } else {
                  pullWithBYOBReader(byobRequest._view, true);
                }
                return promiseResolvedWith(void 0);
              }
              function cancel1Algorithm(reason) {
                canceled1 = true;
                reason1 = reason;
                if (canceled2) {
                  var compositeReason = CreateArrayFromList([
                    reason1,
                    reason2
                  ]);
                  var cancelResult = ReadableStreamCancel(stream, compositeReason);
                  resolveCancelPromise(cancelResult);
                }
                return cancelPromise;
              }
              function cancel2Algorithm(reason) {
                canceled2 = true;
                reason2 = reason;
                if (canceled1) {
                  var compositeReason = CreateArrayFromList([
                    reason1,
                    reason2
                  ]);
                  var cancelResult = ReadableStreamCancel(stream, compositeReason);
                  resolveCancelPromise(cancelResult);
                }
                return cancelPromise;
              }
              function startAlgorithm() {
              }
              branch1 = CreateReadableByteStream(startAlgorithm, pull1Algorithm, cancel1Algorithm);
              branch2 = CreateReadableByteStream(startAlgorithm, pull2Algorithm, cancel2Algorithm);
              forwardReaderError(reader);
              return [
                branch1,
                branch2
              ];
            }
            function convertUnderlyingDefaultOrByteSource(source2, context2) {
              assertDictionary(source2, context2);
              var original = source2;
              var autoAllocateChunkSize = original === null || original === void 0 ? void 0 : original.autoAllocateChunkSize;
              var cancel = original === null || original === void 0 ? void 0 : original.cancel;
              var pull = original === null || original === void 0 ? void 0 : original.pull;
              var start = original === null || original === void 0 ? void 0 : original.start;
              var type = original === null || original === void 0 ? void 0 : original.type;
              return {
                autoAllocateChunkSize: autoAllocateChunkSize === void 0 ? void 0 : convertUnsignedLongLongWithEnforceRange(autoAllocateChunkSize, context2 + " has member 'autoAllocateChunkSize' that"),
                cancel: cancel === void 0 ? void 0 : convertUnderlyingSourceCancelCallback(cancel, original, context2 + " has member 'cancel' that"),
                pull: pull === void 0 ? void 0 : convertUnderlyingSourcePullCallback(pull, original, context2 + " has member 'pull' that"),
                start: start === void 0 ? void 0 : convertUnderlyingSourceStartCallback(start, original, context2 + " has member 'start' that"),
                type: type === void 0 ? void 0 : convertReadableStreamType(type, context2 + " has member 'type' that")
              };
            }
            function convertUnderlyingSourceCancelCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(reason) {
                return promiseCall(fn, original, [reason]);
              };
            }
            function convertUnderlyingSourcePullCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(controller) {
                return promiseCall(fn, original, [controller]);
              };
            }
            function convertUnderlyingSourceStartCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(controller) {
                return reflectCall(fn, original, [controller]);
              };
            }
            function convertReadableStreamType(type, context2) {
              type = "" + type;
              if (type !== "bytes") {
                throw new TypeError(context2 + " '" + type + "' is not a valid enumeration value for ReadableStreamType");
              }
              return type;
            }
            function convertReaderOptions(options, context2) {
              assertDictionary(options, context2);
              var mode2 = options === null || options === void 0 ? void 0 : options.mode;
              return { mode: mode2 === void 0 ? void 0 : convertReadableStreamReaderMode(mode2, context2 + " has member 'mode' that") };
            }
            function convertReadableStreamReaderMode(mode2, context2) {
              mode2 = "" + mode2;
              if (mode2 !== "byob") {
                throw new TypeError(context2 + " '" + mode2 + "' is not a valid enumeration value for ReadableStreamReaderMode");
              }
              return mode2;
            }
            function convertIteratorOptions(options, context2) {
              assertDictionary(options, context2);
              var preventCancel = options === null || options === void 0 ? void 0 : options.preventCancel;
              return { preventCancel: Boolean(preventCancel) };
            }
            function convertPipeOptions(options, context2) {
              assertDictionary(options, context2);
              var preventAbort = options === null || options === void 0 ? void 0 : options.preventAbort;
              var preventCancel = options === null || options === void 0 ? void 0 : options.preventCancel;
              var preventClose = options === null || options === void 0 ? void 0 : options.preventClose;
              var signal = options === null || options === void 0 ? void 0 : options.signal;
              if (signal !== void 0) {
                assertAbortSignal(signal, context2 + " has member 'signal' that");
              }
              return {
                preventAbort: Boolean(preventAbort),
                preventCancel: Boolean(preventCancel),
                preventClose: Boolean(preventClose),
                signal
              };
            }
            function assertAbortSignal(signal, context2) {
              if (!isAbortSignal(signal)) {
                throw new TypeError(context2 + " is not an AbortSignal.");
              }
            }
            function convertReadableWritablePair(pair, context2) {
              assertDictionary(pair, context2);
              var readable = pair === null || pair === void 0 ? void 0 : pair.readable;
              assertRequiredField(readable, "readable", "ReadableWritablePair");
              assertReadableStream(readable, context2 + " has member 'readable' that");
              var writable = pair === null || pair === void 0 ? void 0 : pair.writable;
              assertRequiredField(writable, "writable", "ReadableWritablePair");
              assertWritableStream(writable, context2 + " has member 'writable' that");
              return {
                readable,
                writable
              };
            }
            var ReadableStream2 = function() {
              function ReadableStream3(rawUnderlyingSource, rawStrategy) {
                if (rawUnderlyingSource === void 0) {
                  rawUnderlyingSource = {};
                }
                if (rawStrategy === void 0) {
                  rawStrategy = {};
                }
                if (rawUnderlyingSource === void 0) {
                  rawUnderlyingSource = null;
                } else {
                  assertObject(rawUnderlyingSource, "First parameter");
                }
                var strategy = convertQueuingStrategy(rawStrategy, "Second parameter");
                var underlyingSource = convertUnderlyingDefaultOrByteSource(rawUnderlyingSource, "First parameter");
                InitializeReadableStream(this);
                if (underlyingSource.type === "bytes") {
                  if (strategy.size !== void 0) {
                    throw new RangeError("The strategy for a byte stream cannot have a size function");
                  }
                  var highWaterMark = ExtractHighWaterMark(strategy, 0);
                  SetUpReadableByteStreamControllerFromUnderlyingSource(this, underlyingSource, highWaterMark);
                } else {
                  var sizeAlgorithm = ExtractSizeAlgorithm(strategy);
                  var highWaterMark = ExtractHighWaterMark(strategy, 1);
                  SetUpReadableStreamDefaultControllerFromUnderlyingSource(this, underlyingSource, highWaterMark, sizeAlgorithm);
                }
              }
              Object.defineProperty(ReadableStream3.prototype, "locked", {
                get: function() {
                  if (!IsReadableStream(this)) {
                    throw streamBrandCheckException$1("locked");
                  }
                  return IsReadableStreamLocked(this);
                },
                enumerable: false,
                configurable: true
              });
              ReadableStream3.prototype.cancel = function(reason) {
                if (reason === void 0) {
                  reason = void 0;
                }
                if (!IsReadableStream(this)) {
                  return promiseRejectedWith(streamBrandCheckException$1("cancel"));
                }
                if (IsReadableStreamLocked(this)) {
                  return promiseRejectedWith(new TypeError("Cannot cancel a stream that already has a reader"));
                }
                return ReadableStreamCancel(this, reason);
              };
              ReadableStream3.prototype.getReader = function(rawOptions) {
                if (rawOptions === void 0) {
                  rawOptions = void 0;
                }
                if (!IsReadableStream(this)) {
                  throw streamBrandCheckException$1("getReader");
                }
                var options = convertReaderOptions(rawOptions, "First parameter");
                if (options.mode === void 0) {
                  return AcquireReadableStreamDefaultReader(this);
                }
                return AcquireReadableStreamBYOBReader(this);
              };
              ReadableStream3.prototype.pipeThrough = function(rawTransform, rawOptions) {
                if (rawOptions === void 0) {
                  rawOptions = {};
                }
                if (!IsReadableStream(this)) {
                  throw streamBrandCheckException$1("pipeThrough");
                }
                assertRequiredArgument(rawTransform, 1, "pipeThrough");
                var transform2 = convertReadableWritablePair(rawTransform, "First parameter");
                var options = convertPipeOptions(rawOptions, "Second parameter");
                if (IsReadableStreamLocked(this)) {
                  throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
                }
                if (IsWritableStreamLocked(transform2.writable)) {
                  throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
                }
                var promise = ReadableStreamPipeTo(this, transform2.writable, options.preventClose, options.preventAbort, options.preventCancel, options.signal);
                setPromiseIsHandledToTrue(promise);
                return transform2.readable;
              };
              ReadableStream3.prototype.pipeTo = function(destination, rawOptions) {
                if (rawOptions === void 0) {
                  rawOptions = {};
                }
                if (!IsReadableStream(this)) {
                  return promiseRejectedWith(streamBrandCheckException$1("pipeTo"));
                }
                if (destination === void 0) {
                  return promiseRejectedWith("Parameter 1 is required in 'pipeTo'.");
                }
                if (!IsWritableStream(destination)) {
                  return promiseRejectedWith(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
                }
                var options;
                try {
                  options = convertPipeOptions(rawOptions, "Second parameter");
                } catch (e2) {
                  return promiseRejectedWith(e2);
                }
                if (IsReadableStreamLocked(this)) {
                  return promiseRejectedWith(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream"));
                }
                if (IsWritableStreamLocked(destination)) {
                  return promiseRejectedWith(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream"));
                }
                return ReadableStreamPipeTo(this, destination, options.preventClose, options.preventAbort, options.preventCancel, options.signal);
              };
              ReadableStream3.prototype.tee = function() {
                if (!IsReadableStream(this)) {
                  throw streamBrandCheckException$1("tee");
                }
                var branches = ReadableStreamTee(this);
                return CreateArrayFromList(branches);
              };
              ReadableStream3.prototype.values = function(rawOptions) {
                if (rawOptions === void 0) {
                  rawOptions = void 0;
                }
                if (!IsReadableStream(this)) {
                  throw streamBrandCheckException$1("values");
                }
                var options = convertIteratorOptions(rawOptions, "First parameter");
                return AcquireReadableStreamAsyncIterator(this, options.preventCancel);
              };
              return ReadableStream3;
            }();
            Object.defineProperties(ReadableStream2.prototype, {
              cancel: { enumerable: true },
              getReader: { enumerable: true },
              pipeThrough: { enumerable: true },
              pipeTo: { enumerable: true },
              tee: { enumerable: true },
              values: { enumerable: true },
              locked: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ReadableStream2.prototype, SymbolPolyfill.toStringTag, {
                value: "ReadableStream",
                configurable: true
              });
            }
            if (typeof SymbolPolyfill.asyncIterator === "symbol") {
              Object.defineProperty(ReadableStream2.prototype, SymbolPolyfill.asyncIterator, {
                value: ReadableStream2.prototype.values,
                writable: true,
                configurable: true
              });
            }
            function CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
              if (highWaterMark === void 0) {
                highWaterMark = 1;
              }
              if (sizeAlgorithm === void 0) {
                sizeAlgorithm = function() {
                  return 1;
                };
              }
              var stream = Object.create(ReadableStream2.prototype);
              InitializeReadableStream(stream);
              var controller = Object.create(ReadableStreamDefaultController.prototype);
              SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
              return stream;
            }
            function CreateReadableByteStream(startAlgorithm, pullAlgorithm, cancelAlgorithm) {
              var stream = Object.create(ReadableStream2.prototype);
              InitializeReadableStream(stream);
              var controller = Object.create(ReadableByteStreamController.prototype);
              SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, 0, void 0);
              return stream;
            }
            function InitializeReadableStream(stream) {
              stream._state = "readable";
              stream._reader = void 0;
              stream._storedError = void 0;
              stream._disturbed = false;
            }
            function IsReadableStream(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_readableStreamController")) {
                return false;
              }
              return x2 instanceof ReadableStream2;
            }
            function IsReadableStreamLocked(stream) {
              if (stream._reader === void 0) {
                return false;
              }
              return true;
            }
            function ReadableStreamCancel(stream, reason) {
              stream._disturbed = true;
              if (stream._state === "closed") {
                return promiseResolvedWith(void 0);
              }
              if (stream._state === "errored") {
                return promiseRejectedWith(stream._storedError);
              }
              ReadableStreamClose(stream);
              var reader = stream._reader;
              if (reader !== void 0 && IsReadableStreamBYOBReader(reader)) {
                reader._readIntoRequests.forEach(function(readIntoRequest) {
                  readIntoRequest._closeSteps(void 0);
                });
                reader._readIntoRequests = new SimpleQueue();
              }
              var sourceCancelPromise = stream._readableStreamController[CancelSteps](reason);
              return transformPromiseWith(sourceCancelPromise, noop2);
            }
            function ReadableStreamClose(stream) {
              stream._state = "closed";
              var reader = stream._reader;
              if (reader === void 0) {
                return;
              }
              defaultReaderClosedPromiseResolve(reader);
              if (IsReadableStreamDefaultReader(reader)) {
                reader._readRequests.forEach(function(readRequest) {
                  readRequest._closeSteps();
                });
                reader._readRequests = new SimpleQueue();
              }
            }
            function ReadableStreamError(stream, e2) {
              stream._state = "errored";
              stream._storedError = e2;
              var reader = stream._reader;
              if (reader === void 0) {
                return;
              }
              defaultReaderClosedPromiseReject(reader, e2);
              if (IsReadableStreamDefaultReader(reader)) {
                reader._readRequests.forEach(function(readRequest) {
                  readRequest._errorSteps(e2);
                });
                reader._readRequests = new SimpleQueue();
              } else {
                reader._readIntoRequests.forEach(function(readIntoRequest) {
                  readIntoRequest._errorSteps(e2);
                });
                reader._readIntoRequests = new SimpleQueue();
              }
            }
            function streamBrandCheckException$1(name) {
              return new TypeError("ReadableStream.prototype." + name + " can only be used on a ReadableStream");
            }
            function convertQueuingStrategyInit(init3, context2) {
              assertDictionary(init3, context2);
              var highWaterMark = init3 === null || init3 === void 0 ? void 0 : init3.highWaterMark;
              assertRequiredField(highWaterMark, "highWaterMark", "QueuingStrategyInit");
              return { highWaterMark: convertUnrestrictedDouble(highWaterMark) };
            }
            var byteLengthSizeFunction = function(chunk) {
              return chunk.byteLength;
            };
            Object.defineProperty(byteLengthSizeFunction, "name", {
              value: "size",
              configurable: true
            });
            var ByteLengthQueuingStrategy = function() {
              function ByteLengthQueuingStrategy2(options) {
                assertRequiredArgument(options, 1, "ByteLengthQueuingStrategy");
                options = convertQueuingStrategyInit(options, "First parameter");
                this._byteLengthQueuingStrategyHighWaterMark = options.highWaterMark;
              }
              Object.defineProperty(ByteLengthQueuingStrategy2.prototype, "highWaterMark", {
                get: function() {
                  if (!IsByteLengthQueuingStrategy(this)) {
                    throw byteLengthBrandCheckException("highWaterMark");
                  }
                  return this._byteLengthQueuingStrategyHighWaterMark;
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(ByteLengthQueuingStrategy2.prototype, "size", {
                get: function() {
                  if (!IsByteLengthQueuingStrategy(this)) {
                    throw byteLengthBrandCheckException("size");
                  }
                  return byteLengthSizeFunction;
                },
                enumerable: false,
                configurable: true
              });
              return ByteLengthQueuingStrategy2;
            }();
            Object.defineProperties(ByteLengthQueuingStrategy.prototype, {
              highWaterMark: { enumerable: true },
              size: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(ByteLengthQueuingStrategy.prototype, SymbolPolyfill.toStringTag, {
                value: "ByteLengthQueuingStrategy",
                configurable: true
              });
            }
            function byteLengthBrandCheckException(name) {
              return new TypeError("ByteLengthQueuingStrategy.prototype." + name + " can only be used on a ByteLengthQueuingStrategy");
            }
            function IsByteLengthQueuingStrategy(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_byteLengthQueuingStrategyHighWaterMark")) {
                return false;
              }
              return x2 instanceof ByteLengthQueuingStrategy;
            }
            var countSizeFunction = function() {
              return 1;
            };
            Object.defineProperty(countSizeFunction, "name", {
              value: "size",
              configurable: true
            });
            var CountQueuingStrategy = function() {
              function CountQueuingStrategy2(options) {
                assertRequiredArgument(options, 1, "CountQueuingStrategy");
                options = convertQueuingStrategyInit(options, "First parameter");
                this._countQueuingStrategyHighWaterMark = options.highWaterMark;
              }
              Object.defineProperty(CountQueuingStrategy2.prototype, "highWaterMark", {
                get: function() {
                  if (!IsCountQueuingStrategy(this)) {
                    throw countBrandCheckException("highWaterMark");
                  }
                  return this._countQueuingStrategyHighWaterMark;
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(CountQueuingStrategy2.prototype, "size", {
                get: function() {
                  if (!IsCountQueuingStrategy(this)) {
                    throw countBrandCheckException("size");
                  }
                  return countSizeFunction;
                },
                enumerable: false,
                configurable: true
              });
              return CountQueuingStrategy2;
            }();
            Object.defineProperties(CountQueuingStrategy.prototype, {
              highWaterMark: { enumerable: true },
              size: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(CountQueuingStrategy.prototype, SymbolPolyfill.toStringTag, {
                value: "CountQueuingStrategy",
                configurable: true
              });
            }
            function countBrandCheckException(name) {
              return new TypeError("CountQueuingStrategy.prototype." + name + " can only be used on a CountQueuingStrategy");
            }
            function IsCountQueuingStrategy(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_countQueuingStrategyHighWaterMark")) {
                return false;
              }
              return x2 instanceof CountQueuingStrategy;
            }
            function convertTransformer(original, context2) {
              assertDictionary(original, context2);
              var flush = original === null || original === void 0 ? void 0 : original.flush;
              var readableType = original === null || original === void 0 ? void 0 : original.readableType;
              var start = original === null || original === void 0 ? void 0 : original.start;
              var transform2 = original === null || original === void 0 ? void 0 : original.transform;
              var writableType = original === null || original === void 0 ? void 0 : original.writableType;
              return {
                flush: flush === void 0 ? void 0 : convertTransformerFlushCallback(flush, original, context2 + " has member 'flush' that"),
                readableType,
                start: start === void 0 ? void 0 : convertTransformerStartCallback(start, original, context2 + " has member 'start' that"),
                transform: transform2 === void 0 ? void 0 : convertTransformerTransformCallback(transform2, original, context2 + " has member 'transform' that"),
                writableType
              };
            }
            function convertTransformerFlushCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(controller) {
                return promiseCall(fn, original, [controller]);
              };
            }
            function convertTransformerStartCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(controller) {
                return reflectCall(fn, original, [controller]);
              };
            }
            function convertTransformerTransformCallback(fn, original, context2) {
              assertFunction(fn, context2);
              return function(chunk, controller) {
                return promiseCall(fn, original, [
                  chunk,
                  controller
                ]);
              };
            }
            var TransformStream = function() {
              function TransformStream2(rawTransformer, rawWritableStrategy, rawReadableStrategy) {
                if (rawTransformer === void 0) {
                  rawTransformer = {};
                }
                if (rawWritableStrategy === void 0) {
                  rawWritableStrategy = {};
                }
                if (rawReadableStrategy === void 0) {
                  rawReadableStrategy = {};
                }
                if (rawTransformer === void 0) {
                  rawTransformer = null;
                }
                var writableStrategy = convertQueuingStrategy(rawWritableStrategy, "Second parameter");
                var readableStrategy = convertQueuingStrategy(rawReadableStrategy, "Third parameter");
                var transformer = convertTransformer(rawTransformer, "First parameter");
                if (transformer.readableType !== void 0) {
                  throw new RangeError("Invalid readableType specified");
                }
                if (transformer.writableType !== void 0) {
                  throw new RangeError("Invalid writableType specified");
                }
                var readableHighWaterMark = ExtractHighWaterMark(readableStrategy, 0);
                var readableSizeAlgorithm = ExtractSizeAlgorithm(readableStrategy);
                var writableHighWaterMark = ExtractHighWaterMark(writableStrategy, 1);
                var writableSizeAlgorithm = ExtractSizeAlgorithm(writableStrategy);
                var startPromise_resolve;
                var startPromise = newPromise(function(resolve) {
                  startPromise_resolve = resolve;
                });
                InitializeTransformStream(this, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
                SetUpTransformStreamDefaultControllerFromTransformer(this, transformer);
                if (transformer.start !== void 0) {
                  startPromise_resolve(transformer.start(this._transformStreamController));
                } else {
                  startPromise_resolve(void 0);
                }
              }
              Object.defineProperty(TransformStream2.prototype, "readable", {
                get: function() {
                  if (!IsTransformStream(this)) {
                    throw streamBrandCheckException("readable");
                  }
                  return this._readable;
                },
                enumerable: false,
                configurable: true
              });
              Object.defineProperty(TransformStream2.prototype, "writable", {
                get: function() {
                  if (!IsTransformStream(this)) {
                    throw streamBrandCheckException("writable");
                  }
                  return this._writable;
                },
                enumerable: false,
                configurable: true
              });
              return TransformStream2;
            }();
            Object.defineProperties(TransformStream.prototype, {
              readable: { enumerable: true },
              writable: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(TransformStream.prototype, SymbolPolyfill.toStringTag, {
                value: "TransformStream",
                configurable: true
              });
            }
            function InitializeTransformStream(stream, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm) {
              function startAlgorithm() {
                return startPromise;
              }
              function writeAlgorithm(chunk) {
                return TransformStreamDefaultSinkWriteAlgorithm(stream, chunk);
              }
              function abortAlgorithm(reason) {
                return TransformStreamDefaultSinkAbortAlgorithm(stream, reason);
              }
              function closeAlgorithm() {
                return TransformStreamDefaultSinkCloseAlgorithm(stream);
              }
              stream._writable = CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, writableHighWaterMark, writableSizeAlgorithm);
              function pullAlgorithm() {
                return TransformStreamDefaultSourcePullAlgorithm(stream);
              }
              function cancelAlgorithm(reason) {
                TransformStreamErrorWritableAndUnblockWrite(stream, reason);
                return promiseResolvedWith(void 0);
              }
              stream._readable = CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
              stream._backpressure = void 0;
              stream._backpressureChangePromise = void 0;
              stream._backpressureChangePromise_resolve = void 0;
              TransformStreamSetBackpressure(stream, true);
              stream._transformStreamController = void 0;
            }
            function IsTransformStream(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_transformStreamController")) {
                return false;
              }
              return x2 instanceof TransformStream;
            }
            function TransformStreamError(stream, e2) {
              ReadableStreamDefaultControllerError(stream._readable._readableStreamController, e2);
              TransformStreamErrorWritableAndUnblockWrite(stream, e2);
            }
            function TransformStreamErrorWritableAndUnblockWrite(stream, e2) {
              TransformStreamDefaultControllerClearAlgorithms(stream._transformStreamController);
              WritableStreamDefaultControllerErrorIfNeeded(stream._writable._writableStreamController, e2);
              if (stream._backpressure) {
                TransformStreamSetBackpressure(stream, false);
              }
            }
            function TransformStreamSetBackpressure(stream, backpressure) {
              if (stream._backpressureChangePromise !== void 0) {
                stream._backpressureChangePromise_resolve();
              }
              stream._backpressureChangePromise = newPromise(function(resolve) {
                stream._backpressureChangePromise_resolve = resolve;
              });
              stream._backpressure = backpressure;
            }
            var TransformStreamDefaultController = function() {
              function TransformStreamDefaultController2() {
                throw new TypeError("Illegal constructor");
              }
              Object.defineProperty(TransformStreamDefaultController2.prototype, "desiredSize", {
                get: function() {
                  if (!IsTransformStreamDefaultController(this)) {
                    throw defaultControllerBrandCheckException("desiredSize");
                  }
                  var readableController = this._controlledTransformStream._readable._readableStreamController;
                  return ReadableStreamDefaultControllerGetDesiredSize(readableController);
                },
                enumerable: false,
                configurable: true
              });
              TransformStreamDefaultController2.prototype.enqueue = function(chunk) {
                if (chunk === void 0) {
                  chunk = void 0;
                }
                if (!IsTransformStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException("enqueue");
                }
                TransformStreamDefaultControllerEnqueue(this, chunk);
              };
              TransformStreamDefaultController2.prototype.error = function(reason) {
                if (reason === void 0) {
                  reason = void 0;
                }
                if (!IsTransformStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException("error");
                }
                TransformStreamDefaultControllerError(this, reason);
              };
              TransformStreamDefaultController2.prototype.terminate = function() {
                if (!IsTransformStreamDefaultController(this)) {
                  throw defaultControllerBrandCheckException("terminate");
                }
                TransformStreamDefaultControllerTerminate(this);
              };
              return TransformStreamDefaultController2;
            }();
            Object.defineProperties(TransformStreamDefaultController.prototype, {
              enqueue: { enumerable: true },
              error: { enumerable: true },
              terminate: { enumerable: true },
              desiredSize: { enumerable: true }
            });
            if (typeof SymbolPolyfill.toStringTag === "symbol") {
              Object.defineProperty(TransformStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                value: "TransformStreamDefaultController",
                configurable: true
              });
            }
            function IsTransformStreamDefaultController(x2) {
              if (!typeIsObject(x2)) {
                return false;
              }
              if (!Object.prototype.hasOwnProperty.call(x2, "_controlledTransformStream")) {
                return false;
              }
              return x2 instanceof TransformStreamDefaultController;
            }
            function SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm) {
              controller._controlledTransformStream = stream;
              stream._transformStreamController = controller;
              controller._transformAlgorithm = transformAlgorithm;
              controller._flushAlgorithm = flushAlgorithm;
            }
            function SetUpTransformStreamDefaultControllerFromTransformer(stream, transformer) {
              var controller = Object.create(TransformStreamDefaultController.prototype);
              var transformAlgorithm = function(chunk) {
                try {
                  TransformStreamDefaultControllerEnqueue(controller, chunk);
                  return promiseResolvedWith(void 0);
                } catch (transformResultE) {
                  return promiseRejectedWith(transformResultE);
                }
              };
              var flushAlgorithm = function() {
                return promiseResolvedWith(void 0);
              };
              if (transformer.transform !== void 0) {
                transformAlgorithm = function(chunk) {
                  return transformer.transform(chunk, controller);
                };
              }
              if (transformer.flush !== void 0) {
                flushAlgorithm = function() {
                  return transformer.flush(controller);
                };
              }
              SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm);
            }
            function TransformStreamDefaultControllerClearAlgorithms(controller) {
              controller._transformAlgorithm = void 0;
              controller._flushAlgorithm = void 0;
            }
            function TransformStreamDefaultControllerEnqueue(controller, chunk) {
              var stream = controller._controlledTransformStream;
              var readableController = stream._readable._readableStreamController;
              if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController)) {
                throw new TypeError("Readable side is not in a state that permits enqueue");
              }
              try {
                ReadableStreamDefaultControllerEnqueue(readableController, chunk);
              } catch (e2) {
                TransformStreamErrorWritableAndUnblockWrite(stream, e2);
                throw stream._readable._storedError;
              }
              var backpressure = ReadableStreamDefaultControllerHasBackpressure(readableController);
              if (backpressure !== stream._backpressure) {
                TransformStreamSetBackpressure(stream, true);
              }
            }
            function TransformStreamDefaultControllerError(controller, e2) {
              TransformStreamError(controller._controlledTransformStream, e2);
            }
            function TransformStreamDefaultControllerPerformTransform(controller, chunk) {
              var transformPromise = controller._transformAlgorithm(chunk);
              return transformPromiseWith(transformPromise, void 0, function(r2) {
                TransformStreamError(controller._controlledTransformStream, r2);
                throw r2;
              });
            }
            function TransformStreamDefaultControllerTerminate(controller) {
              var stream = controller._controlledTransformStream;
              var readableController = stream._readable._readableStreamController;
              ReadableStreamDefaultControllerClose(readableController);
              var error3 = new TypeError("TransformStream terminated");
              TransformStreamErrorWritableAndUnblockWrite(stream, error3);
            }
            function TransformStreamDefaultSinkWriteAlgorithm(stream, chunk) {
              var controller = stream._transformStreamController;
              if (stream._backpressure) {
                var backpressureChangePromise = stream._backpressureChangePromise;
                return transformPromiseWith(backpressureChangePromise, function() {
                  var writable = stream._writable;
                  var state2 = writable._state;
                  if (state2 === "erroring") {
                    throw writable._storedError;
                  }
                  return TransformStreamDefaultControllerPerformTransform(controller, chunk);
                });
              }
              return TransformStreamDefaultControllerPerformTransform(controller, chunk);
            }
            function TransformStreamDefaultSinkAbortAlgorithm(stream, reason) {
              TransformStreamError(stream, reason);
              return promiseResolvedWith(void 0);
            }
            function TransformStreamDefaultSinkCloseAlgorithm(stream) {
              var readable = stream._readable;
              var controller = stream._transformStreamController;
              var flushPromise = controller._flushAlgorithm();
              TransformStreamDefaultControllerClearAlgorithms(controller);
              return transformPromiseWith(flushPromise, function() {
                if (readable._state === "errored") {
                  throw readable._storedError;
                }
                ReadableStreamDefaultControllerClose(readable._readableStreamController);
              }, function(r2) {
                TransformStreamError(stream, r2);
                throw readable._storedError;
              });
            }
            function TransformStreamDefaultSourcePullAlgorithm(stream) {
              TransformStreamSetBackpressure(stream, false);
              return stream._backpressureChangePromise;
            }
            function defaultControllerBrandCheckException(name) {
              return new TypeError("TransformStreamDefaultController.prototype." + name + " can only be used on a TransformStreamDefaultController");
            }
            function streamBrandCheckException(name) {
              return new TypeError("TransformStream.prototype." + name + " can only be used on a TransformStream");
            }
            exports3.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy;
            exports3.CountQueuingStrategy = CountQueuingStrategy;
            exports3.ReadableByteStreamController = ReadableByteStreamController;
            exports3.ReadableStream = ReadableStream2;
            exports3.ReadableStreamBYOBReader = ReadableStreamBYOBReader;
            exports3.ReadableStreamBYOBRequest = ReadableStreamBYOBRequest;
            exports3.ReadableStreamDefaultController = ReadableStreamDefaultController;
            exports3.ReadableStreamDefaultReader = ReadableStreamDefaultReader;
            exports3.TransformStream = TransformStream;
            exports3.TransformStreamDefaultController = TransformStreamDefaultController;
            exports3.WritableStream = WritableStream;
            exports3.WritableStreamDefaultController = WritableStreamDefaultController;
            exports3.WritableStreamDefaultWriter = WritableStreamDefaultWriter;
            Object.defineProperty(exports3, "__esModule", { value: true });
          });
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.BaseStandardFontDataFactory = exports2.BaseSVGFactory = exports2.BaseCanvasFactory = exports2.BaseCMapReaderFactory = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var BaseCanvasFactory = /* @__PURE__ */ function() {
            function BaseCanvasFactory2() {
              _classCallCheck2(this, BaseCanvasFactory2);
              if (this.constructor === BaseCanvasFactory2) {
                (0, _util2.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
            }
            _createClass2(BaseCanvasFactory2, [{
              key: "create",
              value: function create3(width2, height2) {
                if (width2 <= 0 || height2 <= 0) {
                  throw new Error("Invalid canvas size");
                }
                var canvas = this._createCanvas(width2, height2);
                return {
                  canvas,
                  context: canvas.getContext("2d")
                };
              }
            }, {
              key: "reset",
              value: function reset(canvasAndContext, width2, height2) {
                if (!canvasAndContext.canvas) {
                  throw new Error("Canvas is not specified");
                }
                if (width2 <= 0 || height2 <= 0) {
                  throw new Error("Invalid canvas size");
                }
                canvasAndContext.canvas.width = width2;
                canvasAndContext.canvas.height = height2;
              }
            }, {
              key: "destroy",
              value: function destroy(canvasAndContext) {
                if (!canvasAndContext.canvas) {
                  throw new Error("Canvas is not specified");
                }
                canvasAndContext.canvas.width = 0;
                canvasAndContext.canvas.height = 0;
                canvasAndContext.canvas = null;
                canvasAndContext.context = null;
              }
            }, {
              key: "_createCanvas",
              value: function _createCanvas(width2, height2) {
                (0, _util2.unreachable)("Abstract method `_createCanvas` called.");
              }
            }]);
            return BaseCanvasFactory2;
          }();
          exports2.BaseCanvasFactory = BaseCanvasFactory;
          var BaseCMapReaderFactory = /* @__PURE__ */ function() {
            function BaseCMapReaderFactory2(_ref) {
              var _ref$baseUrl = _ref.baseUrl, baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl, _ref$isCompressed = _ref.isCompressed, isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed;
              _classCallCheck2(this, BaseCMapReaderFactory2);
              if (this.constructor === BaseCMapReaderFactory2) {
                (0, _util2.unreachable)("Cannot initialize BaseCMapReaderFactory.");
              }
              this.baseUrl = baseUrl;
              this.isCompressed = isCompressed;
            }
            _createClass2(BaseCMapReaderFactory2, [{
              key: "fetch",
              value: function() {
                var _fetch = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee(_ref2) {
                  var _this = this;
                  var name, url, compressionType;
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          name = _ref2.name;
                          if (this.baseUrl) {
                            _context.next = 3;
                            break;
                          }
                          throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        case 3:
                          if (name) {
                            _context.next = 5;
                            break;
                          }
                          throw new Error("CMap name must be specified.");
                        case 5:
                          url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                          compressionType = this.isCompressed ? _util2.CMapCompressionType.BINARY : _util2.CMapCompressionType.NONE;
                          return _context.abrupt("return", this._fetchData(url, compressionType)["catch"](function(reason) {
                            throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "", "CMap at: ").concat(url));
                          }));
                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function fetch2(_x) {
                  return _fetch.apply(this, arguments);
                }
                return fetch2;
              }()
            }, {
              key: "_fetchData",
              value: function _fetchData(url, compressionType) {
                (0, _util2.unreachable)("Abstract method `_fetchData` called.");
              }
            }]);
            return BaseCMapReaderFactory2;
          }();
          exports2.BaseCMapReaderFactory = BaseCMapReaderFactory;
          var BaseStandardFontDataFactory = /* @__PURE__ */ function() {
            function BaseStandardFontDataFactory2(_ref3) {
              var _ref3$baseUrl = _ref3.baseUrl, baseUrl = _ref3$baseUrl === void 0 ? null : _ref3$baseUrl;
              _classCallCheck2(this, BaseStandardFontDataFactory2);
              if (this.constructor === BaseStandardFontDataFactory2) {
                (0, _util2.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
              }
              this.baseUrl = baseUrl;
            }
            _createClass2(BaseStandardFontDataFactory2, [{
              key: "fetch",
              value: function() {
                var _fetch2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee2(_ref4) {
                  var filename, url;
                  return _regenerator2["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          filename = _ref4.filename;
                          if (this.baseUrl) {
                            _context2.next = 3;
                            break;
                          }
                          throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        case 3:
                          if (filename) {
                            _context2.next = 5;
                            break;
                          }
                          throw new Error("Font filename must be specified.");
                        case 5:
                          url = "".concat(this.baseUrl).concat(filename);
                          return _context2.abrupt("return", this._fetchData(url)["catch"](function(reason) {
                            throw new Error("Unable to load font data at: ".concat(url));
                          }));
                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                function fetch2(_x2) {
                  return _fetch2.apply(this, arguments);
                }
                return fetch2;
              }()
            }, {
              key: "_fetchData",
              value: function _fetchData(url) {
                (0, _util2.unreachable)("Abstract method `_fetchData` called.");
              }
            }]);
            return BaseStandardFontDataFactory2;
          }();
          exports2.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
          var BaseSVGFactory = /* @__PURE__ */ function() {
            function BaseSVGFactory2() {
              _classCallCheck2(this, BaseSVGFactory2);
              if (this.constructor === BaseSVGFactory2) {
                (0, _util2.unreachable)("Cannot initialize BaseSVGFactory.");
              }
            }
            _createClass2(BaseSVGFactory2, [{
              key: "create",
              value: function create3(width2, height2) {
                if (width2 <= 0 || height2 <= 0) {
                  throw new Error("Invalid SVG dimensions");
                }
                var svg = this._createSVG("svg:svg");
                svg.setAttribute("version", "1.1");
                svg.setAttribute("width", "".concat(width2, "px"));
                svg.setAttribute("height", "".concat(height2, "px"));
                svg.setAttribute("preserveAspectRatio", "none");
                svg.setAttribute("viewBox", "0 0 ".concat(width2, " ").concat(height2));
                return svg;
              }
            }, {
              key: "createElement",
              value: function createElement2(type) {
                if (typeof type !== "string") {
                  throw new Error("Invalid SVG element type");
                }
                return this._createSVG(type);
              }
            }, {
              key: "_createSVG",
              value: function _createSVG(type) {
                (0, _util2.unreachable)("Abstract method `_createSVG` called.");
              }
            }]);
            return BaseSVGFactory2;
          }();
          exports2.BaseSVGFactory = BaseSVGFactory;
        },
        (__unused_webpack_module, exports, __w_pdfjs_require__) => {
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.build = exports.RenderTask = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
          exports.getDocument = getDocument;
          exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
          exports.version = void 0;
          var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
          var _util = __w_pdfjs_require__(4);
          var _display_utils = __w_pdfjs_require__(1);
          var _font_loader = __w_pdfjs_require__(137);
          var _node_utils = __w_pdfjs_require__(138);
          var _annotation_storage = __w_pdfjs_require__(139);
          var _canvas = __w_pdfjs_require__(140);
          var _worker_options = __w_pdfjs_require__(142);
          var _is_node = __w_pdfjs_require__(6);
          var _message_handler = __w_pdfjs_require__(143);
          var _metadata = __w_pdfjs_require__(144);
          var _optional_content_config = __w_pdfjs_require__(145);
          var _transport_stream = __w_pdfjs_require__(146);
          var _xfa_text = __w_pdfjs_require__(147);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function _classPrivateFieldInitSpec(obj, privateMap, value) {
            _checkPrivateRedeclaration(obj, privateMap);
            privateMap.set(obj, value);
          }
          function _checkPrivateRedeclaration(obj, privateCollection) {
            if (privateCollection.has(obj)) {
              throw new TypeError("Cannot initialize the same private elements twice on an object");
            }
          }
          function _classPrivateFieldSet(receiver, privateMap, value) {
            var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
            _classApplyDescriptorSet(receiver, descriptor, value);
            return value;
          }
          function _classApplyDescriptorSet(receiver, descriptor, value) {
            if (descriptor.set) {
              descriptor.set.call(receiver, value);
            } else {
              if (!descriptor.writable) {
                throw new TypeError("attempted to set read only private field");
              }
              descriptor.value = value;
            }
          }
          function _classPrivateFieldGet(receiver, privateMap) {
            var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
            return _classApplyDescriptorGet(receiver, descriptor);
          }
          function _classExtractFieldDescriptor(receiver, privateMap, action) {
            if (!privateMap.has(receiver)) {
              throw new TypeError("attempted to " + action + " private field on non-instance");
            }
            return privateMap.get(receiver);
          }
          function _classApplyDescriptorGet(receiver, descriptor) {
            if (descriptor.get) {
              return descriptor.get.call(receiver);
            }
            return descriptor.value;
          }
          function _toConsumableArray(arr2) {
            return _arrayWithoutHoles(arr2) || _iterableToArray(arr2) || _unsupportedIterableToArray(arr2) || _nonIterableSpread();
          }
          function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArray(iter) {
            if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
              return Array.from(iter);
          }
          function _arrayWithoutHoles(arr2) {
            if (Array.isArray(arr2))
              return _arrayLikeToArray(arr2);
          }
          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e3) {
              didErr = true;
              err = _e3;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _classCallCheck(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _slicedToArray(arr2, i2) {
            return _arrayWithHoles(arr2) || _iterableToArrayLimit(arr2, i2) || _unsupportedIterableToArray(arr2, i2) || _nonIterableRest();
          }
          function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _unsupportedIterableToArray(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray(o, minLen);
          }
          function _arrayLikeToArray(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _iterableToArrayLimit(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _typeof(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof2(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof = function _typeof2(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof(obj);
          }
          var DEFAULT_RANGE_CHUNK_SIZE = 65536;
          var RENDERING_CANCELLED_TIMEOUT = 100;
          var DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
          exports.DefaultCanvasFactory = DefaultCanvasFactory;
          var DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
          exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
          var DefaultStandardFontDataFactory = _is_node.isNodeJS ? _node_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
          exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
          var createPDFNetworkStream;
          function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
            createPDFNetworkStream = pdfNetworkStreamFactory;
          }
          function getDocument(src2) {
            var task = new PDFDocumentLoadingTask();
            var source2;
            if (typeof src2 === "string" || src2 instanceof URL) {
              source2 = {
                url: src2
              };
            } else if ((0, _util.isArrayBuffer)(src2)) {
              source2 = {
                data: src2
              };
            } else if (src2 instanceof PDFDataRangeTransport) {
              source2 = {
                range: src2
              };
            } else {
              if (_typeof(src2) !== "object") {
                throw new Error("Invalid parameter in getDocument, need either string, URL, Uint8Array, or parameter object.");
              }
              if (!src2.url && !src2.data && !src2.range) {
                throw new Error("Invalid parameter object: need either .data, .range or .url");
              }
              source2 = src2;
            }
            var params = /* @__PURE__ */ Object.create(null);
            var rangeTransport = null, worker2 = null;
            for (var key in source2) {
              var value = source2[key];
              switch (key) {
                case "url":
                  if (typeof window !== "undefined") {
                    try {
                      params[key] = new URL(value, window.location).href;
                      continue;
                    } catch (ex) {
                      (0, _util.warn)('Cannot create valid URL: "'.concat(ex, '".'));
                    }
                  } else if (typeof value === "string" || value instanceof URL) {
                    params[key] = value.toString();
                    continue;
                  }
                  throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                case "range":
                  rangeTransport = value;
                  continue;
                case "worker":
                  worker2 = value;
                  continue;
                case "data":
                  if (_is_node.isNodeJS && typeof Buffer !== "undefined" && value instanceof Buffer) {
                    params[key] = new Uint8Array(value);
                  } else if (value instanceof Uint8Array) {
                    break;
                  } else if (typeof value === "string") {
                    params[key] = (0, _util.stringToBytes)(value);
                  } else if (_typeof(value) === "object" && value !== null && !isNaN(value.length)) {
                    params[key] = new Uint8Array(value);
                  } else if ((0, _util.isArrayBuffer)(value)) {
                    params[key] = new Uint8Array(value);
                  } else {
                    throw new Error("Invalid PDF binary data: either typed array, string, or array-like object is expected in the data property.");
                  }
                  continue;
              }
              params[key] = value;
            }
            params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
            params.CMapReaderFactory = params.CMapReaderFactory || DefaultCMapReaderFactory;
            params.StandardFontDataFactory = params.StandardFontDataFactory || DefaultStandardFontDataFactory;
            params.ignoreErrors = params.stopAtErrors !== true;
            params.fontExtraProperties = params.fontExtraProperties === true;
            params.pdfBug = params.pdfBug === true;
            params.enableXfa = params.enableXfa === true;
            if (typeof params.docBaseUrl !== "string" || (0, _display_utils.isDataScheme)(params.docBaseUrl)) {
              params.docBaseUrl = null;
            }
            if (!Number.isInteger(params.maxImageSize)) {
              params.maxImageSize = -1;
            }
            if (typeof params.useWorkerFetch !== "boolean") {
              params.useWorkerFetch = params.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && params.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory;
            }
            if (typeof params.isEvalSupported !== "boolean") {
              params.isEvalSupported = true;
            }
            if (typeof params.disableFontFace !== "boolean") {
              params.disableFontFace = _is_node.isNodeJS;
            }
            if (typeof params.useSystemFonts !== "boolean") {
              params.useSystemFonts = !_is_node.isNodeJS && !params.disableFontFace;
            }
            if (typeof params.ownerDocument === "undefined") {
              params.ownerDocument = globalThis.document;
            }
            if (typeof params.disableRange !== "boolean") {
              params.disableRange = false;
            }
            if (typeof params.disableStream !== "boolean") {
              params.disableStream = false;
            }
            if (typeof params.disableAutoFetch !== "boolean") {
              params.disableAutoFetch = false;
            }
            (0, _util.setVerbosityLevel)(params.verbosity);
            if (!worker2) {
              var workerParams = {
                verbosity: params.verbosity,
                port: _worker_options.GlobalWorkerOptions.workerPort
              };
              worker2 = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
              task._worker = worker2;
            }
            var docId = task.docId;
            worker2.promise.then(function() {
              if (task.destroyed) {
                throw new Error("Loading aborted");
              }
              var workerIdPromise = _fetchDocument(worker2, params, rangeTransport, docId);
              var networkStreamPromise = new Promise(function(resolve) {
                var networkStream;
                if (rangeTransport) {
                  networkStream = new _transport_stream.PDFDataTransportStream({
                    length: params.length,
                    initialData: params.initialData,
                    progressiveDone: params.progressiveDone,
                    contentDispositionFilename: params.contentDispositionFilename,
                    disableRange: params.disableRange,
                    disableStream: params.disableStream
                  }, rangeTransport);
                } else if (!params.data) {
                  networkStream = createPDFNetworkStream({
                    url: params.url,
                    length: params.length,
                    httpHeaders: params.httpHeaders,
                    withCredentials: params.withCredentials,
                    rangeChunkSize: params.rangeChunkSize,
                    disableRange: params.disableRange,
                    disableStream: params.disableStream
                  });
                }
                resolve(networkStream);
              });
              return Promise.all([workerIdPromise, networkStreamPromise]).then(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), workerId = _ref2[0], networkStream = _ref2[1];
                if (task.destroyed) {
                  throw new Error("Loading aborted");
                }
                var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker2.port);
                var transport = new WorkerTransport(messageHandler, task, networkStream, params);
                task._transport = transport;
                messageHandler.send("Ready", null);
              });
            })["catch"](task._capability.reject);
            return task;
          }
          function _fetchDocument(_x, _x2, _x3, _x4) {
            return _fetchDocument2.apply(this, arguments);
          }
          function _fetchDocument2() {
            _fetchDocument2 = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee7(worker2, source2, pdfDataRangeTransport, docId) {
              var workerId;
              return _regenerator["default"].wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      if (!worker2.destroyed) {
                        _context7.next = 2;
                        break;
                      }
                      throw new Error("Worker was destroyed");
                    case 2:
                      if (pdfDataRangeTransport) {
                        source2.length = pdfDataRangeTransport.length;
                        source2.initialData = pdfDataRangeTransport.initialData;
                        source2.progressiveDone = pdfDataRangeTransport.progressiveDone;
                        source2.contentDispositionFilename = pdfDataRangeTransport.contentDispositionFilename;
                      }
                      _context7.next = 5;
                      return worker2.messageHandler.sendWithPromise("GetDocRequest", {
                        docId,
                        apiVersion: "2.12.313",
                        source: {
                          data: source2.data,
                          url: source2.url,
                          password: source2.password,
                          disableAutoFetch: source2.disableAutoFetch,
                          rangeChunkSize: source2.rangeChunkSize,
                          length: source2.length
                        },
                        maxImageSize: source2.maxImageSize,
                        disableFontFace: source2.disableFontFace,
                        docBaseUrl: source2.docBaseUrl,
                        ignoreErrors: source2.ignoreErrors,
                        isEvalSupported: source2.isEvalSupported,
                        fontExtraProperties: source2.fontExtraProperties,
                        enableXfa: source2.enableXfa,
                        useSystemFonts: source2.useSystemFonts,
                        cMapUrl: source2.useWorkerFetch ? source2.cMapUrl : null,
                        standardFontDataUrl: source2.useWorkerFetch ? source2.standardFontDataUrl : null
                      });
                    case 5:
                      workerId = _context7.sent;
                      if (!worker2.destroyed) {
                        _context7.next = 8;
                        break;
                      }
                      throw new Error("Worker was destroyed");
                    case 8:
                      return _context7.abrupt("return", workerId);
                    case 9:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }));
            return _fetchDocument2.apply(this, arguments);
          }
          var PDFDocumentLoadingTask = /* @__PURE__ */ function() {
            function PDFDocumentLoadingTask2() {
              _classCallCheck(this, PDFDocumentLoadingTask2);
              this._capability = (0, _util.createPromiseCapability)();
              this._transport = null;
              this._worker = null;
              this.docId = "d".concat(PDFDocumentLoadingTask2.idCounters.doc++);
              this.destroyed = false;
              this.onPassword = null;
              this.onProgress = null;
              this.onUnsupportedFeature = null;
            }
            _createClass(PDFDocumentLoadingTask2, [{
              key: "promise",
              get: function get2() {
                return this._capability.promise;
              }
            }, {
              key: "destroy",
              value: function() {
                var _destroy = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee() {
                  var _this$_transport;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          this.destroyed = true;
                          _context.next = 3;
                          return (_this$_transport = this._transport) === null || _this$_transport === void 0 ? void 0 : _this$_transport.destroy();
                        case 3:
                          this._transport = null;
                          if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                          }
                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function destroy() {
                  return _destroy.apply(this, arguments);
                }
                return destroy;
              }()
            }], [{
              key: "idCounters",
              get: function get2() {
                return (0, _util.shadow)(this, "idCounters", {
                  doc: 0
                });
              }
            }]);
            return PDFDocumentLoadingTask2;
          }();
          exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
          var PDFDataRangeTransport = /* @__PURE__ */ function() {
            function PDFDataRangeTransport2(length, initialData) {
              var progressiveDone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
              var contentDispositionFilename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              _classCallCheck(this, PDFDataRangeTransport2);
              this.length = length;
              this.initialData = initialData;
              this.progressiveDone = progressiveDone;
              this.contentDispositionFilename = contentDispositionFilename;
              this._rangeListeners = [];
              this._progressListeners = [];
              this._progressiveReadListeners = [];
              this._progressiveDoneListeners = [];
              this._readyCapability = (0, _util.createPromiseCapability)();
            }
            _createClass(PDFDataRangeTransport2, [{
              key: "addRangeListener",
              value: function addRangeListener(listener) {
                this._rangeListeners.push(listener);
              }
            }, {
              key: "addProgressListener",
              value: function addProgressListener(listener) {
                this._progressListeners.push(listener);
              }
            }, {
              key: "addProgressiveReadListener",
              value: function addProgressiveReadListener(listener) {
                this._progressiveReadListeners.push(listener);
              }
            }, {
              key: "addProgressiveDoneListener",
              value: function addProgressiveDoneListener(listener) {
                this._progressiveDoneListeners.push(listener);
              }
            }, {
              key: "onDataRange",
              value: function onDataRange(begin, chunk) {
                var _iterator = _createForOfIteratorHelper(this._rangeListeners), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var listener = _step.value;
                    listener(begin, chunk);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }, {
              key: "onDataProgress",
              value: function onDataProgress(loaded, total) {
                var _this = this;
                this._readyCapability.promise.then(function() {
                  var _iterator2 = _createForOfIteratorHelper(_this._progressListeners), _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                      var listener = _step2.value;
                      listener(loaded, total);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                });
              }
            }, {
              key: "onDataProgressiveRead",
              value: function onDataProgressiveRead(chunk) {
                var _this2 = this;
                this._readyCapability.promise.then(function() {
                  var _iterator3 = _createForOfIteratorHelper(_this2._progressiveReadListeners), _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                      var listener = _step3.value;
                      listener(chunk);
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                });
              }
            }, {
              key: "onDataProgressiveDone",
              value: function onDataProgressiveDone() {
                var _this3 = this;
                this._readyCapability.promise.then(function() {
                  var _iterator4 = _createForOfIteratorHelper(_this3._progressiveDoneListeners), _step4;
                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                      var listener = _step4.value;
                      listener();
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                });
              }
            }, {
              key: "transportReady",
              value: function transportReady() {
                this._readyCapability.resolve();
              }
            }, {
              key: "requestDataRange",
              value: function requestDataRange(begin, end) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
            }, {
              key: "abort",
              value: function abort() {
              }
            }]);
            return PDFDataRangeTransport2;
          }();
          exports.PDFDataRangeTransport = PDFDataRangeTransport;
          var PDFDocumentProxy = /* @__PURE__ */ function() {
            function PDFDocumentProxy2(pdfInfo, transport) {
              var _this4 = this;
              _classCallCheck(this, PDFDocumentProxy2);
              this._pdfInfo = pdfInfo;
              this._transport = transport;
              Object.defineProperty(this, "fingerprint", {
                get: function get2() {
                  (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead.");
                  return this.fingerprints[0];
                }
              });
              Object.defineProperty(this, "getStats", {
                value: function() {
                  var _value = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee2() {
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            (0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead.");
                            return _context2.abrupt("return", _this4.stats || {
                              streamTypes: {},
                              fontTypes: {}
                            });
                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                  function value() {
                    return _value.apply(this, arguments);
                  }
                  return value;
                }()
              });
            }
            _createClass(PDFDocumentProxy2, [{
              key: "annotationStorage",
              get: function get2() {
                return this._transport.annotationStorage;
              }
            }, {
              key: "numPages",
              get: function get2() {
                return this._pdfInfo.numPages;
              }
            }, {
              key: "fingerprints",
              get: function get2() {
                return this._pdfInfo.fingerprints;
              }
            }, {
              key: "stats",
              get: function get2() {
                return this._transport.stats;
              }
            }, {
              key: "isPureXfa",
              get: function get2() {
                return !!this._transport._htmlForXfa;
              }
            }, {
              key: "allXfaHtml",
              get: function get2() {
                return this._transport._htmlForXfa;
              }
            }, {
              key: "getPage",
              value: function getPage(pageNumber) {
                return this._transport.getPage(pageNumber);
              }
            }, {
              key: "getPageIndex",
              value: function getPageIndex(ref) {
                return this._transport.getPageIndex(ref);
              }
            }, {
              key: "getDestinations",
              value: function getDestinations() {
                return this._transport.getDestinations();
              }
            }, {
              key: "getDestination",
              value: function getDestination(id2) {
                return this._transport.getDestination(id2);
              }
            }, {
              key: "getPageLabels",
              value: function getPageLabels() {
                return this._transport.getPageLabels();
              }
            }, {
              key: "getPageLayout",
              value: function getPageLayout() {
                return this._transport.getPageLayout();
              }
            }, {
              key: "getPageMode",
              value: function getPageMode() {
                return this._transport.getPageMode();
              }
            }, {
              key: "getViewerPreferences",
              value: function getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
            }, {
              key: "getOpenAction",
              value: function getOpenAction() {
                return this._transport.getOpenAction();
              }
            }, {
              key: "getAttachments",
              value: function getAttachments() {
                return this._transport.getAttachments();
              }
            }, {
              key: "getJavaScript",
              value: function getJavaScript() {
                return this._transport.getJavaScript();
              }
            }, {
              key: "getJSActions",
              value: function getJSActions() {
                return this._transport.getDocJSActions();
              }
            }, {
              key: "getOutline",
              value: function getOutline() {
                return this._transport.getOutline();
              }
            }, {
              key: "getOptionalContentConfig",
              value: function getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
            }, {
              key: "getPermissions",
              value: function getPermissions() {
                return this._transport.getPermissions();
              }
            }, {
              key: "getMetadata",
              value: function getMetadata() {
                return this._transport.getMetadata();
              }
            }, {
              key: "getMarkInfo",
              value: function getMarkInfo() {
                return this._transport.getMarkInfo();
              }
            }, {
              key: "getData",
              value: function getData() {
                return this._transport.getData();
              }
            }, {
              key: "getDownloadInfo",
              value: function getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
            }, {
              key: "cleanup",
              value: function cleanup() {
                var keepLoadedFonts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
              }
            }, {
              key: "destroy",
              value: function destroy() {
                return this.loadingTask.destroy();
              }
            }, {
              key: "loadingParams",
              get: function get2() {
                return this._transport.loadingParams;
              }
            }, {
              key: "loadingTask",
              get: function get2() {
                return this._transport.loadingTask;
              }
            }, {
              key: "saveDocument",
              value: function saveDocument() {
                if (this._transport.annotationStorage.size <= 0) {
                  (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                }
                return this._transport.saveDocument();
              }
            }, {
              key: "getFieldObjects",
              value: function getFieldObjects() {
                return this._transport.getFieldObjects();
              }
            }, {
              key: "hasJSActions",
              value: function hasJSActions() {
                return this._transport.hasJSActions();
              }
            }, {
              key: "getCalculationOrderIds",
              value: function getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }]);
            return PDFDocumentProxy2;
          }();
          exports.PDFDocumentProxy = PDFDocumentProxy;
          var PDFPageProxy = /* @__PURE__ */ function() {
            function PDFPageProxy2(pageIndex, pageInfo, transport, ownerDocument) {
              var pdfBug = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
              _classCallCheck(this, PDFPageProxy2);
              this._pageIndex = pageIndex;
              this._pageInfo = pageInfo;
              this._ownerDocument = ownerDocument;
              this._transport = transport;
              this._stats = pdfBug ? new _display_utils.StatTimer() : null;
              this._pdfBug = pdfBug;
              this.commonObjs = transport.commonObjs;
              this.objs = new PDFObjects();
              this.cleanupAfterRender = false;
              this.pendingCleanup = false;
              this._intentStates = /* @__PURE__ */ new Map();
              this._annotationPromises = /* @__PURE__ */ new Map();
              this.destroyed = false;
            }
            _createClass(PDFPageProxy2, [{
              key: "pageNumber",
              get: function get2() {
                return this._pageIndex + 1;
              }
            }, {
              key: "rotate",
              get: function get2() {
                return this._pageInfo.rotate;
              }
            }, {
              key: "ref",
              get: function get2() {
                return this._pageInfo.ref;
              }
            }, {
              key: "userUnit",
              get: function get2() {
                return this._pageInfo.userUnit;
              }
            }, {
              key: "view",
              get: function get2() {
                return this._pageInfo.view;
              }
            }, {
              key: "getViewport",
              value: function getViewport() {
                var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, scale2 = _ref3.scale, _ref3$rotation = _ref3.rotation, rotation = _ref3$rotation === void 0 ? this.rotate : _ref3$rotation, _ref3$offsetX = _ref3.offsetX, offsetX = _ref3$offsetX === void 0 ? 0 : _ref3$offsetX, _ref3$offsetY = _ref3.offsetY, offsetY = _ref3$offsetY === void 0 ? 0 : _ref3$offsetY, _ref3$dontFlip = _ref3.dontFlip, dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: scale2,
                  rotation,
                  offsetX,
                  offsetY,
                  dontFlip
                });
              }
            }, {
              key: "getAnnotations",
              value: function getAnnotations() {
                var _ref4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref4$intent = _ref4.intent, intent = _ref4$intent === void 0 ? "display" : _ref4$intent;
                var intentArgs = this._transport.getRenderingIntent(intent);
                var promise = this._annotationPromises.get(intentArgs.cacheKey);
                if (!promise) {
                  promise = this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                  this._annotationPromises.set(intentArgs.cacheKey, promise);
                  promise = promise.then(function(annotations) {
                    var _iterator5 = _createForOfIteratorHelper(annotations), _step5;
                    try {
                      var _loop = function _loop2() {
                        var annotation = _step5.value;
                        if (annotation.titleObj !== void 0) {
                          Object.defineProperty(annotation, "title", {
                            get: function get2() {
                              (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead.");
                              return annotation.titleObj.str;
                            }
                          });
                        }
                        if (annotation.contentsObj !== void 0) {
                          Object.defineProperty(annotation, "contents", {
                            get: function get2() {
                              (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead.");
                              return annotation.contentsObj.str;
                            }
                          });
                        }
                      };
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                        _loop();
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                    return annotations;
                  });
                }
                return promise;
              }
            }, {
              key: "getJSActions",
              value: function getJSActions() {
                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
              }
            }, {
              key: "getXfa",
              value: function() {
                var _getXfa = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee3() {
                  var _this$_transport$_htm;
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", ((_this$_transport$_htm = this._transport._htmlForXfa) === null || _this$_transport$_htm === void 0 ? void 0 : _this$_transport$_htm.children[this._pageIndex]) || null);
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                }));
                function getXfa() {
                  return _getXfa.apply(this, arguments);
                }
                return getXfa;
              }()
            }, {
              key: "render",
              value: function render(_ref5) {
                var _arguments$, _arguments$2, _this5 = this, _intentState;
                var canvasContext = _ref5.canvasContext, viewport = _ref5.viewport, _ref5$intent = _ref5.intent, intent = _ref5$intent === void 0 ? "display" : _ref5$intent, _ref5$annotationMode = _ref5.annotationMode, annotationMode = _ref5$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref5$annotationMode, _ref5$transform = _ref5.transform, transform2 = _ref5$transform === void 0 ? null : _ref5$transform, _ref5$imageLayer = _ref5.imageLayer, imageLayer = _ref5$imageLayer === void 0 ? null : _ref5$imageLayer, _ref5$canvasFactory = _ref5.canvasFactory, canvasFactory = _ref5$canvasFactory === void 0 ? null : _ref5$canvasFactory, _ref5$background = _ref5.background, background = _ref5$background === void 0 ? null : _ref5$background, _ref5$optionalContent = _ref5.optionalContentConfigPromise, optionalContentConfigPromise = _ref5$optionalContent === void 0 ? null : _ref5$optionalContent, _ref5$annotationCanva = _ref5.annotationCanvasMap, annotationCanvasMap = _ref5$annotationCanva === void 0 ? null : _ref5$annotationCanva;
                if (((_arguments$ = arguments[0]) === null || _arguments$ === void 0 ? void 0 : _arguments$.renderInteractiveForms) !== void 0) {
                  (0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead.");
                  if (arguments[0].renderInteractiveForms === true && annotationMode === _util.AnnotationMode.ENABLE) {
                    annotationMode = _util.AnnotationMode.ENABLE_FORMS;
                  }
                }
                if (((_arguments$2 = arguments[0]) === null || _arguments$2 === void 0 ? void 0 : _arguments$2.includeAnnotationStorage) !== void 0) {
                  (0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead.");
                  if (arguments[0].includeAnnotationStorage === true && annotationMode === _util.AnnotationMode.ENABLE) {
                    annotationMode = _util.AnnotationMode.ENABLE_STORAGE;
                  }
                }
                if (this._stats) {
                  this._stats.time("Overall");
                }
                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode);
                this.pendingCleanup = false;
                if (!optionalContentConfigPromise) {
                  optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                }
                var intentState = this._intentStates.get(intentArgs.cacheKey);
                if (!intentState) {
                  intentState = /* @__PURE__ */ Object.create(null);
                  this._intentStates.set(intentArgs.cacheKey, intentState);
                }
                if (intentState.streamReaderCancelTimeout) {
                  clearTimeout(intentState.streamReaderCancelTimeout);
                  intentState.streamReaderCancelTimeout = null;
                }
                var canvasFactoryInstance = canvasFactory || new DefaultCanvasFactory({
                  ownerDocument: this._ownerDocument
                });
                var intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                if (!intentState.displayReadyCapability) {
                  intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
                  intentState.operatorList = {
                    fnArray: [],
                    argsArray: [],
                    lastChunk: false
                  };
                  if (this._stats) {
                    this._stats.time("Page Request");
                  }
                  this._pumpOperatorList(intentArgs);
                }
                var complete = function complete2(error3) {
                  intentState.renderTasks["delete"](internalRenderTask);
                  if (_this5.cleanupAfterRender || intentPrint) {
                    _this5.pendingCleanup = true;
                  }
                  _this5._tryCleanup();
                  if (error3) {
                    internalRenderTask.capability.reject(error3);
                    _this5._abortOperatorList({
                      intentState,
                      reason: error3 instanceof Error ? error3 : new Error(error3)
                    });
                  } else {
                    internalRenderTask.capability.resolve();
                  }
                  if (_this5._stats) {
                    _this5._stats.timeEnd("Rendering");
                    _this5._stats.timeEnd("Overall");
                  }
                };
                var internalRenderTask = new InternalRenderTask({
                  callback: complete,
                  params: {
                    canvasContext,
                    viewport,
                    transform: transform2,
                    imageLayer,
                    background
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap,
                  operatorList: intentState.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: canvasFactoryInstance,
                  useRequestAnimationFrame: !intentPrint,
                  pdfBug: this._pdfBug
                });
                ((_intentState = intentState).renderTasks || (_intentState.renderTasks = /* @__PURE__ */ new Set())).add(internalRenderTask);
                var renderTask = internalRenderTask.task;
                Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(function(_ref6) {
                  var _ref7 = _slicedToArray(_ref6, 2), transparency = _ref7[0], optionalContentConfig = _ref7[1];
                  if (_this5.pendingCleanup) {
                    complete();
                    return;
                  }
                  if (_this5._stats) {
                    _this5._stats.time("Rendering");
                  }
                  internalRenderTask.initializeGraphics({
                    transparency,
                    optionalContentConfig
                  });
                  internalRenderTask.operatorListChanged();
                })["catch"](complete);
                return renderTask;
              }
            }, {
              key: "getOperatorList",
              value: function getOperatorList() {
                var _ref8 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref8$intent = _ref8.intent, intent = _ref8$intent === void 0 ? "display" : _ref8$intent, _ref8$annotationMode = _ref8.annotationMode, annotationMode = _ref8$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref8$annotationMode;
                function operatorListChanged() {
                  if (intentState.operatorList.lastChunk) {
                    intentState.opListReadCapability.resolve(intentState.operatorList);
                    intentState.renderTasks["delete"](opListTask);
                  }
                }
                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, true);
                var intentState = this._intentStates.get(intentArgs.cacheKey);
                if (!intentState) {
                  intentState = /* @__PURE__ */ Object.create(null);
                  this._intentStates.set(intentArgs.cacheKey, intentState);
                }
                var opListTask;
                if (!intentState.opListReadCapability) {
                  var _intentState2;
                  opListTask = /* @__PURE__ */ Object.create(null);
                  opListTask.operatorListChanged = operatorListChanged;
                  intentState.opListReadCapability = (0, _util.createPromiseCapability)();
                  ((_intentState2 = intentState).renderTasks || (_intentState2.renderTasks = /* @__PURE__ */ new Set())).add(opListTask);
                  intentState.operatorList = {
                    fnArray: [],
                    argsArray: [],
                    lastChunk: false
                  };
                  if (this._stats) {
                    this._stats.time("Page Request");
                  }
                  this._pumpOperatorList(intentArgs);
                }
                return intentState.opListReadCapability.promise;
              }
            }, {
              key: "streamTextContent",
              value: function streamTextContent() {
                var _ref9 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref9$normalizeWhites = _ref9.normalizeWhitespace, normalizeWhitespace = _ref9$normalizeWhites === void 0 ? false : _ref9$normalizeWhites, _ref9$disableCombineT = _ref9.disableCombineTextItems, disableCombineTextItems = _ref9$disableCombineT === void 0 ? false : _ref9$disableCombineT, _ref9$includeMarkedCo = _ref9.includeMarkedContent, includeMarkedContent = _ref9$includeMarkedCo === void 0 ? false : _ref9$includeMarkedCo;
                var TEXT_CONTENT_CHUNK_SIZE = 100;
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  normalizeWhitespace: normalizeWhitespace === true,
                  combineTextItems: disableCombineTextItems !== true,
                  includeMarkedContent: includeMarkedContent === true
                }, {
                  highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                  size: function size(textContent) {
                    return textContent.items.length;
                  }
                });
              }
            }, {
              key: "getTextContent",
              value: function getTextContent() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (this._transport._htmlForXfa) {
                  return this.getXfa().then(function(xfa) {
                    return _xfa_text.XfaText.textContent(xfa);
                  });
                }
                var readableStream = this.streamTextContent(params);
                return new Promise(function(resolve, reject) {
                  function pump() {
                    reader.read().then(function(_ref10) {
                      var _textContent$items;
                      var value = _ref10.value, done = _ref10.done;
                      if (done) {
                        resolve(textContent);
                        return;
                      }
                      Object.assign(textContent.styles, value.styles);
                      (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));
                      pump();
                    }, reject);
                  }
                  var reader = readableStream.getReader();
                  var textContent = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  pump();
                });
              }
            }, {
              key: "getStructTree",
              value: function getStructTree() {
                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
              }
            }, {
              key: "_destroy",
              value: function _destroy() {
                this.destroyed = true;
                var waitOn = [];
                var _iterator6 = _createForOfIteratorHelper(this._intentStates.values()), _step6;
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
                    var intentState = _step6.value;
                    this._abortOperatorList({
                      intentState,
                      reason: new Error("Page was destroyed."),
                      force: true
                    });
                    if (intentState.opListReadCapability) {
                      continue;
                    }
                    var _iterator7 = _createForOfIteratorHelper(intentState.renderTasks), _step7;
                    try {
                      for (_iterator7.s(); !(_step7 = _iterator7.n()).done; ) {
                        var internalRenderTask = _step7.value;
                        waitOn.push(internalRenderTask.completed);
                        internalRenderTask.cancel();
                      }
                    } catch (err) {
                      _iterator7.e(err);
                    } finally {
                      _iterator7.f();
                    }
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
                this.objs.clear();
                this._annotationPromises.clear();
                this._jsActionsPromise = null;
                this._structTreePromise = null;
                this.pendingCleanup = false;
                return Promise.all(waitOn);
              }
            }, {
              key: "cleanup",
              value: function cleanup() {
                var resetStats = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.pendingCleanup = true;
                return this._tryCleanup(resetStats);
              }
            }, {
              key: "_tryCleanup",
              value: function _tryCleanup() {
                var resetStats = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.pendingCleanup) {
                  return false;
                }
                var _iterator8 = _createForOfIteratorHelper(this._intentStates.values()), _step8;
                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done; ) {
                    var _step8$value = _step8.value, renderTasks = _step8$value.renderTasks, operatorList = _step8$value.operatorList;
                    if (renderTasks.size > 0 || !operatorList.lastChunk) {
                      return false;
                    }
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
                this._intentStates.clear();
                this.objs.clear();
                this._annotationPromises.clear();
                this._jsActionsPromise = null;
                this._structTreePromise = null;
                if (resetStats && this._stats) {
                  this._stats = new _display_utils.StatTimer();
                }
                this.pendingCleanup = false;
                return true;
              }
            }, {
              key: "_startRenderPage",
              value: function _startRenderPage(transparency, cacheKey) {
                var intentState = this._intentStates.get(cacheKey);
                if (!intentState) {
                  return;
                }
                if (this._stats) {
                  this._stats.timeEnd("Page Request");
                }
                if (intentState.displayReadyCapability) {
                  intentState.displayReadyCapability.resolve(transparency);
                }
              }
            }, {
              key: "_renderPageChunk",
              value: function _renderPageChunk(operatorListChunk, intentState) {
                for (var i2 = 0, ii = operatorListChunk.length; i2 < ii; i2++) {
                  intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i2]);
                  intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i2]);
                }
                intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                var _iterator9 = _createForOfIteratorHelper(intentState.renderTasks), _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done; ) {
                    var internalRenderTask = _step9.value;
                    internalRenderTask.operatorListChanged();
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
                if (operatorListChunk.lastChunk) {
                  this._tryCleanup();
                }
              }
            }, {
              key: "_pumpOperatorList",
              value: function _pumpOperatorList(_ref11) {
                var _this6 = this;
                var renderingIntent = _ref11.renderingIntent, cacheKey = _ref11.cacheKey;
                var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: renderingIntent,
                  cacheKey,
                  annotationStorage: renderingIntent & _util.RenderingIntentFlag.ANNOTATIONS_STORAGE ? this._transport.annotationStorage.serializable : null
                });
                var reader = readableStream.getReader();
                var intentState = this._intentStates.get(cacheKey);
                intentState.streamReader = reader;
                var pump = function pump2() {
                  reader.read().then(function(_ref12) {
                    var value = _ref12.value, done = _ref12.done;
                    if (done) {
                      intentState.streamReader = null;
                      return;
                    }
                    if (_this6._transport.destroyed) {
                      return;
                    }
                    _this6._renderPageChunk(value, intentState);
                    pump2();
                  }, function(reason) {
                    intentState.streamReader = null;
                    if (_this6._transport.destroyed) {
                      return;
                    }
                    if (intentState.operatorList) {
                      intentState.operatorList.lastChunk = true;
                      var _iterator10 = _createForOfIteratorHelper(intentState.renderTasks), _step10;
                      try {
                        for (_iterator10.s(); !(_step10 = _iterator10.n()).done; ) {
                          var internalRenderTask = _step10.value;
                          internalRenderTask.operatorListChanged();
                        }
                      } catch (err) {
                        _iterator10.e(err);
                      } finally {
                        _iterator10.f();
                      }
                      _this6._tryCleanup();
                    }
                    if (intentState.displayReadyCapability) {
                      intentState.displayReadyCapability.reject(reason);
                    } else if (intentState.opListReadCapability) {
                      intentState.opListReadCapability.reject(reason);
                    } else {
                      throw reason;
                    }
                  });
                };
                pump();
              }
            }, {
              key: "_abortOperatorList",
              value: function _abortOperatorList(_ref13) {
                var _this7 = this;
                var intentState = _ref13.intentState, reason = _ref13.reason, _ref13$force = _ref13.force, force = _ref13$force === void 0 ? false : _ref13$force;
                if (!intentState.streamReader) {
                  return;
                }
                if (!force) {
                  if (intentState.renderTasks.size > 0) {
                    return;
                  }
                  if (reason instanceof _display_utils.RenderingCancelledException) {
                    intentState.streamReaderCancelTimeout = setTimeout(function() {
                      _this7._abortOperatorList({
                        intentState,
                        reason,
                        force: true
                      });
                      intentState.streamReaderCancelTimeout = null;
                    }, RENDERING_CANCELLED_TIMEOUT);
                    return;
                  }
                }
                intentState.streamReader.cancel(new _util.AbortException(reason.message))["catch"](function() {
                });
                intentState.streamReader = null;
                if (this._transport.destroyed) {
                  return;
                }
                var _iterator11 = _createForOfIteratorHelper(this._intentStates), _step11;
                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done; ) {
                    var _step11$value = _slicedToArray(_step11.value, 2), curCacheKey = _step11$value[0], curIntentState = _step11$value[1];
                    if (curIntentState === intentState) {
                      this._intentStates["delete"](curCacheKey);
                      break;
                    }
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }
                this.cleanup();
              }
            }, {
              key: "stats",
              get: function get2() {
                return this._stats;
              }
            }]);
            return PDFPageProxy2;
          }();
          exports.PDFPageProxy = PDFPageProxy;
          var LoopbackPort = /* @__PURE__ */ function() {
            function LoopbackPort2() {
              _classCallCheck(this, LoopbackPort2);
              this._listeners = [];
              this._deferred = Promise.resolve();
            }
            _createClass(LoopbackPort2, [{
              key: "postMessage",
              value: function postMessage2(obj, transfers) {
                var _this8 = this;
                function cloneValue(object) {
                  if (globalThis.structuredClone) {
                    return globalThis.structuredClone(object, transfers);
                  }
                  function fallbackCloneValue(value) {
                    if (typeof value === "function" || _typeof(value) === "symbol" || value instanceof URL) {
                      throw new Error("LoopbackPort.postMessage - cannot clone: ".concat(value === null || value === void 0 ? void 0 : value.toString()));
                    }
                    if (_typeof(value) !== "object" || value === null) {
                      return value;
                    }
                    if (cloned.has(value)) {
                      return cloned.get(value);
                    }
                    var buffer2, result2;
                    if ((buffer2 = value.buffer) && (0, _util.isArrayBuffer)(buffer2)) {
                      if (transfers !== null && transfers !== void 0 && transfers.includes(buffer2)) {
                        result2 = new value.constructor(buffer2, value.byteOffset, value.byteLength);
                      } else {
                        result2 = new value.constructor(value);
                      }
                      cloned.set(value, result2);
                      return result2;
                    }
                    if (value instanceof Map) {
                      result2 = /* @__PURE__ */ new Map();
                      cloned.set(value, result2);
                      var _iterator12 = _createForOfIteratorHelper(value), _step12;
                      try {
                        for (_iterator12.s(); !(_step12 = _iterator12.n()).done; ) {
                          var _step12$value = _slicedToArray(_step12.value, 2), key = _step12$value[0], val = _step12$value[1];
                          result2.set(key, fallbackCloneValue(val));
                        }
                      } catch (err) {
                        _iterator12.e(err);
                      } finally {
                        _iterator12.f();
                      }
                      return result2;
                    }
                    if (value instanceof Set) {
                      result2 = /* @__PURE__ */ new Set();
                      cloned.set(value, result2);
                      var _iterator13 = _createForOfIteratorHelper(value), _step13;
                      try {
                        for (_iterator13.s(); !(_step13 = _iterator13.n()).done; ) {
                          var _val = _step13.value;
                          result2.add(fallbackCloneValue(_val));
                        }
                      } catch (err) {
                        _iterator13.e(err);
                      } finally {
                        _iterator13.f();
                      }
                      return result2;
                    }
                    result2 = Array.isArray(value) ? [] : /* @__PURE__ */ Object.create(null);
                    cloned.set(value, result2);
                    for (var i2 in value) {
                      var _value$hasOwnProperty;
                      var desc = void 0, p2 = value;
                      while (!(desc = Object.getOwnPropertyDescriptor(p2, i2))) {
                        p2 = Object.getPrototypeOf(p2);
                      }
                      if (typeof desc.value === "undefined") {
                        continue;
                      }
                      if (typeof desc.value === "function" && !((_value$hasOwnProperty = value.hasOwnProperty) !== null && _value$hasOwnProperty !== void 0 && _value$hasOwnProperty.call(value, i2))) {
                        continue;
                      }
                      result2[i2] = fallbackCloneValue(desc.value);
                    }
                    return result2;
                  }
                  var cloned = /* @__PURE__ */ new WeakMap();
                  return fallbackCloneValue(object);
                }
                var event = {
                  data: cloneValue(obj)
                };
                this._deferred.then(function() {
                  var _iterator14 = _createForOfIteratorHelper(_this8._listeners), _step14;
                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done; ) {
                      var listener = _step14.value;
                      listener.call(_this8, event);
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                });
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(name, listener) {
                this._listeners.push(listener);
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(name, listener) {
                var i2 = this._listeners.indexOf(listener);
                this._listeners.splice(i2, 1);
              }
            }, {
              key: "terminate",
              value: function terminate() {
                this._listeners.length = 0;
              }
            }]);
            return LoopbackPort2;
          }();
          exports.LoopbackPort = LoopbackPort;
          var PDFWorkerUtil = {
            isWorkerDisabled: false,
            fallbackWorkerSrc: null,
            fakeWorkerId: 0
          };
          {
            if (_is_node.isNodeJS && typeof commonjsRequire === "function") {
              PDFWorkerUtil.isWorkerDisabled = true;
              PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
            } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object") {
              var _document, _document$currentScri;
              var pdfjsFilePath = (_document = document) === null || _document === void 0 ? void 0 : (_document$currentScri = _document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.src;
              if (pdfjsFilePath) {
                PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
              }
            }
            PDFWorkerUtil.createCDNWrapper = function(url) {
              var wrapper = 'importScripts("'.concat(url, '");');
              return URL.createObjectURL(new Blob([wrapper]));
            };
          }
          var PDFWorker = /* @__PURE__ */ function() {
            function PDFWorker() {
              var _ref14 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref14$name = _ref14.name, name = _ref14$name === void 0 ? null : _ref14$name, _ref14$port = _ref14.port, port = _ref14$port === void 0 ? null : _ref14$port, _ref14$verbosity = _ref14.verbosity, verbosity = _ref14$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref14$verbosity;
              _classCallCheck(this, PDFWorker);
              if (port && PDFWorker._workerPorts.has(port)) {
                throw new Error("Cannot use more than one PDFWorker per port.");
              }
              this.name = name;
              this.destroyed = false;
              this.verbosity = verbosity;
              this._readyCapability = (0, _util.createPromiseCapability)();
              this._port = null;
              this._webWorker = null;
              this._messageHandler = null;
              if (port) {
                PDFWorker._workerPorts.set(port, this);
                this._initializeFromPort(port);
                return;
              }
              this._initialize();
            }
            _createClass(PDFWorker, [{
              key: "promise",
              get: function get2() {
                return this._readyCapability.promise;
              }
            }, {
              key: "port",
              get: function get2() {
                return this._port;
              }
            }, {
              key: "messageHandler",
              get: function get2() {
                return this._messageHandler;
              }
            }, {
              key: "_initializeFromPort",
              value: function _initializeFromPort(port) {
                this._port = port;
                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                this._messageHandler.on("ready", function() {
                });
                this._readyCapability.resolve();
              }
            }, {
              key: "_initialize",
              value: function _initialize() {
                var _this9 = this;
                if (typeof Worker !== "undefined" && !PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                  var workerSrc = PDFWorker.workerSrc;
                  try {
                    if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
                      workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                    }
                    var worker2 = new Worker(workerSrc);
                    var messageHandler = new _message_handler.MessageHandler("main", "worker", worker2);
                    var terminateEarly = function terminateEarly2() {
                      worker2.removeEventListener("error", onWorkerError);
                      messageHandler.destroy();
                      worker2.terminate();
                      if (_this9.destroyed) {
                        _this9._readyCapability.reject(new Error("Worker was destroyed"));
                      } else {
                        _this9._setupFakeWorker();
                      }
                    };
                    var onWorkerError = function onWorkerError2() {
                      if (!_this9._webWorker) {
                        terminateEarly();
                      }
                    };
                    worker2.addEventListener("error", onWorkerError);
                    messageHandler.on("test", function(data2) {
                      worker2.removeEventListener("error", onWorkerError);
                      if (_this9.destroyed) {
                        terminateEarly();
                        return;
                      }
                      if (data2) {
                        _this9._messageHandler = messageHandler;
                        _this9._port = worker2;
                        _this9._webWorker = worker2;
                        _this9._readyCapability.resolve();
                        messageHandler.send("configure", {
                          verbosity: _this9.verbosity
                        });
                      } else {
                        _this9._setupFakeWorker();
                        messageHandler.destroy();
                        worker2.terminate();
                      }
                    });
                    messageHandler.on("ready", function(data2) {
                      worker2.removeEventListener("error", onWorkerError);
                      if (_this9.destroyed) {
                        terminateEarly();
                        return;
                      }
                      try {
                        sendTest();
                      } catch (e2) {
                        _this9._setupFakeWorker();
                      }
                    });
                    var sendTest = function sendTest2() {
                      var testObj = new Uint8Array([255]);
                      try {
                        messageHandler.send("test", testObj, [testObj.buffer]);
                      } catch (ex) {
                        (0, _util.warn)("Cannot use postMessage transfers.");
                        testObj[0] = 0;
                        messageHandler.send("test", testObj);
                      }
                    };
                    sendTest();
                    return;
                  } catch (e2) {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
            }, {
              key: "_setupFakeWorker",
              value: function _setupFakeWorker() {
                var _this10 = this;
                if (!PDFWorkerUtil.isWorkerDisabled) {
                  (0, _util.warn)("Setting up fake worker.");
                  PDFWorkerUtil.isWorkerDisabled = true;
                }
                PDFWorker._setupFakeWorkerGlobal.then(function(WorkerMessageHandler) {
                  if (_this10.destroyed) {
                    _this10._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  var port = new LoopbackPort();
                  _this10._port = port;
                  var id2 = "fake".concat(PDFWorkerUtil.fakeWorkerId++);
                  var workerHandler = new _message_handler.MessageHandler(id2 + "_worker", id2, port);
                  WorkerMessageHandler.setup(workerHandler, port);
                  var messageHandler = new _message_handler.MessageHandler(id2, id2 + "_worker", port);
                  _this10._messageHandler = messageHandler;
                  _this10._readyCapability.resolve();
                  messageHandler.send("configure", {
                    verbosity: _this10.verbosity
                  });
                })["catch"](function(reason) {
                  _this10._readyCapability.reject(new Error('Setting up fake worker failed: "'.concat(reason.message, '".')));
                });
              }
            }, {
              key: "destroy",
              value: function destroy() {
                this.destroyed = true;
                if (this._webWorker) {
                  this._webWorker.terminate();
                  this._webWorker = null;
                }
                PDFWorker._workerPorts["delete"](this._port);
                this._port = null;
                if (this._messageHandler) {
                  this._messageHandler.destroy();
                  this._messageHandler = null;
                }
              }
            }], [{
              key: "_workerPorts",
              get: function get2() {
                return (0, _util.shadow)(this, "_workerPorts", /* @__PURE__ */ new WeakMap());
              }
            }, {
              key: "fromPort",
              value: function fromPort(params) {
                if (!(params !== null && params !== void 0 && params.port)) {
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                }
                if (this._workerPorts.has(params.port)) {
                  return this._workerPorts.get(params.port);
                }
                return new PDFWorker(params);
              }
            }, {
              key: "workerSrc",
              get: function get2() {
                if (_worker_options.GlobalWorkerOptions.workerSrc) {
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                }
                if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                  if (!_is_node.isNodeJS) {
                    (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                  }
                  return PDFWorkerUtil.fallbackWorkerSrc;
                }
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
            }, {
              key: "_mainThreadWorkerMessageHandler",
              get: function get2() {
                try {
                  var _globalThis$pdfjsWork;
                  return ((_globalThis$pdfjsWork = globalThis.pdfjsWorker) === null || _globalThis$pdfjsWork === void 0 ? void 0 : _globalThis$pdfjsWork.WorkerMessageHandler) || null;
                } catch (ex) {
                  return null;
                }
              }
            }, {
              key: "_setupFakeWorkerGlobal",
              get: function get() {
                var _this11 = this;
                var loader = /* @__PURE__ */ function() {
                  var _ref15 = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee4() {
                    var mainWorkerMessageHandler, worker;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            mainWorkerMessageHandler = _this11._mainThreadWorkerMessageHandler;
                            if (!mainWorkerMessageHandler) {
                              _context4.next = 3;
                              break;
                            }
                            return _context4.abrupt("return", mainWorkerMessageHandler);
                          case 3:
                            if (!(_is_node.isNodeJS && typeof commonjsRequire === "function")) {
                              _context4.next = 6;
                              break;
                            }
                            worker = eval("require")(_this11.workerSrc);
                            return _context4.abrupt("return", worker.WorkerMessageHandler);
                          case 6:
                            _context4.next = 8;
                            return (0, _display_utils.loadScript)(_this11.workerSrc);
                          case 8:
                            return _context4.abrupt("return", window.pdfjsWorker.WorkerMessageHandler);
                          case 9:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));
                  return function loader2() {
                    return _ref15.apply(this, arguments);
                  };
                }();
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            }]);
            return PDFWorker;
          }();
          exports.PDFWorker = PDFWorker;
          {
            PDFWorker.getWorkerSrc = function() {
              (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead.");
              return this.workerSrc;
            };
          }
          var _docStats = /* @__PURE__ */ new WeakMap();
          var _pageCache = /* @__PURE__ */ new WeakMap();
          var _pagePromises = /* @__PURE__ */ new WeakMap();
          var _metadataPromise = /* @__PURE__ */ new WeakMap();
          var WorkerTransport = /* @__PURE__ */ function() {
            function WorkerTransport2(messageHandler, loadingTask, networkStream, params) {
              _classCallCheck(this, WorkerTransport2);
              _classPrivateFieldInitSpec(this, _docStats, {
                writable: true,
                value: null
              });
              _classPrivateFieldInitSpec(this, _pageCache, {
                writable: true,
                value: /* @__PURE__ */ new Map()
              });
              _classPrivateFieldInitSpec(this, _pagePromises, {
                writable: true,
                value: /* @__PURE__ */ new Map()
              });
              _classPrivateFieldInitSpec(this, _metadataPromise, {
                writable: true,
                value: null
              });
              this.messageHandler = messageHandler;
              this.loadingTask = loadingTask;
              this.commonObjs = new PDFObjects();
              this.fontLoader = new _font_loader.FontLoader({
                docId: loadingTask.docId,
                onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                ownerDocument: params.ownerDocument,
                styleElement: params.styleElement
              });
              this._params = params;
              if (!params.useWorkerFetch) {
                this.CMapReaderFactory = new params.CMapReaderFactory({
                  baseUrl: params.cMapUrl,
                  isCompressed: params.cMapPacked
                });
                this.StandardFontDataFactory = new params.StandardFontDataFactory({
                  baseUrl: params.standardFontDataUrl
                });
              }
              this.destroyed = false;
              this.destroyCapability = null;
              this._passwordCapability = null;
              this._networkStream = networkStream;
              this._fullReader = null;
              this._lastProgress = null;
              this.downloadInfoCapability = (0, _util.createPromiseCapability)();
              this.setupMessageHandler();
            }
            _createClass(WorkerTransport2, [{
              key: "annotationStorage",
              get: function get2() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
            }, {
              key: "stats",
              get: function get2() {
                return _classPrivateFieldGet(this, _docStats);
              }
            }, {
              key: "getRenderingIntent",
              value: function getRenderingIntent(intent) {
                var annotationMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _util.AnnotationMode.ENABLE;
                var isOpList = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                var lastModified = "";
                switch (intent) {
                  case "any":
                    renderingIntent = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    renderingIntent = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)("getRenderingIntent - invalid intent: ".concat(intent));
                }
                switch (annotationMode) {
                  case _util.AnnotationMode.DISABLE:
                    renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                    lastModified = this.annotationStorage.lastModified;
                    break;
                  default:
                    (0, _util.warn)("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
                }
                if (isOpList) {
                  renderingIntent += _util.RenderingIntentFlag.OPLIST;
                }
                return {
                  renderingIntent,
                  cacheKey: "".concat(renderingIntent, "_").concat(lastModified)
                };
              }
            }, {
              key: "destroy",
              value: function destroy() {
                var _this12 = this;
                if (this.destroyCapability) {
                  return this.destroyCapability.promise;
                }
                this.destroyed = true;
                this.destroyCapability = (0, _util.createPromiseCapability)();
                if (this._passwordCapability) {
                  this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                }
                var waitOn = [];
                var _iterator15 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values()), _step15;
                try {
                  for (_iterator15.s(); !(_step15 = _iterator15.n()).done; ) {
                    var page = _step15.value;
                    waitOn.push(page._destroy());
                  }
                } catch (err) {
                  _iterator15.e(err);
                } finally {
                  _iterator15.f();
                }
                _classPrivateFieldGet(this, _pageCache).clear();
                _classPrivateFieldGet(this, _pagePromises).clear();
                if (this.hasOwnProperty("annotationStorage")) {
                  this.annotationStorage.resetModified();
                }
                var terminated = this.messageHandler.sendWithPromise("Terminate", null);
                waitOn.push(terminated);
                Promise.all(waitOn).then(function() {
                  _this12.commonObjs.clear();
                  _this12.fontLoader.clear();
                  _classPrivateFieldSet(_this12, _metadataPromise, null);
                  _this12._getFieldObjectsPromise = null;
                  _this12._hasJSActionsPromise = null;
                  if (_this12._networkStream) {
                    _this12._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                  }
                  if (_this12.messageHandler) {
                    _this12.messageHandler.destroy();
                    _this12.messageHandler = null;
                  }
                  _this12.destroyCapability.resolve();
                }, this.destroyCapability.reject);
                return this.destroyCapability.promise;
              }
            }, {
              key: "setupMessageHandler",
              value: function setupMessageHandler() {
                var _this13 = this;
                var messageHandler = this.messageHandler, loadingTask = this.loadingTask;
                messageHandler.on("GetReader", function(data2, sink) {
                  (0, _util.assert)(_this13._networkStream, "GetReader - no `IPDFStream` instance available.");
                  _this13._fullReader = _this13._networkStream.getFullReader();
                  _this13._fullReader.onProgress = function(evt) {
                    _this13._lastProgress = {
                      loaded: evt.loaded,
                      total: evt.total
                    };
                  };
                  sink.onPull = function() {
                    _this13._fullReader.read().then(function(_ref16) {
                      var value = _ref16.value, done = _ref16.done;
                      if (done) {
                        sink.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetReader - expected an ArrayBuffer.");
                      sink.enqueue(new Uint8Array(value), 1, [value]);
                    })["catch"](function(reason) {
                      sink.error(reason);
                    });
                  };
                  sink.onCancel = function(reason) {
                    _this13._fullReader.cancel(reason);
                    sink.ready["catch"](function(readyReason) {
                      if (_this13.destroyed) {
                        return;
                      }
                      throw readyReason;
                    });
                  };
                });
                messageHandler.on("ReaderHeadersReady", function(data2) {
                  var headersCapability = (0, _util.createPromiseCapability)();
                  var fullReader = _this13._fullReader;
                  fullReader.headersReady.then(function() {
                    if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                      if (_this13._lastProgress) {
                        var _loadingTask$onProgre;
                        (_loadingTask$onProgre = loadingTask.onProgress) === null || _loadingTask$onProgre === void 0 ? void 0 : _loadingTask$onProgre.call(loadingTask, _this13._lastProgress);
                      }
                      fullReader.onProgress = function(evt) {
                        var _loadingTask$onProgre2;
                        (_loadingTask$onProgre2 = loadingTask.onProgress) === null || _loadingTask$onProgre2 === void 0 ? void 0 : _loadingTask$onProgre2.call(loadingTask, {
                          loaded: evt.loaded,
                          total: evt.total
                        });
                      };
                    }
                    headersCapability.resolve({
                      isStreamingSupported: fullReader.isStreamingSupported,
                      isRangeSupported: fullReader.isRangeSupported,
                      contentLength: fullReader.contentLength
                    });
                  }, headersCapability.reject);
                  return headersCapability.promise;
                });
                messageHandler.on("GetRangeReader", function(data2, sink) {
                  (0, _util.assert)(_this13._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  var rangeReader = _this13._networkStream.getRangeReader(data2.begin, data2.end);
                  if (!rangeReader) {
                    sink.close();
                    return;
                  }
                  sink.onPull = function() {
                    rangeReader.read().then(function(_ref17) {
                      var value = _ref17.value, done = _ref17.done;
                      if (done) {
                        sink.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetRangeReader - expected an ArrayBuffer.");
                      sink.enqueue(new Uint8Array(value), 1, [value]);
                    })["catch"](function(reason) {
                      sink.error(reason);
                    });
                  };
                  sink.onCancel = function(reason) {
                    rangeReader.cancel(reason);
                    sink.ready["catch"](function(readyReason) {
                      if (_this13.destroyed) {
                        return;
                      }
                      throw readyReason;
                    });
                  };
                });
                messageHandler.on("GetDoc", function(_ref18) {
                  var pdfInfo = _ref18.pdfInfo;
                  _this13._numPages = pdfInfo.numPages;
                  _this13._htmlForXfa = pdfInfo.htmlForXfa;
                  delete pdfInfo.htmlForXfa;
                  loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this13));
                });
                messageHandler.on("DocException", function(ex) {
                  var reason;
                  switch (ex.name) {
                    case "PasswordException":
                      reason = new _util.PasswordException(ex.message, ex.code);
                      break;
                    case "InvalidPDFException":
                      reason = new _util.InvalidPDFException(ex.message);
                      break;
                    case "MissingPDFException":
                      reason = new _util.MissingPDFException(ex.message);
                      break;
                    case "UnexpectedResponseException":
                      reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                      break;
                    case "UnknownErrorException":
                      reason = new _util.UnknownErrorException(ex.message, ex.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  loadingTask._capability.reject(reason);
                });
                messageHandler.on("PasswordRequest", function(exception) {
                  _this13._passwordCapability = (0, _util.createPromiseCapability)();
                  if (loadingTask.onPassword) {
                    var updatePassword = function updatePassword2(password) {
                      _this13._passwordCapability.resolve({
                        password
                      });
                    };
                    try {
                      loadingTask.onPassword(updatePassword, exception.code);
                    } catch (ex) {
                      _this13._passwordCapability.reject(ex);
                    }
                  } else {
                    _this13._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                  }
                  return _this13._passwordCapability.promise;
                });
                messageHandler.on("DataLoaded", function(data2) {
                  var _loadingTask$onProgre3;
                  (_loadingTask$onProgre3 = loadingTask.onProgress) === null || _loadingTask$onProgre3 === void 0 ? void 0 : _loadingTask$onProgre3.call(loadingTask, {
                    loaded: data2.length,
                    total: data2.length
                  });
                  _this13.downloadInfoCapability.resolve(data2);
                });
                messageHandler.on("StartRenderPage", function(data2) {
                  if (_this13.destroyed) {
                    return;
                  }
                  var page = _classPrivateFieldGet(_this13, _pageCache).get(data2.pageIndex);
                  page._startRenderPage(data2.transparency, data2.cacheKey);
                });
                messageHandler.on("commonobj", function(_ref19) {
                  var _globalThis$FontInspe;
                  var _ref20 = _slicedToArray(_ref19, 3), id2 = _ref20[0], type = _ref20[1], exportedData = _ref20[2];
                  if (_this13.destroyed) {
                    return;
                  }
                  if (_this13.commonObjs.has(id2)) {
                    return;
                  }
                  switch (type) {
                    case "Font":
                      var params = _this13._params;
                      if ("error" in exportedData) {
                        var exportedError = exportedData.error;
                        (0, _util.warn)("Error during font loading: ".concat(exportedError));
                        _this13.commonObjs.resolve(id2, exportedError);
                        break;
                      }
                      var fontRegistry = null;
                      if (params.pdfBug && (_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled) {
                        fontRegistry = {
                          registerFont: function registerFont(font2, url) {
                            globalThis.FontInspector.fontAdded(font2, url);
                          }
                        };
                      }
                      var font = new _font_loader.FontFaceObject(exportedData, {
                        isEvalSupported: params.isEvalSupported,
                        disableFontFace: params.disableFontFace,
                        ignoreErrors: params.ignoreErrors,
                        onUnsupportedFeature: _this13._onUnsupportedFeature.bind(_this13),
                        fontRegistry
                      });
                      _this13.fontLoader.bind(font)["catch"](function(reason) {
                        return messageHandler.sendWithPromise("FontFallback", {
                          id: id2
                        });
                      })["finally"](function() {
                        if (!params.fontExtraProperties && font.data) {
                          font.data = null;
                        }
                        _this13.commonObjs.resolve(id2, font);
                      });
                      break;
                    case "FontPath":
                    case "Image":
                      _this13.commonObjs.resolve(id2, exportedData);
                      break;
                    default:
                      throw new Error("Got unknown common object type ".concat(type));
                  }
                });
                messageHandler.on("obj", function(_ref21) {
                  var _imageData$data;
                  var _ref22 = _slicedToArray(_ref21, 4), id2 = _ref22[0], pageIndex = _ref22[1], type = _ref22[2], imageData = _ref22[3];
                  if (_this13.destroyed) {
                    return;
                  }
                  var pageProxy = _classPrivateFieldGet(_this13, _pageCache).get(pageIndex);
                  if (pageProxy.objs.has(id2)) {
                    return;
                  }
                  switch (type) {
                    case "Image":
                      pageProxy.objs.resolve(id2, imageData);
                      var MAX_IMAGE_SIZE_TO_STORE = 8e6;
                      if ((imageData === null || imageData === void 0 ? void 0 : (_imageData$data = imageData.data) === null || _imageData$data === void 0 ? void 0 : _imageData$data.length) > MAX_IMAGE_SIZE_TO_STORE) {
                        pageProxy.cleanupAfterRender = true;
                      }
                      break;
                    case "Pattern":
                      pageProxy.objs.resolve(id2, imageData);
                      break;
                    default:
                      throw new Error("Got unknown object type ".concat(type));
                  }
                });
                messageHandler.on("DocProgress", function(data2) {
                  var _loadingTask$onProgre4;
                  if (_this13.destroyed) {
                    return;
                  }
                  (_loadingTask$onProgre4 = loadingTask.onProgress) === null || _loadingTask$onProgre4 === void 0 ? void 0 : _loadingTask$onProgre4.call(loadingTask, {
                    loaded: data2.loaded,
                    total: data2.total
                  });
                });
                messageHandler.on("DocStats", function(data2) {
                  if (_this13.destroyed) {
                    return;
                  }
                  _classPrivateFieldSet(_this13, _docStats, Object.freeze({
                    streamTypes: Object.freeze(data2.streamTypes),
                    fontTypes: Object.freeze(data2.fontTypes)
                  }));
                });
                messageHandler.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
                messageHandler.on("FetchBuiltInCMap", function(data2) {
                  if (_this13.destroyed) {
                    return Promise.reject(new Error("Worker was destroyed."));
                  }
                  if (!_this13.CMapReaderFactory) {
                    return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                  }
                  return _this13.CMapReaderFactory.fetch(data2);
                });
                messageHandler.on("FetchStandardFontData", function(data2) {
                  if (_this13.destroyed) {
                    return Promise.reject(new Error("Worker was destroyed."));
                  }
                  if (!_this13.StandardFontDataFactory) {
                    return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                  }
                  return _this13.StandardFontDataFactory.fetch(data2);
                });
              }
            }, {
              key: "_onUnsupportedFeature",
              value: function _onUnsupportedFeature(_ref23) {
                var _this$loadingTask$onU, _this$loadingTask;
                var featureId = _ref23.featureId;
                if (this.destroyed) {
                  return;
                }
                (_this$loadingTask$onU = (_this$loadingTask = this.loadingTask).onUnsupportedFeature) === null || _this$loadingTask$onU === void 0 ? void 0 : _this$loadingTask$onU.call(_this$loadingTask, featureId);
              }
            }, {
              key: "getData",
              value: function getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
            }, {
              key: "getPage",
              value: function getPage(pageNumber) {
                var _this14 = this;
                if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
                  return Promise.reject(new Error("Invalid page request"));
                }
                var pageIndex = pageNumber - 1, cachedPromise = _classPrivateFieldGet(this, _pagePromises).get(pageIndex);
                if (cachedPromise) {
                  return cachedPromise;
                }
                var promise = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex
                }).then(function(pageInfo) {
                  if (_this14.destroyed) {
                    throw new Error("Transport destroyed");
                  }
                  var page = new PDFPageProxy(pageIndex, pageInfo, _this14, _this14._params.ownerDocument, _this14._params.pdfBug);
                  _classPrivateFieldGet(_this14, _pageCache).set(pageIndex, page);
                  return page;
                });
                _classPrivateFieldGet(this, _pagePromises).set(pageIndex, promise);
                return promise;
              }
            }, {
              key: "getPageIndex",
              value: function getPageIndex(ref) {
                return this.messageHandler.sendWithPromise("GetPageIndex", {
                  ref
                });
              }
            }, {
              key: "getAnnotations",
              value: function getAnnotations(pageIndex, intent) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex,
                  intent
                });
              }
            }, {
              key: "saveDocument",
              value: function saveDocument() {
                var _this$_fullReader$fil, _this$_fullReader, _this15 = this;
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: this.annotationStorage.serializable,
                  filename: (_this$_fullReader$fil = (_this$_fullReader = this._fullReader) === null || _this$_fullReader === void 0 ? void 0 : _this$_fullReader.filename) !== null && _this$_fullReader$fil !== void 0 ? _this$_fullReader$fil : null
                })["finally"](function() {
                  _this15.annotationStorage.resetModified();
                });
              }
            }, {
              key: "getFieldObjects",
              value: function getFieldObjects() {
                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
              }
            }, {
              key: "hasJSActions",
              value: function hasJSActions() {
                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
              }
            }, {
              key: "getCalculationOrderIds",
              value: function getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
            }, {
              key: "getDestinations",
              value: function getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
            }, {
              key: "getDestination",
              value: function getDestination(id2) {
                if (typeof id2 !== "string") {
                  return Promise.reject(new Error("Invalid destination request."));
                }
                return this.messageHandler.sendWithPromise("GetDestination", {
                  id: id2
                });
              }
            }, {
              key: "getPageLabels",
              value: function getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
            }, {
              key: "getPageLayout",
              value: function getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
            }, {
              key: "getPageMode",
              value: function getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
            }, {
              key: "getViewerPreferences",
              value: function getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
            }, {
              key: "getOpenAction",
              value: function getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
            }, {
              key: "getAttachments",
              value: function getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
            }, {
              key: "getJavaScript",
              value: function getJavaScript() {
                return this.messageHandler.sendWithPromise("GetJavaScript", null);
              }
            }, {
              key: "getDocJSActions",
              value: function getDocJSActions() {
                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
              }
            }, {
              key: "getPageJSActions",
              value: function getPageJSActions(pageIndex) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex
                });
              }
            }, {
              key: "getStructTree",
              value: function getStructTree(pageIndex) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex
                });
              }
            }, {
              key: "getOutline",
              value: function getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
            }, {
              key: "getOptionalContentConfig",
              value: function getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(function(results) {
                  return new _optional_content_config.OptionalContentConfig(results);
                });
              }
            }, {
              key: "getPermissions",
              value: function getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
            }, {
              key: "getMetadata",
              value: function getMetadata() {
                var _this16 = this;
                return _classPrivateFieldGet(this, _metadataPromise) || _classPrivateFieldSet(this, _metadataPromise, this.messageHandler.sendWithPromise("GetMetadata", null).then(function(results) {
                  var _this16$_fullReader$f, _this16$_fullReader, _this16$_fullReader$c, _this16$_fullReader2;
                  return {
                    info: results[0],
                    metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                    contentDispositionFilename: (_this16$_fullReader$f = (_this16$_fullReader = _this16._fullReader) === null || _this16$_fullReader === void 0 ? void 0 : _this16$_fullReader.filename) !== null && _this16$_fullReader$f !== void 0 ? _this16$_fullReader$f : null,
                    contentLength: (_this16$_fullReader$c = (_this16$_fullReader2 = _this16._fullReader) === null || _this16$_fullReader2 === void 0 ? void 0 : _this16$_fullReader2.contentLength) !== null && _this16$_fullReader$c !== void 0 ? _this16$_fullReader$c : null
                  };
                }));
              }
            }, {
              key: "getMarkInfo",
              value: function getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
            }, {
              key: "startCleanup",
              value: function() {
                var _startCleanup = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee5() {
                  var keepLoadedFonts, _iterator16, _step16, page, cleanupSuccessful, _args5 = arguments;
                  return _regenerator["default"].wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          keepLoadedFonts = _args5.length > 0 && _args5[0] !== void 0 ? _args5[0] : false;
                          _context5.next = 3;
                          return this.messageHandler.sendWithPromise("Cleanup", null);
                        case 3:
                          if (!this.destroyed) {
                            _context5.next = 5;
                            break;
                          }
                          return _context5.abrupt("return");
                        case 5:
                          _iterator16 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values());
                          _context5.prev = 6;
                          _iterator16.s();
                        case 8:
                          if ((_step16 = _iterator16.n()).done) {
                            _context5.next = 15;
                            break;
                          }
                          page = _step16.value;
                          cleanupSuccessful = page.cleanup();
                          if (cleanupSuccessful) {
                            _context5.next = 13;
                            break;
                          }
                          throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
                        case 13:
                          _context5.next = 8;
                          break;
                        case 15:
                          _context5.next = 20;
                          break;
                        case 17:
                          _context5.prev = 17;
                          _context5.t0 = _context5["catch"](6);
                          _iterator16.e(_context5.t0);
                        case 20:
                          _context5.prev = 20;
                          _iterator16.f();
                          return _context5.finish(20);
                        case 23:
                          this.commonObjs.clear();
                          if (!keepLoadedFonts) {
                            this.fontLoader.clear();
                          }
                          _classPrivateFieldSet(this, _metadataPromise, null);
                          this._getFieldObjectsPromise = null;
                          this._hasJSActionsPromise = null;
                        case 28:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, this, [[6, 17, 20, 23]]);
                }));
                function startCleanup() {
                  return _startCleanup.apply(this, arguments);
                }
                return startCleanup;
              }()
            }, {
              key: "loadingParams",
              get: function get2() {
                var params = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch: params.disableAutoFetch,
                  enableXfa: params.enableXfa
                });
              }
            }]);
            return WorkerTransport2;
          }();
          var PDFObjects = /* @__PURE__ */ function() {
            function PDFObjects2() {
              _classCallCheck(this, PDFObjects2);
              this._objs = /* @__PURE__ */ Object.create(null);
            }
            _createClass(PDFObjects2, [{
              key: "_ensureObj",
              value: function _ensureObj(objId) {
                if (this._objs[objId]) {
                  return this._objs[objId];
                }
                return this._objs[objId] = {
                  capability: (0, _util.createPromiseCapability)(),
                  data: null,
                  resolved: false
                };
              }
            }, {
              key: "get",
              value: function get2(objId) {
                var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (callback) {
                  this._ensureObj(objId).capability.promise.then(callback);
                  return null;
                }
                var obj = this._objs[objId];
                if (!obj || !obj.resolved) {
                  throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
                }
                return obj.data;
              }
            }, {
              key: "has",
              value: function has(objId) {
                var obj = this._objs[objId];
                return (obj === null || obj === void 0 ? void 0 : obj.resolved) || false;
              }
            }, {
              key: "resolve",
              value: function resolve(objId, data2) {
                var obj = this._ensureObj(objId);
                obj.resolved = true;
                obj.data = data2;
                obj.capability.resolve(data2);
              }
            }, {
              key: "clear",
              value: function clear() {
                this._objs = /* @__PURE__ */ Object.create(null);
              }
            }]);
            return PDFObjects2;
          }();
          var RenderTask = /* @__PURE__ */ function() {
            function RenderTask2(internalRenderTask) {
              _classCallCheck(this, RenderTask2);
              this._internalRenderTask = internalRenderTask;
              this.onContinue = null;
            }
            _createClass(RenderTask2, [{
              key: "promise",
              get: function get2() {
                return this._internalRenderTask.capability.promise;
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this._internalRenderTask.cancel();
              }
            }]);
            return RenderTask2;
          }();
          exports.RenderTask = RenderTask;
          var InternalRenderTask = /* @__PURE__ */ function() {
            function InternalRenderTask2(_ref24) {
              var callback = _ref24.callback, params = _ref24.params, objs = _ref24.objs, commonObjs = _ref24.commonObjs, annotationCanvasMap = _ref24.annotationCanvasMap, operatorList = _ref24.operatorList, pageIndex = _ref24.pageIndex, canvasFactory = _ref24.canvasFactory, _ref24$useRequestAnim = _ref24.useRequestAnimationFrame, useRequestAnimationFrame = _ref24$useRequestAnim === void 0 ? false : _ref24$useRequestAnim, _ref24$pdfBug = _ref24.pdfBug, pdfBug = _ref24$pdfBug === void 0 ? false : _ref24$pdfBug;
              _classCallCheck(this, InternalRenderTask2);
              this.callback = callback;
              this.params = params;
              this.objs = objs;
              this.commonObjs = commonObjs;
              this.annotationCanvasMap = annotationCanvasMap;
              this.operatorListIdx = null;
              this.operatorList = operatorList;
              this._pageIndex = pageIndex;
              this.canvasFactory = canvasFactory;
              this._pdfBug = pdfBug;
              this.running = false;
              this.graphicsReadyCallback = null;
              this.graphicsReady = false;
              this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
              this.cancelled = false;
              this.capability = (0, _util.createPromiseCapability)();
              this.task = new RenderTask(this);
              this._cancelBound = this.cancel.bind(this);
              this._continueBound = this._continue.bind(this);
              this._scheduleNextBound = this._scheduleNext.bind(this);
              this._nextBound = this._next.bind(this);
              this._canvas = params.canvasContext.canvas;
            }
            _createClass(InternalRenderTask2, [{
              key: "completed",
              get: function get2() {
                return this.capability.promise["catch"](function() {
                });
              }
            }, {
              key: "initializeGraphics",
              value: function initializeGraphics(_ref25) {
                var _globalThis$StepperMa;
                var _ref25$transparency = _ref25.transparency, transparency = _ref25$transparency === void 0 ? false : _ref25$transparency, optionalContentConfig = _ref25.optionalContentConfig;
                if (this.cancelled) {
                  return;
                }
                if (this._canvas) {
                  if (InternalRenderTask2.canvasInUse.has(this._canvas)) {
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  }
                  InternalRenderTask2.canvasInUse.add(this._canvas);
                }
                if (this._pdfBug && (_globalThis$StepperMa = globalThis.StepperManager) !== null && _globalThis$StepperMa !== void 0 && _globalThis$StepperMa.enabled) {
                  this.stepper = globalThis.StepperManager.create(this._pageIndex);
                  this.stepper.init(this.operatorList);
                  this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                }
                var _this$params = this.params, canvasContext = _this$params.canvasContext, viewport = _this$params.viewport, transform2 = _this$params.transform, imageLayer = _this$params.imageLayer, background = _this$params.background;
                this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, imageLayer, optionalContentConfig, this.annotationCanvasMap);
                this.gfx.beginDrawing({
                  transform: transform2,
                  viewport,
                  transparency,
                  background
                });
                this.operatorListIdx = 0;
                this.graphicsReady = true;
                if (this.graphicsReadyCallback) {
                  this.graphicsReadyCallback();
                }
              }
            }, {
              key: "cancel",
              value: function cancel() {
                var error3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                this.running = false;
                this.cancelled = true;
                if (this.gfx) {
                  this.gfx.endDrawing();
                }
                if (this._canvas) {
                  InternalRenderTask2.canvasInUse["delete"](this._canvas);
                }
                this.callback(error3 || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), "canvas"));
              }
            }, {
              key: "operatorListChanged",
              value: function operatorListChanged() {
                if (!this.graphicsReady) {
                  if (!this.graphicsReadyCallback) {
                    this.graphicsReadyCallback = this._continueBound;
                  }
                  return;
                }
                if (this.stepper) {
                  this.stepper.updateOperatorList(this.operatorList);
                }
                if (this.running) {
                  return;
                }
                this._continue();
              }
            }, {
              key: "_continue",
              value: function _continue() {
                this.running = true;
                if (this.cancelled) {
                  return;
                }
                if (this.task.onContinue) {
                  this.task.onContinue(this._scheduleNextBound);
                } else {
                  this._scheduleNext();
                }
              }
            }, {
              key: "_scheduleNext",
              value: function _scheduleNext() {
                var _this17 = this;
                if (this._useRequestAnimationFrame) {
                  window.requestAnimationFrame(function() {
                    _this17._nextBound()["catch"](_this17._cancelBound);
                  });
                } else {
                  Promise.resolve().then(this._nextBound)["catch"](this._cancelBound);
                }
              }
            }, {
              key: "_next",
              value: function() {
                var _next2 = _asyncToGenerator(/* @__PURE__ */ _regenerator["default"].mark(function _callee6() {
                  return _regenerator["default"].wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!this.cancelled) {
                            _context6.next = 2;
                            break;
                          }
                          return _context6.abrupt("return");
                        case 2:
                          this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                          if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                              this.gfx.endDrawing();
                              if (this._canvas) {
                                InternalRenderTask2.canvasInUse["delete"](this._canvas);
                              }
                              this.callback();
                            }
                          }
                        case 4:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, this);
                }));
                function _next() {
                  return _next2.apply(this, arguments);
                }
                return _next;
              }()
            }], [{
              key: "canvasInUse",
              get: function get2() {
                return (0, _util.shadow)(this, "canvasInUse", /* @__PURE__ */ new WeakSet());
              }
            }]);
            return InternalRenderTask2;
          }();
          var version = "2.12.313";
          exports.version = version;
          var build = "a2ae56f39";
          exports.build = build;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.FontLoader = exports2.FontFaceObject = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var BaseFontLoader = /* @__PURE__ */ function() {
            function BaseFontLoader2(_ref) {
              var docId = _ref.docId, onUnsupportedFeature = _ref.onUnsupportedFeature, _ref$ownerDocument = _ref.ownerDocument, ownerDocument = _ref$ownerDocument === void 0 ? globalThis.document : _ref$ownerDocument;
              _ref.styleElement;
              _classCallCheck2(this, BaseFontLoader2);
              if (this.constructor === BaseFontLoader2) {
                (0, _util2.unreachable)("Cannot initialize BaseFontLoader.");
              }
              this.docId = docId;
              this._onUnsupportedFeature = onUnsupportedFeature;
              this._document = ownerDocument;
              this.nativeFontFaces = [];
              this.styleElement = null;
            }
            _createClass2(BaseFontLoader2, [{
              key: "addNativeFontFace",
              value: function addNativeFontFace(nativeFontFace) {
                this.nativeFontFaces.push(nativeFontFace);
                this._document.fonts.add(nativeFontFace);
              }
            }, {
              key: "insertRule",
              value: function insertRule(rule) {
                var styleElement = this.styleElement;
                if (!styleElement) {
                  styleElement = this.styleElement = this._document.createElement("style");
                  styleElement.id = "PDFJS_FONT_STYLE_TAG_".concat(this.docId);
                  this._document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
                }
                var styleSheet = styleElement.sheet;
                styleSheet.insertRule(rule, styleSheet.cssRules.length);
              }
            }, {
              key: "clear",
              value: function clear() {
                var _iterator = _createForOfIteratorHelper2(this.nativeFontFaces), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var nativeFontFace = _step.value;
                    this._document.fonts["delete"](nativeFontFace);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this.nativeFontFaces.length = 0;
                if (this.styleElement) {
                  this.styleElement.remove();
                  this.styleElement = null;
                }
              }
            }, {
              key: "bind",
              value: function() {
                var _bind = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee(font) {
                  var _this = this;
                  var nativeFontFace, rule;
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(font.attached || font.missingFile)) {
                            _context.next = 2;
                            break;
                          }
                          return _context.abrupt("return");
                        case 2:
                          font.attached = true;
                          if (!this.isFontLoadingAPISupported) {
                            _context.next = 19;
                            break;
                          }
                          nativeFontFace = font.createNativeFontFace();
                          if (!nativeFontFace) {
                            _context.next = 18;
                            break;
                          }
                          this.addNativeFontFace(nativeFontFace);
                          _context.prev = 7;
                          _context.next = 10;
                          return nativeFontFace.loaded;
                        case 10:
                          _context.next = 18;
                          break;
                        case 12:
                          _context.prev = 12;
                          _context.t0 = _context["catch"](7);
                          this._onUnsupportedFeature({
                            featureId: _util2.UNSUPPORTED_FEATURES.errorFontLoadNative
                          });
                          (0, _util2.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context.t0, "'."));
                          font.disableFontFace = true;
                          throw _context.t0;
                        case 18:
                          return _context.abrupt("return");
                        case 19:
                          rule = font.createFontFaceRule();
                          if (!rule) {
                            _context.next = 26;
                            break;
                          }
                          this.insertRule(rule);
                          if (!this.isSyncFontLoadingSupported) {
                            _context.next = 24;
                            break;
                          }
                          return _context.abrupt("return");
                        case 24:
                          _context.next = 26;
                          return new Promise(function(resolve) {
                            var request4 = _this._queueLoadingCallback(resolve);
                            _this._prepareFontLoadEvent([rule], [font], request4);
                          });
                        case 26:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this, [[7, 12]]);
                }));
                function bind3(_x) {
                  return _bind.apply(this, arguments);
                }
                return bind3;
              }()
            }, {
              key: "_queueLoadingCallback",
              value: function _queueLoadingCallback(callback) {
                (0, _util2.unreachable)("Abstract method `_queueLoadingCallback`.");
              }
            }, {
              key: "isFontLoadingAPISupported",
              get: function get2() {
                var _this$_document;
                var hasFonts = !!((_this$_document = this._document) !== null && _this$_document !== void 0 && _this$_document.fonts);
                return (0, _util2.shadow)(this, "isFontLoadingAPISupported", hasFonts);
              }
            }, {
              key: "isSyncFontLoadingSupported",
              get: function get2() {
                (0, _util2.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
              }
            }, {
              key: "_loadTestFont",
              get: function get2() {
                (0, _util2.unreachable)("Abstract method `_loadTestFont`.");
              }
            }, {
              key: "_prepareFontLoadEvent",
              value: function _prepareFontLoadEvent(rules, fontsToLoad, request4) {
                (0, _util2.unreachable)("Abstract method `_prepareFontLoadEvent`.");
              }
            }]);
            return BaseFontLoader2;
          }();
          var FontLoader;
          exports2.FontLoader = FontLoader;
          {
            exports2.FontLoader = FontLoader = /* @__PURE__ */ function(_BaseFontLoader) {
              _inherits2(GenericFontLoader, _BaseFontLoader);
              var _super = _createSuper2(GenericFontLoader);
              function GenericFontLoader(params) {
                var _this2;
                _classCallCheck2(this, GenericFontLoader);
                _this2 = _super.call(this, params);
                _this2.loadingContext = {
                  requests: [],
                  nextRequestId: 0
                };
                _this2.loadTestFontId = 0;
                return _this2;
              }
              _createClass2(GenericFontLoader, [{
                key: "isSyncFontLoadingSupported",
                get: function get2() {
                  var supported = false;
                  if (typeof navigator === "undefined") {
                    supported = true;
                  } else {
                    var m2 = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                    if ((m2 === null || m2 === void 0 ? void 0 : m2[1]) >= 14) {
                      supported = true;
                    }
                  }
                  return (0, _util2.shadow)(this, "isSyncFontLoadingSupported", supported);
                }
              }, {
                key: "_queueLoadingCallback",
                value: function _queueLoadingCallback(callback) {
                  function completeRequest() {
                    (0, _util2.assert)(!request4.done, "completeRequest() cannot be called twice.");
                    request4.done = true;
                    while (context2.requests.length > 0 && context2.requests[0].done) {
                      var otherRequest = context2.requests.shift();
                      setTimeout(otherRequest.callback, 0);
                    }
                  }
                  var context2 = this.loadingContext;
                  var request4 = {
                    id: "pdfjs-font-loading-".concat(context2.nextRequestId++),
                    done: false,
                    complete: completeRequest,
                    callback
                  };
                  context2.requests.push(request4);
                  return request4;
                }
              }, {
                key: "_loadTestFont",
                get: function get2() {
                  var getLoadTestFont = function getLoadTestFont2() {
                    return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                  };
                  return (0, _util2.shadow)(this, "_loadTestFont", getLoadTestFont());
                }
              }, {
                key: "_prepareFontLoadEvent",
                value: function _prepareFontLoadEvent(rules, fonts, request4) {
                  function int32(data3, offset) {
                    return data3.charCodeAt(offset) << 24 | data3.charCodeAt(offset + 1) << 16 | data3.charCodeAt(offset + 2) << 8 | data3.charCodeAt(offset + 3) & 255;
                  }
                  function spliceString(s2, offset, remove3, insert) {
                    var chunk1 = s2.substring(0, offset);
                    var chunk2 = s2.substring(offset + remove3);
                    return chunk1 + insert + chunk2;
                  }
                  var i2, ii;
                  var canvas = this._document.createElement("canvas");
                  canvas.width = 1;
                  canvas.height = 1;
                  var ctx = canvas.getContext("2d");
                  var called = 0;
                  function isFontReady(name2, callback) {
                    called++;
                    if (called > 30) {
                      (0, _util2.warn)("Load test font never loaded.");
                      callback();
                      return;
                    }
                    ctx.font = "30px " + name2;
                    ctx.fillText(".", 0, 20);
                    var imageData = ctx.getImageData(0, 0, 1, 1);
                    if (imageData.data[3] > 0) {
                      callback();
                      return;
                    }
                    setTimeout(isFontReady.bind(null, name2, callback));
                  }
                  var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
                  var data2 = this._loadTestFont;
                  var COMMENT_OFFSET = 976;
                  data2 = spliceString(data2, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                  var CFF_CHECKSUM_OFFSET = 16;
                  var XXXX_VALUE = 1482184792;
                  var checksum = int32(data2, CFF_CHECKSUM_OFFSET);
                  for (i2 = 0, ii = loadTestFontId.length - 3; i2 < ii; i2 += 4) {
                    checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i2) | 0;
                  }
                  if (i2 < loadTestFontId.length) {
                    checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i2) | 0;
                  }
                  data2 = spliceString(data2, CFF_CHECKSUM_OFFSET, 4, (0, _util2.string32)(checksum));
                  var url = "url(data:font/opentype;base64,".concat(btoa(data2), ");");
                  var rule = '@font-face {font-family:"'.concat(loadTestFontId, '";src:').concat(url, "}");
                  this.insertRule(rule);
                  var names2 = [];
                  var _iterator2 = _createForOfIteratorHelper2(fonts), _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                      var font = _step2.value;
                      names2.push(font.loadedName);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                  names2.push(loadTestFontId);
                  var div2 = this._document.createElement("div");
                  div2.style.visibility = "hidden";
                  div2.style.width = div2.style.height = "10px";
                  div2.style.position = "absolute";
                  div2.style.top = div2.style.left = "0px";
                  for (var _i = 0, _names = names2; _i < _names.length; _i++) {
                    var name = _names[_i];
                    var span = this._document.createElement("span");
                    span.textContent = "Hi";
                    span.style.fontFamily = name;
                    div2.appendChild(span);
                  }
                  this._document.body.appendChild(div2);
                  isFontReady(loadTestFontId, function() {
                    div2.remove();
                    request4.complete();
                  });
                }
              }]);
              return GenericFontLoader;
            }(BaseFontLoader);
          }
          var FontFaceObject = /* @__PURE__ */ function() {
            function FontFaceObject2(translatedData, _ref2) {
              var _ref2$isEvalSupported = _ref2.isEvalSupported, isEvalSupported = _ref2$isEvalSupported === void 0 ? true : _ref2$isEvalSupported, _ref2$disableFontFace = _ref2.disableFontFace, disableFontFace = _ref2$disableFontFace === void 0 ? false : _ref2$disableFontFace, _ref2$ignoreErrors = _ref2.ignoreErrors, ignoreErrors = _ref2$ignoreErrors === void 0 ? false : _ref2$ignoreErrors, onUnsupportedFeature = _ref2.onUnsupportedFeature, _ref2$fontRegistry = _ref2.fontRegistry, fontRegistry = _ref2$fontRegistry === void 0 ? null : _ref2$fontRegistry;
              _classCallCheck2(this, FontFaceObject2);
              this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
              for (var i2 in translatedData) {
                this[i2] = translatedData[i2];
              }
              this.isEvalSupported = isEvalSupported !== false;
              this.disableFontFace = disableFontFace === true;
              this.ignoreErrors = ignoreErrors === true;
              this._onUnsupportedFeature = onUnsupportedFeature;
              this.fontRegistry = fontRegistry;
            }
            _createClass2(FontFaceObject2, [{
              key: "createNativeFontFace",
              value: function createNativeFontFace() {
                if (!this.data || this.disableFontFace) {
                  return null;
                }
                var nativeFontFace;
                if (!this.cssFontInfo) {
                  nativeFontFace = new FontFace(this.loadedName, this.data, {});
                } else {
                  var css = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  if (this.cssFontInfo.italicAngle) {
                    css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
                  }
                  nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                }
                if (this.fontRegistry) {
                  this.fontRegistry.registerFont(this);
                }
                return nativeFontFace;
              }
            }, {
              key: "createFontFaceRule",
              value: function createFontFaceRule() {
                if (!this.data || this.disableFontFace) {
                  return null;
                }
                var data2 = (0, _util2.bytesToString)(this.data);
                var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data2), ");");
                var rule;
                if (!this.cssFontInfo) {
                  rule = '@font-face {font-family:"'.concat(this.loadedName, '";src:').concat(url, "}");
                } else {
                  var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
                  if (this.cssFontInfo.italicAngle) {
                    css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
                  }
                  rule = '@font-face {font-family:"'.concat(this.cssFontInfo.fontFamily, '";').concat(css, "src:").concat(url, "}");
                }
                if (this.fontRegistry) {
                  this.fontRegistry.registerFont(this, url);
                }
                return rule;
              }
            }, {
              key: "getPathGenerator",
              value: function getPathGenerator(objs, character) {
                if (this.compiledGlyphs[character] !== void 0) {
                  return this.compiledGlyphs[character];
                }
                var cmds;
                try {
                  cmds = objs.get(this.loadedName + "_path_" + character);
                } catch (ex) {
                  if (!this.ignoreErrors) {
                    throw ex;
                  }
                  this._onUnsupportedFeature({
                    featureId: _util2.UNSUPPORTED_FEATURES.errorFontGetPath
                  });
                  (0, _util2.warn)('getPathGenerator - ignoring character: "'.concat(ex, '".'));
                  return this.compiledGlyphs[character] = function(c2, size) {
                  };
                }
                if (this.isEvalSupported && _util2.IsEvalSupportedCached.value) {
                  var jsBuf = [];
                  var _iterator3 = _createForOfIteratorHelper2(cmds), _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                      var current = _step3.value;
                      var args = current.args !== void 0 ? current.args.join(",") : "";
                      jsBuf.push("c.", current.cmd, "(", args, ");\n");
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                  return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                }
                return this.compiledGlyphs[character] = function(c2, size) {
                  var _iterator4 = _createForOfIteratorHelper2(cmds), _step4;
                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                      var _current = _step4.value;
                      if (_current.cmd === "scale") {
                        _current.args = [size, -size];
                      }
                      c2[_current.cmd].apply(c2, _current.args);
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                };
              }
            }]);
            return FontFaceObject2;
          }();
          exports2.FontFaceObject = FontFaceObject;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.NodeStandardFontDataFactory = exports2.NodeCanvasFactory = exports2.NodeCMapReaderFactory = void 0;
          var _base_factory = __w_pdfjs_require__2(135);
          var _is_node2 = __w_pdfjs_require__2(6);
          var _util2 = __w_pdfjs_require__2(4);
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var NodeCanvasFactory = function NodeCanvasFactory2() {
            _classCallCheck2(this, NodeCanvasFactory2);
            (0, _util2.unreachable)("Not implemented: NodeCanvasFactory");
          };
          exports2.NodeCanvasFactory = NodeCanvasFactory;
          var NodeCMapReaderFactory = function NodeCMapReaderFactory2() {
            _classCallCheck2(this, NodeCMapReaderFactory2);
            (0, _util2.unreachable)("Not implemented: NodeCMapReaderFactory");
          };
          exports2.NodeCMapReaderFactory = NodeCMapReaderFactory;
          var NodeStandardFontDataFactory = function NodeStandardFontDataFactory2() {
            _classCallCheck2(this, NodeStandardFontDataFactory2);
            (0, _util2.unreachable)("Not implemented: NodeStandardFontDataFactory");
          };
          exports2.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
          if (_is_node2.isNodeJS) {
            var fetchData = function fetchData2(url) {
              return new Promise(function(resolve, reject) {
                var fs = require$$4;
                fs.readFile(url, function(error3, data2) {
                  if (error3 || !data2) {
                    reject(new Error(error3));
                    return;
                  }
                  resolve(new Uint8Array(data2));
                });
              });
            };
            exports2.NodeCanvasFactory = NodeCanvasFactory = /* @__PURE__ */ function(_BaseCanvasFactory) {
              _inherits2(NodeCanvasFactory2, _BaseCanvasFactory);
              var _super = _createSuper2(NodeCanvasFactory2);
              function NodeCanvasFactory2() {
                _classCallCheck2(this, NodeCanvasFactory2);
                return _super.apply(this, arguments);
              }
              _createClass2(NodeCanvasFactory2, [{
                key: "_createCanvas",
                value: function _createCanvas(width2, height2) {
                  var Canvas2 = require$$4;
                  return Canvas2.createCanvas(width2, height2);
                }
              }]);
              return NodeCanvasFactory2;
            }(_base_factory.BaseCanvasFactory);
            exports2.NodeCMapReaderFactory = NodeCMapReaderFactory = /* @__PURE__ */ function(_BaseCMapReaderFactor) {
              _inherits2(NodeCMapReaderFactory2, _BaseCMapReaderFactor);
              var _super2 = _createSuper2(NodeCMapReaderFactory2);
              function NodeCMapReaderFactory2() {
                _classCallCheck2(this, NodeCMapReaderFactory2);
                return _super2.apply(this, arguments);
              }
              _createClass2(NodeCMapReaderFactory2, [{
                key: "_fetchData",
                value: function _fetchData(url, compressionType) {
                  return fetchData(url).then(function(data2) {
                    return {
                      cMapData: data2,
                      compressionType
                    };
                  });
                }
              }]);
              return NodeCMapReaderFactory2;
            }(_base_factory.BaseCMapReaderFactory);
            exports2.NodeStandardFontDataFactory = NodeStandardFontDataFactory = /* @__PURE__ */ function(_BaseStandardFontData) {
              _inherits2(NodeStandardFontDataFactory2, _BaseStandardFontData);
              var _super3 = _createSuper2(NodeStandardFontDataFactory2);
              function NodeStandardFontDataFactory2() {
                _classCallCheck2(this, NodeStandardFontDataFactory2);
                return _super3.apply(this, arguments);
              }
              _createClass2(NodeStandardFontDataFactory2, [{
                key: "_fetchData",
                value: function _fetchData(url) {
                  return fetchData(url);
                }
              }]);
              return NodeStandardFontDataFactory2;
            }(_base_factory.BaseStandardFontDataFactory);
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.AnnotationStorage = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var AnnotationStorage = /* @__PURE__ */ function() {
            function AnnotationStorage2() {
              _classCallCheck2(this, AnnotationStorage2);
              this._storage = /* @__PURE__ */ new Map();
              this._timeStamp = Date.now();
              this._modified = false;
              this.onSetModified = null;
              this.onResetModified = null;
            }
            _createClass2(AnnotationStorage2, [{
              key: "getValue",
              value: function getValue(key, defaultValue) {
                var value = this._storage.get(key);
                if (value === void 0) {
                  return defaultValue;
                }
                return Object.assign(defaultValue, value);
              }
            }, {
              key: "setValue",
              value: function setValue(key, value) {
                var obj = this._storage.get(key);
                var modified = false;
                if (obj !== void 0) {
                  for (var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++) {
                    var _Object$entries$_i = _slicedToArray2(_Object$entries[_i], 2), entry = _Object$entries$_i[0], val = _Object$entries$_i[1];
                    if (obj[entry] !== val) {
                      modified = true;
                      obj[entry] = val;
                    }
                  }
                } else {
                  modified = true;
                  this._storage.set(key, value);
                }
                if (modified) {
                  this._timeStamp = Date.now();
                  this._setModified();
                }
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return this._storage.size > 0 ? (0, _util2.objectFromMap)(this._storage) : null;
              }
            }, {
              key: "size",
              get: function get2() {
                return this._storage.size;
              }
            }, {
              key: "_setModified",
              value: function _setModified() {
                if (!this._modified) {
                  this._modified = true;
                  if (typeof this.onSetModified === "function") {
                    this.onSetModified();
                  }
                }
              }
            }, {
              key: "resetModified",
              value: function resetModified() {
                if (this._modified) {
                  this._modified = false;
                  if (typeof this.onResetModified === "function") {
                    this.onResetModified();
                  }
                }
              }
            }, {
              key: "serializable",
              get: function get2() {
                return this._storage.size > 0 ? this._storage : null;
              }
            }, {
              key: "lastModified",
              get: function get2() {
                return this._timeStamp.toString();
              }
            }]);
            return AnnotationStorage2;
          }();
          exports2.AnnotationStorage = AnnotationStorage;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.CanvasGraphics = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          var _pattern_helper = __w_pdfjs_require__2(141);
          var _display_utils2 = __w_pdfjs_require__2(1);
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e3) {
              didErr = true;
              err = _e3;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          var MIN_FONT_SIZE = 16;
          var MAX_FONT_SIZE = 100;
          var MAX_GROUP_SIZE = 4096;
          var EXECUTION_TIME = 15;
          var EXECUTION_STEPS = 10;
          var MAX_SIZE_TO_COMPILE = 1e3;
          var FULL_CHUNK_HEIGHT = 16;
          var LINEWIDTH_SCALE_FACTOR = 1.000001;
          function mirrorContextOperations(ctx, destCtx) {
            if (ctx._removeMirroring) {
              throw new Error("Context is already forwarding operations.");
            }
            ctx.__originalSave = ctx.save;
            ctx.__originalRestore = ctx.restore;
            ctx.__originalRotate = ctx.rotate;
            ctx.__originalScale = ctx.scale;
            ctx.__originalTranslate = ctx.translate;
            ctx.__originalTransform = ctx.transform;
            ctx.__originalSetTransform = ctx.setTransform;
            ctx.__originalResetTransform = ctx.resetTransform;
            ctx.__originalClip = ctx.clip;
            ctx.__originalMoveTo = ctx.moveTo;
            ctx.__originalLineTo = ctx.lineTo;
            ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
            ctx.__originalRect = ctx.rect;
            ctx.__originalClosePath = ctx.closePath;
            ctx.__originalBeginPath = ctx.beginPath;
            ctx._removeMirroring = function() {
              ctx.save = ctx.__originalSave;
              ctx.restore = ctx.__originalRestore;
              ctx.rotate = ctx.__originalRotate;
              ctx.scale = ctx.__originalScale;
              ctx.translate = ctx.__originalTranslate;
              ctx.transform = ctx.__originalTransform;
              ctx.setTransform = ctx.__originalSetTransform;
              ctx.resetTransform = ctx.__originalResetTransform;
              ctx.clip = ctx.__originalClip;
              ctx.moveTo = ctx.__originalMoveTo;
              ctx.lineTo = ctx.__originalLineTo;
              ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
              ctx.rect = ctx.__originalRect;
              ctx.closePath = ctx.__originalClosePath;
              ctx.beginPath = ctx.__originalBeginPath;
              delete ctx._removeMirroring;
            };
            ctx.save = function ctxSave() {
              destCtx.save();
              this.__originalSave();
            };
            ctx.restore = function ctxRestore() {
              destCtx.restore();
              this.__originalRestore();
            };
            ctx.translate = function ctxTranslate(x2, y2) {
              destCtx.translate(x2, y2);
              this.__originalTranslate(x2, y2);
            };
            ctx.scale = function ctxScale(x2, y2) {
              destCtx.scale(x2, y2);
              this.__originalScale(x2, y2);
            };
            ctx.transform = function ctxTransform(a6, b2, c2, d2, e2, f2) {
              destCtx.transform(a6, b2, c2, d2, e2, f2);
              this.__originalTransform(a6, b2, c2, d2, e2, f2);
            };
            ctx.setTransform = function ctxSetTransform(a6, b2, c2, d2, e2, f2) {
              destCtx.setTransform(a6, b2, c2, d2, e2, f2);
              this.__originalSetTransform(a6, b2, c2, d2, e2, f2);
            };
            ctx.resetTransform = function ctxResetTransform() {
              destCtx.resetTransform();
              this.__originalResetTransform();
            };
            ctx.rotate = function ctxRotate(angle) {
              destCtx.rotate(angle);
              this.__originalRotate(angle);
            };
            ctx.clip = function ctxRotate(rule) {
              destCtx.clip(rule);
              this.__originalClip(rule);
            };
            ctx.moveTo = function(x2, y2) {
              destCtx.moveTo(x2, y2);
              this.__originalMoveTo(x2, y2);
            };
            ctx.lineTo = function(x2, y2) {
              destCtx.lineTo(x2, y2);
              this.__originalLineTo(x2, y2);
            };
            ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x2, y2) {
              destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2);
              this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2);
            };
            ctx.rect = function(x2, y2, width2, height2) {
              destCtx.rect(x2, y2, width2, height2);
              this.__originalRect(x2, y2, width2, height2);
            };
            ctx.closePath = function() {
              destCtx.closePath();
              this.__originalClosePath();
            };
            ctx.beginPath = function() {
              destCtx.beginPath();
              this.__originalBeginPath();
            };
          }
          function addContextCurrentTransform(ctx) {
            if (ctx.mozCurrentTransform) {
              return;
            }
            ctx._originalSave = ctx.save;
            ctx._originalRestore = ctx.restore;
            ctx._originalRotate = ctx.rotate;
            ctx._originalScale = ctx.scale;
            ctx._originalTranslate = ctx.translate;
            ctx._originalTransform = ctx.transform;
            ctx._originalSetTransform = ctx.setTransform;
            ctx._originalResetTransform = ctx.resetTransform;
            ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
            ctx._transformStack = [];
            try {
              var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(ctx), "lineWidth");
              ctx._setLineWidth = desc.set;
              ctx._getLineWidth = desc.get;
              Object.defineProperty(ctx, "lineWidth", {
                set: function setLineWidth(width2) {
                  this._setLineWidth(width2 * LINEWIDTH_SCALE_FACTOR);
                },
                get: function getLineWidth() {
                  return this._getLineWidth();
                }
              });
            } catch (_24) {
            }
            Object.defineProperty(ctx, "mozCurrentTransform", {
              get: function getCurrentTransform() {
                return this._transformMatrix;
              }
            });
            Object.defineProperty(ctx, "mozCurrentTransformInverse", {
              get: function getCurrentTransformInverse() {
                var _this$_transformMatri = _slicedToArray2(this._transformMatrix, 6), a6 = _this$_transformMatri[0], b2 = _this$_transformMatri[1], c2 = _this$_transformMatri[2], d2 = _this$_transformMatri[3], e2 = _this$_transformMatri[4], f2 = _this$_transformMatri[5];
                var ad_bc = a6 * d2 - b2 * c2;
                var bc_ad = b2 * c2 - a6 * d2;
                return [d2 / ad_bc, b2 / bc_ad, c2 / bc_ad, a6 / ad_bc, (d2 * e2 - c2 * f2) / bc_ad, (b2 * e2 - a6 * f2) / ad_bc];
              }
            });
            ctx.save = function ctxSave() {
              var old = this._transformMatrix;
              this._transformStack.push(old);
              this._transformMatrix = old.slice(0, 6);
              this._originalSave();
            };
            ctx.restore = function ctxRestore() {
              var prev = this._transformStack.pop();
              if (prev) {
                this._transformMatrix = prev;
                this._originalRestore();
              }
            };
            ctx.translate = function ctxTranslate(x2, y2) {
              var m2 = this._transformMatrix;
              m2[4] = m2[0] * x2 + m2[2] * y2 + m2[4];
              m2[5] = m2[1] * x2 + m2[3] * y2 + m2[5];
              this._originalTranslate(x2, y2);
            };
            ctx.scale = function ctxScale(x2, y2) {
              var m2 = this._transformMatrix;
              m2[0] *= x2;
              m2[1] *= x2;
              m2[2] *= y2;
              m2[3] *= y2;
              this._originalScale(x2, y2);
            };
            ctx.transform = function ctxTransform(a6, b2, c2, d2, e2, f2) {
              var m2 = this._transformMatrix;
              this._transformMatrix = [m2[0] * a6 + m2[2] * b2, m2[1] * a6 + m2[3] * b2, m2[0] * c2 + m2[2] * d2, m2[1] * c2 + m2[3] * d2, m2[0] * e2 + m2[2] * f2 + m2[4], m2[1] * e2 + m2[3] * f2 + m2[5]];
              ctx._originalTransform(a6, b2, c2, d2, e2, f2);
            };
            ctx.setTransform = function ctxSetTransform(a6, b2, c2, d2, e2, f2) {
              this._transformMatrix = [a6, b2, c2, d2, e2, f2];
              ctx._originalSetTransform(a6, b2, c2, d2, e2, f2);
            };
            ctx.resetTransform = function ctxResetTransform() {
              this._transformMatrix = [1, 0, 0, 1, 0, 0];
              ctx._originalResetTransform();
            };
            ctx.rotate = function ctxRotate(angle) {
              var cosValue = Math.cos(angle);
              var sinValue = Math.sin(angle);
              var m2 = this._transformMatrix;
              this._transformMatrix = [m2[0] * cosValue + m2[2] * sinValue, m2[1] * cosValue + m2[3] * sinValue, m2[0] * -sinValue + m2[2] * cosValue, m2[1] * -sinValue + m2[3] * cosValue, m2[4], m2[5]];
              this._originalRotate(angle);
            };
          }
          var CachedCanvases = /* @__PURE__ */ function() {
            function CachedCanvases2(canvasFactory) {
              _classCallCheck2(this, CachedCanvases2);
              this.canvasFactory = canvasFactory;
              this.cache = /* @__PURE__ */ Object.create(null);
            }
            _createClass2(CachedCanvases2, [{
              key: "getCanvas",
              value: function getCanvas(id2, width2, height2, trackTransform) {
                var canvasEntry;
                if (this.cache[id2] !== void 0) {
                  canvasEntry = this.cache[id2];
                  this.canvasFactory.reset(canvasEntry, width2, height2);
                  canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
                } else {
                  canvasEntry = this.canvasFactory.create(width2, height2);
                  this.cache[id2] = canvasEntry;
                }
                if (trackTransform) {
                  addContextCurrentTransform(canvasEntry.context);
                }
                return canvasEntry;
              }
            }, {
              key: "clear",
              value: function clear() {
                for (var id2 in this.cache) {
                  var canvasEntry = this.cache[id2];
                  this.canvasFactory.destroy(canvasEntry);
                  delete this.cache[id2];
                }
              }
            }]);
            return CachedCanvases2;
          }();
          function compileType3Glyph(imgData) {
            var POINT_TO_PROCESS_LIMIT = 1e3;
            var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
            var width2 = imgData.width, height2 = imgData.height, width1 = width2 + 1;
            var i2, ii, j2, j0;
            var points = new Uint8Array(width1 * (height2 + 1));
            var lineSize = width2 + 7 & ~7, data0 = imgData.data;
            var data2 = new Uint8Array(lineSize * height2);
            var pos = 0;
            for (i2 = 0, ii = data0.length; i2 < ii; i2++) {
              var elem = data0[i2];
              var mask = 128;
              while (mask > 0) {
                data2[pos++] = elem & mask ? 0 : 255;
                mask >>= 1;
              }
            }
            var count2 = 0;
            pos = 0;
            if (data2[pos] !== 0) {
              points[0] = 1;
              ++count2;
            }
            for (j2 = 1; j2 < width2; j2++) {
              if (data2[pos] !== data2[pos + 1]) {
                points[j2] = data2[pos] ? 2 : 1;
                ++count2;
              }
              pos++;
            }
            if (data2[pos] !== 0) {
              points[j2] = 2;
              ++count2;
            }
            for (i2 = 1; i2 < height2; i2++) {
              pos = i2 * lineSize;
              j0 = i2 * width1;
              if (data2[pos - lineSize] !== data2[pos]) {
                points[j0] = data2[pos] ? 1 : 8;
                ++count2;
              }
              var sum2 = (data2[pos] ? 4 : 0) + (data2[pos - lineSize] ? 8 : 0);
              for (j2 = 1; j2 < width2; j2++) {
                sum2 = (sum2 >> 2) + (data2[pos + 1] ? 4 : 0) + (data2[pos - lineSize + 1] ? 8 : 0);
                if (POINT_TYPES[sum2]) {
                  points[j0 + j2] = POINT_TYPES[sum2];
                  ++count2;
                }
                pos++;
              }
              if (data2[pos - lineSize] !== data2[pos]) {
                points[j0 + j2] = data2[pos] ? 2 : 4;
                ++count2;
              }
              if (count2 > POINT_TO_PROCESS_LIMIT) {
                return null;
              }
            }
            pos = lineSize * (height2 - 1);
            j0 = i2 * width1;
            if (data2[pos] !== 0) {
              points[j0] = 8;
              ++count2;
            }
            for (j2 = 1; j2 < width2; j2++) {
              if (data2[pos] !== data2[pos + 1]) {
                points[j0 + j2] = data2[pos] ? 4 : 8;
                ++count2;
              }
              pos++;
            }
            if (data2[pos] !== 0) {
              points[j0 + j2] = 4;
              ++count2;
            }
            if (count2 > POINT_TO_PROCESS_LIMIT) {
              return null;
            }
            var steps2 = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
            var outlines = [];
            for (i2 = 0; count2 && i2 <= height2; i2++) {
              var p2 = i2 * width1;
              var end = p2 + width2;
              while (p2 < end && !points[p2]) {
                p2++;
              }
              if (p2 === end) {
                continue;
              }
              var coords2 = [p2 % width1, i2];
              var p0 = p2;
              var type = points[p2];
              do {
                var step2 = steps2[type];
                do {
                  p2 += step2;
                } while (!points[p2]);
                var pp = points[p2];
                if (pp !== 5 && pp !== 10) {
                  type = pp;
                  points[p2] = 0;
                } else {
                  type = pp & 51 * type >> 4;
                  points[p2] &= type >> 2 | type << 2;
                }
                coords2.push(p2 % width1, p2 / width1 | 0);
                if (!points[p2]) {
                  --count2;
                }
              } while (p0 !== p2);
              outlines.push(coords2);
              --i2;
            }
            var drawOutline = function drawOutline2(c2) {
              c2.save();
              c2.scale(1 / width2, -1 / height2);
              c2.translate(0, -height2);
              c2.beginPath();
              for (var k3 = 0, kk = outlines.length; k3 < kk; k3++) {
                var o = outlines[k3];
                c2.moveTo(o[0], o[1]);
                for (var l2 = 2, ll = o.length; l2 < ll; l2 += 2) {
                  c2.lineTo(o[l2], o[l2 + 1]);
                }
              }
              c2.fill();
              c2.beginPath();
              c2.restore();
            };
            return drawOutline;
          }
          var CanvasExtraState = /* @__PURE__ */ function() {
            function CanvasExtraState2(width2, height2) {
              _classCallCheck2(this, CanvasExtraState2);
              this.alphaIsShape = false;
              this.fontSize = 0;
              this.fontSizeScale = 1;
              this.textMatrix = _util2.IDENTITY_MATRIX;
              this.textMatrixScale = 1;
              this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
              this.leading = 0;
              this.x = 0;
              this.y = 0;
              this.lineX = 0;
              this.lineY = 0;
              this.charSpacing = 0;
              this.wordSpacing = 0;
              this.textHScale = 1;
              this.textRenderingMode = _util2.TextRenderingMode.FILL;
              this.textRise = 0;
              this.fillColor = "#000000";
              this.strokeColor = "#000000";
              this.patternFill = false;
              this.fillAlpha = 1;
              this.strokeAlpha = 1;
              this.lineWidth = 1;
              this.activeSMask = null;
              this.transferMaps = null;
              this.startNewPathAndClipBox([0, 0, width2, height2]);
            }
            _createClass2(CanvasExtraState2, [{
              key: "clone",
              value: function clone2() {
                var clone3 = Object.create(this);
                clone3.clipBox = this.clipBox.slice();
                return clone3;
              }
            }, {
              key: "setCurrentPoint",
              value: function setCurrentPoint(x2, y2) {
                this.x = x2;
                this.y = y2;
              }
            }, {
              key: "updatePathMinMax",
              value: function updatePathMinMax(transform2, x2, y2) {
                var _Util$applyTransform = _util2.Util.applyTransform([x2, y2], transform2);
                var _Util$applyTransform2 = _slicedToArray2(_Util$applyTransform, 2);
                x2 = _Util$applyTransform2[0];
                y2 = _Util$applyTransform2[1];
                this.minX = Math.min(this.minX, x2);
                this.minY = Math.min(this.minY, y2);
                this.maxX = Math.max(this.maxX, x2);
                this.maxY = Math.max(this.maxY, y2);
              }
            }, {
              key: "updateCurvePathMinMax",
              value: function updateCurvePathMinMax(transform2, x0, y0, x1, y1, x2, y2, x3, y3) {
                var box = _util2.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                this.updatePathMinMax(transform2, box[0], box[1]);
                this.updatePathMinMax(transform2, box[2], box[3]);
              }
            }, {
              key: "getPathBoundingBox",
              value: function getPathBoundingBox() {
                var pathType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _pattern_helper.PathType.FILL;
                var transform2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var box = [this.minX, this.minY, this.maxX, this.maxY];
                if (pathType === _pattern_helper.PathType.STROKE) {
                  if (!transform2) {
                    (0, _util2.unreachable)("Stroke bounding box must include transform.");
                  }
                  var scale2 = _util2.Util.singularValueDecompose2dScale(transform2);
                  var xStrokePad = scale2[0] * this.lineWidth / 2;
                  var yStrokePad = scale2[1] * this.lineWidth / 2;
                  box[0] -= xStrokePad;
                  box[1] -= yStrokePad;
                  box[2] += xStrokePad;
                  box[3] += yStrokePad;
                }
                return box;
              }
            }, {
              key: "updateClipFromPath",
              value: function updateClipFromPath() {
                var intersect = _util2.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(intersect || [0, 0, 0, 0]);
              }
            }, {
              key: "startNewPathAndClipBox",
              value: function startNewPathAndClipBox(box) {
                this.clipBox = box;
                this.minX = Infinity;
                this.minY = Infinity;
                this.maxX = 0;
                this.maxY = 0;
              }
            }, {
              key: "getClippedPathBoundingBox",
              value: function getClippedPathBoundingBox() {
                var pathType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _pattern_helper.PathType.FILL;
                var transform2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return _util2.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform2));
              }
            }]);
            return CanvasExtraState2;
          }();
          function putBinaryImageData(ctx, imgData) {
            var transferMaps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
              ctx.putImageData(imgData, 0, 0);
              return;
            }
            var height2 = imgData.height, width2 = imgData.width;
            var partialChunkHeight = height2 % FULL_CHUNK_HEIGHT;
            var fullChunks = (height2 - partialChunkHeight) / FULL_CHUNK_HEIGHT;
            var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
            var chunkImgData = ctx.createImageData(width2, FULL_CHUNK_HEIGHT);
            var srcPos = 0, destPos;
            var src2 = imgData.data;
            var dest = chunkImgData.data;
            var i2, j2, thisChunkHeight, elemsInThisChunk;
            var transferMapRed, transferMapGreen, transferMapBlue, transferMapGray;
            if (transferMaps) {
              switch (transferMaps.length) {
                case 1:
                  transferMapRed = transferMaps[0];
                  transferMapGreen = transferMaps[0];
                  transferMapBlue = transferMaps[0];
                  transferMapGray = transferMaps[0];
                  break;
                case 4:
                  transferMapRed = transferMaps[0];
                  transferMapGreen = transferMaps[1];
                  transferMapBlue = transferMaps[2];
                  transferMapGray = transferMaps[3];
                  break;
              }
            }
            if (imgData.kind === _util2.ImageKind.GRAYSCALE_1BPP) {
              var srcLength = src2.byteLength;
              var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
              var dest32DataLength = dest32.length;
              var fullSrcDiff = width2 + 7 >> 3;
              var white = 4294967295;
              var black = _util2.IsLittleEndianCached.value ? 4278190080 : 255;
              if (transferMapGray) {
                if (transferMapGray[0] === 255 && transferMapGray[255] === 0) {
                  var _ref = [black, white];
                  white = _ref[0];
                  black = _ref[1];
                }
              }
              for (i2 = 0; i2 < totalChunks; i2++) {
                thisChunkHeight = i2 < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                destPos = 0;
                for (j2 = 0; j2 < thisChunkHeight; j2++) {
                  var srcDiff = srcLength - srcPos;
                  var k3 = 0;
                  var kEnd = srcDiff > fullSrcDiff ? width2 : srcDiff * 8 - 7;
                  var kEndUnrolled = kEnd & ~7;
                  var mask = 0;
                  var srcByte = 0;
                  for (; k3 < kEndUnrolled; k3 += 8) {
                    srcByte = src2[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                  }
                  for (; k3 < kEnd; k3++) {
                    if (mask === 0) {
                      srcByte = src2[srcPos++];
                      mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                  }
                }
                while (destPos < dest32DataLength) {
                  dest32[destPos++] = 0;
                }
                ctx.putImageData(chunkImgData, 0, i2 * FULL_CHUNK_HEIGHT);
              }
            } else if (imgData.kind === _util2.ImageKind.RGBA_32BPP) {
              var hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
              j2 = 0;
              elemsInThisChunk = width2 * FULL_CHUNK_HEIGHT * 4;
              for (i2 = 0; i2 < fullChunks; i2++) {
                dest.set(src2.subarray(srcPos, srcPos + elemsInThisChunk));
                srcPos += elemsInThisChunk;
                if (hasTransferMaps) {
                  for (var _k = 0; _k < elemsInThisChunk; _k += 4) {
                    if (transferMapRed) {
                      dest[_k + 0] = transferMapRed[dest[_k + 0]];
                    }
                    if (transferMapGreen) {
                      dest[_k + 1] = transferMapGreen[dest[_k + 1]];
                    }
                    if (transferMapBlue) {
                      dest[_k + 2] = transferMapBlue[dest[_k + 2]];
                    }
                  }
                }
                ctx.putImageData(chunkImgData, 0, j2);
                j2 += FULL_CHUNK_HEIGHT;
              }
              if (i2 < totalChunks) {
                elemsInThisChunk = width2 * partialChunkHeight * 4;
                dest.set(src2.subarray(srcPos, srcPos + elemsInThisChunk));
                if (hasTransferMaps) {
                  for (var _k2 = 0; _k2 < elemsInThisChunk; _k2 += 4) {
                    if (transferMapRed) {
                      dest[_k2 + 0] = transferMapRed[dest[_k2 + 0]];
                    }
                    if (transferMapGreen) {
                      dest[_k2 + 1] = transferMapGreen[dest[_k2 + 1]];
                    }
                    if (transferMapBlue) {
                      dest[_k2 + 2] = transferMapBlue[dest[_k2 + 2]];
                    }
                  }
                }
                ctx.putImageData(chunkImgData, 0, j2);
              }
            } else if (imgData.kind === _util2.ImageKind.RGB_24BPP) {
              var _hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
              thisChunkHeight = FULL_CHUNK_HEIGHT;
              elemsInThisChunk = width2 * thisChunkHeight;
              for (i2 = 0; i2 < totalChunks; i2++) {
                if (i2 >= fullChunks) {
                  thisChunkHeight = partialChunkHeight;
                  elemsInThisChunk = width2 * thisChunkHeight;
                }
                destPos = 0;
                for (j2 = elemsInThisChunk; j2--; ) {
                  dest[destPos++] = src2[srcPos++];
                  dest[destPos++] = src2[srcPos++];
                  dest[destPos++] = src2[srcPos++];
                  dest[destPos++] = 255;
                }
                if (_hasTransferMaps) {
                  for (var _k3 = 0; _k3 < destPos; _k3 += 4) {
                    if (transferMapRed) {
                      dest[_k3 + 0] = transferMapRed[dest[_k3 + 0]];
                    }
                    if (transferMapGreen) {
                      dest[_k3 + 1] = transferMapGreen[dest[_k3 + 1]];
                    }
                    if (transferMapBlue) {
                      dest[_k3 + 2] = transferMapBlue[dest[_k3 + 2]];
                    }
                  }
                }
                ctx.putImageData(chunkImgData, 0, i2 * FULL_CHUNK_HEIGHT);
              }
            } else {
              throw new Error("bad image kind: ".concat(imgData.kind));
            }
          }
          function putBinaryImageMask(ctx, imgData) {
            var height2 = imgData.height, width2 = imgData.width;
            var partialChunkHeight = height2 % FULL_CHUNK_HEIGHT;
            var fullChunks = (height2 - partialChunkHeight) / FULL_CHUNK_HEIGHT;
            var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
            var chunkImgData = ctx.createImageData(width2, FULL_CHUNK_HEIGHT);
            var srcPos = 0;
            var src2 = imgData.data;
            var dest = chunkImgData.data;
            for (var i2 = 0; i2 < totalChunks; i2++) {
              var thisChunkHeight = i2 < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
              var destPos = 3;
              for (var j2 = 0; j2 < thisChunkHeight; j2++) {
                var elem = void 0, mask = 0;
                for (var k3 = 0; k3 < width2; k3++) {
                  if (!mask) {
                    elem = src2[srcPos++];
                    mask = 128;
                  }
                  dest[destPos] = elem & mask ? 0 : 255;
                  destPos += 4;
                  mask >>= 1;
                }
              }
              ctx.putImageData(chunkImgData, 0, i2 * FULL_CHUNK_HEIGHT);
            }
          }
          function copyCtxState(sourceCtx, destCtx) {
            var properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
            for (var i2 = 0, ii = properties.length; i2 < ii; i2++) {
              var property = properties[i2];
              if (sourceCtx[property] !== void 0) {
                destCtx[property] = sourceCtx[property];
              }
            }
            if (sourceCtx.setLineDash !== void 0) {
              destCtx.setLineDash(sourceCtx.getLineDash());
              destCtx.lineDashOffset = sourceCtx.lineDashOffset;
            }
          }
          function resetCtxToDefault(ctx) {
            ctx.strokeStyle = "#000000";
            ctx.fillStyle = "#000000";
            ctx.fillRule = "nonzero";
            ctx.globalAlpha = 1;
            ctx.lineWidth = 1;
            ctx.lineCap = "butt";
            ctx.lineJoin = "miter";
            ctx.miterLimit = 10;
            ctx.globalCompositeOperation = "source-over";
            ctx.font = "10px sans-serif";
            if (ctx.setLineDash !== void 0) {
              ctx.setLineDash([]);
              ctx.lineDashOffset = 0;
            }
          }
          function composeSMaskBackdrop(bytes, r0, g0, b0) {
            var length = bytes.length;
            for (var i2 = 3; i2 < length; i2 += 4) {
              var alpha2 = bytes[i2];
              if (alpha2 === 0) {
                bytes[i2 - 3] = r0;
                bytes[i2 - 2] = g0;
                bytes[i2 - 1] = b0;
              } else if (alpha2 < 255) {
                var alpha_ = 255 - alpha2;
                bytes[i2 - 3] = bytes[i2 - 3] * alpha2 + r0 * alpha_ >> 8;
                bytes[i2 - 2] = bytes[i2 - 2] * alpha2 + g0 * alpha_ >> 8;
                bytes[i2 - 1] = bytes[i2 - 1] * alpha2 + b0 * alpha_ >> 8;
              }
            }
          }
          function composeSMaskAlpha(maskData, layerData, transferMap) {
            var length = maskData.length;
            var scale2 = 1 / 255;
            for (var i2 = 3; i2 < length; i2 += 4) {
              var alpha2 = transferMap ? transferMap[maskData[i2]] : maskData[i2];
              layerData[i2] = layerData[i2] * alpha2 * scale2 | 0;
            }
          }
          function composeSMaskLuminosity(maskData, layerData, transferMap) {
            var length = maskData.length;
            for (var i2 = 3; i2 < length; i2 += 4) {
              var y2 = maskData[i2 - 3] * 77 + maskData[i2 - 2] * 152 + maskData[i2 - 1] * 28;
              layerData[i2] = transferMap ? layerData[i2] * transferMap[y2 >> 8] >> 8 : layerData[i2] * y2 >> 16;
            }
          }
          function genericComposeSMask(maskCtx, layerCtx, width2, height2, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
            var hasBackdrop = !!backdrop;
            var r0 = hasBackdrop ? backdrop[0] : 0;
            var g0 = hasBackdrop ? backdrop[1] : 0;
            var b0 = hasBackdrop ? backdrop[2] : 0;
            var composeFn;
            if (subtype === "Luminosity") {
              composeFn = composeSMaskLuminosity;
            } else {
              composeFn = composeSMaskAlpha;
            }
            var PIXELS_TO_PROCESS = 1048576;
            var chunkSize = Math.min(height2, Math.ceil(PIXELS_TO_PROCESS / width2));
            for (var row = 0; row < height2; row += chunkSize) {
              var chunkHeight = Math.min(chunkSize, height2 - row);
              var maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width2, chunkHeight);
              var layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width2, chunkHeight);
              if (hasBackdrop) {
                composeSMaskBackdrop(maskData.data, r0, g0, b0);
              }
              composeFn(maskData.data, layerData.data, transferMap);
              layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
            }
          }
          function composeSMask(ctx, smask, layerCtx, layerBox) {
            var layerOffsetX = layerBox[0];
            var layerOffsetY = layerBox[1];
            var layerWidth = layerBox[2] - layerOffsetX;
            var layerHeight = layerBox[3] - layerOffsetY;
            if (layerWidth === 0 || layerHeight === 0) {
              return;
            }
            genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
            ctx.save();
            ctx.globalAlpha = 1;
            ctx.globalCompositeOperation = "source-over";
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.drawImage(layerCtx.canvas, 0, 0);
            ctx.restore();
          }
          function getImageSmoothingEnabled(transform2, interpolate2) {
            var scale2 = _util2.Util.singularValueDecompose2dScale(transform2);
            scale2[0] = Math.fround(scale2[0]);
            scale2[1] = Math.fround(scale2[1]);
            var actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
            if (interpolate2 !== void 0) {
              return interpolate2;
            } else if (scale2[0] <= actualScale || scale2[1] <= actualScale) {
              return true;
            }
            return false;
          }
          var LINE_CAP_STYLES = ["butt", "round", "square"];
          var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
          var NORMAL_CLIP = {};
          var EO_CLIP = {};
          var CanvasGraphics = /* @__PURE__ */ function() {
            function CanvasGraphics2(canvasCtx, commonObjs, objs, canvasFactory, imageLayer, optionalContentConfig, annotationCanvasMap) {
              _classCallCheck2(this, CanvasGraphics2);
              this.ctx = canvasCtx;
              this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
              this.stateStack = [];
              this.pendingClip = null;
              this.pendingEOFill = false;
              this.res = null;
              this.xobjs = null;
              this.commonObjs = commonObjs;
              this.objs = objs;
              this.canvasFactory = canvasFactory;
              this.imageLayer = imageLayer;
              this.groupStack = [];
              this.processingType3 = null;
              this.baseTransform = null;
              this.baseTransformStack = [];
              this.groupLevel = 0;
              this.smaskStack = [];
              this.smaskCounter = 0;
              this.tempSMask = null;
              this.suspendedCtx = null;
              this.contentVisible = true;
              this.markedContentStack = [];
              this.optionalContentConfig = optionalContentConfig;
              this.cachedCanvases = new CachedCanvases(this.canvasFactory);
              this.cachedPatterns = /* @__PURE__ */ new Map();
              this.annotationCanvasMap = annotationCanvasMap;
              this.viewportScale = 1;
              this.outputScaleX = 1;
              this.outputScaleY = 1;
              if (canvasCtx) {
                addContextCurrentTransform(canvasCtx);
              }
              this._cachedGetSinglePixelWidth = null;
            }
            _createClass2(CanvasGraphics2, [{
              key: "beginDrawing",
              value: function beginDrawing(_ref2) {
                var transform2 = _ref2.transform, viewport = _ref2.viewport, _ref2$transparency = _ref2.transparency, transparency = _ref2$transparency === void 0 ? false : _ref2$transparency, _ref2$background = _ref2.background, background = _ref2$background === void 0 ? null : _ref2$background;
                var width2 = this.ctx.canvas.width;
                var height2 = this.ctx.canvas.height;
                this.ctx.save();
                this.ctx.fillStyle = background || "rgb(255, 255, 255)";
                this.ctx.fillRect(0, 0, width2, height2);
                this.ctx.restore();
                if (transparency) {
                  var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width2, height2, true);
                  this.compositeCtx = this.ctx;
                  this.transparentCanvas = transparentCanvas.canvas;
                  this.ctx = transparentCanvas.context;
                  this.ctx.save();
                  this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                }
                this.ctx.save();
                resetCtxToDefault(this.ctx);
                if (transform2) {
                  this.ctx.transform.apply(this.ctx, transform2);
                  this.outputScaleX = transform2[0];
                  this.outputScaleY = transform2[0];
                }
                this.ctx.transform.apply(this.ctx, viewport.transform);
                this.viewportScale = viewport.scale;
                this.baseTransform = this.ctx.mozCurrentTransform.slice();
                this._combinedScaleFactor = Math.hypot(this.baseTransform[0], this.baseTransform[2]);
                if (this.imageLayer) {
                  this.imageLayer.beginLayout();
                }
              }
            }, {
              key: "executeOperatorList",
              value: function executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                var argsArray = operatorList.argsArray;
                var fnArray = operatorList.fnArray;
                var i2 = executionStartIdx || 0;
                var argsArrayLen = argsArray.length;
                if (argsArrayLen === i2) {
                  return i2;
                }
                var chunkOperations = argsArrayLen - i2 > EXECUTION_STEPS && typeof continueCallback === "function";
                var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                var steps2 = 0;
                var commonObjs = this.commonObjs;
                var objs = this.objs;
                var fnId;
                while (true) {
                  if (stepper !== void 0 && i2 === stepper.nextBreakPoint) {
                    stepper.breakIt(i2, continueCallback);
                    return i2;
                  }
                  fnId = fnArray[i2];
                  if (fnId !== _util2.OPS.dependency) {
                    this[fnId].apply(this, argsArray[i2]);
                  } else {
                    var _iterator = _createForOfIteratorHelper2(argsArray[i2]), _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                        var depObjId = _step.value;
                        var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                        if (!objsPool.has(depObjId)) {
                          objsPool.get(depObjId, continueCallback);
                          return i2;
                        }
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                  i2++;
                  if (i2 === argsArrayLen) {
                    return i2;
                  }
                  if (chunkOperations && ++steps2 > EXECUTION_STEPS) {
                    if (Date.now() > endTime) {
                      continueCallback();
                      return i2;
                    }
                    steps2 = 0;
                  }
                }
              }
            }, {
              key: "endDrawing",
              value: function endDrawing() {
                while (this.stateStack.length || this.current.activeSMask !== null) {
                  this.restore();
                }
                this.ctx.restore();
                if (this.transparentCanvas) {
                  this.ctx = this.compositeCtx;
                  this.ctx.save();
                  this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                  this.ctx.drawImage(this.transparentCanvas, 0, 0);
                  this.ctx.restore();
                  this.transparentCanvas = null;
                }
                this.cachedCanvases.clear();
                this.cachedPatterns.clear();
                if (this.imageLayer) {
                  this.imageLayer.endLayout();
                }
              }
            }, {
              key: "_scaleImage",
              value: function _scaleImage(img, inverseTransform) {
                var width2 = img.width;
                var height2 = img.height;
                var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                var paintWidth = width2, paintHeight = height2;
                var tmpCanvasId = "prescale1";
                var tmpCanvas, tmpCtx;
                while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
                  var newWidth = paintWidth, newHeight = paintHeight;
                  if (widthScale > 2 && paintWidth > 1) {
                    newWidth = Math.ceil(paintWidth / 2);
                    widthScale /= paintWidth / newWidth;
                  }
                  if (heightScale > 2 && paintHeight > 1) {
                    newHeight = Math.ceil(paintHeight / 2);
                    heightScale /= paintHeight / newHeight;
                  }
                  tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                  tmpCtx = tmpCanvas.context;
                  tmpCtx.clearRect(0, 0, newWidth, newHeight);
                  tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                  img = tmpCanvas.canvas;
                  paintWidth = newWidth;
                  paintHeight = newHeight;
                  tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img,
                  paintWidth,
                  paintHeight
                };
              }
            }, {
              key: "_createMaskCanvas",
              value: function _createMaskCanvas(img) {
                var ctx = this.ctx;
                var width2 = img.width, height2 = img.height;
                var fillColor = this.current.fillColor;
                var isPatternFill = this.current.patternFill;
                var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width2, height2);
                var maskCtx = maskCanvas.context;
                putBinaryImageMask(maskCtx, img);
                var objToCanvas = ctx.mozCurrentTransform;
                var maskToCanvas = _util2.Util.transform(objToCanvas, [1 / width2, 0, 0, -1 / height2, 0, 0]);
                maskToCanvas = _util2.Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height2]);
                var cord1 = _util2.Util.applyTransform([0, 0], maskToCanvas);
                var cord2 = _util2.Util.applyTransform([width2, height2], maskToCanvas);
                var rect = _util2.Util.normalizeRect([cord1[0], cord1[1], cord2[0], cord2[1]]);
                var drawnWidth = Math.ceil(rect[2] - rect[0]);
                var drawnHeight = Math.ceil(rect[3] - rect[1]);
                var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight, true);
                var fillCtx = fillCanvas.context;
                var offsetX = Math.min(cord1[0], cord2[0]);
                var offsetY = Math.min(cord1[1], cord2[1]);
                fillCtx.translate(-offsetX, -offsetY);
                fillCtx.transform.apply(fillCtx, maskToCanvas);
                var scaled = this._scaleImage(maskCanvas.canvas, fillCtx.mozCurrentTransformInverse);
                fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled(fillCtx.mozCurrentTransform, img.interpolate);
                fillCtx.drawImage(scaled.img, 0, 0, scaled.img.width, scaled.img.height, 0, 0, width2, height2);
                fillCtx.globalCompositeOperation = "source-in";
                var inverse = _util2.Util.transform(fillCtx.mozCurrentTransformInverse, [1, 0, 0, 1, -offsetX, -offsetY]);
                fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                fillCtx.fillRect(0, 0, width2, height2);
                return {
                  canvas: fillCanvas.canvas,
                  offsetX: Math.round(offsetX),
                  offsetY: Math.round(offsetY)
                };
              }
            }, {
              key: "setLineWidth",
              value: function setLineWidth(width2) {
                this.current.lineWidth = width2;
                this.ctx.lineWidth = width2;
              }
            }, {
              key: "setLineCap",
              value: function setLineCap(style) {
                this.ctx.lineCap = LINE_CAP_STYLES[style];
              }
            }, {
              key: "setLineJoin",
              value: function setLineJoin(style) {
                this.ctx.lineJoin = LINE_JOIN_STYLES[style];
              }
            }, {
              key: "setMiterLimit",
              value: function setMiterLimit(limit) {
                this.ctx.miterLimit = limit;
              }
            }, {
              key: "setDash",
              value: function setDash(dashArray, dashPhase) {
                var ctx = this.ctx;
                if (ctx.setLineDash !== void 0) {
                  ctx.setLineDash(dashArray);
                  ctx.lineDashOffset = dashPhase;
                }
              }
            }, {
              key: "setRenderingIntent",
              value: function setRenderingIntent(intent) {
              }
            }, {
              key: "setFlatness",
              value: function setFlatness(flatness) {
              }
            }, {
              key: "setGState",
              value: function setGState(states2) {
                for (var i2 = 0, ii = states2.length; i2 < ii; i2++) {
                  var state2 = states2[i2];
                  var key = state2[0];
                  var value = state2[1];
                  switch (key) {
                    case "LW":
                      this.setLineWidth(value);
                      break;
                    case "LC":
                      this.setLineCap(value);
                      break;
                    case "LJ":
                      this.setLineJoin(value);
                      break;
                    case "ML":
                      this.setMiterLimit(value);
                      break;
                    case "D":
                      this.setDash(value[0], value[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(value);
                      break;
                    case "FL":
                      this.setFlatness(value);
                      break;
                    case "Font":
                      this.setFont(value[0], value[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = state2[1];
                      break;
                    case "ca":
                      this.current.fillAlpha = state2[1];
                      this.ctx.globalAlpha = state2[1];
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = value;
                      break;
                    case "SMask":
                      this.current.activeSMask = value ? this.tempSMask : null;
                      this.tempSMask = null;
                      this.checkSMaskState();
                      break;
                    case "TR":
                      this.current.transferMaps = value;
                  }
                }
              }
            }, {
              key: "checkSMaskState",
              value: function checkSMaskState() {
                var inSMaskMode = !!this.suspendedCtx;
                if (this.current.activeSMask && !inSMaskMode) {
                  this.beginSMaskMode();
                } else if (!this.current.activeSMask && inSMaskMode) {
                  this.endSMaskMode();
                }
              }
            }, {
              key: "beginSMaskMode",
              value: function beginSMaskMode() {
                if (this.suspendedCtx) {
                  throw new Error("beginSMaskMode called while already in smask mode");
                }
                var drawnWidth = this.ctx.canvas.width;
                var drawnHeight = this.ctx.canvas.height;
                var cacheId = "smaskGroupAt" + this.groupLevel;
                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                this.suspendedCtx = this.ctx;
                this.ctx = scratchCanvas.context;
                var ctx = this.ctx;
                ctx.setTransform.apply(ctx, this.suspendedCtx.mozCurrentTransform);
                copyCtxState(this.suspendedCtx, ctx);
                mirrorContextOperations(ctx, this.suspendedCtx);
                this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
            }, {
              key: "endSMaskMode",
              value: function endSMaskMode() {
                if (!this.suspendedCtx) {
                  throw new Error("endSMaskMode called while not in smask mode");
                }
                this.ctx._removeMirroring();
                copyCtxState(this.ctx, this.suspendedCtx);
                this.ctx = this.suspendedCtx;
                this.current.activeSMask = null;
                this.suspendedCtx = null;
              }
            }, {
              key: "compose",
              value: function compose(dirtyBox) {
                if (!this.current.activeSMask) {
                  return;
                }
                if (!dirtyBox) {
                  dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                } else {
                  dirtyBox[0] = Math.floor(dirtyBox[0]);
                  dirtyBox[1] = Math.floor(dirtyBox[1]);
                  dirtyBox[2] = Math.ceil(dirtyBox[2]);
                  dirtyBox[3] = Math.ceil(dirtyBox[3]);
                }
                var smask = this.current.activeSMask;
                var suspendedCtx = this.suspendedCtx;
                composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                this.ctx.save();
                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                this.ctx.restore();
              }
            }, {
              key: "save",
              value: function save() {
                this.ctx.save();
                var old = this.current;
                this.stateStack.push(old);
                this.current = old.clone();
              }
            }, {
              key: "restore",
              value: function restore() {
                if (this.stateStack.length === 0 && this.current.activeSMask) {
                  this.endSMaskMode();
                }
                if (this.stateStack.length !== 0) {
                  this.current = this.stateStack.pop();
                  this.ctx.restore();
                  this.checkSMaskState();
                  this.pendingClip = null;
                  this._cachedGetSinglePixelWidth = null;
                }
              }
            }, {
              key: "transform",
              value: function transform2(a6, b2, c2, d2, e2, f2) {
                this.ctx.transform(a6, b2, c2, d2, e2, f2);
                this._cachedGetSinglePixelWidth = null;
              }
            }, {
              key: "constructPath",
              value: function constructPath(ops, args) {
                var ctx = this.ctx;
                var current = this.current;
                var x2 = current.x, y2 = current.y;
                var startX, startY;
                for (var i2 = 0, j2 = 0, ii = ops.length; i2 < ii; i2++) {
                  switch (ops[i2] | 0) {
                    case _util2.OPS.rectangle:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      var width2 = args[j2++];
                      var height2 = args[j2++];
                      var xw = x2 + width2;
                      var yh = y2 + height2;
                      ctx.moveTo(x2, y2);
                      if (width2 === 0 || height2 === 0) {
                        ctx.lineTo(xw, yh);
                      } else {
                        ctx.lineTo(xw, y2);
                        ctx.lineTo(xw, yh);
                        ctx.lineTo(x2, yh);
                      }
                      current.updatePathMinMax(ctx.mozCurrentTransform, x2, y2);
                      current.updatePathMinMax(ctx.mozCurrentTransform, xw, yh);
                      ctx.closePath();
                      break;
                    case _util2.OPS.moveTo:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      ctx.moveTo(x2, y2);
                      current.updatePathMinMax(ctx.mozCurrentTransform, x2, y2);
                      break;
                    case _util2.OPS.lineTo:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      ctx.lineTo(x2, y2);
                      current.updatePathMinMax(ctx.mozCurrentTransform, x2, y2);
                      break;
                    case _util2.OPS.curveTo:
                      startX = x2;
                      startY = y2;
                      x2 = args[j2 + 4];
                      y2 = args[j2 + 5];
                      ctx.bezierCurveTo(args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3], x2, y2);
                      current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3], x2, y2);
                      j2 += 6;
                      break;
                    case _util2.OPS.curveTo2:
                      startX = x2;
                      startY = y2;
                      ctx.bezierCurveTo(x2, y2, args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3]);
                      current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, x2, y2, args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3]);
                      x2 = args[j2 + 2];
                      y2 = args[j2 + 3];
                      j2 += 4;
                      break;
                    case _util2.OPS.curveTo3:
                      startX = x2;
                      startY = y2;
                      x2 = args[j2 + 2];
                      y2 = args[j2 + 3];
                      ctx.bezierCurveTo(args[j2], args[j2 + 1], x2, y2, x2, y2);
                      current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, args[j2], args[j2 + 1], x2, y2, x2, y2);
                      j2 += 4;
                      break;
                    case _util2.OPS.closePath:
                      ctx.closePath();
                      break;
                  }
                }
                current.setCurrentPoint(x2, y2);
              }
            }, {
              key: "closePath",
              value: function closePath() {
                this.ctx.closePath();
              }
            }, {
              key: "stroke",
              value: function stroke(consumePath) {
                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                var ctx = this.ctx;
                var strokeColor = this.current.strokeColor;
                ctx.globalAlpha = this.current.strokeAlpha;
                if (this.contentVisible) {
                  if (_typeof2(strokeColor) === "object" && strokeColor !== null && strokeColor !== void 0 && strokeColor.getPattern) {
                    var lineWidth = this.getSinglePixelWidth();
                    ctx.save();
                    ctx.strokeStyle = strokeColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.STROKE);
                    ctx.lineWidth = Math.max(lineWidth, this.current.lineWidth);
                    ctx.stroke();
                    ctx.restore();
                  } else {
                    var _lineWidth = this.getSinglePixelWidth();
                    if (_lineWidth < 0 && -_lineWidth >= this.current.lineWidth) {
                      ctx.save();
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                      ctx.stroke();
                      ctx.restore();
                    } else {
                      ctx.lineWidth = Math.max(_lineWidth, this.current.lineWidth);
                      ctx.stroke();
                    }
                  }
                }
                if (consumePath) {
                  this.consumePath(this.current.getClippedPathBoundingBox());
                }
                ctx.globalAlpha = this.current.fillAlpha;
              }
            }, {
              key: "closeStroke",
              value: function closeStroke() {
                this.closePath();
                this.stroke();
              }
            }, {
              key: "fill",
              value: function fill2(consumePath) {
                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                var ctx = this.ctx;
                var fillColor = this.current.fillColor;
                var isPatternFill = this.current.patternFill;
                var needRestore = false;
                if (isPatternFill) {
                  ctx.save();
                  ctx.fillStyle = fillColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL);
                  needRestore = true;
                }
                var intersect = this.current.getClippedPathBoundingBox();
                if (this.contentVisible && intersect !== null) {
                  if (this.pendingEOFill) {
                    ctx.fill("evenodd");
                    this.pendingEOFill = false;
                  } else {
                    ctx.fill();
                  }
                }
                if (needRestore) {
                  ctx.restore();
                }
                if (consumePath) {
                  this.consumePath(intersect);
                }
              }
            }, {
              key: "eoFill",
              value: function eoFill() {
                this.pendingEOFill = true;
                this.fill();
              }
            }, {
              key: "fillStroke",
              value: function fillStroke() {
                this.fill(false);
                this.stroke(false);
                this.consumePath();
              }
            }, {
              key: "eoFillStroke",
              value: function eoFillStroke() {
                this.pendingEOFill = true;
                this.fillStroke();
              }
            }, {
              key: "closeFillStroke",
              value: function closeFillStroke() {
                this.closePath();
                this.fillStroke();
              }
            }, {
              key: "closeEOFillStroke",
              value: function closeEOFillStroke() {
                this.pendingEOFill = true;
                this.closePath();
                this.fillStroke();
              }
            }, {
              key: "endPath",
              value: function endPath() {
                this.consumePath();
              }
            }, {
              key: "clip",
              value: function clip2() {
                this.pendingClip = NORMAL_CLIP;
              }
            }, {
              key: "eoClip",
              value: function eoClip() {
                this.pendingClip = EO_CLIP;
              }
            }, {
              key: "beginText",
              value: function beginText() {
                this.current.textMatrix = _util2.IDENTITY_MATRIX;
                this.current.textMatrixScale = 1;
                this.current.x = this.current.lineX = 0;
                this.current.y = this.current.lineY = 0;
              }
            }, {
              key: "endText",
              value: function endText() {
                var paths = this.pendingTextPaths;
                var ctx = this.ctx;
                if (paths === void 0) {
                  ctx.beginPath();
                  return;
                }
                ctx.save();
                ctx.beginPath();
                for (var i2 = 0; i2 < paths.length; i2++) {
                  var path2 = paths[i2];
                  ctx.setTransform.apply(ctx, path2.transform);
                  ctx.translate(path2.x, path2.y);
                  path2.addToPath(ctx, path2.fontSize);
                }
                ctx.restore();
                ctx.clip();
                ctx.beginPath();
                delete this.pendingTextPaths;
              }
            }, {
              key: "setCharSpacing",
              value: function setCharSpacing(spacing) {
                this.current.charSpacing = spacing;
              }
            }, {
              key: "setWordSpacing",
              value: function setWordSpacing(spacing) {
                this.current.wordSpacing = spacing;
              }
            }, {
              key: "setHScale",
              value: function setHScale(scale2) {
                this.current.textHScale = scale2 / 100;
              }
            }, {
              key: "setLeading",
              value: function setLeading(leading) {
                this.current.leading = -leading;
              }
            }, {
              key: "setFont",
              value: function setFont(fontRefName, size) {
                var fontObj = this.commonObjs.get(fontRefName);
                var current = this.current;
                if (!fontObj) {
                  throw new Error("Can't find font for ".concat(fontRefName));
                }
                current.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
                  (0, _util2.warn)("Invalid font matrix for font " + fontRefName);
                }
                if (size < 0) {
                  size = -size;
                  current.fontDirection = -1;
                } else {
                  current.fontDirection = 1;
                }
                this.current.font = fontObj;
                this.current.fontSize = size;
                if (fontObj.isType3Font) {
                  return;
                }
                var name = fontObj.loadedName || "sans-serif";
                var bold = "normal";
                if (fontObj.black) {
                  bold = "900";
                } else if (fontObj.bold) {
                  bold = "bold";
                }
                var italic = fontObj.italic ? "italic" : "normal";
                var typeface = '"'.concat(name, '", ').concat(fontObj.fallbackName);
                var browserFontSize = size;
                if (size < MIN_FONT_SIZE) {
                  browserFontSize = MIN_FONT_SIZE;
                } else if (size > MAX_FONT_SIZE) {
                  browserFontSize = MAX_FONT_SIZE;
                }
                this.current.fontSizeScale = size / browserFontSize;
                this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
              }
            }, {
              key: "setTextRenderingMode",
              value: function setTextRenderingMode(mode2) {
                this.current.textRenderingMode = mode2;
              }
            }, {
              key: "setTextRise",
              value: function setTextRise(rise) {
                this.current.textRise = rise;
              }
            }, {
              key: "moveText",
              value: function moveText(x2, y2) {
                this.current.x = this.current.lineX += x2;
                this.current.y = this.current.lineY += y2;
              }
            }, {
              key: "setLeadingMoveText",
              value: function setLeadingMoveText(x2, y2) {
                this.setLeading(-y2);
                this.moveText(x2, y2);
              }
            }, {
              key: "setTextMatrix",
              value: function setTextMatrix(a6, b2, c2, d2, e2, f2) {
                this.current.textMatrix = [a6, b2, c2, d2, e2, f2];
                this.current.textMatrixScale = Math.hypot(a6, b2);
                this.current.x = this.current.lineX = 0;
                this.current.y = this.current.lineY = 0;
              }
            }, {
              key: "nextLine",
              value: function nextLine() {
                this.moveText(0, this.current.leading);
              }
            }, {
              key: "paintChar",
              value: function paintChar(character, x2, y2, patternTransform, resetLineWidthToOne) {
                var ctx = this.ctx;
                var current = this.current;
                var font = current.font;
                var textRenderingMode = current.textRenderingMode;
                var fontSize = current.fontSize / current.fontSizeScale;
                var fillStrokeMode = textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                var isAddToPathSet = !!(textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG);
                var patternFill = current.patternFill && !font.missingFile;
                var addToPath;
                if (font.disableFontFace || isAddToPathSet || patternFill) {
                  addToPath = font.getPathGenerator(this.commonObjs, character);
                }
                if (font.disableFontFace || patternFill) {
                  ctx.save();
                  ctx.translate(x2, y2);
                  ctx.beginPath();
                  addToPath(ctx, fontSize);
                  if (patternTransform) {
                    ctx.setTransform.apply(ctx, patternTransform);
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx.fill();
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    if (resetLineWidthToOne) {
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                    }
                    ctx.stroke();
                  }
                  ctx.restore();
                } else {
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx.fillText(character, x2, y2);
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    if (resetLineWidthToOne) {
                      ctx.save();
                      ctx.moveTo(x2, y2);
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                      ctx.strokeText(character, 0, 0);
                      ctx.restore();
                    } else {
                      ctx.strokeText(character, x2, y2);
                    }
                  }
                }
                if (isAddToPathSet) {
                  var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                  paths.push({
                    transform: ctx.mozCurrentTransform,
                    x: x2,
                    y: y2,
                    fontSize,
                    addToPath
                  });
                }
              }
            }, {
              key: "isFontSubpixelAAEnabled",
              get: function get2() {
                var _this$cachedCanvases$ = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10), ctx = _this$cachedCanvases$.context;
                ctx.scale(1.5, 1);
                ctx.fillText("I", 0, 10);
                var data2 = ctx.getImageData(0, 0, 10, 10).data;
                var enabled = false;
                for (var i2 = 3; i2 < data2.length; i2 += 4) {
                  if (data2[i2] > 0 && data2[i2] < 255) {
                    enabled = true;
                    break;
                  }
                }
                return (0, _util2.shadow)(this, "isFontSubpixelAAEnabled", enabled);
              }
            }, {
              key: "showText",
              value: function showText(glyphs) {
                var current = this.current;
                var font = current.font;
                if (font.isType3Font) {
                  return this.showType3Text(glyphs);
                }
                var fontSize = current.fontSize;
                if (fontSize === 0) {
                  return void 0;
                }
                var ctx = this.ctx;
                var fontSizeScale = current.fontSizeScale;
                var charSpacing = current.charSpacing;
                var wordSpacing = current.wordSpacing;
                var fontDirection = current.fontDirection;
                var textHScale = current.textHScale * fontDirection;
                var glyphsLength = glyphs.length;
                var vertical = font.vertical;
                var spacingDir = vertical ? 1 : -1;
                var defaultVMetrics = font.defaultVMetrics;
                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                var simpleFillText = current.textRenderingMode === _util2.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                ctx.save();
                ctx.transform.apply(ctx, current.textMatrix);
                ctx.translate(current.x, current.y + current.textRise);
                if (fontDirection > 0) {
                  ctx.scale(textHScale, -1);
                } else {
                  ctx.scale(textHScale, 1);
                }
                var patternTransform;
                if (current.patternFill) {
                  ctx.save();
                  var pattern = current.fillColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL);
                  patternTransform = ctx.mozCurrentTransform;
                  ctx.restore();
                  ctx.fillStyle = pattern;
                }
                var lineWidth = current.lineWidth;
                var resetLineWidthToOne = false;
                var scale2 = current.textMatrixScale;
                if (scale2 === 0 || lineWidth === 0) {
                  var fillStrokeMode = current.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    this._cachedGetSinglePixelWidth = null;
                    lineWidth = this.getSinglePixelWidth();
                    resetLineWidthToOne = lineWidth < 0;
                  }
                } else {
                  lineWidth /= scale2;
                }
                if (fontSizeScale !== 1) {
                  ctx.scale(fontSizeScale, fontSizeScale);
                  lineWidth /= fontSizeScale;
                }
                ctx.lineWidth = lineWidth;
                var x2 = 0, i2;
                for (i2 = 0; i2 < glyphsLength; ++i2) {
                  var glyph = glyphs[i2];
                  if ((0, _util2.isNum)(glyph)) {
                    x2 += spacingDir * glyph * fontSize / 1e3;
                    continue;
                  }
                  var restoreNeeded = false;
                  var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  var character = glyph.fontChar;
                  var accent = glyph.accent;
                  var scaledX = void 0, scaledY = void 0;
                  var width2 = glyph.width;
                  if (vertical) {
                    var vmetric = glyph.vmetric || defaultVMetrics;
                    var vx = -(glyph.vmetric ? vmetric[1] : width2 * 0.5) * widthAdvanceScale;
                    var vy = vmetric[2] * widthAdvanceScale;
                    width2 = vmetric ? -vmetric[0] : width2;
                    scaledX = vx / fontSizeScale;
                    scaledY = (x2 + vy) / fontSizeScale;
                  } else {
                    scaledX = x2 / fontSizeScale;
                    scaledY = 0;
                  }
                  if (font.remeasure && width2 > 0) {
                    var measuredWidth = ctx.measureText(character).width * 1e3 / fontSize * fontSizeScale;
                    if (width2 < measuredWidth && this.isFontSubpixelAAEnabled) {
                      var characterScaleX = width2 / measuredWidth;
                      restoreNeeded = true;
                      ctx.save();
                      ctx.scale(characterScaleX, 1);
                      scaledX /= characterScaleX;
                    } else if (width2 !== measuredWidth) {
                      scaledX += (width2 - measuredWidth) / 2e3 * fontSize / fontSizeScale;
                    }
                  }
                  if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                    if (simpleFillText && !accent) {
                      ctx.fillText(character, scaledX, scaledY);
                    } else {
                      this.paintChar(character, scaledX, scaledY, patternTransform, resetLineWidthToOne);
                      if (accent) {
                        var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform, resetLineWidthToOne);
                      }
                    }
                  }
                  var charWidth = void 0;
                  if (vertical) {
                    charWidth = width2 * widthAdvanceScale - spacing * fontDirection;
                  } else {
                    charWidth = width2 * widthAdvanceScale + spacing * fontDirection;
                  }
                  x2 += charWidth;
                  if (restoreNeeded) {
                    ctx.restore();
                  }
                }
                if (vertical) {
                  current.y -= x2;
                } else {
                  current.x += x2 * textHScale;
                }
                ctx.restore();
                this.compose();
                return void 0;
              }
            }, {
              key: "showType3Text",
              value: function showType3Text(glyphs) {
                var ctx = this.ctx;
                var current = this.current;
                var font = current.font;
                var fontSize = current.fontSize;
                var fontDirection = current.fontDirection;
                var spacingDir = font.vertical ? 1 : -1;
                var charSpacing = current.charSpacing;
                var wordSpacing = current.wordSpacing;
                var textHScale = current.textHScale * fontDirection;
                var fontMatrix = current.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                var glyphsLength = glyphs.length;
                var isTextInvisible = current.textRenderingMode === _util2.TextRenderingMode.INVISIBLE;
                var i2, glyph, width2, spacingLength;
                if (isTextInvisible || fontSize === 0) {
                  return;
                }
                this._cachedGetSinglePixelWidth = null;
                ctx.save();
                ctx.transform.apply(ctx, current.textMatrix);
                ctx.translate(current.x, current.y);
                ctx.scale(textHScale, fontDirection);
                for (i2 = 0; i2 < glyphsLength; ++i2) {
                  glyph = glyphs[i2];
                  if ((0, _util2.isNum)(glyph)) {
                    spacingLength = spacingDir * glyph * fontSize / 1e3;
                    this.ctx.translate(spacingLength, 0);
                    current.x += spacingLength * textHScale;
                    continue;
                  }
                  var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  var operatorList = font.charProcOperatorList[glyph.operatorListId];
                  if (!operatorList) {
                    (0, _util2.warn)('Type3 character "'.concat(glyph.operatorListId, '" is not available.'));
                    continue;
                  }
                  if (this.contentVisible) {
                    this.processingType3 = glyph;
                    this.save();
                    ctx.scale(fontSize, fontSize);
                    ctx.transform.apply(ctx, fontMatrix);
                    this.executeOperatorList(operatorList);
                    this.restore();
                  }
                  var transformed = _util2.Util.applyTransform([glyph.width, 0], fontMatrix);
                  width2 = transformed[0] * fontSize + spacing;
                  ctx.translate(width2, 0);
                  current.x += width2 * textHScale;
                }
                ctx.restore();
                this.processingType3 = null;
              }
            }, {
              key: "setCharWidth",
              value: function setCharWidth(xWidth, yWidth) {
              }
            }, {
              key: "setCharWidthAndBounds",
              value: function setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                this.ctx.rect(llx, lly, urx - llx, ury - lly);
                this.clip();
                this.endPath();
              }
            }, {
              key: "getColorN_Pattern",
              value: function getColorN_Pattern(IR) {
                var _this = this;
                var pattern;
                if (IR[0] === "TilingPattern") {
                  var color2 = IR[1];
                  var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
                  var canvasGraphicsFactory = {
                    createCanvasGraphics: function createCanvasGraphics(ctx) {
                      return new CanvasGraphics2(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
                    }
                  };
                  pattern = new _pattern_helper.TilingPattern(IR, color2, this.ctx, canvasGraphicsFactory, baseTransform);
                } else {
                  pattern = this._getPattern(IR[1], IR[2]);
                }
                return pattern;
              }
            }, {
              key: "setStrokeColorN",
              value: function setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
            }, {
              key: "setFillColorN",
              value: function setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments);
                this.current.patternFill = true;
              }
            }, {
              key: "setStrokeRGBColor",
              value: function setStrokeRGBColor(r2, g2, b2) {
                var color2 = _util2.Util.makeHexColor(r2, g2, b2);
                this.ctx.strokeStyle = color2;
                this.current.strokeColor = color2;
              }
            }, {
              key: "setFillRGBColor",
              value: function setFillRGBColor(r2, g2, b2) {
                var color2 = _util2.Util.makeHexColor(r2, g2, b2);
                this.ctx.fillStyle = color2;
                this.current.fillColor = color2;
                this.current.patternFill = false;
              }
            }, {
              key: "_getPattern",
              value: function _getPattern(objId) {
                var matrix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var pattern;
                if (this.cachedPatterns.has(objId)) {
                  pattern = this.cachedPatterns.get(objId);
                } else {
                  pattern = (0, _pattern_helper.getShadingPattern)(this.objs.get(objId));
                  this.cachedPatterns.set(objId, pattern);
                }
                if (matrix) {
                  pattern.matrix = matrix;
                }
                return pattern;
              }
            }, {
              key: "shadingFill",
              value: function shadingFill(objId) {
                if (!this.contentVisible) {
                  return;
                }
                var ctx = this.ctx;
                this.save();
                var pattern = this._getPattern(objId);
                ctx.fillStyle = pattern.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.SHADING);
                var inv = ctx.mozCurrentTransformInverse;
                if (inv) {
                  var canvas = ctx.canvas;
                  var width2 = canvas.width;
                  var height2 = canvas.height;
                  var bl = _util2.Util.applyTransform([0, 0], inv);
                  var br = _util2.Util.applyTransform([0, height2], inv);
                  var ul = _util2.Util.applyTransform([width2, 0], inv);
                  var ur = _util2.Util.applyTransform([width2, height2], inv);
                  var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                  var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                  var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                  var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                  this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                } else {
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                }
                this.compose(this.current.getClippedPathBoundingBox());
                this.restore();
              }
            }, {
              key: "beginInlineImage",
              value: function beginInlineImage() {
                (0, _util2.unreachable)("Should not call beginInlineImage");
              }
            }, {
              key: "beginImageData",
              value: function beginImageData() {
                (0, _util2.unreachable)("Should not call beginImageData");
              }
            }, {
              key: "paintFormXObjectBegin",
              value: function paintFormXObjectBegin(matrix, bbox) {
                if (!this.contentVisible) {
                  return;
                }
                this.save();
                this.baseTransformStack.push(this.baseTransform);
                if (Array.isArray(matrix) && matrix.length === 6) {
                  this.transform.apply(this, matrix);
                }
                this.baseTransform = this.ctx.mozCurrentTransform;
                if (bbox) {
                  var width2 = bbox[2] - bbox[0];
                  var height2 = bbox[3] - bbox[1];
                  this.ctx.rect(bbox[0], bbox[1], width2, height2);
                  this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox[0], bbox[1]);
                  this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox[2], bbox[3]);
                  this.clip();
                  this.endPath();
                }
              }
            }, {
              key: "paintFormXObjectEnd",
              value: function paintFormXObjectEnd() {
                if (!this.contentVisible) {
                  return;
                }
                this.restore();
                this.baseTransform = this.baseTransformStack.pop();
              }
            }, {
              key: "beginGroup",
              value: function beginGroup(group) {
                if (!this.contentVisible) {
                  return;
                }
                this.save();
                var suspendedCtx = this.suspendedCtx;
                if (this.current.activeSMask) {
                  this.suspendedCtx = null;
                  this.current.activeSMask = null;
                }
                var currentCtx = this.ctx;
                if (!group.isolated) {
                  (0, _util2.info)("TODO: Support non-isolated groups.");
                }
                if (group.knockout) {
                  (0, _util2.warn)("Knockout groups not supported.");
                }
                var currentTransform = currentCtx.mozCurrentTransform;
                if (group.matrix) {
                  currentCtx.transform.apply(currentCtx, group.matrix);
                }
                if (!group.bbox) {
                  throw new Error("Bounding box is required.");
                }
                var bounds = _util2.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
                var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
                bounds = _util2.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
                var offsetX = Math.floor(bounds[0]);
                var offsetY = Math.floor(bounds[1]);
                var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                var scaleX = 1, scaleY = 1;
                if (drawnWidth > MAX_GROUP_SIZE) {
                  scaleX = drawnWidth / MAX_GROUP_SIZE;
                  drawnWidth = MAX_GROUP_SIZE;
                }
                if (drawnHeight > MAX_GROUP_SIZE) {
                  scaleY = drawnHeight / MAX_GROUP_SIZE;
                  drawnHeight = MAX_GROUP_SIZE;
                }
                this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
                var cacheId = "groupAt" + this.groupLevel;
                if (group.smask) {
                  cacheId += "_smask_" + this.smaskCounter++ % 2;
                }
                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                var groupCtx = scratchCanvas.context;
                groupCtx.scale(1 / scaleX, 1 / scaleY);
                groupCtx.translate(-offsetX, -offsetY);
                groupCtx.transform.apply(groupCtx, currentTransform);
                if (group.smask) {
                  this.smaskStack.push({
                    canvas: scratchCanvas.canvas,
                    context: groupCtx,
                    offsetX,
                    offsetY,
                    scaleX,
                    scaleY,
                    subtype: group.smask.subtype,
                    backdrop: group.smask.backdrop,
                    transferMap: group.smask.transferMap || null,
                    startTransformInverse: null
                  });
                } else {
                  currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                  currentCtx.translate(offsetX, offsetY);
                  currentCtx.scale(scaleX, scaleY);
                  currentCtx.save();
                }
                copyCtxState(currentCtx, groupCtx);
                this.ctx = groupCtx;
                this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
                this.groupStack.push({
                  ctx: currentCtx,
                  suspendedCtx
                });
                this.groupLevel++;
              }
            }, {
              key: "endGroup",
              value: function endGroup(group) {
                if (!this.contentVisible) {
                  return;
                }
                this.groupLevel--;
                var groupCtx = this.ctx;
                var _this$groupStack$pop = this.groupStack.pop(), ctx = _this$groupStack$pop.ctx, suspendedCtx = _this$groupStack$pop.suspendedCtx;
                this.ctx = ctx;
                this.ctx.imageSmoothingEnabled = false;
                if (suspendedCtx) {
                  this.suspendedCtx = suspendedCtx;
                }
                if (group.smask) {
                  this.tempSMask = this.smaskStack.pop();
                  this.restore();
                } else {
                  this.ctx.restore();
                  var currentMtx = this.ctx.mozCurrentTransform;
                  this.restore();
                  this.ctx.save();
                  this.ctx.setTransform.apply(this.ctx, currentMtx);
                  var dirtyBox = _util2.Util.getAxialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx);
                  this.ctx.drawImage(groupCtx.canvas, 0, 0);
                  this.ctx.restore();
                  this.compose(dirtyBox);
                }
              }
            }, {
              key: "beginAnnotations",
              value: function beginAnnotations() {
                this.save();
                if (this.baseTransform) {
                  this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                }
              }
            }, {
              key: "endAnnotations",
              value: function endAnnotations() {
                this.restore();
              }
            }, {
              key: "beginAnnotation",
              value: function beginAnnotation(id2, rect, transform2, matrix, hasOwnCanvas) {
                this.save();
                if (Array.isArray(rect) && rect.length === 4) {
                  var width2 = rect[2] - rect[0];
                  var height2 = rect[3] - rect[1];
                  if (hasOwnCanvas && this.annotationCanvasMap) {
                    transform2 = transform2.slice();
                    transform2[4] -= rect[0];
                    transform2[5] -= rect[1];
                    rect = rect.slice();
                    rect[0] = rect[1] = 0;
                    rect[2] = width2;
                    rect[3] = height2;
                    var _Util$singularValueDe = _util2.Util.singularValueDecompose2dScale(this.ctx.mozCurrentTransform), _Util$singularValueDe2 = _slicedToArray2(_Util$singularValueDe, 2), scaleX = _Util$singularValueDe2[0], scaleY = _Util$singularValueDe2[1];
                    var viewportScale = this.viewportScale;
                    var canvasWidth = Math.ceil(width2 * this.outputScaleX * viewportScale);
                    var canvasHeight = Math.ceil(height2 * this.outputScaleY * viewportScale);
                    this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                    var _this$annotationCanva = this.annotationCanvas, canvas = _this$annotationCanva.canvas, context2 = _this$annotationCanva.context;
                    canvas.style.width = "calc(".concat(width2, "px * var(--viewport-scale-factor))");
                    canvas.style.height = "calc(".concat(height2, "px * var(--viewport-scale-factor))");
                    this.annotationCanvasMap.set(id2, canvas);
                    this.annotationCanvas.savedCtx = this.ctx;
                    this.ctx = context2;
                    this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height2 * scaleY);
                    addContextCurrentTransform(this.ctx);
                    resetCtxToDefault(this.ctx);
                  } else {
                    resetCtxToDefault(this.ctx);
                    this.ctx.rect(rect[0], rect[1], width2, height2);
                    this.clip();
                    this.endPath();
                  }
                }
                this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                this.transform.apply(this, transform2);
                this.transform.apply(this, matrix);
              }
            }, {
              key: "endAnnotation",
              value: function endAnnotation() {
                if (this.annotationCanvas) {
                  this.ctx = this.annotationCanvas.savedCtx;
                  delete this.annotationCanvas.savedCtx;
                  delete this.annotationCanvas;
                }
                this.restore();
              }
            }, {
              key: "paintImageMaskXObject",
              value: function paintImageMaskXObject(img) {
                if (!this.contentVisible) {
                  return;
                }
                var ctx = this.ctx;
                var width2 = img.width, height2 = img.height;
                var glyph = this.processingType3;
                if (glyph && glyph.compiled === void 0) {
                  if (width2 <= MAX_SIZE_TO_COMPILE && height2 <= MAX_SIZE_TO_COMPILE) {
                    glyph.compiled = compileType3Glyph({
                      data: img.data,
                      width: width2,
                      height: height2
                    });
                  } else {
                    glyph.compiled = null;
                  }
                }
                if (glyph !== null && glyph !== void 0 && glyph.compiled) {
                  glyph.compiled(ctx);
                  return;
                }
                var mask = this._createMaskCanvas(img);
                var maskCanvas = mask.canvas;
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                ctx.restore();
                this.compose();
              }
            }, {
              key: "paintImageMaskXObjectRepeat",
              value: function paintImageMaskXObjectRepeat(imgData, scaleX) {
                var skewX = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var skewY = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                var scaleY = arguments.length > 4 ? arguments[4] : void 0;
                var positions = arguments.length > 5 ? arguments[5] : void 0;
                if (!this.contentVisible) {
                  return;
                }
                var ctx = this.ctx;
                ctx.save();
                var currentTransform = ctx.mozCurrentTransform;
                ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                var mask = this._createMaskCanvas(imgData);
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                for (var i2 = 0, ii = positions.length; i2 < ii; i2 += 2) {
                  var trans = _util2.Util.transform(currentTransform, [scaleX, skewX, skewY, scaleY, positions[i2], positions[i2 + 1]]);
                  var _Util$applyTransform3 = _util2.Util.applyTransform([0, 0], trans), _Util$applyTransform4 = _slicedToArray2(_Util$applyTransform3, 2), x2 = _Util$applyTransform4[0], y2 = _Util$applyTransform4[1];
                  ctx.drawImage(mask.canvas, x2, y2);
                }
                ctx.restore();
                this.compose();
              }
            }, {
              key: "paintImageMaskXObjectGroup",
              value: function paintImageMaskXObjectGroup(images) {
                if (!this.contentVisible) {
                  return;
                }
                var ctx = this.ctx;
                var fillColor = this.current.fillColor;
                var isPatternFill = this.current.patternFill;
                for (var i2 = 0, ii = images.length; i2 < ii; i2++) {
                  var image2 = images[i2];
                  var width2 = image2.width, height2 = image2.height;
                  var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width2, height2);
                  var maskCtx = maskCanvas.context;
                  maskCtx.save();
                  putBinaryImageMask(maskCtx, image2);
                  maskCtx.globalCompositeOperation = "source-in";
                  maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL) : fillColor;
                  maskCtx.fillRect(0, 0, width2, height2);
                  maskCtx.restore();
                  ctx.save();
                  ctx.transform.apply(ctx, image2.transform);
                  ctx.scale(1, -1);
                  ctx.drawImage(maskCanvas.canvas, 0, 0, width2, height2, 0, -1, 1, 1);
                  ctx.restore();
                }
                this.compose();
              }
            }, {
              key: "paintImageXObject",
              value: function paintImageXObject(objId) {
                if (!this.contentVisible) {
                  return;
                }
                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                if (!imgData) {
                  (0, _util2.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(imgData);
              }
            }, {
              key: "paintImageXObjectRepeat",
              value: function paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                if (!this.contentVisible) {
                  return;
                }
                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                if (!imgData) {
                  (0, _util2.warn)("Dependent image isn't ready yet");
                  return;
                }
                var width2 = imgData.width;
                var height2 = imgData.height;
                var map = [];
                for (var i2 = 0, ii = positions.length; i2 < ii; i2 += 2) {
                  map.push({
                    transform: [scaleX, 0, 0, scaleY, positions[i2], positions[i2 + 1]],
                    x: 0,
                    y: 0,
                    w: width2,
                    h: height2
                  });
                }
                this.paintInlineImageXObjectGroup(imgData, map);
              }
            }, {
              key: "paintInlineImageXObject",
              value: function paintInlineImageXObject(imgData) {
                if (!this.contentVisible) {
                  return;
                }
                var width2 = imgData.width;
                var height2 = imgData.height;
                var ctx = this.ctx;
                this.save();
                ctx.scale(1 / width2, -1 / height2);
                var imgToPaint;
                if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
                  imgToPaint = imgData;
                } else {
                  var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width2, height2);
                  var tmpCtx = tmpCanvas.context;
                  putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                  imgToPaint = tmpCanvas.canvas;
                }
                var scaled = this._scaleImage(imgToPaint, ctx.mozCurrentTransformInverse);
                ctx.imageSmoothingEnabled = getImageSmoothingEnabled(ctx.mozCurrentTransform, imgData.interpolate);
                ctx.drawImage(scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height2, width2, height2);
                if (this.imageLayer) {
                  var position = this.getCanvasPosition(0, -height2);
                  this.imageLayer.appendImage({
                    imgData,
                    left: position[0],
                    top: position[1],
                    width: width2 / ctx.mozCurrentTransformInverse[0],
                    height: height2 / ctx.mozCurrentTransformInverse[3]
                  });
                }
                this.compose();
                this.restore();
              }
            }, {
              key: "paintInlineImageXObjectGroup",
              value: function paintInlineImageXObjectGroup(imgData, map) {
                if (!this.contentVisible) {
                  return;
                }
                var ctx = this.ctx;
                var w2 = imgData.width;
                var h2 = imgData.height;
                var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w2, h2);
                var tmpCtx = tmpCanvas.context;
                putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                for (var i2 = 0, ii = map.length; i2 < ii; i2++) {
                  var entry = map[i2];
                  ctx.save();
                  ctx.transform.apply(ctx, entry.transform);
                  ctx.scale(1, -1);
                  ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                  if (this.imageLayer) {
                    var position = this.getCanvasPosition(entry.x, entry.y);
                    this.imageLayer.appendImage({
                      imgData,
                      left: position[0],
                      top: position[1],
                      width: w2,
                      height: h2
                    });
                  }
                  ctx.restore();
                }
                this.compose();
              }
            }, {
              key: "paintSolidColorImageMask",
              value: function paintSolidColorImageMask() {
                if (!this.contentVisible) {
                  return;
                }
                this.ctx.fillRect(0, 0, 1, 1);
                this.compose();
              }
            }, {
              key: "markPoint",
              value: function markPoint(tag) {
              }
            }, {
              key: "markPointProps",
              value: function markPointProps(tag, properties) {
              }
            }, {
              key: "beginMarkedContent",
              value: function beginMarkedContent(tag) {
                this.markedContentStack.push({
                  visible: true
                });
              }
            }, {
              key: "beginMarkedContentProps",
              value: function beginMarkedContentProps(tag, properties) {
                if (tag === "OC") {
                  this.markedContentStack.push({
                    visible: this.optionalContentConfig.isVisible(properties)
                  });
                } else {
                  this.markedContentStack.push({
                    visible: true
                  });
                }
                this.contentVisible = this.isContentVisible();
              }
            }, {
              key: "endMarkedContent",
              value: function endMarkedContent() {
                this.markedContentStack.pop();
                this.contentVisible = this.isContentVisible();
              }
            }, {
              key: "beginCompat",
              value: function beginCompat() {
              }
            }, {
              key: "endCompat",
              value: function endCompat() {
              }
            }, {
              key: "consumePath",
              value: function consumePath(clipBox) {
                if (this.pendingClip) {
                  this.current.updateClipFromPath();
                }
                if (!this.pendingClip) {
                  this.compose(clipBox);
                }
                var ctx = this.ctx;
                if (this.pendingClip) {
                  if (this.pendingClip === EO_CLIP) {
                    ctx.clip("evenodd");
                  } else {
                    ctx.clip();
                  }
                  this.pendingClip = null;
                }
                this.current.startNewPathAndClipBox(this.current.clipBox);
                ctx.beginPath();
              }
            }, {
              key: "getSinglePixelWidth",
              value: function getSinglePixelWidth() {
                if (this._cachedGetSinglePixelWidth === null) {
                  var m2 = this.ctx.mozCurrentTransform;
                  var absDet = Math.abs(m2[0] * m2[3] - m2[2] * m2[1]);
                  var sqNorm1 = Math.pow(m2[0], 2) + Math.pow(m2[2], 2);
                  var sqNorm2 = Math.pow(m2[1], 2) + Math.pow(m2[3], 2);
                  var pixelHeight = Math.sqrt(Math.max(sqNorm1, sqNorm2)) / absDet;
                  if (sqNorm1 !== sqNorm2 && this._combinedScaleFactor * pixelHeight > 1) {
                    this._cachedGetSinglePixelWidth = -(this._combinedScaleFactor * pixelHeight);
                  } else if (absDet > Number.EPSILON) {
                    this._cachedGetSinglePixelWidth = pixelHeight;
                  } else {
                    this._cachedGetSinglePixelWidth = 1;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
            }, {
              key: "getCanvasPosition",
              value: function getCanvasPosition(x2, y2) {
                var transform2 = this.ctx.mozCurrentTransform;
                return [transform2[0] * x2 + transform2[2] * y2 + transform2[4], transform2[1] * x2 + transform2[3] * y2 + transform2[5]];
              }
            }, {
              key: "isContentVisible",
              value: function isContentVisible() {
                for (var i2 = this.markedContentStack.length - 1; i2 >= 0; i2--) {
                  if (!this.markedContentStack[i2].visible) {
                    return false;
                  }
                }
                return true;
              }
            }]);
            return CanvasGraphics2;
          }();
          exports2.CanvasGraphics = CanvasGraphics;
          for (var op2 in _util2.OPS) {
            if (CanvasGraphics.prototype[op2] !== void 0) {
              CanvasGraphics.prototype[_util2.OPS[op2]] = CanvasGraphics.prototype[op2];
            }
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.TilingPattern = exports2.PathType = void 0;
          exports2.getShadingPattern = getShadingPattern;
          var _util2 = __w_pdfjs_require__2(4);
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var PathType = {
            FILL: "Fill",
            STROKE: "Stroke",
            SHADING: "Shading"
          };
          exports2.PathType = PathType;
          function applyBoundingBox(ctx, bbox) {
            if (!bbox || typeof Path2D === "undefined") {
              return;
            }
            var width2 = bbox[2] - bbox[0];
            var height2 = bbox[3] - bbox[1];
            var region = new Path2D();
            region.rect(bbox[0], bbox[1], width2, height2);
            ctx.clip(region);
          }
          var BaseShadingPattern = /* @__PURE__ */ function() {
            function BaseShadingPattern2() {
              _classCallCheck2(this, BaseShadingPattern2);
              if (this.constructor === BaseShadingPattern2) {
                (0, _util2.unreachable)("Cannot initialize BaseShadingPattern.");
              }
            }
            _createClass2(BaseShadingPattern2, [{
              key: "getPattern",
              value: function getPattern() {
                (0, _util2.unreachable)("Abstract method `getPattern` called.");
              }
            }]);
            return BaseShadingPattern2;
          }();
          var RadialAxialShadingPattern = /* @__PURE__ */ function(_BaseShadingPattern) {
            _inherits2(RadialAxialShadingPattern2, _BaseShadingPattern);
            var _super = _createSuper2(RadialAxialShadingPattern2);
            function RadialAxialShadingPattern2(IR) {
              var _this;
              _classCallCheck2(this, RadialAxialShadingPattern2);
              _this = _super.call(this);
              _this._type = IR[1];
              _this._bbox = IR[2];
              _this._colorStops = IR[3];
              _this._p0 = IR[4];
              _this._p1 = IR[5];
              _this._r0 = IR[6];
              _this._r1 = IR[7];
              _this.matrix = null;
              return _this;
            }
            _createClass2(RadialAxialShadingPattern2, [{
              key: "_createGradient",
              value: function _createGradient(ctx) {
                var grad;
                if (this._type === "axial") {
                  grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                } else if (this._type === "radial") {
                  grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                }
                var _iterator = _createForOfIteratorHelper2(this._colorStops), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var colorStop = _step.value;
                    grad.addColorStop(colorStop[0], colorStop[1]);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                return grad;
              }
            }, {
              key: "getPattern",
              value: function getPattern(ctx, owner, inverse, pathType) {
                var pattern;
                if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                  var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, ctx.mozCurrentTransform) || [0, 0, 0, 0];
                  var width2 = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                  var height2 = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                  var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width2, height2, true);
                  var tmpCtx = tmpCanvas.context;
                  tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                  tmpCtx.beginPath();
                  tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                  tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                  inverse = _util2.Util.transform(inverse, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
                  tmpCtx.transform.apply(tmpCtx, owner.baseTransform);
                  if (this.matrix) {
                    tmpCtx.transform.apply(tmpCtx, this.matrix);
                  }
                  applyBoundingBox(tmpCtx, this._bbox);
                  tmpCtx.fillStyle = this._createGradient(tmpCtx);
                  tmpCtx.fill();
                  pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                  var domMatrix = new DOMMatrix(inverse);
                  try {
                    pattern.setTransform(domMatrix);
                  } catch (ex) {
                    (0, _util2.warn)('RadialAxialShadingPattern.getPattern: "'.concat(ex === null || ex === void 0 ? void 0 : ex.message, '".'));
                  }
                } else {
                  applyBoundingBox(ctx, this._bbox);
                  pattern = this._createGradient(ctx);
                }
                return pattern;
              }
            }]);
            return RadialAxialShadingPattern2;
          }(BaseShadingPattern);
          function drawTriangle(data2, context2, p1, p2, p3, c1, c2, c3) {
            var coords2 = context2.coords, colors = context2.colors;
            var bytes = data2.data, rowSize = data2.width * 4;
            var tmp;
            if (coords2[p1 + 1] > coords2[p2 + 1]) {
              tmp = p1;
              p1 = p2;
              p2 = tmp;
              tmp = c1;
              c1 = c2;
              c2 = tmp;
            }
            if (coords2[p2 + 1] > coords2[p3 + 1]) {
              tmp = p2;
              p2 = p3;
              p3 = tmp;
              tmp = c2;
              c2 = c3;
              c3 = tmp;
            }
            if (coords2[p1 + 1] > coords2[p2 + 1]) {
              tmp = p1;
              p1 = p2;
              p2 = tmp;
              tmp = c1;
              c1 = c2;
              c2 = tmp;
            }
            var x1 = (coords2[p1] + context2.offsetX) * context2.scaleX;
            var y1 = (coords2[p1 + 1] + context2.offsetY) * context2.scaleY;
            var x2 = (coords2[p2] + context2.offsetX) * context2.scaleX;
            var y2 = (coords2[p2 + 1] + context2.offsetY) * context2.scaleY;
            var x3 = (coords2[p3] + context2.offsetX) * context2.scaleX;
            var y3 = (coords2[p3 + 1] + context2.offsetY) * context2.scaleY;
            if (y1 >= y3) {
              return;
            }
            var c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
            var c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
            var c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
            var minY = Math.round(y1), maxY = Math.round(y3);
            var xa, car, cag, cab;
            var xb, cbr, cbg, cbb;
            for (var y4 = minY; y4 <= maxY; y4++) {
              if (y4 < y2) {
                var _k = void 0;
                if (y4 < y1) {
                  _k = 0;
                } else {
                  _k = (y1 - y4) / (y1 - y2);
                }
                xa = x1 - (x1 - x2) * _k;
                car = c1r - (c1r - c2r) * _k;
                cag = c1g - (c1g - c2g) * _k;
                cab = c1b - (c1b - c2b) * _k;
              } else {
                var _k2 = void 0;
                if (y4 > y3) {
                  _k2 = 1;
                } else if (y2 === y3) {
                  _k2 = 0;
                } else {
                  _k2 = (y2 - y4) / (y2 - y3);
                }
                xa = x2 - (x2 - x3) * _k2;
                car = c2r - (c2r - c3r) * _k2;
                cag = c2g - (c2g - c3g) * _k2;
                cab = c2b - (c2b - c3b) * _k2;
              }
              var k3 = void 0;
              if (y4 < y1) {
                k3 = 0;
              } else if (y4 > y3) {
                k3 = 1;
              } else {
                k3 = (y1 - y4) / (y1 - y3);
              }
              xb = x1 - (x1 - x3) * k3;
              cbr = c1r - (c1r - c3r) * k3;
              cbg = c1g - (c1g - c3g) * k3;
              cbb = c1b - (c1b - c3b) * k3;
              var x1_ = Math.round(Math.min(xa, xb));
              var x2_ = Math.round(Math.max(xa, xb));
              var j2 = rowSize * y4 + x1_ * 4;
              for (var x4 = x1_; x4 <= x2_; x4++) {
                k3 = (xa - x4) / (xa - xb);
                if (k3 < 0) {
                  k3 = 0;
                } else if (k3 > 1) {
                  k3 = 1;
                }
                bytes[j2++] = car - (car - cbr) * k3 | 0;
                bytes[j2++] = cag - (cag - cbg) * k3 | 0;
                bytes[j2++] = cab - (cab - cbb) * k3 | 0;
                bytes[j2++] = 255;
              }
            }
          }
          function drawFigure(data2, figure, context2) {
            var ps = figure.coords;
            var cs = figure.colors;
            var i2, ii;
            switch (figure.type) {
              case "lattice":
                var verticesPerRow = figure.verticesPerRow;
                var rows = Math.floor(ps.length / verticesPerRow) - 1;
                var cols = verticesPerRow - 1;
                for (i2 = 0; i2 < rows; i2++) {
                  var q2 = i2 * verticesPerRow;
                  for (var j2 = 0; j2 < cols; j2++, q2++) {
                    drawTriangle(data2, context2, ps[q2], ps[q2 + 1], ps[q2 + verticesPerRow], cs[q2], cs[q2 + 1], cs[q2 + verticesPerRow]);
                    drawTriangle(data2, context2, ps[q2 + verticesPerRow + 1], ps[q2 + 1], ps[q2 + verticesPerRow], cs[q2 + verticesPerRow + 1], cs[q2 + 1], cs[q2 + verticesPerRow]);
                  }
                }
                break;
              case "triangles":
                for (i2 = 0, ii = ps.length; i2 < ii; i2 += 3) {
                  drawTriangle(data2, context2, ps[i2], ps[i2 + 1], ps[i2 + 2], cs[i2], cs[i2 + 1], cs[i2 + 2]);
                }
                break;
              default:
                throw new Error("illegal figure");
            }
          }
          var MeshShadingPattern = /* @__PURE__ */ function(_BaseShadingPattern2) {
            _inherits2(MeshShadingPattern2, _BaseShadingPattern2);
            var _super2 = _createSuper2(MeshShadingPattern2);
            function MeshShadingPattern2(IR) {
              var _this2;
              _classCallCheck2(this, MeshShadingPattern2);
              _this2 = _super2.call(this);
              _this2._coords = IR[2];
              _this2._colors = IR[3];
              _this2._figures = IR[4];
              _this2._bounds = IR[5];
              _this2._bbox = IR[7];
              _this2._background = IR[8];
              _this2.matrix = null;
              return _this2;
            }
            _createClass2(MeshShadingPattern2, [{
              key: "_createMeshCanvas",
              value: function _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                var EXPECTED_SCALE = 1.1;
                var MAX_PATTERN_SIZE = 3e3;
                var BORDER_SIZE = 2;
                var offsetX = Math.floor(this._bounds[0]);
                var offsetY = Math.floor(this._bounds[1]);
                var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                var width2 = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                var height2 = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                var scaleX = boundsWidth / width2;
                var scaleY = boundsHeight / height2;
                var context2 = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -offsetX,
                  offsetY: -offsetY,
                  scaleX: 1 / scaleX,
                  scaleY: 1 / scaleY
                };
                var paddedWidth = width2 + BORDER_SIZE * 2;
                var paddedHeight = height2 + BORDER_SIZE * 2;
                var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                var tmpCtx = tmpCanvas.context;
                var data2 = tmpCtx.createImageData(width2, height2);
                if (backgroundColor) {
                  var bytes = data2.data;
                  for (var i2 = 0, ii = bytes.length; i2 < ii; i2 += 4) {
                    bytes[i2] = backgroundColor[0];
                    bytes[i2 + 1] = backgroundColor[1];
                    bytes[i2 + 2] = backgroundColor[2];
                    bytes[i2 + 3] = 255;
                  }
                }
                var _iterator2 = _createForOfIteratorHelper2(this._figures), _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var figure = _step2.value;
                    drawFigure(data2, figure, context2);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                tmpCtx.putImageData(data2, BORDER_SIZE, BORDER_SIZE);
                var canvas = tmpCanvas.canvas;
                return {
                  canvas,
                  offsetX: offsetX - BORDER_SIZE * scaleX,
                  offsetY: offsetY - BORDER_SIZE * scaleY,
                  scaleX,
                  scaleY
                };
              }
            }, {
              key: "getPattern",
              value: function getPattern(ctx, owner, inverse, pathType) {
                applyBoundingBox(ctx, this._bbox);
                var scale2;
                if (pathType === PathType.SHADING) {
                  scale2 = _util2.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
                } else {
                  scale2 = _util2.Util.singularValueDecompose2dScale(owner.baseTransform);
                  if (this.matrix) {
                    var matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                    scale2 = [scale2[0] * matrixScale[0], scale2[1] * matrixScale[1]];
                  }
                }
                var temporaryPatternCanvas = this._createMeshCanvas(scale2, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                if (pathType !== PathType.SHADING) {
                  ctx.setTransform.apply(ctx, owner.baseTransform);
                  if (this.matrix) {
                    ctx.transform.apply(ctx, this.matrix);
                  }
                }
                ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
              }
            }]);
            return MeshShadingPattern2;
          }(BaseShadingPattern);
          var DummyShadingPattern = /* @__PURE__ */ function(_BaseShadingPattern3) {
            _inherits2(DummyShadingPattern2, _BaseShadingPattern3);
            var _super3 = _createSuper2(DummyShadingPattern2);
            function DummyShadingPattern2() {
              _classCallCheck2(this, DummyShadingPattern2);
              return _super3.apply(this, arguments);
            }
            _createClass2(DummyShadingPattern2, [{
              key: "getPattern",
              value: function getPattern() {
                return "hotpink";
              }
            }]);
            return DummyShadingPattern2;
          }(BaseShadingPattern);
          function getShadingPattern(IR) {
            switch (IR[0]) {
              case "RadialAxial":
                return new RadialAxialShadingPattern(IR);
              case "Mesh":
                return new MeshShadingPattern(IR);
              case "Dummy":
                return new DummyShadingPattern();
            }
            throw new Error("Unknown IR type: ".concat(IR[0]));
          }
          var PaintType = {
            COLORED: 1,
            UNCOLORED: 2
          };
          var TilingPattern = /* @__PURE__ */ function() {
            function TilingPattern2(IR, color2, ctx, canvasGraphicsFactory, baseTransform) {
              _classCallCheck2(this, TilingPattern2);
              this.operatorList = IR[2];
              this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
              this.bbox = IR[4];
              this.xstep = IR[5];
              this.ystep = IR[6];
              this.paintType = IR[7];
              this.tilingType = IR[8];
              this.color = color2;
              this.ctx = ctx;
              this.canvasGraphicsFactory = canvasGraphicsFactory;
              this.baseTransform = baseTransform;
            }
            _createClass2(TilingPattern2, [{
              key: "createPatternCanvas",
              value: function createPatternCanvas(owner) {
                var operatorList = this.operatorList;
                var bbox = this.bbox;
                var xstep = this.xstep;
                var ystep = this.ystep;
                var paintType = this.paintType;
                var tilingType = this.tilingType;
                var color2 = this.color;
                var canvasGraphicsFactory = this.canvasGraphicsFactory;
                (0, _util2.info)("TilingType: " + tilingType);
                var x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                var matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                var curMatrixScale = _util2.Util.singularValueDecompose2dScale(this.baseTransform);
                var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
                var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                var tmpCtx = tmpCanvas.context;
                var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                graphics.groupLevel = owner.groupLevel;
                this.setFillAndStrokeStyleToContext(graphics, paintType, color2);
                var adjustedX0 = x0;
                var adjustedY0 = y0;
                var adjustedX1 = x1;
                var adjustedY1 = y1;
                if (x0 < 0) {
                  adjustedX0 = 0;
                  adjustedX1 += Math.abs(x0);
                }
                if (y0 < 0) {
                  adjustedY0 = 0;
                  adjustedY1 += Math.abs(y0);
                }
                tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                graphics.baseTransform = graphics.ctx.mozCurrentTransform.slice();
                graphics.executeOperatorList(operatorList);
                graphics.endDrawing();
                return {
                  canvas: tmpCanvas.canvas,
                  scaleX: dimx.scale,
                  scaleY: dimy.scale,
                  offsetX: adjustedX0,
                  offsetY: adjustedY0
                };
              }
            }, {
              key: "getSizeAndScale",
              value: function getSizeAndScale(step2, realOutputSize, scale2) {
                step2 = Math.abs(step2);
                var maxSize = Math.max(TilingPattern2.MAX_PATTERN_SIZE, realOutputSize);
                var size = Math.ceil(step2 * scale2);
                if (size >= maxSize) {
                  size = maxSize;
                } else {
                  scale2 = size / step2;
                }
                return {
                  scale: scale2,
                  size
                };
              }
            }, {
              key: "clipBbox",
              value: function clipBbox(graphics, x0, y0, x1, y1) {
                var bboxWidth = x1 - x0;
                var bboxHeight = y1 - y0;
                graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                graphics.clip();
                graphics.endPath();
              }
            }, {
              key: "setFillAndStrokeStyleToContext",
              value: function setFillAndStrokeStyleToContext(graphics, paintType, color2) {
                var context2 = graphics.ctx, current = graphics.current;
                switch (paintType) {
                  case PaintType.COLORED:
                    var ctx = this.ctx;
                    context2.fillStyle = ctx.fillStyle;
                    context2.strokeStyle = ctx.strokeStyle;
                    current.fillColor = ctx.fillStyle;
                    current.strokeColor = ctx.strokeStyle;
                    break;
                  case PaintType.UNCOLORED:
                    var cssColor = _util2.Util.makeHexColor(color2[0], color2[1], color2[2]);
                    context2.fillStyle = cssColor;
                    context2.strokeStyle = cssColor;
                    current.fillColor = cssColor;
                    current.strokeColor = cssColor;
                    break;
                  default:
                    throw new _util2.FormatError("Unsupported paint type: ".concat(paintType));
                }
              }
            }, {
              key: "getPattern",
              value: function getPattern(ctx, owner, inverse, pathType) {
                var matrix = inverse;
                if (pathType !== PathType.SHADING) {
                  matrix = _util2.Util.transform(matrix, owner.baseTransform);
                  if (this.matrix) {
                    matrix = _util2.Util.transform(matrix, this.matrix);
                  }
                }
                var temporaryPatternCanvas = this.createPatternCanvas(owner);
                var domMatrix = new DOMMatrix(matrix);
                domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                try {
                  pattern.setTransform(domMatrix);
                } catch (ex) {
                  (0, _util2.warn)('TilingPattern.getPattern: "'.concat(ex === null || ex === void 0 ? void 0 : ex.message, '".'));
                }
                return pattern;
              }
            }], [{
              key: "MAX_PATTERN_SIZE",
              get: function get2() {
                return (0, _util2.shadow)(this, "MAX_PATTERN_SIZE", 3e3);
              }
            }]);
            return TilingPattern2;
          }();
          exports2.TilingPattern = TilingPattern;
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.GlobalWorkerOptions = void 0;
          var GlobalWorkerOptions = /* @__PURE__ */ Object.create(null);
          exports2.GlobalWorkerOptions = GlobalWorkerOptions;
          GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === void 0 ? null : GlobalWorkerOptions.workerPort;
          GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === void 0 ? "" : GlobalWorkerOptions.workerSrc;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.MessageHandler = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          var CallbackKind = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          };
          var StreamKind = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function wrapReason(reason) {
            if (!(reason instanceof Error || _typeof2(reason) === "object" && reason !== null)) {
              (0, _util2.warn)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
              return reason;
            }
            switch (reason.name) {
              case "AbortException":
                return new _util2.AbortException(reason.message);
              case "MissingPDFException":
                return new _util2.MissingPDFException(reason.message);
              case "PasswordException":
                return new _util2.PasswordException(reason.message, reason.code);
              case "UnexpectedResponseException":
                return new _util2.UnexpectedResponseException(reason.message, reason.status);
              case "UnknownErrorException":
                return new _util2.UnknownErrorException(reason.message, reason.details);
              default:
                return new _util2.UnknownErrorException(reason.message, reason.toString());
            }
          }
          var MessageHandler = /* @__PURE__ */ function() {
            function MessageHandler2(sourceName, targetName, comObj) {
              var _this = this;
              _classCallCheck2(this, MessageHandler2);
              this.sourceName = sourceName;
              this.targetName = targetName;
              this.comObj = comObj;
              this.callbackId = 1;
              this.streamId = 1;
              this.streamSinks = /* @__PURE__ */ Object.create(null);
              this.streamControllers = /* @__PURE__ */ Object.create(null);
              this.callbackCapabilities = /* @__PURE__ */ Object.create(null);
              this.actionHandler = /* @__PURE__ */ Object.create(null);
              this._onComObjOnMessage = function(event) {
                var data2 = event.data;
                if (data2.targetName !== _this.sourceName) {
                  return;
                }
                if (data2.stream) {
                  _this._processStreamMessage(data2);
                  return;
                }
                if (data2.callback) {
                  var callbackId = data2.callbackId;
                  var capability = _this.callbackCapabilities[callbackId];
                  if (!capability) {
                    throw new Error("Cannot resolve callback ".concat(callbackId));
                  }
                  delete _this.callbackCapabilities[callbackId];
                  if (data2.callback === CallbackKind.DATA) {
                    capability.resolve(data2.data);
                  } else if (data2.callback === CallbackKind.ERROR) {
                    capability.reject(wrapReason(data2.reason));
                  } else {
                    throw new Error("Unexpected callback case");
                  }
                  return;
                }
                var action = _this.actionHandler[data2.action];
                if (!action) {
                  throw new Error("Unknown action from worker: ".concat(data2.action));
                }
                if (data2.callbackId) {
                  var cbSourceName = _this.sourceName;
                  var cbTargetName = data2.sourceName;
                  new Promise(function(resolve) {
                    resolve(action(data2.data));
                  }).then(function(result2) {
                    comObj.postMessage({
                      sourceName: cbSourceName,
                      targetName: cbTargetName,
                      callback: CallbackKind.DATA,
                      callbackId: data2.callbackId,
                      data: result2
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName: cbSourceName,
                      targetName: cbTargetName,
                      callback: CallbackKind.ERROR,
                      callbackId: data2.callbackId,
                      reason: wrapReason(reason)
                    });
                  });
                  return;
                }
                if (data2.streamId) {
                  _this._createStreamSink(data2);
                  return;
                }
                action(data2.data);
              };
              comObj.addEventListener("message", this._onComObjOnMessage);
            }
            _createClass2(MessageHandler2, [{
              key: "on",
              value: function on(actionName, handler) {
                var ah = this.actionHandler;
                if (ah[actionName]) {
                  throw new Error('There is already an actionName called "'.concat(actionName, '"'));
                }
                ah[actionName] = handler;
              }
            }, {
              key: "send",
              value: function send(actionName, data2, transfers) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: actionName,
                  data: data2
                }, transfers);
              }
            }, {
              key: "sendWithPromise",
              value: function sendWithPromise(actionName, data2, transfers) {
                var callbackId = this.callbackId++;
                var capability = (0, _util2.createPromiseCapability)();
                this.callbackCapabilities[callbackId] = capability;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: actionName,
                    callbackId,
                    data: data2
                  }, transfers);
                } catch (ex) {
                  capability.reject(ex);
                }
                return capability.promise;
              }
            }, {
              key: "sendWithStream",
              value: function sendWithStream(actionName, data2, queueingStrategy, transfers) {
                var _this2 = this;
                var streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                return new ReadableStream({
                  start: function start(controller) {
                    var startCapability = (0, _util2.createPromiseCapability)();
                    _this2.streamControllers[streamId] = {
                      controller,
                      startCall: startCapability,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: false
                    };
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      action: actionName,
                      streamId,
                      data: data2,
                      desiredSize: controller.desiredSize
                    }, transfers);
                    return startCapability.promise;
                  },
                  pull: function pull(controller) {
                    var pullCapability = (0, _util2.createPromiseCapability)();
                    _this2.streamControllers[streamId].pullCall = pullCapability;
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL,
                      streamId,
                      desiredSize: controller.desiredSize
                    });
                    return pullCapability.promise;
                  },
                  cancel: function cancel(reason) {
                    (0, _util2.assert)(reason instanceof Error, "cancel must have a valid reason");
                    var cancelCapability = (0, _util2.createPromiseCapability)();
                    _this2.streamControllers[streamId].cancelCall = cancelCapability;
                    _this2.streamControllers[streamId].isClosed = true;
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CANCEL,
                      streamId,
                      reason: wrapReason(reason)
                    });
                    return cancelCapability.promise;
                  }
                }, queueingStrategy);
              }
            }, {
              key: "_createStreamSink",
              value: function _createStreamSink(data2) {
                var streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
                var self2 = this, action = this.actionHandler[data2.action];
                var streamSink = {
                  enqueue: function enqueue(chunk) {
                    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                    var transfers = arguments.length > 2 ? arguments[2] : void 0;
                    if (this.isCancelled) {
                      return;
                    }
                    var lastDesiredSize = this.desiredSize;
                    this.desiredSize -= size;
                    if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                      this.sinkCapability = (0, _util2.createPromiseCapability)();
                      this.ready = this.sinkCapability.promise;
                    }
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.ENQUEUE,
                      streamId,
                      chunk
                    }, transfers);
                  },
                  close: function close() {
                    if (this.isCancelled) {
                      return;
                    }
                    this.isCancelled = true;
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CLOSE,
                      streamId
                    });
                    delete self2.streamSinks[streamId];
                  },
                  error: function error3(reason) {
                    (0, _util2.assert)(reason instanceof Error, "error must have a valid reason");
                    if (this.isCancelled) {
                      return;
                    }
                    this.isCancelled = true;
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.ERROR,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  },
                  sinkCapability: (0, _util2.createPromiseCapability)(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: false,
                  desiredSize: data2.desiredSize,
                  ready: null
                };
                streamSink.sinkCapability.resolve();
                streamSink.ready = streamSink.sinkCapability.promise;
                this.streamSinks[streamId] = streamSink;
                new Promise(function(resolve) {
                  resolve(action(data2.data, streamSink));
                }).then(function() {
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.START_COMPLETE,
                    streamId,
                    success: true
                  });
                }, function(reason) {
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.START_COMPLETE,
                    streamId,
                    reason: wrapReason(reason)
                  });
                });
              }
            }, {
              key: "_processStreamMessage",
              value: function _processStreamMessage(data2) {
                var streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
                var streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                switch (data2.stream) {
                  case StreamKind.START_COMPLETE:
                    if (data2.success) {
                      streamController.startCall.resolve();
                    } else {
                      streamController.startCall.reject(wrapReason(data2.reason));
                    }
                    break;
                  case StreamKind.PULL_COMPLETE:
                    if (data2.success) {
                      streamController.pullCall.resolve();
                    } else {
                      streamController.pullCall.reject(wrapReason(data2.reason));
                    }
                    break;
                  case StreamKind.PULL:
                    if (!streamSink) {
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.PULL_COMPLETE,
                        streamId,
                        success: true
                      });
                      break;
                    }
                    if (streamSink.desiredSize <= 0 && data2.desiredSize > 0) {
                      streamSink.sinkCapability.resolve();
                    }
                    streamSink.desiredSize = data2.desiredSize;
                    new Promise(function(resolve) {
                      resolve(streamSink.onPull && streamSink.onPull());
                    }).then(function() {
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.PULL_COMPLETE,
                        streamId,
                        success: true
                      });
                    }, function(reason) {
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.PULL_COMPLETE,
                        streamId,
                        reason: wrapReason(reason)
                      });
                    });
                    break;
                  case StreamKind.ENQUEUE:
                    (0, _util2.assert)(streamController, "enqueue should have stream controller");
                    if (streamController.isClosed) {
                      break;
                    }
                    streamController.controller.enqueue(data2.chunk);
                    break;
                  case StreamKind.CLOSE:
                    (0, _util2.assert)(streamController, "close should have stream controller");
                    if (streamController.isClosed) {
                      break;
                    }
                    streamController.isClosed = true;
                    streamController.controller.close();
                    this._deleteStreamController(streamController, streamId);
                    break;
                  case StreamKind.ERROR:
                    (0, _util2.assert)(streamController, "error should have stream controller");
                    streamController.controller.error(wrapReason(data2.reason));
                    this._deleteStreamController(streamController, streamId);
                    break;
                  case StreamKind.CANCEL_COMPLETE:
                    if (data2.success) {
                      streamController.cancelCall.resolve();
                    } else {
                      streamController.cancelCall.reject(wrapReason(data2.reason));
                    }
                    this._deleteStreamController(streamController, streamId);
                    break;
                  case StreamKind.CANCEL:
                    if (!streamSink) {
                      break;
                    }
                    new Promise(function(resolve) {
                      resolve(streamSink.onCancel && streamSink.onCancel(wrapReason(data2.reason)));
                    }).then(function() {
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.CANCEL_COMPLETE,
                        streamId,
                        success: true
                      });
                    }, function(reason) {
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.CANCEL_COMPLETE,
                        streamId,
                        reason: wrapReason(reason)
                      });
                    });
                    streamSink.sinkCapability.reject(wrapReason(data2.reason));
                    streamSink.isCancelled = true;
                    delete this.streamSinks[streamId];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
            }, {
              key: "_deleteStreamController",
              value: function() {
                var _deleteStreamController2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee(streamController, streamId) {
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return Promise.allSettled([streamController.startCall && streamController.startCall.promise, streamController.pullCall && streamController.pullCall.promise, streamController.cancelCall && streamController.cancelCall.promise]);
                        case 2:
                          delete this.streamControllers[streamId];
                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function _deleteStreamController(_x, _x2) {
                  return _deleteStreamController2.apply(this, arguments);
                }
                return _deleteStreamController;
              }()
            }, {
              key: "destroy",
              value: function destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }]);
            return MessageHandler2;
          }();
          exports2.MessageHandler = MessageHandler;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.Metadata = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _classPrivateFieldInitSpec2(obj, privateMap, value) {
            _checkPrivateRedeclaration2(obj, privateMap);
            privateMap.set(obj, value);
          }
          function _checkPrivateRedeclaration2(obj, privateCollection) {
            if (privateCollection.has(obj)) {
              throw new TypeError("Cannot initialize the same private elements twice on an object");
            }
          }
          function _classPrivateFieldGet2(receiver, privateMap) {
            var descriptor = _classExtractFieldDescriptor2(receiver, privateMap, "get");
            return _classApplyDescriptorGet2(receiver, descriptor);
          }
          function _classApplyDescriptorGet2(receiver, descriptor) {
            if (descriptor.get) {
              return descriptor.get.call(receiver);
            }
            return descriptor.value;
          }
          function _classPrivateFieldSet2(receiver, privateMap, value) {
            var descriptor = _classExtractFieldDescriptor2(receiver, privateMap, "set");
            _classApplyDescriptorSet2(receiver, descriptor, value);
            return value;
          }
          function _classExtractFieldDescriptor2(receiver, privateMap, action) {
            if (!privateMap.has(receiver)) {
              throw new TypeError("attempted to " + action + " private field on non-instance");
            }
            return privateMap.get(receiver);
          }
          function _classApplyDescriptorSet2(receiver, descriptor, value) {
            if (descriptor.set) {
              descriptor.set.call(receiver, value);
            } else {
              if (!descriptor.writable) {
                throw new TypeError("attempted to set read only private field");
              }
              descriptor.value = value;
            }
          }
          var _metadataMap = /* @__PURE__ */ new WeakMap();
          var _data = /* @__PURE__ */ new WeakMap();
          var Metadata2 = /* @__PURE__ */ function() {
            function Metadata3(_ref) {
              var parsedData = _ref.parsedData, rawData = _ref.rawData;
              _classCallCheck2(this, Metadata3);
              _classPrivateFieldInitSpec2(this, _metadataMap, {
                writable: true,
                value: void 0
              });
              _classPrivateFieldInitSpec2(this, _data, {
                writable: true,
                value: void 0
              });
              _classPrivateFieldSet2(this, _metadataMap, parsedData);
              _classPrivateFieldSet2(this, _data, rawData);
            }
            _createClass2(Metadata3, [{
              key: "getRaw",
              value: function getRaw() {
                return _classPrivateFieldGet2(this, _data);
              }
            }, {
              key: "get",
              value: function get2(name) {
                var _classPrivateFieldGet22;
                return (_classPrivateFieldGet22 = _classPrivateFieldGet2(this, _metadataMap).get(name)) !== null && _classPrivateFieldGet22 !== void 0 ? _classPrivateFieldGet22 : null;
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return (0, _util2.objectFromMap)(_classPrivateFieldGet2(this, _metadataMap));
              }
            }, {
              key: "has",
              value: function has(name) {
                return _classPrivateFieldGet2(this, _metadataMap).has(name);
              }
            }]);
            return Metadata3;
          }();
          exports2.Metadata = Metadata2;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.OptionalContentConfig = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var OptionalContentGroup = function OptionalContentGroup2(name, intent) {
            _classCallCheck2(this, OptionalContentGroup2);
            this.visible = true;
            this.name = name;
            this.intent = intent;
          };
          var OptionalContentConfig = /* @__PURE__ */ function() {
            function OptionalContentConfig2(data2) {
              _classCallCheck2(this, OptionalContentConfig2);
              this.name = null;
              this.creator = null;
              this._order = null;
              this._groups = /* @__PURE__ */ new Map();
              if (data2 === null) {
                return;
              }
              this.name = data2.name;
              this.creator = data2.creator;
              this._order = data2.order;
              var _iterator = _createForOfIteratorHelper2(data2.groups), _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var _group = _step.value;
                  this._groups.set(_group.id, new OptionalContentGroup(_group.name, _group.intent));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              if (data2.baseState === "OFF") {
                var _iterator2 = _createForOfIteratorHelper2(this._groups), _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var group = _step2.value;
                    group.visible = false;
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
              var _iterator3 = _createForOfIteratorHelper2(data2.on), _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                  var on = _step3.value;
                  this._groups.get(on).visible = true;
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              var _iterator4 = _createForOfIteratorHelper2(data2.off), _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                  var off = _step4.value;
                  this._groups.get(off).visible = false;
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
            _createClass2(OptionalContentConfig2, [{
              key: "_evaluateVisibilityExpression",
              value: function _evaluateVisibilityExpression(array) {
                var length = array.length;
                if (length < 2) {
                  return true;
                }
                var operator = array[0];
                for (var i2 = 1; i2 < length; i2++) {
                  var element = array[i2];
                  var state2 = void 0;
                  if (Array.isArray(element)) {
                    state2 = this._evaluateVisibilityExpression(element);
                  } else if (this._groups.has(element)) {
                    state2 = this._groups.get(element).visible;
                  } else {
                    (0, _util2.warn)("Optional content group not found: ".concat(element));
                    return true;
                  }
                  switch (operator) {
                    case "And":
                      if (!state2) {
                        return false;
                      }
                      break;
                    case "Or":
                      if (state2) {
                        return true;
                      }
                      break;
                    case "Not":
                      return !state2;
                    default:
                      return true;
                  }
                }
                return operator === "And";
              }
            }, {
              key: "isVisible",
              value: function isVisible(group) {
                if (this._groups.size === 0) {
                  return true;
                }
                if (!group) {
                  (0, _util2.warn)("Optional content group not defined.");
                  return true;
                }
                if (group.type === "OCG") {
                  if (!this._groups.has(group.id)) {
                    (0, _util2.warn)("Optional content group not found: ".concat(group.id));
                    return true;
                  }
                  return this._groups.get(group.id).visible;
                } else if (group.type === "OCMD") {
                  if (group.expression) {
                    return this._evaluateVisibilityExpression(group.expression);
                  }
                  if (!group.policy || group.policy === "AnyOn") {
                    var _iterator5 = _createForOfIteratorHelper2(group.ids), _step5;
                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                        var id2 = _step5.value;
                        if (!this._groups.has(id2)) {
                          (0, _util2.warn)("Optional content group not found: ".concat(id2));
                          return true;
                        }
                        if (this._groups.get(id2).visible) {
                          return true;
                        }
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                    return false;
                  } else if (group.policy === "AllOn") {
                    var _iterator6 = _createForOfIteratorHelper2(group.ids), _step6;
                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
                        var _id = _step6.value;
                        if (!this._groups.has(_id)) {
                          (0, _util2.warn)("Optional content group not found: ".concat(_id));
                          return true;
                        }
                        if (!this._groups.get(_id).visible) {
                          return false;
                        }
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                    return true;
                  } else if (group.policy === "AnyOff") {
                    var _iterator7 = _createForOfIteratorHelper2(group.ids), _step7;
                    try {
                      for (_iterator7.s(); !(_step7 = _iterator7.n()).done; ) {
                        var _id2 = _step7.value;
                        if (!this._groups.has(_id2)) {
                          (0, _util2.warn)("Optional content group not found: ".concat(_id2));
                          return true;
                        }
                        if (!this._groups.get(_id2).visible) {
                          return true;
                        }
                      }
                    } catch (err) {
                      _iterator7.e(err);
                    } finally {
                      _iterator7.f();
                    }
                    return false;
                  } else if (group.policy === "AllOff") {
                    var _iterator8 = _createForOfIteratorHelper2(group.ids), _step8;
                    try {
                      for (_iterator8.s(); !(_step8 = _iterator8.n()).done; ) {
                        var _id3 = _step8.value;
                        if (!this._groups.has(_id3)) {
                          (0, _util2.warn)("Optional content group not found: ".concat(_id3));
                          return true;
                        }
                        if (this._groups.get(_id3).visible) {
                          return false;
                        }
                      }
                    } catch (err) {
                      _iterator8.e(err);
                    } finally {
                      _iterator8.f();
                    }
                    return true;
                  }
                  (0, _util2.warn)("Unknown optional content policy ".concat(group.policy, "."));
                  return true;
                }
                (0, _util2.warn)("Unknown group type ".concat(group.type, "."));
                return true;
              }
            }, {
              key: "setVisibility",
              value: function setVisibility(id2) {
                var visible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (!this._groups.has(id2)) {
                  (0, _util2.warn)("Optional content group not found: ".concat(id2));
                  return;
                }
                this._groups.get(id2).visible = !!visible;
              }
            }, {
              key: "getOrder",
              value: function getOrder() {
                if (!this._groups.size) {
                  return null;
                }
                if (this._order) {
                  return this._order.slice();
                }
                return Array.from(this._groups.keys());
              }
            }, {
              key: "getGroups",
              value: function getGroups() {
                return this._groups.size > 0 ? (0, _util2.objectFromMap)(this._groups) : null;
              }
            }, {
              key: "getGroup",
              value: function getGroup(id2) {
                return this._groups.get(id2) || null;
              }
            }]);
            return OptionalContentConfig2;
          }();
          exports2.OptionalContentConfig = OptionalContentConfig;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFDataTransportStream = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          var _display_utils2 = __w_pdfjs_require__2(1);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var PDFDataTransportStream = /* @__PURE__ */ function() {
            function PDFDataTransportStream2(params, pdfDataRangeTransport) {
              var _this = this;
              _classCallCheck2(this, PDFDataTransportStream2);
              (0, _util2.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
              this._queuedChunks = [];
              this._progressiveDone = params.progressiveDone || false;
              this._contentDispositionFilename = params.contentDispositionFilename || null;
              var initialData = params.initialData;
              if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
                var buffer2 = new Uint8Array(initialData).buffer;
                this._queuedChunks.push(buffer2);
              }
              this._pdfDataRangeTransport = pdfDataRangeTransport;
              this._isStreamingSupported = !params.disableStream;
              this._isRangeSupported = !params.disableRange;
              this._contentLength = params.length;
              this._fullRequestReader = null;
              this._rangeReaders = [];
              this._pdfDataRangeTransport.addRangeListener(function(begin, chunk) {
                _this._onReceiveData({
                  begin,
                  chunk
                });
              });
              this._pdfDataRangeTransport.addProgressListener(function(loaded, total) {
                _this._onProgress({
                  loaded,
                  total
                });
              });
              this._pdfDataRangeTransport.addProgressiveReadListener(function(chunk) {
                _this._onReceiveData({
                  chunk
                });
              });
              this._pdfDataRangeTransport.addProgressiveDoneListener(function() {
                _this._onProgressiveDone();
              });
              this._pdfDataRangeTransport.transportReady();
            }
            _createClass2(PDFDataTransportStream2, [{
              key: "_onReceiveData",
              value: function _onReceiveData(args) {
                var buffer2 = new Uint8Array(args.chunk).buffer;
                if (args.begin === void 0) {
                  if (this._fullRequestReader) {
                    this._fullRequestReader._enqueue(buffer2);
                  } else {
                    this._queuedChunks.push(buffer2);
                  }
                } else {
                  var found = this._rangeReaders.some(function(rangeReader) {
                    if (rangeReader._begin !== args.begin) {
                      return false;
                    }
                    rangeReader._enqueue(buffer2);
                    return true;
                  });
                  (0, _util2.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
            }, {
              key: "_progressiveDataLength",
              get: function get2() {
                var _this$_fullRequestRea, _this$_fullRequestRea2;
                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
              }
            }, {
              key: "_onProgress",
              value: function _onProgress(evt) {
                if (evt.total === void 0) {
                  var firstReader = this._rangeReaders[0];
                  if (firstReader !== null && firstReader !== void 0 && firstReader.onProgress) {
                    firstReader.onProgress({
                      loaded: evt.loaded
                    });
                  }
                } else {
                  var fullReader = this._fullRequestReader;
                  if (fullReader !== null && fullReader !== void 0 && fullReader.onProgress) {
                    fullReader.onProgress({
                      loaded: evt.loaded,
                      total: evt.total
                    });
                  }
                }
              }
            }, {
              key: "_onProgressiveDone",
              value: function _onProgressiveDone() {
                if (this._fullRequestReader) {
                  this._fullRequestReader.progressiveDone();
                }
                this._progressiveDone = true;
              }
            }, {
              key: "_removeRangeReader",
              value: function _removeRangeReader(reader) {
                var i2 = this._rangeReaders.indexOf(reader);
                if (i2 >= 0) {
                  this._rangeReaders.splice(i2, 1);
                }
              }
            }, {
              key: "getFullReader",
              value: function getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                var queuedChunks = this._queuedChunks;
                this._queuedChunks = null;
                return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
              }
            }, {
              key: "getRangeReader",
              value: function getRangeReader(begin, end) {
                if (end <= this._progressiveDataLength) {
                  return null;
                }
                var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                this._pdfDataRangeTransport.requestDataRange(begin, end);
                this._rangeReaders.push(reader);
                return reader;
              }
            }, {
              key: "cancelAllRequests",
              value: function cancelAllRequests(reason) {
                if (this._fullRequestReader) {
                  this._fullRequestReader.cancel(reason);
                }
                var _iterator = _createForOfIteratorHelper2(this._rangeReaders.slice(0)), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var reader = _step.value;
                    reader.cancel(reason);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this._pdfDataRangeTransport.abort();
              }
            }]);
            return PDFDataTransportStream2;
          }();
          exports2.PDFDataTransportStream = PDFDataTransportStream;
          var PDFDataTransportStreamReader = /* @__PURE__ */ function() {
            function PDFDataTransportStreamReader2(stream, queuedChunks) {
              var progressiveDone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
              var contentDispositionFilename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              _classCallCheck2(this, PDFDataTransportStreamReader2);
              this._stream = stream;
              this._done = progressiveDone || false;
              this._filename = (0, _display_utils2.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
              this._queuedChunks = queuedChunks || [];
              this._loaded = 0;
              var _iterator2 = _createForOfIteratorHelper2(this._queuedChunks), _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                  var chunk = _step2.value;
                  this._loaded += chunk.byteLength;
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              this._requests = [];
              this._headersReady = Promise.resolve();
              stream._fullRequestReader = this;
              this.onProgress = null;
            }
            _createClass2(PDFDataTransportStreamReader2, [{
              key: "_enqueue",
              value: function _enqueue(chunk) {
                if (this._done) {
                  return;
                }
                if (this._requests.length > 0) {
                  var requestCapability = this._requests.shift();
                  requestCapability.resolve({
                    value: chunk,
                    done: false
                  });
                } else {
                  this._queuedChunks.push(chunk);
                }
                this._loaded += chunk.byteLength;
              }
            }, {
              key: "headersReady",
              get: function get2() {
                return this._headersReady;
              }
            }, {
              key: "filename",
              get: function get2() {
                return this._filename;
              }
            }, {
              key: "isRangeSupported",
              get: function get2() {
                return this._stream._isRangeSupported;
              }
            }, {
              key: "isStreamingSupported",
              get: function get2() {
                return this._stream._isStreamingSupported;
              }
            }, {
              key: "contentLength",
              get: function get2() {
                return this._stream._contentLength;
              }
            }, {
              key: "read",
              value: function() {
                var _read = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee() {
                  var chunk, requestCapability;
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(this._queuedChunks.length > 0)) {
                            _context.next = 3;
                            break;
                          }
                          chunk = this._queuedChunks.shift();
                          return _context.abrupt("return", {
                            value: chunk,
                            done: false
                          });
                        case 3:
                          if (!this._done) {
                            _context.next = 5;
                            break;
                          }
                          return _context.abrupt("return", {
                            value: void 0,
                            done: true
                          });
                        case 5:
                          requestCapability = (0, _util2.createPromiseCapability)();
                          this._requests.push(requestCapability);
                          return _context.abrupt("return", requestCapability.promise);
                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function read2() {
                  return _read.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                this._done = true;
                var _iterator3 = _createForOfIteratorHelper2(this._requests), _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                    var requestCapability = _step3.value;
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                this._requests.length = 0;
              }
            }, {
              key: "progressiveDone",
              value: function progressiveDone() {
                if (this._done) {
                  return;
                }
                this._done = true;
              }
            }]);
            return PDFDataTransportStreamReader2;
          }();
          var PDFDataTransportStreamRangeReader = /* @__PURE__ */ function() {
            function PDFDataTransportStreamRangeReader2(stream, begin, end) {
              _classCallCheck2(this, PDFDataTransportStreamRangeReader2);
              this._stream = stream;
              this._begin = begin;
              this._end = end;
              this._queuedChunk = null;
              this._requests = [];
              this._done = false;
              this.onProgress = null;
            }
            _createClass2(PDFDataTransportStreamRangeReader2, [{
              key: "_enqueue",
              value: function _enqueue(chunk) {
                if (this._done) {
                  return;
                }
                if (this._requests.length === 0) {
                  this._queuedChunk = chunk;
                } else {
                  var requestsCapability = this._requests.shift();
                  requestsCapability.resolve({
                    value: chunk,
                    done: false
                  });
                  var _iterator4 = _createForOfIteratorHelper2(this._requests), _step4;
                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                      var requestCapability = _step4.value;
                      requestCapability.resolve({
                        value: void 0,
                        done: true
                      });
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                  this._requests.length = 0;
                }
                this._done = true;
                this._stream._removeRangeReader(this);
              }
            }, {
              key: "isStreamingSupported",
              get: function get2() {
                return false;
              }
            }, {
              key: "read",
              value: function() {
                var _read2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee2() {
                  var chunk, requestCapability;
                  return _regenerator2["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!this._queuedChunk) {
                            _context2.next = 4;
                            break;
                          }
                          chunk = this._queuedChunk;
                          this._queuedChunk = null;
                          return _context2.abrupt("return", {
                            value: chunk,
                            done: false
                          });
                        case 4:
                          if (!this._done) {
                            _context2.next = 6;
                            break;
                          }
                          return _context2.abrupt("return", {
                            value: void 0,
                            done: true
                          });
                        case 6:
                          requestCapability = (0, _util2.createPromiseCapability)();
                          this._requests.push(requestCapability);
                          return _context2.abrupt("return", requestCapability.promise);
                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                function read2() {
                  return _read2.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                this._done = true;
                var _iterator5 = _createForOfIteratorHelper2(this._requests), _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                    var requestCapability = _step5.value;
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                this._requests.length = 0;
                this._stream._removeRangeReader(this);
              }
            }]);
            return PDFDataTransportStreamRangeReader2;
          }();
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.XfaText = void 0;
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var XfaText = /* @__PURE__ */ function() {
            function XfaText2() {
              _classCallCheck2(this, XfaText2);
            }
            _createClass2(XfaText2, null, [{
              key: "textContent",
              value: function textContent(xfa) {
                var items = [];
                var output2 = {
                  items,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function walk(node) {
                  var _node$attributes;
                  if (!node) {
                    return;
                  }
                  var str = null;
                  var name = node.name;
                  if (name === "#text") {
                    str = node.value;
                  } else if (!XfaText2.shouldBuildText(name)) {
                    return;
                  } else if (node !== null && node !== void 0 && (_node$attributes = node.attributes) !== null && _node$attributes !== void 0 && _node$attributes.textContent) {
                    str = node.attributes.textContent;
                  } else if (node.value) {
                    str = node.value;
                  }
                  if (str !== null) {
                    items.push({
                      str
                    });
                  }
                  if (!node.children) {
                    return;
                  }
                  var _iterator = _createForOfIteratorHelper2(node.children), _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                      var child = _step.value;
                      walk(child);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
                walk(xfa);
                return output2;
              }
            }, {
              key: "shouldBuildText",
              value: function shouldBuildText(name) {
                return !(name === "textarea" || name === "input" || name === "option" || name === "select");
              }
            }]);
            return XfaText2;
          }();
          exports2.XfaText = XfaText;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.AnnotationLayer = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          var _display_utils2 = __w_pdfjs_require__2(1);
          var _annotation_storage2 = __w_pdfjs_require__2(139);
          var _scripting_utils = __w_pdfjs_require__2(149);
          var _xfa_layer = __w_pdfjs_require__2(150);
          function _classStaticPrivateMethodGet(receiver, classConstructor, method2) {
            _classCheckPrivateStaticAccess(receiver, classConstructor);
            return method2;
          }
          function _classCheckPrivateStaticAccess(receiver, classConstructor) {
            if (receiver !== classConstructor) {
              throw new TypeError("Private static access of wrong provenance");
            }
          }
          function _get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) {
              _get = Reflect.get;
            } else {
              _get = function _get2(target2, property2, receiver2) {
                var base = _superPropBase(target2, property2);
                if (!base)
                  return;
                var desc = Object.getOwnPropertyDescriptor(base, property2);
                if (desc.get) {
                  return desc.get.call(receiver2);
                }
                return desc.value;
              };
            }
            return _get(target, property, receiver || target);
          }
          function _superPropBase(object, property) {
            while (!Object.prototype.hasOwnProperty.call(object, property)) {
              object = _getPrototypeOf2(object);
              if (object === null)
                break;
            }
            return object;
          }
          function _defineProperty2(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _toConsumableArray2(arr2) {
            return _arrayWithoutHoles2(arr2) || _iterableToArray2(arr2) || _unsupportedIterableToArray2(arr2) || _nonIterableSpread2();
          }
          function _nonIterableSpread2() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArray2(iter) {
            if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
              return Array.from(iter);
          }
          function _arrayWithoutHoles2(arr2) {
            if (Array.isArray(arr2))
              return _arrayLikeToArray2(arr2);
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e3) {
              didErr = true;
              err = _e3;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var DEFAULT_TAB_INDEX = 1e3;
          var GetElementsByNameSet = /* @__PURE__ */ new WeakSet();
          var AnnotationElementFactory = /* @__PURE__ */ function() {
            function AnnotationElementFactory2() {
              _classCallCheck2(this, AnnotationElementFactory2);
            }
            _createClass2(AnnotationElementFactory2, null, [{
              key: "create",
              value: function create3(parameters) {
                var subtype = parameters.data.annotationType;
                switch (subtype) {
                  case _util2.AnnotationType.LINK:
                    return new LinkAnnotationElement(parameters);
                  case _util2.AnnotationType.TEXT:
                    return new TextAnnotationElement(parameters);
                  case _util2.AnnotationType.WIDGET:
                    var fieldType = parameters.data.fieldType;
                    switch (fieldType) {
                      case "Tx":
                        return new TextWidgetAnnotationElement(parameters);
                      case "Btn":
                        if (parameters.data.radioButton) {
                          return new RadioButtonWidgetAnnotationElement(parameters);
                        } else if (parameters.data.checkBox) {
                          return new CheckboxWidgetAnnotationElement(parameters);
                        }
                        return new PushButtonWidgetAnnotationElement(parameters);
                      case "Ch":
                        return new ChoiceWidgetAnnotationElement(parameters);
                    }
                    return new WidgetAnnotationElement(parameters);
                  case _util2.AnnotationType.POPUP:
                    return new PopupAnnotationElement(parameters);
                  case _util2.AnnotationType.FREETEXT:
                    return new FreeTextAnnotationElement(parameters);
                  case _util2.AnnotationType.LINE:
                    return new LineAnnotationElement(parameters);
                  case _util2.AnnotationType.SQUARE:
                    return new SquareAnnotationElement(parameters);
                  case _util2.AnnotationType.CIRCLE:
                    return new CircleAnnotationElement(parameters);
                  case _util2.AnnotationType.POLYLINE:
                    return new PolylineAnnotationElement(parameters);
                  case _util2.AnnotationType.CARET:
                    return new CaretAnnotationElement(parameters);
                  case _util2.AnnotationType.INK:
                    return new InkAnnotationElement(parameters);
                  case _util2.AnnotationType.POLYGON:
                    return new PolygonAnnotationElement(parameters);
                  case _util2.AnnotationType.HIGHLIGHT:
                    return new HighlightAnnotationElement(parameters);
                  case _util2.AnnotationType.UNDERLINE:
                    return new UnderlineAnnotationElement(parameters);
                  case _util2.AnnotationType.SQUIGGLY:
                    return new SquigglyAnnotationElement(parameters);
                  case _util2.AnnotationType.STRIKEOUT:
                    return new StrikeOutAnnotationElement(parameters);
                  case _util2.AnnotationType.STAMP:
                    return new StampAnnotationElement(parameters);
                  case _util2.AnnotationType.FILEATTACHMENT:
                    return new FileAttachmentAnnotationElement(parameters);
                  default:
                    return new AnnotationElement(parameters);
                }
              }
            }]);
            return AnnotationElementFactory2;
          }();
          var AnnotationElement = /* @__PURE__ */ function() {
            function AnnotationElement2(parameters) {
              var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$isRenderable = _ref.isRenderable, isRenderable = _ref$isRenderable === void 0 ? false : _ref$isRenderable, _ref$ignoreBorder = _ref.ignoreBorder, ignoreBorder = _ref$ignoreBorder === void 0 ? false : _ref$ignoreBorder, _ref$createQuadrilate = _ref.createQuadrilaterals, createQuadrilaterals = _ref$createQuadrilate === void 0 ? false : _ref$createQuadrilate;
              _classCallCheck2(this, AnnotationElement2);
              this.isRenderable = isRenderable;
              this.data = parameters.data;
              this.layer = parameters.layer;
              this.page = parameters.page;
              this.viewport = parameters.viewport;
              this.linkService = parameters.linkService;
              this.downloadManager = parameters.downloadManager;
              this.imageResourcesPath = parameters.imageResourcesPath;
              this.renderForms = parameters.renderForms;
              this.svgFactory = parameters.svgFactory;
              this.annotationStorage = parameters.annotationStorage;
              this.enableScripting = parameters.enableScripting;
              this.hasJSActions = parameters.hasJSActions;
              this._fieldObjects = parameters.fieldObjects;
              this._mouseState = parameters.mouseState;
              if (isRenderable) {
                this.container = this._createContainer(ignoreBorder);
              }
              if (createQuadrilaterals) {
                this.quadrilaterals = this._createQuadrilaterals(ignoreBorder);
              }
            }
            _createClass2(AnnotationElement2, [{
              key: "_createContainer",
              value: function _createContainer() {
                var ignoreBorder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var data2 = this.data, page = this.page, viewport = this.viewport;
                var container = document.createElement("section");
                var width2 = data2.rect[2] - data2.rect[0];
                var height2 = data2.rect[3] - data2.rect[1];
                container.setAttribute("data-annotation-id", data2.id);
                var rect = _util2.Util.normalizeRect([data2.rect[0], page.view[3] - data2.rect[1] + page.view[1], data2.rect[2], page.view[3] - data2.rect[3] + page.view[1]]);
                if (data2.hasOwnCanvas) {
                  var transform2 = viewport.transform.slice();
                  var _Util$singularValueDe = _util2.Util.singularValueDecompose2dScale(transform2), _Util$singularValueDe2 = _slicedToArray2(_Util$singularValueDe, 2), scaleX = _Util$singularValueDe2[0], scaleY = _Util$singularValueDe2[1];
                  width2 = Math.ceil(width2 * scaleX);
                  height2 = Math.ceil(height2 * scaleY);
                  rect[0] *= scaleX;
                  rect[1] *= scaleY;
                  for (var i2 = 0; i2 < 4; i2++) {
                    transform2[i2] = Math.sign(transform2[i2]);
                  }
                  container.style.transform = "matrix(".concat(transform2.join(","), ")");
                } else {
                  container.style.transform = "matrix(".concat(viewport.transform.join(","), ")");
                }
                container.style.transformOrigin = "".concat(-rect[0], "px ").concat(-rect[1], "px");
                if (!ignoreBorder && data2.borderStyle.width > 0) {
                  container.style.borderWidth = "".concat(data2.borderStyle.width, "px");
                  if (data2.borderStyle.style !== _util2.AnnotationBorderStyleType.UNDERLINE) {
                    width2 -= 2 * data2.borderStyle.width;
                    height2 -= 2 * data2.borderStyle.width;
                  }
                  var horizontalRadius = data2.borderStyle.horizontalCornerRadius;
                  var verticalRadius = data2.borderStyle.verticalCornerRadius;
                  if (horizontalRadius > 0 || verticalRadius > 0) {
                    var radius = "".concat(horizontalRadius, "px / ").concat(verticalRadius, "px");
                    container.style.borderRadius = radius;
                  }
                  switch (data2.borderStyle.style) {
                    case _util2.AnnotationBorderStyleType.SOLID:
                      container.style.borderStyle = "solid";
                      break;
                    case _util2.AnnotationBorderStyleType.DASHED:
                      container.style.borderStyle = "dashed";
                      break;
                    case _util2.AnnotationBorderStyleType.BEVELED:
                      (0, _util2.warn)("Unimplemented border style: beveled");
                      break;
                    case _util2.AnnotationBorderStyleType.INSET:
                      (0, _util2.warn)("Unimplemented border style: inset");
                      break;
                    case _util2.AnnotationBorderStyleType.UNDERLINE:
                      container.style.borderBottomStyle = "solid";
                      break;
                  }
                  var borderColor = data2.borderColor || data2.color || null;
                  if (borderColor) {
                    container.style.borderColor = _util2.Util.makeHexColor(data2.color[0] | 0, data2.color[1] | 0, data2.color[2] | 0);
                  } else {
                    container.style.borderWidth = 0;
                  }
                }
                container.style.left = "".concat(rect[0], "px");
                container.style.top = "".concat(rect[1], "px");
                if (data2.hasOwnCanvas) {
                  container.style.width = container.style.height = "auto";
                } else {
                  container.style.width = "".concat(width2, "px");
                  container.style.height = "".concat(height2, "px");
                }
                return container;
              }
            }, {
              key: "_createQuadrilaterals",
              value: function _createQuadrilaterals() {
                var ignoreBorder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.data.quadPoints) {
                  return null;
                }
                var quadrilaterals = [];
                var savedRect = this.data.rect;
                var _iterator = _createForOfIteratorHelper2(this.data.quadPoints), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var quadPoint = _step.value;
                    this.data.rect = [quadPoint[2].x, quadPoint[2].y, quadPoint[1].x, quadPoint[1].y];
                    quadrilaterals.push(this._createContainer(ignoreBorder));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this.data.rect = savedRect;
                return quadrilaterals;
              }
            }, {
              key: "_createPopup",
              value: function _createPopup(trigger, data2) {
                var container = this.container;
                if (this.quadrilaterals) {
                  trigger = trigger || this.quadrilaterals;
                  container = this.quadrilaterals[0];
                }
                if (!trigger) {
                  trigger = document.createElement("div");
                  trigger.style.height = container.style.height;
                  trigger.style.width = container.style.width;
                  container.appendChild(trigger);
                }
                var popupElement = new PopupElement({
                  container,
                  trigger,
                  color: data2.color,
                  titleObj: data2.titleObj,
                  modificationDate: data2.modificationDate,
                  contentsObj: data2.contentsObj,
                  richText: data2.richText,
                  hideWrapper: true
                });
                var popup = popupElement.render();
                popup.style.left = container.style.width;
                container.appendChild(popup);
              }
            }, {
              key: "_renderQuadrilaterals",
              value: function _renderQuadrilaterals(className) {
                var _iterator2 = _createForOfIteratorHelper2(this.quadrilaterals), _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var quadrilateral = _step2.value;
                    quadrilateral.className = className;
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                return this.quadrilaterals;
              }
            }, {
              key: "render",
              value: function render() {
                (0, _util2.unreachable)("Abstract method `AnnotationElement.render` called");
              }
            }, {
              key: "_getElementsByName",
              value: function _getElementsByName(name) {
                var skipId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var fields = [];
                if (this._fieldObjects) {
                  var fieldObj = this._fieldObjects[name];
                  if (fieldObj) {
                    var _iterator3 = _createForOfIteratorHelper2(fieldObj), _step3;
                    try {
                      for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                        var _step3$value = _step3.value, page = _step3$value.page, id2 = _step3$value.id, exportValues = _step3$value.exportValues;
                        if (page === -1) {
                          continue;
                        }
                        if (id2 === skipId) {
                          continue;
                        }
                        var exportValue = typeof exportValues === "string" ? exportValues : null;
                        var domElement = document.getElementById(id2);
                        if (domElement && !GetElementsByNameSet.has(domElement)) {
                          (0, _util2.warn)("_getElementsByName - element not allowed: ".concat(id2));
                          continue;
                        }
                        fields.push({
                          id: id2,
                          exportValue,
                          domElement
                        });
                      }
                    } catch (err) {
                      _iterator3.e(err);
                    } finally {
                      _iterator3.f();
                    }
                  }
                  return fields;
                }
                var _iterator4 = _createForOfIteratorHelper2(document.getElementsByName(name)), _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                    var _domElement = _step4.value;
                    var _id = _domElement.id, _exportValue = _domElement.exportValue;
                    if (_id === skipId) {
                      continue;
                    }
                    if (!GetElementsByNameSet.has(_domElement)) {
                      continue;
                    }
                    fields.push({
                      id: _id,
                      exportValue: _exportValue,
                      domElement: _domElement
                    });
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                return fields;
              }
            }], [{
              key: "platform",
              get: function get2() {
                var platform = typeof navigator !== "undefined" ? navigator.platform : "";
                return (0, _util2.shadow)(this, "platform", {
                  isWin: platform.includes("Win"),
                  isMac: platform.includes("Mac")
                });
              }
            }]);
            return AnnotationElement2;
          }();
          var LinkAnnotationElement = /* @__PURE__ */ function(_AnnotationElement) {
            _inherits2(LinkAnnotationElement2, _AnnotationElement);
            var _super = _createSuper2(LinkAnnotationElement2);
            function LinkAnnotationElement2(parameters) {
              var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              _classCallCheck2(this, LinkAnnotationElement2);
              var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action || parameters.data.isTooltipOnly || parameters.data.resetForm || parameters.data.actions && (parameters.data.actions.Action || parameters.data.actions["Mouse Up"] || parameters.data.actions["Mouse Down"]));
              return _super.call(this, parameters, {
                isRenderable,
                ignoreBorder: !!(options !== null && options !== void 0 && options.ignoreBorder),
                createQuadrilaterals: true
              });
            }
            _createClass2(LinkAnnotationElement2, [{
              key: "render",
              value: function render() {
                var data2 = this.data, linkService = this.linkService;
                var link = document.createElement("a");
                if (data2.url) {
                  var _linkService$addLinkA;
                  if (!linkService.addLinkAttributes) {
                    (0, _util2.warn)("LinkAnnotationElement.render - missing `addLinkAttributes`-method on the `linkService`-instance.");
                  }
                  (_linkService$addLinkA = linkService.addLinkAttributes) === null || _linkService$addLinkA === void 0 ? void 0 : _linkService$addLinkA.call(linkService, link, data2.url, data2.newWindow);
                } else if (data2.action) {
                  this._bindNamedAction(link, data2.action);
                } else if (data2.dest) {
                  this._bindLink(link, data2.dest);
                } else {
                  var hasClickAction = false;
                  if (data2.actions && (data2.actions.Action || data2.actions["Mouse Up"] || data2.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                    hasClickAction = true;
                    this._bindJSAction(link, data2);
                  }
                  if (data2.resetForm) {
                    this._bindResetFormAction(link, data2.resetForm);
                  } else if (!hasClickAction) {
                    this._bindLink(link, "");
                  }
                }
                if (this.quadrilaterals) {
                  return this._renderQuadrilaterals("linkAnnotation").map(function(quadrilateral, index2) {
                    var linkElement = index2 === 0 ? link : link.cloneNode();
                    quadrilateral.appendChild(linkElement);
                    return quadrilateral;
                  });
                }
                this.container.className = "linkAnnotation";
                this.container.appendChild(link);
                return this.container;
              }
            }, {
              key: "_bindLink",
              value: function _bindLink(link, destination) {
                var _this = this;
                link.href = this.linkService.getDestinationHash(destination);
                link.onclick = function() {
                  if (destination) {
                    _this.linkService.goToDestination(destination);
                  }
                  return false;
                };
                if (destination || destination === "") {
                  link.className = "internalLink";
                }
              }
            }, {
              key: "_bindNamedAction",
              value: function _bindNamedAction(link, action) {
                var _this2 = this;
                link.href = this.linkService.getAnchorUrl("");
                link.onclick = function() {
                  _this2.linkService.executeNamedAction(action);
                  return false;
                };
                link.className = "internalLink";
              }
            }, {
              key: "_bindJSAction",
              value: function _bindJSAction(link, data2) {
                var _this3 = this;
                link.href = this.linkService.getAnchorUrl("");
                var map = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                var _loop = function _loop2() {
                  var name = _Object$keys[_i2];
                  var jsName = map.get(name);
                  if (!jsName) {
                    return "continue";
                  }
                  link[jsName] = function() {
                    var _this3$linkService$ev;
                    (_this3$linkService$ev = _this3.linkService.eventBus) === null || _this3$linkService$ev === void 0 ? void 0 : _this3$linkService$ev.dispatch("dispatcheventinsandbox", {
                      source: _this3,
                      detail: {
                        id: data2.id,
                        name
                      }
                    });
                    return false;
                  };
                };
                for (var _i2 = 0, _Object$keys = Object.keys(data2.actions); _i2 < _Object$keys.length; _i2++) {
                  var _ret = _loop();
                  if (_ret === "continue")
                    continue;
                }
                if (!link.onclick) {
                  link.onclick = function() {
                    return false;
                  };
                }
                link.className = "internalLink";
              }
            }, {
              key: "_bindResetFormAction",
              value: function _bindResetFormAction(link, resetForm) {
                var _this4 = this;
                var otherClickAction = link.onclick;
                if (!otherClickAction) {
                  link.href = this.linkService.getAnchorUrl("");
                }
                link.className = "internalLink";
                if (!this._fieldObjects) {
                  (0, _util2.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.');
                  if (!otherClickAction) {
                    link.onclick = function() {
                      return false;
                    };
                  }
                  return;
                }
                link.onclick = function() {
                  if (otherClickAction) {
                    otherClickAction();
                  }
                  var resetFormFields = resetForm.fields, resetFormRefs = resetForm.refs, include = resetForm.include;
                  var allFields = [];
                  if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                    var fieldIds = new Set(resetFormRefs);
                    var _iterator5 = _createForOfIteratorHelper2(resetFormFields), _step5;
                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                        var fieldName = _step5.value;
                        var _fields = _this4._fieldObjects[fieldName] || [];
                        var _iterator7 = _createForOfIteratorHelper2(_fields), _step7;
                        try {
                          for (_iterator7.s(); !(_step7 = _iterator7.n()).done; ) {
                            var id2 = _step7.value.id;
                            fieldIds.add(id2);
                          }
                        } catch (err) {
                          _iterator7.e(err);
                        } finally {
                          _iterator7.f();
                        }
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                    for (var _i3 = 0, _Object$values = Object.values(_this4._fieldObjects); _i3 < _Object$values.length; _i3++) {
                      var fields = _Object$values[_i3];
                      var _iterator6 = _createForOfIteratorHelper2(fields), _step6;
                      try {
                        for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
                          var field = _step6.value;
                          if (fieldIds.has(field.id) === include) {
                            allFields.push(field);
                          }
                        }
                      } catch (err) {
                        _iterator6.e(err);
                      } finally {
                        _iterator6.f();
                      }
                    }
                  } else {
                    for (var _i4 = 0, _Object$values2 = Object.values(_this4._fieldObjects); _i4 < _Object$values2.length; _i4++) {
                      var _fields2 = _Object$values2[_i4];
                      allFields.push.apply(allFields, _toConsumableArray2(_fields2));
                    }
                  }
                  var storage = _this4.annotationStorage;
                  var allIds = [];
                  for (var _i5 = 0, _allFields = allFields; _i5 < _allFields.length; _i5++) {
                    var _field = _allFields[_i5];
                    var _id2 = _field.id;
                    allIds.push(_id2);
                    switch (_field.type) {
                      case "text": {
                        var value = _field.defaultValue || "";
                        storage.setValue(_id2, {
                          value,
                          valueAsString: value
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        var _value = _field.defaultValue === _field.exportValues;
                        storage.setValue(_id2, {
                          value: _value
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        var _value2 = _field.defaultValue || "";
                        storage.setValue(_id2, {
                          value: _value2
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    var domElement = document.getElementById(_id2);
                    if (!domElement || !GetElementsByNameSet.has(domElement)) {
                      continue;
                    }
                    domElement.dispatchEvent(new Event("resetform"));
                  }
                  if (_this4.enableScripting) {
                    var _this4$linkService$ev;
                    (_this4$linkService$ev = _this4.linkService.eventBus) === null || _this4$linkService$ev === void 0 ? void 0 : _this4$linkService$ev.dispatch("dispatcheventinsandbox", {
                      source: _this4,
                      detail: {
                        id: "app",
                        ids: allIds,
                        name: "ResetForm"
                      }
                    });
                  }
                  return false;
                };
              }
            }]);
            return LinkAnnotationElement2;
          }(AnnotationElement);
          var TextAnnotationElement = /* @__PURE__ */ function(_AnnotationElement2) {
            _inherits2(TextAnnotationElement2, _AnnotationElement2);
            var _super2 = _createSuper2(TextAnnotationElement2);
            function TextAnnotationElement2(parameters) {
              var _parameters$data$titl, _parameters$data$cont, _parameters$data$rich;
              _classCallCheck2(this, TextAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl = parameters.data.titleObj) !== null && _parameters$data$titl !== void 0 && _parameters$data$titl.str || (_parameters$data$cont = parameters.data.contentsObj) !== null && _parameters$data$cont !== void 0 && _parameters$data$cont.str || (_parameters$data$rich = parameters.data.richText) !== null && _parameters$data$rich !== void 0 && _parameters$data$rich.str);
              return _super2.call(this, parameters, {
                isRenderable
              });
            }
            _createClass2(TextAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "textAnnotation";
                var image2 = document.createElement("img");
                image2.style.height = this.container.style.height;
                image2.style.width = this.container.style.width;
                image2.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                image2.alt = "[{{type}} Annotation]";
                image2.dataset.l10nId = "text_annotation_type";
                image2.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                });
                if (!this.data.hasPopup) {
                  this._createPopup(image2, this.data);
                }
                this.container.appendChild(image2);
                return this.container;
              }
            }]);
            return TextAnnotationElement2;
          }(AnnotationElement);
          var WidgetAnnotationElement = /* @__PURE__ */ function(_AnnotationElement3) {
            _inherits2(WidgetAnnotationElement2, _AnnotationElement3);
            var _super3 = _createSuper2(WidgetAnnotationElement2);
            function WidgetAnnotationElement2() {
              _classCallCheck2(this, WidgetAnnotationElement2);
              return _super3.apply(this, arguments);
            }
            _createClass2(WidgetAnnotationElement2, [{
              key: "render",
              value: function render() {
                if (this.data.alternativeText) {
                  this.container.title = this.data.alternativeText;
                }
                return this.container;
              }
            }, {
              key: "_getKeyModifier",
              value: function _getKeyModifier(event) {
                var _AnnotationElement$pl = AnnotationElement.platform, isWin = _AnnotationElement$pl.isWin, isMac = _AnnotationElement$pl.isMac;
                return isWin && event.ctrlKey || isMac && event.metaKey;
              }
            }, {
              key: "_setEventListener",
              value: function _setEventListener(element, baseName, eventName, valueGetter) {
                var _this5 = this;
                if (baseName.includes("mouse")) {
                  element.addEventListener(baseName, function(event) {
                    var _this5$linkService$ev;
                    (_this5$linkService$ev = _this5.linkService.eventBus) === null || _this5$linkService$ev === void 0 ? void 0 : _this5$linkService$ev.dispatch("dispatcheventinsandbox", {
                      source: _this5,
                      detail: {
                        id: _this5.data.id,
                        name: eventName,
                        value: valueGetter(event),
                        shift: event.shiftKey,
                        modifier: _this5._getKeyModifier(event)
                      }
                    });
                  });
                } else {
                  element.addEventListener(baseName, function(event) {
                    var _this5$linkService$ev2;
                    (_this5$linkService$ev2 = _this5.linkService.eventBus) === null || _this5$linkService$ev2 === void 0 ? void 0 : _this5$linkService$ev2.dispatch("dispatcheventinsandbox", {
                      source: _this5,
                      detail: {
                        id: _this5.data.id,
                        name: eventName,
                        value: event.target.checked
                      }
                    });
                  });
                }
              }
            }, {
              key: "_setEventListeners",
              value: function _setEventListeners(element, names2, getter) {
                var _iterator8 = _createForOfIteratorHelper2(names2), _step8;
                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done; ) {
                    var _this$data$actions;
                    var _step8$value = _slicedToArray2(_step8.value, 2), baseName = _step8$value[0], eventName = _step8$value[1];
                    if (eventName === "Action" || (_this$data$actions = this.data.actions) !== null && _this$data$actions !== void 0 && _this$data$actions[eventName]) {
                      this._setEventListener(element, baseName, eventName, getter);
                    }
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
              }
            }, {
              key: "_setBackgroundColor",
              value: function _setBackgroundColor(element) {
                var color2 = this.data.backgroundColor || null;
                element.style.backgroundColor = color2 === null ? "transparent" : _util2.Util.makeHexColor(color2[0], color2[1], color2[2]);
              }
            }, {
              key: "_dispatchEventFromSandbox",
              value: function _dispatchEventFromSandbox(actions, jsEvent) {
                var _this6 = this;
                var setColor = function setColor2(jsName, styleName, event) {
                  var color2 = event.detail[jsName];
                  event.target.style[styleName] = _scripting_utils.ColorConverters["".concat(color2[0], "_HTML")](color2.slice(1));
                };
                var commonActions = {
                  display: function display(event) {
                    var hidden = event.detail.display % 2 === 1;
                    event.target.style.visibility = hidden ? "hidden" : "visible";
                    _this6.annotationStorage.setValue(_this6.data.id, {
                      hidden,
                      print: event.detail.display === 0 || event.detail.display === 3
                    });
                  },
                  print: function print2(event) {
                    _this6.annotationStorage.setValue(_this6.data.id, {
                      print: event.detail.print
                    });
                  },
                  hidden: function hidden(event) {
                    event.target.style.visibility = event.detail.hidden ? "hidden" : "visible";
                    _this6.annotationStorage.setValue(_this6.data.id, {
                      hidden: event.detail.hidden
                    });
                  },
                  focus: function focus(event) {
                    setTimeout(function() {
                      return event.target.focus({
                        preventScroll: false
                      });
                    }, 0);
                  },
                  userName: function userName(event) {
                    event.target.title = event.detail.userName;
                  },
                  readonly: function readonly(event) {
                    if (event.detail.readonly) {
                      event.target.setAttribute("readonly", "");
                    } else {
                      event.target.removeAttribute("readonly");
                    }
                  },
                  required: function required(event) {
                    if (event.detail.required) {
                      event.target.setAttribute("required", "");
                    } else {
                      event.target.removeAttribute("required");
                    }
                  },
                  bgColor: function bgColor(event) {
                    setColor("bgColor", "backgroundColor", event);
                  },
                  fillColor: function fillColor(event) {
                    setColor("fillColor", "backgroundColor", event);
                  },
                  fgColor: function fgColor(event) {
                    setColor("fgColor", "color", event);
                  },
                  textColor: function textColor(event) {
                    setColor("textColor", "color", event);
                  },
                  borderColor: function borderColor(event) {
                    setColor("borderColor", "borderColor", event);
                  },
                  strokeColor: function strokeColor(event) {
                    setColor("strokeColor", "borderColor", event);
                  }
                };
                for (var _i6 = 0, _Object$keys2 = Object.keys(jsEvent.detail); _i6 < _Object$keys2.length; _i6++) {
                  var name = _Object$keys2[_i6];
                  var action = actions[name] || commonActions[name];
                  if (action) {
                    action(jsEvent);
                  }
                }
              }
            }]);
            return WidgetAnnotationElement2;
          }(AnnotationElement);
          var TextWidgetAnnotationElement = /* @__PURE__ */ function(_WidgetAnnotationElem) {
            _inherits2(TextWidgetAnnotationElement2, _WidgetAnnotationElem);
            var _super4 = _createSuper2(TextWidgetAnnotationElement2);
            function TextWidgetAnnotationElement2(parameters) {
              _classCallCheck2(this, TextWidgetAnnotationElement2);
              var isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
              return _super4.call(this, parameters, {
                isRenderable
              });
            }
            _createClass2(TextWidgetAnnotationElement2, [{
              key: "setPropertyOnSiblings",
              value: function setPropertyOnSiblings(base, key, value, keyInStorage) {
                var storage = this.annotationStorage;
                var _iterator9 = _createForOfIteratorHelper2(this._getElementsByName(base.name, base.id)), _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done; ) {
                    var element = _step9.value;
                    if (element.domElement) {
                      element.domElement[key] = value;
                    }
                    storage.setValue(element.id, _defineProperty2({}, keyInStorage, value));
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
              }
            }, {
              key: "render",
              value: function render() {
                var _this7 = this;
                var storage = this.annotationStorage;
                var id2 = this.data.id;
                this.container.className = "textWidgetAnnotation";
                var element = null;
                if (this.renderForms) {
                  var storedData = storage.getValue(id2, {
                    value: this.data.fieldValue,
                    valueAsString: this.data.fieldValue
                  });
                  var textContent = storedData.valueAsString || storedData.value || "";
                  var elementData = {
                    userValue: null,
                    formattedValue: null,
                    beforeInputSelectionRange: null,
                    beforeInputValue: null
                  };
                  if (this.data.multiLine) {
                    element = document.createElement("textarea");
                    element.textContent = textContent;
                  } else {
                    element = document.createElement("input");
                    element.type = "text";
                    element.setAttribute("value", textContent);
                  }
                  GetElementsByNameSet.add(element);
                  element.disabled = this.data.readOnly;
                  element.name = this.data.fieldName;
                  element.tabIndex = DEFAULT_TAB_INDEX;
                  elementData.userValue = textContent;
                  element.setAttribute("id", id2);
                  element.addEventListener("input", function(event) {
                    storage.setValue(id2, {
                      value: event.target.value
                    });
                    _this7.setPropertyOnSiblings(element, "value", event.target.value, "value");
                  });
                  element.addEventListener("resetform", function(event) {
                    var defaultValue = _this7.data.defaultFieldValue || "";
                    element.value = elementData.userValue = defaultValue;
                    delete elementData.formattedValue;
                  });
                  var blurListener = function blurListener2(event) {
                    if (elementData.formattedValue) {
                      event.target.value = elementData.formattedValue;
                    }
                    event.target.scrollLeft = 0;
                    elementData.beforeInputSelectionRange = null;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    var _this$data$actions2;
                    element.addEventListener("focus", function(event) {
                      if (elementData.userValue) {
                        event.target.value = elementData.userValue;
                      }
                    });
                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                      var actions = {
                        value: function value(event) {
                          elementData.userValue = event.detail.value || "";
                          storage.setValue(id2, {
                            value: elementData.userValue.toString()
                          });
                          if (!elementData.formattedValue) {
                            event.target.value = elementData.userValue;
                          }
                        },
                        valueAsString: function valueAsString(event) {
                          elementData.formattedValue = event.detail.valueAsString || "";
                          if (event.target !== document.activeElement) {
                            event.target.value = elementData.formattedValue;
                          }
                          storage.setValue(id2, {
                            formattedValue: elementData.formattedValue
                          });
                        },
                        selRange: function selRange(event) {
                          var _event$detail$selRang = _slicedToArray2(event.detail.selRange, 2), selStart = _event$detail$selRang[0], selEnd = _event$detail$selRang[1];
                          if (selStart >= 0 && selEnd < event.target.value.length) {
                            event.target.setSelectionRange(selStart, selEnd);
                          }
                        }
                      };
                      _this7._dispatchEventFromSandbox(actions, jsEvent);
                    });
                    element.addEventListener("keydown", function(event) {
                      var _this7$linkService$ev;
                      elementData.beforeInputValue = event.target.value;
                      var commitKey = -1;
                      if (event.key === "Escape") {
                        commitKey = 0;
                      } else if (event.key === "Enter") {
                        commitKey = 2;
                      } else if (event.key === "Tab") {
                        commitKey = 3;
                      }
                      if (commitKey === -1) {
                        return;
                      }
                      elementData.userValue = event.target.value;
                      (_this7$linkService$ev = _this7.linkService.eventBus) === null || _this7$linkService$ev === void 0 ? void 0 : _this7$linkService$ev.dispatch("dispatcheventinsandbox", {
                        source: _this7,
                        detail: {
                          id: id2,
                          name: "Keystroke",
                          value: event.target.value,
                          willCommit: true,
                          commitKey,
                          selStart: event.target.selectionStart,
                          selEnd: event.target.selectionEnd
                        }
                      });
                    });
                    var _blurListener = blurListener;
                    blurListener = null;
                    element.addEventListener("blur", function(event) {
                      if (_this7._mouseState.isDown) {
                        var _this7$linkService$ev2;
                        elementData.userValue = event.target.value;
                        (_this7$linkService$ev2 = _this7.linkService.eventBus) === null || _this7$linkService$ev2 === void 0 ? void 0 : _this7$linkService$ev2.dispatch("dispatcheventinsandbox", {
                          source: _this7,
                          detail: {
                            id: id2,
                            name: "Keystroke",
                            value: event.target.value,
                            willCommit: true,
                            commitKey: 1,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                          }
                        });
                      }
                      _blurListener(event);
                    });
                    element.addEventListener("mousedown", function(event) {
                      elementData.beforeInputValue = event.target.value;
                      elementData.beforeInputSelectionRange = null;
                    });
                    element.addEventListener("keyup", function(event) {
                      if (event.target.selectionStart === event.target.selectionEnd) {
                        elementData.beforeInputSelectionRange = null;
                      }
                    });
                    element.addEventListener("select", function(event) {
                      elementData.beforeInputSelectionRange = [event.target.selectionStart, event.target.selectionEnd];
                    });
                    if ((_this$data$actions2 = this.data.actions) !== null && _this$data$actions2 !== void 0 && _this$data$actions2.Keystroke) {
                      element.addEventListener("input", function(event) {
                        var _this7$linkService$ev3;
                        var selStart = -1;
                        var selEnd = -1;
                        if (elementData.beforeInputSelectionRange) {
                          var _elementData$beforeIn = _slicedToArray2(elementData.beforeInputSelectionRange, 2);
                          selStart = _elementData$beforeIn[0];
                          selEnd = _elementData$beforeIn[1];
                        }
                        (_this7$linkService$ev3 = _this7.linkService.eventBus) === null || _this7$linkService$ev3 === void 0 ? void 0 : _this7$linkService$ev3.dispatch("dispatcheventinsandbox", {
                          source: _this7,
                          detail: {
                            id: id2,
                            name: "Keystroke",
                            value: elementData.beforeInputValue,
                            change: event.data,
                            willCommit: false,
                            selStart,
                            selEnd
                          }
                        });
                      });
                    }
                    this._setEventListeners(element, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function(event) {
                      return event.target.value;
                    });
                  }
                  if (blurListener) {
                    element.addEventListener("blur", blurListener);
                  }
                  if (this.data.maxLen !== null) {
                    element.maxLength = this.data.maxLen;
                  }
                  if (this.data.comb) {
                    var fieldWidth = this.data.rect[2] - this.data.rect[0];
                    var combWidth = fieldWidth / this.data.maxLen;
                    element.classList.add("comb");
                    element.style.letterSpacing = "calc(".concat(combWidth, "px - 1ch)");
                  }
                } else {
                  element = document.createElement("div");
                  element.textContent = this.data.fieldValue;
                  element.style.verticalAlign = "middle";
                  element.style.display = "table-cell";
                }
                this._setTextStyle(element);
                this._setBackgroundColor(element);
                this.container.appendChild(element);
                return this.container;
              }
            }, {
              key: "_setTextStyle",
              value: function _setTextStyle(element) {
                var TEXT_ALIGNMENT = ["left", "center", "right"];
                var _this$data$defaultApp = this.data.defaultAppearanceData, fontSize = _this$data$defaultApp.fontSize, fontColor = _this$data$defaultApp.fontColor;
                var style = element.style;
                if (fontSize) {
                  style.fontSize = "".concat(fontSize, "px");
                }
                style.color = _util2.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                if (this.data.textAlignment !== null) {
                  style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                }
              }
            }]);
            return TextWidgetAnnotationElement2;
          }(WidgetAnnotationElement);
          var CheckboxWidgetAnnotationElement = /* @__PURE__ */ function(_WidgetAnnotationElem2) {
            _inherits2(CheckboxWidgetAnnotationElement2, _WidgetAnnotationElem2);
            var _super5 = _createSuper2(CheckboxWidgetAnnotationElement2);
            function CheckboxWidgetAnnotationElement2(parameters) {
              _classCallCheck2(this, CheckboxWidgetAnnotationElement2);
              return _super5.call(this, parameters, {
                isRenderable: parameters.renderForms
              });
            }
            _createClass2(CheckboxWidgetAnnotationElement2, [{
              key: "render",
              value: function render() {
                var _this8 = this;
                var storage = this.annotationStorage;
                var data2 = this.data;
                var id2 = data2.id;
                var value = storage.getValue(id2, {
                  value: data2.exportValue === data2.fieldValue
                }).value;
                if (typeof value === "string") {
                  value = value !== "Off";
                  storage.setValue(id2, {
                    value
                  });
                }
                this.container.className = "buttonWidgetAnnotation checkBox";
                var element = document.createElement("input");
                GetElementsByNameSet.add(element);
                element.disabled = data2.readOnly;
                element.type = "checkbox";
                element.name = data2.fieldName;
                if (value) {
                  element.setAttribute("checked", true);
                }
                element.setAttribute("id", id2);
                element.setAttribute("exportValue", data2.exportValue);
                element.tabIndex = DEFAULT_TAB_INDEX;
                element.addEventListener("change", function(event) {
                  var _event$target = event.target, name = _event$target.name, checked = _event$target.checked;
                  var _iterator10 = _createForOfIteratorHelper2(_this8._getElementsByName(name, id2)), _step10;
                  try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done; ) {
                      var checkbox = _step10.value;
                      var curChecked = checked && checkbox.exportValue === data2.exportValue;
                      if (checkbox.domElement) {
                        checkbox.domElement.checked = curChecked;
                      }
                      storage.setValue(checkbox.id, {
                        value: curChecked
                      });
                    }
                  } catch (err) {
                    _iterator10.e(err);
                  } finally {
                    _iterator10.f();
                  }
                  storage.setValue(id2, {
                    value: checked
                  });
                });
                element.addEventListener("resetform", function(event) {
                  var defaultValue = data2.defaultFieldValue || "Off";
                  event.target.checked = defaultValue === data2.exportValue;
                });
                if (this.enableScripting && this.hasJSActions) {
                  element.addEventListener("updatefromsandbox", function(jsEvent) {
                    var actions = {
                      value: function value2(event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id2, {
                          value: event.target.checked
                        });
                      }
                    };
                    _this8._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  this._setEventListeners(element, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function(event) {
                    return event.target.checked;
                  });
                }
                this._setBackgroundColor(element);
                this.container.appendChild(element);
                return this.container;
              }
            }]);
            return CheckboxWidgetAnnotationElement2;
          }(WidgetAnnotationElement);
          var RadioButtonWidgetAnnotationElement = /* @__PURE__ */ function(_WidgetAnnotationElem3) {
            _inherits2(RadioButtonWidgetAnnotationElement2, _WidgetAnnotationElem3);
            var _super6 = _createSuper2(RadioButtonWidgetAnnotationElement2);
            function RadioButtonWidgetAnnotationElement2(parameters) {
              _classCallCheck2(this, RadioButtonWidgetAnnotationElement2);
              return _super6.call(this, parameters, {
                isRenderable: parameters.renderForms
              });
            }
            _createClass2(RadioButtonWidgetAnnotationElement2, [{
              key: "render",
              value: function render() {
                var _this9 = this;
                this.container.className = "buttonWidgetAnnotation radioButton";
                var storage = this.annotationStorage;
                var data2 = this.data;
                var id2 = data2.id;
                var value = storage.getValue(id2, {
                  value: data2.fieldValue === data2.buttonValue
                }).value;
                if (typeof value === "string") {
                  value = value !== data2.buttonValue;
                  storage.setValue(id2, {
                    value
                  });
                }
                var element = document.createElement("input");
                GetElementsByNameSet.add(element);
                element.disabled = data2.readOnly;
                element.type = "radio";
                element.name = data2.fieldName;
                if (value) {
                  element.setAttribute("checked", true);
                }
                element.setAttribute("id", id2);
                element.tabIndex = DEFAULT_TAB_INDEX;
                element.addEventListener("change", function(event) {
                  var _event$target2 = event.target, name = _event$target2.name, checked = _event$target2.checked;
                  var _iterator11 = _createForOfIteratorHelper2(_this9._getElementsByName(name, id2)), _step11;
                  try {
                    for (_iterator11.s(); !(_step11 = _iterator11.n()).done; ) {
                      var radio = _step11.value;
                      storage.setValue(radio.id, {
                        value: false
                      });
                    }
                  } catch (err) {
                    _iterator11.e(err);
                  } finally {
                    _iterator11.f();
                  }
                  storage.setValue(id2, {
                    value: checked
                  });
                });
                element.addEventListener("resetform", function(event) {
                  var defaultValue = data2.defaultFieldValue;
                  event.target.checked = defaultValue !== null && defaultValue !== void 0 && defaultValue === data2.buttonValue;
                });
                if (this.enableScripting && this.hasJSActions) {
                  var pdfButtonValue = data2.buttonValue;
                  element.addEventListener("updatefromsandbox", function(jsEvent) {
                    var actions = {
                      value: function value2(event) {
                        var checked = pdfButtonValue === event.detail.value;
                        var _iterator12 = _createForOfIteratorHelper2(_this9._getElementsByName(event.target.name)), _step12;
                        try {
                          for (_iterator12.s(); !(_step12 = _iterator12.n()).done; ) {
                            var radio = _step12.value;
                            var curChecked = checked && radio.id === id2;
                            if (radio.domElement) {
                              radio.domElement.checked = curChecked;
                            }
                            storage.setValue(radio.id, {
                              value: curChecked
                            });
                          }
                        } catch (err) {
                          _iterator12.e(err);
                        } finally {
                          _iterator12.f();
                        }
                      }
                    };
                    _this9._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  this._setEventListeners(element, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function(event) {
                    return event.target.checked;
                  });
                }
                this._setBackgroundColor(element);
                this.container.appendChild(element);
                return this.container;
              }
            }]);
            return RadioButtonWidgetAnnotationElement2;
          }(WidgetAnnotationElement);
          var PushButtonWidgetAnnotationElement = /* @__PURE__ */ function(_LinkAnnotationElemen) {
            _inherits2(PushButtonWidgetAnnotationElement2, _LinkAnnotationElemen);
            var _super7 = _createSuper2(PushButtonWidgetAnnotationElement2);
            function PushButtonWidgetAnnotationElement2(parameters) {
              _classCallCheck2(this, PushButtonWidgetAnnotationElement2);
              return _super7.call(this, parameters, {
                ignoreBorder: parameters.data.hasAppearance
              });
            }
            _createClass2(PushButtonWidgetAnnotationElement2, [{
              key: "render",
              value: function render() {
                var container = _get(_getPrototypeOf2(PushButtonWidgetAnnotationElement2.prototype), "render", this).call(this);
                container.className = "buttonWidgetAnnotation pushButton";
                if (this.data.alternativeText) {
                  container.title = this.data.alternativeText;
                }
                return container;
              }
            }]);
            return PushButtonWidgetAnnotationElement2;
          }(LinkAnnotationElement);
          var ChoiceWidgetAnnotationElement = /* @__PURE__ */ function(_WidgetAnnotationElem4) {
            _inherits2(ChoiceWidgetAnnotationElement2, _WidgetAnnotationElem4);
            var _super8 = _createSuper2(ChoiceWidgetAnnotationElement2);
            function ChoiceWidgetAnnotationElement2(parameters) {
              _classCallCheck2(this, ChoiceWidgetAnnotationElement2);
              return _super8.call(this, parameters, {
                isRenderable: parameters.renderForms
              });
            }
            _createClass2(ChoiceWidgetAnnotationElement2, [{
              key: "render",
              value: function render() {
                var _this10 = this;
                this.container.className = "choiceWidgetAnnotation";
                var storage = this.annotationStorage;
                var id2 = this.data.id;
                storage.getValue(id2, {
                  value: this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : void 0
                });
                var fontSize = this.data.defaultAppearanceData.fontSize;
                if (!fontSize) {
                  fontSize = 9;
                }
                var fontSizeStyle = "calc(".concat(fontSize, "px * var(--zoom-factor))");
                var selectElement = document.createElement("select");
                GetElementsByNameSet.add(selectElement);
                selectElement.disabled = this.data.readOnly;
                selectElement.name = this.data.fieldName;
                selectElement.setAttribute("id", id2);
                selectElement.tabIndex = DEFAULT_TAB_INDEX;
                selectElement.style.fontSize = "".concat(fontSize, "px");
                if (!this.data.combo) {
                  selectElement.size = this.data.options.length;
                  if (this.data.multiSelect) {
                    selectElement.multiple = true;
                  }
                }
                selectElement.addEventListener("resetform", function(event) {
                  var defaultValue = _this10.data.defaultFieldValue;
                  var _iterator13 = _createForOfIteratorHelper2(selectElement.options), _step13;
                  try {
                    for (_iterator13.s(); !(_step13 = _iterator13.n()).done; ) {
                      var option2 = _step13.value;
                      option2.selected = option2.value === defaultValue;
                    }
                  } catch (err) {
                    _iterator13.e(err);
                  } finally {
                    _iterator13.f();
                  }
                });
                var _iterator14 = _createForOfIteratorHelper2(this.data.options), _step14;
                try {
                  for (_iterator14.s(); !(_step14 = _iterator14.n()).done; ) {
                    var option = _step14.value;
                    var optionElement = document.createElement("option");
                    optionElement.textContent = option.displayValue;
                    optionElement.value = option.exportValue;
                    if (this.data.combo) {
                      optionElement.style.fontSize = fontSizeStyle;
                    }
                    if (this.data.fieldValue.includes(option.exportValue)) {
                      optionElement.setAttribute("selected", true);
                    }
                    selectElement.appendChild(optionElement);
                  }
                } catch (err) {
                  _iterator14.e(err);
                } finally {
                  _iterator14.f();
                }
                var getValue = function getValue2(event, isExport) {
                  var name = isExport ? "value" : "textContent";
                  var options = event.target.options;
                  if (!event.target.multiple) {
                    return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                  }
                  return Array.prototype.filter.call(options, function(option2) {
                    return option2.selected;
                  }).map(function(option2) {
                    return option2[name];
                  });
                };
                var getItems = function getItems2(event) {
                  var options = event.target.options;
                  return Array.prototype.map.call(options, function(option2) {
                    return {
                      displayValue: option2.textContent,
                      exportValue: option2.value
                    };
                  });
                };
                if (this.enableScripting && this.hasJSActions) {
                  selectElement.addEventListener("updatefromsandbox", function(jsEvent) {
                    var actions = {
                      value: function value(event) {
                        var value2 = event.detail.value;
                        var values = new Set(Array.isArray(value2) ? value2 : [value2]);
                        var _iterator15 = _createForOfIteratorHelper2(selectElement.options), _step15;
                        try {
                          for (_iterator15.s(); !(_step15 = _iterator15.n()).done; ) {
                            var option2 = _step15.value;
                            option2.selected = values.has(option2.value);
                          }
                        } catch (err) {
                          _iterator15.e(err);
                        } finally {
                          _iterator15.f();
                        }
                        storage.setValue(id2, {
                          value: getValue(event, true)
                        });
                      },
                      multipleSelection: function multipleSelection(event) {
                        selectElement.multiple = true;
                      },
                      remove: function remove3(event) {
                        var options = selectElement.options;
                        var index2 = event.detail.remove;
                        options[index2].selected = false;
                        selectElement.remove(index2);
                        if (options.length > 0) {
                          var i2 = Array.prototype.findIndex.call(options, function(option2) {
                            return option2.selected;
                          });
                          if (i2 === -1) {
                            options[0].selected = true;
                          }
                        }
                        storage.setValue(id2, {
                          value: getValue(event, true),
                          items: getItems(event)
                        });
                      },
                      clear: function clear(event) {
                        while (selectElement.length !== 0) {
                          selectElement.remove(0);
                        }
                        storage.setValue(id2, {
                          value: null,
                          items: []
                        });
                      },
                      insert: function insert(event) {
                        var _event$detail$insert = event.detail.insert, index2 = _event$detail$insert.index, displayValue = _event$detail$insert.displayValue, exportValue = _event$detail$insert.exportValue;
                        var optionElement2 = document.createElement("option");
                        optionElement2.textContent = displayValue;
                        optionElement2.value = exportValue;
                        selectElement.insertBefore(optionElement2, selectElement.children[index2]);
                        storage.setValue(id2, {
                          value: getValue(event, true),
                          items: getItems(event)
                        });
                      },
                      items: function items(event) {
                        var items2 = event.detail.items;
                        while (selectElement.length !== 0) {
                          selectElement.remove(0);
                        }
                        var _iterator16 = _createForOfIteratorHelper2(items2), _step16;
                        try {
                          for (_iterator16.s(); !(_step16 = _iterator16.n()).done; ) {
                            var item = _step16.value;
                            var displayValue = item.displayValue, exportValue = item.exportValue;
                            var optionElement2 = document.createElement("option");
                            optionElement2.textContent = displayValue;
                            optionElement2.value = exportValue;
                            selectElement.appendChild(optionElement2);
                          }
                        } catch (err) {
                          _iterator16.e(err);
                        } finally {
                          _iterator16.f();
                        }
                        if (selectElement.options.length > 0) {
                          selectElement.options[0].selected = true;
                        }
                        storage.setValue(id2, {
                          value: getValue(event, true),
                          items: getItems(event)
                        });
                      },
                      indices: function indices(event) {
                        var indices2 = new Set(event.detail.indices);
                        var _iterator17 = _createForOfIteratorHelper2(event.target.options), _step17;
                        try {
                          for (_iterator17.s(); !(_step17 = _iterator17.n()).done; ) {
                            var option2 = _step17.value;
                            option2.selected = indices2.has(option2.index);
                          }
                        } catch (err) {
                          _iterator17.e(err);
                        } finally {
                          _iterator17.f();
                        }
                        storage.setValue(id2, {
                          value: getValue(event, true)
                        });
                      },
                      editable: function editable(event) {
                        event.target.disabled = !event.detail.editable;
                      }
                    };
                    _this10._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  selectElement.addEventListener("input", function(event) {
                    var _this10$linkService$e;
                    var exportValue = getValue(event, true);
                    var value = getValue(event, false);
                    storage.setValue(id2, {
                      value: exportValue
                    });
                    (_this10$linkService$e = _this10.linkService.eventBus) === null || _this10$linkService$e === void 0 ? void 0 : _this10$linkService$e.dispatch("dispatcheventinsandbox", {
                      source: _this10,
                      detail: {
                        id: id2,
                        name: "Keystroke",
                        value,
                        changeEx: exportValue,
                        willCommit: true,
                        commitKey: 1,
                        keyDown: false
                      }
                    });
                  });
                  this._setEventListeners(selectElement, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"]], function(event) {
                    return event.target.checked;
                  });
                } else {
                  selectElement.addEventListener("input", function(event) {
                    storage.setValue(id2, {
                      value: getValue(event)
                    });
                  });
                }
                this._setBackgroundColor(selectElement);
                this.container.appendChild(selectElement);
                return this.container;
              }
            }]);
            return ChoiceWidgetAnnotationElement2;
          }(WidgetAnnotationElement);
          var PopupAnnotationElement = /* @__PURE__ */ function(_AnnotationElement4) {
            _inherits2(PopupAnnotationElement2, _AnnotationElement4);
            var _super9 = _createSuper2(PopupAnnotationElement2);
            function PopupAnnotationElement2(parameters) {
              var _parameters$data$titl2, _parameters$data$cont2, _parameters$data$rich2;
              _classCallCheck2(this, PopupAnnotationElement2);
              var isRenderable = !!((_parameters$data$titl2 = parameters.data.titleObj) !== null && _parameters$data$titl2 !== void 0 && _parameters$data$titl2.str || (_parameters$data$cont2 = parameters.data.contentsObj) !== null && _parameters$data$cont2 !== void 0 && _parameters$data$cont2.str || (_parameters$data$rich2 = parameters.data.richText) !== null && _parameters$data$rich2 !== void 0 && _parameters$data$rich2.str);
              return _super9.call(this, parameters, {
                isRenderable
              });
            }
            _createClass2(PopupAnnotationElement2, [{
              key: "render",
              value: function render() {
                var IGNORE_TYPES = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
                this.container.className = "popupAnnotation";
                if (IGNORE_TYPES.includes(this.data.parentType)) {
                  return this.container;
                }
                var selector = '[data-annotation-id="'.concat(this.data.parentId, '"]');
                var parentElements = this.layer.querySelectorAll(selector);
                if (parentElements.length === 0) {
                  return this.container;
                }
                var popup = new PopupElement({
                  container: this.container,
                  trigger: Array.from(parentElements),
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText
                });
                var page = this.page;
                var rect = _util2.Util.normalizeRect([this.data.parentRect[0], page.view[3] - this.data.parentRect[1] + page.view[1], this.data.parentRect[2], page.view[3] - this.data.parentRect[3] + page.view[1]]);
                var popupLeft = rect[0] + this.data.parentRect[2] - this.data.parentRect[0];
                var popupTop = rect[1];
                this.container.style.transformOrigin = "".concat(-popupLeft, "px ").concat(-popupTop, "px");
                this.container.style.left = "".concat(popupLeft, "px");
                this.container.style.top = "".concat(popupTop, "px");
                this.container.appendChild(popup.render());
                return this.container;
              }
            }]);
            return PopupAnnotationElement2;
          }(AnnotationElement);
          var PopupElement = /* @__PURE__ */ function() {
            function PopupElement2(parameters) {
              _classCallCheck2(this, PopupElement2);
              this.container = parameters.container;
              this.trigger = parameters.trigger;
              this.color = parameters.color;
              this.titleObj = parameters.titleObj;
              this.modificationDate = parameters.modificationDate;
              this.contentsObj = parameters.contentsObj;
              this.richText = parameters.richText;
              this.hideWrapper = parameters.hideWrapper || false;
              this.pinned = false;
            }
            _createClass2(PopupElement2, [{
              key: "render",
              value: function render() {
                var _this$richText, _this$contentsObj;
                var BACKGROUND_ENLIGHT = 0.7;
                var wrapper = document.createElement("div");
                wrapper.className = "popupWrapper";
                this.hideElement = this.hideWrapper ? wrapper : this.container;
                this.hideElement.hidden = true;
                var popup = document.createElement("div");
                popup.className = "popup";
                var color2 = this.color;
                if (color2) {
                  var r2 = BACKGROUND_ENLIGHT * (255 - color2[0]) + color2[0];
                  var g2 = BACKGROUND_ENLIGHT * (255 - color2[1]) + color2[1];
                  var b2 = BACKGROUND_ENLIGHT * (255 - color2[2]) + color2[2];
                  popup.style.backgroundColor = _util2.Util.makeHexColor(r2 | 0, g2 | 0, b2 | 0);
                }
                var title = document.createElement("h1");
                title.dir = this.titleObj.dir;
                title.textContent = this.titleObj.str;
                popup.appendChild(title);
                var dateObject = _display_utils2.PDFDateString.toDateObject(this.modificationDate);
                if (dateObject) {
                  var modificationDate = document.createElement("span");
                  modificationDate.className = "popupDate";
                  modificationDate.textContent = "{{date}}, {{time}}";
                  modificationDate.dataset.l10nId = "annotation_date_string";
                  modificationDate.dataset.l10nArgs = JSON.stringify({
                    date: dateObject.toLocaleDateString(),
                    time: dateObject.toLocaleTimeString()
                  });
                  popup.appendChild(modificationDate);
                }
                if ((_this$richText = this.richText) !== null && _this$richText !== void 0 && _this$richText.str && (!((_this$contentsObj = this.contentsObj) !== null && _this$contentsObj !== void 0 && _this$contentsObj.str) || this.contentsObj.str === this.richText.str)) {
                  _xfa_layer.XfaLayer.render({
                    xfaHtml: this.richText.html,
                    intent: "richText",
                    div: popup
                  });
                  popup.lastChild.className = "richText popupContent";
                } else {
                  var contents = this._formatContents(this.contentsObj);
                  popup.appendChild(contents);
                }
                if (!Array.isArray(this.trigger)) {
                  this.trigger = [this.trigger];
                }
                var _iterator18 = _createForOfIteratorHelper2(this.trigger), _step18;
                try {
                  for (_iterator18.s(); !(_step18 = _iterator18.n()).done; ) {
                    var element = _step18.value;
                    element.addEventListener("click", this._toggle.bind(this));
                    element.addEventListener("mouseover", this._show.bind(this, false));
                    element.addEventListener("mouseout", this._hide.bind(this, false));
                  }
                } catch (err) {
                  _iterator18.e(err);
                } finally {
                  _iterator18.f();
                }
                popup.addEventListener("click", this._hide.bind(this, true));
                wrapper.appendChild(popup);
                return wrapper;
              }
            }, {
              key: "_formatContents",
              value: function _formatContents(_ref2) {
                var str = _ref2.str, dir = _ref2.dir;
                var p2 = document.createElement("p");
                p2.className = "popupContent";
                p2.dir = dir;
                var lines = str.split(/(?:\r\n?|\n)/);
                for (var i2 = 0, ii = lines.length; i2 < ii; ++i2) {
                  var line = lines[i2];
                  p2.appendChild(document.createTextNode(line));
                  if (i2 < ii - 1) {
                    p2.appendChild(document.createElement("br"));
                  }
                }
                return p2;
              }
            }, {
              key: "_toggle",
              value: function _toggle() {
                if (this.pinned) {
                  this._hide(true);
                } else {
                  this._show(true);
                }
              }
            }, {
              key: "_show",
              value: function _show() {
                var pin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (pin) {
                  this.pinned = true;
                }
                if (this.hideElement.hidden) {
                  this.hideElement.hidden = false;
                  this.container.style.zIndex += 1;
                }
              }
            }, {
              key: "_hide",
              value: function _hide() {
                var unpin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (unpin) {
                  this.pinned = false;
                }
                if (!this.hideElement.hidden && !this.pinned) {
                  this.hideElement.hidden = true;
                  this.container.style.zIndex -= 1;
                }
              }
            }]);
            return PopupElement2;
          }();
          var FreeTextAnnotationElement = /* @__PURE__ */ function(_AnnotationElement5) {
            _inherits2(FreeTextAnnotationElement2, _AnnotationElement5);
            var _super10 = _createSuper2(FreeTextAnnotationElement2);
            function FreeTextAnnotationElement2(parameters) {
              var _parameters$data$titl3, _parameters$data$cont3, _parameters$data$rich3;
              _classCallCheck2(this, FreeTextAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl3 = parameters.data.titleObj) !== null && _parameters$data$titl3 !== void 0 && _parameters$data$titl3.str || (_parameters$data$cont3 = parameters.data.contentsObj) !== null && _parameters$data$cont3 !== void 0 && _parameters$data$cont3.str || (_parameters$data$rich3 = parameters.data.richText) !== null && _parameters$data$rich3 !== void 0 && _parameters$data$rich3.str);
              return _super10.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            _createClass2(FreeTextAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "freeTextAnnotation";
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                return this.container;
              }
            }]);
            return FreeTextAnnotationElement2;
          }(AnnotationElement);
          var LineAnnotationElement = /* @__PURE__ */ function(_AnnotationElement6) {
            _inherits2(LineAnnotationElement2, _AnnotationElement6);
            var _super11 = _createSuper2(LineAnnotationElement2);
            function LineAnnotationElement2(parameters) {
              var _parameters$data$titl4, _parameters$data$cont4, _parameters$data$rich4;
              _classCallCheck2(this, LineAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl4 = parameters.data.titleObj) !== null && _parameters$data$titl4 !== void 0 && _parameters$data$titl4.str || (_parameters$data$cont4 = parameters.data.contentsObj) !== null && _parameters$data$cont4 !== void 0 && _parameters$data$cont4.str || (_parameters$data$rich4 = parameters.data.richText) !== null && _parameters$data$rich4 !== void 0 && _parameters$data$rich4.str);
              return _super11.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            _createClass2(LineAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "lineAnnotation";
                var data2 = this.data;
                var width2 = data2.rect[2] - data2.rect[0];
                var height2 = data2.rect[3] - data2.rect[1];
                var svg = this.svgFactory.create(width2, height2);
                var line = this.svgFactory.createElement("svg:line");
                line.setAttribute("x1", data2.rect[2] - data2.lineCoordinates[0]);
                line.setAttribute("y1", data2.rect[3] - data2.lineCoordinates[1]);
                line.setAttribute("x2", data2.rect[2] - data2.lineCoordinates[2]);
                line.setAttribute("y2", data2.rect[3] - data2.lineCoordinates[3]);
                line.setAttribute("stroke-width", data2.borderStyle.width || 1);
                line.setAttribute("stroke", "transparent");
                line.setAttribute("fill", "transparent");
                svg.appendChild(line);
                this.container.append(svg);
                this._createPopup(line, data2);
                return this.container;
              }
            }]);
            return LineAnnotationElement2;
          }(AnnotationElement);
          var SquareAnnotationElement = /* @__PURE__ */ function(_AnnotationElement7) {
            _inherits2(SquareAnnotationElement2, _AnnotationElement7);
            var _super12 = _createSuper2(SquareAnnotationElement2);
            function SquareAnnotationElement2(parameters) {
              var _parameters$data$titl5, _parameters$data$cont5, _parameters$data$rich5;
              _classCallCheck2(this, SquareAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl5 = parameters.data.titleObj) !== null && _parameters$data$titl5 !== void 0 && _parameters$data$titl5.str || (_parameters$data$cont5 = parameters.data.contentsObj) !== null && _parameters$data$cont5 !== void 0 && _parameters$data$cont5.str || (_parameters$data$rich5 = parameters.data.richText) !== null && _parameters$data$rich5 !== void 0 && _parameters$data$rich5.str);
              return _super12.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            _createClass2(SquareAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "squareAnnotation";
                var data2 = this.data;
                var width2 = data2.rect[2] - data2.rect[0];
                var height2 = data2.rect[3] - data2.rect[1];
                var svg = this.svgFactory.create(width2, height2);
                var borderWidth = data2.borderStyle.width;
                var square2 = this.svgFactory.createElement("svg:rect");
                square2.setAttribute("x", borderWidth / 2);
                square2.setAttribute("y", borderWidth / 2);
                square2.setAttribute("width", width2 - borderWidth);
                square2.setAttribute("height", height2 - borderWidth);
                square2.setAttribute("stroke-width", borderWidth || 1);
                square2.setAttribute("stroke", "transparent");
                square2.setAttribute("fill", "transparent");
                svg.appendChild(square2);
                this.container.append(svg);
                this._createPopup(square2, data2);
                return this.container;
              }
            }]);
            return SquareAnnotationElement2;
          }(AnnotationElement);
          var CircleAnnotationElement = /* @__PURE__ */ function(_AnnotationElement8) {
            _inherits2(CircleAnnotationElement2, _AnnotationElement8);
            var _super13 = _createSuper2(CircleAnnotationElement2);
            function CircleAnnotationElement2(parameters) {
              var _parameters$data$titl6, _parameters$data$cont6, _parameters$data$rich6;
              _classCallCheck2(this, CircleAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl6 = parameters.data.titleObj) !== null && _parameters$data$titl6 !== void 0 && _parameters$data$titl6.str || (_parameters$data$cont6 = parameters.data.contentsObj) !== null && _parameters$data$cont6 !== void 0 && _parameters$data$cont6.str || (_parameters$data$rich6 = parameters.data.richText) !== null && _parameters$data$rich6 !== void 0 && _parameters$data$rich6.str);
              return _super13.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            _createClass2(CircleAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "circleAnnotation";
                var data2 = this.data;
                var width2 = data2.rect[2] - data2.rect[0];
                var height2 = data2.rect[3] - data2.rect[1];
                var svg = this.svgFactory.create(width2, height2);
                var borderWidth = data2.borderStyle.width;
                var circle = this.svgFactory.createElement("svg:ellipse");
                circle.setAttribute("cx", width2 / 2);
                circle.setAttribute("cy", height2 / 2);
                circle.setAttribute("rx", width2 / 2 - borderWidth / 2);
                circle.setAttribute("ry", height2 / 2 - borderWidth / 2);
                circle.setAttribute("stroke-width", borderWidth || 1);
                circle.setAttribute("stroke", "transparent");
                circle.setAttribute("fill", "transparent");
                svg.appendChild(circle);
                this.container.append(svg);
                this._createPopup(circle, data2);
                return this.container;
              }
            }]);
            return CircleAnnotationElement2;
          }(AnnotationElement);
          var PolylineAnnotationElement = /* @__PURE__ */ function(_AnnotationElement9) {
            _inherits2(PolylineAnnotationElement2, _AnnotationElement9);
            var _super14 = _createSuper2(PolylineAnnotationElement2);
            function PolylineAnnotationElement2(parameters) {
              var _parameters$data$titl7, _parameters$data$cont7, _parameters$data$rich7;
              var _this112;
              _classCallCheck2(this, PolylineAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl7 = parameters.data.titleObj) !== null && _parameters$data$titl7 !== void 0 && _parameters$data$titl7.str || (_parameters$data$cont7 = parameters.data.contentsObj) !== null && _parameters$data$cont7 !== void 0 && _parameters$data$cont7.str || (_parameters$data$rich7 = parameters.data.richText) !== null && _parameters$data$rich7 !== void 0 && _parameters$data$rich7.str);
              _this112 = _super14.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
              _this112.containerClassName = "polylineAnnotation";
              _this112.svgElementName = "svg:polyline";
              return _this112;
            }
            _createClass2(PolylineAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = this.containerClassName;
                var data2 = this.data;
                var width2 = data2.rect[2] - data2.rect[0];
                var height2 = data2.rect[3] - data2.rect[1];
                var svg = this.svgFactory.create(width2, height2);
                var points = [];
                var _iterator19 = _createForOfIteratorHelper2(data2.vertices), _step19;
                try {
                  for (_iterator19.s(); !(_step19 = _iterator19.n()).done; ) {
                    var coordinate = _step19.value;
                    var x2 = coordinate.x - data2.rect[0];
                    var y2 = data2.rect[3] - coordinate.y;
                    points.push(x2 + "," + y2);
                  }
                } catch (err) {
                  _iterator19.e(err);
                } finally {
                  _iterator19.f();
                }
                points = points.join(" ");
                var polyline = this.svgFactory.createElement(this.svgElementName);
                polyline.setAttribute("points", points);
                polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                polyline.setAttribute("stroke", "transparent");
                polyline.setAttribute("fill", "transparent");
                svg.appendChild(polyline);
                this.container.append(svg);
                this._createPopup(polyline, data2);
                return this.container;
              }
            }]);
            return PolylineAnnotationElement2;
          }(AnnotationElement);
          var PolygonAnnotationElement = /* @__PURE__ */ function(_PolylineAnnotationEl) {
            _inherits2(PolygonAnnotationElement2, _PolylineAnnotationEl);
            var _super15 = _createSuper2(PolygonAnnotationElement2);
            function PolygonAnnotationElement2(parameters) {
              var _this12;
              _classCallCheck2(this, PolygonAnnotationElement2);
              _this12 = _super15.call(this, parameters);
              _this12.containerClassName = "polygonAnnotation";
              _this12.svgElementName = "svg:polygon";
              return _this12;
            }
            return PolygonAnnotationElement2;
          }(PolylineAnnotationElement);
          var CaretAnnotationElement = /* @__PURE__ */ function(_AnnotationElement10) {
            _inherits2(CaretAnnotationElement2, _AnnotationElement10);
            var _super16 = _createSuper2(CaretAnnotationElement2);
            function CaretAnnotationElement2(parameters) {
              var _parameters$data$titl8, _parameters$data$cont8, _parameters$data$rich8;
              _classCallCheck2(this, CaretAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl8 = parameters.data.titleObj) !== null && _parameters$data$titl8 !== void 0 && _parameters$data$titl8.str || (_parameters$data$cont8 = parameters.data.contentsObj) !== null && _parameters$data$cont8 !== void 0 && _parameters$data$cont8.str || (_parameters$data$rich8 = parameters.data.richText) !== null && _parameters$data$rich8 !== void 0 && _parameters$data$rich8.str);
              return _super16.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            _createClass2(CaretAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "caretAnnotation";
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                return this.container;
              }
            }]);
            return CaretAnnotationElement2;
          }(AnnotationElement);
          var InkAnnotationElement = /* @__PURE__ */ function(_AnnotationElement11) {
            _inherits2(InkAnnotationElement2, _AnnotationElement11);
            var _super17 = _createSuper2(InkAnnotationElement2);
            function InkAnnotationElement2(parameters) {
              var _parameters$data$titl9, _parameters$data$cont9, _parameters$data$rich9;
              var _this13;
              _classCallCheck2(this, InkAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl9 = parameters.data.titleObj) !== null && _parameters$data$titl9 !== void 0 && _parameters$data$titl9.str || (_parameters$data$cont9 = parameters.data.contentsObj) !== null && _parameters$data$cont9 !== void 0 && _parameters$data$cont9.str || (_parameters$data$rich9 = parameters.data.richText) !== null && _parameters$data$rich9 !== void 0 && _parameters$data$rich9.str);
              _this13 = _super17.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
              _this13.containerClassName = "inkAnnotation";
              _this13.svgElementName = "svg:polyline";
              return _this13;
            }
            _createClass2(InkAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = this.containerClassName;
                var data2 = this.data;
                var width2 = data2.rect[2] - data2.rect[0];
                var height2 = data2.rect[3] - data2.rect[1];
                var svg = this.svgFactory.create(width2, height2);
                var _iterator20 = _createForOfIteratorHelper2(data2.inkLists), _step20;
                try {
                  for (_iterator20.s(); !(_step20 = _iterator20.n()).done; ) {
                    var inkList = _step20.value;
                    var points = [];
                    var _iterator21 = _createForOfIteratorHelper2(inkList), _step21;
                    try {
                      for (_iterator21.s(); !(_step21 = _iterator21.n()).done; ) {
                        var coordinate = _step21.value;
                        var x2 = coordinate.x - data2.rect[0];
                        var y2 = data2.rect[3] - coordinate.y;
                        points.push("".concat(x2, ",").concat(y2));
                      }
                    } catch (err) {
                      _iterator21.e(err);
                    } finally {
                      _iterator21.f();
                    }
                    points = points.join(" ");
                    var polyline = this.svgFactory.createElement(this.svgElementName);
                    polyline.setAttribute("points", points);
                    polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                    polyline.setAttribute("stroke", "transparent");
                    polyline.setAttribute("fill", "transparent");
                    this._createPopup(polyline, data2);
                    svg.appendChild(polyline);
                  }
                } catch (err) {
                  _iterator20.e(err);
                } finally {
                  _iterator20.f();
                }
                this.container.append(svg);
                return this.container;
              }
            }]);
            return InkAnnotationElement2;
          }(AnnotationElement);
          var HighlightAnnotationElement = /* @__PURE__ */ function(_AnnotationElement12) {
            _inherits2(HighlightAnnotationElement2, _AnnotationElement12);
            var _super18 = _createSuper2(HighlightAnnotationElement2);
            function HighlightAnnotationElement2(parameters) {
              var _parameters$data$titl10, _parameters$data$cont10, _parameters$data$rich10;
              _classCallCheck2(this, HighlightAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl10 = parameters.data.titleObj) !== null && _parameters$data$titl10 !== void 0 && _parameters$data$titl10.str || (_parameters$data$cont10 = parameters.data.contentsObj) !== null && _parameters$data$cont10 !== void 0 && _parameters$data$cont10.str || (_parameters$data$rich10 = parameters.data.richText) !== null && _parameters$data$rich10 !== void 0 && _parameters$data$rich10.str);
              return _super18.call(this, parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            _createClass2(HighlightAnnotationElement2, [{
              key: "render",
              value: function render() {
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                if (this.quadrilaterals) {
                  return this._renderQuadrilaterals("highlightAnnotation");
                }
                this.container.className = "highlightAnnotation";
                return this.container;
              }
            }]);
            return HighlightAnnotationElement2;
          }(AnnotationElement);
          var UnderlineAnnotationElement = /* @__PURE__ */ function(_AnnotationElement13) {
            _inherits2(UnderlineAnnotationElement2, _AnnotationElement13);
            var _super19 = _createSuper2(UnderlineAnnotationElement2);
            function UnderlineAnnotationElement2(parameters) {
              var _parameters$data$titl11, _parameters$data$cont11, _parameters$data$rich11;
              _classCallCheck2(this, UnderlineAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl11 = parameters.data.titleObj) !== null && _parameters$data$titl11 !== void 0 && _parameters$data$titl11.str || (_parameters$data$cont11 = parameters.data.contentsObj) !== null && _parameters$data$cont11 !== void 0 && _parameters$data$cont11.str || (_parameters$data$rich11 = parameters.data.richText) !== null && _parameters$data$rich11 !== void 0 && _parameters$data$rich11.str);
              return _super19.call(this, parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            _createClass2(UnderlineAnnotationElement2, [{
              key: "render",
              value: function render() {
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                if (this.quadrilaterals) {
                  return this._renderQuadrilaterals("underlineAnnotation");
                }
                this.container.className = "underlineAnnotation";
                return this.container;
              }
            }]);
            return UnderlineAnnotationElement2;
          }(AnnotationElement);
          var SquigglyAnnotationElement = /* @__PURE__ */ function(_AnnotationElement14) {
            _inherits2(SquigglyAnnotationElement2, _AnnotationElement14);
            var _super20 = _createSuper2(SquigglyAnnotationElement2);
            function SquigglyAnnotationElement2(parameters) {
              var _parameters$data$titl12, _parameters$data$cont12, _parameters$data$rich12;
              _classCallCheck2(this, SquigglyAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl12 = parameters.data.titleObj) !== null && _parameters$data$titl12 !== void 0 && _parameters$data$titl12.str || (_parameters$data$cont12 = parameters.data.contentsObj) !== null && _parameters$data$cont12 !== void 0 && _parameters$data$cont12.str || (_parameters$data$rich12 = parameters.data.richText) !== null && _parameters$data$rich12 !== void 0 && _parameters$data$rich12.str);
              return _super20.call(this, parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            _createClass2(SquigglyAnnotationElement2, [{
              key: "render",
              value: function render() {
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                if (this.quadrilaterals) {
                  return this._renderQuadrilaterals("squigglyAnnotation");
                }
                this.container.className = "squigglyAnnotation";
                return this.container;
              }
            }]);
            return SquigglyAnnotationElement2;
          }(AnnotationElement);
          var StrikeOutAnnotationElement = /* @__PURE__ */ function(_AnnotationElement15) {
            _inherits2(StrikeOutAnnotationElement2, _AnnotationElement15);
            var _super21 = _createSuper2(StrikeOutAnnotationElement2);
            function StrikeOutAnnotationElement2(parameters) {
              var _parameters$data$titl13, _parameters$data$cont13, _parameters$data$rich13;
              _classCallCheck2(this, StrikeOutAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl13 = parameters.data.titleObj) !== null && _parameters$data$titl13 !== void 0 && _parameters$data$titl13.str || (_parameters$data$cont13 = parameters.data.contentsObj) !== null && _parameters$data$cont13 !== void 0 && _parameters$data$cont13.str || (_parameters$data$rich13 = parameters.data.richText) !== null && _parameters$data$rich13 !== void 0 && _parameters$data$rich13.str);
              return _super21.call(this, parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            _createClass2(StrikeOutAnnotationElement2, [{
              key: "render",
              value: function render() {
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                if (this.quadrilaterals) {
                  return this._renderQuadrilaterals("strikeoutAnnotation");
                }
                this.container.className = "strikeoutAnnotation";
                return this.container;
              }
            }]);
            return StrikeOutAnnotationElement2;
          }(AnnotationElement);
          var StampAnnotationElement = /* @__PURE__ */ function(_AnnotationElement16) {
            _inherits2(StampAnnotationElement2, _AnnotationElement16);
            var _super22 = _createSuper2(StampAnnotationElement2);
            function StampAnnotationElement2(parameters) {
              var _parameters$data$titl14, _parameters$data$cont14, _parameters$data$rich14;
              _classCallCheck2(this, StampAnnotationElement2);
              var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl14 = parameters.data.titleObj) !== null && _parameters$data$titl14 !== void 0 && _parameters$data$titl14.str || (_parameters$data$cont14 = parameters.data.contentsObj) !== null && _parameters$data$cont14 !== void 0 && _parameters$data$cont14.str || (_parameters$data$rich14 = parameters.data.richText) !== null && _parameters$data$rich14 !== void 0 && _parameters$data$rich14.str);
              return _super22.call(this, parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            _createClass2(StampAnnotationElement2, [{
              key: "render",
              value: function render() {
                this.container.className = "stampAnnotation";
                if (!this.data.hasPopup) {
                  this._createPopup(null, this.data);
                }
                return this.container;
              }
            }]);
            return StampAnnotationElement2;
          }(AnnotationElement);
          var FileAttachmentAnnotationElement = /* @__PURE__ */ function(_AnnotationElement17) {
            _inherits2(FileAttachmentAnnotationElement2, _AnnotationElement17);
            var _super23 = _createSuper2(FileAttachmentAnnotationElement2);
            function FileAttachmentAnnotationElement2(parameters) {
              var _this14$linkService$e;
              var _this14;
              _classCallCheck2(this, FileAttachmentAnnotationElement2);
              _this14 = _super23.call(this, parameters, {
                isRenderable: true
              });
              var _this14$data$file = _this14.data.file, filename = _this14$data$file.filename, content = _this14$data$file.content;
              _this14.filename = (0, _display_utils2.getFilenameFromUrl)(filename);
              _this14.content = content;
              (_this14$linkService$e = _this14.linkService.eventBus) === null || _this14$linkService$e === void 0 ? void 0 : _this14$linkService$e.dispatch("fileattachmentannotation", {
                source: _assertThisInitialized2(_this14),
                id: (0, _util2.stringToPDFString)(filename),
                filename,
                content
              });
              return _this14;
            }
            _createClass2(FileAttachmentAnnotationElement2, [{
              key: "render",
              value: function render() {
                var _this$data$titleObj, _this$data$contentsOb;
                this.container.className = "fileAttachmentAnnotation";
                var trigger = document.createElement("div");
                trigger.style.height = this.container.style.height;
                trigger.style.width = this.container.style.width;
                trigger.addEventListener("dblclick", this._download.bind(this));
                if (!this.data.hasPopup && ((_this$data$titleObj = this.data.titleObj) !== null && _this$data$titleObj !== void 0 && _this$data$titleObj.str || (_this$data$contentsOb = this.data.contentsObj) !== null && _this$data$contentsOb !== void 0 && _this$data$contentsOb.str || this.data.richText)) {
                  this._createPopup(trigger, this.data);
                }
                this.container.appendChild(trigger);
                return this.container;
              }
            }, {
              key: "_download",
              value: function _download() {
                var _this$downloadManager;
                (_this$downloadManager = this.downloadManager) === null || _this$downloadManager === void 0 ? void 0 : _this$downloadManager.openOrDownloadData(this.container, this.content, this.filename);
              }
            }]);
            return FileAttachmentAnnotationElement2;
          }(AnnotationElement);
          var AnnotationLayer3 = /* @__PURE__ */ function() {
            function AnnotationLayer4() {
              _classCallCheck2(this, AnnotationLayer4);
            }
            _createClass2(AnnotationLayer4, null, [{
              key: "render",
              value: function render(parameters) {
                var sortedAnnotations = [], popupAnnotations = [];
                var _iterator22 = _createForOfIteratorHelper2(parameters.annotations), _step22;
                try {
                  for (_iterator22.s(); !(_step22 = _iterator22.n()).done; ) {
                    var _data = _step22.value;
                    if (!_data) {
                      continue;
                    }
                    if (_data.annotationType === _util2.AnnotationType.POPUP) {
                      popupAnnotations.push(_data);
                      continue;
                    }
                    sortedAnnotations.push(_data);
                  }
                } catch (err) {
                  _iterator22.e(err);
                } finally {
                  _iterator22.f();
                }
                if (popupAnnotations.length) {
                  sortedAnnotations.push.apply(sortedAnnotations, popupAnnotations);
                }
                var div2 = parameters.div;
                for (var _i7 = 0, _sortedAnnotations = sortedAnnotations; _i7 < _sortedAnnotations.length; _i7++) {
                  var data2 = _sortedAnnotations[_i7];
                  var element = AnnotationElementFactory.create({
                    data: data2,
                    layer: div2,
                    page: parameters.page,
                    viewport: parameters.viewport,
                    linkService: parameters.linkService,
                    downloadManager: parameters.downloadManager,
                    imageResourcesPath: parameters.imageResourcesPath || "",
                    renderForms: parameters.renderForms !== false,
                    svgFactory: new _display_utils2.DOMSVGFactory(),
                    annotationStorage: parameters.annotationStorage || new _annotation_storage2.AnnotationStorage(),
                    enableScripting: parameters.enableScripting,
                    hasJSActions: parameters.hasJSActions,
                    fieldObjects: parameters.fieldObjects,
                    mouseState: parameters.mouseState || {
                      isDown: false
                    }
                  });
                  if (element.isRenderable) {
                    var rendered = element.render();
                    if (data2.hidden) {
                      rendered.style.visibility = "hidden";
                    }
                    if (Array.isArray(rendered)) {
                      var _iterator23 = _createForOfIteratorHelper2(rendered), _step23;
                      try {
                        for (_iterator23.s(); !(_step23 = _iterator23.n()).done; ) {
                          var renderedElement = _step23.value;
                          div2.appendChild(renderedElement);
                        }
                      } catch (err) {
                        _iterator23.e(err);
                      } finally {
                        _iterator23.f();
                      }
                    } else {
                      if (element instanceof PopupAnnotationElement) {
                        div2.prepend(rendered);
                      } else {
                        div2.appendChild(rendered);
                      }
                    }
                  }
                }
                _classStaticPrivateMethodGet(this, AnnotationLayer4, _setAnnotationCanvasMap).call(this, div2, parameters.annotationCanvasMap);
              }
            }, {
              key: "update",
              value: function update2(parameters) {
                var page = parameters.page, viewport = parameters.viewport, annotations = parameters.annotations, annotationCanvasMap = parameters.annotationCanvasMap, div2 = parameters.div;
                var transform2 = viewport.transform;
                var matrix = "matrix(".concat(transform2.join(","), ")");
                var scale2, ownMatrix;
                var _iterator24 = _createForOfIteratorHelper2(annotations), _step24;
                try {
                  for (_iterator24.s(); !(_step24 = _iterator24.n()).done; ) {
                    var data2 = _step24.value;
                    var elements = div2.querySelectorAll('[data-annotation-id="'.concat(data2.id, '"]'));
                    if (elements) {
                      var _iterator25 = _createForOfIteratorHelper2(elements), _step25;
                      try {
                        for (_iterator25.s(); !(_step25 = _iterator25.n()).done; ) {
                          var element = _step25.value;
                          if (data2.hasOwnCanvas) {
                            var rect = _util2.Util.normalizeRect([data2.rect[0], page.view[3] - data2.rect[1] + page.view[1], data2.rect[2], page.view[3] - data2.rect[3] + page.view[1]]);
                            if (!ownMatrix) {
                              scale2 = Math.abs(transform2[0] || transform2[1]);
                              var ownTransform = transform2.slice();
                              for (var i2 = 0; i2 < 4; i2++) {
                                ownTransform[i2] = Math.sign(ownTransform[i2]);
                              }
                              ownMatrix = "matrix(".concat(ownTransform.join(","), ")");
                            }
                            var left2 = rect[0] * scale2;
                            var top2 = rect[1] * scale2;
                            element.style.left = "".concat(left2, "px");
                            element.style.top = "".concat(top2, "px");
                            element.style.transformOrigin = "".concat(-left2, "px ").concat(-top2, "px");
                            element.style.transform = ownMatrix;
                          } else {
                            element.style.transform = matrix;
                          }
                        }
                      } catch (err) {
                        _iterator25.e(err);
                      } finally {
                        _iterator25.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator24.e(err);
                } finally {
                  _iterator24.f();
                }
                _classStaticPrivateMethodGet(this, AnnotationLayer4, _setAnnotationCanvasMap).call(this, div2, annotationCanvasMap);
                div2.hidden = false;
              }
            }]);
            return AnnotationLayer4;
          }();
          exports2.AnnotationLayer = AnnotationLayer3;
          function _setAnnotationCanvasMap(div2, annotationCanvasMap) {
            if (!annotationCanvasMap) {
              return;
            }
            var _iterator26 = _createForOfIteratorHelper2(annotationCanvasMap), _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done; ) {
                var _step26$value = _slicedToArray2(_step26.value, 2), id2 = _step26$value[0], canvas = _step26$value[1];
                var element = div2.querySelector('[data-annotation-id="'.concat(id2, '"]'));
                if (!element) {
                  continue;
                }
                var firstChild = element.firstChild;
                if (firstChild.nodeName === "CANVAS") {
                  element.replaceChild(canvas, firstChild);
                } else {
                  element.insertBefore(canvas, firstChild);
                }
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
            annotationCanvasMap.clear();
          }
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.ColorConverters = void 0;
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function makeColorComp(n2) {
            return Math.floor(Math.max(0, Math.min(1, n2)) * 255).toString(16).padStart(2, "0");
          }
          var ColorConverters = /* @__PURE__ */ function() {
            function ColorConverters2() {
              _classCallCheck2(this, ColorConverters2);
            }
            _createClass2(ColorConverters2, null, [{
              key: "CMYK_G",
              value: function CMYK_G(_ref) {
                var _ref2 = _slicedToArray2(_ref, 4), c2 = _ref2[0], y2 = _ref2[1], m2 = _ref2[2], k3 = _ref2[3];
                return ["G", 1 - Math.min(1, 0.3 * c2 + 0.59 * m2 + 0.11 * y2 + k3)];
              }
            }, {
              key: "G_CMYK",
              value: function G_CMYK(_ref3) {
                var _ref4 = _slicedToArray2(_ref3, 1), g2 = _ref4[0];
                return ["CMYK", 0, 0, 0, 1 - g2];
              }
            }, {
              key: "G_RGB",
              value: function G_RGB(_ref5) {
                var _ref6 = _slicedToArray2(_ref5, 1), g2 = _ref6[0];
                return ["RGB", g2, g2, g2];
              }
            }, {
              key: "G_HTML",
              value: function G_HTML(_ref7) {
                var _ref8 = _slicedToArray2(_ref7, 1), g2 = _ref8[0];
                var G2 = makeColorComp(g2);
                return "#".concat(G2).concat(G2).concat(G2);
              }
            }, {
              key: "RGB_G",
              value: function RGB_G(_ref9) {
                var _ref10 = _slicedToArray2(_ref9, 3), r2 = _ref10[0], g2 = _ref10[1], b2 = _ref10[2];
                return ["G", 0.3 * r2 + 0.59 * g2 + 0.11 * b2];
              }
            }, {
              key: "RGB_HTML",
              value: function RGB_HTML(_ref11) {
                var _ref12 = _slicedToArray2(_ref11, 3), r2 = _ref12[0], g2 = _ref12[1], b2 = _ref12[2];
                var R = makeColorComp(r2);
                var G2 = makeColorComp(g2);
                var B2 = makeColorComp(b2);
                return "#".concat(R).concat(G2).concat(B2);
              }
            }, {
              key: "T_HTML",
              value: function T_HTML() {
                return "#00000000";
              }
            }, {
              key: "CMYK_RGB",
              value: function CMYK_RGB(_ref13) {
                var _ref14 = _slicedToArray2(_ref13, 4), c2 = _ref14[0], y2 = _ref14[1], m2 = _ref14[2], k3 = _ref14[3];
                return ["RGB", 1 - Math.min(1, c2 + k3), 1 - Math.min(1, m2 + k3), 1 - Math.min(1, y2 + k3)];
              }
            }, {
              key: "CMYK_HTML",
              value: function CMYK_HTML(components) {
                return this.RGB_HTML(this.CMYK_RGB(components));
              }
            }, {
              key: "RGB_CMYK",
              value: function RGB_CMYK(_ref152) {
                var _ref16 = _slicedToArray2(_ref152, 3), r2 = _ref16[0], g2 = _ref16[1], b2 = _ref16[2];
                var c2 = 1 - r2;
                var m2 = 1 - g2;
                var y2 = 1 - b2;
                var k3 = Math.min(c2, m2, y2);
                return ["CMYK", c2, m2, y2, k3];
              }
            }]);
            return ColorConverters2;
          }();
          exports2.ColorConverters = ColorConverters;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.XfaLayer = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          var _xfa_text2 = __w_pdfjs_require__2(147);
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e3) {
              didErr = true;
              err = _e3;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var XfaLayer = /* @__PURE__ */ function() {
            function XfaLayer2() {
              _classCallCheck2(this, XfaLayer2);
            }
            _createClass2(XfaLayer2, null, [{
              key: "setupStorage",
              value: function setupStorage(html, id2, element, storage, intent) {
                var storedData = storage.getValue(id2, {
                  value: null
                });
                switch (element.name) {
                  case "textarea":
                    if (storedData.value !== null) {
                      html.textContent = storedData.value;
                    }
                    if (intent === "print") {
                      break;
                    }
                    html.addEventListener("input", function(event) {
                      storage.setValue(id2, {
                        value: event.target.value
                      });
                    });
                    break;
                  case "input":
                    if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                      if (storedData.value === element.attributes.xfaOn) {
                        html.setAttribute("checked", true);
                      } else if (storedData.value === element.attributes.xfaOff) {
                        html.removeAttribute("checked");
                      }
                      if (intent === "print") {
                        break;
                      }
                      html.addEventListener("change", function(event) {
                        storage.setValue(id2, {
                          value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (storedData.value !== null) {
                        html.setAttribute("value", storedData.value);
                      }
                      if (intent === "print") {
                        break;
                      }
                      html.addEventListener("input", function(event) {
                        storage.setValue(id2, {
                          value: event.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (storedData.value !== null) {
                      var _iterator = _createForOfIteratorHelper2(element.children), _step;
                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                          var option = _step.value;
                          if (option.attributes.value === storedData.value) {
                            option.attributes.selected = true;
                          }
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                    }
                    html.addEventListener("input", function(event) {
                      var options = event.target.options;
                      var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                      storage.setValue(id2, {
                        value
                      });
                    });
                    break;
                }
              }
            }, {
              key: "setAttributes",
              value: function setAttributes(_ref) {
                var html = _ref.html, element = _ref.element, _ref$storage = _ref.storage, storage = _ref$storage === void 0 ? null : _ref$storage, intent = _ref.intent, linkService = _ref.linkService;
                var attributes = element.attributes;
                var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                if (attributes.type === "radio") {
                  attributes.name = "".concat(attributes.name, "-").concat(intent);
                }
                for (var _i = 0, _Object$entries = Object.entries(attributes); _i < _Object$entries.length; _i++) {
                  var _Object$entries$_i = _slicedToArray2(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                  if (value === null || value === void 0 || key === "dataId") {
                    continue;
                  }
                  if (key !== "style") {
                    if (key === "textContent") {
                      html.textContent = value;
                    } else if (key === "class") {
                      if (value.length) {
                        html.setAttribute(key, value.join(" "));
                      }
                    } else {
                      if (isHTMLAnchorElement && (key === "href" || key === "newWindow")) {
                        continue;
                      }
                      html.setAttribute(key, value);
                    }
                  } else {
                    Object.assign(html.style, value);
                  }
                }
                if (isHTMLAnchorElement) {
                  var _linkService$addLinkA;
                  if (!linkService.addLinkAttributes) {
                    (0, _util2.warn)("XfaLayer.setAttribute - missing `addLinkAttributes`-method on the `linkService`-instance.");
                  }
                  (_linkService$addLinkA = linkService.addLinkAttributes) === null || _linkService$addLinkA === void 0 ? void 0 : _linkService$addLinkA.call(linkService, html, attributes.href, attributes.newWindow);
                }
                if (storage && attributes.dataId) {
                  this.setupStorage(html, attributes.dataId, element, storage);
                }
              }
            }, {
              key: "render",
              value: function render(parameters) {
                var storage = parameters.annotationStorage;
                var linkService = parameters.linkService;
                var root2 = parameters.xfaHtml;
                var intent = parameters.intent || "display";
                var rootHtml = document.createElement(root2.name);
                if (root2.attributes) {
                  this.setAttributes({
                    html: rootHtml,
                    element: root2,
                    intent,
                    linkService
                  });
                }
                var stack2 = [[root2, -1, rootHtml]];
                var rootDiv = parameters.div;
                rootDiv.appendChild(rootHtml);
                if (parameters.viewport) {
                  var transform2 = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                  rootDiv.style.transform = transform2;
                }
                if (intent !== "richText") {
                  rootDiv.setAttribute("class", "xfaLayer xfaFont");
                }
                var textDivs = [];
                while (stack2.length > 0) {
                  var _child$attributes;
                  var _stack = _slicedToArray2(stack2[stack2.length - 1], 3), parent = _stack[0], i2 = _stack[1], html = _stack[2];
                  if (i2 + 1 === parent.children.length) {
                    stack2.pop();
                    continue;
                  }
                  var child = parent.children[++stack2[stack2.length - 1][1]];
                  if (child === null) {
                    continue;
                  }
                  var name = child.name;
                  if (name === "#text") {
                    var node = document.createTextNode(child.value);
                    textDivs.push(node);
                    html.appendChild(node);
                    continue;
                  }
                  var childHtml = void 0;
                  if (child !== null && child !== void 0 && (_child$attributes = child.attributes) !== null && _child$attributes !== void 0 && _child$attributes.xmlns) {
                    childHtml = document.createElementNS(child.attributes.xmlns, name);
                  } else {
                    childHtml = document.createElement(name);
                  }
                  html.appendChild(childHtml);
                  if (child.attributes) {
                    this.setAttributes({
                      html: childHtml,
                      element: child,
                      storage,
                      intent,
                      linkService
                    });
                  }
                  if (child.children && child.children.length > 0) {
                    stack2.push([child, -1, childHtml]);
                  } else if (child.value) {
                    var _node = document.createTextNode(child.value);
                    if (_xfa_text2.XfaText.shouldBuildText(name)) {
                      textDivs.push(_node);
                    }
                    childHtml.appendChild(_node);
                  }
                }
                var _iterator2 = _createForOfIteratorHelper2(rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")), _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var el = _step2.value;
                    el.setAttribute("readOnly", true);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                return {
                  textDivs
                };
              }
            }, {
              key: "update",
              value: function update2(parameters) {
                var transform2 = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                parameters.div.style.transform = transform2;
                parameters.div.hidden = false;
              }
            }]);
            return XfaLayer2;
          }();
          exports2.XfaLayer = XfaLayer;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.renderTextLayer = renderTextLayer;
          var _util2 = __w_pdfjs_require__2(4);
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          var MAX_TEXT_DIVS_TO_RENDER = 1e5;
          var DEFAULT_FONT_SIZE = 30;
          var DEFAULT_FONT_ASCENT = 0.8;
          var ascentCache = /* @__PURE__ */ new Map();
          var AllWhitespaceRegexp = /^\s+$/g;
          function getAscent(fontFamily, ctx) {
            var cachedAscent = ascentCache.get(fontFamily);
            if (cachedAscent) {
              return cachedAscent;
            }
            ctx.save();
            ctx.font = "".concat(DEFAULT_FONT_SIZE, "px ").concat(fontFamily);
            var metrics = ctx.measureText("");
            var ascent = metrics.fontBoundingBoxAscent;
            var descent = Math.abs(metrics.fontBoundingBoxDescent);
            if (ascent) {
              ctx.restore();
              var ratio = ascent / (ascent + descent);
              ascentCache.set(fontFamily, ratio);
              return ratio;
            }
            ctx.strokeStyle = "red";
            ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
            ctx.strokeText("g", 0, 0);
            var pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
            descent = 0;
            for (var i2 = pixels.length - 1 - 3; i2 >= 0; i2 -= 4) {
              if (pixels[i2] > 0) {
                descent = Math.ceil(i2 / 4 / DEFAULT_FONT_SIZE);
                break;
              }
            }
            ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
            ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
            pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
            ascent = 0;
            for (var _i = 0, ii = pixels.length; _i < ii; _i += 4) {
              if (pixels[_i] > 0) {
                ascent = DEFAULT_FONT_SIZE - Math.floor(_i / 4 / DEFAULT_FONT_SIZE);
                break;
              }
            }
            ctx.restore();
            if (ascent) {
              var _ratio = ascent / (ascent + descent);
              ascentCache.set(fontFamily, _ratio);
              return _ratio;
            }
            ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
            return DEFAULT_FONT_ASCENT;
          }
          function appendText(task, geom, styles, ctx) {
            var textDiv = document.createElement("span");
            var textDivProperties = task._enhanceTextSelection ? {
              angle: 0,
              canvasWidth: 0,
              hasText: geom.str !== "",
              hasEOL: geom.hasEOL,
              originalTransform: null,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              paddingTop: 0,
              scale: 1
            } : {
              angle: 0,
              canvasWidth: 0,
              hasText: geom.str !== "",
              hasEOL: geom.hasEOL
            };
            task._textDivs.push(textDiv);
            var tx = _util2.Util.transform(task._viewport.transform, geom.transform);
            var angle = Math.atan2(tx[1], tx[0]);
            var style = styles[geom.fontName];
            if (style.vertical) {
              angle += Math.PI / 2;
            }
            var fontHeight = Math.hypot(tx[2], tx[3]);
            var fontAscent = fontHeight * getAscent(style.fontFamily, ctx);
            var left2, top2;
            if (angle === 0) {
              left2 = tx[4];
              top2 = tx[5] - fontAscent;
            } else {
              left2 = tx[4] + fontAscent * Math.sin(angle);
              top2 = tx[5] - fontAscent * Math.cos(angle);
            }
            textDiv.style.left = "".concat(left2, "px");
            textDiv.style.top = "".concat(top2, "px");
            textDiv.style.fontSize = "".concat(fontHeight, "px");
            textDiv.style.fontFamily = style.fontFamily;
            textDiv.setAttribute("role", "presentation");
            textDiv.textContent = geom.str;
            textDiv.dir = geom.dir;
            if (task._fontInspectorEnabled) {
              textDiv.dataset.fontName = geom.fontName;
            }
            if (angle !== 0) {
              textDivProperties.angle = angle * (180 / Math.PI);
            }
            var shouldScaleText = false;
            if (geom.str.length > 1 || task._enhanceTextSelection && AllWhitespaceRegexp.test(geom.str)) {
              shouldScaleText = true;
            } else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
              var absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
              if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
                shouldScaleText = true;
              }
            }
            if (shouldScaleText) {
              if (style.vertical) {
                textDivProperties.canvasWidth = geom.height * task._viewport.scale;
              } else {
                textDivProperties.canvasWidth = geom.width * task._viewport.scale;
              }
            }
            task._textDivProperties.set(textDiv, textDivProperties);
            if (task._textContentStream) {
              task._layoutText(textDiv);
            }
            if (task._enhanceTextSelection && textDivProperties.hasText) {
              var angleCos = 1, angleSin = 0;
              if (angle !== 0) {
                angleCos = Math.cos(angle);
                angleSin = Math.sin(angle);
              }
              var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
              var divHeight = fontHeight;
              var m2, b2;
              if (angle !== 0) {
                m2 = [angleCos, angleSin, -angleSin, angleCos, left2, top2];
                b2 = _util2.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m2);
              } else {
                b2 = [left2, top2, left2 + divWidth, top2 + divHeight];
              }
              task._bounds.push({
                left: b2[0],
                top: b2[1],
                right: b2[2],
                bottom: b2[3],
                div: textDiv,
                size: [divWidth, divHeight],
                m: m2
              });
            }
          }
          function render(task) {
            if (task._canceled) {
              return;
            }
            var textDivs = task._textDivs;
            var capability = task._capability;
            var textDivsLength = textDivs.length;
            if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
              task._renderingDone = true;
              capability.resolve();
              return;
            }
            if (!task._textContentStream) {
              for (var i2 = 0; i2 < textDivsLength; i2++) {
                task._layoutText(textDivs[i2]);
              }
            }
            task._renderingDone = true;
            capability.resolve();
          }
          function findPositiveMin(ts, offset, count2) {
            var result2 = 0;
            for (var i2 = 0; i2 < count2; i2++) {
              var t2 = ts[offset++];
              if (t2 > 0) {
                result2 = result2 ? Math.min(t2, result2) : t2;
              }
            }
            return result2;
          }
          function expand(task) {
            var bounds = task._bounds;
            var viewport = task._viewport;
            var expanded = expandBounds(viewport.width, viewport.height, bounds);
            for (var i2 = 0; i2 < expanded.length; i2++) {
              var div2 = bounds[i2].div;
              var divProperties = task._textDivProperties.get(div2);
              if (divProperties.angle === 0) {
                divProperties.paddingLeft = bounds[i2].left - expanded[i2].left;
                divProperties.paddingTop = bounds[i2].top - expanded[i2].top;
                divProperties.paddingRight = expanded[i2].right - bounds[i2].right;
                divProperties.paddingBottom = expanded[i2].bottom - bounds[i2].bottom;
                task._textDivProperties.set(div2, divProperties);
                continue;
              }
              var e2 = expanded[i2], b2 = bounds[i2];
              var m2 = b2.m, c2 = m2[0], s2 = m2[1];
              var points = [[0, 0], [0, b2.size[1]], [b2.size[0], 0], b2.size];
              var ts = new Float64Array(64);
              for (var j2 = 0, jj = points.length; j2 < jj; j2++) {
                var t2 = _util2.Util.applyTransform(points[j2], m2);
                ts[j2 + 0] = c2 && (e2.left - t2[0]) / c2;
                ts[j2 + 4] = s2 && (e2.top - t2[1]) / s2;
                ts[j2 + 8] = c2 && (e2.right - t2[0]) / c2;
                ts[j2 + 12] = s2 && (e2.bottom - t2[1]) / s2;
                ts[j2 + 16] = s2 && (e2.left - t2[0]) / -s2;
                ts[j2 + 20] = c2 && (e2.top - t2[1]) / c2;
                ts[j2 + 24] = s2 && (e2.right - t2[0]) / -s2;
                ts[j2 + 28] = c2 && (e2.bottom - t2[1]) / c2;
                ts[j2 + 32] = c2 && (e2.left - t2[0]) / -c2;
                ts[j2 + 36] = s2 && (e2.top - t2[1]) / -s2;
                ts[j2 + 40] = c2 && (e2.right - t2[0]) / -c2;
                ts[j2 + 44] = s2 && (e2.bottom - t2[1]) / -s2;
                ts[j2 + 48] = s2 && (e2.left - t2[0]) / s2;
                ts[j2 + 52] = c2 && (e2.top - t2[1]) / -c2;
                ts[j2 + 56] = s2 && (e2.right - t2[0]) / s2;
                ts[j2 + 60] = c2 && (e2.bottom - t2[1]) / -c2;
              }
              var boxScale = 1 + Math.min(Math.abs(c2), Math.abs(s2));
              divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
              divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
              divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
              divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
              task._textDivProperties.set(div2, divProperties);
            }
          }
          function expandBounds(width2, height2, boxes) {
            var bounds = boxes.map(function(box, i3) {
              return {
                x1: box.left,
                y1: box.top,
                x2: box.right,
                y2: box.bottom,
                index: i3,
                x1New: void 0,
                x2New: void 0
              };
            });
            expandBoundsLTR(width2, bounds);
            var expanded = new Array(boxes.length);
            var _iterator = _createForOfIteratorHelper2(bounds), _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                var b2 = _step.value;
                var i2 = b2.index;
                expanded[i2] = {
                  left: b2.x1New,
                  top: 0,
                  right: b2.x2New,
                  bottom: 0
                };
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            boxes.map(function(box, i3) {
              var e2 = expanded[i3], b3 = bounds[i3];
              b3.x1 = box.top;
              b3.y1 = width2 - e2.right;
              b3.x2 = box.bottom;
              b3.y2 = width2 - e2.left;
              b3.index = i3;
              b3.x1New = void 0;
              b3.x2New = void 0;
            });
            expandBoundsLTR(height2, bounds);
            var _iterator2 = _createForOfIteratorHelper2(bounds), _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                var _b = _step2.value;
                var _i2 = _b.index;
                expanded[_i2].top = _b.x1New;
                expanded[_i2].bottom = _b.x2New;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            return expanded;
          }
          function expandBoundsLTR(width2, bounds) {
            bounds.sort(function(a6, b2) {
              return a6.x1 - b2.x1 || a6.index - b2.index;
            });
            var fakeBoundary = {
              x1: -Infinity,
              y1: -Infinity,
              x2: 0,
              y2: Infinity,
              index: -1,
              x1New: 0,
              x2New: 0
            };
            var horizon = [{
              start: -Infinity,
              end: Infinity,
              boundary: fakeBoundary
            }];
            var _iterator3 = _createForOfIteratorHelper2(bounds), _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                var boundary = _step3.value;
                var i2 = 0;
                while (i2 < horizon.length && horizon[i2].end <= boundary.y1) {
                  i2++;
                }
                var j2 = horizon.length - 1;
                while (j2 >= 0 && horizon[j2].start >= boundary.y2) {
                  j2--;
                }
                var _horizonPart = void 0, _affectedBoundary = void 0;
                var q2 = void 0, k3 = void 0, maxXNew = -Infinity;
                for (q2 = i2; q2 <= j2; q2++) {
                  _horizonPart = horizon[q2];
                  _affectedBoundary = _horizonPart.boundary;
                  var xNew = void 0;
                  if (_affectedBoundary.x2 > boundary.x1) {
                    xNew = _affectedBoundary.index > boundary.index ? _affectedBoundary.x1New : boundary.x1;
                  } else if (_affectedBoundary.x2New === void 0) {
                    xNew = (_affectedBoundary.x2 + boundary.x1) / 2;
                  } else {
                    xNew = _affectedBoundary.x2New;
                  }
                  if (xNew > maxXNew) {
                    maxXNew = xNew;
                  }
                }
                boundary.x1New = maxXNew;
                for (q2 = i2; q2 <= j2; q2++) {
                  _horizonPart = horizon[q2];
                  _affectedBoundary = _horizonPart.boundary;
                  if (_affectedBoundary.x2New === void 0) {
                    if (_affectedBoundary.x2 > boundary.x1) {
                      if (_affectedBoundary.index > boundary.index) {
                        _affectedBoundary.x2New = _affectedBoundary.x2;
                      }
                    } else {
                      _affectedBoundary.x2New = maxXNew;
                    }
                  } else if (_affectedBoundary.x2New > maxXNew) {
                    _affectedBoundary.x2New = Math.max(maxXNew, _affectedBoundary.x2);
                  }
                }
                var changedHorizon = [];
                var lastBoundary = null;
                for (q2 = i2; q2 <= j2; q2++) {
                  _horizonPart = horizon[q2];
                  _affectedBoundary = _horizonPart.boundary;
                  var useBoundary = _affectedBoundary.x2 > boundary.x2 ? _affectedBoundary : boundary;
                  if (lastBoundary === useBoundary) {
                    changedHorizon[changedHorizon.length - 1].end = _horizonPart.end;
                  } else {
                    changedHorizon.push({
                      start: _horizonPart.start,
                      end: _horizonPart.end,
                      boundary: useBoundary
                    });
                    lastBoundary = useBoundary;
                  }
                }
                if (horizon[i2].start < boundary.y1) {
                  changedHorizon[0].start = boundary.y1;
                  changedHorizon.unshift({
                    start: horizon[i2].start,
                    end: boundary.y1,
                    boundary: horizon[i2].boundary
                  });
                }
                if (boundary.y2 < horizon[j2].end) {
                  changedHorizon[changedHorizon.length - 1].end = boundary.y2;
                  changedHorizon.push({
                    start: boundary.y2,
                    end: horizon[j2].end,
                    boundary: horizon[j2].boundary
                  });
                }
                for (q2 = i2; q2 <= j2; q2++) {
                  _horizonPart = horizon[q2];
                  _affectedBoundary = _horizonPart.boundary;
                  if (_affectedBoundary.x2New !== void 0) {
                    continue;
                  }
                  var used = false;
                  for (k3 = i2 - 1; !used && k3 >= 0 && horizon[k3].start >= _affectedBoundary.y1; k3--) {
                    used = horizon[k3].boundary === _affectedBoundary;
                  }
                  for (k3 = j2 + 1; !used && k3 < horizon.length && horizon[k3].end <= _affectedBoundary.y2; k3++) {
                    used = horizon[k3].boundary === _affectedBoundary;
                  }
                  for (k3 = 0; !used && k3 < changedHorizon.length; k3++) {
                    used = changedHorizon[k3].boundary === _affectedBoundary;
                  }
                  if (!used) {
                    _affectedBoundary.x2New = maxXNew;
                  }
                }
                Array.prototype.splice.apply(horizon, [i2, j2 - i2 + 1].concat(changedHorizon));
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            for (var _i3 = 0, _horizon = horizon; _i3 < _horizon.length; _i3++) {
              var horizonPart = _horizon[_i3];
              var affectedBoundary = horizonPart.boundary;
              if (affectedBoundary.x2New === void 0) {
                affectedBoundary.x2New = Math.max(width2, affectedBoundary.x2);
              }
            }
          }
          var TextLayerRenderTask = /* @__PURE__ */ function() {
            function TextLayerRenderTask2(_ref) {
              var _globalThis$FontInspe, _this = this;
              var textContent = _ref.textContent, textContentStream = _ref.textContentStream, container = _ref.container, viewport = _ref.viewport, textDivs = _ref.textDivs, textContentItemsStr = _ref.textContentItemsStr, enhanceTextSelection = _ref.enhanceTextSelection;
              _classCallCheck2(this, TextLayerRenderTask2);
              this._textContent = textContent;
              this._textContentStream = textContentStream;
              this._container = container;
              this._document = container.ownerDocument;
              this._viewport = viewport;
              this._textDivs = textDivs || [];
              this._textContentItemsStr = textContentItemsStr || [];
              this._enhanceTextSelection = !!enhanceTextSelection;
              this._fontInspectorEnabled = !!((_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled);
              this._reader = null;
              this._layoutTextLastFontSize = null;
              this._layoutTextLastFontFamily = null;
              this._layoutTextCtx = null;
              this._textDivProperties = /* @__PURE__ */ new WeakMap();
              this._renderingDone = false;
              this._canceled = false;
              this._capability = (0, _util2.createPromiseCapability)();
              this._renderTimer = null;
              this._bounds = [];
              this._capability.promise["finally"](function() {
                if (!_this._enhanceTextSelection) {
                  _this._textDivProperties = null;
                }
                if (_this._layoutTextCtx) {
                  _this._layoutTextCtx.canvas.width = 0;
                  _this._layoutTextCtx.canvas.height = 0;
                  _this._layoutTextCtx = null;
                }
              })["catch"](function() {
              });
            }
            _createClass2(TextLayerRenderTask2, [{
              key: "promise",
              get: function get2() {
                return this._capability.promise;
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this._canceled = true;
                if (this._reader) {
                  this._reader.cancel(new _util2.AbortException("TextLayer task cancelled."))["catch"](function() {
                  });
                  this._reader = null;
                }
                if (this._renderTimer !== null) {
                  clearTimeout(this._renderTimer);
                  this._renderTimer = null;
                }
                this._capability.reject(new Error("TextLayer task cancelled."));
              }
            }, {
              key: "_processItems",
              value: function _processItems(items, styleCache) {
                for (var i2 = 0, len = items.length; i2 < len; i2++) {
                  if (items[i2].str === void 0) {
                    if (items[i2].type === "beginMarkedContentProps" || items[i2].type === "beginMarkedContent") {
                      var parent = this._container;
                      this._container = document.createElement("span");
                      this._container.classList.add("markedContent");
                      if (items[i2].id !== null) {
                        this._container.setAttribute("id", "".concat(items[i2].id));
                      }
                      parent.appendChild(this._container);
                    } else if (items[i2].type === "endMarkedContent") {
                      this._container = this._container.parentNode;
                    }
                    continue;
                  }
                  this._textContentItemsStr.push(items[i2].str);
                  appendText(this, items[i2], styleCache, this._layoutTextCtx);
                }
              }
            }, {
              key: "_layoutText",
              value: function _layoutText(textDiv) {
                var textDivProperties = this._textDivProperties.get(textDiv);
                var transform2 = "";
                if (textDivProperties.canvasWidth !== 0 && textDivProperties.hasText) {
                  var _textDiv$style = textDiv.style, fontSize = _textDiv$style.fontSize, fontFamily = _textDiv$style.fontFamily;
                  if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
                    this._layoutTextCtx.font = "".concat(fontSize, " ").concat(fontFamily);
                    this._layoutTextLastFontSize = fontSize;
                    this._layoutTextLastFontFamily = fontFamily;
                  }
                  var _this$_layoutTextCtx$ = this._layoutTextCtx.measureText(textDiv.textContent), width2 = _this$_layoutTextCtx$.width;
                  if (width2 > 0) {
                    var scale2 = textDivProperties.canvasWidth / width2;
                    if (this._enhanceTextSelection) {
                      textDivProperties.scale = scale2;
                    }
                    transform2 = "scaleX(".concat(scale2, ")");
                  }
                }
                if (textDivProperties.angle !== 0) {
                  transform2 = "rotate(".concat(textDivProperties.angle, "deg) ").concat(transform2);
                }
                if (transform2.length > 0) {
                  if (this._enhanceTextSelection) {
                    textDivProperties.originalTransform = transform2;
                  }
                  textDiv.style.transform = transform2;
                }
                if (textDivProperties.hasText) {
                  this._container.appendChild(textDiv);
                }
                if (textDivProperties.hasEOL) {
                  var br = document.createElement("br");
                  br.setAttribute("role", "presentation");
                  this._container.appendChild(br);
                }
              }
            }, {
              key: "_render",
              value: function _render() {
                var _this2 = this;
                var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var capability = (0, _util2.createPromiseCapability)();
                var styleCache = /* @__PURE__ */ Object.create(null);
                var canvas = this._document.createElement("canvas");
                canvas.height = canvas.width = DEFAULT_FONT_SIZE;
                canvas.mozOpaque = true;
                this._layoutTextCtx = canvas.getContext("2d", {
                  alpha: false
                });
                if (this._textContent) {
                  var textItems = this._textContent.items;
                  var textStyles = this._textContent.styles;
                  this._processItems(textItems, textStyles);
                  capability.resolve();
                } else if (this._textContentStream) {
                  var pump = function pump2() {
                    _this2._reader.read().then(function(_ref2) {
                      var value = _ref2.value, done = _ref2.done;
                      if (done) {
                        capability.resolve();
                        return;
                      }
                      Object.assign(styleCache, value.styles);
                      _this2._processItems(value.items, styleCache);
                      pump2();
                    }, capability.reject);
                  };
                  this._reader = this._textContentStream.getReader();
                  pump();
                } else {
                  throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                }
                capability.promise.then(function() {
                  styleCache = null;
                  if (!timeout) {
                    render(_this2);
                  } else {
                    _this2._renderTimer = setTimeout(function() {
                      render(_this2);
                      _this2._renderTimer = null;
                    }, timeout);
                  }
                }, this._capability.reject);
              }
            }, {
              key: "expandTextDivs",
              value: function expandTextDivs() {
                var expandDivs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this._enhanceTextSelection || !this._renderingDone) {
                  return;
                }
                if (this._bounds !== null) {
                  expand(this);
                  this._bounds = null;
                }
                var transformBuf = [], paddingBuf = [];
                for (var i2 = 0, ii = this._textDivs.length; i2 < ii; i2++) {
                  var div2 = this._textDivs[i2];
                  var divProps = this._textDivProperties.get(div2);
                  if (!divProps.hasText) {
                    continue;
                  }
                  if (expandDivs) {
                    transformBuf.length = 0;
                    paddingBuf.length = 0;
                    if (divProps.originalTransform) {
                      transformBuf.push(divProps.originalTransform);
                    }
                    if (divProps.paddingTop > 0) {
                      paddingBuf.push("".concat(divProps.paddingTop, "px"));
                      transformBuf.push("translateY(".concat(-divProps.paddingTop, "px)"));
                    } else {
                      paddingBuf.push(0);
                    }
                    if (divProps.paddingRight > 0) {
                      paddingBuf.push("".concat(divProps.paddingRight / divProps.scale, "px"));
                    } else {
                      paddingBuf.push(0);
                    }
                    if (divProps.paddingBottom > 0) {
                      paddingBuf.push("".concat(divProps.paddingBottom, "px"));
                    } else {
                      paddingBuf.push(0);
                    }
                    if (divProps.paddingLeft > 0) {
                      paddingBuf.push("".concat(divProps.paddingLeft / divProps.scale, "px"));
                      transformBuf.push("translateX(".concat(-divProps.paddingLeft / divProps.scale, "px)"));
                    } else {
                      paddingBuf.push(0);
                    }
                    div2.style.padding = paddingBuf.join(" ");
                    if (transformBuf.length) {
                      div2.style.transform = transformBuf.join(" ");
                    }
                  } else {
                    div2.style.padding = null;
                    div2.style.transform = divProps.originalTransform;
                  }
                }
              }
            }]);
            return TextLayerRenderTask2;
          }();
          function renderTextLayer(renderParameters) {
            var task = new TextLayerRenderTask({
              textContent: renderParameters.textContent,
              textContentStream: renderParameters.textContentStream,
              container: renderParameters.container,
              viewport: renderParameters.viewport,
              textDivs: renderParameters.textDivs,
              textContentItemsStr: renderParameters.textContentItemsStr,
              enhanceTextSelection: renderParameters.enhanceTextSelection
            });
            task._render(renderParameters.timeout);
            return task;
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SVGGraphics = void 0;
          var _util2 = __w_pdfjs_require__2(4);
          var _display_utils2 = __w_pdfjs_require__2(1);
          var _is_node2 = __w_pdfjs_require__2(6);
          function _toConsumableArray2(arr2) {
            return _arrayWithoutHoles2(arr2) || _iterableToArray2(arr2) || _unsupportedIterableToArray2(arr2) || _nonIterableSpread2();
          }
          function _nonIterableSpread2() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArray2(iter) {
            if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
              return Array.from(iter);
          }
          function _arrayWithoutHoles2(arr2) {
            if (Array.isArray(arr2))
              return _arrayLikeToArray2(arr2);
          }
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e3) {
              didErr = true;
              err = _e3;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var SVGGraphics = function SVGGraphics2() {
            _classCallCheck2(this, SVGGraphics2);
            (0, _util2.unreachable)("Not implemented: SVGGraphics");
          };
          exports2.SVGGraphics = SVGGraphics;
          {
            var opListToTree = function opListToTree2(opList) {
              var opTree = [];
              var tmp = [];
              var _iterator = _createForOfIteratorHelper2(opList), _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var opListElement = _step.value;
                  if (opListElement.fn === "save") {
                    opTree.push({
                      fnId: 92,
                      fn: "group",
                      items: []
                    });
                    tmp.push(opTree);
                    opTree = opTree[opTree.length - 1].items;
                    continue;
                  }
                  if (opListElement.fn === "restore") {
                    opTree = tmp.pop();
                  } else {
                    opTree.push(opListElement);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return opTree;
            };
            var pf = function pf2(value) {
              if (Number.isInteger(value)) {
                return value.toString();
              }
              var s2 = value.toFixed(10);
              var i2 = s2.length - 1;
              if (s2[i2] !== "0") {
                return s2;
              }
              do {
                i2--;
              } while (s2[i2] === "0");
              return s2.substring(0, s2[i2] === "." ? i2 : i2 + 1);
            };
            var pm = function pm2(m2) {
              if (m2[4] === 0 && m2[5] === 0) {
                if (m2[1] === 0 && m2[2] === 0) {
                  if (m2[0] === 1 && m2[3] === 1) {
                    return "";
                  }
                  return "scale(".concat(pf(m2[0]), " ").concat(pf(m2[3]), ")");
                }
                if (m2[0] === m2[3] && m2[1] === -m2[2]) {
                  var a6 = Math.acos(m2[0]) * 180 / Math.PI;
                  return "rotate(".concat(pf(a6), ")");
                }
              } else {
                if (m2[0] === 1 && m2[1] === 0 && m2[2] === 0 && m2[3] === 1) {
                  return "translate(".concat(pf(m2[4]), " ").concat(pf(m2[5]), ")");
                }
              }
              return "matrix(".concat(pf(m2[0]), " ").concat(pf(m2[1]), " ").concat(pf(m2[2]), " ").concat(pf(m2[3]), " ").concat(pf(m2[4]), " ") + "".concat(pf(m2[5]), ")");
            };
            var SVG_DEFAULTS = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            };
            var XML_NS = "http://www.w3.org/XML/1998/namespace";
            var XLINK_NS = "http://www.w3.org/1999/xlink";
            var LINE_CAP_STYLES = ["butt", "round", "square"];
            var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
            var convertImgDataToPng = function() {
              var PNG_HEADER = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]);
              var CHUNK_WRAPPER_SIZE = 12;
              var crcTable = new Int32Array(256);
              for (var i2 = 0; i2 < 256; i2++) {
                var c2 = i2;
                for (var h2 = 0; h2 < 8; h2++) {
                  if (c2 & 1) {
                    c2 = 3988292384 ^ c2 >> 1 & 2147483647;
                  } else {
                    c2 = c2 >> 1 & 2147483647;
                  }
                }
                crcTable[i2] = c2;
              }
              function crc32(data2, start, end) {
                var crc = -1;
                for (var _i = start; _i < end; _i++) {
                  var a6 = (crc ^ data2[_i]) & 255;
                  var b2 = crcTable[a6];
                  crc = crc >>> 8 ^ b2;
                }
                return crc ^ -1;
              }
              function writePngChunk(type, body, data2, offset) {
                var p2 = offset;
                var len = body.length;
                data2[p2] = len >> 24 & 255;
                data2[p2 + 1] = len >> 16 & 255;
                data2[p2 + 2] = len >> 8 & 255;
                data2[p2 + 3] = len & 255;
                p2 += 4;
                data2[p2] = type.charCodeAt(0) & 255;
                data2[p2 + 1] = type.charCodeAt(1) & 255;
                data2[p2 + 2] = type.charCodeAt(2) & 255;
                data2[p2 + 3] = type.charCodeAt(3) & 255;
                p2 += 4;
                data2.set(body, p2);
                p2 += body.length;
                var crc = crc32(data2, offset + 4, p2);
                data2[p2] = crc >> 24 & 255;
                data2[p2 + 1] = crc >> 16 & 255;
                data2[p2 + 2] = crc >> 8 & 255;
                data2[p2 + 3] = crc & 255;
              }
              function adler32(data2, start, end) {
                var a6 = 1;
                var b2 = 0;
                for (var _i2 = start; _i2 < end; ++_i2) {
                  a6 = (a6 + (data2[_i2] & 255)) % 65521;
                  b2 = (b2 + a6) % 65521;
                }
                return b2 << 16 | a6;
              }
              function deflateSync(literals) {
                if (!_is_node2.isNodeJS) {
                  return deflateSyncUncompressed(literals);
                }
                try {
                  var input;
                  if (parseInt(process.versions.node) >= 8) {
                    input = literals;
                  } else {
                    input = Buffer.from(literals);
                  }
                  var output2 = require("zlib").deflateSync(input, {
                    level: 9
                  });
                  return output2 instanceof Uint8Array ? output2 : new Uint8Array(output2);
                } catch (e2) {
                  (0, _util2.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e2);
                }
                return deflateSyncUncompressed(literals);
              }
              function deflateSyncUncompressed(literals) {
                var len = literals.length;
                var maxBlockLength = 65535;
                var deflateBlocks = Math.ceil(len / maxBlockLength);
                var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                var pi = 0;
                idat[pi++] = 120;
                idat[pi++] = 156;
                var pos = 0;
                while (len > maxBlockLength) {
                  idat[pi++] = 0;
                  idat[pi++] = 255;
                  idat[pi++] = 255;
                  idat[pi++] = 0;
                  idat[pi++] = 0;
                  idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                  pi += maxBlockLength;
                  pos += maxBlockLength;
                  len -= maxBlockLength;
                }
                idat[pi++] = 1;
                idat[pi++] = len & 255;
                idat[pi++] = len >> 8 & 255;
                idat[pi++] = ~len & 65535 & 255;
                idat[pi++] = (~len & 65535) >> 8 & 255;
                idat.set(literals.subarray(pos), pi);
                pi += literals.length - pos;
                var adler = adler32(literals, 0, literals.length);
                idat[pi++] = adler >> 24 & 255;
                idat[pi++] = adler >> 16 & 255;
                idat[pi++] = adler >> 8 & 255;
                idat[pi++] = adler & 255;
                return idat;
              }
              function encode2(imgData, kind, forceDataSchema, isMask) {
                var width2 = imgData.width;
                var height2 = imgData.height;
                var bitDepth, colorType, lineSize;
                var bytes = imgData.data;
                switch (kind) {
                  case _util2.ImageKind.GRAYSCALE_1BPP:
                    colorType = 0;
                    bitDepth = 1;
                    lineSize = width2 + 7 >> 3;
                    break;
                  case _util2.ImageKind.RGB_24BPP:
                    colorType = 2;
                    bitDepth = 8;
                    lineSize = width2 * 3;
                    break;
                  case _util2.ImageKind.RGBA_32BPP:
                    colorType = 6;
                    bitDepth = 8;
                    lineSize = width2 * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                var literals = new Uint8Array((1 + lineSize) * height2);
                var offsetLiterals = 0, offsetBytes = 0;
                for (var y2 = 0; y2 < height2; ++y2) {
                  literals[offsetLiterals++] = 0;
                  literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                  offsetBytes += lineSize;
                  offsetLiterals += lineSize;
                }
                if (kind === _util2.ImageKind.GRAYSCALE_1BPP && isMask) {
                  offsetLiterals = 0;
                  for (var _y = 0; _y < height2; _y++) {
                    offsetLiterals++;
                    for (var _i3 = 0; _i3 < lineSize; _i3++) {
                      literals[offsetLiterals++] ^= 255;
                    }
                  }
                }
                var ihdr = new Uint8Array([width2 >> 24 & 255, width2 >> 16 & 255, width2 >> 8 & 255, width2 & 255, height2 >> 24 & 255, height2 >> 16 & 255, height2 >> 8 & 255, height2 & 255, bitDepth, colorType, 0, 0, 0]);
                var idat = deflateSync(literals);
                var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                var data2 = new Uint8Array(pngLength);
                var offset = 0;
                data2.set(PNG_HEADER, offset);
                offset += PNG_HEADER.length;
                writePngChunk("IHDR", ihdr, data2, offset);
                offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                writePngChunk("IDATA", idat, data2, offset);
                offset += CHUNK_WRAPPER_SIZE + idat.length;
                writePngChunk("IEND", new Uint8Array(0), data2, offset);
                return (0, _util2.createObjectURL)(data2, "image/png", forceDataSchema);
              }
              return function convertImgDataToPng2(imgData, forceDataSchema, isMask) {
                var kind = imgData.kind === void 0 ? _util2.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                return encode2(imgData, kind, forceDataSchema, isMask);
              };
            }();
            var SVGExtraState = /* @__PURE__ */ function() {
              function SVGExtraState2() {
                _classCallCheck2(this, SVGExtraState2);
                this.fontSizeScale = 1;
                this.fontWeight = SVG_DEFAULTS.fontWeight;
                this.fontSize = 0;
                this.textMatrix = _util2.IDENTITY_MATRIX;
                this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                this.leading = 0;
                this.textRenderingMode = _util2.TextRenderingMode.FILL;
                this.textMatrixScale = 1;
                this.x = 0;
                this.y = 0;
                this.lineX = 0;
                this.lineY = 0;
                this.charSpacing = 0;
                this.wordSpacing = 0;
                this.textHScale = 1;
                this.textRise = 0;
                this.fillColor = SVG_DEFAULTS.fillColor;
                this.strokeColor = "#000000";
                this.fillAlpha = 1;
                this.strokeAlpha = 1;
                this.lineWidth = 1;
                this.lineJoin = "";
                this.lineCap = "";
                this.miterLimit = 0;
                this.dashArray = [];
                this.dashPhase = 0;
                this.dependencies = [];
                this.activeClipUrl = null;
                this.clipGroup = null;
                this.maskId = "";
              }
              _createClass2(SVGExtraState2, [{
                key: "clone",
                value: function clone2() {
                  return Object.create(this);
                }
              }, {
                key: "setCurrentPoint",
                value: function setCurrentPoint(x2, y2) {
                  this.x = x2;
                  this.y = y2;
                }
              }]);
              return SVGExtraState2;
            }();
            var clipCount = 0;
            var maskCount = 0;
            var shadingCount = 0;
            exports2.SVGGraphics = SVGGraphics = /* @__PURE__ */ function() {
              function SVGGraphics2(commonObjs, objs) {
                var forceDataSchema = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                _classCallCheck2(this, SVGGraphics2);
                this.svgFactory = new _display_utils2.DOMSVGFactory();
                this.current = new SVGExtraState();
                this.transformMatrix = _util2.IDENTITY_MATRIX;
                this.transformStack = [];
                this.extraStack = [];
                this.commonObjs = commonObjs;
                this.objs = objs;
                this.pendingClip = null;
                this.pendingEOFill = false;
                this.embedFonts = false;
                this.embeddedFonts = /* @__PURE__ */ Object.create(null);
                this.cssStyle = null;
                this.forceDataSchema = !!forceDataSchema;
                this._operatorIdMapping = [];
                for (var op2 in _util2.OPS) {
                  this._operatorIdMapping[_util2.OPS[op2]] = op2;
                }
              }
              _createClass2(SVGGraphics2, [{
                key: "save",
                value: function save() {
                  this.transformStack.push(this.transformMatrix);
                  var old = this.current;
                  this.extraStack.push(old);
                  this.current = old.clone();
                }
              }, {
                key: "restore",
                value: function restore() {
                  this.transformMatrix = this.transformStack.pop();
                  this.current = this.extraStack.pop();
                  this.pendingClip = null;
                  this.tgrp = null;
                }
              }, {
                key: "group",
                value: function group(items) {
                  this.save();
                  this.executeOpTree(items);
                  this.restore();
                }
              }, {
                key: "loadDependencies",
                value: function loadDependencies(operatorList) {
                  var _this = this;
                  var fnArray = operatorList.fnArray;
                  var argsArray = operatorList.argsArray;
                  for (var i2 = 0, ii = fnArray.length; i2 < ii; i2++) {
                    if (fnArray[i2] !== _util2.OPS.dependency) {
                      continue;
                    }
                    var _iterator2 = _createForOfIteratorHelper2(argsArray[i2]), _step2;
                    try {
                      var _loop = function _loop2() {
                        var obj = _step2.value;
                        var objsPool = obj.startsWith("g_") ? _this.commonObjs : _this.objs;
                        var promise = new Promise(function(resolve) {
                          objsPool.get(obj, resolve);
                        });
                        _this.current.dependencies.push(promise);
                      };
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                        _loop();
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                  return Promise.all(this.current.dependencies);
                }
              }, {
                key: "transform",
                value: function transform2(a6, b2, c2, d2, e2, f2) {
                  var transformMatrix = [a6, b2, c2, d2, e2, f2];
                  this.transformMatrix = _util2.Util.transform(this.transformMatrix, transformMatrix);
                  this.tgrp = null;
                }
              }, {
                key: "getSVG",
                value: function getSVG(operatorList, viewport) {
                  var _this2 = this;
                  this.viewport = viewport;
                  var svgElement = this._initialize(viewport);
                  return this.loadDependencies(operatorList).then(function() {
                    _this2.transformMatrix = _util2.IDENTITY_MATRIX;
                    _this2.executeOpTree(_this2.convertOpList(operatorList));
                    return svgElement;
                  });
                }
              }, {
                key: "convertOpList",
                value: function convertOpList(operatorList) {
                  var operatorIdMapping = this._operatorIdMapping;
                  var argsArray = operatorList.argsArray;
                  var fnArray = operatorList.fnArray;
                  var opList = [];
                  for (var i2 = 0, ii = fnArray.length; i2 < ii; i2++) {
                    var fnId = fnArray[i2];
                    opList.push({
                      fnId,
                      fn: operatorIdMapping[fnId],
                      args: argsArray[i2]
                    });
                  }
                  return opListToTree(opList);
                }
              }, {
                key: "executeOpTree",
                value: function executeOpTree(opTree) {
                  var _iterator3 = _createForOfIteratorHelper2(opTree), _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                      var opTreeElement = _step3.value;
                      var fn = opTreeElement.fn;
                      var fnId = opTreeElement.fnId;
                      var args = opTreeElement.args;
                      switch (fnId | 0) {
                        case _util2.OPS.beginText:
                          this.beginText();
                          break;
                        case _util2.OPS.dependency:
                          break;
                        case _util2.OPS.setLeading:
                          this.setLeading(args);
                          break;
                        case _util2.OPS.setLeadingMoveText:
                          this.setLeadingMoveText(args[0], args[1]);
                          break;
                        case _util2.OPS.setFont:
                          this.setFont(args);
                          break;
                        case _util2.OPS.showText:
                          this.showText(args[0]);
                          break;
                        case _util2.OPS.showSpacedText:
                          this.showText(args[0]);
                          break;
                        case _util2.OPS.endText:
                          this.endText();
                          break;
                        case _util2.OPS.moveText:
                          this.moveText(args[0], args[1]);
                          break;
                        case _util2.OPS.setCharSpacing:
                          this.setCharSpacing(args[0]);
                          break;
                        case _util2.OPS.setWordSpacing:
                          this.setWordSpacing(args[0]);
                          break;
                        case _util2.OPS.setHScale:
                          this.setHScale(args[0]);
                          break;
                        case _util2.OPS.setTextMatrix:
                          this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                          break;
                        case _util2.OPS.setTextRise:
                          this.setTextRise(args[0]);
                          break;
                        case _util2.OPS.setTextRenderingMode:
                          this.setTextRenderingMode(args[0]);
                          break;
                        case _util2.OPS.setLineWidth:
                          this.setLineWidth(args[0]);
                          break;
                        case _util2.OPS.setLineJoin:
                          this.setLineJoin(args[0]);
                          break;
                        case _util2.OPS.setLineCap:
                          this.setLineCap(args[0]);
                          break;
                        case _util2.OPS.setMiterLimit:
                          this.setMiterLimit(args[0]);
                          break;
                        case _util2.OPS.setFillRGBColor:
                          this.setFillRGBColor(args[0], args[1], args[2]);
                          break;
                        case _util2.OPS.setStrokeRGBColor:
                          this.setStrokeRGBColor(args[0], args[1], args[2]);
                          break;
                        case _util2.OPS.setStrokeColorN:
                          this.setStrokeColorN(args);
                          break;
                        case _util2.OPS.setFillColorN:
                          this.setFillColorN(args);
                          break;
                        case _util2.OPS.shadingFill:
                          this.shadingFill(args[0]);
                          break;
                        case _util2.OPS.setDash:
                          this.setDash(args[0], args[1]);
                          break;
                        case _util2.OPS.setRenderingIntent:
                          this.setRenderingIntent(args[0]);
                          break;
                        case _util2.OPS.setFlatness:
                          this.setFlatness(args[0]);
                          break;
                        case _util2.OPS.setGState:
                          this.setGState(args[0]);
                          break;
                        case _util2.OPS.fill:
                          this.fill();
                          break;
                        case _util2.OPS.eoFill:
                          this.eoFill();
                          break;
                        case _util2.OPS.stroke:
                          this.stroke();
                          break;
                        case _util2.OPS.fillStroke:
                          this.fillStroke();
                          break;
                        case _util2.OPS.eoFillStroke:
                          this.eoFillStroke();
                          break;
                        case _util2.OPS.clip:
                          this.clip("nonzero");
                          break;
                        case _util2.OPS.eoClip:
                          this.clip("evenodd");
                          break;
                        case _util2.OPS.paintSolidColorImageMask:
                          this.paintSolidColorImageMask();
                          break;
                        case _util2.OPS.paintImageXObject:
                          this.paintImageXObject(args[0]);
                          break;
                        case _util2.OPS.paintInlineImageXObject:
                          this.paintInlineImageXObject(args[0]);
                          break;
                        case _util2.OPS.paintImageMaskXObject:
                          this.paintImageMaskXObject(args[0]);
                          break;
                        case _util2.OPS.paintFormXObjectBegin:
                          this.paintFormXObjectBegin(args[0], args[1]);
                          break;
                        case _util2.OPS.paintFormXObjectEnd:
                          this.paintFormXObjectEnd();
                          break;
                        case _util2.OPS.closePath:
                          this.closePath();
                          break;
                        case _util2.OPS.closeStroke:
                          this.closeStroke();
                          break;
                        case _util2.OPS.closeFillStroke:
                          this.closeFillStroke();
                          break;
                        case _util2.OPS.closeEOFillStroke:
                          this.closeEOFillStroke();
                          break;
                        case _util2.OPS.nextLine:
                          this.nextLine();
                          break;
                        case _util2.OPS.transform:
                          this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                          break;
                        case _util2.OPS.constructPath:
                          this.constructPath(args[0], args[1]);
                          break;
                        case _util2.OPS.endPath:
                          this.endPath();
                          break;
                        case 92:
                          this.group(opTreeElement.items);
                          break;
                        default:
                          (0, _util2.warn)("Unimplemented operator ".concat(fn));
                          break;
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
              }, {
                key: "setWordSpacing",
                value: function setWordSpacing(wordSpacing) {
                  this.current.wordSpacing = wordSpacing;
                }
              }, {
                key: "setCharSpacing",
                value: function setCharSpacing(charSpacing) {
                  this.current.charSpacing = charSpacing;
                }
              }, {
                key: "nextLine",
                value: function nextLine() {
                  this.moveText(0, this.current.leading);
                }
              }, {
                key: "setTextMatrix",
                value: function setTextMatrix(a6, b2, c2, d2, e2, f2) {
                  var current = this.current;
                  current.textMatrix = current.lineMatrix = [a6, b2, c2, d2, e2, f2];
                  current.textMatrixScale = Math.hypot(a6, b2);
                  current.x = current.lineX = 0;
                  current.y = current.lineY = 0;
                  current.xcoords = [];
                  current.ycoords = [];
                  current.tspan = this.svgFactory.createElement("svg:tspan");
                  current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                  current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                  current.tspan.setAttributeNS(null, "y", pf(-current.y));
                  current.txtElement = this.svgFactory.createElement("svg:text");
                  current.txtElement.appendChild(current.tspan);
                }
              }, {
                key: "beginText",
                value: function beginText() {
                  var current = this.current;
                  current.x = current.lineX = 0;
                  current.y = current.lineY = 0;
                  current.textMatrix = _util2.IDENTITY_MATRIX;
                  current.lineMatrix = _util2.IDENTITY_MATRIX;
                  current.textMatrixScale = 1;
                  current.tspan = this.svgFactory.createElement("svg:tspan");
                  current.txtElement = this.svgFactory.createElement("svg:text");
                  current.txtgrp = this.svgFactory.createElement("svg:g");
                  current.xcoords = [];
                  current.ycoords = [];
                }
              }, {
                key: "moveText",
                value: function moveText(x2, y2) {
                  var current = this.current;
                  current.x = current.lineX += x2;
                  current.y = current.lineY += y2;
                  current.xcoords = [];
                  current.ycoords = [];
                  current.tspan = this.svgFactory.createElement("svg:tspan");
                  current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                  current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                  current.tspan.setAttributeNS(null, "y", pf(-current.y));
                }
              }, {
                key: "showText",
                value: function showText(glyphs) {
                  var current = this.current;
                  var font = current.font;
                  var fontSize = current.fontSize;
                  if (fontSize === 0) {
                    return;
                  }
                  var fontSizeScale = current.fontSizeScale;
                  var charSpacing = current.charSpacing;
                  var wordSpacing = current.wordSpacing;
                  var fontDirection = current.fontDirection;
                  var textHScale = current.textHScale * fontDirection;
                  var vertical = font.vertical;
                  var spacingDir = vertical ? 1 : -1;
                  var defaultVMetrics = font.defaultVMetrics;
                  var widthAdvanceScale = fontSize * current.fontMatrix[0];
                  var x2 = 0;
                  var _iterator4 = _createForOfIteratorHelper2(glyphs), _step4;
                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                      var glyph = _step4.value;
                      if (glyph === null) {
                        x2 += fontDirection * wordSpacing;
                        continue;
                      } else if ((0, _util2.isNum)(glyph)) {
                        x2 += spacingDir * glyph * fontSize / 1e3;
                        continue;
                      }
                      var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                      var character = glyph.fontChar;
                      var scaledX = void 0, scaledY = void 0;
                      var width2 = glyph.width;
                      if (vertical) {
                        var vx = void 0;
                        var vmetric = glyph.vmetric || defaultVMetrics;
                        vx = glyph.vmetric ? vmetric[1] : width2 * 0.5;
                        vx = -vx * widthAdvanceScale;
                        var vy = vmetric[2] * widthAdvanceScale;
                        width2 = vmetric ? -vmetric[0] : width2;
                        scaledX = vx / fontSizeScale;
                        scaledY = (x2 + vy) / fontSizeScale;
                      } else {
                        scaledX = x2 / fontSizeScale;
                        scaledY = 0;
                      }
                      if (glyph.isInFont || font.missingFile) {
                        current.xcoords.push(current.x + scaledX);
                        if (vertical) {
                          current.ycoords.push(-current.y + scaledY);
                        }
                        current.tspan.textContent += character;
                      } else {
                      }
                      var charWidth = void 0;
                      if (vertical) {
                        charWidth = width2 * widthAdvanceScale - spacing * fontDirection;
                      } else {
                        charWidth = width2 * widthAdvanceScale + spacing * fontDirection;
                      }
                      x2 += charWidth;
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                  current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                  if (vertical) {
                    current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                  } else {
                    current.tspan.setAttributeNS(null, "y", pf(-current.y));
                  }
                  if (vertical) {
                    current.y -= x2;
                  } else {
                    current.x += x2 * textHScale;
                  }
                  current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                  current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                  if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
                    current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                  }
                  if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
                    current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                  }
                  var fillStrokeMode = current.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    if (current.fillColor !== SVG_DEFAULTS.fillColor) {
                      current.tspan.setAttributeNS(null, "fill", current.fillColor);
                    }
                    if (current.fillAlpha < 1) {
                      current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                    }
                  } else if (current.textRenderingMode === _util2.TextRenderingMode.ADD_TO_PATH) {
                    current.tspan.setAttributeNS(null, "fill", "transparent");
                  } else {
                    current.tspan.setAttributeNS(null, "fill", "none");
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    var lineWidthScale = 1 / (current.textMatrixScale || 1);
                    this._setStrokeAttributes(current.tspan, lineWidthScale);
                  }
                  var textMatrix = current.textMatrix;
                  if (current.textRise !== 0) {
                    textMatrix = textMatrix.slice();
                    textMatrix[5] += current.textRise;
                  }
                  current.txtElement.setAttributeNS(null, "transform", "".concat(pm(textMatrix), " scale(").concat(pf(textHScale), ", -1)"));
                  current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                  current.txtElement.appendChild(current.tspan);
                  current.txtgrp.appendChild(current.txtElement);
                  this._ensureTransformGroup().appendChild(current.txtElement);
                }
              }, {
                key: "setLeadingMoveText",
                value: function setLeadingMoveText(x2, y2) {
                  this.setLeading(-y2);
                  this.moveText(x2, y2);
                }
              }, {
                key: "addFontStyle",
                value: function addFontStyle(fontObj) {
                  if (!fontObj.data) {
                    throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                  }
                  if (!this.cssStyle) {
                    this.cssStyle = this.svgFactory.createElement("svg:style");
                    this.cssStyle.setAttributeNS(null, "type", "text/css");
                    this.defs.appendChild(this.cssStyle);
                  }
                  var url = (0, _util2.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                  this.cssStyle.textContent += '@font-face { font-family: "'.concat(fontObj.loadedName, '";') + " src: url(".concat(url, "); }\n");
                }
              }, {
                key: "setFont",
                value: function setFont(details) {
                  var current = this.current;
                  var fontObj = this.commonObjs.get(details[0]);
                  var size = details[1];
                  current.font = fontObj;
                  if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                    this.addFontStyle(fontObj);
                    this.embeddedFonts[fontObj.loadedName] = fontObj;
                  }
                  current.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                  var bold = "normal";
                  if (fontObj.black) {
                    bold = "900";
                  } else if (fontObj.bold) {
                    bold = "bold";
                  }
                  var italic = fontObj.italic ? "italic" : "normal";
                  if (size < 0) {
                    size = -size;
                    current.fontDirection = -1;
                  } else {
                    current.fontDirection = 1;
                  }
                  current.fontSize = size;
                  current.fontFamily = fontObj.loadedName;
                  current.fontWeight = bold;
                  current.fontStyle = italic;
                  current.tspan = this.svgFactory.createElement("svg:tspan");
                  current.tspan.setAttributeNS(null, "y", pf(-current.y));
                  current.xcoords = [];
                  current.ycoords = [];
                }
              }, {
                key: "endText",
                value: function endText() {
                  var _current$txtElement;
                  var current = this.current;
                  if (current.textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG && (_current$txtElement = current.txtElement) !== null && _current$txtElement !== void 0 && _current$txtElement.hasChildNodes()) {
                    current.element = current.txtElement;
                    this.clip("nonzero");
                    this.endPath();
                  }
                }
              }, {
                key: "setLineWidth",
                value: function setLineWidth(width2) {
                  if (width2 > 0) {
                    this.current.lineWidth = width2;
                  }
                }
              }, {
                key: "setLineCap",
                value: function setLineCap(style) {
                  this.current.lineCap = LINE_CAP_STYLES[style];
                }
              }, {
                key: "setLineJoin",
                value: function setLineJoin(style) {
                  this.current.lineJoin = LINE_JOIN_STYLES[style];
                }
              }, {
                key: "setMiterLimit",
                value: function setMiterLimit(limit) {
                  this.current.miterLimit = limit;
                }
              }, {
                key: "setStrokeAlpha",
                value: function setStrokeAlpha(strokeAlpha) {
                  this.current.strokeAlpha = strokeAlpha;
                }
              }, {
                key: "setStrokeRGBColor",
                value: function setStrokeRGBColor(r2, g2, b2) {
                  this.current.strokeColor = _util2.Util.makeHexColor(r2, g2, b2);
                }
              }, {
                key: "setFillAlpha",
                value: function setFillAlpha(fillAlpha) {
                  this.current.fillAlpha = fillAlpha;
                }
              }, {
                key: "setFillRGBColor",
                value: function setFillRGBColor(r2, g2, b2) {
                  this.current.fillColor = _util2.Util.makeHexColor(r2, g2, b2);
                  this.current.tspan = this.svgFactory.createElement("svg:tspan");
                  this.current.xcoords = [];
                  this.current.ycoords = [];
                }
              }, {
                key: "setStrokeColorN",
                value: function setStrokeColorN(args) {
                  this.current.strokeColor = this._makeColorN_Pattern(args);
                }
              }, {
                key: "setFillColorN",
                value: function setFillColorN(args) {
                  this.current.fillColor = this._makeColorN_Pattern(args);
                }
              }, {
                key: "shadingFill",
                value: function shadingFill(args) {
                  var width2 = this.viewport.width;
                  var height2 = this.viewport.height;
                  var inv = _util2.Util.inverseTransform(this.transformMatrix);
                  var bl = _util2.Util.applyTransform([0, 0], inv);
                  var br = _util2.Util.applyTransform([0, height2], inv);
                  var ul = _util2.Util.applyTransform([width2, 0], inv);
                  var ur = _util2.Util.applyTransform([width2, height2], inv);
                  var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                  var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                  var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                  var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                  var rect = this.svgFactory.createElement("svg:rect");
                  rect.setAttributeNS(null, "x", x0);
                  rect.setAttributeNS(null, "y", y0);
                  rect.setAttributeNS(null, "width", x1 - x0);
                  rect.setAttributeNS(null, "height", y1 - y0);
                  rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                  if (this.current.fillAlpha < 1) {
                    rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                  }
                  this._ensureTransformGroup().appendChild(rect);
                }
              }, {
                key: "_makeColorN_Pattern",
                value: function _makeColorN_Pattern(args) {
                  if (args[0] === "TilingPattern") {
                    return this._makeTilingPattern(args);
                  }
                  return this._makeShadingPattern(args);
                }
              }, {
                key: "_makeTilingPattern",
                value: function _makeTilingPattern(args) {
                  var color2 = args[1];
                  var operatorList = args[2];
                  var matrix = args[3] || _util2.IDENTITY_MATRIX;
                  var _args$ = _slicedToArray2(args[4], 4), x0 = _args$[0], y0 = _args$[1], x1 = _args$[2], y1 = _args$[3];
                  var xstep = args[5];
                  var ystep = args[6];
                  var paintType = args[7];
                  var tilingId = "shading".concat(shadingCount++);
                  var _Util$normalizeRect = _util2.Util.normalizeRect([].concat(_toConsumableArray2(_util2.Util.applyTransform([x0, y0], matrix)), _toConsumableArray2(_util2.Util.applyTransform([x1, y1], matrix)))), _Util$normalizeRect2 = _slicedToArray2(_Util$normalizeRect, 4), tx0 = _Util$normalizeRect2[0], ty0 = _Util$normalizeRect2[1], tx1 = _Util$normalizeRect2[2], ty1 = _Util$normalizeRect2[3];
                  var _Util$singularValueDe = _util2.Util.singularValueDecompose2dScale(matrix), _Util$singularValueDe2 = _slicedToArray2(_Util$singularValueDe, 2), xscale = _Util$singularValueDe2[0], yscale = _Util$singularValueDe2[1];
                  var txstep = xstep * xscale;
                  var tystep = ystep * yscale;
                  var tiling = this.svgFactory.createElement("svg:pattern");
                  tiling.setAttributeNS(null, "id", tilingId);
                  tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                  tiling.setAttributeNS(null, "width", txstep);
                  tiling.setAttributeNS(null, "height", tystep);
                  tiling.setAttributeNS(null, "x", "".concat(tx0));
                  tiling.setAttributeNS(null, "y", "".concat(ty0));
                  var svg = this.svg;
                  var transformMatrix = this.transformMatrix;
                  var fillColor = this.current.fillColor;
                  var strokeColor = this.current.strokeColor;
                  var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                  this.svg = bbox;
                  this.transformMatrix = matrix;
                  if (paintType === 2) {
                    var cssColor = _util2.Util.makeHexColor.apply(_util2.Util, _toConsumableArray2(color2));
                    this.current.fillColor = cssColor;
                    this.current.strokeColor = cssColor;
                  }
                  this.executeOpTree(this.convertOpList(operatorList));
                  this.svg = svg;
                  this.transformMatrix = transformMatrix;
                  this.current.fillColor = fillColor;
                  this.current.strokeColor = strokeColor;
                  tiling.appendChild(bbox.childNodes[0]);
                  this.defs.appendChild(tiling);
                  return "url(#".concat(tilingId, ")");
                }
              }, {
                key: "_makeShadingPattern",
                value: function _makeShadingPattern(args) {
                  if (typeof args === "string") {
                    args = this.objs.get(args);
                  }
                  switch (args[0]) {
                    case "RadialAxial":
                      var shadingId = "shading".concat(shadingCount++);
                      var colorStops = args[3];
                      var gradient;
                      switch (args[1]) {
                        case "axial":
                          var point0 = args[4];
                          var point1 = args[5];
                          gradient = this.svgFactory.createElement("svg:linearGradient");
                          gradient.setAttributeNS(null, "id", shadingId);
                          gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                          gradient.setAttributeNS(null, "x1", point0[0]);
                          gradient.setAttributeNS(null, "y1", point0[1]);
                          gradient.setAttributeNS(null, "x2", point1[0]);
                          gradient.setAttributeNS(null, "y2", point1[1]);
                          break;
                        case "radial":
                          var focalPoint = args[4];
                          var circlePoint = args[5];
                          var focalRadius = args[6];
                          var circleRadius = args[7];
                          gradient = this.svgFactory.createElement("svg:radialGradient");
                          gradient.setAttributeNS(null, "id", shadingId);
                          gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                          gradient.setAttributeNS(null, "cx", circlePoint[0]);
                          gradient.setAttributeNS(null, "cy", circlePoint[1]);
                          gradient.setAttributeNS(null, "r", circleRadius);
                          gradient.setAttributeNS(null, "fx", focalPoint[0]);
                          gradient.setAttributeNS(null, "fy", focalPoint[1]);
                          gradient.setAttributeNS(null, "fr", focalRadius);
                          break;
                        default:
                          throw new Error("Unknown RadialAxial type: ".concat(args[1]));
                      }
                      var _iterator5 = _createForOfIteratorHelper2(colorStops), _step5;
                      try {
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                          var colorStop = _step5.value;
                          var stop = this.svgFactory.createElement("svg:stop");
                          stop.setAttributeNS(null, "offset", colorStop[0]);
                          stop.setAttributeNS(null, "stop-color", colorStop[1]);
                          gradient.appendChild(stop);
                        }
                      } catch (err) {
                        _iterator5.e(err);
                      } finally {
                        _iterator5.f();
                      }
                      this.defs.appendChild(gradient);
                      return "url(#".concat(shadingId, ")");
                    case "Mesh":
                      (0, _util2.warn)("Unimplemented pattern Mesh");
                      return null;
                    case "Dummy":
                      return "hotpink";
                    default:
                      throw new Error("Unknown IR type: ".concat(args[0]));
                  }
                }
              }, {
                key: "setDash",
                value: function setDash(dashArray, dashPhase) {
                  this.current.dashArray = dashArray;
                  this.current.dashPhase = dashPhase;
                }
              }, {
                key: "constructPath",
                value: function constructPath(ops, args) {
                  var current = this.current;
                  var x2 = current.x, y2 = current.y;
                  var d2 = [];
                  var j2 = 0;
                  var _iterator6 = _createForOfIteratorHelper2(ops), _step6;
                  try {
                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
                      var op2 = _step6.value;
                      switch (op2 | 0) {
                        case _util2.OPS.rectangle:
                          x2 = args[j2++];
                          y2 = args[j2++];
                          var width2 = args[j2++];
                          var height2 = args[j2++];
                          var xw = x2 + width2;
                          var yh = y2 + height2;
                          d2.push("M", pf(x2), pf(y2), "L", pf(xw), pf(y2), "L", pf(xw), pf(yh), "L", pf(x2), pf(yh), "Z");
                          break;
                        case _util2.OPS.moveTo:
                          x2 = args[j2++];
                          y2 = args[j2++];
                          d2.push("M", pf(x2), pf(y2));
                          break;
                        case _util2.OPS.lineTo:
                          x2 = args[j2++];
                          y2 = args[j2++];
                          d2.push("L", pf(x2), pf(y2));
                          break;
                        case _util2.OPS.curveTo:
                          x2 = args[j2 + 4];
                          y2 = args[j2 + 5];
                          d2.push("C", pf(args[j2]), pf(args[j2 + 1]), pf(args[j2 + 2]), pf(args[j2 + 3]), pf(x2), pf(y2));
                          j2 += 6;
                          break;
                        case _util2.OPS.curveTo2:
                          d2.push("C", pf(x2), pf(y2), pf(args[j2]), pf(args[j2 + 1]), pf(args[j2 + 2]), pf(args[j2 + 3]));
                          x2 = args[j2 + 2];
                          y2 = args[j2 + 3];
                          j2 += 4;
                          break;
                        case _util2.OPS.curveTo3:
                          x2 = args[j2 + 2];
                          y2 = args[j2 + 3];
                          d2.push("C", pf(args[j2]), pf(args[j2 + 1]), pf(x2), pf(y2), pf(x2), pf(y2));
                          j2 += 4;
                          break;
                        case _util2.OPS.closePath:
                          d2.push("Z");
                          break;
                      }
                    }
                  } catch (err) {
                    _iterator6.e(err);
                  } finally {
                    _iterator6.f();
                  }
                  d2 = d2.join(" ");
                  if (current.path && ops.length > 0 && ops[0] !== _util2.OPS.rectangle && ops[0] !== _util2.OPS.moveTo) {
                    d2 = current.path.getAttributeNS(null, "d") + d2;
                  } else {
                    current.path = this.svgFactory.createElement("svg:path");
                    this._ensureTransformGroup().appendChild(current.path);
                  }
                  current.path.setAttributeNS(null, "d", d2);
                  current.path.setAttributeNS(null, "fill", "none");
                  current.element = current.path;
                  current.setCurrentPoint(x2, y2);
                }
              }, {
                key: "endPath",
                value: function endPath() {
                  var current = this.current;
                  current.path = null;
                  if (!this.pendingClip) {
                    return;
                  }
                  if (!current.element) {
                    this.pendingClip = null;
                    return;
                  }
                  var clipId = "clippath".concat(clipCount++);
                  var clipPath = this.svgFactory.createElement("svg:clipPath");
                  clipPath.setAttributeNS(null, "id", clipId);
                  clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                  var clipElement = current.element.cloneNode(true);
                  if (this.pendingClip === "evenodd") {
                    clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                  } else {
                    clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                  }
                  this.pendingClip = null;
                  clipPath.appendChild(clipElement);
                  this.defs.appendChild(clipPath);
                  if (current.activeClipUrl) {
                    current.clipGroup = null;
                    var _iterator7 = _createForOfIteratorHelper2(this.extraStack), _step7;
                    try {
                      for (_iterator7.s(); !(_step7 = _iterator7.n()).done; ) {
                        var prev = _step7.value;
                        prev.clipGroup = null;
                      }
                    } catch (err) {
                      _iterator7.e(err);
                    } finally {
                      _iterator7.f();
                    }
                    clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                  }
                  current.activeClipUrl = "url(#".concat(clipId, ")");
                  this.tgrp = null;
                }
              }, {
                key: "clip",
                value: function clip2(type) {
                  this.pendingClip = type;
                }
              }, {
                key: "closePath",
                value: function closePath() {
                  var current = this.current;
                  if (current.path) {
                    var d2 = "".concat(current.path.getAttributeNS(null, "d"), "Z");
                    current.path.setAttributeNS(null, "d", d2);
                  }
                }
              }, {
                key: "setLeading",
                value: function setLeading(leading) {
                  this.current.leading = -leading;
                }
              }, {
                key: "setTextRise",
                value: function setTextRise(textRise) {
                  this.current.textRise = textRise;
                }
              }, {
                key: "setTextRenderingMode",
                value: function setTextRenderingMode(textRenderingMode) {
                  this.current.textRenderingMode = textRenderingMode;
                }
              }, {
                key: "setHScale",
                value: function setHScale(scale2) {
                  this.current.textHScale = scale2 / 100;
                }
              }, {
                key: "setRenderingIntent",
                value: function setRenderingIntent(intent) {
                }
              }, {
                key: "setFlatness",
                value: function setFlatness(flatness) {
                }
              }, {
                key: "setGState",
                value: function setGState(states2) {
                  var _iterator8 = _createForOfIteratorHelper2(states2), _step8;
                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done; ) {
                      var _step8$value = _slicedToArray2(_step8.value, 2), key = _step8$value[0], value = _step8$value[1];
                      switch (key) {
                        case "LW":
                          this.setLineWidth(value);
                          break;
                        case "LC":
                          this.setLineCap(value);
                          break;
                        case "LJ":
                          this.setLineJoin(value);
                          break;
                        case "ML":
                          this.setMiterLimit(value);
                          break;
                        case "D":
                          this.setDash(value[0], value[1]);
                          break;
                        case "RI":
                          this.setRenderingIntent(value);
                          break;
                        case "FL":
                          this.setFlatness(value);
                          break;
                        case "Font":
                          this.setFont(value);
                          break;
                        case "CA":
                          this.setStrokeAlpha(value);
                          break;
                        case "ca":
                          this.setFillAlpha(value);
                          break;
                        default:
                          (0, _util2.warn)("Unimplemented graphic state operator ".concat(key));
                          break;
                      }
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                }
              }, {
                key: "fill",
                value: function fill2() {
                  var current = this.current;
                  if (current.element) {
                    current.element.setAttributeNS(null, "fill", current.fillColor);
                    current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                    this.endPath();
                  }
                }
              }, {
                key: "stroke",
                value: function stroke() {
                  var current = this.current;
                  if (current.element) {
                    this._setStrokeAttributes(current.element);
                    current.element.setAttributeNS(null, "fill", "none");
                    this.endPath();
                  }
                }
              }, {
                key: "_setStrokeAttributes",
                value: function _setStrokeAttributes(element) {
                  var lineWidthScale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                  var current = this.current;
                  var dashArray = current.dashArray;
                  if (lineWidthScale !== 1 && dashArray.length > 0) {
                    dashArray = dashArray.map(function(value) {
                      return lineWidthScale * value;
                    });
                  }
                  element.setAttributeNS(null, "stroke", current.strokeColor);
                  element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                  element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                  element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                  element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                  element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                  element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                  element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                }
              }, {
                key: "eoFill",
                value: function eoFill() {
                  if (this.current.element) {
                    this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                  }
                  this.fill();
                }
              }, {
                key: "fillStroke",
                value: function fillStroke() {
                  this.stroke();
                  this.fill();
                }
              }, {
                key: "eoFillStroke",
                value: function eoFillStroke() {
                  if (this.current.element) {
                    this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                  }
                  this.fillStroke();
                }
              }, {
                key: "closeStroke",
                value: function closeStroke() {
                  this.closePath();
                  this.stroke();
                }
              }, {
                key: "closeFillStroke",
                value: function closeFillStroke() {
                  this.closePath();
                  this.fillStroke();
                }
              }, {
                key: "closeEOFillStroke",
                value: function closeEOFillStroke() {
                  this.closePath();
                  this.eoFillStroke();
                }
              }, {
                key: "paintSolidColorImageMask",
                value: function paintSolidColorImageMask() {
                  var rect = this.svgFactory.createElement("svg:rect");
                  rect.setAttributeNS(null, "x", "0");
                  rect.setAttributeNS(null, "y", "0");
                  rect.setAttributeNS(null, "width", "1px");
                  rect.setAttributeNS(null, "height", "1px");
                  rect.setAttributeNS(null, "fill", this.current.fillColor);
                  this._ensureTransformGroup().appendChild(rect);
                }
              }, {
                key: "paintImageXObject",
                value: function paintImageXObject(objId) {
                  var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                  if (!imgData) {
                    (0, _util2.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
                    return;
                  }
                  this.paintInlineImageXObject(imgData);
                }
              }, {
                key: "paintInlineImageXObject",
                value: function paintInlineImageXObject(imgData, mask) {
                  var width2 = imgData.width;
                  var height2 = imgData.height;
                  var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                  var cliprect = this.svgFactory.createElement("svg:rect");
                  cliprect.setAttributeNS(null, "x", "0");
                  cliprect.setAttributeNS(null, "y", "0");
                  cliprect.setAttributeNS(null, "width", pf(width2));
                  cliprect.setAttributeNS(null, "height", pf(height2));
                  this.current.element = cliprect;
                  this.clip("nonzero");
                  var imgEl = this.svgFactory.createElement("svg:image");
                  imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                  imgEl.setAttributeNS(null, "x", "0");
                  imgEl.setAttributeNS(null, "y", pf(-height2));
                  imgEl.setAttributeNS(null, "width", pf(width2) + "px");
                  imgEl.setAttributeNS(null, "height", pf(height2) + "px");
                  imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / width2), " ").concat(pf(-1 / height2), ")"));
                  if (mask) {
                    mask.appendChild(imgEl);
                  } else {
                    this._ensureTransformGroup().appendChild(imgEl);
                  }
                }
              }, {
                key: "paintImageMaskXObject",
                value: function paintImageMaskXObject(imgData) {
                  var current = this.current;
                  var width2 = imgData.width;
                  var height2 = imgData.height;
                  var fillColor = current.fillColor;
                  current.maskId = "mask".concat(maskCount++);
                  var mask = this.svgFactory.createElement("svg:mask");
                  mask.setAttributeNS(null, "id", current.maskId);
                  var rect = this.svgFactory.createElement("svg:rect");
                  rect.setAttributeNS(null, "x", "0");
                  rect.setAttributeNS(null, "y", "0");
                  rect.setAttributeNS(null, "width", pf(width2));
                  rect.setAttributeNS(null, "height", pf(height2));
                  rect.setAttributeNS(null, "fill", fillColor);
                  rect.setAttributeNS(null, "mask", "url(#".concat(current.maskId, ")"));
                  this.defs.appendChild(mask);
                  this._ensureTransformGroup().appendChild(rect);
                  this.paintInlineImageXObject(imgData, mask);
                }
              }, {
                key: "paintFormXObjectBegin",
                value: function paintFormXObjectBegin(matrix, bbox) {
                  if (Array.isArray(matrix) && matrix.length === 6) {
                    this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                  }
                  if (bbox) {
                    var width2 = bbox[2] - bbox[0];
                    var height2 = bbox[3] - bbox[1];
                    var cliprect = this.svgFactory.createElement("svg:rect");
                    cliprect.setAttributeNS(null, "x", bbox[0]);
                    cliprect.setAttributeNS(null, "y", bbox[1]);
                    cliprect.setAttributeNS(null, "width", pf(width2));
                    cliprect.setAttributeNS(null, "height", pf(height2));
                    this.current.element = cliprect;
                    this.clip("nonzero");
                    this.endPath();
                  }
                }
              }, {
                key: "paintFormXObjectEnd",
                value: function paintFormXObjectEnd() {
                }
              }, {
                key: "_initialize",
                value: function _initialize(viewport) {
                  var svg = this.svgFactory.create(viewport.width, viewport.height);
                  var definitions = this.svgFactory.createElement("svg:defs");
                  svg.appendChild(definitions);
                  this.defs = definitions;
                  var rootGroup = this.svgFactory.createElement("svg:g");
                  rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                  svg.appendChild(rootGroup);
                  this.svg = rootGroup;
                  return svg;
                }
              }, {
                key: "_ensureClipGroup",
                value: function _ensureClipGroup() {
                  if (!this.current.clipGroup) {
                    var clipGroup = this.svgFactory.createElement("svg:g");
                    clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                    this.svg.appendChild(clipGroup);
                    this.current.clipGroup = clipGroup;
                  }
                  return this.current.clipGroup;
                }
              }, {
                key: "_ensureTransformGroup",
                value: function _ensureTransformGroup() {
                  if (!this.tgrp) {
                    this.tgrp = this.svgFactory.createElement("svg:g");
                    this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                    if (this.current.activeClipUrl) {
                      this._ensureClipGroup().appendChild(this.tgrp);
                    } else {
                      this.svg.appendChild(this.tgrp);
                    }
                  }
                  return this.tgrp;
                }
              }]);
              return SVGGraphics2;
            }();
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFNodeStream = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          var _network_utils = __w_pdfjs_require__2(154);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function _inherits2(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf2(subClass, superClass);
          }
          function _setPrototypeOf2(o, p2) {
            _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
              o2.__proto__ = p3;
              return o2;
            };
            return _setPrototypeOf2(o, p2);
          }
          function _createSuper2(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct2();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf2(Derived), result2;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf2(this).constructor;
                result2 = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result2 = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn2(this, result2);
            };
          }
          function _possibleConstructorReturn2(self2, call) {
            if (call && (_typeof2(call) === "object" || typeof call === "function")) {
              return call;
            } else if (call !== void 0) {
              throw new TypeError("Derived constructors may only return object or undefined");
            }
            return _assertThisInitialized2(self2);
          }
          function _assertThisInitialized2(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct2() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf2(o) {
            _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf2(o);
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var fs = require$$4;
          var http2 = require$$4;
          var https = require$$4;
          var url = require$$4;
          var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
          function parseUrl2(sourceUrl) {
            var parsedUrl = url.parse(sourceUrl);
            if (parsedUrl.protocol === "file:" || parsedUrl.host) {
              return parsedUrl;
            }
            if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
              return url.parse("file:///".concat(sourceUrl));
            }
            if (!parsedUrl.host) {
              parsedUrl.protocol = "file:";
            }
            return parsedUrl;
          }
          var PDFNodeStream = /* @__PURE__ */ function() {
            function PDFNodeStream2(source2) {
              _classCallCheck2(this, PDFNodeStream2);
              this.source = source2;
              this.url = parseUrl2(source2.url);
              this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
              this.isFsUrl = this.url.protocol === "file:";
              this.httpHeaders = this.isHttp && source2.httpHeaders || {};
              this._fullRequestReader = null;
              this._rangeRequestReaders = [];
            }
            _createClass2(PDFNodeStream2, [{
              key: "_progressiveDataLength",
              get: function get2() {
                var _this$_fullRequestRea, _this$_fullRequestRea2;
                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
              }
            }, {
              key: "getFullReader",
              value: function getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                return this._fullRequestReader;
              }
            }, {
              key: "getRangeReader",
              value: function getRangeReader(start, end) {
                if (end <= this._progressiveDataLength) {
                  return null;
                }
                var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                this._rangeRequestReaders.push(rangeReader);
                return rangeReader;
              }
            }, {
              key: "cancelAllRequests",
              value: function cancelAllRequests(reason) {
                if (this._fullRequestReader) {
                  this._fullRequestReader.cancel(reason);
                }
                var _iterator = _createForOfIteratorHelper2(this._rangeRequestReaders.slice(0)), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var reader = _step.value;
                    reader.cancel(reason);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }]);
            return PDFNodeStream2;
          }();
          exports2.PDFNodeStream = PDFNodeStream;
          var BaseFullReader = /* @__PURE__ */ function() {
            function BaseFullReader2(stream) {
              _classCallCheck2(this, BaseFullReader2);
              this._url = stream.url;
              this._done = false;
              this._storedError = null;
              this.onProgress = null;
              var source2 = stream.source;
              this._contentLength = source2.length;
              this._loaded = 0;
              this._filename = null;
              this._disableRange = source2.disableRange || false;
              this._rangeChunkSize = source2.rangeChunkSize;
              if (!this._rangeChunkSize && !this._disableRange) {
                this._disableRange = true;
              }
              this._isStreamingSupported = !source2.disableStream;
              this._isRangeSupported = !source2.disableRange;
              this._readableStream = null;
              this._readCapability = (0, _util2.createPromiseCapability)();
              this._headersCapability = (0, _util2.createPromiseCapability)();
            }
            _createClass2(BaseFullReader2, [{
              key: "headersReady",
              get: function get2() {
                return this._headersCapability.promise;
              }
            }, {
              key: "filename",
              get: function get2() {
                return this._filename;
              }
            }, {
              key: "contentLength",
              get: function get2() {
                return this._contentLength;
              }
            }, {
              key: "isRangeSupported",
              get: function get2() {
                return this._isRangeSupported;
              }
            }, {
              key: "isStreamingSupported",
              get: function get2() {
                return this._isStreamingSupported;
              }
            }, {
              key: "read",
              value: function() {
                var _read = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee() {
                  var chunk, buffer2;
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return this._readCapability.promise;
                        case 2:
                          if (!this._done) {
                            _context.next = 4;
                            break;
                          }
                          return _context.abrupt("return", {
                            value: void 0,
                            done: true
                          });
                        case 4:
                          if (!this._storedError) {
                            _context.next = 6;
                            break;
                          }
                          throw this._storedError;
                        case 6:
                          chunk = this._readableStream.read();
                          if (!(chunk === null)) {
                            _context.next = 10;
                            break;
                          }
                          this._readCapability = (0, _util2.createPromiseCapability)();
                          return _context.abrupt("return", this.read());
                        case 10:
                          this._loaded += chunk.length;
                          if (this.onProgress) {
                            this.onProgress({
                              loaded: this._loaded,
                              total: this._contentLength
                            });
                          }
                          buffer2 = new Uint8Array(chunk).buffer;
                          return _context.abrupt("return", {
                            value: buffer2,
                            done: false
                          });
                        case 14:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function read2() {
                  return _read.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                if (!this._readableStream) {
                  this._error(reason);
                  return;
                }
                this._readableStream.destroy(reason);
              }
            }, {
              key: "_error",
              value: function _error(reason) {
                this._storedError = reason;
                this._readCapability.resolve();
              }
            }, {
              key: "_setReadableStream",
              value: function _setReadableStream(readableStream) {
                var _this = this;
                this._readableStream = readableStream;
                readableStream.on("readable", function() {
                  _this._readCapability.resolve();
                });
                readableStream.on("end", function() {
                  readableStream.destroy();
                  _this._done = true;
                  _this._readCapability.resolve();
                });
                readableStream.on("error", function(reason) {
                  _this._error(reason);
                });
                if (!this._isStreamingSupported && this._isRangeSupported) {
                  this._error(new _util2.AbortException("streaming is disabled"));
                }
                if (this._storedError) {
                  this._readableStream.destroy(this._storedError);
                }
              }
            }]);
            return BaseFullReader2;
          }();
          var BaseRangeReader = /* @__PURE__ */ function() {
            function BaseRangeReader2(stream) {
              _classCallCheck2(this, BaseRangeReader2);
              this._url = stream.url;
              this._done = false;
              this._storedError = null;
              this.onProgress = null;
              this._loaded = 0;
              this._readableStream = null;
              this._readCapability = (0, _util2.createPromiseCapability)();
              var source2 = stream.source;
              this._isStreamingSupported = !source2.disableStream;
            }
            _createClass2(BaseRangeReader2, [{
              key: "isStreamingSupported",
              get: function get2() {
                return this._isStreamingSupported;
              }
            }, {
              key: "read",
              value: function() {
                var _read2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee2() {
                  var chunk, buffer2;
                  return _regenerator2["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return this._readCapability.promise;
                        case 2:
                          if (!this._done) {
                            _context2.next = 4;
                            break;
                          }
                          return _context2.abrupt("return", {
                            value: void 0,
                            done: true
                          });
                        case 4:
                          if (!this._storedError) {
                            _context2.next = 6;
                            break;
                          }
                          throw this._storedError;
                        case 6:
                          chunk = this._readableStream.read();
                          if (!(chunk === null)) {
                            _context2.next = 10;
                            break;
                          }
                          this._readCapability = (0, _util2.createPromiseCapability)();
                          return _context2.abrupt("return", this.read());
                        case 10:
                          this._loaded += chunk.length;
                          if (this.onProgress) {
                            this.onProgress({
                              loaded: this._loaded
                            });
                          }
                          buffer2 = new Uint8Array(chunk).buffer;
                          return _context2.abrupt("return", {
                            value: buffer2,
                            done: false
                          });
                        case 14:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                function read2() {
                  return _read2.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                if (!this._readableStream) {
                  this._error(reason);
                  return;
                }
                this._readableStream.destroy(reason);
              }
            }, {
              key: "_error",
              value: function _error(reason) {
                this._storedError = reason;
                this._readCapability.resolve();
              }
            }, {
              key: "_setReadableStream",
              value: function _setReadableStream(readableStream) {
                var _this2 = this;
                this._readableStream = readableStream;
                readableStream.on("readable", function() {
                  _this2._readCapability.resolve();
                });
                readableStream.on("end", function() {
                  readableStream.destroy();
                  _this2._done = true;
                  _this2._readCapability.resolve();
                });
                readableStream.on("error", function(reason) {
                  _this2._error(reason);
                });
                if (this._storedError) {
                  this._readableStream.destroy(this._storedError);
                }
              }
            }]);
            return BaseRangeReader2;
          }();
          function createRequestOptions(parsedUrl, headers) {
            return {
              protocol: parsedUrl.protocol,
              auth: parsedUrl.auth,
              host: parsedUrl.hostname,
              port: parsedUrl.port,
              path: parsedUrl.path,
              method: "GET",
              headers
            };
          }
          var PDFNodeStreamFullReader = /* @__PURE__ */ function(_BaseFullReader) {
            _inherits2(PDFNodeStreamFullReader2, _BaseFullReader);
            var _super = _createSuper2(PDFNodeStreamFullReader2);
            function PDFNodeStreamFullReader2(stream) {
              var _this3;
              _classCallCheck2(this, PDFNodeStreamFullReader2);
              _this3 = _super.call(this, stream);
              var handleResponse = function handleResponse2(response) {
                if (response.statusCode === 404) {
                  var error3 = new _util2.MissingPDFException('Missing PDF "'.concat(_this3._url, '".'));
                  _this3._storedError = error3;
                  _this3._headersCapability.reject(error3);
                  return;
                }
                _this3._headersCapability.resolve();
                _this3._setReadableStream(response);
                var getResponseHeader = function getResponseHeader2(name) {
                  return _this3._readableStream.headers[name.toLowerCase()];
                };
                var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                  getResponseHeader,
                  isHttp: stream.isHttp,
                  rangeChunkSize: _this3._rangeChunkSize,
                  disableRange: _this3._disableRange
                }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                _this3._isRangeSupported = allowRangeRequests;
                _this3._contentLength = suggestedLength || _this3._contentLength;
                _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
              };
              _this3._request = null;
              if (_this3._url.protocol === "http:") {
                _this3._request = http2.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
              } else {
                _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
              }
              _this3._request.on("error", function(reason) {
                _this3._storedError = reason;
                _this3._headersCapability.reject(reason);
              });
              _this3._request.end();
              return _this3;
            }
            return PDFNodeStreamFullReader2;
          }(BaseFullReader);
          var PDFNodeStreamRangeReader = /* @__PURE__ */ function(_BaseRangeReader) {
            _inherits2(PDFNodeStreamRangeReader2, _BaseRangeReader);
            var _super2 = _createSuper2(PDFNodeStreamRangeReader2);
            function PDFNodeStreamRangeReader2(stream, start, end) {
              var _this4;
              _classCallCheck2(this, PDFNodeStreamRangeReader2);
              _this4 = _super2.call(this, stream);
              _this4._httpHeaders = {};
              for (var property in stream.httpHeaders) {
                var value = stream.httpHeaders[property];
                if (typeof value === "undefined") {
                  continue;
                }
                _this4._httpHeaders[property] = value;
              }
              _this4._httpHeaders.Range = "bytes=".concat(start, "-").concat(end - 1);
              var handleResponse = function handleResponse2(response) {
                if (response.statusCode === 404) {
                  var error3 = new _util2.MissingPDFException('Missing PDF "'.concat(_this4._url, '".'));
                  _this4._storedError = error3;
                  return;
                }
                _this4._setReadableStream(response);
              };
              _this4._request = null;
              if (_this4._url.protocol === "http:") {
                _this4._request = http2.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
              } else {
                _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
              }
              _this4._request.on("error", function(reason) {
                _this4._storedError = reason;
              });
              _this4._request.end();
              return _this4;
            }
            return PDFNodeStreamRangeReader2;
          }(BaseRangeReader);
          var PDFNodeStreamFsFullReader = /* @__PURE__ */ function(_BaseFullReader2) {
            _inherits2(PDFNodeStreamFsFullReader2, _BaseFullReader2);
            var _super3 = _createSuper2(PDFNodeStreamFsFullReader2);
            function PDFNodeStreamFsFullReader2(stream) {
              var _this5;
              _classCallCheck2(this, PDFNodeStreamFsFullReader2);
              _this5 = _super3.call(this, stream);
              var path2 = decodeURIComponent(_this5._url.path);
              if (fileUriRegex.test(_this5._url.href)) {
                path2 = path2.replace(/^\//, "");
              }
              fs.lstat(path2, function(error3, stat) {
                if (error3) {
                  if (error3.code === "ENOENT") {
                    error3 = new _util2.MissingPDFException('Missing PDF "'.concat(path2, '".'));
                  }
                  _this5._storedError = error3;
                  _this5._headersCapability.reject(error3);
                  return;
                }
                _this5._contentLength = stat.size;
                _this5._setReadableStream(fs.createReadStream(path2));
                _this5._headersCapability.resolve();
              });
              return _this5;
            }
            return PDFNodeStreamFsFullReader2;
          }(BaseFullReader);
          var PDFNodeStreamFsRangeReader = /* @__PURE__ */ function(_BaseRangeReader2) {
            _inherits2(PDFNodeStreamFsRangeReader2, _BaseRangeReader2);
            var _super4 = _createSuper2(PDFNodeStreamFsRangeReader2);
            function PDFNodeStreamFsRangeReader2(stream, start, end) {
              var _this6;
              _classCallCheck2(this, PDFNodeStreamFsRangeReader2);
              _this6 = _super4.call(this, stream);
              var path2 = decodeURIComponent(_this6._url.path);
              if (fileUriRegex.test(_this6._url.href)) {
                path2 = path2.replace(/^\//, "");
              }
              _this6._setReadableStream(fs.createReadStream(path2, {
                start,
                end: end - 1
              }));
              return _this6;
            }
            return PDFNodeStreamFsRangeReader2;
          }(BaseRangeReader);
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.createResponseStatusError = createResponseStatusError;
          exports2.extractFilenameFromHeader = extractFilenameFromHeader;
          exports2.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
          exports2.validateResponseStatus = validateResponseStatus;
          var _util2 = __w_pdfjs_require__2(4);
          var _content_disposition = __w_pdfjs_require__2(155);
          var _display_utils2 = __w_pdfjs_require__2(1);
          function validateRangeRequestCapabilities(_ref) {
            var getResponseHeader = _ref.getResponseHeader, isHttp = _ref.isHttp, rangeChunkSize = _ref.rangeChunkSize, disableRange = _ref.disableRange;
            (0, _util2.assert)(rangeChunkSize > 0, "Range chunk size must be larger than zero");
            var returnValues = {
              allowRangeRequests: false,
              suggestedLength: void 0
            };
            var length = parseInt(getResponseHeader("Content-Length"), 10);
            if (!Number.isInteger(length)) {
              return returnValues;
            }
            returnValues.suggestedLength = length;
            if (length <= 2 * rangeChunkSize) {
              return returnValues;
            }
            if (disableRange || !isHttp) {
              return returnValues;
            }
            if (getResponseHeader("Accept-Ranges") !== "bytes") {
              return returnValues;
            }
            var contentEncoding = getResponseHeader("Content-Encoding") || "identity";
            if (contentEncoding !== "identity") {
              return returnValues;
            }
            returnValues.allowRangeRequests = true;
            return returnValues;
          }
          function extractFilenameFromHeader(getResponseHeader) {
            var contentDisposition = getResponseHeader("Content-Disposition");
            if (contentDisposition) {
              var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
              if (filename.includes("%")) {
                try {
                  filename = decodeURIComponent(filename);
                } catch (ex) {
                }
              }
              if ((0, _display_utils2.isPdfFile)(filename)) {
                return filename;
              }
            }
            return null;
          }
          function createResponseStatusError(status, url) {
            if (status === 404 || status === 0 && url.startsWith("file:")) {
              return new _util2.MissingPDFException('Missing PDF "' + url + '".');
            }
            return new _util2.UnexpectedResponseException("Unexpected server response (".concat(status, ') while retrieving PDF "').concat(url, '".'), status);
          }
          function validateResponseStatus(status) {
            return status === 200 || status === 206;
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
          var _util2 = __w_pdfjs_require__2(4);
          function _slicedToArray2(arr2, i2) {
            return _arrayWithHoles2(arr2) || _iterableToArrayLimit2(arr2, i2) || _unsupportedIterableToArray2(arr2, i2) || _nonIterableRest2();
          }
          function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _iterableToArrayLimit2(arr2, i2) {
            var _i = arr2 == null ? null : typeof Symbol !== "undefined" && arr2[Symbol.iterator] || arr2["@@iterator"];
            if (_i == null)
              return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e2;
            try {
              for (_i = _i.call(arr2); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i2 && _arr.length === i2)
                  break;
              }
            } catch (err) {
              _d = true;
              _e2 = err;
            } finally {
              try {
                if (!_n && _i["return"] != null)
                  _i["return"]();
              } finally {
                if (_d)
                  throw _e2;
              }
            }
            return _arr;
          }
          function _arrayWithHoles2(arr2) {
            if (Array.isArray(arr2))
              return arr2;
          }
          function getFilenameFromContentDispositionHeader(contentDisposition) {
            var needsEncodingFixup = true;
            var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
            if (tmp) {
              tmp = tmp[1];
              var filename = rfc2616unquote(tmp);
              filename = unescape(filename);
              filename = rfc5987decode(filename);
              filename = rfc2047decode(filename);
              return fixupEncoding(filename);
            }
            tmp = rfc2231getparam(contentDisposition);
            if (tmp) {
              var _filename = rfc2047decode(tmp);
              return fixupEncoding(_filename);
            }
            tmp = toParamRegExp("filename", "i").exec(contentDisposition);
            if (tmp) {
              tmp = tmp[1];
              var _filename2 = rfc2616unquote(tmp);
              _filename2 = rfc2047decode(_filename2);
              return fixupEncoding(_filename2);
            }
            function toParamRegExp(attributePattern, flags) {
              return new RegExp("(?:^|;)\\s*" + attributePattern + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', flags);
            }
            function textdecode(encoding, value) {
              if (encoding) {
                if (!/^[\x00-\xFF]+$/.test(value)) {
                  return value;
                }
                try {
                  var decoder = new TextDecoder(encoding, {
                    fatal: true
                  });
                  var buffer2 = (0, _util2.stringToBytes)(value);
                  value = decoder.decode(buffer2);
                  needsEncodingFixup = false;
                } catch (e2) {
                  if (/^utf-?8$/i.test(encoding)) {
                    try {
                      value = decodeURIComponent(escape(value));
                      needsEncodingFixup = false;
                    } catch (err) {
                    }
                  }
                }
              }
              return value;
            }
            function fixupEncoding(value) {
              if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                value = textdecode("utf-8", value);
                if (needsEncodingFixup) {
                  value = textdecode("iso-8859-1", value);
                }
              }
              return value;
            }
            function rfc2231getparam(contentDispositionStr) {
              var matches = [];
              var match;
              var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
              while ((match = iter.exec(contentDispositionStr)) !== null) {
                var _match2 = match, _match22 = _slicedToArray2(_match2, 4), n2 = _match22[1], quot = _match22[2], part = _match22[3];
                n2 = parseInt(n2, 10);
                if (n2 in matches) {
                  if (n2 === 0) {
                    break;
                  }
                  continue;
                }
                matches[n2] = [quot, part];
              }
              var parts = [];
              for (var _n2 = 0; _n2 < matches.length; ++_n2) {
                if (!(_n2 in matches)) {
                  break;
                }
                var _matches$_n = _slicedToArray2(matches[_n2], 2), _quot = _matches$_n[0], _part = _matches$_n[1];
                _part = rfc2616unquote(_part);
                if (_quot) {
                  _part = unescape(_part);
                  if (_n2 === 0) {
                    _part = rfc5987decode(_part);
                  }
                }
                parts.push(_part);
              }
              return parts.join("");
            }
            function rfc2616unquote(value) {
              if (value.startsWith('"')) {
                var parts = value.slice(1).split('\\"');
                for (var i2 = 0; i2 < parts.length; ++i2) {
                  var quotindex = parts[i2].indexOf('"');
                  if (quotindex !== -1) {
                    parts[i2] = parts[i2].slice(0, quotindex);
                    parts.length = i2 + 1;
                  }
                  parts[i2] = parts[i2].replace(/\\(.)/g, "$1");
                }
                value = parts.join('"');
              }
              return value;
            }
            function rfc5987decode(extvalue) {
              var encodingend = extvalue.indexOf("'");
              if (encodingend === -1) {
                return extvalue;
              }
              var encoding = extvalue.slice(0, encodingend);
              var langvalue = extvalue.slice(encodingend + 1);
              var value = langvalue.replace(/^[^']*'/, "");
              return textdecode(encoding, value);
            }
            function rfc2047decode(value) {
              if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
                return value;
              }
              return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                if (encoding === "q" || encoding === "Q") {
                  text = text.replace(/_/g, " ");
                  text = text.replace(/=([0-9a-fA-F]{2})/g, function(match, hex2) {
                    return String.fromCharCode(parseInt(hex2, 16));
                  });
                  return textdecode(charset, text);
                }
                try {
                  text = atob(text);
                } catch (e2) {
                }
                return textdecode(charset, text);
              });
            }
            return "";
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFNetworkStream = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          var _network_utils = __w_pdfjs_require__2(154);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          var OK_RESPONSE = 200;
          var PARTIAL_CONTENT_RESPONSE = 206;
          function getArrayBuffer(xhr2) {
            var data2 = xhr2.response;
            if (typeof data2 !== "string") {
              return data2;
            }
            var array = (0, _util2.stringToBytes)(data2);
            return array.buffer;
          }
          var NetworkManager = /* @__PURE__ */ function() {
            function NetworkManager2(url) {
              var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              _classCallCheck2(this, NetworkManager2);
              this.url = url;
              this.isHttp = /^https?:/i.test(url);
              this.httpHeaders = this.isHttp && args.httpHeaders || /* @__PURE__ */ Object.create(null);
              this.withCredentials = args.withCredentials || false;
              this.getXhr = args.getXhr || function NetworkManager_getXhr() {
                return new XMLHttpRequest();
              };
              this.currXhrId = 0;
              this.pendingRequests = /* @__PURE__ */ Object.create(null);
            }
            _createClass2(NetworkManager2, [{
              key: "requestRange",
              value: function requestRange(begin, end, listeners) {
                var args = {
                  begin,
                  end
                };
                for (var prop in listeners) {
                  args[prop] = listeners[prop];
                }
                return this.request(args);
              }
            }, {
              key: "requestFull",
              value: function requestFull(listeners) {
                return this.request(listeners);
              }
            }, {
              key: "request",
              value: function request4(args) {
                var xhr2 = this.getXhr();
                var xhrId = this.currXhrId++;
                var pendingRequest = this.pendingRequests[xhrId] = {
                  xhr: xhr2
                };
                xhr2.open("GET", this.url);
                xhr2.withCredentials = this.withCredentials;
                for (var property in this.httpHeaders) {
                  var value = this.httpHeaders[property];
                  if (typeof value === "undefined") {
                    continue;
                  }
                  xhr2.setRequestHeader(property, value);
                }
                if (this.isHttp && "begin" in args && "end" in args) {
                  xhr2.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
                  pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                } else {
                  pendingRequest.expectedStatus = OK_RESPONSE;
                }
                xhr2.responseType = "arraybuffer";
                if (args.onError) {
                  xhr2.onerror = function(evt) {
                    args.onError(xhr2.status);
                  };
                }
                xhr2.onreadystatechange = this.onStateChange.bind(this, xhrId);
                xhr2.onprogress = this.onProgress.bind(this, xhrId);
                pendingRequest.onHeadersReceived = args.onHeadersReceived;
                pendingRequest.onDone = args.onDone;
                pendingRequest.onError = args.onError;
                pendingRequest.onProgress = args.onProgress;
                xhr2.send(null);
                return xhrId;
              }
            }, {
              key: "onProgress",
              value: function onProgress(xhrId, evt) {
                var _pendingRequest$onPro;
                var pendingRequest = this.pendingRequests[xhrId];
                if (!pendingRequest) {
                  return;
                }
                (_pendingRequest$onPro = pendingRequest.onProgress) === null || _pendingRequest$onPro === void 0 ? void 0 : _pendingRequest$onPro.call(pendingRequest, evt);
              }
            }, {
              key: "onStateChange",
              value: function onStateChange(xhrId, evt) {
                var pendingRequest = this.pendingRequests[xhrId];
                if (!pendingRequest) {
                  return;
                }
                var xhr2 = pendingRequest.xhr;
                if (xhr2.readyState >= 2 && pendingRequest.onHeadersReceived) {
                  pendingRequest.onHeadersReceived();
                  delete pendingRequest.onHeadersReceived;
                }
                if (xhr2.readyState !== 4) {
                  return;
                }
                if (!(xhrId in this.pendingRequests)) {
                  return;
                }
                delete this.pendingRequests[xhrId];
                if (xhr2.status === 0 && this.isHttp) {
                  var _pendingRequest$onErr;
                  (_pendingRequest$onErr = pendingRequest.onError) === null || _pendingRequest$onErr === void 0 ? void 0 : _pendingRequest$onErr.call(pendingRequest, xhr2.status);
                  return;
                }
                var xhrStatus = xhr2.status || OK_RESPONSE;
                var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                  var _pendingRequest$onErr2;
                  (_pendingRequest$onErr2 = pendingRequest.onError) === null || _pendingRequest$onErr2 === void 0 ? void 0 : _pendingRequest$onErr2.call(pendingRequest, xhr2.status);
                  return;
                }
                var chunk = getArrayBuffer(xhr2);
                if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                  var rangeHeader = xhr2.getResponseHeader("Content-Range");
                  var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                  pendingRequest.onDone({
                    begin: parseInt(matches[1], 10),
                    chunk
                  });
                } else if (chunk) {
                  pendingRequest.onDone({
                    begin: 0,
                    chunk
                  });
                } else {
                  var _pendingRequest$onErr3;
                  (_pendingRequest$onErr3 = pendingRequest.onError) === null || _pendingRequest$onErr3 === void 0 ? void 0 : _pendingRequest$onErr3.call(pendingRequest, xhr2.status);
                }
              }
            }, {
              key: "getRequestXhr",
              value: function getRequestXhr(xhrId) {
                return this.pendingRequests[xhrId].xhr;
              }
            }, {
              key: "isPendingRequest",
              value: function isPendingRequest(xhrId) {
                return xhrId in this.pendingRequests;
              }
            }, {
              key: "abortRequest",
              value: function abortRequest(xhrId) {
                var xhr2 = this.pendingRequests[xhrId].xhr;
                delete this.pendingRequests[xhrId];
                xhr2.abort();
              }
            }]);
            return NetworkManager2;
          }();
          var PDFNetworkStream = /* @__PURE__ */ function() {
            function PDFNetworkStream2(source2) {
              _classCallCheck2(this, PDFNetworkStream2);
              this._source = source2;
              this._manager = new NetworkManager(source2.url, {
                httpHeaders: source2.httpHeaders,
                withCredentials: source2.withCredentials
              });
              this._rangeChunkSize = source2.rangeChunkSize;
              this._fullRequestReader = null;
              this._rangeRequestReaders = [];
            }
            _createClass2(PDFNetworkStream2, [{
              key: "_onRangeRequestReaderClosed",
              value: function _onRangeRequestReaderClosed(reader) {
                var i2 = this._rangeRequestReaders.indexOf(reader);
                if (i2 >= 0) {
                  this._rangeRequestReaders.splice(i2, 1);
                }
              }
            }, {
              key: "getFullReader",
              value: function getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                return this._fullRequestReader;
              }
            }, {
              key: "getRangeReader",
              value: function getRangeReader(begin, end) {
                var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                this._rangeRequestReaders.push(reader);
                return reader;
              }
            }, {
              key: "cancelAllRequests",
              value: function cancelAllRequests(reason) {
                var _this$_fullRequestRea;
                (_this$_fullRequestRea = this._fullRequestReader) === null || _this$_fullRequestRea === void 0 ? void 0 : _this$_fullRequestRea.cancel(reason);
                var _iterator = _createForOfIteratorHelper2(this._rangeRequestReaders.slice(0)), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var reader = _step.value;
                    reader.cancel(reason);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }]);
            return PDFNetworkStream2;
          }();
          exports2.PDFNetworkStream = PDFNetworkStream;
          var PDFNetworkStreamFullRequestReader = /* @__PURE__ */ function() {
            function PDFNetworkStreamFullRequestReader2(manager, source2) {
              _classCallCheck2(this, PDFNetworkStreamFullRequestReader2);
              this._manager = manager;
              var args = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = source2.url;
              this._fullRequestId = manager.requestFull(args);
              this._headersReceivedCapability = (0, _util2.createPromiseCapability)();
              this._disableRange = source2.disableRange || false;
              this._contentLength = source2.length;
              this._rangeChunkSize = source2.rangeChunkSize;
              if (!this._rangeChunkSize && !this._disableRange) {
                this._disableRange = true;
              }
              this._isStreamingSupported = false;
              this._isRangeSupported = false;
              this._cachedChunks = [];
              this._requests = [];
              this._done = false;
              this._storedError = void 0;
              this._filename = null;
              this.onProgress = null;
            }
            _createClass2(PDFNetworkStreamFullRequestReader2, [{
              key: "_onHeadersReceived",
              value: function _onHeadersReceived() {
                var fullRequestXhrId = this._fullRequestId;
                var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                var getResponseHeader = function getResponseHeader2(name) {
                  return fullRequestXhr.getResponseHeader(name);
                };
                var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                  getResponseHeader,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                if (allowRangeRequests) {
                  this._isRangeSupported = true;
                }
                this._contentLength = suggestedLength || this._contentLength;
                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                if (this._isRangeSupported) {
                  this._manager.abortRequest(fullRequestXhrId);
                }
                this._headersReceivedCapability.resolve();
              }
            }, {
              key: "_onDone",
              value: function _onDone(data2) {
                if (data2) {
                  if (this._requests.length > 0) {
                    var requestCapability = this._requests.shift();
                    requestCapability.resolve({
                      value: data2.chunk,
                      done: false
                    });
                  } else {
                    this._cachedChunks.push(data2.chunk);
                  }
                }
                this._done = true;
                if (this._cachedChunks.length > 0) {
                  return;
                }
                var _iterator2 = _createForOfIteratorHelper2(this._requests), _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var _requestCapability = _step2.value;
                    _requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                this._requests.length = 0;
              }
            }, {
              key: "_onError",
              value: function _onError(status) {
                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                this._headersReceivedCapability.reject(this._storedError);
                var _iterator3 = _createForOfIteratorHelper2(this._requests), _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                    var requestCapability = _step3.value;
                    requestCapability.reject(this._storedError);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                this._requests.length = 0;
                this._cachedChunks.length = 0;
              }
            }, {
              key: "_onProgress",
              value: function _onProgress(evt) {
                var _this$onProgress;
                (_this$onProgress = this.onProgress) === null || _this$onProgress === void 0 ? void 0 : _this$onProgress.call(this, {
                  loaded: evt.loaded,
                  total: evt.lengthComputable ? evt.total : this._contentLength
                });
              }
            }, {
              key: "filename",
              get: function get2() {
                return this._filename;
              }
            }, {
              key: "isRangeSupported",
              get: function get2() {
                return this._isRangeSupported;
              }
            }, {
              key: "isStreamingSupported",
              get: function get2() {
                return this._isStreamingSupported;
              }
            }, {
              key: "contentLength",
              get: function get2() {
                return this._contentLength;
              }
            }, {
              key: "headersReady",
              get: function get2() {
                return this._headersReceivedCapability.promise;
              }
            }, {
              key: "read",
              value: function() {
                var _read = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee() {
                  var chunk, requestCapability;
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!this._storedError) {
                            _context.next = 2;
                            break;
                          }
                          throw this._storedError;
                        case 2:
                          if (!(this._cachedChunks.length > 0)) {
                            _context.next = 5;
                            break;
                          }
                          chunk = this._cachedChunks.shift();
                          return _context.abrupt("return", {
                            value: chunk,
                            done: false
                          });
                        case 5:
                          if (!this._done) {
                            _context.next = 7;
                            break;
                          }
                          return _context.abrupt("return", {
                            value: void 0,
                            done: true
                          });
                        case 7:
                          requestCapability = (0, _util2.createPromiseCapability)();
                          this._requests.push(requestCapability);
                          return _context.abrupt("return", requestCapability.promise);
                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function read2() {
                  return _read.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                this._done = true;
                this._headersReceivedCapability.reject(reason);
                var _iterator4 = _createForOfIteratorHelper2(this._requests), _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                    var requestCapability = _step4.value;
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                this._requests.length = 0;
                if (this._manager.isPendingRequest(this._fullRequestId)) {
                  this._manager.abortRequest(this._fullRequestId);
                }
                this._fullRequestReader = null;
              }
            }]);
            return PDFNetworkStreamFullRequestReader2;
          }();
          var PDFNetworkStreamRangeRequestReader = /* @__PURE__ */ function() {
            function PDFNetworkStreamRangeRequestReader2(manager, begin, end) {
              _classCallCheck2(this, PDFNetworkStreamRangeRequestReader2);
              this._manager = manager;
              var args = {
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = manager.url;
              this._requestId = manager.requestRange(begin, end, args);
              this._requests = [];
              this._queuedChunk = null;
              this._done = false;
              this._storedError = void 0;
              this.onProgress = null;
              this.onClosed = null;
            }
            _createClass2(PDFNetworkStreamRangeRequestReader2, [{
              key: "_close",
              value: function _close() {
                var _this$onClosed;
                (_this$onClosed = this.onClosed) === null || _this$onClosed === void 0 ? void 0 : _this$onClosed.call(this, this);
              }
            }, {
              key: "_onDone",
              value: function _onDone(data2) {
                var chunk = data2.chunk;
                if (this._requests.length > 0) {
                  var requestCapability = this._requests.shift();
                  requestCapability.resolve({
                    value: chunk,
                    done: false
                  });
                } else {
                  this._queuedChunk = chunk;
                }
                this._done = true;
                var _iterator5 = _createForOfIteratorHelper2(this._requests), _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                    var _requestCapability2 = _step5.value;
                    _requestCapability2.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                this._requests.length = 0;
                this._close();
              }
            }, {
              key: "_onError",
              value: function _onError(status) {
                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                var _iterator6 = _createForOfIteratorHelper2(this._requests), _step6;
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
                    var requestCapability = _step6.value;
                    requestCapability.reject(this._storedError);
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
                this._requests.length = 0;
                this._queuedChunk = null;
              }
            }, {
              key: "_onProgress",
              value: function _onProgress(evt) {
                if (!this.isStreamingSupported) {
                  var _this$onProgress2;
                  (_this$onProgress2 = this.onProgress) === null || _this$onProgress2 === void 0 ? void 0 : _this$onProgress2.call(this, {
                    loaded: evt.loaded
                  });
                }
              }
            }, {
              key: "isStreamingSupported",
              get: function get2() {
                return false;
              }
            }, {
              key: "read",
              value: function() {
                var _read2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee2() {
                  var chunk, requestCapability;
                  return _regenerator2["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!this._storedError) {
                            _context2.next = 2;
                            break;
                          }
                          throw this._storedError;
                        case 2:
                          if (!(this._queuedChunk !== null)) {
                            _context2.next = 6;
                            break;
                          }
                          chunk = this._queuedChunk;
                          this._queuedChunk = null;
                          return _context2.abrupt("return", {
                            value: chunk,
                            done: false
                          });
                        case 6:
                          if (!this._done) {
                            _context2.next = 8;
                            break;
                          }
                          return _context2.abrupt("return", {
                            value: void 0,
                            done: true
                          });
                        case 8:
                          requestCapability = (0, _util2.createPromiseCapability)();
                          this._requests.push(requestCapability);
                          return _context2.abrupt("return", requestCapability.promise);
                        case 11:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                function read2() {
                  return _read2.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                this._done = true;
                var _iterator7 = _createForOfIteratorHelper2(this._requests), _step7;
                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done; ) {
                    var requestCapability = _step7.value;
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
                this._requests.length = 0;
                if (this._manager.isPendingRequest(this._requestId)) {
                  this._manager.abortRequest(this._requestId);
                }
                this._close();
              }
            }]);
            return PDFNetworkStreamRangeRequestReader2;
          }();
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFFetchStream = void 0;
          var _regenerator2 = _interopRequireDefault2(__w_pdfjs_require__2(2));
          var _util2 = __w_pdfjs_require__2(4);
          var _network_utils = __w_pdfjs_require__2(154);
          function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : { "default": obj };
          }
          function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error3) {
              reject(error3);
              return;
            }
            if (info.done) {
              resolve(value);
            } else {
              Promise.resolve(value).then(_next, _throw);
            }
          }
          function _asyncToGenerator2(fn) {
            return function() {
              var self2 = this, args = arguments;
              return new Promise(function(resolve, reject) {
                var gen = fn.apply(self2, args);
                function _next(value) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                  asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(void 0);
              });
            };
          }
          function _createForOfIteratorHelper2(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it)
                  o = it;
                var i2 = 0;
                var F2 = function F3() {
                };
                return { s: F2, n: function n2() {
                  if (i2 >= o.length)
                    return { done: true };
                  return { done: false, value: o[i2++] };
                }, e: function e2(_e2) {
                  throw _e2;
                }, f: F2 };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var normalCompletion = true, didErr = false, err;
            return { s: function s2() {
              it = it.call(o);
            }, n: function n2() {
              var step2 = it.next();
              normalCompletion = step2.done;
              return step2;
            }, e: function e2(_e2) {
              didErr = true;
              err = _e2;
            }, f: function f2() {
              try {
                if (!normalCompletion && it["return"] != null)
                  it["return"]();
              } finally {
                if (didErr)
                  throw err;
              }
            } };
          }
          function _unsupportedIterableToArray2(o, minLen) {
            if (!o)
              return;
            if (typeof o === "string")
              return _arrayLikeToArray2(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor)
              n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set")
              return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
              return _arrayLikeToArray2(o, minLen);
          }
          function _arrayLikeToArray2(arr2, len) {
            if (len == null || len > arr2.length)
              len = arr2.length;
            for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++) {
              arr22[i2] = arr2[i2];
            }
            return arr22;
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function createFetchOptions(headers, withCredentials, abortController) {
            return {
              method: "GET",
              headers,
              signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
              mode: "cors",
              credentials: withCredentials ? "include" : "same-origin",
              redirect: "follow"
            };
          }
          function createHeaders(httpHeaders) {
            var headers = new Headers();
            for (var property in httpHeaders) {
              var value = httpHeaders[property];
              if (typeof value === "undefined") {
                continue;
              }
              headers.append(property, value);
            }
            return headers;
          }
          var PDFFetchStream = /* @__PURE__ */ function() {
            function PDFFetchStream2(source2) {
              _classCallCheck2(this, PDFFetchStream2);
              this.source = source2;
              this.isHttp = /^https?:/i.test(source2.url);
              this.httpHeaders = this.isHttp && source2.httpHeaders || {};
              this._fullRequestReader = null;
              this._rangeRequestReaders = [];
            }
            _createClass2(PDFFetchStream2, [{
              key: "_progressiveDataLength",
              get: function get2() {
                var _this$_fullRequestRea, _this$_fullRequestRea2;
                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
              }
            }, {
              key: "getFullReader",
              value: function getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                this._fullRequestReader = new PDFFetchStreamReader(this);
                return this._fullRequestReader;
              }
            }, {
              key: "getRangeReader",
              value: function getRangeReader(begin, end) {
                if (end <= this._progressiveDataLength) {
                  return null;
                }
                var reader = new PDFFetchStreamRangeReader(this, begin, end);
                this._rangeRequestReaders.push(reader);
                return reader;
              }
            }, {
              key: "cancelAllRequests",
              value: function cancelAllRequests(reason) {
                if (this._fullRequestReader) {
                  this._fullRequestReader.cancel(reason);
                }
                var _iterator = _createForOfIteratorHelper2(this._rangeRequestReaders.slice(0)), _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var reader = _step.value;
                    reader.cancel(reason);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }]);
            return PDFFetchStream2;
          }();
          exports2.PDFFetchStream = PDFFetchStream;
          var PDFFetchStreamReader = /* @__PURE__ */ function() {
            function PDFFetchStreamReader2(stream) {
              var _this = this;
              _classCallCheck2(this, PDFFetchStreamReader2);
              this._stream = stream;
              this._reader = null;
              this._loaded = 0;
              this._filename = null;
              var source2 = stream.source;
              this._withCredentials = source2.withCredentials || false;
              this._contentLength = source2.length;
              this._headersCapability = (0, _util2.createPromiseCapability)();
              this._disableRange = source2.disableRange || false;
              this._rangeChunkSize = source2.rangeChunkSize;
              if (!this._rangeChunkSize && !this._disableRange) {
                this._disableRange = true;
              }
              if (typeof AbortController !== "undefined") {
                this._abortController = new AbortController();
              }
              this._isStreamingSupported = !source2.disableStream;
              this._isRangeSupported = !source2.disableRange;
              this._headers = createHeaders(this._stream.httpHeaders);
              var url = source2.url;
              fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                  throw (0, _network_utils.createResponseStatusError)(response.status, url);
                }
                _this._reader = response.body.getReader();
                _this._headersCapability.resolve();
                var getResponseHeader = function getResponseHeader2(name) {
                  return response.headers.get(name);
                };
                var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                  getResponseHeader,
                  isHttp: _this._stream.isHttp,
                  rangeChunkSize: _this._rangeChunkSize,
                  disableRange: _this._disableRange
                }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                _this._isRangeSupported = allowRangeRequests;
                _this._contentLength = suggestedLength || _this._contentLength;
                _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                if (!_this._isStreamingSupported && _this._isRangeSupported) {
                  _this.cancel(new _util2.AbortException("Streaming is disabled."));
                }
              })["catch"](this._headersCapability.reject);
              this.onProgress = null;
            }
            _createClass2(PDFFetchStreamReader2, [{
              key: "headersReady",
              get: function get2() {
                return this._headersCapability.promise;
              }
            }, {
              key: "filename",
              get: function get2() {
                return this._filename;
              }
            }, {
              key: "contentLength",
              get: function get2() {
                return this._contentLength;
              }
            }, {
              key: "isRangeSupported",
              get: function get2() {
                return this._isRangeSupported;
              }
            }, {
              key: "isStreamingSupported",
              get: function get2() {
                return this._isStreamingSupported;
              }
            }, {
              key: "read",
              value: function() {
                var _read = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee() {
                  var _yield$this$_reader$r, value, done, buffer2;
                  return _regenerator2["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return this._headersCapability.promise;
                        case 2:
                          _context.next = 4;
                          return this._reader.read();
                        case 4:
                          _yield$this$_reader$r = _context.sent;
                          value = _yield$this$_reader$r.value;
                          done = _yield$this$_reader$r.done;
                          if (!done) {
                            _context.next = 9;
                            break;
                          }
                          return _context.abrupt("return", {
                            value,
                            done
                          });
                        case 9:
                          this._loaded += value.byteLength;
                          if (this.onProgress) {
                            this.onProgress({
                              loaded: this._loaded,
                              total: this._contentLength
                            });
                          }
                          buffer2 = new Uint8Array(value).buffer;
                          return _context.abrupt("return", {
                            value: buffer2,
                            done: false
                          });
                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
                function read2() {
                  return _read.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                if (this._reader) {
                  this._reader.cancel(reason);
                }
                if (this._abortController) {
                  this._abortController.abort();
                }
              }
            }]);
            return PDFFetchStreamReader2;
          }();
          var PDFFetchStreamRangeReader = /* @__PURE__ */ function() {
            function PDFFetchStreamRangeReader2(stream, begin, end) {
              var _this2 = this;
              _classCallCheck2(this, PDFFetchStreamRangeReader2);
              this._stream = stream;
              this._reader = null;
              this._loaded = 0;
              var source2 = stream.source;
              this._withCredentials = source2.withCredentials || false;
              this._readCapability = (0, _util2.createPromiseCapability)();
              this._isStreamingSupported = !source2.disableStream;
              if (typeof AbortController !== "undefined") {
                this._abortController = new AbortController();
              }
              this._headers = createHeaders(this._stream.httpHeaders);
              this._headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
              var url = source2.url;
              fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                  throw (0, _network_utils.createResponseStatusError)(response.status, url);
                }
                _this2._readCapability.resolve();
                _this2._reader = response.body.getReader();
              })["catch"](this._readCapability.reject);
              this.onProgress = null;
            }
            _createClass2(PDFFetchStreamRangeReader2, [{
              key: "isStreamingSupported",
              get: function get2() {
                return this._isStreamingSupported;
              }
            }, {
              key: "read",
              value: function() {
                var _read2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2["default"].mark(function _callee2() {
                  var _yield$this$_reader$r2, value, done, buffer2;
                  return _regenerator2["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return this._readCapability.promise;
                        case 2:
                          _context2.next = 4;
                          return this._reader.read();
                        case 4:
                          _yield$this$_reader$r2 = _context2.sent;
                          value = _yield$this$_reader$r2.value;
                          done = _yield$this$_reader$r2.done;
                          if (!done) {
                            _context2.next = 9;
                            break;
                          }
                          return _context2.abrupt("return", {
                            value,
                            done
                          });
                        case 9:
                          this._loaded += value.byteLength;
                          if (this.onProgress) {
                            this.onProgress({
                              loaded: this._loaded
                            });
                          }
                          buffer2 = new Uint8Array(value).buffer;
                          return _context2.abrupt("return", {
                            value: buffer2,
                            done: false
                          });
                        case 13:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                function read2() {
                  return _read2.apply(this, arguments);
                }
                return read2;
              }()
            }, {
              key: "cancel",
              value: function cancel(reason) {
                if (this._reader) {
                  this._reader.cancel(reason);
                }
                if (this._abortController) {
                  this._abortController.abort();
                }
              }
            }]);
            return PDFFetchStreamRangeReader2;
          }();
        }
      ];
      var __webpack_module_cache__ = {};
      function __w_pdfjs_require__(moduleId) {
        var cachedModule = __webpack_module_cache__[moduleId];
        if (cachedModule !== void 0) {
          return cachedModule.exports;
        }
        var module2 = __webpack_module_cache__[moduleId] = {
          id: moduleId,
          loaded: false,
          exports: {}
        };
        __webpack_modules__[moduleId].call(module2.exports, module2, module2.exports, __w_pdfjs_require__);
        module2.loaded = true;
        return module2.exports;
      }
      (() => {
        __w_pdfjs_require__.nmd = (module2) => {
          module2.paths = [];
          if (!module2.children)
            module2.children = [];
          return module2;
        };
      })();
      var __webpack_exports__ = {};
      (() => {
        var exports2 = __webpack_exports__;
        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
        Object.defineProperty(exports2, "AnnotationLayer", {
          enumerable: true,
          get: function get2() {
            return _annotation_layer.AnnotationLayer;
          }
        });
        Object.defineProperty(exports2, "AnnotationMode", {
          enumerable: true,
          get: function get2() {
            return _util2.AnnotationMode;
          }
        });
        Object.defineProperty(exports2, "CMapCompressionType", {
          enumerable: true,
          get: function get2() {
            return _util2.CMapCompressionType;
          }
        });
        Object.defineProperty(exports2, "GlobalWorkerOptions", {
          enumerable: true,
          get: function get2() {
            return _worker_options2.GlobalWorkerOptions;
          }
        });
        Object.defineProperty(exports2, "InvalidPDFException", {
          enumerable: true,
          get: function get2() {
            return _util2.InvalidPDFException;
          }
        });
        Object.defineProperty(exports2, "LinkTarget", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.LinkTarget;
          }
        });
        Object.defineProperty(exports2, "LoopbackPort", {
          enumerable: true,
          get: function get2() {
            return _api.LoopbackPort;
          }
        });
        Object.defineProperty(exports2, "MissingPDFException", {
          enumerable: true,
          get: function get2() {
            return _util2.MissingPDFException;
          }
        });
        Object.defineProperty(exports2, "OPS", {
          enumerable: true,
          get: function get2() {
            return _util2.OPS;
          }
        });
        Object.defineProperty(exports2, "PDFDataRangeTransport", {
          enumerable: true,
          get: function get2() {
            return _api.PDFDataRangeTransport;
          }
        });
        Object.defineProperty(exports2, "PDFDateString", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.PDFDateString;
          }
        });
        Object.defineProperty(exports2, "PDFWorker", {
          enumerable: true,
          get: function get2() {
            return _api.PDFWorker;
          }
        });
        Object.defineProperty(exports2, "PasswordResponses", {
          enumerable: true,
          get: function get2() {
            return _util2.PasswordResponses;
          }
        });
        Object.defineProperty(exports2, "PermissionFlag", {
          enumerable: true,
          get: function get2() {
            return _util2.PermissionFlag;
          }
        });
        Object.defineProperty(exports2, "PixelsPerInch", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.PixelsPerInch;
          }
        });
        Object.defineProperty(exports2, "RenderingCancelledException", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.RenderingCancelledException;
          }
        });
        Object.defineProperty(exports2, "SVGGraphics", {
          enumerable: true,
          get: function get2() {
            return _svg.SVGGraphics;
          }
        });
        Object.defineProperty(exports2, "UNSUPPORTED_FEATURES", {
          enumerable: true,
          get: function get2() {
            return _util2.UNSUPPORTED_FEATURES;
          }
        });
        Object.defineProperty(exports2, "UnexpectedResponseException", {
          enumerable: true,
          get: function get2() {
            return _util2.UnexpectedResponseException;
          }
        });
        Object.defineProperty(exports2, "Util", {
          enumerable: true,
          get: function get2() {
            return _util2.Util;
          }
        });
        Object.defineProperty(exports2, "VerbosityLevel", {
          enumerable: true,
          get: function get2() {
            return _util2.VerbosityLevel;
          }
        });
        Object.defineProperty(exports2, "XfaLayer", {
          enumerable: true,
          get: function get2() {
            return _xfa_layer.XfaLayer;
          }
        });
        Object.defineProperty(exports2, "addLinkAttributes", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.addLinkAttributes;
          }
        });
        Object.defineProperty(exports2, "build", {
          enumerable: true,
          get: function get2() {
            return _api.build;
          }
        });
        Object.defineProperty(exports2, "createObjectURL", {
          enumerable: true,
          get: function get2() {
            return _util2.createObjectURL;
          }
        });
        Object.defineProperty(exports2, "createPromiseCapability", {
          enumerable: true,
          get: function get2() {
            return _util2.createPromiseCapability;
          }
        });
        Object.defineProperty(exports2, "createValidAbsoluteUrl", {
          enumerable: true,
          get: function get2() {
            return _util2.createValidAbsoluteUrl;
          }
        });
        Object.defineProperty(exports2, "getDocument", {
          enumerable: true,
          get: function get2() {
            return _api.getDocument;
          }
        });
        Object.defineProperty(exports2, "getFilenameFromUrl", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.getFilenameFromUrl;
          }
        });
        Object.defineProperty(exports2, "getPdfFilenameFromUrl", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.getPdfFilenameFromUrl;
          }
        });
        Object.defineProperty(exports2, "getXfaPageViewport", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.getXfaPageViewport;
          }
        });
        Object.defineProperty(exports2, "isPdfFile", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.isPdfFile;
          }
        });
        Object.defineProperty(exports2, "loadScript", {
          enumerable: true,
          get: function get2() {
            return _display_utils2.loadScript;
          }
        });
        Object.defineProperty(exports2, "removeNullCharacters", {
          enumerable: true,
          get: function get2() {
            return _util2.removeNullCharacters;
          }
        });
        Object.defineProperty(exports2, "renderTextLayer", {
          enumerable: true,
          get: function get2() {
            return _text_layer.renderTextLayer;
          }
        });
        Object.defineProperty(exports2, "shadow", {
          enumerable: true,
          get: function get2() {
            return _util2.shadow;
          }
        });
        Object.defineProperty(exports2, "version", {
          enumerable: true,
          get: function get2() {
            return _api.version;
          }
        });
        var _display_utils2 = __w_pdfjs_require__(1);
        var _util2 = __w_pdfjs_require__(4);
        var _api = __w_pdfjs_require__(136);
        var _annotation_layer = __w_pdfjs_require__(148);
        var _worker_options2 = __w_pdfjs_require__(142);
        var _is_node2 = __w_pdfjs_require__(6);
        var _text_layer = __w_pdfjs_require__(151);
        var _svg = __w_pdfjs_require__(152);
        var _xfa_layer = __w_pdfjs_require__(150);
        {
          if (_is_node2.isNodeJS) {
            var _require = __w_pdfjs_require__(153), PDFNodeStream = _require.PDFNodeStream;
            (0, _api.setPDFNetworkStreamFactory)(function(params) {
              return new PDFNodeStream(params);
            });
          } else {
            var _require2 = __w_pdfjs_require__(156), PDFNetworkStream = _require2.PDFNetworkStream;
            var _require3 = __w_pdfjs_require__(157), PDFFetchStream = _require3.PDFFetchStream;
            (0, _api.setPDFNetworkStreamFactory)(function(params) {
              if ((0, _display_utils2.isValidFetchUrl)(params.url)) {
                return new PDFFetchStream(params);
              }
              return new PDFNetworkStream(params);
            });
          }
        }
      })();
      return __webpack_exports__;
    })();
  });
})(pdf);
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn$5(self2, call) {
  if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var clipboardEvents = ["onCopy", "onCut", "onPaste"];
var compositionEvents = ["onCompositionEnd", "onCompositionStart", "onCompositionUpdate"];
var keyboardEvents = ["onKeyDown", "onKeyPress", "onKeyUp"];
var focusEvents = ["onFocus", "onBlur"];
var formEvents = ["onChange", "onInput", "onInvalid", "onReset", "onSubmit"];
var genericEvents = ["onError", "onLoad"];
var mouseEvents = ["onClick", "onContextMenu", "onDoubleClick", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp"];
var pointerEvents = ["onPointerDown", "onPointerMove", "onPointerUp", "onPointerCancel", "onGotPointerCapture", "onLostPointerCapture", "onPointerEnter", "onPointerLeave", "onPointerOver", "onPointerOut"];
var selectionEvents = ["onSelect"];
var touchEvents = ["onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart"];
var uiEvents = ["onScroll"];
var wheelEvents = ["onWheel"];
var mediaEvents = ["onAbort", "onCanPlay", "onCanPlayThrough", "onDurationChange", "onEmptied", "onEncrypted", "onEnded", "onError", "onLoadedData", "onLoadedMetadata", "onLoadStart", "onPause", "onPlay", "onPlaying", "onProgress", "onRateChange", "onSeeked", "onSeeking", "onStalled", "onSuspend", "onTimeUpdate", "onVolumeChange", "onWaiting"];
var imageEvents = ["onLoad", "onError"];
var animationEvents = ["onAnimationStart", "onAnimationEnd", "onAnimationIteration"];
var transitionEvents = ["onTransitionEnd"];
var otherEvents = ["onToggle"];
var allEvents = [].concat(clipboardEvents, compositionEvents, keyboardEvents, focusEvents, formEvents, genericEvents, mouseEvents, pointerEvents, selectionEvents, touchEvents, uiEvents, wheelEvents, mediaEvents, imageEvents, animationEvents, transitionEvents, otherEvents);
var makeEventProps = function makeEventProps2(props, getArgs) {
  var eventProps2 = {};
  allEvents.forEach(function(eventName) {
    if (!(eventName in props)) {
      return;
    }
    if (!getArgs) {
      eventProps2[eventName] = props[eventName];
      return;
    }
    eventProps2[eventName] = function(event) {
      return props[eventName](event, getArgs(eventName));
    };
  });
  return eventProps2;
};
function makeCancellablePromise(promise) {
  var isCancelled = false;
  var wrappedPromise = new Promise(function(resolve, reject) {
    promise.then(function() {
      return !isCancelled && resolve.apply(void 0, arguments);
    })["catch"](function(error3) {
      return !isCancelled && reject(error3);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCancelled = true;
    }
  };
}
function mergeClassNames() {
  return Array.prototype.slice.call(arguments).reduce(function(classList2, arg) {
    return classList2.concat(arg);
  }, []).filter(function(arg) {
    return typeof arg === "string";
  }).join(" ");
}
var isProduction$1 = true;
var prefix = "Invariant failed";
function invariant$1(condition, message2) {
  if (condition) {
    return;
  }
  if (isProduction$1) {
    throw new Error(prefix);
  }
  var provided = typeof message2 === "function" ? message2() : message2;
  var value = provided ? prefix + ": " + provided : prefix;
  throw new Error(value);
}
var isProduction = true;
function warning$1(condition, message2) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message2;
    if (typeof console !== "undefined") {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x2) {
    }
  }
}
var DocumentContext = /* @__PURE__ */ createContext(null);
function Message$2(_ref) {
  var children = _ref.children, type = _ref.type;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "react-pdf__message react-pdf__message--".concat(type)
  }, children);
}
Message$2.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(["error", "loading", "no-data"]).isRequired
};
var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
var LinkService = /* @__PURE__ */ function() {
  function LinkService2() {
    _classCallCheck$f(this, LinkService2);
    this.externalLinkTarget = null;
    this.externalLinkRel = null;
  }
  _createClass$d(LinkService2, [{
    key: "setDocument",
    value: function setDocument(pdfDocument) {
      this.pdfDocument = pdfDocument;
    }
  }, {
    key: "setViewer",
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: "setExternalLinkRel",
    value: function setExternalLinkRel(externalLinkRel) {
      this.externalLinkRel = externalLinkRel;
    }
  }, {
    key: "setExternalLinkTarget",
    value: function setExternalLinkTarget(externalLinkTarget) {
      this.externalLinkTarget = externalLinkTarget;
    }
  }, {
    key: "setHistory",
    value: function setHistory() {
    }
  }, {
    key: "pagesCount",
    get: function get2() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
  }, {
    key: "page",
    get: function get2() {
      return this.pdfViewer.currentPageNumber;
    },
    set: function set2(value) {
      this.pdfViewer.currentPageNumber = value;
    }
  }, {
    key: "rotation",
    get: function get2() {
      return 0;
    },
    set: function set2(value) {
    }
  }, {
    key: "goToDestination",
    value: function goToDestination(dest) {
      var _this = this;
      new Promise(function(resolve) {
        if (typeof dest === "string") {
          _this.pdfDocument.getDestination(dest).then(resolve);
        } else if (Array.isArray(dest)) {
          resolve(dest);
        } else {
          dest.then(resolve);
        }
      }).then(function(explicitDest) {
        invariant$1(Array.isArray(explicitDest), '"'.concat(explicitDest, '" is not a valid destination array.'));
        var destRef = explicitDest[0];
        new Promise(function(resolve) {
          if (destRef instanceof Object) {
            _this.pdfDocument.getPageIndex(destRef).then(function(pageIndex) {
              resolve(pageIndex);
            })["catch"](function() {
              invariant$1(false, '"'.concat(destRef, '" is not a valid page reference.'));
            });
          } else if (typeof destRef === "number") {
            resolve(destRef);
          } else {
            invariant$1(false, '"'.concat(destRef, '" is not a valid destination reference.'));
          }
        }).then(function(pageIndex) {
          var pageNumber = pageIndex + 1;
          invariant$1(pageNumber >= 1 && pageNumber <= _this.pagesCount, '"'.concat(pageNumber, '" is not a valid page number.'));
          _this.pdfViewer.scrollPageIntoView({
            dest,
            pageIndex,
            pageNumber
          });
        });
      });
    }
  }, {
    key: "navigateTo",
    value: function navigateTo(dest) {
      this.goToDestination(dest);
    }
  }, {
    key: "goToPage",
    value: function goToPage() {
    }
  }, {
    key: "addLinkAttributes",
    value: function addLinkAttributes(link, url, newWindow) {
      link.href = url;
      link.rel = this.externalLinkRel || DEFAULT_LINK_REL;
      link.target = newWindow ? "_blank" : this.externalLinkTarget || "";
    }
  }, {
    key: "getDestinationHash",
    value: function getDestinationHash() {
      return "#";
    }
  }, {
    key: "getAnchorUrl",
    value: function getAnchorUrl() {
      return "#";
    }
  }, {
    key: "setHash",
    value: function setHash() {
    }
  }, {
    key: "executeNamedAction",
    value: function executeNamedAction() {
    }
  }, {
    key: "cachePageRef",
    value: function cachePageRef() {
    }
  }, {
    key: "isPageVisible",
    value: function isPageVisible() {
      return true;
    }
  }, {
    key: "isPageCached",
    value: function isPageCached() {
      return true;
    }
  }]);
  return LinkService2;
}();
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var isBrowser$1 = typeof window !== "undefined";
var isLocalFileSystem = isBrowser$1 && window.location.protocol === "file:";
function isDefined(variable2) {
  return typeof variable2 !== "undefined";
}
function isProvided(variable2) {
  return isDefined(variable2) && variable2 !== null;
}
function isString$2(variable2) {
  return typeof variable2 === "string";
}
function isArrayBuffer(variable2) {
  return variable2 instanceof ArrayBuffer;
}
function isBlob(variable2) {
  invariant$1(isBrowser$1, "isBlob can only be used in a browser environment");
  return variable2 instanceof Blob;
}
function isFile$1(variable2) {
  invariant$1(isBrowser$1, "isFile can only be used in a browser environment");
  return variable2 instanceof File;
}
function isDataURI(str) {
  return isString$2(str) && /^data:/.test(str);
}
function dataURItoByteString(dataURI) {
  invariant$1(isDataURI(dataURI), "Invalid data URI.");
  var _dataURI$split = dataURI.split(","), _dataURI$split2 = _slicedToArray$4(_dataURI$split, 2), headersString = _dataURI$split2[0], dataString = _dataURI$split2[1];
  var headers = headersString.split(";");
  if (headers.indexOf("base64") !== -1) {
    return atob(dataString);
  }
  return unescape(dataString);
}
function getPixelRatio() {
  return isBrowser$1 && window.devicePixelRatio || 1;
}
var allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function displayCORSWarning() {
  warning$1(!isLocalFileSystem, "Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ".concat(allowFileAccessFromFilesTip));
}
function displayWorkerWarning() {
  warning$1(!isLocalFileSystem, "Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ".concat(allowFileAccessFromFilesTip));
}
function cancelRunningTask(runningTask) {
  if (runningTask && runningTask.cancel)
    runningTask.cancel();
}
function makePageCallback(page, scale2) {
  Object.defineProperty(page, "width", {
    get: function get2() {
      return this.view[2] * scale2;
    },
    configurable: true
  });
  Object.defineProperty(page, "height", {
    get: function get2() {
      return this.view[3] * scale2;
    },
    configurable: true
  });
  Object.defineProperty(page, "originalWidth", {
    get: function get2() {
      return this.view[2];
    },
    configurable: true
  });
  Object.defineProperty(page, "originalHeight", {
    get: function get2() {
      return this.view[3];
    },
    configurable: true
  });
  return page;
}
function isCancelException(error3) {
  return error3.name === "RenderingCancelledException";
}
function loadFromFile(file) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onload = function() {
      return resolve(new Uint8Array(reader.result));
    };
    reader.onerror = function(event) {
      switch (event.target.error.code) {
        case event.target.error.NOT_FOUND_ERR:
          return reject(new Error("Error while reading a file: File not found."));
        case event.target.error.NOT_READABLE_ERR:
          return reject(new Error("Error while reading a file: File not readable."));
        case event.target.error.SECURITY_ERR:
          return reject(new Error("Error while reading a file: Security error."));
        case event.target.error.ABORT_ERR:
          return reject(new Error("Error while reading a file: Aborted."));
        default:
          return reject(new Error("Error while reading a file."));
      }
    };
    reader.readAsArrayBuffer(file);
    return null;
  });
}
function _arrayWithoutHoles(arr2) {
  if (Array.isArray(arr2))
    return _arrayLikeToArray(arr2);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr2) {
  return _arrayWithoutHoles(arr2) || _iterableToArray(arr2) || _unsupportedIterableToArray(arr2) || _nonIterableSpread();
}
var eventProps = function() {
  var result2 = {};
  [].concat(_toConsumableArray(mouseEvents), _toConsumableArray(touchEvents), _toConsumableArray(keyboardEvents)).forEach(function(eventName) {
    result2[eventName] = PropTypes.func;
  });
  return result2;
}();
var fileTypes = [PropTypes.string, PropTypes.instanceOf(ArrayBuffer), PropTypes.shape({
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  httpHeaders: PropTypes.object,
  range: PropTypes.object,
  url: PropTypes.string,
  withCredentials: PropTypes.bool
})];
if (typeof File !== "undefined") {
  fileTypes.push(PropTypes.instanceOf(File));
}
if (typeof Blob !== "undefined") {
  fileTypes.push(PropTypes.instanceOf(Blob));
}
var isClassName = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
var isFile = PropTypes.oneOfType(fileTypes);
var isLinkService = PropTypes.instanceOf(LinkService);
PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]);
var isPage = PropTypes.shape({
  _transport: PropTypes.shape({
    fontLoader: PropTypes.object.isRequired
  }).isRequired,
  commonObjs: PropTypes.shape({
    _objs: PropTypes.object.isRequired
  }).isRequired,
  getAnnotations: PropTypes.func.isRequired,
  getTextContent: PropTypes.func.isRequired,
  getViewport: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired
});
var isPageIndex = function isPageIndex2(props, propName, componentName) {
  var pageIndex = props[propName], pageNumber = props.pageNumber, pdf2 = props.pdf;
  if (!isDefined(pdf2)) {
    return null;
  }
  if (isDefined(pageIndex)) {
    if (typeof pageIndex !== "number") {
      return new Error("`".concat(propName, "` of type `").concat(_typeof$6(pageIndex), "` supplied to `").concat(componentName, "`, expected `number`."));
    }
    if (pageIndex < 0) {
      return new Error("Expected `".concat(propName, "` to be greater or equal to 0."));
    }
    var numPages = pdf2.numPages;
    if (pageIndex + 1 > numPages) {
      return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages - 1, "."));
    }
  } else if (!isDefined(pageNumber)) {
    return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
  }
  return null;
};
var isPageNumber = function isPageNumber2(props, propName, componentName) {
  var pageNumber = props[propName], pageIndex = props.pageIndex, pdf2 = props.pdf;
  if (!isDefined(pdf2)) {
    return null;
  }
  if (isDefined(pageNumber)) {
    if (typeof pageNumber !== "number") {
      return new Error("`".concat(propName, "` of type `").concat(_typeof$6(pageNumber), "` supplied to `").concat(componentName, "`, expected `number`."));
    }
    if (pageNumber < 1) {
      return new Error("Expected `".concat(propName, "` to be greater or equal to 1."));
    }
    var numPages = pdf2.numPages;
    if (pageNumber > numPages) {
      return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages, "."));
    }
  } else if (!isDefined(pageIndex)) {
    return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
  }
  return null;
};
var isPdf = PropTypes.oneOfType([PropTypes.shape({
  getDestination: PropTypes.func.isRequired,
  getOutline: PropTypes.func.isRequired,
  getPage: PropTypes.func.isRequired,
  numPages: PropTypes.number.isRequired
}), PropTypes.bool]);
var isRef = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.any
})]);
var isRenderMode = PropTypes.oneOf(["canvas", "none", "svg"]);
var isRotate = PropTypes.oneOf([0, 90, 180, 270]);
var _excluded = ["url"];
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source2), true).forEach(function(key) {
      _defineProperty$7(target, key, source2[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2)) : ownKeys$2(Object(source2)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
    });
  }
  return target;
}
function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var PDFDataRangeTransport = pdf.exports.PDFDataRangeTransport;
var Document$1 = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(Document2, _PureComponent);
  var _super = _createSuper$6(Document2);
  function Document2() {
    var _this;
    _classCallCheck$f(this, Document2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "state", {
      pdf: null
    });
    _defineProperty$7(_assertThisInitialized(_this), "viewer", {
      scrollPageIntoView: function scrollPageIntoView(_ref) {
        var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
        var onItemClick = _this.props.onItemClick;
        if (onItemClick) {
          onItemClick({
            dest,
            pageIndex,
            pageNumber
          });
          return;
        }
        var page = _this.pages[pageIndex];
        if (page) {
          page.scrollIntoView();
          return;
        }
        warning$1(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
      }
    });
    _defineProperty$7(_assertThisInitialized(_this), "linkService", new LinkService());
    _defineProperty$7(_assertThisInitialized(_this), "loadDocument", function() {
      cancelRunningTask(_this.runningTask);
      if (_this.loadingTask)
        _this.loadingTask.destroy();
      var cancellable = makeCancellablePromise(_this.findDocumentSource());
      _this.runningTask = cancellable;
      cancellable.promise.then(function(source2) {
        _this.onSourceSuccess();
        if (!source2) {
          return;
        }
        _this.setState(function(prevState) {
          if (!prevState.pdf) {
            return null;
          }
          return {
            pdf: null
          };
        });
        var _this$props = _this.props, options = _this$props.options, onLoadProgress = _this$props.onLoadProgress, onPassword2 = _this$props.onPassword;
        _this.loadingTask = pdf.exports.getDocument(_objectSpread$7(_objectSpread$7({}, source2), options));
        _this.loadingTask.onPassword = onPassword2;
        if (onLoadProgress) {
          _this.loadingTask.onProgress = onLoadProgress;
        }
        var cancellable2 = makeCancellablePromise(_this.loadingTask.promise);
        _this.runningTask = cancellable2;
        cancellable2.promise.then(function(pdf2) {
          _this.setState(function(prevState) {
            if (prevState.pdf && prevState.pdf.fingerprint === pdf2.fingerprint) {
              return null;
            }
            return {
              pdf: pdf2
            };
          }, _this.onLoadSuccess);
        })["catch"](function(error3) {
          _this.onLoadError(error3);
        });
      })["catch"](function(error3) {
        _this.onSourceError(error3);
      });
    });
    _defineProperty$7(_assertThisInitialized(_this), "setupLinkService", function() {
      var _this$props2 = _this.props, externalLinkRel = _this$props2.externalLinkRel, externalLinkTarget = _this$props2.externalLinkTarget;
      _this.linkService.setViewer(_this.viewer);
      _this.linkService.setExternalLinkRel(externalLinkRel);
      _this.linkService.setExternalLinkTarget(externalLinkTarget);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onSourceSuccess", function() {
      var onSourceSuccess = _this.props.onSourceSuccess;
      if (onSourceSuccess)
        onSourceSuccess();
    });
    _defineProperty$7(_assertThisInitialized(_this), "onSourceError", function(error3) {
      warning$1(error3);
      var onSourceError = _this.props.onSourceError;
      if (onSourceError)
        onSourceError(error3);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadSuccess", function() {
      var onLoadSuccess = _this.props.onLoadSuccess;
      var pdf2 = _this.state.pdf;
      if (onLoadSuccess)
        onLoadSuccess(pdf2);
      _this.pages = new Array(pdf2.numPages);
      _this.linkService.setDocument(pdf2);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadError", function(error3) {
      _this.setState({
        pdf: false
      });
      warning$1(error3);
      var onLoadError = _this.props.onLoadError;
      if (onLoadError)
        onLoadError(error3);
    });
    _defineProperty$7(_assertThisInitialized(_this), "findDocumentSource", function() {
      return new Promise(function(resolve) {
        var file = _this.props.file;
        if (!file) {
          resolve(null);
        }
        if (typeof file === "string") {
          if (isDataURI(file)) {
            var fileByteString = dataURItoByteString(file);
            resolve({
              data: fileByteString
            });
          }
          displayCORSWarning();
          resolve({
            url: file
          });
        }
        if (file instanceof PDFDataRangeTransport) {
          resolve({
            range: file
          });
        }
        if (isArrayBuffer(file)) {
          resolve({
            data: file
          });
        }
        if (isBrowser$1) {
          if (isBlob(file) || isFile$1(file)) {
            loadFromFile(file).then(function(data2) {
              resolve({
                data: data2
              });
            });
            return;
          }
        }
        invariant$1(_typeof$6(file) === "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object");
        invariant$1(file.url || file.data || file.range, "Invalid parameter object: need either .data, .range or .url");
        if (typeof file.url === "string") {
          if (isDataURI(file.url)) {
            var url = file.url, otherParams = _objectWithoutProperties$3(file, _excluded);
            var _fileByteString = dataURItoByteString(url);
            resolve(_objectSpread$7({
              data: _fileByteString
            }, otherParams));
          }
          displayCORSWarning();
        }
        resolve(file);
      });
    });
    _defineProperty$7(_assertThisInitialized(_this), "registerPage", function(pageIndex, ref) {
      _this.pages[pageIndex] = ref;
    });
    _defineProperty$7(_assertThisInitialized(_this), "unregisterPage", function(pageIndex) {
      delete _this.pages[pageIndex];
    });
    return _this;
  }
  _createClass$d(Document2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadDocument();
      this.setupLinkService();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var file = this.props.file;
      if (file !== prevProps.file) {
        this.loadDocument();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelRunningTask(this.runningTask);
      if (this.loadingTask)
        this.loadingTask.destroy();
    }
  }, {
    key: "childContext",
    get: function get2() {
      var linkService = this.linkService, registerPage = this.registerPage, unregisterPage = this.unregisterPage;
      var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, renderMode = _this$props3.renderMode, rotate = _this$props3.rotate;
      var pdf2 = this.state.pdf;
      return {
        imageResourcesPath,
        linkService,
        pdf: pdf2,
        registerPage,
        renderMode,
        rotate,
        unregisterPage
      };
    }
  }, {
    key: "eventProps",
    get: function get2() {
      var _this2 = this;
      return makeEventProps(this.props, function() {
        return _this2.state.pdf;
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.props.children;
      return /* @__PURE__ */ jsx(DocumentContext.Provider, {
        value: this.childContext,
        children
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var file = this.props.file;
      var pdf2 = this.state.pdf;
      if (!file) {
        var noData = this.props.noData;
        return /* @__PURE__ */ jsx(Message$2, {
          type: "no-data",
          children: typeof noData === "function" ? noData() : noData
        });
      }
      if (pdf2 === null) {
        var loading = this.props.loading;
        return /* @__PURE__ */ jsx(Message$2, {
          type: "loading",
          children: typeof loading === "function" ? loading() : loading
        });
      }
      if (pdf2 === false) {
        var error3 = this.props.error;
        return /* @__PURE__ */ jsx(Message$2, {
          type: "error",
          children: typeof error3 === "function" ? error3() : error3
        });
      }
      return this.renderChildren();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props, className = _this$props4.className, inputRef = _this$props4.inputRef;
      return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({
        className: mergeClassNames("react-pdf__Document", className),
        ref: inputRef
      }, this.eventProps), {
        children: this.renderContent()
      }));
    }
  }]);
  return Document2;
}(PureComponent);
Document$1.defaultProps = {
  error: "Failed to load PDF file.",
  loading: "Loading PDF\u2026",
  noData: "No PDF file specified.",
  onPassword: function onPassword(callback, reason) {
    switch (reason) {
      case PasswordResponses.NEED_PASSWORD: {
        var password = prompt("Enter the password to open this PDF file.");
        callback(password);
        break;
      }
      case PasswordResponses.INCORRECT_PASSWORD: {
        var _password = prompt("Invalid password. Please try again.");
        callback(_password);
        break;
      }
    }
  }
};
var isFunctionOrNode$1 = PropTypes.oneOfType([PropTypes.func, PropTypes.node]);
Document$1.propTypes = _objectSpread$7(_objectSpread$7({}, eventProps), {}, {
  children: PropTypes.node,
  className: isClassName,
  error: isFunctionOrNode$1,
  externalLinkRel: PropTypes.string,
  externalLinkTarget: PropTypes.string,
  file: isFile,
  imageResourcesPath: PropTypes.string,
  inputRef: isRef,
  loading: isFunctionOrNode$1,
  noData: isFunctionOrNode$1,
  onItemClick: PropTypes.func,
  onLoadError: PropTypes.func,
  onLoadProgress: PropTypes.func,
  onLoadSuccess: PropTypes.func,
  onPassword: PropTypes.func,
  onSourceError: PropTypes.func,
  onSourceSuccess: PropTypes.func,
  rotate: PropTypes.number
});
var isDestination = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.any)]);
({
  item: PropTypes.shape({
    dest: isDestination,
    items: PropTypes.arrayOf(PropTypes.shape({
      dest: isDestination,
      title: PropTypes.string
    })),
    title: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  pdf: isPdf.isRequired
});
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source2), true).forEach(function(key) {
      _defineProperty$7(target, key, source2[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2)) : ownKeys$1(Object(source2)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
    });
  }
  return target;
}
_objectSpread$6({
  className: isClassName,
  inputRef: isRef,
  onItemClick: PropTypes.func,
  onLoadError: PropTypes.func,
  onLoadSuccess: PropTypes.func,
  pdf: isPdf
}, eventProps);
function mergeRefs() {
  for (var _len = arguments.length, inputRefs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputRefs[_key] = arguments[_key];
  }
  var filteredInputRefs = inputRefs.filter(Boolean);
  if (filteredInputRefs.length <= 1) {
    return filteredInputRefs[0];
  }
  return function mergedRefs(ref) {
    filteredInputRefs.forEach(function(inputRef) {
      if (typeof inputRef === "function") {
        inputRef(ref);
      } else {
        inputRef.current = ref;
      }
    });
  };
}
var PageContext = /* @__PURE__ */ createContext(null);
function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var ANNOTATION_MODE = pdf.exports.AnnotationMode;
var PageCanvasInternal = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(PageCanvasInternal2, _PureComponent);
  var _super = _createSuper$5(PageCanvasInternal2);
  function PageCanvasInternal2() {
    var _this;
    _classCallCheck$f(this, PageCanvasInternal2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "canvasElement", /* @__PURE__ */ createRef());
    _defineProperty$7(_assertThisInitialized(_this), "onRenderSuccess", function() {
      _this.renderer = null;
      var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale2 = _this$props.scale;
      if (onRenderSuccess)
        onRenderSuccess(makePageCallback(page, scale2));
    });
    _defineProperty$7(_assertThisInitialized(_this), "onRenderError", function(error3) {
      if (isCancelException(error3)) {
        return;
      }
      warning$1(error3);
      var onRenderError = _this.props.onRenderError;
      if (onRenderError)
        onRenderError(error3);
    });
    _defineProperty$7(_assertThisInitialized(_this), "drawPageOnCanvas", function() {
      var canvas = _this.canvasElement.current;
      if (!canvas) {
        return null;
      }
      var _assertThisInitialize = _assertThisInitialized(_this), renderViewport = _assertThisInitialize.renderViewport, viewport = _assertThisInitialize.viewport;
      var _this$props2 = _this.props, canvasBackground = _this$props2.canvasBackground, page = _this$props2.page, renderForms = _this$props2.renderForms;
      canvas.width = renderViewport.width;
      canvas.height = renderViewport.height;
      canvas.style.width = "".concat(Math.floor(viewport.width), "px");
      canvas.style.height = "".concat(Math.floor(viewport.height), "px");
      var renderContext = {
        annotationMode: renderForms ? ANNOTATION_MODE.ENABLE_FORMS : ANNOTATION_MODE.ENABLE,
        get canvasContext() {
          return canvas.getContext("2d");
        },
        viewport: renderViewport
      };
      if (canvasBackground) {
        renderContext.background = canvasBackground;
      }
      _this.cancelRenderingTask();
      _this.renderer = page.render(renderContext);
      return _this.renderer.promise.then(_this.onRenderSuccess)["catch"](_this.onRenderError);
    });
    return _this;
  }
  _createClass$d(PageCanvasInternal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawPageOnCanvas();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props, canvasBackground = _this$props3.canvasBackground, page = _this$props3.page, renderForms = _this$props3.renderForms;
      if (canvasBackground !== prevProps.canvasBackground || renderForms !== prevProps.renderForms) {
        page.cleanup();
        this.drawPageOnCanvas();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRenderingTask();
      var canvas = this.canvasElement.current;
      if (canvas) {
        canvas.width = 0;
        canvas.height = 0;
      }
    }
  }, {
    key: "cancelRenderingTask",
    value: function cancelRenderingTask() {
      if (this.renderer) {
        this.renderer.cancel();
        this.renderer = null;
      }
    }
  }, {
    key: "renderViewport",
    get: function get2() {
      var _this$props4 = this.props, page = _this$props4.page, rotate = _this$props4.rotate, scale2 = _this$props4.scale;
      var pixelRatio = getPixelRatio();
      return page.getViewport({
        scale: scale2 * pixelRatio,
        rotation: rotate
      });
    }
  }, {
    key: "viewport",
    get: function get2() {
      var _this$props5 = this.props, page = _this$props5.page, rotate = _this$props5.rotate, scale2 = _this$props5.scale;
      return page.getViewport({
        scale: scale2,
        rotation: rotate
      });
    }
  }, {
    key: "render",
    value: function render() {
      var canvasRef = this.props.canvasRef;
      return /* @__PURE__ */ jsx("canvas", {
        className: "react-pdf__Page__canvas",
        dir: "ltr",
        ref: mergeRefs(canvasRef, this.canvasElement),
        style: {
          display: "block",
          userSelect: "none"
        }
      });
    }
  }]);
  return PageCanvasInternal2;
}(PureComponent);
PageCanvasInternal.propTypes = {
  canvasBackground: PropTypes.string,
  canvasRef: isRef,
  onRenderError: PropTypes.func,
  onRenderSuccess: PropTypes.func,
  page: isPage.isRequired,
  renderForms: PropTypes.bool,
  rotate: isRotate,
  scale: PropTypes.number.isRequired
};
function PageCanvas(props) {
  return /* @__PURE__ */ jsx(PageContext.Consumer, {
    children: function(context2) {
      return /* @__PURE__ */ jsx(PageCanvasInternal, __spreadValues(__spreadValues({}, context2), props));
    }
  });
}
function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var PageSVGInternal = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(PageSVGInternal2, _PureComponent);
  var _super = _createSuper$4(PageSVGInternal2);
  function PageSVGInternal2() {
    var _this;
    _classCallCheck$f(this, PageSVGInternal2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "state", {
      svg: null
    });
    _defineProperty$7(_assertThisInitialized(_this), "onRenderSuccess", function() {
      _this.renderer = null;
      var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale2 = _this$props.scale;
      if (onRenderSuccess)
        onRenderSuccess(makePageCallback(page, scale2));
    });
    _defineProperty$7(_assertThisInitialized(_this), "onRenderError", function(error3) {
      if (isCancelException(error3)) {
        return;
      }
      warning$1(error3);
      var onRenderError = _this.props.onRenderError;
      if (onRenderError)
        onRenderError(error3);
    });
    _defineProperty$7(_assertThisInitialized(_this), "renderSVG", function() {
      var page = _this.props.page;
      _this.renderer = page.getOperatorList();
      return _this.renderer.then(function(operatorList) {
        var svgGfx = new pdf.exports.SVGGraphics(page.commonObjs, page.objs);
        _this.renderer = svgGfx.getSVG(operatorList, _this.viewport).then(function(svg) {
          _this.setState({
            svg
          }, _this.onRenderSuccess);
        })["catch"](_this.onRenderError);
      })["catch"](_this.onRenderError);
    });
    _defineProperty$7(_assertThisInitialized(_this), "drawPageOnContainer", function(element) {
      var svg = _this.state.svg;
      if (!element || !svg) {
        return;
      }
      if (!element.firstElementChild) {
        element.appendChild(svg);
      }
      var _this$viewport = _this.viewport, width2 = _this$viewport.width, height2 = _this$viewport.height;
      svg.setAttribute("width", width2);
      svg.setAttribute("height", height2);
    });
    return _this;
  }
  _createClass$d(PageSVGInternal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderSVG();
    }
  }, {
    key: "viewport",
    get: function get2() {
      var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale2 = _this$props2.scale;
      return page.getViewport({
        scale: scale2,
        rotation: rotate
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$viewport2 = this.viewport, width2 = _this$viewport2.width, height2 = _this$viewport2.height;
      return /* @__PURE__ */ jsx("div", {
        className: "react-pdf__Page__svg",
        ref: function ref(_ref) {
          return _this2.drawPageOnContainer(_ref);
        },
        style: {
          display: "block",
          backgroundColor: "white",
          overflow: "hidden",
          width: width2,
          height: height2,
          userSelect: "none"
        }
      });
    }
  }]);
  return PageSVGInternal2;
}(PureComponent);
PageSVGInternal.propTypes = {
  onRenderError: PropTypes.func,
  onRenderSuccess: PropTypes.func,
  page: isPage.isRequired,
  rotate: isRotate,
  scale: PropTypes.number.isRequired
};
function PageSVG(props) {
  return /* @__PURE__ */ jsx(PageContext.Consumer, {
    children: function(context2) {
      return /* @__PURE__ */ jsx(PageSVGInternal, __spreadValues(__spreadValues({}, context2), props));
    }
  });
}
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var TextLayerItemInternal = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(TextLayerItemInternal2, _PureComponent);
  var _super = _createSuper$3(TextLayerItemInternal2);
  function TextLayerItemInternal2() {
    var _this;
    _classCallCheck$f(this, TextLayerItemInternal2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "itemElement", /* @__PURE__ */ createRef());
    _defineProperty$7(_assertThisInitialized(_this), "getElementWidth", function(element) {
      var _assertThisInitialize = _assertThisInitialized(_this), sideways = _assertThisInitialize.sideways;
      return element.getBoundingClientRect()[sideways ? "height" : "width"];
    });
    return _this;
  }
  _createClass$d(TextLayerItemInternal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.alignTextItem();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.alignTextItem();
    }
  }, {
    key: "unrotatedViewport",
    get: function get2() {
      var _this$props = this.props, page = _this$props.page, scale2 = _this$props.scale;
      return page.getViewport({
        scale: scale2
      });
    }
  }, {
    key: "rotate",
    get: function get2() {
      var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
      return rotate - page.rotate;
    }
  }, {
    key: "sideways",
    get: function get2() {
      var rotate = this.rotate;
      return rotate % 180 !== 0;
    }
  }, {
    key: "defaultSideways",
    get: function get2() {
      var rotation = this.unrotatedViewport.rotation;
      return rotation % 180 !== 0;
    }
  }, {
    key: "fontSize",
    get: function get2() {
      var transform2 = this.props.transform;
      var defaultSideways = this.defaultSideways;
      var _transform = _slicedToArray$4(transform2, 2), fontHeightPx = _transform[0], fontWidthPx = _transform[1];
      return defaultSideways ? fontWidthPx : fontHeightPx;
    }
  }, {
    key: "top",
    get: function get2() {
      var transform2 = this.props.transform;
      var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
      var _transform2 = _slicedToArray$4(transform2, 6), offsetX = _transform2[2], offsetY = _transform2[3], x2 = _transform2[4], y2 = _transform2[5];
      var _viewport$viewBox = _slicedToArray$4(viewport.viewBox, 4), yMin = _viewport$viewBox[1], yMax = _viewport$viewBox[3];
      return defaultSideways ? x2 + offsetX + yMin : yMax - (y2 + offsetY);
    }
  }, {
    key: "left",
    get: function get2() {
      var transform2 = this.props.transform;
      var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
      var _transform3 = _slicedToArray$4(transform2, 6), x2 = _transform3[4], y2 = _transform3[5];
      var _viewport$viewBox2 = _slicedToArray$4(viewport.viewBox, 1), xMin = _viewport$viewBox2[0];
      return defaultSideways ? y2 - xMin : x2 - xMin;
    }
  }, {
    key: "getFontData",
    value: function getFontData(fontName) {
      var page = this.props.page;
      return new Promise(function(resolve) {
        page.commonObjs.get(fontName, resolve);
      });
    }
  }, {
    key: "alignTextItem",
    value: function alignTextItem() {
      var _this2 = this;
      var element = this.itemElement.current;
      if (!element) {
        return;
      }
      element.style.transform = "";
      var _this$props3 = this.props, fontName = _this$props3.fontName, scale2 = _this$props3.scale, width2 = _this$props3.width;
      element.style.fontFamily = "".concat(fontName, ", sans-serif");
      this.getFontData(fontName).then(function(fontData) {
        var fallbackFontName = fontData ? fontData.fallbackName : "sans-serif";
        element.style.fontFamily = "".concat(fontName, ", ").concat(fallbackFontName);
        var targetWidth = width2 * scale2;
        var actualWidth = _this2.getElementWidth(element);
        var transform2 = "scaleX(".concat(targetWidth / actualWidth, ")");
        var ascent = fontData ? fontData.ascent : 0;
        if (ascent) {
          transform2 += " translateY(".concat((1 - ascent) * 100, "%)");
        }
        element.style.transform = transform2;
        element.style.WebkitTransform = transform2;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var fontSize = this.fontSize, top2 = this.top, left2 = this.left;
      var _this$props4 = this.props, customTextRenderer = _this$props4.customTextRenderer, scale2 = _this$props4.scale, text = _this$props4.str;
      return /* @__PURE__ */ jsx("span", {
        ref: this.itemElement,
        style: {
          height: "1em",
          fontFamily: "sans-serif",
          fontSize: "".concat(fontSize * scale2, "px"),
          position: "absolute",
          top: "".concat(top2 * scale2, "px"),
          left: "".concat(left2 * scale2, "px"),
          transformOrigin: "left bottom",
          whiteSpace: "pre",
          pointerEvents: "all"
        },
        children: customTextRenderer ? customTextRenderer(this.props) : text
      });
    }
  }]);
  return TextLayerItemInternal2;
}(PureComponent);
TextLayerItemInternal.propTypes = {
  customTextRenderer: PropTypes.func,
  fontName: PropTypes.string.isRequired,
  itemIndex: PropTypes.number.isRequired,
  page: isPage.isRequired,
  rotate: isRotate,
  scale: PropTypes.number,
  str: PropTypes.string.isRequired,
  transform: PropTypes.arrayOf(PropTypes.number).isRequired,
  width: PropTypes.number.isRequired
};
function TextLayerItem(props) {
  return /* @__PURE__ */ jsx(PageContext.Consumer, {
    children: function(context2) {
      return /* @__PURE__ */ jsx(TextLayerItemInternal, __spreadValues(__spreadValues({}, context2), props));
    }
  });
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var TextLayerInternal = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(TextLayerInternal2, _PureComponent);
  var _super = _createSuper$2(TextLayerInternal2);
  function TextLayerInternal2() {
    var _this;
    _classCallCheck$f(this, TextLayerInternal2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "state", {
      textItems: null
    });
    _defineProperty$7(_assertThisInitialized(_this), "loadTextItems", function() {
      var page = _this.props.page;
      var cancellable = makeCancellablePromise(page.getTextContent());
      _this.runningTask = cancellable;
      cancellable.promise.then(function(_ref) {
        var textItems = _ref.items;
        _this.setState({
          textItems
        }, _this.onLoadSuccess);
      })["catch"](function(error3) {
        _this.onLoadError(error3);
      });
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadSuccess", function() {
      var onGetTextSuccess = _this.props.onGetTextSuccess;
      var textItems = _this.state.textItems;
      if (onGetTextSuccess)
        onGetTextSuccess(textItems);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadError", function(error3) {
      _this.setState({
        textItems: false
      });
      warning$1(error3);
      var onGetTextError = _this.props.onGetTextError;
      if (onGetTextError)
        onGetTextError(error3);
    });
    return _this;
  }
  _createClass$d(TextLayerInternal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var page = this.props.page;
      invariant$1(page, "Attempted to load page text content, but no page was specified.");
      this.loadTextItems();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var page = this.props.page;
      if (prevProps.page && page !== prevProps.page) {
        this.loadTextItems();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelRunningTask(this.runningTask);
    }
  }, {
    key: "unrotatedViewport",
    get: function get2() {
      var _this$props = this.props, page = _this$props.page, scale2 = _this$props.scale;
      return page.getViewport({
        scale: scale2
      });
    }
  }, {
    key: "rotate",
    get: function get2() {
      var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
      return rotate - page.rotate;
    }
  }, {
    key: "renderTextItems",
    value: function renderTextItems() {
      var textItems = this.state.textItems;
      if (!textItems) {
        return null;
      }
      return textItems.map(function(textItem, itemIndex) {
        return /* @__PURE__ */ jsx(TextLayerItem, __spreadValues({
          itemIndex
        }, textItem), itemIndex);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var viewport = this.unrotatedViewport, rotate = this.rotate;
      return /* @__PURE__ */ jsx("div", {
        className: "react-pdf__Page__textContent",
        style: {
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "".concat(viewport.width, "px"),
          height: "".concat(viewport.height, "px"),
          color: "transparent",
          transform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
          WebkitTransform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
          pointerEvents: "none"
        },
        children: this.renderTextItems()
      });
    }
  }]);
  return TextLayerInternal2;
}(PureComponent);
TextLayerInternal.propTypes = {
  onGetTextError: PropTypes.func,
  onGetTextSuccess: PropTypes.func,
  page: isPage.isRequired,
  rotate: isRotate,
  scale: PropTypes.number
};
function TextLayer(props) {
  return /* @__PURE__ */ jsx(PageContext.Consumer, {
    children: function(context2) {
      return /* @__PURE__ */ jsx(TextLayerInternal, __spreadValues(__spreadValues({}, context2), props));
    }
  });
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var AnnotationLayerInternal = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(AnnotationLayerInternal2, _PureComponent);
  var _super = _createSuper$1(AnnotationLayerInternal2);
  function AnnotationLayerInternal2() {
    var _this;
    _classCallCheck$f(this, AnnotationLayerInternal2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "state", {
      annotations: null
    });
    _defineProperty$7(_assertThisInitialized(_this), "layerElement", /* @__PURE__ */ createRef());
    _defineProperty$7(_assertThisInitialized(_this), "loadAnnotations", function() {
      var page = _this.props.page;
      var cancellable = makeCancellablePromise(page.getAnnotations());
      _this.runningTask = cancellable;
      cancellable.promise.then(function(annotations) {
        _this.setState({
          annotations
        }, _this.onLoadSuccess);
      })["catch"](function(error3) {
        _this.onLoadError(error3);
      });
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadSuccess", function() {
      var onGetAnnotationsSuccess = _this.props.onGetAnnotationsSuccess;
      var annotations = _this.state.annotations;
      if (onGetAnnotationsSuccess)
        onGetAnnotationsSuccess(annotations);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadError", function(error3) {
      _this.setState({
        annotations: false
      });
      warning$1(error3);
      var onGetAnnotationsError = _this.props.onGetAnnotationsError;
      if (onGetAnnotationsError)
        onGetAnnotationsError(error3);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onRenderSuccess", function() {
      var onRenderAnnotationLayerSuccess = _this.props.onRenderAnnotationLayerSuccess;
      if (onRenderAnnotationLayerSuccess)
        onRenderAnnotationLayerSuccess();
    });
    _defineProperty$7(_assertThisInitialized(_this), "onRenderError", function(error3) {
      warning$1(error3);
      var onRenderAnnotationLayerError = _this.props.onRenderAnnotationLayerError;
      if (onRenderAnnotationLayerError)
        onRenderAnnotationLayerError(error3);
    });
    return _this;
  }
  _createClass$d(AnnotationLayerInternal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var page = this.props.page;
      invariant$1(page, "Attempted to load page annotations, but no page was specified.");
      this.loadAnnotations();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props, page = _this$props.page, renderForms = _this$props.renderForms;
      if (prevProps.page && page !== prevProps.page || renderForms !== prevProps.renderForms) {
        this.loadAnnotations();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelRunningTask(this.runningTask);
    }
  }, {
    key: "viewport",
    get: function get2() {
      var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale2 = _this$props2.scale;
      return page.getViewport({
        scale: scale2,
        rotation: rotate
      });
    }
  }, {
    key: "renderAnnotationLayer",
    value: function renderAnnotationLayer() {
      var annotations = this.state.annotations;
      if (!annotations) {
        return;
      }
      var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, linkService = _this$props3.linkService, page = _this$props3.page, renderForms = _this$props3.renderForms;
      var viewport = this.viewport.clone({
        dontFlip: true
      });
      var parameters = {
        annotations,
        div: this.layerElement.current,
        imageResourcesPath,
        linkService,
        page,
        renderForms,
        viewport
      };
      this.layerElement.current.innerHTML = "";
      try {
        pdf.exports.AnnotationLayer.render(parameters);
        this.onRenderSuccess();
      } catch (error3) {
        this.onRenderError(error3);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */ jsx("div", {
        className: "react-pdf__Page__annotations annotationLayer",
        ref: this.layerElement,
        children: this.renderAnnotationLayer()
      });
    }
  }]);
  return AnnotationLayerInternal2;
}(PureComponent);
AnnotationLayerInternal.propTypes = {
  imageResourcesPath: PropTypes.string,
  linkService: isLinkService.isRequired,
  onGetAnnotationsError: PropTypes.func,
  onGetAnnotationsSuccess: PropTypes.func,
  onRenderAnnotationLayerError: PropTypes.func,
  onRenderAnnotationLayerSuccess: PropTypes.func,
  page: isPage,
  renderForms: PropTypes.bool,
  rotate: isRotate,
  scale: PropTypes.number
};
var AnnotationLayer = function AnnotationLayer2(props) {
  return /* @__PURE__ */ jsx(DocumentContext.Consumer, {
    children: function(documentContext) {
      return /* @__PURE__ */ jsx(PageContext.Consumer, {
        children: function(pageContext) {
          return /* @__PURE__ */ jsx(AnnotationLayerInternal, __spreadValues(__spreadValues(__spreadValues({}, documentContext), pageContext), props));
        }
      });
    }
  });
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source2), true).forEach(function(key) {
      _defineProperty$7(target, key, source2[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2)) : ownKeys(Object(source2)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result2);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var defaultScale = 1;
var PageInternal = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(PageInternal2, _PureComponent);
  var _super = _createSuper(PageInternal2);
  function PageInternal2() {
    var _this;
    _classCallCheck$f(this, PageInternal2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized(_this), "state", {
      page: null
    });
    _defineProperty$7(_assertThisInitialized(_this), "pageElement", /* @__PURE__ */ createRef());
    _defineProperty$7(_assertThisInitialized(_this), "onLoadSuccess", function() {
      var _this$props = _this.props, onLoadSuccess = _this$props.onLoadSuccess, registerPage = _this$props.registerPage;
      var page = _this.state.page;
      if (onLoadSuccess)
        onLoadSuccess(makePageCallback(page, _this.scale));
      if (registerPage)
        registerPage(_this.pageIndex, _this.pageElement.current);
    });
    _defineProperty$7(_assertThisInitialized(_this), "onLoadError", function(error3) {
      _this.setState({
        page: false
      });
      warning$1(error3);
      var onLoadError = _this.props.onLoadError;
      if (onLoadError)
        onLoadError(error3);
    });
    _defineProperty$7(_assertThisInitialized(_this), "loadPage", function() {
      var pdf2 = _this.props.pdf;
      var pageNumber = _this.getPageNumber();
      if (!pageNumber) {
        return;
      }
      _this.setState(function(prevState) {
        if (!prevState.page) {
          return null;
        }
        return {
          page: null
        };
      });
      var cancellable = makeCancellablePromise(pdf2.getPage(pageNumber));
      _this.runningTask = cancellable;
      cancellable.promise.then(function(page) {
        _this.setState({
          page
        }, _this.onLoadSuccess);
      })["catch"](function(error3) {
        _this.onLoadError(error3);
      });
    });
    return _this;
  }
  _createClass$d(PageInternal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pdf2 = this.props.pdf;
      invariant$1(pdf2, "Attempted to load a page, but no document was specified.");
      this.loadPage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pdf2 = this.props.pdf;
      if (prevProps.pdf && pdf2 !== prevProps.pdf || this.getPageNumber() !== this.getPageNumber(prevProps)) {
        var unregisterPage = this.props.unregisterPage;
        if (unregisterPage)
          unregisterPage(this.getPageIndex(prevProps));
        this.loadPage();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var unregisterPage = this.props.unregisterPage;
      if (unregisterPage)
        unregisterPage(this.pageIndex);
      cancelRunningTask(this.runningTask);
    }
  }, {
    key: "childContext",
    get: function get2() {
      var page = this.state.page;
      if (!page) {
        return {};
      }
      var _this$props2 = this.props, canvasBackground = _this$props2.canvasBackground, customTextRenderer = _this$props2.customTextRenderer, onGetAnnotationsError = _this$props2.onGetAnnotationsError, onGetAnnotationsSuccess = _this$props2.onGetAnnotationsSuccess, onGetTextError = _this$props2.onGetTextError, onGetTextSuccess = _this$props2.onGetTextSuccess, onRenderAnnotationLayerError = _this$props2.onRenderAnnotationLayerError, onRenderAnnotationLayerSuccess = _this$props2.onRenderAnnotationLayerSuccess, onRenderError = _this$props2.onRenderError, onRenderSuccess = _this$props2.onRenderSuccess, renderForms = _this$props2.renderForms, renderInteractiveForms = _this$props2.renderInteractiveForms;
      return {
        canvasBackground,
        customTextRenderer,
        onGetAnnotationsError,
        onGetAnnotationsSuccess,
        onGetTextError,
        onGetTextSuccess,
        onRenderAnnotationLayerError,
        onRenderAnnotationLayerSuccess,
        onRenderError,
        onRenderSuccess,
        page,
        renderForms: renderForms !== null && renderForms !== void 0 ? renderForms : renderInteractiveForms,
        rotate: this.rotate,
        scale: this.scale
      };
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      if (isProvided(props.pageNumber)) {
        return props.pageNumber - 1;
      }
      if (isProvided(props.pageIndex)) {
        return props.pageIndex;
      }
      return null;
    }
  }, {
    key: "getPageNumber",
    value: function getPageNumber() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      if (isProvided(props.pageNumber)) {
        return props.pageNumber;
      }
      if (isProvided(props.pageIndex)) {
        return props.pageIndex + 1;
      }
      return null;
    }
  }, {
    key: "pageIndex",
    get: function get2() {
      return this.getPageIndex();
    }
  }, {
    key: "pageNumber",
    get: function get2() {
      return this.getPageNumber();
    }
  }, {
    key: "rotate",
    get: function get2() {
      var rotate = this.props.rotate;
      if (isProvided(rotate)) {
        return rotate;
      }
      var page = this.state.page;
      if (!page) {
        return null;
      }
      return page.rotate;
    }
  }, {
    key: "scale",
    get: function get2() {
      var page = this.state.page;
      if (!page) {
        return null;
      }
      var _this$props3 = this.props, scale2 = _this$props3.scale, width2 = _this$props3.width, height2 = _this$props3.height;
      var rotate = this.rotate;
      var pageScale = 1;
      var scaleWithDefault = scale2 === null ? defaultScale : scale2;
      if (width2 || height2) {
        var viewport = page.getViewport({
          scale: 1,
          rotation: rotate
        });
        pageScale = width2 ? width2 / viewport.width : height2 / viewport.height;
      }
      return scaleWithDefault * pageScale;
    }
  }, {
    key: "eventProps",
    get: function get2() {
      var _this2 = this;
      return makeEventProps(this.props, function() {
        var page = _this2.state.page;
        if (!page) {
          return page;
        }
        return makePageCallback(page, _this2.scale);
      });
    }
  }, {
    key: "pageKey",
    get: function get2() {
      var page = this.state.page;
      return "".concat(page.pageIndex, "@").concat(this.scale, "/").concat(this.rotate);
    }
  }, {
    key: "pageKeyNoScale",
    get: function get2() {
      var page = this.state.page;
      return "".concat(page.pageIndex, "/").concat(this.rotate);
    }
  }, {
    key: "renderMainLayer",
    value: function renderMainLayer() {
      var _this$props4 = this.props, canvasRef = _this$props4.canvasRef, renderMode = _this$props4.renderMode;
      switch (renderMode) {
        case "none":
          return null;
        case "svg":
          return /* @__PURE__ */ jsx(PageSVG, {}, "".concat(this.pageKeyNoScale, "_svg"));
        case "canvas":
        default:
          return /* @__PURE__ */ jsx(PageCanvas, {
            canvasRef
          }, "".concat(this.pageKey, "_canvas"));
      }
    }
  }, {
    key: "renderTextLayer",
    value: function renderTextLayer() {
      var renderTextLayer2 = this.props.renderTextLayer;
      if (!renderTextLayer2) {
        return null;
      }
      return /* @__PURE__ */ jsx(TextLayer, {}, "".concat(this.pageKey, "_text"));
    }
  }, {
    key: "renderAnnotationLayer",
    value: function renderAnnotationLayer() {
      var renderAnnotationLayer2 = this.props.renderAnnotationLayer;
      if (!renderAnnotationLayer2) {
        return null;
      }
      return /* @__PURE__ */ jsx(AnnotationLayer, {}, "".concat(this.pageKey, "_annotations"));
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.props.children;
      return /* @__PURE__ */ jsxs(PageContext.Provider, {
        value: this.childContext,
        children: [this.renderMainLayer(), this.renderTextLayer(), this.renderAnnotationLayer(), children]
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var pageNumber = this.pageNumber;
      var pdf2 = this.props.pdf;
      var page = this.state.page;
      if (!pageNumber) {
        var noData = this.props.noData;
        return /* @__PURE__ */ jsx(Message$2, {
          type: "no-data",
          children: typeof noData === "function" ? noData() : noData
        });
      }
      if (pdf2 === null || page === null) {
        var loading = this.props.loading;
        return /* @__PURE__ */ jsx(Message$2, {
          type: "loading",
          children: typeof loading === "function" ? loading() : loading
        });
      }
      if (pdf2 === false || page === false) {
        var error3 = this.props.error;
        return /* @__PURE__ */ jsx(Message$2, {
          type: "error",
          children: typeof error3 === "function" ? error3() : error3
        });
      }
      return this.renderChildren();
    }
  }, {
    key: "render",
    value: function render() {
      var pageNumber = this.pageNumber;
      var _this$props5 = this.props, className = _this$props5.className, inputRef = _this$props5.inputRef;
      return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({
        className: mergeClassNames("react-pdf__Page", className),
        "data-page-number": pageNumber,
        ref: mergeRefs(inputRef, this.pageElement),
        style: {
          position: "relative"
        }
      }, this.eventProps), {
        children: this.renderContent()
      }));
    }
  }]);
  return PageInternal2;
}(PureComponent);
PageInternal.defaultProps = {
  error: "Failed to load the page.",
  loading: "Loading page\u2026",
  noData: "No page specified.",
  renderAnnotationLayer: true,
  renderForms: false,
  renderMode: "canvas",
  renderTextLayer: true,
  scale: defaultScale
};
var isFunctionOrNode = PropTypes.oneOfType([PropTypes.func, PropTypes.node]);
PageInternal.propTypes = _objectSpread$5(_objectSpread$5({}, eventProps), {}, {
  canvasBackground: PropTypes.string,
  children: PropTypes.node,
  className: isClassName,
  customTextRenderer: PropTypes.func,
  error: isFunctionOrNode,
  height: PropTypes.number,
  imageResourcesPath: PropTypes.string,
  inputRef: isRef,
  loading: isFunctionOrNode,
  noData: isFunctionOrNode,
  onGetTextError: PropTypes.func,
  onGetTextSuccess: PropTypes.func,
  onLoadError: PropTypes.func,
  onLoadSuccess: PropTypes.func,
  onRenderError: PropTypes.func,
  onRenderSuccess: PropTypes.func,
  pageIndex: isPageIndex,
  pageNumber: isPageNumber,
  pdf: isPdf,
  registerPage: PropTypes.func,
  renderAnnotationLayer: PropTypes.bool,
  renderForms: PropTypes.bool,
  renderInteractiveForms: PropTypes.bool,
  renderMode: isRenderMode,
  renderTextLayer: PropTypes.bool,
  rotate: isRotate,
  scale: PropTypes.number,
  unregisterPage: PropTypes.func,
  width: PropTypes.number
});
function Page(props, ref) {
  return /* @__PURE__ */ jsx(DocumentContext.Consumer, {
    children: function(context2) {
      return /* @__PURE__ */ jsx(PageInternal, __spreadValues(__spreadValues({
        ref
      }, context2), props));
    }
  });
}
var Page$1 = /* @__PURE__ */ React__default.forwardRef(Page);
displayWorkerWarning();
pdf.exports.GlobalWorkerOptions.workerSrc = "pdf.worker.js";
pdf.exports.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdf.exports.version}/pdf.worker.js`;
const CapturePreviewContainer = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
  box-sizing: border-box;
  padding: 50px;
  z-index: 100;

  @media only screen and (max-height: 480px) {
    width: 100vw;
    height: 100vh;
    padding: 0 50px 80px 50px;
  }

  &.desktop {
    top: 80px;
  }
`;
const CapturePreviewMessage = styled.div`
  display: flex;
  min-height: 25px;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
  min-width: 100px;
`;
const CapturePreviewMessageImage = styled.img`
  margin-right: 10px;
`;
const StyledDocument$1 = styled(Document$1)`
  border-radius: 14px;
  box-sizing: border-box;
  object-fit: contain;
  border: 8px solid #fff;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  transition: 0.4s linear;
  transition-property: border, border-color;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.22);
`;
const StyledPage$1 = styled(Page$1)`
  width: 100%;
  height: 100%;

  canvas {
    width: 100% !important;
    height: auto !important;
  }
`;
const CapturePreviewImageContainer = styled.div`
  max-width: 100%;
  max-height: 100%;
  height: auto;
  overflow: hidden;
  text-align: center;
  border-radius: 14px;
  flex: 1;
  padding: 7px;

  @media only screen and (max-height: 480px) {
    flex: unset;
  }

  &.error {
    img,
    ${StyledDocument$1} {
      border: 10px solid #ff5c6f;
    }
  }

  &.success {
    img,
    ${StyledDocument$1} {
      border: 10px solid #0aeda8;
    }
  }
`;
const CapturePreviewImage = styled.img`
  border-radius: 14px;
  box-sizing: border-box;
  object-fit: contain;
  border: 8px solid #fff;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  transition: 0.4s linear;
  transition-property: border, border-color;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.22);

  &.desktop {
    width: 687px;
    height: 440px;
  }
`;
const CapturePreviewUploadingContainer = styled.div`
  text-align: center;
  width: 100%;
`;
const CapturePreviewUploadingText = styled.p`
  margin: 10px 0;
  font-weight: bold;
`;
const CapturePreviewUploadingBarOutside = styled.div`
  width: 80%;
  height: 7px;
  background: #c6c6c6;
  margin: 0 auto;
  border-radius: 4px;
`;
const CapturePreviewUploadingProgress = styled.div`
  width: ${(props) => props.progress}%;
  height: 7px;
  border-radius: 4px;
  background: #3cb0f7;
  transition: 0.4s linear;
  transition-property: width, background-color;
`;
const CapturePreview = ({
  progress: progress2 = 0,
  finishCapture,
  captureSuccessful,
  onClose,
  message: message2 = "",
  fileType,
  imageBase64,
  isSelfie,
  isPassport,
  isPoa,
  isDesktop: isDesktop2 = false
}) => {
  const {
    t: t2
  } = useTranslation();
  const [text, setText] = useState(t2("notifications.couldntCapture"));
  useEffect(() => {
    const text2 = (() => {
      if (!finishCapture) {
        return t2("common.uploading");
      }
      if (!captureSuccessful) {
        if (isSelfie) {
          return t2("capturePreview.faceError");
        }
        if (isPassport) {
          return t2("capturePreview.passportError");
        }
        if (isPoa) {
          return t2("capturePreview.poaError");
        }
        return t2("capturePreview.idError");
      }
      return t2("capturePreview.success");
    })();
    setText(text2);
    if (finishCapture) {
      const timeout = setTimeout(() => {
        onClose(captureSuccessful);
      }, 1500);
      return () => clearInterval(timeout);
    }
  }, [finishCapture, captureSuccessful, isSelfie, isPassport, onClose, t2, isPoa]);
  return /* @__PURE__ */ jsxs(CapturePreviewContainer, {
    className: classNames({
      desktop: isDesktop2
    }),
    children: [/* @__PURE__ */ jsx(CapturePreviewMessage, {
      children: !captureSuccessful && message2 && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(CapturePreviewMessageImage, {
          src: warning$2,
          alt: "preview"
        }), /* @__PURE__ */ jsx("span", {
          children: message2
        })]
      })
    }), /* @__PURE__ */ jsx(CapturePreviewImageContainer, {
      className: classNames({
        [captureSuccessful == null ? "neutral" : captureSuccessful ? "success" : "error"]: true,
        desktop: isDesktop2
      }),
      children: fileType === "application/pdf" ? /* @__PURE__ */ jsx(StyledDocument$1, {
        file: imageBase64,
        children: /* @__PURE__ */ jsx(StyledPage$1, {
          pageNumber: 1
        })
      }) : imageBase64 && /* @__PURE__ */ jsx(CapturePreviewImage, {
        src: imageBase64,
        alt: "ID capture preview",
        className: classNames({
          desktop: isDesktop2
        })
      })
    }), /* @__PURE__ */ jsxs(CapturePreviewUploadingContainer, {
      children: [/* @__PURE__ */ jsx(CapturePreviewUploadingText, {
        children: text
      }), /* @__PURE__ */ jsx(CapturePreviewUploadingBarOutside, {
        children: /* @__PURE__ */ jsx(CapturePreviewUploadingProgress, {
          progress: progress2
        })
      })]
    })]
  });
};
var outFrame = "data:image/svg+xml;base64,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";
var glare = "data:image/svg+xml;base64,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";
var lens = "data:image/svg+xml;base64,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";
const BottomText = styled.p`
  font-size: 14px;
  font-weight: bold;
  padding-right: 0;
  text-align: center;

  button {
    background-color: transparent;
    color: #00b2fd;
    text-decoration: underline;
    border: none;
  }
`;
const ButtonContainer = styled.div`
  margin: 60px 0 30px 0;

  @media only screen and (max-height: 480px) {
    margin: 10px 0 20px 0;
  }
`;
const CommonIssuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
`;
const InstructionText = styled.p`
  flex: 1;
  text-align: left;
  margin: 0 0 0 21px;
`;
const Title$8 = styled.h1`
  font-size: 26px;
  line-height: 1.35;
  text-align: center;
  margin-bottom: 48px;

  @media only screen and (max-height: 480px) {
    margin-bottom: 10px;
  }
`;
const Instruction = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`;
const customStyles$1 = {
  content: {
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    display: "block"
  },
  overlay: {
    zIndex: 99999999999999
  }
};
function CommonIssuesModal(_h) {
  var _i = _h, {
    style,
    onClose,
    onOpenNativeCamera
  } = _i, props = __objRest(_i, [
    "style",
    "onClose",
    "onOpenNativeCamera"
  ]);
  const {
    t: t2
  } = useTranslation();
  const containerRef = useRef();
  const [, forceUpdate] = useState({});
  useLayoutEffect(() => {
    forceUpdate({});
  }, []);
  useEffect(() => {
    enableBodyScroll(document.getElementsByTagName("body")[0]);
    enableBodyScroll(document.getElementsByTagName("html")[0]);
    document.body.style.position = "unset";
    return () => {
      disableBodyScroll(document.getElementsByTagName("body")[0]);
      disableBodyScroll(document.getElementsByTagName("html")[0]);
      document.body.style.position = "fixed";
    };
  }, []);
  return /* @__PURE__ */ jsx(Modal, __spreadProps(__spreadValues({
    isOpen: true,
    style: customStyles$1,
    contentLabel: "CommonIssuesModal"
  }, props), {
    children: /* @__PURE__ */ jsxs(CommonIssuesContainer, {
      ref: containerRef,
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx(Instruction, {
          children: /* @__PURE__ */ jsx(Title$8, {
            children: t2("commonIssues.commonIssues")
          })
        }), /* @__PURE__ */ jsxs(Instruction, {
          children: [/* @__PURE__ */ jsx("img", {
            src: outFrame,
            alt: "out of frame"
          }), /* @__PURE__ */ jsx(InstructionText, {
            children: t2("commonIssues.idFar")
          })]
        }), /* @__PURE__ */ jsxs(Instruction, {
          children: [/* @__PURE__ */ jsx("img", {
            src: glare,
            alt: "sun meaning glare"
          }), /* @__PURE__ */ jsx(InstructionText, {
            children: t2("commonIssues.glare")
          })]
        }), /* @__PURE__ */ jsxs(Instruction, {
          children: [/* @__PURE__ */ jsx("img", {
            src: lens,
            alt: "Dirty lens"
          }), /* @__PURE__ */ jsx(InstructionText, {
            children: t2("commonIssues.cameraDirty")
          })]
        })]
      }), /* @__PURE__ */ jsx(ButtonContainer, {
        children: /* @__PURE__ */ jsx(Button$3, {
          onClick: onClose,
          children: t2("commonIssues.tryAgain")
        })
      }), mobile.any() && /* @__PURE__ */ jsxs(BottomText, {
        children: [t2("commonIssues.cameraNotWorking"), /* @__PURE__ */ jsx("button", {
          onClick: onOpenNativeCamera,
          children: t2("commonIssues.useNative")
        })]
      })]
    })
  }));
}
var CaptureButton = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NiIgaGVpZ2h0PSI3NiIgdmlld0JveD0iMCAwIDc2IDc2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMzgiIGN5PSIzOCIgcj0iMzciIGZpbGw9IiMwMDAiIG9wYWNpdHk9Ii41Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTM4IDc2QzE3LjAxMyA3NiAwIDU4Ljk4NyAwIDM4UzE3LjAxMyAwIDM4IDBzMzggMTcuMDEzIDM4IDM4LTE3LjAxMyAzOC0zOCAzOHptMC01YzE4LjIyNSAwIDMzLTE0Ljc3NSAzMy0zM1M1Ni4yMjUgNSAzOCA1IDUgMTkuNzc1IDUgMzhzMTQuNzc1IDMzIDMzIDMzeiIvPgogICAgICAgIDxjaXJjbGUgY3g9IjM4IiBjeT0iMzgiIHI9IjI1IiBmaWxsPSIjRkZGIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
var DesktopCaptureButton = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNzYiIHZpZXdCb3g9IjAgMCA3NiA3NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb24gLyBiaWcgLyBjYXB0dXJlIj4KPHBhdGggaWQ9IkNvbWJpbmVkIFNoYXBlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM4IDc2QzU4Ljk4NjggNzYgNzYgNTguOTg2OCA3NiAzOEM3NiAxNy4wMTMyIDU4Ljk4NjggMCAzOCAwQzE3LjAxMzIgMCAwIDE3LjAxMzIgMCAzOEMwIDU4Ljk4NjggMTcuMDEzMiA3NiAzOCA3NlpNMzggNzFDNTYuMjI1NCA3MSA3MSA1Ni4yMjU0IDcxIDM4QzcxIDE5Ljc3NDYgNTYuMjI1NCA1IDM4IDVDMTkuNzc0NiA1IDUgMTkuNzc0NiA1IDM4QzUgNTYuMjI1NCAxOS43NzQ2IDcxIDM4IDcxWiIgZmlsbD0iIzIwMjYzRCIvPgo8Y2lyY2xlIGlkPSJPdmFsIENvcHkgMiIgY3g9IjM4IiBjeT0iMzgiIHI9IjI4IiBmaWxsPSIjMjAyNjNEIi8+CjwvZz4KPC9zdmc+Cg==";
var questionsMaskIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDIzIDIzIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iIzIxMjczQiI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTU2LjUgN0M2Mi44NTEgNyA2OCAxMi4xNDkgNjggMTguNVM2Mi44NTEgMzAgNTYuNSAzMCA0NSAyNC44NTEgNDUgMTguNSA1MC4xNDkgNyA1Ni41IDd6bS0uMjYxIDE1LjE3NmMtLjg1MiAwLTEuNTMuNjQtMS41MyAxLjQyMVM1NS4zODggMjUgNTYuMjQgMjVjLjg1MSAwIDEuNTQ4LS42MjIgMS41NDgtMS40MDNzLS42OTctMS40Mi0xLjU0OC0xLjQyek01Ni40MzIgMTJDNTMuNTY4IDEyIDUyIDEzLjg0NyA1MiAxNS43NjVjMCAuMjY2LjAyLjU1LjA5Ny44bDIuNDM4LjA4OGMtLjA1OC0uMTYtLjA3Ny0uMzU1LS4wNzctLjU2OCAwLS45OTUuNi0yLjAwNyAxLjk3NC0yLjAwNyAxLjI5NyAwIDEuOTM2Ljc4MSAxLjkzNiAxLjU5OCAwIC41MzMtLjI1MiAxLjAxMy0uODMzIDEuNDAzbC0uOTI5LjY0Yy0xLjEwMy43NjMtMS41MjkgMS42MzMtMS41MjkgMi41NzUgMCAuMjY2LjA0LjQ5Ny4wNzguNzI4aDIuMDl2LS4xMDdjMC0uNzI4LjM2OC0xLjI3OCAxLjA0NS0xLjcyMmwuNzk0LS41MTVjMS4xNDItLjc0NiAxLjkxNi0xLjc0IDEuOTE2LTMuMTQ0QzYxIDEzLjc0IDU5LjQzMiAxMiA1Ni40MzIgMTJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzI5IC01NzkpIHRyYW5zbGF0ZSgyODQgNTcyKSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
var backIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgOCAxMiI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTcuNzgzIDUuNTMyTDEuNzIzLjE5MkMxLjU4My4wNjggMS4zOTYgMCAxLjE5NiAwUy44MS4wNjguNjcuMTkyTC4yMjMuNTg1Yy0uMjkuMjU2LS4yOS42NzIgMCAuOTI4bDUuMDg5IDQuNDg1LTUuMDk0IDQuNDg5Yy0uMTQuMTIzLS4yMTguMjg4LS4yMTguNDY0IDAgLjE3Ni4wNzcuMzQuMjE4LjQ2NGwuNDQ2LjM5M2MuMTQuMTI0LjMyNy4xOTIuNTI3LjE5MnMuMzg2LS4wNjguNTI2LS4xOTJsNi4wNjYtNS4zNDVjLjE0LS4xMjQuMjE3LS4yOS4yMTctLjQ2NSAwLS4xNzctLjA3Ny0uMzQyLS4yMTctLjQ2NnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MCAtNjYwKSBtYXRyaXgoLTEgMCAwIDEgNTggNjYwKSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
pdf.exports.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdf.exports.version}/pdf.worker.js`;
const Text$5 = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #20263d;
  padding: 0 30px;
`;
const Title$7 = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 35px;
  text-align: center;
  color: #20263d;
  margin: 0;
`;
const RetakeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  padding: 50px 0px;
  z-index: 99999999999999999;
`;
const ImageContainer$1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  overflow: hidden;
  text-align: center;
  flex: 1;
`;
const Image$8 = styled.img`
  border-radius: 15px;
  box-sizing: border-box;
  object-fit: contain;
  transition: 0.4s linear;
  transition-property: border, border-color;
  box-shadow: 0px 10px 8px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  object-fit: contain;
  max-width: 80%;
  max-height: 100%;
  width: auto;
  margin: auto;
`;
const ButtonsContainer$3 = styled.div`
  height: 20%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;
const RetakeButton = styled.button`
  background-color: transparent;
  width: 150px;
  height: 60px;
  font-size: 16px;
  font-weight: bolder;
  border: none;
  display: flex;
  flex-direction: row;
  max-width: 150px;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 350px) {
    font-size: 12px;
  }
`;
const CustomButton = styled(Button$3)`
  min-width: 175px;
  height: 60px;
  font-size: 16px;

  @media only screen and (max-width: 350px) {
    font-size: 12px;
    min-width: 160px;
  }
`;
const BackIconImg = styled.img`
  margin-right: 10px;
`;
const RetakeParagraph = styled.p`
  text-align: center;
`;
const StyledDocument = styled(Document$1)`
  width: 80%;
  height: 100%;
`;
const StyledPage = styled(Page$1)`
  width: 100%;
  height: 100%;

  canvas {
    width: 100% !important;
    height: auto !important;
  }
`;
function Retake({
  fileType,
  imageBase64,
  onClose,
  handleCapture,
  token
}) {
  const {
    t: t2
  } = useTranslation();
  function handleClick() {
    addEvent({
      token: token.token,
      eventName: "retakeContinue",
      eventData: {},
      eventType: "text"
    });
    handleCapture();
  }
  function handleClose() {
    addEvent({
      token: token.token,
      eventName: "retakeTryAgain",
      eventData: {},
      eventType: "text"
    });
    onClose();
  }
  return /* @__PURE__ */ jsxs(RetakeContainer, {
    className: "IncodeRetakeContainer",
    children: [/* @__PURE__ */ jsx(Title$7, {
      className: "IncodeRetakeTitle",
      children: t2("retake.title")
    }), /* @__PURE__ */ jsx(Text$5, {
      className: "IncodeRetakeSubtitle",
      children: t2("retake.instructions")
    }), /* @__PURE__ */ jsx(ImageContainer$1, {
      className: "IncodeRetakeImageContainer",
      children: fileType === "application/pdf" ? /* @__PURE__ */ jsx(StyledDocument, {
        file: imageBase64,
        children: /* @__PURE__ */ jsx(StyledPage, {
          pageNumber: 1
        })
      }) : /* @__PURE__ */ jsx(Image$8, {
        className: "IncodeRetakeImage",
        src: imageBase64,
        alt: "proof of address"
      })
    }), /* @__PURE__ */ jsxs(ButtonsContainer$3, {
      className: "IncodeRetakeButtonsContainer",
      children: [/* @__PURE__ */ jsxs(RetakeButton, {
        className: "IncodeRetakeButton",
        onClick: handleClose,
        children: [/* @__PURE__ */ jsx(BackIconImg, {
          src: backIcon,
          alt: "back"
        }), " ", /* @__PURE__ */ jsx(RetakeParagraph, {
          children: t2("common.retake")
        })]
      }), /* @__PURE__ */ jsx(CustomButton, {
        className: "IncodeRetakeContinueContainer",
        onClick: handleClick,
        children: t2("common.continue")
      })]
    })]
  });
}
var idLetters = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MjgiIHZpZXdCb3g9IjAgMCA0MCA0MjgiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBmb250LWZhbWlseT0iQ2lyY3VsYXJTdGQtQm9sZCwgQ2lyY3VsYXIgU3RkIiBmb250LXNpemU9IjE1IiBmb250LXdlaWdodD0iYm9sZCIgbGV0dGVyLXNwYWNpbmc9Ii4xIiBvcGFjaXR5PSIuMiI+CiAgICAgICAgPGcgZmlsbD0iIzAwMCI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHRleHQgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMwMSAtMTk4KSB0cmFuc2xhdGUoMzAxIDE5OC41KSByb3RhdGUoLTkwIDkuNSAyMTMuNSkiPgogICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSItMjA0IiB5PSIyMTkiPlogWCAmbHQ7ICZsdDsgWCBaIFggWiBYIFogWCBaIFggWiBYICZsdDsgWiBYIFogWCBaIFggWiBYIFogJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7IDwvdHNwYW4+CiAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICA8dGV4dCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzAxIC0xOTgpIHRyYW5zbGF0ZSgzMDEgMTk4LjUpIHJvdGF0ZSgtOTAgMzAuNSAyMTUpIj4KICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iLTE4MS41IiB5PSIyMjAuNSI+WiBYIFogWCBaIFggWiBYIFogWCBaIFggWiBYIFogWCBaIFggWiBYIFogWCAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDs8L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
var id$1 = "data:image/png;base64,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";
const {
  width: width$1,
  height: height$1,
  top: top$1,
  left: left$1
} = getMaskPosition();
const PassportMaskContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: ${width$1}px;
  height: ${height$1}px;
  top: ${top$1}px;
  left: ${left$1}px;
  position: absolute;
`;
const pulseFirstBorder = Ue`
  0% {
    border: 7.5px white solid;
  }

  100% {
    border: 7.5px transparent solid;
  }
`;
const pulseSecondBorder = Ue`
  0% {
    border-top: 7.5px solid white;
    border-right: 7.5px solid white;
    border-bottom: 7.5px solid white;
  }

  100% {
    border-top: 7.5px transparent solid;
    border-right: 7.5px transparent solid;
    border-bottom: 7.5px transparent solid;
  }
`;
const Table = styled.table`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border-spacing: 0;
  box-shadow: 0 0 0 300px rgba(0, 0, 0, 0.75);

  &.mask-animate-stop {
    #first,
    #second {
      animation-name: none;
    }

    #first {
      border: 7.5px white solid;
    }

    #second {
      border-top: 7.5px solid white;
      border-right: 7.5px solid white;
      border-bottom: 7.5px solid white;
    }
  }

  &.mask-green {
    #first {
      border: 7.5px rgb(9, 237, 168) solid;
    }

    #second {
      border-top: 7.5px solid rgb(8, 230, 173);
      border-right: 7.5px solid rgb(8, 230, 173);
      border-bottom: 7.5px solid rgb(8, 230, 173);
    }
  }

  &.mask-blue {
    #first {
      border: 7.5px solid rgb(0, 135, 226);
    }

    #second {
      border-top: 7.5px solid rgb(0, 135, 226);
      border-right: 7.5px solid rgb(0, 135, 226);
      border-bottom: 7.5px solid rgb(0, 135, 226);
    }
  }

  &.mask-red {
    #first {
      border: 7.5px rgb(255, 99, 123) solid;
    }

    #second {
      border-top: 7.5px solid rgb(255, 99, 123);
      border-right: 7.5px solid rgb(255, 99, 123);
      border-bottom: 7.5px solid rgb(255, 99, 123);
    }
  }

  #first {
    width: 70%;
    border-radius: 5px 0 0 5px;
    animation-name: ${pulseFirstBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
    animation-delay: 0.01s;
    border: 7.5px solid white;
  }

  #second {
    width: 30%;
    border-radius: 0 5px 5px 0;
    animation-name: ${pulseSecondBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
    animation-delay: 0.01s;
    border-top: 7.5px solid white;
    border-right: 7.5px solid white;
    border-bottom: 7.5px solid white;
  }
`;
const Image$7 = styled.img`
  width: 80%;
  position: absolute;
  bottom: 15px;
  right: 15px;
`;
const ImageLetters = styled.img`
  height: 95%;
`;
function PassportMask(props) {
  return /* @__PURE__ */ jsx(PassportMaskContainer, {
    children: /* @__PURE__ */ jsxs(Table, {
      cellSpacing: "0",
      className: classNames({
        [`mask-${props.frame}`]: true,
        "mask-animate-stop": props.animate
      }),
      children: [props.children, /* @__PURE__ */ jsx("tbody", {
        children: /* @__PURE__ */ jsxs("tr", {
          children: [/* @__PURE__ */ jsx("td", {
            id: "first",
            style: {
              position: "relative"
            },
            children: /* @__PURE__ */ jsx(Image$7, {
              src: id$1
            })
          }), /* @__PURE__ */ jsx("td", {
            id: "second",
            align: "center",
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              backgroundOrigin: "padding-box"
            },
            children: /* @__PURE__ */ jsx(ImageLetters, {
              src: idLetters
            })
          })]
        })
      })]
    })
  });
}
const {
  width,
  height,
  top,
  left
} = getMaskPosition();
const pulseBorder = Ue`
  0% {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px transparent;
  }

  100% {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }
`;
const MaskContainer = styled.canvas`
  position: fixed;
  border-radius: 15px;
  width: ${width}px;
  height: ${height}px;
  top: ${top}px;
  left: ${left}px;

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    animation-name: ${pulseBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;

    .sc-fznKkj {
      animation-name: none;
    }
  }
`;
const MaskContainerHorizontal = styled.canvas`
  position: fixed;
  border-radius: 15px;
  width: ${window.innerWidth - 2 * window.innerWidth / 20}px;
  height: ${window.innerHeight / 3}px;
  top: ${(props) => props.top}px;
  left: ${window.innerWidth / 20}px;

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    animation-name: ${pulseBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }
`;
const MaskBarcode = styled.canvas`
  position: fixed;
  border-radius: 15px;
  width: ${window.innerWidth / 2}px;
  height: ${height - 50}px;
  top: 10%;
  left: 200px;
  transform: translate(-50%, 0);

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    animation-name: ${pulseBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;

    .sc-fznKkj {
      animation-name: none;
    }
  }
`;
const DesktopMask = styled.canvas`
  position: fixed;
  border-radius: 15px;
  height: 638px;
  width: 1016px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    animation-name: ${pulseBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;

    .sc-fznKkj {
      animation-name: none;
    }
  }
`;
function Mask(_j) {
  var _k = _j, {
    showBorders = true,
    percentage,
    type
  } = _k, props = __objRest(_k, [
    "showBorders",
    "percentage",
    "type"
  ]);
  if (!props.show)
    return null;
  if (type === "horizontal") {
    return /* @__PURE__ */ jsx(MaskContainerHorizontal, {
      top: props.top,
      className: classNames({
        [`mask-${props.frame}`]: true,
        "mask-animate-stop": !props.animate
      }),
      children: props.children
    });
  } else if (type === "passport") {
    return /* @__PURE__ */ jsx(PassportMask, __spreadValues({}, props));
  } else if (type === "desktop") {
    return /* @__PURE__ */ jsx(DesktopMask, __spreadValues({
      className: classNames({
        [`mask-${props.frame}`]: true,
        "mask-animate-stop": !props.animate
      })
    }, props));
  } else if (type === "vertical") {
    return /* @__PURE__ */ jsx(MaskContainer, {
      className: classNames({
        [`mask-${props.frame}`]: true,
        "mask-animate-stop": !props.animate
      }),
      children: props.children
    });
  } else if (type === "barcode") {
    return /* @__PURE__ */ jsx(MaskBarcode, {
      top: props.top,
      className: classNames({
        [`mask-${props.frame}`]: true,
        "mask-animate-stop": !props.animate
      }),
      children: props.children
    });
  } else {
    return null;
  }
}
async function generateSessionRecordingUploadUrl({
  token,
  type
}) {
  return api.get("/omni/generateSessionRecordingUploadUrl", null, {
    params: { type },
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
const isMediaRecorderSupported = typeof MediaRecorder !== "undefined";
function useMediaRecorder({ token, type }) {
  const mediaRecorderRef = useRef();
  const recordedChunksRef = useRef([]);
  const isRecordingRef = useRef(false);
  const uploadVideo = useCallback(async () => {
    const { current: recordedChunks } = recordedChunksRef;
    const file = new Blob(recordedChunks, { type: "video/webm" });
    const { url } = await generateSessionRecordingUploadUrl({
      token,
      type
    });
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: {
        "x-ms-blob-type": "BlockBlob"
      }
    });
  }, [token, type]);
  const startRecording = useCallback(async (stream) => {
    if (!isMediaRecorderSupported)
      return;
    const mediaRecorder = new MediaRecorder(stream, {
      audioBitsPerSecond: 1e3,
      videoBitsPerSecond: 1e3
    });
    const { current: recordedChunks } = recordedChunksRef;
    function handleStop(event) {
      uploadVideo();
    }
    function handleDataAvailable(event) {
      if (event.data && event.data.size > 0) {
        recordedChunks.push(event.data);
      }
    }
    mediaRecorder.onstop = handleStop;
    mediaRecorder.ondataavailable = handleDataAvailable;
    mediaRecorder.start(5e3);
    mediaRecorderRef.current = mediaRecorder;
    isRecordingRef.current = true;
  }, [uploadVideo]);
  const stopRecording = useCallback(async () => {
    if (!isMediaRecorderSupported)
      return;
    if (isRecordingRef.current === false)
      return;
    const { current: mediaRecorder } = mediaRecorderRef;
    mediaRecorder.stop();
  }, []);
  return { startRecording, stopRecording, uploadVideo };
}
var welcomeLogo$1 = "data:image/svg+xml;base64,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";
const DesktopHeaderContainer = styled.header`
  display: flex;
  position: absolute;
  width: 100%;
  height: 80px;
  top: 0;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.06);

  &.selfie {
    position: unset;
    z-index: 999;
  }
`;
const Logo$1 = styled.img`
  height: 40px;
`;
const DesktopHeader = ({
  logoSrc = welcomeLogo$1,
  className
}) => {
  return /* @__PURE__ */ jsx(DesktopHeaderContainer, {
    className,
    children: /* @__PURE__ */ jsx(Logo$1, {
      src: logoSrc,
      alt: "logo"
    })
  });
};
const QuestionMarkImg = styled.img`
  margin-left: 5px;
`;
const NativeButton = styled.button`
  background-color: #ffffff;
  border-radius: 7px;
  bottom: 15px;
  color: #21273b;
  display: flex;
  font-size: 11px;
  font-weight: bold;
  height: 37px;
  padding: 5px 7px 6px 9px;
  position: fixed;
  right: 15px;
  z-index: 99999;
  line-height: normal;
  border: none;
`;
const moveIn$2 = Ue`
  0% {
    bottom: -200px;
  }

  80% {
    bottom: 6%;
  }

  100% {
    bottom: 5%;
  }
`;
const fadeIn = Ue`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
const FakeButton$2 = styled.div`
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  animation: ${moveIn$2} 1s ease-in forwards;
`;
const FakeButtonMessage = styled.div`
  opacity: 0;
  animation: ${fadeIn} 1s ease-in 0.5s forwards;
  border: 2px solid transparent;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  color: white;
  min-width: 200px;
  white-space: pre-wrap;
  margin-bottom: 20px;
  position: relative;
`;
const FakeButtonArrowDown = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid black;
  bottom: -12px;
  width: 0;
  opacity: 0.5;
  height: 0;
`;
const FakeButtonImage = styled.img`
  width: 75px;
  margin: auto;
`;
const CanvasId = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
`;
const CaptureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f9faff;
`;
const WebcamContainer$1 = styled.div`
  border: 8px solid #e9e9eb;
  border-radius: 36px;
  overflow: hidden;
  max-width: 687px;
  max-height: 440px;

  width: 100%;
  height: 100%;

  &.neutral {
    border: 8px solid #00b2fd;
  }

  &.error {
    border: 8px solid #ff5c6f;
  }

  &.success {
    border: 8px solid #0cd5a2;
  }
`;
const TakenPicture = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const CaptureFeedback = styled.h2`
  position: absolute;
  bottom: 50px;
`;
const SLEEP_DURATION = 2e3;
let manualCaptureTimeout;
let showFillRectangleNorificationTimeout;
function getIdType(type, onlyFront) {
  if (type === "back") {
    return "BackId";
  }
  if (onlyFront) {
    return "Passport";
  }
  return "FrontId";
}
function CaptureId({
  getInstructionsNotification = emptyFunc,
  shouldTakeIdAgain = emptyFunc,
  type,
  onBoarding,
  onError,
  onSuccess,
  numberOfTries,
  onLog,
  onlyFront,
  permission,
  setPermission,
  permissionMessage,
  permissionBackgroundColor,
  token,
  sendBase64,
  stream,
  onOpenNativeCamera,
  onlyCapture,
  timeout = 18e3,
  showCustomCameraPermissionScreen,
  isRetry,
  isSecondId,
  hideRetake,
  isRecordingEnabled = false,
  onRestartOnboarding,
  showDoublePermissionsRequest,
  isCreditCard,
  isCreditCardBack,
  disableFullScreen
}) {
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const [frame2, setFrame] = useState("white");
  const [isManualCapture, setIsManualCapture] = useState(false);
  const [progress2, setProgress] = useState(0);
  const [captureSuccessful, setCaptureSuccessful] = useState(null);
  const [finishCapture, setFinishCapture] = useState(false);
  const [imageBase64, setImageBase64] = useState("");
  const [, setImageCropped] = useState("");
  const [showCapturePreview, setShowCapturePreview] = useState(false);
  const [, setIsGreen] = useState(false);
  const [, setIsBlue] = useState(false);
  const [timesCaptureFailed, setTimesCaptureFailed] = useState(0);
  const [uploadError, setUploadError] = useState(false);
  const [, setShowLoader] = useState(false);
  const [didMount, setDidMount] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [mask, setMask] = useState(false);
  const [top2, setTop] = useState(null);
  const [show2, setShow] = useState(false);
  const [openCommonIssuesModal, setOpenCommonIssuesModal] = useState(false);
  const [retakeState, setRetakeState] = useState({
    isOpen: false,
    imageBase64: null
  });
  const responseRef = useRef(null);
  const pdf417IsDetectingRef = useRef(true);
  const {
    t: t2
  } = useTranslation();
  const {
    showNotification: showNotification2,
    showPriorityNotification,
    closeNotification: closeNotification2
  } = useNotifications();
  const {
    startRecording,
    stopRecording
  } = useMediaRecorder({
    token: sessionToken,
    type: `${type}Id`
  });
  const lowEnd = getBackend() === "wasm";
  const {
    notificationMessage,
    notificationVariant
  } = getInstructionsNotification(lowEnd);
  const webcam = useRef(null);
  const {
    isRotated
  } = useOrientation();
  const showNativeCamera = !isWebRtcSupported();
  const showWebCam = !showNativeCamera;
  const idType = getIdType(type, onlyFront);
  const handleOpenNativeCamera = useCallback(() => {
    showPriorityNotification(/* @__PURE__ */ jsx("div", {
      style: {
        textAlign: "center"
      },
      children: /* @__PURE__ */ jsx("div", {
        children: t2("notifications.switchToNative")
      })
    }), "skip");
    sleep(3e3).then(() => {
      onOpenNativeCamera();
    });
  }, [onOpenNativeCamera, showPriorityNotification, t2]);
  useEffect(() => {
    document.body.style.position = "fixed";
    return () => document.body.style.position = "unset";
  }, []);
  useEffect(() => {
    return () => stopRecording == null ? void 0 : stopRecording();
  }, [stopRecording]);
  const activeManualCapture = useCallback((handleMaskChange2) => {
    closeNotification2();
    onBoarding.stopDetect();
    pdf417IsDetectingRef.current = false;
    setIsManualCapture(true);
    setShow(true);
    setMask(false);
    onLog(getLogObject("manualCaptureOn", {}));
    clearTimeout(manualCaptureTimeout);
    clearTimeout(showFillRectangleNorificationTimeout);
    addEvent({
      token: sessionToken,
      eventName: `switchToManualCapture${idType}`,
      eventData: {
        [`manualCapture${idType}`]: true
      },
      eventType: "text"
    });
  }, [closeNotification2, idType, onBoarding, onLog, sessionToken]);
  useEffect(() => {
    if (!mobile.isDesktop())
      return;
    if (finishCapture) {
      const timeout2 = setTimeout(() => {
        handleCloseCapturePreview(captureSuccessful);
      }, 1500);
      return () => clearInterval(timeout2);
    }
  }, [finishCapture, resetShowRetake, captureSuccessful]);
  useEffect(() => {
    if (isManualCapture || !manualCaptureTimeout) {
      return;
    }
    if (isRotated) {
      clearTimeout(manualCaptureTimeout);
    } else {
      manualCaptureTimeout = setTimeout(activeManualCapture, timeout);
    }
  }, [isRotated, isManualCapture, timeout, activeManualCapture, handleOpenNativeCamera]);
  useEffect(() => {
    return () => {
      clearTimeout(manualCaptureTimeout);
    };
  }, []);
  const autoDetectID = useCallback(async () => {
    const handleIDNotDetected = () => {
      onLog(getLogObject("IDNotDetected", {
        message: `${t2("notifications.couldntCapture")}`
      }));
      showPriorityNotification(notificationMessage, notificationVariant);
    };
    const handleShadow = () => {
      showNotification2(/* @__PURE__ */ jsx("div", {
        style: {
          textAlign: "center"
        },
        children: /* @__PURE__ */ jsx("div", {
          children: t2("notifications.shadowDetected")
        })
      }), "shadow");
    };
    const handleGlare = (change) => {
      if (change) {
        showPriorityNotification(/* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: t2("notifications.glareDetectedChange")
          })
        }), "Focus");
      } else {
        showPriorityNotification(/* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: t2("notifications.glareDetected")
          })
        }), "Focus");
      }
    };
    const handleSharpness = (change) => {
      if (change) {
        showPriorityNotification(/* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: t2("notifications.outOfFocusChange")
          })
        }), "Focus");
      } else {
        showPriorityNotification(/* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: t2("notifications.outOfFocus")
          })
        }), "Focus");
      }
    };
    const canvas = document.getElementById("canvasFrame");
    const canvasId = document.getElementById("canvasId");
    if (!manualCaptureTimeout) {
      manualCaptureTimeout = setTimeout(activeManualCapture, timeout);
    }
    const handleCapturing = async (photo, frameBase64) => {
      const photoCopy = photo.canvasElement.toDataURL().split(",")[1];
      closeNotification2();
      setFrame("blue");
      setIsBlue(true);
      clearTimeout(manualCaptureTimeout);
      clearTimeout(showFillRectangleNorificationTimeout);
      onBoarding.stopDetect();
      showPriorityNotification(/* @__PURE__ */ jsxs("div", {
        style: {
          textAlign: "center"
        },
        children: [/* @__PURE__ */ jsx("div", {
          children: t2("notifications.dontMove")
        }), /* @__PURE__ */ jsx("div", {
          children: t2("notifications.takingPhoto")
        })]
      }), "dontMove");
      await sleep(SLEEP_DURATION);
      closeNotification2();
      if (frameBase64) {
        handleCapture(frameBase64);
        return;
      }
      const lastFrame = await onBoarding.detectFrame(webcam.current);
      if (lastFrame != null) {
        handleCapture(lastFrame);
      } else {
        handleCapture(photoCopy);
      }
    };
    onBoarding.detect({
      canvas,
      canvasId,
      type,
      webcam: webcam.current,
      onFarAway: handleFarAway,
      onTooClose: handleTooClose,
      onCapturing: handleCapturing,
      onIDNotDetected: handleIDNotDetected,
      onNothingHappen: emptyFunc,
      onShadows: handleShadow,
      onGlare: handleGlare,
      onBlur: handleSharpness,
      forceManualCapture: activeManualCapture,
      onMaskChange: handleMaskChange,
      scanPdf417: false
    });
    onBoarding.resumeDetect();
  }, [onBoarding, onLog, showNotification2, showPriorityNotification, t2, type, activeManualCapture]);
  useEffect(() => {
    if (uploadError) {
      setUploadError(false);
      if (!isManualCapture) {
        autoDetectID();
      }
    }
  }, [autoDetectID, isManualCapture, uploadError]);
  useEffect(() => {
    setDidMount(true);
    return () => {
      setDidMount(false);
      onBoarding.stopDetect();
      if (stream) {
        return;
      }
      if (webcam.current && webcam.current.mediaStreamTrack) {
        webcam.current.mediaStreamTrack.stop();
      }
    };
  }, [onBoarding, stream]);
  useEffect(() => {
    addEvent({
      token: sessionToken,
      eventName: `camera${idType}`,
      eventData: {
        [`camera${idType}`]: true
      },
      eventType: "text"
    });
  }, [idType, sessionToken]);
  const skipCapture = async (cb2) => {
    showNotification2(/* @__PURE__ */ jsxs("div", {
      style: {
        textAlign: "center"
      },
      children: [/* @__PURE__ */ jsx("div", {
        children: t2("notifications.couldntCapture")
      }), /* @__PURE__ */ jsx("div", {
        children: t2("notifications.verifyLater")
      })]
    }), "skip");
    await sleep(SLEEP_DURATION);
    onLog(getLogObject("noAttemps", {
      response: responseRef.current,
      message: "No attempt left"
    }));
    closeNotification2();
    if (cb2) {
      cb2();
    }
  };
  const onboardingUpdate = async ({
    key,
    value,
    onProgress
  }) => {
    try {
      await onBoarding.updateSession({
        token: sessionToken,
        key,
        value,
        onProgress
      });
      setShowLoader(false);
    } catch (error3) {
      setShowLoader(false);
    }
  };
  const idUploadError = () => {
    setShowLoader(false);
    closeNotification2();
    setTimesCaptureFailed(timesCaptureFailed + 1);
    setIsGreen(false);
    if (numberOfTries !== -1 && timesCaptureFailed + 1 >= numberOfTries) {
      onboardingUpdate({
        key: "manualIdCheckNeeded",
        value: true
      });
      return skipCapture(() => onError({
        type: "skip"
      }));
    }
    setUploadError(true);
  };
  const idUploadSuccess = () => {
    setShowLoader(false);
    setIsGreen(false);
    setUploadError(false);
    closeNotification2();
    onLog(getLogObject("successCapture", {
      response: responseRef.current
    }));
    onSuccess(responseRef.current);
    return true;
  };
  const getImages2 = (width2, height2, scaleFactor) => {
    return webcam.current.getImageData(width2, height2);
  };
  const toBlob2 = (base64) => {
    const binary = atob(base64);
    const array = [];
    for (let i2 = 0; i2 < binary.length; i2++) {
      array.push(binary.charCodeAt(i2));
    }
    return new Blob([new Uint8Array(array)]);
  };
  const startLoading = () => {
    setShowCapturePreview(true);
  };
  const handleUploadingProgress = setProgress;
  const handleCapture = throttle$1(async (photo) => {
    clearTimeout(manualCaptureTimeout);
    manualCaptureTimeout = void 0;
    if (!webcam.current) {
      return;
    }
    resetShowRetake();
    addEvent({
      token: sessionToken,
      eventName: isManualCapture ? `manualCapture${idType}` : `capture${idType}`,
      eventData: {
        [`manualCapture${idType}`]: true
      },
      eventType: "text"
    });
    const imageBase642 = photo ? photo : getImages2(webcam.current.video.videoWidth, webcam.current.video.videoHeight).canvasElement.toDataURL().split(",")[1];
    startLoading();
    const blob = toBlob2(imageBase642);
    const src2 = URL.createObjectURL(blob);
    if (onlyCapture) {
      return onSuccess({
        imageBase64: imageBase642,
        blob,
        src: src2
      });
    }
    setImageBase64(src2);
    if (isCreditCard || isCreditCardBack) {
      const {
        success
      } = await isCreditCard ? await onBoarding.addCreditCardFront({
        token: sessionToken,
        base64Image: imageBase642
      }) : await onBoarding.addCreditCardBack({
        token: sessionToken,
        base64Image: imageBase642
      });
      if (success) {
        setCaptureSuccessful(true);
        await sleep(SLEEP_DURATION);
        setFrame("white");
      } else {
        onLog(getLogObject("attemptFailed", {
          message,
          reason: errorKey,
          attempt: timesCaptureFailed + 1
        }));
        setCaptureSuccessful(false);
        setErrorMessage("error");
        await sleep(SLEEP_DURATION);
        setFrame("white");
        if (!isManualCapture && !lowEnd) {
          handleMaskChange(false, false);
        }
      }
      setFinishCapture(true);
      setProgress(100);
    } else {
      await onBoarding.capture({
        token: sessionToken,
        image: sendBase64 ? imageBase642 : blob,
        type,
        onProgress: handleUploadingProgress,
        sendBase64,
        onlyFront,
        isRetry,
        isSecondId
      }).then(async (response) => {
        const imgResponse = await onBoarding.getImages({
          token: sessionToken,
          body: {
            images: ["croppedIDFace"]
          }
        });
        responseRef.current = __spreadValues(__spreadProps(__spreadValues({}, response), {
          originalImage: imageBase642,
          frontIdImage: imgResponse.croppedIDFace
        }), imgResponse);
        const {
          status,
          message: message2,
          errorKey: errorKey2
        } = shouldTakeIdAgain(response);
        if (status) {
          onLog(getLogObject("attemptFailed", {
            response: responseRef.current,
            message: message2,
            reason: errorKey2,
            attempt: timesCaptureFailed + 1
          }));
          setCaptureSuccessful(false);
          setErrorMessage(message2);
          await sleep(SLEEP_DURATION);
          setFrame("white");
          if (!isManualCapture && !lowEnd) {
            handleMaskChange(false, false);
          }
        } else {
          setImageCropped(imgResponse.croppedFace);
          setCaptureSuccessful(true);
          await sleep(SLEEP_DURATION);
          setFrame("white");
        }
        setFinishCapture(true);
      }).catch(async (error3) => {
        const {
          message: message2,
          errorKey: errorKey2
        } = shouldTakeIdAgain(error3.response.data);
        onLog(getLogObject("attemptFailed", {
          response: error3.response.data,
          message: message2,
          reason: errorKey2,
          attempt: timesCaptureFailed + 1
        }));
        setErrorMessage(message2);
        setCaptureSuccessful(false);
        setProgress(100);
        setFinishCapture(true);
        await sleep(SLEEP_DURATION);
        setFrame("white");
      });
    }
  }, 300);
  const showInstructions = async () => {
    if (lowEnd || onlyFront)
      handleMaskChange(true, false);
    onBoarding.stopDetect();
    showPriorityNotification(notificationMessage, notificationVariant);
    if (!isManualCapture) {
      await sleep(SLEEP_DURATION);
      autoDetectID();
    }
  };
  const handleMaskChange = (show22, mask2, top22) => {
    if (isManualCapture) {
      return;
    }
    setShow(show22);
    setMask(mask2);
    setTop(top22);
  };
  const handleFarAway = (classification, glare2, sharpness, position, classificationValue, glareValue, sharpnessValue, positionValue) => {
    showPriorityNotification(/* @__PURE__ */ jsx("div", {
      style: {
        textAlign: "center"
      },
      children: /* @__PURE__ */ jsx("div", {
        children: t2("notifications.fitOverlay")
      })
    }), "");
  };
  const handleTooClose = () => {
    showPriorityNotification(/* @__PURE__ */ jsx("div", {
      style: {
        textAlign: "center"
      },
      children: /* @__PURE__ */ jsx("div", {
        children: t2("notifications.fitOverlay")
      })
    }), "");
  };
  const handleCloseCapturePreview = (error3) => {
    if (!error3) {
      idUploadError();
    } else {
      idUploadSuccess();
    }
    if (!isManualCapture) {
      onBoarding.resumeDetect();
    }
    setErrorMessage("");
    setShowCapturePreview(false);
    setProgress(0);
    setFinishCapture(false);
    setCaptureSuccessful(null);
    setFrame("white");
  };
  const handlePlay = () => {
    if (isManualCapture)
      return;
    showInstructions();
  };
  function toggleModal() {
    if (openCommonIssuesModal) {
      onBoarding.resumeDetect();
      autoDetectID();
      addEvent({
        token: sessionToken,
        eventName: `commonIssuesClosed`,
        eventData: {},
        eventType: "text"
      });
    } else {
      addEvent({
        token: sessionToken,
        eventName: `commonIssuesOpened`,
        eventData: {},
        eventType: "text"
      });
      onBoarding.stopDetect();
    }
    setOpenCommonIssuesModal(!openCommonIssuesModal);
  }
  function handleManualCapture() {
    if (numberOfTries !== -1 && timesCaptureFailed >= numberOfTries)
      return;
    const image2 = getImages2(webcam.current.video.videoWidth, webcam.current.video.videoHeight).canvasElement.toDataURL();
    if (hideRetake) {
      handleCapture(image2.split(".")[1]);
    } else {
      setRetakeState({
        isOpen: true,
        imageBase64: image2
      });
    }
  }
  function resetShowRetake() {
    setRetakeState({
      isOpen: false,
      imageBase64: null
    });
  }
  if (!didMount) {
    return null;
  }
  const getMaskType = () => {
    if (!mobile.any()) {
      return "desktop";
    } else if (mask) {
      return "horizontal";
    } else if (onlyFront) {
      return "passport";
    } else {
      return "vertical";
    }
  };
  const maskType = getMaskType();
  if (onBoarding.isDesktop()) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("h1", {
        children: /* @__PURE__ */ jsx(Notification$1, {
          inline: false,
          center: true,
          noPortal: disableFullScreen
        })
      }), !showCapturePreview && /* @__PURE__ */ jsxs(NativeButton, {
        onClick: toggleModal,
        children: [/* @__PURE__ */ jsxs(Trans, {
          t: t2,
          i18nKey: "commonIssues.needHelp",
          children: ["Need ", /* @__PURE__ */ jsx("br", {}), " Help"]
        }), /* @__PURE__ */ jsx(QuestionMarkImg, {
          src: questionsMaskIcon,
          alt: "question mark"
        })]
      }), openCommonIssuesModal && /* @__PURE__ */ jsx(CommonIssuesModal, {
        onClose: toggleModal,
        onOpenNativeCamera
      }), showWebCam && /* @__PURE__ */ jsx(Fragment, {
        children: /* @__PURE__ */ jsxs(CaptureContainer, {
          children: [/* @__PURE__ */ jsxs(WebcamContainer$1, {
            className: classNames({
              [!showCapturePreview ? "" : captureSuccessful == null ? "neutral" : captureSuccessful ? "success" : "error"]: true
            }),
            children: [showCapturePreview ? /* @__PURE__ */ jsx(TakenPicture, {
              src: imageBase64
            }) : /* @__PURE__ */ jsxs(Fragment, {
              children: [/* @__PURE__ */ jsx(WebcamWithChooseCamera, {
                ref: webcam,
                onPlay: handlePlay,
                videoSource: "environment",
                permission,
                setPermission,
                permissionMessage,
                permissionBackgroundColor,
                onLog,
                stream,
                onError,
                onBoarding,
                token: sessionToken,
                showCustomCameraPermissionScreen,
                onStreamReady: isRecordingEnabled ? startRecording : void 0,
                onRestartOnboarding,
                showDoublePermissionsRequest
              }), /* @__PURE__ */ jsx(CanvasId, {
                id: "canvasId"
              })]
            }), /* @__PURE__ */ jsx("span", {
              className: "step__video-overlay"
            }), isManualCapture && retakeState.isOpen && /* @__PURE__ */ jsx(Retake, {
              imageBase64: retakeState.imageBase64,
              onClose: resetShowRetake,
              handleCapture: () => handleCapture(retakeState.imageBase64.split(",")[1]),
              token: {
                token: sessionToken
              }
            })]
          }), isManualCapture && !showCapturePreview && /* @__PURE__ */ jsxs(FakeButton$2, {
            children: [/* @__PURE__ */ jsxs(FakeButtonMessage, {
              children: [`${t2("captureInstructions.step1")} 
 ${t2("captureInstructions.step2")}`, /* @__PURE__ */ jsx(FakeButtonArrowDown, {})]
            }), /* @__PURE__ */ jsx(FakeButtonImage, {
              src: DesktopCaptureButton,
              alt: "capture button",
              onClick: () => handleManualCapture()
            })]
          }), showCapturePreview && /* @__PURE__ */ jsx(CaptureFeedback, {
            children: errorMessage ? errorMessage : t2("desktopHome.uploading")
          })]
        })
      }), /* @__PURE__ */ jsx("canvas", {
        id: "canvasFrame"
      })]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [!showCapturePreview && /* @__PURE__ */ jsxs(NativeButton, {
      onClick: toggleModal,
      children: [/* @__PURE__ */ jsxs(Trans, {
        t: t2,
        i18nKey: "commonIssues.needHelp",
        children: ["Need ", /* @__PURE__ */ jsx("br", {}), " Help"]
      }), /* @__PURE__ */ jsx(QuestionMarkImg, {
        src: questionsMaskIcon,
        alt: "question mark"
      })]
    }), openCommonIssuesModal && /* @__PURE__ */ jsx(CommonIssuesModal, {
      onClose: toggleModal,
      onOpenNativeCamera
    }), showWebCam && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(WebcamWithChooseCamera, {
        ref: webcam,
        onPlay: handlePlay,
        videoSource: "environment",
        permission,
        setPermission,
        permissionMessage,
        permissionBackgroundColor,
        onLog,
        stream,
        onError,
        onBoarding,
        token: sessionToken,
        showCustomCameraPermissionScreen,
        onStreamReady: isRecordingEnabled ? startRecording : void 0,
        onRestartOnboarding,
        showDoublePermissionsRequest
      }), /* @__PURE__ */ jsx(Mask, {
        show: show2,
        top: top2,
        frame: frame2,
        animate: !isManualCapture,
        type: maskType
      }), /* @__PURE__ */ jsx(CanvasId, {
        id: "canvasId"
      }), isManualCapture && retakeState.isOpen && /* @__PURE__ */ jsx(Retake, {
        imageBase64: retakeState.imageBase64,
        onClose: resetShowRetake,
        handleCapture: () => handleCapture(retakeState.imageBase64.split(",")[1]),
        token: {
          token: sessionToken
        }
      }), isManualCapture && /* @__PURE__ */ jsxs(FakeButton$2, {
        children: [/* @__PURE__ */ jsxs(FakeButtonMessage, {
          children: [`${t2("captureInstructions.step1")} 
 ${t2("captureInstructions.step2")}`, /* @__PURE__ */ jsx(FakeButtonArrowDown, {})]
        }), /* @__PURE__ */ jsx(FakeButtonImage, {
          src: CaptureButton,
          alt: "capture button",
          onClick: () => handleManualCapture()
        })]
      }), showCapturePreview && /* @__PURE__ */ jsx(CapturePreview, {
        message: errorMessage,
        progress: progress2,
        finishCapture,
        captureSuccessful,
        onClose: handleCloseCapturePreview,
        imageBase64,
        isSelfie: false,
        isPassport: onlyFront
      }), /* @__PURE__ */ jsx("span", {
        className: "step__video-overlay"
      }), /* @__PURE__ */ jsx(Notification$1, {
        inline: false,
        center: true
      })]
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame"
    })]
  });
}
const CaptureIdWithChooseCamera = (props) => {
  const [deviceId, setDeviceId] = useState(sessionStorage.getItem("deviceId"));
  function handleCameraChosen(deviceId2) {
    setDeviceId(deviceId2);
    sessionStorage.setItem("deviceId", deviceId2);
  }
  if (mobile.any()) {
    return /* @__PURE__ */ jsx(CaptureId, __spreadValues({}, props));
  }
  return deviceId ? /* @__PURE__ */ jsx(CaptureId, __spreadProps(__spreadValues({}, props), {
    deviceId
  })) : /* @__PURE__ */ jsx(ChooseCamera, {
    onCameraChosen: handleCameraChosen
  });
};
const TutorialContainer$2 = styled.div`
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const TutorialHeader$1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(var(--vh) * 30);
  padding: 25px 10px 10px 10px;
  text-align: center;

  .blue {
    color: ${(props) => props.theme.main};
  }

  .blue.IncodeHighlightedText {
    display: inline;
  }

  h1 {
    display: block;
    font-size: 25px;
    line-height: 1.2;
  }

  span {
    font-size: 15px;
    line-height: 22px;
  }

  h1 span {
    font-weight: bold;
    font-size: 28px;
  }

  @media only screen and (max-height: 600px) {
    padding: 0;

    h1 {
      display: inline-block;
      font-size: 20px;
      margin-bottom: 5px;
      width: 100%;
    }

    span {
      font-family: 'CircularStd-Medium';
      font-size: 14px;
      display: inline-block;
    }

    h1 span {
      font-weight: bold;
      font-size: 24px;
    }
  }
`;
const ImageContainer = styled.div`
  height: calc(var(--vh) * 50);

  &.isCreditCard {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
const Image$6 = styled.img`
  height: auto;
  max-height: 100%;
  width: auto;
  max-width: 100%;

  &.isCreditCard {
    padding-top: 0;
    width: 100%;
    height: auto;
    max-height: 100%;
    background-color: #e0e8eb;
    padding: 40px 70px;
    border-radius: 5px;
  }

  &.isCreditCard {
    padding-top: 0;
    width: 100%;
    height: auto;
    max-height: 100%;
    background-color: #e0e8eb;
    padding: 40px 70px;
    border-radius: 5px;
  }
`;
const TutorialAction$2 = styled.div`
  height: calc(var(--vh) * 20);
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 992px) {
    margin-bottom: 0;
    margin-top: 15px;
  }
`;
const StyledButton$2 = styled(Button$3)`
  height: 58px;
  margin-top: 12px;
  line-height: 1.5px;

  &.button-hidden {
    display: none;
  }
`;
function Tutorial$1({
  src: src2,
  next,
  header,
  selfie,
  noWait = false,
  children,
  type,
  disabledButton = false,
  creditCard
}) {
  const [showButton, setShowButton] = useState(noWait);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    const showButtonCallback = () => {
      if (showButton === false) {
        setShowButton(true);
      }
    };
    const id2 = setTimeout(showButtonCallback, 100);
    return () => clearTimeout(id2);
  }, [showButton]);
  return /* @__PURE__ */ jsxs(TutorialContainer$2, {
    children: [/* @__PURE__ */ jsx(TutorialHeader$1, {
      className: classNames("IncodeTutorialHeaderContainer", `IncodeTutorialHeaderContainer${type}`),
      children: header
    }), /* @__PURE__ */ jsx(ImageContainer, {
      className: classNames({
        isCreditCard: creditCard
      }),
      children: /* @__PURE__ */ jsx(Image$6, {
        className: classNames("IncodeTutorialVideo", `IncodeTutorialVideo${type}`, {
          isSelfie: selfie,
          isCreditCard: creditCard
        }),
        src: src2
      })
    }), /* @__PURE__ */ jsx(TutorialAction$2, {
      className: classNames("IncodeTutorialButtonContainer", `IncodeTutorialButtonContainer${type}`),
      children: children || /* @__PURE__ */ jsx(StyledButton$2, {
        className: classNames("IncodeTutorialButton", `IncodeTutorialButton${type}`, {
          "button-hidden": !showButton
        }),
        disabled: disabledButton,
        onClick: next,
        children: t2("common.continue")
      })
    })]
  });
}
const LabelButton$2 = styled.label`
  ${buttonStyles}
  height: 62px;
  margin-top: 20px;
  display: none;
  justify-content: center;
  align-items: center;

  &.showInput {
    display: flex;
  }
`;
LabelButton$2.defaultProps = {
  theme: theme$1
};
function UploadInput$1({
  token,
  onBoarding,
  type,
  shouldTakeIdAgain = emptyFunc,
  onError,
  onSuccess,
  onLog,
  numberOfTries,
  showInput,
  onlyFront
}) {
  const [progress2, setProgress] = useState(0);
  const [timesCaptureFailed, setTimesCaptureFailed] = useState(0);
  const [captureSuccessful, setCaptureSuccessful] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [finishCapture, setFinishCapture] = useState(false);
  const [showCapturePreview, setShowCapturePreview] = useState(false);
  const [imageBase64, setImageBase64] = useState("");
  const idType = getIdType(type, onlyFront);
  const responseRef = useRef(null);
  const {
    t: t2
  } = useTranslation();
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const skipCapture = (cb2 = emptyFunc) => {
    onLog(getLogObject("noAttemps", {
      response: responseRef.current,
      message: "No attempt left"
    }));
    cb2();
  };
  const idUploadError = () => {
    setTimesCaptureFailed(timesCaptureFailed + 1);
    if (numberOfTries !== -1 && timesCaptureFailed + 1 >= numberOfTries) {
      onBoarding.updateSession({
        token: sessionToken,
        key: "manualIdCheckNeeded",
        value: true
      });
      return skipCapture(() => onError("skip"));
    }
  };
  const idUploadSuccess = () => {
    onLog(getLogObject("successCapture", {
      response: responseRef.current
    }));
    onSuccess(responseRef.current);
    return true;
  };
  const handleCloseCapturePreview = (error3) => {
    if (!error3) {
      idUploadError();
    } else {
      idUploadSuccess();
    }
    setErrorMessage("");
    setShowCapturePreview(false);
    setProgress(0);
    setFinishCapture(false);
    setCaptureSuccessful(null);
  };
  async function handleChange(ev) {
    setShowCapturePreview(true);
    const {
      imageBase64: imgBase64
    } = await getScaledImageFromFile(ev.target.files[0]);
    setImageBase64(imgBase64);
    try {
      addEvent({
        token: sessionToken,
        eventName: `nativeCapture${idType}`,
        eventData: {
          [`nativeCapture${idType}`]: true
        },
        eventType: "text"
      });
      const response = await onBoarding.capture({
        token: sessionToken,
        image: imgBase64.split(",")[1],
        type,
        onProgress: setProgress,
        sendBase64: true,
        onlyFront: false
      });
      const imgResponse = await onBoarding.getImages({
        token: sessionToken,
        body: {
          images: ["croppedIDFace"]
        }
      });
      responseRef.current = __spreadValues(__spreadProps(__spreadValues({}, response), {
        originalImage: imgBase64,
        frontIdImage: imgResponse.croppedIDFace
      }), imgResponse);
      const {
        status,
        message: message2,
        errorKey: errorKey2
      } = shouldTakeIdAgain(response);
      if (status) {
        onLog(getLogObject("attemptFailed", {
          response: responseRef.current,
          message: message2,
          reason: errorKey2,
          attempt: timesCaptureFailed + 1
        }));
        setCaptureSuccessful(false);
        setErrorMessage(message2);
        await sleep(SLEEP_DURATION);
      } else {
        setCaptureSuccessful(true);
        await sleep(SLEEP_DURATION);
      }
      setFinishCapture(true);
      setProgress(100);
    } catch (e2) {
      setCaptureSuccessful(false);
      setProgress(100);
      setFinishCapture(true);
      await sleep(SLEEP_DURATION);
    }
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(LabelButton$2, {
      className: classNames({
        showInput
      }),
      children: [/* @__PURE__ */ jsx("input", {
        style: {
          display: "none"
        },
        type: "file",
        accept: "image/*",
        capture: "environment",
        onChange: handleChange
      }), /* @__PURE__ */ jsx("span", {
        children: t2("common.takePhoto")
      })]
    }), showCapturePreview && /* @__PURE__ */ jsx(CapturePreview, {
      message: errorMessage,
      progress: progress2,
      finishCapture,
      captureSuccessful,
      onClose: handleCloseCapturePreview,
      imageBase64,
      isSelfie: false
    })]
  });
}
function NativeCaptureId$1(_l) {
  var _m = _l, {
    tutorialSrc,
    tutorialHeader
  } = _m, props = __objRest(_m, [
    "tutorialSrc",
    "tutorialHeader"
  ]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({}, props), {
      src: tutorialSrc,
      header: tutorialHeader,
      children: /* @__PURE__ */ jsx(UploadInput$1, __spreadProps(__spreadValues({}, props), {
        showInput: true
      }))
    }))
  });
}
const ButtonsContainer$2 = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledButton$1 = styled(Button$3)`
  margin-bottom: 20px;

  @media only screen and (max-height: 600px) {
    margin-bottom: 10px;
    height: 60px;
  }
`;
const TutorialFrontHeader$1 = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    className: "IncodeTutorialHeader IncodeTutorialHeaderFront",
    children: [/* @__PURE__ */ jsx("h1", {
      className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleFront",
      children: t2("tutorial.front1")
    }), mobile.any() && /* @__PURE__ */ jsx("span", {
      className: "IncodeText IncodeTutorialHeaderSubtitle IncodeTutorialHeaderSubtitleFront",
      children: t2("tutorial.front2")
    })]
  });
};
function TutorialFront(_n) {
  var _o = _n, {
    onSuccess,
    token,
    src: src2 = `https://sdk.incode.com/sdk/tutorials/${mobile.any() ? "front" : "front-desktop"}.gif`,
    onError
  } = _o, props = __objRest(_o, [
    "onSuccess",
    "token",
    "src",
    "onError"
  ]);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    if (token == null ? void 0 : token.token) {
      addEvent({
        token: token.token,
        eventName: "tutorialFrontId",
        eventData: {
          tutorialFrontID: true
        },
        eventType: "text"
      });
    }
  }, [token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({}, props), {
    src: src2,
    header: /* @__PURE__ */ jsx(TutorialFrontHeader$1, {}),
    type: "Front",
    children: /* @__PURE__ */ jsx(ButtonsContainer$2, {
      children: /* @__PURE__ */ jsx(StyledButton$1, {
        disabled: props == null ? void 0 : props.disabledButton,
        className: classNames("IncodeTutorialButton", "IncodeTutorialButtonSelfie"),
        onClick: handleClick,
        children: t2(`common.${(props == null ? void 0 : props.disabledButton) ? "pleaseWait" : "continue"}`)
      })
    })
  }));
}
const TutorialPassportHeader = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: t2("tutorial.passport1")
    }), /* @__PURE__ */ jsx("span", {
      children: t2("tutorial.passport2")
    })]
  });
};
function TutorialPassport(_p) {
  var _q = _p, {
    onSuccess,
    token,
    src: src2 = "https://sdk.incode.com/sdk/tutorials/passport.gif",
    onError
  } = _q, props = __objRest(_q, [
    "onSuccess",
    "token",
    "src",
    "onError"
  ]);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    addEvent({
      token: token.token,
      eventName: "tutorialPassport",
      eventData: {
        tutorialPassport: true
      },
      eventType: "text"
    });
  }, [token.token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({}, props), {
    src: src2,
    header: /* @__PURE__ */ jsx(TutorialPassportHeader, {}),
    children: /* @__PURE__ */ jsx(ButtonsContainer$2, {
      children: /* @__PURE__ */ jsx(StyledButton$1, {
        className: classNames("IncodeTutorialButton", `IncodeTutorialButtonSelfie`),
        onClick: handleClick,
        children: t2("common.continue")
      })
    })
  }));
}
const TutorialCreditCardFrontHeader = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: t2("tutorial.creditCardFront")
    }), /* @__PURE__ */ jsx("span", {
      children: t2("tutorial.creditCardFront2")
    })]
  });
};
function TutorialCreditCardFront(_r) {
  var _s = _r, {
    onSuccess,
    token,
    src: src2 = "https://sdk.incode.com/sdk/tutorials/card%20front.svg",
    onError
  } = _s, props = __objRest(_s, [
    "onSuccess",
    "token",
    "src",
    "onError"
  ]);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    addEvent({
      token: token.token,
      eventName: "tutorialCreditCard",
      eventData: {
        tutorialCreditCard: true
      },
      eventType: "text"
    });
  }, [token.token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({
    creditCard: true
  }, props), {
    src: src2,
    header: /* @__PURE__ */ jsx(TutorialCreditCardFrontHeader, {}),
    children: /* @__PURE__ */ jsx(ButtonsContainer$2, {
      children: /* @__PURE__ */ jsx(StyledButton$1, {
        className: classNames("IncodeTutorialButton", `IncodeTutorialButtonSelfie`),
        onClick: handleClick,
        children: t2("common.continue")
      })
    })
  }));
}
const TutorialFrontHeader = ({
  onBoarding
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx("h1", {
      children: t2("tutorial.front1")
    })
  });
};
function CaptureFrontId(props) {
  const [nativeCamera, setNativeCamera] = useState(() => !isWebRtcSupported());
  const {
    t: t2
  } = useTranslation();
  const shouldTakeIdAgain = ({
    sharpness,
    glare: glare2,
    horizontalResolution,
    classification,
    shadowConfidence
  }) => {
    if (!classification) {
      return {
        status: true,
        message: props.type === "passport" ? t2("notifications.passportClassificationFailed") : t2("notifications.frontClassificationFailed")
      };
    }
    const sharpnessThreshold = mobile.isDesktop() ? -1 : 10;
    const glareThreshold = 10;
    const horizontalResolutionThreshold = 155;
    if (sharpness < sharpnessThreshold) {
      return {
        status: true,
        message: t2("notifications.lowSharpness")
      };
    }
    if (glare2 < glareThreshold) {
      return {
        status: true,
        message: t2("notifications.glareDetected")
      };
    }
    if (horizontalResolution < horizontalResolutionThreshold) {
      return {
        status: true,
        message: t2("notifications.lowResolution")
      };
    }
    return {
      status: false,
      message: ""
    };
  };
  const getInstructionsNotification = (lowEnd) => {
    if (props.type === "passport") {
      return {
        notificationMessage: /* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: t2("notifications.showPassport")
          })
        }),
        notificationVariant: "front"
      };
    } else {
      return {
        notificationMessage: /* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: lowEnd ? t2("notifications.showFrontLowEnd.one") : t2("notifications.showFront.one")
          })
        }),
        notificationVariant: "front"
      };
    }
  };
  function handleOpenNativeCamera() {
    const sessionToken = props.token ? props.token.token : props.onBoarding.state.token.token;
    addEvent({
      token: sessionToken,
      eventName: `switchToNativeCaptureFrontId`,
      eventData: {
        [`switchToNativeCaptureFrontId`]: true
      },
      eventType: "text"
    });
    setNativeCamera(true);
  }
  if (nativeCamera) {
    return /* @__PURE__ */ jsx(NativeCaptureId$1, __spreadProps(__spreadValues({}, props), {
      shouldTakeIdAgain,
      type: props.onBoarding.frontType,
      getInstructionsNotification,
      tutorialSrc: "https://sdk.incode.com/sdk/tutorials/front-native.gif",
      tutorialHeader: /* @__PURE__ */ jsx(TutorialFrontHeader, {}),
      onlyFront: props.type === "passport",
      isCreditCard: props.type === "creditCard"
    }));
  } else {
    return /* @__PURE__ */ jsx(CaptureIdWithChooseCamera, __spreadProps(__spreadValues({}, props), {
      shouldTakeIdAgain,
      type: props.onBoarding.frontType,
      onlyFront: props.type === "passport",
      getInstructionsNotification,
      onOpenNativeCamera: handleOpenNativeCamera,
      isCreditCard: props.type === "creditCard"
    }));
  }
}
function CaptureAndTutorial$2(_t) {
  var props = __objRest(_t, []);
  const [disabledButton, setDisabledButton] = useState(true);
  useEffect(() => {
    setDisabledButton(false);
  }, []);
  const {
    currentStep,
    nextStep
  } = useSteps();
  const Tutorial2 = props.type === "passport" ? TutorialPassport : props.type === "creditCard" ? TutorialCreditCardFront : TutorialFront;
  return /* @__PURE__ */ jsxs(Steps, {
    currentStep,
    children: [props.showTutorial && isWebRtcSupported() && /* @__PURE__ */ jsx(Tutorial2, __spreadProps(__spreadValues({}, props), {
      onSuccess: nextStep,
      disabledButton
    })), /* @__PURE__ */ jsx(CaptureFrontId, __spreadValues({}, props))]
  });
}
const TutorialBackHeader = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx("div", {
    className: "IncodeTutorialHeader IncodeTutorialHeaderBack",
    children: /* @__PURE__ */ jsx("h1", {
      className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleBack",
      children: /* @__PURE__ */ jsxs(Trans, {
        t: t2,
        i18nKey: "tutorial.back.title",
        children: ["Now scan the", /* @__PURE__ */ jsx("span", {
          className: "blue IncodeHighlightedText",
          children: "back side"
        }), "of your ID"]
      })
    })
  });
};
function TutorialBack(_u) {
  var _v = _u, {
    onSuccess,
    token,
    src: src2 = `https://sdk.incode.com/sdk/tutorials/${mobile.any() ? "back" : "back-desktop"}.gif`
  } = _v, props = __objRest(_v, [
    "onSuccess",
    "token",
    "src"
  ]);
  useEffect(() => {
    if (token == null ? void 0 : token.token) {
      addEvent({
        token: token.token,
        eventName: "tutorialBackId",
        eventData: {
          tutorialBackID: true
        },
        eventType: "text"
      });
    }
  }, [token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({}, props), {
    src: src2,
    next: handleClick,
    header: /* @__PURE__ */ jsx(TutorialBackHeader, {}),
    type: "Back"
  }));
}
const TutorialCreditCardBackHeader = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: t2("tutorial.creditCardBack")
    }), /* @__PURE__ */ jsx("span", {
      children: t2("tutorial.creditCardBack2")
    })]
  });
};
function TutorialCreditCardBack(_w) {
  var _x = _w, {
    onSuccess,
    token,
    src: src2 = "https://sdk.incode.com/sdk/tutorials/card%20back.svg",
    onError
  } = _x, props = __objRest(_x, [
    "onSuccess",
    "token",
    "src",
    "onError"
  ]);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    addEvent({
      token: token.token,
      eventName: "tutorialCreditCardBack",
      eventData: {
        tutorialCreditCardBack: true
      },
      eventType: "text"
    });
  }, [token.token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({
    creditCard: true
  }, props), {
    src: src2,
    header: /* @__PURE__ */ jsx(TutorialCreditCardBackHeader, {}),
    children: /* @__PURE__ */ jsx(ButtonsContainer$2, {
      children: /* @__PURE__ */ jsx(StyledButton$1, {
        className: classNames("IncodeTutorialButton", `IncodeTutorialButtonSelfie`),
        onClick: handleClick,
        children: t2("common.continue")
      })
    })
  }));
}
function CaptureBackId(props) {
  const [nativeCamera, setNativeCamera] = useState(() => !isWebRtcSupported());
  const {
    t: t2
  } = useTranslation();
  const shouldTakeIdAgain = ({
    sharpness,
    glare: glare2,
    horizontalResolution,
    classification,
    shadowConfidence
  }) => {
    if (!classification) {
      return {
        status: true,
        message: t2("notifications.backClassificationFailed")
      };
    }
    const sharpnessThreshold = mobile.isDesktop() ? -1 : 10;
    const glareThreshold = 10;
    const horizontalResolutionThreshold = 155;
    if (sharpness < sharpnessThreshold) {
      return {
        status: true,
        message: t2("notifications.lowSharpness")
      };
    }
    if (glare2 < glareThreshold) {
      return {
        status: true,
        message: t2("notifications.glareDetected")
      };
    }
    if (horizontalResolution < horizontalResolutionThreshold) {
      return {
        status: true,
        message: t2("notifications.lowResolution")
      };
    }
    return {
      status: false,
      message: ""
    };
  };
  const getInstructionsNotification = (lowEnd) => {
    if (props.scanPdf417) {
      return {
        notificationMessage: /* @__PURE__ */ jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /* @__PURE__ */ jsx("div", {
            children: t2("notifications.showBack.pdf417")
          })
        })
      };
    }
    return {
      notificationMessage: /* @__PURE__ */ jsx("div", {
        style: {
          textAlign: "center"
        },
        children: /* @__PURE__ */ jsx("div", {
          children: lowEnd ? t2("notifications.showBackLowEnd.one") : t2("notifications.showBack.one")
        })
      }),
      notificationVariant: "rotate"
    };
  };
  function handleOpenNativeCamera() {
    const sessionToken = props.token ? props.token.token : props.onBoarding.state.token.token;
    addEvent({
      token: sessionToken,
      eventName: `switchToNativeCaptureBackId`,
      eventData: {
        [`switchToNativeCaptureBackId`]: true
      },
      eventType: "text"
    });
    setNativeCamera(true);
  }
  if (nativeCamera) {
    return /* @__PURE__ */ jsx(NativeCaptureId$1, __spreadProps(__spreadValues({}, props), {
      shouldTakeIdAgain,
      type: props.onBoarding.backType,
      getInstructionsNotification,
      tutorialSrc: "https://sdk.incode.com/sdk/tutorials/back-native.gif",
      tutorialHeader: /* @__PURE__ */ jsx(TutorialBackHeader, {})
    }));
  } else {
    return /* @__PURE__ */ jsx(CaptureIdWithChooseCamera, __spreadProps(__spreadValues({}, props), {
      shouldTakeIdAgain,
      type: props.onBoarding.backType,
      getInstructionsNotification,
      onOpenNativeCamera: handleOpenNativeCamera,
      isCreditCardBack: props.type === "creditCardBack"
    }));
  }
}
function CaptureAndTutorial$1(props) {
  const {
    currentStep,
    nextStep
  } = useSteps();
  const Tutorial2 = props.type === "creditCardBack" ? TutorialCreditCardBack : TutorialBack;
  return /* @__PURE__ */ jsxs(Steps, {
    currentStep,
    children: [props.showTutorial && isWebRtcSupported() && /* @__PURE__ */ jsx(Tutorial2, __spreadProps(__spreadValues({}, props), {
      onSuccess: nextStep,
      token: props.token
    })), /* @__PURE__ */ jsx(CaptureBackId, __spreadValues({}, props))]
  });
}
var faceFrame$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMzYiIGhlaWdodD0iNTE4IiB2aWV3Qm94PSIwIDAgMzM2IDUxOCI+CiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWRhc2hhcnJheT0iNy4xMzk5OTk2NzU3NTA3MzIsMTkuMDM5OTk5Njc1NzUwNzMiIHN0cm9rZS13aWR0aD0iOS4wNDQiIGQ9Ik0xNjggNTEzLjM5MmM3Ni44MyAwIDE2Mi44OTMtMTEzLjkyIDE2Mi44OTMtMjU0LjQ0N1MyODAuMjM2IDQuNDk4IDE2OCA0LjQ5OCA1LjEwNyAxMTguNDE4IDUuMTA3IDI1OC45NDUgOTEuMTcgNTEzLjM5MiAxNjggNTEzLjM5MnoiLz4KPC9zdmc+Cg==";
var captureButton = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NSIgaGVpZ2h0PSI2NSIgdmlld0JveD0iMCAwIDY1IDY1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1NSAtNjQ2KSB0cmFuc2xhdGUoMTU1IDY0NikiPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjMyLjMxOSIgY3k9IjMyLjMxOSIgcj0iMzIuMzE5IiBmaWxsPSIjMjAyNjNEIi8+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMzIuMzE5IiBjeT0iMzIuMzE5IiByPSIyNS4xMzciIGZpbGw9IiNGRkYiIGZpbGwtb3BhY2l0eT0iLjA5MyIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuMDUyIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNy4xOTMgMTIuMjRjMCAyLjI5NC0xLjg4IDQuMTYtNC4xOTMgNC4xNi0yLjMxMiAwLTQuMTkyLTEuODY2LTQuMTkyLTQuMTYgMC0yLjI5MyAxLjg4LTQuMTYgNC4xOTItNC4xNiAyLjMxMiAwIDQuMTkzIDEuODY3IDQuMTkzIDQuMTZ6TTI2IDYuMzM0djExLjgxNEMyNiAxOS43MjMgMjQuNzEzIDIxIDIzLjEyNSAyMUgyLjg3NUMxLjI4NyAyMSAwIDE5LjcyMyAwIDE4LjE0OFY2LjMzNEMwIDQuNzYgMS4yODcgMy40ODIgMi44NzUgMy40ODJoMy41MzZ2LS45ODdDNi40MTEgMS4xMTcgNy41MzcgMCA4LjkyNyAwaDguMTQ2YzEuMzkgMCAyLjUxNiAxLjExNyAyLjUxNiAyLjQ5NXYuOTg2aDMuNTM2QzI0LjcxMyAzLjQ4MiAyNiA0Ljc2IDI2IDYuMzM0em0tNi42NSA1LjkwNmMwLTMuNDczLTIuODQ5LTYuMjk4LTYuMzUtNi4yOTgtMy41IDAtNi4zNDkgMi44MjUtNi4zNDkgNi4yOThTOS41IDE4LjU0IDEzIDE4LjU0YzMuNTAxIDAgNi4zNS0yLjgyNiA2LjM1LTYuMjk5eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1NSAtNjQ2KSB0cmFuc2xhdGUoMTU1IDY0NikgdHJhbnNsYXRlKDE5IDIxKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d2, b2) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (Object.prototype.hasOwnProperty.call(b3, p2))
        d3[p2] = b3[p2];
  };
  return extendStatics(d2, b2);
};
function __extends(d2, b2) {
  if (typeof b2 !== "function" && b2 !== null)
    throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
  extendStatics(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest$1(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __read(o, n2) {
  var m2 = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m2)
    return o;
  var i2 = m2.call(o), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error3) {
    e2 = { error: error3 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack2) {
  if (pack2 || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var createDefinition = function(propNames) {
  return {
    isEnabled: function(props) {
      return propNames.some(function(name) {
        return !!props[name];
      });
    }
  };
};
var featureDefinitions = {
  measureLayout: createDefinition(["layout", "layoutId", "drag"]),
  animation: createDefinition([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: createDefinition(["exit"]),
  drag: createDefinition(["drag", "dragControls"]),
  focus: createDefinition(["whileFocus"]),
  hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: createDefinition([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function loadFeatures(features) {
  for (var key in features) {
    if (features[key] === null)
      continue;
    if (key === "projectionNodeConstructor") {
      featureDefinitions.projectionNodeConstructor = features[key];
    } else {
      featureDefinitions[key].Component = features[key];
    }
  }
}
var warning = function() {
};
var invariant = function() {
};
var LazyContext = createContext({ strict: false });
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
function useFeatures(props, visualElement2, preloadedFeatures) {
  var features = [];
  useContext(LazyContext);
  if (!visualElement2)
    return null;
  for (var i2 = 0; i2 < numFeatures; i2++) {
    var name_1 = featureNames[i2];
    var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component2 = _a.Component;
    if (isEnabled(props) && Component2) {
      features.push(React$1.createElement(Component2, __assign({ key: name_1 }, props, { visualElement: visualElement2 })));
    }
  }
  return features;
}
var MotionConfigContext = createContext({
  transformPagePoint: function(p2) {
    return p2;
  },
  isStatic: false,
  reducedMotion: "never"
});
var MotionContext = createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
var PresenceContext = createContext(null);
var isBrowser = typeof window !== "undefined";
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
var prefersReducedMotion = { current: null };
var hasDetected = false;
function initPrefersReducedMotion() {
  hasDetected = true;
  if (typeof window === "undefined")
    return;
  if (window.matchMedia) {
    var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
    var setReducedMotionPreferences = function() {
      return prefersReducedMotion.current = motionMediaQuery_1.matches;
    };
    motionMediaQuery_1.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}
function useReducedMotion() {
  !hasDetected && initPrefersReducedMotion();
  var _a = __read(useState(prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
  return shouldReduceMotion;
}
function useReducedMotionConfig() {
  var reducedMotionPreference = useReducedMotion();
  var reducedMotion = useContext(MotionConfigContext).reducedMotion;
  if (reducedMotion === "never") {
    return false;
  } else if (reducedMotion === "always") {
    return true;
  } else {
    return reducedMotionPreference;
  }
}
function useVisualElement(Component2, visualState, props, createVisualElement) {
  var lazyContext = useContext(LazyContext);
  var parent = useVisualElementContext();
  var presenceContext = useContext(PresenceContext);
  var shouldReduceMotion = useReducedMotionConfig();
  var visualElementRef = useRef(void 0);
  if (!createVisualElement)
    createVisualElement = lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props,
      presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
      blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
      shouldReduceMotion
    });
  }
  var visualElement2 = visualElementRef.current;
  useIsomorphicLayoutEffect(function() {
    visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.syncRender();
  });
  useEffect(function() {
    var _a;
    (_a = visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
  });
  useIsomorphicLayoutEffect(function() {
    return function() {
      return visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.notifyUnmount();
    };
  }, []);
  return visualElement2;
}
function isRefObject(ref) {
  return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}
function useMotionRef(visualState, visualElement2, externalRef) {
  return useCallback(function(instance2) {
    var _a;
    instance2 && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance2));
    if (visualElement2) {
      instance2 ? visualElement2.mount(instance2) : visualElement2.unmount();
    }
    if (externalRef) {
      if (typeof externalRef === "function") {
        externalRef(instance2);
      } else if (isRefObject(externalRef)) {
        externalRef.current = instance2;
      }
    }
  }, [visualElement2]);
}
function isVariantLabels(v2) {
  return Array.isArray(v2);
}
function isVariantLabel(v2) {
  return typeof v2 === "string" || isVariantLabels(v2);
}
function getCurrent(visualElement2) {
  var current = {};
  visualElement2.forEachValue(function(value, key) {
    return current[key] = value.get();
  });
  return current;
}
function getVelocity$1(visualElement2) {
  var velocity = {};
  visualElement2.forEachValue(function(value, key) {
    return velocity[key] = value.getVelocity();
  });
  return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
  var _a;
  if (currentValues === void 0) {
    currentValues = {};
  }
  if (currentVelocity === void 0) {
    currentVelocity = {};
  }
  if (typeof definition === "function") {
    definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  if (typeof definition === "string") {
    definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
  }
  if (typeof definition === "function") {
    definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  return definition;
}
function resolveVariant(visualElement2, definition, custom) {
  var props = visualElement2.getProps();
  return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement2), getVelocity$1(visualElement2));
}
function checkIfControllingVariants(props) {
  var _a;
  return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || isVariantLabel(props.initial) || isVariantLabel(props.animate) || isVariantLabel(props.whileHover) || isVariantLabel(props.whileDrag) || isVariantLabel(props.whileTap) || isVariantLabel(props.whileFocus) || isVariantLabel(props.exit);
}
function checkIfVariantNode(props) {
  return Boolean(checkIfControllingVariants(props) || props.variants);
}
function getCurrentTreeVariants(props, context2) {
  if (checkIfControllingVariants(props)) {
    var initial = props.initial, animate2 = props.animate;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate2) ? animate2 : void 0
    };
  }
  return props.inherit !== false ? context2 : {};
}
function useCreateMotionContext(props) {
  var _a = getCurrentTreeVariants(props, useContext(MotionContext)), initial = _a.initial, animate2 = _a.animate;
  return useMemo(function() {
    return { initial, animate: animate2 };
  }, [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate2)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
function useConstant(init3) {
  var ref = useRef(null);
  if (ref.current === null) {
    ref.current = init3();
  }
  return ref.current;
}
const defaultTimestep = 1 / 60 * 1e3;
const getCurrentTime = typeof performance !== "undefined" ? () => performance.now() : () => Date.now();
const onNextFrame = typeof window !== "undefined" ? (callback) => window.requestAnimationFrame(callback) : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);
function createRenderStep(runNextFrame2) {
  let toRun = [];
  let toRunNextFrame = [];
  let numToRun = 0;
  let isProcessing2 = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  const step2 = {
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing2;
      const buffer2 = addToCurrentFrame ? toRun : toRunNextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (buffer2.indexOf(callback) === -1) {
        buffer2.push(callback);
        if (addToCurrentFrame && isProcessing2)
          numToRun = toRun.length;
      }
      return callback;
    },
    cancel: (callback) => {
      const index2 = toRunNextFrame.indexOf(callback);
      if (index2 !== -1)
        toRunNextFrame.splice(index2, 1);
      toKeepAlive.delete(callback);
    },
    process: (frameData) => {
      if (isProcessing2) {
        flushNextFrame = true;
        return;
      }
      isProcessing2 = true;
      [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
      toRunNextFrame.length = 0;
      numToRun = toRun.length;
      if (numToRun) {
        for (let i2 = 0; i2 < numToRun; i2++) {
          const callback = toRun[i2];
          callback(frameData);
          if (toKeepAlive.has(callback)) {
            step2.schedule(callback);
            runNextFrame2();
          }
        }
      }
      isProcessing2 = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step2.process(frameData);
      }
    }
  };
  return step2;
}
const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const frame = {
  delta: 0,
  timestamp: 0
};
const stepsOrder = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
];
const steps$2 = stepsOrder.reduce((acc, key) => {
  acc[key] = createRenderStep(() => runNextFrame = true);
  return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
  const step2 = steps$2[key];
  acc[key] = (process2, keepAlive = false, immediate = false) => {
    if (!runNextFrame)
      startLoop();
    return step2.schedule(process2, keepAlive, immediate);
  };
  return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
  acc[key] = steps$2[key].cancel;
  return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
  acc[key] = () => steps$2[key].process(frame);
  return acc;
}, {});
const processStep = (stepId) => steps$2[stepId].process(frame);
const processFrame = (timestamp) => {
  runNextFrame = false;
  frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
  frame.timestamp = timestamp;
  isProcessing = true;
  stepsOrder.forEach(processStep);
  isProcessing = false;
  if (runNextFrame) {
    useDefaultElapsed = false;
    onNextFrame(processFrame);
  }
};
const startLoop = () => {
  runNextFrame = true;
  useDefaultElapsed = true;
  if (!isProcessing)
    onNextFrame(processFrame);
};
const getFrameData = () => frame;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
const clamp$1 = (min2, max2, v2) => Math.min(Math.max(v2, min2), max2);
const safeMin = 1e-3;
const minDuration = 0.01;
const maxDuration = 10;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning(duration <= maxDuration * 1e3);
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp$1(minDamping, maxDamping, dampingRatio);
  duration = clamp$1(minDuration, maxDuration, duration / 1e3);
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const a6 = exponentialDecay - velocity;
      const b2 = calcAngularFreq(undampedFreq2, dampingRatio);
      const c2 = Math.exp(-delta);
      return safeMin - a6 / b2 * c2;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const d2 = delta * velocity + velocity;
      const e2 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration;
      const f2 = Math.exp(-delta);
      const g2 = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d2 - e2) * f2) / g2;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a6 = Math.exp(-undampedFreq2 * duration);
      const b2 = (undampedFreq2 - velocity) * duration + 1;
      return -safeMin + a6 * b2;
    };
    derivative = (undampedFreq2) => {
      const a6 = Math.exp(-undampedFreq2 * duration);
      const b2 = (velocity - undampedFreq2) * (duration * duration);
      return a6 * b2;
    };
  }
  const initialGuess = 5 / duration;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = duration * 1e3;
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result2 = initialGuess;
  for (let i2 = 1; i2 < rootIterations; i2++) {
    result2 = result2 - envelope(result2) / derivative(result2);
  }
  return result2;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some((key) => options[key] !== void 0);
}
function getSpringOptions(options) {
  let springOptions = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: false }, options);
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    const derived = findSpring(options);
    springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), { velocity: 0, mass: 1 });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring(_a) {
  var { from = 0, to = 1, restSpeed = 2, restDelta } = _a, options = __rest(_a, ["from", "to", "restSpeed", "restDelta"]);
  const state2 = { done: false, value: from };
  let { stiffness, damping, mass, velocity, duration, isResolvedFromDuration } = getSpringOptions(options);
  let resolveSpring = zero;
  let resolveVelocity = zero;
  function createSpring() {
    const initialVelocity = velocity ? -(velocity / 1e3) : 0;
    const initialDelta = to - from;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1e3;
    if (restDelta === void 0) {
      restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
    }
    if (dampingRatio < 1) {
      const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
      resolveSpring = (t2) => {
        const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
        return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t2) + initialDelta * Math.cos(angularFreq * t2));
      };
      resolveVelocity = (t2) => {
        const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
        return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t2) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t2)) - envelope * (Math.cos(angularFreq * t2) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t2));
      };
    } else if (dampingRatio === 1) {
      resolveSpring = (t2) => to - Math.exp(-undampedAngularFreq * t2) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t2);
    } else {
      const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
      resolveSpring = (t2) => {
        const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
        const freqForT = Math.min(dampedAngularFreq * t2, 300);
        return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
      };
    }
  }
  createSpring();
  return {
    next: (t2) => {
      const current = resolveSpring(t2);
      if (!isResolvedFromDuration) {
        const currentVelocity = resolveVelocity(t2) * 1e3;
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
        state2.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state2.done = t2 >= duration;
      }
      state2.value = state2.done ? to : current;
      return state2;
    },
    flipTarget: () => {
      velocity = -velocity;
      [from, to] = [to, from];
      createSpring();
    }
  };
}
spring.needsInterpolation = (a6, b2) => typeof a6 === "string" || typeof b2 === "string";
const zero = (_t) => 0;
const progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};
const mix = (from, to, progress2) => -progress2 * from + progress2 * to + from;
const clamp = (min2, max2) => (v2) => Math.max(Math.min(v2, max2), min2);
const sanitize = (v2) => v2 % 1 ? Number(v2.toFixed(5)) : v2;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(v2) {
  return typeof v2 === "string";
}
const number = {
  test: (v2) => typeof v2 === "number",
  parse: parseFloat,
  transform: (v2) => v2
};
const alpha = Object.assign(Object.assign({}, number), { transform: clamp(0, 1) });
const scale = Object.assign(Object.assign({}, number), { default: 1 });
const createUnitType = (unit) => ({
  test: (v2) => isString$1(v2) && v2.endsWith(unit) && v2.split(" ").length === 1,
  parse: parseFloat,
  transform: (v2) => `${v2}${unit}`
});
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = Object.assign(Object.assign({}, percent), { parse: (v2) => percent.parse(v2) / 100, transform: (v2) => percent.transform(v2 * 100) });
const isColorString = (type, testProp) => (v2) => {
  return Boolean(isString$1(v2) && singleColorRegex.test(v2) && v2.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v2, testProp));
};
const splitColor = (aName, bName, cName) => (v2) => {
  if (!isString$1(v2))
    return v2;
  const [a6, b2, c2, alpha2] = v2.match(floatRegex);
  return {
    [aName]: parseFloat(a6),
    [bName]: parseFloat(b2),
    [cName]: parseFloat(c2),
    alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
  };
};
const hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
const clampRgbUnit = clamp(0, 255);
const rgbUnit = Object.assign(Object.assign({}, number), { transform: (v2) => Math.round(clampRgbUnit(v2)) });
const rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")"
};
function parseHex(v2) {
  let r2 = "";
  let g2 = "";
  let b2 = "";
  let a6 = "";
  if (v2.length > 5) {
    r2 = v2.substr(1, 2);
    g2 = v2.substr(3, 2);
    b2 = v2.substr(5, 2);
    a6 = v2.substr(7, 2);
  } else {
    r2 = v2.substr(1, 1);
    g2 = v2.substr(2, 1);
    b2 = v2.substr(3, 1);
    a6 = v2.substr(4, 1);
    r2 += r2;
    g2 += g2;
    b2 += b2;
    a6 += a6;
  }
  return {
    red: parseInt(r2, 16),
    green: parseInt(g2, 16),
    blue: parseInt(b2, 16),
    alpha: a6 ? parseInt(a6, 16) / 255 : 1
  };
}
const hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};
const color = {
  test: (v2) => rgba.test(v2) || hex.test(v2) || hsla.test(v2),
  parse: (v2) => {
    if (rgba.test(v2)) {
      return rgba.parse(v2);
    } else if (hsla.test(v2)) {
      return hsla.parse(v2);
    } else {
      return hex.parse(v2);
    }
  },
  transform: (v2) => {
    return isString$1(v2) ? v2 : v2.hasOwnProperty("red") ? rgba.transform(v2) : hsla.transform(v2);
  }
};
const colorToken = "${c}";
const numberToken = "${n}";
function test(v2) {
  var _a, _b, _c, _d;
  return isNaN(v2) && isString$1(v2) && ((_b = (_a = v2.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v2.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function analyse$1(v2) {
  if (typeof v2 === "number")
    v2 = `${v2}`;
  const values = [];
  let numColors = 0;
  const colors = v2.match(colorRegex);
  if (colors) {
    numColors = colors.length;
    v2 = v2.replace(colorRegex, colorToken);
    values.push(...colors.map(color.parse));
  }
  const numbers = v2.match(floatRegex);
  if (numbers) {
    v2 = v2.replace(floatRegex, numberToken);
    values.push(...numbers.map(number.parse));
  }
  return { values, numColors, tokenised: v2 };
}
function parse$1(v2) {
  return analyse$1(v2).values;
}
function createTransformer(v2) {
  const { values, numColors, tokenised } = analyse$1(v2);
  const numValues = values.length;
  return (v3) => {
    let output2 = tokenised;
    for (let i2 = 0; i2 < numValues; i2++) {
      output2 = output2.replace(i2 < numColors ? colorToken : numberToken, i2 < numColors ? color.transform(v3[i2]) : sanitize(v3[i2]));
    }
    return output2;
  };
}
const convertNumbersToZero = (v2) => typeof v2 === "number" ? 0 : v2;
function getAnimatableNone$1(v2) {
  const parsed = parse$1(v2);
  const transformer = createTransformer(v2);
  return transformer(parsed.map(convertNumbersToZero));
}
const complex = { test, parse: parse$1, createTransformer, getAnimatableNone: getAnimatableNone$1 };
const maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v2) {
  let [name, value] = v2.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v2;
  const [number2] = value.match(floatRegex) || [];
  if (!number2)
    return v2;
  const unit = value.replace(number2, "");
  let defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number2 !== value)
    defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = Object.assign(Object.assign({}, complex), { getAnimatableNone: (v2) => {
  const functions = v2.match(functionRegex);
  return functions ? functions.map(applyDefaultFilter).join(" ") : v2;
} });
function hueToRgb(p2, q2, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p2 + (q2 - p2) * 6 * t2;
  if (t2 < 1 / 2)
    return q2;
  if (t2 < 2 / 3)
    return p2 + (q2 - p2) * (2 / 3 - t2) * 6;
  return p2;
}
function hslaToRgba({ hue, saturation, lightness, alpha: alpha2 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q2 = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p2 = 2 * lightness - q2;
    red = hueToRgb(p2, q2, hue + 1 / 3);
    green = hueToRgb(p2, q2, hue);
    blue = hueToRgb(p2, q2, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha2
  };
}
const mixLinearColor = (from, to, v2) => {
  const fromExpo = from * from;
  const toExpo = to * to;
  return Math.sqrt(Math.max(0, v2 * (toExpo - fromExpo) + fromExpo));
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v2) => colorTypes.find((type) => type.test(v2));
const mixColor = (from, to) => {
  let fromColorType = getColorType(from);
  let toColorType = getColorType(to);
  let fromColor = fromColorType.parse(from);
  let toColor = toColorType.parse(to);
  if (fromColorType === hsla) {
    fromColor = hslaToRgba(fromColor);
    fromColorType = rgba;
  }
  if (toColorType === hsla) {
    toColor = hslaToRgba(toColor);
    toColorType = rgba;
  }
  const blended = Object.assign({}, fromColor);
  return (v2) => {
    for (const key in blended) {
      if (key !== "alpha") {
        blended[key] = mixLinearColor(fromColor[key], toColor[key], v2);
      }
    }
    blended.alpha = mix(fromColor.alpha, toColor.alpha, v2);
    return fromColorType.transform(blended);
  };
};
const isNum = (v2) => typeof v2 === "number";
const combineFunctions = (a6, b2) => (v2) => b2(a6(v2));
const pipe = (...transformers) => transformers.reduce(combineFunctions);
function getMixer(origin, target) {
  if (isNum(origin)) {
    return (v2) => mix(origin, target, v2);
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return mixComplex(origin, target);
  }
}
const mixArray = (from, to) => {
  const output2 = [...from];
  const numValues = output2.length;
  const blendValue = from.map((fromThis, i2) => getMixer(fromThis, to[i2]));
  return (v2) => {
    for (let i2 = 0; i2 < numValues; i2++) {
      output2[i2] = blendValue[i2](v2);
    }
    return output2;
  };
};
const mixObject = (origin, target) => {
  const output2 = Object.assign(Object.assign({}, origin), target);
  const blendValue = {};
  for (const key in output2) {
    if (origin[key] !== void 0 && target[key] !== void 0) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }
  return (v2) => {
    for (const key in blendValue) {
      output2[key] = blendValue[key](v2);
    }
    return output2;
  };
};
function analyse(value) {
  const parsed = complex.parse(value);
  const numValues = parsed.length;
  let numNumbers = 0;
  let numRGB = 0;
  let numHSL = 0;
  for (let i2 = 0; i2 < numValues; i2++) {
    if (numNumbers || typeof parsed[i2] === "number") {
      numNumbers++;
    } else {
      if (parsed[i2].hue !== void 0) {
        numHSL++;
      } else {
        numRGB++;
      }
    }
  }
  return { parsed, numNumbers, numRGB, numHSL };
}
const mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyse(origin);
  const targetStats = analyse(target);
  const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
  } else {
    return (p2) => `${p2 > 0 ? target : origin}`;
  }
};
const mixNumber = (from, to) => (p2) => mix(from, to, p2);
function detectMixerFactory(v2) {
  if (typeof v2 === "number") {
    return mixNumber;
  } else if (typeof v2 === "string") {
    if (color.test(v2)) {
      return mixColor;
    } else {
      return mixComplex;
    }
  } else if (Array.isArray(v2)) {
    return mixArray;
  } else if (typeof v2 === "object") {
    return mixObject;
  }
}
function createMixers(output2, ease, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || detectMixerFactory(output2[0]);
  const numMixers = output2.length - 1;
  for (let i2 = 0; i2 < numMixers; i2++) {
    let mixer = mixerFactory(output2[i2], output2[i2 + 1]);
    if (ease) {
      const easingFunction = Array.isArray(ease) ? ease[i2] : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function fastInterpolate([from, to], [mixer]) {
  return (v2) => mixer(progress(from, to, v2));
}
function slowInterpolate(input, mixers) {
  const inputLength = input.length;
  const lastInputIndex = inputLength - 1;
  return (v2) => {
    let mixerIndex = 0;
    let foundMixerIndex = false;
    if (v2 <= input[0]) {
      foundMixerIndex = true;
    } else if (v2 >= input[lastInputIndex]) {
      mixerIndex = lastInputIndex - 1;
      foundMixerIndex = true;
    }
    if (!foundMixerIndex) {
      let i2 = 1;
      for (; i2 < inputLength; i2++) {
        if (input[i2] > v2 || i2 === lastInputIndex) {
          break;
        }
      }
      mixerIndex = i2 - 1;
    }
    const progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v2);
    return mixers[mixerIndex](progressInRange);
  };
}
function interpolate(input, output2, { clamp: isClamp = true, ease, mixer } = {}) {
  const inputLength = input.length;
  invariant(inputLength === output2.length);
  invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1);
  if (input[0] > input[inputLength - 1]) {
    input = [].concat(input);
    output2 = [].concat(output2);
    input.reverse();
    output2.reverse();
  }
  const mixers = createMixers(output2, ease, mixer);
  const interpolator = inputLength === 2 ? fastInterpolate(input, mixers) : slowInterpolate(input, mixers);
  return isClamp ? (v2) => interpolator(clamp$1(input[0], input[inputLength - 1], v2)) : interpolator;
}
const reverseEasing = (easing) => (p2) => 1 - easing(1 - p2);
const mirrorEasing = (easing) => (p2) => p2 <= 0.5 ? easing(2 * p2) / 2 : (2 - easing(2 * (1 - p2))) / 2;
const createExpoIn = (power) => (p2) => Math.pow(p2, power);
const createBackIn = (power) => (p2) => p2 * p2 * ((power + 1) * p2 - power);
const createAnticipate = (power) => {
  const backEasing = createBackIn(power);
  return (p2) => (p2 *= 2) < 1 ? 0.5 * backEasing(p2) : 0.5 * (2 - Math.pow(2, -10 * (p2 - 1)));
};
const DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const BOUNCE_FIRST_THRESHOLD = 4 / 11;
const BOUNCE_SECOND_THRESHOLD = 8 / 11;
const BOUNCE_THIRD_THRESHOLD = 9 / 10;
const linear = (p2) => p2;
const easeIn = createExpoIn(2);
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);
const circIn = (p2) => 1 - Math.sin(Math.acos(p2));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);
const backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
const backOut = reverseEasing(backIn);
const backInOut = mirrorEasing(backIn);
const anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
const ca = 4356 / 361;
const cb = 35442 / 1805;
const cc = 16061 / 1805;
const bounceOut = (p2) => {
  if (p2 === 1 || p2 === 0)
    return p2;
  const p22 = p2 * p2;
  return p2 < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p22 : p2 < BOUNCE_SECOND_THRESHOLD ? 9.075 * p22 - 9.9 * p2 + 3.4 : p2 < BOUNCE_THIRD_THRESHOLD ? ca * p22 - cb * p2 + cc : 10.8 * p2 * p2 - 20.52 * p2 + 10.72;
};
const bounceIn = reverseEasing(bounceOut);
const bounceInOut = (p2) => p2 < 0.5 ? 0.5 * (1 - bounceOut(1 - p2 * 2)) : 0.5 * bounceOut(p2 * 2 - 1) + 0.5;
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
  const numValues = values.length;
  return values.map((_value, i2) => i2 !== 0 ? i2 / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
  return offset.map((o) => o * duration);
}
function keyframes$1({ from = 0, to = 1, ease, offset, duration = 300 }) {
  const state2 = { done: false, value: from };
  const values = Array.isArray(to) ? to : [from, to];
  const times = convertOffsetToTimes(offset && offset.length === values.length ? offset : defaultOffset(values), duration);
  function createInterpolator() {
    return interpolate(times, values, {
      ease: Array.isArray(ease) ? ease : defaultEasing(values, ease)
    });
  }
  let interpolator = createInterpolator();
  return {
    next: (t2) => {
      state2.value = interpolator(t2);
      state2.done = t2 >= duration;
      return state2;
    },
    flipTarget: () => {
      values.reverse();
      interpolator = createInterpolator();
    }
  };
}
function decay({ velocity = 0, from = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget }) {
  const state2 = { done: false, value: from };
  let amplitude = power * velocity;
  const ideal = from + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - from;
  return {
    next: (t2) => {
      const delta = -amplitude * Math.exp(-t2 / timeConstant);
      state2.done = !(delta > restDelta || delta < -restDelta);
      state2.value = state2.done ? target : target + delta;
      return state2;
    },
    flipTarget: () => {
    }
  };
}
const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(config2) {
  if (Array.isArray(config2.to)) {
    return keyframes$1;
  } else if (types[config2.type]) {
    return types[config2.type];
  }
  const keys = new Set(Object.keys(config2));
  if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) {
    return keyframes$1;
  } else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) {
    return spring;
  }
  return keyframes$1;
}
function loopElapsed(elapsed, duration, delay = 0) {
  return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay = 0, isForwardPlayback = true) {
  return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
  return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const framesync = (update2) => {
  const passTimestamp = ({ delta }) => update2(delta);
  return {
    start: () => sync.update(passTimestamp, true),
    stop: () => cancelSync.update(passTimestamp)
  };
};
function animate$1(_a) {
  var _b, _c;
  var { from, autoplay = true, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, onPlay, onStop, onComplete, onRepeat, onUpdate } = _a, options = __rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to } = options;
  let driverControls;
  let repeatCount = 0;
  let computedDuration = options.duration;
  let latest;
  let isComplete = false;
  let isForwardPlayback = true;
  let interpolateFromNumber;
  const animator = detectAnimationFromOptions(options);
  if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
    interpolateFromNumber = interpolate([0, 100], [from, to], {
      clamp: false
    });
    from = 0;
    to = 100;
  }
  const animation = animator(Object.assign(Object.assign({}, options), { from, to }));
  function repeat2() {
    repeatCount++;
    if (repeatType === "reverse") {
      isForwardPlayback = repeatCount % 2 === 0;
      elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
    } else {
      elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
      if (repeatType === "mirror")
        animation.flipTarget();
    }
    isComplete = false;
    onRepeat && onRepeat();
  }
  function complete() {
    driverControls.stop();
    onComplete && onComplete();
  }
  function update2(delta) {
    if (!isForwardPlayback)
      delta = -delta;
    elapsed += delta;
    if (!isComplete) {
      const state2 = animation.next(Math.max(0, elapsed));
      latest = state2.value;
      if (interpolateFromNumber)
        latest = interpolateFromNumber(latest);
      isComplete = isForwardPlayback ? state2.done : elapsed <= 0;
    }
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
    if (isComplete) {
      if (repeatCount === 0)
        computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
      if (repeatCount < repeatMax) {
        hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat2();
      } else {
        complete();
      }
    }
  }
  function play() {
    onPlay === null || onPlay === void 0 ? void 0 : onPlay();
    driverControls = driver(update2);
    driverControls.start();
  }
  autoplay && play();
  return {
    stop: () => {
      onStop === null || onStop === void 0 ? void 0 : onStop();
      driverControls.stop();
    }
  };
}
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}
function inertia({ from = 0, velocity = 0, min: min2, max: max2, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop }) {
  let currentAnimation;
  function isOutOfBounds(v2) {
    return min2 !== void 0 && v2 < min2 || max2 !== void 0 && v2 > max2;
  }
  function boundaryNearest(v2) {
    if (min2 === void 0)
      return max2;
    if (max2 === void 0)
      return min2;
    return Math.abs(min2 - v2) < Math.abs(max2 - v2) ? min2 : max2;
  }
  function startAnimation2(options) {
    currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
    currentAnimation = animate$1(Object.assign(Object.assign({}, options), {
      driver,
      onUpdate: (v2) => {
        var _a;
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v2);
        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v2);
      },
      onComplete,
      onStop
    }));
  }
  function startSpring(options) {
    startAnimation2(Object.assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta }, options));
  }
  if (isOutOfBounds(from)) {
    startSpring({ from, velocity, to: boundaryNearest(from) });
  } else {
    let target = power * velocity + from;
    if (typeof modifyTarget !== "undefined")
      target = modifyTarget(target);
    const boundary = boundaryNearest(target);
    const heading = boundary === min2 ? -1 : 1;
    let prev;
    let current;
    const checkBoundary = (v2) => {
      prev = current;
      current = v2;
      velocity = velocityPerSecond(v2 - prev, getFrameData().delta);
      if (heading === 1 && v2 > boundary || heading === -1 && v2 < boundary) {
        startSpring({ from: v2, to: boundary, velocity });
      }
    };
    startAnimation2({
      type: "decay",
      from,
      velocity,
      timeConstant,
      power,
      restDelta,
      modifyTarget,
      onUpdate: isOutOfBounds(target) ? checkBoundary : void 0
    });
  }
  return {
    stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
  };
}
const isPoint = (point) => point.hasOwnProperty("x") && point.hasOwnProperty("y");
const isPoint3D = (point) => isPoint(point) && point.hasOwnProperty("z");
const distance1D = (a6, b2) => Math.abs(a6 - b2);
function distance(a6, b2) {
  if (isNum(a6) && isNum(b2)) {
    return distance1D(a6, b2);
  } else if (isPoint(a6) && isPoint(b2)) {
    const xDelta = distance1D(a6.x, b2.x);
    const yDelta = distance1D(a6.y, b2.y);
    const zDelta = isPoint3D(a6) && isPoint3D(b2) ? distance1D(a6.z, b2.z) : 0;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
  }
}
const a = (a12, a22) => 1 - 3 * a22 + 3 * a12;
const b = (a12, a22) => 3 * a22 - 6 * a12;
const c = (a12) => 3 * a12;
const calcBezier = (t2, a12, a22) => ((a(a12, a22) * t2 + b(a12, a22)) * t2 + c(a12)) * t2;
const getSlope = (t2, a12, a22) => 3 * a(a12, a22) * t2 * t2 + 2 * b(a12, a22) * t2 + c(a12);
const subdivisionPrecision = 1e-7;
const subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
  let currentX;
  let currentT;
  let i2 = 0;
  do {
    currentT = aA + (aB - aA) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i2 < subdivisionMaxIterations);
  return currentT;
}
const newtonIterations = 8;
const newtonMinSlope = 1e-3;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (let i2 = 0; i2 < newtonIterations; ++i2) {
    const currentSlope = getSlope(aGuessT, mX1, mX2);
    if (currentSlope === 0) {
      return aGuessT;
    }
    const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }
  return aGuessT;
}
const kSplineTableSize = 11;
const kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return linear;
  const sampleValues = new Float32Array(kSplineTableSize);
  for (let i2 = 0; i2 < kSplineTableSize; ++i2) {
    sampleValues[i2] = calcBezier(i2 * kSampleStepSize, mX1, mX2);
  }
  function getTForX(aX) {
    let intervalStart = 0;
    let currentSample = 1;
    const lastSample = kSplineTableSize - 1;
    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;
    const dist2 = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    const guessForT = intervalStart + dist2 * kSampleStepSize;
    const initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= newtonMinSlope) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }
  return (t2) => t2 === 0 || t2 === 1 ? t2 : calcBezier(getTForX(t2), mY1, mY2);
}
function addUniqueItem(arr2, item) {
  arr2.indexOf(item) === -1 && arr2.push(item);
}
function removeItem(arr2, item) {
  var index2 = arr2.indexOf(item);
  index2 > -1 && arr2.splice(index2, 1);
}
var SubscriptionManager = function() {
  function SubscriptionManager2() {
    this.subscriptions = [];
  }
  SubscriptionManager2.prototype.add = function(handler) {
    var _this = this;
    addUniqueItem(this.subscriptions, handler);
    return function() {
      return removeItem(_this.subscriptions, handler);
    };
  };
  SubscriptionManager2.prototype.notify = function(a6, b2, c2) {
    var numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a6, b2, c2);
    } else {
      for (var i2 = 0; i2 < numSubscriptions; i2++) {
        var handler = this.subscriptions[i2];
        handler && handler(a6, b2, c2);
      }
    }
  };
  SubscriptionManager2.prototype.getSize = function() {
    return this.subscriptions.length;
  };
  SubscriptionManager2.prototype.clear = function() {
    this.subscriptions.length = 0;
  };
  return SubscriptionManager2;
}();
var isFloat = function(value) {
  return !isNaN(parseFloat(value));
};
var MotionValue = function() {
  function MotionValue2(init3) {
    var _this = this;
    this.timeDelta = 0;
    this.lastUpdated = 0;
    this.updateSubscribers = new SubscriptionManager();
    this.velocityUpdateSubscribers = new SubscriptionManager();
    this.renderSubscribers = new SubscriptionManager();
    this.canTrackVelocity = false;
    this.updateAndNotify = function(v2, render) {
      if (render === void 0) {
        render = true;
      }
      _this.prev = _this.current;
      _this.current = v2;
      var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
      if (_this.lastUpdated !== timestamp) {
        _this.timeDelta = delta;
        _this.lastUpdated = timestamp;
        sync.postRender(_this.scheduleVelocityCheck);
      }
      if (_this.prev !== _this.current) {
        _this.updateSubscribers.notify(_this.current);
      }
      if (_this.velocityUpdateSubscribers.getSize()) {
        _this.velocityUpdateSubscribers.notify(_this.getVelocity());
      }
      if (render) {
        _this.renderSubscribers.notify(_this.current);
      }
    };
    this.scheduleVelocityCheck = function() {
      return sync.postRender(_this.velocityCheck);
    };
    this.velocityCheck = function(_a) {
      var timestamp = _a.timestamp;
      if (timestamp !== _this.lastUpdated) {
        _this.prev = _this.current;
        _this.velocityUpdateSubscribers.notify(_this.getVelocity());
      }
    };
    this.hasAnimated = false;
    this.prev = this.current = init3;
    this.canTrackVelocity = isFloat(this.current);
  }
  MotionValue2.prototype.onChange = function(subscription) {
    return this.updateSubscribers.add(subscription);
  };
  MotionValue2.prototype.clearListeners = function() {
    this.updateSubscribers.clear();
  };
  MotionValue2.prototype.onRenderRequest = function(subscription) {
    subscription(this.get());
    return this.renderSubscribers.add(subscription);
  };
  MotionValue2.prototype.attach = function(passiveEffect) {
    this.passiveEffect = passiveEffect;
  };
  MotionValue2.prototype.set = function(v2, render) {
    if (render === void 0) {
      render = true;
    }
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v2, render);
    } else {
      this.passiveEffect(v2, this.updateAndNotify);
    }
  };
  MotionValue2.prototype.get = function() {
    return this.current;
  };
  MotionValue2.prototype.getPrevious = function() {
    return this.prev;
  };
  MotionValue2.prototype.getVelocity = function() {
    return this.canTrackVelocity ? velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  };
  MotionValue2.prototype.start = function(animation) {
    var _this = this;
    this.stop();
    return new Promise(function(resolve) {
      _this.hasAnimated = true;
      _this.stopAnimation = animation(resolve);
    }).then(function() {
      return _this.clearAnimation();
    });
  };
  MotionValue2.prototype.stop = function() {
    if (this.stopAnimation)
      this.stopAnimation();
    this.clearAnimation();
  };
  MotionValue2.prototype.isAnimating = function() {
    return !!this.stopAnimation;
  };
  MotionValue2.prototype.clearAnimation = function() {
    this.stopAnimation = null;
  };
  MotionValue2.prototype.destroy = function() {
    this.updateSubscribers.clear();
    this.renderSubscribers.clear();
    this.stop();
  };
  return MotionValue2;
}();
function motionValue(init3) {
  return new MotionValue(init3);
}
var isMotionValue = function(value) {
  return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};
var secondsToMilliseconds = function(seconds) {
  return seconds * 1e3;
};
var easingLookup = {
  linear,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
};
var easingDefinitionToFunction = function(definition) {
  if (Array.isArray(definition)) {
    invariant(definition.length === 4);
    var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    return easingLookup[definition];
  }
  return definition;
};
var isEasingArray = function(ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};
var isAnimatable = function(key, value) {
  if (key === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && complex.test(value) && !value.startsWith("url(")) {
    return true;
  }
  return false;
};
var isKeyframesTarget = function(v2) {
  return Array.isArray(v2);
};
var underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
};
var criticallyDampedSpring = function(to) {
  return {
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
};
var linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
};
var keyframes = function(values) {
  return {
    type: "keyframes",
    duration: 0.8,
    values
  };
};
var defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
};
var getDefaultTransition = function(valueKey, to) {
  var transitionFactory;
  if (isKeyframesTarget(to)) {
    transitionFactory = keyframes;
  } else {
    transitionFactory = defaultTransitions[valueKey] || defaultTransitions.default;
  }
  return __assign({ to }, transitionFactory(to));
};
var int = __assign(__assign({}, number), { transform: Math.round });
var numberValueTypes = {
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  zIndex: int,
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
var defaultValueTypes = __assign(__assign({}, numberValueTypes), {
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
});
var getDefaultValueType = function(key) {
  return defaultValueTypes[key];
};
function getAnimatableNone(key, value) {
  var _a;
  var defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}
var instantAnimationState = {
  current: false
};
var isCustomValue = function(v2) {
  return Boolean(v2 && typeof v2 === "object" && v2.mix && v2.toValue);
};
var resolveFinalValueInKeyframes = function(v2) {
  return isKeyframesTarget(v2) ? v2[v2.length - 1] || 0 : v2;
};
function isTransitionDefined(_a) {
  _a.when;
  _a.delay;
  _a.delayChildren;
  _a.staggerChildren;
  _a.staggerDirection;
  _a.repeat;
  _a.repeatType;
  _a.repeatDelay;
  _a.from;
  var transition = __rest$1(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(transition).length;
}
function convertTransitionToAnimationOptions(_a) {
  var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = __rest$1(_a, ["ease", "times", "yoyo", "flip", "loop"]);
  var options = __assign({}, transition);
  if (times)
    options["offset"] = times;
  if (transition.duration)
    options["duration"] = secondsToMilliseconds(transition.duration);
  if (transition.repeatDelay)
    options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
  if (ease) {
    options["ease"] = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  }
  if (transition.type === "tween")
    options.type = "keyframes";
  if (yoyo || loop || flip) {
    if (yoyo) {
      options.repeatType = "reverse";
    } else if (loop) {
      options.repeatType = "loop";
    } else if (flip) {
      options.repeatType = "mirror";
    }
    options.repeat = loop || yoyo || flip || transition.repeat;
  }
  if (transition.type !== "spring")
    options.type = "keyframes";
  return options;
}
function getDelayFromTransition(transition, key) {
  var _a, _b;
  var valueTransition = getValueTransition(transition, key) || {};
  return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function hydrateKeyframes(options) {
  if (Array.isArray(options.to) && options.to[0] === null) {
    options.to = __spreadArray([], __read(options.to), false);
    options.to[0] = options.from;
  }
  return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
  var _a;
  if (Array.isArray(options.to)) {
    (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
  }
  hydrateKeyframes(options);
  if (!isTransitionDefined(transition)) {
    transition = __assign(__assign({}, transition), getDefaultTransition(key, options.to));
  }
  return __assign(__assign({}, options), convertTransitionToAnimationOptions(transition));
}
function getAnimation(key, value, target, transition, onComplete) {
  var _a;
  var valueTransition = getValueTransition(transition, key);
  var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
  var isTargetAnimatable = isAnimatable(key, target);
  if (origin === "none" && isTargetAnimatable && typeof target === "string") {
    origin = getAnimatableNone(key, target);
  } else if (isZero(origin) && typeof target === "string") {
    origin = getZeroUnit(target);
  } else if (!Array.isArray(target) && isZero(target) && typeof origin === "string") {
    target = getZeroUnit(origin);
  }
  var isOriginAnimatable = isAnimatable(key, origin);
  function start() {
    var options = {
      from: origin,
      to: target,
      velocity: value.getVelocity(),
      onComplete,
      onUpdate: function(v2) {
        return value.set(v2);
      }
    };
    return valueTransition.type === "inertia" || valueTransition.type === "decay" ? inertia(__assign(__assign({}, options), valueTransition)) : animate$1(__assign(__assign({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function(v2) {
      var _a2;
      options.onUpdate(v2);
      (_a2 = valueTransition.onUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition, v2);
    }, onComplete: function() {
      var _a2;
      options.onComplete();
      (_a2 = valueTransition.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition);
    } }));
  }
  function set2() {
    var _a2, _b;
    var finalTarget = resolveFinalValueInKeyframes(target);
    value.set(finalTarget);
    onComplete();
    (_a2 = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition, finalTarget);
    (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 ? void 0 : _b.call(valueTransition);
    return { stop: function() {
    } };
  }
  return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set2 : start;
}
function isZero(value) {
  return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function getZeroUnit(potentialUnitType) {
  return typeof potentialUnitType === "number" ? 0 : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}
function startAnimation(key, value, target, transition) {
  if (transition === void 0) {
    transition = {};
  }
  if (instantAnimationState.current) {
    transition = { type: false };
  }
  return value.start(function(onComplete) {
    var delayTimer;
    var controls;
    var animation = getAnimation(key, value, target, transition, onComplete);
    var delay = getDelayFromTransition(transition, key);
    var start = function() {
      return controls = animation();
    };
    if (delay) {
      delayTimer = window.setTimeout(start, secondsToMilliseconds(delay));
    } else {
      start();
    }
    return function() {
      clearTimeout(delayTimer);
      controls === null || controls === void 0 ? void 0 : controls.stop();
    };
  });
}
function animate(from, to, transition) {
  if (transition === void 0) {
    transition = {};
  }
  var value = isMotionValue(from) ? from : motionValue(from);
  startAnimation("", value, to, transition);
  return {
    stop: function() {
      return value.stop();
    },
    isAnimating: function() {
      return value.isAnimating();
    }
  };
}
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = function(value) {
  return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function(value) {
  return typeof value === "number" || px.test(value);
};
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  var _a, _b, _c, _d;
  if (shouldCrossfadeOpacity) {
    target.opacity = mix(0, (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, easeCrossfadeIn(progress2));
    target.opacityExit = mix((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, easeCrossfadeOut(progress2));
  } else if (isOnlyMember) {
    target.opacity = mix((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress2);
  }
  for (var i2 = 0; i2 < numBorders; i2++) {
    var borderLabel = "border".concat(borders[i2], "Radius");
    var followRadius = getRadius(follow, borderLabel);
    var leadRadius = getRadius(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    var canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress2), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius(values, radiusName) {
  var _a;
  return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, linear);
function compress(min2, max2, easing) {
  return function(p2) {
    if (p2 < min2)
      return 0;
    if (p2 > max2)
      return 1;
    return easing(progress(min2, max2, p2));
  };
}
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale(_a) {
  var scale2 = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || hasTranslate(values.x) || hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function hasTranslate(value) {
  return value && value !== "0%";
}
function scalePoint(point, scale2, originPoint) {
  var distanceFromOrigin = point - originPoint;
  var scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate, scale2, originPoint, boxScale) {
  if (translate === void 0) {
    translate = 0;
  }
  if (scale2 === void 0) {
    scale2 = 1;
  }
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, _a) {
  var x2 = _a.x, y2 = _a.y;
  applyAxisDelta(box.x, x2.translate, x2.scale, x2.originPoint);
  applyAxisDelta(box.y, y2.translate, y2.scale, y2.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition) {
  var _a, _b;
  if (isSharedTransition === void 0) {
    isSharedTransition = false;
  }
  var treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  var node;
  var delta;
  for (var i2 = 0; i2 < treeLength; i2++) {
    node = treePath[i2];
    delta = node.projectionDelta;
    if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
      continue;
    if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
      transformBox(box, { x: -node.scroll.x, y: -node.scroll.y });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node.latestValues)) {
      transformBox(box, node.latestValues);
    }
  }
}
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis(axis, transforms, _a) {
  var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
  var axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  var originPoint = mix(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"];
var yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(box, transform2) {
  transformAxis(box.x, transform2, xKeys$1);
  transformAxis(box.y, transform2, yKeys$1);
}
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
  if (target === void 0) {
    target = 0;
  }
  if (maxDistance === void 0) {
    maxDistance = 0.01;
  }
  return distance(value, target) < maxDistance;
}
function calcAxisDelta(delta, source2, target, origin) {
  if (origin === void 0) {
    origin = 0.5;
  }
  delta.origin = origin;
  delta.originPoint = mix(source2.min, source2.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source2);
  if (isNear(delta.scale, 1, 1e-4) || isNaN(delta.scale))
    delta.scale = 1;
  delta.translate = mix(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate) || isNaN(delta.translate))
    delta.translate = 0;
}
function calcBoxDelta(delta, source2, target, origin) {
  calcAxisDelta(delta.x, source2.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
  calcAxisDelta(delta.y, source2.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
  target.min = layout.min - parent.min;
  target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
  calcRelativeAxisPosition(target.x, layout.x, parent.x);
  calcRelativeAxisPosition(target.y, layout.y, parent.y);
}
function removePointDelta(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta(axis, translate, scale2, origin, boxScale, originAxis, sourceAxis) {
  if (translate === void 0) {
    translate = 0;
  }
  if (scale2 === void 0) {
    scale2 = 1;
  }
  if (origin === void 0) {
    origin = 0.5;
  }
  if (originAxis === void 0) {
    originAxis = axis;
  }
  if (sourceAxis === void 0) {
    sourceAxis = axis;
  }
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    var relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  var originPoint = mix(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, _a, origin, sourceAxis) {
  var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
  removeAxisTransforms(box.y, transforms, yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}
var createAxisDelta = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
};
var createDelta = function() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
};
var createAxis = function() {
  return { min: 0, max: 0 };
};
var createBox = function() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a6, b2) {
  return a6.x.min === b2.x.min && a6.x.max === b2.x.max && a6.y.min === b2.y.min && a6.y.max === b2.y.max;
}
var NodeStack = function() {
  function NodeStack2() {
    this.members = [];
  }
  NodeStack2.prototype.add = function(node) {
    addUniqueItem(this.members, node);
    node.scheduleRender();
  };
  NodeStack2.prototype.remove = function(node) {
    removeItem(this.members, node);
    if (node === this.prevLead) {
      this.prevLead = void 0;
    }
    if (node === this.lead) {
      var prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  };
  NodeStack2.prototype.relegate = function(node) {
    var indexOfNode = this.members.findIndex(function(member2) {
      return node === member2;
    });
    if (indexOfNode === 0)
      return false;
    var prevLead;
    for (var i2 = indexOfNode; i2 >= 0; i2--) {
      var member = this.members[i2];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  };
  NodeStack2.prototype.promote = function(node, preserveFollowOpacity) {
    var _a;
    var prevLead = this.lead;
    if (node === prevLead)
      return;
    this.prevLead = prevLead;
    this.lead = node;
    node.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node.scheduleRender();
      node.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node.snapshot = prevLead.snapshot;
        node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
        node.snapshot.isShared = true;
      }
      if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
        node.isLayoutDirty = true;
      }
      var crossfade = node.options.crossfade;
      if (crossfade === false) {
        prevLead.hide();
      }
    }
  };
  NodeStack2.prototype.exitAnimationComplete = function() {
    this.members.forEach(function(node) {
      var _a, _b, _c, _d, _e2;
      (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
      (_e2 = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e2 === void 0 ? void 0 : _e2.call(_d);
    });
  };
  NodeStack2.prototype.scheduleRender = function() {
    this.members.forEach(function(node) {
      node.instance && node.scheduleRender(false);
    });
  };
  NodeStack2.prototype.removeLeadSnapshot = function() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = void 0;
    }
  };
  return NodeStack2;
}();
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
var identityProjection = "translate3d(0px, 0px, 0) scale(1, 1)";
function buildProjectionTransform(delta, treeScale, latestTransform) {
  var xTranslate = delta.x.translate / treeScale.x;
  var yTranslate = delta.y.translate / treeScale.y;
  var transform2 = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
  if (latestTransform) {
    var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
    if (rotate)
      transform2 += "rotate(".concat(rotate, "deg) ");
    if (rotateX)
      transform2 += "rotateX(".concat(rotateX, "deg) ");
    if (rotateY)
      transform2 += "rotateY(".concat(rotateY, "deg) ");
  }
  transform2 += "scale(".concat(delta.x.scale, ", ").concat(delta.y.scale, ")");
  return transform2 === identityProjection ? "none" : transform2;
}
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}
var transformAxes = ["", "X", "Y", "Z"];
var order = ["translate", "scale", "rotate", "skew"];
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function(operationKey) {
  return transformAxes.forEach(function(axesKey) {
    return transformProps.push(operationKey + axesKey);
  });
});
function sortTransformProps(a6, b2) {
  return transformProps.indexOf(a6) - transformProps.indexOf(b2);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
  return transformPropSet.has(key);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
  return transformOriginProps.has(key);
}
var compareByDepth = function(a6, b2) {
  return a6.depth - b2.depth;
};
var FlatTree = function() {
  function FlatTree2() {
    this.children = [];
    this.isDirty = false;
  }
  FlatTree2.prototype.add = function(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  };
  FlatTree2.prototype.remove = function(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  };
  FlatTree2.prototype.forEach = function(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  };
  return FlatTree2;
}();
function resolveMotionValue(value) {
  var unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
var animationTarget = 1e3;
var globalProjectionState = {
  hasAnimatedSinceResize: true,
  hasEverUpdated: false
};
function createProjectionNode(_a) {
  var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, resetTransform = _a.resetTransform;
  return function() {
    function ProjectionNode(id2, latestValues, parent) {
      var _this = this;
      if (latestValues === void 0) {
        latestValues = {};
      }
      if (parent === void 0) {
        parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
      }
      this.children = /* @__PURE__ */ new Set();
      this.options = {};
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      this.isLayoutDirty = false;
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      this.isUpdating = false;
      this.isSVG = false;
      this.needsReset = false;
      this.shouldResetTransform = false;
      this.treeScale = { x: 1, y: 1 };
      this.eventHandlers = /* @__PURE__ */ new Map();
      this.potentialNodes = /* @__PURE__ */ new Map();
      this.checkUpdateFailed = function() {
        if (_this.isUpdating) {
          _this.isUpdating = false;
          _this.clearAllSnapshots();
        }
      };
      this.updateProjection = function() {
        _this.nodes.forEach(resolveTargetDelta);
        _this.nodes.forEach(calcProjection);
      };
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      this.sharedNodes = /* @__PURE__ */ new Map();
      this.id = id2;
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? __spreadArray(__spreadArray([], __read(parent.path), false), [parent], false) : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      id2 && this.root.registerPotentialNode(id2, this);
      for (var i2 = 0; i2 < this.path.length; i2++) {
        this.path[i2].shouldResetTransform = true;
      }
      if (this.root === this)
        this.nodes = new FlatTree();
    }
    ProjectionNode.prototype.addEventListener = function(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager());
      }
      return this.eventHandlers.get(name).add(handler);
    };
    ProjectionNode.prototype.notifyListeners = function(name) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      var subscriptionManager = this.eventHandlers.get(name);
      subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify.apply(subscriptionManager, __spreadArray([], __read(args), false));
    };
    ProjectionNode.prototype.hasListeners = function(name) {
      return this.eventHandlers.has(name);
    };
    ProjectionNode.prototype.registerPotentialNode = function(id2, node) {
      this.potentialNodes.set(id2, node);
    };
    ProjectionNode.prototype.mount = function(instance2, isLayoutDirty) {
      var _this = this;
      var _a2;
      if (isLayoutDirty === void 0) {
        isLayoutDirty = false;
      }
      if (this.instance)
        return;
      this.isSVG = instance2 instanceof SVGElement && instance2.tagName !== "svg";
      this.instance = instance2;
      var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement2 = _b.visualElement;
      if (visualElement2 && !visualElement2.getInstance()) {
        visualElement2.mount(instance2);
      }
      this.root.nodes.add(this);
      (_a2 = this.parent) === null || _a2 === void 0 ? void 0 : _a2.children.add(this);
      this.id && this.root.potentialNodes.delete(this.id);
      if (isLayoutDirty && (layout || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        var unblockTimeout_1;
        var resizeUnblockUpdate_1 = function() {
          return _this.root.updateBlockedByResize = false;
        };
        attachResizeListener(instance2, function() {
          _this.root.updateBlockedByResize = true;
          clearTimeout(unblockTimeout_1);
          unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
          if (globalProjectionState.hasAnimatedSinceResize) {
            globalProjectionState.hasAnimatedSinceResize = false;
            _this.nodes.forEach(finishAnimation);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      if (this.options.animate !== false && visualElement2 && (layoutId || layout)) {
        this.addEventListener("didUpdate", function(_a3) {
          var _b2, _c, _d, _e2, _f;
          var delta = _a3.delta, hasLayoutChanged = _a3.hasLayoutChanged, hasRelativeTargetChanged = _a3.hasRelativeTargetChanged, newLayout = _a3.layout;
          if (_this.isTreeAnimationBlocked()) {
            _this.target = void 0;
            _this.relativeTarget = void 0;
            return;
          }
          var layoutTransition = (_c = (_b2 = _this.options.transition) !== null && _b2 !== void 0 ? _b2 : visualElement2.getDefaultTransition()) !== null && _c !== void 0 ? _c : defaultLayoutTransition;
          var _g = visualElement2.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
          var targetChanged = !_this.targetLayout || !boxEquals(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
          var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
            if (_this.resumeFrom) {
              _this.resumingFrom = _this.resumeFrom;
              _this.resumingFrom.resumingFrom = void 0;
            }
            _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            var animationOptions = __assign(__assign({}, getValueTransition(layoutTransition, "layout")), { onPlay: onLayoutAnimationStart, onComplete: onLayoutAnimationComplete });
            if (visualElement2.shouldReduceMotion) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            _this.startAnimation(animationOptions);
          } else {
            if (!hasLayoutChanged && _this.animationProgress === 0) {
              _this.finishAnimation();
            }
            _this.isLead() && ((_f = (_e2 = _this.options).onExitComplete) === null || _f === void 0 ? void 0 : _f.call(_e2));
          }
          _this.targetLayout = newLayout;
        });
      }
    };
    ProjectionNode.prototype.unmount = function() {
      var _a2, _b;
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      (_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.remove(this);
      (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
      this.instance = void 0;
      cancelSync.preRender(this.updateProjection);
    };
    ProjectionNode.prototype.blockUpdate = function() {
      this.updateManuallyBlocked = true;
    };
    ProjectionNode.prototype.unblockUpdate = function() {
      this.updateManuallyBlocked = false;
    };
    ProjectionNode.prototype.isUpdateBlocked = function() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    };
    ProjectionNode.prototype.isTreeAnimationBlocked = function() {
      var _a2;
      return this.isAnimationBlocked || ((_a2 = this.parent) === null || _a2 === void 0 ? void 0 : _a2.isTreeAnimationBlocked()) || false;
    };
    ProjectionNode.prototype.startUpdate = function() {
      var _a2;
      if (this.isUpdateBlocked())
        return;
      this.isUpdating = true;
      (_a2 = this.nodes) === null || _a2 === void 0 ? void 0 : _a2.forEach(resetRotation);
    };
    ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
      var _a2, _b, _c;
      if (shouldNotifyListeners === void 0) {
        shouldNotifyListeners = true;
      }
      if (this.root.isUpdateBlocked()) {
        (_b = (_a2 = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a2);
        return;
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty)
        return;
      this.isLayoutDirty = true;
      for (var i2 = 0; i2 < this.path.length; i2++) {
        var node = this.path[i2];
        node.shouldResetTransform = true;
        node.updateScroll();
      }
      var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
      if (layoutId === void 0 && !layout)
        return;
      var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
      this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    };
    ProjectionNode.prototype.didUpdate = function() {
      var updateWasBlocked = this.isUpdateBlocked();
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements);
        return;
      }
      if (!this.isUpdating)
        return;
      this.isUpdating = false;
      if (this.potentialNodes.size) {
        this.potentialNodes.forEach(mountNodeEarly);
        this.potentialNodes.clear();
      }
      this.nodes.forEach(resetTransformStyle);
      this.nodes.forEach(updateLayout);
      this.nodes.forEach(notifyLayoutUpdate);
      this.clearAllSnapshots();
      flushSync.update();
      flushSync.preRender();
      flushSync.render();
    };
    ProjectionNode.prototype.clearAllSnapshots = function() {
      this.nodes.forEach(clearSnapshot);
      this.sharedNodes.forEach(removeLeadSnapshots);
    };
    ProjectionNode.prototype.scheduleUpdateProjection = function() {
      sync.preRender(this.updateProjection, false, true);
    };
    ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
      var _this = this;
      sync.postRender(function() {
        if (_this.isLayoutDirty) {
          _this.root.didUpdate();
        } else {
          _this.root.checkUpdateFailed();
        }
      });
    };
    ProjectionNode.prototype.updateSnapshot = function() {
      if (this.snapshot || !this.instance)
        return;
      var measured = this.measure();
      var layout = this.removeTransform(this.removeElementScroll(measured));
      roundBox(layout);
      this.snapshot = {
        measured,
        layout,
        latestValues: {}
      };
    };
    ProjectionNode.prototype.updateLayout = function() {
      var _a2;
      if (!this.instance)
        return;
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (var i2 = 0; i2 < this.path.length; i2++) {
          var node = this.path[i2];
          node.updateScroll();
        }
      }
      var measured = this.measure();
      roundBox(measured);
      var prevLayout = this.layout;
      this.layout = {
        measured,
        actual: this.removeElementScroll(measured)
      };
      this.layoutCorrected = createBox();
      this.isLayoutDirty = false;
      this.projectionDelta = void 0;
      this.notifyListeners("measure", this.layout.actual);
      (_a2 = this.options.visualElement) === null || _a2 === void 0 ? void 0 : _a2.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
    };
    ProjectionNode.prototype.updateScroll = function() {
      if (this.options.layoutScroll && this.instance) {
        this.scroll = measureScroll(this.instance);
      }
    };
    ProjectionNode.prototype.resetTransform = function() {
      var _a2;
      if (!resetTransform)
        return;
      var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
      var hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
      var transformTemplate = (_a2 = this.options.visualElement) === null || _a2 === void 0 ? void 0 : _a2.getProps().transformTemplate;
      var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
      var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    };
    ProjectionNode.prototype.measure = function() {
      var visualElement2 = this.options.visualElement;
      if (!visualElement2)
        return createBox();
      var box = visualElement2.measureViewportBox();
      var scroll = this.root.scroll;
      if (scroll) {
        translateAxis(box.x, scroll.x);
        translateAxis(box.y, scroll.y);
      }
      return box;
    };
    ProjectionNode.prototype.removeElementScroll = function(box) {
      var boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      for (var i2 = 0; i2 < this.path.length; i2++) {
        var node = this.path[i2];
        var scroll_1 = node.scroll, options = node.options;
        if (node !== this.root && scroll_1 && options.layoutScroll) {
          translateAxis(boxWithoutScroll.x, scroll_1.x);
          translateAxis(boxWithoutScroll.y, scroll_1.y);
        }
      }
      return boxWithoutScroll;
    };
    ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
      if (transformOnly === void 0) {
        transformOnly = false;
      }
      var withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (var i2 = 0; i2 < this.path.length; i2++) {
        var node = this.path[i2];
        if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
          transformBox(withTransforms, {
            x: -node.scroll.x,
            y: -node.scroll.y
          });
        }
        if (!hasTransform(node.latestValues))
          continue;
        transformBox(withTransforms, node.latestValues);
      }
      if (hasTransform(this.latestValues)) {
        transformBox(withTransforms, this.latestValues);
      }
      return withTransforms;
    };
    ProjectionNode.prototype.removeTransform = function(box) {
      var _a2;
      var boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (var i2 = 0; i2 < this.path.length; i2++) {
        var node = this.path[i2];
        if (!node.instance)
          continue;
        if (!hasTransform(node.latestValues))
          continue;
        hasScale(node.latestValues) && node.updateSnapshot();
        var sourceBox = createBox();
        var nodeBox = node.measure();
        copyBoxInto(sourceBox, nodeBox);
        removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a2 = node.snapshot) === null || _a2 === void 0 ? void 0 : _a2.layout, sourceBox);
      }
      if (hasTransform(this.latestValues)) {
        removeBoxTransforms(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    };
    ProjectionNode.prototype.setTargetDelta = function(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
    };
    ProjectionNode.prototype.setOptions = function(options) {
      var _a2;
      this.options = __assign(__assign(__assign({}, this.options), options), { crossfade: (_a2 = options.crossfade) !== null && _a2 !== void 0 ? _a2 : true });
    };
    ProjectionNode.prototype.clearMeasurements = function() {
      this.scroll = void 0;
      this.layout = void 0;
      this.snapshot = void 0;
      this.prevTransformTemplateValue = void 0;
      this.targetDelta = void 0;
      this.target = void 0;
      this.isLayoutDirty = false;
    };
    ProjectionNode.prototype.resolveTargetDelta = function() {
      var _a2;
      var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
      if (!this.layout || !(layout || layoutId))
        return;
      if (!this.targetDelta && !this.relativeTarget) {
        this.relativeParent = this.getClosestProjectingParent();
        if (this.relativeParent && this.relativeParent.layout) {
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        }
      }
      if (!this.relativeTarget && !this.targetDelta)
        return;
      if (!this.target) {
        this.target = createBox();
        this.targetWithTransforms = createBox();
      }
      if (this.relativeTarget && this.relativeTargetOrigin && ((_a2 = this.relativeParent) === null || _a2 === void 0 ? void 0 : _a2.target)) {
        calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          this.target = this.applyTransform(this.layout.actual);
        } else {
          copyBoxInto(this.target, this.layout.actual);
        }
        applyBoxDelta(this.target, this.targetDelta);
      } else {
        copyBoxInto(this.target, this.layout.actual);
      }
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        this.relativeParent = this.getClosestProjectingParent();
        if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        }
      }
    };
    ProjectionNode.prototype.getClosestProjectingParent = function() {
      if (!this.parent || hasTransform(this.parent.latestValues))
        return void 0;
      if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    };
    ProjectionNode.prototype.calcProjection = function() {
      var _a2;
      var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
      this.isTreeAnimating = Boolean(((_a2 = this.parent) === null || _a2 === void 0 ? void 0 : _a2.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = void 0;
      }
      if (!this.layout || !(layout || layoutId))
        return;
      var lead = this.getLead();
      copyBoxInto(this.layoutCorrected, this.layout.actual);
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
      var target = lead.target;
      if (!target)
        return;
      if (!this.projectionDelta) {
        this.projectionDelta = createDelta();
        this.projectionDeltaWithTransform = createDelta();
      }
      var prevTreeScaleX = this.treeScale.x;
      var prevTreeScaleY = this.treeScale.y;
      var prevProjectionTransform = this.projectionTransform;
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
      if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
    };
    ProjectionNode.prototype.hide = function() {
      this.isVisible = false;
    };
    ProjectionNode.prototype.show = function() {
      this.isVisible = true;
    };
    ProjectionNode.prototype.scheduleRender = function(notifyAll) {
      var _a2, _b, _c;
      if (notifyAll === void 0) {
        notifyAll = true;
      }
      (_b = (_a2 = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a2);
      notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = void 0;
      }
    };
    ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
      var _this = this;
      var _a2;
      if (hasOnlyRelativeTargetChanged === void 0) {
        hasOnlyRelativeTargetChanged = false;
      }
      var snapshot = this.snapshot;
      var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
      var mixedValues = __assign({}, this.latestValues);
      var targetDelta = createDelta();
      this.relativeTarget = this.relativeTargetOrigin = void 0;
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      var relativeLayout = createBox();
      var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
      var isOnlyMember = (((_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.members.length) || 0) <= 1;
      var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      this.mixTargetDelta = function(latest) {
        var _a3;
        var progress2 = latest / 1e3;
        mixAxisDelta(targetDelta.x, delta.x, progress2);
        mixAxisDelta(targetDelta.y, delta.y, progress2);
        _this.setTargetDelta(targetDelta);
        if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a3 = _this.relativeParent) === null || _a3 === void 0 ? void 0 : _a3.layout)) {
          calcRelativePosition(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
          mixBox(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress2);
        }
        if (isSharedLayoutAnimation) {
          _this.animationValues = mixedValues;
          mixValues(mixedValues, snapshotLatestValues, _this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
        }
        _this.root.scheduleUpdateProjection();
        _this.scheduleRender();
        _this.animationProgress = progress2;
      };
      this.mixTargetDelta(0);
    };
    ProjectionNode.prototype.startAnimation = function(options) {
      var _this = this;
      var _a2, _b;
      this.notifyListeners("animationStart");
      (_a2 = this.currentAnimation) === null || _a2 === void 0 ? void 0 : _a2.stop();
      if (this.resumingFrom) {
        (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
      }
      if (this.pendingAnimation) {
        cancelSync.update(this.pendingAnimation);
        this.pendingAnimation = void 0;
      }
      this.pendingAnimation = sync.update(function() {
        globalProjectionState.hasAnimatedSinceResize = true;
        _this.currentAnimation = animate(0, animationTarget, __assign(__assign({}, options), { onUpdate: function(latest) {
          var _a3;
          _this.mixTargetDelta(latest);
          (_a3 = options.onUpdate) === null || _a3 === void 0 ? void 0 : _a3.call(options, latest);
        }, onComplete: function() {
          var _a3;
          (_a3 = options.onComplete) === null || _a3 === void 0 ? void 0 : _a3.call(options);
          _this.completeAnimation();
        } }));
        if (_this.resumingFrom) {
          _this.resumingFrom.currentAnimation = _this.currentAnimation;
        }
        _this.pendingAnimation = void 0;
      });
    };
    ProjectionNode.prototype.completeAnimation = function() {
      var _a2;
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = void 0;
        this.resumingFrom.preserveOpacity = void 0;
      }
      (_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
      this.notifyListeners("animationComplete");
    };
    ProjectionNode.prototype.finishAnimation = function() {
      var _a2;
      if (this.currentAnimation) {
        (_a2 = this.mixTargetDelta) === null || _a2 === void 0 ? void 0 : _a2.call(this, animationTarget);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    };
    ProjectionNode.prototype.applyTransformsToTarget = function() {
      var _a2 = this.getLead(), targetWithTransforms = _a2.targetWithTransforms, target = _a2.target, layout = _a2.layout, latestValues = _a2.latestValues;
      if (!targetWithTransforms || !target || !layout)
        return;
      copyBoxInto(targetWithTransforms, target);
      transformBox(targetWithTransforms, latestValues);
      calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    };
    ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
      var _a2, _b, _c;
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack());
      }
      var stack2 = this.sharedNodes.get(layoutId);
      stack2.add(node);
      node.promote({
        transition: (_a2 = node.options.initialPromotionConfig) === null || _a2 === void 0 ? void 0 : _a2.transition,
        preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
      });
    };
    ProjectionNode.prototype.isLead = function() {
      var stack2 = this.getStack();
      return stack2 ? stack2.lead === this : true;
    };
    ProjectionNode.prototype.getLead = function() {
      var _a2;
      var layoutId = this.options.layoutId;
      return layoutId ? ((_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.lead) || this : this;
    };
    ProjectionNode.prototype.getPrevLead = function() {
      var _a2;
      var layoutId = this.options.layoutId;
      return layoutId ? (_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.prevLead : void 0;
    };
    ProjectionNode.prototype.getStack = function() {
      var layoutId = this.options.layoutId;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    };
    ProjectionNode.prototype.promote = function(_a2) {
      var _b = _a2 === void 0 ? {} : _a2, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
      var stack2 = this.getStack();
      if (stack2)
        stack2.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = void 0;
        this.needsReset = true;
      }
      if (transition)
        this.setOptions({ transition });
    };
    ProjectionNode.prototype.relegate = function() {
      var stack2 = this.getStack();
      if (stack2) {
        return stack2.relegate(this);
      } else {
        return false;
      }
    };
    ProjectionNode.prototype.resetRotation = function() {
      var visualElement2 = this.options.visualElement;
      if (!visualElement2)
        return;
      var hasRotate = false;
      var resetValues = {};
      for (var i2 = 0; i2 < transformAxes.length; i2++) {
        var axis = transformAxes[i2];
        var key = "rotate" + axis;
        if (!visualElement2.getStaticValue(key)) {
          continue;
        }
        hasRotate = true;
        resetValues[key] = visualElement2.getStaticValue(key);
        visualElement2.setStaticValue(key, 0);
      }
      if (!hasRotate)
        return;
      visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.syncRender();
      for (var key in resetValues) {
        visualElement2.setStaticValue(key, resetValues[key]);
      }
      visualElement2.scheduleRender();
    };
    ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
      var _a2, _b, _c, _d, _e2, _f;
      if (styleProp === void 0) {
        styleProp = {};
      }
      var styles = {};
      if (!this.instance || this.isSVG)
        return styles;
      if (!this.isVisible) {
        return { visibility: "hidden" };
      } else {
        styles.visibility = "";
      }
      var transformTemplate = (_a2 = this.options.visualElement) === null || _a2 === void 0 ? void 0 : _a2.getProps().transformTemplate;
      if (this.needsReset) {
        this.needsReset = false;
        styles.opacity = "";
        styles.pointerEvents = resolveMotionValue(styleProp.pointerEvents) || "";
        styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles;
      }
      var lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        var emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
          emptyStyles.pointerEvents = resolveMotionValue(styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      var valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles.transform = transformTemplate(valuesToRender, styles.transform);
      }
      var _g = this.projectionDelta, x2 = _g.x, y2 = _g.y;
      styles.transformOrigin = "".concat(x2.origin * 100, "% ").concat(y2.origin * 100, "% 0");
      if (lead.animationValues) {
        styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        styles.opacity = lead === this ? (_e2 = valuesToRender.opacity) !== null && _e2 !== void 0 ? _e2 : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
      }
      for (var key in scaleCorrectors) {
        if (valuesToRender[key] === void 0)
          continue;
        var _h = scaleCorrectors[key], correct = _h.correct, applyTo = _h.applyTo;
        var corrected = correct(valuesToRender[key], lead);
        if (applyTo) {
          var num = applyTo.length;
          for (var i2 = 0; i2 < num; i2++) {
            styles[applyTo[i2]] = corrected;
          }
        } else {
          styles[key] = corrected;
        }
      }
      if (this.options.layoutId) {
        styles.pointerEvents = lead === this ? resolveMotionValue(styleProp.pointerEvents) || "" : "none";
      }
      return styles;
    };
    ProjectionNode.prototype.clearSnapshot = function() {
      this.resumeFrom = this.snapshot = void 0;
    };
    ProjectionNode.prototype.resetTree = function() {
      this.root.nodes.forEach(function(node) {
        var _a2;
        return (_a2 = node.currentAnimation) === null || _a2 === void 0 ? void 0 : _a2.stop();
      });
      this.root.nodes.forEach(clearMeasurements);
      this.root.sharedNodes.clear();
    };
    return ProjectionNode;
  }();
}
function updateLayout(node) {
  node.updateLayout();
}
function notifyLayoutUpdate(node) {
  var _a, _b, _c, _d;
  var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
  if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
    var _e2 = node.layout, layout_1 = _e2.actual, measuredLayout = _e2.measured;
    if (node.options.animationType === "size") {
      eachAxis(function(axis) {
        var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
        var length = calcLength(axisSnapshot);
        axisSnapshot.min = layout_1[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (node.options.animationType === "position") {
      eachAxis(function(axis) {
        var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
        var length = calcLength(layout_1[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
      });
    }
    var layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout_1, snapshot.layout);
    var visualDelta = createDelta();
    if (snapshot.isShared) {
      calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
    } else {
      calcBoxDelta(visualDelta, layout_1, snapshot.layout);
    }
    var hasLayoutChanged = !isDeltaZero(layoutDelta);
    var hasRelativeTargetChanged = false;
    if (!node.resumeFrom) {
      node.relativeParent = node.getClosestProjectingParent();
      if (node.relativeParent && !node.relativeParent.resumeFrom) {
        var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
        if (parentSnapshot && parentLayout) {
          var relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
          var relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout_1, parentLayout.actual);
          if (!boxEquals(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
        }
      }
    }
    node.notifyListeners("didUpdate", {
      layout: layout_1,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node.isLead()) {
    (_d = (_c = node.options).onExitComplete) === null || _d === void 0 ? void 0 : _d.call(_c);
  }
  node.options.transition = void 0;
}
function clearSnapshot(node) {
  node.clearSnapshot();
}
function clearMeasurements(node) {
  node.clearMeasurements();
}
function resetTransformStyle(node) {
  var visualElement2 = node.options.visualElement;
  if (visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.getProps().onBeforeLayoutMeasure) {
    visualElement2.notifyBeforeLayoutMeasure();
  }
  node.resetTransform();
}
function finishAnimation(node) {
  node.finishAnimation();
  node.targetDelta = node.relativeTarget = node.target = void 0;
}
function resolveTargetDelta(node) {
  node.resolveTargetDelta();
}
function calcProjection(node) {
  node.calcProjection();
}
function resetRotation(node) {
  node.resetRotation();
}
function removeLeadSnapshots(stack2) {
  stack2.removeLeadSnapshot();
}
function mixAxisDelta(output2, delta, p2) {
  output2.translate = mix(delta.translate, 0, p2);
  output2.scale = mix(delta.scale, 1, p2);
  output2.origin = delta.origin;
  output2.originPoint = delta.originPoint;
}
function mixAxis(output2, from, to, p2) {
  output2.min = mix(from.min, to.min, p2);
  output2.max = mix(from.max, to.max, p2);
}
function mixBox(output2, from, to, p2) {
  mixAxis(output2.x, from.x, to.x, p2);
  mixAxis(output2.y, from.y, to.y, p2);
}
function hasOpacityCrossfade(node) {
  return node.animationValues && node.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function mountNodeEarly(node, id2) {
  var searchNode = node.root;
  for (var i2 = node.path.length - 1; i2 >= 0; i2--) {
    if (Boolean(node.path[i2].instance)) {
      searchNode = node.path[i2];
      break;
    }
  }
  var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
  var element = searchElement.querySelector('[data-projection-id="'.concat(id2, '"]'));
  if (element)
    node.mount(element, true);
}
function roundAxis(axis) {
  axis.min = Math.round(axis.min);
  axis.max = Math.round(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
var id = 1;
function useProjectionId() {
  return useConstant(function() {
    if (globalProjectionState.hasEverUpdated) {
      return id++;
    }
  });
}
var LayoutGroupContext = createContext({});
var SwitchLayoutGroupContext = createContext({});
function useProjection(projectionId, _a, visualElement2, ProjectionNodeConstructor) {
  var _b;
  var layoutId = _a.layoutId, layout = _a.layout, drag2 = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
  var initialPromotionConfig = useContext(SwitchLayoutGroupContext);
  if (!ProjectionNodeConstructor || !visualElement2 || (visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.projection)) {
    return;
  }
  visualElement2.projection = new ProjectionNodeConstructor(projectionId, visualElement2.getLatestValues(), (_b = visualElement2.parent) === null || _b === void 0 ? void 0 : _b.projection);
  visualElement2.projection.setOptions({
    layoutId,
    layout,
    alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject(dragConstraints),
    visualElement: visualElement2,
    scheduleRender: function() {
      return visualElement2.scheduleRender();
    },
    animationType: typeof layout === "string" ? layout : "both",
    initialPromotionConfig,
    layoutScroll
  });
}
var VisualElementHandler = function(_super) {
  __extends(VisualElementHandler2, _super);
  function VisualElementHandler2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  VisualElementHandler2.prototype.getSnapshotBeforeUpdate = function() {
    this.updateProps();
    return null;
  };
  VisualElementHandler2.prototype.componentDidUpdate = function() {
  };
  VisualElementHandler2.prototype.updateProps = function() {
    var _a = this.props, visualElement2 = _a.visualElement, props = _a.props;
    if (visualElement2)
      visualElement2.setProps(props);
  };
  VisualElementHandler2.prototype.render = function() {
    return this.props.children;
  };
  return VisualElementHandler2;
}(React__default.Component);
function createMotionComponent(_a) {
  var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component2 = _a.Component;
  preloadedFeatures && loadFeatures(preloadedFeatures);
  function MotionComponent(props, externalRef) {
    var layoutId = useLayoutId(props);
    props = __assign(__assign({}, props), { layoutId });
    var config2 = useContext(MotionConfigContext);
    var features = null;
    var context2 = useCreateMotionContext(props);
    var projectionId = config2.isStatic ? void 0 : useProjectionId();
    var visualState = useVisualState(props, config2.isStatic);
    if (!config2.isStatic && isBrowser) {
      context2.visualElement = useVisualElement(Component2, visualState, __assign(__assign({}, config2), props), createVisualElement);
      useProjection(projectionId, props, context2.visualElement, projectionNodeConstructor || featureDefinitions.projectionNodeConstructor);
      features = useFeatures(props, context2.visualElement);
    }
    return React$1.createElement(VisualElementHandler, { visualElement: context2.visualElement, props: __assign(__assign({}, config2), props) }, features, React$1.createElement(MotionContext.Provider, { value: context2 }, useRender(Component2, props, projectionId, useMotionRef(visualState, context2.visualElement, externalRef), visualState, config2.isStatic, context2.visualElement)));
  }
  return forwardRef(MotionComponent);
}
function useLayoutId(_a) {
  var _b;
  var layoutId = _a.layoutId;
  var layoutGroupId = (_b = useContext(LayoutGroupContext)) === null || _b === void 0 ? void 0 : _b.id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
function createMotionProxy(createConfig) {
  function custom(Component2, customMotionComponentConfig) {
    if (customMotionComponentConfig === void 0) {
      customMotionComponentConfig = {};
    }
    return createMotionComponent(createConfig(Component2, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom;
  }
  var componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom, {
    get: function(_target, key) {
      if (!componentCache.has(key)) {
        componentCache.set(key, custom(key));
      }
      return componentCache.get(key);
    }
  });
}
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Component2) {
  if (typeof Component2 !== "string" || Component2.includes("-")) {
    return false;
  } else if (lowercaseSVGElements.indexOf(Component2) > -1 || /[A-Z]/.test(Component2)) {
    return true;
  }
  return false;
}
function isForcedMotionValue(key, _a) {
  var layout = _a.layout, layoutId = _a.layoutId;
  return isTransformProp(key) || isTransformOriginProp(key) || (layout || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
}
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
  var transform2 = _a.transform, transformKeys2 = _a.transformKeys;
  var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
  var transformString = "";
  transformKeys2.sort(sortTransformProps);
  var transformHasZ = false;
  var numTransformKeys = transformKeys2.length;
  for (var i2 = 0; i2 < numTransformKeys; i2++) {
    var key = transformKeys2[i2];
    transformString += "".concat(translateAlias[key] || key, "(").concat(transform2[key], ") ");
    if (key === "z")
      transformHasZ = true;
  }
  if (!transformHasZ && enableHardwareAcceleration) {
    transformString += "translateZ(0)";
  } else {
    transformString = transformString.trim();
  }
  if (transformTemplate) {
    transformString = transformTemplate(transform2, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
function buildTransformOrigin(_a) {
  var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
  return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}
function isCSSVariable$1(key) {
  return key.startsWith("--");
}
var getValueAsType = function(value, type) {
  return type && typeof value === "number" ? type.transform(value) : value;
};
function buildHTMLStyles(state2, latestValues, options, transformTemplate) {
  var _a;
  var style = state2.style, vars = state2.vars, transform2 = state2.transform, transformKeys2 = state2.transformKeys, transformOrigin = state2.transformOrigin;
  transformKeys2.length = 0;
  var hasTransform2 = false;
  var hasTransformOrigin = false;
  var transformIsNone = true;
  for (var key in latestValues) {
    var value = latestValues[key];
    if (isCSSVariable$1(key)) {
      vars[key] = value;
      continue;
    }
    var valueType = numberValueTypes[key];
    var valueAsType = getValueAsType(value, valueType);
    if (isTransformProp(key)) {
      hasTransform2 = true;
      transform2[key] = valueAsType;
      transformKeys2.push(key);
      if (!transformIsNone)
        continue;
      if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
        transformIsNone = false;
    } else if (isTransformOriginProp(key)) {
      transformOrigin[key] = valueAsType;
      hasTransformOrigin = true;
    } else {
      style[key] = valueAsType;
    }
  }
  if (hasTransform2) {
    style.transform = buildTransform(state2, options, transformIsNone, transformTemplate);
  } else if (transformTemplate) {
    style.transform = transformTemplate({}, "");
  } else if (!latestValues.transform && style.transform) {
    style.transform = "none";
  }
  if (hasTransformOrigin) {
    style.transformOrigin = buildTransformOrigin(transformOrigin);
  }
}
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function copyRawValuesOnly(target, source2, props) {
  for (var key in source2) {
    if (!isMotionValue(source2[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source2[key];
    }
  }
}
function useInitialMotionValues(_a, visualState, isStatic) {
  var transformTemplate = _a.transformTemplate;
  return useMemo(function() {
    var state2 = createHtmlRenderState();
    buildHTMLStyles(state2, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    var vars = state2.vars, style = state2.style;
    return __assign(__assign({}, vars), style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  var styleProp = props.style || {};
  var style = {};
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  if (props.transformValues) {
    style = props.transformValues(style);
  }
  return style;
}
function useHTMLProps(props, visualState, isStatic) {
  var htmlProps = {};
  var style = useStyle(props, visualState, isStatic);
  if (Boolean(props.drag) && props.dragListener !== false) {
    htmlProps.draggable = false;
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
  }
  htmlProps.style = style;
  return htmlProps;
}
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function isValidMotionProp(key) {
  return validMotionProps.has(key);
}
var shouldForward = function(key) {
  return !isValidMotionProp(key);
};
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward = function(key) {
    return key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
  };
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
  var filteredProps = {};
  for (var key in props) {
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}
function calcOrigin$1(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
  var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
  return "".concat(pxOriginX, " ").concat(pxOriginY);
}
var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length, spacing, offset, useDashCase) {
  if (spacing === void 0) {
    spacing = 1;
  }
  if (offset === void 0) {
    offset = 0;
  }
  if (useDashCase === void 0) {
    useDashCase = true;
  }
  attrs.pathLength = 1;
  var keys = useDashCase ? dashKeys : camelKeys;
  attrs[keys.offset] = px.transform(-offset);
  var pathLength = px.transform(length);
  var pathSpacing = px.transform(spacing);
  attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}
function buildSVGAttrs(state2, _a, options, transformTemplate) {
  var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, latest = __rest$1(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(state2, latest, options, transformTemplate);
  state2.attrs = state2.style;
  state2.style = {};
  var attrs = state2.attrs, style = state2.style, dimensions = state2.dimensions;
  if (attrs.transform) {
    if (dimensions)
      style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (pathLength !== void 0) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}
var createSvgRenderState = function() {
  return __assign(__assign({}, createHtmlRenderState()), { attrs: {} });
};
function useSVGProps(props, visualState) {
  var visualProps = useMemo(function() {
    var state2 = createSvgRenderState();
    buildSVGAttrs(state2, visualState, { enableHardwareAcceleration: false }, props.transformTemplate);
    return __assign(__assign({}, state2.attrs), { style: __assign({}, state2.style) });
  }, [visualState]);
  if (props.style) {
    var rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = __assign(__assign({}, rawStyles), visualProps.style);
  }
  return visualProps;
}
function createUseRender(forwardMotionProps) {
  if (forwardMotionProps === void 0) {
    forwardMotionProps = false;
  }
  var useRender = function(Component2, props, projectionId, ref, _a, isStatic) {
    var latestValues = _a.latestValues;
    var useVisualProps = isSVGComponent(Component2) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic);
    var filteredProps = filterProps(props, typeof Component2 === "string", forwardMotionProps);
    var elementProps = __assign(__assign(__assign({}, filteredProps), visualProps), { ref });
    if (projectionId) {
      elementProps["data-projection-id"] = projectionId;
    }
    return createElement(Component2, elementProps);
  };
  return useRender;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
var camelToDash = function(str) {
  return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(element, _a, styleProp, projection) {
  var style = _a.style, vars = _a.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function renderSVG(element, renderState) {
  renderHTML(element, renderState);
  for (var key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}
function scrapeMotionValuesFromProps$1(props) {
  var style = props.style;
  var newValues = {};
  for (var key in style) {
    if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}
function scrapeMotionValuesFromProps(props) {
  var newValues = scrapeMotionValuesFromProps$1(props);
  for (var key in props) {
    if (isMotionValue(props[key])) {
      var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}
function isAnimationControls(v2) {
  return typeof v2 === "object" && typeof v2.start === "function";
}
function makeState(_a, props, context2, presenceContext) {
  var scrapeMotionValuesFromProps2 = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
  var state2 = {
    latestValues: makeLatestValues(props, context2, presenceContext, scrapeMotionValuesFromProps2),
    renderState: createRenderState()
  };
  if (onMount) {
    state2.mount = function(instance2) {
      return onMount(props, instance2, state2);
    };
  }
  return state2;
}
var makeUseVisualState = function(config2) {
  return function(props, isStatic) {
    var context2 = useContext(MotionContext);
    var presenceContext = useContext(PresenceContext);
    return isStatic ? makeState(config2, props, context2, presenceContext) : useConstant(function() {
      return makeState(config2, props, context2, presenceContext);
    });
  };
};
function makeLatestValues(props, context2, presenceContext, scrapeMotionValues) {
  var values = {};
  var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
  var motionValues = scrapeMotionValues(props);
  for (var key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  var initial = props.initial, animate2 = props.animate;
  var isControllingVariants = checkIfControllingVariants(props);
  var isVariantNode = checkIfVariantNode(props);
  if (context2 && isVariantNode && !isControllingVariants && props.inherit !== false) {
    initial !== null && initial !== void 0 ? initial : initial = context2.initial;
    animate2 !== null && animate2 !== void 0 ? animate2 : animate2 = context2.animate;
  }
  var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
  var variantToSet = initialAnimationIsBlocked ? animate2 : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach(function(definition) {
      var resolved = resolveVariantFromProps(props, definition);
      if (!resolved)
        return;
      var transitionEnd = resolved.transitionEnd;
      resolved.transition;
      var target = __rest$1(resolved, ["transitionEnd", "transition"]);
      for (var key2 in target) {
        var valueTarget = target[key2];
        if (Array.isArray(valueTarget)) {
          var index2 = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index2];
        }
        if (valueTarget !== null) {
          values[key2] = valueTarget;
        }
      }
      for (var key2 in transitionEnd)
        values[key2] = transitionEnd[key2];
    });
  }
  return values;
}
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function(props, instance2, _a) {
      var renderState = _a.renderState, latestValues = _a.latestValues;
      try {
        renderState.dimensions = typeof instance2.getBBox === "function" ? instance2.getBBox() : instance2.getBoundingClientRect();
      } catch (e2) {
        renderState.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, props.transformTemplate);
      renderSVG(instance2, renderState);
    }
  })
};
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(Component2, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
  var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
  var baseConfig = isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig;
  return __assign(__assign({}, baseConfig), { preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement, projectionNodeConstructor, Component: Component2 });
}
var AnimationType;
(function(AnimationType2) {
  AnimationType2["Animate"] = "animate";
  AnimationType2["Hover"] = "whileHover";
  AnimationType2["Tap"] = "whileTap";
  AnimationType2["Drag"] = "whileDrag";
  AnimationType2["Focus"] = "whileFocus";
  AnimationType2["InView"] = "whileInView";
  AnimationType2["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return function() {
    return target.removeEventListener(eventName, handler, options);
  };
}
function useDomEvent(ref, eventName, handler, options) {
  useEffect(function() {
    var element = ref.current;
    if (handler && element) {
      return addDomEvent(element, eventName, handler, options);
    }
  }, [ref, eventName, handler, options]);
}
function useFocusGesture(_a) {
  var whileFocus = _a.whileFocus, visualElement2 = _a.visualElement;
  var onFocus = function() {
    var _a2;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Focus, true);
  };
  var onBlur = function() {
    var _a2;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Focus, false);
  };
  useDomEvent(visualElement2, "focus", whileFocus ? onFocus : void 0);
  useDomEvent(visualElement2, "blur", whileFocus ? onBlur : void 0);
}
function isMouseEvent(event) {
  if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
    return !!(event.pointerType === "mouse");
  }
  return event instanceof MouseEvent;
}
function isTouchEvent(event) {
  var hasTouches = !!event.touches;
  return hasTouches;
}
function filterPrimaryPointer(eventHandler) {
  return function(event) {
    var isMouseEvent2 = event instanceof MouseEvent;
    var isPrimaryPointer = !isMouseEvent2 || isMouseEvent2 && event.button === 0;
    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e2, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  var primaryTouch = e2.touches[0] || e2.changedTouches[0];
  var point = primaryTouch || defaultPagePoint;
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}
function pointFromMouse(point, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}
function extractEventInfo(event, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
var wrapHandler = function(handler, shouldFilterPrimaryPointer) {
  if (shouldFilterPrimaryPointer === void 0) {
    shouldFilterPrimaryPointer = false;
  }
  var listener = function(event) {
    return handler(event, extractEventInfo(event));
  };
  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};
var supportsPointerEvents = function() {
  return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function() {
  return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function() {
  return isBrowser && window.onmousedown === null;
};
var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  } else if (supportsTouchEvents()) {
    return touchEventNames[name];
  } else if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }
  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
  return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}
function createLock(name) {
  var lock = null;
  return function() {
    var openLock = function() {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  var lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    var openHorizontal_1 = globalHorizontalLock();
    var openVertical_1 = globalVerticalLock();
    if (openHorizontal_1 && openVertical_1) {
      lock = function() {
        openHorizontal_1();
        openVertical_1();
      };
    } else {
      if (openHorizontal_1)
        openHorizontal_1();
      if (openVertical_1)
        openVertical_1();
    }
  }
  return lock;
}
function isDragActive() {
  var openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}
function createHoverEvent(visualElement2, isActive, callback) {
  return function(event, info) {
    var _a;
    if (!isMouseEvent(event) || isDragActive())
      return;
    (_a = visualElement2.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
    callback === null || callback === void 0 ? void 0 : callback(event, info);
  };
}
function useHoverGesture(_a) {
  var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement2 = _a.visualElement;
  usePointerEvent(visualElement2, "pointerenter", onHoverStart || whileHover ? createHoverEvent(visualElement2, true, onHoverStart) : void 0);
  usePointerEvent(visualElement2, "pointerleave", onHoverEnd || whileHover ? createHoverEvent(visualElement2, false, onHoverEnd) : void 0);
}
var isNodeOrChild = function(parent, child) {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};
function useUnmountEffect(callback) {
  return useEffect(function() {
    return function() {
      return callback();
    };
  }, []);
}
function useTapGesture(_a) {
  var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement2 = _a.visualElement;
  var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
  var isPressing = useRef(false);
  var cancelPointerEndListeners = useRef(null);
  function removePointerEndListener() {
    var _a2;
    (_a2 = cancelPointerEndListeners.current) === null || _a2 === void 0 ? void 0 : _a2.call(cancelPointerEndListeners);
    cancelPointerEndListeners.current = null;
  }
  function checkPointerEnd() {
    var _a2;
    removePointerEndListener();
    isPressing.current = false;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Tap, false);
    return !isDragActive();
  }
  function onPointerUp(event, info) {
    if (!checkPointerEnd())
      return;
    !isNodeOrChild(visualElement2.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info) : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
  }
  function onPointerCancel(event, info) {
    if (!checkPointerEnd())
      return;
    onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
  }
  function onPointerDown(event, info) {
    var _a2;
    removePointerEndListener();
    if (isPressing.current)
      return;
    isPressing.current = true;
    cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Tap, true);
    onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
  }
  usePointerEvent(visualElement2, "pointerdown", hasPressListeners ? onPointerDown : void 0);
  useUnmountEffect(removePointerEndListener);
}
var observerCallbacks = /* @__PURE__ */ new WeakMap();
var observers = /* @__PURE__ */ new WeakMap();
var fireObserverCallback = function(entry) {
  var _a;
  (_a = observerCallbacks.get(entry.target)) === null || _a === void 0 ? void 0 : _a(entry);
};
var fireAllObserverCallbacks = function(entries) {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_a) {
  var root2 = _a.root, options = __rest$1(_a, ["root"]);
  var lookupRoot = root2 || document;
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  var rootObservers = observers.get(lookupRoot);
  var key = JSON.stringify(options);
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, __assign({ root: root2 }, options));
  }
  return rootObservers[key];
}
function observeIntersection(element, options, callback) {
  var rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return function() {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}
function useViewport(_a) {
  var visualElement2 = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
  var state2 = useRef({
    hasEnteredView: false,
    isInView: false
  });
  var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
  if (viewport.once && state2.current.hasEnteredView)
    shouldObserve = false;
  var useObserver = typeof IntersectionObserver === "undefined" ? useMissingIntersectionObserver : useIntersectionObserver;
  useObserver(shouldObserve, state2.current, visualElement2, viewport);
}
var thresholdNames = {
  some: 0,
  all: 1
};
function useIntersectionObserver(shouldObserve, state2, visualElement2, _a) {
  var root2 = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once2 = _a.once;
  useEffect(function() {
    if (!shouldObserve)
      return;
    var options = {
      root: root2 === null || root2 === void 0 ? void 0 : root2.current,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    var intersectionCallback = function(entry) {
      var _a2;
      var isIntersecting = entry.isIntersecting;
      if (state2.isInView === isIntersecting)
        return;
      state2.isInView = isIntersecting;
      if (once2 && !isIntersecting && state2.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        state2.hasEnteredView = true;
      }
      (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.InView, isIntersecting);
      var props = visualElement2.getProps();
      var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
      callback === null || callback === void 0 ? void 0 : callback(entry);
    };
    return observeIntersection(visualElement2.getInstance(), options, intersectionCallback);
  }, [shouldObserve, root2, rootMargin, amount]);
}
function useMissingIntersectionObserver(shouldObserve, state2, visualElement2, _a) {
  var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
  useEffect(function() {
    if (!shouldObserve || !fallback)
      return;
    requestAnimationFrame(function() {
      var _a2;
      state2.hasEnteredView = true;
      var onViewportEnter = visualElement2.getProps().onViewportEnter;
      onViewportEnter === null || onViewportEnter === void 0 ? void 0 : onViewportEnter(null);
      (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.InView, true);
    });
  }, [shouldObserve]);
}
var makeRenderlessComponent = function(hook) {
  return function(props) {
    hook(props);
    return null;
  };
};
var gestureAnimations = {
  inView: makeRenderlessComponent(useViewport),
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
};
var counter = 0;
var incrementId = function() {
  return counter++;
};
var useId = function() {
  return useConstant(incrementId);
};
function usePresence() {
  var context2 = useContext(PresenceContext);
  if (context2 === null)
    return [true, null];
  var isPresent = context2.isPresent, onExitComplete = context2.onExitComplete, register = context2.register;
  var id2 = useId();
  useEffect(function() {
    return register(id2);
  }, []);
  var safeToRemove = function() {
    return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id2);
  };
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return false;
  var prevLength = prev.length;
  if (prevLength !== next.length)
    return false;
  for (var i2 = 0; i2 < prevLength; i2++) {
    if (prev[i2] !== next[i2])
      return false;
  }
  return true;
}
var isNumericalString = function(v2) {
  return /^\-?\d*\.?\d+$/.test(v2);
};
var isZeroValueString = function(v2) {
  return /^0[^.\s]+$/.test(v2);
};
var testValueType = function(v2) {
  return function(type) {
    return type.test(v2);
  };
};
var auto = {
  test: function(v2) {
    return v2 === "auto";
  },
  parse: function(v2) {
    return v2;
  }
};
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = function(v2) {
  return dimensionValueTypes.find(testValueType(v2));
};
var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), false), [color, complex], false);
var findValueType = function(v2) {
  return valueTypes.find(testValueType(v2));
};
function setMotionValue(visualElement2, key, value) {
  if (visualElement2.hasValue(key)) {
    visualElement2.getValue(key).set(value);
  } else {
    visualElement2.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement2, definition) {
  var resolved = resolveVariant(visualElement2, definition);
  var _a = resolved ? visualElement2.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
  _a.transition;
  var target = __rest$1(_a, ["transitionEnd", "transition"]);
  target = __assign(__assign({}, target), transitionEnd);
  for (var key in target) {
    var value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement2, key, value);
  }
}
function checkTargetForNewValues(visualElement2, target, origin) {
  var _a, _b, _c;
  var _d;
  var newValueKeys = Object.keys(target).filter(function(key2) {
    return !visualElement2.hasValue(key2);
  });
  var numNewValues = newValueKeys.length;
  if (!numNewValues)
    return;
  for (var i2 = 0; i2 < numNewValues; i2++) {
    var key = newValueKeys[i2];
    var targetValue = target[key];
    var value = null;
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    if (value === null) {
      value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement2.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
    }
    if (value === void 0 || value === null)
      continue;
    if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
      value = parseFloat(value);
    } else if (!findValueType(value) && complex.test(targetValue)) {
      value = getAnimatableNone(key, targetValue);
    }
    visualElement2.addValue(key, motionValue(value));
    (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
    visualElement2.setBaseTarget(key, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition)
    return;
  var valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement2) {
  var _a, _b;
  var origin = {};
  for (var key in target) {
    origin[key] = (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement2.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
  }
  return origin;
}
function animateVisualElement(visualElement2, definition, options) {
  if (options === void 0) {
    options = {};
  }
  visualElement2.notifyAnimationStart(definition);
  var animation;
  if (Array.isArray(definition)) {
    var animations2 = definition.map(function(variant) {
      return animateVariant(visualElement2, variant, options);
    });
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement2, definition, options);
  } else {
    var resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement2, definition, options.custom) : definition;
    animation = animateTarget(visualElement2, resolvedDefinition, options);
  }
  return animation.then(function() {
    return visualElement2.notifyAnimationComplete(definition);
  });
}
function animateVariant(visualElement2, variant, options) {
  var _a;
  if (options === void 0) {
    options = {};
  }
  var resolved = resolveVariant(visualElement2, variant, options.custom);
  var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement2.getDefaultTransition() || {} : _b;
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  var getAnimation2 = resolved ? function() {
    return animateTarget(visualElement2, resolved, options);
  } : function() {
    return Promise.resolve();
  };
  var getChildAnimations = ((_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
    if (forwardDelay === void 0) {
      forwardDelay = 0;
    }
    var _a2 = transition.delayChildren, delayChildren = _a2 === void 0 ? 0 : _a2, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
    return animateChildren(visualElement2, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : function() {
    return Promise.resolve();
  };
  var when = transition.when;
  if (when) {
    var _c = __read(when === "beforeChildren" ? [getAnimation2, getChildAnimations] : [getChildAnimations, getAnimation2], 2), first = _c[0], last = _c[1];
    return first().then(last);
  } else {
    return Promise.all([getAnimation2(), getChildAnimations(options.delay)]);
  }
}
function animateTarget(visualElement2, definition, _a) {
  var _b;
  var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
  var _e2 = visualElement2.makeTargetAnimatable(definition), _f = _e2.transition, transition = _f === void 0 ? visualElement2.getDefaultTransition() : _f, transitionEnd = _e2.transitionEnd, target = __rest$1(_e2, ["transition", "transitionEnd"]);
  if (transitionOverride)
    transition = transitionOverride;
  var animations2 = [];
  var animationTypeState = type && ((_b = visualElement2.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
  for (var key in target) {
    var value = visualElement2.getValue(key);
    var valueTarget = target[key];
    if (!value || valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    var valueTransition = __assign({ delay }, transition);
    if (visualElement2.shouldReduceMotion && isTransformProp(key)) {
      valueTransition = __assign(__assign({}, valueTransition), { type: false, delay: 0 });
    }
    var animation = startAnimation(key, value, valueTarget, valueTransition);
    animations2.push(animation);
  }
  return Promise.all(animations2).then(function() {
    transitionEnd && setTarget(visualElement2, transitionEnd);
  });
}
function animateChildren(visualElement2, variant, delayChildren, staggerChildren, staggerDirection, options) {
  if (delayChildren === void 0) {
    delayChildren = 0;
  }
  if (staggerChildren === void 0) {
    staggerChildren = 0;
  }
  if (staggerDirection === void 0) {
    staggerDirection = 1;
  }
  var animations2 = [];
  var maxStaggerDuration = (visualElement2.variantChildren.size - 1) * staggerChildren;
  var generateStaggerDuration = staggerDirection === 1 ? function(i2) {
    if (i2 === void 0) {
      i2 = 0;
    }
    return i2 * staggerChildren;
  } : function(i2) {
    if (i2 === void 0) {
      i2 = 0;
    }
    return maxStaggerDuration - i2 * staggerChildren;
  };
  Array.from(visualElement2.variantChildren).sort(sortByTreeOrder).forEach(function(child, i2) {
    animations2.push(animateVariant(child, variant, __assign(__assign({}, options), { delay: delayChildren + generateStaggerDuration(i2) })).then(function() {
      return child.notifyAnimationComplete(variant);
    }));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder(a6, b2) {
  return a6.sortNodePosition(b2);
}
function shouldBlockAnimation(_a, key) {
  var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
  var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.InView,
  AnimationType.Focus,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Exit
];
var reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), false).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement2) {
  return function(animations2) {
    return Promise.all(animations2.map(function(_a) {
      var animation = _a.animation, options = _a.options;
      return animateVisualElement(visualElement2, animation, options);
    }));
  };
}
function createAnimationState(visualElement2) {
  var animate2 = animateList(visualElement2);
  var state2 = createState();
  var allAnimatedKeys = {};
  var isInitialRender = true;
  var buildResolvedTypeValues = function(acc, definition) {
    var resolved = resolveVariant(visualElement2, definition);
    if (resolved) {
      resolved.transition;
      var transitionEnd = resolved.transitionEnd, target = __rest$1(resolved, ["transition", "transitionEnd"]);
      acc = __assign(__assign(__assign({}, acc), target), transitionEnd);
    }
    return acc;
  };
  function isAnimated(key) {
    return allAnimatedKeys[key] !== void 0;
  }
  function setAnimateFunction(makeAnimator) {
    animate2 = makeAnimator(visualElement2);
  }
  function animateChanges(options, changedActiveType) {
    var _a;
    var props = visualElement2.getProps();
    var context2 = visualElement2.getVariantContext(true) || {};
    var animations2 = [];
    var removedKeys = /* @__PURE__ */ new Set();
    var encounteredKeys = {};
    var removedVariantIndex = Infinity;
    var _loop_1 = function(i3) {
      var type = reversePriorityOrder[i3];
      var typeState = state2[type];
      var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context2[type];
      var propIsVariant = isVariantLabel(prop);
      var activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i3;
      var isInherited = prop === context2[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement2.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = __assign({}, encounteredKeys);
      if (!typeState.isActive && activeDelta === null || !prop && !typeState.prevProp || isAnimationControls(prop) || typeof prop === "boolean") {
        return "continue";
      }
      var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      var shouldAnimateType = variantDidChange || type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || i3 > removedVariantIndex && propIsVariant;
      var definitionList = Array.isArray(prop) ? prop : [prop];
      var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      if (activeDelta === false)
        resolvedValues = {};
      var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
      var allKeys = __assign(__assign({}, prevResolvedValues), resolvedValues);
      var markToAnimate = function(key2) {
        shouldAnimateType = true;
        removedKeys.delete(key2);
        typeState.needsAnimating[key2] = true;
      };
      for (var key in allKeys) {
        var next = resolvedValues[key];
        var prev = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        if (next !== prev) {
          if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
            if (!shallowCompare(next, prev) || variantDidChange) {
              markToAnimate(key);
            } else {
              typeState.protectedKeys[key] = true;
            }
          } else if (next !== void 0) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = __assign(__assign({}, encounteredKeys), resolvedValues);
      }
      if (isInitialRender && visualElement2.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && !isInherited) {
        animations2.push.apply(animations2, __spreadArray([], __read(definitionList.map(function(animation) {
          return {
            animation,
            options: __assign({ type }, options)
          };
        })), false));
      }
    };
    for (var i2 = 0; i2 < numAnimationTypes; i2++) {
      _loop_1(i2);
    }
    allAnimatedKeys = __assign({}, encounteredKeys);
    if (removedKeys.size) {
      var fallbackAnimation_1 = {};
      removedKeys.forEach(function(key) {
        var fallbackTarget = visualElement2.getBaseTarget(key);
        if (fallbackTarget !== void 0) {
          fallbackAnimation_1[key] = fallbackTarget;
        }
      });
      animations2.push({ animation: fallbackAnimation_1 });
    }
    var shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && props.initial === false && !visualElement2.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate2(animations2) : Promise.resolve();
  }
  function setActive(type, isActive, options) {
    var _a;
    if (state2[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state2[type].isActive = isActive;
    var animations2 = animateChanges(options, type);
    for (var key in state2) {
      state2[key].protectedKeys = {};
    }
    return animations2;
  }
  return {
    isAnimated,
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: function() {
      return state2;
    }
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (isVariantLabels(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState(isActive) {
  if (isActive === void 0) {
    isActive = false;
  }
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  var _a;
  return _a = {}, _a[AnimationType.Animate] = createTypeState(true), _a[AnimationType.InView] = createTypeState(), _a[AnimationType.Hover] = createTypeState(), _a[AnimationType.Tap] = createTypeState(), _a[AnimationType.Drag] = createTypeState(), _a[AnimationType.Focus] = createTypeState(), _a[AnimationType.Exit] = createTypeState(), _a;
}
var animations = {
  animation: makeRenderlessComponent(function(_a) {
    var visualElement2 = _a.visualElement, animate2 = _a.animate;
    visualElement2.animationState || (visualElement2.animationState = createAnimationState(visualElement2));
    if (isAnimationControls(animate2)) {
      useEffect(function() {
        return animate2.subscribe(visualElement2);
      }, [animate2]);
    }
  }),
  exit: makeRenderlessComponent(function(props) {
    var custom = props.custom, visualElement2 = props.visualElement;
    var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var presenceContext = useContext(PresenceContext);
    useEffect(function() {
      var _a2, _b;
      visualElement2.isPresent = isPresent;
      var animation = (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
      !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(safeToRemove));
    }, [isPresent]);
  })
};
var PanSession = function() {
  function PanSession2(event, handlers, _a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.updatePoint = function() {
      if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
        return;
      var info2 = getPanInfo(_this.lastMoveEventInfo, _this.history);
      var isPanStarted = _this.startEvent !== null;
      var isDistancePastThreshold = distance(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      var point2 = info2.point;
      var timestamp2 = getFrameData().timestamp;
      _this.history.push(__assign(__assign({}, point2), { timestamp: timestamp2 }));
      var _a2 = _this.handlers, onStart = _a2.onStart, onMove = _a2.onMove;
      if (!isPanStarted) {
        onStart && onStart(_this.lastMoveEvent, info2);
        _this.startEvent = _this.lastMoveEvent;
      }
      onMove && onMove(_this.lastMoveEvent, info2);
    };
    this.handlePointerMove = function(event2, info2) {
      _this.lastMoveEvent = event2;
      _this.lastMoveEventInfo = transformPoint(info2, _this.transformPagePoint);
      if (isMouseEvent(event2) && event2.buttons === 0) {
        _this.handlePointerUp(event2, info2);
        return;
      }
      sync.update(_this.updatePoint, true);
    };
    this.handlePointerUp = function(event2, info2) {
      _this.end();
      var _a2 = _this.handlers, onEnd = _a2.onEnd, onSessionEnd = _a2.onSessionEnd;
      var panInfo = getPanInfo(transformPoint(info2, _this.transformPagePoint), _this.history);
      if (_this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (isTouchEvent(event) && event.touches.length > 1)
      return;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    var info = extractEventInfo(event);
    var initialInfo = transformPoint(info, this.transformPagePoint);
    var point = initialInfo.point;
    var timestamp = getFrameData().timestamp;
    this.history = [__assign(__assign({}, point), { timestamp })];
    var onSessionStart = handlers.onSessionStart;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
  }
  PanSession2.prototype.updateHandlers = function(handlers) {
    this.handlers = handlers;
  };
  PanSession2.prototype.end = function() {
    this.removeListeners && this.removeListeners();
    cancelSync.update(this.updatePoint);
  };
  return PanSession2;
}();
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a6, b2) {
  return { x: a6.x - b2.x, y: a6.y - b2.y };
}
function getPanInfo(_a, history) {
  var point = _a.point;
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  var i2 = history.length - 1;
  var timestampedPoint = null;
  var lastPoint = lastDevicePoint(history);
  while (i2 >= 0) {
    timestampedPoint = history[i2];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i2--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
  if (time === 0) {
    return { x: 0, y: 0 };
  }
  var currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}
function applyConstraints(point, _a, elastic) {
  var min2 = _a.min, max2 = _a.max;
  if (min2 !== void 0 && point < min2) {
    point = elastic ? mix(min2, point, elastic.min) : Math.max(point, min2);
  } else if (max2 !== void 0 && point > max2) {
    point = elastic ? mix(max2, point, elastic.max) : Math.min(point, max2);
  }
  return point;
}
function calcRelativeAxisConstraints(axis, min2, max2) {
  return {
    min: min2 !== void 0 ? axis.min + min2 : void 0,
    max: max2 !== void 0 ? axis.max + max2 - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, _a) {
  var top2 = _a.top, left2 = _a.left, bottom = _a.bottom, right = _a.right;
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left2, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top2, bottom)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  var _a;
  var min2 = constraintsAxis.min - layoutAxis.min;
  var max2 = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    _a = __read([max2, min2], 2), min2 = _a[0], max2 = _a[1];
  }
  return { min: min2, max: max2 };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin(source2, target) {
  var origin = 0.5;
  var sourceLength = calcLength(source2);
  var targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source2.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source2.min, source2.max - targetLength, target.min);
  }
  return clamp$1(0, 1, origin);
}
function rebaseAxisConstraints(layout, constraints) {
  var relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic) {
  if (dragElastic === void 0) {
    dragElastic = defaultElastic;
  }
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  var _a;
  return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}
function convertBoundingBoxToBox(_a) {
  var top2 = _a.top, left2 = _a.left, right = _a.right, bottom = _a.bottom;
  return {
    x: { min: left2, max: right },
    y: { min: top2, max: bottom }
  };
}
function convertBoxToBoundingBox(_a) {
  var x2 = _a.x, y2 = _a.y;
  return { top: y2.min, right: x2.max, bottom: y2.max, left: x2.min };
}
function transformBoxPoints(point, transformPoint2) {
  if (!transformPoint2)
    return point;
  var topLeft = transformPoint2({ x: point.left, y: point.top });
  var bottomRight = transformPoint2({ x: point.right, y: point.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function measureViewportBox(instance2, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance2.getBoundingClientRect(), transformPoint2));
}
function measurePageBox(element, rootProjectionNode2, transformPagePoint) {
  var viewportBox = measureViewportBox(element, transformPagePoint);
  var scroll = rootProjectionNode2.scroll;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.x);
    translateAxis(viewportBox.y, scroll.y);
  }
  return viewportBox;
}
var elementDragControls = /* @__PURE__ */ new WeakMap();
var VisualElementDragControls = function() {
  function VisualElementDragControls2(visualElement2) {
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = { x: 0, y: 0 };
    this.constraints = false;
    this.hasMutatedConstraints = false;
    this.elastic = createBox();
    this.visualElement = visualElement2;
  }
  VisualElementDragControls2.prototype.start = function(originEvent, _a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
    if (this.visualElement.isPresent === false)
      return;
    var onSessionStart = function(event) {
      _this.stopAnimation();
      if (snapToCursor) {
        _this.snapToCursor(extractEventInfo(event, "page").point);
      }
    };
    var onStart = function(event, info) {
      var _a2;
      var _b2 = _this.getProps(), drag2 = _b2.drag, dragPropagation = _b2.dragPropagation, onDragStart = _b2.onDragStart;
      if (drag2 && !dragPropagation) {
        if (_this.openGlobalLock)
          _this.openGlobalLock();
        _this.openGlobalLock = getGlobalLock(drag2);
        if (!_this.openGlobalLock)
          return;
      }
      _this.isDragging = true;
      _this.currentDirection = null;
      _this.resolveConstraints();
      if (_this.visualElement.projection) {
        _this.visualElement.projection.isAnimationBlocked = true;
        _this.visualElement.projection.target = void 0;
      }
      eachAxis(function(axis) {
        var _a3, _b3;
        var current = _this.getAxisMotionValue(axis).get() || 0;
        if (percent.test(current)) {
          var measuredAxis = (_b3 = (_a3 = _this.visualElement.projection) === null || _a3 === void 0 ? void 0 : _a3.layout) === null || _b3 === void 0 ? void 0 : _b3.actual[axis];
          if (measuredAxis) {
            var length_1 = calcLength(measuredAxis);
            current = length_1 * (parseFloat(current) / 100);
          }
        }
        _this.originPoint[axis] = current;
      });
      onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
      (_a2 = _this.visualElement.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Drag, true);
    };
    var onMove = function(event, info) {
      var _a2 = _this.getProps(), dragPropagation = _a2.dragPropagation, dragDirectionLock = _a2.dragDirectionLock, onDirectionLock = _a2.onDirectionLock, onDrag = _a2.onDrag;
      if (!dragPropagation && !_this.openGlobalLock)
        return;
      var offset = info.offset;
      if (dragDirectionLock && _this.currentDirection === null) {
        _this.currentDirection = getCurrentDirection(offset);
        if (_this.currentDirection !== null) {
          onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(_this.currentDirection);
        }
        return;
      }
      _this.updateAxis("x", info.point, offset);
      _this.updateAxis("y", info.point, offset);
      _this.visualElement.syncRender();
      onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
    };
    var onSessionEnd = function(event, info) {
      return _this.stop(event, info);
    };
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd
    }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
  };
  VisualElementDragControls2.prototype.stop = function(event, info) {
    var isDragging = this.isDragging;
    this.cancel();
    if (!isDragging)
      return;
    var velocity = info.velocity;
    this.startAnimation(velocity);
    var onDragEnd = this.getProps().onDragEnd;
    onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
  };
  VisualElementDragControls2.prototype.cancel = function() {
    var _a, _b;
    this.isDragging = false;
    if (this.visualElement.projection) {
      this.visualElement.projection.isAnimationBlocked = false;
    }
    (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
    this.panSession = void 0;
    var dragPropagation = this.getProps().dragPropagation;
    if (!dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
  };
  VisualElementDragControls2.prototype.updateAxis = function(axis, _point, offset) {
    var drag2 = this.getProps().drag;
    if (!offset || !shouldDrag(axis, drag2, this.currentDirection))
      return;
    var axisValue = this.getAxisMotionValue(axis);
    var next = this.originPoint[axis] + offset[axis];
    if (this.constraints && this.constraints[axis]) {
      next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next);
  };
  VisualElementDragControls2.prototype.resolveConstraints = function() {
    var _this = this;
    var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
    var layout = (this.visualElement.projection || {}).layout;
    var prevConstraints = this.constraints;
    if (dragConstraints && isRefObject(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout) {
        this.constraints = calcRelativeConstraints(layout.actual, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic(dragElastic);
    if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) {
      eachAxis(function(axis) {
        if (_this.getAxisMotionValue(axis)) {
          _this.constraints[axis] = rebaseAxisConstraints(layout.actual[axis], _this.constraints[axis]);
        }
      });
    }
  };
  VisualElementDragControls2.prototype.resolveRefConstraints = function() {
    var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
    if (!constraints || !isRefObject(constraints))
      return false;
    var constraintsElement = constraints.current;
    var projection = this.visualElement.projection;
    if (!projection || !projection.layout)
      return false;
    var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    var measuredConstraints = calcViewportConstraints(projection.layout.actual, constraintsBox);
    if (onMeasureDragConstraints) {
      var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox(userConstraints);
      }
    }
    return measuredConstraints;
  };
  VisualElementDragControls2.prototype.startAnimation = function(velocity) {
    var _this = this;
    var _a = this.getProps(), drag2 = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
    var constraints = this.constraints || {};
    var momentumAnimations = eachAxis(function(axis) {
      var _a2;
      if (!shouldDrag(axis, drag2, _this.currentDirection)) {
        return;
      }
      var transition = (_a2 = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a2 !== void 0 ? _a2 : {};
      if (dragSnapToOrigin)
        transition = { min: 0, max: 0 };
      var bounceStiffness = dragElastic ? 200 : 1e6;
      var bounceDamping = dragElastic ? 40 : 1e7;
      var inertia2 = __assign(__assign({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness, bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
      return _this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  };
  VisualElementDragControls2.prototype.startAxisValueAnimation = function(axis, transition) {
    var axisValue = this.getAxisMotionValue(axis);
    return startAnimation(axis, axisValue, 0, transition);
  };
  VisualElementDragControls2.prototype.stopAnimation = function() {
    var _this = this;
    eachAxis(function(axis) {
      return _this.getAxisMotionValue(axis).stop();
    });
  };
  VisualElementDragControls2.prototype.getAxisMotionValue = function(axis) {
    var _a, _b;
    var dragKey = "_drag" + axis.toUpperCase();
    var externalMotionValue = this.visualElement.getProps()[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
  };
  VisualElementDragControls2.prototype.snapToCursor = function(point) {
    var _this = this;
    eachAxis(function(axis) {
      var drag2 = _this.getProps().drag;
      if (!shouldDrag(axis, drag2, _this.currentDirection))
        return;
      var projection = _this.visualElement.projection;
      var axisValue = _this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        var _a = projection.layout.actual[axis], min2 = _a.min, max2 = _a.max;
        axisValue.set(point[axis] - mix(min2, max2, 0.5));
      }
    });
  };
  VisualElementDragControls2.prototype.scalePositionWithinConstraints = function() {
    var _this = this;
    var _a;
    var _b = this.getProps(), drag2 = _b.drag, dragConstraints = _b.dragConstraints;
    var projection = this.visualElement.projection;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    var boxProgress = { x: 0, y: 0 };
    eachAxis(function(axis) {
      var axisValue = _this.getAxisMotionValue(axis);
      if (axisValue) {
        var latest = axisValue.get();
        boxProgress[axis] = calcOrigin({ min: latest, max: latest }, _this.constraints[axis]);
      }
    });
    var transformTemplate = this.visualElement.getProps().transformTemplate;
    this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    eachAxis(function(axis) {
      if (!shouldDrag(axis, drag2, null))
        return;
      var axisValue = _this.getAxisMotionValue(axis);
      var _a2 = _this.constraints[axis], min2 = _a2.min, max2 = _a2.max;
      axisValue.set(mix(min2, max2, boxProgress[axis]));
    });
  };
  VisualElementDragControls2.prototype.addListeners = function() {
    var _this = this;
    var _a;
    elementDragControls.set(this.visualElement, this);
    var element = this.visualElement.getInstance();
    var stopPointerListener = addPointerEvent(element, "pointerdown", function(event) {
      var _a2 = _this.getProps(), drag2 = _a2.drag, _b = _a2.dragListener, dragListener = _b === void 0 ? true : _b;
      drag2 && dragListener && _this.start(event);
    });
    var measureDragConstraints = function() {
      var dragConstraints = _this.getProps().dragConstraints;
      if (isRefObject(dragConstraints)) {
        _this.constraints = _this.resolveRefConstraints();
      }
    };
    var projection = this.visualElement.projection;
    var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
      projection.updateLayout();
    }
    measureDragConstraints();
    var stopResizeListener = addDomEvent(window, "resize", function() {
      _this.scalePositionWithinConstraints();
    });
    projection.addEventListener("didUpdate", function(_a2) {
      var delta = _a2.delta, hasLayoutChanged = _a2.hasLayoutChanged;
      if (_this.isDragging && hasLayoutChanged) {
        eachAxis(function(axis) {
          var motionValue2 = _this.getAxisMotionValue(axis);
          if (!motionValue2)
            return;
          _this.originPoint[axis] += delta[axis].translate;
          motionValue2.set(motionValue2.get() + delta[axis].translate);
        });
        _this.visualElement.syncRender();
      }
    });
    return function() {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
    };
  };
  VisualElementDragControls2.prototype.getProps = function() {
    var props = this.visualElement.getProps();
    var _a = props.drag, drag2 = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e2 = props.dragElastic, dragElastic = _e2 === void 0 ? defaultElastic : _e2, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
    return __assign(__assign({}, props), { drag: drag2, dragDirectionLock, dragPropagation, dragConstraints, dragElastic, dragMomentum });
  };
  return VisualElementDragControls2;
}();
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset, lockThreshold) {
  if (lockThreshold === void 0) {
    lockThreshold = 10;
  }
  var direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
function useDrag(props) {
  var groupDragControls = props.dragControls, visualElement2 = props.visualElement;
  var dragControls = useConstant(function() {
    return new VisualElementDragControls(visualElement2);
  });
  useEffect(function() {
    return groupDragControls && groupDragControls.subscribe(dragControls);
  }, [dragControls, groupDragControls]);
  useEffect(function() {
    return dragControls.addListeners();
  }, [dragControls]);
}
function usePanGesture(_a) {
  var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement2 = _a.visualElement;
  var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
  var panSession = useRef(null);
  var transformPagePoint = useContext(MotionConfigContext).transformPagePoint;
  var handlers = {
    onSessionStart: onPanSessionStart,
    onStart: onPanStart,
    onMove: onPan,
    onEnd: function(event, info) {
      panSession.current = null;
      onPanEnd && onPanEnd(event, info);
    }
  };
  useEffect(function() {
    if (panSession.current !== null) {
      panSession.current.updateHandlers(handlers);
    }
  });
  function onPointerDown(event) {
    panSession.current = new PanSession(event, handlers, {
      transformPagePoint
    });
  }
  usePointerEvent(visualElement2, "pointerdown", hasPanEvents && onPointerDown);
  useUnmountEffect(function() {
    return panSession.current && panSession.current.end();
  });
}
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag)
};
var names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var managers = names.map(function() {
    return new SubscriptionManager();
  });
  var propSubscriptions = {};
  var lifecycles = {
    clearAllListeners: function() {
      return managers.forEach(function(manager) {
        return manager.clear();
      });
    },
    updatePropListeners: function(props) {
      names.forEach(function(name) {
        var _a;
        var on = "on" + name;
        var propListener = props[on];
        (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
        if (propListener) {
          propSubscriptions[name] = lifecycles[on](propListener);
        }
      });
    }
  };
  managers.forEach(function(manager, i2) {
    lifecycles["on" + names[i2]] = function(handler) {
      return manager.add(handler);
    };
    lifecycles["notify" + names[i2]] = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return manager.notify.apply(manager, __spreadArray([], __read(args), false));
    };
  });
  return lifecycles;
}
function updateMotionValuesFromProps(element, next, prev) {
  var _a;
  for (var key in next) {
    var nextValue = next[key];
    var prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      element.addValue(key, nextValue);
    } else if (isMotionValue(prevValue)) {
      element.addValue(key, motionValue(nextValue));
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        var existingValue = element.getValue(key);
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
      }
    }
  }
  for (var key in prev) {
    if (next[key] === void 0)
      element.removeValue(key);
  }
  return next;
}
var visualElement = function(_a) {
  var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build2 = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox2 = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps2 = _a.scrapeMotionValuesFromProps;
  return function(_a2, options) {
    var parent = _a2.parent, props = _a2.props, presenceId = _a2.presenceId, blockInitialAnimation = _a2.blockInitialAnimation, visualState = _a2.visualState, shouldReduceMotion = _a2.shouldReduceMotion;
    if (options === void 0) {
      options = {};
    }
    var isMounted = false;
    var latestValues = visualState.latestValues, renderState = visualState.renderState;
    var instance2;
    var lifecycles = createLifecycles();
    var values = /* @__PURE__ */ new Map();
    var valueSubscriptions = /* @__PURE__ */ new Map();
    var prevMotionValues = {};
    var baseTarget = __assign({}, latestValues);
    var removeFromVariantTree;
    function render() {
      if (!instance2 || !isMounted)
        return;
      triggerBuild();
      renderInstance(instance2, renderState, props.style, element.projection);
    }
    function triggerBuild() {
      build2(element, renderState, latestValues, options, props);
    }
    function update2() {
      lifecycles.notifyUpdate(latestValues);
    }
    function bindToMotionValue(key2, value2) {
      var removeOnChange = value2.onChange(function(latestValue) {
        latestValues[key2] = latestValue;
        props.onUpdate && sync.update(update2, false, true);
      });
      var removeOnRenderRequest = value2.onRenderRequest(element.scheduleRender);
      valueSubscriptions.set(key2, function() {
        removeOnChange();
        removeOnRenderRequest();
      });
    }
    var initialMotionValues = scrapeMotionValuesFromProps2(props);
    for (var key in initialMotionValues) {
      var value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key], false);
      }
    }
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    var element = __assign(__assign({
      treeType,
      current: null,
      depth: parent ? parent.depth + 1 : 0,
      parent,
      children: /* @__PURE__ */ new Set(),
      presenceId,
      shouldReduceMotion,
      variantChildren: isVariantNode ? /* @__PURE__ */ new Set() : void 0,
      isVisible: void 0,
      manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
      blockInitialAnimation,
      isMounted: function() {
        return Boolean(instance2);
      },
      mount: function(newInstance) {
        isMounted = true;
        instance2 = element.current = newInstance;
        if (element.projection) {
          element.projection.mount(newInstance);
        }
        if (isVariantNode && parent && !isControllingVariants) {
          removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
        }
        values.forEach(function(value2, key2) {
          return bindToMotionValue(key2, value2);
        });
        parent === null || parent === void 0 ? void 0 : parent.children.add(element);
        element.setProps(props);
      },
      unmount: function() {
        var _a3;
        (_a3 = element.projection) === null || _a3 === void 0 ? void 0 : _a3.unmount();
        cancelSync.update(update2);
        cancelSync.render(render);
        valueSubscriptions.forEach(function(remove3) {
          return remove3();
        });
        removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
        parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
        lifecycles.clearAllListeners();
        instance2 = void 0;
        isMounted = false;
      },
      addVariantChild: function(child) {
        var _a3;
        var closestVariantNode = element.getClosestVariantNode();
        if (closestVariantNode) {
          (_a3 = closestVariantNode.variantChildren) === null || _a3 === void 0 ? void 0 : _a3.add(child);
          return function() {
            return closestVariantNode.variantChildren.delete(child);
          };
        }
      },
      sortNodePosition: function(other) {
        if (!sortNodePosition || treeType !== other.treeType)
          return 0;
        return sortNodePosition(element.getInstance(), other.getInstance());
      },
      getClosestVariantNode: function() {
        return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
      },
      getLayoutId: function() {
        return props.layoutId;
      },
      getInstance: function() {
        return instance2;
      },
      getStaticValue: function(key2) {
        return latestValues[key2];
      },
      setStaticValue: function(key2, value2) {
        return latestValues[key2] = value2;
      },
      getLatestValues: function() {
        return latestValues;
      },
      setVisibility: function(visibility) {
        if (element.isVisible === visibility)
          return;
        element.isVisible = visibility;
        element.scheduleRender();
      },
      makeTargetAnimatable: function(target, canMutate) {
        if (canMutate === void 0) {
          canMutate = true;
        }
        return makeTargetAnimatable(element, target, props, canMutate);
      },
      measureViewportBox: function() {
        return measureViewportBox2(instance2, props);
      },
      addValue: function(key2, value2) {
        if (element.hasValue(key2))
          element.removeValue(key2);
        values.set(key2, value2);
        latestValues[key2] = value2.get();
        bindToMotionValue(key2, value2);
      },
      removeValue: function(key2) {
        var _a3;
        values.delete(key2);
        (_a3 = valueSubscriptions.get(key2)) === null || _a3 === void 0 ? void 0 : _a3();
        valueSubscriptions.delete(key2);
        delete latestValues[key2];
        removeValueFromRenderState(key2, renderState);
      },
      hasValue: function(key2) {
        return values.has(key2);
      },
      getValue: function(key2, defaultValue) {
        var value2 = values.get(key2);
        if (value2 === void 0 && defaultValue !== void 0) {
          value2 = motionValue(defaultValue);
          element.addValue(key2, value2);
        }
        return value2;
      },
      forEachValue: function(callback) {
        return values.forEach(callback);
      },
      readValue: function(key2) {
        var _a3;
        return (_a3 = latestValues[key2]) !== null && _a3 !== void 0 ? _a3 : readValueFromInstance(instance2, key2, options);
      },
      setBaseTarget: function(key2, value2) {
        baseTarget[key2] = value2;
      },
      getBaseTarget: function(key2) {
        if (getBaseTarget) {
          var target = getBaseTarget(props, key2);
          if (target !== void 0 && !isMotionValue(target))
            return target;
        }
        return baseTarget[key2];
      }
    }, lifecycles), {
      build: function() {
        triggerBuild();
        return renderState;
      },
      scheduleRender: function() {
        sync.render(render, false, true);
      },
      syncRender: render,
      setProps: function(newProps) {
        if (newProps.transformTemplate || props.transformTemplate) {
          element.scheduleRender();
        }
        props = newProps;
        lifecycles.updatePropListeners(newProps);
        prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps2(props), prevMotionValues);
      },
      getProps: function() {
        return props;
      },
      getVariant: function(name) {
        var _a3;
        return (_a3 = props.variants) === null || _a3 === void 0 ? void 0 : _a3[name];
      },
      getDefaultTransition: function() {
        return props.transition;
      },
      getTransformPagePoint: function() {
        return props.transformPagePoint;
      },
      getVariantContext: function(startAtParent) {
        if (startAtParent === void 0) {
          startAtParent = false;
        }
        if (startAtParent)
          return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
        if (!isControllingVariants) {
          var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
          if (props.initial !== void 0) {
            context_1.initial = props.initial;
          }
          return context_1;
        }
        var context2 = {};
        for (var i2 = 0; i2 < numVariantProps; i2++) {
          var name_1 = variantProps[i2];
          var prop = props[name_1];
          if (isVariantLabel(prop) || prop === false) {
            context2[name_1] = prop;
          }
        }
        return context2;
      }
    });
    return element;
  };
};
var variantProps = __spreadArray(["initial"], __read(variantPriorityOrder), false);
var numVariantProps = variantProps.length;
function isCSSVariable(value) {
  return typeof value === "string" && value.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  var match = cssVariableRegex.exec(current);
  if (!match)
    return [,];
  var _a = __read(match, 3), token = _a[1], fallback = _a[2];
  return [token, fallback];
}
function getVariableValue(current, element, depth) {
  var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
  if (!token)
    return;
  var resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    return resolved.trim();
  } else if (isCSSVariable(fallback)) {
    return getVariableValue(fallback, element);
  } else {
    return fallback;
  }
}
function resolveCSSVariables(visualElement2, _a, transitionEnd) {
  var _b;
  var target = __rest$1(_a, []);
  var element = visualElement2.getInstance();
  if (!(element instanceof Element))
    return { target, transitionEnd };
  if (transitionEnd) {
    transitionEnd = __assign({}, transitionEnd);
  }
  visualElement2.forEachValue(function(value) {
    var current2 = value.get();
    if (!isCSSVariable(current2))
      return;
    var resolved2 = getVariableValue(current2, element);
    if (resolved2)
      value.set(resolved2);
  });
  for (var key in target) {
    var current = target[key];
    if (!isCSSVariable(current))
      continue;
    var resolved = getVariableValue(current, element);
    if (!resolved)
      continue;
    target[key] = resolved;
    if (transitionEnd)
      (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
  }
  return { target, transitionEnd };
}
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]);
var isPositionalKey = function(key) {
  return positionalKeys.has(key);
};
var hasPositionalKey = function(target) {
  return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function(value, to) {
  value.set(to, false);
  value.set(to);
};
var isNumOrPxType = function(v2) {
  return v2 === number || v2 === px;
};
var BoundingBoxDimension;
(function(BoundingBoxDimension2) {
  BoundingBoxDimension2["width"] = "width";
  BoundingBoxDimension2["height"] = "height";
  BoundingBoxDimension2["left"] = "left";
  BoundingBoxDimension2["right"] = "right";
  BoundingBoxDimension2["top"] = "top";
  BoundingBoxDimension2["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function(pos2, pos3) {
  return function(_bbox, _a) {
    var transform2 = _a.transform;
    if (transform2 === "none" || !transform2)
      return 0;
    var matrix3d = transform2.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform2.match(/^matrix\((.+)\)$/);
      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};
var transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function(key) {
  return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement2) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  if (removedTransforms.length)
    visualElement2.syncRender();
  return removedTransforms;
}
var positionalValues = {
  width: function(_a, _b) {
    var x2 = _a.x;
    var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
    return x2.max - x2.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: function(_a, _b) {
    var y2 = _a.y;
    var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
    return y2.max - y2.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: function(_bbox, _a) {
    var top2 = _a.top;
    return parseFloat(top2);
  },
  left: function(_bbox, _a) {
    var left2 = _a.left;
    return parseFloat(left2);
  },
  bottom: function(_a, _b) {
    var y2 = _a.y;
    var top2 = _b.top;
    return parseFloat(top2) + (y2.max - y2.min);
  },
  right: function(_a, _b) {
    var x2 = _a.x;
    var left2 = _b.left;
    return parseFloat(left2) + (x2.max - x2.min);
  },
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
var convertChangedValueTypes = function(target, visualElement2, changedKeys) {
  var originBbox = visualElement2.measureViewportBox();
  var element = visualElement2.getInstance();
  var elementComputedStyle = getComputedStyle(element);
  var display = elementComputedStyle.display;
  var origin = {};
  if (display === "none") {
    visualElement2.setStaticValue("display", target.display || "block");
  }
  changedKeys.forEach(function(key) {
    origin[key] = positionalValues[key](originBbox, elementComputedStyle);
  });
  visualElement2.syncRender();
  var targetBbox = visualElement2.measureViewportBox();
  changedKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    setAndResetVelocity(value, origin[key]);
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};
var checkAndConvertChangedValueTypes = function(visualElement2, target, origin, transitionEnd) {
  if (origin === void 0) {
    origin = {};
  }
  if (transitionEnd === void 0) {
    transitionEnd = {};
  }
  target = __assign({}, target);
  transitionEnd = __assign({}, transitionEnd);
  var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  var removedTransformValues = [];
  var hasAttemptedToRemoveTransformValues = false;
  var changedValueTypeKeys = [];
  targetPositionalKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    if (!visualElement2.hasValue(key))
      return;
    var from = origin[key];
    var fromType = findDimensionValueType(from);
    var to = target[key];
    var toType;
    if (isKeyframesTarget(to)) {
      var numKeyframes = to.length;
      var fromIndex = to[0] === null ? 1 : 0;
      from = to[fromIndex];
      fromType = findDimensionValueType(from);
      for (var i2 = fromIndex; i2 < numKeyframes; i2++) {
        if (!toType) {
          toType = findDimensionValueType(to[i2]);
        } else {
          invariant(findDimensionValueType(to[i2]) === toType);
        }
      }
    } else {
      toType = findDimensionValueType(to);
    }
    if (fromType !== toType) {
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        var current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
        if (from === 0) {
          value.set(toType.transform(from));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(visualElement2);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== void 0 ? transitionEnd[key] : target[key];
        setAndResetVelocity(value, to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    var convertedTarget = convertChangedValueTypes(target, visualElement2, changedValueTypeKeys);
    if (removedTransformValues.length) {
      removedTransformValues.forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        visualElement2.getValue(key).set(value);
      });
    }
    visualElement2.syncRender();
    return { target: convertedTarget, transitionEnd };
  } else {
    return { target, transitionEnd };
  }
};
function unitConversion(visualElement2, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement2, target, origin, transitionEnd) : { target, transitionEnd };
}
var parseDomVariant = function(visualElement2, target, origin, transitionEnd) {
  var resolved = resolveCSSVariables(visualElement2, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement2, target, origin, transitionEnd);
};
function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(domElement, key) {
    if (isTransformProp(key)) {
      var defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      var computedStyle = getComputedStyle$1(domElement);
      return (isCSSVariable$1(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
    }
  },
  sortNodePosition: function(a6, b2) {
    return a6.compareDocumentPosition(b2) & 2 ? 1 : -1;
  },
  getBaseTarget: function(props, key) {
    var _a;
    return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
  },
  measureViewportBox: function(element, _a) {
    var transformPagePoint = _a.transformPagePoint;
    return measureViewportBox(element, transformPagePoint);
  },
  resetTransform: function(element, domElement, props) {
    var transformTemplate = props.transformTemplate;
    domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    element.scheduleRender();
  },
  restoreTransform: function(instance2, mutableState) {
    instance2.style.transform = mutableState.style.transform;
  },
  removeValueFromRenderState: function(key, _a) {
    var vars = _a.vars, style = _a.style;
    delete vars[key];
    delete style[key];
  },
  makeTargetAnimatable: function(element, _a, _b, isMounted) {
    var transformValues = _b.transformValues;
    if (isMounted === void 0) {
      isMounted = true;
    }
    var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest$1(_a, ["transition", "transitionEnd"]);
    var origin = getOrigin(target, transition || {}, element);
    if (transformValues) {
      if (transitionEnd)
        transitionEnd = transformValues(transitionEnd);
      if (target)
        target = transformValues(target);
      if (origin)
        origin = transformValues(origin);
    }
    if (isMounted) {
      checkTargetForNewValues(element, target, origin);
      var parsed = parseDomVariant(element, target, origin, transitionEnd);
      transitionEnd = parsed.transitionEnd;
      target = parsed.target;
    }
    return __assign({ transition, transitionEnd }, target);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  build: function(element, renderState, latestValues, options, props) {
    if (element.isVisible !== void 0) {
      renderState.style.visibility = element.isVisible ? "visible" : "hidden";
    }
    buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
  },
  render: renderHTML
};
var htmlVisualElement = visualElement(htmlConfig);
var svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), { getBaseTarget: function(props, key) {
  return props[key];
}, readValueFromInstance: function(domElement, key) {
  var _a;
  if (isTransformProp(key)) {
    return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
  }
  key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
  return domElement.getAttribute(key);
}, scrapeMotionValuesFromProps, build: function(_element, renderState, latestValues, options, props) {
  buildSVGAttrs(renderState, latestValues, options, props.transformTemplate);
}, render: renderSVG }));
var createDomVisualElement = function(Component2, options) {
  return isSVGComponent(Component2) ? svgVisualElement(options, { enableHardwareAcceleration: false }) : htmlVisualElement(options, { enableHardwareAcceleration: true });
};
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
var correctBorderRadius = {
  correct: function(latest, node) {
    if (!node.target)
      return latest;
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    var x2 = pixelsToPercent(latest, node.target.x);
    var y2 = pixelsToPercent(latest, node.target.y);
    return "".concat(x2, "% ").concat(y2, "%");
  }
};
var varToken = "_$css";
var correctBoxShadow = {
  correct: function(latest, _a) {
    var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
    var original = latest;
    var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) {
      latest = latest.replace(cssVariableRegex, function(match) {
        cssVariables.push(match);
        return varToken;
      });
    }
    var shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    var template = complex.createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    var xScale = projectionDelta.x.scale * treeScale.x;
    var yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    var averageScale = mix(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset] === "number")
      shadow[2 + offset] /= averageScale;
    if (typeof shadow[3 + offset] === "number")
      shadow[3 + offset] /= averageScale;
    var output2 = template(shadow);
    if (containsCSSVariables) {
      var i_1 = 0;
      output2 = output2.replace(varToken, function() {
        var cssVariable = cssVariables[i_1];
        i_1++;
        return cssVariable;
      });
    }
    return output2;
  }
};
var MeasureLayoutWithContext = function(_super) {
  __extends(MeasureLayoutWithContext2, _super);
  function MeasureLayoutWithContext2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MeasureLayoutWithContext2.prototype.componentDidMount = function() {
    var _this = this;
    var _a = this.props, visualElement2 = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
    var projection = visualElement2.projection;
    addScaleCorrector(defaultScaleCorrectors);
    if (projection) {
      if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
        layoutGroup.group.add(projection);
      if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", function() {
        _this.safeToRemove();
      });
      projection.setOptions(__assign(__assign({}, projection.options), {
        onExitComplete: function() {
          return _this.safeToRemove();
        }
      }));
    }
    globalProjectionState.hasEverUpdated = true;
  };
  MeasureLayoutWithContext2.prototype.getSnapshotBeforeUpdate = function(prevProps) {
    var _this = this;
    var _a = this.props, layoutDependency = _a.layoutDependency, visualElement2 = _a.visualElement, drag2 = _a.drag, isPresent = _a.isPresent;
    var projection = visualElement2.projection;
    if (!projection)
      return null;
    projection.isPresent = isPresent;
    if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        sync.postRender(function() {
          var _a2;
          if (!((_a2 = projection.getStack()) === null || _a2 === void 0 ? void 0 : _a2.members.length)) {
            _this.safeToRemove();
          }
        });
      }
    }
    return null;
  };
  MeasureLayoutWithContext2.prototype.componentDidUpdate = function() {
    var projection = this.props.visualElement.projection;
    if (projection) {
      projection.root.didUpdate();
      if (!projection.currentAnimation && projection.isLead()) {
        this.safeToRemove();
      }
    }
  };
  MeasureLayoutWithContext2.prototype.componentWillUnmount = function() {
    var _a = this.props, visualElement2 = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
    var projection = visualElement2.projection;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
        layoutGroup.group.remove(projection);
      if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
        promoteContext.deregister(projection);
    }
  };
  MeasureLayoutWithContext2.prototype.safeToRemove = function() {
    var safeToRemove = this.props.safeToRemove;
    safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
  };
  MeasureLayoutWithContext2.prototype.render = function() {
    return null;
  };
  return MeasureLayoutWithContext2;
}(React__default.Component);
function MeasureLayout(props) {
  var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
  var layoutGroup = useContext(LayoutGroupContext);
  return /* @__PURE__ */ jsx(MeasureLayoutWithContext, __spreadValues({}, __assign({}, props, {
    layoutGroup,
    switchLayoutGroup: useContext(SwitchLayoutGroupContext),
    isPresent,
    safeToRemove
  })));
}
var defaultScaleCorrectors = {
  borderRadius: __assign(__assign({}, correctBorderRadius), {
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
var layoutFeatures = {
  measureLayout: MeasureLayout
};
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function(ref, notify) {
    ref.addEventListener("resize", notify, { passive: true });
    return function() {
      return ref.removeEventListener("resize", notify);
    };
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  }
});
var rootProjectionNode = {
  current: void 0
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: function(instance2) {
    return {
      x: instance2.scrollLeft,
      y: instance2.scrollTop
    };
  },
  defaultParent: function() {
    if (!rootProjectionNode.current) {
      var documentNode = new DocumentProjectionNode(0, {});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function(instance2, value) {
    instance2.style.transform = value !== null && value !== void 0 ? value : "none";
  }
});
var featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutFeatures);
var motion = /* @__PURE__ */ createMotionProxy(function(Component2, config2) {
  return createDomMotionConfig(Component2, config2, featureBundle, createDomVisualElement, HTMLProjectionNode);
});
const CaptureButtonContainer$2 = styled(motion.div)`
  position: fixed;
  bottom: 18px;
  left: calc(50% - 44px);
  z-index: 9999;

  p {
    margin: 0;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-size: 13px;
    color: #343a4f;
    font-weight: bold;
  }

  button {
    background-color: transparent;
    border: none;
  }
`;
const Hidder = styled(motion.div)`
  background: #f5f5f6;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const WebcamContainer = styled.div`
  height: 301px;
  width: 301px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const spinner$2 = Ue`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const Container$6 = styled.div`
  height: 100%;
  max-width: 300px;
  text-align: center;
  margin: auto;
  padding-top: 100px;
  position: relative;

  @media only screen and (max-height: 600px) {
    padding-top: 30px;
  }
`;
const BordersContainer = styled.div`
  position: absolute;
  left: -17px;
  top: 84px;
  right: 0;
  width: 335px;
  margin: auto;

  @media only screen and (max-height: 600px) {
    top: 14px;
  }
`;
const CameraOvalOuter = styled(motion.div)`
  width: 300px;
  height: 300px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotateZ(0.01deg);
  border: 0px solid #21273b;
`;
const CameraOvalInner = styled.div`
  border-radius: 50%;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  border: 11px solid #fff;

  &.isUploading {
    border: none;
    background-color: rgba(113, 113, 113, 0.07);
  }
`;
const CameraOvalInnerText = styled.p`
  font-size: 23px;
  font-weight: bold;
  color: #21273b;

  &.isError {
    color: #ff5c6f;
  }
`;
const FaceFrame$1 = styled.img`
  height: 85%;
  position: absolute;
  z-index: 10;
`;
const LoadingBordersContainer = styled(motion.svg)`
  height: 100%;
  width: 100%;

  animation: ${spinner$2} 1s linear infinite;

  &.success {
    animation: none;
  }
`;
const NotificationInline = styled(motion.p)`
  font-size: 100px;
  font-size: 23px;
  font-weight: bold;
  margin-top: 30px;
  margin: 30px auto 0 auto;
  height: 60px;

  &.hasManualCapture {
    @media only screen and (max-height: 530px) {
      display: none;
    }
  }
`;
const loadingColors = {
  capturing: "rgba(33, 39, 59, 0.36)",
  uploading: "#3CB0F7",
  success: "#09eda8"
};
function LoadingBorders(_y) {
  var _z = _y, {
    mode: mode2
  } = _z, props = __objRest(_z, [
    "mode"
  ]);
  const color2 = loadingColors[mode2];
  return /* @__PURE__ */ jsxs(LoadingBordersContainer, __spreadProps(__spreadValues({
    width: 272,
    height: 272,
    viewBox: "0 0 272 272",
    className: classNames({
      success: mode2 === "success"
    }),
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: 0.3
    }
  }, props), {
    children: [/* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsx("circle", {
        id: "wydb6yed4a",
        cx: 142,
        cy: 142,
        r: 125
      }), /* @__PURE__ */ jsxs("mask", {
        id: "kb40xhfrmb",
        width: 272,
        height: 272,
        x: -11,
        y: -11,
        maskContentUnits: "userSpaceOnUse",
        maskUnits: "objectBoundingBox",
        children: [/* @__PURE__ */ jsx("path", {
          fill: "#fff",
          d: "M6 6H278V278H6z"
        }), /* @__PURE__ */ jsx("use", {
          xlinkHref: "#wydb6yed4a"
        })]
      })]
    }), /* @__PURE__ */ jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      strokeDasharray: "2.94 4.2",
      children: /* @__PURE__ */ jsx(motion.g, {
        strokeWidth: 22,
        initial: {
          stroke: "rgba(33, 39, 59, 0.36)"
        },
        animate: {
          stroke: color2
        },
        transition: {
          duration: 0.5
        },
        children: /* @__PURE__ */ jsx("g", {
          transform: "translate(-52 -225) translate(46 219)",
          children: /* @__PURE__ */ jsx("use", {
            mask: "url(#kb40xhfrmb)",
            transform: "rotate(-90 142 142)",
            xlinkHref: "#wydb6yed4a"
          })
        })
      })
    })]
  }));
}
const PreviewImage = styled.img`
  width: 100%;
  position: absolute;
  z-index: 1;
  transform: rotateY(180deg) rotateZ(0.01deg);
`;
const LoginContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  video {
    width: 100% !important;
    margin-left: 0 !important;
  }
`;
const Notification = styled.p`
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 20px 15px 20px;
  position: absolute;
  top: 20px;
  left: 50%;
  right: 0;
  max-width: calc(100% - 50px); // 40px are for the padding
  width: fit-content;
  box-sizing: content-box;
  transform: translateX(-50%);
  z-index: 9999999999999;

  &.center {
    font-size: 18px;

    .icon {
      text-align: center;
    }

    .notification-text {
      line-height: 1.5;
      margin: 0;
    }
  }

  &.inline {
    display: flex;
  }

  color: ${(props) => props.isLoading ? "white" : props.isError ? "#ff5c6f" : "white"};

  &.desktop {
    top: 100px;
    padding: 0;
    background-color: transparent;
    color: #20263d;
    font-size: 24px;
    line-height: 22px;
  }
`;
const FaceMask$1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  position: absolute;
  top: 45%;
  width: 35vw;
  height: 35vw;
  transform: translate(-50%, -50%);
  left: 50%;
  border: solid 6.9px;
  border-color: ${(props) => props.isCapturing ? "#0cd5a2" : props.isLoading ? "#00b2fd" : props.error ? "#ff5c6f" : "#fff"};
  border-radius: 50%;
  box-shadow: ${(props) => props.desktop ? "0 0 0 99999px #ffffff" : props.isUploading ? "0 0 0 99999px #F2F2F2" : "0 0 0 99999px rgba(0, 0, 0, 0.6)"};
`;
const WebcamDesktopContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;
function useSelfie({
  timeout = 4e4,
  onLog = emptyFunc,
  handleCapture,
  numberOfTries = 3,
  handleNoAttempsLeft = emptyFunc,
  webcam,
  onSwitchManualCapture = emptyFunc,
  onManualCaptureSelfie = emptyFunc
}) {
  const timesCaptureFailed = useRef(0);
  const capturing = useRef(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [mode2, setMode] = useState("idle");
  const [cameraReady, setCameraReady] = useState(false);
  const [showManualCapture, setShowManualCapture] = useState(false);
  const selfieTimeoutRef = useRef();
  const onSwitchManualCaptureRef = useRef(onSwitchManualCapture);
  const { t: t2 } = useTranslation();
  useEffect(() => {
    onSwitchManualCaptureRef.current = onSwitchManualCapture;
  }, [onSwitchManualCapture]);
  const attemptsFailed = timesCaptureFailed.current;
  useEffect(() => {
    setShowManualCapture(false);
    selfieTimeoutRef.current = window.setTimeout(() => {
      var _a;
      const timeoutLog = getLogObject("timeout", {
        message: "No face found"
      });
      (_a = onSwitchManualCaptureRef.current) == null ? void 0 : _a.call(onSwitchManualCaptureRef);
      onLog(timeoutLog);
      setShowManualCapture(true);
      stopDetect();
    }, timeout);
    const selfieTimeout = selfieTimeoutRef.current;
    return () => clearTimeout(selfieTimeout);
  }, [onLog, timeout, attemptsFailed]);
  const handleFaceAutoCapture = async (selfie, fullImage, faceCoordinates) => {
    stopDetect();
    setMode("idle");
    await sleep(300);
    setMode("uploading");
    handleCapture(selfie, fullImage, faceCoordinates);
  };
  const resetLoading = async ({ response, livenessPassed, imageBase64 }) => {
    timesCaptureFailed.current = timesCaptureFailed.current + 1;
    if (numberOfTries !== -1 && timesCaptureFailed.current >= numberOfTries) {
      return handleNoAttempsLeft({
        response,
        livenessPassed,
        imageBase64
      });
    }
    setNotificationMessage("");
    setMode("idle");
    capturing.current = false;
    await sleep(1e3);
    resumeDetect();
  };
  const handleError = (error3) => {
    const errorMessage = error3.errorMessage || error3.message || error3.reason;
    const { status } = error3;
    if (status === 3004) {
      setNotificationMessage(t2("notifications.unableToCrop"));
      onLog(getLogObject("unableToCrop", {
        message: `${t2("notifications.unableToCrop")}`
      }));
      return;
    }
    switch (errorMessage) {
      case "No faces found on the image":
        setNotificationMessage(t2("notifications.face"));
        onLog(getLogObject("faceNotDetected", {
          message: `${t2("notifications.face")}`
        }));
        break;
      case "BadRequestException: More than one face detected.":
        setNotificationMessage(t2("notifications.multiple"));
        onLog(getLogObject("multipleFacesDetected", {
          message: `${t2("notifications.multiple")}`
        }));
        break;
      case "Cropping area goes off the image.":
        setNotificationMessage(t2("notifications.crop"));
        onLog(getLogObject("cropTooSmall", {
          message: `${t2("notifications.crop")}`
        }));
        break;
      case "Image in portrait orientation is expected.":
        setNotificationMessage(t2("notifications.portrait"));
        onLog(getLogObject("imageNotPortrait", {
          message: `${t2("notifications.portrait")}`
        }));
        break;
      default:
        onLog(getLogObject("InternalServerError", {
          message: `${t2("notifications.error")}`
        }));
        setNotificationMessage(t2("notifications.error"));
        break;
    }
  };
  const autoDetectFace = useCallback(() => {
    const handleFaceFarAway = () => {
      if (!capturing.current) {
        onLog(getLogObject("tooFar", {
          message: t2("notifications.moveCloser")
        }));
        setNotificationMessage(t2("notifications.moveCloser"));
      }
    };
    const handleTooManyFaces = () => {
      if (!capturing.current) {
        onLog(getLogObject("tooManyFaces", {
          message: t2("notifications.tooManyFaces")
        }));
        setNotificationMessage(t2("notifications.tooManyFaces"));
      }
    };
    const handleCenterFace = () => {
      if (!capturing.current) {
        onLog(getLogObject("centerFace", {
          message: t2("notifications.centerFace")
        }));
        setNotificationMessage(t2("notifications.centerFace"));
      }
    };
    const handleFaceCapturing = () => {
      setMode("capturing");
      onLog(getLogObject("dontMove", {
        message: t2("notifications.dontMove")
      }));
      setNotificationMessage(t2("notifications.getReady"));
      capturing.current = true;
    };
    const handleTooClose = () => {
      if (capturing.current) {
        return;
      }
      setNotificationMessage(t2("notifications.moveAway"));
    };
    const canvas = document.getElementById("canvasFrame");
    if (!canvas)
      return;
    canvas.width = 300;
    canvas.height = 400;
    detect({
      canvas,
      type: selfieType,
      webcam: webcam.current,
      onFarAway: handleFaceFarAway,
      onCapture: handleFaceAutoCapture,
      onTooClose: handleTooClose,
      onCapturing: handleFaceCapturing,
      onTooManyFaces: handleTooManyFaces,
      onCenterFace: handleCenterFace,
      onNoFace: () => {
        if (capturing.current) {
          return;
        }
        setNotificationMessage("");
      }
    });
    resumeDetect();
  }, [onLog]);
  const startAutoDetect = useCallback(async () => {
    setCameraReady(true);
    sleep(2e3);
    autoDetectFace();
  }, [autoDetectFace]);
  function handleManualCapture() {
    onManualCaptureSelfie();
    const imageBase64 = webcam.current.getBase64ScreenShot(webcam.current.video.videoWidth, webcam.current.video.videoHeight, 1, false);
    const fullImage = webcam.current.getFullImage(webcam.current.video.videoWidth, webcam.current.video.videoHeight, 1);
    handleFaceAutoCapture(imageBase64, fullImage, null);
  }
  const isCapturing = mode2 === "capturing";
  const isUploading = mode2 === "uploading";
  const isSuccess = mode2 === "success";
  const isError = mode2 === "error";
  const isLoading = isCapturing || isUploading;
  const hideCamera = isUploading || isSuccess || isError;
  const showBorders = cameraReady && (mode2 === "idle" || isError);
  const shouldShowManualCapture = showManualCapture && !hideCamera;
  return {
    notificationMessage,
    mode: mode2,
    capturing,
    cameraReady,
    showManualCapture,
    handleFaceAutoCapture,
    setMode,
    resetLoading,
    setNotificationMessage,
    handleError,
    autoDetectFace,
    startAutoDetect,
    handleManualCapture,
    isCapturing,
    isUploading,
    isSuccess,
    isError,
    isLoading,
    hideCamera,
    showBorders,
    shouldShowManualCapture,
    selfieTimeoutRef
  };
}
const getCircleText$1 = (t2, notification) => ({
  uploading: t2("notifications.uploading"),
  success: t2("notifications.done"),
  error: notification
});
function CaptureSelfie$1({
  onBoarding,
  onError,
  onSuccess,
  permission,
  setPermission,
  permissionMessage,
  permissionBackgroundColor,
  onLog,
  token,
  timeout,
  numberOfTries,
  showPreview,
  stream,
  onlyCapture,
  showCustomCameraPermissionScreen,
  isSecondId,
  assistedOnboarding,
  isRecordingEnabled = false,
  showDoublePermissionsRequest,
  onRestartOnboarding
}) {
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const webcam = useRef(null);
  const [takenCapture, setTakenCapture] = useState(null);
  useEffect(() => onBoarding.resumeDetect(), [onBoarding]);
  const {
    startRecording,
    stopRecording
  } = useMediaRecorder({
    token: sessionToken,
    type: "selfie"
  });
  useEffect(() => {
    return () => stopRecording == null ? void 0 : stopRecording();
  }, [stopRecording]);
  const handleCapture = throttle$1(async (imageBase64, fullImage, faceCoordinates) => {
    var _b;
    try {
      clearTimeout(selfieTimeoutRef.current);
      setTakenCapture(fullImage);
      onBoarding.stopDetect();
      onBoarding.addEvent({
        eventName: "selfieCapture",
        eventType: "text",
        eventData: {},
        token: sessionToken
      });
      const type = onBoarding.selfieType;
      const encryptedImage = await encryptImage(fullImage);
      const blob = toBlob(imageBase64);
      const src2 = URL.createObjectURL(blob);
      if (onlyCapture) {
        return onSuccess({
          imageBase64,
          blob,
          encryptedImage,
          src: src2
        });
      }
      const response = await onBoarding.capture({
        token: sessionToken,
        image: encryptedImage,
        type,
        encrypted: true,
        faceCoordinates
      });
      const livenessPassed = response.confidence === 0;
      const brighnessPassed = response.isBright;
      const lensesPassed = !response.hasLenses;
      const maskPassed = !response.hasFaceMask;
      if (!livenessPassed || !brighnessPassed || !lensesPassed || !maskPassed) {
        setMode("error");
        if (!lensesPassed) {
          onLog(getLogObject("lensesDetected", {
            response,
            message: "Lenses detected"
          }));
          setNotificationMessage(t2("notifications.lenses"));
        } else if (!brighnessPassed) {
          onLog(getLogObject("badBrightness", {
            response,
            message: "Bad brightness"
          }));
          setNotificationMessage(t2("notifications.brightness"));
        } else if (!maskPassed) {
          onLog(getLogObject("badMask", {
            response,
            message: "Mask detected"
          }));
          setNotificationMessage(t2("notifications.mask"));
        } else if (!livenessPassed) {
          onLog(getLogObject("spoofAttempt", {
            response,
            message: "Spoof attempt detected"
          }));
          setNotificationMessage(t2("notifications.spoof"));
        }
        setTakenCapture(null);
        await sleep(3e3);
        resetLoading({
          response,
          livenessPassed,
          imageBase64
        });
        startAutoDetect();
        return;
      }
      const _a = await processFace2(), {
        faceMatch,
        existingUser
      } = _a, processResponse = __objRest(_a, [
        "faceMatch",
        "existingUser"
      ]);
      setMode("success");
      onLog(getLogObject("successCapture", {
        response,
        message: "Selfie uploaded successfully"
      }));
      setNotificationMessage(t2("notifications.success"));
      setTakenCapture(null);
      await sleep(3500);
      return onSuccess(__spreadProps(__spreadValues(__spreadValues({}, response), processResponse), {
        faceMatch,
        existingUser,
        liveness: livenessPassed,
        imageBase64
      }));
    } catch (err) {
      setTakenCapture(null);
      handleError(err.response ? err.response.data : t2("notifications.serverError"));
      setMode("error");
      await sleep(3e3);
      resetLoading({
        response: (_b = err == null ? void 0 : err.response) == null ? void 0 : _b.data,
        livenessPassed: null,
        imageBase64
      });
      startAutoDetect();
    }
  }, 300);
  const {
    t: t2
  } = useTranslation();
  const skipWithError = (existingUser, liveness, imageBase64, faceMatch) => {
    onBoarding.updateSession({
      token: sessionToken,
      key: "manualSelfieCheckNeeded",
      value: true
    });
    const skipLog = getLogObject("skip", {
      existingUser,
      liveness,
      imageBase64,
      faceMatch
    });
    onLog(skipLog);
    onError(skipLog);
  };
  async function handleNoAttempsLeft({
    response,
    livenessPassed,
    imageBase64
  }) {
    onBoarding.addEvent({
      eventName: "noAttempts",
      eventType: "text",
      eventData: {},
      token: sessionToken
    });
    onLog(getLogObject("noAttemps", {
      response,
      message: "No attempt left"
    }));
    const {
      faceMatch,
      existingUser
    } = await processFace2();
    return skipWithError(existingUser, livenessPassed, imageBase64, faceMatch);
  }
  async function processFace2() {
    const processResponse = await onBoarding.processFace({
      token: sessionToken
    });
    if (isSecondId) {
      await onBoarding.processFaceSecondId({
        token: sessionToken
      });
    }
    const faceMatch = processResponse.confidence === 1;
    const existingUser = processResponse.existingUser;
    return __spreadValues({
      faceMatch,
      existingUser
    }, processResponse);
  }
  const {
    showManualCapture,
    mode: mode2,
    setMode,
    resetLoading,
    notificationMessage,
    setNotificationMessage,
    handleError,
    startAutoDetect,
    cameraReady,
    handleManualCapture,
    isSuccess,
    isError,
    isLoading,
    hideCamera,
    showBorders,
    shouldShowManualCapture,
    selfieTimeoutRef
  } = useSelfie({
    timeout,
    onLog,
    handleCapture,
    handleNoAttempsLeft,
    numberOfTries,
    webcam,
    onSwitchManualCapture: () => {
      onBoarding.addEvent({
        eventName: "switchToManualCaptureSelfie",
        eventType: "text",
        eventData: {},
        token: sessionToken
      });
    },
    onManualCaptureSelfie: () => {
      onBoarding.addEvent({
        eventName: "manualCaptureSelfie",
        eventType: "text",
        eventData: {},
        token: sessionToken
      });
    }
  });
  return /* @__PURE__ */ jsxs(Container$6, {
    children: [shouldShowManualCapture && /* @__PURE__ */ jsxs(CaptureButtonContainer$2, {
      initial: {
        scale: 0
      },
      animate: {
        scale: 1
      },
      children: [/* @__PURE__ */ jsx("p", {
        children: t2("common.takePhoto")
      }), /* @__PURE__ */ jsx("button", {
        onClick: handleManualCapture,
        children: /* @__PURE__ */ jsx("img", {
          src: captureButton,
          alt: "capture button"
        })
      })]
    }), /* @__PURE__ */ jsxs(WebcamContainer, {
      children: [(isLoading || isSuccess) && /* @__PURE__ */ jsx(BordersContainer, {
        children: /* @__PURE__ */ jsx(LoadingBorders, {
          mode: mode2
        })
      }), /* @__PURE__ */ jsx(Hidder, {
        initial: {
          width: 0,
          height: 0
        },
        animate: {
          width: cameraReady ? 300 : 10,
          height: cameraReady ? 300 : 10
        },
        children: /* @__PURE__ */ jsx(CameraOvalOuter, {
          className: classNames({
            "no-borders": isLoading || isSuccess,
            "has-error": isError
          }),
          initial: {
            borderWidth: "0px"
          },
          transition: {
            delay: 0,
            ease: "linear"
          },
          animate: {
            borderWidth: showBorders ? "6px" : "0px",
            borderColor: isError ? "#ff5c6f" : "#21273b"
          },
          children: /* @__PURE__ */ jsxs(CameraOvalInner, {
            className: classNames({
              isUploading: hideCamera
            }),
            children: [/* @__PURE__ */ jsx(FaceFrame$1, {
              src: faceFrame$1,
              alt: "face frame",
              className: classNames({
                hidden: hideCamera
              })
            }), showPreview && takenCapture && /* @__PURE__ */ jsx(PreviewImage, {
              src: `data:image/jpeg;base64,${takenCapture}`
            }), /* @__PURE__ */ jsx(WebcamWithChooseCamera, {
              ref: webcam,
              onPlay: startAutoDetect,
              videoSource: assistedOnboarding ? "environment" : "user",
              isSelfie: true,
              className: classNames("video__selfie", {
                hidden: hideCamera
              }),
              permission,
              setPermission,
              permissionMessage,
              permissionBackgroundColor,
              onLog,
              stream,
              onError,
              onBoarding,
              token: sessionToken,
              onStreamReady: isRecordingEnabled ? startRecording : void 0,
              showCustomCameraPermissionScreen,
              assistedOnboarding,
              showDoublePermissionsRequest,
              onRestartOnboarding
            }), hideCamera && /* @__PURE__ */ jsx(CameraOvalInnerText, {
              className: classNames({
                isError
              }),
              children: getCircleText$1(t2, notificationMessage)[mode2]
            })]
          })
        })
      })]
    }), !hideCamera && /* @__PURE__ */ jsx(NotificationInline, {
      initial: {
        scale: 0
      },
      animate: {
        scale: cameraReady ? 1 : 0
      },
      className: classNames({
        hasManualCapture: showManualCapture
      }),
      children: notificationMessage || /* @__PURE__ */ jsxs(Fragment, {
        children: [t2("notifications.selfie.one"), " ", /* @__PURE__ */ jsx("br", {}), t2("notifications.selfie.two")]
      })
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame",
      hidden: true
    })]
  });
}
const LabelButton$1 = styled.label`
  ${buttonStyles}
  margin-top: 20px;
  display: block;
  text-align: center;
`;
LabelButton$1.defaultProps = {
  theme: theme$1
};
function UploadInput({
  token,
  onBoarding,
  shouldTakeAgain = emptyFunc,
  onError,
  onSuccess,
  onLog,
  numberOfTries
}) {
  const [progress2, setProgress] = useState(0);
  const [timesCaptureFailed, setTimesCaptureFailed] = useState(0);
  const [captureSuccessful, setCaptureSuccessful] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [finishCapture, setFinishCapture] = useState(false);
  const [showCapturePreview, setShowCapturePreview] = useState(false);
  const [imageBase64, setImageBase64] = useState("");
  const responseRef = useRef(null);
  const {
    t: t2
  } = useTranslation();
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const skipWithError = (existingUser, faceMatch) => {
    onBoarding.updateSession({
      token: sessionToken,
      key: "manualSelfieCheckNeeded",
      value: true
    });
    const skipLog = getLogObject("skip", {
      existingUser,
      faceMatch
    });
    onLog(skipLog);
    onError(skipLog);
  };
  async function processFace2() {
    const processResponse = await onBoarding.processFace({
      token: sessionToken
    });
    const faceMatch = processResponse.confidence === 1;
    const existingUser = processResponse.existingUser;
    return __spreadValues({
      faceMatch,
      existingUser
    }, processResponse);
  }
  async function handleNoAttempsLeft() {
    onLog(getLogObject("noAttemps", {
      response: responseRef.current,
      message: "No attempt left"
    }));
    const {
      faceMatch,
      existingUser
    } = await processFace2();
    return skipWithError(existingUser, faceMatch);
  }
  const idUploadError = () => {
    setTimesCaptureFailed(timesCaptureFailed + 1);
    if (numberOfTries !== -1 && timesCaptureFailed + 1 >= numberOfTries) {
      onBoarding.updateSession({
        token: sessionToken,
        key: "manualIdCheckNeeded",
        value: true
      });
      return handleNoAttempsLeft();
    }
  };
  const idUploadSuccess = () => {
    onLog(getLogObject("successCapture", {
      response: responseRef.current
    }));
    onSuccess(responseRef.current);
    return true;
  };
  const handleCloseCapturePreview = (error3) => {
    if (!error3) {
      idUploadError();
    } else {
      idUploadSuccess();
    }
    setErrorMessage("");
    setShowCapturePreview(false);
    setProgress(0);
    setFinishCapture(false);
    setCaptureSuccessful(null);
  };
  async function handleChange(ev) {
    setShowCapturePreview(true);
    const {
      imageBase64: imgBase64
    } = await getScaledImageFromFile(ev.target.files[0], 480, true);
    setImageBase64(imgBase64);
    try {
      const type = onBoarding.selfieType;
      const encryptedImage = await encryptImage(imgBase64.split(",")[1]);
      const response = await onBoarding.capture({
        token: sessionToken,
        image: encryptedImage,
        type,
        onProgress: setProgress,
        encrypted: true
      });
      const livenessPassed = response.confidence === 0;
      const brighnessPassed = response.isBright;
      const lensesPassed = !response.hasLenses;
      const maskPassed = !response.hasFaceMask;
      if (!livenessPassed || !brighnessPassed || !lensesPassed || !maskPassed) {
        if (!lensesPassed) {
          onLog(getLogObject("lensesDetected", {
            response,
            message: "Lenses detected"
          }));
          setErrorMessage(t2("notifications.lenses"));
        } else if (!maskPassed) {
          onLog(getLogObject("badMask", {
            response,
            message: "Mask detected"
          }));
          setErrorMessage(t2("notifications.mask"));
        } else if (!brighnessPassed) {
          onLog(getLogObject("badBrightness", {
            response,
            message: "Bad brightness"
          }));
          setErrorMessage(t2("notifications.brightness"));
        } else if (!livenessPassed) {
          onLog(getLogObject("spoofAttempt", {
            response,
            message: "Spoof attempt detected"
          }));
          setErrorMessage(t2("notifications.spoof"));
        }
        setCaptureSuccessful(false);
        await sleep(SLEEP_DURATION);
        setFinishCapture(true);
        setProgress(100);
        return;
      }
      const _a = await processFace2(), {
        faceMatch,
        existingUser
      } = _a, processResponse = __objRest(_a, [
        "faceMatch",
        "existingUser"
      ]);
      responseRef.current = __spreadProps(__spreadValues(__spreadValues({}, response), processResponse), {
        faceMatch,
        existingUser,
        liveness: livenessPassed,
        imageBase64
      });
      const {
        status,
        message: message2,
        errorKey: errorKey2
      } = shouldTakeAgain(response);
      if (status) {
        onLog(getLogObject("attemptFailed", {
          response: responseRef.current,
          message: message2,
          reason: errorKey2,
          attempt: timesCaptureFailed + 1
        }));
        setCaptureSuccessful(false);
        setErrorMessage(message2);
        await sleep(SLEEP_DURATION);
      } else {
        setCaptureSuccessful(true);
        await sleep(SLEEP_DURATION);
      }
      setFinishCapture(true);
      setProgress(100);
    } catch (e2) {
      const {
        message: message2,
        errorKey: errorKey2
      } = shouldTakeAgain(e2.response ? e2.response.data : t2("notifications.serverError"));
      onLog(getLogObject("attemptFailed", {
        response: responseRef.current,
        message: message2,
        reason: errorKey2,
        attempt: timesCaptureFailed + 1
      }));
      setCaptureSuccessful(false);
      setErrorMessage(message2);
      await sleep(SLEEP_DURATION);
      setFinishCapture(true);
      setProgress(100);
    }
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(LabelButton$1, {
      children: [/* @__PURE__ */ jsx("input", {
        style: {
          display: "none"
        },
        type: "file",
        accept: "image/*",
        capture: "user",
        onChange: handleChange
      }), /* @__PURE__ */ jsx("span", {
        children: t2("common.takePhoto")
      })]
    }), showCapturePreview && /* @__PURE__ */ jsx(CapturePreview, {
      message: errorMessage,
      progress: progress2,
      finishCapture,
      captureSuccessful,
      onClose: handleCloseCapturePreview,
      imageBase64,
      isSelfie: true
    })]
  });
}
function NativeCaptureId(_A) {
  var _B = _A, {
    tutorialSrc,
    tutorialHeader
  } = _B, props = __objRest(_B, [
    "tutorialSrc",
    "tutorialHeader"
  ]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({}, props), {
      video: tutorialSrc,
      header: tutorialHeader,
      children: /* @__PURE__ */ jsx(UploadInput, __spreadValues({}, props))
    }))
  });
}
const TutorialSelfieHeader$1 = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: t2("tutorial.selfie1")
    }), /* @__PURE__ */ jsx("span", {
      children: t2("tutorial.selfie2")
    }), /* @__PURE__ */ jsx("br", {}), /* @__PURE__ */ jsx("span", {
      children: t2("tutorial.selfie3")
    })]
  });
};
function TutorialSelfie(_C) {
  var _D = _C, {
    onSuccess,
    token,
    src: src2 = "https://sdk.incode.com/sdk/tutorials/selfie.gif",
    onError
  } = _D, props = __objRest(_D, [
    "onSuccess",
    "token",
    "src",
    "onError"
  ]);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    if (token == null ? void 0 : token.token) {
      addEvent({
        token: token.token,
        eventName: "tutorialSelfie",
        eventData: {
          tutorialSelfie: true
        },
        eventType: "text"
      });
    }
  }, [token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return /* @__PURE__ */ jsx(Tutorial$1, __spreadProps(__spreadValues({}, props), {
    selfie: true,
    src: src2,
    header: /* @__PURE__ */ jsx(TutorialSelfieHeader$1, {}),
    children: /* @__PURE__ */ jsx(ButtonsContainer$2, {
      children: /* @__PURE__ */ jsx(StyledButton$1, {
        className: classNames("IncodeTutorialButton", `IncodeTutorialButtonSelfie`),
        onClick: handleClick,
        children: t2("common.continue")
      })
    })
  }));
}
const TutorialSelfieHeader = ({
  onBoarding
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: t2("tutorial.selfie1")
    }), /* @__PURE__ */ jsxs("span", {
      children: [t2("tutorial.selfie2"), /* @__PURE__ */ jsx("br", {}), t2("tutorial.selfie3")]
    })]
  });
};
function Selfie(props) {
  const {
    t: t2
  } = useTranslation();
  const shouldTakeAgain = (response) => {
    const errorMessage = response.errorMessage || response.message || response.reason;
    if (errorMessage) {
      switch (errorMessage) {
        case "faces were not found":
          return {
            status: true,
            message: t2("notifications.face")
          };
        case "BadRequestException: More than one face detected.":
          return {
            status: true,
            message: t2("notifications.multiple")
          };
        case "Crop is too small":
          return {
            status: true,
            message: t2("notifications.crop")
          };
        case "Image is not portrait":
          return {
            status: true,
            message: t2("notifications.portrait")
          };
        default:
          return {
            status: true,
            message: t2("notifications.error")
          };
      }
    } else {
      const livenessPassed = response.confidence === 0;
      if (livenessPassed) {
        return {
          status: false,
          message: ""
        };
      } else {
        return {
          status: true,
          message: t2("notifications.spoof")
        };
      }
    }
  };
  if (isWebRtcSupported()) {
    return /* @__PURE__ */ jsx(CaptureSelfie$1, __spreadValues({}, props));
  } else {
    return /* @__PURE__ */ jsx(NativeCaptureId, __spreadProps(__spreadValues({}, props), {
      shouldTakeAgain,
      tutorialSrc: "https://sdk.incode.com/sdk/tutorials/selfie-native.gif",
      tutorialHeader: /* @__PURE__ */ jsx(TutorialSelfieHeader, {})
    }));
  }
}
function CaptureAndTutorial(_E) {
  var props = __objRest(_E, []);
  const {
    currentStep,
    nextStep
  } = useSteps();
  return /* @__PURE__ */ jsxs(Steps, {
    currentStep,
    children: [props.showTutorial && isWebRtcSupported() && /* @__PURE__ */ jsx(TutorialSelfie, __spreadProps(__spreadValues({}, props), {
      onSuccess: nextStep
    })), /* @__PURE__ */ jsx(Selfie, __spreadValues({}, props))]
  });
}
const CaptureButtonContainer$1 = styled(CaptureButtonContainer$2)`
  position: absolute;
`;
const SelfieContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #f9faff;
`;
const Container$5 = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
function CaptureSelfie({
  onBoarding,
  onError,
  onSuccess,
  permission,
  setPermission,
  permissionMessage,
  permissionBackgroundColor,
  onLog,
  token,
  timeout,
  numberOfTries,
  stream,
  onlyCapture,
  showCustomCameraPermissionScreen,
  isSecondId,
  fullScreen = true,
  isRecordingEnabled = false
}) {
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const webcam = useRef(null);
  useEffect(() => onBoarding.resumeDetect(), [onBoarding]);
  const {
    startRecording,
    stopRecording
  } = useMediaRecorder({
    token: sessionToken,
    type: "selfie"
  });
  useEffect(() => {
    return () => {
      stopRecording == null ? void 0 : stopRecording();
    };
  }, [stopRecording]);
  const handleCapture = throttle$1(async (imageBase64, fullImage, faceCoordinates) => {
    var _b;
    try {
      clearTimeout(selfieTimeoutRef.current);
      setNotificationMessage("");
      onBoarding.stopDetect();
      onBoarding.addEvent({
        eventName: "selfieCapture",
        eventType: "text",
        eventData: {},
        token: sessionToken
      });
      const type = onBoarding.selfieType;
      const encryptedImage = await encryptImage(fullImage);
      const blob = toBlob(imageBase64);
      const src2 = URL.createObjectURL(blob);
      if (onlyCapture) {
        return onSuccess({
          imageBase64,
          blob,
          encryptedImage,
          src: src2
        });
      }
      const response = await onBoarding.capture({
        token: sessionToken,
        image: encryptedImage,
        type,
        encrypted: true,
        faceCoordinates
      });
      const livenessPassed = response.confidence === 0;
      const brighnessPassed = response.isBright;
      const lensesPassed = !response.hasLenses;
      const maskPassed = !response.hasFaceMask;
      if (!livenessPassed || !brighnessPassed || !lensesPassed || !maskPassed) {
        setMode("error");
        if (!lensesPassed) {
          onLog(getLogObject("lensesDetected", {
            response,
            message: "Lenses detected"
          }));
          setNotificationMessage(t2("notifications.lenses"));
        } else if (!brighnessPassed) {
          onLog(getLogObject("badBrightness", {
            response,
            message: "Bad brightness"
          }));
          setNotificationMessage(t2("notifications.brightness"));
        } else if (!maskPassed) {
          onLog(getLogObject("badMask", {
            response,
            message: "Mask detected"
          }));
          setNotificationMessage(t2("notifications.mask"));
        } else if (!livenessPassed) {
          onLog(getLogObject("spoofAttempt", {
            response,
            message: "Spoof attempt detected"
          }));
          setNotificationMessage(t2("notifications.spoof"));
        }
        await sleep(3e3);
        resetLoading({
          response,
          livenessPassed,
          imageBase64
        });
        startAutoDetect();
        return;
      }
      setNotificationMessage(t2("notifications.processing"));
      const _a = await processFace2(), {
        faceMatch,
        existingUser
      } = _a, processResponse = __objRest(_a, [
        "faceMatch",
        "existingUser"
      ]);
      onLog(getLogObject("successCapture", {
        response,
        message: "Selfie uploaded successfully"
      }));
      setNotificationMessage(t2("notifications.success"));
      await sleep(3500);
      return onSuccess(__spreadProps(__spreadValues(__spreadValues({}, response), processResponse), {
        faceMatch,
        existingUser,
        liveness: livenessPassed,
        imageBase64
      }));
    } catch (err) {
      handleError(err.response ? err.response.data : t2("notifications.serverError"));
      setMode("error");
      await sleep(3e3);
      resetLoading({
        response: (_b = err == null ? void 0 : err.response) == null ? void 0 : _b.data,
        livenessPassed: null,
        imageBase64
      });
      startAutoDetect();
    }
  }, 300);
  const {
    t: t2
  } = useTranslation();
  const skipWithError = (existingUser, liveness, imageBase64, faceMatch) => {
    onBoarding.updateSession({
      token: sessionToken,
      key: "manualSelfieCheckNeeded",
      value: true
    });
    const skipLog = getLogObject("skip", {
      existingUser,
      liveness,
      imageBase64,
      faceMatch
    });
    onLog(skipLog);
    onError(skipLog);
  };
  async function handleNoAttempsLeft({
    response,
    livenessPassed,
    imageBase64
  }) {
    onBoarding.addEvent({
      eventName: "noAttempts",
      eventType: "text",
      eventData: {},
      token: sessionToken
    });
    onLog(getLogObject("noAttemps", {
      response,
      message: "No attempt left"
    }));
    const {
      faceMatch,
      existingUser
    } = await processFace2();
    return skipWithError(existingUser, livenessPassed, imageBase64, faceMatch);
  }
  async function processFace2() {
    const processResponse = await onBoarding.processFace({
      token: sessionToken
    });
    if (isSecondId) {
      await onBoarding.processFaceSecondId({
        token: sessionToken
      });
    }
    const faceMatch = processResponse.confidence === 1;
    const existingUser = processResponse.existingUser;
    return __spreadValues({
      faceMatch,
      existingUser
    }, processResponse);
  }
  const {
    setMode,
    resetLoading,
    notificationMessage,
    setNotificationMessage,
    handleError,
    startAutoDetect,
    handleManualCapture,
    isSuccess,
    isError,
    isLoading,
    shouldShowManualCapture,
    selfieTimeoutRef,
    hideCamera
  } = useSelfie({
    timeout,
    onLog,
    handleCapture,
    handleNoAttempsLeft,
    numberOfTries,
    webcam,
    onSwitchManualCapture: () => {
      setNotificationMessage("");
      onBoarding.addEvent({
        eventName: "switchToManualCaptureSelfie",
        eventType: "text",
        eventData: {},
        token: sessionToken
      });
    },
    onManualCaptureSelfie: () => {
      onBoarding.addEvent({
        eventName: "manualCaptureSelfie",
        eventType: "text",
        eventData: {},
        token: sessionToken
      });
    }
  });
  const notification = isLoading ? "Uploading.." : notificationMessage;
  const isNotCapturing = isLoading || isError || isSuccess;
  return /* @__PURE__ */ jsxs(Container$5, {
    children: [/* @__PURE__ */ jsx(DesktopHeader, {
      className: "selfie"
    }), /* @__PURE__ */ jsxs(SelfieContainer, {
      children: [/* @__PURE__ */ jsx(FaceMask$1, {
        isCapturing: isSuccess,
        isLoading,
        error: isError,
        isUploading: isNotCapturing,
        desktop: true,
        children: /* @__PURE__ */ jsx(FaceFrame$1, {
          src: faceFrame$1,
          alt: "face frame",
          className: classNames({
            hidden: hideCamera
          })
        })
      }), /* @__PURE__ */ jsx(WebcamWithChooseCamera, {
        ref: webcam,
        onPlay: startAutoDetect,
        videoSource: "user",
        isSelfie: true,
        permission,
        setPermission,
        permissionMessage,
        permissionBackgroundColor,
        onLog,
        stream,
        onError,
        onBoarding,
        token: sessionToken,
        onStreamReady: isRecordingEnabled ? startRecording : void 0,
        showCustomCameraPermissionScreen
      }), notification && /* @__PURE__ */ jsx(Notification, {
        isLoading,
        isError,
        className: "desktop",
        children: notification
      }), shouldShowManualCapture && /* @__PURE__ */ jsx(CaptureButtonContainer$1, {
        initial: {
          scale: 0
        },
        animate: {
          scale: 1
        },
        children: /* @__PURE__ */ jsx("button", {
          onClick: handleManualCapture,
          children: /* @__PURE__ */ jsx("img", {
            src: CaptureButton,
            alt: "capture button"
          })
        })
      })]
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame",
      hidden: true
    })]
  });
}
const moveIn$1 = Ue`
  0% {
    bottom: -200px;
  }

  80% {
    bottom: 6%;
  }

  100% {
    bottom: 5%;
  }
`;
const FakeButton$1 = styled.div`
  position: fixed;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  animation: ${moveIn$1} 1s ease-in forwards;

  &.hidden {
    display: none;
  }
`;
const toImage$1 = (base64) => `data:image/png;base64,${base64}`;
function CameraPaperStatement({
  onBoarding,
  onSuccess,
  permission,
  setPermission,
  permissionMessage,
  permissionBackgroundColor,
  onLog,
  token,
  onError,
  numberOfTries,
  timeout = 1e3,
  hideRetake
}) {
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const {
    t: t2
  } = useTranslation();
  const [progress2, setProgress] = useState(0);
  const [showCapturePreview, setShowCapturePreview] = useState(false);
  const [captureSuccessful, setCaptureSuccessful] = useState(null);
  const [finishCapture, setFinishCapture] = useState(null);
  const [images, setImages] = useState(null);
  const [isManualCapture, setIsManualCapture] = useState(false);
  const timesCaptureFailedRef = useRef(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [showRetake, setShowRetake] = useState(false);
  const webcam = useRef();
  const timeoutIdRef = useRef();
  const {
    showNotification: showNotification2,
    closeNotification: closeNotification2
  } = useNotifications();
  useEffect(() => {
    if (!isManualCapture)
      return;
    if (showCapturePreview)
      return;
    timeoutIdRef.current = setInterval(() => {
      onLog(getLogObject("noCaptureInTime", {}));
    }, timeout);
    return () => clearInterval(timeoutIdRef.current);
  }, [onLog, timeout, isManualCapture, showCapturePreview]);
  useEffect(() => {
    sleep(1e3).then(() => {
      showNotification2(/* @__PURE__ */ jsxs("div", {
        style: {
          textAlign: "center"
        },
        children: [/* @__PURE__ */ jsx("div", {
          children: t2("notifications.showUtilityBill.one")
        }), /* @__PURE__ */ jsx("div", {
          children: t2("notifications.showUtilityBill.two")
        }), /* @__PURE__ */ jsx("div", {
          children: t2("notifications.showUtilityBill.three")
        })]
      }), "plug");
      return sleep(2e3);
    }).then(() => setIsManualCapture(true));
    const webcamElement = webcam.current;
    return () => {
      var _a;
      return (_a = webcamElement == null ? void 0 : webcamElement.mediaStreamTrack) == null ? void 0 : _a.stop();
    };
  }, []);
  const getImages2 = async (width2, height2, scaleFactor) => {
    const imageBase64 = await webcam.current.getBase64ScreenShot(width2, height2, scaleFactor, false);
    const fullImage = webcam.current.dataURLtoBlob(width2, height2, scaleFactor);
    const imageData = webcam.current.getImageData(width2, height2);
    const fullImageBase64 = webcam.current.getFullImage(width2, height2, scaleFactor);
    return {
      imageBase64,
      fullImage,
      imageData,
      fullImageBase64
    };
  };
  const handleCapture = async (_images = images) => {
    closeNotification2();
    setShowRetake(false);
    setShowCapturePreview(true);
    return onBoarding.addAddressStatement({
      token: sessionToken,
      image: _images.fullImageBase64,
      onProgress: setProgress
    }).then(async ({
      success
    }) => {
      if (success) {
        setProgress(100);
        setCaptureSuccessful(true);
        setFinishCapture(true);
        await sleep(1500);
        onLog(getLogObject("successCapture", {
          message: "Document captured successfully"
        }));
        onSuccess({
          images: _images
        });
      } else {
        const message2 = t2("notifications.badProofOfAddress");
        timesCaptureFailedRef.current += 1;
        onLog(getLogObject("attemptFailed", {
          response: {
            success
          },
          message: message2,
          attempt: timesCaptureFailedRef.current
        }));
        setCaptureSuccessful(false);
        setFinishCapture(true);
        setErrorMessage(message2);
        await sleep(1500);
      }
    }).catch(async (error3) => {
      const message2 = t2("notifications.badProofOfAddress");
      timesCaptureFailedRef.current += 1;
      onLog(getLogObject("attemptFailed", {
        response: {
          error: error3
        },
        message: error3.message,
        attempt: timesCaptureFailedRef.current
      }));
      setCaptureSuccessful(false);
      setFinishCapture(true);
      setErrorMessage(message2);
      await sleep(1500);
    });
  };
  function cleanUp() {
    setShowRetake(false);
    setShowCapturePreview(false);
    setProgress(0);
    setFinishCapture(false);
    setCaptureSuccessful(null);
    setErrorMessage("");
  }
  function addressSuccess() {
    cleanUp();
  }
  function addressError() {
    cleanUp();
    if (numberOfTries !== -1 && timesCaptureFailedRef.current >= numberOfTries) {
      onLog(getLogObject("noAttemps", {
        response: {
          success: false
        },
        message: "No attempt left"
      }));
      onError("skip");
    }
  }
  const handleCloseCapturePreview = (success) => {
    if (success) {
      addressSuccess();
    } else {
      addressError();
    }
  };
  const handleStartCapture = async () => {
    closeNotification2();
    clearTimeout(timeoutIdRef.current);
    const images2 = await getImages2(webcam.current.video.videoWidth, webcam.current.video.videoHeight, 1);
    setImages(images2);
    if (hideRetake) {
      return handleCapture(images2);
    }
    setShowRetake(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(WebcamWithChooseCamera, {
      ref: webcam,
      videoSource: "environment",
      permission,
      setPermission,
      permissionMessage,
      permissionBackgroundColor,
      onLog,
      dataURLtoBlob: "image/jpeg",
      onError,
      onBoarding,
      token: sessionToken
    }), !hideRetake && showRetake && images && /* @__PURE__ */ jsx(Retake, {
      imageBase64: toImage$1(images.imageBase64),
      onClose: cleanUp,
      handleCapture,
      token: sessionToken
    }), showCapturePreview && images && /* @__PURE__ */ jsx(CapturePreview, {
      open: true,
      progress: progress2,
      message: errorMessage,
      finishCapture,
      captureSuccessful,
      onClose: handleCloseCapturePreview,
      imageBase64: toImage$1(images.imageBase64),
      isSelfie: false,
      isPoa: true
    }), isManualCapture && /* @__PURE__ */ jsx(FakeButton$1, {
      className: classNames({
        hidden: showCapturePreview || showRetake
      }),
      children: /* @__PURE__ */ jsx("img", {
        alt: "capture button",
        src: CaptureButton,
        className: "step__video-catch-event",
        onClick: handleStartCapture
      })
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame",
      hidden: true
    }), /* @__PURE__ */ jsx(Notification$1, {
      inline: false,
      center: true
    })]
  });
}
const NativeCameraContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const LabelButton = styled.label`
  text-transform: uppercase;
  padding: 20px 40px;
  background-color: #3db0f7;
  min-width: 215px;
  border-radius: 31px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  border: none;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin: 15px 0;

  &:hover {
    background-color: #0290cb;
  }

  &.button-hidden {
    display: none;
  }

  &:disabled {
    opacity: 0.5;
    box-shadow: 0 6px 10px 0 rgba(18, 21, 28, 0.4);
    background-color: #757575;
  }
`;
function NativeCamera({
  onBoarding,
  token,
  onLog,
  onSuccess,
  numberOfTries,
  onError,
  documentType = "addressStatement",
  onlyAllowCapture = false
}) {
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const {
    t: t2
  } = useTranslation();
  const [showCapturePreview, setShowCapturePreview] = useState(false);
  const [progress2, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [finishCapture, setFinishCapture] = useState(null);
  const [captureSuccessful, setCaptureSuccessful] = useState(null);
  const [showRetake, setShowRetake] = useState(false);
  const [images, setImages] = useState({});
  const timesCaptureFailedRef = useRef(0);
  const handleImageChange = async (ev) => {
    const imgs = await getScaledImageFromFile(ev.target.files[0]);
    setImages(imgs);
    setShowRetake(true);
  };
  const handleCapture = () => {
    capture2(images);
    setShowRetake(false);
  };
  const capture2 = (images2) => {
    setShowCapturePreview(true);
    return onBoarding.addAddressStatement({
      token: sessionToken,
      file: images2.fullImage,
      docType: documentType,
      onProgress: setProgress
    }).then(async ({
      success
    }) => {
      if (success) {
        setProgress(100);
        setCaptureSuccessful(true);
        setFinishCapture(true);
        onLog(getLogObject("successCapture", {
          message: "Document captured successfully"
        }));
        setCaptureSuccessful(true);
        await sleep(1500);
        uploadAddressProofSuccess(images2);
      } else {
        const message2 = t2("notifications.badProofOfAddress");
        timesCaptureFailedRef.current += 1;
        onLog(getLogObject("attemptFailed", {
          response: {
            success
          },
          message: message2,
          attempt: timesCaptureFailedRef.current
        }));
        setCaptureSuccessful(false);
        setFinishCapture(true);
        setErrorMessage(message2);
        await sleep(1500);
      }
    }).catch(async (error3) => {
      const message2 = t2("notifications.badProofOfAddress");
      timesCaptureFailedRef.current += 1;
      onLog(getLogObject("attemptFailed", {
        response: {
          error: error3
        },
        message: error3.message,
        attempt: timesCaptureFailedRef.current
      }));
      setCaptureSuccessful(false);
      setFinishCapture(true);
      setErrorMessage(message2);
      await sleep(1500);
    });
  };
  const uploadAddressProofSuccess = async (images2) => {
    return onSuccess(__spreadValues({}, images2));
  };
  function cleanUp() {
    setShowRetake(false);
    setShowCapturePreview(false);
    setProgress(0);
    setFinishCapture(false);
    setCaptureSuccessful(null);
    setErrorMessage("");
    setImages({});
  }
  function addressError() {
    cleanUp();
    if (numberOfTries !== -1 && timesCaptureFailedRef.current >= numberOfTries) {
      onLog(getLogObject("noAttemps", {
        response: {
          success: false
        },
        message: "No attempt left"
      }));
      onError("skip");
    }
  }
  const handleCloseCapturePreview = (success) => {
    if (success) {
      cleanUp();
    } else {
      addressError();
    }
  };
  return /* @__PURE__ */ jsxs(NativeCameraContainer, {
    children: [showRetake && /* @__PURE__ */ jsx(Retake, {
      fileType: images.fullImage.type,
      imageBase64: images.imageBase64,
      onClose: cleanUp,
      handleCapture,
      token: sessionToken
    }), showCapturePreview && /* @__PURE__ */ jsx(CapturePreview, {
      open: true,
      progress: progress2,
      message: errorMessage,
      finishCapture,
      captureSuccessful,
      fileType: images.fullImage.type,
      imageBase64: images.imageBase64,
      isSelfie: false,
      isPoa: true,
      onClose: handleCloseCapturePreview
    }), /* @__PURE__ */ jsxs(LabelButton, {
      children: [/* @__PURE__ */ jsx("input", {
        style: {
          display: "none"
        },
        type: "file",
        accept: documentType === "addressStatement" ? "application/pdf, image/*" : "image/*",
        onChange: handleImageChange,
        onClick: (e2) => e2.target.value = null,
        capture: onlyAllowCapture ? "environment" : void 0
      }), /* @__PURE__ */ jsx("span", {
        children: t2(`common.${onBoarding.isDesktop() ? "uploadStatement" : "takePhoto"}`)
      })]
    })]
  });
}
const moveIn = Ue`
  0% {
    bottom: -200px;
  }

  80% {
    bottom: 6%;
  }

  100% {
    bottom: 5%;
  }
`;
const FakeButton = styled.div`
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  animation: ${moveIn} 1s ease-in forwards;

  &.hidden {
    display: none;
  }
`;
const toImage = (base64) => `data:image/png;base64,${base64}`;
function AdditionalId({
  onBoarding,
  onSuccess,
  permission,
  setPermission,
  permissionMessage,
  permissionBackgroundColor,
  onLog,
  token,
  documentType
}) {
  const sessionToken = token ? token.token : onBoarding.state.token.token;
  const [, setFrame] = useState("white");
  const [progress2, setProgress] = useState(0);
  const [showCapturePreview, setShowCapturePreview] = useState(false);
  const [captureSuccessful, setCaptureSuccessful] = useState(null);
  const [finishCapture, setFinishCapture] = useState(null);
  const [imageBase64, setImageBase64] = useState(null);
  const webcam = useRef(null);
  const getImages2 = async (width2, height2, scaleFactor) => {
    const imageBase642 = await webcam.current.getBase64ScreenShot(width2, height2, scaleFactor, false);
    const fullImage = webcam.current.dataURLtoBlob(width2, height2, scaleFactor);
    const imageData = webcam.current.getImageData(width2, height2);
    const fullImageBase64 = webcam.current.getFullImage(width2, height2, scaleFactor);
    return {
      imageBase64: imageBase642,
      fullImage,
      imageData,
      fullImageBase64
    };
  };
  const handleCapture = throttle$1(async (width2, height2, scaleFactor) => {
    const image2 = await getImages2(width2, height2, scaleFactor);
    setShowCapturePreview(true);
    setImageBase64(toImage(image2.imageBase64));
    setFrame("green");
    if (documentType === "secondId") {
      return onBoarding.addFrontSecondId({
        token: sessionToken,
        image: image2.fullImage,
        onProgress: setProgress
      }).then(() => {
        setProgress(100);
        setFrame("white");
        setCaptureSuccessful(true);
        setFinishCapture(true);
        onLog(getLogObject("successCapture", {
          message: "Second ID captured successfully"
        }));
        onBoarding.processSecondId({
          token: sessionToken
        });
      }).then(() => {
        onSuccess("success");
      });
    } else {
      return onBoarding.addDocument({
        token: sessionToken,
        type: documentType,
        image: image2.fullImageBase64,
        onProgress: setProgress
      }).then(() => {
        setProgress(100);
        setFrame("white");
        setCaptureSuccessful(true);
        setFinishCapture(true);
        onLog(getLogObject("successCapture", {
          message: "Document captured successfully"
        }));
      }).then(() => {
        onSuccess("success");
      });
    }
  }, 300);
  const handleCloseCapturePreview = () => {
    setShowCapturePreview(false);
    setProgress(0);
    setFinishCapture(false);
    setCaptureSuccessful(false);
    setFrame("white");
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(WebcamWithChooseCamera, {
      ref: webcam,
      videoSource: "environment",
      permission,
      setPermission,
      permissionMessage,
      permissionBackgroundColor,
      onLog,
      onBoarding,
      token: sessionToken
    }), showCapturePreview && /* @__PURE__ */ jsx(CapturePreview, {
      open: true,
      progress: progress2,
      finishCapture,
      captureSuccessful,
      onClose: handleCloseCapturePreview,
      imageBase64,
      isSelfie: false
    }), /* @__PURE__ */ jsx(FakeButton, {
      className: classNames({
        hidden: showCapturePreview
      }),
      children: /* @__PURE__ */ jsx("img", {
        alt: "capture button",
        src: CaptureButton,
        className: "step__video-catch-event",
        onClick: () => handleCapture(webcam.current.video.videoWidth, webcam.current.video.videoHeight, 1)
      })
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame",
      hidden: true
    }), /* @__PURE__ */ jsx(Notification$1, {
      inline: false,
      center: true
    })]
  });
}
const Container$4 = styled.div`
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
  min-height: 500px;
  position: fixed;
  top: 0;
  left: 0;

  &.disable-full-screen {
    position: relative;
    height: 100%;
    width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  .hidden {
    display: none;
  }
`;
const App$1 = ({
  disableFullScreen = false,
  children
}) => {
  const {
    isRotated
  } = useOrientation();
  useEffect(() => {
    init$1();
  }, []);
  return /* @__PURE__ */ jsx(Fe, {
    theme: theme$1,
    children: /* @__PURE__ */ jsx(I18nextProvider, {
      i18n: instance,
      children: /* @__PURE__ */ jsxs(Container$4, {
        className: classNames({
          ["disable-full-screen"]: disableFullScreen
        }),
        children: [!!mobile.any() && !mobile.isIpad() && isRotated && /* @__PURE__ */ jsx(LandscapeNotSupported, {}), children]
      })
    })
  });
};
function App(props) {
  const component = (() => {
    if (props.type === "passport") {
      return /* @__PURE__ */ jsx(CaptureAndTutorial$2, __spreadValues({}, props));
    }
    if (props.type === props.onBoarding.frontType) {
      return /* @__PURE__ */ jsx(CaptureAndTutorial$2, __spreadProps(__spreadValues({}, props), {
        showTutorial: mobile.isDesktop() ? false : true
      }));
    }
    if (props.type === props.onBoarding.backType) {
      return /* @__PURE__ */ jsx(CaptureAndTutorial$1, __spreadProps(__spreadValues({}, props), {
        showTutorial: mobile.isDesktop() ? false : true
      }));
    }
    if (props.type === props.onBoarding.selfieType) {
      return mobile.isDesktop() ? /* @__PURE__ */ jsx(CaptureSelfie, __spreadValues({}, props)) : /* @__PURE__ */ jsx(CaptureAndTutorial, __spreadValues({}, props));
    }
    if (props.type === "document") {
      const DocumentComponent = props.nativeCamera ? NativeCamera : CameraPaperStatement;
      return /* @__PURE__ */ jsx(DocumentComponent, __spreadValues({}, props));
    }
    if (props.type === "secondId") {
      return /* @__PURE__ */ jsx(AdditionalId, __spreadValues({}, props));
    }
    if (props.type === "thirdId") {
      return /* @__PURE__ */ jsx(AdditionalId, __spreadValues({}, props));
    }
    if (props.type === "creditCard") {
      return /* @__PURE__ */ jsx(CaptureAndTutorial$2, __spreadValues({}, props));
    }
    if (props.type === "creditCardBack") {
      return /* @__PURE__ */ jsx(CaptureAndTutorial$1, __spreadValues({}, props));
    }
  })();
  return /* @__PURE__ */ jsx(NotificationProvider, {
    initialValue: {
      isOpen: false
    },
    children: component
  });
}
function renderCamera(type, element, {
  onSuccess = emptyFunc,
  onError = emptyFunc,
  numberOfTries = 3,
  onLog = emptyFunc,
  permissionMessage,
  permissionBackgroundColor,
  token,
  timeout = 4e4,
  sendBase64 = true,
  documentType,
  showPreview = false,
  stream,
  nativeCamera = false,
  hideRetake = false,
  showTutorial = false,
  onlyCapture = false,
  scanPdf417 = false,
  videoTutorialSrc,
  showCustomCameraPermissionScreen = false,
  isSecondId = false,
  fullScreen = true,
  assistedOnboarding = false,
  isRecordingEnabled = false,
  onRestartOnboarding,
  showDoublePermissionsRequest = false,
  onlyAllowCapture = false,
  disableFullScreen = false
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element),
    onBoarding: this,
    numberOfTries,
    onLog,
    permissionMessage,
    permissionBackgroundColor,
    type,
    token,
    timeout,
    sendBase64,
    documentType,
    showPreview,
    stream,
    nativeCamera,
    hideRetake,
    showTutorial,
    onlyCapture,
    scanPdf417,
    videoSrc: videoTutorialSrc,
    showCustomCameraPermissionScreen,
    isSecondId,
    fullScreen,
    assistedOnboarding,
    isRecordingEnabled,
    onRestartOnboarding,
    showDoublePermissionsRequest,
    onlyAllowCapture,
    disableFullScreen
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    disableFullScreen,
    children: /* @__PURE__ */ jsx(App, __spreadValues({}, props))
  }), element);
  return {
    close: handleUnmount(emptyFunc, element)
  };
}
function createSession$3({
  apiKey: apiKey2,
  sessionId,
  token,
  onStreamsUpdated,
  onConnect,
  onError,
  options
} = {}) {
  if (!apiKey2) {
    throw new Error("Missing apiKey");
  }
  if (!sessionId) {
    throw new Error("Missing sessionId");
  }
  if (!token) {
    throw new Error("Missing token");
  }
  let streams = [];
  let onStreamCreated = (event) => {
    const index2 = streams.findIndex((stream) => stream.id === event.stream.id);
    if (index2 < 0) {
      streams.push(event.stream);
      onStreamsUpdated(streams);
    }
  };
  let onStreamDestroyed = (event) => {
    const index2 = streams.findIndex((stream) => stream.id === event.stream.id);
    if (index2 >= 0) {
      streams.splice(index2, 1);
      onStreamsUpdated(streams);
    }
  };
  let eventHandlers = {
    streamCreated: onStreamCreated,
    streamDestroyed: onStreamDestroyed
  };
  let session = OT.initSession(apiKey2, sessionId, options);
  session.on(eventHandlers);
  session.connect(token, (err) => {
    if (!session) {
      return;
    }
    if (err && typeof onError === "function") {
      onError(err);
    } else if (!err && typeof onConnect === "function") {
      onConnect();
    }
  });
  return {
    session,
    streams,
    disconnect() {
      if (session) {
        session.off(eventHandlers);
        session.disconnect();
      }
      streams = null;
      onStreamCreated = null;
      onStreamDestroyed = null;
      eventHandlers = null;
      session = null;
      this.session = null;
      this.streams = null;
    }
  };
}
class OTSession$2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      streams: []
    };
  }
  getChildContext() {
    return {
      session: this.sessionHelper.session,
      streams: this.state.streams
    };
  }
  componentWillMount() {
    this.createSession();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.apiKey !== this.props.apiKey || prevProps.sessionId !== this.props.sessionId || prevProps.token !== this.props.token) {
      this.createSession();
    }
  }
  componentWillUnmount() {
    this.destroySession();
  }
  createSession() {
    this.destroySession();
    this.sessionHelper = createSession$3({
      apiKey: this.props.apiKey,
      sessionId: this.props.sessionId,
      token: this.props.token,
      onStreamsUpdated: (streams2) => {
        this.setState({
          streams: streams2
        });
      },
      onConnect: this.props.onConnect,
      onError: this.props.onError,
      options: this.props.options
    });
    if (this.props.eventHandlers && typeof this.props.eventHandlers === "object") {
      this.sessionHelper.session.on(this.props.eventHandlers);
    }
    const {
      streams
    } = this.sessionHelper;
    this.setState({
      streams
    });
  }
  destroySession() {
    if (this.sessionHelper) {
      if (this.props.eventHandlers && typeof this.props.eventHandlers === "object") {
        this.sessionHelper.session.off(this.props.eventHandlers);
      }
      this.sessionHelper.disconnect();
    }
  }
  render() {
    const isChildFunction = typeof this.props.children === "function";
    return /* @__PURE__ */ jsx(Fragment, {
      children: isChildFunction ? this.props.children(this.sessionHelper) : this.props.children
    });
  }
}
OTSession$2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.func]).isRequired,
  apiKey: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  onConnect: PropTypes.func,
  onError: PropTypes.func,
  options: PropTypes.object
};
OTSession$2.defaultProps = {
  eventHandlers: null,
  onConnect: null,
  onError: null,
  options: {}
};
OTSession$2.childContextTypes = {
  streams: PropTypes.arrayOf(PropTypes.object),
  session: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  })
};
var reWhitespace = /\s/;
function trimmedEndIndex$1(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace.test(string2.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var _baseTrim = baseTrim$1;
function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$3;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal || freeSelf || Function("return this")();
var _root = root$1;
var root = _root;
var Symbol$3 = root.Symbol;
var _Symbol = Symbol$3;
var Symbol$2 = _Symbol;
var objectProto$1 = Object.prototype;
var hasOwnProperty = objectProto$1.hasOwnProperty;
var nativeObjectToString$1 = objectProto$1.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result2 = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result2;
}
var _getRawTag = getRawTag$1;
var objectProto = Object.prototype;
var nativeObjectToString = objectProto.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$1(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1;
var baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var toNumber = toNumber_1;
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign2 = value < 0 ? -1 : 1;
    return sign2 * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$1(value) {
  var result2 = toFinite(value), remainder = result2 % 1;
  return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
var toInteger_1 = toInteger$1;
var toInteger = toInteger_1;
var FUNC_ERROR_TEXT = "Expected a function";
function before$1(n2, func) {
  var result2;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n2 = toInteger(n2);
  return function() {
    if (--n2 > 0) {
      result2 = func.apply(this, arguments);
    }
    if (n2 <= 1) {
      func = void 0;
    }
    return result2;
  };
}
var before_1 = before$1;
var before = before_1;
function once(func) {
  return before(2, func);
}
var once_1 = once;
var lodash_min = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module2, exports2) {
  (function() {
    function n2(n3, t3, r3) {
      switch (r3.length) {
        case 0:
          return n3.call(t3);
        case 1:
          return n3.call(t3, r3[0]);
        case 2:
          return n3.call(t3, r3[0], r3[1]);
        case 3:
          return n3.call(t3, r3[0], r3[1], r3[2]);
      }
      return n3.apply(t3, r3);
    }
    function t2(n3, t3, r3, e3) {
      for (var u3 = -1, i3 = n3 == null ? 0 : n3.length; ++u3 < i3; ) {
        var o2 = n3[u3];
        t3(e3, o2, r3(o2), n3);
      }
      return e3;
    }
    function r2(n3, t3) {
      for (var r3 = -1, e3 = n3 == null ? 0 : n3.length; ++r3 < e3 && t3(n3[r3], r3, n3) !== false; )
        ;
      return n3;
    }
    function e2(n3, t3) {
      for (var r3 = n3 == null ? 0 : n3.length; r3-- && t3(n3[r3], r3, n3) !== false; )
        ;
      return n3;
    }
    function u2(n3, t3) {
      for (var r3 = -1, e3 = n3 == null ? 0 : n3.length; ++r3 < e3; )
        if (!t3(n3[r3], r3, n3))
          return false;
      return true;
    }
    function i2(n3, t3) {
      for (var r3 = -1, e3 = n3 == null ? 0 : n3.length, u3 = 0, i3 = []; ++r3 < e3; ) {
        var o2 = n3[r3];
        t3(o2, r3, n3) && (i3[u3++] = o2);
      }
      return i3;
    }
    function o(n3, t3) {
      return !!(n3 == null ? 0 : n3.length) && y2(n3, t3, 0) > -1;
    }
    function f2(n3, t3, r3) {
      for (var e3 = -1, u3 = n3 == null ? 0 : n3.length; ++e3 < u3; )
        if (r3(t3, n3[e3]))
          return true;
      return false;
    }
    function c2(n3, t3) {
      for (var r3 = -1, e3 = n3 == null ? 0 : n3.length, u3 = Array(e3); ++r3 < e3; )
        u3[r3] = t3(n3[r3], r3, n3);
      return u3;
    }
    function a6(n3, t3) {
      for (var r3 = -1, e3 = t3.length, u3 = n3.length; ++r3 < e3; )
        n3[u3 + r3] = t3[r3];
      return n3;
    }
    function l2(n3, t3, r3, e3) {
      var u3 = -1, i3 = n3 == null ? 0 : n3.length;
      for (e3 && i3 && (r3 = n3[++u3]); ++u3 < i3; )
        r3 = t3(r3, n3[u3], u3, n3);
      return r3;
    }
    function s2(n3, t3, r3, e3) {
      var u3 = n3 == null ? 0 : n3.length;
      for (e3 && u3 && (r3 = n3[--u3]); u3--; )
        r3 = t3(r3, n3[u3], u3, n3);
      return r3;
    }
    function h2(n3, t3) {
      for (var r3 = -1, e3 = n3 == null ? 0 : n3.length; ++r3 < e3; )
        if (t3(n3[r3], r3, n3))
          return true;
      return false;
    }
    function p2(n3) {
      return n3.split("");
    }
    function _24(n3) {
      return n3.match($t) || [];
    }
    function v2(n3, t3, r3) {
      var e3;
      return r3(n3, function(n4, r4, u3) {
        if (t3(n4, r4, u3))
          return e3 = r4, false;
      }), e3;
    }
    function g2(n3, t3, r3, e3) {
      for (var u3 = n3.length, i3 = r3 + (e3 ? 1 : -1); e3 ? i3-- : ++i3 < u3; )
        if (t3(n3[i3], i3, n3))
          return i3;
      return -1;
    }
    function y2(n3, t3, r3) {
      return t3 === t3 ? Z2(n3, t3, r3) : g2(n3, b2, r3);
    }
    function d2(n3, t3, r3, e3) {
      for (var u3 = r3 - 1, i3 = n3.length; ++u3 < i3; )
        if (e3(n3[u3], t3))
          return u3;
      return -1;
    }
    function b2(n3) {
      return n3 !== n3;
    }
    function w2(n3, t3) {
      var r3 = n3 == null ? 0 : n3.length;
      return r3 ? k3(n3, t3) / r3 : Cn;
    }
    function m2(n3) {
      return function(t3) {
        return t3 == null ? X2 : t3[n3];
      };
    }
    function x2(n3) {
      return function(t3) {
        return n3 == null ? X2 : n3[t3];
      };
    }
    function j2(n3, t3, r3, e3, u3) {
      return u3(n3, function(n4, u4, i3) {
        r3 = e3 ? (e3 = false, n4) : t3(r3, n4, u4, i3);
      }), r3;
    }
    function A2(n3, t3) {
      var r3 = n3.length;
      for (n3.sort(t3); r3--; )
        n3[r3] = n3[r3].value;
      return n3;
    }
    function k3(n3, t3) {
      for (var r3, e3 = -1, u3 = n3.length; ++e3 < u3; ) {
        var i3 = t3(n3[e3]);
        i3 !== X2 && (r3 = r3 === X2 ? i3 : r3 + i3);
      }
      return r3;
    }
    function O(n3, t3) {
      for (var r3 = -1, e3 = Array(n3); ++r3 < n3; )
        e3[r3] = t3(r3);
      return e3;
    }
    function I2(n3, t3) {
      return c2(t3, function(t4) {
        return [t4, n3[t4]];
      });
    }
    function R(n3) {
      return n3 ? n3.slice(0, H2(n3) + 1).replace(Lt, "") : n3;
    }
    function z2(n3) {
      return function(t3) {
        return n3(t3);
      };
    }
    function E2(n3, t3) {
      return c2(t3, function(t4) {
        return n3[t4];
      });
    }
    function S2(n3, t3) {
      return n3.has(t3);
    }
    function W2(n3, t3) {
      for (var r3 = -1, e3 = n3.length; ++r3 < e3 && y2(t3, n3[r3], 0) > -1; )
        ;
      return r3;
    }
    function L2(n3, t3) {
      for (var r3 = n3.length; r3-- && y2(t3, n3[r3], 0) > -1; )
        ;
      return r3;
    }
    function C(n3, t3) {
      for (var r3 = n3.length, e3 = 0; r3--; )
        n3[r3] === t3 && ++e3;
      return e3;
    }
    function U2(n3) {
      return "\\" + Yr[n3];
    }
    function B2(n3, t3) {
      return n3 == null ? X2 : n3[t3];
    }
    function T2(n3) {
      return Nr.test(n3);
    }
    function $2(n3) {
      return Pr.test(n3);
    }
    function D2(n3) {
      for (var t3, r3 = []; !(t3 = n3.next()).done; )
        r3.push(t3.value);
      return r3;
    }
    function M2(n3) {
      var t3 = -1, r3 = Array(n3.size);
      return n3.forEach(function(n4, e3) {
        r3[++t3] = [e3, n4];
      }), r3;
    }
    function F2(n3, t3) {
      return function(r3) {
        return n3(t3(r3));
      };
    }
    function N2(n3, t3) {
      for (var r3 = -1, e3 = n3.length, u3 = 0, i3 = []; ++r3 < e3; ) {
        var o2 = n3[r3];
        o2 !== t3 && o2 !== cn || (n3[r3] = cn, i3[u3++] = r3);
      }
      return i3;
    }
    function P2(n3) {
      var t3 = -1, r3 = Array(n3.size);
      return n3.forEach(function(n4) {
        r3[++t3] = n4;
      }), r3;
    }
    function q2(n3) {
      var t3 = -1, r3 = Array(n3.size);
      return n3.forEach(function(n4) {
        r3[++t3] = [n4, n4];
      }), r3;
    }
    function Z2(n3, t3, r3) {
      for (var e3 = r3 - 1, u3 = n3.length; ++e3 < u3; )
        if (n3[e3] === t3)
          return e3;
      return -1;
    }
    function K2(n3, t3, r3) {
      for (var e3 = r3 + 1; e3--; )
        if (n3[e3] === t3)
          return e3;
      return e3;
    }
    function V2(n3) {
      return T2(n3) ? J2(n3) : _e2(n3);
    }
    function G2(n3) {
      return T2(n3) ? Y2(n3) : p2(n3);
    }
    function H2(n3) {
      for (var t3 = n3.length; t3-- && Ct.test(n3.charAt(t3)); )
        ;
      return t3;
    }
    function J2(n3) {
      for (var t3 = Mr.lastIndex = 0; Mr.test(n3); )
        ++t3;
      return t3;
    }
    function Y2(n3) {
      return n3.match(Mr) || [];
    }
    function Q2(n3) {
      return n3.match(Fr) || [];
    }
    var X2, nn = "4.17.21", tn = 200, rn = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", en = "Expected a function", un = "Invalid `variable` option passed into `_.template`", on = "__lodash_hash_undefined__", fn = 500, cn = "__lodash_placeholder__", an = 1, ln = 2, sn = 4, hn = 1, pn = 2, _n = 1, vn = 2, gn = 4, yn = 8, dn = 16, bn = 32, wn = 64, mn = 128, xn = 256, jn = 512, An = 30, kn = "...", On = 800, In = 16, Rn = 1, zn = 2, En = 3, Sn = 1 / 0, Wn = 9007199254740991, Ln = 17976931348623157e292, Cn = NaN, Un = 4294967295, Bn = Un - 1, Tn = Un >>> 1, $n = [["ary", mn], ["bind", _n], ["bindKey", vn], ["curry", yn], ["curryRight", dn], ["flip", jn], ["partial", bn], ["partialRight", wn], ["rearg", xn]], Dn = "[object Arguments]", Mn = "[object Array]", Fn = "[object AsyncFunction]", Nn = "[object Boolean]", Pn = "[object Date]", qn = "[object DOMException]", Zn = "[object Error]", Kn = "[object Function]", Vn = "[object GeneratorFunction]", Gn = "[object Map]", Hn = "[object Number]", Jn = "[object Null]", Yn = "[object Object]", Qn = "[object Promise]", Xn = "[object Proxy]", nt = "[object RegExp]", tt = "[object Set]", rt = "[object String]", et = "[object Symbol]", ut = "[object Undefined]", it = "[object WeakMap]", ot = "[object WeakSet]", ft = "[object ArrayBuffer]", ct = "[object DataView]", at = "[object Float32Array]", lt = "[object Float64Array]", st = "[object Int8Array]", ht = "[object Int16Array]", pt = "[object Int32Array]", _t = "[object Uint8Array]", vt = "[object Uint8ClampedArray]", gt = "[object Uint16Array]", yt = "[object Uint32Array]", dt = /\b__p \+= '';/g, bt = /\b(__p \+=) '' \+/g, wt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mt = /&(?:amp|lt|gt|quot|#39);/g, xt = /[&<>"']/g, jt = RegExp(mt.source), At = RegExp(xt.source), kt = /<%-([\s\S]+?)%>/g, Ot = /<%([\s\S]+?)%>/g, It = /<%=([\s\S]+?)%>/g, Rt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zt = /^\w*$/, Et = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, St = /[\\^$.*+?()[\]{}|]/g, Wt = RegExp(St.source), Lt = /^\s+/, Ct = /\s/, Ut = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Bt = /\{\n\/\* \[wrapped with (.+)\] \*/, Tt = /,? & /, $t = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Dt = /[()=,{}\[\]\/\s]/, Mt = /\\(\\)?/g, Ft = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Nt = /\w*$/, Pt = /^[-+]0x[0-9a-f]+$/i, qt = /^0b[01]+$/i, Zt = /^\[object .+?Constructor\]$/, Kt = /^0o[0-7]+$/i, Vt = /^(?:0|[1-9]\d*)$/, Gt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ht = /($^)/, Jt = /['\n\r\u2028\u2029\\]/g, Yt = "\\ud800-\\udfff", Qt = "\\u0300-\\u036f", Xt = "\\ufe20-\\ufe2f", nr = "\\u20d0-\\u20ff", tr = Qt + Xt + nr, rr = "\\u2700-\\u27bf", er = "a-z\\xdf-\\xf6\\xf8-\\xff", ur = "\\xac\\xb1\\xd7\\xf7", ir = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", or2 = "\\u2000-\\u206f", fr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", cr = "A-Z\\xc0-\\xd6\\xd8-\\xde", ar = "\\ufe0e\\ufe0f", lr = ur + ir + or2 + fr, sr2 = "['\u2019]", hr = "[" + Yt + "]", pr = "[" + lr + "]", _r = "[" + tr + "]", vr = "\\d+", gr = "[" + rr + "]", yr = "[" + er + "]", dr = "[^" + Yt + lr + vr + rr + er + cr + "]", br = "\\ud83c[\\udffb-\\udfff]", wr = "(?:" + _r + "|" + br + ")", mr = "[^" + Yt + "]", xr = "(?:\\ud83c[\\udde6-\\uddff]){2}", jr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ar = "[" + cr + "]", kr = "\\u200d", Or = "(?:" + yr + "|" + dr + ")", Ir = "(?:" + Ar + "|" + dr + ")", Rr = "(?:" + sr2 + "(?:d|ll|m|re|s|t|ve))?", zr = "(?:" + sr2 + "(?:D|LL|M|RE|S|T|VE))?", Er = wr + "?", Sr = "[" + ar + "]?", Wr = "(?:" + kr + "(?:" + [mr, xr, jr].join("|") + ")" + Sr + Er + ")*", Lr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Cr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ur = Sr + Er + Wr, Br = "(?:" + [gr, xr, jr].join("|") + ")" + Ur, Tr = "(?:" + [mr + _r + "?", _r, xr, jr, hr].join("|") + ")", $r = RegExp(sr2, "g"), Dr = RegExp(_r, "g"), Mr = RegExp(br + "(?=" + br + ")|" + Tr + Ur, "g"), Fr = RegExp([Ar + "?" + yr + "+" + Rr + "(?=" + [pr, Ar, "$"].join("|") + ")", Ir + "+" + zr + "(?=" + [pr, Ar + Or, "$"].join("|") + ")", Ar + "?" + Or + "+" + Rr, Ar + "+" + zr, Cr, Lr, vr, Br].join("|"), "g"), Nr = RegExp("[" + kr + Yt + tr + ar + "]"), Pr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qr2 = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], Zr = -1, Kr = {};
    Kr[at] = Kr[lt] = Kr[st] = Kr[ht] = Kr[pt] = Kr[_t] = Kr[vt] = Kr[gt] = Kr[yt] = true, Kr[Dn] = Kr[Mn] = Kr[ft] = Kr[Nn] = Kr[ct] = Kr[Pn] = Kr[Zn] = Kr[Kn] = Kr[Gn] = Kr[Hn] = Kr[Yn] = Kr[nt] = Kr[tt] = Kr[rt] = Kr[it] = false;
    var Vr = {};
    Vr[Dn] = Vr[Mn] = Vr[ft] = Vr[ct] = Vr[Nn] = Vr[Pn] = Vr[at] = Vr[lt] = Vr[st] = Vr[ht] = Vr[pt] = Vr[Gn] = Vr[Hn] = Vr[Yn] = Vr[nt] = Vr[tt] = Vr[rt] = Vr[et] = Vr[_t] = Vr[vt] = Vr[gt] = Vr[yt] = true, Vr[Zn] = Vr[Kn] = Vr[it] = false;
    var Gr = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    }, Hr = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Jr = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, Yr = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Qr = parseFloat, Xr = parseInt, ne2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, te2 = typeof self == "object" && self && self.Object === Object && self, re2 = ne2 || te2 || Function("return this")(), ee2 = exports2 && !exports2.nodeType && exports2, ue2 = ee2 && true && module2 && !module2.nodeType && module2, ie2 = ue2 && ue2.exports === ee2, oe2 = ie2 && ne2.process, fe2 = function() {
      try {
        var n3 = ue2 && ue2.require && ue2.require("util").types;
        return n3 ? n3 : oe2 && oe2.binding && oe2.binding("util");
      } catch (n4) {
      }
    }(), ce2 = fe2 && fe2.isArrayBuffer, ae2 = fe2 && fe2.isDate, le = fe2 && fe2.isMap, se2 = fe2 && fe2.isRegExp, he2 = fe2 && fe2.isSet, pe2 = fe2 && fe2.isTypedArray, _e2 = m2("length"), ve2 = x2(Gr), ge2 = x2(Hr), ye = x2(Jr), de2 = function p3(x3) {
      function Z3(n3) {
        if (cc2(n3) && !bh(n3) && !(n3 instanceof Ct2)) {
          if (n3 instanceof Y3)
            return n3;
          if (bl.call(n3, "__wrapped__"))
            return eo(n3);
        }
        return new Y3(n3);
      }
      function J3() {
      }
      function Y3(n3, t3) {
        this.__wrapped__ = n3, this.__actions__ = [], this.__chain__ = !!t3, this.__index__ = 0, this.__values__ = X2;
      }
      function Ct2(n3) {
        this.__wrapped__ = n3, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = false, this.__iteratees__ = [], this.__takeCount__ = Un, this.__views__ = [];
      }
      function $t2() {
        var n3 = new Ct2(this.__wrapped__);
        return n3.__actions__ = Tu(this.__actions__), n3.__dir__ = this.__dir__, n3.__filtered__ = this.__filtered__, n3.__iteratees__ = Tu(this.__iteratees__), n3.__takeCount__ = this.__takeCount__, n3.__views__ = Tu(this.__views__), n3;
      }
      function Yt2() {
        if (this.__filtered__) {
          var n3 = new Ct2(this);
          n3.__dir__ = -1, n3.__filtered__ = true;
        } else
          n3 = this.clone(), n3.__dir__ *= -1;
        return n3;
      }
      function Qt2() {
        var n3 = this.__wrapped__.value(), t3 = this.__dir__, r3 = bh(n3), e3 = t3 < 0, u3 = r3 ? n3.length : 0, i3 = Oi(0, u3, this.__views__), o2 = i3.start, f3 = i3.end, c3 = f3 - o2, a7 = e3 ? f3 : o2 - 1, l3 = this.__iteratees__, s3 = l3.length, h3 = 0, p4 = Hl(c3, this.__takeCount__);
        if (!r3 || !e3 && u3 == c3 && p4 == c3)
          return wu(n3, this.__actions__);
        var _25 = [];
        n:
          for (; c3-- && h3 < p4; ) {
            a7 += t3;
            for (var v3 = -1, g3 = n3[a7]; ++v3 < s3; ) {
              var y3 = l3[v3], d3 = y3.iteratee, b3 = y3.type, w3 = d3(g3);
              if (b3 == zn)
                g3 = w3;
              else if (!w3) {
                if (b3 == Rn)
                  continue n;
                break n;
              }
            }
            _25[h3++] = g3;
          }
        return _25;
      }
      function Xt2(n3) {
        var t3 = -1, r3 = n3 == null ? 0 : n3.length;
        for (this.clear(); ++t3 < r3; ) {
          var e3 = n3[t3];
          this.set(e3[0], e3[1]);
        }
      }
      function nr2() {
        this.__data__ = is ? is(null) : {}, this.size = 0;
      }
      function tr2(n3) {
        var t3 = this.has(n3) && delete this.__data__[n3];
        return this.size -= t3 ? 1 : 0, t3;
      }
      function rr2(n3) {
        var t3 = this.__data__;
        if (is) {
          var r3 = t3[n3];
          return r3 === on ? X2 : r3;
        }
        return bl.call(t3, n3) ? t3[n3] : X2;
      }
      function er2(n3) {
        var t3 = this.__data__;
        return is ? t3[n3] !== X2 : bl.call(t3, n3);
      }
      function ur2(n3, t3) {
        var r3 = this.__data__;
        return this.size += this.has(n3) ? 0 : 1, r3[n3] = is && t3 === X2 ? on : t3, this;
      }
      function ir2(n3) {
        var t3 = -1, r3 = n3 == null ? 0 : n3.length;
        for (this.clear(); ++t3 < r3; ) {
          var e3 = n3[t3];
          this.set(e3[0], e3[1]);
        }
      }
      function or3() {
        this.__data__ = [], this.size = 0;
      }
      function fr2(n3) {
        var t3 = this.__data__, r3 = Wr2(t3, n3);
        return !(r3 < 0) && (r3 == t3.length - 1 ? t3.pop() : Ll.call(t3, r3, 1), --this.size, true);
      }
      function cr2(n3) {
        var t3 = this.__data__, r3 = Wr2(t3, n3);
        return r3 < 0 ? X2 : t3[r3][1];
      }
      function ar2(n3) {
        return Wr2(this.__data__, n3) > -1;
      }
      function lr2(n3, t3) {
        var r3 = this.__data__, e3 = Wr2(r3, n3);
        return e3 < 0 ? (++this.size, r3.push([n3, t3])) : r3[e3][1] = t3, this;
      }
      function sr3(n3) {
        var t3 = -1, r3 = n3 == null ? 0 : n3.length;
        for (this.clear(); ++t3 < r3; ) {
          var e3 = n3[t3];
          this.set(e3[0], e3[1]);
        }
      }
      function hr2() {
        this.size = 0, this.__data__ = { hash: new Xt2(), map: new (ts || ir2)(), string: new Xt2() };
      }
      function pr2(n3) {
        var t3 = xi(this, n3).delete(n3);
        return this.size -= t3 ? 1 : 0, t3;
      }
      function _r2(n3) {
        return xi(this, n3).get(n3);
      }
      function vr2(n3) {
        return xi(this, n3).has(n3);
      }
      function gr2(n3, t3) {
        var r3 = xi(this, n3), e3 = r3.size;
        return r3.set(n3, t3), this.size += r3.size == e3 ? 0 : 1, this;
      }
      function yr2(n3) {
        var t3 = -1, r3 = n3 == null ? 0 : n3.length;
        for (this.__data__ = new sr3(); ++t3 < r3; )
          this.add(n3[t3]);
      }
      function dr2(n3) {
        return this.__data__.set(n3, on), this;
      }
      function br2(n3) {
        return this.__data__.has(n3);
      }
      function wr2(n3) {
        this.size = (this.__data__ = new ir2(n3)).size;
      }
      function mr2() {
        this.__data__ = new ir2(), this.size = 0;
      }
      function xr2(n3) {
        var t3 = this.__data__, r3 = t3.delete(n3);
        return this.size = t3.size, r3;
      }
      function jr2(n3) {
        return this.__data__.get(n3);
      }
      function Ar2(n3) {
        return this.__data__.has(n3);
      }
      function kr2(n3, t3) {
        var r3 = this.__data__;
        if (r3 instanceof ir2) {
          var e3 = r3.__data__;
          if (!ts || e3.length < tn - 1)
            return e3.push([n3, t3]), this.size = ++r3.size, this;
          r3 = this.__data__ = new sr3(e3);
        }
        return r3.set(n3, t3), this.size = r3.size, this;
      }
      function Or2(n3, t3) {
        var r3 = bh(n3), e3 = !r3 && dh(n3), u3 = !r3 && !e3 && mh(n3), i3 = !r3 && !e3 && !u3 && Oh(n3), o2 = r3 || e3 || u3 || i3, f3 = o2 ? O(n3.length, hl) : [], c3 = f3.length;
        for (var a7 in n3)
          !t3 && !bl.call(n3, a7) || o2 && (a7 == "length" || u3 && (a7 == "offset" || a7 == "parent") || i3 && (a7 == "buffer" || a7 == "byteLength" || a7 == "byteOffset") || Ci(a7, c3)) || f3.push(a7);
        return f3;
      }
      function Ir2(n3) {
        var t3 = n3.length;
        return t3 ? n3[tu(0, t3 - 1)] : X2;
      }
      function Rr2(n3, t3) {
        return Xi(Tu(n3), Mr2(t3, 0, n3.length));
      }
      function zr2(n3) {
        return Xi(Tu(n3));
      }
      function Er2(n3, t3, r3) {
        (r3 === X2 || Gf(n3[t3], r3)) && (r3 !== X2 || t3 in n3) || Br2(n3, t3, r3);
      }
      function Sr2(n3, t3, r3) {
        var e3 = n3[t3];
        bl.call(n3, t3) && Gf(e3, r3) && (r3 !== X2 || t3 in n3) || Br2(n3, t3, r3);
      }
      function Wr2(n3, t3) {
        for (var r3 = n3.length; r3--; )
          if (Gf(n3[r3][0], t3))
            return r3;
        return -1;
      }
      function Lr2(n3, t3, r3, e3) {
        return ys(n3, function(n4, u3, i3) {
          t3(e3, n4, r3(n4), i3);
        }), e3;
      }
      function Cr2(n3, t3) {
        return n3 && $u(t3, Pc(t3), n3);
      }
      function Ur2(n3, t3) {
        return n3 && $u(t3, qc(t3), n3);
      }
      function Br2(n3, t3, r3) {
        t3 == "__proto__" && Tl ? Tl(n3, t3, { configurable: true, enumerable: true, value: r3, writable: true }) : n3[t3] = r3;
      }
      function Tr2(n3, t3) {
        for (var r3 = -1, e3 = t3.length, u3 = il(e3), i3 = n3 == null; ++r3 < e3; )
          u3[r3] = i3 ? X2 : Mc(n3, t3[r3]);
        return u3;
      }
      function Mr2(n3, t3, r3) {
        return n3 === n3 && (r3 !== X2 && (n3 = n3 <= r3 ? n3 : r3), t3 !== X2 && (n3 = n3 >= t3 ? n3 : t3)), n3;
      }
      function Fr2(n3, t3, e3, u3, i3, o2) {
        var f3, c3 = t3 & an, a7 = t3 & ln, l3 = t3 & sn;
        if (e3 && (f3 = i3 ? e3(n3, u3, i3, o2) : e3(n3)), f3 !== X2)
          return f3;
        if (!fc(n3))
          return n3;
        var s3 = bh(n3);
        if (s3) {
          if (f3 = zi(n3), !c3)
            return Tu(n3, f3);
        } else {
          var h3 = zs(n3), p4 = h3 == Kn || h3 == Vn;
          if (mh(n3))
            return Iu(n3, c3);
          if (h3 == Yn || h3 == Dn || p4 && !i3) {
            if (f3 = a7 || p4 ? {} : Ei(n3), !c3)
              return a7 ? Mu(n3, Ur2(f3, n3)) : Du(n3, Cr2(f3, n3));
          } else {
            if (!Vr[h3])
              return i3 ? n3 : {};
            f3 = Si(n3, h3, c3);
          }
        }
        o2 || (o2 = new wr2());
        var _25 = o2.get(n3);
        if (_25)
          return _25;
        o2.set(n3, f3), kh(n3) ? n3.forEach(function(r3) {
          f3.add(Fr2(r3, t3, e3, r3, n3, o2));
        }) : jh(n3) && n3.forEach(function(r3, u4) {
          f3.set(u4, Fr2(r3, t3, e3, u4, n3, o2));
        });
        var v3 = l3 ? a7 ? di : yi : a7 ? qc : Pc, g3 = s3 ? X2 : v3(n3);
        return r2(g3 || n3, function(r3, u4) {
          g3 && (u4 = r3, r3 = n3[u4]), Sr2(f3, u4, Fr2(r3, t3, e3, u4, n3, o2));
        }), f3;
      }
      function Nr2(n3) {
        var t3 = Pc(n3);
        return function(r3) {
          return Pr2(r3, n3, t3);
        };
      }
      function Pr2(n3, t3, r3) {
        var e3 = r3.length;
        if (n3 == null)
          return !e3;
        for (n3 = ll(n3); e3--; ) {
          var u3 = r3[e3], i3 = t3[u3], o2 = n3[u3];
          if (o2 === X2 && !(u3 in n3) || !i3(o2))
            return false;
        }
        return true;
      }
      function Gr2(n3, t3, r3) {
        if (typeof n3 != "function")
          throw new pl(en);
        return Ws(function() {
          n3.apply(X2, r3);
        }, t3);
      }
      function Hr2(n3, t3, r3, e3) {
        var u3 = -1, i3 = o, a7 = true, l3 = n3.length, s3 = [], h3 = t3.length;
        if (!l3)
          return s3;
        r3 && (t3 = c2(t3, z2(r3))), e3 ? (i3 = f2, a7 = false) : t3.length >= tn && (i3 = S2, a7 = false, t3 = new yr2(t3));
        n:
          for (; ++u3 < l3; ) {
            var p4 = n3[u3], _25 = r3 == null ? p4 : r3(p4);
            if (p4 = e3 || p4 !== 0 ? p4 : 0, a7 && _25 === _25) {
              for (var v3 = h3; v3--; )
                if (t3[v3] === _25)
                  continue n;
              s3.push(p4);
            } else
              i3(t3, _25, e3) || s3.push(p4);
          }
        return s3;
      }
      function Jr2(n3, t3) {
        var r3 = true;
        return ys(n3, function(n4, e3, u3) {
          return r3 = !!t3(n4, e3, u3);
        }), r3;
      }
      function Yr2(n3, t3, r3) {
        for (var e3 = -1, u3 = n3.length; ++e3 < u3; ) {
          var i3 = n3[e3], o2 = t3(i3);
          if (o2 != null && (f3 === X2 ? o2 === o2 && !bc(o2) : r3(o2, f3)))
            var f3 = o2, c3 = i3;
        }
        return c3;
      }
      function ne3(n3, t3, r3, e3) {
        var u3 = n3.length;
        for (r3 = kc(r3), r3 < 0 && (r3 = -r3 > u3 ? 0 : u3 + r3), e3 = e3 === X2 || e3 > u3 ? u3 : kc(e3), e3 < 0 && (e3 += u3), e3 = r3 > e3 ? 0 : Oc(e3); r3 < e3; )
          n3[r3++] = t3;
        return n3;
      }
      function te3(n3, t3) {
        var r3 = [];
        return ys(n3, function(n4, e3, u3) {
          t3(n4, e3, u3) && r3.push(n4);
        }), r3;
      }
      function ee3(n3, t3, r3, e3, u3) {
        var i3 = -1, o2 = n3.length;
        for (r3 || (r3 = Li), u3 || (u3 = []); ++i3 < o2; ) {
          var f3 = n3[i3];
          t3 > 0 && r3(f3) ? t3 > 1 ? ee3(f3, t3 - 1, r3, e3, u3) : a6(u3, f3) : e3 || (u3[u3.length] = f3);
        }
        return u3;
      }
      function ue3(n3, t3) {
        return n3 && bs(n3, t3, Pc);
      }
      function oe3(n3, t3) {
        return n3 && ws(n3, t3, Pc);
      }
      function fe3(n3, t3) {
        return i2(t3, function(t4) {
          return uc(n3[t4]);
        });
      }
      function _e3(n3, t3) {
        t3 = ku(t3, n3);
        for (var r3 = 0, e3 = t3.length; n3 != null && r3 < e3; )
          n3 = n3[no(t3[r3++])];
        return r3 && r3 == e3 ? n3 : X2;
      }
      function de3(n3, t3, r3) {
        var e3 = t3(n3);
        return bh(n3) ? e3 : a6(e3, r3(n3));
      }
      function we2(n3) {
        return n3 == null ? n3 === X2 ? ut : Jn : Bl && Bl in ll(n3) ? ki(n3) : Ki(n3);
      }
      function me2(n3, t3) {
        return n3 > t3;
      }
      function xe2(n3, t3) {
        return n3 != null && bl.call(n3, t3);
      }
      function je2(n3, t3) {
        return n3 != null && t3 in ll(n3);
      }
      function Ae2(n3, t3, r3) {
        return n3 >= Hl(t3, r3) && n3 < Gl(t3, r3);
      }
      function ke2(n3, t3, r3) {
        for (var e3 = r3 ? f2 : o, u3 = n3[0].length, i3 = n3.length, a7 = i3, l3 = il(i3), s3 = 1 / 0, h3 = []; a7--; ) {
          var p4 = n3[a7];
          a7 && t3 && (p4 = c2(p4, z2(t3))), s3 = Hl(p4.length, s3), l3[a7] = !r3 && (t3 || u3 >= 120 && p4.length >= 120) ? new yr2(a7 && p4) : X2;
        }
        p4 = n3[0];
        var _25 = -1, v3 = l3[0];
        n:
          for (; ++_25 < u3 && h3.length < s3; ) {
            var g3 = p4[_25], y3 = t3 ? t3(g3) : g3;
            if (g3 = r3 || g3 !== 0 ? g3 : 0, !(v3 ? S2(v3, y3) : e3(h3, y3, r3))) {
              for (a7 = i3; --a7; ) {
                var d3 = l3[a7];
                if (!(d3 ? S2(d3, y3) : e3(n3[a7], y3, r3)))
                  continue n;
              }
              v3 && v3.push(y3), h3.push(g3);
            }
          }
        return h3;
      }
      function Oe(n3, t3, r3, e3) {
        return ue3(n3, function(n4, u3, i3) {
          t3(e3, r3(n4), u3, i3);
        }), e3;
      }
      function Ie(t3, r3, e3) {
        r3 = ku(r3, t3), t3 = Gi(t3, r3);
        var u3 = t3 == null ? t3 : t3[no(jo(r3))];
        return u3 == null ? X2 : n2(u3, t3, e3);
      }
      function Re2(n3) {
        return cc2(n3) && we2(n3) == Dn;
      }
      function ze2(n3) {
        return cc2(n3) && we2(n3) == ft;
      }
      function Ee2(n3) {
        return cc2(n3) && we2(n3) == Pn;
      }
      function Se2(n3, t3, r3, e3, u3) {
        return n3 === t3 || (n3 == null || t3 == null || !cc2(n3) && !cc2(t3) ? n3 !== n3 && t3 !== t3 : We(n3, t3, r3, e3, Se2, u3));
      }
      function We(n3, t3, r3, e3, u3, i3) {
        var o2 = bh(n3), f3 = bh(t3), c3 = o2 ? Mn : zs(n3), a7 = f3 ? Mn : zs(t3);
        c3 = c3 == Dn ? Yn : c3, a7 = a7 == Dn ? Yn : a7;
        var l3 = c3 == Yn, s3 = a7 == Yn, h3 = c3 == a7;
        if (h3 && mh(n3)) {
          if (!mh(t3))
            return false;
          o2 = true, l3 = false;
        }
        if (h3 && !l3)
          return i3 || (i3 = new wr2()), o2 || Oh(n3) ? pi(n3, t3, r3, e3, u3, i3) : _i(n3, t3, c3, r3, e3, u3, i3);
        if (!(r3 & hn)) {
          var p4 = l3 && bl.call(n3, "__wrapped__"), _25 = s3 && bl.call(t3, "__wrapped__");
          if (p4 || _25) {
            var v3 = p4 ? n3.value() : n3, g3 = _25 ? t3.value() : t3;
            return i3 || (i3 = new wr2()), u3(v3, g3, r3, e3, i3);
          }
        }
        return !!h3 && (i3 || (i3 = new wr2()), vi(n3, t3, r3, e3, u3, i3));
      }
      function Le(n3) {
        return cc2(n3) && zs(n3) == Gn;
      }
      function Ce2(n3, t3, r3, e3) {
        var u3 = r3.length, i3 = u3, o2 = !e3;
        if (n3 == null)
          return !i3;
        for (n3 = ll(n3); u3--; ) {
          var f3 = r3[u3];
          if (o2 && f3[2] ? f3[1] !== n3[f3[0]] : !(f3[0] in n3))
            return false;
        }
        for (; ++u3 < i3; ) {
          f3 = r3[u3];
          var c3 = f3[0], a7 = n3[c3], l3 = f3[1];
          if (o2 && f3[2]) {
            if (a7 === X2 && !(c3 in n3))
              return false;
          } else {
            var s3 = new wr2();
            if (e3)
              var h3 = e3(a7, l3, c3, n3, t3, s3);
            if (!(h3 === X2 ? Se2(l3, a7, hn | pn, e3, s3) : h3))
              return false;
          }
        }
        return true;
      }
      function Ue2(n3) {
        return !(!fc(n3) || Di(n3)) && (uc(n3) ? kl : Zt).test(to(n3));
      }
      function Be2(n3) {
        return cc2(n3) && we2(n3) == nt;
      }
      function Te2(n3) {
        return cc2(n3) && zs(n3) == tt;
      }
      function $e(n3) {
        return cc2(n3) && oc(n3.length) && !!Kr[we2(n3)];
      }
      function De2(n3) {
        return typeof n3 == "function" ? n3 : n3 == null ? La : typeof n3 == "object" ? bh(n3) ? Ze(n3[0], n3[1]) : qe2(n3) : Fa(n3);
      }
      function Me2(n3) {
        if (!Mi(n3))
          return Vl(n3);
        var t3 = [];
        for (var r3 in ll(n3))
          bl.call(n3, r3) && r3 != "constructor" && t3.push(r3);
        return t3;
      }
      function Fe2(n3) {
        if (!fc(n3))
          return Zi(n3);
        var t3 = Mi(n3), r3 = [];
        for (var e3 in n3)
          (e3 != "constructor" || !t3 && bl.call(n3, e3)) && r3.push(e3);
        return r3;
      }
      function Ne2(n3, t3) {
        return n3 < t3;
      }
      function Pe(n3, t3) {
        var r3 = -1, e3 = Hf(n3) ? il(n3.length) : [];
        return ys(n3, function(n4, u3, i3) {
          e3[++r3] = t3(n4, u3, i3);
        }), e3;
      }
      function qe2(n3) {
        var t3 = ji(n3);
        return t3.length == 1 && t3[0][2] ? Ni(t3[0][0], t3[0][1]) : function(r3) {
          return r3 === n3 || Ce2(r3, n3, t3);
        };
      }
      function Ze(n3, t3) {
        return Bi(n3) && Fi(t3) ? Ni(no(n3), t3) : function(r3) {
          var e3 = Mc(r3, n3);
          return e3 === X2 && e3 === t3 ? Nc(r3, n3) : Se2(t3, e3, hn | pn);
        };
      }
      function Ke(n3, t3, r3, e3, u3) {
        n3 !== t3 && bs(t3, function(i3, o2) {
          if (u3 || (u3 = new wr2()), fc(i3))
            Ve2(n3, t3, o2, r3, Ke, e3, u3);
          else {
            var f3 = e3 ? e3(Ji(n3, o2), i3, o2 + "", n3, t3, u3) : X2;
            f3 === X2 && (f3 = i3), Er2(n3, o2, f3);
          }
        }, qc);
      }
      function Ve2(n3, t3, r3, e3, u3, i3, o2) {
        var f3 = Ji(n3, r3), c3 = Ji(t3, r3), a7 = o2.get(c3);
        if (a7)
          return Er2(n3, r3, a7), X2;
        var l3 = i3 ? i3(f3, c3, r3 + "", n3, t3, o2) : X2, s3 = l3 === X2;
        if (s3) {
          var h3 = bh(c3), p4 = !h3 && mh(c3), _25 = !h3 && !p4 && Oh(c3);
          l3 = c3, h3 || p4 || _25 ? bh(f3) ? l3 = f3 : Jf(f3) ? l3 = Tu(f3) : p4 ? (s3 = false, l3 = Iu(c3, true)) : _25 ? (s3 = false, l3 = Wu(c3, true)) : l3 = [] : gc(c3) || dh(c3) ? (l3 = f3, dh(f3) ? l3 = Rc(f3) : fc(f3) && !uc(f3) || (l3 = Ei(c3))) : s3 = false;
        }
        s3 && (o2.set(c3, l3), u3(l3, c3, e3, i3, o2), o2.delete(c3)), Er2(n3, r3, l3);
      }
      function Ge2(n3, t3) {
        var r3 = n3.length;
        if (r3)
          return t3 += t3 < 0 ? r3 : 0, Ci(t3, r3) ? n3[t3] : X2;
      }
      function He2(n3, t3, r3) {
        t3 = t3.length ? c2(t3, function(n4) {
          return bh(n4) ? function(t4) {
            return _e3(t4, n4.length === 1 ? n4[0] : n4);
          } : n4;
        }) : [La];
        var e3 = -1;
        return t3 = c2(t3, z2(mi())), A2(Pe(n3, function(n4, r4, u3) {
          return { criteria: c2(t3, function(t4) {
            return t4(n4);
          }), index: ++e3, value: n4 };
        }), function(n4, t4) {
          return Cu(n4, t4, r3);
        });
      }
      function Je(n3, t3) {
        return Ye2(n3, t3, function(t4, r3) {
          return Nc(n3, r3);
        });
      }
      function Ye2(n3, t3, r3) {
        for (var e3 = -1, u3 = t3.length, i3 = {}; ++e3 < u3; ) {
          var o2 = t3[e3], f3 = _e3(n3, o2);
          r3(f3, o2) && fu(i3, ku(o2, n3), f3);
        }
        return i3;
      }
      function Qe(n3) {
        return function(t3) {
          return _e3(t3, n3);
        };
      }
      function Xe(n3, t3, r3, e3) {
        var u3 = e3 ? d2 : y2, i3 = -1, o2 = t3.length, f3 = n3;
        for (n3 === t3 && (t3 = Tu(t3)), r3 && (f3 = c2(n3, z2(r3))); ++i3 < o2; )
          for (var a7 = 0, l3 = t3[i3], s3 = r3 ? r3(l3) : l3; (a7 = u3(f3, s3, a7, e3)) > -1; )
            f3 !== n3 && Ll.call(f3, a7, 1), Ll.call(n3, a7, 1);
        return n3;
      }
      function nu(n3, t3) {
        for (var r3 = n3 ? t3.length : 0, e3 = r3 - 1; r3--; ) {
          var u3 = t3[r3];
          if (r3 == e3 || u3 !== i3) {
            var i3 = u3;
            Ci(u3) ? Ll.call(n3, u3, 1) : yu(n3, u3);
          }
        }
        return n3;
      }
      function tu(n3, t3) {
        return n3 + Nl(Ql() * (t3 - n3 + 1));
      }
      function ru(n3, t3, r3, e3) {
        for (var u3 = -1, i3 = Gl(Fl((t3 - n3) / (r3 || 1)), 0), o2 = il(i3); i3--; )
          o2[e3 ? i3 : ++u3] = n3, n3 += r3;
        return o2;
      }
      function eu(n3, t3) {
        var r3 = "";
        if (!n3 || t3 < 1 || t3 > Wn)
          return r3;
        do
          t3 % 2 && (r3 += n3), t3 = Nl(t3 / 2), t3 && (n3 += n3);
        while (t3);
        return r3;
      }
      function uu(n3, t3) {
        return Ls(Vi(n3, t3, La), n3 + "");
      }
      function iu(n3) {
        return Ir2(ra(n3));
      }
      function ou(n3, t3) {
        var r3 = ra(n3);
        return Xi(r3, Mr2(t3, 0, r3.length));
      }
      function fu(n3, t3, r3, e3) {
        if (!fc(n3))
          return n3;
        t3 = ku(t3, n3);
        for (var u3 = -1, i3 = t3.length, o2 = i3 - 1, f3 = n3; f3 != null && ++u3 < i3; ) {
          var c3 = no(t3[u3]), a7 = r3;
          if (c3 === "__proto__" || c3 === "constructor" || c3 === "prototype")
            return n3;
          if (u3 != o2) {
            var l3 = f3[c3];
            a7 = e3 ? e3(l3, c3, f3) : X2, a7 === X2 && (a7 = fc(l3) ? l3 : Ci(t3[u3 + 1]) ? [] : {});
          }
          Sr2(f3, c3, a7), f3 = f3[c3];
        }
        return n3;
      }
      function cu(n3) {
        return Xi(ra(n3));
      }
      function au(n3, t3, r3) {
        var e3 = -1, u3 = n3.length;
        t3 < 0 && (t3 = -t3 > u3 ? 0 : u3 + t3), r3 = r3 > u3 ? u3 : r3, r3 < 0 && (r3 += u3), u3 = t3 > r3 ? 0 : r3 - t3 >>> 0, t3 >>>= 0;
        for (var i3 = il(u3); ++e3 < u3; )
          i3[e3] = n3[e3 + t3];
        return i3;
      }
      function lu(n3, t3) {
        var r3;
        return ys(n3, function(n4, e3, u3) {
          return r3 = t3(n4, e3, u3), !r3;
        }), !!r3;
      }
      function su(n3, t3, r3) {
        var e3 = 0, u3 = n3 == null ? e3 : n3.length;
        if (typeof t3 == "number" && t3 === t3 && u3 <= Tn) {
          for (; e3 < u3; ) {
            var i3 = e3 + u3 >>> 1, o2 = n3[i3];
            o2 !== null && !bc(o2) && (r3 ? o2 <= t3 : o2 < t3) ? e3 = i3 + 1 : u3 = i3;
          }
          return u3;
        }
        return hu(n3, t3, La, r3);
      }
      function hu(n3, t3, r3, e3) {
        var u3 = 0, i3 = n3 == null ? 0 : n3.length;
        if (i3 === 0)
          return 0;
        t3 = r3(t3);
        for (var o2 = t3 !== t3, f3 = t3 === null, c3 = bc(t3), a7 = t3 === X2; u3 < i3; ) {
          var l3 = Nl((u3 + i3) / 2), s3 = r3(n3[l3]), h3 = s3 !== X2, p4 = s3 === null, _25 = s3 === s3, v3 = bc(s3);
          if (o2)
            var g3 = e3 || _25;
          else
            g3 = a7 ? _25 && (e3 || h3) : f3 ? _25 && h3 && (e3 || !p4) : c3 ? _25 && h3 && !p4 && (e3 || !v3) : !p4 && !v3 && (e3 ? s3 <= t3 : s3 < t3);
          g3 ? u3 = l3 + 1 : i3 = l3;
        }
        return Hl(i3, Bn);
      }
      function pu(n3, t3) {
        for (var r3 = -1, e3 = n3.length, u3 = 0, i3 = []; ++r3 < e3; ) {
          var o2 = n3[r3], f3 = t3 ? t3(o2) : o2;
          if (!r3 || !Gf(f3, c3)) {
            var c3 = f3;
            i3[u3++] = o2 === 0 ? 0 : o2;
          }
        }
        return i3;
      }
      function _u(n3) {
        return typeof n3 == "number" ? n3 : bc(n3) ? Cn : +n3;
      }
      function vu(n3) {
        if (typeof n3 == "string")
          return n3;
        if (bh(n3))
          return c2(n3, vu) + "";
        if (bc(n3))
          return vs ? vs.call(n3) : "";
        var t3 = n3 + "";
        return t3 == "0" && 1 / n3 == -Sn ? "-0" : t3;
      }
      function gu(n3, t3, r3) {
        var e3 = -1, u3 = o, i3 = n3.length, c3 = true, a7 = [], l3 = a7;
        if (r3)
          c3 = false, u3 = f2;
        else if (i3 >= tn) {
          var s3 = t3 ? null : ks(n3);
          if (s3)
            return P2(s3);
          c3 = false, u3 = S2, l3 = new yr2();
        } else
          l3 = t3 ? [] : a7;
        n:
          for (; ++e3 < i3; ) {
            var h3 = n3[e3], p4 = t3 ? t3(h3) : h3;
            if (h3 = r3 || h3 !== 0 ? h3 : 0, c3 && p4 === p4) {
              for (var _25 = l3.length; _25--; )
                if (l3[_25] === p4)
                  continue n;
              t3 && l3.push(p4), a7.push(h3);
            } else
              u3(l3, p4, r3) || (l3 !== a7 && l3.push(p4), a7.push(h3));
          }
        return a7;
      }
      function yu(n3, t3) {
        return t3 = ku(t3, n3), n3 = Gi(n3, t3), n3 == null || delete n3[no(jo(t3))];
      }
      function du(n3, t3, r3, e3) {
        return fu(n3, t3, r3(_e3(n3, t3)), e3);
      }
      function bu(n3, t3, r3, e3) {
        for (var u3 = n3.length, i3 = e3 ? u3 : -1; (e3 ? i3-- : ++i3 < u3) && t3(n3[i3], i3, n3); )
          ;
        return r3 ? au(n3, e3 ? 0 : i3, e3 ? i3 + 1 : u3) : au(n3, e3 ? i3 + 1 : 0, e3 ? u3 : i3);
      }
      function wu(n3, t3) {
        var r3 = n3;
        return r3 instanceof Ct2 && (r3 = r3.value()), l2(t3, function(n4, t4) {
          return t4.func.apply(t4.thisArg, a6([n4], t4.args));
        }, r3);
      }
      function mu(n3, t3, r3) {
        var e3 = n3.length;
        if (e3 < 2)
          return e3 ? gu(n3[0]) : [];
        for (var u3 = -1, i3 = il(e3); ++u3 < e3; )
          for (var o2 = n3[u3], f3 = -1; ++f3 < e3; )
            f3 != u3 && (i3[u3] = Hr2(i3[u3] || o2, n3[f3], t3, r3));
        return gu(ee3(i3, 1), t3, r3);
      }
      function xu(n3, t3, r3) {
        for (var e3 = -1, u3 = n3.length, i3 = t3.length, o2 = {}; ++e3 < u3; ) {
          r3(o2, n3[e3], e3 < i3 ? t3[e3] : X2);
        }
        return o2;
      }
      function ju(n3) {
        return Jf(n3) ? n3 : [];
      }
      function Au(n3) {
        return typeof n3 == "function" ? n3 : La;
      }
      function ku(n3, t3) {
        return bh(n3) ? n3 : Bi(n3, t3) ? [n3] : Cs(Ec(n3));
      }
      function Ou(n3, t3, r3) {
        var e3 = n3.length;
        return r3 = r3 === X2 ? e3 : r3, !t3 && r3 >= e3 ? n3 : au(n3, t3, r3);
      }
      function Iu(n3, t3) {
        if (t3)
          return n3.slice();
        var r3 = n3.length, e3 = zl ? zl(r3) : new n3.constructor(r3);
        return n3.copy(e3), e3;
      }
      function Ru(n3) {
        var t3 = new n3.constructor(n3.byteLength);
        return new Rl(t3).set(new Rl(n3)), t3;
      }
      function zu(n3, t3) {
        return new n3.constructor(t3 ? Ru(n3.buffer) : n3.buffer, n3.byteOffset, n3.byteLength);
      }
      function Eu(n3) {
        var t3 = new n3.constructor(n3.source, Nt.exec(n3));
        return t3.lastIndex = n3.lastIndex, t3;
      }
      function Su(n3) {
        return _s ? ll(_s.call(n3)) : {};
      }
      function Wu(n3, t3) {
        return new n3.constructor(t3 ? Ru(n3.buffer) : n3.buffer, n3.byteOffset, n3.length);
      }
      function Lu(n3, t3) {
        if (n3 !== t3) {
          var r3 = n3 !== X2, e3 = n3 === null, u3 = n3 === n3, i3 = bc(n3), o2 = t3 !== X2, f3 = t3 === null, c3 = t3 === t3, a7 = bc(t3);
          if (!f3 && !a7 && !i3 && n3 > t3 || i3 && o2 && c3 && !f3 && !a7 || e3 && o2 && c3 || !r3 && c3 || !u3)
            return 1;
          if (!e3 && !i3 && !a7 && n3 < t3 || a7 && r3 && u3 && !e3 && !i3 || f3 && r3 && u3 || !o2 && u3 || !c3)
            return -1;
        }
        return 0;
      }
      function Cu(n3, t3, r3) {
        for (var e3 = -1, u3 = n3.criteria, i3 = t3.criteria, o2 = u3.length, f3 = r3.length; ++e3 < o2; ) {
          var c3 = Lu(u3[e3], i3[e3]);
          if (c3) {
            if (e3 >= f3)
              return c3;
            return c3 * (r3[e3] == "desc" ? -1 : 1);
          }
        }
        return n3.index - t3.index;
      }
      function Uu(n3, t3, r3, e3) {
        for (var u3 = -1, i3 = n3.length, o2 = r3.length, f3 = -1, c3 = t3.length, a7 = Gl(i3 - o2, 0), l3 = il(c3 + a7), s3 = !e3; ++f3 < c3; )
          l3[f3] = t3[f3];
        for (; ++u3 < o2; )
          (s3 || u3 < i3) && (l3[r3[u3]] = n3[u3]);
        for (; a7--; )
          l3[f3++] = n3[u3++];
        return l3;
      }
      function Bu(n3, t3, r3, e3) {
        for (var u3 = -1, i3 = n3.length, o2 = -1, f3 = r3.length, c3 = -1, a7 = t3.length, l3 = Gl(i3 - f3, 0), s3 = il(l3 + a7), h3 = !e3; ++u3 < l3; )
          s3[u3] = n3[u3];
        for (var p4 = u3; ++c3 < a7; )
          s3[p4 + c3] = t3[c3];
        for (; ++o2 < f3; )
          (h3 || u3 < i3) && (s3[p4 + r3[o2]] = n3[u3++]);
        return s3;
      }
      function Tu(n3, t3) {
        var r3 = -1, e3 = n3.length;
        for (t3 || (t3 = il(e3)); ++r3 < e3; )
          t3[r3] = n3[r3];
        return t3;
      }
      function $u(n3, t3, r3, e3) {
        var u3 = !r3;
        r3 || (r3 = {});
        for (var i3 = -1, o2 = t3.length; ++i3 < o2; ) {
          var f3 = t3[i3], c3 = e3 ? e3(r3[f3], n3[f3], f3, r3, n3) : X2;
          c3 === X2 && (c3 = n3[f3]), u3 ? Br2(r3, f3, c3) : Sr2(r3, f3, c3);
        }
        return r3;
      }
      function Du(n3, t3) {
        return $u(n3, Is(n3), t3);
      }
      function Mu(n3, t3) {
        return $u(n3, Rs(n3), t3);
      }
      function Fu(n3, r3) {
        return function(e3, u3) {
          var i3 = bh(e3) ? t2 : Lr2, o2 = r3 ? r3() : {};
          return i3(e3, n3, mi(u3, 2), o2);
        };
      }
      function Nu(n3) {
        return uu(function(t3, r3) {
          var e3 = -1, u3 = r3.length, i3 = u3 > 1 ? r3[u3 - 1] : X2, o2 = u3 > 2 ? r3[2] : X2;
          for (i3 = n3.length > 3 && typeof i3 == "function" ? (u3--, i3) : X2, o2 && Ui(r3[0], r3[1], o2) && (i3 = u3 < 3 ? X2 : i3, u3 = 1), t3 = ll(t3); ++e3 < u3; ) {
            var f3 = r3[e3];
            f3 && n3(t3, f3, e3, i3);
          }
          return t3;
        });
      }
      function Pu(n3, t3) {
        return function(r3, e3) {
          if (r3 == null)
            return r3;
          if (!Hf(r3))
            return n3(r3, e3);
          for (var u3 = r3.length, i3 = t3 ? u3 : -1, o2 = ll(r3); (t3 ? i3-- : ++i3 < u3) && e3(o2[i3], i3, o2) !== false; )
            ;
          return r3;
        };
      }
      function qu(n3) {
        return function(t3, r3, e3) {
          for (var u3 = -1, i3 = ll(t3), o2 = e3(t3), f3 = o2.length; f3--; ) {
            var c3 = o2[n3 ? f3 : ++u3];
            if (r3(i3[c3], c3, i3) === false)
              break;
          }
          return t3;
        };
      }
      function Zu(n3, t3, r3) {
        function e3() {
          return (this && this !== re2 && this instanceof e3 ? i3 : n3).apply(u3 ? r3 : this, arguments);
        }
        var u3 = t3 & _n, i3 = Gu(n3);
        return e3;
      }
      function Ku(n3) {
        return function(t3) {
          t3 = Ec(t3);
          var r3 = T2(t3) ? G2(t3) : X2, e3 = r3 ? r3[0] : t3.charAt(0), u3 = r3 ? Ou(r3, 1).join("") : t3.slice(1);
          return e3[n3]() + u3;
        };
      }
      function Vu(n3) {
        return function(t3) {
          return l2(Ra(ca2(t3).replace($r, "")), n3, "");
        };
      }
      function Gu(n3) {
        return function() {
          var t3 = arguments;
          switch (t3.length) {
            case 0:
              return new n3();
            case 1:
              return new n3(t3[0]);
            case 2:
              return new n3(t3[0], t3[1]);
            case 3:
              return new n3(t3[0], t3[1], t3[2]);
            case 4:
              return new n3(t3[0], t3[1], t3[2], t3[3]);
            case 5:
              return new n3(t3[0], t3[1], t3[2], t3[3], t3[4]);
            case 6:
              return new n3(t3[0], t3[1], t3[2], t3[3], t3[4], t3[5]);
            case 7:
              return new n3(t3[0], t3[1], t3[2], t3[3], t3[4], t3[5], t3[6]);
          }
          var r3 = gs(n3.prototype), e3 = n3.apply(r3, t3);
          return fc(e3) ? e3 : r3;
        };
      }
      function Hu(t3, r3, e3) {
        function u3() {
          for (var o2 = arguments.length, f3 = il(o2), c3 = o2, a7 = wi(u3); c3--; )
            f3[c3] = arguments[c3];
          var l3 = o2 < 3 && f3[0] !== a7 && f3[o2 - 1] !== a7 ? [] : N2(f3, a7);
          return o2 -= l3.length, o2 < e3 ? oi(t3, r3, Qu, u3.placeholder, X2, f3, l3, X2, X2, e3 - o2) : n2(this && this !== re2 && this instanceof u3 ? i3 : t3, this, f3);
        }
        var i3 = Gu(t3);
        return u3;
      }
      function Ju(n3) {
        return function(t3, r3, e3) {
          var u3 = ll(t3);
          if (!Hf(t3)) {
            var i3 = mi(r3, 3);
            t3 = Pc(t3), r3 = function(n4) {
              return i3(u3[n4], n4, u3);
            };
          }
          var o2 = n3(t3, r3, e3);
          return o2 > -1 ? u3[i3 ? t3[o2] : o2] : X2;
        };
      }
      function Yu(n3) {
        return gi(function(t3) {
          var r3 = t3.length, e3 = r3, u3 = Y3.prototype.thru;
          for (n3 && t3.reverse(); e3--; ) {
            var i3 = t3[e3];
            if (typeof i3 != "function")
              throw new pl(en);
            if (u3 && !o2 && bi(i3) == "wrapper")
              var o2 = new Y3([], true);
          }
          for (e3 = o2 ? e3 : r3; ++e3 < r3; ) {
            i3 = t3[e3];
            var f3 = bi(i3), c3 = f3 == "wrapper" ? Os(i3) : X2;
            o2 = c3 && $i(c3[0]) && c3[1] == (mn | yn | bn | xn) && !c3[4].length && c3[9] == 1 ? o2[bi(c3[0])].apply(o2, c3[3]) : i3.length == 1 && $i(i3) ? o2[f3]() : o2.thru(i3);
          }
          return function() {
            var n4 = arguments, e4 = n4[0];
            if (o2 && n4.length == 1 && bh(e4))
              return o2.plant(e4).value();
            for (var u4 = 0, i4 = r3 ? t3[u4].apply(this, n4) : e4; ++u4 < r3; )
              i4 = t3[u4].call(this, i4);
            return i4;
          };
        });
      }
      function Qu(n3, t3, r3, e3, u3, i3, o2, f3, c3, a7) {
        function l3() {
          for (var y3 = arguments.length, d3 = il(y3), b3 = y3; b3--; )
            d3[b3] = arguments[b3];
          if (_25)
            var w3 = wi(l3), m3 = C(d3, w3);
          if (e3 && (d3 = Uu(d3, e3, u3, _25)), i3 && (d3 = Bu(d3, i3, o2, _25)), y3 -= m3, _25 && y3 < a7) {
            return oi(n3, t3, Qu, l3.placeholder, r3, d3, N2(d3, w3), f3, c3, a7 - y3);
          }
          var x4 = h3 ? r3 : this, j3 = p4 ? x4[n3] : n3;
          return y3 = d3.length, f3 ? d3 = Hi(d3, f3) : v3 && y3 > 1 && d3.reverse(), s3 && c3 < y3 && (d3.length = c3), this && this !== re2 && this instanceof l3 && (j3 = g3 || Gu(j3)), j3.apply(x4, d3);
        }
        var s3 = t3 & mn, h3 = t3 & _n, p4 = t3 & vn, _25 = t3 & (yn | dn), v3 = t3 & jn, g3 = p4 ? X2 : Gu(n3);
        return l3;
      }
      function Xu(n3, t3) {
        return function(r3, e3) {
          return Oe(r3, n3, t3(e3), {});
        };
      }
      function ni(n3, t3) {
        return function(r3, e3) {
          var u3;
          if (r3 === X2 && e3 === X2)
            return t3;
          if (r3 !== X2 && (u3 = r3), e3 !== X2) {
            if (u3 === X2)
              return e3;
            typeof r3 == "string" || typeof e3 == "string" ? (r3 = vu(r3), e3 = vu(e3)) : (r3 = _u(r3), e3 = _u(e3)), u3 = n3(r3, e3);
          }
          return u3;
        };
      }
      function ti(t3) {
        return gi(function(r3) {
          return r3 = c2(r3, z2(mi())), uu(function(e3) {
            var u3 = this;
            return t3(r3, function(t4) {
              return n2(t4, u3, e3);
            });
          });
        });
      }
      function ri(n3, t3) {
        t3 = t3 === X2 ? " " : vu(t3);
        var r3 = t3.length;
        if (r3 < 2)
          return r3 ? eu(t3, n3) : t3;
        var e3 = eu(t3, Fl(n3 / V2(t3)));
        return T2(t3) ? Ou(G2(e3), 0, n3).join("") : e3.slice(0, n3);
      }
      function ei(t3, r3, e3, u3) {
        function i3() {
          for (var r4 = -1, c3 = arguments.length, a7 = -1, l3 = u3.length, s3 = il(l3 + c3), h3 = this && this !== re2 && this instanceof i3 ? f3 : t3; ++a7 < l3; )
            s3[a7] = u3[a7];
          for (; c3--; )
            s3[a7++] = arguments[++r4];
          return n2(h3, o2 ? e3 : this, s3);
        }
        var o2 = r3 & _n, f3 = Gu(t3);
        return i3;
      }
      function ui(n3) {
        return function(t3, r3, e3) {
          return e3 && typeof e3 != "number" && Ui(t3, r3, e3) && (r3 = e3 = X2), t3 = Ac(t3), r3 === X2 ? (r3 = t3, t3 = 0) : r3 = Ac(r3), e3 = e3 === X2 ? t3 < r3 ? 1 : -1 : Ac(e3), ru(t3, r3, e3, n3);
        };
      }
      function ii(n3) {
        return function(t3, r3) {
          return typeof t3 == "string" && typeof r3 == "string" || (t3 = Ic(t3), r3 = Ic(r3)), n3(t3, r3);
        };
      }
      function oi(n3, t3, r3, e3, u3, i3, o2, f3, c3, a7) {
        var l3 = t3 & yn, s3 = l3 ? o2 : X2, h3 = l3 ? X2 : o2, p4 = l3 ? i3 : X2, _25 = l3 ? X2 : i3;
        t3 |= l3 ? bn : wn, t3 &= ~(l3 ? wn : bn), t3 & gn || (t3 &= ~(_n | vn));
        var v3 = [n3, t3, u3, p4, s3, _25, h3, f3, c3, a7], g3 = r3.apply(X2, v3);
        return $i(n3) && Ss(g3, v3), g3.placeholder = e3, Yi(g3, n3, t3);
      }
      function fi(n3) {
        var t3 = al[n3];
        return function(n4, r3) {
          if (n4 = Ic(n4), r3 = r3 == null ? 0 : Hl(kc(r3), 292), r3 && Zl(n4)) {
            var e3 = (Ec(n4) + "e").split("e");
            return e3 = (Ec(t3(e3[0] + "e" + (+e3[1] + r3))) + "e").split("e"), +(e3[0] + "e" + (+e3[1] - r3));
          }
          return t3(n4);
        };
      }
      function ci(n3) {
        return function(t3) {
          var r3 = zs(t3);
          return r3 == Gn ? M2(t3) : r3 == tt ? q2(t3) : I2(t3, n3(t3));
        };
      }
      function ai(n3, t3, r3, e3, u3, i3, o2, f3) {
        var c3 = t3 & vn;
        if (!c3 && typeof n3 != "function")
          throw new pl(en);
        var a7 = e3 ? e3.length : 0;
        if (a7 || (t3 &= ~(bn | wn), e3 = u3 = X2), o2 = o2 === X2 ? o2 : Gl(kc(o2), 0), f3 = f3 === X2 ? f3 : kc(f3), a7 -= u3 ? u3.length : 0, t3 & wn) {
          var l3 = e3, s3 = u3;
          e3 = u3 = X2;
        }
        var h3 = c3 ? X2 : Os(n3), p4 = [n3, t3, r3, e3, u3, l3, s3, i3, o2, f3];
        if (h3 && qi(p4, h3), n3 = p4[0], t3 = p4[1], r3 = p4[2], e3 = p4[3], u3 = p4[4], f3 = p4[9] = p4[9] === X2 ? c3 ? 0 : n3.length : Gl(p4[9] - a7, 0), !f3 && t3 & (yn | dn) && (t3 &= ~(yn | dn)), t3 && t3 != _n)
          _25 = t3 == yn || t3 == dn ? Hu(n3, t3, f3) : t3 != bn && t3 != (_n | bn) || u3.length ? Qu.apply(X2, p4) : ei(n3, t3, r3, e3);
        else
          var _25 = Zu(n3, t3, r3);
        return Yi((h3 ? ms : Ss)(_25, p4), n3, t3);
      }
      function li(n3, t3, r3, e3) {
        return n3 === X2 || Gf(n3, gl[r3]) && !bl.call(e3, r3) ? t3 : n3;
      }
      function si(n3, t3, r3, e3, u3, i3) {
        return fc(n3) && fc(t3) && (i3.set(t3, n3), Ke(n3, t3, X2, si, i3), i3.delete(t3)), n3;
      }
      function hi(n3) {
        return gc(n3) ? X2 : n3;
      }
      function pi(n3, t3, r3, e3, u3, i3) {
        var o2 = r3 & hn, f3 = n3.length, c3 = t3.length;
        if (f3 != c3 && !(o2 && c3 > f3))
          return false;
        var a7 = i3.get(n3), l3 = i3.get(t3);
        if (a7 && l3)
          return a7 == t3 && l3 == n3;
        var s3 = -1, p4 = true, _25 = r3 & pn ? new yr2() : X2;
        for (i3.set(n3, t3), i3.set(t3, n3); ++s3 < f3; ) {
          var v3 = n3[s3], g3 = t3[s3];
          if (e3)
            var y3 = o2 ? e3(g3, v3, s3, t3, n3, i3) : e3(v3, g3, s3, n3, t3, i3);
          if (y3 !== X2) {
            if (y3)
              continue;
            p4 = false;
            break;
          }
          if (_25) {
            if (!h2(t3, function(n4, t4) {
              if (!S2(_25, t4) && (v3 === n4 || u3(v3, n4, r3, e3, i3)))
                return _25.push(t4);
            })) {
              p4 = false;
              break;
            }
          } else if (v3 !== g3 && !u3(v3, g3, r3, e3, i3)) {
            p4 = false;
            break;
          }
        }
        return i3.delete(n3), i3.delete(t3), p4;
      }
      function _i(n3, t3, r3, e3, u3, i3, o2) {
        switch (r3) {
          case ct:
            if (n3.byteLength != t3.byteLength || n3.byteOffset != t3.byteOffset)
              return false;
            n3 = n3.buffer, t3 = t3.buffer;
          case ft:
            return !(n3.byteLength != t3.byteLength || !i3(new Rl(n3), new Rl(t3)));
          case Nn:
          case Pn:
          case Hn:
            return Gf(+n3, +t3);
          case Zn:
            return n3.name == t3.name && n3.message == t3.message;
          case nt:
          case rt:
            return n3 == t3 + "";
          case Gn:
            var f3 = M2;
          case tt:
            var c3 = e3 & hn;
            if (f3 || (f3 = P2), n3.size != t3.size && !c3)
              return false;
            var a7 = o2.get(n3);
            if (a7)
              return a7 == t3;
            e3 |= pn, o2.set(n3, t3);
            var l3 = pi(f3(n3), f3(t3), e3, u3, i3, o2);
            return o2.delete(n3), l3;
          case et:
            if (_s)
              return _s.call(n3) == _s.call(t3);
        }
        return false;
      }
      function vi(n3, t3, r3, e3, u3, i3) {
        var o2 = r3 & hn, f3 = yi(n3), c3 = f3.length;
        if (c3 != yi(t3).length && !o2)
          return false;
        for (var a7 = c3; a7--; ) {
          var l3 = f3[a7];
          if (!(o2 ? l3 in t3 : bl.call(t3, l3)))
            return false;
        }
        var s3 = i3.get(n3), h3 = i3.get(t3);
        if (s3 && h3)
          return s3 == t3 && h3 == n3;
        var p4 = true;
        i3.set(n3, t3), i3.set(t3, n3);
        for (var _25 = o2; ++a7 < c3; ) {
          l3 = f3[a7];
          var v3 = n3[l3], g3 = t3[l3];
          if (e3)
            var y3 = o2 ? e3(g3, v3, l3, t3, n3, i3) : e3(v3, g3, l3, n3, t3, i3);
          if (!(y3 === X2 ? v3 === g3 || u3(v3, g3, r3, e3, i3) : y3)) {
            p4 = false;
            break;
          }
          _25 || (_25 = l3 == "constructor");
        }
        if (p4 && !_25) {
          var d3 = n3.constructor, b3 = t3.constructor;
          d3 != b3 && "constructor" in n3 && "constructor" in t3 && !(typeof d3 == "function" && d3 instanceof d3 && typeof b3 == "function" && b3 instanceof b3) && (p4 = false);
        }
        return i3.delete(n3), i3.delete(t3), p4;
      }
      function gi(n3) {
        return Ls(Vi(n3, X2, _o), n3 + "");
      }
      function yi(n3) {
        return de3(n3, Pc, Is);
      }
      function di(n3) {
        return de3(n3, qc, Rs);
      }
      function bi(n3) {
        for (var t3 = n3.name + "", r3 = fs[t3], e3 = bl.call(fs, t3) ? r3.length : 0; e3--; ) {
          var u3 = r3[e3], i3 = u3.func;
          if (i3 == null || i3 == n3)
            return u3.name;
        }
        return t3;
      }
      function wi(n3) {
        return (bl.call(Z3, "placeholder") ? Z3 : n3).placeholder;
      }
      function mi() {
        var n3 = Z3.iteratee || Ca;
        return n3 = n3 === Ca ? De2 : n3, arguments.length ? n3(arguments[0], arguments[1]) : n3;
      }
      function xi(n3, t3) {
        var r3 = n3.__data__;
        return Ti(t3) ? r3[typeof t3 == "string" ? "string" : "hash"] : r3.map;
      }
      function ji(n3) {
        for (var t3 = Pc(n3), r3 = t3.length; r3--; ) {
          var e3 = t3[r3], u3 = n3[e3];
          t3[r3] = [e3, u3, Fi(u3)];
        }
        return t3;
      }
      function Ai(n3, t3) {
        var r3 = B2(n3, t3);
        return Ue2(r3) ? r3 : X2;
      }
      function ki(n3) {
        var t3 = bl.call(n3, Bl), r3 = n3[Bl];
        try {
          n3[Bl] = X2;
          var e3 = true;
        } catch (n4) {
        }
        var u3 = xl.call(n3);
        return e3 && (t3 ? n3[Bl] = r3 : delete n3[Bl]), u3;
      }
      function Oi(n3, t3, r3) {
        for (var e3 = -1, u3 = r3.length; ++e3 < u3; ) {
          var i3 = r3[e3], o2 = i3.size;
          switch (i3.type) {
            case "drop":
              n3 += o2;
              break;
            case "dropRight":
              t3 -= o2;
              break;
            case "take":
              t3 = Hl(t3, n3 + o2);
              break;
            case "takeRight":
              n3 = Gl(n3, t3 - o2);
          }
        }
        return { start: n3, end: t3 };
      }
      function Ii(n3) {
        var t3 = n3.match(Bt);
        return t3 ? t3[1].split(Tt) : [];
      }
      function Ri(n3, t3, r3) {
        t3 = ku(t3, n3);
        for (var e3 = -1, u3 = t3.length, i3 = false; ++e3 < u3; ) {
          var o2 = no(t3[e3]);
          if (!(i3 = n3 != null && r3(n3, o2)))
            break;
          n3 = n3[o2];
        }
        return i3 || ++e3 != u3 ? i3 : (u3 = n3 == null ? 0 : n3.length, !!u3 && oc(u3) && Ci(o2, u3) && (bh(n3) || dh(n3)));
      }
      function zi(n3) {
        var t3 = n3.length, r3 = new n3.constructor(t3);
        return t3 && typeof n3[0] == "string" && bl.call(n3, "index") && (r3.index = n3.index, r3.input = n3.input), r3;
      }
      function Ei(n3) {
        return typeof n3.constructor != "function" || Mi(n3) ? {} : gs(El(n3));
      }
      function Si(n3, t3, r3) {
        var e3 = n3.constructor;
        switch (t3) {
          case ft:
            return Ru(n3);
          case Nn:
          case Pn:
            return new e3(+n3);
          case ct:
            return zu(n3, r3);
          case at:
          case lt:
          case st:
          case ht:
          case pt:
          case _t:
          case vt:
          case gt:
          case yt:
            return Wu(n3, r3);
          case Gn:
            return new e3();
          case Hn:
          case rt:
            return new e3(n3);
          case nt:
            return Eu(n3);
          case tt:
            return new e3();
          case et:
            return Su(n3);
        }
      }
      function Wi(n3, t3) {
        var r3 = t3.length;
        if (!r3)
          return n3;
        var e3 = r3 - 1;
        return t3[e3] = (r3 > 1 ? "& " : "") + t3[e3], t3 = t3.join(r3 > 2 ? ", " : " "), n3.replace(Ut, "{\n/* [wrapped with " + t3 + "] */\n");
      }
      function Li(n3) {
        return bh(n3) || dh(n3) || !!(Cl && n3 && n3[Cl]);
      }
      function Ci(n3, t3) {
        var r3 = typeof n3;
        return t3 = t3 == null ? Wn : t3, !!t3 && (r3 == "number" || r3 != "symbol" && Vt.test(n3)) && n3 > -1 && n3 % 1 == 0 && n3 < t3;
      }
      function Ui(n3, t3, r3) {
        if (!fc(r3))
          return false;
        var e3 = typeof t3;
        return !!(e3 == "number" ? Hf(r3) && Ci(t3, r3.length) : e3 == "string" && t3 in r3) && Gf(r3[t3], n3);
      }
      function Bi(n3, t3) {
        if (bh(n3))
          return false;
        var r3 = typeof n3;
        return !(r3 != "number" && r3 != "symbol" && r3 != "boolean" && n3 != null && !bc(n3)) || (zt.test(n3) || !Rt.test(n3) || t3 != null && n3 in ll(t3));
      }
      function Ti(n3) {
        var t3 = typeof n3;
        return t3 == "string" || t3 == "number" || t3 == "symbol" || t3 == "boolean" ? n3 !== "__proto__" : n3 === null;
      }
      function $i(n3) {
        var t3 = bi(n3), r3 = Z3[t3];
        if (typeof r3 != "function" || !(t3 in Ct2.prototype))
          return false;
        if (n3 === r3)
          return true;
        var e3 = Os(r3);
        return !!e3 && n3 === e3[0];
      }
      function Di(n3) {
        return !!ml && ml in n3;
      }
      function Mi(n3) {
        var t3 = n3 && n3.constructor;
        return n3 === (typeof t3 == "function" && t3.prototype || gl);
      }
      function Fi(n3) {
        return n3 === n3 && !fc(n3);
      }
      function Ni(n3, t3) {
        return function(r3) {
          return r3 != null && (r3[n3] === t3 && (t3 !== X2 || n3 in ll(r3)));
        };
      }
      function Pi(n3) {
        var t3 = Cf(n3, function(n4) {
          return r3.size === fn && r3.clear(), n4;
        }), r3 = t3.cache;
        return t3;
      }
      function qi(n3, t3) {
        var r3 = n3[1], e3 = t3[1], u3 = r3 | e3, i3 = u3 < (_n | vn | mn), o2 = e3 == mn && r3 == yn || e3 == mn && r3 == xn && n3[7].length <= t3[8] || e3 == (mn | xn) && t3[7].length <= t3[8] && r3 == yn;
        if (!i3 && !o2)
          return n3;
        e3 & _n && (n3[2] = t3[2], u3 |= r3 & _n ? 0 : gn);
        var f3 = t3[3];
        if (f3) {
          var c3 = n3[3];
          n3[3] = c3 ? Uu(c3, f3, t3[4]) : f3, n3[4] = c3 ? N2(n3[3], cn) : t3[4];
        }
        return f3 = t3[5], f3 && (c3 = n3[5], n3[5] = c3 ? Bu(c3, f3, t3[6]) : f3, n3[6] = c3 ? N2(n3[5], cn) : t3[6]), f3 = t3[7], f3 && (n3[7] = f3), e3 & mn && (n3[8] = n3[8] == null ? t3[8] : Hl(n3[8], t3[8])), n3[9] == null && (n3[9] = t3[9]), n3[0] = t3[0], n3[1] = u3, n3;
      }
      function Zi(n3) {
        var t3 = [];
        if (n3 != null)
          for (var r3 in ll(n3))
            t3.push(r3);
        return t3;
      }
      function Ki(n3) {
        return xl.call(n3);
      }
      function Vi(t3, r3, e3) {
        return r3 = Gl(r3 === X2 ? t3.length - 1 : r3, 0), function() {
          for (var u3 = arguments, i3 = -1, o2 = Gl(u3.length - r3, 0), f3 = il(o2); ++i3 < o2; )
            f3[i3] = u3[r3 + i3];
          i3 = -1;
          for (var c3 = il(r3 + 1); ++i3 < r3; )
            c3[i3] = u3[i3];
          return c3[r3] = e3(f3), n2(t3, this, c3);
        };
      }
      function Gi(n3, t3) {
        return t3.length < 2 ? n3 : _e3(n3, au(t3, 0, -1));
      }
      function Hi(n3, t3) {
        for (var r3 = n3.length, e3 = Hl(t3.length, r3), u3 = Tu(n3); e3--; ) {
          var i3 = t3[e3];
          n3[e3] = Ci(i3, r3) ? u3[i3] : X2;
        }
        return n3;
      }
      function Ji(n3, t3) {
        if ((t3 !== "constructor" || typeof n3[t3] != "function") && t3 != "__proto__")
          return n3[t3];
      }
      function Yi(n3, t3, r3) {
        var e3 = t3 + "";
        return Ls(n3, Wi(e3, ro(Ii(e3), r3)));
      }
      function Qi(n3) {
        var t3 = 0, r3 = 0;
        return function() {
          var e3 = Jl(), u3 = In - (e3 - r3);
          if (r3 = e3, u3 > 0) {
            if (++t3 >= On)
              return arguments[0];
          } else
            t3 = 0;
          return n3.apply(X2, arguments);
        };
      }
      function Xi(n3, t3) {
        var r3 = -1, e3 = n3.length, u3 = e3 - 1;
        for (t3 = t3 === X2 ? e3 : t3; ++r3 < t3; ) {
          var i3 = tu(r3, u3), o2 = n3[i3];
          n3[i3] = n3[r3], n3[r3] = o2;
        }
        return n3.length = t3, n3;
      }
      function no(n3) {
        if (typeof n3 == "string" || bc(n3))
          return n3;
        var t3 = n3 + "";
        return t3 == "0" && 1 / n3 == -Sn ? "-0" : t3;
      }
      function to(n3) {
        if (n3 != null) {
          try {
            return dl.call(n3);
          } catch (n4) {
          }
          try {
            return n3 + "";
          } catch (n4) {
          }
        }
        return "";
      }
      function ro(n3, t3) {
        return r2($n, function(r3) {
          var e3 = "_." + r3[0];
          t3 & r3[1] && !o(n3, e3) && n3.push(e3);
        }), n3.sort();
      }
      function eo(n3) {
        if (n3 instanceof Ct2)
          return n3.clone();
        var t3 = new Y3(n3.__wrapped__, n3.__chain__);
        return t3.__actions__ = Tu(n3.__actions__), t3.__index__ = n3.__index__, t3.__values__ = n3.__values__, t3;
      }
      function uo(n3, t3, r3) {
        t3 = (r3 ? Ui(n3, t3, r3) : t3 === X2) ? 1 : Gl(kc(t3), 0);
        var e3 = n3 == null ? 0 : n3.length;
        if (!e3 || t3 < 1)
          return [];
        for (var u3 = 0, i3 = 0, o2 = il(Fl(e3 / t3)); u3 < e3; )
          o2[i3++] = au(n3, u3, u3 += t3);
        return o2;
      }
      function io(n3) {
        for (var t3 = -1, r3 = n3 == null ? 0 : n3.length, e3 = 0, u3 = []; ++t3 < r3; ) {
          var i3 = n3[t3];
          i3 && (u3[e3++] = i3);
        }
        return u3;
      }
      function oo() {
        var n3 = arguments.length;
        if (!n3)
          return [];
        for (var t3 = il(n3 - 1), r3 = arguments[0], e3 = n3; e3--; )
          t3[e3 - 1] = arguments[e3];
        return a6(bh(r3) ? Tu(r3) : [r3], ee3(t3, 1));
      }
      function fo(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        return e3 ? (t3 = r3 || t3 === X2 ? 1 : kc(t3), au(n3, t3 < 0 ? 0 : t3, e3)) : [];
      }
      function co(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        return e3 ? (t3 = r3 || t3 === X2 ? 1 : kc(t3), t3 = e3 - t3, au(n3, 0, t3 < 0 ? 0 : t3)) : [];
      }
      function ao(n3, t3) {
        return n3 && n3.length ? bu(n3, mi(t3, 3), true, true) : [];
      }
      function lo(n3, t3) {
        return n3 && n3.length ? bu(n3, mi(t3, 3), true) : [];
      }
      function so(n3, t3, r3, e3) {
        var u3 = n3 == null ? 0 : n3.length;
        return u3 ? (r3 && typeof r3 != "number" && Ui(n3, t3, r3) && (r3 = 0, e3 = u3), ne3(n3, t3, r3, e3)) : [];
      }
      function ho(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        if (!e3)
          return -1;
        var u3 = r3 == null ? 0 : kc(r3);
        return u3 < 0 && (u3 = Gl(e3 + u3, 0)), g2(n3, mi(t3, 3), u3);
      }
      function po(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        if (!e3)
          return -1;
        var u3 = e3 - 1;
        return r3 !== X2 && (u3 = kc(r3), u3 = r3 < 0 ? Gl(e3 + u3, 0) : Hl(u3, e3 - 1)), g2(n3, mi(t3, 3), u3, true);
      }
      function _o(n3) {
        return (n3 == null ? 0 : n3.length) ? ee3(n3, 1) : [];
      }
      function vo(n3) {
        return (n3 == null ? 0 : n3.length) ? ee3(n3, Sn) : [];
      }
      function go(n3, t3) {
        return (n3 == null ? 0 : n3.length) ? (t3 = t3 === X2 ? 1 : kc(t3), ee3(n3, t3)) : [];
      }
      function yo(n3) {
        for (var t3 = -1, r3 = n3 == null ? 0 : n3.length, e3 = {}; ++t3 < r3; ) {
          var u3 = n3[t3];
          e3[u3[0]] = u3[1];
        }
        return e3;
      }
      function bo(n3) {
        return n3 && n3.length ? n3[0] : X2;
      }
      function wo(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        if (!e3)
          return -1;
        var u3 = r3 == null ? 0 : kc(r3);
        return u3 < 0 && (u3 = Gl(e3 + u3, 0)), y2(n3, t3, u3);
      }
      function mo(n3) {
        return (n3 == null ? 0 : n3.length) ? au(n3, 0, -1) : [];
      }
      function xo(n3, t3) {
        return n3 == null ? "" : Kl.call(n3, t3);
      }
      function jo(n3) {
        var t3 = n3 == null ? 0 : n3.length;
        return t3 ? n3[t3 - 1] : X2;
      }
      function Ao(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        if (!e3)
          return -1;
        var u3 = e3;
        return r3 !== X2 && (u3 = kc(r3), u3 = u3 < 0 ? Gl(e3 + u3, 0) : Hl(u3, e3 - 1)), t3 === t3 ? K2(n3, t3, u3) : g2(n3, b2, u3, true);
      }
      function ko(n3, t3) {
        return n3 && n3.length ? Ge2(n3, kc(t3)) : X2;
      }
      function Oo(n3, t3) {
        return n3 && n3.length && t3 && t3.length ? Xe(n3, t3) : n3;
      }
      function Io(n3, t3, r3) {
        return n3 && n3.length && t3 && t3.length ? Xe(n3, t3, mi(r3, 2)) : n3;
      }
      function Ro(n3, t3, r3) {
        return n3 && n3.length && t3 && t3.length ? Xe(n3, t3, X2, r3) : n3;
      }
      function zo(n3, t3) {
        var r3 = [];
        if (!n3 || !n3.length)
          return r3;
        var e3 = -1, u3 = [], i3 = n3.length;
        for (t3 = mi(t3, 3); ++e3 < i3; ) {
          var o2 = n3[e3];
          t3(o2, e3, n3) && (r3.push(o2), u3.push(e3));
        }
        return nu(n3, u3), r3;
      }
      function Eo(n3) {
        return n3 == null ? n3 : Xl.call(n3);
      }
      function So(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        return e3 ? (r3 && typeof r3 != "number" && Ui(n3, t3, r3) ? (t3 = 0, r3 = e3) : (t3 = t3 == null ? 0 : kc(t3), r3 = r3 === X2 ? e3 : kc(r3)), au(n3, t3, r3)) : [];
      }
      function Wo(n3, t3) {
        return su(n3, t3);
      }
      function Lo(n3, t3, r3) {
        return hu(n3, t3, mi(r3, 2));
      }
      function Co(n3, t3) {
        var r3 = n3 == null ? 0 : n3.length;
        if (r3) {
          var e3 = su(n3, t3);
          if (e3 < r3 && Gf(n3[e3], t3))
            return e3;
        }
        return -1;
      }
      function Uo(n3, t3) {
        return su(n3, t3, true);
      }
      function Bo(n3, t3, r3) {
        return hu(n3, t3, mi(r3, 2), true);
      }
      function To(n3, t3) {
        if (n3 == null ? 0 : n3.length) {
          var r3 = su(n3, t3, true) - 1;
          if (Gf(n3[r3], t3))
            return r3;
        }
        return -1;
      }
      function $o(n3) {
        return n3 && n3.length ? pu(n3) : [];
      }
      function Do(n3, t3) {
        return n3 && n3.length ? pu(n3, mi(t3, 2)) : [];
      }
      function Mo(n3) {
        var t3 = n3 == null ? 0 : n3.length;
        return t3 ? au(n3, 1, t3) : [];
      }
      function Fo(n3, t3, r3) {
        return n3 && n3.length ? (t3 = r3 || t3 === X2 ? 1 : kc(t3), au(n3, 0, t3 < 0 ? 0 : t3)) : [];
      }
      function No(n3, t3, r3) {
        var e3 = n3 == null ? 0 : n3.length;
        return e3 ? (t3 = r3 || t3 === X2 ? 1 : kc(t3), t3 = e3 - t3, au(n3, t3 < 0 ? 0 : t3, e3)) : [];
      }
      function Po(n3, t3) {
        return n3 && n3.length ? bu(n3, mi(t3, 3), false, true) : [];
      }
      function qo(n3, t3) {
        return n3 && n3.length ? bu(n3, mi(t3, 3)) : [];
      }
      function Zo(n3) {
        return n3 && n3.length ? gu(n3) : [];
      }
      function Ko(n3, t3) {
        return n3 && n3.length ? gu(n3, mi(t3, 2)) : [];
      }
      function Vo(n3, t3) {
        return t3 = typeof t3 == "function" ? t3 : X2, n3 && n3.length ? gu(n3, X2, t3) : [];
      }
      function Go(n3) {
        if (!n3 || !n3.length)
          return [];
        var t3 = 0;
        return n3 = i2(n3, function(n4) {
          if (Jf(n4))
            return t3 = Gl(n4.length, t3), true;
        }), O(t3, function(t4) {
          return c2(n3, m2(t4));
        });
      }
      function Ho(t3, r3) {
        if (!t3 || !t3.length)
          return [];
        var e3 = Go(t3);
        return r3 == null ? e3 : c2(e3, function(t4) {
          return n2(r3, X2, t4);
        });
      }
      function Jo(n3, t3) {
        return xu(n3 || [], t3 || [], Sr2);
      }
      function Yo(n3, t3) {
        return xu(n3 || [], t3 || [], fu);
      }
      function Qo(n3) {
        var t3 = Z3(n3);
        return t3.__chain__ = true, t3;
      }
      function Xo(n3, t3) {
        return t3(n3), n3;
      }
      function nf(n3, t3) {
        return t3(n3);
      }
      function tf() {
        return Qo(this);
      }
      function rf() {
        return new Y3(this.value(), this.__chain__);
      }
      function ef() {
        this.__values__ === X2 && (this.__values__ = jc(this.value()));
        var n3 = this.__index__ >= this.__values__.length;
        return { done: n3, value: n3 ? X2 : this.__values__[this.__index__++] };
      }
      function uf() {
        return this;
      }
      function of(n3) {
        for (var t3, r3 = this; r3 instanceof J3; ) {
          var e3 = eo(r3);
          e3.__index__ = 0, e3.__values__ = X2, t3 ? u3.__wrapped__ = e3 : t3 = e3;
          var u3 = e3;
          r3 = r3.__wrapped__;
        }
        return u3.__wrapped__ = n3, t3;
      }
      function ff() {
        var n3 = this.__wrapped__;
        if (n3 instanceof Ct2) {
          var t3 = n3;
          return this.__actions__.length && (t3 = new Ct2(this)), t3 = t3.reverse(), t3.__actions__.push({ func: nf, args: [Eo], thisArg: X2 }), new Y3(t3, this.__chain__);
        }
        return this.thru(Eo);
      }
      function cf() {
        return wu(this.__wrapped__, this.__actions__);
      }
      function af(n3, t3, r3) {
        var e3 = bh(n3) ? u2 : Jr2;
        return r3 && Ui(n3, t3, r3) && (t3 = X2), e3(n3, mi(t3, 3));
      }
      function lf(n3, t3) {
        return (bh(n3) ? i2 : te3)(n3, mi(t3, 3));
      }
      function sf(n3, t3) {
        return ee3(yf(n3, t3), 1);
      }
      function hf(n3, t3) {
        return ee3(yf(n3, t3), Sn);
      }
      function pf(n3, t3, r3) {
        return r3 = r3 === X2 ? 1 : kc(r3), ee3(yf(n3, t3), r3);
      }
      function _f(n3, t3) {
        return (bh(n3) ? r2 : ys)(n3, mi(t3, 3));
      }
      function vf(n3, t3) {
        return (bh(n3) ? e2 : ds)(n3, mi(t3, 3));
      }
      function gf(n3, t3, r3, e3) {
        n3 = Hf(n3) ? n3 : ra(n3), r3 = r3 && !e3 ? kc(r3) : 0;
        var u3 = n3.length;
        return r3 < 0 && (r3 = Gl(u3 + r3, 0)), dc(n3) ? r3 <= u3 && n3.indexOf(t3, r3) > -1 : !!u3 && y2(n3, t3, r3) > -1;
      }
      function yf(n3, t3) {
        return (bh(n3) ? c2 : Pe)(n3, mi(t3, 3));
      }
      function df(n3, t3, r3, e3) {
        return n3 == null ? [] : (bh(t3) || (t3 = t3 == null ? [] : [t3]), r3 = e3 ? X2 : r3, bh(r3) || (r3 = r3 == null ? [] : [r3]), He2(n3, t3, r3));
      }
      function bf(n3, t3, r3) {
        var e3 = bh(n3) ? l2 : j2, u3 = arguments.length < 3;
        return e3(n3, mi(t3, 4), r3, u3, ys);
      }
      function wf(n3, t3, r3) {
        var e3 = bh(n3) ? s2 : j2, u3 = arguments.length < 3;
        return e3(n3, mi(t3, 4), r3, u3, ds);
      }
      function mf(n3, t3) {
        return (bh(n3) ? i2 : te3)(n3, Uf(mi(t3, 3)));
      }
      function xf(n3) {
        return (bh(n3) ? Ir2 : iu)(n3);
      }
      function jf(n3, t3, r3) {
        return t3 = (r3 ? Ui(n3, t3, r3) : t3 === X2) ? 1 : kc(t3), (bh(n3) ? Rr2 : ou)(n3, t3);
      }
      function Af(n3) {
        return (bh(n3) ? zr2 : cu)(n3);
      }
      function kf(n3) {
        if (n3 == null)
          return 0;
        if (Hf(n3))
          return dc(n3) ? V2(n3) : n3.length;
        var t3 = zs(n3);
        return t3 == Gn || t3 == tt ? n3.size : Me2(n3).length;
      }
      function Of(n3, t3, r3) {
        var e3 = bh(n3) ? h2 : lu;
        return r3 && Ui(n3, t3, r3) && (t3 = X2), e3(n3, mi(t3, 3));
      }
      function If(n3, t3) {
        if (typeof t3 != "function")
          throw new pl(en);
        return n3 = kc(n3), function() {
          if (--n3 < 1)
            return t3.apply(this, arguments);
        };
      }
      function Rf(n3, t3, r3) {
        return t3 = r3 ? X2 : t3, t3 = n3 && t3 == null ? n3.length : t3, ai(n3, mn, X2, X2, X2, X2, t3);
      }
      function zf(n3, t3) {
        var r3;
        if (typeof t3 != "function")
          throw new pl(en);
        return n3 = kc(n3), function() {
          return --n3 > 0 && (r3 = t3.apply(this, arguments)), n3 <= 1 && (t3 = X2), r3;
        };
      }
      function Ef(n3, t3, r3) {
        t3 = r3 ? X2 : t3;
        var e3 = ai(n3, yn, X2, X2, X2, X2, X2, t3);
        return e3.placeholder = Ef.placeholder, e3;
      }
      function Sf(n3, t3, r3) {
        t3 = r3 ? X2 : t3;
        var e3 = ai(n3, dn, X2, X2, X2, X2, X2, t3);
        return e3.placeholder = Sf.placeholder, e3;
      }
      function Wf(n3, t3, r3) {
        function e3(t4) {
          var r4 = h3, e4 = p4;
          return h3 = p4 = X2, d3 = t4, v3 = n3.apply(e4, r4);
        }
        function u3(n4) {
          return d3 = n4, g3 = Ws(f3, t3), b3 ? e3(n4) : v3;
        }
        function i3(n4) {
          var r4 = n4 - y3, e4 = n4 - d3, u4 = t3 - r4;
          return w3 ? Hl(u4, _25 - e4) : u4;
        }
        function o2(n4) {
          var r4 = n4 - y3, e4 = n4 - d3;
          return y3 === X2 || r4 >= t3 || r4 < 0 || w3 && e4 >= _25;
        }
        function f3() {
          var n4 = fh();
          return o2(n4) ? c3(n4) : (g3 = Ws(f3, i3(n4)), X2);
        }
        function c3(n4) {
          return g3 = X2, m3 && h3 ? e3(n4) : (h3 = p4 = X2, v3);
        }
        function a7() {
          g3 !== X2 && As(g3), d3 = 0, h3 = y3 = p4 = g3 = X2;
        }
        function l3() {
          return g3 === X2 ? v3 : c3(fh());
        }
        function s3() {
          var n4 = fh(), r4 = o2(n4);
          if (h3 = arguments, p4 = this, y3 = n4, r4) {
            if (g3 === X2)
              return u3(y3);
            if (w3)
              return As(g3), g3 = Ws(f3, t3), e3(y3);
          }
          return g3 === X2 && (g3 = Ws(f3, t3)), v3;
        }
        var h3, p4, _25, v3, g3, y3, d3 = 0, b3 = false, w3 = false, m3 = true;
        if (typeof n3 != "function")
          throw new pl(en);
        return t3 = Ic(t3) || 0, fc(r3) && (b3 = !!r3.leading, w3 = "maxWait" in r3, _25 = w3 ? Gl(Ic(r3.maxWait) || 0, t3) : _25, m3 = "trailing" in r3 ? !!r3.trailing : m3), s3.cancel = a7, s3.flush = l3, s3;
      }
      function Lf(n3) {
        return ai(n3, jn);
      }
      function Cf(n3, t3) {
        if (typeof n3 != "function" || t3 != null && typeof t3 != "function")
          throw new pl(en);
        var r3 = function() {
          var e3 = arguments, u3 = t3 ? t3.apply(this, e3) : e3[0], i3 = r3.cache;
          if (i3.has(u3))
            return i3.get(u3);
          var o2 = n3.apply(this, e3);
          return r3.cache = i3.set(u3, o2) || i3, o2;
        };
        return r3.cache = new (Cf.Cache || sr3)(), r3;
      }
      function Uf(n3) {
        if (typeof n3 != "function")
          throw new pl(en);
        return function() {
          var t3 = arguments;
          switch (t3.length) {
            case 0:
              return !n3.call(this);
            case 1:
              return !n3.call(this, t3[0]);
            case 2:
              return !n3.call(this, t3[0], t3[1]);
            case 3:
              return !n3.call(this, t3[0], t3[1], t3[2]);
          }
          return !n3.apply(this, t3);
        };
      }
      function Bf(n3) {
        return zf(2, n3);
      }
      function Tf(n3, t3) {
        if (typeof n3 != "function")
          throw new pl(en);
        return t3 = t3 === X2 ? t3 : kc(t3), uu(n3, t3);
      }
      function $f(t3, r3) {
        if (typeof t3 != "function")
          throw new pl(en);
        return r3 = r3 == null ? 0 : Gl(kc(r3), 0), uu(function(e3) {
          var u3 = e3[r3], i3 = Ou(e3, 0, r3);
          return u3 && a6(i3, u3), n2(t3, this, i3);
        });
      }
      function Df(n3, t3, r3) {
        var e3 = true, u3 = true;
        if (typeof n3 != "function")
          throw new pl(en);
        return fc(r3) && (e3 = "leading" in r3 ? !!r3.leading : e3, u3 = "trailing" in r3 ? !!r3.trailing : u3), Wf(n3, t3, { leading: e3, maxWait: t3, trailing: u3 });
      }
      function Mf(n3) {
        return Rf(n3, 1);
      }
      function Ff(n3, t3) {
        return ph(Au(t3), n3);
      }
      function Nf() {
        if (!arguments.length)
          return [];
        var n3 = arguments[0];
        return bh(n3) ? n3 : [n3];
      }
      function Pf(n3) {
        return Fr2(n3, sn);
      }
      function qf(n3, t3) {
        return t3 = typeof t3 == "function" ? t3 : X2, Fr2(n3, sn, t3);
      }
      function Zf(n3) {
        return Fr2(n3, an | sn);
      }
      function Kf(n3, t3) {
        return t3 = typeof t3 == "function" ? t3 : X2, Fr2(n3, an | sn, t3);
      }
      function Vf(n3, t3) {
        return t3 == null || Pr2(n3, t3, Pc(t3));
      }
      function Gf(n3, t3) {
        return n3 === t3 || n3 !== n3 && t3 !== t3;
      }
      function Hf(n3) {
        return n3 != null && oc(n3.length) && !uc(n3);
      }
      function Jf(n3) {
        return cc2(n3) && Hf(n3);
      }
      function Yf(n3) {
        return n3 === true || n3 === false || cc2(n3) && we2(n3) == Nn;
      }
      function Qf(n3) {
        return cc2(n3) && n3.nodeType === 1 && !gc(n3);
      }
      function Xf(n3) {
        if (n3 == null)
          return true;
        if (Hf(n3) && (bh(n3) || typeof n3 == "string" || typeof n3.splice == "function" || mh(n3) || Oh(n3) || dh(n3)))
          return !n3.length;
        var t3 = zs(n3);
        if (t3 == Gn || t3 == tt)
          return !n3.size;
        if (Mi(n3))
          return !Me2(n3).length;
        for (var r3 in n3)
          if (bl.call(n3, r3))
            return false;
        return true;
      }
      function nc(n3, t3) {
        return Se2(n3, t3);
      }
      function tc(n3, t3, r3) {
        r3 = typeof r3 == "function" ? r3 : X2;
        var e3 = r3 ? r3(n3, t3) : X2;
        return e3 === X2 ? Se2(n3, t3, X2, r3) : !!e3;
      }
      function rc(n3) {
        if (!cc2(n3))
          return false;
        var t3 = we2(n3);
        return t3 == Zn || t3 == qn || typeof n3.message == "string" && typeof n3.name == "string" && !gc(n3);
      }
      function ec(n3) {
        return typeof n3 == "number" && Zl(n3);
      }
      function uc(n3) {
        if (!fc(n3))
          return false;
        var t3 = we2(n3);
        return t3 == Kn || t3 == Vn || t3 == Fn || t3 == Xn;
      }
      function ic(n3) {
        return typeof n3 == "number" && n3 == kc(n3);
      }
      function oc(n3) {
        return typeof n3 == "number" && n3 > -1 && n3 % 1 == 0 && n3 <= Wn;
      }
      function fc(n3) {
        var t3 = typeof n3;
        return n3 != null && (t3 == "object" || t3 == "function");
      }
      function cc2(n3) {
        return n3 != null && typeof n3 == "object";
      }
      function ac(n3, t3) {
        return n3 === t3 || Ce2(n3, t3, ji(t3));
      }
      function lc(n3, t3, r3) {
        return r3 = typeof r3 == "function" ? r3 : X2, Ce2(n3, t3, ji(t3), r3);
      }
      function sc(n3) {
        return vc(n3) && n3 != +n3;
      }
      function hc(n3) {
        if (Es(n3))
          throw new fl(rn);
        return Ue2(n3);
      }
      function pc(n3) {
        return n3 === null;
      }
      function _c(n3) {
        return n3 == null;
      }
      function vc(n3) {
        return typeof n3 == "number" || cc2(n3) && we2(n3) == Hn;
      }
      function gc(n3) {
        if (!cc2(n3) || we2(n3) != Yn)
          return false;
        var t3 = El(n3);
        if (t3 === null)
          return true;
        var r3 = bl.call(t3, "constructor") && t3.constructor;
        return typeof r3 == "function" && r3 instanceof r3 && dl.call(r3) == jl;
      }
      function yc(n3) {
        return ic(n3) && n3 >= -Wn && n3 <= Wn;
      }
      function dc(n3) {
        return typeof n3 == "string" || !bh(n3) && cc2(n3) && we2(n3) == rt;
      }
      function bc(n3) {
        return typeof n3 == "symbol" || cc2(n3) && we2(n3) == et;
      }
      function wc(n3) {
        return n3 === X2;
      }
      function mc(n3) {
        return cc2(n3) && zs(n3) == it;
      }
      function xc(n3) {
        return cc2(n3) && we2(n3) == ot;
      }
      function jc(n3) {
        if (!n3)
          return [];
        if (Hf(n3))
          return dc(n3) ? G2(n3) : Tu(n3);
        if (Ul && n3[Ul])
          return D2(n3[Ul]());
        var t3 = zs(n3);
        return (t3 == Gn ? M2 : t3 == tt ? P2 : ra)(n3);
      }
      function Ac(n3) {
        if (!n3)
          return n3 === 0 ? n3 : 0;
        if (n3 = Ic(n3), n3 === Sn || n3 === -Sn) {
          return (n3 < 0 ? -1 : 1) * Ln;
        }
        return n3 === n3 ? n3 : 0;
      }
      function kc(n3) {
        var t3 = Ac(n3), r3 = t3 % 1;
        return t3 === t3 ? r3 ? t3 - r3 : t3 : 0;
      }
      function Oc(n3) {
        return n3 ? Mr2(kc(n3), 0, Un) : 0;
      }
      function Ic(n3) {
        if (typeof n3 == "number")
          return n3;
        if (bc(n3))
          return Cn;
        if (fc(n3)) {
          var t3 = typeof n3.valueOf == "function" ? n3.valueOf() : n3;
          n3 = fc(t3) ? t3 + "" : t3;
        }
        if (typeof n3 != "string")
          return n3 === 0 ? n3 : +n3;
        n3 = R(n3);
        var r3 = qt.test(n3);
        return r3 || Kt.test(n3) ? Xr(n3.slice(2), r3 ? 2 : 8) : Pt.test(n3) ? Cn : +n3;
      }
      function Rc(n3) {
        return $u(n3, qc(n3));
      }
      function zc(n3) {
        return n3 ? Mr2(kc(n3), -Wn, Wn) : n3 === 0 ? n3 : 0;
      }
      function Ec(n3) {
        return n3 == null ? "" : vu(n3);
      }
      function Sc(n3, t3) {
        var r3 = gs(n3);
        return t3 == null ? r3 : Cr2(r3, t3);
      }
      function Wc(n3, t3) {
        return v2(n3, mi(t3, 3), ue3);
      }
      function Lc(n3, t3) {
        return v2(n3, mi(t3, 3), oe3);
      }
      function Cc(n3, t3) {
        return n3 == null ? n3 : bs(n3, mi(t3, 3), qc);
      }
      function Uc(n3, t3) {
        return n3 == null ? n3 : ws(n3, mi(t3, 3), qc);
      }
      function Bc(n3, t3) {
        return n3 && ue3(n3, mi(t3, 3));
      }
      function Tc(n3, t3) {
        return n3 && oe3(n3, mi(t3, 3));
      }
      function $c(n3) {
        return n3 == null ? [] : fe3(n3, Pc(n3));
      }
      function Dc(n3) {
        return n3 == null ? [] : fe3(n3, qc(n3));
      }
      function Mc(n3, t3, r3) {
        var e3 = n3 == null ? X2 : _e3(n3, t3);
        return e3 === X2 ? r3 : e3;
      }
      function Fc(n3, t3) {
        return n3 != null && Ri(n3, t3, xe2);
      }
      function Nc(n3, t3) {
        return n3 != null && Ri(n3, t3, je2);
      }
      function Pc(n3) {
        return Hf(n3) ? Or2(n3) : Me2(n3);
      }
      function qc(n3) {
        return Hf(n3) ? Or2(n3, true) : Fe2(n3);
      }
      function Zc(n3, t3) {
        var r3 = {};
        return t3 = mi(t3, 3), ue3(n3, function(n4, e3, u3) {
          Br2(r3, t3(n4, e3, u3), n4);
        }), r3;
      }
      function Kc(n3, t3) {
        var r3 = {};
        return t3 = mi(t3, 3), ue3(n3, function(n4, e3, u3) {
          Br2(r3, e3, t3(n4, e3, u3));
        }), r3;
      }
      function Vc(n3, t3) {
        return Gc(n3, Uf(mi(t3)));
      }
      function Gc(n3, t3) {
        if (n3 == null)
          return {};
        var r3 = c2(di(n3), function(n4) {
          return [n4];
        });
        return t3 = mi(t3), Ye2(n3, r3, function(n4, r4) {
          return t3(n4, r4[0]);
        });
      }
      function Hc(n3, t3, r3) {
        t3 = ku(t3, n3);
        var e3 = -1, u3 = t3.length;
        for (u3 || (u3 = 1, n3 = X2); ++e3 < u3; ) {
          var i3 = n3 == null ? X2 : n3[no(t3[e3])];
          i3 === X2 && (e3 = u3, i3 = r3), n3 = uc(i3) ? i3.call(n3) : i3;
        }
        return n3;
      }
      function Jc(n3, t3, r3) {
        return n3 == null ? n3 : fu(n3, t3, r3);
      }
      function Yc(n3, t3, r3, e3) {
        return e3 = typeof e3 == "function" ? e3 : X2, n3 == null ? n3 : fu(n3, t3, r3, e3);
      }
      function Qc(n3, t3, e3) {
        var u3 = bh(n3), i3 = u3 || mh(n3) || Oh(n3);
        if (t3 = mi(t3, 4), e3 == null) {
          var o2 = n3 && n3.constructor;
          e3 = i3 ? u3 ? new o2() : [] : fc(n3) && uc(o2) ? gs(El(n3)) : {};
        }
        return (i3 ? r2 : ue3)(n3, function(n4, r3, u4) {
          return t3(e3, n4, r3, u4);
        }), e3;
      }
      function Xc(n3, t3) {
        return n3 == null || yu(n3, t3);
      }
      function na(n3, t3, r3) {
        return n3 == null ? n3 : du(n3, t3, Au(r3));
      }
      function ta(n3, t3, r3, e3) {
        return e3 = typeof e3 == "function" ? e3 : X2, n3 == null ? n3 : du(n3, t3, Au(r3), e3);
      }
      function ra(n3) {
        return n3 == null ? [] : E2(n3, Pc(n3));
      }
      function ea(n3) {
        return n3 == null ? [] : E2(n3, qc(n3));
      }
      function ua(n3, t3, r3) {
        return r3 === X2 && (r3 = t3, t3 = X2), r3 !== X2 && (r3 = Ic(r3), r3 = r3 === r3 ? r3 : 0), t3 !== X2 && (t3 = Ic(t3), t3 = t3 === t3 ? t3 : 0), Mr2(Ic(n3), t3, r3);
      }
      function ia(n3, t3, r3) {
        return t3 = Ac(t3), r3 === X2 ? (r3 = t3, t3 = 0) : r3 = Ac(r3), n3 = Ic(n3), Ae2(n3, t3, r3);
      }
      function oa(n3, t3, r3) {
        if (r3 && typeof r3 != "boolean" && Ui(n3, t3, r3) && (t3 = r3 = X2), r3 === X2 && (typeof t3 == "boolean" ? (r3 = t3, t3 = X2) : typeof n3 == "boolean" && (r3 = n3, n3 = X2)), n3 === X2 && t3 === X2 ? (n3 = 0, t3 = 1) : (n3 = Ac(n3), t3 === X2 ? (t3 = n3, n3 = 0) : t3 = Ac(t3)), n3 > t3) {
          var e3 = n3;
          n3 = t3, t3 = e3;
        }
        if (r3 || n3 % 1 || t3 % 1) {
          var u3 = Ql();
          return Hl(n3 + u3 * (t3 - n3 + Qr("1e-" + ((u3 + "").length - 1))), t3);
        }
        return tu(n3, t3);
      }
      function fa(n3) {
        return Qh(Ec(n3).toLowerCase());
      }
      function ca2(n3) {
        return n3 = Ec(n3), n3 && n3.replace(Gt, ve2).replace(Dr, "");
      }
      function aa(n3, t3, r3) {
        n3 = Ec(n3), t3 = vu(t3);
        var e3 = n3.length;
        r3 = r3 === X2 ? e3 : Mr2(kc(r3), 0, e3);
        var u3 = r3;
        return r3 -= t3.length, r3 >= 0 && n3.slice(r3, u3) == t3;
      }
      function la(n3) {
        return n3 = Ec(n3), n3 && At.test(n3) ? n3.replace(xt, ge2) : n3;
      }
      function sa(n3) {
        return n3 = Ec(n3), n3 && Wt.test(n3) ? n3.replace(St, "\\$&") : n3;
      }
      function ha(n3, t3, r3) {
        n3 = Ec(n3), t3 = kc(t3);
        var e3 = t3 ? V2(n3) : 0;
        if (!t3 || e3 >= t3)
          return n3;
        var u3 = (t3 - e3) / 2;
        return ri(Nl(u3), r3) + n3 + ri(Fl(u3), r3);
      }
      function pa(n3, t3, r3) {
        n3 = Ec(n3), t3 = kc(t3);
        var e3 = t3 ? V2(n3) : 0;
        return t3 && e3 < t3 ? n3 + ri(t3 - e3, r3) : n3;
      }
      function _a(n3, t3, r3) {
        n3 = Ec(n3), t3 = kc(t3);
        var e3 = t3 ? V2(n3) : 0;
        return t3 && e3 < t3 ? ri(t3 - e3, r3) + n3 : n3;
      }
      function va(n3, t3, r3) {
        return r3 || t3 == null ? t3 = 0 : t3 && (t3 = +t3), Yl(Ec(n3).replace(Lt, ""), t3 || 0);
      }
      function ga(n3, t3, r3) {
        return t3 = (r3 ? Ui(n3, t3, r3) : t3 === X2) ? 1 : kc(t3), eu(Ec(n3), t3);
      }
      function ya() {
        var n3 = arguments, t3 = Ec(n3[0]);
        return n3.length < 3 ? t3 : t3.replace(n3[1], n3[2]);
      }
      function da(n3, t3, r3) {
        return r3 && typeof r3 != "number" && Ui(n3, t3, r3) && (t3 = r3 = X2), (r3 = r3 === X2 ? Un : r3 >>> 0) ? (n3 = Ec(n3), n3 && (typeof t3 == "string" || t3 != null && !Ah(t3)) && (t3 = vu(t3), !t3 && T2(n3)) ? Ou(G2(n3), 0, r3) : n3.split(t3, r3)) : [];
      }
      function ba(n3, t3, r3) {
        return n3 = Ec(n3), r3 = r3 == null ? 0 : Mr2(kc(r3), 0, n3.length), t3 = vu(t3), n3.slice(r3, r3 + t3.length) == t3;
      }
      function wa(n3, t3, r3) {
        var e3 = Z3.templateSettings;
        r3 && Ui(n3, t3, r3) && (t3 = X2), n3 = Ec(n3), t3 = Sh({}, t3, e3, li);
        var u3, i3, o2 = Sh({}, t3.imports, e3.imports, li), f3 = Pc(o2), c3 = E2(o2, f3), a7 = 0, l3 = t3.interpolate || Ht, s3 = "__p += '", h3 = sl((t3.escape || Ht).source + "|" + l3.source + "|" + (l3 === It ? Ft : Ht).source + "|" + (t3.evaluate || Ht).source + "|$", "g"), p4 = "//# sourceURL=" + (bl.call(t3, "sourceURL") ? (t3.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Zr + "]") + "\n";
        n3.replace(h3, function(t4, r4, e4, o3, f4, c4) {
          return e4 || (e4 = o3), s3 += n3.slice(a7, c4).replace(Jt, U2), r4 && (u3 = true, s3 += "' +\n__e(" + r4 + ") +\n'"), f4 && (i3 = true, s3 += "';\n" + f4 + ";\n__p += '"), e4 && (s3 += "' +\n((__t = (" + e4 + ")) == null ? '' : __t) +\n'"), a7 = c4 + t4.length, t4;
        }), s3 += "';\n";
        var _25 = bl.call(t3, "variable") && t3.variable;
        if (_25) {
          if (Dt.test(_25))
            throw new fl(un);
        } else
          s3 = "with (obj) {\n" + s3 + "\n}\n";
        s3 = (i3 ? s3.replace(dt, "") : s3).replace(bt, "$1").replace(wt, "$1;"), s3 = "function(" + (_25 || "obj") + ") {\n" + (_25 ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (u3 ? ", __e = _.escape" : "") + (i3 ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + s3 + "return __p\n}";
        var v3 = Xh(function() {
          return cl(f3, p4 + "return " + s3).apply(X2, c3);
        });
        if (v3.source = s3, rc(v3))
          throw v3;
        return v3;
      }
      function ma(n3) {
        return Ec(n3).toLowerCase();
      }
      function xa(n3) {
        return Ec(n3).toUpperCase();
      }
      function ja(n3, t3, r3) {
        if (n3 = Ec(n3), n3 && (r3 || t3 === X2))
          return R(n3);
        if (!n3 || !(t3 = vu(t3)))
          return n3;
        var e3 = G2(n3), u3 = G2(t3);
        return Ou(e3, W2(e3, u3), L2(e3, u3) + 1).join("");
      }
      function Aa(n3, t3, r3) {
        if (n3 = Ec(n3), n3 && (r3 || t3 === X2))
          return n3.slice(0, H2(n3) + 1);
        if (!n3 || !(t3 = vu(t3)))
          return n3;
        var e3 = G2(n3);
        return Ou(e3, 0, L2(e3, G2(t3)) + 1).join("");
      }
      function ka(n3, t3, r3) {
        if (n3 = Ec(n3), n3 && (r3 || t3 === X2))
          return n3.replace(Lt, "");
        if (!n3 || !(t3 = vu(t3)))
          return n3;
        var e3 = G2(n3);
        return Ou(e3, W2(e3, G2(t3))).join("");
      }
      function Oa(n3, t3) {
        var r3 = An, e3 = kn;
        if (fc(t3)) {
          var u3 = "separator" in t3 ? t3.separator : u3;
          r3 = "length" in t3 ? kc(t3.length) : r3, e3 = "omission" in t3 ? vu(t3.omission) : e3;
        }
        n3 = Ec(n3);
        var i3 = n3.length;
        if (T2(n3)) {
          var o2 = G2(n3);
          i3 = o2.length;
        }
        if (r3 >= i3)
          return n3;
        var f3 = r3 - V2(e3);
        if (f3 < 1)
          return e3;
        var c3 = o2 ? Ou(o2, 0, f3).join("") : n3.slice(0, f3);
        if (u3 === X2)
          return c3 + e3;
        if (o2 && (f3 += c3.length - f3), Ah(u3)) {
          if (n3.slice(f3).search(u3)) {
            var a7, l3 = c3;
            for (u3.global || (u3 = sl(u3.source, Ec(Nt.exec(u3)) + "g")), u3.lastIndex = 0; a7 = u3.exec(l3); )
              var s3 = a7.index;
            c3 = c3.slice(0, s3 === X2 ? f3 : s3);
          }
        } else if (n3.indexOf(vu(u3), f3) != f3) {
          var h3 = c3.lastIndexOf(u3);
          h3 > -1 && (c3 = c3.slice(0, h3));
        }
        return c3 + e3;
      }
      function Ia(n3) {
        return n3 = Ec(n3), n3 && jt.test(n3) ? n3.replace(mt, ye) : n3;
      }
      function Ra(n3, t3, r3) {
        return n3 = Ec(n3), t3 = r3 ? X2 : t3, t3 === X2 ? $2(n3) ? Q2(n3) : _24(n3) : n3.match(t3) || [];
      }
      function za(t3) {
        var r3 = t3 == null ? 0 : t3.length, e3 = mi();
        return t3 = r3 ? c2(t3, function(n3) {
          if (typeof n3[1] != "function")
            throw new pl(en);
          return [e3(n3[0]), n3[1]];
        }) : [], uu(function(e4) {
          for (var u3 = -1; ++u3 < r3; ) {
            var i3 = t3[u3];
            if (n2(i3[0], this, e4))
              return n2(i3[1], this, e4);
          }
        });
      }
      function Ea(n3) {
        return Nr2(Fr2(n3, an));
      }
      function Sa(n3) {
        return function() {
          return n3;
        };
      }
      function Wa(n3, t3) {
        return n3 == null || n3 !== n3 ? t3 : n3;
      }
      function La(n3) {
        return n3;
      }
      function Ca(n3) {
        return De2(typeof n3 == "function" ? n3 : Fr2(n3, an));
      }
      function Ua(n3) {
        return qe2(Fr2(n3, an));
      }
      function Ba(n3, t3) {
        return Ze(n3, Fr2(t3, an));
      }
      function Ta(n3, t3, e3) {
        var u3 = Pc(t3), i3 = fe3(t3, u3);
        e3 != null || fc(t3) && (i3.length || !u3.length) || (e3 = t3, t3 = n3, n3 = this, i3 = fe3(t3, Pc(t3)));
        var o2 = !(fc(e3) && "chain" in e3 && !e3.chain), f3 = uc(n3);
        return r2(i3, function(r3) {
          var e4 = t3[r3];
          n3[r3] = e4, f3 && (n3.prototype[r3] = function() {
            var t4 = this.__chain__;
            if (o2 || t4) {
              var r4 = n3(this.__wrapped__);
              return (r4.__actions__ = Tu(this.__actions__)).push({ func: e4, args: arguments, thisArg: n3 }), r4.__chain__ = t4, r4;
            }
            return e4.apply(n3, a6([this.value()], arguments));
          });
        }), n3;
      }
      function $a() {
        return re2._ === this && (re2._ = Al), this;
      }
      function Da() {
      }
      function Ma(n3) {
        return n3 = kc(n3), uu(function(t3) {
          return Ge2(t3, n3);
        });
      }
      function Fa(n3) {
        return Bi(n3) ? m2(no(n3)) : Qe(n3);
      }
      function Na(n3) {
        return function(t3) {
          return n3 == null ? X2 : _e3(n3, t3);
        };
      }
      function Pa() {
        return [];
      }
      function qa() {
        return false;
      }
      function Za() {
        return {};
      }
      function Ka() {
        return "";
      }
      function Va() {
        return true;
      }
      function Ga(n3, t3) {
        if (n3 = kc(n3), n3 < 1 || n3 > Wn)
          return [];
        var r3 = Un, e3 = Hl(n3, Un);
        t3 = mi(t3), n3 -= Un;
        for (var u3 = O(e3, t3); ++r3 < n3; )
          t3(r3);
        return u3;
      }
      function Ha(n3) {
        return bh(n3) ? c2(n3, no) : bc(n3) ? [n3] : Tu(Cs(Ec(n3)));
      }
      function Ja(n3) {
        var t3 = ++wl;
        return Ec(n3) + t3;
      }
      function Ya(n3) {
        return n3 && n3.length ? Yr2(n3, La, me2) : X2;
      }
      function Qa(n3, t3) {
        return n3 && n3.length ? Yr2(n3, mi(t3, 2), me2) : X2;
      }
      function Xa(n3) {
        return w2(n3, La);
      }
      function nl(n3, t3) {
        return w2(n3, mi(t3, 2));
      }
      function tl(n3) {
        return n3 && n3.length ? Yr2(n3, La, Ne2) : X2;
      }
      function rl(n3, t3) {
        return n3 && n3.length ? Yr2(n3, mi(t3, 2), Ne2) : X2;
      }
      function el(n3) {
        return n3 && n3.length ? k3(n3, La) : 0;
      }
      function ul(n3, t3) {
        return n3 && n3.length ? k3(n3, mi(t3, 2)) : 0;
      }
      x3 = x3 == null ? re2 : be2.defaults(re2.Object(), x3, be2.pick(re2, qr2));
      var il = x3.Array, ol = x3.Date, fl = x3.Error, cl = x3.Function, al = x3.Math, ll = x3.Object, sl = x3.RegExp, hl = x3.String, pl = x3.TypeError, _l = il.prototype, vl = cl.prototype, gl = ll.prototype, yl = x3["__core-js_shared__"], dl = vl.toString, bl = gl.hasOwnProperty, wl = 0, ml = function() {
        var n3 = /[^.]+$/.exec(yl && yl.keys && yl.keys.IE_PROTO || "");
        return n3 ? "Symbol(src)_1." + n3 : "";
      }(), xl = gl.toString, jl = dl.call(ll), Al = re2._, kl = sl("^" + dl.call(bl).replace(St, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ol = ie2 ? x3.Buffer : X2, Il = x3.Symbol, Rl = x3.Uint8Array, zl = Ol ? Ol.allocUnsafe : X2, El = F2(ll.getPrototypeOf, ll), Sl = ll.create, Wl = gl.propertyIsEnumerable, Ll = _l.splice, Cl = Il ? Il.isConcatSpreadable : X2, Ul = Il ? Il.iterator : X2, Bl = Il ? Il.toStringTag : X2, Tl = function() {
        try {
          var n3 = Ai(ll, "defineProperty");
          return n3({}, "", {}), n3;
        } catch (n4) {
        }
      }(), $l = x3.clearTimeout !== re2.clearTimeout && x3.clearTimeout, Dl = ol && ol.now !== re2.Date.now && ol.now, Ml = x3.setTimeout !== re2.setTimeout && x3.setTimeout, Fl = al.ceil, Nl = al.floor, Pl = ll.getOwnPropertySymbols, ql = Ol ? Ol.isBuffer : X2, Zl = x3.isFinite, Kl = _l.join, Vl = F2(ll.keys, ll), Gl = al.max, Hl = al.min, Jl = ol.now, Yl = x3.parseInt, Ql = al.random, Xl = _l.reverse, ns = Ai(x3, "DataView"), ts = Ai(x3, "Map"), rs = Ai(x3, "Promise"), es2 = Ai(x3, "Set"), us = Ai(x3, "WeakMap"), is = Ai(ll, "create"), os = us && new us(), fs = {}, cs = to(ns), as = to(ts), ls = to(rs), ss = to(es2), hs = to(us), ps = Il ? Il.prototype : X2, _s = ps ? ps.valueOf : X2, vs = ps ? ps.toString : X2, gs = function() {
        function n3() {
        }
        return function(t3) {
          if (!fc(t3))
            return {};
          if (Sl)
            return Sl(t3);
          n3.prototype = t3;
          var r3 = new n3();
          return n3.prototype = X2, r3;
        };
      }();
      Z3.templateSettings = { escape: kt, evaluate: Ot, interpolate: It, variable: "", imports: { _: Z3 } }, Z3.prototype = J3.prototype, Z3.prototype.constructor = Z3, Y3.prototype = gs(J3.prototype), Y3.prototype.constructor = Y3, Ct2.prototype = gs(J3.prototype), Ct2.prototype.constructor = Ct2, Xt2.prototype.clear = nr2, Xt2.prototype.delete = tr2, Xt2.prototype.get = rr2, Xt2.prototype.has = er2, Xt2.prototype.set = ur2, ir2.prototype.clear = or3, ir2.prototype.delete = fr2, ir2.prototype.get = cr2, ir2.prototype.has = ar2, ir2.prototype.set = lr2, sr3.prototype.clear = hr2, sr3.prototype.delete = pr2, sr3.prototype.get = _r2, sr3.prototype.has = vr2, sr3.prototype.set = gr2, yr2.prototype.add = yr2.prototype.push = dr2, yr2.prototype.has = br2, wr2.prototype.clear = mr2, wr2.prototype.delete = xr2, wr2.prototype.get = jr2, wr2.prototype.has = Ar2, wr2.prototype.set = kr2;
      var ys = Pu(ue3), ds = Pu(oe3, true), bs = qu(), ws = qu(true), ms = os ? function(n3, t3) {
        return os.set(n3, t3), n3;
      } : La, xs = Tl ? function(n3, t3) {
        return Tl(n3, "toString", {
          configurable: true,
          enumerable: false,
          value: Sa(t3),
          writable: true
        });
      } : La, js = uu, As = $l || function(n3) {
        return re2.clearTimeout(n3);
      }, ks = es2 && 1 / P2(new es2([, -0]))[1] == Sn ? function(n3) {
        return new es2(n3);
      } : Da, Os = os ? function(n3) {
        return os.get(n3);
      } : Da, Is = Pl ? function(n3) {
        return n3 == null ? [] : (n3 = ll(n3), i2(Pl(n3), function(t3) {
          return Wl.call(n3, t3);
        }));
      } : Pa, Rs = Pl ? function(n3) {
        for (var t3 = []; n3; )
          a6(t3, Is(n3)), n3 = El(n3);
        return t3;
      } : Pa, zs = we2;
      (ns && zs(new ns(new ArrayBuffer(1))) != ct || ts && zs(new ts()) != Gn || rs && zs(rs.resolve()) != Qn || es2 && zs(new es2()) != tt || us && zs(new us()) != it) && (zs = function(n3) {
        var t3 = we2(n3), r3 = t3 == Yn ? n3.constructor : X2, e3 = r3 ? to(r3) : "";
        if (e3)
          switch (e3) {
            case cs:
              return ct;
            case as:
              return Gn;
            case ls:
              return Qn;
            case ss:
              return tt;
            case hs:
              return it;
          }
        return t3;
      });
      var Es = yl ? uc : qa, Ss = Qi(ms), Ws = Ml || function(n3, t3) {
        return re2.setTimeout(n3, t3);
      }, Ls = Qi(xs), Cs = Pi(function(n3) {
        var t3 = [];
        return n3.charCodeAt(0) === 46 && t3.push(""), n3.replace(Et, function(n4, r3, e3, u3) {
          t3.push(e3 ? u3.replace(Mt, "$1") : r3 || n4);
        }), t3;
      }), Us = uu(function(n3, t3) {
        return Jf(n3) ? Hr2(n3, ee3(t3, 1, Jf, true)) : [];
      }), Bs = uu(function(n3, t3) {
        var r3 = jo(t3);
        return Jf(r3) && (r3 = X2), Jf(n3) ? Hr2(n3, ee3(t3, 1, Jf, true), mi(r3, 2)) : [];
      }), Ts = uu(function(n3, t3) {
        var r3 = jo(t3);
        return Jf(r3) && (r3 = X2), Jf(n3) ? Hr2(n3, ee3(t3, 1, Jf, true), X2, r3) : [];
      }), $s = uu(function(n3) {
        var t3 = c2(n3, ju);
        return t3.length && t3[0] === n3[0] ? ke2(t3) : [];
      }), Ds = uu(function(n3) {
        var t3 = jo(n3), r3 = c2(n3, ju);
        return t3 === jo(r3) ? t3 = X2 : r3.pop(), r3.length && r3[0] === n3[0] ? ke2(r3, mi(t3, 2)) : [];
      }), Ms = uu(function(n3) {
        var t3 = jo(n3), r3 = c2(n3, ju);
        return t3 = typeof t3 == "function" ? t3 : X2, t3 && r3.pop(), r3.length && r3[0] === n3[0] ? ke2(r3, X2, t3) : [];
      }), Fs = uu(Oo), Ns = gi(function(n3, t3) {
        var r3 = n3 == null ? 0 : n3.length, e3 = Tr2(n3, t3);
        return nu(n3, c2(t3, function(n4) {
          return Ci(n4, r3) ? +n4 : n4;
        }).sort(Lu)), e3;
      }), Ps = uu(function(n3) {
        return gu(ee3(n3, 1, Jf, true));
      }), qs = uu(function(n3) {
        var t3 = jo(n3);
        return Jf(t3) && (t3 = X2), gu(ee3(n3, 1, Jf, true), mi(t3, 2));
      }), Zs = uu(function(n3) {
        var t3 = jo(n3);
        return t3 = typeof t3 == "function" ? t3 : X2, gu(ee3(n3, 1, Jf, true), X2, t3);
      }), Ks = uu(function(n3, t3) {
        return Jf(n3) ? Hr2(n3, t3) : [];
      }), Vs = uu(function(n3) {
        return mu(i2(n3, Jf));
      }), Gs = uu(function(n3) {
        var t3 = jo(n3);
        return Jf(t3) && (t3 = X2), mu(i2(n3, Jf), mi(t3, 2));
      }), Hs = uu(function(n3) {
        var t3 = jo(n3);
        return t3 = typeof t3 == "function" ? t3 : X2, mu(i2(n3, Jf), X2, t3);
      }), Js = uu(Go), Ys = uu(function(n3) {
        var t3 = n3.length, r3 = t3 > 1 ? n3[t3 - 1] : X2;
        return r3 = typeof r3 == "function" ? (n3.pop(), r3) : X2, Ho(n3, r3);
      }), Qs = gi(function(n3) {
        var t3 = n3.length, r3 = t3 ? n3[0] : 0, e3 = this.__wrapped__, u3 = function(t4) {
          return Tr2(t4, n3);
        };
        return !(t3 > 1 || this.__actions__.length) && e3 instanceof Ct2 && Ci(r3) ? (e3 = e3.slice(r3, +r3 + (t3 ? 1 : 0)), e3.__actions__.push({ func: nf, args: [u3], thisArg: X2 }), new Y3(e3, this.__chain__).thru(function(n4) {
          return t3 && !n4.length && n4.push(X2), n4;
        })) : this.thru(u3);
      }), Xs = Fu(function(n3, t3, r3) {
        bl.call(n3, r3) ? ++n3[r3] : Br2(n3, r3, 1);
      }), nh = Ju(ho), th = Ju(po), rh = Fu(function(n3, t3, r3) {
        bl.call(n3, r3) ? n3[r3].push(t3) : Br2(n3, r3, [t3]);
      }), eh = uu(function(t3, r3, e3) {
        var u3 = -1, i3 = typeof r3 == "function", o2 = Hf(t3) ? il(t3.length) : [];
        return ys(t3, function(t4) {
          o2[++u3] = i3 ? n2(r3, t4, e3) : Ie(t4, r3, e3);
        }), o2;
      }), uh = Fu(function(n3, t3, r3) {
        Br2(n3, r3, t3);
      }), ih = Fu(function(n3, t3, r3) {
        n3[r3 ? 0 : 1].push(t3);
      }, function() {
        return [[], []];
      }), oh = uu(function(n3, t3) {
        if (n3 == null)
          return [];
        var r3 = t3.length;
        return r3 > 1 && Ui(n3, t3[0], t3[1]) ? t3 = [] : r3 > 2 && Ui(t3[0], t3[1], t3[2]) && (t3 = [t3[0]]), He2(n3, ee3(t3, 1), []);
      }), fh = Dl || function() {
        return re2.Date.now();
      }, ch = uu(function(n3, t3, r3) {
        var e3 = _n;
        if (r3.length) {
          var u3 = N2(r3, wi(ch));
          e3 |= bn;
        }
        return ai(n3, e3, t3, r3, u3);
      }), ah = uu(function(n3, t3, r3) {
        var e3 = _n | vn;
        if (r3.length) {
          var u3 = N2(r3, wi(ah));
          e3 |= bn;
        }
        return ai(t3, e3, n3, r3, u3);
      }), lh = uu(function(n3, t3) {
        return Gr2(n3, 1, t3);
      }), sh = uu(function(n3, t3, r3) {
        return Gr2(n3, Ic(t3) || 0, r3);
      });
      Cf.Cache = sr3;
      var hh = js(function(t3, r3) {
        r3 = r3.length == 1 && bh(r3[0]) ? c2(r3[0], z2(mi())) : c2(ee3(r3, 1), z2(mi()));
        var e3 = r3.length;
        return uu(function(u3) {
          for (var i3 = -1, o2 = Hl(u3.length, e3); ++i3 < o2; )
            u3[i3] = r3[i3].call(this, u3[i3]);
          return n2(t3, this, u3);
        });
      }), ph = uu(function(n3, t3) {
        return ai(n3, bn, X2, t3, N2(t3, wi(ph)));
      }), _h = uu(function(n3, t3) {
        return ai(n3, wn, X2, t3, N2(t3, wi(_h)));
      }), vh2 = gi(function(n3, t3) {
        return ai(n3, xn, X2, X2, X2, t3);
      }), gh = ii(me2), yh = ii(function(n3, t3) {
        return n3 >= t3;
      }), dh = Re2(function() {
        return arguments;
      }()) ? Re2 : function(n3) {
        return cc2(n3) && bl.call(n3, "callee") && !Wl.call(n3, "callee");
      }, bh = il.isArray, wh = ce2 ? z2(ce2) : ze2, mh = ql || qa, xh = ae2 ? z2(ae2) : Ee2, jh = le ? z2(le) : Le, Ah = se2 ? z2(se2) : Be2, kh = he2 ? z2(he2) : Te2, Oh = pe2 ? z2(pe2) : $e, Ih = ii(Ne2), Rh = ii(function(n3, t3) {
        return n3 <= t3;
      }), zh = Nu(function(n3, t3) {
        if (Mi(t3) || Hf(t3))
          return $u(t3, Pc(t3), n3), X2;
        for (var r3 in t3)
          bl.call(t3, r3) && Sr2(n3, r3, t3[r3]);
      }), Eh = Nu(function(n3, t3) {
        $u(t3, qc(t3), n3);
      }), Sh = Nu(function(n3, t3, r3, e3) {
        $u(t3, qc(t3), n3, e3);
      }), Wh = Nu(function(n3, t3, r3, e3) {
        $u(t3, Pc(t3), n3, e3);
      }), Lh = gi(Tr2), Ch = uu(function(n3, t3) {
        n3 = ll(n3);
        var r3 = -1, e3 = t3.length, u3 = e3 > 2 ? t3[2] : X2;
        for (u3 && Ui(t3[0], t3[1], u3) && (e3 = 1); ++r3 < e3; )
          for (var i3 = t3[r3], o2 = qc(i3), f3 = -1, c3 = o2.length; ++f3 < c3; ) {
            var a7 = o2[f3], l3 = n3[a7];
            (l3 === X2 || Gf(l3, gl[a7]) && !bl.call(n3, a7)) && (n3[a7] = i3[a7]);
          }
        return n3;
      }), Uh = uu(function(t3) {
        return t3.push(X2, si), n2(Mh, X2, t3);
      }), Bh = Xu(function(n3, t3, r3) {
        t3 != null && typeof t3.toString != "function" && (t3 = xl.call(t3)), n3[t3] = r3;
      }, Sa(La)), Th = Xu(function(n3, t3, r3) {
        t3 != null && typeof t3.toString != "function" && (t3 = xl.call(t3)), bl.call(n3, t3) ? n3[t3].push(r3) : n3[t3] = [r3];
      }, mi), $h = uu(Ie), Dh = Nu(function(n3, t3, r3) {
        Ke(n3, t3, r3);
      }), Mh = Nu(function(n3, t3, r3, e3) {
        Ke(n3, t3, r3, e3);
      }), Fh = gi(function(n3, t3) {
        var r3 = {};
        if (n3 == null)
          return r3;
        var e3 = false;
        t3 = c2(t3, function(t4) {
          return t4 = ku(t4, n3), e3 || (e3 = t4.length > 1), t4;
        }), $u(n3, di(n3), r3), e3 && (r3 = Fr2(r3, an | ln | sn, hi));
        for (var u3 = t3.length; u3--; )
          yu(r3, t3[u3]);
        return r3;
      }), Nh = gi(function(n3, t3) {
        return n3 == null ? {} : Je(n3, t3);
      }), Ph = ci(Pc), qh = ci(qc), Zh = Vu(function(n3, t3, r3) {
        return t3 = t3.toLowerCase(), n3 + (r3 ? fa(t3) : t3);
      }), Kh = Vu(function(n3, t3, r3) {
        return n3 + (r3 ? "-" : "") + t3.toLowerCase();
      }), Vh = Vu(function(n3, t3, r3) {
        return n3 + (r3 ? " " : "") + t3.toLowerCase();
      }), Gh = Ku("toLowerCase"), Hh = Vu(function(n3, t3, r3) {
        return n3 + (r3 ? "_" : "") + t3.toLowerCase();
      }), Jh = Vu(function(n3, t3, r3) {
        return n3 + (r3 ? " " : "") + Qh(t3);
      }), Yh = Vu(function(n3, t3, r3) {
        return n3 + (r3 ? " " : "") + t3.toUpperCase();
      }), Qh = Ku("toUpperCase"), Xh = uu(function(t3, r3) {
        try {
          return n2(t3, X2, r3);
        } catch (n3) {
          return rc(n3) ? n3 : new fl(n3);
        }
      }), np = gi(function(n3, t3) {
        return r2(t3, function(t4) {
          t4 = no(t4), Br2(n3, t4, ch(n3[t4], n3));
        }), n3;
      }), tp = Yu(), rp = Yu(true), ep = uu(function(n3, t3) {
        return function(r3) {
          return Ie(r3, n3, t3);
        };
      }), up = uu(function(n3, t3) {
        return function(r3) {
          return Ie(n3, r3, t3);
        };
      }), ip = ti(c2), op2 = ti(u2), fp2 = ti(h2), cp = ui(), ap = ui(true), lp = ni(function(n3, t3) {
        return n3 + t3;
      }, 0), sp = fi("ceil"), hp = ni(function(n3, t3) {
        return n3 / t3;
      }, 1), pp = fi("floor"), _p = ni(function(n3, t3) {
        return n3 * t3;
      }, 1), vp = fi("round"), gp = ni(function(n3, t3) {
        return n3 - t3;
      }, 0);
      return Z3.after = If, Z3.ary = Rf, Z3.assign = zh, Z3.assignIn = Eh, Z3.assignInWith = Sh, Z3.assignWith = Wh, Z3.at = Lh, Z3.before = zf, Z3.bind = ch, Z3.bindAll = np, Z3.bindKey = ah, Z3.castArray = Nf, Z3.chain = Qo, Z3.chunk = uo, Z3.compact = io, Z3.concat = oo, Z3.cond = za, Z3.conforms = Ea, Z3.constant = Sa, Z3.countBy = Xs, Z3.create = Sc, Z3.curry = Ef, Z3.curryRight = Sf, Z3.debounce = Wf, Z3.defaults = Ch, Z3.defaultsDeep = Uh, Z3.defer = lh, Z3.delay = sh, Z3.difference = Us, Z3.differenceBy = Bs, Z3.differenceWith = Ts, Z3.drop = fo, Z3.dropRight = co, Z3.dropRightWhile = ao, Z3.dropWhile = lo, Z3.fill = so, Z3.filter = lf, Z3.flatMap = sf, Z3.flatMapDeep = hf, Z3.flatMapDepth = pf, Z3.flatten = _o, Z3.flattenDeep = vo, Z3.flattenDepth = go, Z3.flip = Lf, Z3.flow = tp, Z3.flowRight = rp, Z3.fromPairs = yo, Z3.functions = $c, Z3.functionsIn = Dc, Z3.groupBy = rh, Z3.initial = mo, Z3.intersection = $s, Z3.intersectionBy = Ds, Z3.intersectionWith = Ms, Z3.invert = Bh, Z3.invertBy = Th, Z3.invokeMap = eh, Z3.iteratee = Ca, Z3.keyBy = uh, Z3.keys = Pc, Z3.keysIn = qc, Z3.map = yf, Z3.mapKeys = Zc, Z3.mapValues = Kc, Z3.matches = Ua, Z3.matchesProperty = Ba, Z3.memoize = Cf, Z3.merge = Dh, Z3.mergeWith = Mh, Z3.method = ep, Z3.methodOf = up, Z3.mixin = Ta, Z3.negate = Uf, Z3.nthArg = Ma, Z3.omit = Fh, Z3.omitBy = Vc, Z3.once = Bf, Z3.orderBy = df, Z3.over = ip, Z3.overArgs = hh, Z3.overEvery = op2, Z3.overSome = fp2, Z3.partial = ph, Z3.partialRight = _h, Z3.partition = ih, Z3.pick = Nh, Z3.pickBy = Gc, Z3.property = Fa, Z3.propertyOf = Na, Z3.pull = Fs, Z3.pullAll = Oo, Z3.pullAllBy = Io, Z3.pullAllWith = Ro, Z3.pullAt = Ns, Z3.range = cp, Z3.rangeRight = ap, Z3.rearg = vh2, Z3.reject = mf, Z3.remove = zo, Z3.rest = Tf, Z3.reverse = Eo, Z3.sampleSize = jf, Z3.set = Jc, Z3.setWith = Yc, Z3.shuffle = Af, Z3.slice = So, Z3.sortBy = oh, Z3.sortedUniq = $o, Z3.sortedUniqBy = Do, Z3.split = da, Z3.spread = $f, Z3.tail = Mo, Z3.take = Fo, Z3.takeRight = No, Z3.takeRightWhile = Po, Z3.takeWhile = qo, Z3.tap = Xo, Z3.throttle = Df, Z3.thru = nf, Z3.toArray = jc, Z3.toPairs = Ph, Z3.toPairsIn = qh, Z3.toPath = Ha, Z3.toPlainObject = Rc, Z3.transform = Qc, Z3.unary = Mf, Z3.union = Ps, Z3.unionBy = qs, Z3.unionWith = Zs, Z3.uniq = Zo, Z3.uniqBy = Ko, Z3.uniqWith = Vo, Z3.unset = Xc, Z3.unzip = Go, Z3.unzipWith = Ho, Z3.update = na, Z3.updateWith = ta, Z3.values = ra, Z3.valuesIn = ea, Z3.without = Ks, Z3.words = Ra, Z3.wrap = Ff, Z3.xor = Vs, Z3.xorBy = Gs, Z3.xorWith = Hs, Z3.zip = Js, Z3.zipObject = Jo, Z3.zipObjectDeep = Yo, Z3.zipWith = Ys, Z3.entries = Ph, Z3.entriesIn = qh, Z3.extend = Eh, Z3.extendWith = Sh, Ta(Z3, Z3), Z3.add = lp, Z3.attempt = Xh, Z3.camelCase = Zh, Z3.capitalize = fa, Z3.ceil = sp, Z3.clamp = ua, Z3.clone = Pf, Z3.cloneDeep = Zf, Z3.cloneDeepWith = Kf, Z3.cloneWith = qf, Z3.conformsTo = Vf, Z3.deburr = ca2, Z3.defaultTo = Wa, Z3.divide = hp, Z3.endsWith = aa, Z3.eq = Gf, Z3.escape = la, Z3.escapeRegExp = sa, Z3.every = af, Z3.find = nh, Z3.findIndex = ho, Z3.findKey = Wc, Z3.findLast = th, Z3.findLastIndex = po, Z3.findLastKey = Lc, Z3.floor = pp, Z3.forEach = _f, Z3.forEachRight = vf, Z3.forIn = Cc, Z3.forInRight = Uc, Z3.forOwn = Bc, Z3.forOwnRight = Tc, Z3.get = Mc, Z3.gt = gh, Z3.gte = yh, Z3.has = Fc, Z3.hasIn = Nc, Z3.head = bo, Z3.identity = La, Z3.includes = gf, Z3.indexOf = wo, Z3.inRange = ia, Z3.invoke = $h, Z3.isArguments = dh, Z3.isArray = bh, Z3.isArrayBuffer = wh, Z3.isArrayLike = Hf, Z3.isArrayLikeObject = Jf, Z3.isBoolean = Yf, Z3.isBuffer = mh, Z3.isDate = xh, Z3.isElement = Qf, Z3.isEmpty = Xf, Z3.isEqual = nc, Z3.isEqualWith = tc, Z3.isError = rc, Z3.isFinite = ec, Z3.isFunction = uc, Z3.isInteger = ic, Z3.isLength = oc, Z3.isMap = jh, Z3.isMatch = ac, Z3.isMatchWith = lc, Z3.isNaN = sc, Z3.isNative = hc, Z3.isNil = _c, Z3.isNull = pc, Z3.isNumber = vc, Z3.isObject = fc, Z3.isObjectLike = cc2, Z3.isPlainObject = gc, Z3.isRegExp = Ah, Z3.isSafeInteger = yc, Z3.isSet = kh, Z3.isString = dc, Z3.isSymbol = bc, Z3.isTypedArray = Oh, Z3.isUndefined = wc, Z3.isWeakMap = mc, Z3.isWeakSet = xc, Z3.join = xo, Z3.kebabCase = Kh, Z3.last = jo, Z3.lastIndexOf = Ao, Z3.lowerCase = Vh, Z3.lowerFirst = Gh, Z3.lt = Ih, Z3.lte = Rh, Z3.max = Ya, Z3.maxBy = Qa, Z3.mean = Xa, Z3.meanBy = nl, Z3.min = tl, Z3.minBy = rl, Z3.stubArray = Pa, Z3.stubFalse = qa, Z3.stubObject = Za, Z3.stubString = Ka, Z3.stubTrue = Va, Z3.multiply = _p, Z3.nth = ko, Z3.noConflict = $a, Z3.noop = Da, Z3.now = fh, Z3.pad = ha, Z3.padEnd = pa, Z3.padStart = _a, Z3.parseInt = va, Z3.random = oa, Z3.reduce = bf, Z3.reduceRight = wf, Z3.repeat = ga, Z3.replace = ya, Z3.result = Hc, Z3.round = vp, Z3.runInContext = p3, Z3.sample = xf, Z3.size = kf, Z3.snakeCase = Hh, Z3.some = Of, Z3.sortedIndex = Wo, Z3.sortedIndexBy = Lo, Z3.sortedIndexOf = Co, Z3.sortedLastIndex = Uo, Z3.sortedLastIndexBy = Bo, Z3.sortedLastIndexOf = To, Z3.startCase = Jh, Z3.startsWith = ba, Z3.subtract = gp, Z3.sum = el, Z3.sumBy = ul, Z3.template = wa, Z3.times = Ga, Z3.toFinite = Ac, Z3.toInteger = kc, Z3.toLength = Oc, Z3.toLower = ma, Z3.toNumber = Ic, Z3.toSafeInteger = zc, Z3.toString = Ec, Z3.toUpper = xa, Z3.trim = ja, Z3.trimEnd = Aa, Z3.trimStart = ka, Z3.truncate = Oa, Z3.unescape = Ia, Z3.uniqueId = Ja, Z3.upperCase = Yh, Z3.upperFirst = Qh, Z3.each = _f, Z3.eachRight = vf, Z3.first = bo, Ta(Z3, function() {
        var n3 = {};
        return ue3(Z3, function(t3, r3) {
          bl.call(Z3.prototype, r3) || (n3[r3] = t3);
        }), n3;
      }(), { chain: false }), Z3.VERSION = nn, r2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n3) {
        Z3[n3].placeholder = Z3;
      }), r2(["drop", "take"], function(n3, t3) {
        Ct2.prototype[n3] = function(r3) {
          r3 = r3 === X2 ? 1 : Gl(kc(r3), 0);
          var e3 = this.__filtered__ && !t3 ? new Ct2(this) : this.clone();
          return e3.__filtered__ ? e3.__takeCount__ = Hl(r3, e3.__takeCount__) : e3.__views__.push({ size: Hl(r3, Un), type: n3 + (e3.__dir__ < 0 ? "Right" : "") }), e3;
        }, Ct2.prototype[n3 + "Right"] = function(t4) {
          return this.reverse()[n3](t4).reverse();
        };
      }), r2(["filter", "map", "takeWhile"], function(n3, t3) {
        var r3 = t3 + 1, e3 = r3 == Rn || r3 == En;
        Ct2.prototype[n3] = function(n4) {
          var t4 = this.clone();
          return t4.__iteratees__.push({ iteratee: mi(n4, 3), type: r3 }), t4.__filtered__ = t4.__filtered__ || e3, t4;
        };
      }), r2(["head", "last"], function(n3, t3) {
        var r3 = "take" + (t3 ? "Right" : "");
        Ct2.prototype[n3] = function() {
          return this[r3](1).value()[0];
        };
      }), r2(["initial", "tail"], function(n3, t3) {
        var r3 = "drop" + (t3 ? "" : "Right");
        Ct2.prototype[n3] = function() {
          return this.__filtered__ ? new Ct2(this) : this[r3](1);
        };
      }), Ct2.prototype.compact = function() {
        return this.filter(La);
      }, Ct2.prototype.find = function(n3) {
        return this.filter(n3).head();
      }, Ct2.prototype.findLast = function(n3) {
        return this.reverse().find(n3);
      }, Ct2.prototype.invokeMap = uu(function(n3, t3) {
        return typeof n3 == "function" ? new Ct2(this) : this.map(function(r3) {
          return Ie(r3, n3, t3);
        });
      }), Ct2.prototype.reject = function(n3) {
        return this.filter(Uf(mi(n3)));
      }, Ct2.prototype.slice = function(n3, t3) {
        n3 = kc(n3);
        var r3 = this;
        return r3.__filtered__ && (n3 > 0 || t3 < 0) ? new Ct2(r3) : (n3 < 0 ? r3 = r3.takeRight(-n3) : n3 && (r3 = r3.drop(n3)), t3 !== X2 && (t3 = kc(t3), r3 = t3 < 0 ? r3.dropRight(-t3) : r3.take(t3 - n3)), r3);
      }, Ct2.prototype.takeRightWhile = function(n3) {
        return this.reverse().takeWhile(n3).reverse();
      }, Ct2.prototype.toArray = function() {
        return this.take(Un);
      }, ue3(Ct2.prototype, function(n3, t3) {
        var r3 = /^(?:filter|find|map|reject)|While$/.test(t3), e3 = /^(?:head|last)$/.test(t3), u3 = Z3[e3 ? "take" + (t3 == "last" ? "Right" : "") : t3], i3 = e3 || /^find/.test(t3);
        u3 && (Z3.prototype[t3] = function() {
          var t4 = this.__wrapped__, o2 = e3 ? [1] : arguments, f3 = t4 instanceof Ct2, c3 = o2[0], l3 = f3 || bh(t4), s3 = function(n4) {
            var t5 = u3.apply(Z3, a6([n4], o2));
            return e3 && h3 ? t5[0] : t5;
          };
          l3 && r3 && typeof c3 == "function" && c3.length != 1 && (f3 = l3 = false);
          var h3 = this.__chain__, p4 = !!this.__actions__.length, _25 = i3 && !h3, v3 = f3 && !p4;
          if (!i3 && l3) {
            t4 = v3 ? t4 : new Ct2(this);
            var g3 = n3.apply(t4, o2);
            return g3.__actions__.push({ func: nf, args: [s3], thisArg: X2 }), new Y3(g3, h3);
          }
          return _25 && v3 ? n3.apply(this, o2) : (g3 = this.thru(s3), _25 ? e3 ? g3.value()[0] : g3.value() : g3);
        });
      }), r2(["pop", "push", "shift", "sort", "splice", "unshift"], function(n3) {
        var t3 = _l[n3], r3 = /^(?:push|sort|unshift)$/.test(n3) ? "tap" : "thru", e3 = /^(?:pop|shift)$/.test(n3);
        Z3.prototype[n3] = function() {
          var n4 = arguments;
          if (e3 && !this.__chain__) {
            var u3 = this.value();
            return t3.apply(bh(u3) ? u3 : [], n4);
          }
          return this[r3](function(r4) {
            return t3.apply(bh(r4) ? r4 : [], n4);
          });
        };
      }), ue3(Ct2.prototype, function(n3, t3) {
        var r3 = Z3[t3];
        if (r3) {
          var e3 = r3.name + "";
          bl.call(fs, e3) || (fs[e3] = []), fs[e3].push({ name: t3, func: r3 });
        }
      }), fs[Qu(X2, vn).name] = [{ name: "wrapper", func: X2 }], Ct2.prototype.clone = $t2, Ct2.prototype.reverse = Yt2, Ct2.prototype.value = Qt2, Z3.prototype.at = Qs, Z3.prototype.chain = tf, Z3.prototype.commit = rf, Z3.prototype.next = ef, Z3.prototype.plant = of, Z3.prototype.reverse = ff, Z3.prototype.toJSON = Z3.prototype.valueOf = Z3.prototype.value = cf, Z3.prototype.first = Z3.prototype.head, Ul && (Z3.prototype[Ul] = uf), Z3;
    }, be2 = de2();
    ue2 ? ((ue2.exports = be2)._ = be2, ee2._ = be2) : re2._ = be2;
  }).call(commonjsGlobal);
})(lodash_min, lodash_min.exports);
var _mapping = {};
(function(exports2) {
  exports2.aliasToReal = {
    "each": "forEach",
    "eachRight": "forEachRight",
    "entries": "toPairs",
    "entriesIn": "toPairsIn",
    "extend": "assignIn",
    "extendAll": "assignInAll",
    "extendAllWith": "assignInAllWith",
    "extendWith": "assignInWith",
    "first": "head",
    "conforms": "conformsTo",
    "matches": "isMatch",
    "property": "get",
    "__": "placeholder",
    "F": "stubFalse",
    "T": "stubTrue",
    "all": "every",
    "allPass": "overEvery",
    "always": "constant",
    "any": "some",
    "anyPass": "overSome",
    "apply": "spread",
    "assoc": "set",
    "assocPath": "set",
    "complement": "negate",
    "compose": "flowRight",
    "contains": "includes",
    "dissoc": "unset",
    "dissocPath": "unset",
    "dropLast": "dropRight",
    "dropLastWhile": "dropRightWhile",
    "equals": "isEqual",
    "identical": "eq",
    "indexBy": "keyBy",
    "init": "initial",
    "invertObj": "invert",
    "juxt": "over",
    "omitAll": "omit",
    "nAry": "ary",
    "path": "get",
    "pathEq": "matchesProperty",
    "pathOr": "getOr",
    "paths": "at",
    "pickAll": "pick",
    "pipe": "flow",
    "pluck": "map",
    "prop": "get",
    "propEq": "matchesProperty",
    "propOr": "getOr",
    "props": "at",
    "symmetricDifference": "xor",
    "symmetricDifferenceBy": "xorBy",
    "symmetricDifferenceWith": "xorWith",
    "takeLast": "takeRight",
    "takeLastWhile": "takeRightWhile",
    "unapply": "rest",
    "unnest": "flatten",
    "useWith": "overArgs",
    "where": "conformsTo",
    "whereEq": "isMatch",
    "zipObj": "zipObject"
  };
  exports2.aryMethod = {
    "1": [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    "2": [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    "3": [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    "4": [
      "fill",
      "setWith",
      "updateWith"
    ]
  };
  exports2.aryRearg = {
    "2": [1, 0],
    "3": [2, 0, 1],
    "4": [3, 2, 0, 1]
  };
  exports2.iterateeAry = {
    "dropRightWhile": 1,
    "dropWhile": 1,
    "every": 1,
    "filter": 1,
    "find": 1,
    "findFrom": 1,
    "findIndex": 1,
    "findIndexFrom": 1,
    "findKey": 1,
    "findLast": 1,
    "findLastFrom": 1,
    "findLastIndex": 1,
    "findLastIndexFrom": 1,
    "findLastKey": 1,
    "flatMap": 1,
    "flatMapDeep": 1,
    "flatMapDepth": 1,
    "forEach": 1,
    "forEachRight": 1,
    "forIn": 1,
    "forInRight": 1,
    "forOwn": 1,
    "forOwnRight": 1,
    "map": 1,
    "mapKeys": 1,
    "mapValues": 1,
    "partition": 1,
    "reduce": 2,
    "reduceRight": 2,
    "reject": 1,
    "remove": 1,
    "some": 1,
    "takeRightWhile": 1,
    "takeWhile": 1,
    "times": 1,
    "transform": 2
  };
  exports2.iterateeRearg = {
    "mapKeys": [1],
    "reduceRight": [1, 0]
  };
  exports2.methodRearg = {
    "assignInAllWith": [1, 0],
    "assignInWith": [1, 2, 0],
    "assignAllWith": [1, 0],
    "assignWith": [1, 2, 0],
    "differenceBy": [1, 2, 0],
    "differenceWith": [1, 2, 0],
    "getOr": [2, 1, 0],
    "intersectionBy": [1, 2, 0],
    "intersectionWith": [1, 2, 0],
    "isEqualWith": [1, 2, 0],
    "isMatchWith": [2, 1, 0],
    "mergeAllWith": [1, 0],
    "mergeWith": [1, 2, 0],
    "padChars": [2, 1, 0],
    "padCharsEnd": [2, 1, 0],
    "padCharsStart": [2, 1, 0],
    "pullAllBy": [2, 1, 0],
    "pullAllWith": [2, 1, 0],
    "rangeStep": [1, 2, 0],
    "rangeStepRight": [1, 2, 0],
    "setWith": [3, 1, 2, 0],
    "sortedIndexBy": [2, 1, 0],
    "sortedLastIndexBy": [2, 1, 0],
    "unionBy": [1, 2, 0],
    "unionWith": [1, 2, 0],
    "updateWith": [3, 1, 2, 0],
    "xorBy": [1, 2, 0],
    "xorWith": [1, 2, 0],
    "zipWith": [1, 2, 0]
  };
  exports2.methodSpread = {
    "assignAll": { "start": 0 },
    "assignAllWith": { "start": 0 },
    "assignInAll": { "start": 0 },
    "assignInAllWith": { "start": 0 },
    "defaultsAll": { "start": 0 },
    "defaultsDeepAll": { "start": 0 },
    "invokeArgs": { "start": 2 },
    "invokeArgsMap": { "start": 2 },
    "mergeAll": { "start": 0 },
    "mergeAllWith": { "start": 0 },
    "partial": { "start": 1 },
    "partialRight": { "start": 1 },
    "without": { "start": 1 },
    "zipAll": { "start": 0 }
  };
  exports2.mutate = {
    "array": {
      "fill": true,
      "pull": true,
      "pullAll": true,
      "pullAllBy": true,
      "pullAllWith": true,
      "pullAt": true,
      "remove": true,
      "reverse": true
    },
    "object": {
      "assign": true,
      "assignAll": true,
      "assignAllWith": true,
      "assignIn": true,
      "assignInAll": true,
      "assignInAllWith": true,
      "assignInWith": true,
      "assignWith": true,
      "defaults": true,
      "defaultsAll": true,
      "defaultsDeep": true,
      "defaultsDeepAll": true,
      "merge": true,
      "mergeAll": true,
      "mergeAllWith": true,
      "mergeWith": true
    },
    "set": {
      "set": true,
      "setWith": true,
      "unset": true,
      "update": true,
      "updateWith": true
    }
  };
  exports2.realToAlias = function() {
    var hasOwnProperty2 = Object.prototype.hasOwnProperty, object = exports2.aliasToReal, result2 = {};
    for (var key in object) {
      var value = object[key];
      if (hasOwnProperty2.call(result2, value)) {
        result2[value].push(key);
      } else {
        result2[value] = [key];
      }
    }
    return result2;
  }();
  exports2.remap = {
    "assignAll": "assign",
    "assignAllWith": "assignWith",
    "assignInAll": "assignIn",
    "assignInAllWith": "assignInWith",
    "curryN": "curry",
    "curryRightN": "curryRight",
    "defaultsAll": "defaults",
    "defaultsDeepAll": "defaultsDeep",
    "findFrom": "find",
    "findIndexFrom": "findIndex",
    "findLastFrom": "findLast",
    "findLastIndexFrom": "findLastIndex",
    "getOr": "get",
    "includesFrom": "includes",
    "indexOfFrom": "indexOf",
    "invokeArgs": "invoke",
    "invokeArgsMap": "invokeMap",
    "lastIndexOfFrom": "lastIndexOf",
    "mergeAll": "merge",
    "mergeAllWith": "mergeWith",
    "padChars": "pad",
    "padCharsEnd": "padEnd",
    "padCharsStart": "padStart",
    "propertyOf": "get",
    "rangeStep": "range",
    "rangeStepRight": "rangeRight",
    "restFrom": "rest",
    "spreadFrom": "spread",
    "trimChars": "trim",
    "trimCharsEnd": "trimEnd",
    "trimCharsStart": "trimStart",
    "zipAll": "zip"
  };
  exports2.skipFixed = {
    "castArray": true,
    "flow": true,
    "flowRight": true,
    "iteratee": true,
    "mixin": true,
    "rearg": true,
    "runInContext": true
  };
  exports2.skipRearg = {
    "add": true,
    "assign": true,
    "assignIn": true,
    "bind": true,
    "bindKey": true,
    "concat": true,
    "difference": true,
    "divide": true,
    "eq": true,
    "gt": true,
    "gte": true,
    "isEqual": true,
    "lt": true,
    "lte": true,
    "matchesProperty": true,
    "merge": true,
    "multiply": true,
    "overArgs": true,
    "partial": true,
    "partialRight": true,
    "propertyOf": true,
    "random": true,
    "range": true,
    "rangeRight": true,
    "subtract": true,
    "zip": true,
    "zipObject": true,
    "zipObjectDeep": true
  };
})(_mapping);
var placeholder = {};
var mapping = _mapping, fallbackHolder = placeholder;
var push = Array.prototype.push;
function baseArity(func, n2) {
  return n2 == 2 ? function(a6, b2) {
    return func.apply(void 0, arguments);
  } : function(a6) {
    return func.apply(void 0, arguments);
  };
}
function baseAry(func, n2) {
  return n2 == 2 ? function(a6, b2) {
    return func(a6, b2);
  } : function(a6) {
    return func(a6);
  };
}
function cloneArray(array) {
  var length = array ? array.length : 0, result2 = Array(length);
  while (length--) {
    result2[length] = array[length];
  }
  return result2;
}
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}
function flatSpread(func, start) {
  return function() {
    var length = arguments.length, lastIndex = length - 1, args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start], otherArgs = args.slice(0, start);
    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result2 = args[0] = cloner.apply(void 0, args);
    func.apply(void 0, args);
    return result2;
  };
}
function baseConvert(util2, name, func, options) {
  var isLib = typeof name == "function", isObj = name === Object(name);
  if (isObj) {
    options = func;
    func = name;
    name = void 0;
  }
  if (func == null) {
    throw new TypeError();
  }
  options || (options = {});
  var config2 = {
    "cap": "cap" in options ? options.cap : true,
    "curry": "curry" in options ? options.curry : true,
    "fixed": "fixed" in options ? options.fixed : true,
    "immutable": "immutable" in options ? options.immutable : true,
    "rearg": "rearg" in options ? options.rearg : true
  };
  var defaultHolder = isLib ? func : fallbackHolder, forceCurry = "curry" in options && options.curry, forceFixed = "fixed" in options && options.fixed, forceRearg = "rearg" in options && options.rearg, pristine = isLib ? func.runInContext() : void 0;
  var helpers = isLib ? func : {
    "ary": util2.ary,
    "assign": util2.assign,
    "clone": util2.clone,
    "curry": util2.curry,
    "forEach": util2.forEach,
    "isArray": util2.isArray,
    "isError": util2.isError,
    "isFunction": util2.isFunction,
    "isWeakMap": util2.isWeakMap,
    "iteratee": util2.iteratee,
    "keys": util2.keys,
    "rearg": util2.rearg,
    "toInteger": util2.toInteger,
    "toPath": util2.toPath
  };
  var ary = helpers.ary, assign = helpers.assign, clone2 = helpers.clone, curry = helpers.curry, each2 = helpers.forEach, isArray2 = helpers.isArray, isError = helpers.isError, isFunction2 = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger2 = helpers.toInteger, toPath = helpers.toPath;
  var aryMethodKeys = keys(mapping.aryMethod);
  var wrappers = {
    "castArray": function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray2(value) ? castArray(cloneArray(value)) : castArray.apply(void 0, arguments);
      };
    },
    "iteratee": function(iteratee) {
      return function() {
        var func2 = arguments[0], arity = arguments[1], result2 = iteratee(func2, arity), length = result2.length;
        if (config2.cap && typeof arity == "number") {
          arity = arity > 2 ? arity - 2 : 1;
          return length && length <= arity ? result2 : baseAry(result2, arity);
        }
        return result2;
      };
    },
    "mixin": function(mixin) {
      return function(source2) {
        var func2 = this;
        if (!isFunction2(func2)) {
          return mixin(func2, Object(source2));
        }
        var pairs2 = [];
        each2(keys(source2), function(key) {
          if (isFunction2(source2[key])) {
            pairs2.push([key, func2.prototype[key]]);
          }
        });
        mixin(func2, Object(source2));
        each2(pairs2, function(pair) {
          var value = pair[1];
          if (isFunction2(value)) {
            func2.prototype[pair[0]] = value;
          } else {
            delete func2.prototype[pair[0]];
          }
        });
        return func2;
      };
    },
    "nthArg": function(nthArg) {
      return function(n2) {
        var arity = n2 < 0 ? 1 : toInteger2(n2) + 1;
        return curry(nthArg(n2), arity);
      };
    },
    "rearg": function(rearg2) {
      return function(func2, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg2(func2, indexes), arity);
      };
    },
    "runInContext": function(runInContext) {
      return function(context2) {
        return baseConvert(util2, runInContext(context2), options);
      };
    }
  };
  function castCap(name2, func2) {
    if (config2.cap) {
      var indexes = mapping.iterateeRearg[name2];
      if (indexes) {
        return iterateeRearg(func2, indexes);
      }
      var n2 = !isLib && mapping.iterateeAry[name2];
      if (n2) {
        return iterateeAry(func2, n2);
      }
    }
    return func2;
  }
  function castCurry(name2, func2, n2) {
    return forceCurry || config2.curry && n2 > 1 ? curry(func2, n2) : func2;
  }
  function castFixed(name2, func2, n2) {
    if (config2.fixed && (forceFixed || !mapping.skipFixed[name2])) {
      var data2 = mapping.methodSpread[name2], start = data2 && data2.start;
      return start === void 0 ? ary(func2, n2) : flatSpread(func2, start);
    }
    return func2;
  }
  function castRearg(name2, func2, n2) {
    return config2.rearg && n2 > 1 && (forceRearg || !mapping.skipRearg[name2]) ? rearg(func2, mapping.methodRearg[name2] || mapping.aryRearg[n2]) : func2;
  }
  function cloneByPath(object, path2) {
    path2 = toPath(path2);
    var index2 = -1, length = path2.length, lastIndex = length - 1, result2 = clone2(Object(object)), nested = result2;
    while (nested != null && ++index2 < length) {
      var key = path2[index2], value = nested[key];
      if (value != null && !(isFunction2(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone2(index2 == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result2;
  }
  function convertLib(options2) {
    return _24.runInContext.convert(options2)(void 0);
  }
  function createConverter(name2, func2) {
    var realName = mapping.aliasToReal[name2] || name2, methodName = mapping.remap[realName] || realName, oldOptions = options;
    return function(options2) {
      var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func2, newOptions = assign(assign({}, oldOptions), options2);
      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }
  function iterateeAry(func2, n2) {
    return overArg(func2, function(func3) {
      return typeof func3 == "function" ? baseAry(func3, n2) : func3;
    });
  }
  function iterateeRearg(func2, indexes) {
    return overArg(func2, function(func3) {
      var n2 = indexes.length;
      return baseArity(rearg(baseAry(func3, n2), indexes), n2);
    });
  }
  function overArg(func2, transform2) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func2();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index2 = config2.rearg ? 0 : length - 1;
      args[index2] = transform2(args[index2]);
      return func2.apply(void 0, args);
    };
  }
  function wrap(name2, func2, placeholder2) {
    var result2, realName = mapping.aliasToReal[name2] || name2, wrapped = func2, wrapper = wrappers[realName];
    if (wrapper) {
      wrapped = wrapper(func2);
    } else if (config2.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func2, cloneArray);
      } else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func2, createCloner(func2));
      } else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func2, cloneByPath);
      }
    }
    each2(aryMethodKeys, function(aryKey) {
      each2(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data2 = mapping.methodSpread[realName], afterRearg = data2 && data2.afterRearg;
          result2 = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
          result2 = castCap(realName, result2);
          result2 = castCurry(realName, result2, aryKey);
          return false;
        }
      });
      return !result2;
    });
    result2 || (result2 = wrapped);
    if (result2 == func2) {
      result2 = forceCurry ? curry(result2, 1) : function() {
        return func2.apply(this, arguments);
      };
    }
    result2.convert = createConverter(realName, func2);
    result2.placeholder = func2.placeholder = placeholder2;
    return result2;
  }
  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _24 = func;
  var pairs = [];
  each2(aryMethodKeys, function(aryKey) {
    each2(mapping.aryMethod[aryKey], function(key) {
      var func2 = _24[mapping.remap[key] || key];
      if (func2) {
        pairs.push([key, wrap(key, func2, _24)]);
      }
    });
  });
  each2(keys(_24), function(key) {
    var func2 = _24[key];
    if (typeof func2 == "function") {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func2.convert = createConverter(key, func2);
      pairs.push([key, func2]);
    }
  });
  each2(pairs, function(pair) {
    _24[pair[0]] = pair[1];
  });
  _24.convert = convertLib;
  _24.placeholder = _24;
  each2(keys(_24), function(key) {
    each2(mapping.realToAlias[key] || [], function(alias) {
      _24[alias] = _24[key];
    });
  });
  return _24;
}
var _baseConvert = baseConvert;
var _ = lodash_min.exports.runInContext();
var fp = _baseConvert(_, _);
var rngBrowser = { exports: {} };
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
  var rnds8 = new Uint8Array(16);
  rngBrowser.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  var rnds = new Array(16);
  rngBrowser.exports = function mathRNG() {
    for (var i2 = 0, r2; i2 < 16; i2++) {
      if ((i2 & 3) === 0)
        r2 = Math.random() * 4294967296;
      rnds[i2] = r2 >>> ((i2 & 3) << 3) & 255;
    }
    return rnds;
  };
}
var byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1) {
  byteToHex[i$1] = (i$1 + 256).toString(16).substr(1);
}
function bytesToUuid$2(buf, offset) {
  var i2 = offset || 0;
  var bth = byteToHex;
  return [
    bth[buf[i2++]],
    bth[buf[i2++]],
    bth[buf[i2++]],
    bth[buf[i2++]],
    "-",
    bth[buf[i2++]],
    bth[buf[i2++]],
    "-",
    bth[buf[i2++]],
    bth[buf[i2++]],
    "-",
    bth[buf[i2++]],
    bth[buf[i2++]],
    "-",
    bth[buf[i2++]],
    bth[buf[i2++]],
    bth[buf[i2++]],
    bth[buf[i2++]],
    bth[buf[i2++]],
    bth[buf[i2++]]
  ].join("");
}
var bytesToUuid_1 = bytesToUuid$2;
var rng$1 = rngBrowser.exports;
var bytesToUuid$1 = bytesToUuid_1;
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1$1(options, buf, offset) {
  var i2 = buf && offset || 0;
  var b2 = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node == null) {
      node = _nodeId = [
        seedBytes[0] | 1,
        seedBytes[1],
        seedBytes[2],
        seedBytes[3],
        seedBytes[4],
        seedBytes[5]
      ];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options.msecs !== void 0 ? options.msecs : new Date().getTime();
  var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b2[i2++] = tl >>> 24 & 255;
  b2[i2++] = tl >>> 16 & 255;
  b2[i2++] = tl >>> 8 & 255;
  b2[i2++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b2[i2++] = tmh >>> 8 & 255;
  b2[i2++] = tmh & 255;
  b2[i2++] = tmh >>> 24 & 15 | 16;
  b2[i2++] = tmh >>> 16 & 255;
  b2[i2++] = clockseq >>> 8 | 128;
  b2[i2++] = clockseq & 255;
  for (var n2 = 0; n2 < 6; ++n2) {
    b2[i2 + n2] = node[n2];
  }
  return buf ? buf : bytesToUuid$1(b2);
}
var v1_1 = v1$1;
var rng = rngBrowser.exports;
var bytesToUuid = bytesToUuid_1;
function v4$1(options, buf, offset) {
  var i2 = buf && offset || 0;
  if (typeof options == "string") {
    buf = options === "binary" ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds2 = options.random || (options.rng || rng)();
  rnds2[6] = rnds2[6] & 15 | 64;
  rnds2[8] = rnds2[8] & 63 | 128;
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i2 + ii] = rnds2[ii];
    }
  }
  return buf || bytesToUuid(rnds2);
}
var v4_1 = v4$1;
var v1 = v1_1;
var v4 = v4_1;
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
var uuid_1 = uuid;
class OTPublisher$2 extends Component {
  constructor(props, context2) {
    super(props);
    __publicField(this, "sessionConnectedHandler", () => {
      this.publishToSession(this.state.publisher);
    });
    __publicField(this, "streamCreatedHandler", (event) => {
      this.setState({
        lastStreamId: event.stream.id
      });
    });
    this.state = {
      publisher: null,
      lastStreamId: "",
      session: props.session || context2.session || null
    };
  }
  componentDidMount() {
    this.createPublisher();
  }
  componentDidUpdate(prevProps, prevState) {
    const useDefault = (value, defaultValue) => value === void 0 ? defaultValue : value;
    const shouldUpdate = (key, defaultValue) => {
      const previous = useDefault(prevProps.properties[key], defaultValue);
      const current = useDefault(this.props.properties[key], defaultValue);
      return previous !== current;
    };
    const updatePublisherProperty = (key, defaultValue) => {
      if (shouldUpdate(key, defaultValue)) {
        const value = useDefault(this.props.properties[key], defaultValue);
        this.state.publisher[key](value);
      }
    };
    if (shouldUpdate("videoSource", void 0)) {
      this.destroyPublisher();
      this.createPublisher();
      return;
    }
    updatePublisherProperty("publishAudio", true);
    updatePublisherProperty("publishVideo", true);
    if (this.state.session !== prevState.session) {
      this.destroyPublisher(prevState.session);
      this.createPublisher();
    }
  }
  componentWillUnmount() {
    if (this.state.session) {
      this.state.session.off("sessionConnected", this.sessionConnectedHandler);
    }
    this.destroyPublisher();
  }
  getPublisher() {
    return this.state.publisher;
  }
  destroyPublisher(session = this.state.session) {
    delete this.publisherId;
    if (this.state.publisher) {
      this.state.publisher.off("streamCreated", this.streamCreatedHandler);
      if (this.props.eventHandlers && typeof this.props.eventHandlers === "object") {
        this.state.publisher.once("destroyed", () => {
          this.state.publisher.off(this.props.eventHandlers);
        });
      }
      if (session) {
        session.unpublish(this.state.publisher);
      }
      this.state.publisher.destroy();
    }
  }
  publishToSession(publisher) {
    const {
      publisherId
    } = this;
    this.state.session.publish(publisher, (err) => {
      if (publisherId !== this.publisherId) {
        return;
      }
      if (err) {
        this.errorHandler(err);
      } else if (typeof this.props.onPublish === "function") {
        this.props.onPublish();
      }
    });
  }
  createPublisher() {
    if (!this.state.session) {
      this.setState({
        publisher: null,
        lastStreamId: ""
      });
      return;
    }
    const properties = this.props.properties || {};
    let container;
    if (properties.insertDefaultUI !== false) {
      container = document.createElement("div");
      container.setAttribute("class", "OTPublisherContainer");
      this.node.appendChild(container);
    }
    this.publisherId = uuid_1();
    const {
      publisherId
    } = this;
    this.errorHandler = once_1((err) => {
      if (publisherId !== this.publisherId) {
        return;
      }
      if (typeof this.props.onError === "function") {
        this.props.onError(err);
      }
    });
    const publisher = OT.initPublisher(container, properties, (err) => {
      if (publisherId !== this.publisherId) {
        return;
      }
      if (err) {
        this.errorHandler(err);
      } else if (typeof this.props.onInit === "function") {
        this.props.onInit();
      }
    });
    publisher.on("streamCreated", this.streamCreatedHandler);
    publisher.setStyle({
      buttonDisplayMode: "off"
    });
    if (this.props.eventHandlers && typeof this.props.eventHandlers === "object") {
      const handles = fp.omitBy(fp.isNil)(this.props.eventHandlers);
      publisher.on(handles);
    }
    if (this.state.session.connection) {
      this.publishToSession(publisher);
    } else {
      this.state.session.once("sessionConnected", this.sessionConnectedHandler);
    }
    this.setState({
      publisher,
      lastStreamId: ""
    });
  }
  render() {
    const {
      className,
      style
    } = this.props;
    return /* @__PURE__ */ jsx("div", {
      className,
      style,
      ref: (node) => {
        this.node = node;
      }
    });
  }
}
OTPublisher$2.propTypes = {
  session: PropTypes.shape({
    connection: PropTypes.shape({
      connectionId: PropTypes.string
    }),
    once: PropTypes.func,
    off: PropTypes.func,
    publish: PropTypes.func,
    unpublish: PropTypes.func
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  properties: PropTypes.object,
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  onInit: PropTypes.func,
  onPublish: PropTypes.func,
  onError: PropTypes.func
};
OTPublisher$2.defaultProps = {
  session: null,
  className: "",
  style: {},
  properties: {},
  eventHandlers: null,
  onInit: null,
  onPublish: null,
  onError: null
};
OTPublisher$2.contextTypes = {
  session: PropTypes.shape({
    connection: PropTypes.shape({
      connectionId: PropTypes.string
    }),
    once: PropTypes.func,
    off: PropTypes.func,
    publish: PropTypes.func,
    unpublish: PropTypes.func
  })
};
class OTSubscriberContext$2 extends Component {
  getChildContext() {
    return {
      stream: this.props.stream
    };
  }
  render() {
    return /* @__PURE__ */ jsx(Fragment, {
      children: this.props.children
    });
  }
}
OTSubscriberContext$2.propTypes = {
  children: PropTypes.element.isRequired,
  stream: PropTypes.shape({
    streamId: PropTypes.string
  }).isRequired
};
OTSubscriberContext$2.childContextTypes = {
  stream: PropTypes.shape({
    streamId: PropTypes.string
  })
};
function OTStreams$2(props, context2) {
  const session = props.session || context2.session || null;
  const streams = props.streams || context2.streams || null;
  if (!session) {
    return /* @__PURE__ */ jsx("div", {});
  }
  const child = Children.only(props.children);
  const childrenWithContextWrapper = Array.isArray(streams) ? streams.map((stream) => child ? /* @__PURE__ */ jsx(OTSubscriberContext$2, {
    stream,
    children: cloneElement(child)
  }, stream.id) : child) : null;
  return childrenWithContextWrapper;
}
OTStreams$2.propTypes = {
  children: PropTypes.element.isRequired,
  session: PropTypes.shape({
    publish: PropTypes.func,
    subscribe: PropTypes.func
  }),
  streams: PropTypes.arrayOf(PropTypes.object)
};
OTStreams$2.defaultProps = {
  session: null,
  streams: null
};
OTStreams$2.contextTypes = {
  session: PropTypes.shape({
    publish: PropTypes.func,
    subscribe: PropTypes.func
  }),
  streams: PropTypes.arrayOf(PropTypes.object)
};
class OTSubscriber$2 extends Component {
  constructor(props, context2) {
    super(props);
    this.state = {
      subscriber: null,
      stream: props.stream || context2.stream || null,
      session: props.session || context2.session || null,
      currentRetryAttempt: 0
    };
    this.maxRetryAttempts = props.maxRetryAttempts || 5;
    this.retryAttemptTimeout = props.retryAttemptTimeout || 1e3;
  }
  componentDidMount() {
    this.createSubscriber();
  }
  componentDidUpdate(prevProps, prevState) {
    const cast2 = (value, Type2, defaultValue) => value === void 0 ? defaultValue : Type2(value);
    const updateSubscriberProperty = (key) => {
      const previous = cast2(prevProps.properties[key], Boolean, true);
      const current = cast2(this.props.properties[key], Boolean, true);
      if (previous !== current) {
        this.state.subscriber[key](current);
      }
    };
    updateSubscriberProperty("subscribeToAudio");
    updateSubscriberProperty("subscribeToVideo");
    if (prevState.session !== this.state.session || prevState.stream !== this.state.stream) {
      this.destroySubscriber(prevState.session);
      this.createSubscriber();
    }
  }
  componentWillUnmount() {
    this.destroySubscriber();
  }
  getSubscriber() {
    return this.state.subscriber;
  }
  createSubscriber() {
    if (!this.state.session || !this.state.stream) {
      this.setState({
        subscriber: null
      });
      return;
    }
    const properties = this.props.properties || {};
    let container;
    if (properties.insertDefaultUI !== false) {
      container = document.createElement("div");
      container.setAttribute("class", "OTSubscriberContainer");
      this.node.appendChild(container);
    }
    this.subscriberId = uuid_1();
    const {
      subscriberId
    } = this;
    const subscriber = this.state.session.subscribe(this.state.stream, container, this.props.properties, (err) => {
      if (subscriberId !== this.subscriberId) {
        return;
      }
      if (err && this.props.retry && this.state.currentRetryAttempt < this.maxRetryAttempts - 1) {
        this.handleRetrySubscriber();
      }
      if (err && typeof this.props.onError === "function") {
        this.props.onError(err);
      } else if (!err && typeof this.props.onSubscribe === "function") {
        this.props.onSubscribe();
      }
    });
    if (this.props.eventHandlers && typeof this.props.eventHandlers === "object") {
      subscriber.on(this.props.eventHandlers);
    }
    this.setState({
      subscriber
    });
  }
  handleRetrySubscriber() {
    setTimeout(() => {
      this.setState((state2) => ({
        currentRetryAttempt: state2.currentRetryAttempt + 1,
        subscriber: null
      }));
      this.createSubscriber();
    }, this.retryAttemptTimeout);
  }
  destroySubscriber(session = this.props.session) {
    delete this.subscriberId;
    if (this.state.subscriber) {
      if (this.props.eventHandlers && typeof this.props.eventHandlers === "object") {
        this.state.subscriber.once("destroyed", () => {
          this.state.subscriber.off(this.props.eventHandlers);
        });
      }
      if (session) {
        session.unsubscribe(this.state.subscriber);
      }
    }
  }
  render() {
    const {
      className,
      style
    } = this.props;
    return /* @__PURE__ */ jsx("div", {
      className,
      style,
      ref: (node) => {
        this.node = node;
      }
    });
  }
}
OTSubscriber$2.propTypes = {
  stream: PropTypes.shape({
    streamId: PropTypes.string
  }),
  session: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  properties: PropTypes.object,
  retry: PropTypes.bool,
  maxRetryAttempts: PropTypes.number,
  retryAttemptTimeout: PropTypes.number,
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  onSubscribe: PropTypes.func,
  onError: PropTypes.func
};
OTSubscriber$2.defaultProps = {
  stream: null,
  session: null,
  className: "",
  style: {},
  properties: {},
  retry: false,
  maxRetryAttempts: 5,
  retryAttemptTimeout: 1e3,
  eventHandlers: null,
  onSubscribe: null,
  onError: null
};
OTSubscriber$2.contextTypes = {
  stream: PropTypes.shape({
    streamId: PropTypes.string
  }),
  session: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  })
};
var getDisplayName$1 = {};
Object.defineProperty(getDisplayName$1, "__esModule", {
  value: true
});
var _default$1 = getDisplayName$1.default = getDisplayName;
function getDisplayName(Component2) {
  return Component2.displayName || Component2.name || (typeof Component2 === "string" && Component2.length > 0 ? Component2 : "Unknown");
}
var script = { exports: {} };
/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */
(function(module2) {
  (function(name, definition) {
    if (module2.exports)
      module2.exports = definition();
    else
      this[name] = definition();
  })("$script", function() {
    var doc = document, head = doc.getElementsByTagName("head")[0], f2 = false, push2 = "push", readyState = "readyState", onreadystatechange = "onreadystatechange", list = {}, ids = {}, delay = {}, scripts = {}, scriptpath, urlArgs;
    function every(ar, fn) {
      for (var i2 = 0, j2 = ar.length; i2 < j2; ++i2)
        if (!fn(ar[i2]))
          return f2;
      return 1;
    }
    function each2(ar, fn) {
      every(ar, function(el) {
        fn(el);
        return 1;
      });
    }
    function $script(paths, idOrDone, optDone) {
      paths = paths[push2] ? paths : [paths];
      var idOrDoneIsDone = idOrDone && idOrDone.call, done = idOrDoneIsDone ? idOrDone : optDone, id2 = idOrDoneIsDone ? paths.join("") : idOrDone, queue = paths.length;
      function loopFn(item) {
        return item.call ? item() : list[item];
      }
      function callback() {
        if (!--queue) {
          list[id2] = 1;
          done && done();
          for (var dset in delay) {
            every(dset.split("|"), loopFn) && !each2(delay[dset], loopFn) && (delay[dset] = []);
          }
        }
      }
      setTimeout(function() {
        each2(paths, function loading(path2, force) {
          if (path2 === null)
            return callback();
          if (!force && !/^https?:\/\//.test(path2) && scriptpath) {
            path2 = path2.indexOf(".js") === -1 ? scriptpath + path2 + ".js" : scriptpath + path2;
          }
          if (scripts[path2]) {
            if (id2)
              ids[id2] = 1;
            return scripts[path2] == 2 ? callback() : setTimeout(function() {
              loading(path2, true);
            }, 0);
          }
          scripts[path2] = 1;
          if (id2)
            ids[id2] = 1;
          create3(path2, callback);
        });
      }, 0);
      return $script;
    }
    function create3(path2, fn) {
      var el = doc.createElement("script"), loaded;
      el.onload = el.onerror = el[onreadystatechange] = function() {
        if (el[readyState] && !/^c|loade/.test(el[readyState]) || loaded)
          return;
        el.onload = el[onreadystatechange] = null;
        loaded = 1;
        scripts[path2] = 2;
        fn();
      };
      el.async = 1;
      el.src = urlArgs ? path2 + (path2.indexOf("?") === -1 ? "?" : "&") + urlArgs : path2;
      head.insertBefore(el, head.lastChild);
    }
    $script.get = create3;
    $script.order = function(scripts2, id2, done) {
      (function callback(s2) {
        s2 = scripts2.shift();
        !scripts2.length ? $script(s2, id2, done) : $script(s2, callback);
      })();
    };
    $script.path = function(p2) {
      scriptpath = p2;
    };
    $script.urlArgs = function(str) {
      urlArgs = str;
    };
    $script.ready = function(deps, ready, req) {
      deps = deps[push2] ? deps : [deps];
      var missing = [];
      !each2(deps, function(dep) {
        list[dep] || missing[push2](dep);
      }) && every(deps, function(dep) {
        return list[dep];
      }) ? ready() : !function(key) {
        delay[key] = delay[key] || [];
        delay[key][push2](ready);
        req && req(missing);
      }(deps.join("|"));
      return $script;
    };
    $script.done = function(idOrDone) {
      $script([null], idOrDone);
    };
    return $script;
  });
})(script);
var scriptjs = script.exports;
const DEFAULT_SCRIPT_URL$1 = "https://static.opentok.com/v2/js/opentok.min.js";
function preloadScript$3(InnerComponent) {
  class PreloadScript extends Component {
    constructor(props) {
      super(props);
      __publicField(this, "onScriptLoad", () => {
        if (this.isPresent) {
          this.setState({
            scriptLoaded: true
          });
        }
      });
      this.state = {
        scriptLoaded: typeof OT !== "undefined"
      };
      this.isPresent = false;
    }
    componentDidMount() {
      this.isPresent = true;
      if (this.scriptLoading || this.state.scriptLoaded) {
        return;
      }
      this.scriptLoading = true;
      const scriptUrl = this.props.opentokClientUrl;
      scriptjs(scriptUrl, this.onScriptLoad);
    }
    componentWillUnmount() {
      this.isPresent = false;
    }
    render() {
      const _a = this.props, {
        opentokClientUrl,
        loadingDelegate
      } = _a, restProps = __objRest(_a, [
        "opentokClientUrl",
        "loadingDelegate"
      ]);
      if (this.state.scriptLoaded) {
        return /* @__PURE__ */ jsx(InnerComponent, __spreadValues({}, restProps));
      }
      return loadingDelegate;
    }
  }
  PreloadScript.displayName = `preloadScript(${_default$1(InnerComponent)})`;
  PreloadScript.propTypes = {
    opentokClientUrl: PropTypes.string,
    loadingDelegate: PropTypes.node
  };
  PreloadScript.defaultProps = {
    opentokClientUrl: DEFAULT_SCRIPT_URL$1,
    loadingDelegate: /* @__PURE__ */ jsx("div", {})
  };
  return PreloadScript;
}
var NetworkTest$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(window, function() {
    return function(e2) {
      var t2 = {};
      function r2(n2) {
        if (t2[n2])
          return t2[n2].exports;
        var o = t2[n2] = { i: n2, l: false, exports: {} };
        return e2[n2].call(o.exports, o, o.exports, r2), o.l = true, o.exports;
      }
      return r2.m = e2, r2.c = t2, r2.d = function(e3, t3, n2) {
        r2.o(e3, t3) || Object.defineProperty(e3, t3, { enumerable: true, get: n2 });
      }, r2.r = function(e3) {
        typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e3, "__esModule", { value: true });
      }, r2.t = function(e3, t3) {
        if (1 & t3 && (e3 = r2(e3)), 8 & t3)
          return e3;
        if (4 & t3 && typeof e3 == "object" && e3 && e3.__esModule)
          return e3;
        var n2 = /* @__PURE__ */ Object.create(null);
        if (r2.r(n2), Object.defineProperty(n2, "default", { enumerable: true, value: e3 }), 2 & t3 && typeof e3 != "string")
          for (var o in e3)
            r2.d(n2, o, function(t4) {
              return e3[t4];
            }.bind(null, o));
        return n2;
      }, r2.n = function(e3) {
        var t3 = e3 && e3.__esModule ? function() {
          return e3.default;
        } : function() {
          return e3;
        };
        return r2.d(t3, "a", t3), t3;
      }, r2.o = function(e3, t3) {
        return Object.prototype.hasOwnProperty.call(e3, t3);
      }, r2.p = "", r2(r2.s = 20);
    }([function(e2, t2, r2) {
      var n2 = r2(7), o = Object.prototype.toString;
      function s2(e3) {
        return o.call(e3) === "[object Array]";
      }
      function i2(e3) {
        return e3 === void 0;
      }
      function a6(e3) {
        return e3 !== null && typeof e3 == "object";
      }
      function c2(e3) {
        if (o.call(e3) !== "[object Object]")
          return false;
        var t3 = Object.getPrototypeOf(e3);
        return t3 === null || t3 === Object.prototype;
      }
      function u2(e3) {
        return o.call(e3) === "[object Function]";
      }
      function l2(e3, t3) {
        if (e3 != null)
          if (typeof e3 != "object" && (e3 = [e3]), s2(e3))
            for (var r3 = 0, n3 = e3.length; r3 < n3; r3++)
              t3.call(null, e3[r3], r3, e3);
          else
            for (var o2 in e3)
              Object.prototype.hasOwnProperty.call(e3, o2) && t3.call(null, e3[o2], o2, e3);
      }
      e2.exports = { isArray: s2, isArrayBuffer: function(e3) {
        return o.call(e3) === "[object ArrayBuffer]";
      }, isBuffer: function(e3) {
        return e3 !== null && !i2(e3) && e3.constructor !== null && !i2(e3.constructor) && typeof e3.constructor.isBuffer == "function" && e3.constructor.isBuffer(e3);
      }, isFormData: function(e3) {
        return typeof FormData != "undefined" && e3 instanceof FormData;
      }, isArrayBufferView: function(e3) {
        return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? ArrayBuffer.isView(e3) : e3 && e3.buffer && e3.buffer instanceof ArrayBuffer;
      }, isString: function(e3) {
        return typeof e3 == "string";
      }, isNumber: function(e3) {
        return typeof e3 == "number";
      }, isObject: a6, isPlainObject: c2, isUndefined: i2, isDate: function(e3) {
        return o.call(e3) === "[object Date]";
      }, isFile: function(e3) {
        return o.call(e3) === "[object File]";
      }, isBlob: function(e3) {
        return o.call(e3) === "[object Blob]";
      }, isFunction: u2, isStream: function(e3) {
        return a6(e3) && u2(e3.pipe);
      }, isURLSearchParams: function(e3) {
        return typeof URLSearchParams != "undefined" && e3 instanceof URLSearchParams;
      }, isStandardBrowserEnv: function() {
        return (typeof navigator == "undefined" || navigator.product !== "ReactNative" && navigator.product !== "NativeScript" && navigator.product !== "NS") && (typeof window != "undefined" && typeof document != "undefined");
      }, forEach: l2, merge: function e3() {
        var t3 = {};
        function r3(r4, n4) {
          c2(t3[n4]) && c2(r4) ? t3[n4] = e3(t3[n4], r4) : c2(r4) ? t3[n4] = e3({}, r4) : s2(r4) ? t3[n4] = r4.slice() : t3[n4] = r4;
        }
        for (var n3 = 0, o2 = arguments.length; n3 < o2; n3++)
          l2(arguments[n3], r3);
        return t3;
      }, extend: function(e3, t3, r3) {
        return l2(t3, function(t4, o2) {
          e3[o2] = r3 && typeof t4 == "function" ? n2(t4, r3) : t4;
        }), e3;
      }, trim: function(e3) {
        return e3.replace(/^\s*/, "").replace(/\s*$/, "");
      }, stripBOM: function(e3) {
        return e3.charCodeAt(0) === 65279 && (e3 = e3.slice(1)), e3;
      } };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true }), t2.assoc = (e3, t3, r3) => Object.assign({}, r3, { [e3]: t3 }), t2.assocPath = (e3, r3, n2) => {
        const o = e3.split("."), s2 = o[0];
        if (!o.length)
          return n2;
        if (o.length === 1)
          return t2.assoc(s2, r3, n2);
        const i2 = t2.get(s2, n2), a6 = i2 && typeof i2 == "object" ? i2 : Object.assign({}, n2, { [s2]: {} }), c2 = t2.assoc(s2, t2.assocPath(o.slice(1).join("."), r3, t2.get(s2, a6)), n2);
        return Object.assign({}, n2, c2);
      }, t2.get = (e3, r3) => {
        if (!r3)
          return r3;
        const [n2, ...o] = e3.split("."), s2 = r3[n2];
        return s2 == null ? s2 : o.length ? t2.get(o.join("."), s2) : s2;
      }, t2.getOr = (e3, r3, n2) => t2.get(r3, n2) || e3, t2.pick = (e3, t3, r3 = false) => e3.reduce((e4, n2) => t3[n2] !== void 0 || r3 ? Object.assign({}, e4, { [n2]: t3[n2] }) : e4, {}), t2.pickAll = (e3, r3) => t2.pick(e3, r3, true), t2.last = (e3) => e3[e3.length - 1], t2.nth = (e3, t3) => e3 < 0 ? t3[t3.length + e3] : t3[e3], t2.head = (e3) => t2.nth(0, e3);
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(1);
      !function(e3) {
        e3.NETWORK_TEST_ERROR = "NetworkTestError", e3.MISSING_OPENTOK_INSTANCE = "MissingOpenTokInstanceError", e3.INCOMPLETE_SESSON_CREDENTIALS = "IncompleteSessionCredentialsError", e3.MISSING_SESSON_CREDENTIALS = "MissingSessionCredentialsError", e3.INVALID_ON_UPDATE_CALLBACK = "InvalidOnUpdateCallback", e3.CONNECTIVITY_ERROR = "ConnectivityError", e3.API_CONNECTIVITY_ERROR = "APIConnectivityError", e3.CONNECT_TO_SESSION_ERROR = "ConnectToSessionError", e3.CONNECT_TO_SESSION_TOKEN_ERROR = "ConnectToSessionTokenError", e3.CONNECT_TO_SESSION_ID_ERROR = "ConnectToSessionSessionIdError", e3.CONNECT_TO_SESSION_NETWORK_ERROR = "ConnectToSessionNetworkError", e3.MEDIA_DEVICE_ERROR = "MediaDeviceError", e3.FAILED_TO_OBTAIN_MEDIA_DEVICES = "FailedToObtainMediaDevices", e3.NO_VIDEO_CAPTURE_DEVICES = "NoVideoCaptureDevicesError", e3.NO_AUDIO_CAPTURE_DEVICES = "NoAudioCaptureDevicesError", e3.PUBLISH_TO_SESSION_ERROR = "PublishToSessionError", e3.INIT_PUBLISHER_ERROR = "InitPublisherError", e3.FAILED_MESSAGING_SERVER_TEST = "FailedMessagingServerTestError", e3.FAILED_TO_CREATE_LOCAL_PUBLISHER = "FailedToCreateLocalPublisher", e3.PUBLISH_TO_SESSION_NOT_CONNECTED = "PublishToSessionNotConnectedError", e3.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR = "PublishToSessionPermissionOrTimeoutError", e3.PUBLISH_TO_SESSION_NETWORK_ERROR = "PublishToSessionNetworkError", e3.SUBSCRIBE_TO_SESSION_ERROR = "SubscribeToSessionError", e3.LOGGING_SERVER_CONNECTION_ERROR = "LoggingServerConnectionError", e3.QUALITY_TEST_ERROR = "QualityTestError", e3.UNSUPPORTED_BROWSER = "UnsupportedBrowser", e3.SUBSCRIBER_GET_STATS_ERROR = "SubscriberGetStatsError", e3.MISSING_SUBSCRIBER_ERROR = "MissingSubscriberError";
      }(t2.ErrorNames || (t2.ErrorNames = {})), function(e3) {
        e3.JS_EXCEPTION = "JS_EXCEPTION", e3.OT_AUTHENTICATION_ERROR = "OT_AUTHENTICATION_ERROR", e3.OT_INVALID_HTTP_STATUS = "OT_INVALID_HTTP_STATUS", e3.OT_CONNECT_FAILED = "OT_CONNECT_FAILED", e3.OT_INVALID_SESSION_ID = "OT_INVALID_SESSION_ID", e3.CONNECT_FAILED = "CONNECT_FAILED", e3.CONNECT_REJECTED = "CONNECT_REJECTED", e3.CONNECTION_TIMEOUT = "CONNECTION_TIMEOUT", e3.NOT_CONNECTED = "NOT_CONNECTED", e3.INVALID_PARAMETER = "INVALID_PARAMETER", e3.P2P_CONNECTION_FAILED = "P2P_CONNECTION_FAILED", e3.API_RESPONSE_FAILURE = "API_RESPONSE_FAILURE", e3.TERMS_OF_SERVICE_FAILURE = "TERMS_OF_SERVICE_FAILURE", e3.CONNECTION_LIMIT_EXCEEDED = "CONNECTION_LIMIT_EXCEEDED", e3.UNABLE_TO_PUBLISH = "UNABLE_TO_PUBLISH", e3.UNABLE_TO_SUBSCRIBE = "UNABLE_TO_SUBSCRIBE", e3.UNSUPPORTED_VIDEO_CODEC = "UNSUPPORTED_VIDEO_CODEC", e3.UNABLE_TO_FORCE_DISCONNECT = "UNABLE_TO_FORCE_DISCONNECT", e3.UNABLE_TO_FORCE_UNPUBLISH = "UNABLE_TO_FORCE_UNPUBLISH", e3.PUBLISHER_ICE_WORKFLOW_FAILED = "PUBLISHER_ICE_WORKFLOW_FAILED", e3.SUBSCRIBER_ICE_WORKFLOW_FAILED = "SUBSCRIBER_ICE_WORKFLOW_FAILED", e3.STREAM_LIMIT_EXCEEDED = "STREAM_LIMIT_EXCEEDED", e3.UNEXPECTED_SERVER_RESPONSE = "UNEXPECTED_SERVER_RESPONSE", e3.REPORT_ISSUE_ERROR = "REPORT_ISSUE_ERROR", e3.ANVIL_BADLY_FORMED_RESPONSE = "ANVIL_BADLY_FORMED_RESPONSE", e3.ANVIL_INVALID_HTTP_STATUS = "ANVIL_INVALID_HTTP_STATUS", e3.ANVIL_XDOMAIN_OR_PARSING_ERROR = "ANVIL_XDOMAIN_OR_PARSING_ERROR", e3.ANVIL_UNKNOWN_HTTP_ERROR = "ANVIL_UNKNOWN_HTTP_ERROR", e3.ANVIL_UNEXPECTED_ERROR_CODE = "ANVIL_UNEXPECTED_ERROR_CODE", e3.ANVIL_EMPTY_RESPONSE_BODY = "ANVIL_EMPTY_RESPONSE_BODY", e3.ANVIL_CONNECT_FAILED = "ANVIL_CONNECT_FAILED";
      }(t2.OTErrorType || (t2.OTErrorType = {})), t2.errorHasName = (e3 = null, t3) => n2.get("name", e3) === t3;
    }, function(e2, t2, r2) {
      var n2 = r2(16);
      function o() {
      }
      var s2 = null, i2 = {};
      function a6(e3) {
        if (typeof this != "object")
          throw new TypeError("Promises must be constructed via new");
        if (typeof e3 != "function")
          throw new TypeError("Promise constructor's argument is not a function");
        this._U = 0, this._V = 0, this._W = null, this._X = null, e3 !== o && p2(e3, this);
      }
      function c2(e3, t3) {
        for (; e3._V === 3; )
          e3 = e3._W;
        if (a6._Y && a6._Y(e3), e3._V === 0)
          return e3._U === 0 ? (e3._U = 1, void (e3._X = t3)) : e3._U === 1 ? (e3._U = 2, void (e3._X = [e3._X, t3])) : void e3._X.push(t3);
        !function(e4, t4) {
          n2(function() {
            var r3 = e4._V === 1 ? t4.onFulfilled : t4.onRejected;
            if (r3 !== null) {
              var n3 = function(e5, t5) {
                try {
                  return e5(t5);
                } catch (e6) {
                  return s2 = e6, i2;
                }
              }(r3, e4._W);
              n3 === i2 ? l2(t4.promise, s2) : u2(t4.promise, n3);
            } else
              e4._V === 1 ? u2(t4.promise, e4._W) : l2(t4.promise, e4._W);
          });
        }(e3, t3);
      }
      function u2(e3, t3) {
        if (t3 === e3)
          return l2(e3, new TypeError("A promise cannot be resolved with itself."));
        if (t3 && (typeof t3 == "object" || typeof t3 == "function")) {
          var r3 = function(e4) {
            try {
              return e4.then;
            } catch (e5) {
              return s2 = e5, i2;
            }
          }(t3);
          if (r3 === i2)
            return l2(e3, s2);
          if (r3 === e3.then && t3 instanceof a6)
            return e3._V = 3, e3._W = t3, void d2(e3);
          if (typeof r3 == "function")
            return void p2(r3.bind(t3), e3);
        }
        e3._V = 1, e3._W = t3, d2(e3);
      }
      function l2(e3, t3) {
        e3._V = 2, e3._W = t3, a6._Z && a6._Z(e3, t3), d2(e3);
      }
      function d2(e3) {
        if (e3._U === 1 && (c2(e3, e3._X), e3._X = null), e3._U === 2) {
          for (var t3 = 0; t3 < e3._X.length; t3++)
            c2(e3, e3._X[t3]);
          e3._X = null;
        }
      }
      function f2(e3, t3, r3) {
        this.onFulfilled = typeof e3 == "function" ? e3 : null, this.onRejected = typeof t3 == "function" ? t3 : null, this.promise = r3;
      }
      function p2(e3, t3) {
        var r3 = false, n3 = function(e4, t4, r4) {
          try {
            e4(t4, r4);
          } catch (e5) {
            return s2 = e5, i2;
          }
        }(e3, function(e4) {
          r3 || (r3 = true, u2(t3, e4));
        }, function(e4) {
          r3 || (r3 = true, l2(t3, e4));
        });
        r3 || n3 !== i2 || (r3 = true, l2(t3, s2));
      }
      e2.exports = a6, a6._Y = null, a6._Z = null, a6._0 = o, a6.prototype.then = function(e3, t3) {
        if (this.constructor !== a6)
          return function(e4, t4, r4) {
            return new e4.constructor(function(n3, s3) {
              var i3 = new a6(o);
              i3.then(n3, s3), c2(e4, new f2(t4, r4, i3));
            });
          }(this, e3, t3);
        var r3 = new a6(o);
        return c2(this, new f2(e3, t3, r3)), r3;
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      t2.default = { getStatsInterval: 1e3, getStatsVideoAndAudioTestDuration: 3e4, getStatsAudioOnlyDuration: 1e4, subscribeOptions: { testNetwork: true, audioVolume: 0 }, minimumVideoAndAudioTestSampleSize: 5, steadyStateSampleWindow: 5e3, steadyStateAllowedDelta: 0.05, qualityThresholds: { video: [{ bps: 1e6, plr: 5e-3, recommendedSetting: "1280x720 @ 30FPS" }, { bps: 6e5, plr: 5e-3, recommendedSetting: "640x480 @ 30FPS" }, { bps: 3e5, plr: 5e-3, recommendedSetting: "320x240 @ 30FPS" }, { bps: 35e4, plr: 0.03, recommendedSetting: "1280x720 @ 30FPS" }, { bps: 25e4, plr: 0.03, recommendedSetting: "640x480 @ 30FPS" }, { bps: 15e4, plr: 0.03, recommendedSetting: "320x240 @ 30FPS" }], audio: [{ minMos: 2.4 }] }, strings: { bandwidthLow: "Bandwidth too low.", noCam: "No camera was found.", noMic: "No microphone was found." } };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(2);
      class o extends Error {
        constructor(e3, t3) {
          super(e3), this.name = t3 || n2.ErrorNames.NETWORK_TEST_ERROR, this.stack = new Error(e3).stack;
        }
      }
      t2.NetworkTestError = o;
      t2.MissingOpenTokInstanceError = class extends o {
        constructor() {
          super("An instance of OT, the OpenTok.js client SDK, is required."), this.name = n2.ErrorNames.MISSING_OPENTOK_INSTANCE;
        }
      };
      t2.IncompleteSessionCredentialsError = class extends o {
        constructor() {
          super("NetworkConnectivity requires an apiKey, sessionId, and token.", n2.ErrorNames.INCOMPLETE_SESSON_CREDENTIALS);
        }
      };
      t2.MissingSessionCredentialsError = class extends o {
        constructor() {
          super("NetworkConnectivity requires OpenTok session credentials.", n2.ErrorNames.MISSING_SESSON_CREDENTIALS);
        }
      };
      t2.InvalidOnUpdateCallback = class extends o {
        constructor() {
          super("The onUpdate callback must be a function that accepts a single parameter.", n2.ErrorNames.INVALID_ON_UPDATE_CALLBACK);
        }
      };
    }, function(e2, t2, r2) {
      e2.exports = r2(23);
    }, function(e2, t2, r2) {
      e2.exports = function(e3, t3) {
        return function() {
          for (var r3 = new Array(arguments.length), n2 = 0; n2 < r3.length; n2++)
            r3[n2] = arguments[n2];
          return e3.apply(t3, r3);
        };
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      function o(e3) {
        return encodeURIComponent(e3).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      }
      e2.exports = function(e3, t3, r3) {
        if (!t3)
          return e3;
        var s2;
        if (r3)
          s2 = r3(t3);
        else if (n2.isURLSearchParams(t3))
          s2 = t3.toString();
        else {
          var i2 = [];
          n2.forEach(t3, function(e4, t4) {
            e4 != null && (n2.isArray(e4) ? t4 += "[]" : e4 = [e4], n2.forEach(e4, function(e5) {
              n2.isDate(e5) ? e5 = e5.toISOString() : n2.isObject(e5) && (e5 = JSON.stringify(e5)), i2.push(o(t4) + "=" + o(e5));
            }));
          }), s2 = i2.join("&");
        }
        if (s2) {
          var a6 = e3.indexOf("#");
          a6 !== -1 && (e3 = e3.slice(0, a6)), e3 += (e3.indexOf("?") === -1 ? "?" : "&") + s2;
        }
        return e3;
      };
    }, function(e2, t2, r2) {
      e2.exports = function(e3) {
        return !(!e3 || !e3.__CANCEL__);
      };
    }, function(e2, t2, r2) {
      (function(t3) {
        var n2 = r2(0), o = r2(29), s2 = { "Content-Type": "application/x-www-form-urlencoded" };
        function i2(e3, t4) {
          !n2.isUndefined(e3) && n2.isUndefined(e3["Content-Type"]) && (e3["Content-Type"] = t4);
        }
        var a6, c2 = { adapter: ((typeof XMLHttpRequest != "undefined" || t3 !== void 0 && Object.prototype.toString.call(t3) === "[object process]") && (a6 = r2(11)), a6), transformRequest: [function(e3, t4) {
          return o(t4, "Accept"), o(t4, "Content-Type"), n2.isFormData(e3) || n2.isArrayBuffer(e3) || n2.isBuffer(e3) || n2.isStream(e3) || n2.isFile(e3) || n2.isBlob(e3) ? e3 : n2.isArrayBufferView(e3) ? e3.buffer : n2.isURLSearchParams(e3) ? (i2(t4, "application/x-www-form-urlencoded;charset=utf-8"), e3.toString()) : n2.isObject(e3) ? (i2(t4, "application/json;charset=utf-8"), JSON.stringify(e3)) : e3;
        }], transformResponse: [function(e3) {
          if (typeof e3 == "string")
            try {
              e3 = JSON.parse(e3);
            } catch (e4) {
            }
          return e3;
        }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, validateStatus: function(e3) {
          return e3 >= 200 && e3 < 300;
        } };
        c2.headers = { common: { Accept: "application/json, text/plain, */*" } }, n2.forEach(["delete", "get", "head"], function(e3) {
          c2.headers[e3] = {};
        }), n2.forEach(["post", "put", "patch"], function(e3) {
          c2.headers[e3] = n2.merge(s2);
        }), e2.exports = c2;
      }).call(this, r2(28));
    }, function(e2, t2, r2) {
      var n2 = r2(0), o = r2(30), s2 = r2(32), i2 = r2(8), a6 = r2(33), c2 = r2(36), u2 = r2(37), l2 = r2(12);
      e2.exports = function(e3) {
        return new Promise(function(t3, r3) {
          var d2 = e3.data, f2 = e3.headers;
          n2.isFormData(d2) && delete f2["Content-Type"];
          var p2 = new XMLHttpRequest();
          if (e3.auth) {
            var E2 = e3.auth.username || "", h2 = e3.auth.password ? unescape(encodeURIComponent(e3.auth.password)) : "";
            f2.Authorization = "Basic " + btoa(E2 + ":" + h2);
          }
          var _24 = a6(e3.baseURL, e3.url);
          if (p2.open(e3.method.toUpperCase(), i2(_24, e3.params, e3.paramsSerializer), true), p2.timeout = e3.timeout, p2.onreadystatechange = function() {
            if (p2 && p2.readyState === 4 && (p2.status !== 0 || p2.responseURL && p2.responseURL.indexOf("file:") === 0)) {
              var n3 = "getAllResponseHeaders" in p2 ? c2(p2.getAllResponseHeaders()) : null, s3 = { data: e3.responseType && e3.responseType !== "text" ? p2.response : p2.responseText, status: p2.status, statusText: p2.statusText, headers: n3, config: e3, request: p2 };
              o(t3, r3, s3), p2 = null;
            }
          }, p2.onabort = function() {
            p2 && (r3(l2("Request aborted", e3, "ECONNABORTED", p2)), p2 = null);
          }, p2.onerror = function() {
            r3(l2("Network Error", e3, null, p2)), p2 = null;
          }, p2.ontimeout = function() {
            var t4 = "timeout of " + e3.timeout + "ms exceeded";
            e3.timeoutErrorMessage && (t4 = e3.timeoutErrorMessage), r3(l2(t4, e3, "ECONNABORTED", p2)), p2 = null;
          }, n2.isStandardBrowserEnv()) {
            var S2 = (e3.withCredentials || u2(_24)) && e3.xsrfCookieName ? s2.read(e3.xsrfCookieName) : void 0;
            S2 && (f2[e3.xsrfHeaderName] = S2);
          }
          if ("setRequestHeader" in p2 && n2.forEach(f2, function(e4, t4) {
            d2 === void 0 && t4.toLowerCase() === "content-type" ? delete f2[t4] : p2.setRequestHeader(t4, e4);
          }), n2.isUndefined(e3.withCredentials) || (p2.withCredentials = !!e3.withCredentials), e3.responseType)
            try {
              p2.responseType = e3.responseType;
            } catch (t4) {
              if (e3.responseType !== "json")
                throw t4;
            }
          typeof e3.onDownloadProgress == "function" && p2.addEventListener("progress", e3.onDownloadProgress), typeof e3.onUploadProgress == "function" && p2.upload && p2.upload.addEventListener("progress", e3.onUploadProgress), e3.cancelToken && e3.cancelToken.promise.then(function(e4) {
            p2 && (p2.abort(), r3(e4), p2 = null);
          }), d2 || (d2 = null), p2.send(d2);
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(31);
      e2.exports = function(e3, t3, r3, o, s2) {
        var i2 = new Error(e3);
        return n2(i2, t3, r3, o, s2);
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      e2.exports = function(e3, t3) {
        t3 = t3 || {};
        var r3 = {}, o = ["url", "method", "data"], s2 = ["headers", "auth", "proxy", "params"], i2 = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"], a6 = ["validateStatus"];
        function c2(e4, t4) {
          return n2.isPlainObject(e4) && n2.isPlainObject(t4) ? n2.merge(e4, t4) : n2.isPlainObject(t4) ? n2.merge({}, t4) : n2.isArray(t4) ? t4.slice() : t4;
        }
        function u2(o2) {
          n2.isUndefined(t3[o2]) ? n2.isUndefined(e3[o2]) || (r3[o2] = c2(void 0, e3[o2])) : r3[o2] = c2(e3[o2], t3[o2]);
        }
        n2.forEach(o, function(e4) {
          n2.isUndefined(t3[e4]) || (r3[e4] = c2(void 0, t3[e4]));
        }), n2.forEach(s2, u2), n2.forEach(i2, function(o2) {
          n2.isUndefined(t3[o2]) ? n2.isUndefined(e3[o2]) || (r3[o2] = c2(void 0, e3[o2])) : r3[o2] = c2(void 0, t3[o2]);
        }), n2.forEach(a6, function(n3) {
          n3 in t3 ? r3[n3] = c2(e3[n3], t3[n3]) : n3 in e3 && (r3[n3] = c2(void 0, e3[n3]));
        });
        var l2 = o.concat(s2).concat(i2).concat(a6), d2 = Object.keys(e3).concat(Object.keys(t3)).filter(function(e4) {
          return l2.indexOf(e4) === -1;
        });
        return n2.forEach(d2, u2), r3;
      };
    }, function(e2, t2, r2) {
      function n2(e3) {
        this.message = e3;
      }
      n2.prototype.toString = function() {
        return "Cancel" + (this.message ? ": " + this.message : "");
      }, n2.prototype.__CANCEL__ = true, e2.exports = n2;
    }, function(e2, t2, r2) {
      e2.exports = r2(41);
    }, function(e2, t2, r2) {
      (function(t3) {
        function r3(e3) {
          o.length || (n2(), true), o[o.length] = e3;
        }
        e2.exports = r3;
        var n2, o = [], s2 = 0;
        function i2() {
          for (; s2 < o.length; ) {
            var e3 = s2;
            if (s2 += 1, o[e3].call(), s2 > 1024) {
              for (var t4 = 0, r4 = o.length - s2; t4 < r4; t4++)
                o[t4] = o[t4 + s2];
              o.length -= s2, s2 = 0;
            }
          }
          o.length = 0, s2 = 0;
        }
        var a6, c2, u2, l2 = t3 !== void 0 ? t3 : self, d2 = l2.MutationObserver || l2.WebKitMutationObserver;
        function f2(e3) {
          return function() {
            var t4 = setTimeout(n3, 0), r4 = setInterval(n3, 50);
            function n3() {
              clearTimeout(t4), clearInterval(r4), e3();
            }
          };
        }
        typeof d2 == "function" ? (a6 = 1, c2 = new d2(i2), u2 = document.createTextNode(""), c2.observe(u2, { characterData: true }), n2 = function() {
          a6 = -a6, u2.data = a6;
        }) : n2 = f2(i2), r3.requestFlush = n2, r3.makeRequestCallFromTimer = f2;
      }).call(this, r2(42));
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(4), o = r2(1);
      t2.default = function(e3) {
        const t3 = o.getOr(0, "timestamp", o.last(e3)) - n2.default.steadyStateSampleWindow;
        return e3.filter((e4) => e4.timestamp >= t3);
      };
    }, function(e2, t2, r2) {
      function n2(e3, t3) {
        const r3 = [];
        for (let n3 = 1; n3 < t3.length; n3 += 1) {
          const o = t3[n3], s2 = t3[n3 - 1];
          if (o[e3] && s2[e3]) {
            const t4 = 8 * (o[e3].bytesReceived ? o[e3].bytesReceived - s2[e3].bytesReceived : 0) / ((o.timestamp - s2.timestamp) / 1e3), n4 = o[e3].packetsReceived, i2 = o[e3].packetsLost, a6 = i2 + n4;
            let c2 = 0;
            a6 > 0 && i2 > 0 && (c2 = i2 / a6);
            const u2 = e3 === "video" ? { frameRate: o[e3].frameRate } : {};
            r3.push(Object.assign({ averageBitrate: t4, packetLossRatio: c2 }, u2));
          }
        }
        return r3;
      }
      Object.defineProperty(t2, "__esModule", { value: true }), t2.default = function(e3) {
        if (e3.length < 2)
          throw new Error("Cannot calculate bitrate with less than two data points.");
        return { audio: n2("audio", e3), video: n2("video", e3) };
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      class n2 {
        constructor(e3) {
          this.stats = { audio: {}, video: {} }, this.bandwidth = { audio: 0, video: 0 }, this.hasAudioTrack = () => this.statsLog[0] && !!this.statsLog[0].audio, this.hasVideoTrack = () => this.statsLog[0] && !!this.statsLog[0].video, this.statsLog = [], this.audioScoresLog = [], this.videoScoresLog = [], this.audioOnlyFallback = !!e3;
        }
        audioScore() {
          return this.audioScoresLog.reduce((e3, t3) => e3 + t3, 0) / this.audioScoresLog.length;
        }
        videoScore() {
          return this.videoScoresLog.reduce((e3, t3) => e3 + t3, 0) / this.videoScoresLog.length;
        }
        clearInterval() {
          this.intervalId && window.clearInterval(this.intervalId), this.intervalId = void 0;
        }
        pruneAudioScores() {
          const e3 = this.audioScoresLog;
          for (; e3.length > n2.maxLogLength; )
            e3.shift();
          this.audioScoresLog = e3;
        }
        pruneVideoScores() {
          const e3 = this.videoScoresLog;
          for (; e3.length > n2.maxLogLength; )
            e3.shift();
          this.videoScoresLog = e3;
        }
        pruneScores() {
          this.pruneAudioScores(), this.pruneVideoScores();
        }
        audioQualityScore() {
          return this.hasAudioTrack() ? this.audioScore() : 1;
        }
        videoQualityScore() {
          return this.hasVideoTrack() ? this.videoScore() : 1;
        }
      }
      n2.maxLogLength = 1e3, n2.scoreInterval = 1e3, t2.default = n2;
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(21).version, o = r2(22), s2 = r2(51), i2 = r2(5), a6 = r2(59);
      t2.default = class {
        constructor(e3, t3, r3) {
          this.validateOT(e3), this.validateCredentials(t3);
          const n3 = this.validateProxyUrl(r3);
          this.otLogging = this.startLoggingEngine(t3.apiKey, t3.sessionId, n3), this.OT = e3, this.credentials = t3, this.options = r3, this.setProxyUrl(n3);
        }
        validateOT(e3) {
          if (!e3 || typeof e3 != "object" || !e3.initSession)
            throw new i2.MissingOpenTokInstanceError();
        }
        validateCredentials(e3) {
          if (!e3)
            throw new i2.MissingSessionCredentialsError();
          if (!e3.apiKey || !e3.sessionId || !e3.token)
            throw new i2.IncompleteSessionCredentialsError();
        }
        validateProxyUrl(e3) {
          return e3 && e3.proxyServerUrl ? e3.proxyServerUrl : "";
        }
        setProxyUrl(e3) {
          this.OT.setProxyUrl && typeof this.OT.setProxyUrl == "function" && e3 && this.OT.setProxyUrl(e3);
        }
        startLoggingEngine(e3, t3, r3) {
          return new a6({ sessionId: t3, partnerId: e3, source: window.location.href, clientVersion: "js-network-test-" + n2, name: "opentok-network-test", componentId: "opentok-network-test" }, { proxyUrl: r3 });
        }
        testConnectivity() {
          return this.otLogging.logEvent({ action: "testConnectivity", variation: "Attempt" }), o.testConnectivity(this.OT, this.credentials, this.otLogging, this.options);
        }
        testQuality(e3) {
          if (this.otLogging.logEvent({ action: "testQuality", variation: "Attempt" }), e3 && (typeof e3 != "function" || e3.length !== 1))
            throw this.otLogging.logEvent({ action: "testQuality", variation: "Failure" }), new i2.InvalidOnUpdateCallback();
          return s2.testQuality(this.OT, this.credentials, this.otLogging, this.options, e3);
        }
        stop() {
          s2.stopQualityTest();
        }
      };
      var c2 = r2(2);
      t2.ErrorNames = c2.ErrorNames;
    }, function(e2) {
      e2.exports = JSON.parse('{"name":"opentok-network-test-js","version":"2.4.3","description":"Precall network test for applications using the OpenTok platform.","main":"dist/NetworkTest/index.js","types":"dist/NetworkTest/index.d.ts","scripts":{"build":"rm -rf dist && webpack --config webpack.config.js","test-setup":"node test/setup/setup.js","test-teardown":"rm test/credentials.json","karma":"karma start","test":"npm run test-setup && npm run karma && npm run test-teardown","example":"npm run build && cd sample && npm run build && python -m SimpleHTTPServer","tslint":"./node_modules/tslint/bin/tslint -p tsconfig.json"},"repository":{"type":"git","url":"git+https://github.com/opentok/opentok-network-test-js.git"},"keywords":["tokbox","opentok","network test","connectivity","webrtc"],"author":{"name":"TokBox","email":"contact@tokbox.com"},"license":"MIT","bugs":{"url":"https://github.com/opentok/network-connectivity-js/issues"},"homepage":"https://github.com/opentok/network-connectivity-js#readme","dependencies":{"axios":"^0.21.1","opentok-solutions-logging":"^1.1.1","promise":"^8.0.1"},"devDependencies":{"@opentok/client":"^2.18.0","@types/expect.js":"^0.3.29","@types/jasmine":"^2.8.8","@types/jasmine-matchers":"^0.2.30","@types/mocha":"^5.2.2","@types/node":"^10.3.2","@types/opentok":"^2.3.4","@types/promise":"^7.1.30","@types/webrtc":"0.0.22","dotenv":"^4.0.0","fs-extra":"^4.0.3","jasmine":"^2.99.0","jasmine-core":"^2.99.1","karma":"^5.1.1","karma-chrome-launcher":"^2.2.0","karma-cli":"^1.0.1","karma-firefox-launcher":"^1.1.0","karma-jasmine":"^1.1.2","karma-mocha-reporter":"^2.2.5","karma-safari-launcher":"^1.0.0","karma-safaritechpreview-launcher":"0.0.6","karma-sauce-launcher":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-webpack":"^2.0.13","opentok":"^2.9.1","terser-webpack-plugin":"^2.3.3","ts-loader":"^4.4.1","tslint":"^5.10.0","tslint-config-airbnb":"^5.9.2","typescript":"2.9.2","webpack":"^4.12.0","webpack-cli":"^3.0.4","webpack-node-externals":"^1.7.2"}}');
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(6), o = r2(15), s2 = r2(49), i2 = r2(2), a6 = r2(50), c2 = r2(1);
      function u2(e3) {
        return new o((t3, r3) => {
          e3.on("sessionDisconnected", () => {
            e3.off(), t3();
          }), e3.disconnect();
        });
      }
      function l2(e3) {
        return new o((t3, r3) => {
          e3.on("destroyed", () => {
            t3();
          }), e3 || t3(), e3.destroy();
        });
      }
      function d2(e3, t3) {
        return new o((r3, n3) => {
          (function(e4) {
            return new o((t4, r4) => {
              e4.getDevices((e5, n4 = []) => {
                if (e5)
                  r4(new s2.FailedToObtainMediaDevices());
                else {
                  const e6 = n4.reduce((e7, t5) => {
                    const r5 = t5.kind === "audioInput" ? "audio" : "video";
                    return Object.assign({}, e7, { [r5]: Object.assign({}, e7[r5], { [t5.deviceId]: t5 }) });
                  }, { audio: {}, video: {} });
                  Object.keys(e6.audio).length || Object.keys(e6.video).length ? t4(e6) : r4(new s2.FailedToObtainMediaDevices());
                }
              });
            });
          })(e3).then((o2) => {
            const i3 = document.createElement("div");
            i3.style.position = "fixed", i3.style.bottom = "-1px", i3.style.width = "1px", i3.style.height = "1px", i3.style.opacity = "0.01", document.body.appendChild(i3);
            const a7 = { width: "100%", height: "100%", insertMode: "append", showControls: false };
            t3 && t3.audioSource && (a7.audioSource = t3.audioSource), t3 && t3.videoSource && (a7.videoSource = t3.videoSource), t3 && t3.audioOnly && (a7.videoSource = null), Object.keys(o2.audio).length || (a7.audioSource = null), Object.keys(o2.video).length || (a7.videoSource = null);
            const c3 = e3.initPublisher(i3, a7, (e4) => {
              e4 ? n3(new s2.FailedToCreateLocalPublisher()) : r3({ publisher: c3 });
            });
            c3.on("streamCreated", () => {
              i3.style.visibility = "hidden";
            });
          }).catch(n3);
        });
      }
      function f2({ session: e3, publisher: t3 }) {
        return new o((r3, n3) => {
          const o2 = { testNetwork: true, audioVolume: 0 }, i3 = (r4) => {
            l2(t3).then(() => u2(e3)).then(() => {
              n3(r4);
            });
          };
          if (t3.stream) {
            const n4 = document.createElement("div"), a7 = e3.subscribe(t3.stream, n4, o2, (n5) => {
              n5 ? i3(new s2.SubscribeToSessionError()) : r3(Object.assign({ session: e3 }, { publisher: t3 }, { subscriber: a7 }));
            });
          } else
            i3(new s2.SubscribeToSessionError());
        });
      }
      function p2(e3, t3, r3) {
        return new o((o2, i3) => {
          const a7 = c2.getOr("", "properties.loggingURL", e3) + "/logging/ClientEvent", u3 = t3 && t3.proxyServerUrl && `${t3.proxyServerUrl}/${a7.replace("https://", "")}` || a7, l3 = () => i3(new s2.LoggingServerConnectionError());
          n2.default.post(u3).then((e4) => e4.status === 200 ? o2(r3) : l3()).catch(l3);
        });
      }
      t2.testConnectivity = function(e3, t3, r3, n3) {
        return new o((c3, E2) => {
          (function(e4, { apiKey: t4, sessionId: r4, token: n4 }, a7) {
            return new o((o2, c4) => {
              let u3 = {};
              a7 && a7.initSessionOptions && (u3 = a7.initSessionOptions), a7 && a7.proxyServerUrl && (e4.hasOwnProperty("setProxyUrl") || (u3.proxyUrl = a7.proxyServerUrl));
              const l3 = e4.initSession(t4, r4, u3);
              l3.connect(n4, (e5) => {
                i2.errorHasName(e5, i2.OTErrorType.OT_AUTHENTICATION_ERROR) ? c4(new s2.ConnectToSessionTokenError()) : i2.errorHasName(e5, i2.OTErrorType.OT_INVALID_SESSION_ID) ? c4(new s2.ConnectToSessionSessionIdError()) : i2.errorHasName(e5, i2.OTErrorType.OT_CONNECT_FAILED) ? c4(new s2.ConnectToSessionNetworkError()) : i2.errorHasName(e5, i2.OTErrorType.OT_INVALID_HTTP_STATUS) ? c4(new s2.APIConnectivityError()) : e5 ? c4(new s2.ConnectToSessionError()) : o2(l3);
              });
            });
          })(e3, t3, n3).then((t4) => function(e4, t5, r4) {
            return new o((n4, o2) => {
              const a7 = (e5) => {
                u2(t5).then(() => {
                  o2(e5);
                });
              };
              d2(e4, r4).then(({ publisher: e5 }) => {
                t5.publish(e5, (r5) => {
                  r5 ? i2.errorHasName(r5, i2.OTErrorType.NOT_CONNECTED) ? a7(new s2.PublishToSessionNotConnectedError()) : i2.errorHasName(r5, i2.OTErrorType.UNABLE_TO_PUBLISH) ? a7(new s2.PublishToSessionPermissionOrTimeoutError()) : r5 && a7(new s2.PublishToSessionError()) : n4(Object.assign({ session: t5 }, { publisher: e5 }));
                });
              }).catch((e5) => {
                a7(e5);
              });
            });
          }(e3, t4, n3)).then(f2).then((t4) => p2(e3, n3, t4)).then((e4) => {
            const t4 = { success: true, failedTests: [] };
            return r3.logEvent({ action: "testConnectivity", variation: "Success" }), (n4 = e4.session, s3 = e4.subscriber, new o((e5, t5) => {
              s3.on("destroyed", () => {
                e5();
              }), s3 || e5(), n4.unsubscribe(s3);
            })).then(() => l2(e4.publisher)).then(() => u2(e4.session)).then(() => c3(t4));
            var n4, s3;
          }).catch((t4) => {
            const o2 = (...e4) => {
              const t5 = a6.mapErrors(...e4), n4 = t5.find((e5) => e5.type === "messaging"), o3 = { failedTests: [...t5, ...n4 ? a6.mapErrors(new s2.FailedMessagingServerTestError()) : []], success: false };
              r3.logEvent({ action: "testConnectivity", variation: "Success" }), c3(o3);
            };
            t4.name === "LoggingServerConnectionError" ? o2(t4) : p2(e3, n3).then(() => o2(t4)).catch((e4) => o2(t4, e4));
          });
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0), o = r2(7), s2 = r2(24), i2 = r2(13);
      function a6(e3) {
        var t3 = new s2(e3), r3 = o(s2.prototype.request, t3);
        return n2.extend(r3, s2.prototype, t3), n2.extend(r3, t3), r3;
      }
      var c2 = a6(r2(10));
      c2.Axios = s2, c2.create = function(e3) {
        return a6(i2(c2.defaults, e3));
      }, c2.Cancel = r2(14), c2.CancelToken = r2(38), c2.isCancel = r2(9), c2.all = function(e3) {
        return Promise.all(e3);
      }, c2.spread = r2(39), c2.isAxiosError = r2(40), e2.exports = c2, e2.exports.default = c2;
    }, function(e2, t2, r2) {
      var n2 = r2(0), o = r2(8), s2 = r2(25), i2 = r2(26), a6 = r2(13);
      function c2(e3) {
        this.defaults = e3, this.interceptors = { request: new s2(), response: new s2() };
      }
      c2.prototype.request = function(e3) {
        typeof e3 == "string" ? (e3 = arguments[1] || {}).url = arguments[0] : e3 = e3 || {}, (e3 = a6(this.defaults, e3)).method ? e3.method = e3.method.toLowerCase() : this.defaults.method ? e3.method = this.defaults.method.toLowerCase() : e3.method = "get";
        var t3 = [i2, void 0], r3 = Promise.resolve(e3);
        for (this.interceptors.request.forEach(function(e4) {
          t3.unshift(e4.fulfilled, e4.rejected);
        }), this.interceptors.response.forEach(function(e4) {
          t3.push(e4.fulfilled, e4.rejected);
        }); t3.length; )
          r3 = r3.then(t3.shift(), t3.shift());
        return r3;
      }, c2.prototype.getUri = function(e3) {
        return e3 = a6(this.defaults, e3), o(e3.url, e3.params, e3.paramsSerializer).replace(/^\?/, "");
      }, n2.forEach(["delete", "get", "head", "options"], function(e3) {
        c2.prototype[e3] = function(t3, r3) {
          return this.request(a6(r3 || {}, { method: e3, url: t3, data: (r3 || {}).data }));
        };
      }), n2.forEach(["post", "put", "patch"], function(e3) {
        c2.prototype[e3] = function(t3, r3, n3) {
          return this.request(a6(n3 || {}, { method: e3, url: t3, data: r3 }));
        };
      }), e2.exports = c2;
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      function o() {
        this.handlers = [];
      }
      o.prototype.use = function(e3, t3) {
        return this.handlers.push({ fulfilled: e3, rejected: t3 }), this.handlers.length - 1;
      }, o.prototype.eject = function(e3) {
        this.handlers[e3] && (this.handlers[e3] = null);
      }, o.prototype.forEach = function(e3) {
        n2.forEach(this.handlers, function(t3) {
          t3 !== null && e3(t3);
        });
      }, e2.exports = o;
    }, function(e2, t2, r2) {
      var n2 = r2(0), o = r2(27), s2 = r2(9), i2 = r2(10);
      function a6(e3) {
        e3.cancelToken && e3.cancelToken.throwIfRequested();
      }
      e2.exports = function(e3) {
        return a6(e3), e3.headers = e3.headers || {}, e3.data = o(e3.data, e3.headers, e3.transformRequest), e3.headers = n2.merge(e3.headers.common || {}, e3.headers[e3.method] || {}, e3.headers), n2.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(t3) {
          delete e3.headers[t3];
        }), (e3.adapter || i2.adapter)(e3).then(function(t3) {
          return a6(e3), t3.data = o(t3.data, t3.headers, e3.transformResponse), t3;
        }, function(t3) {
          return s2(t3) || (a6(e3), t3 && t3.response && (t3.response.data = o(t3.response.data, t3.response.headers, e3.transformResponse))), Promise.reject(t3);
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      e2.exports = function(e3, t3, r3) {
        return n2.forEach(r3, function(r4) {
          e3 = r4(e3, t3);
        }), e3;
      };
    }, function(e2, t2) {
      var r2, n2, o = e2.exports = {};
      function s2() {
        throw new Error("setTimeout has not been defined");
      }
      function i2() {
        throw new Error("clearTimeout has not been defined");
      }
      function a6(e3) {
        if (r2 === setTimeout)
          return setTimeout(e3, 0);
        if ((r2 === s2 || !r2) && setTimeout)
          return r2 = setTimeout, setTimeout(e3, 0);
        try {
          return r2(e3, 0);
        } catch (t3) {
          try {
            return r2.call(null, e3, 0);
          } catch (t4) {
            return r2.call(this, e3, 0);
          }
        }
      }
      !function() {
        try {
          r2 = typeof setTimeout == "function" ? setTimeout : s2;
        } catch (e3) {
          r2 = s2;
        }
        try {
          n2 = typeof clearTimeout == "function" ? clearTimeout : i2;
        } catch (e3) {
          n2 = i2;
        }
      }();
      var c2, u2 = [], l2 = false, d2 = -1;
      function f2() {
        l2 && c2 && (l2 = false, c2.length ? u2 = c2.concat(u2) : d2 = -1, u2.length && p2());
      }
      function p2() {
        if (!l2) {
          var e3 = a6(f2);
          l2 = true;
          for (var t3 = u2.length; t3; ) {
            for (c2 = u2, u2 = []; ++d2 < t3; )
              c2 && c2[d2].run();
            d2 = -1, t3 = u2.length;
          }
          c2 = null, l2 = false, function(e4) {
            if (n2 === clearTimeout)
              return clearTimeout(e4);
            if ((n2 === i2 || !n2) && clearTimeout)
              return n2 = clearTimeout, clearTimeout(e4);
            try {
              n2(e4);
            } catch (t4) {
              try {
                return n2.call(null, e4);
              } catch (t5) {
                return n2.call(this, e4);
              }
            }
          }(e3);
        }
      }
      function E2(e3, t3) {
        this.fun = e3, this.array = t3;
      }
      function h2() {
      }
      o.nextTick = function(e3) {
        var t3 = new Array(arguments.length - 1);
        if (arguments.length > 1)
          for (var r3 = 1; r3 < arguments.length; r3++)
            t3[r3 - 1] = arguments[r3];
        u2.push(new E2(e3, t3)), u2.length !== 1 || l2 || a6(p2);
      }, E2.prototype.run = function() {
        this.fun.apply(null, this.array);
      }, o.title = "browser", o.browser = true, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = h2, o.addListener = h2, o.once = h2, o.off = h2, o.removeListener = h2, o.removeAllListeners = h2, o.emit = h2, o.prependListener = h2, o.prependOnceListener = h2, o.listeners = function(e3) {
        return [];
      }, o.binding = function(e3) {
        throw new Error("process.binding is not supported");
      }, o.cwd = function() {
        return "/";
      }, o.chdir = function(e3) {
        throw new Error("process.chdir is not supported");
      }, o.umask = function() {
        return 0;
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      e2.exports = function(e3, t3) {
        n2.forEach(e3, function(r3, n3) {
          n3 !== t3 && n3.toUpperCase() === t3.toUpperCase() && (e3[t3] = r3, delete e3[n3]);
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(12);
      e2.exports = function(e3, t3, r3) {
        var o = r3.config.validateStatus;
        r3.status && o && !o(r3.status) ? t3(n2("Request failed with status code " + r3.status, r3.config, null, r3.request, r3)) : e3(r3);
      };
    }, function(e2, t2, r2) {
      e2.exports = function(e3, t3, r3, n2, o) {
        return e3.config = t3, r3 && (e3.code = r3), e3.request = n2, e3.response = o, e3.isAxiosError = true, e3.toJSON = function() {
          return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: this.config, code: this.code };
        }, e3;
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      e2.exports = n2.isStandardBrowserEnv() ? { write: function(e3, t3, r3, o, s2, i2) {
        var a6 = [];
        a6.push(e3 + "=" + encodeURIComponent(t3)), n2.isNumber(r3) && a6.push("expires=" + new Date(r3).toGMTString()), n2.isString(o) && a6.push("path=" + o), n2.isString(s2) && a6.push("domain=" + s2), i2 === true && a6.push("secure"), document.cookie = a6.join("; ");
      }, read: function(e3) {
        var t3 = document.cookie.match(new RegExp("(^|;\\s*)(" + e3 + ")=([^;]*)"));
        return t3 ? decodeURIComponent(t3[3]) : null;
      }, remove: function(e3) {
        this.write(e3, "", Date.now() - 864e5);
      } } : { write: function() {
      }, read: function() {
        return null;
      }, remove: function() {
      } };
    }, function(e2, t2, r2) {
      var n2 = r2(34), o = r2(35);
      e2.exports = function(e3, t3) {
        return e3 && !n2(t3) ? o(e3, t3) : t3;
      };
    }, function(e2, t2, r2) {
      e2.exports = function(e3) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e3);
      };
    }, function(e2, t2, r2) {
      e2.exports = function(e3, t3) {
        return t3 ? e3.replace(/\/+$/, "") + "/" + t3.replace(/^\/+/, "") : e3;
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0), o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
      e2.exports = function(e3) {
        var t3, r3, s2, i2 = {};
        return e3 ? (n2.forEach(e3.split("\n"), function(e4) {
          if (s2 = e4.indexOf(":"), t3 = n2.trim(e4.substr(0, s2)).toLowerCase(), r3 = n2.trim(e4.substr(s2 + 1)), t3) {
            if (i2[t3] && o.indexOf(t3) >= 0)
              return;
            i2[t3] = t3 === "set-cookie" ? (i2[t3] ? i2[t3] : []).concat([r3]) : i2[t3] ? i2[t3] + ", " + r3 : r3;
          }
        }), i2) : i2;
      };
    }, function(e2, t2, r2) {
      var n2 = r2(0);
      e2.exports = n2.isStandardBrowserEnv() ? function() {
        var e3, t3 = /(msie|trident)/i.test(navigator.userAgent), r3 = document.createElement("a");
        function o(e4) {
          var n3 = e4;
          return t3 && (r3.setAttribute("href", n3), n3 = r3.href), r3.setAttribute("href", n3), { href: r3.href, protocol: r3.protocol ? r3.protocol.replace(/:$/, "") : "", host: r3.host, search: r3.search ? r3.search.replace(/^\?/, "") : "", hash: r3.hash ? r3.hash.replace(/^#/, "") : "", hostname: r3.hostname, port: r3.port, pathname: r3.pathname.charAt(0) === "/" ? r3.pathname : "/" + r3.pathname };
        }
        return e3 = o(window.location.href), function(t4) {
          var r4 = n2.isString(t4) ? o(t4) : t4;
          return r4.protocol === e3.protocol && r4.host === e3.host;
        };
      }() : function() {
        return true;
      };
    }, function(e2, t2, r2) {
      var n2 = r2(14);
      function o(e3) {
        if (typeof e3 != "function")
          throw new TypeError("executor must be a function.");
        var t3;
        this.promise = new Promise(function(e4) {
          t3 = e4;
        });
        var r3 = this;
        e3(function(e4) {
          r3.reason || (r3.reason = new n2(e4), t3(r3.reason));
        });
      }
      o.prototype.throwIfRequested = function() {
        if (this.reason)
          throw this.reason;
      }, o.source = function() {
        var e3;
        return { token: new o(function(t3) {
          e3 = t3;
        }), cancel: e3 };
      }, e2.exports = o;
    }, function(e2, t2, r2) {
      e2.exports = function(e3) {
        return function(t3) {
          return e3.apply(null, t3);
        };
      };
    }, function(e2, t2, r2) {
      e2.exports = function(e3) {
        return typeof e3 == "object" && e3.isAxiosError === true;
      };
    }, function(e2, t2, r2) {
      e2.exports = r2(3), r2(43), r2(44), r2(45), r2(46), r2(48);
    }, function(e2, t2) {
      var r2;
      r2 = function() {
        return this;
      }();
      try {
        r2 = r2 || new Function("return this")();
      } catch (e3) {
        typeof window == "object" && (r2 = window);
      }
      e2.exports = r2;
    }, function(e2, t2, r2) {
      var n2 = r2(3);
      e2.exports = n2, n2.prototype.done = function(e3, t3) {
        var r3 = arguments.length ? this.then.apply(this, arguments) : this;
        r3.then(null, function(e4) {
          setTimeout(function() {
            throw e4;
          }, 0);
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(3);
      e2.exports = n2, n2.prototype.finally = function(e3) {
        return this.then(function(t3) {
          return n2.resolve(e3()).then(function() {
            return t3;
          });
        }, function(t3) {
          return n2.resolve(e3()).then(function() {
            throw t3;
          });
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(3);
      e2.exports = n2;
      var o = l2(true), s2 = l2(false), i2 = l2(null), a6 = l2(void 0), c2 = l2(0), u2 = l2("");
      function l2(e3) {
        var t3 = new n2(n2._0);
        return t3._V = 1, t3._W = e3, t3;
      }
      n2.resolve = function(e3) {
        if (e3 instanceof n2)
          return e3;
        if (e3 === null)
          return i2;
        if (e3 === void 0)
          return a6;
        if (e3 === true)
          return o;
        if (e3 === false)
          return s2;
        if (e3 === 0)
          return c2;
        if (e3 === "")
          return u2;
        if (typeof e3 == "object" || typeof e3 == "function")
          try {
            var t3 = e3.then;
            if (typeof t3 == "function")
              return new n2(t3.bind(e3));
          } catch (e4) {
            return new n2(function(t4, r3) {
              r3(e4);
            });
          }
        return l2(e3);
      };
      var d2 = function(e3) {
        return typeof Array.from == "function" ? (d2 = Array.from, Array.from(e3)) : (d2 = function(e4) {
          return Array.prototype.slice.call(e4);
        }, Array.prototype.slice.call(e3));
      };
      n2.all = function(e3) {
        var t3 = d2(e3);
        return new n2(function(e4, r3) {
          if (t3.length === 0)
            return e4([]);
          var o2 = t3.length;
          function s3(i4, a7) {
            if (a7 && (typeof a7 == "object" || typeof a7 == "function")) {
              if (a7 instanceof n2 && a7.then === n2.prototype.then) {
                for (; a7._V === 3; )
                  a7 = a7._W;
                return a7._V === 1 ? s3(i4, a7._W) : (a7._V === 2 && r3(a7._W), void a7.then(function(e5) {
                  s3(i4, e5);
                }, r3));
              }
              var c3 = a7.then;
              if (typeof c3 == "function")
                return void new n2(c3.bind(a7)).then(function(e5) {
                  s3(i4, e5);
                }, r3);
            }
            t3[i4] = a7, --o2 == 0 && e4(t3);
          }
          for (var i3 = 0; i3 < t3.length; i3++)
            s3(i3, t3[i3]);
        });
      }, n2.reject = function(e3) {
        return new n2(function(t3, r3) {
          r3(e3);
        });
      }, n2.race = function(e3) {
        return new n2(function(t3, r3) {
          d2(e3).forEach(function(e4) {
            n2.resolve(e4).then(t3, r3);
          });
        });
      }, n2.prototype.catch = function(e3) {
        return this.then(null, e3);
      };
    }, function(e2, t2, r2) {
      var n2 = r2(3), o = r2(47);
      e2.exports = n2, n2.denodeify = function(e3, t3) {
        return typeof t3 == "number" && t3 !== 1 / 0 ? function(e4, t4) {
          for (var r3 = [], o2 = 0; o2 < t4; o2++)
            r3.push("a" + o2);
          var i2 = ["return function (" + r3.join(",") + ") {", "var self = this;", "return new Promise(function (rs, rj) {", "var res = fn.call(", ["self"].concat(r3).concat([s2]).join(","), ");", "if (res &&", '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ") {rs(res);}", "});", "};"].join("");
          return Function(["Promise", "fn"], i2)(n2, e4);
        }(e3, t3) : function(e4) {
          for (var t4 = Math.max(e4.length - 1, 3), r3 = [], o2 = 0; o2 < t4; o2++)
            r3.push("a" + o2);
          var i2 = ["return function (" + r3.join(",") + ") {", "var self = this;", "var args;", "var argLength = arguments.length;", "if (arguments.length > " + t4 + ") {", "args = new Array(arguments.length + 1);", "for (var i = 0; i < arguments.length; i++) {", "args[i] = arguments[i];", "}", "}", "return new Promise(function (rs, rj) {", "var cb = " + s2 + ";", "var res;", "switch (argLength) {", r3.concat(["extra"]).map(function(e5, t5) {
            return "case " + t5 + ":res = fn.call(" + ["self"].concat(r3.slice(0, t5)).concat("cb").join(",") + ");break;";
          }).join(""), "default:", "args[argLength] = cb;", "res = fn.apply(self, args);", "}", "if (res &&", '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ") {rs(res);}", "});", "};"].join("");
          return Function(["Promise", "fn"], i2)(n2, e4);
        }(e3);
      };
      var s2 = "function (err, res) {if (err) { rj(err); } else { rs(res); }}";
      n2.nodeify = function(e3) {
        return function() {
          var t3 = Array.prototype.slice.call(arguments), r3 = typeof t3[t3.length - 1] == "function" ? t3.pop() : null, s3 = this;
          try {
            return e3.apply(this, arguments).nodeify(r3, s3);
          } catch (e4) {
            if (r3 == null)
              return new n2(function(t4, r4) {
                r4(e4);
              });
            o(function() {
              r3.call(s3, e4);
            });
          }
        };
      }, n2.prototype.nodeify = function(e3, t3) {
        if (typeof e3 != "function")
          return this;
        this.then(function(r3) {
          o(function() {
            e3.call(t3, null, r3);
          });
        }, function(r3) {
          o(function() {
            e3.call(t3, r3);
          });
        });
      };
    }, function(e2, t2, r2) {
      var n2 = r2(16), o = [], s2 = [], i2 = n2.makeRequestCallFromTimer(function() {
        if (s2.length)
          throw s2.shift();
      });
      function a6(e3) {
        var t3;
        (t3 = o.length ? o.pop() : new c2()).task = e3, n2(t3);
      }
      function c2() {
        this.task = null;
      }
      e2.exports = a6, c2.prototype.call = function() {
        try {
          this.task.call();
        } catch (e3) {
          a6.onerror ? a6.onerror(e3) : (s2.push(e3), i2());
        } finally {
          this.task = null, o[o.length] = this;
        }
      };
    }, function(e2, t2, r2) {
      var n2 = r2(3);
      e2.exports = n2, n2.enableSynchronous = function() {
        n2.prototype.isPending = function() {
          return this.getState() == 0;
        }, n2.prototype.isFulfilled = function() {
          return this.getState() == 1;
        }, n2.prototype.isRejected = function() {
          return this.getState() == 2;
        }, n2.prototype.getValue = function() {
          if (this._V === 3)
            return this._W.getValue();
          if (!this.isFulfilled())
            throw new Error("Cannot get a value of an unfulfilled promise.");
          return this._W;
        }, n2.prototype.getReason = function() {
          if (this._V === 3)
            return this._W.getReason();
          if (!this.isRejected())
            throw new Error("Cannot get a rejection reason of a non-rejected promise.");
          return this._W;
        }, n2.prototype.getState = function() {
          return this._V === 3 ? this._W.getState() : this._V === -1 || this._V === -2 ? 0 : this._V;
        };
      }, n2.disableSynchronous = function() {
        n2.prototype.isPending = void 0, n2.prototype.isFulfilled = void 0, n2.prototype.isRejected = void 0, n2.prototype.getValue = void 0, n2.prototype.getReason = void 0, n2.prototype.getState = void 0;
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(5), o = r2(2);
      class s2 extends n2.NetworkTestError {
        constructor(e3, t3) {
          super(e3, t3 || o.ErrorNames.CONNECTIVITY_ERROR);
        }
      }
      t2.ConnectivityError = s2;
      t2.APIConnectivityError = class extends s2 {
        constructor() {
          super("Failed to connect to OpenTOK API Server", o.ErrorNames.API_CONNECTIVITY_ERROR);
        }
      };
      class i2 extends s2 {
        constructor(e3, t3) {
          super(e3 || "Failed to connect to the session due to a network error.", t3 || o.ErrorNames.CONNECT_TO_SESSION_ERROR);
        }
      }
      t2.ConnectToSessionError = i2;
      t2.ConnectToSessionTokenError = class extends i2 {
        constructor() {
          super("Failed to connect to the session due to an invalid token.", o.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR);
        }
      };
      t2.ConnectToSessionSessionIdError = class extends i2 {
        constructor() {
          super("Failed to connect to the session due to an invalid session ID.", o.ErrorNames.CONNECT_TO_SESSION_ID_ERROR);
        }
      };
      t2.ConnectToSessionNetworkError = class extends i2 {
        constructor() {
          super("Failed to connect to the session due to a network error.", o.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR);
        }
      };
      class a6 extends s2 {
        constructor(e3, t3) {
          super(e3 || "OpenTok failed to find media devices for this browser.", t3 || o.ErrorNames.MEDIA_DEVICE_ERROR);
        }
      }
      t2.MediaDeviceError = a6;
      t2.FailedToObtainMediaDevices = class extends a6 {
        constructor() {
          super("Failed to obtain media devices.", o.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES);
        }
      };
      t2.NoVideoCaptureDevicesError = class extends a6 {
        constructor() {
          super("This browser has no video capture devices", o.ErrorNames.NO_VIDEO_CAPTURE_DEVICES);
        }
      };
      t2.NoAudioCaptureDevicesError = class extends a6 {
        constructor() {
          super("This browser has no audio capture devices.", o.ErrorNames.NO_AUDIO_CAPTURE_DEVICES);
        }
      };
      class c2 extends s2 {
        constructor(e3, t3) {
          super(e3 || "Encountered an unknown error while attempting to publish to a session.", t3 || o.ErrorNames.PUBLISH_TO_SESSION_ERROR);
        }
      }
      t2.PublishToSessionError = c2;
      t2.FailedMessagingServerTestError = class extends c2 {
        constructor() {
          super("Failed to connect to media server due to messaging server connection failure", o.ErrorNames.FAILED_MESSAGING_SERVER_TEST);
        }
      };
      t2.FailedToCreateLocalPublisher = class extends c2 {
        constructor() {
          super("Failed to create a local publisher object.", o.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER);
        }
      };
      t2.PublishToSessionNotConnectedError = class extends c2 {
        constructor() {
          super("Precall failed to publish to the session because it was not connected.", o.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED);
        }
      };
      t2.PublishToSessionPermissionOrTimeoutError = class extends c2 {
        constructor() {
          super("Precall failed to publish to the session due a permissions error or timeout.", o.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR);
        }
      };
      t2.PublishToSessionNetworkError = class extends c2 {
        constructor() {
          super("Precall failed to publish to the session due a network error.", o.ErrorNames.PUBLISH_TO_SESSION_NETWORK_ERROR);
        }
      };
      t2.SubscribeToSessionError = class extends s2 {
        constructor(e3) {
          super(e3 || "Encountered an unknown error while attempting to subscribe to a session.", o.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR);
        }
      };
      t2.LoggingServerConnectionError = class extends s2 {
        constructor() {
          super("Failed to connect to the OpenTok logging server.", o.ErrorNames.LOGGING_SERVER_CONNECTION_ERROR);
        }
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(2);
      var o;
      !function(e3) {
        e3.Api = "api", e3.Messaging = "messaging", e3.OpentokJs = "OpenTok.js", e3.Media = "media", e3.Logging = "logging", e3.ConnectivityError = "OpenTok.js";
      }(o = t2.FailureType || (t2.FailureType = {}));
      const s2 = (e3) => ({ error: e3, type: (() => {
        switch (e3.name) {
          case n2.ErrorNames.API_CONNECTIVITY_ERROR:
          case n2.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
            return o.Api;
          case n2.ErrorNames.CONNECT_TO_SESSION_ERROR:
          case n2.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR:
          case n2.ErrorNames.CONNECT_TO_SESSION_ID_ERROR:
            return o.Messaging;
          case n2.ErrorNames.MEDIA_DEVICE_ERROR:
          case n2.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
          case n2.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
          case n2.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
          case n2.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER:
          case n2.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED:
          case n2.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR:
          case n2.ErrorNames.PUBLISH_TO_SESSION_NETWORK_ERROR:
            return o.OpentokJs;
          case n2.ErrorNames.PUBLISH_TO_SESSION_ERROR:
          case n2.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR:
          case n2.ErrorNames.FAILED_MESSAGING_SERVER_TEST:
            return o.Media;
          case n2.ErrorNames.LOGGING_SERVER_CONNECTION_ERROR:
            return o.Logging;
          default:
            return o.OpentokJs;
        }
      })() });
      t2.mapErrors = (...e3) => e3.map(s2);
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(15), o = r2(1), s2 = r2(52), i2 = r2(2), a6 = r2(53), c2 = r2(19), u2 = r2(4), l2 = r2(58);
      let d2, f2, p2, E2 = false, h2 = false, _24 = false;
      function S2(e3, t3) {
        return (r3) => new n2((o2, a7) => {
          const c3 = document.createElement("div");
          c3.style.position = "fixed", c3.style.bottom = "-1px", c3.style.width = "1px", c3.style.height = "1px", c3.style.opacity = "0", document.body.appendChild(c3), function(e4) {
            return new n2((t4, r4) => {
              e4.getDevices((e5, n3 = []) => {
                if (e5)
                  r4(new s2.FailedToObtainMediaDevices());
                else {
                  const e6 = n3.reduce((e7, t5) => {
                    const r5 = t5.kind === "audioInput" ? "audio" : "video";
                    return Object.assign({}, e7, { [r5]: Object.assign({}, e7[r5], { [t5.deviceId]: t5 }) });
                  }, { audio: {}, video: {} });
                  Object.keys(e6.audio).length ? t4(e6) : r4(new s2.NoAudioCaptureDevicesError());
                }
              });
            });
          }(e3).then((n3) => {
            Object.keys(n3.video).length || (E2 = true);
            const u3 = { resolution: "1280x720", width: "100%", height: "100%", insertMode: "append", showControls: false };
            t3 && t3.audioSource && (u3.audioSource = t3.audioSource), t3 && t3.videoSource && (u3.videoSource = t3.videoSource), E2 && (u3.videoSource = null);
            const l3 = e3.initPublisher(c3, u3, (e4) => {
              e4 ? a7(new s2.InitPublisherError(e4.message)) : r3.publish(l3, (e5) => {
                if (e5)
                  return i2.errorHasName(e5, i2.OTErrorType.NOT_CONNECTED) ? a7(new s2.PublishToSessionNotConnectedError()) : i2.errorHasName(e5, i2.OTErrorType.UNABLE_TO_PUBLISH) ? a7(new s2.PublishToSessionPermissionOrTimeoutError()) : a7(new s2.PublishToSessionError());
              });
            });
            l3.on("streamCreated", (e4) => {
              const t4 = r3.subscribe(e4.stream, c3, { testNetwork: true, insertMode: "append" }, (e5) => e5 ? a7(new s2.SubscribeToSessionError(e5.message)) : o2({ publisher: l3, subscriber: t4 }));
            });
          }).catch(a7);
        });
      }
      function O(e3, t3, r3, o2) {
        return new n2((a7, c3) => {
          (function(e4, t4) {
            return new n2((r4, n3) => {
              e4.connection ? r4(e4) : e4.connect(t4, (t5) => {
                t5 && (i2.errorHasName(t5, i2.OTErrorType.OT_AUTHENTICATION_ERROR) ? n3(new s2.ConnectToSessionTokenError()) : i2.errorHasName(t5, i2.OTErrorType.OT_INVALID_SESSION_ID) ? n3(new s2.ConnectToSessionSessionIdError()) : i2.errorHasName(t5, i2.OTErrorType.OT_CONNECT_FAILED) ? n3(new s2.ConnectToSessionNetworkError()) : n3(new s2.ConnectToSessionError())), r4(e4);
              });
            });
          })(t3, r3.token).then(S2(e3, o2)).then(a7).catch(c3);
        });
      }
      function m2(e3, t3, r3, i3, l3, S3) {
        let T2;
        return new n2((g2, N2) => {
          O(e3, t3, r3, i3).then(({ publisher: O2, subscriber: v2 }) => {
            if (v2)
              try {
                const s3 = Object.assign({ state: new c2.default(S3) }, { subscriber: v2 }, { credentials: r3 }), N3 = (e4, t4) => {
                  var r4;
                  t4 && l3 && l3((r4 = t4, Object.assign({}, r4, { phase: E2 ? "audio-only" : "audio-video" })));
                }, y2 = () => {
                  const a7 = function(e4) {
                    const t4 = ["bitrate", "packetLossRatio", "supported", "reason", "mos"];
                    return e4.state.stats.audio.mos = e4.state.audioQualityScore(), e4.state.stats.video.mos = e4.state.videoQualityScore(), e4.state.stats.audio.mos >= u2.default.qualityThresholds.audio[0].minMos ? e4.state.stats.audio.supported = true : (e4.state.stats.audio.supported = false, e4.state.stats.audio.reason = u2.default.strings.bandwidthLow), { audio: o.pick(t4, e4.state.stats.audio), video: o.pick(t4.concat(["frameRate", "recommendedResolution", "recommendedFrameRate"]), e4.state.stats.video) };
                  }(s3);
                  if (E2 || (c3 = a7).audio.mos && c3.audio.mos >= u2.default.qualityThresholds.audio[0].minMos || _24)
                    t3.on("sessionDisconnected", () => {
                      g2(a7), t3.off();
                    }), function(e4, t4) {
                      return new n2((r4, n3) => {
                        t4.on("destroyed", () => {
                          r4();
                        }), t4 || r4(), e4.unsubscribe(t4);
                      });
                    }(t3, v2).then(() => function(e4) {
                      return new n2((t4, r4) => {
                        e4.on("destroyed", () => {
                          t4();
                        }), e4 || t4(), e4.destroy();
                      });
                    }(O2)).then(() => t3.disconnect());
                  else {
                    E2 = true;
                    const n3 = a7.video;
                    m2(e3, t3, r3, i3, l3, true).then((e4) => {
                      e4.video = n3, g2(e4);
                    });
                  }
                  var c3;
                };
                f2 = () => {
                  y2();
                };
                const R = (e4) => {
                  clearTimeout(T2), y2();
                };
                a6.default(s3.state, v2, O2, N3, R), T2 = window.setTimeout(y2, d2 + 1), window.clearTimeout(p2), p2 = window.setTimeout(() => {
                  h2 = true, _24 && f2 && f2();
                }, 5e3);
              } catch (e4) {
                N2(new s2.SubscriberGetStatsError());
              }
            else
              N2(new s2.MissingSubscriberError());
          }).catch(N2);
        });
      }
      t2.testQuality = function(e3, t3, r3, o2, i3) {
        return h2 = false, _24 = false, new n2((a7, c3) => {
          E2 = !(!o2 || !o2.audioOnly), d2 = E2 ? u2.default.getStatsAudioOnlyDuration : u2.default.getStatsVideoAndAudioTestDuration, o2 && o2.timeout && (d2 = Math.min(d2, o2.timeout, 3e4));
          const p3 = (e4) => {
            f2 = void 0, r3.logEvent({ action: "testQuality", variation: "Success" }), a7(e4);
          }, h3 = (e4) => {
            f2 = void 0, r3.logEvent({ action: "testQuality", variation: "Failure" }), c3(e4);
          };
          new n2((e4, t4) => {
            const { supported: r4, browser: n3 } = l2.default();
            return r4 ? e4() : t4(new s2.UnsupportedBrowserError(n3));
          }).then(() => {
            let r4 = {};
            o2 && o2.initSessionOptions && (r4 = o2.initSessionOptions), o2 && o2.proxyServerUrl && (e3.hasOwnProperty("setProxyUrl") || (r4.proxyUrl = o2.proxyServerUrl));
            const n3 = e3.initSession(t3.apiKey, t3.sessionId, r4);
            m2(e3, n3, t3, o2, i3).then(p3).catch(h3);
          }).catch(h3);
        });
      }, t2.stopQualityTest = function() {
        _24 = true, h2 && f2 && f2();
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(5), o = r2(2);
      class s2 extends n2.NetworkTestError {
        constructor(e3, t3) {
          super(e3, t3 || o.ErrorNames.QUALITY_TEST_ERROR);
        }
      }
      t2.QualityTestError = s2;
      t2.UnsupportedBrowserError = class extends s2 {
        constructor(e3) {
          super(`Your current browser (${e3}) does not support the audio-video quality test. Please run the test in a supported browser.`, o.ErrorNames.UNSUPPORTED_BROWSER);
        }
      };
      class i2 extends s2 {
        constructor(e3, t3) {
          super(e3 || "Failed to connect to the session due to a network error.", t3 || o.ErrorNames.CONNECT_TO_SESSION_ERROR);
        }
      }
      t2.ConnectToSessionError = i2;
      t2.ConnectToSessionTokenError = class extends i2 {
        constructor() {
          super("Failed to connect to the session due to an invalid token.", o.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR);
        }
      };
      t2.ConnectToSessionSessionIdError = class extends i2 {
        constructor() {
          super("Failed to connect to the session due to an invalid session ID.", o.ErrorNames.CONNECT_TO_SESSION_ID_ERROR);
        }
      };
      t2.ConnectToSessionNetworkError = class extends i2 {
        constructor() {
          super("Failed to connect to the session due to a network error.", o.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR);
        }
      };
      t2.MediaDeviceError = class extends s2 {
        constructor(e3, t3) {
          super(e3 || "OpenTok failed to find media devices for this browser.", t3 || o.ErrorNames.MEDIA_DEVICE_ERROR);
        }
      };
      t2.FailedToObtainMediaDevices = class extends s2 {
        constructor() {
          super("Failed to obtain media devices.", o.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES);
        }
      };
      t2.NoVideoCaptureDevicesError = class extends s2 {
        constructor() {
          super("This browser has no video capture devices", o.ErrorNames.NO_VIDEO_CAPTURE_DEVICES);
        }
      };
      t2.NoAudioCaptureDevicesError = class extends s2 {
        constructor() {
          super("This browser has no audio capture devices.", o.ErrorNames.NO_AUDIO_CAPTURE_DEVICES);
        }
      };
      class a6 extends s2 {
        constructor(e3, t3) {
          super(e3 || "Encountered an unknown error while attempting to publish to a session.", t3 || o.ErrorNames.PUBLISH_TO_SESSION_ERROR);
        }
      }
      t2.PublishToSessionError = a6;
      t2.InitPublisherError = class extends a6 {
        constructor(e3) {
          super(e3 || "Failed to initialize publisher.", o.ErrorNames.INIT_PUBLISHER_ERROR);
        }
      };
      t2.PublishToSessionNotConnectedError = class extends a6 {
        constructor() {
          super("Precall failed to publish to the session because it was not connected.", o.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED);
        }
      };
      t2.PublishToSessionPermissionOrTimeoutError = class extends a6 {
        constructor() {
          super("Precall failed to publish to the session due a permissions error or timeout.", o.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR);
        }
      };
      class c2 extends s2 {
        constructor(e3, t3) {
          super(e3 || "Encountered an unknown error while attempting to publish to a session.", t3 || o.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR);
        }
      }
      t2.SubscribeToSessionError = c2;
      t2.SubscriberGetStatsError = class extends c2 {
        constructor() {
          super("Failed to get network stats for a subscriber.", o.ErrorNames.SUBSCRIBER_GET_STATS_ERROR);
        }
      };
      t2.MissingSubscriberError = class extends c2 {
        constructor() {
          super("Call checkSubscribeToSession before calling checkSubscriberQuality.", o.ErrorNames.MISSING_SUBSCRIBER_ERROR);
        }
      };
    }, function(e2, t2, r2) {
      var n2 = this && this.__awaiter || function(e3, t3, r3, n3) {
        return new (r3 || (r3 = Promise))(function(o2, s3) {
          function i3(e4) {
            try {
              c3(n3.next(e4));
            } catch (e5) {
              s3(e5);
            }
          }
          function a7(e4) {
            try {
              c3(n3.throw(e4));
            } catch (e5) {
              s3(e5);
            }
          }
          function c3(e4) {
            e4.done ? o2(e4.value) : new r3(function(t4) {
              t4(e4.value);
            }).then(i3, a7);
          }
          c3((n3 = n3.apply(e3, t3 || [])).next());
        });
      };
      Object.defineProperty(t2, "__esModule", { value: true });
      const o = r2(54), s2 = r2(55), i2 = r2(19), a6 = r2(1), c2 = r2(57), u2 = (e3) => a6.getOr(0, "packetsLost", e3), l2 = (e3) => u2(e3) + ((e4) => a6.getOr(0, "packetsReceived", e4))(e3);
      function d2(e3, t3, r3) {
        const n3 = () => 1e3 * (() => {
          if (t3) {
            const { rtcStatsReport: e4 } = t3[0];
            e4.forEach((e5) => {
              e5.type === "remote-inbound-rtp" && e5.kind === "audio" && (isNaN(e5.roundTripTime) ? 0 : e5.roundTripTime);
            });
          }
          return 0;
        })() / 2 || 150, o2 = a6.last(r3), s3 = a6.nth(-2, r3);
        if (!o2 || !s3 || !e3.stream)
          return 1;
        const i3 = (d3 = s3, l2(o2[c3 = "audio"]) - l2(d3[c3]));
        var c3, d3;
        if (i3 === 0)
          return 1;
        let f2 = (u2(o2.audio) - u2(s3.audio)) / i3;
        return f2 < 0 && (f2 = 0), ((e4) => {
          const t4 = n3();
          return (r4 = (() => {
            const r5 = t4 + 30;
            return 93.2 - (0.024 * r5 + 0.11 * (r5 - 177.3) * 1) - (0 + 19.8 * Math.log(1 + 29.7 * e4));
          })()) < 0 ? 1 : r4 > 100 ? 4.5 : 1 + 0.035 * r4 + r4 * (r4 - 60) * (100 - r4) * 7e-6;
          var r4;
        })(f2);
      }
      t2.default = function(e3, t3, r3, u3, l3) {
        return e3.intervalId = window.setInterval(() => {
          t3.getStats((i3, f2) => n2(this, void 0, void 0, function* () {
            if (!f2)
              return null;
            let n3 = null;
            try {
              n3 = yield c2.default(r3);
            } catch (e4) {
            }
            if (f2.audio.bytesReceived < 0 || a6.getOr(1, "video.bytesReceived", f2) < 0)
              return e3.clearInterval(), l3(e3);
            if (f2 && e3.statsLog.push(f2), u3 && typeof u3 == "function" && u3(i3, f2), e3.statsLog.length < 2)
              return null;
            e3.stats = s2.default(e3);
            const p2 = function(e4, t4) {
              const r4 = a6.last(t4), n4 = a6.nth(-2, t4);
              if (!r4 || !n4 || !e4.stream)
                return 1;
              const o2 = ((e5, t5, r5) => {
                const n5 = t5.timestamp - r5.timestamp;
                return t5[e5] && t5[e5].bytesReceived ? 8 * (t5[e5].bytesReceived - r5[e5].bytesReceived) / (n5 / 1e3) : 0;
              })("video", r4, n4), s3 = ((e5) => {
                const t5 = 2.069924867 * Math.pow(Math.log10(e5), 0.6250223771);
                return Math.pow(10, t5);
              })(e4.stream.videoDimensions.width * e4.stream.videoDimensions.height);
              if (o2 < 3e4)
                return 1;
              const i4 = Math.min(o2, s3);
              let c3 = Math.log(i4 / 3e4) / Math.log(s3 / 3e4) * 4 + 1;
              return c3 = Math.min(c3, 4.5), c3;
            }(t3, e3.statsLog);
            e3.videoScoresLog.push(p2);
            const E2 = d2(t3, n3, e3.statsLog);
            return e3.audioScoresLog.push(E2), e3.pruneScores(), o.default(e3.statsLog) ? (e3.clearInterval(), l3(e3)) : null;
          }));
        }, i2.default.scoreInterval), t3.on("destroyed", e3.clearInterval.bind(e3)), e3;
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(17), o = r2(18), s2 = r2(4);
      t2.default = function(e3) {
        const t3 = n2.default(e3), r3 = s2.default.steadyStateAllowedDelta;
        let i2 = true;
        if (t3.length < s2.default.minimumVideoAndAudioTestSampleSize)
          return false;
        const a6 = o.default(t3);
        return ["video", "audio"].forEach((e4) => {
          for (let t4 = 1; t4 < a6[e4].length; t4 += 1) {
            const n3 = a6[e4][t4].averageBitrate, o2 = a6[e4][t4 - 1].averageBitrate;
            n3 - o2 > o2 * r3 && (i2 = false);
          }
        }), i2;
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(17), o = r2(18), s2 = r2(56), i2 = r2(4), a6 = r2(1);
      function c2(e3, t3) {
        let r3 = 0, n3 = 0, o2 = 0;
        t3.forEach((t4) => {
          r3 += t4.averageBitrate, n3 += t4.packetLossRatio, e3 === "video" && (o2 += Number(a6.getOr(0, "frameRate", t4)));
        });
        const i3 = { bitrate: r3 / t3.length, packetLossRatio: n3 / t3.length };
        if (e3 === "video") {
          const { supported: r4, reason: n4, recommendedResolution: a7, recommendedFrameRate: c3 } = s2.default(i3), u2 = e3 === "video" ? { recommendedResolution: a7, recommendedFrameRate: c3, frameRate: o2 / t3.length } : {};
          return Object.assign({}, i3, { supported: r4, reason: n4 }, u2);
        }
        return Object.assign({}, i3);
      }
      t2.default = function(e3) {
        const t3 = n2.default(e3.statsLog), r3 = o.default(t3);
        return { audio: e3.hasAudioTrack() ? c2("audio", r3.audio) : { supported: false, reason: i2.default.strings.noMic }, video: e3.audioOnlyFallback ? { supported: false, reason: i2.default.strings.bandwidthLow } : e3.hasVideoTrack() ? c2("video", r3.video) : { supported: false, reason: i2.default.strings.noCam } };
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(4), o = r2(1);
      t2.default = function(e3) {
        const t3 = n2.default.qualityThresholds.video, r3 = e3.bitrate, s2 = e3.packetLossRatio;
        let i2, a6 = false, c2 = 30, u2 = "";
        for (let e4 = 0; e4 < t3.length; e4 += 1) {
          const n3 = t3[e4];
          if (r3 >= n3.bps && s2 <= n3.plr) {
            a6 = true, i2 = o.get("recommendedSetting", n3), c2 = Number(i2.substring(i2.indexOf("@") + 1).replace("FPS", "")), u2 = i2.substring(0, i2.indexOf("@") - 1);
            break;
          }
        }
        const l2 = { supported: a6, recommendedFrameRate: c2, recommendedResolution: u2 };
        return a6 ? (l2.recommendedFrameRate = c2, l2.recommendedResolution = u2) : l2.reason = n2.default.strings.bandwidthLow, l2;
      };
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true }), t2.default = (e3) => new Promise((t3) => {
        if (typeof e3.getRtcStatsReport != "function")
          return t3(null);
        const r3 = e3.getRtcStatsReport();
        r3 ? r3.then(t3).catch(() => t3(null)) : e3.getRtcStatsReport((e4, r4) => {
          t3(r4);
        });
      });
    }, function(e2, t2, r2) {
      Object.defineProperty(t2, "__esModule", { value: true });
      const n2 = r2(1);
      t2.default = function() {
        const e3 = function() {
          const e4 = window && window.navigator;
          return typeof window != "undefined" && window.navigator ? n2.get("mozGetUserMedia", e4) ? "Firefox" : n2.get("webkitGetUserMedia", e4) ? window.hasOwnProperty("webkitRTCPeerConnection") ? e4.userAgent.match(/Edg/) ? "Edge" : e4.userAgent.match(/Opera|OPR\//) ? "Opera" : "Chrome" : e4.userAgent.match(/Version\/(\d+).(\d+)/) ? "Safari" : "WebKit browser without WebRTC support" : e4.mediaDevices && e4.userAgent.match(/Edge\/(\d+).(\d+)$/) ? "non-Chromium Edge" : e4.userAgent.indexOf("MSIE ") > 0 || e4.userAgent.match(/Trident.*rv\:11\./) ? "Internet Explorer" : e4.mediaDevices && e4.userAgent.match(/AppleWebKit\/(\d+)\./) ? "Safari" : "unsupported browser" : "not a browser";
        }();
        return { browser: e3, supported: ["Chrome", "Firefox", "Safari", "Edge", "Opera"].indexOf(e3) > -1 };
      };
    }, function(e2, t2, r2) {
      var n2, o, s2;
      var i2 = function() {
        function e3(e4, t3) {
          for (var r3 = 0; r3 < t3.length; r3++) {
            var n3 = t3[r3];
            n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(e4, n3.key, n3);
          }
        }
        return function(t3, r3, n3) {
          return r3 && e3(t3.prototype, r3), n3 && e3(t3, n3), t3;
        };
      }(), a6 = Object.assign || function(e3) {
        for (var t3 = 1; t3 < arguments.length; t3++) {
          var r3 = arguments[t3];
          for (var n3 in r3)
            Object.prototype.hasOwnProperty.call(r3, n3) && (e3[n3] = r3[n3]);
        }
        return e3;
      };
      o = [r2(6)], (s2 = typeof (n2 = function(e3) {
        var t3 = false, r3 = void 0, n3 = function(e4) {
          return function(e5) {
            if (t3)
              return null;
            for (var r4 = e5 + "=", n4 = document.cookie.split(";"), o3 = void 0, s3 = 0; s3 < n4.length; s3++) {
              for (o3 = n4[s3]; o3.charAt(0) === " "; )
                o3 = o3.substring(1, o3.length);
              if (o3.indexOf(r4) === 0)
                return o3.substring(r4.length, o3.length);
            }
            return null;
          }(e4) || function(e5, r4, n4) {
            if (t3)
              return r4;
            var o3 = "", s3 = void 0;
            n4 && ((s3 = new Date()).setTime(s3.getTime() + 24 * n4 * 60 * 60 * 1e3), o3 = ["; expires=", s3.toGMTString()].join(""));
            var i3 = [e5, "=", r4, o3, "; path=/"].join("");
            return document.cookie = i3, r4;
          }(e4, function() {
            for (var e5 = [], t4 = "0123456789abcdef", r4 = 0; r4 < 36; r4++)
              e5.push(t4.substr(Math.floor(16 * Math.random()), 1));
            return e5[14] = "4", e5[19] = t4.substr(3 & e5[19] | 8, 1), e5[8] = e5[13] = e5[18] = e5[23] = "-", e5.join("");
          }(), 7);
        }, o2 = function(n4) {
          var o3 = function(e4) {
            if (!e4.clientVersion)
              throw console.log("Error. The clientVersion field cannot be null in the log entry"), new Error("The clientVersion field cannot be null in the log entry");
            if (!e4.source)
              throw console.log("Error. The source field cannot be null in the log entry"), new Error("The source field cannot be null in the log entry");
            if (!e4.componentId)
              throw console.log("Error. The componentId field cannot be null in the log entry"), new Error("The componentId field cannot be null in the log entry");
            if (!e4.name)
              throw console.log("Error. The name field cannot be null in the log entry"), new Error("The guid field cannot be null in the log entry");
            var t4 = e4.logVersion || "2", r4 = e4.clientSystemTime || new Date().getTime();
            return a6({}, e4, { logVersion: t4, clientSystemTime: r4 });
          }(n4);
          if (t3)
            e3.post(r3, o3);
          else {
            var s3 = new XMLHttpRequest();
            s3.open("POST", r3, true), s3.setRequestHeader("Content-type", "application/json"), s3.send(JSON.stringify(o3));
          }
        };
        return function() {
          function e4(o3, s3) {
            (function(e5, t4) {
              if (!(e5 instanceof t4))
                throw new TypeError("Cannot call a class as a function");
            })(this, e4), this.analyticsData = o3, t3 = s3 && s3.server;
            var i3 = "hlg.tokbox.com/prod/logging/ClientEvent";
            r3 = s3 && s3.proxyUrl && s3.proxyUrl + "/" + i3 || "https://" + i3, this.analyticsData.guid = n3(o3.name);
          }
          return i2(e4, [{ key: "addSessionInfo", value: function(e5) {
            if (!e5.sessionId)
              throw console.log("Error. The sessionId field cannot be null in the log entry"), new Error("The sessionId field cannot be null in the log entry");
            if (this.analyticsData.sessionId = e5.sessionId, !e5.connectionId)
              throw console.log("Error. The connectionId field cannot be null in the log entry"), new Error("The connectionId field cannot be null in the log entry");
            if (this.analyticsData.connectionId = e5.connectionId, e5.partnerId === 0)
              throw console.log("Error. The partnerId field cannot be null in the log entry"), new Error("The partnerId field cannot be null in the log entry");
            this.analyticsData.partnerId = e5.partnerId;
          } }, { key: "logEvent", value: function(e5) {
            this.analyticsData = a6({}, this.analyticsData, e5, { clientSystemTime: new Date().getTime() }), o2(this.analyticsData);
          } }]), e4;
        }();
      }) == "function" ? n2.apply(t2, o) : n2) === void 0 || (e2.exports = s2);
    }]);
  });
})(NetworkTest$1);
var NetworkTest = /* @__PURE__ */ getDefaultExportFromCjs(NetworkTest$1.exports);
var deleteIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiMzRjNFNDAiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzLjUgMi43NTJMOS4yNjggNi45ODdsNC4yMzQgNC4yMzRhMS42MTMgMS42MTMgMCAwIDEtMi4yOCAyLjI4TDYuOTg3IDkuMjY3IDIuNzUyIDEzLjVhMS42MDcgMS42MDcgMCAwIDEtMS4xNC40NzIgMS42MTMgMS42MTMgMCAwIDEtMS4xNC0yLjc1M2w0LjIzNC00LjIzM0wuNDcyIDIuNzUyYTEuNjEyIDEuNjEyIDAgMCAxIDIuMjgtMi4yOGw0LjIzNSA0LjIzNEwxMS4yMi40NzJhMS42MTMgMS42MTMgMCAwIDEgMi4yOCAyLjI4eiIvPgo8L3N2Zz4K";
var interviewerIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MyIgdmlld0JveD0iMCAwIDQzIDQzIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMjEuNSIgY3k9IjIxLjUiIHI9IjIxLjUiIGZpbGw9IiM1OTU5NTkiLz4KICAgICAgICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNMjIgOGMtNS40ODEgMC05Ljk0MSA0LjQ2LTkuOTQxIDkuOTQxdjkuMTc3YTIuMjk3IDIuMjk3IDAgMCAwIDIuMjk0IDIuMjk0IDIuMjk3IDIuMjk3IDAgMCAwIDIuMjk0LTIuMjk0VjE5LjQ3YTIuMjk3IDIuMjk3IDAgMCAwLTIuMjk0LTIuMjk0Yy0uMjU4IDAtLjUwMS4wNTItLjczMy4xMy4zMjctNC4zNDIgMy45NTYtNy43NzggOC4zOC03Ljc3OCA0LjQyMSAwIDguMDUgMy40MzMgOC4zOCA3Ljc3MmEyLjI1MyAyLjI1MyAwIDAgMC0uNzMzLS4xMjQgMi4yOTcgMi4yOTcgMCAwIDAtMi4yOTQgMi4yOTR2Ny42NDdhMi4yOTcgMi4yOTcgMCAwIDAgMi4yOTQgMi4yOTRjLjI3IDAgLjUyNC0uMDU1Ljc2NS0uMTQxdi45MDZhLjc2Ni43NjYgMCAwIDEtLjc2NS43NjRoLTUuNDk0QTIuMjkgMi4yOSAwIDAgMCAyMiAyOS40MTFhMi4yOTcgMi4yOTcgMCAwIDAtMi4yOTQgMi4yOTVBMi4yOTcgMi4yOTcgMCAwIDAgMjIgMzRhMi4yOSAyLjI5IDAgMCAwIDIuMTUzLTEuNTNoNS40OTRhMi4yOTcgMi4yOTcgMCAwIDAgMi4yOTQtMi4yOTNWMTcuOTRDMzEuOTQxIDEyLjQ2IDI3LjQ4MSA4IDIyIDh6TTMzLjQ3IDE4Ljg0N3Y4Ljg5NEEyLjI5IDIuMjkgMCAwIDAgMzUgMjUuNTg4VjIxYTIuMjkgMi4yOSAwIDAgMC0xLjUzLTIuMTUzek05IDIxdjQuNTg4YTIuMjkgMi4yOSAwIDAgMCAxLjUzIDIuMTUzdi04Ljg5NEEyLjI5IDIuMjkgMCAwIDAgOSAyMXoiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
var userIcon = "data:image/png;base64,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";
var readMessage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8ZyBmaWxsPSIjMENENUEyIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIgMjRDNS4zODQgMjQgMCAxOC42MTcgMCAxMiAwIDUuMzg0IDUuMzg0IDAgMTIgMGM2LjYxNyAwIDEyIDUuMzg0IDEyIDEyIDAgNi42MTctNS4zODMgMTItMTIgMTJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEzIC02MTgpIHRyYW5zbGF0ZSgxMTMgNjE4KSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTE2Ljc1MiAxNS43NWMtLjMyNy4zMzMtLjg1NC4zMzMtMS4xODEgMGwtMy41OTQtMy42ODEtMy41OTQgMy42ODFjLS4zNTEuMzA4LS44OC4yNjYtMS4xODEtLjA5My0uMjctLjMyMS0uMjctLjc5NiAwLTEuMTE3bDQuMTg4LTQuMjljLjMyNy0uMzMzLjg1NS0uMzMzIDEuMTgyIDBsNC4xODggNC4yOWMuMzIzLjMzOC4zMi44NzgtLjAwOCAxLjIxeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMyAtNjE4KSB0cmFuc2xhdGUoMTEzIDYxOCkgcm90YXRlKC0xODAgMTIgMTMpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
var localizedFormat$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(commonjsGlobal, function() {
    var e2 = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(t2, o, n2) {
      var r2 = o.prototype, i2 = r2.format;
      n2.en.formats = e2, r2.format = function(t3) {
        t3 === void 0 && (t3 = "YYYY-MM-DDTHH:mm:ssZ");
        var o2 = this.$locale().formats, n3 = function(t4, o3) {
          return t4.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t5, n4, r3) {
            var i3 = r3 && r3.toUpperCase();
            return n4 || o3[r3] || e2[r3] || o3[i3].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e3, t6, o4) {
              return t6 || o4.slice(1);
            });
          });
        }(t3, o2 === void 0 ? {} : o2);
        return i2.call(this, n3);
      };
    };
  });
})(localizedFormat$1);
var localizedFormat = localizedFormat$1.exports;
dayjs.extend(localizedFormat);
const NewMessage = styled.button`
  display: block;
  cursor: pointer;
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  bottom: 66px;
  min-width: 200px;
  white-space: nowrap;
  height: 60px;
  padding: 17px 19px 15px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
  border: solid 1px #cccccc;
  background-color: #ffffff;

  & img {
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
`;
const SENDER = "interviewer";
function ChatView({
  messages = [],
  onClose = emptyFunc,
  onSendMessage = emptyFunc,
  setUnreadMessages
}) {
  const {
    t: t2
  } = useTranslation();
  const [input, setInput] = useState("");
  const messagesElement = useRef(null);
  const receivedMessagesRef = useRef([]);
  const [newMessages, setNewMessages] = useState(0);
  const [messageSentByUser, setMessageSentByUser] = useState(false);
  useEventListener("scroll", handleScroll3, messagesElement.current);
  const markMessagesAsRead = useCallback(() => {
    receivedMessagesRef.current.forEach((_24, index2) => {
      receivedMessagesRef.current[index2].read = true;
    });
    setNewMessages(0);
    scrollToBottom();
  }, []);
  useEffect(() => {
    enableBodyScroll(document.getElementsByTagName("html")[0]);
    return clearAllBodyScrollLocks();
  }, []);
  useLayoutEffect(() => {
    function handleUnReadMessages() {
      if (receivedMessagesRef.current.length === 0) {
        const filteredNewMessages = messages.filter((message2) => message2.author === SENDER && !receivedMessagesRef.current.some((messageRef) => messageRef.date === message2.date));
        if (filteredNewMessages.length > 0) {
          receivedMessagesRef.current = [...receivedMessagesRef.current, ...filteredNewMessages];
        }
      } else {
        receivedMessagesRef.current = messages.filter((message2) => message2.author === SENDER);
      }
      const unreadMessages = receivedMessagesRef.current.reduce((acc, current) => {
        if (!current.read) {
          acc += 1;
        }
        return acc;
      }, 0);
      setNewMessages(unreadMessages);
      if (unreadMessages === 0 || messageSentByUser || unreadMessages > 0 && thresholdReached(messagesElement.current.scrollTop)) {
        markMessagesAsRead();
        setMessageSentByUser(false);
      }
    }
    handleUnReadMessages();
  }, [messages, markMessagesAsRead, messageSentByUser]);
  useEffect(() => {
    setUnreadMessages(0);
    return () => setUnreadMessages(0);
  }, [setUnreadMessages]);
  const scrollToBottom = () => {
    messagesElement.current.scrollTop = messagesElement.current.scrollHeight;
  };
  function handleScroll3(event) {
    const {
      target: {
        scrollTop
      }
    } = event;
    if (thresholdReached(scrollTop)) {
      markMessagesAsRead();
    }
  }
  function thresholdReached(scrollTop) {
    const height2 = messagesElement.current.scrollHeight - messagesElement.current.clientHeight;
    return height2 === scrollTop;
  }
  const handleSendMessage = (event) => {
    event.preventDefault();
    onSendMessage(input);
    setInput("");
    setMessageSentByUser(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "chatScreenBack",
      onClick: onClose
    }), /* @__PURE__ */ jsxs("div", {
      className: "chatScreen",
      tabIndex: 1,
      children: [/* @__PURE__ */ jsx("div", {
        className: "chat-header",
        children: /* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "no-style",
          children: /* @__PURE__ */ jsx("img", {
            src: deleteIcon,
            alt: "delete icon"
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "messages",
        ref: messagesElement,
        children: messages.map((message2) => /* @__PURE__ */ jsxs("div", {
          className: classNames("message-container", {
            mine: message2.author === "user",
            "from-other": message2.author === "interviewer"
          }),
          children: [/* @__PURE__ */ jsx("div", {
            className: "avatar",
            children: /* @__PURE__ */ jsx("img", {
              src: message2.author === "interviewer" ? interviewerIcon : userIcon,
              alt: "avatar"
            })
          }), /* @__PURE__ */ jsx("div", {
            className: classNames("message", {
              mine: message2.author === "user",
              "from-other": message2.author === "interviewer"
            }),
            style: {
              color: message2.author === "user" ? "white" : "black"
            },
            children: message2.body
          }), /* @__PURE__ */ jsx("span", {
            className: "date",
            children: dayjs(message2.date).format("MMM D LT")
          })]
        }, message2.date + message2.body))
      }), newMessages > 0 && /* @__PURE__ */ jsxs(NewMessage, {
        onClick: markMessagesAsRead,
        children: [/* @__PURE__ */ jsx("img", {
          src: readMessage,
          alt: "new message"
        }), /* @__PURE__ */ jsx("span", {
          children: `${newMessages} new message(s)`
        })]
      }), /* @__PURE__ */ jsxs("form", {
        className: "message-form",
        onSubmit: handleSendMessage,
        children: [/* @__PURE__ */ jsx("input", {
          type: "text",
          className: "send-message-input",
          value: input,
          onChange: (ev) => setInput(ev.target.value),
          placeholder: t2("support.writeMessage")
        }), /* @__PURE__ */ jsx("button", {
          disabled: !input,
          className: "no-style",
          children: t2("common.send")
        })]
      })]
    })]
  });
}
var chatIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPGNpcmNsZSBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiIGZpbGw9IiNGRkYiLz4KICAgICAgICA8ZyBmaWxsPSIjMjEyNzNCIj4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjMjEyNzNCIiBzdHJva2Utd2lkdGg9Ii4yIiBkPSJNMjMuMDI0IDQ4Ljg2Yy0yLjE3NSAxLjU1My00LjQ2MyAyLjItNi42OTEgMi4yLS41NTQgMC0xLjA2LS4wNDMtMS41MTgtLjExNGExLjg4MSAxLjg4MSAwIDAgMS0xLjU3LTEuNTc3IDEuODY4IDEuODY4IDAgMCAxIDEuMDI3LTEuOTdjMS4yMy0uNjA0IDIuMjE0LTEuNzY4IDIuOTctMy4yNy02LjIyOC03LjU1LTUuNzAzLTE4LjY4NCAxLjI0NS0yNS42MzJBMTguOTYyIDE4Ljk2MiAwIDAgMSAzMS45OSAxMi45YzUuMTAzIDAgOS44OTMgMS45ODYgMTMuNTA0IDUuNTk3IDMuNjE0IDMuNjE0IDUuNjA0IDguNDA1IDUuNjA0IDEzLjUwMyAwIDUuMTAyLTEuOTg1IDkuODkyLTUuNTk2IDEzLjUwM2ExOS4wOTYgMTkuMDk2IDAgMCAxLTEzLjUyIDUuNTk3Yy0zLjExMyAwLTYuMTg2LS43Ni04Ljk1OC0yLjI0em0tNi4zOTYtLjE3NGMxLjc4OC0uMDYgMy42MjQtLjY2MSA1LjM2Mi0yLjAwN2EuMjYzLjI2MyAwIDAgMSAuMDg4LS4wNjQgMS4xOCAxLjE4IDAgMCAxIDEuNDQtLjE4NGM2LjU2NCAzLjg1NyAxNC45MSAyLjc4NyAyMC4zLTIuNjA0IDYuNTI2LTYuNTI1IDYuNTIzLTE3LjEzMS0uMDA4LTIzLjY1NC02LjUxNy02LjUyNS0xNy4xMy02LjUyNS0yMy42NTUgMC02LjI0MyA2LjI0My02LjU1IDE2LjMwNS0uNzAyIDIyLjkxMy4xNjIuMTg3LjI2Mi40MjEuMjg2LjY1MS4wNjMuMjUuMDQzLjUxMy0uMDYxLjc2NC0uNzQyIDEuNjktMS43NDQgMy4xNTItMy4wNSA0LjE4NXoiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTI0IDMxaDN2M2gtM3pNMzAgMzFoM3YzaC0zek0zNiAzMWgzdjNoLTN6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
function Chat({
  session,
  playAlert,
  unreadMessages,
  setUnreadMessages
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  useEffect(() => {
    session.on("signal:msg", (event) => {
      const messageObject = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      const newMessage = {
        date: Date.now(),
        body: messageObject.message,
        author: messageObject.author
      };
      setMessages((messages2) => [...messages2, newMessage]);
      if (messageObject.author === "interviewer") {
        setUnreadMessages((currentUnreadMessages) => currentUnreadMessages + 1);
      }
    });
    session.on("signal:wake-up", () => {
      playAlert();
    });
  }, [session]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("button", {
      className: "float-button no-style",
      onClick: () => {
        setIsOpen(true);
      },
      children: /* @__PURE__ */ jsxs("div", {
        className: "button-inside",
        children: [unreadMessages > 0 && /* @__PURE__ */ jsx("div", {
          className: "indicator",
          children: unreadMessages
        }), /* @__PURE__ */ jsx("img", {
          src: chatIcon,
          alt: "chat icon"
        })]
      })
    }), isOpen && /* @__PURE__ */ jsx(ChatView, {
      onClose: () => setIsOpen(false),
      messages,
      setUnreadMessages,
      onSendMessage: (message2) => {
        session.signal({
          type: "msg",
          data: JSON.stringify({
            message: message2,
            author: "user"
          })
        });
      }
    })]
  });
}
var phone$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDI1IDEwIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTIuMTc1IDkuMDA3bDQuMTU0LjAwNWMuODI2IDAgMS40OTgtLjY5NyAxLjQ5Ny0xLjU1NGwtLjAwMi0yLjA5M2MuMTAyLS4wMy4yMDktLjA2LjMyMS0uMDkgMS4wMjctLjI5NCAyLjQzMy0uNjk1IDQuMzM3LS42OTIgMS45MDkuMDAyIDMuMzE4LjQwNyA0LjM0Ny43MDJsLjMxNC4wOXYxLjQwM2wuMDAyLjY5MWMwIC44NTguNjc1IDEuNTU1IDEuNSAxLjU1N2w0LjE1Ni4wMDVjLjgyNSAwIDEuNDk3LS42OTYgMS40OTYtMS41NTRsLS4wMDUtMS4xNzRoLS4wMzFjLS4wNTUtLjQ0Ny0uMTgtLjktLjM3LTEuMzM0YTUuMDA0IDUuMDA0IDAgMCAwLS42NS0xLjA3OEMyMS4yMzggMS4zNCAxOC4xMi4yOTggMTIuNDguMjkgNC42ODQuMjgzIDEuODQgMy43MTUgMS43MiAzLjg2NWMtLjI2LjMzLS40NzIuNjgzLS42NDcgMS4wODItLjE4OC40My0uMzEyLjg4Mi0uMzY2IDEuMzI4bC0uMDI0LjAwMUwuNjczIDcuNDVjLjAwMi44NTcuNjc1IDEuNTU1IDEuNTAyIDEuNTU3eiIvPgo8L3N2Zz4K";
var mic = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDE0IDIxIj4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTcuMDAyIDE0LjUxYzEuMDY5IDAgMS45ODQtLjM5NSAyLjc0NS0xLjE4NC43NjItLjc4OSAxLjE0Mi0xLjczOCAxLjE0Mi0yLjg0NlY0LjAzYzAtMS4xMDgtLjM4LTIuMDU2LTEuMTQyLTIuODQ2QzguOTg3LjM5NCA4LjA3MSAwIDcuMDAyIDBjLTEuMDcgMC0xLjk4NS4zOTUtMi43NDYgMS4xODQtLjc2MS43OS0xLjE0MiAxLjczOC0xLjE0MiAyLjg0N3Y2LjQ0OWMwIDEuMTA4LjM4IDIuMDU3IDEuMTQyIDIuODQ2Ljc2MS43OSAxLjY3NyAxLjE4NCAyLjc0NiAxLjE4NHoiLz4KICAgICAgICA8cGF0aCBkPSJNMTMuNzY5IDguM2EuNzM0LjczNCAwIDAgMC0uNTQ3LS4yMzljLS4yMSAwLS4zOTMuMDgtLjU0Ny4yNGEuNzkuNzkgMCAwIDAtLjIzLjU2NnYxLjYxM2MwIDEuNTUzLS41MzMgMi44ODItMS41OTggMy45ODYtMS4wNjUgMS4xMDUtMi4zNDcgMS42NTctMy44NDUgMS42NTctMS40OTkgMC0yLjc4LS41NTItMy44NDYtMS42NTctMS4wNjUtMS4xMDQtMS41OTctMi40MzMtMS41OTctMy45ODZWOC44NjdhLjc4OS43ODkgMCAwIDAtLjIzLS41NjYuNzM0LjczNCAwIDAgMC0uNTQ4LS4yNGMtLjIxIDAtLjM5My4wOC0uNTQ2LjI0YS43ODkuNzg5IDAgMCAwLS4yMzEuNTY2djEuNjEzYzAgMS44NTYuNTk3IDMuNDcgMS43OTIgNC44NDMgMS4xOTQgMS4zNzMgMi42NyAyLjE2IDQuNDI4IDIuMzYxdjEuNjYzaC0zLjExYy0uMjEgMC0uMzkzLjA4LS41NDcuMjRhLjc4OS43ODkgMCAwIDAtLjIzLjU2Ni43OS43OSAwIDAgMCAuMjMuNTY3Yy4xNTQuMTYuMzM2LjI0LjU0Ny4yNGg3Ljc3NWMuMjEgMCAuMzkzLS4wOC41NDctLjI0YS43ODkuNzg5IDAgMCAwIC4yMzEtLjU2Ny43ODguNzg4IDAgMCAwLS4yMzEtLjU2Ni43MzQuNzM0IDAgMCAwLS41NDctLjI0SDcuNzh2LTEuNjYzYzEuNzU4LS4yMDEgMy4yMzQtLjk4OCA0LjQyOS0yLjM2MUMxMy40MDIgMTMuOTUgMTQgMTIuMzM2IDE0IDEwLjQ4VjguODY3YS43ODkuNzg5IDAgMCAwLS4yMzEtLjU2NnoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
var innerLoader = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aW5uZXItbG9hZGVyLTJAMXg8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImlubmVyLWxvYWRlci0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjAwMDAwMCwgMi4wMDAwMDApIiBzdHJva2U9IiMyMTI3M0IiIHN0cm9rZS13aWR0aD0iMyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiwyNCBDMTguNjI3MzMzMywyNCAyNCwxOC42MjczMzMzIDI0LDEyIEMyNCw1LjM3MjY2NjY3IDE4LjYyNzMzMzMsMCAxMiwwIEM1LjM3MjY2NjY3LDAgMCw1LjM3MjY2NjY3IDAsMTIiIGlkPSJQYXRoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4wMDAwMDAsIDEyLjAwMDAwMCkgcm90YXRlKDE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTIuMDAwMDAwLCAtMTIuMDAwMDAwKSAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
var outterLoader = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+b3V0dGVyLWxvYWRlci0yQDF4PC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJvdXR0ZXItbG9hZGVyLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDAwMDAwLCAyLjAwMDAwMCkiIHN0cm9rZT0iIzAwQjJGRCIgc3Ryb2tlLXdpZHRoPSIzIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE4LDM2IEMyNy45NDEsMzYgMzYsMjcuOTQxIDM2LDE4IEMzNiw4LjA1OSAyNy45NDEsMCAxOCwwIEM4LjA1OSwwIDAsOC4wNTkgMCwxOCIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
const SpinnerContainer = styled.div`
  position: relative;
  height: 40px;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes reverse-spinner {
    to {
      transform: rotate(-360deg);
    }
  }

  .loader-img {
    position: absolute;
    max-width: unset;
  }

  .outter {
    left: calc(50% - 21px);
    animation: spinner 0.6s linear infinite;
  }

  .inner {
    top: 6px;
    left: calc(50% - 15px);
    animation: reverse-spinner 0.6s linear infinite;
  }
`;
function Spinner() {
  return /* @__PURE__ */ jsxs(SpinnerContainer, {
    className: "IncodeBandwidthSpinner",
    children: [/* @__PURE__ */ jsx("img", {
      className: "loader-img outter",
      src: outterLoader,
      alt: "loading..."
    }), /* @__PURE__ */ jsx("img", {
      className: "loader-img inner",
      src: innerLoader,
      alt: "loading..."
    })]
  });
}
var smsIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSI1NCIgdmlld0JveD0iMCAwIDQ1IDU0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iIzIwMjYzRCIgZD0iTTI3LjcxOCAwYzMuMzY5IDAgNi4xMSAyLjczMSA2LjExIDYuMDg4djcuOTY2aDMuNTY3YzMuOTk1IDAgNy4yNDUgMy4yMzkgNy4yNDUgNy4yMTl2NS45MDFjMCAzLjk4LTMuMjUgNy4yMi03LjI0NSA3LjIyaC0zLjU2OHYxMy41MThjMCAzLjM1Ny0yLjc0IDYuMDg4LTYuMTEgNi4wODhINi4xMUMyLjc0IDU0IDAgNTEuMjY5IDAgNDcuOTEyVjYuMDg4QzAgMi43MyAyLjc0MSAwIDYuMTEgMHpNOC42OSAyLjg4SDUuOGMtMS42MSAwLTIuOTIgMS4zMDctMi45MiAyLjkxM3Y0MS42OTRjMCAxLjYwNiAxLjMxIDIuOTEzIDIuOTIgMi45MTNoMjEuNTJjMS42MSAwIDIuOTItMS4zMDcgMi45Mi0yLjkxM1YzNC4wMWgtNy4yNTZsLTUuMDg4IDIuNTYyYy0uMzAxLjE3Ni0uNjQuMjY2LS45NzkuMjY2LS4zMDUgMC0uNjEyLS4wNzItLjg5NS0uMjE5LS42NDQtLjMzNC0xLjA0NC0uOTktMS4wNDQtMS43MTVWMjAuOTMxYzAtMy45NjggMy4yMzctNy4xOTYgNy4yMTUtNy4xOTZoOC4wNDdWNS43OTNjMC0xLjYwNi0xLjMxLTIuOTEzLTIuOTItMi45MTNoLTIuODl2MS42ODljMCAxLjY2OS0xLjM2MSAzLjAyNy0zLjAzNCAzLjAyN2gtOS42NzFjLTEuNjc0IDAtMy4wMzUtMS4zNTgtMy4wMzUtMy4wMjdWMi44OHptMTEuMzMgNDEuNzZjLjg3MyAwIDEuNTguNjQ1IDEuNTggMS40NCAwIC43OTUtLjcwNyAxLjQ0LTEuNTggMS40NGgtNi4yYy0uODczIDAtMS41OC0uNjQ1LTEuNTgtMS40NCAwLS43OTUuNzA3LTEuNDQgMS41OC0xLjQ0ek0yMS42IDIuODhoLTkuMzZ2MS40NGg5LjM2VjIuODh6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzNDQjBGNyIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMzcuNjc4IDE3LjI4YzIuMjUgMCA0LjA4MiAxLjc5MiA0LjA4MiAzLjk5NXY1LjgxNWMwIDIuMjAzLTEuODMxIDMuOTk0LTQuMDgyIDMuOTk0aC0xNC4zOGMtLjM1MSAwLS42OS4wOS0uOTg5LjI2M0wxOC43MiAzMy4xMlYyMS4yNzVjMC0yLjIwMyAxLjgzMS0zLjk5NSA0LjA4Mi0zLjk5NWgxNC44NzZ6bS0uMzc5IDcuOTJoLTYuOTE4Yy0uODczIDAtMS41ODEuNjQ1LTEuNTgxIDEuNDQgMCAuNzk1LjcwOCAxLjQ0IDEuNTgxIDEuNDRoNi45MThjLjg3MyAwIDEuNTgxLS42NDUgMS41ODEtMS40NCAwLS43OTUtLjcwOC0xLjQ0LTEuNTgxLTEuNDR6bS0uMDI2LTUuNzZIMjMuMjA3Yy0uODg3IDAtMS42MDcuNjQ1LTEuNjA3IDEuNDQgMCAuNzk1LjcyIDEuNDQgMS42MDcgMS40NGgxNC4wNjZjLjg4NyAwIDEuNjA3LS42NDUgMS42MDctMS40NCAwLS43OTUtLjcyLTEuNDQtMS42MDctMS40NHoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
const SmsContainer = styled.div`
  display: flex;
  padding: 0px 15px;
`;
const SmsIconImg = styled.img`
  width: 45px;
`;
const SmsText = styled.p`
  font-size: 18px;
  font-weight: bold;
`;
const SMSMessageContainer = styled.div`
  padding: 0 20px;
`;
function SMSMesage({
  onDisconnect
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(SMSMessageContainer, {
    className: "IncodeSMSMessageContainer",
    children: [/* @__PURE__ */ jsxs(SmsContainer, {
      className: "IncodeSMSContainer",
      children: [/* @__PURE__ */ jsx(SmsIconImg, {
        src: smsIcon,
        alt: "phone with sms",
        className: "IncodeSMSIconImg"
      }), /* @__PURE__ */ jsx(SmsText, {
        className: "IncodeSmsText",
        children: t2("conference.smsMessage")
      })]
    }), /* @__PURE__ */ jsx(DisconnectButton, {
      className: "IncodeDisconnectButton IncodeDisconnectButtonQueue",
      onClick: onDisconnect,
      children: t2("support.disconnectWaitingRoom")
    })]
  });
}
var spinner$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjg2IiBoZWlnaHQ9IjI4NiIgdmlld0JveD0iMCAwIDI4NiAyODYiPgogICAgPGRlZnM+CiAgICAgICAgPGNpcmNsZSBpZD0iYSIgY3g9IjE1MCIgY3k9IjE1MCIgcj0iMTMxIi8+CiAgICAgICAgPG1hc2sgaWQ9ImIiIHdpZHRoPSIyODYiIGhlaWdodD0iMjg2IiB4PSItMTIiIHk9Ii0xMiI+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik03IDdoMjg2djI4Nkg3eiIvPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgPC9kZWZzPgogICAgPHVzZSBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzFDMUYyOCIgc3Ryb2tlLWRhc2hhcnJheT0iMyw1IiBzdHJva2Utd2lkdGg9IjI0IiBtYXNrPSJ1cmwoI2IpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtNykiIHhsaW5rOmhyZWY9IiNhIi8+Cjwvc3ZnPgo=";
const spinnerAnimation = Ue`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const SpinnerImg = styled.img`
  position: absolute;
  animation: ${spinnerAnimation} 0.6s linear infinite;
`;
const Footer$1 = styled.div`
  text-align: center;
  width: 100%;
`;
const ConnectingParagraph = styled.p`
  padding: 10px;
`;
const BandwithContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
const BandwithTitle = styled.h1`
  font-weight: normal;
`;
const BandwidthSubtitle = styled.h2`
  display: none;
`;
const BandwithParagraph = styled.p`
  opacity: 0.5;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #21273b;
`;
const ConnectingTitle = styled.h1`
  display: none;
`;
const ConnectingImage = styled.img`
  display: none;
`;
const BandwidthImage = styled.img`
  display: none;
`;
const LoadingCircle = styled.div`
  height: ${(props) => props.noPadding ? "calc(100% - 90px)" : "100%"};
  display: flex;
  padding-top: ${(props) => props.noPadding ? "0px" : "30px"};
  position: fixed;
  justify-content: space-evenly;
  flex-direction: column;
  top: ${(props) => props.noPadding ? "90px" : "0"};
  width: 100%;
`;
const SpinnerInner = styled.div`
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
`;
function Connecting({
  index: index2,
  bandwidth,
  onDisconnect,
  onlyCircle = false,
  incodeConnectingImageSrc,
  incodeBandwidthImageSrc
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, {
    children: bandwidth ? /* @__PURE__ */ jsxs(BandwithContainer, {
      className: "IncodeBandwithContainer",
      children: [/* @__PURE__ */ jsx(BandwithTitle, {
        className: "IncodeBandwithTitle",
        children: t2("conference.networkTest")
      }), /* @__PURE__ */ jsx(BandwidthImage, {
        alt: "checking bandwidth",
        className: "IncodeBandwidthImage",
        src: incodeBandwidthImageSrc
      }), /* @__PURE__ */ jsx(BandwidthSubtitle, {
        className: "IncodeBandwidthSubtitle",
        children: t2("conference.networkTestSubtitle")
      }), /* @__PURE__ */ jsx(Spinner, {}), /* @__PURE__ */ jsx(BandwithParagraph, {
        className: "IncodeBandwithText",
        children: bandwidth
      })]
    }) : /* @__PURE__ */ jsxs(LoadingCircle, {
      noPadding: onlyCircle,
      className: "IncodeLoadingCircleContainer",
      children: [/* @__PURE__ */ jsx(ConnectingTitle, {
        className: "IncodeConnectingTitle",
        children: t2("support.connectingTitle")
      }), /* @__PURE__ */ jsx(ConnectingImage, {
        className: "IncodeConnectingImage",
        alt: "connecting",
        src: incodeConnectingImageSrc
      }), /* @__PURE__ */ jsxs(SpinnerInner, {
        className: "IncodeLoadingCircleSpinnerInner",
        children: [/* @__PURE__ */ jsx(SpinnerImg, {
          src: spinner$1,
          alt: "spinner",
          className: "IncodeLoadingCircleImg"
        }), /* @__PURE__ */ jsx(ConnectingParagraph, {
          className: "IncodeLoadingCircleConnectingText",
          children: t2("support.bankRepresentativeSoon")
        }), index2 && index2 > 0 ? /* @__PURE__ */ jsx(ConnectingParagraph, {
          className: "IncodeLoadingCircleConnectingText",
          children: /* @__PURE__ */ jsxs(Trans, {
            i18nKey: "support.queuePlace",
            children: ["Place in the queue is:", /* @__PURE__ */ jsx("span", {
              className: "IncodeConnectingSpan",
              children: {
                index: index2
              }
            })]
          })
        }) : index2 && index2 === 0 ? `${t2("support.queueNext")}` : ""]
      }), !onlyCircle && /* @__PURE__ */ jsx(Footer$1, {
        className: "IncodeFooterSmsMessage",
        children: /* @__PURE__ */ jsx(SMSMesage, {
          onDisconnect
        })
      })]
    })
  });
}
const ExecutiveReadyContainer = styled.div`
  padding: 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
`;
const ExecutiveReadyTitle = styled.h1`
  display: none;
`;
const Message$1 = styled.p`
  font-size: 28px;
  color: #21273b;
  font-weight: bold;
`;
const ButtonsContainer$1 = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`;
const ExecutiveReadyImage = styled.img`
  display: none;
`;
function ExecutiveReady({
  onConnect,
  onDisconnect,
  incodeExecutiveReadyImageSrc
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(ExecutiveReadyContainer, {
    className: "IncodeExecutiveReadyContainer",
    children: [/* @__PURE__ */ jsx(ExecutiveReadyTitle, {
      className: "IncodeExecutiveReadyTitle",
      children: t2("conference.executiveReadyTitle")
    }), /* @__PURE__ */ jsx(ExecutiveReadyImage, {
      className: "IncodeExecutiveReadyImage",
      alt: "executive ready",
      src: incodeExecutiveReadyImageSrc
    }), /* @__PURE__ */ jsx(Message$1, {
      className: "IncodeExecutiveReadyMessage",
      children: t2("conference.executiveReady")
    }), /* @__PURE__ */ jsxs(ButtonsContainer$1, {
      className: "IncodeExecutiveReadyButtonContainer",
      children: [/* @__PURE__ */ jsx(Button$3, {
        className: "IncodeExecutiveReadyConnectButton",
        onClick: onConnect,
        children: t2("common.connect")
      }), /* @__PURE__ */ jsx(DisconnectButton, {
        className: "IncodeExecutiveReadyDisconnectButton",
        onClick: onDisconnect,
        children: t2("conference.disconnectExecutiveReady")
      })]
    })]
  });
}
const ModalSubtitle = styled.h2`
  display: none;
`;
const CloseButton = styled.button`
  position: absolute;
  background-color: transparent;
  top: 15px;
  right: 25px;
`;
const AreYouSureModalContainer = styled(Modal)`
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  border-radius: 4px;
  -webkit-overflow-scrolling: touch;
  outline: none;
  padding: 20px;
`;
const getTitle = (origin, t2) => {
  switch (origin) {
    case "waiting-room":
      return {
        title: t2("support.aysConnectingModalTitle"),
        subtitle: t2("support.aysConnectingModalSubtitle")
      };
    case "user-turn":
      return {
        title: t2("support.aysExecutiveReadyModalTitle"),
        subtitle: t2("support.aysExecutiveModalSubtitle")
      };
    case "support":
      return {
        title: t2("support.aysSupportModalTitle"),
        subtitle: t2("support.aysSupportModalSubtitle")
      };
    default:
      return {
        title: t2("conference.areYouSure"),
        subtitle: t2("conference.areYouSureSubtitle")
      };
  }
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "95vw",
    padding: "50px 30px",
    borderRadius: 25,
    textAlign: "center"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.67)",
    zIndex: 9999
  }
};
function AreYouSureModal({
  onDisconnect,
  closeModal,
  isOpen,
  theme: theme2,
  origin
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    title,
    subtitle
  } = getTitle(origin, t2);
  return /* @__PURE__ */ jsxs(AreYouSureModalContainer, {
    isOpen,
    style: __spreadProps(__spreadValues({}, customStyles), {
      content: __spreadValues(__spreadValues({}, customStyles.content), theme2.modal),
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.67)",
        zIndex: 9999
      }
    }),
    onRequestClose: closeModal,
    contentLabel: "Are You Sure Modal",
    shouldCloseOnOverlayClick: false,
    className: "IncodeAreYouSureModal",
    overlayClassName: "IncodeAreYouSureModalOverlay",
    children: [/* @__PURE__ */ jsx(CloseButton, {
      className: "IncodeAreYouSureModalCloseIconButton",
      onClick: closeModal,
      children: /* @__PURE__ */ jsx("span", {
        className: "IncodeAreYouSureModalCloseIconSpan"
      })
    }), /* @__PURE__ */ jsx(ModalTitle, {
      className: "IncodeAreYouSureModalTitle",
      children: title
    }), /* @__PURE__ */ jsx(ModalSubtitle, {
      className: "IncodeAreYouSureModalSubtitle",
      children: subtitle
    }), /* @__PURE__ */ jsxs("div", {
      className: "IncodeAreYouSureModalButtonsContainer",
      children: [/* @__PURE__ */ jsx(ModalButton, {
        onClick: closeModal,
        className: "IncodeAreYouSureModalContinueProcessButton",
        children: t2("conference.continueProcess")
      }), /* @__PURE__ */ jsx(DisconnectButton, {
        className: "IncodeAreYouSureModalDisconnectButton",
        onClick: onDisconnect,
        children: t2("conference.disconnect")
      })]
    })]
  });
}
const LegalModalContainer = styled(Modal)`
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  border-radius: 4px;
  -webkit-overflow-scrolling: touch;
  outline: none;
  padding: 20px;
`;
function LegalModal(_F) {
  var _G = _F, {
    handleDisconnect,
    onLog,
    session
  } = _G, props = __objRest(_G, [
    "handleDisconnect",
    "onLog",
    "session"
  ]);
  const {
    t: t2
  } = useTranslation();
  const [bureauAccepted, setBureauAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  function handleAccept() {
    onLog(getLogObject("clientAcceptedTerms", {
      status: "Client accepted terms"
    }));
    session.signal({
      type: "terms",
      data: {
        bureauAccepted,
        termsAccepted
      }
    });
    props.onRequestClose();
  }
  function handleDeny() {
    onLog(getLogObject("clientRejectedTerms", {
      message: "Client rejected terms so conference can't be continued"
    }));
    handleDisconnect();
  }
  return /* @__PURE__ */ jsxs(LegalModalContainer, __spreadProps(__spreadValues({
    style: {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)",
        zIndex: 1e3
      }
    },
    contentLabel: "Legal Modal"
  }, props), {
    className: "IncodeLegalModal",
    overlayClassName: "IncodeLegalModalOverlay",
    children: [/* @__PURE__ */ jsx(ModalTitle, {
      className: "IncodeLegalModalTitle",
      children: t2("conference.bureauTitle")
    }), /* @__PURE__ */ jsx(Checkbox, {
      id: "bureau",
      text: t2("conference.bureau"),
      handleChange: () => setBureauAccepted(!bureauAccepted)
    }), /* @__PURE__ */ jsx(ModalTitle, {
      className: "IncodeLegalModalTermsText",
      children: t2("conference.termsTitle")
    }), /* @__PURE__ */ jsx(Checkbox, {
      id: "terms",
      text: t2("conference.terms"),
      handleChange: () => setTermsAccepted(!termsAccepted)
    }), /* @__PURE__ */ jsxs("div", {
      className: "IncodeLegalModalButtonsContainer",
      children: [/* @__PURE__ */ jsx(ModalButton, {
        onClick: handleAccept,
        className: "IncodeLegalModalAcceptButton",
        disabled: !termsAccepted,
        children: t2("conference.accept")
      }), /* @__PURE__ */ jsx(DisconnectButton, {
        className: "IncodeLegalModalCancelButton",
        onClick: handleDeny,
        children: t2("conference.cancel")
      })]
    })]
  }));
}
function Error$4() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx("div", {
    className: "support",
    children: /* @__PURE__ */ jsx("div", {
      className: "card-wrapper",
      children: /* @__PURE__ */ jsxs("div", {
        className: "circle error",
        children: [/* @__PURE__ */ jsx("h1", {
          children: t2("common.error")
        }), /* @__PURE__ */ jsx("h2", {
          children: t2("support.noConnection")
        })]
      })
    })
  });
}
const conferenceStatus = {
  approve: "approve",
  badInternet: "no-internet",
  close: "close",
  deny: "deny",
  executiveDisconnected: "executive-disconnected",
  genericError: "generic-error",
  noBrowser: "no-browser",
  noDevice: "no-device",
  noPermission: "no-permissions",
  OTPError: "OTPError",
  noConnection: "no-connection"
};
const TEST_TIMEOUT = 5e3;
const ModalTitle = styled.h1`
  font-size: 23px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
`;
const ModalButton = styled(Button$3)`
  width: 100%;
  text-transform: none;
  margin-top: 30px;
`;
const waitingRoom = "waiting-room";
function Header({
  onFinishSession,
  onMute,
  audio,
  name
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("header", {
    className: "IncodeConferenceHeader",
    children: [/* @__PURE__ */ jsx("button", {
      className: classNames("mute", {
        muted: !audio
      }),
      onClick: onMute,
      children: /* @__PURE__ */ jsx("img", {
        alt: "microphone",
        src: mic
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "center",
      children: [/* @__PURE__ */ jsx("h1", {
        children: name
      }), /* @__PURE__ */ jsx("small", {
        children: t2("support.connected")
      })]
    }), /* @__PURE__ */ jsx("button", {
      className: "hang",
      onClick: onFinishSession,
      children: /* @__PURE__ */ jsx("img", {
        alt: "phone",
        src: phone$1
      })
    })]
  });
}
function CallFinished({
  classes,
  onSuccess
}) {
  const {
    t: t2
  } = useTranslation();
  const handleRestart = () => {
    onSuccess();
  };
  return /* @__PURE__ */ jsx("div", {
    className: "support",
    children: /* @__PURE__ */ jsxs("div", {
      className: "card-wrapper apply",
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("h1", {
          children: t2("support.thanks")
        }), /* @__PURE__ */ jsx("h3", {
          children: t2("support.finished")
        })]
      }), /* @__PURE__ */ jsx(Button$3, {
        variant: "contained",
        size: "large",
        className: classes.button,
        onClick: handleRestart,
        children: t2("support.restart")
      })]
    })
  });
}
function Stream({
  subscriberEventHandlers
}) {
  return /* @__PURE__ */ jsx("div", {
    className: "subscriber IncodeSubscriberContainer",
    children: /* @__PURE__ */ jsx(OTSubscriber$2, {
      eventHandlers: subscriberEventHandlers
    })
  });
}
function getSession$1(onBoarding, token, events) {
  return createSession$3(__spreadValues({
    apiKey: onBoarding.tokboxApiKey,
    sessionId: token.sessionId,
    token: token.interviewToken
  }, events));
}
function addToQueue(onBoarding, token, queueName) {
  return onBoarding.addToQueue({
    token: token.token,
    queueName
  }).then((response) => {
    return Math.ceil(response.waitingTimeInSeconds / 60);
  });
}
const DisconnectButton = styled(SecondaryButton)`
  margin-top: 30px;
`;
function Conference({
  classes,
  token,
  onBoarding,
  onSuccess,
  onConnect,
  interviewerData: savedInterviewerData,
  playAlert,
  onLog,
  queue,
  onError,
  showLegalModal,
  customImagesSrc
}) {
  const [completeState] = useState({
    isComplete: false,
    status: ""
  });
  const [error3, setError] = useState(null);
  const [connected, setConnected] = useState(false);
  const [userTurn, setUserTurn] = useState(false);
  const [index2, setIndex] = useState(null);
  const [bandwidth, setBandwidth] = useState(null);
  const [audio, setAudio] = useState(true);
  const [shouldPool, setShouldPool] = useState(false);
  const [time, setTime] = useState(0);
  const [interviewerData, setInterviewerData] = useState(null);
  const [status, setStatus] = useState("waiting");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const sessionHelper = useRef(null);
  const signalSession = useRef(null);
  const signalConnected = useRef(false);
  const interval = useRef(null);
  const publisherRef = useRef(null);
  const {
    t: t2
  } = useTranslation();
  useEffect(() => {
    if (!connected)
      return;
    onBoarding.addEvent({
      token: token.token,
      eventName: "startVideoconference",
      eventData: {},
      eventType: "text"
    });
    onLog(getLogObject("conferenceConnected", {
      message: "Conference successfully connected"
    }));
  }, [token, onBoarding, connected, onLog]);
  useEffect(() => {
    async function connectSession() {
      try {
        await window.OT.getUserMedia({
          audio: true,
          video: true
        });
      } catch (e2) {
        if (e2.originalName === "NotAllowedError") {
          onLog(getLogObject("permissionDenied", {
            message: `User denied to use camera.`
          }));
        }
        return onError("no-permissions", e2);
      }
      if (savedInterviewerData) {
        setUserTurn(true);
        setInterviewerData(savedInterviewerData);
        window.clearInterval(interval.current);
        setStatus("user-turn");
        return;
      }
      const time2 = await addToQueue(onBoarding, token, queue);
      setTime(time2);
      setShouldPool(true);
    }
    connectSession();
  }, []);
  useEffect(() => {
    if (index2 !== 1)
      return;
    onBoarding.addEvent({
      token: token.token,
      eventName: "userFirstInQueue",
      eventData: {},
      eventType: "text"
    });
  }, [index2, onBoarding, token]);
  useEffect(() => {
    if (userTurn)
      return;
    if (!shouldPool)
      return;
    function pool2() {
      onBoarding.getQueueIndex({
        token: token.token,
        queueName: queue
      }).then(async (data2) => {
        if (data2.index === 0) {
          const res = await onBoarding.getInterviewerName({
            token: token.token
          });
          setUserTurn(true);
          setInterviewerData(res);
          window.clearInterval(interval.current);
          setStatus("user-turn");
          setIndex(0);
          onLog(getLogObject("executiveReady", {
            message: "Executive is ready to take videocall"
          }));
        } else {
          setIndex(data2.index);
        }
      });
    }
    const intervalId = setInterval(() => {
      if (!userTurn) {
        pool2();
      }
    }, 1e3);
    return () => clearInterval(intervalId);
  }, [handleConnect, userTurn, shouldPool, onBoarding, token.token, queue, onError, onLog]);
  useEventListener("message", ({
    data: data2
  }) => {
    var _a, _b;
    const session = (_b = (_a = publisherRef.current) == null ? void 0 : _a.state) == null ? void 0 : _b.session;
    if (!session)
      return;
    if (data2 === "OK") {
      sendExternalScore("selfie", 100, session);
      return;
    }
    if (data2 === "NOK") {
      sendExternalScore("selfie", 0, session);
    }
  }, window);
  useOffline(() => {
    onError(conferenceStatus.noConnection);
  });
  const eventHandlers = useMemo(() => ({
    sessionConnected: ({
      target: session
    }) => {
      sendMessage({
        success: true
      }, "connect", session);
      sessionHelper.current = {
        session
      };
      return setConnected(true);
    },
    sessionDisconnected: () => setConnected(false),
    "signal:close": (ev) => {
      const fullSignalData = JSON.parse(ev.data);
      onLog(getLogObject("conferenceClosed", fullSignalData));
    },
    "signal:showLegalModal": () => {
      if (showLegalModal) {
        setIsLegalModalOpen(true);
      }
    },
    "signal:conferenceFinished": (ev) => {
      const fullSignalData = JSON.parse(ev.data);
      onLog(getLogObject("conferenceFinished", {
        message: "Conference successfully finished"
      }));
      return onSuccess(fullSignalData.status);
    }
  }), [onLog, onSuccess, showLegalModal]);
  function handleSessionError(err) {
    onSuccess("rejected");
    setConnected(false);
    setError(`Failed to connect: ${err.message}`);
    onLog(getLogObject("conferenceFailed", {
      message: err.message
    }));
  }
  function setSignalSession(interviewerData2) {
    signalSession.current = getSession$1(onBoarding, {
      sessionId: interviewerData2.sessionId,
      interviewToken: interviewerData2.interviewToken
    }, {
      onError: (err) => {
        onSuccess("rejectedSignal");
        setError(`Failed to connect singal session: ${err.message}`);
        onLog(getLogObject("conferenceSignalFailed", {
          message: err.message
        }));
      },
      onConnect: () => {
        signalConnected.current = true;
        onLog(getLogObject("signal-connect", {
          success: true
        }));
        const {
          session
        } = signalSession.current;
        session.signal({
          type: "connectSignal"
        }, (error22) => {
          if (error22) {
            console.log("connectSignal error: " + error22.message);
          } else {
            console.log("connectSignal sent");
          }
        });
      },
      onDisconnect: signalConnected.current = false
    });
  }
  const sendSignal = (msg, type) => new Promise((resolve, reject) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = signalSession.current) == null ? void 0 : _a.session) == null ? void 0 : _b.signal) == null ? void 0 : _c.call(_b, {
      type,
      data: msg
    }, (error22) => {
      if (error22) {
        console.log(`${type} signal error: ` + error22.message);
        reject(error22);
      } else {
        console.log(`${type} signal sent`);
        resolve();
      }
    });
  });
  async function handleConnect() {
    setStatus("connecting");
    setBandwidth(t2("conference.checkingInternet"));
    onLog(getLogObject("clientClickedConnect", {
      message: "Client clicked connect after executive accepted videoconference"
    }));
    const {
      index: index22
    } = await onBoarding.getQueueIndex({
      token: token.token,
      queueName: queue
    });
    if (index22 === -1) {
      onError(conferenceStatus.executiveDisconnected);
      onLog(getLogObject(conferenceStatus.executiveDisconnected, {}));
      logToServer({
        type: conferenceStatus.executiveDisconnected,
        reason: "Executive finish the call"
      });
      return;
    }
    const options = {
      audioOnly: false,
      timeout: TEST_TIMEOUT
    };
    setSignalSession(interviewerData);
    const connectivityInterval = setInterval(connectivityCheck, 100);
    async function connectivityCheck() {
      console.log("attempting connectivity check", signalConnected.current);
      if (signalConnected.current) {
        console.log("connectivity check started");
        onBoarding.getOpenTokTest({
          token: token.token
        }).then(async (res) => {
          const config2 = {
            apiKey: onBoarding.tokboxApiKey,
            sessionId: res.sessionId,
            token: res.interviewToken
          };
          const otNetworkTest = new NetworkTest(window.OT, config2, options);
          await sendSignal("", "testInit");
          const results = await otNetworkTest.testConnectivity();
          if (results.failedTests) {
            for (const failedTest of results.failedTests) {
              let reason = "";
              let conferenceError;
              switch (failedTest.error.name) {
                case NetworkTest$1.exports.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
                  conferenceError = conferenceStatus.noPermission;
                  reason = `User didn't grant device permissions`;
                  break;
                case NetworkTest$1.exports.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
                case NetworkTest$1.exports.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
                  conferenceError = conferenceStatus.noDevice;
                  reason = "User has no device available to connect";
                  break;
                default:
                  conferenceError = conferenceStatus.genericError;
                  reason = `Customer had an unexpected error when connecting`;
                  break;
              }
              onLog(getLogObject("networkTest-failedTests", {
                reason,
                error: conferenceError,
                results
              }));
              logToServer({
                type: "networkTest-failedTests",
                reason
              });
              await sendSignal(reason, "connectivityError");
              return onError(conferenceError);
            }
          }
          await sendSignal("", "checkingInternet");
          setBandwidth(t2("conference.checkingInternet"));
          otNetworkTest.testQuality().then((results2) => {
            onBoarding.getQueueIndex({
              token: token.token,
              queueName: queue
            }).then(async ({
              index: index3
            }) => {
              if (index3 === -1) {
                onError(conferenceStatus.executiveDisconnected);
                onLog(getLogObject(conferenceStatus.executiveDisconnected, {}));
                logToServer({
                  type: conferenceStatus.executiveDisconnected,
                  reason: "Executive finish the call"
                });
                return;
              }
              logToServer({
                type: "video-mos",
                reason: results2.video.mos
              });
              logToServer({
                type: "audio-mos",
                reason: results2.audio.mos
              });
              if (results2.audio.mos < 1.1 || results2.video.mos < 1.1) {
                setBandwidth(t2("conference.internetNotStable"));
                await sendSignal(`audio ${results2.audio.mos} - video ${results2.video.mos}`, "internetNotStable");
              } else {
                setBandwidth(t2("conference.internetStable"));
                await sendSignal("", "internetStable");
              }
              await signalSession.current.disconnect();
              onLog(getLogObject("conferenceConnecting", {
                message: "Conference started connecting status"
              }));
              setConnected(true);
              setStatus("connected");
              onBoarding.connectToQueue({
                token: token.token,
                queue
              });
            }).catch(async (error22) => {
              onError("OpenTok quality test error", error22);
              await sendSignal("", "queueIndexErr");
            });
          }).catch(async (error22) => {
            let reason = "";
            switch (error22.name) {
              case NetworkTest$1.exports.ErrorNames.UNSUPPORTED_BROWSER:
                onError(conferenceStatus.noBrowser);
                reason = conferenceStatus.noBrowser;
                break;
              case NetworkTest$1.exports.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
                onError(conferenceStatus.badInternet);
                reason = conferenceStatus.badInternet;
                break;
              case NetworkTest$1.exports.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
                onError(conferenceStatus.noPermission);
                reason = conferenceStatus.noPermission;
                break;
              case NetworkTest$1.exports.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
              case NetworkTest$1.exports.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
                onError(conferenceStatus.noDevice);
                reason = conferenceStatus.noDevice;
                break;
              case NetworkTest$1.exports.ErrorNames.INIT_PUBLISHER_ERROR:
                await signalSession.current.disconnect();
                setConnected(true);
                setStatus("connected");
                onBoarding.connectToQueue({
                  token: token.token,
                  queue
                });
                break;
              default:
                onError(conferenceStatus.genericError);
                reason = `${conferenceStatus.genericError}-${error22.name}`;
                break;
            }
            await sendSignal(reason, "qualityError");
          });
        });
        clearInterval(connectivityInterval);
      }
    }
  }
  function requestDisconnect() {
    setModalIsOpen(true);
  }
  function handleDisconnect(origin, session) {
    switch (origin) {
      case waitingRoom:
        onLog(getLogObject("clientDisconnected", {
          message: "Client clicked disconnect in waiting room"
        }));
        break;
      case "user-turn":
        onLog(getLogObject("clientClickedDisconnect", {
          message: "Client clicked disconnect after executive accepted videoconference"
        }));
        break;
      case "support":
        onLog(getLogObject("clientClickedDisconnectOnSupport", {
          message: "Client clicked disconnect while being in conference"
        }));
        break;
    }
    if (origin === "support") {
      handleFinishSession(session);
    } else {
      onBoarding.removeFromQueue({
        queueName: queue,
        token: token.token
      });
      onSuccess(conferenceStatus.close);
    }
  }
  const sendMessage = (msg, type, session) => new Promise((resolve, reject) => {
    return session == null ? void 0 : session.signal({
      type,
      data: msg
    }, (error22) => {
      if (error22) {
        console.log("signal error: " + error22.message);
        reject(error22);
      } else {
        console.log("signal sent");
        resolve();
      }
    });
  });
  async function handleFinishSession(session) {
    await sendMessage("Call is closed", "user-disconnected", session);
    onSuccess(conferenceStatus.close);
    session.disconnect();
  }
  function sendExternalScore(image2, score, session) {
    return sendMessage({
      score,
      image: image2
    }, "externalScore", session);
  }
  if (completeState.isComplete) {
    return /* @__PURE__ */ jsx(CallFinished, {
      classes,
      status: completeState.status,
      onSuccess
    });
  }
  if (error3) {
    return /* @__PURE__ */ jsx(Error$4, {});
  }
  const renderModal = (origin, session) => /* @__PURE__ */ jsx(AreYouSureModal, {
    closeModal: () => setModalIsOpen(false),
    isOpen: modalIsOpen,
    onDisconnect: () => handleDisconnect(origin, session),
    theme: onBoarding.theme,
    origin
  });
  if (status === "user-turn") {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [renderModal("user-turn"), /* @__PURE__ */ jsx(ExecutiveReady, {
        onConnect: handleConnect,
        onDisconnect: requestDisconnect,
        incodeExecutiveReadyImageSrc: customImagesSrc.incodeExecutiveReadyImageSrc
      })]
    });
  }
  if (status === "waiting" || status === "connecting") {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [renderModal(waitingRoom), /* @__PURE__ */ jsx(Connecting, {
        index: index2,
        time,
        bandwidth,
        onConnect: handleConnect,
        onDisconnect: requestDisconnect,
        incodeConnectingImageSrc: customImagesSrc.incodeConnectingImageSrc,
        incodeBandwidthImageSrc: customImagesSrc.incodeBandwidthImageSrc
      })]
    });
  }
  function logToServer(ev) {
    let event;
    try {
      event = JSON.stringify(ev);
    } catch {
      event = ev.reason || "";
    }
    const interviewId = (token == null ? void 0 : token.interviewId) || (savedInterviewerData == null ? void 0 : savedInterviewerData.interviewId);
    if (!interviewId) {
      return;
    }
    onBoarding.addConferenceEvent({
      token: token.token,
      interviewId,
      opentokSessionId: interviewerData.sessionId,
      eventType: ev.type,
      details: event,
      eventSource: "customer"
    });
  }
  const publisherEventHandlers = {
    accessAllowed: logToServer,
    accessDenied: logToServer,
    accessDialogClosed: logToServer,
    error: logToServer,
    accessDialogOpened: logToServer,
    destroyed: logToServer,
    mediaStopped: logToServer,
    streamCreated: logToServer,
    streamDestroyed: logToServer,
    videoDimensionsChanged: logToServer,
    videoElementCreated: logToServer
  };
  const subscriberEventHandlers = {
    audioLevel: logToServer,
    audioStatsUpdated: logToServer,
    connected: logToServer,
    error: logToServer,
    streamDisconnected: logToServer,
    streamReconnected: logToServer,
    videoDisabled: logToServer,
    videoDisableWarning: logToServer,
    videoDisableWarningLifted: logToServer,
    videoEnabled: logToServer,
    videoStatsUpdated: logToServer
  };
  return /* @__PURE__ */ jsx(OTSession$2, {
    apiKey: onBoarding.tokboxApiKey,
    sessionId: interviewerData.sessionId,
    token: interviewerData.interviewToken,
    eventHandlers,
    onError: handleSessionError,
    children: ({
      session
    }) => /* @__PURE__ */ jsxs("section", {
      className: "support IncodeConferenceContainer",
      children: [renderModal("support", session), /* @__PURE__ */ jsx(LegalModal, {
        isOpen: isLegalModalOpen,
        onLog,
        onRequestClose: () => setIsLegalModalOpen(false),
        handleDisconnect: () => handleFinishSession(session),
        shouldCloseOnOverlayClick: false,
        session
      }), /* @__PURE__ */ jsxs("div", {
        className: !connected ? "connecting" : "publisher",
        children: [connected && /* @__PURE__ */ jsx(Header, {
          audio,
          onFinishSession: requestDisconnect,
          onMute: () => setAudio((audio2) => !audio2),
          name: interviewerData.interviewerName
        }), /* @__PURE__ */ jsx(OTPublisher$2, {
          ref: publisherRef,
          properties: {
            publishAudio: audio
          },
          eventHandlers: publisherEventHandlers
        }), /* @__PURE__ */ jsx(OTStreams$2, {
          loading: /* @__PURE__ */ jsx(Connecting, {
            onlyCircle: true
          }),
          children: /* @__PURE__ */ jsx(Stream, {
            subscriberEventHandlers
          })
        }), connected && userTurn ? /* @__PURE__ */ jsx(Fragment, {
          children: /* @__PURE__ */ jsx(Chat, {
            session,
            playAlert,
            unreadMessages,
            setUnreadMessages
          })
        }) : /* @__PURE__ */ jsx(Connecting, {
          index: index2,
          time
        })]
      })]
    })
  });
}
var Conference$1 = preloadScript$3(Conference);
const IncodeOTPTitle = styled.h1`
  display: none;
`;
const IncodeOTPSecondsParagraph = styled.p`
  display: none;
`;
const TimerLabel = styled.p`
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: rgba(28, 31, 40, 0.4);
  margin: 0;
`;
const Button$2 = styled(Button$3)`
  margin-top: 60px;
`;
const Error$3 = styled.span`
  font-size: 14px;
  color: #f54f68;
`;
const Text$4 = styled.p`
  font-size: 39px;
  font-weight: bold;
  margin: 0;
  letter-spacing: 15px;
  margin-top: 15px;

  &.loading {
    letter-spacing: unset;
  }
`;
const Label = styled.label`
  font-size: 16px;
`;
const Content$1 = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.5);
  text-align: center;
  padding-top: 50px;
`;
const Container$3 = styled.section`
  height: 100%;
  background-color: #21273b;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #21273b;
`;
function OTP({
  isReady,
  interviewCode,
  timer: timer2,
  onSubmit,
  error: error3,
  onCodeChange,
  code
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx(Container$3, {
    className: "IncodeOTP",
    children: /* @__PURE__ */ jsxs(Content$1, {
      className: "IncodeOTPContent",
      children: [/* @__PURE__ */ jsx(IncodeOTPTitle, {
        className: "IncodeOTPTitle"
      }), /* @__PURE__ */ jsx(IncodeOTPSecondsParagraph, {
        className: "IncodeOTPSecondsParagraph"
      }), /* @__PURE__ */ jsx(Label, {
        className: "IncodeOTPLabel",
        children: t2("otp.enterLabel")
      }), !isReady ? /* @__PURE__ */ jsx(Text$4, {
        className: "IncodeOTPText loading",
        children: t2("common.loading")
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(Text$4, {
          className: "IncodeOTPText",
          children: interviewCode
        }), /* @__PURE__ */ jsxs(TimerLabel, {
          className: "IncodeOTPTimer timer",
          children: [timer2, " s"]
        }), /* @__PURE__ */ jsx(IndividualCharacterInputBoxes, {
          amount: interviewCode.length,
          onChange: onCodeChange,
          autoFocus: true,
          value: code,
          password: false,
          isNumeric: false
        })]
      }), /* @__PURE__ */ jsx("div", {
        children: error3 && /* @__PURE__ */ jsxs(Error$3, {
          className: "IncodeOTPError",
          children: [" ", t2("otp.error")]
        })
      }), /* @__PURE__ */ jsx(Button$2, {
        className: "IncodeOTPButton",
        disabled: code.length !== 6,
        onClick: () => onSubmit(code),
        theme: theme$1,
        children: t2("otp.submit")
      })]
    })
  });
}
function SimpleOTP({
  token: {
    token
  },
  onBoarding,
  numberOfTries,
  onError,
  onLog,
  onSuccess,
  otpTimeout
}) {
  const [interviewCode, setInterviewCode] = useState("");
  const [code, setCode] = useState("");
  const [error3, setError] = useState(false);
  const [tries, setTries] = useState(0);
  const [loading, setLoading] = useState(true);
  const [timer2, setTimer] = useState(otpTimeout / 1e3);
  const setNewOTP = useCallback(async function setNewOTP2() {
    const {
      interviewCode: interviewCode2
    } = await onBoarding.generateOTP({
      token
    });
    setInterviewCode(interviewCode2);
    setLoading(false);
    setTimer(otpTimeout / 1e3);
    setCode("");
  }, [onBoarding, token, otpTimeout]);
  useEffect(() => {
    setNewOTP();
  }, [token, setNewOTP]);
  useInterval(() => {
    if (timer2 === 0) {
      setNewOTP();
    } else {
      setTimer(timer2 - 1);
    }
  }, 1e3);
  async function handleError() {
    const newTries = tries + 1;
    setError(true);
    setTries((tries2) => tries2 + 1);
    onLog(getLogObject("otpAttemptFailed", {
      message: "Incorrect OTP"
    }));
    if (numberOfTries !== -1 && newTries >= numberOfTries) {
      onError("OTPError");
      onLog(getLogObject("otpNoAttemptsLeft", {
        message: "No attempts left"
      }));
      return;
    }
    setNewOTP();
  }
  function handleCodeChange(string2) {
    if (string2 === code) {
      return;
    }
    setError(false);
    setCode(string2);
  }
  async function handleSubmit(code2) {
    try {
      const {
        success
      } = await onBoarding.verifyOTP({
        token,
        code: code2
      });
      if (success) {
        onBoarding.addEvent({
          token,
          eventName: "otpSubmitted",
          eventData: {},
          eventType: "text"
        });
        onLog(getLogObject("otpPassed", {
          message: "Correct OTP"
        }));
        onSuccess();
      }
    } catch (e2) {
      handleError();
    }
  }
  return /* @__PURE__ */ jsx(OTP, {
    isReady: !loading,
    interviewCode,
    timer: timer2,
    onSubmit: handleSubmit,
    error: error3,
    onCodeChange: handleCodeChange,
    code
  });
}
var serviceBell = "data:audio/mpeg;base64,//uQZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAA+AABgJwAIEBAWGxsfHyImJiktLTIyNTk5PUFBR0dLUFBTU1dbW2BjY2hobHFxdHh4e3t/g4OHi4uOjpGWlpqaoKWlqa2tsrK2ubm9wsLGxsvOztLS1djY3OHh5eXp7Ozw8/P39/z+/v8AAABaTEFNRTMuOTlyBMMAAAAAAAAAADUgJAZUTQAB6gAAYCfWBG0SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vQZAAAAtUAze0AAAoAAA/woAABGpU1R/msJACHACKjAAAAsjABAehKjdweHnngAAAGYAAAI1/gH/wAdA/oeHhgB////+AgAADH//4AAB//9/SCPADPjh5//////+AAAAAAHh4eHhgAAAAAHh4eHhgAAAAAHh4eHpAAAABAeKy0UAyIGKUAwgCHQ4FLUAFxYONmOMgvoDBgc9Q5gZkcMUdgsYcWIR6GiCEOBGhHBCxUsOExwfeFJNN4JEbhFBpQ04VKLHJvo8S1dUhfNkK62RJ3LUIRLvAIWlsUZYyVcCGjC1vrGChJTcmGkNbU0YfUiu3qRwaY/8Uvv+riBX8i8J0nThIoLeaItco4ellPDkzA8xA0twtybbZpNK4FkU3i5FSBH3ftIdly6IPaQ6lLd07L7Q3Uw3qveu0X/lv9t+8EOQ5A8Ujeed7cosxuBJRn/aOFwEIEIACAAEac5mMGlL/qr9v/Yn//rX7Veu3+n/6P/7v/7OkdkHsoQKUGYFB8MBiOgBAaQMsVEIMHNBGZTxGB5gRa0zGGAYNES2GTAgzSiDKBzCxjpm0J4QFU12HAZsCgSAQPbnCokkQ/IXCZUDxlYm1IAkSqSsbltgTwNKi81cSjGIiMVHtxnzdHN3URF18bC2U3kPzODMBJTMAmA2svl0yedbrCs1R1YDoWhLkM1CgiFhgMUmOQGZYJQwVrUVpnvp31ge9Vpn4bSN3zTwcMsJkyijDUcbP/I42QdDN43jFDnCYyn1ORqbtWO156kfihl5lcNChLEhcZ6BiPZplLmkUmYuBxhQ0Q1Ts9VWb2e5//7zyzPX4f//5kd1G0DcZ0HRisbkRDMHg0HAhju8N////////////////////24xSYaqWLf5h5CBCAAGF/V57PHvpUTJubX6vq+i3d5Ovyvb/1oYlYl12sR9l1nd7P/t1f7LiYhhERAAAAAcVZB2puKlUUxEAtCYyZcgHGAlYRCmcCRFTUPICkylJ0zcYiq2Qv050ngSWQ7SCotIAMAgEmM4zV3UgqWQFAzAnCRWDgEnSsWHYi4snaQo0VhSukcWAmbREI6CwaAVNVjpgvHImdLBJ+NOa0+7swMslhMAodgP/7wGTnAAklY1L+a4AiK2AIhcAAACRpbT/9ngAocIAh44AAACEDCoYMNhoHBZAKIgSkKYAAagqS5ggGmEDCZsqpwoVmDgaHEUwcCS+rKGbvehwZu6krZiFAKWhLVNolqXOMBgwwCBgcE3EL5F9h4MszIBqaANICLYOLTIhkAGAgEAhuPAYxGCTHUqNfg4ycAwUPI8HAtlQqCTCYCQiZVTyCBXlcaNSmM2a27P8y13//+///////+dLjjW7jjjVx4Ek4IVSblC80pwAABtQ/r5UiVuOos2bu95j/zxn//////6/6f/3q2HhQYAIAAAAODOdN+pE84yibEwgwMOaBjzEp9GOEHiUIQQEKm+mulknWhMUFL/MBW0/qTkOWHqhscIIsbF9zjrQU2KddNszK20ScAoFaQuVYNeT0vBH2rKBGIQGtxAEFUeZPOzQS9yAdbo8FkxwYAEbXIUrjamTbOawd8FbH6giGpWqdaBYAMbbM7jSJxr5d41lsDUhNWWpBiygr7KCvkjrKY7QrzjlM8jd0ik/FBiqBEFCIBl3UewEDDBofIQAbflhhUFwWARFRIMaDowpBcDAyYEi8YPTYZsmWYHiOAgLAQGMragyJGuBKFvXiuMSy/mq1uls6pu1sopI4G656gBAAhQAHi3+z/SzZcwPf0O9v//////6Ld6gkAAAKMCFoiQEZSJAFZMlAIxHBwZQvoLvETrY6NHUuokmuuNqMl0V/QU20MtpNPS/gxWPKx5oFt0/zC6ofqvWnSX+iUuTmo28Yu5K7WcGIgEkTDhhIRm/AkjSutdr1qYiAEgoAxCOv3Nu1ONOmOqDQ9JU32fhgJhdkqAGmX21N9EqwAKjStuMxgkFAqVsHVA/jQ3eVVXW5Fh02VNfZ2zUhALWFKqZT5fpZxMFgwHmGAOYBGJiVymJQIllH9lJCEphuBSYTZzFGmj2cKzDEDEC1ptjdp9m2h3Gmpt95//ugZPqDF/tNz3s87PoXIAiJAAAAHLUlP8zztaBygGHkAAAA+FwEAg7UhAAAJQhvX8VIosKtDqPqR+R///927////0f//t+utnlmMAEAAAAOB2QRGDpBqAAFAiKB4QOwTCMNMaUNlQaVkqDabwhQVTd9tJEJBNgZG7StMO/HZAMOjzok0pfKllMXcyIJ0ww/qc7/rnYm+j8vA+qcaPAVCaeTdQqcDUxhQANnaROKITocBFKHpaXJ4FnZQ5DD3anZTGUKElB4DshYsoWpWvZosGAQAmm7yZ3HwUAMHpczUAPVRQc6cUizX4OVRcilC4JIgLFX/lUhYdGVAiABDINMUpIwEQKy8qq6CcdApGgV0NRYBAAkHGhOB8YFoBqQqmq+HWfmXJvhpqhwVCZ0b1gg0D4H/6mqde2rr//////2af/b//v//4t85dkqERh2ZjOKQPhc0xWRGagJBgB4ZQrjI6ZgqBFy+LEW9irouCXRV6zVzKkPMJgKH2Gj6sznn3cLsEm4TGwukTExmAxTgxlFOBUMGiQyjU8s9trTGZntNhnzK13WeVNupfjWrvMoYiLoF7zFRnHjDBFnn1q/18svvXcuZY2qbO79Sp8ZiKSDMM5i8o7PyxqhgUdHBQE8z8W7FfmuafBJm9A9u5FSvR/+S3f76v3f/+z//ev//t1eu7RV/b3ElWcXCAAq//ugZOEDly1ET3s89WgYgAh1AAAAE3kPQ8y/lkB5ACGUAAAAJLFwgZpOGMNYAl5rOXBI85EgZcXsCRvQkZTuY/zMlRuxAK3It3WrjYCis5zLHdmqkoGYui5bypjRZ5QAqNA14YZM4tFEnVGSCJqpT1GqazA1c1Wkmp1JlgDBOhCo9GrsrQb0XXrqUllshw12dSBDS1LBfAZVEeaHSAAQkBZ/+531tp0+r1f2/7//////p2f0fO5UyimBBGEsDogMAHlm8OYjBypIUmIS3MiKOYobGKxDVCiye8MOHZm1bYtZd99t5d0okUM81vu685XoZZGqskMVLSzUyJ01GeAcpA5BIUCXkUidH55rSWs6Y0kTqRsgzstimYG4swDUogWXGpx/+qkyNkk1JGSpSGSpbeOojLZ59iwSfoFXCu0ISP/tf72sddrtnT6v//7f///Z/+cl//7davu8tpVmB4wAIIBaYxwQFMEIiIYZQBUaXAOxhghWLJKsDnoeUXX0t5OqLQ04riS+n//2o0UC5d5rdVSzQmHQWXWuEtIzhVgnwsQAZYiwFs86jj9Fdb0akC4Spmza1oCsgPmibCIl7Wr/6/qdaIvS6pTnUFGQioORnkgIOAxTOt33L7qX9JTUcO///+O+/Lbaqfd/Vr2afT+zJO7/puV83ks7IwWCCjxScgMA34IeMM8mXO9I//uAZPeBlApCU3MJpZAX4BiIAAAAESEJR8zTOQhlACHYAAAAGIIPvEFWB7FGtqdUqHlx6rWYLVKzd/3kk2sMNlQAeF1/e22G682wTQ7pbJrAgunR0LWELgAFCPxmkuh/+pJ1H2S6ZoOeApJAk5J5EyOpI//6u06Nw3SWgdZSyGgSrpJFJRLpXuszRxFVDala3+cf/6f/v/az/9f/+p+rX9y6+9vId3YPiKCACGcmRFhDLeMKEVJJCDEDHUCIp/TDFHkalSH2AMDTUbVgyHJk0K7Dn/r0pAUrC5qApNMjIrWGCBoua87qqWjMmIqGAgJyxRjyTTZn/2dRecwPK1OozFoBrMD5yeNUv//VXapZdNOdUth9gxSbAAA1LAAbv20iMKMeQF5Bt7mOath5iBf/9f///9H/9ft/9///9H3vY1vMh8xSAAkSPTAU0TNNQMqiGcaSoFQIHF2xVMGDyEAIRxbyNzJW5LeVXVMmJA3/+3Bk/gETxkHS8ymlkCRgCGUAAAAOkQVHzLKWQHuAYdgAAAAv//9R4WT3DNjCIxDEnrg8NhW6SyEBx6yZQBMqBowhF0Haxq/+ZeYnvoJkUAkfAsWJ1Jf///5PorzrLQDrhR85FVa2fb+128X8zvv/639P7Opyka+nv220/Tvsp/cn0/+pP13+/caJignAYAAERgyqYwxoIkWQPBErSsAwSlXyIQFlD7zPxpQVOpoSuWeMQuq+jzk//+o0LR5Xctaf6Daz+vHDtrJfUSYSAkOAgfA4AYWEvI///Jo8pXUmYChwQWQsoIibM//+yu7Uh2nzmUR4OGQNVYDZ43QIzYGAOPr8clLf6njL6V/pf//T//qtu/+j7/////R8ZUkrOoCEQyUjaJAkQJDJVASmaw7imAeryD0EBM1T//uAZPAAk6lBUvsppZAlAAh5AAAADhEFT+ymlkCMACFEAAAARhdDTE+HXZ0pu1FyZTalncubJSCI/LfNYpirc53EJePpYsoWgQMAQIAasBYbQPZomgr/+s1NXR6CZoO8DEwWAKHJBi6kj//+9S1EOUppiN42OBIagMEYxVQyA+A/+z0bD/T/Zs/6f+v3fr//9H/9X//0Kuvcw6eHAMDgAALxgQsBPEzoNqNHcoROEcy1iZiNDqAOMMMAZIghuazUhS/EEwPG2HWIlXh3gWD72Z1k6qkTRdJ1NBT3JctECKQoUGpMAwSKxZxROLV//ooGxjrQTMCHhegDAqgAUIY4jVJn//9b1ql/eufMtRtRIcxhAaWhJmCUABcs3cBt7f7lNYji2Pt+/q6P//Z+//d0M/d//V/65ZEkBAhAADhZULLgJQyCh4o0AW9KGDoBAKMFAkoW9uu419CfStyUNUxfZv3fuQXdzlVUdmKyxyv/+3Bk/YFTqkHT+yKmCB3gCHUAAAAO6QdD7Jq2QGcAIdgAAABVYvP9lkWuQxIsXfqV5ZPy2PKrRlB1WIDAaYojUeBgWHEURAKx6ES+vrf7/f/3Xe67qvU/C3SRt3FriwlOu5E4CYDDQJQBMRf6M02Pf7///////8tbsy5/3kX82GzMNFEhi4yJxg7MiRkHgI907fVUDUid/d6PLPa19DaFf///////qrqHgEUjIADgAALOD6YIMAiyNYmKASSEUAjBdiICp4Cpaq5EDuONFvzMxBpqjzsxV6Yvjfp05ijro72NNYuT/3pqrIYxKtXt43mSQ24z6jgAYDinwyQFAWUQ3KKfPnf2Z69pmXDemYE2QAWeF8AARWBnTxgaaBwYxGkVTZF2//+pRoHeMyZNjUmwzJuXwaN8DB4J//uAZPWBE+tBUfs11Pog4Ah2AAAAFOELMez3lOhOAGIYAAAALgYAIE1MgB2r97bMNDK3OMjfvypj7Xf//////0f///+/6aeHYDMSALoCUQIrOko1lTJTDJgYyQgFUiRCK0OXhpWN7WAIqW5S15XVEsqAX63TV5aKmjU2p4dzsT9m5hS1IJlMOQdGneu4y1tWXK0rCg0AGJmKfENgKJqazqz17WP+3r1azBd0EzQnxsAYBAQG+MUBsYjgYVAQXMiyiCk8apN//6SjEMDniwTxPEPCgMLovQlHwFH+wMP2qV1WpLkaCKFJc/U9VqrGfT+zS71X0f2927+3/76qLy3t/3caVv69t2l2AZDAAAGxgwc3zxhg1cJwAQQlEQhWO7xuKPva/QDA4EaI4iczL3kqOlPX/EvBxZ/YmTh8vokNIcbLfRL5gtRNgQDAcYWMgX0O9y+7Vlxum5gXOpMwJsPYAyeQFFZsz////mFWshP/+5Bk7YOUoUFN+zur6h/gCIkAAAASzQUzzPK06JmAYZQAAAAJtQcONwAAomgANf6y6+YaBe2TRFDp0dB38vMOHlwNQooAEVIOeEThjKmNGZZ4CnJUAoaZEd0kEBxyTkDKfU+3ISLUob9WqNSB1+/+9J/kw3ef/AALBwcHPAYET0hkdeLOMQamAHeTyL1JHlzAz5v5i7rTt3LoGH4YKJ1JH//Mz6mTUhuXfnqgkkmjpJfb8CCwdS1twK9iAxnZzel99tLumuxGnXMUMWpH+6rqdt0ejfR2XluLPZ/38jX5maFTQwMAgA1UMbNWtF0UGOuMcSMIVKY034kQrArhSyiboX1gGXtcgZkTguw48i7c1UHayJb88vwiWEioojJL8zZm+Vd1NVZdfhwEhZw4klfEJFhTVf3RJJdXqda5MlpNAvkADZwNJ5B1Q1dv/9SalH1OlOF6vQGykUgaOwJIDVIAVgV+nyjdKF2aCBS+VwojZo7Pr2U+Gf++v6NWv+/71fQQ7f/d1bd7bsrOGZHAAA6YFqQq2KnvyCsDSeHXRGEcUCP/+3Bk84CTeEFSezig+BPAGIkAAAEOOQNJ7Jp2QLuAYVgAAACJNcNiRdr74KEt41pnLfWn5cWH6X//RYLM8ChfynceByCnsaDwupz93msFRUhwICoGiHEBPo/ol1pkXW5eLyS/0RjgM1iAKEilidSRf//Ug9+UecMB5SNgSYhTIarBQZS7PqPv0e6NxXI37lp/90j2+/u/9XtV/////T9PQv39s3Z3CRjBAAuWG4gJUyyTfxNZUDDGCwNDjxNOOhjyJdd3Ee2noQr9q8b+aafug3v+lgESUr1qt2zQpfjxkEBilrXhZHS8Ew5ABjiOx2T9jM4eN7JpqZi+cKnpoE2KQAyLYGFXQT9B+/0VXX1Fj1GtwSGgs9YQzIgByn30v4ogvyuv2eSYhg9n/////////r3f6fV/Z/JL//uAZOwAFAhBzvM7paAl4BhlAAAADzEFReyilmh9AGHYAAAAvILIMIcDLIliYkAZGYgoYUaVaVpao1Q+kAJE0qMQIQaFwVWp4PJDd5k0xAUo1/+o6TCY/v/3h2gqWpTGr9JX+nztWMq0pIQgCDKpu5Vy1/5roI23T709HnOtR7UTIArUQWJ0+zu8vltF11qSOFc8bIusuNmepNJsP6Cw3eunv80AAAIiCQgxaAbn+yT/XdKr////+r9//+r//6v66vzbtoRXBUBADAEDN4wvY2sQABaqTIW0DyBU6thmAUDWeg02qaa7kT2bsaX7DCqoOesu3z6ijYuRIRXDuP45YYaFEoQIhYYYCeFmc6jXQ3BwIRW9n8Nvcd4S6IpMRSA0hGSalEHUDkOQ1xx5W/8vl8olkBrvhylcNU7rz0gAqI7SHO0bI0h1jxeURiZaw1ycr5YfhXhyWVKt99IOYGkWrBqGKWX8p15lyy3hKeb/+4Bk8IATsEFSeymlmB4gCHYAAAAQxSNN7JqcKGgAIiQAAAAaoYe5c8/ksxxhty3fh/KksZsQkz/37DI/aAZUACR8R/YLccNkdTO5a4r///t/V6f+v/kuqn//3f/rq/M2EYTUGAAAKCwgQohSIDImsKBHSbwFPpXCAGaISiglUrLWAqq5u0ypuDtOy1RSbV8eS2MkCwM4HOTGSqTSTFa7DtLYlsy11ar/P9LpVTOVAUSWbbmmQntaBq7XtnKBX1FyIwzFYzcvQ8/UiryF4kExd5dUMvrVd2MxlnLUDNqoqg7lzzpadl+ZZlCZ21NUK5X8tRN4lTMqdt9l1LWZE7QCCDECwLACxX9ZCudLxWxNUw2FMtEDDQqHlrLGdptn1mpqrhMQ9eppmi5G5bKEA22cqkPN/in0KzkU//tr9O3///s/6pX//+P/d1393JdkMw4AAAYLvkNpjBg4sQ0lpRhEE6PICpBQJhRNIoZLlf/7kGT6gBYrStL7D82aIWAIdgAAABmtK03s423odgBhlAAAADNFmFjtQfGGGt5WnQwxoLpVPLhAgcuYqdG5H+kjFqtDT6utE2bVr1ukty2LIXyx3yqub4kBM6lLxMDEhHjda3MfDPaO5dg2vcwl7hQw7q83/ncYxDYgCHR9DbaAqtE/Udte+0P081jG5zKV2n2dppTwT7OG4uosCKCjNv1K1Y678q2ooOMYCEJh+Wm9x6YXACQj8uTHYai0Cclv4QD27f6lAIwBCqsmVuAwzf0XOcylpN/d6vb1/G9P/qT9akI+SsYpNjmvv+j7Ni9183ZqR81VqwkIAAAAcA1KBAydRhTIBCI+AqKHVRQUcOvVEbcoM3w4SzBOuJNgkcvblg9D76llHP3yobEglum3SX49JZZMN1bk0lS5mE23kTlWbOWUBgx1WXgAOeQIkA90RbMn6JEkcWstocSGsrCqGGCT5DnNrE9LgP5/FqsXgWfsv8Sgkw/CTB4oLexpdDbR9vJazh7ZfD8bdx3s8ndi7tPrRwp0nGTRRmAgSMfBkrBqw//7oGTQABYgSVL7OucqLaAIVQAAABoRKUftP5wggoBh4BAAAM3BrsDRNZovAwR+zMZUKoTGgY5Uu3O4T0bmO3KzvX71WzlAABJibq0sys4hX9jy02ttf/9Fzv/1+v/93/V///0c/6X5u7NlMwAAAA4EBZyqkywyiaKjpmkSHFDBABgcscHIg64qA5aABbEG0sJa/uGI3DtLYu3CqaLeSHlzLVLFrer1A8zTbMemJTaj8XiDM6aSgw0cYnBkpuUEBMzjT90s1hjjX7nQ3Lvy2buxKNK9iuUNvokOda2dQDEppp1eU4X3bjOFuYlkzGcrko5Q4S6PSZX8TCpI0IR3HnljO4AKBqv5dwg0JrIKQLDDDZbG61ynlDQApAEB4uKwC3/s/LL9///Yv/9/1I//2/9/3//o/v3KhXcTAIgwASQIOImQXOACgocFiBwUQos3FvBptPdeCwLtKwqONCY1KX3dhkU3+eWSjZQpz/3hTvLTw/cn4zFKmfPtfrN+u2UGgd3PY/jMz2PbxHGdBUobllAaW7UDMjASbD7JI1SRupVH9DtpVoEktKcODZNkgKOwRbB5mVjC8H+KAT0K0jy6XpKber//u/b9f///QvrrpHZWIQwAELg0IWyrGepACRI0KTF2oeyUqETjKg09nHTjT2Vw3zyM1btD0Jh6jrdoGQlIalzuvSvEk24iFP/7kGTRgZWHQ9J7OuXYHCAIeAAAAA/1B1HsmpwIXAAiJAAAAErDa6CYtp4CI0ANEMNBay+QM1rUpZqgicKy2MDRSSJwpMtA6MoAw2BEmIKbI/6q67LqUzmB1YxGQc4UiIpJAUcgXak4fdjWYICCloACXbqCCudj6NCs/0II7Wf////7P+r6udalNEAEGrgAQAokhQleZ0o8GBiSI8FYN6KoGEOVRCRFiCgydN9lbhzTsNNfV78GVsTYO7BWlO/h21UuVJjc2/89E6e5rPOxUszcSHKTeYf2VbpI5N02EvRoECBAjXnPIDBJhMFwmyfUZl4T2E8oN2ERKyKVBBZorrpr0l3dJzgfmbqUsvGrIggHgHkTA3fN2YT5P9vTXQ4o/qvUrrb///Hv//6v/////9f/urtzNBNAABEuOXm2yGjCU62R5Qyl1chHKspACPESKlL/LDX3Mke4tAL4RV5a1mCLa8ChHDK5ytJ4KkdWq+r/JJS+GpPFbluvKJXVp1+FM1oNPSUdI+1HnVxlNnDv447prXx2lwutMi2Vu9PgJIHGYv/7kGTeAZQ0Q1LzCaWSGYAYiQAAABJREUnMppwIYYBh1AAAANut+U9VNaklUdRdWcK1E2TQODMF6sxOImKw0cC+l5E2zqSEDJQAB6pJ5/Y0XGMxjAG2ADZjZV067P+93/+5dVddf//0fup1fv0/E3CqZiAAGYgQRmUMAszNMZOdQQVDQ/AwSYpVRrroLnr3X0w5w6JYkspo3LYrKqKDdkBxFbl9TlJnhN0/Y1bbu+Uqy7f7A96VUDwhZYNCLV2Tf0M5CIHq5Wd8//+5/csp+39BTzVupK03DA5AOI4GlueNLc6betvdEyrc4k4e8cTcxMi0dLoNVYOElZN+kVkhC51L3fMZTV7Ka//0f/Z6f/r///7P/+uj6f26xYVjA0CAAAdwbDCrDRgKZCMqaGBIRMbfGxwo+dAUxNdKgjqu06TInKnpXg/m5VUrlQxEn9/+mnP/I4nD8ZnorP458wytfbpoyF0B4Q7TrP3flE9zSf5iZmqTpKUpJR9BMqAcagNeJ02RUpdH/9Kq2RVNeZEi6QNegsQ3I4d4D6P+rRW2Qu+7///7gGT3AZSeRFLzOpXCJqAYZgAAABIFFUPM7pcAZgBh4AAAAFU5hztL0N+vdqk9qG/c/t281229bP6vq7uXVVBMiAgBWsgba8bCAgiME8W3SHEsVCggc0kBZuCAqDbUZWazKMPxGJt+ovDFN39lgYDjbU2bOTPd6rokhMY+ouPh1dqwRQA0mB7QAsZaTQSM0kaX+ikbnUPUmYCvgEQQuQau3pf9VT1WmRRPoZgWlKCA6A1EmBJj5nnNt+XUiKe3R4vc9n//92tP0Vf1/o/3tf+tSt7LtbhWDsBAAAVHGZzPKBkpunmUmPBAqEzhiBODiVQhSEqi9qRrcpW/az4m1+D20k0Xysy3ywcAA3CYim62jAb2eUFS52LHrMjirEskSJRF8CCyBklQrUpImRiaot/5xzhcM1tsmaESA10AAZqKWJ1JF//84gjTQOmgm76/3IMdWflQUSRtoeWverdAAgBhAA38XO2zHWL1svOa//uAZOmAE/pBUnsanaAhQAhhAAAADykDSey+lIh2gCGUAAAAdyXu7vzXXo//1f//7f6f+n/+j4urdkVQcAgIAQtMO0WFFooSBXS7pnIhRIwgKQwTBpGCWqtYZi5t56HCcFwJFCr/ctU5VSGk71DnalIlJwsjPIgeDcV7/tCkVMkSAEBYFpAIaSZdTZX/zA5dRkn00DMTwBgUiAsDzZn//9JLWiimWVrqKS1OISgWSJUaEDen9YlE639XTobrV+pfq7ccz39Q49FKdPvejfUnhGz9Dv/o06XIs69F+s7XiJcFSMKAAtIbJTenCIEHi30YOCUzlEQI0SghxrhYoZIO7a6uVg7vvy/Eos77rpYAIj8tfnqgSaZRURBJ2/122EUCbBIoBqA5BE1JqXaTB5DUzHy7MS57dEAUqHTF1JvOH3/roo1uvJB+ZOtYoQESVQiDUADv930cDsY6nS7TX///RlFfq3f9vr2f2bf///r/+4Bk8gCUWkNR+zTeSCJACGkAAAAPUQVF7Ka2SKaAIRQAAABr+KuVg2QAAAAKDLiMEoGxAIIFBCrRmrmsIAQgEeqiSOhwrPC2i8lyuAFhmsyFB+CmJTjJMOU1EVUhtvuOXN7AkQGZgmTJo9UMFCIUhUiZCCVI5cnUuiNPNve/kYlcKlko5n3VWvchixNwRGL7sVpXXh92E9zMocibJixdu7jlFM9wqUlJ2phLJfrd2H+0EYxwiWsZdIH2i0zQkpYBpWRVe3P/eesP//+wIAQLlOd4s77u2XXOVQ+r+rbT//6raerS//+r+3//uz3+pd2f54M0AIAAHgRrpGnQcZgw04mGaLytQc6CmnoDJErg4AKhs/XS5jWWGOa/Dr1JJI8NXdJPE2f55Yd7O0sodyOQIyCj5u5lUfyxalFKXvO2AeZ+N15+H7WN+k7nnnvLl3valmjfeH3fkWP1I4YJglbDVWtWpOYGCajRDPVmq//7kGTtgBOZQVL7KaWQH+AYdgAAABT9I0Hsp3ZghoBh4AAAAE2Y3IuRNSZfMkC85MKw9oHhWQZNVU4ad1lUCfAdWMZ1MjctvrYZznf+rsZZ2dykNst6PRxtvV10NR//+U69//X93txCIqAAAAYBSFGIxyQVIFCSQgeBAYhAiMrxcLJFBbUogzGHl6LMYrF61thzdHnv5yOSKrFavcvy5v+4ZWn+fOMW79V95DAt12Y85Q6iFBozLr9SvBVjeQQWzM6J0KJINDMoUGfqT1OwAZchMl/58rW91f/VNf1lllNVqe7LLsgpue3mtZ00ozrbfQe0xwz/Hly/LrVz/7lOggITQkue5bwIX0P3NXR2r1////////1//WraqpZ0ExAAAA4AFjZ8mIF9hd4K0LEAeQgJI1VwWgo8FgLsCwmPtwDE9Rg6OAj4Mr0frzaaZRqiTuXbcrf+1e7LGwMsbG6D2UDkVGMx/JurTXiLSguLBcShMboJS/MTtVL8rn+fLML2sI648bh+LN7dXXjZSrMLnGjUCwPBDXH8hztuGHcsapJR9v/7gGT9gBS+SNF7OoXAJmAIZQAAABNBI0vsjzwgZQBiJAAAAPeDuWdyyGHQXm2dy08maPW4cvrO3I3XQ8H2safzCahykwl9zV7WF77IOBJgNy0l/WMR/t03sZ//6fpf7/8dbTd2exRz//5D8XKafbimMgQI0gw0CVmGQXnBExhtJ7FAKh6sYFAIhEGlA19q3v2q1mLKaVRyKv+xOjvSmlaWENM2fV9ZU4r0ONG8GxPU19FWBpmmkbkrtsUzWIk0kUqNycsspe8ssjcpooOlUnh2TRqLPtL5bjOS5crkMuf2Yf2KOE1qC2gAVo15fLxJrTd1+YTGZdXpeTUA1cad9qdybEsla5WCNgAwQGtYVn+NM8DOFFmvqrHaDJxQ5RO1qDYfyl2ufTG5ClD2VezqNbHuKWvX/V1////td/+/cpGv6v6P+3/X9NX5qrdCJAwAAAAMuVdCpQ6sLBAJNMsqUn8GBhhgY0WR41MVlilT//uQZOkJlZVI0PsM05ojABhlAAAAFvEdR2zjXKh8AGHYAAAAIFzuanG8cDQG5DSNzF/LEqCmKM01Td+Exkwf1/JK707MP7RTdh6Ov1fY3fgwtEcSFo/uJKo3HHViWoxerzG9cqZY9tfMSzGM3JfS91Kh1+CGmymxezy3S5d3vPHnOa+UzOU1QT8rbKHWq6k9enpn4pkphw8jETrlM3jqZ4AAgTUAB+Q9GKtpnLns0ORRKf/99n//7EdX/d/9P1V0sKphEAgpmQDirZkggoAAnGgUVTgqaAQJoZNGoYEUPVjTBTzaKqxrjpymrCGC3sc8kO5M689qk5G7mdLlPyFmbsTme879L9Ko1jBBI+b8Dvw5RzspnF025YKTt5uQdC3KFvrf75q5TiIWmrLr1yi/muc/8P1j/e7/VNuduSh3B1E0G7ljIIrKo8SnQfkltHUraGOLij6HmrvdGu7UBwC8UV//////////3fs+lfvLx6VDCMAkAAwljrKB3AtSZSwVbA1DllwzbFaKBFRKIHLmWW+peRyVtsRjTex6MOI4uPMM//uQZNEBlQtEUPs7zaAdAAh5AAAAEokNReybXAhngGHYAAAA1OyJC3cpZVX3UjlSxK3jfqnt/v86tZdMpkatoLSN7Lu2sJZOTHEaaad0tzYvmRuVmags2AMFDeLaD5o3q2XemtBSBQWwY6J9MEECgnUMqBdSiboYDpLbP1fjuTJ6P//3aPvZf/2I7PpouZt3////X+Z3VSMw+gNgAEjwGKMGYFAgZwGBjCBrtAhhBhL4wgg6dTQva2IudIGcPA/7AqRh1V2cN9xaKUQSiRU8ujFLMZzcqeFpsLqXP3v7VNJ9U5AUZgMYr67YmL97gYcOqqoUoOsYxKQ4ScUkgRwBI4PupBzp8rmv/UjVdlosoV0xamZH3WKQBaKgSFf8I/OWqsUjTzV2ltKZTv+ltOhS6sn1OKUEOM/aiPRk8p+fp+hHc9lO11b5vaRlRAYIADQiELgaSOiVWeTVAMSC5MxogeGMqC44MBJJJLpCp1qasPTDTpVVj9uo6OWfzad5ME1nZsZoiIusky0ZcUK7NA0hIAKewAiRzoyv6llUsp4YhmV4//uQZNkAlEJB0ns6paAcYAhhAAAAEMkFT+yOnACwAGFUAAAAdpuU286vP72z3D87WP2bt0Ki8BSnt27S673+f+t3/1r/+tuvdv5tKgezXsyqFaoSqMB0DlZtAAFf9HVYtQcFmcWP/b/R//q+7////+z////17F/CwrKDhwAQxkNgIJJzgpSiqEMi2zvFBz0DiDeJKjzj+RgtypdNqdN3bZTOQN93HPrRSYyW8zy3M0VB3K5Alqlsa1VpIp2W130Crc9pxa8Ut3J7HLPnRRSSPuyJ5zxuykjhuXCDgBVAkUmrKmaS/rS6lpKRSdaxPCCGWCsxiDSAFwmyKvTHZC2oV7nV7R9Tk4UTV9f/R/6uco9tSP///1Cn36f1OVX5y9yWiFVIhRABQIzYIwSKA1QwEiSBAIcRIg64yFDBdFtG4pP2F/pAr1aUzaraYhDtqltUl1RMoEx/8NZekIeDaQUxrL/MomUJDgQFwNsKGZL3/+yTVH01LT6zgTDF9Kq6//+pFlMYjnHuo3oBnwbw4AAjUAAG36OwWfkWCoNCGz9ft//2//uAZOwAlIJB0PNJ3ZAb4AhyAAAAEIkHRczqdoCIAGGUAAAAb//Tb////6f//6KP1/VXq6zuphEgAAikC5BasHstsJVEVAs0HLCImOlg8gPBBBGNxIWC2VLXirgVXXVTZxZlkc9hJWJreGfsgi7HngUno05YHS8IuAYEACoSJISZ50P/vzE6paTlBnMyAAoJwRBInXaV2b//+sWk91Ph3gcAAsh+j9xayKFOLf///////96v///////U+8q0ZkYzDIAAjBJJnUGSGVTAZEESJtJMghGSigJMM57sNqpo27MZZSXpqMvs5ty3u6yAmF1/f7t3a8DwhIrrw0XdAiEhBrcASzFoOmS1f/9ZdQpr1yyEhY4EbW/7+1NCtSRQPtqN3WDQEDCywAAIWQAN39CTnpZuCC7ko///Zo/u0bv//6+r6z8d4iBMIzAAMG0yhE4zBQLxE4RaM1wjOBCh8PhQYWvdh5mgoCFY3GZY9rf/+4Bk5wCTg0FTeymlkCGACHkAAAAOLQNJ7Jq2QF6AYdgAAABk5W5yebWy0RTAuLpPUgyBmsmDNSGtAmkSLE8QEAkDADR8QMSJ9n//zq2MlJvuxXBZAUEyZJG3///LDdR/CRA8QpaTu9IqlB4jG1oVRcorpVSrs//2f//////////8Zf6+1bi5KUjkAAGRtsbKpkSJLAqxp4lUZY4BjlBAQBQjDPGBF2O4spNCVRR/HUgVrUk1ru0pB5n+YW6ylvywCoL/1nwYmieRgEVIHJJCyy4mgn//mWd36ygEgxPv////mbdR+sIgg5qgCUgAH/c3osLdrFVW///9X6P/68uMokRkAADgAAwoAaqAyRM0DGGakYAwDcEBoGIzFRCiFy0bG7J4sBa5H4fEAT8OW2d2qSf3mWDCYWxZwwztSb6b0+3uCgeU09JKokNJSBEAAYSYYHMDgAMHRQQ5peRs9f+Yl1FRlc67mBmQQDDoPP/7YGT+AJNiQVFzKaWQGoAYeQAAAA2RA0ns1lMAeYBh5AAAAAaDxBVGu29t11XVdSNjpBSvsXg7RoMqBFFBZaRZEqBFCfd6hvKI6xR3whYn6O//////V6dv//VV/o9KpmWAEAAEAOAAALwcYKPZjynG6OBD4QIINFMw3n0ApolTSuwuZSiAZImtRNViL7w7BLccIVVIQTgQAPDs8l+6TvQzZ7Wi0DQ0pkXVh1SFmWPuj2wwMADaCYCoAJg9BiGhsFuYMgAgOAXQ0ae7kYp8Py5/ea7vf/jS83eaNnO07cBGAzDUFBSIeV/t5fj+ubs/vmu5TOFblrOphNWAaDn83qraFg9OLv/7gGTlgJM8QVL7JqWQE4AIdgAAABGtBz3svrZocQBh5AAAAJMCzwBRtOKK2rPQArAAH3/rZV1rUTFUqFvq/bT///p/d+q//////65doUFIgAADmW22czxBysxQxQA1HDdPStMlCCyTEwUxxYuwywWLjagLaPolVDz7PJZgack9GMiUNBnerckVLlAFHyo3dsckXdCL83x7igFlwLoQFCgYisQGIa2mA4RCgCu49cQsUd7qS766a1pPxjTVA3JwOWAzUigMkBELqhzSeMUlv/9FCUly4dGNFmiNXQWYgiARcHCBgVzABU4PGWj6sADxs0iD/RmKayQwjYZemKf//avu//////193r//3/RVhndBASAAAOAABSNCsaRAEZuYArsumHMI/jozggw0aLo7cqbZTZ+3jXvGZh/JmPWZRQUBLsLz5xqcqvpGN285dyO23illHSV48pU0dWpewKBExXLI89B8MIoiA1Z8mh+v//uQZPeBlYRDS/s+43gdQBh2AAAAFBUJL+z2r6h/AGHkAAAArf020V32PoziaBmTAx4EAEBitrANH8Z4qucPlz/7qZSU+ms2EK05uQ0PsYEwBFJAZTABEwOgNfZ/sfd5NKav9hXd///8n/W53//R7PtX6KO7/Vz1LmqKYBgcW0OERBcWnIW0iDQGArqqhhhx8QIBkTQZ5kSTkEtUfZoUchmUOXLrXP0WAiaPe+5/Lo1rPtW1blt3dnl6ET8okqdhgMCdqvIrt0jdyvnz/f503RUuiT9BBDTICBl2IChIcJeRs7f+3Ui3IckhmZJ1BNYGaAgCNgNb/lj1TTpiL4cT1u6f06eHE4imoAqyAwkNKOAMa5W4UBDYyqB2yyklEa0+o4aha1eqoKsM4ahj88lIZWNbsVQPf/H28bXilnNAc4hbfPr+rjOyvSBAQMgcgELCVjV//2dnom9NJtApgOGiYN/UzoupFJE6pNjdT5gUa1Vn8IghRwEEK8CktlPQsSmtNGTXqmits59v+/T////v////Q5X/7k/VbiIzKIZFEAAm//uAZO6BFKhBTHs9raodYBhhAAAAD00DPezulqA8gGIkAAAA4ySDqmoZ5yHUNbDmUnUSpogaQjC97vpnXIHxXax5227vi5c/3dj2ZE0+Zd38VIzOyGgRUt240TqNqEDAMCwGgA+JwIOXE0P/UmXTU+s2MaKLazgAgUEESeRf6lLS1VXVUouIudNvWfrCICDeyTJ/09lBsu16k6VXrtdF/+n//1f/o/sq+l3/pv3N9oeHo0jBgAQ5rQME436TIrCGzEkElzDIA1zSRlcWlZEz9TvKDp9o/WaPa8DW3lYlA0TdFL8oK7+ucy4bFQLNOd5+motIiZBCSA04kcRdS//n60EHQ+pMhgBpAMq///u7M6jGdWc11m1YQgAcPcBAITA5b7WaP6Uat///+v///9n9v/////VtV+GzsojIcQAGAohCqsa/h9TPdI0LSB9gaylIIhh02E50rU1UH5cz98oazbHOyDXN4s/KD9w/nhb/+3Bk9QCTqEDR+y+kQCGgGHgAAAAO1QM/7Ca2QG4AIdgAAAA4sZUJBoEDMFN6iBeDZcCxMDrhBS5cTQf/1sdPrOJm38sgJKiyjVL//7tUVklLTbrfF8DAbgR7/biW2lr2Utu6f///6fX//V/9//////9N+8+4aIgDEMGAAZU1tEUwYy8hnToKA7cCtJpLmAgI806EReZ4VEmCKnf6C6dsCx4Hfi/BwpKjU6aKKJVSJJFS12KqRdJkjgQCwNMOHNMkf9SDINOpc/9NAh4Amhpv+/+lX+snfXyBAvTgBCAAP/9HWn6Uf//////Uj/nvq/6v/byv/9H7eYrO7g8xBSAAVEwTXBNVE1lDMEH3AsADoyyVwqFEyzM22chkix14xKzEHGdpvn4//00cmip8se6tU4fQzTB0MtS8//twZOsAk3pBUnsppZgY4AiIAAAADbkFQewmlkBnACHgAAAA9RqUgL4EAwAZEWw3ZO/1OeM9FJkEFfykA40LlLyPy2bVqTsmkkg61pNWsnvW2P4LElm7Lumnp1qoY+OvcRaU2fX39n2+tCtD2Tuj7+petP+j//av0vurxaZnCYAhLARslAg8WGCMoEaphSJ3IQgxaIDrRSgHLGMWbo40Qm4x5kjsx1iSt5bIiEp8dcVnDlql+1STUNqkHQS/xjAI2mmeLFtbl2OV3KfpM78RFXjtVgh/4Yp5Q6EZv8/+5qD60FEQ+VWjln8twwYTIxbqWe4YYUsmf+5jr9Z5yyv3esM//71fuFfl2Yk76jSpTI8LueFS9lKL1Pb7gA5QP8Ml1+t6+V7tjLv9//R/9X/////f//o2rmlY0f/7cGTtgNNDQVH7NJTIGoAIdgAAAA6ZBUfsppZgjQBhRAAAAAOQCAcEwDbTc83AB1kBWiyw2OCkyKJnYBCCLVhhEWsCgIRpQoZ23B/LrYZU+Vv8ekgZKEmmytpMCKn1pUYrg0LoFQpQ+glYeQwH8JMDFQ2ORafi3dkVmXW8f///G5fr8wqU3asZh2lsZ0EGhU7ZVLb+Vbdv6a9jzLn/+7X9/8pq1rmWGeNnUzcuwyUCbjZZ63uJPc4USh61nj2P2qgSUFK+xXuvbSVDiVnFXpck2XLufNb//s/0/7v6Nnv/3SV2xFXL3MVxRAiAgJ4ChgCgQUADsJMROKRERUwZAolmQFQkRmTRAwUYRpVQeCdWPDr+RqKS9+HU5rWiwBDEmruEsfzfcuwBI5uCZy7KrlPqTW6WItGJaZb/+5Bk6oCVDUfReybHChmgGHUAAAAUNSc/7LN2YI0AIZgAAAAbMxrS+7ylx78fum/hc2skFoIImaC1DngaKCynF3SVMjV9aVBA6utSjZGozU7OXzy0GBdzrPRVK5TMD66mNCyDkH6+AsvZqV/so3toQ9X1dbNmn/d/+3+pP/vv3f/6P/q1fk3aOJIEgHHUCXDKhMMI2VS7gPIGvQMeZSETKpqzk3wEw7kCrrSQay787M14YXprl2JpLhxAyykq0+PKtPTwVEH8jEjn6/5bouTdFKhELgc8BwQoI1ykjE/UsY0+WFj888sL26eX36fuv/WDoDBFDLvxumpKSxSUlSxDc/SXcrEbhzCkq5PpFN3/5Xt/nnhhqlKwmN09ev3D/y5LLGGGrvO8bEAgJZL38oz5JllZlEweMMDjZdVt56gFYTUFRIMAHwoxJOAAyACMnETXSM4dPMbWTVzwzM5MedStnMpMR4GKpsCiIIiiImMqJR0UBR6YDCab4KMC2QMKSICJUNJMuBMhDxi0TmdwOqMVAYBFRWEDEIBUZCx6MOBQzOT/+5Bk6IEUtElQe0aXCB6gGGEAAAAUVSVD1Z2AKEoAIiaAAASTCJUMuAIaCBgQCKdGHw6tBIZFQxA/j2whbgkQ6gIOgOTrWkb4FEQkAwcAAoMnBceATKKJqpgoUmDDQYjEYQBwIFjJRiMBAMxwAVOgwIFqgsBisBAQJl/ACCBZ1p8qeBQAMPA4YCJhsNmOQSJAuGEMUmRoAgQEGGQWWqjcOrzUdLqIIl9u+18tgGAtqjqNTBgEDgQYOAiakVWGUec1AUoAIQapS0tnJhYUIXNNkTnNrf/9+YODReUMBama64Ht0eXfGAGNDEgAxddt2hU1IgIAADZm05sd+7yh9O5P/R6f+3s7f0//v3/V+dnoxGYQABhJCFCzWNJHzQeLvmm0aaBBKPGNyGSAcSs7NOpDKCV0Q3KWGstd139Xez1CgwHG4BzbpDUCYWa1rKhfl2YAj0utdxn6q1nSXMYFUdtmla+9mXOCBgSuZBLa/K9S1LaKQ5RKVP8zJoTQYdpOYyprQjBA20US2dyt2YBryuTxzPHPK1JZBPTV50YDgSgicvj/+6Bk8YAJlU3T/m+IgBtACKXAAAAXESVL3Z0AAHQAYeeCAAAjQWAtgWHZtTTUnZg3RUhgVIRdXu/c4/vxFyotrO9SynLl2/AAABKAAM97P+vRck0tFTXtkE///9//v//6///9Cv+7p1MkAEAACBCadYoWUNJVDwhDMEoGQgIcAPP8X2GmGSs7TRbOocz90l+NyTDfeIskx1d2n8TJ0mq1z6N8tz9YCXmillW/nb8YSJabshUdODDG/gyfhl+l6sUsbv5UNWtu1NXMPlcH1rMbp5+/r7xiYuJG2E/Lb9ud5Vxz7FJ3PtTHGzJZRLIAls64bKBCKKaQ5ZnlVHkf5PUVXzTBpakgheqa1Vuau5fW/9WiAAACQAIr/0f6qGGzx4lUj86neSRQAAAA4HFBQlI8inDGwTCHVLle4REkAI5eVzDQTBZe4qexe5l1ClwvZusfiljmHW5Ez1e7WqzcskVPnFYiy1x3/YhD8kpaecm2hX4oMbmo02sWfWC07jBAHmHz29bKy1h0a8Nui6ogc7Q2iPq8ViRyRRUEHEtw12Uy2RSyWW4cpsowt9qMupKr9SGLOrZsvFCqrytzMJjUSBqwlDQJPBwBvQEYOY4HcgcCXm1Rz9m/hS5VuTLgpkP/09jCqSqTFDjvv/os6fo///6Kf9N3/+36Kuu6hLIDMAAADgvUZV4EoEpTRGP/+6Bk0oDVZElTey/dkBAACIkAAAEXQR1R7L+cKGsAIYgAAAC9cLqhYZQERlJVjjJokmWAIFFgGDF2lXyyLNDbDRtbghx24wNADvEd1nkatfEXsmH/eKGH3qKCuJRwbOcmKIvxHXOAQhIygVgZoUZzdZUCWMqrQG/MclGU7IolLuy+WXJPIHBdh6ajdH8g8ywOjJwPYVIVdQzEoZi0YkNmHk6ZygxkkxJHGeVOZ5mdMea27jBjDo2MCwJdyDJ0VAgiACEppiI4TrYNTBYBGPNyhWMdlN7rC2EUAAEmgAD+hXU5Y/osq3av/293//+7////9Oj/T/6v2953Q2AQBCSDLQ0gy0BY4SpMVcykDAJQygcFQlbLutrDiCNpLrVKjOVNKONNC/V7jCyJbvOY6l2NJenJyVvVIJ7KrSy6RTj72nxEXBzVwxQxyabk7D9y7VEMx2VUKAIXedjHkuqrwBKcNA8is2vtWsOY933fOYZ540tzVWY2+sFtIsY1azxfSwCg6dQB/I71tUC3/Ff7D5ZuttGUXo3Ei5SHf2+Z/1ej226OLo9f9///R06a/cvVg1cDQEAAEBJkomUkL9hQMPLGFhkxfhiISgkEKE24qaRhqC2WdPJGmvwpibt1dc76j5QNP6z58tb6RxNoilroyEo7H5xKQoUToERQDLMT8a1pF8njTM21UHTMioj/+5Bk/IHWPkTR+zzt2h3AGHkAAAASNQtLzI98AImAYYgAAAA6TNPoKRAxZELHiCpMrnNkGTbstkmNTiZSFw0lsUi2iRoaMA2RKRug8SwGqr//Pu9dv/0b//X/of0XdSv/b//o/lf/9H7WY8w7AmRBEYDYzPMMwcidT6MY0IqLemkBwEoBAtdQdYRYQvck1IFGsXFiENxj/xwUTJir2V6/hV727hCotU1zWPblibs4wAKpnuQ/djOkqxmju91LpbCA7IYh0zB0loDrAwikNATSqQdPU6NFG71oprVTKQzRVaxkW0TEIQADTU+Q4GUKO/+lBAUW1D1Umk9Fv9X0qd2/8+73y/R93/Xt9v//Xfeq6UExAAAAOsguoyIHQm5oxYQ6BrgZMLcKzgQIlFrSszSWyp8JEsuVlgCHIAwhFi5bmixcmVS41vqXUvL1JcPh1D8CLlosD1BH0xcILK5zxstVl0zG2kr3lNFlqrz98/8qbCpHa9yVX35t6uo7GRRBgwKuqW8kE/NWvyyqYdvY/qt3lbLnZ+U2AoEvrjVtPRjnDIz/+4Bk7gGUQ0JT+yamAhrACHEAAAAQcQVP7I6cCIQAYdgAAACABlZI71JiAAQzQABajxC6ihgRT6lD6ApZKf///3f/pfos////6t+i6nYRkRA4AAyiYRgq2CxhCyNHmJAZLSThCo7JCOvMMBmqNeaHzhQTAraM3lUFSzWX6KpZliM3chZibrNrhbDQuTj5106lMqIELC5wAPHsC40AQ/SxOM25FJcfx5+ufdtazsW7cy9sxhI5Q7aAg1FqEpaV1qXXcO6wyzt1bmWX0tmkr9xp5iPRsQhUXjVanT0tSKZeE/AWdmVTmqam//8s/f1DTLW/Un/+h91zV//f/09O/9///1/3dar73/aZdwsIoAAED468l6cBh6gBQUww1HgauAA7A4WCok/S5SDJ+DVEJiPGI8zGZmT+3DvAobtaBLmeFq7G+PJqlukVkXLxDQTKAYMOQIzUdMGX10OgtRxZbLu16iVAXWjWJ1Jf+39e6v/7kGTugdTXQlBzDN2SIOAYeQAAABNpDUXsp3ZgdIAhhAAAANEmTS84m7jOBTIaIID6N17rmmXU8F432PV36bLbMhj5u3Zqu023dTqnU0p/VkUOf9XXRWdQr566xX1d3DQ7goQzGaFHkwCNk1wTKNYsQrlozCYf4ScTZc1sivFmF0Uq1+M8U4Rrgl+oM5+9EgJMRvXLnIiSgWXFRol9qxuiyqJsiIc4GeRUioW5mV1oZ5y+3SUzHTP1JlwZcDMBwLHTZFL/S/Wr0FKHey8jivMwSIAqtKjolj/R9U4n2bM6GGlFbP///7PX/du/6unT//66/c3lqIcFWMAAArIvohEE/IiGbILmjkLGBEdEhjHIiEIlHkDjCyOFQM55KY4EVv/4HuB4ri/8728W6diMk8m9TadXivSgEJMDChiiktSSDqqLp81fzI8XjRvqOj6BJYLLKyL////WWnfMi2yISHAWcmiyiDAAFJiU0VmKv0pW14WQh/ttqX//R//9+r/f9f10q+r6r9F23q/bznmHYFWOiAGbnMMbl4LXDvTOZDp2FP/7gGTygZOeQVP7L6NQLWAYUQAAAA8pB0nsppZAbIAh2AAAAJGHi3KwqMPKt0ZWnUvBCODGyQ88DavNDfP/XtFKFMO/3+9mTUbMWvHrWhLCVkiwFAYCogZE2NfXSff1ompwvUtNAvjMASjgMMiCpI///+tIyq0iXRMQiWAsFKkRukcb9Vara2aHfZFdNbEodpT/Rf8n9nUd2dnf7E9NPfbrdsdTVTsG1aeIkCABAADgAAsROOAYU44AUQbNVEE9NJzK+hHThFHQeOVp2KaqIMEe6B1uO7E4bi8ZqTIoIxqkMtl1mrcrSapT1oba+/k7Ln4sNKk6l7WFN1bAuFTET8PqM0w0DFV2cP/GKGL4fYzs9339dx+1nT4LRpJW+jAxEAAJD0wessygD4BBCms4sPS21zv//////19xfOu7196nBYbGXasTKqwcKyVJcUwNhIxVCsOA5UrqS0YAADLASH9RkCtAa+jPBto5CTv+//twZPwAk4xB0/sPo2AmAAhmAAAADkUDTeymlkiiAGFEAAAAgZq6f6W//bt9L+3/0//lPa3/71tpx3qAhTQgQOZIHFqJZ/wdEAKISUXWlSYxxMsBViLsAYqhzCUY0TJfJmvtOa4/r/TVPO4p6lExOYZcyuSGXSy5GrtHvPd/sqnoy2R/k0TAXY+NLDAZxZdZ7AGX+3/UdND6jZSZcIuMwG9gaaLgGgA2FlQzJFi6kj/+syNz6y6kUyDlArFE0WUAuUakAABYQCiSFTLSapBFb/ziEfruT7kUo2ft/////////u/7/7P+lXRqhCAzAADgAAsDCiJCCbYxtlCEU16RFGCFzjOZ2ahY8e+q31zraWQp5eL9MUgNuMka3hKanRQIaSWKxeUT/y7DKmtx5/JLGe/lbpHIl7sxdP/7kGTtARWRQsz7HOt6J+AIaAAAABKFCT3sbq3oaYAh1AAAAIQwbG03LHYDCW3jrw5L3mnO//9x/9a3/4U9FvCvKIbZQX3AgiGHs9GTIUhAJLVfqW2set/5wvObFgni6U4CQIscs1THMBwGGWEuBDGAMRCQa5QM6QAAC0BqtXr1Ci17tffsnl6vXP9+n///7t9y7f/d/tR1//05KSwCIkB0lgali5ubCpYjcEcByRgLu07QWaDgldMwUUAAGDDGXyi848VgOL0uUBQ+OeBmVdiLYWt0zfyqnwf9lTdY1ANHFpFDqZrLmXIYhUKGFqCdQhhhQEgoNNxiW5md7+f//8y3hztSnpPwp5Y/7XEfxYWHkb2dJNhh4Glxl2u9GabF7/6nsoyK5qLEEwqViqSZkK4CwrHOEZAI0wHHAcFrJEjUYIJNP+ln/fS+nT/Wr7/+/////////7qFqIuQVUQAQOAABC6vQzgwQ6AhEXTZ5M8tjxuKx4lGDlESGLKBvUPArCLqoIVPRxqVbuuVSBgf1nKX/3pI5InibNkWJzqxGoKXCv/7kGTnA5UoQk17Pa1aImAYaAAAABTJCS/M8rVoW4Bh2AAAAFwMICADkwlAsHBOaBuaIL//poH60DMmByw/QBIdAyNbQMtAoOlHcVTZF///2UeE3OUj6ikGblIBDOBE9RvG6qAGAh1Pf/c7UueeNp3+u5Kf//Rd//Vr//2pa7d83///R0qlIdjEAEAAOZQ44QDUTDXDtDJbB2JnKnCAupHk3yR7l9IqrY0qBZTBkKWK2kMO25ON2WXiA4BDpiGWvu2HZnaj6xt/WmyaNPfD9h/kWm9eJHoRBcwDLjYMJFQkMAFh0dqYX+ffx/9/3+b5dqV/zwp5Y/bFCgVHSNMcKLZh8FF2WJO7GqXJrf/1O4+AbtLRgphcQLBSHCMaAugQDC8DkP2I8sHaVf3f+USYsp88+ZZ////7///3f//9P/7OzUqXZ6BTQwAA4AACzAk0XGGJTeHLIDXgiFN1kM70Smj1DTy7EiWkqm8iqEqeZoE9P919/yx8NW0/0nPYRFNbLyKKqLdk4BwfHxMJoBhkAgFwoHCsQKSZUN01f3+gXzSgZv/7kGTjAdRBQc77Ka2aIiAIZQAAABRhCy/s8tHoZIAhxAAAAlwi4swNnAwAIAMw54DRINEAh2lY1Sb//9TlIl5NsiVwUCRBRNoAMEAziExHxOmwsCHAfq/uTr7VsYY/3/7PR+pP/p//////+j/0wRo4CQCDAHBqg0gChDEXKHKU0QxCiOJmRE44pOPTq3F42loEVNlFnGttJfFbDEWHSmVSSARknAYC6R0rLvy35utEZuD3RWNNsoeZ2LFHIEYGhzCRo6DwqtphekBAC6qDM4Aldu93+5f3v/rX9qXbn8zsS+KNTMDgJNa4jM+SCMLAPBwBLFd6M01l7//63OB6J8V1Ioi1gKC4XKFoIGIcEB40AgsHhbSSKp9kgBgiV1HPkl19DXexb91FU4xmqz////oquIyFNWQAQOAAAKyGGHSGFqxhoRJG/AkAYyCqLTBbUSuk09GFwO3Bbc3aUar6oYEu3frktAsna/8vSrXrMohJlRlqpCsKQyKWAwcDwOYBQFgyMmVT6Cl/+3LidaBmTBAxCQBIRAy5FQJMgaJbPO3////7kGTuARR0Qk37Ka2aGqAIdQAAABVNDy3s9rHgXwBiJBAAAPUTSig6yiOJZUAXIgAz+FvNFgQEB1tDP7XP+hCTyXM2f/UTs1bedVHVUb/+rdbt++1/6brttfrd7mjG6P+856qXBVDAgAKGmoGeEgdOOxjA4Ysi2FzklMRE4XeTEBKpd9IdTJpzd5A0emtsu5//tWYmPtZ8z7RyTKiY8o38ztm3SWI8EjQGcIkETUv/9ZfepFJP6JDgMdCAUAjiNUkf///mPreoSIEQZMAhg7dNXnof6YeQOhzKNu/1Jp7v1f/SxGK9P762v3f9H+9qaOn9rdermAngx3ACiQccBGg50FHBQE3xjHZEQRhw2iE4aQg8qBl7QKAlW2J9mILQwgBoUV5/7bETR9//2w0SpQKAeQXbOxSRIWhUXQ6IBSeSTP//mGo1MlegmQwAUoGnf///1MZOg0xdIyCAQG/Gr1ALlQANViaUa12JMnmkmPyDJiOrV1+v+/3f////r/r3bmIk1mIKgB1ElsYkiAwC+QxCLKjEDgaNEZ8iGqbkQBQt+f/7gGT2gJQQQc77Ka2aKgAIVQAAAA2JBUvsppZgkwAhpAAAAJyKIHPnbjbZYcYnDzr8/mKTxQjy538nlyRlgMitDsJ+4CRuCZMAhJgbkIOMuG//+nqMjyvqHyAC3DVRETZH///87XrN8JBB3nlg6/6W12oxdADWQFVX3t///0M7fX//////69n/9NX7qsWmiDEAQ4AIjzMVNGw4wwasKxWUZQE4xZdosFCOtqvB8XcSTVmchm6mT8zea6kluiJ6Bg11VOcuUEUiAkPurYqpGpMjlALLwOwcE6myKX//1J9aCZMCkwM0vBRikv///WnsYL6z7LCYQLlqUD1//zXjuh4wkr7tH0/9f3aPz6u7V/r9471YpKdre3v9y/y7uLh4UVBEr55kpAikIFKIF7wAIJj5mQjCJVDTEDi0JC30u4nhNKlm2ARN/Pxn8VllA/f//h0kg6aOnPP7kzHUXwFggBckVA+g7f/+o/+sfgEP//twZPyA03VB0/sppZAdIAh2AAAADaEFTe0mlmB1gGHIAAAABCUnjVL2//zpezM09b2ESBYW4CAFSJ0d91rCI9EjKs+mw57f/6lf///1f9n//M0K+JnJZFUAwIIACKETBBqBW+RaiMVpwOJAgY8gwsBCD0alrc4+qFd8P1oqvJl8bjNOjQhj4OXJ7OsrnFnkh8kPpL3Jc1NiaFCgnYAzrsTcYnFq//9Mv+mgXxZgHeAKmLqX///PakvXyHBSzqB7mo68W7KTqbN61wukD8V/ZR5K+n7P349xL270sA/fD69Y5Uo7obLNdDFCaU17U5jRMsAhEHABBIgwauhWwtgLnG3k+FBj8qUjkBI7C3ZHSsyZgvVMdh7kVXhm4J8RMK6y3y0gTR46mWVn7VGRiZE8REG5wFpmHnJF2f/7cGT7gRNoQVH7OKD4IgAYYQAAAAytBUvsmpZgdAAh5AAAAP//1l36zAa4FSiK4RE2Rfv//qepEu+tqh9g4PJjlTTV1b0siqyt/zlyP///Rp//6fR/00f/6lf/9NWlZ0JTJAAA4IALXmZMBljYETgMFQ0jhAMIjlMFHwa4ZRDMkHS4SJ7Im6s5bd3G8ibyY9oZvQ6SwxXROOSm3O0dmValVNQyWI0salGcUSYed5V8jASMG1U567jB4LXY6cMRunsd/D8t//N/386nfzwp6R/2cFrzVQnNKBNHJ/aarlj///+bLZJEho2DYsA1YgFxi/SAAJFIAB/U7KG9diFq12Euj/r////////d///7P1QqyyChGBgDqo6OARQzwBRCOcBUlVwy1h0QFCqykVtqTsoQ8ftUzW2vXZz/+3Bk/QCTT0FP+zScwC6ACEEAAAANIQVH7EayYHMAIdgAAABl1iOV7legIRlDh2kc/L5HO0ECZ9v0k9KaWgpNXIZTBYcu1CSYCgYYlIadiFcYeASHAEwWBr2scvy/9/zffz3rPD9Z1JXEGRiAIjAVujCsGQwBmmxaltY9ZX//6jU0dyNGybE0DR+ApiJkJEL7cQ+ktnLnvX6xRCqXt1bK+zO1///6/W6j3dn0f/9if0LXdlJBIQgA4oAEsDwLATJ3hGGsQnokk2hEGDBmuEqaBqwA0UlVdd1j8qlbtylrMudavfv3CwLJgWCCwbtMyi7IP5J+XrkMfG8rVTCNq7diXvoDQFMNjuONizMKgGSvZY78YpM8PfqQ7IqTQ00C+RQZsLIANHj8DO4UC6kZoul5FKpFL67a+65h//uAZPgCFJlBTHs8pHodgAh5AAAAEqUFL8z2keiHgCGUAAAAMrmJIpJA0D4OCRVWnADKAAN2S/6GQOOFS1ynkLfpZ/tv32pSq/2d7V/6vo/u/1fo//S7X0QrQoIZmAAHBAAieC4jQAFcDfxQ0SwJiAK2h3ZCVQRYtfAUCXap0jw7MqY82OLNeZe0O/dpag4UwwabyjsYnZ69K9dmJzGpyrMYy5M5xWvI9AwImG50djZpg8EIIXilNznefreH/r//uH4d/eFekibSBGDTD05MZAhWGLTtrHv///5ykio6VaYSaCpzSkZbId4zUne09n02WnKrKP/tbZ0bf6P/9luuc/////XVpnVTQkEAAOIADJ8R2Ns8cEBCAKnBWAJgEky+IQ+JIg7prj9LmUtdNWWGXYbjDyxYq+89IqeMCgyhhmO7TV5fD9JTz8vzpaSXySXwiAbscXgz+AmbCwGGL4onqYoCRNkQEK7fiH6epn//+5Bk6IAUpkFMez2reifgGGYAAAARlQUx7PJx4HuAIdgAAACs+Yd/vef+OGH/hnYl78JsmTBUGPAPl0muxqlyx6t0bOtS/6U4cLaymYsUy0iahEqBb2lONwCLf6hvsYoWuZ/rd/F20u9VX/6Xfv2ef6v27qrrSWz/2/RanCkZqQGHydV5QaIkhaFuJhNGaaLMhUuECAwMiTDcRpDzM+Wulc7DD30Z012c7q7LhzUeYl61H5qWVKS7u3Nyyhp6TCl7IVEHucVaJCECSYmJ20QA1OavHKe3e77KrV1KdSaqk0C+TAs8BYGAYzfABx/GSKpsz7e3+mouGii4ZzrzpUXBqFQoXj6LeGfvo/LdtnU7//6m/3fs//////fd/9TP6IVoUGIzAADgAAY6Yygv5JpJIQTVyP7CxAqOJEjEkAhRe5VdlKqawTkxaHGkTsgabV1SdIAnFkcpbVqMx7CrbysXZVJaKFRTWEdZS3JwVig4BjD4gTpwOAwdS/Tqyecqb16H0EUFtTV2TNCsHwgZnWoGQQoFsRmidLyKX/+mqbtoziX/+5Bk8oOU5kFLez2keiJgCFEAAAARaQcxzPK06GKAIdQAAAAxIR1A1FYIisW4AEYAApTf/iJ/VbYiI6Fkuyr9zN/9n//Xf26dvZqVd+pDf3o/+yjKyqZ2diDA4pAAgwNpDADYUNFoIaDOAqSLSkQSiBVWBzDJkyUc0qljyFmL7sud1QOONZ1e56hpXV/dfqrSYTmFe3K88q9784vYvzS+wotHAIaPj/xivhh3//1p0DD1oJkwJvAxkkKHEX//+syKqzBNObVbHrhEWJyWkFSfj34r6cOiAIRyApOYpaumuv2fod6P/7///uu/s//+peu6xoiFYUCDsAKtGaCAEyj4ciGjA5wSvL6gLl8AqGLMI2vA0BVycbm00MOBQXpdF5+tZyTQIocN87uEVWkyYLTIb6SmiQ5IC6YD4jxBxFTZv/8xM5j/mQACAOVJ5F//81OGa0Z9JZmraxrUDQWLA0ASAJ3/RrcOXv7jbr/2f/t6LL/v36///11f/X6v/9HbmWlxMEMhR6ACUQMIYoIApOxwQw+IPJQplH6MjBRJoXIQDUP/+4Bk/4CUX0DL+x2reiYgGGYAAAAPHQU97O6WoIaAIeQAAACQ6tJHAuZBTIIblTyRJG8P4FBKCq3PmSykT5cPlgytXLiaBmTADxoHTGCxlxNB//0DBnMv1JkMAFFB4v//pLPIu5pWcOrrqPMkDQWFAJ4/YBdO7q6WNpoqqMrVZV8WCn/rfr/3f///+/r3J/o/Rud/Quy9uHmHAwDD4ARXmKSDBTOVCHwdUZbBKcBRQUPVAjo8+tG0sVMVIdoD+tNcKjmnFp+//VOiJW5l3WdGV0SsBnZv5RqSJDgKIwNoOGZLyKv/5uZoOdMf1FkCpkZo1S//9MwSRYzUgmcMkXdRqhBoHC0k0DNRwABJagAPpo5BlSSlCleOTqYaLbf9P5M4jO7AGghsADqAuCALw5EgGSsMlJBY1FxYR/hAIRNLTRSAwTusBVynS8kXxh+KQJ+sPKoBML/65965MelatXLVYOYWoiYBAAA0cCw9wv/7cGT9gBN5QVD7JqWYHsAYZQQAAA5xBUXs4oPohQBhlAAAACZaTQ/+t02qQf00CbAwIAQu1L//540MVokWlVE8kcMjKatBoCyVUZoLQoG03rYAKDtL82ZRyrguOZtY2R3NZo3XMt/3f////v/33f9P///o7cnlu4kLSMPwBS4yHQDCNKhmJjmB01MUMm2JKiwkFAiUws0nsndIF6y6s7rWWwORIf//TaEpYtbpKPM6ySxKLH+H36HmiRDQh8BniQImVL//Ol4+zIJ/rLARgWTZv//c3dcuoVqQMklOWklhJYgdz+x/QAAlKgAPZ6Dywx+pTaoCYpf0f//6v//f///////+lVzEWyuyB2AxaAASDePbQhiInCAABJOwBUgpUpua6gKwVjc5OtpyBdhqsPvRIGfNagb88uH/+3Bk9oATokFQ+yalmhUgGIkAAAAPkRU97Jq2aIiAIeQAAABVAwS2Lq5V7i3M0BAUAwKiDj2b4xxZxIhAFAMANpgcAx2Euya//WXnTSNTZq9BMmAYCQUAxqlt/+mt0VmR9JNBIyPpGqyRpBAGRyjNxS4TSbkUGKLPMX62fo61qoWBkf+70//9H//9XVc7//u/+qr7q6RWdALAozABu0w1M0REiam9AmGIhlUeYgXgx5Q0d2Llf+2jw9zGV8q2uYrbMuXDT9f/bJLAivPVr9Xp07uYnydQRbRJY2NSiKwCdUDNwBflIzUnbN603dR1pQWZHezLOD7AgxGYNUmrzBNLrVnjiBkW6nPGS1NUo8kwQAw+gSbSMAEAsABYCv6D/6eL1XMzIgFP/7P//2df/+r//////r/MuUl3//uAZO0Ak5JCUHsmnZoe4BiJAAAAEKEHNeyatmh0gGGYAAAAgE0DduAQad5QGCOEsPhMJMa9DBJoQhSwRFpXNxGTGhDQLfsMdNxJI4blMrkfYMmCgeg9FaVkGJgiiZfTXRKpkYmpeAgDBGQGyW21VIGCDL00006BcLj90D+RiWcqWjYISbIsc68bl/dW9UkYpLGHJW1xyGsLsXYuxQBTR+LkMP4/liJuW7b9xRTtnLD2vw/T5Rhh7E5HKHYciHIxYW57f/WhZRyE3PH24Tp1//zf/91P0ejlfq7fv/+r3f9Sav3O6YqqFWBpvgLGR/G5g358YTmOAVNTONVjfiTCja5Wbtka6m+waMxVd0EwI1lrP//tGJjZ5cq4Tc1lPxKs15/aS5bwv0dPetR6bHCHYcoz1+P48xvXqXHDmrtnHDK1VrS6hltXlW4I1SPtnG78apnLEaC26fJ5RK4YKpVKUN14jnsqlYe3Royqswz/+4Bk94DUD0DM+1ih+B+gCHkAAAAUQSE57NMTSH8AYYQAAAAlyXmLAqxK4kRCV0Qo8kKc5vBVz2LFqSX19YmQIUoATr/uY70apT3sY7xZ8iX/1///+/6P/29P//+vu7tepiCXYskoVMID1sG4mAtih0z5QcQZB4IBkJUKCCobcdGSB7rSmvP0sDArIbN3//TPiYbv8y+1OSq7VhUw+vMv1rKRY5S6lHShsOBsf/L+ZarZ3/1S3I9a3hbp5/W5rHDDOlCp0zr1a3dlNFy5Zsc1ezrcxlt2AGfU2pm1SX7UNbRttImR0CVViIi1Q65hhLM8ooXVEgAAQkCp+lX+hgbL29Pct//5D9X//Yjs9v2//9X/+qrL3crYiDXgzsAYWhJQVYoY0YOBNAsECp0BkLlGe0AUCRkyAXFvJesrsu4vKLOq+757y3cYUNBZ6738a09lQWpVTJNatR1i+YCkgPqC+y2W9aKNKs4TxupNif/7kGTqABUySs97GHx4HoAYdgAAABLNJTns4TygfIAh5AAAAJPMo2WaqTQMwBBotXUm1yn7rxtqZKWFSKYlQhVvESJ951ZNV+hgRIiUhPHYKigAAacCn9bZF5N3s6NKez7f0/b+7//////9X9bvDvMvUFuxc11CZvavYk+QlMIVXG6t5BTxYmI0kcw/+RXFqhLdPmyVPLJUDTP/NRrACPxHBTQvtkv+tJ/0q26h3Bai4bG5VUxBTUUzLjk5LjVVVVVVVVVVVVVMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7YGTrAfQ2Rsx7M046GyAYeAAAAAjIuSfnmbZoAAA/wAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EGTdj/AAAH+AAAAIAAAP8AAAAQAAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVQVBFVEFHRVjQBwAApgAAAAQAAAAAAACgAAAAAAAAAAAaAAAAAAAAAFRpdGxlAFNvdW5kQmlibGUuY29tIE11c3QgQ3JlZGl0GgAAAAAAAABBcnRpc3QAU291bmRCaWJsZS5jb20gTXVzdCBDcmVkaXQEAAAAAAAAAFllYXIAMjAxNxUAAAAAAAAAU291cmNlAGh0dHA6Ly9zb3VuZGJpYmxlLmNvbUFQRVRBR0VY0AcAAKYAAAAEAAAAAAAAgAAAAAAAAAAAVEFHU291bmRCaWJsZS5jb20gTXVzdCBDcmVkaXQAAAAAU291bmRCaWJsZS5jb20gTXVzdCBDcmVkaXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAxNwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8=";
var media = {
  webm: "data:video/webm;base64,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",
  mp4: "data:video/mp4;base64,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"
};
const { webm, mp4 } = media;
const oldIOS = () => typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ""])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
const nativeWakeLock = () => "wakeLock" in navigator;
class NoSleep {
  constructor() {
    this.enabled = false;
    if (nativeWakeLock()) {
      this._wakeLock = null;
      const handleVisibilityChange = () => {
        if (this._wakeLock !== null && document.visibilityState === "visible") {
          this.enable();
        }
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      document.addEventListener("fullscreenchange", handleVisibilityChange);
    } else if (oldIOS()) {
      this.noSleepTimer = null;
    } else {
      this.noSleepVideo = document.createElement("video");
      this.noSleepVideo.setAttribute("title", "No Sleep");
      this.noSleepVideo.setAttribute("playsinline", "");
      this._addSourceToVideo(this.noSleepVideo, "webm", webm);
      this._addSourceToVideo(this.noSleepVideo, "mp4", mp4);
      this.noSleepVideo.addEventListener("loadedmetadata", () => {
        if (this.noSleepVideo.duration <= 1) {
          this.noSleepVideo.setAttribute("loop", "");
        } else {
          this.noSleepVideo.addEventListener("timeupdate", () => {
            if (this.noSleepVideo.currentTime > 0.5) {
              this.noSleepVideo.currentTime = Math.random();
            }
          });
        }
      });
    }
  }
  _addSourceToVideo(element, type, dataURI) {
    var source2 = document.createElement("source");
    source2.src = dataURI;
    source2.type = `video/${type}`;
    element.appendChild(source2);
  }
  get isEnabled() {
    return this.enabled;
  }
  enable() {
    if (nativeWakeLock()) {
      return navigator.wakeLock.request("screen").then((wakeLock) => {
        this._wakeLock = wakeLock;
        this.enabled = true;
        console.log("Wake Lock active.");
        this._wakeLock.addEventListener("release", () => {
          console.log("Wake Lock released.");
        });
      }).catch((err) => {
        this.enabled = false;
        console.error(`${err.name}, ${err.message}`);
        throw err;
      });
    } else if (oldIOS()) {
      this.disable();
      console.warn(`
        NoSleep enabled for older iOS devices. This can interrupt
        active or long-running network requests from completing successfully.
        See https://github.com/richtr/NoSleep.js/issues/15 for more details.
      `);
      this.noSleepTimer = window.setInterval(() => {
        if (!document.hidden) {
          window.location.href = window.location.href.split("#")[0];
          window.setTimeout(window.stop, 0);
        }
      }, 15e3);
      this.enabled = true;
      return Promise.resolve();
    } else {
      let playPromise = this.noSleepVideo.play();
      return playPromise.then((res) => {
        this.enabled = true;
        return res;
      }).catch((err) => {
        this.enabled = false;
        throw err;
      });
    }
  }
  disable() {
    if (nativeWakeLock()) {
      if (this._wakeLock) {
        this._wakeLock.release();
      }
      this._wakeLock = null;
    } else if (oldIOS()) {
      if (this.noSleepTimer) {
        console.warn(`
          NoSleep now disabled for older iOS devices.
        `);
        window.clearInterval(this.noSleepTimer);
        this.noSleepTimer = null;
      }
    } else {
      this.noSleepVideo.pause();
    }
    this.enabled = false;
  }
}
var src = NoSleep;
var desktopIcon = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJkZXNrdG9wIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtZGVza3RvcCBmYS13LTE4IiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDU3NiA1MTIiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTUyOCAwSDQ4QzIxLjUgMCAwIDIxLjUgMCA0OHYzMjBjMCAyNi41IDIxLjUgNDggNDggNDhoMTkybC0xNiA0OGgtNzJjLTEzLjMgMC0yNCAxMC43LTI0IDI0czEwLjcgMjQgMjQgMjRoMjcyYzEzLjMgMCAyNC0xMC43IDI0LTI0cy0xMC43LTI0LTI0LTI0aC03MmwtMTYtNDhoMTkyYzI2LjUgMCA0OC0yMS41IDQ4LTQ4VjQ4YzAtMjYuNS0yMS41LTQ4LTQ4LTQ4em0tMTYgMzUySDY0VjY0aDQ0OHYyODh6Ij48L3BhdGg+PC9zdmc+";
const DesktopDetectedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  text-align: center;
  z-index: 9999999;
  box-sizing: border-box;
  padding: 50px;
  font-weight: bolder;
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
`;
const Image$5 = styled.img`
  height: 90px;
  margin-bottom: 25px;
`;
const Text$3 = styled.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-size: 22px;
`;
function DesktopDetected() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(DesktopDetectedContainer, {
    children: [/* @__PURE__ */ jsx(Image$5, {
      src: desktopIcon,
      alt: "browser not supported"
    }), /* @__PURE__ */ jsx(Text$3, {
      children: t2("common.onlyMobile")
    }), /* @__PURE__ */ jsx(Text$3, {
      children: t2("common.goToMobile")
    })]
  });
}
const noSleep = new src();
const steps$1 = ["otp", "conference"];
function ConferenceApp({
  showOTP,
  onBoarding,
  token,
  onSuccess,
  numberOfTries,
  onError,
  onConnect,
  interviewerData,
  onLog,
  queue,
  showLegalModal,
  customImagesSrc,
  otpTimeout
}) {
  const [step2, _setStep] = useState(steps$1.indexOf(showOTP ? "otp" : "conference"));
  const audioRef = useRef(null);
  function setStep(step22) {
    return _setStep(steps$1.indexOf(step22));
  }
  const playAlert = () => {
    audioRef.current.play();
  };
  useEffect(() => {
    noSleep.enable();
  }, []);
  function handleNextStep(time) {
    noSleep.enable();
    setStep("conference");
    playAlert();
    audioRef.current.pause();
  }
  if (!mobile.any()) {
    return /* @__PURE__ */ jsx(DesktopDetected, {});
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("audio", {
      src: serviceBell,
      ref: audioRef
    }), /* @__PURE__ */ jsxs(Steps, {
      currentStep: step2,
      children: [/* @__PURE__ */ jsx(SimpleOTP, {
        onBoarding,
        token,
        onSuccess: handleNextStep,
        numberOfTries,
        onError,
        onLog,
        queue,
        otpTimeout
      }), /* @__PURE__ */ jsx(Conference$1, {
        onBoarding,
        token,
        onSuccess,
        onConnect,
        interviewerData,
        playAlert,
        onLog,
        queue,
        onError,
        showLegalModal,
        customImagesSrc
      })]
    })]
  });
}
function renderConference(element, {
  token,
  showOTP = false,
  numberOfTries = 3,
  interviewerData,
  queue = "",
  showLegalModal = false,
  customImagesSrc = {},
  otpTimeout = 3e4
}, {
  onSuccess,
  onError,
  onConnect = emptyFunc,
  onLog = emptyFunc
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element)
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(ConferenceApp, {
      onBoarding: this,
      token,
      onSuccess: props.onSuccess,
      showOTP,
      numberOfTries,
      onError: props.onError,
      onConnect,
      onLog,
      interviewerData,
      queue,
      showLegalModal,
      customImagesSrc,
      otpTimeout
    })
  }), element);
  return {
    close: handleUnmount(emptyFunc, element)
  };
}
const isWebRtcNotSupported$2 = !isWebRtcSupported();
function renderFrontTutorial(element, {
  onSuccess,
  noWait,
  token = {},
  videoSrc
}) {
  if (isWebRtcNotSupported$2) {
    onSuccess();
  }
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    noWait,
    token,
    videoSrc
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(TutorialFront, __spreadValues({}, props))
  }), element);
}
const isWebRtcNotSupported$1 = !isWebRtcSupported();
function renderBackTutorial(element, {
  onSuccess,
  noWait,
  token = {},
  videoSrc
}) {
  if (isWebRtcNotSupported$1) {
    onSuccess();
  }
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    noWait,
    token,
    videoSrc
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(TutorialBack, __spreadValues({}, props))
  }), element);
}
const isWebRtcNotSupported = !isWebRtcSupported();
function renderSelfieTutorial(element, {
  onSuccess,
  noWait,
  token = {},
  videoSrc,
  onError
}) {
  if (isWebRtcNotSupported) {
    onSuccess();
  }
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element),
    onBoarding: this,
    noWait,
    token,
    videoSrc
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(TutorialSelfie, __spreadValues({}, props))
  }), element);
}
function renderPassportTutorial(element, {
  onSuccess,
  token = {}
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    token
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(TutorialPassport, __spreadValues({}, props))
  }), element);
}
var Document = "data:image/png;base64,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";
const TutorialContainer$1 = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: auto;
`;
const Title$6 = styled.h1`
  font-size: 1.6em;
  text-align: center;
  margin-bottom: 1em;
`;
const Subtitle$1 = styled.p`
  width: 70%;
  font-size: 1em;
  text-align: center;
  margin-top: 0;
  margin-bottom: 40px;
`;
const Image$4 = styled.img`
  height: 250px;
  margin-bottom: 50px;
`;
const TutorialAction$1 = styled.div`
  margin-bottom: calc(var(--vw) * 15);
  min-height: 82px;
  min-width: 50px;
`;
const Button$1 = styled.button`
  text-transform: uppercase;
  padding: 20px;
  background-color: #3db0f7;
  min-width: 215px;
  height: 62px;
  border-radius: 31px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  line-height: 1.5px;
  border: none;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  &.hover {
    background-color: #3db0f7;
  }

  &.button-hidden {
    display: none;
  }
`;
function TutorialDocument({
  onSuccess
}) {
  const {
    t: t2
  } = useTranslation();
  const containerRef = useRef();
  return /* @__PURE__ */ jsxs(TutorialContainer$1, {
    ref: containerRef,
    children: [/* @__PURE__ */ jsx(Title$6, {
      children: "Align your document to the frame and take a photo"
    }), /* @__PURE__ */ jsx(Subtitle$1, {
      children: "All text showing must be clear and readable with no shadows"
    }), /* @__PURE__ */ jsx(Image$4, {
      src: Document
    }), /* @__PURE__ */ jsx(TutorialAction$1, {
      children: /* @__PURE__ */ jsx(Button$1, {
        onClick: onSuccess,
        children: t2("common.continue")
      })
    })]
  });
}
function renderTutorialDocument(element, {
  onSuccess
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(TutorialDocument, __spreadValues({}, props))
  }), element);
}
function processId({ token, queueName = "" }) {
  return api.post(`/omni/process/id?queueName=${queueName}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
function processSecondId({ token, queueName = "" }) {
  return api.post(`/omni/process/second-id?queueName=${queueName}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
function processFace({ token, imageType: imageType2 = "selfie" }) {
  return api.post(`/omni/process/face?imageType=${imageType2}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function processFaceSecondId({ token, imageType: imageType2 = "selfie" }) {
  return api.post(`/omni/process/face-vs-second-id?imageType=${imageType2}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function getInterviewerName({ token }) {
  return api.get("/omni/get/interviewer-info", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function getOpenTokTest({ token }) {
  return api.get("/omni/get/opentok-test", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
const getAddAddressStatementUrl = (fileType, docType) => `/omni/add/document?type=${docType}&format=${fileType === "application/pdf" ? "pdf" : "image"}`;
const addressStatementUrl = "/omni/add/address-statement/v2";
function addAddressStatement({
  token,
  file,
  image: image2,
  docType = "addressStatement",
  onProgress = emptyFunc
}) {
  let promise;
  if (image2) {
    promise = api.post(addressStatementUrl, { base64Image: image2 }, {
      headers: {
        "X-Incode-Hardware-Id": token
      },
      onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
    });
  } else {
    promise = api.post(getAddAddressStatementUrl(file.type, docType), file, {
      headers: {
        "X-Incode-Hardware-Id": token,
        "Content-Type": file.type
      },
      onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
    });
  }
  return promise.then((res) => res.data).catch((e2) => Promise.reject(e2.response.data));
}
function processAddressStatement({ token }) {
  return api.post("/omni/process/address", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
function processWatchlist({ token }) {
  return api.post("/omni/process/watchlist", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function processGovernmentValidation({ token }) {
  return api.post("/omni/process/government-validation", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function addPhone({ token, phone: phone2, text }) {
  return api.post("/omni/add/phone", { phone: phone2, text }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
function addName({ token, name }) {
  return api.post("/omni/add/name", { name }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
const addCustomFields = ({ token, fields }) => {
  return api.post("/omni/add/custom-fields", { customFields: __spreadValues({}, fields) }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
};
function getImages$1({ token, body }) {
  return api.post("/omni/get/images", body, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function getConnectionDetails(uuid2) {
  return api.get(`/omni/queue/conference/connection-details?uuid=${uuid2}`).then((response) => {
    return response.data;
  }).catch((err) => {
    return { error: `Error: ${err}` };
  });
}
const fetchModulesUrl = "/omni/get/onboarding-modules";
function fetchModules({ token }) {
  return api.get(fetchModulesUrl, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function fetchModels({ type }) {
  return api.get(`/omni/web-libs?type=${type}`, null, {}).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function update({ token, updatedData }) {
  return api.put(`/omni/update`, updatedData, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
const verifyOTPUrl = "/omni/code/verify";
function verifyOTP({ code, token }) {
  return api.post(verifyOTPUrl, {
    interviewCode: code
  }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
const generateOTPUrl = "/omni/code/generate";
function generateOTP({ token }) {
  return api.get(generateOTPUrl, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function connectToQueue({ token, queueName = "" }) {
  return api.post(`/omni/queue/conference/connect?queueName=${queueName}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function addConferenceEvent({
  token,
  interviewId,
  opentokSessionId,
  eventType,
  details,
  eventSource
}) {
  return api.post("/omni/conference/add/event", {
    interviewId,
    opentokSessionId,
    eventType,
    details,
    eventSource
  }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
function removeFromQueue({ token, queueName = "" }) {
  return api.post(`/omni/queue/conference/disconnect?queueName=${queueName}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function approve({ token }) {
  return api.post("/omni/process/approve", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response && e2.response.data));
}
function addGeolocation({ token, latitude, longitude }) {
  return api.post("/omni/add/geolocation", {
    longitude,
    latitude
  }, {
    headers: {
      "X-Incode-Hardware-Id": token.token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response && e2.response.data));
}
/*!
 * Signature Pad v4.0.5 | https://github.com/szimek/signature_pad
 * (c) 2022 Szymon Nowak | Released under the MIT license
 */
class Point {
  constructor(x2, y2, pressure, time) {
    if (isNaN(x2) || isNaN(y2)) {
      throw new Error(`Point is invalid: (${x2}, ${y2})`);
    }
    this.x = +x2;
    this.y = +y2;
    this.pressure = pressure || 0;
    this.time = time || Date.now();
  }
  distanceTo(start) {
    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
  }
  equals(other) {
    return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
  }
  velocityFrom(start) {
    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
  }
}
class Bezier {
  constructor(startPoint, control2, control1, endPoint, startWidth, endWidth) {
    this.startPoint = startPoint;
    this.control2 = control2;
    this.control1 = control1;
    this.endPoint = endPoint;
    this.startWidth = startWidth;
    this.endWidth = endWidth;
  }
  static fromPoints(points, widths) {
    const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
    const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
    return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
  }
  static calculateControlPoints(s1, s2, s3) {
    const dx1 = s1.x - s2.x;
    const dy1 = s1.y - s2.y;
    const dx2 = s2.x - s3.x;
    const dy2 = s2.y - s3.y;
    const m1 = { x: (s1.x + s2.x) / 2, y: (s1.y + s2.y) / 2 };
    const m2 = { x: (s2.x + s3.x) / 2, y: (s2.y + s3.y) / 2 };
    const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    const dxm = m1.x - m2.x;
    const dym = m1.y - m2.y;
    const k3 = l2 / (l1 + l2);
    const cm = { x: m2.x + dxm * k3, y: m2.y + dym * k3 };
    const tx = s2.x - cm.x;
    const ty = s2.y - cm.y;
    return {
      c1: new Point(m1.x + tx, m1.y + ty),
      c2: new Point(m2.x + tx, m2.y + ty)
    };
  }
  length() {
    const steps2 = 10;
    let length = 0;
    let px2;
    let py;
    for (let i2 = 0; i2 <= steps2; i2 += 1) {
      const t2 = i2 / steps2;
      const cx = this.point(t2, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
      const cy = this.point(t2, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (i2 > 0) {
        const xdiff = cx - px2;
        const ydiff = cy - py;
        length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
      }
      px2 = cx;
      py = cy;
    }
    return length;
  }
  point(t2, start, c1, c2, end) {
    return start * (1 - t2) * (1 - t2) * (1 - t2) + 3 * c1 * (1 - t2) * (1 - t2) * t2 + 3 * c2 * (1 - t2) * t2 * t2 + end * t2 * t2 * t2;
  }
}
class SignatureEventTarget {
  constructor() {
    try {
      this._et = new EventTarget();
    } catch (error3) {
      this._et = document;
    }
  }
  addEventListener(type, listener, options) {
    this._et.addEventListener(type, listener, options);
  }
  dispatchEvent(event) {
    return this._et.dispatchEvent(event);
  }
  removeEventListener(type, callback, options) {
    this._et.removeEventListener(type, callback, options);
  }
}
function throttle(fn, wait = 250) {
  let previous = 0;
  let timeout = null;
  let result2;
  let storedContext;
  let storedArgs;
  const later = () => {
    previous = Date.now();
    timeout = null;
    result2 = fn.apply(storedContext, storedArgs);
    if (!timeout) {
      storedContext = null;
      storedArgs = [];
    }
  };
  return function wrapper(...args) {
    const now2 = Date.now();
    const remaining = wait - (now2 - previous);
    storedContext = this;
    storedArgs = args;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now2;
      result2 = fn.apply(storedContext, storedArgs);
      if (!timeout) {
        storedContext = null;
        storedArgs = [];
      }
    } else if (!timeout) {
      timeout = window.setTimeout(later, remaining);
    }
    return result2;
  };
}
class SignaturePad extends SignatureEventTarget {
  constructor(canvas, options = {}) {
    super();
    this.canvas = canvas;
    this._handleMouseDown = (event) => {
      if (event.buttons === 1) {
        this._drawningStroke = true;
        this._strokeBegin(event);
      }
    };
    this._handleMouseMove = (event) => {
      if (this._drawningStroke) {
        this._strokeMoveUpdate(event);
      }
    };
    this._handleMouseUp = (event) => {
      if (event.buttons === 1 && this._drawningStroke) {
        this._drawningStroke = false;
        this._strokeEnd(event);
      }
    };
    this._handleTouchStart = (event) => {
      event.preventDefault();
      if (event.targetTouches.length === 1) {
        const touch = event.changedTouches[0];
        this._strokeBegin(touch);
      }
    };
    this._handleTouchMove = (event) => {
      event.preventDefault();
      const touch = event.targetTouches[0];
      this._strokeMoveUpdate(touch);
    };
    this._handleTouchEnd = (event) => {
      const wasCanvasTouched = event.target === this.canvas;
      if (wasCanvasTouched) {
        event.preventDefault();
        const touch = event.changedTouches[0];
        this._strokeEnd(touch);
      }
    };
    this._handlePointerStart = (event) => {
      this._drawningStroke = true;
      event.preventDefault();
      this._strokeBegin(event);
    };
    this._handlePointerMove = (event) => {
      if (this._drawningStroke) {
        event.preventDefault();
        this._strokeMoveUpdate(event);
      }
    };
    this._handlePointerEnd = (event) => {
      if (this._drawningStroke) {
        event.preventDefault();
        this._drawningStroke = false;
        this._strokeEnd(event);
      }
    };
    this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
    this.minWidth = options.minWidth || 0.5;
    this.maxWidth = options.maxWidth || 2.5;
    this.throttle = "throttle" in options ? options.throttle : 16;
    this.minDistance = "minDistance" in options ? options.minDistance : 5;
    this.dotSize = options.dotSize || 0;
    this.penColor = options.penColor || "black";
    this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
    this._strokeMoveUpdate = this.throttle ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate;
    this._ctx = canvas.getContext("2d");
    this.clear();
    this.on();
  }
  clear() {
    const { _ctx: ctx, canvas } = this;
    ctx.fillStyle = this.backgroundColor;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    this._data = [];
    this._reset();
    this._isEmpty = true;
  }
  fromDataURL(dataUrl, options = {}) {
    return new Promise((resolve, reject) => {
      const image2 = new Image();
      const ratio = options.ratio || window.devicePixelRatio || 1;
      const width2 = options.width || this.canvas.width / ratio;
      const height2 = options.height || this.canvas.height / ratio;
      const xOffset = options.xOffset || 0;
      const yOffset = options.yOffset || 0;
      this._reset();
      image2.onload = () => {
        this._ctx.drawImage(image2, xOffset, yOffset, width2, height2);
        resolve();
      };
      image2.onerror = (error3) => {
        reject(error3);
      };
      image2.crossOrigin = "anonymous";
      image2.src = dataUrl;
      this._isEmpty = false;
    });
  }
  toDataURL(type = "image/png", encoderOptions) {
    switch (type) {
      case "image/svg+xml":
        return this._toSVG();
      default:
        return this.canvas.toDataURL(type, encoderOptions);
    }
  }
  on() {
    this.canvas.style.touchAction = "none";
    this.canvas.style.msTouchAction = "none";
    this.canvas.style.userSelect = "none";
    const isIOS = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
    if (window.PointerEvent && !isIOS) {
      this._handlePointerEvents();
    } else {
      this._handleMouseEvents();
      if ("ontouchstart" in window) {
        this._handleTouchEvents();
      }
    }
  }
  off() {
    this.canvas.style.touchAction = "auto";
    this.canvas.style.msTouchAction = "auto";
    this.canvas.style.userSelect = "auto";
    this.canvas.removeEventListener("pointerdown", this._handlePointerStart);
    this.canvas.removeEventListener("pointermove", this._handlePointerMove);
    document.removeEventListener("pointerup", this._handlePointerEnd);
    this.canvas.removeEventListener("mousedown", this._handleMouseDown);
    this.canvas.removeEventListener("mousemove", this._handleMouseMove);
    document.removeEventListener("mouseup", this._handleMouseUp);
    this.canvas.removeEventListener("touchstart", this._handleTouchStart);
    this.canvas.removeEventListener("touchmove", this._handleTouchMove);
    this.canvas.removeEventListener("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(pointGroups, { clear = true } = {}) {
    if (clear) {
      this.clear();
    }
    this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));
    this._data = this._data.concat(pointGroups);
  }
  toData() {
    return this._data;
  }
  _strokeBegin(event) {
    this.dispatchEvent(new CustomEvent("beginStroke", { detail: event }));
    const newPointGroup = {
      dotSize: this.dotSize,
      minWidth: this.minWidth,
      maxWidth: this.maxWidth,
      penColor: this.penColor,
      points: []
    };
    this._data.push(newPointGroup);
    this._reset();
    this._strokeUpdate(event);
  }
  _strokeUpdate(event) {
    if (this._data.length === 0) {
      this._strokeBegin(event);
      return;
    }
    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", { detail: event }));
    const x2 = event.clientX;
    const y2 = event.clientY;
    const pressure = event.pressure !== void 0 ? event.pressure : event.force !== void 0 ? event.force : 0;
    const point = this._createPoint(x2, y2, pressure);
    const lastPointGroup = this._data[this._data.length - 1];
    const lastPoints = lastPointGroup.points;
    const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
    const isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
    const { penColor, dotSize, minWidth: minWidth2, maxWidth } = lastPointGroup;
    if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
      const curve = this._addPoint(point);
      if (!lastPoint) {
        this._drawDot(point, {
          penColor,
          dotSize,
          minWidth: minWidth2,
          maxWidth
        });
      } else if (curve) {
        this._drawCurve(curve, {
          penColor,
          dotSize,
          minWidth: minWidth2,
          maxWidth
        });
      }
      lastPoints.push({
        time: point.time,
        x: point.x,
        y: point.y,
        pressure: point.pressure
      });
    }
    this.dispatchEvent(new CustomEvent("afterUpdateStroke", { detail: event }));
  }
  _strokeEnd(event) {
    this._strokeUpdate(event);
    this.dispatchEvent(new CustomEvent("endStroke", { detail: event }));
  }
  _handlePointerEvents() {
    this._drawningStroke = false;
    this.canvas.addEventListener("pointerdown", this._handlePointerStart);
    this.canvas.addEventListener("pointermove", this._handlePointerMove);
    document.addEventListener("pointerup", this._handlePointerEnd);
  }
  _handleMouseEvents() {
    this._drawningStroke = false;
    this.canvas.addEventListener("mousedown", this._handleMouseDown);
    this.canvas.addEventListener("mousemove", this._handleMouseMove);
    document.addEventListener("mouseup", this._handleMouseUp);
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart);
    this.canvas.addEventListener("touchmove", this._handleTouchMove);
    this.canvas.addEventListener("touchend", this._handleTouchEnd);
  }
  _reset() {
    this._lastPoints = [];
    this._lastVelocity = 0;
    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
    this._ctx.fillStyle = this.penColor;
  }
  _createPoint(x2, y2, pressure) {
    const rect = this.canvas.getBoundingClientRect();
    return new Point(x2 - rect.left, y2 - rect.top, pressure, new Date().getTime());
  }
  _addPoint(point) {
    const { _lastPoints } = this;
    _lastPoints.push(point);
    if (_lastPoints.length > 2) {
      if (_lastPoints.length === 3) {
        _lastPoints.unshift(_lastPoints[0]);
      }
      const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2]);
      const curve = Bezier.fromPoints(_lastPoints, widths);
      _lastPoints.shift();
      return curve;
    }
    return null;
  }
  _calculateCurveWidths(startPoint, endPoint) {
    const velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
    const newWidth = this._strokeWidth(velocity);
    const widths = {
      end: newWidth,
      start: this._lastWidth
    };
    this._lastVelocity = velocity;
    this._lastWidth = newWidth;
    return widths;
  }
  _strokeWidth(velocity) {
    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
  }
  _drawCurveSegment(x2, y2, width2) {
    const ctx = this._ctx;
    ctx.moveTo(x2, y2);
    ctx.arc(x2, y2, width2, 0, 2 * Math.PI, false);
    this._isEmpty = false;
  }
  _drawCurve(curve, options) {
    const ctx = this._ctx;
    const widthDelta = curve.endWidth - curve.startWidth;
    const drawSteps = Math.ceil(curve.length()) * 2;
    ctx.beginPath();
    ctx.fillStyle = options.penColor;
    for (let i2 = 0; i2 < drawSteps; i2 += 1) {
      const t2 = i2 / drawSteps;
      const tt = t2 * t2;
      const ttt = tt * t2;
      const u2 = 1 - t2;
      const uu = u2 * u2;
      const uuu = uu * u2;
      let x2 = uuu * curve.startPoint.x;
      x2 += 3 * uu * t2 * curve.control1.x;
      x2 += 3 * u2 * tt * curve.control2.x;
      x2 += ttt * curve.endPoint.x;
      let y2 = uuu * curve.startPoint.y;
      y2 += 3 * uu * t2 * curve.control1.y;
      y2 += 3 * u2 * tt * curve.control2.y;
      y2 += ttt * curve.endPoint.y;
      const width2 = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
      this._drawCurveSegment(x2, y2, width2);
    }
    ctx.closePath();
    ctx.fill();
  }
  _drawDot(point, options) {
    const ctx = this._ctx;
    const width2 = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
    ctx.beginPath();
    this._drawCurveSegment(point.x, point.y, width2);
    ctx.closePath();
    ctx.fillStyle = options.penColor;
    ctx.fill();
  }
  _fromData(pointGroups, drawCurve, drawDot) {
    for (const group of pointGroups) {
      const { penColor, dotSize, minWidth: minWidth2, maxWidth, points } = group;
      if (points.length > 1) {
        for (let j2 = 0; j2 < points.length; j2 += 1) {
          const basicPoint = points[j2];
          const point = new Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
          this.penColor = penColor;
          if (j2 === 0) {
            this._reset();
          }
          const curve = this._addPoint(point);
          if (curve) {
            drawCurve(curve, {
              penColor,
              dotSize,
              minWidth: minWidth2,
              maxWidth
            });
          }
        }
      } else {
        this._reset();
        drawDot(points[0], {
          penColor,
          dotSize,
          minWidth: minWidth2,
          maxWidth
        });
      }
    }
  }
  _toSVG() {
    const pointGroups = this._data;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const minX = 0;
    const minY = 0;
    const maxX = this.canvas.width / ratio;
    const maxY = this.canvas.height / ratio;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", this.canvas.width.toString());
    svg.setAttribute("height", this.canvas.height.toString());
    this._fromData(pointGroups, (curve, { penColor }) => {
      const path2 = document.createElement("path");
      if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
        const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
        path2.setAttribute("d", attr);
        path2.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
        path2.setAttribute("stroke", penColor);
        path2.setAttribute("fill", "none");
        path2.setAttribute("stroke-linecap", "round");
        svg.appendChild(path2);
      }
    }, (point, { penColor, dotSize, minWidth: minWidth2, maxWidth }) => {
      const circle = document.createElement("circle");
      const size = dotSize > 0 ? dotSize : (minWidth2 + maxWidth) / 2;
      circle.setAttribute("r", size.toString());
      circle.setAttribute("cx", point.x.toString());
      circle.setAttribute("cy", point.y.toString());
      circle.setAttribute("fill", penColor);
      svg.appendChild(circle);
    });
    const prefix2 = "data:image/svg+xml;base64,";
    const header = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="${minX} ${minY} ${this.canvas.width} ${this.canvas.height}" width="${maxX}" height="${maxY}">`;
    let body = svg.innerHTML;
    if (body === void 0) {
      const dummy = document.createElement("dummy");
      const nodes = svg.childNodes;
      dummy.innerHTML = "";
      for (let i2 = 0; i2 < nodes.length; i2 += 1) {
        dummy.appendChild(nodes[i2].cloneNode(true));
      }
      body = dummy.innerHTML;
    }
    const footer = "</svg>";
    const data2 = header + body + footer;
    return prefix2 + btoa(data2);
  }
}
function debounce(func, wait, immediate) {
  let timeout;
  return function(...params) {
    const later = () => {
      timeout = null;
      if (!immediate)
        func(...params);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow)
      func(...params);
  };
}
function useSignaturePad(getCanvas, signatureProps, ref) {
  const signaturePadRef = useRef();
  const getCanvasRef = useRef();
  const signaturePropsRef = useRef();
  useEffect(() => {
    getCanvasRef.current = getCanvas;
  }, [getCanvas]);
  useEffect(() => {
    signaturePropsRef.current = signatureProps;
  });
  const resize2 = useCallback(() => {
    var _a;
    const canvas = getCanvasRef.current();
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
    (_a = signaturePadRef.current) == null ? void 0 : _a.clear();
  }, []);
  useEventListener("resize", debounce(() => {
    console.log("resizing for event");
    resize2();
  }, 700), window);
  useEffect(() => {
    const canvas = getCanvasRef.current();
    if (!canvas)
      return;
    signaturePadRef.current = new SignaturePad(canvas, signaturePropsRef.current);
    Object.keys(signaturePropsRef.current.events).forEach((eventName) => signaturePadRef.current.addEventListener(eventName, signaturePropsRef.current.events[eventName]));
    setTimeout(() => {
      resize2();
    }, 700);
    return () => {
      Object.keys(signaturePropsRef.current.events).forEach((eventName) => signaturePadRef.current.removeEventListener(eventName, signaturePropsRef.current.events[eventName]));
    };
  }, [resize2]);
  const getBlob = () => {
    signaturePadRef.current.backgroundColor = "#ffffff";
    const base64 = getCanvas().toDataURL();
    const binary = atob(base64.split(",")[1]);
    const array = [];
    for (let i2 = 0; i2 < binary.length; i2++) {
      array.push(binary.charCodeAt(i2));
    }
    return new Blob([new Uint8Array(array)]);
  };
  useImperativeHandle(ref, () => ({
    toDataURL() {
      return getCanvas().toDataURL();
    },
    getSignaturePad: () => signaturePadRef.current,
    getCanvas,
    clear: () => signaturePadRef.current.clear(),
    isEmpty: () => signaturePadRef.current.isEmpty(),
    off: () => signaturePadRef.current.off(),
    getBlob
  }));
}
function SignatureCanvas(_H, ref) {
  var _I = _H, {
    canvasProps,
    className
  } = _I, props = __objRest(_I, [
    "canvasProps",
    "className"
  ]);
  const canvasRef = useRef();
  useSignaturePad(() => canvasRef.current, props, ref);
  return /* @__PURE__ */ jsx("canvas", __spreadProps(__spreadValues({}, canvasProps), {
    className,
    ref: canvasRef
  }));
}
var SignatureCanvas$1 = forwardRef(SignatureCanvas);
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const CanvasContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
`;
const ClearButton = styled.button`
  padding: 20px;
  background-color: transparent;
  border: none;
`;
const Canvas = styled(SignatureCanvas$1)`
  width: 100%;
  border: 1.5px solid #20263d;
  border-radius: 18px;
  height: 100%;
  background-color: rgb(255, 255, 255);
`;
const SignatureContainer = styled.div`
  height: 100%;
  padding: 6% 6% 15% 6%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-color: rgb(255, 255, 255);

  &.desktop {
    position: unset;
    padding: 175px;
  }
`;
const TextInstructionsLabel = styled.label`
  font-size: 26px;
  opacity: 0.5;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
`;
function Signature({
  onSuccess,
  onBoarding,
  token,
  type,
  title,
  subtitle,
  initials
}) {
  const {
    t: t2
  } = useTranslation();
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isTouched, setIsTouched] = useState(false);
  function handleDone() {
    if (canvasRef.current.isEmpty()) {
      return;
    }
    canvasRef.current.off();
    onBoarding.addEvent({
      token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    setLoading(true);
    const addSignature2 = initials ? onBoarding.addInitials : onBoarding.addSignature;
    addSignature2({
      token,
      image: canvasRef.current.getBlob(),
      type
    }).then(onSuccess).catch(() => setLoading(false));
  }
  function clearCanvas() {
    canvasRef.current.clear();
    setIsTouched(false);
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [onBoarding.isDesktop() && /* @__PURE__ */ jsx(DesktopHeader, {}), /* @__PURE__ */ jsxs(SignatureContainer, {
      className: classNames("IncodeSignatureContainer", {
        desktop: onBoarding.isDesktop()
      }),
      children: [title, subtitle, /* @__PURE__ */ jsxs(CanvasContainer, {
        children: [/* @__PURE__ */ jsx(Canvas, {
          ref: canvasRef,
          events: {
            beginStroke: () => setIsTouched(true)
          },
          backgroundColor: "#ffffff",
          canvasProps: {
            style: {
              backgroundColor: "#ffffff"
            }
          }
        }), !isTouched && /* @__PURE__ */ jsx(TextInstructionsLabel, {
          children: initials ? t2("signature.placeholderInitials") : t2("signature.placeholder")
        })]
      }), /* @__PURE__ */ jsxs(ButtonsContainer, {
        className: "IncodeSignatureButtonsContainer",
        children: [/* @__PURE__ */ jsx(ClearButton, {
          onClick: clearCanvas,
          disabled: !isTouched,
          children: t2("signature.clear")
        }), /* @__PURE__ */ jsx(Button$3, {
          onClick: handleDone,
          disabled: loading || !isTouched,
          theme: theme$1,
          children: t2("signature.done")
        })]
      })]
    })]
  });
}
function renderSignature(element, {
  onSuccess,
  token,
  type,
  title,
  subtitle,
  initials = false
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    token,
    type,
    title,
    subtitle,
    initials
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(Signature, __spreadValues({}, props))
  }), element);
}
function addSignature({ token, image: image2, type }) {
  return api.post("/omni/add/signature", image2, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "image/jpeg"
    },
    params: {
      type
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response && e2.response.data));
}
function addInitials({ token, image: image2, type }) {
  return api.post("/omni/add/initials", image2, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "image/jpeg"
    },
    params: {
      type
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response && e2.response.data));
}
async function attachSignatureOnAnnotation({
  contractId,
  signatureType,
  token,
  signedContractId,
  orientation = "ORIENTATION_NORMAL"
}) {
  return api.post("/omni/attach-signature-on-annotation", {
    contractId,
    signatureType,
    signedContractId,
    orientation
  }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
async function getSignedContractsLinks({ token }) {
  return api.get("/omni/get/signed-contracts-links", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
function getMedicalOcrData({ token }) {
  return api.get(`/omni/get/medical-ocr-data`, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((err) => {
    return { error: `Error: ${err}` };
  });
}
function fetchProcessingStatus({ token }) {
  return api.get("/omni/get/postprocess/isfinished", null, {
    headers: {
      "X-Incode-Hardware-Id": token.token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response && e2.response.data));
}
const TutorialContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`;
const TutorialHeader = styled.div`
  padding: 0 10px 10px 10px;
  text-align: center;
  .blue {
    color: #00b2fd;
  }

  @media only screen and (max-height: 600px) {
    padding: 0 0 10px 0;

    h1 {
      display: block;
      font-size: 1.5em;
      margin-top: 0.83em;
      margin-bottom: 0.83em;
      margin-left: 0;
      margin-right: 0;
      font-weight: bold;
    }
  }
`;
const Image$3 = styled.img`
  margin: 0 auto;
  display: block;
  flex: 1;
  max-width: 80%;

  @media only screen and (max-height: 600px) {
    flex-grow: 1;
    width: 40vw;
  }
`;
const TutorialAction = styled.div`
  margin-bottom: calc(var(--vw) * 15);
  min-height: 82px;
  min-width: 50px;
  text-align: center;
`;
const Button = styled(Button$3)`
  margin-top: 50px;
`;
function Tutorial({
  goNext
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(TutorialContainer, {
    children: [/* @__PURE__ */ jsx(TutorialHeader, {
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("h1", {
          children: t2("videoSelfie.tutorial.title")
        }), /* @__PURE__ */ jsx("span", {
          children: t2("videoSelfie.tutorial.body")
        })]
      })
    }), /* @__PURE__ */ jsxs(TutorialAction, {
      children: [/* @__PURE__ */ jsx(Image$3, {
        src: "https://sdk.incode.com/sdk/tutorials/video-selfie.gif"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: goNext,
        children: t2("common.continue")
      })]
    })]
  });
}
var dist = {};
var OTSession$1 = {};
var createSession$2 = {};
Object.defineProperty(createSession$2, "__esModule", {
  value: true
});
createSession$2.default = createSession$1;
function createSession$1() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, apiKey2 = _ref.apiKey, sessionId = _ref.sessionId, token = _ref.token, onStreamsUpdated = _ref.onStreamsUpdated, onConnect = _ref.onConnect, onError = _ref.onError, options = _ref.options;
  if (!apiKey2) {
    throw new Error("Missing apiKey");
  }
  if (!sessionId) {
    throw new Error("Missing sessionId");
  }
  if (!token) {
    throw new Error("Missing token");
  }
  var streams = [];
  var onStreamCreated = function onStreamCreated2(event) {
    var index2 = streams.findIndex(function(stream) {
      return stream.id === event.stream.id;
    });
    if (index2 < 0) {
      streams.push(event.stream);
      onStreamsUpdated(streams);
    }
  };
  var onStreamDestroyed = function onStreamDestroyed2(event) {
    var index2 = streams.findIndex(function(stream) {
      return stream.id === event.stream.id;
    });
    if (index2 >= 0) {
      streams.splice(index2, 1);
      onStreamsUpdated(streams);
    }
  };
  var eventHandlers = {
    streamCreated: onStreamCreated,
    streamDestroyed: onStreamDestroyed
  };
  var session = OT.initSession(apiKey2, sessionId, options);
  session.on(eventHandlers);
  session.connect(token, function(err) {
    if (!session) {
      return;
    }
    if (err && typeof onError === "function") {
      onError(err);
    } else if (!err && typeof onConnect === "function") {
      onConnect();
    }
  });
  return {
    session,
    streams,
    disconnect: function disconnect() {
      if (session) {
        session.off(eventHandlers);
        session.disconnect();
      }
      streams = null;
      onStreamCreated = null;
      onStreamDestroyed = null;
      eventHandlers = null;
      session = null;
      this.session = null;
      this.streams = null;
    }
  };
}
Object.defineProperty(OTSession$1, "__esModule", {
  value: true
});
var _typeof$5 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass$b = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react$8 = React__default;
var _react2$8 = _interopRequireDefault$9(_react$8);
var _propTypes$8 = propTypes$3.exports;
var _propTypes2$8 = _interopRequireDefault$9(_propTypes$8);
var _createSession2$1 = createSession$2;
var _createSession3 = _interopRequireDefault$9(_createSession2$1);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck$c(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$4(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var OTSession = function(_Component) {
  _inherits$4(OTSession2, _Component);
  function OTSession2(props) {
    _classCallCheck$c(this, OTSession2);
    var _this = _possibleConstructorReturn$4(this, (OTSession2.__proto__ || Object.getPrototypeOf(OTSession2)).call(this, props));
    _this.state = {
      streams: []
    };
    return _this;
  }
  _createClass$b(OTSession2, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        session: this.sessionHelper.session,
        streams: this.state.streams
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount2() {
      this.createSession();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.apiKey !== this.props.apiKey || prevProps.sessionId !== this.props.sessionId || prevProps.token !== this.props.token) {
        this.createSession();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroySession();
    }
  }, {
    key: "createSession",
    value: function createSession2() {
      var _this2 = this;
      this.destroySession();
      this.sessionHelper = (0, _createSession3.default)({
        apiKey: this.props.apiKey,
        sessionId: this.props.sessionId,
        token: this.props.token,
        onStreamsUpdated: function onStreamsUpdated(streams2) {
          _this2.setState({
            streams: streams2
          });
        },
        onConnect: this.props.onConnect,
        onError: this.props.onError,
        options: this.props.options
      });
      if (this.props.eventHandlers && _typeof$5(this.props.eventHandlers) === "object") {
        this.sessionHelper.session.on(this.props.eventHandlers);
      }
      var streams = this.sessionHelper.streams;
      this.setState({
        streams
      });
    }
  }, {
    key: "destroySession",
    value: function destroySession() {
      if (this.sessionHelper) {
        if (this.props.eventHandlers && _typeof$5(this.props.eventHandlers) === "object") {
          this.sessionHelper.session.off(this.props.eventHandlers);
        }
        this.sessionHelper.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var childrenIsFunc = typeof children === "function";
      return _react2$8.default.createElement(React.Fragment, null, childrenIsFunc ? children(this.sessionHelper) : this.props.children);
    }
  }]);
  return OTSession2;
}(_react$8.Component);
OTSession$1.default = OTSession;
OTSession.propTypes = {
  children: _propTypes2$8.default.oneOfType([_propTypes2$8.default.element, _propTypes2$8.default.arrayOf(_propTypes2$8.default.element), _propTypes2$8.default.func]).isRequired,
  apiKey: _propTypes2$8.default.string.isRequired,
  sessionId: _propTypes2$8.default.string.isRequired,
  token: _propTypes2$8.default.string.isRequired,
  eventHandlers: _propTypes2$8.default.objectOf(_propTypes2$8.default.func),
  onConnect: _propTypes2$8.default.func,
  onError: _propTypes2$8.default.func,
  options: _propTypes2$8.default.object
};
OTSession.defaultProps = {
  eventHandlers: null,
  onConnect: null,
  onError: null,
  options: {}
};
OTSession.childContextTypes = {
  streams: _propTypes2$8.default.arrayOf(_propTypes2$8.default.object),
  session: _propTypes2$8.default.shape({
    subscribe: _propTypes2$8.default.func,
    unsubscribe: _propTypes2$8.default.func
  })
};
var OTPublisher$1 = {};
Object.defineProperty(OTPublisher$1, "__esModule", {
  value: true
});
var _typeof$4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass$a = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react$7 = React__default;
var _react2$7 = _interopRequireDefault$8(_react$7);
var _propTypes$7 = propTypes$3.exports;
var _propTypes2$7 = _interopRequireDefault$8(_propTypes$7);
var _once = once_1;
var _once2 = _interopRequireDefault$8(_once);
var _fp = fp;
var _uuid$1 = uuid_1;
var _uuid2$1 = _interopRequireDefault$8(_uuid$1);
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck$b(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$3(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var OTPublisher = function(_Component) {
  _inherits$3(OTPublisher2, _Component);
  function OTPublisher2(props, context2) {
    _classCallCheck$b(this, OTPublisher2);
    var _this = _possibleConstructorReturn$3(this, (OTPublisher2.__proto__ || Object.getPrototypeOf(OTPublisher2)).call(this, props));
    _this.sessionConnectedHandler = function() {
      _this.publishToSession(_this.state.publisher);
    };
    _this.streamCreatedHandler = function(event) {
      _this.setState({ lastStreamId: event.stream.id });
    };
    _this.state = {
      publisher: null,
      lastStreamId: "",
      session: props.session || context2.session || null
    };
    return _this;
  }
  _createClass$a(OTPublisher2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPublisher();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      var useDefault = function useDefault2(value, defaultValue) {
        return value === void 0 ? defaultValue : value;
      };
      var shouldUpdate = function shouldUpdate2(key, defaultValue) {
        var previous = useDefault(prevProps.properties[key], defaultValue);
        var current = useDefault(_this2.props.properties[key], defaultValue);
        return previous !== current;
      };
      var updatePublisherProperty = function updatePublisherProperty2(key, defaultValue) {
        if (shouldUpdate(key, defaultValue)) {
          var value = useDefault(_this2.props.properties[key], defaultValue);
          _this2.state.publisher[key](value);
        }
      };
      if (shouldUpdate("videoSource", void 0)) {
        this.destroyPublisher();
        this.createPublisher();
        return;
      }
      updatePublisherProperty("publishAudio", true);
      updatePublisherProperty("publishVideo", true);
      if (this.state.session !== prevState.session) {
        this.destroyPublisher(prevState.session);
        this.createPublisher();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.session) {
        this.state.session.off("sessionConnected", this.sessionConnectedHandler);
      }
      this.destroyPublisher();
    }
  }, {
    key: "getPublisher",
    value: function getPublisher() {
      return this.state.publisher;
    }
  }, {
    key: "destroyPublisher",
    value: function destroyPublisher() {
      var _this3 = this;
      var session = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.state.session;
      delete this.publisherId;
      if (this.state.publisher) {
        this.state.publisher.off("streamCreated", this.streamCreatedHandler);
        if (this.props.eventHandlers && _typeof$4(this.props.eventHandlers) === "object") {
          this.state.publisher.once("destroyed", function() {
            _this3.state.publisher.off(_this3.props.eventHandlers);
          });
        }
        if (session) {
          session.unpublish(this.state.publisher);
        }
        this.state.publisher.destroy();
      }
    }
  }, {
    key: "publishToSession",
    value: function publishToSession(publisher) {
      var _this4 = this;
      var publisherId = this.publisherId;
      this.state.session.publish(publisher, function(err) {
        if (publisherId !== _this4.publisherId) {
          return;
        }
        if (err) {
          _this4.errorHandler(err);
        } else if (typeof _this4.props.onPublish === "function") {
          _this4.props.onPublish();
        }
      });
    }
  }, {
    key: "createPublisher",
    value: function createPublisher() {
      var _this5 = this;
      if (!this.state.session) {
        this.setState({ publisher: null, lastStreamId: "" });
        return;
      }
      var properties = this.props.properties || {};
      var container = void 0;
      if (properties.insertDefaultUI !== false) {
        container = document.createElement("div");
        container.setAttribute("class", "OTPublisherContainer");
        this.node.appendChild(container);
      }
      this.publisherId = (0, _uuid2$1.default)();
      var publisherId = this.publisherId;
      this.errorHandler = (0, _once2.default)(function(err) {
        if (publisherId !== _this5.publisherId) {
          return;
        }
        if (typeof _this5.props.onError === "function") {
          _this5.props.onError(err);
        }
      });
      var publisher = OT.initPublisher(container, properties, function(err) {
        if (publisherId !== _this5.publisherId) {
          return;
        }
        if (err) {
          _this5.errorHandler(err);
        } else if (typeof _this5.props.onInit === "function") {
          _this5.props.onInit();
        }
      });
      publisher.on("streamCreated", this.streamCreatedHandler);
      if (this.props.eventHandlers && _typeof$4(this.props.eventHandlers) === "object") {
        var handles = (0, _fp.omitBy)(_fp.isNil)(this.props.eventHandlers);
        publisher.on(handles);
      }
      if (this.state.session.connection) {
        this.publishToSession(publisher);
      } else {
        this.state.session.once("sessionConnected", this.sessionConnectedHandler);
      }
      this.setState({ publisher, lastStreamId: "" });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _props = this.props, className = _props.className, style = _props.style;
      return _react2$7.default.createElement("div", { className, style, ref: function ref(node) {
        _this6.node = node;
      } });
    }
  }]);
  return OTPublisher2;
}(_react$7.Component);
OTPublisher$1.default = OTPublisher;
OTPublisher.propTypes = {
  session: _propTypes2$7.default.shape({
    connection: _propTypes2$7.default.shape({
      connectionId: _propTypes2$7.default.string
    }),
    once: _propTypes2$7.default.func,
    off: _propTypes2$7.default.func,
    publish: _propTypes2$7.default.func,
    unpublish: _propTypes2$7.default.func
  }),
  className: _propTypes2$7.default.string,
  style: _propTypes2$7.default.object,
  properties: _propTypes2$7.default.object,
  eventHandlers: _propTypes2$7.default.objectOf(_propTypes2$7.default.func),
  onInit: _propTypes2$7.default.func,
  onPublish: _propTypes2$7.default.func,
  onError: _propTypes2$7.default.func
};
OTPublisher.defaultProps = {
  session: null,
  className: "",
  style: {},
  properties: {},
  eventHandlers: null,
  onInit: null,
  onPublish: null,
  onError: null
};
OTPublisher.contextTypes = {
  session: _propTypes2$7.default.shape({
    connection: _propTypes2$7.default.shape({
      connectionId: _propTypes2$7.default.string
    }),
    once: _propTypes2$7.default.func,
    off: _propTypes2$7.default.func,
    publish: _propTypes2$7.default.func,
    unpublish: _propTypes2$7.default.func
  })
};
var OTStreams$1 = {};
var OTSubscriberContext$1 = {};
Object.defineProperty(OTSubscriberContext$1, "__esModule", {
  value: true
});
var _createClass$9 = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react$6 = React__default;
var _react2$6 = _interopRequireDefault$7(_react$6);
var _propTypes$6 = propTypes$3.exports;
var _propTypes2$6 = _interopRequireDefault$7(_propTypes$6);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck$a(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$2(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var OTSubscriberContext = function(_Component) {
  _inherits$2(OTSubscriberContext2, _Component);
  function OTSubscriberContext2() {
    _classCallCheck$a(this, OTSubscriberContext2);
    return _possibleConstructorReturn$2(this, (OTSubscriberContext2.__proto__ || Object.getPrototypeOf(OTSubscriberContext2)).apply(this, arguments));
  }
  _createClass$9(OTSubscriberContext2, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        stream: this.props.stream
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react2$6.default.createElement(React.Fragment, null, this.props.children);
    }
  }]);
  return OTSubscriberContext2;
}(_react$6.Component);
OTSubscriberContext$1.default = OTSubscriberContext;
OTSubscriberContext.propTypes = {
  children: _propTypes2$6.default.element.isRequired,
  stream: _propTypes2$6.default.shape({
    streamId: _propTypes2$6.default.string
  }).isRequired
};
OTSubscriberContext.childContextTypes = {
  stream: _propTypes2$6.default.shape({
    streamId: _propTypes2$6.default.string
  })
};
Object.defineProperty(OTStreams$1, "__esModule", {
  value: true
});
OTStreams$1.default = OTStreams;
var _react$5 = React__default;
var _react2$5 = _interopRequireDefault$6(_react$5);
var _propTypes$5 = propTypes$3.exports;
var _propTypes2$5 = _interopRequireDefault$6(_propTypes$5);
var _OTSubscriberContext = OTSubscriberContext$1;
var _OTSubscriberContext2 = _interopRequireDefault$6(_OTSubscriberContext);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function OTStreams(props, context2) {
  var session = props.session || context2.session || null;
  var streams = props.streams || context2.streams || null;
  if (!session) {
    return null;
  }
  var child = _react$5.Children.only(props.children);
  console.log(props.loading, "uwu");
  var childrenWithContextWrapper = Array.isArray(streams) && streams.length > 0 ? streams.map(function(stream) {
    return _react2$5.default.createElement(_OTSubscriberContext2.default, {
      stream,
      key: stream.id
    }, (0, _react$5.cloneElement)(child));
  }) : props.loading;
  return _react2$5.default.createElement(React.Fragment, null, childrenWithContextWrapper);
}
OTStreams.propTypes = {
  children: _propTypes2$5.default.element.isRequired,
  session: _propTypes2$5.default.shape({
    publish: _propTypes2$5.default.func,
    subscribe: _propTypes2$5.default.func
  }),
  streams: _propTypes2$5.default.arrayOf(_propTypes2$5.default.object)
};
OTStreams.defaultProps = {
  session: null,
  streams: null,
  loading: null
};
OTStreams.contextTypes = {
  session: _propTypes2$5.default.shape({
    publish: _propTypes2$5.default.func,
    subscribe: _propTypes2$5.default.func
  }),
  streams: _propTypes2$5.default.arrayOf(_propTypes2$5.default.object),
  loading: _propTypes2$5.default.element
};
var OTSubscriber$1 = {};
Object.defineProperty(OTSubscriber$1, "__esModule", {
  value: true
});
var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass$8 = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react$4 = React__default;
var _react2$4 = _interopRequireDefault$5(_react$4);
var _propTypes$4 = propTypes$3.exports;
var _propTypes2$4 = _interopRequireDefault$5(_propTypes$4);
var _uuid = uuid_1;
var _uuid2 = _interopRequireDefault$5(_uuid);
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck$9(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var OTSubscriber = function(_Component) {
  _inherits$1(OTSubscriber2, _Component);
  function OTSubscriber2(props, context2) {
    _classCallCheck$9(this, OTSubscriber2);
    var _this = _possibleConstructorReturn$1(this, (OTSubscriber2.__proto__ || Object.getPrototypeOf(OTSubscriber2)).call(this, props));
    _this.state = {
      subscriber: null,
      stream: props.stream || context2.stream || null,
      session: props.session || context2.session || null,
      currentRetryAttempt: 0
    };
    _this.maxRetryAttempts = props.maxRetryAttempts || 5;
    _this.retryAttemptTimeout = props.retryAttemptTimeout || 1e3;
    return _this;
  }
  _createClass$8(OTSubscriber2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createSubscriber();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      var cast2 = function cast3(value, Type2, defaultValue) {
        return value === void 0 ? defaultValue : Type2(value);
      };
      var updateSubscriberProperty = function updateSubscriberProperty2(key) {
        var previous = cast2(prevProps.properties[key], Boolean, true);
        var current = cast2(_this2.props.properties[key], Boolean, true);
        if (previous !== current) {
          _this2.state.subscriber[key](current);
        }
      };
      updateSubscriberProperty("subscribeToAudio");
      updateSubscriberProperty("subscribeToVideo");
      if (prevState.session !== this.state.session || prevState.stream !== this.state.stream) {
        this.destroySubscriber(prevState.session);
        this.createSubscriber();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroySubscriber();
    }
  }, {
    key: "getSubscriber",
    value: function getSubscriber() {
      return this.state.subscriber;
    }
  }, {
    key: "createSubscriber",
    value: function createSubscriber() {
      var _this3 = this;
      if (!this.state.session || !this.state.stream) {
        this.setState({ subscriber: null });
        return;
      }
      var properties = this.props.properties || {};
      var container = void 0;
      if (properties.insertDefaultUI !== false) {
        container = document.createElement("div");
        container.setAttribute("class", "OTSubscriberContainer");
        this.node.appendChild(container);
      }
      this.subscriberId = (0, _uuid2.default)();
      var subscriberId = this.subscriberId;
      var subscriber = this.state.session.subscribe(this.state.stream, container, this.props.properties, function(err) {
        if (subscriberId !== _this3.subscriberId) {
          return;
        }
        if (err && _this3.props.retry && _this3.state.currentRetryAttempt < _this3.maxRetryAttempts - 1) {
          _this3.handleRetrySubscriber();
        }
        if (err && typeof _this3.props.onError === "function") {
          _this3.props.onError(err);
        } else if (!err && typeof _this3.props.onSubscribe === "function") {
          _this3.props.onSubscribe();
        }
      });
      if (this.props.eventHandlers && _typeof$3(this.props.eventHandlers) === "object") {
        subscriber.on(this.props.eventHandlers);
      }
      this.setState({ subscriber });
    }
  }, {
    key: "handleRetrySubscriber",
    value: function handleRetrySubscriber() {
      var _this4 = this;
      setTimeout(function() {
        _this4.setState(function(state2) {
          return {
            currentRetryAttempt: state2.currentRetryAttempt + 1,
            subscriber: null
          };
        });
        _this4.createSubscriber();
      }, this.retryAttemptTimeout);
    }
  }, {
    key: "destroySubscriber",
    value: function destroySubscriber() {
      var _this5 = this;
      var session = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.session;
      delete this.subscriberId;
      if (this.state.subscriber) {
        if (this.props.eventHandlers && _typeof$3(this.props.eventHandlers) === "object") {
          this.state.subscriber.once("destroyed", function() {
            _this5.state.subscriber.off(_this5.props.eventHandlers);
          });
        }
        if (session) {
          session.unsubscribe(this.state.subscriber);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _props = this.props, className = _props.className, style = _props.style;
      return _react2$4.default.createElement("div", { className, style, ref: function ref(node) {
        _this6.node = node;
      } });
    }
  }]);
  return OTSubscriber2;
}(_react$4.Component);
OTSubscriber$1.default = OTSubscriber;
OTSubscriber.propTypes = {
  stream: _propTypes2$4.default.shape({
    streamId: _propTypes2$4.default.string
  }),
  session: _propTypes2$4.default.shape({
    subscribe: _propTypes2$4.default.func,
    unsubscribe: _propTypes2$4.default.func
  }),
  className: _propTypes2$4.default.string,
  style: _propTypes2$4.default.object,
  properties: _propTypes2$4.default.object,
  retry: _propTypes2$4.default.bool,
  maxRetryAttempts: _propTypes2$4.default.number,
  retryAttemptTimeout: _propTypes2$4.default.number,
  eventHandlers: _propTypes2$4.default.objectOf(_propTypes2$4.default.func),
  onSubscribe: _propTypes2$4.default.func,
  onError: _propTypes2$4.default.func
};
OTSubscriber.defaultProps = {
  stream: null,
  session: null,
  className: "",
  style: {},
  properties: {},
  retry: false,
  maxRetryAttempts: 5,
  retryAttemptTimeout: 1e3,
  eventHandlers: null,
  onSubscribe: null,
  onError: null
};
OTSubscriber.contextTypes = {
  stream: _propTypes2$4.default.shape({
    streamId: _propTypes2$4.default.string
  }),
  session: _propTypes2$4.default.shape({
    subscribe: _propTypes2$4.default.func,
    unsubscribe: _propTypes2$4.default.func
  })
};
var preloadScript$2 = {};
Object.defineProperty(preloadScript$2, "__esModule", {
  value: true
});
var _createClass$7 = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
preloadScript$2.default = preloadScript$1;
var _react$3 = React__default;
var _react2$3 = _interopRequireDefault$4(_react$3);
var _propTypes$3 = propTypes$3.exports;
var _propTypes2$3 = _interopRequireDefault$4(_propTypes$3);
var _reactDisplayName = getDisplayName$1;
var _reactDisplayName2 = _interopRequireDefault$4(_reactDisplayName);
var _scriptjs = script.exports;
var _scriptjs2 = _interopRequireDefault$4(_scriptjs);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties$2(obj, keys) {
  var target = {};
  for (var i2 in obj) {
    if (keys.indexOf(i2) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i2))
      continue;
    target[i2] = obj[i2];
  }
  return target;
}
function _classCallCheck$8(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_SCRIPT_URL = "https://static.opentok.com/v2/js/opentok.min.js";
function preloadScript$1(InnerComponent) {
  var PreloadScript = function(_Component) {
    _inherits(PreloadScript2, _Component);
    function PreloadScript2(props) {
      _classCallCheck$8(this, PreloadScript2);
      var _this = _possibleConstructorReturn(this, (PreloadScript2.__proto__ || Object.getPrototypeOf(PreloadScript2)).call(this, props));
      _this.onScriptLoad = function() {
        if (_this.isPresent) {
          _this.setState({ scriptLoaded: true });
        }
      };
      _this.state = {
        scriptLoaded: typeof OT !== "undefined"
      };
      _this.isPresent = false;
      return _this;
    }
    _createClass$7(PreloadScript2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.isPresent = true;
        if (this.scriptLoading || this.state.scriptLoaded) {
          return;
        }
        this.scriptLoading = true;
        var scriptUrl = this.props.opentokClientUrl;
        (0, _scriptjs2.default)(scriptUrl, this.onScriptLoad);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.isPresent = false;
      }
    }, {
      key: "render",
      value: function render() {
        var _props = this.props;
        _props.opentokClientUrl;
        var loadingDelegate = _props.loadingDelegate, restProps = _objectWithoutProperties$2(_props, ["opentokClientUrl", "loadingDelegate"]);
        if (this.state.scriptLoaded) {
          return _react2$3.default.createElement(InnerComponent, restProps);
        }
        return loadingDelegate;
      }
    }]);
    return PreloadScript2;
  }(_react$3.Component);
  PreloadScript.displayName = "preloadScript(" + (0, _reactDisplayName2.default)(InnerComponent) + ")";
  PreloadScript.propTypes = {
    opentokClientUrl: _propTypes2$3.default.string,
    loadingDelegate: _propTypes2$3.default.node
  };
  PreloadScript.defaultProps = {
    opentokClientUrl: DEFAULT_SCRIPT_URL,
    loadingDelegate: _react2$3.default.createElement("div", null)
  };
  return PreloadScript;
}
Object.defineProperty(dist, "__esModule", {
  value: true
});
var preloadScript = dist.preloadScript = createSession = dist.createSession = dist.OTSubscriber = dist.OTStreams = dist.OTPublisher = dist.OTSession = void 0;
var _OTSession = OTSession$1;
var _OTSession2 = _interopRequireDefault$3(_OTSession);
var _OTPublisher = OTPublisher$1;
var _OTPublisher2 = _interopRequireDefault$3(_OTPublisher);
var _OTStreams = OTStreams$1;
var _OTStreams2 = _interopRequireDefault$3(_OTStreams);
var _OTSubscriber = OTSubscriber$1;
var _OTSubscriber2 = _interopRequireDefault$3(_OTSubscriber);
var _createSession = createSession$2;
var _createSession2 = _interopRequireDefault$3(_createSession);
var _preloadScript = preloadScript$2;
var _preloadScript2 = _interopRequireDefault$3(_preloadScript);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
dist.default = {
  OTSession: _OTSession2.default,
  OTPublisher: _OTPublisher2.default,
  OTStreams: _OTStreams2.default,
  OTSubscriber: _OTSubscriber2.default,
  createSession: _createSession2.default,
  preloadScript: _preloadScript2.default
};
dist.OTSession = _OTSession2.default;
dist.OTPublisher = _OTPublisher2.default;
dist.OTStreams = _OTStreams2.default;
dist.OTSubscriber = _OTSubscriber2.default;
var createSession = dist.createSession = _createSession2.default;
preloadScript = dist.preloadScript = _preloadScript2.default;
async function getOpentokSession(token) {
  const res = await api.post("/omni/speech/create-session", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  });
  return res.data;
}
async function startRecorder(token) {
  const res = await api.post("/omni/speech/record-start", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  });
  return res.data;
}
async function stopRecorder(token) {
  const res = await api.post("/omni/speech/record-stop", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  });
  return res.data;
}
var faceFrame = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMzYiIGhlaWdodD0iNTE4IiB2aWV3Qm94PSIwIDAgMzM2IDUxOCI+CiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWRhc2hhcnJheT0iNy4xMzk5OTk2NzU3NTA3MzIsMTkuMDM5OTk5Njc1NzUwNzMiIHN0cm9rZS13aWR0aD0iOS4wNDQiIGQ9Ik0xNjggNTEzLjM5MmM3Ni44MyAwIDE2Mi44OTMtMTEzLjkyIDE2Mi44OTMtMjU0LjQ0N1MyODAuMjM2IDQuNDk4IDE2OCA0LjQ5OCA1LjEwNyAxMTguNDE4IDUuMTA3IDI1OC45NDUgOTEuMTcgNTEzLjM5MiAxNjggNTEzLjM5MnoiLz4KPC9zdmc+Cg==";
var recordingIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIGZpbGw9IiNGRkYiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI3LjUiIHI9IjQuNSIgZmlsbD0iI0VDMDEwMCIvPgogICAgPC9nPgo8L3N2Zz4K";
const ProofOfAddressMaskContainer = styled.div``;
const ProofOfAddressTopMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5;
  min-height: 115px;
  padding-top: 30px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 21px;
    font-weight: bold;
    color: #fff;
    margin: 0;
    text-align: center;
  }
`;
const Blue = styled.span`
  color: #00b2fd;
`;
const ProofOfAddressBottomMask = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    background: transparent;
    color: white;
    box-shadow: none;
    border: none;
    border-bottom: 2px solid #fff;
    font-size: 18px;
    font-weight: bold;
    padding: 10px;
    text-transform: capitalize;
  }
`;
function ProofOfAddress({
  onNext
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(ProofOfAddressMaskContainer, {
    children: [/* @__PURE__ */ jsx(ProofOfAddressTopMask, {
      children: /* @__PURE__ */ jsx("p", {
        children: /* @__PURE__ */ jsxs(Trans, {
          i18nKey: "videoSelfie.showPoa",
          children: ["Show your ", /* @__PURE__ */ jsx(Blue, {
            children: "Proof of Address"
          }), " ", /* @__PURE__ */ jsx("br", {}), "and then press Continue"]
        })
      })
    }), /* @__PURE__ */ jsx(ProofOfAddressBottomMask, {
      children: /* @__PURE__ */ jsx("button", {
        onClick: onNext,
        children: t2("common.continue").toLowerCase()
      })
    })]
  });
}
var microphone = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMSIgaGVpZ2h0PSI1MSIgdmlld0JveD0iMCAwIDMxIDUxIj4KICAgIDxnIGZpbGw9IiNGRkYiPgogICAgICAgIDxwYXRoIGQ9Ik0zMC42NCAyNC40MDh2LTcuMjI0YzAtLjc3Mi0uNjMyLTEuNDAzLTEuNDA0LTEuNDAzLS43NzEgMC0xLjQwMi42MzEtMS40MDIgMS40MDN2Ny4yMjRjMCA2Ljg3My01LjYxMSAxMi40ODQtMTIuNDg1IDEyLjQ4NC02Ljg3MyAwLTEyLjQ4NC01LjYxLTEyLjQ4NC0xMi40ODR2LTcuMjI0YzAtLjc3Mi0uNjMxLTEuNDAzLTEuNDAzLTEuNDAzLS43NzEgMC0xLjQwMi42MzEtMS40MDIgMS40MDN2Ny4yMjRjMCA3LjkyNSA2LjEwMiAxNC41MTggMTMuODg3IDE1LjIydjIuNDU0Yy00LjQ5LjM1LTguNjI3IDIuNTk1LTExLjQzMyA2LjE3Mi0uMzUuNDIxLS40Mi45ODItLjE0IDEuNDczLjIxLjQ5MS43MDEuNzcyIDEuMjYzLjc3MmgyMy40OTVjLjU2MiAwIDEuMDUzLS4yOCAxLjI2My0uNzcyLjIxLS40OS4xNC0xLjA1Mi0uMTQtMS40NzMtMi44MDYtMy41NzctNi45NDQtNS43NS0xMS40MzMtNi4xNzJ2LTIuNDU1YzcuNzE1LS43MDEgMTMuODE3LTcuMjk0IDEzLjgxNy0xNS4yMnptLTYuOTQ0IDIzLjI4NUg3LjAwM2MyLjM4NS0xLjg5MyA1LjI2LTIuODc1IDguMzQ2LTIuODc1IDMuMDg2IDAgNi4wMzIgMS4wNTIgOC4zNDcgMi44NzV6Ii8+CiAgICAgICAgPHBhdGggZD0iTTE1LjM1IDBDOS44NzggMCA1LjM5IDQuNDg5IDUuMzkgOS45NnYxNC40NDhjMCA1LjU0IDQuNDg5IDkuOTYgOS45NiA5Ljk2IDUuNDcgMCA5Ljk1OS00LjQ5IDkuOTU5LTkuOTZWOS45NTlDMjUuMzA5IDQuNDkgMjAuODIgMCAxNS4zNDkgMHptNy4xNTMgMjQuNDA4YzAgMy45MjctMy4yMjYgNy4xNTQtNy4xNTQgNy4xNTQtMy45MjcgMC03LjE1NC0zLjIyNy03LjE1NC03LjE1NHYtMy4wMTZoMi44MDZjLjc3MSAwIDEuNDAyLS42MzEgMS40MDItMS40MDMgMC0uNzcxLS42My0xLjQwMy0xLjQwMi0xLjQwM0g4LjE5NXYtMi44MDVoNS42MTFjLjc3MiAwIDEuNDAzLS42MzEgMS40MDMtMS40MDMgMC0uNzcxLS42MzEtMS40MDItMS40MDMtMS40MDJoLTUuNjFWOS45NTljMC0zLjkyNyAzLjIyNi03LjE1MyA3LjE1My03LjE1MyAzLjkyOCAwIDcuMTU0IDMuMjI2IDcuMTU0IDcuMTU0djE0LjQ0OHoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
const sizes = {
  small: {
    width: 16,
    height: 6
  },
  medium: {
    width: 22,
    height: 7
  },
  big: {
    width: 28,
    height: 8
  }
};
function SoundWave({
  size,
  active
}) {
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 7"
  }, sizes[size]), {
    children: /* @__PURE__ */ jsx("path", {
      fill: active ? "#FF5C6F" : "#FFF",
      d: "M.8 5.011C.396 5.418.4 6.07.805 6.471c.404.4 1.058.396 1.458-.006C4.59 4.12 7.692 2.83 11.001 2.83c3.31 0 6.41 1.29 8.735 3.635.402.402 1.056.406 1.46.006.203-.204.304-.468.304-.732 0-.262-.099-.525-.3-.728C18.489 2.274 14.866.77 11.002.77S3.514 2.274.8 5.01z"
    })
  }));
}
const MicrophoneImage = styled.img`
  margin-top: 3px;
`;
const MicrophoneContainer = styled.div`
  z-index: 5;
  position: ${(props) => props.isQuestions ? "relative" : "absolute"};
  bottom: ${(props) => props.isQuestions ? "0" : "-100px"};
  transform: translate(-50%, 0%);
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    transition: all 0.5s ease-out;
  }
`;
function Microphone({
  sound,
  isQuestions
}) {
  const [snd, setSnd] = useState(sound);
  useEffect(() => {
    setSnd(sound);
  }, [sound]);
  const lowIsActive = snd > 0.2;
  const mediumIsActive = snd > 0.4;
  const bigIsActive = snd > 0.6;
  return /* @__PURE__ */ jsxs(MicrophoneContainer, {
    isQuestions,
    children: [/* @__PURE__ */ jsx(SoundWave, {
      size: "big",
      active: bigIsActive
    }), /* @__PURE__ */ jsx(SoundWave, {
      size: "medium",
      active: mediumIsActive
    }), /* @__PURE__ */ jsx(SoundWave, {
      size: "small",
      active: lowIsActive
    }), /* @__PURE__ */ jsx(MicrophoneImage, {
      src: microphone,
      alt: "",
      className: "src"
    })]
  });
}
const QuestionMaskContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5;
  display: flex;
  justify-content: space-around;
  gap: 10px;
  padding: 50px 15px;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  h1 {
    font-size: 38px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    max-width: 363px;
  }

  button {
    max-width: 290px;
    padding: 20px;
    white-space: nowrap;
  }
`;
function QuestionsContainer({
  onBoarding,
  token,
  onNext,
  sound
}) {
  const [questions, setQuestions] = useState([]);
  const [mode2, setMode] = useState("home");
  useEffect(() => {
    if (!onBoarding)
      return;
    async function getRandomQuestions2() {
      const {
        questionAndAnswers
      } = await onBoarding.getRandomQuestions({
        token: token.token
      });
      setQuestions(questionAndAnswers);
    }
    getRandomQuestions2();
  }, [onBoarding, token]);
  if (mode2 === "home") {
    return /* @__PURE__ */ jsx(QuestionsMask, {
      onNext: () => setMode("questions")
    });
  }
  return /* @__PURE__ */ jsx(Questions, {
    questions,
    onNext,
    sound,
    addEvent: (params) => onBoarding.addEvent(__spreadValues({
      token: token.token
    }, params))
  });
}
function QuestionsMask({
  onNext
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(QuestionMaskContainer, {
    children: [/* @__PURE__ */ jsx("div", {}), /* @__PURE__ */ jsx("h1", {
      children: t2("videoSelfie.weNeedVerbalAnswer")
    }), /* @__PURE__ */ jsx(Button$3, {
      onClick: onNext,
      children: t2("videoSelfie.readyAnswer")
    })]
  });
}
const Question$1 = styled.p`
  color: #fff;
  font-size: 39px;
  font-weight: bold;
  text-align: center;
  line-height: normal;

  @media only screen and (max-height: 500px) {
    font-size: 25px;
  }
`;
const QuestionText = styled.p`
  font-size: 17px;
  font-weight: bold;
  color: #fff;
  text-align: center;

  @media only screen and (max-height: 550px) {
    font-size: 12px;
  }
`;
const QuestionButton = styled.button`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  border: none;
  background-color: transparent;
  border-bottom: solid 2px #ffffff;
  max-width: 375px;
  text-transform: capitalize;
`;
const BottomContainer = styled.div`
  text-align: center;
  margin-bottom: 15px;
`;
const QuestionStepper = styled.div`
  display: flex;
  position: fixed;
  top: 50px;
  z-index: 10;
  width: 100%;
  padding: 0 20px;
`;
const QuestionStep = styled.div`
  height: 4px;
  border-radius: 2px;
  background-color: #fff;
  flex: 1;
  margin-right: 10px;

  &::last-child {
    margin-right: 0px;
  }

  &.active {
    background-color: #00b2fd;
  }
`;
function Questions({
  questions,
  onNext,
  sound,
  addEvent: addEvent2
}) {
  const {
    t: t2
  } = useTranslation();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  function handleContinue() {
    const nextQuestion = currentQuestion + 1;
    addEvent2({
      eventName: `videoSelfieQuestion${currentQuestion + 1}Answered`,
      eventType: "text",
      eventData: {
        question: questions[currentQuestion]
      }
    });
    if (nextQuestion >= questions.length) {
      onNext();
      return;
    }
    setCurrentQuestion(nextQuestion);
  }
  return /* @__PURE__ */ jsxs(QuestionMaskContainer, {
    children: [/* @__PURE__ */ jsx(QuestionStepper, {
      children: questions.map(({
        id: id2
      }, index2) => /* @__PURE__ */ jsx(QuestionStep, {
        className: classNames({
          active: currentQuestion >= index2
        })
      }, id2))
    }), /* @__PURE__ */ jsx(Steps, {
      currentStep: currentQuestion,
      children: questions.map(({
        id: id2,
        question
      }) => {
        return /* @__PURE__ */ jsx(Question$1, {
          children: question
        }, id2);
      })
    }), /* @__PURE__ */ jsxs(BottomContainer, {
      children: [/* @__PURE__ */ jsx(Microphone, {
        sound,
        isQuestions: true
      }), /* @__PURE__ */ jsx(QuestionText, {
        children: t2("videoSelfie.tapContinue")
      }), /* @__PURE__ */ jsx(QuestionButton, {
        onClick: handleContinue,
        children: t2("common.continue").toLowerCase()
      })]
    })]
  });
}
const IdMaskContainer = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  align-items: center;
`;
const CaptureIdMask = styled.div`
  z-index: 5;
  width: calc(100% - 80px);
  height: 70vh;
  border-radius: 9px;
  border: solid 6.9px;

  border-color: ${(props) => props.isCapturing ? "#ffffff" : props.isSuccess ? "#0cd5a2" : props.isError ? "#ff5c6f" : "#fff"};
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.8);
`;
const Text$2 = styled.p`
  z-index: 5;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  color: ${(props) => props.isCapturing ? "#ffffff" : props.isSuccess ? "#0cd5a2" : props.isError ? "#ff5c6f" : "#ffffff"};

  max-width: 80%;
  z-index: 6;
  margin-bottom: 20px;
`;
function IdMask({
  mode: mode2,
  isCapturing,
  isError,
  message: message2,
  isSuccess
}) {
  const {
    t: t2
  } = useTranslation();
  const processingText = t2("videoSelfie.processingSelfie");
  const showText = mode2 === "front" ? t2("videoSelfie.showFront") : t2("videoSelfie.showBack");
  return /* @__PURE__ */ jsxs(IdMaskContainer, {
    children: [/* @__PURE__ */ jsx(Text$2, {
      isCapturing,
      isError,
      isSuccess,
      className: "id",
      children: isError || isSuccess ? message2 : isCapturing ? processingText : showText
    }), /* @__PURE__ */ jsx(CaptureIdMask, {
      isError,
      isSuccess,
      isCapturing
    })]
  });
}
const Container$2 = styled.div`
  display: grid;
  grid-template-rows: repeat(2, auto);
  align-items: center;
  grid-gap: 33px;
`;
const Title$5 = styled.h2`
  font-size: 25px;
  color: #fff;
  text-align: center;
`;
const Content = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-gap: 33px;
  color: #fff;
`;
const List$1 = styled.div`
  counter-reset: countLi;
  display: grid;
  grid-template-rows: auto;
  grid-gap: 33px;

  span {
    counter-increment: countLi;
    position: relative;
    max-width: 300px;
    padding-left: 70px;
    line-height: 1.42;
    &::before {
      content: counter(countLi);
      position: absolute;
      width: 40px;
      height: 40px;
      background: white;
      left: 8px;
      border-radius: 50%;
      color: black;
      text-align: center;
      top: 50%;
      transform: translateY(-50%);
      line-height: 2.4;
    }
  }
`;
const StyledButton = styled.button`
  width: 210px;
  background-color: #3db0f7;
  min-width: 215px;
  border-radius: 31px;
  color: #fff;
  font-size: 18px;
  margin: 0 auto;
`;
function SpeechRecommendations({
  tryAgain = emptyFunc
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Container$2, {
    children: [/* @__PURE__ */ jsx(Title$5, {
      children: t2("common.somethingWrong")
    }), /* @__PURE__ */ jsxs(Content, {
      children: [/* @__PURE__ */ jsxs(List$1, {
        children: [/* @__PURE__ */ jsx("span", {
          children: t2("selfieInstructions.quietPlace")
        }), /* @__PURE__ */ jsx("span", {
          children: t2("selfieInstructions.headphonesMicrophone")
        }), /* @__PURE__ */ jsx("span", {
          children: t2("selfieInstructions.clearPronunciation")
        })]
      }), /* @__PURE__ */ jsx(StyledButton, {
        onClick: tryAgain,
        children: t2("common.tryAgain")
      })]
    })]
  });
}
var waveEncoder = () => {
  let BYTES_PER_SAMPLE = 2;
  let recorded = [];
  function encode2(buffer2) {
    let length = buffer2.length;
    let data2 = new Uint8Array(length * BYTES_PER_SAMPLE);
    for (let i2 = 0; i2 < length; i2++) {
      let index2 = i2 * BYTES_PER_SAMPLE;
      let sample = buffer2[i2];
      if (sample > 1) {
        sample = 1;
      } else if (sample < -1) {
        sample = -1;
      }
      sample = sample * 32768;
      data2[index2] = sample;
      data2[index2 + 1] = sample >> 8;
    }
    recorded.push(data2);
  }
  function dump(sampleRate) {
    let bufferLength = recorded.length ? recorded[0].length : 0;
    let length = recorded.length * bufferLength;
    let wav = new Uint8Array(44 + length);
    let view = new DataView(wav.buffer);
    view.setUint32(0, 1380533830, false);
    view.setUint32(4, 36 + length, true);
    view.setUint32(8, 1463899717, false);
    view.setUint32(12, 1718449184, false);
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * BYTES_PER_SAMPLE, true);
    view.setUint16(32, BYTES_PER_SAMPLE, true);
    view.setUint16(34, 8 * BYTES_PER_SAMPLE, true);
    view.setUint32(36, 1684108385, false);
    view.setUint32(40, length, true);
    for (let i2 = 0; i2 < recorded.length; i2++) {
      wav.set(recorded[i2], i2 * bufferLength + 44);
    }
    recorded = [];
    postMessage(wav.buffer, [wav.buffer]);
  }
  onmessage = (e2) => {
    if (e2.data[0] === "encode") {
      encode2(e2.data[1]);
    } else if (e2.data[0] === "dump") {
      dump(e2.data[1]);
    }
  };
};
let AudioContext = window.AudioContext || window.webkitAudioContext;
let createWorker = (fn) => {
  let js = fn.toString().replace(/^(\(\)\s*=>|function\s*\(\))\s*{/, "").replace(/}$/, "");
  let blob = new Blob([js]);
  return new Worker(URL.createObjectURL(blob));
};
let error = (method2) => {
  let event = new Event("error");
  event.data = new Error("Wrong state for " + method2);
  return event;
};
let context;
class MediaRecorder$2 {
  constructor(stream, config2 = null) {
    this.stream = stream;
    this.config = config2;
    this.state = "inactive";
    this.em = document.createDocumentFragment();
    this.encoder = createWorker(MediaRecorder$2.encoder);
    let recorder = this;
    this.encoder.addEventListener("message", (e2) => {
      let event = new Event("dataavailable");
      event.data = new Blob([e2.data], { type: recorder.mimeType });
      recorder.em.dispatchEvent(event);
      if (recorder.state === "inactive") {
        recorder.em.dispatchEvent(new Event("stop"));
      }
    });
  }
  start(timeslice) {
    if (this.state !== "inactive") {
      return this.em.dispatchEvent(error("start"));
    }
    this.state = "recording";
    if (!context) {
      context = new AudioContext(this.config);
    }
    this.clone = this.stream.clone();
    this.input = context.createMediaStreamSource(this.clone);
    this.processor = context.createScriptProcessor(2048, 1, 1);
    this.encoder.postMessage(["init", context.sampleRate]);
    this.processor.onaudioprocess = (e2) => {
      if (this.state === "recording") {
        this.encoder.postMessage(["encode", e2.inputBuffer.getChannelData(0)]);
      }
    };
    this.input.connect(this.processor);
    this.processor.connect(context.destination);
    this.em.dispatchEvent(new Event("start"));
    if (timeslice) {
      this.slicing = setInterval(() => {
        if (this.state === "recording")
          this.requestData();
      }, timeslice);
    }
    return void 0;
  }
  stop() {
    if (this.state === "inactive") {
      return this.em.dispatchEvent(error("stop"));
    }
    this.requestData();
    this.state = "inactive";
    this.clone.getTracks().forEach((track) => {
      track.stop();
    });
    this.processor.disconnect();
    this.input.disconnect();
    return clearInterval(this.slicing);
  }
  pause() {
    if (this.state !== "recording") {
      return this.em.dispatchEvent(error("pause"));
    }
    this.state = "paused";
    return this.em.dispatchEvent(new Event("pause"));
  }
  resume() {
    if (this.state !== "paused") {
      return this.em.dispatchEvent(error("resume"));
    }
    this.state = "recording";
    return this.em.dispatchEvent(new Event("resume"));
  }
  requestData() {
    if (this.state === "inactive") {
      return this.em.dispatchEvent(error("requestData"));
    }
    return this.encoder.postMessage(["dump", context.sampleRate]);
  }
  addEventListener(...args) {
    this.em.addEventListener(...args);
  }
  removeEventListener(...args) {
    this.em.removeEventListener(...args);
  }
  dispatchEvent(...args) {
    this.em.dispatchEvent(...args);
  }
}
MediaRecorder$2.prototype.mimeType = "audio/wav";
MediaRecorder$2.isTypeSupported = (mimeType) => {
  return MediaRecorder$2.prototype.mimeType === mimeType;
};
MediaRecorder$2.notSupported = !navigator.mediaDevices || !AudioContext;
MediaRecorder$2.encoder = waveEncoder;
var mpegEncoder = () => {
  importScripts("https://cdnjs.cloudflare.com/ajax/libs/lamejs/1.2.0/lame.min.js");
  let CHANNELS = 1;
  let KBPS = 128;
  let DEFAULT_SAMPLE_RATE = 44100;
  let encoder;
  let recorded = new Int8Array();
  function concat2(a6, b2) {
    if (b2.length === 0) {
      return a6;
    }
    let c2 = new Int8Array(a6.length + b2.length);
    c2.set(a6);
    c2.set(b2, a6.length);
    return c2;
  }
  function init3(sampleRate) {
    encoder = new lamejs.Mp3Encoder(CHANNELS, sampleRate || DEFAULT_SAMPLE_RATE, KBPS);
  }
  function encode2(buffer2) {
    for (let i2 = 0; i2 < buffer2.length; i2++) {
      buffer2[i2] = buffer2[i2] * 32767.5;
    }
    let buf = encoder.encodeBuffer(buffer2);
    recorded = concat2(recorded, buf);
  }
  function dump() {
    let buf = encoder.flush();
    recorded = concat2(recorded, buf);
    let buffer2 = recorded.buffer;
    recorded = new Int8Array();
    postMessage(buffer2, [buffer2]);
  }
  onmessage = (e2) => {
    if (e2.data[0] === "init") {
      init3(e2.data[1]);
    } else if (e2.data[0] === "encode") {
      encode2(e2.data[1]);
    } else {
      dump(e2.data[1]);
    }
  };
};
function createSoundMeter({ onSoundChange, stream }) {
  const AudioContext2 = window.AudioContext || window.webkitAudioContext;
  const context2 = new AudioContext2();
  const script2 = context2.createScriptProcessor(4096, 1, 1);
  const mic2 = context2.createMediaStreamSource(stream);
  mic2.connect(script2);
  script2.connect(context2.destination);
  script2.onaudioprocess = (event) => {
    const input = event.inputBuffer.getChannelData(0);
    const sumOfSquares = input.reduce((a6, b2) => a6 + b2 * b2, 0);
    onSoundChange(Math.sqrt(sumOfSquares / input.length));
  };
  return {
    stop() {
      script2.disconnect(context2.destination);
      mic2.disconnect(script2);
    }
  };
}
const getVideoSelfieConfig = ({ session: { token } }) => {
  return api.get(`/omni/get/videoselfie/config`, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
};
MediaRecorder$2.encoder = mpegEncoder;
MediaRecorder$2.prototype.mimeType = "audio/mpeg";
const MediaRecorder$1 = MediaRecorder$2;
const SmallText = styled.span`
  font-size: 21px;
`;
const Question = styled(Question$1)`
  font-size: 35px;
`;
const stateMachineStatus = {
  IDLE: "idle",
  PENDING: "pending",
  SUCCESS: "success",
  REJECTED: "rejected"
};
const stateMachineReducer = (state2, action) => {
  switch (action.type) {
    case "idle": {
      return {
        status: "idle",
        error: null
      };
    }
    case "pending": {
      return {
        status: "pending",
        error: null
      };
    }
    case "success": {
      return {
        status: "resolved",
        error: null
      };
    }
    case "rejected": {
      return {
        status: "rejected",
        error: action.error
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
const useStateMachine = () => {
  const [state2, dispatch] = useReducer(stateMachineReducer, {
    status: "idle",
    error: null
  });
  return {
    status: state2.status,
    error: state2.error,
    setStatus: dispatch
  };
};
const getConsent = (config2, lang) => {
  const langCode = lang.split("-")[0];
  const consentKey = Object.keys(config2.consents).find((key) => key.startsWith(langCode));
  return config2.consents[consentKey].answer;
};
function SpeechMask({
  onNext,
  publisher,
  speechToTextCheck,
  stopRecording,
  onBoarding,
  token,
  streamOT,
  numberOfTries
}) {
  const {
    t: t2,
    i18n
  } = useTranslation();
  const [sound, setSound] = useState();
  const [consent, setConsent] = useState();
  const mediaRecorderRef = useRef();
  const triesRef = useRef(0);
  const {
    status,
    setStatus
  } = useStateMachine();
  useEffect(() => {
    let audioStream;
    let soundMeter;
    async function prepareSpeech() {
      if (streamOT) {
        const {
          OT: OT2
        } = window;
        audioStream = await OT2.getUserMedia({
          audio: true,
          video: true
        });
        soundMeter = createSoundMeter({
          onSoundChange(volume) {
            setSound(volume.toFixed(2));
          },
          stream: audioStream
        });
        const mediaRecorder = new MediaRecorder$1(audioStream.clone());
        mediaRecorderRef.current = mediaRecorder;
        publisher.publishVideo(true);
        mediaRecorder.start();
      }
    }
    prepareSpeech();
    return () => {
      var _a;
      soundMeter.stop();
      (_a = audioStream == null ? void 0 : audioStream.getTracks()) == null ? void 0 : _a.forEach((track) => track.stop());
    };
  }, [publisher, streamOT]);
  useEffect(() => {
    getVideoSelfieConfig({
      session: token
    }).then((config2) => {
      const consent2 = getConsent(config2, i18n.language);
      setConsent(consent2);
    });
  }, []);
  function handleSpeech() {
    if (speechToTextCheck === false) {
      onNext();
      return;
    }
    setStatus({
      type: stateMachineStatus.PENDING
    });
    let recordedChunks = [];
    async function uploadFileAndProcess(event) {
      if (!(event.data.size > 0)) {
        return onNext(true);
      }
      recordedChunks.push(event.data);
      const audio = new Blob(recordedChunks, {
        type: "audio/mp3"
      });
      const {
        success
      } = await onBoarding.addSpeech({
        token: token.token,
        audio
      }).catch((e2) => ({
        success: false
      }));
      mediaRecorderRef.current.removeEventListener("dataavailable", uploadFileAndProcess);
      if (success) {
        setStatus({
          type: stateMachineStatus.SUCCESS
        });
        return stopRecording(() => onNext(true));
      }
      mediaRecorderRef.current.start();
      publisher.publishVideo(true);
      recordedChunks = [];
      const newTries = triesRef.current + 1;
      triesRef.current = newTries;
      if (numberOfTries !== -1 && newTries >= numberOfTries) {
        return stopRecording(() => onNext(false));
      }
      setStatus({
        type: stateMachineStatus.REJECTED
      });
    }
    mediaRecorderRef.current.addEventListener("dataavailable", uploadFileAndProcess);
    mediaRecorderRef.current.stop();
    mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
  }
  function handleTryAgain() {
    setStatus({
      type: stateMachineStatus.IDLE
    });
  }
  const shouldShowInstructions = status === stateMachineStatus.IDLE || status === stateMachineStatus.SUCCESS;
  const shouldShowError = status === stateMachineStatus.REJECTED;
  return /* @__PURE__ */ jsxs(QuestionMaskContainer, {
    children: [status === stateMachineStatus.PENDING && /* @__PURE__ */ jsx(Loader, {
      message: t2("common.processing"),
      fullScreen: true
    }), shouldShowInstructions && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs(Question, {
        children: [/* @__PURE__ */ jsx(SmallText, {
          children: t2("videoSelfie.nowSay")
        }), " ", /* @__PURE__ */ jsx("br", {}), `"${consent || ""}"`, /* @__PURE__ */ jsx("br", {}), /* @__PURE__ */ jsx(SmallText, {
          children: t2("videoSelfie.outLoud")
        })]
      }), /* @__PURE__ */ jsxs(BottomContainer, {
        children: [/* @__PURE__ */ jsx(Microphone, {
          sound,
          isQuestions: true
        }), /* @__PURE__ */ jsx(QuestionText, {
          children: t2("videoSelfie.tapContinue")
        }), /* @__PURE__ */ jsx(QuestionButton, {
          onClick: handleSpeech,
          children: t2("common.continue").toLowerCase()
        })]
      })]
    }), shouldShowError && /* @__PURE__ */ jsx(SpeechRecommendations, {
      tryAgain: handleTryAgain
    })]
  });
}
const Container$1 = styled.div`
  position: relative;
  height: 100%;
  min-height: 487px;
  overflow: auto;
`;
const FaceMask = styled.div`
  z-index: 5;
  position: absolute;
  top: 45%;
  width: 80vw;
  height: 80vw;
  transform: translate(-50%, -50%);
  left: 50%;
  border: solid 6.9px;
  border-color: ${(props) => props.isCapturing ? "#0cd5a2" : props.selfieLoading ? "#00b2fd" : props.error ? "#ff5c6f" : "#fff"};
  border-radius: 50%;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.6);
`;
const FaceFrame = styled.img`
  z-index: 5;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  height: 250px;
`;
const Text$1 = styled.p`
  z-index: 5;
  font-size: 25px;
  font-weight: bold;
  position: absolute;
  bottom: ${(props) => props.isId ? "90px" : "30%"};
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  color: ${(props) => props.isCapturing ? "#0cd5a2" : "#ffffff"};
  max-width: 80%;
  &.id {
    bottom: 500px;
  }
  &.selfie {
    bottom: 20%;
  }
  &.speech {
    top: 10px;
  }
`;
const Counter = styled.p`
  position: absolute;
  z-index: 6;
  top: 5px;
  left: 8px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  margin: 0;
  display: flex;
`;
const LoadingText = styled.p`
  font-size: 23px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
`;
const RecordingImg = styled.img`
  margin-right: 5px;
`;
function Loading$1({
  children
}) {
  return /* @__PURE__ */ jsx(Spinner$2, {
    children: /* @__PURE__ */ jsx(LoadingText, {
      children
    })
  });
}
function getSession(token, apiKey2, events = {}) {
  return createSession(__spreadValues({
    apiKey: apiKey2,
    sessionId: token.sessionId,
    token: token.token
  }, events));
}
const webcamFuncionality = {
  getBase64ScreenShot() {
    return "";
  },
  dataURLtoBlob() {
    return;
  },
  getFullImage() {
    return;
  },
  getImageData(width2, height2) {
    const canvasEl = document.createElement("canvas");
    canvasEl.width = width2;
    canvasEl.height = height2;
    const ctx = canvasEl.getContext("2d");
    ctx.clearRect(0, 0, width2, height2);
    ctx.drawImage(this.video, 0, 0);
    const canvas = canvasEl;
    const context2 = canvas.getContext("2d");
    return canvas && context2.getImageData(0, 0, width2, height2);
  }
};
const timeoutSleep = 2e3;
function VideoRecorder({
  onSuccess: _onSuccess,
  onError: _onError,
  token,
  onBoarding,
  modules,
  speechToTextCheck,
  onLog,
  numberOfTries,
  performLiveness = false,
  videoSelfieAsSelfie,
  compareOCREnabled = false,
  compareIDEnabled = true
}) {
  const [modeIndex, setModeIndex] = useState(-1);
  const [isCapturing, setIsCapturing] = useState(false);
  const isDetecting = useRef(true);
  const [sound, setSound] = useState();
  const [stream, setStream] = useState(null);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error3, setError] = useState(false);
  const [frontIDSuccess, setFrontIdSuccess] = useState(false);
  const [selfieLoading, setSelfieLoading] = useState(false);
  const [notification, setNotification] = useState("");
  const [counter2, setCounter] = useState(0);
  const webcam = useRef();
  const openTokSessionRef = useRef();
  const requestId = useRef();
  const recordingDateRef = useRef();
  const publishContainerRef = useRef();
  const publisherRef = useRef();
  const onCapturingRef = useRef(emptyFunc);
  const triesRef = useRef(1);
  const compareTriesRef = useRef(1);
  const {
    t: t2
  } = useTranslation();
  const allGoodText = t2("videoSelfie.allGood");
  const mode2 = modules[modeIndex];
  useInterval(() => {
    setCounter(counter2 + 1);
  }, ready ? 1e3 : null);
  const onSuccess = useCallback((...props) => {
    onBoarding.addEvent({
      eventName: "videoSelfieCompletedSuccessfully",
      eventType: "text",
      eventData: {},
      token: token.token
    });
    _onSuccess(props);
  }, [_onSuccess, onBoarding, token]);
  const onError = useCallback((...props) => {
    onBoarding.addEvent({
      eventName: "videoSelfieCompletedUnsuccessfully",
      eventType: "text",
      eventData: {},
      token: token.token
    });
    _onError(props);
  }, [_onError, onBoarding, token]);
  const stopRecording = useCallback(async (callback = emptyFunc) => {
    setLoading(true);
    openTokSessionRef.current.disconnect();
    stream.getTracks().forEach((track) => track.stop());
    await stopRecorder(token.token);
    callback == null ? void 0 : callback();
  }, [stream, token.token]);
  const nextMode = useCallback(async () => {
    const newModeIndex = modeIndex + 1;
    if (newModeIndex >= modules.length) {
      await stopRecording();
      onSuccess();
      return;
    }
    setModeIndex(modeIndex + 1);
  }, [modeIndex, modules.length, onSuccess, stopRecording]);
  useEffect(() => {
    if (stream)
      return;
    const {
      OT: OT2
    } = window;
    async function getStream() {
      try {
        const stream2 = await OT2.getUserMedia({
          video: true,
          audio: true
        });
        setStream(stream2);
        if (Boolean(mobile.Android())) {
          stream2.getTracks().forEach((track) => track.stop());
        }
        const session = await getOpentokSession(token.token);
        const openTok = getSession(session, onBoarding.tokboxApiKey, {
          async onConnect() {
            publisherRef.current = OT2.initPublisher(publishContainerRef.current, {
              height: "100%",
              width: "100%",
              resolution: "640x480"
            });
            publisherRef.current.setStyle({
              buttonDisplayMode: "off",
              archiveStatusDisplayMode: "off"
            });
            publisherRef.current.on("audioLevelUpdated", (event) => {
              setSound(event.audioLevel.toFixed(2));
            });
            openTok.session.publish(publisherRef.current, async () => {
              const videoElement = publishContainerRef.current.querySelector("video");
              webcam.current = videoElement;
              await startRecorder(token.token);
              setReady(true);
              nextMode();
              recordingDateRef.current = new Date();
            });
          }
        });
        openTokSessionRef.current = openTok;
      } catch (e2) {
        if (e2.originalName === "NotAllowedError") {
          onLog(getLogObject("permissionDenied", {
            message: `User denied to use camera.`
          }));
        }
        return onError(e2);
      }
    }
    getStream();
  }, [token.token, nextMode, onError, onLog, stream, onBoarding.tokboxApiKey]);
  useEffect(() => {
    if (!ready)
      return;
    if (mode2 !== "selfie")
      return;
    async function handleCapture() {
      try {
        setNotification(t2("videoSelfie.processingSelfie"));
        setSelfieLoading(true);
        onBoarding.stopDetect();
        const image2 = publisherRef.current.getImgData();
        const type = onBoarding.selfieType;
        const encryptedImage = await encryptImage(image2);
        window.image = image2;
        window.publisher = publisherRef.current;
        const response = await onBoarding.capture({
          token: token.token,
          image: encryptedImage,
          type,
          encrypted: true,
          imageType: videoSelfieAsSelfie ? "selfie" : "videoSelfie"
        });
        const liveness = performLiveness ? response.confidence < 0.6 : true;
        if (!liveness) {
          setSelfieLoading(false);
          const error22 = new Error("Liveness failed");
          error22.response = {
            data: {
              errorMessage: "liveness-failed"
            }
          };
          throw error22;
        }
        const processResponse = await onBoarding.processFace({
          token: token.token,
          imageType: videoSelfieAsSelfie ? "selfie" : "videoSelfie"
        });
        const faceMatch = processResponse.confidence != null ? processResponse.confidence > 0.3 : true;
        if (!faceMatch) {
          setSelfieLoading(false);
          const error22 = new Error("No match!");
          error22.response = {
            data: {
              errorMessage: "no-match"
            }
          };
          throw error22;
        }
        setSelfieLoading(false);
        setIsCapturing(true);
        setNotification(allGoodText);
        await sleep(3e3);
        setIsCapturing(false);
        nextMode();
      } catch (e2) {
        setIsCapturing(false);
        setIsCapturing(false);
        setSelfieLoading(false);
        setError(true);
        const response = e2.response ? e2.response.data : t2("notifications.serverError");
        const errorMessage = (response == null ? void 0 : response.errorMessage) || (response == null ? void 0 : response.message) || (response == null ? void 0 : response.reason);
        switch (errorMessage) {
          case "No faces found on the image":
            setNotification(t2("notifications.face"));
            break;
          case "BadRequestException: More than one face detected.":
            setNotification(t2("notifications.multiple"));
            break;
          case "Cropping area goes off the image.":
            setNotification(t2("notifications.crop"));
            break;
          case "Image in portrait orientation is expected.":
            setNotification(t2("notifications.portrait"));
            break;
          case "no-match":
            setNotification(t2("notifications.noMatch"));
            break;
          case "liveness-failed":
            setNotification(t2("notifications.spoof"));
            break;
          default:
            setNotification(t2("notifications.error"));
            break;
        }
        const {
          current: tries
        } = triesRef;
        await sleep(3e3);
        setError(false);
        if (tries >= numberOfTries) {
          await onBoarding.processFace({
            token: token.token,
            imageType: videoSelfieAsSelfie ? "selfie" : "videoSelfie"
          });
          await stopRecording();
          onError(e2);
          return;
        }
        setNotification("");
        detect22();
        triesRef.current = tries + 1;
      }
    }
    async function detect22() {
      await sleep(timeoutSleep);
      onBoarding.resumeDetect();
      onBoarding.detect({
        canvas: document.createElement("canvas"),
        type: onBoarding.selfieType,
        webcam: {
          video: webcam.current,
          getBase64ScreenShot: emptyFunc,
          getFullImage: emptyFunc,
          getImageData: emptyFunc
        },
        onCapturing: throttle$1(handleCapture, 1e3),
        onError: emptyFunc,
        looseMode: true
      });
    }
    detect22();
  }, [ready, mode2, t2, onBoarding, token.token, allGoodText, nextMode, numberOfTries, onError, stopRecording, performLiveness, videoSelfieAsSelfie]);
  useEffect(() => {
    const handleError = async (message2) => {
      setIsCapturing(false);
      setError(true);
      setNotification(message2);
      const {
        current: compareTries
      } = compareTriesRef;
      await sleep(3e3);
      setError(false);
      if (compareTries >= 3) {
        await stopRecording();
        onError(message2);
        return;
      }
      setNotification("");
      isDetecting.current = true;
      detect2();
      compareTriesRef.current = compareTries + 1;
    };
    onCapturingRef.current = async () => {
      if (!["front", "back"].includes(mode2)) {
        return;
      }
      isDetecting.current = false;
      onBoarding.stopDetect();
      window.cancelAnimationFrame(requestId.current);
      setIsCapturing(true);
      if (mode2 === "front" && (compareOCREnabled || compareIDEnabled)) {
        setIsCapturing(true);
        const image2 = publisherRef.current.getImgData();
        const compareOCRPromise = compareOCREnabled ? onBoarding.compareOCR({
          token: token.token,
          image: image2
        }) : Promise.resolve({
          success: true
        });
        const compareIDPromise = compareIDEnabled ? onBoarding.compareID({
          token: token.token,
          image: image2
        }) : Promise.resolve({
          faceRecognitionConfidence: 1,
          idTypeMatched: true
        });
        const [compareOcrResponse, compareIdResponse] = await Promise.allSettled([compareOCRPromise, compareIDPromise]);
        if (compareOcrResponse.status === "rejected" || compareIdResponse.status === "rejected" || !compareIdResponse.value.idTypeMatched) {
          handleError(t2("notifications.compareID.scanFailed"));
          return;
        }
        if (compareIdResponse.value.faceRecognitionConfidence !== 1) {
          handleError(t2("notifications.compareID.photoVerificationFailed"));
          return;
        }
        if (!compareOcrResponse.value.success) {
          handleError(t2("notifications.compareID.nameVerificationFailed"));
          return;
        }
      }
      setIsCapturing(false);
      setFrontIdSuccess(true);
      setNotification(allGoodText);
      await sleep(3e3);
      setNotification("");
      setFrontIdSuccess(false);
      nextMode();
      onBoarding.addEvent({
        eventName: mode2 === "front" ? "videoSelfieIdFrontDetected" : "videoSelfieIdBackDetected",
        eventType: "text",
        eventData: {},
        token: token.token
      });
    };
  }, [mode2, nextMode, onBoarding, token.token]);
  const detect2 = useCallback(() => {
    const loop = async () => {
      if (!isDetecting.current && webcam.current) {
        return;
      }
      await onBoarding.idVideoSelfieDetection({
        webcam: __spreadValues({
          video: webcam.current
        }, webcamFuncionality),
        onCapturing: throttle$1(onCapturingRef.current, 1e3),
        onFarAway: emptyFunc,
        isMobile: true
      });
      await sleep(1e3);
      requestId.current = window.requestAnimationFrame(loop);
    };
    requestId.current = window.requestAnimationFrame(loop);
  }, [onBoarding]);
  useEffect(() => {
    if (!ready)
      return;
    if (mode2 === "front" || mode2 === "back") {
      sleep(5e3).then(() => {
        isDetecting.current = true;
        detect2();
      });
      detect2();
    }
  }, [ready, mode2, detect2]);
  async function handleFinish(success) {
    if (success) {
      onSuccess();
    } else {
      onError();
    }
  }
  function handlePoaNext() {
    onBoarding.addEvent({
      eventName: "videoSelfiePoaScanned",
      eventType: "text",
      eventData: {},
      token: token.token
    });
    nextMode();
  }
  function handleQuestionNext() {
    nextMode();
  }
  const minutes = Math.floor(counter2 / 60).toString().padStart(2, "0");
  const seconds = (counter2 % 60).toString().padStart(2, "0");
  return /* @__PURE__ */ jsxs(Container$1, {
    children: [!ready && /* @__PURE__ */ jsx(Loading$1, {
      children: t2("videoSelfie.starting")
    }), ready && !loading && /* @__PURE__ */ jsxs(Counter, {
      children: [/* @__PURE__ */ jsx(RecordingImg, {
        src: recordingIcon,
        alt: "recording red point"
      }), " ", minutes, ":", seconds]
    }), mode2 === "selfie" && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx(FaceMask, {
        isCapturing,
        selfieLoading,
        error: error3,
        children: /* @__PURE__ */ jsx(FaceFrame, {
          src: faceFrame,
          alt: "face frame",
          className: "face-frame"
        })
      })
    }), ["front", "back"].includes(mode2) && /* @__PURE__ */ jsx(IdMask, {
      isSuccess: frontIDSuccess,
      isError: error3,
      isCapturing,
      message: notification,
      mode: mode2
    }), mode2 === "selfie" && /* @__PURE__ */ jsx(Text$1, {
      className: "selfie",
      children: notification || t2("videoSelfie.lookCamera")
    }), mode2 === "poa" && /* @__PURE__ */ jsx(ProofOfAddress, {
      onNext: handlePoaNext
    }), mode2 === "questions" && /* @__PURE__ */ jsx(QuestionsContainer, {
      onNext: handleQuestionNext,
      onBoarding,
      token,
      sound
    }), mode2 === "speech" && /* @__PURE__ */ jsx(SpeechMask, {
      onNext: handleFinish,
      speechToTextCheck,
      stopRecording,
      streamOT: stream,
      publisher: publisherRef.current,
      onBoarding,
      token,
      numberOfTries
    }), loading && /* @__PURE__ */ jsx(Loading$1, {
      children: t2("videoSelfie.processing")
    }), /* @__PURE__ */ jsx("div", {
      ref: publishContainerRef
    })]
  });
}
var VideoRecorder$1 = preloadScript(VideoRecorder);
styled.section`
  height: 100%;
`;
const steps = ["tutorial", "videoRecorder"];
function Recorder(props) {
  const [step2, _setStep] = useState(steps.indexOf(props.showTutorial ? "tutorial" : "videoRecorder"));
  function setStep(step22) {
    return _setStep(steps.indexOf(step22));
  }
  return /* @__PURE__ */ jsxs(Steps, {
    currentStep: step2,
    children: [/* @__PURE__ */ jsx(Tutorial, __spreadValues({
      goNext: () => setStep("videoRecorder")
    }, props)), /* @__PURE__ */ jsx(VideoRecorder$1, __spreadValues({
      goNext: (success) => setStep(success ? "success" : "not-success")
    }, props))]
  });
}
function renderVideoSelfie(element, {
  token,
  showTutorial = false,
  modules = ["selfie", "front", "back", "poa", "questions", "speech"],
  speechToTextCheck = true,
  performLiveness = false,
  videoSelfieAsSelfie = false,
  compareOCREnabled = false,
  compareIDEnabled = true
}, {
  onSuccess,
  onError,
  onLog = () => {
  },
  numberOfTries = 3
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element)
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(Recorder, {
      onBoarding: this,
      token,
      onSuccess: props.onSuccess,
      onError: props.onError,
      showTutorial,
      modules,
      speechToTextCheck,
      onLog,
      numberOfTries,
      performLiveness,
      videoSelfieAsSelfie,
      compareOCREnabled,
      compareIDEnabled
    })
  }), element);
}
const LinkButton = styled.button`
  background: transparent;
`;
const Container = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #21273b;
  padding: 50px 10px;
`;
const Error$2 = styled.span`
  font-size: 14px;
  color: #f54f68;
`;
function SMSOTP({
  token: {
    token
  },
  onBoarding,
  onError,
  onLog,
  onSuccess,
  numberOfTries
}) {
  const [code, setCode] = useState("");
  const [tries, setTries] = useState(0);
  const [error3, setError] = useState(false);
  const {
    t: t2
  } = useTranslation();
  const sendOTPSMS2 = useCallback(() => {
    onBoarding.sendOTPSMS({
      token
    });
    setError(false);
    setCode("");
  }, [onBoarding, token]);
  useEffect(() => {
    sendOTPSMS2();
  }, [sendOTPSMS2]);
  function handleCodeChange(string2) {
    if (string2 === code) {
      return;
    }
    setCode(string2);
    setError(false);
  }
  async function handleError() {
    setError(true);
    const newTries = tries + 1;
    setTries((tries2) => tries2 + 1);
    onLog(getLogObject("otpAttemptFailed", {
      message: "Incorrect OTP"
    }));
    if (numberOfTries !== -1 && newTries >= numberOfTries) {
      onError("OTPError");
      onLog(getLogObject("otpNoAttemptsLeft", {
        message: "No attempts left"
      }));
    }
  }
  async function handleSubmit() {
    try {
      const {
        success
      } = await onBoarding.compareOTP({
        token,
        code
      });
      if (success) {
        onBoarding.addEvent({
          token,
          eventName: "otpSubmitted",
          eventData: {},
          eventType: "text"
        });
        onLog(getLogObject("otpPassed", {
          message: "Correct OTP"
        }));
        onSuccess();
      } else {
        handleError();
      }
    } catch (e2) {
      handleError();
    }
  }
  return /* @__PURE__ */ jsxs(Container, {
    children: [/* @__PURE__ */ jsx("p", {
      children: t2("otp.insertSMS")
    }), /* @__PURE__ */ jsx(IndividualCharacterInputBoxes, {
      amount: 6,
      onChange: handleCodeChange,
      autoFocus: true,
      value: code
    }), error3 && /* @__PURE__ */ jsxs(Error$2, {
      className: "IncodeOTPError",
      children: [" ", t2("otp.error")]
    }), /* @__PURE__ */ jsx("p", {
      children: /* @__PURE__ */ jsxs(Trans, {
        t: t2,
        i18nKey: "otp.didYouNotGetIt",
        children: ["You did not get the sms?", /* @__PURE__ */ jsx(LinkButton, {
          onClick: sendOTPSMS2,
          children: "Send again"
        })]
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(Button$3, {
        onClick: handleSubmit,
        theme: theme$1,
        children: t2("otp.submit")
      })
    })]
  });
}
function OTPApp(props) {
  return /* @__PURE__ */ jsx(Fragment, {
    children: props.useSMS ? /* @__PURE__ */ jsx(SMSOTP, __spreadValues({}, props)) : /* @__PURE__ */ jsx(SimpleOTP, __spreadValues({}, props))
  });
}
function renderOTP(element, {
  token,
  numberOfTries = 3,
  otpTimeout = 3e4,
  useSMS = false
}, {
  onSuccess,
  onError,
  onLog = emptyFunc
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element)
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(OTPApp, {
      onBoarding: this,
      token,
      onSuccess: props.onSuccess,
      numberOfTries,
      onError: props.onError,
      onLog,
      otpTimeout,
      useSMS
    })
  }), element);
}
let isLoaded = false;
function loadExternalFiles({
  facefinderURL = "https://template-console.s3.amazonaws.com/webcamera/facefinder",
  opencvURL = "https://sdk.incode.com/sdk/scripts/opencv.js"
}) {
  if (isLoaded) {
    return;
  }
  fetch(facefinderURL).then((response) => {
    response.arrayBuffer().then((buffer2) => {
      const bytes = new Int8Array(buffer2);
      state.facefinderClassifyRegion = pico.unpack_cascade(bytes);
    });
  });
  const loader2 = new ScriptLoader({
    src: opencvURL,
    global: "cv"
  });
  loader2.load();
  isLoaded = true;
}
function getRandomQuestions({ token, numberOfQuestions = 3 }) {
  return api.get("/omni/get/questionAndAnswer", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    },
    params: { numberOfQuestions }
  }).then((response) => response.data);
}
function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
}
async function sendGeolocation(token) {
  const onBoarding = this;
  return getCurrentPosition().then((pos) => onBoarding.addGeolocation({
    token,
    longitude: pos.coords.longitude,
    latitude: pos.coords.latitude
  }));
}
function mock({
  token,
  interviewId
}) {
  return api.get(`/omni/mock?interviewId=${interviewId}`, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  });
}
function setSessionStatus({ token, action }) {
  return api.post(`/omni/session/status/set?action=${action}`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function renderCapture(type, element, options) {
  return renderCamera.call(this, type, element, __spreadProps(__spreadValues({}, options), {
    onlyCapture: true
  }));
}
function addSpeech({ token, audio, onProgress = emptyFunc }) {
  return api.post(`/omni/add/speech?audioOnly=true`, audio, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "audio/mp4"
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function fetchAssets({ token }) {
  return api.get("/omni/asset/fetch-all", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function sendOTPSMS({ token }) {
  return api.get("/omni/send/sms-otp", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function compareOTP({ token, code }) {
  return api.get("/omni/compare/sms-otp", {}, {
    params: { code },
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
const getFinishStatus = (flowId, { token }) => {
  return api.get(`/omni/finish-status${flowId ? `?flowId=${flowId}` : ""}`, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
};
async function sendMfa({ verificationCode, transactionId }) {
  return api.post("/omni/oneToN/mfa", { verificationCode, transactionId }).then((response) => response.data).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
const ErrorContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;
const ErrorSpan = styled.span`
  font-size: 16px;
  color: #ff5c6f;
`;
const Error$1 = ({
  error: error3
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx(ErrorContainer, {
    children: error3 && /* @__PURE__ */ jsx(ErrorSpan, {
      children: t2(`secondFactor.${error3}`)
    })
  });
};
const SecondFactorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
`;
const DivWithMargin = styled.div`
  margin-bottom: 90px;
`;
const SecondFactor = ({
  transactionId,
  onSuccess
}) => {
  const [verificationCode, setVerificationCode] = useState("");
  const [error3, setError] = useState("");
  const [isLoading, seTIsLoading] = useState(false);
  const {
    t: t2
  } = useTranslation();
  async function handleContinue() {
    try {
      seTIsLoading(true);
      const response = await sendMfa({
        transactionId,
        verificationCode
      });
      onSuccess(response);
    } catch {
      seTIsLoading(false);
      setError("incorrect");
    }
  }
  return /* @__PURE__ */ jsxs(SecondFactorContainer, {
    children: [/* @__PURE__ */ jsxs(DivWithMargin, {
      children: [/* @__PURE__ */ jsx("h1", {
        children: t2("secondFactor.title")
      }), /* @__PURE__ */ jsx("p", {
        children: t2("secondFactor.instruction")
      })]
    }), /* @__PURE__ */ jsxs(DivWithMargin, {
      children: [/* @__PURE__ */ jsx(Input$2, {
        type: "tel",
        autoComplete: "off",
        value: verificationCode,
        onChange: (ev) => {
          setVerificationCode(ev.target.value);
          setError("");
        }
      }), error3 && /* @__PURE__ */ jsx(Error$1, {
        error: error3
      })]
    }), /* @__PURE__ */ jsx(Button$3, {
      disabled: isLoading,
      onClick: handleContinue,
      children: t2("common.continue")
    })]
  });
};
const getCircleText = (t2, notification) => ({
  uploading: t2("notifications.uploading"),
  success: t2("notifications.done"),
  error: notification
});
function Login({
  onBoarding,
  onError,
  onSuccess,
  timeout = 4e4,
  stopAtError = false,
  stopAtAccessDenied = false,
  isOneToOne = false,
  oneToOneProps
}) {
  const [loginMode, setLoginMode] = useState("selfie");
  const [transactionId, setTransactionId] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const webcam = useRef(null);
  const handleLoginError = async (err) => {
    var _a;
    if (stopAtError) {
      onError(err);
      return;
    }
    handleError(err || t2("notifications.serverError"));
    setMode("error");
    await sleep(3e3);
    resetLoading({
      response: (_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data,
      livenessPassed: null,
      imageBase64
    });
    startAutoDetect();
  };
  const handleLoginSuccess = async (response) => {
    const livenessPassed = response.spoofAttempt === false;
    const loginSuccess = !!response.customerId;
    const secondFactor = response.secondFactor;
    if (secondFactor) {
      setLoginMode("secondFactor");
      setTransactionId(response.transactionId);
      setImageBase64(imageBase64);
      return;
    }
    if (!livenessPassed || !loginSuccess) {
      if (stopAtError) {
        onError("error");
        return;
      }
      setMode("error");
      if (!livenessPassed) {
        setNotificationMessage(t2("notifications.spoof"));
      } else if (!loginSuccess) {
        setNotificationMessage(t2("selfie.accessDenied"));
      }
      await sleep(3e3);
      if (!loginSuccess && stopAtAccessDenied) {
        const error3 = new Error("AccessDenied");
        console.dir(error3);
        onError(error3);
        return;
      }
      resetLoading({
        response,
        livenessPassed,
        imageBase64
      });
      startAutoDetect();
      return;
    }
    handleSuccess(response, imageBase64);
  };
  const onBoardingIdentify = async (imageBase642, faceCoordinates) => {
    await onBoarding.identify({
      base64Image: imageBase642,
      faceCoordinates
    }).then(handleLoginSuccess).catch(handleLoginError);
  };
  const onBoardingOneToOneIdentify = async (imageBase642, faceCoordinates) => {
    await onBoarding.OneToOneIdentify({
      base64Image: imageBase642,
      faceCoordinates,
      phone: oneToOneProps.phone
    }).then(handleLoginSuccess).catch(handleLoginError);
  };
  const handleCapture = throttle$1(async (imageBase642, _24, faceCoordinates) => {
    if (!isOneToOne) {
      onBoardingIdentify(imageBase642, faceCoordinates);
    } else {
      onBoardingOneToOneIdentify(imageBase642, faceCoordinates);
    }
  }, 300);
  async function handleSuccess(response, image2) {
    onSuccess(__spreadProps(__spreadValues({}, response), {
      token: response.token,
      base64Image: image2 || imageBase64
    }));
  }
  const {
    t: t2
  } = useTranslation();
  const {
    showManualCapture,
    mode: mode2,
    notificationMessage,
    startAutoDetect,
    cameraReady,
    handleManualCapture,
    isSuccess,
    isError,
    isLoading,
    hideCamera,
    showBorders,
    shouldShowManualCapture,
    handleError,
    setMode,
    resetLoading,
    setNotificationMessage
  } = useSelfie({
    timeout,
    handleCapture,
    numberOfTries: -1,
    webcam
  });
  if (loginMode === "secondFactor") {
    return /* @__PURE__ */ jsx(SecondFactor, {
      transactionId,
      onSuccess: handleSuccess
    });
  }
  return /* @__PURE__ */ jsxs(Container$6, {
    children: [shouldShowManualCapture && /* @__PURE__ */ jsxs(CaptureButtonContainer$2, {
      initial: {
        scale: 0
      },
      animate: {
        scale: 1
      },
      children: [/* @__PURE__ */ jsx("p", {
        children: t2("common.takePhoto")
      }), /* @__PURE__ */ jsx("button", {
        onClick: handleManualCapture,
        children: /* @__PURE__ */ jsx("img", {
          src: captureButton,
          alt: "capture button"
        })
      })]
    }), /* @__PURE__ */ jsxs(WebcamContainer, {
      children: [(isLoading || isSuccess) && /* @__PURE__ */ jsx(BordersContainer, {
        children: /* @__PURE__ */ jsx(LoadingBorders, {
          mode: mode2
        })
      }), /* @__PURE__ */ jsx(Hidder, {
        initial: {
          width: 50,
          height: 50
        },
        animate: {
          width: cameraReady ? 300 : 50,
          height: cameraReady ? 300 : 50
        },
        children: /* @__PURE__ */ jsx(CameraOvalOuter, {
          className: classNames({
            "no-borders": isLoading || isSuccess,
            "has-error": isError
          }),
          initial: {
            borderWidth: "0px"
          },
          transition: {
            delay: 0,
            ease: "linear"
          },
          animate: {
            borderWidth: showBorders ? "6px" : "0px",
            borderColor: isError ? "#ff5c6f" : "#21273b"
          },
          children: /* @__PURE__ */ jsxs(CameraOvalInner, {
            className: classNames({
              isUploading: hideCamera
            }),
            children: [/* @__PURE__ */ jsx(FaceFrame$1, {
              src: faceFrame$1,
              alt: "face frame",
              className: classNames({
                hidden: hideCamera
              })
            }), /* @__PURE__ */ jsx(WebcamWithChooseCamera, {
              ref: webcam,
              videoSource: "user",
              onPlay: startAutoDetect,
              isSelfie: true,
              className: classNames("video__selfie", {
                hidden: hideCamera
              }),
              onError
            }), hideCamera && /* @__PURE__ */ jsx(CameraOvalInnerText, {
              className: classNames({
                isError
              }),
              children: getCircleText(t2, notificationMessage)[mode2]
            })]
          })
        })
      })]
    }), !hideCamera && /* @__PURE__ */ jsx(NotificationInline, {
      initial: {
        scale: 0
      },
      animate: {
        scale: cameraReady ? 1 : 0
      },
      className: classNames({
        hasManualCapture: showManualCapture
      }),
      children: notificationMessage || /* @__PURE__ */ jsxs(Fragment, {
        children: [t2("notifications.selfie.one"), " ", /* @__PURE__ */ jsx("br", {}), t2("notifications.selfie.two")]
      })
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame",
      hidden: true
    })]
  });
}
function renderLogin(element, {
  onSuccess,
  onError,
  timeout,
  stopAtAccessDenied,
  stopAtError,
  isOneToOne,
  oneToOneProps
}) {
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element),
    onBoarding: this,
    timeout,
    stopAtAccessDenied,
    stopAtError,
    isOneToOne,
    oneToOneProps
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(Login, __spreadValues({}, props))
  }), element);
  return {
    close: handleUnmount(emptyFunc, element)
  };
}
const CaptureButtonContainer = styled(captureButton)`
  position: absolute;
`;
function LoginDesktop({
  onBoarding,
  onError,
  onSuccess,
  timeout = 4e4,
  stopAtAccessDenied = false
}) {
  const [loginMode, setLoginMode] = useState("selfie");
  const [transactionId, setTransactionId] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const webcam = useRef(null);
  const handleCapture = throttle$1(async (imageBase642, _24, faceCoordinates) => {
    await onBoarding.identify({
      base64Image: imageBase642,
      faceCoordinates
    }).then(async (response) => {
      const livenessPassed = response.spoofAttempt === false;
      const loginSuccess = !!response.customerId;
      const secondFactor = response.secondFactor;
      if (secondFactor) {
        setLoginMode("secondFactor");
        setTransactionId(response.transactionId);
        setImageBase64(imageBase642);
        return;
      }
      if (!livenessPassed || !loginSuccess) {
        setMode("error");
        if (!livenessPassed) {
          setNotificationMessage(t2("notifications.spoof"));
        } else if (!loginSuccess) {
          setNotificationMessage(t2("selfie.accessDenied"));
        }
        await sleep(3e3);
        if (!loginSuccess && stopAtAccessDenied) {
          const error3 = new Error("AccessDenied");
          console.dir(error3);
          onError(error3);
          return;
        }
        resetLoading({
          response,
          livenessPassed,
          imageBase64: imageBase642
        });
        startAutoDetect();
        return;
      }
      handleSuccess(response, imageBase642);
    }).catch(async (err) => {
      var _a;
      console.error(err);
      handleError(err || t2("notifications.serverError"));
      setMode("error");
      await sleep(3e3);
      resetLoading({
        response: (_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data,
        livenessPassed: null,
        imageBase64: imageBase642
      });
      startAutoDetect();
    });
  }, 300);
  async function handleSuccess(response, image2) {
    const session = await onBoarding.createSession("ALL", null, {
      interviewId: response.interviewId
    });
    onSuccess(__spreadProps(__spreadValues({}, response), {
      token: session.token,
      base64Image: image2 || imageBase64
    }));
  }
  const {
    t: t2
  } = useTranslation();
  const {
    notificationMessage,
    startAutoDetect,
    handleManualCapture,
    isSuccess,
    isError,
    isLoading,
    hideCamera,
    shouldShowManualCapture,
    handleError,
    setMode,
    resetLoading,
    setNotificationMessage
  } = useSelfie({
    timeout,
    handleCapture,
    numberOfTries: -1,
    webcam
  });
  if (loginMode === "secondFactor") {
    return /* @__PURE__ */ jsx(SecondFactor, {
      transactionId,
      onSuccess: handleSuccess
    });
  }
  const notification = isLoading ? "Uploading.." : notificationMessage;
  const isNotCapturing = isLoading || isError || isSuccess;
  return /* @__PURE__ */ jsxs(LoginContainer, {
    className: "login-desktop-container",
    children: [shouldShowManualCapture && /* @__PURE__ */ jsxs(CaptureButtonContainer, {
      className: "capture-button-container",
      initial: {
        scale: 0
      },
      animate: {
        scale: 1
      },
      children: [/* @__PURE__ */ jsx("p", {
        children: t2("common.takePhoto")
      }), /* @__PURE__ */ jsx("button", {
        className: "capture-button",
        onClick: handleManualCapture,
        children: /* @__PURE__ */ jsx("img", {
          src: captureButton,
          alt: "capture button"
        })
      })]
    }), /* @__PURE__ */ jsxs(WebcamDesktopContainer, {
      className: "webcam-container",
      children: [/* @__PURE__ */ jsx(FaceMask$1, {
        className: "face-mask-container",
        isCapturing: isSuccess,
        isLoading,
        error: isError,
        isUploading: isNotCapturing,
        children: /* @__PURE__ */ jsx(FaceFrame$1, {
          src: faceFrame$1,
          alt: "face frame",
          className: classNames({
            hidden: hideCamera
          }, "face-frame")
        })
      }), /* @__PURE__ */ jsx(WebcamWithChooseCamera, {
        ref: webcam,
        videoSource: "user",
        onPlay: startAutoDetect,
        isSelfie: true,
        className: classNames("video__selfie", {
          hidden: hideCamera
        }),
        onError,
        onBoarding
      }), notification && /* @__PURE__ */ jsx(Notification, {
        className: "notification-container",
        isLoading,
        isError,
        children: notification
      }), shouldShowManualCapture && /* @__PURE__ */ jsx(CaptureButtonContainer, {
        className: "capture-button-container",
        initial: {
          scale: 0
        },
        animate: {
          scale: 1
        },
        children: /* @__PURE__ */ jsx("button", {
          onClick: handleManualCapture,
          children: /* @__PURE__ */ jsx("img", {
            src: captureButton,
            alt: "capture button"
          })
        })
      })]
    }), /* @__PURE__ */ jsx("canvas", {
      id: "canvasFrame",
      hidden: true
    })]
  });
}
function renderLoginDesktop(element, {
  onSuccess,
  onError,
  timeout,
  stopAtAccessDenied
}) {
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element),
    onBoarding: this,
    timeout,
    stopAtAccessDenied
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(LoginDesktop, __spreadValues({}, props))
  }), element);
}
async function identify({ base64Image, faceCoordinates }) {
  return api.post("/omni/oneToN/identify", {
    selfie: {
      base64Image: await encryptImage(base64Image),
      faceCoordinates
    }
  }).then((response) => response.data).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
async function OneToOneIdentify({ base64Image, phone: phone2 }) {
  return api.post("omni/1to1/identify", {
    phone: phone2,
    selfie: {
      base64Image: await encryptImage(base64Image)
    }
  }).then((response) => response.data).catch((e2) => {
    var _a;
    return Promise.reject((_a = e2 == null ? void 0 : e2.response) == null ? void 0 : _a.data);
  });
}
const addCurpUrl = `/omni/add/curp`;
function addCurp(curp, token) {
  return api.post(addCurpUrl, { curp }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
const addCurpv2Url = `/omni/add/curp/v2`;
function addCurpv2(data2, token) {
  return api.post(addCurpv2Url, data2, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
var isHTMLElement = (value) => value instanceof HTMLElement;
const EVENTS = {
  BLUR: "blur",
  CHANGE: "change",
  INPUT: "input"
};
const VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
const SELECT = "select";
const UNDEFINED = "undefined";
const INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
function attachEventListeners({ ref }, shouldAttachChangeEvent, handleChange) {
  if (isHTMLElement(ref) && handleChange) {
    ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
    ref.addEventListener(EVENTS.BLUR, handleChange);
  }
}
var isNullOrUndefined = (value) => value == null;
const isObjectType = (value) => typeof value === "object";
var isObject$1 = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);
var isKey = (value) => /^\w*$/.test(value);
var compact = (value) => value.filter(Boolean);
var stringToPath = (input) => compact(input.replace(/["|']/g, "").replace(/\[/g, ".").replace(/\]/g, "").split("."));
function set(object, path2, value) {
  let index2 = -1;
  const tempPath = isKey(path2) ? [path2] : stringToPath(path2);
  const length = tempPath.length;
  const lastIndex = length - 1;
  while (++index2 < length) {
    const key = tempPath[index2];
    let newValue = value;
    if (index2 !== lastIndex) {
      const objValue = object[key];
      newValue = isObject$1(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index2 + 1]) ? [] : {};
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
}
var transformToNestObject = (data2, value = {}) => {
  for (const key in data2) {
    !isKey(key) ? set(value, key, data2[key]) : value[key] = data2[key];
  }
  return value;
};
var isUndefined = (val) => val === void 0;
var get = (obj = {}, path2, defaultValue) => {
  const result2 = compact(path2.split(/[,[\].]+?/)).reduce((result3, key) => isNullOrUndefined(result3) ? result3 : result3[key], obj);
  return isUndefined(result2) || result2 === obj ? isUndefined(obj[path2]) ? defaultValue : obj[path2] : result2;
};
var focusOnErrorField = (fields, fieldErrors) => {
  for (const key in fields) {
    if (get(fieldErrors, key)) {
      const field = fields[key];
      if (field) {
        if (field.ref.focus && isUndefined(field.ref.focus())) {
          break;
        } else if (field.options) {
          field.options[0].ref.focus();
          break;
        }
      }
    }
  }
};
var removeAllEventListeners = (ref, validateWithStateUpdate) => {
  if (isHTMLElement(ref) && ref.removeEventListener) {
    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
  }
};
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = (options) => Array.isArray(options) ? options.reduce((previous, option) => option && option.ref.checked ? {
  isValid: true,
  value: option.ref.value
} : previous, defaultReturn) : defaultReturn;
var getMultipleSelectValue = (options) => [...options].filter(({ selected }) => selected).map(({ value }) => value);
var isRadioInput = (element) => element.type === "radio";
var isFileInput = (element) => element.type === "file";
var isCheckBoxInput = (element) => element.type === "checkbox";
var isMultipleSelect = (element) => element.type === `${SELECT}-multiple`;
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values = options.filter((option) => option && option.ref.checked).map(({ ref: { value: value2 } }) => value2);
      return { value: values, isValid: !!values.length };
    }
    const { checked, value, attributes } = options[0].ref;
    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === "" ? validResult : { value, isValid: true } : validResult : defaultResult;
  }
  return defaultResult;
};
function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
  const field = fieldsRef.current[name];
  if (field) {
    const { ref: { value, disabled }, ref, valueAsNumber, valueAsDate, setValueAs } = field;
    if (disabled && excludeDisabled) {
      return;
    }
    if (isFileInput(ref)) {
      return ref.files;
    }
    if (isRadioInput(ref)) {
      return getRadioValue(field.options).value;
    }
    if (isMultipleSelect(ref)) {
      return getMultipleSelectValue(ref.options);
    }
    if (isCheckBoxInput(ref)) {
      return getCheckboxValue(field.options).value;
    }
    return shouldKeepRawValue ? value : valueAsNumber ? value === "" ? NaN : +value : valueAsDate ? ref.valueAsDate : setValueAs ? setValueAs(value) : value;
  }
  if (shallowFieldsStateRef) {
    return get(shallowFieldsStateRef.current, name);
  }
}
function isDetached(element) {
  if (!element) {
    return true;
  }
  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
    return false;
  }
  return isDetached(element.parentNode);
}
var isEmptyObject = (value) => isObject$1(value) && !Object.keys(value).length;
var isBoolean = (value) => typeof value === "boolean";
function baseGet(object, updatePath) {
  const length = updatePath.slice(0, -1).length;
  let index2 = 0;
  while (index2 < length) {
    object = isUndefined(object) ? index2++ : object[updatePath[index2++]];
  }
  return object;
}
function unset(object, path2) {
  const updatePath = isKey(path2) ? [path2] : stringToPath(path2);
  const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
  const key = updatePath[updatePath.length - 1];
  let previousObjRef;
  if (childObject) {
    delete childObject[key];
  }
  for (let k3 = 0; k3 < updatePath.slice(0, -1).length; k3++) {
    let index2 = -1;
    let objectRef;
    const currentPaths = updatePath.slice(0, -(k3 + 1));
    const currentPathsLength = currentPaths.length - 1;
    if (k3 > 0) {
      previousObjRef = object;
    }
    while (++index2 < currentPaths.length) {
      const item = currentPaths[index2];
      objectRef = objectRef ? objectRef[item] : object[item];
      if (currentPathsLength === index2 && (isObject$1(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter((data2) => isObject$1(data2) && !isEmptyObject(data2) || isBoolean(data2)).length)) {
        previousObjRef ? delete previousObjRef[item] : delete object[item];
      }
      previousObjRef = objectRef;
    }
  }
  return object;
}
const isSameRef = (fieldValue, ref) => fieldValue && fieldValue.ref === ref;
function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
  const { ref, ref: { name } } = field;
  const fieldRef = fieldsRef.current[name];
  if (!shouldUnregister) {
    const value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
    !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
  }
  if (!ref.type || !fieldRef) {
    delete fieldsRef.current[name];
    return;
  }
  if (isRadioInput(ref) || isCheckBoxInput(ref)) {
    if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
      compact(fieldRef.options).forEach((option = {}, index2) => {
        if (isDetached(option.ref) && isSameRef(option, option.ref) || forceDelete) {
          removeAllEventListeners(option.ref, handleChange);
          unset(fieldRef.options, `[${index2}]`);
        }
      });
      if (fieldRef.options && !compact(fieldRef.options).length) {
        delete fieldsRef.current[name];
      }
    } else {
      delete fieldsRef.current[name];
    }
  } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
    removeAllEventListeners(ref, handleChange);
    delete fieldsRef.current[name];
  }
}
var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
function deepMerge(target, source2) {
  if (isPrimitive(target) || isPrimitive(source2)) {
    return source2;
  }
  for (const key in source2) {
    const targetValue = target[key];
    const sourceValue = source2[key];
    try {
      target[key] = isObject$1(targetValue) && isObject$1(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
    } catch (_a) {
    }
  }
  return target;
}
function deepEqual(object1, object2, isErrorObject) {
  if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
    return object1 === object2;
  }
  if (!isValidElement(object1)) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      if (!(isErrorObject && key === "ref")) {
        const val2 = object2[key];
        if ((isObject$1(val1) || Array.isArray(val1)) && (isObject$1(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
          return false;
        }
      }
    }
  }
  return true;
}
function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
  let index2 = -1;
  while (++index2 < values.length) {
    for (const key in values[index2]) {
      if (Array.isArray(values[index2][key])) {
        !dirtyFields[index2] && (dirtyFields[index2] = {});
        dirtyFields[index2][key] = [];
        setDirtyFields(values[index2][key], get(defaultValues[index2] || {}, key, []), dirtyFields[index2][key], dirtyFields[index2], key);
      } else {
        deepEqual(get(defaultValues[index2] || {}, key), values[index2][key]) ? set(dirtyFields[index2] || {}, key) : dirtyFields[index2] = Object.assign(Object.assign({}, dirtyFields[index2]), { [key]: true });
      }
    }
    parentNode && !dirtyFields.length && delete parentNode[parentName];
  }
  return dirtyFields;
}
var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));
var isString = (value) => typeof value === "string";
var getFieldsValues = (fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) => {
  const output2 = {};
  for (const name in fieldsRef.current) {
    if (isUndefined(search) || (isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find((data2) => name.startsWith(data2)))) {
      output2[name] = getFieldValue(fieldsRef, name, void 0, excludeDisabled);
    }
  }
  return shouldUnregister ? transformToNestObject(output2) : deepMerge(shallowFieldsState, transformToNestObject(output2));
};
var isErrorStateChanged = ({ errors, name, error: error3, validFields, fieldsWithValidation }) => {
  const isValid = isUndefined(error3);
  const previousError = get(errors, name);
  return isValid && !!previousError || !isValid && !deepEqual(previousError, error3, true) || isValid && get(fieldsWithValidation, name) && !get(validFields, name);
};
var isRegex = (value) => value instanceof RegExp;
var getValueAndMessage = (validationData) => isObject$1(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ""
};
var isFunction = (value) => typeof value === "function";
var isMessage = (value) => isString(value) || isValidElement(value);
function getValidateError(result2, ref, type = "validate") {
  if (isMessage(result2) || isBoolean(result2) && !result2) {
    return {
      type,
      message: isMessage(result2) ? result2 : "",
      ref
    };
  }
}
var appendErrors = (name, validateAllFieldCriteria, errors, type, message2) => validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), { [type]: message2 || true }) }) : {};
var validateField = async (fieldsRef, validateAllFieldCriteria, { ref, ref: { value }, options, required, maxLength, minLength, min: min2, max: max2, pattern, validate }, shallowFieldsStateRef) => {
  const name = ref.name;
  const error3 = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox = isRadio || isCheckBox;
  const isEmpty = value === "";
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error3);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message2 = exceedMax ? maxLengthMessage : minLengthMessage;
    error3[name] = Object.assign({
      type: exceedMax ? maxType : minType,
      message: message2,
      ref
    }, exceedMax ? appendErrorsCurry(maxType, message2) : appendErrorsCurry(minType, message2));
  };
  if (required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid)) {
    const { value: value2, message: message2 } = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required);
    if (value2) {
      error3[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message: message2, ref: isRadioOrCheckbox ? ((fieldsRef.current[name].options || [])[0] || {}).ref : ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message2));
      if (!validateAllFieldCriteria) {
        return error3;
      }
    }
  }
  if ((!isNullOrUndefined(min2) || !isNullOrUndefined(max2)) && value !== "") {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max2);
    const minOutput = getValueAndMessage(min2);
    if (!isNaN(value)) {
      const valueNumber = ref.valueAsNumber || parseFloat(value);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(value);
      if (isString(maxOutput.value)) {
        exceedMax = valueDate > new Date(maxOutput.value);
      }
      if (isString(minOutput.value)) {
        exceedMin = valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        return error3;
      }
    }
  }
  if (isString(value) && !isEmpty && (maxLength || minLength)) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && value.length > maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && value.length < minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        return error3;
      }
    }
  }
  if (isString(value) && pattern && !isEmpty) {
    const { value: patternValue, message: message2 } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !patternValue.test(value)) {
      error3[name] = Object.assign({
        type: INPUT_VALIDATION_RULES.pattern,
        message: message2,
        ref
      }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message2));
      if (!validateAllFieldCriteria) {
        return error3;
      }
    }
  }
  if (validate) {
    const fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
    const validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;
    if (isFunction(validate)) {
      const result2 = await validate(fieldValue);
      const validateError = getValidateError(result2, validateRef);
      if (validateError) {
        error3[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
        if (!validateAllFieldCriteria) {
          return error3;
        }
      }
    } else if (isObject$1(validate)) {
      let validationResult = {};
      for (const [key, validateFunction] of Object.entries(validate)) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateResult = await validateFunction(fieldValue);
        const validateError = getValidateError(validateResult, validateRef, key);
        if (validateError) {
          validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
          if (validateAllFieldCriteria) {
            error3[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error3[name] = Object.assign({ ref: validateRef }, validationResult);
        if (!validateAllFieldCriteria) {
          return error3;
        }
      }
    }
  }
  return error3;
};
const getPath = (rootPath, values, paths = []) => {
  for (const property in values) {
    const rootName = rootPath + (isObject$1(values) ? `.${property}` : `[${property}]`);
    isPrimitive(values[property]) ? paths.push(rootName) : getPath(rootName, values[property], paths);
  }
  return paths;
};
var assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField) => {
  let value = void 0;
  watchFields.add(fieldName);
  if (!isEmptyObject(fieldValues)) {
    value = get(fieldValues, fieldName);
    if (isObject$1(value) || Array.isArray(value)) {
      getPath(fieldName, value).forEach((name) => watchFields.add(name));
    }
  }
  return isUndefined(value) ? isSingleField ? inputValue : get(inputValue, fieldName) : value;
};
var skipValidation = ({ isOnBlur, isOnChange, isOnTouch, isTouched, isReValidateOnBlur, isReValidateOnChange, isBlurEvent, isSubmitted, isOnAll }) => {
  if (isOnAll) {
    return false;
  } else if (!isSubmitted && isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var getFieldArrayParentName = (name) => name.substring(0, name.indexOf("["));
const isMatchFieldArrayName = (name, searchName) => RegExp(`^${searchName}([|.)\\d+`.replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(name);
var isNameInFieldArray = (names2, name) => [...names2].some((current) => isMatchFieldArrayName(name, current));
var isSelectInput = (element) => element.type === `${SELECT}-one`;
function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
  const observer = new MutationObserver(() => {
    for (const field of Object.values(fieldsRef.current)) {
      if (field && field.options) {
        for (const option of field.options) {
          if (option && option.ref && isDetached(option.ref)) {
            removeFieldEventListenerAndRef(field);
          }
        }
      } else if (field && isDetached(field.ref)) {
        removeFieldEventListenerAndRef(field);
      }
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}
var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;
function cloneObject(data2) {
  var _a;
  let copy2;
  if (isPrimitive(data2) || isWeb && (data2 instanceof File || isHTMLElement(data2))) {
    return data2;
  }
  if (!["Set", "Map", "Object", "Date", "Array"].includes((_a = data2.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
    return data2;
  }
  if (data2 instanceof Date) {
    copy2 = new Date(data2.getTime());
    return copy2;
  }
  if (data2 instanceof Set) {
    copy2 = /* @__PURE__ */ new Set();
    for (const item of data2) {
      copy2.add(item);
    }
    return copy2;
  }
  if (data2 instanceof Map) {
    copy2 = /* @__PURE__ */ new Map();
    for (const key of data2.keys()) {
      copy2.set(key, cloneObject(data2.get(key)));
    }
    return copy2;
  }
  copy2 = Array.isArray(data2) ? [] : {};
  for (const key in data2) {
    copy2[key] = cloneObject(data2[key]);
  }
  return copy2;
}
var modeChecker = (mode2) => ({
  isOnSubmit: !mode2 || mode2 === VALIDATION_MODE.onSubmit,
  isOnBlur: mode2 === VALIDATION_MODE.onBlur,
  isOnChange: mode2 === VALIDATION_MODE.onChange,
  isOnAll: mode2 === VALIDATION_MODE.all,
  isOnTouch: mode2 === VALIDATION_MODE.onTouched
});
var isRadioOrCheckboxFunction = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);
const isWindowUndefined = typeof window === UNDEFINED;
const isProxyEnabled = isWeb ? "Proxy" in window : typeof Proxy !== UNDEFINED;
function useForm({ mode: mode2 = VALIDATION_MODE.onSubmit, reValidateMode = VALIDATION_MODE.onChange, resolver, context: context2, defaultValues = {}, shouldFocusError = true, shouldUnregister = true, criteriaMode } = {}) {
  const fieldsRef = useRef({});
  const fieldArrayDefaultValuesRef = useRef({});
  const fieldArrayValuesRef = useRef({});
  const watchFieldsRef = useRef(/* @__PURE__ */ new Set());
  const useWatchFieldsRef = useRef({});
  const useWatchRenderFunctionsRef = useRef({});
  const fieldsWithValidationRef = useRef({});
  const validFieldsRef = useRef({});
  const defaultValuesRef = useRef(defaultValues);
  const isUnMount = useRef(false);
  const isWatchAllRef = useRef(false);
  const handleChangeRef = useRef();
  const shallowFieldsStateRef = useRef({});
  const resetFieldArrayFunctionRef = useRef({});
  const contextRef = useRef(context2);
  const resolverRef = useRef(resolver);
  const fieldArrayNamesRef = useRef(/* @__PURE__ */ new Set());
  const modeRef = useRef(modeChecker(mode2));
  const { isOnSubmit, isOnTouch } = modeRef.current;
  const isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;
  const [formState, setFormState] = useState({
    isDirty: false,
    isValidating: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touched: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: !isOnSubmit,
    errors: {}
  });
  const readFormStateRef = useRef({
    isDirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    touched: !isProxyEnabled || isOnTouch,
    isValidating: !isProxyEnabled,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  });
  const formStateRef = useRef(formState);
  const observerRef = useRef();
  const { isOnBlur: isReValidateOnBlur, isOnChange: isReValidateOnChange } = useRef(modeChecker(reValidateMode)).current;
  contextRef.current = context2;
  resolverRef.current = resolver;
  formStateRef.current = formState;
  shallowFieldsStateRef.current = shouldUnregister ? {} : isEmptyObject(shallowFieldsStateRef.current) ? cloneObject(defaultValues) : shallowFieldsStateRef.current;
  const updateFormState = useCallback((state2 = {}) => {
    if (!isUnMount.current) {
      formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state2);
      setFormState(formStateRef.current);
    }
  }, []);
  const updateIsValidating = () => readFormStateRef.current.isValidating && updateFormState({
    isValidating: true
  });
  const shouldRenderBaseOnError = useCallback((name, error3, shouldRender = false, state2 = {}, isValid) => {
    let shouldReRender = shouldRender || isErrorStateChanged({
      errors: formStateRef.current.errors,
      error: error3,
      name,
      validFields: validFieldsRef.current,
      fieldsWithValidation: fieldsWithValidationRef.current
    });
    const previousError = get(formStateRef.current.errors, name);
    if (error3) {
      unset(validFieldsRef.current, name);
      shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error3, true);
      set(formStateRef.current.errors, name, error3);
    } else {
      if (get(fieldsWithValidationRef.current, name) || resolverRef.current) {
        set(validFieldsRef.current, name, true);
        shouldReRender = shouldReRender || previousError;
      }
      unset(formStateRef.current.errors, name);
    }
    if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state2) || readFormStateRef.current.isValidating) {
      updateFormState(Object.assign(Object.assign(Object.assign({}, state2), resolverRef.current ? { isValid: !!isValid } : {}), { isValidating: false }));
    }
  }, []);
  const setFieldValue = useCallback((name, rawValue) => {
    const { ref, options } = fieldsRef.current[name];
    const value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? "" : rawValue;
    if (isRadioInput(ref)) {
      (options || []).forEach(({ ref: radioRef }) => radioRef.checked = radioRef.value === value);
    } else if (isFileInput(ref) && !isString(value)) {
      ref.files = value;
    } else if (isMultipleSelect(ref)) {
      [...ref.options].forEach((selectRef) => selectRef.selected = value.includes(selectRef.value));
    } else if (isCheckBoxInput(ref) && options) {
      options.length > 1 ? options.forEach(({ ref: checkboxRef }) => checkboxRef.checked = Array.isArray(value) ? !!value.find((data2) => data2 === checkboxRef.value) : value === checkboxRef.value) : options[0].ref.checked = !!value;
    } else {
      ref.value = value;
    }
  }, []);
  const isFormDirty = useCallback((name, data2) => {
    if (readFormStateRef.current.isDirty) {
      const formValues = getValues();
      name && data2 && set(formValues, name, data2);
      return !deepEqual(formValues, defaultValuesRef.current);
    }
    return false;
  }, []);
  const updateAndGetDirtyState = useCallback((name, shouldRender = true) => {
    if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
      const isFieldDirty = !deepEqual(get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
      const isDirtyFieldExist = get(formStateRef.current.dirtyFields, name);
      const previousIsDirty = formStateRef.current.isDirty;
      isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
      const state2 = {
        isDirty: isFormDirty(),
        dirtyFields: formStateRef.current.dirtyFields
      };
      const isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state2.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== get(formStateRef.current.dirtyFields, name);
      isChanged && shouldRender && updateFormState(state2);
      return isChanged ? state2 : {};
    }
    return {};
  }, []);
  const executeValidation = useCallback(async (name, skipReRender) => {
    const error3 = (await validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef))[name];
    shouldRenderBaseOnError(name, error3, skipReRender);
    return isUndefined(error3);
  }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  const executeSchemaOrResolverValidation = useCallback(async (names2) => {
    const { errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
    const previousFormIsValid = formStateRef.current.isValid;
    if (Array.isArray(names2)) {
      const isInputsValid = names2.map((name) => {
        const error3 = get(errors, name);
        error3 ? set(formStateRef.current.errors, name, error3) : unset(formStateRef.current.errors, name);
        return !error3;
      }).every(Boolean);
      updateFormState({
        isValid: isEmptyObject(errors),
        isValidating: false
      });
      return isInputsValid;
    } else {
      const error3 = get(errors, names2);
      shouldRenderBaseOnError(names2, error3, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
      return !error3;
    }
  }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  const trigger = useCallback(async (name) => {
    const fields = name || Object.keys(fieldsRef.current);
    updateIsValidating();
    if (resolverRef.current) {
      return executeSchemaOrResolverValidation(fields);
    }
    if (Array.isArray(fields)) {
      !name && (formStateRef.current.errors = {});
      const result2 = await Promise.all(fields.map(async (data2) => await executeValidation(data2, null)));
      updateFormState({
        isValidating: false
      });
      return result2.every(Boolean);
    }
    return await executeValidation(fields);
  }, [executeSchemaOrResolverValidation, executeValidation]);
  const setInternalValues = useCallback((name, value, { shouldDirty, shouldValidate }) => {
    const data2 = {};
    set(data2, name, value);
    for (const fieldName of getPath(name, value)) {
      if (fieldsRef.current[fieldName]) {
        setFieldValue(fieldName, get(data2, fieldName));
        shouldDirty && updateAndGetDirtyState(fieldName);
        shouldValidate && trigger(fieldName);
      }
    }
  }, [trigger, setFieldValue, updateAndGetDirtyState]);
  const setInternalValue = useCallback((name, value, config2) => {
    !shouldUnregister && !isPrimitive(value) && set(shallowFieldsStateRef.current, name, Array.isArray(value) ? [...value] : Object.assign({}, value));
    if (fieldsRef.current[name]) {
      setFieldValue(name, value);
      config2.shouldDirty && updateAndGetDirtyState(name);
      config2.shouldValidate && trigger(name);
    } else if (!isPrimitive(value)) {
      setInternalValues(name, value, config2);
      if (fieldArrayNamesRef.current.has(name)) {
        const parentName = getFieldArrayParentName(name) || name;
        set(fieldArrayDefaultValuesRef.current, name, value);
        resetFieldArrayFunctionRef.current[parentName]({
          [parentName]: get(fieldArrayDefaultValuesRef.current, parentName)
        });
        if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config2.shouldDirty) {
          set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
          updateFormState({
            isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), { [name]: value }), defaultValuesRef.current)
          });
        }
      }
    }
    !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
  }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);
  const isFieldWatched = (name) => isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
  const renderWatchedInputs = (name) => {
    let found = true;
    if (!isEmptyObject(useWatchFieldsRef.current)) {
      for (const key in useWatchFieldsRef.current) {
        if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
          useWatchRenderFunctionsRef.current[key]();
          found = false;
        }
      }
    }
    return found;
  };
  function setValue(name, value, config2) {
    setInternalValue(name, value, config2 || {});
    isFieldWatched(name) && updateFormState();
    renderWatchedInputs(name);
  }
  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : async ({ type, target }) => {
    let name = target.name;
    const field = fieldsRef.current[name];
    let error3;
    let isValid;
    if (field) {
      const isBlurEvent = type === EVENTS.BLUR;
      const shouldSkipValidation = skipValidation(Object.assign({
        isBlurEvent,
        isReValidateOnChange,
        isReValidateOnBlur,
        isTouched: !!get(formStateRef.current.touched, name),
        isSubmitted: formStateRef.current.isSubmitted
      }, modeRef.current));
      let state2 = updateAndGetDirtyState(name, false);
      let shouldRender = !isEmptyObject(state2) || !isBlurEvent && isFieldWatched(name);
      if (isBlurEvent && !get(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
        set(formStateRef.current.touched, name, true);
        state2 = Object.assign(Object.assign({}, state2), { touched: formStateRef.current.touched });
      }
      if (!shouldUnregister && isCheckBoxInput(target)) {
        set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
      }
      if (shouldSkipValidation) {
        !isBlurEvent && renderWatchedInputs(name);
        return (!isEmptyObject(state2) || shouldRender && isEmptyObject(state2)) && updateFormState(state2);
      }
      updateIsValidating();
      if (resolverRef.current) {
        const { errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
        const previousFormIsValid = formStateRef.current.isValid;
        error3 = get(errors, name);
        if (isCheckBoxInput(target) && !error3 && resolverRef.current) {
          const parentNodeName = getFieldArrayParentName(name);
          const currentError = get(errors, parentNodeName, {});
          currentError.type && currentError.message && (error3 = currentError);
          if (parentNodeName && (currentError || get(formStateRef.current.errors, parentNodeName))) {
            name = parentNodeName;
          }
        }
        isValid = isEmptyObject(errors);
        previousFormIsValid !== isValid && (shouldRender = true);
      } else {
        error3 = (await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef))[name];
      }
      !isBlurEvent && renderWatchedInputs(name);
      shouldRenderBaseOnError(name, error3, shouldRender, state2, isValid);
    }
  };
  function setFieldArrayDefaultValues(data2) {
    if (!shouldUnregister) {
      let copy2 = cloneObject(data2);
      for (const value of fieldArrayNamesRef.current) {
        if (isKey(value) && !copy2[value]) {
          copy2 = Object.assign(Object.assign({}, copy2), { [value]: [] });
        }
      }
      return copy2;
    }
    return data2;
  }
  function getValues(payload) {
    if (isString(payload)) {
      return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
    }
    if (Array.isArray(payload)) {
      const data2 = {};
      for (const name of payload) {
        set(data2, name, getFieldValue(fieldsRef, name, shallowFieldsStateRef));
      }
      return data2;
    }
    return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
  }
  const validateResolver = useCallback(async (values = {}) => {
    const newDefaultValues = isEmptyObject(fieldsRef.current) ? defaultValuesRef.current : {};
    const { errors } = await resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria) || {};
    const isValid = isEmptyObject(errors);
    formStateRef.current.isValid !== isValid && updateFormState({
      isValid
    });
  }, [isValidateAllFieldCriteria]);
  const removeFieldEventListener = useCallback((field, forceDelete) => {
    findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);
    if (shouldUnregister) {
      unset(validFieldsRef.current, field.ref.name);
      unset(fieldsWithValidationRef.current, field.ref.name);
    }
  }, [shouldUnregister]);
  const updateWatchedValue = useCallback((name) => {
    if (isWatchAllRef.current) {
      updateFormState();
    } else {
      for (const watchField of watchFieldsRef.current) {
        if (watchField.startsWith(name)) {
          updateFormState();
          break;
        }
      }
      renderWatchedInputs(name);
    }
  }, []);
  const removeFieldEventListenerAndRef = useCallback((field, forceDelete) => {
    if (field) {
      removeFieldEventListener(field, forceDelete);
      if (shouldUnregister && !compact(field.options || []).length) {
        unset(formStateRef.current.errors, field.ref.name);
        set(formStateRef.current.dirtyFields, field.ref.name, true);
        updateFormState({
          isDirty: isFormDirty()
        });
        readFormStateRef.current.isValid && resolverRef.current && validateResolver();
        updateWatchedValue(field.ref.name);
      }
    }
  }, [validateResolver, removeFieldEventListener]);
  function clearErrors(name) {
    name && (Array.isArray(name) ? name : [name]).forEach((inputName) => fieldsRef.current[inputName] && isKey(inputName) ? delete formStateRef.current.errors[inputName] : unset(formStateRef.current.errors, inputName));
    updateFormState({
      errors: name ? formStateRef.current.errors : {}
    });
  }
  function setError(name, error3) {
    const ref = (fieldsRef.current[name] || {}).ref;
    set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error3), { ref }));
    updateFormState({
      isValid: false
    });
    error3.shouldFocus && ref && ref.focus && ref.focus();
  }
  const watchInternal = useCallback((fieldNames, defaultValue, watchId) => {
    const watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
    let fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);
    if (isString(fieldNames)) {
      const parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;
      if (fieldArrayNamesRef.current.has(parentNodeName)) {
        fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
      }
      return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(get(defaultValuesRef.current, fieldNames)) ? defaultValue : get(defaultValuesRef.current, fieldNames), true);
    }
    const combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;
    if (Array.isArray(fieldNames)) {
      return fieldNames.reduce((previous, name) => Object.assign(Object.assign({}, previous), { [name]: assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues) }), {});
    }
    isWatchAllRef.current = isUndefined(watchId);
    return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
  }, []);
  function watch(fieldNames, defaultValue) {
    return watchInternal(fieldNames, defaultValue);
  }
  function unregister(name) {
    for (const fieldName of Array.isArray(name) ? name : [name]) {
      removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
    }
  }
  function registerFieldRef(ref, options = {}) {
    const { name, type, value } = ref;
    const fieldRefAndValidationOptions = Object.assign({ ref }, options);
    const fields = fieldsRef.current;
    const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
    const isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);
    const compareRef = (currentRef) => isWeb && (!isHTMLElement(ref) || currentRef === ref);
    let field = fields[name];
    let isEmptyDefaultValue = true;
    let defaultValue;
    if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find((option) => {
      return value === option.ref.value && compareRef(option.ref);
    }) : compareRef(field.ref))) {
      fields[name] = Object.assign(Object.assign({}, field), options);
      return;
    }
    if (type) {
      field = isRadioOrCheckbox ? Object.assign({ options: [
        ...compact(field && field.options || []),
        {
          ref
        }
      ], ref: { type, name } }, options) : Object.assign({}, fieldRefAndValidationOptions);
    } else {
      field = fieldRefAndValidationOptions;
    }
    fields[name] = field;
    const isEmptyUnmountFields = isUndefined(get(shallowFieldsStateRef.current, name));
    if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
      defaultValue = get(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
      isEmptyDefaultValue = isUndefined(defaultValue);
      if (!isEmptyDefaultValue && !isFieldArray) {
        setFieldValue(name, defaultValue);
      }
    }
    if (!isEmptyObject(options)) {
      set(fieldsWithValidationRef.current, name, true);
      if (!isOnSubmit && readFormStateRef.current.isValid) {
        validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then((error3) => {
          const previousFormIsValid = formStateRef.current.isValid;
          isEmptyObject(error3) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
          previousFormIsValid !== isEmptyObject(error3) && updateFormState();
        });
      }
    }
    if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
      !isFieldArray && unset(formStateRef.current.dirtyFields, name);
    }
    if (type) {
      attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
    }
  }
  function register(refOrRegisterOptions, options) {
    if (!isWindowUndefined) {
      if (isString(refOrRegisterOptions)) {
        registerFieldRef({ name: refOrRegisterOptions }, options);
      } else if (isObject$1(refOrRegisterOptions) && "name" in refOrRegisterOptions) {
        registerFieldRef(refOrRegisterOptions, options);
      } else {
        return (ref) => ref && registerFieldRef(ref, refOrRegisterOptions);
      }
    }
  }
  const handleSubmit = useCallback((onValid, onInvalid) => async (e2) => {
    if (e2 && e2.preventDefault) {
      e2.preventDefault();
      e2.persist();
    }
    let fieldErrors = {};
    let fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
    readFormStateRef.current.isSubmitting && updateFormState({
      isSubmitting: true
    });
    try {
      if (resolverRef.current) {
        const { errors, values } = await resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);
        formStateRef.current.errors = fieldErrors = errors;
        fieldValues = values;
      } else {
        for (const field of Object.values(fieldsRef.current)) {
          if (field) {
            const { name } = field.ref;
            const fieldError = await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);
            if (fieldError[name]) {
              set(fieldErrors, name, fieldError[name]);
              unset(validFieldsRef.current, name);
            } else if (get(fieldsWithValidationRef.current, name)) {
              unset(formStateRef.current.errors, name);
              set(validFieldsRef.current, name, true);
            }
          }
        }
      }
      if (isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every((name) => name in fieldsRef.current)) {
        updateFormState({
          errors: {},
          isSubmitting: true
        });
        await onValid(fieldValues, e2);
      } else {
        formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
        onInvalid && await onInvalid(formStateRef.current.errors, e2);
        shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);
      }
    } finally {
      formStateRef.current.isSubmitting = false;
      updateFormState({
        isSubmitted: true,
        isSubmitting: false,
        isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
        submitCount: formStateRef.current.submitCount + 1
      });
    }
  }, [shouldFocusError, isValidateAllFieldCriteria]);
  const resetRefs = ({ errors, isDirty, isSubmitted, touched, isValid, submitCount, dirtyFields }) => {
    if (!isValid) {
      validFieldsRef.current = {};
      fieldsWithValidationRef.current = {};
    }
    fieldArrayDefaultValuesRef.current = {};
    watchFieldsRef.current = /* @__PURE__ */ new Set();
    isWatchAllRef.current = false;
    updateFormState({
      submitCount: submitCount ? formStateRef.current.submitCount : 0,
      isDirty: isDirty ? formStateRef.current.isDirty : false,
      isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
      isValid: isValid ? formStateRef.current.isValid : false,
      dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
      touched: touched ? formStateRef.current.touched : {},
      errors: errors ? formStateRef.current.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };
  const reset = (values, omitResetState = {}) => {
    if (isWeb) {
      for (const field of Object.values(fieldsRef.current)) {
        if (field) {
          const { ref, options } = field;
          const inputRef = isRadioOrCheckboxFunction(ref) && Array.isArray(options) ? options[0].ref : ref;
          if (isHTMLElement(inputRef)) {
            try {
              inputRef.closest("form").reset();
              break;
            } catch (_a) {
            }
          }
        }
      }
    }
    fieldsRef.current = {};
    defaultValuesRef.current = Object.assign({}, values || defaultValuesRef.current);
    values && renderWatchedInputs("");
    Object.values(resetFieldArrayFunctionRef.current).forEach((resetFieldArray) => isFunction(resetFieldArray) && resetFieldArray());
    shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values || defaultValuesRef.current);
    resetRefs(omitResetState);
  };
  useEffect(() => {
    resolver && readFormStateRef.current.isValid && validateResolver();
    observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
  }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
  useEffect(() => () => {
    observerRef.current && observerRef.current.disconnect();
    isUnMount.current = true;
    Object.values(fieldsRef.current).forEach((field) => removeFieldEventListenerAndRef(field, true));
  }, []);
  if (!resolver && readFormStateRef.current.isValid) {
    formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
  }
  const commonProps = {
    trigger,
    setValue: useCallback(setValue, [setInternalValue, trigger]),
    getValues: useCallback(getValues, []),
    register: useCallback(register, [defaultValuesRef.current]),
    unregister: useCallback(unregister, []),
    formState: isProxyEnabled ? new Proxy(formState, {
      get: (obj, prop) => {
        if (prop in obj) {
          readFormStateRef.current[prop] = true;
          return obj[prop];
        }
        return void 0;
      }
    }) : formState
  };
  const control2 = useMemo(() => Object.assign({
    isFormDirty,
    updateWatchedValue,
    shouldUnregister,
    updateFormState,
    removeFieldEventListener,
    watchInternal,
    mode: modeRef.current,
    reValidateMode: {
      isReValidateOnBlur,
      isReValidateOnChange
    },
    validateResolver: resolver ? validateResolver : void 0,
    fieldsRef,
    resetFieldArrayFunctionRef,
    useWatchFieldsRef,
    useWatchRenderFunctionsRef,
    fieldArrayDefaultValuesRef,
    validFieldsRef,
    fieldsWithValidationRef,
    fieldArrayNamesRef,
    readFormStateRef,
    formStateRef,
    defaultValuesRef,
    shallowFieldsStateRef,
    fieldArrayValuesRef
  }, commonProps), [
    defaultValuesRef.current,
    updateWatchedValue,
    shouldUnregister,
    removeFieldEventListener,
    watchInternal
  ]);
  return Object.assign({
    watch,
    control: control2,
    handleSubmit,
    reset: useCallback(reset, []),
    clearErrors: useCallback(clearErrors, []),
    setError: useCallback(setError, []),
    errors: formState.errors
  }, commonProps);
}
const FormContext = createContext(null);
FormContext.displayName = "RHFContext";
var loadingLogo = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MyIgdmlld0JveD0iMCAwIDQzIDQzIj4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjMjAyNjNEIiBzdHJva2UtZGFzaGFycmF5PSIyLDMiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiIHN0cm9rZS13aWR0aD0iNSIgZD0iTTIxLjUgNDBDMzEuNzE3IDQwIDQwIDMxLjcxNyA0MCAyMS41UzMxLjcxNyAzIDIxLjUgMyAzIDExLjI4MyAzIDIxLjUgMTEuMjgzIDQwIDIxLjUgNDB6Ii8+Cjwvc3ZnPgo=";
var greenCheck = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOSIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDM5IDI4Ij4KICAgIDxwYXRoIGZpbGw9IiMwQ0Q1QTIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTM3Ljg1OCA2LjU3NEwxNy4yODQgMjYuODcyYTMuOTQxIDMuOTQxIDAgMCAxLTUuNTIgMGwtMTAuNjItMTAuNDhhMy44MTUgMy44MTUgMCAwIDEgMC01LjQ0NSAzLjk0IDMuOTQgMCAwIDEgNS41MTggMGw3Ljg2MiA3Ljc1NkwzMi4zMzcgMS4xMjhhMy45NDEgMy45NDEgMCAwIDEgNS41MiAwIDMuODE2IDMuODE2IDAgMCAxIDAgNS40NDZ6Ii8+Cjwvc3ZnPgo=";
var redStrike = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjVDNkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTI3LjA1NCA1LjUxNUwxOC41NyAxNGw4LjQ4NCA4LjQ4NGEzLjIzMSAzLjIzMSAwIDAgMS00LjU2OCA0LjU3TDE0IDE4LjU2OWwtOC40ODUgOC40ODVBMy4yMiAzLjIyIDAgMCAxIDMuMjMxIDI4YTMuMjMxIDMuMjMxIDAgMCAxLTIuMjg0LTUuNTE2TDkuNDMgMTQgLjk0NiA1LjUxNUEzLjIzIDMuMjMgMCAwIDEgNS41MTUuOTQ1TDE0IDkuNDMyIDIyLjQ4NS45NDZhMy4yMzEgMy4yMzEgMCAwIDEgNC41NjkgNC41Njl6Ii8+Cjwvc3ZnPgo=";
const states = [{
  value: "AS",
  label: "Aguascalientes"
}, {
  value: "BC",
  label: "Baja California"
}, {
  value: "BS",
  label: "Baja California Sur"
}, {
  value: "CC",
  label: "Campeche"
}, {
  value: "CL",
  label: "Coahuila de Zaragoza"
}, {
  value: "CM",
  label: "Colima"
}, {
  value: "CS",
  label: "Chiapas"
}, {
  value: "CH",
  label: "Chihuahua"
}, {
  value: "DF",
  label: "Distrito Federal"
}, {
  value: "DG",
  label: "Durango"
}, {
  value: "GT",
  label: "Guanajuato"
}, {
  value: "GR",
  label: "Guerrero"
}, {
  value: "HG",
  label: "Hidalgo"
}, {
  value: "JC",
  label: "Jalisco"
}, {
  value: "MC",
  label: "Estado de M\xE9xico"
}, {
  value: "MN",
  label: "Michoacan de Ocampo"
}, {
  value: "MS",
  label: "Morelos"
}, {
  value: "NT",
  label: "Nayarit"
}, {
  value: "NL",
  label: "Nuevo Le\xF3n"
}, {
  value: "OC",
  label: "Oaxaca"
}, {
  value: "PL",
  label: "Puebla"
}, {
  value: "QT",
  label: "Queretaro de Arteaga"
}, {
  value: "QR",
  label: "Quintana Roo"
}, {
  value: "SP",
  label: "San Luis Potosi"
}, {
  value: "SL",
  label: "Sinaloa"
}, {
  value: "SR",
  label: "Sonora"
}, {
  value: "TC",
  label: "Tabasco"
}, {
  value: "TS",
  label: "Tamaulipas"
}, {
  value: "TL",
  label: "Tlaxcala"
}, {
  value: "VZ",
  label: "Veracruz"
}, {
  value: "YN",
  label: "Yucatan"
}, {
  value: "ZS",
  label: "Zacatecas"
}, {
  value: "NE",
  label: "Extranjero"
}];
const EnterCurpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(var(--vh) * 100);
  width: calc(var(--vw) * 100);
`;
const Title$4 = styled.h1`
  width: 100%;
  height: 30px;
  font-weight: bold;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
`;
const Input$1 = styled.input`
  width: 90%;
  max-width: 332px;
  height: 55px;
  margin-bottom: 20px;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: rgba(33, 39, 59, 0.2);
  font-weight: bold;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #21273b;

  &.enterCurp {
    text-transform: uppercase;
  }

  &.error-input {
    background-color: #ff637b;
    color: #fff;
    margin-bottom: 35px;
    &::placeholder {
      color: #fff;
      opacity: 0.5;
    }
  }

  &.curpName {
    &:focus {
      @media only screen and (max-height: 400px) {
        margin-top: 100px;
        color: green;
      }
    }
  }

  @media only screen and (max-height: 600px) {
    font-size: 17px;
    height: 40px;
    margin-bottom: 10px;
    padding: 5px 15px;
  }

  &.birthDate:not(.hasValue) {
    color: lightgray;
    :before {
      color: #21273b;
      content: attr(placeholder);
    }
  }
`;
const Select = styled.select`
  width: 90%;
  max-width: 332px;
  height: 55px;
  margin-bottom: 20px;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: rgba(33, 39, 59, 0.2);
  font-weight: bold;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
  border: none;

  &.error-input {
    border: solid 0.9px #ff5c6f;
    background-color: rgba(255, 92, 111, 0.1);
  }

  @media only screen and (max-height: 600px) {
    font-size: 17px;
    height: 40px;
    margin-bottom: 10px;
    padding: 5px 15px;
  }
`;
const Footer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 25px;
`;
const Paragraph$2 = styled.p`
  height: 27px;
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.69;
  text-align: center;
  color: #21273b;
`;
const Span$1 = styled.span`
  color: #3cb0f7;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  span {
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    color: #ff637b;
    width: 100%;
    margin-bottom: 40px;
  }
`;
const errorInputClass = "error-input";
const spinner = Ue`
  to {
    transform: rotate(360deg);
  }
`;
const Text = styled.p`
  font-size: 28px;
  text-align: center;
  font-weight: bold;
  &.weak {
    font-size: 20px;
    font-weight: normal;
  }
`;
const Image$2 = styled.img`
  &.loading-icon {
    animation: ${spinner} 3s linear infinite;
  }
`;
function Loading() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Image$2, {
      src: loadingLogo,
      alt: "loading...",
      className: "loading-icon"
    }), /* @__PURE__ */ jsx(Text, {
      children: t2("curp.verifying")
    })]
  });
}
function Success() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Image$2, {
      src: greenCheck,
      alt: "success"
    }), /* @__PURE__ */ jsx("p", {
      children: t2("curp.success")
    })]
  });
}
function NotSuccess({
  willRetry = false
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Image$2, {
      src: redStrike,
      alt: "failure"
    }), /* @__PURE__ */ jsx(Text, {
      children: t2("curp.failed")
    }), willRetry && /* @__PURE__ */ jsx(Text, {
      className: "weak",
      children: t2("curp.retry")
    })]
  });
}
function InProgress() {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Image$2, {
      src: greenCheck,
      alt: "inProgress"
    }), /* @__PURE__ */ jsx("p", {
      children: t2("curp.inProgress")
    })]
  });
}
const CURP_LENGTH = 18;
const isValidCurp = (curp) => typeof curp === "string" && curp.length === CURP_LENGTH && curp.toUpperCase().match(regex.CURP_PATTERN);
function EnterCurp({
  onSuccess,
  token
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    register,
    handleSubmit,
    errors,
    reset,
    watch
  } = useForm();
  const [enterCurp, setEnterCurp] = useState(true);
  const [curpFromOCR, setCurpFromOcr] = useState(false);
  const [status, setStatus] = useState("loading");
  const [userRetried, setUserRetried] = useState(false);
  const generateCurpParagraphRef = useRef();
  const height2 = window.visualViewport.height;
  const resizeHandler = () => {
    const viewport = window.visualViewport.height;
    generateCurpParagraphRef.current.style.bottom = `${viewport === height2 ? 25 : height2 - viewport - 125}px`;
  };
  useEventListener("resize", resizeHandler, window.visualViewport);
  useEffect(() => {
    enableBodyScroll(document.getElementsByTagName("body")[0]);
    enableBodyScroll(document.getElementsByTagName("html")[0]);
    document.body.style.position = "unset";
    return () => {
      disableBodyScroll(document.getElementsByTagName("body")[0]);
      disableBodyScroll(document.getElementsByTagName("html")[0]);
      document.body.style.position = "fixed";
    };
  }, []);
  useEffect(() => {
    ocrData({
      token
    }).then((dataFromOcr) => {
      const {
        curp: ocrCurp
      } = dataFromOcr;
      if (!ocrCurp) {
        setStatus("idle");
        return;
      }
      addCurp(ocrCurp.toUpperCase(), token).then((response) => {
        if (response.success) {
          setStatus("success");
          setTimeout(onSuccess, 3e3);
        } else {
          setStatus("idle");
          setUserRetried(true);
          setCurpFromOcr(true);
          reset({
            curp: ocrCurp
          });
        }
      }).catch(() => {
        setStatus("idle");
        setUserRetried(true);
        setCurpFromOcr(true);
        reset({
          curp: ocrCurp
        });
      });
    }).catch(() => setStatus("idle"));
  }, [onSuccess, reset, token]);
  const validateCurp = async (data2) => {
    const birthDate = enterCurp ? "" : formatCurpDate(data2.birthDate);
    let success = false;
    setStatus("loading");
    try {
      const response = enterCurp ? await addCurp(data2.curp.toUpperCase(), token) : await addCurpv2(__spreadProps(__spreadValues({}, data2), {
        birthDate
      }), token);
      if (response.result === "Attempting validation by scraping method") {
        setStatus("inProgress");
        success = true;
      } else {
        success = response.success;
        setStatus(success ? "success" : "failed");
      }
    } catch (error3) {
      setStatus("failed");
    }
    setTimeout(() => {
      if (userRetried || success) {
        onSuccess();
      } else {
        setUserRetried(true);
        setStatus("idle");
      }
    }, 3e3);
  };
  const formatCurpDate = (date) => {
    const splittedDate = date.split("-");
    return `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
  };
  const generateCurp = () => {
    setEnterCurp(false);
    reset();
  };
  const titleText = useMemo(() => {
    let text = t2("curp.labels.generate");
    if (curpFromOCR)
      text = t2("curp.labels.confirm");
    else if (enterCurp)
      text = t2("curp.labels.enter");
    return `${text} ${t2("curp.labels.yourCURP")}`;
  }, [curpFromOCR, enterCurp, t2]);
  const CurpStatus = ((cStatus) => {
    if (cStatus === "loading") {
      return Loading;
    }
    if (cStatus === "success") {
      return Success;
    }
    if (cStatus === "failed") {
      return NotSuccess;
    }
    if (cStatus === "inProgress") {
      return InProgress;
    }
  })(status);
  if (status !== "idle")
    return /* @__PURE__ */ jsx(EnterCurpContainer, {
      children: /* @__PURE__ */ jsx(CurpStatus, {
        willRetry: !userRetried,
        enterCurp
      })
    });
  return /* @__PURE__ */ jsxs(EnterCurpContainer, {
    children: [/* @__PURE__ */ jsx(Title$4, {
      children: titleText
    }), /* @__PURE__ */ jsxs(Form, {
      onSubmit: handleSubmit(validateCurp),
      autoComplete: "false",
      children: [enterCurp ? /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(Input$1, {
          id: "curp",
          name: "curp",
          placeholder: "CURP",
          className: classNames("enterCurp", {
            "error-input": errors.curp
          }),
          ref: register({
            required: t2("curp.errors.curpRequired"),
            validate: (value) => {
              return isValidCurp(value) || t2("curp.errors.curpInvalid");
            }
          })
        }), !!errors.curp && /* @__PURE__ */ jsx("span", {
          children: errors.curp.message
        })]
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(Input$1, {
          id: "name",
          name: "name",
          className: classNames("curpName", {
            "error-input": errors.name
          }),
          ref: register({
            required: "required"
          }),
          placeholder: t2("curp.labels.name")
        }), /* @__PURE__ */ jsx(Input$1, {
          id: "firstLastName",
          name: "firstLastName",
          className: errors.firstLastName && errorInputClass,
          ref: register({
            required: "required"
          }),
          placeholder: t2("curp.labels.firstLastName")
        }), /* @__PURE__ */ jsx(Input$1, {
          id: "secondLastName",
          name: "secondLastName",
          className: errors.secondLastName && errorInputClass,
          ref: register,
          placeholder: t2("curp.labels.secondLastName")
        }), /* @__PURE__ */ jsxs(Select, {
          id: "gender",
          name: "gender",
          className: errors.gender && errorInputClass,
          ref: register({
            required: "required"
          }),
          children: [/* @__PURE__ */ jsx("option", {
            disabled: true,
            selected: true,
            value: "",
            children: t2("curp.labels.gender")
          }), /* @__PURE__ */ jsx("option", {
            value: "H",
            children: t2("curp.labels.male")
          }), /* @__PURE__ */ jsx("option", {
            value: "M",
            children: t2("curp.labels.female")
          })]
        }), /* @__PURE__ */ jsx(Input$1, {
          id: "birthDate",
          name: "birthDate",
          className: classNames("birthDate", {
            "error-input": errors.birthDate,
            hasValue: watch("birthDate")
          }),
          type: "date",
          max: formatInputDate(new Date()),
          ref: register({
            required: "required"
          }),
          placeholder: t2("curp.labels.birthDate")
        }), /* @__PURE__ */ jsxs(Select, {
          id: "state",
          name: "state",
          className: errors.state && errorInputClass,
          ref: register({
            required: "required"
          }),
          children: [/* @__PURE__ */ jsx("option", {
            disabled: true,
            selected: true,
            value: "",
            children: t2("curp.labels.state")
          }), /* @__PURE__ */ jsx("option", {
            value: "NE",
            children: t2("curp.labels.bornAbroad")
          }, "NE"), states.map((state2) => /* @__PURE__ */ jsx("option", {
            value: state2.value,
            children: state2.label
          }, state2.value))]
        })]
      }), /* @__PURE__ */ jsx(Button$3, {
        disabled: status !== "idle",
        type: "submit",
        children: t2("common.continue")
      })]
    }), enterCurp && /* @__PURE__ */ jsx(Footer, {
      className: "enteringCurp",
      ref: generateCurpParagraphRef,
      children: /* @__PURE__ */ jsxs(Paragraph$2, {
        children: [t2("curp.labels.missing"), /* @__PURE__ */ jsx(Span$1, {
          onClick: generateCurp,
          children: t2("curp.labels.generate")
        })]
      })
    })]
  });
}
function renderEnterCurp(element, {
  onSuccess,
  token
}) {
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    token
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(EnterCurp, __spreadValues({}, props))
  }), element);
}
var lib = {};
var mode$1 = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};
var mode = mode$1;
function QR8bitByte(data2) {
  this.mode = mode.MODE_8BIT_BYTE;
  this.data = data2;
}
QR8bitByte.prototype = {
  getLength: function(buffer2) {
    return this.data.length;
  },
  write: function(buffer2) {
    for (var i2 = 0; i2 < this.data.length; i2++) {
      buffer2.put(this.data.charCodeAt(i2), 8);
    }
  }
};
var _8BitByte = QR8bitByte;
var ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
};
var ECL = ErrorCorrectLevel;
function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}
QRRSBlock.RS_BLOCK_TABLE = [
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
  if (rsBlock == void 0) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }
  var length = rsBlock.length / 3;
  var list = new Array();
  for (var i2 = 0; i2 < length; i2++) {
    var count2 = rsBlock[i2 * 3 + 0];
    var totalCount = rsBlock[i2 * 3 + 1];
    var dataCount = rsBlock[i2 * 3 + 2];
    for (var j2 = 0; j2 < count2; j2++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }
  return list;
};
QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case ECL.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
    case ECL.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
    case ECL.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
    case ECL.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
    default:
      return void 0;
  }
};
var RSBlock$1 = QRRSBlock;
function QRBitBuffer() {
  this.buffer = new Array();
  this.length = 0;
}
QRBitBuffer.prototype = {
  get: function(index2) {
    var bufIndex = Math.floor(index2 / 8);
    return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) == 1;
  },
  put: function(num, length) {
    for (var i2 = 0; i2 < length; i2++) {
      this.putBit((num >>> length - i2 - 1 & 1) == 1);
    }
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(bit) {
    var bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }
    if (bit) {
      this.buffer[bufIndex] |= 128 >>> this.length % 8;
    }
    this.length++;
  }
};
var BitBuffer$1 = QRBitBuffer;
var QRMath = {
  glog: function(n2) {
    if (n2 < 1) {
      throw new Error("glog(" + n2 + ")");
    }
    return QRMath.LOG_TABLE[n2];
  },
  gexp: function(n2) {
    while (n2 < 0) {
      n2 += 255;
    }
    while (n2 >= 256) {
      n2 -= 255;
    }
    return QRMath.EXP_TABLE[n2];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++) {
  QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}
var math$2 = QRMath;
var math$1 = math$2;
function QRPolynomial(num, shift) {
  if (num.length == void 0) {
    throw new Error(num.length + "/" + shift);
  }
  var offset = 0;
  while (offset < num.length && num[offset] == 0) {
    offset++;
  }
  this.num = new Array(num.length - offset + shift);
  for (var i2 = 0; i2 < num.length - offset; i2++) {
    this.num[i2] = num[i2 + offset];
  }
}
QRPolynomial.prototype = {
  get: function(index2) {
    return this.num[index2];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(e2) {
    var num = new Array(this.getLength() + e2.getLength() - 1);
    for (var i2 = 0; i2 < this.getLength(); i2++) {
      for (var j2 = 0; j2 < e2.getLength(); j2++) {
        num[i2 + j2] ^= math$1.gexp(math$1.glog(this.get(i2)) + math$1.glog(e2.get(j2)));
      }
    }
    return new QRPolynomial(num, 0);
  },
  mod: function(e2) {
    if (this.getLength() - e2.getLength() < 0) {
      return this;
    }
    var ratio = math$1.glog(this.get(0)) - math$1.glog(e2.get(0));
    var num = new Array(this.getLength());
    for (var i2 = 0; i2 < this.getLength(); i2++) {
      num[i2] = this.get(i2);
    }
    for (var i2 = 0; i2 < e2.getLength(); i2++) {
      num[i2] ^= math$1.gexp(math$1.glog(e2.get(i2)) + ratio);
    }
    return new QRPolynomial(num, 0).mod(e2);
  }
};
var Polynomial$2 = QRPolynomial;
var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;
var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function(data2) {
    var d2 = data2 << 10;
    while (QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d2 ^= QRUtil.G15 << QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G15);
    }
    return (data2 << 10 | d2) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function(data2) {
    var d2 = data2 << 12;
    while (QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d2 ^= QRUtil.G18 << QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G18);
    }
    return data2 << 12 | d2;
  },
  getBCHDigit: function(data2) {
    var digit = 0;
    while (data2 != 0) {
      digit++;
      data2 >>>= 1;
    }
    return digit;
  },
  getPatternPosition: function(typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function(maskPattern, i2, j2) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i2 + j2) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return i2 % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return j2 % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (i2 + j2) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(i2 / 2) + Math.floor(j2 / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return i2 * j2 % 2 + i2 * j2 % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (i2 * j2 % 2 + i2 * j2 % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (i2 * j2 % 3 + (i2 + j2) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function(errorCorrectLength) {
    var a6 = new Polynomial$1([1], 0);
    for (var i2 = 0; i2 < errorCorrectLength; i2++) {
      a6 = a6.multiply(new Polynomial$1([1, math.gexp(i2)], 0));
    }
    return a6;
  },
  getLengthInBits: function(mode2, type) {
    if (1 <= type && type < 10) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 10;
        case Mode.MODE_ALPHA_NUM:
          return 9;
        case Mode.MODE_8BIT_BYTE:
          return 8;
        case Mode.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + mode2);
      }
    } else if (type < 27) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 12;
        case Mode.MODE_ALPHA_NUM:
          return 11;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + mode2);
      }
    } else if (type < 41) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 14;
        case Mode.MODE_ALPHA_NUM:
          return 13;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + mode2);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function(qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0;
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark = qrCode.isDark(row, col);
        for (var r2 = -1; r2 <= 1; r2++) {
          if (row + r2 < 0 || moduleCount <= row + r2) {
            continue;
          }
          for (var c2 = -1; c2 <= 1; c2++) {
            if (col + c2 < 0 || moduleCount <= col + c2) {
              continue;
            }
            if (r2 == 0 && c2 == 0) {
              continue;
            }
            if (dark == qrCode.isDark(row + r2, col + c2)) {
              sameCount++;
            }
          }
        }
        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    }
    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count2 = 0;
        if (qrCode.isDark(row, col))
          count2++;
        if (qrCode.isDark(row + 1, col))
          count2++;
        if (qrCode.isDark(row, col + 1))
          count2++;
        if (qrCode.isDark(row + 1, col + 1))
          count2++;
        if (count2 == 0 || count2 == 4) {
          lostPoint += 3;
        }
      }
    }
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    }
    var darkCount = 0;
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }
    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var util$1 = QRUtil;
var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;
function QRCode$1(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
}
var proto = QRCode$1.prototype;
proto.addData = function(data2) {
  var newData = new BitByte(data2);
  this.dataList.push(newData);
  this.dataCache = null;
};
proto.isDark = function(row, col) {
  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
    throw new Error(row + "," + col);
  }
  return this.modules[row][col];
};
proto.getModuleCount = function() {
  return this.moduleCount;
};
proto.make = function() {
  if (this.typeNumber < 1) {
    var typeNumber = 1;
    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
      var buffer2 = new BitBuffer();
      var totalDataCount = 0;
      for (var i2 = 0; i2 < rsBlocks.length; i2++) {
        totalDataCount += rsBlocks[i2].dataCount;
      }
      for (var i2 = 0; i2 < this.dataList.length; i2++) {
        var data2 = this.dataList[i2];
        buffer2.put(data2.mode, 4);
        buffer2.put(data2.getLength(), util.getLengthInBits(data2.mode, typeNumber));
        data2.write(buffer2);
      }
      if (buffer2.getLengthInBits() <= totalDataCount * 8)
        break;
    }
    this.typeNumber = typeNumber;
  }
  this.makeImpl(false, this.getBestMaskPattern());
};
proto.makeImpl = function(test2, maskPattern) {
  this.moduleCount = this.typeNumber * 4 + 17;
  this.modules = new Array(this.moduleCount);
  for (var row = 0; row < this.moduleCount; row++) {
    this.modules[row] = new Array(this.moduleCount);
    for (var col = 0; col < this.moduleCount; col++) {
      this.modules[row][col] = null;
    }
  }
  this.setupPositionProbePattern(0, 0);
  this.setupPositionProbePattern(this.moduleCount - 7, 0);
  this.setupPositionProbePattern(0, this.moduleCount - 7);
  this.setupPositionAdjustPattern();
  this.setupTimingPattern();
  this.setupTypeInfo(test2, maskPattern);
  if (this.typeNumber >= 7) {
    this.setupTypeNumber(test2);
  }
  if (this.dataCache == null) {
    this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  }
  this.mapData(this.dataCache, maskPattern);
};
proto.setupPositionProbePattern = function(row, col) {
  for (var r2 = -1; r2 <= 7; r2++) {
    if (row + r2 <= -1 || this.moduleCount <= row + r2)
      continue;
    for (var c2 = -1; c2 <= 7; c2++) {
      if (col + c2 <= -1 || this.moduleCount <= col + c2)
        continue;
      if (0 <= r2 && r2 <= 6 && (c2 == 0 || c2 == 6) || 0 <= c2 && c2 <= 6 && (r2 == 0 || r2 == 6) || 2 <= r2 && r2 <= 4 && 2 <= c2 && c2 <= 4) {
        this.modules[row + r2][col + c2] = true;
      } else {
        this.modules[row + r2][col + c2] = false;
      }
    }
  }
};
proto.getBestMaskPattern = function() {
  var minLostPoint = 0;
  var pattern = 0;
  for (var i2 = 0; i2 < 8; i2++) {
    this.makeImpl(true, i2);
    var lostPoint = util.getLostPoint(this);
    if (i2 == 0 || minLostPoint > lostPoint) {
      minLostPoint = lostPoint;
      pattern = i2;
    }
  }
  return pattern;
};
proto.createMovieClip = function(target_mc, instance_name, depth) {
  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  var cs = 1;
  this.make();
  for (var row = 0; row < this.modules.length; row++) {
    var y2 = row * cs;
    for (var col = 0; col < this.modules[row].length; col++) {
      var x2 = col * cs;
      var dark = this.modules[row][col];
      if (dark) {
        qr_mc.beginFill(0, 100);
        qr_mc.moveTo(x2, y2);
        qr_mc.lineTo(x2 + cs, y2);
        qr_mc.lineTo(x2 + cs, y2 + cs);
        qr_mc.lineTo(x2, y2 + cs);
        qr_mc.endFill();
      }
    }
  }
  return qr_mc;
};
proto.setupTimingPattern = function() {
  for (var r2 = 8; r2 < this.moduleCount - 8; r2++) {
    if (this.modules[r2][6] != null) {
      continue;
    }
    this.modules[r2][6] = r2 % 2 == 0;
  }
  for (var c2 = 8; c2 < this.moduleCount - 8; c2++) {
    if (this.modules[6][c2] != null) {
      continue;
    }
    this.modules[6][c2] = c2 % 2 == 0;
  }
};
proto.setupPositionAdjustPattern = function() {
  var pos = util.getPatternPosition(this.typeNumber);
  for (var i2 = 0; i2 < pos.length; i2++) {
    for (var j2 = 0; j2 < pos.length; j2++) {
      var row = pos[i2];
      var col = pos[j2];
      if (this.modules[row][col] != null) {
        continue;
      }
      for (var r2 = -2; r2 <= 2; r2++) {
        for (var c2 = -2; c2 <= 2; c2++) {
          if (r2 == -2 || r2 == 2 || c2 == -2 || c2 == 2 || r2 == 0 && c2 == 0) {
            this.modules[row + r2][col + c2] = true;
          } else {
            this.modules[row + r2][col + c2] = false;
          }
        }
      }
    }
  }
};
proto.setupTypeNumber = function(test2) {
  var bits = util.getBCHTypeNumber(this.typeNumber);
  for (var i2 = 0; i2 < 18; i2++) {
    var mod2 = !test2 && (bits >> i2 & 1) == 1;
    this.modules[Math.floor(i2 / 3)][i2 % 3 + this.moduleCount - 8 - 3] = mod2;
  }
  for (var i2 = 0; i2 < 18; i2++) {
    var mod2 = !test2 && (bits >> i2 & 1) == 1;
    this.modules[i2 % 3 + this.moduleCount - 8 - 3][Math.floor(i2 / 3)] = mod2;
  }
};
proto.setupTypeInfo = function(test2, maskPattern) {
  var data2 = this.errorCorrectLevel << 3 | maskPattern;
  var bits = util.getBCHTypeInfo(data2);
  for (var i2 = 0; i2 < 15; i2++) {
    var mod2 = !test2 && (bits >> i2 & 1) == 1;
    if (i2 < 6) {
      this.modules[i2][8] = mod2;
    } else if (i2 < 8) {
      this.modules[i2 + 1][8] = mod2;
    } else {
      this.modules[this.moduleCount - 15 + i2][8] = mod2;
    }
  }
  for (var i2 = 0; i2 < 15; i2++) {
    var mod2 = !test2 && (bits >> i2 & 1) == 1;
    if (i2 < 8) {
      this.modules[8][this.moduleCount - i2 - 1] = mod2;
    } else if (i2 < 9) {
      this.modules[8][15 - i2 - 1 + 1] = mod2;
    } else {
      this.modules[8][15 - i2 - 1] = mod2;
    }
  }
  this.modules[this.moduleCount - 8][8] = !test2;
};
proto.mapData = function(data2, maskPattern) {
  var inc = -1;
  var row = this.moduleCount - 1;
  var bitIndex = 7;
  var byteIndex = 0;
  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
    if (col == 6)
      col--;
    while (true) {
      for (var c2 = 0; c2 < 2; c2++) {
        if (this.modules[row][col - c2] == null) {
          var dark = false;
          if (byteIndex < data2.length) {
            dark = (data2[byteIndex] >>> bitIndex & 1) == 1;
          }
          var mask = util.getMask(maskPattern, row, col - c2);
          if (mask) {
            dark = !dark;
          }
          this.modules[row][col - c2] = dark;
          bitIndex--;
          if (bitIndex == -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || this.moduleCount <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};
QRCode$1.PAD0 = 236;
QRCode$1.PAD1 = 17;
QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer2 = new BitBuffer();
  for (var i2 = 0; i2 < dataList.length; i2++) {
    var data2 = dataList[i2];
    buffer2.put(data2.mode, 4);
    buffer2.put(data2.getLength(), util.getLengthInBits(data2.mode, typeNumber));
    data2.write(buffer2);
  }
  var totalDataCount = 0;
  for (var i2 = 0; i2 < rsBlocks.length; i2++) {
    totalDataCount += rsBlocks[i2].dataCount;
  }
  if (buffer2.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer2.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  }
  if (buffer2.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer2.put(0, 4);
  }
  while (buffer2.getLengthInBits() % 8 != 0) {
    buffer2.putBit(false);
  }
  while (true) {
    if (buffer2.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer2.put(QRCode$1.PAD0, 8);
    if (buffer2.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer2.put(QRCode$1.PAD1, 8);
  }
  return QRCode$1.createBytes(buffer2, rsBlocks);
};
QRCode$1.createBytes = function(buffer2, rsBlocks) {
  var offset = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);
  for (var r2 = 0; r2 < rsBlocks.length; r2++) {
    var dcCount = rsBlocks[r2].dataCount;
    var ecCount = rsBlocks[r2].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r2] = new Array(dcCount);
    for (var i2 = 0; i2 < dcdata[r2].length; i2++) {
      dcdata[r2][i2] = 255 & buffer2.buffer[i2 + offset];
    }
    offset += dcCount;
    var rsPoly = util.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new Polynomial(dcdata[r2], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r2] = new Array(rsPoly.getLength() - 1);
    for (var i2 = 0; i2 < ecdata[r2].length; i2++) {
      var modIndex = i2 + modPoly.getLength() - ecdata[r2].length;
      ecdata[r2][i2] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }
  var totalCodeCount = 0;
  for (var i2 = 0; i2 < rsBlocks.length; i2++) {
    totalCodeCount += rsBlocks[i2].totalCount;
  }
  var data2 = new Array(totalCodeCount);
  var index2 = 0;
  for (var i2 = 0; i2 < maxDcCount; i2++) {
    for (var r2 = 0; r2 < rsBlocks.length; r2++) {
      if (i2 < dcdata[r2].length) {
        data2[index2++] = dcdata[r2][i2];
      }
    }
  }
  for (var i2 = 0; i2 < maxEcCount; i2++) {
    for (var r2 = 0; r2 < rsBlocks.length; r2++) {
      if (i2 < ecdata[r2].length) {
        data2[index2++] = ecdata[r2][i2];
      }
    }
  }
  return data2;
};
var QRCode_1 = QRCode$1;
var QRCodeCell$1 = {};
Object.defineProperty(QRCodeCell$1, "__esModule", {
  value: true
});
var _propTypes$2 = propTypes$3.exports;
var _propTypes2$2 = _interopRequireDefault$2(_propTypes$2);
var _react$2 = React__default;
var _react2$2 = _interopRequireDefault$2(_react$2);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var propTypes$2 = {
  d: _propTypes2$2.default.string.isRequired,
  fill: _propTypes2$2.default.string.isRequired,
  transformX: _propTypes2$2.default.number.isRequired,
  transformY: _propTypes2$2.default.number.isRequired
};
var defaultProps$2 = {};
var QRCodeCell = function QRCodeCell2(_ref) {
  var d2 = _ref.d, fill2 = _ref.fill, transformX = _ref.transformX, transformY = _ref.transformY;
  return _react2$2.default.createElement("path", { d: d2, fill: fill2, transform: "matrix(" + [1, 0, 0, 1, transformX, transformY] + ")" });
};
QRCodeCell.propTypes = propTypes$2;
QRCodeCell.defaultProps = defaultProps$2;
QRCodeCell$1.default = QRCodeCell;
var QRCodeSurface$1 = {};
Object.defineProperty(QRCodeSurface$1, "__esModule", {
  value: true
});
var _extends$1 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2];
    for (var key in source2) {
      if (Object.prototype.hasOwnProperty.call(source2, key)) {
        target[key] = source2[key];
      }
    }
  }
  return target;
};
var _propTypes$1 = propTypes$3.exports;
var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);
var _react$1 = React__default;
var _react2$1 = _interopRequireDefault$1(_react$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties$1(obj, keys) {
  var target = {};
  for (var i2 in obj) {
    if (keys.indexOf(i2) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i2))
      continue;
    target[i2] = obj[i2];
  }
  return target;
}
var propTypes$1 = {
  children: _propTypes2$1.default.array.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  xmlns: _propTypes2$1.default.string
};
var defaultProps$1 = {
  title: void 0,
  xmlns: "http://www.w3.org/2000/svg"
};
var QRCodeSurface = function QRCodeSurface2(_ref) {
  var children = _ref.children, size = _ref.size, title = _ref.title, xmlns = _ref.xmlns, props = _objectWithoutProperties$1(_ref, ["children", "size", "title", "xmlns"]);
  return _react2$1.default.createElement("svg", _extends$1({}, props, { height: size, width: size, xmlns }), title ? _react2$1.default.createElement("title", null, title) : null, children);
};
QRCodeSurface.propTypes = propTypes$1;
QRCodeSurface.defaultProps = defaultProps$1;
QRCodeSurface$1.default = QRCodeSurface;
Object.defineProperty(lib, "__esModule", {
  value: true
});
var _extends = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2];
    for (var key in source2) {
      if (Object.prototype.hasOwnProperty.call(source2, key)) {
        target[key] = source2[key];
      }
    }
  }
  return target;
};
var _QRCode = QRCode_1;
var _QRCode2 = _interopRequireDefault(_QRCode);
var _ErrorCorrectLevel = ErrorCorrectLevel;
var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);
var _propTypes = propTypes$3.exports;
var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = React__default;
var _react2 = _interopRequireDefault(_react);
var _QRCodeCell = QRCodeCell$1;
var _QRCodeCell2 = _interopRequireDefault(_QRCodeCell);
var _QRCodeSurface = QRCodeSurface$1;
var _QRCodeSurface2 = _interopRequireDefault(_QRCodeSurface);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i2 in obj) {
    if (keys.indexOf(i2) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i2))
      continue;
    target[i2] = obj[i2];
  }
  return target;
}
var propTypes = {
  bgColor: _propTypes2.default.string,
  fgColor: _propTypes2.default.string,
  level: _propTypes2.default.oneOf(["L", "M", "Q", "H"]),
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};
var defaultProps = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
};
var QRCode = function QRCode2(_ref) {
  var bgColor = _ref.bgColor, fgColor = _ref.fgColor, level = _ref.level, size = _ref.size, value = _ref.value, props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  var tileSize = size / cells.length;
  return _react2.default.createElement(_QRCodeSurface2.default, _extends({}, props, { size }), cells.map(function(row, rowIndex) {
    return row.map(function(cell, cellIndex) {
      var fill2 = cell ? fgColor : bgColor;
      var transformX = Math.round(cellIndex * tileSize);
      var transformY = Math.round(rowIndex * tileSize);
      var qrItemWidth = Math.round((cellIndex + 1) * tileSize) - transformX;
      var qrItemHeight = Math.round((rowIndex + 1) * tileSize) - transformY;
      var d2 = "M 0 0 L " + qrItemWidth + " 0 L " + qrItemWidth + " " + qrItemHeight + " L 0 " + qrItemHeight + " Z";
      return _react2.default.createElement(_QRCodeCell2.default, {
        key: "rectangle-" + rowIndex + "-" + cellIndex,
        d: d2,
        fill: fill2,
        transformX,
        transformY
      });
    });
  }));
};
QRCode.propTypes = propTypes;
QRCode.defaultProps = defaultProps;
var _default = lib.default = (0, _react.memo)(QRCode);
var metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([457]\\d{6})$", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2457]\\d{6})$", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "1|([267]\\d{6})$", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "0|(183[12])", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "(?:[25689]\\d|40)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], "BL": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([3-8]\\d{6})$", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}", [10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:355[0-46-9]|4(?:5(?:2[024-9]|5[0-46-9])|60[1-9]|9(?:2[0-5]|49)))\\d{4}|52(?:3(?:[2-46-9][02-9]|5[02-46-9])|4(?:[2-478][02-9]|5[034]|6[2-9]|9[05-9])|7[2-4]\\d)\\d{5}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[1256]|33|44|66|77|88)|622)[2-9]\\d{6}"], 0, 0, 0, ["600[2-9]\\d{6}"]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "0|(1(?:[12]\\d|79)\\d\\d)", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1 $2", ["[146][2-9]|[2578]"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["[39]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-59]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-24-69]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "(?:[56]94|80\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "0|([25-9]\\d{5})$", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|1[0-24-7]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "1|([3-9]\\d{6})$", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "[2-489]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([25-8]\\d{5})$", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|55\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[38]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([0-24-8]\\d{5})$", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "0|(1001)"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:29(?:[189][05]|2[29]|3[01])|38(?:8[057]|9[05]))\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|6[0-367]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "0|([24-9]\\d{6})$", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[57-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "670$1", 0, "670"], "MQ": ["596", "00", "(?:69|80)\\d{7}|(?:59|97)6\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "1|([34]\\d{6})$", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["5"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9])|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "[2-57-9]\\d{5}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, 0, " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "(?:[45]|80\\d\\d)\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}", [7, 8, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]]], "RE": ["262", "00", "9769\\d{5}|(?:26|[68]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, "26[23]|69|[89]"], "RO": ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-5]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|(5\\d{6})$", "721$1", 0, "721"], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "1|([2-479]\\d{6})$", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-46-8]\\d{6})$", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[26-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]", "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}", [10], [["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:355[0-46-9]|4(?:5(?:2[024-9]|5[0-46-9])|60[1-9]|9(?:2[0-5]|49)))\\d{4}|52(?:3(?:[2-46-9][02-9]|5[02-46-9])|4(?:[2-478][02-9]|5[034]|6[2-9]|9[05-9])|7[2-4]\\d)\\d{5}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[1256]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "810", "(?:33|55|[679]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-578]\\d{6})$", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "80\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63"], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:005|[1-9]\\d\\d)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:005|[1-9]\\d\\d)\\d{5}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["4"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]], "883": ["883", 0, "(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?", [9, 10, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[35]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadata(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function _classCallCheck$7(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var ParseError = function ParseError2(code) {
  _classCallCheck$7(this, ParseError2);
  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
function compare(a6, b2) {
  a6 = a6.split("-");
  b2 = b2.split("-");
  var pa = a6[0].split(".");
  var pb = b2[0].split(".");
  for (var i2 = 0; i2 < 3; i2++) {
    var na = Number(pa[i2]);
    var nb = Number(pb[i2]);
    if (na > nb)
      return 1;
    if (nb > na)
      return -1;
    if (!isNaN(na) && isNaN(nb))
      return 1;
    if (isNaN(na) && !isNaN(nb))
      return -1;
  }
  if (a6[1] && b2[1]) {
    return a6[1] > b2[1] ? 1 : a6[1] < b2[1] ? -1 : 0;
  }
  return !a6[1] && b2[1] ? 1 : a6[1] && !b2[1] ? -1 : 0;
}
function _typeof$2(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$2 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$2(obj);
}
function _classCallCheck$6(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$6(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$6(Constructor, staticProps);
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$6(this, Metadata2);
    validateMetadata(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$6(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_24) {
        return _24 !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$6(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$6(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_24) {
        return new Format(_24, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types2() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format, metadata2) {
    _classCallCheck$6(this, Format2);
    this._format = format;
    this.metadata = metadata2;
  }
  _createClass$6(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata2) {
    _classCallCheck$6(this, Type2);
    this.type = type;
    this.metadata = metadata2;
  }
  _createClass$6(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types2, type) {
  switch (type) {
    case "FIXED_LINE":
      return types2[0];
    case "MOBILE":
      return types2[1];
    case "TOLL_FREE":
      return types2[2];
    case "PREMIUM_RATE":
      return types2[3];
    case "PERSONAL_NUMBER":
      return types2[4];
    case "VOICEMAIL":
      return types2[5];
    case "UAN":
      return types2[6];
    case "PAGER":
      return types2[7];
    case "VOIP":
      return types2[8];
    case "SHARED_COST":
      return types2[9];
  }
}
function validateMetadata(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!is_object(metadata2) || !is_object(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + type_of(metadata2) + ": " + metadata2, "."));
  }
}
var is_object = function is_object2(_24) {
  return _typeof$2(_24) === "object";
};
var type_of = function type_of2(_24) {
  return _typeof$2(_24);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata2) {
  return metadata2.countries[country] !== void 0;
}
function setVersion(metadata2) {
  var version2 = metadata2.version;
  if (typeof version2 === "number") {
    this.v1 = version2 === 1;
    this.v2 = version2 === 2;
    this.v3 = version2 === 3;
    this.v4 = version2 === 4;
  } else {
    if (!version2) {
      this.v1 = true;
    } else if (compare(version2, V3) === -1) {
      this.v2 = true;
    } else if (compare(version2, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + "(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$", "i");
function isViablePhoneNumber(number2) {
  return number2.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number2);
}
function isViablePhoneNumberStart(number2) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number2);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number2) {
  var start = number2.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number2.slice(0, start);
  var matches = number2.match(EXTN_PATTERN);
  var i2 = 1;
  while (i2 < matches.length) {
    if (matches[i2]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i2]
      };
    }
    i2++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  "\uFF11": "1",
  "\uFF12": "2",
  "\uFF13": "3",
  "\uFF14": "4",
  "\uFF15": "5",
  "\uFF16": "6",
  "\uFF17": "7",
  "\uFF18": "8",
  "\uFF19": "9",
  "\u0660": "0",
  "\u0661": "1",
  "\u0662": "2",
  "\u0663": "3",
  "\u0664": "4",
  "\u0665": "5",
  "\u0666": "6",
  "\u0667": "7",
  "\u0668": "8",
  "\u0669": "9",
  "\u06F0": "0",
  "\u06F1": "1",
  "\u06F2": "2",
  "\u06F3": "3",
  "\u06F4": "4",
  "\u06F5": "5",
  "\u06F6": "6",
  "\u06F7": "7",
  "\u06F8": "8",
  "\u06F9": "9"
};
function parseDigit(character) {
  return DIGITS[character];
}
function parseDigits(string2) {
  var result2 = "";
  for (var _iterator = string2.split(""), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
    var _ref;
    if (_isArray) {
      if (_i >= _iterator.length)
        break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done)
        break;
      _ref = _i.value;
    }
    var character = _ref;
    var digit = parseDigit(character);
    if (digit) {
      result2 += digit;
    }
  }
  return result2;
}
function parseIncompletePhoneNumber(string2) {
  var result2 = "";
  for (var _iterator = string2.split(""), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
    var _ref;
    if (_isArray) {
      if (_i >= _iterator.length)
        break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done)
        break;
      _ref = _i.value;
    }
    var character = _ref;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  if (character === "+") {
    if (prevParsedCharacters) {
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function mergeArrays(a6, b2) {
  var merged = a6.slice();
  for (var _iterator = b2, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
    var _ref;
    if (_isArray) {
      if (_i >= _iterator.length)
        break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done)
        break;
      _ref = _i.value;
    }
    var element = _ref;
    if (a6.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a7, b3) {
    return a7 - b3;
  });
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type, metadata2) {
  var type_info = metadata2.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata2.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata2);
    }
    var mobile_type = metadata2.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function _slicedToArray$3(arr2, i2) {
  return _arrayWithHoles$3(arr2) || _iterableToArrayLimit$3(arr2, i2) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$3(arr2, i2) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e2 = void 0;
  try {
    for (var _i = arr2[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$3(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function parseRFC3966(text) {
  var number2;
  var ext;
  text = text.replace(/^tel:/, "tel=");
  for (var _iterator = text.split(";"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
    var _ref;
    if (_isArray) {
      if (_i >= _iterator.length)
        break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done)
        break;
      _ref = _i.value;
    }
    var part = _ref;
    var _part$split = part.split("="), _part$split2 = _slicedToArray$3(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
    switch (name) {
      case "tel":
        number2 = value;
        break;
      case "ext":
        ext = value;
        break;
      case "phone-context":
        if (value[0] === "+") {
          number2 = value + number2;
        }
        break;
    }
  }
  if (!isViablePhoneNumber(number2)) {
    return {};
  }
  var result2 = {
    number: number2
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function formatRFC3966(_ref2) {
  var number2 = _ref2.number, ext = _ref2.ext;
  if (!number2) {
    return "";
  }
  if (number2[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number2).concat(ext ? ";ext=" + ext : "");
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var type = _NON_FIXED_LINE_PHONE[_i];
    if (isNumberTypeEqualTo(nationalNumber, type, metadata2)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata2) {
  type = metadata2.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (!input.country) {
    return false;
  }
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata2.nationalNumberPattern());
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number2, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode;
  _ref.metadata;
  var formattedNumber = number2.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function _objectSpread$4(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys2 = Object.keys(source2);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source2).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source2, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$6(target, key, source2[key]);
    });
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata2) {
  if (options) {
    options = _objectSpread$4({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number2;
  switch (format) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number2 = formatNationalNumber$1(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number2 = formatNationalNumber$1(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number2 = "+".concat(countryCallingCode, " ").concat(number2);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
  }
}
function formatNationalNumber$1(number2, carrierCode, formatAs, metadata2, options) {
  var format = chooseFormatForNumber(metadata2.formats(), number2);
  if (!format) {
    return number2;
  }
  return formatNationalNumberUsingFormat(number2, format, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata: metadata2
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
    var _ref;
    if (_isArray) {
      if (_i >= _iterator.length)
        break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done)
        break;
      _ref = _i.value;
    }
    var format = _ref;
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber$1(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber$1(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys2 = Object.keys(source2);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source2).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source2, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$5(target, key, source2[key]);
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$5(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$5(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$5(Constructor, staticProps);
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryCallingCode, nationalNumber, metadata2) {
    _classCallCheck$5(this, PhoneNumber2);
    if (!countryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata2) {
      throw new TypeError("`metadata` not passed");
    }
    var _metadata2 = new Metadata(metadata2);
    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;
      _metadata2.country(countryCallingCode);
      countryCallingCode = _metadata2.countryCallingCode();
    }
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata2;
  }
  _createClass$5(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.metadata);
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$3({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number2, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number2.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number2 = number2.slice(number2.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number2.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number2;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2) {
  if (number2 && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number2);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number2.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number2.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number2.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number2.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number2
  };
}
function extractNationalNumber(number2, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  if (!shouldExtractNationalPrefix(number2, nationalNumber, metadata2)) {
    return {
      nationalNumber: number2
    };
  }
  if (number2.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) {
    if (metadata2.possibleLengths()) {
      switch (checkNumberLength(nationalNumber, metadata2)) {
        case "TOO_SHORT":
        case "INVALID_LENGTH":
          return {
            nationalNumber: number2
          };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldExtractNationalPrefix(number2, nationalSignificantNumber, metadata2) {
  if (matchesEntirely(number2, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalSignificantNumber, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number2.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number2.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number2, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number2
  };
}
function extractCountryCallingCode(number2, country, callingCode, metadata2) {
  if (!number2) {
    return {};
  }
  if (number2[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number2, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number2) {
      number2 = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        number: number2
      };
    }
  }
  if (number2[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i2 = 2;
  while (i2 - 1 <= MAX_LENGTH_COUNTRY_CODE && i2 <= number2.length) {
    var _countryCallingCode = number2.slice(1, i2);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number2.slice(i2)
      };
    }
    i2++;
  }
  return {};
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata2) {
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata2.isNonGeographicCallingCode(callingCode)) {
      return "001";
    }
  }
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata2.metadata);
}
function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata2) {
  metadata2 = new Metadata(metadata2);
  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
    var _ref;
    if (_isArray) {
      if (_i >= _iterator.length)
        break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done)
        break;
      _ref = _i.value;
    }
    var country = _ref;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      return country;
    }
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error3 = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error3 === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function extractFormattedPhoneNumber$1(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  if (text && text.indexOf("tel:") === 0) {
    return parseRFC3966(text);
  }
  var number2 = extractFormattedPhoneNumber$1(text, extract, v2);
  if (!number2) {
    return {};
  }
  if (!isViablePhoneNumber(number2)) {
    if (isViablePhoneNumberStart(number2)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number2);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number2
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number2 && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else
    return {};
  if (!number2) {
    return {
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number2), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata2);
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001")
      ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    nationalNumber,
    carrierCode
  };
}
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys2 = Object.keys(source2);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source2).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source2, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$4(target, key, source2[key]);
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber(text, options, metadata2) {
  return parse(text, _objectSpread$2({}, options, {
    v2: true
  }), metadata2);
}
function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys2 = Object.keys(source2);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source2).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source2, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$3(target, key, source2[key]);
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray$2(arr2, i2) {
  return _arrayWithHoles$2(arr2) || _iterableToArrayLimit$2(arr2, i2) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$2(arr2, i2) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e2 = void 0;
  try {
    for (var _i = arr2[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$2(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray$2(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$1({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
var isObject = function isObject2(_24) {
  return _typeof$1(_24) === "object";
};
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys2 = Object.keys(source2);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source2).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source2, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$2(target, key, source2[key]);
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberFromString$2(text, options, metadata2) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2)) {
    options = _objectSpread({}, options, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumber(text, options, metadata2);
  } catch (error3) {
    if (error3 instanceof ParseError)
      ;
    else {
      throw error3;
    }
  }
}
function parsePhoneNumberFromString$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumberFromString$2(text, options, metadata2);
}
function _classCallCheck$4(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$4(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$4(Constructor, staticProps);
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var AsYouTypeState = /* @__PURE__ */ function() {
  function AsYouTypeState2(_ref) {
    var _this = this;
    var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
    _classCallCheck$4(this, AsYouTypeState2);
    _defineProperty$1(this, "update", function(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        _this[key] = properties[key];
      }
    });
    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }
  _createClass$4(AsYouTypeState2, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = void 0;
      this.missingPlus = void 0;
      this.callingCode = void 0;
      this.digits = "";
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = void 0;
      this.carrierCode = void 0;
      this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      return this.onCallingCodeChange(this.country, callingCode);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      this.international = true;
      this.initCountryAndCallingCode();
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }
      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }
      return this.digits;
    }
  }]);
  return AsYouTypeState2;
}();
var DIGIT_PLACEHOLDER = "x";
var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
function repeat(string2, times) {
  if (times < 1) {
    return "";
  }
  var result2 = "";
  while (times > 1) {
    if (times & 1) {
      result2 += string2;
    }
    times >>= 1;
    string2 += string2;
  }
  return result2 + string2;
}
function cutAndStripNonPairedParens(string2, cutBeforeIndex) {
  if (string2[cutBeforeIndex] === ")") {
    cutBeforeIndex++;
  }
  return stripNonPairedParens(string2.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string2) {
  var dangling_braces = [];
  var i2 = 0;
  while (i2 < string2.length) {
    if (string2[i2] === "(") {
      dangling_braces.push(i2);
    } else if (string2[i2] === ")") {
      dangling_braces.pop();
    }
    i2++;
  }
  var start = 0;
  var cleared_string = "";
  dangling_braces.push(string2.length);
  for (var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++) {
    var index2 = _dangling_braces[_i2];
    cleared_string += string2.slice(start, index2);
    start = index2 + 1;
  }
  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  for (var _iterator2 = digits.split(""), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ; ) {
    var _ref2;
    if (_isArray2) {
      if (_i3 >= _iterator2.length)
        break;
      _ref2 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done)
        break;
      _ref2 = _i3.value;
    }
    var digit = _ref2;
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }
    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }
  return [template, position];
}
function formatCompleteNumber(state2, format, _ref) {
  var metadata2 = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
  if (matcher.test(state2.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state2, format, {
      metadata: metadata2,
      shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata2) {
  return checkNumberLength(nationalSignificantNumber, metadata2) === "IS_POSSIBLE";
}
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state2, format, _ref2) {
  var metadata2 = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  state2.nationalSignificantNumber;
  state2.international;
  state2.nationalPrefix;
  state2.carrierCode;
  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state2, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix,
      metadata: metadata2
    });
    if (formattedNumber) {
      return formattedNumber;
    }
  }
  return formatNationalNumber(state2, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix,
    metadata: metadata2
  });
}
function formatNationalNumber(state2, format, _ref3) {
  var metadata2 = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state2.nationalSignificantNumber, format, {
    carrierCode: state2.carrierCode,
    useInternationalFormat: state2.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata2
  });
  if (!useNationalPrefixFormattingRule) {
    if (state2.nationalPrefix) {
      formattedNationalNumber = state2.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state2.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state2.complexPrefixBeforeNationalSignificantNumber + " " + formattedNationalNumber;
    }
  }
  if (isValidFormattedNationalNumber(formattedNationalNumber, state2)) {
    return formattedNationalNumber;
  }
}
function isValidFormattedNationalNumber(formattedNationalNumber, state2) {
  return parseDigits(formattedNationalNumber) === state2.getNationalDigits();
}
function _classCallCheck$3(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$3(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$3(Constructor, staticProps);
  return Constructor;
}
var PatternMatcher = /* @__PURE__ */ function() {
  function PatternMatcher2(pattern) {
    _classCallCheck$3(this, PatternMatcher2);
    this.matchTree = new PatternParser().parse(pattern);
  }
  _createClass$3(PatternMatcher2, [{
    key: "match",
    value: function match(string2) {
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
      if (!string2) {
        throw new Error("String is required");
      }
      var result2 = _match(string2.split(""), this.matchTree, true);
      if (result2 && result2.match) {
        delete result2.matchedChars;
      }
      if (result2 && result2.overflow) {
        if (!allowOverflow) {
          return;
        }
      }
      return result2;
    }
  }]);
  return PatternMatcher2;
}();
function _match(characters, tree, last) {
  if (typeof tree === "string") {
    if (last) {
      if (characters.length > tree.length) {
        return {
          overflow: true
        };
      }
    }
    var characterString = characters.join("");
    if (tree.indexOf(characterString) === 0) {
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      }
      return {
        partialMatch: true
      };
    }
    if (characterString.indexOf(tree) === 0) {
      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }
    return;
  }
  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i2 = 0;
    while (i2 < tree.length) {
      var subtree = tree[i2];
      var result2 = _match(restCharacters, subtree, last && i2 === tree.length - 1);
      if (!result2) {
        return;
      } else if (result2.overflow) {
        return result2;
      } else if (result2.match) {
        restCharacters = restCharacters.slice(result2.matchedChars.length);
        if (restCharacters.length === 0) {
          if (i2 === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true
            };
          }
        }
      } else {
        if (result2.partialMatch) {
          return {
            partialMatch: true
          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result2, null, 2)));
        }
      }
      i2++;
    }
    if (last) {
      return {
        overflow: true
      };
    }
    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }
  switch (tree.op) {
    case "|":
      var partialMatch;
      for (var _iterator = tree.args, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
        var _ref2;
        if (_isArray) {
          if (_i >= _iterator.length)
            break;
          _ref2 = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done)
            break;
          _ref2 = _i.value;
        }
        var branch = _ref2;
        var _result = _match(characters, branch, last);
        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }
      if (partialMatch) {
        return {
          partialMatch: true
        };
      }
      return;
    case "[]":
      for (var _iterator2 = tree.args, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ; ) {
        var _ref3;
        if (_isArray2) {
          if (_i2 >= _iterator2.length)
            break;
          _ref3 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done)
            break;
          _ref3 = _i2.value;
        }
        var _char = _ref3;
        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }
          if (last) {
            return {
              overflow: true
            };
          }
          return {
            match: true,
            matchedChars: [_char]
          };
        }
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}
var OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var PatternParser = /* @__PURE__ */ function() {
  function PatternParser2() {
    _classCallCheck$3(this, PatternParser2);
  }
  _createClass$3(PatternParser2, [{
    key: "parse",
    value: function parse2(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);
      if (this.context.length !== 1) {
        throw new Error("Non-finalized contexts left when pattern parse ended");
      }
      var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
      if (branches) {
        return [{
          op: "|",
          args: branches.concat([instructions])
        }];
      }
      if (instructions.length === 0) {
        throw new Error("Pattern is required");
      }
      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context2) {
      this.context.push(context2);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error("Pattern is required");
      }
      var match = pattern.match(OPERATOR);
      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }
        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(""));
        return;
      }
      var operator = match[1];
      var before2 = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);
      switch (operator) {
        case "(?:":
          if (before2) {
            this.parsePattern(before2);
          }
          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }
          if (before2) {
            this.parsePattern(before2);
          }
          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }
          var _this$getContext = this.getContext(), branches = _this$getContext.branches;
          branches.push(this.getContext().instructions);
          this.endContext();
          this.getContext().instructions.push({
            op: "|",
            args: branches
          });
          break;
        case "|":
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }
          if (before2) {
            this.parsePattern(before2);
          }
          if (!this.getContext().branches) {
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }
          this.getContext().branches.push(this.getContext().instructions);
          this.getContext().instructions = [];
          break;
        case "[":
          if (before2) {
            this.parsePattern(before2);
          }
          this.startContext({
            oneOfSet: true
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }
          this.endContext();
          this.getContext().instructions.push({
            op: "[]",
            args: parseOneOfSet(before2)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(operator));
      }
      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);
  return PatternParser2;
}();
function parseOneOfSet(pattern) {
  var values = [];
  var i2 = 0;
  while (i2 < pattern.length) {
    if (pattern[i2] === "-") {
      if (i2 === 0 || i2 === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }
      var prevValue = pattern[i2 - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i2 + 1].charCodeAt(0) - 1;
      var value = prevValue;
      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i2]);
    }
    i2++;
  }
  return values;
}
function _classCallCheck$2(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DUMMY_DIGIT = "9";
var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);
var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/;
var CREATE_CHARACTER_CLASS_PATTERN = function() {
  return /\[([^\[\]])*\]/g;
};
var CREATE_STANDALONE_DIGIT_PATTERN = function() {
  return /\d(?=[^,}][^,}])/g;
};
var NON_ALTERING_FORMAT_REG_EXP = new RegExp("^[" + VALID_PUNCTUATION + "]*(\\$\\d[" + VALID_PUNCTUATION + "]*)+$");
var MIN_LEADING_DIGITS_LENGTH = 3;
var AsYouTypeFormatter = /* @__PURE__ */ function() {
  function AsYouTypeFormatter2(_ref) {
    var _this = this;
    _ref.state;
    var metadata2 = _ref.metadata;
    _classCallCheck$2(this, AsYouTypeFormatter2);
    _defineProperty(this, "getSeparatorAfterNationalPrefix", function(format) {
      if (_this.isNANP) {
        return " ";
      }
      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return " ";
      }
      return "";
    });
    _defineProperty(this, "shouldTryNationalPrefixFormattingRule", function(format, _ref2) {
      var international = _ref2.international, nationalPrefix = _ref2.nationalPrefix;
      if (format.nationalPrefixFormattingRule()) {
        var usesNationalPrefix = format.usesNationalPrefix();
        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    });
    this.metadata = metadata2;
    this.resetFormat();
  }
  _createClass$2(AsYouTypeFormatter2, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = void 0;
      this.template = void 0;
      this.nationalNumberTemplate = void 0;
      this.populatedNationalNumberTemplate = void 0;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state2) {
      this.resetFormat();
      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === "1";
        this.matchingFormats = numberingPlan.formats();
        if (state2.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state2);
        }
      } else {
        this.isNANP = void 0;
        this.matchingFormats = [];
      }
    }
  }, {
    key: "format",
    value: function format(nextDigits, state2) {
      var _this2 = this;
      if (canFormatCompleteNumber(state2.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
          var _ref3;
          if (_isArray) {
            if (_i >= _iterator.length)
              break;
            _ref3 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done)
              break;
            _ref3 = _i.value;
          }
          var format2 = _ref3;
          var formattedCompleteNumber = formatCompleteNumber(state2, format2, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format3) {
              return _this2.shouldTryNationalPrefixFormattingRule(format3, {
                international: state2.international,
                nationalPrefix: state2.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
          });
          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format2;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state2);
            this.populatedNationalNumberTemplate = formattedCompleteNumber;
            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      }
      return this.formatNationalNumberWithNextDigits(nextDigits, state2);
    }
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state2) {
      var previouslyChosenFormat = this.chosenFormat;
      var newlyChosenFormat = this.chooseFormat(state2);
      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          return this.formatNextNationalNumberDigits(state2.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref4) {
      var _this3 = this;
      var nationalSignificantNumber = _ref4.nationalSignificantNumber, nationalPrefix = _ref4.nationalPrefix, international = _ref4.international;
      var leadingDigits = nationalSignificantNumber;
      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;
      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }
      this.matchingFormats = this.matchingFormats.filter(function(format) {
        return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      });
      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      if (nationalPrefix && !format.usesNationalPrefix() && !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      }
      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }
      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length;
      if (leadingDigitsPatternsCount === 0) {
        return true;
      }
      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex];
      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        try {
          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== void 0;
        } catch (error3) {
          console.error(error3);
          return true;
        }
      }
      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state2) {
      var _this4 = this;
      var _loop2 = function _loop22() {
        if (_isArray2) {
          if (_i2 >= _iterator2.length)
            return "break";
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done)
            return "break";
          _ref5 = _i2.value;
        }
        var format = _ref5;
        if (_this4.chosenFormat === format) {
          return "break";
        }
        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state2.international))) {
          return "continue";
        }
        if (!_this4.createTemplateForFormat(format, state2)) {
          _this4.matchingFormats = _this4.matchingFormats.filter(function(_24) {
            return _24 !== format;
          });
          return "continue";
        }
        _this4.chosenFormat = format;
        return "break";
      };
      _loop:
        for (var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ; ) {
          var _ref5;
          var _ret = _loop2();
          switch (_ret) {
            case "break":
              break _loop;
            case "continue":
              continue;
          }
        }
      if (!this.chosenFormat) {
        this.resetFormat();
      }
      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state2) {
      if (format.pattern().indexOf("|") >= 0) {
        return;
      }
      var template = this.getTemplateForFormat(format, state2);
      if (template) {
        this.setNationalNumberTemplate(template, state2);
        return true;
      }
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
      var IDDPrefix = _ref6.IDDPrefix, missingPlus = _ref6.missingPlus;
      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + " ";
      }
      if (missingPlus) {
        return "";
      }
      return "+";
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state2) {
      if (!this.template) {
        return;
      }
      var index2 = -1;
      var i2 = 0;
      var internationalPrefix = state2.international ? this.getInternationalPrefixBeforeCountryCallingCode(state2, {
        spacing: false
      }) : "";
      while (i2 < internationalPrefix.length + state2.getDigitsWithoutInternationalPrefix().length) {
        index2 = this.template.indexOf(DIGIT_PLACEHOLDER, index2 + 1);
        i2++;
      }
      return cutAndStripNonPairedParens(this.template, index2 + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state2) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template;
      this.populatedNationalNumberTemplatePosition = -1;
      if (state2.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state2).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state2.callingCode.length) + " " + template;
      } else {
        this.template = template;
      }
    }
  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref7) {
      var nationalSignificantNumber = _ref7.nationalSignificantNumber, international = _ref7.international, nationalPrefix = _ref7.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      {
        pattern = pattern.replace(CREATE_CHARACTER_CLASS_PATTERN(), "\\d").replace(CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
      }
      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0];
      if (nationalSignificantNumber.length > digits.length) {
        return;
      }
      var strictPattern = new RegExp("^" + pattern + "$");
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT);
      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }
      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate;
      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international,
        nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule());
        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || "") + parseDigits("$1")) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true;
          if (nationalPrefix) {
            var i2 = nationalPrefix.length;
            while (i2 > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i2--;
            }
          }
        }
      }
      var template = digits.replace(new RegExp(pattern), numberFormat).replace(new RegExp(DUMMY_DIGIT, "g"), DIGIT_PLACEHOLDER);
      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + " " + template;
        } else if (nationalPrefix) {
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }
      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }
      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result2 = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
      if (!result2) {
        this.resetFormat();
        return;
      }
      this.populatedNationalNumberTemplate = result2[0];
      this.populatedNationalNumberTemplatePosition = result2[1];
      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }]);
  return AsYouTypeFormatter2;
}();
function _slicedToArray$1(arr2, i2) {
  return _arrayWithHoles$1(arr2) || _iterableToArrayLimit$1(arr2, i2) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$1(arr2, i2) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e2 = void 0;
  try {
    for (var _i = arr2[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function _classCallCheck$1(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  return Constructor;
}
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+";
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i");
var VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + PLUS_CHARS + "][" + VALID_PUNCTUATION + VALID_DIGITS + "]*|[" + VALID_PUNCTUATION + VALID_DIGITS + "]+)";
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$");
var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var AsYouTypeParser = /* @__PURE__ */ function() {
  function AsYouTypeParser2(_ref) {
    var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata2 = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
    _classCallCheck$1(this, AsYouTypeParser2);
    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata2;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }
  _createClass$1(AsYouTypeParser2, [{
    key: "input",
    value: function input(text, state2) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text), _extractFormattedDigi2 = _slicedToArray$1(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
      var digits = parseDigits(formattedDigits);
      var justLeadingPlus;
      if (hasPlus) {
        if (!state2.digits) {
          state2.startInternationalNumber();
          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }
      if (digits) {
        this.inputDigits(digits, state2);
      }
      return {
        digits,
        justLeadingPlus
      };
    }
  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state2) {
      var digits = state2.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3;
      state2.appendDigits(nextDigits);
      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state2);
      }
      if (this.isWaitingForCountryCallingCode(state2)) {
        if (!this.extractCountryCallingCode(state2)) {
          return;
        }
      } else {
        state2.appendNationalSignificantNumberDigits(nextDigits);
      }
      if (!state2.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state2.getNationalDigits(), state2.update);
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international, callingCode = _ref2.callingCode;
      return international && !callingCode;
    }
  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state2) {
      var _extractCountryCallin = extractCountryCallingCode("+" + state2.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
      if (countryCallingCode) {
        state2.setCallingCode(countryCallingCode);
        state2.update({
          nationalSignificantNumber: number2
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;
        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = void 0;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
      }
    }
  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }
      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
      if (nationalNumber === nationalDigits) {
        return;
      }
      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }
      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }
      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode;
      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }
      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput;
      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber);
      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true;
        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex);
        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }
      setState({
        nationalPrefix,
        carrierCode,
        nationalSignificantNumber,
        nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber
      });
      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state2) {
      if (this.extractAnotherNationalSignificantNumber(state2.getNationalDigits(), state2.nationalSignificantNumber, state2.update)) {
        return true;
      }
      if (this.extractIddPrefix(state2)) {
        this.extractCallingCodeAndNationalSignificantNumber(state2);
        return true;
      }
      if (this.fixMissingPlus(state2)) {
        this.extractCallingCodeAndNationalSignificantNumber(state2);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state2) {
      var international = state2.international, IDDPrefix = state2.IDDPrefix, digits = state2.digits;
      state2.nationalSignificantNumber;
      if (international || IDDPrefix) {
        return;
      }
      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
      if (numberWithoutIDD !== void 0 && numberWithoutIDD !== digits) {
        state2.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state2);
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state2) {
      if (!state2.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state2.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode;
        _extractCountryCallin2.number;
        if (newCallingCode) {
          state2.update({
            missingPlus: true
          });
          this.startInternationalNumber(state2);
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state2) {
      state2.startInternationalNumber();
      if (state2.nationalSignificantNumber) {
        state2.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = void 0;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state2) {
      if (this.extractCountryCallingCode(state2)) {
        this.extractNationalSignificantNumber(state2.getNationalDigits(), state2.update);
      }
    }
  }]);
  return AsYouTypeParser2;
}();
function extractFormattedPhoneNumber(text) {
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (startsAt < 0) {
    return;
  }
  text = text.slice(startsAt);
  var hasPlus;
  if (text[0] === "+") {
    hasPlus = true;
    text = text.slice("+".length);
  }
  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, "");
  if (hasPlus) {
    text = "+" + text;
  }
  return text;
}
function _extractFormattedDigitsAndPlus(text) {
  var extractedNumber = extractFormattedPhoneNumber(text) || "";
  if (extractedNumber[0] === "+") {
    return [extractedNumber.slice("+".length), true];
  }
  return [extractedNumber];
}
function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = _slicedToArray$1(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1];
  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = "";
  }
  return [formattedDigits, hasPlus];
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _slicedToArray(arr2, i2) {
  return _arrayWithHoles(arr2) || _iterableToArrayLimit(arr2, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr2, i2) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e2 = void 0;
  try {
    for (var _i = arr2[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
var AsYouType$1 = /* @__PURE__ */ function() {
  function AsYouType2(optionsOrDefaultCountry, metadata2) {
    _classCallCheck(this, AsYouType2);
    this.metadata = new Metadata(metadata2);
    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = _slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }
  _createClass(AsYouType2, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      var defaultCountry;
      var defaultCallingCode;
      if (optionsOrDefaultCountry) {
        if (_typeof(optionsOrDefaultCountry) === "object") {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }
      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = void 0;
      }
      return [defaultCountry, defaultCallingCode];
    }
  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
      if (justLeadingPlus) {
        this.formattedOutput = "+";
      } else if (digits) {
        this.determineTheCountryIfNeeded();
        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }
        var formattedNationalNumber;
        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }
        if (formattedNationalNumber === void 0) {
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded();
            var nationalDigits = this.state.getNationalDigits();
            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }
        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;
      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
          _this.metadata.selectNumberingPlan(country, callingCode);
          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();
          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = "";
      return this;
    }
  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    }
  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode2() {
      return this.getCallingCode();
    }
  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits;
      if (digits) {
        return this._getCountry();
      }
    }
  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;
      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    }
  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;
      if (this.isInternational()) {
        var prefix2 = function prefix3(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };
        var callingCode = this.state.callingCode;
        if (!callingCode) {
          return prefix2("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }
        if (!formattedNationalNumber) {
          return prefix2(callingCode);
        }
        return prefix2("".concat(callingCode, " ").concat(formattedNationalNumber));
      }
      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
      var number2 = nationalSignificantNumber;
      var prefix2 = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
      if (prefix2) {
        number2 = prefix2 + number2;
      }
      return number2;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number2 = this.getNonFormattedNumber();
      if (number2) {
        return number2.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    }
  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber;
      if (!digits) {
        return;
      }
      if (this.isInternational()) {
        if (callingCode) {
          return "+" + callingCode + nationalSignificantNumber;
        } else {
          return "+" + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return "+" + callingCode_ + nationalSignificantNumber;
        }
      }
    }
  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode;
      var country = this._getCountry();
      if (!nationalSignificantNumber) {
        return;
      }
      if (!country && !callingCode) {
        return;
      }
      var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      }
      return phoneNumber;
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();
      if (!phoneNumber) {
        return false;
      }
      return phoneNumber.isPossible();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();
      if (!phoneNumber) {
        return false;
      }
      return phoneNumber.isValid();
    }
  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]);
  return AsYouType2;
}();
function parsePhoneNumberFromString() {
  return withMetadata(parsePhoneNumberFromString$1, arguments);
}
function AsYouType(country) {
  return AsYouType$1.call(this, country, metadata);
}
AsYouType.prototype = Object.create(AsYouType$1.prototype, {});
AsYouType.prototype.constructor = AsYouType;
const getOnboardingStatusUrl = (interviewId) => `/omni/get/onboarding/status?=${interviewId}`;
function getOnboardingStatus(token) {
  return api.get(getOnboardingStatusUrl(token.interviewId), null, {
    headers: {
      "X-Incode-Hardware-Id": token.token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
}
function sendRedirectSMS({ token, smsType }) {
  return api.post("/omni/notify/send-sms", { smsType }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
var phone = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU0IiBoZWlnaHQ9IjMyMCIgdmlld0JveD0iMCAwIDE1NCAzMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIxNTEuOTI3IiBoZWlnaHQ9IjMxNy45MjEiIHJ4PSIxNy41ODQxIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjODA4NjhGIiBzdHJva2Utd2lkdGg9IjEuMDU1MDUiLz4KPHJlY3QgeD0iNTguNjc2IiB5PSIxNi40NzQiIHdpZHRoPSIzNy42MzAxIiBoZWlnaHQ9IjEwLjU1MDUiIHJ4PSI1LjI3NTI0IiBmaWxsPSIjRUNFRkYyIi8+CjxyZWN0IHg9IjYwLjQzNDIiIHk9IjE1Ljc3MDYiIHdpZHRoPSIzMy4wNTgyIiBoZWlnaHQ9IjcuMzg1MzQiIHJ4PSIzLjY5MjY3IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjODA4NjhGIiBzdHJva2Utd2lkdGg9IjAuNzAzMzY2Ii8+CjxyZWN0IHg9IjY0LjY1NDgiIHk9IjE4LjU4NDIiIHdpZHRoPSIyNC42MTc4IiBoZWlnaHQ9IjEuNzU4NDEiIHJ4PSIwLjg3OTIwNyIgZmlsbD0iI0VDRUZGMiIvPgo8Y2lyY2xlIGN4PSI3Ni43ODc3IiBjeT0iMzAwLjQ1OCIgcj0iMTMuNTM5OCIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzgwODY4RiIgc3Ryb2tlLXdpZHRoPSIwLjcwMzM2NiIvPgo8Y2lyY2xlIGN4PSI3Ni43ODc1IiBjeT0iMzAwLjQ1OCIgcj0iNy41NjExOCIgZmlsbD0iI0VDRUZGMiIvPgo8cmVjdCB4PSIxMS41NTAzIiB5PSIzNS44MTY2IiB3aWR0aD0iMTM2LjQ1MyIgaGVpZ2h0PSIyNDIuMzA5IiByeD0iNS4yNzUyNCIgZmlsbD0iI0VDRUZGMiIvPgo8cmVjdCB4PSI1LjU3MjAyIiB5PSIzNy41NzUxIiB3aWR0aD0iMTQwLjY3MyIgaGVpZ2h0PSIyNDUuNDc1IiByeD0iMy41MTY4MyIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iOS4wODg1IiB5PSIzOC45ODE4IiB3aWR0aD0iMTM1Ljc1IiBoZWlnaHQ9IjI0MS42MDYiIHJ4PSI0LjkyMzU2IiBmaWxsPSIjRUNFRkYyIiBzdHJva2U9IiM4MDg2OEYiIHN0cm9rZS13aWR0aD0iMC43MDMzNjYiLz4KPC9zdmc+Cg==";
var welcomeLogo = "data:image/svg+xml;base64,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";
const getStartInfoUrl = () => `/omni/start-info`;
const getStartInfo = ({ token }) => {
  return api.get(getStartInfoUrl(), null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => {
    return response.data;
  }).catch((e2) => Promise.reject(e2.response.data));
};
const asYouType = new AsYouType();
const RedirectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  flex-direction: row;
`;
const Title$3 = styled.h1`
  width: 500px;
  text-align: center;
  font-size: 24px;
  padding: 0 15px;
  font-weight: bold;
`;
const QrContainer = styled.div`
  background-color: #eceff2;
  padding: 30px;
  border-radius: 12px;
`;
const List = styled.ul`
  list-style-type: disc;
  color: #bebebe;
  width: 350px;
  font-size: 18px;
  line-height: 1.2em;
`;
const Item = styled.li`
  margin-bottom: 5px;
`;
const VerticalLine = styled.div`
  border-left: 2px solid #cccccc;
  height: 260px;
  flex-direction: row;
`;
const QrItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const SeparatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Paragraph$1 = styled.p`
  margin: 35px 0;
`;
const Input = styled.input`
  width: 250px;
  height: 50px;
  border: 1px solid #b6b6b6;
  border-radius: 5px;
  font-size: 24px;
  color: #858996;
  margin-bottom: 20px;
  text-align: center;
`;
const Image$1 = styled.img`
  height: 225px;
`;
const Logo = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  max-width: 150px;
`;
const SmsSentContainer = styled.div`
  width: 400px;
  height: 60px;
  background-color: #0cd5a2;
  padding: 10px;
  white-space: pre-wrap;
  text-align: center;
`;
const SmsSentParagraph = styled.p`
  color: #ffffff;
  margin: 0;
  font-size: 16px;
`;
const ResendParagraph = styled.p`
  color: #00b2fd;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
`;
const ContinueButton = styled.button`
  position: absolute;
  top: 40px;
  right: 40px;
  border-radius: 50px;
  padding: 19px 32px;
  border: 1px solid;
`;
const envUrls = {
  stage: "https://onboarding.incodesmile.com",
  demo: "https://demo-onboarding.incodesmile.com",
  saas: "https://saas-onboarding.incodesmile.com",
  saaseu: "https://saaseu-onboarding.incode.com",
  banorte: "https://banorte-onboarding.incodesmile.com/incode",
  gbm: "https://onboarding.omni.gbmapi.com/incode"
};
function Redirect({
  session,
  flowId,
  onSuccess,
  url,
  showSms,
  allowReEnrollment,
  externalId,
  assets,
  expired,
  smsText,
  skipDesktopRedirect,
  allowSkipRedirect = false
}) {
  const {
    t: t2
  } = useTranslation();
  const [formattedNumber, setFormattedNumber] = useState("");
  const [loading, setLoading] = useState(null);
  const [number2, setNumber] = useState();
  const [disabled, setDisabled] = useState(true);
  const [smsSent, setSmsSent] = useState(false);
  const [isReEnrollSession, setIsReEnrollSession] = useState(false);
  const [logoSrc, setLogoSrc] = useState();
  useEffect(() => addEvent({
    token: session.token,
    eventName: "qrCodeShown",
    eventData: {},
    eventType: "text"
  }), [session]);
  useEffect(() => {
    getOnboardingStatus(session).then((res) => {
      if ((res == null ? void 0 : res.onboardingStatus) === "ONBOARDING_FINISHED" && allowReEnrollment && !expired) {
        setIsReEnrollSession(true);
      }
    });
    getStartInfo(session).then((res) => {
      setFormattedNumber(res.phonePrefix);
    });
  }, []);
  useEffect(() => {
    if (!assets) {
      return;
    }
    const {
      logo
    } = assets;
    if (!logo) {
      setLogoSrc(welcomeLogo);
      return;
    }
    setLogoSrc(logo);
  }, [assets]);
  const handleFlowSuccessRedirection = async () => {
    try {
      const {
        redirectionUrl = ""
      } = await getFinishStatus(flowId, session);
      sleep(3e3);
      if (Boolean(redirectionUrl)) {
        window.location.replace(redirectionUrl);
        return;
      }
    } catch (e2) {
      console.error(e2, "finish");
    }
  };
  useInterval(() => {
    getOnboardingStatus(session).then((res) => {
      if (isReEnrollSession) {
        if ((res == null ? void 0 : res.onboardingStatus) !== "ONBOARDING_FINISHED") {
          setIsReEnrollSession(false);
        }
      } else if ((res == null ? void 0 : res.onboardingStatus) === "ONBOARDING_FINISHED") {
        onSuccess(res);
        handleFlowSuccessRedirection();
      }
    }).catch(emptyFunc);
  }, 5e3);
  const getUrl = () => {
    if (url && (allowReEnrollment || !expired) && externalId) {
      const newUrl = new URL(url);
      const params = new URLSearchParams(url.search);
      params.append("interviewId", session == null ? void 0 : session.interviewId);
      params.append("externalId", externalId);
      return `${newUrl == null ? void 0 : newUrl.href}${session.clientId}${flowId ? `/flow/${flowId}` : ""}?${params}`;
    }
    return url || `${envUrls[session.env]}/${session.clientId}${flowId ? `/flow/${flowId}` : ""}?interviewId=${session == null ? void 0 : session.interviewId}`;
  };
  const redirectUrl = getUrl();
  function handleChange({
    target: {
      value
    }
  }) {
    const number22 = parsePhoneNumberFromString(value);
    const format = asYouType.input(value);
    setFormattedNumber(format);
    asYouType.reset();
    if (number22 && number22.isValid()) {
      setNumber(value);
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }
  const getText = () => {
    return `${smsText} ${getUrl()}`;
  };
  const handleButtonClick = async () => {
    setLoading(true);
    addEvent({
      token: session.token,
      eventName: "userClickedSendSms",
      eventData: {},
      eventType: "text"
    });
    await addPhone(__spreadValues({
      phone: number2,
      token: session.token
    }, smsText && {
      text: getText()
    }));
    if (!smsText) {
      await sendRedirectSMS({
        smsType: "DESKTOP_ONBOARDING",
        token: session.token
      });
    }
    setLoading(false);
    setSmsSent(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(RedirectContainer, {
      children: [allowSkipRedirect ? /* @__PURE__ */ jsx(ContinueButton, {
        onClick: skipDesktopRedirect,
        children: t2("redirect.continueOnDesktop")
      }) : null, /* @__PURE__ */ jsxs(QrItemContainer, {
        children: [/* @__PURE__ */ jsx(QrContainer, {
          children: /* @__PURE__ */ jsx(_default, {
            value: redirectUrl,
            bgColor: "#eceff2",
            size: 150
          })
        }), /* @__PURE__ */ jsx(Title$3, {
          children: t2("redirect.scanQrTitle")
        }), /* @__PURE__ */ jsxs(List, {
          children: [/* @__PURE__ */ jsx(Item, {
            children: t2("redirect.scanQrParagraph1")
          }), /* @__PURE__ */ jsx(Item, {
            children: t2("redirect.scanQrParagraph2")
          }), /* @__PURE__ */ jsx(Item, {
            children: t2("redirect.scanQrParagraph3")
          })]
        })]
      }), showSms && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs(SeparatorContainer, {
          children: [/* @__PURE__ */ jsx(VerticalLine, {}), /* @__PURE__ */ jsx(Paragraph$1, {
            children: t2("common.or")
          }), /* @__PURE__ */ jsx(VerticalLine, {})]
        }), /* @__PURE__ */ jsxs(QrItemContainer, {
          children: [/* @__PURE__ */ jsx(Image$1, {
            src: phone,
            alt: "mobile device"
          }), /* @__PURE__ */ jsx(Title$3, {
            children: t2("redirect.sendLink")
          }), /* @__PURE__ */ jsx(Input, {
            autoComplete: "off",
            type: "tel",
            onChange: handleChange,
            value: formattedNumber
          }), /* @__PURE__ */ jsx(List, {
            children: /* @__PURE__ */ jsx(Item, {
              children: t2("redirect.linkParagraph")
            })
          }), smsSent ? /* @__PURE__ */ jsx(SmsSentContainer, {
            children: /* @__PURE__ */ jsx(SmsSentParagraph, {
              children: /* @__PURE__ */ jsxs(Trans, {
                i18nKey: "redirect.succesfullySent",
                t: t2,
                children: ["SMS succesfully sent.", /* @__PURE__ */ jsx("br", {}), "The link will expire in 15 minutes."]
              })
            })
          }) : /* @__PURE__ */ jsx(Button$3, {
            disabled: disabled || loading,
            onClick: handleButtonClick,
            children: t2("common.send")
          }), smsSent && /* @__PURE__ */ jsx(ResendParagraph, {
            onClick: () => {
              setSmsSent(false);
              handleButtonClick();
            },
            children: t2("redirect.linkNotReceived")
          })]
        })]
      })]
    }), logoSrc && /* @__PURE__ */ jsx(Logo, {
      src: logoSrc
    })]
  });
}
function renderRedirectToMobile(element, {
  onSuccess,
  session,
  flowId,
  logoSrc,
  url,
  showSms = true,
  allowReEnrollment = true,
  externalId,
  assets,
  expired,
  smsText,
  skipDesktopRedirect,
  allowSkipRedirect
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    session,
    flowId,
    logoSrc,
    url,
    showSms,
    allowReEnrollment,
    externalId,
    assets,
    expired,
    smsText,
    skipDesktopRedirect,
    allowSkipRedirect
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(Redirect, __spreadValues({}, props))
  }), element);
}
const addBarcode = ({ token, rawBarcode }) => {
  return api.post("/omni/add/barcode", { rawBarcode }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
};
const attemptFinished = ({ token }) => {
  return api.post("/omni/attempt-finished", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
};
var backgroundId = "data:image/png;base64,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";
const ShowInstructions = ({
  goNext,
  token
}) => {
  useEffect(() => {
    if (token == null ? void 0 : token.token) {
      addEvent({
        token: token.token,
        eventName: "retryInstructions",
        eventData: {},
        eventType: "text"
      });
    }
  }, [token]);
  function handleClick() {
    addEvent({
      token: token == null ? void 0 : token.token,
      eventName: "retryInstructionContinue",
      eventData: {},
      eventType: "text"
    });
    goNext();
  }
  return /* @__PURE__ */ jsxs("div", {
    style: {
      padding: "0 30px 10px 30px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      justifyContent: "space-around"
    },
    children: [/* @__PURE__ */ jsxs("div", {
      style: {
        textAlign: "center"
      },
      children: [/* @__PURE__ */ jsx("h1", {
        className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleInstructions",
        style: {
          fontSize: "28px"
        },
        children: "Retake capture"
      }), /* @__PURE__ */ jsx("p", {
        style: {
          fontSize: "14px"
        },
        children: "There was an error in taking the capture, we will need you to retake a photo."
      })]
    }), /* @__PURE__ */ jsx("img", {
      src: backgroundId,
      style: {
        width: "100%"
      },
      alt: "id blur"
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(Button$3, {
        onClick: handleClick,
        children: "Retake"
      })
    })]
  });
};
const ProcessId = ({
  token,
  goNext,
  callProcessFace
}) => {
  useEffect(() => {
    const dataPromise = processId({
      token: token.token
    }).then(() => {
      if (callProcessFace) {
        return processFace({
          token: token.token
        });
      }
    }).catch(console.log);
    const sleepPromise = sleep(3e3);
    Promise.all([dataPromise, sleepPromise]).then(() => {
      goNext();
    });
  }, [token.token, goNext, callProcessFace]);
  return /* @__PURE__ */ jsx(Spinner$2, {});
};
const RetrySteps = ({
  token,
  onSuccess,
  onBoarding,
  numberOfTries,
  onError,
  showPassport
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [stepsToRetry, setStepsToRetry] = useState([]);
  const {
    currentStep,
    setStep,
    nextStep
  } = useSteps();
  useEffect(() => {
    if (!isLoading)
      return;
    async function finishRetry() {
      var _a;
      await attemptFinished({
        token: token.token
      }).catch(console.log);
      const {
        retryInfo
      } = await getScore({
        token: token.token
      });
      if (!(retryInfo == null ? void 0 : retryInfo.stepsToRetry) || ((_a = retryInfo == null ? void 0 : retryInfo.stepsToRetry) == null ? void 0 : _a.length) === 0) {
        onSuccess();
        return;
      }
      setStep(0);
      setStepsToRetry(retryInfo == null ? void 0 : retryInfo.stepsToRetry);
      setIsLoading(false);
    }
    finishRetry();
  }, [token.token, onSuccess, setStep, isLoading]);
  const reset = useCallback(() => {
    setIsLoading(true);
    setStepsToRetry([]);
  }, []);
  if (isLoading) {
    return /* @__PURE__ */ jsx(Spinner$2, {});
  }
  if (stepsToRetry.length === 0) {
    return null;
  }
  const handleFrontIdSuccess = async (response) => {
    if (response.typeOfId === "Passport" && !showPassport) {
      setStep(currentStep + 2);
      return;
    }
    nextStep();
  };
  return /* @__PURE__ */ jsx(NotificationProvider, {
    initialValue: {
      isOpen: false
    },
    children: /* @__PURE__ */ jsxs(Steps, {
      currentStep,
      children: [/* @__PURE__ */ jsx(ShowInstructions, {
        goNext: nextStep,
        token
      }), (stepsToRetry == null ? void 0 : stepsToRetry.includes("frontId")) && /* @__PURE__ */ jsx(CaptureAndTutorial$2, {
        onSuccess: handleFrontIdSuccess,
        onError,
        onBoarding,
        numberOfTries,
        type: showPassport ? "passport" : onBoarding.frontType,
        token,
        timeout: 4e4,
        sendBase64: true,
        showPreview: false,
        nativeCamera: false,
        hideRetake: false,
        showTutorial: true,
        onlyCapture: false,
        scanPdf417: false,
        showCustomCameraPermissionScreen: false,
        onLog: emptyFunc,
        isRetry: !showPassport && !(stepsToRetry == null ? void 0 : stepsToRetry.includes("backId"))
      }), (stepsToRetry == null ? void 0 : stepsToRetry.includes("backId")) && /* @__PURE__ */ jsx(CaptureAndTutorial$1, {
        onSuccess: nextStep,
        onError,
        onBoarding,
        numberOfTries,
        type: onBoarding.backType,
        token,
        timeout: 4e4,
        sendBase64: true,
        showPreview: false,
        nativeCamera: false,
        hideRetake: false,
        showTutorial: true,
        onlyCapture: false,
        scanPdf417: false,
        showCustomCameraPermissionScreen: false,
        onLog: emptyFunc,
        isRetry: !(stepsToRetry == null ? void 0 : stepsToRetry.includes("frontId"))
      }), ((stepsToRetry == null ? void 0 : stepsToRetry.includes("backId")) || (stepsToRetry == null ? void 0 : stepsToRetry.includes("frontId"))) && /* @__PURE__ */ jsx(ProcessId, {
        goNext: reset,
        token,
        callProcessFace: stepsToRetry == null ? void 0 : stepsToRetry.includes("frontId")
      })]
    })
  });
};
function renderRetrySteps(element, {
  token,
  numberOfTries,
  showPassport
}, {
  onSuccess,
  onError
}) {
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onError: handleUnmount(onError, element)
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(RetrySteps, {
      onBoarding: this,
      token,
      onSuccess: props.onSuccess,
      numberOfTries,
      onError: props.onError,
      showPassport
    })
  }), element);
}
function addWatchListResults({ token, firstName = null, lastName = null }) {
  return api.post(`/omni/watchlist-result`, {
    firstName,
    lastName,
    subscribe: true
  }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function initWatchList({ token }) {
  return api.post(`/omni/init-watchlist`, {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function addFrontSecondId({ token, image: image2, onProgress = emptyFunc }) {
  return api.post(`/omni/add/front-second-id`, image2, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "image/jpeg"
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
const getCustomFields = ({ token }) => {
  return api.get("/omni/get/custom-fields", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
};
const addEmail = ({ token, email }) => {
  return api.post("/omni/add/email", { email }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
};
function getImages({ token, body }) {
  return api.post("/omni/get/images/v2", body, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function hasClass(element, className) {
  if (element.classList)
    return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
function addClass(element, className) {
  if (element.classList)
    element.classList.add(className);
  else if (!hasClass(element, className))
    if (typeof element.className === "string")
      element.className = element.className + " " + className;
    else
      element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
}
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === "string") {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
  }
}
var config = {
  disabled: false
};
var TransitionGroupContext = React__default.createContext(null);
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context2) {
    var _this;
    _this = _React$Component.call(this, props, context2) || this;
    var parentGroup = context2;
    var appear2 = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear2) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear2;
    exit = enter = appear2 = timeout;
    if (timeout != null && typeof timeout !== "number") {
      exit = timeout.exit;
      enter = timeout.enter;
      appear2 = timeout.appear !== void 0 ? timeout.appear : enter;
    }
    return {
      exit,
      enter,
      appear: appear2
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: null
    }, typeof children === "function" ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps));
  };
  return Transition2;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = {};
function noop() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;
var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(" ").forEach(function(c2) {
    return addClass(node, c2);
  });
};
var removeClass = function removeClass2(node, classes) {
  return node && classes && classes.split(" ").forEach(function(c2) {
    return removeClass$1(node, c2);
  });
};
var CSSTransition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(CSSTransition2, _React$Component);
  function CSSTransition2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
      _this.removeClasses(node, "exit");
      _this.addClass(node, appearing ? "appear" : "enter", "base");
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
      var type = appearing ? "appear" : "enter";
      _this.addClass(node, type, "active");
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
      var type = appearing ? "appear" : "enter";
      _this.removeClasses(node, type);
      _this.addClass(node, type, "done");
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function(maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
      _this.removeClasses(node, "appear");
      _this.removeClasses(node, "enter");
      _this.addClass(node, "exit", "base");
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function(maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
      _this.addClass(node, "exit", "active");
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function(maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
      _this.removeClasses(node, "exit");
      _this.addClass(node, "exit", "done");
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function(maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function(type) {
      var classNames2 = _this.props.classNames;
      var isStringClassNames = typeof classNames2 === "string";
      var prefix2 = isStringClassNames && classNames2 ? classNames2 + "-" : "";
      var baseClassName = isStringClassNames ? "" + prefix2 + type : classNames2[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames2[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames2[type + "Done"];
      return {
        baseClassName,
        activeClassName,
        doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition2.prototype;
  _proto.addClass = function addClass2(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
    if (type === "appear" && phase === "done" && doneClassName) {
      className += " " + doneClassName;
    }
    if (phase === "active") {
      node && node.scrollTop;
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
    _this$props.classNames;
    var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition$1, _extends$2({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition2;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = {};
var CSSTransition$1 = CSSTransition;
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren)
    return false;
  if (React__default.isValidElement(oldChildren) && React__default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
var modes = {
  out: "out-in",
  in: "in-out"
};
var callHook = function callHook2(element, name, cb2) {
  return function() {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb2();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(_ref) {
  var current = _ref.current, changeState = _ref.changeState;
  return React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, "onExited", function() {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function(_ref2) {
  var current = _ref2.current, changeState = _ref2.changeState, children = _ref2.children;
  return [current, React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, "onEntered", function() {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(_ref3) {
  var children = _ref3.children, changeState = _ref3.changeState;
  return React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, "onEntered", function() {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function(_ref4) {
  var current = _ref4.current, children = _ref4.children, changeState = _ref4.changeState;
  return [React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, "onExited", function() {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  }), React__default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
var SwitchTransition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(SwitchTransition2, _React$Component);
  function SwitchTransition2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function(status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status,
        current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state2) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state2.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state2.current && areChildrenDifferent(state2.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: React__default.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props, children = _this$props.children, mode2 = _this$props.mode, _this$state = this.state, status = _this$state.status, current = _this$state.current;
    var data2 = {
      children,
      current,
      changeState: this.changeState,
      status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode2](data2);
        break;
      case EXITING:
        component = leaveRenders[mode2](data2);
        break;
      case ENTERED:
        component = current;
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition2;
}(React__default.Component);
SwitchTransition.propTypes = {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
var SwitchTransition$1 = SwitchTransition;
var matched = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDM2IDI4Ij4KICAgIDxwYXRoIGZpbGw9IiMwY2Q1YTIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTM1LjM1IDMuODY1TDMyLjE5LjY2Yy0uNDMzLS40NC0uOTYtLjY2LTEuNTc5LS42Ni0uNjIgMC0xLjE0Ni4yMi0xLjU4LjY2TDEzLjc5NiAxNi4xNDUgNi45NjggOS4xOTJjLS40MzQtLjQ0LS45Ni0uNjYtMS41OC0uNjYtLjYxOSAwLTEuMTQ1LjIyLTEuNTc5LjY2TC42NSAxMi4zOTdDLjIxNyAxMi44MzcgMCAxMy4zNzIgMCAxNHMuMjE3IDEuMTYzLjY1IDEuNjAzbDguNDA4IDguNTMyIDMuMTU5IDMuMjA1Yy40MzMuNDQuOTYuNjYgMS41OC42Ni42MTggMCAxLjE0NS0uMjIgMS41NzgtLjY2bDMuMTYtMy4yMDVMMzUuMzUgNy4wN0EyLjIgMi4yIDAgMCAwIDM2IDUuNDY4YzAtLjYyOC0uMjE3LTEuMTYzLS42NS0xLjYwM3oiLz4KPC9zdmc+Cg==";
var notMatched = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxwYXRoIGZpbGw9IiNGOTRDNkEiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTIzLjMyNiAxNmw3LjkyLTcuOTJBMi40OTIgMi40OTIgMCAwIDAgMzIgNi4yNWMwLS43Mi0uMjUyLTEuMzMtLjc1NC0xLjgzMkwyNy41ODMuNzU0QTIuNDk0IDIuNDk0IDAgMCAwIDI1Ljc1IDBjLS43MTggMC0xLjMyOS4yNTEtMS44MzIuNzU0TDE2IDguNjc0IDguMDguNzUzQTIuNDkzIDIuNDkzIDAgMCAwIDYuMjUgMEM1LjUzIDAgNC45Mi4yNTEgNC40MTcuNzU0TC43NTQgNC40MThBMi40OTQgMi40OTQgMCAwIDAgMCA2LjI0OWMwIC43MTkuMjUxIDEuMzMuNzU0IDEuODMyTDguNjc0IDE2bC03LjkyIDcuOTE4QTIuNDk1IDIuNDk1IDAgMCAwIDAgMjUuNzUxYzAgLjcxOC4yNTEgMS4zMjkuNzU0IDEuODMybDMuNjY0IDMuNjYzQTIuNDkzIDIuNDkzIDAgMCAwIDYuMjQ5IDMyYy43MTkgMCAxLjMzLS4yNTIgMS44MzItLjc1NGw3LjkyLTcuOTIgNy45MTkgNy45MmEyLjQ5MiAyLjQ5MiAwIDAgMCAxLjgzMi43NTRjLjcxOCAwIDEuMzI5LS4yNTIgMS44MzEtLjc1NGwzLjY2My0zLjY2M0EyLjQ5MiAyLjQ5MiAwIDAgMCAzMiAyNS43NWMwLS43MTgtLjI1MS0xLjMyOS0uNzU0LTEuODMyTDIzLjMyNiAxNnoiLz4KPC9zdmc+Cg==";
var crossOut = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE1Ljk2IDMuNjUxTDExLjExIDguNWw0Ljg0OCA0Ljg0OGExLjg0NiAxLjg0NiAwIDAgMS0yLjYxIDIuNjExTDguNSAxMS4xMTFsLTQuODQ5IDQuODQ4Yy0uMzYuMzYtLjgzMi41NDEtMS4zMDUuNTQxYTEuODQ2IDEuODQ2IDAgMCAxLTEuMzA1LTMuMTUyTDUuODkgOC41IDEuMDQgMy42NWExLjg0NiAxLjg0NiAwIDAgMSAyLjYxLTIuNjFMOC41IDUuODg4bDQuODQ4LTQuODQ5YTEuODQ2IDEuODQ2IDAgMCAxIDIuNjExIDIuNjExeiIvPgo8L3N2Zz4K";
var check = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE5IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE4LjQ0MyAzLjI4N0w4LjQyIDEzLjQzN2ExLjg4NSAxLjg4NSAwIDAgMS0yLjY4OSAwTC41NTcgOC4xOTZhMS45NDMgMS45NDMgMCAwIDEgMC0yLjcyNCAxLjg4NSAxLjg4NSAwIDAgMSAyLjY4OSAwbDMuODMgMy44NzlMMTUuNzU0LjU2NGExLjg4NSAxLjg4NSAwIDAgMSAyLjY5IDBjLjc0Mi43NTIuNzQyIDEuOTcgMCAyLjcyM3oiLz4KPC9zdmc+Cg==";
var user = "data:image/svg+xml;base64,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";
var facePlaceholder = "data:image/png;base64,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";
const MatchUserContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(var(--vh) * 100);
`;
const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
const Title$2 = styled.h1`
  text-align: center;

  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @media only screen and (max-height: 480px) {
    margin: 0;
  }
`;
const CirclesContainer = styled.div`
  height: 225px;
  width: 100%;
  position: relative;
  margin-bottom: 20px;

  @media only screen and (max-height: 480px) {
    margin-bottom: 0;
  }
`;
const appear = Ue`
  to {
    visibility: visible;
  }
`;
const MessageContainer = styled.div`
  animation: ${appear} 0s 2s forwards;
  visibility: hidden;
  background-color: #21273b;
  padding: 20px;
  border-radius: 10px;
  color: white;
  min-width: 192px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  position: relative;
  top: 20px;

  @media only screen and (max-height: 480px) {
    top: 40px;
  }
`;
const UserIcon = styled.img`
  margin-right: 10px;
`;
const Span = styled.span``;
const RedDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #ff637b;
  position: absolute;
  right: 10px;
  top: 10px;
`;
const ArrowDown = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #21273b;
  bottom: -9px;
  width: 0;
  height: 0;
`;
const LivenessStripe = styled.div`
  height: 60px;
  width: 100%;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.liveness ? "#0cd5a2" : "#ff5c6f"};

  img {
    margin-right: 10px;
  }
`;
const disappear1 = Ue`
  0% {
    left: 36px;
    opacity: 1;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
`;
const disappear2 = Ue`
  0% {
    left: calc(100% - 36px);
    opacity: 1;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
`;
const LabelContainer = styled.div`
  position: absolute;
  text-align: center;
  color: white;
  animation: ${(props) => props.coolId ? disappear1 : disappear2} 1.2s
    ease-in-out 0.8s forwards;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);

  p {
    position: absolute;
    font-weight: bold;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: -3px;
  }
`;
const Circle = styled.div`
  position: absolute;
  border-radius: 100%;
  overflow: hidden;
  width: 169px;
  height: 169px;
  border: 2.6px solid #fff;
  top: 50px;
  animation: ${(props) => props.coolId ? circle1 : circle2} 1.2s ease-in-out
    0.8s forwards;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
`;
const circle1 = Ue`
  0% {
    left: 36px;
    opacity: 1;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.8;
  }
`;
const circle2 = Ue`
  0% {
    left: calc(100% - 36px);
    opacity: 1;
  }

  90% {
    opacity: 0.7;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 1;
  }
`;
const checkAnimation = Ue`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
const CircleThreeContainer = styled(Circle)`
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  width: 169px;
  height: 169px;
  left: 50%;
  transform: translateX(-50%);
  animation: ${checkAnimation} 0.9s ease-out 2s forwards;

  &.matched {
    background-color: rgba(6, 134, 80, 0.6);
  }
`;
const CircleThreeImage = styled.img`
  &.check {
    width: 36px;
    height: 28px;
    margin: 68px auto 0 auto;
    display: block;
  }

  &.notCheck {
    width: 28px;
    height: 28px;
    margin: 68px auto 0 auto;
    display: block;
  }
`;
const continueButtonAnimation = Ue`
  0% {
    pointer-events: none
    opacity:0;
  }

  100% {
    pointer-events: auto;
    opacity:1;
  }
`;
const ContainerContinueButton = styled.div`
  min-height: 60px;
  width: 100%;
  text-align: center;

  button {
    opacity: 0;
    animation: ${continueButtonAnimation} 0.9s ease-out 2s forwards;
  }
`;
const BoxWithTooltip = styled.div`
  position: relative;
  background: #000;
  height: 40px;
  width: 100px;
  border-radius: 10px;
  opacity: 0.3;

  :after,
  :before {
    top: 90%;
    left: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  :after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: #000;
    border-width: 15px;
    margin-left: -15px;
  }

  :before {
    border-width: 40px;
    margin-left: -40px;
  }
`;
const CircleOne = ({
  croppedIdFace
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsxs(LabelContainer, {
    coolId: true,
    children: [/* @__PURE__ */ jsx(BoxWithTooltip, {}), /* @__PURE__ */ jsx("p", {
      children: "ID"
    })]
  }), /* @__PURE__ */ jsx(Circle, {
    coolId: true,
    style: {
      background: croppedIdFace ? `url(data:image/jpg;base64,${croppedIdFace}) left center no-repeat` : `url(${facePlaceholder}) left center no-repeat`,
      backgroundSize: "cover"
    }
  })]
});
const CircleTwo = ({
  croppedFace
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsxs(LabelContainer, {
    children: [/* @__PURE__ */ jsx(BoxWithTooltip, {}), /* @__PURE__ */ jsx("p", {
      children: "Selfie"
    })]
  }), /* @__PURE__ */ jsx(Circle, {
    style: {
      background: croppedFace ? `url(data:image/jpg;base64,${croppedFace}) center center no-repeat` : `url(${facePlaceholder}) left center no-repeat`,
      backgroundSize: "cover"
    }
  })]
});
const CircleThree = ({
  faceMatch
}) => {
  return /* @__PURE__ */ jsx(CircleThreeContainer, {
    className: classNames({
      circle: true,
      matched: faceMatch
    }),
    children: /* @__PURE__ */ jsx(CircleThreeImage, {
      src: faceMatch ? matched : notMatched,
      className: faceMatch ? "check" : "notCheck",
      alt: "status"
    })
  });
};
const Message = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(MessageContainer, {
    children: [/* @__PURE__ */ jsx(UserIcon, {
      src: user,
      alt: "user icon"
    }), /* @__PURE__ */ jsx(Span, {
      children: t2("matchUser.alreadyExists")
    }), /* @__PURE__ */ jsx(RedDot, {}), /* @__PURE__ */ jsx(ArrowDown, {})]
  });
};
const FaceMatch = ({
  onSuccess,
  onBoarding,
  token,
  liveness,
  existingUser
}) => {
  const {
    t: t2
  } = useTranslation();
  const [croppedFace, setCroppedFace] = useState(null);
  const [croppedIdFace, setCroppedIdFace] = useState(null);
  const [faceMatch, setFaceMatch] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState(t2("matchUser.matching"));
  useEffect(() => {
    if (!isLoading) {
      const timeout = setTimeout(() => {
        setTitle(faceMatch ? t2("matchUser.matched") : t2("matchUser.facesNoMatch"));
      }, 2e3);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [faceMatch, isLoading, t2]);
  useEffect(() => {
    Promise.all([onBoarding.getImages({
      token: token.token,
      body: {
        images: ["croppedFace", "croppedIDFace"]
      }
    }), onBoarding.getScore({
      token: token.token
    })]).then(([res, score]) => {
      var _a, _b;
      setFaceMatch(((_b = (_a = score == null ? void 0 : score.faceRecognition) == null ? void 0 : _a.overall) == null ? void 0 : _b.status) === "OK");
      setCroppedFace(res.croppedFace);
      setCroppedIdFace(res.croppedIDFace);
      setIsLoading(false);
    });
  }, [onBoarding, token.token]);
  function handleClick() {
    onBoarding.addEvent({
      token: token.token,
      eventName: "continue",
      eventData: {},
      eventType: "text"
    });
    onSuccess();
  }
  return isLoading ? null : /* @__PURE__ */ jsxs(Fragment, {
    children: [onBoarding.isDesktop() && /* @__PURE__ */ jsx(DesktopHeader, {}), /* @__PURE__ */ jsxs(MatchUserContainer, {
      children: [/* @__PURE__ */ jsxs(BodyContainer, {
        children: [/* @__PURE__ */ jsx(SwitchTransition$1, {
          mode: "out-in",
          children: /* @__PURE__ */ jsx(CSSTransition$1, {
            classNames: "fade",
            addEndListener: (node, done) => {
              node.addEventListener("transitionend", done, false);
            },
            children: /* @__PURE__ */ jsx(Title$2, {
              children: title
            })
          }, title)
        }), existingUser && /* @__PURE__ */ jsx(Message, {}), /* @__PURE__ */ jsxs(CirclesContainer, {
          children: [/* @__PURE__ */ jsx(CircleOne, {
            croppedIdFace
          }), /* @__PURE__ */ jsx(CircleTwo, {
            croppedFace
          }), /* @__PURE__ */ jsx(CircleThree, {
            faceMatch
          })]
        }), /* @__PURE__ */ jsx(ContainerContinueButton, {
          children: /* @__PURE__ */ jsx(Button$3, {
            onClick: handleClick,
            children: t2("matchUser.continue")
          })
        })]
      }), /* @__PURE__ */ jsxs(LivenessStripe, {
        liveness,
        children: [/* @__PURE__ */ jsx("img", {
          src: liveness ? check : crossOut,
          alt: "cross out icon"
        }), liveness ? t2("matchUser.livenessSuccess") : t2("matchUser.livenessFailed")]
      })]
    })]
  });
};
function renderFaceMatch(element, {
  token,
  onSuccess,
  liveness,
  existingUser
}) {
  init$1();
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    token,
    liveness,
    existingUser,
    onBoarding: this
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(FaceMatch, __spreadValues({}, props))
  }), element);
}
const getInterviewData = (token) => {
  return api.get("/omni/get/data", null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response));
};
function lastNameMatch({ token }) {
  return api.get("/omni/last-name-match", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response));
}
function lastNameMatchByCustomer({ token }) {
  return api.get("/omni/customer/last-name-match ", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response));
}
function sendEmail({ status, token }) {
  return api.post("/omni/fanid/send-email", { status }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function addCreditCardFront({ token, base64Image, onProgress = emptyFunc }) {
  return api.post(`/omni/add/credit-card-front/v2`, { base64Image }, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "application/json"
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function addCreditCardBack({ token, base64Image, onProgress = emptyFunc }) {
  return api.post(`/omni/add/credit-card-back/v2`, { base64Image }, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "application/json"
    },
    onUploadProgress: ({ loaded, total }) => onProgress(loaded / total * 100)
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
function processCreditCard({ token }) {
  return api.post("/omni/process/credit-card", {}, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
}
function compareOCR({ token, image: image2 }) {
  return api.post("omni/videoselfie/compare-ocr/v2", { base64Image: image2 }, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "application/json"
    }
  }).then((response) => {
    return response.data;
  });
}
function compareID({ token, image: image2 }) {
  return api.post("/omni/videoselfie/compare-id/v2", { base64Image: image2 }, {
    headers: {
      "X-Incode-Hardware-Id": token,
      "Content-Type": "application/json"
    }
  }).then((response) => {
    return response.data;
  });
}
const addMLConsent = ({ token, mlConsentChecked }) => {
  return api.post("/omni/add/ml-consent", { status: mlConsentChecked }, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).catch((e2) => Promise.reject(e2.response.data));
};
var ConsentType = /* @__PURE__ */ ((ConsentType2) => {
  ConsentType2["US"] = "US";
  ConsentType2["GDPR"] = "GDPR";
  return ConsentType2;
})(ConsentType || {});
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  overflow: scroll;
  height: 100%;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
`;
const Title$1 = styled.h1`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;

  @media only screen and (max-height: 480px) {
    margin: 0 0 15px 0;
  }
`;
const Paragraph = styled.p`
  font-size: 14px;
  margin-top: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media only screen and (max-height: 480px) {
    font-size: 12px;
    margin: 0 0 10px 0;
    &:last-of-type {
      margin: 0;
    }
  }
`;
const CustomCheckBox = styled.div`
  position: relative;
  height: 25px;
  width: 25px;
  min-width: 25px;
  margin-right: 10px;
  background-color: #eee;
  border-radius: 5px;

  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;
const CheckBox = styled.input.attrs({
  type: "checkbox"
})`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;
const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  margin: 30px 0;
  font-size: 14px;
  line-height: normal;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${CheckBox}:checked ~ ${CustomCheckBox} {
    background-color: ${(props) => props.theme.main};
  }

  ${CheckBox}:checked ~ ${CustomCheckBox}:after {
    display: block;
  }

  ${CustomCheckBox}:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  @media only screen and (max-height: 480px) {
    margin: 15px 0;
  }
`;
CheckboxLabel.defaultProps = {
  theme: theme$1
};
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const Link = styled.a`
  color: ${(props) => props.theme.main};
`;
Link.defaultProps = {
  theme: theme$1
};
function AcceptCheck({
  id: id2,
  consentChecked,
  setConsentChecked,
  text
}) {
  function handleChange() {
    setConsentChecked(!consentChecked);
  }
  return /* @__PURE__ */ jsxs(CheckboxLabel, {
    htmlFor: id2,
    className: "accept-check",
    onChange: handleChange,
    children: [/* @__PURE__ */ jsx(CheckBox, {
      id: id2
    }), /* @__PURE__ */ jsx(CustomCheckBox, {}), text]
  });
}
const MLConsent = ({
  token,
  onBoarding,
  onSuccess,
  type
}) => {
  const {
    t: t2
  } = useTranslation();
  const [consentChecked, setConsentChecked] = useState(false);
  const handleContinue = async () => {
    await onBoarding.addMLConsent({
      token: token.token,
      mlConsentChecked: consentChecked
    });
    onSuccess();
  };
  return /* @__PURE__ */ jsxs(Wrapper, {
    children: [/* @__PURE__ */ jsx(Title$1, {
      children: t2("mlConsent.title")
    }), type === ConsentType.US ? /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsxs(Paragraph, {
        children: [t2("mlConsent.USLabel1"), " ", /* @__PURE__ */ jsx(Link, {
          href: "https://www.incode.com/incode-privacy-policy/",
          rel: "noreferrer",
          target: "_blank",
          children: "https://www.incode.com/incode-privacy-policy/"
        }), " ", t2("mlConsent.USLabel2")]
      })
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs(Paragraph, {
        children: [t2("mlConsent.GDPRLabel1"), " ", /* @__PURE__ */ jsx(Link, {
          color: theme$1.main,
          href: "https://www.incode.com/incode-privacy-policy/",
          rel: "noreferrer",
          target: "_blank",
          children: "https://www.incode.com/incode-privacy-policy/"
        })]
      }), /* @__PURE__ */ jsxs(Paragraph, {
        children: [/* @__PURE__ */ jsxs("strong", {
          children: [t2("mlConsent.important"), ": "]
        }), t2("mlConsent.GDPRLabel2"), " ", /* @__PURE__ */ jsx(Link, {
          href: "mailto:legalcompliance@incode.com",
          rel: "noreferrer",
          target: "_blank",
          children: "legalcompliance@incode.com"
        }), " ", t2("mlConsent.GDPRLabel3")]
      })]
    }), /* @__PURE__ */ jsx(AcceptCheck, {
      id: "clientConsent",
      consentChecked,
      setConsentChecked,
      text: t2("mlConsent.checkboxLabel")
    }), /* @__PURE__ */ jsx(ButtonWrapper, {
      children: /* @__PURE__ */ jsx(Button$3, {
        theme: theme$1,
        onClick: handleContinue,
        children: t2("mlConsent.button.continue")
      })
    })]
  });
};
function renderMlConsent(element, {
  token,
  type,
  onSuccess
}) {
  const props = {
    onSuccess: handleUnmount(onSuccess, element),
    onBoarding: this,
    type,
    token
  };
  ReactDOM.render(/* @__PURE__ */ jsx(App$1, {
    children: /* @__PURE__ */ jsx(MLConsent, __spreadValues({}, props))
  }), element);
}
function create({
  apiKey: apiKey2,
  apiURL,
  lang,
  encrypt = false,
  translations = {},
  opencvURL,
  facefinderURL,
  theme: _theme = {},
  clientId,
  tokboxApiKey = "46135862"
}) {
  setTheme(_theme);
  loadExternalFiles({
    opencvURL,
    facefinderURL
  });
  if (lang) {
    instance.changeLanguage(lang);
  }
  if (clientId) {
    apiKey2 = sha1(clientId);
  }
  const api2 = createApi({ apiKey: apiKey2, apiURL });
  setApi(api2);
  _warmup();
  return {
    createSession: createSession$4,
    updateSession,
    publishKeys,
    capture,
    frontType,
    backType,
    selfieType,
    ocrData,
    getScore,
    addToQueue: addToQueue$1,
    getQueueIndex,
    addDocument,
    state,
    processId,
    processFace,
    getInterviewerName,
    getOpenTokTest,
    addAddressStatement,
    processAddressStatement,
    processWatchlist,
    processGovernmentValidation,
    addPhone,
    postFingerPrint: postFingerprint,
    getImages: getImages$1,
    getConnectionDetails,
    fetchModules,
    fetchModels,
    update,
    detect,
    stopDetect,
    resumeDetect,
    detectFrame,
    callIDDetection: callIDClassification,
    renderCamera,
    renderConference,
    renderFrontTutorial,
    renderBackTutorial,
    renderSelfieTutorial,
    renderPassportTutorial,
    renderDocumentTutorial: renderTutorialDocument,
    encrypt,
    sendFingerprint,
    verifyOTP,
    generateOTP,
    connectToQueue,
    addConferenceEvent,
    removeFromQueue,
    approve,
    addGeolocation,
    warmup,
    renderSignature,
    addSignature,
    getMedicalOcrData,
    idDetection,
    renderVideoSelfie,
    singleFrameDetection,
    renderOTP,
    addEvent,
    getRandomQuestions,
    idVideoSelfieDetection,
    sendGeolocation,
    fetchProcessingStatus,
    theme: theme$1,
    tokboxApiKey,
    mock,
    setSessionStatus,
    renderCapture,
    addSpeech,
    fetchAssets,
    setTheme,
    sendOTPSMS,
    compareOTP,
    getFinishStatus,
    renderLogin,
    renderLoginDesktop,
    identify,
    OneToOneIdentify,
    addCurp,
    addCurpv2,
    renderEnterCurp,
    addInitials,
    attachSignatureOnAnnotation,
    getSignedContractsLinks,
    renderRedirectToMobile,
    getOnboardingStatus,
    addWatchListResults,
    initWatchList,
    addName,
    addEmail,
    addCustomFields,
    addBarcode,
    renderRetrySteps,
    isDesktop: mobile.isDesktop,
    addFrontSecondId,
    processSecondId,
    ocrDataSecondId,
    processFaceSecondId,
    getCustomFields,
    getImagesV2: getImages,
    renderFaceMatch,
    sendRedirectSMS,
    sendMfa,
    getInterviewData,
    lastNameMatch,
    lastNameMatchByCustomer,
    sendEmail,
    addCreditCardFront,
    addCreditCardBack,
    processCreditCard,
    i18n: instance,
    compareOCR,
    compareID,
    getStartInfo,
    addMLConsent,
    renderMlConsent
  };
}
const getVerifyVerificationUrl = (isEKYC) => isEKYC ? "omni/externalVerification/ekyc" : `/omni/externalVerification`;
function verifyInformation(verifyEntity, token, isEKYC = false) {
  return api.post(getVerifyVerificationUrl(isEKYC), verifyEntity, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data);
}
let getRegions = () => {
  return api.get("/omni/getRegions").then((res) => res.data).catch(() => ({}));
};
const RedirectedCallFinishedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
const Title = styled.h1`
  width: 500px;
  text-align: center;
  margin-bottom: 50px;
`;
const Subtitle = styled.h2`
  width: 400;
  text-align: center;
  margin-bottom: 50px;
`;
function RedirectedCallFinished({
  title,
  subtitle
}) {
  return /* @__PURE__ */ jsxs(RedirectedCallFinishedContainer, {
    children: [/* @__PURE__ */ jsx(Title, {
      children: title
    }), /* @__PURE__ */ jsx(Subtitle, {
      children: subtitle
    })]
  });
}
const addQrUrl = `/omni/qr`;
function addQr({ token }) {
  return api.get(addQrUrl, null, {
    headers: {
      "X-Incode-Hardware-Id": token
    }
  }).then((response) => response.data).catch((e2) => Promise.reject(e2.response.data));
}
export { Login, RedirectedCallFinished, Spinner, WebcamWithChooseCamera as Webcam, addCustomFields, addDocument, addEvent, addQr, api, conferenceStatus, create, createSession$4 as createSession, getFinishStatus, getImages$1 as getImages, getImages as getImagesV2, getInterviewData, getRegions, getScore, instance as i18n, mock, ocrData, sendEmail, theme$1 as theme, update, verifyInformation };
